/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1989);
	module.exports = __webpack_require__(942);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2001);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _all = __webpack_require__(64);
	
	Object.keys(_all).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _all[key];
	    }
	  });
	});
	
	var util = _interopRequireWildcard(_all);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	global.util = util;
	global.twd = util;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	var createNonEnumerableProperty = __webpack_require__(65);
	var defineBuiltIn = __webpack_require__(44);
	var defineGlobalProperty = __webpack_require__(341);
	var copyConstructorProperties = __webpack_require__(201);
	var isForced = __webpack_require__(207);
	
	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	module.exports = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = global;
	  } else if (STATIC) {
	    target = global[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = global[TARGET] && global[TARGET].prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || (targetProperty && targetProperty.sham)) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};


/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	module.exports = exports.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument);
	
	  // Clone the date
	  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
	      // eslint-disable-next-line no-console
	      console.warn(new Error().stack);
	    }
	    return new Date(NaN);
	  }
	}
	module.exports = exports.default;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(204);
	
	var FunctionPrototype = Function.prototype;
	var call = FunctionPrototype.call;
	var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
	
	module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call.apply(fn, arguments);
	  };
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var _inheritsLoose = __webpack_require__(449);
	var React = __webpack_require__(1);
	__webpack_require__(452);
	var emotionElement = __webpack_require__(781);
	var utils = __webpack_require__(454);
	var serialize = __webpack_require__(314);
	var sheet = __webpack_require__(453);
	var css = __webpack_require__(782);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var _inheritsLoose__default = /*#__PURE__*/_interopDefault(_inheritsLoose);
	var css__default = /*#__PURE__*/_interopDefault(css);
	
	var jsx = function jsx(type, props) {
	  var args = arguments;
	
	  if (props == null || !emotionElement.hasOwnProperty.call(props, 'css')) {
	    // $FlowFixMe
	    return React.createElement.apply(undefined, args);
	  }
	
	  var argsLength = args.length;
	  var createElementArgArray = new Array(argsLength);
	  createElementArgArray[0] = emotionElement.Emotion;
	  createElementArgArray[1] = emotionElement.createEmotionProps(type, props);
	
	  for (var i = 2; i < argsLength; i++) {
	    createElementArgArray[i] = args[i];
	  } // $FlowFixMe
	
	
	  return React.createElement.apply(null, createElementArgArray);
	};
	
	var warnedAboutCssPropForGlobal = false;
	var Global = /* #__PURE__ */emotionElement.withEmotionCache(function (props, cache) {
	  if (false) {
	    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
	    warnedAboutCssPropForGlobal = true;
	  }
	
	  var styles = props.styles;
	
	  if (typeof styles === 'function') {
	    return /*#__PURE__*/React.createElement(emotionElement.ThemeContext.Consumer, null, function (theme) {
	      var serialized = serialize.serializeStyles([styles(theme)]);
	      return /*#__PURE__*/React.createElement(InnerGlobal, {
	        serialized: serialized,
	        cache: cache
	      });
	    });
	  }
	
	  var serialized = serialize.serializeStyles([styles]);
	  return /*#__PURE__*/React.createElement(InnerGlobal, {
	    serialized: serialized,
	    cache: cache
	  });
	});
	
	// maintain place over rerenders.
	// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
	// initial client-side render from SSR, use place of hydrating tag
	var InnerGlobal = /*#__PURE__*/function (_React$Component) {
	  _inheritsLoose__default['default'](InnerGlobal, _React$Component);
	
	  function InnerGlobal(props, context, updater) {
	    return _React$Component.call(this, props, context, updater) || this;
	  }
	
	  var _proto = InnerGlobal.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.sheet = new sheet.StyleSheet({
	      key: this.props.cache.key + "-global",
	      nonce: this.props.cache.sheet.nonce,
	      container: this.props.cache.sheet.container
	    }); // $FlowFixMe
	
	    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
	
	    if (node !== null) {
	      this.sheet.tags.push(node);
	    }
	
	    if (this.props.cache.sheet.tags.length) {
	      this.sheet.before = this.props.cache.sheet.tags[0];
	    }
	
	    this.insertStyles();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.serialized.name !== this.props.serialized.name) {
	      this.insertStyles();
	    }
	  };
	
	  _proto.insertStyles = function insertStyles() {
	    if (this.props.serialized.next !== undefined) {
	      // insert keyframes
	      utils.insertStyles(this.props.cache, this.props.serialized.next, true);
	    }
	
	    if (this.sheet.tags.length) {
	      // if this doesn't exist then it will be null so the style element will be appended
	      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
	      this.sheet.before = element;
	      this.sheet.flush();
	    }
	
	    this.props.cache.insert("", this.props.serialized, this.sheet, false);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.sheet.flush();
	  };
	
	  _proto.render = function render() {
	
	    return null;
	  };
	
	  return InnerGlobal;
	}(React.Component);
	
	var keyframes = function keyframes() {
	  var insertable = css__default['default'].apply(void 0, arguments);
	  var name = "animation-" + insertable.name; // $FlowFixMe
	
	  return {
	    name: name,
	    styles: "@keyframes " + name + "{" + insertable.styles + "}",
	    anim: 1,
	    toString: function toString() {
	      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
	    }
	  };
	};
	
	var classnames = function classnames(args) {
	  var len = args.length;
	  var i = 0;
	  var cls = '';
	
	  for (; i < len; i++) {
	    var arg = args[i];
	    if (arg == null) continue;
	    var toAdd = void 0;
	
	    switch (typeof arg) {
	      case 'boolean':
	        break;
	
	      case 'object':
	        {
	          if (Array.isArray(arg)) {
	            toAdd = classnames(arg);
	          } else {
	            toAdd = '';
	
	            for (var k in arg) {
	              if (arg[k] && k) {
	                toAdd && (toAdd += ' ');
	                toAdd += k;
	              }
	            }
	          }
	
	          break;
	        }
	
	      default:
	        {
	          toAdd = arg;
	        }
	    }
	
	    if (toAdd) {
	      cls && (cls += ' ');
	      cls += toAdd;
	    }
	  }
	
	  return cls;
	};
	
	function merge(registered, css, className) {
	  var registeredStyles = [];
	  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
	
	  if (registeredStyles.length < 2) {
	    return className;
	  }
	
	  return rawClassName + css(registeredStyles);
	}
	
	var Noop = function Noop() {
	  return null;
	};
	
	var ClassNames = emotionElement.withEmotionCache(function (props, context) {
	  return /*#__PURE__*/React.createElement(emotionElement.ThemeContext.Consumer, null, function (theme) {
	    var hasRendered = false;
	
	    var css = function css() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('css can only be used during render');
	      }
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var serialized = serialize.serializeStyles(args, context.registered);
	
	      {
	        utils.insertStyles(context, serialized, false);
	      }
	
	      return context.key + "-" + serialized.name;
	    };
	
	    var cx = function cx() {
	      if (hasRendered && ("production") !== 'production') {
	        throw new Error('cx can only be used during render');
	      }
	
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return merge(context.registered, css, classnames(args));
	    };
	
	    var content = {
	      css: css,
	      cx: cx,
	      theme: theme
	    };
	    var ele = props.children(content);
	    hasRendered = true;
	    var possiblyStyleElement = /*#__PURE__*/React.createElement(Noop, null);
	
	
	    return /*#__PURE__*/React.createElement(React.Fragment, null, possiblyStyleElement, ele);
	  });
	});
	
	exports.CacheProvider = emotionElement.CacheProvider;
	exports.ThemeContext = emotionElement.ThemeContext;
	exports.withEmotionCache = emotionElement.withEmotionCache;
	Object.defineProperty(exports, 'css', {
	  enumerable: true,
	  get: function () {
	    return css__default['default'];
	  }
	});
	exports.ClassNames = ClassNames;
	exports.Global = Global;
	exports.createElement = jsx;
	exports.jsx = jsx;
	exports.keyframes = keyframes;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1219);


/***/ },
/* 11 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	var check = function (it) {
	  return it && it.Math === Math && it;
	};
	
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	module.exports =
	  // eslint-disable-next-line es/no-global-this -- safe
	  check(typeof globalThis == 'object' && globalThis) ||
	  check(typeof window == 'object' && window) ||
	  // eslint-disable-next-line no-restricted-globals -- safe
	  check(typeof self == 'object' && self) ||
	  check(typeof global == 'object' && global) ||
	  check(typeof this == 'object' && this) ||
	  // eslint-disable-next-line no-new-func -- fallback
	  (function () { return this; })() || Function('return this')();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	  var number = Number(dirtyNumber);
	  if (isNaN(number)) {
	    return number;
	  }
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	module.exports = exports.default;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1973)();
	}


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113),
		__webpack_require__(704),
		__webpack_require__(229),
		__webpack_require__(702),
		__webpack_require__(412),
		__webpack_require__(287),
		__webpack_require__(284),
		__webpack_require__(707),
		__webpack_require__(286),
		__webpack_require__(703),
		__webpack_require__(1824),
		__webpack_require__(154),
		__webpack_require__(53),
		__webpack_require__(228),
		__webpack_require__(676),
		__webpack_require__(180)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr, getProto, slice, flat, push, indexOf,
		class2type, toString, hasOwn, fnToString, ObjectFunctionString,
		support, isFunction, isWindow, DOMEval, toType ) {
	
	"use strict";
	
	var version = "3.7.1",
	
		rhtmlSuffix = /HTML$/i,
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
	
		// Retrieve the text value of an array of DOM nodes
		text: function( elem ) {
			var node,
				ret = "",
				i = 0,
				nodeType = elem.nodeType;
	
			if ( !nodeType ) {
	
				// If no nodeType, this is expected to be an array
				while ( ( node = elem[ i++ ] ) ) {
	
					// Do not traverse comment nodes
					ret += jQuery.text( node );
				}
			}
			if ( nodeType === 1 || nodeType === 11 ) {
				return elem.textContent;
			}
			if ( nodeType === 9 ) {
				return elem.documentElement.textContent;
			}
			if ( nodeType === 3 || nodeType === 4 ) {
				return elem.nodeValue;
			}
	
			// Do not include comment or processing instruction nodes
	
			return ret;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
							[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		isXMLDoc: function( elem ) {
			var namespace = elem && elem.namespaceURI,
				docElem = elem && ( elem.ownerDocument || elem ).documentElement;
	
			// Assume HTML when documentElement doesn't yet exist, such as inside
			// document fragments.
			return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
		function( _i, name ) {
			class2type[ "[object " + name + "]" ] = name.toLowerCase();
		} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	// Detect IE8's incomplete defineProperty implementation
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
	});


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(204);
	
	var call = Function.prototype.call;
	
	module.exports = NATIVE_BIND ? call.bind(call) : function () {
	  return call.apply(call, arguments);
	};


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(92);
	
	var $String = String;
	
	module.exports = function (argument) {
	  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(20);
	
	var $String = String;
	var $TypeError = TypeError;
	
	// `Assert: Type(argument) is Object`
	module.exports = function (argument) {
	  if (isObject(argument)) return argument;
	  throw new $TypeError($String(argument) + ' is not an object');
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.TOOLTIP_TYPES = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(301));
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(83));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ShallowEqual = __webpack_require__(313);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var PRESENTATION_ATTRIBUTES = {
	  'aria-current': _propTypes["default"].string,
	  // state
	  'aria-details': _propTypes["default"].any,
	  'aria-disabled': _propTypes["default"].any,
	  // state
	  'aria-hidden': _propTypes["default"].any,
	  // state
	  'aria-invalid': _propTypes["default"].any,
	  // state
	  'aria-keyshortcuts': _propTypes["default"].any,
	  'aria-label': _propTypes["default"].any,
	  'aria-roledescription': _propTypes["default"].any,
	  // Widget Attributes
	  'aria-autocomplete': _propTypes["default"].any,
	  'aria-checked': _propTypes["default"].any,
	  'aria-expanded': _propTypes["default"].any,
	  'aria-haspopup': _propTypes["default"].any,
	  'aria-level': _propTypes["default"].any,
	  'aria-modal': _propTypes["default"].any,
	  'aria-multiline': _propTypes["default"].any,
	  'aria-multiselectable': _propTypes["default"].any,
	  'aria-orientation': _propTypes["default"].any,
	  'aria-placeholder': _propTypes["default"].any,
	  'aria-pressed': _propTypes["default"].any,
	  'aria-readonly': _propTypes["default"].any,
	  'aria-required': _propTypes["default"].any,
	  'aria-selected': _propTypes["default"].any,
	  'aria-sort': _propTypes["default"].any,
	  'aria-valuemax': _propTypes["default"].any,
	  'aria-valuemin': _propTypes["default"].any,
	  'aria-valuenow': _propTypes["default"].any,
	  'aria-valuetext': _propTypes["default"].any,
	  // Live Region Attributes
	  'aria-atomic': _propTypes["default"].any,
	  'aria-busy': _propTypes["default"].any,
	  'aria-live': _propTypes["default"].any,
	  'aria-relevant': _propTypes["default"].any,
	  // Drag-and-Drop Attributes
	  'aria-dropeffect': _propTypes["default"].any,
	  'aria-grabbed': _propTypes["default"].any,
	  // Relationship Attributes
	  'aria-activedescendant': _propTypes["default"].any,
	  'aria-colcount': _propTypes["default"].any,
	  'aria-colindex': _propTypes["default"].any,
	  'aria-colspan': _propTypes["default"].any,
	  'aria-controls': _propTypes["default"].any,
	  'aria-describedby': _propTypes["default"].any,
	  'aria-errormessage': _propTypes["default"].any,
	  'aria-flowto': _propTypes["default"].any,
	  'aria-labelledby': _propTypes["default"].any,
	  'aria-owns': _propTypes["default"].any,
	  'aria-posinset': _propTypes["default"].any,
	  'aria-rowcount': _propTypes["default"].any,
	  'aria-rowindex': _propTypes["default"].any,
	  'aria-rowspan': _propTypes["default"].any,
	  'aria-setsize': _propTypes["default"].any,
	  alignmentBaseline: _propTypes["default"].string,
	  angle: _propTypes["default"].number,
	  baselineShift: _propTypes["default"].string,
	  clip: _propTypes["default"].string,
	  clipPath: _propTypes["default"].string,
	  clipRule: _propTypes["default"].string,
	  color: _propTypes["default"].string,
	  colorInterpolation: _propTypes["default"].string,
	  colorInterpolationFilters: _propTypes["default"].string,
	  colorProfile: _propTypes["default"].string,
	  colorRendering: _propTypes["default"].string,
	  cursor: _propTypes["default"].string,
	  direction: _propTypes["default"].oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes["default"].string,
	  dominantBaseline: _propTypes["default"].string,
	  enableBackground: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  fillOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  fillRule: _propTypes["default"].oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes["default"].string,
	  floodColor: _propTypes["default"].string,
	  floodOpacity: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  font: _propTypes["default"].string,
	  fontFamily: _propTypes["default"].string,
	  fontSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontSizeAdjust: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  fontStretch: _propTypes["default"].oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes["default"].oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes["default"].oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes["default"].oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes["default"].string,
	  glyphOrientationVertical: _propTypes["default"].string,
	  imageRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  letterSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  lightingColor: _propTypes["default"].string,
	  lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  markerEnd: _propTypes["default"].string,
	  markerMid: _propTypes["default"].string,
	  markerStart: _propTypes["default"].string,
	  mask: _propTypes["default"].string,
	  opacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  overflow: _propTypes["default"].oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes["default"].oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes["default"].string,
	  stopOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  stroke: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeDasharray: _propTypes["default"].string,
	  strokeDashoffset: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeLinecap: _propTypes["default"].oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes["default"].oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeOpacity: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  strokeWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes["default"].oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes["default"].oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes["default"].oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes["default"].oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  writingMode: _propTypes["default"].oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes["default"].string,
	  role: _propTypes["default"].string,
	  focusable: _propTypes["default"].string,
	  tabIndex: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  dx: _propTypes["default"].number,
	  dy: _propTypes["default"].number,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  r: _propTypes["default"].number,
	  // The radius of Rectangle
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	};
	exports.PRESENTATION_ATTRIBUTES = PRESENTATION_ATTRIBUTES;
	var EVENT_ATTRIBUTES = {
	  onClick: _propTypes["default"].func,
	  onMouseDown: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onMouseOver: _propTypes["default"].func,
	  onMouseMove: _propTypes["default"].func,
	  onMouseOut: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onTouchEnd: _propTypes["default"].func,
	  onTouchMove: _propTypes["default"].func,
	  onTouchStart: _propTypes["default"].func,
	  onTouchCancel: _propTypes["default"].func
	};
	exports.EVENT_ATTRIBUTES = EVENT_ATTRIBUTES;
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
	exports.SCALE_TYPES = SCALE_TYPES;
	var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	exports.LEGEND_TYPES = LEGEND_TYPES;
	var TOOLTIP_TYPES = ['none'];
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	
	exports.TOOLTIP_TYPES = TOOLTIP_TYPES;
	
	var getDisplayName = function getDisplayName(Comp) {
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	
	  if (!Comp) {
	    return '';
	  }
	
	  return Comp.displayName || Comp.name || 'Component';
	};
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	
	
	exports.getDisplayName = getDisplayName;
	
	var findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	
	
	exports.findAllByType = findAllByType;
	
	var findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	  return result && result[0];
	};
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	
	
	exports.findChildByType = findChildByType;
	
	var withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types;
	
	  if ((0, _isArray2["default"])(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react["default"].Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	
	
	exports.withoutType = withoutType;
	
	var getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	
	  return out;
	};
	
	exports.getPresentationAttributes = getPresentationAttributes;
	
	var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
	  return function (e) {
	    originalHandler(props, e);
	    return null;
	  };
	};
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el           A react element or the props of a react element
	 * @param  {Function} newHandler   New handler of event
	 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
	 * @return {Object}                attributes or null
	 */
	
	
	var filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!el || (0, _isFunction2["default"])(el)) {
	    return null;
	  }
	
	  var props = _react["default"].isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
	    }
	  }
	
	  return out;
	};
	
	exports.filterEventAttributes = filterEventAttributes;
	
	var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	    return null;
	  };
	};
	
	var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject2["default"])(props)) {
	    return null;
	  }
	
	  var out = null; // eslint-disable-next-line no-restricted-syntax
	
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction2["default"])(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandlerOfChild(props[i], data, index);
	    }
	  }
	
	  return out;
	};
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	
	
	exports.filterEventsOfChild = filterEventsOfChild;
	
	var validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	exports.validateWidthHeight = validateWidthHeight;
	
	var isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	exports.isSsr = isSsr;
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString2["default"])(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	
	
	var filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react["default"].Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString2["default"])(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	exports.filterSvgElements = filterSvgElements;
	
	var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil2["default"])(nextChild) && (0, _isNil2["default"])(prevChild)) {
	    return true;
	  }
	
	  if (!(0, _isNil2["default"])(nextChild) && !(0, _isNil2["default"])(prevChild)) {
	    var _ref = nextChild.props || {},
	        nextChildren = _ref.children,
	        nextProps = _objectWithoutProperties(_ref, ["children"]);
	
	    var _ref2 = prevChild.props || {},
	        prevChildren = _ref2.children,
	        prevProps = _objectWithoutProperties(_ref2, ["children"]);
	
	    if (nextChildren && prevChildren) {
	      // eslint-disable-next-line no-use-before-define
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
	    }
	
	    if (!nextChildren && !prevChildren) {
	      return (0, _ShallowEqual.shallowEqual)(nextProps, prevProps);
	    }
	
	    return false;
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	
	
	exports.isSingleChildEqual = isSingleChildEqual;
	
	var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	
	  if (count === 1) {
	    return isSingleChildEqual((0, _isArray2["default"])(nextChildren) ? nextChildren[0] : nextChildren, (0, _isArray2["default"])(prevChildren) ? prevChildren[0] : prevChildren);
	  }
	
	  for (var _i = 0; _i < count; _i++) {
	    var nextChild = nextChildren[_i];
	    var prevChild = prevChildren[_i];
	
	    if ((0, _isArray2["default"])(nextChild) || (0, _isArray2["default"])(prevChild)) {
	      if (!isChildrenEqual(nextChild, prevChild)) {
	        return false;
	      }
	    } else if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	exports.isChildrenEqual = isChildrenEqual;
	
	var renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray2["default"])(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	exports.renderByOrder = renderByOrder;
	
	var getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	exports.getReactEventByType = getReactEventByType;
	
	var parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};
	
	exports.parseChildIndex = parseChildIndex;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(22);
	
	module.exports = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var shared = __webpack_require__(147);
	var hasOwn = __webpack_require__(28);
	var uid = __webpack_require__(174);
	var NATIVE_SYMBOL = __webpack_require__(173);
	var USE_SYMBOL_AS_UID = __webpack_require__(562);
	
	var Symbol = global.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;
	
	module.exports = function (name) {
	  if (!hasOwn(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
	      ? Symbol[name]
	      : createWellKnownSymbol('Symbol.' + name);
	  } return WellKnownSymbolsStore[name];
	};


/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var documentAll = typeof document == 'object' && document.all;
	
	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_ARRAY_BUFFER = __webpack_require__(334);
	var DESCRIPTORS = __webpack_require__(15);
	var global = __webpack_require__(11);
	var isCallable = __webpack_require__(22);
	var isObject = __webpack_require__(20);
	var hasOwn = __webpack_require__(28);
	var classof = __webpack_require__(92);
	var tryToString = __webpack_require__(149);
	var createNonEnumerableProperty = __webpack_require__(65);
	var defineBuiltIn = __webpack_require__(44);
	var defineBuiltInAccessor = __webpack_require__(54);
	var isPrototypeOf = __webpack_require__(77);
	var getPrototypeOf = __webpack_require__(86);
	var setPrototypeOf = __webpack_require__(100);
	var wellKnownSymbol = __webpack_require__(21);
	var uid = __webpack_require__(174);
	var InternalStateModule = __webpack_require__(52);
	
	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	var Int8Array = global.Int8Array;
	var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
	var Uint8ClampedArray = global.Uint8ClampedArray;
	var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
	var TypedArray = Int8Array && getPrototypeOf(Int8Array);
	var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
	var ObjectPrototype = Object.prototype;
	var TypeError = global.TypeError;
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
	var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
	// Fixing native typed arrays in Opera Presto crashes the browser, see #595
	var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
	var TYPED_ARRAY_TAG_REQUIRED = false;
	var NAME, Constructor, Prototype;
	
	var TypedArrayConstructorsList = {
	  Int8Array: 1,
	  Uint8Array: 1,
	  Uint8ClampedArray: 1,
	  Int16Array: 2,
	  Uint16Array: 2,
	  Int32Array: 4,
	  Uint32Array: 4,
	  Float32Array: 4,
	  Float64Array: 8
	};
	
	var BigIntArrayConstructorsList = {
	  BigInt64Array: 8,
	  BigUint64Array: 8
	};
	
	var isView = function isView(it) {
	  if (!isObject(it)) return false;
	  var klass = classof(it);
	  return klass === 'DataView'
	    || hasOwn(TypedArrayConstructorsList, klass)
	    || hasOwn(BigIntArrayConstructorsList, klass);
	};
	
	var getTypedArrayConstructor = function (it) {
	  var proto = getPrototypeOf(it);
	  if (!isObject(proto)) return;
	  var state = getInternalState(proto);
	  return (state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR)) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
	};
	
	var isTypedArray = function (it) {
	  if (!isObject(it)) return false;
	  var klass = classof(it);
	  return hasOwn(TypedArrayConstructorsList, klass)
	    || hasOwn(BigIntArrayConstructorsList, klass);
	};
	
	var aTypedArray = function (it) {
	  if (isTypedArray(it)) return it;
	  throw new TypeError('Target is not a typed array');
	};
	
	var aTypedArrayConstructor = function (C) {
	  if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C))) return C;
	  throw new TypeError(tryToString(C) + ' is not a typed array constructor');
	};
	
	var exportTypedArrayMethod = function (KEY, property, forced, options) {
	  if (!DESCRIPTORS) return;
	  if (forced) for (var ARRAY in TypedArrayConstructorsList) {
	    var TypedArrayConstructor = global[ARRAY];
	    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY)) try {
	      delete TypedArrayConstructor.prototype[KEY];
	    } catch (error) {
	      // old WebKit bug - some methods are non-configurable
	      try {
	        TypedArrayConstructor.prototype[KEY] = property;
	      } catch (error2) { /* empty */ }
	    }
	  }
	  if (!TypedArrayPrototype[KEY] || forced) {
	    defineBuiltIn(TypedArrayPrototype, KEY, forced ? property
	      : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
	  }
	};
	
	var exportTypedArrayStaticMethod = function (KEY, property, forced) {
	  var ARRAY, TypedArrayConstructor;
	  if (!DESCRIPTORS) return;
	  if (setPrototypeOf) {
	    if (forced) for (ARRAY in TypedArrayConstructorsList) {
	      TypedArrayConstructor = global[ARRAY];
	      if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY)) try {
	        delete TypedArrayConstructor[KEY];
	      } catch (error) { /* empty */ }
	    }
	    if (!TypedArray[KEY] || forced) {
	      // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
	      try {
	        return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
	      } catch (error) { /* empty */ }
	    } else return;
	  }
	  for (ARRAY in TypedArrayConstructorsList) {
	    TypedArrayConstructor = global[ARRAY];
	    if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
	      defineBuiltIn(TypedArrayConstructor, KEY, property);
	    }
	  }
	};
	
	for (NAME in TypedArrayConstructorsList) {
	  Constructor = global[NAME];
	  Prototype = Constructor && Constructor.prototype;
	  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
	  else NATIVE_ARRAY_BUFFER_VIEWS = false;
	}
	
	for (NAME in BigIntArrayConstructorsList) {
	  Constructor = global[NAME];
	  Prototype = Constructor && Constructor.prototype;
	  if (Prototype) enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
	}
	
	// WebKit bug - typed arrays constructors prototype is Object.prototype
	if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
	  // eslint-disable-next-line no-shadow -- safe
	  TypedArray = function TypedArray() {
	    throw new TypeError('Incorrect invocation');
	  };
	  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
	    if (global[NAME]) setPrototypeOf(global[NAME], TypedArray);
	  }
	}
	
	if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
	  TypedArrayPrototype = TypedArray.prototype;
	  if (NATIVE_ARRAY_BUFFER_VIEWS) for (NAME in TypedArrayConstructorsList) {
	    if (global[NAME]) setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
	  }
	}
	
	// WebKit bug - one more object in Uint8ClampedArray prototype chain
	if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
	  setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
	}
	
	if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
	  TYPED_ARRAY_TAG_REQUIRED = true;
	  defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
	    configurable: true,
	    get: function () {
	      return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
	    }
	  });
	  for (NAME in TypedArrayConstructorsList) if (global[NAME]) {
	    createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
	  }
	}
	
	module.exports = {
	  NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
	  TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
	  aTypedArray: aTypedArray,
	  aTypedArrayConstructor: aTypedArrayConstructor,
	  exportTypedArrayMethod: exportTypedArrayMethod,
	  exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
	  getTypedArrayConstructor: getTypedArrayConstructor,
	  isView: isView,
	  isTypedArray: isTypedArray,
	  TypedArray: TypedArray,
	  TypedArrayPrototype: TypedArrayPrototype
	};


/***/ },
/* 24 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 25 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(451);
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var toPropertyKey = __webpack_require__(451);
	function _defineProperty(obj, key, value) {
	  key = toPropertyKey(key);
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	  return obj;
	}
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var toObject = __webpack_require__(33);
	
	var hasOwnProperty = uncurryThis({}.hasOwnProperty);
	
	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	module.exports = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototypeOf = __webpack_require__(776);
	var isNativeReflectConstruct = __webpack_require__(777);
	var possibleConstructorReturn = __webpack_require__(778);
	function _createSuper(Derived) {
	  var hasNativeReflectConstruct = isNativeReflectConstruct();
	  return function _createSuperInternal() {
	    var Super = getPrototypeOf(Derived),
	      result;
	    if (hasNativeReflectConstruct) {
	      var NewTarget = getPrototypeOf(this).constructor;
	      result = Reflect.construct(Super, arguments, NewTarget);
	    } else {
	      result = Super.apply(this, arguments);
	    }
	    return possibleConstructorReturn(this, result);
	  };
	}
	module.exports = _createSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(450);
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = '';
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (arg) {
					classes = appendClass(classes, parseValue(arg));
				}
			}
	
			return classes;
		}
	
		function parseValue (arg) {
			if (typeof arg === 'string' || typeof arg === 'number') {
				return arg;
			}
	
			if (typeof arg !== 'object') {
				return '';
			}
	
			if (Array.isArray(arg)) {
				return classNames.apply(null, arg);
			}
	
			if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
				return arg.toString();
			}
	
			var classes = '';
	
			for (var key in arg) {
				if (hasOwn.call(arg, key) && arg[key]) {
					classes = appendClass(classes, key);
				}
			}
	
			return classes;
		}
	
		function appendClass (value, newClass) {
			if (!newClass) {
				return value;
			}
		
			if (value) {
				return value + ' ' + newClass;
			}
		
			return value + newClass;
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getFirstCusip = exports.allAccounts = exports.getDefaultAcctNo = exports.getAccount = exports.getAccounts = exports.useOrderTicket = exports.ContextProvider = exports.STEPS = exports.MODES = exports.Context = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define, eqeqeq */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _usePositionsInfo = __webpack_require__(1065);
	
	var _usePositionsInfo2 = _interopRequireDefault(_usePositionsInfo);
	
	var _useOpenOrdersInfo = __webpack_require__(1059);
	
	var _useOpenOrdersInfo2 = _interopRequireDefault(_useOpenOrdersInfo);
	
	var _useAccountInfo = __webpack_require__(1056);
	
	var _useAccountInfo2 = _interopRequireDefault(_useAccountInfo);
	
	var _useBondInfo = __webpack_require__(1058);
	
	var _useBondInfo2 = _interopRequireDefault(_useBondInfo);
	
	var _useOrderInfo = __webpack_require__(1061);
	
	var _useOrderInfo2 = _interopRequireDefault(_useOrderInfo);
	
	var _useOrderForm = __webpack_require__(1060);
	
	var _useOrderForm2 = _interopRequireDefault(_useOrderForm);
	
	var _useAttestations = __webpack_require__(1057);
	
	var _useAttestations2 = _interopRequireDefault(_useAttestations);
	
	var _useValidation = __webpack_require__(1066);
	
	var _useValidation2 = _interopRequireDefault(_useValidation);
	
	var _useModals = __webpack_require__(325);
	
	var _useModals2 = _interopRequireDefault(_useModals);
	
	var _useOrderTicketReset = __webpack_require__(1064);
	
	var _useOrderTicketPreview = __webpack_require__(1063);
	
	var _useOrderTicketConfirm = __webpack_require__(1062);
	
	var _attestationsCd = __webpack_require__(1026);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Context = exports.Context = _react2.default.createContext();
	
	var Last = (0, _twd.getState)('order-ticket.last', {
	    ts: 0,
	    snapshotView: 'snapshot'
	});
	
	var MODES = exports.MODES = {
	    RFQ: 'rfq', // to create rfq
	    ORDER: 'order', // to create one B/S/W/F
	    ORDER_Z: 'order-z', // to confirm order
	    TRADE: 'trade' // from place-a-trade
	};
	
	var STEPS = exports.STEPS = {
	    ENTRY: 'entry',
	    PREVIEW: 'preview',
	    CONFIRM: 'confirm'
	};
	
	var resetingTicket = false;
	
	var ContextProvider = exports.ContextProvider = function ContextProvider() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$action = _ref.action,
	        action_ = _ref$action === undefined ? '' : _ref$action,
	        _ref$acctNo = _ref.acctNo,
	        acctNo_ = _ref$acctNo === undefined ? getDefaultAcctNo() : _ref$acctNo,
	        _ref$cusip = _ref.cusip,
	        cusip_ = _ref$cusip === undefined ? '' : _ref$cusip,
	        _ref$qty = _ref.qty,
	        qty_ = _ref$qty === undefined ? '' : _ref$qty,
	        _ref$price = _ref.price,
	        price_ = _ref$price === undefined ? '' : _ref$price,
	        _ref$yld = _ref.yld,
	        yld_ = _ref$yld === undefined ? '' : _ref$yld,
	        _ref$executionType = _ref.executionType,
	        executionType_ = _ref$executionType === undefined ? '' : _ref$executionType,
	        _ref$sourceAction = _ref.sourceAction,
	        sourceAction_ = _ref$sourceAction === undefined ? '' : _ref$sourceAction,
	        _ref$sourceOrderNo = _ref.sourceOrderNo,
	        sourceOrderNo_ = _ref$sourceOrderNo === undefined ? '' : _ref$sourceOrderNo,
	        _ref$actionSubset = _ref.actionSubset,
	        actionSubset_ = _ref$actionSubset === undefined ? '' : _ref$actionSubset,
	        ts_ = _ref.ts,
	        _ref$backFrom = _ref.backFrom,
	        backFrom_ = _ref$backFrom === undefined ? '' : _ref$backFrom,
	        _ref$from = _ref.from,
	        from_ = _ref$from === undefined ? '' : _ref$from,
	        _ref$step = _ref.step,
	        step_ = _ref$step === undefined ? '' : _ref$step,
	        _ref$isTreasuryAuctio = _ref.isTreasuryAuction,
	        isTreasuryAuction_ = _ref$isTreasuryAuctio === undefined ? false : _ref$isTreasuryAuctio,
	        _ref$settlement = _ref.settlement,
	        settlement_ = _ref$settlement === undefined ? '' : _ref$settlement,
	        children = _ref.children;
	
	    var isReset = ts_ && Last.value.ts < ts_ && !from_;
	    if (isReset) {
	        Last.reset();
	        Last.set({ ts: ts_, snapshotView: 'snapshot', from: from_ });
	        (0, _useBondInfo.resetLastBondInfo)();
	        (0, _useOrderInfo.resetLastOrderInfo)();
	        (0, _useOrderForm.resetLastOrderForm)();
	        (0, _usePositionsInfo.resetLastPositionsInfo)();
	        (0, _useOpenOrdersInfo.resetLastOpenOrdersInfo)();
	        (0, _useAccountInfo.resetLastAccountInfo)();
	        setTimeout(function () {
	            setIsTreasuryAuction(isTreasuryAuction_);
	            setSnapshotView('snapshot');
	        });
	    }
	
	    var _React$useState = _react2.default.useState(ts_ || Last.value.ts || Date.now()),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        ts = _React$useState2[0],
	        setTs_ = _React$useState2[1];
	
	    var setTs = _react2.default.useCallback(function (ts) {
	        Last.set({ ts: ts });
	        setTs_(ts);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(isTreasuryAuction_),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        isTreasuryAuction = _React$useState4[0],
	        setIsTreasuryAuction_ = _React$useState4[1];
	
	    var setIsTreasuryAuction = _react2.default.useCallback(function (isTreasuryAuction) {
	        Last.set({ isTreasuryAuction: isTreasuryAuction });
	        setIsTreasuryAuction_(isTreasuryAuction);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(from_ || Last.value.from || ''),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        from = _React$useState6[0],
	        setFrom_ = _React$useState6[1];
	
	    var setFrom = _react2.default.useCallback(function (from) {
	        Last.set({ from: from });
	        setFrom_(from);
	    }, []);
	
	    var _React$useState7 = _react2.default.useState(step_ || Last.value.step || STEPS.ENTRY),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        step = _React$useState8[0],
	        setStep_ = _React$useState8[1];
	
	    var setStep = _react2.default.useCallback(function (step) {
	        Last.set({ step: step });
	        setStep_(step);
	    }, []);
	
	    var _React$useState9 = _react2.default.useState(Last.value.snapshotView || 'snapshot'),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        snapshotView = _React$useState10[0],
	        setSnapshotView_ = _React$useState10[1];
	
	    var setSnapshotView = _react2.default.useCallback(function (snapshotView) {
	        Last.set({ snapshotView: snapshotView });
	        setSnapshotView_(snapshotView);
	    }, []);
	
	    var validation = (0, _useValidation2.default)();
	    var validateTicket = function validateTicket() {
	        var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	        return validation.validate(Object.assign({}, orderForm, orderInfo, bondInfo, {
	            isChangeToRfq: isChangeToRfq,
	            isRestricted: isRestricted,
	            isTreasuryAuction: isTreasuryAuction
	        }, override));
	    };
	
	    var orderForm = (0, _useOrderForm2.default)({
	        ts_: ts_, acctNo_: acctNo_, action_: action_, cusip_: cusip_, qty_: qty_, price_: price_, yld_: yld_, sourceAction_: sourceAction_, actionSubset_: actionSubset_,
	        validateTicket: validateTicket
	    });
	
	    var positionsInfo = (0, _usePositionsInfo2.default)(Object.assign({}, orderForm, { ts: ts }));
	    var openOrdersInfo = (0, _useOpenOrdersInfo2.default)(Object.assign({}, orderForm, { ts: ts }));
	    var accountInfo = (0, _useAccountInfo2.default)(Object.assign({}, orderForm, { ts: ts }));
	    var bondInfo = (0, _useBondInfo2.default)({ orderForm: orderForm, ts: ts });
	    var modals = (0, _useModals2.default)();
	
	    var orderInfo = (0, _useOrderInfo2.default)(Object.assign({
	        step: step
	    }, modals, orderForm, {
	        sourceAction: sourceAction_,
	        sourceOrderNo: sourceOrderNo_,
	        ts: ts,
	        from: from
	    }));
	
	    var attestations = (0, _useAttestations2.default)(Object.assign({}, bondInfo, orderInfo));
	
	    var resetTicket = function resetTicket() {
	        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	            _ref2$acctNo = _ref2.acctNo,
	            acctNo = _ref2$acctNo === undefined ? '' : _ref2$acctNo,
	            _ref2$cusip = _ref2.cusip,
	            cusip = _ref2$cusip === undefined ? '' : _ref2$cusip,
	            _ref2$action = _ref2.action,
	            action = _ref2$action === undefined ? '' : _ref2$action,
	            _ref2$qty = _ref2.qty,
	            qty = _ref2$qty === undefined ? '' : _ref2$qty,
	            _ref2$price = _ref2.price,
	            price = _ref2$price === undefined ? '' : _ref2$price,
	            _ref2$yld = _ref2.yld,
	            yld = _ref2$yld === undefined ? '' : _ref2$yld,
	            _ref2$sourceAction_ = _ref2.sourceAction_,
	            sourceAction_ = _ref2$sourceAction_ === undefined ? '' : _ref2$sourceAction_,
	            _ref2$actionSubset_ = _ref2.actionSubset_,
	            actionSubset_ = _ref2$actionSubset_ === undefined ? '' : _ref2$actionSubset_,
	            _ref2$sourceOrderNo_ = _ref2.sourceOrderNo_,
	            sourceOrderNo_ = _ref2$sourceOrderNo_ === undefined ? '' : _ref2$sourceOrderNo_,
	            _ref2$ts = _ref2.ts,
	            ts = _ref2$ts === undefined ? 0 : _ref2$ts;
	
	        resetingTicket = true;
	        Last.reset();
	        setTs(ts);
	        setIsChangeToRfq(false);
	        setIsRestricted(false);
	        setIsPreviewed(false);
	
	        setStep(STEPS.ENTRY);
	        acctNo = acctNo || getDefaultAcctNo();
	        orderForm.reset({ ts: ts, cusip: cusip, action: action, qty: qty, price: price, yld: yld, acctNo: acctNo, sourceAction_: sourceAction_, actionSubset_: actionSubset_ });
	        accountInfo.reset();
	        positionsInfo.reset();
	        bondInfo.reset();
	        orderInfo.reset();
	        validation.reset();
	        modals.reset();
	        (0, _useOrderTicketReset.reset)(Object.assign({}, orderForm, orderInfo, validation, {
	            cusip: cusip, action: action, qty: qty, price: price, yld: yld, acctNo: acctNo,
	            sourceAction_: sourceAction_, actionSubset_: actionSubset_, sourceOrderNo_: sourceOrderNo_,
	            isTreasuryAuction: isTreasuryAuction,
	            callback: function callback(info) {
	                bondInfo.updateBondInfo({ cusip: cusip, ts: ts, isReset: true });
	                positionsInfo.updatePositions({ acctNo: acctNo, ts: ts, isReset: true });
	
	                if (!isTreasuryAuction && orderForm.mode !== MODES.ORDER_Z && !info.price && ['S', 'B'].indexOf(action) >= 0) {
	                    orderForm.setAction(action === 'S' ? 'W' : 'F');
	                    orderForm.setNoMarketRfq(true);
	                    return;
	                }
	
	                if (['S', 'B'].indexOf(action) >= 0) {
	                    (0, _twd.publish)('order_ticket_recalc_totals');
	                }
	            }
	        }));
	
	        setTimeout(function () {
	            resetingTicket = false;
	        });
	    };
	
	    _react2.default.useEffect(function () {
	        if (backFrom_) return;
	
	        if (action_ === 'S' && sourceAction_ === 'H' && !cusip_) {
	            acctNo_ = acctNo_ || getDefaultAcctNo();
	            cusip_ = getFirstCusip(acctNo_);
	        }
	
	        resetTicket({
	            ts: ts_ || Date.now(),
	            acctNo: acctNo_,
	            cusip: cusip_,
	            action: action_,
	            qty: qty_,
	            price: price_,
	            yld: yld_,
	            sourceAction_: sourceAction_,
	            actionSubset_: actionSubset_,
	            sourceOrderNo_: sourceOrderNo_
	        });
	        setFrom(from_);
	    }, [ts_, acctNo_, cusip_, action_, qty_, price_, yld_, sourceAction_, actionSubset_, sourceOrderNo_, backFrom_, from_]);
	
	    var _React$useState11 = _react2.default.useState(_twd.Status.LOADED),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        ticketStatus = _React$useState12[0],
	        setTicketStatus = _React$useState12[1];
	
	    var _React$useState13 = _react2.default.useState(false),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        autoPreview = _React$useState14[0],
	        setAutoPreview = _React$useState14[1];
	
	    var _React$useState15 = _react2.default.useState(false),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        isPreviewed = _React$useState16[0],
	        setIsPreviewed = _React$useState16[1];
	
	    var _React$useState17 = _react2.default.useState(Last.value.isChangeToRfq || false),
	        _React$useState18 = _slicedToArray(_React$useState17, 2),
	        isChangeToRfq = _React$useState18[0],
	        setIsChangeToRfq_ = _React$useState18[1];
	
	    var setIsChangeToRfq = _react2.default.useCallback(function (isChangeToRfq) {
	        Last.set({ isChangeToRfq: isChangeToRfq });
	        setIsChangeToRfq_(isChangeToRfq);
	    }, []);
	
	    var _React$useState19 = _react2.default.useState(Last.value.isRestricted || false),
	        _React$useState20 = _slicedToArray(_React$useState19, 2),
	        isRestricted = _React$useState20[0],
	        setIsRestricted_ = _React$useState20[1];
	
	    var setIsRestricted = _react2.default.useCallback(function (isRestricted) {
	        Last.set({ isRestricted: isRestricted });
	        setIsRestricted_(isRestricted);
	    }, []);
	
	    _react2.default.useEffect(function () {
	        setIsRestricted(orderForm.mode !== MODES.ORDER_Z && bondInfo.hasBondInfo && bondInfo.isBondRestricted && ['S', 'W'].indexOf(orderForm.action) < 0);
	    }, [orderForm.mode, bondInfo.hasBondInfo, bondInfo.isBondRestricted, orderForm.action]);
	
	    var changeToRfq = function changeToRfq() {
	        var action = orderForm.action,
	            setAction = orderForm.setAction;
	
	        var a = action;
	        action = action === 'S' ? 'W' : action === 'B' ? 'F' : action;
	        if (a === action) return;
	
	        setAction(action);
	        setAutoPreview(true);
	        return true;
	    };
	
	    var getIsChangeToRfq = function getIsChangeToRfq(_ref3) {
	        var orderInfo = _ref3.orderInfo,
	            orderForm = _ref3.orderForm,
	            bondInfo = _ref3.bondInfo;
	
	
	        if (['S', 'B'].indexOf(orderForm.action) < 0) {
	            return;
	        }
	
	        if (orderInfo.invType === 'M' && (orderInfo.statusMsg || '').indexOf('10329') > 0 && orderForm.qty < 5) {
	            return;
	        }
	
	        var qty = orderInfo.qty,
	            max_qty_avail = orderInfo.max_qty_avail,
	            qty_min = orderInfo.qty_min,
	            qty_incr = orderInfo.qty_incr;
	
	        var hasQty = qty && qty <= max_qty_avail && qty >= qty_min && qty % qty_incr === 0;
	
	        return orderForm.mode !== MODES.ORDER_Z && bondInfo.hasBondInfo && (!bondInfo.isBondRestricted && !orderInfo.hasMarket || bondInfo.isBondRestricted && ['S'].indexOf(orderForm.action) >= 0 || qty && !hasQty);
	    };
	
	    var checkPriceChanged = function checkPriceChanged(currPrice, newInfo) {
	        currPrice = (0, _twd.numberFrom)(currPrice);
	        var newPrice = (0, _twd.numberFrom)(newInfo.invPrice);
	        if (!currPrice || !newPrice || currPrice === newPrice || newInfo.primary === 'Y' || newInfo.executionType === 'Limit') {
	            return;
	        }
	
	        modals.setModals(Object.assign({
	            view: 'order-ticket-price-change-notice-modal'
	        }, newInfo, {
	            initialPrice: currPrice,
	            currentPrice: newPrice,
	            callback: function callback() {
	                reloadTicket();
	            }
	        }));
	        orderInfo.setOrderInfo(newInfo);
	        setIsChangeToRfq(false);
	        setTimeout(function () {
	            return modals.showModals();
	        });
	        return true;
	    };
	
	    var previewTicket = function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var currInfo, currPrice, currQty, isBuySellOrder, newInfo, info, isChg, statusMsg, isFail, prospectus;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setAutoPreview(false);
	
	                            currInfo = orderInfo.orderInfo || {};
	                            currPrice = currInfo.invPrice || currInfo.price;
	                            currQty = currInfo.qty;
	
	                            if (!(!isTreasuryAuction && isChangeToRfq && orderForm.qty == currQty && changeToRfq())) {
	                                _context.next = 6;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 6:
	                            if (validateTicket()) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 8:
	                            isBuySellOrder = ['B', 'S'].indexOf(orderForm.action) >= 0 && orderForm.mode !== MODES.ORDER_Z && !isTreasuryAuction;
	
	                            if (!(isBuySellOrder && orderForm.qty != currQty)) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            _context.next = 12;
	                            return (0, _useOrderTicketReset.reset)(Object.assign({}, orderForm, orderInfo, validation, {
	                                sourceAction_: sourceAction_,
	                                actionSubset_: actionSubset_,
	                                sourceOrderNo_: sourceOrderNo_,
	                                isTreasuryAuction: isTreasuryAuction,
	                                isPreview: true
	                            }));
	
	                        case 12:
	                            newInfo = _context.sent;
	
	                            if (!checkPriceChanged(currPrice, newInfo)) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 15:
	
	                            setIsPreviewed(true);
	
	                            setTicketStatus(_twd.Status.LOADING);
	                            _context.next = 19;
	                            return (0, _useOrderTicketPreview.preview)(Object.assign({
	                                step: step
	                            }, orderForm, orderInfo, attestations, {
	                                sourceAction_: sourceAction_,
	                                actionSubset_: actionSubset_,
	                                sourceOrderNo_: sourceOrderNo_,
	                                isTreasuryAuction: isTreasuryAuction
	                            }));
	
	                        case 19:
	                            info = _context.sent;
	
	                            setTicketStatus(_twd.Status.LOADED);
	
	                            if (!(info && isBuySellOrder)) {
	                                _context.next = 24;
	                                break;
	                            }
	
	                            if (!checkPriceChanged(currPrice, info)) {
	                                _context.next = 24;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 24:
	
	                            setTimeout(function () {
	                                modals.showModals();
	                            });
	
	                            if (!(info && !isTreasuryAuction)) {
	                                _context.next = 30;
	                                break;
	                            }
	
	                            isChg = getIsChangeToRfq({
	                                orderInfo: info,
	                                orderForm: orderForm,
	                                bondInfo: bondInfo
	                            });
	
	                            setIsChangeToRfq(isChg);
	
	                            if (!isChg) {
	                                _context.next = 30;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 30:
	                            statusMsg = (info.statusMsg || '').toLowerCase();
	                            isFail = !info || info.status === 'Fail' || statusMsg.indexOf('click preview to continue') > 0 || statusMsg.indexOf('10329') > 0;
	
	
	                            if (attestations.hasAttestCD && statusMsg.indexOf('12697') > 0) {
	                                (0, _twd.showModal)({
	                                    view: "order-ticket-attestations-modal",
	                                    content: _attestationsCd.AttestationsCD,
	                                    src: "https://us.etrade.com/l/f/agreement-library/brokered-cd-disclosure",
	                                    title: "E*TRADE from Morgan Stanley Brokered Certificate of Deposit Disclosure Statement",
	                                    label: "I have read the Brokerage CD Disclosure and agree to its terms.",
	                                    value: attestations.attestCD,
	                                    onAttest: attestations.setAttestCD
	                                });
	                            } else if (statusMsg.indexOf('29353') > 0) {
	                                prospectus = bondInfo && bondInfo.bondInfo && bondInfo.bondInfo.issue && bondInfo.bondInfo.issue.prospectus;
	
	                                if (attestations.hasAttestCorp && prospectus) {
	                                    (0, _twd.showModal)({
	                                        view: 'order-ticket-attestations-modal',
	                                        src: prospectus,
	                                        title: "Prospectus / Offering Document",
	                                        label: "I have reviewed the prospectus / offering document before placing this order.",
	                                        value: attestations.attestCorp,
	                                        onAttest: attestations.setAttestCorp
	                                    });
	                                }
	                            }
	
	                            if (!isFail) {
	                                _context.next = 35;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 35:
	
	                            setStep(STEPS.PREVIEW);
	
	                        case 36:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function previewTicket() {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	
	    var calculateTicket = function () {
	        var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(_ref5) {
	            var isSkipErrors = _ref5.isSkipErrors;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (validateTicket({ isSkipErrors: isSkipErrors })) {
	                                _context2.next = 2;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 2:
	                            _context2.next = 4;
	                            return (0, _useOrderTicketPreview.preview)(Object.assign({
	                                step: step }, orderForm, orderInfo, attestations, {
	                                isCalc: true,
	                                sourceAction_: sourceAction_, actionSubset_: actionSubset_, sourceOrderNo_: sourceOrderNo_
	                            }));
	
	                        case 4:
	                            return _context2.abrupt('return', _context2.sent);
	
	                        case 5:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }));
	
	        return function calculateTicket(_x4) {
	            return _ref6.apply(this, arguments);
	        };
	    }();
	
	    var confirmTicket = function () {
	        var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee3() {
	            var currInfo, currPrice, info;
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            currInfo = orderInfo.orderInfo || {};
	                            currPrice = currInfo.invPrice;
	
	
	                            setTicketStatus(_twd.Status.LOADING);
	                            _context3.next = 5;
	                            return (0, _useOrderTicketConfirm.confirm)(Object.assign({
	                                step: step
	                            }, orderForm, orderInfo, attestations, {
	                                sourceAction_: sourceAction_,
	                                actionSubset_: actionSubset_,
	                                sourceOrderNo_: sourceOrderNo_,
	                                isTreasuryAuction: isTreasuryAuction
	                            }));
	
	                        case 5:
	                            info = _context3.sent;
	
	                            setTicketStatus(_twd.Status.LOADED);
	
	                            if (!(!info || info.status !== 'Ok' && info.status !== 'Alert')) {
	                                _context3.next = 10;
	                                break;
	                            }
	
	                            if (['S', 'B'].indexOf(orderForm.action) >= 0 && orderForm.mode !== MODES.ORDER_Z && checkPriceChanged(currPrice, info)) {
	                                setStep(STEPS.ENTRY);
	                            }
	
	                            return _context3.abrupt('return');
	
	                        case 10:
	
	                            setStep(STEPS.CONFIRM);
	
	                        case 11:
	                        case 'end':
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, undefined);
	        }));
	
	        return function confirmTicket() {
	            return _ref7.apply(this, arguments);
	        };
	    }();
	
	    _react2.default.useEffect(function () {
	        if (resetingTicket) return;
	
	        var orderInfo_ = orderInfo.orderInfo;
	
	        var _ref8 = orderInfo_ || {},
	            orderCusip = _ref8.cusip,
	            orderAction = _ref8.action;
	
	        var cusip = orderForm.cusip,
	            action = orderForm.action;
	
	
	        var isReload = cusip && action && (cusip !== orderCusip || action !== orderAction);
	        if (!isReload && !isChangeToRfq) return;
	
	        reloadTicket(function () {
	            if (['S', 'B'].indexOf(action) >= 0) {
	                (0, _twd.publish)('order_ticket_recalc_totals');
	            }
	        });
	    }, [orderForm.cusip, orderForm.action]);
	
	    var reloadTicket = function reloadTicket(cb) {
	        setIsChangeToRfq(false);
	        setIsRestricted(false);
	        setIsPreviewed(false);
	
	        setTicketStatus(_twd.Status.LOADING);
	        (0, _useOrderTicketReset.reset)(Object.assign({}, orderForm, orderInfo, validation, {
	            isPreview: false,
	            isTreasuryAuction: isTreasuryAuction,
	            sourceAction_: sourceAction_, actionSubset_: actionSubset_, sourceOrderNo_: sourceOrderNo_,
	            callback: function callback(info) {
	                orderInfo.orderInfo = Object.assign({}, orderInfo.orderInfo, info);
	                orderInfo.hiddenState = Object.assign({}, orderInfo.hiddenState, info && info.hiddenState);
	
	                setTicketStatus(_twd.Status.LOADED);
	
	                var action = orderForm.action;
	                if (!isTreasuryAuction && orderForm.mode !== MODES.ORDER_Z && !info.price && ['S', 'B'].indexOf(action) >= 0) {
	                    orderForm.setAction(action === 'S' ? 'W' : 'F');
	                    orderForm.setNoMarketRfq(true);
	                    return;
	                }
	
	                if (cb) {
	                    cb();
	                }
	
	                if (!autoPreview) return;
	
	                setAutoPreview(false);
	                previewTicket();
	            }
	        }));
	    };
	
	    _react2.default.useEffect(function () {
	        if (isChangeToRfq || orderForm.mode === MODES.ORDER_Z) {
	            return;
	        }
	
	        var cusip = orderForm.cusip,
	            action = orderForm.action,
	            setQty = orderForm.setQty;
	        var positionsTotalQty = positionsInfo.positionsTotalQty;
	
	
	        if (cusip && (action === 'S' || action === 'W') && positionsTotalQty > 0) {
	            setQty(positionsTotalQty);
	        }
	    }, [orderForm.cusip, orderForm.action, positionsInfo.positionsTotalQty]);
	
	    _react2.default.useEffect(function () {
	        if (resetingTicket) return;
	
	        var info = orderInfo.orderInfo;
	
	        if (!info) return;
	
	        var priceOrYield = orderForm.priceOrYield,
	            setPrice = orderForm.setPrice,
	            setYld = orderForm.setYld,
	            mode = orderForm.mode;
	
	        if (mode === MODES.ORDER_Z) return;
	
	        if (priceOrYield === 1) {
	            setPrice((0, _twd.isEmpty)(info.price) ? '' : (0, _twd.numberFrom)(price_) || info.price);
	            setYld('');
	        }
	        if (priceOrYield === 0) {
	            setPrice('');
	            setYld((0, _twd.isEmpty)(info.yield) ? '' : info.yield);
	        }
	    }, [orderInfo.orderInfo, orderForm.priceOrYield]);
	
	    _react2.default.useEffect(function () {
	        positionsInfo.updatePositions({ acctNo: orderForm.acctNo });
	    }, [orderForm.acctNo]);
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: Object.assign({
	                Last: Last
	            }, orderForm, positionsInfo, openOrdersInfo, accountInfo, bondInfo, orderInfo, attestations, validation, {
	                isTreasuryAuction: isTreasuryAuction,
	                setIsTreasuryAuction: setIsTreasuryAuction,
	                isChangeToRfq: isChangeToRfq,
	                isRestricted: isRestricted,
	                isPreviewed: isPreviewed,
	                autoPreview: autoPreview,
	                ticketStatus: ticketStatus,
	                previewTicket: previewTicket,
	                calculateTicket: calculateTicket,
	                confirmTicket: confirmTicket,
	                reloadTicket: reloadTicket,
	                snapshotView: snapshotView, setSnapshotView: setSnapshotView,
	                step: step, setStep: setStep,
	                ts: ts,
	                sourceAction_: sourceAction_,
	                actionSubset_: actionSubset_,
	                executionType_: executionType_,
	                action_: action_,
	                settlement_: settlement_,
	                from: from
	            }) },
	        children
	    );
	};
	
	var useOrderTicket = exports.useOrderTicket = function useOrderTicket() {
	    return _react2.default.useContext(Context);
	};
	
	var getAccounts = exports.getAccounts = function getAccounts() {
	    return (0, _twd.arrayFrom)(global.app.config.accounts).filter(Boolean);
	};
	
	var getAccount = exports.getAccount = function getAccount(acctNo) {
	    return (0, _twd.arrayFrom)(global.app.config.accounts).filter(function (a) {
	        return a.acctNo === acctNo;
	    })[0];
	};
	
	var getDefaultAcctNo = exports.getDefaultAcctNo = function getDefaultAcctNo() {
	    return getAccounts()[0].acctNo || '';
	};
	
	var allAccounts = exports.allAccounts = function allAccounts() {
	    return getAccounts().map(function (a) {
	        return a.acctNo;
	    }).sort();
	};
	
	var getFirstCusip = exports.getFirstCusip = function getFirstCusip(acctNo_) {
	    acctNo_ = acctNo_ || getDefaultAcctNo();
	    var h = global.app.config.holdings.filter(function (_ref9) {
	        var acctNo = _ref9.acctNo;
	        return acctNo_ === acctNo;
	    }).filter(function (_ref10) {
	        var maturity = _ref10.maturity;
	
	        var isMatured = (0, _twd.parseDate)(maturity) < Date.now();
	        return !isMatured;
	    }).sort((0, _twd.sortFn)(function (_ref11) {
	        var issue = _ref11.issue;
	        return (issue || '').trim();
	    }))[0] || {};
	    return h.cusip || '';
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var requireObjectCoercible = __webpack_require__(46);
	
	var $Object = Object;
	
	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	module.exports = function (argument) {
	  return $Object(requireObjectCoercible(argument));
	};


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Setter = __webpack_require__(665);
	var Parser = /*#__PURE__*/function () {
	  function Parser() {
	    (0, _classCallCheck2.default)(this, Parser);
	    (0, _defineProperty2.default)(this, "incompatibleTokens", void 0);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", void 0);
	  }
	  (0, _createClass2.default)(Parser, [{
	    key: "run",
	    value: function run(dateString, token, match, options) {
	      var result = this.parse(dateString, token, match, options);
	      if (!result) {
	        return null;
	      }
	      return {
	        setter: new _Setter.ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
	        rest: result.rest
	      };
	    }
	  }, {
	    key: "validate",
	    value: function validate(_utcDate, _value, _options) {
	      return true;
	    }
	  }]);
	  return Parser;
	}();
	exports.Parser = Parser;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var isCallable = __webpack_require__(22);
	
	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};
	
	module.exports = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
	};


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(22);
	var tryToString = __webpack_require__(149);
	
	var $TypeError = TypeError;
	
	// `Assert: IsCallable(argument) is true`
	module.exports = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw new $TypeError(tryToString(argument) + ' is not a function');
	};


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dayPeriodEnumToHours = dayPeriodEnumToHours;
	exports.isLeapYearIndex = isLeapYearIndex;
	exports.mapValue = mapValue;
	exports.normalizeTwoDigitYear = normalizeTwoDigitYear;
	exports.parseAnyDigitsSigned = parseAnyDigitsSigned;
	exports.parseNDigits = parseNDigits;
	exports.parseNDigitsSigned = parseNDigitsSigned;
	exports.parseNumericPattern = parseNumericPattern;
	exports.parseTimezonePattern = parseTimezonePattern;
	var _index = __webpack_require__(42);
	var _constants = __webpack_require__(68);
	function mapValue(parseFnResult, mapFn) {
	  if (!parseFnResult) {
	    return parseFnResult;
	  }
	  return {
	    value: mapFn(parseFnResult.value),
	    rest: parseFnResult.rest
	  };
	}
	function parseNumericPattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	  return {
	    value: parseInt(matchResult[0], 10),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseTimezonePattern(pattern, dateString) {
	  var matchResult = dateString.match(pattern);
	  if (!matchResult) {
	    return null;
	  }
	
	  // Input is 'Z'
	  if (matchResult[0] === 'Z') {
	    return {
	      value: 0,
	      rest: dateString.slice(1)
	    };
	  }
	  var sign = matchResult[1] === '+' ? 1 : -1;
	  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
	  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
	  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
	  return {
	    value: sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * _index.millisecondsInSecond),
	    rest: dateString.slice(matchResult[0].length)
	  };
	}
	function parseAnyDigitsSigned(dateString) {
	  return parseNumericPattern(_constants.numericPatterns.anyDigitsSigned, dateString);
	}
	function parseNDigits(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigit, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigits, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigits, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigits, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
	  }
	}
	function parseNDigitsSigned(n, dateString) {
	  switch (n) {
	    case 1:
	      return parseNumericPattern(_constants.numericPatterns.singleDigitSigned, dateString);
	    case 2:
	      return parseNumericPattern(_constants.numericPatterns.twoDigitsSigned, dateString);
	    case 3:
	      return parseNumericPattern(_constants.numericPatterns.threeDigitsSigned, dateString);
	    case 4:
	      return parseNumericPattern(_constants.numericPatterns.fourDigitsSigned, dateString);
	    default:
	      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
	  }
	}
	function dayPeriodEnumToHours(dayPeriod) {
	  switch (dayPeriod) {
	    case 'morning':
	      return 4;
	    case 'evening':
	      return 17;
	    case 'pm':
	    case 'noon':
	    case 'afternoon':
	      return 12;
	    case 'am':
	    case 'midnight':
	    case 'night':
	    default:
	      return 0;
	  }
	}
	function normalizeTwoDigitYear(twoDigitYear, currentYear) {
	  var isCommonEra = currentYear > 0;
	  // Absolute number of the current year:
	  // 1 -> 1 AC
	  // 0 -> 1 BC
	  // -1 -> 2 BC
	  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
	  var result;
	  if (absCurrentYear <= 50) {
	    result = twoDigitYear || 100;
	  } else {
	    var rangeEnd = absCurrentYear + 50;
	    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
	    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
	    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
	  }
	  return isCommonEra ? result : 1 - result;
	}
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(133),
	    isObject = __webpack_require__(83);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinearRegression = exports.findEntryInArray = exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(185));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(299));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(300));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(301));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	exports.mathSign = mathSign;
	
	var isPercent = function isPercent(value) {
	  return (0, _isString2["default"])(value) && value.indexOf('%') === value.length - 1;
	};
	
	exports.isPercent = isPercent;
	
	var isNumber = function isNumber(value) {
	  return (0, _isNumber2["default"])(value) && !(0, _isNaN2["default"])(value);
	};
	
	exports.isNumber = isNumber;
	
	var isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString2["default"])(value);
	};
	
	exports.isNumOrStr = isNumOrStr;
	var idCounter = 0;
	
	var uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	  return "".concat(prefix || '').concat(id);
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	
	
	exports.uniqueId = uniqueId;
	
	var getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString2["default"])(percent)) {
	    return defaultValue;
	  }
	
	  var value;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if ((0, _isNaN2["default"])(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	exports.getPercentValue = getPercentValue;
	
	var getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	exports.getAnyElementOfObject = getAnyElementOfObject;
	
	var hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray2["default"])(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	exports.hasDuplicate = hasDuplicate;
	
	var interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};
	
	exports.interpolateNumber = interpolateNumber;
	
	var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
	  if (!ary || !ary.length) {
	    return null;
	  }
	
	  return ary.find(function (entry) {
	    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _get2["default"])(entry, specifiedKey)) === specifiedValue;
	  });
	};
	/**
	 * The least square linear regression
	 * @param {Array} data The array of points
	 * @returns {Object} The domain of x, and the parameter of linear function
	 */
	
	
	exports.findEntryInArray = findEntryInArray;
	
	var getLinearRegression = function getLinearRegression(data) {
	  if (!data || !data.length) {
	    return null;
	  }
	
	  var len = data.length;
	  var xsum = 0;
	  var ysum = 0;
	  var xysum = 0;
	  var xxsum = 0;
	  var xmin = Infinity;
	  var xmax = -Infinity;
	
	  for (var i = 0; i < len; i++) {
	    xsum += data[i].cx;
	    ysum += data[i].cy;
	    xysum += data[i].cx * data[i].cy;
	    xxsum += data[i].cx * data[i].cx;
	    xmin = Math.min(xmin, data[i].cx);
	    xmax = Math.max(xmax, data[i].cx);
	  }
	
	  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
	  return {
	    xmin: xmin,
	    xmax: xmax,
	    a: a,
	    b: (ysum - a * xsum) / len
	  };
	};
	
	exports.getLinearRegression = getLinearRegression;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toLength = __webpack_require__(80);
	
	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	module.exports = function (obj) {
	  return toLength(obj.length);
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var IE8_DOM_DEFINE = __webpack_require__(521);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(563);
	var anObject = __webpack_require__(18);
	var toPropertyKey = __webpack_require__(126);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE = 'configurable';
	var WRITABLE = 'writable';
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  } return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 42 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.secondsInYear = exports.secondsInWeek = exports.secondsInQuarter = exports.secondsInMonth = exports.secondsInMinute = exports.secondsInHour = exports.secondsInDay = exports.quartersInYear = exports.monthsInYear = exports.monthsInQuarter = exports.minutesInHour = exports.minTime = exports.millisecondsInSecond = exports.millisecondsInMinute = exports.millisecondsInHour = exports.maxTime = exports.daysInYear = exports.daysInWeek = void 0;
	/**
	 * Days in 1 week.
	 *
	 * @name daysInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	var daysInWeek = 7;
	
	/**
	 * Days in 1 year
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * @name daysInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInWeek = daysInWeek;
	var daysInYear = 365.2425;
	
	/**
	 * Maximum allowed time.
	 *
	 * @name maxTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.daysInYear = daysInYear;
	var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
	
	/**
	 * Milliseconds in 1 minute
	 *
	 * @name millisecondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.maxTime = maxTime;
	var millisecondsInMinute = 60000;
	
	/**
	 * Milliseconds in 1 hour
	 *
	 * @name millisecondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInMinute = millisecondsInMinute;
	var millisecondsInHour = 3600000;
	
	/**
	 * Milliseconds in 1 second
	 *
	 * @name millisecondsInSecond
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInHour = millisecondsInHour;
	var millisecondsInSecond = 1000;
	
	/**
	 * Minimum allowed time.
	 *
	 * @name minTime
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.millisecondsInSecond = millisecondsInSecond;
	var minTime = -maxTime;
	
	/**
	 * Minutes in 1 hour
	 *
	 * @name minutesInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minTime = minTime;
	var minutesInHour = 60;
	
	/**
	 * Months in 1 quarter
	 *
	 * @name monthsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.minutesInHour = minutesInHour;
	var monthsInQuarter = 3;
	
	/**
	 * Months in 1 year
	 *
	 * @name monthsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInQuarter = monthsInQuarter;
	var monthsInYear = 12;
	
	/**
	 * Quarters in 1 year
	 *
	 * @name quartersInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.monthsInYear = monthsInYear;
	var quartersInYear = 4;
	
	/**
	 * Seconds in 1 hour
	 *
	 * @name secondsInHour
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.quartersInYear = quartersInYear;
	var secondsInHour = 3600;
	
	/**
	 * Seconds in 1 minute
	 *
	 * @name secondsInMinute
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInHour = secondsInHour;
	var secondsInMinute = 60;
	
	/**
	 * Seconds in 1 day
	 *
	 * @name secondsInDay
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMinute = secondsInMinute;
	var secondsInDay = secondsInHour * 24;
	
	/**
	 * Seconds in 1 week
	 *
	 * @name secondsInWeek
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInDay = secondsInDay;
	var secondsInWeek = secondsInDay * 7;
	
	/**
	 * Seconds in 1 year
	 *
	 * @name secondsInYear
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInWeek = secondsInWeek;
	var secondsInYear = secondsInDay * daysInYear;
	
	/**
	 * Seconds in 1 month
	 *
	 * @name secondsInMonth
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInYear = secondsInYear;
	var secondsInMonth = secondsInYear / 12;
	
	/**
	 * Seconds in 1 quarter
	 *
	 * @name secondsInQuarter
	 * @constant
	 * @type {number}
	 * @default
	 */
	exports.secondsInMonth = secondsInMonth;
	var secondsInQuarter = secondsInMonth * 3;
	exports.secondsInQuarter = secondsInQuarter;

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(22);
	var definePropertyModule = __webpack_require__(41);
	var makeBuiltIn = __webpack_require__(351);
	var defineGlobalProperty = __webpack_require__(341);
	
	module.exports = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;
	    else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];
	      else if (O[key]) simple = true;
	    } catch (error) { /* empty */ }
	    if (simple) O[key] = value;
	    else definePropertyModule.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  } return O;
	};


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(141);
	var aCallable = __webpack_require__(36);
	var NATIVE_BIND = __webpack_require__(204);
	
	var bind = uncurryThis(uncurryThis.bind);
	
	// optional / simple context binding
	module.exports = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isNullOrUndefined = __webpack_require__(66);
	
	var $TypeError = TypeError;
	
	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	module.exports = function (it) {
	  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
	  return it;
	};


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path = __webpack_require__(106);
	var hasOwn = __webpack_require__(28);
	var wrappedWellKnownSymbolModule = __webpack_require__(565);
	var defineProperty = __webpack_require__(41).f;
	
	module.exports = function (NAME) {
	  var Symbol = path.Symbol || (path.Symbol = {});
	  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
	    value: wrappedWellKnownSymbolModule.f(NAME)
	  });
	};


/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	module.exports = false;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var trunc = __webpack_require__(531);
	
	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	module.exports = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : trunc(number);
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ["children", "className"]);
	
	  var layerClass = (0, _classnames["default"])('recharts-layer', className);
	  return _react["default"].createElement("g", _extends({
	    className: layerClass
	  }, others), children);
	}
	
	Layer.propTypes = propTypes;
	var _default = Layer;
	exports["default"] = _default;

/***/ },
/* 51 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDefaultOptions = getDefaultOptions;
	exports.setDefaultOptions = setDefaultOptions;
	var defaultOptions = {};
	function getDefaultOptions() {
	  return defaultOptions;
	}
	function setDefaultOptions(newOptions) {
	  defaultOptions = newOptions;
	}

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_WEAK_MAP = __webpack_require__(564);
	var global = __webpack_require__(11);
	var isObject = __webpack_require__(20);
	var createNonEnumerableProperty = __webpack_require__(65);
	var hasOwn = __webpack_require__(28);
	var shared = __webpack_require__(363);
	var sharedKey = __webpack_require__(261);
	var hiddenKeys = __webpack_require__(206);
	
	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError = global.TypeError;
	var WeakMap = global.WeakMap;
	var set, get, has;
	
	var enforce = function (it) {
	  return has(it) ? get(it) : set(it, {});
	};
	
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
	    } return state;
	  };
	};
	
	if (NATIVE_WEAK_MAP || shared.state) {
	  var store = shared.state || (shared.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwn(it, STATE) ? it[STATE] : {};
	  };
	  has = function (it) {
	    return hasOwn(it, STATE);
	  };
	}
	
	module.exports = {
	  set: set,
	  get: get,
	  has: has,
	  enforce: enforce,
	  getterFor: getterFor
	};


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function isFunction( obj ) {
	
			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" &&
				typeof obj.item !== "function";
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var makeBuiltIn = __webpack_require__(351);
	var defineProperty = __webpack_require__(41);
	
	module.exports = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
	  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
	  return defineProperty.f(target, name, descriptor);
	};


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// toObject with fallback for non-array-like ES3 strings
	var IndexedObject = __webpack_require__(166);
	var requireObjectCoercible = __webpack_require__(46);
	
	module.exports = function (it) {
	  return IndexedObject(requireObjectCoercible(it));
	};


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useCalculator = exports.ContextProvider = exports.Context = exports.STEPS = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _getHoldings = __webpack_require__(859);
	
	var _getBondInfo = __webpack_require__(857);
	
	var _getCalcInput = __webpack_require__(464);
	
	var _getCalcOutput = __webpack_require__(858);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var STEPS = exports.STEPS = {
	    INIT: 'init',
	    INIT_LOADING: 'init-loading',
	    INIT_ERROR: 'init-error',
	    CUSIP_INPUT: 'cusip-input',
	    CUSIP_LOADING: 'cusip-loading',
	    CUSIP_ERROR: 'cusip-error',
	    CALC_INPUT: 'calc-input',
	    CALC_LOADING: 'calc-loading',
	    CALC_ERROR: 'calc-error',
	    CALC_OUTPUT: 'calc-output',
	    UNKNOWN: 'unknown'
	};
	
	(0, _twd.subscribe)('calculator.calculator', function (args) {
	
	    if ((0, _twd.getConfig)('entitlements.ETradeCalculator', 'No') === 'Yes') {
	        (0, _twd.showModal)(Object.assign({
	            view: 'calculator'
	        }, args || {}));
	        return;
	    }
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    var url = base + '/' + owaTcDaoContext + '/pkg_calc_bond_online.seed?p_javascript=2&p_id=null&p_data_source=I';
	    var name = 'calculator';
	    var options = 'toolbar=no,width=800,height=600,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no';
	    (0, _twd.openWindow)(url, name, options);
	});
	
	var useContext = function useContext() {
	    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _React$useState = _react2.default.useState(STEPS.INIT),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        step = _React$useState2[0],
	        setStep = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.NULL),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(args.cusip || null),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        cusip = _React$useState6[0],
	        setCusip = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState([]),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        holdings = _React$useState8[0],
	        setHoldings = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(null),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        bondInfo = _React$useState10[0],
	        setBondInfo = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState((0, _getCalcInput.getCalcInput)(args)),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        calcInput = _React$useState12[0],
	        setCalcInput = _React$useState12[1];
	
	    var _React$useState13 = _react2.default.useState(null),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        calcOutput = _React$useState14[0],
	        setCalcOutput = _React$useState14[1];
	
	    var _React$useState15 = _react2.default.useState(args.showCoupon),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        showCoupon = _React$useState16[0],
	        setShowCoupon = _React$useState16[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var holdingArray, bi, calc;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setStep(STEPS.INIT);
	
	                            holdingArray = holdings;
	
	                            if (!(0, _twd.isEmpty)(holdingArray)) {
	                                _context.next = 18;
	                                break;
	                            }
	
	                            _context.prev = 3;
	
	                            setStep(STEPS.INIT_LOADING);
	                            _context.next = 7;
	                            return (0, _getHoldings.getHoldings)();
	
	                        case 7:
	                            holdingArray = _context.sent;
	
	                            setHoldings(holdingArray);
	
	                            if (!(0, _twd.isEmpty)(cusip)) {
	                                _context.next = 12;
	                                break;
	                            }
	
	                            setStep(STEPS.CUSIP_INPUT);
	                            return _context.abrupt('return');
	
	                        case 12:
	                            _context.next = 18;
	                            break;
	
	                        case 14:
	                            _context.prev = 14;
	                            _context.t0 = _context['catch'](3);
	
	                            setStep(STEPS.INIT_ERROR);
	                            return _context.abrupt('return');
	
	                        case 18:
	                            if (!(0, _twd.isEmpty)(cusip)) {
	                                _context.next = 21;
	                                break;
	                            }
	
	                            setStep(STEPS.CUSIP_INPUT);
	                            return _context.abrupt('return');
	
	                        case 21:
	                            if (!(step === STEPS.INIT_LOADING)) {
	                                _context.next = 23;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 23:
	                            if (!(!(0, _twd.isEmpty)(cusip) && (0, _twd.isEmpty)(bondInfo))) {
	                                _context.next = 41;
	                                break;
	                            }
	
	                            _context.prev = 24;
	
	                            setStep(STEPS.CUSIP_LOADING);
	                            _context.next = 28;
	                            return (0, _getBondInfo.getBondInfo)({ cusip: cusip, holdings: holdingArray });
	
	                        case 28:
	                            bi = _context.sent;
	
	                            setBondInfo(bi);
	
	                            if (calcInput && !calcInput.settlement) {
	                                calcInput.settlement = bi.settlement;
	                                setCalcInput(Object.assign({}, calcInput));
	                            }
	
	                            if ((0, _getCalcInput.isCalcInput)(bi, calcInput)) {
	                                _context.next = 34;
	                                break;
	                            }
	
	                            setStep(STEPS.CALC_INPUT);
	                            return _context.abrupt('return');
	
	                        case 34:
	                            _context.next = 41;
	                            break;
	
	                        case 36:
	                            _context.prev = 36;
	                            _context.t1 = _context['catch'](24);
	
	                            console.error('cusip-error', _context.t1);
	                            setStep(STEPS.CUSIP_ERROR);
	                            return _context.abrupt('return');
	
	                        case 41:
	                            if ((0, _getCalcInput.isCalcInput)(bondInfo, calcInput)) {
	                                _context.next = 44;
	                                break;
	                            }
	
	                            setStep(STEPS.CALC_INPUT);
	                            return _context.abrupt('return');
	
	                        case 44:
	                            if (!(step === STEPS.CUSIP_LOADING)) {
	                                _context.next = 46;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 46:
	                            if (!(!(0, _twd.isEmpty)(calcInput) && (0, _getCalcInput.isCalcInput)(bondInfo, calcInput) && (0, _twd.isEmpty)(calcOutput))) {
	                                _context.next = 65;
	                                break;
	                            }
	
	                            _context.prev = 47;
	
	                            setStep(STEPS.CALC_LOADING);
	                            _context.next = 51;
	                            return (0, _getCalcOutput.getCalcOutput)(Object.assign({
	                                cusip: cusip
	                            }, calcInput));
	
	                        case 51:
	                            calc = _context.sent;
	
	                            if (!(calc && !(0, _twd.isEmpty)(calc.error))) {
	                                _context.next = 54;
	                                break;
	                            }
	
	                            throw calc.error;
	
	                        case 54:
	
	                            setCalcOutput(calc);
	                            setShowCoupon(true);
	                            setStep(STEPS.CALC_OUTPUT);
	                            return _context.abrupt('return');
	
	                        case 60:
	                            _context.prev = 60;
	                            _context.t2 = _context['catch'](47);
	
	                            console.error('calc-error', _context.t2);
	                            setStep(STEPS.CALC_ERROR);
	                            return _context.abrupt('return');
	
	                        case 65:
	
	                            setStep(STEPS.UNKNOWN);
	
	                        case 66:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[3, 14], [24, 36], [47, 60]]);
	        }))();
	    }, [cusip, calcInput]);
	
	    var changeCusip = function changeCusip() {
	        setBondInfo(null);
	        setCalcOutput(null);
	        setCusip('');
	        setShowCoupon(false);
	    };
	
	    var resetCalc = function resetCalc() {
	        setCalcOutput(null);
	        setStep(STEPS.CALC_INPUT);
	    };
	
	    return {
	        step: step, setStep: setStep,
	        status: status, setStatus: setStatus,
	        cusip: cusip, setCusip: setCusip,
	        showCoupon: showCoupon,
	        holdings: holdings,
	        bondInfo: bondInfo, setBondInfo: setBondInfo,
	        calcInput: calcInput, setCalcInput: setCalcInput,
	        calcOutput: calcOutput, setCalcOutput: setCalcOutput,
	        changeCusip: changeCusip,
	        resetCalc: resetCalc,
	        from_: args.from
	    };
	};
	
	var Context = exports.Context = _react2.default.createContext();
	var ContextProvider = function ContextProvider(_ref2) {
	    var children = _ref2.children,
	        args = _objectWithoutProperties(_ref2, ['children']);
	
	    var ctx = useContext(args);
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: ctx },
	        children
	    );
	};
	exports.ContextProvider = ContextProvider;
	var useCalculator = exports.useCalculator = function useCalculator() {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(45);
	var uncurryThis = __webpack_require__(8);
	var IndexedObject = __webpack_require__(166);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var arraySpeciesCreate = __webpack_require__(200);
	
	var push = uncurryThis([].push);
	
	// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_MAP = TYPE === 1;
	  var IS_FILTER = TYPE === 2;
	  var IS_SOME = TYPE === 3;
	  var IS_EVERY = TYPE === 4;
	  var IS_FIND_INDEX = TYPE === 6;
	  var IS_FILTER_REJECT = TYPE === 7;
	  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
	  return function ($this, callbackfn, that, specificCreate) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var length = lengthOfArrayLike(self);
	    var boundFunction = bind(callbackfn, that);
	    var index = 0;
	    var create = specificCreate || arraySpeciesCreate;
	    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
	    var value, result;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (TYPE) {
	        if (IS_MAP) target[index] = result; // map
	        else if (result) switch (TYPE) {
	          case 3: return true;              // some
	          case 5: return value;             // find
	          case 6: return index;             // findIndex
	          case 2: push(target, value);      // filter
	        } else switch (TYPE) {
	          case 4: return false;             // every
	          case 7: push(target, value);      // filterReject
	        }
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.forEach` method
	  // https://tc39.es/ecma262/#sec-array.prototype.foreach
	  forEach: createMethod(0),
	  // `Array.prototype.map` method
	  // https://tc39.es/ecma262/#sec-array.prototype.map
	  map: createMethod(1),
	  // `Array.prototype.filter` method
	  // https://tc39.es/ecma262/#sec-array.prototype.filter
	  filter: createMethod(2),
	  // `Array.prototype.some` method
	  // https://tc39.es/ecma262/#sec-array.prototype.some
	  some: createMethod(3),
	  // `Array.prototype.every` method
	  // https://tc39.es/ecma262/#sec-array.prototype.every
	  every: createMethod(4),
	  // `Array.prototype.find` method
	  // https://tc39.es/ecma262/#sec-array.prototype.find
	  find: createMethod(5),
	  // `Array.prototype.findIndex` method
	  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
	  findIndex: createMethod(6),
	  // `Array.prototype.filterReject` method
	  // https://github.com/tc39/proposal-array-filtering
	  filterReject: createMethod(7)
	};


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var call = __webpack_require__(16);
	var propertyIsEnumerableModule = __webpack_require__(257);
	var createPropertyDescriptor = __webpack_require__(85);
	var toIndexedObject = __webpack_require__(55);
	var toPropertyKey = __webpack_require__(126);
	var hasOwn = __webpack_require__(28);
	var IE8_DOM_DEFINE = __webpack_require__(521);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (IE8_DOM_DEFINE) try {
	    return $getOwnPropertyDescriptor(O, P);
	  } catch (error) { /* empty */ }
	  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	// eslint-disable-next-line es/no-set -- safe
	var SetPrototype = Set.prototype;
	
	module.exports = {
	  // eslint-disable-next-line es/no-set -- safe
	  Set: Set,
	  add: uncurryThis(SetPrototype.add),
	  has: uncurryThis(SetPrototype.has),
	  remove: uncurryThis(SetPrototype['delete']),
	  proto: SetPrototype
	};


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var has = __webpack_require__(59).has;
	
	// Perform ? RequireInternalSlot(M, [[SetData]])
	module.exports = function (it) {
	  has(it);
	  return it;
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	var toString = uncurryThis({}.toString);
	var stringSlice = uncurryThis(''.slice);
	
	module.exports = function (it) {
	  return stringSlice(toString(it), 8, -1);
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(1789);
	} else {
	  module.exports = require('./formik.cjs.development.js');
	}

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return window.document;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.safeNum = exports.delay = exports.isWebKit = exports.toHash = exports.toCamel = exports.setScroll = exports.returnModalFocus = exports.hideModal = exports.showModal = exports.show = exports.getEventHandlers = exports.$ = exports.processAtmosphereMessage = exports.atmosphere = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _ajax = __webpack_require__(1154);
	
	Object.keys(_ajax).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _ajax[key];
	        }
	    });
	});
	
	var _atmosphere = __webpack_require__(1155);
	
	Object.defineProperty(exports, 'atmosphere', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_atmosphere).default;
	    }
	});
	Object.defineProperty(exports, 'processAtmosphereMessage', {
	    enumerable: true,
	    get: function get() {
	        return _atmosphere.processAtmosphereMessage;
	    }
	});
	
	var _backFrom = __webpack_require__(1157);
	
	Object.keys(_backFrom).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _backFrom[key];
	        }
	    });
	});
	
	var _compare = __webpack_require__(1158);
	
	Object.keys(_compare).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _compare[key];
	        }
	    });
	});
	
	var _cookie = __webpack_require__(481);
	
	Object.keys(_cookie).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _cookie[key];
	        }
	    });
	});
	
	var _dash = __webpack_require__(1159);
	
	Object.keys(_dash).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _dash[key];
	        }
	    });
	});
	
	var _disclosures = __webpack_require__(1160);
	
	Object.keys(_disclosures).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _disclosures[key];
	        }
	    });
	});
	
	var _dom = __webpack_require__(1161);
	
	Object.keys(_dom).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _dom[key];
	        }
	    });
	});
	
	var _fields = __webpack_require__(1165);
	
	Object.keys(_fields).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _fields[key];
	        }
	    });
	});
	
	var _format = __webpack_require__(483);
	
	Object.keys(_format).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _format[key];
	        }
	    });
	});
	
	var _frameIn = __webpack_require__(1186);
	
	Object.keys(_frameIn).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _frameIn[key];
	        }
	    });
	});
	
	var _getConfig = __webpack_require__(485);
	
	Object.keys(_getConfig).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _getConfig[key];
	        }
	    });
	});
	
	var _getId = __webpack_require__(486);
	
	Object.keys(_getId).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _getId[key];
	        }
	    });
	});
	
	var _icons = __webpack_require__(487);
	
	Object.keys(_icons).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _icons[key];
	        }
	    });
	});
	
	var _iconLabel = __webpack_require__(1187);
	
	Object.keys(_iconLabel).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _iconLabel[key];
	        }
	    });
	});
	
	var _isCusip = __webpack_require__(1189);
	
	Object.keys(_isCusip).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _isCusip[key];
	        }
	    });
	});
	
	var _isTradingHour = __webpack_require__(1190);
	
	Object.keys(_isTradingHour).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _isTradingHour[key];
	        }
	    });
	});
	
	var _mediaQueries = __webpack_require__(162);
	
	Object.keys(_mediaQueries).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _mediaQueries[key];
	        }
	    });
	});
	
	var _minimalNavigation = __webpack_require__(1191);
	
	Object.keys(_minimalNavigation).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _minimalNavigation[key];
	        }
	    });
	});
	
	var _paging = __webpack_require__(1192);
	
	Object.keys(_paging).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _paging[key];
	        }
	    });
	});
	
	var _parse = __webpack_require__(332);
	
	Object.keys(_parse).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _parse[key];
	        }
	    });
	});
	
	var _parseDate = __webpack_require__(1193);
	
	Object.keys(_parseDate).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _parseDate[key];
	        }
	    });
	});
	
	var _flyout = __webpack_require__(482);
	
	Object.keys(_flyout).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _flyout[key];
	        }
	    });
	});
	
	var _pubsub = __webpack_require__(1195);
	
	Object.keys(_pubsub).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _pubsub[key];
	        }
	    });
	});
	
	var _section = __webpack_require__(1196);
	
	Object.keys(_section).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _section[key];
	        }
	    });
	});
	
	var _state = __webpack_require__(1197);
	
	Object.keys(_state).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _state[key];
	        }
	    });
	});
	
	var _status = __webpack_require__(1198);
	
	Object.keys(_status).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _status[key];
	        }
	    });
	});
	
	var _track = __webpack_require__(1200);
	
	Object.keys(_track).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _track[key];
	        }
	    });
	});
	
	var _trackSearch = __webpack_require__(1199);
	
	Object.keys(_trackSearch).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _trackSearch[key];
	        }
	    });
	});
	
	var _trapFocus = __webpack_require__(1201);
	
	Object.keys(_trapFocus).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _trapFocus[key];
	        }
	    });
	});
	
	var _url = __webpack_require__(488);
	
	Object.keys(_url).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _url[key];
	        }
	    });
	});
	
	var _usePrevious = __webpack_require__(1202);
	
	Object.keys(_usePrevious).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _usePrevious[key];
	        }
	    });
	});
	
	var _util = __webpack_require__(489);
	
	Object.keys(_util).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _util[key];
	        }
	    });
	});
	
	var _values = __webpack_require__(490);
	
	Object.keys(_values).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _values[key];
	        }
	    });
	});
	
	__webpack_require__(1194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = global.$;
	exports.$ = $;
	var getEventHandlers = exports.getEventHandlers = function getEventHandlers(dom) {
	    if (!dom) return {};
	
	    for (var key in dom) {
	        if (!key.startsWith('__reactEventHandlers$')) continue;
	        return dom[key];
	    }
	    return {};
	};
	
	var show = exports.show = function show(loc, arg) {
	    var _loc$split = loc.split('/'),
	        _loc$split2 = _slicedToArray(_loc$split, 2),
	        view = _loc$split2[0],
	        hash = _loc$split2[1];
	
	    var a = Object.assign({ view: view }, hash && { hash: hash }, arg);
	    (0, _pubsub.publish)('goto', a);
	};
	
	var modalSource = null;
	
	var showModal = exports.showModal = function showModal(arg) {
	    var p = (0, _util.isString)(arg) ? { view: arg } : arg;
	
	    modalSource = p.source || document.activeElement;
	    var e = $(modalSource);
	    if (e.length > 0 && !e.is(':focusable')) {
	        modalSource = e.closest(':focusable')[0];
	    }
	
	    (0, _pubsub.publish)('modal', p);
	};
	
	var hideModal = exports.hideModal = function hideModal() {
	    (0, _pubsub.publish)('modal', '');
	    returnModalFocus();
	};
	
	var returnModalFocus = exports.returnModalFocus = function returnModalFocus() {
	    if (!modalSource) return;
	    try {
	        modalSource.focus();
	    } catch (e) {} finally {
	        modalSource = null;
	    }
	};
	
	var setScroll = exports.setScroll = function setScroll(hash, isHideModal) {
	    try {
	        if (isHideModal) hideModal();
	
	        var e = $(hash);
	        if (e.length === 0) return;
	
	        var r = $('#root');
	        var t = e.offset().top - r.offset().top;
	
	        if (t <= 0) return;
	
	        r.scrollTop(t);
	    } catch (e) {}
	};
	
	var toCamel = exports.toCamel = function toCamel(str) {
	    return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, c) {
	        return c.toUpperCase();
	    });
	};
	
	var toHash = exports.toHash = function toHash(str) {
	    return (str || '').split('').reduce(function (a, b) {
	        a = (a << 5) - a + b.charCodeAt(0);
	        return a & a;
	    }, 0);
	};
	
	var isWebKit = exports.isWebKit = function isWebKit() {
	    return (/WebKit/.test(navigator.userAgent)
	    );
	};
	
	var delay = exports.delay = function delay(ms) {
	    return new Promise(function (ok) {
	        return setTimeout(ok, ms);
	    });
	};
	
	var safeNum = exports.safeNum = function safeNum(x) {
	    var dv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    var n = Number.parseFloat(x);
	    return isNaN(n) ? dv : n;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var definePropertyModule = __webpack_require__(41);
	var createPropertyDescriptor = __webpack_require__(85);
	
	module.exports = DESCRIPTORS ? function (object, key, value) {
	  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	module.exports = function (it) {
	  return it === null || it === undefined;
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(45);
	var call = __webpack_require__(16);
	var anObject = __webpack_require__(18);
	var tryToString = __webpack_require__(149);
	var isArrayIteratorMethod = __webpack_require__(347);
	var lengthOfArrayLike = __webpack_require__(40);
	var isPrototypeOf = __webpack_require__(77);
	var getIterator = __webpack_require__(252);
	var getIteratorMethod = __webpack_require__(205);
	var iteratorClose = __webpack_require__(254);
	
	var $TypeError = TypeError;
	
	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};
	
	var ResultPrototype = Result.prototype;
	
	module.exports = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = bind(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;
	
	  var stop = function (condition) {
	    if (iterator) iteratorClose(iterator, 'normal', condition);
	    return new Result(true, condition);
	  };
	
	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    } return INTERRUPTED ? fn(value, stop) : fn(value);
	  };
	
	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && isPrototypeOf(ResultPrototype, result)) return result;
	      } return new Result(false);
	    }
	    iterator = getIterator(iterable, iterFn);
	  }
	
	  next = IS_RECORD ? iterable.next : iterator.next;
	  while (!(step = call(next, iterator)).done) {
	    try {
	      result = callFn(step.value);
	    } catch (error) {
	      iteratorClose(iterator, 'throw', error);
	    }
	    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
	  } return new Result(false);
	};


/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.timezonePatterns = exports.numericPatterns = void 0;
	var numericPatterns = {
	  month: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  date: /^(3[0-1]|[0-2]?\d)/,
	  // 0 to 31
	  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
	  // 0 to 366
	  week: /^(5[0-3]|[0-4]?\d)/,
	  // 0 to 53
	  hour23h: /^(2[0-3]|[0-1]?\d)/,
	  // 0 to 23
	  hour24h: /^(2[0-4]|[0-1]?\d)/,
	  // 0 to 24
	  hour11h: /^(1[0-1]|0?\d)/,
	  // 0 to 11
	  hour12h: /^(1[0-2]|0?\d)/,
	  // 0 to 12
	  minute: /^[0-5]?\d/,
	  // 0 to 59
	  second: /^[0-5]?\d/,
	  // 0 to 59
	
	  singleDigit: /^\d/,
	  // 0 to 9
	  twoDigits: /^\d{1,2}/,
	  // 0 to 99
	  threeDigits: /^\d{1,3}/,
	  // 0 to 999
	  fourDigits: /^\d{1,4}/,
	  // 0 to 9999
	
	  anyDigitsSigned: /^-?\d+/,
	  singleDigitSigned: /^-?\d/,
	  // 0 to 9, -0 to -9
	  twoDigitsSigned: /^-?\d{1,2}/,
	  // 0 to 99, -0 to -99
	  threeDigitsSigned: /^-?\d{1,3}/,
	  // 0 to 999, -0 to -999
	  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
	};
	exports.numericPatterns = numericPatterns;
	var timezonePatterns = {
	  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
	  basic: /^([+-])(\d{2})(\d{2})|Z/,
	  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
	  extended: /^([+-])(\d{2}):(\d{2})|Z/,
	  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
	};
	exports.timezonePatterns = timezonePatterns;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDomainOfCategoryAxis = exports.getBandSizeOfAxis = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(438));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(299));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(301));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _max2 = _interopRequireDefault(__webpack_require__(742));
	
	var _min2 = _interopRequireDefault(__webpack_require__(744));
	
	var _flatMap2 = _interopRequireDefault(__webpack_require__(1944));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _get2 = _interopRequireDefault(__webpack_require__(185));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _rechartsScale = __webpack_require__(2003);
	
	var d3Scales = _interopRequireWildcard(__webpack_require__(620));
	
	var _d3Shape = __webpack_require__(381);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(232));
	
	var _Legend = _interopRequireDefault(__webpack_require__(446));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil2["default"])(obj) || (0, _isNil2["default"])(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get2["default"])(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction2["default"])(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	
	
	exports.getValueByDataKey = getValueByDataKey;
	
	var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = (0, _flatMap2["default"])(data, function (entry) {
	    return getValueByDataKey(entry, key);
	  });
	
	  if (type === 'number') {
	    var domain = flattenData.filter(function (entry) {
	      return (0, _DataUtils.isNumber)(entry) || parseFloat(entry, 10);
	    });
	    return domain.length ? [(0, _min2["default"])(domain), (0, _max2["default"])(domain)] : [Infinity, -Infinity];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  }) : flattenData;
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	exports.getDomainOfDataByKey = getDomainOfDataByKey;
	
	var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
	      var range = axis.range; // ticks are distributed in a circle
	
	      for (var i = 0; i < len; i++) {
	        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
	        var cur = unsortedTicks[i].coordinate;
	        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
	        var sameDirectionCoord = void 0;
	
	        if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
	          var diffInterval = [];
	
	          if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
	            sameDirectionCoord = after;
	            var curInRange = cur + range[1] - range[0];
	            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
	            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
	          } else {
	            sameDirectionCoord = before;
	            var afterInRange = after + range[1] - range[0];
	            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
	            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
	          }
	
	          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
	
	          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        } else {
	          var min = Math.min(before, after);
	          var max = Math.max(before, after);
	
	          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        }
	      }
	    } else {
	      // ticks are distributed in a single direction
	      for (var _i = 0; _i < len; _i++) {
	        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
	          index = ticks[_i].index;
	          break;
	        }
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	
	
	exports.calculateActiveTickIndex = calculateActiveTickIndex;
	
	var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var _item$props = item.props,
	      stroke = _item$props.stroke,
	      fill = _item$props.fill;
	  var result;
	
	  switch (displayName) {
	    case 'Line':
	      result = stroke;
	      break;
	
	    case 'Area':
	    case 'Radar':
	      result = stroke && stroke !== 'none' ? stroke : fill;
	      break;
	
	    default:
	      result = fill;
	      break;
	  }
	
	  return result;
	};
	
	exports.getMainColorOfGraphicItem = getMainColorOfGraphicItem;
	
	var getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendContent = _ref.legendContent;
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData;
	
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
	      var item = _ref2.item,
	          props = _ref2.props;
	      var data = props.sectors || props.data || [];
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item;
	      var _item$props2 = item.props,
	          dataKey = _item$props2.dataKey,
	          name = _item$props2.name,
	          legendType = _item$props2.legendType,
	          hide = _item$props2.hide;
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _objectSpread({}, legendItem.props, {}, _Legend["default"].getWithHeight(legendItem, legendWidth), {
	    payload: legendData,
	    item: legendItem
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	
	
	exports.getLegendProps = getLegendProps;
	
	var getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === void 0 ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil2["default"])(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	
	
	exports.getBarSizeList = getBarSizeList;
	
	var getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === void 0 ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	  var len = sizeList.length;
	  if (len < 1) return null;
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result; // whether or not is barSize setted by user
	
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = {
	      offset: offset - realBarGap,
	      size: 0
	    };
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: prev
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({
	            item: item,
	            position: newRes[newRes.length - 1].position
	          });
	        });
	      }
	
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	exports.getBarPosition = getBarPosition;
	
	var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({
	    children: children,
	    items: items,
	    legendWidth: legendWidth,
	    legendHeight: legendHeight
	  });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _objectSpread({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	exports.appendOffsetOfLegend = appendOffsetOfLegend;
	
	var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	    return (0, _isNil2["default"])(direction) || (0, _isNil2["default"])(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray2["default"])(entryValue) ? [(0, _min2["default"])(entryValue), (0, _max2["default"])(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray2["default"])(errorValue) ? errorValue[1] : errorValue);
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	
	exports.getDomainOfErrorBars = getDomainOfErrorBars;
	
	var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil2["default"])(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	
	
	exports.parseErrorBarsOfAxis = parseErrorBarsOfAxis;
	
	var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var dataKey = item.props.dataKey;
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {}; // Get the union set of category axis
	
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	        result.push(entry[i]);
	      }
	    }
	
	    return result;
	  }, []);
	};
	
	exports.getDomainOfItemsWithSameAxis = getDomainOfItemsWithSameAxis;
	
	var isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	/**
	 * Calculate the Coordinates of grid
	 * @param  {Array} ticks The ticks in axis
	 * @param {Number} min   The minimun value of axis
	 * @param {Number} max   The maximun value of axis
	 * @return {Array}       Coordinates
	 */
	
	
	exports.isCategorialAxis = isCategorialAxis;
	
	var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin, hasMax;
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	
	
	exports.getCoordinatesOfGrid = getCoordinatesOfGrid;
	
	var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type,
	      range = axis.range;
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	  offset = axis.axisType === 'angleAxis' ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line
	
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return {
	        coordinate: scale(entry) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  } // When axis has duplicated text, serial numbers are used to generate scale
	
	
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	
	
	exports.getTicksOfAxis = getTicksOfAxis;
	
	var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler;
	
	  if ((0, _isFunction2["default"])(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction2["default"])(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction2["default"])(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction2["default"])(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction2["default"])(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	
	
	exports.combineEventHandlers = combineEventHandlers;
	
	var parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    if (layout === 'radial' && axisType === 'angleAxis') {
	      return {
	        scale: d3Scales.scaleLinear(),
	        realScaleType: 'linear'
	      };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return {
	        scale: d3Scales.scalePoint(),
	        realScaleType: 'point'
	      };
	    }
	
	    if (type === 'category') {
	      return {
	        scale: d3Scales.scaleBand(),
	        realScaleType: 'band'
	      };
	    }
	
	    return {
	      scale: d3Scales.scaleLinear(),
	      realScaleType: 'linear'
	    };
	  }
	
	  if ((0, _isString2["default"])(scale)) {
	    var name = "scale".concat(scale.slice(0, 1).toUpperCase()).concat(scale.slice(1));
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction2["default"])(scale) ? {
	    scale: scale
	  } : {
	    scale: d3Scales.scalePoint(),
	    realScaleType: 'point'
	  };
	};
	
	exports.parseScale = parseScale;
	var EPS = 1e-4;
	
	var checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	exports.checkDomainOfScale = checkDomainOfScale;
	
	var findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	exports.findPositionOfBar = findPositionOfBar;
	
	var truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	  var result = [value[0], value[1]];
	
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	/* eslint no-param-reassign: 0 */
	
	
	exports.truncateByDomain = truncateByDomain;
	
	var offsetSign = function offsetSign(series) {
	  var n = series.length;
	
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = (0, _isNaN2["default"])(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	      /* eslint-disable prefer-destructuring */
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	      /* eslint-enable prefer-destructuring */
	
	    }
	  }
	};
	
	exports.offsetSign = offsetSign;
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	  return stack(data);
	};
	
	exports.getStackedData = getStackedData;
	
	var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
	  if (!data) {
	    return null;
	  } // reversing items to affect render order (for layering)
	
	
	  var items = reverseStackOrder ? _items.reverse() : _items;
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props3 = item.props,
	        stackId = _item$props3.stackId,
	        hide = _item$props3.hide;
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || {
	      hasStack: false,
	      stackGroups: {}
	    };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: []
	      };
	      childGroup.items.push(item);
	      parentGroup.hasStack = true;
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId,
	        cateAxisId: cateAxisId,
	        items: [item]
	      };
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	        return _objectSpread({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	
	
	exports.getStackGroupsByAxisId = getStackGroupsByAxisId;
	
	var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [(0, _min2["default"])(ticks), (0, _max2["default"])(ticks)];
	  }
	
	  return ticks;
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	
	
	exports.calculateDomainOfTicks = calculateDomainOfTicks;
	
	var getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	
	    if (!domain.length) {
	      return null;
	    }
	
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	    return {
	      niceTicks: tickValues
	    };
	  }
	
	  if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return {
	      niceTicks: _tickValues
	    };
	  }
	
	  return null;
	};
	
	exports.getTicksOfScale = getTicksOfScale;
	
	var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index,
	      dataKey = _ref6.dataKey;
	
	  if (axis.type === 'category') {
	    // find coordinate of category axis by the value of category
	    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil2["default"])(entry[axis.dataKey])) {
	      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
	
	      if (matchedTick) {
	        return matchedTick.coordinate + bandSize / 2;
	      }
	    }
	
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, !(0, _isNil2["default"])(dataKey) ? dataKey : axis.dataKey);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) : null;
	};
	
	exports.getCateCoordinateOfLine = getCateCoordinateOfLine;
	
	var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	  return !(0, _isNil2["default"])(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	exports.getCateCoordinateOfBar = getCateCoordinateOfBar;
	
	var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	exports.getBaseValueOfBar = getBaseValueOfBar;
	
	var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	exports.getStackedDataOfItem = getStackedDataOfItem;
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [(0, _min2["default"])(entry.concat([result[0]]).filter(_DataUtils.isNumber)), (0, _max2["default"])(entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	exports.getDomainOfStackGroups = getDomainOfStackGroups;
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MIN_VALUE_REG = MIN_VALUE_REG;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	exports.MAX_VALUE_REG = MAX_VALUE_REG;
	
	var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray2["default"])(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	  /* eslint-disable prefer-destructuring */
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	    domain[0] = dataDomain[0] - value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[0])) {
	    domain[0] = specifiedDomain[0](dataDomain[0]);
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else if ((0, _isFunction2["default"])(specifiedDomain[1])) {
	    domain[1] = specifiedDomain[1](dataDomain[1]);
	  } else {
	    domain[1] = dataDomain[1];
	  }
	  /* eslint-enable prefer-destructuring */
	
	
	  return domain;
	};
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	
	
	exports.parseSpecifiedDomain = parseSpecifiedDomain;
	
	var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy2["default"])(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	/**
	 * parse the domain of a category axis when a domain is specified
	 * @param   {Array}        specifiedDomain  The domain specified by users
	 * @param   {Array}        calculatedDomain The domain calculated by dateKey
	 * @param   {ReactElement} axisChild        The axis element
	 * @returns {Array}        domains
	 */
	
	
	exports.getBandSizeOfAxis = getBandSizeOfAxis;
	
	var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
	  if (!specifiedDomain || !specifiedDomain.length) {
	    return calculatedDomain;
	  }
	
	  if ((0, _isEqual2["default"])(specifiedDomain, (0, _get2["default"])(axisChild, 'type.defaultProps.domain'))) {
	    return calculatedDomain;
	  }
	
	  return specifiedDomain;
	};
	
	exports.parseDomainOfCategoryAxis = parseDomainOfCategoryAxis;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var has = __webpack_require__(72).has;
	
	// Perform ? RequireInternalSlot(M, [[MapData]])
	module.exports = function (it) {
	  has(it);
	  return it;
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(21);
	var create = __webpack_require__(76);
	var defineProperty = __webpack_require__(41).f;
	
	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype = Array.prototype;
	
	// Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] === undefined) {
	  defineProperty(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: create(null)
	  });
	}
	
	// add a key to Array.prototype[@@unscopables]
	module.exports = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	// eslint-disable-next-line es/no-map -- safe
	var MapPrototype = Map.prototype;
	
	module.exports = {
	  // eslint-disable-next-line es/no-map -- safe
	  Map: Map,
	  set: uncurryThis(MapPrototype.set),
	  get: uncurryThis(MapPrototype.get),
	  has: uncurryThis(MapPrototype.has),
	  remove: uncurryThis(MapPrototype['delete']),
	  proto: MapPrototype
	};


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineProperty = __webpack_require__(41).f;
	var hasOwn = __webpack_require__(28);
	var wellKnownSymbol = __webpack_require__(21);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	
	module.exports = function (target, TAG, STATIC) {
	  if (target && !STATIC) target = target.prototype;
	  if (target && !hasOwn(target, TO_STRING_TAG)) {
	    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
	  }
	};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.hasCreditRatings = exports.useBondDetail = exports.ContextProvider = exports.Context = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _twd.getState)('bond_detail.last', { ts: 0, cusip: '' });
	
	var Context = exports.Context = _react2.default.createContext();
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var cusip_ = _ref.cusip,
	        children = _ref.children;
	
	
	    cusip_ = cusip_ || Last.value.cusip;
	
	    var _React$useState = _react2.default.useState(cusip_ || Last.value.cusip),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        cusip = _React$useState2[0],
	        setCusip = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState({}),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        issue = _React$useState4[0],
	        setIssue = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        hold = _React$useState6[0],
	        setHold = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState({}),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        bid = _React$useState8[0],
	        setBid = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState({}),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        offer = _React$useState10[0],
	        setOffer = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState({}),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        ask = _React$useState12[0],
	        setAsk = _React$useState12[1];
	
	    var _React$useState13 = _react2.default.useState({}),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        desc = _React$useState14[0],
	        setDesc = _React$useState14[1];
	
	    var _React$useState15 = _react2.default.useState([]),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        events = _React$useState16[0],
	        setEvents = _React$useState16[1];
	
	    var _React$useState17 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState18 = _slicedToArray(_React$useState17, 2),
	        status = _React$useState18[0],
	        setStatus = _React$useState18[1];
	
	    _react2.default.useEffect(function () {
	
	        setCusip(cusip_);
	        Last.set({ cusip: cusip });
	        setHold((0, _twd.getConfig)('cusips_held', {})[cusip_] || []);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref3, issuedata, data_, _ref4, bookdata, warn_, _ref5, descdata, desc_, issue_, offer_, _ref6, eventsdata, events_;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.next = 4;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/cusip/issuedata',
	                                method: 'GET',
	                                params: { cusip: cusip_ }
	                            });
	
	                        case 4:
	                            _ref3 = _context.sent;
	                            issuedata = _ref3.data;
	                            _context.next = 8;
	                            return issuedata;
	
	                        case 8:
	                            _context.t0 = _context.sent.IssueData;
	
	                            if (_context.t0) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.t0 = {};
	
	                        case 11:
	                            data_ = _context.t0;
	
	                            if (!(Object.keys(data_).length === 0)) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            setStatus('Not Found');
	                            return _context.abrupt('return');
	
	                        case 15:
	                            _context.next = 17;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/cusip/warningAndBook',
	                                method: 'POST',
	                                params: {
	                                    "p_criteria_fmt": "ADVANCED",
	                                    "p_cusip": cusip_,
	                                    "p_maxrows": 1,
	                                    "p_monarch": "Y",
	                                    "p_output_fmt": "JSON",
	                                    "p_multiple": ["BOL-UOR", "BOL-ROR"],
	                                    "p_submit": "JSON",
	                                    "p_redirect_output": "Y",
	                                    "p_type": "0",
	                                    "p_min_qty": 1,
	                                    "p_is_offer_search": false,
	                                    "p_search_criteria": {},
	                                    "p_mode": "RP"
	                                }
	                            });
	
	                        case 17:
	                            _ref4 = _context.sent;
	                            bookdata = _ref4.data;
	                            _context.next = 21;
	                            return bookdata;
	
	                        case 21:
	                            _context.t1 = _context.sent[0];
	
	                            if (_context.t1) {
	                                _context.next = 24;
	                                break;
	                            }
	
	                            _context.t1 = {};
	
	                        case 24:
	                            warn_ = _context.t1;
	                            _context.next = 27;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/bondDetailService/getIssueDesc',
	                                method: 'POST',
	                                params: {
	                                    p_cusip: cusip_,
	                                    p_id_type: 'I',
	                                    p_brand: (0, _twd.getBrand)(),
	                                    p_alloc_id: '',
	                                    p_watch_id: '',
	                                    p_ngw: 'Y'
	                                }
	                            });
	
	                        case 27:
	                            _ref5 = _context.sent;
	                            descdata = _ref5.data;
	                            _context.t2 = _twd.evalJson;
	                            _context.next = 32;
	                            return descdata;
	
	                        case 32:
	                            _context.t3 = _context.sent;
	                            _context.t4 = {};
	                            desc_ = (0, _context.t2)(_context.t3, _context.t4);
	
	                            setDesc(desc_ || {});
	                            issue_ = Object.assign(desc_.issue || {}, {
	                                data: data_,
	                                issueDisplay: data_.issueDisplay,
	                                warningText: data_.warningTextRewrite,
	                                babInd: data_.babInd,
	                                spInd: data_.spInd,
	                                condCallableInd: data_.condCallableInd,
	                                research: data_.research,
	                                allowTrading: warn_.allowTrading,
	                                showBook: warn_.showBook
	                            });
	
	                            setIssue(issue_);
	                            offer_ = desc_.bestoffer || {};
	
	                            setOffer(offer_);
	                            setAsk(offer_.ask || {});
	                            setBid(offer_.bid || {});
	
	                            _context.next = 44;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/bondDetailService/getSecurityEvents ',
	                                method: 'POST',
	                                params: {
	                                    cusip: cusip_,
	                                    invType: issue_.type
	                                }
	                            });
	
	                        case 44:
	                            _ref6 = _context.sent;
	                            eventsdata = _ref6.data;
	                            _context.t5 = _twd.evalJson;
	                            _context.next = 49;
	                            return eventsdata;
	
	                        case 49:
	                            _context.t6 = _context.sent;
	                            _context.t7 = {};
	                            events_ = (0, _context.t5)(_context.t6, _context.t7).securityeventsjson;
	
	                            setEvents(events_ || []);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 59;
	                            break;
	
	                        case 56:
	                            _context.prev = 56;
	                            _context.t8 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 59:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 56]]);
	        }))();
	    }, [cusip_ || Last.value.params]);
	
	    return _react2.default.createElement(
	        Context.Provider,
	        {
	            value: {
	                cusip: cusip,
	                issue: issue,
	                offer: offer,
	                bid: bid,
	                ask: ask,
	                hold: hold,
	                events: events,
	                desc: desc,
	                status: status
	            } },
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: status },
	            children
	        )
	    );
	};
	var useBondDetail = exports.useBondDetail = function useBondDetail() {
	    return _react2.default.useContext(Context);
	};
	
	var hasCreditRatings = exports.hasCreditRatings = function hasCreditRatings(issue) {
	
	    if (issue.type === 'T' && issue.category === 'B') {
	        return true;
	    }
	    return ['S', 'R', 'O', 'L'].indexOf(issue.type) < 0;
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(46);
	var toString = __webpack_require__(17);
	
	var quot = /"/g;
	var replace = uncurryThis(''.replace);
	
	// `CreateHTML` abstract operation
	// https://tc39.es/ecma262/#sec-createhtml
	module.exports = function (string, tag, attribute, value) {
	  var S = toString(requireObjectCoercible(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* global ActiveXObject -- old IE, WSH */
	var anObject = __webpack_require__(18);
	var definePropertiesModule = __webpack_require__(354);
	var enumBugKeys = __webpack_require__(344);
	var hiddenKeys = __webpack_require__(206);
	var html = __webpack_require__(520);
	var documentCreateElement = __webpack_require__(249);
	var sharedKey = __webpack_require__(261);
	
	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	
	var EmptyConstructor = function () { /* empty */ };
	
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};
	
	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  activeXDocument = null; // avoid memory leak
	  return temp;
	};
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};
	
	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) { /* ignore */ }
	  NullProtoObject = typeof document != 'undefined'
	    ? document.domain && activeXDocument
	      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	      : NullProtoObjectViaIFrame()
	    : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	
	hiddenKeys[IE_PROTO] = true;
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	module.exports = uncurryThis({}.isPrototypeOf);


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var iterateSimple = __webpack_require__(124);
	var SetHelpers = __webpack_require__(59);
	
	var Set = SetHelpers.Set;
	var SetPrototype = SetHelpers.proto;
	var forEach = uncurryThis(SetPrototype.forEach);
	var keys = uncurryThis(SetPrototype.keys);
	var next = keys(new Set()).next;
	
	module.exports = function (set, fn, interruptible) {
	  return interruptible ? iterateSimple({ iterator: keys(set), next: next }, fn) : forEach(set, fn);
	};


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	// check the existence of a method, lowercase
	// of a tag and escaping quotes in arguments
	module.exports = function (METHOD_NAME) {
	  return fails(function () {
	    var test = ''[METHOD_NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  });
	};


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(49);
	
	var min = Math.min;
	
	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	module.exports = function (argument) {
	  var len = toIntegerOrInfinity(argument);
	  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(111),
		__webpack_require__(113),
		__webpack_require__(63),
		__webpack_require__(287),
		__webpack_require__(286),
		__webpack_require__(1825),
		__webpack_require__(412),
		__webpack_require__(229),
		__webpack_require__(1826),
		__webpack_require__(1827),
		__webpack_require__(708),
		__webpack_require__(706),
		__webpack_require__(154),
	
		// The following utils are attached directly to the jQuery object.
		__webpack_require__(698),
		__webpack_require__(1821)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName, arr, document, indexOf, hasOwn, pop, push,
		slice, sort, splice, whitespace, rtrimCSS, support ) {
	
	"use strict";
	
	var preferredDoc = document,
		pushNative = push;
	
	( function() {
	
	var i,
		Expr,
		outermostContext,
		sortInput,
		hasDuplicate,
		push = pushNative,
	
		// Local document vars
		document,
		documentElement,
		documentIsHTML,
		rbuggyQSA,
		matches,
	
		// Instance-specific data
		expando = jQuery.expando,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
			"loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
			whitespace + "*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			ID: new RegExp( "^#(" + identifier + ")" ),
			CLASS: new RegExp( "^\\.(" + identifier + ")" ),
			TAG: new RegExp( "^(" + identifier + "|[*])" ),
			ATTR: new RegExp( "^" + attributes ),
			PSEUDO: new RegExp( "^" + pseudos ),
			CHILD: new RegExp(
				"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
					whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
					whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			bool: new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			needsContext: new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			if ( nonHex ) {
	
				// Strip the backslash prefix from a non-hex escape sequence
				return nonHex;
			}
	
			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			return high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// Used for iframes; see `setDocument`.
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE/Edge.
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && nodeName( elem, "fieldset" );
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android <=4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = {
			apply: function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			},
			call: function( target ) {
				pushNative.apply( target, slice.call( arguments, 1 ) );
			}
		};
	}
	
	function find( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE 9 only
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									push.call( results, elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								find.contains( context, elem ) &&
								elem.id === m ) {
	
								push.call( results, elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( !nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when
						// strict-comparing two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( newContext != context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = jQuery.escapeSelector( nid );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties
			// (see https://github.com/jquery/sizzle/issues/157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by jQuery selector module
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			return nodeName( elem, "input" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
				elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11+
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						elem.isDisabled !== !disabled &&
							inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a jQuery selector context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [node] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	function setDocument( node ) {
		var subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		documentElement = document.documentElement;
		documentIsHTML = !jQuery.isXMLDoc( document );
	
		// Support: iOS 7 only, IE 9 - 11+
		// Older browsers didn't support unprefixed `matches`.
		matches = documentElement.matches ||
			documentElement.webkitMatchesSelector ||
			documentElement.msMatchesSelector;
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors
		// (see trac-13936).
		// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
		// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
		if ( documentElement.msMatchesSelector &&
	
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 9 - 11+, Edge 12 - 18+
			subWindow.addEventListener( "unload", unloadHandler );
		}
	
		// Support: IE <10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			documentElement.appendChild( el ).id = jQuery.expando;
			return !document.getElementsByName ||
				!document.getElementsByName( jQuery.expando ).length;
		} );
	
		// Support: IE 9 only
		// Check to see if it's possible to do matchesSelector
		// on a disconnected node.
		support.disconnectedMatch = assert( function( el ) {
			return matches.call( el, "*" );
		} );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// IE/Edge don't support the :scope pseudo-class.
		support.scope = assert( function() {
			return document.querySelectorAll( ":scope" );
		} );
	
		// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
		// Make sure the `:has()` argument is parsed unforgivingly.
		// We include `*` in the test to detect buggy implementations that are
		// _selectively_ forgiving (specifically when the list includes at least
		// one valid selector).
		// Note that we treat complete lack of support for `:has()` as if it were
		// spec-compliant support, which is fine because use of `:has()` in such
		// environments will fail in the qSA path and fall back to jQuery traversal
		// anyway.
		support.cssHas = assert( function() {
			try {
				document.querySelector( ":has(*,:jqfake)" );
				return false;
			} catch ( e ) {
				return true;
			}
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter.ID = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter.ID =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find.ID = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find.TAG = function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );
	
			// DocumentFragment nodes don't have gEBTN
			} else {
				return context.querySelectorAll( tag );
			}
		};
	
		// Class
		Expr.find.CLASS = function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		rbuggyQSA = [];
	
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {
	
			var input;
	
			documentElement.appendChild( el ).innerHTML =
				"<a id='" + expando + "' href='' disabled='disabled'></a>" +
				"<select id='" + expando + "-\r\\' disabled='disabled'>" +
				"<option selected=''></option></select>";
	
			// Support: iOS <=7 - 8 only
			// Boolean attributes and "value" are not treated correctly in some XML documents
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}
	
			// Support: iOS <=7 - 8 only
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}
	
			// Support: iOS 8 only
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}
	
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}
	
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );
	
			// Support: IE 9 - 11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
			// In some of the document kinds, these selectors wouldn't work natively.
			// This is probably OK but for backwards compatibility we want to maintain
			// handling them through jQuery traversal in jQuery 3.x.
			documentElement.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}
	
			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}
		} );
	
		if ( !support.cssHas ) {
	
			// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
			// Our regular `try-catch` mechanism fails to detect natively-unsupported
			// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
			// in browsers that parse the `:has()` argument as a forgiving selector list.
			// https://drafts.csswg.org/selectors/#relational now requires the argument
			// to be parsed unforgivingly, but browsers have not yet fully adjusted.
			rbuggyQSA.push( ":has" );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a === document || a.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b === document || b.ownerDocument == preferredDoc &&
					find.contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		};
	
		return document;
	}
	
	find.matches = function( expr, elements ) {
		return find( expr, null, null, elements );
	};
	
	find.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return find( expr, document, null, [ elem ] ).length > 0;
	};
	
	find.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return jQuery.contains( context, elem );
	};
	
	
	find.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (see trac-13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		if ( val !== undefined ) {
			return val;
		}
	
		return elem.getAttribute( name );
	};
	
	find.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	jQuery.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		//
		// Support: Android <=4.0+
		// Testing for detecting duplicates is unpredictable so instead assume we can't
		// depend on duplicate detection in all browsers without a stable sort.
		hasDuplicate = !support.sortStable;
		sortInput = !support.sortStable && slice.call( results, 0 );
		sort.call( results, sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				splice.call( results, duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	jQuery.fn.uniqueSort = function() {
		return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
	};
	
	Expr = jQuery.expr = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			ATTR: function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
					.replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			CHILD: function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						find.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
					);
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					find.error( match[ 0 ] );
				}
	
				return match;
			},
	
			PSEUDO: function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			TAG: function( nodeNameSelector ) {
				var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return nodeName( elem, expectedNodeName );
					};
			},
	
			CLASS: function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace + ")" + className +
						"(" + whitespace + "|$)" ) ) &&
					classCache( className, function( elem ) {
						return pattern.test(
							typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
						);
					} );
			},
	
			ATTR: function( name, operator, check ) {
				return function( elem ) {
					var result = find.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					if ( operator === "=" ) {
						return result === check;
					}
					if ( operator === "!=" ) {
						return result !== check;
					}
					if ( operator === "^=" ) {
						return check && result.indexOf( check ) === 0;
					}
					if ( operator === "*=" ) {
						return check && result.indexOf( check ) > -1;
					}
					if ( operator === "$=" ) {
						return check && result.slice( -check.length ) === check;
					}
					if ( operator === "~=" ) {
						return ( " " + result.replace( rwhitespace, " " ) + " " )
							.indexOf( check ) > -1;
					}
					if ( operator === "|=" ) {
						return result === check || result.slice( 0, check.length + 1 ) === check + "-";
					}
	
					return false;
				};
			},
	
			CHILD: function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
								outerCache = parent[ expando ] || ( parent[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										outerCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
									outerCache = elem[ expando ] || ( elem[ expando ] = {} );
									cache = outerCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											nodeName( node, name ) :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
												outerCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			PSEUDO: function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// https://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						find.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as jQuery does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf.call( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			not: markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrimCSS, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element
						// (see https://github.com/jquery/sizzle/issues/299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			has: markFunction( function( selector ) {
				return function( elem ) {
					return find( selector, elem ).length > 0;
				};
			} ),
	
			contains: markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// https://www.w3.org/TR/selectors/#lang-pseudo
			lang: markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					find.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			target: function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			root: function( elem ) {
				return elem === documentElement;
			},
	
			focus: function( elem ) {
				return elem === safeActiveElement() &&
					document.hasFocus() &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			enabled: createDisabledPseudo( false ),
			disabled: createDisabledPseudo( true ),
	
			checked: function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				return ( nodeName( elem, "input" ) && !!elem.checked ) ||
					( nodeName( elem, "option" ) && !!elem.selected );
			},
	
			selected: function( elem ) {
	
				// Support: IE <=11+
				// Accessing the selectedIndex property
				// forces the browser to treat the default option as
				// selected when in an optgroup.
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			empty: function( elem ) {
	
				// https://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			parent: function( elem ) {
				return !Expr.pseudos.empty( elem );
			},
	
			// Element/input types
			header: function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			input: function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			button: function( elem ) {
				return nodeName( elem, "input" ) && elem.type === "button" ||
					nodeName( elem, "button" );
			},
	
			text: function( elem ) {
				var attr;
				return nodeName( elem, "input" ) && elem.type === "text" &&
	
					// Support: IE <10 only
					// New HTML5 attribute values (e.g., "search") appear
					// with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			first: createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			last: createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			even: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			odd: createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i;
	
				if ( argument < 0 ) {
					i = argument + length;
				} else if ( argument > length ) {
					i = length;
				} else {
					i = argument;
				}
	
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos.nth = Expr.pseudos.eq;
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	function tokenize( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrimCSS, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		if ( parseOnly ) {
			return soFar.length;
		}
	
		return soFar ?
			find.error( selector ) :
	
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
	}
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							if ( skip && nodeName( elem, skip ) ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = outerCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								outerCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			find( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem, matcherOut,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed ||
					multipleContexts( selector || "*",
						context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems;
	
			if ( matcher ) {
	
				// If we have a postFinder, or filtered seed, or non-seed postFilter
				// or preexisting results,
				matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
					// ...intermediate processing is necessary
					[] :
	
					// ...otherwise use results directly
					results;
	
				// Find primary matches
				matcher( matcherIn, matcherOut, context, xml );
			} else {
				matcherOut = matcherIn;
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf.call( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element
				// (see https://github.com/jquery/sizzle/issues/299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 )
								.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrimCSS, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: iOS <=7 - 9 only
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
				// elements by id. (see trac-14142)
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								push.call( results, elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						jQuery.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	function compile( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	}
	
	/**
	 * A low-level selection function that works with jQuery's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with jQuery selector compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	function select( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find.ID(
					token.matches[ 0 ].replace( runescape, funescape ),
					context
				) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) &&
							testContext( context.parentNode ) || context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	}
	
	// One-time assignments
	
	// Support: Android <=4.0 - 4.1+
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Android <=4.0 - 4.1+
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	jQuery.find = find;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.unique = jQuery.uniqueSort;
	
	// These have always been private, but they used to be documented as part of
	// Sizzle so let's maintain them for now for backwards compatibility purposes.
	find.compile = compile;
	find.select = select;
	find.setDocument = setDocument;
	find.tokenize = tokenize;
	
	find.escape = jQuery.escapeSelector;
	find.getText = jQuery.text;
	find.isXML = jQuery.isXMLDoc;
	find.selectors = jQuery.expr;
	find.support = jQuery.support;
	find.uniqueSort = jQuery.uniqueSort;
	
		/* eslint-enable */
	
	} )();
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 84 */
/***/ function(module, exports) {

	function _typeof(o) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 85 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(28);
	var isCallable = __webpack_require__(22);
	var toObject = __webpack_require__(33);
	var sharedKey = __webpack_require__(261);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(340);
	
	var IE_PROTO = sharedKey('IE_PROTO');
	var $Object = Object;
	var ObjectPrototype = $Object.prototype;
	
	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
	  var constructor = object.constructor;
	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  } return object instanceof $Object ? ObjectPrototype : null;
	};


/***/ },
/* 87 */
/***/ function(module, exports) {

	'use strict';
	var $TypeError = TypeError;
	
	module.exports = function (passed, required) {
	  if (passed < required) throw new $TypeError('Not enough arguments');
	  return passed;
	};


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1861),
	    baseMatchesProperty = __webpack_require__(1862),
	    identity = __webpack_require__(186),
	    isArray = __webpack_require__(43),
	    property = __webpack_require__(1957);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "configBezier", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configBezier;
	  }
	});
	Object.defineProperty(exports, "configSpring", {
	  enumerable: true,
	  get: function get() {
	    return _easing.configSpring;
	  }
	});
	Object.defineProperty(exports, "translateStyle", {
	  enumerable: true,
	  get: function get() {
	    return _util.translateStyle;
	  }
	});
	Object.defineProperty(exports, "AnimateGroup", {
	  enumerable: true,
	  get: function get() {
	    return _AnimateGroup.default;
	  }
	});
	exports.default = void 0;
	
	var _Animate = _interopRequireDefault(__webpack_require__(756));
	
	var _easing = __webpack_require__(757);
	
	var _util = __webpack_require__(304);
	
	var _AnimateGroup = _interopRequireDefault(__webpack_require__(1993));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Animate.default;
	exports.default = _default;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sectionListCss = exports.listCss = exports.headerCss = exports.tableCss = exports.sectionCss = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n'], ['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    tbody tr td {\n        vertical-align:top;\n    }\n    tbody tr td:nth-child(1) {\n        color: #767676;\n    }\n    tbody tr td:nth-child(2) {\n        text-align:right;\n    }\n    tbody tr td:nth-child(3) {\n        text-align:right;\n    }\n'], ['\n    tbody tr td {\n        vertical-align:top;\n    }\n    tbody tr td:nth-child(1) {\n        color: #767676;\n    }\n    tbody tr td:nth-child(2) {\n        text-align:right;\n    }\n    tbody tr td:nth-child(3) {\n        text-align:right;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    tbody tr td {\n        vertical-align:top;\n    }\n    tbody tr td:nth-child(2) {\n        text-align:right;\n        font-weight: 500;\n    }\n'], ['\n    tbody tr td {\n        vertical-align:top;\n    }\n    tbody tr td:nth-child(2) {\n        text-align:right;\n        font-weight: 500;\n    }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n'], ['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    & {\n        display:grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n        color: #767676;\n    }\n    dd {\n        text-align: right;\n        color: #242424;\n    }\n'], ['\n    & {\n        display:grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n        color: #767676;\n    }\n    dd {\n        text-align: right;\n        color: #242424;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	
	
	var sectionCss = exports.sectionCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);
	var tableCss = exports.tableCss = (0, _core.css)(_templateObject2);
	
	var headerCss = exports.headerCss = (0, _core.css)(_templateObject3);
	
	var listCss = exports.listCss = (0, _core.css)(_templateObject4);
	
	var sectionListCss = exports.sectionListCss = (0, _core.css)(_templateObject5);

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	module.exports = uncurryThis([].slice);


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(369);
	var isCallable = __webpack_require__(22);
	var classofRaw = __webpack_require__(61);
	var wellKnownSymbol = __webpack_require__(21);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Object = Object;
	
	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) { /* empty */ }
	};
	
	// getting tag from ES6+ `Object.prototype.toString`
	module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
	    // builtinTag case
	    : CORRECT_ARGUMENTS ? classofRaw(O)
	    // ES3 arguments fallback
	    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_BIND = __webpack_require__(204);
	
	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call;
	
	// eslint-disable-next-line es/no-reflect -- safe
	module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Initialize a jQuery object
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(53),
		__webpack_require__(680),
	
		__webpack_require__(700)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, isFunction, rsingleTag ) {
	
	"use strict";
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	return init;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(727);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 96 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var RADIAN = Math.PI / 180;
	exports.RADIAN = RADIAN;
	
	var degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	exports.degreeToRadian = degreeToRadian;
	
	var radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	exports.radianToDegree = radianToDegree;
	
	var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	exports.polarToCartesian = polarToCartesian;
	
	var getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	
	
	exports.getMaxRadius = getMaxRadius;
	
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height;
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle;
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	    var range;
	
	    if ((0, _isNil2["default"])(axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	      var _range = range;
	
	      var _range2 = _slicedToArray(_range, 2);
	
	      startAngle = _range2[0];
	      endAngle = _range2[1];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      range: range,
	      radius: outerRadius,
	      realScaleType: realScaleType,
	      scale: scale,
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	exports.distanceBetweenPoints = distanceBetweenPoints;
	
	var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	  var radius = distanceBetweenPoints({
	    x: x,
	    y: y
	  }, {
	    x: cx,
	    y: cy
	  });
	
	  if (radius <= 0) {
	    return {
	      radius: radius
	    };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return {
	    radius: radius,
	    angle: radianToDegree(angleInRadian),
	    angleInRadian: angleInRadian
	  };
	};
	
	exports.getAngleOfPoint = getAngleOfPoint;
	
	var formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	exports.formatAngleOfSector = formatAngleOfSector;
	
	var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	  return angle + min * 360;
	};
	
	var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
	  var x = _ref5.x,
	      y = _ref5.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({
	    x: x,
	    y: y
	  }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	  var inRange;
	
	  if (startAngle <= endAngle) {
	    while (formatAngle > endAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < startAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	  } else {
	    while (formatAngle > startAngle) {
	      formatAngle -= 360;
	    }
	
	    while (formatAngle < endAngle) {
	      formatAngle += 360;
	    }
	
	    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
	  }
	
	  if (inRange) {
	    return _objectSpread({}, sector, {
	      radius: radius,
	      angle: reverseFormatAngleOfSetor(formatAngle, sector)
	    });
	  }
	
	  return null;
	};
	
	exports.inRangeOfSector = inRangeOfSector;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isPrototypeOf = __webpack_require__(77);
	
	var $TypeError = TypeError;
	
	module.exports = function (it, Prototype) {
	  if (isPrototypeOf(Prototype, it)) return it;
	  throw new $TypeError('Incorrect invocation');
	};


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var iterateSimple = __webpack_require__(124);
	var MapHelpers = __webpack_require__(72);
	
	var Map = MapHelpers.Map;
	var MapPrototype = MapHelpers.proto;
	var forEach = uncurryThis(MapPrototype.forEach);
	var entries = uncurryThis(MapPrototype.entries);
	var next = entries(new Map()).next;
	
	module.exports = function (map, fn, interruptible) {
	  return interruptible ? iterateSimple({ iterator: entries(map), next: next }, function (entry) {
	    return fn(entry[1], entry[0]);
	  }) : forEach(map, fn);
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-proto -- safe */
	var uncurryThisAccessor = __webpack_require__(251);
	var isObject = __webpack_require__(20);
	var requireObjectCoercible = __webpack_require__(46);
	var aPossiblePrototype = __webpack_require__(491);
	
	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	// Works with __proto__ only. Old v8 can't work with null proto objects.
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
	  var CORRECT_SETTER = false;
	  var test = {};
	  var setter;
	  try {
	    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
	    setter(test, []);
	    CORRECT_SETTER = test instanceof Array;
	  } catch (error) { /* empty */ }
	  return function setPrototypeOf(O, proto) {
	    requireObjectCoercible(O);
	    aPossiblePrototype(proto);
	    if (!isObject(O)) return O;
	    if (CORRECT_SETTER) setter(O, proto);
	    else O.__proto__ = proto;
	    return O;
	  };
	}() : undefined);


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(423);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = function (METHOD_NAME, argument) {
	  var method = [][METHOD_NAME];
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call -- required for testing
	    method.call(null, argument || function () { return 1; }, 1);
	  });
	};


/***/ },
/* 103 */
/***/ function(module, exports) {

	'use strict';
	module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var userAgent = __webpack_require__(103);
	
	var process = global.process;
	var Deno = global.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}
	
	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && userAgent) {
	  match = userAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = userAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	
	module.exports = version;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(36);
	var isNullOrUndefined = __webpack_require__(66);
	
	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	module.exports = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	
	module.exports = global;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(49);
	
	var max = Math.max;
	var min = Math.min;
	
	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	module.exports = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min(integer, length);
	};


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var call = __webpack_require__(16);
	var DESCRIPTORS = __webpack_require__(15);
	var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(370);
	var ArrayBufferViewCore = __webpack_require__(23);
	var ArrayBufferModule = __webpack_require__(242);
	var anInstance = __webpack_require__(98);
	var createPropertyDescriptor = __webpack_require__(85);
	var createNonEnumerableProperty = __webpack_require__(65);
	var isIntegralNumber = __webpack_require__(348);
	var toLength = __webpack_require__(80);
	var toIndex = __webpack_require__(368);
	var toOffset = __webpack_require__(559);
	var toUint8Clamped = __webpack_require__(1260);
	var toPropertyKey = __webpack_require__(126);
	var hasOwn = __webpack_require__(28);
	var classof = __webpack_require__(92);
	var isObject = __webpack_require__(20);
	var isSymbol = __webpack_require__(123);
	var create = __webpack_require__(76);
	var isPrototypeOf = __webpack_require__(77);
	var setPrototypeOf = __webpack_require__(100);
	var getOwnPropertyNames = __webpack_require__(145).f;
	var typedArrayFrom = __webpack_require__(561);
	var forEach = __webpack_require__(57).forEach;
	var setSpecies = __webpack_require__(170);
	var defineBuiltInAccessor = __webpack_require__(54);
	var definePropertyModule = __webpack_require__(41);
	var getOwnPropertyDescriptorModule = __webpack_require__(58);
	var arrayFromConstructorAndList = __webpack_require__(243);
	var InternalStateModule = __webpack_require__(52);
	var inheritIfRequired = __webpack_require__(143);
	
	var getInternalState = InternalStateModule.get;
	var setInternalState = InternalStateModule.set;
	var enforceInternalState = InternalStateModule.enforce;
	var nativeDefineProperty = definePropertyModule.f;
	var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	var RangeError = global.RangeError;
	var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
	var ArrayBufferPrototype = ArrayBuffer.prototype;
	var DataView = ArrayBufferModule.DataView;
	var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
	var TYPED_ARRAY_TAG = ArrayBufferViewCore.TYPED_ARRAY_TAG;
	var TypedArray = ArrayBufferViewCore.TypedArray;
	var TypedArrayPrototype = ArrayBufferViewCore.TypedArrayPrototype;
	var isTypedArray = ArrayBufferViewCore.isTypedArray;
	var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	var WRONG_LENGTH = 'Wrong length';
	
	var addGetter = function (it, key) {
	  defineBuiltInAccessor(it, key, {
	    configurable: true,
	    get: function () {
	      return getInternalState(this)[key];
	    }
	  });
	};
	
	var isArrayBuffer = function (it) {
	  var klass;
	  return isPrototypeOf(ArrayBufferPrototype, it) || (klass = classof(it)) === 'ArrayBuffer' || klass === 'SharedArrayBuffer';
	};
	
	var isTypedArrayIndex = function (target, key) {
	  return isTypedArray(target)
	    && !isSymbol(key)
	    && key in target
	    && isIntegralNumber(+key)
	    && key >= 0;
	};
	
	var wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
	  key = toPropertyKey(key);
	  return isTypedArrayIndex(target, key)
	    ? createPropertyDescriptor(2, target[key])
	    : nativeGetOwnPropertyDescriptor(target, key);
	};
	
	var wrappedDefineProperty = function defineProperty(target, key, descriptor) {
	  key = toPropertyKey(key);
	  if (isTypedArrayIndex(target, key)
	    && isObject(descriptor)
	    && hasOwn(descriptor, 'value')
	    && !hasOwn(descriptor, 'get')
	    && !hasOwn(descriptor, 'set')
	    // TODO: add validation descriptor w/o calling accessors
	    && !descriptor.configurable
	    && (!hasOwn(descriptor, 'writable') || descriptor.writable)
	    && (!hasOwn(descriptor, 'enumerable') || descriptor.enumerable)
	  ) {
	    target[key] = descriptor.value;
	    return target;
	  } return nativeDefineProperty(target, key, descriptor);
	};
	
	if (DESCRIPTORS) {
	  if (!NATIVE_ARRAY_BUFFER_VIEWS) {
	    getOwnPropertyDescriptorModule.f = wrappedGetOwnPropertyDescriptor;
	    definePropertyModule.f = wrappedDefineProperty;
	    addGetter(TypedArrayPrototype, 'buffer');
	    addGetter(TypedArrayPrototype, 'byteOffset');
	    addGetter(TypedArrayPrototype, 'byteLength');
	    addGetter(TypedArrayPrototype, 'length');
	  }
	
	  $({ target: 'Object', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
	    getOwnPropertyDescriptor: wrappedGetOwnPropertyDescriptor,
	    defineProperty: wrappedDefineProperty
	  });
	
	  module.exports = function (TYPE, wrapper, CLAMPED) {
	    var BYTES = TYPE.match(/\d+/)[0] / 8;
	    var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + TYPE;
	    var SETTER = 'set' + TYPE;
	    var NativeTypedArrayConstructor = global[CONSTRUCTOR_NAME];
	    var TypedArrayConstructor = NativeTypedArrayConstructor;
	    var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
	    var exported = {};
	
	    var getter = function (that, index) {
	      var data = getInternalState(that);
	      return data.view[GETTER](index * BYTES + data.byteOffset, true);
	    };
	
	    var setter = function (that, index, value) {
	      var data = getInternalState(that);
	      data.view[SETTER](index * BYTES + data.byteOffset, CLAMPED ? toUint8Clamped(value) : value, true);
	    };
	
	    var addElement = function (that, index) {
	      nativeDefineProperty(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	
	    if (!NATIVE_ARRAY_BUFFER_VIEWS) {
	      TypedArrayConstructor = wrapper(function (that, data, offset, $length) {
	        anInstance(that, TypedArrayConstructorPrototype);
	        var index = 0;
	        var byteOffset = 0;
	        var buffer, byteLength, length;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new ArrayBuffer(byteLength);
	        } else if (isArrayBuffer(data)) {
	          buffer = data;
	          byteOffset = toOffset(offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw new RangeError(WRONG_LENGTH);
	            byteLength = $len - byteOffset;
	            if (byteLength < 0) throw new RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + byteOffset > $len) throw new RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (isTypedArray(data)) {
	          return arrayFromConstructorAndList(TypedArrayConstructor, data);
	        } else {
	          return call(typedArrayFrom, TypedArrayConstructor, data);
	        }
	        setInternalState(that, {
	          buffer: buffer,
	          byteOffset: byteOffset,
	          byteLength: byteLength,
	          length: length,
	          view: new DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	
	      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
	      TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = create(TypedArrayPrototype);
	    } else if (TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
	      TypedArrayConstructor = wrapper(function (dummy, data, typedArrayOffset, $length) {
	        anInstance(dummy, TypedArrayConstructorPrototype);
	        return inheritIfRequired(function () {
	          if (!isObject(data)) return new NativeTypedArrayConstructor(toIndex(data));
	          if (isArrayBuffer(data)) return $length !== undefined
	            ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES), $length)
	            : typedArrayOffset !== undefined
	              ? new NativeTypedArrayConstructor(data, toOffset(typedArrayOffset, BYTES))
	              : new NativeTypedArrayConstructor(data);
	          if (isTypedArray(data)) return arrayFromConstructorAndList(TypedArrayConstructor, data);
	          return call(typedArrayFrom, TypedArrayConstructor, data);
	        }(), dummy, TypedArrayConstructor);
	      });
	
	      if (setPrototypeOf) setPrototypeOf(TypedArrayConstructor, TypedArray);
	      forEach(getOwnPropertyNames(NativeTypedArrayConstructor), function (key) {
	        if (!(key in TypedArrayConstructor)) {
	          createNonEnumerableProperty(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
	        }
	      });
	      TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
	    }
	
	    if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) {
	      createNonEnumerableProperty(TypedArrayConstructorPrototype, 'constructor', TypedArrayConstructor);
	    }
	
	    enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
	
	    if (TYPED_ARRAY_TAG) {
	      createNonEnumerableProperty(TypedArrayConstructorPrototype, TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
	    }
	
	    var FORCED = TypedArrayConstructor !== NativeTypedArrayConstructor;
	
	    exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
	
	    $({ global: true, constructor: true, forced: FORCED, sham: !NATIVE_ARRAY_BUFFER_VIEWS }, exported);
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayConstructor)) {
	      createNonEnumerableProperty(TypedArrayConstructor, BYTES_PER_ELEMENT, BYTES);
	    }
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) {
	      createNonEnumerableProperty(TypedArrayConstructorPrototype, BYTES_PER_ELEMENT, BYTES);
	    }
	
	    setSpecies(CONSTRUCTOR_NAME);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addDays;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addDays
	 * @category Day Helpers
	 * @summary Add the specified number of days to the given date.
	 *
	 * @description
	 * Add the specified number of days to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} - the new date with the days added
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // Add 10 days to 1 September 2014:
	 * const result = addDays(new Date(2014, 8, 1), 10)
	 * //=> Thu Sep 11 2014 00:00:00
	 */
	function addDays(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 days, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  date.setDate(date.getDate() + amount);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	function nodeName( elem, name ) {
	
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	}
	
	return nodeName;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(688)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( Data ) {
		"use strict";
	
		return new Data();
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return [];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(739));
	
	var _find2 = _interopRequireDefault(__webpack_require__(1942));
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(438));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _range2 = _interopRequireDefault(__webpack_require__(746));
	
	var _throttle2 = _interopRequireDefault(__webpack_require__(1961));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Surface = _interopRequireDefault(__webpack_require__(233));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(306));
	
	var _Legend = _interopRequireDefault(__webpack_require__(446));
	
	var _Curve = _interopRequireDefault(__webpack_require__(191));
	
	var _Cross = _interopRequireDefault(__webpack_require__(772));
	
	var _Sector = _interopRequireDefault(__webpack_require__(310));
	
	var _Dot = _interopRequireDefault(__webpack_require__(160));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(192));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _CartesianAxis = _interopRequireDefault(__webpack_require__(764));
	
	var _Brush = _interopRequireDefault(__webpack_require__(763));
	
	var _DOMUtils = __webpack_require__(311);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _DetectReferenceElementsDomain = __webpack_require__(2025);
	
	var _PolarUtils = __webpack_require__(97);
	
	var _ShallowEqual = __webpack_require__(313);
	
	var _Events = __webpack_require__(2026);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	var originCoordinate = {
	  x: 0,
	  y: 0
	};
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === void 0 ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	
	  var CategoricalChartWrapper =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    /**
	     * Returns default, reset state for the categorical chart.
	     * @param {Object} props Props object to use when creating the default state
	     * @return {Object} Whole new state
	     */
	    function CategoricalChartWrapper(_props) {
	      var _this;
	
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalChartWrapper).call(this, _props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex,
	              updateId = _this$state.updateId;
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex,
	            updateId: updateId
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	        var updateId = _this.state.updateId;
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	          if (!(0, _isNil2["default"])(data.dataStartIndex) || !(0, _isNil2["default"])(data.dataEndIndex)) {
	            _this.setState(_objectSpread({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex,
	              updateId: updateId
	            })));
	          } else if (!(0, _isNil2["default"])(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	
	            var viewBox = _objectSpread({}, offset, {
	              x: offset.left,
	              y: offset.top
	            }); // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	
	
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_objectSpread({}, data, {
	              activeLabel: activeLabel,
	              activeCoordinate: activeCoordinate,
	              activePayload: activePayload
	            }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref2) {
	        var startIndex = _ref2.startIndex,
	            endIndex = _ref2.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          var updateId = _this.state.updateId;
	
	          _this.setState(function () {
	            return _objectSpread({
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
	              props: _this.props,
	              dataStartIndex: startIndex,
	              dataEndIndex: endIndex,
	              updateId: updateId
	            }));
	          });
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _objectSpread({}, mouse, {
	            isTooltipActive: true
	          });
	
	          _this.setState(nextState);
	
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction2["default"])(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	
	        var nextState = mouse ? _objectSpread({}, mouse, {
	          isTooltipActive: true
	        }) : {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleItemMouseEnter = function (el) {
	        _this.setState(function () {
	          return {
	            isTooltipActive: true,
	            activeItem: el,
	            activePayload: el.tooltipPayload,
	            activeCoordinate: el.tooltipPosition || {
	              x: el.cx,
	              y: el.cy
	            }
	          };
	        });
	      };
	
	      _this.handleItemMouseLeave = function () {
	        _this.setState(function () {
	          return {
	            isTooltipActive: false
	          };
	        });
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction2["default"])(e.persist)) {
	          e.persist();
	        }
	
	        _this.triggeredAfterMouseMove(e);
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	        var nextState = {
	          isTooltipActive: false
	        };
	
	        _this.setState(nextState);
	
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction2["default"])(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleOuterEvent = function (e) {
	        var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	        if (eventName && (0, _isFunction2["default"])(_this.props[eventName])) {
	          var mouse = _this.getMouseInfo(e);
	
	          var handler = _this.props[eventName];
	          handler(mouse, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	        if ((0, _isFunction2["default"])(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	        if ((0, _isFunction2["default"])(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	        if ((0, _isFunction2["default"])(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchStart = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseDown(e.changedTouches[0]);
	        }
	      };
	
	      _this.handleTouchEnd = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseUp(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref3) {
	        var xAxis = _ref3.xAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, xAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref4) {
	        var yAxis = _ref4.yAxis,
	            width = _ref4.width,
	            height = _ref4.height,
	            offset = _ref4.offset;
	        return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis["default"].getTicks(_objectSpread({}, _CartesianAxis["default"].defaultProps, {}, yAxis, {
	          ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (axisMap) {
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy2["default"])(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis,
	          tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	        };
	      };
	
	      _this.renderCursor = function (element) {
	        var _this$state3 = _this.state,
	            isTooltipActive = _this$state3.isTooltipActive,
	            activeCoordinate = _this$state3.activeCoordinate,
	            activePayload = _this$state3.activePayload,
	            offset = _this$state3.offset;
	
	        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	          return null;
	        }
	
	        var layout = _this.props.layout;
	        var restProps;
	        var cursorComp = _Curve["default"];
	
	        if (chartName === 'ScatterChart') {
	          restProps = activeCoordinate;
	          cursorComp = _Cross["default"];
	        } else if (chartName === 'BarChart') {
	          restProps = _this.getCursorRectangle();
	          cursorComp = _Rectangle["default"];
	        } else if (layout === 'radial') {
	          var _this$getCursorPoints = _this.getCursorPoints(),
	              cx = _this$getCursorPoints.cx,
	              cy = _this$getCursorPoints.cy,
	              radius = _this$getCursorPoints.radius,
	              startAngle = _this$getCursorPoints.startAngle,
	              endAngle = _this$getCursorPoints.endAngle;
	
	          restProps = {
	            cx: cx,
	            cy: cy,
	            startAngle: startAngle,
	            endAngle: endAngle,
	            innerRadius: radius,
	            outerRadius: radius
	          };
	          cursorComp = _Sector["default"];
	        } else {
	          restProps = {
	            points: _this.getCursorPoints()
	          };
	          cursorComp = _Curve["default"];
	        }
	
	        var key = element.key || '_recharts-cursor';
	
	        var cursorProps = _objectSpread({
	          stroke: '#ccc',
	          pointerEvents: 'none'
	        }, offset, {}, restProps, {}, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	          payload: activePayload,
	          key: key,
	          className: 'recharts-tooltip-cursor'
	        });
	
	        return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	      };
	
	      _this.renderPolarAxis = function (element, displayName, index) {
	        var axisType = element.type.axisType;
	
	        var axisMap = _this.state["".concat(axisType, "Map")];
	
	        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
	        return (0, _react.cloneElement)(element, _objectSpread({}, axisOption, {
	          className: axisType,
	          key: element.key || "".concat(displayName, "-").concat(index),
	          ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true)
	        }));
	      };
	
	      _this.renderXAxis = function (element, displayName, index) {
	        var xAxisMap = _this.state.xAxisMap;
	        var axisObj = xAxisMap[element.props.xAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderYAxis = function (element, displayName, index) {
	        var yAxisMap = _this.state.yAxisMap;
	        var axisObj = yAxisMap[element.props.yAxisId];
	        return _this.renderAxis(axisObj, element, displayName, index);
	      };
	
	      _this.renderGrid = function (element) {
	        var _this$state4 = _this.state,
	            xAxisMap = _this$state4.xAxisMap,
	            yAxisMap = _this$state4.yAxisMap,
	            offset = _this$state4.offset;
	        var _this$props2 = _this.props,
	            width = _this$props2.width,
	            height = _this$props2.height;
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxisWithFiniteDomain = (0, _find2["default"])(yAxisMap, function (axis) {
	          return (0, _every2["default"])(axis.domain, Number.isFinite);
	        });
	        var yAxis = yAxisWithFiniteDomain || (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	        var props = element.props || {};
	        return (0, _react.cloneElement)(element, {
	          key: element.key || 'grid',
	          x: (0, _DataUtils.isNumber)(props.x) ? props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(props.y) ? props.y : offset.top,
	          width: (0, _DataUtils.isNumber)(props.width) ? props.width : offset.width,
	          height: (0, _DataUtils.isNumber)(props.height) ? props.height : offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
	        });
	      };
	
	      _this.renderPolarGrid = function (element) {
	        var _this$state5 = _this.state,
	            radiusAxisMap = _this$state5.radiusAxisMap,
	            angleAxisMap = _this$state5.angleAxisMap;
	        var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	        var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	        var cx = angleAxis.cx,
	            cy = angleAxis.cy,
	            innerRadius = angleAxis.innerRadius,
	            outerRadius = angleAxis.outerRadius;
	        return (0, _react.cloneElement)(element, {
	          polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	            return entry.coordinate;
	          }),
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          key: element.key || 'polar-grid'
	        });
	      };
	
	      _this.renderBrush = function (element) {
	        var _this$props3 = _this.props,
	            margin = _this$props3.margin,
	            data = _this$props3.data;
	        var _this$state6 = _this.state,
	            offset = _this$state6.offset,
	            dataStartIndex = _this$state6.dataStartIndex,
	            dataEndIndex = _this$state6.dataEndIndex,
	            updateId = _this$state6.updateId; // TODO: update brush when children update
	
	        return (0, _react.cloneElement)(element, {
	          key: element.key || '_recharts-brush',
	          onChange: (0, _ChartUtils.combineEventHandlers)(_this.handleBrushChange, null, element.props.onChange),
	          data: data,
	          x: (0, _DataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
	          y: (0, _DataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: (0, _DataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: "brush-".concat(updateId)
	        });
	      };
	
	      _this.renderReferenceElement = function (element, displayName, index) {
	        if (!element) {
	          return null;
	        }
	
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            clipPathId = _assertThisInitialize.clipPathId;
	
	        var _this$state7 = _this.state,
	            xAxisMap = _this$state7.xAxisMap,
	            yAxisMap = _this$state7.yAxisMap,
	            offset = _this$state7.offset;
	        var _element$props = element.props,
	            xAxisId = _element$props.xAxisId,
	            yAxisId = _element$props.yAxisId;
	        return (0, _react.cloneElement)(element, {
	          key: element.key || "".concat(displayName, "-").concat(index),
	          xAxis: xAxisMap[xAxisId],
	          yAxis: yAxisMap[yAxisId],
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          },
	          clipPathId: clipPathId
	        });
	      };
	
	      _this.renderGraphicChild = function (element, displayName, index) {
	        var item = _this.filterFormatItem(element, displayName, index);
	
	        if (!item) {
	          return null;
	        }
	
	        var graphicalItem = (0, _react.cloneElement)(element, item.props);
	        var _this$state8 = _this.state,
	            isTooltipActive = _this$state8.isTooltipActive,
	            tooltipAxis = _this$state8.tooltipAxis,
	            activeTooltipIndex = _this$state8.activeTooltipIndex,
	            activeLabel = _this$state8.activeLabel;
	        var children = _this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var _item$props = item.props,
	            points = _item$props.points,
	            isRange = _item$props.isRange,
	            baseLine = _item$props.baseLine;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            hide = _item$item$props.hide;
	        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
	
	        function findWithPayload(entry) {
	          return tooltipAxis.dataKey(entry.payload);
	        }
	
	        if (hasActive) {
	          var activePoint, basePoint;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey);
	            activePoint = (0, _DataUtils.findEntryInArray)(points, specifiedKey, activeLabel);
	            basePoint = isRange && baseLine && (0, _DataUtils.findEntryInArray)(baseLine, specifiedKey, activeLabel);
	          } else {
	            activePoint = points[activeTooltipIndex];
	            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	          }
	
	          if (!(0, _isNil2["default"])(activePoint)) {
	            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
	              item: item,
	              activePoint: activePoint,
	              basePoint: basePoint,
	              childIndex: activeTooltipIndex,
	              isRange: isRange
	            })));
	          }
	        }
	
	        if (isRange) {
	          return [graphicalItem, null, null];
	        }
	
	        return [graphicalItem, null];
	      };
	
	      _this.renderCustomized = function (element) {
	        return (0, _react.cloneElement)(element, _objectSpread({}, _this.props, {}, _this.state));
	      };
	
	      var defaultState = _this.constructor.createDefaultState(_props);
	
	      var _updateId = 0;
	      _this.state = _objectSpread({}, defaultState, {
	        updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	        props: _props
	      }, defaultState, {
	        updateId: _updateId
	      })));
	      _this.uniqueChartId = (0, _isNil2["default"])(_props.id) ? (0, _DataUtils.uniqueId)('recharts') : _props.id;
	      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
	
	      if (_props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle2["default"])(_this.triggeredAfterMouseMove, _props.throttleDelay);
	      }
	
	      return _this;
	    }
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.addListener();
	        }
	      } // eslint-disable-next-line camelcase
	
	    }, {
	      key: "componentWillReceiveProps",
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var _this$props4 = this.props,
	            data = _this$props4.data,
	            children = _this$props4.children,
	            width = _this$props4.width,
	            height = _this$props4.height,
	            layout = _this$props4.layout,
	            stackOffset = _this$props4.stackOffset,
	            margin = _this$props4.margin;
	        var updateId = this.state.updateId;
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(function (oldState) {
	            return _objectSpread({}, defaultState, {
	              updateId: updateId + 1,
	              chartX: oldState.chartX,
	              chartY: oldState.chartY
	            }, _this2.getTooltipData(), {
	              isTooltipActive: oldState.isTooltipActive
	            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	              props: nextProps
	            }, defaultState, {
	              updateId: updateId + 1
	            })));
	          });
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          // update configuration in chilren
	          var hasGlobalData = !(0, _isNil2["default"])(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          this.setState(function (prevState) {
	            return _objectSpread({
	              updateId: newUpdateId
	            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
	              props: nextProps
	            }, prevState, {
	              updateId: newUpdateId
	            })));
	          });
	        } // add syncId
	
	
	        if ((0, _isNil2["default"])(this.props.syncId) && !(0, _isNil2["default"])(nextProps.syncId)) {
	          this.addListener();
	        } // remove syncId
	
	
	        if (!(0, _isNil2["default"])(this.props.syncId) && (0, _isNil2["default"])(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (!(0, _isNil2["default"])(this.props.syncId)) {
	          this.removeListener();
	        }
	
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: "getAxisMap",
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === void 0 ? 'xAxis' : _ref5$axisType,
	            AxisComp = _ref5.AxisComp,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	        var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis
	
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, {
	            axes: axes,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems,
	            axisType: axisType,
	            axisIdKey: axisIdKey,
	            stackGroups: stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: "getAxisMapByAxes",
	      value: function getAxisMapByAxes(props, _ref6) {
	        var _this3 = this;
	
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType); // Eliminate duplicated axes
	
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
	              scale = _child$props.scale,
	              ticks = _child$props.ticks;
	          var axisId = child.props[axisIdKey];
	
	          var displayedData = _this3.constructor.getDisplayedData(props, {
	            graphicalItems: graphicalItems.filter(function (item) {
	              return item.props[axisIdKey] === axisId;
	            }),
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	
	          var len = displayedData.length;
	
	          if (!result[axisId]) {
	            var domain, duplicateDomain, categoricalDomain;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	
	                if (allowDuplicatedCategory && duplicate) {
	                  duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale
	
	                  domain = (0, _range2["default"])(0, len);
	                } else if (!allowDuplicatedCategory) {
	                  // remove duplicated category
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                }
	              } else if (type === 'category') {
	                if (!allowDuplicatedCategory) {
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil2["default"])(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                } else {
	                  // eliminate undefined or null or empty string
	                  domain = domain.filter(function (entry) {
	                    return entry !== '' && !(0, _isNil2["default"])(entry);
	                  });
	                }
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: "getAxisMapByItems",
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1; // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain;
	
	            if (isCategorial) {
	              domain = (0, _range2["default"])(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _DetectReferenceElementsDomain.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	    }, {
	      key: "getActiveCoordinate",
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	        var entry = tooltipTicks.find(function (tick) {
	          return tick && tick.index === activeIndex;
	        });
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return {
	              x: entry.coordinate,
	              y: rangeObj.y
	            };
	          }
	
	          if (layout === 'vertical') {
	            return {
	              x: rangeObj.x,
	              y: entry.coordinate
	            };
	          }
	
	          if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	            return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle,
	              radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	          return _objectSpread({}, rangeObj, {}, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle,
	            radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: "getMouseInfo",
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _this$state9 = this.state,
	            xAxisMap = _this$state9.xAxisMap,
	            yAxisMap = _this$state9.yAxisMap;
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	          return _objectSpread({}, e, {
	            xValue: xValue,
	            yValue: yValue
	          });
	        }
	
	        var toolTipData = this.getTooltipData(rangeObj);
	
	        if (toolTipData) {
	          return _objectSpread({}, e, {}, toolTipData);
	        }
	
	        return null;
	      }
	      /**
	       * Returns tooltip data based on a mouse position (as a parameter or in state)
	       * @param  {Object} rangeObj  { x, y } coordinates
	       * @return {Object}           Tooltip data data
	       */
	
	    }, {
	      key: "getTooltipData",
	      value: function getTooltipData(rangeObj) {
	        var rangeData = rangeObj || {
	          x: this.state.chartX,
	          y: this.state.chartY
	        };
	        var pos = this.calculateTooltipPos(rangeData);
	        var _this$state10 = this.state,
	            ticks = _this$state10.orderedTooltipTicks,
	            axis = _this$state10.tooltipAxis,
	            tooltipTicks = _this$state10.tooltipTicks;
	
	        if (!ticks) {
	          return null;
	        }
	
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeData);
	          return {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          };
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @param  {String} activeLabel    Active label of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: "getTooltipContent",
	      value: function getTooltipContent(activeIndex, activeLabel) {
	        var _this$state11 = this.state,
	            graphicalItems = _this$state11.graphicalItems,
	            tooltipAxis = _this$state11.tooltipAxis;
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        } // get data by activeIndex when the axis don't allow duplicated category
	
	
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter,
	              data = _child$props2.data,
	              tooltipType = _child$props2.tooltipType;
	          var payload;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            // graphic child has data props
	            payload = (0, _DataUtils.findEntryInArray)(data || displayedData, tooltipAxis.dataKey, activeLabel);
	          } else {
	            payload = data && data[activeIndex] || displayedData[activeIndex];
	          }
	
	          if (!payload) {
	            return result;
	          }
	
	          return [].concat(_toConsumableArray(result), [_objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey,
	            unit: unit,
	            formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(payload, dataKey),
	            type: tooltipType,
	            payload: payload
	          })]);
	        }, []);
	      }
	    }, {
	      key: "getFormatItems",
	      value: function getFormatItems(props, currentState) {
	        var _this4 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _this$constructor$get = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get.numericAxisName,
	            cateAxisName = _this$constructor$get.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({
	          barSize: barSize,
	          stackGroups: stackGroups
	        });
	        var formatedItems = [];
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this4.constructor.getDisplayedData(props, {
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, item);
	
	          var _item$props2 = item.props,
	              dataKey = _item$props2.dataKey,
	              childMaxBarSize = _item$props2.maxBarSize;
	          var numericAxisId = item.props["".concat(numericAxisName, "Id")];
	          var cateAxisId = item.props["".concat(cateAxisName, "Id")];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _objectSpread4;
	
	            var axisMap = currentState["".concat(entry.axisType, "Map")];
	            var id = item.props["".concat(entry.axisType, "Id")];
	            var axis = axisMap && axisMap[id];
	            return _objectSpread({}, result, (_objectSpread4 = {}, _defineProperty(_objectSpread4, entry.axisType, axis), _defineProperty(_objectSpread4, "".concat(entry.axisType, "Ticks"), (0, _ChartUtils.getTicksOfAxis)(axis)), _objectSpread4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil2["default"])(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap,
	            barCategoryGap: barCategoryGap,
	            bandSize: bandSize,
	            sizeList: sizeList[cateAxisId],
	            maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _objectSpread5;
	
	            formatedItems.push({
	              props: _objectSpread({}, componsedFn(_objectSpread({}, axisObj, {
	                displayedData: displayedData,
	                props: props,
	                dataKey: dataKey,
	                item: item,
	                bandSize: bandSize,
	                barPosition: barPosition,
	                offset: offset,
	                stackedData: stackedData,
	                layout: layout,
	                dataStartIndex: dataStartIndex,
	                dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this4.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_objectSpread5 = {
	                key: item.key || "item-".concat(index)
	              }, _defineProperty(_objectSpread5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread5, "animationId", updateId), _objectSpread5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	        return formatedItems;
	      }
	    }, {
	      key: "getCursorRectangle",
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _this$state12 = this.state,
	            activeCoordinate = _this$state12.activeCoordinate,
	            offset = _this$state12.offset,
	            tooltipAxisBandSize = _this$state12.tooltipAxisBandSize;
	        var halfSize = tooltipAxisBandSize / 2;
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: "getCursorPoints",
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _this$state13 = this.state,
	            activeCoordinate = _this$state13.activeCoordinate,
	            offset = _this$state13.offset;
	        var x1, y1, x2, y2;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil2["default"])(activeCoordinate.cx) || !(0, _isNil2["default"])(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx,
	              cy: _cy,
	              radius: radius,
	              startAngle: startAngle,
	              endAngle: endAngle
	            };
	          }
	        }
	
	        return [{
	          x: x1,
	          y: y1
	        }, {
	          x: x2,
	          y: y2
	        }];
	      }
	    }, {
	      key: "calculateTooltipPos",
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: "inRange",
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	          return isInRange ? {
	            x: x,
	            y: y
	          } : null;
	        }
	
	        var _this$state14 = this.state,
	            angleAxisMap = _this$state14.angleAxisMap,
	            radiusAxisMap = _this$state14.radiusAxisMap;
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	          return (0, _PolarUtils.inRangeOfSector)({
	            x: x,
	            y: y
	          }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: "parseEventsOfWrapper",
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	        return _objectSpread({}, outerEvents, {}, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: "updateStateOfAxisMapsOffsetAndStackGroups",
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var _this5 = this;
	
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex,
	            updateId = _ref8.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({
	          props: props
	        })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data,
	            reverseStackOrder = props.reverseStackOrder;
	
	        var _this$constructor$get2 = this.constructor.getAxisNameByLayout(layout),
	            numericAxisName = _this$constructor$get2.numericAxisName,
	            cateAxisName = _this$constructor$get2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = "".concat(entry.axisType, "Map");
	          return _objectSpread({}, result, _defineProperty({}, name, _this5.getAxisMap(props, _objectSpread({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	        var offset = this.calculateOffset(_objectSpread({}, axisObj, {
	          props: props,
	          graphicalItems: graphicalItems
	        }));
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	        var formatedGraphicalItems = this.getFormatItems(props, _objectSpread({}, axisObj, {
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex,
	          updateId: updateId,
	          graphicalItems: graphicalItems,
	          stackGroups: stackGroups,
	          offset: offset
	        }));
	        return _objectSpread({
	          formatedGraphicalItems: formatedGraphicalItems,
	          graphicalItems: graphicalItems,
	          offset: offset,
	          stackGroups: stackGroups
	        }, ticksObj, {}, axisObj);
	      }
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: "addListener",
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: "removeListener",
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: "calculateOffset",
	      value: function calculateOffset(_ref9) {
	        var props = _ref9.props,
	            graphicalItems = _ref9.graphicalItems,
	            _ref9$xAxisMap = _ref9.xAxisMap,
	            xAxisMap = _ref9$xAxisMap === void 0 ? {} : _ref9$xAxisMap,
	            _ref9$yAxisMap = _ref9.yAxisMap,
	            yAxisMap = _ref9$yAxisMap === void 0 ? {} : _ref9$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend["default"]);
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, {
	          left: margin.left || 0,
	          right: margin.right || 0
	        });
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, {
	          top: margin.top || 0,
	          bottom: margin.bottom || 0
	        });
	
	        var offset = _objectSpread({}, offsetV, {}, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush["default"].defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _objectSpread({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	    }, {
	      key: "triggerSyncEvent",
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	        if (!(0, _isNil2["default"])(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: "filterFormatItem",
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: "renderAxis",
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height;
	        return _react["default"].createElement(_CartesianAxis["default"], _extends({}, axisOptions, {
	          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
	          key: element.key || "".concat(displayName, "-").concat(index),
	          viewBox: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: "renderLegend",
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this6 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _this$props6 = this.props,
	            children = _this$props6.children,
	            width = _this$props6.width,
	            height = _this$props6.height;
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children,
	          formatedGraphicalItems: formatedGraphicalItems,
	          legendWidth: legendWidth,
	          legendHeight: legendHeight,
	          legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        var item = props.item,
	            otherProps = _objectWithoutProperties(props, ["item"]);
	
	        return (0, _react.cloneElement)(item, _objectSpread({}, otherProps, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this6.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: "renderTooltip",
	      value: function renderTooltip() {
	        var children = this.props.children;
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _this$state15 = this.state,
	            isTooltipActive = _this$state15.isTooltipActive,
	            activeCoordinate = _this$state15.activeCoordinate,
	            activePayload = _this$state15.activePayload,
	            activeLabel = _this$state15.activeLabel,
	            offset = _this$state15.offset;
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _objectSpread({}, offset, {
	            x: offset.left,
	            y: offset.top
	          }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: "renderActivePoints",
	      value: function renderActivePoints(_ref10) {
	        var item = _ref10.item,
	            activePoint = _ref10.activePoint,
	            basePoint = _ref10.basePoint,
	            childIndex = _ref10.childIndex,
	            isRange = _ref10.isRange;
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props2 = item.item.props,
	            activeDot = _item$item$props2.activeDot,
	            dataKey = _item$item$props2.dataKey;
	
	        var dotProps = _objectSpread({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: "".concat(key, "-activePoint-").concat(childIndex)
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot), {}, (0, _ReactUtils.filterEventAttributes)(activeDot));
	
	        result.push(this.constructor.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.constructor.renderActiveDot(activeDot, _objectSpread({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: "".concat(key, "-basePoint-").concat(childIndex)
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: "renderClipPath",
	      value: function renderClipPath() {
	        var clipPathId = this.clipPathId;
	        var _this$state$offset = this.state.offset,
	            left = _this$state$offset.left,
	            top = _this$state$offset.top,
	            height = _this$state$offset.height,
	            width = _this$state$offset.width;
	        return _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: clipPathId
	        }, _react["default"].createElement("rect", {
	          x: left,
	          y: top,
	          height: height,
	          width: width
	        })));
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this7 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _this$props7 = this.props,
	            children = _this$props7.children,
	            className = _this$props7.className,
	            width = _this$props7.width,
	            height = _this$props7.height,
	            style = _this$props7.style,
	            compact = _this$props7.compact,
	            others = _objectWithoutProperties(_this$props7, ["children", "className", "width", "height", "style", "compact"]);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: {
	            handler: this.renderGrid,
	            once: true
	          },
	          ReferenceArea: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceLine: {
	            handler: this.renderReferenceElement
	          },
	          ReferenceDot: {
	            handler: this.renderReferenceElement
	          },
	          XAxis: {
	            handler: this.renderXAxis
	          },
	          YAxis: {
	            handler: this.renderYAxis
	          },
	          Brush: {
	            handler: this.renderBrush,
	            once: true
	          },
	          Bar: {
	            handler: this.renderGraphicChild
	          },
	          Line: {
	            handler: this.renderGraphicChild
	          },
	          Area: {
	            handler: this.renderGraphicChild
	          },
	          Radar: {
	            handler: this.renderGraphicChild
	          },
	          RadialBar: {
	            handler: this.renderGraphicChild
	          },
	          Scatter: {
	            handler: this.renderGraphicChild
	          },
	          Pie: {
	            handler: this.renderGraphicChild
	          },
	          Funnel: {
	            handler: this.renderGraphicChild
	          },
	          Tooltip: {
	            handler: this.renderCursor,
	            once: true
	          },
	          PolarGrid: {
	            handler: this.renderPolarGrid,
	            once: true
	          },
	          PolarAngleAxis: {
	            handler: this.renderPolarAxis
	          },
	          PolarRadiusAxis: {
	            handler: this.renderPolarAxis
	          },
	          Customized: {
	            handler: this.renderCustomized
	          }
	        }; // The "compact" mode is mainly used as the panorama within Brush
	
	        if (compact) {
	          return _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	            width: width,
	            height: height
	          }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map));
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react["default"].createElement("div", _extends({
	          className: (0, _classnames["default"])('recharts-wrapper', className),
	          style: _objectSpread({
	            position: 'relative',
	            cursor: 'default',
	            width: width,
	            height: height
	          }, style)
	        }, events, {
	          ref: function ref(node) {
	            _this7.container = node;
	          }
	        }), _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	          width: width,
	          height: height
	        }), this.renderClipPath(), (0, _ReactUtils.renderByOrder)(children, map)), this.renderLegend(), this.renderTooltip());
	      }
	    }], [{
	      key: "getAxisNameByLayout",
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return {
	            numericAxisName: 'yAxis',
	            cateAxisName: 'xAxis'
	          };
	        }
	
	        if (layout === 'vertical') {
	          return {
	            numericAxisName: 'xAxis',
	            cateAxisName: 'yAxis'
	          };
	        }
	
	        if (layout === 'centric') {
	          return {
	            numericAxisName: 'radiusAxis',
	            cateAxisName: 'angleAxis'
	          };
	        }
	
	        return {
	          numericAxisName: 'angleAxis',
	          cateAxisName: 'radiusAxis'
	        };
	      }
	    }, {
	      key: "renderActiveDot",
	      value: function renderActiveDot(option, props) {
	        var dot;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction2["default"])(option)) {
	          dot = option(props);
	        } else {
	          dot = _react["default"].createElement(_Dot["default"], props);
	        }
	
	        return _react["default"].createElement(_Layer["default"], {
	          className: "recharts-active-dot",
	          key: props.key
	        }, dot);
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component);
	
	  CategoricalChartWrapper.displayName = chartName;
	  CategoricalChartWrapper.propTypes = _objectSpread({
	    syncId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	    compact: _propTypes["default"].bool,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	    layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes["default"].oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes["default"].number,
	    margin: _propTypes["default"].shape({
	      top: _propTypes["default"].number,
	      right: _propTypes["default"].number,
	      bottom: _propTypes["default"].number,
	      left: _propTypes["default"].number
	    }),
	    barCategoryGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barGap: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    barSize: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    maxBarSize: _propTypes["default"].number,
	    style: _propTypes["default"].object,
	    className: _propTypes["default"].string,
	    children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	    defaultShowTooltip: _propTypes["default"].bool,
	    onClick: _propTypes["default"].func,
	    onMouseLeave: _propTypes["default"].func,
	    onMouseEnter: _propTypes["default"].func,
	    onMouseMove: _propTypes["default"].func,
	    onMouseDown: _propTypes["default"].func,
	    onMouseUp: _propTypes["default"].func,
	    reverseStackOrder: _propTypes["default"].bool,
	    id: _propTypes["default"].string
	  }, propTypes);
	  CategoricalChartWrapper.defaultProps = _objectSpread({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: {
	      top: 5,
	      right: 5,
	      bottom: 5,
	      left: 5
	    },
	    reverseStackOrder: false
	  }, defaultProps);
	
	  CategoricalChartWrapper.createDefaultState = function (props) {
	    var children = props.children,
	        defaultShowTooltip = props.defaultShowTooltip;
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush["default"]);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: !(0, _isNil2["default"])(defaultShowTooltip) ? defaultShowTooltip : false
	    };
	  };
	
	  CategoricalChartWrapper.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	      return name && name.indexOf('Bar') >= 0;
	    });
	  };
	
	  CategoricalChartWrapper.getDisplayedData = function (props, _ref11, item) {
	    var graphicalItems = _ref11.graphicalItems,
	        dataStartIndex = _ref11.dataStartIndex,
	        dataEndIndex = _ref11.dataEndIndex;
	    var itemsData = (graphicalItems || []).reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	
	    if (itemsData && itemsData.length > 0) {
	      return itemsData;
	    }
	
	    if (item && item.props && item.props.data && item.props.data.length > 0) {
	      return item.props.data;
	    }
	
	    var data = props.data;
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    return [];
	  };
	
	  return CategoricalChartWrapper;
	};
	
	var _default = generateCategoricalChart;
	exports["default"] = _default;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(83));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _last2 = _interopRequireDefault(__webpack_require__(741));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _Label = _interopRequireDefault(__webpack_require__(134));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  id: _propTypes["default"].string,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  valueAccessor: _propTypes["default"].func,
	  clockWise: _propTypes["default"].bool,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func])
	};
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray2["default"])(entry.value) ? (0, _last2["default"])(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      id = props.id,
	      others = _objectWithoutProperties(props, ["data", "valueAccessor", "dataKey", "clockWise", "id"]);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-label-list"
	  }, data.map(function (entry, index) {
	    var value = (0, _isNil2["default"])(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	    var idProps = (0, _isNil2["default"])(id) ? {} : {
	      id: "".concat(id, "-").concat(index)
	    };
	    return _react["default"].createElement(_Label["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, idProps, {
	      index: index,
	      value: value,
	      viewBox: _Label["default"].parseViewBox((0, _isNil2["default"])(clockWise) ? entry : _objectSpread({}, entry, {
	        clockWise: clockWise
	      })),
	      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
	
	    }));
	  }));
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data
	    });
	  }
	
	  if (_react["default"].isValidElement(label) || (0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(LabelList, {
	      key: "labelList-implicit",
	      data: data,
	      content: label
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(LabelList, _extends({
	      data: data
	    }, label, {
	      key: "labelList-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: "labelList-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	var _default = LabelList;
	exports["default"] = _default;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ContextProvider = exports.Context = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('corporates.market-news', {
	    tab: 'CUSTOM',
	
	    customSearchType: 'company',
	    customKeyword: '',
	    customSearch: '',
	    customIndustry: [],
	    customDate: 'today',
	
	    holdingCompany: [],
	    holdingDate: 'today'
	});
	
	var useContext = function useContext() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$modal = _ref.modal,
	        modal = _ref$modal === undefined ? false : _ref$modal;
	
	    var _React$useState = _react2.default.useState(modal),
	        _React$useState2 = _slicedToArray(_React$useState, 1),
	        isModal = _React$useState2[0];
	
	    var _React$useState3 = _react2.default.useState(state.value.tab || 'CUSTOM'),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        tab = _React$useState4[0],
	        setTab_ = _React$useState4[1];
	
	    var setTab = _react2.default.useCallback(function (a) {
	        state.set({ tab: a });setTab_(a);
	    }, []);
	
	    // custom-tab
	
	    var _React$useState5 = _react2.default.useState(state.value.customSearchType || 'company'),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        customSearchType = _React$useState6[0],
	        setCustomSearchType_ = _React$useState6[1];
	
	    var setCustomSearchType = _react2.default.useCallback(function (a) {
	        state.set({ customSearchType: a });setCustomSearchType_(a);
	    }, []);
	
	    var _React$useState7 = _react2.default.useState(state.value.customSearch || ''),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        customKeyword = _React$useState8[0],
	        setCustomKeyword_ = _React$useState8[1];
	
	    var setCustomKeyword = _react2.default.useCallback(function (a) {
	        state.set({ customKeyword: a });setCustomKeyword_(a);
	    }, []);
	
	    var _React$useState9 = _react2.default.useState(state.value.customSearch || ''),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        customSearch = _React$useState10[0],
	        setCustomSearch_ = _React$useState10[1];
	
	    var setCustomSearch = _react2.default.useCallback(function (a) {
	        state.set({ customSearch: a });setCustomSearch_(a);
	    }, []);
	
	    var _React$useState11 = _react2.default.useState(state.value.customIndustry || []),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        customIndustry = _React$useState12[0],
	        setCustomIndustry_ = _React$useState12[1];
	
	    var setCustomIndustry = _react2.default.useCallback(function (a) {
	        state.set({ customIndustry: a });setCustomIndustry_(a);
	    }, []);
	
	    var _React$useState13 = _react2.default.useState(state.value.customDate || 'today'),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        customDate = _React$useState14[0],
	        setCustomDate_ = _React$useState14[1];
	
	    var setCustomDate = _react2.default.useCallback(function (a) {
	        state.set({ customDate: a });setCustomDate_(a);
	    }, []);
	
	    // holding-tab
	
	    var _React$useState15 = _react2.default.useState(state.value.holdingCompany || []),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        holdingCompany = _React$useState16[0],
	        setHoldingCompany_ = _React$useState16[1];
	
	    var setHoldingCompany = _react2.default.useCallback(function (a) {
	        state.set({ holdingCompany: a });setHoldingCompany_(a);
	    }, []);
	
	    var _React$useState17 = _react2.default.useState(state.value.holdingDate || 'today'),
	        _React$useState18 = _slicedToArray(_React$useState17, 2),
	        holdingDate = _React$useState18[0],
	        setHoldingDate_ = _React$useState18[1];
	
	    var setHoldingDate = _react2.default.useCallback(function (a) {
	        state.set({ holdingDate: a });setHoldingDate_(a);
	    }, []);
	
	    return {
	        isModal: isModal,
	        tab: tab, setTab: setTab,
	
	        customSearchType: customSearchType, setCustomSearchType: setCustomSearchType,
	        customKeyword: customKeyword, setCustomKeyword: setCustomKeyword,
	        customSearch: customSearch, setCustomSearch: setCustomSearch,
	        customIndustry: customIndustry, setCustomIndustry: setCustomIndustry,
	        customDate: customDate, setCustomDate: setCustomDate,
	
	        holdingCompany: holdingCompany, setHoldingCompany: setHoldingCompany,
	        holdingDate: holdingDate, setHoldingDate: setHoldingDate
	    };
	};
	
	var Context = exports.Context = _react2.default.createContext();
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref2) {
	    var modal = _ref2.modal,
	        children = _ref2.children;
	
	    var ctx = useContext({ modal: modal });
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: ctx },
	        children
	    );
	};
	
	exports.default = function () {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sectionCss = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n'], ['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	
	
	var sectionCss = exports.sectionCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.displayInline = exports.backgroundColor = exports.textAlignRight = exports.sectionCss = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n    ', ' {\n        padding: 0px;\n    }\n'], ['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n    ', ' {\n        padding: 0px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    ', ' { text-align: right }\n'], ['\n    ', ' { text-align: right }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ' { background-color: #f6f6f6; }\n'], ['\n    ', ' { background-color: #f6f6f6; }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    ', ' { display: inline; }\n'], ['\n    ', ' { display: inline; }\n']);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	
	
	var sectionCss = exports.sectionCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs, _twd.mediaQueries.xs);
	
	var textAlignRight = exports.textAlignRight = (0, _core.css)(_templateObject2, _twd.mediaQueries.notXs);
	
	var backgroundColor = exports.backgroundColor = (0, _core.css)(_templateObject3, _twd.mediaQueries.notXs);
	
	var displayInline = exports.displayInline = (0, _core.css)(_templateObject4, _twd.mediaQueries.notXs);

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.parseDetail = exports.PAGESIZE = exports.allAccounts = exports.getAccounts = exports.useOrders = exports.ContextProvider = exports.TODAY = exports.Context = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _fixParams = __webpack_require__(1080);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Context = exports.Context = _react2.default.createContext();
	
	var TODAY = exports.TODAY = function TODAY() {
	    return _twd.fmt.mdy(new Date());
	};
	
	var Last = (0, _twd.getState)('orders.last', {
	    ts: 0,
	    showFilters: true,
	    filters: {
	        tradeSubmitDateRangeMin: TODAY(),
	        tradeSubmitDateRangeMax: TODAY()
	    }
	});
	
	var ContextProvider = exports.ContextProvider = function ContextProvider() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$_ts = _ref._ts,
	        _ts = _ref$_ts === undefined ? 0 : _ref$_ts,
	        backFrom = _ref.backFrom,
	        children = _ref.children;
	
	    var _React$useState = _react2.default.useState(Last.value.ts || Date.now()),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        ts = _React$useState2[0],
	        setTs_ = _React$useState2[1];
	
	    var setTs = _react2.default.useCallback(function (a) {
	        Last.set({ ts: a });
	        setTs_(a);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.accounts || []),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        accounts = _React$useState4[0],
	        setAccounts_ = _React$useState4[1];
	
	    var setAccounts = _react2.default.useCallback(function (accounts, isReset) {
	        Last.set({ accounts: accounts });
	        setAccounts_(accounts);
	
	        if (isReset) return;
	        setMode('search');
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(null),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        accountsRef = _React$useState6[0],
	        setAccountsRef = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(Last.value.filters || {}),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        filters = _React$useState8[0],
	        setFilters_ = _React$useState8[1];
	
	    var setFilters = _react2.default.useCallback(function (filters, isReset) {
	        Last.set({ filters: filters });
	        setFilters_(filters);
	
	        if (isReset) return;
	        setMode('search');
	    }, []);
	
	    var _React$useState9 = _react2.default.useState(Last.value.showFilters),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        showFilters = _React$useState10[0],
	        setShowFilters_ = _React$useState10[1];
	
	    var setShowFilters = _react2.default.useCallback(function (showFilters) {
	        Last.set({ showFilters: showFilters });
	        setShowFilters_(showFilters);
	    }, []);
	
	    var _React$useState11 = _react2.default.useState(Last.value.rows || []),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        rows = _React$useState12[0],
	        setRows_ = _React$useState12[1];
	
	    var setRows = _react2.default.useCallback(function (rows) {
	        Last.set({ rows: rows });
	        setRows_(rows);
	    }, []);
	
	    var _React$useState13 = _react2.default.useState(Last.value.shown || {}),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        shown = _React$useState14[0],
	        setShown_ = _React$useState14[1];
	
	    var setShown = _react2.default.useCallback(function (shown) {
	        Last.set({ shown: shown });
	        setShown_(shown);
	    }, []);
	
	    var _React$useState15 = _react2.default.useState(Last.value.count || 0),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        count = _React$useState16[0],
	        setCount_ = _React$useState16[1];
	
	    var setCount = _react2.default.useCallback(function (count) {
	        Last.set({ count: count });
	        setCount_(count);
	    }, []);
	
	    var _React$useState17 = _react2.default.useState(Last.value.page || 1),
	        _React$useState18 = _slicedToArray(_React$useState17, 2),
	        page = _React$useState18[0],
	        setPage_ = _React$useState18[1];
	
	    var setPage = _react2.default.useCallback(function (page) {
	        Last.set({ page: page });
	        setPage_(page);
	    }, []);
	
	    var _React$useState19 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState20 = _slicedToArray(_React$useState19, 2),
	        status = _React$useState20[0],
	        setStatus = _React$useState20[1];
	
	    var _React$useState21 = _react2.default.useState(null),
	        _React$useState22 = _slicedToArray(_React$useState21, 2),
	        mode = _React$useState22[0],
	        setMode = _React$useState22[1];
	
	    _react2.default.useEffect(function () {
	        var m = !backFrom && _ts > Last.value.ts ? 'reset' : backFrom && _ts <= Last.value.ts ? 'redraw' : backFrom && _ts > Last.value.ts ? 'reload' : 'search';
	        setMode(m);
	    }, []);
	
	    var onLoadMore = function onLoadMore() {
	        setPage(page + 1);
	        setMode('load-more');
	    };
	
	    _react2.default.useEffect(function () {
	        switch (mode) {
	            case "search":
	                setShown({});
	                setRows([]);
	                setCount(0);
	                setPage(1);
	                doSearch();
	                break;
	            case "load-more":
	                doSearch();
	                break;
	            case "reset":
	                setShown({});
	                setRows([]);
	                setCount(0);
	                setPage(1);
	                setFilters({
	                    tradeSubmitDateRangeMin: TODAY(),
	                    tradeSubmitDateRangeMax: TODAY()
	                }, true);
	                setAccounts([], true);
	                doSearch();
	                break;
	            case "reload":
	                setRows([]);
	                setCount(0);
	                doSearch();
	                break;
	            case "redraw":
	                setStatus(_twd.Status.LOADED);
	                break;
	            default:
	                break;
	
	        }
	    }, [mode]);
	
	    var doSearch = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var isReload, p, _ref3, data, a, isLoadMore;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.prev = 1;
	                            isReload = mode === 'reload';
	                            p = (0, _fixParams.fixParams)(accounts, filters, isReload ? 1 : page, isReload ? page * PAGESIZE : PAGESIZE);
	                            _context.next = 6;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/trades',
	                                method: 'POST',
	                                params: p
	                            });
	
	                        case 6:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            _context.next = 10;
	                            return data;
	
	                        case 10:
	                            a = _context.sent;
	
	                            if ((0, _twd.arrayFrom)(a.rows).length === 0) {
	                                a.resultSetCount = 0;
	                            }
	
	                            isLoadMore = mode === 'load-more';
	
	                            a.rows = (0, _twd.arrayFrom)(a.rows).map(function (r, i) {
	                                return processTradeRecord(r, i);
	                            });
	                            a.rows = (isLoadMore ? Last.value.rows || [] : []).concat(a.rows);
	
	                            setRows(a.rows);
	                            if (p.pageNumber === 1) {
	                                setCount(a.resultSetCount);
	                            }
	                            setStatus(_twd.Status.LOADED);
	                            setMode(null);
	                            _context.next = 25;
	                            break;
	
	                        case 21:
	                            _context.prev = 21;
	                            _context.t0 = _context['catch'](1);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	                            setMode('error');
	
	                        case 25:
	
	                            setTs(Date.now());
	
	                        case 26:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[1, 21]]);
	        }));
	
	        return function doSearch() {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: {
	                Last: Last,
	                ts: ts, setTs: setTs,
	                accounts: accounts, setAccounts: setAccounts,
	                accountsRef: accountsRef, setAccountsRef: setAccountsRef,
	                filters: filters, setFilters: setFilters,
	                showFilters: showFilters, setShowFilters: setShowFilters,
	
	                status: status, setStatus: setStatus,
	                rows: rows, setRows: setRows,
	                shown: shown, setShown: setShown,
	                count: count, setCount: setCount,
	                page: page, setPage: setPage,
	                onLoadMore: onLoadMore
	            } },
	        children
	    );
	};
	
	var ACTIONS = ['action', 'buy', 'limitbuy', 'sell', 'limitsell'];
	
	var processTradeRecord = function processTradeRecord(rec) {
	
	    rec.tradeExecStatus = (0, _twd.arrayFrom)(rec.execList).map(function (a, i) {
	        return Object.assign({}, a, { index: i, actionIndex: Math.max(ACTIONS.indexOf(a.action), 0) });
	    }).sort(function (a, b) {
	        var d = b.actionIndex - a.actionIndex;
	        return d === 0 ? a.index - b.index : d;
	    });
	
	    return rec;
	};
	
	var useOrders = exports.useOrders = function useOrders() {
	    return _react2.default.useContext(Context);
	};
	
	var getAccounts = exports.getAccounts = function getAccounts() {
	    return (0, _twd.arrayFrom)(global.app.config.accounts).filter(Boolean);
	};
	
	var allAccounts = exports.allAccounts = function allAccounts() {
	    return getAccounts().map(function (a) {
	        return a.acctNo;
	    }).sort();
	};
	
	var PAGESIZE = exports.PAGESIZE = 50;
	
	var parseDetail = exports.parseDetail = function parseDetail(txt) {
	    var d = (0, _twd.evalJson)(txt, { orderDetails: [] }).orderDetails[0];
	    if (!d) return;
	
	    (0, _twd.arrayFrom)(d.AccountList).concat((0, _twd.arrayFrom)(d.OrderList)).concat((0, _twd.arrayFrom)(d.PriceList)).forEach(function (_ref4) {
	        var label = _ref4.label,
	            value = _ref4.value,
	            order = _ref4.order;
	
	        var v = value || order;
	        var n = (0, _twd.toCamel)(String(label).trim());
	        if (n in d) return;
	        d[n] = v;
	    });
	
	    return d;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var definePropertyModule = __webpack_require__(41);
	var createPropertyDescriptor = __webpack_require__(85);
	
	module.exports = function (object, key, value) {
	  if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
	  else object[key] = value;
	};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var classof = __webpack_require__(61);
	
	module.exports = classof(global.process) === 'process';


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(61);
	
	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	module.exports = Array.isArray || function isArray(argument) {
	  return classof(argument) === 'Array';
	};


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var isCallable = __webpack_require__(22);
	var isPrototypeOf = __webpack_require__(77);
	var USE_SYMBOL_AS_UID = __webpack_require__(562);
	
	var $Object = Object;
	
	module.exports = USE_SYMBOL_AS_UID ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
	};


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	
	module.exports = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
	  var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
	  var next = record.next;
	  var step, result;
	  while (!(step = call(next, iterator)).done) {
	    result = fn(step.value);
	    if (result !== undefined) return result;
	  }
	};


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(36);
	
	var $TypeError = TypeError;
	
	var PromiseCapability = function (C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aCallable(resolve);
	  this.reject = aCallable(reject);
	};
	
	// `NewPromiseCapability` abstract operation
	// https://tc39.es/ecma262/#sec-newpromisecapability
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toPrimitive = __webpack_require__(266);
	var isSymbol = __webpack_require__(123);
	
	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	module.exports = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarDays;
	var _index = _interopRequireDefault(__webpack_require__(109));
	var _index2 = _interopRequireDefault(__webpack_require__(278));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_DAY = 86400000;
	
	/**
	 * @name differenceInCalendarDays
	 * @category Day Helpers
	 * @summary Get the number of calendar days between the given dates.
	 *
	 * @description
	 * Get the number of calendar days between the given dates. This means that the times are removed
	 * from the dates and then the difference in days is calculated.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 366
	 * // How many calendar days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInCalendarDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 1
	 */
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfDayLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfDayRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfDayLeft.getTime() - (0, _index.default)(startOfDayLeft);
	  var timestampRight = startOfDayRight.getTime() - (0, _index.default)(startOfDayRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a day is not constant
	  // (e.g. it's different in the day of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	module.exports = exports.default;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	var _index = _interopRequireDefault(__webpack_require__(650));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	module.exports = exports.default;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextDay;
	var _index = _interopRequireDefault(__webpack_require__(110));
	var _index2 = _interopRequireDefault(__webpack_require__(276));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextDay
	 * @category Weekday Helpers
	 * @summary When is the next day of the week?
	 *
	 * @description
	 * When is the next day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {Day} day - day of the week
	 * @returns {Date} - the date is the next day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the next Monday after Mar, 20, 2020?
	 * const result = nextDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 23 2020 00:00:00
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 21, 2020?
	 * const result = nextDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextDay(date, day) {
	  (0, _index3.default)(2, arguments);
	  var delta = day - (0, _index2.default)(date);
	  if (delta <= 0) delta += 7;
	  return (0, _index.default)(date, delta);
	}
	module.exports = exports.default;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousDay;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(276));
	var _index3 = _interopRequireDefault(__webpack_require__(280));
	/**
	 * @name previousDay
	 * @category Weekday Helpers
	 * @summary When is the previous day of the week?
	 *
	 * @description
	 * When is the previous day of the week? 0-6 the day of the week, 0 represents Sunday.
	 *
	 * @param {Date | number} date - the date to check
	 * @param {number} day - day of the week
	 * @returns {Date} - the date is the previous day of week
	 * @throws {TypeError} - 2 arguments required
	 *
	 * @example
	 * // When is the previous Monday before Mar, 20, 2020?
	 * const result = previousDay(new Date(2020, 2, 20), 1)
	 * //=> Mon Mar 16 2020 00:00:00
	 *
	 * @example
	 * // When is the previous Tuesday before Mar, 21, 2020?
	 * const result = previousDay(new Date(2020, 2, 21), 2)
	 * //=> Tue Mar 17 2020 00:00:00
	 */
	function previousDay(date, day) {
	  (0, _index.default)(2, arguments);
	  var delta = (0, _index2.default)(date) - day;
	  if (delta <= 0) delta += 7;
	  return (0, _index3.default)(date, delta);
	}
	module.exports = exports.default;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeek;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(12));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var _index4 = __webpack_require__(51);
	/**
	 * @name startOfWeek
	 * @category Week Helpers
	 * @summary Return the start of a week for the given date.
	 *
	 * @description
	 * Return the start of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the start of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The start of a week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
	 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index3.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setDate(date.getDate() - diff);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// Only count HTML whitespace
		// Other whitespace should count in values
		// https://infra.spec.whatwg.org/#ascii-whitespace
		return ( /[^\x20\t\r\n\f]+/g );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(183),
	    getRawTag = __webpack_require__(1898),
	    objectToString = __webpack_require__(1926);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isObject2 = _interopRequireDefault(__webpack_require__(83));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Text = _interopRequireDefault(__webpack_require__(159));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	var _PolarUtils = __webpack_require__(97);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var cartesianViewBoxShape = _propTypes["default"].shape({
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number
	});
	
	var polarViewBoxShape = _propTypes["default"].shape({
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number
	});
	
	var propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes["default"].func,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  offset: _propTypes["default"].number,
	  position: _propTypes["default"].oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  className: _propTypes["default"].string,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func])
	});
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	  var label = (0, _isNil2["default"])(props.children) ? value : props.children;
	
	  if ((0, _isFunction2["default"])(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset,
	      className = labelProps.className;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle, direction;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
	  var id = (0, _isNil2["default"])(labelProps.id) ? (0, _DataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
	  return _react["default"].createElement("text", _extends({}, attrs, {
	    dominantBaseline: "central",
	    className: (0, _classnames["default"])('recharts-radial-bar-label', className)
	  }), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
	    id: id,
	    d: path
	  })), _react["default"].createElement("textPath", {
	    xlinkHref: "#".concat(id)
	  }, label));
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'centerTop') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'centerBottom') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: sign > 0 ? 'end' : 'start'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject2["default"])(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content,
	      _props$className = props.className,
	      className = _props$className === void 0 ? '' : _props$className;
	
	  if (!viewBox || (0, _isNil2["default"])(value) && (0, _isNil2["default"])(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction2["default"])(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	
	  var label;
	
	  if ((0, _isFunction2["default"])(content)) {
	    label = content(props);
	
	    if ((0, _react.isValidElement)(label)) {
	      return label;
	    }
	  } else {
	    label = getLabel(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	  var events = (0, _ReactUtils.filterEventAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	  return _react["default"].createElement(_Text["default"], _extends({
	    className: (0, _classnames["default"])('recharts-label', className)
	  }, attrs, positionAttrs, events), label);
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    }
	
	    if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return {
	        x: top,
	        y: left,
	        width: width,
	        height: height
	      };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return {
	      x: x,
	      y: y,
	      width: 0,
	      height: 0
	    };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx,
	      cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      viewBox: viewBox,
	      value: label
	    });
	  }
	
	  if ((0, _react.isValidElement)(label)) {
	    if (label.type === Label) {
	      return (0, _react.cloneElement)(label, {
	        key: 'label-implicit',
	        viewBox: viewBox
	      });
	    }
	
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isFunction2["default"])(label)) {
	    return _react["default"].createElement(Label, {
	      key: "label-implicit",
	      content: label,
	      viewBox: viewBox
	    });
	  }
	
	  if ((0, _isObject2["default"])(label)) {
	    return _react["default"].createElement(Label, _extends({
	      viewBox: viewBox
	    }, label, {
	      key: "label-implicit"
	    }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	
	  var children = parentProps.children;
	  var parentViewBox = parseViewBox(parentProps);
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: "label-".concat(index)
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	var _default = Label;
	exports["default"] = _default;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Surface", {
	  enumerable: true,
	  get: function get() {
	    return _Surface2["default"];
	  }
	});
	Object.defineProperty(exports, "Layer", {
	  enumerable: true,
	  get: function get() {
	    return _Layer2["default"];
	  }
	});
	Object.defineProperty(exports, "Legend", {
	  enumerable: true,
	  get: function get() {
	    return _Legend2["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip2["default"];
	  }
	});
	Object.defineProperty(exports, "ResponsiveContainer", {
	  enumerable: true,
	  get: function get() {
	    return _ResponsiveContainer2["default"];
	  }
	});
	Object.defineProperty(exports, "Cell", {
	  enumerable: true,
	  get: function get() {
	    return _Cell2["default"];
	  }
	});
	Object.defineProperty(exports, "Text", {
	  enumerable: true,
	  get: function get() {
	    return _Text2["default"];
	  }
	});
	Object.defineProperty(exports, "Label", {
	  enumerable: true,
	  get: function get() {
	    return _Label2["default"];
	  }
	});
	Object.defineProperty(exports, "LabelList", {
	  enumerable: true,
	  get: function get() {
	    return _LabelList2["default"];
	  }
	});
	Object.defineProperty(exports, "Customized", {
	  enumerable: true,
	  get: function get() {
	    return _Customized2["default"];
	  }
	});
	Object.defineProperty(exports, "Sector", {
	  enumerable: true,
	  get: function get() {
	    return _Sector2["default"];
	  }
	});
	Object.defineProperty(exports, "Curve", {
	  enumerable: true,
	  get: function get() {
	    return _Curve2["default"];
	  }
	});
	Object.defineProperty(exports, "Rectangle", {
	  enumerable: true,
	  get: function get() {
	    return _Rectangle2["default"];
	  }
	});
	Object.defineProperty(exports, "Polygon", {
	  enumerable: true,
	  get: function get() {
	    return _Polygon2["default"];
	  }
	});
	Object.defineProperty(exports, "Dot", {
	  enumerable: true,
	  get: function get() {
	    return _Dot2["default"];
	  }
	});
	Object.defineProperty(exports, "Cross", {
	  enumerable: true,
	  get: function get() {
	    return _Cross2["default"];
	  }
	});
	Object.defineProperty(exports, "Symbols", {
	  enumerable: true,
	  get: function get() {
	    return _Symbols2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarGrid", {
	  enumerable: true,
	  get: function get() {
	    return _PolarGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarRadiusAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarRadiusAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "PolarAngleAxis", {
	  enumerable: true,
	  get: function get() {
	    return _PolarAngleAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "Pie", {
	  enumerable: true,
	  get: function get() {
	    return _Pie2["default"];
	  }
	});
	Object.defineProperty(exports, "Radar", {
	  enumerable: true,
	  get: function get() {
	    return _Radar2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBar", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBar2["default"];
	  }
	});
	Object.defineProperty(exports, "Brush", {
	  enumerable: true,
	  get: function get() {
	    return _Brush2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceLine", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceLine2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceDot", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceDot2["default"];
	  }
	});
	Object.defineProperty(exports, "ReferenceArea", {
	  enumerable: true,
	  get: function get() {
	    return _ReferenceArea2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianAxis", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "CartesianGrid", {
	  enumerable: true,
	  get: function get() {
	    return _CartesianGrid2["default"];
	  }
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _Line2["default"];
	  }
	});
	Object.defineProperty(exports, "Area", {
	  enumerable: true,
	  get: function get() {
	    return _Area2["default"];
	  }
	});
	Object.defineProperty(exports, "Bar", {
	  enumerable: true,
	  get: function get() {
	    return _Bar2["default"];
	  }
	});
	Object.defineProperty(exports, "Scatter", {
	  enumerable: true,
	  get: function get() {
	    return _Scatter2["default"];
	  }
	});
	Object.defineProperty(exports, "XAxis", {
	  enumerable: true,
	  get: function get() {
	    return _XAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "YAxis", {
	  enumerable: true,
	  get: function get() {
	    return _YAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ZAxis", {
	  enumerable: true,
	  get: function get() {
	    return _ZAxis2["default"];
	  }
	});
	Object.defineProperty(exports, "ErrorBar", {
	  enumerable: true,
	  get: function get() {
	    return _ErrorBar2["default"];
	  }
	});
	Object.defineProperty(exports, "LineChart", {
	  enumerable: true,
	  get: function get() {
	    return _LineChart2["default"];
	  }
	});
	Object.defineProperty(exports, "BarChart", {
	  enumerable: true,
	  get: function get() {
	    return _BarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "PieChart", {
	  enumerable: true,
	  get: function get() {
	    return _PieChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Treemap", {
	  enumerable: true,
	  get: function get() {
	    return _Treemap2["default"];
	  }
	});
	Object.defineProperty(exports, "Sankey", {
	  enumerable: true,
	  get: function get() {
	    return _Sankey2["default"];
	  }
	});
	Object.defineProperty(exports, "RadarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ScatterChart", {
	  enumerable: true,
	  get: function get() {
	    return _ScatterChart2["default"];
	  }
	});
	Object.defineProperty(exports, "AreaChart", {
	  enumerable: true,
	  get: function get() {
	    return _AreaChart2["default"];
	  }
	});
	Object.defineProperty(exports, "RadialBarChart", {
	  enumerable: true,
	  get: function get() {
	    return _RadialBarChart2["default"];
	  }
	});
	Object.defineProperty(exports, "ComposedChart", {
	  enumerable: true,
	  get: function get() {
	    return _ComposedChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Funnel", {
	  enumerable: true,
	  get: function get() {
	    return _Funnel2["default"];
	  }
	});
	Object.defineProperty(exports, "FunnelChart", {
	  enumerable: true,
	  get: function get() {
	    return _FunnelChart2["default"];
	  }
	});
	Object.defineProperty(exports, "Trapezoid", {
	  enumerable: true,
	  get: function get() {
	    return _Trapezoid2["default"];
	  }
	});
	
	__webpack_require__(2022);
	
	var _Surface2 = _interopRequireDefault(__webpack_require__(233));
	
	var _Layer2 = _interopRequireDefault(__webpack_require__(50));
	
	var _Legend2 = _interopRequireDefault(__webpack_require__(446));
	
	var _Tooltip2 = _interopRequireDefault(__webpack_require__(306));
	
	var _ResponsiveContainer2 = _interopRequireDefault(__webpack_require__(2020));
	
	var _Cell2 = _interopRequireDefault(__webpack_require__(190));
	
	var _Text2 = _interopRequireDefault(__webpack_require__(159));
	
	var _Label2 = _interopRequireDefault(__webpack_require__(134));
	
	var _LabelList2 = _interopRequireDefault(__webpack_require__(115));
	
	var _Customized2 = _interopRequireDefault(__webpack_require__(2017));
	
	var _Sector2 = _interopRequireDefault(__webpack_require__(310));
	
	var _Curve2 = _interopRequireDefault(__webpack_require__(191));
	
	var _Rectangle2 = _interopRequireDefault(__webpack_require__(192));
	
	var _Polygon2 = _interopRequireDefault(__webpack_require__(309));
	
	var _Dot2 = _interopRequireDefault(__webpack_require__(160));
	
	var _Cross2 = _interopRequireDefault(__webpack_require__(772));
	
	var _Symbols2 = _interopRequireDefault(__webpack_require__(447));
	
	var _PolarGrid2 = _interopRequireDefault(__webpack_require__(2021));
	
	var _PolarRadiusAxis2 = _interopRequireDefault(__webpack_require__(308));
	
	var _PolarAngleAxis2 = _interopRequireDefault(__webpack_require__(307));
	
	var _Pie2 = _interopRequireDefault(__webpack_require__(769));
	
	var _Radar2 = _interopRequireDefault(__webpack_require__(770));
	
	var _RadialBar2 = _interopRequireDefault(__webpack_require__(771));
	
	var _Brush2 = _interopRequireDefault(__webpack_require__(763));
	
	var _ReferenceLine2 = _interopRequireDefault(__webpack_require__(767));
	
	var _ReferenceDot2 = _interopRequireDefault(__webpack_require__(766));
	
	var _ReferenceArea2 = _interopRequireDefault(__webpack_require__(765));
	
	var _CartesianAxis2 = _interopRequireDefault(__webpack_require__(764));
	
	var _CartesianGrid2 = _interopRequireDefault(__webpack_require__(2005));
	
	var _Line2 = _interopRequireDefault(__webpack_require__(444));
	
	var _Area2 = _interopRequireDefault(__webpack_require__(442));
	
	var _Bar2 = _interopRequireDefault(__webpack_require__(443));
	
	var _Scatter2 = _interopRequireDefault(__webpack_require__(445));
	
	var _XAxis2 = _interopRequireDefault(__webpack_require__(188));
	
	var _YAxis2 = _interopRequireDefault(__webpack_require__(189));
	
	var _ZAxis2 = _interopRequireDefault(__webpack_require__(305));
	
	var _ErrorBar2 = _interopRequireDefault(__webpack_require__(232));
	
	var _LineChart2 = _interopRequireDefault(__webpack_require__(2010));
	
	var _BarChart2 = _interopRequireDefault(__webpack_require__(2007));
	
	var _PieChart2 = _interopRequireDefault(__webpack_require__(2011));
	
	var _Treemap2 = _interopRequireDefault(__webpack_require__(2016));
	
	var _Sankey2 = _interopRequireDefault(__webpack_require__(2014));
	
	var _RadarChart2 = _interopRequireDefault(__webpack_require__(2012));
	
	var _ScatterChart2 = _interopRequireDefault(__webpack_require__(2015));
	
	var _AreaChart2 = _interopRequireDefault(__webpack_require__(2006));
	
	var _RadialBarChart2 = _interopRequireDefault(__webpack_require__(2013));
	
	var _ComposedChart2 = _interopRequireDefault(__webpack_require__(2008));
	
	var _Funnel2 = _interopRequireDefault(__webpack_require__(768));
	
	var _FunnelChart2 = _interopRequireDefault(__webpack_require__(2009));
	
	var _Trapezoid2 = _interopRequireDefault(__webpack_require__(773));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabeledScaleHelper = exports.ScaleHelper = exports.rectWithCoords = exports.rectWithPoints = exports.formatAxisMap = void 0;
	
	var _every2 = _interopRequireDefault(__webpack_require__(739));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(1952));
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === void 0 ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
	    var range, x, y, needSpace;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _objectSpread({}, axis, {
	      realScaleType: realScaleType
	    }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _objectSpread({}, axis, {}, ticks, {
	      realScaleType: realScaleType,
	      x: x,
	      y: y,
	      scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	
	    finalAxis.bandSize = (0, _ChartUtils.getBandSizeOfAxis)(finalAxis, ticks);
	
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	exports.formatAxisMap = formatAxisMap;
	
	var rectWithPoints = function rectWithPoints(_ref, _ref2) {
	  var x1 = _ref.x,
	      y1 = _ref.y;
	  var x2 = _ref2.x,
	      y2 = _ref2.y;
	  return {
	    x: Math.min(x1, x2),
	    y: Math.min(y1, y2),
	    width: Math.abs(x2 - x1),
	    height: Math.abs(y2 - y1)
	  };
	};
	/**
	 * Compute the x, y, width, and height of a box from two reference points.
	 * @param  {Object} coords     x1, x2, y1, and y2
	 * @return {Object} object
	 */
	
	
	exports.rectWithPoints = rectWithPoints;
	
	var rectWithCoords = function rectWithCoords(_ref3) {
	  var x1 = _ref3.x1,
	      y1 = _ref3.y1,
	      x2 = _ref3.x2,
	      y2 = _ref3.y2;
	  return rectWithPoints({
	    x: x1,
	    y: y1
	  }, {
	    x: x2,
	    y: y2
	  });
	};
	
	exports.rectWithCoords = rectWithCoords;
	
	var ScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(ScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new ScaleHelper(obj);
	    }
	  }]);
	
	  function ScaleHelper(scale) {
	    _classCallCheck(this, ScaleHelper);
	
	    this.scale = scale;
	  }
	
	  _createClass(ScaleHelper, [{
	    key: "apply",
	    value: function apply(value) {
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref4.bandAware,
	          position = _ref4.position;
	
	      if (value === undefined) {
	        return undefined;
	      }
	
	      if (position) {
	        switch (position) {
	          case 'start':
	            {
	              return this.scale(value);
	            }
	
	          case 'middle':
	            {
	              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
	              return this.scale(value) + offset;
	            }
	
	          case 'end':
	            {
	              var _offset = this.bandwidth ? this.bandwidth() : 0;
	
	              return this.scale(value) + _offset;
	            }
	
	          default:
	            {
	              return this.scale(value);
	            }
	        }
	      }
	
	      if (bandAware) {
	        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
	
	        return this.scale(value) + _offset2;
	      }
	
	      return this.scale(value);
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(value) {
	      var range = this.range();
	      var first = range[0];
	      var last = range[range.length - 1];
	      return first <= last ? value >= first && value <= last : value >= last && value <= first;
	    }
	  }, {
	    key: "domain",
	    get: function get() {
	      return this.scale.domain;
	    }
	  }, {
	    key: "range",
	    get: function get() {
	      return this.scale.range;
	    }
	  }, {
	    key: "rangeMin",
	    get: function get() {
	      return this.range()[0];
	    }
	  }, {
	    key: "rangeMax",
	    get: function get() {
	      return this.range()[1];
	    }
	  }, {
	    key: "bandwidth",
	    get: function get() {
	      return this.scale.bandwidth;
	    }
	  }]);
	
	  return ScaleHelper;
	}();
	
	exports.ScaleHelper = ScaleHelper;
	ScaleHelper.EPS = 1e-4;
	
	var LabeledScaleHelper =
	/*#__PURE__*/
	function () {
	  _createClass(LabeledScaleHelper, null, [{
	    key: "create",
	    value: function create(obj) {
	      return new this(obj);
	    }
	  }]);
	
	  function LabeledScaleHelper(scales) {
	    _classCallCheck(this, LabeledScaleHelper);
	
	    this.scales = (0, _mapValues2["default"])(scales, ScaleHelper.create);
	    Object.assign(this, this.scales);
	  }
	
	  _createClass(LabeledScaleHelper, [{
	    key: "apply",
	    value: function apply(coords) {
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref5.bandAware;
	
	      var scales = this.scales;
	      return (0, _mapValues2["default"])(coords, function (value, label) {
	        return scales[label].apply(value, {
	          bandAware: bandAware
	        });
	      });
	    }
	  }, {
	    key: "isInRange",
	    value: function isInRange(coords) {
	      var scales = this.scales;
	      return (0, _every2["default"])(coords, function (value, label) {
	        return scales[label].isInRange(value);
	      });
	    }
	  }]);
	
	  return LabeledScaleHelper;
	}();
	
	exports.LabeledScaleHelper = LabeledScaleHelper;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useAppContext = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AppContext = __webpack_require__(790);
	
	var _twd = __webpack_require__(2);
	
	var _header = __webpack_require__(934);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__(918);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _content = __webpack_require__(791);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _framed = __webpack_require__(921);
	
	var _framed2 = _interopRequireDefault(_framed);
	
	var _modal = __webpack_require__(797);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _flyout = __webpack_require__(793);
	
	var _flyout2 = _interopRequireDefault(_flyout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.useAppContext = _AppContext.useAppContext; /* eslint-disable no-use-before-define,no-mixed-operators */
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _AppContext.AppContextProvider,
	            null,
	            _react2.default.createElement(App, null)
	        )
	    );
	};
	
	var App = function App() {
	    var _useAppContext = (0, _AppContext.useAppContext)(),
	        status = _useAppContext.status,
	        is401 = _useAppContext.is401;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        is401 && _react2.default.createElement(Show401, null),
	        !is401 && _react2.default.createElement(
	            _twd.Loading,
	            { status: status },
	            _react2.default.createElement(MainApp, null)
	        )
	    );
	};
	
	var Show401 = function Show401() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 text-center' },
	                'Session has expired. Please relogin.'
	            )
	        )
	    );
	};
	
	var MainApp = function MainApp() {
	    var _useAppContext2 = (0, _AppContext.useAppContext)(),
	        view = _useAppContext2.view,
	        args = _useAppContext2.args,
	        modal = _useAppContext2.modal,
	        modalArgs = _useAppContext2.modalArgs;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'main',
	            { id: 'main', className: 'layout' },
	            _react2.default.createElement(_header2.default, null),
	            _react2.default.createElement(_content2.default, { view: view, args: args }),
	            _react2.default.createElement(_framed2.default, { view: view, args: args }),
	            _react2.default.createElement(_footer2.default, null),
	            _react2.default.createElement(_modal2.default, { view: modal, args: modalArgs }),
	            _react2.default.createElement(_flyout2.default, null)
	        )
	    );
	};

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ContextProvider = exports.Context = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBenchmarks = __webpack_require__(902);
	
	var _useBenchmarks2 = _interopRequireDefault(_useBenchmarks);
	
	var _useTickers = __webpack_require__(903);
	
	var _useTickers2 = _interopRequireDefault(_useTickers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _twd.getState)('corporates.scatter-graph', {
	    rating: 'INVESTMENT_GRADE'
	});
	
	var colors = ['#FFA21F', '#FF9C9C', '#B7C9ED', '#241056', '#3991FF', '#FF5593', '#0065E3', '#FFA120', '#65ECED', '#5627D8', '#63AD02'];
	
	var Context = exports.Context = _react2.default.createContext();
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var children = _ref.children;
	
	
	    var state = (0, _twd.getState)('corporates.scatter-graph');
	
	    var _React$useState = _react2.default.useState(state.value.rating || 'INVESTMENT_GRADE'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        rating = _React$useState2[0],
	        setRating_ = _React$useState2[1];
	
	    var setRating = _react2.default.useCallback(function (m) {
	        state.set({ rating: m });
	        setRating_(m);
	    }, []);
	
	    var benchmarks = (0, _useBenchmarks2.default)();
	    var tickers = (0, _useTickers2.default)({ rating: rating });
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: Object.assign({
	                rating: rating, setRating: setRating,
	                colors: colors
	            }, benchmarks, tickers) },
	        children
	    );
	};
	
	exports.default = function () {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ContextProvider = exports.Context = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('municipals.market-news', {
	    tab: 'CUSTOM',
	
	    customSearchType: 'cusip',
	    customKeyword: '',
	    customCusip: [],
	    customPurpose: [],
	    customState: '',
	    customStateTs: 0,
	    customCounty: '',
	    customCity: '',
	    customDate: 'this_month',
	
	    holdingCompany: [],
	    holdings: [],
	    holdingDate: 'this_month'
	});
	
	var useContext = function useContext() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$modal = _ref.modal,
	        modal = _ref$modal === undefined ? false : _ref$modal;
	
	    var _React$useState = _react2.default.useState(modal),
	        _React$useState2 = _slicedToArray(_React$useState, 1),
	        isModal = _React$useState2[0];
	
	    var _React$useState3 = _react2.default.useState(state.value.tab || 'CUSTOM'),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        tab = _React$useState4[0],
	        setTab_ = _React$useState4[1];
	
	    var setTab = _react2.default.useCallback(function (a) {
	        state.set({ tab: a });setTab_(a);
	    }, []);
	
	    // custom-tab
	
	    var _React$useState5 = _react2.default.useState(state.value.customSearchType || 'cusip'),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        customSearchType = _React$useState6[0],
	        setCustomSearchType_ = _React$useState6[1];
	
	    var setCustomSearchType = _react2.default.useCallback(function (a) {
	        state.set({ customSearchType: a });setCustomSearchType_(a);
	    }, []);
	
	    var _React$useState7 = _react2.default.useState(state.value.customKeyword || ''),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        customKeyword = _React$useState8[0],
	        setCustomKeyword_ = _React$useState8[1];
	
	    var setCustomKeyword = _react2.default.useCallback(function (a) {
	        state.set({ customKeyword: a });setCustomKeyword_(a);
	    }, []);
	
	    var _React$useState9 = _react2.default.useState(state.value.customCusip || ''),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        customCusip = _React$useState10[0],
	        setCustomCusip_ = _React$useState10[1];
	
	    var setCustomCusip = _react2.default.useCallback(function (a) {
	        state.set({ customCusip: a });setCustomCusip_(a);
	    }, []);
	
	    var _React$useState11 = _react2.default.useState(state.value.customPurpose || []),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        customPurpose = _React$useState12[0],
	        setCustomPurpose_ = _React$useState12[1];
	
	    var setCustomPurpose = _react2.default.useCallback(function (a) {
	        state.set({ customPurpose: a });setCustomPurpose_(a);
	    }, []);
	
	    var defaultState = (0, _twd.getConfig)('account_states.0.stateOfResidence', '');
	
	    var _React$useState13 = _react2.default.useState(state.value.customStateTs ? state.value.customState : defaultState),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        customState = _React$useState14[0],
	        setCustomState_ = _React$useState14[1];
	
	    var setCustomState = _react2.default.useCallback(function (a) {
	        state.set({ customState: a, customStateTs: Date.now() });setCustomState_(a);
	    }, []);
	
	    var _React$useState15 = _react2.default.useState(state.value.customCounty || ''),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        customCounty = _React$useState16[0],
	        setCustomCounty_ = _React$useState16[1];
	
	    var setCustomCounty = _react2.default.useCallback(function (a) {
	        state.set({ customCounty: a });setCustomCounty_(a);
	    }, []);
	
	    var _React$useState17 = _react2.default.useState(state.value.customCity || ''),
	        _React$useState18 = _slicedToArray(_React$useState17, 2),
	        customCity = _React$useState18[0],
	        setCustomCity_ = _React$useState18[1];
	
	    var setCustomCity = _react2.default.useCallback(function (a) {
	        state.set({ customCity: a });setCustomCity_(a);
	    }, []);
	
	    var _React$useState19 = _react2.default.useState(state.value.customDate || 'today'),
	        _React$useState20 = _slicedToArray(_React$useState19, 2),
	        customDate = _React$useState20[0],
	        setCustomDate_ = _React$useState20[1];
	
	    var setCustomDate = _react2.default.useCallback(function (a) {
	        state.set({ customDate: a });setCustomDate_(a);
	    }, []);
	
	    // holding-tab
	
	    var _React$useState21 = _react2.default.useState(state.value.holdings || []),
	        _React$useState22 = _slicedToArray(_React$useState21, 2),
	        holdings = _React$useState22[0],
	        setHoldings_ = _React$useState22[1];
	
	    var setHoldings = _react2.default.useCallback(function (a) {
	        state.set({ holdings: a });setHoldings_(a);
	    }, []);
	
	    var _React$useState23 = _react2.default.useState(state.value.holdingDate || 'today'),
	        _React$useState24 = _slicedToArray(_React$useState23, 2),
	        holdingDate = _React$useState24[0],
	        setHoldingDate_ = _React$useState24[1];
	
	    var setHoldingDate = _react2.default.useCallback(function (a) {
	        state.set({ holdingDate: a });setHoldingDate_(a);
	    }, []);
	
	    return {
	        isModal: isModal,
	        tab: tab, setTab: setTab,
	
	        customSearchType: customSearchType, setCustomSearchType: setCustomSearchType,
	        customKeyword: customKeyword, setCustomKeyword: setCustomKeyword,
	        customCusip: customCusip, setCustomCusip: setCustomCusip,
	        customPurpose: customPurpose, setCustomPurpose: setCustomPurpose,
	        customState: customState, setCustomState: setCustomState,
	        customCounty: customCounty, setCustomCounty: setCustomCounty,
	        customCity: customCity, setCustomCity: setCustomCity,
	        customDate: customDate, setCustomDate: setCustomDate,
	
	        holdings: holdings, setHoldings: setHoldings,
	        holdingDate: holdingDate, setHoldingDate: setHoldingDate
	    };
	};
	
	var Context = exports.Context = _react2.default.createContext();
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref2) {
	    var modal = _ref2.modal,
	        children = _ref2.children;
	
	    var ctx = useContext({ modal: modal });
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: ctx },
	        children
	    );
	};
	
	exports.default = function () {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ContextProvider = exports.Context = exports.RATING_VALUES = exports.RATINGS = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBenchmarks = __webpack_require__(993);
	
	var _useBenchmarks2 = _interopRequireDefault(_useBenchmarks);
	
	var _useOffers = __webpack_require__(994);
	
	var _useOffers2 = _interopRequireDefault(_useOffers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RATINGS = exports.RATINGS = [{ value: 'AAA', label: 'Aaa/AAA' }, { value: 'AA', label: 'Aa/AA' }, { value: 'A', label: 'A/A' }, { value: 'BBB', label: 'Baa/BBB' }, { value: 'HY', label: 'HY' }];
	var RATING_VALUES = exports.RATING_VALUES = RATINGS.map(function (a) {
	    return a.value;
	});
	
	(0, _twd.getState)('municipals.scatter-graph', {
	    ratings: [].concat(RATING_VALUES),
	    activeState: '',
	    activeStateTs: 0
	});
	
	var colors = ['#FFA21F', '#FF9C9C', '#B7C9ED', '#241056', '#3991FF', '#FF5593', '#0065E3', '#FFA120', '#65ECED', '#5627D8', '#63AD02'];
	
	var Context = exports.Context = _react2.default.createContext();
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var children = _ref.children;
	
	
	    var state = (0, _twd.getState)('municipals.scatter-graph');
	
	    var _React$useState = _react2.default.useState(state.value.ratings || [].concat(RATING_VALUES)),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        ratings = _React$useState2[0],
	        setRatings_ = _React$useState2[1];
	
	    var setRatings = _react2.default.useCallback(function (m) {
	        state.set({ ratings: m });
	        setRatings_(m);
	    }, []);
	
	    var defaultState = (0, _twd.getConfig)('account_states.0.stateOfResidence', '');
	
	    var _React$useState3 = _react2.default.useState(state.value.activeStateTs ? state.value.activeState : defaultState),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        activeState = _React$useState4[0],
	        setActiveState_ = _React$useState4[1];
	
	    var setActiveState = _react2.default.useCallback(function (m) {
	        state.set({ activeState: m, activeStateTs: Date.now() });
	        setActiveState_(m);
	    }, []);
	
	    var benchmarks = (0, _useBenchmarks2.default)();
	    var offers = (0, _useOffers2.default)({ activeState: activeState });
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: Object.assign({
	                RATINGS: RATINGS,
	                RATING_VALUES: RATING_VALUES,
	                ratings: ratings, setRatings: setRatings,
	                activeState: activeState, setActiveState: setActiveState,
	                colors: colors
	            }, benchmarks, offers) },
	        children
	    );
	};
	
	exports.default = function () {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classofRaw = __webpack_require__(61);
	var uncurryThis = __webpack_require__(8);
	
	module.exports = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
	};


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(36);
	var anObject = __webpack_require__(18);
	var call = __webpack_require__(16);
	var toIntegerOrInfinity = __webpack_require__(49);
	var getIteratorDirect = __webpack_require__(1249);
	
	var INVALID_SIZE = 'Invalid size';
	var $RangeError = RangeError;
	var $TypeError = TypeError;
	var max = Math.max;
	
	var SetRecord = function (set, intSize) {
	  this.set = set;
	  this.size = max(intSize, 0);
	  this.has = aCallable(set.has);
	  this.keys = aCallable(set.keys);
	};
	
	SetRecord.prototype = {
	  getIterator: function () {
	    return getIteratorDirect(anObject(call(this.keys, this.set)));
	  },
	  includes: function (it) {
	    return call(this.has, this.set, it);
	  }
	};
	
	// `GetSetRecord` abstract operation
	// https://tc39.es/proposal-set-methods/#sec-getsetrecord
	module.exports = function (obj) {
	  anObject(obj);
	  var numSize = +obj.size;
	  // NOTE: If size is undefined, then numSize will be NaN
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (numSize !== numSize) throw new $TypeError(INVALID_SIZE);
	  var intSize = toIntegerOrInfinity(numSize);
	  if (intSize < 0) throw new $RangeError(INVALID_SIZE);
	  return new SetRecord(obj, intSize);
	};


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(22);
	var isObject = __webpack_require__(20);
	var setPrototypeOf = __webpack_require__(100);
	
	// makes subclassing work correct for wrapped built-ins
	module.exports = function ($this, dummy, Wrapper) {
	  var NewTarget, NewTargetPrototype;
	  if (
	    // it can work only with native `setPrototypeOf`
	    setPrototypeOf &&
	    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
	    isCallable(NewTarget = dummy.constructor) &&
	    NewTarget !== Wrapper &&
	    isObject(NewTargetPrototype = NewTarget.prototype) &&
	    NewTargetPrototype !== Wrapper.prototype
	  ) setPrototypeOf($this, NewTargetPrototype);
	  return $this;
	};


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var hiddenKeys = __webpack_require__(206);
	var isObject = __webpack_require__(20);
	var hasOwn = __webpack_require__(28);
	var defineProperty = __webpack_require__(41).f;
	var getOwnPropertyNamesModule = __webpack_require__(145);
	var getOwnPropertyNamesExternalModule = __webpack_require__(355);
	var isExtensible = __webpack_require__(356);
	var uid = __webpack_require__(174);
	var FREEZING = __webpack_require__(164);
	
	var REQUIRED = false;
	var METADATA = uid('meta');
	var id = 0;
	
	var setMetadata = function (it) {
	  defineProperty(it, METADATA, { value: {
	    objectID: 'O' + id++, // object ID
	    weakData: {}          // weak collections IDs
	  } });
	};
	
	var fastKey = function (it, create) {
	  // return a primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!hasOwn(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMetadata(it);
	  // return object ID
	  } return it[METADATA].objectID;
	};
	
	var getWeakData = function (it, create) {
	  if (!hasOwn(it, METADATA)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMetadata(it);
	  // return the store of weak collections IDs
	  } return it[METADATA].weakData;
	};
	
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
	  return it;
	};
	
	var enable = function () {
	  meta.enable = function () { /* empty */ };
	  REQUIRED = true;
	  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
	  var splice = uncurryThis([].splice);
	  var test = {};
	  test[METADATA] = 1;
	
	  // prevent exposing of metadata key
	  if (getOwnPropertyNames(test).length) {
	    getOwnPropertyNamesModule.f = function (it) {
	      var result = getOwnPropertyNames(it);
	      for (var i = 0, length = result.length; i < length; i++) {
	        if (result[i] === METADATA) {
	          splice(result, i, 1);
	          break;
	        }
	      } return result;
	    };
	
	    $({ target: 'Object', stat: true, forced: true }, {
	      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
	    });
	  }
	};
	
	var meta = module.exports = {
	  enable: enable,
	  fastKey: fastKey,
	  getWeakData: getWeakData,
	  onFreeze: onFreeze
	};
	
	hiddenKeys[METADATA] = true;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var internalObjectKeys = __webpack_require__(536);
	var enumBugKeys = __webpack_require__(344);
	
	var hiddenKeys = enumBugKeys.concat('length', 'prototype');
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return internalObjectKeys(O, hiddenKeys);
	};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	
	var createSetLike = function (size) {
	  return {
	    size: size,
	    has: function () {
	      return false;
	    },
	    keys: function () {
	      return {
	        next: function () {
	          return { done: true };
	        }
	      };
	    }
	  };
	};
	
	module.exports = function (name) {
	  var Set = getBuiltIn('Set');
	  try {
	    new Set()[name](createSetLike(0));
	    try {
	      // late spec change, early WebKit ~ Safari 17.0 beta implementation does not pass it
	      // https://github.com/tc39/proposal-set-methods/pull/88
	      new Set()[name](createSetLike(-1));
	      return false;
	    } catch (error2) {
	      return true;
	    }
	  } catch (error) {
	    return false;
	  }
	};


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var store = __webpack_require__(363);
	
	module.exports = function (key, value) {
	  return store[key] || (store[key] = value || {});
	};


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var isCallable = __webpack_require__(22);
	var isIterable = __webpack_require__(1253);
	var isObject = __webpack_require__(20);
	
	var Set = getBuiltIn('Set');
	
	var isSetLike = function (it) {
	  return isObject(it)
	    && typeof it.size == 'number'
	    && isCallable(it.has)
	    && isCallable(it.keys);
	};
	
	// fallback old -> new set methods proposal arguments
	module.exports = function (it) {
	  if (isSetLike(it)) return it;
	  return isIterable(it) ? new Set(it) : it;
	};


/***/ },
/* 149 */
/***/ function(module, exports) {

	'use strict';
	var $String = String;
	
	module.exports = function (argument) {
	  try {
	    return $String(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareAsc;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name compareAsc
	 * @category Common Helpers
	 * @summary Compare the two dates and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return 1 if the first date is after the second,
	 * -1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989:
	 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> -1
	 *
	 * @example
	 * // Sort the array of dates:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareAsc)
	 * //=> [
	 * //   Wed Feb 11 1987 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Sun Jul 02 1995 00:00:00
	 * // ]
	 */
	function compareAsc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(131));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the start of an ISO week for the given date.
	 *
	 * @description
	 * Return the start of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week for 2 September 2014 11:55:00:
	 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports.default;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(53),
		__webpack_require__(132),
		__webpack_require__(1795),
		__webpack_require__(673),
		__webpack_require__(674),
	
		__webpack_require__(94),
		__webpack_require__(678),
		__webpack_require__(690),
		__webpack_require__(181),
		__webpack_require__(699) // jQuery.param
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, isFunction, rnothtmlwhite, location, nonce, rquery ) {
	
	"use strict";
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
	
	originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes trac-9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (trac-10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket trac-12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// trac-9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script but not if jsonp
				if ( !isSuccess &&
					jQuery.inArray( "script", s.dataTypes ) > -1 &&
					jQuery.inArray( "json", s.dataTypes ) < 0 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(180),
		__webpack_require__(53)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isFunction ) {
	
	"use strict";
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
							value :
							value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	return access;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// All support tests are defined in their respective modules.
		return {};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1856),
	    getValue = __webpack_require__(1899);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38),
	    isLength = __webpack_require__(435);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(133),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reduceCssCalc = _interopRequireDefault(__webpack_require__(2027));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DOMUtils = __webpack_require__(311);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return {
	        word: word,
	        width: (0, _DOMUtils.getStringSize)(word, props.style).width
	      };
	    });
	    var spaceWidth = (0, _DOMUtils.getStringSize)("\xA0", props.style).width;
	    return {
	      wordsWithComputedWidth: wordsWithComputedWidth,
	      spaceWidth: spaceWidth
	    };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text(_props) {
	    var _this;
	
	    _classCallCheck(this, Text);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Text).call(this, _props));
	
	    _this.getWordsWithoutCalculate = function (props) {
	      var words = !(0, _isNil2["default"])(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	      return [{
	        words: words
	      }];
	    };
	
	    _this.state = {
	      wordsByLines: _this.getWordsByLines(_props, true)
	    };
	    return _this;
	  }
	
	  _createClass(Text, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.width !== this.props.width || prevProps.scaleToFit !== this.props.scaleToFit || prevProps.children !== this.props.children || prevProps.style !== this.props.style) {
	        var needCalculate = this.props.children !== prevProps.children || this.props.style !== prevProps.style;
	        this.updateWordsByLines(this.props, needCalculate);
	      }
	    }
	  }, {
	    key: "updateWordsByLines",
	    value: function updateWordsByLines(props, needCalculate) {
	      this.setState({
	        wordsByLines: this.getWordsByLines(props, needCalculate)
	      });
	    }
	  }, {
	    key: "getWordsByLines",
	    value: function getWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            return this.getWordsWithoutCalculate(props);
	          }
	        }
	
	        return this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	      }
	
	      return this.getWordsWithoutCalculate(props);
	    }
	  }, {
	    key: "calculateWordsByLines",
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	      return (wordsWithComputedWidth || []).reduce(function (result, _ref) {
	        var word = _ref.word,
	            width = _ref.width;
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = {
	            words: [word],
	            width: width
	          };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          dx = _this$props.dx,
	          dy = _this$props.dy,
	          textAnchor = _this$props.textAnchor,
	          verticalAnchor = _this$props.verticalAnchor,
	          scaleToFit = _this$props.scaleToFit,
	          angle = _this$props.angle,
	          lineHeight = _this$props.lineHeight,
	          capHeight = _this$props.capHeight,
	          className = _this$props.className,
	          textProps = _objectWithoutProperties(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className"]);
	
	      var wordsByLines = this.state.wordsByLines;
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	      var startDy;
	
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(capHeight, ")"));
	          break;
	
	        case 'middle':
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
	          break;
	
	        default:
	          startDy = (0, _reduceCssCalc["default"])("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
	          break;
	      }
	
	      var transforms = [];
	
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push("scale(".concat(this.props.width / lineWidth, ")"));
	      }
	
	      if (angle) {
	        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
	      }
	
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react["default"].createElement("text", _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), (0, _ReactUtils.filterEventAttributes)(textProps), {
	        x: x,
	        y: y,
	        className: (0, _classnames["default"])('recharts-text', className),
	        textAnchor: textAnchor
	      }), wordsByLines.map(function (line, index) {
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement("tspan", {
	            x: x,
	            dy: index === 0 ? startDy : lineHeight,
	            key: index
	          }, line.words.join(' '))
	        );
	      }));
	    }
	  }]);
	
	  return Text;
	}(_react.Component);
	
	Text.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes["default"].bool,
	  angle: _propTypes["default"].number,
	  textAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes["default"].oneOf(['start', 'middle', 'end']),
	  style: _propTypes["default"].object
	});
	Text.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em',
	  // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	
	};
	var _default = Text;
	exports["default"] = _default;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Dot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Dot, _PureComponent);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dot).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          r = _this$props.r,
	          className = _this$props.className;
	      var layerClass = (0, _classnames["default"])('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react["default"].createElement("circle", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.PureComponent);
	
	Dot.displayName = 'Dot';
	Dot.propTypes = {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  r: _propTypes["default"].number
	};
	var _default = Dot;
	exports["default"] = _default;

/***/ },
/* 161 */
117,
/* 162 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var mediaQueries = exports.mediaQueries = {
	    xs: '@media (max-width: 767px)',
	    notXs: '@media (min-width: 768px)',
	    sm: '@media (min-width: 768px)',
	    md: '@media (min-width: 992px)',
	    lg: '@media (min-width: 1200px)',
	
	    width: function width() {
	        return global.innerWidth || global.document.documentElement.clientWidth || global.document.body.clientWidth;
	    },
	    isNotXs: function isNotXs() {
	        return this.width() > 767;
	    },
	    isXs: function isXs() {
	        return this.width() < 768;
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 163 */
/***/ function(module, exports) {

	'use strict';
	var $TypeError = TypeError;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
	
	module.exports = function (it) {
	  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
	  return it;
	};


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
	  return Object.isExtensible(Object.preventExtensions({}));
	});


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var hasOwn = __webpack_require__(28);
	
	var FunctionPrototype = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
	
	var EXISTS = hasOwn(FunctionPrototype, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
	var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));
	
	module.exports = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var classof = __webpack_require__(61);
	
	var $Object = Object;
	var split = uncurryThis(''.split);
	
	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	module.exports = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classof(it) === 'String' ? split(it, '') : $Object(it);
	} : $Object;


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var isCallable = __webpack_require__(22);
	var classof = __webpack_require__(92);
	var getBuiltIn = __webpack_require__(35);
	var inspectSource = __webpack_require__(346);
	
	var noop = function () { /* empty */ };
	var construct = getBuiltIn('Reflect', 'construct');
	var constructorRegExp = /^\s*(?:class|function)\b/;
	var exec = uncurryThis(constructorRegExp.exec);
	var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
	
	var isConstructorModern = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  try {
	    construct(noop, [], argument);
	    return true;
	  } catch (error) {
	    return false;
	  }
	};
	
	var isConstructorLegacy = function isConstructor(argument) {
	  if (!isCallable(argument)) return false;
	  switch (classof(argument)) {
	    case 'AsyncFunction':
	    case 'GeneratorFunction':
	    case 'AsyncGeneratorFunction': return false;
	  }
	  try {
	    // we can't check .prototype since constructors produced by .bind haven't it
	    // `Function#toString` throws on some built-it function in some legacy engines
	    // (for example, `DOMQuad` and similar in FF41-)
	    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
	  } catch (error) {
	    return true;
	  }
	};
	
	isConstructorLegacy.sham = true;
	
	// `IsConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-isconstructor
	module.exports = !construct || fails(function () {
	  var called;
	  return isConstructorModern(isConstructorModern.call)
	    || !isConstructorModern(Object)
	    || !isConstructorModern(function () { called = true; })
	    || called;
	}) ? isConstructorLegacy : isConstructorModern;


/***/ },
/* 168 */
/***/ function(module, exports) {

	'use strict';
	module.exports = {};


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	
	module.exports = global.Promise;


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var defineBuiltInAccessor = __webpack_require__(54);
	var wellKnownSymbol = __webpack_require__(21);
	var DESCRIPTORS = __webpack_require__(15);
	
	var SPECIES = wellKnownSymbol('species');
	
	module.exports = function (CONSTRUCTOR_NAME) {
	  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
	
	  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
	    defineBuiltInAccessor(Constructor, SPECIES, {
	      configurable: true,
	      get: function () { return this; }
	    });
	  }
	};


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(18);
	var aConstructor = __webpack_require__(333);
	var isNullOrUndefined = __webpack_require__(66);
	var wellKnownSymbol = __webpack_require__(21);
	
	var SPECIES = wellKnownSymbol('species');
	
	// `SpeciesConstructor` abstract operation
	// https://tc39.es/ecma262/#sec-speciesconstructor
	module.exports = function (O, defaultConstructor) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
	};


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(46);
	var toString = __webpack_require__(17);
	var whitespaces = __webpack_require__(269);
	
	var replace = uncurryThis(''.replace);
	var ltrim = RegExp('^[' + whitespaces + ']+');
	var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
	
	// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
	var createMethod = function (TYPE) {
	  return function ($this) {
	    var string = toString(requireObjectCoercible($this));
	    if (TYPE & 1) string = replace(string, ltrim, '');
	    if (TYPE & 2) string = replace(string, rtrim, '$1');
	    return string;
	  };
	};
	
	module.exports = {
	  // `String.prototype.{ trimLeft, trimStart }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
	  start: createMethod(1),
	  // `String.prototype.{ trimRight, trimEnd }` methods
	  // https://tc39.es/ecma262/#sec-string.prototype.trimend
	  end: createMethod(2),
	  // `String.prototype.trim` method
	  // https://tc39.es/ecma262/#sec-string.prototype.trim
	  trim: createMethod(3)
	};


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-symbol -- required for testing */
	var V8_VERSION = __webpack_require__(104);
	var fails = __webpack_require__(7);
	var global = __webpack_require__(11);
	
	var $String = global.String;
	
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
	    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
	});


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	var id = 0;
	var postfix = Math.random();
	var toString = uncurryThis(1.0.toString);
	
	module.exports = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(55);
	var addToUnscopables = __webpack_require__(71);
	var Iterators = __webpack_require__(168);
	var InternalStateModule = __webpack_require__(52);
	var defineProperty = __webpack_require__(41).f;
	var defineIterator = __webpack_require__(350);
	var createIterResultObject = __webpack_require__(202);
	var IS_PURE = __webpack_require__(48);
	var DESCRIPTORS = __webpack_require__(15);
	
	var ARRAY_ITERATOR = 'Array Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
	
	// `Array.prototype.entries` method
	// https://tc39.es/ecma262/#sec-array.prototype.entries
	// `Array.prototype.keys` method
	// https://tc39.es/ecma262/#sec-array.prototype.keys
	// `Array.prototype.values` method
	// https://tc39.es/ecma262/#sec-array.prototype.values
	// `Array.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
	// `CreateArrayIterator` internal method
	// https://tc39.es/ecma262/#sec-createarrayiterator
	module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
	  setInternalState(this, {
	    type: ARRAY_ITERATOR,
	    target: toIndexedObject(iterated), // target
	    index: 0,                          // next index
	    kind: kind                         // kind
	  });
	// `%ArrayIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
	}, function () {
	  var state = getInternalState(this);
	  var target = state.target;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = undefined;
	    return createIterResultObject(undefined, true);
	  }
	  switch (state.kind) {
	    case 'keys': return createIterResultObject(index, false);
	    case 'values': return createIterResultObject(target[index], false);
	  } return createIterResultObject([index, target[index]], false);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values%
	// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
	// https://tc39.es/ecma262/#sec-createmappedargumentsobject
	var values = Iterators.Arguments = Iterators.Array;
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');
	
	// V8 ~ Chrome 45- bug
	if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
	  defineProperty(values, 'name', { value: 'values' });
	} catch (error) { /* empty */ }


/***/ },
/* 176 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return sign + output;
	}
	module.exports = exports.default;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1675));
	var _default = _index.default;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 178 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRoundingMethod = getRoundingMethod;
	var roundingMap = {
	  ceil: Math.ceil,
	  round: Math.round,
	  floor: Math.floor,
	  trunc: function trunc(value) {
	    return value < 0 ? Math.ceil(value) : Math.floor(value);
	  } // Math.trunc is not supported by IE
	};
	
	var defaultRoundingMethod = 'trunc';
	function getRoundingMethod(method) {
	  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
	}

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the ISO week-numbering year of the given date,
	 * which always starts 3 days before the year's first Thursday.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeekYear(new Date(2005, 0, 2))
	 * //=> 2004
	 */
	function getISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(284),
		__webpack_require__(707)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type, toString ) {
	
	"use strict";
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	
	return toType;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(53),
		__webpack_require__(229),
		__webpack_require__(405)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction, slice ) {
	
	"use strict";
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.error );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getErrorHook ) {
										process.error = jQuery.Deferred.getErrorHook();
	
									// The deprecated alias of the above. While the name suggests
									// returning the stack, not an error instance, jQuery just passes
									// it directly to `console.warn` so both will work; an instance
									// just better cooperates with source maps.
									} else if ( jQuery.Deferred.getStackHook ) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the primary Deferred
				primary = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							primary.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( primary.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return primary.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
			}
	
			return primary.promise();
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(704),
		__webpack_require__(287),
		__webpack_require__(1822),
		__webpack_require__(1823),
		__webpack_require__(701),
		__webpack_require__(111),
	
		__webpack_require__(94),
		__webpack_require__(700),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, getProto, indexOf, dir, siblings, rneedsContext, nodeName ) {
	
	"use strict";
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(95);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(158);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(292);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 186 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(714),
	    baseKeys = __webpack_require__(1859),
	    isArrayLike = __webpack_require__(157);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var XAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(XAxis, _PureComponent);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.PureComponent);
	
	XAxis.displayName = 'XAxis';
	XAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes["default"].number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['top', 'bottom']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  padding: _propTypes["default"].shape({
	    left: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	XAxis.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: {
	    left: 0,
	    right: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false,
	  allowDuplicatedCategory: true
	};
	var _default = XAxis;
	exports["default"] = _default;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var YAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(YAxis, _PureComponent);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(YAxis).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.PureComponent);
	
	YAxis.displayName = 'YAxis';
	YAxis.propTypes = {
	  allowDecimals: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes["default"].array,
	  // The count of ticks
	  tickCount: _propTypes["default"].number,
	  // The formatter function of tick
	  tickFormatter: _propTypes["default"].func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes["default"].number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes["default"].number,
	  mirror: _propTypes["default"].bool,
	  // The orientation of axis
	  orientation: _propTypes["default"].oneOf(['left', 'right']),
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    bottom: _propTypes["default"].number
	  }),
	  allowDataOverflow: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  minTickGap: _propTypes["default"].number,
	  tickSize: _propTypes["default"].number,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes["default"].bool
	};
	YAxis.defaultProps = {
	  allowDuplicatedCategory: true,
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: {
	    top: 0,
	    bottom: 0
	  },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	};
	var _default = YAxis;
	exports["default"] = _default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _ReactUtils = __webpack_require__(19);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function Cell() {
	  return null;
	}
	
	Cell.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
	Cell.displayName = 'Cell';
	var _default = Cell;
	exports["default"] = _default;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _d3Shape = __webpack_require__(381);
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed,
	  curveBasisOpen: _d3Shape.curveBasisOpen,
	  curveBasis: _d3Shape.curveBasis,
	  curveLinearClosed: _d3Shape.curveLinearClosed,
	  curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX,
	  curveMonotoneY: _d3Shape.curveMonotoneY,
	  curveNatural: _d3Shape.curveNatural,
	  curveStep: _d3Shape.curveStep,
	  curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	
	var getX = function getX(p) {
	  return p.x;
	};
	
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction2["default"])(type)) {
	    return type;
	  }
	
	  var name = "curve".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
	  }
	
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Curve, _PureComponent);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Curve).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine,
	          layout = _this$props.layout,
	          connectNulls = _this$props.connectNulls;
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction;
	
	      if ((0, _isArray2["default"])(baseLine)) {
	        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
	          return defined(base);
	        }) : baseLine;
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _objectSpread({}, entry, {
	            base: formatBaseLine[index]
	          });
	        });
	
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	
	        lineFunction.defined(defined).curve(curveFactory);
	        return lineFunction(areaPoints);
	      }
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          points = _this$props2.points,
	          path = _this$props2.path,
	          pathRef = _this$props2.pathRef;
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	        className: (0, _classnames["default"])('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.PureComponent);
	
	Curve.displayName = 'Curve';
	Curve.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  connectNulls: _propTypes["default"].bool,
	  path: _propTypes["default"].string,
	  pathRef: _propTypes["default"].func
	});
	Curve.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	};
	var _default = Curve;
	exports["default"] = _default;

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var ySign = height >= 0 ? 1 : -1;
	  var xSign = width >= 0 ? 1 : -1;
	  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
	  var path;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
	    }
	
	    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
	
	    if (newRadius[1] > 0) {
	      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
	    }
	
	    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
	    }
	
	    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
	
	    if (newRadius[3] > 0) {
	      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
	    }
	
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
	  } else {
	    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
	  }
	
	  return path;
	};
	
	var Rectangle =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Rectangle, _PureComponent);
	
	  function Rectangle() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rectangle)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Rectangle, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          radius = _this$props.radius,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isAnimationActive = _this$props2.isAnimationActive,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currWidth = _ref.width,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Rectangle;
	}(_react.PureComponent);
	
	Rectangle.displayName = 'Rectangle';
	Rectangle.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Rectangle.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Rectangle;
	exports["default"] = _default;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = void 0;
	
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _twd = __webpack_require__(2);
	
	exports.default = function (values) {
	    var p = Object.assign({
	        holdRatingAndOr: 'OR',
	        holdUnderlyingRating: 'NO'
	    }, values);
	
	    delete p.isEdit;
	    delete p.primarySecondary;
	
	    if (!p.holdCusip && p.cusip || p.isSubmit) {
	        p.holdCusip = (p.cusip || '').split(',').map(function (a) {
	            return a.trim();
	        }).filter(Boolean);
	    }
	    if (!p.holdIssue && p.issuer || p.isSubmit) {
	        p.holdIssue = (0, _twd.arrayFrom)((p.issuer || '').trim()).filter(Boolean);
	    }
	    delete p.isSubmit;
	
	    p.holdSymbol = (0, _twd.arrayFrom)(p.holdSymbol).filter(Boolean);
	    p.ytwMin = p.offerYtwMin;
	    p.ytwMax = p.offerYtwMax;
	    p.ytmMin = p.offerYtmMin;
	    p.ytmMax = p.offerYtmMax;
	
	    var invTypes = (0, _twd.arrayFrom)(p.holdInvType).filter(Boolean);
	    var fieldArrays = Object.keys(getFieldArrays(invTypes));
	
	    ALL_FIELD_ARRAYS.forEach(function (k) {
	        if (fieldArrays.indexOf(k) >= 0) return;
	        delete p[k];
	    });
	
	    fieldArrays.forEach(function (k) {
	        var arr = p[k];
	        var v = collectFieldArray(arr);
	        Object.assign(p, v);
	        delete p[k];
	    });
	
	    var isCD = invTypes.indexOf('S') >= 0;
	    var isCorp = invTypes.indexOf('C') >= 0;
	    var isTreasury = invTypes.indexOf('T') >= 0;
	    var isMuni = invTypes.indexOf('M') >= 0;
	
	    p.offeringType = ['ask-side'];
	    if (isCD || isCorp) {
	        p.offeringType = p.offeringType.concat((0, _twd.arrayFrom)(p.primarySecondary)).filter(Boolean);
	    }
	
	    if (['AND', 'OR'].indexOf(p.holdRatingAndOr) < 0) {
	        p.holdRatingAndOr = p.holdRatingAndOr === true ? 'OR' : 'AND';
	    }
	
	    if (isCD || isTreasury) {
	        p.holdFdicNum = p.cdFdic;
	        delete p.holdMoodyRatingMin;
	        delete p.holdMoodyRatingMax;
	        delete p.holdSpRatingMin;
	        delete p.holdSpRatingMax;
	        delete p.holdRatingAndOr;
	        delete p.holdUnderlyingRating;
	    }
	
	    if (isCD) {
	        p.holdBlueSkyStateCD = (0, _twd.arrayFrom)(p.holdBlueSkyStateCD).filter(Boolean);
	    }
	
	    if (isMuni) {
	        p.holdState = (0, _twd.arrayFrom)(p.holdState).filter(Boolean);
	        p.holdInsurance = p.muniInsured ? ['Any'] : [];
	    }
	
	    if (p.offeringPosted) {
	        p.offeringNewToday = p.offeringPosted === 'New today';
	        delete p.offeringPosted;
	    }
	
	    if (p.sortBy) {
	        p.sort = [{
	            field: p.sortBy,
	            direction: SORT_ORDERS[p.sortOrder] || 'ASC'
	        }];
	        delete p.sortBy;
	        delete p.sortOrder;
	    }
	
	    p.holdMaturityMin = (0, _twd.formatDate)(p.holdMaturityMin);
	    p.holdMaturityMax = (0, _twd.formatDate)(p.holdMaturityMax, true);
	    p.holdFirstCallMin = (0, _twd.formatDate)(p.holdFirstCallMin);
	    p.holdFirstCallMax = (0, _twd.formatDate)(p.holdFirstCallMax, true);
	
	    return (0, _twd.cleanObject)(p);
	};
	
	var getFieldArrays = function getFieldArrays() {
	    var invTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    return ['_'].concat(invTypes).map(function (a) {
	        return FIELD_ARRAYS[a];
	    }).reduce(function (x, a) {
	        return Object.assign({}, x, a);
	    });
	};
	
	var SORT_ORDERS = {
	    'Ascending': 'ASC',
	    'Descending': 'DESC'
	};
	
	var FIELD_ARRAYS = {
	    C: {
	        corpSectors: [],
	        corpFeatures: [],
	        corpDebtRanks: [],
	        corpMarketTypes: []
	    },
	
	    M: {
	        muniStates: [],
	        muniCategories: [],
	        muniTaxTreatments: [],
	        muniPurposes: [],
	        muniEnvironmentals: [],
	        muniDeminimis: []
	    },
	
	    S: {
	        cdBlueSky: [],
	        cdMarketTypes: []
	    },
	
	    T: {
	        treasuryTypes: []
	    },
	
	    A: {
	        agencyTypes: []
	    },
	
	    _: {
	        couponFrequencies: [],
	        couponPayMonths: [],
	        couponFeatures: [],
	
	        callFeatures: [],
	        putFeatures: [],
	        otherFeatures: []
	    }
	};
	
	var ALL_FIELD_ARRAYS = Object.keys(FIELD_ARRAYS).map(function (a) {
	    return Object.keys(FIELD_ARRAYS[a]);
	}).reduce(function (x, a) {
	    return (x || []).concat(a);
	});
	
	var collectFieldArray = function collectFieldArray(array) {
	    return (0, _twd.arrayFrom)(array).reduce(function (p, a) {
	        var _a$split = a.split('='),
	            _a$split2 = _slicedToArray(_a$split, 2),
	            k = _a$split2[0],
	            v = _a$split2[1];
	
	        if (!p[k]) p[k] = [];
	
	        var arr = p[k];
	        var i = arr.indexOf(v);
	        if (i < 0) arr.push(v);
	
	        return p;
	    }, {});
	};

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var msg = _ref.msg;
	    return _react2.default.createElement(
	        'div',
	        {
	            className: 'text-muted text-center' },
	        _twd.NO_RESULT_ICON,
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'h5',
	            { className: 'subhead' },
	            msg
	        )
	    );
	};

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$label = _ref.label,
	        label = _ref$label === undefined ? '' : _ref$label;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'vertical-offset-sm' }),
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'text-muted text-right' },
	            'Showing only ',
	            label,
	            ' since 2011'
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fitchRatings = exports.moodysRatings = exports.spRatings = undefined;
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = _ref.field,
	        form = _ref.form,
	        error = _ref.error,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-fields-ratings' : _ref$dataName,
	        label = _ref.label,
	        labelStyle = _ref.labelStyle,
	        labelClass = _ref.labelClass,
	        ariaLabel = _ref.ariaLabel,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'error', 'dataName', 'label', 'labelStyle', 'labelClass', 'ariaLabel']);
	
	    var id = (0, _twd.getId)();
	
	    var r = props.ratingType;
	    var ratings = r === 'sp' ? spRatings : r === 'moodys' ? moodysRatings : r === 'fitch' ? fitchRatings : spRatings;
	
	    var err = form.errors && form.errors[field.name];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: labelStyle, className: labelClass },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'select-wrapper' + (err || error ? ' has-error' : '') },
	            _react2.default.createElement(
	                'select',
	                Object.assign({
	                    'data-name': dataName,
	                    className: 'form-control',
	                    id: id,
	                    'aria-label': ariaLabel
	                }, field, err || error ? { "aria-invalid": true } : {}, {
	                    onChange: function onChange(e) {
	                        form.setFieldValue(field.name, e.target.value || '');
	                    }
	                }),
	                ratings.map(function (a, i) {
	                    return _react2.default.createElement(
	                        'option',
	                        {
	                            'data-name': dataName + '-option',
	                            'data-value': a,
	                            key: i },
	                        a
	                    );
	                })
	            ),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	var spRatings = exports.spRatings = ['ALL', 'AAA', 'AA+', 'AA', 'AA-', 'A+', 'A', 'A-', 'BBB+', 'BBB', 'BBB-', 'BB+', 'BB', 'BB-', 'B+', 'B', 'B-', 'CCC+', 'CCC', 'CCC-', 'CC', 'C', 'CI', 'SD', 'D', 'R', 'NM', 'NR', 'None'];
	
	var moodysRatings = exports.moodysRatings = ['ALL', 'Aaa', 'Aa1', 'Aa2', 'Aa3', 'A1', 'A2', 'A3', 'Baa1', 'Baa2', 'Baa3', 'Ba1', 'Ba2', 'Ba3', 'B1', 'B2', 'B3', 'Caa1', 'Caa2', 'Caa3', 'Ca', 'C', 'NR/WR', 'None'];
	
	var fitchRatings = exports.fitchRatings = ['ALL', 'AAA', 'AA+', 'AA', 'AA-', 'A+', 'A', 'A-', 'BBB+', 'BBB', 'BBB-', 'BB+', 'BB', 'BB-', 'B+', 'B', 'B-', 'CCC+', 'CCC', 'CCC-', 'CC', 'C', 'D', 'NR', 'None'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIndexedObject = __webpack_require__(55);
	var toAbsoluteIndex = __webpack_require__(107);
	var lengthOfArrayLike = __webpack_require__(40);
	
	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    if (length === 0) return !IS_INCLUDES && -1;
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var wellKnownSymbol = __webpack_require__(21);
	var V8_VERSION = __webpack_require__(104);
	
	var SPECIES = wellKnownSymbol('species');
	
	module.exports = function (METHOD_NAME) {
	  // We can't use this feature detection in V8 since it causes
	  // deoptimization and serious performance degradation
	  // https://github.com/zloirock/core-js/issues/677
	  return V8_VERSION >= 51 || !fails(function () {
	    var array = [];
	    var constructor = array.constructor = {};
	    constructor[SPECIES] = function () {
	      return { foo: 1 };
	    };
	    return array[METHOD_NAME](Boolean).foo !== 1;
	  });
	};


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var arraySpeciesConstructor = __webpack_require__(1241);
	
	// `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray, length) {
	  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
	};


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(28);
	var ownKeys = __webpack_require__(357);
	var getOwnPropertyDescriptorModule = __webpack_require__(58);
	var definePropertyModule = __webpack_require__(41);
	
	module.exports = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = definePropertyModule.f;
	  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};


/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	module.exports = function (value, done) {
	  return { value: value, done: done };
	};


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(44);
	
	module.exports = function (target, src, options) {
	  for (var key in src) defineBuiltIn(target, key, src[key], options);
	  return target;
	};


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = (function () { /* empty */ }).bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(92);
	var getMethod = __webpack_require__(105);
	var isNullOrUndefined = __webpack_require__(66);
	var Iterators = __webpack_require__(168);
	var wellKnownSymbol = __webpack_require__(21);
	
	var ITERATOR = wellKnownSymbol('iterator');
	
	module.exports = function (it) {
	  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
	    || getMethod(it, '@@iterator')
	    || Iterators[classof(it)];
	};


/***/ },
/* 206 */
168,
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var isCallable = __webpack_require__(22);
	
	var replacement = /#|\.prototype\./;
	
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value === POLYFILL ? true
	    : value === NATIVE ? false
	    : isCallable(detection) ? fails(detection)
	    : !!detection;
	};
	
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	
	module.exports = isForced;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toString = __webpack_require__(17);
	
	module.exports = function (argument, $default) {
	  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
	};


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var internalObjectKeys = __webpack_require__(536);
	var enumBugKeys = __webpack_require__(344);
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	module.exports = Object.keys || function keys(O) {
	  return internalObjectKeys(O, enumBugKeys);
	};


/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (exec) {
	  try {
	    return { error: false, value: exec() };
	  } catch (error) {
	    return { error: true, value: error };
	  }
	};


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var NativePromiseConstructor = __webpack_require__(169);
	var isCallable = __webpack_require__(22);
	var isForced = __webpack_require__(207);
	var inspectSource = __webpack_require__(346);
	var wellKnownSymbol = __webpack_require__(21);
	var IS_BROWSER = __webpack_require__(511);
	var IS_DENO = __webpack_require__(342);
	var IS_PURE = __webpack_require__(48);
	var V8_VERSION = __webpack_require__(104);
	
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	var SPECIES = wellKnownSymbol('species');
	var SUBCLASSING = false;
	var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);
	
	var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
	  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
	  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
	  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	  // We can't detect it synchronously, so just check versions
	  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
	  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
	  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
	  // We can't use @@species feature detection in V8 since it causes
	  // deoptimization and performance degradation
	  // https://github.com/zloirock/core-js/issues/679
	  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
	    // Detect correctness of subclassing with @@species support
	    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
	    var FakePromise = function (exec) {
	      exec(function () { /* empty */ }, function () { /* empty */ });
	    };
	    var constructor = promise.constructor = {};
	    constructor[SPECIES] = FakePromise;
	    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
	    if (!SUBCLASSING) return true;
	  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
	});
	
	module.exports = {
	  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
	  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
	  SUBCLASSING: SUBCLASSING
	};


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var anObject = __webpack_require__(18);
	var isCallable = __webpack_require__(22);
	var classof = __webpack_require__(61);
	var regexpExec = __webpack_require__(358);
	
	var $TypeError = TypeError;
	
	// `RegExpExec` abstract operation
	// https://tc39.es/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (isCallable(exec)) {
	    var result = call(exec, R, S);
	    if (result !== null) anObject(result);
	    return result;
	  }
	  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
	  throw new $TypeError('RegExp#exec called on incompatible receiver');
	};


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var hasOwn = __webpack_require__(28);
	var isPrototypeOf = __webpack_require__(77);
	var regExpFlags = __webpack_require__(359);
	
	var RegExpPrototype = RegExp.prototype;
	
	module.exports = function (R) {
	  var flags = R.flags;
	  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
	    ? call(regExpFlags, R) : flags;
	};


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThisAccessor = __webpack_require__(251);
	var SetHelpers = __webpack_require__(59);
	
	module.exports = uncurryThisAccessor(SetHelpers.proto, 'size', 'get') || function (set) {
	  return set.size;
	};


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var charAt = __webpack_require__(262).charAt;
	var toString = __webpack_require__(17);
	var InternalStateModule = __webpack_require__(52);
	var defineIterator = __webpack_require__(350);
	var createIterResultObject = __webpack_require__(202);
	
	var STRING_ITERATOR = 'String Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
	
	// `String.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
	defineIterator(String, 'String', function (iterated) {
	  setInternalState(this, {
	    type: STRING_ITERATOR,
	    string: toString(iterated),
	    index: 0
	  });
	// `%StringIteratorPrototype%.next` method
	// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
	}, function next() {
	  var state = getInternalState(this);
	  var string = state.string;
	  var index = state.index;
	  var point;
	  if (index >= string.length) return createIterResultObject(undefined, true);
	  point = charAt(string, index);
	  state.index += point.length;
	  return createIterResultObject(point, false);
	});


/***/ },
/* 216 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	function assign(target, object) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	  for (var property in object) {
	    if (Object.prototype.hasOwnProperty.call(object, property)) {
	      ;
	      target[property] = object[property];
	    }
	  }
	  return target;
	}
	module.exports = exports.default;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = __webpack_require__(51);
	function startOfUTCWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	module.exports = exports.default;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMonths;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addMonths
	 * @category Month Helpers
	 * @summary Add the specified number of months to the given date.
	 *
	 * @description
	 * Add the specified number of months to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 months to 1 September 2014:
	 * const result = addMonths(new Date(2014, 8, 1), 5)
	 * //=> Sun Feb 01 2015 00:00:00
	 */
	function addMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var amount = (0, _index.default)(dirtyAmount);
	  if (isNaN(amount)) {
	    return new Date(NaN);
	  }
	  if (!amount) {
	    // If 0 months, no-op to avoid changing times in the hour before end of DST
	    return date;
	  }
	  var dayOfMonth = date.getDate();
	
	  // The JS Date object supports date math by accepting out-of-bounds values for
	  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
	  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
	  // want except that dates will wrap around the end of a month, meaning that
	  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
	  // we'll default to the end of the desired month by adding 1 to the desired
	  // month and using a date of 0 to back up one day to the end of the desired
	  // month.
	  var endOfDesiredMonth = new Date(date.getTime());
	  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
	  var daysInMonth = endOfDesiredMonth.getDate();
	  if (dayOfMonth >= daysInMonth) {
	    // If we're already at the end of the month, then this is the correct date
	    // and we're done.
	    return endOfDesiredMonth;
	  } else {
	    // Otherwise, we now know that setting the original day-of-month value won't
	    // cause an overflow, so set the desired day-of-month. Note that we can't
	    // just set the date of `endOfDesiredMonth` because that object may have had
	    // its time changed in the unusual case where where a DST transition was on
	    // the last day of the month and its local time was in the hour skipped or
	    // repeated next to a DST transition.  So we use `date` instead which is
	    // guaranteed to still have the original time.
	    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
	    return date;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	var _index = _interopRequireDefault(__webpack_require__(128));
	var _index2 = _interopRequireDefault(__webpack_require__(224));
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	var _index4 = _interopRequireDefault(__webpack_require__(1567));
	var _index5 = _interopRequireDefault(__webpack_require__(624));
	var _index6 = _interopRequireDefault(__webpack_require__(109));
	var _index7 = __webpack_require__(628);
	var _index8 = _interopRequireDefault(__webpack_require__(12));
	var _index9 = _interopRequireDefault(__webpack_require__(5));
	var _index10 = __webpack_require__(51);
	var _index11 = _interopRequireDefault(__webpack_require__(177));
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */
	
	function format(dirtyDate, dirtyFormatStr, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var defaultOptions = (0, _index10.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  var originalDate = (0, _index3.default)(dirtyDate);
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index6.default)(originalDate);
	  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index4.default[firstCharacter];
	    if (formatter) {
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matched = input.match(escapedStringRegExp);
	  if (!matched) {
	    return input;
	  }
	  return matched[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameDay;
	var _index = _interopRequireDefault(__webpack_require__(278));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameDay
	 * @category Day Helpers
	 * @summary Are the given dates in the same day (and year and month)?
	 *
	 * @description
	 * Are the given dates in the same day (and year and month)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same day (and year and month)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
	 * //=> true
	 *
	 * @example
	 * // Are 4 September and 4 October in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
	 * //=> false
	 *
	 * @example
	 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
	 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
	 * //=> false
	 */
	function isSameDay(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfDay = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfDay = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(179));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the start of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an ISO week-numbering year for 2 July 2005:
	 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(219));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (trac-9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	
	return camelCase;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(153),
		__webpack_require__(225),
		__webpack_require__(111),
		__webpack_require__(414),
		__webpack_require__(409),
		__webpack_require__(687),
		__webpack_require__(408),
		__webpack_require__(685),
		__webpack_require__(1806),
		__webpack_require__(683),
		__webpack_require__(682),
		__webpack_require__(681),
		__webpack_require__(407),
		__webpack_require__(684),
	
		__webpack_require__(94),
		__webpack_require__(679),
		__webpack_require__(81) // contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, camelCase, nodeName, rcssNum, rnumnonpx,
		rcustomProp, cssExpand, getStyles, swap, curCSS, adjustCSS, addGetHookIf,
		support, finalPropName ) {
	
	"use strict";
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0,
			marginDelta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			// Count margin delta separately to only add it after scroll gutter adjustment.
			// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
			if ( box === "margin" ) {
				marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta + marginDelta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			animationIterationCount: true,
			aspectRatio: true,
			borderImageSlice: true,
			columnCount: true,
			flexGrow: true,
			flexShrink: true,
			fontWeight: true,
			gridArea: true,
			gridColumn: true,
			gridColumnEnd: true,
			gridColumnStart: true,
			gridRow: true,
			gridRowEnd: true,
			gridRowStart: true,
			lineHeight: true,
			opacity: true,
			order: true,
			orphans: true,
			scale: true,
			widows: true,
			zIndex: true,
			zoom: true,
	
			// SVG-related
			fillOpacity: true,
			floodOpacity: true,
			stopOpacity: true,
			strokeMiterlimit: true,
			strokeOpacity: true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (trac-7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug trac-9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (trac-7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
				) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(285),
		__webpack_require__(53),
		__webpack_require__(132),
		__webpack_require__(413),
		__webpack_require__(229),
		__webpack_require__(282),
		__webpack_require__(112),
		__webpack_require__(111),
	
		__webpack_require__(94),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, isFunction, rnothtmlwhite,
		rcheckableType, slice, acceptData, dataPriv, nodeName ) {
	
	"use strict";
	
	var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (trac-13208)
					// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (trac-13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
							return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
							return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", true );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, isSetup ) {
	
		// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
		if ( !isSetup ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					if ( !saved ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						this[ type ]();
						result = dataPriv.get( this, type );
						dataPriv.set( this, type, false );
	
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
	
							return result;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering
					// the native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved ) {
	
					// ...and capture the result
					dataPriv.set( this, type, jQuery.event.trigger(
						saved[ 0 ],
						saved.slice( 1 ),
						this
					) );
	
					// Abort handling of the native event by all jQuery handlers while allowing
					// native handlers on the same element to run. On target, this is achieved
					// by stopping immediate propagation just on the jQuery event. However,
					// the native event is re-wrapped by a jQuery one on each level of the
					// propagation so the only way to stop it for jQuery is to stop it for
					// everyone via native `stopPropagation()`. This is not a problem for
					// focus/blur which don't bubble, but it does also stop click on checkboxes
					// and radios. We accept this limitation.
					event.stopPropagation();
					event.isImmediatePropagationStopped = returnTrue;
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (trac-504, trac-13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
		which: true
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	
		function focusMappedHandler( nativeEvent ) {
			if ( document.documentMode ) {
	
				// Support: IE 11+
				// Attach a single focusin/focusout handler on the document while someone wants
				// focus/blur. This is because the former are synchronous in IE while the latter
				// are async. In other browsers, all those handlers are invoked synchronously.
	
				// `handle` from private data would already wrap the event, but we need
				// to change the `type` here.
				var handle = dataPriv.get( this, "handle" ),
					event = jQuery.event.fix( nativeEvent );
				event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
				event.isSimulated = true;
	
				// First, handle focusin/focusout
				handle( nativeEvent );
	
				// ...then, handle focus/blur
				//
				// focus/blur don't bubble while focusin/focusout do; simulate the former by only
				// invoking the handler at the lower level.
				if ( event.target === event.currentTarget ) {
	
					// The setup part calls `leverageNative`, which, in turn, calls
					// `jQuery.event.add`, so event handle will already have been set
					// by this point.
					handle( event );
				}
			} else {
	
				// For non-IE browsers, attach a single capturing handler on the document
				// while someone wants focusin/focusout.
				jQuery.event.simulate( delegateType, nativeEvent.target,
					jQuery.event.fix( nativeEvent ) );
			}
		}
	
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				var attaches;
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, true );
	
				if ( document.documentMode ) {
	
					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					attaches = dataPriv.get( this, delegateType );
					if ( !attaches ) {
						this.addEventListener( delegateType, focusMappedHandler );
					}
					dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
				} else {
	
					// Return false to allow normal processing in the caller
					return false;
				}
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			teardown: function() {
				var attaches;
	
				if ( document.documentMode ) {
					attaches = dataPriv.get( this, delegateType ) - 1;
					if ( !attaches ) {
						this.removeEventListener( delegateType, focusMappedHandler );
						dataPriv.remove( this, delegateType );
					} else {
						dataPriv.set( this, delegateType, attaches );
					}
				} else {
	
					// Return false to indicate standard teardown should be applied
					return false;
				}
			},
	
			// Suppress native focus or blur if we're currently inside
			// a leveraged native-event stack
			_default: function( event ) {
				return dataPriv.get( event.target, type );
			},
	
			delegateType: delegateType
		};
	
		// Support: Firefox <=44
		// Firefox doesn't have focus(in | out) events
		// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
		//
		// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
		// focus(in | out) events fire after focus & blur events,
		// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
		// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
		//
		// Support: IE 9 - 11+
		// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
		// attach a single handler for both events in IE.
		jQuery.event.special[ delegateType ] = {
			setup: function() {
	
				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType );
	
				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.addEventListener( delegateType, focusMappedHandler );
					} else {
						doc.addEventListener( type, focusMappedHandler, true );
					}
				}
				dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					dataHolder = document.documentMode ? this : doc,
					attaches = dataPriv.get( dataHolder, delegateType ) - 1;
	
				if ( !attaches ) {
					if ( document.documentMode ) {
						this.removeEventListener( delegateType, focusMappedHandler );
					} else {
						doc.removeEventListener( type, focusMappedHandler, true );
					}
					dataPriv.remove( dataHolder, delegateType );
				} else {
					dataPriv.set( dataHolder, delegateType, attaches );
				}
			}
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.slice;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 230 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(716),
	    baseAssignValue = __webpack_require__(420);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ErrorBar =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBar).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: "renderErrorBars",
	    value: function renderErrorBars() {
	      var _this$props = this.props,
	          offset = _this$props.offset,
	          layout = _this$props.layout,
	          width = _this$props.width,
	          dataKey = _this$props.dataKey,
	          data = _this$props.data,
	          dataPointFormatter = _this$props.dataPointFormatter,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis,
	          others = _objectWithoutProperties(_this$props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid, yMid, xMin, yMin, xMax, yMax, scale, coordsTop, coordsMid, coordsBot, lowBound, highBound;
	
	        if (Array.isArray(errorVal)) {
	          var _errorVal = _slicedToArray(errorVal, 2);
	
	          lowBound = _errorVal[0];
	          highBound = _errorVal[1];
	        } else {
	          lowBound = highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = {
	            x1: xMax,
	            y1: yMin,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMin,
	            y1: yMid,
	            x2: xMax,
	            y2: yMid
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMin,
	            y2: yMax
	          };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = {
	            x1: xMin,
	            y1: yMax,
	            x2: xMax,
	            y2: yMax
	          };
	          coordsMid = {
	            x1: xMid,
	            y1: yMin,
	            x2: xMid,
	            y2: yMax
	          };
	          coordsBot = {
	            x1: xMin,
	            y1: yMin,
	            x2: xMax,
	            y2: yMin
	          };
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            className: "recharts-errorBar",
	            key: "bar-".concat(i)
	          }, props), _react["default"].createElement("line", coordsTop), _react["default"].createElement("line", coordsMid), _react["default"].createElement("line", coordsBot))
	        );
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-errorBars"
	      }, this.renderErrorBars());
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component);
	
	ErrorBar.propTypes = {
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  data: _propTypes["default"].array,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  layout: _propTypes["default"].string,
	  dataPointFormatter: _propTypes["default"].func,
	  stroke: _propTypes["default"].string,
	  strokeWidth: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  offset: _propTypes["default"].number
	};
	ErrorBar.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	};
	var _default = ErrorBar;
	exports["default"] = _default;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var propTypes = {
	  width: _propTypes["default"].number.isRequired,
	  height: _propTypes["default"].number.isRequired,
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  className: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
	};
	
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ["children", "width", "height", "viewBox", "className", "style"]);
	
	  var svgView = viewBox || {
	    width: width,
	    height: height,
	    x: 0,
	    y: 0
	  };
	  var layerClass = (0, _classnames["default"])('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	  return _react["default"].createElement("svg", _extends({}, attrs, {
	    className: layerClass,
	    width: width,
	    height: height,
	    style: style,
	    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
	    version: "1.1"
	  }), children);
	}
	
	Surface.propTypes = propTypes;
	var _default = Surface;
	exports["default"] = _default;

/***/ },
/* 234 */
117,
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.textAlignRight = exports.resultListCss = exports.listCss = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n'], ['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    & {\n        display:grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight: 400;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n        color: #242424;\n        /* color: #767676; */\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n        color: #242424;\n    }\n'], ['\n    & {\n        display:grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight: 400;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n        color: #242424;\n        /* color: #767676; */\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n        color: #242424;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ' { text-align: right }\n'], ['\n    ', ' { text-align: right }\n']);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	
	
	var listCss = exports.listCss = (0, _core.css)(_templateObject);
	
	var resultListCss = exports.resultListCss = (0, _core.css)(_templateObject2);
	
	var textAlignRight = exports.textAlignRight = (0, _core.css)(_templateObject3, _twd.mediaQueries.notXs);

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' { text-align: right }\n'], ['\n    ', ' { text-align: right }\n']);
	
	__webpack_require__(1);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        name = _ref.name,
	        rating = _ref.rating,
	        setRating = _ref.setRating,
	        _ref$align = _ref.align,
	        align = _ref$align === undefined ? 'right' : _ref$align;
	
	    var css = align === 'right' ? { css: textAlignRight } : {};
	    return (0, _core.jsx)(
	        'div',
	        css,
	        (0, _core.jsx)(
	            'fieldset',
	            null,
	            (0, _core.jsx)(
	                'div',
	                { className: 'radio radio-inline' },
	                (0, _core.jsx)('input', { type: 'radio',
	                    'data-name': name + '-investment-grade',
	                    id: name + '-investment-grade',
	                    name: name,
	                    checked: rating === 'INVESTMENT_GRADE',
	                    onChange: function onChange() {
	                        return setRating('INVESTMENT_GRADE');
	                    } }),
	                (0, _core.jsx)(
	                    'label',
	                    { htmlFor: name + '-investment-grade' },
	                    'Investment Grade'
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'radio radio-inline' },
	                (0, _core.jsx)('input', { type: 'radio',
	                    'data-name': name + '-high-yield',
	                    id: name + '-high-yield',
	                    name: name,
	                    checked: rating === 'HIGH_YIELD',
	                    onChange: function onChange() {
	                        return setRating('HIGH_YIELD');
	                    } }),
	                (0, _core.jsx)(
	                    'label',
	                    { htmlFor: name + '-high-yield' },
	                    'High Yield'
	                )
	            )
	        )
	    );
	};
	
	var textAlignRight = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _gridRow = __webpack_require__(1089);
	
	var _gridRow2 = _interopRequireDefault(_gridRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        rows = _ref.rows,
	        _ref$dataCategory = _ref.dataCategory,
	        dataCategory = _ref$dataCategory === undefined ? 'quick-ideas' : _ref$dataCategory,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'overview-quick-ideas' : _ref$dataName,
	        _ref$showFrequency = _ref.showFrequency,
	        showFrequency = _ref$showFrequency === undefined ? false : _ref$showFrequency;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-module': 'overview-quick-ideas',
	                    'data-category': dataCategory,
	                    'data-name': dataName + '-table',
	                    className: 'table' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'col-md-6' },
	                            'Issuer'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'col-md-2' },
	                            'Maturity'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { 'whiteSpace': 'nowrap' }, className: 'col-md-1' },
	                            _react2.default.createElement(_twd.Flyout, { label: 'Yield', html: DISCLAIMER })
	                        ),
	                        showFrequency ? _react2.default.createElement(
	                            'th',
	                            { className: 'text-right col-md-2', style: { whiteSpace: 'nowrap' } },
	                            'Coupon Frequency'
	                        ) : _react2.default.createElement(
	                            'th',
	                            { className: 'text-right col-md-2' },
	                            'Moody\'s / S&P'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right col-md-1' },
	                            'Price'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    Array.isArray(rows) && rows.map(function (a, i) {
	                        return _react2.default.createElement(_gridRow2.default, { dataCategory: dataCategory, dataName: dataName, key: i, data: a, index: i, showFrequency: showFrequency });
	                    })
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var DISCLAIMER = '\n    The yield to worst metric is used to evaluate\n    the lowest (worst-case scenario) yield an investor could experience \u2013 with\n    the assumption the issuer does not default. Select your range for yield to worst.\n    ';

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.onViewAll = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _twd.getState)('overview.quick-ideas', {});
	
	exports.default = function (_ref) {
	    var id = _ref.id,
	        url = _ref.url,
	        params = _ref.params,
	        _ref$rowCount = _ref.rowCount,
	        rowCount = _ref$rowCount === undefined ? 1 : _ref$rowCount;
	
	    var hasLast = id in Last.value;
	    var initStatus = hasLast ? _twd.Status.LOADED : _twd.Status.LOADING;
	    var initData = hasLast ? Last.value[id] : [];
	
	    var _React$useState = _react2.default.useState(initStatus),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(initData),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        data = _React$useState4[0],
	        setData = _React$useState4[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        if (status !== _twd.Status.LOADING) return;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref3, _data, abort, a, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _twd.ajax)({
	                                url: url,
	                                method: 'POST',
	                                params: params
	                            });
	
	                        case 3:
	                            _ref3 = _context.sent;
	                            _data = _ref3.data;
	                            abort = _ref3.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 9;
	                            return _data;
	
	                        case 9:
	                            a = _context.sent;
	
	                            lastAbort.current = null;
	
	                            rs = getRows(a, rowCount);
	
	                            Last.set(_defineProperty({}, id, rs));
	                            setData(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 22;
	                            break;
	
	                        case 17:
	                            _context.prev = 17;
	                            _context.t0 = _context['catch'](0);
	
	                            if (!(_context.t0.name === 'AbortError')) {
	                                _context.next = 21;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 21:
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 22:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 17]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) lastAbort.current();
	        };
	    }, [status]);
	
	    return { status: status, Status: _twd.Status, setStatus: setStatus, data: data, onViewAll: onViewAll };
	};
	
	var onViewAll = exports.onViewAll = function onViewAll(_ref4) {
	    var searchParams = _ref4.searchParams;
	
	    if (!searchParams) return;
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: searchParams,
	        _ts: Date.now(),
	        from: 'overview'
	    }));
	};
	
	var getRows = function getRows(_ref5, rowCount) {
	    var _ref5$quickIdeasDto = _ref5.quickIdeasDto,
	        quickIdeasDto = _ref5$quickIdeasDto === undefined ? {} : _ref5$quickIdeasDto;
	
	    var m = Object.values(quickIdeasDto || {})[0];
	    return Object.values(m).filter(Boolean).map(function (v) {
	        return (v.rowsList || v.rows || []).slice(0, rowCount);
	    }).flat().filter(Boolean);
	};

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useTreasuryAuctions = exports.ContextProvider = exports.Context = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define, eqeqeq */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Context = exports.Context = _react2.default.createContext();
	
	var ContextProvider = exports.ContextProvider = function ContextProvider() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        children = _ref.children;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        auctions = _React$useState4[0],
	        setAuctions = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        upcoming = _React$useState6[0],
	        setUpcoming = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState([]),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        schedules = _React$useState8[0],
	        setSchedules = _React$useState8[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref3, auctions_, _auctions, _ref4, upcoming_, _ref5, schedules_;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.next = 4;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/treasuryauctions',
	                                method: 'GET'
	                            });
	
	                        case 4:
	                            _ref3 = _context.sent;
	                            auctions_ = _ref3.data;
	                            _context.next = 8;
	                            return auctions_;
	
	                        case 8:
	                            _auctions = _context.sent;
	
	                            setAuctions(_auctions.map(function (a) {
	                                return Object.assign({}, a, { ctfYield: a.ctfYield === 0 ? null : a.ctfYield });
	                            }));
	
	                            _context.next = 12;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/treasuryauctions/upcoming',
	                                method: 'GET'
	                            });
	
	                        case 12:
	                            _ref4 = _context.sent;
	                            upcoming_ = _ref4.data;
	                            _context.t0 = setUpcoming;
	                            _context.next = 17;
	                            return upcoming_;
	
	                        case 17:
	                            _context.t1 = _context.sent;
	                            (0, _context.t0)(_context.t1);
	                            _context.next = 21;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/treasuryauctions/schedules',
	                                method: 'GET',
	                                type: 'text'
	                            });
	
	                        case 21:
	                            _ref5 = _context.sent;
	                            schedules_ = _ref5.data;
	                            _context.t2 = setSchedules;
	                            _context.t3 = _twd.evalJson;
	                            _context.next = 27;
	                            return schedules_;
	
	                        case 27:
	                            _context.t4 = _context.sent;
	                            _context.t5 = [];
	                            _context.t6 = (0, _context.t3)(_context.t4, _context.t5);
	                            (0, _context.t2)(_context.t6);
	
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 40;
	                            break;
	
	                        case 34:
	                            _context.prev = 34;
	                            _context.t7 = _context['catch'](0);
	
	                            setAuctions([]);
	                            setUpcoming([]);
	                            setSchedules([]);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 40:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 34]]);
	        }))();
	    }, []);
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: {
	                status: status,
	                auctions: auctions,
	                upcoming: upcoming,
	                schedules: schedules
	            } },
	        children
	    );
	};
	
	var useTreasuryAuctions = exports.useTreasuryAuctions = function useTreasuryAuctions() {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChartTable = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(1151);
	
	var _table = __webpack_require__(1153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartTable = exports.ChartTable = function ChartTable(args) {
	
	    return _react2.default.createElement(
	        'figure',
	        null,
	        _react2.default.createElement(
	            'div',
	            { 'aria-hidden': 'true' },
	            _react2.default.createElement(_chart.Chart, args)
	        ),
	        _react2.default.createElement(
	            'figcaption',
	            { className: 'screen-reader-only' },
	            _react2.default.createElement(_table.Table, args)
	        )
	    );
	};

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var charAt = __webpack_require__(262).charAt;
	
	// `AdvanceStringIndex` abstract operation
	// https://tc39.es/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? charAt(S, index).length : 1);
	};


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(15);
	var NATIVE_ARRAY_BUFFER = __webpack_require__(334);
	var FunctionName = __webpack_require__(165);
	var createNonEnumerableProperty = __webpack_require__(65);
	var defineBuiltInAccessor = __webpack_require__(54);
	var defineBuiltIns = __webpack_require__(203);
	var fails = __webpack_require__(7);
	var anInstance = __webpack_require__(98);
	var toIntegerOrInfinity = __webpack_require__(49);
	var toLength = __webpack_require__(80);
	var toIndex = __webpack_require__(368);
	var fround = __webpack_require__(528);
	var IEEE754 = __webpack_require__(1252);
	var getPrototypeOf = __webpack_require__(86);
	var setPrototypeOf = __webpack_require__(100);
	var arrayFill = __webpack_require__(336);
	var arraySlice = __webpack_require__(91);
	var inheritIfRequired = __webpack_require__(143);
	var copyConstructorProperties = __webpack_require__(201);
	var setToStringTag = __webpack_require__(73);
	var InternalStateModule = __webpack_require__(52);
	
	var PROPER_FUNCTION_NAME = FunctionName.PROPER;
	var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length';
	var WRONG_INDEX = 'Wrong index';
	var getInternalArrayBufferState = InternalStateModule.getterFor(ARRAY_BUFFER);
	var getInternalDataViewState = InternalStateModule.getterFor(DATA_VIEW);
	var setInternalState = InternalStateModule.set;
	var NativeArrayBuffer = global[ARRAY_BUFFER];
	var $ArrayBuffer = NativeArrayBuffer;
	var ArrayBufferPrototype = $ArrayBuffer && $ArrayBuffer[PROTOTYPE];
	var $DataView = global[DATA_VIEW];
	var DataViewPrototype = $DataView && $DataView[PROTOTYPE];
	var ObjectPrototype = Object.prototype;
	var Array = global.Array;
	var RangeError = global.RangeError;
	var fill = uncurryThis(arrayFill);
	var reverse = uncurryThis([].reverse);
	
	var packIEEE754 = IEEE754.pack;
	var unpackIEEE754 = IEEE754.unpack;
	
	var packInt8 = function (number) {
	  return [number & 0xFF];
	};
	
	var packInt16 = function (number) {
	  return [number & 0xFF, number >> 8 & 0xFF];
	};
	
	var packInt32 = function (number) {
	  return [number & 0xFF, number >> 8 & 0xFF, number >> 16 & 0xFF, number >> 24 & 0xFF];
	};
	
	var unpackInt32 = function (buffer) {
	  return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
	};
	
	var packFloat32 = function (number) {
	  return packIEEE754(fround(number), 23, 4);
	};
	
	var packFloat64 = function (number) {
	  return packIEEE754(number, 52, 8);
	};
	
	var addGetter = function (Constructor, key, getInternalState) {
	  defineBuiltInAccessor(Constructor[PROTOTYPE], key, {
	    configurable: true,
	    get: function () {
	      return getInternalState(this)[key];
	    }
	  });
	};
	
	var get = function (view, count, index, isLittleEndian) {
	  var store = getInternalDataViewState(view);
	  var intIndex = toIndex(index);
	  var boolIsLittleEndian = !!isLittleEndian;
	  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
	  var bytes = store.bytes;
	  var start = intIndex + store.byteOffset;
	  var pack = arraySlice(bytes, start, start + count);
	  return boolIsLittleEndian ? pack : reverse(pack);
	};
	
	var set = function (view, count, index, conversion, value, isLittleEndian) {
	  var store = getInternalDataViewState(view);
	  var intIndex = toIndex(index);
	  var pack = conversion(+value);
	  var boolIsLittleEndian = !!isLittleEndian;
	  if (intIndex + count > store.byteLength) throw new RangeError(WRONG_INDEX);
	  var bytes = store.bytes;
	  var start = intIndex + store.byteOffset;
	  for (var i = 0; i < count; i++) bytes[start + i] = pack[boolIsLittleEndian ? i : count - i - 1];
	};
	
	if (!NATIVE_ARRAY_BUFFER) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, ArrayBufferPrototype);
	    var byteLength = toIndex(length);
	    setInternalState(this, {
	      type: ARRAY_BUFFER,
	      bytes: fill(Array(byteLength), 0),
	      byteLength: byteLength
	    });
	    if (!DESCRIPTORS) {
	      this.byteLength = byteLength;
	      this.detached = false;
	    }
	  };
	
	  ArrayBufferPrototype = $ArrayBuffer[PROTOTYPE];
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, DataViewPrototype);
	    anInstance(buffer, ArrayBufferPrototype);
	    var bufferState = getInternalArrayBufferState(buffer);
	    var bufferLength = bufferState.byteLength;
	    var offset = toIntegerOrInfinity(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw new RangeError('Wrong offset');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw new RangeError(WRONG_LENGTH);
	    setInternalState(this, {
	      type: DATA_VIEW,
	      buffer: buffer,
	      byteLength: byteLength,
	      byteOffset: offset,
	      bytes: bufferState.bytes
	    });
	    if (!DESCRIPTORS) {
	      this.buffer = buffer;
	      this.byteLength = byteLength;
	      this.byteOffset = offset;
	    }
	  };
	
	  DataViewPrototype = $DataView[PROTOTYPE];
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, 'byteLength', getInternalArrayBufferState);
	    addGetter($DataView, 'buffer', getInternalDataViewState);
	    addGetter($DataView, 'byteLength', getInternalDataViewState);
	    addGetter($DataView, 'byteOffset', getInternalDataViewState);
	  }
	
	  defineBuiltIns(DataViewPrototype, {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : false);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackInt32(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false)) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : false), 23);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : false), 52);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packInt8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packInt8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packInt16, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packInt32, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packFloat32, value, arguments.length > 2 ? arguments[2] : false);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packFloat64, value, arguments.length > 2 ? arguments[2] : false);
	    }
	  });
	} else {
	  var INCORRECT_ARRAY_BUFFER_NAME = PROPER_FUNCTION_NAME && NativeArrayBuffer.name !== ARRAY_BUFFER;
	  /* eslint-disable no-new -- required for testing */
	  if (!fails(function () {
	    NativeArrayBuffer(1);
	  }) || !fails(function () {
	    new NativeArrayBuffer(-1);
	  }) || fails(function () {
	    new NativeArrayBuffer();
	    new NativeArrayBuffer(1.5);
	    new NativeArrayBuffer(NaN);
	    return NativeArrayBuffer.length !== 1 || INCORRECT_ARRAY_BUFFER_NAME && !CONFIGURABLE_FUNCTION_NAME;
	  })) {
	    /* eslint-enable no-new -- required for testing */
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, ArrayBufferPrototype);
	      return inheritIfRequired(new NativeArrayBuffer(toIndex(length)), this, $ArrayBuffer);
	    };
	
	    $ArrayBuffer[PROTOTYPE] = ArrayBufferPrototype;
	
	    ArrayBufferPrototype.constructor = $ArrayBuffer;
	
	    copyConstructorProperties($ArrayBuffer, NativeArrayBuffer);
	  } else if (INCORRECT_ARRAY_BUFFER_NAME && CONFIGURABLE_FUNCTION_NAME) {
	    createNonEnumerableProperty(NativeArrayBuffer, 'name', ARRAY_BUFFER);
	  }
	
	  // WebKit bug - the same parent prototype for typed arrays and data view
	  if (setPrototypeOf && getPrototypeOf(DataViewPrototype) !== ObjectPrototype) {
	    setPrototypeOf(DataViewPrototype, ObjectPrototype);
	  }
	
	  // iOS Safari 7.x bug
	  var testView = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = uncurryThis(DataViewPrototype.setInt8);
	  testView.setInt8(0, 2147483648);
	  testView.setInt8(1, 2147483649);
	  if (testView.getInt8(0) || !testView.getInt8(1)) defineBuiltIns(DataViewPrototype, {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8(this, byteOffset, value << 24 >> 24);
	    }
	  }, { unsafe: true });
	}
	
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	
	module.exports = {
	  ArrayBuffer: $ArrayBuffer,
	  DataView: $DataView
	};


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var lengthOfArrayLike = __webpack_require__(40);
	
	module.exports = function (Constructor, list, $length) {
	  var index = 0;
	  var length = arguments.length > 2 ? $length : lengthOfArrayLike(list);
	  var result = new Constructor(length);
	  while (length > index) result[index] = list[index++];
	  return result;
	};


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(45);
	var IndexedObject = __webpack_require__(166);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	
	// `Array.prototype.{ findLast, findLastIndex }` methods implementation
	var createMethod = function (TYPE) {
	  var IS_FIND_LAST_INDEX = TYPE === 1;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IndexedObject(O);
	    var index = lengthOfArrayLike(self);
	    var boundFunction = bind(callbackfn, that);
	    var value, result;
	    while (index-- > 0) {
	      value = self[index];
	      result = boundFunction(value, index, O);
	      if (result) switch (TYPE) {
	        case 0: return value; // findLast
	        case 1: return index; // findLastIndex
	      }
	    }
	    return IS_FIND_LAST_INDEX ? -1 : undefined;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.findLast` method
	  // https://github.com/tc39/proposal-array-find-from-last
	  findLast: createMethod(0),
	  // `Array.prototype.findLastIndex` method
	  // https://github.com/tc39/proposal-array-find-from-last
	  findLastIndex: createMethod(1)
	};


/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aCallable = __webpack_require__(36);
	var toObject = __webpack_require__(33);
	var IndexedObject = __webpack_require__(166);
	var lengthOfArrayLike = __webpack_require__(40);
	
	var $TypeError = TypeError;
	
	var REDUCE_EMPTY = 'Reduce of empty array with no initial value';
	
	// `Array.prototype.{ reduce, reduceRight }` methods implementation
	var createMethod = function (IS_RIGHT) {
	  return function (that, callbackfn, argumentsLength, memo) {
	    var O = toObject(that);
	    var self = IndexedObject(O);
	    var length = lengthOfArrayLike(O);
	    aCallable(callbackfn);
	    if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
	    var index = IS_RIGHT ? length - 1 : 0;
	    var i = IS_RIGHT ? -1 : 1;
	    if (argumentsLength < 2) while (true) {
	      if (index in self) {
	        memo = self[index];
	        index += i;
	        break;
	      }
	      index += i;
	      if (IS_RIGHT ? index < 0 : length <= index) {
	        throw new $TypeError(REDUCE_EMPTY);
	      }
	    }
	    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
	      memo = callbackfn(memo, self[index], index, O);
	    }
	    return memo;
	  };
	};
	
	module.exports = {
	  // `Array.prototype.reduce` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduce
	  left: createMethod(false),
	  // `Array.prototype.reduceRight` method
	  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
	  right: createMethod(true)
	};


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(21);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var called = 0;
	  var iteratorWithReturn = {
	    next: function () {
	      return { done: !!called++ };
	    },
	    'return': function () {
	      SAFE_CLOSING = true;
	    }
	  };
	  iteratorWithReturn[ITERATOR] = function () {
	    return this;
	  };
	  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
	  Array.from(iteratorWithReturn, function () { throw 2; });
	} catch (error) { /* empty */ }
	
	module.exports = function (exec, SKIP_CLOSING) {
	  try {
	    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
	  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
	  var ITERATION_SUPPORT = false;
	  try {
	    var object = {};
	    object[ITERATOR] = function () {
	      return {
	        next: function () {
	          return { done: ITERATION_SUPPORT = true };
	        }
	      };
	    };
	    exec(object);
	  } catch (error) { /* empty */ }
	  return ITERATION_SUPPORT;
	};


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(8);
	var isForced = __webpack_require__(207);
	var defineBuiltIn = __webpack_require__(44);
	var InternalMetadataModule = __webpack_require__(144);
	var iterate = __webpack_require__(67);
	var anInstance = __webpack_require__(98);
	var isCallable = __webpack_require__(22);
	var isNullOrUndefined = __webpack_require__(66);
	var isObject = __webpack_require__(20);
	var fails = __webpack_require__(7);
	var checkCorrectnessOfIteration = __webpack_require__(246);
	var setToStringTag = __webpack_require__(73);
	var inheritIfRequired = __webpack_require__(143);
	
	module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
	  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
	  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var NativeConstructor = global[CONSTRUCTOR_NAME];
	  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
	  var Constructor = NativeConstructor;
	  var exported = {};
	
	  var fixMethod = function (KEY) {
	    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
	    defineBuiltIn(NativePrototype, KEY,
	      KEY === 'add' ? function add(value) {
	        uncurriedNativeMethod(this, value === 0 ? 0 : value);
	        return this;
	      } : KEY === 'delete' ? function (key) {
	        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : KEY === 'get' ? function get(key) {
	        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : KEY === 'has' ? function has(key) {
	        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
	      } : function set(key, value) {
	        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
	        return this;
	      }
	    );
	  };
	
	  var REPLACE = isForced(
	    CONSTRUCTOR_NAME,
	    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
	      new NativeConstructor().entries().next();
	    }))
	  );
	
	  if (REPLACE) {
	    // create collection constructor
	    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
	    InternalMetadataModule.enable();
	  } else if (isForced(CONSTRUCTOR_NAME, true)) {
	    var instance = new Constructor();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
	    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    // eslint-disable-next-line no-new -- required for testing
	    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new NativeConstructor();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	
	    if (!ACCEPT_ITERABLES) {
	      Constructor = wrapper(function (dummy, iterable) {
	        anInstance(dummy, NativePrototype);
	        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
	        if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	        return that;
	      });
	      Constructor.prototype = NativePrototype;
	      NativePrototype.constructor = Constructor;
	    }
	
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	
	    // weak collections should not contains .clear method
	    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
	  }
	
	  exported[CONSTRUCTOR_NAME] = Constructor;
	  $({ global: true, constructor: true, forced: Constructor !== NativeConstructor }, exported);
	
	  setToStringTag(Constructor, CONSTRUCTOR_NAME);
	
	  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
	
	  return Constructor;
	};


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var tryToString = __webpack_require__(149);
	
	var $TypeError = TypeError;
	
	module.exports = function (O, P) {
	  if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
	};


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var isObject = __webpack_require__(20);
	
	var document = global.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS = isObject(document) && isObject(document.createElement);
	
	module.exports = function (it) {
	  return EXISTS ? document.createElement(it) : {};
	};


/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4` since it's moved to entry points
	__webpack_require__(373);
	var call = __webpack_require__(16);
	var defineBuiltIn = __webpack_require__(44);
	var regexpExec = __webpack_require__(358);
	var fails = __webpack_require__(7);
	var wellKnownSymbol = __webpack_require__(21);
	var createNonEnumerableProperty = __webpack_require__(65);
	
	var SPECIES = wellKnownSymbol('species');
	var RegExpPrototype = RegExp.prototype;
	
	module.exports = function (KEY, exec, FORCED, SHAM) {
	  var SYMBOL = wellKnownSymbol(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegExp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) !== 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	
	    if (KEY === 'split') {
	      // We can't use real regex here since it causes deoptimization
	      // and serious performance degradation in V8
	      // https://github.com/zloirock/core-js/issues/306
	      re = {};
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	      re.flags = '';
	      re[SYMBOL] = /./[SYMBOL];
	    }
	
	    re.exec = function () {
	      execCalled = true;
	      return null;
	    };
	
	    re[SYMBOL]('');
	    return !execCalled;
	  });
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    FORCED
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
	      var $exec = regexp.exec;
	      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
	        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	          // The native String method already delegates to @@method (this
	          // polyfilled function), leasing to infinite recursion.
	          // We avoid it by directly calling the native @@method method.
	          return { done: true, value: call(nativeRegExpMethod, regexp, str, arg2) };
	        }
	        return { done: true, value: call(nativeMethod, str, regexp, arg2) };
	      }
	      return { done: false };
	    });
	
	    defineBuiltIn(String.prototype, KEY, methods[0]);
	    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
	  }
	
	  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
	};


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(36);
	
	module.exports = function (object, key, method) {
	  try {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
	  } catch (error) { /* empty */ }
	};


/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var aCallable = __webpack_require__(36);
	var anObject = __webpack_require__(18);
	var tryToString = __webpack_require__(149);
	var getIteratorMethod = __webpack_require__(205);
	
	var $TypeError = TypeError;
	
	module.exports = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
	  throw new $TypeError(tryToString(argument) + ' is not iterable');
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(20);
	var classof = __webpack_require__(61);
	var wellKnownSymbol = __webpack_require__(21);
	
	var MATCH = wellKnownSymbol('match');
	
	// `IsRegExp` abstract operation
	// https://tc39.es/ecma262/#sec-isregexp
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
	};


/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var anObject = __webpack_require__(18);
	var getMethod = __webpack_require__(105);
	
	module.exports = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);
	  try {
	    innerResult = getMethod(iterator, 'return');
	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }
	    innerResult = call(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }
	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};


/***/ },
/* 255 */
/***/ function(module, exports) {

	'use strict';
	// eslint-disable-next-line es/no-math-expm1 -- safe
	var $expm1 = Math.expm1;
	var exp = Math.exp;
	
	// `Math.expm1` method implementation
	// https://tc39.es/ecma262/#sec-math.expm1
	module.exports = (!$expm1
	  // Old FF bug
	  // eslint-disable-next-line no-loss-of-precision -- required for old engines
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) !== -2e-17
	) ? function expm1(x) {
	  var n = +x;
	  return n === 0 ? n : n > -1e-6 && n < 1e-6 ? n + n * n / 2 : exp(n) - 1;
	} : $expm1;


/***/ },
/* 256 */
/***/ function(module, exports) {

	'use strict';
	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 257 */
/***/ function(module, exports) {

	'use strict';
	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);
	
	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IS_PURE = __webpack_require__(48);
	var global = __webpack_require__(11);
	var fails = __webpack_require__(7);
	var WEBKIT = __webpack_require__(343);
	
	// Forced replacement object prototype accessors methods
	module.exports = IS_PURE || !fails(function () {
	  // This feature detection crashes old WebKit
	  // https://github.com/zloirock/core-js/issues/232
	  if (WEBKIT && WEBKIT < 535) return;
	  var key = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call, es/no-legacy-object-prototype-accessor-methods -- required for testing
	  __defineSetter__.call(null, key, function () { /* empty */ });
	  delete global[key];
	});


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NativePromiseConstructor = __webpack_require__(169);
	var checkCorrectnessOfIteration = __webpack_require__(246);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(211).CONSTRUCTOR;
	
	module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
	  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
	});


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var global = __webpack_require__(11);
	
	// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
	var $RegExp = global.RegExp;
	
	var UNSUPPORTED_Y = fails(function () {
	  var re = $RegExp('a', 'y');
	  re.lastIndex = 2;
	  return re.exec('abcd') !== null;
	});
	
	// UC Browser bug
	// https://github.com/zloirock/core-js/issues/1008
	var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
	  return !$RegExp('a', 'y').sticky;
	});
	
	var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
	  var re = $RegExp('^r', 'gy');
	  re.lastIndex = 2;
	  return re.exec('str') !== null;
	});
	
	module.exports = {
	  BROKEN_CARET: BROKEN_CARET,
	  MISSED_STICKY: MISSED_STICKY,
	  UNSUPPORTED_Y: UNSUPPORTED_Y
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var shared = __webpack_require__(147);
	var uid = __webpack_require__(174);
	
	var keys = shared('keys');
	
	module.exports = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(49);
	var toString = __webpack_require__(17);
	var requireObjectCoercible = __webpack_require__(46);
	
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var stringSlice = uncurryThis(''.slice);
	
	var createMethod = function (CONVERT_TO_STRING) {
	  return function ($this, pos) {
	    var S = toString(requireObjectCoercible($this));
	    var position = toIntegerOrInfinity(pos);
	    var size = S.length;
	    var first, second;
	    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
	    first = charCodeAt(S, position);
	    return first < 0xD800 || first > 0xDBFF || position + 1 === size
	      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
	        ? CONVERT_TO_STRING
	          ? charAt(S, position)
	          : first
	        : CONVERT_TO_STRING
	          ? stringSlice(S, position, position + 2)
	          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
	  };
	};
	
	module.exports = {
	  // `String.prototype.codePointAt` method
	  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
	  codeAt: createMethod(false),
	  // `String.prototype.at` method
	  // https://github.com/mathiasbynens/String.prototype.at
	  charAt: createMethod(true)
	};


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(49);
	var toString = __webpack_require__(17);
	var requireObjectCoercible = __webpack_require__(46);
	
	var $RangeError = RangeError;
	
	// `String.prototype.repeat` method implementation
	// https://tc39.es/ecma262/#sec-string.prototype.repeat
	module.exports = function repeat(count) {
	  var str = toString(requireObjectCoercible(this));
	  var result = '';
	  var n = toIntegerOrInfinity(count);
	  if (n < 0 || n === Infinity) throw new $RangeError('Wrong number of repetitions');
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
	  return result;
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var apply = __webpack_require__(93);
	var bind = __webpack_require__(45);
	var isCallable = __webpack_require__(22);
	var hasOwn = __webpack_require__(28);
	var fails = __webpack_require__(7);
	var html = __webpack_require__(520);
	var arraySlice = __webpack_require__(91);
	var createElement = __webpack_require__(249);
	var validateArgumentsLength = __webpack_require__(87);
	var IS_IOS = __webpack_require__(513);
	var IS_NODE = __webpack_require__(121);
	
	var set = global.setImmediate;
	var clear = global.clearImmediate;
	var process = global.process;
	var Dispatch = global.Dispatch;
	var Function = global.Function;
	var MessageChannel = global.MessageChannel;
	var String = global.String;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var $location, defer, channel, port;
	
	fails(function () {
	  // Deno throws a ReferenceError on `location` access without `--location` flag
	  $location = global.location;
	});
	
	var run = function (id) {
	  if (hasOwn(queue, id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	
	var runner = function (id) {
	  return function () {
	    run(id);
	  };
	};
	
	var eventListener = function (event) {
	  run(event.data);
	};
	
	var globalPostMessageDefer = function (id) {
	  // old engines have not location.origin
	  global.postMessage(String(id), $location.protocol + '//' + $location.host);
	};
	
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!set || !clear) {
	  set = function setImmediate(handler) {
	    validateArgumentsLength(arguments.length, 1);
	    var fn = isCallable(handler) ? handler : Function(handler);
	    var args = arraySlice(arguments, 1);
	    queue[++counter] = function () {
	      apply(fn, undefined, args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clear = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (IS_NODE) {
	    defer = function (id) {
	      process.nextTick(runner(id));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(runner(id));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  // except iOS - https://github.com/zloirock/core-js/issues/624
	  } else if (MessageChannel && !IS_IOS) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = eventListener;
	    defer = bind(port.postMessage, port);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (
	    global.addEventListener &&
	    isCallable(global.postMessage) &&
	    !global.importScripts &&
	    $location && $location.protocol !== 'file:' &&
	    !fails(globalPostMessageDefer)
	  ) {
	    defer = globalPostMessageDefer;
	    global.addEventListener('message', eventListener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in createElement('script')) {
	    defer = function (id) {
	      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(runner(id), 0);
	    };
	  }
	}
	
	module.exports = {
	  set: set,
	  clear: clear
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	// `thisNumberValue` abstract operation
	// https://tc39.es/ecma262/#sec-thisnumbervalue
	module.exports = uncurryThis(1.0.valueOf);


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var isObject = __webpack_require__(20);
	var isSymbol = __webpack_require__(123);
	var getMethod = __webpack_require__(105);
	var ordinaryToPrimitive = __webpack_require__(538);
	var wellKnownSymbol = __webpack_require__(21);
	
	var $TypeError = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	
	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	module.exports = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = call(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw new $TypeError("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var speciesConstructor = __webpack_require__(171);
	
	var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	
	// a part of `TypedArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#typedarray-species-create
	module.exports = function (originalArray) {
	  return aTypedArrayConstructor(speciesConstructor(originalArray, getTypedArrayConstructor(originalArray)));
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var wellKnownSymbol = __webpack_require__(21);
	var DESCRIPTORS = __webpack_require__(15);
	var IS_PURE = __webpack_require__(48);
	
	var ITERATOR = wellKnownSymbol('iterator');
	
	module.exports = !fails(function () {
	  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
	  var url = new URL('b?a=1&b=2&c=3', 'http://a');
	  var params = url.searchParams;
	  var params2 = new URLSearchParams('a=1&a=2&b=3');
	  var result = '';
	  url.pathname = 'c%20d';
	  params.forEach(function (value, key) {
	    params['delete']('b');
	    result += key + value;
	  });
	  params2['delete']('a', 2);
	  // `undefined` case is a Chromium 117 bug
	  // https://bugs.chromium.org/p/v8/issues/detail?id=14222
	  params2['delete']('b', undefined);
	  return (IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')))
	    || (!params.size && (IS_PURE || !DESCRIPTORS))
	    || !params.sort
	    || url.href !== 'http://a/c%20d?a=1&c=3'
	    || params.get('c') !== '3'
	    || String(new URLSearchParams('?a=1')) !== 'a=1'
	    || !params[ITERATOR]
	    // throws in Edge
	    || new URL('https://a@b').username !== 'a'
	    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
	    // not punycoded in Edge
	    || new URL('http://тест').host !== 'xn--e1aybc'
	    // not escaped in Chrome 62-
	    || new URL('http://a#б').hash !== '#%D0%B1'
	    // fails in Chrome 66-
	    || result !== 'a1c3'
	    // throws in Safari
	    || new URL('http://x', undefined).host !== 'x';
	});


/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	// a string of all valid unicode whitespaces
	module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
	  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(369);
	var defineBuiltIn = __webpack_require__(44);
	var toString = __webpack_require__(1256);
	
	// `Object.prototype.toString` method
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	if (!TO_STRING_TAG_SUPPORT) {
	  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
	}


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var DOMIterables = __webpack_require__(508);
	var DOMTokenListPrototype = __webpack_require__(509);
	var ArrayIteratorMethods = __webpack_require__(175);
	var createNonEnumerableProperty = __webpack_require__(65);
	var setToStringTag = __webpack_require__(73);
	var wellKnownSymbol = __webpack_require__(21);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayValues = ArrayIteratorMethods.values;
	
	var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
	  if (CollectionPrototype) {
	    // some Chrome versions have non-configurable methods on DOMTokenList
	    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
	      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
	    } catch (error) {
	      CollectionPrototype[ITERATOR] = ArrayValues;
	    }
	    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
	    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
	      // some Chrome versions have non-configurable methods on DOMTokenList
	      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
	        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
	      } catch (error) {
	        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
	      }
	    }
	  }
	};
	
	for (var COLLECTION_NAME in DOMIterables) {
	  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
	}
	
	handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addWeeks;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(110));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addWeeks
	 * @category Week Helpers
	 * @summary Add the specified number of weeks to the given date.
	 *
	 * @description
	 * Add the specified number of week to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 4 weeks to 1 September 2014:
	 * const result = addWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Sep 29 2014 00:00:00
	 */
	function addWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var days = amount * 7;
	  return (0, _index2.default)(dirtyDate, days);
	}
	module.exports = exports.default;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name differenceInMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the number of milliseconds between the given dates.
	 *
	 * @description
	 * Get the number of milliseconds between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of milliseconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many milliseconds are between
	 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
	 * const result = differenceInMilliseconds(
	 *   new Date(2014, 6, 2, 12, 30, 21, 700),
	 *   new Date(2014, 6, 2, 12, 30, 20, 600)
	 * )
	 * //=> 1100
	 */
	function differenceInMilliseconds(dateLeft, dateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dateLeft).getTime() - (0, _index.default)(dateRight).getTime();
	}
	module.exports = exports.default;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMonths;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(387));
	var _index3 = _interopRequireDefault(__webpack_require__(150));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var _index5 = _interopRequireDefault(__webpack_require__(651));
	/**
	 * @name differenceInMonths
	 * @category Month Helpers
	 * @summary Get the number of full months between the given dates.
	 *
	 * @description
	 * Get the number of full months between the given dates using trunc as a default rounding method.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
	 * //=> 7
	 */
	function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  var result;
	
	  // Check for the difference of less than month
	  if (difference < 1) {
	    result = 0;
	  } else {
	    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
	      // This will check if the date is end of Feb and assign a higher end of month date
	      // to compare it with Jan
	      dateLeft.setDate(30);
	    }
	    dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
	
	    // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
	    // If so, result must be decreased by 1 in absolute value
	    var isLastMonthNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	
	    // Check for cases of one full calendar month
	    if ((0, _index5.default)((0, _index.default)(dirtyDateLeft)) && difference === 1 && (0, _index3.default)(dirtyDateLeft, dateRight) === 1) {
	      isLastMonthNotFull = false;
	    }
	    result = sign * (difference - Number(isLastMonthNotFull));
	  }
	
	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports.default;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInSeconds;
	var _index = _interopRequireDefault(__webpack_require__(273));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = __webpack_require__(178);
	/**
	 * @name differenceInSeconds
	 * @category Second Helpers
	 * @summary Get the number of seconds between the given dates.
	 *
	 * @description
	 * Get the number of seconds between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of seconds
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many seconds are between
	 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
	 * const result = differenceInSeconds(
	 *   new Date(2014, 6, 2, 12, 30, 20, 0),
	 *   new Date(2014, 6, 2, 12, 30, 7, 999)
	 * )
	 * //=> 12
	 */
	function differenceInSeconds(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 1000;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports.default;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDay;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getDay
	 * @category Weekday Helpers
	 * @summary Get the day of the week of the given date.
	 *
	 * @description
	 * Get the day of the week of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the week is 29 February 2012?
	 * const result = getDay(new Date(2012, 1, 29))
	 * //=> 3
	 */
	function getDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day;
	}
	module.exports = exports.default;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWeekend;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isWeekend
	 * @category Weekday Helpers
	 * @summary Does the given date fall on a weekend?
	 *
	 * @description
	 * Does the given date fall on a weekend?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date falls on a weekend
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Does 5 October 2014 fall on a weekend?
	 * const result = isWeekend(new Date(2014, 9, 5))
	 * //=> true
	 */
	function isWeekend(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  return day === 0 || day === 6;
	}
	module.exports = exports.default;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDay;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfDay
	 * @category Day Helpers
	 * @summary Return the start of a day for the given date.
	 *
	 * @description
	 * Return the start of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a day for 2 September 2014 11:55:00:
	 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 00:00:00
	 */
	function startOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfMonth
	 * @category Month Helpers
	 * @summary Return the start of a month for the given date.
	 *
	 * @description
	 * Return the start of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a month for 2 September 2014 11:55:00:
	 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function startOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subDays;
	var _index = _interopRequireDefault(__webpack_require__(110));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name subDays
	 * @category Day Helpers
	 * @summary Subtract the specified number of days from the given date.
	 *
	 * @description
	 * Subtract the specified number of days from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 10 days from 1 September 2014:
	 * const result = subDays(new Date(2014, 8, 1), 10)
	 * //=> Fri Aug 22 2014 00:00:00
	 */
	function subDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(285),
		__webpack_require__(698) // jQuery.contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, documentElement ) {
		"use strict";
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	
		return isAttached;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	/**
	 * Determines whether an object can have data
	 */
	return function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(281),
		__webpack_require__(702),
		__webpack_require__(53),
		__webpack_require__(412),
		__webpack_require__(413),
		__webpack_require__(153),
		__webpack_require__(696),
		__webpack_require__(695),
		__webpack_require__(697),
		__webpack_require__(692),
		__webpack_require__(693),
		__webpack_require__(691),
		__webpack_require__(694),
	
		__webpack_require__(112),
		__webpack_require__(689),
		__webpack_require__(282),
		__webpack_require__(676),
		__webpack_require__(111),
	
		__webpack_require__(94),
		__webpack_require__(182),
		__webpack_require__(81),
		__webpack_require__(227)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isAttached, flat, isFunction, push, rcheckableType,
		access, rtagName, rscriptType,
		wrapMap, getAll, setGlobalEval, buildFragment, support,
		dataPriv, dataUser, acceptData, DOMEval, nodeName ) {
	
	"use strict";
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	
		rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (trac-8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Re-enable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
	
								// Unwrap a CDATA section containing script contents. This shouldn't be
								// needed as in XML documents they're already not visible when
								// inspecting element contents and in HTML documents they have no
								// meaning but we're preserving that logic for backwards compatibility.
								// This will be removed completely in 4.0. See gh-4904.
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew jQuery#find here for performance reasons:
				// https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// [[Class]] -> type pairs
		return {};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(63)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
		"use strict";
	
		return document.documentElement;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(284)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
		"use strict";
	
		return class2type.hasOwnProperty;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.indexOf;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1912),
	    listCacheDelete = __webpack_require__(1913),
	    listCacheGet = __webpack_require__(1914),
	    listCacheHas = __webpack_require__(1915),
	    listCacheSet = __webpack_require__(1916);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(298);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(718),
	    createBaseEach = __webpack_require__(1888);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(158);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(293),
	    toKey = __webpack_require__(184);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(43),
	    isKey = __webpack_require__(429),
	    stringToPath = __webpack_require__(736),
	    toString = __webpack_require__(750);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1910);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1835),
	    Map = __webpack_require__(415),
	    Promise = __webpack_require__(1837),
	    Set = __webpack_require__(709),
	    WeakMap = __webpack_require__(1838),
	    baseGetTag = __webpack_require__(133),
	    toSource = __webpack_require__(737);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(298),
	    isArrayLike = __webpack_require__(157),
	    isIndex = __webpack_require__(428),
	    isObject = __webpack_require__(83);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(156);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 298 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(300);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(133),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(133),
	    isArray = __webpack_require__(43),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 302 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1979);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = void 0;
	
	var _intersection2 = _interopRequireDefault(__webpack_require__(1947));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection2.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	exports.getIntersectionKeys = getIntersectionKeys;
	
	var identity = function identity(param) {
	  return param;
	};
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	
	
	exports.identity = identity;
	
	var getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return "-".concat(v.toLowerCase());
	  });
	};
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	
	
	exports.getDashCase = getDashCase;
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
	    }
	
	    return _objectSpread({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;
	
	var log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	
	
	exports.log = log;
	
	var debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	    return item;
	  };
	};
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	
	
	exports.debug = debug;
	
	var debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(void 0, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
	    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
	    return res;
	  };
	};
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	
	
	exports.debugf = debugf;
	
	var mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	
	
	exports.mapObject = mapObject;
	
	var translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _objectSpread({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	exports.translateStyle = translateStyle;
	
	var compose = function compose() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
	  }).join(',');
	};
	
	exports.getTransitionVal = getTransitionVal;
	var isDev = ("production") !== 'production';
	
	var warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};
	
	exports.warn = warn;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ZAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ZAxis, _PureComponent);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ZAxis).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: "render",
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.PureComponent);
	
	ZAxis.displayName = 'ZAxis';
	ZAxis.propTypes = {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  // The range of axis
	  range: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func])
	};
	ZAxis.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	};
	var _default = ZAxis;
	exports["default"] = _default;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(751));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reactSmooth = __webpack_require__(89);
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _DefaultTooltipContent = _interopRequireDefault(__webpack_require__(2019));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CLS_PREFIX = 'recharts-tooltip-wrapper';
	var EPS = 1;
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.dataKey;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var propTypes = {
	  allowEscapeViewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].bool,
	    y: _propTypes["default"].bool
	  }),
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  active: _propTypes["default"].bool,
	  separator: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  offset: _propTypes["default"].number,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  wrapperStyle: _propTypes["default"].object,
	  contentStyle: _propTypes["default"].object,
	  cursor: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].element, _propTypes["default"].object]),
	  coordinate: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  position: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }),
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  isAnimationActive: _propTypes["default"].bool,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes["default"].func,
	  filterNull: _propTypes["default"].bool,
	  useTranslate3d: _propTypes["default"].bool
	};
	var defaultProps = {
	  active: false,
	  allowEscapeViewBox: {
	    x: false,
	    y: false
	  },
	  offset: 10,
	  viewBox: {
	    x1: 0,
	    x2: 0,
	    y1: 0,
	    y2: 0
	  },
	  coordinate: {
	    x: 0,
	    y: 0
	  },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  filterNull: true,
	  useTranslate3d: false
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultTooltipContent["default"], props);
	};
	
	var Tooltip =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Tooltip, _PureComponent);
	
	  function Tooltip() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	
	    _this.getTranslate = function (_ref) {
	      var key = _ref.key,
	          tooltipDimension = _ref.tooltipDimension,
	          viewBoxDimension = _ref.viewBoxDimension;
	      var _this$props = _this.props,
	          allowEscapeViewBox = _this$props.allowEscapeViewBox,
	          coordinate = _this$props.coordinate,
	          offset = _this$props.offset,
	          position = _this$props.position,
	          viewBox = _this$props.viewBox;
	
	      if (position && (0, _DataUtils.isNumber)(position[key])) {
	        return position[key];
	      }
	
	      var restricted = coordinate[key] - tooltipDimension - offset;
	      var unrestricted = coordinate[key] + offset;
	
	      if (allowEscapeViewBox[key]) {
	        return unrestricted;
	      }
	
	      var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
	      var viewBoxBoundary = viewBox[key] + viewBoxDimension;
	
	      if (tooltipBoundary > viewBoxBoundary) {
	        return Math.max(restricted, viewBox[key]);
	      }
	
	      return Math.max(unrestricted, viewBox[key]);
	    };
	
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          filterNull = _this$props2.filterNull,
	          paylodUniqBy = _this$props2.paylodUniqBy;
	      var finalPayload = getUniqPaylod(paylodUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
	        return !(0, _isNil2["default"])(entry.value);
	      }) : payload);
	      var hasPayload = finalPayload && finalPayload.length;
	      var _this$props3 = this.props,
	          content = _this$props3.content,
	          viewBox = _this$props3.viewBox,
	          coordinate = _this$props3.coordinate,
	          position = _this$props3.position,
	          active = _this$props3.active,
	          wrapperStyle = _this$props3.wrapperStyle;
	
	      var outerStyle = _objectSpread({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	
	      var translateX, translateY;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _this$state2 = this.state,
	            boxWidth = _this$state2.boxWidth,
	            boxHeight = _this$state2.boxHeight;
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = this.getTranslate({
	            key: 'x',
	            tooltipDimension: boxWidth,
	            viewBoxDimension: viewBox.width
	          });
	          translateY = this.getTranslate({
	            key: 'y',
	            tooltipDimension: boxHeight,
	            viewBoxDimension: viewBox.height
	          });
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
	      }), {}, outerStyle);
	
	      if (isAnimationActive && active) {
	        outerStyle = _objectSpread({}, (0, _reactSmooth.translateStyle)({
	          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
	        }), {}, outerStyle);
	      }
	
	      var cls = (0, _classnames["default"])(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, "".concat(CLS_PREFIX, "-right"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-left"), (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-bottom"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-top"), (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY < coordinate.y), _classNames));
	      return _react["default"].createElement("div", {
	        className: cls,
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: finalPayload
	      })));
	    }
	  }]);
	
	  return Tooltip;
	}(_react.PureComponent);
	
	Tooltip.displayName = 'Tooltip';
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	var _default = Tooltip;
	exports["default"] = _default;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _Dot = _interopRequireDefault(__webpack_require__(160));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(309));
	
	var _Text = _interopRequireDefault(__webpack_require__(159));
	
	var _PolarUtils = __webpack_require__(97);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarAngleAxis, _PureComponent);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarAngleAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: "getTickLineCoord",
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          radius = _this$props.radius,
	          orientation = _this$props.orientation,
	          tickLine = _this$props.tickLine;
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	      return {
	        x1: p1.x,
	        y1: p1.y,
	        x2: p2.x,
	        y2: p2.y
	      };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          radius = _this$props2.radius,
	          axisLine = _this$props2.axisLine,
	          axisLineType = _this$props2.axisLineType;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react["default"].createElement(_Dot["default"], _extends({
	          className: "recharts-polar-angle-axis-line"
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	
	      var ticks = this.props.ticks;
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	      return _react["default"].createElement(_Polygon["default"], _extends({
	        className: "recharts-polar-angle-axis-line"
	      }, props, {
	        points: points
	      }));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props3 = this.props,
	          ticks = _this$props3.ticks,
	          tick = _this$props3.tick,
	          tickLine = _this$props3.tickLine,
	          tickFormatter = _this$props3.tickFormatter,
	          stroke = _this$props3.stroke;
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this.getTickLineCoord(entry);
	
	        var textAnchor = _this.getTickTextAnchor(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i,
	          payload: entry,
	          x: lineCoord.x2,
	          y: lineCoord.y2
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-angle-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-polar-angle-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          radius = _this$props4.radius,
	          axisLine = _this$props4.axisLine;
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-angle-axis"
	      }, axisLine && this.renderAxisLine(), this.renderTicks());
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-angle-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.PureComponent);
	
	PolarAngleAxis.displayName = 'PolarAngleAxis';
	PolarAngleAxis.axisType = 'angleAxis';
	PolarAngleAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  hide: _propTypes["default"].bool,
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_ReactUtils.SCALE_TYPES), _propTypes["default"].func]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  axisLineType: _propTypes["default"].oneOf(['polygon', 'circle']),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  stroke: _propTypes["default"].string,
	  orientation: _propTypes["default"].oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes["default"].func,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarAngleAxis.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false,
	  allowDuplicatedCategory: true
	};
	var _default = PolarAngleAxis;
	exports["default"] = _default;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _minBy2 = _interopRequireDefault(__webpack_require__(1954));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(743));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _Text = _interopRequireDefault(__webpack_require__(159));
	
	var _Label = _interopRequireDefault(__webpack_require__(134));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _PolarUtils = __webpack_require__(97);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarRadiusAxis =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarRadiusAxis, _PureComponent);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarRadiusAxis).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: "getTickValueCoord",
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _this$props = this.props,
	          angle = _this$props.angle,
	          cx = _this$props.cx,
	          cy = _this$props.cy;
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	
	        case 'right':
	          textAnchor = 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getViewBox",
	    value: function getViewBox() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          angle = _this$props2.angle,
	          ticks = _this$props2.ticks;
	      var maxRadiusTick = (0, _maxBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy2["default"])(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      return {
	        cx: cx,
	        cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy,
	          angle = _this$props3.angle,
	          ticks = _this$props3.ticks,
	          axisLine = _this$props3.axisLine,
	          others = _objectWithoutProperties(_this$props3, ["cx", "cy", "angle", "ticks", "axisLine"]);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-polar-radius-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	    value: function renderTicks() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          ticks = _this$props4.ticks,
	          tick = _this$props4.tick,
	          angle = _this$props4.angle,
	          tickFormatter = _this$props4.tickFormatter,
	          stroke = _this$props4.stroke,
	          others = _objectWithoutProperties(_this$props4, ["ticks", "tick", "angle", "tickFormatter", "stroke"]);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var items = ticks.map(function (entry, i) {
	        var coord = _this.getTickValueCoord(entry);
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-polar-radius-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          ticks = _this$props5.ticks,
	          axisLine = _this$props5.axisLine,
	          tick = _this$props5.tick;
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-polar-radius-axis"
	      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), _Label["default"].renderCallByParent(this.props, this.getViewBox()));
	    }
	  }], [{
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-polar-radius-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.PureComponent);
	
	PolarRadiusAxis.displayName = 'PolarRadiusAxis';
	PolarRadiusAxis.axisType = 'radiusAxis';
	PolarRadiusAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes["default"].oneOf(['number', 'category']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  angle: _propTypes["default"].number,
	  tickCount: _propTypes["default"].number,
	  ticks: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    coordinate: _propTypes["default"].number
	  })),
	  orientation: _propTypes["default"].oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  domain: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes["default"].func]),
	  allowDataOverflow: _propTypes["default"].bool,
	  allowDuplicatedCategory: _propTypes["default"].bool
	});
	PolarRadiusAxis.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto',
	  allowDuplicatedCategory: true
	};
	var _default = PolarRadiusAxis;
	exports["default"] = _default;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Polygon, _PureComponent);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          points = _this$props.points,
	          className = _this$props.className;
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-polygon', className);
	      return _react["default"].createElement("polygon", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.PureComponent);
	
	Polygon.displayName = 'Polygon';
	Polygon.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number
	  }))
	});
	var _default = Polygon;
	exports["default"] = _default;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _PolarUtils = __webpack_require__(97);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius,
	      cornerIsExternal = _ref.cornerIsExternal;
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	
	  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle
	
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line
	
	  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), lineTangencyAngle);
	  return {
	    center: center,
	    circleTangency: circleTangency,
	    lineTangency: lineTangency,
	    theta: theta
	  };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide
	
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
	  } else {
	    path += "L ".concat(cx, ",").concat(cy, " Z");
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      forceCornerRadius = _ref3.forceCornerRadius,
	      cornerIsExternal = _ref3.cornerIsExternal,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: startAngle,
	    sign: sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx,
	    cy: cy,
	    radius: outerRadius,
	    angle: endAngle,
	    sign: -sign,
	    cornerRadius: cornerRadius,
	    cornerIsExternal: cornerIsExternal
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    if (forceCornerRadius) {
	      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
	    }
	
	    return getSectorPath({
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    });
	  }
	
	  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: startAngle,
	      sign: sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx,
	      cy: cy,
	      radius: innerRadius,
	      angle: endAngle,
	      sign: -sign,
	      isExternal: true,
	      cornerRadius: cornerRadius,
	      cornerIsExternal: cornerIsExternal
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
	    }
	
	    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
	  } else {
	    path += "L".concat(cx, ",").concat(cy, "Z");
	  }
	
	  return path;
	};
	
	var Sector =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sector, _PureComponent);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          innerRadius = _this$props.innerRadius,
	          outerRadius = _this$props.outerRadius,
	          cornerRadius = _this$props.cornerRadius,
	          forceCornerRadius = _this$props.forceCornerRadius,
	          cornerIsExternal = _this$props.cornerIsExternal,
	          startAngle = _this$props.startAngle,
	          endAngle = _this$props.endAngle,
	          className = _this$props.className;
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          forceCornerRadius: forceCornerRadius,
	          cornerIsExternal: cornerIsExternal,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: startAngle,
	          endAngle: endAngle
	        });
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.PureComponent);
	
	Sector.displayName = 'Sector';
	Sector.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool
	});
	Sector.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0,
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	var _default = Sector;
	exports["default"] = _default;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = void 0;
	
	var _ReactUtils = __webpack_require__(19);
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return "".concat(value, "px");
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	  return formatStrs.join('');
	}
	
	var getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
	  }, '');
	};
	
	exports.getStyleString = getStyleString;
	
	var getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	
	  var str = "".concat(text);
	  var styleString = getStyleString(style);
	  var cacheKey = "".concat(str, "-").concat(styleString);
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
	    // https://en.wikipedia.org/wiki/Content_Security_Policy
	
	
	    var measurementSpanStyle = _objectSpread({}, SPAN_STYLE, {}, style);
	
	    Object.keys(measurementSpanStyle).map(function (styleKey) {
	      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
	      return styleKey;
	    });
	    measurementSpan.textContent = str;
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = {
	      width: rect.width,
	      height: rect.height
	    };
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	};
	
	exports.getStringSize = getStringSize;
	
	var getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = {
	    top: 0,
	    left: 0
	  }; // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	
	
	exports.getOffset = getOffset;
	
	var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};
	
	exports.calculateChartCoordinate = calculateChartCoordinate;

/***/ },
/* 312 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ifOverflowMatches = void 0;
	
	var ifOverflowMatches = function ifOverflowMatches(props, value) {
	  var alwaysShow = props.alwaysShow;
	  var ifOverflow = props.ifOverflow;
	
	  if (alwaysShow) {
	    ifOverflow = 'extendDomain';
	  }
	
	  return ifOverflow === value;
	};
	
	exports.ifOverflowMatches = ifOverflowMatches;

/***/ },
/* 313 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hashString = _interopDefault(__webpack_require__(783));
	var unitless = _interopDefault(__webpack_require__(786));
	var memoize = _interopDefault(__webpack_require__(784));
	
	var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
	var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
	var hyphenateRegex = /[A-Z]|^ms/g;
	var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
	
	var isCustomProperty = function isCustomProperty(property) {
	  return property.charCodeAt(1) === 45;
	};
	
	var isProcessableValue = function isProcessableValue(value) {
	  return value != null && typeof value !== 'boolean';
	};
	
	var processStyleName = memoize(function (styleName) {
	  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
	});
	
	var processStyleValue = function processStyleValue(key, value) {
	  switch (key) {
	    case 'animation':
	    case 'animationName':
	      {
	        if (typeof value === 'string') {
	          return value.replace(animationRegex, function (match, p1, p2) {
	            cursor = {
	              name: p1,
	              styles: p2,
	              next: cursor
	            };
	            return p1;
	          });
	        }
	      }
	  }
	
	  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
	    return value + 'px';
	  }
	
	  return value;
	};
	
	if (false) {
	  var contentValuePattern = /(attr|calc|counters?|url)\(/;
	  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
	  var oldProcessStyleValue = processStyleValue;
	  var msPattern = /^-ms-/;
	  var hyphenPattern = /-(.)/g;
	  var hyphenatedCache = {};
	
	  processStyleValue = function processStyleValue(key, value) {
	    if (key === 'content') {
	      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
	        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
	      }
	    }
	
	    var processed = oldProcessStyleValue(key, value);
	
	    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
	      hyphenatedCache[key] = true;
	      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
	        return _char.toUpperCase();
	      }) + "?");
	    }
	
	    return processed;
	  };
	}
	
	var shouldWarnAboutInterpolatingClassNameFromCss = true;
	
	function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
	  if (interpolation == null) {
	    return '';
	  }
	
	  if (interpolation.__emotion_styles !== undefined) {
	    if (false) {
	      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	    }
	
	    return interpolation;
	  }
	
	  switch (typeof interpolation) {
	    case 'boolean':
	      {
	        return '';
	      }
	
	    case 'object':
	      {
	        if (interpolation.anim === 1) {
	          cursor = {
	            name: interpolation.name,
	            styles: interpolation.styles,
	            next: cursor
	          };
	          return interpolation.name;
	        }
	
	        if (interpolation.styles !== undefined) {
	          var next = interpolation.next;
	
	          if (next !== undefined) {
	            // not the most efficient thing ever but this is a pretty rare case
	            // and there will be very few iterations of this generally
	            while (next !== undefined) {
	              cursor = {
	                name: next.name,
	                styles: next.styles,
	                next: cursor
	              };
	              next = next.next;
	            }
	          }
	
	          var styles = interpolation.styles + ";";
	
	          if (false) {
	            styles += interpolation.map;
	          }
	
	          return styles;
	        }
	
	        return createStringFromObject(mergedProps, registered, interpolation);
	      }
	
	    case 'function':
	      {
	        if (mergedProps !== undefined) {
	          var previousCursor = cursor;
	          var result = interpolation(mergedProps);
	          cursor = previousCursor;
	          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
	        } else if (false) {
	          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
	        }
	
	        break;
	      }
	
	    case 'string':
	      if (false) {
	        var matched = [];
	        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
	          var fakeVarName = "animation" + matched.length;
	          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
	          return "${" + fakeVarName + "}";
	        });
	
	        if (matched.length) {
	          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
	        }
	      }
	
	      break;
	  } // finalize string values (regular strings and functions interpolated into css calls)
	
	
	  if (registered == null) {
	    return interpolation;
	  }
	
	  var cached = registered[interpolation];
	
	  if (false) {
	    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
	    shouldWarnAboutInterpolatingClassNameFromCss = false;
	  }
	
	  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
	}
	
	function createStringFromObject(mergedProps, registered, obj) {
	  var string = '';
	
	  if (Array.isArray(obj)) {
	    for (var i = 0; i < obj.length; i++) {
	      string += handleInterpolation(mergedProps, registered, obj[i], false);
	    }
	  } else {
	    for (var _key in obj) {
	      var value = obj[_key];
	
	      if (typeof value !== 'object') {
	        if (registered != null && registered[value] !== undefined) {
	          string += _key + "{" + registered[value] + "}";
	        } else if (isProcessableValue(value)) {
	          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
	        }
	      } else {
	        if (_key === 'NO_COMPONENT_SELECTOR' && ("production") !== 'production') {
	          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
	        }
	
	        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
	          for (var _i = 0; _i < value.length; _i++) {
	            if (isProcessableValue(value[_i])) {
	              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
	            }
	          }
	        } else {
	          var interpolated = handleInterpolation(mergedProps, registered, value, false);
	
	          switch (_key) {
	            case 'animation':
	            case 'animationName':
	              {
	                string += processStyleName(_key) + ":" + interpolated + ";";
	                break;
	              }
	
	            default:
	              {
	                if (false) {
	                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
	                }
	
	                string += _key + "{" + interpolated + "}";
	              }
	          }
	        }
	      }
	    }
	  }
	
	  return string;
	}
	
	var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
	var sourceMapPattern;
	
	if (false) {
	  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
	} // this is the cursor for keyframes
	// keyframes are stored on the SerializedStyles object as a linked list
	
	
	var cursor;
	var serializeStyles = function serializeStyles(args, registered, mergedProps) {
	  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
	    return args[0];
	  }
	
	  var stringMode = true;
	  var styles = '';
	  cursor = undefined;
	  var strings = args[0];
	
	  if (strings == null || strings.raw === undefined) {
	    stringMode = false;
	    styles += handleInterpolation(mergedProps, registered, strings, false);
	  } else {
	    if (false) {
	      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	    }
	
	    styles += strings[0];
	  } // we start at 1 since we've already handled the first arg
	
	
	  for (var i = 1; i < args.length; i++) {
	    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
	
	    if (stringMode) {
	      if (false) {
	        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
	      }
	
	      styles += strings[i];
	    }
	  }
	
	  var sourceMap;
	
	  if (false) {
	    styles = styles.replace(sourceMapPattern, function (match) {
	      sourceMap = match;
	      return '';
	    });
	  } // using a global regex with .exec is stateful so lastIndex has to be reset each time
	
	
	  labelPattern.lastIndex = 0;
	  var identifierName = '';
	  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
	
	  while ((match = labelPattern.exec(styles)) !== null) {
	    identifierName += '-' + // $FlowFixMe we know it's not null
	    match[1];
	  }
	
	  var name = hashString(styles) + identifierName;
	
	  if (false) {
	    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
	    return {
	      name: name,
	      styles: styles,
	      map: sourceMap,
	      next: cursor,
	      toString: function toString() {
	        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
	      }
	    };
	  }
	
	  return {
	    name: name,
	    styles: styles,
	    next: cursor
	  };
	};
	
	exports.serializeStyles = serializeStyles;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initialValues = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	var _formFieldArrays = __webpack_require__(460);
	
	var _twd = __webpack_require__(2);
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$searchParams = _ref.searchParams,
	        searchParams = _ref$searchParams === undefined ? {} : _ref$searchParams,
	        invType = _ref.invType;
	
	    if (invType && !searchParams.holdInvType) {
	        searchParams.holdInvType = [invType];
	    }
	
	    var defaultState = (0, _twd.getConfig)('account_states.0.stateOfResidence', '');
	    var values = Object.assign({
	        muniStates: defaultState && !searchParams.holdState ? ['holdState=' + defaultState] : [],
	        cdBlueSky: defaultState && !searchParams.holdBlueSkyStateCD ? ['holdBlueSkyStateCD=' + defaultState] : []
	    }, initialValues, searchParams);
	
	    values.holdInvType = (0, _twd.arrayFrom)(values.holdInvType).filter(function (a) {
	        return validInvTypes.indexOf(a) >= 0;
	    });
	
	    values.issuer = (0, _twd.arrayFrom)(values.holdIssue).map(function (a) {
	        return a.trim();
	    }).filter(Boolean).join();
	    values.cusip = (0, _twd.arrayFrom)(values.holdCusip).map(function (a) {
	        return a.trim();
	    }).filter(Boolean).join();
	
	    values.holdSymbol = (0, _twd.arrayFrom)(values.holdSymbol)[0] || '';
	
	    var holdInvType = values.holdInvType[0];
	    if (holdInvType === 'C' && values.isEdit) {
	        delete values.corpMarketTypes;
	    }
	
	    values.holdRatingAndOr = values.holdRatingAndOr !== 'AND';
	
	    for (var k in _formFieldArrays.FormFieldArrays) {
	        var arr = _formFieldArrays.FormFieldArrays[k].map(function (a) {
	            return a.value;
	        }).filter(function (a) {
	            return hasParam(searchParams, a);
	        });
	        if (!(0, _twd.isEmpty)(arr)) {
	            values[k] = arr;
	        }
	    }
	
	    _formFieldArrays.SearchParamArrays.forEach(function (k) {
	        delete values[k];
	    });
	
	    if (holdInvType !== 'C') {
	        values.corpMarketTypes = ['primarySecondary=secondary'];
	    }
	    if (holdInvType !== 'S') {
	        values.cdMarketTypes = ['primarySecondary=primary'];
	    }
	
	    if (searchParams.sort) {
	        var a = (0, _twd.arrayFrom)(searchParams.sort)[0] || {};
	        values.sortBy = a.field || 'holdMaturitySortDt';
	        values.sortOrder = SORT_ORDERS[a.direction] || 'Ascending';
	    }
	
	    if (searchParams.offeringNewToday) {
	        values.offeringPosted = 'New Today';
	    }
	
	    delete values.isEdit;
	
	    return (0, _twd.cleanObject)(values);
	};
	
	var hasParam = function hasParam(searchParams, s) {
	    var _s$split = s.split('='),
	        _s$split2 = _slicedToArray(_s$split, 2),
	        k = _s$split2[0],
	        v = _s$split2[1];
	
	    var arr = searchParams[k];
	    return arr && Array.isArray(arr) && arr.indexOf(v) >= 0;
	};
	
	var SORT_ORDERS = {
	    'ASC': 'Ascending',
	    'DESC': 'Descending'
	};
	
	var validInvTypes = ['C', 'M', 'S', 'T', 'A'];
	
	var initialValues = exports.initialValues = {
	    holdInvType: ['C'],
	    issuer: '',
	    cusip: '',
	    corpMarketTypes: ['primarySecondary=secondary'],
	    cdMarketTypes: ['primarySecondary=primary'],
	
	    offeringPosted: 'Any Time',
	    sortBy: 'holdMaturitySortDt',
	    sortOrder: 'Ascending',
	    resultsPerPage: 50,
	
	    holdSpRatingMin: 'BBB-',
	    holdSpRatingMax: 'AAA',
	    holdMoodyRatingMin: 'Baa3',
	    holdMoodyRatingMax: 'Aaa',
	    rating: 'investment-grade',
	    holdRatingAndOr: 'OR',
	
	    holdMaturityMin: '',
	    holdMaturityMax: '',
	    clientPriceMin: '',
	    clientPriceMax: '',
	    quantityMin: '',
	    quantityMax: '',
	    offerYtwMin: '',
	    offerYtwMax: '',
	    offerYtmMin: '',
	    offerYtmMax: '',
	    holdCouponMin: '',
	    holdCouponMax: '',
	    holdFirstCallMin: '',
	    holdFirstCallMax: ''
	};

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.INV_TYPE_LABELS = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _header = __webpack_require__(822);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _bondFeatures = __webpack_require__(811);
	
	var _bondFeatures2 = _interopRequireDefault(_bondFeatures);
	
	var _originalIssuance = __webpack_require__(828);
	
	var _originalIssuance2 = _interopRequireDefault(_originalIssuance);
	
	var _importantDocuments = __webpack_require__(823);
	
	var _importantDocuments2 = _interopRequireDefault(_importantDocuments);
	
	var _creditRatings = __webpack_require__(813);
	
	var _creditRatings2 = _interopRequireDefault(_creditRatings);
	
	var _couponFeatures = __webpack_require__(812);
	
	var _couponFeatures2 = _interopRequireDefault(_couponFeatures);
	
	var _redemptionFeatures = __webpack_require__(829);
	
	var _redemptionFeatures2 = _interopRequireDefault(_redemptionFeatures);
	
	var _referenceInformation = __webpack_require__(830);
	
	var _referenceInformation2 = _interopRequireDefault(_referenceInformation);
	
	var _bestOffering = __webpack_require__(810);
	
	var _bestOffering2 = _interopRequireDefault(_bestOffering);
	
	var _mbsSpeed = __webpack_require__(825);
	
	var _mbsSpeed2 = _interopRequireDefault(_mbsSpeed);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	__webpack_require__(1775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref.cusip,
	        _ref$from = _ref.from,
	        from = _ref$from === undefined ? '' : _ref$from;
	
	    if (cusip) {
	        location.hash = 'bond-detail.' + cusip;
	    }
	
	    return _react2.default.createElement(
	        _useBondDetail2.ContextProvider,
	        { cusip: cusip },
	        _react2.default.createElement(
	            'div',
	            { className: 'bond-detail' },
	            _react2.default.createElement(
	                'div',
	                { style: { background: "#ffffff" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    from && from !== 'bond-detail' && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'nav',
	                            { 'aria-label': 'breadcrumb' },
	                            _react2.default.createElement(
	                                'ol',
	                                { className: 'breadcrumb', style: { margin: 0, padding: 0, backgroundColor: '#fff' } },
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'breadcrumb-item', style: { margin: 0, padding: 0 } },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: '#',
	                                            className: 'link-button',
	                                            onClick: function onClick() {
	                                                var u = (0, _twd.safeURL)(from);
	                                                if (u) {
	                                                    (0, _twd.openWindow)(u.toString());
	                                                    return;
	                                                }
	
	                                                (0, _twd.viewBack)();
	                                            } },
	                                        _react2.default.createElement(
	                                            'i',
	                                            {
	                                                style: { color: 'var(--primary-base-color)', fontSize: '13px', width: '10px' },
	                                                className: 'material-icons',
	                                                'aria-hidden': 'true'
	                                            },
	                                            'navigate_before'
	                                        ),
	                                        'Back'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'breadcrumb-item active', style: { margin: 0, padding: 0 } },
	                                    _react2.default.createElement(
	                                        'span',
	                                        { style: { fontWeight: '500', color: '#242424' }, 'aria-current': 'page' },
	                                        'Bond detail'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(Content, null),
	            _react2.default.createElement('div', { className: 'row vertical-offset-lg' })
	        )
	    );
	};
	
	var Content = function Content() {
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        cusip = _useBondDetail.cusip,
	        status = _useBondDetail.status;
	
	    if (status === 'Not Found') {
	        return _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-lg' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-muted text-center' },
	                    _twd.NO_RESULT_ICON,
	                    _react2.default.createElement('br', null),
	                    'Bond detail for ',
	                    cusip,
	                    ' is not found.'
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { background: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	                _react2.default.createElement(_header2.default, null)
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container section-container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-4' },
	                        _react2.default.createElement(_bondFeatures2.default, null),
	                        _react2.default.createElement(_referenceInformation2.default, null),
	                        _react2.default.createElement(_originalIssuance2.default, null),
	                        _react2.default.createElement(_mbsSpeed2.default, null),
	                        _react2.default.createElement(_importantDocuments2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-4' },
	                        _react2.default.createElement(_creditRatings2.default, null),
	                        _react2.default.createElement(_couponFeatures2.default, null),
	                        _react2.default.createElement(_redemptionFeatures2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-4' },
	                        _react2.default.createElement(_bestOffering2.default, null)
	                    )
	                )
	            )
	        )
	    );
	};
	
	var INV_TYPE_LABELS = exports.INV_TYPE_LABELS = {
	    'A': 'Agency',
	    'R': 'Pass-Through',
	    'K': 'Asset-Backed',
	    'S': 'CD',
	    'O': 'CMO',
	    'C': 'Corporate',
	    'M': 'Municipal',
	    'P': 'Preferred',
	    'L': 'Structured',
	    'T': 'Treasury'
	};

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAuth = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	(0, _twd.getState)('corporates.market-news.use-bitvore', {
	    token: '',
	    expired: 0
	});
	
	var getAuth = exports.getAuth = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var state, _state$value, token, expired, now, _ajax, data, a;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        state = (0, _twd.getState)('corporates.market-news.use-bitvore');
	                        _state$value = state.value, token = _state$value.token, expired = _state$value.expired;
	                        now = Date.now();
	
	                        if (!(token && expired > now)) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return', { Authorization: 'Bearer ' + token });
	
	                    case 6:
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/retailservice/bitvoreNewsAPIService/getAccessTokenByAPIType',
	                            method: 'POST',
	                            params: { bondType: 'CORP' }
	                        }), data = _ajax.data;
	                        _context.next = 9;
	                        return data;
	
	                    case 9:
	                        a = _context.sent;
	
	                        if (a.access_token) {
	                            _context.next = 12;
	                            break;
	                        }
	
	                        throw new Error('no access token');
	
	                    case 12:
	
	                        state.set({
	                            token: a.access_token,
	                            expired: now + a.expires_in * 1000
	                        });
	
	                        (0, _twd.publish)('corporates-market-news-unavailable', false);
	
	                        return _context.abrupt('return', { Authorization: 'Bearer ' + state.value.token });
	
	                    case 17:
	                        _context.prev = 17;
	                        _context.t0 = _context['catch'](0);
	
	                        (0, _twd.publish)('corporates-market-news-unavailable', true);
	
	                    case 20:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[0, 17]]);
	    }));
	
	    return function getAuth() {
	        return _ref.apply(this, arguments);
	    };
	}();

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toSearchParams = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _twd = __webpack_require__(2);
	
	var toSearchParams = exports.toSearchParams = function toSearchParams(values) {
	    var p = Object.assign({
	        holdUnderlyingRating: 'NO',
	        offeringType: ['ask-side']
	    }, values);
	
	    p.ytwMin = p.offerYtwMin;
	    p.ytwMax = p.offerYtwMax;
	
	    delete p.holdCorpSectorCode;
	    delete p.holdCorpType;
	
	    (0, _twd.arrayFrom)(p.sectors).forEach(function (s) {
	        var _s$split = s.split('='),
	            _s$split2 = _slicedToArray(_s$split, 2),
	            k = _s$split2[0],
	            v = _s$split2[1];
	
	        if (!p[k]) p[k] = [];
	
	        var arr = p[k];
	        var i = arr.indexOf(v);
	        if (i < 0) arr.push(v);
	    });
	    delete p.sectors;
	
	    if (p.holdCallableInd) {
	        p.holdCallableInd = ['N'];
	        p.holdCallFeatures = ['holdCallableInd-N'];
	    } else {
	        delete p.holdCallableInd;
	    }
	
	    if (['AND', 'OR'].indexOf(p.holdRatingAndOr) < 0) {
	        p.holdRatingAndOr = p.holdRatingAndOr === true ? 'OR' : 'AND';
	    }
	
	    p.holdMaturityMin = (0, _twd.formatDate)(p.holdMaturityMin);
	    p.holdMaturityMax = (0, _twd.formatDate)(p.holdMaturityMax, true);
	
	    return (0, _twd.cleanObject)(p);
	};

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useQuickScreener = exports.ContextProvider = exports.initialValues = exports.Context = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(137);
	
	var _validate = __webpack_require__(888);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _submit = __webpack_require__(887);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Context = exports.Context = _react2.default.createContext();
	var initialValues = exports.initialValues = {
	    holdInvType: ['C'],
	    holdMaturityMin: '',
	    holdMaturityMax: '',
	    quantityMin: '',
	    quantityMax: '',
	    offerYtwMin: '',
	    offerYtwMax: '',
	    clientPriceMin: '',
	    clientPriceMax: '',
	    holdSpRatingMin: 'BBB-',
	    holdSpRatingMax: 'AAA',
	    holdMoodyRatingMin: 'Baa3',
	    holdMoodyRatingMax: 'Aaa',
	    holdRatingAndOr: 'OR',
	    rating: 'investment-grade',
	    holdCorpSectorCode: [],
	    sectors: []
	};
	
	var state = (0, _twd.getState)('corporates.quick-screener', {
	    currentValues: initialValues
	});
	
	var onValidate = function onValidate(values) {
	    var err = (0, _validate2.default)(values);
	    state.set({
	        currentValues: values,
	        errors: err
	    });
	    return err;
	};
	
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var children = _ref.children;
	
	    var _useAppContext = (0, _App.useAppContext)(),
	        ajax = _useAppContext.ajax,
	        Status = _useAppContext.Status;
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: {
	                state: state, ajax: ajax, Status: Status, onValidate: onValidate, onSubmit: _submit2.default
	            } },
	        children
	    );
	};
	
	var useQuickScreener = exports.useQuickScreener = function useQuickScreener() {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toSearchParams = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _twd = __webpack_require__(2);
	
	var toSearchParams = exports.toSearchParams = function toSearchParams(values) {
	    var p = Object.assign({
	        holdUnderlyingRating: 'NO',
	        offeringType: ['ask-side']
	    }, values);
	
	    p.ytwMin = p.offerYtwMin;
	    p.ytwMax = p.offerYtwMax;
	
	    delete p.holdCorpSectorCode;
	    delete p.holdCorpType;
	
	    (0, _twd.arrayFrom)(p.states).concat((0, _twd.arrayFrom)(p.purposes)).forEach(function (s) {
	        var _s$split = s.split('='),
	            _s$split2 = _slicedToArray(_s$split, 2),
	            k = _s$split2[0],
	            v = _s$split2[1];
	
	        if (!p[k]) p[k] = [];
	
	        var arr = p[k];
	        var i = arr.indexOf(v);
	        if (i < 0) arr.push(v);
	    });
	    delete p.states;
	    delete p.purposes;
	
	    p.holdMuniType = [];
	    if (p.holdMuniTypeG) p.holdMuniType.push('G');
	    if (p.holdMuniTypeR) p.holdMuniType.push('R');
	
	    p.holdTaxable = [];
	    if (p.holdTaxableY) p.holdTaxable.push('Y');
	    if (p.holdTaxableN) p.holdTaxable.push('N');
	
	    if (p.holdCallableInd) {
	        p.holdCallableInd = ['N'];
	        p.holdCallFeatures = ['holdCallableInd-N'];
	    } else {
	        delete p.holdCallableInd;
	    }
	
	    if (['AND', 'OR'].indexOf(p.holdRatingAndOr) < 0) {
	        p.holdRatingAndOr = p.holdRatingAndOr === true ? 'OR' : 'AND';
	    }
	
	    delete p.holdMuniTypeG;
	    delete p.holdMuniTypeR;
	    delete p.holdTaxableY;
	    delete p.holdTaxableN;
	
	    p.holdMaturityMin = (0, _twd.formatDate)(p.holdMaturityMin);
	    p.holdMaturityMax = (0, _twd.formatDate)(p.holdMaturityMax, true);
	
	    return (0, _twd.cleanObject)(p);
	};

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useQuickScreener = exports.ContextProvider = exports.initialValues = exports.Context = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(137);
	
	var _validate = __webpack_require__(978);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _submit = __webpack_require__(977);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Context = exports.Context = _react2.default.createContext();
	var initialValues = exports.initialValues = {
	    holdInvType: ['M'],
	    holdMaturityMin: '',
	    holdMaturityMax: '',
	    quantityMin: '',
	    quantityMax: '',
	    offerYtwMin: '',
	    offerYtwMax: '',
	    clientPriceMin: '',
	    clientPriceMax: '',
	    holdSpRatingMin: 'BBB-',
	    holdSpRatingMax: 'AAA',
	    holdMoodyRatingMin: 'Baa3',
	    holdMoodyRatingMax: 'Aaa',
	    holdRatingAndOr: 'OR',
	    rating: 'investment-grade',
	
	    holdMuniTypeG: true,
	    holdMuniTypeR: true,
	    holdTaxableY: false,
	    holdTaxableN: true,
	
	    purposes: []
	
	};
	
	var state = (0, _twd.getState)('municipals.quick-screener', {
	    currentValues: initialValues
	});
	
	var onValidate = function onValidate(values) {
	    var err = (0, _validate2.default)(values);
	    state.set({
	        currentValues: values,
	        errors: err
	    });
	    return err;
	};
	
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var children = _ref.children;
	
	    var _useAppContext = (0, _App.useAppContext)(),
	        ajax = _useAppContext.ajax,
	        Status = _useAppContext.Status;
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: {
	                state: state, ajax: ajax, Status: Status, onValidate: onValidate, onSubmit: _submit2.default
	            } },
	        children
	    );
	};
	
	var useQuickScreener = exports.useQuickScreener = function useQuickScreener() {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Account = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Account = exports.Account = function Account() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        step = _useOrderTicket.step,
	        acctNo = _useOrderTicket.acctNo,
	        setAcctNo = _useOrderTicket.setAcctNo,
	        orderInfo = _useOrderTicket.orderInfo,
	        hasOrderInfo = _useOrderTicket.hasOrderInfo,
	        accountInfo = _useOrderTicket.accountInfo,
	        hasAccountInfo = _useOrderTicket.hasAccountInfo,
	        mode = _useOrderTicket.mode;
	
	    var isEntry = step === _useOrderTicket2.STEPS.ENTRY;
	    var isPreview = step === _useOrderTicket2.STEPS.PREVIEW || step === _useOrderTicket2.STEPS.CONFIRM;
	
	    var purchasingPowerLabel = isEntry ? 'Pre-trade purchasing power' : isPreview ? 'Post-trade purchasing power' : null;
	
	    var purchasingPower = isEntry && hasAccountInfo ? accountInfo.purchasingPower : accountInfo.purchasingPower && isPreview && hasOrderInfo && orderInfo.action === 'S' ? accountInfo.purchasingPower + orderInfo.netMoney : accountInfo.purchasingPower && isPreview && hasOrderInfo && orderInfo.action === 'B' ? accountInfo.purchasingPower - orderInfo.netMoney : null;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'row vertical-offset-base' }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-3 col-xs-12 vertical-offset-sm' },
	                isEntry && (0, _core.jsx)(SelectAccount, { acctNo: acctNo, setAcctNo: setAcctNo, accounts: (0, _useOrderTicket2.getAccounts)(), mode: mode }),
	                isPreview && (0, _core.jsx)(ShowAccount, { acctNo: acctNo, accounts: (0, _useOrderTicket2.getAccounts)() })
	            ),
	            (0, _core.jsx)('div', { className: 'col-md-6 col-xs-12' }),
	            hasOrderInfo && (0, _core.jsx)(
	                'div',
	                {
	                    className: 'col-md-3 col-xs-12 vertical-offset-sm',
	                    css: _style.textAlignRight
	                },
	                (0, _core.jsx)(
	                    'div',
	                    null,
	                    purchasingPowerLabel
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'text-bold' },
	                    _twd.fmt.money(purchasingPower)
	                )
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var ShowAccount = function ShowAccount(_ref) {
	    var acctNo = _ref.acctNo,
	        accounts = _ref.accounts;
	
	
	    var detail = accounts.filter(function (a) {
	        return a.acctNo === acctNo;
	    })[0] || { acctNo: acctNo };
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            null,
	            'Account'
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'text-truncate' },
	            (0, _core.jsx)(
	                'b',
	                null,
	                detail.title
	            )
	        )
	    );
	};
	
	var SelectAccount = function SelectAccount(_ref2) {
	    var acctNo = _ref2.acctNo,
	        accounts = _ref2.accounts,
	        setAcctNo = _ref2.setAcctNo,
	        mode = _ref2.mode;
	
	
	    var canEdit = mode !== _useOrderTicket2.MODES.ORDER_Z;
	
	    return (0, _core.jsx)(_twd.Fields.SelectMulti, {
	        dataName: 'order-ticket-account',
	        label: "Account",
	
	        emptyText: 'Select account',
	        allText: '',
	        disabled: !canEdit,
	
	        showSelectAll: false,
	        isMultiSelect: false,
	
	        options: accounts.map(function (a) {
	            return { label: a.title, value: a.acctNo };
	        }),
	        style: { marginBottom: '0px' },
	        optionCheckboxLabelConfig: {
	            className: "text-truncate"
	        },
	
	        placeholder: function placeholder(_ref3) {
	            var emptyText = _ref3.emptyText,
	                allText = _ref3.allText,
	                values = _ref3.values,
	                options = _ref3.options;
	
	            var a = options.filter(function (_ref4) {
	                var value = _ref4.value;
	                return value === acctNo;
	            })[0];
	            return a && a.label || emptyText;
	        },
	
	        onSelect: function onSelect(acct) {
	            setAcctNo(acct.value);
	        }
	    });
	};

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Footer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = exports.Footer = function Footer() {
	    return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement("div", { className: "row vertical-offset-lg" }),
	        _react2.default.createElement(
	            "div",
	            { className: "row xs-hide" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-6", style: { height: '25px' } },
	                _react2.default.createElement(
	                    "div",
	                    { style: { display: 'inline', verticalAlign: 'bottom', height: '25px' } },
	                    "The bond resource center is powered by"
	                ),
	                _react2.default.createElement("img", { alt: "tradeweb", "aria-hidden": true, src: "./resources/images/tradeweb-logo.svg" })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-6", style: { height: '25px' } },
	                _react2.default.createElement(
	                    "div",
	                    { style: { position: 'absolute', right: 0, bottom: 0 } },
	                    "All data provided by Tradeweb Markets LLC unless otherwise noted."
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "row xs-show" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 text-center" },
	                "The bond resource",
	                _react2.default.createElement("br", null),
	                "center is powered by",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("img", { alt: "tradeweb", "aria-hidden": true, src: "./resources/images/tradeweb-logo.svg" }),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement("br", null),
	                "All data provided by Tradeweb Market",
	                _react2.default.createElement("br", null),
	                "LLC unless otherwise noted."
	            )
	        ),
	        _react2.default.createElement("div", { className: "row vertical-offset-lg" })
	    );
	};

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _errors = __webpack_require__(1025);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = exports.Header = function Header() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        step = _useOrderTicket.step,
	        isRfq = _useOrderTicket.isRfq,
	        action = _useOrderTicket.action;
	
	    var title = step === 'entry' && ['W', 'F'].indexOf(action) >= 0 ? 'Quote request' : step === 'entry' ? 'Bond order' : step === 'preview' && !isRfq ? 'Preview bond order' : step === 'preview' && isRfq ? 'Preview quote request' : step === 'confirm' && !isRfq ? 'Order confirmation' : step === 'confirm' && isRfq ? 'Quote request confirmation' : '';
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'large-header' },
	                    title
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12 text-body text-right' },
	                'Talk to a Fixed Income Specialist. Call ',
	                _react2.default.createElement(
	                    'a',
	                    {
	                        style: { textDecoration: 'underline' },
	                        alt: '877-355-3237',
	                        href: 'tel:18773553237',
	                        'aria-label': '877-355-3237' },
	                    '877-355-3237'
	                )
	            )
	        ),
	        _react2.default.createElement(_errors.Errors, null)
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetModals = exports.hideModals = exports.showModals = exports.setModals = undefined;
	
	var _twd = __webpack_require__(2);
	
	var modals = [];
	
	// {view:...}
	var setModals = exports.setModals = function setModals(m) {
	    if (!m) return;
	    var n = -1;
	    do {
	        n = modals.find(function (_ref) {
	            var view = _ref.view;
	            return view === m.view;
	        });
	        modals.splice(n, 1);
	    } while (n >= 0);
	
	    modals.push(m);
	};
	
	var showModals = exports.showModals = function showModals() {
	    var a = modals.shift();
	    if (!a || !('view' in a)) return;
	
	    (0, _twd.showModal)(a);
	};
	
	var hideModals = exports.hideModals = function hideModals() {
	    (0, _twd.hideModal)();
	    setTimeout(function () {
	        showModals();
	    });
	};
	
	var resetModals = exports.resetModals = function resetModals() {
	    hideModals();
	    modals.length = 0;
	};
	
	exports.default = function () {
	    return {
	        setModals: setModals,
	        reset: resetModals,
	        resetModals: resetModals,
	        showModals: showModals,
	        hideModals: hideModals
	    };
	};

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.backgroundColor = exports.textAlignRight = exports.sectionCss = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n\n    .table {\n        border-bottom: 0px;\n    }\n}    \n'], ['\n    background-color: #ffffff;\n    ', ' {\n        padding: 0 20px;\n    }\n\n    .table {\n        border-bottom: 0px;\n    }\n}    \n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    ', ' { text-align: right }\n'], ['\n    ', ' { text-align: right }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ' { background-color: #f6f6f6; }\n'], ['\n    ', ' { background-color: #f6f6f6; }\n']);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	
	
	var sectionCss = exports.sectionCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);
	
	var textAlignRight = exports.textAlignRight = (0, _core.css)(_templateObject2, _twd.mediaQueries.notXs);
	
	var backgroundColor = exports.backgroundColor = (0, _core.css)(_templateObject3, _twd.mediaQueries.notXs);

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toSearchParams = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _twd = __webpack_require__(2);
	
	var toSearchParams = exports.toSearchParams = function toSearchParams(_ref) {
	    var invType = _ref.invType,
	        corpSectors = _ref.corpSectors,
	        muniStates = _ref.muniStates,
	        muniPurposes = _ref.muniPurposes,
	        muniGeneralObligation = _ref.muniGeneralObligation,
	        muniRevenue = _ref.muniRevenue,
	        muniTaxExempt = _ref.muniTaxExempt,
	        muniTaxable = _ref.muniTaxable,
	        cdBlueSky = _ref.cdBlueSky,
	        cdNewIssue = _ref.cdNewIssue,
	        cdSecondary = _ref.cdSecondary,
	        agencyTypes = _ref.agencyTypes,
	        treasuryTypes = _ref.treasuryTypes,
	        holdMaturityMin = _ref.holdMaturityMin,
	        holdMaturityMax = _ref.holdMaturityMax,
	        quantityMin = _ref.quantityMin,
	        quantityMax = _ref.quantityMax,
	        offerYtwMin = _ref.offerYtwMin,
	        offerYtwMax = _ref.offerYtwMax,
	        clientPriceMin = _ref.clientPriceMin,
	        clientPriceMax = _ref.clientPriceMax,
	        holdMoodyRatingMin = _ref.holdMoodyRatingMin,
	        holdMoodyRatingMax = _ref.holdMoodyRatingMax,
	        holdSpRatingMin = _ref.holdSpRatingMin,
	        holdSpRatingMax = _ref.holdSpRatingMax,
	        holdCallableInd = _ref.holdCallableInd,
	        holdRatingAndOr = _ref.holdRatingAndOr;
	
	
	    var p = {
	        holdInvType: [invType],
	        holdRatingAndOr: holdRatingAndOr,
	        holdUnderlyingRating: 'NO',
	        offeringType: ['ask-side'],
	        holdMaturityMin: (0, _twd.formatDate)(holdMaturityMin),
	        holdMaturityMax: (0, _twd.formatDate)(holdMaturityMax, true),
	        quantityMin: quantityMin, quantityMax: quantityMax,
	        offerYtwMin: offerYtwMin, offerYtwMax: offerYtwMax,
	        ytwMin: offerYtwMin,
	        ytwMax: offerYtwMax,
	        clientPriceMin: clientPriceMin, clientPriceMax: clientPriceMax
	    };
	
	    var isCorp = invType === 'C';
	    var isMuni = invType === 'M';
	    var isCD = invType === 'S';
	    var isTreasury = invType === 'T';
	    var isAgency = invType === 'A';
	    var hasRating = !(isCD || isTreasury);
	
	    if (isCorp) {
	        Object.assign(p, getParams(corpSectors));
	    } else if (isMuni) {
	        Object.assign(p, getParams(muniStates, muniPurposes));
	
	        p.holdMuniType = [];
	        if (muniGeneralObligation) p.holdMuniType.push('G');
	        if (muniRevenue) p.holdMuniType.push('R');
	
	        p.holdTaxable = [];
	        if (muniTaxable) p.holdTaxable.push('Y');
	        if (muniTaxExempt) p.holdTaxable.push('N');
	    } else if (isCD) {
	        Object.assign(p, getParams(cdBlueSky));
	
	        p.holdBlueSkyStateCD = (0, _twd.arrayFrom)(p.holdBlueSkyStateCD).filter(Boolean);
	        p.primarySecondary = [];
	        if (cdNewIssue) p.primarySecondary.push('primary');
	        if (cdSecondary) p.primarySecondary.push('secondary');
	        p.offeringType = p.offeringType.concat(p.primarySecondary);
	    } else if (isAgency) {
	        Object.assign(p, getParams(agencyTypes));
	    } else if (isTreasury) {
	        Object.assign(p, getParams(treasuryTypes));
	    }
	
	    if (hasRating) {
	        Object.assign(p, {
	            holdMoodyRatingMin: holdMoodyRatingMin,
	            holdMoodyRatingMax: holdMoodyRatingMax,
	            holdSpRatingMin: holdSpRatingMin,
	            holdSpRatingMax: holdSpRatingMax
	        });
	        if (['AND', 'OR'].indexOf(holdRatingAndOr) < 0) {
	            p.holdRatingAndOr = holdRatingAndOr === true ? 'OR' : 'AND';
	        }
	    }
	
	    if (!isTreasury && holdCallableInd) {
	        p.holdCallableInd = ['N'];
	        p.holdCallFeatures = ['holdCallableInd-N'];
	    }
	
	    return (0, _twd.cleanObject)(p);
	};
	
	var getParams = function getParams() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	    }
	
	    return args.reduce(function (x, a) {
	        return x.concat((0, _twd.arrayFrom)(a));
	    }, []).reduce(function (x, a) {
	        var _a$split = a.split('='),
	            _a$split2 = _slicedToArray(_a$split, 2),
	            k = _a$split2[0],
	            v = _a$split2[1];
	
	        if (!x[k]) x[k] = [];
	
	        var arr = x[k];
	        var i = arr.indexOf(v);
	        if (i < 0) arr.push(v);
	
	        return x;
	    }, {});
	};

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useQuickScreener = exports.ContextProvider = exports.initialValues = exports.Context = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(137);
	
	var _validate = __webpack_require__(1099);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _submit = __webpack_require__(1098);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Context = exports.Context = _react2.default.createContext();
	var initialValues = exports.initialValues = {
	    invType: 'C',
	    holdMaturityMin: '',
	    holdMaturityMax: '',
	    quantityMin: '',
	    quantityMax: '',
	    offerYtwMin: '',
	    offerYtwMax: '',
	    clientPriceMin: '',
	    clientPriceMax: '',
	    holdSpRatingMin: 'BBB-',
	    holdSpRatingMax: 'AAA',
	    holdMoodyRatingMin: 'Baa3',
	    holdMoodyRatingMax: 'Aaa',
	    holdRatingAndOr: 'OR',
	    rating: 'investment-grade',
	
	    corpSectors: [],
	
	    muniPurposes: [],
	    muniGeneralObligation: true,
	    muniRevenue: true,
	    muniTaxExempt: true,
	    muniTaxable: false,
	
	    cdNewIssue: true,
	    cdSecondary: false,
	
	    agencyTypes: [],
	    treasuryTypes: [],
	
	    holdCallableInd: false
	};
	
	var state = (0, _twd.getState)('overview.quick-screener', {
	    currentValues: initialValues
	});
	
	var onValidate = function onValidate(values) {
	    var err = (0, _validate2.default)(values);
	    state.set({
	        currentValues: values,
	        errors: err
	    });
	    return err;
	};
	
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var children = _ref.children;
	
	    var _useAppContext = (0, _App.useAppContext)(),
	        ajax = _useAppContext.ajax,
	        Status = _useAppContext.Status;
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: {
	                state: state, ajax: ajax, Status: Status, onValidate: onValidate, onSubmit: _submit2.default
	            } },
	        children
	    );
	};
	
	var useQuickScreener = exports.useQuickScreener = function useQuickScreener() {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 329 */
117,
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    computerIcon: _react2.default.createElement(
	        "svg",
	        { width: "96", height: "96", viewBox: "0 0 96 96", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.24 72.96H5.76C3.9744 72.96 2.46912 71.7341 2.04096 70.08H93.959C93.5309 71.7341 92.0256 72.96 90.24 72.96ZM10.56 68.16H85.44V22.08H10.56V68.16ZM87.36 68.16V20.16H8.64V68.16H0V69.12C0 72.2966 2.58336 74.88 5.76 74.88H90.24C93.4166 74.88 96 72.2966 96 69.12V68.16H87.36ZM18.24 60.48H20.16V41.28H18.24V60.48ZM27.84 60.48H29.76V31.68H27.84V60.48ZM37.44 60.48H39.36V50.88H37.44V60.48ZM47.04 60.48H48.96V46.08H47.04V60.48ZM56.64 60.48H58.56V41.28H56.64V60.48ZM66.24 60.48H68.16V36.48H66.24V60.48ZM75.84 60.48H77.76V46.08H75.84V60.48Z", fill: "#242424" })
	    ),
	
	    dollarIcon: _react2.default.createElement(
	        "svg",
	        { width: "60", height: "61", viewBox: "0 0 60 61", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30 2.65828C14.6486 2.65828 2.15999 15.1469 2.15999 30.4983C2.15999 45.8496 14.6486 58.3383 30 58.3383C45.3513 58.3383 57.84 45.8496 57.84 30.4983C57.84 15.1469 45.3513 2.65828 30 2.65828ZM30 60.2583C13.5907 60.2583 0.23999 46.9076 0.23999 30.4983C0.23999 14.089 13.5907 0.738281 30 0.738281C46.4093 0.738281 59.76 14.089 59.76 30.4983C59.76 46.9076 46.4093 60.2583 30 60.2583ZM29.3864 18.0225V28.8628C29.2721 28.8292 29.1233 28.7879 28.9736 28.7457C28.7019 28.6708 28.4283 28.5959 28.364 28.57C24.8628 27.5668 23.2328 25.8436 23.2328 23.146C23.2328 20.2459 25.6424 18.2462 29.3864 18.0225ZM31.1662 42.971V31.2935L31.3332 31.3425C35.7886 32.5444 37.5252 34.2139 37.5252 37.2974C37.5252 40.4961 35.0926 42.6599 31.1662 42.971ZM32.0792 29.5502L31.1662 29.3313V18.0254C35.2212 18.3537 37.0971 20.7316 37.1566 22.9665L37.1604 23.1067H39.1044L39.1016 22.9598C39.0142 19.2503 35.8318 16.5633 31.1662 16.2427V13.4942H29.3864V16.2206C24.3617 16.4951 21.2475 19.2023 21.2475 23.3102C21.2475 26.9294 23.3489 29.243 27.6728 30.3815L29.3864 30.8433V42.9739C24.7073 42.6955 22.5531 39.9643 22.4964 37.3559L22.4936 37.2148H20.49L20.491 37.3598C20.5121 40.8945 23.2721 44.5425 29.3864 44.7777V47.5022H31.1662V44.7336C36.3176 44.388 39.5096 41.4935 39.5096 37.1544C39.5096 33.1905 37.2881 30.9163 32.0792 29.5502Z", fill: "#242424" })
	    ),
	
	    executive_summary: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.5769 11.52V21.4819L28.6018 43.9315L21.9007 32.5569L5.75977 60.48H65.8546L43.0169 20.9246V18H53.8082V11.52H41.5769ZM43.0169 16.56H52.3675V12.9607H43.0169V16.56ZM35.9688 34.0632L42.4574 22.8355L49.345 34.7652L46.2475 37.8619L41.3875 33.0019L38.1475 36.2419L35.9688 34.0632ZM41.3875 35.0388L46.2475 39.8988L50.0902 36.0561L63.3605 59.0407H8.25529L21.913 35.4146L28.6133 46.7892L35.2229 35.3534L38.1475 38.2788L41.3875 35.0388Z", fill: "#242424" })
	    ),
	
	    position_details: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.5998 4.32C20.0115 4.32 18.7198 5.61169 18.7198 7.20001V64.8C18.7198 66.3883 20.0115 67.68 21.5998 67.68H50.3998C51.9881 67.68 53.2798 66.3883 53.2798 64.8V7.20001C53.2798 5.61169 51.9881 4.32 50.3998 4.32H21.5998ZM50.3998 69.12H21.5998C19.2173 69.12 17.2798 67.1825 17.2798 64.8V7.20001C17.2798 4.81753 19.2173 2.88 21.5998 2.88H50.3998C52.7823 2.88 54.7198 4.81753 54.7198 7.20001V64.8C54.7198 67.1825 52.7823 69.12 50.3998 69.12ZM24.4798 50.4H25.9198V21.6H24.4798V50.4ZM31.6798 50.4H33.1198V14.4H31.6798V50.4ZM38.8798 50.4H40.3198V32.4H38.8798V50.4ZM46.0798 50.4H47.5198V25.2H46.0798V50.4ZM32.3998 63.36H39.5998V61.92H32.3998V63.36ZM18.7198 58.32H53.2798V56.88H18.7198V58.32Z", fill: "#242424" })
	    ),
	
	    reinvestment_proceeds: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M59.1626 42.1848L66.0746 30.6648H57.521C56.2178 25.3584 52.7618 19.8648 48.3698 19.8648C46.5338 19.8648 44.7698 20.844 43.1498 22.6872C41.7098 17.6472 38.3834 12.6648 34.2002 12.6648C31.7162 12.6648 29.2466 14.5224 27.3242 17.7912C26.2308 16.847 24.8443 16.3102 23.4002 16.272C18.0002 16.272 13.997 24.6168 13.6802 30.672H5.92578L17.5898 50.112H38.6714C38.9234 55.728 43.373 59.328 50.1914 59.328C56.2754 59.328 65.3114 55.2528 65.3114 49.608C65.2898 46.5336 62.597 43.92 59.1626 42.1848ZM48.3626 21.3048C51.6314 21.3048 54.7634 25.848 56.0378 30.6648H43.6826C43.7618 30.1824 43.8266 29.6928 43.8626 29.16C43.8659 29.1 43.8659 29.04 43.8626 28.98C43.8626 28.5984 43.9058 28.2024 43.9058 27.7848C43.9058 27.5544 43.9058 27.3168 43.9058 27.0648C43.9058 26.9784 43.9058 26.8992 43.9058 26.8128C43.9058 26.7264 43.9058 26.496 43.8698 26.3376C43.8338 26.1792 43.8698 26.1432 43.8698 26.0424C43.8698 25.8192 43.8194 25.596 43.7834 25.3656C43.7834 25.2648 43.7474 25.164 43.733 25.0632C43.7186 24.9624 43.6826 24.7536 43.6538 24.5952C43.6503 24.54 43.6503 24.4847 43.6538 24.4296C45.0578 22.4208 46.757 21.312 48.3698 21.312L48.3626 21.3048ZM34.2002 14.112C37.6274 14.112 40.8818 19.08 42.041 24.1272L42.1058 24.4296C42.2925 25.2544 42.4176 26.0919 42.4802 26.9352C42.4802 26.9712 42.4802 27.0072 42.4802 27.0432C42.4802 27.2952 42.4802 27.5472 42.4802 27.7632C42.4802 28.1952 42.4802 28.62 42.4298 29.0304L42.3866 29.4768C42.3866 29.7288 42.329 29.9808 42.293 30.1968C42.257 30.4128 42.2426 30.4776 42.2138 30.6144H33.1202C33.1202 30.5352 33.1202 30.456 33.1202 30.3768C33.1202 30.2976 33.1202 30.0312 33.077 29.8584V29.5992C33.077 29.3688 33.0194 29.1312 32.9834 28.8792C32.9834 28.8 32.9834 28.7208 32.9834 28.6416L32.8754 28.0656C32.8669 28.0002 32.8549 27.9353 32.8394 27.8712C32.2145 24.5073 30.7258 21.3637 28.5194 18.7488C30.0818 15.84 32.177 14.112 34.2002 14.112ZM23.4002 17.712C24.1259 17.7658 24.8336 17.9643 25.4815 18.2957C26.1294 18.627 26.7045 19.0847 27.173 19.6416L27.2738 19.7496C27.4466 19.9296 27.6122 20.124 27.7778 20.3256L27.9002 20.4768C27.9722 20.556 28.037 20.6496 28.1018 20.736C28.1666 20.8224 28.2602 20.9448 28.3322 21.0528L28.4762 21.2544C30.1598 23.8138 31.2247 26.7299 31.5866 29.772C31.5866 30.0024 31.6298 30.2328 31.6442 30.492C31.6442 30.5496 31.6442 30.6072 31.6442 30.6576H15.1202C15.4442 24.8184 19.3034 17.712 23.4002 17.712ZM8.47458 32.112H63.5258L60.7898 36.6696H11.2106L8.47458 32.112ZM12.0746 38.1096H59.9258L57.8522 41.5728C55.423 40.5242 52.8149 39.9522 50.1698 39.888C46.5698 39.888 43.6538 40.896 41.6378 42.6672H14.8106L12.0746 38.1096ZM18.4106 48.672L15.6746 44.1072H40.3202C39.3671 45.4507 38.7995 47.0292 38.6786 48.672H18.4106ZM50.1698 57.888C43.949 57.888 40.0898 54.72 40.0898 49.608C40.0898 44.496 43.949 41.328 50.1698 41.328C56.1386 41.328 63.8498 45.3456 63.8498 49.608C63.8498 53.8704 56.1602 57.888 50.1698 57.888Z", fill: "#242424" })
	    ),
	
	    coupon_cashflow: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement(
	            "g",
	            { clipPath: "url(#clip0_1621_6751)" },
	            _react2.default.createElement("path", { d: "M36.8639 48.744V46.656C40.7519 46.368 43.1279 44.208 43.1279 40.968C43.1279 38.016 41.4719 36.288 37.5839 35.28L36.8639 35.136V26.64C39.8879 26.856 41.3279 28.656 41.3279 30.312V30.456H42.7679V30.312C42.6959 27.504 40.3199 25.488 36.7919 25.272V23.256H35.4959V25.272C31.7519 25.488 29.3759 27.504 29.3759 30.6C29.3759 33.336 30.9599 35.064 34.1999 35.928L35.4959 36.288V45.36C31.9679 45.144 30.3839 43.128 30.3119 41.112V41.04H28.7999V41.184C28.7999 43.848 30.8879 46.584 35.4959 46.728V48.744H36.8639ZM36.8639 36.576H37.0079C40.3199 37.44 41.6879 38.736 41.6879 41.04C41.6879 43.344 39.8879 45.072 36.9359 45.288V36.576H36.8639ZM35.2079 34.704C35.0639 34.704 34.9199 34.632 34.7759 34.56C32.1839 33.84 30.9599 32.544 30.9599 30.456C30.9599 28.296 32.7599 26.784 35.5679 26.64V34.776L35.2079 34.704ZM35.9999 15.12C46.7999 15.12 55.8719 23.4 56.8079 34.2L54.5039 31.896L53.4959 32.904L57.5999 37.008L61.7039 32.904L60.6959 31.896L58.2479 34.344C57.3119 22.032 46.5839 12.816 34.2719 13.752C24.0479 14.544 15.6959 22.176 13.9679 32.256L15.4079 32.472C17.0639 22.464 25.7759 15.12 35.9999 15.12ZM35.9999 56.88C25.1999 56.88 16.1279 48.6 15.1919 37.8L17.4959 40.104L18.5039 39.096L14.3999 34.992L10.2959 39.096L11.3039 40.104L13.7519 37.656C14.6879 49.968 25.4159 59.184 37.7279 58.248C47.9519 57.456 56.3039 49.824 58.0319 39.744L56.5919 39.528C54.9359 49.536 46.2239 56.88 35.9999 56.88Z", fill: "#242424" })
	        ),
	        _react2.default.createElement(
	            "defs",
	            null,
	            _react2.default.createElement(
	                "clipPath",
	                { id: "clip0_1621_6751" },
	                _react2.default.createElement("rect", { width: "72", height: "72", fill: "white" })
	            )
	        )
	    ),
	
	    credit_ratings_history: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.91998 53.28H64.08V18.72H7.91998V53.28ZM6.47998 54.72H65.52V17.28H6.47998V54.72ZM25.2 33.4181L32.4 40.6181L39.6 33.4181L46.8 40.6181L58.109 29.3091L57.0909 28.291L46.8 38.582L39.6 31.382L32.4 38.582L25.2 31.382L13.8909 42.691L14.909 43.7091L25.2 33.4181Z", fill: "#242424" })
	    ),
	
	    muni_position_attributes: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M50.4002 55.44H56.1602V35.28H50.4002V55.44ZM7.20023 62.64H63.3602V56.88H7.20023V62.64ZM14.4002 55.44H20.1602V35.28H14.4002V55.44ZM39.6002 55.44H48.9602V35.28H39.6002V55.44ZM32.4002 55.44H38.1602V35.28H32.4002V55.44ZM21.6002 55.44H30.9602V35.28H21.6002V55.44ZM7.20023 33.84H63.3602V28.08H7.20023V33.84ZM35.2802 10.2053L62.0253 26.64H8.53583L35.2802 10.2053ZM64.8002 35.28V26.6602L64.8024 26.6566L64.8002 26.6551V26.64H64.7758L35.2802 8.51472L5.78543 26.64H5.76023V26.6551L5.75879 26.6566L5.76023 26.6587V35.28H12.9602V55.44H5.76023V64.08H64.8002V55.44H57.6002V35.28H64.8002ZM35.2802 23.04C33.6919 23.04 32.4002 21.7483 32.4002 20.16C32.4002 18.5717 33.6919 17.28 35.2802 17.28C36.8685 17.28 38.1602 18.5717 38.1602 20.16C38.1602 21.7483 36.8685 23.04 35.2802 23.04ZM35.2802 15.84C32.8977 15.84 30.9602 17.7775 30.9602 20.16C30.9602 22.5425 32.8977 24.48 35.2802 24.48C37.6627 24.48 39.6002 22.5425 39.6002 20.16C39.6002 17.7775 37.6627 15.84 35.2802 15.84Z", fill: "#242424" })
	    ),
	
	    corp_position_attributes: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67.68 54.72H4.32C2.9808 54.72 1.85184 53.8006 1.53072 52.56H70.4693C70.1482 53.8006 69.0192 54.72 67.68 54.72ZM7.92 51.12H64.08V16.56H7.92V51.12ZM65.52 51.12V15.12H6.48V51.12H0V51.84C0 54.2225 1.93752 56.16 4.32 56.16H67.68C70.0625 56.16 72 54.2225 72 51.84V51.12H65.52ZM13.68 45.36H15.12V30.96H13.68V45.36ZM20.88 45.36H22.32V23.76H20.88V45.36ZM28.08 45.36H29.52V38.16H28.08V45.36ZM35.28 45.36H36.72V34.56H35.28V45.36ZM42.48 45.36H43.92V30.96H42.48V45.36ZM49.68 45.36H51.12V27.36H49.68V45.36ZM56.88 45.36H58.32V34.56H56.88V45.36Z", fill: "#242424" })
	    ),
	
	    fdic_certificate_concentration: _react2.default.createElement(
	        "svg",
	        { width: "72", height: "72", viewBox: "0 0 72 72", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.72 47.52H7.91998V12.96H64.08V47.52H28.5019L18.72 57.3019V47.52ZM17.28 48.96V60.7781L29.0981 48.96H65.52V11.52H6.47998V48.96H17.28ZM34.3028 40.7354C34.3028 39.9722 34.8925 39.3746 35.6463 39.3746C36.4095 39.3746 37.0071 39.9722 37.0071 40.7354C37.0071 41.4763 36.3966 42.0797 35.6463 42.0797C34.8925 42.0797 34.3028 41.4893 34.3028 40.7354ZM29.6923 24.2587C29.8363 20.8747 32.3678 18.6873 36.142 18.6873C39.2128 18.6873 42.311 20.3347 42.311 24.0139C42.311 26.4583 41.0042 27.9415 38.8953 29.5406C36.7274 31.1944 36.3458 32.2305 36.3458 33.7958V35.338H34.8475V33.6136C34.8475 31.6185 35.6632 30.2937 37.9658 28.5499C39.7478 27.174 40.7796 25.9989 40.7796 24.0636C40.7796 21.0921 38.2279 20.0373 36.0427 20.0373C32.5946 20.0373 31.2381 22.3154 31.1244 24.2659L31.1208 24.3336H29.6887L29.6923 24.2587Z", fill: "#242424" })
	    ),
	
	    pdf: _react2.default.createElement(
	        "svg",
	        { width: "14", height: "16", viewBox: "0 0 14 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { d: "M2.0002 15.1C1.6002 15.1 1.2002 14.8 1.2002 14.3V1.50001C1.2002 1.10001 1.5002 0.700012 2.0002 0.700012H8.9002C9.10019 0.700012 9.30019 0.800012 9.4002 0.900012L12.5002 4.10001C12.6002 4.20001 12.7002 4.40001 12.7002 4.60001V14.4C12.7002 14.8 12.4002 15.2 11.9002 15.2H2.0002V15.1Z", fill: "white" }),
	        _react2.default.createElement(
	            "mask",
	            { id: "mask0_1629_6344", style: { maskType: 'alpha' }, maskUnits: "userSpaceOnUse", x: "1", y: "0", width: "12", height: "16" },
	            _react2.default.createElement("path", { d: "M2.0002 15.1C1.6002 15.1 1.2002 14.8 1.2002 14.3V1.49995C1.2002 1.09995 1.5002 0.699951 2.0002 0.699951H8.9002C9.10019 0.699951 9.30019 0.799951 9.4002 0.899951L12.5002 4.09995C12.6002 4.19995 12.7002 4.39995 12.7002 4.59995V14.4C12.7002 14.8 12.4002 15.2 11.9002 15.2H2.0002V15.1Z", fill: "white" })
	        ),
	        _react2.default.createElement(
	            "g",
	            { mask: "url(#mask0_1629_6344)" },
	            _react2.default.createElement("path", { d: "M8.8 5.49985C8.4 5.49985 8 5.19985 8 4.69985V-8.10015C8 -8.50015 8.3 -8.90015 8.8 -8.90015H18.8C19.2 -8.90015 19.6 -8.60015 19.6 -8.10015V4.79985C19.6 5.19985 19.3 5.59985 18.8 5.59985H8.8V5.49985Z", fill: "white" }),
	            _react2.default.createElement("path", { d: "M18.8003 -8.1001V4.7999H8.80029V-8.1001H18.8003ZM18.8003 -9.6001H8.80029C8.00029 -9.6001 7.30029 -8.9001 7.30029 -8.1001V4.7999C7.30029 5.5999 8.00029 6.2999 8.80029 6.2999H18.8003C19.6003 6.2999 20.3003 5.5999 20.3003 4.7999V-8.1001C20.3003 -8.9001 19.6003 -9.6001 18.8003 -9.6001Z", fill: "#666666" })
	        ),
	        _react2.default.createElement("path", { d: "M8.9 1.5L12 4.7V14.4H2V1.5H8.9ZM8.9 0H2C1.2 0 0.5 0.7 0.5 1.5V14.4C0.5 15.2 1.2 15.9 2 15.9H12C12.8 15.9 13.5 15.2 13.5 14.4V4.8C13.5 4.4 13.3 4 13.1 3.8L10 0.599999C9.7 0.199999 9.3 0 8.9 0Z", fill: "#666666" }),
	        _react2.default.createElement("path", { d: "M3.5 9H4.5C5.2 9 5.6 9.3 5.6 10V10.1C5.6 10.7 5.2 11.1 4.5 11.1H4.1V12.4H3.5V9ZM4.5 10.6C4.8 10.6 5 10.4 5 10.1V10C5 9.6 4.8 9.5 4.5 9.5H4.1V10.6H4.5Z", fill: "#666666" }),
	        _react2.default.createElement("path", { d: "M7 9C8 9 8.5 9.49999 8.5 10.4V11C8.5 11.9 8 12.4 7 12.4H6V9H7ZM6.7 9.5V11.9H7C7.6 11.9 7.8 11.6 7.8 11V10.4C7.8 9.79999 7.6 9.5 7 9.5H6.7Z", fill: "#666666" }),
	        _react2.default.createElement("path", { d: "M9 9H10.9V9.5H9.7V10.5H10.7V11H9.7V12.4H9.1V9H9Z", fill: "#666666" })
	    )
	
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ErrorBoundary = exports.useTeyCalculator = exports.ContextProvider = exports.Context = exports.getDefaultValues = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	__webpack_require__(1785);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _footer = __webpack_require__(1119);
	
	var _input = __webpack_require__(1120);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _search = __webpack_require__(1121);
	
	var _search2 = _interopRequireDefault(_search);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _twd.subscribe)('tey-calculator.tey-calculator', function (args) {
	
	    if ((0, _twd.getConfig)('entitlements.ETradeTeyCalculator', 'No') === 'Yes') {
	        (0, _twd.showModal)(Object.assign({
	            view: 'tey-calculator'
	        }, args || {}));
	        return;
	    }
	
	    var url = 'https://us.etrade.com/speedbump/securities?target=https%3A%2F%2Fwww.broadridgeadvisor.com%2Fkt%2Ftrns.aspx%3Fil%3Det%26xsl%3Dinput%26xd%3Div-at-cl06-a02';
	    var name = 'calculator';
	    var options = 'toolbar=no,width=800,height=600,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no';
	    (0, _twd.openWindow)(url, name, options);
	});
	
	var getDefaultValues = exports.getDefaultValues = function getDefaultValues() {
	    return {
	        input: {
	            bondProductType: '',
	            bondYield: '',
	            taxState: '',
	            customTaxRate: '',
	            federalTaxRate: ''
	        },
	        search: {
	            searchFor: '',
	            taxState: '',
	            muniInStates: [],
	            muniOutStates: [],
	            holdMaturityMin: '',
	            holdMaturityMax: '',
	            callFeatures: []
	        }
	    };
	};
	
	var state = (0, _twd.getState)('tey-calculator', Object.assign({}, getDefaultValues()));
	
	var Context = exports.Context = _react2.default.createContext();
	
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: {
	                state: state,
	                getDefaultValues: getDefaultValues
	            } },
	        children
	    );
	};
	
	var useTeyCalculator = exports.useTeyCalculator = function useTeyCalculator() {
	    return _react2.default.useContext(Context);
	};
	
	exports.default = function (args) {
	
	    _react2.default.useEffect(function () {
	        var tmId = setTimeout(function () {
	            (0, _twd.$)('#modal :focusable').eq(0).focus();
	        }, 200);
	
	        return function () {
	            return clearTimeout(tmId);
	        };
	    }, []);
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        calcTs = _React$useState2[0],
	        setCalcTs = _React$useState2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'holdings-modal',
	                className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'holdings-modal-close',
	                            className: 'close',
	                            'aria-label': 'Close',
	                            type: 'button',
	                            onClick: function onClick() {
	                                state.set(Object.assign({}, getDefaultValues()));
	                                (0, _twd.hideModal)();
	                            } },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Tax-equivalent yields calculator'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'tey-calculator-form container' },
	                        _react2.default.createElement(
	                            ContextProvider,
	                            null,
	                            _react2.default.createElement(_input2.default, Object.assign({}, args, { onCalcTs: setCalcTs })),
	                            _react2.default.createElement(_search2.default, Object.assign({}, args, { ts: calcTs }))
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement('hr', { 'aria-hidden': 'true', className: 'vertical-offset-sm' }),
	                    _react2.default.createElement(_footer.Assumptions, null),
	                    _react2.default.createElement(_footer.Disclosures, null)
	                )
	            )
	        )
	    );
	};
	
	var ErrorBoundary = exports.ErrorBoundary = function (_React$Component) {
	    _inherits(ErrorBoundary, _React$Component);
	
	    function ErrorBoundary(props) {
	        _classCallCheck(this, ErrorBoundary);
	
	        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));
	
	        _this.state = { hasError: false };
	        return _this;
	    }
	
	    _createClass(ErrorBoundary, [{
	        key: 'componentDidCatch',
	        value: function componentDidCatch(error) {
	            console.log('ERROR', error);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.hasError) {
	                // eslint-disable-next-line
	                this.state.hasError = false;
	
	                setTimeout(function () {
	                    return (0, _twd.publish)('error-boundary');
	                });
	                return null;
	            }
	            return this.props.children;
	        }
	    }], [{
	        key: 'getDerivedStateFromError',
	        value: function getDerivedStateFromError(error) {
	            return { hasError: true };
	        }
	    }]);
	
	    return ErrorBoundary;
	}(_react2.default.Component);

/***/ },
/* 332 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable no-cond-assign,no-eval */
	
	var parseJson = exports.parseJson = function parseJson(txt, val) {
	    try {
	        return JSON.parse(txt);
	    } catch (x) {
	        return val;
	    }
	};
	
	var evalJson = exports.evalJson = function evalJson(txt, val) {
	    if (!txt) return val;
	
	    try {
	        return eval(txt);
	    } catch (x) {
	        return val;
	    }
	};
	
	var parseStringBlocks = exports.parseStringBlocks = function parseStringBlocks(str) {
	    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	        _ref$left = _ref.left,
	        left = _ref$left === undefined ? '{' : _ref$left,
	        _ref$right = _ref.right,
	        right = _ref$right === undefined ? '}' : _ref$right,
	        _ref$mergeTokens = _ref.mergeTokens,
	        mergeTokens = _ref$mergeTokens === undefined ? true : _ref$mergeTokens;
	
	    var blockRegex = new RegExp(left + '|' + right, 'ig');
	    var leftRegex = new RegExp(left, 'i');
	    var blocks = [];
	    var depth, pos, match;
	
	    do {
	        depth = 0;
	        while (match = blockRegex.exec(str)) {
	
	            if (leftRegex.test(match[0])) {
	                if (!depth) {
	                    pos = blockRegex.lastIndex;
	                }
	                depth++;
	                continue;
	            }
	
	            if (!depth) continue;
	
	            depth--;
	            if (!depth) {
	                blocks.push(str.slice(pos, match.index));
	            }
	        }
	    } while (depth && (blockRegex.lastIndex = pos));
	
	    return mergeTokens ? blocks.map(function (a) {
	        return left + a + right;
	    }) : blocks;
	};
	
	var parseHtml = exports.parseHtml = function parseHtml(str) {
	    return (str || '').replaceAll('&quot;', '"').replace(/(&#(\d+);)/g, function (_, __, charCode) {
	        return String.fromCharCode(charCode);
	    }).replaceAll('&lt;', '<').replaceAll('&gt;', '>').replaceAll('&amp;', '&');
	};

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isConstructor = __webpack_require__(167);
	var tryToString = __webpack_require__(149);
	
	var $TypeError = TypeError;
	
	// `Assert: IsConstructor(argument) is true`
	module.exports = function (argument) {
	  if (isConstructor(argument)) return argument;
	  throw new $TypeError(tryToString(argument) + ' is not a constructor');
	};


/***/ },
/* 334 */
/***/ function(module, exports) {

	'use strict';
	// eslint-disable-next-line es/no-typed-arrays -- safe
	module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';


/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
	var fails = __webpack_require__(7);
	
	module.exports = fails(function () {
	  if (typeof ArrayBuffer == 'function') {
	    var buffer = new ArrayBuffer(8);
	    // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
	    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
	  }
	});


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toObject = __webpack_require__(33);
	var toAbsoluteIndex = __webpack_require__(107);
	var lengthOfArrayLike = __webpack_require__(40);
	
	// `Array.prototype.fill` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.fill
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = lengthOfArrayLike(O);
	  var argumentsLength = arguments.length;
	  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
	  var end = argumentsLength > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var isArray = __webpack_require__(122);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Safari < 13 does not throw an error in this case
	var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
	  // makes no sense without proper strict mode support
	  if (this !== undefined) return true;
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).length = 1;
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	}();
	
	module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
	  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
	    throw new $TypeError('Cannot set read only .length');
	  } return O.length = length;
	} : function (O, length) {
	  return O.length = length;
	};


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var arraySlice = __webpack_require__(91);
	
	var floor = Math.floor;
	
	var sort = function (array, comparefn) {
	  var length = array.length;
	
	  if (length < 8) {
	    // insertion sort
	    var i = 1;
	    var element, j;
	
	    while (i < length) {
	      j = i;
	      element = array[i];
	      while (j && comparefn(array[j - 1], element) > 0) {
	        array[j] = array[--j];
	      }
	      if (j !== i++) array[j] = element;
	    }
	  } else {
	    // merge sort
	    var middle = floor(length / 2);
	    var left = sort(arraySlice(array, 0, middle), comparefn);
	    var right = sort(arraySlice(array, middle), comparefn);
	    var llength = left.length;
	    var rlength = right.length;
	    var lindex = 0;
	    var rindex = 0;
	
	    while (lindex < llength || rindex < rlength) {
	      array[lindex + rindex] = (lindex < llength && rindex < rlength)
	        ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
	        : lindex < llength ? left[lindex++] : right[rindex++];
	    }
	  }
	
	  return array;
	};
	
	module.exports = sort;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(21);
	
	var MATCH = wellKnownSymbol('match');
	
	module.exports = function (METHOD_NAME) {
	  var regexp = /./;
	  try {
	    '/./'[METHOD_NAME](regexp);
	  } catch (error1) {
	    try {
	      regexp[MATCH] = false;
	      return '/./'[METHOD_NAME](regexp);
	    } catch (error2) { /* empty */ }
	  } return false;
	};


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	
	module.exports = !fails(function () {
	  function F() { /* empty */ }
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	
	module.exports = function (key, value) {
	  try {
	    defineProperty(global, key, { value: value, configurable: true, writable: true });
	  } catch (error) {
	    global[key] = value;
	  } return value;
	};


/***/ },
/* 342 */
/***/ function(module, exports) {

	'use strict';
	/* global Deno -- Deno case */
	module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(103);
	
	var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
	
	module.exports = !!webkit && +webkit[1];


/***/ },
/* 344 */
/***/ function(module, exports) {

	'use strict';
	// IE8- don't enum bug keys
	module.exports = [
	  'constructor',
	  'hasOwnProperty',
	  'isPrototypeOf',
	  'propertyIsEnumerable',
	  'toLocaleString',
	  'toString',
	  'valueOf'
	];


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	
	var $Error = Error;
	var replace = uncurryThis(''.replace);
	
	var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
	// eslint-disable-next-line redos/no-vulnerable -- safe
	var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
	var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
	
	module.exports = function (stack, dropEntries) {
	  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
	    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
	  } return stack;
	};


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var isCallable = __webpack_require__(22);
	var store = __webpack_require__(363);
	
	var functionToString = uncurryThis(Function.toString);
	
	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(store.inspectSource)) {
	  store.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	
	module.exports = store.inspectSource;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(21);
	var Iterators = __webpack_require__(168);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var ArrayPrototype = Array.prototype;
	
	// check on default Array iterator
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
	};


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(20);
	
	var floor = Math.floor;
	
	// `IsIntegralNumber` abstract operation
	// https://tc39.es/ecma262/#sec-isintegralnumber
	// eslint-disable-next-line es/no-number-isinteger -- safe
	module.exports = Number.isInteger || function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IteratorPrototype = __webpack_require__(526).IteratorPrototype;
	var create = __webpack_require__(76);
	var createPropertyDescriptor = __webpack_require__(85);
	var setToStringTag = __webpack_require__(73);
	var Iterators = __webpack_require__(168);
	
	var returnThis = function () { return this; };
	
	module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
	  var TO_STRING_TAG = NAME + ' Iterator';
	  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
	  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
	  Iterators[TO_STRING_TAG] = returnThis;
	  return IteratorConstructor;
	};


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var IS_PURE = __webpack_require__(48);
	var FunctionName = __webpack_require__(165);
	var isCallable = __webpack_require__(22);
	var createIteratorConstructor = __webpack_require__(349);
	var getPrototypeOf = __webpack_require__(86);
	var setPrototypeOf = __webpack_require__(100);
	var setToStringTag = __webpack_require__(73);
	var createNonEnumerableProperty = __webpack_require__(65);
	var defineBuiltIn = __webpack_require__(44);
	var wellKnownSymbol = __webpack_require__(21);
	var Iterators = __webpack_require__(168);
	var IteratorsCore = __webpack_require__(526);
	
	var PROPER_FUNCTION_NAME = FunctionName.PROPER;
	var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
	var IteratorPrototype = IteratorsCore.IteratorPrototype;
	var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
	var ITERATOR = wellKnownSymbol('iterator');
	var KEYS = 'keys';
	var VALUES = 'values';
	var ENTRIES = 'entries';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
	  createIteratorConstructor(IteratorConstructor, NAME, next);
	
	  var getIterationMethod = function (KIND) {
	    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
	    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
	
	    switch (KIND) {
	      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
	      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
	      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
	    }
	
	    return function () { return new IteratorConstructor(this); };
	  };
	
	  var TO_STRING_TAG = NAME + ' Iterator';
	  var INCORRECT_VALUES_NAME = false;
	  var IterablePrototype = Iterable.prototype;
	  var nativeIterator = IterablePrototype[ITERATOR]
	    || IterablePrototype['@@iterator']
	    || DEFAULT && IterablePrototype[DEFAULT];
	  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
	  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
	  var CurrentIteratorPrototype, methods, KEY;
	
	  // fix native
	  if (anyNativeIterator) {
	    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
	    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
	      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
	        if (setPrototypeOf) {
	          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
	        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
	          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
	        }
	      }
	      // Set @@toStringTag to native iterators
	      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
	      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
	    }
	  }
	
	  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
	  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
	    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
	      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
	    } else {
	      INCORRECT_VALUES_NAME = true;
	      defaultIterator = function values() { return call(nativeIterator, this); };
	    }
	  }
	
	  // export additional methods
	  if (DEFAULT) {
	    methods = {
	      values: getIterationMethod(VALUES),
	      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
	      entries: getIterationMethod(ENTRIES)
	    };
	    if (FORCED) for (KEY in methods) {
	      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
	        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
	      }
	    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
	  }
	
	  // define iterator
	  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
	    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
	  }
	  Iterators[NAME] = defaultIterator;
	
	  return methods;
	};


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var isCallable = __webpack_require__(22);
	var hasOwn = __webpack_require__(28);
	var DESCRIPTORS = __webpack_require__(15);
	var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(165).CONFIGURABLE;
	var inspectSource = __webpack_require__(346);
	var InternalStateModule = __webpack_require__(52);
	
	var enforceInternalState = InternalStateModule.enforce;
	var getInternalState = InternalStateModule.get;
	var $String = String;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var stringSlice = uncurryThis(''.slice);
	var replace = uncurryThis(''.replace);
	var join = uncurryThis([].join);
	
	var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
	  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
	});
	
	var TEMPLATE = String(String).split('String');
	
	var makeBuiltIn = module.exports = function (value, name, options) {
	  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
	  }
	  if (options && options.getter) name = 'get ' + name;
	  if (options && options.setter) name = 'set ' + name;
	  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
	    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
	    else value.name = name;
	  }
	  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
	    defineProperty(value, 'length', { value: options.arity });
	  }
	  try {
	    if (options && hasOwn(options, 'constructor') && options.constructor) {
	      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
	    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	    } else if (value.prototype) value.prototype = undefined;
	  } catch (error) { /* empty */ }
	  var state = enforceInternalState(value);
	  if (!hasOwn(state, 'source')) {
	    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	  } return value;
	};
	
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	// eslint-disable-next-line no-extend-native -- required
	Function.prototype.toString = makeBuiltIn(function toString() {
	  return isCallable(this) && getInternalState(this).source || inspectSource(this);
	}, 'toString');


/***/ },
/* 352 */
/***/ function(module, exports) {

	'use strict';
	// `Math.sign` method implementation
	// https://tc39.es/ecma262/#sec-math.sign
	// eslint-disable-next-line es/no-math-sign -- safe
	module.exports = Math.sign || function sign(x) {
	  var n = +x;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
	};


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isRegExp = __webpack_require__(253);
	
	var $TypeError = TypeError;
	
	module.exports = function (it) {
	  if (isRegExp(it)) {
	    throw new $TypeError("The method doesn't accept regular expressions");
	  } return it;
	};


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(563);
	var definePropertyModule = __webpack_require__(41);
	var anObject = __webpack_require__(18);
	var toIndexedObject = __webpack_require__(55);
	var objectKeys = __webpack_require__(209);
	
	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
	  return O;
	};


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-object-getownpropertynames -- safe */
	var classof = __webpack_require__(61);
	var toIndexedObject = __webpack_require__(55);
	var $getOwnPropertyNames = __webpack_require__(145).f;
	var arraySlice = __webpack_require__(91);
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return $getOwnPropertyNames(it);
	  } catch (error) {
	    return arraySlice(windowNames);
	  }
	};
	
	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && classof(it) === 'Window'
	    ? getWindowNames(it)
	    : $getOwnPropertyNames(toIndexedObject(it));
	};


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var isObject = __webpack_require__(20);
	var classof = __webpack_require__(61);
	var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(335);
	
	// eslint-disable-next-line es/no-object-isextensible -- safe
	var $isExtensible = Object.isExtensible;
	var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });
	
	// `Object.isExtensible` method
	// https://tc39.es/ecma262/#sec-object.isextensible
	module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
	  if (!isObject(it)) return false;
	  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return false;
	  return $isExtensible ? $isExtensible(it) : true;
	} : $isExtensible;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var uncurryThis = __webpack_require__(8);
	var getOwnPropertyNamesModule = __webpack_require__(145);
	var getOwnPropertySymbolsModule = __webpack_require__(256);
	var anObject = __webpack_require__(18);
	
	var concat = uncurryThis([].concat);
	
	// all object keys, includes non-enumerable and symbols
	module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = getOwnPropertyNamesModule.f(anObject(it));
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
	/* eslint-disable regexp/no-useless-quantifier -- testing */
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(17);
	var regexpFlags = __webpack_require__(359);
	var stickyHelpers = __webpack_require__(260);
	var shared = __webpack_require__(147);
	var create = __webpack_require__(76);
	var getInternalState = __webpack_require__(52).get;
	var UNSUPPORTED_DOT_ALL = __webpack_require__(360);
	var UNSUPPORTED_NCG = __webpack_require__(542);
	
	var nativeReplace = shared('native-string-replace', String.prototype.replace);
	var nativeExec = RegExp.prototype.exec;
	var patchedExec = nativeExec;
	var charAt = uncurryThis(''.charAt);
	var indexOf = uncurryThis(''.indexOf);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/;
	  var re2 = /b*/g;
	  call(nativeExec, re1, 'a');
	  call(nativeExec, re2, 'a');
	  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
	})();
	
	var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
	
	if (PATCH) {
	  patchedExec = function exec(string) {
	    var re = this;
	    var state = getInternalState(re);
	    var str = toString(string);
	    var raw = state.raw;
	    var result, reCopy, lastIndex, match, i, object, group;
	
	    if (raw) {
	      raw.lastIndex = re.lastIndex;
	      result = call(patchedExec, raw, str);
	      re.lastIndex = raw.lastIndex;
	      return result;
	    }
	
	    var groups = state.groups;
	    var sticky = UNSUPPORTED_Y && re.sticky;
	    var flags = call(regexpFlags, re);
	    var source = re.source;
	    var charsAdded = 0;
	    var strCopy = str;
	
	    if (sticky) {
	      flags = replace(flags, 'y', '');
	      if (indexOf(flags, 'g') === -1) {
	        flags += 'g';
	      }
	
	      strCopy = stringSlice(str, re.lastIndex);
	      // Support anchored sticky behavior.
	      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
	        source = '(?: ' + source + ')';
	        strCopy = ' ' + strCopy;
	        charsAdded++;
	      }
	      // ^(? + rx + ) is needed, in combination with some str slicing, to
	      // simulate the 'y' flag.
	      reCopy = new RegExp('^(?:' + source + ')', flags);
	    }
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
	
	    match = call(nativeExec, sticky ? reCopy : re, strCopy);
	
	    if (sticky) {
	      if (match) {
	        match.input = stringSlice(match.input, charsAdded);
	        match[0] = stringSlice(match[0], charsAdded);
	        match.index = re.lastIndex;
	        re.lastIndex += match[0].length;
	      } else re.lastIndex = 0;
	    } else if (UPDATES_LAST_INDEX_WRONG && match) {
	      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
	      call(nativeReplace, match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    if (match && groups) {
	      match.groups = object = create(null);
	      for (i = 0; i < groups.length; i++) {
	        group = groups[i];
	        object[group[0]] = match[group[1]];
	      }
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(18);
	
	// `RegExp.prototype.flags` getter implementation
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.hasIndices) result += 'd';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.dotAll) result += 's';
	  if (that.unicode) result += 'u';
	  if (that.unicodeSets) result += 'v';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var global = __webpack_require__(11);
	
	// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
	var $RegExp = global.RegExp;
	
	module.exports = fails(function () {
	  var re = $RegExp('.', 's');
	  return !(re.dotAll && re.test('\n') && re.flags === 's');
	});


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var apply = __webpack_require__(93);
	var isCallable = __webpack_require__(22);
	var ENGINE_IS_BUN = __webpack_require__(1245);
	var USER_AGENT = __webpack_require__(103);
	var arraySlice = __webpack_require__(91);
	var validateArgumentsLength = __webpack_require__(87);
	
	var Function = global.Function;
	// dirty IE9- and Bun 0.3.0- checks
	var WRAP = /MSIE .\./.test(USER_AGENT) || ENGINE_IS_BUN && (function () {
	  var version = global.Bun.version.split('.');
	  return version.length < 3 || version[0] === '0' && (version[1] < 3 || version[1] === '3' && version[2] === '0');
	})();
	
	// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
	// https://github.com/oven-sh/bun/issues/1633
	module.exports = function (scheduler, hasTimeArg) {
	  var firstParamIndex = hasTimeArg ? 2 : 1;
	  return WRAP ? function (handler, timeout /* , ...arguments */) {
	    var boundArgs = validateArgumentsLength(arguments.length, 1) > firstParamIndex;
	    var fn = isCallable(handler) ? handler : Function(handler);
	    var params = boundArgs ? arraySlice(arguments, firstParamIndex) : [];
	    var callback = boundArgs ? function () {
	      apply(fn, this, params);
	    } : fn;
	    return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
	  } : scheduler;
	};


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var SetHelpers = __webpack_require__(59);
	var iterate = __webpack_require__(78);
	
	var Set = SetHelpers.Set;
	var add = SetHelpers.add;
	
	module.exports = function (set) {
	  var result = new Set();
	  iterate(set, function (it) {
	    add(result, it);
	  });
	  return result;
	};


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IS_PURE = __webpack_require__(48);
	var globalThis = __webpack_require__(11);
	var defineGlobalProperty = __webpack_require__(341);
	
	var SHARED = '__core-js_shared__';
	var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});
	
	(store.versions || (store.versions = [])).push({
	  version: '3.37.1',
	  mode: IS_PURE ? 'pure' : 'global',
	  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
	  license: 'https://github.com/zloirock/core-js/blob/v3.37.1/LICENSE',
	  source: 'https://github.com/zloirock/core-js'
	});


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var uncurryThis = __webpack_require__(8);
	var toLength = __webpack_require__(80);
	var toString = __webpack_require__(17);
	var $repeat = __webpack_require__(263);
	var requireObjectCoercible = __webpack_require__(46);
	
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	var ceil = Math.ceil;
	
	// `String.prototype.{ padStart, padEnd }` methods implementation
	var createMethod = function (IS_END) {
	  return function ($this, maxLength, fillString) {
	    var S = toString(requireObjectCoercible($this));
	    var intMaxLength = toLength(maxLength);
	    var stringLength = S.length;
	    var fillStr = fillString === undefined ? ' ' : toString(fillString);
	    var fillLen, stringFiller;
	    if (intMaxLength <= stringLength || fillStr === '') return S;
	    fillLen = intMaxLength - stringLength;
	    stringFiller = repeat(fillStr, ceil(fillLen / fillStr.length));
	    if (stringFiller.length > fillLen) stringFiller = stringSlice(stringFiller, 0, fillLen);
	    return IS_END ? S + stringFiller : stringFiller + S;
	  };
	};
	
	module.exports = {
	  // `String.prototype.padStart` method
	  // https://tc39.es/ecma262/#sec-string.prototype.padstart
	  start: createMethod(false),
	  // `String.prototype.padEnd` method
	  // https://tc39.es/ecma262/#sec-string.prototype.padend
	  end: createMethod(true)
	};


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var PROPER_FUNCTION_NAME = __webpack_require__(165).PROPER;
	var fails = __webpack_require__(7);
	var whitespaces = __webpack_require__(269);
	
	var non = '\u200B\u0085\u180E';
	
	// check that a method works with the correct list
	// of whitespaces and has a correct name
	module.exports = function (METHOD_NAME) {
	  return fails(function () {
	    return !!whitespaces[METHOD_NAME]()
	      || non[METHOD_NAME]() !== non
	      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
	  });
	};


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var fails = __webpack_require__(7);
	var V8 = __webpack_require__(104);
	var IS_BROWSER = __webpack_require__(511);
	var IS_DENO = __webpack_require__(342);
	var IS_NODE = __webpack_require__(121);
	
	var structuredClone = global.structuredClone;
	
	module.exports = !!structuredClone && !fails(function () {
	  // prevent V8 ArrayBufferDetaching protector cell invalidation and performance degradation
	  // https://github.com/zloirock/core-js/issues/679
	  if ((IS_DENO && V8 > 92) || (IS_NODE && V8 > 94) || (IS_BROWSER && V8 > 97)) return false;
	  var buffer = new ArrayBuffer(8);
	  var clone = structuredClone(buffer, { transfer: [buffer] });
	  return buffer.byteLength !== 0 || clone.byteLength !== 8;
	});


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toPrimitive = __webpack_require__(266);
	
	var $TypeError = TypeError;
	
	// `ToBigInt` abstract operation
	// https://tc39.es/ecma262/#sec-tobigint
	module.exports = function (argument) {
	  var prim = toPrimitive(argument, 'number');
	  if (typeof prim == 'number') throw new $TypeError("Can't convert number to bigint");
	  // eslint-disable-next-line es/no-bigint -- safe
	  return BigInt(prim);
	};


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(49);
	var toLength = __webpack_require__(80);
	
	var $RangeError = RangeError;
	
	// `ToIndex` abstract operation
	// https://tc39.es/ecma262/#sec-toindex
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toIntegerOrInfinity(it);
	  var length = toLength(number);
	  if (number !== length) throw new $RangeError('Wrong length or index');
	  return length;
	};


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(21);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var test = {};
	
	test[TO_STRING_TAG] = 'z';
	
	module.exports = String(test) === '[object z]';


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-new -- required for testing */
	var global = __webpack_require__(11);
	var fails = __webpack_require__(7);
	var checkCorrectnessOfIteration = __webpack_require__(246);
	var NATIVE_ARRAY_BUFFER_VIEWS = __webpack_require__(23).NATIVE_ARRAY_BUFFER_VIEWS;
	
	var ArrayBuffer = global.ArrayBuffer;
	var Int8Array = global.Int8Array;
	
	module.exports = !NATIVE_ARRAY_BUFFER_VIEWS || !fails(function () {
	  Int8Array(1);
	}) || !fails(function () {
	  new Int8Array(-1);
	}) || !checkCorrectnessOfIteration(function (iterable) {
	  new Int8Array();
	  new Int8Array(null);
	  new Int8Array(1.5);
	  new Int8Array(iterable);
	}, true) || fails(function () {
	  // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
	  return new Int8Array(new ArrayBuffer(2), 1, undefined).length !== 1;
	});


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(36);
	var requireObjectCoercible = __webpack_require__(46);
	var iterate = __webpack_require__(67);
	var MapHelpers = __webpack_require__(72);
	var IS_PURE = __webpack_require__(48);
	var fails = __webpack_require__(7);
	
	var Map = MapHelpers.Map;
	var has = MapHelpers.has;
	var get = MapHelpers.get;
	var set = MapHelpers.set;
	var push = uncurryThis([].push);
	
	var DOES_NOT_WORK_WITH_PRIMITIVES = IS_PURE || fails(function () {
	  return Map.groupBy('ab', function (it) {
	    return it;
	  }).get('a').length !== 1;
	});
	
	// `Map.groupBy` method
	// https://github.com/tc39/proposal-array-grouping
	$({ target: 'Map', stat: true, forced: IS_PURE || DOES_NOT_WORK_WITH_PRIMITIVES }, {
	  groupBy: function groupBy(items, callbackfn) {
	    requireObjectCoercible(items);
	    aCallable(callbackfn);
	    var map = new Map();
	    var k = 0;
	    iterate(items, function (value) {
	      var key = callbackfn(value, k++);
	      if (!has(map, key)) set(map, key, [value]);
	      else push(get(map, key), value);
	    });
	    return map;
	  }
	});


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var setToStringTag = __webpack_require__(73);
	
	// Math[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-math-@@tostringtag
	setToStringTag(Math, 'Math', true);


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var exec = __webpack_require__(358);
	
	// `RegExp.prototype.exec` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.exec
	$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
	  exec: exec
	});


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var difference = __webpack_require__(545);
	var setMethodAcceptSetLike = __webpack_require__(146);
	
	// `Set.prototype.difference` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('difference') }, {
	  difference: difference
	});


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var intersection = __webpack_require__(546);
	var setMethodAcceptSetLike = __webpack_require__(146);
	
	var INCORRECT = !setMethodAcceptSetLike('intersection') || fails(function () {
	  // eslint-disable-next-line es/no-array-from, es/no-set -- testing
	  return String(Array.from(new Set([1, 2, 3]).intersection(new Set([3, 2])))) !== '3,2';
	});
	
	// `Set.prototype.intersection` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: INCORRECT }, {
	  intersection: intersection
	});


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isDisjointFrom = __webpack_require__(547);
	var setMethodAcceptSetLike = __webpack_require__(146);
	
	// `Set.prototype.isDisjointFrom` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isDisjointFrom') }, {
	  isDisjointFrom: isDisjointFrom
	});


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isSubsetOf = __webpack_require__(548);
	var setMethodAcceptSetLike = __webpack_require__(146);
	
	// `Set.prototype.isSubsetOf` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isSubsetOf') }, {
	  isSubsetOf: isSubsetOf
	});


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isSupersetOf = __webpack_require__(549);
	var setMethodAcceptSetLike = __webpack_require__(146);
	
	// `Set.prototype.isSupersetOf` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('isSupersetOf') }, {
	  isSupersetOf: isSupersetOf
	});


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var symmetricDifference = __webpack_require__(550);
	var setMethodAcceptSetLike = __webpack_require__(146);
	
	// `Set.prototype.symmetricDifference` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('symmetricDifference') }, {
	  symmetricDifference: symmetricDifference
	});


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var union = __webpack_require__(551);
	var setMethodAcceptSetLike = __webpack_require__(146);
	
	// `Set.prototype.union` method
	// https://github.com/tc39/proposal-set-methods
	$({ target: 'Set', proto: true, real: true, forced: !setMethodAcceptSetLike('union') }, {
	  union: union
	});


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ v1.3.7 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1565)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Path) { 'use strict';
	
	function constant(x) {
	  return function constant() {
	    return x;
	  };
	}
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = y32 * x10 - x32 * y10;
	  if (t * t < epsilon) return;
	  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	function arc() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00),
	            oc;
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
	          var ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	}
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	function curveLinear(context) {
	  return new Linear(context);
	}
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	function line() {
	  var x$1 = x,
	      y$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	}
	
	function area() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function identity(d) {
	  return d;
	}
	
	function pie() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	}
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	function lineRadial$1() {
	  return lineRadial(line().curve(curveRadialLinear));
	}
	
	function areaRadial() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	}
	
	function pointRadial(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	}
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$1 = x,
	      y$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$1.apply(this, (argv[0] = s, argv)), +y$1.apply(this, argv), +x$1.apply(this, (argv[0] = t, argv)), +y$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), link) : x$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), link) : y$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3),
	    tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810,
	    kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
	    kx = Math.sin(tau / 10) * kr,
	    ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5,
	    s = Math.sqrt(3) / 2,
	    k = 1 / Math.sqrt(12),
	    a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	function symbol() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	}
	
	function noop() {}
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basis(context) {
	  return new Basis(context);
	}
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisClosed(context) {
	  return new BasisClosed(context);
	}
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	function basisOpen(context) {
	  return new BasisOpen(context);
	}
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	function linearClosed(context) {
	  return new LinearClosed(context);
	}
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	function natural(context) {
	  return new Natural(context);
	}
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	function step(context) {
	  return new Step(context, 0.5);
	}
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	function none(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	}
	
	function none$1(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	}
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	function stack() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	}
	
	function expand(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	}
	
	function diverging(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = 0, d[1] = dy;
	      }
	    }
	  }
	}
	
	function silhouette(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	}
	
	function wiggle(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	}
	
	function appearance(series) {
	  var peaks = series.map(peak);
	  return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
	}
	
	function peak(series) {
	  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
	  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
	  return j;
	}
	
	function ascending(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	}
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	function descending$1(series) {
	  return ascending(series).reverse();
	}
	
	function insideOut(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = appearance(series),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	}
	
	function reverse(series) {
	  return none$1(series).reverse();
	}
	
	exports.arc = arc;
	exports.area = area;
	exports.areaRadial = areaRadial;
	exports.curveBasis = basis;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBundle = bundle;
	exports.curveCardinal = cardinal;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveLinear = curveLinear;
	exports.curveLinearClosed = linearClosed;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.line = line;
	exports.lineRadial = lineRadial$1;
	exports.linkHorizontal = linkHorizontal;
	exports.linkRadial = linkRadial;
	exports.linkVertical = linkVertical;
	exports.pie = pie;
	exports.pointRadial = pointRadial;
	exports.radialArea = areaRadial;
	exports.radialLine = lineRadial$1;
	exports.stack = stack;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAppearance = appearance;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	exports.symbol = symbol;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.symbols = symbols;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(218));
	var _index4 = _interopRequireDefault(__webpack_require__(12));
	var _index5 = __webpack_require__(51);
	function getUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCDay;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = __webpack_require__(51);
	function setUTCDay(dirtyDate, dirtyDay, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(2, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addHours;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(219));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_HOUR = 3600000;
	
	/**
	 * @name addHours
	 * @category Hour Helpers
	 * @summary Add the specified number of hours to the given date.
	 *
	 * @description
	 * Add the specified number of hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 2 hours to 10 July 2014 23:00:00:
	 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
	 * //=> Fri Jul 11 2014 01:00:00
	 */
	function addHours(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
	}
	module.exports = exports.default;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMinutes;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(219));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_MINUTE = 60000;
	
	/**
	 * @name addMinutes
	 * @category Minute Helpers
	 * @summary Add the specified number of minutes to the given date.
	 *
	 * @description
	 * Add the specified number of minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 minutes to 10 July 2014 12:00:00:
	 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 12:30:00
	 */
	function addMinutes(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
	}
	module.exports = exports.default;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addQuarters;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(220));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addQuarters
	 * @category Quarter Helpers
	 * @summary Add the specified number of year quarters to the given date.
	 *
	 * @description
	 * Add the specified number of year quarters to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 1 quarter to 1 September 2014:
	 * const result = addQuarters(new Date(2014, 8, 1), 1)
	 * //=> Mon Dec 01 2014 00:00:00
	 */
	function addQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  var months = amount * 3;
	  return (0, _index2.default)(dirtyDate, months);
	}
	module.exports = exports.default;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarMonths;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name differenceInCalendarMonths
	 * @category Month Helpers
	 * @summary Get the number of calendar months between the given dates.
	 *
	 * @description
	 * Get the number of calendar months between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar months
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar months are between 31 January 2014 and 1 September 2014?
	 * const result = differenceInCalendarMonths(
	 *   new Date(2014, 8, 1),
	 *   new Date(2014, 0, 31)
	 * )
	 * //=> 8
	 */
	function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
	  return yearDiff * 12 + monthDiff;
	}
	module.exports = exports.default;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarWeeks;
	var _index = _interopRequireDefault(__webpack_require__(131));
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name differenceInCalendarWeeks
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar weeks between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5)
	 * )
	 * //=> 3
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInCalendarWeeks(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 6, 5),
	 *   { weekStartsOn: 1 }
	 * )
	 * //=> 2
	 */
	function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var startOfWeekLeft = (0, _index.default)(dirtyDateLeft, options);
	  var startOfWeekRight = (0, _index.default)(dirtyDateRight, options);
	  var timestampLeft = startOfWeekLeft.getTime() - (0, _index2.default)(startOfWeekLeft);
	  var timestampRight = startOfWeekRight.getTime() - (0, _index2.default)(startOfWeekRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports.default;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarYears;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name differenceInCalendarYears
	 * @category Year Helpers
	 * @summary Get the number of calendar years between the given dates.
	 *
	 * @description
	 * Get the number of calendar years between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInCalendarYears(
	 *   new Date(2015, 1, 11),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() - dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInDays;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(127));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	// Like `compareAsc` but uses local time not UTC, which is needed
	// for accurate equality comparisons of UTC timestamps that end up
	// having the same representation in local time, e.g. one hour before
	// DST ends vs. the instant that DST ends.
	function compareLocalAsc(dateLeft, dateRight) {
	  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
	  if (diff < 0) {
	    return -1;
	  } else if (diff > 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	
	/**
	 * @name differenceInDays
	 * @category Day Helpers
	 * @summary Get the number of full days between the given dates.
	 *
	 * @description
	 * Get the number of full day periods between two dates. Fractional days are
	 * truncated towards zero.
	 *
	 * One "full day" is the distance between a local time in one day to the same
	 * local time on the next or previous day. A full day can sometimes be less than
	 * or more than 24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
	 *
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full days according to the local timezone
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full days are between
	 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
	 * const result = differenceInDays(
	 *   new Date(2012, 6, 2, 0, 0),
	 *   new Date(2011, 6, 2, 23, 0)
	 * )
	 * //=> 365
	 * // How many full days are between
	 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
	 * const result = differenceInDays(
	 *   new Date(2011, 6, 3, 0, 1),
	 *   new Date(2011, 6, 2, 23, 59)
	 * )
	 * //=> 0
	 * // How many full days are between
	 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 92 days, even in
	 * // time zones where DST starts and the
	 * // period has only 92*24-1 hours.
	 * const result = differenceInDays(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 1)
	 * )
	//=> 92
	 */
	function differenceInDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = compareLocalAsc(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft.setDate(dateLeft.getDate() - sign * difference);
	
	  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastDayNotFull);
	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports.default;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInHours;
	var _index = __webpack_require__(42);
	var _index2 = _interopRequireDefault(__webpack_require__(273));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var _index4 = __webpack_require__(178);
	/**
	 * @name differenceInHours
	 * @category Hour Helpers
	 * @summary Get the number of hours between the given dates.
	 *
	 * @description
	 * Get the number of hours between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of hours
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
	 * const result = differenceInHours(
	 *   new Date(2014, 6, 2, 19, 0),
	 *   new Date(2014, 6, 2, 6, 50)
	 * )
	 * //=> 12
	 */
	function differenceInHours(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInHour;
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports.default;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInMinutes;
	var _index = __webpack_require__(42);
	var _index2 = _interopRequireDefault(__webpack_require__(273));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var _index4 = __webpack_require__(178);
	/**
	 * @name differenceInMinutes
	 * @category Minute Helpers
	 * @summary Get the number of minutes between the given dates.
	 *
	 * @description
	 * Get the signed number of full (rounded towards 0) minutes between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of minutes
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
	 * const result = differenceInMinutes(
	 *   new Date(2014, 6, 2, 12, 20, 0),
	 *   new Date(2014, 6, 2, 12, 7, 59)
	 * )
	 * //=> 12
	 *
	 * @example
	 * // How many minutes are between 10:01:59 and 10:00:00
	 * const result = differenceInMinutes(
	 *   new Date(2000, 0, 1, 10, 0, 0),
	 *   new Date(2000, 0, 1, 10, 1, 59)
	 * )
	 * //=> -1
	 */
	function differenceInMinutes(dateLeft, dateRight, options) {
	  (0, _index3.default)(2, arguments);
	  var diff = (0, _index2.default)(dateLeft, dateRight) / _index.millisecondsInMinute;
	  return (0, _index4.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports.default;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(637));
	var _index2 = _interopRequireDefault(__webpack_require__(398));
	var _index3 = _interopRequireDefault(__webpack_require__(277));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachWeekendOfInterval
	 * @category Interval Helpers
	 * @summary List all the Saturdays and Sundays in the given date interval.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given date interval.
	 *
	 * @param {Interval} interval - the given interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given date interval
	 * const result = eachWeekendOfInterval({
	 *   start: new Date(2018, 8, 17),
	 *   end: new Date(2018, 8, 30)
	 * })
	 * //=> [
	 * //   Sat Sep 22 2018 00:00:00,
	 * //   Sun Sep 23 2018 00:00:00,
	 * //   Sat Sep 29 2018 00:00:00,
	 * //   Sun Sep 30 2018 00:00:00
	 * // ]
	 */
	function eachWeekendOfInterval(interval) {
	  (0, _index4.default)(1, arguments);
	  var dateInterval = (0, _index.default)(interval);
	  var weekends = [];
	  var index = 0;
	  while (index < dateInterval.length) {
	    var date = dateInterval[index++];
	    if ((0, _index3.default)(date)) {
	      weekends.push(date);
	      if ((0, _index2.default)(date)) index = index + 5;
	    }
	  }
	  return weekends;
	}
	module.exports = exports.default;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDay;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfDay
	 * @category Day Helpers
	 * @summary Return the end of a day for the given date.
	 *
	 * @description
	 * Return the end of a day for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a day
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a day for 2 September 2014 11:55:00:
	 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 02 2014 23:59:59.999
	 */
	function endOfDay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfMonth
	 * @category Month Helpers
	 * @summary Return the end of a month for the given date.
	 *
	 * @description
	 * Return the end of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a month for 2 September 2014 11:55:00:
	 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  add: true,
	  addBusinessDays: true,
	  addDays: true,
	  addHours: true,
	  addISOWeekYears: true,
	  addMilliseconds: true,
	  addMinutes: true,
	  addMonths: true,
	  addQuarters: true,
	  addSeconds: true,
	  addWeeks: true,
	  addYears: true,
	  areIntervalsOverlapping: true,
	  clamp: true,
	  closestIndexTo: true,
	  closestTo: true,
	  compareAsc: true,
	  compareDesc: true,
	  daysToWeeks: true,
	  differenceInBusinessDays: true,
	  differenceInCalendarDays: true,
	  differenceInCalendarISOWeekYears: true,
	  differenceInCalendarISOWeeks: true,
	  differenceInCalendarMonths: true,
	  differenceInCalendarQuarters: true,
	  differenceInCalendarWeeks: true,
	  differenceInCalendarYears: true,
	  differenceInDays: true,
	  differenceInHours: true,
	  differenceInISOWeekYears: true,
	  differenceInMilliseconds: true,
	  differenceInMinutes: true,
	  differenceInMonths: true,
	  differenceInQuarters: true,
	  differenceInSeconds: true,
	  differenceInWeeks: true,
	  differenceInYears: true,
	  eachDayOfInterval: true,
	  eachHourOfInterval: true,
	  eachMinuteOfInterval: true,
	  eachMonthOfInterval: true,
	  eachQuarterOfInterval: true,
	  eachWeekOfInterval: true,
	  eachWeekendOfInterval: true,
	  eachWeekendOfMonth: true,
	  eachWeekendOfYear: true,
	  eachYearOfInterval: true,
	  endOfDay: true,
	  endOfDecade: true,
	  endOfHour: true,
	  endOfISOWeek: true,
	  endOfISOWeekYear: true,
	  endOfMinute: true,
	  endOfMonth: true,
	  endOfQuarter: true,
	  endOfSecond: true,
	  endOfToday: true,
	  endOfTomorrow: true,
	  endOfWeek: true,
	  endOfYear: true,
	  endOfYesterday: true,
	  format: true,
	  formatDistance: true,
	  formatDistanceStrict: true,
	  formatDistanceToNow: true,
	  formatDistanceToNowStrict: true,
	  formatDuration: true,
	  formatISO: true,
	  formatISO9075: true,
	  formatISODuration: true,
	  formatRFC3339: true,
	  formatRFC7231: true,
	  formatRelative: true,
	  fromUnixTime: true,
	  getDate: true,
	  getDay: true,
	  getDayOfYear: true,
	  getDaysInMonth: true,
	  getDaysInYear: true,
	  getDecade: true,
	  getDefaultOptions: true,
	  getHours: true,
	  getISODay: true,
	  getISOWeek: true,
	  getISOWeekYear: true,
	  getISOWeeksInYear: true,
	  getMilliseconds: true,
	  getMinutes: true,
	  getMonth: true,
	  getOverlappingDaysInIntervals: true,
	  getQuarter: true,
	  getSeconds: true,
	  getTime: true,
	  getUnixTime: true,
	  getWeek: true,
	  getWeekOfMonth: true,
	  getWeekYear: true,
	  getWeeksInMonth: true,
	  getYear: true,
	  hoursToMilliseconds: true,
	  hoursToMinutes: true,
	  hoursToSeconds: true,
	  intervalToDuration: true,
	  intlFormat: true,
	  intlFormatDistance: true,
	  isAfter: true,
	  isBefore: true,
	  isDate: true,
	  isEqual: true,
	  isExists: true,
	  isFirstDayOfMonth: true,
	  isFriday: true,
	  isFuture: true,
	  isLastDayOfMonth: true,
	  isLeapYear: true,
	  isMatch: true,
	  isMonday: true,
	  isPast: true,
	  isSameDay: true,
	  isSameHour: true,
	  isSameISOWeek: true,
	  isSameISOWeekYear: true,
	  isSameMinute: true,
	  isSameMonth: true,
	  isSameQuarter: true,
	  isSameSecond: true,
	  isSameWeek: true,
	  isSameYear: true,
	  isSaturday: true,
	  isSunday: true,
	  isThisHour: true,
	  isThisISOWeek: true,
	  isThisMinute: true,
	  isThisMonth: true,
	  isThisQuarter: true,
	  isThisSecond: true,
	  isThisWeek: true,
	  isThisYear: true,
	  isThursday: true,
	  isToday: true,
	  isTomorrow: true,
	  isTuesday: true,
	  isValid: true,
	  isWednesday: true,
	  isWeekend: true,
	  isWithinInterval: true,
	  isYesterday: true,
	  lastDayOfDecade: true,
	  lastDayOfISOWeek: true,
	  lastDayOfISOWeekYear: true,
	  lastDayOfMonth: true,
	  lastDayOfQuarter: true,
	  lastDayOfWeek: true,
	  lastDayOfYear: true,
	  lightFormat: true,
	  max: true,
	  milliseconds: true,
	  millisecondsToHours: true,
	  millisecondsToMinutes: true,
	  millisecondsToSeconds: true,
	  min: true,
	  minutesToHours: true,
	  minutesToMilliseconds: true,
	  minutesToSeconds: true,
	  monthsToQuarters: true,
	  monthsToYears: true,
	  nextDay: true,
	  nextFriday: true,
	  nextMonday: true,
	  nextSaturday: true,
	  nextSunday: true,
	  nextThursday: true,
	  nextTuesday: true,
	  nextWednesday: true,
	  parse: true,
	  parseISO: true,
	  parseJSON: true,
	  previousDay: true,
	  previousFriday: true,
	  previousMonday: true,
	  previousSaturday: true,
	  previousSunday: true,
	  previousThursday: true,
	  previousTuesday: true,
	  previousWednesday: true,
	  quartersToMonths: true,
	  quartersToYears: true,
	  roundToNearestMinutes: true,
	  secondsToHours: true,
	  secondsToMilliseconds: true,
	  secondsToMinutes: true,
	  set: true,
	  setDate: true,
	  setDay: true,
	  setDayOfYear: true,
	  setDefaultOptions: true,
	  setHours: true,
	  setISODay: true,
	  setISOWeek: true,
	  setISOWeekYear: true,
	  setMilliseconds: true,
	  setMinutes: true,
	  setMonth: true,
	  setQuarter: true,
	  setSeconds: true,
	  setWeek: true,
	  setWeekYear: true,
	  setYear: true,
	  startOfDay: true,
	  startOfDecade: true,
	  startOfHour: true,
	  startOfISOWeek: true,
	  startOfISOWeekYear: true,
	  startOfMinute: true,
	  startOfMonth: true,
	  startOfQuarter: true,
	  startOfSecond: true,
	  startOfToday: true,
	  startOfTomorrow: true,
	  startOfWeek: true,
	  startOfWeekYear: true,
	  startOfYear: true,
	  startOfYesterday: true,
	  sub: true,
	  subBusinessDays: true,
	  subDays: true,
	  subHours: true,
	  subISOWeekYears: true,
	  subMilliseconds: true,
	  subMinutes: true,
	  subMonths: true,
	  subQuarters: true,
	  subSeconds: true,
	  subWeeks: true,
	  subYears: true,
	  toDate: true,
	  weeksToDays: true,
	  yearsToMonths: true,
	  yearsToQuarters: true
	};
	Object.defineProperty(exports, "add", {
	  enumerable: true,
	  get: function get() {
	    return _index.default;
	  }
	});
	Object.defineProperty(exports, "addBusinessDays", {
	  enumerable: true,
	  get: function get() {
	    return _index2.default;
	  }
	});
	Object.defineProperty(exports, "addDays", {
	  enumerable: true,
	  get: function get() {
	    return _index3.default;
	  }
	});
	Object.defineProperty(exports, "addHours", {
	  enumerable: true,
	  get: function get() {
	    return _index4.default;
	  }
	});
	Object.defineProperty(exports, "addISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index5.default;
	  }
	});
	Object.defineProperty(exports, "addMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index6.default;
	  }
	});
	Object.defineProperty(exports, "addMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index7.default;
	  }
	});
	Object.defineProperty(exports, "addMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index8.default;
	  }
	});
	Object.defineProperty(exports, "addQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index9.default;
	  }
	});
	Object.defineProperty(exports, "addSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index10.default;
	  }
	});
	Object.defineProperty(exports, "addWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index11.default;
	  }
	});
	Object.defineProperty(exports, "addYears", {
	  enumerable: true,
	  get: function get() {
	    return _index12.default;
	  }
	});
	Object.defineProperty(exports, "areIntervalsOverlapping", {
	  enumerable: true,
	  get: function get() {
	    return _index13.default;
	  }
	});
	Object.defineProperty(exports, "clamp", {
	  enumerable: true,
	  get: function get() {
	    return _index14.default;
	  }
	});
	Object.defineProperty(exports, "closestIndexTo", {
	  enumerable: true,
	  get: function get() {
	    return _index15.default;
	  }
	});
	Object.defineProperty(exports, "closestTo", {
	  enumerable: true,
	  get: function get() {
	    return _index16.default;
	  }
	});
	Object.defineProperty(exports, "compareAsc", {
	  enumerable: true,
	  get: function get() {
	    return _index17.default;
	  }
	});
	Object.defineProperty(exports, "compareDesc", {
	  enumerable: true,
	  get: function get() {
	    return _index18.default;
	  }
	});
	Object.defineProperty(exports, "daysToWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index19.default;
	  }
	});
	Object.defineProperty(exports, "differenceInBusinessDays", {
	  enumerable: true,
	  get: function get() {
	    return _index20.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarDays", {
	  enumerable: true,
	  get: function get() {
	    return _index21.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index22.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarISOWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index23.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index24.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index25.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index26.default;
	  }
	});
	Object.defineProperty(exports, "differenceInCalendarYears", {
	  enumerable: true,
	  get: function get() {
	    return _index27.default;
	  }
	});
	Object.defineProperty(exports, "differenceInDays", {
	  enumerable: true,
	  get: function get() {
	    return _index28.default;
	  }
	});
	Object.defineProperty(exports, "differenceInHours", {
	  enumerable: true,
	  get: function get() {
	    return _index29.default;
	  }
	});
	Object.defineProperty(exports, "differenceInISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index30.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index31.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index32.default;
	  }
	});
	Object.defineProperty(exports, "differenceInMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index33.default;
	  }
	});
	Object.defineProperty(exports, "differenceInQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index34.default;
	  }
	});
	Object.defineProperty(exports, "differenceInSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index35.default;
	  }
	});
	Object.defineProperty(exports, "differenceInWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index36.default;
	  }
	});
	Object.defineProperty(exports, "differenceInYears", {
	  enumerable: true,
	  get: function get() {
	    return _index37.default;
	  }
	});
	Object.defineProperty(exports, "eachDayOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index38.default;
	  }
	});
	Object.defineProperty(exports, "eachHourOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index39.default;
	  }
	});
	Object.defineProperty(exports, "eachMinuteOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index40.default;
	  }
	});
	Object.defineProperty(exports, "eachMonthOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index41.default;
	  }
	});
	Object.defineProperty(exports, "eachQuarterOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index42.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index43.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index44.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index45.default;
	  }
	});
	Object.defineProperty(exports, "eachWeekendOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index46.default;
	  }
	});
	Object.defineProperty(exports, "eachYearOfInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index47.default;
	  }
	});
	Object.defineProperty(exports, "endOfDay", {
	  enumerable: true,
	  get: function get() {
	    return _index48.default;
	  }
	});
	Object.defineProperty(exports, "endOfDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index49.default;
	  }
	});
	Object.defineProperty(exports, "endOfHour", {
	  enumerable: true,
	  get: function get() {
	    return _index50.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index51.default;
	  }
	});
	Object.defineProperty(exports, "endOfISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index52.default;
	  }
	});
	Object.defineProperty(exports, "endOfMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index53.default;
	  }
	});
	Object.defineProperty(exports, "endOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index54.default;
	  }
	});
	Object.defineProperty(exports, "endOfQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index55.default;
	  }
	});
	Object.defineProperty(exports, "endOfSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index56.default;
	  }
	});
	Object.defineProperty(exports, "endOfToday", {
	  enumerable: true,
	  get: function get() {
	    return _index57.default;
	  }
	});
	Object.defineProperty(exports, "endOfTomorrow", {
	  enumerable: true,
	  get: function get() {
	    return _index58.default;
	  }
	});
	Object.defineProperty(exports, "endOfWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index59.default;
	  }
	});
	Object.defineProperty(exports, "endOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index60.default;
	  }
	});
	Object.defineProperty(exports, "endOfYesterday", {
	  enumerable: true,
	  get: function get() {
	    return _index61.default;
	  }
	});
	Object.defineProperty(exports, "format", {
	  enumerable: true,
	  get: function get() {
	    return _index62.default;
	  }
	});
	Object.defineProperty(exports, "formatDistance", {
	  enumerable: true,
	  get: function get() {
	    return _index63.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceStrict", {
	  enumerable: true,
	  get: function get() {
	    return _index64.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNow", {
	  enumerable: true,
	  get: function get() {
	    return _index65.default;
	  }
	});
	Object.defineProperty(exports, "formatDistanceToNowStrict", {
	  enumerable: true,
	  get: function get() {
	    return _index66.default;
	  }
	});
	Object.defineProperty(exports, "formatDuration", {
	  enumerable: true,
	  get: function get() {
	    return _index67.default;
	  }
	});
	Object.defineProperty(exports, "formatISO", {
	  enumerable: true,
	  get: function get() {
	    return _index68.default;
	  }
	});
	Object.defineProperty(exports, "formatISO9075", {
	  enumerable: true,
	  get: function get() {
	    return _index69.default;
	  }
	});
	Object.defineProperty(exports, "formatISODuration", {
	  enumerable: true,
	  get: function get() {
	    return _index70.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC3339", {
	  enumerable: true,
	  get: function get() {
	    return _index71.default;
	  }
	});
	Object.defineProperty(exports, "formatRFC7231", {
	  enumerable: true,
	  get: function get() {
	    return _index72.default;
	  }
	});
	Object.defineProperty(exports, "formatRelative", {
	  enumerable: true,
	  get: function get() {
	    return _index73.default;
	  }
	});
	Object.defineProperty(exports, "fromUnixTime", {
	  enumerable: true,
	  get: function get() {
	    return _index74.default;
	  }
	});
	Object.defineProperty(exports, "getDate", {
	  enumerable: true,
	  get: function get() {
	    return _index75.default;
	  }
	});
	Object.defineProperty(exports, "getDay", {
	  enumerable: true,
	  get: function get() {
	    return _index76.default;
	  }
	});
	Object.defineProperty(exports, "getDayOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index77.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index78.default;
	  }
	});
	Object.defineProperty(exports, "getDaysInYear", {
	  enumerable: true,
	  get: function get() {
	    return _index79.default;
	  }
	});
	Object.defineProperty(exports, "getDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index80.default;
	  }
	});
	Object.defineProperty(exports, "getDefaultOptions", {
	  enumerable: true,
	  get: function get() {
	    return _index81.default;
	  }
	});
	Object.defineProperty(exports, "getHours", {
	  enumerable: true,
	  get: function get() {
	    return _index82.default;
	  }
	});
	Object.defineProperty(exports, "getISODay", {
	  enumerable: true,
	  get: function get() {
	    return _index83.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index84.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index85.default;
	  }
	});
	Object.defineProperty(exports, "getISOWeeksInYear", {
	  enumerable: true,
	  get: function get() {
	    return _index86.default;
	  }
	});
	Object.defineProperty(exports, "getMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index87.default;
	  }
	});
	Object.defineProperty(exports, "getMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index88.default;
	  }
	});
	Object.defineProperty(exports, "getMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index89.default;
	  }
	});
	Object.defineProperty(exports, "getOverlappingDaysInIntervals", {
	  enumerable: true,
	  get: function get() {
	    return _index90.default;
	  }
	});
	Object.defineProperty(exports, "getQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index91.default;
	  }
	});
	Object.defineProperty(exports, "getSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index92.default;
	  }
	});
	Object.defineProperty(exports, "getTime", {
	  enumerable: true,
	  get: function get() {
	    return _index93.default;
	  }
	});
	Object.defineProperty(exports, "getUnixTime", {
	  enumerable: true,
	  get: function get() {
	    return _index94.default;
	  }
	});
	Object.defineProperty(exports, "getWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index95.default;
	  }
	});
	Object.defineProperty(exports, "getWeekOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index96.default;
	  }
	});
	Object.defineProperty(exports, "getWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index97.default;
	  }
	});
	Object.defineProperty(exports, "getWeeksInMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index98.default;
	  }
	});
	Object.defineProperty(exports, "getYear", {
	  enumerable: true,
	  get: function get() {
	    return _index99.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index100.default;
	  }
	});
	Object.defineProperty(exports, "hoursToMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index101.default;
	  }
	});
	Object.defineProperty(exports, "hoursToSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index102.default;
	  }
	});
	Object.defineProperty(exports, "intervalToDuration", {
	  enumerable: true,
	  get: function get() {
	    return _index103.default;
	  }
	});
	Object.defineProperty(exports, "intlFormat", {
	  enumerable: true,
	  get: function get() {
	    return _index104.default;
	  }
	});
	Object.defineProperty(exports, "intlFormatDistance", {
	  enumerable: true,
	  get: function get() {
	    return _index105.default;
	  }
	});
	Object.defineProperty(exports, "isAfter", {
	  enumerable: true,
	  get: function get() {
	    return _index106.default;
	  }
	});
	Object.defineProperty(exports, "isBefore", {
	  enumerable: true,
	  get: function get() {
	    return _index107.default;
	  }
	});
	Object.defineProperty(exports, "isDate", {
	  enumerable: true,
	  get: function get() {
	    return _index108.default;
	  }
	});
	Object.defineProperty(exports, "isEqual", {
	  enumerable: true,
	  get: function get() {
	    return _index109.default;
	  }
	});
	Object.defineProperty(exports, "isExists", {
	  enumerable: true,
	  get: function get() {
	    return _index110.default;
	  }
	});
	Object.defineProperty(exports, "isFirstDayOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index111.default;
	  }
	});
	Object.defineProperty(exports, "isFriday", {
	  enumerable: true,
	  get: function get() {
	    return _index112.default;
	  }
	});
	Object.defineProperty(exports, "isFuture", {
	  enumerable: true,
	  get: function get() {
	    return _index113.default;
	  }
	});
	Object.defineProperty(exports, "isLastDayOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index114.default;
	  }
	});
	Object.defineProperty(exports, "isLeapYear", {
	  enumerable: true,
	  get: function get() {
	    return _index115.default;
	  }
	});
	Object.defineProperty(exports, "isMatch", {
	  enumerable: true,
	  get: function get() {
	    return _index116.default;
	  }
	});
	Object.defineProperty(exports, "isMonday", {
	  enumerable: true,
	  get: function get() {
	    return _index117.default;
	  }
	});
	Object.defineProperty(exports, "isPast", {
	  enumerable: true,
	  get: function get() {
	    return _index118.default;
	  }
	});
	Object.defineProperty(exports, "isSameDay", {
	  enumerable: true,
	  get: function get() {
	    return _index119.default;
	  }
	});
	Object.defineProperty(exports, "isSameHour", {
	  enumerable: true,
	  get: function get() {
	    return _index120.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index121.default;
	  }
	});
	Object.defineProperty(exports, "isSameISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index122.default;
	  }
	});
	Object.defineProperty(exports, "isSameMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index123.default;
	  }
	});
	Object.defineProperty(exports, "isSameMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index124.default;
	  }
	});
	Object.defineProperty(exports, "isSameQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index125.default;
	  }
	});
	Object.defineProperty(exports, "isSameSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index126.default;
	  }
	});
	Object.defineProperty(exports, "isSameWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index127.default;
	  }
	});
	Object.defineProperty(exports, "isSameYear", {
	  enumerable: true,
	  get: function get() {
	    return _index128.default;
	  }
	});
	Object.defineProperty(exports, "isSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _index129.default;
	  }
	});
	Object.defineProperty(exports, "isSunday", {
	  enumerable: true,
	  get: function get() {
	    return _index130.default;
	  }
	});
	Object.defineProperty(exports, "isThisHour", {
	  enumerable: true,
	  get: function get() {
	    return _index131.default;
	  }
	});
	Object.defineProperty(exports, "isThisISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index132.default;
	  }
	});
	Object.defineProperty(exports, "isThisMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index133.default;
	  }
	});
	Object.defineProperty(exports, "isThisMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index134.default;
	  }
	});
	Object.defineProperty(exports, "isThisQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index135.default;
	  }
	});
	Object.defineProperty(exports, "isThisSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index136.default;
	  }
	});
	Object.defineProperty(exports, "isThisWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index137.default;
	  }
	});
	Object.defineProperty(exports, "isThisYear", {
	  enumerable: true,
	  get: function get() {
	    return _index138.default;
	  }
	});
	Object.defineProperty(exports, "isThursday", {
	  enumerable: true,
	  get: function get() {
	    return _index139.default;
	  }
	});
	Object.defineProperty(exports, "isToday", {
	  enumerable: true,
	  get: function get() {
	    return _index140.default;
	  }
	});
	Object.defineProperty(exports, "isTomorrow", {
	  enumerable: true,
	  get: function get() {
	    return _index141.default;
	  }
	});
	Object.defineProperty(exports, "isTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _index142.default;
	  }
	});
	Object.defineProperty(exports, "isValid", {
	  enumerable: true,
	  get: function get() {
	    return _index143.default;
	  }
	});
	Object.defineProperty(exports, "isWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _index144.default;
	  }
	});
	Object.defineProperty(exports, "isWeekend", {
	  enumerable: true,
	  get: function get() {
	    return _index145.default;
	  }
	});
	Object.defineProperty(exports, "isWithinInterval", {
	  enumerable: true,
	  get: function get() {
	    return _index146.default;
	  }
	});
	Object.defineProperty(exports, "isYesterday", {
	  enumerable: true,
	  get: function get() {
	    return _index147.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index148.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index149.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index150.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index151.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index152.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index153.default;
	  }
	});
	Object.defineProperty(exports, "lastDayOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index154.default;
	  }
	});
	Object.defineProperty(exports, "lightFormat", {
	  enumerable: true,
	  get: function get() {
	    return _index155.default;
	  }
	});
	Object.defineProperty(exports, "max", {
	  enumerable: true,
	  get: function get() {
	    return _index156.default;
	  }
	});
	Object.defineProperty(exports, "milliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index157.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToHours", {
	  enumerable: true,
	  get: function get() {
	    return _index158.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index159.default;
	  }
	});
	Object.defineProperty(exports, "millisecondsToSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index160.default;
	  }
	});
	Object.defineProperty(exports, "min", {
	  enumerable: true,
	  get: function get() {
	    return _index161.default;
	  }
	});
	Object.defineProperty(exports, "minutesToHours", {
	  enumerable: true,
	  get: function get() {
	    return _index162.default;
	  }
	});
	Object.defineProperty(exports, "minutesToMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index163.default;
	  }
	});
	Object.defineProperty(exports, "minutesToSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index164.default;
	  }
	});
	Object.defineProperty(exports, "monthsToQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index165.default;
	  }
	});
	Object.defineProperty(exports, "monthsToYears", {
	  enumerable: true,
	  get: function get() {
	    return _index166.default;
	  }
	});
	Object.defineProperty(exports, "nextDay", {
	  enumerable: true,
	  get: function get() {
	    return _index167.default;
	  }
	});
	Object.defineProperty(exports, "nextFriday", {
	  enumerable: true,
	  get: function get() {
	    return _index168.default;
	  }
	});
	Object.defineProperty(exports, "nextMonday", {
	  enumerable: true,
	  get: function get() {
	    return _index169.default;
	  }
	});
	Object.defineProperty(exports, "nextSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _index170.default;
	  }
	});
	Object.defineProperty(exports, "nextSunday", {
	  enumerable: true,
	  get: function get() {
	    return _index171.default;
	  }
	});
	Object.defineProperty(exports, "nextThursday", {
	  enumerable: true,
	  get: function get() {
	    return _index172.default;
	  }
	});
	Object.defineProperty(exports, "nextTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _index173.default;
	  }
	});
	Object.defineProperty(exports, "nextWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _index174.default;
	  }
	});
	Object.defineProperty(exports, "parse", {
	  enumerable: true,
	  get: function get() {
	    return _index175.default;
	  }
	});
	Object.defineProperty(exports, "parseISO", {
	  enumerable: true,
	  get: function get() {
	    return _index176.default;
	  }
	});
	Object.defineProperty(exports, "parseJSON", {
	  enumerable: true,
	  get: function get() {
	    return _index177.default;
	  }
	});
	Object.defineProperty(exports, "previousDay", {
	  enumerable: true,
	  get: function get() {
	    return _index178.default;
	  }
	});
	Object.defineProperty(exports, "previousFriday", {
	  enumerable: true,
	  get: function get() {
	    return _index179.default;
	  }
	});
	Object.defineProperty(exports, "previousMonday", {
	  enumerable: true,
	  get: function get() {
	    return _index180.default;
	  }
	});
	Object.defineProperty(exports, "previousSaturday", {
	  enumerable: true,
	  get: function get() {
	    return _index181.default;
	  }
	});
	Object.defineProperty(exports, "previousSunday", {
	  enumerable: true,
	  get: function get() {
	    return _index182.default;
	  }
	});
	Object.defineProperty(exports, "previousThursday", {
	  enumerable: true,
	  get: function get() {
	    return _index183.default;
	  }
	});
	Object.defineProperty(exports, "previousTuesday", {
	  enumerable: true,
	  get: function get() {
	    return _index184.default;
	  }
	});
	Object.defineProperty(exports, "previousWednesday", {
	  enumerable: true,
	  get: function get() {
	    return _index185.default;
	  }
	});
	Object.defineProperty(exports, "quartersToMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index186.default;
	  }
	});
	Object.defineProperty(exports, "quartersToYears", {
	  enumerable: true,
	  get: function get() {
	    return _index187.default;
	  }
	});
	Object.defineProperty(exports, "roundToNearestMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index188.default;
	  }
	});
	Object.defineProperty(exports, "secondsToHours", {
	  enumerable: true,
	  get: function get() {
	    return _index189.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index190.default;
	  }
	});
	Object.defineProperty(exports, "secondsToMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index191.default;
	  }
	});
	Object.defineProperty(exports, "set", {
	  enumerable: true,
	  get: function get() {
	    return _index192.default;
	  }
	});
	Object.defineProperty(exports, "setDate", {
	  enumerable: true,
	  get: function get() {
	    return _index193.default;
	  }
	});
	Object.defineProperty(exports, "setDay", {
	  enumerable: true,
	  get: function get() {
	    return _index194.default;
	  }
	});
	Object.defineProperty(exports, "setDayOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index195.default;
	  }
	});
	Object.defineProperty(exports, "setDefaultOptions", {
	  enumerable: true,
	  get: function get() {
	    return _index196.default;
	  }
	});
	Object.defineProperty(exports, "setHours", {
	  enumerable: true,
	  get: function get() {
	    return _index197.default;
	  }
	});
	Object.defineProperty(exports, "setISODay", {
	  enumerable: true,
	  get: function get() {
	    return _index198.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index199.default;
	  }
	});
	Object.defineProperty(exports, "setISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index200.default;
	  }
	});
	Object.defineProperty(exports, "setMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index201.default;
	  }
	});
	Object.defineProperty(exports, "setMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index202.default;
	  }
	});
	Object.defineProperty(exports, "setMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index203.default;
	  }
	});
	Object.defineProperty(exports, "setQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index204.default;
	  }
	});
	Object.defineProperty(exports, "setSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index205.default;
	  }
	});
	Object.defineProperty(exports, "setWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index206.default;
	  }
	});
	Object.defineProperty(exports, "setWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index207.default;
	  }
	});
	Object.defineProperty(exports, "setYear", {
	  enumerable: true,
	  get: function get() {
	    return _index208.default;
	  }
	});
	Object.defineProperty(exports, "startOfDay", {
	  enumerable: true,
	  get: function get() {
	    return _index209.default;
	  }
	});
	Object.defineProperty(exports, "startOfDecade", {
	  enumerable: true,
	  get: function get() {
	    return _index210.default;
	  }
	});
	Object.defineProperty(exports, "startOfHour", {
	  enumerable: true,
	  get: function get() {
	    return _index211.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index212.default;
	  }
	});
	Object.defineProperty(exports, "startOfISOWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index213.default;
	  }
	});
	Object.defineProperty(exports, "startOfMinute", {
	  enumerable: true,
	  get: function get() {
	    return _index214.default;
	  }
	});
	Object.defineProperty(exports, "startOfMonth", {
	  enumerable: true,
	  get: function get() {
	    return _index215.default;
	  }
	});
	Object.defineProperty(exports, "startOfQuarter", {
	  enumerable: true,
	  get: function get() {
	    return _index216.default;
	  }
	});
	Object.defineProperty(exports, "startOfSecond", {
	  enumerable: true,
	  get: function get() {
	    return _index217.default;
	  }
	});
	Object.defineProperty(exports, "startOfToday", {
	  enumerable: true,
	  get: function get() {
	    return _index218.default;
	  }
	});
	Object.defineProperty(exports, "startOfTomorrow", {
	  enumerable: true,
	  get: function get() {
	    return _index219.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeek", {
	  enumerable: true,
	  get: function get() {
	    return _index220.default;
	  }
	});
	Object.defineProperty(exports, "startOfWeekYear", {
	  enumerable: true,
	  get: function get() {
	    return _index221.default;
	  }
	});
	Object.defineProperty(exports, "startOfYear", {
	  enumerable: true,
	  get: function get() {
	    return _index222.default;
	  }
	});
	Object.defineProperty(exports, "startOfYesterday", {
	  enumerable: true,
	  get: function get() {
	    return _index223.default;
	  }
	});
	Object.defineProperty(exports, "sub", {
	  enumerable: true,
	  get: function get() {
	    return _index224.default;
	  }
	});
	Object.defineProperty(exports, "subBusinessDays", {
	  enumerable: true,
	  get: function get() {
	    return _index225.default;
	  }
	});
	Object.defineProperty(exports, "subDays", {
	  enumerable: true,
	  get: function get() {
	    return _index226.default;
	  }
	});
	Object.defineProperty(exports, "subHours", {
	  enumerable: true,
	  get: function get() {
	    return _index227.default;
	  }
	});
	Object.defineProperty(exports, "subISOWeekYears", {
	  enumerable: true,
	  get: function get() {
	    return _index228.default;
	  }
	});
	Object.defineProperty(exports, "subMilliseconds", {
	  enumerable: true,
	  get: function get() {
	    return _index229.default;
	  }
	});
	Object.defineProperty(exports, "subMinutes", {
	  enumerable: true,
	  get: function get() {
	    return _index230.default;
	  }
	});
	Object.defineProperty(exports, "subMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index231.default;
	  }
	});
	Object.defineProperty(exports, "subQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index232.default;
	  }
	});
	Object.defineProperty(exports, "subSeconds", {
	  enumerable: true,
	  get: function get() {
	    return _index233.default;
	  }
	});
	Object.defineProperty(exports, "subWeeks", {
	  enumerable: true,
	  get: function get() {
	    return _index234.default;
	  }
	});
	Object.defineProperty(exports, "subYears", {
	  enumerable: true,
	  get: function get() {
	    return _index235.default;
	  }
	});
	Object.defineProperty(exports, "toDate", {
	  enumerable: true,
	  get: function get() {
	    return _index236.default;
	  }
	});
	Object.defineProperty(exports, "weeksToDays", {
	  enumerable: true,
	  get: function get() {
	    return _index237.default;
	  }
	});
	Object.defineProperty(exports, "yearsToMonths", {
	  enumerable: true,
	  get: function get() {
	    return _index238.default;
	  }
	});
	Object.defineProperty(exports, "yearsToQuarters", {
	  enumerable: true,
	  get: function get() {
	    return _index239.default;
	  }
	});
	var _index = _interopRequireDefault(__webpack_require__(629));
	var _index2 = _interopRequireDefault(__webpack_require__(630));
	var _index3 = _interopRequireDefault(__webpack_require__(110));
	var _index4 = _interopRequireDefault(__webpack_require__(384));
	var _index5 = _interopRequireDefault(__webpack_require__(631));
	var _index6 = _interopRequireDefault(__webpack_require__(219));
	var _index7 = _interopRequireDefault(__webpack_require__(385));
	var _index8 = _interopRequireDefault(__webpack_require__(220));
	var _index9 = _interopRequireDefault(__webpack_require__(386));
	var _index10 = _interopRequireDefault(__webpack_require__(632));
	var _index11 = _interopRequireDefault(__webpack_require__(272));
	var _index12 = _interopRequireDefault(__webpack_require__(633));
	var _index13 = _interopRequireDefault(__webpack_require__(1574));
	var _index14 = _interopRequireDefault(__webpack_require__(1575));
	var _index15 = _interopRequireDefault(__webpack_require__(1576));
	var _index16 = _interopRequireDefault(__webpack_require__(1577));
	var _index17 = _interopRequireDefault(__webpack_require__(150));
	var _index18 = _interopRequireDefault(__webpack_require__(1578));
	var _index19 = _interopRequireDefault(__webpack_require__(1579));
	var _index20 = _interopRequireDefault(__webpack_require__(1580));
	var _index21 = _interopRequireDefault(__webpack_require__(127));
	var _index22 = _interopRequireDefault(__webpack_require__(634));
	var _index23 = _interopRequireDefault(__webpack_require__(1581));
	var _index24 = _interopRequireDefault(__webpack_require__(387));
	var _index25 = _interopRequireDefault(__webpack_require__(635));
	var _index26 = _interopRequireDefault(__webpack_require__(388));
	var _index27 = _interopRequireDefault(__webpack_require__(389));
	var _index28 = _interopRequireDefault(__webpack_require__(390));
	var _index29 = _interopRequireDefault(__webpack_require__(391));
	var _index30 = _interopRequireDefault(__webpack_require__(1582));
	var _index31 = _interopRequireDefault(__webpack_require__(273));
	var _index32 = _interopRequireDefault(__webpack_require__(392));
	var _index33 = _interopRequireDefault(__webpack_require__(274));
	var _index34 = _interopRequireDefault(__webpack_require__(1583));
	var _index35 = _interopRequireDefault(__webpack_require__(275));
	var _index36 = _interopRequireDefault(__webpack_require__(1584));
	var _index37 = _interopRequireDefault(__webpack_require__(636));
	var _index38 = _interopRequireDefault(__webpack_require__(637));
	var _index39 = _interopRequireDefault(__webpack_require__(1585));
	var _index40 = _interopRequireDefault(__webpack_require__(1586));
	var _index41 = _interopRequireDefault(__webpack_require__(1587));
	var _index42 = _interopRequireDefault(__webpack_require__(1588));
	var _index43 = _interopRequireDefault(__webpack_require__(1589));
	var _index44 = _interopRequireDefault(__webpack_require__(393));
	var _index45 = _interopRequireDefault(__webpack_require__(1590));
	var _index46 = _interopRequireDefault(__webpack_require__(1591));
	var _index47 = _interopRequireDefault(__webpack_require__(1592));
	var _index48 = _interopRequireDefault(__webpack_require__(394));
	var _index49 = _interopRequireDefault(__webpack_require__(1593));
	var _index50 = _interopRequireDefault(__webpack_require__(1594));
	var _index51 = _interopRequireDefault(__webpack_require__(1595));
	var _index52 = _interopRequireDefault(__webpack_require__(1596));
	var _index53 = _interopRequireDefault(__webpack_require__(1597));
	var _index54 = _interopRequireDefault(__webpack_require__(395));
	var _index55 = _interopRequireDefault(__webpack_require__(1598));
	var _index56 = _interopRequireDefault(__webpack_require__(1599));
	var _index57 = _interopRequireDefault(__webpack_require__(1600));
	var _index58 = _interopRequireDefault(__webpack_require__(1601));
	var _index59 = _interopRequireDefault(__webpack_require__(638));
	var _index60 = _interopRequireDefault(__webpack_require__(639));
	var _index61 = _interopRequireDefault(__webpack_require__(1602));
	var _index62 = _interopRequireDefault(__webpack_require__(221));
	var _index63 = _interopRequireDefault(__webpack_require__(640));
	var _index64 = _interopRequireDefault(__webpack_require__(641));
	var _index65 = _interopRequireDefault(__webpack_require__(1603));
	var _index66 = _interopRequireDefault(__webpack_require__(1604));
	var _index67 = _interopRequireDefault(__webpack_require__(1605));
	var _index68 = _interopRequireDefault(__webpack_require__(1606));
	var _index69 = _interopRequireDefault(__webpack_require__(1607));
	var _index70 = _interopRequireDefault(__webpack_require__(1608));
	var _index71 = _interopRequireDefault(__webpack_require__(1609));
	var _index72 = _interopRequireDefault(__webpack_require__(1610));
	var _index73 = _interopRequireDefault(__webpack_require__(1611));
	var _index74 = _interopRequireDefault(__webpack_require__(1612));
	var _index75 = _interopRequireDefault(__webpack_require__(642));
	var _index76 = _interopRequireDefault(__webpack_require__(276));
	var _index77 = _interopRequireDefault(__webpack_require__(1613));
	var _index78 = _interopRequireDefault(__webpack_require__(643));
	var _index79 = _interopRequireDefault(__webpack_require__(1614));
	var _index80 = _interopRequireDefault(__webpack_require__(1615));
	var _index81 = _interopRequireDefault(__webpack_require__(1616));
	var _index82 = _interopRequireDefault(__webpack_require__(1617));
	var _index83 = _interopRequireDefault(__webpack_require__(644));
	var _index84 = _interopRequireDefault(__webpack_require__(645));
	var _index85 = _interopRequireDefault(__webpack_require__(179));
	var _index86 = _interopRequireDefault(__webpack_require__(1618));
	var _index87 = _interopRequireDefault(__webpack_require__(1619));
	var _index88 = _interopRequireDefault(__webpack_require__(1620));
	var _index89 = _interopRequireDefault(__webpack_require__(1621));
	var _index90 = _interopRequireDefault(__webpack_require__(1622));
	var _index91 = _interopRequireDefault(__webpack_require__(646));
	var _index92 = _interopRequireDefault(__webpack_require__(1623));
	var _index93 = _interopRequireDefault(__webpack_require__(647));
	var _index94 = _interopRequireDefault(__webpack_require__(1624));
	var _index95 = _interopRequireDefault(__webpack_require__(648));
	var _index96 = _interopRequireDefault(__webpack_require__(1625));
	var _index97 = _interopRequireDefault(__webpack_require__(649));
	var _index98 = _interopRequireDefault(__webpack_require__(1626));
	var _index99 = _interopRequireDefault(__webpack_require__(1627));
	var _index100 = _interopRequireDefault(__webpack_require__(1628));
	var _index101 = _interopRequireDefault(__webpack_require__(1629));
	var _index102 = _interopRequireDefault(__webpack_require__(1630));
	var _index103 = _interopRequireDefault(__webpack_require__(1631));
	var _index104 = _interopRequireDefault(__webpack_require__(1632));
	var _index105 = _interopRequireDefault(__webpack_require__(1633));
	var _index106 = _interopRequireDefault(__webpack_require__(1634));
	var _index107 = _interopRequireDefault(__webpack_require__(1635));
	var _index108 = _interopRequireDefault(__webpack_require__(650));
	var _index109 = _interopRequireDefault(__webpack_require__(1636));
	var _index110 = _interopRequireDefault(__webpack_require__(1637));
	var _index111 = _interopRequireDefault(__webpack_require__(1638));
	var _index112 = _interopRequireDefault(__webpack_require__(1639));
	var _index113 = _interopRequireDefault(__webpack_require__(1640));
	var _index114 = _interopRequireDefault(__webpack_require__(651));
	var _index115 = _interopRequireDefault(__webpack_require__(652));
	var _index116 = _interopRequireDefault(__webpack_require__(1641));
	var _index117 = _interopRequireDefault(__webpack_require__(1642));
	var _index118 = _interopRequireDefault(__webpack_require__(1643));
	var _index119 = _interopRequireDefault(__webpack_require__(222));
	var _index120 = _interopRequireDefault(__webpack_require__(653));
	var _index121 = _interopRequireDefault(__webpack_require__(654));
	var _index122 = _interopRequireDefault(__webpack_require__(1644));
	var _index123 = _interopRequireDefault(__webpack_require__(655));
	var _index124 = _interopRequireDefault(__webpack_require__(656));
	var _index125 = _interopRequireDefault(__webpack_require__(657));
	var _index126 = _interopRequireDefault(__webpack_require__(658));
	var _index127 = _interopRequireDefault(__webpack_require__(397));
	var _index128 = _interopRequireDefault(__webpack_require__(659));
	var _index129 = _interopRequireDefault(__webpack_require__(660));
	var _index130 = _interopRequireDefault(__webpack_require__(398));
	var _index131 = _interopRequireDefault(__webpack_require__(1645));
	var _index132 = _interopRequireDefault(__webpack_require__(1646));
	var _index133 = _interopRequireDefault(__webpack_require__(1647));
	var _index134 = _interopRequireDefault(__webpack_require__(1648));
	var _index135 = _interopRequireDefault(__webpack_require__(1649));
	var _index136 = _interopRequireDefault(__webpack_require__(1650));
	var _index137 = _interopRequireDefault(__webpack_require__(1651));
	var _index138 = _interopRequireDefault(__webpack_require__(1652));
	var _index139 = _interopRequireDefault(__webpack_require__(1653));
	var _index140 = _interopRequireDefault(__webpack_require__(1654));
	var _index141 = _interopRequireDefault(__webpack_require__(1655));
	var _index142 = _interopRequireDefault(__webpack_require__(1656));
	var _index143 = _interopRequireDefault(__webpack_require__(128));
	var _index144 = _interopRequireDefault(__webpack_require__(1657));
	var _index145 = _interopRequireDefault(__webpack_require__(277));
	var _index146 = _interopRequireDefault(__webpack_require__(1658));
	var _index147 = _interopRequireDefault(__webpack_require__(1659));
	var _index148 = _interopRequireDefault(__webpack_require__(1660));
	var _index149 = _interopRequireDefault(__webpack_require__(1661));
	var _index150 = _interopRequireDefault(__webpack_require__(1662));
	var _index151 = _interopRequireDefault(__webpack_require__(661));
	var _index152 = _interopRequireDefault(__webpack_require__(1663));
	var _index153 = _interopRequireDefault(__webpack_require__(662));
	var _index154 = _interopRequireDefault(__webpack_require__(1664));
	var _index155 = _interopRequireDefault(__webpack_require__(1665));
	var _index156 = _interopRequireDefault(__webpack_require__(663));
	var _index157 = _interopRequireDefault(__webpack_require__(1676));
	var _index158 = _interopRequireDefault(__webpack_require__(1677));
	var _index159 = _interopRequireDefault(__webpack_require__(1678));
	var _index160 = _interopRequireDefault(__webpack_require__(1679));
	var _index161 = _interopRequireDefault(__webpack_require__(664));
	var _index162 = _interopRequireDefault(__webpack_require__(1680));
	var _index163 = _interopRequireDefault(__webpack_require__(1681));
	var _index164 = _interopRequireDefault(__webpack_require__(1682));
	var _index165 = _interopRequireDefault(__webpack_require__(1683));
	var _index166 = _interopRequireDefault(__webpack_require__(1684));
	var _index167 = _interopRequireDefault(__webpack_require__(129));
	var _index168 = _interopRequireDefault(__webpack_require__(1685));
	var _index169 = _interopRequireDefault(__webpack_require__(1686));
	var _index170 = _interopRequireDefault(__webpack_require__(1687));
	var _index171 = _interopRequireDefault(__webpack_require__(1688));
	var _index172 = _interopRequireDefault(__webpack_require__(1689));
	var _index173 = _interopRequireDefault(__webpack_require__(1690));
	var _index174 = _interopRequireDefault(__webpack_require__(1691));
	var _index175 = _interopRequireDefault(__webpack_require__(666));
	var _index176 = _interopRequireDefault(__webpack_require__(1724));
	var _index177 = _interopRequireDefault(__webpack_require__(1725));
	var _index178 = _interopRequireDefault(__webpack_require__(130));
	var _index179 = _interopRequireDefault(__webpack_require__(1726));
	var _index180 = _interopRequireDefault(__webpack_require__(1727));
	var _index181 = _interopRequireDefault(__webpack_require__(1728));
	var _index182 = _interopRequireDefault(__webpack_require__(1729));
	var _index183 = _interopRequireDefault(__webpack_require__(1730));
	var _index184 = _interopRequireDefault(__webpack_require__(1731));
	var _index185 = _interopRequireDefault(__webpack_require__(1732));
	var _index186 = _interopRequireDefault(__webpack_require__(1733));
	var _index187 = _interopRequireDefault(__webpack_require__(1734));
	var _index188 = _interopRequireDefault(__webpack_require__(1735));
	var _index189 = _interopRequireDefault(__webpack_require__(1736));
	var _index190 = _interopRequireDefault(__webpack_require__(1737));
	var _index191 = _interopRequireDefault(__webpack_require__(1738));
	var _index192 = _interopRequireDefault(__webpack_require__(1739));
	var _index193 = _interopRequireDefault(__webpack_require__(1740));
	var _index194 = _interopRequireDefault(__webpack_require__(1741));
	var _index195 = _interopRequireDefault(__webpack_require__(1742));
	var _index196 = _interopRequireDefault(__webpack_require__(1743));
	var _index197 = _interopRequireDefault(__webpack_require__(1744));
	var _index198 = _interopRequireDefault(__webpack_require__(1745));
	var _index199 = _interopRequireDefault(__webpack_require__(1746));
	var _index200 = _interopRequireDefault(__webpack_require__(667));
	var _index201 = _interopRequireDefault(__webpack_require__(1747));
	var _index202 = _interopRequireDefault(__webpack_require__(1748));
	var _index203 = _interopRequireDefault(__webpack_require__(399));
	var _index204 = _interopRequireDefault(__webpack_require__(1749));
	var _index205 = _interopRequireDefault(__webpack_require__(1750));
	var _index206 = _interopRequireDefault(__webpack_require__(1751));
	var _index207 = _interopRequireDefault(__webpack_require__(1752));
	var _index208 = _interopRequireDefault(__webpack_require__(1753));
	var _index209 = _interopRequireDefault(__webpack_require__(278));
	var _index210 = _interopRequireDefault(__webpack_require__(1754));
	var _index211 = _interopRequireDefault(__webpack_require__(668));
	var _index212 = _interopRequireDefault(__webpack_require__(151));
	var _index213 = _interopRequireDefault(__webpack_require__(223));
	var _index214 = _interopRequireDefault(__webpack_require__(400));
	var _index215 = _interopRequireDefault(__webpack_require__(279));
	var _index216 = _interopRequireDefault(__webpack_require__(401));
	var _index217 = _interopRequireDefault(__webpack_require__(669));
	var _index218 = _interopRequireDefault(__webpack_require__(1755));
	var _index219 = _interopRequireDefault(__webpack_require__(1756));
	var _index220 = _interopRequireDefault(__webpack_require__(131));
	var _index221 = _interopRequireDefault(__webpack_require__(402));
	var _index222 = _interopRequireDefault(__webpack_require__(403));
	var _index223 = _interopRequireDefault(__webpack_require__(1757));
	var _index224 = _interopRequireDefault(__webpack_require__(1758));
	var _index225 = _interopRequireDefault(__webpack_require__(1759));
	var _index226 = _interopRequireDefault(__webpack_require__(280));
	var _index227 = _interopRequireDefault(__webpack_require__(1760));
	var _index228 = _interopRequireDefault(__webpack_require__(670));
	var _index229 = _interopRequireDefault(__webpack_require__(224));
	var _index230 = _interopRequireDefault(__webpack_require__(1761));
	var _index231 = _interopRequireDefault(__webpack_require__(671));
	var _index232 = _interopRequireDefault(__webpack_require__(1762));
	var _index233 = _interopRequireDefault(__webpack_require__(1763));
	var _index234 = _interopRequireDefault(__webpack_require__(1764));
	var _index235 = _interopRequireDefault(__webpack_require__(1765));
	var _index236 = _interopRequireDefault(__webpack_require__(6));
	var _index237 = _interopRequireDefault(__webpack_require__(1766));
	var _index238 = _interopRequireDefault(__webpack_require__(1767));
	var _index239 = _interopRequireDefault(__webpack_require__(1768));
	var _index240 = __webpack_require__(42);
	Object.keys(_index240).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  if (key in exports && exports[key] === _index240[key]) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _index240[key];
	    }
	  });
	});

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameWeek;
	var _index = _interopRequireDefault(__webpack_require__(131));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameWeek
	 * @category Week Helpers
	 * @summary Are the given dates in the same week (and month and year)?
	 *
	 * @description
	 * Are the given dates in the same week (and month and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the dates are in the same week (and month and year)
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Are 31 August 2014 and 4 September 2014 in the same week?
	 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
	 * //=> true
	 *
	 * @example
	 * // If week starts with Monday,
	 * // are 31 August 2014 and 4 September 2014 in the same week?
	 * const result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
	 *   weekStartsOn: 1
	 * })
	 * //=> false
	 *
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same week?
	 * const result = isSameWeek(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameWeek(dirtyDateLeft, dirtyDateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfWeek = (0, _index.default)(dirtyDateLeft, options);
	  var dateRightStartOfWeek = (0, _index.default)(dirtyDateRight, options);
	  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSunday;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSunday
	 * @category Weekday Helpers
	 * @summary Is the given date Sunday?
	 *
	 * @description
	 * Is the given date Sunday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 21 September 2014 Sunday?
	 * const result = isSunday(new Date(2014, 8, 21))
	 * //=> true
	 */
	function isSunday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 0;
	}
	module.exports = exports.default;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMonth;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(643));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setMonth
	 * @category Month Helpers
	 * @summary Set the month to the given date.
	 *
	 * @description
	 * Set the month to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} month - the month of the new date
	 * @returns {Date} the new date with the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set February to 1 September 2014:
	 * const result = setMonth(new Date(2014, 8, 1), 1)
	 * //=> Sat Feb 01 2014 00:00:00
	 */
	function setMonth(dirtyDate, dirtyMonth) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var month = (0, _index.default)(dirtyMonth);
	  var year = date.getFullYear();
	  var day = date.getDate();
	  var dateWithDesiredMonth = new Date(0);
	  dateWithDesiredMonth.setFullYear(year, month, 15);
	  dateWithDesiredMonth.setHours(0, 0, 0, 0);
	  var daysInMonth = (0, _index3.default)(dateWithDesiredMonth);
	  // Set the last day of the new month
	  // if the original date was the last day of the longer month
	  date.setMonth(month, Math.min(day, daysInMonth));
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfMinute;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfMinute
	 * @category Minute Helpers
	 * @summary Return the start of a minute for the given date.
	 *
	 * @description
	 * Return the start of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a minute for 1 December 2014 22:15:45.400:
	 * const result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:00
	 */
	function startOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfQuarter;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the start of a year quarter for the given date.
	 *
	 * @description
	 * Return the start of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a quarter for 2 September 2014 11:55:00:
	 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Jul 01 2014 00:00:00
	 */
	function startOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3;
	  date.setMonth(month, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(649));
	var _index2 = _interopRequireDefault(__webpack_require__(131));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var _index5 = __webpack_require__(51);
	/**
	 * @name startOfWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Return the start of a local week-numbering year for the given date.
	 *
	 * @description
	 * Return the start of a local week-numbering year.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the start of a week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // The start of an a week-numbering year for 2 July 2005 with default settings:
	 * const result = startOfWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // The start of a week-numbering year for 2 July 2005
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = startOfWeekYear(new Date(2005, 6, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Mon Jan 03 2005 00:00:00
	 */
	function startOfWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfYear
	 * @category Year Helpers
	 * @summary Return the start of a year for the given date.
	 *
	 * @description
	 * Return the start of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a year for 2 September 2014 11:55:00:
	 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Jan 01 2014 00:00:00
	 */
	function startOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var cleanDate = (0, _index.default)(dirtyDate);
	  var date = new Date(0);
	  date.setFullYear(cleanDate.getFullYear(), 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(63),
		__webpack_require__(154)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(180),
		__webpack_require__(53),
		__webpack_require__(132)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isFunction, rnothtmlwhite ) {
	
	"use strict";
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(132)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( rnothtmlwhite ) {
		"use strict";
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
		return stripAndCollapse;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(285),
		__webpack_require__(154)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, documentElement, support ) {
	
	"use strict";
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (trac-8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			//
			// Support: Firefox 70+
			// Only Firefox includes border widths
			// in computed dimensions. (gh-4529)
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
					tr.style.cssText = "box-sizing:content-box;border:1px solid";
	
					// Support: Chrome 86+
					// Height set through cssText does not get applied.
					// Computed height then comes back as 0.
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					// Support: Android 8 Chrome 86+
					// In our bodyBackground.html iframe,
					// display for all div elements is set to "inline",
					// which causes a problem only in Android 8 Chrome 86.
					// Ensuring the div is `display: block`
					// gets around this issue.
					trChild.style.display = "block";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
						parseInt( trStyle.borderTopWidth, 10 ) +
						parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return [ "Top", "Right", "Bottom", "Left" ];
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(705)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {
		"use strict";
	
		return new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(225),
		__webpack_require__(63),
		__webpack_require__(53),
		__webpack_require__(414),
		__webpack_require__(132),
		__webpack_require__(408),
		__webpack_require__(686),
		__webpack_require__(682),
		__webpack_require__(112),
		__webpack_require__(1804),
	
		__webpack_require__(94),
		__webpack_require__(411),
		__webpack_require__(181),
		__webpack_require__(182),
		__webpack_require__(283),
		__webpack_require__(226),
		__webpack_require__(1813)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, camelCase, document, isFunction, rcssNum, rnothtmlwhite, cssExpand,
		isHiddenWithinTree, adjustCSS, dataPriv, showHide ) {
	
	"use strict";
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
					/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
	
			doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(112),
		__webpack_require__(181),
		__webpack_require__(405)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv ) {
	
	"use strict";
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
		"use strict";
	
		return arr.push;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /^(?:checkbox|radio)$/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(705)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( pnum ) {
	
	"use strict";
	
	return new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(156),
	    root = __webpack_require__(95);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1917),
	    mapCacheDelete = __webpack_require__(1918),
	    mapCacheGet = __webpack_require__(1919),
	    mapCacheHas = __webpack_require__(1920),
	    mapCacheSet = __webpack_require__(1921);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(416),
	    setCacheAdd = __webpack_require__(1928),
	    setCacheHas = __webpack_require__(1929);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(288),
	    stackClear = __webpack_require__(1931),
	    stackDelete = __webpack_require__(1932),
	    stackGet = __webpack_require__(1933),
	    stackHas = __webpack_require__(1934),
	    stackSet = __webpack_require__(1935);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 419 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(725);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(418),
	    arrayEach = __webpack_require__(1840),
	    assignValue = __webpack_require__(716),
	    baseAssign = __webpack_require__(1842),
	    baseAssignIn = __webpack_require__(1843),
	    cloneBuffer = __webpack_require__(1878),
	    copyArray = __webpack_require__(724),
	    copySymbols = __webpack_require__(1885),
	    copySymbolsIn = __webpack_require__(1886),
	    getAllKeys = __webpack_require__(728),
	    getAllKeysIn = __webpack_require__(729),
	    getTag = __webpack_require__(295),
	    initCloneArray = __webpack_require__(1906),
	    initCloneByTag = __webpack_require__(1907),
	    initCloneObject = __webpack_require__(1908),
	    isArray = __webpack_require__(43),
	    isBuffer = __webpack_require__(434),
	    isMap = __webpack_require__(1949),
	    isObject = __webpack_require__(83),
	    isSet = __webpack_require__(1950),
	    keys = __webpack_require__(187),
	    keysIn = __webpack_require__(437);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(419),
	    isFlattenable = __webpack_require__(1909);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1852),
	    isObjectLike = __webpack_require__(96);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 424 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(710);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(733);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(711),
	    stubArray = __webpack_require__(747);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 428 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(43),
	    isSymbol = __webpack_require__(158);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 430 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(727);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(448)(module)))

/***/ },
/* 432 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1851),
	    isObjectLike = __webpack_require__(96);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(95),
	    stubFalse = __webpack_require__(1959);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(448)(module)))

/***/ },
/* 435 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(133),
	    getPrototype = __webpack_require__(426),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(714),
	    baseKeysIn = __webpack_require__(1860),
	    isArrayLike = __webpack_require__(157);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(422),
	    baseOrderBy = __webpack_require__(1863),
	    baseRest = __webpack_require__(723),
	    isIterateeCall = __webpack_require__(296);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1969)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Manager = Manager;
	exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var ManagerReferenceNodeContext = React.createContext();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = React.createContext();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	function Manager(_ref) {
	  var children = _ref.children;
	
	  var _React$useState = React.useState(null),
	      referenceNode = _React$useState[0],
	      setReferenceNode = _React$useState[1];
	
	  var hasUnmounted = React.useRef(false);
	  React.useEffect(function () {
	    return function () {
	      hasUnmounted.current = true;
	    };
	  }, []);
	  var handleSetReferenceNode = React.useCallback(function (node) {
	    if (!hasUnmounted.current) {
	      setReferenceNode(node);
	    }
	  }, []);
	  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
	    value: referenceNode
	  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	    value: handleSetReferenceNode
	  }, children));
	}

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useIsomorphicLayoutEffect = exports.fromEntries = exports.setRef = exports.safeInvoke = exports.unwrapArray = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === 'function') {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === 'function') {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	/**
	 * Simple ponyfill for Object.fromEntries
	 */
	
	
	exports.setRef = setRef;
	
	var fromEntries = function fromEntries(entries) {
	  return entries.reduce(function (acc, _ref) {
	    var key = _ref[0],
	        value = _ref[1];
	    acc[key] = value;
	    return acc;
	  }, {});
	};
	/**
	 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
	 */
	
	
	exports.fromEntries = fromEntries;
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(299));
	
	var _max2 = _interopRequireDefault(__webpack_require__(742));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _get2 = _interopRequireDefault(__webpack_require__(185));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _Curve = _interopRequireDefault(__webpack_require__(191));
	
	var _Dot = _interopRequireDefault(__webpack_require__(160));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Area =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Area, _PureComponent);
	
	  function Area() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Area)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-area-');
	
	    _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Area, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points,
	          baseLine = _this$props.baseLine;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (isAnimationActive && !isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          points = _this$props2.points,
	          dataKey = _this$props2.dataKey;
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, areaProps, {}, customDotProps, {}, dotEvents, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-area-dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderHorizontalRect",
	    value: function renderHorizontalRect(alpha) {
	      var _this$props3 = this.props,
	          baseLine = _this$props3.baseLine,
	          points = _this$props3.points,
	          strokeWidth = _this$props3.strokeWidth;
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = (0, _max2["default"])(points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxY = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxY)) {
	        return _react["default"].createElement("rect", {
	          x: startX < endX ? startX : startX - width,
	          y: 0,
	          width: width,
	          height: parseInt(maxY + (strokeWidth || 1), 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderVerticalRect",
	    value: function renderVerticalRect(alpha) {
	      var _this$props4 = this.props,
	          baseLine = _this$props4.baseLine,
	          points = _this$props4.points,
	          strokeWidth = _this$props4.strokeWidth;
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = (0, _max2["default"])(points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else if (baseLine && (0, _isArray2["default"])(baseLine) && baseLine.length) {
	        maxX = Math.max((0, _max2["default"])(baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxX)) {
	        return _react["default"].createElement("rect", {
	          x: 0,
	          y: startY < endY ? startY : startY - height,
	          width: maxX + (strokeWidth || 1),
	          height: parseInt(height, 10)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderClipRect",
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: "renderAreaStatically",
	    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
	      var _this$props5 = this.props,
	          layout = _this$props5.layout,
	          type = _this$props5.type,
	          stroke = _this$props5.stroke,
	          connectNulls = _this$props5.connectNulls,
	          isRange = _this$props5.isRange;
	      return _react["default"].createElement(_Layer["default"], {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, _react["default"].createElement(_Curve["default"], _extends({}, this.props, {
	        points: points,
	        baseLine: baseLine,
	        stroke: "none",
	        className: "recharts-area-area"
	      })), stroke !== 'none' && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: points
	      })), stroke !== 'none' && isRange && _react["default"].createElement(_Curve["default"], _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: "recharts-area-curve",
	        layout: layout,
	        type: type,
	        connectNulls: connectNulls,
	        fill: "none",
	        points: baseLine
	      })));
	    }
	  }, {
	    key: "renderAreaWithAnimation",
	    value: function renderAreaWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          baseLine = _this$props6.baseLine,
	          isAnimationActive = _this$props6.isAnimationActive,
	          animationBegin = _this$props6.animationBegin,
	          animationDuration = _this$props6.animationDuration,
	          animationEasing = _this$props6.animationEasing,
	          animationId = _this$props6.animationId;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "area-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion
	
	          var stepPoints = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            }
	
	            return entry;
	          });
	          var stepBaseLine;
	
	          if ((0, _DataUtils.isNumber)(baseLine)) {
	            var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	            stepBaseLine = interpolator(t);
	          } else if ((0, _isNil2["default"])(baseLine) || (0, _isNaN2["default"])(baseLine)) {
	            var _interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, 0);
	
	            stepBaseLine = _interpolator(t);
	          } else {
	            stepBaseLine = baseLine.map(function (entry, index) {
	              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	              if (prevBaseLine[prevPointIndex]) {
	                var prev = prevBaseLine[prevPointIndex];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	                return _objectSpread({}, entry, {
	                  x: interpolatorX(t),
	                  y: interpolatorY(t)
	                });
	              }
	
	              return entry;
	            });
	          }
	
	          return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
	        }
	
	        return _react["default"].createElement(_Layer["default"], null, _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	          id: "animationClipPath-".concat(clipPathId)
	        }, _this3.renderClipRect(t))), _react["default"].createElement(_Layer["default"], {
	          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
	        }, _this3.renderAreaStatically(points, baseLine, needClip, clipPathId)));
	      });
	    }
	  }, {
	    key: "renderArea",
	    value: function renderArea(needClip, clipPathId) {
	      var _this$props7 = this.props,
	          points = _this$props7.points,
	          baseLine = _this$props7.baseLine,
	          isAnimationActive = _this$props7.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          prevBaseLine = _this$state2.prevBaseLine,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points) || !(0, _isEqual2["default"])(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props8 = this.props,
	          hide = _this$props8.hide,
	          dot = _this$props8.dot,
	          points = _this$props8.points,
	          className = _this$props8.className,
	          top = _this$props8.top,
	          left = _this$props8.left,
	          xAxis = _this$props8.xAxis,
	          yAxis = _this$props8.yAxis,
	          width = _this$props8.width,
	          height = _this$props8.height,
	          isAnimationActive = _this$props8.isAnimationActive,
	          id = _this$props8.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: parseInt(height, 10)
	      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }]);
	
	  return Area;
	}(_react.PureComponent);
	
	Area.displayName = 'Area';
	Area.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  connectNulls: _propTypes["default"].bool,
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // dot configuration
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object, _propTypes["default"].bool]),
	  hide: _propTypes["default"].bool,
	  // have curve configuration
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	  isRange: _propTypes["default"].bool,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Area.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Area.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	};
	
	Area.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	  var points = displayedData.map(function (entry, index) {
	    var value;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  var baseLine;
	
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      if (layout === 'horizontal') {
	        return {
	          x: entry.x,
	          y: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? yAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null
	        };
	      }
	
	      return {
	        x: !(0, _isNil2["default"])((0, _get2["default"])(entry, 'value[0]')) ? xAxis.scale((0, _get2["default"])(entry, 'value[0]')) : null,
	        y: entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _objectSpread({
	    points: points,
	    baseLine: baseLine,
	    layout: layout,
	    isRange: isRange
	  }, offset);
	};
	
	Area.renderDotItem = function (option, props) {
	  var dotItem;
	
	  if (_react["default"].isValidElement(option)) {
	    dotItem = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	      className: "recharts-area-dot"
	    }));
	  }
	
	  return dotItem;
	};
	
	var _default = Area;
	exports["default"] = _default;

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(192));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(232));
	
	var _Cell = _interopRequireDefault(__webpack_require__(190));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Bar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Bar, _PureComponent);
	
	  function Bar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-bar-');
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Bar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "renderRectanglesStatically",
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return data && data.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {}, entry, {
	          index: i
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-bar-rectangle"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderRectangle(shape, props));
	      });
	    }
	  }, {
	    key: "renderRectanglesWithAnimation",
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          data = _this$props2.data,
	          layout = _this$props2.layout,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "bar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	            var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	            var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	            return _objectSpread({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t),
	              width: interpolatorWidth(t),
	              height: interpolatorHeight(t)
	            });
	          }
	
	          if (layout === 'horizontal') {
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	
	            var h = _interpolatorHeight(t);
	
	            return _objectSpread({}, entry, {
	              y: entry.y + entry.height - h,
	              height: h
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	          var w = interpolator(t);
	          return _objectSpread({}, entry, {
	            width: w
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderRectanglesStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderRectangles",
	    value: function renderRectangles() {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this4 = this;
	
	      var data = this.props.data;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return data.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({}, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "background-bar-".concat(i),
	          className: 'recharts-bar-background-rectangle'
	        });
	
	        return _this4.constructor.renderRectangle(_this4.props.background, props);
	      });
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          layout = _this$props4.layout,
	          children = _this$props4.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: "error-bar-".concat(i),
	          // eslint-disable-line react/no-array-index-key
	          data: data,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          offset: offset,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          hide = _this$props5.hide,
	          data = _this$props5.data,
	          className = _this$props5.className,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          left = _this$props5.left,
	          top = _this$props5.top,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          isAnimationActive = _this$props5.isAnimationActive,
	          background = _this$props5.background,
	          id = _this$props5.id;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, _react["default"].createElement(_Layer["default"], {
	        className: "recharts-bar-rectangles",
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, data));
	    }
	  }], [{
	    key: "renderRectangle",
	    value: function renderRectangle(option, props) {
	      var rectangle;
	
	      if (_react["default"].isValidElement(option)) {
	        rectangle = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react["default"].createElement(_Rectangle["default"], props);
	      }
	
	      return rectangle;
	    }
	  }]);
	
	  return Bar;
	}(_react.PureComponent);
	
	Bar.displayName = 'Bar';
	Bar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  layout: _propTypes["default"].oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  stackId: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  barSize: _propTypes["default"].number,
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  hide: _propTypes["default"].bool,
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number,
	    radius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].array]),
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array])
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  animationId: _propTypes["default"].number,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes["default"].string
	});
	Bar.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Bar.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      item = _ref2.item,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      stackedData = _ref2.stackedData,
	      dataStartIndex = _ref2.dataStartIndex,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var rects = displayedData.map(function (entry, index) {
	    var value, x, y, width, height, background;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	      background = {
	        x: x,
	        y: yAxis.y,
	        width: width,
	        height: yAxis.height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	      background = {
	        x: xAxis.x,
	        y: y,
	        width: xAxis.width,
	        height: height
	      };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	
	        width += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {
	      x: x,
	      y: y,
	      width: width,
	      height: height,
	      value: stackedData ? value : value[1],
	      payload: entry,
	      background: background
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    data: rects,
	    layout: layout
	  }, offset);
	};
	
	var _default = Bar;
	exports["default"] = _default;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Curve = _interopRequireDefault(__webpack_require__(191));
	
	var _Dot = _interopRequireDefault(__webpack_require__(160));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(232));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Line =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Line, _PureComponent);
	
	  function Line() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-line-');
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      _this.props.onAnimationEnd();
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      _this.props.onAnimationStart();
	    };
	
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({
	        totalLength: totalLength
	      });
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "getTotalLength",
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	
	      try {
	        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	      } catch (err) {
	        return 0;
	      }
	    }
	  }, {
	    key: "getStrokeDasharray",
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	      var remainLines = [];
	
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	      return [].concat(_toConsumableArray(this.constructor.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return "".concat(line, "px");
	      }).join(', ');
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          points = _this$props2.points,
	          xAxis = _this$props2.xAxis,
	          yAxis = _this$props2.yAxis,
	          layout = _this$props2.layout,
	          children = _this$props2.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          dot = _this$props3.dot,
	          points = _this$props3.points,
	          dataKey = _this$props3.dataKey;
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, lineProps, {}, customDotProps, {}, dotEvents, {
	          value: entry.value,
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      };
	      return _react["default"].createElement(_Layer["default"], _extends({
	        className: "recharts-line-dots",
	        key: "dots"
	      }, dotsProps), dots);
	    }
	  }, {
	    key: "renderCurveStatically",
	    value: function renderCurveStatically(points, needClip, clipPathId, props) {
	      var _this$props4 = this.props,
	          type = _this$props4.type,
	          layout = _this$props4.layout,
	          connectNulls = _this$props4.connectNulls;
	
	      var curveProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
	        points: points
	      }, props, {
	        type: type,
	        layout: layout,
	        connectNulls: connectNulls
	      });
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, curveProps, {
	        pathRef: this.pathRef
	      }));
	    }
	  }, {
	    key: "renderCurveWithAnimation",
	    value: function renderCurveWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          strokeDasharray = _this$props5.strokeDasharray,
	          isAnimationActive = _this$props5.isAnimationActive,
	          animationBegin = _this$props5.animationBegin,
	          animationDuration = _this$props5.animationDuration,
	          animationEasing = _this$props5.animationEasing,
	          animationId = _this$props5.animationId,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      var _this$state = this.state,
	          prevPoints = _this$state.prevPoints,
	          totalLength = _this$state.totalLength;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "line-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	
	        if (prevPoints) {
	          var prevPointsDiffFactor = prevPoints.length / points.length;
	          var stepData = points.map(function (entry, index) {
	            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
	
	            if (prevPoints[prevPointIndex]) {
	              var prev = prevPoints[prevPointIndex];
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              return _objectSpread({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t)
	              });
	            } // magic number of faking previous x and y location
	
	
	            if (_this3.animateNewValues) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(width * 2, entry.x);
	
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(height / 2, entry.y);
	
	              return _objectSpread({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            return _objectSpread({}, entry, {
	              x: entry.x,
	              y: entry.y
	            });
	          });
	          return _this3.renderCurveStatically(stepData, needClip, clipPathId);
	        }
	
	        var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	        var curLength = interpolator(t);
	        var currentStrokeDasharray;
	
	        if (strokeDasharray) {
	          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	            return parseFloat(num);
	          });
	          currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	        } else {
	          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
	        }
	
	        return _this3.renderCurveStatically(points, needClip, clipPathId, {
	          strokeDasharray: currentStrokeDasharray
	        });
	      });
	    }
	  }, {
	    key: "renderCurve",
	    value: function renderCurve(needClip, clipPathId) {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	      var _this$state2 = this.state,
	          prevPoints = _this$state2.prevPoints,
	          totalLength = _this$state2.totalLength;
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderCurveStatically(points, needClip, clipPathId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          dot = _this$props7.dot,
	          points = _this$props7.points,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          top = _this$props7.top,
	          left = _this$props7.left,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          isAnimationActive = _this$props7.isAnimationActive,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames["default"])('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "repeat",
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames["default"])('recharts-line-dot', option ? option.className : '');
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: className
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Line;
	}(_react.PureComponent);
	
	Line.displayName = 'Line';
	Line.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  unit: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxis: _propTypes["default"].object,
	  xAxis: _propTypes["default"].object,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes["default"].bool,
	  hide: _propTypes["default"].bool,
	  // whether have dot in line
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animateNewValues: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes["default"].number,
	  id: _propTypes["default"].string
	});
	Line.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animateNewValues: true,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	};
	
	Line.getComposedData = function (_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize,
	      displayedData = _ref2.displayedData,
	      offset = _ref2.offset;
	  var layout = props.layout;
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({
	          axis: xAxis,
	          ticks: xAxisTicks,
	          bandSize: bandSize,
	          entry: entry,
	          index: index
	        }),
	        y: (0, _isNil2["default"])(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil2["default"])(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        entry: entry,
	        index: index
	      }),
	      value: value,
	      payload: entry
	    };
	  });
	  return _objectSpread({
	    points: points,
	    layout: layout
	  }, offset);
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(305));
	
	var _Curve = _interopRequireDefault(__webpack_require__(191));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(447));
	
	var _ErrorBar = _interopRequireDefault(__webpack_require__(232));
	
	var _Cell = _interopRequireDefault(__webpack_require__(190));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Scatter =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Scatter, _PureComponent);
	
	  function Scatter() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scatter)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevPoints = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    };
	
	    _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationFinished: false
	      });
	    };
	
	    _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-');
	    return _this;
	  }
	
	  _createClass(Scatter, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: "renderSymbolsStatically",
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          shape = _this$props2.shape,
	          activeShape = _this$props2.activeShape,
	          activeIndex = _this$props2.activeIndex;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      return points.map(function (entry, i) {
	        var props = _objectSpread({
	          key: "symbol-".concat(i)
	        }, baseProps, {}, entry);
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-scatter-symbol"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
	      });
	    }
	  }, {
	    key: "renderSymbolsWithAnimation",
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          points = _this$props3.points,
	          isAnimationActive = _this$props3.isAnimationActive,
	          animationBegin = _this$props3.animationBegin,
	          animationDuration = _this$props3.animationDuration,
	          animationEasing = _this$props3.animationEasing,
	          animationId = _this$props3.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[index];
	
	          if (prev) {
	            var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	            var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	            var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	            return _objectSpread({}, entry, {
	              cx: interpolatorCx(t),
	              cy: interpolatorCy(t),
	              size: interpolatorSize(t)
	            });
	          }
	
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	          return _objectSpread({}, entry, {
	            size: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSymbolsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSymbols",
	    value: function renderSymbols() {
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: "renderErrorBar",
	    value: function renderErrorBar() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          xAxis = _this$props5.xAxis,
	          yAxis = _this$props5.yAxis,
	          children = _this$props5.children;
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar["default"]);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.node.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	        return _react["default"].cloneElement(item, {
	          key: i,
	          // eslint-disable-line react/no-array-index-key
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: "renderLine",
	    value: function renderLine() {
	      var _this$props6 = this.props,
	          points = _this$props6.points,
	          line = _this$props6.line,
	          lineType = _this$props6.lineType,
	          lineJointType = _this$props6.lineJointType;
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints, lineItem;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return {
	            x: entry.cx,
	            y: entry.cy
	          };
	        });
	      } else if (lineType === 'fitting') {
	        var _getLinearRegression = (0, _DataUtils.getLinearRegression)(points),
	            xmin = _getLinearRegression.xmin,
	            xmax = _getLinearRegression.xmax,
	            a = _getLinearRegression.a,
	            b = _getLinearRegression.b;
	
	        var linearExp = function linearExp(x) {
	          return a * x + b;
	        };
	
	        linePoints = [{
	          x: xmin,
	          y: linearExp(xmin)
	        }, {
	          x: xmax,
	          y: linearExp(xmax)
	        }];
	      }
	
	      var lineProps = _objectSpread({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react["default"].isValidElement(line)) {
	        lineItem = _react["default"].cloneElement(line, lineProps);
	      } else if ((0, _isFunction2["default"])(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react["default"].createElement(_Curve["default"], _extends({}, lineProps, {
	          type: lineJointType
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-scatter-line",
	        key: "recharts-scatter-line"
	      }, lineItem);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          hide = _this$props7.hide,
	          points = _this$props7.points,
	          line = _this$props7.line,
	          className = _this$props7.className,
	          xAxis = _this$props7.xAxis,
	          yAxis = _this$props7.yAxis,
	          left = _this$props7.left,
	          top = _this$props7.top,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          id = _this$props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isAnimationActive = _this$state.isAnimationActive,
	          isAnimationFinished = _this$state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil2["default"])(id) ? this.id : id;
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
	      }, needClip ? _react["default"].createElement("defs", null, _react["default"].createElement("clipPath", {
	        id: "clipPath-".concat(clipPathId)
	      }, _react["default"].createElement("rect", {
	        x: left,
	        y: top,
	        width: width,
	        height: height
	      }))) : null, line && this.renderLine(), this.renderErrorBar(), _react["default"].createElement(_Layer["default"], {
	        key: "recharts-scatter-symbols"
	      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderSymbolItem",
	    value: function renderSymbolItem(option, props) {
	      var symbol;
	
	      if (_react["default"].isValidElement(option)) {
	        symbol = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react["default"].createElement(_Symbols["default"], _extends({}, props, {
	          type: option
	        }));
	      }
	
	      return symbol;
	    }
	  }]);
	
	  return Scatter;
	}(_react.PureComponent);
	
	Scatter.displayName = 'Scatter';
	Scatter.propTypes = _objectSpread({}, _ReactUtils.EVENT_ATTRIBUTES, {}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  zAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  line: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  lineType: _propTypes["default"].oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes["default"].func]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  className: _propTypes["default"].string,
	  name: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  activeIndex: _propTypes["default"].number,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes["default"].element, _propTypes["default"].func]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    size: _propTypes["default"].number,
	    node: _propTypes["default"].shape({
	      x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	      z: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	    }),
	    payload: _propTypes["default"].any
	  })),
	  hide: _propTypes["default"].bool,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Scatter.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	};
	
	Scatter.getComposedData = function (_ref2) {
	  var xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      zAxis = _ref2.zAxis,
	      item = _ref2.item,
	      displayedData = _ref2.displayedData,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter,
	      offset = _ref2.offset,
	      xAxisTicks = _ref2.xAxisTicks,
	      yAxisTicks = _ref2.yAxisTicks;
	  var tooltipType = item.props.tooltipType;
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell["default"]);
	  var xAxisDataKey = (0, _isNil2["default"])(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil2["default"])(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis["default"].defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
	  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil2["default"])(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{
	      name: xAxis.name || xAxis.dataKey,
	      unit: xAxis.unit || '',
	      value: x,
	      payload: entry,
	      dataKey: xAxisDataKey,
	      type: tooltipType
	    }, {
	      name: yAxis.name || yAxis.dataKey,
	      unit: yAxis.unit || '',
	      value: y,
	      payload: entry,
	      dataKey: yAxisDataKey,
	      type: tooltipType
	    }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey,
	        unit: zAxis.unit || '',
	        value: z,
	        payload: entry,
	        dataKey: zAxisDataKey,
	        type: tooltipType
	      });
	    }
	
	    var cx = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: xAxis,
	      ticks: xAxisTicks,
	      bandSize: xBandSize,
	      entry: entry,
	      index: index,
	      dataKey: xAxisDataKey
	    });
	    var cy = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: yAxis,
	      ticks: yAxisTicks,
	      bandSize: yBandSize,
	      entry: entry,
	      index: index,
	      dataKey: yAxisDataKey
	    });
	    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
	    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
	    return _objectSpread({}, entry, {
	      cx: cx,
	      cy: cy,
	      x: cx - radius,
	      y: cy - radius,
	      xAxis: xAxis,
	      yAxis: yAxis,
	      zAxis: zAxis,
	      width: 2 * radius,
	      height: 2 * radius,
	      size: size,
	      node: {
	        x: x,
	        y: y,
	        z: z
	      },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: {
	        x: cx,
	        y: cy
	      },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	  return _objectSpread({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	};
	
	var _default = Scatter;
	exports["default"] = _default;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _uniqBy2 = _interopRequireDefault(__webpack_require__(751));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _DefaultLegendContent = _interopRequireDefault(__webpack_require__(2018));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(19);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultUniqBy = function defaultUniqBy(entry) {
	  return entry.value;
	};
	
	var getUniqPaylod = function getUniqPaylod(option, payload) {
	  if (option === true) {
	    return (0, _uniqBy2["default"])(payload, defaultUniqBy);
	  }
	
	  if ((0, _isFunction2["default"])(option)) {
	    return (0, _uniqBy2["default"])(payload, option);
	  }
	
	  return payload;
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react["default"].isValidElement(content)) {
	    return _react["default"].cloneElement(content, props);
	  }
	
	  if ((0, _isFunction2["default"])(content)) {
	    return content(props);
	  }
	
	  return _react["default"].createElement(_DefaultLegendContent["default"], props);
	};
	
	var EPS = 1;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Legend, _PureComponent);
	
	  function Legend() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Legend)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    };
	    return _this;
	  }
	
	  _createClass(Legend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: "getBBox",
	    value: function getBBox() {
	      var _this$state = this.state,
	          boxWidth = _this$state.boxWidth,
	          boxHeight = _this$state.boxHeight;
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return {
	          width: boxWidth,
	          height: boxHeight
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: "getDefaultPosition",
	    value: function getDefaultPosition(style) {
	      var _this$props = this.props,
	          layout = _this$props.layout,
	          align = _this$props.align,
	          verticalAlign = _this$props.verticalAlign,
	          margin = _this$props.margin,
	          chartWidth = _this$props.chartWidth,
	          chartHeight = _this$props.chartHeight;
	      var hPos, vPos;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || {
	            width: 0
	          };
	          hPos = {
	            left: ((chartWidth || 0) - box.width) / 2
	          };
	        } else {
	          hPos = align === 'right' ? {
	            right: margin && margin.right || 0
	          } : {
	            left: margin && margin.left || 0
	          };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || {
	            height: 0
	          };
	
	          vPos = {
	            top: ((chartHeight || 0) - _box.height) / 2
	          };
	        } else {
	          vPos = verticalAlign === 'bottom' ? {
	            bottom: margin && margin.bottom || 0
	          } : {
	            top: margin && margin.top || 0
	          };
	        }
	      }
	
	      return _objectSpread({}, hPos, {}, vPos);
	    }
	  }, {
	    key: "updateBBox",
	    value: function updateBBox() {
	      var _this$state2 = this.state,
	          boxWidth = _this$state2.boxWidth,
	          boxHeight = _this$state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          content = _this$props2.content,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          wrapperStyle = _this$props2.wrapperStyle,
	          paylodUniqBy = _this$props2.paylodUniqBy,
	          payload = _this$props2.payload;
	
	      var outerStyle = _objectSpread({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), {}, wrapperStyle);
	
	      return _react["default"].createElement("div", {
	        className: "recharts-legend-wrapper",
	        style: outerStyle,
	        ref: function ref(node) {
	          _this2.wrapperNode = node;
	        }
	      }, renderContent(content, _objectSpread({}, this.props, {
	        payload: getUniqPaylod(paylodUniqBy, payload)
	      })));
	    }
	  }], [{
	    key: "getWithHeight",
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      }
	
	      if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.PureComponent);
	
	Legend.displayName = 'Legend';
	Legend.propTypes = {
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  wrapperStyle: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    left: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    right: _propTypes["default"].number
	  }),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  paylodUniqBy: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  onBBoxUpdate: _propTypes["default"].func
	};
	Legend.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	};
	var _default = Legend;
	exports["default"] = _default;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _d3Shape = __webpack_require__(381);
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle,
	  symbolCross: _d3Shape.symbolCross,
	  symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare,
	  symbolStar: _d3Shape.symbolStar,
	  symbolTriangle: _d3Shape.symbolTriangle,
	  symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = "symbol".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	
	    case 'square':
	      return size * size;
	
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Symbols, _PureComponent);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Symbols).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: "getPath",
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _this$props = this.props,
	          size = _this$props.size,
	          sizeType = _this$props.sizeType,
	          type = _this$props.type;
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	      return symbol();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          className = _this$props2.className,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          size = _this$props2.size;
	
	      if (cx === +cx && cy === +cy && size === +size) {
	        return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames["default"])('recharts-symbols', className),
	          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.PureComponent);
	
	Symbols.displayName = 'Symbols';
	Symbols.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  type: _propTypes["default"].oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  size: _propTypes["default"].number,
	  sizeType: _propTypes["default"].oneOf(['area', 'diameter'])
	});
	Symbols.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	};
	var _default = Symbols;
	exports["default"] = _default;

/***/ },
/* 448 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(450);
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 450 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(84)["default"];
	var toPrimitive = __webpack_require__(779);
	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var sheet = __webpack_require__(453);
	var Stylis = _interopDefault(__webpack_require__(785));
	__webpack_require__(787);
	
	// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
	// inlined to avoid umd wrapper and peerDep warnings/installing stylis
	// since we use stylis after closure compiler
	var delimiter = '/*|*/';
	var needle = delimiter + '}';
	
	function toSheet(block) {
	  if (block) {
	    Sheet.current.insert(block + '}');
	  }
	}
	
	var Sheet = {
	  current: null
	};
	var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
	  switch (context) {
	    // property
	    case 1:
	      {
	        switch (content.charCodeAt(0)) {
	          case 64:
	            {
	              // @import
	              Sheet.current.insert(content + ';');
	              return '';
	            }
	          // charcode for l
	
	          case 108:
	            {
	              // charcode for b
	              // this ignores label
	              if (content.charCodeAt(2) === 98) {
	                return '';
	              }
	            }
	        }
	
	        break;
	      }
	    // selector
	
	    case 2:
	      {
	        if (ns === 0) return content + delimiter;
	        break;
	      }
	    // at-rule
	
	    case 3:
	      {
	        switch (ns) {
	          // @font-face, @page
	          case 102:
	          case 112:
	            {
	              Sheet.current.insert(selectors[0] + content);
	              return '';
	            }
	
	          default:
	            {
	              return content + (at === 0 ? delimiter : '');
	            }
	        }
	      }
	
	    case -2:
	      {
	        content.split(needle).forEach(toSheet);
	      }
	  }
	};
	
	var createCache = function createCache(options) {
	  if (options === undefined) options = {};
	  var key = options.key || 'css';
	  var stylisOptions;
	
	  if (options.prefix !== undefined) {
	    stylisOptions = {
	      prefix: options.prefix
	    };
	  }
	
	  var stylis = new Stylis(stylisOptions);
	
	  if (false) {
	    // $FlowFixMe
	    if (/[^a-z-]/.test(key)) {
	      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
	    }
	  }
	
	  var inserted = {}; // $FlowFixMe
	
	  var container;
	
	  {
	    container = options.container || document.head;
	    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
	    Array.prototype.forEach.call(nodes, function (node) {
	      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
	
	      attrib.split(' ').forEach(function (id) {
	        inserted[id] = true;
	      });
	
	      if (node.parentNode !== container) {
	        container.appendChild(node);
	      }
	    });
	  }
	
	  var _insert;
	
	  {
	    stylis.use(options.stylisPlugins)(ruleSheet);
	
	    _insert = function insert(selector, serialized, sheet, shouldCache) {
	      var name = serialized.name;
	      Sheet.current = sheet;
	
	      if (false) {
	        var map = serialized.map;
	        Sheet.current = {
	          insert: function insert(rule) {
	            sheet.insert(rule + map);
	          }
	        };
	      }
	
	      stylis(selector, serialized.styles);
	
	      if (shouldCache) {
	        cache.inserted[name] = true;
	      }
	    };
	  }
	
	  if (false) {
	    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
	    var commentStart = /\/\*/g;
	    var commentEnd = /\*\//g;
	    stylis.use(function (context, content) {
	      switch (context) {
	        case -1:
	          {
	            while (commentStart.test(content)) {
	              commentEnd.lastIndex = commentStart.lastIndex;
	
	              if (commentEnd.test(content)) {
	                commentStart.lastIndex = commentEnd.lastIndex;
	                continue;
	              }
	
	              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
	            }
	
	            commentStart.lastIndex = 0;
	            break;
	          }
	      }
	    });
	    stylis.use(function (context, content, selectors) {
	      switch (context) {
	        case -1:
	          {
	            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
	            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
	
	            if (unsafePseudoClasses && cache.compat !== true) {
	              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
	                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
	                var ignore = ignoreRegExp.test(content);
	
	                if (unsafePseudoClass && !ignore) {
	                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
	                }
	              });
	            }
	
	            break;
	          }
	      }
	    });
	  }
	
	  var cache = {
	    key: key,
	    sheet: new sheet.StyleSheet({
	      key: key,
	      container: container,
	      nonce: options.nonce,
	      speedy: options.speedy
	    }),
	    nonce: options.nonce,
	    inserted: inserted,
	    registered: {},
	    insert: _insert
	  };
	  return cache;
	};
	
	exports.default = createCache;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*
	
	Based off glamor's StyleSheet, thanks Sunil ❤️
	
	high performance StyleSheet for css-in-js systems
	
	- uses multiple style tags behind the scenes for millions of rules
	- uses `insertRule` for appending in production for *much* faster performance
	
	// usage
	
	import { StyleSheet } from '@emotion/sheet'
	
	let styleSheet = new StyleSheet({ key: '', container: document.head })
	
	styleSheet.insert('#box { border: 1px solid red; }')
	- appends a css rule into the stylesheet
	
	styleSheet.flush()
	- empties the stylesheet of all its contents
	
	*/
	// $FlowFixMe
	function sheetForTag(tag) {
	  if (tag.sheet) {
	    // $FlowFixMe
	    return tag.sheet;
	  } // this weirdness brought to you by firefox
	
	  /* istanbul ignore next */
	
	
	  for (var i = 0; i < document.styleSheets.length; i++) {
	    if (document.styleSheets[i].ownerNode === tag) {
	      // $FlowFixMe
	      return document.styleSheets[i];
	    }
	  }
	}
	
	function createStyleElement(options) {
	  var tag = document.createElement('style');
	  tag.setAttribute('data-emotion', options.key);
	
	  if (options.nonce !== undefined) {
	    tag.setAttribute('nonce', options.nonce);
	  }
	
	  tag.appendChild(document.createTextNode(''));
	  return tag;
	}
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(options) {
	    this.isSpeedy = options.speedy === undefined ? ("production") === 'production' : options.speedy;
	    this.tags = [];
	    this.ctr = 0;
	    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
	
	    this.key = options.key;
	    this.container = options.container;
	    this.before = null;
	  }
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.insert = function insert(rule) {
	    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
	    // it's 1 in dev because we insert source maps that map a single rule to a location
	    // and you can only have one source map per style tag
	    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
	      var _tag = createStyleElement(this);
	
	      var before;
	
	      if (this.tags.length === 0) {
	        before = this.before;
	      } else {
	        before = this.tags[this.tags.length - 1].nextSibling;
	      }
	
	      this.container.insertBefore(_tag, before);
	      this.tags.push(_tag);
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    if (this.isSpeedy) {
	      var sheet = sheetForTag(tag);
	
	      try {
	        // this is a really hot path
	        // we check the second character first because having "i"
	        // as the second character will happen less often than
	        // having "@" as the first character
	        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
	        // the big drawback is that the css won't be editable in devtools
	
	        sheet.insertRule(rule, // we need to insert @import rules before anything else
	        // otherwise there will be an error
	        // technically this means that the @import rules will
	        // _usually_(not always since there could be multiple style tags)
	        // be the first ones in prod and generally later in dev
	        // this shouldn't really matter in the real world though
	        // @import is generally only used for font faces from google fonts and etc.
	        // so while this could be technically correct then it would be slower and larger
	        // for a tiny bit of correctness that won't matter in the real world
	        isImportRule ? 0 : sheet.cssRules.length);
	      } catch (e) {
	        if (false) {
	          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
	        }
	      }
	    } else {
	      tag.appendChild(document.createTextNode(rule));
	    }
	
	    this.ctr++;
	  };
	
	  _proto.flush = function flush() {
	    // $FlowFixMe
	    this.tags.forEach(function (tag) {
	      return tag.parentNode.removeChild(tag);
	    });
	    this.tags = [];
	    this.ctr = 0;
	  };
	
	  return StyleSheet;
	}();
	
	exports.StyleSheet = StyleSheet;


/***/ },
/* 454 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var isBrowser = "object" !== 'undefined';
	function getRegisteredStyles(registered, registeredStyles, classNames) {
	  var rawClassName = '';
	  classNames.split(' ').forEach(function (className) {
	    if (registered[className] !== undefined) {
	      registeredStyles.push(registered[className]);
	    } else {
	      rawClassName += className + " ";
	    }
	  });
	  return rawClassName;
	}
	var insertStyles = function insertStyles(cache, serialized, isStringTag) {
	  var className = cache.key + "-" + serialized.name;
	
	  if ( // we only need to add the styles to the registered cache if the
	  // class name could be used further down
	  // the tree but if it's a string tag, we know it won't
	  // so we don't have to add it to registered cache.
	  // this improves memory usage since we can avoid storing the whole style string
	  (isStringTag === false || // we need to always store it if we're in compat mode and
	  // in node since emotion-server relies on whether a style is in
	  // the registered cache to know whether a style is global or not
	  // also, note that this check will be dead code eliminated in the browser
	  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
	    cache.registered[className] = serialized.styles;
	  }
	
	  if (cache.inserted[serialized.name] === undefined) {
	    var current = serialized;
	
	    do {
	      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
	
	      current = current.next;
	    } while (current !== undefined);
	  }
	};
	
	exports.getRegisteredStyles = getRegisteredStyles;
	exports.insertStyles = insertStyles;


/***/ },
/* 455 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.adjustView = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = global.$;
	
	var adjustView = exports.adjustView = function adjustView(_ref) {
	    var view_ = _ref.view,
	        args_ = _ref.args;
	
	    var view = view_;
	    var args = args_ || {};
	    var modal = '';
	    var modalArgs = {};
	
	    if (view === 'bond-detail' && (0, _twd.getConfig)('entitlements.ETradeBondDetail', 'No') !== 'Yes') {
	        view = 'tools';
	        args.view = 'tools.bond-detail';
	    } else if (view === 'tools' && args.view === 'tools.bond-detail' && (0, _twd.getConfig)('entitlements.ETradeBondDetail', 'No') === 'Yes') {
	        view = 'bond-detail';
	    } else if (view === 'tools' && args.view === 'tools.bond-portfolio-report') {
	        view = 'portfolio-report';
	    } else if (view === 'tools' && args.view === 'tools.treasury-auctions' && (0, _twd.getConfig)('entitlements.ETradeTreasuryAuctions', 'No') === 'Yes') {
	        view = 'treasury-auctions';
	    } else if (view === 'tools' && args.view === 'tools.get-a-bond-quote' && (0, _twd.getConfig)('entitlements.ETradeOrderTicket', 'No') === 'Yes') {
	        view = 'order-ticket';
	        args.actionSubset = 'WF';
	        args.ts = Date.now();
	    } else if (view === 'tools' && args.view === 'tools.load-url' && args.url && args.url.indexOf('pkg_etrade.order_detail') > 0 && (0, _twd.getConfig)('entitlements.ETradeViewOrders', 'No') === 'Yes') {
	        var url = new URL(args.url);
	        view = 'orders';
	        args = { view: 'orders' };
	        modal = 'order-detail';
	        modalArgs = {
	            view: 'order-detail',
	            action: '?',
	            orderNo: url.searchParams.get('p_order_no')
	        };
	    } else if (view === 'sell-your-bond' && (0, _twd.getConfig)('entitlements.ETradeOrderTicket', 'No') === 'Yes') {
	        view = 'order-ticket';
	        args.action = 'S';
	        args.sourceAction = 'H';
	    }
	
	    return [view, args, modal, modalArgs];
	};
	
	exports.default = function (_ref2) {
	    var args = _ref2.args,
	        setView = _ref2.setView,
	        setArgs = _ref2.setArgs,
	        setModal = _ref2.setModal,
	        setModalArgs = _ref2.setModalArgs,
	        setIs401 = _ref2.setIs401;
	
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('goto.app', function () {
	            var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            if (typeof args === 'string') {
	                var _args$split = args.split('/'),
	                    _args$split2 = _slicedToArray(_args$split, 2),
	                    _view = _args$split2[0],
	                    hash = _args$split2[1];
	
	                args = Object.assign({ view: _view }, hash && { hash: hash });
	            }
	
	            var dest = args.view;
	            if (!dest) return;
	
	            if (dest === '401') {
	                setIs401(true);
	                return;
	            }
	
	            $('.tooltip').remove();
	
	            var view = dest.split('.')[0];
	
	            var _adjustView = adjustView({ view: view, args: args }),
	                _adjustView2 = _slicedToArray(_adjustView, 2),
	                v = _adjustView2[0],
	                a = _adjustView2[1];
	
	            if (v) {
	                setArgs(a);
	                setView(v);
	            }
	
	            $('#main')[0].scrollIntoView();
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    _react2.default.useLayoutEffect(function () {
	        if (!args.hash) return;
	        (0, _twd.setScroll)('#' + args.hash);
	    }, [args]);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('modal.app', function () {
	            var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            args = typeof args === 'string' ? { view: args } : args;
	
	            var dest = args.view;
	            args.ts = Date.now();
	            setModalArgs(!dest ? null : args);
	
	            var view = !dest ? null : dest.split('.')[0];
	            setModal(view);
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('open.app', function () {
	            var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            args = typeof args === 'string' ? { url: args } : args;
	            var _args = args,
	                url = _args.url,
	                name = _args.name,
	                options = _args.options;
	
	            (0, _twd.openWindow)(url, name, options);
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('error-boundary.app', function () {
	            var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            setView('overview');
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(234);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'knowledge-center' : _ref$dataName;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': dataName, className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-4 col-xs-4' },
	                    (0, _core.jsx)(
	                        'div',
	                        { style: { marginTop: "-20px" } },
	                        (0, _core.jsx)('i', { className: 'et-icon et-icon-xl et-graduation-gift', 'aria-hidden': 'true' })
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-8 col-xs-8' },
	                    (0, _core.jsx)(
	                        'h4',
	                        null,
	                        'Looking to expand your fixed income knowledge?'
	                    ),
	                    (0, _core.jsx)(
	                        'a',
	                        { href: '#',
	                            'data-name': dataName + '-library-link',
	                            style: { cursor: 'pointer' },
	                            onClick: function onClick() {
	                                return (0, _twd.openWindow)('https://us.etrade.com/knowledge/library/bonds-cds');
	                            }
	                        },
	                        'Explore our bond investing library'
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(234);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useRecentSearches2 = __webpack_require__(799);
	
	var _useRecentSearches3 = _interopRequireDefault(_useRecentSearches2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'recent-searches' : _ref$dataName;
	
	    var _useRecentSearches = (0, _useRecentSearches3.default)(),
	        status = _useRecentSearches.status,
	        recentSearches = _useRecentSearches.recentSearches;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': dataName, className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'h6',
	                        { className: 'sub-head' },
	                        'Recent Searches'
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12 text-truncate' },
	                    (0, _core.jsx)(
	                        _twd.Loading,
	                        { status: status },
	                        recentSearches.map(function (a, i) {
	                            return (0, _core.jsx)(
	                                _react2.default.Fragment,
	                                { key: i },
	                                (0, _core.jsx)(
	                                    'div',
	                                    {
	                                        'data-name': dataName + '-row',
	                                        className: 'link-button text-truncate vertical-offset-xs',
	                                        style: { display: 'block' },
	                                        item: a,
	                                        onClick: function onClick() {
	                                            return onSearch(a);
	                                        } },
	                                    a.description
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var onSearch = function onSearch(_ref2) {
	    var searchParams = _ref2.searchParams;
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: (0, _twd.cleanObject)(Object.assign(searchParams, { persistToPreviousSearches: false })),
	        _ts: Date.now(),
	        from: 'advanced-screener'
	    }));
	};

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(234);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useSavedSearches2 = __webpack_require__(800);
	
	var _useSavedSearches3 = _interopRequireDefault(_useSavedSearches2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'saved-searches' : _ref$dataName,
	        _ref$maxLength = _ref.maxLength,
	        maxLength = _ref$maxLength === undefined ? 25 : _ref$maxLength;
	
	    var _useSavedSearches = (0, _useSavedSearches3.default)(),
	        status = _useSavedSearches.status,
	        savedSearches = _useSavedSearches.savedSearches;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': dataName, className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-xs-6' },
	                    (0, _core.jsx)(
	                        'h6',
	                        { className: 'sub-head' },
	                        'Saved Searches'
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-xs-6 text-right' },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': dataName + '-manage-link',
	                            className: 'link-button',
	                            onClick: function onClick(e) {
	                                (0, _twd.showModal)({
	                                    view: 'manage-saved-searches',
	                                    source: e.target
	                                });
	                            }
	                        },
	                        'Manage'
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12 text-truncate' },
	                    (0, _core.jsx)(
	                        _twd.Loading,
	                        { status: status },
	                        (0, _twd.arrayFrom)(savedSearches).slice(0, maxLength).map(function (a, i) {
	                            return (0, _core.jsx)(
	                                _react2.default.Fragment,
	                                { key: i },
	                                (0, _core.jsx)(
	                                    'div',
	                                    {
	                                        'data-name': dataName + '-row',
	                                        className: 'link-button text-truncate vertical-offset-xs',
	                                        style: { display: 'block' },
	                                        item: a,
	                                        onClick: function onClick() {
	                                            return onSearch(a);
	                                        } },
	                                    a.description
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var onSearch = function onSearch(_ref2) {
	    var id = _ref2.id,
	        searchParams = _ref2.searchParams;
	
	    var sp = Object.assign({ savedQueryId: id }, searchParams, { persistToPreviousSearches: false });
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: (0, _twd.cleanObject)(sp),
	        _ts: Date.now(),
	        from: 'advanced-screener'
	    }));
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SearchParamArrays = exports.FormFieldArrays = undefined;
	
	var _twd = __webpack_require__(2);
	
	var FormFieldArrays = exports.FormFieldArrays = {
	    corpSectors: _twd.CORP_SECTORS,
	    corpFeatures: _twd.CORP_FEATURES,
	    corpDebtRanks: _twd.CORP_DEBT_RANKS,
	    corpMarketTypes: _twd.MARKET_TYPES,
	
	    muniStates: _twd.MUNI_STATES_AND_TERRITORIES,
	    muniCategories: _twd.MUNI_CATEGORIES,
	    muniTaxTreatments: _twd.MUNI_TAXABILITIES,
	    muniPurposes: _twd.MUNI_PURPOSES,
	    muniEnvironmentals: _twd.MUNI_ENVIRONMENTALS,
	    muniDeminimis: _twd.MUNI_DEMINIMIS,
	
	    cdBlueSky: _twd.CD_STATES_AND_TERRITORIES,
	    cdMarketTypes: _twd.MARKET_TYPES,
	
	    treasuryTypes: _twd.TREASURY_TYPES,
	    agencyTypes: _twd.AGENCY_TYPES,
	
	    couponFrequencies: _twd.COUPON_FREQUENCIES,
	    couponPayMonths: _twd.COUPON_MONTHS,
	    couponFeatures: _twd.COUPON_FEATURES,
	
	    callFeatures: _twd.CALL_FEATURES,
	    putFeatures: _twd.PUT_FEATURES,
	    otherFeatures: _twd.OTHER_FEATURES
	};
	
	var SearchParamArrays = exports.SearchParamArrays = Object.values(FormFieldArrays).map(function (arr) {
	    return arr.map(function (a) {
	        return a.value.split('=')[0];
	    }).filter(Boolean);
	}).map(function (arr) {
	    return (0, _twd.arrayUnique)(arr);
	}).reduce(function (x, arr) {
	    return [].concat(x, arr);
	}).filter(Boolean).concat(['holdInsurance', 'holdFdicNum']);

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.saveSearch = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _toSearchParams = __webpack_require__(194);
	
	var _toSearchParams2 = _interopRequireDefault(_toSearchParams);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var errors = _ref.errors,
	        values = _ref.values;
	
	    var hasError = Object.keys(errors).length > 0;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'advanced-screener-save-search-button',
	            className: 'btn btn-lg btn-primary-outline btn-block',
	            type: 'button',
	            disabled: hasError,
	            onClick: function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(e) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    _context.next = 2;
	                                    return saveSearch({ values: values, source: e.target });
	
	                                case 2:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, undefined);
	                }));
	
	                return function (_x) {
	                    return _ref2.apply(this, arguments);
	                };
	            }()
	        },
	        'Save search'
	    );
	};
	
	var saveSearch = exports.saveSearch = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(_ref3) {
	        var values = _ref3.values,
	            source = _ref3.source;
	        var qId, q, sp, p;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        qId = values.savedQueryId;
	                        _context2.next = 3;
	                        return getSavedQuery(qId);
	
	                    case 3:
	                        _context2.t0 = _context2.sent;
	
	                        if (_context2.t0) {
	                            _context2.next = 6;
	                            break;
	                        }
	
	                        _context2.t0 = {};
	
	                    case 6:
	                        q = _context2.t0;
	                        sp = Object.assign({
	                            searchType: 'offers',
	                            savedQueryId: qId
	                        }, (0, _toSearchParams2.default)(values));
	                        p = (0, _twd.cleanObject)({
	                            id: qId,
	                            description: q.description || '',
	                            notes: q.notes,
	                            isCopy: 'N',
	                            formText: JSON.stringify(sp),
	                            source: source
	                        });
	
	
	                        (0, _twd.showModal)({ view: 'save-search', params: p });
	
	                    case 10:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined);
	    }));
	
	    return function saveSearch(_x2) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var getSavedQuery = function () {
	    var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(qId) {
	        var _ajax, data;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        if (qId) {
	                            _context3.next = 2;
	                            break;
	                        }
	
	                        return _context3.abrupt('return');
	
	                    case 2:
	                        _context3.prev = 2;
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/portfolio/savedQuerySearchById/' + qId,
	                            method: 'GET'
	                        }), data = _ajax.data;
	                        _context3.t1 = _twd.arrayFrom;
	                        _context3.next = 7;
	                        return data;
	
	                    case 7:
	                        _context3.t2 = _context3.sent;
	                        _context3.t0 = (0, _context3.t1)(_context3.t2)[0];
	
	                        if (_context3.t0) {
	                            _context3.next = 11;
	                            break;
	                        }
	
	                        _context3.t0 = {};
	
	                    case 11:
	                        return _context3.abrupt('return', _context3.t0);
	
	                    case 14:
	                        _context3.prev = 14;
	                        _context3.t3 = _context3['catch'](2);
	                        return _context3.abrupt('return');
	
	                    case 17:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, undefined, [[2, 14]]);
	    }));
	
	    return function getSavedQuery(_x3) {
	        return _ref5.apply(this, arguments);
	    };
	}();

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var formatCouponType = function formatCouponType(r) {
	    var c = r.couponTypeCode;
	    if (c === 'B') return 'Zero';
	    if (['A', 'C', 'F', 'K', 'N'].indexOf(c) >= 0) return 'Fixed, Non-Zero';
	    if (r.f2fFixedInd === 'Y') return 'Fixed to Float, Fixed';
	    if ((0, _twd.arrayFrom)(r.stepSchedule).length > 1) return 'Multi-Step';
	    if (['D', 'I', 'E', 'G'].indexOf(c) >= 0) return 'Floating';
	};
	
	exports.default = function (_ref) {
	    var issue = _ref.issue,
	        offer = _ref.offer;
	
	    var label = formatCouponType(issue) || _twd.COUPON_TYPE_LABELS[issue.couponTypeCode] || _twd.fmt.empty();
	
	    if ((0, _twd.arrayFrom)(issue.stepSchedule).length > 1) {
	        return _react2.default.createElement(
	            'button',
	            {
	                className: 'link-button',
	                onClick: function onClick(e) {
	                    (0, _twd.showModal)({
	                        view: 'multi-step-coupon',
	                        issue: issue,
	                        from: 'bond-detail',
	                        source: e.target
	                    });
	                } },
	            label
	        );
	    }
	
	    if (issue.floaterInd === 'Y' && issue.f2fFixedInd === 'Y') {
	        return _react2.default.createElement(
	            'button',
	            {
	                className: 'link-button',
	                onClick: function onClick(e) {
	                    (0, _twd.showModal)({
	                        view: 'f2f-info',
	                        issue: issue,
	                        from: 'bond-detail',
	                        source: e.target
	                    });
	                } },
	            label
	        );
	    }
	
	    if (issue.floaterInd === 'Y' && ['O', 'R', 'K'].indexOf(issue.type) < 0) {
	        return _react2.default.createElement(
	            'button',
	            {
	                className: 'link-button',
	                onClick: function onClick(e) {
	                    (0, _twd.showModal)({
	                        view: 'ars-info',
	                        issue: issue,
	                        offer: offer,
	                        from: 'bond-detail',
	                        source: e.target
	                    });
	                } },
	            label
	        );
	    }
	
	    return label;
	};

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var html = _ref.html;
	
	    var ls = (0, _twd.parseJson)((0, _twd.parseHtml)(html), {}).uwList;
	    if (!ls || ls.length === 0) return _twd.fmt.empty();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: ls[0].name } }),
	        ls.length > 1 && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            '\xA0 ',
	            _react2.default.createElement(
	                'button',
	                {
	                    className: 'link-button',
	                    'aria-label': 'show more',
	                    onClick: function onClick(e) {
	                        (0, _twd.showModal)({
	                            view: 'underwriter',
	                            list: ls,
	                            from: 'bond-detail',
	                            source: e.target
	                        });
	                    } },
	                '+ more'
	            )
	        )
	    );
	};

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isCalcInput = exports.getCalcInputErrors = exports.getCalcInput = undefined;
	
	var _twd = __webpack_require__(2);
	
	var getCalcInput = exports.getCalcInput = function getCalcInput() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref.cusip,
	        price = _ref.price,
	        _ref$priceOrYield = _ref.priceOrYield,
	        priceOrYield = _ref$priceOrYield === undefined ? '1' : _ref$priceOrYield,
	        yld = _ref.yld,
	        qty = _ref.qty,
	        _ref$action = _ref.action,
	        action = _ref$action === undefined ? 'B' : _ref$action,
	        settlement = _ref.settlement;
	
	    if (!cusip) {
	        return null;
	    }
	
	    var py = !(0, _twd.isEmpty)(priceOrYield) ? String(priceOrYield) : !(0, _twd.isEmpty)(yld) ? '0' : '1';
	    return (0, _twd.cleanObject)({
	        cusip: cusip,
	        priceYield: py === '1' ? price : yld,
	        priceOrYield: py,
	        qty: qty,
	        action: action,
	        settlement: settlement
	    });
	};
	
	var getCalcInputErrors = exports.getCalcInputErrors = function getCalcInputErrors(bi, ci) {
	    var err = {};
	    if (!ci) {
	        return { error: 'empty fields' };
	    }
	
	    if (bi && !bi.canCalc) {
	        return { error: 'cant calc' };
	    }
	
	    var priceYield = ci.priceYield,
	        priceOrYield = ci.priceOrYield,
	        qty = ci.qty,
	        settlement = ci.settlement;
	
	
	    var py = String(priceOrYield);
	    var px = py === '1' ? parseFloat(priceYield) : NaN;
	    var ytw = py === '0' ? parseFloat(priceYield) : NaN;
	    var ytm = py === '2' ? parseFloat(priceYield) : NaN;
	
	    if (isNaN(px) && isNaN(ytw) && isNaN(ytm)) {
	        err.priceYield = py === '1' ? 'Enter price.' : 'Enter yield.';
	    } else if (!isNaN(px) && px === 0) {
	        err.priceYield = 'Enter price.';
	    } else if (!isNaN(px) && (px <= 0 || px > 999)) {
	        err.priceYield = 'Price cannot exceed 999.';
	    } else if (!isNaN(ytw) && Math.abs(ytw) > 999) {
	        err.priceYield = 'Yield cannot exceed 999.';
	    } else if (!isNaN(ytm) && Math.abs(ytm) > 999) {
	        err.priceYield = 'Yield cannot exceed 999.';
	    }
	
	    var issue = bi && bi.issue || {};
	    var type = issue.type,
	        firstSettlement = issue.firstSettlement,
	        maturity = issue.maturity,
	        minQty = issue.minQty,
	        maturityEff = issue.maturityEff;
	
	    var q = parseFloat(qty);
	    var incrQty = type === 'M' || type === 'A' ? 5 : 1;
	    if (!q) {
	        err.quantity = 'Enter quantity.';
	    } else if (q < minQty) {
	        err.quantity = 'Quantity should be equal or greater than ' + _twd.fmt.qty(minQty) + '.';
	    } else if (q % incrQty !== 0) {
	        err.quantity = 'Increment for this bond is ' + _twd.fmt.qty(incrQty) + '.';
	    } else if (q > 9999) {
	        err.quantity = 'Quantity cannot exceed 9,999.';
	    }
	
	    var mat = (0, _twd.parseDate)(maturity);
	    var matEff = (0, _twd.parseDate)(maturityEff);
	    var stl1 = (0, _twd.parseDate)(firstSettlement);
	    var stl = (0, _twd.parseDate)(settlement);
	    var now = Date.now();
	    if (!stl) {
	        err.settlement = 'Enter date.';
	    } else if (stl && stl <= now) {
	        err.settlement = 'Date must be after today.';
	    } else if (stl && matEff && stl >= matEff) {
	        err.settlement = 'Date cannot exceed Maturity date.';
	    } else if (stl && mat && stl >= mat) {
	        err.settlement = 'Date cannot exceed Maturity date.';
	    } else if (stl && stl1 && stl < stl1) {
	        err.settlement = 'Date must be after first settlement date.';
	    } else if (stl && (0, _twd.arrayFrom)((0, _twd.getConfig)('next_holiday', [])).indexOf(_twd.fmt.mdy(stl)) >= 0) {
	        err.settlement = 'Date must be a business day.';
	    } else if (stl && (0, _twd.arrayFrom)((0, _twd.getConfig)('working_holiday', [])).indexOf(_twd.fmt.mdy(stl)) >= 0) {
	        err.settlement = 'Date must be a business day.';
	    } else if (stl && [0, 6].indexOf(stl.getDay()) >= 0) {
	        err.settlement = 'Date must be a business day.';
	    }
	
	    return (0, _twd.cleanObject)(err);
	};
	
	var isCalcInput = exports.isCalcInput = function isCalcInput(bi, ci) {
	    return Object.keys(getCalcInputErrors(bi, ci)).length === 0;
	};

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useMarketNews = __webpack_require__(116);
	
	var _useMarketNews2 = _interopRequireDefault(_useMarketNews);
	
	var _select = __webpack_require__(870);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        type = _ref.type,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? "corporates-market-news-date-picker" : _ref$dataName,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 6 : _ref$size;
	
	    var a = (0, _useMarketNews2.default)();
	    var isCustom = type === 'custom';
	
	    var _ref2 = isCustom ? [a.customDate, a.setCustomDate] : [a.holdingDate, a.setHoldingDate],
	        _ref3 = _slicedToArray(_ref2, 2),
	        dateRange = _ref3[0],
	        setDateRange = _ref3[1];
	
	    var arg = {
	        dateRange: dateRange, setDateRange: setDateRange
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_select2.default, Object.assign({ dataName: dataName, size: size }, arg))
	    );
	};

/***/ },
/* 466 */
[2039, 891, 892, 893, 890],
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var color = _ref.color,
	        label = _ref.label;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "svg",
	            { height: "10", width: "10" },
	            _react2.default.createElement("circle", { cx: "5", cy: "5", r: "4", stroke: color, strokeWidth: "1", fill: color })
	        ),
	        "\xA0",
	        label
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getGenericSearch = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _twd = __webpack_require__(2);
	
	var SEARCH_TERMS = {
	    'cmo,abs,mbs,cmos,asset-backed,asset backed,asset back,mortgage-backed,mortgage backed,mortgage back,mortgage': {
	        holdInvType: ['O', 'R', 'K']
	    },
	    '*pass': {
	        holdInvType: ['O', 'R', 'K']
	    },
	
	    'corp,corps,corporate,corporates,corporate bond,corporate bonds': {
	        holdInvType: ['C']
	    },
	
	    'muni,munis,municipal,municipals,municipal bond,municipal bonds': {
	        holdInvType: ['M']
	    },
	
	    'agency bonds,agencies,agency': {
	        holdInvType: ['A']
	    },
	    'ati,aid to israel': {
	        holdInvType: ['A'], holdAgencyType: ['ATI']
	    },
	    'dn,discount notes': {
	        holdInvType: ['A'], holdAgencyType: ['B']
	    },
	    'famc,federal agriculture mortgage corporation': {
	        holdInvType: ['A'], holdAgencyType: ['FAMC']
	    },
	    'ffcb,federal farm credit banks': {
	        holdInvType: ['A'], holdAgencyType: ['FFCB']
	    },
	    'fha,farmers home administration': {
	        holdInvType: ['A'], holdAgencyType: ['FHA']
	    },
	    'fhlb,federal home loan banks': {
	        holdInvType: ['A'], holdAgencyType: ['FHLB']
	    },
	    'fhlmc,federal home loan mortgage corporation': {
	        holdInvType: ['A'], holdAgencyType: ['FHLMC']
	    },
	    'fico,financing corp': {
	        holdInvType: ['A'], holdAgencyType: ['FICO']
	    },
	    'fjob,federal judiciary office building': {
	        holdInvType: ['A'], holdAgencyType: ['FJOB']
	    },
	    'fnma,federal national mortgage association': {
	        holdInvType: ['A'], holdAgencyType: ['FNMA']
	    },
	    'gnma,government national mortgage association': {
	        holdInvType: ['A'], holdAgencyType: ['GNMA']
	    },
	    'hud,housing & urban development': {
	        holdInvType: ['A'], holdAgencyType: ['HUD']
	    },
	    'sba,small business administration': {
	        holdInvType: ['A'], holdAgencyType: ['SBA']
	    },
	    'slma,student loan marketing association': {
	        holdInvType: ['A'], holdAgencyType: ['SLMA']
	    },
	    'tva,tennessee valley authority': {
	        holdInvType: ['A'], holdAgencyType: ['TVA']
	    },
	
	    'cd,cds,brokered cds,certificate of deposit,certificates of deposit': {
	        holdInvType: ['S']
	    },
	
	    'structured': {
	        holdInvType: ['L']
	    },
	
	    'treasury,treasuries,treasurys,us treasuries,s. treasuries': {
	        holdInvType: ['T']
	    },
	    't bill,t bills,t-bill,treasury bill,treasury bills': {
	        holdInvType: ['T'], holdTreasuryType: ['Bills']
	    },
	    't note,t notes,t-note,treasury note,treasury notes': {
	        holdInvType: ['T'], holdTreasuryType: ['Notes']
	    },
	    't bond,t bonds,t-bond,treasury bond,treasury bonds': {
	        holdInvType: ['T'], holdTreasuryType: ['Bonds']
	    },
	    'tips,tip': {
	        holdInvType: ['T'], holdTreasuryType: ['TIPS']
	    },
	    'strips,strip': {
	        holdInvType: ['T'], holdTreasuryType: ['STRIPS']
	    },
	    'frn': {
	        holdInvType: ['T'], holdTreasuryType: ['FRN']
	    },
	
	    'treasury auction,treasury auctions,auction,auctions': function treasuryAuctionTreasuryAuctionsAuctionAuctions() {
	        (0, _twd.show)('tools.treasury-auctions');
	    }
	
	};
	
	var getGenericSearch = exports.getGenericSearch = function getGenericSearch(txt) {
	    if (!txt) return;
	
	    var cusipSearch = getCusipList(txt);
	    if (cusipSearch) return cusipSearch;
	
	    var ltext = txt.toLowerCase();
	
	    var _ref = Object.entries(SEARCH_TERMS).find(function (_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 2),
	            terms = _ref4[0],
	            value = _ref4[1];
	
	        return terms[0] === '*' && ltext.indexOf(terms.substring(1)) === 0 || terms.split(',').map(function (a) {
	            return a.trim();
	        }).indexOf(ltext) >= 0;
	    }) || [],
	        _ref2 = _slicedToArray(_ref, 2),
	        _ = _ref2[0],
	        sp = _ref2[1];
	
	    if (sp && (0, _twd.isObject)(sp)) {
	        sp = Object.assign({
	            offeringType: ['ask-side']
	        }, sp);
	    }
	
	    return sp;
	};
	
	var getCusipList = function getCusipList(txt) {
	
	    var ls = (0, _twd.arrayUnique)(txt.split(',').map(function (a) {
	        return a.trim().toUpperCase();
	    }).filter(Boolean));
	    if (ls.length === 0) return;
	
	    var notCusip = ls.findIndex(function (a) {
	        return !(0, _twd.isCusip)(a);
	    }) >= 0;
	    if (notCusip) return;
	
	    if (ls.length > 100) return { error: 'Please enter up to 100 comma separated CUSIPs' };
	
	    return {
	        holdCusip: ls,
	        holdIdentifierLabel: "holdCusip",
	        holdIdentifiers: ls,
	        offeringType: ['ask-side']
	    };
	};

/***/ },
/* 469 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable no-use-before-define */
	
	var getSearchParams = exports.getSearchParams = function getSearchParams(rs, keyword) {
	    return [].concat(getSymbolSearchParams(rs)).concat(getIssuerSearchParams(rs)).concat(getCusipSearchParams(rs, keyword)).filter(Boolean);
	};
	
	var getSymbolSearchParams = exports.getSymbolSearchParams = function getSymbolSearchParams(rs) {
	    return Object.values(rs.reduce(function (x, r) {
	        var t = r.type;
	        if (t !== 'C') return x;
	
	        var k = r.symbol;
	        if (k in x) return x;
	
	        x[k] = {
	            symbol: k,
	            searchParams: {
	                holdInvType: ['C'],
	                holdSymbol: [k]
	            }
	        };
	        return x;
	    }, {}));
	};
	
	var getIssuerSearchParams = exports.getIssuerSearchParams = function getIssuerSearchParams(rs) {
	    return Object.values(rs.reduce(function (x, r) {
	        var k = r.issue;
	        if (k in x) return x;
	
	        x[k] = {
	            issue: k,
	            searchParams: {
	                holdIssue: [k]
	            }
	        };
	        return x;
	    }, {}));
	};
	
	var getCusipSearchParams = exports.getCusipSearchParams = function getCusipSearchParams(rs, keyword) {
	    return Object.values(rs.reduce(function (x, r) {
	        var c = r.cusip;
	        var i = r.isin;
	        var k = c.indexOf(keyword) < 0 && i.indexOf(keyword) < 0 ? c.substring(0, 6) : c;
	        if (k in x) return x;
	
	        x[k] = {
	            cusip: k,
	            searchParams: {
	                holdCusip: [k],
	                holdIdentifierLabel: "holdCusip",
	                holdIdentifiers: [k]
	            }
	        };
	        return x;
	    }, {}));
	};

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.onClick = exports.getColor = exports.svgCss = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    .clickable { cursor:pointer; }\n\n    min-width: 741px;\n    ', ' {\n        width: 100%;\n    }\n'], ['\n    .clickable { cursor:pointer; }\n\n    min-width: 741px;\n    ', ' {\n        width: 100%;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _tooltip = __webpack_require__(951);
	
	var _states = __webpack_require__(949);
	
	var _states2 = _interopRequireDefault(_states);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	/** @jsx jsx */
	
	
	var svgCss = exports.svgCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$values = _ref.values,
	        values = _ref$values === undefined ? {} : _ref$values;
	
	    return (0, _core.jsx)(
	        'svg',
	        { height: '453',
	            'aria-hidden': 'true',
	            viewBox: '0 0 741 453', fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg', css: svgCss },
	        Object.entries(_states2.default).map(function (_ref2, i) {
	            var _ref3 = _slicedToArray(_ref2, 2),
	                state = _ref3[0],
	                svgFn = _ref3[1];
	
	            var v = values[state] || { state: state };
	            var n = v.tradeCount || 0;
	            var c = getColor(n);
	            var lc = getLabelColor(n);
	
	            var t = {
	                onClick: function onClick(e) {
	                    return _onClick({ state: state });
	                },
	                onMouseOver: function onMouseOver(e) {
	                    return (0, _tooltip.onMouseOverFn)(e, Object.assign({ state: state }, v));
	                },
	                onMouseOut: function onMouseOut(e) {
	                    return (0, _tooltip.onMouseOutFn)(e);
	                },
	                'id': 'municipal-map-' + state,
	                'data-name': 'municipal-map-state',
	                'data-tooltip-id': 'municipal-map-' + state + '-label',
	                'data-state': state
	            };
	
	            var lt = {
	                onClick: function onClick(e) {
	                    return _onClick({ state: state });
	                },
	                onMouseOver: function onMouseOver(e) {
	                    return (0, _tooltip.onMouseOverFn)(e, Object.assign({ state: state }, v));
	                },
	                onMouseOut: function onMouseOut(e) {
	                    return (0, _tooltip.onMouseOutFn)(e);
	                },
	                'data-state': state,
	                'data-name': 'municipal-map-state-label',
	                'data-tooltip-id': 'municipal-map-' + state + '-label',
	                'id': 'municipal-map-' + state + '-label'
	
	            };
	
	            return (0, _core.jsx)(
	                _react2.default.Fragment,
	                { key: i },
	                svgFn({ color: c, labelColor: lc, labelTooltip: lt, tooltip: t })
	            );
	        }),
	        (0, _core.jsx)('path', { d: 'M476.76 257.397C476.641 257.443 476.613 257.507 476.613 257.58C476.604 257.672 476.714 257.809 476.815 257.938C476.87 258.002 476.925 258.075 476.97 258.148C476.998 258.148 477.025 258.148 477.053 258.148C477.309 258.148 477.309 258.139 477.364 257.993C477.428 257.828 477.401 257.617 477.309 257.516C477.208 257.388 476.943 257.333 476.76 257.397Z',
	            fill: '#391B8D' }),
	        (0, _core.jsx)('path', { d: 'M640.137 193.902C640.448 194.085 640.732 194.259 640.961 194.735C641.016 194.845 641.062 194.964 641.098 195.083L641.877 193.911L641.666 193.783C641.273 193.545 640.87 193.298 640.467 193.078C640.384 193.032 640.32 192.995 640.265 192.959C640.21 192.931 640.146 192.885 640.128 192.885C639.999 193.032 639.862 193.307 639.761 193.526C639.743 193.554 639.734 193.581 639.716 193.609C639.771 193.646 639.825 193.691 639.88 193.728C639.963 193.792 640.054 193.847 640.137 193.902Z',
	            fill: '#825FE2' }),
	        (0, _core.jsx)('path', { d: 'M501.405 232.56C501.386 232.532 501.377 232.505 501.359 232.477C501.341 232.45 501.258 232.386 501.203 232.34C501.121 232.276 501.038 232.202 500.965 232.12C500.965 232.138 500.956 232.166 500.956 232.184C500.928 232.331 500.883 232.633 500.883 232.798C500.983 232.825 501.112 232.862 501.203 232.88C501.24 232.807 501.377 232.624 501.405 232.56Z',
	            fill: '#825FE2' })
	    );
	};
	
	var getColor = exports.getColor = function getColor(n) {
	    var isBlue = (0, _twd.getConfig)('entitlements.ETradeBlue', 'No') === 'Yes';
	    if (isBlue) {
	        return n > 1000 ? '#00172b' : n > 500 ? '#002b51' : n > 250 ? '#094274' : n > 100 ? '#1b5b93' : n > 50 ? '#467eb0' : '#6496c2';
	    }
	    return n > 1000 ? '#5627D8' : n > 500 ? '#6C43DD' : n > 250 ? '#825FE2' : n > 100 ? '#977AE7' : n > 50 ? '#AD96EC' : '#C3B2F1';
	};
	
	var getLabelColor = function getLabelColor(n) {
	    return n > 1000 ? 'white' : n > 500 ? 'white' : n > 250 ? 'white' : n > 100 ? 'white' : n > 50 ? '#444444' : '#444444';
	};
	
	var _onClick = function _onClick(_ref4) {
	    var state = _ref4.state;
	
	    (0, _twd.show)("offerings", {
	        searchParams: {
	            holdInvType: ['M'],
	            holdState: [state],
	            persistToPreviousSearches: false,
	            offeringType: ['ask-side']
	        },
	        _ts: Date.now(),
	        from: 'municipals'
	    });
	};
	exports.onClick = _onClick;

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useMarketNews = __webpack_require__(139);
	
	var _useMarketNews2 = _interopRequireDefault(_useMarketNews);
	
	var _select = __webpack_require__(962);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        type = _ref.type,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? "municipals-market-news-date-picker" : _ref$dataName,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 6 : _ref$size;
	
	    var a = (0, _useMarketNews2.default)();
	    var isCustom = type === 'custom';
	
	    var _ref2 = isCustom ? [a.customDate, a.setCustomDate] : [a.holdingDate, a.setHoldingDate],
	        _ref3 = _slicedToArray(_ref2, 2),
	        dateRange = _ref3[0],
	        setDateRange = _ref3[1];
	
	    var arg = {
	        dateRange: dateRange, setDateRange: setDateRange
	    };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(_select2.default, Object.assign({ dataName: dataName, size: size }, arg))
	    );
	};

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useMarketNews = __webpack_require__(139);
	
	var _criteria = __webpack_require__(958);
	
	var _criteria2 = _interopRequireDefault(_criteria);
	
	var _news = __webpack_require__(969);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var modal = _ref.modal,
	        props = _objectWithoutProperties(_ref, ['modal']);
	
	    return (0, _core.jsx)(
	        _useMarketNews.ContextProvider,
	        { modal: modal },
	        (0, _core.jsx)(Main, Object.assign({ modal: modal }, props))
	    );
	};
	
	var Main = function Main() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$modal = _ref2.modal,
	        modal = _ref2$modal === undefined ? false : _ref2$modal;
	
	    var _React$useState = _react2.default.useState(true),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        available = _React$useState2[0],
	        setAvailable = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('municipals-market-news-unavailable.municipals-market-news', function (f) {
	            setAvailable(!f);
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var id = modal ? (0, _twd.getId)() : 'municipal-market-news';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: id, className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'municipals-market-news', className: modal ? '' : 'container vertical-offst-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            !modal && (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Municipal Market News'
	                    )
	                )
	            ),
	            available && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12' },
	                        (0, _core.jsx)(_criteria2.default, null)
	                    )
	                ),
	                (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	                (0, _core.jsx)(_news2.default, { modal: modal })
	            ),
	            !available && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'text-muted text-center' },
	                    (0, _core.jsx)(
	                        'i',
	                        { className: 'material-icons et-icon-lg', 'aria-hidden': 'true' },
	                        'chat'
	                    ),
	                    (0, _core.jsx)('br', null),
	                    'The Municipal Market News module is currently unavailable.',
	                    (0, _core.jsx)('br', null),
	                    'Please try again at a later time.'
	                )
	            ),
	            (0, _core.jsx)('div', { className: modal ? 'row vertical-offset-xxs' : 'row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 473 */
[2039, 981, 982, 983, 980],
/* 474 */
467,
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        rows = _ref.rows,
	        status = _ref.status,
	        count = _ref.count,
	        onLoadMore = _ref.onLoadMore,
	        _ref$pageSize = _ref.pageSize,
	        pageSize = _ref$pageSize === undefined ? 10 : _ref$pageSize;
	
	    var moreCount = Math.min(pageSize, count - rows.length);
	
	    return _react2.default.createElement(
	        _twd.Loading,
	        { status: status },
	        rows.length ? _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-3' },
	                'Viewing 1 - ',
	                _twd.format.count(rows.length),
	                ' of ',
	                _twd.format.count(count)
	            ),
	            moreCount > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-6' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'offerings-view-more',
	                        onClick: onLoadMore,
	                        className: 'btn btn-primary btn-block'
	                    },
	                    'View ',
	                    _twd.format.count(moreCount),
	                    ' more'
	                )
	            ) : null
	        ) : _react2.default.createElement(
	            'div',
	            { className: 'universal-message universal-message-danger' },
	            _react2.default.createElement(
	                'div',
	                { className: 'universal-message-content' },
	                _react2.default.createElement(
	                    'p',
	                    { className: 'universal-message-heading' },
	                    'No result found.'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ErrorBoundary = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-use-before-define */
	
	
	var ErrorBoundary = exports.ErrorBoundary = function (_React$Component) {
	    _inherits(ErrorBoundary, _React$Component);
	
	    function ErrorBoundary(props) {
	        _classCallCheck(this, ErrorBoundary);
	
	        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));
	
	        _this.state = { hasError: false };
	        return _this;
	    }
	
	    _createClass(ErrorBoundary, [{
	        key: 'componentDidCatch',
	        value: function componentDidCatch(error) {
	            console.log('ERROR', error);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.hasError) {
	                // eslint-disable-next-line
	                this.state.hasError = false;
	
	                setTimeout(function () {
	                    return (0, _twd.publish)('error-boundary');
	                });
	                return null;
	            }
	            return this.props.children;
	        }
	    }], [{
	        key: 'getDerivedStateFromError',
	        value: function getDerivedStateFromError(error) {
	            return { hasError: true };
	        }
	    }]);
	
	    return ErrorBoundary;
	}(_react2.default.Component);

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIcon = exports.CustomerBuyIcon = exports.CustomerSellIcon = exports.DealerToDealerIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DealerToDealerIcon = exports.DealerToDealerIcon = function DealerToDealerIcon(_ref) {
	    var _ref$fill = _ref.fill,
	        fill = _ref$fill === undefined ? '#EF6F06' : _ref$fill,
	        width = _ref.width,
	        height = _ref.height,
	        x = _ref.x,
	        y = _ref.y,
	        cx = _ref.cx,
	        cy = _ref.cy,
	        r = _ref.r;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'svg',
	            Object.assign({ viewBox: '0 0 10 10' }, { width: width, height: height, x: x, y: y, cx: cx, cy: cy, r: r }),
	            _react2.default.createElement('rect', { x: '0', y: '0', width: '10', height: '10', fill: fill })
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	var CustomerSellIcon = exports.CustomerSellIcon = function CustomerSellIcon(_ref2) {
	    var _ref2$fill = _ref2.fill,
	        fill = _ref2$fill === undefined ? '#006CB6' : _ref2$fill,
	        width = _ref2.width,
	        height = _ref2.height,
	        x = _ref2.x,
	        y = _ref2.y,
	        cx = _ref2.cx,
	        cy = _ref2.cy,
	        r = _ref2.r;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'svg',
	            Object.assign({ viewBox: '-1 -1 12 12' }, { width: width, height: height, x: x, y: y, cx: cx, cy: cy, r: r }),
	            _react2.default.createElement('polygon', { points: '5,-1 11,11 -1,11', fill: fill })
	        )
	    );
	};
	
	var CustomerBuyIcon = exports.CustomerBuyIcon = function CustomerBuyIcon(_ref3) {
	    var _ref3$fill = _ref3.fill,
	        fill = _ref3$fill === undefined ? '#8B06B9' : _ref3$fill,
	        width = _ref3.width,
	        height = _ref3.height,
	        x = _ref3.x,
	        y = _ref3.y,
	        cx = _ref3.cx,
	        cy = _ref3.cy,
	        r = _ref3.r;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'svg',
	            Object.assign({ viewBox: '0 0 10 10' }, { width: width, height: height, x: x, y: y, cx: cx, cy: cy, r: r }),
	            _react2.default.createElement('circle', { cx: '5', cy: '5', r: '5', fill: fill })
	        )
	    );
	};
	
	var getIcon = exports.getIcon = function getIcon(label) {
	    if (!label) return null;
	    var l = label.toLowerCase();
	    var props = { width: 10, height: 10 };
	    if (l.includes('dealer to dealer')) return _react2.default.createElement(DealerToDealerIcon, props);
	    if (l.includes('customer sell')) return _react2.default.createElement(CustomerSellIcon, props);
	    if (l.includes('customer buy')) return _react2.default.createElement(CustomerBuyIcon, props);
	    return null;
	};

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Chart = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _recharts = __webpack_require__(135);
	
	var _chartTooltip = __webpack_require__(1135);
	
	var _chartShapes = __webpack_require__(477);
	
	var _chartFormat = __webpack_require__(1134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chart = exports.Chart = function Chart(_ref) {
	    var context = _ref.context;
	
	    var _React$useState = _react2.default.useState(true),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showCustomerBuys = _React$useState2[0],
	        setShowCustomerBuys = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(true),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        showCustomerSells = _React$useState4[0],
	        setShowCustomerSells = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(true),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        showDealerToDealers = _React$useState6[0],
	        setShowDealerToDealers = _React$useState6[1];
	
	    var xDomain = context.chartXDomain({ showCustomerBuys: showCustomerBuys, showCustomerSells: showCustomerSells, showDealerToDealers: showDealerToDealers });
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(CheckboxSelector, { value: showCustomerBuys, setValue: setShowCustomerBuys, label: 'Customer Buy' }),
	                _react2.default.createElement(CheckboxSelector, { value: showCustomerSells, setValue: setShowCustomerSells, label: 'Customer Sell' }),
	                _react2.default.createElement(CheckboxSelector, { value: showDealerToDealers, setValue: setShowDealerToDealers, label: 'Dealer to Dealer' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    _recharts.ResponsiveContainer,
	                    { width: '100%', height: 240 },
	                    _react2.default.createElement(
	                        _recharts.ScatterChart,
	                        {
	                            margin: {
	                                top: 5, right: 40, left: 0, bottom: 5
	                            }
	                        },
	                        _react2.default.createElement(_recharts.CartesianGrid, { vertical: false }),
	                        _react2.default.createElement(_recharts.XAxis, {
	                            dataKey: 'x',
	                            domain: xDomain,
	                            ticks: context.chartXTicks(xDomain),
	                            interval: 'preserveStartEnd',
	                            type: 'number',
	                            scale: 'time',
	                            tickFormatter: function tickFormatter(a) {
	                                return (0, _chartFormat.formatXAxisTicks)(a, context.filterByDate, showCustomerBuys || showCustomerSells || showDealerToDealers);
	                            },
	                            padding: { left: 10, right: 10 }
	                        }),
	                        _react2.default.createElement(_recharts.YAxis, {
	                            dataKey: 'y',
	                            domain: context.chartYDomain({ showCustomerBuys: showCustomerBuys, showCustomerSells: showCustomerSells, showDealerToDealers: showDealerToDealers }),
	                            width: 5,
	                            tickFormatter: function tickFormatter(a) {
	                                return (0, _chartFormat.formatYAxisTicks)(a, context.showDataAs);
	                            },
	                            scale: 'linear',
	                            axisLine: false,
	                            orientation: 'right' }),
	                        showCustomerBuys && _react2.default.createElement(_recharts.Scatter, Object.assign({ name: 'Customer Buy' }, _chartTooltip.ChartTooltip, { shape: function shape(p) {
	                                return _react2.default.createElement(_chartShapes.CustomerBuyIcon, p);
	                            }, data: context.customerBuys() })),
	                        showCustomerSells && _react2.default.createElement(_recharts.Scatter, Object.assign({ name: 'Customer Sell' }, _chartTooltip.ChartTooltip, { shape: function shape(p) {
	                                return _react2.default.createElement(_chartShapes.CustomerSellIcon, p);
	                            }, data: context.customerSells() })),
	                        showDealerToDealers && _react2.default.createElement(_recharts.Scatter, Object.assign({ name: 'Dealer to Dealer' }, _chartTooltip.ChartTooltip, { shape: function shape(p) {
	                                return _react2.default.createElement(_chartShapes.DealerToDealerIcon, p);
	                            }, data: context.dealerToDealers() }))
	                    )
	                )
	            )
	        )
	    );
	};
	
	var CheckboxSelector = function CheckboxSelector(_ref2) {
	    var value = _ref2.value,
	        setValue = _ref2.setValue,
	        label = _ref2.label;
	
	    var id = (0, _twd.getId)('trader-history-checkbox-selector');
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'checkbox', style: { display: 'inline-block' } },
	            _react2.default.createElement('input', {
	                type: 'checkbox',
	                id: id,
	                checked: value,
	                onChange: function onChange(e) {
	                    console.log('changed', e.target.checked);
	                    setValue(e.target.checked);
	                }
	            }),
	            _react2.default.createElement(
	                'label',
	                { htmlFor: id, style: { marginRight: '10px' } },
	                _react2.default.createElement(
	                    'span',
	                    { style: { marginRight: '5px' } },
	                    (0, _chartShapes.getIcon)(label)
	                ),
	                ' ',
	                label
	            )
	        )
	    );
	};

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Table = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define,eqeqeq */
	var Table = exports.Table = function Table(_ref) {
	    var context = _ref.context;
	
	
	    var n = context.filterByDate;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'h4',
	                { className: 'col-md-6 text-medium', style: { fontSize: 'inherit' } },
	                context.showDataAs === 'price-history' ? 'Price' : 'Yield',
	                ' history details for ',
	                n == 0 ? 'today' : 'last ' + n + ' days'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right' },
	                _react2.default.createElement(JumpTo, { context: context })
	            )
	        ),
	        _react2.default.createElement(Details, { context: context })
	    );
	};
	
	var JumpTo = function JumpTo(_ref2) {
	    var context = _ref2.context;
	
	    var id = (0, _twd.getId)();
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'label',
	            { htmlFor: id, className: 'text-medium', style: { fontSize: 'inherit', display: 'inline' } },
	            'Jump to '
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'select-wrapper inline', style: getSelectStyle() },
	            _react2.default.createElement(
	                'select',
	                {
	                    id: id,
	                    'aria-label': 'select trade date',
	                    defaultValue: context.lastTradeDate,
	                    style: { paddingRight: '25px' },
	                    className: 'text-bold',
	                    onChange: function onChange(e) {
	                        document.location.href = '#trade-history-detail-' + _twd.fmt.mdy(e.target.value);
	                    }
	                },
	                context.tradeDates.map(function (date, i) {
	                    return _react2.default.createElement(
	                        'option',
	                        { key: 'trade-date-' + i, value: date },
	                        date
	                    );
	                })
	            )
	        )
	    );
	};
	
	var getSelectStyle = function getSelectStyle() {
	    var color = getComputedStyle(document.documentElement).getPropertyValue('--primary-base-color').trim() || '#5627d8';
	    console.log(color);
	    return {
	        display: 'inline',
	        backgroundImage: "url(\"data:image/svg+xml;charset=utf8,%3Csvg width='12px' height='10px' viewBox='258 91 12 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(264.000000, 96.000000) rotate(90.000000) translate(-264.000000, -96.000000) translate(260.500000, 90.000000)'%3E%3Cpolygon id='Shape' fill='" + color.replace('#', '%23') + "' points='1 0 -0.4 1.4 4.2 6 -0.4 10.6 1 12 7 6'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\")",
	        backgroundRepeat: 'no-repeat',
	        backgroundPosition: 'calc(100% - 7px) 50%'
	    };
	};
	
	var Details = function Details(_ref3) {
	    var context = _ref3.context;
	    var _context$tradeDetails = context.tradeDetails,
	        details = _context$tradeDetails.details,
	        summary = _context$tradeDetails.summary;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(DetailsTable, { context: context, details: details }),
	        _react2.default.createElement(DetailsSummary, Object.assign({ context: context }, summary))
	    );
	};
	
	var DetailsTable = function DetailsTable(_ref4) {
	    var details = _ref4.details;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row table-responsive vertical-offset-xs trade-history-table-scroll',
	                style: {
	                    margin: 0,
	                    background: '#ffffff',
	                    border: 'solid 1px #e4e4e4',
	                    minHeight: '360px',
	                    maxHeight: '360px',
	                    overflowY: 'auto'
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped trade-history-sticky-table', style: { marginBottom: 0 } },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Trade time'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Price'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Yield'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Quantity'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Trade Type (Special Notes)'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        function () {
	                            var curr = null;
	                            return details.map(function (r, i) {
	                                var a = curr !== r.tradeDate;
	                                if (a) {
	                                    curr = r.tradeDate;
	                                }
	                                return _react2.default.createElement(DetailRow, Object.assign({ key: 'detail-' + i, idx: i, isNewSection: a }, r));
	                            });
	                        }()
	                    )
	                )
	            )
	        )
	    );
	};
	
	var DetailRow = function DetailRow(_ref5) {
	    var idx = _ref5.idx,
	        tradeDateTime = _ref5.tradeDateTime,
	        tradePrice = _ref5.tradePrice,
	        tradeYield = _ref5.tradeYield,
	        tradeQuantity = _ref5.tradeQuantity,
	        tradeType = _ref5.tradeType,
	        tradeNotes = _ref5.tradeNotes,
	        isEstimate = _ref5.isEstimate,
	        isNewSection = _ref5.isNewSection;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'tr',
	            Object.assign({ key: 'trade-history-detail-' + idx
	            }, isNewSection ? { id: 'trade-history-detail-' + _twd.fmt.mdy(tradeDateTime) } : {}, {
	                style: isNewSection ? { scrollMarginTop: 'var(--trade-history-sticky-h1, 40px)' } : {}
	            }),
	            _react2.default.createElement(
	                'td',
	                { style: { whiteSpace: 'nowrap', verticalAlign: 'top' } },
	                _twd.fmt.ts(tradeDateTime)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: 'text-right', style: { verticalAlign: 'top' } },
	                _twd.fmt.price3(tradePrice)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: 'text-right', style: { verticalAlign: 'top' } },
	                _twd.fmt.ytw3(tradeYield)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: 'text-right', style: { verticalAlign: 'top' } },
	                isEstimate ? '* 1,000' : _twd.fmt.qty(tradeQuantity)
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: { verticalAlign: 'top' } },
	                tradeType,
	                ' ',
	                tradeNotes ? '(' + tradeNotes + ')' : ''
	            )
	        )
	    );
	};
	
	var DetailsSummary = function DetailsSummary(_ref6) {
	    var totalTrades = _ref6.totalTrades,
	        averagePrice = _ref6.averagePrice,
	        averageYield = _ref6.averageYield,
	        hasEstimates = _ref6.hasEstimates;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { minWidth: '90px', display: 'inline-block' } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Total trades'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-medium' },
	                        _twd.fmt.qty(totalTrades)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { minWidth: '90px', display: 'inline-block' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-right' },
	                        'Average price'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-medium text-right' },
	                        _twd.fmt.price3(averagePrice)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { minWidth: '90px', display: 'inline-block' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-right' },
	                        'Average yield'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-medium text-right' },
	                        _twd.fmt.ytw3(averageYield)
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 text-right text-small' },
	                hasEstimates ? _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    '* Total quantity traded may be greater due to 1MM+ trades',
	                    _react2.default.createElement('br', null)
	                ) : null,
	                'Source: FINRA TRACE/MSRB'
	            )
	        )
	    );
	};

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _twd.getState)('treasury-cart.last', {
	    ts: 0
	});
	var loading = false;
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(Last.value.chartData || []),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        chartData = _React$useState2[0],
	        setChartData_ = _React$useState2[1];
	
	    var setChartData = _react2.default.useCallback(function (chartData) {
	        Last.set({ chartData: chartData });
	        setChartData_(chartData);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.chartDataStatus || _twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        chartDataStatus = _React$useState4[0],
	        setChartDataStatus_ = _React$useState4[1];
	
	    var setChartDataStatus = _react2.default.useCallback(function (chartDataStatus) {
	        Last.set({ chartDataStatus: chartDataStatus });
	        setChartDataStatus_(chartDataStatus);
	    }, []);
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var url, _ref2, data__, data_, data;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(!(0, _twd.isEmpty)(chartData) || loading)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	
	                            setChartDataStatus(_twd.Status.LOADING);
	                            loading = true;
	
	                            _context.prev = 4;
	                            url = '/esb/retailservice/yieldCurveService/getYieldCurveData';
	                            _context.next = 8;
	                            return (0, _twd.ajax)({
	                                url: url,
	                                method: 'GET'
	                            });
	
	                        case 8:
	                            _ref2 = _context.sent;
	                            data__ = _ref2.data;
	                            _context.next = 12;
	                            return data__;
	
	                        case 12:
	                            _context.t0 = _context.sent.yieldCurveDataMap;
	
	                            if (_context.t0) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            _context.t0 = {};
	
	                        case 15:
	                            data_ = _context.t0;
	                            data = [{ id: 'BD_1MO', name: '1M', x: 0 }, { id: 'BD_3MO', name: '3M', x: 1 }, { id: 'BD_6MO', name: '6M', x: 2 }, { id: 'BD_1YR', name: '1Y', x: 3 }, { id: 'BD_2YR', name: '2Y', x: 4 }, { id: 'BD_3YR', name: '3Y', x: 5 }, { id: 'BD_5YR', name: '5Y', x: 6 }, { id: 'BD_7YR', name: '7Y', x: 7 }, { id: 'BD_10YR', name: '10Y', x: 8 }, { id: 'BD_20YR', name: '20Y', x: 9 }, { id: 'BD_30YR', name: '30Y', x: 10 }].map(function (_ref3) {
	                                var id = _ref3.id,
	                                    name = _ref3.name,
	                                    x = _ref3.x;
	
	                                var a = data_[id] || {};
	                                return {
	                                    name: name,
	                                    x: x,
	                                    current: (a.current || {}).ytw,
	                                    "1mo": (a.month1 || {}).ytw,
	                                    "3mo": (a.month3 || {}).ytw,
	                                    "6mo": (a.month6 || {}).ytw,
	                                    "1yr": (a.month12 || {}).ytw
	                                };
	                            });
	
	
	                            setChartData(data);
	                            setChartDataStatus(_twd.Status.LOADED);
	                            _context.next = 24;
	                            break;
	
	                        case 21:
	                            _context.prev = 21;
	                            _context.t1 = _context['catch'](4);
	
	                            setChartDataStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 24:
	
	                            loading = false;
	
	                        case 25:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[4, 21]]);
	        }))();
	    }, [chartData, setChartData]);
	
	    return {
	        chartData: chartData,
	        chartDataStatus: chartDataStatus
	    };
	};

/***/ },
/* 481 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var readCookies = exports.readCookies = function readCookies() {
	    var r = /\s?(.*?)=(.*?);/g;
	    var c = document.cookie + ';';
	    var cookies = {};
	    while (true) {
	        var m = r.exec(c);
	        if (!m) break;
	
	        var n = m[1];
	        if (!n) continue;
	
	        var v = m[2];
	        v = v === 'null' ? null : v;
	        cookies[n] = v;
	    }
	    return cookies;
	};

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Flyout = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _reactPopper = __webpack_require__(1985);
	
	var _mediaQueries = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flyout = exports.Flyout = function Flyout(_ref) {
	    var _ref$label = _ref.label,
	        label = _ref$label === undefined ? "" : _ref$label,
	        _ref$ariaLabel = _ref.ariaLabel,
	        ariaLabel = _ref$ariaLabel === undefined ? "" : _ref$ariaLabel,
	        _ref$html = _ref.html,
	        html = _ref$html === undefined ? "" : _ref$html,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? "" : _ref$dataName,
	        _ref$className = _ref.className,
	        className = _ref$className === undefined ? 'btn-label btn-flyout' : _ref$className,
	        _ref$popperStyles = _ref.popperStyles,
	        popperStyles = _ref$popperStyles === undefined ? {
	        maxWidth: Math.min(_mediaQueries.mediaQueries.width() - 40, 300) + 'px'
	    } : _ref$popperStyles,
	        _ref$contentStyle = _ref.contentStyle,
	        contentStyle = _ref$contentStyle === undefined ? {
	        width: '300px'
	    } : _ref$contentStyle,
	        _ref$isLabel = _ref.isLabel,
	        isLabel = _ref$isLabel === undefined ? false : _ref$isLabel,
	        _ref$labelAttrs = _ref.labelAttrs,
	        labelAttrs = _ref$labelAttrs === undefined ? {} : _ref$labelAttrs,
	        _ref$labelStyle = _ref.labelStyle,
	        labelStyle = _ref$labelStyle === undefined ? {
	        display: 'inline'
	    } : _ref$labelStyle,
	        _ref$showIcon = _ref.showIcon,
	        showIcon = _ref$showIcon === undefined ? true : _ref$showIcon,
	        _ref$iconName = _ref.iconName,
	        iconName = _ref$iconName === undefined ? "info_outline" : _ref$iconName,
	        _ref$iconCls = _ref.iconCls,
	        iconCls = _ref$iconCls === undefined ? "text-muted material-icons" : _ref$iconCls,
	        _ref$iconStyle = _ref.iconStyle,
	        iconStyle = _ref$iconStyle === undefined ? {} : _ref$iconStyle,
	        _ref$isButton = _ref.isButton,
	        isButton = _ref$isButton === undefined ? true : _ref$isButton,
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled,
	        _ref$onClick = _ref.onClick,
	        onClick = _ref$onClick === undefined ? null : _ref$onClick,
	        _ref$placement = _ref.placement,
	        placement = _ref$placement === undefined ? "top" : _ref$placement,
	        _ref$strategy = _ref.strategy,
	        strategy = _ref$strategy === undefined ? "fixed" : _ref$strategy,
	        _ref$trackMouseOnTip = _ref.trackMouseOnTip,
	        trackMouseOnTip = _ref$trackMouseOnTip === undefined ? true : _ref$trackMouseOnTip,
	        _ref$trigger = _ref.trigger,
	        trigger = _ref$trigger === undefined ? ['click'] : _ref$trigger,
	        _ref$anchorEl = _ref.anchorEl,
	        anchorEl = _ref$anchorEl === undefined ? null : _ref$anchorEl,
	        _ref$autoShow = _ref.autoShow,
	        autoShow = _ref$autoShow === undefined ? false : _ref$autoShow,
	        _ref$onShow = _ref.onShow,
	        onShow = _ref$onShow === undefined ? function () {} : _ref$onShow,
	        _ref$onHide = _ref.onHide,
	        onHide = _ref$onHide === undefined ? function () {} : _ref$onHide;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        show = _React$useState2[0],
	        setShow = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(anchorEl),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        btnEl = _React$useState4[0],
	        setBtnEl = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(null),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        iconEl = _React$useState6[0],
	        setIconEl = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(null),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        popEl = _React$useState8[0],
	        setPopEl = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(null),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        arrEl = _React$useState10[0],
	        setArrEl = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState((0, _twd.getId)()),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        elId = _React$useState12[0],
	        _ = _React$useState12[1];
	
	    var _usePopper = (0, _reactPopper.usePopper)(showIcon ? iconEl : btnEl, popEl, {
	        placement: placement,
	        strategy: strategy,
	        modifiers: [{
	            name: 'arrow',
	            options: { element: arrEl }
	        }, {
	            name: 'flip',
	            options: {
	                fallbackPlacements: ['top', 'bottom']
	            }
	        }, {
	            name: 'preventOverflow',
	            options: {
	                enabled: true,
	                boundariesElement: 'window'
	            }
	        }]
	    }),
	        styles = _usePopper.styles,
	        attributes = _usePopper.attributes,
	        state = _usePopper.state;
	
	    var doShow = function doShow(val) {
	        if (!val) {
	            btnEl.removeAttribute('mouse-on-tip');
	            btnEl.removeAttribute('mouse-on-button');
	            btnEl.removeAttribute('focus-on-button');
	        }
	        setShow(val);
	
	        if (anchorEl) {
	            if (val) {
	                anchorEl.setAttribute('aria-controls', elId);
	            } else {
	                anchorEl.removeAttribute('aria-controls');
	            }
	        }
	    };
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('hide_flyout', function () {
	            setShow(false);
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, [setShow]);
	
	    var showFn = function showFn() {
	        setTimeout(function () {
	            return doShow(true);
	        });
	    };
	    var hideFn = function hideFn() {
	        setTimeout(function () {
	            var f = btnEl.hasAttribute('mouse-on-tip') || btnEl.hasAttribute('mouse-on-button') || btnEl.hasAttribute('focus-on-button');
	            if (f) return;
	
	            doShow(false);
	        }, 100);
	    };
	
	    _react2.default.useEffect(function () {
	        if (!popEl) return;
	
	        if (show) {
	            onShow({ contentEl: popEl });
	        } else {
	            onHide();
	        }
	    }, [show, popEl]);
	
	    _react2.default.useEffect(function () {
	        if (!show || !popEl) return;
	
	        var hasClick = trigger.includes('click');
	        setTimeout(function () {
	            var focusEl = hasClick ? btnEl : popEl;
	            focusEl.focus();
	        });
	
	        var addFn = popEl.addEventListener.bind(popEl);
	        var keydownFn = function keydownFn(ev) {
	            if (ev.key !== 'Escape') return;
	            ev.stopPropagation();
	            doShow(false);
	        };
	        addFn('keydown', keydownFn);
	
	        var popEnterFn = function popEnterFn() {
	            btnEl.setAttribute('mouse-on-tip', 'true');
	        };
	        var popLeaveFn = function popLeaveFn() {
	            btnEl.removeAttribute('mouse-on-tip');
	            hideFn();
	        };
	        if (trackMouseOnTip) addFn('mouseenter', popEnterFn);
	        if (trackMouseOnTip) addFn('mouseleave', popLeaveFn);
	
	        var clickFn = function clickFn(ev) {
	            if (popEl.contains(ev.target)) return;
	            doShow(false);
	        };
	        document.addEventListener('click', clickFn);
	
	        return function () {
	            var remFn = popEl.removeEventListener.bind(popEl);
	            remFn('keydown', keydownFn);
	            if (trackMouseOnTip) remFn('mouseenter', popEnterFn);
	            if (trackMouseOnTip) remFn('mouseleave', popLeaveFn);
	
	            document.removeEventListener('click', clickFn);
	        };
	    }, [show, btnEl, popEl]);
	
	    _react2.default.useEffect(function () {
	        if (!btnEl) return;
	
	        var hasClick = trigger.includes('click');
	        var hasHover = trigger.includes('hover');
	        var hasFocus = trigger.includes('focus');
	
	        var addFn = btnEl.addEventListener.bind(btnEl);
	
	        var keydownFn = function keydownFn(ev) {
	            if (ev.key === 'Escape') {
	                ev.stopPropagation();
	                doShow(false);
	            } else if (ev.key === 'Tab') {
	                doShow(false);
	            }
	        };
	        addFn('keydown', keydownFn);
	
	        var clickFn = function clickFn(ev) {
	            var curr = btnEl.getAttribute('aria-expanded') === 'true';
	            setTimeout(function () {
	                return doShow(!curr);
	            });
	        };
	        if (hasClick) {
	            addFn('click', clickFn);
	        }
	
	        var focusFn = function focusFn() {
	            btnEl.setAttribute('focus-on-button', 'true');
	            showFn();
	        };
	        var blurFn = function blurFn() {
	            btnEl.removeAttribute('focus-on-button');
	            hideFn();
	        };
	        if (hasFocus) {
	            addFn('focus', focusFn);
	        }
	        if (hasFocus || hasHover) {
	            addFn('blur', blurFn);
	        }
	
	        var mouseOverFn = function mouseOverFn() {
	            btnEl.setAttribute('mouse-on-button', 'true');
	            showFn();
	        };
	        var mouseOutFn = function mouseOutFn() {
	            btnEl.removeAttribute('mouse-on-button');
	            hideFn();
	            setTimeout(function () {
	                return btnEl.focus();
	            });
	        };
	        if (hasHover || hasFocus) {
	            addFn('mouseover', mouseOverFn);
	        }
	        if (hasHover || hasFocus) {
	            addFn('mouseout', mouseOutFn);
	        }
	
	        return function () {
	            var remFn = btnEl.removeEventListener.bind(btnEl);
	            remFn('keydown', keydownFn);
	            if (hasClick) {
	                remFn('click', clickFn);
	            }
	            if (hasFocus) {
	                remFn('focus', focusFn);
	            }
	            if (hasFocus || hasHover) {
	                remFn('blur', blurFn);
	            }
	            if (hasHover) {
	                remFn('mouseover', mouseOverFn);
	            }
	            if (hasHover) {
	                remFn('mouseout', mouseOutFn);
	            }
	        };
	    }, [btnEl]);
	
	    var Tag = '' + (isButton ? 'button' : 'a');
	    var showBtn = !anchorEl;
	    var LabelTag = '' + (isLabel ? 'label' : 'span');
	    var canExpand = trigger.includes('click') || trigger.includes('focus');
	
	    _react2.default.useEffect(function () {
	        if (!autoShow) return;
	
	        setTimeout(function () {
	            doShow(true);
	        });
	    }, []);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        showBtn && _react2.default.createElement(
	            Tag,
	            Object.assign({
	                ref: setBtnEl,
	                'aria-label': ariaLabel || label && label + ' information' || 'information'
	            }, canExpand && { "aria-expanded": show }, isButton && { type: "button" }, {
	                trigger: trigger.join(','),
	                className: className,
	                disabled: disabled,
	                'aria-controls': elId
	            }, isButton ? {} : { href: "#" }, onClick && { onClick: onClick }, {
	                'data-name': dataName
	            }),
	            label && _react2.default.createElement(
	                LabelTag,
	                Object.assign({ style: labelStyle }, labelAttrs),
	                label
	            ),
	            showIcon && _react2.default.createElement(
	                'i',
	                {
	                    ref: setIconEl,
	                    className: iconCls,
	                    'aria-hidden': 'true',
	                    style: Object.assign({
	                        marginTop: '-3px',
	                        fontSize: '15px',
	                        textDecoration: 'none',
	                        verticalAlign: 'middle',
	                        marginLeft: '5px',
	                        position: 'relative'
	                    }, iconStyle)
	                },
	                iconName
	            )
	        ),
	        show && _react2.default.createElement(
	            'div',
	            Object.assign({
	                ref: setPopEl,
	                className: 'flyout ' + (show ? "in " : "") + ' fade popover react-popover ' + (state && state.placement || placement),
	                style: Object.assign({}, popperStyles, styles.popper)
	            }, attributes.popper),
	            _react2.default.createElement('div', {
	                ref: setArrEl,
	                className: 'arrow',
	                style: styles.arrow }),
	            _react2.default.createElement(
	                'div',
	                {
	                    id: elId,
	                    className: 'popover-content',
	                    style: contentStyle,
	                    role: 'tooltip'
	                },
	                typeof html === 'string' ? _react2.default.createElement('div', { style: { minHeight: '22px' }, dangerouslySetInnerHTML: { __html: (0, _twd.parseHtml)(html) } }) : html
	            )
	        )
	    );
	};

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fmt = exports.format = exports.showBondOrder = undefined;
	
	var _order = __webpack_require__(1185);
	
	Object.defineProperty(exports, 'showBondOrder', {
	    enumerable: true,
	    get: function get() {
	        return _order.showBondOrder;
	    }
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(221);
	
	var _format2 = _interopRequireDefault(_format);
	
	var _issuer = __webpack_require__(1180);
	
	var _issuer2 = _interopRequireDefault(_issuer);
	
	var _detail = __webpack_require__(484);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatDt = function formatDt(a, fmt, zeroHours) {
	    var d = new Date(a);
	    if (isNaN(d)) return '';
	
	    if (zeroHours) {
	        d.setHours(0, 0, 0, 0);
	    }
	
	    return (0, _format2.default)(d, fmt);
	};
	
	var empty = function empty() {
	    var cls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'span',
	            { className: 'screen-reader-only' },
	            'Empty'
	        ),
	        _react2.default.createElement(
	            'span',
	            { 'aria-hidden': 'true', className: cls },
	            '--'
	        )
	    );
	};
	
	var slash = function slash() {
	    var cls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'span',
	            { className: 'screen-reader-only' },
	            'slash'
	        ),
	        _react2.default.createElement(
	            'span',
	            { 'aria-hidden': 'true', className: cls },
	            '/'
	        )
	    );
	};
	
	var format = exports.format = {
	    emptyHtml: '\n        <span class="screen-reader-only">Empty</span>\n        <span aria-hidden="true">--</span>\n    ',
	    empty: empty,
	    slash: slash,
	
	    ytw: function ytw(a, lbl) {
	        var dv = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : empty();
	
	        var x = Number.parseFloat(a);
	        if (isNaN(x)) return dv;
	        return x.toLocaleString("en-US", { maximumFractionDigits: 3 }) + ' ' + (lbl && '<sup> ' + lbl + '</sup>' || '');
	    },
	
	    ytw3: function ytw3(a, lbl) {
	        var x = Number.parseFloat(a);
	        if (isNaN(x)) return empty();
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            x.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 }),
	            lbl && _react2.default.createElement(
	                'sup',
	                null,
	                ' ',
	                lbl
	            )
	        );
	    },
	
	    price: function price(a) {
	        var dv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : empty();
	
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? dv : x.toLocaleString("en-US", { maximumFractionDigits: 3 });
	    },
	
	    price3: function price3(a) {
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
	    },
	
	    priceDemin: function priceDemin(a) {
	        var x = Number.parseFloat(a);
	        if (isNaN(x)) return empty();
	        if (x === -9999 || x === -1) return 'N/A';
	        return x.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
	    },
	
	    priceN: function priceN(a) {
	        var n = Math.max(((a + '').split('.')[1] || []).length || 3, 3);
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", { maximumFractionDigits: n });
	    },
	
	    price3N: function price3N(a) {
	        var n = Math.max(((a + '').split('.')[1] || []).length || 3, 3);
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: n });
	    },
	
	    price0: function price0(a) {
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", { maximumFractionDigits: 0 });
	    },
	
	    cpn: function cpn(a) {
	        var dv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : empty();
	        var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? dv : x.toLocaleString("en-US", { maximumFractionDigits: 3 }) + postfix;
	    },
	
	    cpn3: function cpn3(a) {
	        var dv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : empty();
	        var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? dv : x.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 }) + postfix;
	    },
	
	    cty: function cty(a) {
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", { maximumFractionDigits: 3 });
	    },
	
	    dur: function dur(a) {
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", { maximumFractionDigits: 3 });
	    },
	
	    pct: function pct(a) {
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", { maximumFractionDigits: 3 }) + '%';
	    },
	
	    qty: function qty(a) {
	        var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        var postfix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : x.toLocaleString("en-US", opt) + postfix;
	    },
	
	    count: function count(a) {
	        var dv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : empty();
	
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? dv : x.toLocaleString();
	    },
	
	    nvl: function nvl(a) {
	        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : empty();
	        return a === null || a === undefined ? t : a;
	    },
	
	    nullIf: function nullIf(a, b) {
	        return a === b ? null : a;
	    },
	
	    mdy: function mdy(a) {
	        return a ? formatDt(a, 'P', true) : empty();
	    },
	
	    time: function time(a) {
	        return formatDt(a, 'hh:mm a');
	    },
	
	    ts: function ts(a) {
	        return formatDt(a, 'P hh:mm a');
	    },
	
	    date: function date(a) {
	        return formatDt(a, 'MMMM d, yyyy', true);
	    },
	
	    fmtDt: function fmtDt(a, fmt) {
	        return formatDt(a, fmt);
	    },
	
	    warningText: function warningText(a) {
	        return String(a || '').replaceAll('|', '<span aria-hidden="true">|</span>');
	    },
	
	    money: function money(a) {
	        var x = Number.parseFloat(a);
	        return isNaN(x) ? empty() : '$' + x.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	    },
	
	    issuer: _issuer2.default,
	    IssuerDetail: _detail.Detail,
	
	    buy: _order.buy,
	    sell: _order.sell,
	    orderDetail: _order.orderDetail,
	    orderPhone: _order.orderPhone,
	
	    initCap: function initCap(a) {
	        return !a ? '' : a.toLowerCase().replace(/(?:^|\s)[a-z]/g, function (m) {
	            return m.toUpperCase();
	        });
	    },
	
	    factor: function factor(a) {
	        var n = Number.parseFloat(a);
	        return isNaN(n) ? '' : n % 1 === 0 ? n.toLocaleString() + '.000' : a;
	    }
	
	};
	
	var fmt = exports.fmt = format;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Detail = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        white-space: nowrap;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n'], ['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        white-space: nowrap;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    dt, dd {\n        white-space: nowrap;\n        margin: 0;\n        font-weight:400;\n        line-height: 1.4;\n    }\n    dt {\n        padding: 6px;\n        padding-top: 0px;\n    }\n    dd {\n        padding: 6px;\n        padding-top: 0px;\n        font-weight:500;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    div {\n        display: grid;\n        grid-template-columns: 1fr;\n    }\n'], ['\n    dt, dd {\n        white-space: nowrap;\n        margin: 0;\n        font-weight:400;\n        line-height: 1.4;\n    }\n    dt {\n        padding: 6px;\n        padding-top: 0px;\n    }\n    dd {\n        padding: 6px;\n        padding-top: 0px;\n        font-weight:500;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    div {\n        display: grid;\n        grid-template-columns: 1fr;\n    }\n']);
	
	var _twd = __webpack_require__(2);
	
	var _core = __webpack_require__(9);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var listCss = (0, _core.css)(_templateObject);
	var offerCss = (0, _core.css)(_templateObject2);
	
	var Detail = exports.Detail = function Detail(_ref) {
	    var holdIssue = _ref.holdIssue,
	        holdCusip = _ref.holdCusip,
	        holdCoupon = _ref.holdCoupon,
	        holdCorpSector = _ref.holdCorpSector,
	        holdInvType = _ref.holdInvType,
	        holdSpInd = _ref.holdSpInd,
	        holdUseOfProceeds = _ref.holdUseOfProceeds,
	        askPrice = _ref.askPrice,
	        askQuantity = _ref.askQuantity,
	        askYield = _ref.askYield,
	        askYieldmat = _ref.askYieldmat,
	        moodyRating = _ref.moodyRating,
	        spRating = _ref.spRating,
	        firstCouponDate = _ref.firstCouponDate,
	        nextCouponDate = _ref.nextCouponDate,
	        datedDate = _ref.datedDate,
	        research = _ref.research,
	        showBackLink = _ref.showBackLink,
	        showTradeHistory = _ref.showTradeHistory,
	        showBondDetail = _ref.showBondDetail,
	        isTreasuryAuction = _ref.isTreasuryAuction,
	        from = _ref.from;
	
	    var entryDetail = holdInvType === 'C' ? { label: 'Sector', value: holdCorpSector } : holdInvType === 'M' ? { label: 'Purpose', value: holdUseOfProceeds } : {};
	
	    var hasOffer = !(0, _twd.isEmpty)(askPrice) || !(0, _twd.isEmpty)(askQuantity) || !(0, _twd.isEmpty)(askYield) || !(0, _twd.isEmpty)(askYieldmat);
	
	    var prospectus = (0, _twd.arrayFrom)(research).filter(function (a) {
	        return a.type === 'legal' || a.type === 'sales';
	    }).map(function (_ref2) {
	        var url = _ref2.url;
	
	
	        url = String(url).replace("BDResearch.showViewer('", "").replace("');", '');
	
	        return url ? (0, _twd.getConfig)('bw_service_host') + url : '';
	    })[0];
	
	    var isTradeHistoryLink = showTradeHistory === 'Y' && ['A', 'C', 'M'].indexOf(holdInvType) >= 0;
	    var isBondDetailLink = !isTreasuryAuction && (!isTradeHistoryLink || showBondDetail === 'Y');
	
	    return (0, _core.jsx)(
	        'div',
	        { className: 'bond-issuer', 'data-name': 'bond-issuer-tooltip' },
	        (0, _core.jsx)(
	            'h3',
	            { className: 'text-bold text-truncate', style: { maxWidth: '300px' } },
	            holdIssue
	        ),
	        hasOffer && (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'dl',
	                { css: offerCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-3', style: { paddingRight: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Price'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.format.price(askPrice, _twd.format.empty())
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-3', style: { paddingRight: 0, paddingLeft: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Qty Available'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.format.count(askQuantity, _twd.format.empty())
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-3 text-right', style: { paddingRight: 0, paddingLeft: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'YTM'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.format.ytw(askYieldmat, '', _twd.format.empty())
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-3 text-right', style: { paddingLeft: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'YTW'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.format.ytw(askYield, '', _twd.format.empty())
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)(
	                'dl',
	                { css: listCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6', style: { paddingRight: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'CUSIP'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        holdCusip
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Type'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        INV_TYPES[holdInvType] || _twd.format.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        entryDetail.label || _twd.format.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        entryDetail.value || _twd.format.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Moody/S&P'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        moodyRating || _twd.format.empty(),
	                        ' / ',
	                        spRating || _twd.format.empty()
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6', style: { paddingLeft: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        isTreasuryAuction ? _twd.format.empty() : _twd.format.cpn(holdCoupon)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'First Coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        firstCouponDate || _twd.format.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Next Coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        nextCouponDate || _twd.format.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Dated'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        datedDate || _twd.format.empty()
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-5 text-nowrap' },
	                prospectus && (0, _core.jsx)(
	                    'button',
	                    {
	                        'data-name': 'prospectus-offering-document-link',
	                        className: 'btn-link',
	                        onClick: function onClick() {
	                            (0, _twd.openWindow)(prospectus, "_blank");
	                        }
	                    },
	                    'Prospectus / Offering Document'
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-7 text-right text-nowrap' },
	                isBondDetailLink ? (0, _core.jsx)(
	                    'button',
	                    {
	                        'data-name': 'bond-detail-link',
	                        className: 'btn-link',
	                        onClick: function onClick() {
	                            (0, _twd.hideModal)();
	                            (0, _twd.show)("bond-detail", {
	                                cusip: holdCusip,
	                                showBackLink: showBackLink,
	                                from: from
	                            });
	                        }
	                    },
	                    'Bond detail'
	                ) : null,
	                isBondDetailLink && isTradeHistoryLink && (0, _core.jsx)(
	                    'span',
	                    { 'aria-hidden': 'true', style: { width: '10px', display: 'inline-block' } },
	                    '\xA0 \xA0'
	                ),
	                isTradeHistoryLink ? (0, _core.jsx)(
	                    'button',
	                    {
	                        'data-name': 'trade-history-link',
	                        className: 'btn-link',
	                        onClick: function onClick(e) {
	                            (0, _twd.showModal)({
	                                view: 'trade-history',
	                                cusip: holdCusip,
	                                source: e.target
	                            });
	                        }
	                    },
	                    'Trade history'
	                ) : null
	            )
	        )
	    );
	};
	
	var INV_TYPES = {
	    'A': 'Agencies',
	    'R': 'Pass-Throughs',
	    'K': 'Asset-Backed',
	    'S': 'CDs',
	    'O': 'CMOs',
	    'C': 'Corporates',
	    'M': 'Municipals',
	    'P': 'Preferreds',
	    'L': 'Structured Products',
	    'T': 'U.S. Treasuries'
	};

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getOwaTcdaoContext = exports.deleteUserParm = exports.setUserParm = exports.getUserParm = exports.hasSvc = exports.getParm = exports.getEnvironment = exports.getUserId = exports.getSessionId = exports.getBrand = exports.setConfig = exports.getConfig = undefined;
	
	var _cookie = __webpack_require__(481);
	
	var getConfig = exports.getConfig = function getConfig(key, defaultValue) {
	    var cfg = (global.app || {}).config || {};
	    var keys = (key || '.').split('.');
	    for (var i = 0, n = keys.length; i < n; i++) {
	        var k = keys[i];
	        cfg = cfg[k];
	        if (cfg === undefined || cfg === null) break;
	    }
	    return cfg === undefined || cfg === null ? defaultValue : cfg;
	}; /* eslint-disable no-use-before-define,no-mixed-operators */
	var setConfig = exports.setConfig = function setConfig(values) {
	    var cfg = (global.app || {}).config || {};
	    return Object.assign(cfg, values);
	};
	
	var getBrand = exports.getBrand = function getBrand() {
	    return getConfig('user.Brand') || (0, _cookie.readCookies)()['last-login-brand'];
	};
	
	var getSessionId = exports.getSessionId = function getSessionId() {
	    return getConfig('user.SessionId') || (0, _cookie.readCookies)()[getBrand() + '-si'];
	};
	
	var getUserId = exports.getUserId = function getUserId() {
	    return getConfig('user.UserId');
	};
	
	var getEnvironment = exports.getEnvironment = function getEnvironment() {
	    return window.location.host.split('.').shift()[2].toUpperCase();
	};
	
	var getParm = exports.getParm = function getParm(key, defaultValue) {
	    var cfg = (global.app || {}).config || {};
	    var ps = cfg['parm'] || {};
	    return key in ps ? ps[key] : defaultValue;
	};
	
	var services = void 0;
	var hasSvc = exports.hasSvc = function hasSvc(key) {
	    if (!services) {
	        var cfg = global.app && global.app.config;
	        services = cfg && cfg.user && cfg.user.Services && cfg.user.Services.Service || [];
	    }
	    return services.indexOf(key) >= 0;
	};
	
	var getUserParm = exports.getUserParm = function getUserParm(name, dv) {
	    var p = getConfig('user.UserParms', { Parm: [] }).Parm.filter(function (_ref) {
	        var Name = _ref.Name;
	        return Name === name;
	    })[0];
	    return p ? p.Value : dv;
	};
	
	var setUserParm = exports.setUserParm = function setUserParm(name, Value) {
	    var ps = getConfig('user.UserParms', { Parm: [] }).Parm;
	    var p = ps.filter(function (_ref2) {
	        var Name = _ref2.Name;
	        return Name === name;
	    })[0];
	    if (!p) {
	        ps.push({ Name: name, Value: Value });
	    } else {
	        p.Value = Value;
	    }
	};
	
	var deleteUserParm = exports.deleteUserParm = function deleteUserParm(name) {
	    var ps = getConfig('user.UserParms', {});
	    ps.Parm = (ps.Parm || []).filter(function (_ref3) {
	        var Name = _ref3.Name;
	        return Name !== name;
	    });
	};
	
	var getOwaTcdaoContext = exports.getOwaTcdaoContext = function getOwaTcdaoContext() {
	    var owaTcDaoContext = getConfig('entitlements.EnableOwaToTcdao', 'No') === 'Yes';
	    return owaTcDaoContext ? 'servlet/tcdao' : 'owa';
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 486 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _id = 0;
	
	var getId = exports.getId = function getId() {
	    _id--;
	    return 'el' + _id;
	};

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.matIcon = exports.icons = undefined;
	
	var _noResult = __webpack_require__(1188);
	
	Object.keys(_noResult).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _noResult[key];
	        }
	    });
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var icons = exports.icons = {
	    "article": _react2.default.createElement(
	        'svg',
	        { width: '13', height: '13', viewBox: '0 0 13 13', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M11.1667 0.729004H1.83333C1.1 0.729004 0.5 1.329 0.5 2.06234V11.3957C0.5 12.129 1.1 12.729 1.83333 12.729H11.1667C11.9 12.729 12.5 12.129 12.5 11.3957V2.06234C12.5 1.329 11.9 0.729004 11.1667 0.729004ZM7.83333 10.0623H3.16667V8.729H7.83333V10.0623ZM9.83333 7.39567H3.16667V6.06234H9.83333V7.39567ZM9.83333 4.729H3.16667V3.39567H9.83333V4.729Z', fill: 'var(--primary-base-color)' })
	    ),
	
	    "tv": _react2.default.createElement(
	        'svg',
	        { width: '15', height: '13', viewBox: '0 0 15 13', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M13.4993 0.729004H1.49935C0.766016 0.729004 0.166016 1.329 0.166016 2.06234V10.0623C0.166016 10.7957 0.766016 11.3957 1.49935 11.3957H4.83268V12.729H10.166V11.3957H13.4993C14.2327 11.3957 14.826 10.7957 14.826 10.0623L14.8327 2.06234C14.8327 1.329 14.2327 0.729004 13.4993 0.729004ZM13.4993 10.0623H1.49935V2.06234H13.4993V10.0623Z', fill: 'var(--primary-base-color)' })
	    ),
	
	    "books": _react2.default.createElement(
	        'svg',
	        { width: '15', height: '14', viewBox: '0 0 15 14', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M2.16732 3.22898H0.833984V12.5623C0.833984 13.2957 1.43398 13.8957 2.16732 13.8957H11.5007V12.5623H2.16732V3.22898ZM12.834 0.562317H4.83398C4.10065 0.562317 3.50065 1.16232 3.50065 1.89565V9.89565C3.50065 10.629 4.10065 11.229 4.83398 11.229H12.834C13.5673 11.229 14.1673 10.629 14.1673 9.89565V1.89565C14.1673 1.16232 13.5673 0.562317 12.834 0.562317ZM12.1673 6.56232H5.50065V5.22898H12.1673V6.56232ZM9.50065 9.22898H5.50065V7.89565H9.50065V9.22898ZM12.1673 3.89565H5.50065V2.56232H12.1673V3.89565Z', fill: 'var(--primary-base-color)' })
	    ),
	
	    "campaign": _react2.default.createElement(
	        'svg',
	        { width: '15', height: '12', viewBox: '0 0 15 12', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M11.5007 5.56236V6.89569H14.1673V5.56236H11.5007ZM10.1673 9.96902C10.8073 10.4424 11.6407 11.069 12.3007 11.5624C12.5673 11.209 12.834 10.849 13.1007 10.4957C12.4407 10.0024 11.6073 9.37569 10.9673 8.89569C10.7007 9.25569 10.434 9.61569 10.1673 9.96902ZM13.1007 1.96236C12.834 1.60902 12.5673 1.24902 12.3007 0.895691C11.6407 1.38902 10.8073 2.01569 10.1673 2.49569C10.434 2.84902 10.7007 3.20902 10.9673 3.56236C11.6073 3.08236 12.4407 2.46236 13.1007 1.96236ZM2.16732 4.22902C1.43398 4.22902 0.833984 4.82902 0.833984 5.56236V6.89569C0.833984 7.62902 1.43398 8.22902 2.16732 8.22902H2.83398V10.8957H4.16732V8.22902H4.83398L8.16732 10.229V2.22902L4.83398 4.22902H2.16732ZM9.83398 6.22902C9.83398 5.34236 9.44732 4.54236 8.83398 3.99569V8.45569C9.44732 7.91569 9.83398 7.11569 9.83398 6.22902Z', fill: 'var(--primary-base-color)' })
	    ),
	
	    "calculate": _react2.default.createElement(
	        'svg',
	        {
	            width: '15', height: '15', viewBox: '0 0 22 22', fill: 'var(--primary-base-color)', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' }),
	        _react2.default.createElement('path', { d: 'M6.25 7.72h5v1.5h-5zM13 15.75h5v1.5h-5zm0-2.5h5v1.5h-5zM8 18h1.5v-2h2v-1.5h-2v-2H8v2H6V16h2zm6.09-7.05 1.41-1.41 1.41 1.41 1.06-1.06-1.41-1.42 1.41-1.41L16.91 6 15.5 7.41 14.09 6l-1.06 1.06 1.41 1.41-1.41 1.42z' })
	    ),
	
	    "plus": _react2.default.createElement(
	        'svg',
	        { width: '16', height: '17', viewBox: '0 0 16 17', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M15 2.5C15 2.23638 14.9099 1.97784 14.7161 1.78395C14.5222 1.59006 14.2636 1.5 14 1.5H2C1.73638 1.5 1.47784 1.59006 1.28395 1.78395C1.09006 1.97784 1 2.23638 1 2.5V14.5C1 14.7636 1.09006 15.0222 1.28395 15.2161C1.47784 15.4099 1.73638 15.5 2 15.5H14C14.2636 15.5 14.5222 15.4099 14.7161 15.2161C14.9099 15.0222 15 14.7636 15 14.5V2.5ZM2 1H14C14.8239 1 15.5 1.67614 15.5 2.5V14.5C15.5 15.3239 14.8239 16 14 16H2C1.17614 16 0.5 15.3239 0.5 14.5V2.5C0.5 1.67614 1.17614 1 2 1Z', fill: 'var(--primary-base-color)', stroke: 'var(--primary-base-color)' }),
	        _react2.default.createElement('path', { d: 'M8 13.4V3.59998', stroke: 'var(--primary-base-color)', strokeWidth: '1.5', strokeMiterlimit: '10' }),
	        _react2.default.createElement('path', { d: 'M12.9001 8.5H3.1001', stroke: 'var(--primary-base-color)', strokeWidth: '1.5', strokeMiterlimit: '10' })
	    ),
	
	    "minus": _react2.default.createElement(
	        'svg',
	        { width: '16', height: '17', viewBox: '0 0 16 17', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        _react2.default.createElement('path', { d: 'M15 2.5C15 2.23638 14.9099 1.97784 14.7161 1.78395C14.5222 1.59006 14.2636 1.5 14 1.5H2C1.73638 1.5 1.47784 1.59006 1.28395 1.78395C1.09006 1.97784 1 2.23638 1 2.5V14.5C1 14.7636 1.09006 15.0222 1.28395 15.2161C1.47784 15.4099 1.73638 15.5 2 15.5H14C14.2636 15.5 14.5222 15.4099 14.7161 15.2161C14.9099 15.0222 15 14.7636 15 14.5V2.5ZM2 1H14C14.8239 1 15.5 1.67614 15.5 2.5V14.5C15.5 15.3239 14.8239 16 14 16H2C1.17614 16 0.5 15.3239 0.5 14.5V2.5C0.5 1.67614 1.17614 1 2 1Z', fill: 'var(--primary-base-color)', stroke: 'var(--primary-base-color)' }),
	        _react2.default.createElement('path', { d: 'M12.9001 8.5H3.1001', stroke: 'var(--primary-base-color)', strokeWidth: '1.5', strokeMiterlimit: '10' })
	    )
	
	};
	
	var matIcon = exports.matIcon = function matIcon(name) {
	    var postfix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
	    var fontSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "15px";
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'i',
	            {
	                style: { color: 'var(--primary-base-color)', fontSize: fontSize },
	                className: 'material-icons',
	                'aria-hidden': 'true'
	            },
	            name
	        ),
	        postfix
	    );
	};

/***/ },
/* 488 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var safeURL = exports.safeURL = function safeURL(url, defVal) {
	    try {
	        return new URL(url);
	    } catch (x) {
	        return defVal;
	    }
	};
	
	var fixURL = exports.fixURL = function fixURL(url) {
	    var u = typeof url === 'string' ? safeURL(url) : url;
	    var isEtrade = u.host.indexOf('etrade.com') >= 0;
	    var isBonddesk = u.host.indexOf('bonddesk.com') >= 0;
	
	    var isQa = location.host.indexOf('qa') >= 0;
	    var isTst1 = location.host.indexOf('tst1') >= 0;
	    if ((isQa || isTst1) && (isEtrade || isBonddesk)) {
	        var dom = isEtrade ? 'uat' : isBonddesk && isQa ? 'qa' : isBonddesk && isTst1 ? 'tst1' : '';
	        var arr = u.host.split('.');
	        if (arr.length === 3) {
	            arr.splice(1, 0, dom);
	            u.host = arr.join('.');
	        }
	    }
	    return u;
	};
	
	var openWindow = exports.openWindow = function openWindow(url, name, option) {
	    var u = safeURL(url);
	    if (!u) {
	        return window.open(url, name, option);
	    }
	
	    fixURL(u);
	
	    if (name) {
	        return window.open(u.toString(), name, option);
	    } else {
	        location.href = u.toString();
	        return undefined;
	    }
	};

/***/ },
/* 489 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isEmpty = exports.isEmpty = function isEmpty(a) {
	    return a == null || a === '' || Array.isArray(a) && a.length === 0;
	};
	
	var isEmptyObject = exports.isEmptyObject = function isEmptyObject(a) {
	    return isEmpty(a) || Object.keys(a).length === 0;
	};
	
	var isString = exports.isString = function isString(a) {
	    return typeof a === 'string';
	};
	
	var isBoolean = exports.isBoolean = function isBoolean(a) {
	    return typeof a === 'boolean';
	};
	
	var isObject = exports.isObject = function isObject(a) {
	    return a !== null && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object';
	};
	
	var isNumeric = exports.isNumeric = function isNumeric(a) {
	    return !isNaN(parseFloat(a)) && isFinite(a);
	};
	
	var cleanObject = exports.cleanObject = function cleanObject(obj) {
	    var v = {};
	    for (var k in obj) {
	        var a = obj[k];
	        if (isEmpty(a)) continue;
	        v[k] = a;
	    }
	    return v;
	};
	
	var clearObject = exports.clearObject = function clearObject(obj) {
	    if (!obj) return obj;
	    for (var k in obj) {
	        delete obj[k];
	    }
	    return obj;
	};
	
	var coalesce = exports.coalesce = function coalesce() {
	    return Array.from(arguments).find(function (a) {
	        return !isEmpty(a);
	    });
	};
	
	var pickObject = exports.pickObject = function pickObject() {
	    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var key = arguments[1];
	    var defaultValue = arguments[2];
	
	    if (!obj || !key) return defaultValue;
	
	    var keys = (key || '.').split('.');
	    for (var i = 0, n = keys.length; i < n; i++) {
	        var k = keys[i];
	        obj = obj[k];
	        if (obj === undefined || obj === null) break;
	    }
	
	    return obj === undefined || obj === null ? defaultValue : obj;
	};
	
	var isEquals = exports.isEquals = function equals(o, p) {
	
	    var keysO = Object.keys(o).sort();
	    var keysP = Object.keys(p).sort();
	
	    if (keysO.length !== keysP.length) return false;
	    if (keysO.join('') !== keysP.join('')) return false;
	
	    for (var i = 0, n = keysO.length; i < n; i++) {
	        var k = keysO[i];
	        var a = o[k];
	        var b = p[k];
	
	        if (Array.isArray(a)) {
	            if (!Array.isArray(b)) return false;
	            if (equals(a.sort(), b.sort()) === false) return false;
	        } else if (isObject(a)) {
	            if (!isObject(b)) return false;
	            if (a === o) {
	                if (b !== p) return false;
	            } else if (equals(a, b) === false) {
	                return false;
	            }
	        } else if (a !== b) {
	            return false;
	        }
	    }
	    return true;
	};
	
	var stringFrom = exports.stringFrom = function stringFrom(v) {
	    return v === undefined || v === null ? '' : String(v);
	};
	
	var numberFrom = exports.numberFrom = function numberFrom(v) {
	    var dv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return isNumeric(v) ? parseFloat(v) : dv;
	};
	
	var arrayFrom = exports.arrayFrom = function arrayFrom(v) {
	    if (v === undefined || v === null) return [];
	
	    return Array.isArray(v) ? v : [v];
	};
	
	var arrayRemove = exports.arrayRemove = function arrayRemove(arr, v) {
	    if (!Array.isArray(arr)) return arr;
	
	    var isfn = typeof v === 'function';
	    var i = isfn ? arr.findIndex(v) : arr.indexOf(v);
	    if (i < 0) return arr;
	
	    arr.splice(i, 1);
	    return arr;
	};
	
	var arrayInsert = exports.arrayInsert = function arrayInsert(arr, v, x) {
	    if (!Array.isArray(arr)) return arr;
	
	    var isfn = typeof v === 'function';
	    var i = isfn ? arr.findIndex(v) : arr.indexOf(v);
	    if (i < 0) {
	        arr.push(isfn ? x || v : v);
	    }
	
	    return arr;
	};
	
	var arrayToggle = exports.arrayToggle = function arrayToggle(arr, v, x) {
	    if (!Array.isArray(arr)) return arr;
	
	    var isfn = typeof v === 'function';
	    var i = isfn ? arr.findIndex(v) : arr.indexOf(v);
	    if (i < 0) {
	        arr.push(isfn ? x || v : v);
	    } else {
	        arr.splice(i, 1);
	    }
	
	    return arr;
	};
	
	var arrayUnique = exports.arrayUnique = function arrayUnique(arr) {
	    return arr.reduce(function (x, a) {
	        if (x.indexOf(a) >= 0) return x;
	        x.push(a);
	        return x;
	    }, []);
	};
	
	var arraySplit = exports.arraySplit = function arraySplit(arr, size) {
	    var a = [].concat(arr);
	    var b = [];
	    while (a.length) {
	        b.push(a.splice(0, size));
	    }
	    return b;
	};
	
	var sleep = exports.sleep = function sleep(ms) {
	    return new Promise(function (f) {
	        return setTimeout(f, ms);
	    });
	};
	
	var bufferedFn = exports.bufferedFn = function bufferedFn(fn) {
	    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
	
	    var tmId;
	
	    return function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        if (tmId) clearTimeout(tmId);
	
	        tmId = setTimeout(function () {
	            fn.apply(null, args);
	        }, ms);
	    };
	};
	
	var sortFn = exports.sortFn = function sortFn(fn) {
	    var asc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    return function (a, b) {
	        var ai = fn(a);
	        var bi = fn(b);
	        return ai > bi ? asc : ai < bi ? -asc : 0;
	    };
	};

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _agencyTypes = __webpack_require__(1203);
	
	Object.keys(_agencyTypes).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _agencyTypes[key];
	        }
	    });
	});
	
	var _bondFeatures = __webpack_require__(1204);
	
	Object.keys(_bondFeatures).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _bondFeatures[key];
	        }
	    });
	});
	
	var _corpDebtRanks = __webpack_require__(1205);
	
	Object.keys(_corpDebtRanks).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _corpDebtRanks[key];
	        }
	    });
	});
	
	var _corpFeatures = __webpack_require__(1206);
	
	Object.keys(_corpFeatures).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _corpFeatures[key];
	        }
	    });
	});
	
	var _corpSectors = __webpack_require__(1207);
	
	Object.keys(_corpSectors).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _corpSectors[key];
	        }
	    });
	});
	
	var _couponFeatures = __webpack_require__(1208);
	
	Object.keys(_couponFeatures).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _couponFeatures[key];
	        }
	    });
	});
	
	var _couponFrequencies = __webpack_require__(1209);
	
	Object.keys(_couponFrequencies).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _couponFrequencies[key];
	        }
	    });
	});
	
	var _couponMonths = __webpack_require__(1210);
	
	Object.keys(_couponMonths).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _couponMonths[key];
	        }
	    });
	});
	
	var _marketTypes = __webpack_require__(1211);
	
	Object.keys(_marketTypes).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _marketTypes[key];
	        }
	    });
	});
	
	var _muniCategories = __webpack_require__(1212);
	
	Object.keys(_muniCategories).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _muniCategories[key];
	        }
	    });
	});
	
	var _muniEnvironmentals = __webpack_require__(1214);
	
	Object.keys(_muniEnvironmentals).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _muniEnvironmentals[key];
	        }
	    });
	});
	
	var _muniDeminimis = __webpack_require__(1213);
	
	Object.keys(_muniDeminimis).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _muniDeminimis[key];
	        }
	    });
	});
	
	var _muniPurposes = __webpack_require__(1215);
	
	Object.keys(_muniPurposes).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _muniPurposes[key];
	        }
	    });
	});
	
	var _muniTaxabilities = __webpack_require__(1216);
	
	Object.keys(_muniTaxabilities).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _muniTaxabilities[key];
	        }
	    });
	});
	
	var _statesTerritories = __webpack_require__(1217);
	
	Object.keys(_statesTerritories).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _statesTerritories[key];
	        }
	    });
	});
	
	var _treasuryTypes = __webpack_require__(1218);
	
	Object.keys(_treasuryTypes).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _treasuryTypes[key];
	        }
	    });
	});
	var INV_TYPE_LABELS = exports.INV_TYPE_LABELS = {
	    'A': 'Agencies',
	    'R': 'Pass-Throughs',
	    'K': 'Asset-Backed',
	    'S': 'CDs',
	    'O': 'CMOs',
	    'C': 'Corporates',
	    'M': 'Municipals',
	    'P': 'Preferreds',
	    'L': 'Structured Products',
	    'T': 'U.S. Treasuries'
	};
	
	var YES_NO = exports.YES_NO = {
	    'Y': 'Yes',
	    'N': 'No'
	};

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isPossiblePrototype = __webpack_require__(525);
	
	var $String = String;
	var $TypeError = TypeError;
	
	module.exports = function (argument) {
	  if (isPossiblePrototype(argument)) return argument;
	  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
	};


/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThisAccessor = __webpack_require__(251);
	var classof = __webpack_require__(61);
	
	var $TypeError = TypeError;
	
	// Includes
	// - Perform ? RequireInternalSlot(O, [[ArrayBufferData]]).
	// - If IsSharedArrayBuffer(O) is true, throw a TypeError exception.
	module.exports = uncurryThisAccessor(ArrayBuffer.prototype, 'byteLength', 'get') || function (O) {
	  if (classof(O) !== 'ArrayBuffer') throw new $TypeError('ArrayBuffer expected');
	  return O.byteLength;
	};


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var arrayBufferByteLength = __webpack_require__(492);
	
	var slice = uncurryThis(ArrayBuffer.prototype.slice);
	
	module.exports = function (O) {
	  if (arrayBufferByteLength(O) !== 0) return false;
	  try {
	    slice(O, 0, 0);
	    return false;
	  } catch (error) {
	    return true;
	  }
	};


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(8);
	var uncurryThisAccessor = __webpack_require__(251);
	var toIndex = __webpack_require__(368);
	var isDetached = __webpack_require__(493);
	var arrayBufferByteLength = __webpack_require__(492);
	var detachTransferable = __webpack_require__(506);
	var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(366);
	
	var structuredClone = global.structuredClone;
	var ArrayBuffer = global.ArrayBuffer;
	var DataView = global.DataView;
	var TypeError = global.TypeError;
	var min = Math.min;
	var ArrayBufferPrototype = ArrayBuffer.prototype;
	var DataViewPrototype = DataView.prototype;
	var slice = uncurryThis(ArrayBufferPrototype.slice);
	var isResizable = uncurryThisAccessor(ArrayBufferPrototype, 'resizable', 'get');
	var maxByteLength = uncurryThisAccessor(ArrayBufferPrototype, 'maxByteLength', 'get');
	var getInt8 = uncurryThis(DataViewPrototype.getInt8);
	var setInt8 = uncurryThis(DataViewPrototype.setInt8);
	
	module.exports = (PROPER_STRUCTURED_CLONE_TRANSFER || detachTransferable) && function (arrayBuffer, newLength, preserveResizability) {
	  var byteLength = arrayBufferByteLength(arrayBuffer);
	  var newByteLength = newLength === undefined ? byteLength : toIndex(newLength);
	  var fixedLength = !isResizable || !isResizable(arrayBuffer);
	  var newBuffer;
	  if (isDetached(arrayBuffer)) throw new TypeError('ArrayBuffer is detached');
	  if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	    arrayBuffer = structuredClone(arrayBuffer, { transfer: [arrayBuffer] });
	    if (byteLength === newByteLength && (preserveResizability || fixedLength)) return arrayBuffer;
	  }
	  if (byteLength >= newByteLength && (!preserveResizability || fixedLength)) {
	    newBuffer = slice(arrayBuffer, 0, newByteLength);
	  } else {
	    var options = preserveResizability && !fixedLength && maxByteLength ? { maxByteLength: maxByteLength(arrayBuffer) } : undefined;
	    newBuffer = new ArrayBuffer(newByteLength, options);
	    var a = new DataView(arrayBuffer);
	    var b = new DataView(newBuffer);
	    var copyLength = min(newByteLength, byteLength);
	    for (var i = 0; i < copyLength; i++) setInt8(b, i, getInt8(a, i));
	  }
	  if (!PROPER_STRUCTURED_CLONE_TRANSFER) detachTransferable(arrayBuffer);
	  return newBuffer;
	};


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toObject = __webpack_require__(33);
	var toAbsoluteIndex = __webpack_require__(107);
	var lengthOfArrayLike = __webpack_require__(40);
	var deletePropertyOrThrow = __webpack_require__(248);
	
	var min = Math.min;
	
	// `Array.prototype.copyWithin` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.copywithin
	// eslint-disable-next-line es/no-array-prototype-copywithin -- safe
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = lengthOfArrayLike(O);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else deletePropertyOrThrow(O, to);
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $forEach = __webpack_require__(57).forEach;
	var arrayMethodIsStrict = __webpack_require__(102);
	
	var STRICT_METHOD = arrayMethodIsStrict('forEach');
	
	// `Array.prototype.forEach` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
	  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	} : [].forEach;


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(45);
	var call = __webpack_require__(16);
	var toObject = __webpack_require__(33);
	var callWithSafeIterationClosing = __webpack_require__(1242);
	var isArrayIteratorMethod = __webpack_require__(347);
	var isConstructor = __webpack_require__(167);
	var lengthOfArrayLike = __webpack_require__(40);
	var createProperty = __webpack_require__(120);
	var getIterator = __webpack_require__(252);
	var getIteratorMethod = __webpack_require__(205);
	
	var $Array = Array;
	
	// `Array.from` method implementation
	// https://tc39.es/ecma262/#sec-array.from
	module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	  var O = toObject(arrayLike);
	  var IS_CONSTRUCTOR = isConstructor(this);
	  var argumentsLength = arguments.length;
	  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
	  var mapping = mapfn !== undefined;
	  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
	  var iteratorMethod = getIteratorMethod(O);
	  var index = 0;
	  var length, result, step, iterator, next, value;
	  // if the target is not iterable or it's an array with the default iterator - use a simple case
	  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
	    result = IS_CONSTRUCTOR ? new this() : [];
	    iterator = getIterator(O, iteratorMethod);
	    next = iterator.next;
	    for (;!(step = call(next, iterator)).done; index++) {
	      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
	      createProperty(result, index, value);
	    }
	  } else {
	    length = lengthOfArrayLike(O);
	    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
	    for (;length > index; index++) {
	      value = mapping ? mapfn(O[index], index) : O[index];
	      createProperty(result, index, value);
	    }
	  }
	  result.length = index;
	  return result;
	};


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-array-prototype-lastindexof -- safe */
	var apply = __webpack_require__(93);
	var toIndexedObject = __webpack_require__(55);
	var toIntegerOrInfinity = __webpack_require__(49);
	var lengthOfArrayLike = __webpack_require__(40);
	var arrayMethodIsStrict = __webpack_require__(102);
	
	var min = Math.min;
	var $lastIndexOf = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
	var STRICT_METHOD = arrayMethodIsStrict('lastIndexOf');
	var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;
	
	// `Array.prototype.lastIndexOf` method implementation
	// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
	module.exports = FORCED ? function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	  // convert -0 to +0
	  if (NEGATIVE_ZERO) return apply($lastIndexOf, this, arguments) || 0;
	  var O = toIndexedObject(this);
	  var length = lengthOfArrayLike(O);
	  if (length === 0) return -1;
	  var index = length - 1;
	  if (arguments.length > 1) index = min(index, toIntegerOrInfinity(arguments[1]));
	  if (index < 0) index = length + index;
	  for (;index >= 0; index--) if (index in O && O[index] === searchElement) return index || 0;
	  return -1;
	} : $lastIndexOf;


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var lengthOfArrayLike = __webpack_require__(40);
	
	// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.toReversed
	// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.toReversed
	module.exports = function (O, C) {
	  var len = lengthOfArrayLike(O);
	  var A = new C(len);
	  var k = 0;
	  for (; k < len; k++) A[k] = O[len - k - 1];
	  return A;
	};


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var lengthOfArrayLike = __webpack_require__(40);
	var toIntegerOrInfinity = __webpack_require__(49);
	
	var $RangeError = RangeError;
	
	// https://tc39.es/proposal-change-array-by-copy/#sec-array.prototype.with
	// https://tc39.es/proposal-change-array-by-copy/#sec-%typedarray%.prototype.with
	module.exports = function (O, C, index, value) {
	  var len = lengthOfArrayLike(O);
	  var relativeIndex = toIntegerOrInfinity(index);
	  var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
	  if (actualIndex >= len || actualIndex < 0) throw new $RangeError('Incorrect index');
	  var A = new C(len);
	  var k = 0;
	  for (; k < len; k++) A[k] = k === actualIndex ? value : O[k];
	  return A;
	};


/***/ },
/* 501 */
/***/ function(module, exports) {

	'use strict';
	var commonAlphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	var base64Alphabet = commonAlphabet + '+/';
	var base64UrlAlphabet = commonAlphabet + '-_';
	
	var inverse = function (characters) {
	  // TODO: use `Object.create(null)` in `core-js@4`
	  var result = {};
	  var index = 0;
	  for (; index < 64; index++) result[characters.charAt(index)] = index;
	  return result;
	};
	
	module.exports = {
	  i2c: base64Alphabet,
	  c2i: inverse(base64Alphabet),
	  i2cUrl: base64UrlAlphabet,
	  c2iUrl: inverse(base64UrlAlphabet)
	};


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var bind = __webpack_require__(45);
	var anObject = __webpack_require__(18);
	var toObject = __webpack_require__(33);
	var iterate = __webpack_require__(67);
	
	module.exports = function (C, adder, ENTRY) {
	  return function from(source /* , mapFn, thisArg */) {
	    var O = toObject(source);
	    var length = arguments.length;
	    var mapFn = length > 1 ? arguments[1] : undefined;
	    var mapping = mapFn !== undefined;
	    var boundFunction = mapping ? bind(mapFn, length > 2 ? arguments[2] : undefined) : undefined;
	    var result = new C();
	    var n = 0;
	    iterate(O, function (nextItem) {
	      var entry = mapping ? boundFunction(nextItem, n++) : nextItem;
	      if (ENTRY) adder(result, anObject(entry)[0], entry[1]);
	      else adder(result, entry);
	    });
	    return result;
	  };
	};


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(18);
	
	// https://tc39.github.io/proposal-setmap-offrom/
	module.exports = function (C, adder, ENTRY) {
	  return function of() {
	    var result = new C();
	    var length = arguments.length;
	    for (var index = 0; index < length; index++) {
	      var entry = arguments[index];
	      if (ENTRY) adder(result, anObject(entry)[0], entry[1]);
	      else adder(result, entry);
	    } return result;
	  };
	};


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(76);
	var defineBuiltInAccessor = __webpack_require__(54);
	var defineBuiltIns = __webpack_require__(203);
	var bind = __webpack_require__(45);
	var anInstance = __webpack_require__(98);
	var isNullOrUndefined = __webpack_require__(66);
	var iterate = __webpack_require__(67);
	var defineIterator = __webpack_require__(350);
	var createIterResultObject = __webpack_require__(202);
	var setSpecies = __webpack_require__(170);
	var DESCRIPTORS = __webpack_require__(15);
	var fastKey = __webpack_require__(144).fastKey;
	var InternalStateModule = __webpack_require__(52);
	
	var setInternalState = InternalStateModule.set;
	var internalStateGetterFor = InternalStateModule.getterFor;
	
	module.exports = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var Constructor = wrapper(function (that, iterable) {
	      anInstance(that, Prototype);
	      setInternalState(that, {
	        type: CONSTRUCTOR_NAME,
	        index: create(null),
	        first: undefined,
	        last: undefined,
	        size: 0
	      });
	      if (!DESCRIPTORS) that.size = 0;
	      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	    });
	
	    var Prototype = Constructor.prototype;
	
	    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
	
	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var entry = getEntry(that, key);
	      var previous, index;
	      // change existing entry
	      if (entry) {
	        entry.value = value;
	      // create new entry
	      } else {
	        state.last = entry = {
	          index: index = fastKey(key, true),
	          key: key,
	          value: value,
	          previous: previous = state.last,
	          next: undefined,
	          removed: false
	        };
	        if (!state.first) state.first = entry;
	        if (previous) previous.next = entry;
	        if (DESCRIPTORS) state.size++;
	        else that.size++;
	        // add to index
	        if (index !== 'F') state.index[index] = entry;
	      } return that;
	    };
	
	    var getEntry = function (that, key) {
	      var state = getInternalState(that);
	      // fast case
	      var index = fastKey(key);
	      var entry;
	      if (index !== 'F') return state.index[index];
	      // frozen object case
	      for (entry = state.first; entry; entry = entry.next) {
	        if (entry.key === key) return entry;
	      }
	    };
	
	    defineBuiltIns(Prototype, {
	      // `{ Map, Set }.prototype.clear()` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.clear
	      // https://tc39.es/ecma262/#sec-set.prototype.clear
	      clear: function clear() {
	        var that = this;
	        var state = getInternalState(that);
	        var entry = state.first;
	        while (entry) {
	          entry.removed = true;
	          if (entry.previous) entry.previous = entry.previous.next = undefined;
	          entry = entry.next;
	        }
	        state.first = state.last = undefined;
	        state.index = create(null);
	        if (DESCRIPTORS) state.size = 0;
	        else that.size = 0;
	      },
	      // `{ Map, Set }.prototype.delete(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.delete
	      // https://tc39.es/ecma262/#sec-set.prototype.delete
	      'delete': function (key) {
	        var that = this;
	        var state = getInternalState(that);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.next;
	          var prev = entry.previous;
	          delete state.index[entry.index];
	          entry.removed = true;
	          if (prev) prev.next = next;
	          if (next) next.previous = prev;
	          if (state.first === entry) state.first = next;
	          if (state.last === entry) state.last = prev;
	          if (DESCRIPTORS) state.size--;
	          else that.size--;
	        } return !!entry;
	      },
	      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.foreach
	      // https://tc39.es/ecma262/#sec-set.prototype.foreach
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        var state = getInternalState(this);
	        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	        var entry;
	        while (entry = entry ? entry.next : state.first) {
	          boundFunction(entry.value, entry.key, this);
	          // revert to the last existing entry
	          while (entry && entry.removed) entry = entry.previous;
	        }
	      },
	      // `{ Map, Set}.prototype.has(key)` methods
	      // https://tc39.es/ecma262/#sec-map.prototype.has
	      // https://tc39.es/ecma262/#sec-set.prototype.has
	      has: function has(key) {
	        return !!getEntry(this, key);
	      }
	    });
	
	    defineBuiltIns(Prototype, IS_MAP ? {
	      // `Map.prototype.get(key)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.get
	      get: function get(key) {
	        var entry = getEntry(this, key);
	        return entry && entry.value;
	      },
	      // `Map.prototype.set(key, value)` method
	      // https://tc39.es/ecma262/#sec-map.prototype.set
	      set: function set(key, value) {
	        return define(this, key === 0 ? 0 : key, value);
	      }
	    } : {
	      // `Set.prototype.add(value)` method
	      // https://tc39.es/ecma262/#sec-set.prototype.add
	      add: function add(value) {
	        return define(this, value = value === 0 ? 0 : value, value);
	      }
	    });
	    if (DESCRIPTORS) defineBuiltInAccessor(Prototype, 'size', {
	      configurable: true,
	      get: function () {
	        return getInternalState(this).size;
	      }
	    });
	    return Constructor;
	  },
	  setStrong: function (Constructor, CONSTRUCTOR_NAME, IS_MAP) {
	    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
	    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
	    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
	    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
	    // https://tc39.es/ecma262/#sec-map.prototype.entries
	    // https://tc39.es/ecma262/#sec-map.prototype.keys
	    // https://tc39.es/ecma262/#sec-map.prototype.values
	    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
	    // https://tc39.es/ecma262/#sec-set.prototype.entries
	    // https://tc39.es/ecma262/#sec-set.prototype.keys
	    // https://tc39.es/ecma262/#sec-set.prototype.values
	    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
	    defineIterator(Constructor, CONSTRUCTOR_NAME, function (iterated, kind) {
	      setInternalState(this, {
	        type: ITERATOR_NAME,
	        target: iterated,
	        state: getInternalCollectionState(iterated),
	        kind: kind,
	        last: undefined
	      });
	    }, function () {
	      var state = getInternalIteratorState(this);
	      var kind = state.kind;
	      var entry = state.last;
	      // revert to the last existing entry
	      while (entry && entry.removed) entry = entry.previous;
	      // get next entry
	      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
	        // or finish the iteration
	        state.target = undefined;
	        return createIterResultObject(undefined, true);
	      }
	      // return step by kind
	      if (kind === 'keys') return createIterResultObject(entry.key, false);
	      if (kind === 'values') return createIterResultObject(entry.value, false);
	      return createIterResultObject([entry.key, entry.value], false);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // `{ Map, Set }.prototype[@@species]` accessors
	    // https://tc39.es/ecma262/#sec-get-map-@@species
	    // https://tc39.es/ecma262/#sec-get-set-@@species
	    setSpecies(CONSTRUCTOR_NAME);
	  }
	};


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIns = __webpack_require__(203);
	var getWeakData = __webpack_require__(144).getWeakData;
	var anInstance = __webpack_require__(98);
	var anObject = __webpack_require__(18);
	var isNullOrUndefined = __webpack_require__(66);
	var isObject = __webpack_require__(20);
	var iterate = __webpack_require__(67);
	var ArrayIterationModule = __webpack_require__(57);
	var hasOwn = __webpack_require__(28);
	var InternalStateModule = __webpack_require__(52);
	
	var setInternalState = InternalStateModule.set;
	var internalStateGetterFor = InternalStateModule.getterFor;
	var find = ArrayIterationModule.find;
	var findIndex = ArrayIterationModule.findIndex;
	var splice = uncurryThis([].splice);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (state) {
	  return state.frozen || (state.frozen = new UncaughtFrozenStore());
	};
	
	var UncaughtFrozenStore = function () {
	  this.entries = [];
	};
	
	var findUncaughtFrozen = function (store, key) {
	  return find(store.entries, function (it) {
	    return it[0] === key;
	  });
	};
	
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.entries.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = findIndex(this.entries, function (it) {
	      return it[0] === key;
	    });
	    if (~index) splice(this.entries, index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
	    var Constructor = wrapper(function (that, iterable) {
	      anInstance(that, Prototype);
	      setInternalState(that, {
	        type: CONSTRUCTOR_NAME,
	        id: id++,
	        frozen: undefined
	      });
	      if (!isNullOrUndefined(iterable)) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
	    });
	
	    var Prototype = Constructor.prototype;
	
	    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
	
	    var define = function (that, key, value) {
	      var state = getInternalState(that);
	      var data = getWeakData(anObject(key), true);
	      if (data === true) uncaughtFrozenStore(state).set(key, value);
	      else data[state.id] = value;
	      return that;
	    };
	
	    defineBuiltIns(Prototype, {
	      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
	      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
	      'delete': function (key) {
	        var state = getInternalState(this);
	        if (!isObject(key)) return false;
	        var data = getWeakData(key);
	        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
	        return data && hasOwn(data, state.id) && delete data[state.id];
	      },
	      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
	      // https://tc39.es/ecma262/#sec-weakset.prototype.has
	      has: function has(key) {
	        var state = getInternalState(this);
	        if (!isObject(key)) return false;
	        var data = getWeakData(key);
	        if (data === true) return uncaughtFrozenStore(state).has(key);
	        return data && hasOwn(data, state.id);
	      }
	    });
	
	    defineBuiltIns(Prototype, IS_MAP ? {
	      // `WeakMap.prototype.get(key)` method
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
	      get: function get(key) {
	        var state = getInternalState(this);
	        if (isObject(key)) {
	          var data = getWeakData(key);
	          if (data === true) return uncaughtFrozenStore(state).get(key);
	          return data ? data[state.id] : undefined;
	        }
	      },
	      // `WeakMap.prototype.set(key, value)` method
	      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
	      set: function set(key, value) {
	        return define(this, key, value);
	      }
	    } : {
	      // `WeakSet.prototype.add(value)` method
	      // https://tc39.es/ecma262/#sec-weakset.prototype.add
	      add: function add(value) {
	        return define(this, value, true);
	      }
	    });
	
	    return Constructor;
	  }
	};


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var tryNodeRequire = __webpack_require__(560);
	var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(366);
	
	var structuredClone = global.structuredClone;
	var $ArrayBuffer = global.ArrayBuffer;
	var $MessageChannel = global.MessageChannel;
	var detach = false;
	var WorkerThreads, channel, buffer, $detach;
	
	if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	  detach = function (transferable) {
	    structuredClone(transferable, { transfer: [transferable] });
	  };
	} else if ($ArrayBuffer) try {
	  if (!$MessageChannel) {
	    WorkerThreads = tryNodeRequire('worker_threads');
	    if (WorkerThreads) $MessageChannel = WorkerThreads.MessageChannel;
	  }
	
	  if ($MessageChannel) {
	    channel = new $MessageChannel();
	    buffer = new $ArrayBuffer(2);
	
	    $detach = function (transferable) {
	      channel.port1.postMessage(null, [transferable]);
	    };
	
	    if (buffer.byteLength === 2) {
	      $detach(buffer);
	      if (buffer.byteLength === 0) detach = $detach;
	    }
	  }
	} catch (error) { /* empty */ }
	
	module.exports = detach;


/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	module.exports = {
	  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
	  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
	  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
	  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
	  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
	  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
	  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
	  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
	  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
	  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
	  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
	  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
	  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
	  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
	  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
	  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
	  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
	  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
	  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
	  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
	  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
	  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
	  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
	  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
	  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
	};


/***/ },
/* 508 */
/***/ function(module, exports) {

	'use strict';
	// iterable DOM collections
	// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
	module.exports = {
	  CSSRuleList: 0,
	  CSSStyleDeclaration: 0,
	  CSSValueList: 0,
	  ClientRectList: 0,
	  DOMRectList: 0,
	  DOMStringList: 0,
	  DOMTokenList: 1,
	  DataTransferItemList: 0,
	  FileList: 0,
	  HTMLAllCollection: 0,
	  HTMLCollection: 0,
	  HTMLFormElement: 0,
	  HTMLSelectElement: 0,
	  MediaList: 0,
	  MimeTypeArray: 0,
	  NamedNodeMap: 0,
	  NodeList: 1,
	  PaintRequestList: 0,
	  Plugin: 0,
	  PluginArray: 0,
	  SVGLengthList: 0,
	  SVGNumberList: 0,
	  SVGPathSegList: 0,
	  SVGPointList: 0,
	  SVGStringList: 0,
	  SVGTransformList: 0,
	  SourceBufferList: 0,
	  StyleSheetList: 0,
	  TextTrackCueList: 0,
	  TextTrackList: 0,
	  TouchList: 0
	};


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
	var documentCreateElement = __webpack_require__(249);
	
	var classList = documentCreateElement('span').classList;
	var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
	
	module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(103);
	
	var firefox = userAgent.match(/firefox\/(\d+)/i);
	
	module.exports = !!firefox && +firefox[1];


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IS_DENO = __webpack_require__(342);
	var IS_NODE = __webpack_require__(121);
	
	module.exports = !IS_DENO && !IS_NODE
	  && typeof window == 'object'
	  && typeof document == 'object';


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var UA = __webpack_require__(103);
	
	module.exports = /MSIE|Trident/.test(UA);


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(103);
	
	// eslint-disable-next-line redos/no-vulnerable -- safe
	module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createNonEnumerableProperty = __webpack_require__(65);
	var clearErrorStack = __webpack_require__(345);
	var ERROR_STACK_INSTALLABLE = __webpack_require__(515);
	
	// non-standard V8
	var captureStackTrace = Error.captureStackTrace;
	
	module.exports = function (error, C, stack, dropEntries) {
	  if (ERROR_STACK_INSTALLABLE) {
	    if (captureStackTrace) captureStackTrace(error, C);
	    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
	  }
	};


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var createPropertyDescriptor = __webpack_require__(85);
	
	module.exports = !fails(function () {
	  var error = new Error('a');
	  if (!('stack' in error)) return true;
	  // eslint-disable-next-line es/no-object-defineproperty -- safe
	  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
	  return error.stack !== 7;
	});


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var fails = __webpack_require__(7);
	var anObject = __webpack_require__(18);
	var normalizeStringArgument = __webpack_require__(208);
	
	var nativeErrorToString = Error.prototype.toString;
	
	var INCORRECT_TO_STRING = fails(function () {
	  if (DESCRIPTORS) {
	    // Chrome 32- incorrectly call accessor
	    // eslint-disable-next-line es/no-object-create, es/no-object-defineproperty -- safe
	    var object = Object.create(Object.defineProperty({}, 'name', { get: function () {
	      return this === object;
	    } }));
	    if (nativeErrorToString.call(object) !== 'true') return true;
	  }
	  // FF10- does not properly handle non-strings
	  return nativeErrorToString.call({ message: 1, name: 2 }) !== '2: 1'
	    // IE8 does not properly handle defaults
	    || nativeErrorToString.call({}) !== 'Error';
	});
	
	module.exports = INCORRECT_TO_STRING ? function toString() {
	  var O = anObject(this);
	  var name = normalizeStringArgument(O.name, 'Error');
	  var message = normalizeStringArgument(O.message);
	  return !name ? message : !message ? name : name + ': ' + message;
	} : nativeErrorToString;


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isArray = __webpack_require__(122);
	var lengthOfArrayLike = __webpack_require__(40);
	var doesNotExceedSafeInteger = __webpack_require__(163);
	var bind = __webpack_require__(45);
	
	// `FlattenIntoArray` abstract operation
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? bind(mapper, thisArg) : false;
	  var element, elementLen;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      if (depth > 0 && isArray(element)) {
	        elementLen = lengthOfArrayLike(element);
	        targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
	      } else {
	        doesNotExceedSafeInteger(targetIndex + 1);
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	};
	
	module.exports = flattenIntoArray;


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(36);
	var isObject = __webpack_require__(20);
	var hasOwn = __webpack_require__(28);
	var arraySlice = __webpack_require__(91);
	var NATIVE_BIND = __webpack_require__(204);
	
	var $Function = Function;
	var concat = uncurryThis([].concat);
	var join = uncurryThis([].join);
	var factories = {};
	
	var construct = function (C, argsLength, args) {
	  if (!hasOwn(factories, argsLength)) {
	    var list = [];
	    var i = 0;
	    for (; i < argsLength; i++) list[i] = 'a[' + i + ']';
	    factories[argsLength] = $Function('C,a', 'return new C(' + join(list, ',') + ')');
	  } return factories[argsLength](C, args);
	};
	
	// `Function.prototype.bind` method implementation
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	module.exports = NATIVE_BIND ? $Function.bind : function bind(that /* , ...args */) {
	  var F = aCallable(this);
	  var Prototype = F.prototype;
	  var partArgs = arraySlice(arguments, 1);
	  var boundFunction = function bound(/* args... */) {
	    var args = concat(partArgs, arraySlice(arguments));
	    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
	  };
	  if (isObject(Prototype)) boundFunction.prototype = Prototype;
	  return boundFunction;
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var toObject = __webpack_require__(33);
	
	var floor = Math.floor;
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	// eslint-disable-next-line redos/no-vulnerable -- safe
	var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
	
	// `GetSubstitution` abstract operation
	// https://tc39.es/ecma262/#sec-getsubstitution
	module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
	  var tailPos = position + matched.length;
	  var m = captures.length;
	  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	  if (namedCaptures !== undefined) {
	    namedCaptures = toObject(namedCaptures);
	    symbols = SUBSTITUTION_SYMBOLS;
	  }
	  return replace(replacement, symbols, function (match, ch) {
	    var capture;
	    switch (charAt(ch, 0)) {
	      case '$': return '$';
	      case '&': return matched;
	      case '`': return stringSlice(str, 0, position);
	      case "'": return stringSlice(str, tailPos);
	      case '<':
	        capture = namedCaptures[stringSlice(ch, 1, -1)];
	        break;
	      default: // \d\d?
	        var n = +ch;
	        if (n === 0) return match;
	        if (n > m) {
	          var f = floor(n / 10);
	          if (f === 0) return match;
	          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
	          return match;
	        }
	        capture = captures[n - 1];
	    }
	    return capture === undefined ? '' : capture;
	  });
	};


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	
	module.exports = getBuiltIn('document', 'documentElement');


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var fails = __webpack_require__(7);
	var createElement = __webpack_require__(249);
	
	// Thanks to IE8 for its funny defineProperty
	module.exports = !DESCRIPTORS && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(createElement('div'), 'a', {
	    get: function () { return 7; }
	  }).a !== 7;
	});


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(20);
	var createNonEnumerableProperty = __webpack_require__(65);
	
	// `InstallErrorCause` abstract operation
	// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
	module.exports = function (O, options) {
	  if (isObject(options) && 'cause' in options) {
	    createNonEnumerableProperty(O, 'cause', options.cause);
	  }
	};


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(92);
	
	module.exports = function (it) {
	  var klass = classof(it);
	  return klass === 'BigInt64Array' || klass === 'BigUint64Array';
	};


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(28);
	
	module.exports = function (descriptor) {
	  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
	};


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(20);
	
	module.exports = function (argument) {
	  return isObject(argument) || argument === null;
	};


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var isCallable = __webpack_require__(22);
	var isObject = __webpack_require__(20);
	var create = __webpack_require__(76);
	var getPrototypeOf = __webpack_require__(86);
	var defineBuiltIn = __webpack_require__(44);
	var wellKnownSymbol = __webpack_require__(21);
	var IS_PURE = __webpack_require__(48);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;
	
	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
	
	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
	  else {
	    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
	  }
	}
	
	var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype[ITERATOR].call(test) !== test;
	});
	
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
	else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
	
	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable(IteratorPrototype[ITERATOR])) {
	  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
	    return this;
	  });
	}
	
	module.exports = {
	  IteratorPrototype: IteratorPrototype,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var aCallable = __webpack_require__(36);
	var isCallable = __webpack_require__(22);
	var anObject = __webpack_require__(18);
	
	var $TypeError = TypeError;
	
	// `Map.prototype.upsert` method
	// https://github.com/tc39/proposal-upsert
	module.exports = function upsert(key, updateFn /* , insertFn */) {
	  var map = anObject(this);
	  var get = aCallable(map.get);
	  var has = aCallable(map.has);
	  var set = aCallable(map.set);
	  var insertFn = arguments.length > 2 ? arguments[2] : undefined;
	  var value;
	  if (!isCallable(updateFn) && !isCallable(insertFn)) {
	    throw new $TypeError('At least one callback required');
	  }
	  if (call(has, map, key)) {
	    value = call(get, map, key);
	    if (isCallable(updateFn)) {
	      value = updateFn(value);
	      call(set, map, key, value);
	    }
	  } else if (isCallable(insertFn)) {
	    value = insertFn();
	    call(set, map, key, value);
	  } return value;
	};


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var floatRound = __webpack_require__(1254);
	
	var FLOAT32_EPSILON = 1.1920928955078125e-7; // 2 ** -23;
	var FLOAT32_MAX_VALUE = 3.4028234663852886e+38; // 2 ** 128 - 2 ** 104
	var FLOAT32_MIN_VALUE = 1.1754943508222875e-38; // 2 ** -126;
	
	// `Math.fround` method implementation
	// https://tc39.es/ecma262/#sec-math.fround
	// eslint-disable-next-line es/no-math-fround -- safe
	module.exports = Math.fround || function fround(x) {
	  return floatRound(x, FLOAT32_EPSILON, FLOAT32_MAX_VALUE, FLOAT32_MIN_VALUE);
	};


/***/ },
/* 529 */
/***/ function(module, exports) {

	'use strict';
	var log = Math.log;
	var LOG10E = Math.LOG10E;
	
	// eslint-disable-next-line es/no-math-log10 -- safe
	module.exports = Math.log10 || function log10(x) {
	  return log(x) * LOG10E;
	};


/***/ },
/* 530 */
/***/ function(module, exports) {

	'use strict';
	var log = Math.log;
	
	// `Math.log1p` method implementation
	// https://tc39.es/ecma262/#sec-math.log1p
	// eslint-disable-next-line es/no-math-log1p -- safe
	module.exports = Math.log1p || function log1p(x) {
	  var n = +x;
	  return n > -1e-8 && n < 1e-8 ? n - n * n / 2 : log(1 + n);
	};


/***/ },
/* 531 */
/***/ function(module, exports) {

	'use strict';
	var ceil = Math.ceil;
	var floor = Math.floor;
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	module.exports = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var safeGetBuiltIn = __webpack_require__(543);
	var bind = __webpack_require__(45);
	var macrotask = __webpack_require__(264).set;
	var Queue = __webpack_require__(541);
	var IS_IOS = __webpack_require__(513);
	var IS_IOS_PEBBLE = __webpack_require__(1246);
	var IS_WEBOS_WEBKIT = __webpack_require__(1247);
	var IS_NODE = __webpack_require__(121);
	
	var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
	var document = global.document;
	var process = global.process;
	var Promise = global.Promise;
	var microtask = safeGetBuiltIn('queueMicrotask');
	var notify, toggle, node, promise, then;
	
	// modern engines have queueMicrotask method
	if (!microtask) {
	  var queue = new Queue();
	
	  var flush = function () {
	    var parent, fn;
	    if (IS_NODE && (parent = process.domain)) parent.exit();
	    while (fn = queue.get()) try {
	      fn();
	    } catch (error) {
	      if (queue.head) notify();
	      throw error;
	    }
	    if (parent) parent.enter();
	  };
	
	  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
	  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
	  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
	    toggle = true;
	    node = document.createTextNode('');
	    new MutationObserver(flush).observe(node, { characterData: true });
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    promise = Promise.resolve(undefined);
	    // workaround of WebKit ~ iOS Safari 10.1 bug
	    promise.constructor = Promise;
	    then = bind(promise.then, promise);
	    notify = function () {
	      then(flush);
	    };
	  // Node.js without promises
	  } else if (IS_NODE) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessage
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    // `webpack` dev server bug on IE global methods - use bind(fn, global)
	    macrotask = bind(macrotask, global);
	    notify = function () {
	      macrotask(flush);
	    };
	  }
	
	  microtask = function (fn) {
	    if (!queue.head) notify();
	    queue.add(fn);
	  };
	}
	
	module.exports = microtask;


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var fails = __webpack_require__(7);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(17);
	var trim = __webpack_require__(172).trim;
	var whitespaces = __webpack_require__(269);
	
	var charAt = uncurryThis(''.charAt);
	var $parseFloat = global.parseFloat;
	var Symbol = global.Symbol;
	var ITERATOR = Symbol && Symbol.iterator;
	var FORCED = 1 / $parseFloat(whitespaces + '-0') !== -Infinity
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails(function () { $parseFloat(Object(ITERATOR)); }));
	
	// `parseFloat` method
	// https://tc39.es/ecma262/#sec-parsefloat-string
	module.exports = FORCED ? function parseFloat(string) {
	  var trimmedString = trim(toString(string));
	  var result = $parseFloat(trimmedString);
	  return result === 0 && charAt(trimmedString, 0) === '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var fails = __webpack_require__(7);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(17);
	var trim = __webpack_require__(172).trim;
	var whitespaces = __webpack_require__(269);
	
	var $parseInt = global.parseInt;
	var Symbol = global.Symbol;
	var ITERATOR = Symbol && Symbol.iterator;
	var hex = /^[+-]?0x/i;
	var exec = uncurryThis(hex.exec);
	var FORCED = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
	  // MS Edge 18- broken with boxed symbols
	  || (ITERATOR && !fails(function () { $parseInt(Object(ITERATOR)); }));
	
	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	module.exports = FORCED ? function parseInt(string, radix) {
	  var S = trim(toString(string));
	  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var uncurryThis = __webpack_require__(8);
	var call = __webpack_require__(16);
	var fails = __webpack_require__(7);
	var objectKeys = __webpack_require__(209);
	var getOwnPropertySymbolsModule = __webpack_require__(256);
	var propertyIsEnumerableModule = __webpack_require__(257);
	var toObject = __webpack_require__(33);
	var IndexedObject = __webpack_require__(166);
	
	// eslint-disable-next-line es/no-object-assign -- safe
	var $assign = Object.assign;
	// eslint-disable-next-line es/no-object-defineproperty -- required for testing
	var defineProperty = Object.defineProperty;
	var concat = uncurryThis([].concat);
	
	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	module.exports = !$assign || fails(function () {
	  // should have correct order of operations (Edge bug)
	  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
	    enumerable: true,
	    get: function () {
	      defineProperty(this, 'b', {
	        value: 3,
	        enumerable: false
	      });
	    }
	  }), { b: 2 })).b !== 1) return true;
	  // should work with symbols and should have deterministic property order (V8 bug)
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line es/no-symbol -- safe
	  var symbol = Symbol('assign detection');
	  var alphabet = 'abcdefghijklmnopqrst';
	  A[symbol] = 7;
	  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
	  return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
	  var T = toObject(target);
	  var argumentsLength = arguments.length;
	  var index = 1;
	  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	  var propertyIsEnumerable = propertyIsEnumerableModule.f;
	  while (argumentsLength > index) {
	    var S = IndexedObject(arguments[index++]);
	    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var hasOwn = __webpack_require__(28);
	var toIndexedObject = __webpack_require__(55);
	var indexOf = __webpack_require__(198).indexOf;
	var hiddenKeys = __webpack_require__(206);
	
	var push = uncurryThis([].push);
	
	module.exports = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwn(O, key = names[i++])) {
	    ~indexOf(result, key) || push(result, key);
	  }
	  return result;
	};


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var fails = __webpack_require__(7);
	var uncurryThis = __webpack_require__(8);
	var objectGetPrototypeOf = __webpack_require__(86);
	var objectKeys = __webpack_require__(209);
	var toIndexedObject = __webpack_require__(55);
	var $propertyIsEnumerable = __webpack_require__(257).f;
	
	var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
	var push = uncurryThis([].push);
	
	// in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
	// of `null` prototype objects
	var IE_BUG = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es/no-object-create -- safe
	  var O = Object.create(null);
	  O[2] = 2;
	  return !propertyIsEnumerable(O, 2);
	});
	
	// `Object.{ entries, values }` methods implementation
	var createMethod = function (TO_ENTRIES) {
	  return function (it) {
	    var O = toIndexedObject(it);
	    var keys = objectKeys(O);
	    var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) {
	        push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};
	
	module.exports = {
	  // `Object.entries` method
	  // https://tc39.es/ecma262/#sec-object.entries
	  entries: createMethod(true),
	  // `Object.values` method
	  // https://tc39.es/ecma262/#sec-object.values
	  values: createMethod(false)
	};


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var isCallable = __webpack_require__(22);
	var isObject = __webpack_require__(20);
	
	var $TypeError = TypeError;
	
	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	module.exports = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
	  throw new $TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(20);
	var newPromiseCapability = __webpack_require__(125);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineProperty = __webpack_require__(41).f;
	
	module.exports = function (Target, Source, key) {
	  key in Target || defineProperty(Target, key, {
	    configurable: true,
	    get: function () { return Source[key]; },
	    set: function (it) { Source[key] = it; }
	  });
	};


/***/ },
/* 541 */
/***/ function(module, exports) {

	'use strict';
	var Queue = function () {
	  this.head = null;
	  this.tail = null;
	};
	
	Queue.prototype = {
	  add: function (item) {
	    var entry = { item: item, next: null };
	    var tail = this.tail;
	    if (tail) tail.next = entry;
	    else this.head = entry;
	    this.tail = entry;
	  },
	  get: function () {
	    var entry = this.head;
	    if (entry) {
	      var next = this.head = entry.next;
	      if (next === null) this.tail = null;
	      return entry.item;
	    }
	  }
	};
	
	module.exports = Queue;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(7);
	var global = __webpack_require__(11);
	
	// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
	var $RegExp = global.RegExp;
	
	module.exports = fails(function () {
	  var re = $RegExp('(?<a>b)', 'g');
	  return re.exec('b').groups.a !== 'b' ||
	    'b'.replace(re, '$<a>c') !== 'bc';
	});


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(15);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	
	// Avoid NodeJS experimental warning
	module.exports = function (name) {
	  if (!DESCRIPTORS) return global[name];
	  var descriptor = getOwnPropertyDescriptor(global, name);
	  return descriptor && descriptor.value;
	};


/***/ },
/* 544 */
/***/ function(module, exports) {

	'use strict';
	// `SameValue` abstract operation
	// https://tc39.es/ecma262/#sec-samevalue
	// eslint-disable-next-line es/no-object-is -- safe
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
	};


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(60);
	var SetHelpers = __webpack_require__(59);
	var clone = __webpack_require__(362);
	var size = __webpack_require__(214);
	var getSetRecord = __webpack_require__(142);
	var iterateSet = __webpack_require__(78);
	var iterateSimple = __webpack_require__(124);
	
	var has = SetHelpers.has;
	var remove = SetHelpers.remove;
	
	// `Set.prototype.difference` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function difference(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  var result = clone(O);
	  if (size(O) <= otherRec.size) iterateSet(O, function (e) {
	    if (otherRec.includes(e)) remove(result, e);
	  });
	  else iterateSimple(otherRec.getIterator(), function (e) {
	    if (has(O, e)) remove(result, e);
	  });
	  return result;
	};


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(60);
	var SetHelpers = __webpack_require__(59);
	var size = __webpack_require__(214);
	var getSetRecord = __webpack_require__(142);
	var iterateSet = __webpack_require__(78);
	var iterateSimple = __webpack_require__(124);
	
	var Set = SetHelpers.Set;
	var add = SetHelpers.add;
	var has = SetHelpers.has;
	
	// `Set.prototype.intersection` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function intersection(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  var result = new Set();
	
	  if (size(O) > otherRec.size) {
	    iterateSimple(otherRec.getIterator(), function (e) {
	      if (has(O, e)) add(result, e);
	    });
	  } else {
	    iterateSet(O, function (e) {
	      if (otherRec.includes(e)) add(result, e);
	    });
	  }
	
	  return result;
	};


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(60);
	var has = __webpack_require__(59).has;
	var size = __webpack_require__(214);
	var getSetRecord = __webpack_require__(142);
	var iterateSet = __webpack_require__(78);
	var iterateSimple = __webpack_require__(124);
	var iteratorClose = __webpack_require__(254);
	
	// `Set.prototype.isDisjointFrom` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isDisjointFrom
	module.exports = function isDisjointFrom(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (size(O) <= otherRec.size) return iterateSet(O, function (e) {
	    if (otherRec.includes(e)) return false;
	  }, true) !== false;
	  var iterator = otherRec.getIterator();
	  return iterateSimple(iterator, function (e) {
	    if (has(O, e)) return iteratorClose(iterator, 'normal', false);
	  }) !== false;
	};


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(60);
	var size = __webpack_require__(214);
	var iterate = __webpack_require__(78);
	var getSetRecord = __webpack_require__(142);
	
	// `Set.prototype.isSubsetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSubsetOf
	module.exports = function isSubsetOf(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (size(O) > otherRec.size) return false;
	  return iterate(O, function (e) {
	    if (!otherRec.includes(e)) return false;
	  }, true) !== false;
	};


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(60);
	var has = __webpack_require__(59).has;
	var size = __webpack_require__(214);
	var getSetRecord = __webpack_require__(142);
	var iterateSimple = __webpack_require__(124);
	var iteratorClose = __webpack_require__(254);
	
	// `Set.prototype.isSupersetOf` method
	// https://tc39.github.io/proposal-set-methods/#Set.prototype.isSupersetOf
	module.exports = function isSupersetOf(other) {
	  var O = aSet(this);
	  var otherRec = getSetRecord(other);
	  if (size(O) < otherRec.size) return false;
	  var iterator = otherRec.getIterator();
	  return iterateSimple(iterator, function (e) {
	    if (!has(O, e)) return iteratorClose(iterator, 'normal', false);
	  }) !== false;
	};


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(60);
	var SetHelpers = __webpack_require__(59);
	var clone = __webpack_require__(362);
	var getSetRecord = __webpack_require__(142);
	var iterateSimple = __webpack_require__(124);
	
	var add = SetHelpers.add;
	var has = SetHelpers.has;
	var remove = SetHelpers.remove;
	
	// `Set.prototype.symmetricDifference` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function symmetricDifference(other) {
	  var O = aSet(this);
	  var keysIter = getSetRecord(other).getIterator();
	  var result = clone(O);
	  iterateSimple(keysIter, function (e) {
	    if (has(O, e)) remove(result, e);
	    else add(result, e);
	  });
	  return result;
	};


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aSet = __webpack_require__(60);
	var add = __webpack_require__(59).add;
	var clone = __webpack_require__(362);
	var getSetRecord = __webpack_require__(142);
	var iterateSimple = __webpack_require__(124);
	
	// `Set.prototype.union` method
	// https://github.com/tc39/proposal-set-methods
	module.exports = function union(other) {
	  var O = aSet(this);
	  var keysIter = getSetRecord(other).getIterator();
	  var result = clone(O);
	  iterateSimple(keysIter, function (it) {
	    add(result, it);
	  });
	  return result;
	};


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zloirock/core-js/issues/280
	var userAgent = __webpack_require__(103);
	
	module.exports = /Version\/10(?:\.\d+){1,2}(?: [\w./]+)?(?: Mobile\/\w+)? Safari\//.test(userAgent);


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $trimEnd = __webpack_require__(172).end;
	var forcedStringTrimMethod = __webpack_require__(365);
	
	// `String.prototype.{ trimEnd, trimRight }` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimend
	// https://tc39.es/ecma262/#String.prototype.trimright
	module.exports = forcedStringTrimMethod('trimEnd') ? function trimEnd() {
	  return $trimEnd(this);
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	} : ''.trimEnd;


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $trimStart = __webpack_require__(172).start;
	var forcedStringTrimMethod = __webpack_require__(365);
	
	// `String.prototype.{ trimStart, trimLeft }` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimstart
	// https://tc39.es/ecma262/#String.prototype.trimleft
	module.exports = forcedStringTrimMethod('trimStart') ? function trimStart() {
	  return $trimStart(this);
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	} : ''.trimStart;


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var getBuiltIn = __webpack_require__(35);
	var wellKnownSymbol = __webpack_require__(21);
	var defineBuiltIn = __webpack_require__(44);
	
	module.exports = function () {
	  var Symbol = getBuiltIn('Symbol');
	  var SymbolPrototype = Symbol && Symbol.prototype;
	  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
	  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	
	  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
	    // `Symbol.prototype[@@toPrimitive]` method
	    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	    // eslint-disable-next-line no-unused-vars -- required for .length
	    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
	      return call(valueOf, this);
	    }, { arity: 1 });
	  }
	};


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var uncurryThis = __webpack_require__(8);
	
	var Symbol = getBuiltIn('Symbol');
	var keyFor = Symbol.keyFor;
	var thisSymbolValue = uncurryThis(Symbol.prototype.valueOf);
	
	// `Symbol.isRegisteredSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
	module.exports = Symbol.isRegisteredSymbol || function isRegisteredSymbol(value) {
	  try {
	    return keyFor(thisSymbolValue(value)) !== undefined;
	  } catch (error) {
	    return false;
	  }
	};


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var shared = __webpack_require__(147);
	var getBuiltIn = __webpack_require__(35);
	var uncurryThis = __webpack_require__(8);
	var isSymbol = __webpack_require__(123);
	var wellKnownSymbol = __webpack_require__(21);
	
	var Symbol = getBuiltIn('Symbol');
	var $isWellKnownSymbol = Symbol.isWellKnownSymbol;
	var getOwnPropertyNames = getBuiltIn('Object', 'getOwnPropertyNames');
	var thisSymbolValue = uncurryThis(Symbol.prototype.valueOf);
	var WellKnownSymbolsStore = shared('wks');
	
	for (var i = 0, symbolKeys = getOwnPropertyNames(Symbol), symbolKeysLength = symbolKeys.length; i < symbolKeysLength; i++) {
	  // some old engines throws on access to some keys like `arguments` or `caller`
	  try {
	    var symbolKey = symbolKeys[i];
	    if (isSymbol(Symbol[symbolKey])) wellKnownSymbol(symbolKey);
	  } catch (error) { /* empty */ }
	}
	
	// `Symbol.isWellKnownSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
	// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
	module.exports = function isWellKnownSymbol(value) {
	  if ($isWellKnownSymbol && $isWellKnownSymbol(value)) return true;
	  try {
	    var symbol = thisSymbolValue(value);
	    for (var j = 0, keys = getOwnPropertyNames(WellKnownSymbolsStore), keysLength = keys.length; j < keysLength; j++) {
	      // eslint-disable-next-line eqeqeq -- polyfilled symbols case
	      if (WellKnownSymbolsStore[keys[j]] == symbol) return true;
	    }
	  } catch (error) { /* empty */ }
	  return false;
	};


/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var NATIVE_SYMBOL = __webpack_require__(173);
	
	/* eslint-disable es/no-symbol -- safe */
	module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toPositiveInteger = __webpack_require__(1259);
	
	var $RangeError = RangeError;
	
	module.exports = function (it, BYTES) {
	  var offset = toPositiveInteger(it);
	  if (offset % BYTES) throw new $RangeError('Wrong offset');
	  return offset;
	};


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IS_NODE = __webpack_require__(121);
	
	module.exports = function (name) {
	  try {
	    // eslint-disable-next-line no-new-func -- safe
	    if (IS_NODE) return Function('return require("' + name + '")')();
	  } catch (error) { /* empty */ }
	};


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var bind = __webpack_require__(45);
	var call = __webpack_require__(16);
	var aConstructor = __webpack_require__(333);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var getIterator = __webpack_require__(252);
	var getIteratorMethod = __webpack_require__(205);
	var isArrayIteratorMethod = __webpack_require__(347);
	var isBigIntArray = __webpack_require__(523);
	var aTypedArrayConstructor = __webpack_require__(23).aTypedArrayConstructor;
	var toBigInt = __webpack_require__(367);
	
	module.exports = function from(source /* , mapfn, thisArg */) {
	  var C = aConstructor(this);
	  var O = toObject(source);
	  var argumentsLength = arguments.length;
	  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
	  var mapping = mapfn !== undefined;
	  var iteratorMethod = getIteratorMethod(O);
	  var i, length, result, thisIsBigIntArray, value, step, iterator, next;
	  if (iteratorMethod && !isArrayIteratorMethod(iteratorMethod)) {
	    iterator = getIterator(O, iteratorMethod);
	    next = iterator.next;
	    O = [];
	    while (!(step = call(next, iterator)).done) {
	      O.push(step.value);
	    }
	  }
	  if (mapping && argumentsLength > 2) {
	    mapfn = bind(mapfn, arguments[2]);
	  }
	  length = lengthOfArrayLike(O);
	  result = new (aTypedArrayConstructor(C))(length);
	  thisIsBigIntArray = isBigIntArray(result);
	  for (i = 0; length > i; i++) {
	    value = mapping ? mapfn(O[i], i) : O[i];
	    // FF30- typed arrays doesn't properly convert objects to typed array values
	    result[i] = thisIsBigIntArray ? toBigInt(value) : +value;
	  }
	  return result;
	};


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-symbol -- required for testing */
	var NATIVE_SYMBOL = __webpack_require__(173);
	
	module.exports = NATIVE_SYMBOL
	  && !Symbol.sham
	  && typeof Symbol.iterator == 'symbol';


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var fails = __webpack_require__(7);
	
	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	module.exports = DESCRIPTORS && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var isCallable = __webpack_require__(22);
	
	var WeakMap = global.WeakMap;
	
	module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(21);
	
	exports.f = wellKnownSymbol;


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var hasOwn = __webpack_require__(28);
	var createNonEnumerableProperty = __webpack_require__(65);
	var isPrototypeOf = __webpack_require__(77);
	var setPrototypeOf = __webpack_require__(100);
	var copyConstructorProperties = __webpack_require__(201);
	var proxyAccessor = __webpack_require__(540);
	var inheritIfRequired = __webpack_require__(143);
	var normalizeStringArgument = __webpack_require__(208);
	var installErrorCause = __webpack_require__(522);
	var installErrorStack = __webpack_require__(514);
	var DESCRIPTORS = __webpack_require__(15);
	var IS_PURE = __webpack_require__(48);
	
	module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
	  var STACK_TRACE_LIMIT = 'stackTraceLimit';
	  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
	  var path = FULL_NAME.split('.');
	  var ERROR_NAME = path[path.length - 1];
	  var OriginalError = getBuiltIn.apply(null, path);
	
	  if (!OriginalError) return;
	
	  var OriginalErrorPrototype = OriginalError.prototype;
	
	  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
	  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;
	
	  if (!FORCED) return OriginalError;
	
	  var BaseError = getBuiltIn('Error');
	
	  var WrappedError = wrapper(function (a, b) {
	    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
	    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
	    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
	    installErrorStack(result, WrappedError, result.stack, 2);
	    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
	    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
	    return result;
	  });
	
	  WrappedError.prototype = OriginalErrorPrototype;
	
	  if (ERROR_NAME !== 'Error') {
	    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
	    else copyConstructorProperties(WrappedError, BaseError, { name: true });
	  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
	    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
	    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
	  }
	
	  copyConstructorProperties(WrappedError, OriginalError);
	
	  if (!IS_PURE) try {
	    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
	    if (OriginalErrorPrototype.name !== ERROR_NAME) {
	      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
	    }
	    OriginalErrorPrototype.constructor = WrappedError;
	  } catch (error) { /* empty */ }
	
	  return WrappedError;
	};


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var isArray = __webpack_require__(122);
	var isObject = __webpack_require__(20);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var doesNotExceedSafeInteger = __webpack_require__(163);
	var createProperty = __webpack_require__(120);
	var arraySpeciesCreate = __webpack_require__(200);
	var arrayMethodHasSpeciesSupport = __webpack_require__(199);
	var wellKnownSymbol = __webpack_require__(21);
	var V8_VERSION = __webpack_require__(104);
	
	var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
	
	// We can't use this feature detection in V8 since it causes
	// deoptimization and serious performance degradation
	// https://github.com/zloirock/core-js/issues/679
	var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
	  var array = [];
	  array[IS_CONCAT_SPREADABLE] = false;
	  return array.concat()[0] !== array;
	});
	
	var isConcatSpreadable = function (O) {
	  if (!isObject(O)) return false;
	  var spreadable = O[IS_CONCAT_SPREADABLE];
	  return spreadable !== undefined ? !!spreadable : isArray(O);
	};
	
	var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');
	
	// `Array.prototype.concat` method
	// https://tc39.es/ecma262/#sec-array.prototype.concat
	// with adding support of @@isConcatSpreadable and @@species
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  concat: function concat(arg) {
	    var O = toObject(this);
	    var A = arraySpeciesCreate(O, 0);
	    var n = 0;
	    var i, k, length, len, E;
	    for (i = -1, length = arguments.length; i < length; i++) {
	      E = i === -1 ? O : arguments[i];
	      if (isConcatSpreadable(E)) {
	        len = lengthOfArrayLike(E);
	        doesNotExceedSafeInteger(n + len);
	        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
	      } else {
	        doesNotExceedSafeInteger(n + 1);
	        createProperty(A, n++, E);
	      }
	    }
	    A.length = n;
	    return A;
	  }
	});


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var from = __webpack_require__(497);
	var checkCorrectnessOfIteration = __webpack_require__(246);
	
	var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
	  // eslint-disable-next-line es/no-array-from -- required for testing
	  Array.from(iterable);
	});
	
	// `Array.from` method
	// https://tc39.es/ecma262/#sec-array.from
	$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
	  from: from
	});


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var apply = __webpack_require__(93);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var isCallable = __webpack_require__(22);
	var isSymbol = __webpack_require__(123);
	var arraySlice = __webpack_require__(91);
	var getReplacerFunction = __webpack_require__(1250);
	var NATIVE_SYMBOL = __webpack_require__(173);
	
	var $String = String;
	var $stringify = getBuiltIn('JSON', 'stringify');
	var exec = uncurryThis(/./.exec);
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var replace = uncurryThis(''.replace);
	var numberToString = uncurryThis(1.0.toString);
	
	var tester = /[\uD800-\uDFFF]/g;
	var low = /^[\uD800-\uDBFF]$/;
	var hi = /^[\uDC00-\uDFFF]$/;
	
	var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
	  var symbol = getBuiltIn('Symbol')('stringify detection');
	  // MS Edge converts symbol values to JSON as {}
	  return $stringify([symbol]) !== '[null]'
	    // WebKit converts symbol values to JSON as null
	    || $stringify({ a: symbol }) !== '{}'
	    // V8 throws on boxed symbols
	    || $stringify(Object(symbol)) !== '{}';
	});
	
	// https://github.com/tc39/proposal-well-formed-stringify
	var ILL_FORMED_UNICODE = fails(function () {
	  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
	    || $stringify('\uDEAD') !== '"\\udead"';
	});
	
	var stringifyWithSymbolsFix = function (it, replacer) {
	  var args = arraySlice(arguments);
	  var $replacer = getReplacerFunction(replacer);
	  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
	  args[1] = function (key, value) {
	    // some old implementations (like WebKit) could pass numbers as keys
	    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
	    if (!isSymbol(value)) return value;
	  };
	  return apply($stringify, null, args);
	};
	
	var fixIllFormed = function (match, offset, string) {
	  var prev = charAt(string, offset - 1);
	  var next = charAt(string, offset + 1);
	  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
	    return '\\u' + numberToString(charCodeAt(match, 0), 16);
	  } return match;
	};
	
	if ($stringify) {
	  // `JSON.stringify` method
	  // https://tc39.es/ecma262/#sec-json.stringify
	  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
	    // eslint-disable-next-line no-unused-vars -- required for `.length`
	    stringify: function stringify(it, replacer, space) {
	      var args = arraySlice(arguments);
	      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
	      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
	    }
	  });
	}


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var setToStringTag = __webpack_require__(73);
	
	// JSON[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-json-@@tostringtag
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1323);


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var log1p = __webpack_require__(530);
	
	// eslint-disable-next-line es/no-math-acosh -- required for testing
	var $acosh = Math.acosh;
	var log = Math.log;
	var sqrt = Math.sqrt;
	var LN2 = Math.LN2;
	
	var FORCED = !$acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  || Math.floor($acosh(Number.MAX_VALUE)) !== 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  || $acosh(Infinity) !== Infinity;
	
	// `Math.acosh` method
	// https://tc39.es/ecma262/#sec-math.acosh
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  acosh: function acosh(x) {
	    var n = +x;
	    return n < 1 ? NaN : n > 94906265.62425156
	      ? log(n) + LN2
	      : log1p(n - 1 + sqrt(n - 1) * sqrt(n + 1));
	  }
	});


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// eslint-disable-next-line es/no-math-asinh -- required for testing
	var $asinh = Math.asinh;
	var log = Math.log;
	var sqrt = Math.sqrt;
	
	function asinh(x) {
	  var n = +x;
	  return !isFinite(n) || n === 0 ? n : n < 0 ? -asinh(-n) : log(n + sqrt(n * n + 1));
	}
	
	var FORCED = !($asinh && 1 / $asinh(0) > 0);
	
	// `Math.asinh` method
	// https://tc39.es/ecma262/#sec-math.asinh
	// Tor Browser bug: Math.asinh(0) -> -0
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  asinh: asinh
	});


/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// eslint-disable-next-line es/no-math-atanh -- required for testing
	var $atanh = Math.atanh;
	var log = Math.log;
	
	var FORCED = !($atanh && 1 / $atanh(-0) < 0);
	
	// `Math.atanh` method
	// https://tc39.es/ecma262/#sec-math.atanh
	// Tor Browser bug: Math.atanh(-0) -> 0
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  atanh: function atanh(x) {
	    var n = +x;
	    return n === 0 ? n : log((1 + n) / (1 - n)) / 2;
	  }
	});


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var sign = __webpack_require__(352);
	
	var abs = Math.abs;
	var pow = Math.pow;
	
	// `Math.cbrt` method
	// https://tc39.es/ecma262/#sec-math.cbrt
	$({ target: 'Math', stat: true }, {
	  cbrt: function cbrt(x) {
	    var n = +x;
	    return sign(n) * pow(abs(n), 1 / 3);
	  }
	});


/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	var floor = Math.floor;
	var log = Math.log;
	var LOG2E = Math.LOG2E;
	
	// `Math.clz32` method
	// https://tc39.es/ecma262/#sec-math.clz32
	$({ target: 'Math', stat: true }, {
	  clz32: function clz32(x) {
	    var n = x >>> 0;
	    return n ? 31 - floor(log(n + 0.5) * LOG2E) : 32;
	  }
	});


/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var expm1 = __webpack_require__(255);
	
	// eslint-disable-next-line es/no-math-cosh -- required for testing
	var $cosh = Math.cosh;
	var abs = Math.abs;
	var E = Math.E;
	
	var FORCED = !$cosh || $cosh(710) === Infinity;
	
	// `Math.cosh` method
	// https://tc39.es/ecma262/#sec-math.cosh
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  cosh: function cosh(x) {
	    var t = expm1(abs(x) - 1) + 1;
	    return (t + 1 / (t * E * E)) * (E / 2);
	  }
	});


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var expm1 = __webpack_require__(255);
	
	// `Math.expm1` method
	// https://tc39.es/ecma262/#sec-math.expm1
	// eslint-disable-next-line es/no-math-expm1 -- required for testing
	$({ target: 'Math', stat: true, forced: expm1 !== Math.expm1 }, { expm1: expm1 });


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fround = __webpack_require__(528);
	
	// `Math.fround` method
	// https://tc39.es/ecma262/#sec-math.fround
	$({ target: 'Math', stat: true }, { fround: fround });


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// eslint-disable-next-line es/no-math-hypot -- required for testing
	var $hypot = Math.hypot;
	var abs = Math.abs;
	var sqrt = Math.sqrt;
	
	// Chrome 77 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=9546
	var FORCED = !!$hypot && $hypot(Infinity, NaN) !== Infinity;
	
	// `Math.hypot` method
	// https://tc39.es/ecma262/#sec-math.hypot
	$({ target: 'Math', stat: true, arity: 2, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  hypot: function hypot(value1, value2) {
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * sqrt(sum);
	  }
	});


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	
	// eslint-disable-next-line es/no-math-imul -- required for testing
	var $imul = Math.imul;
	
	var FORCED = fails(function () {
	  return $imul(0xFFFFFFFF, 5) !== -5 || $imul.length !== 2;
	});
	
	// `Math.imul` method
	// https://tc39.es/ecma262/#sec-math.imul
	// some WebKit versions fails with big numbers, some has wrong arity
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  imul: function imul(x, y) {
	    var UINT16 = 0xFFFF;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var log10 = __webpack_require__(529);
	
	// `Math.log10` method
	// https://tc39.es/ecma262/#sec-math.log10
	$({ target: 'Math', stat: true }, {
	  log10: log10
	});


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var log1p = __webpack_require__(530);
	
	// `Math.log1p` method
	// https://tc39.es/ecma262/#sec-math.log1p
	$({ target: 'Math', stat: true }, { log1p: log1p });


/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	var log = Math.log;
	var LN2 = Math.LN2;
	
	// `Math.log2` method
	// https://tc39.es/ecma262/#sec-math.log2
	$({ target: 'Math', stat: true }, {
	  log2: function log2(x) {
	    return log(x) / LN2;
	  }
	});


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var sign = __webpack_require__(352);
	
	// `Math.sign` method
	// https://tc39.es/ecma262/#sec-math.sign
	$({ target: 'Math', stat: true }, {
	  sign: sign
	});


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var expm1 = __webpack_require__(255);
	
	var abs = Math.abs;
	var exp = Math.exp;
	var E = Math.E;
	
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-math-sinh -- required for testing
	  return Math.sinh(-2e-17) !== -2e-17;
	});
	
	// `Math.sinh` method
	// https://tc39.es/ecma262/#sec-math.sinh
	// V8 near Chromium 38 has a problem with very small numbers
	$({ target: 'Math', stat: true, forced: FORCED }, {
	  sinh: function sinh(x) {
	    var n = +x;
	    return abs(n) < 1 ? (expm1(n) - expm1(-n)) / 2 : (exp(n - 1) - exp(-n - 1)) * (E / 2);
	  }
	});


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var expm1 = __webpack_require__(255);
	
	var exp = Math.exp;
	
	// `Math.tanh` method
	// https://tc39.es/ecma262/#sec-math.tanh
	$({ target: 'Math', stat: true }, {
	  tanh: function tanh(x) {
	    var n = +x;
	    var a = expm1(n);
	    var b = expm1(-n);
	    return a === Infinity ? 1 : b === Infinity ? -1 : (a - b) / (exp(n) + exp(-n));
	  }
	});


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var trunc = __webpack_require__(531);
	
	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	$({ target: 'Math', stat: true }, {
	  trunc: trunc
	});


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var IS_PURE = __webpack_require__(48);
	var DESCRIPTORS = __webpack_require__(15);
	var global = __webpack_require__(11);
	var path = __webpack_require__(106);
	var uncurryThis = __webpack_require__(8);
	var isForced = __webpack_require__(207);
	var hasOwn = __webpack_require__(28);
	var inheritIfRequired = __webpack_require__(143);
	var isPrototypeOf = __webpack_require__(77);
	var isSymbol = __webpack_require__(123);
	var toPrimitive = __webpack_require__(266);
	var fails = __webpack_require__(7);
	var getOwnPropertyNames = __webpack_require__(145).f;
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	var defineProperty = __webpack_require__(41).f;
	var thisNumberValue = __webpack_require__(265);
	var trim = __webpack_require__(172).trim;
	
	var NUMBER = 'Number';
	var NativeNumber = global[NUMBER];
	var PureNumberNamespace = path[NUMBER];
	var NumberPrototype = NativeNumber.prototype;
	var TypeError = global.TypeError;
	var stringSlice = uncurryThis(''.slice);
	var charCodeAt = uncurryThis(''.charCodeAt);
	
	// `ToNumeric` abstract operation
	// https://tc39.es/ecma262/#sec-tonumeric
	var toNumeric = function (value) {
	  var primValue = toPrimitive(value, 'number');
	  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
	};
	
	// `ToNumber` abstract operation
	// https://tc39.es/ecma262/#sec-tonumber
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, 'number');
	  var first, third, radix, maxCode, digits, length, index, code;
	  if (isSymbol(it)) throw new TypeError('Cannot convert a Symbol value to a number');
	  if (typeof it == 'string' && it.length > 2) {
	    it = trim(it);
	    first = charCodeAt(it, 0);
	    if (first === 43 || first === 45) {
	      third = charCodeAt(it, 2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (charCodeAt(it, 1)) {
	        // fast equal of /^0b[01]+$/i
	        case 66:
	        case 98:
	          radix = 2;
	          maxCode = 49;
	          break;
	        // fast equal of /^0o[0-7]+$/i
	        case 79:
	        case 111:
	          radix = 8;
	          maxCode = 55;
	          break;
	        default:
	          return +it;
	      }
	      digits = stringSlice(it, 2);
	      length = digits.length;
	      for (index = 0; index < length; index++) {
	        code = charCodeAt(digits, index);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));
	
	var calledWithNew = function (dummy) {
	  // includes check on 1..constructor(foo) case
	  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
	};
	
	// `Number` constructor
	// https://tc39.es/ecma262/#sec-number-constructor
	var NumberWrapper = function Number(value) {
	  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
	  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
	};
	
	NumberWrapper.prototype = NumberPrototype;
	if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;
	
	$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
	  Number: NumberWrapper
	});
	
	// Use `internal/copy-constructor-properties` helper in `core-js@4`
	var copyConstructorProperties = function (target, source) {
	  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES2015 (in case, if modules with ES2015 Number statics required before):
	    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
	    // ESNext
	    'fromString,range'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};
	
	if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
	if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// `Number.EPSILON` constant
	// https://tc39.es/ecma262/#sec-number.epsilon
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  EPSILON: Math.pow(2, -52)
	});


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var numberIsFinite = __webpack_require__(1255);
	
	// `Number.isFinite` method
	// https://tc39.es/ecma262/#sec-number.isfinite
	$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isIntegralNumber = __webpack_require__(348);
	
	// `Number.isInteger` method
	// https://tc39.es/ecma262/#sec-number.isinteger
	$({ target: 'Number', stat: true }, {
	  isInteger: isIntegralNumber
	});


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// `Number.isNaN` method
	// https://tc39.es/ecma262/#sec-number.isnan
	$({ target: 'Number', stat: true }, {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare -- NaN check
	    return number !== number;
	  }
	});


/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isIntegralNumber = __webpack_require__(348);
	
	var abs = Math.abs;
	
	// `Number.isSafeInteger` method
	// https://tc39.es/ecma262/#sec-number.issafeinteger
	$({ target: 'Number', stat: true }, {
	  isSafeInteger: function isSafeInteger(number) {
	    return isIntegralNumber(number) && abs(number) <= 0x1FFFFFFFFFFFFF;
	  }
	});


/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// `Number.MAX_SAFE_INTEGER` constant
	// https://tc39.es/ecma262/#sec-number.max_safe_integer
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
	});


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// `Number.MIN_SAFE_INTEGER` constant
	// https://tc39.es/ecma262/#sec-number.min_safe_integer
	$({ target: 'Number', stat: true, nonConfigurable: true, nonWritable: true }, {
	  MIN_SAFE_INTEGER: -0x1FFFFFFFFFFFFF
	});


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var parseFloat = __webpack_require__(533);
	
	// `Number.parseFloat` method
	// https://tc39.es/ecma262/#sec-number.parseFloat
	// eslint-disable-next-line es/no-number-parsefloat -- required for testing
	$({ target: 'Number', stat: true, forced: Number.parseFloat !== parseFloat }, {
	  parseFloat: parseFloat
	});


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var parseInt = __webpack_require__(534);
	
	// `Number.parseInt` method
	// https://tc39.es/ecma262/#sec-number.parseint
	// eslint-disable-next-line es/no-number-parseint -- required for testing
	$({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
	  parseInt: parseInt
	});


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(49);
	var thisNumberValue = __webpack_require__(265);
	var $repeat = __webpack_require__(263);
	var log10 = __webpack_require__(529);
	var fails = __webpack_require__(7);
	
	var $RangeError = RangeError;
	var $String = String;
	var $isFinite = isFinite;
	var abs = Math.abs;
	var floor = Math.floor;
	var pow = Math.pow;
	var round = Math.round;
	var nativeToExponential = uncurryThis(1.0.toExponential);
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	
	// Edge 17-
	var ROUNDS_PROPERLY = nativeToExponential(-6.9e-11, 4) === '-6.9000e-11'
	  // IE11- && Edge 14-
	  && nativeToExponential(1.255, 2) === '1.25e+0'
	  // FF86-, V8 ~ Chrome 49-50
	  && nativeToExponential(12345, 3) === '1.235e+4'
	  // FF86-, V8 ~ Chrome 49-50
	  && nativeToExponential(25, 0) === '3e+1';
	
	// IE8-
	var throwsOnInfinityFraction = function () {
	  return fails(function () {
	    nativeToExponential(1, Infinity);
	  }) && fails(function () {
	    nativeToExponential(1, -Infinity);
	  });
	};
	
	// Safari <11 && FF <50
	var properNonFiniteThisCheck = function () {
	  return !fails(function () {
	    nativeToExponential(Infinity, Infinity);
	    nativeToExponential(NaN, Infinity);
	  });
	};
	
	var FORCED = !ROUNDS_PROPERLY || !throwsOnInfinityFraction() || !properNonFiniteThisCheck();
	
	// `Number.prototype.toExponential` method
	// https://tc39.es/ecma262/#sec-number.prototype.toexponential
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toExponential: function toExponential(fractionDigits) {
	    var x = thisNumberValue(this);
	    if (fractionDigits === undefined) return nativeToExponential(x);
	    var f = toIntegerOrInfinity(fractionDigits);
	    if (!$isFinite(x)) return String(x);
	    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
	    if (f < 0 || f > 20) throw new $RangeError('Incorrect fraction digits');
	    if (ROUNDS_PROPERLY) return nativeToExponential(x, f);
	    var s = '';
	    var m = '';
	    var e = 0;
	    var c = '';
	    var d = '';
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x === 0) {
	      e = 0;
	      m = repeat('0', f + 1);
	    } else {
	      // this block is based on https://gist.github.com/SheetJSDev/1100ad56b9f856c95299ed0e068eea08
	      // TODO: improve accuracy with big fraction digits
	      var l = log10(x);
	      e = floor(l);
	      var n = 0;
	      var w = pow(10, e - f);
	      n = round(x / w);
	      if (2 * x >= (2 * n + 1) * w) {
	        n += 1;
	      }
	      if (n >= pow(10, f + 1)) {
	        n /= 10;
	        e += 1;
	      }
	      m = $String(n);
	    }
	    if (f !== 0) {
	      m = stringSlice(m, 0, 1) + '.' + stringSlice(m, 1);
	    }
	    if (e === 0) {
	      c = '+';
	      d = '0';
	    } else {
	      c = e > 0 ? '+' : '-';
	      d = $String(abs(e));
	    }
	    m += 'e' + c + d;
	    return s + m;
	  }
	});


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(49);
	var thisNumberValue = __webpack_require__(265);
	var $repeat = __webpack_require__(263);
	var fails = __webpack_require__(7);
	
	var $RangeError = RangeError;
	var $String = String;
	var floor = Math.floor;
	var repeat = uncurryThis($repeat);
	var stringSlice = uncurryThis(''.slice);
	var nativeToFixed = uncurryThis(1.0.toFixed);
	
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	var multiply = function (data, n, c) {
	  var index = -1;
	  var c2 = c;
	  while (++index < 6) {
	    c2 += n * data[index];
	    data[index] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	
	var divide = function (data, n) {
	  var index = 6;
	  var c = 0;
	  while (--index >= 0) {
	    c += data[index];
	    data[index] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	
	var dataToString = function (data) {
	  var index = 6;
	  var s = '';
	  while (--index >= 0) {
	    if (s !== '' || index === 0 || data[index] !== 0) {
	      var t = $String(data[index]);
	      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
	    }
	  } return s;
	};
	
	var FORCED = fails(function () {
	  return nativeToFixed(0.00008, 3) !== '0.000' ||
	    nativeToFixed(0.9, 0) !== '1' ||
	    nativeToFixed(1.255, 2) !== '1.25' ||
	    nativeToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToFixed({});
	});
	
	// `Number.prototype.toFixed` method
	// https://tc39.es/ecma262/#sec-number.prototype.tofixed
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toFixed: function toFixed(fractionDigits) {
	    var number = thisNumberValue(this);
	    var fractDigits = toIntegerOrInfinity(fractionDigits);
	    var data = [0, 0, 0, 0, 0, 0];
	    var sign = '';
	    var result = '0';
	    var e, z, j, k;
	
	    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
	    if (fractDigits < 0 || fractDigits > 20) throw new $RangeError('Incorrect fraction digits');
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (number !== number) return 'NaN';
	    if (number <= -1e21 || number >= 1e21) return $String(number);
	    if (number < 0) {
	      sign = '-';
	      number = -number;
	    }
	    if (number > 1e-21) {
	      e = log(number * pow(2, 69, 1)) - 69;
	      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(data, 0, z);
	        j = fractDigits;
	        while (j >= 7) {
	          multiply(data, 1e7, 0);
	          j -= 7;
	        }
	        multiply(data, pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(data, 1 << 23);
	          j -= 23;
	        }
	        divide(data, 1 << j);
	        multiply(data, 1, 1);
	        divide(data, 2);
	        result = dataToString(data);
	      } else {
	        multiply(data, 0, z);
	        multiply(data, 1 << -e, 0);
	        result = dataToString(data) + repeat('0', fractDigits);
	      }
	    }
	    if (fractDigits > 0) {
	      k = result.length;
	      result = sign + (k <= fractDigits
	        ? '0.' + repeat('0', fractDigits - k) + result
	        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
	    } else {
	      result = sign + result;
	    } return result;
	  }
	});


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var thisNumberValue = __webpack_require__(265);
	
	var nativeToPrecision = uncurryThis(1.0.toPrecision);
	
	var FORCED = fails(function () {
	  // IE7-
	  return nativeToPrecision(1, undefined) !== '1';
	}) || !fails(function () {
	  // V8 ~ Android 4.3-
	  nativeToPrecision({});
	});
	
	// `Number.prototype.toPrecision` method
	// https://tc39.es/ecma262/#sec-number.prototype.toprecision
	$({ target: 'Number', proto: true, forced: FORCED }, {
	  toPrecision: function toPrecision(precision) {
	    return precision === undefined
	      ? nativeToPrecision(thisNumberValue(this))
	      : nativeToPrecision(thisNumberValue(this), precision);
	  }
	});


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var setToStringTag = __webpack_require__(73);
	
	$({ global: true }, { Reflect: {} });
	
	// Reflect[@@toStringTag] property
	// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
	setToStringTag(global.Reflect, 'Reflect', true);


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1384);


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.asyncIterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.asynciterator
	defineWellKnownSymbol('asyncIterator');


/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	// `Symbol.prototype.description` getter
	// https://tc39.es/ecma262/#sec-symbol.prototype.description
	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(8);
	var hasOwn = __webpack_require__(28);
	var isCallable = __webpack_require__(22);
	var isPrototypeOf = __webpack_require__(77);
	var toString = __webpack_require__(17);
	var defineBuiltInAccessor = __webpack_require__(54);
	var copyConstructorProperties = __webpack_require__(201);
	
	var NativeSymbol = global.Symbol;
	var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
	
	if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
	  // Safari 12 bug
	  NativeSymbol().description !== undefined
	)) {
	  var EmptyStringDescriptionStore = {};
	  // wrap Symbol constructor for correct work with undefined description
	  var SymbolWrapper = function Symbol() {
	    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
	    var result = isPrototypeOf(SymbolPrototype, this)
	      ? new NativeSymbol(description)
	      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
	      : description === undefined ? NativeSymbol() : NativeSymbol(description);
	    if (description === '') EmptyStringDescriptionStore[result] = true;
	    return result;
	  };
	
	  copyConstructorProperties(SymbolWrapper, NativeSymbol);
	  SymbolWrapper.prototype = SymbolPrototype;
	  SymbolPrototype.constructor = SymbolWrapper;
	
	  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
	  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
	  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
	  var regexp = /^Symbol\((.*)\)[^)]+$/;
	  var replace = uncurryThis(''.replace);
	  var stringSlice = uncurryThis(''.slice);
	
	  defineBuiltInAccessor(SymbolPrototype, 'description', {
	    configurable: true,
	    get: function description() {
	      var symbol = thisSymbolValue(this);
	      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
	      var string = symbolDescriptiveString(symbol);
	      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
	      return desc === '' ? undefined : desc;
	    }
	  });
	
	  $({ global: true, constructor: true, forced: true }, {
	    Symbol: SymbolWrapper
	  });
	}


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.hasInstance` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.hasinstance
	defineWellKnownSymbol('hasInstance');


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.isConcatSpreadable` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.isconcatspreadable
	defineWellKnownSymbol('isConcatSpreadable');


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.iterator` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.iterator
	defineWellKnownSymbol('iterator');


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1422);
	__webpack_require__(1423);
	__webpack_require__(1424);
	__webpack_require__(569);
	__webpack_require__(1336);


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.matchAll` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.matchall
	defineWellKnownSymbol('matchAll');


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.match` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.match
	defineWellKnownSymbol('match');


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.replace` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.replace
	defineWellKnownSymbol('replace');


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.search` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.search
	defineWellKnownSymbol('search');


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.species` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.species
	defineWellKnownSymbol('species');


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.split` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.split
	defineWellKnownSymbol('split');


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	var defineSymbolToPrimitive = __webpack_require__(555);
	
	// `Symbol.toPrimitive` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.toprimitive
	defineWellKnownSymbol('toPrimitive');
	
	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var defineWellKnownSymbol = __webpack_require__(47);
	var setToStringTag = __webpack_require__(73);
	
	// `Symbol.toStringTag` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.tostringtag
	defineWellKnownSymbol('toStringTag');
	
	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.unscopables` well-known symbol
	// https://tc39.es/ecma262/#sec-symbol.unscopables
	defineWellKnownSymbol('unscopables');


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
	__webpack_require__(175);
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var safeGetBuiltIn = __webpack_require__(543);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(15);
	var USE_NATIVE_URL = __webpack_require__(268);
	var defineBuiltIn = __webpack_require__(44);
	var defineBuiltInAccessor = __webpack_require__(54);
	var defineBuiltIns = __webpack_require__(203);
	var setToStringTag = __webpack_require__(73);
	var createIteratorConstructor = __webpack_require__(349);
	var InternalStateModule = __webpack_require__(52);
	var anInstance = __webpack_require__(98);
	var isCallable = __webpack_require__(22);
	var hasOwn = __webpack_require__(28);
	var bind = __webpack_require__(45);
	var classof = __webpack_require__(92);
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(20);
	var $toString = __webpack_require__(17);
	var create = __webpack_require__(76);
	var createPropertyDescriptor = __webpack_require__(85);
	var getIterator = __webpack_require__(252);
	var getIteratorMethod = __webpack_require__(205);
	var createIterResultObject = __webpack_require__(202);
	var validateArgumentsLength = __webpack_require__(87);
	var wellKnownSymbol = __webpack_require__(21);
	var arraySort = __webpack_require__(338);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var URL_SEARCH_PARAMS = 'URLSearchParams';
	var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
	var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
	
	var nativeFetch = safeGetBuiltIn('fetch');
	var NativeRequest = safeGetBuiltIn('Request');
	var Headers = safeGetBuiltIn('Headers');
	var RequestPrototype = NativeRequest && NativeRequest.prototype;
	var HeadersPrototype = Headers && Headers.prototype;
	var RegExp = global.RegExp;
	var TypeError = global.TypeError;
	var decodeURIComponent = global.decodeURIComponent;
	var encodeURIComponent = global.encodeURIComponent;
	var charAt = uncurryThis(''.charAt);
	var join = uncurryThis([].join);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var shift = uncurryThis([].shift);
	var splice = uncurryThis([].splice);
	var split = uncurryThis(''.split);
	var stringSlice = uncurryThis(''.slice);
	
	var plus = /\+/g;
	var sequences = Array(4);
	
	var percentSequence = function (bytes) {
	  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
	};
	
	var percentDecode = function (sequence) {
	  try {
	    return decodeURIComponent(sequence);
	  } catch (error) {
	    return sequence;
	  }
	};
	
	var deserialize = function (it) {
	  var result = replace(it, plus, ' ');
	  var bytes = 4;
	  try {
	    return decodeURIComponent(result);
	  } catch (error) {
	    while (bytes) {
	      result = replace(result, percentSequence(bytes--), percentDecode);
	    }
	    return result;
	  }
	};
	
	var find = /[!'()~]|%20/g;
	
	var replacements = {
	  '!': '%21',
	  "'": '%27',
	  '(': '%28',
	  ')': '%29',
	  '~': '%7E',
	  '%20': '+'
	};
	
	var replacer = function (match) {
	  return replacements[match];
	};
	
	var serialize = function (it) {
	  return replace(encodeURIComponent(it), find, replacer);
	};
	
	var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
	  setInternalState(this, {
	    type: URL_SEARCH_PARAMS_ITERATOR,
	    target: getInternalParamsState(params).entries,
	    index: 0,
	    kind: kind
	  });
	}, URL_SEARCH_PARAMS, function next() {
	  var state = getInternalIteratorState(this);
	  var target = state.target;
	  var index = state.index++;
	  if (!target || index >= target.length) {
	    state.target = undefined;
	    return createIterResultObject(undefined, true);
	  }
	  var entry = target[index];
	  switch (state.kind) {
	    case 'keys': return createIterResultObject(entry.key, false);
	    case 'values': return createIterResultObject(entry.value, false);
	  } return createIterResultObject([entry.key, entry.value], false);
	}, true);
	
	var URLSearchParamsState = function (init) {
	  this.entries = [];
	  this.url = null;
	
	  if (init !== undefined) {
	    if (isObject(init)) this.parseObject(init);
	    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
	  }
	};
	
	URLSearchParamsState.prototype = {
	  type: URL_SEARCH_PARAMS,
	  bindURL: function (url) {
	    this.url = url;
	    this.update();
	  },
	  parseObject: function (object) {
	    var entries = this.entries;
	    var iteratorMethod = getIteratorMethod(object);
	    var iterator, next, step, entryIterator, entryNext, first, second;
	
	    if (iteratorMethod) {
	      iterator = getIterator(object, iteratorMethod);
	      next = iterator.next;
	      while (!(step = call(next, iterator)).done) {
	        entryIterator = getIterator(anObject(step.value));
	        entryNext = entryIterator.next;
	        if (
	          (first = call(entryNext, entryIterator)).done ||
	          (second = call(entryNext, entryIterator)).done ||
	          !call(entryNext, entryIterator).done
	        ) throw new TypeError('Expected sequence with length 2');
	        push(entries, { key: $toString(first.value), value: $toString(second.value) });
	      }
	    } else for (var key in object) if (hasOwn(object, key)) {
	      push(entries, { key: key, value: $toString(object[key]) });
	    }
	  },
	  parseQuery: function (query) {
	    if (query) {
	      var entries = this.entries;
	      var attributes = split(query, '&');
	      var index = 0;
	      var attribute, entry;
	      while (index < attributes.length) {
	        attribute = attributes[index++];
	        if (attribute.length) {
	          entry = split(attribute, '=');
	          push(entries, {
	            key: deserialize(shift(entry)),
	            value: deserialize(join(entry, '='))
	          });
	        }
	      }
	    }
	  },
	  serialize: function () {
	    var entries = this.entries;
	    var result = [];
	    var index = 0;
	    var entry;
	    while (index < entries.length) {
	      entry = entries[index++];
	      push(result, serialize(entry.key) + '=' + serialize(entry.value));
	    } return join(result, '&');
	  },
	  update: function () {
	    this.entries.length = 0;
	    this.parseQuery(this.url.query);
	  },
	  updateURL: function () {
	    if (this.url) this.url.update();
	  }
	};
	
	// `URLSearchParams` constructor
	// https://url.spec.whatwg.org/#interface-urlsearchparams
	var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
	  anInstance(this, URLSearchParamsPrototype);
	  var init = arguments.length > 0 ? arguments[0] : undefined;
	  var state = setInternalState(this, new URLSearchParamsState(init));
	  if (!DESCRIPTORS) this.size = state.entries.length;
	};
	
	var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
	
	defineBuiltIns(URLSearchParamsPrototype, {
	  // `URLSearchParams.prototype.append` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
	  append: function append(name, value) {
	    var state = getInternalParamsState(this);
	    validateArgumentsLength(arguments.length, 2);
	    push(state.entries, { key: $toString(name), value: $toString(value) });
	    if (!DESCRIPTORS) this.length++;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.delete` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
	  'delete': function (name /* , value */) {
	    var state = getInternalParamsState(this);
	    var length = validateArgumentsLength(arguments.length, 1);
	    var entries = state.entries;
	    var key = $toString(name);
	    var $value = length < 2 ? undefined : arguments[1];
	    var value = $value === undefined ? $value : $toString($value);
	    var index = 0;
	    while (index < entries.length) {
	      var entry = entries[index];
	      if (entry.key === key && (value === undefined || entry.value === value)) {
	        splice(entries, index, 1);
	        if (value !== undefined) break;
	      } else index++;
	    }
	    if (!DESCRIPTORS) this.size = entries.length;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.get` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
	  get: function get(name) {
	    var entries = getInternalParamsState(this).entries;
	    validateArgumentsLength(arguments.length, 1);
	    var key = $toString(name);
	    var index = 0;
	    for (; index < entries.length; index++) {
	      if (entries[index].key === key) return entries[index].value;
	    }
	    return null;
	  },
	  // `URLSearchParams.prototype.getAll` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
	  getAll: function getAll(name) {
	    var entries = getInternalParamsState(this).entries;
	    validateArgumentsLength(arguments.length, 1);
	    var key = $toString(name);
	    var result = [];
	    var index = 0;
	    for (; index < entries.length; index++) {
	      if (entries[index].key === key) push(result, entries[index].value);
	    }
	    return result;
	  },
	  // `URLSearchParams.prototype.has` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
	  has: function has(name /* , value */) {
	    var entries = getInternalParamsState(this).entries;
	    var length = validateArgumentsLength(arguments.length, 1);
	    var key = $toString(name);
	    var $value = length < 2 ? undefined : arguments[1];
	    var value = $value === undefined ? $value : $toString($value);
	    var index = 0;
	    while (index < entries.length) {
	      var entry = entries[index++];
	      if (entry.key === key && (value === undefined || entry.value === value)) return true;
	    }
	    return false;
	  },
	  // `URLSearchParams.prototype.set` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
	  set: function set(name, value) {
	    var state = getInternalParamsState(this);
	    validateArgumentsLength(arguments.length, 1);
	    var entries = state.entries;
	    var found = false;
	    var key = $toString(name);
	    var val = $toString(value);
	    var index = 0;
	    var entry;
	    for (; index < entries.length; index++) {
	      entry = entries[index];
	      if (entry.key === key) {
	        if (found) splice(entries, index--, 1);
	        else {
	          found = true;
	          entry.value = val;
	        }
	      }
	    }
	    if (!found) push(entries, { key: key, value: val });
	    if (!DESCRIPTORS) this.size = entries.length;
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.sort` method
	  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
	  sort: function sort() {
	    var state = getInternalParamsState(this);
	    arraySort(state.entries, function (a, b) {
	      return a.key > b.key ? 1 : -1;
	    });
	    state.updateURL();
	  },
	  // `URLSearchParams.prototype.forEach` method
	  forEach: function forEach(callback /* , thisArg */) {
	    var entries = getInternalParamsState(this).entries;
	    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
	    var index = 0;
	    var entry;
	    while (index < entries.length) {
	      entry = entries[index++];
	      boundFunction(entry.value, entry.key, this);
	    }
	  },
	  // `URLSearchParams.prototype.keys` method
	  keys: function keys() {
	    return new URLSearchParamsIterator(this, 'keys');
	  },
	  // `URLSearchParams.prototype.values` method
	  values: function values() {
	    return new URLSearchParamsIterator(this, 'values');
	  },
	  // `URLSearchParams.prototype.entries` method
	  entries: function entries() {
	    return new URLSearchParamsIterator(this, 'entries');
	  }
	}, { enumerable: true });
	
	// `URLSearchParams.prototype[@@iterator]` method
	defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });
	
	// `URLSearchParams.prototype.toString` method
	// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
	defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
	  return getInternalParamsState(this).serialize();
	}, { enumerable: true });
	
	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	  get: function size() {
	    return getInternalParamsState(this).entries.length;
	  },
	  configurable: true,
	  enumerable: true
	});
	
	setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
	
	$({ global: true, constructor: true, forced: !USE_NATIVE_URL }, {
	  URLSearchParams: URLSearchParamsConstructor
	});
	
	// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
	if (!USE_NATIVE_URL && isCallable(Headers)) {
	  var headersHas = uncurryThis(HeadersPrototype.has);
	  var headersSet = uncurryThis(HeadersPrototype.set);
	
	  var wrapRequestOptions = function (init) {
	    if (isObject(init)) {
	      var body = init.body;
	      var headers;
	      if (classof(body) === URL_SEARCH_PARAMS) {
	        headers = init.headers ? new Headers(init.headers) : new Headers();
	        if (!headersHas(headers, 'content-type')) {
	          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	        return create(init, {
	          body: createPropertyDescriptor(0, $toString(body)),
	          headers: createPropertyDescriptor(0, headers)
	        });
	      }
	    } return init;
	  };
	
	  if (isCallable(nativeFetch)) {
	    $({ global: true, enumerable: true, dontCallGetSet: true, forced: true }, {
	      fetch: function fetch(input /* , init */) {
	        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
	      }
	    });
	  }
	
	  if (isCallable(NativeRequest)) {
	    var RequestConstructor = function Request(input /* , init */) {
	      anInstance(this, RequestPrototype);
	      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
	    };
	
	    RequestPrototype.constructor = RequestConstructor;
	    RequestConstructor.prototype = RequestPrototype;
	
	    $({ global: true, constructor: true, dontCallGetSet: true, forced: true }, {
	      Request: RequestConstructor
	    });
	  }
	}
	
	module.exports = {
	  URLSearchParams: URLSearchParamsConstructor,
	  getState: getInternalParamsState
	};


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ v2.2.2 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1561), __webpack_require__(1560), __webpack_require__(1564), __webpack_require__(1563), __webpack_require__(621), __webpack_require__(1566)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-array', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Collection,d3Array,d3Interpolate,d3Format,d3Time,d3TimeFormat) { 'use strict';
	
	function initRange(domain, range) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.range(domain); break;
	    default: this.range(range).domain(domain); break;
	  }
	  return this;
	}
	
	function initInterpolator(domain, interpolator) {
	  switch (arguments.length) {
	    case 0: break;
	    case 1: this.interpolator(domain); break;
	    default: this.interpolator(interpolator).domain(domain); break;
	  }
	  return this;
	}
	
	var array = Array.prototype;
	
	var map = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal() {
	  var index = d3Collection.map(),
	      domain = [],
	      range = [],
	      unknown = implicit;
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range[(i - 1) % range.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), scale) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal(domain, range).unknown(unknown);
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range[1] < range[0],
	        start = range[reverse - 0],
	        stop = range[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band(domain(), range)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return initRange.apply(rescale(), arguments);
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band.apply(null, arguments).paddingInner(1));
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function number(x) {
	  return +x;
	}
	
	var unit = [0, 1];
	
	function identity(x) {
	  return x;
	}
	
	function normalize(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(isNaN(b) ? NaN : 0.5);
	}
	
	function clamper(domain) {
	  var a = domain[0], b = domain[domain.length - 1], t;
	  if (a > b) t = a, a = b, b = t;
	  return function(x) { return Math.max(a, Math.min(b, x)); };
	}
	
	// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
	function bimap(domain, range, interpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
	  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range, interpolate) {
	  var j = Math.min(domain.length, range.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range = range.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = normalize(domain[i], domain[i + 1]);
	    r[i] = interpolate(range[i], range[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function transformer() {
	  var domain = unit,
	      range = unit,
	      interpolate = d3Interpolate.interpolate,
	      transform,
	      untransform,
	      unknown,
	      clamp = identity,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
	  }
	
	  scale.invert = function(y) {
	    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), d3Interpolate.interpolateNumber)))(y)));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map.call(_, number), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate = _, rescale()) : interpolate;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t, u) {
	    transform = t, untransform = u;
	    return rescale();
	  };
	}
	
	function continuous(transform, untransform) {
	  return transformer()(transform, untransform);
	}
	
	function tickFormat(start, stop, count, specifier) {
	  var step = d3Array.tickStep(start, stop, count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	}
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    var d = domain();
	    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(identity, identity);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return linearish(scale);
	}
	
	function identity$1(domain) {
	  var unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map.call(_, number), scale) : domain.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return identity$1(domain).unknown(unknown);
	  };
	
	  domain = arguments.length ? map.call(domain, number) : [0, 1];
	
	  return linearish(scale);
	}
	
	function nice(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	}
	
	function transformLog(x) {
	  return Math.log(x);
	}
	
	function transformExp(x) {
	  return Math.exp(x);
	}
	
	function transformLogn(x) {
	  return -Math.log(-x);
	}
	
	function transformExpn(x) {
	  return -Math.exp(-x);
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function loggish(transform) {
	  var scale = transform(transformLog, transformExp),
	      domain = scale.domain,
	      base = 10,
	      logs,
	      pows;
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) {
	      logs = reflect(logs), pows = reflect(pows);
	      transform(transformLogn, transformExpn);
	    } else {
	      transform(transformLog, transformExp);
	    }
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  return scale;
	}
	
	function log() {
	  var scale = loggish(transformer()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy(scale, log()).base(scale.base());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function transformSymlog(c) {
	  return function(x) {
	    return Math.sign(x) * Math.log1p(Math.abs(x / c));
	  };
	}
	
	function transformSymexp(c) {
	  return function(x) {
	    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
	  };
	}
	
	function symlogish(transform) {
	  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
	
	  scale.constant = function(_) {
	    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
	  };
	
	  return linearish(scale);
	}
	
	function symlog() {
	  var scale = symlogish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, symlog()).constant(scale.constant());
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function transformPow(exponent) {
	  return function(x) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  };
	}
	
	function transformSqrt(x) {
	  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
	}
	
	function transformSquare(x) {
	  return x < 0 ? -x * x : x * x;
	}
	
	function powish(transform) {
	  var scale = transform(identity, identity),
	      exponent = 1;
	
	  function rescale() {
	    return exponent === 1 ? transform(identity, identity)
	        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
	        : transform(transformPow(exponent), transformPow(1 / exponent));
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, rescale()) : exponent;
	  };
	
	  return linearish(scale);
	}
	
	function pow() {
	  var scale = powish(transformer());
	
	  scale.copy = function() {
	    return copy(scale, pow()).exponent(scale.exponent());
	  };
	
	  initRange.apply(scale, arguments);
	
	  return scale;
	}
	
	function sqrt() {
	  return pow.apply(null, arguments).exponent(0.5);
	}
	
	function quantile() {
	  var domain = [],
	      range = [],
	      thresholds = [],
	      unknown;
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : range[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range = [0, 1],
	      unknown;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : scale;
	  };
	
	  scale.thresholds = function() {
	    return domain.slice();
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(linearish(scale), arguments);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range = [0, 1],
	      unknown,
	      n = 1;
	
	  function scale(x) {
	    return x <= x ? range[d3Array.bisect(domain, x, 0, n)] : unknown;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range)
	        .unknown(unknown);
	  };
	
	  return initRange.apply(scale, arguments);
	}
	
	var durationSecond = 1000,
	    durationMinute = durationSecond * 60,
	    durationHour = durationMinute * 60,
	    durationDay = durationHour * 24,
	    durationWeek = durationDay * 7,
	    durationMonth = durationDay * 30,
	    durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	  var scale = continuous(identity, identity),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format(".%L"),
	      formatSecond = format(":%S"),
	      formatMinute = format("%I:%M"),
	      formatHour = format("%I %p"),
	      formatDay = format("%a %d"),
	      formatWeek = format("%b %d"),
	      formatMonth = format("%B"),
	      formatYear = format("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	  };
	
	  return scale;
	}
	
	function time() {
	  return initRange.apply(calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
	}
	
	function utcTime() {
	  return initRange.apply(calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
	}
	
	function transformer$1() {
	  var x0 = 0,
	      x1 = 1,
	      t0,
	      t1,
	      k10,
	      transform,
	      interpolator = identity,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
	    return scale;
	  };
	}
	
	function copy$1(source, target) {
	  return target
	      .domain(source.domain())
	      .interpolator(source.interpolator())
	      .clamp(source.clamp())
	      .unknown(source.unknown());
	}
	
	function sequential() {
	  var scale = linearish(transformer$1()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, sequential());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialLog() {
	  var scale = loggish(transformer$1()).domain([1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSymlog() {
	  var scale = symlogish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialPow() {
	  var scale = powish(transformer$1());
	
	  scale.copy = function() {
	    return copy$1(scale, sequentialPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function sequentialSqrt() {
	  return sequentialPow.apply(null, arguments).exponent(0.5);
	}
	
	function sequentialQuantile() {
	  var domain = [],
	      interpolator = identity;
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return interpolator((d3Array.bisect(domain, x) - 1) / (domain.length - 1));
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return scale;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequentialQuantile(interpolator).domain(domain);
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function transformer$2() {
	  var x0 = 0,
	      x1 = 0.5,
	      x2 = 1,
	      t0,
	      t1,
	      t2,
	      k10,
	      k21,
	      interpolator = identity,
	      transform,
	      clamp = false,
	      unknown;
	
	  function scale(x) {
	    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  return function(t) {
	    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
	    return scale;
	  };
	}
	
	function diverging() {
	  var scale = linearish(transformer$2()(identity));
	
	  scale.copy = function() {
	    return copy$1(scale, diverging());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingLog() {
	  var scale = loggish(transformer$2()).domain([0.1, 1, 10]);
	
	  scale.copy = function() {
	    return copy$1(scale, divergingLog()).base(scale.base());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSymlog() {
	  var scale = symlogish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingSymlog()).constant(scale.constant());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingPow() {
	  var scale = powish(transformer$2());
	
	  scale.copy = function() {
	    return copy$1(scale, divergingPow()).exponent(scale.exponent());
	  };
	
	  return initInterpolator.apply(scale, arguments);
	}
	
	function divergingSqrt() {
	  return divergingPow.apply(null, arguments).exponent(0.5);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity$1;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleSymlog = symlog;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.scaleSequential = sequential;
	exports.scaleSequentialLog = sequentialLog;
	exports.scaleSequentialPow = sequentialPow;
	exports.scaleSequentialSqrt = sequentialSqrt;
	exports.scaleSequentialSymlog = sequentialSymlog;
	exports.scaleSequentialQuantile = sequentialQuantile;
	exports.scaleDiverging = diverging;
	exports.scaleDivergingLog = divergingLog;
	exports.scaleDivergingPow = divergingPow;
	exports.scaleDivergingSqrt = divergingSqrt;
	exports.scaleDivergingSymlog = divergingSymlog;
	exports.tickFormat = tickFormat;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
	  }
	
	  interval.floor = function(date) {
	    return floori(date = new Date(+date)), date;
	  };
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	var _index = _interopRequireDefault(__webpack_require__(216));
	function cloneObject(object) {
	  return (0, _index.default)({}, object);
	}
	module.exports = exports.default;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(176));
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */
	
	var formatters = {
	  // Year
	  y: function y(date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	
	    var signedYear = date.getUTCFullYear();
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function M(date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function d(date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function a(date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	      case 'aaa':
	        return dayPeriodEnumValue;
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function H(date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function m(date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function s(date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 624 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	};
	var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	};
	var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	  var dateTimeFormat;
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	};
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(217));
	var _index3 = _interopRequireDefault(__webpack_require__(1572));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(217));
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(218));
	var _index3 = _interopRequireDefault(__webpack_require__(1573));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 628 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
	exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
	exports.throwProtectedError = throwProtectedError;
	var protectedDayOfYearTokens = ['D', 'DD'];
	var protectedWeekYearTokens = ['YY', 'YYYY'];
	function isProtectedDayOfYearToken(token) {
	  return protectedDayOfYearTokens.indexOf(token) !== -1;
	}
	function isProtectedWeekYearToken(token) {
	  return protectedWeekYearTokens.indexOf(token) !== -1;
	}
	function throwProtectedError(token, format, input) {
	  if (token === 'YYYY') {
	    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'YY') {
	    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'D') {
	    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  } else if (token === 'DD') {
	    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
	  }
	}

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = add;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(110));
	var _index2 = _interopRequireDefault(__webpack_require__(220));
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var _index5 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name add
	 * @category Common Helpers
	 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @description
	 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 *
	 * | Key            | Description                        |
	 * |----------------|------------------------------------|
	 * | years          | Amount of years to be added        |
	 * | months         | Amount of months to be added       |
	 * | weeks          | Amount of weeks to be added        |
	 * | days           | Amount of days to be added         |
	 * | hours          | Amount of hours to be added        |
	 * | minutes        | Amount of minutes to be added      |
	 * | seconds        | Amount of seconds to be added      |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add the following duration to 1 September 2014, 10:19:50
	 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30,
	 * })
	 * //=> Thu Jun 15 2017 15:29:20
	 */
	function add(dirtyDate, duration) {
	  (0, _index4.default)(2, arguments);
	  if (!duration || (0, _typeof2.default)(duration) !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index5.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index5.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index5.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index5.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index5.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index5.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index5.default)(duration.seconds) : 0;
	
	  // Add years and months
	  var date = (0, _index3.default)(dirtyDate);
	  var dateWithMonths = months || years ? (0, _index2.default)(date, months + years * 12) : date;
	
	  // Add weeks and days
	  var dateWithDays = days || weeks ? (0, _index.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;
	
	  // Add days, hours, minutes and seconds
	  var minutesToAdd = minutes + hours * 60;
	  var secondsToAdd = seconds + minutesToAdd * 60;
	  var msToAdd = secondsToAdd * 1000;
	  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
	  return finalDate;
	}
	module.exports = exports.default;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addBusinessDays;
	var _index = _interopRequireDefault(__webpack_require__(277));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var _index5 = _interopRequireDefault(__webpack_require__(398));
	var _index6 = _interopRequireDefault(__webpack_require__(660));
	/**
	 * @name addBusinessDays
	 * @category Day Helpers
	 * @summary Add the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 10 business days to 1 September 2014:
	 * const result = addBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
	 */
	function addBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var startedOnWeekend = (0, _index.default)(date);
	  var amount = (0, _index3.default)(dirtyAmount);
	  if (isNaN(amount)) return new Date(NaN);
	  var hours = date.getHours();
	  var sign = amount < 0 ? -1 : 1;
	  var fullWeeks = (0, _index3.default)(amount / 5);
	  date.setDate(date.getDate() + fullWeeks * 7);
	
	  // Get remaining days not part of a full week
	  var restDays = Math.abs(amount % 5);
	
	  // Loops over remaining days
	  while (restDays > 0) {
	    date.setDate(date.getDate() + sign);
	    if (!(0, _index.default)(date)) restDays -= 1;
	  }
	
	  // If the date is a weekend day and we reduce a dividable of
	  // 5 from it, we land on a weekend date.
	  // To counter this, we add days accordingly to land on the next business day
	  if (startedOnWeekend && (0, _index.default)(date) && amount !== 0) {
	    // If we're reducing days, we want to add days until we land on a weekday
	    // If we're adding days we want to reduce days until we land on a weekday
	    if ((0, _index6.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
	    if ((0, _index5.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
	  }
	
	  // Restore hours to avoid DST lag
	  date.setHours(hours);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addISOWeekYears;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(179));
	var _index3 = _interopRequireDefault(__webpack_require__(667));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Add the specified number of ISO week-numbering years to the given date.
	 *
	 * @description
	 * Add the specified number of ISO week-numbering years to the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 ISO week-numbering years to 2 July 2010:
	 * const result = addISOWeekYears(new Date(2010, 6, 2), 5)
	 * //=> Fri Jun 26 2015 00:00:00
	 */
	function addISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index4.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index3.default)(dirtyDate, (0, _index2.default)(dirtyDate) + amount);
	}
	module.exports = exports.default;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addSeconds;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(219));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addSeconds
	 * @category Second Helpers
	 * @summary Add the specified number of seconds to the given date.
	 *
	 * @description
	 * Add the specified number of seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 30 seconds to 10 July 2014 12:45:00:
	 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:45:30
	 */
	function addSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 1000);
	}
	module.exports = exports.default;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addYears;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(220));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name addYears
	 * @category Year Helpers
	 * @summary Add the specified number of years to the given date.
	 *
	 * @description
	 * Add the specified number of years to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 5 years to 1 September 2014:
	 * const result = addYears(new Date(2014, 8, 1), 5)
	 * //=> Sun Sep 01 2019 00:00:00
	 */
	function addYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, amount * 12);
	}
	module.exports = exports.default;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeekYears;
	var _index = _interopRequireDefault(__webpack_require__(179));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name differenceInCalendarISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
	 * const result = differenceInCalendarISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 2
	 */
	function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft) - (0, _index.default)(dirtyDateRight);
	}
	module.exports = exports.default;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarQuarters;
	var _index = _interopRequireDefault(__webpack_require__(646));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name differenceInCalendarQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of calendar quarters between the given dates.
	 *
	 * @description
	 * Get the number of calendar quarters between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
	 * const result = differenceInCalendarQuarters(
	 *   new Date(2014, 6, 2),
	 *   new Date(2013, 11, 31)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var dateLeft = (0, _index2.default)(dirtyDateLeft);
	  var dateRight = (0, _index2.default)(dirtyDateRight);
	  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
	  var quarterDiff = (0, _index.default)(dateLeft) - (0, _index.default)(dateRight);
	  return yearDiff * 4 + quarterDiff;
	}
	module.exports = exports.default;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInYears;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(389));
	var _index3 = _interopRequireDefault(__webpack_require__(150));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name differenceInYears
	 * @category Year Helpers
	 * @summary Get the number of full years between the given dates.
	 *
	 * @description
	 * Get the number of full years between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full years are between 31 December 2013 and 11 February 2015?
	 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
	 * //=> 1
	 */
	function differenceInYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index4.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	
	  // Set both dates to a valid leap year for accurate comparison when dealing
	  // with leap days
	  dateLeft.setFullYear(1584);
	  dateRight.setFullYear(1584);
	
	  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastYearNotFull = (0, _index3.default)(dateLeft, dateRight) === -sign;
	  var result = sign * (difference - Number(isLastYearNotFull));
	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports.default;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachDayOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachDayOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of dates within the specified time interval.
	 *
	 * @description
	 * Return the array of dates within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each day between 6 October 2014 and 10 October 2014:
	 * const result = eachDayOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 9, 10)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 00:00:00,
	 * //   Tue Oct 07 2014 00:00:00,
	 * //   Wed Oct 08 2014 00:00:00,
	 * //   Thu Oct 09 2014 00:00:00,
	 * //   Fri Oct 10 2014 00:00:00
	 * // ]
	 */
	function eachDayOfInterval(dirtyInterval, options) {
	  var _options$step;
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setDate(currentDate.getDate() + step);
	    currentDate.setHours(0, 0, 0, 0);
	  }
	  return dates;
	}
	module.exports = exports.default;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfWeek;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfWeek
	 * @category Week Helpers
	 * @summary Return the end of a week for the given date.
	 *
	 * @description
	 * Return the end of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the end of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The end of a week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 23:59:59.999
	 *
	 * @example
	 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
	 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setDate(date.getDate() + diff);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfYear
	 * @category Year Helpers
	 * @summary Return the end of a year for the given date.
	 *
	 * @description
	 * Return the end of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a year for 2 September 2014 11:55:00:
	 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 23:59:59.999
	 */
	function endOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistance;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(150));
	var _index3 = _interopRequireDefault(__webpack_require__(274));
	var _index4 = _interopRequireDefault(__webpack_require__(275));
	var _index5 = _interopRequireDefault(__webpack_require__(177));
	var _index6 = _interopRequireDefault(__webpack_require__(6));
	var _index7 = _interopRequireDefault(__webpack_require__(622));
	var _index8 = _interopRequireDefault(__webpack_require__(216));
	var _index9 = _interopRequireDefault(__webpack_require__(109));
	var _index10 = _interopRequireDefault(__webpack_require__(5));
	var MINUTES_IN_DAY = 1440;
	var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
	var MINUTES_IN_MONTH = 43200;
	var MINUTES_IN_TWO_MONTHS = 86400;
	
	/**
	 * @name formatDistance
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words.
	 *
	 * | Distance between dates                                            | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance between dates | Result               |
	 * |------------------------|----------------------|
	 * | 0 secs ... 5 secs      | less than 5 seconds  |
	 * | 5 secs ... 10 secs     | less than 10 seconds |
	 * | 10 secs ... 20 secs    | less than 20 seconds |
	 * | 20 secs ... 40 secs    | half a minute        |
	 * | 40 secs ... 60 secs    | less than a minute   |
	 * | 60 secs ... 90 secs    | 1 minute             |
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00, including seconds?
	 * const result = formatDistance(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0),
	 *   { includeSeconds: true }
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> 'about 1 year ago'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> 'pli ol 1 jaro'
	 */
	
	function formatDistance(dirtyDate, dirtyBaseDate, options) {
	  var _ref, _options$locale;
	  (0, _index10.default)(2, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index5.default;
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain formatDistance property');
	  }
	  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	  var localizeOptions = (0, _index8.default)((0, _index7.default)(options), {
	    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
	    comparison: comparison
	  });
	  var dateLeft;
	  var dateRight;
	  if (comparison > 0) {
	    dateLeft = (0, _index6.default)(dirtyBaseDate);
	    dateRight = (0, _index6.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index6.default)(dirtyDate);
	    dateRight = (0, _index6.default)(dirtyBaseDate);
	  }
	  var seconds = (0, _index4.default)(dateRight, dateLeft);
	  var offsetInSeconds = ((0, _index9.default)(dateRight) - (0, _index9.default)(dateLeft)) / 1000;
	  var minutes = Math.round((seconds - offsetInSeconds) / 60);
	  var months;
	
	  // 0 up to 2 mins
	  if (minutes < 2) {
	    if (options !== null && options !== void 0 && options.includeSeconds) {
	      if (seconds < 5) {
	        return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
	      } else if (seconds < 10) {
	        return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
	      } else if (seconds < 20) {
	        return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
	      } else if (seconds < 40) {
	        return locale.formatDistance('halfAMinute', 0, localizeOptions);
	      } else if (seconds < 60) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', 1, localizeOptions);
	      }
	    } else {
	      if (minutes === 0) {
	        return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
	      } else {
	        return locale.formatDistance('xMinutes', minutes, localizeOptions);
	      }
	    }
	
	    // 2 mins up to 0.75 hrs
	  } else if (minutes < 45) {
	    return locale.formatDistance('xMinutes', minutes, localizeOptions);
	
	    // 0.75 hrs up to 1.5 hrs
	  } else if (minutes < 90) {
	    return locale.formatDistance('aboutXHours', 1, localizeOptions);
	
	    // 1.5 hrs up to 24 hrs
	  } else if (minutes < MINUTES_IN_DAY) {
	    var hours = Math.round(minutes / 60);
	    return locale.formatDistance('aboutXHours', hours, localizeOptions);
	
	    // 1 day up to 1.75 days
	  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
	    return locale.formatDistance('xDays', 1, localizeOptions);
	
	    // 1.75 days up to 30 days
	  } else if (minutes < MINUTES_IN_MONTH) {
	    var days = Math.round(minutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions);
	
	    // 1 month up to 2 months
	  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
	    months = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('aboutXMonths', months, localizeOptions);
	  }
	  months = (0, _index3.default)(dateRight, dateLeft);
	
	  // 2 months up to 12 months
	  if (months < 12) {
	    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
	    return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
	
	    // 1 year up to max Date
	  } else {
	    var monthsSinceStartOfYear = months % 12;
	    var years = Math.floor(months / 12);
	
	    // N years up to 1 years 3 months
	    if (monthsSinceStartOfYear < 3) {
	      return locale.formatDistance('aboutXYears', years, localizeOptions);
	
	      // N years 3 months up to N years 9 months
	    } else if (monthsSinceStartOfYear < 9) {
	      return locale.formatDistance('overXYears', years, localizeOptions);
	
	      // N years 9 months up to N year 12 months
	    } else {
	      return locale.formatDistance('almostXYears', years + 1, localizeOptions);
	    }
	  }
	}
	module.exports = exports.default;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceStrict;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(109));
	var _index3 = _interopRequireDefault(__webpack_require__(150));
	var _index4 = _interopRequireDefault(__webpack_require__(6));
	var _index5 = _interopRequireDefault(__webpack_require__(622));
	var _index6 = _interopRequireDefault(__webpack_require__(216));
	var _index7 = _interopRequireDefault(__webpack_require__(177));
	var _index8 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_MINUTE = 1000 * 60;
	var MINUTES_IN_DAY = 60 * 24;
	var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
	var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;
	
	/**
	 * @name formatDistanceStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given dates in words.
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
	 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // What is the distance between 2 July 2014 and 1 January 2015?
	 * const result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
	 * //=> '6 months'
	 *
	 * @example
	 * // What is the distance between 1 January 2015 00:00:15
	 * // and 1 January 2015 00:00:00?
	 * const result = formatDistanceStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   new Date(2015, 0, 1, 0, 0, 0)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, with a suffix?
	 * const result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
	 *   addSuffix: true
	 * })
	 * //=> '1 year ago'
	 *
	 * @example
	 * // What is the distance from 1 January 2016
	 * // to 1 January 2015, in minutes?
	 * const result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
	 *   unit: 'minute'
	 * })
	 * //=> '525600 minutes'
	 *
	 * @example
	 * // What is the distance from 1 January 2015
	 * // to 28 January 2015, in months, rounded up?
	 * const result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
	 *   locale: eoLocale
	 * })
	 * //=> '1 jaro'
	 */
	
	function formatDistanceStrict(dirtyDate, dirtyBaseDate, options) {
	  var _ref, _options$locale, _options$roundingMeth;
	  (0, _index8.default)(2, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index7.default;
	  if (!locale.formatDistance) {
	    throw new RangeError('locale must contain localize.formatDistance property');
	  }
	  var comparison = (0, _index3.default)(dirtyDate, dirtyBaseDate);
	  if (isNaN(comparison)) {
	    throw new RangeError('Invalid time value');
	  }
	  var localizeOptions = (0, _index6.default)((0, _index5.default)(options), {
	    addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
	    comparison: comparison
	  });
	  var dateLeft;
	  var dateRight;
	  if (comparison > 0) {
	    dateLeft = (0, _index4.default)(dirtyBaseDate);
	    dateRight = (0, _index4.default)(dirtyDate);
	  } else {
	    dateLeft = (0, _index4.default)(dirtyDate);
	    dateRight = (0, _index4.default)(dirtyBaseDate);
	  }
	  var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
	  var roundingMethodFn;
	  if (roundingMethod === 'floor') {
	    roundingMethodFn = Math.floor;
	  } else if (roundingMethod === 'ceil') {
	    roundingMethodFn = Math.ceil;
	  } else if (roundingMethod === 'round') {
	    roundingMethodFn = Math.round;
	  } else {
	    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
	  }
	  var milliseconds = dateRight.getTime() - dateLeft.getTime();
	  var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
	  var timezoneOffset = (0, _index2.default)(dateRight) - (0, _index2.default)(dateLeft);
	
	  // Use DST-normalized difference in minutes for years, months and days;
	  // use regular difference in minutes for hours, minutes and seconds.
	  var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
	  var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
	  var unit;
	  if (!defaultUnit) {
	    if (minutes < 1) {
	      unit = 'second';
	    } else if (minutes < 60) {
	      unit = 'minute';
	    } else if (minutes < MINUTES_IN_DAY) {
	      unit = 'hour';
	    } else if (dstNormalizedMinutes < MINUTES_IN_MONTH) {
	      unit = 'day';
	    } else if (dstNormalizedMinutes < MINUTES_IN_YEAR) {
	      unit = 'month';
	    } else {
	      unit = 'year';
	    }
	  } else {
	    unit = String(defaultUnit);
	  }
	
	  // 0 up to 60 seconds
	  if (unit === 'second') {
	    var seconds = roundingMethodFn(milliseconds / 1000);
	    return locale.formatDistance('xSeconds', seconds, localizeOptions);
	
	    // 1 up to 60 mins
	  } else if (unit === 'minute') {
	    var roundedMinutes = roundingMethodFn(minutes);
	    return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);
	
	    // 1 up to 24 hours
	  } else if (unit === 'hour') {
	    var hours = roundingMethodFn(minutes / 60);
	    return locale.formatDistance('xHours', hours, localizeOptions);
	
	    // 1 up to 30 days
	  } else if (unit === 'day') {
	    var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
	    return locale.formatDistance('xDays', days, localizeOptions);
	
	    // 1 up to 12 months
	  } else if (unit === 'month') {
	    var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
	    return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);
	
	    // 1 year up to max Date
	  } else if (unit === 'year') {
	    var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
	    return locale.formatDistance('xYears', years, localizeOptions);
	  }
	  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
	}
	module.exports = exports.default;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDate;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getDate
	 * @category Day Helpers
	 * @summary Get the day of the month of the given date.
	 *
	 * @description
	 * Get the day of the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the month is 29 February 2012?
	 * const result = getDate(new Date(2012, 1, 29))
	 * //=> 29
	 */
	function getDate(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dayOfMonth = date.getDate();
	  return dayOfMonth;
	}
	module.exports = exports.default;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getDaysInMonth
	 * @category Month Helpers
	 * @summary Get the number of days in a month of the given date.
	 *
	 * @description
	 * Get the number of days in a month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in February 2000?
	 * const result = getDaysInMonth(new Date(2000, 1))
	 * //=> 29
	 */
	function getDaysInMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var monthIndex = date.getMonth();
	  var lastDayOfMonth = new Date(0);
	  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
	  lastDayOfMonth.setHours(0, 0, 0, 0);
	  return lastDayOfMonth.getDate();
	}
	module.exports = exports.default;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISODay;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getISODay
	 * @category Weekday Helpers
	 * @summary Get the day of the ISO week of the given date.
	 *
	 * @description
	 * Get the day of the ISO week of the given date,
	 * which is 7 for Sunday, 1 for Monday etc.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the ISO week is 26 February 2012?
	 * const result = getISODay(new Date(2012, 1, 26))
	 * //=> 7
	 */
	function getISODay(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  if (day === 0) {
	    day = 7;
	  }
	  return day;
	}
	module.exports = exports.default;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(223));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name getISOWeek
	 * @category ISO Week Helpers
	 * @summary Get the ISO week of the given date.
	 *
	 * @description
	 * Get the ISO week of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which week of the ISO-week numbering year is 2 January 2005?
	 * const result = getISOWeek(new Date(2005, 0, 2))
	 * //=> 53
	 */
	function getISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getQuarter;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getQuarter
	 * @category Quarter Helpers
	 * @summary Get the year quarter of the given date.
	 *
	 * @description
	 * Get the year quarter of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which quarter is 2 July 2014?
	 * const result = getQuarter(new Date(2014, 6, 2))
	 * //=> 3
	 */
	function getQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var quarter = Math.floor(date.getMonth() / 3) + 1;
	  return quarter;
	}
	module.exports = exports.default;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTime;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getTime
	 * @category Timestamp Helpers
	 * @summary Get the milliseconds timestamp of the given date.
	 *
	 * @description
	 * Get the milliseconds timestamp of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05.123:
	 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 1330515905123
	 */
	function getTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  return timestamp;
	}
	module.exports = exports.default;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeek;
	var _index = _interopRequireDefault(__webpack_require__(131));
	var _index2 = _interopRequireDefault(__webpack_require__(402));
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name getWeek
	 * @category Week Helpers
	 * @summary Get the local week index of the given date.
	 *
	 * @description
	 * Get the local week index of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week of the local week numbering year is 2 January 2005 with default options?
	 * const result = getWeek(new Date(2005, 0, 2))
	 * //=> 2
	 *
	 * // Which week of the local week numbering year is 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January?
	 * const result = getWeek(new Date(2005, 0, 2), {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> 53
	 */
	
	function getWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index3.default)(dirtyDate);
	  var diff = (0, _index.default)(date, options).getTime() - (0, _index2.default)(date, options).getTime();
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(131));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var _index5 = __webpack_require__(51);
	/**
	 * @name getWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Get the local week-numbering year of the given date.
	 *
	 * @description
	 * Get the local week-numbering year of the given date.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Number} the local week-numbering year
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 with the default settings?
	 * const result = getWeekYear(new Date(2004, 11, 26))
	 * //=> 2005
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
	 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
	 * //=> 2004
	 *
	 * @example
	 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
	 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
	 * //=> 2004
	 */
	function getWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = date.getFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	module.exports = exports.default;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLastDayOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(394));
	var _index3 = _interopRequireDefault(__webpack_require__(395));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isLastDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the last day of a month?
	 *
	 * @description
	 * Is the given date the last day of a month?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 28 February 2014 the last day of a month?
	 * const result = isLastDayOfMonth(new Date(2014, 1, 28))
	 * //=> true
	 */
	function isLastDayOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  return (0, _index2.default)(date).getTime() === (0, _index3.default)(date).getTime();
	}
	module.exports = exports.default;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isLeapYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isLeapYear
	 * @category Year Helpers
	 * @summary Is the given date in the leap year?
	 *
	 * @description
	 * Is the given date in the leap year?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the leap year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2012 in the leap year?
	 * const result = isLeapYear(new Date(2012, 8, 1))
	 * //=> true
	 */
	function isLeapYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	module.exports = exports.default;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameHour;
	var _index = _interopRequireDefault(__webpack_require__(668));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameHour
	 * @category Hour Helpers
	 * @summary Are the given dates in the same hour (and same day)?
	 *
	 * @description
	 * Are the given dates in the same hour (and same day)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same hour (and same day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
	 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
	 * //=> true
	 *
	 * @example
	 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
	 * const result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
	 * //=> false
	 */
	function isSameHour(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfHour = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfHour = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(397));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameISOWeek
	 * @category ISO Week Helpers
	 * @summary Are the given dates in the same ISO week (and year)?
	 *
	 * @description
	 * Are the given dates in the same ISO week (and year)?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
	 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
	 * //=> true
	 *
	 * @example
	 * // Are 1 September 2014 and 1 September 2015 in the same ISO week?
	 * const result = isSameISOWeek(new Date(2014, 8, 1), new Date(2015, 8, 1))
	 * //=> false
	 */
	function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  return (0, _index.default)(dirtyDateLeft, dirtyDateRight, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports.default;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMinute;
	var _index = _interopRequireDefault(__webpack_require__(400));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameMinute
	 * @category Minute Helpers
	 * @summary Are the given dates in the same minute (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same minute (and hour and day)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same minute (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15 in the same minute?
	 * const result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 4, 6, 30, 15)
	 * )
	 * //=> true
	 *
	 * @example
	 * // Are 4 September 2014 06:30:00 and 5 September 2014 06:30:00 in the same minute?
	 * const result = isSameMinute(
	 *   new Date(2014, 8, 4, 6, 30),
	 *   new Date(2014, 8, 5, 6, 30)
	 * )
	 * //=> false
	 */
	function isSameMinute(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfMinute = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfMinute = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameMonth
	 * @category Month Helpers
	 * @summary Are the given dates in the same month (and year)?
	 *
	 * @description
	 * Are the given dates in the same month (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same month (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2015 in the same month?
	 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
	 * //=> false
	 */
	function isSameMonth(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
	}
	module.exports = exports.default;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameQuarter;
	var _index = _interopRequireDefault(__webpack_require__(401));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameQuarter
	 * @category Quarter Helpers
	 * @summary Are the given dates in the same quarter (and year)?
	 *
	 * @description
	 * Are the given dates in the same quarter (and year)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same quarter (and year)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
	 * //=> true
	 *
	 * @example
	 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
	 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
	 * //=> false
	 */
	function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfQuarter = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfQuarter = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameSecond;
	var _index = _interopRequireDefault(__webpack_require__(669));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameSecond
	 * @category Second Helpers
	 * @summary Are the given dates in the same second (and hour and day)?
	 *
	 * @description
	 * Are the given dates in the same second (and hour and day)?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same second (and hour and day)
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500 in the same second?
	 * const result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 30, 15),
	 *   new Date(2014, 8, 4, 6, 30, 15, 500)
	 * )
	 * //=> true
	 *
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 4 September 2014 06:01.15.000 in the same second?
	 * const result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 4, 6, 1, 15)
	 * )
	 * //=> false
	 *
	 * @example
	 * // Are 4 September 2014 06:00:15.000 and 5 September 2014 06:00.15.000 in the same second?
	 * const result = isSameSecond(
	 *   new Date(2014, 8, 4, 6, 0, 15),
	 *   new Date(2014, 8, 5, 6, 0, 15)
	 * )
	 * //=> false
	 */
	function isSameSecond(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfSecond = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfSecond = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameYear
	 * @category Year Helpers
	 * @summary Are the given dates in the same year?
	 *
	 * @description
	 * Are the given dates in the same year?
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 September 2014 and 25 September 2014 in the same year?
	 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
	 * //=> true
	 */
	function isSameYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  return dateLeft.getFullYear() === dateRight.getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSaturday;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSaturday
	 * @category Weekday Helpers
	 * @summary Is the given date Saturday?
	 *
	 * @description
	 * Is the given date Saturday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 27 September 2014 Saturday?
	 * const result = isSaturday(new Date(2014, 8, 27))
	 * //=> true
	 */
	function isSaturday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 6;
	}
	module.exports = exports.default;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name lastDayOfMonth
	 * @category Month Helpers
	 * @summary Return the last day of a month for the given date.
	 *
	 * @description
	 * Return the last day of a month for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a month for 2 September 2014 11:55:00:
	 * const result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  date.setFullYear(date.getFullYear(), month + 1, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfWeek;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(12));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var _index4 = __webpack_require__(51);
	/**
	 * @name lastDayOfWeek
	 * @category Week Helpers
	 * @summary Return the last day of a week for the given date.
	 *
	 * @description
	 * Return the last day of a week for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the last day of a week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // The last day of a week for 2 September 2014 11:55:00:
	 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sat Sep 06 2014 00:00:00
	 *
	 * @example
	 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
	 * const result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index3.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getDay();
	  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
	  date.setHours(0, 0, 0, 0);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = max;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name max
	 * @category Common Helpers
	 * @summary Return the latest of the given dates.
	 *
	 * @description
	 * Return the latest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} the latest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the latest?
	 * const result = max([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Sun Jul 02 1995 00:00:00
	 */
	function max(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = min;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name min
	 * @category Common Helpers
	 * @summary Returns the earliest of the given dates.
	 *
	 * @description
	 * Returns the earliest of the given dates.
	 *
	 * @param {Date[]|Number[]} datesArray - the dates to compare
	 * @returns {Date} - the earliest of the dates
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which of these dates is the earliest?
	 * const result = min([
	 *   new Date(1989, 6, 10),
	 *   new Date(1987, 1, 11),
	 *   new Date(1995, 6, 2),
	 *   new Date(1990, 0, 1)
	 * ])
	 * //=> Wed Feb 11 1987 00:00:00
	 */
	function min(dirtyDatesArray) {
	  (0, _index2.default)(1, arguments);
	  var datesArray;
	  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	    // If `dirtyDatesArray` is Array-like Object, convert to Array.
	  } else if ((0, _typeof2.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  } else {
	    // `dirtyDatesArray` is non-iterable, return Invalid Date
	    return new Date(NaN);
	  }
	  var result;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
	      result = currentDate;
	    }
	  });
	  return result || new Date(NaN);
	}
	module.exports = exports.default;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ValueSetter = exports.Setter = exports.DateToSystemTimezoneSetter = void 0;
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var TIMEZONE_UNIT_PRIORITY = 10;
	var Setter = /*#__PURE__*/function () {
	  function Setter() {
	    (0, _classCallCheck2.default)(this, Setter);
	    (0, _defineProperty2.default)(this, "priority", void 0);
	    (0, _defineProperty2.default)(this, "subPriority", 0);
	  }
	  (0, _createClass2.default)(Setter, [{
	    key: "validate",
	    value: function validate(_utcDate, _options) {
	      return true;
	    }
	  }]);
	  return Setter;
	}();
	exports.Setter = Setter;
	var ValueSetter = /*#__PURE__*/function (_Setter) {
	  (0, _inherits2.default)(ValueSetter, _Setter);
	  var _super = (0, _createSuper2.default)(ValueSetter);
	  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
	    var _this;
	    (0, _classCallCheck2.default)(this, ValueSetter);
	    _this = _super.call(this);
	    _this.value = value;
	    _this.validateValue = validateValue;
	    _this.setValue = setValue;
	    _this.priority = priority;
	    if (subPriority) {
	      _this.subPriority = subPriority;
	    }
	    return _this;
	  }
	  (0, _createClass2.default)(ValueSetter, [{
	    key: "validate",
	    value: function validate(utcDate, options) {
	      return this.validateValue(utcDate, this.value, options);
	    }
	  }, {
	    key: "set",
	    value: function set(utcDate, flags, options) {
	      return this.setValue(utcDate, flags, this.value, options);
	    }
	  }]);
	  return ValueSetter;
	}(Setter);
	exports.ValueSetter = ValueSetter;
	var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
	  (0, _inherits2.default)(DateToSystemTimezoneSetter, _Setter2);
	  var _super2 = (0, _createSuper2.default)(DateToSystemTimezoneSetter);
	  function DateToSystemTimezoneSetter() {
	    var _this2;
	    (0, _classCallCheck2.default)(this, DateToSystemTimezoneSetter);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this2 = _super2.call.apply(_super2, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "subPriority", -1);
	    return _this2;
	  }
	  (0, _createClass2.default)(DateToSystemTimezoneSetter, [{
	    key: "set",
	    value: function set(date, flags) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      var convertedDate = new Date(0);
	      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
	      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
	      return convertedDate;
	    }
	  }]);
	  return DateToSystemTimezoneSetter;
	}(Setter);
	exports.DateToSystemTimezoneSetter = DateToSystemTimezoneSetter;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parse;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _createForOfIteratorHelper2 = _interopRequireDefault(__webpack_require__(775));
	var _index = _interopRequireDefault(__webpack_require__(177));
	var _index2 = _interopRequireDefault(__webpack_require__(224));
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	var _index4 = _interopRequireDefault(__webpack_require__(216));
	var _index5 = _interopRequireDefault(__webpack_require__(624));
	var _index6 = _interopRequireDefault(__webpack_require__(109));
	var _index7 = __webpack_require__(628);
	var _index8 = _interopRequireDefault(__webpack_require__(12));
	var _index9 = _interopRequireDefault(__webpack_require__(5));
	var _Setter = __webpack_require__(665);
	var _index10 = __webpack_require__(1723);
	var _index11 = __webpack_require__(51);
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
	
	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var notWhitespaceRegExp = /\S/;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name parse
	 * @category Common Helpers
	 * @summary Parse the date.
	 *
	 * @description
	 * Return the date parsed from string using the given format string.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * parse('23 AM', 'HH a', new Date())
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `parse` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
	 *
	 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
	 *
	 *    while `uu` will just assign the year as is:
	 *
	 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
	 *
	 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be assigned to the date in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
	 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
	 *
	 * `referenceDate` must be passed for correct work of the function.
	 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
	 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
	 * In this case parsing will be done in the context of the current date.
	 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
	 * then `Invalid Date` will be returned.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 * If parsing failed, `Invalid Date` will be returned.
	 * Invalid Date is a Date, whose time value is NaN.
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {String} dateString - the string to parse
	 * @param {String} formatString - the string of tokens
	 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {Date} the parsed date
	 * @throws {TypeError} 3 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Parse 11 February 2014 from middle-endian format:
	 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
	 * //=> Tue Feb 11 2014 00:00:00
	 *
	 * @example
	 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
	 *   locale: eo
	 * })
	 * //=> Sun Feb 28 2010 00:00:00
	 */
	function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(3, arguments);
	  var dateString = String(dirtyDateString);
	  var formatString = String(dirtyFormatString);
	  var defaultOptions = (0, _index11.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index.default;
	  if (!locale.match) {
	    throw new RangeError('locale must contain match property');
	  }
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
	
	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (formatString === '') {
	    if (dateString === '') {
	      return (0, _index3.default)(dirtyReferenceDate);
	    } else {
	      return new Date(NaN);
	    }
	  }
	  var subFnOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale
	  };
	
	  // If timezone isn't specified, it will be set to the system timezone
	  var setters = [new _Setter.DateToSystemTimezoneSetter()];
	  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter in _index5.default) {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp);
	  var usedTokens = [];
	  var _iterator = (0, _createForOfIteratorHelper2.default)(tokens),
	    _step;
	  try {
	    var _loop = function _loop() {
	      var token = _step.value;
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(token)) {
	        (0, _index7.throwProtectedError)(token, formatString, dirtyDateString);
	      }
	      var firstCharacter = token[0];
	      var parser = _index10.parsers[firstCharacter];
	      if (parser) {
	        var incompatibleTokens = parser.incompatibleTokens;
	        if (Array.isArray(incompatibleTokens)) {
	          var incompatibleToken = usedTokens.find(function (usedToken) {
	            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
	          });
	          if (incompatibleToken) {
	            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
	          }
	        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
	          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
	        }
	        usedTokens.push({
	          token: firstCharacter,
	          fullToken: token
	        });
	        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
	        if (!parseResult) {
	          return {
	            v: new Date(NaN)
	          };
	        }
	        setters.push(parseResult.setter);
	        dateString = parseResult.rest;
	      } else {
	        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	        }
	
	        // Replace two single quote characters with one single quote character
	        if (token === "''") {
	          token = "'";
	        } else if (firstCharacter === "'") {
	          token = cleanEscapedString(token);
	        }
	
	        // Cut token from string, or, if string doesn't match the token, return Invalid Date
	        if (dateString.indexOf(token) === 0) {
	          dateString = dateString.slice(token.length);
	        } else {
	          return {
	            v: new Date(NaN)
	          };
	        }
	      }
	    };
	    for (_iterator.s(); !(_step = _iterator.n()).done;) {
	      var _ret = _loop();
	      if ((0, _typeof2.default)(_ret) === "object") return _ret.v;
	    }
	
	    // Check if the remaining input contains something other than whitespace
	  } catch (err) {
	    _iterator.e(err);
	  } finally {
	    _iterator.f();
	  }
	  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
	    return new Date(NaN);
	  }
	  var uniquePrioritySetters = setters.map(function (setter) {
	    return setter.priority;
	  }).sort(function (a, b) {
	    return b - a;
	  }).filter(function (priority, index, array) {
	    return array.indexOf(priority) === index;
	  }).map(function (priority) {
	    return setters.filter(function (setter) {
	      return setter.priority === priority;
	    }).sort(function (a, b) {
	      return b.subPriority - a.subPriority;
	    });
	  }).map(function (setterArray) {
	    return setterArray[0];
	  });
	  var date = (0, _index3.default)(dirtyReferenceDate);
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  var utcDate = (0, _index2.default)(date, (0, _index6.default)(date));
	  var flags = {};
	  var _iterator2 = (0, _createForOfIteratorHelper2.default)(uniquePrioritySetters),
	    _step2;
	  try {
	    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
	      var setter = _step2.value;
	      if (!setter.validate(utcDate, subFnOptions)) {
	        return new Date(NaN);
	      }
	      var result = setter.set(utcDate, flags, subFnOptions);
	      // Result is tuple (date, flags)
	      if (Array.isArray(result)) {
	        utcDate = result[0];
	        (0, _index4.default)(flags, result[1]);
	        // Result is date
	      } else {
	        utcDate = result;
	      }
	    }
	  } catch (err) {
	    _iterator2.e(err);
	  } finally {
	    _iterator2.f();
	  }
	  return utcDate;
	}
	function cleanEscapedString(input) {
	  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(223));
	var _index4 = _interopRequireDefault(__webpack_require__(127));
	var _index5 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Set the ISO week-numbering year to the given date.
	 *
	 * @description
	 * Set the ISO week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
	 * @returns {Date} the new date with the ISO week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set ISO week-numbering year 2007 to 29 December 2008:
	 * const result = setISOWeekYear(new Date(2008, 11, 29), 2007)
	 * //=> Mon Jan 01 2007 00:00:00
	 */
	function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeekYear = (0, _index.default)(dirtyISOWeekYear);
	  var diff = (0, _index4.default)(date, (0, _index3.default)(date));
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  date = (0, _index3.default)(fourthOfJanuary);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfHour;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfHour
	 * @category Hour Helpers
	 * @summary Return the start of an hour for the given date.
	 *
	 * @description
	 * Return the start of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of an hour for 2 September 2014 11:55:00:
	 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:00:00
	 */
	function startOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfSecond;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfSecond
	 * @category Second Helpers
	 * @summary Return the start of a second for the given date.
	 *
	 * @description
	 * Return the start of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a second for 1 December 2014 22:15:45.400:
	 * const result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.000
	 */
	function startOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subISOWeekYears;
	var _index = _interopRequireDefault(__webpack_require__(631));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name subISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * @description
	 * Subtract the specified number of ISO week-numbering years from the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the ISO week-numbering years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 ISO week-numbering years from 1 September 2014:
	 * const result = subISOWeekYears(new Date(2014, 8, 1), 5)
	 * //=> Mon Aug 31 2009 00:00:00
	 */
	function subISOWeekYears(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMonths;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(220));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name subMonths
	 * @category Month Helpers
	 * @summary Subtract the specified number of months from the given date.
	 *
	 * @description
	 * Subtract the specified number of months from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the months subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 months from 1 February 2015:
	 * const result = subMonths(new Date(2015, 1, 1), 5)
	 * //=> Mon Sep 01 2014 00:00:00
	 */
	function subMonths(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */
	;(function (globalScope) {
	  'use strict';
	
	
	  /*
	   *  decimal.js-light v2.5.1
	   *  An arbitrary-precision Decimal type for JavaScript.
	   *  https://github.com/MikeMcl/decimal.js-light
	   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
	   *  MIT Expat Licence
	   */
	
	
	  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
	
	
	    // The limit on the value of `precision`, and on the value of the first argument to
	    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
	  var MAX_DIGITS = 1e9,                        // 0 to 1e9
	
	
	    // The initial configuration properties of the Decimal constructor.
	    Decimal = {
	
	      // These values must be integers within the stated ranges (inclusive).
	      // Most of these values can be changed during run-time using `Decimal.config`.
	
	      // The maximum number of significant digits of the result of a calculation or base conversion.
	      // E.g. `Decimal.config({ precision: 20 });`
	      precision: 20,                         // 1 to MAX_DIGITS
	
	      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
	      // `toFixed`, `toPrecision` and `toSignificantDigits`.
	      //
	      // ROUND_UP         0 Away from zero.
	      // ROUND_DOWN       1 Towards zero.
	      // ROUND_CEIL       2 Towards +Infinity.
	      // ROUND_FLOOR      3 Towards -Infinity.
	      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
	      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
	      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
	      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
	      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
	      //
	      // E.g.
	      // `Decimal.rounding = 4;`
	      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
	      rounding: 4,                           // 0 to 8
	
	      // The exponent value at and beneath which `toString` returns exponential notation.
	      // JavaScript numbers: -7
	      toExpNeg: -7,                          // 0 to -MAX_E
	
	      // The exponent value at and above which `toString` returns exponential notation.
	      // JavaScript numbers: 21
	      toExpPos:  21,                         // 0 to MAX_E
	
	      // The natural logarithm of 10.
	      // 115 digits
	      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
	    },
	
	
	  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
	
	
	    external = true,
	
	    decimalError = '[DecimalError] ',
	    invalidArgument = decimalError + 'Invalid argument: ',
	    exponentOutOfRange = decimalError + 'Exponent out of range: ',
	
	    mathfloor = Math.floor,
	    mathpow = Math.pow,
	
	    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
	
	    ONE,
	    BASE = 1e7,
	    LOG_BASE = 7,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284
	
	    // Decimal.prototype object
	    P = {};
	
	
	  // Decimal prototype methods
	
	
	  /*
	   *  absoluteValue                       abs
	   *  comparedTo                          cmp
	   *  decimalPlaces                       dp
	   *  dividedBy                           div
	   *  dividedToIntegerBy                  idiv
	   *  equals                              eq
	   *  exponent
	   *  greaterThan                         gt
	   *  greaterThanOrEqualTo                gte
	   *  isInteger                           isint
	   *  isNegative                          isneg
	   *  isPositive                          ispos
	   *  isZero
	   *  lessThan                            lt
	   *  lessThanOrEqualTo                   lte
	   *  logarithm                           log
	   *  minus                               sub
	   *  modulo                              mod
	   *  naturalExponential                  exp
	   *  naturalLogarithm                    ln
	   *  negated                             neg
	   *  plus                                add
	   *  precision                           sd
	   *  squareRoot                          sqrt
	   *  times                               mul
	   *  toDecimalPlaces                     todp
	   *  toExponential
	   *  toFixed
	   *  toInteger                           toint
	   *  toNumber
	   *  toPower                             pow
	   *  toPrecision
	   *  toSignificantDigits                 tosd
	   *  toString
	   *  valueOf                             val
	   */
	
	
	  /*
	   * Return a new Decimal whose value is the absolute value of this Decimal.
	   *
	   */
	  P.absoluteValue = P.abs = function () {
	    var x = new this.constructor(this);
	    if (x.s) x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return
	   *   1    if the value of this Decimal is greater than the value of `y`,
	   *  -1    if the value of this Decimal is less than the value of `y`,
	   *   0    if they have the same value
	   *
	   */
	  P.comparedTo = P.cmp = function (y) {
	    var i, j, xdL, ydL,
	      x = this;
	
	    y = new x.constructor(y);
	
	    // Signs differ?
	    if (x.s !== y.s) return x.s || -y.s;
	
	    // Compare exponents.
	    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
	
	    xdL = x.d.length;
	    ydL = y.d.length;
	
	    // Compare digit by digit.
	    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
	      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
	  };
	
	
	  /*
	   * Return the number of decimal places of the value of this Decimal.
	   *
	   */
	  P.decimalPlaces = P.dp = function () {
	    var x = this,
	      w = x.d.length - 1,
	      dp = (w - x.e) * LOG_BASE;
	
	    // Subtract the number of trailing zeros of the last word.
	    w = x.d[w];
	    if (w) for (; w % 10 == 0; w /= 10) dp--;
	
	    return dp < 0 ? 0 : dp;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.dividedBy = P.div = function (y) {
	    return divide(this, new this.constructor(y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
	   * by the value of `y`, truncated to `precision` significant digits.
	   *
	   */
	  P.dividedToIntegerBy = P.idiv = function (y) {
	    var x = this,
	      Ctor = x.constructor;
	    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
	   *
	   */
	  P.equals = P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
	   *
	   */
	  P.exponent = function () {
	    return getBase10Exponent(this);
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
	   * false.
	   *
	   */
	  P.greaterThan = P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
	   * otherwise return false.
	   *
	   */
	  P.greaterThanOrEqualTo = P.gte = function (y) {
	    return this.cmp(y) >= 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is an integer, otherwise return false.
	   *
	   */
	  P.isInteger = P.isint = function () {
	    return this.e > this.d.length - 2;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is negative, otherwise return false.
	   *
	   */
	  P.isNegative = P.isneg = function () {
	    return this.s < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is positive, otherwise return false.
	   *
	   */
	  P.isPositive = P.ispos = function () {
	    return this.s > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is 0, otherwise return false.
	   *
	   */
	  P.isZero = function () {
	    return this.s === 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than `y`, otherwise return false.
	   *
	   */
	  P.lessThan = P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
	   *
	   */
	  P.lessThanOrEqualTo = P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return the logarithm of the value of this Decimal to the specified base, truncated to
	   * `precision` significant digits.
	   *
	   * If no base is specified, return log[10](x).
	   *
	   * log[base](x) = ln(x) / ln(base)
	   *
	   * The maximum error of the result is 1 ulp (unit in the last place).
	   *
	   * [base] {number|string|Decimal} The base of the logarithm.
	   *
	   */
	  P.logarithm = P.log = function (base) {
	    var r,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision,
	      wpr = pr + 5;
	
	    // Default base is 10.
	    if (base === void 0) {
	      base = new Ctor(10);
	    } else {
	      base = new Ctor(base);
	
	      // log[-b](x) = NaN
	      // log[0](x)  = NaN
	      // log[1](x)  = NaN
	      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
	    }
	
	    // log[b](-x) = NaN
	    // log[b](0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // log[b](1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    external = false;
	    r = divide(ln(x, wpr), ln(base, wpr), wpr);
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.minus = P.sub = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.modulo = P.mod = function (y) {
	    var q,
	      x = this,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    y = new Ctor(y);
	
	    // x % 0 = NaN
	    if (!y.s) throw Error(decimalError + 'NaN');
	
	    // Return x if x is 0.
	    if (!x.s) return round(new Ctor(x), pr);
	
	    // Prevent rounding of intermediate calculations.
	    external = false;
	    q = divide(x, y, 0, 1).times(y);
	    external = true;
	
	    return x.minus(q);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
	   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.naturalExponential = P.exp = function () {
	    return exp(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
	   * truncated to `precision` significant digits.
	   *
	   */
	  P.naturalLogarithm = P.ln = function () {
	    return ln(this);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
	   * -1.
	   *
	   */
	  P.negated = P.neg = function () {
	    var x = new this.constructor(this);
	    x.s = -x.s || 0;
	    return x;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.plus = P.add = function (y) {
	    var x = this;
	    y = new x.constructor(y);
	    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
	  };
	
	
	  /*
	   * Return the number of significant digits of the value of this Decimal.
	   *
	   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
	   *
	   */
	  P.precision = P.sd = function (z) {
	    var e, sd, w,
	      x = this;
	
	    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
	
	    e = getBase10Exponent(x) + 1;
	    w = x.d.length - 1;
	    sd = w * LOG_BASE + 1;
	    w = x.d[w];
	
	    // If non-zero...
	    if (w) {
	
	      // Subtract the number of trailing zeros of the last word.
	      for (; w % 10 == 0; w /= 10) sd--;
	
	      // Add the number of digits of the first word.
	      for (w = x.d[0]; w >= 10; w /= 10) sd++;
	    }
	
	    return z && e > sd ? e : sd;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
	   * significant digits.
	   *
	   */
	  P.squareRoot = P.sqrt = function () {
	    var e, n, pr, r, s, t, wpr,
	      x = this,
	      Ctor = x.constructor;
	
	    // Negative or zero?
	    if (x.s < 1) {
	      if (!x.s) return new Ctor(0);
	
	      // sqrt(-x) = NaN
	      throw Error(decimalError + 'NaN');
	    }
	
	    e = getBase10Exponent(x);
	    external = false;
	
	    // Initial estimate.
	    s = Math.sqrt(+x);
	
	    // Math.sqrt underflow/overflow?
	    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
	    if (s == 0 || s == 1 / 0) {
	      n = digitsToString(x.d);
	      if ((n.length + e) % 2 == 0) n += '0';
	      s = Math.sqrt(n);
	      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
	
	      if (s == 1 / 0) {
	        n = '5e' + e;
	      } else {
	        n = s.toExponential();
	        n = n.slice(0, n.indexOf('e') + 1) + e;
	      }
	
	      r = new Ctor(n);
	    } else {
	      r = new Ctor(s.toString());
	    }
	
	    pr = Ctor.precision;
	    s = wpr = pr + 3;
	
	    // Newton-Raphson iteration.
	    for (;;) {
	      t = r;
	      r = t.plus(divide(x, t, wpr + 2)).times(0.5);
	
	      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
	        n = n.slice(wpr - 3, wpr + 1);
	
	        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
	        // 4999, i.e. approaching a rounding boundary, continue the iteration.
	        if (s == wpr && n == '4999') {
	
	          // On the first iteration only, check to see if rounding up gives the exact result as the
	          // nines may infinitely repeat.
	          round(t, pr + 1, 0);
	
	          if (t.times(t).eq(x)) {
	            r = t;
	            break;
	          }
	        } else if (n != '9999') {
	          break;
	        }
	
	        wpr += 4;
	      }
	    }
	
	    external = true;
	
	    return round(r, pr);
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
	   * `precision` significant digits.
	   *
	   */
	  P.times = P.mul = function (y) {
	    var carry, e, i, k, r, rL, t, xdL, ydL,
	      x = this,
	      Ctor = x.constructor,
	      xd = x.d,
	      yd = (y = new Ctor(y)).d;
	
	    // Return 0 if either is 0.
	    if (!x.s || !y.s) return new Ctor(0);
	
	    y.s *= x.s;
	    e = x.e + y.e;
	    xdL = xd.length;
	    ydL = yd.length;
	
	    // Ensure xd points to the longer array.
	    if (xdL < ydL) {
	      r = xd;
	      xd = yd;
	      yd = r;
	      rL = xdL;
	      xdL = ydL;
	      ydL = rL;
	    }
	
	    // Initialise the result array with zeros.
	    r = [];
	    rL = xdL + ydL;
	    for (i = rL; i--;) r.push(0);
	
	    // Multiply!
	    for (i = ydL; --i >= 0;) {
	      carry = 0;
	      for (k = xdL + i; k > i;) {
	        t = r[k] + yd[i] * xd[k - i - 1] + carry;
	        r[k--] = t % BASE | 0;
	        carry = t / BASE | 0;
	      }
	
	      r[k] = (r[k] + carry) % BASE | 0;
	    }
	
	    // Remove trailing zeros.
	    for (; !r[--rL];) r.pop();
	
	    if (carry) ++e;
	    else r.shift();
	
	    y.d = r;
	    y.e = e;
	
	    return external ? round(y, Ctor.precision) : y;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
	   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
	   *
	   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toDecimalPlaces = P.todp = function (dp, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    x = new Ctor(x);
	    if (dp === void 0) return x;
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    return round(x, dp + getBase10Exponent(x) + 1, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in exponential notation rounded to
	   * `dp` fixed decimal places using rounding mode `rounding`.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toExponential = function (dp, rm) {
	    var str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) {
	      str = toString(x, true);
	    } else {
	      checkInt32(dp, 0, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), dp + 1, rm);
	      str = toString(x, true, dp + 1);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
	   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
	   * omitted.
	   *
	   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
	   *
	   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   * (-0).toFixed(3) is '0.000'.
	   * (-0.5).toFixed(0) is '-0'.
	   *
	   */
	  P.toFixed = function (dp, rm) {
	    var str, y,
	      x = this,
	      Ctor = x.constructor;
	
	    if (dp === void 0) return toString(x);
	
	    checkInt32(dp, 0, MAX_DIGITS);
	
	    if (rm === void 0) rm = Ctor.rounding;
	    else checkInt32(rm, 0, 8);
	
	    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
	    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
	
	    // To determine whether to add the minus sign look at the value before it was rounded,
	    // i.e. look at `x` rather than `y`.
	    return x.isneg() && !x.isZero() ? '-' + str : str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
	   * rounding mode `rounding`.
	   *
	   */
	  P.toInteger = P.toint = function () {
	    var x = this,
	      Ctor = x.constructor;
	    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
	  };
	
	
	  /*
	   * Return the value of this Decimal converted to a number primitive.
	   *
	   */
	  P.toNumber = function () {
	    return +this;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
	   * truncated to `precision` significant digits.
	   *
	   * For non-integer or very large exponents pow(x, y) is calculated using
	   *
	   *   x^y = exp(y*ln(x))
	   *
	   * The maximum error is 1 ulp (unit in last place).
	   *
	   * y {number|string|Decimal} The power to which to raise this Decimal.
	   *
	   */
	  P.toPower = P.pow = function (y) {
	    var e, k, pr, r, sign, yIsInt,
	      x = this,
	      Ctor = x.constructor,
	      guard = 12,
	      yn = +(y = new Ctor(y));
	
	    // pow(x, 0) = 1
	    if (!y.s) return new Ctor(ONE);
	
	    x = new Ctor(x);
	
	    // pow(0, y > 0) = 0
	    // pow(0, y < 0) = Infinity
	    if (!x.s) {
	      if (y.s < 1) throw Error(decimalError + 'Infinity');
	      return x;
	    }
	
	    // pow(1, y) = 1
	    if (x.eq(ONE)) return x;
	
	    pr = Ctor.precision;
	
	    // pow(x, 1) = x
	    if (y.eq(ONE)) return round(x, pr);
	
	    e = y.e;
	    k = y.d.length - 1;
	    yIsInt = e >= k;
	    sign = x.s;
	
	    if (!yIsInt) {
	
	      // pow(x < 0, y non-integer) = NaN
	      if (sign < 0) throw Error(decimalError + 'NaN');
	
	    // If y is a small integer use the 'exponentiation by squaring' algorithm.
	    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
	      r = new Ctor(ONE);
	
	      // Max k of 9007199254740991 takes 53 loop iterations.
	      // Maximum digits array length; leaves [28, 34] guard digits.
	      e = Math.ceil(pr / LOG_BASE + 4);
	
	      external = false;
	
	      for (;;) {
	        if (k % 2) {
	          r = r.times(x);
	          truncate(r.d, e);
	        }
	
	        k = mathfloor(k / 2);
	        if (k === 0) break;
	
	        x = x.times(x);
	        truncate(x.d, e);
	      }
	
	      external = true;
	
	      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
	    }
	
	    // Result is negative if x is negative and the last digit of integer y is odd.
	    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
	
	    x.s = 1;
	    external = false;
	    r = y.times(ln(x, pr + guard));
	    external = true;
	    r = exp(r);
	    r.s = sign;
	
	    return r;
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal rounded to `sd` significant digits
	   * using rounding mode `rounding`.
	   *
	   * Return exponential notation if `sd` is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toPrecision = function (sd, rm) {
	    var e, str,
	      x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      e = getBase10Exponent(x);
	      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	
	      x = round(new Ctor(x), sd, rm);
	      e = getBase10Exponent(x);
	      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
	    }
	
	    return str;
	  };
	
	
	  /*
	   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
	   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
	   * omitted.
	   *
	   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
	   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
	   *
	   */
	  P.toSignificantDigits = P.tosd = function (sd, rm) {
	    var x = this,
	      Ctor = x.constructor;
	
	    if (sd === void 0) {
	      sd = Ctor.precision;
	      rm = Ctor.rounding;
	    } else {
	      checkInt32(sd, 1, MAX_DIGITS);
	
	      if (rm === void 0) rm = Ctor.rounding;
	      else checkInt32(rm, 0, 8);
	    }
	
	    return round(new Ctor(x), sd, rm);
	  };
	
	
	  /*
	   * Return a string representing the value of this Decimal.
	   *
	   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
	   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
	   *
	   */
	  P.toString = P.valueOf = P.val = P.toJSON = function () {
	    var x = this,
	      e = getBase10Exponent(x),
	      Ctor = x.constructor;
	
	    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
	  };
	
	
	  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
	
	
	  /*
	   *  add                 P.minus, P.plus
	   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
	   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
	   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
	   *  exp                 P.exp, P.pow
	   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
	   *                      P.toString, divide, round, toString, exp, ln
	   *  getLn10             P.log, ln
	   *  getZeroString       digitsToString, toString
	   *  ln                  P.log, P.ln, P.pow, exp
	   *  parseDecimal        Decimal
	   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
	   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
	   *                      divide, getLn10, exp, ln
	   *  subtract            P.minus, P.plus
	   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
	   *  truncate            P.pow
	   *
	   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
	   *                      getLn10, exp, ln, parseDecimal, Decimal, config
	   */
	
	
	  function add(x, y) {
	    var carry, d, e, i, k, len, xd, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // If either is zero...
	    if (!x.s || !y.s) {
	
	      // Return x if y is zero.
	      // Return y if y is non-zero.
	      if (!y.s) y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are finite, non-zero numbers with the same sign.
	
	    k = x.e;
	    e = y.e;
	    xd = xd.slice();
	    i = k - e;
	
	    // If base 1e7 exponents differ...
	    if (i) {
	      if (i < 0) {
	        d = xd;
	        i = -i;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = k;
	        len = xd.length;
	      }
	
	      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
	      k = Math.ceil(pr / LOG_BASE);
	      len = k > len ? k + 1 : len + 1;
	
	      if (i > len) {
	        i = len;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
	      d.reverse();
	      for (; i--;) d.push(0);
	      d.reverse();
	    }
	
	    len = xd.length;
	    i = yd.length;
	
	    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
	    if (len - i < 0) {
	      i = len;
	      d = yd;
	      yd = xd;
	      xd = d;
	    }
	
	    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
	    for (carry = 0; i;) {
	      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
	      xd[i] %= BASE;
	    }
	
	    if (carry) {
	      xd.unshift(carry);
	      ++e;
	    }
	
	    // Remove trailing zeros.
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	    for (len = xd.length; xd[--len] == 0;) xd.pop();
	
	    y.d = xd;
	    y.e = e;
	
	    return external ? round(y, pr) : y;
	  }
	
	
	  function checkInt32(i, min, max) {
	    if (i !== ~~i || i < min || i > max) {
	      throw Error(invalidArgument + i);
	    }
	  }
	
	
	  function digitsToString(d) {
	    var i, k, ws,
	      indexOfLastWord = d.length - 1,
	      str = '',
	      w = d[0];
	
	    if (indexOfLastWord > 0) {
	      str += w;
	      for (i = 1; i < indexOfLastWord; i++) {
	        ws = d[i] + '';
	        k = LOG_BASE - ws.length;
	        if (k) str += getZeroString(k);
	        str += ws;
	      }
	
	      w = d[i];
	      ws = w + '';
	      k = LOG_BASE - ws.length;
	      if (k) str += getZeroString(k);
	    } else if (w === 0) {
	      return '0';
	    }
	
	    // Remove trailing zeros of last w.
	    for (; w % 10 === 0;) w /= 10;
	
	    return str + w;
	  }
	
	
	  var divide = (function () {
	
	    // Assumes non-zero x and k, and hence non-zero result.
	    function multiplyInteger(x, k) {
	      var temp,
	        carry = 0,
	        i = x.length;
	
	      for (x = x.slice(); i--;) {
	        temp = x[i] * k + carry;
	        x[i] = temp % BASE | 0;
	        carry = temp / BASE | 0;
	      }
	
	      if (carry) x.unshift(carry);
	
	      return x;
	    }
	
	    function compare(a, b, aL, bL) {
	      var i, r;
	
	      if (aL != bL) {
	        r = aL > bL ? 1 : -1;
	      } else {
	        for (i = r = 0; i < aL; i++) {
	          if (a[i] != b[i]) {
	            r = a[i] > b[i] ? 1 : -1;
	            break;
	          }
	        }
	      }
	
	      return r;
	    }
	
	    function subtract(a, b, aL) {
	      var i = 0;
	
	      // Subtract b from a.
	      for (; aL--;) {
	        a[aL] -= i;
	        i = a[aL] < b[aL] ? 1 : 0;
	        a[aL] = i * BASE + a[aL] - b[aL];
	      }
	
	      // Remove leading zeros.
	      for (; !a[0] && a.length > 1;) a.shift();
	    }
	
	    return function (x, y, pr, dp) {
	      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
	        Ctor = x.constructor,
	        sign = x.s == y.s ? 1 : -1,
	        xd = x.d,
	        yd = y.d;
	
	      // Either 0?
	      if (!x.s) return new Ctor(x);
	      if (!y.s) throw Error(decimalError + 'Division by zero');
	
	      e = x.e - y.e;
	      yL = yd.length;
	      xL = xd.length;
	      q = new Ctor(sign);
	      qd = q.d = [];
	
	      // Result exponent may be one less than e.
	      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
	      if (yd[i] > (xd[i] || 0)) --e;
	
	      if (pr == null) {
	        sd = pr = Ctor.precision;
	      } else if (dp) {
	        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
	      } else {
	        sd = pr;
	      }
	
	      if (sd < 0) return new Ctor(0);
	
	      // Convert precision in number of base 10 digits to base 1e7 digits.
	      sd = sd / LOG_BASE + 2 | 0;
	      i = 0;
	
	      // divisor < 1e7
	      if (yL == 1) {
	        k = 0;
	        yd = yd[0];
	        sd++;
	
	        // k is the carry.
	        for (; (i < xL || k) && sd--; i++) {
	          t = k * BASE + (xd[i] || 0);
	          qd[i] = t / yd | 0;
	          k = t % yd | 0;
	        }
	
	      // divisor >= 1e7
	      } else {
	
	        // Normalise xd and yd so highest order digit of yd is >= BASE/2
	        k = BASE / (yd[0] + 1) | 0;
	
	        if (k > 1) {
	          yd = multiplyInteger(yd, k);
	          xd = multiplyInteger(xd, k);
	          yL = yd.length;
	          xL = xd.length;
	        }
	
	        xi = yL;
	        rem = xd.slice(0, yL);
	        remL = rem.length;
	
	        // Add zeros to make remainder as long as divisor.
	        for (; remL < yL;) rem[remL++] = 0;
	
	        yz = yd.slice();
	        yz.unshift(0);
	        yd0 = yd[0];
	
	        if (yd[1] >= BASE / 2) ++yd0;
	
	        do {
	          k = 0;
	
	          // Compare divisor and remainder.
	          cmp = compare(yd, rem, yL, remL);
	
	          // If divisor < remainder.
	          if (cmp < 0) {
	
	            // Calculate trial digit, k.
	            rem0 = rem[0];
	            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
	
	            // k will be how many times the divisor goes into the current remainder.
	            k = rem0 / yd0 | 0;
	
	            //  Algorithm:
	            //  1. product = divisor * trial digit (k)
	            //  2. if product > remainder: product -= divisor, k--
	            //  3. remainder -= product
	            //  4. if product was < remainder at 2:
	            //    5. compare new remainder and divisor
	            //    6. If remainder > divisor: remainder -= divisor, k++
	
	            if (k > 1) {
	              if (k >= BASE) k = BASE - 1;
	
	              // product = divisor * trial digit.
	              prod = multiplyInteger(yd, k);
	              prodL = prod.length;
	              remL = rem.length;
	
	              // Compare product and remainder.
	              cmp = compare(prod, rem, prodL, remL);
	
	              // product > remainder.
	              if (cmp == 1) {
	                k--;
	
	                // Subtract divisor from product.
	                subtract(prod, yL < prodL ? yz : yd, prodL);
	              }
	            } else {
	
	              // cmp is -1.
	              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
	              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
	              if (k == 0) cmp = k = 1;
	              prod = yd.slice();
	            }
	
	            prodL = prod.length;
	            if (prodL < remL) prod.unshift(0);
	
	            // Subtract product from remainder.
	            subtract(rem, prod, remL);
	
	            // If product was < previous remainder.
	            if (cmp == -1) {
	              remL = rem.length;
	
	              // Compare divisor and new remainder.
	              cmp = compare(yd, rem, yL, remL);
	
	              // If divisor < new remainder, subtract divisor from remainder.
	              if (cmp < 1) {
	                k++;
	
	                // Subtract divisor from remainder.
	                subtract(rem, yL < remL ? yz : yd, remL);
	              }
	            }
	
	            remL = rem.length;
	          } else if (cmp === 0) {
	            k++;
	            rem = [0];
	          }    // if cmp === 1, k will be 0
	
	          // Add the next digit, k, to the result array.
	          qd[i++] = k;
	
	          // Update the remainder.
	          if (cmp && rem[0]) {
	            rem[remL++] = xd[xi] || 0;
	          } else {
	            rem = [xd[xi]];
	            remL = 1;
	          }
	
	        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
	      }
	
	      // Leading zero?
	      if (!qd[0]) qd.shift();
	
	      q.e = e;
	
	      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
	    };
	  })();
	
	
	  /*
	   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
	   * significant digits.
	   *
	   * Taylor/Maclaurin series.
	   *
	   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
	   *
	   * Argument reduction:
	   *   Repeat x = x / 32, k += 5, until |x| < 0.1
	   *   exp(x) = exp(x / 2^k)^(2^k)
	   *
	   * Previously, the argument was initially reduced by
	   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
	   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
	   * found to be slower than just dividing repeatedly by 32 as above.
	   *
	   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
	   *
	   *  exp(x) is non-terminating for any finite, non-zero x.
	   *
	   */
	  function exp(x, sd) {
	    var denominator, guard, pow, sum, t, wpr,
	      i = 0,
	      k = 0,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
	
	    // exp(0) = 1
	    if (!x.s) return new Ctor(ONE);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    t = new Ctor(0.03125);
	
	    while (x.abs().gte(0.1)) {
	      x = x.times(t);    // x = x / 2^5
	      k += 5;
	    }
	
	    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
	    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
	    wpr += guard;
	    denominator = pow = sum = new Ctor(ONE);
	    Ctor.precision = wpr;
	
	    for (;;) {
	      pow = round(pow.times(x), wpr);
	      denominator = denominator.times(++i);
	      t = sum.plus(divide(pow, denominator, wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        while (k--) sum = round(sum.times(sum), wpr);
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	    }
	  }
	
	
	  // Calculate the base 10 exponent from the base 1e7 exponent.
	  function getBase10Exponent(x) {
	    var e = x.e * LOG_BASE,
	      w = x.d[0];
	
	    // Add the number of digits of the first word of the digits array.
	    for (; w >= 10; w /= 10) e++;
	    return e;
	  }
	
	
	  function getLn10(Ctor, sd, pr) {
	
	    if (sd > Ctor.LN10.sd()) {
	
	
	      // Reset global state in case the exception is caught.
	      external = true;
	      if (pr) Ctor.precision = pr;
	      throw Error(decimalError + 'LN10 precision limit exceeded');
	    }
	
	    return round(new Ctor(Ctor.LN10), sd);
	  }
	
	
	  function getZeroString(k) {
	    var zs = '';
	    for (; k--;) zs += '0';
	    return zs;
	  }
	
	
	  /*
	   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
	   * digits.
	   *
	   *  ln(n) is non-terminating (n != 1)
	   *
	   */
	  function ln(y, sd) {
	    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
	      n = 1,
	      guard = 10,
	      x = y,
	      xd = x.d,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // ln(-x) = NaN
	    // ln(0) = -Infinity
	    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
	
	    // ln(1) = 0
	    if (x.eq(ONE)) return new Ctor(0);
	
	    if (sd == null) {
	      external = false;
	      wpr = pr;
	    } else {
	      wpr = sd;
	    }
	
	    if (x.eq(10)) {
	      if (sd == null) external = true;
	      return getLn10(Ctor, wpr);
	    }
	
	    wpr += guard;
	    Ctor.precision = wpr;
	    c = digitsToString(xd);
	    c0 = c.charAt(0);
	    e = getBase10Exponent(x);
	
	    if (Math.abs(e) < 1.5e15) {
	
	      // Argument reduction.
	      // The series converges faster the closer the argument is to 1, so using
	      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
	      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
	      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
	      // later be divided by this number, then separate out the power of 10 using
	      // ln(a*10^b) = ln(a) + b*ln(10).
	
	      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
	      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
	      // max n is 6 (gives 0.7 - 1.3)
	      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
	        x = x.times(y);
	        c = digitsToString(x.d);
	        c0 = c.charAt(0);
	        n++;
	      }
	
	      e = getBase10Exponent(x);
	
	      if (c0 > 1) {
	        x = new Ctor('0.' + c);
	        e++;
	      } else {
	        x = new Ctor(c0 + '.' + c.slice(1));
	      }
	    } else {
	
	      // The argument reduction method above may result in overflow if the argument y is a massive
	      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
	      // function using ln(x*10^e) = ln(x) + e*ln(10).
	      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
	      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
	
	      Ctor.precision = pr;
	      return sd == null ? (external = true, round(x, pr)) : x;
	    }
	
	    // x is reduced to a value near 1.
	
	    // Taylor series.
	    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
	    // where x = (y - 1)/(y + 1)    (|x| < 1)
	    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
	    x2 = round(x.times(x), wpr);
	    denominator = 3;
	
	    for (;;) {
	      numerator = round(numerator.times(x2), wpr);
	      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
	
	      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
	        sum = sum.times(2);
	
	        // Reverse the argument reduction.
	        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
	        sum = divide(sum, new Ctor(n), wpr);
	
	        Ctor.precision = pr;
	        return sd == null ? (external = true, round(sum, pr)) : sum;
	      }
	
	      sum = t;
	      denominator += 2;
	    }
	  }
	
	
	  /*
	   * Parse the value of a new Decimal `x` from string `str`.
	   */
	  function parseDecimal(x, str) {
	    var e, i, len;
	
	    // Decimal point?
	    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
	
	    // Exponential form?
	    if ((i = str.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +str.slice(i + 1);
	      str = str.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = str.length;
	    }
	
	    // Determine leading zeros.
	    for (i = 0; str.charCodeAt(i) === 48;) ++i;
	
	    // Determine trailing zeros.
	    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
	    str = str.slice(i, len);
	
	    if (str) {
	      len -= i;
	      e = e - i - 1;
	      x.e = mathfloor(e / LOG_BASE);
	      x.d = [];
	
	      // Transform base
	
	      // e is the base 10 exponent.
	      // i is where to slice str to get the first word of the digits array.
	      i = (e + 1) % LOG_BASE;
	      if (e < 0) i += LOG_BASE;
	
	      if (i < len) {
	        if (i) x.d.push(+str.slice(0, i));
	        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
	        str = str.slice(i);
	        i = LOG_BASE - str.length;
	      } else {
	        i -= len;
	      }
	
	      for (; i--;) str += '0';
	      x.d.push(+str);
	
	      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
	    } else {
	
	      // Zero.
	      x.s = 0;
	      x.e = 0;
	      x.d = [0];
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
	   */
	   function round(x, sd, rm) {
	    var i, j, k, n, rd, doRound, w, xdi,
	      xd = x.d;
	
	    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
	    // w: the word of xd which contains the rounding digit, a base 1e7 number.
	    // xdi: the index of w within xd.
	    // n: the number of digits of w.
	    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
	    // they had leading zeros)
	    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
	
	    // Get the length of the first word of the digits array xd.
	    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
	    i = sd - n;
	
	    // Is the rounding digit in the first word of xd?
	    if (i < 0) {
	      i += LOG_BASE;
	      j = sd;
	      w = xd[xdi = 0];
	    } else {
	      xdi = Math.ceil((i + 1) / LOG_BASE);
	      k = xd.length;
	      if (xdi >= k) return x;
	      w = k = xd[xdi];
	
	      // Get the number of digits of w.
	      for (n = 1; k >= 10; k /= 10) n++;
	
	      // Get the index of rd within w.
	      i %= LOG_BASE;
	
	      // Get the index of rd within w, adjusted for leading zeros.
	      // The number of leading zeros of w is given by LOG_BASE - n.
	      j = i - LOG_BASE + n;
	    }
	
	    if (rm !== void 0) {
	      k = mathpow(10, n - j - 1);
	
	      // Get the rounding digit at index j of w.
	      rd = w / k % 10 | 0;
	
	      // Are there any non-zero digits after the rounding digit?
	      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
	
	      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
	      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
	      // 714.
	
	      doRound = rm < 4
	        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
	        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&
	
	          // Check whether the digit to the left of the rounding digit is odd.
	          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
	            rm == (x.s < 0 ? 8 : 7));
	    }
	
	    if (sd < 1 || !xd[0]) {
	      if (doRound) {
	        k = getBase10Exponent(x);
	        xd.length = 1;
	
	        // Convert sd to decimal places.
	        sd = sd - k - 1;
	
	        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
	        x.e = mathfloor(-sd / LOG_BASE) || 0;
	      } else {
	        xd.length = 1;
	
	        // Zero.
	        xd[0] = x.e = x.s = 0;
	      }
	
	      return x;
	    }
	
	    // Remove excess digits.
	    if (i == 0) {
	      xd.length = xdi;
	      k = 1;
	      xdi--;
	    } else {
	      xd.length = xdi + 1;
	      k = mathpow(10, LOG_BASE - i);
	
	      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
	      // j > 0 means i > number of leading zeros of w.
	      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
	    }
	
	    if (doRound) {
	      for (;;) {
	
	        // Is the digit to be rounded up in the first word of xd?
	        if (xdi == 0) {
	          if ((xd[0] += k) == BASE) {
	            xd[0] = 1;
	            ++x.e;
	          }
	
	          break;
	        } else {
	          xd[xdi] += k;
	          if (xd[xdi] != BASE) break;
	          xd[xdi--] = 0;
	          k = 1;
	        }
	      }
	    }
	
	    // Remove trailing zeros.
	    for (i = xd.length; xd[--i] === 0;) xd.pop();
	
	    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
	      throw Error(exponentOutOfRange + getBase10Exponent(x));
	    }
	
	    return x;
	  }
	
	
	  function subtract(x, y) {
	    var d, e, i, j, k, len, xd, xe, xLTy, yd,
	      Ctor = x.constructor,
	      pr = Ctor.precision;
	
	    // Return y negated if x is zero.
	    // Return x if y is zero and x is non-zero.
	    if (!x.s || !y.s) {
	      if (y.s) y.s = -y.s;
	      else y = new Ctor(x);
	      return external ? round(y, pr) : y;
	    }
	
	    xd = x.d;
	    yd = y.d;
	
	    // x and y are non-zero numbers with the same sign.
	
	    e = y.e;
	    xe = x.e;
	    xd = xd.slice();
	    k = xe - e;
	
	    // If exponents differ...
	    if (k) {
	      xLTy = k < 0;
	
	      if (xLTy) {
	        d = xd;
	        k = -k;
	        len = yd.length;
	      } else {
	        d = yd;
	        e = xe;
	        len = xd.length;
	      }
	
	      // Numbers with massively different exponents would result in a very high number of zeros
	      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
	      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
	      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
	
	      if (k > i) {
	        k = i;
	        d.length = 1;
	      }
	
	      // Prepend zeros to equalise exponents.
	      d.reverse();
	      for (i = k; i--;) d.push(0);
	      d.reverse();
	
	    // Base 1e7 exponents equal.
	    } else {
	
	      // Check digits to determine which is the bigger number.
	
	      i = xd.length;
	      len = yd.length;
	      xLTy = i < len;
	      if (xLTy) len = i;
	
	      for (i = 0; i < len; i++) {
	        if (xd[i] != yd[i]) {
	          xLTy = xd[i] < yd[i];
	          break;
	        }
	      }
	
	      k = 0;
	    }
	
	    if (xLTy) {
	      d = xd;
	      xd = yd;
	      yd = d;
	      y.s = -y.s;
	    }
	
	    len = xd.length;
	
	    // Append zeros to xd if shorter.
	    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
	    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;
	
	    // Subtract yd from xd.
	    for (i = yd.length; i > k;) {
	      if (xd[--i] < yd[i]) {
	        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
	        --xd[j];
	        xd[i] += BASE;
	      }
	
	      xd[i] -= yd[i];
	    }
	
	    // Remove trailing zeros.
	    for (; xd[--len] === 0;) xd.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xd[0] === 0; xd.shift()) --e;
	
	    // Zero?
	    if (!xd[0]) return new Ctor(0);
	
	    y.d = xd;
	    y.e = e;
	
	    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
	    return external ? round(y, pr) : y;
	  }
	
	
	  function toString(x, isExp, sd) {
	    var k,
	      e = getBase10Exponent(x),
	      str = digitsToString(x.d),
	      len = str.length;
	
	    if (isExp) {
	      if (sd && (k = sd - len) > 0) {
	        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
	      } else if (len > 1) {
	        str = str.charAt(0) + '.' + str.slice(1);
	      }
	
	      str = str + (e < 0 ? 'e' : 'e+') + e;
	    } else if (e < 0) {
	      str = '0.' + getZeroString(-e - 1) + str;
	      if (sd && (k = sd - len) > 0) str += getZeroString(k);
	    } else if (e >= len) {
	      str += getZeroString(e + 1 - len);
	      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
	    } else {
	      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
	      if (sd && (k = sd - len) > 0) {
	        if (e + 1 === len) str += '.';
	        str += getZeroString(k);
	      }
	    }
	
	    return x.s < 0 ? '-' + str : str;
	  }
	
	
	  // Does not strip trailing zeros.
	  function truncate(arr, len) {
	    if (arr.length > len) {
	      arr.length = len;
	      return true;
	    }
	  }
	
	
	  // Decimal methods
	
	
	  /*
	   *  clone
	   *  config/set
	   */
	
	
	  /*
	   * Create and return a Decimal constructor with the same configuration properties as this Decimal
	   * constructor.
	   *
	   */
	  function clone(obj) {
	    var i, p, ps;
	
	    /*
	     * The Decimal constructor and exported function.
	     * Return a new Decimal instance.
	     *
	     * value {number|string|Decimal} A numeric value.
	     *
	     */
	    function Decimal(value) {
	      var x = this;
	
	      // Decimal called without new.
	      if (!(x instanceof Decimal)) return new Decimal(value);
	
	      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
	      // which points to Object.
	      x.constructor = Decimal;
	
	      // Duplicate.
	      if (value instanceof Decimal) {
	        x.s = value.s;
	        x.e = value.e;
	        x.d = (value = value.d) ? value.slice() : value;
	        return;
	      }
	
	      if (typeof value === 'number') {
	
	        // Reject Infinity/NaN.
	        if (value * 0 !== 0) {
	          throw Error(invalidArgument + value);
	        }
	
	        if (value > 0) {
	          x.s = 1;
	        } else if (value < 0) {
	          value = -value;
	          x.s = -1;
	        } else {
	          x.s = 0;
	          x.e = 0;
	          x.d = [0];
	          return;
	        }
	
	        // Fast path for small integers.
	        if (value === ~~value && value < 1e7) {
	          x.e = 0;
	          x.d = [value];
	          return;
	        }
	
	        return parseDecimal(x, value.toString());
	      } else if (typeof value !== 'string') {
	        throw Error(invalidArgument + value);
	      }
	
	      // Minus sign?
	      if (value.charCodeAt(0) === 45) {
	        value = value.slice(1);
	        x.s = -1;
	      } else {
	        x.s = 1;
	      }
	
	      if (isDecimal.test(value)) parseDecimal(x, value);
	      else throw Error(invalidArgument + value);
	    }
	
	    Decimal.prototype = P;
	
	    Decimal.ROUND_UP = 0;
	    Decimal.ROUND_DOWN = 1;
	    Decimal.ROUND_CEIL = 2;
	    Decimal.ROUND_FLOOR = 3;
	    Decimal.ROUND_HALF_UP = 4;
	    Decimal.ROUND_HALF_DOWN = 5;
	    Decimal.ROUND_HALF_EVEN = 6;
	    Decimal.ROUND_HALF_CEIL = 7;
	    Decimal.ROUND_HALF_FLOOR = 8;
	
	    Decimal.clone = clone;
	    Decimal.config = Decimal.set = config;
	
	    if (obj === void 0) obj = {};
	    if (obj) {
	      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
	      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
	    }
	
	    Decimal.config(obj);
	
	    return Decimal;
	  }
	
	
	  /*
	   * Configure global settings for a Decimal constructor.
	   *
	   * `obj` is an object with one or more of the following properties,
	   *
	   *   precision  {number}
	   *   rounding   {number}
	   *   toExpNeg   {number}
	   *   toExpPos   {number}
	   *
	   * E.g. Decimal.config({ precision: 20, rounding: 4 })
	   *
	   */
	  function config(obj) {
	    if (!obj || typeof obj !== 'object') {
	      throw Error(decimalError + 'Object expected');
	    }
	    var i, p, v,
	      ps = [
	        'precision', 1, MAX_DIGITS,
	        'rounding', 0, 8,
	        'toExpNeg', -1 / 0, 0,
	        'toExpPos', 0, 1 / 0
	      ];
	
	    for (i = 0; i < ps.length; i += 3) {
	      if ((v = obj[p = ps[i]]) !== void 0) {
	        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
	        else throw Error(invalidArgument + p + ': ' + v);
	      }
	    }
	
	    if ((v = obj[p = 'LN10']) !== void 0) {
	        if (v == Math.LN10) this[p] = new this(v);
	        else throw Error(invalidArgument + p + ': ' + v);
	    }
	
	    return this;
	  }
	
	
	  // Create and configure initial Decimal constructor.
	  Decimal = clone(Decimal);
	
	  Decimal['default'] = Decimal.Decimal = Decimal;
	
	  // Internal constant.
	  ONE = new Decimal(1);
	
	
	  // Export.
	
	
	  // AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return Decimal;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other environments that support module.exports.
	  } else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Decimal;
	
	    // Browser.
	  } else {
	    if (!globalScope) {
	      globalScope = typeof self != 'undefined' && self && self.self == self
	        ? self : Function('return this')();
	    }
	
	    globalScope.Decimal = Decimal;
	  }
	})(this);


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return { guid: Date.now() };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /\?/ );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(153),
		__webpack_require__(404),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, support ) {
	
	"use strict";
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// Use proper attribute retrieval (trac-12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(63)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document ) {
		"use strict";
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
		return DOMEval;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(680),
		__webpack_require__(691),
	
		// This is the only module that needs core/support
		__webpack_require__(1802)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, rsingleTag, buildFragment, support ) {
	
	"use strict";
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	return jQuery.parseHTML;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml, parserErrorElem;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {}
	
		parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
		if ( !xml || parserErrorElem ) {
			jQuery.error( "Invalid XML: " + (
				parserErrorElem ?
					jQuery.map( parserErrorElem.childNodes, function( el ) {
						return el.textContent;
					} ).join( "\n" ) :
					data
			) );
		}
		return xml;
	};
	
	return jQuery.parseXML;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(1801),
		__webpack_require__(181)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {
	
	"use strict";
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See trac-6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// rsingleTag matches a string consisting of a single HTML element with no attributes
		// and captures the element's name
		return ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	return addGetHookIf;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(414)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, rcssNum ) {
	
	"use strict";
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	return adjustCSS;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(281),
		__webpack_require__(1805),
		__webpack_require__(409),
		__webpack_require__(685),
		__webpack_require__(687),
		__webpack_require__(706),
		__webpack_require__(407)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isAttached, rboxStyle, rnumnonpx, getStyles,
		rcustomProp, rtrimCSS, support ) {
	
	"use strict";
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			isCustomProp = rcustomProp.test( name ),
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, trac-12537)
		//   .css('--customProperty) (gh-3144)
		if ( computed ) {
	
			// Support: IE <=9 - 11+
			// IE only supports `"float"` in `getPropertyValue`; in computed styles
			// it's only available as `"cssFloat"`. We no longer modify properties
			// sent to `.css()` apart from camelCasing, so we need to check both.
			// Normally, this would create difference in behavior: if
			// `getPropertyValue` returns an empty string, the value returned
			// by `.css()` would be `undefined`. This is usually the case for
			// disconnected elements. However, in IE even disconnected elements
			// with no styles return `"none"` for `getPropertyValue( "float" )`
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( isCustomProp && ret ) {
	
				// Support: Firefox 105+, Chrome <=105+
				// Spec requires trimming whitespace for custom properties (gh-4926).
				// Firefox only trims leading whitespace. Chrome just collapses
				// both leading & trailing whitespace to a single space.
				//
				// Fall back to `undefined` if empty string returned.
				// This collapses a missing definition with property defined
				// and set to an empty string but there's no standard API
				// allowing us to differentiate them without a performance penalty
				// and returning `undefined` aligns with older jQuery.
				//
				// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
				// as whitespace while CSS does not, but this is not a problem
				// because CSS preprocessing replaces them with U+000A LINE FEED
				// (which *is* CSS whitespace)
				// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
				ret = ret.replace( rtrimCSS, "$1" ) || undefined;
			}
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	return curCSS;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(63),
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, jQuery ) {
	
	"use strict";
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	return finalPropName;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(281)
	
		// css is assumed
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isAttached ) {
		"use strict";
	
		// isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
		// through the CSS cascade), which is useful in deciding whether or not to make it visible.
		// It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
		// * A hidden ancestor does not force an element to be classified as hidden.
		// * Being disconnected from the document does not force an element to be classified as hidden.
		// These differences improve the behavior of .toggle() et al. when applied to elements that are
		// detached or contained within hidden ancestors (gh-2404, gh-2863).
		return function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	return /^--/;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(225),
		__webpack_require__(132),
		__webpack_require__(282)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, camelCase, rnothtmlwhite, acceptData ) {
	
	"use strict";
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see trac-8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	
	return Data;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 689 */
112,
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(112),
		__webpack_require__(282),
		__webpack_require__(286),
		__webpack_require__(53),
		__webpack_require__(228),
		__webpack_require__(227)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document, dataPriv, acceptData, hasOwn, isFunction, isWindow ) {
	
	"use strict";
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (trac-9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (trac-6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(180),
		__webpack_require__(281),
		__webpack_require__(696),
		__webpack_require__(695),
		__webpack_require__(697),
		__webpack_require__(692),
		__webpack_require__(693)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, isAttached, rtagName, rscriptType, wrapMap, getAll, setGlobalEval ) {
	
	"use strict";
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (trac-12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	return buildFragment;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(111)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName ) {
	
	"use strict";
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	return getAll;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(112)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( dataPriv ) {
	
	"use strict";
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	return setGlobalEval;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(63),
		__webpack_require__(154)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (trac-11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (trac-14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	return support;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /^$|^module$|\/(?:java|ecma)script/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		// rtagName captures the name from the first start tag in a string of HTML
		// https://html.spec.whatwg.org/multipage/syntax.html#tag-open-state
		// https://html.spec.whatwg.org/multipage/syntax.html#tag-name-state
		return ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(694)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( support ) {
	
	"use strict";
	
	// We have to close these tags to support XHTML (trac-13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	return wrapMap;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Note: an element does not contain itself
	jQuery.contains = function( a, b ) {
		var bup = b && b.parentNode;
	
		return a === bup || !!( bup && bup.nodeType === 1 && (
	
			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ?
				a.contains( bup ) :
				a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
		) );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(180),
		__webpack_require__(413),
		__webpack_require__(53),
		__webpack_require__(94),
		__webpack_require__(182), // filter
		__webpack_require__(675)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, toType, rcheckableType, isFunction ) {
	
	"use strict";
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} ).filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} ).map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(287),
		__webpack_require__(53),
		__webpack_require__(701),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, indexOf, isFunction, rneedsContext ) {
	
	"use strict";
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
		"use strict";
	
		return jQuery.expr.match.needsContext;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	
	"use strict";
	
	// Support: IE 9 - 11+, Edge 18+, Android Browser 4.0 - 4.3 only, iOS 7 - 11 only, Safari 11 only,
	// Firefox <= 61 only
	// Provide fallback for browsers without Array#flat.
	return arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(286)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( hasOwn ) {
		"use strict";
	
		return hasOwn.toString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return Object.getPrototypeOf;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(708)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( whitespace ) {
	
	"use strict";
	
	return new RegExp(
		"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
		"g"
	);
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(284)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( class2type ) {
		"use strict";
	
		return class2type.toString;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// https://www.w3.org/TR/css3-selectors/#whitespace
	return "[\\x20\\t\\r\\n\\f]";
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(156),
	    root = __webpack_require__(95);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(95);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 711 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(1849);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 713 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1872),
	    isArguments = __webpack_require__(433),
	    isArray = __webpack_require__(43),
	    isBuffer = __webpack_require__(434),
	    isIndex = __webpack_require__(428),
	    isTypedArray = __webpack_require__(740);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 715 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(420),
	    eq = __webpack_require__(298);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 717 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(1847),
	    keys = __webpack_require__(187);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(419),
	    isArray = __webpack_require__(43);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 720 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 721 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(290),
	    isArrayLike = __webpack_require__(157);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(186),
	    overRest = __webpack_require__(734),
	    setToString = __webpack_require__(735);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 724 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(156);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(417),
	    arraySome = __webpack_require__(715),
	    cacheHas = __webpack_require__(424);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 727 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(719),
	    getSymbols = __webpack_require__(427),
	    keys = __webpack_require__(187);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(719),
	    getSymbolsIn = __webpack_require__(730),
	    keysIn = __webpack_require__(437);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(419),
	    getPrototype = __webpack_require__(426),
	    getSymbols = __webpack_require__(427),
	    stubArray = __webpack_require__(747);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 732 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 733 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1839);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1867),
	    shortOut = __webpack_require__(1930);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1923);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 737 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83),
	    now = __webpack_require__(1956),
	    toNumber = __webpack_require__(749);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(1841),
	    baseEvery = __webpack_require__(1845),
	    baseIteratee = __webpack_require__(88),
	    isArray = __webpack_require__(43),
	    isIterateeCall = __webpack_require__(296);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1858),
	    baseUnary = __webpack_require__(230),
	    nodeUtil = __webpack_require__(431);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 741 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(291),
	    baseGt = __webpack_require__(720),
	    identity = __webpack_require__(186);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(291),
	    baseGt = __webpack_require__(720),
	    baseIteratee = __webpack_require__(88);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(291),
	    baseLt = __webpack_require__(721),
	    identity = __webpack_require__(186);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(155),
	    baseClone = __webpack_require__(421),
	    baseUnset = __webpack_require__(1876),
	    castPath = __webpack_require__(293),
	    copyObject = __webpack_require__(231),
	    customOmitClone = __webpack_require__(1893),
	    flatRest = __webpack_require__(1896),
	    getAllKeysIn = __webpack_require__(729);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1891);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 747 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(749);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(1874),
	    isObject = __webpack_require__(83),
	    isSymbol = __webpack_require__(158);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(1873);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(88),
	    baseUniq = __webpack_require__(1875);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(455);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('Promise constructor\'s argument is not a function');
	  }
	  this._x = 0;
	  this._y = 0;
	  this._z = null;
	  this._A = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._B = null;
	Promise._C = null;
	Promise._D = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	}
	function handle(self, deferred) {
	  while (self._y === 3) {
	    self = self._z;
	  }
	  if (Promise._B) {
	    Promise._B(self);
	  }
	  if (self._y === 0) {
	    if (self._x === 0) {
	      self._x = 1;
	      self._A = deferred;
	      return;
	    }
	    if (self._x === 1) {
	      self._x = 2;
	      self._A = [self._A, deferred];
	      return;
	    }
	    self._A.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._y === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._y === 1) {
	        resolve(deferred.promise, self._z);
	      } else {
	        reject(deferred.promise, self._z);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._z);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._y = 3;
	      self._z = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._y = 1;
	  self._z = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._y = 2;
	  self._z = newValue;
	  if (Promise._C) {
	    Promise._C(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._x === 1) {
	    handle(self, self._A);
	    self._A = null;
	  }
	  if (self._x === 2) {
	    for (var i = 0; i < self._A.length; i++) {
	      handle(self, self._A[i]);
	    }
	    self._A = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  });
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 753 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePopper = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(303));
	
	var _core = __webpack_require__(788);
	
	var _reactFastCompare = _interopRequireDefault(__webpack_require__(1986));
	
	var _utils = __webpack_require__(441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var EMPTY_MODIFIERS = [];
	
	var usePopper = function usePopper(referenceElement, popperElement, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var prevOptions = React.useRef(null);
	  var optionsWithDefaults = {
	    onFirstUpdate: options.onFirstUpdate,
	    placement: options.placement || 'bottom',
	    strategy: options.strategy || 'absolute',
	    modifiers: options.modifiers || EMPTY_MODIFIERS
	  };
	
	  var _React$useState = React.useState({
	    styles: {
	      popper: {
	        position: optionsWithDefaults.strategy,
	        left: '0',
	        top: '0'
	      },
	      arrow: {
	        position: 'absolute'
	      }
	    },
	    attributes: {}
	  }),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var updateStateModifier = React.useMemo(function () {
	    return {
	      name: 'updateState',
	      enabled: true,
	      phase: 'write',
	      fn: function fn(_ref) {
	        var state = _ref.state;
	        var elements = Object.keys(state.elements);
	        ReactDOM.flushSync(function () {
	          setState({
	            styles: (0, _utils.fromEntries)(elements.map(function (element) {
	              return [element, state.styles[element] || {}];
	            })),
	            attributes: (0, _utils.fromEntries)(elements.map(function (element) {
	              return [element, state.attributes[element]];
	            }))
	          });
	        });
	      },
	      requires: ['computeStyles']
	    };
	  }, []);
	  var popperOptions = React.useMemo(function () {
	    var newOptions = {
	      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
	      placement: optionsWithDefaults.placement,
	      strategy: optionsWithDefaults.strategy,
	      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
	        name: 'applyStyles',
	        enabled: false
	      }])
	    };
	
	    if ((0, _reactFastCompare["default"])(prevOptions.current, newOptions)) {
	      return prevOptions.current || newOptions;
	    } else {
	      prevOptions.current = newOptions;
	      return newOptions;
	    }
	  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
	  var popperInstanceRef = React.useRef();
	  (0, _utils.useIsomorphicLayoutEffect)(function () {
	    if (popperInstanceRef.current) {
	      popperInstanceRef.current.setOptions(popperOptions);
	    }
	  }, [popperOptions]);
	  (0, _utils.useIsomorphicLayoutEffect)(function () {
	    if (referenceElement == null || popperElement == null) {
	      return;
	    }
	
	    var createPopper = options.createPopper || _core.createPopper;
	    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
	    popperInstanceRef.current = popperInstance;
	    return function () {
	      popperInstance.destroy();
	      popperInstanceRef.current = null;
	    };
	  }, [referenceElement, popperElement, options.createPopper]);
	  return {
	    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
	    styles: state.styles,
	    attributes: state.attributes,
	    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
	    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
	  };
	};
	
	exports.usePopper = usePopper;

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(455);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _AnimateManager = _interopRequireDefault(__webpack_require__(1995));
	
	var _easing = __webpack_require__(757);
	
	var _configUpdate = _interopRequireDefault(__webpack_require__(1996));
	
	var _util = __webpack_require__(304);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var Animate =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Animate, _PureComponent);
	
	  function Animate(props, context) {
	    var _this;
	
	    _classCallCheck(this, Animate);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animate).call(this, props, context));
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	
	    if (!isActive) {
	      _this.state = {
	        style: {}
	      }; // if children is a function and animation is not active, set style to 'to'
	
	      if (typeof children === 'function') {
	        _this.state = {
	          style: to
	        };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = {
	        style: steps[0].style
	      };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	        return _possibleConstructorReturn(_this);
	      }
	
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = {
	        style: {}
	      };
	    }
	
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props2 = this.props,
	          isActive = _this$props2.isActive,
	          canBegin = _this$props2.canBegin;
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props3 = this.props,
	          isActive = _this$props3.isActive,
	          canBegin = _this$props3.canBegin,
	          attributeName = _this$props3.attributeName,
	          shouldReAnimate = _this$props3.shouldReAnimate;
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        var newState = {
	          style: attributeName ? _defineProperty({}, attributeName, this.props.to) : this.props.to
	        };
	
	        if (this.state && this.state.style) {
	          if (attributeName && this.state.style[attributeName] !== this.props.to || !attributeName && this.state.style !== this.props.to) {
	            // eslint-disable-next-line react/no-did-update-set-state
	            this.setState(newState);
	          }
	        }
	
	        return;
	      }
	
	      if ((0, _isEqual2.default)(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
	        return;
	      }
	
	      var isTriggered = !prevProps.canBegin || !prevProps.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;
	
	      if (this.state && this.state.style) {
	        var _newState = {
	          style: attributeName ? _defineProperty({}, attributeName, from) : from
	        };
	
	        if (attributeName && this.state.style[attributeName] !== from || !attributeName && this.state.style !== from) {
	          // eslint-disable-next-line react/no-did-update-set-state
	          this.setState(_newState);
	        }
	      }
	
	      this.runAnimation(_objectSpread({}, this.props, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: "runJSAnimation",
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	      var startAnimation = (0, _configUpdate.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: "runStepAnimation",
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return _toConsumableArray(sequence).concat([_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	
	        var newStyle = _objectSpread({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return _toConsumableArray(sequence).concat([newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: "runAnimation",
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager.default)();
	      }
	
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	      var manager = this.manager;
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	      manager.start([onAnimationStart, begin, _objectSpread({}, to, {
	        transition: transition
	      }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: "handleStyleChange",
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: "changeStyle",
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          children = _this$props4.children,
	          begin = _this$props4.begin,
	          duration = _this$props4.duration,
	          attributeName = _this$props4.attributeName,
	          easing = _this$props4.easing,
	          isActive = _this$props4.isActive,
	          steps = _this$props4.steps,
	          from = _this$props4.from,
	          to = _this$props4.to,
	          canBegin = _this$props4.canBegin,
	          onAnimationEnd = _this$props4.onAnimationEnd,
	          shouldReAnimate = _this$props4.shouldReAnimate,
	          onAnimationReStart = _this$props4.onAnimationReStart,
	          others = _objectWithoutProperties(_this$props4, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);
	
	      var count = _react.Children.count(children);
	
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === void 0 ? {} : _container$props$styl,
	            className = _container$props.className;
	        var res = (0, _react.cloneElement)(container, _objectSpread({}, others, {
	          style: _objectSpread({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react.default.createElement("div", null, _react.Children.map(children, function (child) {
	        return cloneContainer(child);
	      }));
	    }
	  }]);
	
	  return Animate;
	}(_react.PureComponent);
	
	Animate.displayName = 'Animate';
	Animate.propTypes = {
	  from: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  to: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
	  attributeName: _propTypes.default.string,
	  // animation duration
	  duration: _propTypes.default.number,
	  begin: _propTypes.default.number,
	  easing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
	    duration: _propTypes.default.number.isRequired,
	    style: _propTypes.default.object.isRequired,
	    easing: _propTypes.default.oneOfType([_propTypes.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes.default.arrayOf('string'),
	    onAnimationEnd: _propTypes.default.func
	  })),
	  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  isActive: _propTypes.default.bool,
	  canBegin: _propTypes.default.bool,
	  onAnimationEnd: _propTypes.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes.default.bool,
	  onAnimationStart: _propTypes.default.func,
	  onAnimationReStart: _propTypes.default.func
	};
	Animate.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	};
	var _default = Animate;
	exports.default = _default;

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = void 0;
	
	var _util = __webpack_require__(304);
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    var newParams = _toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)).concat([0]);
	
	    return multyTime(newParams, t);
	  };
	}; // calculate cubic-bezier using Newton's method
	
	
	var configBezier = function configBezier() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	        break;
	
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	        break;
	
	      default:
	        {
	          var easing = args[0].split('(');
	
	          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
	            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
	              return parseFloat(x);
	            });
	
	            var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);
	
	            x1 = _easing$1$split$0$spl2[0];
	            y1 = _easing$1$split$0$spl2[1];
	            x2 = _easing$1$split$0$spl2[2];
	            y2 = _easing$1$split$0$spl2[3];
	          } else {
	            (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', instead received %s', args);
	          }
	        }
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	  return bezier;
	};
	
	exports.configBezier = configBezier;
	
	var configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === void 0 ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === void 0 ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	  return stepper;
	};
	
	exports.configSpring = configSpring;
	
	var configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	
	      case 'spring':
	        return configSpring();
	
	      default:
	        if (easing.split('(')[0] === 'cubic-bezier') {
	          return configBezier(easing);
	        }
	
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	  return null;
	};
	
	exports.configEasing = configEasing;

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(303));
	
	var _reactLifecyclesCompat = __webpack_require__(753);
	
	var _PropTypes = __webpack_require__(761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(753);
	
	var _ChildMapping = __webpack_require__(2000);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(1998));
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1999));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(759));
	
	var _Transition = _interopRequireDefault(__webpack_require__(758));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	  Transition: _Transition.default,
	  TransitionGroup: _TransitionGroup.default,
	  ReplaceTransition: _ReplaceTransition.default,
	  CSSTransition: _CSSTransition.default
	};

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 762 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.memoize = exports.reverse = exports.compose = exports.map = exports.range = exports.curry = exports.PLACE_HOLDER = void 0;
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	exports.PLACE_HOLDER = PLACE_HOLDER;
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(void 0, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(void 0, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	exports.curry = curry;
	
	var range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	exports.range = range;
	var map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	exports.map = map;
	
	var compose = function compose() {
	  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse(); // first function can receive multiply arguments
	
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(void 0, arguments));
	  };
	};
	
	exports.compose = compose;
	
	var reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  } // can be string
	
	
	  return arr.split('').reverse.join('');
	};
	
	exports.reverse = reverse;
	
	var memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	  return function () {
	    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(void 0, args);
	    return lastResult;
	  };
	};
	
	exports.memoize = memoize;

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _range2 = _interopRequireDefault(__webpack_require__(746));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _d3Scale = __webpack_require__(620);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Text = _interopRequireDefault(__webpack_require__(159));
	
	var _DataUtils = __webpack_require__(39);
	
	var _CssPrefixUtils = __webpack_require__(2024);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Brush =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Brush, _PureComponent);
	
	  function Brush(props) {
	    var _this;
	
	    _classCallCheck(this, Brush);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Brush).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'endX')
	    };
	    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Brush, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          x = _this$props.x,
	          travellerWidth = _this$props.travellerWidth,
	          updateId = _this$props.updateId;
	
	      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
	        this.setState(this.updateScale(nextProps));
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	      var _this$props2 = this.props,
	          gap = _this$props2.gap,
	          data = _this$props2.data;
	      var lastIndex = data.length - 1;
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.constructor.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.constructor.getIndexInRange(this.scaleValues, max);
	      return {
	        startIndex: minIndex - minIndex % gap,
	        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
	      };
	    }
	  }, {
	    key: "getTextOfTick",
	    value: function getTextOfTick(index) {
	      var _this$props3 = this.props,
	          data = _this$props3.data,
	          tickFormatter = _this$props3.tickFormatter,
	          dataKey = _this$props3.dataKey;
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	      return (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: "handleSlideDrag",
	    value: function handleSlideDrag(e) {
	      var _this$state = this.state,
	          slideMoveStartX = _this$state.slideMoveStartX,
	          startX = _this$state.startX,
	          endX = _this$state.endX;
	      var _this$props4 = this.props,
	          x = _this$props4.x,
	          width = _this$props4.width,
	          travellerWidth = _this$props4.travellerWidth,
	          startIndex = _this$props4.startIndex,
	          endIndex = _this$props4.endIndex,
	          onChange = _this$props4.onChange;
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerDragStart",
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: "handleTravellerMove",
	    value: function handleTravellerMove(e) {
	      var _this$setState;
	
	      var _this$state2 = this.state,
	          brushMoveStartX = _this$state2.brushMoveStartX,
	          movingTravellerId = _this$state2.movingTravellerId,
	          endX = _this$state2.endX,
	          startX = _this$state2.startX;
	      var prevValue = this.state[movingTravellerId];
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          width = _this$props5.width,
	          travellerWidth = _this$props5.travellerWidth,
	          onChange = _this$props5.onChange,
	          gap = _this$props5.gap,
	          data = _this$props5.data;
	      var params = {
	        startX: this.state.startX,
	        endX: this.state.endX
	      };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	      var startIndex = newIndex.startIndex,
	          endIndex = newIndex.endIndex;
	
	      var isFullGap = function isFullGap() {
	        var lastIndex = data.length - 1;
	
	        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
	          return true;
	        }
	
	        return false;
	      };
	
	      this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
	        if (onChange) {
	          if (isFullGap()) {
	            onChange(newIndex);
	          }
	        }
	      });
	    }
	  }, {
	    key: "updateScale",
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	      var len = data.length;
	      this.scale = (0, _d3Scale.scalePoint)().domain((0, _range2["default"])(0, len)).range([x, x + width - travellerWidth]);
	      this.scaleValues = this.scale.domain().map(function (entry) {
	        return _this3.scale(entry);
	      });
	      return {
	        isTextActive: false,
	        isSlideMoving: false,
	        isTravellerMoving: false,
	        startX: this.scale(startIndex),
	        endX: this.scale(endIndex)
	      };
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          fill = _this$props6.fill,
	          stroke = _this$props6.stroke;
	      return _react["default"].createElement("rect", {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: "renderPanorama",
	    value: function renderPanorama() {
	      var _this$props7 = this.props,
	          x = _this$props7.x,
	          y = _this$props7.y,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          data = _this$props7.data,
	          children = _this$props7.children,
	          padding = _this$props7.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react["default"].cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: "renderTraveller",
	    value: function renderTraveller(travellerX, id) {
	      var _this$props8 = this.props,
	          y = _this$props8.y,
	          travellerWidth = _this$props8.travellerWidth,
	          height = _this$props8.height,
	          stroke = _this$props8.stroke;
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(travellerX, this.props.x);
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-traveller",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.travellerDragStartHandlers[id],
	        onTouchStart: this.travellerDragStartHandlers[id],
	        style: {
	          cursor: 'col-resize'
	        }
	      }, _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: travellerWidth,
	        height: height,
	        fill: stroke,
	        stroke: "none"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY,
	        x2: x + travellerWidth - 1,
	        y2: lineY,
	        fill: "none",
	        stroke: "#fff"
	      }), _react["default"].createElement("line", {
	        x1: x + 1,
	        y1: lineY + 2,
	        x2: x + travellerWidth - 1,
	        y2: lineY + 2,
	        fill: "none",
	        stroke: "#fff"
	      }));
	    }
	  }, {
	    key: "renderSlide",
	    value: function renderSlide(startX, endX) {
	      var _this$props9 = this.props,
	          y = _this$props9.y,
	          height = _this$props9.height,
	          stroke = _this$props9.stroke;
	      return _react["default"].createElement("rect", {
	        className: "recharts-brush-slide",
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: {
	          cursor: 'move'
	        },
	        stroke: "none",
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: "renderText",
	    value: function renderText() {
	      var _this$props10 = this.props,
	          startIndex = _this$props10.startIndex,
	          endIndex = _this$props10.endIndex,
	          y = _this$props10.y,
	          height = _this$props10.height,
	          travellerWidth = _this$props10.travellerWidth,
	          stroke = _this$props10.stroke;
	      var _this$state3 = this.state,
	          startX = _this$state3.startX,
	          endX = _this$state3.endX;
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-brush-texts"
	      }, _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "end",
	        verticalAnchor: "middle",
	        x: Math.min(startX, endX) - offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(startIndex)), _react["default"].createElement(_Text["default"], _extends({
	        textAnchor: "start",
	        verticalAnchor: "middle",
	        x: Math.max(startX, endX) + travellerWidth + offset,
	        y: y + height / 2
	      }, attrs), this.getTextOfTick(endIndex)));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props11 = this.props,
	          data = _this$props11.data,
	          className = _this$props11.className,
	          children = _this$props11.children,
	          x = _this$props11.x,
	          y = _this$props11.y,
	          width = _this$props11.width,
	          height = _this$props11.height,
	          alwaysShowText = _this$props11.alwaysShowText;
	      var _this$state4 = this.state,
	          startX = _this$state4.startX,
	          endX = _this$state4.endX,
	          isTextActive = _this$state4.isTextActive,
	          isSlideMoving = _this$state4.isSlideMoving,
	          isTravellerMoving = _this$state4.isTravellerMoving;
	
	      if (!data || !data.length || !(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || width <= 0 || height <= 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-brush', className);
	      var isPanoramic = _react["default"].Children.count(children) === 1;
	      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass,
	        onMouseMove: this.handleDrag,
	        onMouseLeave: this.handleLeaveWrapper,
	        onMouseUp: this.handleDragEnd,
	        onTouchEnd: this.handleDragEnd,
	        onTouchMove: this.handleTouchMove,
	        style: style
	      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTraveller(startX, 'startX'), this.renderTraveller(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
	    }
	  }], [{
	    key: "getIndexInRange",
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }]);
	
	  return Brush;
	}(_react.PureComponent);
	
	Brush.displayName = 'Brush';
	Brush.propTypes = {
	  className: _propTypes["default"].string,
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number.isRequired,
	  travellerWidth: _propTypes["default"].number,
	  gap: _propTypes["default"].number,
	  padding: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  }),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].array,
	  startIndex: _propTypes["default"].number,
	  endIndex: _propTypes["default"].number,
	  tickFormatter: _propTypes["default"].func,
	  children: _propTypes["default"].node,
	  onChange: _propTypes["default"].func,
	  updateId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  leaveTimeOut: _propTypes["default"].number,
	  alwaysShowText: _propTypes["default"].bool
	};
	Brush.defaultProps = {
	  height: 40,
	  travellerWidth: 5,
	  gap: 1,
	  fill: '#fff',
	  stroke: '#666',
	  padding: {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  },
	  leaveTimeOut: 1000,
	  alwaysShowText: false
	};
	var _default = Brush;
	exports["default"] = _default;

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _ShallowEqual = __webpack_require__(313);
	
	var _DOMUtils = __webpack_require__(311);
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Text = _interopRequireDefault(__webpack_require__(159));
	
	var _Label = _interopRequireDefault(__webpack_require__(134));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianAxis =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxis).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ["viewBox"]);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _this$props = this.props,
	          viewBoxOld = _this$props.viewBox,
	          restPropsOld = _objectWithoutProperties(_this$props, ["viewBox"]);
	
	      return !(0, _ShallowEqual.shallowEqual)(viewBox, viewBoxOld) || !(0, _ShallowEqual.shallowEqual)(restProps, restPropsOld) || !(0, _ShallowEqual.shallowEqual)(state, this.state);
	    }
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: "getTickLineCoord",
	    value: function getTickLineCoord(data) {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          orientation = _this$props2.orientation,
	          tickSize = _this$props2.tickSize,
	          mirror = _this$props2.mirror,
	          tickMargin = _this$props2.tickMargin;
	      var x1, x2, y1, y2, tx, ty;
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = y2 - sign * finalTickSize;
	          ty = y1 - sign * tickMargin;
	          tx = tickCoord;
	          break;
	
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = x2 - sign * finalTickSize;
	          tx = x1 - sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = x2 + sign * finalTickSize;
	          tx = x1 + sign * tickMargin;
	          ty = tickCoord;
	          break;
	
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = y2 + sign * finalTickSize;
	          ty = y1 + sign * tickMargin;
	          tx = tickCoord;
	          break;
	      }
	
	      return {
	        line: {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2
	        },
	        tick: {
	          x: tx,
	          y: ty
	        }
	      };
	    }
	  }, {
	    key: "getTickTextAnchor",
	    value: function getTickTextAnchor() {
	      var _this$props3 = this.props,
	          orientation = _this$props3.orientation,
	          mirror = _this$props3.mirror;
	      var textAnchor;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: "getTickVerticalAnchor",
	    value: function getTickVerticalAnchor() {
	      var _this$props4 = this.props,
	          orientation = _this$props4.orientation,
	          mirror = _this$props4.mirror;
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: "renderAxisLine",
	    value: function renderAxisLine() {
	      var _this$props5 = this.props,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height,
	          orientation = _this$props5.orientation,
	          axisLine = _this$props5.axisLine,
	          mirror = _this$props5.mirror;
	
	      var props = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _objectSpread({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react["default"].createElement("line", _extends({
	        className: "recharts-cartesian-axis-line"
	      }, props));
	    }
	  }, {
	    key: "renderTicks",
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	    value: function renderTicks(ticks) {
	      var _this = this;
	
	      var _this$props6 = this.props,
	          tickLine = _this$props6.tickLine,
	          stroke = _this$props6.stroke,
	          tick = _this$props6.tick,
	          tickFormatter = _this$props6.tickFormatter,
	          unit = _this$props6.unit;
	      var finalTicks = CartesianAxis.getTicks(_objectSpread({}, this.props, {
	        ticks: ticks
	      }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var tickLineProps = _objectSpread({}, axisProps, {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = finalTicks.map(function (entry, i) {
	        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
	            lineCoord = _this$getTickLineCoor.line,
	            tickCoord = _this$getTickLineCoor.tick;
	
	        var tickProps = _objectSpread({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none',
	          fill: stroke
	        }, customTickProps, {}, tickCoord, {
	          index: i,
	          payload: entry,
	          visibleTicksCount: finalTicks.length
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-cartesian-axis-tick",
	          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), tickLine && _react["default"].createElement("line", _extends({
	          className: "recharts-cartesian-axis-tick-line"
	        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, "".concat((0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value).concat(unit || '')));
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-axis-ticks"
	      }, items);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props7 = this.props,
	          axisLine = _this$props7.axisLine,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          ticksGenerator = _this$props7.ticksGenerator,
	          className = _this$props7.className,
	          hide = _this$props7.hide;
	
	      if (hide) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          ticks = _this$props8.ticks,
	          noTicksProps = _objectWithoutProperties(_this$props8, ["ticks"]);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction2["default"])(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-cartesian-axis', className)
	      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), _Label["default"].renderCallByParent(this.props));
	    }
	  }], [{
	    key: "getTicks",
	    value: function getTicks(props) {
	      var tick = props.tick,
	          ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter,
	          unit = props.unit;
	
	      if (!ticks || !ticks.length || !tick) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        }, true);
	      }
	
	      if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks,
	          tickFormatter: tickFormatter,
	          viewBox: viewBox,
	          orientation: orientation,
	          minTickGap: minTickGap,
	          unit: unit
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({
	        ticks: ticks,
	        tickFormatter: tickFormatter,
	        viewBox: viewBox,
	        orientation: orientation,
	        minTickGap: minTickGap,
	        unit: unit
	      });
	    }
	  }, {
	    key: "getNumberIntervalTicks",
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: "getTicksStart",
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap,
	          unit = _ref2.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey] + unitSize;
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _objectSpread({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _objectSpread({}, tail, {
	            isShow: true
	          });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	
	      for (var _i = 0; _i < count; _i++) {
	        var entry = result[_i];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[_i] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "getTicksEnd",
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap,
	          unit = _ref3.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'
	
	      var unitSize = unit && sizeKey === 'width' ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	      var start, end;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var _i2 = len - 1; _i2 >= 0; _i2--) {
	        var entry = result[_i2];
	        var content = (0, _isFunction2["default"])(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (_i2 === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[_i2] = entry = _objectSpread({}, entry, {
	            tickCoord: entry.coordinate
	          });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[_i2] = _objectSpread({}, entry, {
	            isShow: true
	          });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: "renderTickItem",
	    value: function renderTickItem(option, props, value) {
	      var tickItem;
	
	      if (_react["default"].isValidElement(option)) {
	        tickItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react["default"].createElement(_Text["default"], _extends({}, props, {
	          className: "recharts-cartesian-axis-tick-value"
	        }), value);
	      }
	
	      return tickItem;
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component);
	
	CartesianAxis.displayName = 'CartesianAxis';
	CartesianAxis.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  orientation: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  tick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  axisLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  tickLine: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  mirror: _propTypes["default"].bool,
	  tickMargin: _propTypes["default"].number.isRequired,
	  minTickGap: _propTypes["default"].number,
	  ticks: _propTypes["default"].array,
	  tickSize: _propTypes["default"].number,
	  stroke: _propTypes["default"].string,
	  tickFormatter: _propTypes["default"].func,
	  ticksGenerator: _propTypes["default"].func,
	  interval: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	});
	CartesianAxis.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  tickMargin: 2,
	  interval: 'preserveEnd'
	};
	var _default = CartesianAxis;
	exports["default"] = _default;

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Label = _interopRequireDefault(__webpack_require__(134));
	
	var _CartesianUtils = __webpack_require__(136);
	
	var _IfOverflowMatches = __webpack_require__(312);
	
	var _DataUtils = __webpack_require__(39);
	
	var _LogUtils = __webpack_require__(193);
	
	var _ReactUtils = __webpack_require__(19);
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(192));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceArea =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceArea, _PureComponent);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceArea).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: "getRect",
	    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
	      var _this$props = this.props,
	          xValue1 = _this$props.x1,
	          xValue2 = _this$props.x2,
	          yValue1 = _this$props.y1,
	          yValue2 = _this$props.y2,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scale = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var p1 = {
	        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
	        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
	      };
	      var p2 = {
	        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
	        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
	      };
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (!scale.isInRange(p1) || !scale.isInRange(p2))) {
	        return null;
	      }
	
	      return (0, _CartesianUtils.rectWithPoints)(p1, p2);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x1 = _this$props2.x1,
	          x2 = _this$props2.x2,
	          y1 = _this$props2.y1,
	          y2 = _this$props2.y2,
	          className = _this$props2.className,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	      var hasX1 = (0, _DataUtils.isNumOrStr)(x1);
	      var hasX2 = (0, _DataUtils.isNumOrStr)(x2);
	      var hasY1 = (0, _DataUtils.isNumOrStr)(y1);
	      var hasY2 = (0, _DataUtils.isNumOrStr)(y2);
	      var shape = this.props.shape;
	
	      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);
	
	      if (!rect && !shape) {
	        return null;
	      }
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-area', className)
	      }, this.constructor.renderRect(shape, _objectSpread({
	        clipPath: clipPath
	      }, this.props, {}, rect)), _Label["default"].renderCallByParent(this.props, rect));
	    }
	  }], [{
	    key: "renderRect",
	    value: function renderRect(option, props) {
	      var rect;
	
	      if (_react["default"].isValidElement(option)) {
	        rect = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        rect = option(props);
	      } else {
	        rect = _react["default"].createElement(_Rectangle["default"], _extends({}, props, {
	          className: "recharts-reference-area-rect"
	        }));
	      }
	
	      return rect;
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.PureComponent);
	
	ReferenceArea.displayName = 'ReferenceArea';
	ReferenceArea.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  x2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y1: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y2: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element])
	});
	ReferenceArea.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	};
	var _default = ReferenceArea;
	exports["default"] = _default;

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Dot = _interopRequireDefault(__webpack_require__(160));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _Label = _interopRequireDefault(__webpack_require__(134));
	
	var _DataUtils = __webpack_require__(39);
	
	var _IfOverflowMatches = __webpack_require__(312);
	
	var _CartesianUtils = __webpack_require__(136);
	
	var _LogUtils = __webpack_require__(193);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ReferenceDot =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceDot, _PureComponent);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceDot).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: "getCoordinate",
	    value: function getCoordinate() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          xAxis = _this$props.xAxis,
	          yAxis = _this$props.yAxis;
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var result = scales.apply({
	        x: x,
	        y: y
	      }, {
	        bandAware: true
	      });
	
	      if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.isInRange(result)) {
	        return null;
	      }
	
	      return result;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          x = _this$props2.x,
	          y = _this$props2.y,
	          r = _this$props2.r,
	          alwaysShow = _this$props2.alwaysShow,
	          clipPathId = _this$props2.clipPathId;
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var cx = coordinate.x,
	          cy = coordinate.y;
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          className = _this$props3.className;
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var dotProps = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        cx: cx,
	        cy: cy
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-dot', className)
	      }, this.constructor.renderDot(shape, dotProps), _Label["default"].renderCallByParent(this.props, {
	        x: cx - r,
	        y: cy - r,
	        width: 2 * r,
	        height: 2 * r
	      }));
	    }
	  }], [{
	    key: "renderDot",
	    value: function renderDot(option, props) {
	      var dot;
	
	      if (_react["default"].isValidElement(option)) {
	        dot = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dot = option(props);
	      } else {
	        dot = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: "recharts-reference-dot-dot"
	        }));
	      }
	
	      return dot;
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.PureComponent);
	
	ReferenceDot.displayName = 'ReferenceDot';
	ReferenceDot.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes["default"].number,
	  xAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  yAxis: _propTypes["default"].shape({
	    scale: _propTypes["default"].func
	  }),
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  clipPathId: _propTypes["default"].string
	});
	ReferenceDot.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	};
	var _default = ReferenceDot;
	exports["default"] = _default;

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _some2 = _interopRequireDefault(__webpack_require__(1958));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _Label = _interopRequireDefault(__webpack_require__(134));
	
	var _IfOverflowMatches = __webpack_require__(312);
	
	var _DataUtils = __webpack_require__(39);
	
	var _CartesianUtils = __webpack_require__(136);
	
	var _LogUtils = __webpack_require__(193);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var renderLine = function renderLine(option, props) {
	  var line;
	
	  if (_react["default"].isValidElement(option)) {
	    line = _react["default"].cloneElement(option, props);
	  } else if ((0, _isFunction2["default"])(option)) {
	    line = option(props);
	  } else {
	    line = _react["default"].createElement("line", _extends({}, props, {
	      className: "recharts-reference-line-line"
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(ReferenceLine, _PureComponent);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceLine).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: "getEndPoints",
	    value: function getEndPoints(scales, isFixedX, isFixedY, isSegment) {
	      var _this$props = this.props,
	          _this$props$viewBox = _this$props.viewBox,
	          x = _this$props$viewBox.x,
	          y = _this$props$viewBox.y,
	          width = _this$props$viewBox.width,
	          height = _this$props$viewBox.height,
	          position = _this$props.position;
	
	      if (isFixedY) {
	        var _this$props2 = this.props,
	            yCoord = _this$props2.y,
	            orientation = _this$props2.yAxis.orientation;
	        var coord = scales.y.apply(yCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.y.isInRange(coord)) {
	          return null;
	        }
	
	        var points = [{
	          x: x + width,
	          y: coord
	        }, {
	          x: x,
	          y: coord
	        }];
	        return orientation === 'left' ? points.reverse() : points;
	      }
	
	      if (isFixedX) {
	        var _this$props3 = this.props,
	            xCoord = _this$props3.x,
	            _orientation = _this$props3.xAxis.orientation;
	
	        var _coord = scales.x.apply(xCoord, {
	          position: position
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && !scales.x.isInRange(_coord)) {
	          return null;
	        }
	
	        var _points = [{
	          x: _coord,
	          y: y + height
	        }, {
	          x: _coord,
	          y: y
	        }];
	        return _orientation === 'top' ? _points.reverse() : _points;
	      }
	
	      if (isSegment) {
	        var segment = this.props.segment;
	
	        var _points2 = segment.map(function (p) {
	          return scales.apply(p, {
	            position: position
	          });
	        });
	
	        if ((0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'discard') && (0, _some2["default"])(_points2, function (p) {
	          return !scales.isInRange(p);
	        })) {
	          return null;
	        }
	
	        return _points2;
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          fixedX = _this$props4.x,
	          fixedY = _this$props4.y,
	          segment = _this$props4.segment,
	          xAxis = _this$props4.xAxis,
	          yAxis = _this$props4.yAxis,
	          shape = _this$props4.shape,
	          className = _this$props4.className,
	          alwaysShow = _this$props4.alwaysShow,
	          clipPathId = _this$props4.clipPathId;
	      (0, _LogUtils.warn)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({
	        x: xAxis.scale,
	        y: yAxis.scale
	      });
	
	      var isX = (0, _DataUtils.isNumOrStr)(fixedX);
	      var isY = (0, _DataUtils.isNumOrStr)(fixedY);
	      var isSegment = segment && segment.length === 2;
	      var endPoints = this.getEndPoints(scales, isX, isY, isSegment);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          _endPoints$ = _endPoints[0],
	          x1 = _endPoints$.x,
	          y1 = _endPoints$.y,
	          _endPoints$2 = _endPoints[1],
	          x2 = _endPoints$2.x,
	          y2 = _endPoints$2.y;
	
	      var clipPath = (0, _IfOverflowMatches.ifOverflowMatches)(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
	
	      var props = _objectSpread({
	        clipPath: clipPath
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      });
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: (0, _classnames["default"])('recharts-reference-line', className)
	      }, renderLine(shape, props), _Label["default"].renderCallByParent(this.props, (0, _CartesianUtils.rectWithCoords)({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      })));
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.PureComponent);
	
	ReferenceLine.displayName = 'ReferenceLine';
	ReferenceLine.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    width: _propTypes["default"].number,
	    height: _propTypes["default"].number
	  }),
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  isFront: _propTypes["default"].bool,
	  alwaysShow: _propTypes["default"].bool,
	  ifOverflow: _propTypes["default"].oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
	  x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  segment: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    y: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  })),
	  position: _propTypes["default"].oneOf(['middle', 'start', 'end']),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  yAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  xAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].func
	});
	ReferenceLine.defaultProps = {
	  isFront: false,
	  ifOverflow: 'discard',
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1,
	  position: 'middle'
	};
	var _default = ReferenceLine;
	exports["default"] = _default;

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(436));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(745));
	
	var _isString2 = _interopRequireDefault(__webpack_require__(301));
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(300));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Trapezoid = _interopRequireDefault(__webpack_require__(773));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _Cell = _interopRequireDefault(__webpack_require__(190));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Funnel =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Funnel, _PureComponent);
	
	  function Funnel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Funnel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Funnel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (trapezoids) {
	      _this.setState({
	        prevTrapezoids: trapezoids
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Funnel, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          trapezoids = _this$props.trapezoids;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(trapezoids);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderTrapezoidsStatically",
	    value: function renderTrapezoidsStatically(trapezoids) {
	      var _this2 = this;
	
	      var activeShape = this.props.activeShape;
	      return trapezoids.map(function (entry, i) {
	        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;
	
	        var trapezoidProps = _objectSpread({}, entry, {
	          stroke: entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-funnel-trapezoid"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "trapezoid-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this2.constructor.renderTrapezoidItem(trapezoidOptions, trapezoidProps));
	      });
	    }
	  }, {
	    key: "renderTrapezoidsWithAnimation",
	    value: function renderTrapezoidsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props2 = this.props,
	          trapezoids = _this$props2.trapezoids,
	          isAnimationActive = _this$props2.isAnimationActive,
	          animationBegin = _this$props2.animationBegin,
	          animationDuration = _this$props2.animationDuration,
	          animationEasing = _this$props2.animationEasing,
	          animationId = _this$props2.animationId;
	      var prevTrapezoids = this.state.prevTrapezoids;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "funnel-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = trapezoids.map(function (entry, index) {
	          var prev = prevTrapezoids && prevTrapezoids[index];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            var _interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(prev.upperWidth, entry.upperWidth);
	
	            var _interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(prev.lowerWidth, entry.lowerWidth);
	
	            var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t),
	              upperWidth: _interpolatorUpperWidth(t),
	              lowerWidth: _interpolatorLowerWidth(t),
	              height: _interpolatorHeight(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.x + entry.upperWidth / 2, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.y + entry.height / 2, entry.y);
	          var interpolatorUpperWidth = (0, _DataUtils.interpolateNumber)(0, entry.upperWidth);
	          var interpolatorLowerWidth = (0, _DataUtils.interpolateNumber)(0, entry.lowerWidth);
	          var interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t),
	            upperWidth: interpolatorUpperWidth(t),
	            lowerWidth: interpolatorLowerWidth(t),
	            height: interpolatorHeight(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderTrapezoidsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderTrapezoids",
	    value: function renderTrapezoids() {
	      var _this$props3 = this.props,
	          trapezoids = _this$props3.trapezoids,
	          isAnimationActive = _this$props3.isAnimationActive;
	      var prevTrapezoids = this.state.prevTrapezoids;
	
	      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !(0, _isEqual2["default"])(prevTrapezoids, trapezoids))) {
	        return this.renderTrapezoidsWithAnimation();
	      }
	
	      return this.renderTrapezoidsStatically(trapezoids);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props4 = this.props,
	          hide = _this$props4.hide,
	          trapezoids = _this$props4.trapezoids,
	          className = _this$props4.className,
	          isAnimationActive = _this$props4.isAnimationActive;
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      if (hide || !trapezoids || !trapezoids.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoids', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, trapezoids));
	    }
	  }], [{
	    key: "renderTrapezoidItem",
	    value: function renderTrapezoidItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Trapezoid["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Trapezoid["default"], props);
	    }
	  }]);
	
	  return Funnel;
	}(_react.PureComponent);
	
	Funnel.displayName = 'Funnel';
	Funnel.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  trapezoids: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	});
	Funnel.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  labelLine: true,
	  hide: false,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name'
	};
	
	Funnel.getRealFunnelData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Funnel.getRealWidthHeight = function (item, offset) {
	  var customWidth = item.props.width;
	  var width = offset.width,
	      height = offset.height,
	      left = offset.left,
	      right = offset.right,
	      top = offset.top,
	      bottom = offset.bottom;
	  var realHeight = height;
	  var realWidth = width;
	
	  if ((0, _isNumber2["default"])(customWidth)) {
	    realWidth = customWidth;
	  } else if ((0, _isString2["default"])(customWidth)) {
	    realWidth = realWidth * parseFloat(customWidth) / 100;
	  }
	
	  return {
	    realWidth: realWidth - left - right - 50,
	    realHeight: realHeight - bottom - top,
	    offsetX: (width - realWidth) / 2,
	    offsetY: (height - realHeight) / 2
	  };
	};
	
	Funnel.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      offset = _ref2.offset,
	      onItemMouseLeave = _ref2.onItemMouseLeave,
	      onItemMouseEnter = _ref2.onItemMouseEnter;
	  var funnelData = Funnel.getRealFunnelData(item);
	  var _item$props2 = item.props,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      tooltipType = _item$props2.tooltipType;
	  var left = offset.left,
	      top = offset.top;
	
	  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
	      realHeight = _Funnel$getRealWidthH.realHeight,
	      realWidth = _Funnel$getRealWidthH.realWidth,
	      offsetX = _Funnel$getRealWidthH.offsetX,
	      offsetY = _Funnel$getRealWidthH.offsetY;
	
	  var maxValue = (0, _ChartUtils.getValueByDataKey)(funnelData[0], dataKey, 0);
	  var len = funnelData.length;
	  var rowHeight = realHeight / len;
	  var trapezoids = funnelData.map(function (entry, i) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	    var nextVal = 0;
	
	    if (i !== len - 1) {
	      nextVal = (0, _ChartUtils.getValueByDataKey)(funnelData[i + 1], dataKey, 0);
	    }
	
	    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
	    var y = realHeight / len * i + left + offsetY;
	    var upperWidth = val / maxValue * realWidth;
	    var lowerWidth = nextVal / maxValue * realWidth;
	    var tooltipPayload = [{
	      name: name,
	      value: val,
	      payload: entry,
	      dataKey: dataKey,
	      type: tooltipType
	    }];
	    var tooltipPosition = {
	      x: x + upperWidth / 2,
	      y: y + rowHeight / 2
	    };
	    return _objectSpread({
	      x: x,
	      y: y,
	      width: Math.max(upperWidth, lowerWidth),
	      upperWidth: upperWidth,
	      lowerWidth: lowerWidth,
	      height: rowHeight,
	      name: name,
	      val: val,
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: tooltipPosition
	    }, (0, _omit2["default"])(entry, 'width'), {
	      payload: entry
	    });
	  });
	  return {
	    trapezoids: trapezoids,
	    data: funnelData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  };
	};
	
	var _default = Funnel;
	exports["default"] = _default;

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _get2 = _interopRequireDefault(__webpack_require__(185));
	
	var _isPlainObject2 = _interopRequireDefault(__webpack_require__(436));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(82));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Sector = _interopRequireDefault(__webpack_require__(310));
	
	var _Curve = _interopRequireDefault(__webpack_require__(191));
	
	var _Text = _interopRequireDefault(__webpack_require__(159));
	
	var _Label = _interopRequireDefault(__webpack_require__(134));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _Cell = _interopRequireDefault(__webpack_require__(190));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _PolarUtils = __webpack_require__(97);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _LogUtils = __webpack_require__(193);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Pie =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Pie, _PureComponent);
	
	  function Pie() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	    _this.id = (0, _DataUtils.uniqueId)('recharts-pie-');
	
	    _this.cachePrevData = function (sectors) {
	      _this.setState({
	        prevSectors: sectors
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Pie, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          sectors = _this$props.sectors;
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: "isActiveIndex",
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: "renderLabels",
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _this$props2 = this.props,
	          label = _this$props2.label,
	          labelLine = _this$props2.labelLine,
	          dataKey = _this$props2.dataKey,
	          valueKey = _this$props2.valueKey;
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	
	        var labelProps = _objectSpread({}, pieProps, {}, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.constructor.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	
	        var lineProps = _objectSpread({}, pieProps, {}, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          index: i,
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
	          key: 'line'
	        });
	
	        var realDataKey = dataKey; // TODO: compatible to lower versions
	
	        if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil2["default"])(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], {
	            key: "label-".concat(i)
	          }, labelLine && _this2.constructor.renderLabelLineItem(labelLine, lineProps), _this2.constructor.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey)))
	        );
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-pie-labels"
	      }, labels);
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          activeShape = _this$props3.activeShape,
	          blendStroke = _this$props3.blendStroke;
	      return sectors.map(function (entry, i) {
	        var sectorOptions = _this3.isActiveIndex(i) ? activeShape : null;
	
	        var sectorProps = _objectSpread({}, entry, {
	          stroke: blendStroke ? entry.fill : entry.stroke
	        });
	
	        return _react["default"].createElement(_Layer["default"], _extends({
	          className: "recharts-pie-sector"
	        }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          key: "sector-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }), _this3.constructor.renderSectorItem(sectorOptions, sectorProps));
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          sectors = _this$props4.sectors,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevSectors = this.state.prevSectors;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "pie-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = [];
	        var first = sectors && sectors[0];
	        var curAngle = first.startAngle;
	        sectors.forEach(function (entry, index) {
	          var prev = prevSectors && prevSectors[index];
	          var paddingAngle = index > 0 ? (0, _get2["default"])(entry, 'paddingAngle', 0) : 0;
	
	          if (prev) {
	            var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	
	            var latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + angleIp(t) + paddingAngle
	            });
	
	            stepData.push(latest);
	            curAngle = latest.endAngle;
	          } else {
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	            var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	            var deltaAngle = interpolatorAngle(t);
	
	            var _latest = _objectSpread({}, entry, {
	              startAngle: curAngle + paddingAngle,
	              endAngle: curAngle + deltaAngle + paddingAngle
	            });
	
	            stepData.push(_latest);
	            curAngle = _latest.endAngle;
	          }
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this4.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          sectors = _this$props5.sectors,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual2["default"])(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          sectors = _this$props6.sectors,
	          className = _this$props6.className,
	          label = _this$props6.label,
	          cx = _this$props6.cx,
	          cy = _this$props6.cy,
	          innerRadius = _this$props6.innerRadius,
	          outerRadius = _this$props6.outerRadius,
	          isAnimationActive = _this$props6.isAnimationActive,
	          prevSectors = _this$props6.prevSectors;
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-pie', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderSectors(), label && this.renderLabels(sectors), _Label["default"].renderCallByParent(this.props, null, false), (!isAnimationActive || prevSectors && (0, _isEqual2["default"])(prevSectors, sectors)) && _LabelList["default"].renderCallByParent(this.props, sectors, false));
	    }
	  }], [{
	    key: "getTextAnchor",
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      }
	
	      if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: "renderLabelLineItem",
	    value: function renderLabelLineItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Curve["default"], _extends({}, props, {
	        type: "linear",
	        className: "recharts-pie-label-line"
	      }));
	    }
	  }, {
	    key: "renderLabelItem",
	    value: function renderLabelItem(option, props, value) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      var label = value;
	
	      if ((0, _isFunction2["default"])(option)) {
	        label = option(props);
	
	        if (_react["default"].isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react["default"].createElement(_Text["default"], _extends({}, props, {
	        alignmentBaseline: "middle",
	        className: "recharts-pie-label-text"
	      }), label);
	    }
	  }, {
	    key: "renderSectorItem",
	    value: function renderSectorItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      if ((0, _isPlainObject2["default"])(option)) {
	        return _react["default"].createElement(_Sector["default"], _extends({}, props, option));
	      }
	
	      return _react["default"].createElement(_Sector["default"], props);
	    }
	  }]);
	
	  return Pie;
	}(_react.PureComponent);
	
	Pie.displayName = 'Pie';
	Pie.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  animationId: _propTypes["default"].number,
	  cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  startAngle: _propTypes["default"].number,
	  endAngle: _propTypes["default"].number,
	  paddingAngle: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  valueKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  data: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  blendStroke: _propTypes["default"].bool,
	  minAngle: _propTypes["default"].number,
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  maxRadius: _propTypes["default"].number,
	  sectors: _propTypes["default"].arrayOf(_propTypes["default"].object),
	  hide: _propTypes["default"].bool,
	  labelLine: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].shape({
	    offsetRadius: _propTypes["default"].number
	  }), _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].bool]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].arrayOf(_propTypes["default"].number)]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
	  id: _propTypes["default"].string
	});
	Pie.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name',
	  // Match each sector's stroke color to it's fill color
	  blendStroke: false
	};
	
	Pie.parseDeltaAngle = function (_ref2) {
	  var startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	  return sign * deltaAngle;
	};
	
	Pie.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _objectSpread({
	        payload: entry
	      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _objectSpread({}, presentationProps, {}, cell.props);
	    });
	  }
	
	  return [];
	};
	
	Pie.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	  return {
	    cx: cx,
	    cy: cy,
	    innerRadius: innerRadius,
	    outerRadius: outerRadius,
	    maxRadius: maxRadius
	  };
	};
	
	Pie.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      offset = _ref3.offset,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter;
	  var pieData = Pie.getRealPieData(item);
	
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey,
	      tooltipType = _item$props2.tooltipType;
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({
	    startAngle: startAngle,
	    endAngle: endAngle
	  });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil2["default"])(dataKey) && (0, _isNil2["default"])(valueKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = 'value';
	  } else if ((0, _isNil2["default"])(dataKey)) {
	    (0, _LogUtils.warn)(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors;
	
	  if (sum > 0) {
	    var prev;
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{
	        name: name,
	        value: val,
	        payload: entry,
	        dataKey: realDataKey,
	        type: tooltipType
	      }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	      prev = _objectSpread({
	        percent: percent,
	        cornerRadius: cornerRadius,
	        name: name,
	        tooltipPayload: tooltipPayload,
	        midAngle: midAngle,
	        middleRadius: middleRadius,
	        tooltipPosition: tooltipPosition
	      }, entry, {}, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry,
	        paddingAngle: (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle
	      });
	      return prev;
	    });
	  }
	
	  return _objectSpread({}, coordinate, {
	    sectors: sectors,
	    data: pieData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	};
	
	var _default = Pie;
	exports["default"] = _default;

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(19);
	
	var _PolarUtils = __webpack_require__(97);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _Polygon = _interopRequireDefault(__webpack_require__(309));
	
	var _Dot = _interopRequireDefault(__webpack_require__(160));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Radar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Radar, _PureComponent);
	
	  function Radar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (points) {
	      _this.setState({
	        prevPoints: points
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    };
	
	    _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Radar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          points = _this$props.points;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: "renderDots",
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          dot = _this$props2.dot,
	          dataKey = _this$props2.dataKey;
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _objectSpread({
	          key: "dot-".concat(i),
	          r: 3
	        }, baseProps, {}, customDotProps, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          payload: entry
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-dots"
	      }, dots);
	    }
	  }, {
	    key: "renderPolygonStatically",
	    value: function renderPolygonStatically(points) {
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          dot = _this$props3.dot;
	      var radar;
	
	      if (_react["default"].isValidElement(shape)) {
	        radar = _react["default"].cloneElement(shape, _objectSpread({}, this.props, {
	          points: points
	        }));
	      } else if ((0, _isFunction2["default"])(shape)) {
	        radar = shape(_objectSpread({}, this.props, {
	          points: points
	        }));
	      } else {
	        radar = _react["default"].createElement(_Polygon["default"], _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radar-polygon"
	      }, radar, dot ? this.renderDots(points) : null);
	    }
	  }, {
	    key: "renderPolygonWithAnimation",
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          points = _this$props4.points,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevPoints = this.state.prevPoints;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radar-".concat(animationId),
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart
	      }, function (_ref) {
	        var t = _ref.t;
	        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
	        var stepData = points.map(function (entry, index) {
	          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];
	
	          if (prev) {
	            var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	
	            var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	            return _objectSpread({}, entry, {
	              x: _interpolatorX(t),
	              y: _interpolatorY(t)
	            });
	          }
	
	          var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	          var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	          return _objectSpread({}, entry, {
	            x: interpolatorX(t),
	            y: interpolatorY(t)
	          });
	        });
	        return _this3.renderPolygonStatically(stepData);
	      });
	    }
	  }, {
	    key: "renderPolygon",
	    value: function renderPolygon() {
	      var _this$props5 = this.props,
	          points = _this$props5.points,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual2["default"])(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          className = _this$props6.className,
	          points = _this$props6.points,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-radar', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(this.props, points));
	    }
	  }], [{
	    key: "renderDotItem",
	    value: function renderDotItem(option, props) {
	      var dotItem;
	
	      if (_react["default"].isValidElement(option)) {
	        dotItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react["default"].createElement(_Dot["default"], _extends({}, props, {
	          className: "recharts-radar-dot"
	        }));
	      }
	
	      return dotItem;
	    }
	  }]);
	
	  return Radar;
	}(_react.PureComponent);
	
	Radar.displayName = 'Radar';
	Radar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].func]).isRequired,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  points: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    x: _propTypes["default"].number,
	    y: _propTypes["default"].number,
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    angle: _propTypes["default"].number,
	    radius: _propTypes["default"].number,
	    value: _propTypes["default"].number,
	    payload: _propTypes["default"].object
	  })),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  activeDot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  // whether have dot in poly line
	  dot: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].bool]),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationId: _propTypes["default"].number,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Radar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	
	Radar.getComposedData = function (_ref2) {
	  var radiusAxis = _ref2.radiusAxis,
	      angleAxis = _ref2.angleAxis,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name) + (bandSize || 0);
	    var radius = radiusAxis.scale(value);
	    return _objectSpread({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name,
	      value: value,
	      cx: cx,
	      cy: cy,
	      radius: radius,
	      angle: angle,
	      payload: entry
	    });
	  });
	  return {
	    points: points
	  };
	};
	
	var _default = Radar;
	exports["default"] = _default;

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(101));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _Sector = _interopRequireDefault(__webpack_require__(310));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _LabelList = _interopRequireDefault(__webpack_require__(115));
	
	var _Cell = _interopRequireDefault(__webpack_require__(190));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var RadialBar =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(RadialBar, _PureComponent);
	
	  function RadialBar() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isAnimationFinished: false
	    };
	
	    _this.cachePrevData = function (data) {
	      _this.setState({
	        prevData: data
	      });
	    };
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(RadialBar, [{
	    key: "componentWillReceiveProps",
	    // eslint-disable-next-line camelcase
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          animationId = _this$props.animationId,
	          data = _this$props.data;
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: "getDeltaAngle",
	    value: function getDeltaAngle() {
	      var _this$props2 = this.props,
	          startAngle = _this$props2.startAngle,
	          endAngle = _this$props2.endAngle;
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	      return sign * deltaAngle;
	    }
	  }, {
	    key: "renderSectorsStatically",
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          shape = _this$props3.shape,
	          activeShape = _this$props3.activeShape,
	          activeIndex = _this$props3.activeIndex,
	          cornerRadius = _this$props3.cornerRadius,
	          others = _objectWithoutProperties(_this$props3, ["shape", "activeShape", "activeIndex", "cornerRadius"]);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      return sectors.map(function (entry, i) {
	        var props = _objectSpread({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, {}, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-sector',
	          forceCornerRadius: others.forceCornerRadius,
	          cornerIsExternal: others.cornerIsExternal
	        });
	
	        return _this2.constructor.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: "renderSectorsWithAnimation",
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _this$props4 = this.props,
	          data = _this$props4.data,
	          isAnimationActive = _this$props4.isAnimationActive,
	          animationBegin = _this$props4.animationBegin,
	          animationDuration = _this$props4.animationDuration,
	          animationEasing = _this$props4.animationEasing,
	          animationId = _this$props4.animationId;
	      var prevData = this.state.prevData;
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        from: {
	          t: 0
	        },
	        to: {
	          t: 1
	        },
	        key: "radialBar-".concat(animationId),
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref) {
	        var t = _ref.t;
	        var stepData = data.map(function (entry, index) {
	          var prev = prevData && prevData[index];
	
	          if (prev) {
	            var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	            var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	            return _objectSpread({}, entry, {
	              startAngle: interpolatorStartAngle(t),
	              endAngle: interpolatorEndAngle(t)
	            });
	          }
	
	          var endAngle = entry.endAngle,
	              startAngle = entry.startAngle;
	          var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	          return _objectSpread({}, entry, {
	            endAngle: interpolator(t)
	          });
	        });
	        return _react["default"].createElement(_Layer["default"], null, _this3.renderSectorsStatically(stepData));
	      });
	    }
	  }, {
	    key: "renderSectors",
	    value: function renderSectors() {
	      var _this$props5 = this.props,
	          data = _this$props5.data,
	          isAnimationActive = _this$props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual2["default"])(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ["value", "background"]);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _objectSpread({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, {}, backgroundProps, {}, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: "sector-".concat(i),
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.constructor.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          hide = _this$props6.hide,
	          data = _this$props6.data,
	          className = _this$props6.className,
	          background = _this$props6.background,
	          isAnimationActive = _this$props6.isAnimationActive;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var layerClass = (0, _classnames["default"])('recharts-area', className);
	      return _react["default"].createElement(_Layer["default"], {
	        className: layerClass
	      }, background && _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-background"
	      }, this.renderBackground(data)), _react["default"].createElement(_Layer["default"], {
	        className: "recharts-radial-bar-sectors"
	      }, this.renderSectors(data)), (!isAnimationActive || isAnimationFinished) && _LabelList["default"].renderCallByParent(_objectSpread({}, this.props, {
	        clockWise: this.getDeltaAngle() < 0
	      }), data));
	    }
	  }], [{
	    key: "renderSectorShape",
	    value: function renderSectorShape(shape, props) {
	      var sectorShape;
	
	      if (_react["default"].isValidElement(shape)) {
	        sectorShape = _react["default"].cloneElement(shape, props);
	      } else if ((0, _isFunction2["default"])(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react["default"].createElement(_Sector["default"], props);
	      }
	
	      return sectorShape;
	    }
	  }]);
	
	  return RadialBar;
	}(_react.PureComponent);
	
	RadialBar.displayName = 'RadialBar';
	RadialBar.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  angleAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  radiusAxisId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  shape: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element]),
	  activeShape: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func, _propTypes["default"].element]),
	  activeIndex: _propTypes["default"].number,
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]).isRequired,
	  cornerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  forceCornerRadius: _propTypes["default"].bool,
	  cornerIsExternal: _propTypes["default"].bool,
	  minPointSize: _propTypes["default"].number,
	  maxBarSize: _propTypes["default"].number,
	  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    cx: _propTypes["default"].number,
	    cy: _propTypes["default"].number,
	    innerRadius: _propTypes["default"].number,
	    outerRadius: _propTypes["default"].number,
	    value: _propTypes["default"].value
	  })),
	  legendType: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES),
	  tooltipType: _propTypes["default"].oneOf(_ReactUtils.TOOLTIP_TYPES),
	  label: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].object]),
	  background: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func, _propTypes["default"].object, _propTypes["default"].element]),
	  hide: _propTypes["default"].bool,
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	});
	RadialBar.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  forceCornerRadius: false,
	  cornerIsExternal: false
	};
	
	RadialBar.getComposedData = function (_ref2) {
	  var item = _ref2.item,
	      props = _ref2.props,
	      radiusAxis = _ref2.radiusAxis,
	      radiusAxisTicks = _ref2.radiusAxisTicks,
	      angleAxis = _ref2.angleAxis,
	      angleAxisTicks = _ref2.angleAxisTicks,
	      displayedData = _ref2.displayedData,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData,
	      barPosition = _ref2.barPosition,
	      bandSize = _ref2.bandSize,
	      dataStartIndex = _ref2.dataStartIndex;
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({
	    props: props,
	    numericAxis: numericAxis
	  });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell["default"]);
	  var sectors = displayedData.map(function (entry, index) {
	    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray2["default"])(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	        endAngle += delta;
	      }
	
	      backgroundSector = {
	        background: {
	          cx: cx,
	          cy: cy,
	          innerRadius: innerRadius,
	          outerRadius: outerRadius,
	          startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	
	        outerRadius += _delta;
	      }
	    }
	
	    return _objectSpread({}, entry, {}, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx,
	      cy: cy,
	      innerRadius: innerRadius,
	      outerRadius: outerRadius,
	      startAngle: startAngle,
	      endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	  return {
	    data: sectors,
	    layout: layout
	  };
	};
	
	var _default = RadialBar;
	exports["default"] = _default;

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Cross =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Cross, _PureComponent);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Cross).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          width = _this$props.width,
	          height = _this$props.height,
	          top = _this$props.top,
	          left = _this$props.left,
	          className = _this$props.className;
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames["default"])('recharts-cross', className),
	        d: this.constructor.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }], [{
	    key: "getPath",
	    value: function getPath(x, y, width, height, top, left) {
	      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
	    }
	  }]);
	
	  return Cross;
	}(_react.PureComponent);
	
	Cross.displayName = 'Cross';
	Cross.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  top: _propTypes["default"].number,
	  left: _propTypes["default"].number,
	  className: _propTypes["default"].string
	});
	Cross.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	};
	var _default = Cross;
	exports["default"] = _default;

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
	  var widthGap = upperWidth - lowerWidth;
	  var path;
	  path = "M ".concat(x, ",").concat(y);
	  path += "L ".concat(x + upperWidth, ",").concat(y);
	  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
	  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
	  path += "L ".concat(x, ",").concat(y, " Z");
	  return path;
	};
	
	var Trapezoid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Trapezoid, _PureComponent);
	
	  function Trapezoid() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Trapezoid);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Trapezoid)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      totalLength: -1
	    };
	    return _this;
	  }
	
	  _createClass(Trapezoid, [{
	    key: "componentDidMount",
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {// calculate total length error
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          y = _this$props.y,
	          upperWidth = _this$props.upperWidth,
	          lowerWidth = _this$props.lowerWidth,
	          height = _this$props.height,
	          className = _this$props.className;
	      var totalLength = this.state.totalLength;
	      var _this$props2 = this.props,
	          animationEasing = _this$props2.animationEasing,
	          animationDuration = _this$props2.animationDuration,
	          animationBegin = _this$props2.animationBegin,
	          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
	
	      if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames["default"])('recharts-trapezoid', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react["default"].createElement("g", null, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
	        })));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        canBegin: totalLength > 0,
	        from: {
	          upperWidth: 0,
	          lowerWidth: 0,
	          height: height,
	          x: x,
	          y: y
	        },
	        to: {
	          upperWidth: upperWidth,
	          lowerWidth: lowerWidth,
	          height: height,
	          x: x,
	          y: y
	        },
	        duration: animationDuration,
	        animationEasing: animationEasing,
	        isActive: isUpdateAnimationActive
	      }, function (_ref) {
	        var currUpperWidth = _ref.upperWidth,
	            currLowerWidth = _ref.lowerWidth,
	            currHeight = _ref.height,
	            currX = _ref.x,
	            currY = _ref.y;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          canBegin: totalLength > 0,
	          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
	          to: "".concat(totalLength, "px 0px"),
	          attributeName: "strokeDasharray",
	          begin: animationBegin,
	          duration: animationDuration,
	          easing: animationEasing
	        }, _react["default"].createElement("path", _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	          className: layerClass,
	          d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
	          ref: function ref(node) {
	            _this2.node = node;
	          }
	        })));
	      });
	    }
	  }]);
	
	  return Trapezoid;
	}(_react.PureComponent);
	
	Trapezoid.displayName = 'Trapezoid';
	Trapezoid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes["default"].string,
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  upperWidth: _propTypes["default"].number,
	  lowerWidth: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	});
	Trapezoid.defaultProps = {
	  x: 0,
	  y: 0,
	  upperWidth: 0,
	  lowerWidth: 0,
	  height: 0,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	};
	var _default = Trapezoid;
	exports["default"] = _default;

/***/ },
/* 774 */
/***/ function(module, exports) {

	function _arrayLikeToArray(arr, len) {
	  if (len == null || len > arr.length) len = arr.length;
	  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
	  return arr2;
	}
	module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var unsupportedIterableToArray = __webpack_require__(780);
	function _createForOfIteratorHelper(o, allowArrayLike) {
	  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
	  if (!it) {
	    if (Array.isArray(o) || (it = unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
	      if (it) o = it;
	      var i = 0;
	      var F = function F() {};
	      return {
	        s: F,
	        n: function n() {
	          if (i >= o.length) return {
	            done: true
	          };
	          return {
	            done: false,
	            value: o[i++]
	          };
	        },
	        e: function e(_e) {
	          throw _e;
	        },
	        f: F
	      };
	    }
	    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	  }
	  var normalCompletion = true,
	    didErr = false,
	    err;
	  return {
	    s: function s() {
	      it = it.call(o);
	    },
	    n: function n() {
	      var step = it.next();
	      normalCompletion = step.done;
	      return step;
	    },
	    e: function e(_e2) {
	      didErr = true;
	      err = _e2;
	    },
	    f: function f() {
	      try {
	        if (!normalCompletion && it["return"] != null) it["return"]();
	      } finally {
	        if (didErr) throw err;
	      }
	    }
	  };
	}
	module.exports = _createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 776 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 777 */
/***/ function(module, exports) {

	function _isNativeReflectConstruct() {
	  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	  if (Reflect.construct.sham) return false;
	  if (typeof Proxy === "function") return true;
	  try {
	    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	    return true;
	  } catch (e) {
	    return false;
	  }
	}
	module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(84)["default"];
	var assertThisInitialized = __webpack_require__(24);
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return assertThisInitialized(self);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(84)["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeToArray = __webpack_require__(774);
	function _unsupportedIterableToArray(o, minLen) {
	  if (!o) return;
	  if (typeof o === "string") return arrayLikeToArray(o, minLen);
	  var n = Object.prototype.toString.call(o).slice(8, -1);
	  if (n === "Object" && o.constructor) n = o.constructor.name;
	  if (n === "Map" || n === "Set") return Array.from(o);
	  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(449);
	var React = __webpack_require__(1);
	var createCache = __webpack_require__(452);
	var utils = __webpack_require__(454);
	var serialize = __webpack_require__(314);
	
	function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }
	
	var createCache__default = /*#__PURE__*/_interopDefault(createCache);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var EmotionCacheContext = /*#__PURE__*/React.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
	// because this module is primarily intended for the browser and node
	// but it's also required in react native and similar environments sometimes
	// and we could have a special build just for that
	// but this is much easier and the native packages
	// might use a different theme context in the future anyway
	typeof HTMLElement !== 'undefined' ? createCache__default['default']() : null);
	var ThemeContext = /*#__PURE__*/React.createContext({});
	var CacheProvider = EmotionCacheContext.Provider;
	
	var withEmotionCache = function withEmotionCache(func) {
	  var render = function render(props, ref) {
	    return /*#__PURE__*/React.createElement(EmotionCacheContext.Consumer, null, function (cache) {
	      return func(props, cache, ref);
	    });
	  }; // $FlowFixMe
	
	
	  return /*#__PURE__*/React.forwardRef(render);
	};
	
	// thus we only need to replace what is a valid character for JS, but not for CSS
	
	var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
	  return identifier.replace(/\$/g, '-');
	};
	
	var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
	var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
	var createEmotionProps = function createEmotionProps(type, props) {
	  if (false) {
	    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
	  }
	
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps[typePropName] = type; // TODO: check if this still works with all of those different JSX functions
	
	  if (false) {
	    var error = new Error();
	
	    if (error.stack) {
	      // chrome
	      var match = error.stack.match(/at (?:Object\.|Module\.|)(?:jsx|createEmotionProps).*\n\s+at (?:Object\.|)([A-Z][A-Za-z$]+) /);
	
	      if (!match) {
	        // safari and firefox
	        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
	      }
	
	      if (match) {
	        newProps[labelPropName] = sanitizeIdentifier(match[1]);
	      }
	    }
	  }
	
	  return newProps;
	};
	
	var Noop = function Noop() {
	  return null;
	};
	
	var render = function render(cache, props, theme, ref) {
	  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
	  // not passing the registered cache to serializeStyles because it would
	  // make certain babel optimisations not possible
	
	  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
	    cssProp = cache.registered[cssProp];
	  }
	
	  var type = props[typePropName];
	  var registeredStyles = [cssProp];
	  var className = '';
	
	  if (typeof props.className === 'string') {
	    className = utils.getRegisteredStyles(cache.registered, registeredStyles, props.className);
	  } else if (props.className != null) {
	    className = props.className + " ";
	  }
	
	  var serialized = serialize.serializeStyles(registeredStyles);
	
	  if (false) {
	    var labelFromStack = props[labelPropName];
	
	    if (labelFromStack) {
	      serialized = serialize.serializeStyles([serialized, 'label:' + labelFromStack + ';']);
	    }
	  }
	
	  var rules = utils.insertStyles(cache, serialized, typeof type === 'string');
	  className += cache.key + "-" + serialized.name;
	  var newProps = {};
	
	  for (var key in props) {
	    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (("production") === 'production' || key !== labelPropName)) {
	      newProps[key] = props[key];
	    }
	  }
	
	  newProps.ref = ref;
	  newProps.className = className;
	  var ele = /*#__PURE__*/React.createElement(type, newProps);
	  var possiblyStyleElement = /*#__PURE__*/React.createElement(Noop, null);
	
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, possiblyStyleElement, ele);
	}; // eslint-disable-next-line no-undef
	
	
	var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
	  if (typeof props.css === 'function') {
	    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
	      return render(cache, props, theme, ref);
	    });
	  }
	
	  return render(cache, props, null, ref);
	});
	
	if (false) {
	  Emotion.displayName = 'EmotionCssPropInternal';
	}
	
	exports.CacheProvider = CacheProvider;
	exports.Emotion = Emotion;
	exports.ThemeContext = ThemeContext;
	exports.createEmotionProps = createEmotionProps;
	exports.hasOwnProperty = hasOwnProperty;
	exports.withEmotionCache = withEmotionCache;


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var serialize = __webpack_require__(314);
	
	function css() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return serialize.serializeStyles(args);
	}
	
	exports.default = css;


/***/ },
/* 783 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/* eslint-disable */
	// Inspired by https://github.com/garycourt/murmurhash-js
	// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
	function murmur2(str) {
	  // 'm' and 'r' are mixing constants generated offline.
	  // They're not really 'magic', they just happen to work well.
	  // const m = 0x5bd1e995;
	  // const r = 24;
	  // Initialize the hash
	  var h = 0; // Mix 4 bytes at a time into the hash
	
	  var k,
	      i = 0,
	      len = str.length;
	
	  for (; len >= 4; ++i, len -= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	    k =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
	    k ^=
	    /* k >>> r: */
	    k >>> 24;
	    h =
	    /* Math.imul(k, m): */
	    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
	    /* Math.imul(h, m): */
	    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Handle the last few bytes of the input array
	
	
	  switch (len) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h =
	      /* Math.imul(h, m): */
	      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  } // Do a few final mixes of the hash to ensure the last few
	  // bytes are well-incorporated.
	
	
	  h ^= h >>> 13;
	  h =
	  /* Math.imul(h, m): */
	  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
	  return ((h ^ h >>> 15) >>> 0).toString(36);
	}
	
	exports.default = murmur2;


/***/ },
/* 784 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) cache[arg] = fn(arg);
	    return cache[arg];
	  };
	}
	
	exports.default = memoize;


/***/ },
/* 785 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function stylis_min (W) {
	  function M(d, c, e, h, a) {
	    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
	      g = e.charCodeAt(l);
	      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
	
	      if (0 === b + n + v + m) {
	        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
	          switch (g) {
	            case 32:
	            case 9:
	            case 59:
	            case 13:
	            case 10:
	              break;
	
	            default:
	              f += e.charAt(l);
	          }
	
	          g = 59;
	        }
	
	        switch (g) {
	          case 123:
	            f = f.trim();
	            q = f.charCodeAt(0);
	            k = 1;
	
	            for (t = ++l; l < B;) {
	              switch (g = e.charCodeAt(l)) {
	                case 123:
	                  k++;
	                  break;
	
	                case 125:
	                  k--;
	                  break;
	
	                case 47:
	                  switch (g = e.charCodeAt(l + 1)) {
	                    case 42:
	                    case 47:
	                      a: {
	                        for (u = l + 1; u < J; ++u) {
	                          switch (e.charCodeAt(u)) {
	                            case 47:
	                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                              break;
	
	                            case 10:
	                              if (47 === g) {
	                                l = u + 1;
	                                break a;
	                              }
	
	                          }
	                        }
	
	                        l = u;
	                      }
	
	                  }
	
	                  break;
	
	                case 91:
	                  g++;
	
	                case 40:
	                  g++;
	
	                case 34:
	                case 39:
	                  for (; l++ < J && e.charCodeAt(l) !== g;) {
	                  }
	
	              }
	
	              if (0 === k) break;
	              l++;
	            }
	
	            k = e.substring(t, l);
	            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
	
	            switch (q) {
	              case 64:
	                0 < r && (f = f.replace(N, ''));
	                g = f.charCodeAt(1);
	
	                switch (g) {
	                  case 100:
	                  case 109:
	                  case 115:
	                  case 45:
	                    r = c;
	                    break;
	
	                  default:
	                    r = O;
	                }
	
	                k = M(c, r, k, g, a + 1);
	                t = k.length;
	                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
	                if (0 < t) switch (g) {
	                  case 115:
	                    f = f.replace(da, ea);
	
	                  case 100:
	                  case 109:
	                  case 45:
	                    k = f + '{' + k + '}';
	                    break;
	
	                  case 107:
	                    f = f.replace(fa, '$1 $2');
	                    k = f + '{' + k + '}';
	                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
	                    break;
	
	                  default:
	                    k = f + k, 112 === h && (k = (p += k, ''));
	                } else k = '';
	                break;
	
	              default:
	                k = M(c, X(c, f, I), k, h, a + 1);
	            }
	
	            F += k;
	            k = I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	            break;
	
	          case 125:
	          case 59:
	            f = (0 < r ? f.replace(N, '') : f).trim();
	            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
	              case 0:
	                break;
	
	              case 64:
	                if (105 === g || 99 === g) {
	                  G += f + e.charAt(l);
	                  break;
	                }
	
	              default:
	                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
	            }
	            I = r = u = q = 0;
	            f = '';
	            g = e.charCodeAt(++l);
	        }
	      }
	
	      switch (g) {
	        case 13:
	        case 10:
	          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
	          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
	          z = 1;
	          D++;
	          break;
	
	        case 59:
	        case 125:
	          if (0 === b + n + v + m) {
	            z++;
	            break;
	          }
	
	        default:
	          z++;
	          y = e.charAt(l);
	
	          switch (g) {
	            case 9:
	            case 32:
	              if (0 === n + m + b) switch (x) {
	                case 44:
	                case 58:
	                case 9:
	                case 32:
	                  y = '';
	                  break;
	
	                default:
	                  32 !== g && (y = ' ');
	              }
	              break;
	
	            case 0:
	              y = '\\0';
	              break;
	
	            case 12:
	              y = '\\f';
	              break;
	
	            case 11:
	              y = '\\v';
	              break;
	
	            case 38:
	              0 === n + b + m && (r = I = 1, y = '\f' + y);
	              break;
	
	            case 108:
	              if (0 === n + b + m + E && 0 < u) switch (l - u) {
	                case 2:
	                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
	
	                case 8:
	                  111 === K && (E = K);
	              }
	              break;
	
	            case 58:
	              0 === n + b + m && (u = l);
	              break;
	
	            case 44:
	              0 === b + v + n + m && (r = 1, y += '\r');
	              break;
	
	            case 34:
	            case 39:
	              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
	              break;
	
	            case 91:
	              0 === n + b + v && m++;
	              break;
	
	            case 93:
	              0 === n + b + v && m--;
	              break;
	
	            case 41:
	              0 === n + b + m && v--;
	              break;
	
	            case 40:
	              if (0 === n + b + m) {
	                if (0 === q) switch (2 * x + 3 * K) {
	                  case 533:
	                    break;
	
	                  default:
	                    q = 1;
	                }
	                v++;
	              }
	
	              break;
	
	            case 64:
	              0 === b + v + n + m + u + k && (k = 1);
	              break;
	
	            case 42:
	            case 47:
	              if (!(0 < n + m + v)) switch (b) {
	                case 0:
	                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
	                    case 235:
	                      b = 47;
	                      break;
	
	                    case 220:
	                      t = l, b = 42;
	                  }
	
	                  break;
	
	                case 42:
	                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
	              }
	          }
	
	          0 === b && (f += y);
	      }
	
	      K = x;
	      x = g;
	      l++;
	    }
	
	    t = p.length;
	
	    if (0 < t) {
	      r = c;
	      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
	      p = r.join(',') + '{' + p + '}';
	
	      if (0 !== w * E) {
	        2 !== w || L(p, 2) || (E = 0);
	
	        switch (E) {
	          case 111:
	            p = p.replace(ha, ':-moz-$1') + p;
	            break;
	
	          case 112:
	            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
	        }
	
	        E = 0;
	      }
	    }
	
	    return G + p + F;
	  }
	
	  function X(d, c, e) {
	    var h = c.trim().split(ia);
	    c = h;
	    var a = h.length,
	        m = d.length;
	
	    switch (m) {
	      case 0:
	      case 1:
	        var b = 0;
	
	        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
	          c[b] = Z(d, c[b], e).trim();
	        }
	
	        break;
	
	      default:
	        var v = b = 0;
	
	        for (c = []; b < a; ++b) {
	          for (var n = 0; n < m; ++n) {
	            c[v++] = Z(d[n] + ' ', h[b], e).trim();
	          }
	        }
	
	    }
	
	    return c;
	  }
	
	  function Z(d, c, e) {
	    var h = c.charCodeAt(0);
	    33 > h && (h = (c = c.trim()).charCodeAt(0));
	
	    switch (h) {
	      case 38:
	        return c.replace(F, '$1' + d.trim());
	
	      case 58:
	        return d.trim() + c.replace(F, '$1' + d.trim());
	
	      default:
	        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
	    }
	
	    return d + c;
	  }
	
	  function P(d, c, e, h) {
	    var a = d + ';',
	        m = 2 * c + 3 * e + 4 * h;
	
	    if (944 === m) {
	      d = a.indexOf(':', 9) + 1;
	      var b = a.substring(d, a.length - 1).trim();
	      b = a.substring(0, d).trim() + b + ';';
	      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
	    }
	
	    if (0 === w || 2 === w && !L(a, 1)) return a;
	
	    switch (m) {
	      case 1015:
	        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
	
	      case 951:
	        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
	
	      case 963:
	        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
	
	      case 1009:
	        if (100 !== a.charCodeAt(4)) break;
	
	      case 969:
	      case 942:
	        return '-webkit-' + a + a;
	
	      case 978:
	        return '-webkit-' + a + '-moz-' + a + a;
	
	      case 1019:
	      case 983:
	        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
	
	      case 883:
	        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
	        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
	        break;
	
	      case 932:
	        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
	          case 103:
	            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
	
	          case 98:
	            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
	        }
	        return '-webkit-' + a + '-ms-' + a + a;
	
	      case 964:
	        return '-webkit-' + a + '-ms-flex-' + a + a;
	
	      case 1023:
	        if (99 !== a.charCodeAt(8)) break;
	        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
	        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
	
	      case 1005:
	        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
	
	      case 1e3:
	        b = a.substring(13).trim();
	        c = b.indexOf('-') + 1;
	
	        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
	          case 226:
	            b = a.replace(G, 'tb');
	            break;
	
	          case 232:
	            b = a.replace(G, 'tb-rl');
	            break;
	
	          case 220:
	            b = a.replace(G, 'lr');
	            break;
	
	          default:
	            return a;
	        }
	
	        return '-webkit-' + a + '-ms-' + b + a;
	
	      case 1017:
	        if (-1 === a.indexOf('sticky', 9)) break;
	
	      case 975:
	        c = (a = d).length - 10;
	        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
	
	        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
	          case 203:
	            if (111 > b.charCodeAt(8)) break;
	
	          case 115:
	            a = a.replace(b, '-webkit-' + b) + ';' + a;
	            break;
	
	          case 207:
	          case 102:
	            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
	        }
	
	        return a + ';';
	
	      case 938:
	        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
	          case 105:
	            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
	
	          case 115:
	            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
	
	          default:
	            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
	        }
	        break;
	
	      case 973:
	      case 989:
	        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
	
	      case 931:
	      case 953:
	        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
	        break;
	
	      case 962:
	        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
	    }
	
	    return a;
	  }
	
	  function L(d, c) {
	    var e = d.indexOf(1 === c ? ':' : '{'),
	        h = d.substring(0, 3 !== c ? e : 10);
	    e = d.substring(e + 1, d.length - 1);
	    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
	  }
	
	  function ea(d, c) {
	    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
	    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
	  }
	
	  function H(d, c, e, h, a, m, b, v, n, q) {
	    for (var g = 0, x = c, w; g < A; ++g) {
	      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
	        case void 0:
	        case !1:
	        case !0:
	        case null:
	          break;
	
	        default:
	          x = w;
	      }
	    }
	
	    if (x !== c) return x;
	  }
	
	  function T(d) {
	    switch (d) {
	      case void 0:
	      case null:
	        A = S.length = 0;
	        break;
	
	      default:
	        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
	          T(d[c]);
	        } else Y = !!d | 0;
	    }
	
	    return T;
	  }
	
	  function U(d) {
	    d = d.prefix;
	    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
	    return U;
	  }
	
	  function B(d, c) {
	    var e = d;
	    33 > e.charCodeAt(0) && (e = e.trim());
	    V = e;
	    e = [V];
	
	    if (0 < A) {
	      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
	      void 0 !== h && 'string' === typeof h && (c = h);
	    }
	
	    var a = M(O, e, c, 0, 0);
	    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
	    V = '';
	    E = 0;
	    z = D = 1;
	    return a;
	  }
	
	  var ca = /^\0+/g,
	      N = /[\0\r\f]/g,
	      aa = /: */g,
	      ka = /zoo|gra/,
	      ma = /([,: ])(transform)/g,
	      ia = /,\r+?/g,
	      F = /([\t\r\n ])*\f?&/g,
	      fa = /@(k\w+)\s*(\S*)\s*/,
	      Q = /::(place)/g,
	      ha = /:(read-only)/g,
	      G = /[svh]\w+-[tblr]{2}/,
	      da = /\(\s*(.*)\s*\)/g,
	      oa = /([\s\S]*?);/g,
	      ba = /-self|flex-/g,
	      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
	      la = /stretch|:\s*\w+\-(?:conte|avail)/,
	      ja = /([^-])(image-set\()/,
	      z = 1,
	      D = 1,
	      E = 0,
	      w = 1,
	      O = [],
	      S = [],
	      A = 0,
	      R = null,
	      Y = 0,
	      V = '';
	  B.use = T;
	  B.set = U;
	  void 0 !== W && U(W);
	  return B;
	}
	
	exports.default = stylis_min;


/***/ },
/* 786 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var unitlessKeys = {
	  animationIterationCount: 1,
	  borderImageOutset: 1,
	  borderImageSlice: 1,
	  borderImageWidth: 1,
	  boxFlex: 1,
	  boxFlexGroup: 1,
	  boxOrdinalGroup: 1,
	  columnCount: 1,
	  columns: 1,
	  flex: 1,
	  flexGrow: 1,
	  flexPositive: 1,
	  flexShrink: 1,
	  flexNegative: 1,
	  flexOrder: 1,
	  gridRow: 1,
	  gridRowEnd: 1,
	  gridRowSpan: 1,
	  gridRowStart: 1,
	  gridColumn: 1,
	  gridColumnEnd: 1,
	  gridColumnSpan: 1,
	  gridColumnStart: 1,
	  msGridRow: 1,
	  msGridRowSpan: 1,
	  msGridColumn: 1,
	  msGridColumnSpan: 1,
	  fontWeight: 1,
	  lineHeight: 1,
	  opacity: 1,
	  order: 1,
	  orphans: 1,
	  tabSize: 1,
	  widows: 1,
	  zIndex: 1,
	  zoom: 1,
	  WebkitLineClamp: 1,
	  // SVG-related properties
	  fillOpacity: 1,
	  floodOpacity: 1,
	  stopOpacity: 1,
	  strokeDasharray: 1,
	  strokeDashoffset: 1,
	  strokeMiterlimit: 1,
	  strokeOpacity: 1,
	  strokeWidth: 1
	};
	
	exports.default = unitlessKeys;


/***/ },
/* 787 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var weakMemoize = function weakMemoize(func) {
	  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
	  var cache = new WeakMap();
	  return function (arg) {
	    if (cache.has(arg)) {
	      // $FlowFixMe
	      return cache.get(arg);
	    }
	
	    var ret = func(arg);
	    cache.set(arg, ret);
	    return ret;
	  };
	};
	
	exports.default = weakMemoize;


/***/ },
/* 788 */
/***/ function(module, exports) {

	/**
	 * @popperjs/core v2.11.8 - MIT License
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function getWindow(node) {
	  if (node == null) {
	    return window;
	  }
	
	  if (node.toString() !== '[object Window]') {
	    var ownerDocument = node.ownerDocument;
	    return ownerDocument ? ownerDocument.defaultView || window : window;
	  }
	
	  return node;
	}
	
	function isElement(node) {
	  var OwnElement = getWindow(node).Element;
	  return node instanceof OwnElement || node instanceof Element;
	}
	
	function isHTMLElement(node) {
	  var OwnElement = getWindow(node).HTMLElement;
	  return node instanceof OwnElement || node instanceof HTMLElement;
	}
	
	function isShadowRoot(node) {
	  // IE 11 has no ShadowRoot
	  if (typeof ShadowRoot === 'undefined') {
	    return false;
	  }
	
	  var OwnElement = getWindow(node).ShadowRoot;
	  return node instanceof OwnElement || node instanceof ShadowRoot;
	}
	
	var max = Math.max;
	var min = Math.min;
	var round = Math.round;
	
	function getUAString() {
	  var uaData = navigator.userAgentData;
	
	  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
	    return uaData.brands.map(function (item) {
	      return item.brand + "/" + item.version;
	    }).join(' ');
	  }
	
	  return navigator.userAgent;
	}
	
	function isLayoutViewport() {
	  return !/^((?!chrome|android).)*safari/i.test(getUAString());
	}
	
	function getBoundingClientRect(element, includeScale, isFixedStrategy) {
	  if (includeScale === void 0) {
	    includeScale = false;
	  }
	
	  if (isFixedStrategy === void 0) {
	    isFixedStrategy = false;
	  }
	
	  var clientRect = element.getBoundingClientRect();
	  var scaleX = 1;
	  var scaleY = 1;
	
	  if (includeScale && isHTMLElement(element)) {
	    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
	    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
	  }
	
	  var _ref = isElement(element) ? getWindow(element) : window,
	      visualViewport = _ref.visualViewport;
	
	  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
	  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
	  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
	  var width = clientRect.width / scaleX;
	  var height = clientRect.height / scaleY;
	  return {
	    width: width,
	    height: height,
	    top: y,
	    right: x + width,
	    bottom: y + height,
	    left: x,
	    x: x,
	    y: y
	  };
	}
	
	function getWindowScroll(node) {
	  var win = getWindow(node);
	  var scrollLeft = win.pageXOffset;
	  var scrollTop = win.pageYOffset;
	  return {
	    scrollLeft: scrollLeft,
	    scrollTop: scrollTop
	  };
	}
	
	function getHTMLElementScroll(element) {
	  return {
	    scrollLeft: element.scrollLeft,
	    scrollTop: element.scrollTop
	  };
	}
	
	function getNodeScroll(node) {
	  if (node === getWindow(node) || !isHTMLElement(node)) {
	    return getWindowScroll(node);
	  } else {
	    return getHTMLElementScroll(node);
	  }
	}
	
	function getNodeName(element) {
	  return element ? (element.nodeName || '').toLowerCase() : null;
	}
	
	function getDocumentElement(element) {
	  // $FlowFixMe[incompatible-return]: assume body is always available
	  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
	  element.document) || window.document).documentElement;
	}
	
	function getWindowScrollBarX(element) {
	  // If <html> has a CSS width greater than the viewport, then this will be
	  // incorrect for RTL.
	  // Popper 1 is broken in this case and never had a bug report so let's assume
	  // it's not an issue. I don't think anyone ever specifies width on <html>
	  // anyway.
	  // Browsers where the left scrollbar doesn't cause an issue report `0` for
	  // this (e.g. Edge 2019, IE11, Safari)
	  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
	}
	
	function getComputedStyle(element) {
	  return getWindow(element).getComputedStyle(element);
	}
	
	function isScrollParent(element) {
	  // Firefox wants us to check `-x` and `-y` variations as well
	  var _getComputedStyle = getComputedStyle(element),
	      overflow = _getComputedStyle.overflow,
	      overflowX = _getComputedStyle.overflowX,
	      overflowY = _getComputedStyle.overflowY;
	
	  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
	}
	
	function isElementScaled(element) {
	  var rect = element.getBoundingClientRect();
	  var scaleX = round(rect.width) / element.offsetWidth || 1;
	  var scaleY = round(rect.height) / element.offsetHeight || 1;
	  return scaleX !== 1 || scaleY !== 1;
	} // Returns the composite rect of an element relative to its offsetParent.
	// Composite means it takes into account transforms as well as layout.
	
	
	function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
	  if (isFixed === void 0) {
	    isFixed = false;
	  }
	
	  var isOffsetParentAnElement = isHTMLElement(offsetParent);
	  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
	  var documentElement = getDocumentElement(offsetParent);
	  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
	  var scroll = {
	    scrollLeft: 0,
	    scrollTop: 0
	  };
	  var offsets = {
	    x: 0,
	    y: 0
	  };
	
	  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
	    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
	    isScrollParent(documentElement)) {
	      scroll = getNodeScroll(offsetParent);
	    }
	
	    if (isHTMLElement(offsetParent)) {
	      offsets = getBoundingClientRect(offsetParent, true);
	      offsets.x += offsetParent.clientLeft;
	      offsets.y += offsetParent.clientTop;
	    } else if (documentElement) {
	      offsets.x = getWindowScrollBarX(documentElement);
	    }
	  }
	
	  return {
	    x: rect.left + scroll.scrollLeft - offsets.x,
	    y: rect.top + scroll.scrollTop - offsets.y,
	    width: rect.width,
	    height: rect.height
	  };
	}
	
	// means it doesn't take into account transforms.
	
	function getLayoutRect(element) {
	  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
	  // Fixes https://github.com/popperjs/popper-core/issues/1223
	
	  var width = element.offsetWidth;
	  var height = element.offsetHeight;
	
	  if (Math.abs(clientRect.width - width) <= 1) {
	    width = clientRect.width;
	  }
	
	  if (Math.abs(clientRect.height - height) <= 1) {
	    height = clientRect.height;
	  }
	
	  return {
	    x: element.offsetLeft,
	    y: element.offsetTop,
	    width: width,
	    height: height
	  };
	}
	
	function getParentNode(element) {
	  if (getNodeName(element) === 'html') {
	    return element;
	  }
	
	  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
	    // $FlowFixMe[incompatible-return]
	    // $FlowFixMe[prop-missing]
	    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
	    element.parentNode || ( // DOM Element detected
	    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
	    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
	    getDocumentElement(element) // fallback
	
	  );
	}
	
	function getScrollParent(node) {
	  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
	    // $FlowFixMe[incompatible-return]: assume body is always available
	    return node.ownerDocument.body;
	  }
	
	  if (isHTMLElement(node) && isScrollParent(node)) {
	    return node;
	  }
	
	  return getScrollParent(getParentNode(node));
	}
	
	/*
	given a DOM element, return the list of all scroll parents, up the list of ancesors
	until we get to the top window object. This list is what we attach scroll listeners
	to, because if any of these parent elements scroll, we'll need to re-calculate the
	reference element's position.
	*/
	
	function listScrollParents(element, list) {
	  var _element$ownerDocumen;
	
	  if (list === void 0) {
	    list = [];
	  }
	
	  var scrollParent = getScrollParent(element);
	  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
	  var win = getWindow(scrollParent);
	  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
	  var updatedList = list.concat(target);
	  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
	  updatedList.concat(listScrollParents(getParentNode(target)));
	}
	
	function isTableElement(element) {
	  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
	}
	
	function getTrueOffsetParent(element) {
	  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
	  getComputedStyle(element).position === 'fixed') {
	    return null;
	  }
	
	  return element.offsetParent;
	} // `.offsetParent` reports `null` for fixed elements, while absolute elements
	// return the containing block
	
	
	function getContainingBlock(element) {
	  var isFirefox = /firefox/i.test(getUAString());
	  var isIE = /Trident/i.test(getUAString());
	
	  if (isIE && isHTMLElement(element)) {
	    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
	    var elementCss = getComputedStyle(element);
	
	    if (elementCss.position === 'fixed') {
	      return null;
	    }
	  }
	
	  var currentNode = getParentNode(element);
	
	  if (isShadowRoot(currentNode)) {
	    currentNode = currentNode.host;
	  }
	
	  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
	    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
	    // create a containing block.
	    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
	
	    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
	      return currentNode;
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }
	
	  return null;
	} // Gets the closest ancestor positioned element. Handles some edge cases,
	// such as table ancestors and cross browser bugs.
	
	
	function getOffsetParent(element) {
	  var window = getWindow(element);
	  var offsetParent = getTrueOffsetParent(element);
	
	  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
	    offsetParent = getTrueOffsetParent(offsetParent);
	  }
	
	  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
	    return window;
	  }
	
	  return offsetParent || getContainingBlock(element) || window;
	}
	
	var top = 'top';
	var bottom = 'bottom';
	var right = 'right';
	var left = 'left';
	var auto = 'auto';
	var basePlacements = [top, bottom, right, left];
	var start = 'start';
	var end = 'end';
	var clippingParents = 'clippingParents';
	var viewport = 'viewport';
	var popper = 'popper';
	var reference = 'reference';
	var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
	  return acc.concat([placement + "-" + start, placement + "-" + end]);
	}, []);
	var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
	  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
	}, []); // modifiers that need to read the DOM
	
	var beforeRead = 'beforeRead';
	var read = 'read';
	var afterRead = 'afterRead'; // pure-logic modifiers
	
	var beforeMain = 'beforeMain';
	var main = 'main';
	var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
	
	var beforeWrite = 'beforeWrite';
	var write = 'write';
	var afterWrite = 'afterWrite';
	var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
	
	function order(modifiers) {
	  var map = new Map();
	  var visited = new Set();
	  var result = [];
	  modifiers.forEach(function (modifier) {
	    map.set(modifier.name, modifier);
	  }); // On visiting object, check for its dependencies and visit them recursively
	
	  function sort(modifier) {
	    visited.add(modifier.name);
	    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
	    requires.forEach(function (dep) {
	      if (!visited.has(dep)) {
	        var depModifier = map.get(dep);
	
	        if (depModifier) {
	          sort(depModifier);
	        }
	      }
	    });
	    result.push(modifier);
	  }
	
	  modifiers.forEach(function (modifier) {
	    if (!visited.has(modifier.name)) {
	      // check for visited object
	      sort(modifier);
	    }
	  });
	  return result;
	}
	
	function orderModifiers(modifiers) {
	  // order based on dependencies
	  var orderedModifiers = order(modifiers); // order based on phase
	
	  return modifierPhases.reduce(function (acc, phase) {
	    return acc.concat(orderedModifiers.filter(function (modifier) {
	      return modifier.phase === phase;
	    }));
	  }, []);
	}
	
	function debounce(fn) {
	  var pending;
	  return function () {
	    if (!pending) {
	      pending = new Promise(function (resolve) {
	        Promise.resolve().then(function () {
	          pending = undefined;
	          resolve(fn());
	        });
	      });
	    }
	
	    return pending;
	  };
	}
	
	function mergeByName(modifiers) {
	  var merged = modifiers.reduce(function (merged, current) {
	    var existing = merged[current.name];
	    merged[current.name] = existing ? Object.assign({}, existing, current, {
	      options: Object.assign({}, existing.options, current.options),
	      data: Object.assign({}, existing.data, current.data)
	    }) : current;
	    return merged;
	  }, {}); // IE11 does not support Object.values
	
	  return Object.keys(merged).map(function (key) {
	    return merged[key];
	  });
	}
	
	function getViewportRect(element, strategy) {
	  var win = getWindow(element);
	  var html = getDocumentElement(element);
	  var visualViewport = win.visualViewport;
	  var width = html.clientWidth;
	  var height = html.clientHeight;
	  var x = 0;
	  var y = 0;
	
	  if (visualViewport) {
	    width = visualViewport.width;
	    height = visualViewport.height;
	    var layoutViewport = isLayoutViewport();
	
	    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
	      x = visualViewport.offsetLeft;
	      y = visualViewport.offsetTop;
	    }
	  }
	
	  return {
	    width: width,
	    height: height,
	    x: x + getWindowScrollBarX(element),
	    y: y
	  };
	}
	
	// of the `<html>` and `<body>` rect bounds if horizontally scrollable
	
	function getDocumentRect(element) {
	  var _element$ownerDocumen;
	
	  var html = getDocumentElement(element);
	  var winScroll = getWindowScroll(element);
	  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
	  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
	  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
	  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
	  var y = -winScroll.scrollTop;
	
	  if (getComputedStyle(body || html).direction === 'rtl') {
	    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
	  }
	
	  return {
	    width: width,
	    height: height,
	    x: x,
	    y: y
	  };
	}
	
	function contains(parent, child) {
	  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
	
	  if (parent.contains(child)) {
	    return true;
	  } // then fallback to custom implementation with Shadow DOM support
	  else if (rootNode && isShadowRoot(rootNode)) {
	      var next = child;
	
	      do {
	        if (next && parent.isSameNode(next)) {
	          return true;
	        } // $FlowFixMe[prop-missing]: need a better way to handle this...
	
	
	        next = next.parentNode || next.host;
	      } while (next);
	    } // Give up, the result is false
	
	
	  return false;
	}
	
	function rectToClientRect(rect) {
	  return Object.assign({}, rect, {
	    left: rect.x,
	    top: rect.y,
	    right: rect.x + rect.width,
	    bottom: rect.y + rect.height
	  });
	}
	
	function getInnerBoundingClientRect(element, strategy) {
	  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
	  rect.top = rect.top + element.clientTop;
	  rect.left = rect.left + element.clientLeft;
	  rect.bottom = rect.top + element.clientHeight;
	  rect.right = rect.left + element.clientWidth;
	  rect.width = element.clientWidth;
	  rect.height = element.clientHeight;
	  rect.x = rect.left;
	  rect.y = rect.top;
	  return rect;
	}
	
	function getClientRectFromMixedType(element, clippingParent, strategy) {
	  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
	} // A "clipping parent" is an overflowable container with the characteristic of
	// clipping (or hiding) overflowing elements with a position different from
	// `initial`
	
	
	function getClippingParents(element) {
	  var clippingParents = listScrollParents(getParentNode(element));
	  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
	  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
	
	  if (!isElement(clipperElement)) {
	    return [];
	  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
	
	
	  return clippingParents.filter(function (clippingParent) {
	    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
	  });
	} // Gets the maximum area that the element is visible in due to any number of
	// clipping parents
	
	
	function getClippingRect(element, boundary, rootBoundary, strategy) {
	  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
	  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
	  var firstClippingParent = clippingParents[0];
	  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
	    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
	    accRect.top = max(rect.top, accRect.top);
	    accRect.right = min(rect.right, accRect.right);
	    accRect.bottom = min(rect.bottom, accRect.bottom);
	    accRect.left = max(rect.left, accRect.left);
	    return accRect;
	  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
	  clippingRect.width = clippingRect.right - clippingRect.left;
	  clippingRect.height = clippingRect.bottom - clippingRect.top;
	  clippingRect.x = clippingRect.left;
	  clippingRect.y = clippingRect.top;
	  return clippingRect;
	}
	
	function getBasePlacement(placement) {
	  return placement.split('-')[0];
	}
	
	function getVariation(placement) {
	  return placement.split('-')[1];
	}
	
	function getMainAxisFromPlacement(placement) {
	  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
	}
	
	function computeOffsets(_ref) {
	  var reference = _ref.reference,
	      element = _ref.element,
	      placement = _ref.placement;
	  var basePlacement = placement ? getBasePlacement(placement) : null;
	  var variation = placement ? getVariation(placement) : null;
	  var commonX = reference.x + reference.width / 2 - element.width / 2;
	  var commonY = reference.y + reference.height / 2 - element.height / 2;
	  var offsets;
	
	  switch (basePlacement) {
	    case top:
	      offsets = {
	        x: commonX,
	        y: reference.y - element.height
	      };
	      break;
	
	    case bottom:
	      offsets = {
	        x: commonX,
	        y: reference.y + reference.height
	      };
	      break;
	
	    case right:
	      offsets = {
	        x: reference.x + reference.width,
	        y: commonY
	      };
	      break;
	
	    case left:
	      offsets = {
	        x: reference.x - element.width,
	        y: commonY
	      };
	      break;
	
	    default:
	      offsets = {
	        x: reference.x,
	        y: reference.y
	      };
	  }
	
	  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
	
	  if (mainAxis != null) {
	    var len = mainAxis === 'y' ? 'height' : 'width';
	
	    switch (variation) {
	      case start:
	        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
	        break;
	
	      case end:
	        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
	        break;
	    }
	  }
	
	  return offsets;
	}
	
	function getFreshSideObject() {
	  return {
	    top: 0,
	    right: 0,
	    bottom: 0,
	    left: 0
	  };
	}
	
	function mergePaddingObject(paddingObject) {
	  return Object.assign({}, getFreshSideObject(), paddingObject);
	}
	
	function expandToHashMap(value, keys) {
	  return keys.reduce(function (hashMap, key) {
	    hashMap[key] = value;
	    return hashMap;
	  }, {});
	}
	
	function detectOverflow(state, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      _options$placement = _options.placement,
	      placement = _options$placement === void 0 ? state.placement : _options$placement,
	      _options$strategy = _options.strategy,
	      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
	      _options$boundary = _options.boundary,
	      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
	      _options$rootBoundary = _options.rootBoundary,
	      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
	      _options$elementConte = _options.elementContext,
	      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
	      _options$altBoundary = _options.altBoundary,
	      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
	      _options$padding = _options.padding,
	      padding = _options$padding === void 0 ? 0 : _options$padding;
	  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	  var altContext = elementContext === popper ? reference : popper;
	  var popperRect = state.rects.popper;
	  var element = state.elements[altBoundary ? altContext : elementContext];
	  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
	  var referenceClientRect = getBoundingClientRect(state.elements.reference);
	  var popperOffsets = computeOffsets({
	    reference: referenceClientRect,
	    element: popperRect,
	    strategy: 'absolute',
	    placement: placement
	  });
	  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
	  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
	  // 0 or negative = within the clipping rect
	
	  var overflowOffsets = {
	    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
	    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
	    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
	    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
	  };
	  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
	
	  if (elementContext === popper && offsetData) {
	    var offset = offsetData[placement];
	    Object.keys(overflowOffsets).forEach(function (key) {
	      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
	      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
	      overflowOffsets[key] += offset[axis] * multiply;
	    });
	  }
	
	  return overflowOffsets;
	}
	
	var DEFAULT_OPTIONS = {
	  placement: 'bottom',
	  modifiers: [],
	  strategy: 'absolute'
	};
	
	function areValidElements() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return !args.some(function (element) {
	    return !(element && typeof element.getBoundingClientRect === 'function');
	  });
	}
	
	function popperGenerator(generatorOptions) {
	  if (generatorOptions === void 0) {
	    generatorOptions = {};
	  }
	
	  var _generatorOptions = generatorOptions,
	      _generatorOptions$def = _generatorOptions.defaultModifiers,
	      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
	      _generatorOptions$def2 = _generatorOptions.defaultOptions,
	      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
	  return function createPopper(reference, popper, options) {
	    if (options === void 0) {
	      options = defaultOptions;
	    }
	
	    var state = {
	      placement: 'bottom',
	      orderedModifiers: [],
	      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
	      modifiersData: {},
	      elements: {
	        reference: reference,
	        popper: popper
	      },
	      attributes: {},
	      styles: {}
	    };
	    var effectCleanupFns = [];
	    var isDestroyed = false;
	    var instance = {
	      state: state,
	      setOptions: function setOptions(setOptionsAction) {
	        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
	        cleanupModifierEffects();
	        state.options = Object.assign({}, defaultOptions, state.options, options);
	        state.scrollParents = {
	          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
	          popper: listScrollParents(popper)
	        }; // Orders the modifiers based on their dependencies and `phase`
	        // properties
	
	        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
	
	        state.orderedModifiers = orderedModifiers.filter(function (m) {
	          return m.enabled;
	        });
	        runModifierEffects();
	        return instance.update();
	      },
	      // Sync update – it will always be executed, even if not necessary. This
	      // is useful for low frequency updates where sync behavior simplifies the
	      // logic.
	      // For high frequency updates (e.g. `resize` and `scroll` events), always
	      // prefer the async Popper#update method
	      forceUpdate: function forceUpdate() {
	        if (isDestroyed) {
	          return;
	        }
	
	        var _state$elements = state.elements,
	            reference = _state$elements.reference,
	            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
	        // anymore
	
	        if (!areValidElements(reference, popper)) {
	          return;
	        } // Store the reference and popper rects to be read by modifiers
	
	
	        state.rects = {
	          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
	          popper: getLayoutRect(popper)
	        }; // Modifiers have the ability to reset the current update cycle. The
	        // most common use case for this is the `flip` modifier changing the
	        // placement, which then needs to re-run all the modifiers, because the
	        // logic was previously ran for the previous placement and is therefore
	        // stale/incorrect
	
	        state.reset = false;
	        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
	        // is filled with the initial data specified by the modifier. This means
	        // it doesn't persist and is fresh on each update.
	        // To ensure persistent data, use `${name}#persistent`
	
	        state.orderedModifiers.forEach(function (modifier) {
	          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
	        });
	
	        for (var index = 0; index < state.orderedModifiers.length; index++) {
	          if (state.reset === true) {
	            state.reset = false;
	            index = -1;
	            continue;
	          }
	
	          var _state$orderedModifie = state.orderedModifiers[index],
	              fn = _state$orderedModifie.fn,
	              _state$orderedModifie2 = _state$orderedModifie.options,
	              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
	              name = _state$orderedModifie.name;
	
	          if (typeof fn === 'function') {
	            state = fn({
	              state: state,
	              options: _options,
	              name: name,
	              instance: instance
	            }) || state;
	          }
	        }
	      },
	      // Async and optimistically optimized update – it will not be executed if
	      // not necessary (debounced to run at most once-per-tick)
	      update: debounce(function () {
	        return new Promise(function (resolve) {
	          instance.forceUpdate();
	          resolve(state);
	        });
	      }),
	      destroy: function destroy() {
	        cleanupModifierEffects();
	        isDestroyed = true;
	      }
	    };
	
	    if (!areValidElements(reference, popper)) {
	      return instance;
	    }
	
	    instance.setOptions(options).then(function (state) {
	      if (!isDestroyed && options.onFirstUpdate) {
	        options.onFirstUpdate(state);
	      }
	    }); // Modifiers have the ability to execute arbitrary code before the first
	    // update cycle runs. They will be executed in the same order as the update
	    // cycle. This is useful when a modifier adds some persistent data that
	    // other modifiers need to use, but the modifier is run after the dependent
	    // one.
	
	    function runModifierEffects() {
	      state.orderedModifiers.forEach(function (_ref) {
	        var name = _ref.name,
	            _ref$options = _ref.options,
	            options = _ref$options === void 0 ? {} : _ref$options,
	            effect = _ref.effect;
	
	        if (typeof effect === 'function') {
	          var cleanupFn = effect({
	            state: state,
	            name: name,
	            instance: instance,
	            options: options
	          });
	
	          var noopFn = function noopFn() {};
	
	          effectCleanupFns.push(cleanupFn || noopFn);
	        }
	      });
	    }
	
	    function cleanupModifierEffects() {
	      effectCleanupFns.forEach(function (fn) {
	        return fn();
	      });
	      effectCleanupFns = [];
	    }
	
	    return instance;
	  };
	}
	
	var passive = {
	  passive: true
	};
	
	function effect$2(_ref) {
	  var state = _ref.state,
	      instance = _ref.instance,
	      options = _ref.options;
	  var _options$scroll = options.scroll,
	      scroll = _options$scroll === void 0 ? true : _options$scroll,
	      _options$resize = options.resize,
	      resize = _options$resize === void 0 ? true : _options$resize;
	  var window = getWindow(state.elements.popper);
	  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
	
	  if (scroll) {
	    scrollParents.forEach(function (scrollParent) {
	      scrollParent.addEventListener('scroll', instance.update, passive);
	    });
	  }
	
	  if (resize) {
	    window.addEventListener('resize', instance.update, passive);
	  }
	
	  return function () {
	    if (scroll) {
	      scrollParents.forEach(function (scrollParent) {
	        scrollParent.removeEventListener('scroll', instance.update, passive);
	      });
	    }
	
	    if (resize) {
	      window.removeEventListener('resize', instance.update, passive);
	    }
	  };
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var eventListeners = {
	  name: 'eventListeners',
	  enabled: true,
	  phase: 'write',
	  fn: function fn() {},
	  effect: effect$2,
	  data: {}
	};
	
	function popperOffsets(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  // Offsets are the actual position the popper needs to have to be
	  // properly positioned near its reference element
	  // This is the most basic placement, and will be adjusted by
	  // the modifiers in the next step
	  state.modifiersData[name] = computeOffsets({
	    reference: state.rects.reference,
	    element: state.rects.popper,
	    strategy: 'absolute',
	    placement: state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var popperOffsets$1 = {
	  name: 'popperOffsets',
	  enabled: true,
	  phase: 'read',
	  fn: popperOffsets,
	  data: {}
	};
	
	var unsetSides = {
	  top: 'auto',
	  right: 'auto',
	  bottom: 'auto',
	  left: 'auto'
	}; // Round the offsets to the nearest suitable subpixel based on the DPR.
	// Zooming can change the DPR, but it seems to report a value that will
	// cleanly divide the values into the appropriate subpixels.
	
	function roundOffsetsByDPR(_ref, win) {
	  var x = _ref.x,
	      y = _ref.y;
	  var dpr = win.devicePixelRatio || 1;
	  return {
	    x: round(x * dpr) / dpr || 0,
	    y: round(y * dpr) / dpr || 0
	  };
	}
	
	function mapToStyles(_ref2) {
	  var _Object$assign2;
	
	  var popper = _ref2.popper,
	      popperRect = _ref2.popperRect,
	      placement = _ref2.placement,
	      variation = _ref2.variation,
	      offsets = _ref2.offsets,
	      position = _ref2.position,
	      gpuAcceleration = _ref2.gpuAcceleration,
	      adaptive = _ref2.adaptive,
	      roundOffsets = _ref2.roundOffsets,
	      isFixed = _ref2.isFixed;
	  var _offsets$x = offsets.x,
	      x = _offsets$x === void 0 ? 0 : _offsets$x,
	      _offsets$y = offsets.y,
	      y = _offsets$y === void 0 ? 0 : _offsets$y;
	
	  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
	    x: x,
	    y: y
	  }) : {
	    x: x,
	    y: y
	  };
	
	  x = _ref3.x;
	  y = _ref3.y;
	  var hasX = offsets.hasOwnProperty('x');
	  var hasY = offsets.hasOwnProperty('y');
	  var sideX = left;
	  var sideY = top;
	  var win = window;
	
	  if (adaptive) {
	    var offsetParent = getOffsetParent(popper);
	    var heightProp = 'clientHeight';
	    var widthProp = 'clientWidth';
	
	    if (offsetParent === getWindow(popper)) {
	      offsetParent = getDocumentElement(popper);
	
	      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
	        heightProp = 'scrollHeight';
	        widthProp = 'scrollWidth';
	      }
	    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
	
	
	    offsetParent = offsetParent;
	
	    if (placement === top || (placement === left || placement === right) && variation === end) {
	      sideY = bottom;
	      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
	      offsetParent[heightProp];
	      y -= offsetY - popperRect.height;
	      y *= gpuAcceleration ? 1 : -1;
	    }
	
	    if (placement === left || (placement === top || placement === bottom) && variation === end) {
	      sideX = right;
	      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
	      offsetParent[widthProp];
	      x -= offsetX - popperRect.width;
	      x *= gpuAcceleration ? 1 : -1;
	    }
	  }
	
	  var commonStyles = Object.assign({
	    position: position
	  }, adaptive && unsetSides);
	
	  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
	    x: x,
	    y: y
	  }, getWindow(popper)) : {
	    x: x,
	    y: y
	  };
	
	  x = _ref4.x;
	  y = _ref4.y;
	
	  if (gpuAcceleration) {
	    var _Object$assign;
	
	    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
	  }
	
	  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
	}
	
	function computeStyles(_ref5) {
	  var state = _ref5.state,
	      options = _ref5.options;
	  var _options$gpuAccelerat = options.gpuAcceleration,
	      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
	      _options$adaptive = options.adaptive,
	      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
	      _options$roundOffsets = options.roundOffsets,
	      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
	  var commonStyles = {
	    placement: getBasePlacement(state.placement),
	    variation: getVariation(state.placement),
	    popper: state.elements.popper,
	    popperRect: state.rects.popper,
	    gpuAcceleration: gpuAcceleration,
	    isFixed: state.options.strategy === 'fixed'
	  };
	
	  if (state.modifiersData.popperOffsets != null) {
	    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.popperOffsets,
	      position: state.options.strategy,
	      adaptive: adaptive,
	      roundOffsets: roundOffsets
	    })));
	  }
	
	  if (state.modifiersData.arrow != null) {
	    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
	      offsets: state.modifiersData.arrow,
	      position: 'absolute',
	      adaptive: false,
	      roundOffsets: roundOffsets
	    })));
	  }
	
	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-placement': state.placement
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var computeStyles$1 = {
	  name: 'computeStyles',
	  enabled: true,
	  phase: 'beforeWrite',
	  fn: computeStyles,
	  data: {}
	};
	
	// and applies them to the HTMLElements such as popper and arrow
	
	function applyStyles(_ref) {
	  var state = _ref.state;
	  Object.keys(state.elements).forEach(function (name) {
	    var style = state.styles[name] || {};
	    var attributes = state.attributes[name] || {};
	    var element = state.elements[name]; // arrow is optional + virtual elements
	
	    if (!isHTMLElement(element) || !getNodeName(element)) {
	      return;
	    } // Flow doesn't support to extend this property, but it's the most
	    // effective way to apply styles to an HTMLElement
	    // $FlowFixMe[cannot-write]
	
	
	    Object.assign(element.style, style);
	    Object.keys(attributes).forEach(function (name) {
	      var value = attributes[name];
	
	      if (value === false) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, value === true ? '' : value);
	      }
	    });
	  });
	}
	
	function effect$1(_ref2) {
	  var state = _ref2.state;
	  var initialStyles = {
	    popper: {
	      position: state.options.strategy,
	      left: '0',
	      top: '0',
	      margin: '0'
	    },
	    arrow: {
	      position: 'absolute'
	    },
	    reference: {}
	  };
	  Object.assign(state.elements.popper.style, initialStyles.popper);
	  state.styles = initialStyles;
	
	  if (state.elements.arrow) {
	    Object.assign(state.elements.arrow.style, initialStyles.arrow);
	  }
	
	  return function () {
	    Object.keys(state.elements).forEach(function (name) {
	      var element = state.elements[name];
	      var attributes = state.attributes[name] || {};
	      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
	
	      var style = styleProperties.reduce(function (style, property) {
	        style[property] = '';
	        return style;
	      }, {}); // arrow is optional + virtual elements
	
	      if (!isHTMLElement(element) || !getNodeName(element)) {
	        return;
	      }
	
	      Object.assign(element.style, style);
	      Object.keys(attributes).forEach(function (attribute) {
	        element.removeAttribute(attribute);
	      });
	    });
	  };
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var applyStyles$1 = {
	  name: 'applyStyles',
	  enabled: true,
	  phase: 'write',
	  fn: applyStyles,
	  effect: effect$1,
	  requires: ['computeStyles']
	};
	
	function distanceAndSkiddingToXY(placement, rects, offset) {
	  var basePlacement = getBasePlacement(placement);
	  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
	
	  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
	    placement: placement
	  })) : offset,
	      skidding = _ref[0],
	      distance = _ref[1];
	
	  skidding = skidding || 0;
	  distance = (distance || 0) * invertDistance;
	  return [left, right].indexOf(basePlacement) >= 0 ? {
	    x: distance,
	    y: skidding
	  } : {
	    x: skidding,
	    y: distance
	  };
	}
	
	function offset(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options,
	      name = _ref2.name;
	  var _options$offset = options.offset,
	      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
	  var data = placements.reduce(function (acc, placement) {
	    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
	    return acc;
	  }, {});
	  var _data$state$placement = data[state.placement],
	      x = _data$state$placement.x,
	      y = _data$state$placement.y;
	
	  if (state.modifiersData.popperOffsets != null) {
	    state.modifiersData.popperOffsets.x += x;
	    state.modifiersData.popperOffsets.y += y;
	  }
	
	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var offset$1 = {
	  name: 'offset',
	  enabled: true,
	  phase: 'main',
	  requires: ['popperOffsets'],
	  fn: offset
	};
	
	var hash$1 = {
	  left: 'right',
	  right: 'left',
	  bottom: 'top',
	  top: 'bottom'
	};
	function getOppositePlacement(placement) {
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash$1[matched];
	  });
	}
	
	var hash = {
	  start: 'end',
	  end: 'start'
	};
	function getOppositeVariationPlacement(placement) {
	  return placement.replace(/start|end/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	function computeAutoPlacement(state, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _options = options,
	      placement = _options.placement,
	      boundary = _options.boundary,
	      rootBoundary = _options.rootBoundary,
	      padding = _options.padding,
	      flipVariations = _options.flipVariations,
	      _options$allowedAutoP = _options.allowedAutoPlacements,
	      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
	  var variation = getVariation(placement);
	  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
	    return getVariation(placement) === variation;
	  }) : basePlacements;
	  var allowedPlacements = placements$1.filter(function (placement) {
	    return allowedAutoPlacements.indexOf(placement) >= 0;
	  });
	
	  if (allowedPlacements.length === 0) {
	    allowedPlacements = placements$1;
	  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
	
	
	  var overflows = allowedPlacements.reduce(function (acc, placement) {
	    acc[placement] = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding
	    })[getBasePlacement(placement)];
	    return acc;
	  }, {});
	  return Object.keys(overflows).sort(function (a, b) {
	    return overflows[a] - overflows[b];
	  });
	}
	
	function getExpandedFallbackPlacements(placement) {
	  if (getBasePlacement(placement) === auto) {
	    return [];
	  }
	
	  var oppositePlacement = getOppositePlacement(placement);
	  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
	}
	
	function flip(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;
	
	  if (state.modifiersData[name]._skip) {
	    return;
	  }
	
	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
	      specifiedFallbackPlacements = options.fallbackPlacements,
	      padding = options.padding,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      _options$flipVariatio = options.flipVariations,
	      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
	      allowedAutoPlacements = options.allowedAutoPlacements;
	  var preferredPlacement = state.options.placement;
	  var basePlacement = getBasePlacement(preferredPlacement);
	  var isBasePlacement = basePlacement === preferredPlacement;
	  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
	  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
	    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      padding: padding,
	      flipVariations: flipVariations,
	      allowedAutoPlacements: allowedAutoPlacements
	    }) : placement);
	  }, []);
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var checksMap = new Map();
	  var makeFallbackChecks = true;
	  var firstFittingPlacement = placements[0];
	
	  for (var i = 0; i < placements.length; i++) {
	    var placement = placements[i];
	
	    var _basePlacement = getBasePlacement(placement);
	
	    var isStartVariation = getVariation(placement) === start;
	    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
	    var len = isVertical ? 'width' : 'height';
	    var overflow = detectOverflow(state, {
	      placement: placement,
	      boundary: boundary,
	      rootBoundary: rootBoundary,
	      altBoundary: altBoundary,
	      padding: padding
	    });
	    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
	
	    if (referenceRect[len] > popperRect[len]) {
	      mainVariationSide = getOppositePlacement(mainVariationSide);
	    }
	
	    var altVariationSide = getOppositePlacement(mainVariationSide);
	    var checks = [];
	
	    if (checkMainAxis) {
	      checks.push(overflow[_basePlacement] <= 0);
	    }
	
	    if (checkAltAxis) {
	      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
	    }
	
	    if (checks.every(function (check) {
	      return check;
	    })) {
	      firstFittingPlacement = placement;
	      makeFallbackChecks = false;
	      break;
	    }
	
	    checksMap.set(placement, checks);
	  }
	
	  if (makeFallbackChecks) {
	    // `2` may be desired in some cases – research later
	    var numberOfChecks = flipVariations ? 3 : 1;
	
	    var _loop = function _loop(_i) {
	      var fittingPlacement = placements.find(function (placement) {
	        var checks = checksMap.get(placement);
	
	        if (checks) {
	          return checks.slice(0, _i).every(function (check) {
	            return check;
	          });
	        }
	      });
	
	      if (fittingPlacement) {
	        firstFittingPlacement = fittingPlacement;
	        return "break";
	      }
	    };
	
	    for (var _i = numberOfChecks; _i > 0; _i--) {
	      var _ret = _loop(_i);
	
	      if (_ret === "break") break;
	    }
	  }
	
	  if (state.placement !== firstFittingPlacement) {
	    state.modifiersData[name]._skip = true;
	    state.placement = firstFittingPlacement;
	    state.reset = true;
	  }
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var flip$1 = {
	  name: 'flip',
	  enabled: true,
	  phase: 'main',
	  fn: flip,
	  requiresIfExists: ['offset'],
	  data: {
	    _skip: false
	  }
	};
	
	function getAltAxis(axis) {
	  return axis === 'x' ? 'y' : 'x';
	}
	
	function within(min$1, value, max$1) {
	  return max(min$1, min(value, max$1));
	}
	function withinMaxClamp(min, value, max) {
	  var v = within(min, value, max);
	  return v > max ? max : v;
	}
	
	function preventOverflow(_ref) {
	  var state = _ref.state,
	      options = _ref.options,
	      name = _ref.name;
	  var _options$mainAxis = options.mainAxis,
	      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
	      _options$altAxis = options.altAxis,
	      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
	      boundary = options.boundary,
	      rootBoundary = options.rootBoundary,
	      altBoundary = options.altBoundary,
	      padding = options.padding,
	      _options$tether = options.tether,
	      tether = _options$tether === void 0 ? true : _options$tether,
	      _options$tetherOffset = options.tetherOffset,
	      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
	  var overflow = detectOverflow(state, {
	    boundary: boundary,
	    rootBoundary: rootBoundary,
	    padding: padding,
	    altBoundary: altBoundary
	  });
	  var basePlacement = getBasePlacement(state.placement);
	  var variation = getVariation(state.placement);
	  var isBasePlacement = !variation;
	  var mainAxis = getMainAxisFromPlacement(basePlacement);
	  var altAxis = getAltAxis(mainAxis);
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : tetherOffset;
	  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
	    mainAxis: tetherOffsetValue,
	    altAxis: tetherOffsetValue
	  } : Object.assign({
	    mainAxis: 0,
	    altAxis: 0
	  }, tetherOffsetValue);
	  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
	  var data = {
	    x: 0,
	    y: 0
	  };
	
	  if (!popperOffsets) {
	    return;
	  }
	
	  if (checkMainAxis) {
	    var _offsetModifierState$;
	
	    var mainSide = mainAxis === 'y' ? top : left;
	    var altSide = mainAxis === 'y' ? bottom : right;
	    var len = mainAxis === 'y' ? 'height' : 'width';
	    var offset = popperOffsets[mainAxis];
	    var min$1 = offset + overflow[mainSide];
	    var max$1 = offset - overflow[altSide];
	    var additive = tether ? -popperRect[len] / 2 : 0;
	    var minLen = variation === start ? referenceRect[len] : popperRect[len];
	    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
	    // outside the reference bounds
	
	    var arrowElement = state.elements.arrow;
	    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
	      width: 0,
	      height: 0
	    };
	    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
	    var arrowPaddingMin = arrowPaddingObject[mainSide];
	    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
	    // to include its full size in the calculation. If the reference is small
	    // and near the edge of a boundary, the popper can overflow even if the
	    // reference is not overflowing as well (e.g. virtual elements with no
	    // width or height)
	
	    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
	    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
	    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
	    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
	    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
	    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
	    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
	    var tetherMax = offset + maxOffset - offsetModifierValue;
	    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
	    popperOffsets[mainAxis] = preventedOffset;
	    data[mainAxis] = preventedOffset - offset;
	  }
	
	  if (checkAltAxis) {
	    var _offsetModifierState$2;
	
	    var _mainSide = mainAxis === 'x' ? top : left;
	
	    var _altSide = mainAxis === 'x' ? bottom : right;
	
	    var _offset = popperOffsets[altAxis];
	
	    var _len = altAxis === 'y' ? 'height' : 'width';
	
	    var _min = _offset + overflow[_mainSide];
	
	    var _max = _offset - overflow[_altSide];
	
	    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
	
	    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
	
	    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
	
	    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
	
	    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
	
	    popperOffsets[altAxis] = _preventedOffset;
	    data[altAxis] = _preventedOffset - _offset;
	  }
	
	  state.modifiersData[name] = data;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var preventOverflow$1 = {
	  name: 'preventOverflow',
	  enabled: true,
	  phase: 'main',
	  fn: preventOverflow,
	  requiresIfExists: ['offset']
	};
	
	var toPaddingObject = function toPaddingObject(padding, state) {
	  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
	    placement: state.placement
	  })) : padding;
	  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
	};
	
	function arrow(_ref) {
	  var _state$modifiersData$;
	
	  var state = _ref.state,
	      name = _ref.name,
	      options = _ref.options;
	  var arrowElement = state.elements.arrow;
	  var popperOffsets = state.modifiersData.popperOffsets;
	  var basePlacement = getBasePlacement(state.placement);
	  var axis = getMainAxisFromPlacement(basePlacement);
	  var isVertical = [left, right].indexOf(basePlacement) >= 0;
	  var len = isVertical ? 'height' : 'width';
	
	  if (!arrowElement || !popperOffsets) {
	    return;
	  }
	
	  var paddingObject = toPaddingObject(options.padding, state);
	  var arrowRect = getLayoutRect(arrowElement);
	  var minProp = axis === 'y' ? top : left;
	  var maxProp = axis === 'y' ? bottom : right;
	  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
	  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
	  var arrowOffsetParent = getOffsetParent(arrowElement);
	  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
	  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
	  // outside of the popper bounds
	
	  var min = paddingObject[minProp];
	  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
	  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
	  var offset = within(min, center, max); // Prevents breaking syntax highlighting...
	
	  var axisProp = axis;
	  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
	}
	
	function effect(_ref2) {
	  var state = _ref2.state,
	      options = _ref2.options;
	  var _options$element = options.element,
	      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
	
	  if (arrowElement == null) {
	    return;
	  } // CSS selector
	
	
	  if (typeof arrowElement === 'string') {
	    arrowElement = state.elements.popper.querySelector(arrowElement);
	
	    if (!arrowElement) {
	      return;
	    }
	  }
	
	  if (!contains(state.elements.popper, arrowElement)) {
	    return;
	  }
	
	  state.elements.arrow = arrowElement;
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var arrow$1 = {
	  name: 'arrow',
	  enabled: true,
	  phase: 'main',
	  fn: arrow,
	  effect: effect,
	  requires: ['popperOffsets'],
	  requiresIfExists: ['preventOverflow']
	};
	
	function getSideOffsets(overflow, rect, preventedOffsets) {
	  if (preventedOffsets === void 0) {
	    preventedOffsets = {
	      x: 0,
	      y: 0
	    };
	  }
	
	  return {
	    top: overflow.top - rect.height - preventedOffsets.y,
	    right: overflow.right - rect.width + preventedOffsets.x,
	    bottom: overflow.bottom - rect.height + preventedOffsets.y,
	    left: overflow.left - rect.width - preventedOffsets.x
	  };
	}
	
	function isAnySideFullyClipped(overflow) {
	  return [top, right, bottom, left].some(function (side) {
	    return overflow[side] >= 0;
	  });
	}
	
	function hide(_ref) {
	  var state = _ref.state,
	      name = _ref.name;
	  var referenceRect = state.rects.reference;
	  var popperRect = state.rects.popper;
	  var preventedOffsets = state.modifiersData.preventOverflow;
	  var referenceOverflow = detectOverflow(state, {
	    elementContext: 'reference'
	  });
	  var popperAltOverflow = detectOverflow(state, {
	    altBoundary: true
	  });
	  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
	  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
	  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
	  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
	  state.modifiersData[name] = {
	    referenceClippingOffsets: referenceClippingOffsets,
	    popperEscapeOffsets: popperEscapeOffsets,
	    isReferenceHidden: isReferenceHidden,
	    hasPopperEscaped: hasPopperEscaped
	  };
	  state.attributes.popper = Object.assign({}, state.attributes.popper, {
	    'data-popper-reference-hidden': isReferenceHidden,
	    'data-popper-escaped': hasPopperEscaped
	  });
	} // eslint-disable-next-line import/no-unused-modules
	
	
	var hide$1 = {
	  name: 'hide',
	  enabled: true,
	  phase: 'main',
	  requiresIfExists: ['preventOverflow'],
	  fn: hide
	};
	
	var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];
	var createPopper$1 = /*#__PURE__*/popperGenerator({
	  defaultModifiers: defaultModifiers$1
	}); // eslint-disable-next-line import/no-unused-modules
	
	var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
	var createPopper = /*#__PURE__*/popperGenerator({
	  defaultModifiers: defaultModifiers
	}); // eslint-disable-next-line import/no-unused-modules
	
	exports.applyStyles = applyStyles$1;
	exports.arrow = arrow$1;
	exports.computeStyles = computeStyles$1;
	exports.createPopper = createPopper;
	exports.createPopperLite = createPopper$1;
	exports.defaultModifiers = defaultModifiers;
	exports.detectOverflow = detectOverflow;
	exports.eventListeners = eventListeners;
	exports.flip = flip$1;
	exports.hide = hide$1;
	exports.offset = offset$1;
	exports.popperGenerator = popperGenerator;
	exports.popperOffsets = popperOffsets$1;
	exports.preventOverflow = preventOverflow$1;
	//# sourceMappingURL=popper.js.map


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {(function (factory) {
	   true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
	  factory();
	})((function () { 'use strict';
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    Object.defineProperty(Constructor, "prototype", {
	      writable: false
	    });
	    return Constructor;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    Object.defineProperty(subClass, "prototype", {
	      writable: false
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	    return _setPrototypeOf(o, p);
	  }
	
	  function _isNativeReflectConstruct() {
	    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
	    if (Reflect.construct.sham) return false;
	    if (typeof Proxy === "function") return true;
	
	    try {
	      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    } else if (call !== void 0) {
	      throw new TypeError("Derived constructors may only return object or undefined");
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _createSuper(Derived) {
	    var hasNativeReflectConstruct = _isNativeReflectConstruct();
	
	    return function _createSuperInternal() {
	      var Super = _getPrototypeOf(Derived),
	          result;
	
	      if (hasNativeReflectConstruct) {
	        var NewTarget = _getPrototypeOf(this).constructor;
	
	        result = Reflect.construct(Super, arguments, NewTarget);
	      } else {
	        result = Super.apply(this, arguments);
	      }
	
	      return _possibleConstructorReturn(this, result);
	    };
	  }
	
	  function _superPropBase(object, property) {
	    while (!Object.prototype.hasOwnProperty.call(object, property)) {
	      object = _getPrototypeOf(object);
	      if (object === null) break;
	    }
	
	    return object;
	  }
	
	  function _get() {
	    if (typeof Reflect !== "undefined" && Reflect.get) {
	      _get = Reflect.get.bind();
	    } else {
	      _get = function _get(target, property, receiver) {
	        var base = _superPropBase(target, property);
	
	        if (!base) return;
	        var desc = Object.getOwnPropertyDescriptor(base, property);
	
	        if (desc.get) {
	          return desc.get.call(arguments.length < 3 ? target : receiver);
	        }
	
	        return desc.value;
	      };
	    }
	
	    return _get.apply(this, arguments);
	  }
	
	  var Emitter = /*#__PURE__*/function () {
	    function Emitter() {
	      _classCallCheck(this, Emitter);
	
	      Object.defineProperty(this, 'listeners', {
	        value: {},
	        writable: true,
	        configurable: true
	      });
	    }
	
	    _createClass(Emitter, [{
	      key: "addEventListener",
	      value: function addEventListener(type, callback, options) {
	        if (!(type in this.listeners)) {
	          this.listeners[type] = [];
	        }
	
	        this.listeners[type].push({
	          callback: callback,
	          options: options
	        });
	      }
	    }, {
	      key: "removeEventListener",
	      value: function removeEventListener(type, callback) {
	        if (!(type in this.listeners)) {
	          return;
	        }
	
	        var stack = this.listeners[type];
	
	        for (var i = 0, l = stack.length; i < l; i++) {
	          if (stack[i].callback === callback) {
	            stack.splice(i, 1);
	            return;
	          }
	        }
	      }
	    }, {
	      key: "dispatchEvent",
	      value: function dispatchEvent(event) {
	        if (!(event.type in this.listeners)) {
	          return;
	        }
	
	        var stack = this.listeners[event.type];
	        var stackToCall = stack.slice();
	
	        for (var i = 0, l = stackToCall.length; i < l; i++) {
	          var listener = stackToCall[i];
	
	          try {
	            listener.callback.call(this, event);
	          } catch (e) {
	            Promise.resolve().then(function () {
	              throw e;
	            });
	          }
	
	          if (listener.options && listener.options.once) {
	            this.removeEventListener(event.type, listener.callback);
	          }
	        }
	
	        return !event.defaultPrevented;
	      }
	    }]);
	
	    return Emitter;
	  }();
	
	  var AbortSignal = /*#__PURE__*/function (_Emitter) {
	    _inherits(AbortSignal, _Emitter);
	
	    var _super = _createSuper(AbortSignal);
	
	    function AbortSignal() {
	      var _this;
	
	      _classCallCheck(this, AbortSignal);
	
	      _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
	      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
	      // the parent constructor directly instead as a workaround. For general details, see babel bug:
	      // https://github.com/babel/babel/issues/3041
	      // This hack was added as a fix for the issue described here:
	      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042
	
	      if (!_this.listeners) {
	        Emitter.call(_assertThisInitialized(_this));
	      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
	      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl
	
	
	      Object.defineProperty(_assertThisInitialized(_this), 'aborted', {
	        value: false,
	        writable: true,
	        configurable: true
	      });
	      Object.defineProperty(_assertThisInitialized(_this), 'onabort', {
	        value: null,
	        writable: true,
	        configurable: true
	      });
	      Object.defineProperty(_assertThisInitialized(_this), 'reason', {
	        value: undefined,
	        writable: true,
	        configurable: true
	      });
	      return _this;
	    }
	
	    _createClass(AbortSignal, [{
	      key: "toString",
	      value: function toString() {
	        return '[object AbortSignal]';
	      }
	    }, {
	      key: "dispatchEvent",
	      value: function dispatchEvent(event) {
	        if (event.type === 'abort') {
	          this.aborted = true;
	
	          if (typeof this.onabort === 'function') {
	            this.onabort.call(this, event);
	          }
	        }
	
	        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
	      }
	    }]);
	
	    return AbortSignal;
	  }(Emitter);
	  var AbortController = /*#__PURE__*/function () {
	    function AbortController() {
	      _classCallCheck(this, AbortController);
	
	      // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
	      // we want Object.keys(new AbortController()) to be [] for compat with the native impl
	      Object.defineProperty(this, 'signal', {
	        value: new AbortSignal(),
	        writable: true,
	        configurable: true
	      });
	    }
	
	    _createClass(AbortController, [{
	      key: "abort",
	      value: function abort(reason) {
	        var event;
	
	        try {
	          event = new Event('abort');
	        } catch (e) {
	          if (typeof document !== 'undefined') {
	            if (!document.createEvent) {
	              // For Internet Explorer 8:
	              event = document.createEventObject();
	              event.type = 'abort';
	            } else {
	              // For Internet Explorer 11:
	              event = document.createEvent('Event');
	              event.initEvent('abort', false, false);
	            }
	          } else {
	            // Fallback where document isn't available:
	            event = {
	              type: 'abort',
	              bubbles: false,
	              cancelable: false
	            };
	          }
	        }
	
	        var signalReason = reason;
	
	        if (signalReason === undefined) {
	          if (typeof document === 'undefined') {
	            signalReason = new Error('This operation was aborted');
	            signalReason.name = 'AbortError';
	          } else {
	            try {
	              signalReason = new DOMException('signal is aborted without reason');
	            } catch (err) {
	              // IE 11 does not support calling the DOMException constructor, use a
	              // regular error object on it instead.
	              signalReason = new Error('This operation was aborted');
	              signalReason.name = 'AbortError';
	            }
	          }
	        }
	
	        this.signal.reason = signalReason;
	        this.signal.dispatchEvent(event);
	      }
	    }, {
	      key: "toString",
	      value: function toString() {
	        return '[object AbortController]';
	      }
	    }]);
	
	    return AbortController;
	  }();
	
	  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	    // These are necessary to make sure that we get correct output for:
	    // Object.prototype.toString.call(new AbortController())
	    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
	    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
	  }
	
	  function polyfillNeeded(self) {
	    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
	      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
	      return true;
	    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
	    // defining window.Request, and this polyfill need to work on top of unfetch
	    // so the below feature detection needs the !self.AbortController part.
	    // The Request.prototype check is also needed because Safari versions 11.1.2
	    // up to and including 12.1.x has a window.AbortController present but still
	    // does NOT correctly implement abortable fetch:
	    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2
	
	
	    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
	  }
	
	  /**
	   * Note: the "fetch.Request" default value is available for fetch imported from
	   * the "node-fetch" package and not in browsers. This is OK since browsers
	   * will be importing umd-polyfill.js from that path "self" is passed the
	   * decorator so the default value will not be used (because browsers that define
	   * fetch also has Request). One quirky setup where self.fetch exists but
	   * self.Request does not is when the "unfetch" minimal fetch polyfill is used
	   * on top of IE11; for this case the browser will try to use the fetch.Request
	   * default value which in turn will be undefined but then then "if (Request)"
	   * will ensure that you get a patched fetch but still no Request (as expected).
	   * @param {fetch, Request = fetch.Request}
	   * @returns {fetch: abortableFetch, Request: AbortableRequest}
	   */
	
	  function abortableFetchDecorator(patchTargets) {
	    if ('function' === typeof patchTargets) {
	      patchTargets = {
	        fetch: patchTargets
	      };
	    }
	
	    var _patchTargets = patchTargets,
	        fetch = _patchTargets.fetch,
	        _patchTargets$Request = _patchTargets.Request,
	        NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
	        NativeAbortController = _patchTargets.AbortController,
	        _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
	        __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;
	
	    if (!polyfillNeeded({
	      fetch: fetch,
	      Request: NativeRequest,
	      AbortController: NativeAbortController,
	      __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
	    })) {
	      return {
	        fetch: fetch,
	        Request: Request
	      };
	    }
	
	    var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
	    // defining window.Request, and this polyfill need to work on top of unfetch
	    // hence we only patch it if it's available. Also we don't patch it if signal
	    // is already available on the Request prototype because in this case support
	    // is present and the patching below can cause a crash since it assigns to
	    // request.signal which is technically a read-only property. This latter error
	    // happens when you run the main5.js node-fetch example in the repo
	    // "abortcontroller-polyfill-examples". The exact error is:
	    //   request.signal = init.signal;
	    //   ^
	    // TypeError: Cannot set property signal of #<Request> which has only a getter
	
	    if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
	      Request = function Request(input, init) {
	        var signal;
	
	        if (init && init.signal) {
	          signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
	          // been installed because if we're running on top of a browser with a
	          // working native AbortController (i.e. the polyfill was installed due to
	          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
	          // fake AbortSignal to the native fetch will trigger:
	          // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.
	
	          delete init.signal;
	        }
	
	        var request = new NativeRequest(input, init);
	
	        if (signal) {
	          Object.defineProperty(request, 'signal', {
	            writable: false,
	            enumerable: false,
	            configurable: true,
	            value: signal
	          });
	        }
	
	        return request;
	      };
	
	      Request.prototype = NativeRequest.prototype;
	    }
	
	    var realFetch = fetch;
	
	    var abortableFetch = function abortableFetch(input, init) {
	      var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;
	
	      if (signal) {
	        var abortError;
	
	        try {
	          abortError = new DOMException('Aborted', 'AbortError');
	        } catch (err) {
	          // IE 11 does not support calling the DOMException constructor, use a
	          // regular error object on it instead.
	          abortError = new Error('Aborted');
	          abortError.name = 'AbortError';
	        } // Return early if already aborted, thus avoiding making an HTTP request
	
	
	        if (signal.aborted) {
	          return Promise.reject(abortError);
	        } // Turn an event into a promise, reject it once `abort` is dispatched
	
	
	        var cancellation = new Promise(function (_, reject) {
	          signal.addEventListener('abort', function () {
	            return reject(abortError);
	          }, {
	            once: true
	          });
	        });
	
	        if (init && init.signal) {
	          // Never pass .signal to the native implementation when the polyfill has
	          // been installed because if we're running on top of a browser with a
	          // working native AbortController (i.e. the polyfill was installed due to
	          // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
	          // fake AbortSignal to the native fetch will trigger:
	          // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
	          delete init.signal;
	        } // Return the fastest promise (don't need to wait for request to finish)
	
	
	        return Promise.race([cancellation, realFetch(input, init)]);
	      }
	
	      return realFetch(input, init);
	    };
	
	    return {
	      fetch: abortableFetch,
	      Request: Request
	    };
	  }
	
	  (function (self) {
	
	    if (!polyfillNeeded(self)) {
	      return;
	    }
	
	    if (!self.fetch) {
	      console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
	      return;
	    }
	
	    var _abortableFetch = abortableFetchDecorator(self),
	        fetch = _abortableFetch.fetch,
	        Request = _abortableFetch.Request;
	
	    self.fetch = fetch;
	    self.Request = Request;
	    Object.defineProperty(self, 'AbortController', {
	      writable: true,
	      enumerable: false,
	      configurable: true,
	      value: AbortController
	    });
	    Object.defineProperty(self, 'AbortSignal', {
	      writable: true,
	      enumerable: false,
	      configurable: true,
	      value: AbortSignal
	    });
	  })(typeof self !== 'undefined' ? self : global);
	
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useAppContext = exports.AppContextProvider = exports.APP = exports.AppContext = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define,no-unused-expressions,no-eval */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _initNav = __webpack_require__(456);
	
	var _initNav2 = _interopRequireDefault(_initNav);
	
	var _initUrl = __webpack_require__(796);
	
	var _initHoldings = __webpack_require__(794);
	
	var _initTime = __webpack_require__(795);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var isDev = document.location.href.indexOf('localhost') > 0;
	var defaultStatus = isDev ? _twd.Status.LOADED : _twd.Status.LOADING;
	
	var AppContext = exports.AppContext = _react2.default.createContext();
	var APP = exports.APP = {
	    isDev: isDev,
	    ajax: _twd.ajax,
	    publish: _twd.publish,
	    subscribe: _twd.subscribe,
	    unsubscribe: _twd.unsubscribe,
	    config: {}
	};
	global.app = APP;
	
	var AppContextProvider = exports.AppContextProvider = function AppContextProvider(_ref) {
	    var children = _ref.children;
	
	    var _React$useState = _react2.default.useState(defaultStatus),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _getUrlDefaultValues = (0, _initUrl.getUrlDefaultValues)(),
	        defaultView = _getUrlDefaultValues.defaultView,
	        defaultArgs = _getUrlDefaultValues.defaultArgs,
	        defaultModal = _getUrlDefaultValues.defaultModal,
	        defaultModalArgs = _getUrlDefaultValues.defaultModalArgs;
	
	    var _React$useState3 = _react2.default.useState(defaultView),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        view = _React$useState4[0],
	        setView = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(defaultArgs),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        args = _React$useState6[0],
	        setArgs = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(defaultModal),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        modal = _React$useState8[0],
	        setModal = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(defaultModalArgs),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        modalArgs = _React$useState10[0],
	        setModalArgs = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState(false),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        is401 = _React$useState12[0],
	        setIs401 = _React$useState12[1];
	
	    (0, _initNav2.default)({ view: view, args: args, setView: setView, setArgs: setArgs, setModal: setModal, setModalArgs: setModalArgs, setIs401: setIs401 });
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var keys, _ref3, data, cfg, tagUrl, el, etNavJs, _el, aatid;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(status !== _twd.Status.LOADING)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            keys = [
	                            // 'atmosphere_url',
	                            'notifier_url', 'bw_service_host', 'entitlements', 'user', 'previous_business_day', 'next_holiday', 'working_holiday', 'end_of_day_time', 'prev_end_of_day_time', 'state_rates', 'account_states', // todo: add user account state
	                            { 'parm': ['ENSIGHTEN-TAGGING-URL', 'BRIDGE-ETNAVJS', 'BRIDGE-ETNAVTOKEN', 'BRIDGE-AATID'] }];
	                            _context.prev = 3;
	                            _context.next = 6;
	                            return (0, _twd.ajax)({
	                                url: '/esb/generic/masterConfig?firstLoad=true',
	                                method: 'POST',
	                                body: JSON.stringify(keys)
	                            });
	
	                        case 6:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            _context.next = 10;
	                            return data;
	
	                        case 10:
	                            cfg = _context.sent;
	
	                            cfg.state_tax_rates = (0, _twd.arrayFrom)(cfg.state_rates).reduce(function (x, a) {
	                                return Object.assign({}, x, _defineProperty({}, a.Description, a.Value));
	                            }, {});
	                            APP.config = cfg;
	
	                            _context.next = 15;
	                            return initStyles();
	
	                        case 15:
	                            _context.next = 17;
	                            return (0, _twd.initTwdToken)();
	
	                        case 17:
	                            _context.next = 19;
	                            return (0, _initTime.initTime)();
	
	                        case 19:
	
	                            (0, _twd.atmosphere)(cfg, [
	                            // 'allocation',
	                            // 'account.alert.detail',
	                            // 'account.alert.summary',
	                            // 'account.alert.subscription.reject',
	                            // 'account.material.alert',
	                            'bidoffer.new', 'bidoffer.change', 'bidoffer.status', 'bidoffer.status.cancelled', 'bidoffer.status.expired', 'bidoffer.status.rejected', 'bidoffer.status.replaced', 'bidoffer.status.showing', 'circle.change', 'circle.expire', 'circle.new', 'circle.notify', 'circle.status', 'order.change', 'order.new', 'order.status', 'order.status.cancelled', 'order.status.expired', 'order.status.filled', 'order.status.rejected', 'order.statusnote'].filter(Boolean));
	
	                            tagUrl = (0, _twd.getParm)('ENSIGHTEN-TAGGING-URL');
	
	                            if (tagUrl) {
	                                // etrade provided script, creates temp style
	                                !function (e, a, n, t) {
	                                    var i = e.head;
	                                    if (i) {
	                                        if (a) return;
	                                        var o = e.createElement("style");
	                                        o.id = "alloy-prehiding";
	                                        o.innerText = n;
	                                        i.appendChild(o);
	                                        setTimeout(function () {
	                                            o.parentNode && o.parentNode.removeChild(o);
	                                        }, t);
	                                    }
	                                }(document, document.location.href.indexOf("adobe_authoring_enabled") !== -1, ".personalization-container { opacity: 0 !important }", 3000);
	
	                                el = document.createElement('script');
	
	                                el.setAttribute('type', 'text/javascript');
	                                el.setAttribute('src', tagUrl);
	                                el.setAttribute('async', true);
	                                document.head.appendChild(el);
	                            }
	
	                            etNavJs = (0, _twd.getParm)('BRIDGE-ETNAVJS');
	
	                            if (etNavJs) {
	                                global.etBellaNavToken = (0, _twd.getParm)('BRIDGE-ETNAVTOKEN');
	
	                                _el = document.createElement('script');
	
	                                _el.setAttribute('type', 'text/javascript');
	                                _el.setAttribute('src', etNavJs);
	                                document.head.appendChild(_el);
	                            }
	
	                            aatid = (0, _twd.getParm)('BRIDGE-AATID');
	
	                            if (aatid) {
	                                document.body.setAttribute('aatid', aatid);
	                            }
	
	                            _context.next = 28;
	                            return (0, _initUrl.getUrlLinkInfo)({ setView: setView, setArgs: setArgs, setModal: setModal, setModalArgs: setModalArgs });
	
	                        case 28:
	                            _context.next = 30;
	                            return (0, _initHoldings.getUserHoldings)();
	
	                        case 30:
	
	                            Array.from(document.getElementsByTagName("etrade-footer")).forEach(function (e) {
	                                return e.style.display = '';
	                            });
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 37;
	                            break;
	
	                        case 34:
	                            _context.prev = 34;
	                            _context.t0 = _context['catch'](3);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 37:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[3, 34]]);
	        }))();
	    }, [status]);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('user-holdings.app', function (rs) {
	            (0, _initHoldings.setUserHoldings)(rs);
	        });
	        return function () {
	            if (subId) (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    return _react2.default.createElement(
	        AppContext.Provider,
	        { value: Object.assign({}, APP, { is401: is401, view: view, args: args, modal: modal, modalArgs: modalArgs, status: status, Status: _twd.Status, Loading: _twd.Loading }) },
	        children
	    );
	};
	
	var initStyles = function initStyles() {
	    if ((0, _twd.getConfig)('entitlements.ETradeBlue', 'No') !== 'Yes') {
	        return;
	    }
	
	    document.documentElement.style.cssText = '\n        --primary-base-color: #1173B0;\n        --primary-dark-color: #0B4D85;\n        --secondary-base-color: #599DC8;\n        --primary-outline-color: #1173B0;\n        --primary-background-color: #1173B0;\n        --primary-disabled-color: #9CC3DD;\n        --primary-hover-color: #e9f2f9;\n        --btn-border-radius: 22px;\n        --snakbar-background-color: #002451;\n    ';
	};
	
	var useAppContext = exports.useAppContext = function useAppContext() {
	    return _react2.default.useContext(AppContext);
	};
	
	(0, _twd.$)(function () {
	    var u = new URL(location.href);
	    setTimeout(function () {
	        (0, _twd.setScroll)(u.hash);
	    }, 2000);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _faq = __webpack_require__(911);
	
	var _faq2 = _interopRequireDefault(_faq);
	
	var _overview = __webpack_require__(1087);
	
	var _overview2 = _interopRequireDefault(_overview);
	
	var _corporates = __webpack_require__(864);
	
	var _corporates2 = _interopRequireDefault(_corporates);
	
	var _municipals = __webpack_require__(973);
	
	var _municipals2 = _interopRequireDefault(_municipals);
	
	var _orders = __webpack_require__(1086);
	
	var _orders2 = _interopRequireDefault(_orders);
	
	var _orderTicket = __webpack_require__(1042);
	
	var _orderTicket2 = _interopRequireDefault(_orderTicket);
	
	var _confirm = __webpack_require__(1074);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	var _offerings = __webpack_require__(1019);
	
	var _offerings2 = _interopRequireDefault(_offerings);
	
	var _savedSearches = __webpack_require__(1114);
	
	var _savedSearches2 = _interopRequireDefault(_savedSearches);
	
	var _advancedScreener = __webpack_require__(798);
	
	var _advancedScreener2 = _interopRequireDefault(_advancedScreener);
	
	var _portfolioReport = __webpack_require__(1110);
	
	var _portfolioReport2 = _interopRequireDefault(_portfolioReport);
	
	var _sellYourBond = __webpack_require__(1116);
	
	var _sellYourBond2 = _interopRequireDefault(_sellYourBond);
	
	var _toolsAndResources = __webpack_require__(1125);
	
	var _toolsAndResources2 = _interopRequireDefault(_toolsAndResources);
	
	var _tools = __webpack_require__(1128);
	
	var _tools2 = _interopRequireDefault(_tools);
	
	var _treasuryAuctions = __webpack_require__(1149);
	
	var _treasuryAuctions2 = _interopRequireDefault(_treasuryAuctions);
	
	var _bondDetail = __webpack_require__(316);
	
	var _bondDetail2 = _interopRequireDefault(_bondDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        view = _ref.view,
	        _ref$args = _ref.args,
	        args = _ref$args === undefined ? {} : _ref$args;
	
	    return _react2.default.createElement(
	        ErrorBoundary,
	        null,
	        _react2.default.createElement(Content, { view: view, args: args })
	    );
	};
	
	var titles = {
	    overview: 'Overview - Bond Resource Center - E*TRADE',
	    corporates: 'Corporates - Bond Resource Center - E*TRADE',
	    municipals: 'Municipals - Bond Resource Center - E*TRADE',
	    'advanced-screener': 'Advanced Screener - Bond Resource Center - E*TRADE',
	    'sell-your-bond': 'Sell Your Bond - Bond Resource Center - E*TRADE',
	    'bond-detail': 'Bond Detail - Bond Resource Center - E*TRADE',
	    'offerings': 'Search Results - Bond Resource Center - E*TRADE',
	    'orders': 'View Orders - Bond Resource Center - E*TRADE',
	    'orders-confirm': 'Order - Bond Resource Center - E*TRADE',
	    'order-ticket': 'Place a Trade - Bond Resource Center - E*TRADE',
	    'tools': 'Tools and Resources - Bond Resource Center - E*TRADE',
	    'tools-and-resources': 'Tools and Resources - Bond Resource Center - E*TRADE',
	    'tools.bond-order': 'Bond Order - Bond Resource Center - E*TRADE',
	    'portfolio-report': 'Portfolio Report - Bond Resource Center - E*TRADE',
	    'treasury-auctions': 'Treasury Auctions - Bond Resource Center - E*TRADE',
	    'faq': 'Frequently Asked Questions - Bond Resource Center - E*TRADE'
	};
	
	var Content = function Content() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        view = _ref2.view,
	        _ref2$args = _ref2.args,
	        args = _ref2$args === undefined ? {} : _ref2$args;
	
	    args = args || {};
	
	    if (view === 'bond-detail') {
	        if (args.last) {
	            args.from = (_twd.Views.history[_twd.Views.index] || [])[0] || '';
	            delete args.last;
	        }
	        if (!args.cusip) {
	            view = 'overview';
	        }
	    }
	
	    view = view === 'search-results' ? 'advanced-screener' : view;
	
	    if (TRACKABLE_LOCATIONS.indexOf(args.view || view) >= 0) {
	        (0, _twd.setLastLoc)(args);
	    }
	
	    _react2.default.useEffect(function () {
	        (0, _twd.trackView)(view, args);
	
	        document.title = titles[args.view || view] || 'Bond Resource Center - E*TRADE';
	    }, [view, args]);
	
	    return _react2.default.createElement(
	        'div',
	        { id: 'content', style: { minHeight: '150px' } },
	        view === 'overview' ? _react2.default.createElement(_overview2.default, args) : view === 'corporates' ? _react2.default.createElement(_corporates2.default, args) : view === 'municipals' ? _react2.default.createElement(_municipals2.default, args) : view === 'advanced-screener' ? _react2.default.createElement(_advancedScreener2.default, args) : view === 'sell-your-bond' ? _react2.default.createElement(_sellYourBond2.default, args) : view === 'tools-and-resources' ? _react2.default.createElement(_toolsAndResources2.default, args) : view === 'bond-detail' ? _react2.default.createElement(_bondDetail2.default, args) : view === 'offerings' ? _react2.default.createElement(_offerings2.default, args) : view === 'orders' ? _react2.default.createElement(_orders2.default, args) : view === 'order-ticket' ? _react2.default.createElement(_orderTicket2.default, args) : view === 'orders-confirm' ? _react2.default.createElement(_confirm2.default, args) : view === 'portfolio-report' ? _react2.default.createElement(_portfolioReport2.default, args) : view === 'saved-searches' ? _react2.default.createElement(_savedSearches2.default, args) : view === 'treasury-auctions' ? _react2.default.createElement(_treasuryAuctions2.default, args) : view === 'tools' ? _react2.default.createElement(_tools2.default, args) : view === 'tools.bond-order' ? _react2.default.createElement(_tools2.default, args) : view === 'faq' ? _react2.default.createElement(_faq2.default, args) : _react2.default.createElement(_overview2.default, args)
	    );
	};
	
	var TRACKABLE_LOCATIONS = ['overview', 'corporates', 'municipals', 'advanced-screener', 'tools-and-resources', 'offerings', 'orders', 'portfolio-report', 'treasury-auctions', 'tools', 'faq'];
	
	var ErrorBoundary = function (_React$Component) {
	    _inherits(ErrorBoundary, _React$Component);
	
	    function ErrorBoundary(props) {
	        _classCallCheck(this, ErrorBoundary);
	
	        var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));
	
	        _this.state = { hasError: false };
	        return _this;
	    }
	
	    _createClass(ErrorBoundary, [{
	        key: 'componentDidCatch',
	        value: function componentDidCatch(error) {
	            console.log('ERROR', error);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.state.hasError) {
	                // eslint-disable-next-line
	                this.state.hasError = false;
	
	                setTimeout(function () {
	                    return (0, _twd.publish)('error-boundary');
	                });
	                return _react2.default.createElement(Content, { view: '' });
	            }
	            return this.props.children;
	        }
	    }], [{
	        key: 'getDerivedStateFromError',
	        value: function getDerivedStateFromError(error) {
	            return { hasError: true };
	        }
	    }]);
	
	    return ErrorBoundary;
	}(_react2.default.Component);

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? 'Important Disclosures' : _ref$title,
	        _ref$html = _ref.html,
	        html = _ref$html === undefined ? '-' : _ref$html,
	        _ref$modalClass = _ref.modalClass,
	        modalClass = _ref$modalClass === undefined ? 'modal-dialog modal-md' : _ref$modalClass,
	        buttons = _ref.buttons,
	        _ref$buttonClass = _ref.buttonClass,
	        buttonClass = _ref$buttonClass === undefined ? 'col-centered-8' : _ref$buttonClass,
	        _ref$buttonStyle = _ref.buttonStyle,
	        buttonStyle = _ref$buttonStyle === undefined ? { display: 'flex' } : _ref$buttonStyle,
	        _ref$isTitleHTML = _ref.isTitleHTML,
	        isTitleHTML = _ref$isTitleHTML === undefined ? false : _ref$isTitleHTML;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: modalClass },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'close',
	                            'aria-label': 'close',
	                            'data-name': 'disclosures-close-link',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    isTitleHTML ? _react2.default.createElement('h2', { className: 'modal-title text-center vertical-offset-sm', dangerouslySetInnerHTML: { __html: title } }) : _react2.default.createElement(
	                        'h2',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement('div', { className: 'col-xs-12 col-md-12', dangerouslySetInnerHTML: { __html: html } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: buttonClass, style: buttonStyle },
	                            buttons && (0, _twd.arrayFrom)(buttons).map(function (b, i) {
	                                return _react2.default.createElement(
	                                    'button',
	                                    { type: 'button', key: i,
	                                        style: b.style || {},
	                                        className: b.className || 'btn btn-primary',
	                                        onClick: b.onClick },
	                                    b.label
	                                );
	                            }),
	                            !buttons && _react2.default.createElement(
	                                'button',
	                                { className: 'btn btn-block btn-primary', type: 'button',
	                                    onClick: _twd.hideModal
	                                },
	                                'Close'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        el = _React$useState2[0],
	        setEl = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(null),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        args = _React$useState4[0],
	        setArgs = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('show_flyout.app', function (_ref) {
	            var el = _ref.el,
	                args = _objectWithoutProperties(_ref, ['el']);
	
	            (0, _twd.publish)('hide_flyout');
	
	            setEl(el);
	            setArgs(args);
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, [el]);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        el && (0, _core.jsx)(_twd.Flyout, Object.assign({
	            anchorEl: el,
	            autoShow: true,
	            trigger: ["hover"],
	            contentStyle: { maxWidth: '600px', width: 'fit-content' },
	            popperStyles: {
	                maxWidth: Math.min(_twd.mediaQueries.width() - 40, 600) + 'px'
	            },
	            onHide: function onHide() {
	                setEl(null);
	                setArgs(null);
	            }
	        }, args))
	    );
	};

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setUserHoldings = exports.getUserHoldings = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var getUserHoldings = exports.getUserHoldings = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _ajax, data, rs;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldings',
	                            method: 'GET'
	                        }), data = _ajax.data;
	                        _context.next = 3;
	                        return data;
	
	                    case 3:
	                        rs = _context.sent;
	
	                        setUserHoldings(rs);
	
	                    case 5:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function getUserHoldings() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var setUserHoldings = exports.setUserHoldings = function setUserHoldings(rs) {
	    var accts = (0, _twd.arrayFrom)(rs.accounts).filter(function (a) {
	        return a.title && a.title.trim();
	    }).filter(function (_ref2) {
	        var maturity = _ref2.maturity;
	
	        var isMatured = (0, _twd.parseDate)(maturity) < Date.now();
	        return !isMatured;
	    });
	
	    (0, _twd.setConfig)({
	        holdings: (0, _twd.arrayFrom)(rs.holdings),
	        accounts: accts,
	        cusips_held: (0, _twd.arrayFrom)(rs.holdings).reduce(function (x, h) {
	            var cusip = h.cusip;
	            if (!cusip) return x;
	            if (!x[cusip]) x[cusip] = [];
	            x[cusip].push(h);
	
	            return x;
	        }, {}),
	        holdings_ts: Date.now()
	    });
	};

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initTime = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var initTime = exports.initTime = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _ref2, data, now, est, tz, eod, peod;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return (0, _twd.ajax)({
	                            url: '/esb/uit/order/getEstTime?firstLoad=true',
	                            method: 'GET'
	                        });
	
	                    case 3:
	                        _ref2 = _context.sent;
	                        data = _ref2.data;
	                        now = new Date();
	                        _context.t0 = Date;
	                        _context.next = 9;
	                        return data;
	
	                    case 9:
	                        _context.t1 = _context.sent;
	
	                        if (_context.t1) {
	                            _context.next = 12;
	                            break;
	                        }
	
	                        _context.t1 = {};
	
	                    case 12:
	                        _context.t2 = _context.t1.est;
	                        est = new _context.t0(_context.t2);
	                        tz = Math.round((est - now.valueOf()) / 1000 / 60 / 60);
	                        eod = new Date((0, _twd.getConfig)('end_of_day_time'));
	                        // eod = new Date(eod.setHours(eod.getHours() + tz))
	
	                        peod = new Date((0, _twd.getConfig)('prev_end_of_day_time'));
	                        // peod = new Date(eod.setHours(eod.getHours() + tz))
	
	                        (0, _twd.setConfig)({
	                            timezoneOffset: tz,
	                            startServerTime: new Date(now.setHours(now.getHours() + tz)),
	
	                            endOfDayTime: isNaN(eod) ? 1700 : Math.min(eod.getHours() * 100 + eod.getMinutes(), 1700),
	
	                            previousEndOfDayTime: isNaN(peod) ? 1700 : Math.min(peod.getHours() * 100 + peod.getMinutes(), 1700)
	
	                        });
	                        _context.next = 22;
	                        break;
	
	                    case 20:
	                        _context.prev = 20;
	                        _context.t3 = _context['catch'](0);
	
	                    case 22:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[0, 20]]);
	    }));
	
	    return function initTime() {
	        return _ref.apply(this, arguments);
	    };
	}();

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUrlLinkInfo = exports.getUrlDefaultValues = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _twd = __webpack_require__(2);
	
	var _initNav = __webpack_require__(456);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getUrlDefaultValues = exports.getUrlDefaultValues = function getUrlDefaultValues() {
	    var defaultView = 'overview';
	    var defaultArgs = {};
	    var defaultModal = '';
	    var defaultModalArgs = {};
	
	    var u = new URL(location.href);
	    var sp = u.searchParams;
	    if (sp.has('show')) {
	        defaultView = sp.get('show').split('.')[0];
	
	        var p = { view: sp.get('show') };
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = sp.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _ref = _step.value;
	
	                var _ref2 = _slicedToArray(_ref, 2);
	
	                var k = _ref2[0];
	                var v = _ref2[1];
	
	                p[k] = v;
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	
	        defaultArgs = p;
	    } else if (u.hash) {
	        var h = u.hash.slice(1);
	        defaultView = h.split('.')[0];
	
	        var _p = { view: h };
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = sp.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _ref3 = _step2.value;
	
	                var _ref4 = _slicedToArray(_ref3, 2);
	
	                var _k = _ref4[0];
	                var _v = _ref4[1];
	
	                _p[_k] = _v;
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                    _iterator2.return();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        defaultArgs = _p;
	    }
	
	    if (sp.has('modal')) {
	        defaultModal = sp.get('modal').split('.')[0];
	
	        var _p2 = {};
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = sp.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var _ref5 = _step3.value;
	
	                var _ref6 = _slicedToArray(_ref5, 2);
	
	                var _k2 = _ref6[0];
	                var _v2 = _ref6[1];
	
	                _p2[_k2] = _v2;
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                    _iterator3.return();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        defaultModalArgs = _p2;
	    }
	
	    return {
	        defaultView: defaultView, defaultArgs: defaultArgs,
	        defaultModal: defaultModal, defaultModalArgs: defaultModalArgs
	    };
	};
	
	var getUrlLinkInfo = exports.getUrlLinkInfo = function () {
	    var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref7) {
	        var setView = _ref7.setView,
	            setArgs = _ref7.setArgs,
	            setModal = _ref7.setModal,
	            setModalArgs = _ref7.setModalArgs;
	
	        var u, sp, action, infoId, _ref9, data, _sp, nav, url, view, args, origin, cusip, acctNo, _ref10, acct_, isSell, orderNo, _ajax, _data, _action, sourceAction, rs, gn, pn, _ref11, _data2, _sp2, _adjustView, _adjustView2, v, a, m, mA;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        u = new URL(location.href);
	                        sp = u.searchParams;
	                        action = sp.get('action');
	                        infoId = sp.get('infoId');
	
	                        if (!(!action || !infoId)) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 6:
	                        _context.prev = 6;
	                        _context.next = 9;
	                        return (0, _twd.ajax)({
	                            url: '/esb/report/emailTemplates/linkInfo/' + infoId,
	                            method: 'GET',
	                            params: { action: action }
	                        });
	
	                    case 9:
	                        _ref9 = _context.sent;
	                        data = _ref9.data;
	                        _context.t0 = URLSearchParams;
	                        _context.next = 14;
	                        return data;
	
	                    case 14:
	                        _context.t2 = _context.sent;
	
	                        if (_context.t2) {
	                            _context.next = 17;
	                            break;
	                        }
	
	                        _context.t2 = {};
	
	                    case 17:
	                        _context.t1 = _context.t2.params;
	
	                        if (_context.t1) {
	                            _context.next = 20;
	                            break;
	                        }
	
	                        _context.t1 = '';
	
	                    case 20:
	                        _context.t3 = _context.t1;
	                        _sp = new _context.t0(_context.t3);
	                        nav = _sp.get('pa-nav');
	
	                        if (nav) {
	                            _context.next = 25;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 25:
	                        url = (0, _twd.safeURL)(_sp.get('pa-arg'));
	
	                        if (url) {
	                            _context.next = 28;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 28:
	                        view = 'tools';
	                        args = { view: 'tools.load-url', url: url.toString(), frameName: 'content' };
	                        origin = (0, _twd.setOrigin)(url.searchParams.get('p_from'));
	
	                        if (!(nav === 'pa-nav-blotter')) {
	                            _context.next = 36;
	                            break;
	                        }
	
	                        view = 'orders';
	                        args = { view: 'orders' };
	                        _context.next = 117;
	                        break;
	
	                    case 36:
	                        if (!(nav === 'pa-nav-issue')) {
	                            _context.next = 42;
	                            break;
	                        }
	
	                        cusip = url.searchParams.get('p_cusip');
	
	                        view = 'bond-detail';
	                        args = {
	                            view: 'bond-detail.bond-detail',
	                            cusip: cusip,
	                            from: (0, _twd.safeURL)(origin),
	                            showBackLink: 'N'
	                        };
	                        _context.next = 117;
	                        break;
	
	                    case 42:
	                        if (!((nav === 'pa-nav-order' || nav === 'pa-nav-get-bond-quote') && (0, _twd.getConfig)('entitlements.ETradeOrderTicket', 'No') === 'Yes')) {
	                            _context.next = 63;
	                            break;
	                        }
	
	                        view = 'order-ticket';
	
	                        acctNo = url.searchParams.get('p_acct_no');
	
	                        if (!(acctNo && url.searchParams.get("p_acct_no_encrypted") === 'Y')) {
	                            _context.next = 60;
	                            break;
	                        }
	
	                        _context.prev = 46;
	                        _context.next = 49;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/trades/accountTransform',
	                            method: 'POST',
	                            headers_: {
	                                'Content-Type': 'application/x-www-form-urlencoded'
	                            },
	                            type: 'text',
	                            body: (0, _twd.toQueryString)({
	                                p_acct_no: acctNo
	                            })
	                        });
	
	                    case 49:
	                        _ref10 = _context.sent;
	                        acct_ = _ref10.data;
	                        _context.next = 53;
	                        return acct_;
	
	                    case 53:
	                        acctNo = _context.sent;
	                        _context.next = 60;
	                        break;
	
	                    case 56:
	                        _context.prev = 56;
	                        _context.t4 = _context['catch'](46);
	
	                        console.error('init-url.order-ticket', _context.t4);
	                        acctNo = null;
	
	                    case 60:
	
	                        args = (0, _twd.cleanObject)({
	                            view: 'order-ticket.order-ticket',
	                            acctNo: acctNo,
	                            cusip: url.searchParams.get('p_cusip'),
	                            action: url.searchParams.get('p_action'),
	                            qty: url.searchParams.get('p_qty') || url.searchParams.get('p_quantity'),
	                            from: (0, _twd.safeURL)(origin)
	                        });
	                        _context.next = 117;
	                        break;
	
	                    case 63:
	                        if (!((nav === 'pa-nav-buy-quote' || nav === 'pa-nav-sell-quote') && (0, _twd.getConfig)('entitlements.ETradeOrderTicket', 'No') === 'Yes')) {
	                            _context.next = 81;
	                            break;
	                        }
	
	                        view = 'order-ticket';
	
	                        isSell = nav === 'pa-nav-sell-quote';
	                        orderNo = url.searchParams.get('p_quote_id');
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/retailservice/etradeBestQuote/' + orderNo,
	                            method: 'GET',
	                            params: {
	                                side: isSell ? 'S' : 'B'
	                            }
	                        }), _data = _ajax.data;
	                        _action = isSell ? 'S' : 'B';
	                        sourceAction = isSell ? 'Y' : 'Z';
	                        _context.next = 72;
	                        return _data;
	
	                    case 72:
	                        _context.t5 = _context.sent;
	
	                        if (_context.t5) {
	                            _context.next = 75;
	                            break;
	                        }
	
	                        _context.t5 = {};
	
	                    case 75:
	                        _context.next = 77;
	                        return _context.t5;
	
	                    case 77:
	                        rs = _context.sent;
	
	                        args = (0, _twd.cleanObject)({
	                            view: 'order-ticket.order-ticket',
	                            acctNo: url.searchParams.get('p_acct_no') || rs.accountNumber,
	                            cusip: rs.cusip,
	                            action: _action,
	                            qty: rs.quantity,
	                            price: rs.price,
	                            yld: rs['yield'],
	                            sourceAction: sourceAction,
	                            sourceOrderNo: orderNo + '|' + (rs.quoteId || ''),
	                            from: (0, _twd.safeURL)(origin)
	                        });
	                        _context.next = 117;
	                        break;
	
	                    case 81:
	                        if (!(nav === 'pa-nav-get-bond-quote')) {
	                            _context.next = 85;
	                            break;
	                        }
	
	                        args = {
	                            view: 'tools.get-a-bond-quote',
	                            url: url.toString(),
	                            actionSubset: 'WF',
	                            ts: Date.now()
	                        };
	                        _context.next = 117;
	                        break;
	
	                    case 85:
	                        if (!(nav === 'pa-nav-ladder-builder')) {
	                            _context.next = 90;
	                            break;
	                        }
	
	                        view = 'bond-ladder-builder';
	                        args = {};
	                        _context.next = 117;
	                        break;
	
	                    case 90:
	                        if (!(nav === 'pa-nav-bond-advanced-search')) {
	                            _context.next = 95;
	                            break;
	                        }
	
	                        view = 'advanced-screener';
	                        args = { view: 'advanced-screener' };
	                        _context.next = 117;
	                        break;
	
	                    case 95:
	                        if (!(nav === 'pa-nav-run-saved-search')) {
	                            _context.next = 116;
	                            break;
	                        }
	
	                        view = 'overview';
	                        args = { view: 'overview' };
	
	                        gn = 'FIXED_INCOME_SOLUTION_CENTER';
	                        pn = url.searchParams.get('p_query_name');
	                        _context.next = 102;
	                        return (0, _twd.ajax)({
	                            url: '/esb/retailservice/fixedIncomeSystemSearchService/getByQueryNameList',
	                            method: 'POST',
	                            params: {
	                                quickPickGroupSubType: gn,
	                                quickPickItemNameList: [pn]
	                            }
	                        });
	
	                    case 102:
	                        _ref11 = _context.sent;
	                        _data2 = _ref11.data;
	                        _context.t6 = _twd.parseJson;
	                        _context.t7 = _twd.pickObject;
	                        _context.next = 108;
	                        return _data2;
	
	                    case 108:
	                        _context.t8 = _context.sent;
	                        _context.t9 = 'fixedIncomeSystemSearchDto.' + gn + '.' + pn;
	                        _context.t10 = {};
	                        _context.t11 = (0, _context.t7)(_context.t8, _context.t9, _context.t10).queryText;
	                        _sp2 = (0, _context.t6)(_context.t11);
	
	
	                        if (_sp2) {
	                            view = 'offerings';
	                            delete _sp2['savedQuickPickId'];
	                            args = {
	                                view: view,
	                                searchParams: Object.assign({
	                                    persistToPreviousSearches: false
	                                }, _sp2),
	                                _ts: Date.now()
	                            };
	                        }
	                        _context.next = 117;
	                        break;
	
	                    case 116:
	                        if (nav === 'pa-nav-primary-cds') {
	                            view = 'offerings';
	                            args = {
	                                view: view,
	                                searchParams: {
	                                    holdInvType: ['S'],
	                                    offeringType: ['primary', 'ask-side'],
	                                    primarySecondary: ['primary'],
	                                    persistToPreviousSearches: false
	                                },
	                                _ts: Date.now(),
	                                from: 'overview'
	                            };
	                        } else if (nav === 'pa-nav-program-notes') {
	                            view = 'offerings';
	                            args = {
	                                view: view,
	                                searchParams: {
	                                    holdInvType: ['C'],
	                                    offeringType: ['primary', 'ask-side'],
	                                    primarySecondary: ['primary'],
	                                    persistToPreviousSearches: false
	                                },
	                                _ts: Date.now(),
	                                from: 'overview'
	                            };
	                        }
	
	                    case 117:
	                        _adjustView = (0, _initNav.adjustView)({ view: view, args: args }), _adjustView2 = _slicedToArray(_adjustView, 4), v = _adjustView2[0], a = _adjustView2[1], m = _adjustView2[2], mA = _adjustView2[3];
	
	                        if (v) {
	                            setArgs(a);
	                            setView(v);
	                        }
	                        if (m) {
	                            setModalArgs(mA);
	                            setModal(m);
	                        }
	
	                        _context.next = 125;
	                        break;
	
	                    case 122:
	                        _context.prev = 122;
	                        _context.t12 = _context['catch'](6);
	
	                        console.log('init-error', _context.t12);
	
	                    case 125:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[6, 122], [46, 56]]);
	    }));
	
	    return function getUrlLinkInfo(_x) {
	        return _ref8.apply(this, arguments);
	    };
	}();

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _modal = __webpack_require__(861);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _modal3 = __webpack_require__(876);
	
	var _modal4 = _interopRequireDefault(_modal3);
	
	var _disclosures = __webpack_require__(792);
	
	var _disclosures2 = _interopRequireDefault(_disclosures);
	
	var _alertsModal = __webpack_require__(922);
	
	var _alertsModal2 = _interopRequireDefault(_alertsModal);
	
	var _holdingsModal = __webpack_require__(936);
	
	var _holdingsModal2 = _interopRequireDefault(_holdingsModal);
	
	var _manageSavedSearches = __webpack_require__(1111);
	
	var _manageSavedSearches2 = _interopRequireDefault(_manageSavedSearches);
	
	var _modal5 = __webpack_require__(967);
	
	var _modal6 = _interopRequireDefault(_modal5);
	
	var _tradeHistory = __webpack_require__(1143);
	
	var _tradeHistory2 = _interopRequireDefault(_tradeHistory);
	
	var _depthOfMarket = __webpack_require__(1003);
	
	var _depthOfMarket2 = _interopRequireDefault(_depthOfMarket);
	
	var _modal7 = __webpack_require__(1017);
	
	var _modal8 = _interopRequireDefault(_modal7);
	
	var _modal9 = __webpack_require__(1083);
	
	var _modal10 = _interopRequireDefault(_modal9);
	
	var _modal11 = __webpack_require__(1108);
	
	var _modal12 = _interopRequireDefault(_modal11);
	
	var _saveSearch = __webpack_require__(1113);
	
	var _saveSearch2 = _interopRequireDefault(_saveSearch);
	
	var _teyCalculator = __webpack_require__(331);
	
	var _teyCalculator2 = _interopRequireDefault(_teyCalculator);
	
	var _underwriterModal = __webpack_require__(831);
	
	var _underwriterModal2 = _interopRequireDefault(_underwriterModal);
	
	var _arsInfoModal = __webpack_require__(809);
	
	var _arsInfoModal2 = _interopRequireDefault(_arsInfoModal);
	
	var _f2fInfoModal = __webpack_require__(820);
	
	var _f2fInfoModal2 = _interopRequireDefault(_f2fInfoModal);
	
	var _mbsSpeedModal = __webpack_require__(824);
	
	var _mbsSpeedModal2 = _interopRequireDefault(_mbsSpeedModal);
	
	var _multiStepCouponModal = __webpack_require__(826);
	
	var _multiStepCouponModal2 = _interopRequireDefault(_multiStepCouponModal);
	
	var _modal13 = __webpack_require__(818);
	
	var _modal14 = _interopRequireDefault(_modal13);
	
	var _factorsModal = __webpack_require__(821);
	
	var _factorsModal2 = _interopRequireDefault(_factorsModal);
	
	var _searchModal = __webpack_require__(1046);
	
	var _searchModal2 = _interopRequireDefault(_searchModal);
	
	var _duplicateOrderModal = __webpack_require__(1023);
	
	var _duplicateOrderModal2 = _interopRequireDefault(_duplicateOrderModal);
	
	var _priceChangeNoticeModal = __webpack_require__(1044);
	
	var _priceChangeNoticeModal2 = _interopRequireDefault(_priceChangeNoticeModal);
	
	var _attestationsModal = __webpack_require__(1027);
	
	var _attestationsModal2 = _interopRequireDefault(_attestationsModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onModalKeydown = function onModalKeydown(ev) {
	    (0, _twd.trapFocus)(this, ev);
	}; /* eslint-disable no-use-before-define */
	
	exports.default = function (_ref) {
	    var view = _ref.view,
	        args = _ref.args;
	
	    var ts = (args || {}).ts;
	    var ref = _react2.default.useRef(null);
	
	    _react2.default.useEffect(function () {
	        (0, _twd.$)('#modal').modal(view ? 'show' : 'hide');
	
	        if (view) {
	            (0, _twd.$)('#modal').one('hidden.bs.modal', function () {
	                (0, _twd.publish)('hide_flyout');
	                (0, _twd.returnModalFocus)();
	            });
	        }
	
	        setTimeout(function () {
	            var fe = (0, _twd.$)('#modal .focus-on-load');
	            if (fe.length > 0) {
	                fe.focus();
	                return;
	            }
	
	            var fs = (0, _twd.$)('#modal :focusable');
	            if (fs.eq(0).focus().length === 0) {
	                (0, _twd.$)('#modal a.close').eq(0).focus();
	            }
	        }, 200);
	    }, [view, ts]);
	
	    _react2.default.useEffect(function () {
	        var el = ref.current;
	        if (!el) return;
	
	        el.removeEventListener('keydown', onModalKeydown);
	        el.addEventListener('keydown', onModalKeydown);
	        return function () {
	            el.removeEventListener('keydown', onModalKeydown);
	        };
	    }, [ref]);
	
	    var cmp = view === 'corporates-market-news-modal' ? _react2.default.createElement(_modal4.default, args) : view === 'depth-of-market' ? _react2.default.createElement(_depthOfMarket2.default, args) : view === 'disclosures' ? _react2.default.createElement(_disclosures2.default, args) : view === 'holdings' ? _react2.default.createElement(_holdingsModal2.default, args) : view === 'alerts' ? _react2.default.createElement(_alertsModal2.default, args) : view === 'calculator' ? _react2.default.createElement(_modal2.default, args) : view === 'manage-saved-searches' ? _react2.default.createElement(_manageSavedSearches2.default, args) : view === 'municipals-market-news-modal' ? _react2.default.createElement(_modal6.default, args) : view === 'offerings-modal' ? _react2.default.createElement(_modal8.default, args) : view === 'order-detail' ? _react2.default.createElement(_modal10.default, args) : view === 'portfolio-report-modal' ? _react2.default.createElement(_modal12.default, args) : view === 'save-search' ? _react2.default.createElement(_saveSearch2.default, args) : view === 'underwriter' ? _react2.default.createElement(_underwriterModal2.default, args) : view === 'ars-info' ? _react2.default.createElement(_arsInfoModal2.default, args) : view === 'f2f-info' ? _react2.default.createElement(_f2fInfoModal2.default, args) : view === 'mbs-speed' ? _react2.default.createElement(_mbsSpeedModal2.default, args) : view === 'multi-step-coupon' ? _react2.default.createElement(_multiStepCouponModal2.default, args) : view === 'events' ? _react2.default.createElement(_modal14.default, args) : view === 'factors' ? _react2.default.createElement(_factorsModal2.default, args) : view === 'tey-calculator' ? _react2.default.createElement(_teyCalculator2.default, args) : view === 'trade-history' ? _react2.default.createElement(_tradeHistory2.default, args) : view === 'order-ticket-search-modal' ? _react2.default.createElement(_searchModal2.default, args) : view === 'order-ticket-duplicate-order-modal' ? _react2.default.createElement(_duplicateOrderModal2.default, args) : view === 'order-ticket-price-change-notice-modal' ? _react2.default.createElement(_priceChangeNoticeModal2.default, args) : view === 'order-ticket-attestations-modal' ? _react2.default.createElement(_attestationsModal2.default, args) : null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { ref: ref, className: 'modal', id: 'modal', role: 'dialog', 'data-backdrop': 'static' },
	            cmp
	        )
	    );
	};
	
	(function ($) {
	    function visible(element) {
	        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
	            return $.css(this, 'visibility') === 'hidden';
	        }).length;
	    }
	
	    function _focusable(element) {
	        var map,
	            mapName,
	            img,
	            nodeName = element.nodeName.toLowerCase();
	        var isTabIndexNotNaN = !isNaN($.attr(element, 'tabindex'));
	        if ('area' === nodeName) {
	            map = element.parentNode;
	            mapName = map.name;
	            if (!element.href || !mapName || map.nodeName.toLowerCase() !== 'map') {
	                return false;
	            }
	            img = $('img[usemap=#' + mapName + ']')[0];
	            return !!img && visible(img);
	        }
	
	        if (!visible(element)) return false;
	
	        if (/input|select|textarea|button|object/.test(nodeName)) {
	            return !element.disabled;
	        }
	
	        if ('a' === nodeName) {
	            return element.href || isTabIndexNotNaN;
	        }
	
	        return isTabIndexNotNaN;
	    }
	
	    $.extend($.expr[':'], {
	        focusable: function focusable(element) {
	            return _focusable(element);
	        }
	    });
	})(_twd.$);

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _searchForm = __webpack_require__(802);
	
	var _searchForm2 = _interopRequireDefault(_searchForm);
	
	var _recentSearches = __webpack_require__(458);
	
	var _recentSearches2 = _interopRequireDefault(_recentSearches);
	
	var _savedSearches = __webpack_require__(459);
	
	var _savedSearches2 = _interopRequireDefault(_savedSearches);
	
	var _knowledgeCenter = __webpack_require__(457);
	
	var _knowledgeCenter2 = _interopRequireDefault(_knowledgeCenter);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var view = _ref.view,
	        searchParams = _ref.searchParams;
	
	    (0, _twd.trackPage)('advanced-screener');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-9 col-xs-12' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'large-header' },
	                        'Advanced Screener'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-3 col-xs-12 text-right' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'advanced-screener-sell-your-bond-link',
	                            className: 'btn btn-link',
	                            onClick: function onClick() {
	                                return (0, _twd.show)('sell-your-bond', { from: "advanced-screener" });
	                            }
	                        },
	                        'Sell your bond'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-lg' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8 col-xs-12' },
	                        _react2.default.createElement(_searchForm2.default, { searchParams: searchParams, invType: view.split('.')[1] })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-xs-12' },
	                        _react2.default.createElement(_recentSearches2.default, { dataName: 'advanced-screener-recent-searches' }),
	                        _react2.default.createElement(_savedSearches2.default, { dataName: 'advanced-screener-saved-searches' }),
	                        _react2.default.createElement(_knowledgeCenter2.default, { dataName: 'advanced-screener-knowledge-center' })
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        recentSearches = _React$useState4[0],
	        setRecentSearches = _React$useState4[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        var dismounted = false;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, data, abort, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(status !== _twd.Status.LOADING)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _ajax = (0, _twd.ajax)({
	                                url: '/esb/generic/masterConfig',
	                                params: ['portfolio_recent_searches']
	                            }), data = _ajax.data, abort = _ajax.abort;
	
	                            lastAbort.current = abort;
	
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            _context.t0 = _context.sent.portfolio_recent_searches;
	
	                            if (_context.t0) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.t0 = [];
	
	                        case 11:
	                            _context.t1 = function (a) {
	                                a.searchParams = (a.queryText || {}).metadata || a.queryText || {};
	                                return a;
	                            };
	
	                            _context.t2 = function (a) {
	                                return a.searchParams.searchType === 'offers';
	                            };
	
	                            rs = _context.t0.map(_context.t1).filter(_context.t2).slice(0, 5);
	
	                            if (!dismounted) {
	                                _context.next = 16;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 16:
	
	                            setRecentSearches(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 25;
	                            break;
	
	                        case 20:
	                            _context.prev = 20;
	                            _context.t3 = _context['catch'](2);
	
	                            if (!dismounted) {
	                                _context.next = 24;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 24:
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 25:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 20]]);
	        }))();
	
	        return function () {
	            dismounted = true;
	
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	        };
	    }, []);
	
	    return { status: status, recentSearches: recentSearches };
	};

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        savedSearches = _React$useState4[0],
	        setSavedSearches = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(Date.now()),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        ts = _React$useState6[0],
	        setTs = _React$useState6[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        var dismounted = false;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, data, abort, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(status !== _twd.Status.LOADING)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _ajax = (0, _twd.ajax)({
	                                url: '/esb/portfolio/savedQuerySearchByCurrentUser',
	                                method: 'GET'
	                            }), data = _ajax.data, abort = _ajax.abort;
	
	                            lastAbort.current = abort;
	
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            _context.t0 = _context.sent;
	
	                            if (_context.t0) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.t0 = [];
	
	                        case 11:
	                            _context.t1 = function (a) {
	                                a.modified = new Date(a.modified);
	                                a.queryText = (0, _twd.parseJson)(a.formText);
	                                a.searchParams = (a.queryText || {}).metadata || a.queryText || {};
	                                return a;
	                            };
	
	                            _context.t2 = function (a) {
	                                return a.searchParams.searchType === 'offers';
	                            };
	
	                            _context.t3 = function (a, b) {
	                                return b.modified.valueOf() - a.modified.valueOf();
	                            };
	
	                            rs = _context.t0.map(_context.t1).filter(_context.t2).sort(_context.t3);
	
	                            if (!dismounted) {
	                                _context.next = 17;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 17:
	
	                            setSavedSearches(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 26;
	                            break;
	
	                        case 21:
	                            _context.prev = 21;
	                            _context.t4 = _context['catch'](2);
	
	                            if (!dismounted) {
	                                _context.next = 25;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 25:
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 26:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 21]]);
	        }))();
	
	        return function () {
	            dismounted = true;
	
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	        };
	    }, [ts]);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('search_saved.advanced_screener_use_saved_searches', function () {
	            setStatus(_twd.Status.LOADING);
	            setTs(Date.now());
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('manage_saved_searches.advanced_screener_use_saved_searches', function () {
	            setStatus(_twd.Status.LOADING);
	            setTs(Date.now());
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    return { status: status, savedSearches: savedSearches };
	};

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1774);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _securitiesField = __webpack_require__(803);
	
	var _securitiesField2 = _interopRequireDefault(_securitiesField);
	
	var _saveSearchButton = __webpack_require__(461);
	
	var _saveSearchButton2 = _interopRequireDefault(_saveSearchButton);
	
	var _submitButton = __webpack_require__(804);
	
	var _submitButton2 = _interopRequireDefault(_submitButton);
	
	var _symbolField = __webpack_require__(806);
	
	var _symbolField2 = _interopRequireDefault(_symbolField);
	
	var _formFieldArrays = __webpack_require__(460);
	
	var _fromSearchParams = __webpack_require__(315);
	
	var _toSearchParams = __webpack_require__(194);
	
	var _toSearchParams2 = _interopRequireDefault(_toSearchParams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Labels = _twd.Fields.Labels;
	
	
	var getResetValues = function getResetValues(curr) {
	
	    var holdInvType = (0, _twd.arrayFrom)(curr.holdInvType);
	    var a = (0, _toSearchParams2.default)(curr);
	    delete a.holdInvType;
	
	    var defaultState = (0, _twd.getConfig)('account_states.0.stateOfResidence', '');
	    var defaultValues = Object.assign({}, _fromSearchParams.initialValues, {
	        holdInvType: holdInvType,
	        muniStates: (0, _twd.arrayFrom)(defaultState).filter(Boolean).map(function (a) {
	            return 'holdState=' + a;
	        }),
	        cdBlueSky: (0, _twd.arrayFrom)(defaultState).filter(Boolean).map(function (a) {
	            return 'holdBlueSkyStateCD=' + a;
	        })
	    });
	    var b = (0, _toSearchParams2.default)(defaultValues);
	    delete b.holdInvType;
	
	    if (!(0, _twd.isEquals)(a, b)) return defaultValues;
	
	    return Object.assign({}, _fromSearchParams.initialValues, {
	        holdInvType: holdInvType,
	        corpMarketTypes: [],
	        cdMarketTypes: [],
	        cdBlueSky: [],
	        muniStates: [],
	        rating: "all-ratings",
	        holdMoodyRatingMin: "ALL",
	        holdMoodyRatingMax: "ALL",
	        holdSpRatingMin: "ALL",
	        holdSpRatingMax: "ALL",
	        holdRatingAndOr: false
	    });
	};
	
	exports.default = function (_ref) {
	    var handleSubmit = _ref.handleSubmit,
	        values = _ref.values,
	        errors = _ref.errors,
	        validateForm = _ref.validateForm,
	        resetForm = _ref.resetForm,
	        setFieldValue = _ref.setFieldValue;
	
	
	    _react2.default.useEffect(function () {
	        validateForm();
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('search_saved.advanced_screener_form', function (_ref2) {
	            var savedQueryId = _ref2.savedQueryId;
	
	            setFieldValue('savedQueryId', savedQueryId, false);
	            values.savedQueryId = savedQueryId;
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('manage_saved_searches.advanced_screener_form', function (_ref3) {
	            var deletedIds = _ref3.deletedIds;
	
	            var id = values.savedQueryId;
	            var isDeleted = (0, _twd.arrayFrom)(deletedIds).indexOf(id) >= 0;
	            if (!isDeleted) return;
	
	            setFieldValue('savedQueryId', '', false);
	            delete values.savedQueryId;
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var hasDeMinimis = (0, _twd.getConfig)('entitlements.ShowDeMinimisSearchCriteriaInOfferSearch', 'No') === 'Yes';
	    var invType = (0, _twd.arrayFrom)(values.holdInvType)[0];
	    var isCorp = invType === 'C';
	    var isMuni = invType === 'M';
	    var isCD = invType === 'S';
	    var isTreasury = invType === 'T';
	    var isAgency = invType === 'A';
	    var hasRating = !(isCD || isTreasury);
	
	    return _react2.default.createElement(
	        'form',
	        { className: 'advanced-screener-search-form-form', onSubmit: handleSubmit },
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-6' },
	                _react2.default.createElement(_twd.Flyout, { label: 'Security type', className: 'btn-label btn-flyout medium-header', html: Labels.Securities })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-6 text-right' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        'data-name': 'advanced-screener-clear-all-selections',
	                        className: 'link-button',
	                        onClick: function onClick() {
	                            resetForm(getResetValues(values));
	                            setTimeout(function () {
	                                validateForm();
	                            });
	                        }
	                    },
	                    'Clear All Selections'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_formik.FieldArray, { name: 'holdInvType', component: _securitiesField2.default })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row form-group', style: { marginBottom: 0 } },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-6 col-md-6 col-xs-12' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'advanced-screener-issue',
	                    name: 'issuer',
	                    component: _twd.Fields.Text,
	                    error: errors.issuer,
	                    label: _react2.default.createElement(_twd.Flyout, { label: 'Issuer', html: Labels.Issuer })
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-6 col-md-6 col-xs-12' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'advanced-screener-cusip',
	                    name: 'cusip',
	                    component: _twd.Fields.Text,
	                    error: errors.cusip,
	                    label: _react2.default.createElement(_twd.Flyout, { label: 'CUSIP', html: Labels.Cusip })
	                })
	            )
	        ),
	        isCorp && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row form-group', style: { marginBottom: '0px' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-3 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'corpSectors',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-corp-sectors',
	                                    emptyText: 'All sectors',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.corpSectors, listConfig: { style: { minWidth: '200px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Sectors', html: Labels.CorpSector })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-3 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'corpFeatures',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-corp-type',
	                                    options: _formFieldArrays.FormFieldArrays.corpFeatures,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Type', html: Labels.CorpFeatures })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'corpDebtRanks',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-corp-debt-ranking',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.corpDebtRanks,
	                                    listConfig: { style: { minWidth: '200px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Debt ranking', html: Labels.CorpDebtRanks })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'corpMarketTypes',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-corp-market-type',
	                                    options: _formFieldArrays.FormFieldArrays.corpMarketTypes,
	                                    listConfig: { style: { minWidth: '130px' } },
	                                    inputConfig: { style: { paddingRight: '25px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Market type', html: Labels.CorpMarketTypes })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            name: 'holdSymbol',
	                            component: _symbolField2.default,
	                            listConfig: { style: { minWidth: '230px', minHeight: '0px' } },
	                            label: _react2.default.createElement(_twd.Flyout, { label: 'Symbol', html: Labels.CorpSymbol })
	                        })
	                    )
	                )
	            )
	        ),
	        isMuni && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row form-group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-3 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'muniStates',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-muni-states',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.muniStates,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'State / Territory', html: Labels.MuniStates })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-3 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'muniCategories',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-muni-categories',
	                                    options: _formFieldArrays.FormFieldArrays.muniCategories,
	                                    listConfig: { style: { minWidth: '210px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Category', html: Labels.MuniCategories })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'muniTaxTreatments',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-muni-tax-treatment',
	                                    options: _formFieldArrays.FormFieldArrays.muniTaxTreatments,
	                                    listConfig: { style: { minWidth: '200px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Tax treatment', html: Labels.MuniTaxTreatments })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'muniPurposes',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-muni-use-of-proceeds',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.muniPurposes,
	                                    listConfig: { style: { minWidth: '150px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Use of proceeds', html: Labels.MuniPurposes })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'muniEnvironmentals',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-muni-environmental',
	                                    options: _formFieldArrays.FormFieldArrays.muniEnvironmentals,
	                                    listConfig: { style: { minWidth: '300px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Environmental', html: Labels.MuniEnvironmentals })
	                                }));
	                            }
	                        })
	                    ),
	                    hasDeMinimis && _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-3 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'muniDeminimis',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-muni-deminimis',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.muniDeminimis,
	                                    listConfig: { style: { minWidth: '250px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'De Minimis', html: Labels.MuniDeminimis })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: "col-lg-3 col-md-3 col-xs-12" + (hasDeMinimis ? ' advanced-screener-issuer-container' : '') },
	                        _react2.default.createElement(_formik.Field, {
	                            name: 'muniInsured',
	                            component: _twd.Fields.Checkbox,
	                            'data-name': 'advanced-screener-muni-insured',
	                            label: 'Insured',
	                            info: Labels.MuniInsured
	                        })
	                    )
	                )
	            )
	        ),
	        isCD && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row form-group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-3 col-md-4 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'cdBlueSky',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-cd-bluesky',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.cdBlueSky, label: _react2.default.createElement(_twd.Flyout, { label: 'Blue Sky State / Territory', html: Labels.CdBlueSky })
	                                }));
	                            }
	                        }),
	                        _react2.default.createElement(_twd.Flyout, { label: 'Blue Sky Restriction', html: Labels.BlueSkyRestriction })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-3 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'cdMarketTypes',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-cd-market-type',
	                                    options: _formFieldArrays.FormFieldArrays.cdMarketTypes,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Market type', html: Labels.CorpMarketTypes })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-lg-2 col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            name: 'cdFdic',
	                            component: _twd.Fields.Text,
	                            'data-name': 'advanced-screener-cd-fdic',
	                            label: _react2.default.createElement(_twd.Flyout, { label: 'FDIC number', html: Labels.CdFdic })
	                        })
	                    )
	                )
	            )
	        ),
	        isAgency && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row form-group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'agencyTypes',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-agency-issuer',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.agencyTypes,
	                                    listConfig: { style: { minWidth: '365px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Agency/GSE', html: Labels.AgencyTypes })
	                                }));
	                            }
	                        })
	                    )
	                )
	            )
	        ),
	        isTreasury && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row form-group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'treasuryTypes',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-treasury-type',
	                                    showSelectAll: true,
	                                    options: _formFieldArrays.FormFieldArrays.treasuryTypes,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Type', html: Labels.TreasuryTypes })
	                                }));
	                            }
	                        })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Flyout, { label: 'Maturity date', className: 'btn-label btn-flyout medium-header', html: Labels.Maturity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "row form-group" + (errors.holdMaturity ? ' has-error' : ''),
	                        style: Object.assign({}, errors.holdMaturity && { marginBottom: '0px' }) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-maturity-date-min',
	                            name: 'holdMaturityMin',
	                            component: _twd.Fields.Maturity,
	                            error: errors.holdMaturity,
	                            label: 'Minimum'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-maturity-date-max',
	                            name: 'holdMaturityMax',
	                            component: _twd.Fields.Maturity,
	                            error: errors.holdMaturity,
	                            label: 'Maximum'
	                        })
	                    )
	                ),
	                errors.holdMaturity && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-8' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'field-status has-error' },
	                            errors.holdMaturity
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                hasRating && _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-md-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Flyout, { label: 'Credit rating', className: 'btn-label btn-flyout medium-header', html: Labels.Rating }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row vertical-offset-xxs' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-md-12' },
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-credit-rating-investment-grade',
	                                    name: 'rating',
	                                    component: _twd.Fields.Radio,
	                                    value: 'investment-grade',
	                                    label: 'Investment Grade',
	                                    className: 'radio-inline',
	                                    onClick: function onClick() {
	                                        Object.assign(values, {
	                                            holdSpRatingMin: 'BBB-',
	                                            holdSpRatingMax: 'AAA',
	                                            holdMoodyRatingMin: 'Baa3',
	                                            holdMoodyRatingMax: 'Aaa'
	                                        });
	                                    }
	                                }),
	                                '\xA0 \xA0',
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-credit-rating-high-yield',
	                                    name: 'rating', component: _twd.Fields.Radio,
	                                    value: 'high-yield',
	                                    label: 'High Yield',
	                                    className: 'radio-inline',
	                                    onClick: function onClick() {
	                                        Object.assign(values, {
	                                            holdSpRatingMin: 'C',
	                                            holdSpRatingMax: 'BB+',
	                                            holdMoodyRatingMin: 'C',
	                                            holdMoodyRatingMax: 'Ba1'
	                                        });
	                                    }
	                                }),
	                                '\xA0 \xA0',
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-credit-rating-all-ratings',
	                                    name: 'rating', component: _twd.Fields.Radio,
	                                    value: 'all-ratings',
	                                    label: 'All ratings',
	                                    className: 'radio-inline',
	                                    onClick: function onClick() {
	                                        Object.assign(values, {
	                                            holdSpRatingMin: 'ALL',
	                                            holdSpRatingMax: 'ALL',
	                                            holdMoodyRatingMin: 'ALL',
	                                            holdMoodyRatingMax: 'ALL'
	                                        });
	                                    }
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-md-8 col-lg-6' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'Moody\'s credit rating'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: "row form-group" + (errors.holdMoodyRating ? ' has-error' : ''), style: Object.assign({}, errors.holdMoodyRating && { marginBottom: '0px' }) },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-6 col-md-6 col-lg-6' },
	                                        _react2.default.createElement(_formik.Field, {
	                                            dataName: 'advanced-screener-moodys-credit-rating-min',
	                                            name: 'holdMoodyRatingMin',
	                                            component: _twd.Fields.Rating,
	                                            ratingType: 'moodys',
	                                            error: errors.holdMoodyRating,
	                                            label: 'Minimum Moody\'s credit rating',
	                                            labelClass: 'screen-reader-only'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-6 col-md-6 col-lg-6' },
	                                        _react2.default.createElement(_formik.Field, {
	                                            dataName: 'advanced-screener-moodys-credit-rating-max',
	                                            name: 'holdMoodyRatingMax',
	                                            component: _twd.Fields.Rating,
	                                            ratingType: 'moodys',
	                                            error: errors.holdMoodyRating,
	                                            label: 'Maximum Moody\'s credit rating',
	                                            labelClass: 'screen-reader-only'
	                                        })
	                                    )
	                                ),
	                                errors.holdMoodyRating && _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-md-12' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'field-status has-error' },
	                                            errors.holdMoodyRating
	                                        )
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-md-8 col-lg-6' },
	                                _react2.default.createElement(
	                                    'label',
	                                    null,
	                                    'S&P credit rating'
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: "row form-group" + (errors.holdSpRating ? ' has-error' : ''), style: Object.assign({}, errors.holdSpRating && { marginBottom: '0px' }) },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-6 col-md-6 col-lg-6' },
	                                        _react2.default.createElement(_formik.Field, {
	                                            dataName: 'advanced-screener-sp-credit-rating-min',
	                                            name: 'holdSpRatingMin',
	                                            component: _twd.Fields.Rating,
	                                            ratingType: 'sp',
	                                            error: errors.holdSpRating,
	                                            label: 'Minimum S&P\'s credit rating',
	                                            labelClass: 'screen-reader-only'
	                                        })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-6 col-md-6 col-lg-6' },
	                                        _react2.default.createElement(_formik.Field, {
	                                            dataName: 'advanced-screener-sp-credit-rating-max',
	                                            name: 'holdSpRatingMax',
	                                            component: _twd.Fields.Rating,
	                                            ratingType: 'sp',
	                                            error: errors.holdSpRating,
	                                            label: 'Maximum S&P\'s credit rating',
	                                            labelClass: 'screen-reader-only'
	                                        })
	                                    )
	                                ),
	                                errors.holdSpRating && _react2.default.createElement(
	                                    'div',
	                                    { className: 'row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'col-xs-12 col-md-12' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            { className: 'field-status has-error' },
	                                            errors.holdSpRating
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-md-12' },
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-credit-ratings-and-or',
	                                    name: 'holdRatingAndOr',
	                                    component: _twd.Fields.Checkbox,
	                                    label: 'Results can match Moody\'s or S&P ratings selection'
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Flyout, { label: 'Price', className: 'btn-label btn-flyout medium-header', html: Labels.Price })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "row form-group" + (errors.clientPrice ? ' has-error' : ''), style: Object.assign({}, errors.clientPrice && { marginBottom: '0px' }) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-price-min',
	                            name: 'clientPriceMin',
	                            component: _twd.Fields.Price,
	                            prefix: '$',
	                            error: errors.clientPrice,
	                            label: 'Minimum'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-price-max',
	                            name: 'clientPriceMax',
	                            component: _twd.Fields.Price,
	                            prefix: '$',
	                            error: errors.clientPrice,
	                            label: 'Maximum'
	                        })
	                    )
	                ),
	                errors.clientPrice && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-8' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'field-status has-error' },
	                            errors.clientPrice
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Flyout, { label: 'Quantity', className: 'btn-label btn-flyout medium-header', html: Labels.Quantity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "row form-group" + (errors.quantity ? ' has-error' : ''), style: Object.assign({}, errors.quantity && { marginBottom: '0px' }) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-quantity-min',
	                            name: 'quantityMin',
	                            component: _twd.Fields.Quantity,
	                            prefix: '$',
	                            suffix: ',000',
	                            error: errors.quantity,
	                            label: 'Minimum'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-quantity-max',
	                            name: 'quantityMax',
	                            component: _twd.Fields.Quantity,
	                            prefix: '$',
	                            suffix: ',000',
	                            error: errors.quantity,
	                            label: 'Maximum'
	                        })
	                    )
	                ),
	                errors.quantity && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-8' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'field-status has-error' },
	                            errors.quantity
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Flyout, { label: 'Yield to worst', className: 'btn-label btn-flyout medium-header', html: Labels.Yield })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "row form-group" + (errors.offerYtw ? ' has-error' : ''), style: Object.assign({}, errors.offerYtw && { marginBottom: '0px' }) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-yield-to-worst-min',
	                            name: 'offerYtwMin',
	                            component: _twd.Fields.Yield,
	                            suffix: '%',
	                            error: errors.offerYtw,
	                            label: 'Minimum'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-yield-to-worst-max',
	                            name: 'offerYtwMax',
	                            component: _twd.Fields.Yield,
	                            suffix: '%',
	                            error: errors.offerYtw,
	                            label: 'Maximum'
	                        })
	                    )
	                ),
	                errors.offerYtw && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-8' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'field-status has-error' },
	                            errors.offerYtw
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Flyout, { label: 'Yield to maturity', className: 'btn-label btn-flyout medium-header', html: Labels.YieldToMaturity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: "row form-group" + (errors.offerYtm ? ' has-error' : ''), style: Object.assign({}, errors.offerYtm && { marginBottom: '0px' }) },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-yield-to-maturity-min',
	                            name: 'offerYtmMin',
	                            component: _twd.Fields.Yield,
	                            suffix: '%',
	                            error: errors.offerYtm,
	                            label: 'Minimum'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-4' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'advanced-screener-yield-to-maturity-max',
	                            name: 'offerYtmMax',
	                            component: _twd.Fields.Yield,
	                            suffix: '%',
	                            error: errors.offerYtm,
	                            label: 'Maximum'
	                        })
	                    )
	                ),
	                errors.offerYtm && _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-8' },
	                        _react2.default.createElement(
	                            'label',
	                            { className: 'field-status has-error' },
	                            errors.offerYtm
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(_twd.Flyout, { label: 'Coupon', className: 'btn-label btn-flyout medium-header', html: Labels.Coupon })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-4' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: "row form-group" + (errors.holdCoupon ? ' has-error' : ''), style: Object.assign({}, errors.holdCoupon && { marginBottom: '0px' }) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6 col-md-6' },
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-coupon-min',
	                                    name: 'holdCouponMin',
	                                    component: _twd.Fields.Yield,
	                                    suffix: '%',
	                                    error: errors.holdCoupon,
	                                    label: 'Minimum'
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6 col-md-6' },
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-coupon-max',
	                                    name: 'holdCouponMax',
	                                    component: _twd.Fields.Yield,
	                                    suffix: '%',
	                                    error: errors.holdCoupon,
	                                    label: 'Maximum'
	                                })
	                            )
	                        ),
	                        errors.holdCoupon && _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-md-12' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-status has-error' },
	                                    errors.holdCoupon
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-8' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row form-group', style: { marginBottom: '0px' } },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4 col-xs-12' },
	                                _react2.default.createElement(_formik.FieldArray, {
	                                    name: 'couponFrequencies',
	                                    render: function render(args) {
	                                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                            dataName: 'advanced-screener-coupon-frequency',
	                                            options: _formFieldArrays.FormFieldArrays.couponFrequencies,
	                                            label: _react2.default.createElement(_twd.Flyout, { label: 'Coupon frequency', html: _twd.Fields.Labels.CouponFrequencies })
	                                        }));
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4 col-xs-12' },
	                                _react2.default.createElement(_formik.FieldArray, {
	                                    name: 'couponPayMonths',
	                                    render: function render(args) {
	                                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                            dataName: 'advanced-screener-coupon-pay-month',
	                                            options: _formFieldArrays.FormFieldArrays.couponPayMonths,
	                                            label: _react2.default.createElement(_twd.Flyout, { label: 'Coupon pay month', html: _twd.Fields.Labels.CouponPayMonths })
	                                        }));
	                                    }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-4 col-xs-12' },
	                                _react2.default.createElement(_formik.FieldArray, {
	                                    name: 'couponFeatures',
	                                    render: function render(args) {
	                                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                            dataName: 'advanced-screener-coupon-features',
	                                            options: _formFieldArrays.FormFieldArrays.couponFeatures,
	                                            listConfig: { style: { minWidth: '200px' } },
	                                            label: _react2.default.createElement(_twd.Flyout, { label: 'Coupon features', html: _twd.Fields.Labels.CouponFeatures })
	                                        }));
	                                    }
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'medium-header' },
	                            'Redemption Features & Special Provisions'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row form-group', style: { marginBottom: '0px' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'callFeatures',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-call-features',
	                                    options: _formFieldArrays.FormFieldArrays.callFeatures,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Call features', html: _twd.Fields.Labels.CallFeatures })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'putFeatures',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-put-features',
	                                    options: _formFieldArrays.FormFieldArrays.putFeatures,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Put features', html: _twd.Fields.Labels.PutFeatures })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.FieldArray, {
	                            name: 'otherFeatures',
	                            render: function render(args) {
	                                return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                    dataName: 'advanced-screener-other-features',
	                                    options: _formFieldArrays.FormFieldArrays.otherFeatures,
	                                    listConfig: { style: { minWidth: '300px' } },
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Other features', html: _twd.Fields.Labels.OtherFeatures })
	                                }));
	                            }
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-6' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: "row form-group" + (errors.holdFirstCall ? ' has-error' : ''),
	                                style: Object.assign({}, errors.holdFirstCall && { marginBottom: '0px' }) },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6 col-md-4' },
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-next-call-date-min',
	                                    name: 'holdFirstCallMin',
	                                    component: _twd.Fields.Maturity,
	                                    error: errors.holdFirstCall,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Next call min', html: Labels.NextCall }),
	                                    labelStyle: { whiteSpace: 'nowrap' }
	                                })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-6 col-md-4' },
	                                _react2.default.createElement(_formik.Field, {
	                                    'data-name': 'advanced-screener-next-call-date-max',
	                                    name: 'holdFirstCallMax',
	                                    component: _twd.Fields.Maturity,
	                                    error: errors.holdFirstCall,
	                                    label: _react2.default.createElement(_twd.Flyout, { label: 'Next call max', html: Labels.NextCall }),
	                                    labelStyle: { whiteSpace: 'nowrap' }
	                                })
	                            )
	                        ),
	                        errors.holdFirstCall && _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-xs-12 col-md-8' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-status has-error' },
	                                    errors.holdFirstCall
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row form-group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'advanced-screener-offering-posted',
	                            name: 'offeringPosted',
	                            component: _twd.Fields.Select,
	                            options: ['Any time', 'New today'],
	                            label: 'Offering posted'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'advanced-screener-sort-by',
	                            name: 'sortBy',
	                            component: _twd.Fields.Select,
	                            options: SORT_BY,
	                            label: 'Sort by'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3 col-xs-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'advanced-screener-sort-order',
	                            name: 'sortOrder',
	                            component: _twd.Fields.Select,
	                            options: ['Ascending', 'Descending'],
	                            label: 'Sort order'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-2 col-xs-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'advanced-screener-results-per-page',
	                            name: 'resultsPerPage',
	                            component: _twd.Fields.Select,
	                            options: [5, 10, 20, 50, 100, 200, 300],
	                            label: 'Results per page',
	                            labelStyle: { whiteSpace: 'nowrap' }
	                        })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-md-xxs vertical-offset-sm-sm vertical-offset-xs-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-4' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'advanced-screener-clear-all-button',
	                        className: 'btn btn-lg btn-primary-outline btn-block',
	                        type: 'button',
	                        onClick: function onClick() {
	                            resetForm(getResetValues(values));
	                            setTimeout(function () {
	                                validateForm();
	                            });
	                        }
	                    },
	                    'Clear all '
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-4' },
	                _react2.default.createElement(_saveSearchButton2.default, { errors: errors, values: values })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-4' },
	                _react2.default.createElement(_submitButton2.default, { errors: errors, values: values })
	            )
	        )
	    );
	};
	
	var SORT_BY = [{ label: 'Quantity', value: 'askQuantity' }, { label: 'Issuer', value: 'holdIssue' }, { label: 'Coupon', value: 'holdCoupon' }, { label: 'Maturity', value: 'holdMaturitySortDt' }, { label: 'Price', value: 'askPrice' }, { label: 'Yield to worst', value: 'askYield' }, { label: 'Yield to maturity', value: 'askYieldmat' }];

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(234);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _form = __webpack_require__(801);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _fromSearchParams = __webpack_require__(315);
	
	var _fromSearchParams2 = _interopRequireDefault(_fromSearchParams);
	
	var _useSearchForm2 = __webpack_require__(807);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var searchParams = _ref.searchParams,
	        invType = _ref.invType;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                _useSearchForm2.ContextProvider,
	                null,
	                (0, _core.jsx)(FormMain, { searchParams: searchParams, invType: invType })
	            )
	        )
	    );
	};
	
	var FormMain = function FormMain() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$searchParams = _ref2.searchParams,
	        searchParams = _ref2$searchParams === undefined ? {} : _ref2$searchParams,
	        invType = _ref2.invType;
	
	    var _useSearchForm = (0, _useSearchForm2.useSearchForm)(),
	        state = _useSearchForm.state,
	        onValidate = _useSearchForm.onValidate,
	        onSubmit = _useSearchForm.onSubmit;
	
	    searchParams = Object.keys(searchParams).length > 0 ? searchParams : state.value.currentValues || {};
	    invType = invType ? invType : (0, _twd.arrayFrom)(searchParams.holdInvType)[0];
	
	    var values = (0, _fromSearchParams2.default)({ searchParams: searchParams, invType: invType });
	
	    return (0, _core.jsx)(_formik.Formik, {
	        initialValues: values,
	        onSubmit: onSubmit,
	        component: _form2.default,
	        validate: onValidate,
	        validateOnBlur: true,
	        validateOnChange: true
	    });
	};

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var name = _ref.name,
	        form = _ref.form,
	        push = _ref.push,
	        remove = _ref.remove,
	        x = _objectWithoutProperties(_ref, ['name', 'form', 'push', 'remove']);
	
	    var values = form.values[name] || [];
	
	    var err = form.errors && form.errors[name];
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'advanced-screener-search-form-securites-field filter-group' + (err ? ' has-error' : '') },
	        invTypes.map(function (a, i) {
	            var id = (0, _twd.getId)();
	            return _react2.default.createElement(
	                'div',
	                { className: 'filter', key: i },
	                _react2.default.createElement('input', {
	                    'data-name': 'advanced-screener-security-type',
	                    name: 'invType',
	                    id: id,
	                    type: 'checkbox',
	                    checked: values.includes(a.value),
	                    value: a.value,
	                    onChange: function onChange(e) {
	                        if (!e.target.checked) return;
	                        if (a.value === 'treasury-auctions') {
	                            (0, _twd.show)('tools.treasury-auctions', { from: 'advanced-screener' });
	                            return;
	                        }
	                        remove(0);
	                        push(a.value);
	                    }
	                }),
	                _react2.default.createElement(
	                    'label',
	                    { className: 'btn btn-large', htmlFor: id },
	                    a.name
	                )
	            );
	        }),
	        err && _react2.default.createElement(
	            'label',
	            { className: 'field-status has-error', style: { textAlign: 'left' } },
	            err
	        )
	    );
	};
	
	var invTypes = [{ name: 'Corporates', value: 'C' }, { name: 'Municipals', value: 'M' }, { name: 'CDs', value: 'S' }, { name: 'Agencies', value: 'A' }, { name: 'U.S. Treasuries', value: 'T' }, { name: 'Treasury Auctions', value: 'treasury-auctions' }];

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _toSearchParams = __webpack_require__(194);
	
	var _toSearchParams2 = _interopRequireDefault(_toSearchParams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var errors = _ref.errors,
	        values = _ref.values;
	
	
	    var timerId = _react2.default.useRef();
	    var lastBody = _react2.default.useRef();
	    var lastAbort = _react2.default.useRef();
	    var hasError = Object.keys(errors).length > 0;
	    var buttonRef = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        if (timerId.current) {
	            clearInterval(timerId.current);
	            timerId.current = 0;
	        }
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var p, body, _ref3, data, abort, _ref4, resultSetCount;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!hasError) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            p = Object.assign({
	                                searchType: 'offers',
	                                pageNumber: 1,
	                                persistToPreviousSearches: false,
	                                marketCheckRequired: false
	                            }, (0, _toSearchParams2.default)(Object.assign({ isSubmit: true }, values)), {
	                                resultsPerPage: 1,
	                                sort: [{
	                                    field: 'holdMaturitySortDt',
	                                    direction: 'ASC'
	                                }]
	                            });
	                            body = JSON.stringify(p);
	
	                            if (!(lastBody.current === body)) {
	                                _context.next = 6;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 6:
	
	                            lastBody.current = body;
	
	                            _context.prev = 7;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 11;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/offersearch/getHitCount',
	                                method: 'POST',
	                                body: body
	                            });
	
	                        case 11:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            abort = _ref3.abort;
	
	
	                            updateText(null);
	                            lastAbort.current = abort;
	                            _context.next = 18;
	                            return data;
	
	                        case 18:
	                            _ref4 = _context.sent;
	                            resultSetCount = _ref4.resultSetCount;
	
	                            lastAbort.current = null;
	                            updateText(resultSetCount);
	
	                            _context.next = 27;
	                            break;
	
	                        case 24:
	                            _context.prev = 24;
	                            _context.t0 = _context['catch'](7);
	
	                            updateText(null);
	
	                        case 27:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[7, 24]]);
	        })), 1000);
	
	        return function () {
	            if (lastAbort.current) lastAbort.current();
	            if (timerId.current) clearInterval(timerId.current);
	        };
	    });
	
	    var updateText = function updateText(count) {
	        if (!buttonRef.current) return;
	        if (count === null || count === undefined) {
	            buttonRef.current.innerHTML = 'View results';
	            return;
	        }
	
	        var s = 'View (' + _twd.fmt.count(count) + ') results';
	        buttonRef.current.innerHTML = s;
	    };
	
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'advanced-screener-view-results-button',
	            ref: buttonRef,
	            type: 'submit',
	            disabled: hasError,
	            className: 'btn btn-primary btn-block' },
	        'View results'
	    );
	};

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toSearchParams = __webpack_require__(194);
	
	var _toSearchParams2 = _interopRequireDefault(_toSearchParams);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (values) {
	    if (!values) return;
	
	    var p = (0, _toSearchParams2.default)(Object.assign({ isSubmit: true }, values));
	    setTimeout(function () {
	        (0, _twd.trackSearch)('Advanced Screener', p, true);
	    });
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: Object.assign(p, { persistToPreviousSearches: true }),
	        _ts: Date.now(),
	        from: 'advanced-screener'
	    }));
	};

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	var updating = false;
	
	exports.default = function (_ref) {
	    var field = _ref.field,
	        form = _ref.form,
	        error = _ref.error,
	        label = _ref.label,
	        style = _ref.style,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'error', 'label', 'style']);
	
	    var err = form.errors && form.errors[field.name];
	    var id = (0, _twd.getId)();
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'form-group ' + (err || error ? ' has-error' : ''),
	                style: Object.assign({ whiteSpace: 'nowrap' }, style)
	            },
	            _react2.default.createElement(_twd.Fields.SearchCusip, Object.assign({
	                id: id,
	                dataName: 'advanced-screener-corp-symbol',
	
	                onClear: function onClear() {
	                    form.setFieldValue(field.name, '');
	
	                    updating = true;
	                    setTimeout(function () {
	                        updating = false;
	                    }, 500);
	                },
	
	                onSelect: function onSelect(a) {
	                    var v = (0, _twd.isString)(a) ? a : a.value;
	                    form.setFieldValue(field.name, v);
	
	                    updating = true;
	                    setTimeout(function () {
	                        updating = false;
	                    }, 500);
	                    return v;
	                },
	
	                filter: function filter(a) {
	                    return a.type === 'C' && a.symbol && a.issuer;
	                },
	                map: function map(a) {
	                    return {
	                        value: a.symbol,
	                        label: a.symbol + ' - ' + a.issuer
	                    };
	                },
	
	                name: field.name,
	                value: field.value
	
	            }, field, props, {
	
	                onBlur: function onBlur(_ref2) {
	                    var keyword = _ref2.keyword;
	
	                    if (updating) return;
	
	                    var a = (keyword || '').trim();
	                    if (!a) return;
	
	                    form.setFieldValue(field.name, a);
	                    return a;
	                }
	            })),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useSearchForm = exports.ContextProvider = exports.Context = undefined;
	
	var _toSearchParams = __webpack_require__(194);
	
	Object.keys(_toSearchParams).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _toSearchParams[key];
	        }
	    });
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _validate = __webpack_require__(808);
	
	var _validate2 = _interopRequireDefault(_validate);
	
	var _submit = __webpack_require__(805);
	
	var _submit2 = _interopRequireDefault(_submit);
	
	var _fromSearchParams = __webpack_require__(315);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Context = exports.Context = _react2.default.createContext();
	
	var state = (0, _twd.getState)('advanced_screener.search_form', {
	    currentValues: _fromSearchParams.initialValues
	});
	
	var onValidate = function onValidate(values) {
	    var err = (0, _validate2.default)(values);
	    state.set({
	        currentValues: values,
	        errors: err
	    });
	    return err;
	};
	
	var ContextProvider = exports.ContextProvider = function ContextProvider(_ref) {
	    var children = _ref.children;
	
	    return _react2.default.createElement(
	        Context.Provider,
	        { value: {
	                state: state, onValidate: onValidate, onSubmit: _submit2.default
	            } },
	        children
	    );
	};
	
	var useSearchForm = exports.useSearchForm = function useSearchForm() {
	    return _react2.default.useContext(Context);
	};

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ratings = __webpack_require__(197);
	
	var _twd = __webpack_require__(2);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-use-before-define */
	
	exports.default = function (values) {
	    checkRatingIndicator(values);
	
	    return Object.assign({}, validateHoldInvType(values), validateMaturity(values, 'holdMaturity'), validateRatings(values, 'holdSpRating', _ratings.spRatings), validateRatings(values, 'holdMoodyRating', _ratings.moodysRatings), validateNumbers(values, 'clientPrice'), validateNumbers(values, 'quantity'), validateNumbers(values, 'offerYtw'), validateNumbers(values, 'offerYtm'), validateNumbers(values, 'holdCoupon'), validateMaturity(values, 'holdFirstCall'));
	};
	
	var checkRatingIndicator = function checkRatingIndicator(values) {
	    var sMin = values.holdSpRatingMin,
	        sMax = values.holdSpRatingMax,
	        mMin = values.holdMoodyRatingMin,
	        mMax = values.holdMoodyRatingMax;
	
	
	    if (sMin === 'BBB-' && sMax === 'AAA' && mMin === 'Baa3' && mMax === 'Aaa') {
	        values.rating = 'investment-grade';
	    } else if (sMin === 'C' && sMax === 'BB+' && mMin === 'C' && mMax === 'Ba1') {
	        values.rating = 'high-yield';
	    } else if (sMin === 'ALL' && sMax === 'ALL' && mMin === 'ALL' && mMax === 'ALL') {
	        values.rating = 'all-ratings';
	    } else if (!sMin && !sMax && !mMin && !mMax) {
	        values.rating = 'all-ratings';
	    } else {
	        values.rating = '';
	    }
	};
	
	var validateHoldInvType = function validateHoldInvType(values) {
	    var arr = values.holdInvType;
	    if (!Array.isArray(arr) || arr.length === 0) {
	        return { holdInvType: 'Please select security type' };
	    }
	};
	
	var validateRatings = function validateRatings(values, name, ratings) {
	    var min = ratings.indexOf(values[name + 'Min']);
	    var max = ratings.indexOf(values[name + 'Max']);
	    var e = {};
	    if (max > min) {
	        e[name] = 'Please enter higher ratings';
	    }
	    return e;
	};
	
	var validateMaturity = function validateMaturity(values, name) {
	    var min = (0, _twd.parseDate)(values[name + 'Min']);
	    var max = (0, _twd.parseDate)(values[name + 'Max'], true);
	    if (max < min) {
	        return _defineProperty({}, name, 'Please select later date');
	    }
	};
	
	var validateNumbers = function validateNumbers(values, name) {
	    var min = parseFloat(values[name + 'Min']);
	    var max = parseFloat(values[name + 'Max']);
	    var e = {};
	    if (max < min) {
	        e[name] = 'Please enter max > min';
	    }
	    return e;
	};

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _style = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define,no-mixed-operators */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$issue = _ref.issue,
	        issue = _ref$issue === undefined ? {} : _ref$issue,
	        _ref$offer = _ref.offer,
	        offer = _ref$offer === undefined ? {} : _ref$offer;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'modal-dialog modal-sm' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'modal-content' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'modal-header' },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'bond-detail-ars-info-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        (0, _core.jsx)(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'modal-title text-center' },
	                        'ARS Info'
	                    ),
	                    (0, _core.jsx)('h5', { className: 'modal-title text-center vertical-offset-sm',
	                        dangerouslySetInnerHTML: { __html: (0, _twd.parseHtml)(issue.formulaText).replaceAll('<BR>', ' ') } }),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'table-responsive' },
	                                (0, _core.jsx)(
	                                    'table',
	                                    {
	                                        'data-name': 'bond-detail-ars-info-table',
	                                        className: 'table align-top',
	                                        css: _style.tableCss },
	                                    (0, _core.jsx)(
	                                        'tbody',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Reset frequency'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                issue.resetFreqDesc
	                                            )
	                                        ),
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Current reset'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                _twd.fmt.mdy(issue.cachedDatum.f2fFixedInd === 'Y' ? null : offer.prevCoupon || issue.prevCoupon)
	                                            )
	                                        ),
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Next reset'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                _twd.fmt.mdy(issue.cachedDatum.f2fFixedInd === 'Y' ? offer.nextResetDate || issue.nextResetDate : offer.nextCoupon || issue.nextCoupon)
	                                            )
	                                        ),
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Current determination'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                _twd.fmt.mdy(issue.cachedDatum.f2fFixedInd === 'Y' ? null : offer.determinationDt || issue.determinationDt)
	                                            )
	                                        ),
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Next determination'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                _twd.fmt.mdy(offer.nextDeterminationDt || issue.nextDeterminationDt)
	                                            )
	                                        ),
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Floor'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                issue.floatFloor || _twd.fmt.empty()
	                                            )
	                                        ),
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Cap'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                issue.floatCeiling || _twd.fmt.empty()
	                                            )
	                                        ),
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'td',
	                                                null,
	                                                'Formula'
	                                            ),
	                                            (0, _core.jsx)('td', { dangerouslySetInnerHTML: { __html: (0, _twd.parseHtml)(issue.formulaText).replaceAll('<BR>', ' ') } })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.best_offerings', {
	    show: true
	});
	
	var datePrice = function datePrice(date, price) {
	    return [date && _twd.fmt.mdy(date), price && price !== '-' && '@' + _twd.fmt.price3(price)].filter(Boolean).join('');
	};
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue,
	        cusip = _useBondDetail.cusip,
	        bid = _useBondDetail.bid,
	        ask = _useBondDetail.ask,
	        offer = _useBondDetail.offer;
	
	    var hasOffer = bid && bid.id || ask && ask.id;
	    var hasDiscountYield = ['C', 'A', 'T'].indexOf(issue.type) >= 0 && issue.category === 'B';
	
	    var brButtons = [issue.showBook && (0, _core.jsx)(
	        'button',
	        {
	            'data-name': 'bond-detail-depth-of-market-button',
	            className: 'link-button',
	            style: { minHeight: '20px' },
	            onClick: function onClick(e) {
	                (0, _twd.showModal)({
	                    view: 'depth-of-market',
	                    cusip: cusip,
	                    allowTrading: issue.allowTrading,
	                    from: 'bond-detail',
	                    source: e.target
	                });
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('layers'), 'Depth of Market')
	    ), ['A', 'C', 'M'].includes(issue.type) && (0, _core.jsx)(
	        'button',
	        {
	            'data-name': 'bond-detail-trade-history-button',
	            className: 'link-button',
	            style: { minHeight: '20px' },
	            onClick: function onClick(e) {
	                (0, _twd.showModal)({
	                    view: 'trade-history',
	                    cusip: issue.cusip,
	                    source: e.target
	                });
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('graphic_eq'), 'Trade History')
	    )].filter(Boolean);
	
	    var isMatured = (0, _twd.parseDate)(issue.maturityEff) < Date.now() || (0, _twd.parseDate)(issue.redemptionDt) < Date.now() || issue.calledInFullInd === 'Y';
	    var canTrade = !isMatured && issue.allowTrading && issue.type !== 'P';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-best-offering',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'Best offering',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        !canTrade && (0, _core.jsx)(
	                            'div',
	                            { className: 'text-body text-center vertical-offset-sm' },
	                            _twd.NO_RESULT_ICON,
	                            (0, _core.jsx)('br', null),
	                            (0, _core.jsx)(
	                                'h4',
	                                { className: 'small-header' },
	                                'Security unavailable for online trading'
	                            ),
	                            'For support placing a trade in this security, please call 877-355-3237.'
	                        ),
	                        canTrade && !hasOffer && (0, _core.jsx)(
	                            'div',
	                            { className: 'text-body text-center vertical-offset-sm' },
	                            _twd.NO_RESULT_ICON,
	                            (0, _core.jsx)('br', null),
	                            (0, _core.jsx)(
	                                'h4',
	                                { className: 'small-header' },
	                                'No current offers'
	                            ),
	                            'You may solicit a quote by submitting a Bid or Offer Wanted request.'
	                        ),
	                        canTrade && hasOffer && (0, _core.jsx)(
	                            'div',
	                            null,
	                            (0, _core.jsx)(
	                                'table',
	                                { className: 'table', css: _style.tableCss },
	                                (0, _core.jsx)(
	                                    'thead',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)('th', { className: 'col-md-6' }),
	                                        (0, _core.jsx)(
	                                            'th',
	                                            { className: 'col-md-3 text-right' },
	                                            'Bid'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'th',
	                                            { className: 'col-md-3 text-right' },
	                                            'Ask'
	                                        )
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'tbody',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Quantity'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.qty(bid.quantity)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.qty(ask.quantity)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Minimum'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.qty(bid.quantityMin)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.qty(ask.quantityMin)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Increment'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.qty(bid.quantityIncr)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.qty(ask.quantityIncr)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Price'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.price3N(bid.dispPrice)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.price3N(ask.dispPrice)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Settlement'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.mdy(bid.settlement)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.mdy(ask.settlement)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Priced to'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            bid.worstYield || ''
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            ask.worstYield || ''
	                                        )
	                                    ),
	                                    hasDiscountYield && (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Discount yield'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.customerDiscount)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.customerDiscount)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Yield to worst',
	                                            (0, _core.jsx)('br', null),
	                                            datePrice(offer.ytwRdate, offer.ytwRprice)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.ytw, bid.ytwEstInd)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.ytw, ask.ytwEstInd)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Yield to maturity',
	                                            (0, _core.jsx)('br', null),
	                                            datePrice(offer.ytmRdate, offer.ytmRprice)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.ytm, bid.ytmEstInd)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.ytm, ask.ytmEstInd)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Yield next call (c)',
	                                            (0, _core.jsx)('br', null),
	                                            datePrice(offer.ytcRdate, offer.ytcRprice)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.ytc)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.ytc)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Yield par call (p)'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.ytp)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.ytp)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Yield put (u)'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.ytu)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.ytu)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Yield sink (s)'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.yts)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.yts)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Current yield'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.cy)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.cy)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Annual percentage yield'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(bid.apy)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.ytw3(ask.apy)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Macaulay duration'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(bid.duration)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(ask.duration)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Mod duration to earliest redemption'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(bid.modDurationToCall)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(ask.modDurationToCall)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Mod duration to worst'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(bid.modduration)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(ask.modduration)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Mod duration to maturity'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(bid.modDurationToMaturity)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.dur(ask.modDurationToMaturity)
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tr',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'td',
	                                            { role: 'rowheader' },
	                                            'Convexity'
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.cty(bid.convexity)
	                                        ),
	                                        (0, _core.jsx)(
	                                            'td',
	                                            null,
	                                            _twd.fmt.cty(ask.convexity)
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        (!issue.allowTrading || !hasOffer) && (0, _core.jsx)('hr', { className: 'vertical-offset-sm', 'aria-hidden': 'true' }),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12 col-md-6 vertical-offset-xs' },
	                            (0, _core.jsx)(
	                                'button',
	                                {
	                                    style: { minHeight: '20px' },
	                                    'data-name': 'bond-detail-bond-offerings-price-yield-calculator',
	                                    className: 'link-button',
	                                    onClick: function onClick() {
	
	                                        if ((0, _twd.getConfig)('entitlements.ETradeCalculator', 'No') === 'Yes') {
	                                            (0, _twd.showModal)({
	                                                view: 'calculator',
	                                                cusip: cusip,
	                                                action: 'B',
	                                                from: 'bond-detail',
	                                                price: ask && ask.price || 100
	                                            });
	                                            return;
	                                        }
	
	                                        var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	                                        var sp = new URLSearchParams();
	                                        sp.set('p_javascript', 2);
	                                        sp.set('p_data_source', ask && ask.id || bid && bid.id ? 'I' : 'D');
	                                        sp.set('p_id', ask && ask.id || bid && bid.id || issue.cusip);
	                                        sp.set('p_price_type', 1);
	                                        sp.set('p_price', ask && ask.price || bid && bid.price || 100);
	                                        sp.set('p_quantity', ask && ask.quantity || bid && bid.quantity || 0);
	                                        sp.set('p_commission', '');
	                                        sp.set('p_ts', Date.now());
	
	                                        var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	                                        var url = base + '/' + owaTcDaoContext + '/pkg_calc_bond_online.seed?' + sp.toString();
	
	                                        (0, _twd.publish)('open', {
	                                            url: url,
	                                            name: '_blank',
	                                            options: "toolbar=no,width=760,height=490,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no"
	                                        });
	                                    }
	                                },
	                                (0, _twd.iconLabel)(_twd.icons.calculate, 'Price/yield calculator')
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12 col-md-6 vertical-offset-xs' },
	                            brButtons[0] || null
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12 col-md-6 vertical-offset-xs' },
	                            (0, _core.jsx)(
	                                'button',
	                                {
	                                    style: { minHeight: '20px' },
	                                    'data-name': 'bond-detail-bond-offerings-tey-calculator',
	                                    className: 'link-button',
	                                    onClick: function onClick(e) {
	                                        (0, _twd.publish)('tey-calculator', {
	                                            bondType: issue.type,
	                                            bondYield: ask.ytw || bid.ytw || null,
	                                            issueState: issue.state,
	                                            isReset: true,
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                (0, _twd.iconLabel)(_twd.icons.calculate, 'TEY calculator')
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12 col-md-6 vertical-offset-xs' },
	                            brButtons[1] || null
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	var _bondDetail = __webpack_require__(316);
	
	var _underwriter = __webpack_require__(463);
	
	var _underwriter2 = _interopRequireDefault(_underwriter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.bond_features', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue,
	        events = _useBondDetail.events;
	
	    var invType = issue.spInd === 'Y' ? 'L' : issue.type;
	    var hasEvents = ['C', 'M', 'A', 'L'].indexOf(invType) >= 0 && !(issue.type === 'S' && issue.spInd === 'Y' && issue.category === 'N');
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-bond-features',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: _bondDetail.INV_TYPE_LABELS[invType] + " features",
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)(
	                            'dl',
	                            { css: _style.sectionListCss },
	                            invType === 'A' ? (0, _core.jsx)(AgencyFeatures, { issue: issue }) : invType === 'R' ? (0, _core.jsx)(PassThroughAssetBackedCMOFeatures, { issue: issue }) : invType === 'K' ? (0, _core.jsx)(PassThroughAssetBackedCMOFeatures, { issue: issue }) : invType === 'S' ? (0, _core.jsx)(CDFeatures, { issue: issue }) : invType === 'O' ? (0, _core.jsx)(PassThroughAssetBackedCMOFeatures, { issue: issue }) : invType === 'L' ? (0, _core.jsx)(StructuredProductFeatures, { issue: issue }) : invType === 'C' ? (0, _core.jsx)(CorporateFeatures, { issue: issue }) : invType === 'M' ? (0, _core.jsx)(MunicipalFeatures, { issue: issue }) : invType === 'P' ? (0, _core.jsx)(PreferredFeatures, { issue: issue }) : invType === 'T' ? (0, _core.jsx)(TreasuryFeatures, { issue: issue }) : null
	                        ),
	                        hasEvents && function () {
	                            var tab = invType === 'A' ? 'redemptions' : invType === 'M' ? 'material-event-filings' : 'default-events';
	
	                            var lbl = invType === 'M' ? 'View all Material Events' : 'View all events';
	
	                            return (0, _core.jsx)(
	                                'div',
	                                { className: 'row' },
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'col-xs-12' },
	                                    (0, _core.jsx)(
	                                        'button',
	                                        {
	                                            className: 'link-button',
	                                            onClick: function onClick(e) {
	                                                (0, _twd.showModal)({
	                                                    view: 'events',
	                                                    tab: tab,
	                                                    issue: issue,
	                                                    events: events,
	                                                    from: 'bond-detail',
	                                                    source: e.target
	                                                });
	                                            } },
	                                        (0, _twd.iconLabel)((0, _twd.matIcon)('timeline'), lbl)
	                                    )
	                                )
	                            );
	                        }()
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};
	
	var CorporateFeatures = function CorporateFeatures(_ref) {
	    var issue = _ref.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Sector'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.CORP_SECTOR_LABELS[issue.sectorCode]
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Convertible'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.convertibleInd === 'Y' ? (0, _twd.parseHtml)(issue.convertibleText) : 'No'
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Listed'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.convertibleInd] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Symbol'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.symbol || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Debt Ranking'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.drnkDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Religious org'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (issue.religiOrg || '').trim() || _twd.fmt.empty()
	        )
	    );
	};
	
	var MunicipalFeatures = function MunicipalFeatures(_ref2) {
	    var issue = _ref2.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Category'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.categoryDesc) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'State'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.state || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Use of proceeds'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.useofproceedsdesc) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Debt Ranking'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.drnkDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Federally taxable'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.taxable] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'State taxable'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.stateTaxExempt === 'No' ? 'N' : 'Y'] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Subject to AMT'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.altMinTax] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Bank qualified'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.bankQualified] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Build America Bonds'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.babInd] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Religious org'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (issue.religiOrg || '').trim() || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Obligor'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.corporationName) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Project name'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.projectName || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Enhancement'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.enhancement || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Primary insurance'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.insurance || _twd.fmt.empty(),
	            function () {
	                var a = issue.insurance && issue.primInsurerRatingList && issue.primInsurerRatingList[0];
	                return a ? [' (', a.moodyRating, '/', a.spRating, ')'].join('') : '';
	            }()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Secondary insurance'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.secInsurance || _twd.fmt.empty(),
	            function () {
	                var a = issue.secInsurance && issue.secInsurerRatingList && issue.secInsurerRatingList[0];
	                return a ? [' (', a.moodyRating, '/', a.spRating, ')'].join('') : '';
	            }()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Reinsurance'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.reinsurance || _twd.fmt.empty(),
	            function () {
	                var a = issue.reinsurance && issue.reinsInsurerRatingList && issue.reinsInsurerRatingList[0];
	                return a ? [' (', a.moodyRating, '/', a.spRating, ')'].join('') : '';
	            }()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Redemption type'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.redemptionTypeDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Escrowed'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.escrowedToMaturity] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'PreRefunded'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.preRefund] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Min amount'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.qty(issue.minAmt)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Increment amount'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.qty(issue.denominationAmt)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Deminimus price'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.priceDemin(issue.marketDiscPoint)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Environmental type'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.environmental) || _twd.fmt.empty()
	        )
	    );
	};
	
	var CDFeatures = function CDFeatures(_ref3) {
	    var issue = _ref3.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'New Issue'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.YES_NO[issue.newIssueInd] || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Blue Sky Sate Restrictions'
	        ),
	        (0, _core.jsx)('dd', { dangerouslySetInnerHTML: { __html: (0, _twd.parseHtml)((issue.bluesky || '').replaceAll('<BR>', '').split(',').join(',\u200B') || _twd.fmt.emptyHtml) } }),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'City, state'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (issue.city ? issue.city + ', ' : '') + (issue.state || '') || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'FDIC number'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.fdic || _twd.fmt.empty()
	        )
	    );
	};
	
	var AgencyFeatures = function AgencyFeatures(_ref4) {
	    var issue = _ref4.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Issuer'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.issuer || _twd.fmt.empty()
	        )
	    );
	};
	
	var TreasuryFeatures = function TreasuryFeatures(_ref5) {
	    var issue = _ref5.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Type'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.categoryDesc || _twd.fmt.empty()
	        )
	    );
	};
	
	var StructuredProductFeatures = function StructuredProductFeatures(_ref6) {
	    var issue = _ref6.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Category'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.categoryDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Class'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.subCatClass || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Program type'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.programType || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Payoff profile'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.payoffDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Issuer'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.issuer || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Underwriter'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _core.jsx)(_underwriter2.default, { html: issue.underwriter })
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'City, state'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (issue.city ? issue.city + ', ' : '') + (issue.state || '') || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'FDIC number'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.fdic || _twd.fmt.empty()
	        )
	    );
	};
	
	var PassThroughAssetBackedCMOFeatures = function PassThroughAssetBackedCMOFeatures(_ref7) {
	    var issue = _ref7.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Category'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.categoryDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'WAM'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.wghtdAvgMaturity) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'WAM date'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.mdy(issue.wghtdAvgMaturityDt)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'WAC'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.wghtdAvgCoupon) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'WAC date'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.mdy(issue.wghtdAvgCouponDt)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'WALA'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.wghtdAvgLoanAge || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Pool type'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.poolType || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Pool number'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.poolNo || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Tranche type'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.trancheDesc) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Collateral'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.collateralDesc) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Collateral coupon'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.cpn(issue.collateralCoupon)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Payment delay'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.daysDelay || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Factor'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.factor && (0, _core.jsx)(
	                'button',
	                {
	                    className: 'link-button',
	                    onClick: function onClick(e) {
	                        (0, _twd.showModal)({
	                            view: 'factors',
	                            list: issue.factorList,
	                            from: 'bond-detail',
	                            source: e.target
	                        });
	                    } },
	                issue.factor
	            ) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'FFIEC'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.ffiecFlag || _twd.fmt.empty()
	        )
	    );
	};
	
	var PreferredFeatures = function PreferredFeatures(_ref8) {
	    var issue = _ref8.issue;
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Issuer'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            (0, _twd.parseHtml)(issue.issuer) || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Symbol'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.symbol || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Exchange'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.exchangeDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Category'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.categoryDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Debt Ranking'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.drnkDesc || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'QDI eligibility'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.qdi || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Ex-Div date'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.mdy(issue.exDividendDt)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Div pay date'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.mdy(issue.dividendPayDt)
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Lead manager'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            issue.leadManager || _twd.fmt.empty()
	        ),
	        (0, _core.jsx)(
	            'dt',
	            null,
	            'Security notes'
	        ),
	        (0, _core.jsx)(
	            'dd',
	            null,
	            _twd.fmt.initCap(issue.note) || _twd.fmt.empty()
	        )
	    );
	};

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	var _couponType = __webpack_require__(462);
	
	var _couponType2 = _interopRequireDefault(_couponType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.coupon_features', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue,
	        offer = _useBondDetail.offer,
	        ask = _useBondDetail.ask,
	        bid = _useBondDetail.bid;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-coupon-features',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'Coupon features',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)(
	                            'dl',
	                            { css: _style.sectionListCss },
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Coupon'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.format.cpn3(issue.coupon)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Coupon frequency'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.COUPON_FREQUENCY_LABELS[issue.frequencyCode] || _twd.format.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Coupon type'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                (0, _core.jsx)(_couponType2.default, { issue: issue, offer: offer })
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Next coupon'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.format.mdy(issue.nextCoupon)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'First coupon'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.format.mdy(issue.firstCoupon)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Last coupon'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.format.mdy(issue.lastCoupon)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Day count'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.COUPON_DAY_COUNT_LABELS[issue.currDaycount] || _twd.format.empty()
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'vertical-offset-sm' },
	                            (0, _core.jsx)(
	                                'button',
	                                {
	                                    'data-name': 'bond-detail-coupon-features-coupon-payment-calculator',
	                                    className: 'link-button',
	                                    onClick: function onClick() {
	
	                                        if ((0, _twd.getConfig)('entitlements.ETradeCalculator', 'No') === 'Yes') {
	                                            (0, _twd.showModal)({
	                                                view: 'calculator',
	                                                cusip: issue.cusip,
	                                                action: 'B',
	                                                price: ask && ask.price || 100,
	                                                showCoupon: true
	                                            });
	                                            return;
	                                        }
	
	                                        var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	                                        var sp = new URLSearchParams();
	                                        sp.set('p_javascript', 2);
	                                        sp.set('p_data_source', ask && ask.id || bid && bid.id ? 'I' : 'D');
	                                        sp.set('p_id', ask && ask.id || bid && bid.id || issue.cusip);
	                                        sp.set('p_price_type', 1);
	                                        sp.set('p_price', ask && ask.price || bid && bid.price || 100);
	                                        sp.set('p_quantity', ask && ask.quantity || bid && bid.quantity || 0);
	                                        sp.set('p_commission', '');
	                                        sp.set('p_ts', Date.now());
	
	                                        var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	                                        var url = base + '/' + owaTcDaoContext + '/pkg_calc_bond_online.seed?' + sp.toString();
	
	                                        (0, _twd.publish)('open', {
	                                            url: url,
	                                            name: '_blank',
	                                            options: "toolbar=no,width=760,height=490,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no"
	                                        });
	                                    }
	                                },
	                                (0, _twd.iconLabel)(_twd.icons.calculate, 'Calculate coupon payment')
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.credit_ratings', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue,
	        events = _useBondDetail.events;
	
	    if (!(0, _useBondDetail2.hasCreditRatings)(issue)) return null;
	
	    var hasMoody = issue.moodyRating !== '-' && issue.mratingValue > 0;
	    var hasMoodyNR = issue.moodyRating === 'NR';
	    var hasSp = issue.spRating !== '-' && issue.sratingValue > 0;
	    var hasSpNR = issue.spRating === 'NR';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-credit-ratings',
	                className: 'container',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'Credit ratings',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'vertical-offset-sm text-muted' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-body text-bold' },
	                                'Long term Moody\'s rating'
	                            ),
	                            hasMoody ? (0, _core.jsx)('span', { className: 'medium-header', dangerouslySetInnerHTML: { __html: issue.moodyRating || '' } }) : _twd.fmt.empty(),
	                            '\xA0 ',
	                            !hasMoody || hasMoodyNR ? '' : issue.mratingValue > 58 ? '(Investment grade)' : '(High Yield)',
	                            (0, _core.jsx)('br', null),
	                            hasMoody && (0, _core.jsx)(
	                                _react2.default.Fragment,
	                                null,
	                                'Effective ',
	                                _twd.format.mdy(issue.mmaturityLtRatingDate)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'vertical-offset-sm text-muted' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-body text-bold' },
	                                'Long term S&P rating'
	                            ),
	                            hasSp ? (0, _core.jsx)('span', { className: 'medium-header', dangerouslySetInnerHTML: { __html: issue.spRating || '' } }) : _twd.fmt.empty(),
	                            '\xA0 ',
	                            !hasSp || hasSpNR ? '' : issue.sratingValue > 58 ? '(Investment grade)' : '(High Yield)',
	                            (0, _core.jsx)('br', null),
	                            hasSp && (0, _core.jsx)(
	                                _react2.default.Fragment,
	                                null,
	                                'Effective ',
	                                _twd.format.mdy(issue.maturityLtRatingDate)
	                            )
	                        ),
	                        issue.type === 'T' && (0, _core.jsx)(
	                            'div',
	                            { className: 'vertical-offset-sm text-muted' },
	                            'United States Treasury securities are backed by the full faith and credit of the United States Government.'
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'vertical-offset-sm' },
	                            (0, _core.jsx)(
	                                'button',
	                                {
	                                    className: 'link-button',
	                                    onClick: function onClick(e) {
	                                        (0, _twd.showModal)({
	                                            view: 'events',
	                                            tab: 'credit-ratings-actions',
	                                            issue: issue,
	                                            events: events,
	                                            from: 'bond-detail',
	                                            source: e.target
	                                        });
	                                    } },
	                                (0, _twd.iconLabel)((0, _twd.matIcon)('graphic_eq'), 'View full rating history')
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _empty = __webpack_require__(195);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	var _foot = __webpack_require__(196);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var rows = _ref.rows;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        (!rows || rows.length === 0) && (0, _empty2.default)({ msg: 'There are no historical rating actions since 9/30/2011' }),
	        rows && rows.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-name': 'bond-detail-events-ratings-credit-rating-actions-table',
	                    className: 'table table-striped align-top' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement('th', { style: { borderBottom: 0 } }),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderBottom: 0, fontWeight: 500, color: '#242424' }, colSpan: '3', className: 'text-center' },
	                            'Moody\'s Ratings Actions'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderBottom: 0, fontWeight: 500, color: '#242424' }, colSpan: '3', className: 'text-center' },
	                            'S&P Ratings Actions'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderTop: 0, borderRight: '1px solid #e4e4e4' } },
	                            'Action Date'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderTop: 0 } },
	                            'Long Term'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderTop: 0 } },
	                            'Watch/Outlook'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderTop: 0, borderRight: '1px solid #e4e4e4' } },
	                            'Underlying'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderTop: 0 } },
	                            'Long Term'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderTop: 0 } },
	                            'Watch/Outlook'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { style: { borderTop: 0 } },
	                            'Underlying'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rows.map(function (r, i) {
	                        return _react2.default.createElement(
	                            'tr',
	                            {
	                                'data-name': 'bond-detail-events-ratings-credit-rating-actions-row',
	                                key: i },
	                            _react2.default.createElement(
	                                'td',
	                                { style: { borderRight: '1px solid #e4e4e4' } },
	                                _twd.fmt.mdy(r.creditRatingDate)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                trend(r.moodyLtTrend),
	                                r.moodyLtRating
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.moodyWatchOutlook || '-- / --'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { style: { borderRight: '1px solid #e4e4e4' } },
	                                trend(r.moodyUndTrend),
	                                ' ',
	                                r.moodyUndRating
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                trend(r.spLtTrend),
	                                r.spLtRating
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.spWatchOutlook || '-- / --'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                trend(r.spUndTrend),
	                                ' ',
	                                r.spUndRating
	                            )
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(_foot2.default, { label: 'Credit Ratings Actions' })
	    );
	};
	
	var trend = function trend(value) {
	    return _react2.default.createElement('span', {
	        'aria-hidden': 'true',
	        style: {
	            width: '15px',
	            display: 'inline-block',
	            color: value === 'D' ? '#cc0000' : value === 'U' ? '#107A1B' : 'transparent'
	        },
	
	        dangerouslySetInnerHTML: {
	            __html: value === 'D' ? '&#9660;' : value === 'U' ? '&#9650;' : ''
	        }
	    });
	};

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _empty = __webpack_require__(195);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	var _foot = __webpack_require__(196);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var rows = _ref.rows;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        (!rows || rows.length === 0) && (0, _empty2.default)({ msg: 'There are no default events since 9/30/2011' }),
	        rows && rows.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-name': 'bond-detail-events-ratings-default-events-table',
	                    className: 'table table-striped align-top' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date Published'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Event Description'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rows && rows.map(function (r, i) {
	                        return _react2.default.createElement(
	                            'tr',
	                            {
	                                'data-name': 'bond-detail-events-ratings-default-events-row',
	                                key: i },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _twd.fmt.mdy(r.alertDate)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.alertDescription
	                            )
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(_foot2.default, { label: 'Default Events' })
	    );
	};

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _empty = __webpack_require__(195);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	var _foot = __webpack_require__(196);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var rows = _ref.rows;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        (!rows || rows.length === 0) && (0, _empty2.default)({ msg: 'There are no disclosure filings since 9/30/2011' }),
	        rows && rows.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-name': 'bond-detail-events-ratings-disclosure-filings-table',
	                    className: 'table table-striped align-top' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date Published'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Event Type'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Event Description'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rows && rows.map(function (r, i) {
	                        return _react2.default.createElement(
	                            'tr',
	                            {
	                                'data-name': 'bond-detail-events-ratings-disclosure-filings-row',
	                                key: i },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _twd.fmt.mdy(r.alertDate)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.alertCode
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.alertDescription
	                            )
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(_foot2.default, { label: 'Disclosure Filings' })
	    );
	};

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _empty = __webpack_require__(195);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	var _foot = __webpack_require__(196);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var rows = _ref.rows;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        (!rows || rows.length === 0) && (0, _empty2.default)({ msg: 'There are no material event filings since 9/30/2011' }),
	        rows && rows.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-name': 'bond-detail-events-ratings-material-events-filings-table',
	                    className: 'table table-striped align-top' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date Published'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Event Type'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Event Description'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rows && rows.map(function (r, i) {
	                        return _react2.default.createElement(
	                            'tr',
	                            {
	                                'data-name': 'bond-detail-events-ratings-material-events-filings-row',
	                                key: i },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _twd.fmt.mdy(r.alertDate)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.alertCode
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.alertDescription
	                            )
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(_foot2.default, { label: 'Material Event Filings' })
	    );
	};

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _redemptions = __webpack_require__(819);
	
	var _redemptions2 = _interopRequireDefault(_redemptions);
	
	var _materialEventFilings = __webpack_require__(817);
	
	var _materialEventFilings2 = _interopRequireDefault(_materialEventFilings);
	
	var _disclosureFilings = __webpack_require__(816);
	
	var _disclosureFilings2 = _interopRequireDefault(_disclosureFilings);
	
	var _creditRatingActions = __webpack_require__(814);
	
	var _creditRatingActions2 = _interopRequireDefault(_creditRatingActions);
	
	var _defaultEvents = __webpack_require__(815);
	
	var _defaultEvents2 = _interopRequireDefault(_defaultEvents);
	
	var _useBondDetail = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        issue = _ref.issue,
	        _ref$events = _ref.events,
	        events = _ref$events === undefined ? [] : _ref$events,
	        _ref$tab = _ref.tab,
	        tab_ = _ref$tab === undefined ? 'default-events' : _ref$tab;
	
	    var _React$useState = _react2.default.useState(tab_ || 'default-events'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tab = _React$useState2[0],
	        setTab = _React$useState2[1];
	
	    var invType = issue.type;
	    var isMuni = invType === 'M';
	    var isAgcy = invType === 'A';
	    var isCorp = !isMuni && !isAgcy;
	
	    var hasRtg = (0, _useBondDetail.hasCreditRatings)(issue);
	    var title = 'Events' + (hasRtg ? ' and Ratings' : '');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'bond-detail-underwriter-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'large-header text-center vertical-offset-sm' },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container', style: { background: "#ffffff" } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-9' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    issue.issueDisplay
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-3 text-right text-bold' },
	                            issue.cusip
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 vertical-offset-sm' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                'data-name': 'faq-nav-tabs',
	                                className: 'nav-tabs nav-tabs-border' },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                isCorp && _react2.default.createElement(
	                                    'li',
	                                    { className: tab === 'default-events' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'events-ratings-default-events',
	                                            className: 'subhead',
	                                            onClick: function onClick() {
	                                                return setTab('default-events');
	                                            } },
	                                        'Default Events'
	                                    )
	                                ),
	                                isMuni && _react2.default.createElement(
	                                    'li',
	                                    { className: tab === 'material-event-filings' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'events-ratings-material-event-filings',
	                                            className: 'subhead',
	                                            onClick: function onClick() {
	                                                return setTab('material-event-filings');
	                                            } },
	                                        'Material Event Filings'
	                                    )
	                                ),
	                                isMuni && _react2.default.createElement(
	                                    'li',
	                                    { className: tab === 'disclosure-filings' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'events-ratings-disclosure-filings',
	                                            className: 'subhead',
	                                            onClick: function onClick() {
	                                                return setTab('disclosure-filings');
	                                            } },
	                                        'Disclosure Filings'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: tab === 'redemptions' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'events-ratings-redemptions',
	                                            className: 'subhead',
	                                            onClick: function onClick() {
	                                                return setTab('redemptions');
	                                            } },
	                                        'Redemptions'
	                                    )
	                                ),
	                                hasRtg && _react2.default.createElement(
	                                    'li',
	                                    { className: tab === 'credit-ratings-actions' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'events-ratings-credit-ratings-actions',
	                                            className: 'subhead',
	                                            onClick: function onClick() {
	                                                return setTab('credit-ratings-actions');
	                                            } },
	                                        'Credit Rating Actions'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        tab === 'default-events' && _react2.default.createElement(_defaultEvents2.default, {
	                            rows: (0, _twd.arrayFrom)((events.filter(function (e) {
	                                return e.eventName === 'taxabledefaultevents';
	                            })[0] || {}).eventList)
	                        }),
	                        tab === 'material-event-filings' && _react2.default.createElement(_materialEventFilings2.default, {
	                            rows: (0, _twd.arrayFrom)((events.filter(function (e) {
	                                return e.eventName === 'eventfilings';
	                            })[0] || {}).eventList)
	                        }),
	                        tab === 'disclosure-filings' && _react2.default.createElement(_disclosureFilings2.default, {
	                            rows: (0, _twd.arrayFrom)((events.filter(function (e) {
	                                return e.eventName === 'disclosurefiling';
	                            })[0] || {}).eventList)
	                        }),
	                        tab === 'redemptions' && _react2.default.createElement(_redemptions2.default, {
	                            rows: (0, _twd.arrayFrom)((events.filter(function (e) {
	                                return e.eventName === 'redemptions';
	                            })[0] || {}).eventList)
	                        }),
	                        tab === 'credit-ratings-actions' && _react2.default.createElement(_creditRatingActions2.default, {
	                            rows: (0, _twd.arrayFrom)((events.filter(function (e) {
	                                return e.eventName === 'creditrating';
	                            })[0] || {}).creditRatingList)
	                        })
	                    ),
	                    _react2.default.createElement('div', { className: 'col-md-2 col-xs-1' })
	                )
	            )
	        )
	    );
	};

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _empty = __webpack_require__(195);
	
	var _empty2 = _interopRequireDefault(_empty);
	
	var _foot = __webpack_require__(196);
	
	var _foot2 = _interopRequireDefault(_foot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var rows = _ref.rows;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        (!rows || rows.length === 0) && (0, _empty2.default)({ msg: 'There are no redemptions since 9/30/2011' }),
	        rows && rows.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-name': 'bond-detail-events-ratings-redemptions-table',
	                    className: 'table table-striped align-top' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date Published'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Event Description'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rows && rows.map(function (r, i) {
	                        return _react2.default.createElement(
	                            'tr',
	                            {
	                                'data-name': 'bond-detail-events-ratings-redemptions-row',
	                                key: i },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _twd.fmt.mdy(r.alertDate)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                r.alertDescription
	                            )
	                        );
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(_foot2.default, { label: 'Redemptions' })
	    );
	};

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define,no-mixed-operators */
	var freqCodeLabel = function freqCodeLabel(a) {
	    return {
	        'A': 'Annually',
	        'S': 'Semi-Annually',
	        'Q': 'Quarterly',
	        'M': 'Monthly'
	    }[a] || '-';
	};
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$issue = _ref.issue,
	        issue = _ref$issue === undefined ? {} : _ref$issue;
	
	    var datum = issue.cachedDatum || {};
	    var cpns = (0, _twd.arrayFrom)(datum.couponSchedule);
	    var fcs = (0, _twd.arrayFrom)(datum.fltfcSchedule);
	    var rss = (0, _twd.arrayFrom)(datum.fltrsSchedule);
	
	    var bms = (0, _twd.arrayFrom)(datum.fltbmSchedule);
	    var f2f = bms.map(function (a, i, arr) {
	        var r = {
	            couponFormula: (0, _twd.parseHtml)(a.fltrxText),
	            reset: a.dt,
	            until: arr[i + 1] && arr[i + 1].dt || issue.maturity
	        };
	        var rDt = new Date(r.reset);
	        var uDt = new Date(r.until);
	        var cur = new Date();
	        if (cur >= rDt && cur <= uDt) {
	            Object.assign(r, {
	                nextDetermination: issue.nextDeterminationDt,
	                nextResetDt: issue.nextResetDate
	            });
	        }
	
	        var fc = fcs.filter(function (a) {
	            return a.dt === r.reset;
	        })[0];
	        if (fc) {
	            Object.assign(r, {
	                cap: fc.ceiling,
	                floor: fc.floor
	            });
	        }
	
	        var rs = rss.filter(function (a) {
	            return a.dt === r.reset;
	        })[0];
	        if (rs) {
	            r.frequency = freqCodeLabel(rs.freqCode);
	        }
	
	        var cpn = cpns.filter(function (a) {
	            return a.dt === r.reset;
	        })[0];
	        if (cpn) {
	            Object.assign(r, {
	                couponRate: cpn.coupon,
	                estInd: String(cpn.estInd) === '1'
	            });
	        }
	
	        return r;
	    });
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'bond-detail-ars-info-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'modal-title text-center' },
	                        issue.f2fFixedInd === 'Y' ? 'Fixed To Float F2F Info' : 'Floating/Variable FLT Info'
	                    ),
	                    _react2.default.createElement('h5', { className: 'modal-title text-center vertical-offset-sm', dangerouslySetInnerHTML: { __html: (0, _twd.parseHtml)(issue.formulaText).replaceAll('<BR>', ' ') } }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive' },
	                                _react2.default.createElement(
	                                    'table',
	                                    {
	                                        'data-name': 'bond-detail-ars-info-table',
	                                        className: 'table align-top' },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Reset Frequency'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Current Reset'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Next',
	                                                _react2.default.createElement('br', null),
	                                                'Reset'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Next Determination'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Floor'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Cap'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { width: '35%' },
	                                                'Formula'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Coupon Rate'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Until'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        f2f.map(function (a, i) {
	                                            return _react2.default.createElement(
	                                                'tr',
	                                                { key: i },
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.frequency || _twd.fmt.empty()
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.reset
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.nextResetDt || _twd.fmt.empty()
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.nextDetermination || _twd.fmt.empty()
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.floor || _twd.fmt.empty()
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.cap || _twd.fmt.empty()
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.couponFormula || _twd.fmt.empty()
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.couponRate || _twd.fmt.empty(),
	                                                    _react2.default.createElement(
	                                                        'sup',
	                                                        null,
	                                                        a.estInd ? 'EST' : ''
	                                                    )
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    a.until
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$list = _ref.list,
	        list = _ref$list === undefined ? [] : _ref$list;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'bond-detail-underwriter-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Factor schedule'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive' },
	                                _react2.default.createElement(
	                                    'table',
	                                    {
	                                        'data-name': 'bond-detail-underwriter-table',
	                                        className: 'table align-top table-striped' },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Date'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'text-right' },
	                                                'Factor'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        list.map(function (r, i) {
	                                            return _react2.default.createElement(
	                                                'tr',
	                                                { key: i },
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    _twd.fmt.mdy(r.factorDt)
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    { className: 'text-right' },
	                                                    _twd.fmt.factor(r.factor)
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _bondDetail = __webpack_require__(316);
	
	var _style = __webpack_require__(90);
	
	var _couponType = __webpack_require__(462);
	
	var _couponType2 = _interopRequireDefault(_couponType);
	
	var _order = __webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); } /** @jsx jsx */
	/* eslint-disable no-use-before-define,no-empty-pattern */
	
	
	exports.default = function (_ref) {
	    _objectDestructuringEmpty(_ref);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue,
	        offer = _useBondDetail.offer,
	        bid = _useBondDetail.bid,
	        ask = _useBondDetail.ask,
	        hold = _useBondDetail.hold;
	
	    var invType = issue.type;
	    var isMBS = ['O', 'R', 'K'].indexOf(invType) >= 0;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12 col-md-9' },
	                (0, _core.jsx)(
	                    'h2',
	                    { className: 'large-header' },
	                    issue.issueDisplay
	                ),
	                (0, _core.jsx)('h6', { className: 'subhead', dangerouslySetInnerHTML: { __html: (0, _twd.parseHtml)(issue.descriptionInfo).replace('<br>', '') } })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12 col-md-3 text-right' },
	                (0, _core.jsx)(AddToWatclisthButton, null),
	                (0, _core.jsx)(_order.Sell, null),
	                (0, _core.jsx)(_order.Buy, null)
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'dl',
	                { css: _style.listCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-4 col-xs-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Bid'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (0, _core.jsx)(_order.Bid, { dataName: 'bond-detail-header-bid' })
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Bid qty'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.qty(bid.quantity)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Bid YTM/YTW'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.ytw3(bid.ytm),
	                        ' / ',
	                        _twd.fmt.ytw3(bid.ytw)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Ask'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (0, _core.jsx)(_order.Ask, { dataName: 'bond-detail-header-ask' })
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Ask qty'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.qty(ask.quantity)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Ask YTM/YTW'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.ytw3(ask.ytm),
	                        ' / ',
	                        _twd.fmt.ytw3(ask.ytw)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Quote request'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        { style: { fontWeight: 'normal' } },
	                        function () {
	                            var isMatured = (0, _twd.parseDate)(issue.maturityEff) < Date.now() || (0, _twd.parseDate)(issue.redemptionDt) < Date.now() || issue.calledInFullInd === 'Y';
	                            var arr = [!isMatured && issue.allowTrading && hold.length > 0 ? (0, _core.jsx)(_order.BidWanted, { dataName: 'bond-detail-header-bid-wanted' }) : null, !isMatured && issue.allowTrading && issue.newIssueInd !== 'Y' && issue.type !== 'P' ? (0, _core.jsx)(_order.OfferWanted, { dataName: 'bond-detail-header-bid-wanted' }) : null].filter(Boolean);
	
	                            return arr.length === 0 ? _twd.fmt.empty() : arr.length === 1 ? arr[0] : (0, _core.jsx)(
	                                _react2.default.Fragment,
	                                null,
	                                arr[0],
	                                ' | ',
	                                arr[1]
	                            );
	                        }()
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-4 col-xs-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Product Type'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        function () {
	                            var invType = issue.spInd === 'Y' ? 'L' : issue.type;
	                            return _bondDetail.INV_TYPE_LABELS[invType] || _twd.fmt.empty();
	                        }()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'CUSIP'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        issue.cusip
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'ISIN'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        issue.isin
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Maturity date'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.mdy(issue.maturity)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Callable'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.YES_NO[isMBS ? 'N' : issue.callableInd] || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'New issue'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.YES_NO[issue.newIssueInd] || _twd.fmt.empty()
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-4 col-xs-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.ytw3(issue.coupon)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Coupon type'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (0, _core.jsx)(_couponType2.default, { issue: issue, offer: offer })
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Next coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.mdy(issue.nextCoupon)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Last coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.mdy(issue.lastCoupon)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Pay frequency'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.COUPON_FREQUENCY_LABELS[issue.frequencyCode] || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Min denom/increment'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.qty(issue.minAmt),
	                        'x',
	                        _twd.fmt.qty(issue.denominationAmt)
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	    );
	};
	
	var AddToWatclisthButton = function AddToWatclisthButton() {
	
	    return (0, _core.jsx)(_twd.Flyout, {
	        html: "Add to watchlist",
	        className: 'link-button large-header',
	        placement: 'bottom',
	        trigger: ["hover", "focus"],
	        iconName: 'playlist_add',
	        iconCls: 'material-icons et-icon-xs',
	        popperStyles: { width: '150px' },
	        isButton: false,
	        onClick: function onClick() {
	            (0, _twd.openWindow)('https://us.etrade.com/etx/pw/watchlists#/wl');
	        }
	    });
	};

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.important_documents', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var bond = (0, _useBondDetail.useBondDetail)();
	    var docs = Documents.map(function (f) {
	        return f(bond);
	    }).filter(Boolean);
	    if (docs.length === 0) return null;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-important-documents',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'Important documents',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' }),
	                        docs.map(function (d, i) {
	                            return (0, _core.jsx)(
	                                'div',
	                                { key: i, className: 'row vertical-offset-sm' },
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'col-xs-12' },
	                                    d
	                                )
	                            );
	                        })
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' })
	        )
	    );
	};
	
	var Documents = [
	// factsheet
	function (_ref) {
	    var issue = _ref.issue,
	        ask = _ref.ask;
	
	    var f = (0, _twd.hasSvc)('FACT') && ['M', 'C'].indexOf(issue.type) >= 0 && issue.currencyCode === 'USD' && issue.floaterInd === 'N' && issue.linkedIndexInd === 'N';
	    if (!f) return;
	
	    var sp = new URLSearchParams([['p_id', ask.id || ''], ['p_type', issue.type || ''], ['p_cusip', issue.cusip || '']]);
	
	    var url = 'https://www.bonddesk.com/' + (0, _twd.getBrand)() + '/servlet/rtresult/factsheet.pdf?' + sp.toString();
	
	    return (0, _core.jsx)(
	        'button',
	        {
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)(url, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('picture_as_pdf'), 'Factsheet'),
	        ' '
	    );
	},
	
	// moody rating
	function (_ref2) {
	    var issue = _ref2.issue;
	
	    var f = (0, _twd.hasSvc)('MDBR') && ['M', 'C', 'A', 'P'].indexOf(issue.type) >= 0 && issue.moodyRating && ['-', 'Nr', 'Nr-A', 'NR', 'WR', 'Wr'].indexOf(issue.moodyRating) < 0;
	    if (!f) return;
	
	    return (0, _core.jsx)(
	        'button',
	        {
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)('/esb/moodysreport/getBondReport?cusip=' + issue.cusip, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('picture_as_pdf'), "Moody's Bond Report"),
	        ' '
	    );
	},
	
	// prospectus
	function (_ref3) {
	    var issue = _ref3.issue;
	    var research = issue.research;
	
	    var f = Array.isArray(research) && research.filter(function (r) {
	        return r.type === 'legal';
	    })[0];
	    if (!f) return;
	
	    var url = 'https://www.bonddesk.com' + f.url.replace("BDResearch.showViewer('", "").replace("');", "");
	
	    return (0, _core.jsx)(
	        'button',
	        {
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)(url, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('open_in_new'), 'Prospectus/Offering Document')
	    );
	},
	
	// emma
	function (_ref4) {
	    var issue = _ref4.issue;
	
	    var f = (0, _twd.hasSvc)('EMMA') && ['M'].indexOf(issue.type) >= 0 && issue.currencyCode === 'USD';
	    if (!f) return;
	
	    var url = (0, _twd.fixURL)('https://us.etrade.com/e/t/jumppage/viewjumppage?PageName=speedbump&comp=https%3A%2F%2Femma.msrb.org' + '%2FSecurityView%2FSecurityDetails.aspx%3Fcusip=' + issue.cusip);
	
	    return (0, _core.jsx)(
	        'button',
	        {
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)(url, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('open_in_new'), 'Disclosure info/EMMA')
	    );
	}];

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$list = _ref.list,
	        list = _ref$list === undefined ? [] : _ref$list;
	
	    var style = {
	        fontWeight: 400,
	        color: '#767676'
	    };
	    list.sort(function (a, b) {
	        return a.speedLevel - b.speedLevel;
	    });
	    var n = list.length;
	    var size = n > 5 ? 'modal-lg' : n > 2 ? 'modal-md' : 'modal-sm';
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: "modal-dialog " + size },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'bond-detail-mbs-speed-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'MBS speed information'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive' },
	                                _react2.default.createElement(
	                                    'table',
	                                    {
	                                        'data-name': 'bond-detail-mbs-speed-table',
	                                        className: 'table align-top' },
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { style: style },
	                                                'Interest rate shift'
	                                            ),
	                                            list.map(function (a, i) {
	                                                return _react2.default.createElement(
	                                                    'td',
	                                                    { key: i, className: 'text-right' },
	                                                    a.speedLevel
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { style: style },
	                                                'Speed'
	                                            ),
	                                            list.map(function (a, i) {
	                                                return _react2.default.createElement(
	                                                    'td',
	                                                    { key: i, className: 'text-right' },
	                                                    a.prepayModelValue,
	                                                    ' ',
	                                                    a.prepayModelType
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { style: style },
	                                                'Average life'
	                                            ),
	                                            list.map(function (a, i) {
	                                                return _react2.default.createElement(
	                                                    'td',
	                                                    { key: i, className: 'text-right' },
	                                                    _twd.fmt.dur(a.avgLife)
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { style: style },
	                                                'Next principal'
	                                            ),
	                                            list.map(function (a, i) {
	                                                return _react2.default.createElement(
	                                                    'td',
	                                                    { key: i, className: 'text-right' },
	                                                    _twd.fmt.mdy(a.firstPrincipal)
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { style: style },
	                                                'Last principal'
	                                            ),
	                                            list.map(function (a, i) {
	                                                return _react2.default.createElement(
	                                                    'td',
	                                                    { key: i, className: 'text-right' },
	                                                    _twd.fmt.mdy(a.lastPrincipal)
	                                                );
	                                            })
	                                        ),
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'td',
	                                                { style: style },
	                                                'Yield %'
	                                            ),
	                                            list.map(function (a, i) {
	                                                return _react2.default.createElement(
	                                                    'td',
	                                                    { key: i, className: 'text-right' },
	                                                    _twd.fmt.ytw(a.expYield)
	                                                );
	                                            })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _style = __webpack_require__(90);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.mbs_speed', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        offer = _useBondDetail.offer;
	
	    var hasMbs = !offer.errorText && offer.mbsSpeedLevel && offer.mbsSpeedLevel.length > 0 && offer.speedHistory && offer.speedHistory.length > 0;
	
	    if (!hasMbs) return null;
	
	    var speed = offer.speedHistory.map(_twd.parseHtml);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-mbs-speed',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'MBS information',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)(
	                            'table',
	                            { className: 'table', css: _style.tableCss },
	                            (0, _core.jsx)(
	                                'thead',
	                                null,
	                                (0, _core.jsx)(
	                                    'tr',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'th',
	                                        null,
	                                        'MBS speed information'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'th',
	                                        { className: 'text-right' },
	                                        (0, _core.jsx)(
	                                            'button',
	                                            {
	                                                className: 'link-button',
	                                                onClick: function onClick(e) {
	                                                    (0, _twd.showModal)({
	                                                        view: 'mbs-speed',
	                                                        list: offer.mbsSpeedLevel,
	                                                        from: 'bond-detail',
	                                                        source: e.target
	                                                    });
	                                                } },
	                                            'View chart'
	                                        )
	                                    )
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'tbody',
	                                null,
	                                (0, _core.jsx)(
	                                    'tr',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        '1 month actual'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        speed[0] || _twd.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'tr',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        '3 month avg.'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        speed[1] || _twd.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'tr',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        '6 month avg.'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        speed[2] || _twd.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'tr',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        '12 month avg.'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        speed[3] || _twd.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'tr',
	                                    null,
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        'Lifetime avg.'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'td',
	                                        null,
	                                        speed[4] || _twd.fmt.empty()
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define,no-mixed-operators */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$issue = _ref.issue,
	        issue = _ref$issue === undefined ? {} : _ref$issue;
	
	    var steps = (0, _twd.arrayFrom)(issue.stepSchedule);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'bond-detail-multi-step-coupon-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'modal-title text-center' },
	                        'Multi-Step Coupon'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive' },
	                                _react2.default.createElement(
	                                    'table',
	                                    {
	                                        'data-name': 'bond-detail-multi-step-coupon-table',
	                                        className: 'table align-top table-striped'
	                                    },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Date'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                { className: 'text-right' },
	                                                'Coupon'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        steps.map(function (s, i) {
	                                            return _react2.default.createElement(
	                                                'tr',
	                                                { key: i },
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    _twd.fmt.mdy(s.dt)
	                                                ),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    { className: 'text-right' },
	                                                    cpn2(s.coupon)
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var cpn2 = function cpn2(a) {
	    var x = Number.parseFloat(a);
	    return isNaN(x) ? _twd.fmt.empty() : x.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	};

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OfferWanted = exports.BidWanted = exports.Ask = exports.Bid = exports.Buy = exports.Sell = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail7 = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sell = exports.Sell = function Sell() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'bond-detail-sell' : _ref$dataName;
	
	    var _useBondDetail = (0, _useBondDetail7.useBondDetail)(),
	        issue = _useBondDetail.issue,
	        hold = _useBondDetail.hold,
	        bid = _useBondDetail.bid;
	
	    if (hold.length === 0) return null;
	
	    return bid && bid.id && issue.allowTrading ? order({
	        label: 'Sell',
	        style: { minWidth: '69px', minHeight: '25px', marginLeft: '20px' },
	        action: 'S',
	        acctNo: hold[0].acctNo,
	        cusip: issue.cusip,
	        dataName: dataName,
	        className: 'btn btn-primary'
	    }) : null;
	}; /* eslint-disable no-use-before-define,no-empty-pattern */
	var Buy = exports.Buy = function Buy() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$dataName = _ref2.dataName,
	        dataName = _ref2$dataName === undefined ? 'bond-detail-buy' : _ref2$dataName;
	
	    var _useBondDetail2 = (0, _useBondDetail7.useBondDetail)(),
	        issue = _useBondDetail2.issue,
	        ask = _useBondDetail2.ask;
	
	    return ask && ask.id && issue.allowTrading ? order({
	        label: 'Buy',
	        style: { minWidth: '69px', minHeight: '25px', marginLeft: '20px' },
	        action: 'B',
	        cusip: issue.cusip,
	        dataName: dataName,
	        className: 'btn btn-primary'
	    }) : _twd.fmt.orderPhone({ style: { marginLeft: '20px' } });
	};
	
	var Bid = exports.Bid = function Bid() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$dataName = _ref3.dataName,
	        dataName = _ref3$dataName === undefined ? 'bond-detail-bid' : _ref3$dataName;
	
	    var _useBondDetail3 = (0, _useBondDetail7.useBondDetail)(),
	        issue = _useBondDetail3.issue,
	        bid = _useBondDetail3.bid,
	        hold = _useBondDetail3.hold;
	
	    var h = hold[0];
	    var action = 'S';
	    if (h) {
	        var bidQty = parseFloat(bid.quantity);
	        var holdQty = h.qty;
	        action = bidQty > holdQty ? 'S' : 'W';
	    }
	
	    return issue.allowTrading && h ? order({
	        label: _twd.fmt.price3N(bid.dispPrice),
	        action: action,
	        acctNo: hold[0].acctNo,
	        cusip: issue.cusip,
	        dataName: dataName
	    }) : _twd.fmt.price3N(bid.dispPrice);
	};
	
	var Ask = exports.Ask = function Ask() {
	    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref4$dataName = _ref4.dataName,
	        dataName = _ref4$dataName === undefined ? 'bond-detail-ask' : _ref4$dataName;
	
	    var _useBondDetail4 = (0, _useBondDetail7.useBondDetail)(),
	        issue = _useBondDetail4.issue,
	        ask = _useBondDetail4.ask;
	
	    return ask && ask.id && issue.allowTrading ? order({
	        action: 'B',
	        label: _twd.fmt.price3N(ask.dispPrice),
	        cusip: issue.cusip,
	        dataName: dataName
	    }) : _twd.fmt.price3N(ask.dispPrice);
	};
	
	var BidWanted = exports.BidWanted = function BidWanted() {
	    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref5$dataName = _ref5.dataName,
	        dataName = _ref5$dataName === undefined ? 'bond-detail-ask' : _ref5$dataName;
	
	    var _useBondDetail5 = (0, _useBondDetail7.useBondDetail)(),
	        issue = _useBondDetail5.issue,
	        hold = _useBondDetail5.hold;
	
	    return issue.allowTrading && hold.length > 0 ? order({
	        action: 'W',
	        label: 'Bid wanted',
	        acctNo: hold[0].acctNo,
	        cusip: issue.cusip,
	        dataName: dataName
	    }) : null;
	};
	
	var OfferWanted = exports.OfferWanted = function OfferWanted() {
	    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref6$dataName = _ref6.dataName,
	        dataName = _ref6$dataName === undefined ? 'bond-detail-ask' : _ref6$dataName;
	
	    var _useBondDetail6 = (0, _useBondDetail7.useBondDetail)(),
	        issue = _useBondDetail6.issue;
	
	    return issue.allowTrading ? order({
	        action: 'F',
	        label: 'Offer wanted',
	        cusip: issue.cusip,
	        dataName: dataName
	    }) : null;
	};
	
	var order = function order(_ref7) {
	    var label = _ref7.label,
	        cusip = _ref7.cusip,
	        _ref7$acctNo = _ref7.acctNo,
	        acctNo = _ref7$acctNo === undefined ? '' : _ref7$acctNo,
	        _ref7$qty = _ref7.qty,
	        qty = _ref7$qty === undefined ? '' : _ref7$qty,
	        _ref7$action = _ref7.action,
	        action = _ref7$action === undefined ? 'B' : _ref7$action,
	        _ref7$sourceAction = _ref7.sourceAction,
	        sourceAction = _ref7$sourceAction === undefined ? '' : _ref7$sourceAction,
	        _ref7$dataName = _ref7.dataName,
	        dataName = _ref7$dataName === undefined ? '' : _ref7$dataName,
	        _ref7$style = _ref7.style,
	        style = _ref7$style === undefined ? {} : _ref7$style,
	        _ref7$className = _ref7.className,
	        className = _ref7$className === undefined ? 'link-button' : _ref7$className;
	    return _react2.default.createElement(
	        'a',
	        { href: '#',
	            'data-name': dataName,
	            type: 'button',
	            className: className,
	            style: style,
	            onClick: function onClick() {
	                (0, _twd.hideModal)();
	                (0, _twd.showBondOrder)({
	                    action: action,
	                    cusip: cusip,
	                    acctNo: acctNo,
	                    qty: qty,
	                    sourceAction: sourceAction,
	                    ts: Date.now(),
	                    from: '#bond-detail.' + cusip
	                });
	            }
	        },
	        label
	    );
	};

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	var _underwriter = __webpack_require__(463);
	
	var _underwriter2 = _interopRequireDefault(_underwriter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.original_issuance', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue;
	
	    var invType = issue.type;
	    var hasMore = ['C', 'M', 'T', 'A', 'S'].indexOf(invType) >= 0 && !(invType === 'C' && issue.category === 'N') && !(invType === 'S' && issue.category === 'N');
	    var isPreferred = invType === 'P';
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-original-issuance',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'Original issuance',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)(
	                            'dl',
	                            { css: _style.sectionListCss },
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Issue Date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.issueDt)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Dated date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.dated) || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'First trade date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                (0, _twd.parseHtml)(issue.firstExecution) || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'First settlement'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.firstSettlement) || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Original size'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.qty((0, _twd.parseHtml)(issue.originalIssue).trim().replaceAll('$', '').replaceAll(',', ''), isPreferred ? {} : { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }, isPreferred ? ' Shares' : '')
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Outstanding issue size'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.qty(issue.outstandingAmt, { style: 'currency', currency: 'USD', maximumFractionDigits: 0 })
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Original issue price/yield'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.price3(issue.originalPrice),
	                                '/',
	                                _twd.fmt.ytw(issue.originalYield)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Revised issue price'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.priceDemin(issue.revIssuePrice)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Delivery'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                DELIVERY[issue.delivery] || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Underwriter'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                (0, _core.jsx)(_underwriter2.default, { html: issue.underwriter })
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Collateral'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                (0, _twd.parseHtml)(issue.collateralDesc) || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Factor'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                issue.factor && Array.from(issue.factorList).length > 0 && (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        className: 'link-button',
	                                        onClick: function onClick(e) {
	                                            (0, _twd.showModal)({
	                                                view: 'factors',
	                                                list: issue.factorList,
	                                                from: 'bond-detail',
	                                                source: e.target
	                                            });
	                                        } },
	                                    _twd.fmt.factor(issue.factor)
	                                ) || issue.factor && (0, _core.jsx)(
	                                    _react2.default.Fragment,
	                                    null,
	                                    _twd.fmt.factor(issue.factor)
	                                ) || _twd.fmt.empty()
	                            )
	                        ),
	                        hasMore && (0, _core.jsx)(
	                            'div',
	                            { className: 'row' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'col-xs-12' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        className: 'link-button',
	                                        onClick: function onClick(e) {
	                                            (0, _twd.showModal)({
	                                                view: 'offerings-modal',
	                                                name: issue.issueDisplay,
	                                                maturity: 'ALL',
	                                                params: Object.assign({
	                                                    persistToPreviousSearches: false,
	                                                    holdInvType: [issue.type]
	                                                }, issue.type === 'C' && issue.symbol && { holdSymbol: [issue.symbol] }, issue.type !== 'C' && { holdIssue: [issue.issue] }),
	                                                from: 'bond-detail',
	                                                source: e.target
	                                            });
	                                        } },
	                                    'More offerings from this issuer'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};
	
	var DELIVERY = {
	    "A": "Registered Or Bearer",
	    "B": "Bearer",
	    "C": "Book Entry",
	    "I": "Interchangeable",
	    "R": "Registered",
	    "Z": "Custodial Receipt"
	};

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.redemption_features', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        showCall = _React$useState4[0],
	        setShowCall = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(false),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        showSink = _React$useState6[0],
	        setShowSink = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(false),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        showPut = _React$useState8[0],
	        setShowPut = _React$useState8[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue;
	
	    var invType = issue.type;
	    var isMBS = ['O', 'R', 'K'].indexOf(invType) >= 0;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-redemption-features',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'Redemption features',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)(
	                            'dl',
	                            { css: _style.sectionListCss },
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Redemption type'
	                            ),
	                            (0, _core.jsx)('dd', { dangerouslySetInnerHTML: {
	                                    __html: [(0, _twd.parseHtml)(issue.callfeaturesText), (0, _twd.parseHtml)(issue.callMakeWholeDisplay)].filter(Boolean).join('<br/>') || _twd.fmt.emptyHtml
	                                } }),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Callable'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.YES_NO[isMBS ? 'N' : issue.callableInd] || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Putable'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.YES_NO[issue.putableInd] || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Sinking fund'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.YES_NO[issue.nextSink ? 'Y' : 'N']
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Conditional call'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                (0, _twd.parseHtml)(issue.conditionalcallreason) || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Conditional call in full'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.YES_NO[issue.calledInFullInd] || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Next call date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                (0, _twd.parseHtml)(issue.calldaysnoticeText) || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Next put date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.nextOptPutDt)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Put type'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                function () {
	                                    var p = getPutType(issue);
	                                    if (!p) return _twd.fmt.empty();
	
	                                    return (0, _core.jsx)(
	                                        _react2.default.Fragment,
	                                        null,
	                                        p.label,
	                                        '\xA0',
	                                        p.tip && (0, _core.jsx)(_twd.Flyout, { html: p.tip })
	                                    );
	                                }()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Next sink'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.nextSink)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Make whole end date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.callMakeWholeExp)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Make whole benchmark/spread'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.nullIf(issue.callMakeWholeBenchmark, 'Unknown') || _twd.fmt.empty(),
	                                ' / ',
	                                _twd.fmt.nullIf(issue.callMakeWholeSpread, '-') || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Make whole yield'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.ytw(issue.callMakeWholeYield)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Call schedule'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                issue.displayCallSched === 'Y' && issue.callList && issue.callList.length > 0 && (0, _core.jsx)(
	                                    'button',
	                                    { className: 'link-button',
	                                        onClick: function onClick() {
	                                            return setShowCall(!showCall);
	                                        }
	                                    },
	                                    (0, _twd.matIcon)(showCall ? 'keyboard_arrow_down' : 'keyboard_arrow_right', ''),
	                                    'View schedule'
	                                ) || _twd.fmt.empty(),
	                                showCall && issue.displayCallSched === 'Y' && issue.callList && issue.callList.length > 0 && issue.callList.map(function (s, i) {
	                                    return (0, _core.jsx)(
	                                        'p',
	                                        { key: i },
	                                        _twd.fmt.mdy(s.callDt),
	                                        '@ ',
	                                        _twd.fmt.price3(s.callPrice)
	                                    );
	                                })
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Put schedule'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                issue.displayPutSchedule === 'Y' && issue.putSchedule && issue.putSchedule.length > 0 && (0, _core.jsx)(
	                                    'button',
	                                    { className: 'link-button',
	                                        onClick: function onClick() {
	                                            return setShowPut(!showPut);
	                                        }
	                                    },
	                                    (0, _twd.matIcon)(showPut ? 'keyboard_arrow_down' : 'keyboard_arrow_right', ''),
	                                    'View schedule'
	                                ) || _twd.fmt.empty(),
	                                showPut && issue.displayPutSchedule === 'Y' && issue.putSchedule && issue.putSchedule.length > 0 && issue.putSchedule.map(function (s, i) {
	                                    return (0, _core.jsx)(
	                                        'p',
	                                        { key: i },
	                                        _twd.fmt.mdy(s.dt),
	                                        '@ ',
	                                        _twd.fmt.qty(s.price)
	                                    );
	                                })
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Sink schedule'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                issue.sinkSchedule && issue.sinkSchedule.length > 0 && (0, _core.jsx)(
	                                    'button',
	                                    { className: 'link-button',
	                                        onClick: function onClick() {
	                                            return setShowSink(!showSink);
	                                        }
	                                    },
	                                    (0, _twd.matIcon)(showSink ? 'keyboard_arrow_down' : 'keyboard_arrow_right', ''),
	                                    'View schedule'
	                                ) || _twd.fmt.empty(),
	                                showSink && issue.sinkSchedule && issue.sinkSchedule.length > 0 && issue.sinkSchedule.map(function (s, i) {
	                                    return (0, _core.jsx)(
	                                        'p',
	                                        { key: i },
	                                        _twd.fmt.mdy(s.dt),
	                                        '@ ',
	                                        _twd.fmt.qty(s.amt)
	                                    );
	                                })
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Security Notes'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.initCap(issue.note) || _twd.fmt.empty()
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' })
	        )
	    );
	};
	
	var getPutType = function getPutType(_ref) {
	    var conditionalputreason = _ref.conditionalputreason,
	        condPutFeatures = _ref.condPutFeatures,
	        putType = _ref.putType;
	
	    return conditionalputreason && conditionalputreason === 'Death of holder' && PUT_TYPE_CODE.D || conditionalputreason && { label: (0, _twd.parseHtml)(conditionalputreason) } || PUT_TYPE_CODE[condPutFeatures];
	};
	
	var PUT_TYPE_CODE = {
	    'A': {
	        label: 'Convenant violation'
	    },
	    'B': {
	        label: 'Change of control'
	    },
	    'C': {
	        label: 'Rating downgrade'
	    },
	    'D': {
	        label: 'Death of holder',
	        tip: 'Survivors Options may vary among issuers. Please review the Prospectus and the Pricing Supplement for additional information regarding the Survivors Option.'
	    },
	    'Z': {
	        label: 'Other'
	    }
	};

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBondDetail2 = __webpack_require__(74);
	
	var _style = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('bond_detail.reference_information', {
	    show: true
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.show),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        state.set({ show: m });
	        setShowSection_(m);
	    }, []);
	
	    var _useBondDetail = (0, _useBondDetail2.useBondDetail)(),
	        issue = _useBondDetail.issue;
	
	    var isSp = issue.structuredPrdCdsInd === 'Y' && ['C', 'S'].indexOf(issue.type) >= 0;
	    if (!isSp) return null;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'xs-hide vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'bond-detail-original-issuance',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        _twd.Section,
	                        {
	                            title: 'Reference Asset(s) Information',
	                            show: showSection,
	                            setShow: setShowSection,
	                            cls: 'small-header',
	                            arrowSize: 'large'
	                        },
	                        (0, _core.jsx)(
	                            'dl',
	                            { css: _style.sectionListCss },
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Initial valuation date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.initialValDate)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Final valuation date'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.mdy(issue.finalValDate) || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Principal protection %'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.cpn(issue.principalProtectionAmt)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Principal protection type'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                issue.principalProtectionDesc || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Buffer %'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.cpn(issue.buffer)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Participation type'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                issue.participationDesc || _twd.fmt.empty()
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Participation rate'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.qty(issue.participationAmt)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Minimum return (floor)'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.qty(issue.minRedemptionAmt)
	                            ),
	                            (0, _core.jsx)(
	                                'dt',
	                                null,
	                                'Maxiumum return (cap)'
	                            ),
	                            (0, _core.jsx)(
	                                'dd',
	                                null,
	                                _twd.fmt.qty(issue.maxRedemptionAmt)
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$list = _ref.list,
	        list = _ref$list === undefined ? [] : _ref$list;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-md' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'bond-detail-underwriter-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Underwriters'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'table-responsive' },
	                                _react2.default.createElement(
	                                    'table',
	                                    {
	                                        'data-name': 'bond-detail-underwriter-table',
	                                        className: 'table align-top table-striped' },
	                                    _react2.default.createElement(
	                                        'thead',
	                                        null,
	                                        _react2.default.createElement(
	                                            'tr',
	                                            null,
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Underwriter'
	                                            ),
	                                            _react2.default.createElement(
	                                                'th',
	                                                null,
	                                                'Syndicate'
	                                            )
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tbody',
	                                        null,
	                                        list.map(function (r, i) {
	                                            return _react2.default.createElement(
	                                                'tr',
	                                                { key: i },
	                                                _react2.default.createElement('td', { dangerouslySetInnerHTML: { __html: r.name } }),
	                                                _react2.default.createElement(
	                                                    'td',
	                                                    null,
	                                                    r.rank
	                                                )
	                                            );
	                                        })
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BondDetails = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(235);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	var _header = __webpack_require__(833);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	var BondDetails = exports.BondDetails = function BondDetails() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        bondInfo = _useCalculator.bondInfo,
	        from_ = _useCalculator.from_;
	
	    if ((0, _twd.isEmpty)(bondInfo)) return null;
	
	    var issue = bondInfo.issue || {};
	    var bestoffer = bondInfo.bestoffer || {};
	    var bid = bestoffer.bid || {};
	    var ask = bestoffer.ask || {};
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)('div', {
	                    className: 'h3 text-bold text-truncate',
	                    style: { marginBottom: '0px', maxWidth: '300px', display: 'inline' },
	                    dangerouslySetInnerHTML: { __html: issue.issue }
	                }),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'text-bold', style: { display: 'inline', paddingLeft: '5px' } },
	                    issue.cusip
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row  vertical-offset-xs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12 text-muted' },
	                (0, _core.jsx)('div', { style: { fontWeight: 500 }, dangerouslySetInnerHTML: { __html: issue.warningText } })
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row bond-details-row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-9 col-xs-12 vertical-offset-sm' },
	                (0, _core.jsx)(Offer, { bid: bid }),
	                (0, _core.jsx)(Offer, { ask: ask })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-3 col-xs-12 text-center vertical-offset-sm bond-details-buttons', css: _style.textAlignRight },
	                (0, _core.jsx)(
	                    'div',
	                    { style: { marginTop: 'auto' } },
	                    (0, _core.jsx)(OrderButton, { action: 'S', bondInfo: bondInfo, from: from_ }),
	                    (0, _core.jsx)(OrderButton, { action: 'B', bondInfo: bondInfo, from: from_ })
	                )
	            )
	        ),
	        (0, _core.jsx)(_header.Header, null)
	    );
	};
	
	var Offer = function Offer(_ref) {
	    var ask = _ref.ask,
	        bid = _ref.bid;
	
	    var obj = bid ? bid : ask;
	
	    if (!obj || !obj.id) return null;
	
	    var label = bid ? 'Current best bid:' : 'Current best offer:';
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            null,
	            (0, _core.jsx)(
	                'span',
	                { className: 'text-bold', style: { paddingRight: '10px' } },
	                label
	            ),
	            'Price ',
	            (0, _core.jsx)(
	                'span',
	                { className: 'text-bold', style: { paddingRight: '10px' } },
	                _twd.fmt.price3(obj.dispPrice)
	            ),
	            'YTM/YTW ',
	            (0, _core.jsx)(
	                'span',
	                { className: 'text-bold', style: { paddingRight: '10px' } },
	                _twd.fmt.ytw3(obj.ytm),
	                '/',
	                _twd.fmt.ytw3(obj.ytw)
	            ),
	            'Quantity ',
	            (0, _core.jsx)(
	                'span',
	                { className: 'text-bold' },
	                'Min. ',
	                _twd.fmt.qty(obj.quantityMin),
	                ' - Max. ',
	                _twd.fmt.qty(obj.quantity)
	            )
	        )
	    );
	};
	
	var OrderButton = function OrderButton(_ref2) {
	    var action_ = _ref2.action,
	        bondInfo = _ref2.bondInfo,
	        from = _ref2.from;
	
	    if (!bondInfo) return null;
	
	    var label = action_ === 'S' ? 'Sell' : 'Buy';
	    var action = action_ === 'S' && bondInfo.isHeld && bondInfo.hasBid ? 'S' : action_ === 'S' && bondInfo.isHeld && !bondInfo.hasBid ? 'W' : !bondInfo.canTrade ? '' : action_ === 'B' && bondInfo.isRestricted ? '-' : action_ === 'B' && bondInfo.hasAsk ? 'B' : action_ === 'B' && !bondInfo.hasAsk ? 'F' : '';
	
	    if (action === '-') {
	        return _twd.fmt.orderPhone({ style: { marginLeft: '20px' } });
	    }
	
	    if (!action) return null;
	
	    return (0, _core.jsx)(
	        'a',
	        { href: '#',
	            type: 'button',
	            className: 'btn btn-xs btn-primary-outline text-bold',
	            style: {
	                paddingLeft: '20px',
	                paddingRight: '20px',
	                marginLeft: '10px'
	            },
	            onClick: function onClick() {
	                (0, _twd.hideModal)();
	                (0, _twd.showBondOrder)((0, _twd.cleanObject)({
	                    action: action,
	                    cusip: bondInfo.cusip,
	                    qty: action === 'S' ? bondInfo.holdings[0].qty : null,
	                    from: from,
	                    ts: Date.now()
	                }));
	            }
	        },
	        label
	    );
	};

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.INV_TYPE_LABELS = exports.Header = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define,no-empty-pattern */
	
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(235);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = exports.Header = function Header() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        bondInfo = _useCalculator.bondInfo;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection = _React$useState2[1];
	
	    if ((0, _twd.isEmpty)(bondInfo)) return null;
	
	    var issue = bondInfo.issue || {};
	    var bestoffer = bondInfo.bestoffer || {};
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row calculator-bond-details-headers' },
	            (0, _core.jsx)(
	                'div',
	                { className: "col-md-12" },
	                (0, _core.jsx)(_twd.SectionHeader, {
	                    title: 'Bond details',
	                    cls: 'subhead',
	                    arrowSize: 'large',
	                    show: showSection,
	                    setShow: setShowSection
	                })
	            )
	        ),
	        (0, _core.jsx)(
	            _twd.SectionBody,
	            { show: showSection },
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-base calculator-bond-details-headers' },
	                (0, _core.jsx)(
	                    'dl',
	                    { css: _style.listCss },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-4 col-xs-12' },
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Type'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            function () {
	                                var invType = issue.spInd === 'Y' ? 'L' : issue.type;
	                                return INV_TYPE_LABELS[invType] || _twd.fmt.empty();
	                            }()
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'CUSIP'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            issue.cusip
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Maturity date'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.mdy(issue.maturity)
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Settlement date'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.mdy(bondInfo.settlement) || _twd.fmt.empty()
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Frequency'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.COUPON_FREQUENCY_LABELS[issue.frequencyCode] || _twd.fmt.empty()
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-4 col-xs-12' },
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Day Count'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.COUPON_DAY_COUNT_LABELS[issue.currDaycount] || _twd.fmt.empty()
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Redemption value'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.price3(issue.redemptionPrice)
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Issue date'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.mdy(issue.issueDt)
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'First coupon date'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.mdy(issue.firstCoupon)
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Last coupon date'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.mdy(issue.lastCoupon)
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-4 col-xs-12' },
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Coupon'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.ytw3(issue.coupon)
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Federally taxable'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.YES_NO[issue.taxable] || _twd.fmt.empty()
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'State taxable'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.YES_NO[issue.stateTaxExempt === 'No' ? 'N' : 'Y'] || _twd.fmt.empty()
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Call date'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.mdy(bestoffer.ytcRdate)
	                        ),
	                        (0, _core.jsx)(
	                            'dt',
	                            null,
	                            'Call price'
	                        ),
	                        (0, _core.jsx)(
	                            'dd',
	                            null,
	                            _twd.fmt.price3(bestoffer.ytcRprice)
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var INV_TYPE_LABELS = exports.INV_TYPE_LABELS = {
	    'A': 'Agency',
	    'R': 'Pass-Through',
	    'K': 'Asset-Backed',
	    'S': 'CD',
	    'O': 'CMO',
	    'C': 'Corporate',
	    'M': 'Municipal',
	    'P': 'Preferred',
	    'L': 'Structured',
	    'T': 'Treasury'
	};

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CalcCoupons = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	var _couponsFirstYear = __webpack_require__(836);
	
	var _couponsByYear = __webpack_require__(835);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalcCoupons = exports.CalcCoupons = function CalcCoupons() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        calcOutput = _useCalculator.calcOutput,
	        showCoupon = _useCalculator.showCoupon,
	        bondInfo = _useCalculator.bondInfo;
	
	    var _React$useState = _react2.default.useState('first-year'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        show = _React$useState2[0],
	        setShow = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(showCoupon),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        showSection = _React$useState4[0],
	        setShowSection = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        if (!showCoupon) return;
	
	        setShowSection(true);
	    }, [showCoupon]);
	
	    var isShow = bondInfo && bondInfo.canCalc;
	    if (!isShow) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: "col-md-12" },
	                _react2.default.createElement(_twd.SectionHeader, {
	                    title: 'Coupon payment schedules',
	                    cls: 'subhead',
	                    arrowSize: 'large',
	                    show: showSection,
	                    setShow: setShowSection
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _twd.SectionBody,
	            { show: showSection },
	            (0, _twd.isEmpty)(calcOutput) && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-md' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 text-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'vertical-offset-xs' },
	                            _react2.default.createElement('i', { className: 'et-icon-md et-icon et-alert', 'aria-hidden': 'true' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'vertical-offset-xs' },
	                            _react2.default.createElement(
	                                'p',
	                                { className: 'small-header vertical-offset-xxs' },
	                                'Run calculation first'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'text-body' },
	                                'Coupon payment schedules are generated from calculator data.'
	                            )
	                        )
	                    )
	                )
	            ),
	            !(0, _twd.isEmpty)(calcOutput) && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 nav-tabs nav-tabs-border' },
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                { className: show === 'first-year' ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: function onClick() {
	                                            return setShow('first-year');
	                                        } },
	                                    'First 12 months'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                { className: show === 'by-year' ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'button',
	                                    { onClick: function onClick() {
	                                            return setShow('by-year');
	                                        } },
	                                    'By year'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        show === 'first-year' && _react2.default.createElement(_couponsFirstYear.CouponsFirstYear, null),
	                        show === 'by-year' && _react2.default.createElement(_couponsByYear.CouponsByYear, null)
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CouponsByYear = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    table {\n        width: 100%;\n        border-collapse: collapse;\n        table-layout: fixed;\n    }\n\n    thead, tfoot {\n        display: table;\n        width: 100%\n    }\n\n    tbody {\n        display: block;\n        max-height: 350px;\n        overflow-y: auto;\n        --webkit-overflow-scrolling: touch;\n    }\n\n    tbody tr { display: flex; }\n    th:nth-child(1), td:nth-child(1) { width: 50%; }\n    th:nth-child(2), td:nth-child(2) { width: 50%; }\n'], ['\n    table {\n        width: 100%;\n        border-collapse: collapse;\n        table-layout: fixed;\n    }\n\n    thead, tfoot {\n        display: table;\n        width: 100%\n    }\n\n    tbody {\n        display: block;\n        max-height: 350px;\n        overflow-y: auto;\n        --webkit-overflow-scrolling: touch;\n    }\n\n    tbody tr { display: flex; }\n    th:nth-child(1), td:nth-child(1) { width: 50%; }\n    th:nth-child(2), td:nth-child(2) { width: 50%; }\n']);
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var CouponsByYear = exports.CouponsByYear = function CouponsByYear() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        co = _useCalculator.calcOutput;
	
	    var payments = (0, _twd.arrayFrom)(co.paymentsByYears);
	    var total = payments.reduce(function (x, _ref) {
	        var interest = _ref.interest,
	            principal = _ref.principal;
	        return x + interest + principal;
	    }, 0);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'table-responsive', css: stickyTableCss },
	            (0, _core.jsx)(
	                'table',
	                { className: 'table table-striped coupon-payments', style: { marginBottom: 0 } },
	                (0, _core.jsx)(
	                    'thead',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'th',
	                            null,
	                            'Date'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-right' },
	                            'Payment amount'
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'tbody',
	                    null,
	                    payments.map(function (_ref2, i) {
	                        var date = _ref2.date,
	                            interest = _ref2.interest,
	                            principal = _ref2.principal;
	
	                        return (0, _core.jsx)(
	                            'tr',
	                            { key: i },
	                            (0, _core.jsx)(
	                                'td',
	                                null,
	                                i === 0 ? 'YTD ' : '',
	                                _twd.fmt.fmtDt(date, 'yyyy'),
	                                ' ',
	                                interest && principal ? '*' : ''
	                            ),
	                            (0, _core.jsx)(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.money(interest + principal)
	                            )
	                        );
	                    })
	                ),
	                (0, _core.jsx)(
	                    'tfoot',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-bold' },
	                            'Total'
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-bold text-right' },
	                            _twd.fmt.money(total)
	                        )
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            null,
	            (0, _core.jsx)(
	                'div',
	                { className: 'vertical-offset-base' },
	                '* Includes interest and principal payment'
	            )
	        )
	    );
	};
	
	var stickyTableCss = (0, _core.css)(_templateObject);

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CouponsFirstYear = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CouponsFirstYear = exports.CouponsFirstYear = function CouponsFirstYear() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        co = _useCalculator.calcOutput,
	        bi = _useCalculator.bondInfo,
	        ci = _useCalculator.calcInput;
	
	    var firstYear = (0, _twd.arrayFrom)(co.paymentsFirstYear).reduce(function (x, r) {
	        return Object.assign({}, x, _defineProperty({}, _twd.fmt.fmtDt(r.date, 'MMMM yyyy'), r));
	    }, {});
	
	    var issue = (bi || {}).issue;
	    var mat = (0, _twd.parseDate)(issue.maturity);
	    var now = (0, _twd.parseDate)((ci || {}).settlement) || new Date();
	    var payments = [].concat(_toConsumableArray(Array(12).keys())).map(function (i) {
	        var d = new Date(now.getFullYear(), now.getMonth() + i, 1);
	        if (d > mat) return null;
	
	        var ds = _twd.fmt.fmtDt(d, 'MMMM yyyy');
	        return Object.assign({
	            dateStr: ds,
	            principal: 0,
	            interest: 0
	        }, firstYear[ds]);
	    }).filter(Boolean);
	
	    var total = payments.reduce(function (x, _ref) {
	        var interest = _ref.interest,
	            principal = _ref.principal;
	        return x + interest + principal;
	    }, 0);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                { className: 'table table-striped coupon-payments', style: { marginBottom: 0 } },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Payment amount'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    payments.map(function (_ref2, i) {
	                        var dateStr = _ref2.dateStr,
	                            interest = _ref2.interest,
	                            principal = _ref2.principal;
	
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: i },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                dateStr,
	                                ' ',
	                                interest && principal ? '*' : ''
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.money(interest + principal)
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement(
	                    'tfoot',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-bold' },
	                            'Total'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-bold text-right' },
	                            _twd.fmt.money(total)
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-base' },
	            '* Includes interest and principal payment'
	        )
	    );
	};

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CalcInput = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	var _action = __webpack_require__(838);
	
	var _priceOrYield = __webpack_require__(839);
	
	var _priceYield = __webpack_require__(840);
	
	var _quantity = __webpack_require__(841);
	
	var _settlement = __webpack_require__(842);
	
	var _getCalcInput = __webpack_require__(464);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalcInput = exports.CalcInput = function CalcInput() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        step = _useCalculator.step,
	        cusip = _useCalculator.cusip,
	        calcInput = _useCalculator.calcInput,
	        bondInfo = _useCalculator.bondInfo,
	        setCalcInput = _useCalculator.setCalcInput,
	        setCalcOutput = _useCalculator.setCalcOutput;
	
	    var input = calcInput || {};
	
	    var _React$useState = _react2.default.useState(input.action || 'B'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        action = _React$useState2[0],
	        setAction = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(input.priceOrYield || 1),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        priceOrYield = _React$useState4[0],
	        setPriceOrYield = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(input.priceYield),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        priceYield = _React$useState6[0],
	        setPriceYield = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(input.qty),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        qty = _React$useState8[0],
	        setQty = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(input.settlement),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        settlement = _React$useState10[0],
	        setSettlement = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState(true),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        showSection = _React$useState12[0],
	        setShowSection = _React$useState12[1];
	
	    var _React$useState13 = _react2.default.useState({}),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        errors = _React$useState14[0],
	        setErrors = _React$useState14[1];
	
	    _react2.default.useEffect(function () {
	        if (!bondInfo) {
	            return;
	        }
	
	        if (!settlement && bondInfo.settlement) {
	            setSettlement(bondInfo.settlement);
	        }
	
	        var issue = bondInfo && bondInfo.issue || {};
	        var stl = (0, _twd.parseDate)(settlement || bondInfo.settlement);
	        var mat = (0, _twd.parseDate)(issue.maturity);
	        if (stl && mat && stl > mat) {
	            setErrors(Object.assign(errors, {
	                settlement: 'Date cannot exceed Maturity date'
	            }));
	        }
	    }, [bondInfo]);
	
	    _react2.default.useEffect(function () {
	        if (step !== _useCalculator2.STEPS.CUSIP_INPUT) return;
	        setAction('B');
	        setPriceOrYield(1);
	        setPriceYield('');
	        setQty('');
	        setShowSection(true);
	        setErrors({});
	    }, [step]);
	
	    var isShow = bondInfo && bondInfo.canCalc;
	    if (!isShow) return null;
	
	    var ci = { cusip: cusip, action: action, priceOrYield: priceOrYield, priceYield: priceYield, qty: qty, settlement: settlement };
	
	    var onEnter = function onEnter(isShowError) {
	        var err = (0, _getCalcInput.getCalcInputErrors)(bondInfo, ci);
	        var hasErr = Object.keys(err).length > 0;
	        if (hasErr && !isShowError) {
	            return;
	        }
	
	        setErrors(err);
	        setCalcOutput(null);
	        setCalcInput(ci);
	    };
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: "col-md-12" },
	                _react2.default.createElement(_twd.SectionHeader, {
	                    title: 'Calculator inputs',
	                    afterTitle: _react2.default.createElement(_twd.Flyout, { html: calcInputTooltip, ariaLabel: 'Calculator inputs information' }),
	                    cls: 'subhead',
	                    arrowSize: 'large',
	                    show: showSection,
	                    setShow: setShowSection
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _twd.SectionBody,
	            { show: showSection },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement('div', { className: 'col-xs-12 col-auto xs-hide', style: { minWidth: '10px' } }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-auto', style: { minWidth: '116px' } },
	                    _react2.default.createElement(_action.Action, {
	                        action: action,
	                        setAction: setAction })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-auto', style: { minWidth: '116px' } },
	                    _react2.default.createElement(_priceOrYield.PriceOrYield, {
	                        priceOrYield: priceOrYield,
	                        setPriceOrYield: setPriceOrYield
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-auto', style: { minWidth: '130px' } },
	                    _react2.default.createElement(_priceYield.PriceYield, {
	                        priceOrYield: priceOrYield,
	                        priceYield: priceYield,
	                        setPriceYield: setPriceYield,
	                        err: errors.priceYield,
	                        bondInfo: bondInfo,
	                        action: action,
	                        isLoading: step === _useCalculator2.STEPS.INIT_LOADING || step === _useCalculator2.STEPS.CUSIP_LOADING || step === _useCalculator2.STEPS.CALC_LOADING,
	                        onEnter: onEnter
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-auto', style: { minWidth: '103px' } },
	                    _react2.default.createElement(_quantity.Quantity, {
	                        quantity: qty,
	                        setQuantity: setQty,
	                        err: errors.quantity,
	                        onEnter: onEnter
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-auto', style: { minWidth: '120px' } },
	                    _react2.default.createElement(_settlement.Settlement, {
	                        settlement: settlement,
	                        setSettlement: setSettlement,
	                        err: errors.settlement,
	                        bondInfo: bondInfo,
	                        onEnter: onEnter
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-auto', style: { minWidth: '100px' } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'from-group ',
	                            style: { paddingLeft: '0px', paddingRight: '0px' }
	                        },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                type: 'button',
	                                className: 'btn btn-primary btn-block',
	                                style: { marginTop: '20px' },
	                                onClick: function onClick() {
	                                    onEnter(true);
	                                }
	                            },
	                            'Calculate'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement('div', { className: 'row xs-show md-show vertical-offset-base' })
	        )
	    );
	};
	
	var calcInputTooltip = '\n<p>To run a calculation using this tool, several inputs must be populated by the user.  First, using the \u201CAction\u201D menu, indicate whether you are buying or selling the bond in this hypothetical trade scenario.  Next, choose whether you wish to calculate based upon a target price or yield value under the \u201CCalculate using\u201D menu.  Next, input the target price or yield aligning with the former selection.  Lastly, input the quantity of bonds you\u2019re buying or selling for this scenario.</p>\n\n<p>Please note:\n<ul>\n<li>The \u201CAction\u201D menu will default to the \u201CBuy\u201D selection</li>\n<li>The \u201CCalculate using\u201D menu will default to the \u201CPrice\u201D selection</li>\n<li>The \u201CPrice\u201D field will be pre-populated with the current best available offer price (when available)</li>\n<li>The \u201CSettlement Date\u201D will always default to regular way settlement, assuming the present day as trade date</li>\n</ul>\n</p>\n\n<p>Users can interact with each of these menus and manually change the variables for custom scenarios. Results generated from default or custom inputs may not align with live market trade outcomes.</p>\n\n';

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Action = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Action = exports.Action = function Action(_ref) {
	    var action = _ref.action,
	        setAction = _ref.setAction;
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'form-group',
	                style: { paddingLeft: '0px', paddingRight: '0px' }
	            },
	            _react2.default.createElement(
	                'label',
	                {
	                    className: 'label',
	                    htmlFor: id,
	                    style: { lineHeight: '20px', display: 'inline', textAlign: 'left', marginBottom: 0 }
	                },
	                'Action'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'select-wrapper' },
	                _react2.default.createElement(
	                    'select',
	                    {
	                        id: id,
	                        'data-name': 'calculator-enter-input-action',
	                        defaultValue: action,
	                        onChange: function onChange(e) {
	                            return setAction(e.target.value);
	                        },
	                        className: 'form-control'
	                    },
	                    _react2.default.createElement(
	                        'option',
	                        { value: 'B', selected: action === 'B' },
	                        'Buy'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: 'S', selected: action === 'S' },
	                        'Sell'
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PriceOrYield = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var PriceOrYield = exports.PriceOrYield = function PriceOrYield(_ref) {
	    var priceOrYield = _ref.priceOrYield,
	        setPriceOrYield = _ref.setPriceOrYield;
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'form-group',
	                style: { paddingLeft: '0px', paddingRight: '0px' }
	            },
	            _react2.default.createElement(
	                'label',
	                {
	                    className: 'label',
	                    htmlFor: id,
	                    style: { lineHeight: '20px', display: 'inline', textAlign: 'left', marginBottom: 0 }
	                },
	                'Calculate using'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'select-wrapper' },
	                _react2.default.createElement(
	                    'select',
	                    {
	                        id: id,
	                        'data-name': 'calculator-enter-input-action',
	                        defaultValue: priceOrYield,
	                        onChange: function onChange(e) {
	                            return setPriceOrYield(e.target.value);
	                        },
	                        className: 'form-control'
	                    },
	                    _react2.default.createElement(
	                        'option',
	                        { value: '1', selected: String(priceOrYield) === '1' },
	                        'Price'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: '2', selected: String(priceOrYield) === '2' },
	                        'YTM'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: '0', selected: String(priceOrYield) === '0' },
	                        'YTW'
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PriceYield = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define, eqeqeq */
	var PriceYield = exports.PriceYield = function PriceYield(_ref) {
	    var priceOrYield = _ref.priceOrYield,
	        priceYield = _ref.priceYield,
	        setPriceYield = _ref.setPriceYield,
	        err = _ref.err,
	        bondInfo = _ref.bondInfo,
	        action = _ref.action,
	        isLoading = _ref.isLoading,
	        onEnter = _ref.onEnter;
	
	    var id = (0, _twd.getId)();
	    var py = String(priceOrYield);
	    var isPrice = py === '1';
	    var label = isPrice ? 'Price' : 'Yield';
	    var linkLabel = action === 'S' && bondInfo.hasBid ? isPrice ? ' Use best bid price' : ' Use best bid yield' : action === 'B' && bondInfo.hasAsk ? isPrice ? ' Use best offer price' : ' Use best offer yield' : '';
	
	    var linkField = py === '1' ? 'price' : py === '2' ? 'ytm' : py === '0' ? 'ytw' : '';
	    var linkObject = action === 'S' && bondInfo.hasBid ? bondInfo.bestoffer.bid : action === 'B' && bondInfo.hasAsk ? bondInfo.bestoffer.ask : null;
	    var linkValue = linkObject && linkField ? (0, _twd.safeNum)(linkObject[linkField]) : null;
	
	    _react2.default.useEffect(function () {
	        if ((0, _twd.isEmpty)(priceOrYield)) return;
	        if (isLoading && !(0, _twd.isEmpty)(priceYield)) return;
	        setPriceYield(linkValue || '');
	    }, [priceOrYield, action]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                { style: { display: 'flex' } },
	                _react2.default.createElement(
	                    'label',
	                    {
	                        className: 'label price-yield-label',
	                        htmlFor: id
	                    },
	                    label
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'text-body price-yield-link'
	                    },
	                    linkValue && _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn-link',
	                            onClick: function onClick() {
	                                var v = (0, _twd.isEmpty)(priceYield) || priceYield != linkValue ? linkValue : '';
	                                setPriceYield(v);
	                            }
	                        },
	                        linkLabel
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: (err ? ' has-error' : '') + ' price-yield-input' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'input-group vertical-offset-xxs' },
	                    isPrice && _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-addon' },
	                        '$'
	                    ),
	                    _react2.default.createElement('input', {
	                        className: 'form-control',
	                        type: 'number',
	                        id: id,
	                        value: priceYield,
	                        onChange: function onChange(e) {
	                            return setPriceYield(e.target.value);
	                        },
	                        style: Object.assign({}, isPrice && { paddingLeft: '20px' }),
	                        onKeyUp: function onKeyUp(e) {
	                            var key = e.keyCode || e.key || e.which;
	                            if (!(key === 13 || key === 'Enter')) return;
	
	                            e.preventDefault();
	                            onEnter();
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-addon' },
	                        isPrice ? _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            '\xA0'
	                        ) : '%'
	                    )
	                ),
	                err && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    err
	                )
	            )
	        )
	    );
	};

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Quantity = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Quantity = exports.Quantity = function Quantity(_ref) {
	    var quantity = _ref.quantity,
	        setQuantity = _ref.setQuantity,
	        err = _ref.err,
	        onEnter = _ref.onEnter;
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_twd.Flyout, {
	                    label: 'Quantity',
	                    isLabel: true,
	                    labelAttrs: { htmlFor: id, className: 'label' },
	                    html: QuantityTooltip,
	                    labelStyle: { lineHeight: '20px', display: 'inline', flex: 1, marginBottom: 0 }
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: err ? ' has-error' : '' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-xxs' },
	                    _react2.default.createElement('input', {
	                        className: 'form-control',
	                        type: 'number',
	                        id: id,
	                        value: quantity,
	                        onChange: function onChange(e) {
	                            return setQuantity(e.target.value);
	                        },
	                        onKeyUp: function onKeyUp(e) {
	                            var key = e.keyCode || e.key || e.which;
	                            if (!(key === 13 || key === 'Enter')) return;
	
	                            e.preventDefault();
	                            onEnter();
	                        }
	                    })
	                ),
	                err && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    err
	                )
	            )
	        )
	    );
	};
	
	var QuantityTooltip = '\n<p>Utilize the quantity field to input the number of bonds you wish to buy or sell in this hypothetical trade scenario.  You will find the available quantities associated with the current best bid and current best offer on the platform (when available) below the issuer name present at the top of this tool.<p>\n\n<p>Please note:<br/>\nLive markets may not be available to support orders for custom quantities which fall above or below the displayed dealer levels.</p>\n';

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Settlement = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Settlement = exports.Settlement = function Settlement(_ref) {
	    var settlement = _ref.settlement,
	        setSettlement = _ref.setSettlement,
	        err = _ref.err,
	        onEnter = _ref.onEnter;
	
	    var id = (0, _twd.getId)();
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm' },
	            _react2.default.createElement(
	                'label',
	                {
	                    className: 'label',
	                    htmlFor: id,
	                    style: { lineHeight: '20px', display: 'inline', marginBottom: 0 }
	                },
	                'Settlement date'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: err ? ' has-error' : '' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-xxs' },
	                    _react2.default.createElement('input', {
	                        className: 'form-control text-muted',
	                        type: 'text',
	                        id: id,
	                        value: settlement,
	                        onChange: function onChange(e) {
	                            return setSettlement(e.target.value);
	                        },
	                        onKeyUp: function onKeyUp(e) {
	                            var key = e.keyCode || e.key || e.which;
	                            if (!(key === 13 || key === 'Enter')) return;
	
	                            e.preventDefault();
	                            onEnter();
	                        }
	                    })
	                ),
	                err && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    err
	                )
	            )
	        )
	    );
	};

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CalcOutput = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _chartOrTable = __webpack_require__(847);
	
	var _yieldTable = __webpack_require__(851);
	
	var _perTransaction = __webpack_require__(849);
	
	var _twd = __webpack_require__(2);
	
	var _actionCard = __webpack_require__(844);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalcOutput = exports.CalcOutput = function CalcOutput() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        step = _useCalculator.step,
	        calcOutput = _useCalculator.calcOutput,
	        changeCusip = _useCalculator.changeCusip,
	        bondInfo = _useCalculator.bondInfo;
	
	    var _React$useState = _react2.default.useState(true),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection = _React$useState2[1];
	
	    var isShow = bondInfo && bondInfo.canCalc && !(0, _twd.isEmpty)(calcOutput) && step === _useCalculator2.STEPS.CALC_OUTPUT;
	    if (!isShow) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xxs' },
	            _react2.default.createElement(
	                'div',
	                { className: "col-md-12" },
	                _react2.default.createElement(_twd.SectionHeader, {
	                    title: 'Calculation results',
	                    cls: 'subhead',
	                    arrowSize: 'large',
	                    show: showSection,
	                    setShow: setShowSection
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _twd.SectionBody,
	            { show: showSection },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-base' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { padding: '10px', backgroundColor: '#f6f6f6' } },
	                        _react2.default.createElement(_yieldTable.YieldTable, null),
	                        _react2.default.createElement('div', { className: 'vertical-offset-sm' }),
	                        _react2.default.createElement(_perTransaction.PerTransaction, null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    _react2.default.createElement('div', { className: 'md-show vertical-offset-base' }),
	                    _react2.default.createElement(_chartOrTable.ChartOrTable, { chartData: calcOutput.priceYields, bondInfo: bondInfo }),
	                    _react2.default.createElement('div', { className: 'vertical-offset-base' }),
	                    _react2.default.createElement(_actionCard.ActionCard, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-base' },
	                _react2.default.createElement('div', { className: 'col-md-4' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-4 text-center' },
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'button',
	                            className: 'btn btn-primary-outline btn-block',
	                            onClick: changeCusip
	                        },
	                        'Change CUSIP'
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'col-md-4' })
	            )
	        )
	    );
	};

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ActionCard = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCard = exports.ActionCard = function ActionCard() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        calcInput = _useCalculator.calcInput,
	        bondInfo = _useCalculator.bondInfo,
	        from_ = _useCalculator.from_;
	
	    var ci = calcInput;
	    var bi = bondInfo;
	    if (!ci || !bi) return null;
	
	    var isBuy = ci.action === 'B';
	    var isSell = ci.action === 'S';
	
	    var action = isBuy && (bi.isRestricted || !bi.canTrade) ? BUY_BOND_RESTRICTED : isSell && !bi.isHeld ? SELL_BOND_NOT_OWN : isBuy && bi.hasAsk ? BUY_BOND_LIVE : isBuy && !bi.hasAsk ? BUY_BOND_NO_LIVE : isSell && bi.hasBid ? SELL_BOND_LIVE : isSell && !bi.hasBid ? SELL_BOND_NO_LIVE : null;
	    if (!action) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'card card-primary',
	                style: { cursor: 'pointer' },
	                onClick: function onClick() {
	                    if (!action.action) return;
	
	                    (0, _twd.hideModal)();
	                    (0, _twd.showBondOrder)((0, _twd.cleanObject)({
	                        action: action.action,
	                        cusip: bondInfo.cusip,
	                        // price: calcOutput.price,
	                        // qty: calcOutput.qty,
	                        from: from_,
	                        ts: Date.now()
	
	                    }));
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'card-title text-center' },
	                    action.title
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-base' },
	                    action.text
	                ),
	                action.button && _react2.default.createElement(
	                    'div',
	                    { className: 'text-center' },
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'btn btn-primary', style: { width: '50%' } },
	                        action.button
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var BUY_BOND_LIVE = {
	    title: 'This security is available',
	    text: 'You can trade this security at the best available price. Keep in mind, current pricing listed in bond details may not align with custom calculations.',
	    button: 'Buy',
	    action: 'B'
	};
	
	var BUY_BOND_NO_LIVE = {
	    title: 'This security is not available',
	    text: 'There is no live market active for this security. However, you can request a price quote from dealers if you wish to place a trade.',
	    button: 'Offer wanted',
	    action: 'F'
	};
	
	var BUY_BOND_RESTRICTED = {
	    title: 'This security is not available',
	    text: 'Buy orders for this asset class are not available for online trading. Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders.'
	};
	
	var SELL_BOND_LIVE = {
	    title: 'This security is available',
	    text: 'You can trade this security at the best available price. Keep in mind, current pricing listed in bond details may not align with custom calculations.',
	    button: 'Sell',
	    action: 'S'
	};
	
	var SELL_BOND_NO_LIVE = {
	    title: 'This security is not available',
	    text: 'There is no live market active for this security. However, you can request a price quote from dealers if you wish to place a trade.',
	    button: 'Bid wanted',
	    action: 'W'
	};
	
	var SELL_BOND_NOT_OWN = {
	    title: 'This security is not available',
	    text: 'You do not currently hold any of this security to sell and E*TRADE does not allow short-selling of bonds. Keep in mind, current offer pricing listed in bond details may not align with price levels that result from custom calculations.'
	};

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChartCaption = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartCaption = exports.ChartCaption = function ChartCaption(_ref) {
	    var chartData = _ref.chartData,
	        bondInfo = _ref.bondInfo;
	    return _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Price'
	                ),
	                _react2.default.createElement(
	                    'th',
	                    null,
	                    'Yield to Maturity'
	                ),
	                bondInfo.isCallable && _react2.default.createElement(
	                    'th',
	                    null,
	                    'Yield to Call'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            chartData.map(function (_ref2, i) {
	                var price = _ref2.price,
	                    ytm = _ref2.ytm,
	                    ytc = _ref2.ytc;
	                return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        price
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        ytm
	                    ),
	                    bondInfo.isCallable && _react2.default.createElement(
	                        'td',
	                        null,
	                        ytc
	                    )
	                );
	            })
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChartFigure = undefined;
	
	var _legendCss;
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _recharts = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var ChartFigure = exports.ChartFigure = function ChartFigure(_ref) {
	    var chartData = _ref.chartData,
	        bondInfo = _ref.bondInfo;
	
	    var centerPrice = (chartData[4] || {}).price;
	    var maxYield = chartData.length > 0 ? Math.max.apply(Math, _toConsumableArray(chartData.map(function (_ref2) {
	        var ytc = _ref2.ytc,
	            ytm = _ref2.ytm;
	        return Math.max(Math.abs(ytc), Math.abs(ytm));
	    }).map(function (a) {
	        return parseInt(a, 10);
	    })).concat([0])) : 20;
	
	    return (0, _core.jsx)(
	        _recharts.ResponsiveContainer,
	        { width: '100%', height: 300 },
	        (0, _core.jsx)(
	            _recharts.ScatterChart,
	            {
	                margin: {
	                    top: 5,
	                    right: maxYield >= 1000 ? 40 : maxYield >= 100 ? 30 : maxYield >= 10 ? 20 : 15,
	                    left: 5,
	                    bottom: 5
	                }
	            },
	            (0, _core.jsx)(_recharts.CartesianGrid, { strokeDasharray: '3 3', vertical: false }),
	            (0, _core.jsx)(_recharts.XAxis, {
	                dataKey: 'x',
	                domain: ['auto', 'auto'],
	                padding: { left: 20, right: 10 },
	                type: 'number',
	                scale: 'linear',
	                tickLine: false,
	                interval: 0,
	                tick: (0, _core.jsx)(CustomXAxisTick, null),
	                ticks: chartData.map(function (a) {
	                    return a.price;
	                })
	            }),
	            (0, _core.jsx)(_recharts.YAxis, {
	                dataKey: 'y',
	                domain: ['auto', 'auto'],
	                padding: { top: 10, bottom: 10 },
	                width: 25,
	                scale: 'linear',
	                orientation: 'right',
	                tickFormatter: formatYAxisTicks
	            }),
	            !(0, _twd.isEmpty)(centerPrice) && (0, _core.jsx)(_recharts.ReferenceLine, {
	                x: centerPrice,
	                strokeDasharray: '3 3'
	            }),
	            (0, _core.jsx)(_recharts.Legend, {
	                verticalAlign: 'top',
	                align: 'left',
	                content: renderLegend
	            }),
	            (0, _core.jsx)(_recharts.Scatter, { name: 'ytm',
	                data: getData(chartData, 'ytm', '#8b06b9'),
	                line: true,
	                fill: '#8b06b9',
	                shape: renderShape }),
	            bondInfo.isCallable && (0, _core.jsx)(_recharts.Scatter, { name: 'ytc',
	                data: getData(chartData, 'ytc', '#ef6f06'),
	                line: true,
	                fill: '#ef6f06',
	                shape: renderShape }),
	            (0, _core.jsx)(_recharts.Tooltip, {
	                position: { y: 25 },
	                offset: 1,
	                content: (0, _core.jsx)(TooltipContent, Object.assign({ chartData: chartData }, { isCallable: bondInfo.isCallable })),
	                isAnimationActive: false,
	                cursor: (0, _core.jsx)(TooltipCursor, null),
	                wrapperStyle: { zIndex: 3 }
	            })
	        )
	    );
	};
	
	var getData = function getData(data, key, color) {
	    return data.filter(function (a) {
	        return !(0, _twd.isEmpty)(a[key]);
	    }).map(function (a) {
	        return {
	            key: key, color: color, x: a['price'], y: a[key]
	        };
	    });
	};
	
	var renderShape = function renderShape(_ref3) {
	    var cx = _ref3.cx,
	        cy = _ref3.cy,
	        x = _ref3.x,
	        y = _ref3.y,
	        width = _ref3.width,
	        height = _ref3.height,
	        color = _ref3.color;
	
	    var p = {
	        cx: cx, cy: cy, x: x, y: y, width: width, height: height,
	        stroke: color,
	        fill: '#fff',
	        r: 4,
	        className: 'recharts-dot'
	    };
	    return (0, _core.jsx)('circle', Object.assign({}, p, {
	        onMouseOver: function onMouseOver(e) {
	            return (0, _twd.domAttrSet)(e.target, { fill: color });
	        },
	        onMouseOut: function onMouseOut(e) {
	            return (0, _twd.domAttrSet)(e.target, { fill: '#fff' });
	        }
	    }));
	};
	
	var legends = {
	    'ytm': 'Yield to Maturity',
	    'ytc': 'Yield to Call'
	};
	
	var renderLegend = function renderLegend(_ref4) {
	    var payload = _ref4.payload;
	    return (0, _core.jsx)(
	        'div',
	        { style: { width: '100%', textAlign: 'left', marginBottom: '10px' } },
	        payload.map(function (entry, index) {
	            var v = entry.value;
	            return (0, _core.jsx)(
	                'span',
	                { key: index,
	                    style: { borderLeft: '4px solid ' + entry.color },
	                    css: legendCss },
	                '\xA0 ',
	                legends[v] || v
	            );
	        })
	    );
	};
	
	var legendCss = (_legendCss = {}, _defineProperty(_legendCss, _twd.mediaQueries.notXs, {
	    paddingRight: '10px'
	}), _defineProperty(_legendCss, _twd.mediaQueries.xs, {
	    paddingRight: '10px'
	}), _legendCss);
	
	var CustomXAxisTick = function CustomXAxisTick(_ref5) {
	    var x = _ref5.x,
	        y = _ref5.y,
	        stroke = _ref5.stroke,
	        fill = _ref5.fill,
	        payload = _ref5.payload,
	        index = _ref5.index;
	    var value = payload.value;
	
	
	    var isMajor = index % 2 === 0;
	    var text = isMajor ? value.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 }) : '';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('line', { 'class': 'recharts-cartesian-axis-tick-line', width: '295', height: '30', x: '20', y: '265',
	            stroke: isMajor ? "#666" : "#aaa",
	            fill: 'none',
	            x1: x,
	            y1: isMajor ? "271" : "269",
	            x2: x,
	            y2: '265'
	        }),
	        isMajor && (0, _core.jsx)(
	            'text',
	            {
	                width: '295',
	                height: '30',
	                x: x,
	                y: y,
	                stroke: stroke,
	                fill: fill,
	                'class': 'recharts-text recharts-cartesian-axis-tick-value', 'text-anchor': 'middle' },
	            (0, _core.jsx)(
	                'tspan',
	                {
	                    x: x,
	                    dy: '0.71em'
	                },
	                text
	            )
	        )
	    );
	};
	
	var formatYAxisTicks = function formatYAxisTicks(x) {
	    return x.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	};
	
	var TooltipContent = function TooltipContent(_ref6) {
	    var payload = _ref6.payload,
	        active = _ref6.active,
	        chartData = _ref6.chartData,
	        isCallable = _ref6.isCallable;
	
	    if (!active) return null;
	
	    var p = payload[0];
	    var a = p && p.payload;
	    if (!a) return null;
	
	    var b = chartData.filter(function (_ref7) {
	        var x = _ref7.price;
	        return x === a.x;
	    })[0];
	    if (!b) return null;
	
	    return (0, _core.jsx)(
	        'div',
	        { className: 'custom-tooltip',
	            style: { border: '1px solid #e4e4e4', backgroundColor: '#fff', textAlign: 'left', padding: '5px' } },
	        (0, _core.jsx)(
	            'div',
	            null,
	            (0, _core.jsx)(
	                'span',
	                { style: { paddingRight: '5px' } },
	                'Price  ',
	                (0, _core.jsx)(
	                    'b',
	                    null,
	                    _twd.format.price3(b['price'])
	                )
	            ),
	            (0, _core.jsx)(
	                'span',
	                { style: { borderLeft: '4px solid #8b06b9', paddingLeft: '5px', paddingRight: '5px' } },
	                'YTM  ',
	                (0, _core.jsx)(
	                    'b',
	                    null,
	                    _twd.format.ytw3(b['ytm'])
	                )
	            ),
	            isCallable && (0, _core.jsx)(
	                'span',
	                { style: { borderLeft: '4px solid #ef6f06', paddingLeft: '5px' } },
	                'YTC ',
	                (0, _core.jsx)(
	                    'b',
	                    null,
	                    _twd.format.ytw3(b['ytc'])
	                )
	            )
	        )
	    );
	};
	
	var TooltipCursor = function TooltipCursor(_ref8) {
	    var stroke = _ref8.stroke,
	        width = _ref8.width,
	        height = _ref8.height,
	        x = _ref8.x,
	        y = _ref8.y,
	        top = _ref8.top;
	
	
	    if (!x) return null;
	
	    var args = {
	        x: x, y: y, stroke: stroke, width: width, height: height,
	        className: 'recharts-cross recharts-tooltip-cursor',
	        pointerEvents: 'none',
	        strokeDasharray: '5',
	        d: 'M' + x + ',' + top + 'v' + height
	    };
	    return (0, _core.jsx)('path', args);
	};

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChartOrTable = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(848);
	
	var _table = __webpack_require__(850);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChartOrTable = exports.ChartOrTable = function ChartOrTable(_ref) {
	    var chartData = _ref.chartData,
	        bondInfo = _ref.bondInfo;
	
	    var _React$useState = _react2.default.useState('chart'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        show = _React$useState2[0],
	        setShow = _React$useState2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-xxs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'text-body text-bold', style: { display: 'inline' } },
	                'Yield to Maturity' + (bondInfo.isCallable ? '/Call' : '') + ' '
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'select-wrapper inline text-bold', style: getSelectStyle() },
	                _react2.default.createElement(
	                    'select',
	                    {
	                        'aria-label': 'show yield to maturity ' + (bondInfo.isCallable ? '/call' : '') + ' chart or table',
	                        defaultValue: show,
	                        style: { paddingRight: '35px' },
	                        onChange: function onChange(e) {
	                            return setShow(e.target.value);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'option',
	                        { value: 'chart' },
	                        'chart'
	                    ),
	                    _react2.default.createElement(
	                        'option',
	                        { value: 'table' },
	                        'table'
	                    )
	                )
	            )
	        ),
	        show === 'chart' && _react2.default.createElement(_chart.Chart, { chartData: chartData, bondInfo: bondInfo }),
	        show === 'table' && _react2.default.createElement(_table.Table, { chartData: chartData, bondInfo: bondInfo })
	    );
	};
	
	var getSelectStyle = function getSelectStyle() {
	    var color = getComputedStyle(document.documentElement).getPropertyValue('--primary-base-color').trim() || '#5627d8';
	    console.log(color);
	    return {
	        display: 'inline',
	        backgroundImage: "url(\"data:image/svg+xml;charset=utf8,%3Csvg width='12px' height='10px' viewBox='258 91 12 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(264.000000, 96.000000) rotate(90.000000) translate(-264.000000, -96.000000) translate(260.500000, 90.000000)'%3E%3Cpolygon id='Shape' fill='" + color.replace('#', '%23') + "' points='1 0 -0.4 1.4 4.2 6 -0.4 10.6 1 12 7 6'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\")",
	        backgroundRepeat: 'no-repeat',
	        backgroundPosition: 'calc(100% - 7px) 50%'
	    };
	};

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Chart = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chartCaption = __webpack_require__(845);
	
	var _chartFigure = __webpack_require__(846);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chart = exports.Chart = function Chart(_ref) {
	    var chartData = _ref.chartData,
	        bondInfo = _ref.bondInfo;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                Array.isArray(chartData) && _react2.default.createElement(
	                    'figure',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { 'aria-hidden': 'true', style: { fontSize: '12px' } },
	                        _react2.default.createElement(_chartFigure.ChartFigure, { chartData: chartData, bondInfo: bondInfo })
	                    ),
	                    _react2.default.createElement(
	                        'figcaption',
	                        { className: 'screen-reader-only' },
	                        _react2.default.createElement(_chartCaption.ChartCaption, { chartData: chartData, bondInfo: bondInfo })
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PerTransaction = undefined;
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(235);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PerTransaction = exports.PerTransaction = function PerTransaction() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        co = _useCalculator.calcOutput;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'h3',
	            null,
	            'Per transaction ($)'
	        ),
	        (0, _core.jsx)(
	            'dl',
	            { css: _style.resultListCss, style: { marginBottom: '0px' } },
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Amount'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.money(co.amount)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Commission'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.money(co.commission)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Accrued Int'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.money(co.accruedInt)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Total order'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.money(co.totalOrder)
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Table = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Table = exports.Table = function Table(_ref) {
	    var chartData = _ref.chartData;
	
	    var isBlue = (0, _twd.getConfig)('entitlements.ETradeBlue', 'No') === 'Yes';
	    var color = isBlue ? '#e9f2f9' : '#f3f0ff';
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped' },
	            _react2.default.createElement(
	                'thead',
	                { style: { borderBottomWidth: 'medium' } },
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-left', style: { width: '33%' } },
	                        'Price'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-left', style: { width: '33%' } },
	                        'Yield to Maturity'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right', style: { width: '33%' } },
	                        'Yield to Call'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                chartData.map(function (_ref2, i) {
	                    var price = _ref2.price,
	                        ytm = _ref2.ytm,
	                        ytc = _ref2.ytc;
	
	                    var style = i === 4 ? { backgroundColor: color } : {};
	                    return _react2.default.createElement(
	                        'tr',
	                        { className: 'text-right ' + (i === 4 ? 'text-bold' : ''), style: style },
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-left', style: { fontVariantNumeric: 'tabular-nums' } },
	                            alignNum(price, 3, 3)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-left', style: { fontVariantNumeric: 'tabular-nums' } },
	                            alignNum(ytm, 3, 4)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _twd.fmt.ytw3(ytc)
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var alignNum = function alignNum(num) {
	    var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	    var intWidthCh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
	
	    var x = parseFloat(num);
	    if (isNaN(x)) return _twd.fmt.empty();
	
	    var _x$toLocaleString$spl = x.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits }).split('.'),
	        _x$toLocaleString$spl2 = _slicedToArray(_x$toLocaleString$spl, 2),
	        i = _x$toLocaleString$spl2[0],
	        d = _x$toLocaleString$spl2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'span',
	            { style: {
	                    display: 'inline-block',
	                    width: intWidthCh + 'ch',
	                    textAlign: 'right'
	                } },
	            i
	        ),
	        d ? '.' + d : ''
	    );
	};

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.YieldTable = undefined;
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(235);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YieldTable = exports.YieldTable = function YieldTable() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        co = _useCalculator.calcOutput,
	        bondInfo = _useCalculator.bondInfo;
	
	    if ((0, _twd.isEmpty)(bondInfo)) return null;
	
	    var issue = bondInfo.issue || {};
	    var hasDisc = ['A', 'C', 'T'].indexOf(issue.type) >= 0 && issue.category === 'B';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'h3',
	            null,
	            'Price/Yields (Per bond)'
	        ),
	        (0, _core.jsx)(
	            'dl',
	            { css: _style.resultListCss },
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Price'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.price3(co.price)
	            ),
	            hasDisc && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'dt',
	                    null,
	                    'Discount'
	                ),
	                (0, _core.jsx)(
	                    'dd',
	                    null,
	                    _twd.fmt.ytw3(co.discountYield)
	                )
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                (0, _twd.isEmpty)(co.ytw) ? null : (0, _core.jsx)(
	                    _react2.default.Fragment,
	                    null,
	                    '(',
	                    _twd.fmt.mdy(co.ytwDate),
	                    '@',
	                    _twd.fmt.price0(co.ytwPrice),
	                    ') '
	                ),
	                'YTW'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.ytw3(co.ytw)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                (0, _twd.isEmpty)(co.ytm) ? null : (0, _core.jsx)(
	                    _react2.default.Fragment,
	                    null,
	                    '(',
	                    _twd.fmt.mdy(co.ytmDate),
	                    '@',
	                    _twd.fmt.price0(co.ytmPrice),
	                    ') '
	                ),
	                'YTM'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.ytw3(co.ytm)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                (0, _twd.isEmpty)(co.ytc) ? null : (0, _core.jsx)(
	                    _react2.default.Fragment,
	                    null,
	                    '(',
	                    _twd.fmt.mdy(co.ytcDate),
	                    '@',
	                    _twd.fmt.price0(co.ytcPrice),
	                    ') '
	                ),
	                'YTC'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.ytw3(co.ytc)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Yield-to-Sink'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.ytw3(co.yts)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Yield-to-Put'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.ytw3(co.ytp)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Yield-to-Par Call'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.ytw3(co.ytpc)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Cur Yield'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.ytw3(co.currentYield)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Duration'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.dur(co.duration)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                'Convexity'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.cty(co.convexity)
	            ),
	            (0, _core.jsx)(
	                'dt',
	                null,
	                _twd.fmt.count(co.accruedIntDays),
	                ' Days Acc. Int'
	            ),
	            (0, _core.jsx)(
	                'dd',
	                null,
	                _twd.fmt.money(co.accruedIntPerBond)
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CantCalc = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useCalculator2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CantCalc = exports.CantCalc = function CantCalc() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        bondInfo = _useCalculator.bondInfo;
	
	    if ((0, _twd.isEmpty)(bondInfo)) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        !bondInfo.canCalc && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12 text-center' },
	                _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' }),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Calculations are not supported for this bond. Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders'
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CusipInput = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' {\n        float: left;\n        width: calc(50% - 10px);\n        padding-right: 20px;\n    }\n'], ['\n    ', ' {\n        float: left;\n        width: calc(50% - 10px);\n        padding-right: 20px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    font-weight: 500;\n    ', ' {\n        display: inline-block;\n        max-width: 20px;\n        margin-top: 25px;\n        margin-left: 5px;\n    }\n    ', ' {\n        margin-bottom:15px;\n    }\n'], ['\n    font-weight: 500;\n    ', ' {\n        display: inline-block;\n        max-width: 20px;\n        margin-top: 25px;\n        margin-left: 5px;\n    }\n    ', ' {\n        margin-bottom:15px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ' {\n        float: right;\n        padding-left: 20px;\n        width: calc(50% - 10px);\n    }\n'], ['\n    ', ' {\n        float: right;\n        padding-left: 20px;\n        width: calc(50% - 10px);\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	var _selectHolding = __webpack_require__(855);
	
	var _inputCusip = __webpack_require__(854);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CusipInput = exports.CusipInput = function CusipInput() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        step = _useCalculator.step,
	        cusip_ = _useCalculator.cusip,
	        setCusip_ = _useCalculator.setCusip,
	        holdings = _useCalculator.holdings,
	        setBondInfo = _useCalculator.setBondInfo,
	        setCalcInput = _useCalculator.setCalcInput,
	        setCalcOutput = _useCalculator.setCalcOutput;
	
	    var _React$useState = _react2.default.useState(cusip_ || ''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        cusip = _React$useState2[0],
	        _setCusip = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        isError = _React$useState4[0],
	        setIsError = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        _setCusip(cusip_);
	        setIsError(false);
	    }, [cusip_]);
	
	    var isShow = step === _useCalculator2.STEPS.CUSIP_INPUT || step === _useCalculator2.STEPS.CUSIP_ERROR;
	    if (!isShow) return null;
	
	    var onEnter = function onEnter(value) {
	        var val = value && value.trim();
	        if (!val || !(0, _twd.isCusip)(val)) {
	            setIsError(true);
	            return;
	        }
	
	        setIsError(false);
	        setCusip_(val);
	        setBondInfo(null);
	        setCalcInput(null);
	        setCalcOutput(null);
	    };
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)(
	                    'h3',
	                    { className: 'subhead', style: { marginBottom: '0px' } },
	                    'Enter a CUSIP or select from your holdings'
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-6 col-xs-12', css: selectCusipCss },
	                (0, _core.jsx)(_inputCusip.InputCusip, {
	                    cusip: cusip,
	                    setCusip: _setCusip,
	                    isError: isError,
	                    onEnter: onEnter
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'text-center', css: orCss },
	                'or'
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-6 col-xs-12', css: selectHoldingCss },
	                (0, _core.jsx)(_selectHolding.SelectHolding, {
	                    cusip: cusip,
	                    setCusip: function setCusip(newCusip) {
	                        setIsError(false);
	                        _setCusip(newCusip);
	                    },
	                    holdings: holdings,
	                    isError: isError })
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)('div', { className: 'col-md-4 xs-hide' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-4 col-xs-12 text-center' },
	                (0, _core.jsx)(
	                    'button',
	                    {
	                        className: 'btn btn-primary btn-block',
	                        type: 'button',
	                        onClick: function onClick() {
	                            onEnter(cusip);
	                        } },
	                    'Get Data'
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'col-md-4 xs-hide' })
	        )
	    );
	};
	
	var selectCusipCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);
	
	var orCss = (0, _core.css)(_templateObject2, _twd.mediaQueries.notXs, _twd.mediaQueries.xs);
	
	var selectHoldingCss = (0, _core.css)(_templateObject3, _twd.mediaQueries.notXs);

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InputCusip = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputCusip = exports.InputCusip = function InputCusip(_ref) {
	    var cusip = _ref.cusip,
	        setCusip = _ref.setCusip,
	        isError = _ref.isError,
	        onEnter = _ref.onEnter;
	
	
	    var id = (0, _twd.getId)();
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        el = _React$useState2[0],
	        setEl = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        if (!el) return;
	        setTimeout(function () {
	            return el.focus();
	        }, 100);
	    }, [el]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_twd.Flyout, {
	                    label: 'CUSIP',
	                    labelAttrs: { htmlFor: id, className: 'label' },
	                    html: CusipTooltip,
	                    labelStyle: { lineHeight: '20px', display: 'inline' },
	                    isLabel: true
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: isError ? ' has-error' : '' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-xxs' },
	                    _react2.default.createElement('input', Object.assign({
	                        ref: setEl,
	                        className: 'form-control focus-on-load',
	                        type: 'text',
	                        id: id,
	                        value: cusip
	                    }, isError ? { "aria-invalid": true } : {}, {
	                        onChange: function onChange(e) {
	                            setCusip(e.target.value);
	                        },
	                        onKeyUp: function onKeyUp(e) {
	                            var key = e.keyCode || e.key || e.which;
	                            if (!(key === 13 || key === 'Enter')) return;
	
	                            e.preventDefault();
	                            onEnter(e.target.value);
	                        }
	                    }))
	                ),
	                isError && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error', style: { textAlign: 'left' } },
	                    'Please enter a valid CUSIP'
	                )
	            )
	        )
	    );
	};
	
	var CusipTooltip = '\n<p>CUSIP stands for Committee on Uniform Securities Identification Procedures. When issued, each bond is assigned a CUSIP number, comprised of nine alphanumeric characters to uniquely identify the security.</p>\n';

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectHolding = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var SelectHolding = exports.SelectHolding = function SelectHolding(_ref) {
	    var cusip = _ref.cusip,
	        setCusip = _ref.setCusip,
	        holdings = _ref.holdings;
	
	
	    var cusips = [];
	    var rs = (0, _twd.arrayFrom)(holdings).filter(function (_ref2) {
	        var cusip = _ref2.cusip;
	
	        if (cusips.indexOf(cusip) >= 0) return false;
	        cusips.push(cusip);
	        return true;
	    }).filter(function (_ref3) {
	        var maturity = _ref3.maturity;
	
	        var isMatured = (0, _twd.parseDate)(maturity) < Date.now();
	        return !isMatured;
	    }).sort((0, _twd.sortFn)(function (_ref4) {
	        var issue = _ref4.issue,
	            maturity = _ref4.maturity;
	
	        return (issue || '').trim() + _twd.fmt.fmtDt((0, _twd.parseDate)(maturity), 'yyyy-MM-dd');
	    }));
	    var isDisabled = rs.length === 0;
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'label',
	                    {
	                        className: 'label', htmlFor: id,
	                        style: { lineHeight: '20px', display: 'inline' }
	                    },
	                    'Holdings'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'select-wrapper vertical-offset-xxs' },
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            id: id,
	                            'data-name': 'calculator-enter-cusip-select-holdings',
	                            defaultValue: cusip || '',
	                            disabled: isDisabled,
	                            'aria-disabled': isDisabled,
	                            onChange: function onChange(e) {
	                                var newCusip = e.target.value;
	                                if (!newCusip) return;
	
	                                setCusip(newCusip);
	                            },
	                            className: 'form-control text-truncate',
	                            style: { paddingRight: '25px' }
	                        },
	                        rs.length > 0 && [{ cusip: '', issue: 'Select' }].concat(rs).map(function (a, i) {
	                            return _react2.default.createElement(
	                                'option',
	                                {
	                                    'data-name': 'calculator-enter-cusip-select-holdings-option',
	                                    key: i,
	                                    value: a.cusip || '',
	                                    selected: a.cusip === cusip
	                                },
	                                (0, _twd.parseHtml)(a.issue || '')
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Footer = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useCalculator2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = exports.Footer = function Footer() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        step = _useCalculator.step;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection = _React$useState2[1];
	
	    var isShow = [_useCalculator2.STEPS.INIT, _useCalculator2.STEPS.INIT_LOADING, _useCalculator2.STEPS.INIT_ERROR, _useCalculator2.STEPS.CUSIP_LOADING, _useCalculator2.STEPS.CALC_LOADING].indexOf(step) < 0;
	    if (!isShow) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: "col-md-12" },
	                _react2.default.createElement(_twd.SectionHeader, {
	                    title: 'Important disclosures and footnotes',
	                    cls: 'subhead',
	                    arrowSize: 'large',
	                    show: showSection,
	                    setShow: setShowSection
	                })
	            )
	        ),
	        _react2.default.createElement(
	            _twd.SectionBody,
	            { show: showSection },
	            _react2.default.createElement(
	                'div',
	                { className: 'row form-group vertical-offset-sm' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(DisclosureText, null)
	                )
	            )
	        )
	    );
	};
	
	var DisclosureText = function DisclosureText() {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'p',
	            null,
	            'This Price/Yield Calculator (the \u201CTool\u201D) enables users to run \u201Cwhat-if\u201D scenarios for the securities (and their associated offers) they\u2019re researching.  The Tool and its corresponding calculations are for informational purposes only. By using the Tool, you can run hypothetical scenarios to understand the yield you may achieve on a purchase or sale of a security based upon varying price levels. The results will display Yield to Worst, Yield to Maturity and Yield to Call when available. Bond prices and yields have an inverse relationship.  When a bond\u2019s price is rising, the associated yield is declining \u2013 and vice versa.  The Tool enables you to visually observe this relationship via the \u201CYield to Maturity/Call\u201D chart (found on the right rail of the tool once your output is generated).  There are many other factors beyond price and yield which should be considered before making any investment decision.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Below the \u201CYield to Maturity/Call\u201D chart \u2013 users will be informed if a live market bid or offer is available for the security active within the tool.  This feature is available to enable users an easier transition to an order ticket flow but is not to be construed as a recommendation by Morgan Stanley to buy or sell a given security.  The pathway will load an order ticket with details associated with the best available offer for the security \u2013 this may or may not align with the custom inputs the user is running within the tool.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'The Tool is provided by a third party that is not affiliated with Morgan Stanley. Unless otherwise specifically indicated, all information in the Tool has been provided by, and is the sole responsibility of, such third party and has not been independently verified by Morgan Stanley.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'The information provided by the Tool neither is, nor should be construed as, an offer, or a solicitation of an offer, or a recommendation, to buy or sell securities or other instruments by Morgan Stanley. No information presented by the Tool constitutes a recommendation by Morgan Stanley to buy, sell, or hold any security, financial product, or instrument discussed therein, or to open a particular account or to engage in any specific investment strategy. You understand and agree that Morgan Stanley has no liability whatsoever for the results of your investment strategies, transactions, and decisions.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Morgan Stanley and its affiliates do not provide tax advice, and nothing in this section should be construed as tax advice. Please consult with your tax professional before acting on any such information.  Morgan Stanley does not guarantee that the content and yields are accurate, complete, or timely. Morgan Stanley is not liable for any losses arising out of or related to your use of the Tool. '
	        ),
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Tradeweb Direct Copyright and Disclosure'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'The Bond Calculator Software provides calculations based on the information selected and entered by the individual, and the assumptions set forth herein. Tradeweb Direct LLC and its affiliates (collectively, Tradeweb Direct) own all right, title and interest in and to the Bond Calculator Software, the accompanying materials and any documents generated by the Bond Calculator Software. Reproduction or duplication without the permission of Tradeweb Direct, by any means, of the Bond Calculator Software, the accompanying materials, or the documents is strictly prohibited and in violation of federal copyright laws. Tradeweb Direct cannot guarantee the complete accuracy of the calculations produced by the Bond Calculator Software and all output should be reviewed by the user to ensure accuracy. Tradeweb Direct makes no representations or warranties, and disclaims all express, implied and statutory warranties of any kind, including any warranties of quantity, quality, timeliness, completeness, accuracy, merchantability and fitness for a particular purpose. The Bond Calculator Software, the accompanying materials, output and any documents generated by the Bond Calculator Software are provided \u201Cas-is\u201D and Tradeweb Direct is not liable for any damages arising out of the use or access to the foregoing. The Bond Calculator Software and the output thereof does not constitute an offer or solicitation to buy or sell any security or financial product, a recommendation concerning any security, financial product or asset class, or an offer to provide investment advice or any other service; and Tradeweb Direct is not providing users of the Bond Calculator Software with legal, tax, accounting, financial planning or estate planning advice. The Bond Calculator Software is meant only to assist the individual in evaluating various scenarios and cannot, and should not be expected to, replace competent professional advice.'
	        )
	    );
	};

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getBondInfo = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var getBondInfo = exports.getBondInfo = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	        var cusip = _ref.cusip,
	            holdings = _ref.holdings;
	
	        var _ref3, bond_, bond, issue, _ref4, book_, book, _ref5, settle_, cs, _ref6, type, category, callableInd, couponTypeCode, mat, now;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        if (cusip) {
	                            _context.next = 2;
	                            break;
	                        }
	
	                        return _context.abrupt('return', null);
	
	                    case 2:
	                        if ((0, _twd.isCusip)(cusip)) {
	                            _context.next = 4;
	                            break;
	                        }
	
	                        throw new Error('invalid cusip');
	
	                    case 4:
	                        _context.next = 6;
	                        return (0, _twd.ajax)({
	                            url: '/esb/retailservice/bondDetailService/getIssueDesc',
	                            method: 'POST',
	                            params: {
	                                p_cusip: cusip,
	                                p_id_type: 'I',
	                                p_brand: (0, _twd.getBrand)(),
	                                p_alloc_id: '',
	                                p_watch_id: '',
	                                p_ngw: 'Y'
	                            }
	                        });
	
	                    case 6:
	                        _ref3 = _context.sent;
	                        bond_ = _ref3.data;
	                        _context.next = 10;
	                        return bond_;
	
	                    case 10:
	                        bond = _context.sent;
	                        issue = bond.issue = bond.issue || {};
	
	                        issue.prospectus = function () {
	                            var t = issue && issue.researchLinks;
	                            if (!t) {
	                                return;
	                            }
	                            if (t.indexOf('LEGAL(' + issue.cusip + ')') < 0 && t.indexOf('SALES(' + issue.cusip + ')') < 0) {
	                                return;
	                            }
	
	                            var a = t.indexOf('BDResearch.showViewer(');
	                            var s = t.substring(a, t.indexOf(')', a));
	                            var u = String(s).replace("BDResearch.showViewer('", '').replaceAll("'", '');
	                            var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	                            return u ? 'https://www.bonddesk.com/etrade/' + owaTcDaoContext + '/' + u : '';
	                        }();
	
	                        _context.next = 15;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/cusip/warningAndBook',
	                            method: 'POST',
	                            params: {
	                                "p_criteria_fmt": "ADVANCED",
	                                "p_cusip": cusip,
	                                "p_maxrows": 1,
	                                "p_monarch": "Y",
	                                "p_output_fmt": "JSON",
	                                "p_multiple": ["BOL-UOR", "BOL-ROR"],
	                                "p_submit": "JSON",
	                                "p_redirect_output": "Y",
	                                "p_type": "0",
	                                "p_min_qty": 1,
	                                "p_is_offer_search": false,
	                                "p_search_criteria": {},
	                                "p_mode": "RP"
	                            }
	                        });
	
	                    case 15:
	                        _ref4 = _context.sent;
	                        book_ = _ref4.data;
	                        _context.next = 19;
	                        return book_;
	
	                    case 19:
	                        _context.t0 = _context.sent[0];
	
	                        if (_context.t0) {
	                            _context.next = 22;
	                            break;
	                        }
	
	                        _context.t0 = {};
	
	                    case 22:
	                        book = _context.t0;
	
	                        bond.issue.showBook = book.showBook;
	                        bond.issue.allowTrading = book.allowTrading;
	                        bond.issue.warningText = book.warningText;
	
	                        _context.next = 28;
	                        return (0, _twd.ajax)({
	                            url: '/esb/retailservice/dates/tradeAndSettlement',
	                            method: 'POST',
	                            params: { cusip: cusip }
	                        });
	
	                    case 28:
	                        _ref5 = _context.sent;
	                        settle_ = _ref5.data;
	                        _context.next = 32;
	                        return settle_;
	
	                    case 32:
	                        cs = _context.sent;
	
	                        if (cs) {
	                            bond.settlement = cs.settleDate;
	                        }
	
	                        _ref6 = issue || {}, type = _ref6.type, category = _ref6.category, callableInd = _ref6.callableInd, couponTypeCode = _ref6.couponTypeCode;
	
	                        bond.isMBS = ['O', 'R', 'K'].indexOf(type) >= 0;
	                        bond.isRestricted = bond.isMBS || type === 'P' || type === 'C' && category === 'N' || type === 'S' && category === 'N';
	
	                        bond.holdings = (0, _twd.arrayFrom)(holdings).filter(function (_ref7) {
	                            var a = _ref7.cusip;
	                            return a === cusip;
	                        });
	                        bond.isHeld = bond.holdings.length > 0;
	                        mat = (0, _twd.parseDate)(bond.issue.maturity);
	                        now = Date.now();
	
	                        bond.isMatured = mat && mat < now;
	                        bond.hasAsk = book.allowTrading && bond.bestoffer && bond.bestoffer.ask && bond.bestoffer.ask.id;
	                        bond.hasBid = book.allowTrading && bond.bestoffer && bond.bestoffer.bid && bond.bestoffer.bid.id;
	                        bond.canCalc = !bond.isRestricted && couponTypeCode !== 'E' && couponTypeCode !== '0';
	                        bond.canTrade = book.allowTrading && !bond.isMatured;
	                        bond.isCallable = callableInd === 'Y' && !bond.isMBS;
	                        return _context.abrupt('return', bond);
	
	                    case 48:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function getBondInfo(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getCalcOutput = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var getCalcOutput = exports.getCalcOutput = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	        var cusip = _ref.cusip,
	            priceYield = _ref.priceYield,
	            priceOrYield = _ref.priceOrYield,
	            action = _ref.action,
	            qty = _ref.qty,
	            settlement = _ref.settlement;
	
	        var settleDt, _ajax, data, calc;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        if (cusip) {
	                            _context.next = 2;
	                            break;
	                        }
	
	                        return _context.abrupt('return', null);
	
	                    case 2:
	                        settleDt = (0, _twd.parseDate)(settlement);
	
	                        if (settleDt) {
	                            _context.next = 5;
	                            break;
	                        }
	
	                        return _context.abrupt('return', null);
	
	                    case 5:
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/retailservice/calculator/calculate',
	                            method: 'POST',
	                            params: {
	                                cusip: cusip,
	                                priceYield: priceYield,
	                                priceOrYield: priceOrYield,
	                                action: action,
	                                qty: qty,
	                                settlement: _twd.fmt.mdy(settleDt)
	                            }
	                        }), data = _ajax.data;
	                        _context.next = 8;
	                        return data;
	
	                    case 8:
	                        calc = _context.sent;
	
	
	                        calc.priceYields = (0, _twd.arrayFrom)(calc.priceYields).sort(function (_ref3, _ref4) {
	                            var a = _ref3.price;
	                            var b = _ref4.price;
	                            return a - b;
	                        });
	
	                        calc.paymentsFirstYear = (0, _twd.arrayFrom)(calc.paymentsFirstYear);
	
	                        calc.paymentsByYears = (0, _twd.arrayFrom)(calc.paymentsByYears).map(function (r) {
	                            return Object.assign({}, r, { date: (0, _twd.parseDate)(r.year) });
	                        });
	
	                        return _context.abrupt('return', calc);
	
	                    case 13:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function getCalcOutput(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getHoldings = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var getHoldings = exports.getHoldings = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _ajax, data, rs, now, hs;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldings',
	                            method: 'GET'
	                        }), data = _ajax.data;
	                        _context.next = 3;
	                        return data;
	
	                    case 3:
	                        rs = _context.sent;
	                        now = new Date();
	                        hs = (0, _twd.arrayFrom)(rs.holdings).map(function (a) {
	                            var m = a.maturity;
	                            if (!m) return a;
	
	                            var d = new Date(m);
	                            if (!isNaN(d) && m.indexOf('T') < 0 && m.split('-').length === 3) {
	                                a.maturity = m + 'T00:00:00';
	                            }
	                            return a;
	                        }).filter(function (_ref2) {
	                            var maturity = _ref2.maturity;
	
	                            var d = new Date(maturity);
	                            return d && d >= now;
	                        }).sort((0, _twd.sortFn)(function (a) {
	                            return a.maturity ? new Date(a.maturity) : Number.POSITIVE_INFINITY;
	                        }));
	                        return _context.abrupt('return', hs);
	
	                    case 7:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function getHoldings() {
	        return _ref.apply(this, arguments);
	    };
	}();

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useCalculator2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = exports.Header = function Header() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        step = _useCalculator.step,
	        changeCusip = _useCalculator.changeCusip,
	        bondInfo = _useCalculator.bondInfo,
	        showCoupon = _useCalculator.showCoupon,
	        calcOutput = _useCalculator.calcOutput,
	        resetCalc = _useCalculator.resetCalc;
	
	    var isShowBack = [_useCalculator2.STEPS.INIT, _useCalculator2.STEPS.INIT_LOADING, _useCalculator2.STEPS.INIT_ERROR, _useCalculator2.STEPS.CUSIP_INPUT, _useCalculator2.STEPS.CUSIP_ERROR, _useCalculator2.STEPS.CUSIP_LOADING].indexOf(step) < 0;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-2 col-xs-2' },
	                _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                isShowBack && _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'close',
	                        style: { right: 'unset' },
	                        'aria-label': 'close',
	                        type: 'button',
	                        onClick: function onClick() {
	                            var fn = step === _useCalculator2.STEPS.CALC_OUTPUT || step === _useCalculator2.STEPS.CALC_ERROR ? resetCalc : changeCusip;
	                            fn();
	                        } },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'material-icons', 'aria-hidden': 'true', style: { color: 'var(--primary-base-color)' } },
	                        'arrow_back'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-8 col-xs-8 text-center' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'medium-header ' },
	                    'Price/yield calculator'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-2 col-xs-2' },
	                _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'close',
	                        'aria-label': 'close',
	                        'data-name': 'calculator-modal-close-link',
	                        type: 'button',
	                        onClick: _twd.hideModal },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'material-icons', 'aria-hidden': 'true', style: { color: 'var(--primary-base-color)' } },
	                        'close'
	                    )
	                )
	            )
	        ),
	        !(0, _twd.isEmpty)(bondInfo) && bondInfo.canCalc && showCoupon && (0, _twd.isEmpty)(calcOutput) && _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'universal-message universal-message-info universal-message-dismissible',
	                        role: 'alert' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'universal-message-content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'universal-message-heading' },
	                            'Enter a quantity in the calculator to review the estimated coupon payment schedule from investing in this security at the current best offer price. You can also edit the current best offer to perform custom calculations.'
	                        )
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(1776);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _navigation = __webpack_require__(862);
	
	var _header = __webpack_require__(860);
	
	var _cusipInput = __webpack_require__(853);
	
	var _bondDetails = __webpack_require__(832);
	
	var _calcInput = __webpack_require__(837);
	
	var _calcOutput = __webpack_require__(843);
	
	var _useCalculator4 = __webpack_require__(56);
	
	var _twd = __webpack_require__(2);
	
	var _nextStep = __webpack_require__(863);
	
	var _calcCoupons = __webpack_require__(834);
	
	var _footer = __webpack_require__(856);
	
	var _cantCalc = __webpack_require__(852);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (args) {
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'calculator-modal',
	                className: 'modal-dialog modal-lg calculator-modal'
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    _useCalculator4.ContextProvider,
	                    args,
	                    _react2.default.createElement(_navigation.Navigation, null),
	                    _react2.default.createElement(_header.Header, null),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container calculator-form' },
	                        _react2.default.createElement(Init, null),
	                        _react2.default.createElement(_cusipInput.CusipInput, null),
	                        _react2.default.createElement(CusipStatus, null),
	                        _react2.default.createElement(_bondDetails.BondDetails, null),
	                        _react2.default.createElement(_calcInput.CalcInput, null),
	                        _react2.default.createElement(CalcStatus, null),
	                        _react2.default.createElement(_calcOutput.CalcOutput, null),
	                        _react2.default.createElement(_calcCoupons.CalcCoupons, null),
	                        _react2.default.createElement(_cantCalc.CantCalc, null),
	                        _react2.default.createElement(_nextStep.NextStep, null),
	                        _react2.default.createElement(_footer.Footer, null)
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Init = function Init() {
	    var _useCalculator = (0, _useCalculator4.useCalculator)(),
	        step = _useCalculator.step;
	
	    return step === _useCalculator4.STEPS.INIT || step === _useCalculator4.STEPS.INIT_LOADING ? _react2.default.createElement(_twd.Loading, { status: _twd.Status.LOADING }) : step === _useCalculator4.STEPS.INIT_ERROR ? _react2.default.createElement(_twd.Loading, { status: _twd.Status.FAILED_TO_LOAD }) : null;
	};
	
	var CusipStatus = function CusipStatus() {
	    var _useCalculator2 = (0, _useCalculator4.useCalculator)(),
	        step = _useCalculator2.step;
	
	    return step === _useCalculator4.STEPS.CUSIP_LOADING ? _react2.default.createElement(_twd.Loading, { status: _twd.Status.LOADING }) : step === _useCalculator4.STEPS.CUSIP_ERROR ? _react2.default.createElement(_twd.Loading, { status: _twd.Status.FAILED_TO_LOAD }) : null;
	};
	
	var CalcStatus = function CalcStatus() {
	    var _useCalculator3 = (0, _useCalculator4.useCalculator)(),
	        step = _useCalculator3.step;
	
	    return step === _useCalculator4.STEPS.CALC_LOADING ? _react2.default.createElement(_twd.Loading, { status: _twd.Status.LOADING }) : step === _useCalculator4.STEPS.CALC_ERROR ? _react2.default.createElement(_twd.Loading, { status: _twd.Status.FAILED_TO_LOAD }) : null;
	};

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Navigation = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useCalculator2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Navigation = exports.Navigation = function Navigation() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        step = _useCalculator.step;
	
	    var r = getLabels(step);
	
	    return _react2.default.createElement(
	        'nav',
	        { className: 'minimal-navigation' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 vertical-offset-xs' },
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://etrade.com' },
	                    _react2.default.createElement('img', { src: 'resources/images/logo.svg', alt: 'etrade', width: '150' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'progress', role: 'progressbar',
	                        'aria-label': 'Progress',
	                        'aria-valuenow': r.value,
	                        'aria-valuemin': '1',
	                        'aria-valuemax': '3' },
	                    _react2.default.createElement('div', { className: 'progress-bar', style: { width: r.width } })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 text-center text-muted' },
	                _react2.default.createElement(
	                    'span',
	                    null,
	                    r.label
	                )
	            )
	        )
	    );
	};
	
	var getLabels = function getLabels(step) {
	    switch (step) {
	        case _useCalculator2.STEPS.UNKNOWN:
	            return {
	                label: "Unexpected State/Error",
	                value: 0,
	                width: '0%'
	            };
	        case _useCalculator2.STEPS.CALC_INPUT:
	        case _useCalculator2.STEPS.CALC_ERROR:
	        case _useCalculator2.STEPS.CALC_LOADING:
	            return {
	                label: "Step 2 of 3: Calculate price/yield",
	                value: 2,
	                width: '67%'
	            };
	        case _useCalculator2.STEPS.CALC_OUTPUT:
	            return {
	                label: "Step 3 of 3: Review results and next steps",
	                value: 3,
	                width: '100%'
	            };
	        case _useCalculator2.STEPS.INIT:
	        case _useCalculator2.STEPS.INIT_LOADING:
	        case _useCalculator2.STEPS.INIT_ERROR:
	        case _useCalculator2.STEPS.CUSIP_INPUT:
	        case _useCalculator2.STEPS.CUSIP_ERROR:
	        case _useCalculator2.STEPS.CUSIP_LOADING:
	        default:
	            return {
	                label: "Step 1 of 3: Enter CUSIP",
	                value: 1,
	                width: '33%'
	            };
	    }
	};

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NextStep = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useCalculator2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NextStep = exports.NextStep = function NextStep() {
	    var _useCalculator = (0, _useCalculator2.useCalculator)(),
	        cusip = _useCalculator.cusip,
	        calcOutput = _useCalculator.calcOutput,
	        step = _useCalculator.step,
	        from_ = _useCalculator.from_;
	
	    var isShow = !(0, _twd.isEmpty)(calcOutput) && step === _useCalculator2.STEPS.CALC_OUTPUT;
	    if (!isShow) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'small-header', style: { margin: 0 } },
	                    'Next Steps'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 card-group' },
	                _react2.default.createElement(
	                    'div',
	                    {
	                        className: 'card card-primary flex-md-6 flex-xs-12',
	                        style: { cursor: 'pointer', marginLeft: 0 },
	                        onClick: function onClick() {
	                            (0, _twd.hideModal)();
	                            (0, _twd.show)('bond-detail', { cusip: cusip, from: from_ });
	                        }
	                    },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card-body' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'card-title' },
	                            'Take a closer look'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'vertical-offset-base' },
	                            'Review the detailed terms and features of this security.'
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-link' },
	                            'View bond offering detail'
	                        )
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yieldGrids = __webpack_require__(910);
	
	var _yieldGrids2 = _interopRequireDefault(_yieldGrids);
	
	var _scatterGraph = __webpack_require__(899);
	
	var _scatterGraph2 = _interopRequireDefault(_scatterGraph);
	
	var _marketSnapshot = __webpack_require__(882);
	
	var _marketSnapshot2 = _interopRequireDefault(_marketSnapshot);
	
	var _quickScreener = __webpack_require__(885);
	
	var _quickScreener2 = _interopRequireDefault(_quickScreener);
	
	var _resources = __webpack_require__(889);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	var _sectorActivity = __webpack_require__(904);
	
	var _sectorActivity2 = _interopRequireDefault(_sectorActivity);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	
	exports.default = function () {
	    (0, _twd.trackPage)('corporates');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container', style: { padding: 0 } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(_yieldGrids2.default, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8 col-xs-12' },
	                        _react2.default.createElement(_scatterGraph2.default, null),
	                        _react2.default.createElement(_marketSnapshot2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-xs-12' },
	                        _react2.default.createElement(_quickScreener2.default, null),
	                        _react2.default.createElement(_resources2.default, null),
	                        _react2.default.createElement(_sectorActivity2.default, null)
	                    )
	                )
	            )
	        )
	    );
	};
	// import MarketNews from './market-news'

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _customSearch = __webpack_require__(866);
	
	var _customSearch2 = _interopRequireDefault(_customSearch);
	
	var _holdingSearch = __webpack_require__(871);
	
	var _holdingSearch2 = _interopRequireDefault(_holdingSearch);
	
	var _useMarketNews2 = __webpack_require__(116);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        isModal = _useMarketNews.isModal,
	        tab = _useMarketNews.tab,
	        setTab = _useMarketNews.setTab;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'corporates-market-news-nav-tabs',
	                className: 'nav-tabs' },
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    { className: tab === 'CUSTOM' ? 'active' : '' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'corporates-market-news-custom-search-nav-tab',
	                            onClick: function onClick() {
	                                return setTab('CUSTOM');
	                            } },
	                        'Custom Search'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: tab === 'HOLDING' ? 'active' : '' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'corporates-market-news-holding-search-nav-tab',
	                            onClick: function onClick() {
	                                return setTab('HOLDING');
	                            } },
	                        'Holdings Search'
	                    )
	                )
	            )
	        ),
	        tab === 'CUSTOM' && _react2.default.createElement(_customSearch2.default, { isModal: isModal }),
	        tab === 'HOLDING' && _react2.default.createElement(_holdingSearch2.default, null)
	    );
	};

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-top: 20px;\n    }\n'], ['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-top: 20px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    .control-label { text-align:center; }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { margin-top: 15px; }\n    }\n\n'], ['\n    .control-label { text-align:center; }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { margin-top: 15px; }\n    }\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	var _searchManual = __webpack_require__(867);
	
	var _searchManual2 = _interopRequireDefault(_searchManual);
	
	var _searchSector = __webpack_require__(868);
	
	var _searchSector2 = _interopRequireDefault(_searchSector);
	
	var _datePicker = __webpack_require__(465);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _useMarketNews2 = __webpack_require__(116);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var isModal = _ref.isModal;
	
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        customSearchType = _useMarketNews.customSearchType,
	        setCustomSearchType = _useMarketNews.setCustomSearchType,
	        customKeyword = _useMarketNews.customKeyword,
	        setCustomKeyword = _useMarketNews.setCustomKeyword;
	
	    var isKeyword = customSearchType === 'keyword';
	    var id = (0, _twd.getId)();
	
	    _react2.default.useEffect(function () {
	        var _id = id + '-search-type-' + (isKeyword ? 'keyword' : 'company');
	        var el = document.getElementById(_id);
	
	        if (!el) return;
	        el.checked = true;
	    });
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'vertical-offset-xs',
	                style: {
	                    padding: '10px',
	                    backgroundColor: "#f6f6f6"
	                } },
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-10 col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'form-horizontal', css: formCss },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-4' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'radio radio-inline' },
	                                (0, _core.jsx)('input', { type: 'radio',
	                                    id: id + '-search-type-company',
	                                    name: 'corporates-market-news-custom-search-type',
	                                    defaultChecked: !isKeyword,
	                                    onChange: function onChange() {
	                                        setCustomSearchType('company');
	                                    }
	                                }),
	                                (0, _core.jsx)(
	                                    'label',
	                                    { htmlFor: id + '-search-type-company' },
	                                    'Company'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'radio radio-inline' },
	                                (0, _core.jsx)('input', { type: 'radio',
	                                    id: id + '-search-type-keyword',
	                                    name: 'corporates-market-news-custom-search-type',
	                                    defaultChecked: isKeyword,
	                                    onChange: function onChange() {
	                                        setCustomSearchType('keyword');
	                                    }
	                                }),
	                                (0, _core.jsx)(
	                                    'label',
	                                    { htmlFor: id + '-search-type-keyword' },
	                                    'Keyword'
	                                )
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'form-group col-md-3', style: { marginBottom: 0 } },
	                            (0, _core.jsx)(
	                                'label',
	                                {
	                                    htmlFor: id + (isKeyword ? '-keyword' : '-company') + '-input'
	                                },
	                                isKeyword ? 'Keyword' : 'Company'
	                            ),
	                            isKeyword ? (0, _core.jsx)('input', {
	                                type: 'text',
	                                id: id + '-keyword-input',
	                                className: 'form-control',
	                                value: customKeyword,
	                                onChange: function onChange(e) {
	                                    setCustomKeyword(e.target.value);
	                                }
	                            }) : (0, _core.jsx)(_searchManual2.default, {
	                                id: id + '-company-input'
	                            })
	                        ),
	                        (0, _core.jsx)(
	                            'label',
	                            { className: 'control-label col-md-1 col-xs-12',
	                                css: labelCss },
	                            'or'
	                        ),
	                        (0, _core.jsx)(_searchSector2.default, { className: 'col-md-3', isModal: isModal })
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-2 col-xs-12' },
	                    (0, _core.jsx)(_datePicker2.default, {
	                        dataName: 'corporates-market-news-custom-search-date-range',
	                        type: 'custom',
	                        size: 10 })
	                )
	            )
	        )
	    );
	};
	
	var labelCss = (0, _core.css)(_templateObject, _twd.mediaQueries.xs, _twd.mediaQueries.notXs);
	
	var formCss = (0, _core.css)(_templateObject2, _twd.mediaQueries.xs, _twd.mediaQueries.sm, _twd.mediaQueries.sm, _twd.mediaQueries.notXs);

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useSearchManual2 = __webpack_require__(869);
	
	var _useSearchManual3 = _interopRequireDefault(_useSearchManual2);
	
	var _useMarketNews2 = __webpack_require__(116);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Lock = false;
	var bounce = function bounce() {
	    var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
	
	    Lock = true;
	    setTimeout(function () {
	        Lock = false;
	    }, ms);
	};
	
	exports.default = function (_ref) {
	    var id = _ref.id;
	
	    var _useSearchManual = (0, _useSearchManual3.default)(),
	        status = _useSearchManual.status,
	        keyword = _useSearchManual.keyword,
	        setKeyword = _useSearchManual.setKeyword,
	        searchResults = _useSearchManual.searchResults,
	        setEntered = _useSearchManual.setEntered;
	
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        customSearch = _useMarketNews.customSearch,
	        setCustomSearch = _useMarketNews.setCustomSearch;
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('corporate-market-news-custom-search-entered', function (a) {
	            setCustomSearch(a);
	        });
	        return function () {
	            return (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var resetField = function resetField() {
	        setKeyword('');
	        setCustomSearch('');
	    };
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('corporates-market-news-custom-search-changed', function (field) {
	            if (field !== 'sector') return;
	            resetField();
	        });
	        return function () {
	            return (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    return _react2.default.createElement(
	        _twd.Fields.Search,
	        {
	            id: id,
	            dataName: 'corporates-market-news-custom-search-company',
	            multiple: false,
	            value: customSearch && customSearch.name || keyword,
	
	            onSelect: function onSelect(a) {
	                if ((0, _twd.isString)(a)) {
	                    setCustomSearch(undefined);
	                    setEntered(true);
	                } else {
	                    bounce();
	                    setCustomSearch(a);
	                }
	            },
	
	            onBlur: function onBlur(a) {
	                if (Lock) return;
	
	                var _ref2 = a || {},
	                    keyword = _ref2.keyword;
	
	                if (keyword) {
	                    setCustomSearch(undefined);
	                    setEntered(true);
	                } else {
	                    resetField();
	                }
	            },
	
	            onClear: function onClear() {
	                resetField();
	            },
	
	            onChange: function onChange(a) {
	                (0, _twd.publish)('corporates-market-news-custom-search-changed', 'custom', keyword);
	            }
	        },
	        function (_ref3) {
	            var text = _ref3.keyword;
	
	            setKeyword(text);
	
	            return _react2.default.createElement(
	                _twd.Loading,
	                { status: status, spinner: false },
	                searchResults.map(function (r, i) {
	                    return _react2.default.createElement(
	                        _twd.Fields.SearchOption,
	                        {
	                            dataName: 'corporates-market-news-custom-search-company',
	                            key: i,
	                            item: r },
	                        r.name
	                    );
	                })
	            );
	        }
	    );
	};

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSectors = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useMarketNews2 = __webpack_require__(116);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = function (_ref) {
	    var isModal = _ref.isModal,
	        className = _ref.className,
	        id = _ref.id;
	
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        selected = _useMarketNews.customIndustry,
	        setSelected = _useMarketNews.setCustomIndustry;
	
	    var _React$useState = _react2.default.useState(''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        text = _React$useState2[0],
	        setText = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(_twd.CORP_SECTORS),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        searchResults = _React$useState4[0],
	        setSearchResults = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        sectorError = _React$useState6[0],
	        setSectorError = _React$useState6[1];
	
	    _react2.default.useEffect(function () {
	        var a = getSectors({ text: text, selected: selected });
	        setSearchResults(a);
	    }, [text, selected]);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('corporates-market-news-custom-search-changed', function (field, keyword) {
	            if (field !== 'custom' || (0, _twd.isEmpty)(keyword)) return;
	            setSelected([]);
	        });
	        return function () {
	            return (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var n = selected.length;
	    var isAll = n === _twd.CORP_SECTORS.length || n === 0;
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: ['form-group', className, sectorError ? ' has-error ' : ''].join(' '),
	            style: { marginBottom: 0 }
	        },
	        _react2.default.createElement(
	            'label',
	            null,
	            'Industry'
	        ),
	        _react2.default.createElement(
	            _twd.Fields.Search,
	            {
	                id: id,
	                dataName: 'corporates-market-news-custom-search-industry',
	                placeholder: isAll ? 'All' : 'Selected',
	                type: 'select',
	                listConfig: {
	                    style: { minWidth: '200px' }
	                },
	                onSelect: function onSelect(a) {
	                    var arr = (0, _twd.arrayToggle)(selected, function (b) {
	                        return isEq(a, b);
	                    }, a);
	                    setSelected([].concat(_toConsumableArray(arr)));
	
	                    var err = arr.length < 5 ? '' : 'Please select up to 4 industries.';
	                    setSectorError(err);
	
	                    if (!err) (0, _twd.publish)('corporates-market-news-custom-search-changed', 'sector');
	                }
	            },
	            function (_ref2) {
	                var text = _ref2.keyword;
	
	                setText(text);
	
	                return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        searchResults.map(function (a, i) {
	                            return _react2.default.createElement(
	                                _twd.Fields.SearchOption,
	                                {
	                                    dataName: 'corporates-market-news-custom-search-industry',
	                                    item: a,
	                                    key: i },
	                                _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                                    dataName: 'corporates-market-news-custom-search-industry',
	                                    checked: a.selected,
	                                    label: a.label })
	                            );
	                        })
	                    )
	                );
	            }
	        ),
	        _react2.default.createElement(
	            'label',
	            { className: 'field-status' },
	            sectorError
	        )
	    );
	};
	
	var getSectors = exports.getSectors = function getSectors() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$text = _ref3.text,
	        text = _ref3$text === undefined ? '' : _ref3$text,
	        _ref3$selected = _ref3.selected,
	        selected = _ref3$selected === undefined ? [] : _ref3$selected;
	
	    var t = text.toLowerCase();
	    return _twd.CORP_SECTORS.filter(function (a) {
	        return a.sic_code;
	    }).map(function (a) {
	        return Object.assign(Object.assign({}, a), {
	            selected: !!selected.find(function (b) {
	                return isEq(a, b);
	            })
	        });
	    }).filter(function (a) {
	        return !text || a.label.toLowerCase().indexOf(t) >= 0;
	    });
	};
	
	var isEq = function isEq(a, b) {
	    return a.label === b.label;
	};

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBitvore = __webpack_require__(317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('corporates.market-news.use-search-manual', {});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        keyword = _React$useState2[0],
	        setKeyword = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        entered = _React$useState4[0],
	        setEntered = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        status = _React$useState6[0],
	        setStatus = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState([]),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        searchResults = _React$useState8[0],
	        setSearchResults = _React$useState8[1];
	
	    var timerId = _react2.default.useRef();
	    var lastKeyword = _react2.default.useRef(state.value.lastKeyword);
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        if (timerId.current) {
	            clearTimeout(timerId.current);
	            timerId.current = 0;
	        }
	
	        var dismounted = false;
	        setSearchResults([]);
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var auth, _ref2, data, abort, a, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (keyword) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            if (!(lastKeyword.current === keyword && searchResults.length > 0)) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            if (entered) {
	                                (0, _twd.publish)('corporate-market-news-custom-search-entered', searchResults[0]);
	                                setEntered(false);
	                            }
	                            return _context.abrupt('return');
	
	                        case 5:
	
	                            state.set({ lastKeyword: keyword });
	                            setStatus(_twd.Status.LOADING);
	                            lastKeyword.current = keyword;
	
	                            _context.prev = 8;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 12;
	                            return (0, _useBitvore.getAuth)();
	
	                        case 12:
	                            auth = _context.sent;
	                            _context.next = 15;
	                            return (0, _twd.ajax)({
	                                url: 'https://api.bitvore.com/entityapi/entities',
	                                method: 'GET',
	                                headers: Object.assign({}, auth),
	                                isDc: false,
	                                params: {
	                                    lookup: keyword.trim(),
	                                    pageSize: 10
	                                }
	                            });
	
	                        case 15:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 21;
	                            return data;
	
	                        case 21:
	                            a = _context.sent;
	
	                            if (!dismounted) {
	                                _context.next = 24;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 24:
	                            rs = (0, _twd.arrayFrom)(a.response);
	
	                            setSearchResults(rs);
	                            setStatus(_twd.Status.LOADED);
	                            if (entered && rs.length > 0) {
	                                (0, _twd.publish)('corporate-market-news-custom-search-entered', rs[0]);
	                                setEntered(false);
	                            }
	                            _context.next = 36;
	                            break;
	
	                        case 30:
	                            _context.prev = 30;
	                            _context.t0 = _context['catch'](8);
	
	                            if (!dismounted) {
	                                _context.next = 34;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 34:
	
	                            setSearchResults([]);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 36:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[8, 30]]);
	        })), 500);
	
	        return function () {
	            dismounted = true;
	
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	            if (timerId.current) {
	                clearTimeout(timerId.current);
	                timerId.current = 0;
	            }
	        };
	    }, [keyword, entered]);
	
	    return { keyword: keyword, setKeyword: setKeyword, status: status, searchResults: searchResults, setEntered: setEntered };
	};

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        dateRange = _ref.dateRange,
	        setDateRange = _ref.setDateRange,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? "corporates-market-news-date-picker" : _ref$dataName,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 6 : _ref$size;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("div", { className: "col-md-" + (12 - size) }),
	        _react2.default.createElement(
	            "div",
	            { className: "form-group col-md-" + size, style: { marginBottom: 0 } },
	            _react2.default.createElement(
	                "label",
	                null,
	                "Date Range"
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "select-wrapper" },
	                _react2.default.createElement(
	                    "select",
	                    {
	                        "data-name": dataName + '-select',
	                        className: "form-control",
	                        value: dateRange,
	                        onChange: function onChange(e) {
	                            return setDateRange(e.target.value);
	                        }
	                    },
	                    dateRanges.map(function (a, i) {
	                        return _react2.default.createElement(
	                            "option",
	                            {
	                                name: dataName + '-option',
	                                key: i,
	                                value: a.value },
	                            a.label
	                        );
	                    })
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var dateRanges = [{ value: 'today', label: 'Today' }, { value: 'this_week', label: 'This week' }, { value: 'this_month', label: 'This month' }];

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _searchCompany = __webpack_require__(872);
	
	var _searchCompany2 = _interopRequireDefault(_searchCompany);
	
	var _datePicker = __webpack_require__(465);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _tags = __webpack_require__(873);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _useHoldingSearch2 = __webpack_require__(874);
	
	var _useHoldingSearch3 = _interopRequireDefault(_useHoldingSearch2);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useHoldingSearch = (0, _useHoldingSearch3.default)(),
	        status = _useHoldingSearch.status,
	        error = _useHoldingSearch.error,
	        selected = _useHoldingSearch.selected,
	        setSelected = _useHoldingSearch.setSelected;
	
	    return _react2.default.createElement(
	        _twd.Loading,
	        { status: status, error: error },
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-xs',
	                style: {
	                    padding: '10px',
	                    backgroundColor: "#f6f6f6"
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-7 col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-7', style: { marginBottom: 0 } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Company'
	                            ),
	                            _react2.default.createElement(_searchCompany2.default, { selected: selected, setSelected: setSelected })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-5 col-xs-12' },
	                    _react2.default.createElement(_datePicker2.default, {
	                        dataName: 'corporates-market-news-holding-search-date-range',
	                        type: 'holding' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(_tags2.default, { selected: selected, setSelected: setSelected })
	            )
	        )
	    );
	};

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var state = (0, _twd.getState)('corporates.use-search-company');
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        selected = _ref.selected,
	        setSelected = _ref.setSelected;
	
	    var _React$useState = _react2.default.useState(''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        text = _React$useState2[0],
	        setText = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        searchResults = _React$useState4[0],
	        setSearchResults = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        var a = getCompanies({ text: text, selected: selected });
	        setSearchResults(a);
	    }, [text, selected]);
	
	    var isAll = selected.length === (0, _twd.arrayFrom)(state.value.companies).length;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Fields.Search,
	            {
	                dataName: 'corporates-market-news-holding-search-company',
	                placeholder: isAll ? 'All' : 'Selected',
	                type: 'select',
	                onSelect: function onSelect(a) {
	                    var arr = a.value === '*' ? isAll ? [] : [].concat(_toConsumableArray(searchResults)) : (0, _twd.arrayToggle)([].concat(_toConsumableArray(selected)), function (b) {
	                        return isEq(a, b);
	                    }, a);
	
	                    setSelected([].concat(_toConsumableArray(arr)));
	                }
	            },
	            function (_ref2) {
	                var text = _ref2.keyword;
	
	                setText(text);
	
	                return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    searchResults.length > 1 && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            _twd.Fields.SearchOption,
	                            {
	                                dataName: 'corporates-market-news-holding-search-company-select-all',
	                                item: { value: '*' } },
	                            _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                                dataName: 'corporates-market-news-holding-search-company-select-all-label',
	                                checked: isAll,
	                                label: 'Select all' })
	                        ),
	                        _react2.default.createElement('hr', { 'aria-hidden': 'true' })
	                    ),
	                    searchResults.map(function (a, i) {
	                        return _react2.default.createElement(
	                            _twd.Fields.SearchOption,
	                            {
	                                dataName: 'corporates-market-news-holding-search-company',
	                                item: a,
	                                key: i },
	                            _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                                dataName: 'corporates-market-news-holding-search-company-label',
	                                checked: a.selected,
	                                label: a.label,
	                                className: 'text-truncate'
	                            })
	                        );
	                    })
	                );
	            }
	        )
	    );
	};
	
	var getCompanies = function getCompanies() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$text = _ref3.text,
	        text = _ref3$text === undefined ? '' : _ref3$text,
	        _ref3$selected = _ref3.selected,
	        selected = _ref3$selected === undefined ? [] : _ref3$selected;
	
	    var t = text.toLowerCase();
	    return (0, _twd.arrayFrom)(state.value.companies).map(function (a) {
	        return Object.assign(Object.assign({}, a), {
	            selected: !!selected.find(function (b) {
	                return isEq(a, b);
	            })
	        });
	    }).filter(function (a) {
	        return !text || a.label.toLowerCase().indexOf(t) >= 0;
	    });
	};
	
	var isEq = function isEq(a, b) {
	    return a.label === b.label;
	};

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var selected = _ref.selected,
	        setSelected = _ref.setSelected;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        selected.length > 0 && selected.map(function (a, i) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    'data-name': 'corporates-market-news-holding-search-tag',
	                    'data-label': a.label,
	                    key: i,
	                    className: 'tag tag-dismissible',
	                    onClick: function onClick() {
	                        var n = (0, _twd.arrayToggle)(selected, a);
	                        setSelected([].concat(_toConsumableArray(n)));
	                    }
	                },
	                a.label
	            );
	        }),
	        selected.length === 0 && _react2.default.createElement(
	            'div',
	            { className: 'text-muted' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'You have no active corporate bond holdings at this time. Within Holdings Search, existing positions are accessible within the Company dropdown - allowing for customized news searches aligned with your corporate holdings.'
	            ),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(
	                'p',
	                null,
	                'For more information on corporate bond investing, please reference the Corporate Bond Resources module.'
	            )
	        )
	    );
	};

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useMarketNews2 = __webpack_require__(116);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	var _useBitvore = __webpack_require__(317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('corporates.use-search-company', {
	    companies: []
	});
	
	exports.default = function () {
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        selected = _useMarketNews.holdingCompany,
	        setSelected = _useMarketNews.setHoldingCompany;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(''),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        error = _React$useState4[0],
	        setError = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, a, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setError('');
	                            setStatus(_twd.Status.LOADING);
	                            _context.next = 5;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/bitvoreNewsAPIService/getUserHoldingsList',
	                                method: 'POST',
	                                params: {
	                                    invTypes: ['C']
	                                }
	                            });
	
	                        case 5:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            _context.t0 = _twd.arrayFrom;
	                            _context.next = 10;
	                            return data;
	
	                        case 10:
	                            _context.t1 = _context.sent;
	                            a = (0, _context.t0)(_context.t1);
	                            rs = Object.values(a.filter(function (i) {
	                                return i.issue;
	                            }).reduce(function (x, i) {
	                                var d = i.issue;
	                                if (!d || !d.trim()) return x;
	
	                                var n = i.symbol;
	                                if (!x[n]) {
	                                    x[n] = { qty: 0, symbol: n, label: d.trim() };
	                                }
	
	                                x[n].qty += i.qty;
	                                return x;
	                            }, {})).sort(function (a, b) {
	                                return b.qty - a.qty;
	                            }).slice(0, 10).sort(function (a, b) {
	                                if (b.label > a.label) return -1;
	                                if (b.label < a.label) return 1;
	                                return 0;
	                            });
	                            _context.next = 15;
	                            return applyBitvoreIds(rs);
	
	                        case 15:
	
	                            state.set({ companies: rs });
	
	                            if ((0, _twd.isEmpty)(selected)) {
	                                setSelected(rs);
	                            }
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 23;
	                            break;
	
	                        case 20:
	                            _context.prev = 20;
	                            _context.t2 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 23:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 20]]);
	        }))();
	    }, []);
	
	    return {
	        selected: selected, setSelected: setSelected,
	        status: status, error: error
	    };
	};
	
	var applyBitvoreIds = function () {
	    var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(rs) {
	        var tickers, auth, _ref4, data, a;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        tickers = rs.map(function (r) {
	                            return r.symbol;
	                        }).filter(Boolean);
	
	                        if (!(tickers.length === 0)) {
	                            _context2.next = 3;
	                            break;
	                        }
	
	                        return _context2.abrupt('return', []);
	
	                    case 3:
	                        _context2.next = 5;
	                        return (0, _useBitvore.getAuth)();
	
	                    case 5:
	                        auth = _context2.sent;
	                        _context2.next = 8;
	                        return (0, _twd.ajax)({
	                            url: 'https://api.bitvore.com/entityapi/entities',
	                            method: 'GET',
	                            headers: Object.assign({}, auth),
	                            isDc: false,
	                            params: {
	                                ticker: tickers,
	                                pageSize: tickers.length * 2
	                            }
	                        });
	
	                    case 8:
	                        _ref4 = _context2.sent;
	                        data = _ref4.data;
	                        _context2.next = 12;
	                        return data;
	
	                    case 12:
	                        a = _context2.sent;
	
	                        (0, _twd.arrayFrom)(a.response).forEach(function (t) {
	                            var r = rs.find(function (r) {
	                                return r.symbol === t.ticker;
	                            });
	                            if (!r) return;
	                            if (!r.bitvoreId) r.bitvoreId = [];
	                            r.bitvoreId.push(t.id);
	                        });
	
	                        return _context2.abrupt('return', rs);
	
	                    case 15:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined);
	    }));
	
	    return function applyBitvoreIds(_x) {
	        return _ref3.apply(this, arguments);
	    };
	}();

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(161);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useMarketNews = __webpack_require__(116);
	
	var _criteria = __webpack_require__(865);
	
	var _criteria2 = _interopRequireDefault(_criteria);
	
	var _news = __webpack_require__(878);
	
	var _news2 = _interopRequireDefault(_news);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var modal = _ref.modal,
	        props = _objectWithoutProperties(_ref, ['modal']);
	
	    return (0, _core.jsx)(
	        _useMarketNews.ContextProvider,
	        { modal: modal },
	        (0, _core.jsx)(Main, Object.assign({ modal: modal }, props))
	    );
	};
	
	var Main = function Main() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$modal = _ref2.modal,
	        modal = _ref2$modal === undefined ? false : _ref2$modal;
	
	    var _React$useState = _react2.default.useState(true),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        available = _React$useState2[0],
	        setAvailable = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('corporates-market-news-unavailable.corporates-market-news', function (f) {
	            setAvailable(!f);
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var id = modal ? (0, _twd.getId)() : 'corporate-market-news';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: id, className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'corporates-market-news',
	                className: modal ? '' : 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            !modal && (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Corporate Market News'
	                    )
	                )
	            ),
	            available && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12' },
	                        (0, _core.jsx)(_criteria2.default, null)
	                    )
	                ),
	                (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	                (0, _core.jsx)(_news2.default, { modal: modal })
	            ),
	            !available && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'text-muted text-center' },
	                    (0, _core.jsx)(
	                        'i',
	                        { className: 'material-icons et-icon-lg', 'aria-hidden': 'true' },
	                        'chat'
	                    ),
	                    (0, _core.jsx)('br', null),
	                    'The Corporate Market News module is currently unavailable.',
	                    (0, _core.jsx)('br', null),
	                    'Please try again at a later time.'
	                )
	            ),
	            (0, _core.jsx)('div', { className: modal ? 'row vertical-offset-xxs' : 'row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _marketNews = __webpack_require__(875);
	
	var _marketNews2 = _interopRequireDefault(_marketNews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'corporates-market-news-modal',
	                className: 'modal-dialog',
	                style: {
	                    verticalAlign: 'top',
	                    minWidth: '70%'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content',
	                    style: {
	                        background: "#ffffff",
	                        paddingBottom: '0px'
	                    } },
	                _react2.default.createElement(_twd.MinimalNavigation, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement('div', { className: 'col-md-3' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 text-center' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'medium-header' },
	                            'Corporate Market news'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3' },
	                        _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'close',
	                                'aria-label': 'close',
	                                'data-name': 'corporates-market-news-modal-close-link',
	                                type: 'button',
	                                onClick: _twd.hideModal },
	                            _react2.default.createElement(
	                                'i',
	                                { className: 'material-icons', 'aria-hidden': 'true' },
	                                'close'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_marketNews2.default, { modal: true })
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(221);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var modal = _ref.modal,
	        rows = _ref.rows;
	
	
	    var rs = modal ? rows : rows.slice(0, 5);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        rs.map(function (r, i) {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                { key: i },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xxs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12', style: {
	                                overflow: 'hidden',
	                                textOverflow: 'ellipsis',
	                                display: '-webkit-box',
	                                WebkitBoxOrient: 'vertical',
	                                WebkitLineClamp: '1',
	                                maxHeight: '1.6em',
	                                lineHeight: '1.4em'
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: r.sourceUrl,
	                                'data-name': 'corporates-market-news-row',
	                                className: 'text-bold',
	                                target: '_blank'
	                            },
	                            r.title
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 vertical-offset-xxs', style: {
	                                overflow: 'hidden',
	                                textOverflow: 'ellipsis',
	                                display: '-webkit-box',
	                                WebkitBoxOrient: 'vertical',
	                                WebkitLineClamp: '2',
	                                maxHeight: '3.0em',
	                                lineHeight: '1.4em'
	                            } },
	                        r.excerpt
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 vertical-offset-xs text-muted' },
	                        (0, _format2.default)(new Date(r.publishedAt), 'EEEE, MMMM dd, yyyy kk:mm a'),
	                        ' - ',
	                        r.sourceName
	                    )
	                )
	            );
	        })
	    );
	};

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useNews2 = __webpack_require__(880);
	
	var _useNews3 = _interopRequireDefault(_useNews2);
	
	var _items = __webpack_require__(877);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _paging = __webpack_require__(879);
	
	var _paging2 = _interopRequireDefault(_paging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var modal = _ref.modal;
	
	    var _useNews = (0, _useNews3.default)({ modal: modal }),
	        rows = _useNews.rows,
	        status = _useNews.status,
	        error = _useNews.error,
	        page = _useNews.page,
	        setPage = _useNews.setPage,
	        total = _useNews.total;
	
	    var n = (0, _twd.arrayFrom)(rows).length;
	    var isMore = !modal && n > 5;
	
	    return _react2.default.createElement(
	        _twd.Loading,
	        { status: status, error: error },
	        _react2.default.createElement(_items2.default, { rows: rows, modal: modal }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xxs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                isMore && _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'corporates--more-stories-link',
	                        className: 'text-bold link-button',
	                        onClick: function onClick(e) {
	                            return (0, _twd.showModal)('corporates--modal', { source: e.target });
	                        } },
	                    'More Stories...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6 text-right' },
	                _react2.default.createElement(_twd.Disclosures, {
	                    dataName: 'corporates--disclosures-link',
	                    html: DISCLOSURES })
	            )
	        ),
	        modal && _react2.default.createElement(_paging2.default, { page: page, setPage: setPage, total: total })
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var DISCLOSURES = '\n    Please review <a style="cursor:pointer"\n    onclick="twd.hideModal();twd.openWindow(\'https://www.lexisnexis.com/en-us/terms/general/default.page\', \'_blank\')">LexisNexis terms and conditions</a>\n    in order to access the full text for LexisNexis licensed articles.\n';

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        page = _ref.page,
	        total = _ref.total,
	        setPage = _ref.setPage;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'row vertical-offset-xxs' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 text-center' },
	            _react2.default.createElement(
	                'div',
	                { className: 'pagination-with-label' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'pagination' },
	                    function () {
	                        if (total === 0) return null;
	
	                        var ps = paging({ page: page, total: total });
	
	                        var maxPage = ps[ps.length - 1];
	                        var arr = [];
	
	                        if (page !== 1) arr.push(_react2.default.createElement(
	                            'li',
	                            { key: 0, className: 'previous' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn-link',
	                                    'aria-label': 'previous',
	                                    'data-name': 'corporates-market-news-paging-left',
	                                    onClick: function onClick() {
	                                        return setPage(page - 1);
	                                    } },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'chevron_left'
	                                )
	                            )
	                        ));
	
	                        var _loop = function _loop(i, n) {
	                            var p = ps[i];
	                            var c = p === page;
	                            arr.push(_react2.default.createElement(
	                                'li',
	                                { key: arr.length + 1,
	                                    className: c ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn-link',
	                                        'aria-label': 'page ' + (i + 1),
	                                        'data-name': 'corporates-market-news-paging-page',
	                                        disabled: c, onClick: function onClick() {
	                                            return setPage(p);
	                                        } },
	                                    i === n - 2 && ps[i] + 1 !== ps[i + 1] ? '...' : _twd.fmt.count(p)
	                                )
	                            ));
	                        };
	
	                        for (var i = 0, n = ps.length; i < n; i++) {
	                            _loop(i, n);
	                        }
	
	                        if (page !== maxPage) arr.push(_react2.default.createElement(
	                            'li',
	                            { key: arr.length + 1, className: 'next' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn-link',
	                                    'aria-label': 'next',
	                                    'data-name': 'corporates-market-news-paging-right',
	                                    onClick: function onClick() {
	                                        return setPage(page + 1);
	                                    } },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'chevron_right'
	                                )
	                            )
	                        ));
	
	                        return arr;
	                    }()
	                )
	            )
	        )
	    );
	};
	
	var paging = function paging() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$page = _ref2.page,
	        page = _ref2$page === undefined ? 0 : _ref2$page,
	        _ref2$total = _ref2.total,
	        total = _ref2$total === undefined ? 0 : _ref2$total,
	        _ref2$size = _ref2.size,
	        size = _ref2$size === undefined ? 10 : _ref2$size;
	
	    var nPages = Math.ceil(total / size);
	    var pages = [];
	    if (nPages === 0) return pages;
	
	    if (page < 5) {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return i + 1;
	        });
	    } else if (page + 5 >= nPages) {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return nPages - 6 + i;
	        });
	    } else {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return page - 3 + i;
	        });
	    }
	    pages = pages.filter(function (a) {
	        return a < nPages;
	    });
	    pages.push(nPages);
	
	    return pages;
	};

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBitvore = __webpack_require__(317);
	
	var _useMarketNews2 = __webpack_require__(116);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	var _dateFns = __webpack_require__(396);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var NO_RESULT = 'There are no results that match your search. Please review your search criteria and try again';
	var TIMED_OUT = 'Timed-out';
	
	exports.default = function (_ref) {
	    var modal = _ref.modal;
	
	    var _React$useState = _react2.default.useState([]),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        rows = _React$useState2[0],
	        setRows = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(''),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        error = _React$useState6[0],
	        setError = _React$useState6[1];
	
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        tab = _useMarketNews.tab,
	        customSearchType = _useMarketNews.customSearchType,
	        customKeyword = _useMarketNews.customKeyword,
	        customSearch = _useMarketNews.customSearch,
	        customIndustry = _useMarketNews.customIndustry,
	        customDate = _useMarketNews.customDate,
	        holdingCompany = _useMarketNews.holdingCompany,
	        holdingDate = _useMarketNews.holdingDate;
	
	    var _React$useState7 = _react2.default.useState(1),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        page = _React$useState8[0],
	        setPage = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(0),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        total = _React$useState10[0],
	        setTotal = _React$useState10[1];
	
	    var timerId = _react2.default.useRef();
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        setPage(1);
	        setTotal(0);
	    }, [tab, customSearch, customIndustry, customDate, holdingCompany, holdingDate]);
	
	    var _React$useState11 = _react2.default.useState(),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        params = _React$useState12[0],
	        setParams = _React$useState12[1];
	
	    _react2.default.useEffect(function () {
	        var p = getParams({
	            modal: modal,
	            page: page,
	            tab: tab,
	            customSearchType: customSearchType,
	            customKeyword: customKeyword,
	            customSearch: customSearch,
	            customIndustry: customIndustry,
	            customDate: customDate,
	
	            holdingCompany: holdingCompany,
	            holdingDate: holdingDate
	        });
	        setParams(p);
	    }, [page, tab, customSearchType, customSearch, customKeyword, customIndustry, customDate, holdingCompany, holdingDate]);
	
	    _react2.default.useEffect(function () {
	        if (timerId.current) {
	            clearInterval(timerId.current);
	            timerId.current = 0;
	        }
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var isTimedOut, auth, url, _ref3, data, abort, isTO, _ref4, response, _total, f;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setRows([]);
	                            setError('');
	                            setStatus(_twd.Status.LOADING);
	
	                            if (params) {
	                                _context.next = 7;
	                                break;
	                            }
	
	                            setRows([]);
	                            setStatus(_twd.Status.LOADED);
	                            return _context.abrupt('return');
	
	                        case 7:
	                            if (!(Object.keys(params).length === 0)) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            setError(NO_RESULT);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	                            return _context.abrupt('return');
	
	                        case 11:
	                            isTimedOut = void 0;
	                            _context.prev = 12;
	                            _context.next = 15;
	                            return (0, _useBitvore.getAuth)();
	
	                        case 15:
	                            auth = _context.sent;
	
	                            if (auth) {
	                                _context.next = 19;
	                                break;
	                            }
	
	                            setStatus(_twd.Status.UNAVAILABLE);
	                            return _context.abrupt('return');
	
	                        case 19:
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            url = 'https://api.bitvore.com/corpnews';
	                            _context.next = 23;
	                            return (0, _twd.ajax)({
	                                url: url,
	                                method: 'POST',
	                                headers: Object.assign({
	                                    'Content-Type': 'application/json',
	                                    'Accept': '*/*'
	                                }, auth),
	                                params: params
	                            });
	
	                        case 23:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            abort = _ref3.abort;
	                            isTO = _ref3.isTimedOut;
	
	                            isTimedOut = isTO;
	                            lastAbort.current = abort;
	                            _context.next = 31;
	                            return data;
	
	                        case 31:
	                            _ref4 = _context.sent;
	                            response = _ref4.response;
	                            _total = _ref4.total;
	
	                            lastAbort.current = null;
	
	                            (0, _twd.publish)('corporates-market-news-unavailable', false);
	
	                            f = !response || !Array.isArray(response) || response.length === 0;
	
	                            if (!f) {
	                                _context.next = 41;
	                                break;
	                            }
	
	                            setError(NO_RESULT);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	                            return _context.abrupt('return');
	
	                        case 41:
	
	                            setRows(response);
	                            setTotal(_total);
	
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 57;
	                            break;
	
	                        case 46:
	                            _context.prev = 46;
	                            _context.t0 = _context['catch'](12);
	
	                            if (!(_context.t0.name === 'SyntaxError')) {
	                                _context.next = 51;
	                                break;
	                            }
	
	                            (0, _twd.publish)('corporates-market-news-unavailable', true);
	                            return _context.abrupt('return');
	
	                        case 51:
	                            if (!(_context.t0.name === 'AbortError')) {
	                                _context.next = 54;
	                                break;
	                            }
	
	                            if (isTimedOut()) {
	                                setError(TIMED_OUT);
	                                setStatus(_twd.Status.FAILED_TO_LOAD);
	                            }
	                            return _context.abrupt('return');
	
	                        case 54:
	
	                            setPage(1);
	                            setTotal(0);
	                            setStatus(_twd.Status.LOADING);
	
	                        case 57:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[12, 46]]);
	        })), 500);
	
	        return function () {
	            if (lastAbort.current) {
	                lastAbort.current();
	            }
	            if (timerId.current) {
	                clearInterval(timerId.current);
	            }
	        };
	    }, [params]);
	
	    return {
	        rows: rows, status: status, error: error,
	        page: page, setPage: setPage,
	        total: total
	    };
	};
	
	var getParams = function getParams(_ref5) {
	    var modal = _ref5.modal,
	        page = _ref5.page,
	        tab = _ref5.tab,
	        customSearchType = _ref5.customSearchType,
	        customKeyword = _ref5.customKeyword,
	        customSearch = _ref5.customSearch,
	        customIndustry = _ref5.customIndustry,
	        customDate = _ref5.customDate,
	        holdingCompany = _ref5.holdingCompany,
	        holdingDate = _ref5.holdingDate;
	
	    var pageNo = modal ? Math.max(page, 1) : 1;
	    var pageSize = modal ? 10 : 6;
	
	    var isCustom = tab === 'CUSTOM';
	
	    var startDate = ymd(getInitialDate(isCustom ? customDate : holdingDate));
	    var endDate = ymd(new Date());
	    var industries = (0, _twd.arrayFrom)(customIndustry);
	
	    var param = {};
	    var isKeyword = customSearchType === 'keyword';
	
	    if (isCustom && isKeyword && customKeyword === undefined) {
	        return;
	    } else if (isCustom && !isKeyword && customSearch === undefined) {
	        return;
	    } else if (isCustom && isKeyword && !(0, _twd.isEmpty)(customKeyword)) {
	        param.text = customKeyword;
	    } else if (isCustom && !isKeyword && !(0, _twd.isEmpty)(customSearch)) {
	        param.orgScope = { bvId: [customSearch.id] };
	    } else if (isCustom && industries.length < 5) {
	        var codes = industries.filter(function (a) {
	            return a.sic_code;
	        }).reduce(function (x, a) {
	            return x.concat(a.sic_code);
	        }, []).sort();
	        param.orgScope = { orgQuery: {
	                sic: codes.length === _twd.CORP_SIC_CODES_LENGTH ? [] : codes
	            } };
	    } else if (!isCustom && !(0, _twd.isEmpty)(holdingCompany)) {
	        var bvId = holdingCompany.map(function (a) {
	            return a.bitvoreId;
	        }).flat().filter(Boolean);
	        if (bvId.length === 0) return {};
	        param.orgScope = { bvId: bvId };
	    }
	
	    if (Object.keys(param).length === 0) return;
	
	    return Object.assign({}, param, {
	        startDate: startDate,
	        endDate: endDate,
	        timezone: 'America/New_York',
	        pageNo: pageNo,
	        pageSize: pageSize
	    });
	};
	
	var ymd = function ymd(d) {
	    return (0, _dateFns.format)(d, 'yyyy-MM-dd');
	};
	
	var getInitialDate = function getInitialDate(dateType) {
	    var today = new Date();
	    switch (dateType) {
	        case "today":
	            return (0, _dateFns.startOfDay)(today);
	        case "this_month":
	            return (0, _dateFns.addDays)(today, -30);
	        case "last_90_days":
	            return (0, _dateFns.addDays)(today, -90);
	        case "this_year":
	            return (0, _dateFns.startOfYear)(today);
	        case "this_week":
	        default:
	            return (0, _dateFns.addDays)(today, -7);
	    }
	};

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var tab = _ref.tab,
	        rows = _ref.rows;
	
	
	    var isRatio = tab !== 'MOST_ACTIVE_BUYS';
	    var totals = { buys: 0, sells: 0 };
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            {
	                'data-name': 'corporate-market-snapshot-table',
	                className: 'table table-hover align-top' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Symbol'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Issuer'
	                    ),
	                    !isRatio && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'CUSIPs'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Trades'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right', nowrap: 'true' },
	                            'Par Value',
	                            _react2.default.createElement('br', null),
	                            'Traded (MM)'
	                        )
	                    ),
	                    isRatio && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Buys'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Sells'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Ratio'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right', nowrap: 'true' },
	                        'Median Yield'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rows && rows.map(function (r, i) {
	                    if (isRatio) {
	                        totals.buys += r.buys;
	                        totals.sells += r.sells;
	                    }
	                    return _react2.default.createElement(
	                        'tr',
	                        {
	                            'data-name': 'corporate-market-snapshot-row',
	                            key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            formatSymbol(r)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            r.issuer || r.ticker
	                        ),
	                        !isRatio && _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.count(r.cusips)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.count(r.trades)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                '$',
	                                r.parValue
	                            )
	                        ),
	                        isRatio && _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.count(r.buys)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.count(r.sells)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                formatRatio(r)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.ytw(r.medianYield),
	                            '%'
	                        )
	                    );
	                })
	            ),
	            isRatio && _react2.default.createElement(
	                'tfoot',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    { className: 'text-right' },
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'text-left', colSpan: '2' },
	                        'TOTALS'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _twd.fmt.count(totals.buys)
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _twd.fmt.count(totals.sells)
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        formatRatio(totals)
	                    ),
	                    _react2.default.createElement('td', null)
	                )
	            )
	        )
	    );
	};
	
	var formatSymbol = function formatSymbol(_ref2) {
	    var symbol = _ref2.ticker,
	        issuer = _ref2.issuer;
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'corporate-market-snapshot-symbol-link',
	            'data-symbol': symbol,
	            className: 'link-button',
	            onClick: function onClick(e) {
	                var p = {
	                    view: 'offerings-modal',
	                    name: issuer,
	                    params: {
	                        persistToPreviousSearches: false,
	                        holdInvType: ['C'],
	                        holdSymbol: [symbol]
	                    },
	                    maturity: 'ALL',
	                    from: 'corporates',
	                    source: e.target
	                };
	                (0, _twd.showModal)(p);
	            }
	        },
	        symbol
	    );
	};
	
	var formatRatio = function formatRatio(_ref3) {
	    var buys = _ref3.buys,
	        sells = _ref3.sells;
	
	    if (!sells) return '-';
	    var a = buys / sells;
	    return a.toFixed(3);
	};

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(161);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useMarketSnapshot2 = __webpack_require__(883);
	
	var _useMarketSnapshot3 = _interopRequireDefault(_useMarketSnapshot2);
	
	var _twd = __webpack_require__(2);
	
	var _grid = __webpack_require__(881);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _ratingFieldset = __webpack_require__(236);
	
	var _ratingFieldset2 = _interopRequireDefault(_ratingFieldset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useMarketSnapshot = (0, _useMarketSnapshot3.default)(),
	        tab = _useMarketSnapshot.tab,
	        setTab = _useMarketSnapshot.setTab,
	        rating = _useMarketSnapshot.rating,
	        setRating = _useMarketSnapshot.setRating,
	        rows = _useMarketSnapshot.rows,
	        status = _useMarketSnapshot.status;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'corporate-market-snapshot', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'corporate-market-snapshot', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Corporate Market Snapshot'
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    (0, _core.jsx)(_ratingFieldset2.default, { name: 'corporates-market-snapshot-rating',
	                        rating: rating, setRating: setRating })
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { 'data-name': 'corporate-market-snapshot-nav-tabs', className: 'nav-tabs' },
	                        (0, _core.jsx)(
	                            'ul',
	                            null,
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'MOST_ACTIVE_BUYS' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'corporate-market-snapshot-most-active-buys-nav-tab',
	                                        onClick: function onClick() {
	                                            return setTab('MOST_ACTIVE_BUYS');
	                                        } },
	                                    'Most active buys'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'HIGHEST_RATIO' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'corporate-market-snapshot-highest-buy-sell-ratio-nav-tab',
	                                        onClick: function onClick() {
	                                            return setTab('HIGHEST_RATIO');
	                                        } },
	                                    'Highest buy/sell ratio'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'LOWEST_RATIO' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'corporate-market-snapshot-lowest-buy-sell-ratio-nav-tab',
	                                        onClick: function onClick() {
	                                            return setTab('LOWEST_RATIO');
	                                        } },
	                                    'Lowest buy/sell ratio'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                _twd.Loading,
	                { status: status },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-12' },
	                        (0, _core.jsx)(_grid2.default, { tab: tab, rows: rows })
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-12 col-sm-8 text-small' },
	                        'Source: Tradeweb Direct LLC & TRACE. Based on top 100 most actively traded issuers.'
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-12 col-sm-4 text-right' },
	                        (0, _core.jsx)(_twd.Disclosures, {
	                            dataName: 'corporate-market-snapshot-disclosures-link',
	                            html: DISCLOSURES[tab] || '' })
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var DISCLOSURES = {
	    MOST_ACTIVE_BUYS: '\n    <p>This list displays the top 10 most actively purchased issuers in the retail markets.\n    Note that the list only considers buy trades by retail investors, not sell trades.</p>\n    ',
	
	    HIGHEST_RATIO: '\n    <p>This table displays the issuers in the retail market with the most positive momentum,\n    as measured by the ratio of buy trades to sell trades. When a bond is popular among\n    retail investors, it will have many buyers and few sellers.</p>\n\n    <p>Bonds with substantially more buys than sells will appear on this list.</p>\n\n    <p>In order to appear on this list, each firm has to be among the top 100\n    most actively traded issuers in the retail market.</p>\n    ',
	    LOWEST_RATIO: '\n    <p>This table displays the issuers in the retail market with the most negative momentum,\n    as measured by the ratio of buy trades to sell trades.\n    When a bond is out of favor with retail investors, it will have few buyers and many sellers.</p>\n\n    <p>Bonds with substantially fewer buys than sells will appear on this list.</p>\n\n    <p>In order to appear on this list, each firm has to be among the top 100\n    most actively traded issuers in the retail market.</p>\n    '
	};

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('corporates.market-snapshot', {
	    tab: 'MOST_ACTIVE_BUYS',
	    rating: 'INVESTMENT_GRADE'
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.tab || 'MOST_ACTIVE_BUYS'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tab = _React$useState2[0],
	        setTab_ = _React$useState2[1];
	
	    var setTab = _react2.default.useCallback(function (m) {
	        state.set({ tab: m });
	        setTab_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(state.value.rating || 'INVESTMENT_GRADE'),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        rating = _React$useState4[0],
	        setRating_ = _React$useState4[1];
	
	    var setRating = _react2.default.useCallback(function (m) {
	        state.set({ rating: m });
	        setRating_(m);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        rows = _React$useState6[0],
	        setRows = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        status = _React$useState8[0],
	        setStatus = _React$useState8[1];
	
	    _react2.default.useEffect(function () {
	
	        setRows([]);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var url, mktType, _ref2, data, a;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	                            url = '/esb/retailservice/marketSnapshotService/getMarketSnapshotByType';
	                            mktType = marketSnapshotsTypes[rating + '-' + tab];
	                            _context.next = 6;
	                            return (0, _twd.ajax)({
	                                url: url,
	                                method: 'POST',
	                                params: {
	                                    marketSnapshotsType: mktType
	                                }
	                            });
	
	                        case 6:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            _context.next = 10;
	                            return data;
	
	                        case 10:
	                            a = _context.sent;
	
	                            setRows((0, _twd.arrayFrom)(a));
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 18;
	                            break;
	
	                        case 15:
	                            _context.prev = 15;
	                            _context.t0 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 18:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 15]]);
	        }))();
	    }, [tab, rating]);
	
	    return { tab: tab, setTab: setTab, rating: rating, setRating: setRating, rows: rows, status: status };
	};
	
	var marketSnapshotsTypes = {
	    'INVESTMENT_GRADE-MOST_ACTIVE_BUYS': 'IG_MOST_ACTIVE_BUYS',
	    'INVESTMENT_GRADE-HIGHEST_RATIO': 'IG_HIGH_BUY_SELL_RATIO',
	    'INVESTMENT_GRADE-LOWEST_RATIO': 'IG_LOW_BUY_SELL_RATIO',
	    'HIGH_YIELD-MOST_ACTIVE_BUYS': 'HY_MOST_ACTIVE_BUYS',
	    'HIGH_YIELD-HIGHEST_RATIO': 'HY_HIGH_BUY_SELL_RATIO',
	    'HIGH_YIELD-LOWEST_RATIO': 'HY_LOW_BUY_SELL_RATIO'
	    // IG_MOST_ACTIVE,
	    // HY_MOST_ACTIVE,
	    // IG_MOST_ACTIVE_BUYS,
	    // HY_MOST_ACTIVE_BUYS,
	    // IG_HIGH_BUY_SELL_RATIO,
	    // HY_HIGH_BUY_SELL_RATIO,
	    // IG_LOW_BUY_SELL_RATIO,
	    // HY_LOW_BUY_SELL_RATIO
	
	};

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _submitButton = __webpack_require__(886);
	
	var _submitButton2 = _interopRequireDefault(_submitButton);
	
	var _toSearchParams = __webpack_require__(318);
	
	var _useQuickScreener = __webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	
	var Labels = _twd.Fields.Labels;
	
	
	var getResetValues = function getResetValues(curr) {
	
	    var a = Object.assign({}, curr);
	    var b = Object.assign({}, _useQuickScreener.initialValues);
	
	    if (!(0, _twd.isEquals)(a, b)) {
	        return Object.assign({}, _useQuickScreener.initialValues, {
	            holdSpRatingMin: 'BBB-',
	            holdSpRatingMax: 'AAA',
	            holdMoodyRatingMin: 'Baa3',
	            holdMoodyRatingMax: 'Aaa'
	        });
	    }
	
	    return Object.assign(b, {
	        rating: "all-ratings",
	        holdMoodyRatingMin: "ALL",
	        holdMoodyRatingMax: "ALL",
	        holdSpRatingMin: "ALL",
	        holdSpRatingMax: "ALL"
	    });
	};
	
	exports.default = function (_ref) {
	    var handleSubmit = _ref.handleSubmit,
	        values = _ref.values,
	        errors = _ref.errors,
	        resetForm = _ref.resetForm,
	        validateForm = _ref.validateForm;
	
	
	    _react2.default.useEffect(function () {
	        validateForm();
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('corporates_quick_screener_clear_all.corporates_quick_screener_form', function () {
	            resetForm(getResetValues(values));
	            setTimeout(function () {
	                validateForm();
	            });
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, [values]);
	
	    return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, {
	                            label: 'Sectors',
	                            info: Labels.CorpSector
	                        })
	                    )
	                ),
	                _react2.default.createElement(_formik.FieldArray, {
	                    name: 'sectors',
	                    render: function render(args) {
	                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                            dataName: 'corporates-quick-screener-sectors',
	                            emptyText: 'All',
	                            showSelectAll: true,
	                            options: _twd.CORP_SECTORS,
	                            style: { marginBottom: '10px' }
	                        }));
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Maturity Date', info: _twd.Fields.Labels.Maturity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-maturity-min',
	                            name: 'holdMaturityMin',
	                            component: _twd.Fields.Maturity,
	                            label: 'Min',
	                            error: errors.holdMaturity
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-maturity-max',
	                            name: 'holdMaturityMax',
	                            component: _twd.Fields.Maturity,
	                            label: 'Max',
	                            error: errors.holdMaturity
	                        })
	                    ),
	                    errors.holdMaturity && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.holdMaturity
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Quantity', info: _twd.Fields.Labels.Quantity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-quantity-min',
	                            name: 'quantityMin',
	                            component: _twd.Fields.Quantity,
	                            label: 'Min',
	                            error: errors.quantity
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-quantity-max',
	                            name: 'quantityMax',
	                            component: _twd.Fields.Quantity,
	                            label: 'Max',
	                            error: errors.quantity
	                        })
	                    ),
	                    errors.quantity && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.quantity
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Yield', info: _twd.Fields.Labels.Yield })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-yield-min',
	                            name: 'offerYtwMin',
	                            component: _twd.Fields.Yield,
	                            placeholder: '%',
	                            error: errors.offerYtw,
	                            label: 'Min'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-yield-max',
	                            name: 'offerYtwMax',
	                            component: _twd.Fields.Yield,
	                            placeholder: '%',
	                            error: errors.offerYtw,
	                            label: 'Max'
	                        })
	                    ),
	                    errors.offerYtw && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.offerYtw
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Price', info: _twd.Fields.Labels.Price })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-price-min',
	                            name: 'clientPriceMin',
	                            component: _twd.Fields.Price,
	                            placeholder: '$',
	                            error: errors.clientPrice,
	                            label: 'Min'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-price-max',
	                            name: 'clientPriceMax',
	                            component: _twd.Fields.Price,
	                            placeholder: '$',
	                            error: errors.clientPrice,
	                            label: 'Max'
	                        })
	                    ),
	                    errors.clientPrice && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.clientPrice
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, {
	                            id: 'corporates-quick-screener-rating-label',
	                            label: 'Rating', info: _twd.Fields.Labels.Rating })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-rating-investment-grade',
	                            'aria-describedby': 'corporates-quick-screener-rating-label',
	                            name: 'rating',
	                            component: _twd.Fields.Radio,
	                            value: 'investment-grade',
	                            label: 'Investment Grade',
	                            className: 'radio-inline',
	                            onClick: function onClick() {
	                                Object.assign(values, {
	                                    holdSpRatingMin: 'BBB-',
	                                    holdSpRatingMax: 'AAA',
	                                    holdMoodyRatingMin: 'Baa3',
	                                    holdMoodyRatingMax: 'Aaa'
	                                });
	                            } }),
	                        '\xA0 \xA0',
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-rating-high-yield',
	                            'aria-describedby': 'corporates-quick-screener-rating-label',
	                            name: 'rating',
	                            component: _twd.Fields.Radio,
	                            value: 'high-yield',
	                            label: 'High Yield',
	                            className: 'radio-inline',
	                            onClick: function onClick() {
	                                Object.assign(values, {
	                                    holdSpRatingMin: 'C',
	                                    holdSpRatingMax: 'BB+',
	                                    holdMoodyRatingMin: 'C',
	                                    holdMoodyRatingMax: 'Ba1'
	                                });
	                            } }),
	                        '\xA0 \xA0',
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'corporates-quick-screener-rating-all-ratings',
	                            name: 'rating', component: _twd.Fields.Radio,
	                            value: 'all-ratings',
	                            label: 'All ratings',
	                            className: 'radio-inline',
	                            onClick: function onClick() {
	                                Object.assign(values, {
	                                    holdSpRatingMin: 'ALL',
	                                    holdSpRatingMax: 'ALL',
	                                    holdMoodyRatingMin: 'ALL',
	                                    holdMoodyRatingMax: 'ALL'
	                                });
	                            } })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12 col-lg-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Moody\'s' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'corporates-quick-screener-moodys-credit-rating-min',
	                            name: 'holdMoodyRatingMin',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'moodys',
	                            error: errors.holdMoodyRating,
	                            label: 'Min',
	                            ariaLabel: 'Minimum Moody\'s Rating'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'corporates-quick-screener-moodys-credit-rating-max',
	                            name: 'holdMoodyRatingMax',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'moodys',
	                            error: errors.holdMoodyRating,
	                            label: 'Max',
	                            ariaLabel: 'Maximum Moody\'s Rating'
	                        })
	                    ),
	                    errors.holdMoodyRating && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.holdMoodyRating
	                    ),
	                    _react2.default.createElement(_twd.Dash, { margin: 10 })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12 col-lg-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'S&P' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'corporates-quick-screener-sp-credit-rating-min',
	                            name: 'holdSpRatingMin',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'sp',
	                            error: errors.holdSpRating,
	                            label: 'Min',
	                            ariaLabel: 'Minimum S&ampP Rating'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'corporates-quick-screener-sp-credit-rating-max',
	                            name: 'holdSpRatingMax',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'sp',
	                            error: errors.holdSpRating,
	                            label: 'Max',
	                            ariaLabel: 'Maximum S&ampP Rating'
	                        })
	                    ),
	                    errors.holdSpRating && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.holdSpRating
	                    ),
	                    _react2.default.createElement(_twd.Dash, { margin: 10 })
	                )
	            )
	        ),
	        _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'corporates-quick-screener-credit-ratings-and-or',
	                    name: 'holdRatingAndOr',
	                    component: _twd.Fields.Checkbox,
	                    label: 'Results can match Moody\'s or S&P ratings selection'
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'corporates-quick-screener-exclude-callable',
	                    name: 'holdCallableInd',
	                    component: _twd.Fields.Checkbox,
	                    label: 'Exclude Callable'
	                })
	            )
	        ),
	        _react2.default.createElement('div', { className: 'row vertical-offset-base' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_submitButton2.default, { errors: errors, values: values })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 text-center' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'corporates-quick-screener-advanced-screener',
	                        className: 'btn btn-link',
	                        onClick: function onClick() {
	                            var p = (0, _toSearchParams.toSearchParams)(values);
	                            p.isEdit = true;
	
	                            (0, _twd.show)('advanced-screener', Object.assign({
	                                searchParams: p,
	                                _ts: Date.now(),
	                                from: 'corporates'
	                            }));
	                        }
	                    },
	                    'Advanced Screener'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(161);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _form = __webpack_require__(884);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _formik = __webpack_require__(62);
	
	var _useQuickScreener2 = __webpack_require__(319);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'corporate-quick-screener', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'corporate-quick-screener', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                _useQuickScreener2.ContextProvider,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-8' },
	                        (0, _core.jsx)(
	                            'h3',
	                            { className: 'medium-header' },
	                            'Corporate Quick Screener'
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-4 text-right' },
	                        (0, _core.jsx)(
	                            'button',
	                            {
	                                type: 'button',
	                                'data-name': 'corporates-quick-screener-clear-all',
	                                className: 'link-button',
	                                onClick: function onClick() {
	                                    (0, _twd.publish)('corporates_quick_screener_clear_all', true);
	                                }
	                            },
	                            'Clear All '
	                        )
	                    )
	                ),
	                (0, _core.jsx)(FormMain, null)
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var FormMain = function FormMain() {
	    var _useQuickScreener = (0, _useQuickScreener2.useQuickScreener)(),
	        state = _useQuickScreener.state,
	        onValidate = _useQuickScreener.onValidate,
	        onSubmit = _useQuickScreener.onSubmit;
	
	    return (0, _core.jsx)(_formik.Formik, {
	        initialValues: state.value.currentValues,
	        onSubmit: onSubmit,
	        component: _form2.default,
	        validate: onValidate,
	        validateOnBlur: true,
	        validateOnChange: true
	    });
	};

/***/ },
/* 886 */
[2038, 319, 318],
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toSearchParams = __webpack_require__(318);
	
	var _twd = __webpack_require__(2);
	
	exports.default = function (values) {
	    if (!values) return;
	
	    var p = (0, _toSearchParams.toSearchParams)(values);
	    setTimeout(function () {
	        (0, _twd.trackSearch)('Corporate Quick Screener', p);
	    });
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: Object.assign(p, { persistToPreviousSearches: true }),
	        _ts: Date.now(),
	        from: 'corporates'
	    }));
	};

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ratings = __webpack_require__(197);
	
	var _twd = __webpack_require__(2);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-use-before-define */
	
	exports.default = function (values) {
	    checkRatingIndicator(values);
	
	    return Object.assign({}, validateHoldInvType(values), validateMaturity(values, 'holdMaturity'), validateNumbers(values, 'quantity'), validateNumbers(values, 'offerYtw'), validateNumbers(values, 'clientPrice'), validateRatings(values, 'holdSpRating', _ratings.spRatings), validateRatings(values, 'holdMoodyRating', _ratings.moodysRatings));
	};
	
	var checkRatingIndicator = function checkRatingIndicator(values) {
	    var sMin = values.holdSpRatingMin,
	        sMax = values.holdSpRatingMax,
	        mMin = values.holdMoodyRatingMin,
	        mMax = values.holdMoodyRatingMax;
	
	
	    if (sMin === 'BBB-' && sMax === 'AAA' && mMin === 'Baa3' && mMax === 'Aaa') {
	        values.rating = 'investment-grade';
	    } else if (sMin === 'C' && sMax === 'BB+' && mMin === 'C' && mMax === 'Ba1') {
	        values.rating = 'high-yield';
	    } else if (sMin === 'ALL' && sMax === 'ALL' && mMin === 'ALL' && mMax === 'ALL') {
	        values.rating = 'all-ratings';
	    } else {
	        values.rating = '';
	    }
	};
	
	var validateHoldInvType = function validateHoldInvType(values) {
	    var arr = values.holdInvType;
	    if (!Array.isArray(arr) || arr.length === 0) {
	        return { holdInvType: 'Please select at least one security type' };
	    }
	};
	
	var validateRatings = function validateRatings(values, name, ratings) {
	    var min = ratings.indexOf(values[name + 'Min']);
	    var max = ratings.indexOf(values[name + 'Max']);
	    var e = {};
	    if (max > min) {
	        e[name] = 'Please enter higher ratings';
	    }
	    return e;
	};
	
	var validateMaturity = function validateMaturity(values, name) {
	    var min = (0, _twd.parseDate)(values[name + 'Min']);
	    var max = (0, _twd.parseDate)(values[name + 'Max'], true);
	    if (max < min) {
	        return _defineProperty({}, name, 'Please select later date');
	    }
	};
	
	var validateNumbers = function validateNumbers(values, name) {
	    var min = parseFloat(values[name + 'Min']);
	    var max = parseFloat(values[name + 'Max']);
	    var e = {};
	    if (max < min) {
	        e[name] = 'Please enter max > min';
	    }
	    return e;
	};

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(161);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = __webpack_require__(1829);
	
	var state = (0, _twd.getState)('corporates.resources', {
	    tab: 'why',
	    index: 0
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.tab || 'why'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tab = _React$useState2[0],
	        setTab_ = _React$useState2[1];
	
	    var setTab = _react2.default.useCallback(function (m) {
	        state.set({ tab: m });
	        setTab_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(state.value.index || 0),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        index = _React$useState4[0],
	        setIndex_ = _React$useState4[1];
	
	    var setIndex = _react2.default.useCallback(function (m) {
	        state.set({ index: m });
	        setIndex_(m);
	    }, []);
	
	    var tabItems = items[tab] || [];
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'corporate-bond-resources', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'corporate-bond-resources', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header', style: { marginBottom: 0 } },
	                        'Corporate Bond Resources'
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { 'data-name': 'corporates-bond-resources-nav-tabs', className: 'nav-tabs' },
	                        (0, _core.jsx)(
	                            'ul',
	                            null,
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'why' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'corporates-bond-resources-why-invest-nav-tab',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('why');
	                                        } },
	                                    'Why invest?'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'faq' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'corporates-bond-resources-faq-nav-tab',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('faq');
	                                        } },
	                                    'FAQ'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'risk' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'corporates-bond-resources-risks-nav-tab',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('risk');
	                                        } },
	                                    'Risks'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            Array.isArray(tabItems) ? renderItems(tabItems, index, setIndex) : renderItem(tabItems)
	        )
	    );
	};
	
	var renderItem = function renderItem(_ref) {
	    var html = _ref.html,
	        disclosure = _ref.disclosure;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: disclosure ? "row" : "row vertical-offset-sm" },
	            (0, _core.jsx)('div', { className: 'col-md-12', dangerouslySetInnerHTML: { __html: html } })
	        ),
	        disclosure && (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12 text-right' },
	                (0, _core.jsx)(_twd.Disclosures, { html: disclosure })
	            )
	        )
	    );
	};
	
	var renderItems = function renderItems(items, index, setIndex) {
	    return items.map(function (item, idx) {
	        var _item = _slicedToArray(item, 2),
	            title = _item[0],
	            content = _item[1];
	
	        var showItem = idx === index;
	        return (0, _core.jsx)(
	            _react2.default.Fragment,
	            { key: idx },
	            (0, _core.jsx)(
	                'div',
	                null,
	                (0, _core.jsx)(
	                    'button',
	                    {
	                        'data-name': 'corporates-bond-resources-item-arrow',
	                        'data-label': title,
	                        style: { position: 'relative', top: -2, zIndex: 1 },
	                        className: 'btn-link text-muted',
	                        onClick: function onClick() {
	                            return setIndex(showItem ? -1 : idx);
	                        } },
	                    (0, _core.jsx)(
	                        'i',
	                        { style: { color: 'var(--primary-base-color)' }, className: 'material-icons' },
	                        showItem ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { style: { position: 'relative', top: '-20px', paddingLeft: 20 } },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'corporates-bond-resources-item-title',
	                            'data-label': title,
	                            className: "btn-link text-muted" + (showItem ? " vertical-offset-sm" : ''),
	                            onClick: function onClick() {
	                                return setIndex(showItem ? -1 : idx);
	                            } },
	                        (0, _core.jsx)(
	                            'b',
	                            { style: { color: 'var(--primary-base-color)' } },
	                            (0, _core.jsx)(
	                                'span',
	                                null,
	                                title
	                            )
	                        )
	                    ),
	                    showItem && (0, _core.jsx)('div', { css: css, dangerouslySetInnerHTML: { __html: content } })
	                )
	            )
	        );
	    });
	};
	
	var css = {
	
	    'li': {
	        'padding-left': '10px'
	    },
	    'img': {
	        'max-width': '100%'
	    }
	};

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' {\n        display: inline-block;\n    }\n    ', ' {\n        text-align:left;\n        width: 100%;\n        display: block;\n        padding: 1px 0;\n        margin-bottom: 5px;\n    }\n'], ['\n    ', ' {\n        display: inline-block;\n    }\n    ', ' {\n        text-align:left;\n        width: 100%;\n        display: block;\n        padding: 1px 0;\n        margin-bottom: 5px;\n    }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	var _useScatterGraph2 = __webpack_require__(138);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        benchmarks = _useScatterGraph.benchmarks,
	        selectedBenchmarks = _useScatterGraph.selectedBenchmarks,
	        setSelectedBenchmarks = _useScatterGraph.setSelectedBenchmarks,
	        colors = _useScatterGraph.colors;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)('div', { className: 'col-md-1' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-9 col-xs-12 text-center' },
	                (0, _core.jsx)(
	                    'div',
	                    { css: legendCss },
	                    (0, _core.jsx)(
	                        'label',
	                        { className: 'text-small' },
	                        'Yield curves: \xA0\xA0'
	                    )
	                ),
	                benchmarks.map(function (a, index) {
	                    return (0, _core.jsx)(
	                        'div',
	                        { css: legendCss, key: index },
	                        (0, _core.jsx)(_twd.Fields.CheckboxLabel, {
	                            dataName: 'corporates-scatter-graph-benchmark',
	                            key: index,
	                            value: a,
	                            label: a,
	                            checked: selectedBenchmarks.indexOf(a) >= 0,
	
	                            onChange: function onChange(e) {
	                                var v = e.target.value;
	                                var f = e.target.checked;
	                                var a = [].concat(_toConsumableArray(selectedBenchmarks));
	                                var n = f ? (0, _twd.arrayInsert)(a, v) : (0, _twd.arrayRemove)(a, v);
	                                setSelectedBenchmarks(n);
	                            },
	
	                            className: 'label-small',
	                            style: {
	                                borderLeft: '4px solid ' + colors[index],
	                                paddingLeft: '5px',
	                                paddingRight: '10px'
	                            } })
	                    );
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12 col-md-2 text-right' },
	                (0, _core.jsx)(_twd.Disclosures, {
	                    dataName: 'corporates-scatter-graph-disclosures-link',
	                    html: DISCLOSURES })
	            )
	        )
	    );
	};
	
	var legendCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs, _twd.mediaQueries.xs);
	
	var DISCLOSURES = '\n    <p>\n    This graph allows you to see whether a bond is yielding more or less than\n    the prevailing yields for comparable bonds. By default, the scatter graph\n    will plot offerings from the top five most heavily traded issuers currently\n    available on the Bond Resource Center. Each bond is depicted as\n    an individual point on the graph, and each issuer has a defined color designation.\n    The chart also displays color-coded Treasury and corporate yield curves\n    to analyze against the plotted offerings.\n    </p>\n    <p>\n    To amend the issuers displayed in your scatter graph view, click the\n    \u201CTop 5 actively traded issuers\u201D dropdown and use the checkboxes to alter\n    your active selections. Additionally, you may conduct a separate custom search\n    by entering a company name or symbol in the \u201CCustom issuer\u201D search bar.\n    Users can also customize the active yield curves by interacting with\n    the yield curve checkboxes at the base of the graph.\n    </p>';

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(135);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var props = _objectWithoutProperties(_ref, []);
	
	    var payload = props.payload;
	
	    return _react2.default.createElement(_recharts.Dot, Object.assign({
	        onMouseOver: activateBenchmarkShape,
	        onMouseOut: deactivateBenchmarkShape,
	        className: 'benchmarks-dot-' + payload.x + ' benchmark-' + payload.benchmark
	    }, props));
	};
	
	var activateBenchmarkShape = function activateBenchmarkShape(e, ev) {
	    var el = (0, _all.$)(ev.currentTarget);
	    var p = e.payload || {};
	    el.attr('data-benchmark', p.benchmark);
	    el.attr('data-maturity-years', p.maturityYearValue);
	    el.attr('data-yield', p.yieldValue);
	
	    (0, _all.$)('.' + e.className).each(function (i, a) {
	        var j = (0, _all.$)(a);
	        var c = (0, _all.$)(a).attr('fill');
	        j.attr({ r: 4, stroke: c, fill: '#fff' });
	    });
	};
	
	var deactivateBenchmarkShape = function deactivateBenchmarkShape(e) {
	    (0, _all.$)('.' + e.className).each(function (i, a) {
	        var j = (0, _all.$)(a);
	        var c = (0, _all.$)(a).attr('stroke');
	        j.attr({ r: 2, stroke: c, fill: c });
	    });
	};

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (props) {
	    var active = props.active,
	        payload = props.payload,
	        coordinate = props.coordinate;
	    var x = coordinate.x;
	
	    if (!active || !x) return null;
	
	    var a = (0, _twd.arrayFrom)(payload)[0];
	    if (!a) return null;
	    var p = a.payload;
	    if (!p || !p.benchmark) return null;
	
	    return renderBenchmarksTooltip(Object.assign({}, props, { payload: p }));
	};
	
	var renderBenchmarksTooltip = function renderBenchmarksTooltip(_ref) {
	    var colors = _ref.colors,
	        benchmarks = _ref.benchmarks,
	        selectedBenchmarks = _ref.selectedBenchmarks,
	        benchmarksData = _ref.benchmarksData,
	        payload = _ref.payload;
	
	    var data = benchmarks.map(function (b, i) {
	        return {
	            name: b,
	            selected: selectedBenchmarks.indexOf(b) >= 0,
	            color: colors[i]
	        };
	    }).filter(function (b) {
	        return b.selected;
	    }).map(function (b) {
	        var arr = benchmarksData[b.name];
	        if (!arr) return null;
	
	        var a = arr.find(function (n) {
	            return n.x === payload.x;
	        });
	        if (!a) return null;
	
	        b.data = a;
	        return b;
	    }).filter(Boolean);
	
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                border: '1px solid #eaeaea',
	                backgroundColor: '#fff',
	                padding: '5px'
	            } },
	        _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'text-bold' },
	                        formatDuration(payload.x),
	                        ' \xA0 '
	                    ),
	                    data.map(function (a, i) {
	                        return _react2.default.createElement(
	                            'td',
	                            {
	                                key: i + 1,
	                                className: 'label-small',
	                                style: {
	                                    borderLeft: '4px solid ' + a.color,
	                                    paddingLeft: '5px',
	                                    paddingRight: '10px'
	                                } },
	                            a.name,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'label-large text-bold' },
	                                _twd.format.ytw(a.data.y),
	                                '%'
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	var formatDuration = function formatDuration(x) {
	    return x < 1.0 ? x * 10 + ' Month' : x + ' Year';
	};

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var stroke = _ref.stroke,
	        width = _ref.width,
	        height = _ref.height,
	        x = _ref.x,
	        y = _ref.y,
	        top = _ref.top,
	        payload = _ref.payload;
	
	
	    if (!x) return null;
	
	    var a = (0, _twd.arrayFrom)(payload)[0];
	    if (!a) return null;
	    var p = a.payload;
	    if (!p || !p.benchmark) return null;
	
	    var args = {
	        x: x, y: y, stroke: stroke, width: width, height: height,
	        className: 'recharts-cross recharts-tooltip-cursor',
	        pointerEvents: 'none',
	        strokeDasharray: '5',
	        d: 'M' + x + ',' + top + 'v' + height
	    };
	    return _react2.default.createElement('path', args);
	};

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(135);
	
	var _useScatterGraph = __webpack_require__(138);
	
	var _useScatterGraph2 = _interopRequireDefault(_useScatterGraph);
	
	var _benchmark = __webpack_require__(466);
	
	var _tooltip = __webpack_require__(901);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var ctx = (0, _useScatterGraph2.default)();
	    var colors = ctx.colors,
	        benchmarks = ctx.benchmarks,
	        selectedBenchmarks = ctx.selectedBenchmarks,
	        benchmarksData = ctx.benchmarksData,
	        top5Tickers = ctx.top5Tickers,
	        selectedTop5Tickers = ctx.selectedTop5Tickers,
	        customTickers = ctx.customTickers,
	        selectedCustomTickers = ctx.selectedCustomTickers,
	        tickersData = ctx.tickersData;
	
	
	    var isTop5 = (0, _twd.isEmpty)(customTickers);
	    var items = isTop5 ? top5Tickers : customTickers;
	    var selected = isTop5 ? selectedTop5Tickers : selectedCustomTickers;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            { width: '100%', height: 350 },
	            _react2.default.createElement(
	                _recharts.ScatterChart,
	                {
	                    margin: {
	                        top: 5, right: 40, left: 0, bottom: 5
	                    }
	                },
	                _react2.default.createElement(_recharts.CartesianGrid, { vertical: false }),
	                _react2.default.createElement(_recharts.XAxis, { dataKey: 'x',
	                    type: 'number',
	                    domain: [0, 30],
	                    scale: 'linear',
	                    unit: ' yr',
	                    ticks: [0, 5, 10, 15, 20, 25, 30]
	                }),
	                _react2.default.createElement(_recharts.YAxis, { dataKey: 'y',
	                    domain: [0, function (dataMax) {
	                        return Math.floor(dataMax) + 2;
	                    }],
	                    width: 5,
	                    unit: '.0%',
	                    scale: 'linear',
	                    axisLine: false,
	                    orientation: 'right' }),
	                benchmarks.map(function (a, i) {
	                    return {
	                        label: a,
	                        data: benchmarksData[a] || [],
	                        color: colors[i],
	                        selected: selectedBenchmarks.indexOf(a) >= 0
	                    };
	                }).filter(function (a) {
	                    return a.selected;
	                }).map(function (a, i) {
	                    return _react2.default.createElement(_recharts.Scatter, { key: i,
	                        data: a.data,
	                        dot: true,
	                        shape: _react2.default.createElement(_benchmark.BenchmarkShape, { r: 2, fill: a.color }),
	                        line: { stroke: a.color, strokeWidth: 2 }
	                    });
	                }),
	                items.map(function (a, i) {
	                    return {
	                        label: a,
	                        data: tickersData[a] || [],
	                        color: colors[5 + i],
	                        selected: selected.indexOf(a) >= 0
	                    };
	                }).filter(function (a) {
	                    return a.selected;
	                }).map(function (a, i) {
	                    return _react2.default.createElement(_recharts.Scatter, Object.assign({ key: 5 + i,
	                        data: a.data,
	                        fill: a.color
	                    }, _tooltip2.default));
	                }),
	                _react2.default.createElement(_recharts.Tooltip, {
	                    position: { y: 0 },
	                    offset: 1,
	                    content: _react2.default.createElement(_benchmark.BenchmarkTooltipContent, ctx),
	                    isAnimationActive: false,
	                    cursor: _react2.default.createElement(_benchmark.BenchmarkTooltipCursor, null),
	                    wrapperStyle: { zIndex: 3 }
	                })
	            )
	        )
	    );
	};

/***/ },
/* 895 */
[2040, 896, 897],
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-top: 20px;\n    }\n'], ['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-top: 20px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-left: 5px;\n        margin-top: 23px;\n    }\n'], ['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-left: 5px;\n        margin-top: 23px;\n    }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	var _top = __webpack_require__(898);
	
	var _top2 = _interopRequireDefault(_top);
	
	var _useScatterGraph2 = __webpack_require__(138);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	exports.default = function () {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        customTickers = _useScatterGraph.customTickers,
	        setCustomTickers = _useScatterGraph.setCustomTickers;
	
	    var inputRef = _react2.default.useRef();
	    _react2.default.useEffect(function () {
	        inputRef.current.value = customTickers.join(', ');
	    }, [customTickers]);
	
	    var _React$useState = _react2.default.useState(),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        customError = _React$useState2[0],
	        setCustomError = _React$useState2[1];
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'vertical-offset-xs',
	                style: {
	                    backgroundColor: "#f6f6f6",
	                    padding: "10px"
	                } },
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-7 col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'form-horizontal' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'form-group col-md-6 col-lg-5', style: { marginBottom: 0 } },
	                            (0, _core.jsx)(
	                                'label',
	                                { htmlFor: 'corporates-scatter-graph-top5' },
	                                'Top 5 actively traded issuers'
	                            ),
	                            (0, _core.jsx)(_top2.default, { id: 'corporates-scatter-graph-top5' })
	                        ),
	                        (0, _core.jsx)(
	                            'label',
	                            { className: 'control-label col-md-1 col-lg-1 col-xs-12',
	                                css: labelCss },
	                            'or'
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'form-group col-md-4 col-lg-4' + (customError ? ' has-error' : ''), style: { marginBottom: 0 } },
	                            (0, _core.jsx)(
	                                'label',
	                                { htmlFor: 'corporates-scatter-graph-custom-issuer' },
	                                'Custom issuer'
	                            ),
	                            (0, _core.jsx)('input', {
	                                id: 'corporates-scatter-graph-custom-issuer',
	                                'data-name': 'corporates-scatter-graph-custom-issuer',
	                                ref: inputRef,
	                                type: 'text',
	                                placeholder: 'Symbol',
	                                className: 'form-control',
	                                onBlur: function onBlur(e) {
	                                    setTimeout(function () {
	                                        setCustomError('');
	
	                                        var s = inputRef.current.value;
	                                        var arr = s.split(',').map(function (a) {
	                                            return a.trim();
	                                        }).filter(Boolean);
	
	                                        if (arr.length === 0) {
	                                            if (!(0, _twd.isEmpty)(customTickers)) {
	                                                setCustomTickers([]);
	                                            }
	                                            return;
	                                        }
	
	                                        if (arr.length > 5) {
	                                            setCustomError('Please enter up-to 5 symbols');
	                                            return;
	                                        }
	
	                                        setCustomTickers([].concat(_toConsumableArray(arr)));
	                                    }, 100);
	                                },
	
	                                onKeyPress: function onKeyPress(e) {
	                                    var key = e.key;
	                                    if (!(key === 13 || key === 'Enter')) return;
	                                    e.preventDefault();
	                                    e.currentTarget.blur();
	                                }
	                            }),
	                            (0, _core.jsx)(
	                                'label',
	                                { className: 'field-status' },
	                                customError
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'button',
	                            {
	                                'data-name': 'corporates-scatter-graph-clear-link',
	                                className: 'link-button control-label col-md-1 col-xs-12',
	                                css: clearCss,
	                                onClick: function onClick() {
	                                    setCustomError('');
	
	                                    var e = inputRef.current;
	                                    e.value = '';
	                                    e.focus();
	
	                                    setCustomTickers([]);
	                                }
	                            },
	                            'Clear'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var labelCss = (0, _core.css)(_templateObject, _twd.mediaQueries.xs, _twd.mediaQueries.notXs);
	
	var clearCss = (0, _core.css)(_templateObject2, _twd.mediaQueries.xs, _twd.mediaQueries.notXs);

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useScatterGraph2 = __webpack_require__(138);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	var _circleLabel = __webpack_require__(467);
	
	var _circleLabel2 = _interopRequireDefault(_circleLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        colors = _useScatterGraph.colors,
	        top5Tickers = _useScatterGraph.top5Tickers,
	        selectedTop5Tickers = _useScatterGraph.selectedTop5Tickers,
	        setSelectedTop5Tickers = _useScatterGraph.setSelectedTop5Tickers,
	        customTickers = _useScatterGraph.customTickers,
	        selectedCustomTickers = _useScatterGraph.selectedCustomTickers,
	        setSelectedCustomTickers = _useScatterGraph.setSelectedCustomTickers;
	
	    var isTop5 = (0, _twd.isEmpty)(customTickers);
	    var items = isTop5 ? top5Tickers : customTickers;
	    var selected = isTop5 ? selectedTop5Tickers : selectedCustomTickers;
	    var setSelected = isTop5 ? setSelectedTop5Tickers : setSelectedCustomTickers;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        items.map(function (a, i) {
	            return {
	                label: a,
	                color: colors[5 + i],
	                selected: selected.indexOf(a) >= 0
	            };
	        }).filter(function (a) {
	            return a.selected;
	        }).map(function (a, i) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    'data-name': 'corporates-scatter-graph-tag',
	                    'data-label': a.label,
	                    key: i,
	                    className: 'tag tag-dismissible',
	                    style: {
	                        margin: '1px'
	                    },
	                    onClick: function onClick() {
	                        var n = (0, _twd.arrayToggle)(selected, a.label);
	                        setSelected([].concat(_toConsumableArray(n)));
	                    }
	                },
	                _react2.default.createElement(_circleLabel2.default, { color: a.color, label: a.label })
	            );
	        })
	    );
	};

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useScatterGraph2 = __webpack_require__(138);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	var _circleLabel = __webpack_require__(467);
	
	var _circleLabel2 = _interopRequireDefault(_circleLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled,
	        id = _ref.id;
	
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        colors = _useScatterGraph.colors,
	        top5Tickers = _useScatterGraph.top5Tickers,
	        selectedTop5Tickers = _useScatterGraph.selectedTop5Tickers,
	        setSelectedTop5Tickers = _useScatterGraph.setSelectedTop5Tickers;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Fields.Search,
	            {
	                id: id,
	                dataName: 'corporates-scatter-graph-top5-issuers',
	                placeholder: getPlaceholder(selectedTop5Tickers, "Select"),
	                type: 'select',
	                disabled: disabled,
	                onSelect: function onSelect(a) {
	                    var arr = (0, _twd.arrayToggle)(selectedTop5Tickers, a.label);
	                    setSelectedTop5Tickers([].concat(_toConsumableArray(arr)));
	                }
	            },
	            function () {
	                return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        top5Tickers.map(function (a, i) {
	                            return {
	                                label: a,
	                                color: colors[5 + i],
	                                selected: selectedTop5Tickers.indexOf(a) >= 0
	                            };
	                        }).map(function (a, i) {
	                            return _react2.default.createElement(
	                                _twd.Fields.SearchOption,
	                                {
	                                    dataName: 'corporates-scatter-graph-top5',
	                                    item: a, key: i },
	                                _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                                    dataName: 'corporates-scatter-graph-top5-option',
	                                    checked: a.selected,
	                                    label: _react2.default.createElement(_circleLabel2.default, { color: a.color, label: a.label })
	                                })
	                            );
	                        })
	                    )
	                );
	            }
	        )
	    );
	};
	
	var getPlaceholder = function getPlaceholder(arr, emptyText) {
	    arr = (0, _twd.arrayFrom)(arr);
	    var n = arr.length;
	    if (n === 0) return emptyText;
	
	    return arr[0] + (n > 1 ? ' + ' + (n - 1) + ' selected' : '');
	};

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(161);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useScatterGraph2 = __webpack_require__(138);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	var _twd = __webpack_require__(2);
	
	var _ratingFieldset = __webpack_require__(236);
	
	var _ratingFieldset2 = _interopRequireDefault(_ratingFieldset);
	
	var _chart = __webpack_require__(894);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _table = __webpack_require__(900);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _criteria = __webpack_require__(895);
	
	var _benchmark = __webpack_require__(466);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    return (0, _core.jsx)(
	        _useScatterGraph2.ContextProvider,
	        null,
	        (0, _core.jsx)(Main, null)
	    );
	};
	
	var Main = function Main() {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        rating = _useScatterGraph.rating,
	        setRating = _useScatterGraph.setRating,
	        tickersStatus = _useScatterGraph.tickersStatus,
	        tickerError = _useScatterGraph.tickerError;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'scatter-graph-offering-search', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'corporates-scatter-graph-offering-search', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Scatter Graph Offering Search'
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    (0, _core.jsx)(_ratingFieldset2.default, {
	                        name: 'corporates-scatter-graph-rating',
	                        dataName: 'corporates-scatter-graph-rating',
	                        rating: rating,
	                        setRating: setRating })
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)(_criteria.CriteriaForm, null)
	                )
	            ),
	            (0, _core.jsx)(
	                _twd.Loading,
	                { status: tickersStatus, error: tickerError },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-12', style: { position: 'relative' } },
	                        (0, _core.jsx)(
	                            'figure',
	                            null,
	                            (0, _core.jsx)(
	                                'div',
	                                { 'aria-hidden': 'true' },
	                                (0, _core.jsx)(_chart2.default, null)
	                            ),
	                            (0, _core.jsx)(
	                                'figcaption',
	                                { className: 'screen-reader-only' },
	                                (0, _core.jsx)(_table2.default, null)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { style: { position: 'absolute', top: 0, zIndex: 2 } },
	                            (0, _core.jsx)(_criteria.CriteriaTags, null)
	                        )
	                    )
	                ),
	                (0, _core.jsx)(_benchmark.BenchmarkLegends, null)
	            )
	        )
	    );
	};

/***/ },
/* 900 */
[2041, 138],
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _twd = __webpack_require__(2);
	
	var onMouseOver = function onMouseOver(payload, _, event) {
	
	    (0, _twd.publish)('show_flyout', {
	        el: event.target,
	        showIcon: false,
	        html: _twd.format.IssuerDetail(Object.assign({ from: 'corporates/scatter-graph-offering-search' }, payload))
	    });
	}; /* eslint-disable no-use-before-define */
	exports.default = {
	    onMouseOver: onMouseOver,
	
	    onClick: onMouseOver
	};

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var state = (0, _twd.getState)('corporates.scatter-graph');
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var benchmarks = ['Treasury', 'AAA', 'AA', 'A', 'BBB'];
	
	    var _React$useState3 = _react2.default.useState({}),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        benchmarksData = _React$useState4[0],
	        setBenchmarksData = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(state.value.selectedBenchmarks || benchmarks),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        selectedBenchmarks = _React$useState6[0],
	        setSelectedBenchmarks_ = _React$useState6[1];
	
	    var setSelectedBenchmarks = _react2.default.useCallback(function (a) {
	        state.set({ selectedBenchmarks: a });
	        setSelectedBenchmarks_(a);
	    }, []);
	
	    var lastDataAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, abort, a, m, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref4, k, v, _ret;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	                            if (lastDataAbort.current) lastDataAbort.current();
	
	                            _context.next = 5;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/yieldCurveService/getBenchmarkDataByType',
	                                method: 'POST',
	                                params: {
	                                    bondType: 'CORP',
	                                    marketSnapshotType: 'CORPORATE_BENCHMARK_DATA',
	                                    useCache: true
	                                }
	                            });
	
	                        case 5:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	
	                            lastDataAbort.current = abort;
	                            _context.next = 11;
	                            return data;
	
	                        case 11:
	                            _context.t0 = _context.sent.benchmarkYieldValues;
	
	                            if (_context.t0) {
	                                _context.next = 14;
	                                break;
	                            }
	
	                            _context.t0 = {};
	
	                        case 14:
	                            a = _context.t0;
	
	                            lastDataAbort.current = null;
	
	                            m = {
	                                'Treas': 'Treasury',
	                                'CorpAAA': 'AAA',
	                                'CorpAA': 'AA',
	                                'CorpA': 'A',
	                                'CorpBBB': 'BBB'
	                            };
	
	                            _loop = function _loop(k, v) {
	
	                                var n = m[k];
	                                if (!n) return 'continue';
	
	                                a[n] = (0, _twd.arrayFrom)(v).map(function (i) {
	                                    i.benchmark = n;
	                                    i.x = i.maturityYearValue;
	                                    i.y = i.yieldValue;
	                                    return i;
	                                }).filter(function (a) {
	                                    return a.x <= 30;
	                                });
	                            };
	
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context.prev = 21;
	                            _iterator = Object.entries(a)[Symbol.iterator]();
	
	                        case 23:
	                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                _context.next = 34;
	                                break;
	                            }
	
	                            _ref3 = _step.value;
	                            _ref4 = _slicedToArray(_ref3, 2);
	                            k = _ref4[0];
	                            v = _ref4[1];
	                            _ret = _loop(k, v);
	
	                            if (!(_ret === 'continue')) {
	                                _context.next = 31;
	                                break;
	                            }
	
	                            return _context.abrupt('continue', 31);
	
	                        case 31:
	                            _iteratorNormalCompletion = true;
	                            _context.next = 23;
	                            break;
	
	                        case 34:
	                            _context.next = 40;
	                            break;
	
	                        case 36:
	                            _context.prev = 36;
	                            _context.t1 = _context['catch'](21);
	                            _didIteratorError = true;
	                            _iteratorError = _context.t1;
	
	                        case 40:
	                            _context.prev = 40;
	                            _context.prev = 41;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 43:
	                            _context.prev = 43;
	
	                            if (!_didIteratorError) {
	                                _context.next = 46;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 46:
	                            return _context.finish(43);
	
	                        case 47:
	                            return _context.finish(40);
	
	                        case 48:
	                            setBenchmarksData(a);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 56;
	                            break;
	
	                        case 52:
	                            _context.prev = 52;
	                            _context.t2 = _context['catch'](0);
	
	                            if (lastDataAbort.current) lastDataAbort.current();
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 56:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 52], [21, 36, 40, 48], [41,, 43, 47]]);
	        }))();
	
	        return function () {
	            if (lastDataAbort.current) lastDataAbort.current();
	        };
	    }, []);
	
	    return {
	        benchmarks: benchmarks,
	        benchmarksStatus: status,
	        benchmarksData: benchmarksData,
	        selectedBenchmarks: selectedBenchmarks,
	        setSelectedBenchmarks: setSelectedBenchmarks
	    };
	};

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var NO_RESULT = '\n    <div class="text-center text-body">' + _twd.NO_RESULT_ICON_HTML + '\n    <br/>\n    <h4 class="small-header">No offerings available</h4>\n    No offerings align with your search criteria. Please try an alternate search.\n    </div>\n';
	
	exports.default = function (_ref) {
	    var rating = _ref.rating;
	
	
	    var state = (0, _twd.getState)('corporates.scatter-graph');
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(''),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        error = _React$useState4[0],
	        setError = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState({}),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        tickersData = _React$useState6[0],
	        setTickersData = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(state.value.top5Tickers || []),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        top5Tickers = _React$useState8[0],
	        setTop5Tickers_ = _React$useState8[1];
	
	    var setTop5Tickers = _react2.default.useCallback(function (a) {
	        state.set({ top5Tickers: a });
	        setTop5Tickers_(a);
	    }, []);
	
	    var _React$useState9 = _react2.default.useState(state.value.selectedTop5Tickers || []),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        selectedTop5Tickers = _React$useState10[0],
	        setSelectedTop5Tickers_ = _React$useState10[1];
	
	    var setSelectedTop5Tickers = _react2.default.useCallback(function (a) {
	        state.set({ selectedTop5Tickers: a });
	        setSelectedTop5Tickers_(a);
	    }, []);
	
	    var _React$useState11 = _react2.default.useState(state.value.customTickers || []),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        customTickers = _React$useState12[0],
	        setCustomTickers_ = _React$useState12[1];
	
	    var setCustomTickers = _react2.default.useCallback(function (a) {
	        state.set({ customTickers: a });
	        setCustomTickers_(a);
	        setSelectedTop5Tickers([]);
	    }, []);
	
	    var _React$useState13 = _react2.default.useState(state.value.customTickers || []),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        selectedCustomTickers = _React$useState14[0],
	        setSelectedCustomTickers_ = _React$useState14[1];
	
	    var setSelectedCustomTickers = _react2.default.useCallback(function (a) {
	        state.set({ selectedCustomTickers: a });
	        setSelectedCustomTickers_(a);
	    }, []);
	
	    var lastDataAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        ;_asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var _ret;
	
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            return _context2.delegateYield(_regenerator2.default.mark(function _callee() {
	                                var isIG, mktType, isCustom, _ref3, data, abort, a, ks, ds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref4, _ref5, k, v, n;
	
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                        switch (_context.prev = _context.next) {
	                                            case 0:
	                                                setError('');
	                                                setStatus(_twd.Status.LOADING);
	                                                if (lastDataAbort.current) lastDataAbort.current();
	
	                                                isIG = rating === 'INVESTMENT_GRADE';
	                                                mktType = isIG ? 'CORP_IG_SCATTER_GRAPH_DATA' : 'CORP_HY_SCATTER_GRAPH_DATA';
	                                                isCustom = !(0, _twd.isEmpty)(customTickers);
	                                                _context.next = 8;
	                                                return (0, _twd.ajax)({
	                                                    url: '/esb/retailservice/yieldCurveService/getScatterGraphOfferingSearchData',
	                                                    method: 'POST',
	                                                    params: Object.assign({
	                                                        bondType: 'CORP',
	                                                        marketSnapshotType: mktType,
	                                                        maxYield: 20
	                                                    }, isCustom ? { symbols: customTickers } : {})
	                                                });
	
	                                            case 8:
	                                                _ref3 = _context.sent;
	                                                data = _ref3.data;
	                                                abort = _ref3.abort;
	
	
	                                                lastDataAbort.current = abort;
	                                                _context.next = 14;
	                                                return data;
	
	                                            case 14:
	                                                _context.t1 = _context.sent.topIssuerBondsDto;
	
	                                                if (_context.t1) {
	                                                    _context.next = 17;
	                                                    break;
	                                                }
	
	                                                _context.t1 = {};
	
	                                            case 17:
	                                                _context.t0 = _context.t1.topBondYieldValues;
	
	                                                if (_context.t0) {
	                                                    _context.next = 20;
	                                                    break;
	                                                }
	
	                                                _context.t0 = {};
	
	                                            case 20:
	                                                a = _context.t0;
	
	                                                lastDataAbort.current = null;
	
	                                                ks = [];
	                                                ds = {};
	                                                _iteratorNormalCompletion = true;
	                                                _didIteratorError = false;
	                                                _iteratorError = undefined;
	                                                _context.prev = 27;
	
	                                                for (_iterator = Object.entries(a)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                                    _ref4 = _step.value;
	                                                    _ref5 = _slicedToArray(_ref4, 2);
	                                                    k = _ref5[0];
	                                                    v = _ref5[1];
	
	                                                    ks.push(k);
	                                                    ds[k] = (0, _twd.arrayFrom)(v).filter(function (i) {
	                                                        return i.yieldValue >= 0.0;
	                                                    }).map(function (i) {
	                                                        var r = i.scatterOfferRow;
	                                                        r.x = i.maturityYearValue;
	                                                        r.y = i.yieldValue;
	                                                        r.maturityYearValue = i.maturityYearValue;
	                                                        r.yieldValue = i.yieldValue;
	                                                        r.rating = isIG ? 'Investment Grade' : 'High Yield';
	                                                        return r;
	                                                    }).filter(function (a) {
	                                                        return a.x <= 30;
	                                                    });
	                                                }
	
	                                                _context.next = 35;
	                                                break;
	
	                                            case 31:
	                                                _context.prev = 31;
	                                                _context.t2 = _context['catch'](27);
	                                                _didIteratorError = true;
	                                                _iteratorError = _context.t2;
	
	                                            case 35:
	                                                _context.prev = 35;
	                                                _context.prev = 36;
	
	                                                if (!_iteratorNormalCompletion && _iterator.return) {
	                                                    _iterator.return();
	                                                }
	
	                                            case 38:
	                                                _context.prev = 38;
	
	                                                if (!_didIteratorError) {
	                                                    _context.next = 41;
	                                                    break;
	                                                }
	
	                                                throw _iteratorError;
	
	                                            case 41:
	                                                return _context.finish(38);
	
	                                            case 42:
	                                                return _context.finish(35);
	
	                                            case 43:
	                                                if (!isCustom) {
	                                                    setTop5Tickers([].concat(ks));
	                                                    setSelectedTop5Tickers([].concat(ks));
	                                                } else {
	                                                    setSelectedCustomTickers([].concat(ks));
	                                                }
	
	                                                setTickersData(ds);
	
	                                                n = Object.values(ds).reduce(function (n, a) {
	                                                    return n + a.length;
	                                                }, 0);
	
	                                                if (!(n === 0 && isCustom)) {
	                                                    _context.next = 50;
	                                                    break;
	                                                }
	
	                                                setError(NO_RESULT);
	                                                setStatus(_twd.Status.UNAVAILABLE);
	                                                return _context.abrupt('return', {
	                                                    v: void 0
	                                                });
	
	                                            case 50:
	
	                                                setStatus(_twd.Status.LOADED);
	
	                                            case 51:
	                                            case 'end':
	                                                return _context.stop();
	                                        }
	                                    }
	                                }, _callee, undefined, [[27, 31, 35, 43], [36,, 38, 42]]);
	                            })(), 't0', 2);
	
	                        case 2:
	                            _ret = _context2.t0;
	
	                            if (!((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object")) {
	                                _context2.next = 5;
	                                break;
	                            }
	
	                            return _context2.abrupt('return', _ret.v);
	
	                        case 5:
	                            _context2.next = 11;
	                            break;
	
	                        case 7:
	                            _context2.prev = 7;
	                            _context2.t1 = _context2['catch'](0);
	
	                            if (lastDataAbort.current) lastDataAbort.current();
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 11:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 7]]);
	        }))();
	
	        return function () {
	            if (lastDataAbort.current) lastDataAbort.current();
	        };
	    }, [rating, customTickers]);
	
	    return {
	        tickersData: tickersData,
	        tickersStatus: status,
	        tickerError: error,
	
	        top5Tickers: top5Tickers,
	        selectedTop5Tickers: selectedTop5Tickers, setSelectedTop5Tickers: setSelectedTop5Tickers,
	
	        customTickers: customTickers, setCustomTickers: setCustomTickers,
	        selectedCustomTickers: selectedCustomTickers, setSelectedCustomTickers: setSelectedCustomTickers
	    };
	};

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(161);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useSectorActivity2 = __webpack_require__(906);
	
	var _useSectorActivity3 = _interopRequireDefault(_useSectorActivity2);
	
	var _sectorRankings = __webpack_require__(905);
	
	var _sectorRankings2 = _interopRequireDefault(_sectorRankings);
	
	var _ratingFieldset = __webpack_require__(236);
	
	var _ratingFieldset2 = _interopRequireDefault(_ratingFieldset);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useSectorActivity = (0, _useSectorActivity3.default)(),
	        rating = _useSectorActivity.rating,
	        _setRating = _useSectorActivity.setRating,
	        maturity = _useSectorActivity.maturity,
	        setMaturity = _useSectorActivity.setMaturity,
	        sectors = _useSectorActivity.sectors,
	        status = _useSectorActivity.status,
	        total = _useSectorActivity.total;
	
	    var _React$useState = _react2.default.useState(1),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        page = _React$useState2[0],
	        setPage = _React$useState2[1];
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'sector-activity-search', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'corporate-sector-activity', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Sector Activity Search'
	                    ),
	                    'There were ',
	                    _twd.fmt.count(total),
	                    ' TRACE-reportable corporate bond trades in the last trading day. Search offerings from the top three issuers, within the prior session\'s most active sectors.'
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'container', style: { backgroundColor: "#f6f6f6" } },
	                        (0, _core.jsx)('div', { className: 'row vertical-offset-xs' }),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'row' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                (0, _core.jsx)(_ratingFieldset2.default, {
	                                    name: 'corporates-market-top-sectors-rating',
	                                    dataName: 'corporates-market-top-sectors-rating',
	                                    align: 'left',
	                                    rating: rating,
	                                    setRating: function setRating(r) {
	                                        _setRating(r);
	                                        setPage(1);
	                                    }
	                                })
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'row' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'col-md-12 col-xs-12' },
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'form-group', style: { marginBottom: '10px' } },
	                                    (0, _core.jsx)(
	                                        'div',
	                                        { className: 'vertical-offset-xxs' },
	                                        'Select maturity range'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'div',
	                                        { className: 'select-wrapper' },
	                                        (0, _core.jsx)(
	                                            'select',
	                                            {
	                                                id: 'corporates-top-sectors-maturity-range',
	                                                'data-name': 'corporates-top-sectors-maturity-range',
	                                                className: 'form-control',
	                                                value: maturity,
	                                                onChange: function onChange(e) {
	                                                    setMaturity(e.target.value);
	                                                    setPage(1);
	                                                } },
	                                            (0, _core.jsx)(
	                                                'option',
	                                                { value: 'LT_3' },
	                                                'Shorter term (<3 years)'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'option',
	                                                { value: '3_TO_5' },
	                                                'Shorter term (3-5 years)'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'option',
	                                                { value: '5_TO_10' },
	                                                'Medium term (5-10 years)'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'option',
	                                                { value: '10_TO_20' },
	                                                'Longer term (10-20 years)'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'option',
	                                                { value: 'GT_20' },
	                                                'Longer term (>20 years)'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                _twd.Loading,
	                { status: status },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'equally-spaced' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'small-header' },
	                        'Total trades in the last trading day:'
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'small-header text-right' },
	                        _twd.fmt.count(total)
	                    )
	                ),
	                (0, _core.jsx)(_sectorRankings2.default, {
	                    sectors: sectors,
	                    page: page,
	                    total: total,
	                    maturity: maturity })
	            ),
	            (0, _core.jsx)('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xs' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12 col-sm-8' },
	                    (0, _core.jsx)(_twd.Paging, {
	                        dataName: 'corporates-top-sectors-paging',
	                        total: sectors.length,
	                        page: page,
	                        setPage: setPage,
	                        size: 3 })
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12 col-sm-4 text-right' },
	                    (0, _core.jsx)(_twd.Disclosures, {
	                        dataName: 'corporates-top-sectors-disclosures-link',
	                        html: DISCLOSURES })
	                )
	            )
	        )
	    );
	};
	
	var DISCLOSURES = '\n<p>\nThe advanced screening functionality within the Bond Resource Center enables users\nto filter corporate bond offerings across 12 unique industry sectors.\nThe Sector Activity Search tool helps users identify and search offerings\nfrom issuers within each corporate sector.\nThe sectors are ranked in descending order by number of trades based on TRACE-reported\ncorporate bond trade data from the previous trading day.\nEach sector will display the number of trades from the previous day and the percentage\nof total trades they comprise. The total number of trades is an aggregate value of\nall sectors\u2019 trades from the previous day.\n<p>\n\n<p>\nEach sector listing will display the three top-traded issuers within each corresponding sector.\nUsers can curate a list of bond offers using this tool in two easy steps. To begin your search,\nfirst choose your time horizon. The maturity dropdown filter at the top of the module will\ndefault to shorter-term offerings (within three years), but you may want to select an alternate\nmaturity range aligned with your requirements. Finally, click an issuer name within a sector\nlisting to generate a search results page with offerings meeting your criteria.\n<p>\n\n<p class="text-small">\n*Sector categories may include: Basic Materials, Consumer Goods, Consumer Services,\nFinancials, Healthcare, Industrials, Oil and Gas, Other, Technology, Telecommunications,\nTransportation, and Utilities.\n</p>\n';

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _tagCss, _paddingCss;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        sectors = _ref.sectors,
	        total = _ref.total,
	        maturity = _ref.maturity,
	        _ref$page = _ref.page,
	        page = _ref$page === undefined ? 1 : _ref$page;
	
	    var size = 3;
	    var n = Math.max((page - 1) * size, 0);
	    return sectors.slice(n, n + size).map(function (s, i) {
	        return (0, _core.jsx)(Sector, Object.assign({}, s, { index: n + i + 1, key: i, totalTrades: total, maturity: maturity }));
	    });
	};
	
	var Sector = function Sector() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        label = _ref2.label,
	        total = _ref2.total,
	        maturity = _ref2.maturity,
	        index = _ref2.index,
	        _ref2$issuers = _ref2.issuers,
	        issuers = _ref2$issuers === undefined ? [] : _ref2$issuers,
	        totalTrades = _ref2.totalTrades;
	
	    var pct = Math.round(total / Math.max(totalTrades, 1) * 100);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)('hr', { 'aria-hidden': 'true', className: 'vertical-offset-xxs' }),
	                (0, _core.jsx)(
	                    'label',
	                    { className: 'medium-header', style: { margin: 0 } },
	                    index,
	                    '. ',
	                    label,
	                    ': ',
	                    _all.format.count(total)
	                ),
	                (0, _core.jsx)(
	                    'label',
	                    { className: 'tiny-header' },
	                    '\xA0 (',
	                    pct,
	                    '% of total)'
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12 text-center', css: paddingCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'progress',
	                        style: { position: 'relative', height: '10px', backgroundColor: '#e4e4e4' } },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'progress-bar',
	                            style: { width: pct + "%", backgroundColor: 'green' }
	                        },
	                        (0, _core.jsx)('span', { className: 'sr-only' })
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xxs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12', css: paddingCss },
	                (0, _core.jsx)(
	                    'div',
	                    null,
	                    (0, _core.jsx)(
	                        'label',
	                        { className: 'label-small' },
	                        'Select issuer to view offerings:'
	                    )
	                ),
	                issuers.map(function (_ref3, key) {
	                    var name = _ref3.name,
	                        symbol = _ref3.symbol;
	
	                    return (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'corporates-sector-activity-tag',
	                            key: key,
	                            className: 'tag text-truncate',
	                            css: tagCss,
	                            onClick: function onClick(e) {
	                                var p = {
	                                    view: 'offerings-modal',
	                                    name: name,
	                                    maturity: maturity,
	                                    params: {
	                                        persistToPreviousSearches: false,
	                                        holdInvType: ['C'],
	                                        holdSymbol: [symbol]
	                                    },
	                                    from: 'corporates',
	                                    source: e.target
	                                };
	                                (0, _all.showModal)(p);
	                            } },
	                        name
	                    );
	                })
	            )
	        )
	    );
	};
	
	var tagCss = (_tagCss = {}, _defineProperty(_tagCss, _all.mediaQueries.notXs, {
	    maxWidth: '40%',
	    margin: 0,
	    marginRight: '5px'
	}), _defineProperty(_tagCss, _all.mediaQueries.xs, {
	    maxWidth: '130px'
	}), _tagCss);
	
	var paddingCss = (_paddingCss = {}, _defineProperty(_paddingCss, _all.mediaQueries.notXs, {
	    paddingLeft: '30px'
	}), _defineProperty(_paddingCss, _all.mediaQueries.xs, {}), _paddingCss);

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('corporates.top-sectors', {
	    rating: 'INVESTMENT_GRADE',
	    maturity: 'LT_3'
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.rating || 'INVESTMENT_GRADE'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        rating = _React$useState2[0],
	        setRating_ = _React$useState2[1];
	
	    var setRating = _react2.default.useCallback(function (m) {
	        state.set({ rating: m });
	        setRating_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(state.value.maturity || 'LT_3'),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        maturity = _React$useState4[0],
	        setMaturity_ = _React$useState4[1];
	
	    var setMaturity = _react2.default.useCallback(function (m) {
	        state.set({ maturity: m });
	        setMaturity_(m);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        sectors = _React$useState6[0],
	        setSectors = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        status = _React$useState8[0],
	        setStatus = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(0),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        total = _React$useState10[0],
	        setTotal = _React$useState10[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        setTotal(null);
	        setSectors([]);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, abort, a, rs, r;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            setStatus(_twd.Status.LOADING);
	                            _context.next = 5;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/topMovingSectorService/getTopMovingSectorsData',
	                                method: 'POST',
	                                params: {
	                                    assetType: 'CORP',
	                                    rating: rating === 'INVESTMENT_GRADE' ? 'IG' : 'HY',
	                                    maturityRange: maturityRangeMap[maturity],
	                                    numberOfIssuers: 3
	                                }
	                            });
	
	                        case 5:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	                            lastAbort.current = abort;
	                            _context.next = 11;
	                            return data;
	
	                        case 11:
	                            a = _context.sent;
	
	                            lastAbort.current = null;
	
	                            rs = (0, _twd.arrayFrom)(a.topMovingSectors).filter(function (t) {
	                                return t.sector;
	                            }).map(function (t) {
	                                return {
	                                    label: _twd.CORP_SECTOR_LABELS[t.sector] || t.sector,
	                                    total: t.tradeCount,
	                                    totalTradeCount: t.totalTradesCount,
	                                    issuers: (0, _twd.arrayFrom)(t.topMovingIssuerLists).map(function (a) {
	                                        return {
	                                            name: a.issuer,
	                                            symbol: a.symbol
	                                        };
	                                    })
	                                };
	                            });
	                            r = rs[0];
	
	                            setTotal(r && r.totalTradeCount);
	                            setSectors(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 24;
	                            break;
	
	                        case 20:
	                            _context.prev = 20;
	                            _context.t0 = _context['catch'](0);
	
	                            setTotal(null);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 24:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 20]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	        };
	    }, [rating, maturity]);
	
	    return {
	        rating: rating, setRating: setRating,
	        maturity: maturity, setMaturity: setMaturity,
	        status: status,
	        sectors: sectors, total: total };
	};
	
	var maturityRangeMap = {
	    'LT_3': '0Y-3Y',
	    '3_TO_5': '3Y-5Y',
	    '5_TO_10': '5Y-10Y',
	    '10_TO_20': '10Y-20Y',
	    'GT_20': '20Y+'
	};

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        index = _ref.index,
	        table = _ref.table,
	        rating = _ref.rating;
	
	    var t = index === 0 ? data.displayName : formatYield(data.yield);
	
	    var _React$useState = _react2.default.useState(t),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        text = _React$useState2[0],
	        setText = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(data.id),
	        _React$useState4 = _slicedToArray(_React$useState3, 1),
	        cellId = _React$useState4[0];
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('yield_bucket.yield_grid_' + cellId, function (_ref2) {
	            var id = _ref2.id,
	                value = _ref2.value;
	
	            return id === cellId && setText(formatYield(value));
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var q = data.queryText;
	    if (!q) return text;
	
	    if (text === '-') return text;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'corporates-yield-grid-cell',
	            'data-cell-id': cellId,
	            'data-rating': rating,
	            'data-table': table,
	            'data-row': data.headerName,
	            'data-column': data.colName,
	            onClick: function onClick() {
	                return onSearch((0, _twd.parseJson)(q));
	            },
	            className: 'link-button text-left' },
	        text
	    );
	};
	
	var formatYield = function formatYield(x) {
	    var a = parseFloat(x);
	    if (isNaN(a)) return '-';
	
	    var s = a.toFixed(3);
	    if (s === '0.000') return '-';
	    return s + '%';
	};
	
	var onSearch = function onSearch(p) {
	    if (!p) return;
	    Object.assign(p, {
	        respectSplitRating: true,
	        persistToPreviousSearches: false,
	        sort: [{ field: 'askYield', direction: 'DESC' }]
	    });
	    delete p['savedQuickPickId'];
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: p,
	        _ts: Date.now(),
	        from: 'corporates'
	    }));
	};

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var s = (0, _twd.yieldGridLastUpdated)();
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-8' },
	            s ? s + ' \xA0 | \xA0 ' : '',
	            'Yields update as prices change, and may be delayed.  Please see disclosures.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-4 text-right' },
	            _react2.default.createElement(_twd.Disclosures, {
	                dataName: 'corporates-yield-grid-disclosures-link',
	                html: DISCLOSURES
	            })
	        )
	    );
	};
	
	var DISCLOSURES = '\n    <p>\n    The Yield by Category table can be sorted by highest or average yield.\n    By default, the table is configured to display the highest available yield on\n    the Tradeweb dealer network aligned with each asset class and maturity.\n    To view the average yield amongst available offers for a given asset class and maturity,\n    simply click the "Average Yield" toggle above the table.\n    </p>\n    <p>\n    The yield values displayed represent the existence of a minimum of 10 bonds ($1,000 face value)\n    available at the respective credit ratings (as designated by Moody\'s or S&P) for which the ask price\n    is between 85 and 120, excluding zero-coupon bonds (US Treasury Zeroes).\n    </p>\n    <p>\n    Yields displayed within the grid will update in response to changes in available offerings and offering prices.\n    These yields will update as offer pricing changes throughout the trading day and may be delayed.\n    </p>';

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('corporates.yield-grids', {
	    method: 'HIGHEST',
	    rating: 'INVESTMENT_GRADE'
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.method || 'HIGHEST'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        method = _React$useState2[0],
	        setMethod_ = _React$useState2[1];
	
	    var setMethod = _react2.default.useCallback(function (m) {
	        state.set({ method: m });
	        setMethod_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(state.value.rating || 'INVESTMENT_GRADE'),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        rating = _React$useState4[0],
	        setRating_ = _React$useState4[1];
	
	    var setRating = _react2.default.useCallback(function (m) {
	        state.set({ rating: m });
	        setRating_(m);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        grids = _React$useState6[0],
	        setGrids = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        status = _React$useState8[0],
	        setStatus = _React$useState8[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    var _React$useState9 = _react2.default.useState(Date.now()),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        ts = _React$useState10[0],
	        setTs = _React$useState10[1];
	
	    _react2.default.useEffect(function () {
	
	        setGrids([]);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var gridType, _ref2, data, abort, x, t, r, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	
	                            gridType = rating === 'INVESTMENT_GRADE' ? 'CORPORATES_INVESTMENT_GRADE' : 'CORPORATES_HIGH_YIELD';
	                            _context.next = 5;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/yieldGridService/getYieldGridDataByType',
	                                method: 'POST',
	                                params: {
	                                    brand: 'etrade' || (0, _twd.getBrand)(),
	                                    yieldGridTypeList: [{
	                                        gridType: gridType,
	                                        yieldType: method
	                                    }]
	                                }
	                            });
	
	                        case 5:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 11;
	                            return data;
	
	                        case 11:
	                            x = _context.sent;
	
	                            lastAbort.current = null;
	
	                            t = method === 'HIGHEST' ? 'Highest Yield' : 'Average Yield';
	                            r = rating === 'INVESTMENT_GRADE' ? 'Investment Grade' : 'High Yield';
	                            rs = (0, _twd.arrayFrom)(x[0].tables).map(function (a) {
	                                return Object.assign(a, { table: t, rating: r });
	                            });
	
	                            setGrids(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 24;
	                            break;
	
	                        case 20:
	                            _context.prev = 20;
	                            _context.t0 = _context['catch'](0);
	
	                            if (lastAbort.current) lastAbort.current();
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 24:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 20]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) lastAbort.current();
	        };
	    }, [method, rating, ts]);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('atmosphere_reconnected.corporates_yield_grids', function (_ref3) {
	            var ts = _ref3.ts;
	
	            setTs(ts);
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    return { method: method, setMethod: setMethod, rating: rating, setRating: setRating, grids: grids, status: status };
	};

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useYieldGrids = __webpack_require__(909);
	
	var _useYieldGrids2 = _interopRequireDefault(_useYieldGrids);
	
	var _twd = __webpack_require__(2);
	
	var _footer = __webpack_require__(908);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _cell = __webpack_require__(907);
	
	var _cell2 = _interopRequireDefault(_cell);
	
	var _ratingFieldset = __webpack_require__(236);
	
	var _ratingFieldset2 = _interopRequireDefault(_ratingFieldset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useYieldGrid = (0, _useYieldGrids2.default)(),
	        method = _useYieldGrid.method,
	        setMethod = _useYieldGrid.setMethod,
	        rating = _useYieldGrid.rating,
	        setRating = _useYieldGrid.setRating,
	        grids = _useYieldGrid.grids,
	        status = _useYieldGrid.status;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { 'data-name': 'corporates-yield-grid', style: { background: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                'data-name': 'corporates-yield-grid-nav-tabs',
	                                className: 'nav-tabs' },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: method === 'HIGHEST' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'corporates-yield-grid-highest-yield-nav-tab',
	                                            onClick: function onClick() {
	                                                return setMethod('HIGHEST');
	                                            } },
	                                        'Highest Yield'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: method === 'AVERAGE_10' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'corporates-yield-grid-average-yield-nav-tab',
	                                            onClick: function onClick() {
	                                                return setMethod('AVERAGE_10');
	                                            } },
	                                        'Average Yield'
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 col-xs-12' },
	                        _react2.default.createElement(_ratingFieldset2.default, {
	                            name: 'corporates-yield-grid-rating',
	                            dataName: 'corporates-yield-grid-rating',
	                            rating: rating, setRating: setRating })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _twd.Loading,
	                { status: status },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Grids, { grids: grids }),
	                            _react2.default.createElement(_footer2.default, { grids: grids })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Grids = function Grids(_ref) {
	    var grids = _ref.grids;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        grids && grids.map(function (g, i) {
	            return _react2.default.createElement(Grid, { key: i, grid: g, index: i });
	        })
	    );
	};
	
	var Grid = function Grid(_ref2) {
	    var grid = _ref2.grid,
	        index = _ref2.index;
	
	    var w = (83.34 / (grid.columns.length - 1)).toFixed(2) + '%';
	
	    var rs = (grid.rows && [].concat(_toConsumableArray(grid.rows)) || []).map(function (r) {
	        return Object.assign(r, { table: grid.table, rating: grid.rating });
	    });
	    rs.shift();
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            { 'data-name': 'corporates-yield-grid-table-' + index, className: 'table' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    grid.columns && grid.columns.map(function (c, i) {
	                        return _react2.default.createElement(
	                            'th',
	                            { key: i,
	                                width: i === 0 ? '16.66%' : w,
	                                className: i === 0 ? 'text-left' : 'text-right' },
	                            i === 0 ? _react2.default.createElement(
	                                'h6',
	                                { className: 'subhead', style: { marginBottom: 0 } },
	                                c
	                            ) : c
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rs && rs.map(function (r, i) {
	                    return _react2.default.createElement(Row, { key: i, row: r });
	                })
	            )
	        )
	    );
	};
	
	var Row = function Row(_ref3) {
	    var row = _ref3.row;
	
	    return _react2.default.createElement(
	        'tr',
	        { 'data-name': 'corporates-yield-grid-row' },
	        row.row && row.row.map(function (a, i) {
	            return _react2.default.createElement(
	                'td',
	                { key: i,
	                    className: i === 0 ? 'text-left' : 'text-right' },
	                _react2.default.createElement(_cell2.default, { data: a, index: i, table: row.table, rating: row.rating })
	            );
	        })
	    );
	};

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(915);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _managing = __webpack_require__(912);
	
	var _managing2 = _interopRequireDefault(_managing);
	
	var _terms = __webpack_require__(916);
	
	var _terms2 = _interopRequireDefault(_terms);
	
	var _trading = __webpack_require__(917);
	
	var _trading2 = _interopRequireDefault(_trading);
	
	var _searching = __webpack_require__(913);
	
	var _searching2 = _interopRequireDefault(_searching);
	
	var _starting = __webpack_require__(914);
	
	var _starting2 = _interopRequireDefault(_starting);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('faq', {
	    tab: 'terms'
	});
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$view = _ref.view,
	        view = _ref$view === undefined ? '' : _ref$view;
	
	    (0, _twd.trackPage)('faq');
	
	    var t = view.split('.')[1] || '';
	
	    var _React$useState = _react2.default.useState(t || state.value.tab || 'terms'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tab = _React$useState2[0],
	        setTab_ = _React$useState2[1];
	
	    var setTab = _react2.default.useCallback(function (m) {
	        state.set({ tab: m });
	        setTab_(m);
	    }, []);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)(
	                'h3',
	                { className: 'medium-header', style: { marginBottom: '0px' } },
	                'Frequently asked questions'
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12 vertical-offset-sm' },
	                    (0, _core.jsx)(
	                        'div',
	                        {
	                            'data-name': 'faq-nav-tabs',
	                            className: 'nav-tabs' },
	                        (0, _core.jsx)(
	                            'ul',
	                            null,
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'terms' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'faq-common-bond-terms-to-know',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('terms');
	                                        } },
	                                    'Common bond terms to know'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'starting' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'faq-getting-started',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('starting');
	                                        } },
	                                    'Getting Started: Bond Fundamentals'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'trading' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'faq-trading-bonds-at-etrade',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('trading');
	                                        } },
	                                    'Trading Bonds at E*TRADE'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'searching' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'faq-searching-for-bonds',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('searching');
	                                        } },
	                                    'Searching for bonds'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'managing' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'faq-managing-bond-holding',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('managing');
	                                        } },
	                                    'Managing bond holdings'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)('div', { className: 'col-md-2 col-xs-1' }),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-8 col-xs-10' },
	                    tab === 'terms' && (0, _core.jsx)(_terms2.default, null),
	                    tab === 'starting' && (0, _core.jsx)(_starting2.default, null),
	                    tab === 'trading' && (0, _core.jsx)(_trading2.default, null),
	                    tab === 'searching' && (0, _core.jsx)(_searching2.default, null),
	                    tab === 'managing' && (0, _core.jsx)(_managing2.default, null)
	                ),
	                (0, _core.jsx)('div', { className: 'col-md-2 col-xs-1' })
	            )
	        )
	    );
	};

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h2',
	            { className: 'large-header vertical-offset-sm' },
	            'Managing bond holdings'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How can I analyze and monitor my bond holdings? '
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'E*TRADE provides online portfolio tools that allow you to review your bond portfolio and that of your linked accounts. '
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-sm' },
	                    'The ',
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                                return (0, _twd.show)('portfolio-report');
	                            } },
	                        'Bond Portfolio Report'
	                    ),
	                    ' is a downloadable file on the Bond Resource Center providing quick access to an in-depth analysis of your bond holdings. The online report includes important information about your bond holdings such as a snapshot of your complete portfolio, individual position details, expected cash flow, maturity and duration exposure, credit quality distribution, and more. To review and analyze your bond holdings:'
	                ),
	                _react2.default.createElement(
	                    'ol',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Visit the Overview Tab of the Bond Resource Center.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Click the ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                                    return (0, _twd.show)('portfolio-report');
	                                } },
	                            'Bond Portfolio Report'
	                        ),
	                        ' link within the Tools tab.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Select the account(s) you would like to analyze and click View Report to generate an analysis of the fixed- income securities in your account(s).'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'When will I receive interest payments for my bond?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'There are several ways you can monitor when you will receive interest payments for your bond. Within the E*TRADE Portfolios page, click the Issuer name for a bond to load the Bond Description page. Under the Issuer Information section, you will see the first, last, and next coupon date, along with coupon frequency. The Estimated Income tool within the Portfolios Page also displays your expected monthly income in a table and graph view.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Alternatively, you can find this information by downloading a ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.show)('portfolio-report');
	                        } },
	                    'Bond Portfolio Report'
	                ),
	                ' within the Bond Resource Center. This report also breaks down your coupon cash flow.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'What happens when my bond matures?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'When your bond matures, you will receive an alert notifying you that your bond has been redeemed for cash. Cash typically settles in your account on the same day as the bond\u2019s maturity or when principal is received from the issuer.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How do I sign up for bond alerts?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'All E*TRADE clients automatically receive material event alerts associated with their active bond positions. If you\u2019re interested in receiving notifications for new issue bond offerings, please sign up ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)("https://us.etrade.com/e/t/alerts/setnewissuealerts");
	                        } },
	                    'here'
	                ),
	                '.  '
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'What is an evaluated price?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'The Last Price value displayed for your bond on the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)("https://us.etrade.com/etx/pw/portfolios?ploc=2017-nav-Accounts#/portfolios/0/positions");
	                        } },
	                    'Portfolios Page'
	                ),
	                ' is a daily end-of-day evaluated price. This is an estimated price for the bond based on numerous factors and not necessarily reflective of live market conditions. The evaluated price should not be considered a price for which the bond can currently be bought or sold. Investors will need to request an offer or bid for the bond they wish to buy or sell.'
	            )
	        )
	    );
	};

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h2',
	            { className: 'large-header vertical-offset-sm' },
	            'Searching for bonds'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'What criteria are important to consider when searching for a bond?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-sm' },
	                    'It\u2019s important to carefully consider your financial situation, specific investment objectives, and risk tolerance before making any investment decision. When researching a suitable bond investment, investors often consider a wide range of criteria to aid in their analysis. This list is not exhaustive, but here are some common criteria bond investors evaluate:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Bond type'
	                        ),
	                        ': Different bond types have different characteristics, benefits and risks. Make sure you understand the terms and features of the bond you\u2019re reviewing.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Credit rating'
	                        ),
	                        ': Consider the level of risk you\u2019re willing to assume for your bond investment. A bond\u2019s credit rating will provide some perspective on the bond\u2019s likelihood of default.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Maturity date'
	                        ),
	                        ': What is your investment time frame, and when do you want your principal investment returned?'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Coupon and yield to maturity'
	                        ),
	                        ': What income stream and total return do you require for your investment? Do you seek income generation, capital preservation, or alternative goals?'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Payment dates'
	                        ),
	                        ': Most bonds pay interest semi-annually, but others can pay more or less frequently\u2014or even upon maturity.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Taxability'
	                        ),
	                        ': Are you seeking a taxable or tax-advantaged investment?'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Redemption provisions'
	                        ),
	                        ': Understand whether your bond may be called by the issuer prior to maturity and the potential implications of this action.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Price'
	                        ),
	                        ': Many factors can impact a bond\u2019s price in the secondary market. Consider using services like Market Check or TRACE/MSRB trade reporting history to evaluate a bond\u2019s current offer price.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            'Liquidity'
	                        ),
	                        ':  Some bonds are more liquid and easily bought and sold than others. Are you looking to hold this investment to maturity, or seeking flexibility to quickly sell if needed?'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'What types of bonds are available on the Bond Resource Center?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'E*TRADE clients are provided access to a robust offering of over 50,000 bonds from over 200 leading liquidity providers on the Bond Resource Center. Here you can buy and sell a range of asset classes, including Treasuries, corporates, municipals, brokered CDs, agencies, new issues, high-yield products, and more. To learn more about the benefits and risks associated with each product, check out the educational material available in our ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)("https://us.etrade.com/knowledge/library/bonds-cds");
	                        } },
	                    'Knowledge Library'
	                ),
	                '.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'Where do I find additional information about a bond I\u2019m interested in?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'To view the detailed terms and features of a particular bond, click the issuer name to load the bond\u2019s description page. For additional credit analysis on most corporate and municipal bonds offered on the platform, please reference the Moody\u2019s report corresponding to that CUSIP.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'Is there anyone at E*TRADE who can help guide my experience on the Bond Resource Center?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Yes, E*TRADE clients have direct access to our experienced Fixed Income Specialist team who can answer your questions and help you navigate the Bond Resource Center to support your bond or CD selection process.  Our Fixed Income Specialists can provide support on how to utilize the range of tools, screeners, and services offered on the platform. If you\'d like, they can also place the trades on your behalf. To speak with one of our Fixed Income Specialists, please call 877-355-3237.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'Individual bonds vs. bond funds'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'There are numerous ways you can invest in fixed income at E*TRADE. While the Bond Resource Center provides you direct access to individual bond investment options, you also have access to bond fund solutions. For more information regarding the benefits and risks associated with individual bonds versus bond funds, please visit our ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)("https://us.etrade.com/knowledge/library/bonds-cds/bond-versus-bond-funds");
	                        } },
	                    'Knowledge Library'
	                ),
	                '.'
	            )
	        )
	    );
	};

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _core = __webpack_require__(9);
	
	var _ratingsTable = __webpack_require__(2035);
	
	var _ratingsTable2 = _interopRequireDefault(_ratingsTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'h2',
	            { className: 'large-header vertical-offset-sm' },
	            'Getting Started: Bond Fundamentals'
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What is a bond?'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                'A bond, also referred to as a fixed income security, is an interest-bearing debt obligation. When an investor purchases a bond, they are making a loan to the issuer of the bond. In return, the borrower (issuer) is obligated to adhere to the terms of the loan. These terms may vary, but an investor is typically due fixed interest payments on stated dates and a return of their principal upon maturity of the bond.'
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What are the benefits of bond investing?'
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'vertical-offset-sm' },
	            'Individual bonds offer investors a range of potential benefits. Some of these benefits include:'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Diversification:'
	                ),
	                ' Bonds can help add stability and diversification to a portfolio as they typically have a low correlation with other asset classes, like stocks.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Capital preservation:'
	                ),
	                ' Bonds are generally considered lower risk investments and can be a great vehicle to preserve wealth. When you purchase a bond, the issuer promises to return your principal investment upon maturity.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Income generation:'
	                ),
	                ' Bonds can provide investors with a predictable income stream. Most bonds make fixed-rate semi-annual interest payments.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Tax advantages:'
	                ),
	                ' Certain types of bonds can offer investors tax advantages. If purchased from an issuer in your state of residence, municipal bonds may provide interest income that is free from federal, state, and local taxes.'
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What are the risks associated with bond investing?'
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'vertical-offset-sm' },
	            'Like all investments, individual bonds are subject to varying risks you will want to familiarize yourself with.  Some of these risks include:'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Credit or default risk:'
	                ),
	                ' The risk that the bond\u2019s issuer will be unable to make the bonds interest or principal payments when they are due.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Interest rate risk:'
	                ),
	                ' Interest rate risk is the risk that changes in interest rates may reduce or erode the market value of your bonds. '
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Call risk and reinvestment risk:'
	                ),
	                ' If interest rates decline, a bond issuer may call their bonds (if they feature a redemption feature), and you, as an investor, will receive your principal back sooner than expected. If this occurs you may not be able to find similar bonds with comparable yields to your original holding, which is known as reinvestment risk.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    'Liquidity risk:'
	                ),
	                ' This is the risk bond investors may face where it may be difficult to quickly sell a bond due to a thin market for that particular security. An investor may be placed into a position to sell their bond at a discount to market value if the security is thinly traded.'
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'I\u2019m new to bond investing, how can I get started?'
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'vertical-offset-sm' },
	            'E*TRADE clients new to bond investing have access to a range of resources to get started investing in bonds, including:'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)("https://us.etrade.com/knowledge/library/bonds-cds");
	                        } },
	                    'Bonds and CDs Knowledge Library'
	                ),
	                ':  E*TRADE\u2019s repository of fixed income educational content.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                (0, _core.jsx)(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)('https://www.bonddesk.com/etrade/smart_bond_investing.pdf', '_blank');
	                        } },
	                    'FINRA\u2019s Smart Bond Investing'
	                ),
	                ': Comprehensive bond investing guide from FINRA.'
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What is the relationship between bond prices and bond yields?'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                'Bond prices and yields have what\u2019s called an inverse relationship. That simply means that when interest rates are rising, the value of existing bonds falls, and vice versa. Why is this the case? Let\u2019s look at an example. Let\u2019s say you own a bond with a 4% coupon, but comparable new issue bonds feature a 3% coupon. If you were interested in selling your bond, potential buyers would be willing to pay more (a premium) for your bond as it features a higher coupon than the newly issued comparable bonds. Alternatively, let\u2019s say you were looking to sell that same bond with a 4% coupon, but prevailing interest rates have risen, and comparable new issue bonds now feature a 5% coupon. In this scenario, you would need to sell your bond at a lower price (a discount) in order to attract investors to buy.'
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'text-center' },
	            (0, _core.jsx)('img', { src: 'resources/images/faq-price-yield-chart.png', alt: 'price yield relationship' })
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What are bond ratings?'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                'A bond rating is a grade given by a rating agency to measure the creditworthiness of a bond. A bond\u2019s rating reflects the issuer\u2019s ability to make future interest and principal payments as promised. Among other factors, a bond\u2019s rating also impacts the yield an issuer must pay to attract investors to purchase the bond. All else being equal, lower-rated bonds typically feature higher yields in order to compensate investors for assuming additional risk.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                'Bonds get rated when an issuer engages a rating agency to conduct a financial analysis of its balance sheet regarding the risk of payment interruption.  The two largest ratings agencies are Standard & Poor\u2019s (S&P) and Moody\u2019s. Bonds with high ratings (such as AAA at S&P and Aaa at Moody\'s) have a lower probability of incurring a payment default. Bonds with low ratings (CCC at S&P or Caa2 at Moody\'s) have a much higher probability of default. Bonds rated BBB-/Baa3 and above are considered investment grade.'
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'text-center' },
	            (0, _core.jsx)(
	                'figure',
	                null,
	                (0, _core.jsx)('img', { src: _ratingsTable2.default, alt: 'ratings table' }),
	                (0, _core.jsx)(
	                    'figcaption',
	                    { className: 'screen-reader-only' },
	                    (0, _core.jsx)(
	                        'table',
	                        null,
	                        (0, _core.jsx)(
	                            'caption',
	                            null,
	                            'Risk Rankings of Investment Grade and High-Yield Corporate Bonds'
	                        ),
	                        (0, _core.jsx)('col', null),
	                        (0, _core.jsx)('col', null),
	                        (0, _core.jsx)('colgroup', { span: '3' }),
	                        (0, _core.jsx)(
	                            'thead',
	                            null,
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'col' },
	                                    'Grade Type'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'col' },
	                                    'Type of Investment'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { colSpan: '3', scope: 'colgroup' },
	                                    'Credit Rating'
	                                )
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'tbody',
	                            null,
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { rowSpan: '3', scope: 'rowgroup' },
	                                    'Investment Grade'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'row' },
	                                    'High Investment Grade'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'AAA'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'AA+'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'AA-'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'row' },
	                                    'Medium Investment Grade'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'A+'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'A'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'A-'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'row' },
	                                    'Low Investment Grade'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'BBB+'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'BBB'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'BBB-'
	                                )
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'tbody',
	                            null,
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { rowSpan: '4', scope: 'rowgroup' },
	                                    'Speculative Grade'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'row' },
	                                    'Non-Investment Grade Speculative'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'BB+'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'BB'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'BB-'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'row' },
	                                    'Highly Speculative'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'B+'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'B'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'B-'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'row' },
	                                    'Extremely Speculative'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'CCC+'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'CCC'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'CCC-'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { scope: 'row' },
	                                    'In Default'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'CC'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'C'
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    null,
	                                    'D'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What is a bond ladder?'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                'A bond ladder is an investment strategy used to diversify a portfolio of fixed income securities by purchasing bonds with staggered maturities. This strategy can be used to manage interest rate risk and generate predictable cash flow. For a detailed guide on using bond ladders, please reference our ',
	                (0, _core.jsx)(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)("https://us.etrade.com/knowledge/library/bonds-cds/bond-ladders");
	                        } },
	                    'Knowledge Library'
	                ),
	                '.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                'You can use E*TRADE\u2019s ',
	                (0, _core.jsx)(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.show)('bond-ladder-builder');
	                        } },
	                    'Bond Ladder Builder'
	                ),
	                ' to guide you through the bond ladder building process.'
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What is the minimum bond order size?'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                'Bond orders must be placed for at least one whole bond. You cannot place orders for a fractional bond size. Bonds generally have a face value of $1,000, and that\u2019s often the minimum investment for many bond offers you\u2019ll find available on our website. Certain bond dealers impose a higher minimum quantity (for example, a $10,000 face value). You can observe this minimum on either the search results table, bond description page, or bond order ticket when placing a trade.'
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What is the difference between new issue and secondary bonds?'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                'When you purchase a new issue bond (in the primary market), you\u2019re buying a security that\u2019s just been issued\u2014 and you become the initial owner. Proceeds of your transaction go to the issuer of that security (e.g., a corporation or government agency for bonds or a bank for CDs). New issues are typically purchased at face value, i.e., $1,000.'
	            ),
	            (0, _core.jsx)(
	                'li',
	                null,
	                'Alternatively, when you buy or sell on the secondary market, you\u2019re trading with another market participant (that is to say, other investors), not the original issuer of the bond. Proceeds from a secondary market transaction go to the seller of the bond. Secondary bonds can be bought and sold at a premium or discount to their original face value.'
	            )
	        ),
	        (0, _core.jsx)(
	            'h4',
	            { className: 'small-header' },
	            'What is the difference between a brokered CD and a traditional bank CD?'
	        ),
	        (0, _core.jsx)(
	            'ul',
	            null,
	            (0, _core.jsx)(
	                'li',
	                null,
	                'E*TRADE provides clients access to brokered CDs on the ',
	                (0, _core.jsx)(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.show)('overview');
	                        } },
	                    'Bond Resource Center'
	                ),
	                '. Brokered CDs share many characteristics with bank CDs, such as FDIC insurance coverage to applicable limits, but they also have some unique benefits. When purchasing a traditional bank CD, investors may be subject to early withdrawal fees assessed by the bank if they elect to withdraw their funds prior to maturity. However, brokered CDs give investors the opportunity to sell their CDs prior to maturity on the secondary market (without penalty), offering enhanced liquidity. If you sell your CD prior to maturity, you may experience a gain or loss.'
	            )
	        )
	    );
	};

/***/ },
/* 915 */
117,
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "h2",
	            { className: "large-header vertical-offset-sm" },
	            "Common bond terms to know"
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Callable bond"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "A bond is callable if the issuer has the right to redeem (call) the bond prior to its stated maturity date, usually at a predetermined price. A bond is more likely to be called if interest rates have declined since the bond\u2019s initial issuance. The issuing entity may elect to call the bonds in order to refinance their debt at a lower rate of interest. Please reference a bond\u2019s call schedule for additional terms regarding its call features."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Make whole call"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "A make whole call provision allows the issuer to pay off remaining debt early, but with different terms than a traditional par call. The issuer is required to make a lump sum payment to the borrower which is equivalent to the net present value of future coupon payments (that will not be paid incrementally due to the early call), plus the principal payment the investor would have received upon maturity. A make whole call can be seen as a form of investor protection, as the investor will be \u201Cmade whole\u201D if the issuer calls their bonds early."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Yield"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "Yield is the return earned on a bond, usually quoted as a percentage, based upon the price and interest payments received."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Yield to maturity and yield to worst"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "Yield to maturity is the most commonly quoted yield calculation, and it represents the total return received on a bond if it is held until its maturity date. The yield to worst is representative of the worst-case scenario yield an investor could experience, with the assumption that the issuer doesn\u2019t default."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Coupon (Interest rate)"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "A bond\u2019s coupon is its annual interest rate, which is expressed as a percentage of the bond\u2019s face value. As an example: a $1,000 bond with a 5% coupon would pay $50 a year, typically in semi-annual payments."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Bid and ask prices"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "An ask (offer) price represents the price at which the dealer is willing to sell their bonds\u2014but it may be subject to change. You will see a dealer\u2019s ask price displayed in green font within the Price column on your search results."
	            ),
	            _react2.default.createElement(
	                "li",
	                null,
	                "A bid price represents the price the dealer is willing to purchase bonds at, but it may be subject to change.  You will see a dealer\u2019s bid indication in red font within the Price column on your search results."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Issuer"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "Bonds represent debt issued by a corporation, government, or municipality. The issuer is the legal entity that registers and sells securities to raise capital to fund their operations. The issuer is obligated to pay the principal and interest on the bond."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Principal"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "A bonds principal (or face value) is the stated amount of value the issuer owes the bondholder at maturity. The face value for most bonds is $1,000, but it can vary by issuer and asset class. A bond\u2019s principal will remain static over the life of the bond, but its price in the secondary market may fluctuate."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Maturity"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "Maturity refers to the date by which the investor will receive their principal (or par amount) repaid by the issuer and when the issuer\u2019s obligation will end. There are exceptions, but most bond maturities typically range from less than one year to 30 years."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Credit rating"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "A bond\u2019s credit rating refers to its likelihood of default as determined by an independent rating agency. Bonds can fall on a spectrum from highly rated investment grade bonds to poorly rated speculative grade bonds with a higher probability of default."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Accrued interest"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "Accrued interest is the amount of interest that has accumulated on a bond since its last interest payment date. The seller of a bond is due the bond\u2019s accrued interest, which is paid by the buyer as a cost of the bond transaction."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Bid Wanted"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "The announcement that a holder of a security wants to sell and will entertain bids. A bid wanted is the order you enter when you wish to sell a bond you own."
	            )
	        ),
	        _react2.default.createElement(
	            "h4",
	            { className: "small-header" },
	            "Offer Wanted"
	        ),
	        _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	                "li",
	                null,
	                "An offer wanted is a solicitation for a quote from an investor interested in buying a bond. An offer wanted is the order you enter when you wish to buy a bond."
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var ordersPage = function ordersPage() {
	    (0, _twd.openWindow)('https://us.etrade.com/e/t/invest/vieworders?ploc=2017-nav-Accounts');
	};
	
	var brcOrdersPage = function brcOrdersPage() {
	    (0, _twd.show)('orders');
	};
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h2',
	            { className: 'large-header vertical-offset-sm' },
	            'Trading Bonds at E*TRADE'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'When can I enter a bond trade?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'The ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.show)('overview');
	                        } },
	                    'Bond Resource Center'
	                ),
	                ' is operational 24 hours a day, seven days a week, unless closed for market holidays or system maintenance. Clients should be aware there may be less liquidity and dealer participation outside of normal trading hours. While orders may be placed at any time, actual trade execution will not occur outside normal trading hours. The hours of operation for the E*TRADE Fixed Income Trading Desk to review and execute orders is Monday\u2013Friday from 8 a.m.\u20135 p.m. ET.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How do I purchase a bond?'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm' },
	            'There are multiple ways to buy a bond at E*TRADE.'
	        ),
	        _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'First, consider conducting a search through one of our search resources, such as the Global Search Bar at the top of the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.show)('overview');
	                        } },
	                    'Bond Resource Center'
	                ),
	                ', the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.show)('advanced-screener');
	                        } },
	                    'Advanced Bond Screener'
	                ),
	                ', or simply clicking the cell of a product type and yield within the Yield by Category grid.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Review the available offers on the subsequent Search Results page to isolate your bond selection.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'The right column of a Search Results page will display an Action column with a Buy button.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Click the Buy button to load the Bond Order ticket.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Enter your criteria in any variable fields (i.e., quantity) and click the Preview button.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Confirm the details of your order are correct, and then click Place Order.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'You will receive an alert when your trade has been executed. To check the status of your order, view the ',
	            _react2.default.createElement(
	                'a',
	                { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                'Orders Page'
	            ),
	            '.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How do I sell a bond I own?'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm' },
	            'You can sell your bond holdings from within the ',
	            _react2.default.createElement(
	                'a',
	                { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                        return (0, _twd.openWindow)("https://us.etrade.com/etx/pw/portfolios?ploc=2017-nav-Accounts#/portfolios/0/positions");
	                    } },
	                'Portfolios Page'
	            ),
	            '. If you are currently within the Bond Resource Center, you can also click the Holdings tab from the global navigation menu to be redirected to the ',
	            _react2.default.createElement(
	                'a',
	                { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                        return (0, _twd.openWindow)("https://us.etrade.com/etx/pw/portfolios?ploc=2017-nav-Accounts#/portfolios/0/positions");
	                    } },
	                'Portfolios Page'
	            ),
	            '. '
	        ),
	        _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Within the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)("https://us.etrade.com/etx/pw/portfolios?ploc=2017-nav-Accounts#/portfolios/0/positions");
	                        } },
	                    'Portfolios Page'
	                ),
	                ', navigate to the position you want to sell, click the Trade button, and then the Sell button. Note: If you have multiple accounts, click the dropdown at the top of the page to select the account associated with the bond position you want to sell.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'You\u2019ll be directed to a quote request ticket to place a bid wanted request. Enter the quantity of bonds you\u2019d like to sell and click Preview.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Confirm the details of your quote request, and then click Place Quote Request.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'To check the status of your quote request, access the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.openWindow)('https://us.etrade.com/e/t/invest/viewbondquotes?rightrail=disable&results_perpage=20');
	                        } },
	                    'Bond Quotes'
	                ),
	                ' tab within the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                '. You can also monitor the status of your quote request within the Bond Resource Center\u2019s ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: brcOrdersPage },
	                    'Orders Page'
	                ),
	                '.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Your quote request will collect bids for the period of time indicated on the order status page. The system will then display the best available bid at which you can sell your bond. Click the Sell link to proceed.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Click the Preview button to review the details of your sell order. If all criteria are accurate, click Place Order to submit your trade.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'You will receive an alert when your trade has been executed. To check the status of your order, view the ',
	            _react2.default.createElement(
	                'a',
	                { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                'Orders Page'
	            ),
	            '.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'What is a Quote Request, and when should I use the \u201CGet a Bond Quote\u201D tool?'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'What is a Quote Request?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'A quote request is a solicitation of a bid or ask price for the bond you wish to buy or sell. Your request will be displayed to our dealer network through our trading desk to find the best price. Please note that a quote request is not an order, and it does not obligate you to buy or sell. It is merely a request to find a price.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'When do I use the \u201CGet a Bond Quote\u201D tool?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Requesting a bond quote is useful when the specific security you wish to buy or sell is not found from a CUSIP search or when your quote doesn\'t return an acceptable quantity or price. If you are selling a bond you already own, it is also the easiest way to find a buyer. However, if there is already a live market sell or buy price displayed on the Bond Resource Center, placing a buy or sell quote request does not necessarily result in a better price.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'What happens after I place a Quote Request?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'After you place a quote request, it will be displayed to our dealer network, and if there is an interest for your buy or sell quote request, you will be receiving a quote. Please note it may take some time to receive your quote. The security type and current market conditions will influence when your quote is received. Once available, the quote will be displayed in within the Bond Quotes tab of the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                '. '
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'Placing an order after receiving a quote'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'If you are happy with the quote you received, you can then proceed to place a buy or sell order. Alongside your price quote, you will see a Buy or Sell link on the ',
	                _react2.default.createElement(
	                    'a',
	                    { style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                '. Clicking this link will bring you to a buy or sell order ticket where you can proceed to place your order. Once complete, you can monitor the status of your order on the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                '.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'Can I change or cancel an order before execution?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'In most instances, you may submit a cancel request prior to trade execution by visiting the Open Orders tab within the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                ' and clicking Cancel Request under the Links column. On the subsequent page, you will need to click the Cancel Order button to complete submission of your cancel request. Following this action, a confirmation notification stating \u201CRequest has been sent\u201D should appear on the page. '
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Cancel requests for open Treasury Auction orders must be submitted prior to 9 a.m. ET on the day of the auction. Even if submitted prior to 9 a.m. ET, there is no guarantee a cancel request can be honored. You\'ll receive an alert when your cancellation request is accepted.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'If you want to change the parameters of an active open order, you will need to first submit a cancel request and then enter a new order with your updated criteria.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How long will it take to process my bond trade or bond quote request?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Orders for live offerings are executed within minutes; subject (non-live) orders or Bid Wanted/Offer Wanted Quote Requests may take 15 minutes or more. When trade or quote information is received, you\'ll see it displayed on the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                '. Check back frequently until you receive an execution. For updates, please call our Fixed Income Specialists at 877-355-3237.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'When will my bond trade settle?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'The settlement date represents that date upon which ownership is transferred for your bond transaction. Settlement date will vary depending on the type of bond you\u2019re buying or selling.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Most securities you can access and trade through E*TRADE, like Treasuries, Agencies, Corporates and Municipal Bonds, will settle the business day following the day of the trade (T+1).'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'What commissions or fees are associated with bond trading?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'All online secondary trades are subject to a $1 per bond commission, with a minimum of $10 and maximum of $250 per order.  Treasuries (auctions and secondaries) trade commission-free. New issues (excluding Treasury auctions) have a sales concession included in the offering price, so you will not be charged an additional commission or fee. Broker-assisted trades placed through the Fixed Income Specialists are subject to online secondary pricing, plus a $20 commission.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Secondary market trades executed through a Fixed Income Specialist may be subject to a commission.'
	            )
	        ),
	        _react2.default.createElement(
	            'table',
	            { className: 'table', style: { marginBottom: '6px' } },
	            _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        { width: '50%' },
	                        _react2.default.createElement(
	                            'h4',
	                            { style: { marginBottom: 0 } },
	                            'Bonds and CDs commission table:'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        '\xA0'
	                    )
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'U.S. Treasury auction'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        '$0'
	                    )
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'U.S. Treasury secondary trades online'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        '$0'
	                    )
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'Online secondary trades'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        '$1 per bond (minimum $10, maximum $250)'
	                    )
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'Broker-assisted trades'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'Online secondary pricing plus $20 commission'
	                    )
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'New Issues (except Treasury auction)'
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        'Offering price includes a selling concession'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-base' },
	            'Trade commission not to exceed 2% of total principal value.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'Can I only buy bonds at the prices shown as live?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'The prices displayed for the live offerings on the Bond Resource Center are set by fixed income dealers. It is these dealers that determine whether a trade can be requested at a price different from the listed price. If a better price can be requested (limit price), the price field on your ticket will appear in a variable text box that can be edited. In most cases, the prices are set by the \u201CStreet,\u201D and you will not have the ability to negotiate.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Please keep in mind that dealers are not required to match or improve upon online prices based on prior trades for a CUSIP. A dealer has the right to set the market. Even if you have the ability to negotiate for a better price on a specific bond, that does not guarantee you will be able to secure the price you\u2019re asking. An order whereby a dealer has passed (not accepted) your price means that your order will be rejected.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How can I assess a bond\u2019s offering price?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'E*TRADE provides several resources to help clients assess the fair value of a bond they\u2019re looking to purchase. For TRACE-reportable corporates and MSRB-reportable municipals, clients can access the bond\u2019s trade history by clicking the More link in their Search Results table or within the bond\u2019s description page which can be accessed by clicking the bond issuer\u2019s name.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-sm' },
	                    'Alternatively, for quicker perspective, consider reviewing the pre-trade price analysis conducted by our Market Check service. This service, also located within your Search Results table, will compare a bond\u2019s current offer price (for certain corporate and municipal bonds) against recent transactions in that same bond within the last five trading sessions as reported by TRACE or the MSRB. Offerings with prices exceeding our price variance thresholds will be suppressed from display. Based on this evaluation, the service will present one of two visual indicators for the bond\u2019s price which corresponds to its status:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            '\u201CAligns with Recent Trade Prices\u201D'
	                        ),
	                        ': The offering price is less than or equal to three points (four points for high-yield) of the last TRACE/MSRB-reported trade.'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Corporate Bonds: Within a two-day lookback period, the current offering price is within 3% of average customer buy activity for TRACE/MSRB-reportable trades, and within 4% of average interdealer trade activity.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Municipal Bonds: Within a five-day lookback period, the current offering price is within 3% of average customer buy activity for TRACE/MSRB-reportable trades, and within 4% of average interdealer trade activity.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'text-bold' },
	                            '\u201CNo Recent Trades for Comparison\u201D'
	                        ),
	                        ': There have been no TRACE/MSRB-reported trades in this CUSIP in the last five trading sessions.'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'Can I trade non-US bonds (foreign bonds)?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Yes, you can trade foreign bonds at E*TRADE so long as they are US dollar denominated.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How do I buy Treasuries at auction?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'Treasury securities are classified as bills, bonds, or notes, depending on the issue\'s term to maturity. These securities are offered at auctions.'
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'To buy Treasuries at auction:'
	        ),
	        _react2.default.createElement(
	            'ol',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'In the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                            return (0, _twd.show)('overview');
	                        } },
	                    'Bond Resource Center'
	                ),
	                ', click the Tools and Resources tab, then click the Treasury Auctions link.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Enter the number of bonds you want to buy using the variable text box above the table.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Under the Select column, mark the Treasury issue you wish to purchase. You will only be able to select issues for which we are currently accepting purchase requests.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'Click Preview Order. Confirm that the details of your order are correct, and then click Place Order.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'You\'ll receive an alert when your trade has executed. To check the status of your order, view the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                '.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm' },
	            'For support finding and trading treasury bonds, please reference our ',
	            _react2.default.createElement(
	                'a',
	                { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                        return window.open('https://content.etrade.com/etrade/estation/pdf/trading-treasury-bonds.pdf', '_blank');
	                    } },
	                'Treasury Bond Guide'
	            ),
	            '.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'If no auctions are currently available, please click the ',
	            _react2.default.createElement(
	                'a',
	                { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                        return (0, _twd.openWindow)('https://www.treasury.gov/resource-center/data-chart-center/quarterly-refunding/Documents/auctions.pdf', '_blank');
	                    } },
	                'Upcoming Auctions'
	            ),
	            ' link to review the Treasury\u2019s tentative auction schedule.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How do I check the status of my open bond order?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'You can monitor the status of an open bond order on the ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: ordersPage },
	                    'Orders Page'
	                ),
	                ' under the Accounts tab. '
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-sm' },
	                    'Additionally, the Bond Resource Center ',
	                    _react2.default.createElement(
	                        'a',
	                        { style: { cursor: 'pointer' }, onClick: brcOrdersPage },
	                        'Orders Page'
	                    ),
	                    ' enables you to track your orders and to change the status of some orders. To use this screen, take the following steps:'
	                ),
	                _react2.default.createElement(
	                    'ol',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'In the ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#', style: { cursor: 'pointer' }, onClick: function onClick() {
	                                    return (0, _twd.show)('overview');
	                                } },
	                            'Bond Resource Center'
	                        ),
	                        ', click Orders.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'If you\'d like to narrow the list of bonds displayed, change the display criteria with any of the available fields, including the Type, Date Range, and Status fields.'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Click Update to view the refined list of orders upon making your selections.'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'What does it mean if the execution price of the bond I bought is in red?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'When looking at an executed trade on the Bond Resource Center ',
	                _react2.default.createElement(
	                    'a',
	                    { href: '#', style: { cursor: 'pointer' }, onClick: brcOrdersPage },
	                    'Orders Page'
	                ),
	                ', you may notice from time to time that the execution price appears in red. This color is used by E*TRADE to show that our Fixed Income Trade Desk has been able to secure you a better price than the price originally submitted with your order.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'The prices at which you request to trade are set by fixed income dealers. Our execution price advocacy is a result of our philosophy of maintaining unfiltered access to the widest possible selection of fixed income securities for our customers. E*TRADE offers inventory from over 200 fixed income dealers, representing one of the largest bond and CD selections in the US. We list over 50,000 unique bond and CD offerings online daily.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                'However, even though the E*TRADE online inventory is large, our offerings may not represent all bonds and prices available in the market. As a result, when customers trade bonds through E*TRADE, we look beyond our online network of fixed income dealers to attempt to secure a better execution price. If we are successful in doing so, the execution price on the order ticket will show in red.'
	            ),
	            _react2.default.createElement(
	                'li',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-sm' },
	                    'Price improvements may occur more often for certain fixed income sectors, such as corporate bonds, municipals, and Treasuries. Improvements tend to occur less frequently for especially inactive securities like CDs and agencies. The amount of price improvement will vary based on a variety of factors, including:'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Whether you are buying or selling'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'The asset class you are trading'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Whether you are looking for a primary or secondary offering'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'The credit rating of the issue and issue news'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'The selected maturity'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Other attributes or factors (e.g., our firm\u2019s ability to maintain relationships with additional outside market participants)'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-sm text-bold' },
	            'Due to these variables, price improvement cannot be guaranteed.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            { className: 'small-header' },
	            'How do I purchase new issue municipal offerings?'
	        ),
	        _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	                'li',
	                null,
	                'New issue municipal bonds are not currently offered by E*TRADE.'
	            )
	        )
	    );
	};

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1778);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            Template,
	            { id: 'vendor-disclosures-title' },
	            '<div class="text-left"><h3>E*TRADE from Morgan Stanley</h3></div>'
	        ),
	        _react2.default.createElement(
	            Template,
	            { id: 'vendor-disclosures' },
	            VENDOR_DISCLOSURES
	        )
	    );
	};
	
	var Template = function Template(_ref) {
	    var children = _ref.children,
	        attrs = _objectWithoutProperties(_ref, ['children']);
	
	    return _react2.default.createElement('template', Object.assign({}, attrs, {
	        dangerouslySetInnerHTML: { __html: children }
	    }));
	};
	
	var VENDOR_DISCLOSURES = '\n<div>\n    <h2 class="h4 strong">Morgan Stanley</h2>\n    <p>\n        Morgan Stanley Research does not provide individually tailored investment advice. The content and information provided has been prepared without regard to the individual financial circumstances and objectives of the person(s) who receive it. The strategies and/or investments discussed may not be appropriate for all investors.  The appropriateness of a particular investment or strategy will depend on an investor\u2019s individual circumstances and objectives. Access to or use of Morgan Stanley Research content and information does not establish an advisory or fiduciary relationship with Morgan Stanley &amp; Co. LLC or its affiliates (\u201CMorgan Stanley\u201D). The content or information provided is not an offer to buy or sell any security or participate in any trading strategy. Past performance is not an indicator of future results. Morgan Stanley Research content is proprietary to Morgan Stanley and may not be copied or distributed. Morgan Stanley is not responsible for any damages or losses arising from any use of the content or information.  Morgan Stanley does not guarantee the accuracy, adequacy, completeness or availability of any information contained in Morgan Stanley Research content and is not responsible for any errors or omissions or for the results obtained from the use of such information.  For important disclosures, please see the Morgan Stanley Research Disclosure Website at <a href="http://www.morganstanley.com/researchdisclosures" target="_blank">www.morganstanley.com/researchdisclosures</a>.\n    </p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">About Thomson Reuters</h2>\n    <p>\n        Thomson Reuters is the world\'s leading source of intelligent information for businesses and professionals. We combine industry expertise with innovative technology to deliver critical information to leading decision makers in the financial, legal, tax and accounting, scientific, healthcare and media markets, powered by the world\'s most trusted news organization. With headquarters in New York and major operations in London and Eagan, Minnesota, Thomson Reuters employs more than 50,000 people in 93 countries. Thomson Reuters shares are listed on the New York Stock Exchange (NYSE: TRI); Toronto Stock Exchange (TSX: TRI); London Stock Exchange (LSE: TRIL); and Nasdaq (NASDAQ: TRIN). For more information, go to <a href="http://www.thomsonreuters.com" target="_blank">www.thomsonreuters.com</a>\n    </p>\n    <p>StockReports+ is a sophisticated tool that provides analytics at the stock, industry, portfolio, and market levels. It provides stock ratings throughout the reports that are designed to be transparent and easily understood and is the culmination of years of hard work and millions of dollars in development and research.</p>\n    <p>Thomson Reuters has leveraged its expertise in the areas of earnings, valuation, and insider analysis and has combined that knowledge with its vast warehouse of fundamental data to create an effective model. The ratings are systematically generated, driven 100% by market data. As an unbiased, third party provider and developer of financial content, Thomson Reuters furnishes investors with a professional-grade stock rating system.</p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">SmartConsensus <span class="fs-base">by ResearchTeam\u2122</span></h2>\n    <p>\n        <span class="text-bold">SmartConsensus</span> by Research Team\u2122 is unique third-party research that employs a \'wisdom of crowds\' approach to investment research. The concept is simple: a combination ("team") of different research providers issuing company ratings may perform better than the individual research providers alone. The historical accuracy of each provider ("track record") is traditionally used to find the \'best\' research provider. Certain providers may have poor track records, but may still add overall value if their strengths are used in combination with another research provider.\n    </p>\n    <p>\n        <span class="text-bold">SmartConsensus</span> is a rating based on a universe of companies covered by a team of research providers known as "Constituents" \u2013 Thomson Reuters and MarketEdge. Detailed analysis is performed on each constituent\u2019s own ratings, historical track records and methodologies to identify the areas of strength for each constituent. These strengths are then factored into the ratings generation process to create an overall team rating ("SmartConsensus") for each company covered.\n    </p>\n    <p>All three constituents must have a current rating for a particular company in order for there to be a SmartConsensus rating. If less than three constituents have current ratings for a particular company, then the SmartConsensus rating for the stock is "Not Rated". All of the constituents must have unanimous \'Buy\' ratings in order for there to be a SmartConsensus \'Buy\' rating. It takes only one opinion to make any other rating. For example, a single \'Sell\' rating among the constituents will result in a SmartConsensus \'Sell\' rating.</p>\n    <p>\n        <span class="text-bold">SmartConsensus</span> reports provide you with a complete rating picture including the current SmartConsensus rating, rating history and a comparison of the SmartConsensus to its constituents.\n    </p>\n    <p>\n        <span class="text-bold">Disclosure</span>\n        <br>\n        Reproduction of Independent Research Products, Research Team or SmartConsensus in any form is prohibited except with the prior written permission of Markit On Demand, Inc. Because of the possibility of human or mechanical error by Markit On Demand\'s sources, Markit On Demand or others, Markit On Demand does not guarantee the accuracy, adequacy, completeness or availability of any information contained in the Independent Research Products, Research Team or SmartConsensus and is not responsible for any errors or omissions or for the results obtained from the use of such information. Markit On Demand GIVES NO EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, ANY WARRANTIES OF MERCHANTABILITY, ACCURACY, TIMELINESS OR FITNESS FOR A PARTICULAR PURPOSE OR USE. In no event shall Markit On Demand be liable for any indirect, special or consequential damages in connection with subscriber\'s or others\' use of Independent Research Products, Research Team or SmartConsensus. Markit On Demand makes no recommendation regarding any of the securities contained herein. Markit On Demand makes no offer or solicitation to buy or sell any of the securities contained herein. <span class="text-bold">Past performance is not an indication of future results.</span>\n    </p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">Morningstar</h2>\n    <p>\n        \xA9 2021 Morningstar. All rights reserved. The information contained herein: (1) is proprietary to Morningstar Research Services LLC, Morningstar, Inc. and/or their content providers; (2) may not be copied or distributed; and (3) is not warranted to be accurate, complete or timely. Neither Morningstar Research Services, Morningstar nor their content providers are responsible for any damages or losses arising from any use of this information. Access to or use of the information contained herein does not establish an advisory or fiduciary relationship with Morningstar Research Services, Morningstar, Inc. or their content providers. Past performance is no guarantee of future results.<br><a href="http://global.morningstar.com/equitydisclosures" target="_blank">http://global.morningstar.com/equitydisclosures</a>\n    </p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">Argus</h2>\n    <p>\n        Argus Research Co. (ARC) is an independent investment research provider whose parent company, Argus Investors\' Counsel, Inc. (AIC), is registered with the U.S. Securities and Exchange Commission. Argus Investors\' Counsel is a subsidiary of The Argus Research Group, Inc. The Argus trademark, service mark and logo are the intellectual property of The Argus Research Group, Inc. The information contained in this research report is produced and copyrighted by Argus Research Co., and any unauthorized use, duplication, redistribution or disclosure is prohibited by law and can result in prosecution. The content of this report may be derived from Argus research reports, notes, or analyses. The opinions and information contained herein have been obtained or derived from sources believed to be reliable, but Argus makes no representation as to their timeliness, accuracy or completeness or for their fitness for any particular purpose. This report is not an offer to sell or a solicitation of an offer to buy any security. The information and material presented in this report are for general information only and do not specifically address individual investment objectives, financial situations or the particular needs of any specific person who may receive this report. Investing in any security or investment strategies discussed may not be suitable for you and it is recommended that you consult an independent investment advisor. Nothing in this report constitutes individual investment, legal or tax advice. Argus shall accept no liability for any loss arising from the use of this report, nor shall Argus treat all recipients of this report as customers simply by virtue of their receipt of this material. Investments involve risk and an investor may incur either profits or losses. Past performance should not be taken as an indication or guarantee of future performance.\n    </p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">Dow Jones</h2>\n    <p>\n        Copyright \xA9 2021 Dow Jones &amp; Company, Inc.\n    </p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">Market Edge</h2>\n    <p>\n        Past performance is not a guarantee of future results. The data contained in Market Edge is obtained from sources considered by Computrade Systems, Inc. to be reliable but the accuracy and completeness thereof are not guaranteed. Computrade Systems, Inc. does not and will not warrant the performance and results that may be obtained while using the Market Edge research service. The Market Edge research service &amp; Second Opinion are neither offers to sell nor solicitations of offers to buy any security. \xA9 2021 Computrade Systems, Inc. Market Edge\xAE and Second Opinion\xAE are registered trademarks of Computrade Systems, Inc.\n    </p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">Trefis</h2>\n    <p>\n        Trefis content is provided by <a href="http://www.trefis.com" target="_blank">www.trefis.com</a>, a service of Insight Guru, Inc. Trefis services, including its tools, content and analysis, are not intended to provide tax, legal, insurance or investment advice, and no Trefis service should be construed as an offer to sell, a solicitation of an offer to buy, or a recommendation for any security by Insight Guru, Inc. or any third party. The user of any Trefis services is solely responsible for determining whether any investment, security or strategy, or any other product or service, is appropriate or suitable for them based on their investment objectives and personal financial situation. For the complete Trefis Terms of Use, including restrictions and privacy policy, see <a href="http://www.trefis.com/terms" target="_blank">www.trefis.com/terms</a>.\n    </p>\n</div>\n<br>\n<div>\n    <h2 class="h4 strong">TipRanks</h2>\n    <p>\n        By accessing the content regarding analyst and blogger performance (the "Content") that TipRanks Ltd. makes available as a service (the "Service"), you are confirming that you have read and agreed to the terms available at this link: <a href="http://www.tipranks.com/userDisclaimer" target="_blank">http://www.tipranks.com/userDisclaimer</a> (the "Terms").\n    </p>\n    <p>\n        The Service uses an automated algorithm to rank certain (but not all) financial analysts and bloggers based on certain (but not all) recommendations they have published. The algorithm is based on TipRanks\'s own subjective judgment and discretion and its ranking criteria and methods are disclosed and explained at <a href="http://www.tipranks.com/faq" target="_blank">www.tipranks.com/faq</a>.\n    </p>\n    <p>\n        The Content is based, among other things, on past stock performance, which is not indicative of future results. Given that the Service is based on an automated algorithm, the content may be inaccurate, outdated, partial or incomplete. The Service is offered solely for informational purposes and may not be relied on for the purpose of any investment or transaction in securities.\n    </p>\n    <p>\n        Neither the Service nor the Content constitute, are intended to constitute, or should be construed as, a solicitation or offer to buy or sell an interest in any security, or investment advice regarding any transaction, futures contract, security or other financial product, investment manager, or trading or investment strategy. TipRanks is not a registered investment advisor or broker-dealer, and does not provide investment advisory services or any advice or recommendations with respect to buying or selling securities. The recommendations and the Content presented in the Service do not express the views, opinions or recommendations of TipRanks.\n    </p>\n    <p>\n        THE TERMS (<a href="http://www.tipranks.com/userDisclaimer" target="_blank">http://www.tipranks.com/userDisclaimer</a>) INCLUDE ADDITIONAL PROVISIONS THAT YOU SHOULD CAREFULLY READ, SUCH AS PROVISIONS REGARDING LIMITATION OF TIPRANKS\'S LIABILITY, DISCLAIMER OF WARRANTIES, INDEMNIFICATION, GOVERNING LAW AND JURISDICTION.\n    </p>\n</div>\n';

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUrl = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _framedIn = __webpack_require__(920);
	
	var _framedIn2 = _interopRequireDefault(_framedIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    var url = getUrl();
	    if (!url) return null;
	
	    return _react2.default.createElement(_framedIn2.default, {
	        id: 'framed-bond-ladder-builder',
	        dataName: 'bond-ladder-builder-frame',
	        src: url,
	        height: 700,
	        getHeight: function getHeight(w) {
	            var h = 0;
	            try {
	                var app = w.Ext.apps.OneStepLadder;
	                for (var n in app) {
	                    var p = app[n];
	                    if ((typeof p === 'undefined' ? 'undefined' : _typeof(p)) !== 'object') continue;
	
	                    try {
	                        var m = {
	                            criteriapanel: 50,
	                            resultspanel: 150
	                        }[n] || 50;
	                        var a = p.getEl().getHeight() + m;
	                        h = Math.max(h, a);
	                    } catch (e) {}
	                }
	            } catch (e) {}
	
	            return h;
	        }
	    });
	};
	
	var getUrl = exports.getUrl = function getUrl() {
	    try {
	        var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	        return base + '/servlet/deploy/OneStepLadder.htm?theme=etrade&prior=Y';
	    } catch (x) {}
	};

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        id = _ref.id,
	        src = _ref.src,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 200 : _ref$height,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-frame' : _ref$dataName,
	        frameName = _ref.frameName,
	        getHeight = _ref.getHeight;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        loading = _React$useState2[0],
	        setLoading = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        setLoading(true);
	    }, [src]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { id: id, style: { background: "#fff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement('div', { className: 'row vertical-offset-lg' }),
	                loading && _react2.default.createElement(
	                    'div',
	                    { 'data-name': 'loading-spinner', className: 'spinner', style: { width: "45px" } },
	                    _react2.default.createElement(
	                        'svg',
	                        { className: 'circular', viewBox: '25 25 50 50' },
	                        _react2.default.createElement('circle', { className: 'background', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' }),
	                        _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' })
	                    )
	                ),
	                _react2.default.createElement('iframe', {
	                    'data-name': dataName,
	                    src: src,
	
	                    style: {
	                        width: '100%',
	                        minHeight: '250px',
	                        visibility: 'show'
	                    },
	                    marginWidth: '0',
	                    marginHeight: '0',
	                    frameBorder: '0',
	                    onLoad: function onLoad(ev) {
	                        ev.persist();
	                        var e = ev.target;
	                        e.style.visibility = 'visible';
	
	                        var fn = function fn() {
	                            try {
	                                var w = e.contentWindow;
	                                var d = w.document;
	                                var b = d.body;
	                                var de = d.documentElement;
	
	                                var frameHeight = 0;
	                                if (frameName) try {
	                                    var fr = w.frames[frameName];
	                                    var fd = fr.document;
	                                    var fb = fd.body;
	                                    var fde = fd.documentElement;
	                                    frameHeight = Math.max(fb.scrollHeight, fb.offsetHeight, fde.clientHeight, fde.scrollHeight, fde.offsetHeight);
	                                } catch (e) {}
	
	                                var calcHeight = 0;
	                                if (getHeight) try {
	                                    calcHeight = getHeight(w);
	                                } catch (e) {}
	
	                                var h = calcHeight || Math.max(b.scrollHeight, b.offsetHeight, de.clientHeight, de.scrollHeight, de.offsetHeight, frameHeight);
	                                if (parseInt(h, 10)) {
	                                    e.style.height = Math.max(h, height) + 'px';
	                                }
	                            } catch (x) {
	                                clearInterval(resizeInt);
	                                e.style.height = '100%';
	                            }
	                        };
	
	                        var resizeInt = setInterval(function () {
	                            fn();
	                        }, 1000);
	                        fn();
	
	                        setLoading(false);
	                    }
	                }),
	                _react2.default.createElement('div', { className: 'row vertical-offset-lg bottom-border-row' })
	            )
	        )
	    );
	};

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bondLadderBuilder = __webpack_require__(919);
	
	var _bondLadderBuilder2 = _interopRequireDefault(_bondLadderBuilder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FRAMED = {
	    'bond-ladder-builder': { reload: true }
	};
	
	exports.default = function (_ref) {
	    var view = _ref.view,
	        args = _ref.args;
	
	    var _React$useState = _react2.default.useState(0),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        bondLadderBuilderTs = _React$useState2[0],
	        setBondLadderBuilderTs = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        var content = document.getElementById('content');
	        if (content) {
	            content.style.display = view in FRAMED ? 'none' : 'block';
	        }
	
	        if (showFrame('bond-ladder-builder', view, args)) {
	            setBondLadderBuilderTs(Date.now());
	        }
	    }, [view]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        bondLadderBuilderTs > 0 && _react2.default.createElement(_bondLadderBuilder2.default, null)
	    );
	};
	
	var showFrame = function showFrame(name, view, args) {
	    var isShow = FRAMED[name] && view === name;
	
	    var framed = document.getElementById('framed-' + name);
	    if (!framed) return isShow;
	
	    var frame = framed.querySelector('iframe');
	    if (isShow && frame && !args.backFrom && FRAMED[name].reload) {
	        frame.contentWindow.location.reload();
	    }
	
	    framed.style.display = isShow ? 'block' : 'none';
	
	    return isShow;
	};

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _grid = __webpack_require__(923);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    // let { status, count, holdingAlerts } = useAlerts()
	    var Last = (0, _twd.getState)('header.alerts');
	    var holdingAlerts = (0, _twd.arrayFrom)(Last.value.alerts);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'alerts-modal',
	                className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'alerts-modal-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Bond Alerts'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            _twd.Loading,
	                            { status: status },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-left', style: {
	                                            background: '#ffffff',
	                                            border: 'solid 1px #e4e4e4',
	                                            padding: '10px',
	                                            maxHeight: '300px',
	                                            overflowY: 'auto'
	
	                                        } },
	                                    _react2.default.createElement(_grid2.default, { alerts: holdingAlerts })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement('div', { className: 'col-md-4' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'alerts-modal-close-button',
	                                    className: 'btn btn-block btn-primary',
	                                    type: 'button',
	                                    onClick: _twd.hideModal
	                                },
	                                'Close'
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'col-md-4' })
	                    )
	                )
	            )
	        )
	    );
	};
	// import useAlerts from './use-alerts'
	/* eslint-disable no-use-before-define */

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var alerts = _ref.alerts;
	
	
	    alerts = (0, _twd.arrayFrom)(alerts);
	    if (alerts.length === 0) {
	        return _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'alerts-modal-not-found',
	                className: 'text-center' },
	            _react2.default.createElement(
	                'div',
	                { className: 'vertical-offset-xs' },
	                _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'small-header vertical-offset-xxs' },
	                    'No holding alerts found.'
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive', style: { maxWidth: '100%', overflowY: 'auto' } },
	        _react2.default.createElement(
	            'table',
	            { 'data-name': 'alerts-modal-table', className: 'table table-striped' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-left' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'small-header' },
	                            'Holding Alerts'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                alerts.map(function (r, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { 'data-name': 'alerts-modal-row', key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(HoldingAlerts, r)
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var HoldingAlerts = function HoldingAlerts(_ref2) {
	    var alertDate = _ref2.alertDate,
	        alertDescription = _ref2.alertDescription,
	        cusip = _ref2.cusip,
	        issue = _ref2.issue,
	        maturity = _ref2.maturity,
	        coupon = _ref2.coupon,
	        acctNo = _ref2.acctNo,
	        qty = _ref2.qty;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'text-body' },
	            _react2.default.createElement(
	                'p',
	                null,
	                _twd.fmt.mdy(alertDate),
	                ' ',
	                _react2.default.createElement(
	                    'span',
	                    { className: 'subhead' },
	                    alertDescription
	                )
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                _twd.fmt.issuer({
	                    cusip: cusip,
	                    issuer: (issue || cusip || '') + ' ' + _twd.fmt.cpn(coupon) + ' ' + _twd.fmt.mdy(maturity),
	                    showBackLink: 'N',
	                    className: 'link-button'
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'equally-spaced' },
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: '50%' } },
	                    'Account #: ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'text-bold' },
	                        acctNo
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { width: '50%' } },
	                    'Quantity: ',
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'text-bold' },
	                        _twd.fmt.qty(qty)
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useAlerts = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var _useAlerts = useAlerts(0),
	        status = _useAlerts.status,
	        count = _useAlerts.count;
	
	    return _react2.default.createElement(_twd.Flyout, {
	        disabled: status === _twd.Status.LOADING,
	        className: 'btn btn-link',
	        dataName: 'alerts-link',
	        label: 'Alerts ' + (count > 0 ? '(' + count + ')' : ''),
	        html: DISCLAIMER,
	        trigger: ['hover'],
	        onClick: function onClick(e) {
	            return (0, _twd.showModal)('alerts', { source: e.target });
	        },
	        showIcon: false,
	        placement: 'bottom'
	    });
	};
	
	var Last = (0, _twd.getState)('header.alerts', {
	    ts: 0,
	    alerts: []
	});
	
	var useAlerts = exports.useAlerts = function useAlerts() {
	    var _React$useState = _react2.default.useState(Last.value.ts),
	        _React$useState2 = _slicedToArray(_React$useState, 1),
	        ts = _React$useState2[0];
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(0),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        count = _React$useState6[0],
	        setCount = _React$useState6[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        if (Last.value.ts > ts) return;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, hData, hAbort, alerts, n;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.prev = 1;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _ajax = (0, _twd.ajax)({
	                                url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldingsAlerts',
	                                method: 'GET'
	                            }), hData = _ajax.data, hAbort = _ajax.abort;
	
	                            lastAbort.current = hAbort;
	                            _context.t0 = getHoldingAlerts;
	                            _context.next = 8;
	                            return hData;
	
	                        case 8:
	                            _context.t1 = _context.sent;
	
	                            if (_context.t1) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.t1 = {};
	
	                        case 11:
	                            _context.t2 = _context.t1;
	                            alerts = (0, _context.t0)(_context.t2);
	
	                            lastAbort.current = null;
	
	                            n = alerts.length;
	
	                            setCount(n);
	
	                            Last.set({
	                                ts: Date.now(),
	                                alerts: alerts
	                            });
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 23;
	                            break;
	
	                        case 20:
	                            _context.prev = 20;
	                            _context.t3 = _context['catch'](1);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 23:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[1, 20]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) {
	                lastAbort.current();
	            }
	        };
	    }, [ts]);
	
	    // React.useEffect(() => {
	    //     let subId = subscribe('order_status.header_use_alerts',
	    //         bufferedFn(() => {
	    //             setTs(Date.now())
	    //         }))
	    //     return () => { unsubscribe(subId) }
	    // },[])
	
	    return {
	        status: status, count: count
	    };
	};
	
	var getHoldingAlerts = function getHoldingAlerts(_ref2) {
	    var allCusipEvents = _ref2.allCusipEvents;
	
	    var rs = (0, _twd.arrayFrom)(allCusipEvents);
	    var m = rs.reduce(function (x, r) {
	        var h = r.acctNo + ' ' + r.cusip + ' ' + r.alertDate + ' ' + r.alertDescription;
	        if (x[h]) {
	            x[h].qty += r.qty;
	        } else {
	            x[h] = r;
	        }
	        return x;
	    }, {});
	    return Object.values(m).sort(function (a, b) {
	        var x = new Date(a.alertDate);
	        var y = new Date(b.alertDate);
	        return y - x;
	    });
	};
	
	var DISCLAIMER = '\n    <p><b><u>Click the Alerts link (above) to view your alert listings</u></b></p>\n\n    <p><b>Did you know?</b><br/>\n    You are automatically enrolled to receive bond alerts for your\n    fixed income positions. These include, but are not limited to,\n    Moody\'s and S&P rating change events, call and redemption\n    events, market price change events and material events\n    </p>\n\n    <p><b>Looking for more?</b><br/>\n    E*Trade also provides clients access to new issue bond\n    alerts on a subscription basis. If you are interested in\n    receiving notifications for new issues, please\n    <a href=\'#\'\n        data-name="sign-up-link"\n        style="cursor:pointer"\n        onClick="twd.openWindow(\'https://us.etrade.com/e/t/alerts/setnewissuealerts\')">sign-up here</a>\n    </p>\n';

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _core = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    // const id = getId()
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'dropdown dropdown-right' },
	            (0, _core.jsx)(
	                'a',
	                { href: '#',
	                    'data-name': 'faq',
	                    className: 'btn btn-link',
	                    type: 'button',
	                    onClick: function onClick() {
	                        return (0, _twd.show)('faq');
	                    }
	                },
	                'FAQ'
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _predictiveSearch = __webpack_require__(927);
	
	var _predictiveSearch2 = _interopRequireDefault(_predictiveSearch);
	
	var _recentSearches = __webpack_require__(928);
	
	var _recentSearches2 = _interopRequireDefault(_recentSearches);
	
	var _savedSearches = __webpack_require__(929);
	
	var _savedSearches2 = _interopRequireDefault(_savedSearches);
	
	var _useGlobalSearch2 = __webpack_require__(930);
	
	var _useGlobalSearch3 = _interopRequireDefault(_useGlobalSearch2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useGlobalSearch = (0, _useGlobalSearch3.default)(),
	        inputRef = _useGlobalSearch.inputRef,
	        resultRef = _useGlobalSearch.resultRef,
	        mode = _useGlobalSearch.mode,
	        prevMode = _useGlobalSearch.prevMode,
	        Modes = _useGlobalSearch.Modes,
	        keyword = _useGlobalSearch.keyword,
	        onSearch = _useGlobalSearch.onSearch,
	        onFocus = _useGlobalSearch.onFocus,
	        onClear = _useGlobalSearch.onClear,
	        onBlur = _useGlobalSearch.onBlur,
	        onKeyPress = _useGlobalSearch.onKeyPress,
	        onKeyDown = _useGlobalSearch.onKeyDown,
	        onChange = _useGlobalSearch.onChange;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'form-group' },
	            _react2.default.createElement(
	                'div',
	                { className: 'form-icon-group icon-left', style: { overflow: "visible" } },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'material-icons', 'aria-hidden': 'true', style: { color: 'var(--primary-base-color)' } },
	                    'search'
	                ),
	                _react2.default.createElement('input', {
	                    'data-name': 'global-search',
	                    ref: inputRef,
	                    type: 'text',
	                    className: 'form-control',
	                    onFocus: onFocus,
	                    onBlur: onBlur,
	                    onKeyUp: onKeyPress,
	                    onKeyDown: onKeyDown,
	                    onChange: onChange,
	                    placeholder: 'CUSIP, Company Name, or Stock Symbol',
	                    'aria-label': 'Search'
	                }),
	                mode !== Modes.NONE && _react2.default.createElement(
	                    'button',
	                    {
	                        'aria-hidden': 'true',
	                        'data-name': 'global-search-clear',
	                        onClick: onClear,
	                        tabIndex: -1,
	                        style: {
	                            position: 'absolute',
	                            top: 0,
	                            right: '25px',
	                            zIndex: 2,
	                            cursor: 'pointer',
	                            background: '0 0',
	                            border: 'none'
	                        }
	                    },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'material-icons', 'aria-hidden': 'true', style: {
	                                pointerEvents: 'auto'
	                            } },
	                        'clear'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    {
	                        ref: resultRef,
	                        onMouseOver: function onMouseOver() {
	                            if (!(mode === Modes.SARCH || mode === Modes.SHOW_LAST)) return;
	                            resultRef.current.setAttribute('mouse-on-result', 'Y');
	                        },
	                        onMouseOut: function onMouseOut() {
	                            resultRef.current.removeAttribute('mouse-on-result');
	                        }
	                    },
	                    function () {
	                        var refresh = mode === Modes.SHOW_LAST && prevMode === Modes.NONE;
	
	                        return mode === Modes.SEARCH ? _react2.default.createElement(_predictiveSearch2.default, { onSearch: onSearch, keyword: keyword }) : mode === Modes.SHOW_LAST ? _react2.default.createElement(
	                            'div',
	                            { className: 'auto-suggest-menu' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: { overflow: 'hidden', margin: '10px' } },
	                                _react2.default.createElement(_recentSearches2.default, { onSearch: onSearch, refresh: refresh }),
	                                _react2.default.createElement(_savedSearches2.default, { onSearch: onSearch, refresh: refresh })
	                            )
	                        ) : null;
	                    }()
	                )
	            )
	        )
	    );
	};

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _usePredictiveSearch2 = __webpack_require__(931);
	
	var _usePredictiveSearch3 = _interopRequireDefault(_usePredictiveSearch2);
	
	var _twd = __webpack_require__(2);
	
	var _searchParams = __webpack_require__(469);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var keyword = _ref.keyword,
	        onSearch = _ref.onSearch;
	
	    var _usePredictiveSearch = (0, _usePredictiveSearch3.default)({ keyword: keyword }),
	        status = _usePredictiveSearch.status,
	        error = _usePredictiveSearch.error,
	        searchResults = _usePredictiveSearch.searchResults;
	
	    var symbols = _react2.default.useMemo(function () {
	        return (0, _searchParams.getSymbolSearchParams)(searchResults);
	    }, [searchResults]);
	    var issuers = _react2.default.useMemo(function () {
	        return (0, _searchParams.getIssuerSearchParams)(searchResults);
	    }, [searchResults]);
	    var cusips = _react2.default.useMemo(function () {
	        return (0, _searchParams.getCusipSearchParams)(searchResults, keyword);
	    }, [searchResults]);
	
	    return _react2.default.createElement(
	        'div',
	        {
	            'data-name': 'global-search-predictive-search',
	            className: 'auto-suggest-menu'
	        },
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: status, error: error, spinner: false },
	            !(0, _twd.isEmpty)(symbols) && '\xA0 Symbol(s)',
	            !(0, _twd.isEmpty)(symbols) && symbols.map(function (a, i) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: i,
	                        'data-name': 'global-search-predictive-search-symbol',
	                        className: 'auto-suggest-menu-item text-truncate',
	                        style: { color: "var(--primary-base-color)" },
	                        item: a,
	                        onClick: function onClick() {
	                            return onSearch(a);
	                        }
	                    },
	                    a.symbol
	                );
	            }),
	            !(0, _twd.isEmpty)(issuers) && '\xA0 Issuer(s)',
	            !(0, _twd.isEmpty)(issuers) && issuers.map(function (a, i) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: i,
	                        'data-name': 'global-search-predictive-search-issuer',
	                        className: 'auto-suggest-menu-item text-truncate',
	                        style: { color: "var(--primary-base-color)" },
	                        item: a,
	                        onClick: function onClick() {
	                            return onSearch(a);
	                        }
	                    },
	                    a.issue
	                );
	            }),
	            !(0, _twd.isEmpty)(cusips) && '\xA0 CUSIP(s)',
	            !(0, _twd.isEmpty)(cusips) && cusips.map(function (a, i) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: i,
	                        'data-name': 'global-search-predictive-search-cusip',
	                        className: 'auto-suggest-menu-item text-truncate',
	                        style: { color: "var(--primary-base-color)" },
	                        item: a,
	                        onClick: function onClick() {
	                            return onSearch(a);
	                        }
	                    },
	                    a.cusip
	                );
	            })
	        )
	    );
	};

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _useRecentSearches2 = __webpack_require__(932);
	
	var _useRecentSearches3 = _interopRequireDefault(_useRecentSearches2);
	
	var _twd = __webpack_require__(2);
	
	var _core = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	exports.default = function (_ref) {
	    var refresh = _ref.refresh,
	        onSearch = _ref.onSearch;
	
	    var _useRecentSearches = (0, _useRecentSearches3.default)({ refresh: refresh }),
	        status = _useRecentSearches.status,
	        Loading = _useRecentSearches.Loading,
	        recentSearches = _useRecentSearches.recentSearches;
	
	    return (0, _core.jsx)(
	        'div',
	        {
	            'data-name': 'global-search-recent-searches',
	            className: 'col-xs-12 col-md-6', css: style },
	        (0, _core.jsx)(
	            'div',
	            { className: 'text-bold' },
	            'Recent Searches'
	        ),
	        (0, _core.jsx)(
	            Loading,
	            { status: status, spinner: false },
	            recentSearches.map(function (a, i) {
	                return (0, _core.jsx)(
	                    'div',
	                    { key: i,
	                        'data-name': 'global-search-recent-search',
	                        className: 'auto-suggest-menu-item',
	                        item: a,
	                        onClick: function onClick() {
	                            return onSearch(a);
	                        } },
	                    (0, _core.jsx)(_twd.Flyout, {
	                        trigger: ['hover'],
	                        showIcon: false,
	                        isButton: false,
	                        html: (0, _twd.parseHtml)(a.description),
	                        className: 'link-button',
	                        labelStyle: { width: '100%' },
	                        trackMouseOnTip: false,
	                        label: (0, _core.jsx)(
	                            'span',
	                            { style: { display: 'block' }, className: 'text-truncate' },
	                            a.description
	                        )
	                    })
	                );
	            })
	        )
	    );
	};
	
	var style = _defineProperty({}, _twd.mediaQueries.notXs, {
	    float: 'left',
	    paddingBottom: '100%',
	    marginBottom: '-100%',
	    borderRight: '1px solid #e4e4e4'
	});

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _useSavedSearches2 = __webpack_require__(933);
	
	var _useSavedSearches3 = _interopRequireDefault(_useSavedSearches2);
	
	var _twd = __webpack_require__(2);
	
	var _core = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	exports.default = function (_ref) {
	    var refresh = _ref.refresh,
	        onSearch = _ref.onSearch;
	
	    var _useSavedSearches = (0, _useSavedSearches3.default)({ refresh: refresh }),
	        status = _useSavedSearches.status,
	        Loading = _useSavedSearches.Loading,
	        savedSearches = _useSavedSearches.savedSearches;
	
	    return (0, _core.jsx)(
	        'div',
	        {
	            'data-name': 'global-search-saved-searches',
	            className: 'col-xs-12 col-md-6', css: style },
	        (0, _core.jsx)(
	            'div',
	            { className: 'text-bold' },
	            'Saved Searches'
	        ),
	        (0, _core.jsx)(
	            Loading,
	            { status: status, spinner: false },
	            savedSearches.map(function (a, i) {
	                return (0, _core.jsx)(
	                    'div',
	                    { key: i,
	                        'data-name': 'global-search-saved-search',
	                        className: 'auto-suggest-menu-item',
	                        item: a,
	                        onClick: function onClick() {
	                            return onSearch(a);
	                        } },
	                    (0, _core.jsx)(_twd.Flyout, {
	                        trigger: ['hover'],
	                        showIcon: false,
	                        isButton: false,
	                        html: (0, _twd.parseHtml)(a.description),
	                        className: 'link-button',
	                        labelStyle: { display: 'inline-block' },
	                        trackMouseOnTip: false,
	                        label: (0, _core.jsx)(
	                            'span',
	                            { className: 'text-truncate' },
	                            a.description
	                        )
	                    })
	                );
	            }),
	            (0, _core.jsx)(
	                'button',
	                {
	                    'data-name': 'global-search-saved-searches-view-all',
	                    className: 'btn btn-link', onClick: onViewAll },
	                'View all'
	            )
	        )
	    );
	};
	
	var style = _defineProperty({}, _twd.mediaQueries.notXs, {
	    float: 'left',
	    paddingBottom: '100%',
	    marginBottom: '-100%'
	});
	
	var onViewAll = function onViewAll(e) {
	    (0, _twd.showModal)('manage-saved-searches', { source: e.target });
	};

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _formik = __webpack_require__(62);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _searchParams = __webpack_require__(469);
	
	var _genericSearch = __webpack_require__(468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var $ = global.$;
	
	var Modes = {
	    'NONE': 'none',
	    'SHOW_LAST': 'show_last',
	    'SEARCH': 'search'
	};
	
	exports.default = function () {
	    var inputRef = _react2.default.useRef();
	    var resultRef = _react2.default.useRef();
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        keyword = _React$useState2[0],
	        setKeyword = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(Modes.NONE),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        mode = _React$useState4[0],
	        setMode = _React$useState4[1];
	
	    var prevMode = (0, _twd.usePrevious)(mode);
	
	    var lock = false;
	    var onFocus = function onFocus(e) {
	        onChange(e);
	    };
	    var onClear = function onClear() {
	        lock = true;
	        var e = inputRef.current;
	        e.value = '';
	        e.focus();
	    };
	
	    var onBlur = function onBlur() {
	        setTimeout(function () {
	            var inputEl = inputRef.current;
	            if (resultRef.current.getAttribute('mouse-on-result')) {
	                inputEl.focus();
	                return;
	            }
	
	            if (lock) {
	                lock = false;
	                return;
	            }
	
	            setKeyword('');
	            setMode(Modes.NONE);
	
	            var rs = $(inputEl).closest('.container').find(':focusable').get();
	            var n = rs.indexOf(inputEl);
	            var a = rs[inputEl.shiftKeyed ? n - 1 : n + 1];
	            if (a) a.focus();
	        }, 250);
	    };
	
	    var onChange = function onChange(e) {
	        var txt = e.target.value;
	        setKeyword(txt ? txt.toUpperCase() : txt);
	        setMode(txt ? Modes.SEARCH : Modes.SHOW_LAST);
	    };
	
	    var onKeyPress = function onKeyPress(e) {
	        var key = e.keyCode || e.key || e.which;
	
	        if (!(key === 13 || key === 'Enter')) return;
	
	        e.preventDefault();
	
	        var el = resultRef.current;
	        var a = $(el).find('.auto-suggest-menu-item.focus')[0];
	        if (a) {
	            var i = (0, _twd.getEventHandlers)(a).item;
	            if (!i) return;
	
	            e.target.blur();
	            onSearch(i);
	            return;
	        }
	
	        var txt = (0, _twd.stringFrom)(e.target.value).trim();
	        if (!txt) return;
	
	        {
	            var gsp = (0, _genericSearch.getGenericSearch)(txt.toLowerCase());
	            if (gsp && !gsp.error) {
	                e.target.blur();
	                if ((0, _twd.isObject)(gsp)) {
	                    return onSearch({ searchParams: gsp });
	                }
	
	                if ((0, _formik.isFunction)(gsp)) {
	                    return gsp();
	                }
	                return;
	            }
	        }
	
	        e.persist();
	
	        setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, _a, rs, ps, k, idx, sp;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/securitysuggestions',
	                                method: 'GET',
	                                params: {
	                                    keyword: txt.trim(),
	                                    page: 1,
	                                    start: 0,
	                                    limit: 10
	                                }
	                            });
	
	                        case 3:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            _context.next = 7;
	                            return data;
	
	                        case 7:
	                            _a = _context.sent;
	                            rs = (0, _twd.arrayFrom)(_a.securities);
	                            ps = (0, _searchParams.getSearchParams)(rs, txt);
	                            k = txt.trim().toLowerCase();
	                            idx = Math.max(ps.findIndex(function (a) {
	                                return isMatch(a, k);
	                            }), 0);
	                            sp = ps[idx];
	
	                            if (sp) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 15:
	
	                            (0, _twd.track)('Bond Resource Center Search', { search_term: txt.trim() });
	
	                            e.target.blur();
	                            onSearch(sp);
	                            _context.next = 22;
	                            break;
	
	                        case 20:
	                            _context.prev = 20;
	                            _context.t0 = _context['catch'](0);
	
	                        case 22:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 20]]);
	        })));
	    };
	
	    var isMatch = function isMatch(a, k) {
	        return a.symbol && a.symbol.toLowerCase() === k || a.issue && a.issue.toLowerCase() === k || a.cusip && a.cusip.toLowerCase() === k;
	    };
	
	    var onKeyDown = function onKeyDown(e) {
	        var key = e.keyCode || e.key || e.which;
	
	        var isEsc = key === 27 || key === 'Escape';
	        var isTab = key === 9 || key === 'Tab';
	        var isExit = mode !== Modes.SEARCH && (isEsc || isTab);
	        var inputEl = inputRef.current;
	        inputEl.shiftKeyed = e.shiftKey;
	
	        if (isExit) {
	            e.preventDefault();
	            resultRef.current.removeAttribute('mouse-on-result');
	            inputEl.blur();
	
	            return;
	        }
	
	        if (mode !== Modes.SEARCH) return;
	
	        if (isEsc) {
	            inputEl.value = '';
	            setKeyword('');
	            setMode(Modes.SHOW_LAST);
	            return;
	        }
	
	        if (key === 38 || key === 'ArrowUp') {
	            var el = resultRef.current;
	
	            var a = $(el).find('.auto-suggest-menu-item.focus').removeClass('focus').prev('.auto-suggest-menu-item').addClass('focus');
	            if (a.length > 0) return;
	
	            $(el).find('.auto-suggest-menu-item').last().addClass('focus');
	            return;
	        }
	
	        if (key === 40 || key === 'ArrowDown') {
	            var _el = resultRef.current;
	
	            var _a2 = $(_el).find('.auto-suggest-menu-item.focus').removeClass('focus').next('.auto-suggest-menu-item').addClass('focus');
	            if (_a2.length > 0) return;
	
	            $(_el).find('.auto-suggest-menu-item').first().addClass('focus');
	            return;
	        }
	    };
	
	    var onSearch = function onSearch(_ref3) {
	        var searchParams = _ref3.searchParams;
	
	        if (resultRef.current) {
	            resultRef.current.removeAttribute('mouse-on-result');
	        }
	
	        setMode(Modes.NONE);
	        (0, _twd.show)('offerings', {
	            searchParams: Object.assign({
	                offeringType: ['ask-side'],
	                origin: 'global-search'
	            }, (0, _twd.cleanObject)(searchParams)),
	            _ts: Date.now()
	        });
	    };
	
	    return {
	        mode: mode, prevMode: prevMode, Modes: Modes, keyword: keyword, onSearch: onSearch,
	        inputRef: inputRef, resultRef: resultRef,
	        onFocus: onFocus, onClear: onClear, onBlur: onBlur, onKeyPress: onKeyPress, onKeyDown: onKeyDown, onChange: onChange };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _genericSearch = __webpack_require__(468);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('global-search.predictive-search', {});
	
	exports.default = function (_ref) {
	    var keyword = _ref.keyword;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(''),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        error = _React$useState4[0],
	        setError = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        searchResults = _React$useState6[0],
	        setSearchResults = _React$useState6[1];
	
	    var timerId = _react2.default.useRef();
	    var lastKeyword = _react2.default.useRef(state.value.lastKeyword);
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        if (timerId.current) {
	            clearTimeout(timerId.current);
	            timerId.current = 0;
	        }
	
	        var dismounted = false;
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var gs, _ref3, data, abort, a, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (keyword) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            gs = (0, _genericSearch.getGenericSearch)(keyword);
	
	                            if (!gs) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            setSearchResults([]);
	                            setError(gs.error || '');
	                            setStatus(gs.error ? _twd.Status.FAILED_TO_LOAD : _twd.Status.LOADING);
	                            return _context.abrupt('return');
	
	                        case 8:
	                            if (!(lastKeyword.current === keyword && searchResults.length > 0)) {
	                                _context.next = 10;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 10:
	
	                            state.set({ lastKeyword: keyword });
	                            setStatus(_twd.Status.LOADING);
	                            setError('');
	                            lastKeyword.current = keyword;
	
	                            _context.prev = 14;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 18;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/securitysuggestions',
	                                method: 'GET',
	                                params: {
	                                    keyword: keyword.trim(),
	                                    page: 1,
	                                    start: 0,
	                                    limit: 10
	                                }
	                            });
	
	                        case 18:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            abort = _ref3.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 24;
	                            return data;
	
	                        case 24:
	                            a = _context.sent;
	
	                            if (!dismounted) {
	                                _context.next = 27;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 27:
	
	                            (0, _twd.track)('Bond Resource Center Search', { search_term: keyword.trim() });
	
	                            rs = (a.securities || []).slice(0, 10).map(function (a) {
	                                a.searchParams = {
	                                    holdCusip: [a.cusip],
	                                    holdIdentifierLabel: "holdCusip",
	                                    holdIdentifiers: [a.cusip],
	                                    offeringType: ['ask-side']
	                                };
	                                return a;
	                            });
	
	                            if (!(rs.length === 0)) {
	                                _context.next = 31;
	                                break;
	                            }
	
	                            throw new Error('empty-result');
	
	                        case 31:
	
	                            setSearchResults(rs);
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 42;
	                            break;
	
	                        case 35:
	                            _context.prev = 35;
	                            _context.t0 = _context['catch'](14);
	
	                            if (!dismounted) {
	                                _context.next = 39;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 39:
	
	                            setSearchResults([]);
	                            setError('\n                    There are no results that match your search for\n                    <span class="text-bold"><u>' + keyword + '</u></span>.\n                    Please review your search criteria and try again.\n                ');
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 42:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[14, 35]]);
	        })), 500);
	
	        return function () {
	            dismounted = true;
	
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	            if (timerId.current) {
	                clearTimeout(timerId.current);
	                timerId.current = 0;
	            }
	        };
	    }, [keyword]);
	
	    return { status: status, error: error, keyword: keyword, searchResults: searchResults };
	};

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('global-search.recent-searches', { recentSearches: [] });
	
	exports.default = function (_ref) {
	    var refresh = _ref.refresh;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        recentSearches = _React$useState4[0],
	        setRecentSearches = _React$useState4[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        var dismounted = false;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, data, abort, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(status !== _twd.Status.LOADING)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _ajax = (0, _twd.ajax)({
	                                url: '/esb/generic/masterConfig',
	                                params: ['portfolio_recent_searches']
	                            }), data = _ajax.data, abort = _ajax.abort;
	
	                            lastAbort.current = abort;
	
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            _context.t0 = _context.sent.portfolio_recent_searches;
	
	                            if (_context.t0) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.t0 = [];
	
	                        case 11:
	                            _context.t1 = function (a) {
	                                a.searchParams = (a.queryText || {}).metadata || a.queryText || {};
	                                return a;
	                            };
	
	                            _context.t2 = function (a) {
	                                return a.searchParams.searchType === 'offers';
	                            };
	
	                            rs = _context.t0.map(_context.t1).filter(_context.t2).slice(0, 5);
	
	                            if (!dismounted) {
	                                _context.next = 16;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 16:
	
	                            state.value.recentSearches = rs;
	                            setRecentSearches(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 26;
	                            break;
	
	                        case 21:
	                            _context.prev = 21;
	                            _context.t3 = _context['catch'](2);
	
	                            if (!dismounted) {
	                                _context.next = 25;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 25:
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 26:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 21]]);
	        }))();
	
	        return function () {
	            dismounted = true;
	
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	        };
	    }, []);
	
	    return { status: status, Loading: _twd.Loading, recentSearches: recentSearches };
	};

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('global-search.saved-searches', { savedSearches: [] });
	
	exports.default = function (_ref) {
	    var refresh = _ref.refresh;
	
	    var _React$useState = _react2.default.useState(refresh ? _twd.Status.LOADING : _twd.Status.LOADED),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(refresh ? [] : state.value.savedSearches),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        savedSearches = _React$useState4[0],
	        setSavedSearches = _React$useState4[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        var dismounted = false;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, data, abort, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(status !== _twd.Status.LOADING)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _ajax = (0, _twd.ajax)({
	                                url: '/esb/portfolio/savedQuerySearchByCurrentUser',
	                                method: 'GET'
	                            }), data = _ajax.data, abort = _ajax.abort;
	
	
	                            lastAbort.current = abort;
	
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            _context.t0 = _context.sent;
	
	                            if (_context.t0) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            _context.t0 = [];
	
	                        case 11:
	                            _context.t1 = function (a) {
	                                a.modified = new Date(a.modified);
	                                a.queryText = (0, _twd.parseJson)(a.formText);
	                                a.searchParams = (a.queryText || {}).metadata || a.queryText || {};
	                                return a;
	                            };
	
	                            _context.t2 = function (a) {
	                                return a.searchParams.searchType === 'offers';
	                            };
	
	                            _context.t3 = function (a, b) {
	                                return b.modified.valueOf() - a.modified.valueOf();
	                            };
	
	                            rs = _context.t0.map(_context.t1).filter(_context.t2).sort(_context.t3).slice(0, 5);
	
	                            if (!dismounted) {
	                                _context.next = 17;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 17:
	
	                            state.value.savedSearches = rs;
	                            setSavedSearches(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 27;
	                            break;
	
	                        case 22:
	                            _context.prev = 22;
	                            _context.t4 = _context['catch'](2);
	
	                            if (!dismounted) {
	                                _context.next = 26;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 26:
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 27:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 22]]);
	        }))();
	
	        return function () {
	            dismounted = true;
	
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	        };
	    }, []);
	
	    return { status: status, Loading: _twd.Loading, savedSearches: savedSearches };
	};

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bondSupport = __webpack_require__(925);
	
	var _bondSupport2 = _interopRequireDefault(_bondSupport);
	
	var _globalSearch = __webpack_require__(926);
	
	var _globalSearch2 = _interopRequireDefault(_globalSearch);
	
	var _messages = __webpack_require__(939);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _menu = __webpack_require__(938);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _navTabs = __webpack_require__(941);
	
	var _navTabs2 = _interopRequireDefault(_navTabs);
	
	var _twd = __webpack_require__(2);
	
	var _App = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useAppContext = (0, _App.useAppContext)(),
	        view = _useAppContext.view;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-6' },
	                    _react2.default.createElement(
	                        'h1',
	                        {
	                            onClick: function onClick() {
	                                return (0, _twd.show)('overview');
	                            }
	                        },
	                        'Bond Resource Center'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-sm-6 text-right' },
	                    _react2.default.createElement(_bondSupport2.default, null)
	                )
	            ),
	            (!view || view === 'overview') && _react2.default.createElement(_messages2.default, null),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-6' },
	                    _react2.default.createElement(_globalSearch2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-6' },
	                    _react2.default.createElement(_menu2.default, null)
	                )
	            ),
	            _react2.default.createElement(_navTabs2.default, null)
	        )
	    );
	};

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var holdings = _ref.holdings,
	        account = _ref.account;
	
	
	    var acctHoldings = (0, _twd.arrayFrom)(holdings).filter(function (r) {
	        return r.acctNo === account;
	    });
	
	    if (acctHoldings.length === 0) {
	        return _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'holdings-modal-not-found',
	                className: 'text-center' },
	            _react2.default.createElement(
	                'div',
	                { className: 'vertical-offset-xs' },
	                _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'small-header vertical-offset-xxs' },
	                    'No holdings found.'
	                )
	            )
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive', style: { maxWidth: '100%', overflowY: 'auto' } },
	        _react2.default.createElement(
	            'table',
	            { 'data-name': 'holdings-modal-table', className: 'table table-striped' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { style: { maxWidth: '300px' } },
	                        'Issuer'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Qty'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Coupon'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Maturity'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Action'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                acctHoldings.map(function (r, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        {
	                            'data-name': 'holdings-modal-row',
	                            key: i },
	                        _react2.default.createElement(
	                            'td',
	                            {
	                                style: { maxWidth: '300px' },
	                                className: 'text-left text-truncate' },
	                            _twd.fmt.issuer({
	                                issuer: r.issue,
	                                showBackLink: 'N',
	                                cusip: r.cusip
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.qty(r.qty)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.cpn(r.coupon)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right', style: { overflow: 'visible' } },
	                            _twd.fmt.mdy(r.maturity)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.sell({
	                                cusip: r.cusip,
	                                acctNo: r.acctNo,
	                                qty: r.qty,
	                                sourceAction: 'H',
	                                style: { padding: '3px' } })
	                        )
	                    );
	                })
	            )
	        )
	    );
	};

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useHoldingsModal = __webpack_require__(937);
	
	var _useHoldingsModal2 = _interopRequireDefault(_useHoldingsModal);
	
	var _grid = __webpack_require__(935);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var acctNo = _ref.acctNo;
	
	    var _useHoldingModals = (0, _useHoldingsModal2.default)({ acctNo: acctNo }),
	        status = _useHoldingModals.status,
	        accounts = _useHoldingModals.accounts,
	        holdings = _useHoldingModals.holdings,
	        account = _useHoldingModals.account,
	        setAccount = _useHoldingModals.setAccount;
	
	    _react2.default.useEffect(function () {
	        setTimeout(function () {
	            (0, _twd.$)('#modal :focusable').eq(0).focus();
	        }, 200);
	    }, [status]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'holdings-modal',
	                className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'holdings-modal-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Holdings'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            _twd.Loading,
	                            { status: status },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row vertical-offset-base' },
	                                _react2.default.createElement(Select, { account: account, accounts: accounts, setAccount: setAccount })
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-left', style: {
	                                            background: '#ffffff',
	                                            border: 'solid 1px #e4e4e4',
	                                            padding: '10px',
	                                            maxHeight: '300px',
	                                            overflowY: 'auto'
	                                        } },
	                                    _react2.default.createElement(_grid2.default, { holdings: holdings, account: account })
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement('div', { className: 'col-md-4' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-4' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'holdings-modal-close-button',
	                                    className: 'btn btn-block btn-primary',
	                                    type: 'button',
	                                    onClick: _twd.hideModal
	                                },
	                                'Close'
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'col-md-4' })
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Select = function Select(_ref2) {
	    var account = _ref2.account,
	        accounts = _ref2.accounts,
	        setAccount = _ref2.setAccount;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'col-md-2 col-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-md-8 col-xs-12 from-group',
	                style: { paddingLeft: '0px', paddingRight: '0px' }
	            },
	            _react2.default.createElement(_twd.Fields.SelectMulti, {
	                dataName: 'header-holdings-modal-account',
	                label: _react2.default.createElement(
	                    'label',
	                    { className: 'label' },
	                    'Account'
	                ),
	
	                emptyText: '',
	                allText: '',
	
	                showSelectAll: false,
	                isMultiSelect: false,
	
	                options: accounts.map(function (a) {
	                    return { label: a.title, value: a.acctNo };
	                }),
	                style: { marginBottom: '0px' },
	                optionCheckboxLabelConfig: {
	                    className: "text-truncate"
	                },
	
	                placeholder: function placeholder(_ref3) {
	                    var emptyText = _ref3.emptyText,
	                        allText = _ref3.allText,
	                        values = _ref3.values,
	                        options = _ref3.options;
	
	                    var a = options.filter(function (_ref4) {
	                        var value = _ref4.value;
	                        return value === account;
	                    })[0];
	                    return a && a.label || emptyText;
	                },
	
	                onSelect: function onSelect(acct) {
	                    setAccount(acct.value);
	                }
	            })
	        ),
	        _react2.default.createElement('div', { className: 'col-md-2 col-xs' })
	    );
	};

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function (_ref) {
	    var acctNo = _ref.acctNo;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        accounts = _React$useState4[0],
	        setAccounts = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        holdings = _React$useState6[0],
	        setHoldings = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(acctNo),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        account = _React$useState8[0],
	        setAccount = _React$useState8[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        ;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, data, abort, rs, accts, _holdings;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.prev = 1;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _ajax = (0, _twd.ajax)({
	                                url: '/esb/retailservice/holdingAndAlertDataService/getUserHoldings',
	                                method: 'GET'
	                            }), data = _ajax.data, abort = _ajax.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 7;
	                            return data;
	
	                        case 7:
	                            rs = _context.sent;
	
	                            lastAbort.current = null;
	
	                            accts = (0, _twd.arrayFrom)(rs.accounts).filter(function (a) {
	                                return a.title && a.title.trim();
	                            }).sort((0, _twd.sortFn)(function (a) {
	                                return a.title.trim();
	                            }));
	
	
	                            setAccounts(accts);
	                            setAccount(account || (accts[0] || {}).acctNo);
	                            _holdings = (0, _twd.arrayFrom)(rs.holdings).map(function (a) {
	                                var m = a.maturity;
	                                if (!m) return a;
	
	                                var d = new Date(m);
	                                if (!isNaN(d)) {
	                                    a.maturity = _twd.fmt.mdy(d);
	                                }
	                                return a;
	                            }).filter(function (_ref3) {
	                                var maturity = _ref3.maturity;
	
	                                var isMatured = (0, _twd.parseDate)(maturity) < Date.now();
	                                return !isMatured;
	                            }).sort((0, _twd.sortFn)(function (_ref4) {
	                                var issue = _ref4.issue,
	                                    maturity = _ref4.maturity;
	
	                                return (issue || '').trim() + '-' + _twd.fmt.fmtDt((0, _twd.parseDate)(maturity), 'yyyy-MM-dd');
	                            }));
	
	                            setHoldings(_holdings);
	
	                            setStatus(_twd.Status.LOADED);
	                            setTimeout(function () {
	                                (0, _twd.publish)('user-holdings', rs);
	                            });
	                            _context.next = 21;
	                            break;
	
	                        case 18:
	                            _context.prev = 18;
	                            _context.t0 = _context['catch'](1);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 21:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[1, 18]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) {
	                lastAbort.current();
	            }
	        };
	    }, []);
	
	    return {
	        status: status,
	        accounts: accounts, holdings: holdings,
	        account: account, setAccount: setAccount
	    };
	};

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _alerts = __webpack_require__(924);
	
	var _alerts2 = _interopRequireDefault(_alerts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'text-right space-around' },
	        _react2.default.createElement(
	            'a',
	            { href: '#',
	                'data-name': 'orders-link',
	                style: { marginRight: '5px' },
	                className: 'btn btn-link',
	                onClick: function onClick() {
	                    (0, _twd.publish)('orders_reset_filters');
	                    (0, _twd.show)('orders', { _ts: Date.now() });
	                }
	            },
	            'Orders'
	        ),
	        _react2.default.createElement(
	            'button',
	            {
	                'data-name': 'holdings-link',
	                style: { marginRight: '5px' },
	                className: 'btn btn-link',
	                onClick: function onClick(e) {
	                    return (0, _twd.showModal)('holdings', { source: e.target });
	                }
	            },
	            'Holdings'
	        ),
	        _react2.default.createElement(_alerts2.default, null)
	    );
	};

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useMessages2 = __webpack_require__(940);
	
	var _useMessages3 = _interopRequireDefault(_useMessages2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useMessages = (0, _useMessages3.default)(),
	        status = _useMessages.status,
	        Status = _useMessages.Status,
	        messages = _useMessages.messages,
	        onDismiss = _useMessages.onDismiss;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        status === Status.LOADED && messages.length > 0 && messages.map(function (m, i) {
	            return _react2.default.createElement(Message, { key: i, message: m, onDismiss: onDismiss });
	        })
	    );
	};
	
	var Message = function Message(_ref) {
	    var msg = _ref.message,
	        onDismiss = _ref.onDismiss;
	
	
	    var header = msg.header || 'message-' + msg.seq;
	    var content = '\n    <h4 aria-live="assertive" class="universal-message-heading vertical-offset-sm">' + header + '</h4>\n    ' + msg.message + '\n    ';
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(
	                'div',
	                {
	                    'data-name': 'messages-message',
	                    className: 'universal-message universal-message-info universal-message-dismissible',
	                    role: 'alert' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'messages-message-close',
	                        className: 'close',
	                        onClick: function onClick() {
	                            return onDismiss(msg.messageId);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'i',
	                        { className: 'material-icons', 'aria-hidden': 'true' },
	                        'close'
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'sr-only' },
	                        'Close'
	                    )
	                ),
	                _react2.default.createElement('div', {
	                    'data-name': 'messages-message-content',
	                    className: 'universal-message-content',
	                    style: { width: '100%' },
	                    dangerouslySetInnerHTML: { __html: content } })
	            )
	        )
	    );
	};

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _App = __webpack_require__(137);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = {};
	
	exports.default = function () {
	    var _useAppContext = (0, _App.useAppContext)(),
	        ajax = _useAppContext.ajax,
	        Status = _useAppContext.Status;
	
	    var msg = state.messages;
	    var initStatus = !msg ? Status.LOADING : Status.LOADED;
	
	    var _React$useState = _react2.default.useState(initStatus),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(msg || []),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        messages = _React$useState4[0],
	        setMessages = _React$useState4[1];
	
	    var updateMessages = function updateMessages(a) {
	        state.messages = a;
	        setMessages(a);
	    };
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, data, a;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(status !== Status.LOADING)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	                            _ajax = ajax({
	                                url: '/esb/administration/helpMessageCenterTab/getMessageCenterByBrandIdentifier',
	                                method: 'GET',
	                                params: {
	                                    brandname: (0, _all.getBrand)(),
	                                    identifier: 'overview'
	                                }
	                            }), data = _ajax.data;
	                            _context.next = 6;
	                            return data;
	
	                        case 6:
	                            _context.t1 = _context.sent[0];
	
	                            if (_context.t1) {
	                                _context.next = 9;
	                                break;
	                            }
	
	                            _context.t1 = {};
	
	                        case 9:
	                            _context.t0 = _context.t1.messageCenterDetails;
	
	                            if (_context.t0) {
	                                _context.next = 12;
	                                break;
	                            }
	
	                            _context.t0 = [];
	
	                        case 12:
	                            _context.t2 = function (a, b) {
	                                return a.seq - b.seq;
	                            };
	
	                            a = _context.t0.sort(_context.t2);
	
	                            updateMessages(a);
	
	                            setStatus(Status.LOADED);
	                            _context.next = 21;
	                            break;
	
	                        case 18:
	                            _context.prev = 18;
	                            _context.t3 = _context['catch'](2);
	
	                            setStatus(Status.FAILED_TO_LOAD);
	
	                        case 21:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 18]]);
	        }))();
	    }, [status]);
	
	    var onDismiss = function onDismiss(messageId) {
	        var a = messages.filter(function (m) {
	            return m.messageId !== messageId;
	        });
	        updateMessages(a);
	    };
	
	    return { status: status, Status: Status, messages: messages, onDismiss: onDismiss };
	};

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _App = __webpack_require__(137);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useAppContext = (0, _App.useAppContext)(),
	        view = _useAppContext.view;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: view === 'portfolio-report' ? 'row' : 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    { 'data-name': 'header-nav-tabs', className: 'nav-tabs nav-tabs-border' },
	                    _react2.default.createElement(
	                        'ul',
	                        { role: 'tablist' },
	                        _react2.default.createElement(
	                            'li',
	                            { role: 'presentation',
	                                className: !view || view === 'overview' ? 'active' : '' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'header-overview-nav-tab',
	                                    'data-toggle': 'tab',
	                                    role: 'tab',
	                                    'aria-selected': !view || view === 'overview',
	                                    onClick: function onClick() {
	                                        return (0, _twd.show)('overview');
	                                    }
	                                },
	                                'Overview'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { role: 'presentation',
	                                className: view === 'corporates' ? 'active' : '' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'header-corporates-nav-tab',
	                                    'data-toggle': 'tab',
	                                    role: 'tab',
	                                    'aria-selected': view === 'corporates',
	                                    onClick: function onClick() {
	                                        return (0, _twd.show)('corporates');
	                                    }
	                                },
	                                'Corporates'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { role: 'presentation',
	                                className: view === 'municipals' ? 'active' : '' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'header-municipals-nav-tab',
	                                    'data-toggle': 'tab',
	                                    role: 'tab',
	                                    'aria-selected': view === 'municipals',
	                                    onClick: function onClick() {
	                                        return (0, _twd.show)('municipals');
	                                    }
	                                },
	                                'Municipals'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { role: 'presentation',
	                                className: view === 'advanced-screener' || view === 'offerings' || view === 'search-results' ? 'active' : '' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'header-advanced-screener-nav-tab',
	                                    'data-toggle': 'tab',
	                                    role: 'tab',
	                                    'aria-selected': view === 'advanced-screener' || view === 'offerings' || view === 'search-results',
	                                    onClick: function onClick() {
	                                        return (0, _twd.show)('advanced-screener');
	                                    }
	                                },
	                                'Advanced Screener'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { role: 'presentation',
	                                className: view === 'tools-and-resources' || view === 'tools' || view === 'treasury-auctions' || view === 'portfolio-report' ? 'active' : '' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'header-tools-and-resources-nav-tab',
	                                    'data-toggle': 'tab',
	                                    role: 'tab',
	                                    'aria-selected': view === 'tools-and-resources' || view === 'tools' || view === 'treasury-auctions' || view === 'portfolio-report',
	                                    onClick: function onClick() {
	                                        return (0, _twd.show)('tools-and-resources');
	                                    }
	                                },
	                                'Tools and Resources'
	                            )
	                        ),
	                        (0, _twd.getConfig)('entitlements.ETradeOrderTicket', 'No') === 'Yes' ? _react2.default.createElement(
	                            'li',
	                            { role: 'presentation',
	                                className: view === 'order-ticket' ? 'active' : '' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'header-order-ticket-nav-tab',
	                                    'data-toggle': 'tab',
	                                    role: 'tab',
	                                    'aria-selected': view === 'order-ticket',
	                                    onClick: function onClick() {
	                                        return (0, _twd.show)('order-ticket', { ts: Date.now() });
	                                    }
	                                },
	                                'Place a Trade'
	                            )
	                        ) : null
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	__webpack_require__(1976);
	
	__webpack_require__(1978);
	
	__webpack_require__(789);
	
	var _jquery = __webpack_require__(1817);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(1777);
	
	__webpack_require__(1779);
	
	__webpack_require__(1222);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(303);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(2);
	
	var _App = __webpack_require__(137);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	global.jQuery = global.$ = _jquery2.default;
	
	var root = document.getElementById('root');
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), root);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var items = __webpack_require__(1830);
	
	var state = (0, _twd.getState)('municipals.education', {
	    tab: 'getting-started'
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.tab || 'getting-started'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tab = _React$useState2[0],
	        setTab_ = _React$useState2[1];
	
	    var setTab = _react2.default.useCallback(function (m) {
	        state.set({ tab: m });
	        setTab_(m);
	    }, []);
	
	    var tabItems = items[tab] || [];
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'msrb-municipal-market-education', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'MSRB Municipal Market Education'
	                    ),
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        'The Municipal Securities Rulemaking Board (MSRB), the self-regulatory organization that promotes a fair and efficient municipal bond market, provides free resources to learn about municipal bonds and the municipal securities market. The MSRB operates the free Electronic Municipal Market Access (EMMA\xAE) website to provide public access to municipal bond data and disclosures. The below MSRB resources and more are available at the Municipal Securities Rulemaking Board\u2019s website, ',
	                        (0, _core.jsx)(
	                            'a',
	                            { target: 'blank', href: 'https://www.msrb.org' },
	                            'www.msrb.org'
	                        ),
	                        '.'
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12 vertical-offset-sm' },
	                    (0, _core.jsx)(
	                        'div',
	                        {
	                            'data-name': 'municipals-market-educations-nav-tabs',
	                            className: 'nav-tabs' },
	                        (0, _core.jsx)(
	                            'ul',
	                            null,
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'getting-started' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'municipals-market-educations-getting-started-nav-tab',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('getting-started');
	                                        } },
	                                    'Getting Started'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'the-municipal-market' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'municipals-market-educations-the-municipal-market-nav-tab',
	                                        className: 'subhead',
	                                        onClick: function onClick() {
	                                            return setTab('the-municipal-market');
	                                        } },
	                                    'The Municipal Market'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            tabItems.map(function (a, i) {
	                var _a = _slicedToArray(a, 3),
	                    icon = _a[0],
	                    text = _a[1],
	                    url = _a[2];
	
	                return (0, _core.jsx)(
	                    'div',
	                    { key: i, className: 'row vertical-offset-sm' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12' },
	                        _twd.icons[icon],
	                        (0, _core.jsx)(
	                            'a',
	                            { href: '#',
	                                'data-name': 'municipals-market-educations-item',
	                                className: 'tiny-header',
	                                style: {
	                                    paddingLeft: '10px',
	                                    color: 'var(--primary-base-color)',
	                                    cursor: 'pointer'
	                                },
	                                onClick: function onClick() {
	                                    return onUrl({ url: url });
	                                }
	                            },
	                            text
	                        )
	                    )
	                );
	            })
	        )
	    );
	};
	
	var onUrl = function onUrl(_ref) {
	    var url = _ref.url;
	
	    (0, _twd.openWindow)(url, '_blank');
	};

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    'Transportation': {
	        label: 'Transportation',
	        searchParams: {
	            holdIssueType: ['Envrnmntl', 'Green'],
	            holdUseOfProceeds: ['Transportation']
	        },
	        icon: _react2.default.createElement(
	            'svg',
	            { width: '61', height: '49', viewBox: '0 0 61 49', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M30.8516 0.229004H9.85156C4.87156 0.229004 0.851562 4.249 0.851562 9.229V33.229C0.851562 38.209 4.87156 42.229 9.85156 42.229L6.85156 45.229V48.229H9.85156L15.8516 42.139L21.8516 42.229V27.229H6.85156V6.169L33.8516 6.229V12.229H39.8516V9.229C39.8516 4.249 35.8316 0.229004 30.8516 0.229004ZM9.85156 30.229C11.5016 30.229 12.8516 31.579 12.8516 33.229C12.8516 34.879 11.5016 36.229 9.85156 36.229C8.20156 36.229 6.85156 34.879 6.85156 33.229C6.85156 31.579 8.20156 30.229 9.85156 30.229ZM56.5616 17.209C56.1416 16.009 55.0016 15.229 53.6516 15.229H32.0816C30.7016 15.229 29.5916 16.009 29.1416 17.209L24.8516 29.539L24.8816 46.069C24.8816 47.209 25.8116 48.229 26.9516 48.229H28.8116C29.9516 48.229 30.8516 47.089 30.8516 45.949V42.229H54.8516V45.949C54.8516 47.089 55.7816 48.229 56.9216 48.229H58.7516C59.8916 48.229 60.8216 47.209 60.8216 46.069L60.8516 41.959V29.539L56.5616 17.209ZM32.0816 18.229H53.6516L56.7416 27.229H28.9916L32.0816 18.229ZM30.8516 36.229C29.2016 36.229 27.8516 34.879 27.8516 33.229C27.8516 31.579 29.2016 30.229 30.8516 30.229C32.5016 30.229 33.8516 31.579 33.8516 33.229C33.8516 34.879 32.5016 36.229 30.8516 36.229ZM54.8516 36.229C53.2016 36.229 51.8516 34.879 51.8516 33.229C51.8516 31.579 53.2016 30.229 54.8516 30.229C56.5016 30.229 57.8516 31.579 57.8516 33.229C57.8516 34.879 56.5016 36.229 54.8516 36.229Z', fill: '#767676' })
	        )
	    },
	
	    'Water': {
	        label: 'Water & Power',
	        searchParams: {
	            holdIssueType: ['Envrnmntl', 'Green'],
	            holdUseOfProceeds: ['Utilities']
	        },
	        icon: _react2.default.createElement(
	            'svg',
	            { width: '55', height: '49', viewBox: '0 0 55 49', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M54.5 30.229C54.5 28.429 53 27.229 51.5 27.229H45.5V33.229H51.5C53 33.229 54.5 32.029 54.5 30.229Z', fill: '#767676' }),
	            _react2.default.createElement('path', { d: 'M51.5 39.229H45.5V45.229H51.5C53 45.229 54.5 43.729 54.5 42.229C54.5 40.729 53 39.229 51.5 39.229Z', fill: '#767676' }),
	            _react2.default.createElement('path', { d: 'M27.5 30.229H21.5V42.229H27.5C27.5 45.529 30.2 48.229 33.5 48.229H42.5V24.229H33.5C30.2 24.229 27.5 26.929 27.5 30.229Z', fill: '#767676' }),
	            _react2.default.createElement('path', { d: 'M6.5 27.229C6.5 23.929 9.2 21.229 12.5 21.229H17C22.7 21.229 27.5 16.429 27.5 10.729C27.5 5.029 22.7 0.229004 17 0.229004H6.5C4.7 0.229004 3.5 1.429 3.5 3.229C3.5 5.029 4.7 6.229 6.5 6.229H17C19.4 6.229 21.5 8.329 21.5 10.729C21.5 13.129 19.4 15.229 17 15.229H12.5C5.9 15.229 0.5 20.629 0.5 27.229C0.5 33.829 5.9 39.229 12.5 39.229H18.5V33.229H12.5C9.2 33.229 6.5 30.529 6.5 27.229Z', fill: '#767676' })
	        )
	    },
	
	    'Housing': {
	        label: 'Housing & Government Buildings',
	        searchParams: {
	            holdIssueType: ['Envrnmntl', 'Green'],
	            holdUseOfProceeds: ['Housing', 'Government']
	        },
	        icon: _react2.default.createElement(
	            'svg',
	            { width: '61', height: '52', viewBox: '0 0 61 52', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M51.8516 19.129V3.229H42.8516V11.029L30.8516 0.229004L0.851562 27.229H9.85156V51.229H24.8516V33.229H36.8516V51.229H51.8516V27.229H60.8516L51.8516 19.129ZM24.8516 21.229C24.8516 17.929 27.5516 15.229 30.8516 15.229C34.1516 15.229 36.8516 17.929 36.8516 21.229H24.8516Z', fill: '#767676' })
	        )
	    },
	
	    'Education': {
	        label: 'Education & Healthcare',
	        searchParams: {
	            holdIssueType: ['Envrnmntl', 'Green'],
	            holdUseOfProceeds: ['Education', 'Healthcare']
	        },
	        icon: _react2.default.createElement(
	            'svg',
	            { width: '67', height: '55', viewBox: '0 0 67 55', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M12.8516 30.769V42.769L33.8516 54.229L54.8516 42.769V30.769L33.8516 42.229L12.8516 30.769ZM33.8516 0.229004L0.851562 18.229L33.8516 36.229L60.8516 21.499V42.229H66.8516V18.229L33.8516 0.229004Z', fill: '#767676' })
	        )
	    },
	
	    'Pollution': {
	        label: 'Pollution, Sanitation & Preservation',
	        searchParams: {
	            holdIssueType: ['Envrnmntl', 'Green'],
	            holdUseOfProceeds: ['Industrial', 'Utilities']
	        },
	        icon: _react2.default.createElement(
	            'svg',
	            { width: '62', height: '61', viewBox: '0 0 62 61', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	            _react2.default.createElement('path', { d: 'M61.3616 21.739C61.3616 10.129 51.9716 0.739014 40.3616 0.739014C28.7516 0.739014 19.3616 10.129 19.3616 21.739C19.3616 32.149 26.9216 40.759 36.8516 42.409V54.229H12.8516V45.229H15.8516V33.229C15.8516 31.579 14.5016 30.229 12.8516 30.229H3.85156C2.20156 30.229 0.851562 31.579 0.851562 33.229V45.229H3.85156V60.229H51.8516V54.229H42.8516V42.589C53.2616 41.359 61.3616 32.509 61.3616 21.739ZM8.35156 27.229C10.8416 27.229 12.8516 25.219 12.8516 22.729C12.8516 20.239 10.8416 18.229 8.35156 18.229C5.86156 18.229 3.85156 20.239 3.85156 22.729C3.85156 25.219 5.86156 27.229 8.35156 27.229Z', fill: '#767676' })
	        )
	    }
	
	};

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _categories = __webpack_require__(944);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _useGreenBonds2 = __webpack_require__(946);
	
	var _useGreenBonds3 = _interopRequireDefault(_useGreenBonds2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useGreenBonds = (0, _useGreenBonds3.default)(),
	        status = _useGreenBonds.status,
	        error = _useGreenBonds.error,
	        categories = _useGreenBonds.categories;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'green-bond-search', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'municipals-green-bond-search', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Green Bond Search'
	                    ),
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        'Quick access to municipal market offerings focused on environmental, social and governance (ESG) initiatives. '
	                    ),
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        'Click a \u201CView Results\u201D link to see offerings associated with your chosen category.'
	                    ),
	                    (0, _core.jsx)('hr', { 'aria-hidden': 'true' })
	                )
	            ),
	            (0, _core.jsx)(
	                _twd.Loading,
	                { status: status, error: error },
	                (0, _twd.arrayFrom)(categories).map(function (c, i) {
	                    var a = _categories2.default[c.greenBondGroup];
	                    if (!a) return null;
	
	                    var cat = Object.assign({}, a, {
	                        offerCount: c.offerCount
	                    });
	
	                    var sp = Object.assign({
	                        holdInvType: ['M'],
	                        holdIssueType: ['Envrnmntl', 'Green'],
	                        persistToPreviousSearches: false,
	                        offeringType: ['ask-side']
	                    }, cat.searchParams);
	
	                    return (0, _core.jsx)(
	                        _react2.default.Fragment,
	                        { key: i },
	                        (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'row' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'col-xs-3 text-center' },
	                                cat.icon
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'col-xs-9' },
	                                (0, _core.jsx)(
	                                    'label',
	                                    { className: 'label-large text-bold' },
	                                    cat.label
	                                ),
	                                (0, _core.jsx)('br', null),
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'municipals-green-bond-search-item',
	                                        className: 'btn-link label-large text-bold',
	                                        onClick: function onClick() {
	                                            (0, _twd.show)('offerings', {
	                                                searchParams: sp,
	                                                _ts: Date.now(),
	                                                from: 'municipals/green-bond-search'
	                                            });
	                                        } },
	                                    'View (',
	                                    _twd.format.count(cat.offerCount),
	                                    ') Results'
	                                )
	                            )
	                        )
	                    );
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12 text-right' },
	                    (0, _core.jsx)(_twd.Disclosures, {
	                        dataName: 'municipals-green-bond-search-disclosures-link',
	                        html: DISCLOSURES
	                    })
	                )
	            )
	        )
	    );
	};
	
	var DISCLOSURES = '\n<p>The Green Bond Search feature provides quick access to Green Bond\nofferings on the platform. Green bonds are fixed income securities\nthat specifically allocate their proceeds to fund projects with\nan environmental and/or climate-related benefit. Each green bond theme below\nis grouped by their use of proceeds category and will display\nsearch results according to the following:\n</p>\n\n<p><b>Transportation:</b> Mass/Rapid Transportation, Airports</p>\n<p><b>Water & Power:</b> Water, Water & Sewer, Sewer, Seaports/Marine Terminals, Flood Control/Storm Drain, Electricity & Public Power, Comb Utilities</p>\n<p><b>Housing & Government Buildings:</b> Multi-Family Housing, Single-Family Housing, Government/Public Buildings, Office Building/LTD Partnership, Single-Family Housing</p>\n<p><b>Education & Healthcare:</b> Primary/Secondary Education, Public Higher Education, Private Higher Education, Charter School, Hospitals</p>\n<p><b>Pollution, Sanitation & Preservation:</b> Sanitation, Solid Wastes & Reservation Recovery, Land Preservation, Pollution Control</p>\n';

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('municipals.green-bonds', {
	    values: []
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.values || []),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        values = _React$useState2[0],
	        setValues_ = _React$useState2[1];
	
	    var setValues = _react2.default.useCallback(function (a) {
	        state.set({ values: a });
	        setValues_(a);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(''),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        error = _React$useState6[0],
	        setError = _React$useState6[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        ;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, abort, categories;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setValues({});
	                            setError('');
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.prev = 3;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 7;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/marketSnapshotService/getMarketSnapshotByType',
	                                method: 'POST',
	                                params: {
	                                    marketSnapshotsType: 'MUNI_GREEN_BOND_DATA'
	                                }
	                            });
	
	                        case 7:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 13;
	                            return data;
	
	                        case 13:
	                            categories = _context.sent;
	
	                            lastAbort.current = null;
	
	                            setValues(categories);
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 22;
	                            break;
	
	                        case 19:
	                            _context.prev = 19;
	                            _context.t0 = _context['catch'](3);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 22:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[3, 19]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) {
	                lastAbort.current();
	            }
	        };
	    }, []);
	
	    return {
	        categories: values,
	        error: error,
	        status: status
	    };
	};

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useState = (0, _react.useState)(''),
	        _useState2 = _slicedToArray(_useState, 2),
	        state = _useState2[0],
	        setState = _useState2[1];
	
	    (0, _react.useEffect)(function () {
	        var e = document.getElementById('municipal-map-' + state);
	        if (!e) return;
	        e.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
	    }, [state]);
	
	    var id = (0, _twd.getId)();
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'label',
	            { htmlFor: id },
	            'Browse by State'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'select-wrapper' },
	            _react2.default.createElement(
	                'select',
	                {
	                    id: id,
	                    'data-name': 'municipals-scatter-graph-active-state',
	                    className: 'form-control',
	                    value: state,
	                    onChange: function onChange(e) {
	                        var a = e.target.value;
	                        setState(a);
	                    }
	                },
	                [{
	                    label: 'All',
	                    value: ''
	                }].concat(_twd.MUNI_STATES_AND_TERRITORIES).map(function (a, i) {
	                    var s = a.value.split('=')[1] || '';
	                    return _react2.default.createElement(
	                        'option',
	                        { key: i, value: s },
	                        a.label
	                    );
	                })
	            )
	        )
	    );
	};

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n', ' {\n    overflow-x: hidden;\n}\n'], ['\n', ' {\n    overflow-x: hidden;\n}\n']);
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _twd = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _statesMap = __webpack_require__(470);
	
	var _statesMap2 = _interopRequireDefault(_statesMap);
	
	var _table = __webpack_require__(950);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _useMap2 = __webpack_require__(957);
	
	var _useMap3 = _interopRequireDefault(_useMap2);
	
	var _activeState = __webpack_require__(947);
	
	var _activeState2 = _interopRequireDefault(_activeState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useMap = (0, _useMap3.default)(),
	        values = _useMap.values,
	        error = _useMap.error,
	        status = _useMap.status;
	
	    var isBlue = (0, _twd.getConfig)('entitlements.ETradeBlue', 'No') === 'Yes';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'municipal-map', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'municipals-map', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                _twd.Loading,
	                { status: status, error: error },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-8 col-xs-12' },
	                        (0, _core.jsx)(
	                            'h3',
	                            { className: 'medium-header' },
	                            'Municipal Map'
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-4 col-xs-12 text-small' },
	                        (0, _core.jsx)(_activeState2.default, null),
	                        (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12 table-responsive', css: mapCss },
	                        (0, _core.jsx)(
	                            'figure',
	                            null,
	                            (0, _core.jsx)(
	                                'div',
	                                { 'aria-hidden': 'true' },
	                                (0, _core.jsx)(_statesMap2.default, { values: values })
	                            ),
	                            (0, _core.jsx)(
	                                'figcaption',
	                                { className: 'screen-reader-only' },
	                                (0, _core.jsx)(_table2.default, { values: values })
	                            )
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row', 'aria-hidden': 'true' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-8 col-xs-12' },
	                        'Trades by state:',
	                        (0, _core.jsx)('br', null),
	                        (0, _core.jsx)(Legend, { color: isBlue ? "#00172b" : "#5627D8", label: '1001+' }),
	                        (0, _core.jsx)(Legend, { color: isBlue ? "#002b51" : "#6C43DD", label: '501-1000' }),
	                        (0, _core.jsx)(Legend, { color: isBlue ? "#094274" : "#825FE2", label: '251-500' }),
	                        (0, _core.jsx)(Legend, { color: isBlue ? "#1b5b93" : "#977AE7", label: '101-250' }),
	                        (0, _core.jsx)(Legend, { color: isBlue ? "#467eb0" : "#AD96EC", label: '51-100' }),
	                        (0, _core.jsx)(Legend, { color: isBlue ? "#6496c2" : "#C3B2F1", label: '0-50' })
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-4 col-xs-12 text-right' },
	                        '\xA0',
	                        (0, _core.jsx)('br', null),
	                        (0, _core.jsx)(
	                            'button',
	                            {
	                                'data-name': 'municipals-map-us-territories-link',
	                                className: 'btn btn-link text-small text-bold',
	                                onClick: function onClick() {
	                                    (0, _twd.show)('offerings', {
	                                        searchParams: {
	                                            holdInvType: ['M'],
	                                            holdState: ['AS', 'GU', 'VI'],
	                                            persistToPreviousSearches: false,
	                                            offeringType: ['ask-side']
	                                        },
	                                        _ts: Date.now(),
	                                        from: 'municipals'
	                                    });
	                                } },
	                            'View offerings from US Territories'
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-10 col-xs-12 text-small', 'aria-hidden': 'true' },
	                        'Municipal map color scale is based upon the number of MSRB-reported trades (by state) from the previous trading day.'
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-2 col-xs-12 text-right' },
	                        (0, _core.jsx)(_twd.Disclosures, {
	                            dataName: 'municipals-map-disclosures-link',
	                            html: DISCLOSURES
	                        })
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};
	
	var Legend = function Legend(_ref) {
	    var color = _ref.color,
	        label = _ref.label;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { style: { padding: '9px 0', lineHeight: '13px', paddingRight: '10px', minHeight: '33px', display: 'inline-block', whiteSpace: 'nowrap' } },
	            (0, _core.jsx)(
	                'svg',
	                { height: '10', width: '10' },
	                (0, _core.jsx)('circle', { cx: '5', cy: '5', r: '5', stroke: color, strokeWidth: '1', fill: color })
	            ),
	            '\xA0',
	            label
	        )
	    );
	};
	
	var mapCss = (0, _core.css)(_templateObject, _twd.mediaQueries.lg);
	
	var DISCLOSURES = '\n    The Municipal Map allows you to search for unique CUSIPs being offered\n    in each of the 50 states in the US, as well as in US territories.\n    The state color scale of the Municipal Map is based upon\n    the number of MSRB-reported trades (by state) from the previous trading day.\n    The legend at the bottom of the map shows how these trade volumes align with the state color scale.\n    You can click on a state to view a list of active municipal bond offerings from that state.\n    You can also hover over a state to see current data points for that state\u2019s offerings,\n    including: number of unique CUSIPs, general obligation and revenue offerings, and average yields.\n';

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MAP = {};
	
	MAP.AK = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$color = _ref.color,
	        color = _ref$color === undefined ? "#6496c2" : _ref$color,
	        _ref$labelColor = _ref.labelColor,
	        labelColor = _ref$labelColor === undefined ? "white" : _ref$labelColor,
	        _ref$tooltip = _ref.tooltip,
	        tooltip = _ref$tooltip === undefined ? {} : _ref$tooltip,
	        _ref$labelTooltip = _ref.labelTooltip,
	        labelTooltip = _ref$labelTooltip === undefined ? {} : _ref$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M187.757 403.859L189.836 406.542V408.914L189.24 411.002L188.352 411.295L187.757 411.002L186.273 408.914L186.566 407.733L185.385 405.645L183.297 404.161L185.678 406.24L186.273 408.026L185.971 408.914L184.78 409.216L183.223 408.768L183.892 409.216L184.194 410.407L183.297 409.509L183.031 408.713L182.701 408.621V408.026L183.003 407.43L182.106 405.645L181.511 405.947L182.106 406.24V408.328H181.218L180.32 407.43H180.586L180.888 406.533L180.283 404.161L179.99 405.342L180.283 405.938L179.99 406.533L178.507 406.24L177.609 405.645V405.049L178.204 403.859L177.609 401.78L176.895 401.532L177.536 401.276L177.545 401.239L176.986 401.468L175.915 401.111L175.026 400.516L174.724 399.921L173.241 400.223H172.343L171.702 400.113L171.555 399.05L170.566 397.246V396.651L170.804 396.083L170.75 396.092L170.502 396.678L170.227 395.873V396.44H169.632L167.544 394.664L166.06 395.25L164.897 394.526L165.502 395.131L165.804 396.028H166.399V395.726L166.692 395.433L167.59 394.838V395.131L169.971 397.512H169.376L168.478 396.321L168.185 396.624L170.264 398.702L170.566 399.298L169.971 400.195V401.084L169.074 402.567L168.185 401.386V399.6L166.692 398.4L165.502 396.028L164.311 394.545V394.242H164.439L163.679 393.766L162.186 391.092L162.489 390.79L164.87 389.901L165.465 390.497L166.353 390.79L169.33 391.98V392.576L170.795 393.455L170.804 393.409L174.367 396.312L174.44 396.285L175.613 397.246L176.51 398.135V399.032L177.737 399.014L177.856 400.021L177.838 400.113L178.8 400.287L179.688 401.184L180.283 400.882L182.665 401.477L183.562 402.073L183.26 402.668L182.372 403.859L181.474 404.454L181.181 405.049V406.24L181.474 406.533V407.724L181.511 407.733V406.542L181.218 406.24V405.049L181.511 404.454L182.408 403.859L183.297 402.668L183.599 402.082L182.701 401.477L183.892 401.184L185.678 402.082H186.502V401.963L186.795 401.368L187.693 401.963V403.749L186.612 403.126V403.208L187.757 403.859ZM170.731 402.265L170.136 402.558L169.843 403.456L170.438 404.344L171.922 405.242L172.517 405.828H171.922V406.725L172.517 408.209L173.112 408.511L172.819 407.018L173.415 407.623V405.828H172.819L172.517 404.939V404.344L173.112 404.051L172.517 402.86H171.629L170.731 402.265ZM176.977 409.995L175.787 410.59V411.488L176.977 411.781L177.582 410.297L176.977 409.995ZM169.614 404.655L167.526 401.386H166.93L167.526 401.093L167.233 400.488L166.042 400.791L164.851 400.195L164.558 401.084L163.661 399.902L163.963 399.6L166.042 400.488L166.93 400.195V399.902L166.042 398.409L164.851 399.005L163.368 398.409L162.232 398.126V398.107L163.423 398.4L164.906 398.702L165.502 398.4L165.804 398.107L165.502 397.219L165.209 396.624L161.939 396.028L161.344 396.624L160.153 396.917L159.851 398.4L160.153 399.298L161.014 399.591L160.987 399.6L163.661 401.981H164.256L165.145 402.576L165.74 402.283V402.879L166.344 403.474L166.93 405.251L167.828 405.553L168.121 406.148L168.716 405.553V406.441L170.209 407.934L170.804 408.227V407.934L170.511 407.339H170.804L169.614 404.655ZM181.447 409.4L179.661 407.321L175.494 404.939L174.01 405.544V405.837L174.605 407.33L174.303 408.218L174.605 408.52L175.201 408.218L175.494 407.339L176.391 408.52L176.089 408.813H175.494L175.201 409.116L176.684 409.711H177.582L178.47 410.599L177.279 411.79L177.582 412.385L181.144 414.766H182.042L181.447 413.283L180.851 412.98L180.256 413.576L178.763 411.497L181.447 412.385L183.232 413.869L184.121 413.576V412.678L182.637 410.004L181.447 409.4ZM164.851 404.362L165.447 404.069V403.172L164.256 401.981L163.963 402.283L164.851 404.362ZM176.51 403.492L177.408 402.302L174.129 400.516L173.241 401.111L174.202 401.633L173.341 402.43L174.431 404.381H175.32L175.613 403.795L175.32 403.19L174.129 402.595V402.009L175.613 402.897V403.492H176.51ZM43.1636 373.178H43.7589L44.9495 373.773L46.7354 375.852L47.6238 376.145L48.5213 375.55L49.7119 376.145L50.3072 374.955L47.926 374.369L46.4332 373.178V372.28L45.8379 371.685L45.2517 371.392L43.7589 372.28L41.973 371.09V370.201L41.6799 370.797L41.0847 372.583V373.178L41.973 373.773L43.1636 373.178ZM17.5475 445.081L16.3569 445.676L16.6592 445.978H16.9522L16.6592 446.271L15.1663 446.867L12.199 446.574L15.4686 447.169H17.2545L18.1428 445.978L17.5475 445.081ZM0 444.485L0.293069 445.978L0.888366 446.271L1.78589 445.676L1.19059 444.485H0ZM159.558 393.94L157.772 393.345H156.581V393.052L159.256 393.647H159.558V393.052L160.446 393.94L161.042 395.726L162.47 394.865L163.35 395.744H164.54L163.047 393.363L161.866 391.577L160.373 389.196V388.894L161.271 389.489L162.159 390.982L162.452 390.68L164.833 389.791H164.54L163.945 388.894L163.643 389.196L163.047 388.601H161.866L161.564 388.308L161.49 388.335L160.941 386.934L160.043 386.339L158.853 386.046L158.322 386.833L158.294 386.815L157.103 388.308V390.68H157.177V391.266L156.288 391.568L154.502 394.242L153.312 395.433L156.288 396.624L157.177 396.917H157.772L158.963 397.512L160.749 395.726L159.558 393.94ZM57.7804 396.953L56.2968 395.763L55.3993 396.056L55.1062 395.763L53.9156 396.651H52.1297L51.8366 396.953V397.549L52.725 398.437L55.7015 399.93L57.1851 399.334L57.4874 398.73L57.7804 396.953ZM44.9129 442.104L44.0245 441.811L43.1361 442.104L42.5408 442.406L42.2478 443.002L40.4619 444.192V444.788L38.9691 446.271L39.8666 445.978L41.6433 445.081L43.1361 443.597L44.3267 443.295L44.9129 442.104ZM50.5728 440.025L50.2705 440.327L49.9683 440.025V439.43L48.1916 439.723L47.8894 440.025L47.5963 442.406L44.3267 443.597L45.2151 444.192L47.5963 443.295H48.4847L49.3822 443.002L51.7542 441.216L52.0564 440.621L50.8658 439.43L50.5728 440.025ZM19.3334 447.462H18.445L17.5475 447.169L18.445 448.057L19.6356 448.35H22.0168L19.9287 447.755L19.3334 447.462ZM7.14356 446.574H6.53911L6.84134 445.978H7.14356V445.676H6.24604L4.76238 447.755L7.7297 447.462L8.03193 446.867L7.14356 446.574ZM76.8391 433.285L76.2346 432.992L75.9416 433.285V435.071L77.4344 433.285L77.1322 432.094L76.8391 433.285ZM104.159 413.713L104.452 412.523L103.856 412.825L102.666 414.015L102.364 413.713L102.666 412.825H101.768L101.173 413.118L99.3963 413.42L98.801 414.015L99.0941 416.397L99.6894 416.992L99.0941 416.69L98.801 415.801V414.904L97.3082 415.206L96.4198 416.094L96.1267 417.578L96.7129 418.173L97.0151 419.071L97.9035 420.554L98.4988 421.452L99.3963 421.15L100.285 420.261L101.173 418.173H101.475L101.173 418.778L101.475 419.364L101.768 419.071L103.261 417.285L104.754 415.801L105.34 414.611H104.754L104.159 413.713ZM99.6894 406.579L99.9824 407.467L100.285 406.579H99.6894ZM104.754 409.253L103.563 409.555V408.96L103.856 407.769L102.968 408.062L101.768 410.141L100.587 411.927L102.071 412.523L102.364 412.229L101.768 411.634L102.071 411.332L102.968 411.927L105.34 411.039L105.642 410.444L105.34 409.555L104.754 409.253ZM173.708 404.939L174.303 404.646V404.344L173.222 402.393L174.074 401.587L173.112 401.075H171.033L170.731 401.67L171.629 402.265L171.922 402.558L172.517 402.86L172.819 403.153L173.708 404.939ZM74.1557 431.499H73.5604L73.2673 431.801L73.5604 432.992L74.751 433.285L75.3463 432.387V431.801H74.751L74.1557 431.499ZM119.655 393.345V393.94L118.162 396.321V397.512L119.352 396.917L119.655 395.131L120.25 394.233L120.845 393.345L119.948 393.043L119.655 393.345ZM154.328 394.261L153.44 392.182L148.98 389.8L148.385 388.903L146.892 388.61L146.297 388.308L146.003 386.531L144.218 387.126L143.622 388.308L141.836 388.015L141.534 388.61H140.05L139.757 388.015H139.19L139.29 387.987H139.886L136.909 377.876L136.808 377.913L129.427 352.214L129.5 352.104L124.445 334.557H124.426L123.529 331.58L122.045 326.818L117.283 325.334L115.204 325.041L114.608 325.627L114.315 325.93L113.125 326.818L112.529 327.12L110.441 326.525H108.655L107.172 326.818H105.981L105.679 326.525L104.791 326.223H103.893L101.814 325.627L98.5446 325.93L97.0517 326.818H95.8611L96.1634 325.93L94.3775 325.627V325.334L94.9728 324.446L94.6797 324.144H92.2985L90.8057 324.446L90.5126 325.041L89.6243 324.739L89.322 323.549L88.4337 322.66L87.8384 323.255L87.2431 324.739L86.3455 325.041V324.144L87.2431 323.255V322.66L84.8619 321.46L82.1876 324.739L79.2111 325.627H78.6158L79.2111 325.334L78.9089 324.739L78.0205 325.334L76.8299 326.525L75.0441 328.604L73.8535 329.199L72.9651 328.906L71.7745 330.097L69.9886 332.771L69.0911 335.445L67.3052 337.533L66.4168 337.826L63.7426 338.129L61.6545 337.826L61.3614 339.915L60.7661 341.691L61.6545 342.882L63.4403 343.779H63.5869L66.4443 346.93L67.3327 350.199L69.4116 351.088H70.6114L72.095 350.795L72.9834 351.39V351.683L72.6903 351.39L72.095 353.176L72.9834 354.367L73.5787 354.66L72.9834 354.953L71.7928 353.771L70.9045 351.683H70.3092L70.0161 351.985L70.3092 352.874L70.9045 353.176L72.095 354.66L72.9834 355.255L73.8809 355.85L74.1832 356.446H73.2856L71.7928 357.929L66.4443 357.343L66.1421 356.143L66.7374 354.064L66.1421 353.771H65.4094H64.9515L64.0814 354.119L60.7203 355.328V355.924L61.6087 356.519V356.812L60.125 356.519L59.5297 355.924L54.172 358.9V359.788L55.9579 360.979L58.6322 362.17L58.3391 363.058L58.0369 363.36L58.3391 365.146L58.0369 366.034L58.3391 366.63L58.9344 367.225L62.204 368.416L64.5851 367.82L69.3475 368.113L70.5381 367.225L72.9193 366.63L73.5146 365.732L74.696 366.932V367.82L73.8077 368.416H73.2124V369.304L73.8077 370.201L74.696 372.876L74.403 373.773L73.5146 375.55L72.0218 375.852H70.8312L69.9428 375.55L69.0453 376.741L69.6406 377.043L69.6589 377.07L69.0728 376.777L67.5891 378.27L66.6916 378.563L64.6126 376.777L63.422 377.079L62.2314 378.563L61.6361 380.056L61.9384 380.944L60.4455 382.135L57.176 386.302L56.8829 388.088L58.3666 391.055L59.2549 391.357L59.5572 390.762L60.7478 391.357L60.4455 391.953L59.8502 392.246V392.511L59.5663 392.786V393.079H60.1616L60.4639 393.977L58.678 395.167L61.3522 397.549L62.5428 399.334L62.8359 400.223L64.0265 400.818L66.1146 400.516L68.1936 399.334L68.7889 398.144L70.2817 401.12V401.413L70.8678 403.199L69.6864 404.683L70.2817 405.874L70.5748 407.659L70.2817 408.85L69.6864 408.548L69.0911 408.85L71.1701 409.143L72.0676 408.85V407.659H73.249V407.614L75.5661 406.167L75.8592 406.46L75.5661 406.762L77.0498 407.952H77.3428L77.6451 407.055L78.2403 407.357L80.0262 410.627H80.6215L81.5099 410.031L80.9146 408.548L81.2168 407.357L81.5099 407.055L82.7005 408.841L83.2958 409.143L86.8493 407.366V407.403L86.8676 407.357L87.1515 406.808L87.4446 407.101H89.8257V407.11H87.4446L87.1515 408.31L86.5653 409.189H86.5562V409.198L85.6587 410.673L85.0634 416.332L82.0869 419.3L81.5007 420.49L81.7938 421.681H80.9879L80.704 421.388L77.1322 423.769H77.0314V423.851L75.3463 425.253L74.4579 427.332V428.229L74.1557 428.825L73.5604 429.127L73.2673 428.522V427.927H73.5604L72.672 427.634L71.7745 427.332L69.9978 427.927L68.2119 429.42L65.5285 432.387L63.7426 432.992V434.777H63.1473L62.8542 433.285H61.9567L58.6871 434.777L58.0918 435.666L57.2035 435.959V436.563L57.4965 437.452H58.9802L59.8777 436.563L60.473 436.261H62.552L63.7426 435.959L64.6401 436.261V434.475L64.0356 433.285L64.9332 432.992L65.5285 434.475L66.7191 434.182L66.426 432.992L66.1238 432.387L66.426 431.801L67.0121 432.094V433.587L67.9097 433.88L69.1002 433.285L70.5931 429.713H71.4814L70.8861 431.206L72.0767 431.499L74.751 430.61L76.2346 429.42L76.5369 428.825H77.1322L77.4344 428.229L78.0297 428.522V429.127L78.222 429.511V429.713L78.277 429.612L78.3228 429.713V429.521L78.5243 429.127V428.229L82.3891 427.332L83.5797 425.848L82.3891 424.657L82.9844 423.769H84.7703L84.4681 423.174H84.175V422.872L85.9609 422.276L86.254 421.086L86.8493 421.388L90.0272 419.071H90.1738V417.88L89.5785 418.173V417.88L91.3644 416.69V416.103L91.6574 416.397L92.2527 416.094L93.1502 414.904H93.7364L94.3317 413.42L94.927 412.825L95.8245 412.523L96.4198 412.825L97.3082 412.229L97.9035 411.332L98.2057 409.253L98.801 408.365L99.3963 408.062L99.9824 407.467H98.4988L98.801 408.062L97.9035 408.365H97.0151V409.848L96.1267 410.444L94.6339 411.039L93.4433 411.634L93.7364 414.015L92.5458 414.904L91.9597 415.801L91.6574 416.094L91.3644 415.801L91.0621 416.094L90.1738 416.69L89.5785 417.578L89.2854 418.173L88.6901 418.476V419.007H88.6351V418.411L89.2304 418.109L89.5235 417.514L90.1188 416.625L91.0163 416.03L91.3094 415.737L91.6116 416.03L91.9047 415.737L92.5 414.84L93.6906 413.951L93.3884 411.57L94.579 410.975L96.0718 410.379L96.9602 409.784V408.3H95.7696L95.7604 408.246H97.8394L98.7277 407.952L98.4347 407.357H99.9183L99.6252 406.46H100.221V406.167L98.7277 404.976L97.5371 405.269L97.2441 405.571L96.951 404.976L97.2441 403.19L98.1324 402.595L99.0299 401.404L100.514 400.507L102.006 398.135V396.651L103.188 393.372L104.388 391.293L105.871 390.103L106.448 389.526L106.512 389.553L107.099 388.958H109.471L109.205 389.233L110.689 390.414L110.634 390.396L109.736 390.991H108.848L108.252 390.396L106.467 392.182L105.276 392.777L105.871 393.968V395.158L105.569 396.349L104.983 397.832L104.681 399.618L105.276 400.214L105.871 400.507L106.76 399.618H107.364L106.76 400.809L104.681 402.302V403.19L105.569 403.785L108.252 402.888L108.848 401.404L109.443 400.809L109.736 401.111L111.824 399.325V397.539L113.015 396.944L115.396 396.651V396.349L115.094 393.674L114.801 393.372V393.07L114.499 391.889V391.586H114.242L113.967 391.312V390.716H114.004V391.266L114.297 391.559H114.599V391.861L114.892 393.043V393.345L115.195 393.647L115.488 396.321V396.614L117.567 396.321L118.162 395.424L116.98 394.233L117.274 393.043L116.385 390.964L115.488 390.671L115.79 389.178L116.385 388.885L116.083 390.671H116.385L118.464 389.773L118.757 388.885L120.543 387.987V389.48L120.845 389.178L121.138 389.773L122.329 389.178L122.036 389.48L120.845 390.368L121.138 390.671H122.329L123.822 390.075V390.671L123.226 391.266L122.036 391.861H121.441L121.138 392.749L121.734 393.647L124.408 391.266L126.789 392.154L126.194 391.559L127.384 390.964V391.861L131.158 393.006L131.13 393.07L131.231 393.033L131.258 393.043L131.268 393.024L135.297 391.586L139.162 391.284L140.939 392.182L143.622 391.879L144.813 390.689L145.115 389.8L146.003 391.284V391.879H145.408V392.475L145.71 392.777L152.25 394.261L153.147 394.856V395.451L154.328 394.261Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M92.8908 372.099H94.4943L95.2126 369.829H98.7147L99.4459 372.099H101.216L98.1887 362.927H95.9567L92.8908 372.099ZM96.9701 364.325L98.317 368.584H95.6103L96.9701 364.325ZM102.616 372.099H104.322V367.815L107.85 372.099H109.864L105.874 367.301L109.671 362.927H107.837L104.322 367.083V362.927H102.616V372.099Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.AL = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$color = _ref2.color,
	        color = _ref2$color === undefined ? "#6496c2" : _ref2$color,
	        _ref2$labelColor = _ref2.labelColor,
	        labelColor = _ref2$labelColor === undefined ? "white" : _ref2$labelColor,
	        _ref2$tooltip = _ref2.tooltip,
	        tooltip = _ref2$tooltip === undefined ? {} : _ref2$tooltip,
	        _ref2$labelTooltip = _ref2.labelTooltip,
	        labelTooltip = _ref2$labelTooltip === undefined ? {} : _ref2$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M515.289 362.234C515.344 361.51 515.362 360.787 515.38 360.063C515.39 359.697 515.399 359.33 515.417 358.964C515.454 358.103 515.261 357.801 514.455 357.426C513.466 356.968 512.935 356.427 512.184 355.612L512.065 355.484C511.836 355.255 511.561 354.962 511.506 354.586C511.442 354.156 511.561 353.643 511.662 353.185C511.708 352.993 511.745 352.819 511.772 352.654L511.79 352.489C511.827 352.178 511.9 352.031 512.239 351.949L512.377 351.912C512.752 351.802 513.155 351.793 513.558 351.775C513.732 351.766 513.906 351.766 514.071 351.747L518.091 351.363C520.033 351.179 521.984 351.005 523.934 350.841C527.067 350.566 531.206 350.2 535.364 349.751C538.927 349.366 542.554 348.927 546.061 348.496L549.651 348.056C549.697 348.047 549.78 348.029 549.862 348.011C549.99 347.983 550.118 347.956 550.228 347.937C550.228 347.928 550.219 347.919 550.219 347.91C550.1 347.516 549.972 347.104 549.779 346.783C549.67 346.6 549.514 346.408 549.285 346.188C549.239 346.142 549.166 346.106 549.083 346.069C548.983 346.023 548.873 345.968 548.781 345.877C548.058 345.181 548.25 344.173 548.397 343.367C548.442 343.129 548.488 342.891 548.506 342.68C548.525 342.415 548.561 342.14 548.589 341.838C548.69 340.95 548.809 339.933 548.58 339.2C548.158 337.817 547.618 336.462 547.087 335.482C547.059 335.436 547.032 335.4 547.005 335.363C546.931 335.262 546.84 335.134 546.812 334.942C546.776 334.694 546.849 334.401 546.922 334.136C546.95 334.044 546.968 333.962 546.986 333.888L547.133 333.119C547.233 332.588 547.334 332.057 547.426 331.526C547.462 331.306 547.444 331.077 547.435 330.829C547.417 330.546 547.398 330.243 547.453 329.941C547.536 329.511 547.783 329.089 547.994 328.714C548.076 328.567 548.158 328.43 548.232 328.293C548.296 328.164 548.387 328.009 548.488 327.835C548.772 327.349 549.212 326.607 549.093 326.195C549.074 326.122 549.019 326.003 548.827 325.911C548.635 325.811 548.47 325.774 548.332 325.747C547.838 325.646 547.591 325.444 547.691 324.675C547.746 324.254 547.655 323.805 547.563 323.338C547.536 323.191 547.508 323.045 547.481 322.898C547.371 322.257 547.316 322.175 546.858 321.662L546.684 321.479C546.363 321.131 546.07 320.801 545.841 320.352C545.237 319.153 544.687 317.879 544.129 316.57C543.497 315.086 543.085 313.456 542.691 311.881C542.535 311.258 542.379 310.644 542.215 310.04C541.5 307.448 540.777 304.856 540.053 302.264C539.44 300.066 538.826 297.859 538.212 295.661C537.69 293.775 537.141 291.897 536.591 290.02C535.831 287.409 535.044 284.699 534.338 282.024C534.229 281.612 534.128 281.2 534.018 280.788L533.917 280.394C530.583 280.751 527.341 281.063 524.136 281.347C517.313 281.942 511.589 282.427 505.819 282.876C505.233 282.922 504.647 282.958 504.061 283.004C502.925 283.077 501.753 283.16 500.608 283.279C499.949 283.352 499.298 283.435 498.648 283.526C498.511 283.545 498.382 283.563 498.245 283.581C498.254 283.59 498.254 283.59 498.263 283.6C498.648 283.957 499.042 284.323 499.298 284.744C499.518 285.12 499.491 285.532 499.463 285.889C499.454 285.981 499.454 286.081 499.445 286.173L499.372 289.04C499.335 290.23 499.307 291.421 499.28 292.621L499.225 295.176C499.188 296.788 499.152 298.4 499.115 300.011C498.987 305.049 498.886 310.086 498.785 315.123L498.456 332.029C498.437 333.165 498.419 334.291 498.401 335.427L498.373 336.975C498.355 337.927 498.465 338.889 498.575 339.832L498.666 340.629C498.85 342.351 499.079 344.109 499.307 345.803C499.417 346.591 499.518 347.379 499.619 348.166C500.287 353.442 500.938 358.726 501.588 364.01L501.652 363.983L501.982 363.928L503.2 363.946L504.079 364.23L505.38 361.703L505.801 359.156L506.479 358.424L506.533 358.387L506.753 358.46L506.964 358.525L507.651 358.781L507.742 358.854L507.935 359.12L510.618 364.56L508.594 365.851L507.825 366.135L507.898 366.227L509.757 366.108L510.325 366.016L512.45 365.485L514.474 364.771L515.069 364.597C515.179 364.029 515.307 362.985 515.316 362.673C515.271 362.508 515.28 362.362 515.289 362.234Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M512.549 321.704H514.152L514.87 319.433H518.372L519.104 321.704H520.874L517.846 312.532H515.614L512.549 321.704ZM516.628 313.93L517.975 318.189H515.268L516.628 313.93ZM522.274 321.704H527.892V320.344H523.98V312.532H522.274V321.704Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.AR = function () {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$color = _ref3.color,
	        color = _ref3$color === undefined ? "#6496c2" : _ref3$color,
	        _ref3$labelColor = _ref3.labelColor,
	        labelColor = _ref3$labelColor === undefined ? "white" : _ref3$labelColor,
	        _ref3$tooltip = _ref3.tooltip,
	        tooltip = _ref3$tooltip === undefined ? {} : _ref3$tooltip,
	        _ref3$labelTooltip = _ref3.labelTooltip,
	        labelTooltip = _ref3$labelTooltip === undefined ? {} : _ref3$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M467.354 285.056C467.492 284.323 467.95 284.323 468.288 284.314C468.371 284.314 468.472 284.314 468.572 284.305C468.655 284.296 468.737 284.286 468.783 284.277C468.792 284.25 468.801 284.213 468.82 284.167L468.875 284.003C468.893 283.957 468.911 283.883 468.929 283.81C469.039 283.389 469.177 282.812 469.626 282.647C469.946 282.528 470.23 282.729 470.431 282.885C470.496 282.931 470.615 283.013 470.66 283.023C470.688 282.986 470.825 282.729 470.825 282.583C470.825 282.528 470.825 282.491 470.825 282.473C470.816 282.482 470.77 282.473 470.725 282.464C470.651 282.446 470.56 282.418 470.459 282.381C470.358 282.345 470.276 282.262 470.248 282.162C470.212 282.061 470.23 281.951 470.294 281.859C470.404 281.695 470.706 281.264 470.642 281.072C470.615 280.989 470.496 280.925 470.404 280.889C470.367 280.87 470.285 280.879 470.202 280.889C470.01 280.907 469.69 280.934 469.461 280.651C469.323 280.477 469.268 280.293 469.314 280.128C469.378 279.872 469.607 279.762 469.781 279.68C469.854 279.643 469.937 279.606 469.983 279.57C470.129 279.432 470.166 279.377 470.184 279.103C470.184 279.039 470.175 278.947 470.166 278.865C470.157 278.791 470.157 278.727 470.157 278.681C470.157 278.59 470.166 278.507 470.193 278.434C470.12 278.352 470.001 278.297 469.964 278.315C469.955 278.324 469.937 278.333 469.891 278.425C469.818 278.562 469.699 278.801 469.369 278.892C469.277 278.92 469.168 278.901 469.085 278.846C469.003 278.791 468.948 278.7 468.929 278.599C468.92 278.517 468.902 278.443 468.893 278.37C468.838 278.077 468.765 277.674 469.122 277.381C469.25 277.271 469.406 277.234 469.525 277.207C469.571 277.198 469.635 277.179 469.653 277.17C469.699 277.134 469.772 277.033 469.827 276.951C469.864 276.886 469.909 276.831 469.946 276.776C470.019 276.685 470.138 276.639 470.248 276.648C470.367 276.657 470.468 276.731 470.523 276.841C470.551 276.886 470.578 276.951 470.605 277.033C470.834 277.537 470.981 277.775 471.073 277.876C471.146 277.61 471.182 277.07 471.146 276.914C471.109 276.804 471.063 276.74 471.018 276.676C470.908 276.52 470.825 276.364 470.816 276.053C470.798 275.623 470.899 275.329 471.127 275.174C471.256 275.082 471.485 275.009 471.814 275.155C472.034 275.256 472.107 275.458 472.162 275.595C472.172 275.632 472.199 275.687 472.208 275.705C472.245 275.723 472.346 275.742 472.455 275.76C472.355 275.513 472.226 275.293 472.034 275.018C471.979 274.936 471.961 274.844 471.979 274.743C471.998 274.652 472.062 274.569 472.144 274.514C472.236 274.459 472.364 274.404 472.492 274.34C472.813 274.185 473.344 273.928 473.362 273.672C473.362 273.589 473.271 273.397 473.206 273.37C473.179 273.388 472.987 273.507 472.886 273.571C472.813 273.617 472.739 273.663 472.684 273.69C472.602 273.736 472.51 273.736 472.419 273.718C472.327 273.69 472.263 273.626 472.217 273.544C472.19 273.489 472.144 273.415 472.089 273.333C471.842 272.939 471.677 272.646 471.732 272.362C471.86 271.703 472.556 271.639 472.886 271.611L472.996 271.602C473.307 271.565 473.619 271.446 473.783 271.309C473.857 271.245 473.912 271.162 473.976 271.062C474.067 270.915 474.186 270.723 474.415 270.604C474.589 270.512 474.773 270.494 474.928 270.475C474.992 270.466 475.084 270.457 475.13 270.448C475.13 270.439 475.13 270.411 475.121 270.366C475.111 270.356 475.038 270.338 474.992 270.329C474.818 270.283 474.553 270.21 474.379 269.944C474.25 269.752 474.223 269.514 474.296 269.285C474.379 269.038 474.562 268.845 474.782 268.754C475.13 268.616 475.496 268.735 475.789 268.845C475.835 268.69 475.826 268.653 475.752 268.552C475.716 268.497 475.578 268.451 475.459 268.415C475.267 268.36 475.038 268.287 474.892 268.076C474.818 267.966 474.773 267.856 474.763 267.746C473.051 267.856 471.347 267.975 469.644 268.094L465.816 268.36C465.687 268.369 465.568 268.305 465.504 268.195C465.44 268.085 465.431 267.948 465.495 267.838L466.594 265.924C467.116 264.99 467.611 264.101 468.481 263.341C468.554 263.277 468.636 263.213 468.719 263.14C469.03 262.883 469.323 262.645 469.378 262.306C469.442 261.876 469.351 261.271 469.177 260.951C468.572 259.843 468.261 259.495 468.114 259.403C468.023 259.348 467.675 259.394 467.501 259.412C467.4 259.421 467.299 259.44 467.217 259.44L460.247 259.843C456.556 260.053 452.747 260.273 448.992 260.41C446.62 260.493 444.248 260.603 441.875 260.713C439.613 260.813 437.351 260.923 435.098 261.006C430.144 261.189 425.226 261.317 420.619 261.427C415.921 261.546 411.158 261.628 406.68 261.702C406.725 262.251 406.79 262.792 406.872 263.332C407.339 266.537 407.825 269.743 408.319 272.939L408.585 274.698C408.685 275.339 408.795 275.98 408.914 276.621C409.152 277.94 409.4 279.295 409.482 280.632C409.565 281.988 409.519 283.38 409.473 284.726C409.446 285.395 409.427 286.063 409.418 286.723C409.336 294.04 409.29 301.358 409.235 308.675L409.217 311.496L409.381 311.725C409.519 311.927 409.555 311.981 409.821 312.155L409.995 312.265C410.197 312.403 410.398 312.531 410.59 312.613C410.819 312.714 410.819 312.705 411.03 312.595L411.378 312.412C411.946 312.119 412.477 311.844 413.2 311.844C413.237 311.844 413.274 311.844 413.31 311.844C413.503 311.853 415.215 311.936 415.591 312.714C415.701 312.934 415.673 313.236 415.655 313.511C415.646 313.593 415.646 313.667 415.646 313.722L415.811 321.818C416.855 321.79 417.908 321.772 418.952 321.754C420.72 321.717 422.478 321.68 424.246 321.634C426.975 321.561 429.695 321.497 432.424 321.424C435.474 321.351 438.533 321.277 441.582 321.195C444.916 321.103 448.305 320.966 451.583 320.819C453.433 320.737 455.283 320.664 457.143 320.59C457.188 320.545 457.225 320.49 457.262 320.444C457.619 320.023 457.866 319.29 457.967 318.337C458.022 317.843 457.994 317.348 457.912 317.165C457.848 317.028 457.729 316.881 457.601 316.726C457.463 316.552 457.317 316.368 457.207 316.158C456.923 315.599 456.73 314.995 456.538 314.408C456.474 314.198 456.401 313.996 456.327 313.786C456.3 313.694 456.3 313.603 456.346 313.52C456.392 313.438 456.465 313.374 456.556 313.346C456.63 313.328 456.712 313.309 456.785 313.291C457.124 313.218 457.216 313.172 457.234 313.071C457.252 312.952 457.069 312.833 456.831 312.687C456.767 312.65 456.703 312.613 456.648 312.568C456.584 312.522 456.52 312.485 456.456 312.439C456.19 312.275 455.888 312.091 455.723 311.734C455.613 311.487 455.595 311.285 455.677 311.102C455.796 310.837 456.071 310.754 456.318 310.681C456.428 310.654 456.538 310.617 456.648 310.562C456.721 310.525 456.767 310.498 456.804 310.47C456.758 310.443 456.712 310.406 456.676 310.379C456.419 310.214 456.108 310.003 456.007 309.637C455.897 309.216 456.062 308.629 456.3 307.915C456.364 307.723 456.419 307.558 456.447 307.439C456.52 307.118 456.584 306.789 456.657 306.45C456.795 305.772 456.932 305.067 457.152 304.407C457.362 303.785 457.829 303.574 458.287 303.382C458.406 303.336 458.525 303.281 458.654 303.217C458.782 303.153 458.938 303.089 459.112 303.025C459.725 302.777 460.165 302.576 460.119 302.228C460.092 302.017 459.991 301.916 459.808 301.77C459.56 301.568 459.148 301.229 459.524 300.46L459.588 300.332C459.863 299.755 460.156 299.16 460.476 298.592C460.559 298.445 460.632 298.28 460.724 298.097C461.017 297.465 461.346 296.751 461.923 296.504C462.235 296.366 462.537 296.311 462.83 296.266C463.178 296.202 463.508 296.147 463.801 295.954C464.277 295.634 464.268 295.331 464.176 294.626C464.158 294.516 464.149 294.397 464.14 294.269C464.121 294.049 464.075 293.811 464.03 293.564C463.929 292.996 463.828 292.401 463.92 291.879C464.002 291.393 464.369 290.899 464.689 290.459C464.808 290.303 464.918 290.148 465 290.01C465.092 289.864 465.193 289.672 465.294 289.47C465.559 288.966 465.852 288.399 466.246 288.096C466.484 287.904 466.796 287.84 467.07 287.785C467.29 287.739 467.501 287.693 467.62 287.602C467.629 287.593 467.647 287.583 467.656 287.574C467.656 287.565 467.656 287.556 467.647 287.538L467.611 287.336C467.583 287.153 467.537 286.961 467.501 286.759C467.4 286.292 467.29 285.761 467.318 285.276L467.308 285.12H467.336C467.345 285.12 467.345 285.092 467.354 285.056Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M427.334 295.131H428.938L429.656 292.861H433.158L433.889 295.131H435.659L432.632 285.959H430.4L427.334 295.131ZM431.413 287.358L432.76 291.616H430.054L431.413 287.358ZM437.059 295.131H438.765V291.424H439.856L442.255 295.131H444.102L441.523 291.168C442.665 290.872 443.563 290.141 443.563 288.705V288.653C443.563 286.78 442.152 285.959 440.138 285.959H437.059V295.131ZM438.765 290.205V287.281H440.138C441.228 287.281 441.883 287.64 441.883 288.692V288.743C441.883 289.718 441.28 290.205 440.138 290.205H438.765Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.AZ = function () {
	    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref4$color = _ref4.color,
	        color = _ref4$color === undefined ? "#6496c2" : _ref4$color,
	        _ref4$labelColor = _ref4.labelColor,
	        labelColor = _ref4$labelColor === undefined ? "white" : _ref4$labelColor,
	        _ref4$tooltip = _ref4.tooltip,
	        tooltip = _ref4$tooltip === undefined ? {} : _ref4$tooltip,
	        _ref4$labelTooltip = _ref4.labelTooltip,
	        labelTooltip = _ref4$labelTooltip === undefined ? {} : _ref4$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M197.447 310.342L205.488 252.287C206.019 248.44 206.55 244.603 207.09 240.756C201.183 239.941 195.844 239.172 190.77 238.403C186.969 237.826 183.114 237.194 179.377 236.58L175.1 235.884C169.697 235.005 164.458 234.117 159.512 233.256C154.842 232.441 150.116 231.552 145.537 230.701L139.547 229.583C139.199 231.406 138.851 233.219 138.521 235.042C138.375 235.848 138.228 236.653 138.082 237.459C137.844 238.778 137.605 240.088 137.358 241.407C137.331 241.572 137.303 241.755 137.276 241.938C137.221 242.359 137.166 242.799 137.01 243.174C136.854 243.541 136.561 243.889 136.296 244.2C136.186 244.337 136.067 244.466 135.975 244.585C135.902 244.685 135.82 244.795 135.746 244.896C135.243 245.61 134.684 246.426 133.411 245.958C132.742 245.72 132.523 245.043 132.33 244.438C132.211 244.081 132.101 243.751 131.927 243.55C131.506 243.074 130.297 242.799 129.317 242.698C128.502 242.616 127.101 242.79 126.918 243.193C126.808 243.422 126.799 243.861 126.799 244.218C126.799 244.402 126.789 244.576 126.78 244.731C126.753 245.006 126.734 245.281 126.716 245.555L126.698 245.839C126.643 246.517 126.579 247.195 126.515 247.882C126.359 249.512 126.203 251.197 126.222 252.818C126.231 253.569 126.304 254.32 126.377 255.062C126.505 256.39 126.643 257.764 126.414 259.174C126.276 260.026 125.782 260.768 125.306 261.491C125.159 261.711 125.013 261.931 124.884 262.15L124.866 262.178C124.866 262.526 124.765 262.865 124.665 263.176C124.582 263.433 124.509 263.671 124.491 263.9C124.426 264.687 124.866 265.383 125.333 266.116C125.736 266.748 126.148 267.398 126.24 268.14C126.313 268.763 126.478 269.395 126.634 270.008C126.698 270.237 126.753 270.466 126.808 270.704L126.835 270.805C127.046 271.675 127.137 272.078 127.696 272.747L128.017 273.131C128.429 273.617 128.823 274.075 129.161 274.652C129.418 275.091 129.656 275.503 129.409 276.09C129.262 276.447 128.951 276.602 128.685 276.74C128.621 276.777 128.557 276.804 128.493 276.85C127.687 277.317 126.936 277.674 126.148 277.995C125.965 278.068 125.773 278.132 125.58 278.187C125.049 278.361 124.555 278.517 124.28 278.883L124.06 279.167C123.611 279.744 123.108 280.403 122.833 281.044C122.622 281.539 122.531 282.107 122.43 282.656L122.348 283.132C122.201 283.911 122.027 284.808 121.771 285.697C121.459 286.768 121.23 287.199 120.525 288.032C120.443 288.124 120.36 288.243 120.269 288.362C120.058 288.655 119.811 288.994 119.527 289.186C119.289 289.342 119.005 289.378 118.748 289.415C118.583 289.443 118.437 289.461 118.327 289.507C118.272 289.534 118.217 289.552 118.18 289.562C118.171 289.607 118.162 289.662 118.144 289.717C118.071 289.992 118.025 290.303 117.988 290.606C117.97 290.761 117.951 290.926 117.924 291.082C117.869 291.439 117.796 291.796 117.723 292.163C117.576 292.877 117.429 293.61 117.402 294.297C117.374 294.855 117.613 295.258 118.125 295.533C118.299 295.625 118.519 295.652 118.757 295.679C119.16 295.734 119.609 295.789 119.921 296.192C120.507 296.952 120.452 298.226 120.067 299.031C119.701 299.792 116.23 301.138 115.057 301.697C114.92 301.898 114.783 302.09 114.728 302.136C114.077 302.667 113.922 302.548 113.72 303.418C113.693 303.519 113.372 304.664 113.427 304.691C117.072 306.88 120.717 309.069 124.362 311.258C129.418 314.299 134.446 317.367 139.574 320.279L157.14 330.408L159.366 331.7C159.366 331.7 160.062 332.093 160.062 332.102L163.753 334.218L165.511 334.63C165.511 334.63 172.975 335.784 173.094 335.802C178.141 336.581 183.196 337.286 188.251 338.019C190.001 338.275 191.75 338.513 193.499 338.751L196.045 320.563C196.494 317.165 196.97 313.749 197.447 310.342Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M154.282 285.052H155.885L156.604 282.782H160.106L160.837 285.052H162.607L159.58 275.88H157.348L154.282 285.052ZM158.361 277.279L159.708 281.537H157.001L158.361 277.279ZM163.275 285.052H170.241V283.68H165.789L170.369 276.098V275.88H163.75V277.227H167.957L163.275 284.821V285.052Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.CA = function () {
	    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref5$color = _ref5.color,
	        color = _ref5$color === undefined ? "#6496c2" : _ref5$color,
	        _ref5$labelColor = _ref5.labelColor,
	        labelColor = _ref5$labelColor === undefined ? "white" : _ref5$labelColor,
	        _ref5$tooltip = _ref5.tooltip,
	        tooltip = _ref5$tooltip === undefined ? {} : _ref5$tooltip,
	        _ref5$labelTooltip = _ref5.labelTooltip,
	        labelTooltip = _ref5$labelTooltip === undefined ? {} : _ref5$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M114.828 301.037C111.605 300.781 108.381 300.268 105.175 299.883C101.778 299.471 98.3707 299.105 94.973 298.674C90.1739 298.07 85.3566 297.539 80.5484 296.952H80.4569L79.7975 294.049L80.063 289.745V289.598C80.0722 289.598 80.0814 288.664 80.0814 288.664L80.0905 288.298L79.9165 286.805L79.8432 286.274C78.5977 282.546 76.4088 279.469 73.9452 276.456C73.1301 275.467 72.315 274.469 71.5091 273.47C71.1885 273.067 71.0237 273.205 70.5108 273.269C69.8148 273.36 69.0821 273.37 68.4502 273.04C68.0564 272.838 67.571 272.573 67.2504 272.28C67.0764 272.115 66.939 271.895 66.9757 271.62C67.0123 271.382 67.1588 271.327 67.3695 271.172C67.5801 271.016 67.6351 271.034 67.69 270.723C67.7358 270.466 67.6992 270.265 67.6626 269.999C67.5984 269.541 67.5343 269.083 67.4428 268.635C67.2687 267.82 66.9574 266.766 66.069 266.501C65.3638 266.29 64.6311 266.144 63.8984 266.098C63.4222 266.07 63.0742 266.134 62.6437 265.942C62.0484 265.676 61.4531 265.411 60.8578 265.145C60.8578 265.154 58.9437 263.707 58.9437 263.707C58.495 263.378 58.1012 262.233 57.8173 261.72C57.4509 261.07 57.0846 260.41 56.6816 259.778C55.8757 258.515 54.8957 257.251 53.5128 256.591C52.368 256.033 50.9851 256.426 49.8036 255.84C48.9061 255.401 48.2284 254.622 47.3492 254.155C46.4517 253.679 45.3984 253.514 44.4185 253.349C43.7499 253.239 43.0722 253.166 42.4036 253.047C41.7259 252.928 41.3321 252.369 40.9658 251.847C40.8192 251.637 40.0133 250.794 40.0316 250.574C40.0316 250.565 40.1507 249.191 40.1507 249.191C40.572 247.039 40.8009 244.685 41.7168 242.671C41.9549 242.139 42.2205 241.507 42.2022 240.912C42.1838 240.262 41.6526 240.134 41.3504 239.657C40.7093 238.659 40.572 237.267 40.0682 236.186C38.9601 233.833 37.5772 231.506 36.066 229.4C35.6905 228.878 35.6447 228.347 35.6264 227.706C35.5989 226.964 35.4616 226.762 35.0952 226.13C34.7106 225.471 34.4358 225.041 34.4725 224.29C34.5549 222.357 33.4467 219.949 32.2195 218.492C31.8073 217.998 31.3128 217.778 31.0472 217.21C30.8182 216.716 30.6351 216.322 30.6717 215.772C30.7725 214.38 30.9556 212.988 31.093 211.605C31.6333 211.413 32.3202 211.34 32.7507 210.982C34.2435 209.764 34.5457 207.31 33.9046 205.606C33.7215 205.112 33.4833 204.718 32.9522 204.746C32.4484 204.773 32.018 204.91 31.5051 204.764C30.3695 204.452 29.7284 203.042 29.3621 202.035C29.1331 201.403 28.9041 200.917 28.5744 200.34C28.1623 199.617 28.0249 199.278 28.0616 198.454C28.1257 197.071 28.1715 195.679 28.263 194.296C28.318 193.508 28.5103 192.739 28.721 191.979C28.8675 191.457 29.2064 190.806 29.2155 190.266C29.2155 190.239 29.2338 189.982 29.2338 189.982L29.4079 188.984C29.9024 188.654 31.0472 188.599 31.1479 189.359C31.1754 189.598 31.1663 190.11 31.0747 190.339C30.9831 190.559 30.7633 190.587 30.6534 190.779C30.5527 190.962 30.5527 191.228 30.516 191.429C30.4611 191.777 30.4061 192.116 30.342 192.464L30.516 192.748L32.6224 194.955L32.7781 195.056L33.1445 195.184L33.3918 195.111C33.4009 195.093 33.4101 192.052 33.4101 192.052L32.3569 189.002L32.6041 187.821C32.6041 187.812 32.0821 187.427 32.0821 187.427L31.5784 186.291L33.3093 185.916L33.5932 185.778L33.9687 185.485L34.0054 185.376L33.9871 185.201L32.6408 183.177C32.6408 183.168 31.2945 183.544 31.2945 183.544L30.8091 184.808C30.5801 185.531 30.1222 186.291 30.571 186.96C30.6717 187.116 30.9098 187.409 30.8732 187.601C30.8457 187.738 30.2687 188.26 30.1405 188.315C29.3163 188.663 27.796 186.291 27.3838 185.824C26.6054 184.936 25.8452 184.02 25.0484 183.15C24.8836 182.967 25.4148 181.474 25.4697 181.245C25.6621 180.439 25.8635 179.56 25.6163 178.745C25.2866 177.637 25.0668 176.437 24.6272 175.365C24.0777 174.01 23.2442 172.719 22.5757 171.418C22.0628 170.429 21.5316 169.458 20.9821 168.487C20.396 167.443 19.5992 166.372 19.4984 165.135C19.3977 163.899 19.6999 162.534 19.8281 161.298C20.0113 159.393 19.9197 157.149 21.1012 155.537C21.4217 155.098 21.8338 154.722 21.9804 154.191C22.1544 153.596 22.2093 152.872 22.2551 152.25C22.3467 151.041 22.4108 149.74 21.9804 148.604C20.9088 145.756 19.471 143.119 18.0606 140.426L17.9873 140.206L18.3078 137.056L18.3536 136.973C19.2695 135.654 20.1945 134.326 21.3576 133.191C22.246 132.33 23.1618 131.442 23.8853 130.434C24.2517 129.93 24.5722 129.381 24.847 128.822C25.0484 128.41 24.9477 128.3 25.0118 127.916C25.1309 127.137 25.6712 126.359 25.9734 125.635C26.2024 125.095 26.4222 124.564 26.6512 124.023L27.8876 121.157C28.0432 120.149 28.1531 119.142 28.1623 118.116C28.1715 117.118 28.0707 116.165 28.1715 115.167C28.2356 114.544 28.2997 113.922 28.3638 113.29L28.7759 111.778C32.714 113.015 36.7163 114.15 40.4529 115.195C47.0378 117.035 53.87 119.014 61.3616 121.239C68.322 123.309 75.2915 125.122 80.6584 126.478L79.7425 130.031C77.9017 137.138 76.1066 144.099 74.3299 151.15C72.7455 157.442 71.0878 163.633 69.3752 169.944C68.844 171.903 68.4319 173.525 68.0655 175.054C67.69 176.611 68.322 178.314 69.0363 179.386L70.4467 181.511C71.8846 183.663 73.3225 185.824 74.7603 187.967C76.7752 190.962 78.7717 193.966 80.7591 196.97C82.4625 199.534 84.1752 202.099 85.8878 204.663C87.5455 207.136 89.1848 209.609 90.8333 212.081C92.9856 215.324 95.147 218.566 97.3175 221.789C99.7536 225.416 102.181 229.052 104.598 232.688C105.871 234.602 107.144 236.507 108.418 238.421C110.533 241.599 112.658 244.768 114.783 247.937L122.412 259.339C122.595 259.614 122.805 259.888 123.016 260.172C123.419 260.713 123.84 261.28 124.106 261.848C124.124 261.894 124.143 261.949 124.152 261.995L124.106 262.077L124.17 262.114C124.188 262.361 124.097 262.645 124.005 262.956C123.923 263.24 123.831 263.524 123.804 263.826C123.721 264.843 124.243 265.667 124.756 266.464C125.132 267.059 125.489 267.609 125.553 268.195C125.635 268.864 125.8 269.514 125.965 270.155C126.02 270.384 126.084 270.613 126.139 270.833L126.167 270.933C126.386 271.858 126.505 272.362 127.165 273.159L127.494 273.553C127.888 274.011 128.264 274.45 128.603 275.046C128.804 275.394 128.877 275.54 128.768 275.806C128.722 275.925 128.584 275.998 128.355 276.117C128.282 276.154 128.209 276.19 128.136 276.236C127.348 276.694 126.652 277.033 125.883 277.335C125.718 277.399 125.535 277.454 125.351 277.518C124.774 277.701 124.124 277.912 123.712 278.452L123.492 278.736C123.016 279.35 122.485 280.046 122.173 280.77C121.935 281.337 121.835 281.942 121.734 282.537L121.651 282.995C121.505 283.755 121.34 284.634 121.093 285.495C120.809 286.475 120.626 286.823 119.985 287.583C119.893 287.693 119.801 287.822 119.701 287.959C119.518 288.206 119.316 288.49 119.133 288.609C119.023 288.682 118.821 288.71 118.629 288.737C118.437 288.765 118.235 288.792 118.043 288.866C117.97 288.893 117.915 288.911 117.878 288.93C117.631 289.012 117.548 289.113 117.493 289.36C117.484 289.397 117.475 289.461 117.448 289.534C117.356 289.855 117.319 290.194 117.274 290.514C117.255 290.67 117.237 290.816 117.21 290.963C117.155 291.311 117.081 291.659 117.008 292.016C116.862 292.749 116.706 293.509 116.678 294.26C116.642 295.093 117.017 295.744 117.768 296.128C118.052 296.275 118.354 296.321 118.629 296.348C118.986 296.394 119.215 296.43 119.334 296.595C119.737 297.117 119.692 298.116 119.408 298.711C119.151 299.297 116.074 300.488 114.828 301.037ZM47.9994 263.24L48.4207 263.442L48.6131 263.533L49.1259 263.726L49.6388 263.854L52.0291 263.808L52.1299 263.79L52.2581 263.68L52.7343 263.314H52.7435L52.7527 263.295L52.6611 263.149L52.194 262.81L51.8093 262.782L51.7727 262.801L51.6994 262.847L51.6445 262.874L51.6079 262.892L51.5804 262.901L51.5346 262.938L50.1242 262.471L49.5838 262.086L48.2376 261.464L47.4866 261.171L47.4041 261.152L47.3034 261.271L47.5781 262.856L47.6148 262.956L47.9994 263.24ZM61.5539 283.948L61.8561 285.852L62.195 286.915L62.2866 287.061L62.9734 287.913L64.0541 287.959L64.0999 287.913L63.9351 287.556L61.9385 284.076L61.5539 283.948ZM64.5853 278.929L64.6952 279.029L66.4536 279.863H66.5819L66.7833 279.744L66.8475 279.588L66.8108 279.295L66.7559 279.158L66.0965 277.793L65.5836 277.353L64.915 276.813L64.0816 276.145L63.3306 275.897L63.2665 275.879L63.2574 275.906L63.2665 276.026L63.3306 276.071L64.5853 278.929ZM43.8232 263.469L44.0064 263.46L46.0853 263.213L46.1494 263.204L46.1586 263.094L46.1952 262.517L45.0596 261.473L42.5135 261.262L43.1638 262.718L43.2645 262.901L43.8232 263.469Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M57.2951 220.124C59.4758 220.124 61.0408 219.008 61.3102 216.802H59.6426C59.463 218.098 58.565 218.739 57.2951 218.739C55.6018 218.739 54.614 217.52 54.614 215.455V215.352C54.614 213.3 55.6659 212.043 57.2822 212.043C58.6035 212.043 59.2834 212.671 59.4758 213.89H61.2076C61.0024 211.735 59.3732 210.683 57.2694 210.683C54.7167 210.683 52.8181 212.607 52.8181 215.365V215.468C52.8181 218.29 54.4216 220.124 57.2951 220.124ZM61.8947 219.996H63.4982L64.2166 217.726H67.7186L68.4498 219.996H70.22L67.1926 210.824H64.9606L61.8947 219.996ZM65.974 212.222L67.3209 216.481H64.6142L65.974 212.222Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.CO = function () {
	    var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref6$color = _ref6.color,
	        color = _ref6$color === undefined ? "#6496c2" : _ref6$color,
	        _ref6$labelColor = _ref6.labelColor,
	        labelColor = _ref6$labelColor === undefined ? "white" : _ref6$labelColor,
	        _ref6$tooltip = _ref6.tooltip,
	        tooltip = _ref6$tooltip === undefined ? {} : _ref6$tooltip,
	        _ref6$labelTooltip = _ref6.labelTooltip,
	        labelTooltip = _ref6$labelTooltip === undefined ? {} : _ref6$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M290.807 248.917C292.254 249.026 293.71 249.146 295.157 249.265C297.887 249.484 300.607 249.704 303.336 249.897L303.592 245.913C303.748 243.522 303.904 241.132 304.05 238.742C304.471 231.955 304.884 225.169 305.296 218.382C305.506 214.948 305.708 211.514 305.909 208.07C306.12 204.544 306.331 201.027 306.541 197.501C306.541 197.492 306.541 197.474 306.541 197.465L306.66 195.532C306.761 193.893 306.871 192.253 306.972 190.614L307.054 189.35C307.173 187.583 307.283 185.806 307.402 184.038L307.549 181.74C307.558 181.666 307.576 181.511 307.604 181.327C307.64 181.099 307.723 180.531 307.723 180.274C307.576 180.265 307.329 180.265 307.228 180.265C307.118 180.265 307.036 180.265 306.99 180.265L304.71 180.109C299.37 179.752 294.745 179.423 290.487 179.102C286.393 178.791 282.299 178.443 278.205 178.095L276.09 177.911C271.281 177.508 222.778 171.958 218.144 171.336C217.906 171.299 217.631 171.262 217.311 171.226L216.761 175.292C216.203 179.441 215.617 183.58 215.03 187.72L214.298 192.922C214.078 194.47 213.867 196.027 213.657 197.575C213.217 200.789 212.768 204.104 212.265 207.365C211.761 210.616 211.367 213.922 210.982 217.128C210.708 219.463 210.415 221.872 210.094 224.244C209.636 227.532 209.178 230.82 208.711 234.098C208.427 236.113 208.143 238.137 207.859 240.152C213.18 240.885 218.602 241.572 223.685 242.203L225.581 242.442C227.348 242.661 229.107 242.89 230.874 243.092C232.221 243.248 233.567 243.44 234.904 243.623C236.434 243.834 238.009 244.053 239.566 244.227C244.026 244.722 248.559 245.18 252.946 245.62L254.961 245.821C259.971 246.334 265.658 246.902 271.272 247.378C276.657 247.827 282.143 248.239 287.446 248.633L288.692 248.724C289.168 248.761 289.644 248.798 290.12 248.834L290.807 248.917Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M253.38 216.459C255.56 216.459 257.125 215.343 257.395 213.137H255.727C255.547 214.433 254.65 215.074 253.38 215.074C251.686 215.074 250.699 213.855 250.699 211.79V211.687C250.699 209.635 251.75 208.378 253.367 208.378C254.688 208.378 255.368 209.006 255.56 210.225H257.292C257.087 208.07 255.458 207.018 253.354 207.018C250.801 207.018 248.903 208.942 248.903 211.7V211.803C248.903 214.625 250.506 216.459 253.38 216.459ZM263.055 216.459C265.838 216.459 267.673 214.445 267.673 211.764V211.662C267.673 208.968 265.787 207.031 263.055 207.031C260.335 207.031 258.411 209.019 258.411 211.7V211.803C258.411 214.445 260.245 216.459 263.055 216.459ZM263.08 215.087C261.413 215.087 260.194 213.791 260.194 211.79V211.687C260.194 209.712 261.259 208.391 263.055 208.391C264.85 208.391 265.902 209.789 265.902 211.675V211.777C265.902 213.765 264.812 215.087 263.08 215.087Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.CT = function () {
	    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref7$color = _ref7.color,
	        color = _ref7$color === undefined ? "#6496c2" : _ref7$color,
	        _ref7$labelColor = _ref7.labelColor,
	        labelColor = _ref7$labelColor === undefined ? "white" : _ref7$labelColor,
	        _ref7$tooltip = _ref7.tooltip,
	        tooltip = _ref7$tooltip === undefined ? {} : _ref7$tooltip,
	        _ref7$labelTooltip = _ref7.labelTooltip,
	        labelTooltip = _ref7$labelTooltip === undefined ? {} : _ref7$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M697.551 136.589C697.294 135.993 697.276 135.563 697.505 135.316C697.56 135.261 697.633 135.197 697.734 135.169C696.983 132.138 696.131 128.969 695.142 125.525C695.032 125.507 694.703 125.617 694.519 125.681C694.391 125.727 694.272 125.763 694.181 125.782L692.853 126.093C692.349 126.212 691.836 126.322 691.332 126.441C690.838 126.551 690.343 126.661 689.849 126.78L684.811 127.971C684.711 127.998 684.592 128.016 684.463 128.035C684.271 128.062 683.978 128.108 683.877 128.172H683.868C683.868 128.291 683.859 128.419 683.795 128.593C683.639 128.987 683.346 129.079 683.09 129.161L682.916 129.216C682.824 129.244 682.723 129.234 682.641 129.198C682.559 129.152 682.494 129.07 682.476 128.978C682.439 128.831 682.421 128.712 682.403 128.621C682.403 128.602 682.394 128.584 682.394 128.566C682.366 128.566 682.33 128.566 682.284 128.575C681.936 128.602 681.551 128.712 681.176 128.822C680.974 128.877 680.773 128.941 680.571 128.987C679.948 129.134 679.316 129.262 678.694 129.399L674.783 130.233C674.728 130.242 674.673 130.26 674.618 130.269L674.957 132.119C675.268 133.804 675.571 135.49 675.864 137.175L676.551 141.177C676.578 141.351 676.596 141.543 676.615 141.736C676.651 142.102 676.688 142.523 676.816 142.78C676.944 143.054 677.292 143.329 677.595 143.586C677.732 143.696 677.86 143.805 677.979 143.906C678.043 143.97 678.089 144.053 678.089 144.153C678.089 144.245 678.053 144.337 677.988 144.401L677.448 144.959C676.935 145.481 676.432 146.013 675.919 146.535C675.818 146.635 675.736 146.718 675.662 146.782C675.616 146.828 675.561 146.874 675.525 146.91C675.543 146.919 675.589 146.983 675.681 147.102L676.679 148.394L679.536 145.967L681.743 144.3L682.614 144.062C682.614 144.062 682.412 143.934 682.412 143.925C682.412 143.925 682.614 144.053 682.614 144.044L682.632 143.97L682.87 143.522L683.071 143.247L684.555 141.516L684.665 141.47L684.94 141.818L685.535 141.726L686.634 141.269L688.383 140.737L688.814 140.637L689.482 140.673L691.882 139.684L692.01 139.702L692.138 139.684L692.825 139.419L693.485 139.116L693.475 138.64L693.704 138.549L693.924 138.713L694.281 138.768L694.62 138.695L694.877 138.219L695.847 138.109L696.113 137.898L696.589 137.514L697.34 137.294L697.633 137.184C697.652 137.092 697.652 136.799 697.551 136.589Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M705.309 156.913L686.525 137.442", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M712.208 165.835C714.389 165.835 715.954 164.719 716.223 162.512H714.556C714.376 163.808 713.478 164.449 712.208 164.449C710.515 164.449 709.527 163.231 709.527 161.165V161.063C709.527 159.01 710.579 157.753 712.195 157.753C713.517 157.753 714.196 158.382 714.389 159.6H716.121C715.915 157.445 714.286 156.393 712.183 156.393C709.63 156.393 707.731 158.318 707.731 161.076V161.178C707.731 164 709.335 165.835 712.208 165.835ZM719.41 165.706H721.129V157.881H723.682V156.534H716.858V157.881H719.41V165.706Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "705", y: "153", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.DC = function () {
	    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref8$color = _ref8.color,
	        color = _ref8$color === undefined ? "#6496c2" : _ref8$color,
	        _ref8$labelColor = _ref8.labelColor,
	        labelColor = _ref8$labelColor === undefined ? "white" : _ref8$labelColor,
	        _ref8$tooltip = _ref8.tooltip,
	        tooltip = _ref8$tooltip === undefined ? {} : _ref8$tooltip,
	        _ref8$labelTooltip = _ref8.labelTooltip,
	        labelTooltip = _ref8$labelTooltip === undefined ? {} : _ref8$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", { d: "M673.239 228.89L642 196", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M676.581 233.789H679.339C682.559 233.789 684.111 231.891 684.111 229.222V229.107C684.111 226.439 682.559 224.617 679.365 224.617H676.581V233.789ZM678.287 232.442V225.964H679.275C681.43 225.964 682.328 227.157 682.328 229.133V229.235C682.328 231.262 681.34 232.442 679.288 232.442H678.287ZM689.754 233.917C691.935 233.917 693.5 232.801 693.769 230.595H692.101C691.922 231.891 691.024 232.532 689.754 232.532C688.061 232.532 687.073 231.313 687.073 229.248V229.145C687.073 227.093 688.125 225.836 689.741 225.836C691.062 225.836 691.742 226.464 691.935 227.683H693.666C693.461 225.528 691.832 224.476 689.728 224.476C687.175 224.476 685.277 226.4 685.277 229.158V229.261C685.277 232.083 686.88 233.917 689.754 233.917Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "676.581", y: "220.789", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.DE = function () {
	    var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref9$color = _ref9.color,
	        color = _ref9$color === undefined ? "#6496c2" : _ref9$color,
	        _ref9$labelColor = _ref9.labelColor,
	        labelColor = _ref9$labelColor === undefined ? "white" : _ref9$labelColor,
	        _ref9$tooltip = _ref9.tooltip,
	        tooltip = _ref9$tooltip === undefined ? {} : _ref9$tooltip,
	        _ref9$labelTooltip = _ref9.labelTooltip,
	        labelTooltip = _ref9$labelTooltip === undefined ? {} : _ref9$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M668.235 195.725L667.64 193.673L666.825 191.292L666.477 190.577L666.449 190.687L666.257 190.834L665.991 190.907L665.634 190.843L665.149 190.651L664.471 190.129L663.253 189.158L663.106 188.984L662.996 188.517L662.694 187.702L662.172 187.271L661.421 186.914L660.927 185.174L661.027 184.707L660.991 184.414L660.67 183.59L660.56 183.434L659.974 182.683L659.754 182.555L658.82 182.005L657.987 180.86L657.483 180.467L657.346 179.972L657.474 178.662L656.695 178.25L656.604 177.82L656.668 177.609L656.778 177.325L657.062 177.06C657.098 176.913 657.153 176.785 657.199 176.666C657.236 176.574 657.263 176.501 657.282 176.428C657.291 176.409 657.3 176.382 657.309 176.354C657.391 175.759 657.501 175.274 657.813 174.669C657.868 174.559 657.923 174.449 657.987 174.349C657.236 174.12 656.485 174.147 655.871 174.44C655.486 174.624 655.148 174.926 654.891 175.31C654.836 175.393 654.763 175.594 654.699 175.777C654.589 176.098 654.479 176.391 654.333 176.583L654.717 178.04L654.763 178.223C655.23 179.972 655.697 181.73 656.192 183.48C656.411 184.258 656.631 185.046 656.851 185.824C657.419 187.848 657.996 189.881 658.564 191.905L659.415 194.955C659.452 195.065 659.489 195.285 659.544 195.55C659.644 196.045 659.919 197.346 660.111 197.547C660.212 197.547 660.67 197.419 660.881 197.364C661.036 197.318 661.174 197.281 661.265 197.272C661.549 197.226 661.824 197.172 662.108 197.117L662.63 197.016C664.077 196.741 665.542 196.421 666.962 196.1L668.272 195.807L668.235 195.725Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M678.966 194.023L664.763 192.419", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M682.995 200.067H685.753C688.973 200.067 690.525 198.168 690.525 195.5V195.385C690.525 192.717 688.973 190.895 685.779 190.895H682.995V200.067ZM684.701 198.72V192.242H685.689C687.844 192.242 688.742 193.435 688.742 195.41V195.513C688.742 197.54 687.754 198.72 685.702 198.72H684.701ZM692.153 200.067H698.105V198.72H693.859V196.039H697.091V194.756H693.859V192.242H697.887V190.895H692.153V200.067Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "682.995", y: "185.067", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.FL = function () {
	    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref10$color = _ref10.color,
	        color = _ref10$color === undefined ? "#6496c2" : _ref10$color,
	        _ref10$labelColor = _ref10.labelColor,
	        labelColor = _ref10$labelColor === undefined ? "white" : _ref10$labelColor,
	        _ref10$tooltip = _ref10.tooltip,
	        tooltip = _ref10$tooltip === undefined ? {} : _ref10$tooltip,
	        _ref10$labelTooltip = _ref10.labelTooltip,
	        labelTooltip = _ref10$labelTooltip === undefined ? {} : _ref10$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M603.302 346.573C603.494 346.545 603.695 346.527 603.888 346.509C603.961 347.571 604.062 348.643 604.501 349.549C604.703 349.971 605.033 350.209 605.243 350.694C605.509 351.289 605.536 351.94 605.674 352.572C605.93 353.716 606.452 354.815 606.873 355.914C607.881 358.515 608.769 361.235 610.198 363.653C610.28 363.781 612.524 367.573 612.524 367.573L613.678 369.478L614.603 370.907L615.317 372.024L615.748 372.61L617.021 374.167L619.832 377.565C620.895 378.847 623.716 380.715 623.78 382.529C623.798 383.078 623.258 383.225 623.047 383.857C622.369 385.917 624.137 388.976 625.227 390.606C626.71 392.841 628.093 395.067 629.431 397.402C630.53 399.307 631.638 401.212 632.728 403.126C634.294 405.846 635.997 408.255 636.437 411.433L636.647 412.944L636.721 413.686C636.867 417.01 636.876 420.344 637.179 423.659C637.261 424.593 637.472 425.518 637.554 426.452C637.655 427.524 637.362 428.495 637.334 429.566C636.684 429.273 637.124 428.55 636.794 428.037C635.457 428.431 635.42 430.839 635.145 432.012C635.145 432.021 635.081 432.616 635.081 432.616L635.136 432.973C635.457 433.935 635.997 434.622 635.438 435.556C635.127 436.078 634.33 436.682 634.504 437.333C633.872 437.296 633.534 437.791 633.332 438.331C632.847 438.065 632.444 437.727 631.857 437.891C631.656 438.752 631.4 439.522 630.319 439.43C630.209 440.474 628.689 439.183 627.929 439.402C627.535 439.522 627.141 440.034 626.756 440.236C626.307 440.474 625.795 440.63 625.309 440.749C624.293 440.987 623.304 440.657 622.855 439.576C622.644 439.064 622.47 437.314 623.221 437.314C623.267 437.021 622.617 436.408 622.406 436.06C621.985 435.354 622.049 435.263 621.28 434.777C622.067 433.852 619.796 432.048 619.246 431.508L618.715 431.343L618.486 429.997L618.376 429.777L618.303 429.704L617.57 429.292L617.177 429.127L617.067 429.09L615.546 428.77H615.354L613.541 429.108L613.394 429.209L613.266 429.365L613.248 429.548L613.202 429.878L613.147 430.088L613.037 430.07L612.945 429.978L611.956 428.586L610.592 426.251L610.418 425.61L610.317 425.179C609.703 423 608.907 420.38 606.333 419.941L606.287 419.639L605.61 419.419L605.371 419.648L605.307 420.023L604.758 420.133L604.73 419.611L603.906 417.633L603.219 417.047L603.091 416.644L603.943 416.461L604.584 417.093L604.804 415.151L605.344 415.078C605.124 415.105 604.987 415.096 604.804 414.895C604.721 414.803 604.703 413.164 604.52 413.191C604.382 413.209 604.227 413.136 604.08 413.154C604.016 413.026 603.943 412.678 603.961 412.532C604.089 412.486 604.236 412.394 604.373 412.376C604.135 411.826 603.585 412.184 603.237 412.458C602.523 413.026 602.78 412.999 603.054 413.759C603.201 414.144 603.668 414.766 603.384 415.215C603.164 415.572 602.395 415.646 602.12 415.426C601.91 415.673 601.845 416.021 601.909 416.351C601.882 416.36 601.763 416.387 601.745 416.406C601.699 416.076 601.662 415.71 601.497 415.407C601.488 415.389 599.501 412.962 599.501 412.962C599.492 412.953 596.735 408.795 596.735 408.795L596.579 408.575L596.341 408.255L596.195 408.053L595.499 407.201L595.105 406.799L594.281 405.965L593.401 405.141L592.907 404.234L593.31 404.051L593.841 403.703L594.858 402.073L594.922 401.935L595.022 401.413L596.57 399.105L596.598 399.041L596.936 398.208L597.019 397.768L596.772 397.008L596.552 396.715L595.865 396.688L595.334 396.422L595.425 397.521L595.663 397.777L595.709 398.245L595.096 398.29L594.473 397.814L594.674 397.475L594.244 395.9H593.685L593.236 395.992L592.797 396.111C592.797 396.12 591.771 396.404 591.771 396.404L591.716 396.459L591.68 396.596L591.771 396.788L591.945 396.907L592.357 397.081L593.108 396.953L593.172 397.439L593.612 397.631L594.235 397.365L594.308 397.796L593.859 398.052L594.107 398.547L593.566 399.38L593.722 400.186L593.438 400.672L592.394 400.955L592.431 401.514L592.641 401.725L592.797 402.21L592.293 402.348L592.055 400.754L591.396 399.747L590.379 398.858L589.701 397.75C590.388 396.614 590.727 395.653 590.498 394.242C590.425 393.757 589.958 393.088 590.15 392.887C590.068 392.896 589.985 392.914 589.894 392.924L591.194 388.179L591.057 383.637L590.809 381.063L590.709 380.505L590.608 380.285L588.602 378.755L588.63 378.178L588.474 377.711L587.531 377.299L587.925 376.805L587.567 376.219L587.201 376.063L584.756 376.237L584.38 376.869L583.858 376.805L583.199 374.927L581.779 374.533V374.515L581.505 373.572L580.983 372.775L580.68 372.354L580.314 372.189H579.957L579.252 371.868L578.061 371.255L577.713 371.062L577.676 370.962C577.521 370.147 577.356 369.341 577.2 368.526C576.559 368.406 575.634 368.141 575.13 367.756C574.398 367.198 573.931 365.924 573.299 365.183L572.621 364.706L572.493 364.624L570.844 363.91L569.947 363.653L568.555 363.03L567.575 362.453L566.283 362.417L563.746 362.774C563.316 362.985 562.189 363.305 562.015 363.781C561.75 364.505 562.84 365.137 562.785 365.824C562.721 366.694 561.365 366.675 561.008 365.979C559.689 366.447 558.7 367.298 557.61 368.141L556.63 368.965L555.769 369.597L554.954 370.119L553.324 370.641L552.665 370.788L552.124 370.705L551.685 370.76L551.392 370.852L549.99 371.374C549.981 371.383 548.562 371.493 548.562 371.493L548.525 369.762L548.479 369.579L548.26 369.203L547.38 368.104L547.023 367.765L546.968 367.72C546.968 367.71 545.402 367.234 545.402 367.234L545.063 367.097L544.953 367.033L544.541 366.74L544.01 366.254L540.722 364.34L540.475 364.212L540.31 364.111L540.145 364.02L539.88 363.891L539.074 363.488L538.872 363.397L538.643 363.305L538.368 363.168L538.112 363.085L537.214 362.756C537.214 362.747 531.005 361.474 531.005 361.474L524.97 361.931L523.22 362.38L519.759 363.461L519.621 363.488L519.539 363.516L519.008 363.644L518.65 363.717L518.092 363.827L515.765 364.377L515.72 364.386C515.82 363.763 515.912 362.985 515.921 362.701C515.93 362.554 515.93 362.417 515.939 362.298C515.994 361.565 516.013 360.832 516.031 360.091C516.04 359.724 516.049 359.358 516.068 359.001C516.113 357.856 515.775 357.306 514.703 356.812C513.806 356.391 513.357 355.933 512.642 355.154L512.505 355.008C512.349 354.852 512.157 354.65 512.13 354.486C512.084 354.183 512.185 353.735 512.276 353.332C512.322 353.121 512.368 352.929 512.395 352.755L512.413 352.599C512.441 352.59 512.478 352.581 512.505 352.572C512.798 352.489 513.165 352.471 513.522 352.462C513.714 352.452 513.897 352.443 514.071 352.434L518.092 352.049C520.033 351.866 521.984 351.692 523.926 351.527C527.067 351.253 531.197 350.886 535.374 350.438C538.945 350.053 542.572 349.604 546.08 349.174L549.67 348.734C549.734 348.725 549.835 348.707 549.945 348.679C550.055 348.652 550.274 348.606 550.375 348.578L550.412 348.698L550.494 348.67C550.54 348.762 550.595 348.872 550.622 348.945C550.659 349.027 550.696 349.11 550.723 349.155L551.731 350.978C551.795 351.097 551.886 351.289 551.978 351.509C552.39 352.434 552.738 353.149 553.196 353.341C553.452 353.451 553.81 353.405 554.249 353.332C554.368 353.313 554.469 353.295 554.542 353.286L556.704 353.139C560.752 352.865 576.165 351.811 579.819 351.564L581.706 351.436C583.309 351.326 584.921 351.216 586.523 351.097L589.427 350.886C589.738 350.859 590.077 350.822 590.416 350.776C591.158 350.676 591.918 350.584 592.559 350.685C592.595 350.694 592.623 350.694 592.65 350.703C592.65 350.722 592.65 350.749 592.659 350.776C592.669 350.868 592.678 350.969 592.705 351.106C592.742 351.289 592.76 351.473 592.788 351.656C592.843 352.049 592.907 352.462 593.017 352.846C593.09 353.121 593.328 353.771 593.832 354.028C594.235 354.229 594.702 354.11 595.068 354.019C595.169 353.991 595.26 353.964 595.352 353.945C596.131 353.799 596.25 353.597 596.268 352.947C596.268 352.865 596.277 352.764 596.277 352.645L596.314 352.104C596.341 351.784 596.369 351.454 596.378 351.134L596.387 350.987C596.405 350.593 596.414 350.135 596.314 349.723C596.222 349.357 596.021 349.082 595.837 348.853C595.737 348.725 595.645 348.606 595.563 348.459C595.407 348.157 595.425 347.873 595.462 347.479L595.48 347.25C595.489 347.131 595.489 347.022 595.489 346.921C595.499 346.564 595.508 346.454 595.682 346.316C595.975 346.069 596.662 345.629 596.799 345.602C596.836 345.62 596.927 345.703 596.982 345.748C597.092 345.84 597.202 345.941 597.33 345.996C597.468 346.051 597.614 346.078 597.742 346.097C597.797 346.106 597.843 346.115 597.889 346.124C598.942 346.353 600.032 346.582 601.195 346.683C601.964 346.728 602.642 346.655 603.302 346.573ZM621.802 449.184L621.71 448.827L620.968 448.607L620.638 448.506L620.098 448.24L619.768 448.561L619.439 448.314L619.43 448.955L619.072 448.946L618.624 449.11L618.312 449.532L617.937 449.587L617.754 449.788L617.744 449.971L616.984 450.731L616.38 451.235L616.151 451.363L615.592 451.62L615.528 451.602L615.436 451.51L615.299 451.528L614.576 451.702L614.337 452.023L614.31 452.133L614.374 452.426L614.42 452.444L614.805 452.353L615.876 452.298L616.902 451.675L618.358 450.832L618.825 450.704L618.816 449.999L619.146 449.925H619.155L619.237 450.264L620.822 450.145L621.765 449.678L622.049 449.495L622.003 449.339L621.802 449.184ZM605.362 420.435L605.207 420.655L604.208 420.408L603.915 420.243L603.705 420.051L602.239 417.303L602.111 416.571L601.809 416.745L601.992 417.331L603.595 420.289L603.723 420.509L603.787 420.573L603.869 420.637L604.666 421.058L605.133 421.196L605.381 421.205L605.5 421.196L605.674 421.104L606.379 420.536V420.49L605.573 420.335L605.362 420.435ZM637.682 431.764L637.563 431.975L636.968 433.981L636.803 434.777L636.034 436.014L635.264 436.49L635.704 436.783L635.741 437.507L635.045 438.157L635.228 438.606L634.953 439L634.459 439.045L634.706 439.668L634.394 439.915L633.772 439.576L633.726 439.796L634.193 439.979L634.165 440.108L633.872 440.923L633.396 441.5L633.066 441.454L633.048 442.04L632.673 442.333L632.325 442.635L631.83 443.396L631.821 443.478V443.496L631.857 443.533L633.094 442.351L633.167 442.26L633.955 441.143L634.568 440.163L635.667 438.862L635.896 438.404L635.988 438.129L635.878 437.882L635.906 437.772L636.849 435.354L637.069 434.924L637.169 434.86L637.6 433.633L637.875 432.36L637.756 431.764H637.682Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M605.798 402.336H607.505V398.578H610.635V397.257H607.505V394.524H611.481V393.164H605.798V402.336ZM612.964 402.336H618.583V400.977H614.67V393.164H612.964V402.336Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.GA = function () {
	    var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref11$color = _ref11.color,
	        color = _ref11$color === undefined ? "#6496c2" : _ref11$color,
	        _ref11$labelColor = _ref11.labelColor,
	        labelColor = _ref11$labelColor === undefined ? "white" : _ref11$labelColor,
	        _ref11$tooltip = _ref11.tooltip,
	        tooltip = _ref11$tooltip === undefined ? {} : _ref11$tooltip,
	        _ref11$labelTooltip = _ref11.labelTooltip,
	        labelTooltip = _ref11$labelTooltip === undefined ? {} : _ref11$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M606.361 322.148C605.857 322.075 605.225 321.974 604.895 321.653C604.456 321.214 604.355 320.426 604.263 319.675C604.208 319.263 604.163 318.869 604.062 318.613C603.879 318.146 603.632 317.669 603.384 317.211C603.256 316.973 603.128 316.735 603.018 316.497L602.954 316.36C602.752 315.957 602.633 315.709 602.313 315.435L602.157 315.307C601.781 314.995 601.461 314.73 601.021 314.556C600.902 314.51 600.792 314.473 600.673 314.436C600.206 314.281 599.675 314.107 599.428 313.566C599.245 313.163 599.171 312.733 599.098 312.312C599.043 311.964 598.988 311.634 598.869 311.341C598.787 311.121 598.649 310.901 598.512 310.672C598.448 310.572 598.393 310.471 598.338 310.379L597.01 308.026C596.928 307.87 596.836 307.687 596.744 307.504C596.58 307.156 596.396 306.762 596.177 306.542C595.7 306.057 594.775 305.69 593.96 305.36C593.612 305.223 593.292 305.095 593.017 304.967C591.872 304.417 590.901 303.52 590.297 302.439C590.141 302.164 590.077 301.862 590.022 301.578C589.976 301.349 589.931 301.129 589.839 300.955C589.665 300.626 589.317 300.287 589.006 299.984L588.777 299.756C588.364 299.343 588.035 299.014 587.54 298.803C586.917 298.537 586.505 298.354 585.992 297.896C585.892 297.805 585.791 297.722 585.681 297.64C585.296 297.329 584.903 296.999 584.628 296.55L584.573 296.468C584.216 295.882 584.051 295.616 583.51 295.195C583.135 294.892 582.576 294.48 582.063 294.343C581.944 294.306 581.844 294.297 581.752 294.279C581.541 294.242 581.322 294.206 581.001 294.013C580.836 293.912 580.644 293.821 580.461 293.72C580.021 293.491 579.563 293.253 579.206 292.923C578.968 292.704 578.794 292.41 578.629 292.136C578.519 291.962 578.418 291.788 578.299 291.641C578.08 291.376 577.841 291.11 577.594 290.835C576.916 290.084 576.22 289.306 575.863 288.408C575.488 287.483 574.957 286.723 574.398 285.917L574.004 285.34C573.931 285.239 573.867 285.13 573.812 285.02C573.61 284.672 573.519 284.543 573.299 284.525C573.079 284.498 572.859 284.562 572.63 284.626C572.356 284.699 572.072 284.782 571.751 284.754C570.918 284.69 570.011 284.04 569.214 283.463C568.949 283.27 568.701 283.096 568.472 282.959C568.298 282.849 568.097 282.739 567.886 282.629C567.419 282.382 566.943 282.126 566.586 281.787C566.018 281.246 566.164 280.624 566.302 280.074L566.329 279.964C566.485 279.296 566.851 278.673 567.218 278.105C567.438 277.766 567.731 277.556 568.005 277.354C568.198 277.217 568.381 277.079 568.527 276.914C568.637 276.786 568.665 276.557 568.692 276.319C568.701 276.228 568.71 276.136 568.729 276.044L565.001 276.631C560.688 277.308 556.392 277.904 552.253 278.389C552.024 278.517 551.676 278.535 551.227 278.545C551.108 278.545 551.007 278.545 550.943 278.554L542.93 279.525C540.063 279.873 537.288 280.193 534.577 280.486L534.65 280.788C534.751 281.201 534.861 281.613 534.971 282.016C535.676 284.69 536.464 287.383 537.224 289.993C537.773 291.879 538.323 293.757 538.845 295.643C539.459 297.851 540.072 300.049 540.686 302.247C541.409 304.838 542.133 307.43 542.847 310.022C543.012 310.627 543.168 311.249 543.333 311.872C543.717 313.42 544.12 315.023 544.734 316.46C545.283 317.752 545.824 319.016 546.428 320.197C546.611 320.563 546.868 320.847 547.161 321.168L547.335 321.36C547.866 321.956 547.994 322.157 548.132 322.945C548.159 323.082 548.187 323.229 548.214 323.366C548.315 323.87 548.415 324.392 548.351 324.923C548.324 325.124 548.333 325.207 548.342 325.234C548.351 325.216 548.415 325.234 548.461 325.234C548.626 325.271 548.855 325.317 549.13 325.463C549.45 325.628 549.652 325.866 549.743 326.168C549.945 326.864 549.46 327.689 549.066 328.348C548.974 328.504 548.892 328.65 548.828 328.769C548.754 328.916 548.663 329.072 548.571 329.227C548.37 329.575 548.168 329.923 548.104 330.235C548.067 330.455 548.077 330.693 548.095 330.949C548.113 331.224 548.132 331.508 548.086 331.801C548.003 332.341 547.893 332.882 547.793 333.413L547.646 334.182C547.628 334.264 547.6 334.374 547.573 334.484C547.527 334.649 547.463 334.896 547.481 334.997C547.481 335.025 547.509 335.052 547.555 335.116C547.6 335.18 547.646 335.244 547.683 335.318C548.434 336.71 548.974 338.322 549.221 339.164C549.487 340.034 549.368 341.124 549.258 342.086C549.221 342.37 549.194 342.644 549.176 342.901C549.157 343.139 549.112 343.395 549.057 343.661C548.919 344.375 548.782 345.108 549.24 345.548C549.258 345.557 549.313 345.584 549.359 345.612C549.478 345.667 549.624 345.731 549.753 345.859C550.018 346.125 550.211 346.354 550.357 346.592C550.595 346.985 550.733 347.434 550.87 347.874C550.907 348.011 550.952 348.139 550.998 348.268C551.117 348.396 551.209 348.588 551.31 348.835C551.337 348.9 551.364 348.955 551.383 348.991L552.39 350.814C552.464 350.951 552.555 351.162 552.665 351.4C552.848 351.812 553.279 352.774 553.526 352.883C553.627 352.92 554.02 352.856 554.204 352.829C554.341 352.801 554.469 352.783 554.561 352.783L556.722 352.636C560.77 352.361 576.184 351.308 579.838 351.061L581.725 350.933C583.327 350.823 584.93 350.713 586.542 350.594L589.445 350.383C589.747 350.365 590.068 350.319 590.398 350.273C591.185 350.173 592 350.063 592.733 350.182C593.246 350.264 593.356 350.466 593.402 350.869C593.411 350.942 593.42 351.033 593.438 351.153C593.475 351.345 593.502 351.537 593.53 351.73C593.585 352.105 593.64 352.49 593.74 352.838C593.841 353.204 594.024 353.506 594.198 353.589C594.381 353.68 594.665 353.598 594.958 353.525C595.068 353.497 595.178 353.47 595.288 353.442C595.545 353.396 595.627 353.36 595.655 353.341C595.645 353.332 595.645 353.213 595.655 353.094C595.655 353.003 595.664 352.893 595.673 352.774L595.709 352.224C595.737 351.913 595.755 351.601 595.764 351.29L595.774 351.134C595.783 350.759 595.801 350.383 595.728 350.063C595.673 349.834 595.535 349.66 595.371 349.458C595.252 349.303 595.133 349.147 595.032 348.964C594.775 348.487 594.812 348.039 594.849 347.608L594.867 347.398C594.876 347.288 594.876 347.196 594.876 347.105C594.885 346.729 594.894 346.335 595.316 345.978C595.325 345.969 596.47 345.071 596.955 345.108C597.184 345.126 597.358 345.282 597.523 345.419C597.578 345.465 597.651 345.538 597.688 345.548C597.743 345.575 597.843 345.584 597.944 345.603C598.008 345.612 598.072 345.621 598.127 345.639C599.162 345.859 600.225 346.088 601.351 346.18C601.974 346.234 602.587 346.161 603.238 346.079C603.439 346.051 603.65 346.033 603.851 346.015C603.824 345.612 603.778 345.218 603.723 344.833C603.677 344.577 603.577 343.176 603.412 342.205L603.247 340.904L604.987 336.059C605.115 334.429 605.243 332.799 605.381 331.169C605.976 331.764 606.077 329.951 606.058 329.584C605.976 328.238 605.481 329.392 604.831 328.568C605.115 328.192 605.564 328.495 605.894 328.321C606.718 327.872 607.359 326.297 607.835 325.518C608.238 324.859 608.788 324.19 609.099 323.476L609.255 323.119L609.31 322.853V322.716L606.617 322.203C606.544 322.175 606.452 322.157 606.361 322.148Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M565.935 322.748C568.526 322.748 570.117 321.209 570.117 318.669V317.822H566.127V319.105H568.436C568.385 320.375 567.679 321.414 565.96 321.414C564.036 321.414 563.125 320.067 563.125 318.104V318.002C563.125 315.988 564.165 314.654 565.96 314.654C567.153 314.654 567.974 315.18 568.18 316.398H569.886C569.642 314.205 567.897 313.307 565.935 313.307C563.254 313.307 561.355 315.257 561.355 317.989V318.092C561.355 320.798 562.997 322.748 565.935 322.748ZM570.545 322.62H572.148L572.866 320.349H576.368L577.1 322.62H578.87L575.842 313.448H573.61L570.545 322.62ZM574.624 314.846L575.971 319.105H573.264L574.624 314.846Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.HI = function () {
	    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref12$color = _ref12.color,
	        color = _ref12$color === undefined ? "#6496c2" : _ref12$color,
	        _ref12$labelColor = _ref12.labelColor,
	        labelColor = _ref12$labelColor === undefined ? "white" : _ref12$labelColor,
	        _ref12$tooltip = _ref12.tooltip,
	        tooltip = _ref12$tooltip === undefined ? {} : _ref12$tooltip,
	        _ref12$labelTooltip = _ref12.labelTooltip,
	        labelTooltip = _ref12$labelTooltip === undefined ? {} : _ref12$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M222.65 399.82L222.897 400.58V401.093L222.394 402.357V403.886L221.377 404.903L220.617 405.416L218.071 405.159L217.054 404.143L215.525 403.63L215.021 403.126V402.357L215.781 401.34L218.327 399.307H221.881L222.65 399.82ZM278.15 421.058L277.894 420.554L276.108 420.051L274.075 418.769V418.521L272.554 418.265L270.008 419.538L268.735 417.505L267.975 417.248H267.215L266.959 417.752L266.446 418.769L266.702 419.785L267.719 420.811L269.248 421.571L269.752 421.058L270.521 421.315L271.025 424.364L271.529 424.621H273.315L275.861 423.604L277.124 423.091L278.15 422.075V421.058ZM296.211 439.43V438.413L295.698 437.653L294.425 437.91L294.177 435.867L293.161 434.594L291.118 433.33L288.069 432.057L285.275 431.545L282.986 430.528L282.473 429.768L280.944 429.511L280.44 429.768L280.183 430.784L280.44 431.801L281.713 433.578V434.594L279.927 436.884L278.407 438.413L278.15 439.174L278.91 440.19L279.927 441.207L281.713 445.529L281.456 449.605L281.713 450.109L282.226 450.878L284.763 451.895L285.779 452.655L286.292 452.142L288.069 448.836L289.342 448.075L291.631 446.299L293.665 446.042L295.954 444.769L298.747 442.223L299.26 441.207L297.484 440.447L296.211 439.43ZM209.682 404.646L208.152 405.672L207.896 407.192L208.152 407.449H208.409L209.169 406.176L210.442 405.672L210.698 403.886H209.938L209.682 404.646ZM249.292 412.193L248.788 411.936V411.167H248.275L248.019 411.936L247.002 411.167L246.746 410.407L247.002 409.903L246.746 409.39H246.499L245.226 407.101L244.466 406.853L243.696 407.357L242.423 409.134L239.886 409.647L240.646 410.16V410.92L241.407 411.68L241.663 412.44L242.423 412.953L242.936 414.226L243.953 413.97L246.499 413.713L247.763 414.482L249.292 413.97V414.226L250.309 413.457L249.548 413.209L249.292 412.193ZM263.14 419.547H261.363L260.603 419.794V420.06L261.619 421.067L261.867 421.837L262.123 422.853L264.413 422.084L264.669 421.067L264.156 420.307L263.14 419.547ZM268.992 424.63L267.215 425.399L266.702 426.15L267.462 426.416L269.495 425.903L269.248 424.886L268.992 424.63ZM262.636 415.215L262.892 415.728H262.636L262.123 415.472H261.867L261.619 415.215L260.859 414.968L257.296 414.711H257.04L256.28 416.745H256.536L260.09 416.497L263.14 417.001H263.909L265.429 415.984L265.942 414.968L264.925 414.711L262.636 415.215Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M240.202 438.071H241.908V434.172H246.026V438.071H247.745V428.899H246.026V432.799H241.908V428.899H240.202V438.071ZM249.887 438.071H251.606V428.899H249.887V438.071Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "236", y: "426", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.IA = function () {
	    var _ref13 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref13$color = _ref13.color,
	        color = _ref13$color === undefined ? "#6496c2" : _ref13$color,
	        _ref13$labelColor = _ref13.labelColor,
	        labelColor = _ref13$labelColor === undefined ? "white" : _ref13$labelColor,
	        _ref13$tooltip = _ref13.tooltip,
	        tooltip = _ref13$tooltip === undefined ? {} : _ref13$tooltip,
	        _ref13$labelTooltip = _ref13.labelTooltip,
	        labelTooltip = _ref13$labelTooltip === undefined ? {} : _ref13$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M379.818 139.107C379.8 139.336 379.781 139.648 379.836 139.776C379.882 139.876 380.029 139.986 380.166 140.096C380.358 140.243 380.578 140.408 380.697 140.664C380.835 140.948 380.899 141.635 380.78 141.974H380.77C380.789 142.075 380.77 142.184 380.697 142.267C380.642 142.331 380.569 142.368 380.496 142.386C380.331 142.468 380.166 142.477 380.001 142.487C380.01 142.633 380.019 142.771 380.056 142.89C380.074 142.963 380.129 143.155 380.166 143.192C380.175 143.192 380.212 143.21 380.349 143.238C380.377 143.247 380.468 143.238 380.532 143.228C380.734 143.21 381.036 143.183 381.265 143.393C381.448 143.567 381.512 143.87 381.576 144.263C381.595 144.355 381.604 144.437 381.622 144.501C381.824 145.243 381.842 145.417 381.613 146.123C381.494 146.471 381.402 146.828 381.302 147.176L381.164 147.661C381.027 148.147 380.853 148.632 380.688 149.108C380.514 149.621 380.331 150.134 380.184 150.647L380.074 151.013C379.928 151.508 379.745 152.112 379.763 152.524V152.625C379.8 152.662 379.845 152.707 379.9 152.772C379.955 152.836 380.029 152.891 380.093 152.946C380.203 153.037 380.303 153.129 380.395 153.229C380.917 153.861 381.192 154.759 381.439 155.556C381.503 155.766 381.567 155.968 381.631 156.169C381.851 156.197 382.071 156.27 382.227 156.444C382.474 156.71 382.456 157.085 382.428 157.479C382.391 158.028 382.419 158.816 382.556 159.329C382.575 159.402 382.63 159.494 382.694 159.595C382.776 159.723 382.859 159.869 382.904 160.052C382.968 160.318 382.923 160.556 382.877 160.767C382.859 160.877 382.831 160.987 382.831 161.097C382.831 161.463 382.996 161.857 383.152 162.241C383.207 162.379 383.261 162.516 383.316 162.653C383.747 163.853 384.278 164.916 384.937 166.143C384.992 166.244 385.057 166.344 385.112 166.454C385.295 166.766 385.487 167.095 385.579 167.452C385.707 167.993 385.725 168.588 385.734 169.156C385.743 169.422 385.743 169.687 385.762 169.934C385.826 170.777 386.311 171.528 386.824 172.316C386.989 172.563 387.145 172.81 387.291 173.057C387.813 173.937 388.143 175.054 388.207 176.116C388.244 176.684 388.271 177.261 388.308 177.829L388.344 178.607C388.344 178.653 388.344 178.717 388.344 178.8C388.344 178.882 388.335 179.047 388.344 179.102C388.344 179.093 388.5 179.148 388.573 179.184C388.784 179.267 389.022 179.358 389.16 179.578C389.388 179.954 389.297 180.485 389.205 181.007C389.169 181.236 389.123 181.465 389.123 181.611C389.132 181.969 389.224 182.344 389.324 182.729C389.361 182.866 389.398 183.013 389.425 183.15C389.608 183.938 389.682 184.359 389.526 185.174C389.498 185.293 389.48 185.412 389.453 185.522C389.352 185.989 389.269 186.328 389.416 186.74L389.599 187.299C389.865 188.086 390.103 188.819 390.423 189.515C394.636 189.561 398.849 189.588 403.071 189.607C410.279 189.643 417.395 189.341 425.885 188.901C430.153 188.682 433.99 188.444 437.617 188.196L438.441 188.132C439.155 188.077 439.897 188.013 440.63 188.004C440.831 188.004 441.06 187.986 441.298 187.967C441.619 187.94 441.949 187.922 442.278 187.922C442.828 187.922 443.359 187.986 443.78 188.233C444.238 188.499 444.788 188.874 444.971 189.387C445.017 189.506 445.008 189.625 444.998 189.707C445.017 189.836 445.145 189.973 445.209 190.037C445.273 190.101 445.328 190.156 445.365 190.211L445.612 190.523C445.859 190.834 446.088 191.127 446.354 191.374C446.629 191.631 446.803 191.64 447.215 191.658L447.416 191.667C447.444 191.658 447.471 191.64 447.489 191.631C447.554 191.603 447.645 191.567 447.654 191.539C447.801 191.31 447.764 190.065 447.609 189.744C447.581 189.689 447.526 189.643 447.444 189.579C447.297 189.469 447.059 189.277 447.077 188.92C447.096 188.499 447.728 187.812 447.728 187.812C448.076 187.445 448.671 187.134 449.239 187.015C449.394 186.987 449.559 186.997 449.724 187.006C449.834 187.015 450.026 187.024 450.081 186.997C450.21 186.923 450.603 186.429 450.732 186.2C450.878 185.934 450.86 185.568 450.841 185.183C450.832 184.853 450.814 184.524 450.887 184.194C451.043 183.525 451.684 182.665 452.197 182.207C452.298 182.115 452.38 182.051 452.453 182.005C452.591 181.904 452.6 181.895 452.637 181.63C452.682 181.273 452.692 180.879 452.682 180.503C452.682 179.825 452.618 179.276 452.325 178.8C452.115 178.452 452.078 178.388 451.849 178.278L451.675 178.195C451.455 178.095 451.272 178.003 451.025 177.747C450.2 176.886 450.255 176.501 450.512 175.512L450.576 175.265C450.612 175.118 450.64 174.953 450.667 174.779C450.75 174.285 450.851 173.726 451.135 173.36C451.162 173.323 451.189 173.296 451.226 173.277C452.179 172.691 453.534 172.462 454.514 172.462C455.604 172.49 456.41 172.132 457.5 171.592C457.619 171.537 457.738 171.482 457.866 171.427C458.141 171.299 458.434 171.171 458.635 171.006C458.91 170.786 459.157 170.438 459.395 170.108L459.588 169.843C459.917 169.394 459.936 169.248 460 168.625L460.018 168.377C460.055 167.947 460.091 167.581 460.412 167.15C460.513 167.013 460.623 166.894 460.723 166.775C460.907 166.564 461.062 166.39 461.172 166.143C461.502 165.374 461.74 164.76 461.923 164.201C462.115 163.606 462.088 162.617 461.731 162.113C461.484 161.747 461.163 161.39 460.861 161.051C460.696 160.868 460.54 160.694 460.394 160.51L460.247 160.327C460.046 160.08 459.872 159.86 459.634 159.723C458.809 159.256 458.04 158.825 458.187 157.671C458.26 157.067 457.591 156.609 457.005 156.206L456.849 156.096C456.749 156.023 456.584 155.949 456.41 155.858C455.833 155.574 455.173 155.253 455.054 154.713C455.018 154.557 455.027 154.328 455.21 154.081C455.237 153.797 454.807 152.982 454.413 152.488C454.193 152.204 453.708 152.14 453.241 152.066C453.104 152.048 452.975 152.03 452.847 152.002L452.582 151.956C451.95 151.837 451.299 151.718 450.704 151.361C449.825 150.83 449.596 150.381 449.239 149.584C449.166 149.41 449.083 149.236 449.001 149.072C448.735 148.522 448.469 147.954 448.323 147.341L448.222 146.956C448.039 146.232 447.828 145.417 447.847 144.703C447.856 144.053 448.085 143.366 448.561 142.569C448.607 142.487 448.689 142.377 448.772 142.267C448.909 142.084 449.156 141.726 449.156 141.58C449.156 141.525 449.12 141.351 448.735 140.902C448.534 140.673 448.277 140.499 448.002 140.316L447.645 140.069C447.251 139.794 447.151 139.666 447.16 139.089C447.169 138.603 447.114 138.118 447.041 137.614L446.052 137.66C441.509 137.88 436.976 138.072 432.433 138.255C428.229 138.429 411.213 138.878 406.899 138.942L405.095 138.97C401.514 139.025 397.805 139.08 394.16 139.089L390.304 139.098C387.31 139.107 384.306 139.116 381.311 139.107L379.809 139.098C379.818 139.08 379.818 139.089 379.818 139.107Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M413.43 168.684H415.149V159.512H413.43V168.684ZM416.607 168.684H418.211L418.929 166.414H422.431L423.162 168.684H424.932L421.905 159.512H419.673L416.607 168.684ZM420.686 160.911L422.033 165.169H419.327L420.686 160.911Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.ID = function () {
	    var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref14$color = _ref14.color,
	        color = _ref14$color === undefined ? "#6496c2" : _ref14$color,
	        _ref14$labelColor = _ref14.labelColor,
	        labelColor = _ref14$labelColor === undefined ? "white" : _ref14$labelColor,
	        _ref14$tooltip = _ref14.tooltip,
	        tooltip = _ref14$tooltip === undefined ? {} : _ref14$tooltip,
	        _ref14$labelTooltip = _ref14.labelTooltip,
	        labelTooltip = _ref14$labelTooltip === undefined ? {} : _ref14$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M142.478 28.675C141.534 32.7413 140.618 36.8168 139.712 40.8923C139.19 43.2277 138.668 45.5723 138.136 47.9077C137.688 49.8859 137.248 51.8549 136.799 53.8332L135.764 58.449C135.645 59.0168 135.517 59.603 135.334 60.1708C135.197 60.6104 135.306 61.0317 135.444 61.5171C135.508 61.746 135.572 61.9842 135.609 62.2223C135.755 63.0923 135.883 63.999 135.746 64.7408C135.691 65.0339 135.572 65.2995 135.453 65.5468C135.343 65.7849 135.242 66.0047 135.206 66.2245C135.169 66.426 135.206 66.7007 135.242 66.9663C135.261 67.1037 135.279 67.2411 135.288 67.3693V67.4243C135.297 67.4426 135.306 67.47 135.316 67.4975L135.352 67.58C135.526 67.9738 135.636 68.3584 135.746 68.7248C135.938 69.3933 136.094 69.9611 136.598 70.4282C136.717 70.5381 136.836 70.6572 136.955 70.7854C137.202 71.0327 137.45 71.2891 137.706 71.4448C138.219 71.7653 138.567 71.9851 138.778 72.672L138.814 72.7911C139.107 73.7436 139.51 75.0349 138.723 75.8775C137.807 76.8574 137.092 77.6817 136.424 78.5426C135.966 79.1287 135.618 79.7057 135.261 80.3285C135.132 80.5391 135.013 80.7498 134.876 80.9604C134.73 81.1985 134.592 81.4366 134.455 81.6748C133.979 82.5082 133.484 83.3599 132.742 84.0285C132.376 84.3673 132.11 84.6329 132.101 85.0176C132.092 85.1916 132.11 85.3106 132.129 85.4114C132.174 85.7777 132.156 85.9975 131.817 86.4921C131.606 86.7943 131.35 87.0507 131.103 87.3072C131.002 87.4079 130.91 87.5087 130.819 87.6002C130.315 88.1406 129.857 88.2871 129.216 88.4795C128.584 88.6718 128.236 89.203 127.824 89.8166C127.714 89.9814 127.604 90.1463 127.485 90.3111C127.329 90.5218 127.146 90.7507 126.963 90.9797C126.469 91.5842 125.947 92.2161 125.8 92.8572C125.69 93.3151 125.635 93.8097 125.58 94.295C125.553 94.5423 125.525 94.7896 125.489 95.0369C125.48 95.1101 125.461 95.2017 125.443 95.2842C125.406 95.4765 125.351 95.7146 125.397 95.8337C125.461 95.9894 125.846 96.255 126.698 96.4656C126.771 96.4839 126.844 96.4839 126.927 96.4931C127.174 96.5114 127.513 96.548 127.787 96.8136C128.044 97.07 128.548 97.9951 128.575 98.4255C128.603 98.8468 128.355 99.1124 128.154 99.3322C128.071 99.4238 127.989 99.5062 127.934 99.5978C127.76 99.8908 127.687 100.285 127.604 100.669C127.568 100.834 127.54 100.999 127.494 101.155C127.357 101.713 127.101 102.162 126.835 102.648C126.157 103.866 125.342 105.45 124.994 107.025L118.711 134.986C120.891 135.499 123.117 136.012 125.315 136.479C131.24 137.733 151.16 141.891 155.812 142.807C155.876 142.78 155.95 142.78 156.014 142.798C158.193 143.348 160.456 143.723 162.654 144.08L163.972 144.3C165.429 144.547 168.194 145.014 171.51 145.573C179.276 146.892 189.817 148.678 193.691 149.291C194.195 146.141 194.699 142.99 195.212 139.831C195.853 135.911 197.858 123.181 199.058 115.579L199.828 110.725C200.011 109.562 200.176 108.39 200.35 107.218C200.359 107.172 200.368 107.126 200.368 107.071C200.34 107.044 200.313 107.025 200.285 106.998C199.937 106.696 199.58 106.384 199.37 105.908C199.232 105.615 199.141 105.303 199.049 105.01C198.976 104.763 198.903 104.525 198.802 104.287L198.701 104.04C198.014 102.309 197.63 101.906 197.428 101.878C197.291 101.887 196.512 102.199 196.274 102.382C195.954 102.629 195.651 103.014 195.367 103.389C195.221 103.582 195.074 103.774 194.928 103.939C194.855 104.021 194.79 104.104 194.735 104.177C194.47 104.516 194.241 104.809 193.572 104.791H193.417C192.895 104.781 192.4 104.763 191.86 104.607C190.486 104.214 189.469 104.012 188.352 103.893C188.169 103.875 187.967 103.838 187.766 103.801C187.372 103.737 186.96 103.664 186.649 103.71C186.401 103.747 186.145 103.875 185.87 104.003C185.568 104.15 185.256 104.305 184.918 104.36C184.56 104.415 184.194 104.305 183.874 104.204C183.782 104.177 183.681 104.15 183.599 104.122L181.181 103.518C180.054 103.234 179.487 103.444 179.221 104.232L179.166 104.424C179.065 104.754 178.955 105.12 178.607 105.249C178.269 105.368 177.948 105.148 177.838 105.075C177.389 104.772 176.849 104.085 176.583 103.6C176.08 102.693 176.226 101.356 176.327 100.376L176.345 100.193C176.419 99.4696 176.126 98.1141 175.631 97.4547C175.494 97.2715 175.31 97.07 175.136 96.9052C175.072 96.8411 174.981 96.7587 174.926 96.7129C174.807 96.7403 174.679 96.7678 174.559 96.7129C174.147 96.5572 173.863 96.1176 173.607 95.7238C173.543 95.623 173.479 95.5223 173.415 95.4399L173.167 95.101C172.664 94.4141 172.233 93.828 171.995 92.9396C171.83 92.3168 171.629 91.6757 171.436 91.0438C170.869 89.1847 170.273 87.2614 170.273 85.3381C170.273 84.8985 170.31 84.4955 170.347 84.1017C170.402 83.479 170.456 82.8928 170.356 82.2334C170.301 81.8579 170.081 81.5648 169.825 81.2351C169.76 81.1436 169.696 81.0611 169.632 80.9696C169.577 80.8963 169.531 80.8139 169.477 80.7314C169.385 80.5849 169.284 80.4292 169.193 80.3376L169.119 80.2735C169.074 80.2918 169.037 80.3101 168.991 80.3285C168.515 80.5299 168.13 80.878 167.727 81.2535C167.343 81.6015 166.94 81.9678 166.445 82.2151C166.299 82.2884 166.152 82.3708 165.987 82.4532C165.483 82.728 164.906 83.0394 164.375 83.1493C163.615 83.3141 163.423 82.8562 163.295 82.554C163.267 82.4898 163.24 82.4166 163.194 82.3342C162.974 81.8946 162.672 81.3176 162.351 81.1619C162.305 81.1436 162.141 81.1344 162.049 81.1252C161.802 81.1069 161.555 81.0886 161.371 80.9421C161.197 80.7955 161.142 80.6307 161.197 80.4292C161.161 80.0354 161.28 79.5592 161.39 79.147C161.435 78.973 161.481 78.8082 161.5 78.6708C161.536 78.4968 161.564 78.3136 161.591 78.1304C161.646 77.7366 161.71 77.3337 161.82 76.949C162.022 76.2346 162.333 75.5295 162.635 74.8517C162.782 74.522 162.928 74.1923 163.056 73.8626L164.852 69.3933C165.163 68.6148 165.52 67.8364 165.859 67.0854C166.326 66.0688 166.802 65.0156 167.178 63.9441C167.205 63.8708 167.233 63.7975 167.269 63.7151C167.379 63.4495 167.526 63.074 167.416 62.9183C167.269 62.7168 166.876 62.7626 166.482 62.8542C166.024 62.9549 165.035 63.0282 164.531 62.6161C164.238 62.378 164.155 61.9842 164.073 61.5995C164.027 61.3614 163.963 61.0592 163.862 60.9767C163.835 60.9584 163.743 60.9493 163.661 60.9493C163.469 60.9401 163.176 60.9309 162.928 60.6928C162.507 60.299 162.159 59.777 161.82 59.2733C161.71 59.1084 161.6 58.9436 161.49 58.7879C161.133 58.2842 161.051 57.7255 160.968 57.1852C160.904 56.7547 160.849 56.3426 160.648 55.9854C160.135 55.0329 159.704 54.0347 159.292 53.073L159.118 52.6701C159.027 52.4594 158.944 52.2121 158.844 51.9465C158.615 51.2871 158.322 50.4629 157.9 50.179C157.708 50.0507 157.47 49.9683 157.204 49.8767C156.911 49.776 156.609 49.6752 156.343 49.4921C155.95 49.2265 155.702 48.8785 155.464 48.5305L155.345 48.3656C155.217 48.1916 155.07 48.0084 154.915 47.8161C154.576 47.404 154.228 46.9827 154.017 46.5156C153.806 46.0577 153.898 45.5723 153.98 45.1418L154.026 44.8854C154.1 44.4092 154.283 43.9696 154.466 43.5483C154.722 42.9347 154.96 42.3577 154.851 41.7349C154.75 41.1488 154.383 40.5077 154.026 39.8849C153.871 39.6101 153.715 39.3354 153.587 39.079L153.303 38.4928C153.092 38.0532 152.881 37.6228 152.662 37.1832C152.616 37.0916 152.552 36.9908 152.488 36.8901C152.323 36.6337 152.158 36.3681 152.121 36.0933C152.066 35.672 152.222 35.1408 152.369 34.6738C152.424 34.4906 152.479 34.3166 152.506 34.1609L152.946 32.0911C153.504 29.4443 154.072 26.7975 154.64 24.1599L155.757 18.9304L145.28 16.6592C144.575 19.7364 143.86 22.8136 143.137 25.8817L142.478 28.675Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M153.206 121.038H154.925V111.866H153.206V121.038ZM157.088 121.038H159.847C163.066 121.038 164.619 119.139 164.619 116.471V116.355C164.619 113.687 163.066 111.866 159.872 111.866H157.088V121.038ZM158.795 119.691V113.213H159.782C161.937 113.213 162.835 114.406 162.835 116.381V116.484C162.835 118.511 161.848 119.691 159.795 119.691H158.795Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.IL = function () {
	    var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref15$color = _ref15.color,
	        color = _ref15$color === undefined ? "#6496c2" : _ref15$color,
	        _ref15$labelColor = _ref15.labelColor,
	        labelColor = _ref15$labelColor === undefined ? "white" : _ref15$labelColor,
	        _ref15$tooltip = _ref15.tooltip,
	        tooltip = _ref15$tooltip === undefined ? {} : _ref15$tooltip,
	        _ref15$labelTooltip = _ref15.labelTooltip,
	        labelTooltip = _ref15$labelTooltip === undefined ? {} : _ref15$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M470.165 153.751C467.977 153.861 465.779 153.99 463.59 154.118C460.98 154.264 458.369 154.42 455.759 154.548C455.805 154.759 456.437 155.061 456.739 155.217C456.959 155.327 457.151 155.418 457.27 155.501L457.426 155.611C458.104 156.078 459.029 156.71 458.901 157.726C458.818 158.395 459.175 158.633 459.936 159.063C460.357 159.301 460.595 159.595 460.824 159.869L460.97 160.043C461.117 160.217 461.273 160.391 461.428 160.565C461.749 160.923 462.079 161.298 462.353 161.692C462.857 162.424 462.875 163.624 462.628 164.384C462.445 164.961 462.198 165.602 461.85 166.39C461.703 166.738 461.492 166.967 461.291 167.196C461.199 167.297 461.108 167.407 461.016 167.535C460.815 167.8 460.796 168.02 460.76 168.405L460.732 168.661C460.659 169.321 460.632 169.614 460.192 170.209L460.009 170.466C459.752 170.814 459.468 171.217 459.13 171.491C458.855 171.72 458.525 171.867 458.205 172.004C458.086 172.059 457.976 172.105 457.866 172.16C456.721 172.728 455.814 173.14 454.56 173.103C453.607 173.076 452.416 173.36 451.702 173.781C451.546 174.028 451.464 174.468 451.4 174.852C451.363 175.045 451.336 175.228 451.29 175.384L451.226 175.64C451.006 176.492 450.979 176.602 451.574 177.224C451.73 177.389 451.83 177.435 452.023 177.527L452.215 177.618C452.609 177.82 452.728 178.021 452.948 178.378C453.36 179.056 453.415 179.78 453.424 180.457C453.424 180.86 453.424 181.282 453.369 181.685C453.305 182.188 453.177 182.326 452.911 182.518C452.856 182.564 452.792 182.61 452.71 182.683C452.27 183.077 451.73 183.809 451.611 184.322C451.556 184.551 451.565 184.835 451.574 185.128C451.592 185.595 451.611 186.081 451.372 186.502C451.317 186.612 450.795 187.418 450.402 187.601C450.191 187.693 449.944 187.683 449.715 187.665C449.605 187.656 449.467 187.647 449.403 187.665C448.982 187.748 448.506 187.995 448.259 188.26C448.094 188.434 447.819 188.819 447.791 188.938C447.801 188.947 447.865 188.984 447.901 189.021C448.011 189.103 448.158 189.222 448.259 189.414C448.497 189.881 448.588 191.42 448.268 191.905C448.14 192.098 447.938 192.18 447.801 192.244C447.782 192.253 447.764 192.263 447.746 192.263L447.737 192.354L447.617 192.345C447.471 192.537 447.352 192.885 447.251 193.197C447.196 193.371 447.141 193.545 447.077 193.682C446.573 194.873 446.83 195.944 447.123 197.181C447.187 197.446 447.251 197.712 447.306 197.996C447.608 199.452 448.103 200.734 448.79 202.319C449 202.813 449.303 203.436 449.678 203.839C449.944 204.123 450.292 204.352 450.658 204.599C450.951 204.791 451.253 204.993 451.519 205.231C452.169 205.808 452.755 206.458 453.332 207.09C453.79 207.594 454.257 208.107 454.743 208.574C455.146 208.958 455.567 209.325 455.988 209.682C456.208 209.874 456.419 210.057 456.629 210.25C456.748 210.36 456.886 210.46 457.023 210.57C457.417 210.891 457.875 211.248 458.113 211.697C458.379 212.2 458.891 213.547 458.653 214.27C458.589 214.463 458.516 214.573 458.461 214.655C458.406 214.747 458.397 214.756 458.406 214.847C458.434 215.113 458.598 215.479 458.745 215.791C458.809 215.937 458.882 216.084 458.928 216.212C458.946 216.267 458.965 216.313 458.983 216.349H459.001C459.203 216.386 459.624 216.221 459.899 216.12C460.073 216.056 460.229 216.001 460.348 215.965C461.209 215.736 461.602 215.635 462.546 215.864C462.72 215.91 462.894 215.946 463.068 215.983C463.663 216.111 464.286 216.249 464.844 216.532C464.918 216.569 465.018 216.615 465.119 216.661C465.861 217.018 466.493 217.348 466.649 217.824C466.878 218.501 466.383 218.978 466.026 219.326C465.843 219.5 465.65 219.683 465.614 219.829C465.586 219.921 465.66 220.159 465.715 220.333C465.779 220.525 465.843 220.727 465.852 220.91C465.87 221.276 465.788 221.496 465.669 221.799C465.394 222.522 465.138 223.172 464.89 223.823C464.579 224.638 464.277 225.444 463.956 226.259C463.736 226.826 463.324 228.274 464.332 229.382C464.954 230.078 465.705 230.71 466.438 231.314C466.859 231.662 467.281 232.019 467.674 232.386C467.903 232.596 468.132 232.816 468.361 233.045C468.81 233.494 469.268 233.952 469.753 234.281C470.056 234.483 470.459 234.584 470.862 234.675C471.008 234.712 471.155 234.748 471.292 234.785C471.457 234.831 471.667 234.868 471.896 234.913C472.519 235.032 473.215 235.161 473.618 235.49C473.811 235.646 473.93 235.902 474.049 236.131C474.085 236.214 474.122 236.287 474.159 236.342L475.047 237.807C475.129 237.945 475.23 238.091 475.349 238.247C475.606 238.604 475.88 238.989 476.018 239.383H476.064L476.082 239.676C476.082 239.685 476.082 239.685 476.082 239.694L476.109 239.932C476.219 240.436 476.567 240.857 476.943 241.297L477.089 241.48C477.492 241.965 477.941 242.936 477.538 243.596C477.364 243.87 477.108 243.925 476.952 243.953C476.906 243.962 476.833 243.971 476.824 243.989C476.805 244.081 476.833 244.74 476.888 245.024C476.952 245.409 477.254 245.876 477.538 246.325C477.721 246.609 477.895 246.883 478.014 247.14C478.097 247.305 478.161 247.47 478.234 247.634C478.481 248.221 478.655 248.633 479.214 248.926C479.516 249.081 479.938 249.072 480.395 249.063C480.643 249.054 480.89 249.054 481.128 249.072C480.899 248.651 480.771 248.321 480.826 248.056C480.899 247.708 481.311 247.36 481.879 246.902C482.016 246.792 482.126 246.7 482.19 246.636C482.355 246.48 482.511 246.297 482.685 246.114C483.061 245.702 483.445 245.281 483.885 245.006C484.224 244.786 484.343 244.759 484.709 244.914L484.837 244.969C485.808 245.363 486.77 245.775 487.722 246.197L489.16 246.81C489.545 246.975 489.838 247.067 490.277 247.076C490.644 247.085 490.699 247.067 490.827 246.508C490.973 245.894 490.909 245.546 490.57 245.143C490.479 245.033 490.369 244.942 490.259 244.841C489.957 244.575 489.581 244.237 489.526 243.696C489.471 243.193 489.682 242.515 489.902 241.865C490.113 241.251 490.47 240.875 490.937 240.802C491.166 240.756 491.386 240.857 491.55 240.94C491.614 240.967 491.715 241.013 491.752 241.022C491.724 241.022 491.798 240.912 491.843 240.839C491.917 240.738 491.99 240.628 492.082 240.546C492.43 240.225 492.814 240.097 493.144 240.015C493.263 239.987 493.465 239.95 493.703 239.923C494.133 239.859 495.269 239.703 495.397 239.438C495.406 239.419 495.388 239.373 495.369 239.337C495.232 239.09 495.04 238.897 494.847 238.696C494.573 238.412 494.252 238.091 494.078 237.588C493.886 237.029 493.785 236.617 494.161 235.957C494.335 235.655 494.573 235.445 494.783 235.261C495.012 235.069 495.205 234.904 495.305 234.648C495.342 234.556 495.36 234.483 495.369 234.41C495.388 234.327 495.406 234.236 495.452 234.144L494.802 232.688C494.756 232.587 494.765 232.459 494.82 232.367C494.884 232.267 494.985 232.212 495.104 232.202C495.214 232.202 495.314 232.202 495.397 232.202C495.443 232.202 495.489 232.202 495.525 232.202C495.525 232.193 495.534 232.166 495.553 232.129C495.672 231.809 495.653 231.268 495.644 230.783C495.635 230.536 495.626 230.298 495.635 230.105L495.717 228.365C495.727 228.191 495.717 227.99 495.717 227.797C495.708 227.349 495.69 226.881 495.809 226.469C495.901 226.149 496.13 225.874 496.34 225.636C496.404 225.563 496.468 225.489 496.523 225.416L498.062 223.374C498.575 222.696 498.831 221.908 499.097 221.075C499.17 220.837 499.253 220.608 499.335 220.37L499.417 220.132C499.518 219.82 499.628 219.491 499.811 219.198C499.976 218.923 500.196 218.694 500.397 218.465C500.59 218.254 500.773 218.062 500.901 217.851C501.112 217.503 501.203 216.908 501.176 216.487C501.158 216.239 501.029 216.001 500.883 215.745C500.782 215.571 500.691 215.397 500.626 215.214C500.434 214.692 500.526 214.298 500.617 213.876L500.654 213.712C500.736 213.336 500.498 212.97 500.251 212.585C500.178 212.466 500.095 212.347 500.031 212.219C499.921 212.026 499.775 211.843 499.619 211.651C499.436 211.431 499.253 211.211 499.115 210.946C498.767 210.277 498.831 209.636 498.895 209.013C499.005 207.878 499.179 206.825 499.344 205.808L499.454 205.121C499.61 204.132 499.527 203.253 499.436 202.236L499.335 201.183C499.143 199.141 498.96 197.098 498.786 195.056C498.648 193.389 498.511 191.731 498.373 190.065C498.135 187.189 497.906 184.304 497.65 181.428L497.393 178.607C497.036 174.66 496.688 170.713 496.349 166.756L496.185 164.714C495.516 163.936 495.205 162.892 494.857 161.765C494.261 159.86 493.162 158.706 492.237 156.994C491.376 155.382 491.889 153.907 491.788 152.195C489.261 152.369 486.742 152.57 484.224 152.772C479.992 153.184 475.523 153.477 470.165 153.751Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M471.156 198.005H472.875V188.833H471.156V198.005ZM475.038 198.005H480.657V196.646H476.744V188.833H475.038V198.005Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.IN = function () {
	    var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref16$color = _ref16.color,
	        color = _ref16$color === undefined ? "#6496c2" : _ref16$color,
	        _ref16$labelColor = _ref16.labelColor,
	        labelColor = _ref16$labelColor === undefined ? "white" : _ref16$labelColor,
	        _ref16$tooltip = _ref16.tooltip,
	        tooltip = _ref16$tooltip === undefined ? {} : _ref16$tooltip,
	        _ref16$labelTooltip = _ref16.labelTooltip,
	        labelTooltip = _ref16$labelTooltip === undefined ? {} : _ref16$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M498.071 178.773L498.328 181.594C498.584 184.469 498.822 187.354 499.051 190.239C499.189 191.906 499.317 193.564 499.463 195.221C499.637 197.264 499.821 199.306 500.013 201.348L500.114 202.402C500.205 203.427 500.297 204.389 500.132 205.46L500.022 206.147C499.857 207.155 499.692 208.199 499.592 209.225C499.528 209.902 499.482 210.369 499.738 210.855C499.839 211.047 499.995 211.239 500.16 211.432C500.334 211.633 500.508 211.853 500.645 212.1C500.709 212.21 500.773 212.32 500.846 212.43C501.149 212.897 501.478 213.428 501.341 214.069L501.304 214.234C501.222 214.601 501.167 214.848 501.286 215.187C501.341 215.333 501.423 215.471 501.497 215.617C501.662 215.919 501.854 216.258 501.872 216.661C501.9 217.183 501.799 217.934 501.497 218.429C501.332 218.694 501.121 218.923 500.92 219.152C500.727 219.363 500.544 219.564 500.407 219.784C500.269 220.013 500.178 220.288 500.077 220.572L499.995 220.819C499.912 221.048 499.839 221.277 499.766 221.506C499.491 222.358 499.207 223.237 498.63 224.006L497.091 226.049C497.027 226.131 496.963 226.213 496.89 226.305C496.725 226.506 496.551 226.708 496.496 226.891C496.405 227.203 496.414 227.605 496.432 228.008C496.441 228.228 496.441 228.439 496.432 228.631L496.35 230.371C496.34 230.555 496.35 230.765 496.359 230.994C496.377 231.534 496.395 232.157 496.221 232.606C496.084 232.963 495.901 233.073 495.672 233.11L496.057 233.961C496.377 233.897 496.661 234.035 496.89 234.181C496.963 234.099 497.091 233.943 497.119 233.888C497.101 233.888 497.018 233.751 496.963 233.678C496.908 233.595 496.862 233.513 496.826 233.43C496.688 233.155 496.551 232.844 496.661 232.533C496.734 232.34 496.881 232.194 497.11 232.084C497.531 231.892 498.136 231.892 498.676 231.901C498.896 231.901 499.097 231.901 499.262 231.892C499.72 231.855 500.114 231.818 500.581 231.672C500.663 231.644 500.746 231.654 500.819 231.69C500.846 231.461 500.956 231.196 501.103 230.875C501.158 230.756 501.204 230.655 501.231 230.573C501.268 230.463 501.359 230.371 501.478 230.344C501.588 230.307 501.716 230.353 501.799 230.435C501.872 230.509 501.945 230.6 502.028 230.701C502.147 230.838 502.321 231.058 502.431 231.095C502.486 231.122 502.587 231.086 502.733 231.031C502.815 231.003 502.907 230.967 502.999 230.948C503.603 230.793 504.125 230.957 504.638 231.113C504.766 231.15 504.894 231.186 505.023 231.223C505.948 231.47 506.744 232.047 507.514 232.606C507.651 232.707 507.779 232.798 507.908 232.89L507.944 232.817C508.411 231.947 508.86 231.131 509.712 230.463C510.298 230.005 510.985 229.474 511.626 229.199C512.212 228.952 512.487 229.281 512.707 229.556C512.771 229.63 512.835 229.712 512.917 229.804C513.073 229.968 513.238 230.17 513.412 230.371C513.741 230.774 514.117 231.232 514.474 231.434C514.557 231.48 514.639 231.525 514.868 231.186C515.161 230.738 515.546 229.923 515.628 229.465C515.646 229.391 515.61 229.208 515.582 229.062C515.509 228.695 515.427 228.237 515.729 227.926C515.885 227.77 516.077 227.761 516.205 227.743C516.233 227.743 516.269 227.743 516.287 227.734C516.434 227.67 516.608 227.541 516.773 227.422C516.864 227.358 516.956 227.285 517.048 227.23L518.943 226.012C519.053 225.939 519.2 225.939 519.31 226.003C519.42 226.067 519.484 226.195 519.475 226.323C519.392 227.294 519.887 227.825 520.995 227.926C521.773 227.999 522.451 228.063 523.12 227.834L523.294 227.78C523.321 227.77 523.349 227.761 523.376 227.752C523.376 227.743 523.385 227.734 523.385 227.725L523.431 227.587C523.523 227.322 523.541 226.955 523.55 226.607C523.559 226.424 523.568 226.241 523.587 226.076C523.678 225.27 523.724 224.821 524.173 224.08L524.393 223.713C524.686 223.219 524.979 222.706 525.428 222.266C526.792 220.947 528.019 219.592 528.935 218.557L529.073 218.41C529.219 218.255 529.329 218.136 529.366 217.989C529.393 217.87 529.375 217.714 529.366 217.559C529.347 217.366 529.329 217.156 529.366 216.936C529.494 216.295 529.732 215.663 529.961 215.049C530.071 214.756 530.181 214.463 530.282 214.17C530.309 214.079 530.373 214.014 530.456 213.969C530.538 213.923 530.63 213.923 530.721 213.95C530.877 214.005 531.078 214.097 531.289 214.188C531.655 214.353 532.141 214.582 532.425 214.564C532.654 214.546 533.139 214.143 533.432 213.905C533.588 213.776 533.734 213.657 533.853 213.575C534.623 213.053 535.392 212.531 536.161 212.009L537.004 211.441C537.343 211.212 537.343 211.212 537.15 210.772C537.013 210.452 536.802 210.159 536.573 209.847C536.372 209.573 536.17 209.289 536.015 208.977L535.951 208.849C535.85 208.666 535.832 208.593 535.85 208.355C535.868 208.107 536.17 207.356 536.399 207.063C536.207 205.36 536.024 203.665 535.832 201.962C535.658 200.332 535.484 198.711 535.291 197.081C534.98 194.351 534.687 191.613 534.403 188.875C534.073 185.724 533.734 182.574 533.368 179.432C532.718 173.928 532.031 168.259 531.271 162.105C531.142 161.94 531.106 161.711 531.069 161.5C531.051 161.408 531.023 161.244 530.996 161.198C530.877 161.152 530.254 161.28 529.979 161.326C529.814 161.354 529.677 161.381 529.567 161.399L522.973 162.159C516.681 162.883 510.344 163.506 505.536 163.964L505.242 163.991C504.601 164.477 503.924 164.907 503.228 165.301C500.938 166.565 499.931 166.904 497.394 165.795C497.229 165.722 497.082 165.64 496.945 165.548L497.055 166.894C497.366 170.878 497.723 174.826 498.071 178.773Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M511.014 193.653H512.733V184.481H511.014V193.653ZM514.897 193.653H516.449V186.623L520.579 193.653H522.35V184.481H520.797V191.113L516.936 184.481H514.897V193.653Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.KS = function () {
	    var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref17$color = _ref17.color,
	        color = _ref17$color === undefined ? "#6496c2" : _ref17$color,
	        _ref17$labelColor = _ref17.labelColor,
	        labelColor = _ref17$labelColor === undefined ? "white" : _ref17$labelColor,
	        _ref17$tooltip = _ref17.tooltip,
	        tooltip = _ref17$tooltip === undefined ? {} : _ref17$tooltip,
	        _ref17$labelTooltip = _ref17.labelTooltip,
	        labelTooltip = _ref17$labelTooltip === undefined ? {} : _ref17$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M306.605 208.107C306.404 211.541 306.193 214.985 305.992 218.419C305.579 225.205 305.167 231.992 304.746 238.778C304.6 241.169 304.444 243.559 304.288 245.949L304.032 249.897C304.38 249.915 304.728 249.933 305.076 249.952L305.644 249.979C312.073 250.336 359.413 252.14 366.456 252.259C373.205 252.369 380.074 252.388 386.714 252.406C392.072 252.424 397.512 252.369 402.778 252.324L405.773 252.296C405.736 249.448 405.69 246.59 405.654 243.742L405.617 241.196C405.562 237.258 405.534 233.32 405.516 229.382C405.498 226.011 405.48 222.632 405.434 219.262L405.425 218.327C405.415 217.604 405.406 216.871 405.397 216.148C405.397 216.056 405.415 215.873 405.434 215.672C405.452 215.479 405.489 215.113 405.489 214.93C405.315 214.866 404.912 214.801 404.738 214.774C404.6 214.747 404.481 214.728 404.417 214.71C404.316 214.682 404.188 214.664 404.051 214.637C403.684 214.573 403.272 214.499 403.007 214.307C402.759 214.124 402.585 213.794 402.439 213.492C402.384 213.382 402.338 213.29 402.283 213.217C402.091 212.915 401.899 212.594 401.715 212.274C401.349 211.651 400.974 211.019 400.543 210.451C400.369 210.222 400.168 210.012 399.966 209.801C399.856 209.691 399.756 209.581 399.655 209.471C399.6 209.416 399.517 209.334 399.417 209.251C399.014 208.894 398.73 208.62 398.666 208.317C398.583 207.933 398.913 207.154 399.197 206.559C399.362 206.22 399.627 205.826 399.884 205.533C400.076 205.313 400.342 205.13 400.589 204.956C400.983 204.691 401.349 204.434 401.358 204.114C401.386 203.473 400.909 202.923 400.452 202.392C400.424 202.364 400.406 202.337 400.378 202.309C400.094 202.621 399.765 202.896 399.124 202.813C398.547 202.74 398.006 202.346 397.548 201.98L397.274 201.769C396.825 201.412 396.312 201.009 395.991 200.569C395.955 200.514 395.909 200.45 395.872 200.386C395.442 200.386 395.011 200.386 394.581 200.386C387.593 200.414 381.805 200.395 376.392 200.35C370.137 200.295 364.551 200.203 359.312 200.075C353.066 199.928 329.996 199.159 324.217 198.82C321.653 198.664 319.079 198.518 316.505 198.371C313.401 198.197 310.287 198.023 307.182 197.831C307.008 201.265 306.807 204.691 306.605 208.107Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M345.574 231.908H347.28V227.623L350.808 231.908H352.822L348.833 227.11L352.63 222.736H350.795L347.28 226.892V222.736H345.574V231.908ZM356.834 232.036C358.861 232.036 360.208 230.792 360.208 229.201C360.208 227.367 359.092 226.751 356.937 226.456C355.346 226.225 355.038 225.853 355.038 225.109C355.038 224.404 355.577 223.903 356.616 223.903C357.668 223.903 358.22 224.314 358.386 225.276H359.951C359.772 223.518 358.592 222.62 356.616 222.62C354.705 222.62 353.422 223.749 353.422 225.25C353.422 226.969 354.461 227.636 356.655 227.931C358.143 228.175 358.566 228.496 358.566 229.342C358.566 230.189 357.848 230.753 356.834 230.753C355.282 230.753 354.91 229.984 354.795 229.06H353.153C353.281 230.792 354.333 232.036 356.834 232.036Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.KY = function () {
	    var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref18$color = _ref18.color,
	        color = _ref18$color === undefined ? "#6496c2" : _ref18$color,
	        _ref18$labelColor = _ref18.labelColor,
	        labelColor = _ref18$labelColor === undefined ? "white" : _ref18$labelColor,
	        _ref18$tooltip = _ref18.tooltip,
	        tooltip = _ref18$tooltip === undefined ? {} : _ref18$tooltip,
	        _ref18$labelTooltip = _ref18.labelTooltip,
	        labelTooltip = _ref18$labelTooltip === undefined ? {} : _ref18$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M576.366 229.281C575.789 228.942 575.46 228.457 575.194 227.99C574.993 228.09 574.846 228.081 574.544 227.99C574.26 227.907 573.82 227.642 573.619 227.449C573.399 227.229 573.243 226.955 573.097 226.698C572.996 226.524 572.904 226.359 572.785 226.213L572.492 225.837C572.163 225.416 571.833 225.004 571.485 224.61C571.412 224.528 571.265 224.409 571.109 224.28C570.569 223.832 570.221 223.511 570.166 223.172C570.129 222.916 570.294 222.724 570.423 222.577C570.423 222.577 570.423 222.568 570.432 222.568C570.386 222.559 570.349 222.54 570.313 222.531C570.212 222.504 570.12 222.476 570.084 222.458C569.662 222.266 569.461 221.927 569.278 221.634C569.168 221.46 569.076 221.295 568.93 221.167C568.774 221.112 568.655 221.066 568.554 220.965C568.444 220.855 568.399 220.736 568.362 220.626C568.353 220.59 568.334 220.544 568.316 220.525C568.307 220.525 568.225 220.489 568.16 220.461C567.968 220.388 567.748 220.297 567.648 220.095C567.446 219.701 567.62 219.078 567.858 218.364C567.904 218.236 567.941 218.117 567.959 218.034C568.096 217.476 568.124 217.219 567.895 216.798C567.721 216.477 567.666 216.157 567.629 215.873C567.611 215.754 567.593 215.635 567.565 215.516L567.464 215.488L567.51 215.342C567.501 215.314 567.492 215.296 567.483 215.269C567.281 214.801 566.842 214.133 566.558 213.922C566.283 213.73 565.926 213.629 565.541 213.519C564.873 213.327 564.112 213.107 563.755 212.31C563.49 211.715 563.371 211.101 563.242 210.424C563.233 210.378 563.233 210.332 563.224 210.277C563.215 210.222 563.206 210.122 563.187 210.094C563.187 210.094 563.187 210.094 563.178 210.094C563.05 210.094 562.592 210.351 562.418 210.442C562.308 210.497 562.217 210.552 562.153 210.579C561.685 210.79 561.383 211.028 560.999 211.477C560.898 211.596 560.815 211.788 560.742 211.981C560.614 212.301 560.467 212.658 560.128 212.832C559.9 212.951 559.643 212.942 559.414 212.942C559.258 212.933 559.103 212.942 559.011 212.979C558.993 212.988 558.929 213.061 558.892 213.107C558.755 213.254 558.59 213.446 558.333 213.446C558.059 213.446 557.766 213.226 557.427 212.961C557.253 212.823 557.033 212.658 556.932 212.622C556.3 212.411 555.65 212.246 555.155 212.191C554.798 212.155 554.276 212.31 553.947 212.567C553.837 212.649 553.818 212.732 553.782 212.897C553.727 213.135 553.635 213.574 552.93 213.593C551.978 213.602 551.446 213.025 550.979 212.521C550.677 212.191 550.393 211.871 550.008 211.724C549.697 211.605 549.193 211.688 548.754 211.761C548.58 211.788 548.424 211.816 548.277 211.834C547.636 211.898 547.224 211.788 546.666 211.624L546.583 211.596C546.464 211.559 546.336 211.532 546.199 211.504C545.887 211.44 545.567 211.367 545.283 211.221C545.219 211.184 545.173 211.166 545.136 211.156C544.935 211.074 544.871 210.973 544.834 210.79C544.825 210.753 544.816 210.699 544.788 210.625C544.605 210.048 544.413 209.673 544.101 209.16C544.028 209.032 543.946 208.885 543.872 208.739C543.698 208.409 543.497 208.024 543.286 207.869C542.966 207.63 542.416 207.475 541.94 207.337C541.683 207.264 541.436 207.191 541.226 207.118C540.887 206.989 540.685 207.072 540.291 207.227C540.191 207.264 540.081 207.31 539.971 207.356C539.421 207.557 538.963 207.511 538.478 207.466L538.203 207.438C538.084 207.429 537.947 207.401 537.8 207.383C537.544 207.347 537.003 207.255 536.884 207.365C536.793 207.475 536.518 208.098 536.5 208.253C536.5 208.299 536.491 208.326 536.491 208.345L536.591 208.51C536.729 208.775 536.903 209.023 537.095 209.288C537.333 209.618 537.571 209.957 537.745 210.35C538.075 211.12 538.002 211.422 537.351 211.852L536.509 212.42C535.74 212.942 534.97 213.464 534.201 213.986C534.1 214.06 533.972 214.16 533.826 214.279C533.386 214.646 532.882 215.049 532.443 215.085C532.021 215.113 531.454 214.866 530.968 214.646C530.904 214.618 530.84 214.591 530.785 214.563C530.721 214.747 530.648 214.93 530.574 215.122C530.355 215.708 530.126 216.313 530.006 216.89C529.979 217.009 529.997 217.155 530.016 217.311C530.034 217.512 530.061 217.741 530.006 217.97C529.933 218.291 529.732 218.511 529.549 218.703L529.43 218.831C528.505 219.875 527.268 221.249 525.885 222.577C525.51 222.943 525.244 223.392 524.96 223.877L524.731 224.253C524.356 224.867 524.328 225.187 524.237 225.975C524.218 226.13 524.209 226.295 524.2 226.46C524.182 226.854 524.163 227.266 524.044 227.623L524.008 227.742C523.907 228.072 523.806 228.145 523.477 228.246L523.312 228.301C522.497 228.576 521.727 228.502 520.912 228.429C519.676 228.319 518.925 227.706 518.778 226.726L517.395 227.614C517.313 227.669 517.23 227.724 517.148 227.788C516.956 227.935 516.745 228.081 516.516 228.173C516.415 228.219 516.315 228.228 516.232 228.237C516.196 228.237 516.15 228.246 516.141 228.246C516.141 228.264 516.196 228.594 516.223 228.741C516.26 228.96 516.305 229.189 516.269 229.391C516.159 230.014 515.683 230.939 515.408 231.369C514.913 232.138 514.373 231.992 514.107 231.836C513.65 231.58 513.228 231.067 512.853 230.609C512.697 230.417 512.541 230.233 512.395 230.078C512.294 229.977 512.212 229.876 512.148 229.794C512.083 229.721 512.001 229.62 511.974 229.601C511.974 229.601 511.937 229.602 511.864 229.638C511.314 229.867 510.646 230.389 510.151 230.774C509.363 231.387 508.979 232.111 508.521 232.944L508.301 233.356C508.255 233.439 508.173 233.503 508.081 233.521C507.99 233.54 507.889 233.53 507.806 233.476C507.568 233.311 507.321 233.137 507.074 232.963C506.35 232.441 505.608 231.9 504.812 231.69C504.674 231.653 504.537 231.607 504.4 231.571C503.942 231.424 503.548 231.305 503.127 231.415C503.053 231.433 502.989 231.461 502.925 231.479C502.696 231.561 502.421 231.662 502.11 231.525C501.927 231.442 501.762 231.287 501.615 231.122C501.533 231.314 501.441 231.552 501.46 231.644C501.469 231.653 501.56 231.726 501.625 231.772C501.744 231.873 501.881 231.983 501.963 232.129C502 232.193 502.009 232.212 502.009 232.212C502.147 232.322 502.165 232.523 502.082 232.67C502.073 232.688 502.055 232.725 502.037 232.77C502.009 232.853 501.661 233.439 501.386 233.53C501.212 233.585 500.434 233.411 500.297 233.219C500.141 233.008 500.159 232.688 500.223 232.267C499.903 232.331 499.591 232.358 499.271 232.386C499.088 232.404 498.859 232.395 498.621 232.395C498.181 232.386 497.631 232.386 497.348 232.514C497.274 232.541 497.265 232.569 497.265 232.569C497.265 232.587 497.265 232.66 497.402 232.917C497.43 232.981 497.476 233.045 497.512 233.1C497.65 233.32 497.815 233.595 497.732 233.897C497.696 234.034 497.586 234.162 497.375 234.41C497.311 234.492 497.247 234.556 497.219 234.602C497.174 234.684 497.091 234.739 497 234.758C496.917 234.776 496.816 234.767 496.734 234.712L496.633 234.639C496.404 234.483 496.23 234.382 496.102 234.437C496.065 234.465 496.056 234.529 496.038 234.575C496.02 234.675 495.992 234.785 495.937 234.913C495.772 235.326 495.479 235.582 495.223 235.802C495.04 235.957 494.866 236.113 494.747 236.315C494.527 236.708 494.545 236.882 494.719 237.386C494.847 237.752 495.067 237.972 495.324 238.238C495.543 238.458 495.772 238.696 495.956 239.025C496.139 239.346 496.084 239.602 496.001 239.767C495.736 240.308 494.838 240.482 493.785 240.628C493.574 240.656 493.4 240.683 493.3 240.711C492.942 240.802 492.723 240.903 492.53 241.086C492.494 241.114 492.439 241.196 492.393 241.269C492.255 241.452 492.109 241.672 491.871 241.727C491.633 241.782 491.413 241.681 491.239 241.599C491.175 241.572 491.065 241.517 491.028 241.517C490.754 241.562 490.598 241.938 490.543 242.103C490.396 242.524 490.149 243.266 490.195 243.66C490.222 243.934 490.442 244.136 490.699 244.365C490.836 244.484 490.964 244.603 491.074 244.731C491.669 245.436 491.614 246.096 491.468 246.7C491.312 247.332 491.147 247.781 490.231 247.79C489.691 247.781 489.306 247.662 488.858 247.47L487.411 246.847C486.458 246.435 485.497 246.023 484.535 245.629L484.388 245.565C484.352 245.546 484.324 245.537 484.297 245.528C484.315 245.537 484.278 245.565 484.233 245.592C483.848 245.839 483.491 246.224 483.152 246.6C482.978 246.792 482.804 246.984 482.63 247.149C482.557 247.222 482.419 247.332 482.264 247.46C482.035 247.644 481.503 248.065 481.449 248.23C481.449 248.358 481.732 248.862 481.861 249.081C481.934 249.219 482.007 249.338 482.053 249.429C482.254 249.585 482.392 249.787 482.474 250.034C482.685 250.721 482.328 251.536 482.09 251.966C482.007 252.122 481.879 252.232 481.769 252.314C481.723 252.351 481.659 252.406 481.641 252.424C481.668 252.433 481.787 252.488 481.861 252.516C482.071 252.598 482.337 252.708 482.438 252.974C482.566 253.303 482.419 253.807 482.2 254.485C482.145 254.65 482.09 254.796 482.071 254.897C481.971 255.337 481.842 255.529 481.696 255.74C481.632 255.831 481.558 255.941 481.476 256.097C481.43 256.179 481.412 256.289 481.403 256.399C481.375 256.601 481.339 256.839 481.11 256.994C480.89 257.141 480.624 257.113 480.45 257.068C480.111 256.994 479.846 256.765 479.617 256.527L479.067 257.892C480.908 257.635 482.786 257.535 484.608 257.434C485.332 257.397 486.064 257.352 486.788 257.306C488.675 257.178 490.561 257.04 492.439 256.912L496.212 256.646C496.322 256.637 496.441 256.637 496.56 256.637C497.164 256.637 497.183 256.582 497.183 256.317C497.183 255.831 496.972 255.245 496.761 254.677C496.661 254.393 496.56 254.109 496.487 253.853C496.459 253.752 496.477 253.642 496.542 253.56C496.606 253.477 496.697 253.423 496.798 253.413C497.357 253.386 497.915 253.377 498.593 253.386C498.657 253.386 498.758 253.377 498.877 253.368C499.344 253.331 499.692 253.313 499.921 253.459C500.15 253.597 500.223 253.752 500.242 253.908C502.98 253.587 505.526 253.322 508.008 253.075C508.869 252.992 509.73 252.891 510.591 252.781C512.605 252.543 514.684 252.296 516.763 252.296C517.423 252.296 518.055 252.168 518.714 252.03C519.319 251.911 519.941 251.774 520.601 251.756C522.194 251.701 523.788 251.637 525.391 251.563C528.001 251.453 530.776 251.298 533.404 250.895C534.815 250.684 536.207 250.483 537.69 250.391C538.716 250.327 539.742 250.272 540.768 250.226L542.141 250.153C544.77 250.016 547.444 249.713 550.036 249.42C550.53 249.365 550.97 249.32 551.41 249.274C552.316 249.182 553.251 249.091 554.148 248.953C554.716 248.862 555.293 248.752 555.852 248.642C556.346 248.541 556.859 248.44 557.372 248.358L557.427 248.33C557.72 248.175 558.013 248.001 558.306 247.818C558.929 247.442 559.57 247.057 560.248 246.819C560.412 246.764 560.577 246.728 560.742 246.691C560.916 246.654 561.081 246.627 561.218 246.563C561.585 246.398 561.942 246.151 562.299 245.922C562.482 245.803 562.665 245.684 562.849 245.574L563.059 245.446C563.38 245.244 563.719 245.033 564.14 244.933C564.222 244.914 564.286 244.905 564.341 244.896L564.424 244.869C564.479 244.795 564.534 244.521 564.57 244.374C564.598 244.264 564.616 244.154 564.644 244.072C564.68 243.953 564.699 243.852 564.726 243.77C564.836 243.293 564.964 242.982 565.678 242.936C566.329 242.89 566.466 242.854 566.961 242.432C567.281 242.149 567.391 241.956 567.419 241.553L567.437 241.278C567.464 240.711 567.51 240.363 568.124 239.896C568.27 239.786 568.481 239.694 568.701 239.602C568.875 239.529 569.195 239.392 569.259 239.319C569.296 239.245 569.241 238.989 569.204 238.824C569.14 238.531 569.067 238.192 569.186 237.899C569.342 237.533 569.781 237.185 570.166 236.882C570.313 236.773 570.441 236.663 570.532 236.58C570.88 236.251 571.183 235.957 571.567 235.692C571.906 235.454 572.282 235.261 572.657 235.069C573.161 234.813 573.628 234.575 573.985 234.236C574.471 233.778 574.91 233.192 575.341 232.624C575.579 232.303 575.817 231.992 576.055 231.708L577.978 229.391C577.905 229.4 577.841 229.418 577.777 229.427C577.401 229.547 576.962 229.638 576.366 229.281Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M537.077 237.864H538.783V233.579L542.311 237.864H544.325L540.336 233.066L544.133 228.692H542.298L538.783 232.848V228.692H537.077V237.864ZM547.74 237.864H549.459V233.9L552.332 228.692H550.664L548.65 232.489L546.585 228.692H544.699L547.74 233.887V237.864Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.LA = function () {
	    var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref19$color = _ref19.color,
	        color = _ref19$color === undefined ? "#6496c2" : _ref19$color,
	        _ref19$labelColor = _ref19.labelColor,
	        labelColor = _ref19$labelColor === undefined ? "white" : _ref19$labelColor,
	        _ref19$tooltip = _ref19.tooltip,
	        tooltip = _ref19$tooltip === undefined ? {} : _ref19$tooltip,
	        _ref19$labelTooltip = _ref19.labelTooltip,
	        labelTooltip = _ref19$labelTooltip === undefined ? {} : _ref19$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M482.969 368.351C482.566 367.811 482.236 367.216 482.282 366.666C482.291 366.511 482.337 366.392 482.365 366.3C482.401 366.199 482.42 366.153 482.401 366.071C482.374 365.952 482.273 365.778 482.191 365.631C482.136 365.54 482.09 365.457 482.053 365.375L481.989 365.247C481.797 364.862 481.623 364.496 481.394 364.166C481.147 363.809 480.881 363.461 480.625 363.104L480.222 362.554C480.112 362.408 479.974 362.243 479.828 362.069C479.48 361.657 479.077 361.199 478.921 360.732C478.683 360.017 478.994 358.9 479.233 357.993C479.306 357.737 479.361 357.508 479.407 357.316C479.425 357.242 479.434 357.16 479.443 357.077C479.48 356.83 479.516 356.555 479.645 356.336C479.745 356.171 479.892 356.116 479.974 356.088C480.139 355.777 480.176 355.365 480.176 354.971C478.601 355.081 477.016 355.182 475.432 355.292L473.747 355.401C466.347 355.896 458.974 356.262 452.105 356.583C452.005 356.583 451.904 356.546 451.84 356.473C451.766 356.4 451.739 356.299 451.748 356.198C451.858 355.365 451.995 354.531 452.133 353.698C452.261 352.901 452.398 352.095 452.508 351.298C452.609 350.575 452.691 349.851 452.774 349.128L452.92 347.882C452.966 347.47 453.012 347.076 453.204 346.646L453.332 346.371C453.928 345.052 454.551 343.679 455.402 342.516C456.547 340.959 457.509 339.64 458.452 338.266L459.386 336.901C459.414 336.856 459.469 336.792 459.542 336.709C459.597 336.645 459.716 336.508 459.771 336.416C459.688 336.306 459.496 336.123 459.405 336.041C459.313 335.958 459.24 335.876 459.194 335.83L458.397 334.896C458.315 334.804 458.296 334.667 458.342 334.548C458.388 334.429 458.498 334.346 458.617 334.328C458.736 334.31 458.91 334.31 459.093 334.3C459.359 334.291 459.908 334.273 460.027 334.191C460.046 334.126 460.009 333.788 459.991 333.623C459.981 333.504 459.963 333.394 459.963 333.302C459.954 333.183 459.963 333.027 459.972 332.872C459.981 332.588 460 332.231 459.927 332.066C459.826 331.846 459.487 331.544 459.221 331.297C459.075 331.168 458.937 331.04 458.837 330.93C458.232 330.289 458.04 330.014 458.324 329.062C458.37 328.897 458.406 328.778 458.425 328.705C458.388 328.677 458.324 328.641 458.278 328.613L458.15 328.531C457.838 328.338 457.701 328.183 457.573 327.853C457.362 327.331 457.261 326.745 457.17 326.177C457.124 325.911 457.087 325.655 457.033 325.408C456.968 325.115 456.886 324.812 456.794 324.501C456.611 323.832 456.419 323.146 456.382 322.477C456.364 322.056 456.483 321.68 456.675 321.332C454.999 321.396 453.323 321.47 451.638 321.543C448.359 321.68 444.962 321.827 441.628 321.918C438.569 322.001 435.519 322.074 432.46 322.147C429.74 322.211 427.011 322.285 424.282 322.358C422.514 322.404 420.747 322.44 418.979 322.477C417.935 322.495 416.882 322.514 415.838 322.541L415.856 323.338C415.893 325.05 415.92 326.763 415.966 328.476C415.984 329.318 415.984 330.17 415.994 331.022C416.003 333.238 416.012 335.537 416.296 337.735C416.323 337.982 416.342 338.266 416.36 338.568C416.387 339.136 416.415 339.786 416.598 340.208C416.763 340.583 417.221 341.023 417.633 341.417C417.844 341.618 418.036 341.801 418.192 341.975C418.686 342.525 418.732 342.854 418.833 343.45L419.364 346.646C419.437 347.086 419.721 347.36 420.078 347.708C420.188 347.809 420.289 347.919 420.399 348.029C420.967 348.624 421.397 349.247 421.855 349.906C422.606 350.996 422.807 352.278 423 353.515C423.018 353.616 423.027 353.707 423.046 353.808L423.375 353.725C423.476 353.698 423.586 353.716 423.668 353.78C423.751 353.845 423.806 353.945 423.806 354.046L423.842 357.691C423.842 357.865 423.852 358.039 423.852 358.222C423.879 359.083 423.897 359.962 423.577 360.823C423.32 361.51 422.936 362.16 422.569 362.801C422.395 363.095 422.23 363.388 422.075 363.681C422.011 363.8 421.937 363.919 421.855 364.056C421.599 364.487 421.241 365.073 421.397 365.393C421.443 365.494 421.507 365.595 421.562 365.696C421.773 366.044 422.02 366.474 421.937 367.033C421.882 367.408 421.635 367.573 421.47 367.692C421.379 367.756 421.324 367.802 421.305 367.848C421.251 367.985 421.379 368.498 421.443 368.745C421.479 368.901 421.516 369.048 421.534 369.157C421.553 369.295 421.58 369.432 421.608 369.57C421.663 369.872 421.727 370.183 421.745 370.485C421.773 370.87 421.763 371.264 421.754 371.648C421.745 371.832 421.745 372.006 421.745 372.189C421.745 372.335 421.754 372.491 421.773 372.665C421.8 373.05 421.827 373.48 421.736 373.847C421.58 374.433 421.168 374.909 420.765 375.376C420.481 375.706 420.206 376.017 420.051 376.338C420.014 376.42 419.996 376.557 419.987 376.695C419.968 376.887 419.959 377.116 419.849 377.318C419.694 377.611 419.391 377.776 419.098 377.94C418.906 378.05 418.668 378.188 418.613 378.298C418.613 378.426 418.869 379.094 419.016 379.277C419.144 379.433 419.401 379.571 419.657 379.699C419.767 379.754 419.877 379.809 419.968 379.864L420.252 380.028C420.793 379.763 421.333 379.479 421.928 379.351C422.817 379.168 423.723 379.049 424.612 378.929C426.407 378.691 428.339 378.417 430.125 378.81C432.763 379.387 435.199 380.752 437.754 381.613L438.304 381.75H438.331L439.21 381.869L443.011 382.373H443.084L443.35 382.346H443.487L443.881 382.236L444.458 381.805C444.458 381.805 445.264 381.448 445.273 381.448L446.061 381.329H446.967L447.05 381.375L447.279 381.622L450.2 383.023L450.457 383.097L451.043 382.913L451.217 382.803L452.059 381.631L452.087 381.512L452.05 381.439L449.66 380.395L449.156 380.312L448.799 380.395C448.799 380.395 447.673 380.798 447.673 380.807L446.226 380.761L445.942 380.715L445.603 380.056L445.328 379.433L445.383 379.094L445.923 378.581L446.674 378.069L446.986 377.895L447.956 377.455L449.449 377.116L449.44 378.829L451.29 378.288L451.519 378.252L453.104 378.298L453.287 378.426L453.241 379.964L454.395 380.148L454.605 380.807L454.697 381.301L454.816 381.888C456.089 382.162 458.196 382.217 459.23 383.023C459.514 383.243 460.256 383.967 460.064 384.388C459.862 384.837 459.203 384.287 459.139 384.415L458.855 385.212L458.022 385.67L457.994 385.789L458.507 386.329L458.892 386.632L463.498 387.685L465.715 389.837L468.792 389.15L468.407 388.821L466.063 389.379L465.76 388.912L466.411 388.573L468.087 388.06L468.38 386.778L469.442 386.659V386.22L468.957 385.661L469.763 385.175L470.706 385.624L470.239 386.192L470.321 386.705L472.162 386.806L472.437 385.807L472.73 385.414L473.243 385.331L473.518 385.533L474.003 386.183L473.692 386.705L473.765 387.337L474.901 387.813L474.919 388.134L474.653 388.436L474.58 388.482L474.205 388.665L474.058 388.738L473.893 388.766L473.573 388.83L473.206 389.049C473.206 389.049 473.225 389.141 473.225 389.15H473.316L475.111 388.555L475.798 388.189L475.835 388.161L475.89 388.115L476.86 387.309L476.906 387.264C476.906 387.264 477.071 387.108 477.071 387.099L477.218 386.952L478.033 386.1L478.994 385.386L479.068 385.258L479.086 385.212L479.058 385.166L478.93 385.148L478.051 385.826L477.731 386.192C477.731 386.192 477.309 386.274 477.291 386.256L476.833 385.377L477.74 384.269C477.74 384.269 477.721 382.3 477.721 382.291C477.721 382.291 478.472 382.043 478.472 382.062L478.665 382.281L478.811 382.373L479.159 382.336L479.352 382.071L479.59 381.778L479.974 381.54L480.176 381.457L480.368 381.411L480.505 381.485L480.606 381.53L480.615 381.585L480.954 382.749L480.973 382.84V383.005L480.918 383.124L480.716 383.463L480.505 384.324L481.577 384.232C482.987 384.351 484.444 384.626 485.689 385.331C486.797 385.954 487.539 386.961 488.354 387.905L490.461 387.85L491.432 388.454L492.814 387.63L493.291 386.558C493.291 386.558 493.556 385.926 493.556 385.917C493.556 385.917 493.611 385.679 493.611 385.661L493.346 385.13L493.236 385.029L493.126 384.983L492.567 385.24L491.944 384.882L491.541 384.315L490.735 383.316L487.585 382.41L486.413 382.455L485.955 382.492L483.134 380.999L482.694 380.706L482.584 380.587L482.575 380.496L482.722 379.067L482.841 378.646L483.326 378.233L483.619 378.059L484.929 378.124L485.414 378.38L485.689 378.554L485.708 378.481L485.671 378.38L484.929 377.739L484.572 377.766L484.315 377.721L483.958 377.565L483.207 377.153L483.116 376.997L483.052 376.484L483.308 376.411L484.892 376.466L485.57 376.731L486.431 376.402L487.017 375.532L488.034 373.847L487.86 373.755L487.136 373.389L486.971 373.26L486.083 372.29L486.055 372.079L486.046 371.786L486.193 371.648L486.284 371.548L486.614 371.365L486.211 371.044L485.588 370.852L485.066 371.108L483.94 372.354L483.967 372.775L483.793 373.874L483.711 374.149L483.491 374.323L483.125 374.488L482.786 374.524L482.301 374.469L481.247 373.929L481.321 373.379L480.524 373.563L480.158 373.379L480.011 373.27L479.91 373.105L479.764 372.738L479.672 372.354L480.35 371.548L481.403 371.832L481.513 371.172L482.09 371.072L482.365 370.247L483.015 369.478L483.931 369.102C483.601 368.956 483.271 368.754 482.969 368.351Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M428.956 351.025H434.574V349.665H430.662V341.853H428.956V351.025ZM435.353 351.025H436.957L437.675 348.754H441.177L441.908 351.025H443.678L440.651 341.853H438.419L435.353 351.025ZM439.432 343.251L440.779 347.51H438.073L439.432 343.251Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.MA = function () {
	    var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref20$color = _ref20.color,
	        color = _ref20$color === undefined ? "#6496c2" : _ref20$color,
	        _ref20$labelColor = _ref20.labelColor,
	        labelColor = _ref20$labelColor === undefined ? "white" : _ref20$labelColor,
	        _ref20$tooltip = _ref20.tooltip,
	        tooltip = _ref20$tooltip === undefined ? {} : _ref20$tooltip,
	        _ref20$labelTooltip = _ref20.labelTooltip,
	        labelTooltip = _ref20$labelTooltip === undefined ? {} : _ref20$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M703.732 107.923L703.778 108.097L704.245 109.214L704.978 110.615L705.729 110.945L706.278 110.936L706.709 110.121L706.883 110.194L707.057 110.652L707.377 110.542L707.451 110.954L707.139 111.22L706.993 112.09L706.819 112.191L706.617 112.007L706.434 112.291L705.143 112.96L704.987 113.235L704.447 113.445L704.639 113.766L705.06 113.876L705.143 114.26L704.95 114.325L704.648 114.59L704.548 114.938H704.218L704.126 115.121L704.291 115.543L704.657 115.634L704.685 115.707L704.254 115.808L704.181 115.753L703.961 115.25L703.806 115.515L703.687 115.881L703.732 116.303L704.364 116.98L703.732 117.081L703.641 117.502L703.971 117.933L704.3 118.437L704.795 118.263L705.189 118.363L705.326 117.796L704.996 117.603L705.381 117.539L705.912 117.96L706.361 117.933L707.039 118.034L707.909 118.629L709.475 120.369L709.337 121.468L708.953 121.926L710.363 122.549L711.004 122.393L711.746 123.364L711.966 123.868L712.048 124.71L712.25 124.674L712.506 124.857L712.882 125.067L713.211 125.159L714.036 125.205L714.521 125.177L715.364 124.921L715.886 125.122L716.316 124.609L717.177 124.06L717.827 123.62L718.358 123.318L718.487 123.034L718.697 122.906L718.542 122.402L718.303 121.779L718.194 121.441L717.8 120.864L717.589 120.827L717.461 121.065L717.534 121.77L717.214 121.028L716.82 119.728L716.499 119.343L716.289 119.206L716.069 119.114L715.712 119.032L715.62 119.059L715.446 119.151L715.354 119.243L715.281 119.371L715.245 119.581L715.254 119.673L714.53 119.389L714.494 119.334L714.539 119.16L714.668 119.023L714.887 118.904L715.098 118.83L715.473 118.794L716.078 118.821L716.554 118.931L716.921 119.087L717.342 119.38L717.745 119.783L718.249 120.369L718.651 120.946L719.274 122.045L719.558 122.613L719.952 123.785L720.19 124.619L720.236 125.003L720.108 125.498L720.08 126.926L719.815 127.055L719.915 126.313L719.805 125.379L719.778 125.287L719.714 125.177L719.393 125.022L719.247 124.985L719.155 125.012L716.609 126.386L716.481 126.936L716.124 126.588L715.263 126.78L715.18 127.055L714.338 127.558L713.88 128.712L712.241 129.363L711.81 129.894C711.801 129.903 711.261 130.581 711.261 130.581L710.757 131.432L710.189 131.616L709.887 132.037L709.484 132.302L708.925 132.541L708.77 132.531L708.916 132.238L709.447 132.092L709.749 131.661L710.812 130.718L710.922 130.37L711.334 129.857C711.334 129.848 711.755 128.969 711.755 128.969L711.407 127.293L711.123 127L711.398 126.661L711.123 126.505C711.123 126.496 710.152 126.478 710.152 126.478L710.336 127.137L709.933 127.11L710.015 128.053L709.292 127.998L709.658 128.474L709.282 128.85L709.053 128.831L708.477 128.923L708.238 129.234L708.092 129.418L708.074 129.463L708.11 130.022L708.174 130.233L708.367 130.471L707.268 131.414L706.599 131.442L706.562 131.487C706.398 130.965 706.214 130.434 706.04 129.93C706.022 129.894 706.013 129.839 705.995 129.775C705.921 129.5 705.811 129.125 705.582 128.923C705.353 128.712 705.06 128.685 704.804 128.657L704.722 128.648H704.694L704.52 128.621L704.447 128.593L704.584 128.438L704.199 128.08C703.961 127.851 703.714 127.623 703.32 127.503C703.155 127.458 703 127.439 702.881 127.43C702.707 127.412 702.643 127.412 702.569 127.348C702.441 127.229 702.395 127 702.359 126.789L702.34 126.688C702.313 126.551 702.258 126.404 702.194 126.249C702.13 126.084 702.066 125.91 702.066 125.791C702.066 125.672 702.011 125.562 701.91 125.498C701.809 125.434 701.69 125.425 701.58 125.47L701.461 125.525C701.305 124.93 701.159 124.344 701.012 123.749C700.994 123.657 700.93 123.584 700.857 123.529C700.774 123.483 700.683 123.465 700.591 123.492C699.089 123.913 697.578 124.371 696.085 124.829C696.021 124.848 695.948 124.884 695.856 124.912C695.82 124.93 695.765 124.948 695.71 124.967L695.701 124.939L695.682 124.948C695.636 124.866 695.554 124.793 695.417 124.774C695.325 124.765 695.243 124.783 695.188 124.811C694.904 124.793 694.592 124.902 694.308 125.003C694.199 125.04 694.107 125.076 694.034 125.095L692.706 125.406C692.202 125.525 691.698 125.635 691.195 125.745C690.7 125.855 690.196 125.965 689.702 126.084L684.665 127.275C684.582 127.293 684.481 127.311 684.372 127.32C684.069 127.366 683.73 127.412 683.502 127.568C683.227 127.751 683.181 127.934 683.19 128.135C683.19 128.19 683.199 128.227 683.163 128.309C683.144 128.364 683.135 128.383 683.071 128.41C682.97 127.934 682.769 127.797 682.219 127.851C681.807 127.888 681.386 128.007 680.983 128.117C680.791 128.172 680.598 128.227 680.415 128.273C679.792 128.419 679.17 128.548 678.547 128.685L674.627 129.518C674.581 129.527 674.535 129.537 674.49 129.546V129.537L674.261 129.582H674.252C674.252 129.582 674.197 129.527 674.142 129.244C674.059 128.786 674.114 128.236 674.16 127.696C674.187 127.421 674.206 127.155 674.215 126.899L674.416 119.041C674.416 118.931 674.407 118.775 674.398 118.601C674.38 118.363 674.343 117.86 674.416 117.731V117.722C674.453 117.713 674.49 117.695 674.545 117.676C675.048 117.457 675.689 117.356 676.303 117.264C676.614 117.219 676.917 117.173 677.201 117.109L684.106 115.634L684.225 115.735L684.344 115.579C686.597 115.103 688.85 114.618 691.103 114.114C692.513 113.802 693.933 113.482 695.343 113.152C695.664 113.079 696.003 113.015 696.351 112.951C697.074 112.823 697.825 112.685 698.549 112.392C698.915 112.246 698.979 112.181 699.144 111.797L699.181 111.705C699.208 111.632 699.281 111.476 699.291 111.449C699.355 111.421 699.749 111.513 699.913 111.302C699.977 111.22 700.005 111.11 699.977 111.009L699.932 110.835C699.767 110.203 699.767 109.993 700.06 109.864C700.115 109.864 700.261 109.883 700.353 109.901C700.655 109.956 700.967 110.011 701.177 109.8C701.379 109.608 701.379 109.306 701.379 109.04C701.379 108.949 701.379 108.793 701.397 108.756C701.516 108.527 702.139 108.078 702.469 107.941C702.597 107.886 702.698 107.877 702.835 107.904C702.936 107.923 703.009 107.95 703.064 107.959C703.329 108.097 703.476 108.069 703.732 107.923ZM720.758 129.93L720.492 129.692L720.263 129.647L720.273 129.72L720.346 129.784L720.474 129.875L720.602 130.004L720.676 130.123L720.73 130.471L720.639 130.828L720.492 131.103L720.291 131.332L720.172 131.396L719.787 131.57L718.88 131.808L718.239 131.835L718.166 131.808L718.001 131.771L717.809 131.817L717.882 131.954L717.992 132.055L718.157 132.128L719.384 132.376L720.099 132.422L720.382 132.367L721.417 132.128L721.582 132.055L721.875 131.826L721.967 131.707L721.976 131.671L721.985 131.487L721.912 131.24L720.758 129.93ZM715.071 130.736L714.823 131.332L714.466 131.176L713.825 130.938L713.486 130.288L713.01 130.37L712.937 130.224H712.863L712.396 130.736L712.012 131.203L711.883 131.432L711.389 132.971L710.592 133.163L710.784 133.53L711.59 133.768L711.764 133.292L712.213 132.87L715.4 131.973L715.409 131.863L715.235 131.139L715.071 130.736Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M700.04 120.033L712.41 111.328", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M715.982 112.104H717.521V105.177L720.305 112.104H720.856L723.589 105.177V112.104H725.295V102.932H723.037L720.677 109.192L718.265 102.932H715.982V112.104ZM726.688 112.104H728.292L729.01 109.833H732.512L733.244 112.104H735.014L731.986 102.932H729.754L726.688 112.104ZM730.768 104.33L732.115 108.589H729.408L730.768 104.33Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "715", y: "100", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.MD = function () {
	    var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref21$color = _ref21.color,
	        color = _ref21$color === undefined ? "#6496c2" : _ref21$color,
	        _ref21$labelColor = _ref21.labelColor,
	        labelColor = _ref21$labelColor === undefined ? "white" : _ref21$labelColor,
	        _ref21$tooltip = _ref21.tooltip,
	        tooltip = _ref21$tooltip === undefined ? {} : _ref21$tooltip,
	        _ref21$labelTooltip = _ref21.labelTooltip,
	        labelTooltip = _ref21$labelTooltip === undefined ? {} : _ref21$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M668.454 197.419L668.436 198.042L668.381 198.609L668.024 202.602L667.997 202.841L667.951 203.015L667.877 203.289L667.832 203.491L667.401 203.637L667.713 203.042L667.813 202.612L667.887 201.778L668.134 199.663L667.969 200.404L667.548 200.743L667.456 200.175L667.026 200.487L666.65 202.227L666.522 203.015L666.156 203.124L666.174 203.628L665.936 203.555L665.945 204.141L664.132 204.764C663.985 204.81 663.82 204.855 663.646 204.901C663.243 205.002 662.785 205.121 662.456 205.35C662.153 205.551 662.007 205.899 661.879 206.202C661.842 206.284 661.805 206.367 661.769 206.44L661.595 206.715C661.119 206.696 660.432 206.678 660.432 206.678L659.617 207.713L659.131 207.878L659.122 207.218L658.829 206.843L659.149 206.119L659.067 205.863L659.488 205.606L659.726 205.094L659.177 204.993L659.012 205.414L658.737 204.929L659.259 204.05L658.472 203.976L657.849 204.626L657.519 204.489L657.419 203.344L658.646 202.859L658.38 202.364L657.593 202.09C657.593 202.08 657.171 202.465 657.171 202.465L656.64 202.108L656.091 201.485L656.558 201.256L656.851 200.972L656.448 200.359L655.99 200.322V201L655.605 201.623L655.99 202.08L656.1 202.969L655.569 202.74L655.138 202.722L655.019 202.163L654.195 202.236L654.094 202.639L654.882 202.978L654.634 203.289L653.975 202.868L653.746 202.548L653.398 202.3L652.931 202.135L652.867 202.09L652.675 201.751L653.041 201.329L652.418 201.238L651.85 200.121L651.099 199.278L652.006 198.811L652.107 198.362L651.31 197.803L651.53 197.153L651.603 197.025L651.905 196.769L652.024 196.695L653.132 196.384L653.178 196.311L652.986 195.972L652.317 195.834L651.612 194.873L651.383 194.9L651.173 195.331L650.651 195.157L650.605 195.193L650.467 195.514V195.688L650.678 195.889L650.705 196.063L650.495 196.256L650.348 196.027L650.193 194.873L650.202 194.497L650.467 193.49L650.495 193.444L650.843 193.023L651.2 193.38L651.814 193.371L651.713 192.748C651.713 192.739 651.566 192.153 651.511 191.915C651.493 191.85 651.484 191.814 651.484 191.814L651.328 191.512L650.934 191.255L650.715 191.686L650.44 191.594L650.156 191.786L650.248 192.125L649.68 192.208L649.872 192.94L649.432 193.536L649.423 192.904L649.112 191.741L649.643 189.881L650.11 190.724L651.182 190.568L651.282 190.367L651.035 188.645L650.806 188.755L651.053 189.973L650.541 189.927L650.385 188.737L649.597 187.931L649.579 187.574L649.625 187.299L650.183 184.689L650.339 184.432L650.403 184.35L650.266 183.425L650.046 183.681L649.533 184.286L649.057 184.973L649.084 185.33L648.837 185.247L648.626 184.643L648.315 184.423H648.242L648.022 184.524L648.333 185.357L647.701 185.577L647.573 186.337L647.802 186.456L647.875 186.429L647.866 186.557L647.821 186.703L647.463 187.308L647.271 187.537L646.456 187.454L646.071 187.381H646.044L645.806 187.821L647.07 188.279L647.683 188.911L647.976 189.442L647.848 189.946L648.48 190.367L648.572 190.559L647.647 191.393L648.086 191.915L647.747 192.986L647.601 193.646L647.94 193.783L647.253 195.202L647.372 195.587L647.463 195.734L647.848 196.063L647.857 196.292L647.94 196.659L648.626 199.012L648.691 199.186L648.901 199.58L649.158 199.919L649.762 200.359L650.889 201.265L650.934 201.357L650.999 201.714L650.898 202.502L651.539 204.169L652.629 205.231L652.51 205.606L653.004 206.907L652.391 206.705L651.759 206.101L650.825 205.716L650.724 206.22L649.79 205.753L648.865 204.892L647.665 204.626L646.657 204.837L646.465 205.011L645.824 204.709L645.293 204.013L645.357 204.443V204.672L645.329 204.8L644.011 204.196L643.864 203.921L643.177 203.509L642.325 201.961L641.749 202.364L641.391 202.859L641.025 202.923L640.824 203.28L640.109 203.967L639.972 203.94L639.459 203.692L639.166 203.189L638.8 202.053L638.836 201.503L639.047 200.752L639.596 199.763L639.935 199.342L640.127 199.544L640.622 199.067L640.073 198.481C640.127 198.445 640.182 198.399 640.256 198.344C640.329 198.28 640.439 198.142 640.64 197.868L640.695 197.794C641.107 197.263 641.208 196.43 641.227 196.192C641.227 196.173 641.227 196.155 641.227 196.127L642.637 193.994C642.692 193.911 642.71 193.82 642.683 193.728C642.664 193.636 642.6 193.554 642.527 193.508L642.014 193.197C641.611 192.949 641.199 192.702 640.787 192.473C640.714 192.437 640.659 192.4 640.604 192.373C640.366 192.226 640.091 192.061 639.679 192.391C639.441 192.583 639.276 192.913 639.129 193.206C638.964 193.124 638.781 193.059 638.534 193.05C638.433 193.041 638.323 193.05 638.213 193.059C638.012 193.069 637.765 193.087 637.728 193.032C637.728 193.014 637.728 192.959 637.737 192.931C637.746 192.794 637.774 192.556 637.6 192.373C637.472 192.235 637.279 192.189 637.114 192.153C637.069 192.144 637.023 192.134 636.986 192.125L636.821 192.061C636.363 191.878 636.162 191.796 635.539 191.841C634.706 191.905 634.165 191.85 633.707 191.338C633.598 191.219 633.515 190.999 633.588 190.852C633.607 190.806 633.643 190.779 633.735 190.724C633.9 190.614 634.184 190.44 634.156 189.927V189.79C634.156 189.506 634.046 189.369 633.781 189.295C633.735 189.286 633.671 189.268 633.588 189.231C633.488 189.195 633.378 189.176 633.259 189.149C633.14 189.121 633.002 189.094 632.947 189.057C632.837 188.984 632.782 188.911 632.718 188.819C632.599 188.645 632.407 188.37 631.903 188.407C631.793 188.416 631.702 188.434 631.61 188.444C631.509 188.462 631.473 188.471 631.409 188.462C631.345 188.453 631.271 188.416 631.18 188.37C631.051 188.306 630.905 188.233 630.731 188.215C630.621 188.205 630.493 188.205 630.355 188.215C630.062 188.233 629.952 188.224 629.907 188.16C629.888 188.086 629.943 187.857 629.98 187.72C630.062 187.354 630.154 186.978 629.916 186.713C629.705 186.493 629.421 186.484 629.229 186.493C629.165 186.493 629.064 186.493 629.046 186.493C629.027 186.456 629.018 186.337 629.018 186.264C629.009 186.062 628.991 185.806 628.799 185.623C628.689 185.522 628.542 185.495 628.377 185.467C628.313 185.458 628.249 185.449 628.222 185.44C628.038 185.339 627.901 185.119 627.764 184.881C628.102 184.716 628.203 184.515 628.13 183.965C628.121 183.874 628.066 183.791 628.002 183.736C627.928 183.681 627.837 183.654 627.745 183.672C627.434 183.718 627.123 183.782 626.82 183.855C626.6 183.91 626.372 183.956 626.143 184.002C626.014 184.02 625.895 184.084 625.776 184.139C625.721 184.167 625.621 184.212 625.648 184.231C625.611 184.203 625.538 184.112 625.492 184.048C625.437 183.974 625.382 183.91 625.327 183.855C624.979 183.498 624.43 183.113 623.871 182.93C627.498 182.252 631.024 181.575 634.578 180.87C640.75 179.642 647.015 178.305 653.068 177.014L653.682 176.886L654.094 178.424C654.094 178.433 654.094 178.443 654.103 178.443C654.57 180.192 655.037 181.941 655.523 183.681C655.788 184.606 656.045 185.531 656.301 186.456C656.832 188.343 657.364 190.22 657.886 192.107L658.737 195.157C658.765 195.267 658.811 195.459 658.856 195.706C659.186 197.272 659.397 197.996 659.781 198.17C660.074 198.298 660.487 198.197 661.045 198.051C661.174 198.014 661.283 197.987 661.366 197.968C661.65 197.923 661.934 197.858 662.218 197.803L662.73 197.703C664.187 197.428 665.661 197.098 667.081 196.787L668.381 196.503L668.427 196.961L668.454 197.419ZM606.177 186.172L607.478 194.323C608.082 193.92 608.522 193.105 608.778 192.629C609.163 191.924 609.676 191.319 610.17 190.733L610.537 190.294C610.61 190.211 610.692 190.083 610.784 189.955C611.04 189.579 611.324 189.158 611.654 188.993C611.975 188.837 612.323 188.947 612.625 189.039C612.762 189.085 612.9 189.13 613 189.13L613.092 189.14C613.128 189.14 613.156 189.14 613.183 189.149C613.193 189.13 613.211 189.103 613.229 189.075L614.585 187.207C614.612 187.161 614.658 187.088 614.704 187.006C614.96 186.566 615.143 186.282 615.4 186.209C615.72 186.126 616.132 186.337 616.563 186.566C616.728 186.649 616.929 186.758 617.002 186.777C617.241 186.832 617.479 186.813 617.753 186.795L617.9 186.786C618.028 186.777 618.202 186.786 618.404 186.795C618.697 186.804 619.31 186.832 619.448 186.74C619.549 186.667 619.732 186.282 619.814 186.09C619.878 185.952 619.933 185.824 619.988 185.742C620.025 185.678 620.071 185.568 620.135 185.44C620.391 184.881 620.593 184.478 620.876 184.331C621.105 184.222 621.334 184.313 621.518 184.386C621.573 184.405 621.655 184.441 621.682 184.441C621.682 184.396 621.719 184.331 621.774 184.258C621.838 184.176 621.911 184.011 621.976 183.864C622.076 183.645 622.186 183.397 622.342 183.205C619.832 183.672 617.259 184.148 614.594 184.634C611.709 185.183 608.916 185.687 606.177 186.172ZM656.585 203.912L656.558 203.811L656.109 203.445L655.807 203.509L655.624 203.747L655.715 204.471L655.816 204.81L655.935 205.011L655.944 205.002L655.972 205.029L656.365 205.332L656.732 205.597L656.933 205.652L657.08 205.597L657.144 205.497L657.043 205.185L656.851 204.617L656.658 204.178V204.169L656.585 203.912Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M673 211.5L662 201", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M676.581 216.789H678.121V209.862L680.904 216.789H681.456L684.188 209.862V216.789H685.894V207.617H683.637L681.276 213.877L678.865 207.617H676.581V216.789ZM687.994 216.789H690.752C693.971 216.789 695.524 214.891 695.524 212.222V212.107C695.524 209.439 693.971 207.617 690.777 207.617H687.994V216.789ZM689.7 215.442V208.964H690.687C692.843 208.964 693.74 210.157 693.74 212.133V212.235C693.74 214.262 692.753 215.442 690.7 215.442H689.7Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "676.581", y: "205.789", width: "20", height: "13", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.ME = function () {
	    var _ref22 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref22$color = _ref22.color,
	        color = _ref22$color === undefined ? "#6496c2" : _ref22$color,
	        _ref22$labelColor = _ref22.labelColor,
	        labelColor = _ref22$labelColor === undefined ? "white" : _ref22$labelColor,
	        _ref22$tooltip = _ref22.tooltip,
	        tooltip = _ref22$tooltip === undefined ? {} : _ref22$tooltip,
	        _ref22$labelTooltip = _ref22.labelTooltip,
	        labelTooltip = _ref22$labelTooltip === undefined ? {} : _ref22$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M740 61.4072L740.018 61.5354L739.698 62.3139L738.635 64.5119L738.352 65.0339L737.546 65.9223L737.088 66.023L737.28 65.327L736.923 65.1896L736.703 64.2829L735.934 64.8874L736.437 65.5559L736.19 66.4718L735.65 66.7465L734.697 66.3161L734.368 66.9114L734.688 68.0287L734.221 68.4866L733.342 68.7522L733.058 69.4757L731.364 68.8621L731.822 71.399L731.336 71.6463L730.933 71.8295L730.823 71.8661L730.842 72.1592L730.704 72.4248L730.622 72.4431L730.558 72.3881L730.42 72.2691L730.265 72.498L730.219 72.8277L730.173 73.0658L730.155 73.3772L730.146 73.478V73.6153L730.008 73.6337L729.917 73.597L729.23 72.9101L729.037 72.6629L728.726 71.9577L728.662 71.7195L728.671 71.5639L728.607 71.454L728.524 71.4082L728.177 71.454L727.7 71.5547L727.279 71.6371L726.849 71.8295L726.775 72.4431L726.317 72.8918L725.914 73.1757L725.64 73.4139L725.438 73.8168L725.383 73.8626L725.301 73.8809L725.209 73.8168L725.099 73.3955L725.072 73.1757L724.907 73.0658H724.797L724.733 73.1116L724.687 73.2032L724.678 73.3314L724.852 73.7619L724.999 74.2931L724.944 74.3389L724.797 74.3663L724.687 74.2198L724.669 74.0458L724.275 73.3497L723.982 74.0916L723.588 74.1099L723.845 74.7144L724.037 75.6943L724.074 75.7676L724.119 75.85L724.248 75.9416L724.467 75.8958L724.596 76.0332L724.87 76.4087L724.889 76.4911L724.953 76.8666L724.632 77.004L724.623 76.9673L724.44 76.8483L723.817 76.5552L723.442 76.4545L722.123 76.198L721.582 76.372L721.363 76.6743L720.951 76.72L720.914 76.6376L720.538 75.0715L720.529 74.7327L720.557 74.6869L720.657 74.5678L720.703 74.0458L720.685 73.8535L720.538 73.9359C720.538 73.9267 720.392 74.0183 720.392 74.0183L719.714 74.8426L719.412 74.5953L719.128 74.6228L719.082 74.9433L718.542 75.328L718.496 75.5478L718.661 75.8317L718.78 75.9874L718.972 76.0423L719.293 76.3903L719.375 76.9398V77.123L718.798 78.8265L718.963 79.779L718.752 79.9804L718.908 80.5025L718.872 80.8413L718.945 81.2809L719.54 80.9787L719.668 81.345L719.412 81.6015L719.384 81.9312L718.203 83.6163L718.34 84.0834L717.727 84.5871L717.25 84.2299L716.078 84.4314L715.767 84.3948L715.52 84.3582L715.336 84.6054L715.281 84.6695L715.272 85.0725L715.355 85.7502L715.144 87.0049L715.043 87.1515L713.431 87.8658L713.047 87.9941H712.763L712.653 89.203L711.737 90.1371L710.885 89.2945C710.885 89.2854 710.244 89.7708 710.244 89.7708L709.896 90.4119L709.383 90.7141L709.612 89.3861L709.301 88.4886L709.182 88.4062L709.072 88.4428L708.129 90.0455L707.652 90.879L707.323 92.2344V92.3535L707.561 92.6007L708.632 93.8738L708.01 94.3866L706.746 95.0002L706.608 96.2549L707.057 96.9052L706.389 98.7918L705.628 99.0299L705.226 100.88L705.748 101.274L705.061 103.902L704.392 103.673C704.255 103.618 704.062 103.563 703.861 103.499C703.504 103.389 702.963 103.234 702.817 103.06C702.698 102.922 702.67 102.602 702.643 102.299C702.606 101.887 702.579 101.466 702.322 101.155C702.029 100.788 701.471 100.532 700.985 100.303C700.839 100.239 700.701 100.175 700.591 100.111C700.06 99.8267 699.749 99.6436 699.584 99.1124C699.447 98.6636 699.428 98.1416 699.401 97.6379C699.392 97.4181 699.382 97.1983 699.364 96.9876C699.318 96.4747 699.163 96.0718 698.998 95.6505L698.934 95.4948C698.815 95.1742 698.686 94.8537 698.558 94.5332C698.247 93.7455 697.917 92.9304 697.67 92.1245C697.139 90.3844 696.607 88.6443 696.076 86.9042C695.023 83.4332 693.933 79.8431 692.798 76.3262C691.946 73.6794 690.92 70.5564 689.803 67.3785C690.013 67.2502 690.242 67.1312 690.242 67.1312L691.927 68.0653L692.092 68.1478H692.459L692.596 68.0195L692.624 67.9463L692.614 67.5342C692.614 67.525 692.596 66.948 692.596 66.948L692.587 66.3894L692.752 62.9275L692.926 61.9933L693.036 61.7735L693.164 61.5171L693.457 60.9767L693.924 60.1342L693.961 60.07L694.089 59.9144C694.089 59.9052 694.19 59.777 694.19 59.777L694.867 58.971L696.433 55.1703L696.461 54.8955L696.433 54.172L696.25 54.0255L696.049 53.9339H695.463L695.243 53.1921L695.041 52.377L694.666 50.1881L694.822 49.0067L695.014 47.5871C695.014 47.578 695.151 47.1933 695.151 47.1933L695.27 47.0193C695.279 47.001 695.316 46.9827 695.316 46.9827L695.701 46.6988L696.378 45.6547L696.232 44.5465L695.765 40.8649L695.756 40.8099L695.774 40.7641L696.085 39.83L696.974 37.229L698.696 32.2376L701.003 25.5428L701.947 25.4604L703.073 25.4421L703.238 25.4879L703.44 25.7626L703.485 25.8451L703.403 25.955L703.394 25.9824L703.366 26.3854L703.971 28.3453L704.154 28.501L704.246 28.5468L706.068 29.1421L706.535 28.7391L707.808 27.5302L709.2 26.2572L711.362 24.3797L711.655 24.2057L712.223 24.0317L712.754 23.9859L712.964 24.0317L713.935 24.3614L716.774 25.5703L719.32 27.1822L719.357 27.2646L723.423 40.2329L725.795 47.926L725.612 48.2099L725.594 48.3748L725.978 50.0965L726.189 50.2705C726.189 50.2614 730.283 50.4446 730.283 50.4446L730.42 50.353L730.668 50.2614L730.75 50.2797L731.153 50.5819L731.208 50.6918L732.215 53.8881L732.316 54.5017L732.179 55.326L732.124 55.4176L731.922 55.5824L731.941 55.7656L732.435 56.2876L733.525 57.3866L734.239 57.7621L734.267 57.7804L734.304 57.7988L734.432 57.8354L734.496 57.8171L734.798 57.3775L734.752 57.0844V56.6082L734.816 56.5074L734.963 56.4799L736.401 56.5441C736.41 56.5441 736.941 56.9379 736.941 56.9379L737.243 57.2035L739.817 60.3356L740.082 60.8577L740 61.4072ZM728.415 73.4688L728.177 73.2307L728.167 73.2124L727.352 73.0842L726.803 73.3864L726.409 73.5512L726.088 73.7985L725.969 73.9634L725.814 74.6411L725.731 75.1356L725.795 75.3738L726.052 75.7401L726.381 76.0423L727.27 76.3171L727.526 76.198L727.728 75.7218L727.609 75.502L727.572 75.4928L727.535 75.4379L727.499 75.273L727.563 75.1173L727.709 74.9799L728.213 74.8334L728.561 74.4304L728.607 74.3847L728.616 74.3663L728.753 74.1099L728.662 73.8626L728.415 73.4688ZM722.278 79.7148L721.976 79.6324L721.876 79.4859L722.37 79.2478L721.647 78.8723L721.555 78.799L721.308 78.9364L720.639 79.7606L720.511 80.1178L720.483 80.4475L720.511 80.4933L720.877 80.4567L721.537 81.5923L721.766 81.6656L721.894 81.629L722.398 81.3634L722.507 81.2535L722.681 80.878L722.727 80.7864L722.782 80.5574L722.718 80.42L722.278 79.7148ZM723.918 77.0864L723.725 76.9398L723.084 76.7567L722.984 76.7292L722.92 76.7475L722.984 76.8025L723.011 76.9124V77.0314L722.91 77.5718L722.7 77.5351V77.8282L722.709 77.8923L722.993 78.7257L723.295 78.799L723.524 78.9181L723.661 79.0188L723.716 78.7074L723.964 78.5426L724.147 78.1762L724.055 77.297L723.918 77.0864Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M704.07 67.6642H705.609V60.7371L708.393 67.6642H708.945L711.677 60.7371V67.6642H713.383V58.4922H711.125L708.765 64.7522L706.353 58.4922H704.07V67.6642ZM715.482 67.6642H721.435V66.3172H717.188V63.6362H720.421V62.3534H717.188V59.8391H721.216V58.4922H715.482V67.6642Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.MI = function () {
	    var _ref23 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref23$color = _ref23.color,
	        color = _ref23$color === undefined ? "#6496c2" : _ref23$color,
	        _ref23$labelColor = _ref23.labelColor,
	        labelColor = _ref23$labelColor === undefined ? "white" : _ref23$labelColor,
	        _ref23$tooltip = _ref23.tooltip,
	        tooltip = _ref23$tooltip === undefined ? {} : _ref23$tooltip,
	        _ref23$labelTooltip = _ref23.labelTooltip,
	        labelTooltip = _ref23$labelTooltip === undefined ? {} : _ref23$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M522.881 161.344C516.883 162.031 510.865 162.626 506.149 163.084C506.515 162.745 506.872 162.388 507.184 162.003C508.374 160.556 508.466 158.789 509.208 157.113C510.032 155.244 510.966 153.742 511.305 151.663C511.946 147.744 511.415 143.943 510.325 140.179C509.418 137.056 505.187 133.292 505.902 129.921L506.103 129.537L506.415 129.042L506.634 128.648L506.79 128.19L506.854 127.87L506.891 127.403L506.882 127.348L506.222 124.747L505.37 123.639L506.369 122.118L506.808 121.047L507.541 118.043L507.651 117.054L507.66 116.706L507.669 115.002C507.816 113.519 506.744 112.401 508.1 111.385C509.473 110.35 509.061 109.892 509.015 108.088C509.025 108.097 509.299 107.996 509.318 107.978C509.4 108.088 509.391 108.234 509.473 108.344C509.693 108.317 509.959 108.161 510.16 108.069C510.114 107.822 510.279 107.52 510.224 107.273C510.398 107.172 510.701 107.044 510.893 107.016C511.003 107.19 511.214 107.291 511.323 107.465C512.093 106.613 512.77 105.661 513.256 104.681C513.466 104.241 513.622 102.812 514.025 102.556L514.804 102.052H514.932L515.142 102.391L514.126 103.399L514.584 104.772L514.373 105.789L514.593 107.135L514.547 107.172L514.373 107.85L514.346 108.024L514.355 108.463L514.401 108.765L514.721 109.709C514.73 109.709 515.152 109.993 515.152 109.993C514.776 109.736 515.765 108.097 515.857 107.914C515.701 107.859 515.555 107.74 515.399 107.675C515.674 107.108 515.848 106.467 515.93 105.844C516.095 105.926 516.315 106.137 516.434 106.274C515.967 106.943 516.379 107.428 516.269 108.143C516.168 108.729 515.71 109.361 515.61 110.011C515.738 109.993 515.884 110.02 516.013 110.029C515.985 108.994 516.864 108.646 517.295 107.813C517.661 107.108 517.698 106.293 517.743 105.514C517.817 104.049 516.782 102.006 517.331 100.706C518.082 98.9292 519.969 99.0391 521.425 98.6087C523.66 97.9401 520.143 96.896 519.786 95.2658V95.1559L519.85 94.9636L520.216 94.1577L520.354 93.9653L521.636 92.5733L521.022 91.7124L523.312 91.7307L523.431 91.63L523.184 91.0988L523.715 90.998L524.044 90.9339L524.283 91.2819L527.598 92.8755L528.633 92.6923L529.182 92.4725L530.629 92.8114L530.776 92.9213L531.902 94.2676L536.06 95.8978L538.735 96.722L539.092 96.7678L539.779 96.6854L539.971 96.4748L540.063 96.4839L540.694 97.1983L541.647 98.8926C541.647 98.9017 542.636 99.9824 542.636 99.9824L543.543 101.814L543.479 101.878L543.268 101.86L542.599 101.677L542.37 101.549L542.224 101.365L541.812 101.274L541.427 101.549L541.345 101.677L541.235 101.97L541.226 102.034L541.372 102.748L541.537 103.389L541.629 103.582L541.711 103.71L542.261 104.168L543.259 104.8L543.579 105.267L544.184 107.227L544.193 107.657L544.101 110.799L544.165 111.238L544.248 112.484L544.092 113.958L543.076 115.13L542.847 115.066H542.645L542.389 115.158L542.297 115.222L542.132 115.46L541.995 115.717L541.903 116.092L541.848 117.219L541.885 117.869L541.894 118.318L541.858 119.105L540.804 120.351L539.788 120.635L539.495 120.671H538.973L538.753 120.836L538.68 120.919L538.432 121.267L538.158 122.027L538.121 122.173L538.029 124.829L539.925 126.652L541.464 127.265L544.056 124.591L544.074 124.509L544.211 123.822L544.559 122.714L546.061 120.094L549.477 117.915L550.109 117.75L551.74 118.363L552.39 118.748L552.491 118.849L552.958 119.508L554.02 121.047L554.194 121.404L554.542 122.457L554.679 122.943L554.872 123.785L554.936 124.151L555.156 125.287L555.229 125.507L555.833 126.661L556.63 128.254L557.061 131.689L557.143 131.9L557.454 132.641L557.482 132.751L557.738 133.484L557.83 133.75L558.856 135.27L558.773 140.142L558.682 141.855L558.627 142.276L558.581 142.395L557.949 143.43L557.885 143.503L557.674 143.567L556.951 143.705L556.245 143.018L556.2 142.899L556.429 142.349L556.667 142.139L556.978 142.203L557.134 141.983L557.189 141.891L557.207 141.736L557.17 141.571L557.061 141.443L557.006 141.415L556.484 141.287L556.337 141.259L556.136 141.296L555.833 141.461C555.815 141.47 554.579 145.738 554.579 145.738L554.469 146.672L554.423 146.837L554.13 147.533L553.709 147.817L553.361 147.991L553.04 148.082H552.985L552.436 148.375L552.252 148.559L552.088 148.907L551.804 149.859L551.813 149.914V149.978L551.886 150.986L551.794 152.57L551.566 153.596L550.118 155.437L548.882 157.68L548.827 157.781L548.809 157.864L548.818 158.679H548.809C545.402 159.256 541.995 159.833 538.588 160.391C537.452 160.575 536.317 160.758 535.181 160.932L532.223 161.38C532.177 161.39 532.113 161.408 532.031 161.426C531.994 161.435 531.948 161.445 531.902 161.463V161.435L531.792 161.454C531.783 161.39 531.765 161.326 531.756 161.271C531.719 161.023 531.673 160.776 531.509 160.611C531.197 160.309 530.611 160.4 529.869 160.538C529.732 160.565 529.604 160.593 529.512 160.602L522.881 161.344ZM456.098 84.175C456.556 84.6879 456.987 85.2374 457.408 85.7686C457.618 86.0342 457.82 86.2906 458.031 86.547C458.424 87.0324 459.349 87.1515 460.174 87.2614C460.458 87.298 460.732 87.3347 460.98 87.3896L466.923 88.6077C467.281 88.6809 467.638 88.7451 468.004 88.8183C468.892 88.9832 469.808 89.148 470.678 89.4228C471.127 89.5602 471.53 89.7616 471.915 89.9631C472.208 90.1097 472.501 90.2654 472.812 90.3844C473.289 90.5676 473.829 90.6866 474.351 90.8057C474.607 90.8606 474.864 90.9156 475.111 90.9797C475.166 90.9889 475.23 91.0072 475.313 91.0163C475.569 91.053 475.853 91.0988 476.045 91.2545C476.21 91.3827 476.292 91.5017 476.338 91.5842C476.366 91.5842 476.412 91.5842 476.466 91.5842C476.723 91.575 476.97 91.5384 477.217 91.5109C477.666 91.4559 478.133 91.401 478.619 91.4468C479.278 91.5109 479.938 91.6025 480.588 91.6849L481.54 91.8131C482.035 91.8772 482.749 92.0146 483.262 92.5183C483.912 93.1502 483.738 93.5257 483.436 93.947C483.372 94.0386 483.299 94.1394 483.235 94.2584C483.189 94.35 483.189 94.3866 483.189 94.3866C483.198 94.4141 483.271 94.4965 483.757 94.6248C483.995 94.6889 484.269 94.7347 484.563 94.7896C485.836 95.0186 487.576 95.3208 487.64 96.951C487.649 97.1983 487.676 97.4639 487.704 97.7295C487.768 98.3889 487.841 99.0666 487.713 99.671C487.576 100.294 487.246 100.907 486.925 101.503C486.87 101.613 486.806 101.723 486.751 101.832C487.008 101.851 487.273 101.86 487.512 101.832C487.649 101.814 487.686 101.777 487.786 101.677C487.887 101.567 488.034 101.411 488.308 101.31C488.473 101.255 488.684 101.283 488.94 101.411C489.068 101.475 489.49 101.704 489.609 102.052C489.7 102.318 489.572 102.648 489.389 103.078C489.352 103.16 489.316 103.243 489.297 103.298C489.252 103.444 489.188 103.591 489.123 103.747C488.931 104.204 488.739 104.681 488.94 105.01C489.371 105.706 489.801 105.88 490.534 106L490.607 106.009L491.184 104.214L491.981 102.931L493.089 100.404L493.483 99.1582C493.483 99.1582 493.703 98.279 493.712 98.2606L494.005 97.5921L494.582 96.2458L495.351 95.8428L496.038 94.7438L495.571 93.9745L495.846 93.3426L496.304 92.8297L496.34 92.2252L496.679 91.63L496.917 92.2436L496.395 93.1136L496.633 93.4616L496.752 93.773L496.89 94.4416L497.082 95.9069L498.52 94.8262L499.124 93.5074L499.06 92.3626L499.527 92.1703L499.894 92.5366L500.727 92.6557L501.13 91.8589L501.78 91.346L502.128 92.1886L501.606 93.2785L501.909 93.4983L501.121 93.6082L500.571 94.7713L500.562 95.1285L500.178 95.3483L500.288 95.8611L500.764 96.374L501.616 96.603L501.277 95.6413L501.808 95.5131L501.799 94.6614L502.339 94.5973L502.486 93.9104C502.486 93.9104 503.136 93.7455 503.136 93.7364L503.191 93.7547L503.374 93.6723L503.557 93.1136L504.244 93.0678L504.381 92.9121L504.519 91.9597V91.0072L504.61 90.8423L505.013 90.3295L505.682 89.9631L505.966 89.8624L507.184 89.6792H507.468L509.299 89.78C509.299 89.78 509.94 89.3587 509.94 89.3678L512.01 89.2946L512.395 89.1297L512.496 89.0015L512.88 88.3512L512.999 87.9574L513.668 87.0233L513.879 86.7943L513.979 86.721L514.126 86.6661L514.996 86.4829L515.179 86.4738L516.113 86.5196L518.687 87.0416L520.152 87.4812L523.477 89.8807L523.88 89.4136L523.614 88.2139L523.935 86.2998L525.968 86.8767L528.523 87.4354L531.014 86.7485H531.078L531.197 86.8218L531.389 86.9042L532.287 86.9408L533.936 86.9775L534.036 86.5928L533.89 86.1166L533.615 86.0616L533.175 85.5488L532.461 85.622L531.948 85.3015L531.426 84.7978L531.518 84.3399L531.847 83.946L529.952 83.3233L529.173 83.4881L528.908 82.7921L529.512 82.2517L529.814 82.1693L529.512 81.6381L529.228 81.3817L529.082 80.4384L528.697 80.0354L528.468 79.028L528.092 78.6525L527.616 78.0755L526.984 77.9564L526.288 78.1946L526.014 78.4418L525.959 79.3302L525.492 79.376L524.484 79.7423L524.411 79.3943L523.852 78.799L523.129 78.7349L522.14 79.4401L521.498 79.7698L521.05 79.2936L520.409 79.3119L519.978 79.1287L519.2 79.4126L519.071 79.3668L518.962 79.2936L518.742 79.0371L518.659 78.8631L518.623 78.6525L518.614 75.8866L518.623 75.6668L518.678 75.4012L518.797 75.1082L519.291 74.174L518.394 74.5953L516.754 74.7235C516.754 74.7235 516.003 74.9525 516.003 74.9342L514.501 75.8317L513.228 76.5552L512.899 76.6743L512.514 76.7475L511.974 76.8025L510.014 76.9673H509.483L508.649 76.8941L507.926 77.0589L504.83 77.9198L502.568 79.7423L500.965 80.4567L500.727 80.9054L500.333 81.0703L500.049 81.8304L499.793 81.9403L499.665 82.5814L499.271 82.5448L499.243 82.1785L498.557 82.2426L498.273 81.8488L497.641 81.7114L497.274 82.5082L496.963 82.4807L496.853 82.4166L496.029 81.748L495.763 81.2077L495.598 81.052L495.205 80.9787H495.104L494.417 81.3634C494.417 81.3634 493.977 81.7572 493.977 81.748L493.84 81.7847L492.274 82.0319H491.642L491.147 81.922L490.946 81.8304L490.754 81.6748L490.653 81.5557L488.006 78.2037L487.887 77.8191L487.777 77.3062L487.283 76.8483L485.396 75.8317L485.02 75.7218L483.94 75.4379L482.218 75.5386L481.091 74.7601L480.954 74.696L480.826 74.7418L479.809 75.4379L478.518 76.8208L477.932 77.6359L477.73 77.9748L477.685 78.0938L477.401 78.1121L477.245 77.7916L477.108 77.4527L477.089 77.352L477.108 76.4087L477.346 75.328L477.52 74.6777L476.292 73.652C476.292 73.652 475.899 72.672 475.871 72.6079C475.587 71.8936 473.966 72.7453 474.168 70.9228C471.42 73.5329 469.689 76.5552 465.843 78.0022C464.185 78.625 462.216 77.9748 460.787 79.147C459.267 80.4017 458.791 81.4092 456.84 82.1327C456.062 82.4257 455.347 82.8928 454.633 83.1859C454.679 83.2134 454.724 83.2317 454.77 83.2592C455.237 83.4973 455.714 83.7446 456.098 84.175ZM509.08 103.527L508.429 103.948L508.512 104.424L508.997 104.8L509.318 105.239L509.876 105.349L509.968 105.02L509.702 103.71L509.08 103.527ZM476.219 69.4849L474.461 70.7305L474.488 71.4173L474.919 72.1958L476.082 72.379L476.521 73.4871L477.712 74.4854L479.727 70.6938L478.884 70.7671L479.727 70.6847L480.478 70.3458L480.808 69.9062L482.593 67.4151L484.205 67.0762L484.352 67.0854L485.552 66.7007L485.561 66.6183L485.442 66.0322L485.259 65.8948L484.929 65.7208L484.389 65.5468L482.868 65.5834L482.273 65.6201L481.559 65.7483L479.901 66.2062L479.489 66.3894L477.547 67.6624L477.217 67.9188L476.778 68.4958L476.228 69.4757L478.756 69.2743V69.2834L476.219 69.4849ZM526.38 89.8807L525.647 90.2196L526.261 90.1646L527.213 91.346L528.441 91.3918L528.679 90.3569L527.662 90.3111L526.38 89.8807ZM534.897 86.3913L535.099 86.6203L535.273 86.8493L535.813 86.9408H537.874L538.295 86.776L538.396 86.6844L538.46 86.5745L538.78 85.5579L538.762 85.4938L538.661 85.3748L537.242 83.9277L536.683 83.772L536.564 83.7537L535.776 83.8911L535.639 84.1201L536.372 84.3673L536.472 84.8527L535.969 85.0451L535.401 85.2282L535.135 85.8052L534.787 85.9975L534.604 85.503L534.366 85.4297L534.165 85.9609L534.247 86.2906L534.897 86.3913ZM513.998 95.4765L514.831 95.5223L515.39 94.9087L515.463 94.4507L515.179 93.6998L515.207 92.8389L514.895 92.6191L515.097 92.4359L514.346 92.3352L514.355 93.0678L513.952 93.7547L514.044 94.2951L513.869 94.7621L513.998 95.4765Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M523.333 143.945H524.872V137.018L527.656 143.945H528.208L530.94 137.018V143.945H532.646V134.773H530.389L528.028 141.033L525.617 134.773H523.333V143.945ZM534.797 143.945H536.516V134.773H534.797V143.945Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.MN = function () {
	    var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref24$color = _ref24.color,
	        color = _ref24$color === undefined ? "#6496c2" : _ref24$color,
	        _ref24$labelColor = _ref24.labelColor,
	        labelColor = _ref24$labelColor === undefined ? "white" : _ref24$labelColor,
	        _ref24$tooltip = _ref24.tooltip,
	        tooltip = _ref24$tooltip === undefined ? {} : _ref24$tooltip,
	        _ref24$labelTooltip = _ref24.labelTooltip,
	        labelTooltip = _ref24$labelTooltip === undefined ? {} : _ref24$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M373.059 43.3559L382.29 43.4567H394.847L396.807 43.4384L396.788 40.7733L396.77 39.6559L396.761 37.8609L396.752 37.3663C396.752 37.348 399.023 37.5678 399.023 37.5678L399.737 37.8975L400.571 38.6027L401.514 41.7715V43.7406L402.146 44.2718C402.375 45.3158 402.1 46.9369 402.833 47.7245C403.419 48.3564 404.234 48.4572 404.994 48.4755C405.883 48.503 406.405 48.1641 407.311 48.5762C407.531 48.677 407.384 49.1257 407.751 49.2998C408.09 49.4646 408.722 49.3364 409.115 49.3547C409.866 49.3913 411.46 49.1441 412.055 49.547C412.76 50.0233 412.211 50.9849 412.522 51.3146C413.2 52.0106 417.111 51.3604 416.589 50.0965C421.479 47.6879 426.324 51.626 430.482 53.9248L430.784 53.7141L433.211 53.5401L433.523 54.0988L434.054 55.2069L434.109 55.2985L434.2 55.4267L436.334 56.1502C436.334 56.1594 436.994 56.0587 436.994 56.0587L437.314 56.1319C437.333 56.1502 437.369 56.2327 437.369 56.2327L437.543 57.0661L437.461 57.4507L437.415 57.5515L437.424 57.5973L438.267 57.8537L440.089 58.275L441.967 58.1468L442.406 58.0644L442.681 57.9636L442.864 57.872C442.873 57.872 445.337 55.8847 445.337 55.8847C445.337 55.8755 445.96 55.3535 445.96 55.3535L447.004 54.8406H447.462L447.498 54.8589L447.553 54.923L448.02 55.9671L448.222 56.5349C448.222 56.5532 448.597 57.3134 448.597 57.3134L448.726 57.4324L450.85 57.0386L455.457 56.6723L455.933 56.6448L456.464 56.7455L456.675 56.7913L457.289 57.0295L457.618 57.4874L457.673 57.6248L457.646 57.8629L457.701 57.9819L458.012 58.2017L458.873 58.6139L459.157 58.6322L459.45 58.4948L461.694 58.0735L463.645 57.8262L463.626 57.9911L463.581 58.0369L462.912 58.5589L462.72 58.7054L460.21 60.1891L458.598 61.0592L457.692 61.5629L456.831 61.9292L455.778 62.2864L454.963 62.5703L452.737 63.5045L451.629 63.9807L449.358 65.4644L447.856 66.7191L446.097 68.4042L445.841 68.5599L444.916 69.5948L444.595 69.9703L443.121 72.0035L441.216 74.2931L440.987 74.5403L440.52 74.87L439.879 75.2181L438.377 76.7567L438.01 77.1597L437.36 77.9381L436.811 78.2037L436.325 78.57L434.283 80.3102L433.971 80.6032L433.88 80.7131L433.935 80.8871C433.459 80.8505 432.543 81.3908 432.424 81.8762C432.369 82.096 432.433 82.2884 432.479 82.4257C432.534 82.5998 432.534 82.5998 432.469 82.6639C432.378 82.7463 431.993 82.7005 431.865 82.5723C431.764 82.4715 431.618 82.4349 431.48 82.499C431.352 82.554 431.27 82.6822 431.27 82.8287L431.618 92.326L431.627 92.5183C431.636 92.6832 431.654 92.8297 431.609 92.8938C431.499 93.0495 431.077 93.2602 430.803 93.3975C430.638 93.48 430.482 93.5624 430.363 93.6356C429.878 93.9379 429.401 94.2584 428.925 94.5698L428.183 95.0552C427.661 95.3849 427.075 95.7512 426.681 96.2733C426.324 96.7495 426.068 97.3265 425.82 97.876C425.72 98.1141 425.61 98.3431 425.509 98.5537C425.216 99.1307 424.868 99.8908 424.731 100.651C424.685 100.917 424.676 101.228 424.731 101.594C424.831 102.364 425.188 102.446 425.765 102.519C426.489 102.611 426.828 102.867 427.185 103.618C427.533 104.333 427.606 104.882 427.423 105.349C427.332 105.578 427.203 105.789 427.066 106.018C426.846 106.384 426.617 106.76 426.562 107.236C426.452 108.106 426.352 108.976 426.26 109.846C426.159 110.734 426.306 111.201 426.553 111.98C426.773 112.694 426.819 113.4 426.7 114.27C426.681 114.407 426.608 114.645 426.526 114.901C426.333 115.524 426.132 116.175 426.324 116.568C426.443 116.816 426.745 116.953 427.039 117.081C427.139 117.127 427.258 117.182 427.313 117.209C427.762 117.53 428.147 117.86 428.412 118.144C428.531 118.272 428.641 118.427 428.751 118.583C429.044 118.986 429.374 119.444 429.914 119.655C430.354 119.829 430.821 119.801 431.27 119.774C431.627 119.755 431.966 119.728 432.25 119.82C432.369 119.856 432.387 119.865 432.387 119.865C432.396 119.893 432.414 119.966 432.442 120.076C432.469 120.186 432.488 120.268 432.506 120.342C432.607 120.809 432.68 120.909 433.23 121.276C433.715 121.605 434.255 121.798 434.777 121.981C435.006 122.063 435.235 122.146 435.464 122.237L435.565 122.283C436.16 122.53 436.765 122.787 437.213 123.208C437.351 123.336 437.369 123.382 437.369 123.446C437.369 123.538 437.36 123.666 437.397 123.858C437.433 124.051 437.525 124.234 437.616 124.408C437.69 124.545 437.763 124.692 437.809 124.838C438.047 125.681 438.377 125.919 438.972 126.35L441.692 128.3C442.269 128.712 442.818 128.868 443.45 129.051L443.707 129.125C444.238 129.28 444.485 129.619 444.824 130.086C444.916 130.205 445.007 130.333 445.163 130.535C445.694 131.213 445.85 131.414 445.969 132.202C446.051 132.779 446.17 133.539 446.335 134.308C446.418 134.702 446.518 135.105 446.619 135.517C446.729 135.975 446.848 136.442 446.94 136.909L446.042 136.955C441.5 137.175 436.966 137.367 432.424 137.55C428.22 137.724 411.213 138.173 406.899 138.237L405.095 138.265C401.514 138.32 397.814 138.375 394.169 138.384L390.313 138.393C387.428 138.402 384.553 138.411 381.668 138.402L381.677 136.424C381.686 133.008 381.713 129.582 381.732 126.166C381.75 122.65 381.778 119.142 381.787 115.625L381.805 110.698C381.805 110.469 381.823 110.203 381.842 109.91C381.924 108.472 382.034 106.503 380.798 105.725C380.587 105.597 380.047 105.276 379.525 105.12C379.369 105.075 379.213 105.056 379.067 105.047C378.856 105.029 378.774 105.02 378.71 104.946C378.545 104.772 378.435 104.452 378.325 104.14C378.242 103.911 378.16 103.664 378.05 103.463C377.894 103.188 377.711 102.941 377.528 102.702L377.281 102.382C376.914 101.906 376.841 101.796 377.125 101.429C377.391 101.091 377.794 100.862 378.215 100.614C378.508 100.44 378.819 100.266 379.085 100.047C380.184 99.1307 380.486 97.7936 380.523 96.6671H380.532L380.541 95.9802H380.505C380.495 95.8337 380.468 95.678 380.44 95.5223C380.395 95.2567 380.349 95.0002 380.386 94.7896C380.404 94.6522 380.45 94.5332 380.495 94.4141C380.569 94.2126 380.651 93.9745 380.651 93.6906C380.651 93.0953 380.55 92.4817 380.45 91.8955C380.404 91.6208 380.358 91.346 380.321 91.0804L380.285 90.8057C380.212 90.2287 380.147 89.6792 379.909 89.0931L379.451 88.0032C379.149 87.298 378.856 86.5837 378.572 85.8693L378.426 85.5121C378.233 85.0451 378.023 84.5597 377.949 84.1017C377.867 83.6163 377.922 83.0394 377.977 82.4807C377.995 82.27 378.013 82.0686 378.032 81.8671C378.05 81.6381 378.068 81.4092 378.096 81.171C378.169 80.4933 378.242 79.7973 378.096 79.1562C378.032 78.854 377.931 78.5609 377.83 78.2587C377.693 77.8557 377.565 77.4802 377.528 77.0864C377.446 76.1247 377.436 75.1082 377.427 74.1374C377.418 73.4505 377.418 72.7636 377.382 72.0859C377.281 70.0436 377.125 68.276 376.887 66.5267C376.759 65.6109 376.338 64.7683 375.935 63.9532C375.669 63.4129 375.413 62.9092 375.238 62.378C375.01 61.6819 374.817 60.9584 374.634 60.2532C374.542 59.896 374.451 59.548 374.35 59.2C374.304 59.0351 374.249 58.8611 374.194 58.678C374.03 58.1743 373.865 57.6522 373.892 57.2035C373.911 56.9196 373.984 56.6356 374.066 56.3426C374.167 55.9671 374.277 55.5824 374.268 55.1611C374.259 54.804 374.268 54.4376 374.277 54.0713C374.295 53.3111 374.304 52.5235 374.213 51.7084C374.222 51.6077 374.231 51.4795 374.176 51.3512C374.112 51.1955 373.993 51.104 373.901 51.0307C373.883 51.0215 373.865 51.0032 373.846 51.0032C373.865 50.875 373.993 50.5819 374.057 50.4262C374.112 50.298 374.167 50.179 374.194 50.0874C374.231 49.9866 374.277 49.8676 374.332 49.7394C374.478 49.3913 374.643 49.0067 374.625 48.677C374.616 48.3656 374.433 48.0542 374.277 47.7795C374.204 47.6512 374.139 47.5413 374.103 47.4314C373.883 46.8636 373.709 46.2592 373.535 45.673C373.462 45.4349 373.398 45.1968 373.324 44.9678C373.297 44.8671 373.26 44.7663 373.214 44.6473C373.095 44.2077 372.903 43.6582 373.059 43.3559ZM467.345 60.6653L467.738 60.7661L468.132 60.6562L470.275 59.3374L469.424 59.374L469.414 59.0901L471.31 57.7347L472.217 57.5698L473.124 57.0752L474.094 56.2144L474.333 55.9579L474.195 55.5916L474.287 55.2894L475.422 54.3827L475.899 53.7874L474.461 54.1812L473.701 54.5842L473.215 54.8955L473.032 55.1153L473.014 55.1611L472.922 55.326L472.034 55.9304L469.442 57.5515L468.297 58.2292L467.354 58.8703L466.96 59.2641L466.612 59.7312L466.52 59.951L466.795 60.354L467.345 60.6653Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M394.137 101.796H395.677V94.8686L398.46 101.796H399.012L401.744 94.8686V101.796H403.45V92.6237H401.193L398.832 98.8838L396.421 92.6237H394.137V101.796ZM405.55 101.796H407.102V94.766L411.233 101.796H413.003V92.6237H411.451V99.2558L407.589 92.6237H405.55V101.796Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.MO = function () {
	    var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref25$color = _ref25.color,
	        color = _ref25$color === undefined ? "#6496c2" : _ref25$color,
	        _ref25$labelColor = _ref25.labelColor,
	        labelColor = _ref25$labelColor === undefined ? "white" : _ref25$labelColor,
	        _ref25$tooltip = _ref25.tooltip,
	        tooltip = _ref25$tooltip === undefined ? {} : _ref25$tooltip,
	        _ref25$labelTooltip = _ref25.labelTooltip,
	        labelTooltip = _ref25$labelTooltip === undefined ? {} : _ref25$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M445.09 190.935L444.852 190.632C444.815 190.596 444.778 190.55 444.733 190.504C444.595 190.358 444.44 190.202 444.366 190.01C444.311 189.872 444.321 189.735 444.33 189.652C444.22 189.259 443.643 188.929 443.451 188.81C442.956 188.517 442.113 188.581 441.362 188.636C441.115 188.654 440.868 188.673 440.657 188.673C439.943 188.682 439.219 188.746 438.514 188.801L437.681 188.865C434.054 189.121 430.207 189.35 425.94 189.57C417.441 190.019 410.315 190.321 403.08 190.275C398.986 190.257 394.893 190.229 390.799 190.184C390.817 190.211 390.835 190.248 390.854 190.275C390.881 190.257 390.918 190.239 390.955 190.229C391.064 190.193 391.183 190.229 391.266 190.303L391.376 190.394C391.577 190.55 391.825 190.751 391.843 191.035C391.861 191.31 391.715 191.512 391.605 191.658C391.55 191.731 391.486 191.814 391.495 191.86C391.513 192.217 391.77 192.73 391.98 193.151C392.063 193.316 392.136 193.472 392.2 193.609C392.292 193.81 392.466 193.975 392.658 194.14C392.878 194.342 393.107 194.543 393.244 194.845C393.317 195.01 393.336 195.157 393.354 195.285C393.363 195.386 393.372 195.468 393.409 195.541C393.592 195.917 393.894 196.301 394.187 196.668C394.334 196.86 394.49 197.043 394.618 197.226L396.074 199.278C396.166 199.415 396.248 199.562 396.33 199.699H396.569V200.13C396.578 200.139 396.587 200.157 396.596 200.166C396.862 200.524 397.329 200.899 397.741 201.229L398.016 201.449C398.373 201.742 398.84 202.08 399.243 202.135C399.6 202.181 399.71 202.071 400.021 201.705L400.15 201.549C400.214 201.476 400.305 201.43 400.415 201.43C400.516 201.43 400.607 201.476 400.672 201.558C400.772 201.687 400.882 201.806 400.992 201.934C401.514 202.538 402.1 203.225 402.064 204.132C402.036 204.782 401.478 205.167 400.992 205.506C400.763 205.661 400.543 205.817 400.415 205.973C400.195 206.22 399.966 206.568 399.829 206.852C399.518 207.493 399.334 208.033 399.353 208.171C399.389 208.281 399.737 208.592 399.884 208.729C400.003 208.839 400.104 208.931 400.168 208.995C400.269 209.105 400.369 209.206 400.47 209.316C400.69 209.545 400.91 209.774 401.102 210.021C401.551 210.616 401.945 211.275 402.32 211.907C402.503 212.219 402.686 212.53 402.879 212.832C402.934 212.924 402.998 213.043 403.062 213.162C403.163 213.354 403.309 213.657 403.428 213.739C403.566 213.84 403.923 213.904 404.188 213.95C404.344 213.977 404.491 214.005 404.61 214.032C404.655 214.041 404.747 214.06 404.866 214.078C405.58 214.197 405.928 214.289 406.093 214.508C406.222 214.682 406.212 214.939 406.139 215.726C406.121 215.9 406.103 216.056 406.103 216.129C406.112 216.853 406.121 217.586 406.13 218.309L406.139 219.243C406.185 222.614 406.203 225.993 406.222 229.363C406.24 233.301 406.267 237.23 406.322 241.169L406.359 243.715C406.405 246.572 406.441 249.42 406.478 252.269V252.69C406.487 253.487 406.487 254.283 406.487 255.08C406.487 257.031 406.487 259.027 406.634 261.006C411.121 260.932 415.902 260.85 420.609 260.731C425.216 260.621 430.125 260.493 435.08 260.31C437.342 260.227 439.595 260.126 441.857 260.017C444.229 259.907 446.61 259.797 448.982 259.714C452.728 259.577 456.538 259.357 460.22 259.147L467.189 258.753C467.262 258.753 467.345 258.734 467.427 258.725C467.583 258.707 467.757 258.689 467.922 258.689C468.123 258.689 468.316 258.716 468.481 258.817C468.911 259.082 469.387 259.879 469.79 260.621C470.065 261.134 470.138 261.903 470.065 262.398C469.973 262.993 469.543 263.35 469.167 263.662C469.094 263.726 469.021 263.781 468.948 263.845C468.169 264.532 467.72 265.328 467.207 266.253L466.429 267.618L469.616 267.398C471.411 267.27 473.197 267.151 474.992 267.032C475.029 266.977 475.056 266.931 475.084 266.885L475.157 266.775C475.239 266.638 475.258 266.519 475.276 266.354C475.294 266.208 475.313 266.052 475.386 265.86C475.496 265.567 475.771 265.393 476.036 265.219C476.503 264.925 476.522 264.843 476.467 264.706C476.439 264.678 476.274 264.605 476.164 264.559C475.981 264.477 475.789 264.394 475.661 264.257C475.468 264.055 475.322 263.79 475.203 263.561C475.148 263.46 475.093 263.359 475.038 263.268C474.965 263.158 474.965 263.011 475.038 262.901C475.111 262.792 475.23 262.737 475.368 262.746C475.45 262.755 475.542 262.773 475.642 262.782C476.238 262.874 476.796 262.929 476.998 262.599C476.998 262.517 476.851 262.315 476.164 261.885L475.981 261.766C475.871 261.693 475.816 261.555 475.835 261.427C475.862 261.299 475.954 261.189 476.082 261.152C476.146 261.134 476.274 261.116 476.421 261.088C476.641 261.051 477.154 260.969 477.273 260.896C477.3 260.85 477.19 260.584 476.906 260.145C476.86 260.081 476.824 260.026 476.796 259.971C476.613 259.659 476.586 259.357 476.558 259.092C476.549 259 476.54 258.908 476.522 258.817H476.457L476.439 258.542C476.402 258.478 476.338 258.405 476.283 258.322C476.119 258.112 475.908 257.846 475.926 257.489C475.954 257.123 476.183 256.829 476.531 256.701C476.98 256.546 477.529 256.683 477.822 257.003C478.124 257.342 478.143 257.837 478.014 258.176C477.978 258.286 477.923 258.377 477.868 258.45L477.877 258.515C477.886 258.588 477.914 258.744 477.941 258.844C478.033 258.716 478.143 258.441 478.179 258.341L478.234 258.222C478.234 258.212 478.243 258.203 478.243 258.194L479.223 255.776C479.269 255.666 479.361 255.593 479.471 255.566C479.59 255.547 479.7 255.575 479.782 255.657C479.855 255.73 479.938 255.813 480.011 255.895C480.222 256.115 480.432 256.344 480.634 256.39C480.698 256.399 480.734 256.408 480.762 256.408C480.744 256.399 480.753 256.335 480.762 256.289C480.78 256.133 480.817 255.95 480.918 255.758C481.009 255.584 481.101 255.456 481.174 255.346C481.302 255.153 481.376 255.044 481.449 254.732C481.476 254.622 481.531 254.448 481.595 254.256C481.687 253.99 481.888 253.368 481.843 253.203C481.833 253.212 481.714 253.166 481.65 253.129C481.43 253.038 481.156 252.928 481.055 252.644C480.881 252.159 481.22 251.884 481.385 251.756C481.44 251.71 481.513 251.655 481.531 251.618C481.833 251.05 481.953 250.528 481.861 250.208C481.833 250.125 481.797 250.052 481.742 249.997L481.641 250.043L481.568 249.869C481.275 249.722 480.863 249.732 480.423 249.741C479.91 249.75 479.379 249.759 478.921 249.53C478.143 249.127 477.877 248.504 477.621 247.9C477.556 247.753 477.492 247.598 477.419 247.433C477.309 247.195 477.144 246.947 476.98 246.691C476.659 246.187 476.32 245.656 476.229 245.134C476.229 245.125 476.009 243.843 476.357 243.495C476.522 243.33 476.714 243.293 476.842 243.266C476.952 243.248 476.961 243.238 476.97 243.229C477.163 242.918 476.86 242.249 476.577 241.91L476.43 241.736C476.045 241.278 475.615 240.766 475.459 240.115H475.45L475.441 240.042C475.423 239.95 475.413 239.868 475.404 239.767V239.74C475.349 239.419 475.038 238.989 474.791 238.641C474.672 238.467 474.553 238.302 474.461 238.155L473.573 236.69C473.527 236.617 473.481 236.525 473.435 236.424C473.362 236.287 473.261 236.076 473.188 236.012C472.922 235.793 472.29 235.674 471.778 235.582C471.53 235.536 471.292 235.49 471.109 235.435C470.981 235.399 470.843 235.362 470.697 235.335C470.239 235.225 469.763 235.115 469.369 234.84C468.829 234.474 468.343 233.988 467.876 233.521C467.656 233.301 467.436 233.082 467.217 232.88C466.823 232.523 466.411 232.175 465.999 231.836C465.257 231.213 464.478 230.563 463.828 229.84C462.949 228.878 462.766 227.44 463.324 226.011C463.636 225.205 463.947 224.39 464.258 223.584C464.506 222.934 464.753 222.275 465.009 221.625C465.138 221.286 465.183 221.176 465.174 220.947C465.174 220.846 465.119 220.69 465.074 220.544C464.982 220.26 464.881 219.939 464.964 219.646C465.055 219.317 465.312 219.069 465.559 218.831C465.925 218.474 466.09 218.282 466.008 218.044C465.925 217.805 465.156 217.439 464.826 217.283C464.716 217.228 464.616 217.183 464.533 217.137C464.057 216.89 463.48 216.761 462.93 216.642C462.747 216.606 462.564 216.56 462.39 216.523C461.612 216.331 461.364 216.404 460.531 216.624C460.421 216.651 460.284 216.706 460.137 216.761C459.734 216.908 459.276 217.073 458.91 217.027L458.828 217.018C458.525 216.981 458.434 216.862 458.351 216.624L458.287 216.459C458.241 216.34 458.177 216.212 458.113 216.074C457.948 215.708 457.756 215.287 457.719 214.902C457.683 214.573 457.793 214.408 457.875 214.27C457.921 214.206 457.957 214.142 457.985 214.041C458.113 213.638 457.783 212.549 457.49 212.008C457.316 211.678 456.941 211.385 456.584 211.092C456.437 210.973 456.291 210.863 456.162 210.744C455.952 210.552 455.741 210.369 455.521 210.186C455.091 209.81 454.66 209.444 454.257 209.05C453.754 208.565 453.278 208.033 452.81 207.53C452.252 206.916 451.675 206.275 451.052 205.725C450.823 205.515 450.548 205.341 450.264 205.149C449.88 204.892 449.486 204.626 449.165 204.288C448.717 203.802 448.387 203.115 448.149 202.566C447.444 200.936 446.94 199.626 446.628 198.115C446.574 197.84 446.509 197.574 446.445 197.318C446.134 196.018 445.85 194.79 446.436 193.398C446.491 193.27 446.537 193.124 446.592 192.968C446.665 192.739 446.748 192.501 446.848 192.272C446.537 192.235 446.244 192.144 445.905 191.832C445.603 191.576 445.337 191.255 445.09 190.935Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M424.375 231.908H425.914V224.981L428.698 231.908H429.249L431.982 224.981V231.908H433.688V222.736H431.43L429.07 228.996L426.658 222.736H424.375V231.908ZM439.969 232.036C442.753 232.036 444.587 230.022 444.587 227.341V227.238C444.587 224.545 442.701 222.608 439.969 222.608C437.249 222.608 435.325 224.596 435.325 227.277V227.38C435.325 230.022 437.16 232.036 439.969 232.036ZM439.995 230.664C438.327 230.664 437.108 229.368 437.108 227.367V227.264C437.108 225.289 438.173 223.967 439.969 223.967C441.765 223.967 442.817 225.366 442.817 227.251V227.354C442.817 229.342 441.726 230.664 439.995 230.664Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.MS = function () {
	    var _ref26 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref26$color = _ref26.color,
	        color = _ref26$color === undefined ? "#6496c2" : _ref26$color,
	        _ref26$labelColor = _ref26.labelColor,
	        labelColor = _ref26$labelColor === undefined ? "white" : _ref26$labelColor,
	        _ref26$tooltip = _ref26.tooltip,
	        tooltip = _ref26$tooltip === undefined ? {} : _ref26$tooltip,
	        _ref26$labelTooltip = _ref26.labelTooltip,
	        labelTooltip = _ref26$labelTooltip === undefined ? {} : _ref26$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M498.896 348.24C498.795 347.452 498.694 346.664 498.584 345.877C498.355 344.173 498.126 342.415 497.943 340.684L497.861 339.896C497.751 338.935 497.641 337.946 497.659 336.956L497.687 335.418C497.705 334.282 497.723 333.147 497.742 332.02L498.071 315.114C498.172 310.076 498.273 305.039 498.401 299.993C498.438 298.381 498.474 296.769 498.511 295.157L498.566 292.602C498.593 291.412 498.621 290.212 498.657 289.021L498.731 286.155C498.731 286.054 498.74 285.944 498.749 285.843C498.767 285.541 498.786 285.285 498.676 285.092C498.474 284.753 498.117 284.424 497.769 284.103C497.623 283.966 497.476 283.828 497.339 283.7C496.844 283.764 496.35 283.819 495.855 283.856C492.723 284.112 489.581 284.36 486.449 284.607C480.908 285.037 475.267 285.376 469.818 285.715L468.032 285.825C468.059 286.1 468.123 286.384 468.187 286.668C468.233 286.887 468.279 287.089 468.306 287.29L468.334 287.464C468.398 287.785 468.361 287.941 468.078 288.188C467.83 288.399 467.51 288.463 467.226 288.518C467.006 288.563 466.804 288.609 466.685 288.701C466.411 288.911 466.154 289.415 465.925 289.855C465.815 290.074 465.705 290.276 465.605 290.441C465.513 290.587 465.394 290.752 465.266 290.926C464.991 291.302 464.671 291.732 464.616 292.062C464.542 292.465 464.634 292.996 464.725 293.509C464.771 293.775 464.817 294.031 464.835 294.269C464.845 294.388 464.863 294.498 464.872 294.608C464.954 295.295 465.046 296.009 464.203 296.586C463.791 296.861 463.352 296.943 462.967 297.007C462.701 297.053 462.445 297.099 462.216 297.2C461.877 297.346 461.593 297.969 461.364 298.464C461.273 298.665 461.181 298.848 461.099 299.004C460.787 299.563 460.513 300.13 460.229 300.707L460.165 300.836C460.027 301.12 460.046 301.138 460.265 301.312C460.467 301.477 460.76 301.715 460.824 302.219C460.943 303.125 460.009 303.501 459.386 303.739C459.24 303.794 459.102 303.849 458.983 303.913C458.846 303.986 458.708 304.041 458.58 304.096C458.141 304.288 457.93 304.389 457.82 304.71C457.619 305.332 457.481 306.01 457.344 306.67C457.28 307.008 457.206 307.347 457.133 307.677C457.097 307.814 457.042 307.998 456.968 308.217C456.84 308.62 456.611 309.289 456.684 309.545C456.712 309.655 456.923 309.793 457.069 309.893C457.316 310.058 457.6 310.25 457.582 310.58C457.564 310.91 457.252 311.111 456.977 311.258C456.831 311.331 456.666 311.386 456.52 311.423C456.465 311.441 456.391 311.459 456.346 311.478C456.346 311.487 456.355 311.505 456.364 311.524C456.446 311.688 456.611 311.798 456.831 311.936C456.904 311.981 456.977 312.027 457.051 312.073C457.097 312.1 457.151 312.137 457.206 312.165C457.509 312.348 458.012 312.65 457.939 313.227C457.875 313.74 457.454 313.914 457.124 313.996C457.151 314.088 457.179 314.179 457.216 314.271C457.399 314.83 457.591 315.407 457.848 315.92C457.921 316.066 458.04 316.213 458.159 316.368C458.305 316.551 458.461 316.744 458.553 316.954C458.754 317.403 458.69 318.237 458.663 318.484C458.544 319.592 458.25 320.425 457.802 320.966C457.756 321.021 457.71 321.076 457.655 321.14L457.664 321.341L457.499 321.35C457.243 321.708 457.032 322.092 457.051 322.495C457.078 323.091 457.261 323.741 457.435 324.373C457.527 324.693 457.609 325.014 457.683 325.316C457.738 325.573 457.783 325.838 457.829 326.122C457.921 326.653 458.012 327.203 458.186 327.642C458.269 327.835 458.305 327.88 458.498 328L458.626 328.073C459.176 328.412 459.185 328.595 459.001 329.236C458.791 329.932 458.827 329.959 459.34 330.509C459.432 330.61 459.551 330.71 459.688 330.829C460.027 331.132 460.403 331.471 460.568 331.828C460.705 332.139 460.687 332.57 460.668 332.936C460.659 333.073 460.659 333.201 460.659 333.311C460.659 333.394 460.668 333.485 460.687 333.586C460.732 334.007 460.797 334.539 460.43 334.786C460.201 334.942 459.853 334.987 459.386 335.006L459.734 335.409C459.771 335.445 459.826 335.5 459.899 335.564C460.265 335.912 460.503 336.16 460.503 336.434C460.503 336.663 460.339 336.874 460.082 337.176C460.036 337.231 459.991 337.277 459.972 337.314L459.038 338.678C458.086 340.061 457.124 341.389 455.97 342.955C455.155 344.054 454.55 345.391 453.974 346.683L453.845 346.957C453.699 347.287 453.662 347.599 453.616 347.983L453.47 349.229C453.387 349.952 453.296 350.685 453.204 351.408C453.094 352.214 452.966 353.02 452.829 353.826C452.719 354.513 452.6 355.209 452.499 355.896C459.249 355.576 466.475 355.218 473.719 354.733L475.404 354.623C477.099 354.513 478.802 354.394 480.496 354.284C480.579 354.275 480.679 354.312 480.744 354.367C480.808 354.422 480.853 354.513 480.863 354.605C480.899 355.191 480.89 355.942 480.551 356.51C480.451 356.674 480.313 356.729 480.231 356.757C480.185 356.867 480.157 357.05 480.139 357.206C480.121 357.306 480.112 357.407 480.093 357.49C480.048 357.691 479.983 357.938 479.91 358.204C479.7 358.973 479.416 360.026 479.59 360.539C479.699 360.869 480.048 361.281 480.359 361.638C480.524 361.831 480.67 362.005 480.789 362.17L481.192 362.719C481.458 363.076 481.714 363.433 481.971 363.791C482.236 364.166 482.429 364.578 482.621 364.972L482.685 365.1C482.722 365.164 482.758 365.238 482.804 365.311C482.914 365.503 483.042 365.723 483.097 365.943C483.161 366.218 483.088 366.41 483.042 366.547C483.015 366.621 482.997 366.666 482.997 366.73C482.969 367.115 483.409 367.701 483.564 367.976C483.857 368.48 484.407 368.535 484.929 368.498L486.742 366.923L487.017 365.366L487.951 366.007L490.882 365.164L493.263 364.542C493.263 364.542 494.399 364.258 494.399 364.267L494.93 364.578L495.947 365.155L496.23 365.21L499.995 365.348L500.114 365.302L500.965 364.752L500.892 364.203C500.224 358.863 499.564 353.551 498.896 348.24Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M470.272 325.201H471.811V318.274L474.595 325.201H475.147L477.879 318.274V325.201H479.585V316.029H477.327L474.967 322.289L472.555 316.029H470.272V325.201ZM484.802 325.33C486.828 325.33 488.175 324.085 488.175 322.495C488.175 320.66 487.059 320.044 484.904 319.749C483.314 319.518 483.006 319.146 483.006 318.402C483.006 317.697 483.545 317.197 484.584 317.197C485.635 317.197 486.187 317.607 486.354 318.569H487.919C487.739 316.812 486.559 315.914 484.584 315.914C482.672 315.914 481.389 317.043 481.389 318.544C481.389 320.262 482.429 320.93 484.622 321.225C486.11 321.468 486.533 321.789 486.533 322.636C486.533 323.482 485.815 324.047 484.802 324.047C483.249 324.047 482.877 323.277 482.762 322.353H481.12C481.248 324.085 482.3 325.33 484.802 325.33Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.MT = function () {
	    var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref27$color = _ref27.color,
	        color = _ref27$color === undefined ? "#6496c2" : _ref27$color,
	        _ref27$labelColor = _ref27.labelColor,
	        labelColor = _ref27$labelColor === undefined ? "white" : _ref27$labelColor,
	        _ref27$tooltip = _ref27.tooltip,
	        tooltip = _ref27$tooltip === undefined ? {} : _ref27$tooltip,
	        _ref27$labelTooltip = _ref27.labelTooltip,
	        labelTooltip = _ref27$labelTooltip === undefined ? {} : _ref27$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M153.596 32.2285L153.165 34.2983C153.129 34.4631 153.074 34.6554 153.01 34.8661C152.89 35.2416 152.753 35.7178 152.79 35.9926C152.808 36.1208 152.945 36.3406 153.055 36.5146C153.138 36.6428 153.211 36.7619 153.266 36.8718C153.486 37.3114 153.696 37.751 153.916 38.1906L154.2 38.7767C154.319 39.024 154.466 39.2804 154.621 39.546C155.006 40.2146 155.4 40.9106 155.528 41.6158C155.675 42.4401 155.382 43.1361 155.098 43.8139C154.933 44.2168 154.768 44.6015 154.704 44.9953C154.686 45.0869 154.667 45.1785 154.649 45.2792C154.576 45.6364 154.512 45.9752 154.631 46.2317C154.805 46.6163 155.125 47.0101 155.437 47.3856C155.601 47.578 155.757 47.7794 155.894 47.9626L156.014 48.1275C156.233 48.4297 156.435 48.7228 156.719 48.9151C156.92 49.0525 157.167 49.1349 157.424 49.2265C157.708 49.3272 158.01 49.428 158.276 49.6111C158.88 50.0233 159.201 50.9299 159.475 51.7176C159.567 51.9648 159.64 52.203 159.732 52.3953L159.906 52.7983C160.336 53.7874 160.739 54.7215 161.243 55.6557C161.49 56.1228 161.563 56.6082 161.637 57.0844C161.71 57.5698 161.774 58.0186 162.04 58.394C162.15 58.5497 162.26 58.7238 162.379 58.8886C162.69 59.3648 163.02 59.8502 163.386 60.1891C163.45 60.2441 163.514 60.2532 163.679 60.2624C163.844 60.2715 164.073 60.2807 164.274 60.4272C164.586 60.6653 164.668 61.0866 164.741 61.453C164.787 61.6911 164.851 61.9933 164.952 62.0757C165.181 62.2589 165.859 62.2681 166.326 62.1673C166.72 62.0849 167.535 61.9109 167.965 62.5062C168.304 62.9641 168.066 63.5411 167.901 63.9624C167.874 64.0356 167.846 64.0997 167.819 64.1639C167.434 65.2537 166.949 66.3252 166.472 67.3601C166.134 68.102 165.786 68.8713 165.474 69.6406L163.679 74.1099C163.542 74.4488 163.395 74.7785 163.249 75.1173C162.956 75.7767 162.663 76.4544 162.47 77.123C162.369 77.471 162.314 77.8465 162.26 78.2129C162.232 78.4052 162.205 78.5884 162.168 78.7715C162.14 78.9272 162.095 79.1104 162.04 79.3027C161.948 79.6599 161.838 80.072 161.866 80.3193C161.866 80.3468 161.866 80.3743 161.866 80.4017C161.93 80.4109 162.012 80.4109 162.067 80.42C162.269 80.4292 162.47 80.4475 162.635 80.5299C163.157 80.7955 163.496 81.4641 163.752 81.9495C163.826 82.096 163.862 82.1876 163.899 82.2609C163.936 82.3433 163.981 82.4532 164.009 82.4715C164.009 82.4715 164.064 82.4898 164.201 82.4532C164.641 82.3616 165.163 82.0686 165.63 81.8213C165.795 81.7297 165.96 81.6473 166.106 81.574C166.518 81.3634 166.866 81.052 167.233 80.7223C167.663 80.3285 168.112 79.9346 168.689 79.6782C168.753 79.6507 168.799 79.6233 168.835 79.6049C169.183 79.4309 169.339 79.5408 169.559 79.7515L169.623 79.8156C169.779 79.9713 169.907 80.1636 170.017 80.3468C170.063 80.42 170.108 80.4933 170.154 80.5574L170.337 80.8139C170.621 81.1893 170.905 81.574 170.997 82.1235C171.116 82.8745 171.052 83.5247 170.988 84.1658C170.951 84.5413 170.914 84.926 170.914 85.3381C170.914 87.1606 171.491 89.0381 172.05 90.8423C172.251 91.4926 172.444 92.1337 172.618 92.7656C172.819 93.5257 173.204 94.0478 173.68 94.698L173.937 95.046C174.01 95.1468 174.074 95.2475 174.147 95.3574C174.321 95.623 174.523 95.9344 174.715 96.0534C174.825 96.026 174.935 96.0077 175.063 96.0351C175.219 96.0809 175.356 96.2 175.53 96.3648C175.777 96.5938 175.988 96.8228 176.153 97.0426C176.766 97.8577 177.087 99.3963 176.995 100.257L176.977 100.44C176.886 101.274 176.757 102.538 177.151 103.261C177.371 103.664 177.847 104.259 178.186 104.498C178.305 104.58 178.36 104.58 178.36 104.58C178.369 104.552 178.424 104.342 178.47 104.214L178.534 103.994C179.111 102.29 180.769 102.702 181.309 102.84L183.727 103.444C183.828 103.472 183.928 103.499 184.038 103.536C184.304 103.618 184.579 103.701 184.78 103.664C185.018 103.627 185.275 103.499 185.54 103.371C185.852 103.215 186.172 103.06 186.529 103.014C186.951 102.959 187.427 103.041 187.857 103.115C188.05 103.151 188.233 103.179 188.398 103.197C189.561 103.316 190.605 103.527 192.024 103.93C192.482 104.058 192.913 104.067 193.407 104.085H193.563C193.884 104.095 193.939 104.021 194.167 103.728C194.232 103.646 194.305 103.563 194.378 103.463C194.515 103.307 194.653 103.124 194.799 102.941C195.111 102.528 195.44 102.107 195.834 101.805C196.036 101.649 197.025 101.091 197.51 101.164C198.28 101.283 198.847 102.565 199.324 103.756L199.415 103.994C199.525 104.25 199.598 104.516 199.681 104.781C199.772 105.074 199.855 105.34 199.965 105.597C200.075 105.835 200.249 106.027 200.45 106.219C200.578 105.349 200.707 104.479 200.844 103.609C200.972 102.794 201.128 101.979 201.284 101.164C201.357 100.77 201.439 100.376 201.503 99.9824C201.531 99.8359 201.549 99.6436 201.567 99.4329C201.613 98.8651 201.677 98.224 201.925 97.8577C202.227 97.4272 202.776 97.5646 203.188 97.6562C203.298 97.6837 203.399 97.7111 203.5 97.7203C204.141 97.821 204.773 97.9676 205.387 98.1049C205.817 98.2057 206.257 98.3064 206.696 98.3889C207.539 98.5537 208.409 98.6636 209.261 98.7643L210.195 98.8834C212.283 99.1673 255.034 104.818 260.154 105.423C262.975 105.752 265.869 105.999 268.653 106.247C270.567 106.412 272.481 106.576 274.386 106.769C277.445 107.08 280.504 107.364 283.572 107.648L287.519 108.014C287.547 107.804 287.574 107.584 287.592 107.373C287.766 105.917 287.95 104.415 288.069 102.922L288.334 99.7168C288.545 97.1158 288.765 94.5057 288.957 91.8955L288.985 91.5567H288.994C289.415 86.5653 289.836 81.574 290.267 76.5827L291.164 66.0047C291.613 60.7386 292.062 55.4817 292.483 50.2156C292.694 47.6054 292.914 45.0045 293.133 42.3943L293.381 39.4453L282.042 38.4379L269.871 37.2106C269.871 37.2106 257.553 35.8186 257.553 35.8094C257.553 35.8094 245.647 34.3349 245.381 34.2983C233.86 32.4941 222.275 31.1295 210.753 29.2978C203.628 28.1621 196.53 26.8891 189.423 25.6252C183.287 24.5262 177.179 23.299 171.061 22.0809L170.136 21.8978L165.117 20.8903L156.38 19.0312L155.263 24.2606C154.722 26.9349 154.154 29.5817 153.596 32.2285Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M215.462 71.5584H217.001V64.6313L219.785 71.5584H220.337L223.069 64.6313V71.5584H224.775V62.3864H222.517L220.157 68.6464L217.745 62.3864H215.462V71.5584ZM228.709 71.5584H230.428V63.7333H232.981V62.3864H226.156V63.7333H228.709V71.5584Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.NC = function () {
	    var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref28$color = _ref28.color,
	        color = _ref28$color === undefined ? "#6496c2" : _ref28$color,
	        _ref28$labelColor = _ref28.labelColor,
	        labelColor = _ref28$labelColor === undefined ? "white" : _ref28$labelColor,
	        _ref28$tooltip = _ref28.tooltip,
	        tooltip = _ref28$tooltip === undefined ? {} : _ref28$tooltip,
	        _ref28$labelTooltip = _ref28.labelTooltip,
	        labelTooltip = _ref28$labelTooltip === undefined ? {} : _ref28$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M664.69 231.69L664.764 231.671L667.236 236.406C667.245 236.415 668.006 237.542 668.006 237.542C668.015 237.542 668.436 238.201 668.436 238.201L668.912 238.76L669.59 239.621L670.268 240.564L671.193 242.194L671.861 243.229L671.797 243.431L670.424 241.892L669.865 240.665L669.114 240.436L668.656 239.474L667.978 238.119L667.145 236.489C667.136 236.498 666.586 235.609 666.586 235.609L666.082 235.536L665.844 234.923L666.256 235.06L666.037 234.538L665.469 233.567L665.478 233.366L665.157 233.109L664.58 231.708C664.617 231.699 664.654 231.699 664.69 231.69ZM663.243 232.431L663.436 232.505L663.646 232.367L664.297 232.404L664.159 231.8C663.866 231.864 663.573 231.928 663.28 231.983L663.243 232.431ZM650.66 234.52C654.314 233.833 658.124 233.073 662.465 232.157L662.501 232.312L663.197 233.466L663.619 233.421L663.802 233.659L663.353 233.686L664.196 234.758L664.159 234.153L664.122 233.448L664.425 233.512L664.663 234.739L666.458 237.111L667.099 238.623L667.328 239.117L667.346 239.3H667.255L666.687 239.071L666.494 238.943L666.128 238.568L665.734 238.064C665.606 237.908 663.701 238.046 663.472 238.146C662.859 238.421 662.392 239.218 661.833 239.602C661.366 239.932 660.77 240.134 660.248 240.381C659.726 240.637 659.149 240.839 658.701 241.205C658.206 241.626 657.794 242.167 657.382 242.661C656.842 242.497 656.237 242.094 655.797 242.478C655.367 242.854 655.514 243.513 655.495 244.063C656.026 244.456 657.528 243.715 658.014 243.458C658.426 243.238 658.627 242.89 659.076 242.716C659.589 242.515 659.69 242.771 660.065 243.174C660.871 242.597 661.659 241.975 662.639 241.727C663.207 241.59 663.774 241.361 664.306 241.608C664.828 241.846 664.873 242.268 665.066 242.79C665.57 241.828 666.321 240.546 667.603 241.333C668.876 242.121 669.517 244.063 669.819 245.455L669.837 245.537L669.865 246.755L669.407 247.689C668.921 247.955 668.171 247.781 667.786 248.156C667.484 248.459 667.236 248.935 667.062 249.329C666.797 249.924 666.888 250.327 666.76 250.931C666.659 251.38 666.412 251.783 666.128 252.15C665.808 252.562 665.46 253.02 664.974 253.157C664.214 253.368 663.289 253.322 662.501 253.404C661.934 253.459 661.485 253.487 660.926 253.413C660.514 253.358 659.763 253.404 659.388 253.12C659.415 253.157 659.443 253.194 659.47 253.221C659.25 253.569 659.04 253.908 658.82 254.256C659.424 254.247 660.358 254.018 660.77 254.512C661.412 255.282 660.633 256.93 660.432 257.782L660.212 258.295L659.443 259.833C659.443 259.843 659.497 259.952 659.497 259.952L659.754 260.218L660.322 260.163L661.366 259.568L661.65 258.24L662.254 259.009L662.978 259.724L663.912 259.559L663.161 258.579L664.379 258.945L664.818 260.09L663.93 261.445L663.582 261.473L663.243 261.949L663.509 262.59L665.972 258.835L667.2 256.994L667.456 257.333L666.256 258.927L665.56 260.603L664.205 262.563L662.804 265.548L662.373 266.482L662.089 265.979L661.613 265.823C660.139 265.53 658.765 265.658 657.354 266.18C656.402 266.528 655.01 267.004 654.25 267.7C654.241 267.71 649.268 272.243 649.268 272.243L646.978 275.348C645.677 277.28 645.357 279.927 645.082 282.18C645.082 282.189 644.936 283.38 644.936 283.38L644.441 283.609L644.066 283.105L642.921 282.995H642.316L641.73 283.077L640.347 283.371L638.909 283.819L638.864 283.828C638.854 283.828 637.224 284.781 637.206 284.79L637.032 284.671C632.709 281.594 628.817 278.819 624.915 275.971C622.791 274.423 620.702 272.967 618.541 271.529L618.394 271.428C618.037 271.181 617.845 271.071 617.305 271.135C616.755 271.208 616.206 271.3 615.656 271.4C615.391 271.446 615.125 271.492 614.85 271.538C614.008 271.675 613.165 271.794 612.322 271.913L611.388 272.051C609.538 272.316 607.697 272.591 605.847 272.866L604.41 273.077C604.226 273.104 604.007 273.159 603.769 273.214C603.32 273.324 602.807 273.443 602.495 273.379C602.376 273.351 602.395 272.875 602.395 272.646C602.395 272.5 602.404 272.362 602.395 272.243C602.358 271.51 602.01 271.181 601.607 270.805C601.525 270.723 601.433 270.64 601.342 270.549C601.222 270.43 601.103 270.283 600.975 270.146C600.71 269.834 600.435 269.523 600.096 269.294C599.327 268.772 598.878 269.331 598.603 269.67C598.512 269.779 598.42 269.899 598.31 269.999C598.264 270.036 598.228 270.073 598.2 270.109H598.191C598.191 270.091 598.219 270.027 598.237 269.981C598.283 269.871 598.328 269.752 598.365 269.605C598.457 269.202 598.411 268.882 598.228 268.653C598.063 268.433 597.797 268.323 597.449 268.305C596.909 268.287 596.341 268.36 595.792 268.433C595.535 268.47 595.279 268.506 595.031 268.525C593.172 268.699 591.313 268.891 589.454 269.093L587.604 269.285C586.908 269.358 586.212 269.441 585.516 269.523C583.995 269.706 582.42 269.889 580.872 269.972C580.305 269.999 579.636 269.926 579.059 270.118C578.555 270.283 578.061 270.567 577.594 270.851C577.374 270.979 577.163 271.107 576.953 271.217C576.385 271.52 575.863 271.886 575.359 272.243C574.846 272.6 574.37 272.948 573.848 273.223C573.555 273.379 573.207 273.452 572.841 273.534C572.639 273.58 572.428 273.626 572.236 273.681C571.769 273.818 571.339 274.029 570.926 274.24L570.588 274.404C570.469 274.459 570.313 274.514 570.139 274.578C569.763 274.716 569.342 274.872 569.067 275.11L564.854 275.769C560.696 276.419 556.566 276.996 552.564 277.463C552.591 277.134 552.564 276.694 552.518 276.181C552.5 275.998 552.491 275.851 552.491 275.751C552.491 275.577 552.472 275.394 552.463 275.22C552.417 274.624 552.399 274.249 552.683 273.983C552.738 273.937 552.793 273.873 552.857 273.8C553.013 273.644 553.269 273.37 553.416 273.324C553.553 273.278 553.754 273.296 553.956 273.324C554.212 273.351 554.505 273.388 554.78 273.296C555.449 273.076 555.907 272.472 556.071 271.584L556.493 269.285C556.813 269.202 557.18 268.946 557.592 268.625C557.702 268.543 557.802 268.47 557.876 268.424C558.114 268.268 558.361 268.103 558.608 267.929C559.085 267.6 559.579 267.252 560.074 267.023C560.413 266.867 560.816 266.858 561.237 266.84C561.823 266.812 562.492 266.785 563.041 266.363C563.206 266.235 563.38 266.107 563.554 265.979C564.076 265.594 564.616 265.191 565.093 264.733C565.257 264.568 565.441 264.385 565.605 264.092L565.67 263.982C565.724 263.891 565.789 263.799 565.825 263.707C565.871 263.607 565.862 263.506 565.853 263.424C565.944 263.378 566.082 263.323 566.164 263.295C566.265 263.259 566.356 263.222 566.411 263.195L567.712 262.544C567.831 262.489 567.996 262.425 568.188 262.352C568.738 262.141 569.351 261.912 569.608 261.555C569.754 261.354 569.782 261.051 569.809 260.786C569.818 260.703 569.827 260.63 569.837 260.575L570.139 259.018C570.148 258.963 570.148 258.927 570.139 258.936C570.157 258.927 570.175 258.908 570.212 258.89L570.295 258.835C570.395 258.771 570.478 258.744 570.551 258.707C570.697 258.643 570.871 258.57 571.1 258.359C571.339 258.139 571.577 257.91 571.806 257.672C572.09 257.388 572.383 257.104 572.676 256.839L572.804 256.72C572.914 256.619 573.161 256.381 573.253 256.381C573.253 256.381 573.262 256.372 573.326 256.454C573.363 256.5 573.363 256.518 573.308 256.701C573.262 256.848 573.207 257.049 573.243 257.297C573.317 257.709 573.647 258.167 574.141 258.24C574.535 258.295 574.736 258.029 574.846 257.874C574.901 257.791 574.956 257.727 575.02 257.681C575.103 257.626 575.167 257.599 575.213 257.58C575.359 257.516 575.478 257.452 575.643 257.223C575.835 256.967 575.973 256.692 576.101 256.426C576.257 256.106 576.403 255.804 576.623 255.593C577.127 255.108 577.969 254.43 578.619 254.1C578.867 253.981 579.114 254.073 579.508 254.238C579.828 254.375 580.186 254.531 580.598 254.503H580.717C580.937 254.503 581.046 254.43 581.147 254.247C581.166 254.21 581.193 254.164 581.248 254.082C581.449 253.789 581.605 253.459 581.761 253.148C581.834 253.001 581.907 252.846 581.99 252.708C582.182 252.351 582.356 251.976 582.521 251.609C582.649 251.325 582.787 251.041 582.924 250.767C583.153 250.309 583.583 249.979 584.023 249.677C584.133 249.759 584.279 249.823 584.444 249.869C584.82 249.961 585.168 249.869 585.351 249.64C585.507 249.439 585.47 249.136 585.406 248.651C585.388 248.532 585.369 248.422 585.369 248.358C585.351 247.662 585.36 246.966 585.36 246.261V245.574L586.331 245.482C590.095 245.125 593.978 244.75 597.77 244.154C602.541 243.403 632.132 238.421 636.162 237.615L637.783 237.295C641.483 236.562 645.174 235.829 648.874 235.069L650.394 234.758C650.541 234.712 650.614 234.62 650.66 234.52ZM579.874 265.97C579.865 265.905 579.856 265.86 579.856 265.86L579.874 265.97ZM673.977 248.45L673.849 247.387L673.83 247.167L673.721 246.416L673.372 245.647L673.125 245.07L672.713 244.264L672.567 244.044L672.209 243.605L672.182 243.568H672.154L672.081 243.55L672.026 243.614L672.731 245.125L672.905 245.345L673.125 245.62L673.308 246.032L673.437 246.426L673.611 247.222L673.757 248.972L673.84 250.144L673.904 251.911L673.867 252.195L672.695 253.065L671.587 253.825L671.385 253.963L671.129 254.1V254.109L670.717 254.293L669.37 255.373L668.491 256.143L668.244 256.5L668.024 257.123L668.015 257.187L668.051 257.242L668.189 257.113L668.399 256.811L668.839 256.289L669.224 255.95L670.112 255.19L670.735 254.686L670.991 254.485L671.248 254.338L672.695 253.395L673.015 253.194L673.418 253.047L673.693 252.965L673.913 252.992H674.078L674.151 252.827L674.16 251.279L674.096 250.006L673.977 248.45ZM669.27 241.269H669.059L668.885 241.306L668.775 241.407L668.784 241.443L668.857 241.572L669.883 243.055L670.002 243.147L670.652 243.266L670.707 243.257L670.771 243.128L670.579 242.442L670.332 242.02L670.011 241.681L669.764 241.489L669.508 241.37V241.361L669.27 241.269Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M621.375 260.313H622.927V253.283L627.058 260.313H628.828V251.141H627.276V257.773L623.415 251.141H621.375V260.313ZM634.949 260.441C637.129 260.441 638.694 259.325 638.964 257.118H637.296C637.117 258.414 636.219 259.055 634.949 259.055C633.255 259.055 632.268 257.837 632.268 255.772V255.669C632.268 253.616 633.319 252.359 634.936 252.359C636.257 252.359 636.937 252.988 637.129 254.207H638.861C638.656 252.051 637.027 251 634.923 251C632.37 251 630.472 252.924 630.472 255.682V255.784C630.472 258.607 632.075 260.441 634.949 260.441Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.ND = function () {
	    var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref29$color = _ref29.color,
	        color = _ref29$color === undefined ? "#6496c2" : _ref29$color,
	        _ref29$labelColor = _ref29.labelColor,
	        labelColor = _ref29$labelColor === undefined ? "white" : _ref29$labelColor,
	        _ref29$tooltip = _ref29.tooltip,
	        tooltip = _ref29$tooltip === undefined ? {} : _ref29$tooltip,
	        _ref29$labelTooltip = _ref29.labelTooltip,
	        labelTooltip = _ref29$labelTooltip === undefined ? {} : _ref29$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M293.189 50.3072C292.767 55.5733 292.319 60.8394 291.87 66.0963L290.972 76.6743C290.542 81.6748 290.121 86.6753 289.699 91.6758L290.349 91.7307C296.165 92.1886 303.034 92.729 309.884 93.2052C315.279 93.5807 320.774 93.9196 326.69 94.2493C333.119 94.6064 338.449 94.8537 343.45 95.046C347.269 95.1926 351.088 95.3116 354.916 95.4399C357.471 95.5223 360.027 95.6047 362.591 95.6963C367.134 95.852 371.759 95.8886 376.228 95.9253C377.428 95.9344 378.618 95.9436 379.809 95.9527C379.8 95.8428 379.772 95.7329 379.754 95.6139C379.699 95.3025 379.644 94.9819 379.699 94.6614C379.726 94.4782 379.781 94.3134 379.846 94.1577C379.91 93.9837 379.965 93.8371 379.965 93.6631C379.965 93.1228 379.864 92.5458 379.772 91.978C379.726 91.6941 379.681 91.4102 379.644 91.1354L379.607 90.8607C379.543 90.302 379.479 89.8258 379.278 89.3312L378.829 88.2505C378.527 87.5361 378.234 86.8218 377.941 86.1074L377.794 85.7594C377.583 85.2557 377.364 84.7337 377.272 84.1933C377.18 83.6163 377.235 82.9936 377.299 82.3891C377.318 82.1876 377.336 81.9861 377.345 81.803C377.364 81.5649 377.382 81.3267 377.409 81.0703C377.473 80.4475 377.547 79.8156 377.428 79.2753C377.364 79.0005 377.272 78.7258 377.18 78.451C377.034 78.0297 376.887 77.5901 376.842 77.1139C376.75 76.1248 376.741 75.099 376.732 74.1099C376.722 73.4322 376.722 72.7545 376.686 72.0859C376.594 70.0619 376.439 68.3126 376.2 66.5817C376.091 65.7757 375.715 65.0248 375.312 64.2188C375.046 63.6785 374.772 63.129 374.579 62.552C374.341 61.8376 374.149 61.105 373.966 60.3906C373.874 60.0426 373.783 59.6946 373.691 59.3465C373.645 59.1908 373.59 59.0168 373.545 58.852C373.37 58.3116 373.178 57.7072 373.206 57.1394C373.224 56.7822 373.316 56.4433 373.407 56.1228C373.499 55.7839 373.59 55.4634 373.581 55.1337C373.572 54.7673 373.581 54.3918 373.59 54.0163C373.609 53.2837 373.618 52.5235 373.526 51.8275C373.517 51.7542 373.517 51.6809 373.526 51.6168C373.535 51.5802 373.508 51.5619 373.48 51.5344C373.37 51.452 373.224 51.3329 373.178 51.1406C373.114 50.8658 373.242 50.5361 373.435 50.1057C373.48 49.9958 373.526 49.9042 373.545 49.8309C373.581 49.721 373.636 49.5745 373.7 49.428C373.81 49.1807 373.947 48.8327 373.947 48.6587C373.938 48.5213 373.801 48.2649 373.691 48.0634C373.599 47.9077 373.517 47.7611 373.471 47.6329C373.242 47.0376 373.059 46.4149 372.885 45.8196C372.821 45.5814 372.748 45.3525 372.674 45.1235C372.647 45.0319 372.61 44.9404 372.574 44.8304C372.418 44.3908 372.226 43.8322 372.326 43.3376L364.349 43.2186C350.639 42.8797 336.938 42.321 323.237 41.625L317.165 41.2587C317.165 41.2587 306.532 40.526 306.532 40.5351L294.068 39.5277L293.821 42.4767C293.619 45.096 293.399 47.697 293.189 50.3072Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M323.583 70.6421H325.135V63.6124L329.266 70.6421H331.036V61.4701H329.484V68.1022L325.623 61.4701H323.583V70.6421ZM333.141 70.6421H335.899C339.119 70.6421 340.671 68.7436 340.671 66.0753V65.9599C340.671 63.2917 339.119 61.4701 335.925 61.4701H333.141V70.6421ZM334.848 69.2952V62.817H335.835C337.99 62.817 338.888 64.01 338.888 65.9855V66.0882C338.888 68.115 337.901 69.2952 335.848 69.2952H334.848Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.NE = function () {
	    var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref30$color = _ref30.color,
	        color = _ref30$color === undefined ? "#6496c2" : _ref30$color,
	        _ref30$labelColor = _ref30.labelColor,
	        labelColor = _ref30$labelColor === undefined ? "white" : _ref30$labelColor,
	        _ref30$tooltip = _ref30.tooltip,
	        tooltip = _ref30$tooltip === undefined ? {} : _ref30$tooltip,
	        _ref30$labelTooltip = _ref30.labelTooltip,
	        labelTooltip = _ref30$labelTooltip === undefined ? {} : _ref30$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M308.236 181.776L308.089 184.075C307.979 185.852 307.86 187.619 307.741 189.396L307.659 190.66C307.549 192.299 307.448 193.939 307.347 195.578L307.246 197.172C310.351 197.364 313.465 197.538 316.57 197.712C319.143 197.858 321.708 198.005 324.281 198.161C330.051 198.509 353.103 199.269 359.349 199.415C364.587 199.544 370.174 199.626 376.42 199.69C381.833 199.736 387.612 199.754 394.599 199.727C394.902 199.727 395.204 199.727 395.506 199.727C395.497 199.718 395.497 199.708 395.488 199.699L394.032 197.648C393.903 197.474 393.766 197.291 393.619 197.117C393.308 196.723 392.978 196.311 392.768 195.862C392.676 195.688 392.658 195.514 392.649 195.386C392.64 195.294 392.63 195.212 392.603 195.148C392.53 194.983 392.356 194.827 392.182 194.671C391.953 194.47 391.696 194.241 391.55 193.902C391.495 193.774 391.421 193.627 391.348 193.472C391.101 192.977 390.826 192.409 390.799 191.915C390.78 191.622 390.936 191.42 391.046 191.264C391.055 191.246 391.073 191.228 391.092 191.2C391.046 191.246 390.982 191.274 390.918 191.283C390.78 191.301 390.652 191.246 390.579 191.136C390.359 190.825 390.176 190.504 390.011 190.184H389.782V189.717C389.452 189.002 389.214 188.26 388.958 187.5L388.775 186.942C388.573 186.346 388.683 185.861 388.793 185.348L388.866 185.018C389.004 184.35 388.949 184.048 388.775 183.278C388.747 183.141 388.711 183.013 388.674 182.875C388.573 182.463 388.463 182.042 388.445 181.602C388.436 181.382 388.482 181.126 388.537 180.86C388.592 180.54 388.683 180.064 388.592 179.917C388.564 179.89 388.427 179.835 388.344 179.798C388.134 179.716 387.886 179.624 387.749 179.404C387.648 179.249 387.648 179.038 387.667 178.754C387.667 178.699 387.667 178.662 387.667 178.626L387.621 177.847C387.593 177.279 387.557 176.702 387.529 176.135C387.474 175.191 387.163 174.166 386.705 173.378C386.568 173.14 386.403 172.902 386.247 172.654C385.707 171.83 385.148 170.978 385.075 169.953C385.056 169.696 385.047 169.422 385.047 169.138C385.038 168.606 385.029 168.048 384.91 167.581C384.846 167.315 384.681 167.04 384.525 166.766C384.461 166.656 384.397 166.546 384.333 166.436C383.655 165.181 383.115 164.101 382.666 162.855C382.62 162.727 382.565 162.599 382.51 162.461C382.327 162.012 382.135 161.554 382.144 161.051C382.144 160.895 382.171 160.739 382.199 160.593C382.236 160.428 382.263 160.291 382.226 160.172C382.208 160.098 382.153 160.007 382.098 159.906C382.016 159.778 381.933 159.631 381.888 159.457C381.723 158.834 381.714 157.955 381.741 157.397C381.75 157.213 381.768 156.92 381.723 156.865C381.723 156.865 381.659 156.801 381.356 156.792L381.018 156.783V156.673C380.871 156.646 380.715 156.618 380.56 156.591C379.946 156.49 379.25 156.371 378.783 156.069C378.307 155.757 377.748 154.823 377.62 154.283C377.583 154.127 377.592 153.98 377.601 153.861C377.611 153.706 377.611 153.642 377.556 153.55C377.464 153.422 377.253 153.303 377.07 153.202L376.896 153.101C376.493 152.863 376.054 152.698 375.587 152.533L374.964 152.304C374.478 152.121 374.02 151.947 373.535 151.81C373.462 151.792 373.37 151.764 373.27 151.746C372.656 151.59 371.731 151.361 371.447 150.711C371.365 150.519 371.401 150.317 371.447 150.134C371.447 150.125 371.456 150.106 371.456 150.088C371.401 150.097 371.328 150.097 371.273 150.097C371.099 150.097 370.934 150.106 370.806 150.07C370.614 150.015 370.476 149.951 370.357 149.887C370.174 149.795 370.11 149.758 369.881 149.804C369.789 149.823 369.679 149.877 369.56 149.932C369.395 150.015 369.212 150.106 369.002 150.134C368.791 150.161 368.59 150.097 368.416 150.051C368.306 150.015 368.187 149.978 368.113 149.987C368.077 149.987 367.976 150.042 367.912 150.079C367.729 150.18 367.509 150.299 367.252 150.253C366.95 150.198 366.831 150.024 366.767 149.932C366.776 149.923 366.758 149.914 366.675 149.923C366.566 149.932 366.52 149.969 366.364 150.125L366.245 150.253C366.172 150.326 366.071 150.354 365.97 150.345C365.869 150.335 365.778 150.28 365.723 150.198L365.668 150.116C365.613 150.033 365.439 149.777 365.357 149.758C365.274 149.96 365.137 150.299 364.642 150.253C364.331 150.226 364.166 150.033 364.047 149.914C363.992 149.85 363.955 149.813 363.928 149.804C363.818 149.786 363.772 149.786 363.745 149.786C363.754 149.795 363.745 149.841 363.726 149.868C363.708 149.923 363.681 149.978 363.653 150.033C363.516 150.317 363.003 151.279 362.206 151.563C361.144 151.938 360.347 151.27 359.642 150.683C359.303 150.4 358.982 150.134 358.653 149.987L358.488 149.914C357.957 149.676 357.49 149.465 357.022 149.044L355.869 148.009C355.795 147.945 355.713 147.863 355.63 147.771C355.502 147.634 355.328 147.441 355.218 147.405C355.09 147.35 354.824 147.368 354.614 147.368C354.504 147.377 354.394 147.377 354.293 147.377L351.692 147.304C345.739 147.13 339.795 146.91 334.044 146.663C328.586 146.425 306.569 145.124 301.01 144.721C296.403 144.392 291.714 144.007 287.19 143.641L285.22 143.476L283.627 162.278C283.389 165.062 283.151 167.855 282.922 170.64C282.775 172.38 282.629 174.12 282.473 175.86L282.308 177.719C285.056 177.948 287.803 178.177 290.56 178.378C294.809 178.699 299.434 179.029 304.7 179.377L307.054 179.532C307.091 179.532 307.155 179.532 307.237 179.532C307.823 179.523 308.117 179.542 308.291 179.725C308.492 179.963 308.465 180.402 308.309 181.382C308.263 181.584 308.245 181.712 308.236 181.776Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M331.83 176.015H333.382V168.985L337.513 176.015H339.283V166.843H337.731V173.475L333.869 166.843H331.83V176.015ZM341.388 176.015H347.34V174.668H343.094V171.987H346.327V170.704H343.094V168.19H347.122V166.843H341.388V176.015Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.NH = function () {
	    var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref31$color = _ref31.color,
	        color = _ref31$color === undefined ? "#6496c2" : _ref31$color,
	        _ref31$labelColor = _ref31.labelColor,
	        labelColor = _ref31$labelColor === undefined ? "white" : _ref31$labelColor,
	        _ref31$tooltip = _ref31.tooltip,
	        tooltip = _ref31$tooltip === undefined ? {} : _ref31$tooltip,
	        _ref31$labelTooltip = _ref31.labelTooltip,
	        labelTooltip = _ref31$labelTooltip === undefined ? {} : _ref31$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M703.66 104.15C703.156 103.994 702.579 103.829 702.295 103.508C702.02 103.197 701.984 102.767 701.947 102.345C701.919 102.043 701.901 101.723 701.773 101.576C701.581 101.338 701.077 101.1 700.674 100.917C700.518 100.843 700.372 100.779 700.243 100.706C699.602 100.367 699.135 100.074 698.897 99.2956C698.741 98.7735 698.714 98.2057 698.687 97.6562C698.677 97.4455 698.668 97.2349 698.65 97.0334C698.613 96.6213 698.485 96.2916 698.32 95.8795L698.256 95.7146C698.137 95.3941 698.009 95.0735 697.881 94.7621C697.56 93.9654 697.23 93.1411 696.974 92.2985C696.443 90.5584 695.912 88.8183 695.38 87.0782C694.327 83.6072 693.237 80.0171 692.102 76.5094C691.287 73.9908 690.316 71.0235 689.263 68.0012L689.079 68.7431L689.006 68.8072L688.466 68.9262L687.834 68.8805L687.44 68.679L687.385 68.624L687.275 68.4042L687.019 68.2668L686.881 68.3676L685.901 69.6406L685.608 72.7911L685.663 73.3314L685.975 73.9359C685.92 74.0366 685.837 74.1832 685.846 74.2381C685.865 74.3389 686.002 74.4946 686.121 74.6228C686.277 74.7968 686.433 74.9708 686.515 75.1906C686.698 75.6668 686.515 76.1889 686.35 76.6376C686.304 76.7567 686.259 76.8849 686.231 76.9948C686.194 77.1322 686.13 77.2787 686.075 77.4436C685.929 77.8191 685.737 78.3411 685.846 78.6067C685.929 78.799 686.213 79.0829 686.451 79.3119C686.616 79.4767 686.771 79.6324 686.881 79.7698L686.982 79.8889C687.129 80.072 687.293 80.2735 687.403 80.5116C687.587 80.9238 687.486 81.1527 687.358 81.3725C687.312 81.455 687.266 81.5282 687.239 81.6656C687.211 81.8121 687.239 81.9312 687.266 82.0869C687.321 82.3433 687.385 82.6547 687.174 83.0852C686.936 83.5797 686.643 84.1658 686.259 84.5871C686.075 84.7886 685.865 84.8619 685.709 84.9168C685.645 84.9443 685.59 84.9626 685.553 84.9809C685.434 85.0634 685.306 85.2282 685.187 85.4022C685.123 85.4847 685.059 85.5762 684.995 85.6495C684.683 86.025 684.253 86.2814 683.841 86.5287C683.273 86.8676 682.778 87.1606 682.623 87.7102C682.531 88.0399 682.714 88.6993 682.934 89.1389C682.952 89.1755 683.035 89.2488 683.081 89.2946C683.2 89.4045 683.319 89.5144 683.383 89.6701C683.474 89.9082 683.429 90.1555 683.383 90.3844C683.374 90.4485 683.355 90.5218 683.346 90.5859C683.484 90.6592 683.621 90.7508 683.648 90.9431C683.676 91.1171 683.603 91.2819 683.529 91.4285C683.511 91.4651 683.502 91.4926 683.493 91.5201C683.401 91.8131 683.319 92.1154 683.245 92.4176L683.2 92.5916C683.154 92.7564 683.126 92.8572 683.154 92.9121C683.255 92.9396 683.401 93.0129 683.465 93.1777C683.539 93.3426 683.511 93.5624 683.456 93.828L683.438 93.9104C683.401 94.2493 683.264 94.5149 683.136 94.753C683.016 94.9911 682.916 95.1926 682.925 95.4124C682.934 95.5956 682.952 95.7604 682.971 95.9253C683.026 96.3649 683.081 96.8228 682.833 97.3906C682.714 97.6562 682.586 97.821 682.458 97.9859C682.403 98.05 682.348 98.1233 682.293 98.2057C682.174 98.3797 682.183 98.3889 682.22 98.5262C682.247 98.627 682.275 98.746 682.284 98.9109C682.302 99.1399 682.238 99.378 682.192 99.5886C682.165 99.6802 682.146 99.7809 682.128 99.8634C682.201 99.9458 682.247 100.083 682.192 100.294C682.137 100.477 682.009 100.614 681.908 100.715C681.872 100.752 681.808 100.816 681.798 100.843C681.67 101.091 681.753 101.503 681.826 101.906C681.853 102.061 681.881 102.208 681.899 102.345C681.908 102.409 681.918 102.528 681.927 102.684C681.972 103.444 682.046 103.921 682.119 104.104C682.174 104.113 682.22 104.131 682.266 104.168C682.357 104.232 682.412 104.342 682.403 104.452C682.403 104.507 682.394 104.562 682.385 104.626C682.385 104.653 682.375 104.699 682.375 104.736C682.458 104.791 682.549 104.864 682.577 105.001C682.632 105.212 682.65 105.459 682.632 105.816C682.614 106.393 682.614 106.888 682.632 107.373C682.641 107.63 682.714 107.84 682.806 108.078C682.888 108.298 682.98 108.536 683.017 108.811C683.053 109.068 683.016 109.315 682.989 109.544C682.962 109.764 682.934 109.974 682.971 110.167C682.98 110.231 683.016 110.304 683.044 110.386C683.126 110.606 683.218 110.853 683.163 111.092C683.099 111.348 682.888 111.513 682.714 111.641C682.65 111.687 682.54 111.778 682.513 111.815C682.494 111.861 682.494 111.879 682.531 112.007C682.559 112.108 682.595 112.255 682.595 112.429C682.595 112.63 682.513 112.795 682.44 112.942C682.403 113.024 682.348 113.125 682.357 113.171C682.375 113.665 683.355 114.37 683.887 114.755C683.996 114.837 684.097 114.911 684.189 114.975C686.414 114.499 688.649 114.022 690.874 113.528C692.285 113.216 693.695 112.896 695.106 112.566C695.435 112.493 695.792 112.429 696.14 112.365C696.827 112.236 697.542 112.108 698.146 111.87C698.274 111.815 698.32 111.806 698.357 111.778C698.357 111.778 698.384 111.696 698.421 111.623L698.458 111.531C698.65 111.064 698.806 110.918 699.126 110.863C699.007 110.35 698.952 109.663 699.731 109.324C699.923 109.242 700.152 109.278 700.399 109.324C700.463 109.333 700.555 109.351 700.619 109.361C700.619 109.297 700.619 109.205 700.619 109.132C700.619 108.93 700.628 108.71 700.711 108.546C700.93 108.124 701.709 107.584 702.13 107.41C702.396 107.3 702.634 107.282 702.899 107.337C703.028 107.364 703.119 107.392 703.183 107.41C703.247 107.41 703.403 107.337 703.486 107.282L703.705 107.153L704.117 104.378L704.053 104.351C704.008 104.25 703.834 104.204 703.66 104.15Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M691.335 82.0073L673.697 59.1002", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M664.67 55.9816H666.222V48.9518L670.352 55.9816H672.123V46.8096H670.57V53.4416L666.709 46.8096H664.67V55.9816ZM674.228 55.9816H675.934V52.0819H680.052V55.9816H681.771V46.8096H680.052V50.7093H675.934V46.8096H674.228V55.9816Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "664", y: "43", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.NJ = function () {
	    var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref32$color = _ref32.color,
	        color = _ref32$color === undefined ? "#6496c2" : _ref32$color,
	        _ref32$labelColor = _ref32.labelColor,
	        labelColor = _ref32$labelColor === undefined ? "white" : _ref32$labelColor,
	        _ref32$tooltip = _ref32.tooltip,
	        tooltip = _ref32$tooltip === undefined ? {} : _ref32$tooltip,
	        _ref32$labelTooltip = _ref32.labelTooltip,
	        labelTooltip = _ref32$labelTooltip === undefined ? {} : _ref32$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M674.637 171.281L675.104 171.757L674.939 172.48L673.647 174.898L674.334 175.823L673.94 176.235L674.206 176.84L673.409 178.598L671.724 180.302L671.175 181.153L671.01 181.447L670.818 181.914L670.524 182.729L670.195 183.883V183.947L670.213 183.965L669.718 185.724L669.361 186.594L668.903 187.381L668.235 187.757L668.061 187.802L667.658 187.848L667.603 187.821L667.511 187.72L667.493 186.63L667.52 186.355L667.585 185.998L667.841 185L667.878 184.78L667.951 184.496V183.983L667.786 183.727L667.484 183.507L667.346 183.489L665.826 183.48L665.689 183.205L664.7 183.471L664.37 183.983L663.921 183.809L663.784 183.251L663.015 182.866L662.666 182.793L662.776 182.536L662.584 182.317L662.09 182.436L662.025 182.655L661.613 182.426L661.219 181.831L660.725 181.932L660.45 181.776L660.441 181.767L660.267 181.492L659.827 181.419L659.342 180.925L659.122 180.659L658.765 180.586L658.545 180.402L658.243 180.329L657.904 179.844L658.161 179.771L657.941 178.846L658.206 178.342L657.886 178.186L657.858 178.012C657.84 177.921 657.822 177.811 657.794 177.71C657.758 177.536 657.703 177.344 657.721 177.243C657.73 177.16 657.776 177.078 657.822 176.968C657.886 176.822 657.968 176.666 657.987 176.464C658.014 176.272 658.041 176.098 658.087 175.933C658.161 175.631 658.252 175.338 658.426 175.008C658.499 174.871 658.563 174.752 658.637 174.624L658.655 174.633L658.719 174.477C658.866 174.23 659.031 173.992 659.214 173.744C659.525 173.323 659.699 173.25 660.23 173.03L660.322 172.993C661.009 172.7 661.256 172.526 661.659 171.885C661.861 171.565 662.035 171.226 662.209 170.896L662.419 170.502C662.96 169.495 663.482 168.817 664.168 168.24C664.223 168.194 664.297 168.139 664.37 168.084C664.562 167.947 664.773 167.791 664.91 167.599C664.993 167.48 665.02 167.333 665.048 167.214C665.057 167.178 665.066 167.132 665.048 167.123C665.093 167.114 665.158 167.104 665.203 167.095C665.35 167.068 665.524 167.05 665.67 166.967C665.854 166.866 666.018 166.711 666.156 166.573C666.22 166.518 666.275 166.463 666.33 166.408C666.412 166.344 666.458 166.244 666.449 166.143C666.449 166.042 666.394 165.941 666.312 165.877L663.427 163.67C663.17 163.469 662.85 163.295 662.547 163.13C662.144 162.901 661.723 162.672 661.485 162.406C661.293 162.186 661.128 161.793 660.99 161.445C660.917 161.252 660.835 161.069 660.762 160.913C660.514 160.41 660.377 160.336 659.846 160.126C659.736 160.08 659.589 160.034 659.443 159.988C659.131 159.888 658.738 159.759 658.591 159.595C658.444 159.439 658.371 159.063 658.316 158.789C658.298 158.688 658.28 158.605 658.261 158.523L658.197 158.276C658.106 157.919 657.996 157.516 658.032 157.223C658.051 157.067 658.078 157.012 658.087 157.049C658.197 157.039 658.371 157.03 658.564 156.929C659.269 156.554 659.543 154.997 659.26 154.429C659.141 154.182 658.893 153.971 658.664 153.761C658.463 153.587 658.197 153.349 658.179 153.257C658.197 153.138 658.444 152.772 658.554 152.616C658.628 152.497 658.692 152.405 658.728 152.341C658.811 152.176 658.902 152.021 659.003 151.856C659.195 151.517 659.397 151.169 659.553 150.802C659.617 150.656 659.736 150.454 659.846 150.244L659.992 149.978C660.322 149.383 660.359 148.87 660.395 148.375C660.414 148.11 660.432 147.863 660.496 147.588C660.688 146.736 661.091 146.297 661.861 145.738C662.062 145.839 662.291 145.93 662.584 146.031L665.68 147.112C666.806 147.505 667.969 147.908 669.132 148.256L672.2 149.172C672.255 149.191 672.356 149.209 672.466 149.227C672.576 149.246 672.823 149.301 672.942 149.337C672.951 149.465 672.933 149.722 672.924 149.841C672.915 149.951 672.906 150.051 672.906 150.106C672.906 150.729 672.787 151.325 672.658 151.956L672.594 152.286C672.466 152.964 672.429 153.632 672.402 154.292L672.374 154.915L672.301 154.997L672.393 155.226L672.136 155.336C671.999 155.4 671.834 155.437 671.678 155.473C671.459 155.528 671.23 155.592 671.019 155.693C670.442 155.986 670.524 156.371 670.589 156.646C670.598 156.71 670.616 156.774 670.625 156.856L670.643 156.957C670.653 157.039 670.689 157.232 670.634 157.296C670.57 157.332 670.479 157.378 670.424 157.488C670.259 157.8 670.286 158.056 670.305 158.257C670.314 158.376 670.277 158.761 670.25 158.889L670.515 159.091L670.506 159.182L670.616 159.356L670.882 159.421L671.23 159.558C671.239 159.549 671.44 159.659 671.44 159.659L671.678 159.247L672.246 159.237L672.951 159.301L673.647 159.622L674.325 159.631L674.133 158.889L673.986 158.871L673.977 158.743L673.757 158.615L673.748 158.505L673.821 158.422L673.858 158.367H673.95L674.133 158.45L674.609 159.082L674.902 160.254L675.003 160.666L675.012 160.694L675.122 161.509L675.149 161.857L675.168 162.608L675.131 165.099L675.113 165.117L675.131 165.108V165.428L675.204 166.848L675.223 167.251L675.323 168.451L674.801 170.227L674.637 171.281ZM671.862 156.124C671.669 156.169 671.486 156.224 671.349 156.298C671.257 156.343 671.239 156.371 671.23 156.371C671.23 156.371 671.257 156.435 671.266 156.49C671.285 156.572 671.303 156.655 671.312 156.755L671.321 156.847C671.367 157.113 671.394 157.351 671.312 157.543C671.239 157.717 671.101 157.809 671.01 157.864C670.973 157.964 670.982 158.038 671.001 158.175C671.019 158.312 671.028 158.486 670.992 158.697L671.129 158.642L671.22 158.496L671.34 158.422L671.532 158.221H671.587L671.779 158.047L671.907 157.873C671.907 157.873 671.962 157.854 671.962 157.864L672.017 157.873L672.329 157.561L672.814 156.609L672.851 156.417L672.585 156.114L672.521 155.904L672.411 155.95C672.246 156.023 672.054 156.069 671.862 156.124Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M682.86 173.636L671.635 168.825", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M685.744 178.305H687.296V171.276L691.427 178.305H693.197V169.133H691.645V175.765L687.784 169.133H685.744V178.305ZM696.149 178.421C697.843 178.421 698.984 177.51 698.984 175.522V169.133H697.265V175.483C697.265 176.612 696.727 177.048 695.893 177.048C695.354 177.048 695.033 176.946 694.713 176.817V178.151C695.008 178.305 695.392 178.421 696.149 178.421Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "685", y: "168", width: "15", height: "13", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.NM = function () {
	    var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref33$color = _ref33.color,
	        color = _ref33$color === undefined ? "#6496c2" : _ref33$color,
	        _ref33$labelColor = _ref33.labelColor,
	        labelColor = _ref33$labelColor === undefined ? "white" : _ref33$labelColor,
	        _ref33$tooltip = _ref33.tooltip,
	        tooltip = _ref33$tooltip === undefined ? {} : _ref33$tooltip,
	        _ref33$labelTooltip = _ref33.labelTooltip,
	        labelTooltip = _ref33$labelTooltip === undefined ? {} : _ref33$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M230.389 334.41C230.179 334.163 230.005 333.952 229.968 333.604C229.941 333.293 229.986 333.147 230.16 332.991C230.188 332.963 230.206 332.954 230.234 332.881C230.279 332.78 230.325 332.46 230.325 332.286C230.197 332.203 230.041 332.093 230.032 331.874C230.023 331.608 230.27 331.434 230.362 331.37C230.673 331.159 231.149 331.214 231.736 331.315C231.845 331.333 231.937 331.351 232.01 331.361L239.859 332.185C243.275 332.542 246.691 332.89 250.107 333.238L255.035 333.742C258.496 334.09 262.013 334.401 265.42 334.694L268.726 334.987C271.538 335.235 274.35 335.445 277.161 335.665C278.755 335.784 280.339 335.903 281.933 336.031C282.024 336.041 282.125 336.059 282.235 336.068C282.409 336.096 282.583 336.123 282.693 336.105L282.757 336.096C282.757 336.05 282.766 335.995 282.766 335.94L283.7 323.365C284.039 318.768 284.47 314.106 284.891 309.591L284.937 309.097C285.303 305.103 285.669 300.726 286.054 295.725C286.43 290.789 286.805 285.862 287.181 280.925L287.529 276.355C287.785 272.921 288.051 269.477 288.307 266.034C288.38 264.999 288.463 263.955 288.536 262.92C288.618 261.729 288.71 260.529 288.802 259.339C288.811 259.275 288.802 259.183 288.802 259.092C288.802 258.826 288.802 258.515 288.902 258.286C289.012 258.048 289.205 257.947 289.342 257.883C289.397 257.855 289.443 257.837 289.47 257.809L289.489 257.58H289.516C289.516 257.507 289.516 257.425 289.516 257.379C289.516 257.287 289.516 257.205 289.525 257.141L290.084 249.549C289.608 249.512 289.131 249.475 288.655 249.439L287.41 249.347C282.107 248.953 276.621 248.541 271.236 248.092C265.613 247.625 259.925 247.048 254.906 246.535L252.892 246.334C248.505 245.885 243.962 245.427 239.511 244.942C237.945 244.768 236.361 244.548 234.831 244.337C233.494 244.154 232.157 243.962 230.811 243.806C229.043 243.596 227.275 243.376 225.508 243.156L223.612 242.918C218.529 242.286 213.107 241.59 207.777 240.866C207.237 244.704 206.706 248.55 206.174 252.397L198.133 310.452C197.657 313.868 197.19 317.284 196.714 320.691L194.149 338.861C198.161 339.42 202.172 339.96 206.184 340.482L206.559 337.607L207.191 332.698L220.553 334.355C222.486 334.575 224.427 334.804 226.36 335.024C227.66 335.171 228.951 335.326 230.243 335.473C230.609 335.519 231.094 335.482 231.433 335.61C231.443 335.61 231.442 335.619 231.452 335.619L231.287 335.4C230.985 335.07 230.673 334.749 230.389 334.41Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M233.788 295.131H235.34V288.102L239.471 295.131H241.241V285.959H239.689V292.591L235.827 285.959H233.788V295.131ZM243.346 295.131H244.885V288.204L247.669 295.131H248.221L250.953 288.204V295.131H252.659V285.959H250.401L248.041 292.219L245.629 285.959H243.346V295.131Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.NV = function () {
	    var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref34$color = _ref34.color,
	        color = _ref34$color === undefined ? "#6496c2" : _ref34$color,
	        _ref34$labelColor = _ref34.labelColor,
	        labelColor = _ref34$labelColor === undefined ? "white" : _ref34$labelColor,
	        _ref34$tooltip = _ref34.tooltip,
	        tooltip = _ref34$tooltip === undefined ? {} : _ref34$tooltip,
	        _ref34$labelTooltip = _ref34.labelTooltip,
	        labelTooltip = _ref34$labelTooltip === undefined ? {} : _ref34$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M148.165 181.511C150.454 169.751 152.442 159.521 152.762 157.845L155.537 143.43C150.601 142.45 131.057 138.375 125.186 137.129C122.494 136.561 119.765 135.92 117.136 135.297C115.616 134.94 114.095 134.583 112.575 134.235C107.291 133.035 101.997 131.826 96.7128 130.608C93.2784 129.821 89.8165 128.914 86.4645 128.044C84.99 127.659 83.5155 127.275 82.041 126.899L81.3084 126.707L80.4017 130.205C78.5608 137.312 76.7658 144.273 74.9891 151.325C73.4046 157.625 71.7378 163.817 70.0343 170.127C69.5032 172.077 69.091 173.699 68.7247 175.219C68.4591 176.327 68.8071 177.811 69.6039 179.001L71.0235 181.126C72.4613 183.278 73.89 185.44 75.3371 187.583C77.3519 190.577 79.3485 193.581 81.345 196.585C83.0485 199.15 84.7519 201.714 86.4737 204.278C88.1314 206.751 89.7707 209.224 91.4193 211.697C93.5715 214.939 95.7329 218.172 97.9034 221.405C100.34 225.031 102.767 228.667 105.184 232.312C106.457 234.226 107.73 236.131 109.003 238.036C111.119 241.205 113.244 244.383 115.368 247.552L122.997 258.954C123.171 259.22 123.373 259.485 123.584 259.76C123.95 260.255 124.325 260.749 124.609 261.29C124.655 261.225 124.692 261.161 124.738 261.097C125.177 260.438 125.626 259.76 125.736 259.055C125.946 257.736 125.827 256.463 125.699 255.126C125.626 254.375 125.553 253.606 125.544 252.827C125.516 251.17 125.681 249.466 125.837 247.818C125.901 247.14 125.965 246.462 126.011 245.794L126.029 245.51C126.047 245.235 126.066 244.951 126.093 244.676C126.102 244.539 126.111 244.383 126.111 244.218C126.12 243.779 126.13 243.275 126.294 242.918C126.743 241.956 128.85 241.965 129.39 242.029C130.077 242.103 131.762 242.35 132.44 243.101C132.715 243.403 132.852 243.825 132.98 244.237C133.145 244.731 133.292 245.198 133.649 245.317C134.4 245.583 134.674 245.244 135.187 244.502C135.261 244.392 135.343 244.282 135.425 244.173C135.526 244.035 135.645 243.898 135.773 243.751C136.012 243.467 136.268 243.174 136.378 242.909C136.497 242.616 136.552 242.231 136.598 241.846C136.625 241.645 136.653 241.452 136.68 241.269C136.937 239.96 137.166 238.641 137.404 237.331C137.55 236.525 137.697 235.719 137.843 234.913C138.384 231.992 138.942 229.07 139.51 226.149C139.849 224.372 140.197 222.595 140.536 220.809C140.966 218.511 144.785 198.857 148.165 181.511Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M101.843 178.763H103.395V171.734L107.526 178.763H109.296V169.591H107.744V176.224L103.883 169.591H101.843V178.763ZM113.736 178.763H115.711L118.816 169.591H117.212L114.813 177.032L112.427 169.591H110.644L113.736 178.763Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.NY = function () {
	    var _ref35 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref35$color = _ref35.color,
	        color = _ref35$color === undefined ? "#6496c2" : _ref35$color,
	        _ref35$labelColor = _ref35.labelColor,
	        labelColor = _ref35$labelColor === undefined ? "white" : _ref35$labelColor,
	        _ref35$tooltip = _ref35.tooltip,
	        tooltip = _ref35$tooltip === undefined ? {} : _ref35$tooltip,
	        _ref35$labelTooltip = _ref35.labelTooltip,
	        labelTooltip = _ref35$labelTooltip === undefined ? {} : _ref35$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M675.168 146.242C675.232 146.177 675.314 146.113 675.397 146.022C675.909 145.5 676.413 144.978 676.926 144.447L677.21 144.153C677.182 144.135 677.155 144.108 677.127 144.089C676.761 143.796 676.349 143.457 676.157 143.045C675.992 142.679 675.946 142.221 675.9 141.781C675.882 141.598 675.864 141.424 675.836 141.269L675.149 137.266C674.856 135.581 674.554 133.896 674.252 132.22L673.885 130.205C673.867 130.196 673.858 130.187 673.84 130.178C673.574 130.004 673.492 129.665 673.446 129.39C673.354 128.85 673.4 128.245 673.455 127.668C673.473 127.403 673.501 127.155 673.501 126.917L673.702 119.059C673.702 118.968 673.693 118.83 673.684 118.684C673.656 118.345 673.647 118.043 673.675 117.796C673.629 117.777 673.574 117.759 673.528 117.731C673.134 117.502 672.869 116.907 672.878 116.523C672.878 116.303 672.988 116.12 673.07 115.973C673.116 115.891 673.171 115.799 673.171 115.753C673.18 115.598 673.107 115.35 673.043 115.14C673.006 115.011 672.97 114.892 672.942 114.782C672.768 113.967 672.603 113.152 672.438 112.337L672.035 110.341C671.861 109.498 671.697 108.665 671.523 107.831C671.449 107.474 671.385 107.108 671.321 106.732C671.184 105.954 671.046 105.148 670.799 104.443C670.634 103.975 670.543 103.838 670.515 103.801C670.524 103.811 670.488 103.811 670.46 103.811C670.35 103.801 670.195 103.801 670.048 103.71C669.883 103.6 669.819 103.444 669.764 103.325C669.746 103.289 669.727 103.234 669.718 103.225C669.654 103.17 669.416 103.115 669.352 103.151C669.37 103.179 669.379 103.49 669.379 103.627C669.379 103.728 669.389 103.82 669.379 103.884C669.379 103.994 669.315 104.104 669.224 104.159C669.132 104.223 669.013 104.232 668.903 104.186C667.887 103.765 668.07 102.574 668.198 101.787L668.216 101.686C668.235 101.558 668.262 101.439 668.29 101.32C668.354 101.008 668.409 100.761 668.317 100.504C668.253 100.312 668.143 100.12 668.015 99.9183C667.932 99.7718 667.841 99.6253 667.777 99.4787C667.31 98.5079 666.907 97.4913 666.513 96.5022L666.467 96.3923C666.22 95.7696 666.229 95.1285 666.238 94.5148L666.247 94.0752C666.247 93.6723 666.247 93.2876 666.385 92.848C666.421 92.7106 666.476 92.5733 666.531 92.4451C666.641 92.1611 666.733 91.9139 666.714 91.6757C666.696 91.4743 666.604 91.2636 666.513 91.0347C666.403 90.7691 666.284 90.4943 666.256 90.1921C666.238 89.9356 666.293 89.6884 666.339 89.4594C666.385 89.2671 666.421 89.0748 666.412 88.9191C666.348 88.2139 665.835 87.7376 665.295 87.2339L665.231 87.1698C664.498 86.4829 664.498 85.2832 664.498 84.4955C664.498 84.3215 664.535 84.1017 664.562 83.8819C664.608 83.598 664.663 83.2408 664.599 83.076C664.562 82.9752 664.498 82.9295 664.361 82.8379C664.159 82.7005 663.848 82.4899 663.793 81.9587C663.765 81.6656 663.829 81.4092 663.875 81.1802C663.921 80.9604 663.967 80.7681 663.939 80.5666C663.921 80.4475 663.829 80.3193 663.729 80.1819C663.61 80.0171 663.472 79.8064 663.436 79.55L660.395 80.3926L657.409 81.1527L655.596 81.6748L655.45 81.7206L654.176 82.096L652.436 82.4899L647.463 83.4332L647.143 83.4515L646.218 83.5156L645.916 83.5614L644.285 84.5047L644.056 84.6604L639.615 89.7158L639.047 90.4943L637.096 93.5166L636.455 94.579L636.098 95.449L635.713 96.7495L633.726 98.453L630.942 101.411L630.649 102.648L630.63 103.032L630.639 103.234L630.823 103.728L632.004 104.571L632.755 104.891L633.817 104.983L633.918 105.01L634.001 105.12L634.275 105.816L634.303 106.082L634.239 106.174L634.001 106.677L633.332 107.117L632.883 107.144L632.572 107.621L633.387 107.95L634.193 110.002L634.349 110.496L634.495 111.348L634.532 111.797L634.504 112.062L634.458 112.346L634.367 112.575L634.303 112.658L633.598 113.097L633.185 113.207L633.002 113.216L632.663 113.07L632.16 113.225L632.086 113.271L630.548 114.892C630.548 114.892 629.962 115.543 629.962 115.552C629.962 115.552 628.945 117.081 628.945 117.09L628.46 117.64L628.167 117.86L626.353 118.922L626.28 118.94L625.337 119.114L624.897 119.032H624.32L623.926 119.114L621.829 119.655L621.087 119.856L619.255 120.983L619.045 121.01L618.697 120.946L617.625 120.506L617.534 120.461L616.938 120.131L615.638 119.82L613.632 119.783L613.11 119.856L607.267 120.845H606.937L606.232 121.074L605.188 121.477L602.834 122.622L600.059 124.106L600.646 127.046L600.792 127.302L601.195 127.384V127.394L601.424 128.227L601.525 128.612L601.662 128.758L602.202 128.987L602.743 129.079L602.935 129.207L603.1 129.418L603.814 130.709L604.272 131.716V131.854L604.126 132.128L603.604 132.815L603.292 132.962L602.45 133.649L602.111 133.942L601.561 135.38L601.406 135.828L601.378 136.195L600.16 137.083L598.915 138.063L598.347 138.796L598.127 139.281L597.871 139.629L596.845 140.655L595.737 141.699L594.912 142.395L594.784 142.487V142.496C594.885 143.128 594.995 143.76 595.105 144.392L595.334 145.692C595.361 145.839 595.37 145.967 595.379 146.123C595.398 146.315 595.425 146.718 595.48 146.901C595.7 146.901 596.359 146.745 596.643 146.672C596.845 146.617 597.019 146.571 597.129 146.553C598.328 146.342 599.528 146.123 600.728 145.912L602.496 145.6C604.437 145.252 606.379 144.895 608.311 144.538L610.647 144.108C617.47 142.853 624.32 141.479 630.117 140.298C637.508 138.796 643.141 137.624 648.379 136.488L649.909 136.149C650.77 135.957 651.337 135.828 652.171 136.625C652.446 136.891 652.565 137.184 652.675 137.459C652.72 137.569 652.757 137.678 652.821 137.788C652.858 137.871 652.885 137.917 652.903 137.953C652.931 137.953 652.958 137.953 652.995 137.944L653.142 137.935C653.206 137.935 653.279 137.926 653.371 137.907C653.719 137.862 654.122 137.816 654.387 137.99C654.607 138.136 654.744 138.429 654.918 138.823C654.964 138.924 655.001 139.006 655.028 139.061C655.23 139.428 655.431 139.831 655.633 140.234C656.146 141.269 656.677 142.34 657.4 143.045C657.84 143.467 658.554 143.961 659.177 144.117C659.406 144.172 659.644 144.144 659.891 144.108C660.313 144.053 660.835 143.97 661.311 144.437C661.522 144.648 661.686 144.795 661.851 144.914H661.86L661.87 144.932C662.126 145.115 662.392 145.234 662.84 145.39L665.863 146.443C667.053 146.855 668.207 147.267 669.361 147.606L672.429 148.522C672.475 148.531 672.539 148.55 672.631 148.568C673.07 148.65 673.373 148.724 673.528 148.916C673.693 149.117 673.684 149.447 673.638 149.923C673.629 150.015 673.62 150.088 673.62 150.134C673.62 150.821 673.492 151.48 673.354 152.121L673.29 152.442C673.171 153.065 673.144 153.687 673.116 154.347L673.025 154.924L673.052 154.896L673.043 154.933L673.025 154.96L672.988 155.189L673.07 155.336L672.832 155.876L673.015 156.343L673.208 156.334L673.492 156.435V156.609L673.244 156.691L673.253 156.874L673.675 156.829L674.545 156.472L675.287 156.27L674.902 156.609L674.536 156.911L674.545 157.158L675.039 156.82L675.772 156.288L676.55 155.785H676.706L676.779 155.739L676.761 155.821L677.347 155.739L678.364 155.492L679.014 155.281V155.043L678.547 155.153L678.364 155.308L678.135 155.318L677.485 155.592L676.944 155.638L677.521 155.336L677.704 155.299L678.501 154.905L678.95 154.786L679.216 154.924L679.802 154.466L680.012 154.319L680.177 154.219L680.076 154.09L679.866 153.907L680.388 153.715L680.653 153.559L681.35 153.257L682.375 152.607L682.787 151.984L682.971 152.121L683.886 152.094L683.96 151.608L684.766 151.499L685.352 150.967L685.782 150.702L686.35 150.711L686.524 150.345L686.991 150.271L687.11 150.482L687.504 150.335L687.724 150.07L687.989 149.923L688.136 149.511L688.63 149.465L688.914 148.907L689.345 148.989L689.729 148.742L689.885 148.824L688.814 149.566L688.869 149.621L690.114 148.833L691.488 147.908L691.763 147.753L691.955 147.597L691.927 147.515L692.01 147.267H691.9L691.708 147.478L691.607 147.45L691.644 147.038L691.561 146.928L691.873 146.809L692.276 146.819L692.34 147.057L692.001 147.469L692.047 147.551L692.917 146.938L696.03 144.236L697.413 143.091L698.741 141.983L698.906 141.607L698.228 141.543L697.633 141.992L697.551 142.514L697.349 142.377L696.965 143.064L696.653 143.155L696.369 143.457L696.223 143.76H696.03L695.554 143.338L695.49 143.027L695.124 142.89L694.84 143.348L694.217 143.256L694.199 143.87L694.025 143.924L693.942 144.135L693.603 144.199L693.274 143.696L693.036 143.815L693.292 144.318L692.688 144.529L692.431 145.353L692.01 145.71L691.882 146.351L691.488 146.681L690.535 146.608L689.958 146.718L689.995 146.434L690.334 146.351L690.618 145.857L690.691 145.454L691.305 145.06L691.378 144.694L691.854 144.941L691.616 144.382L691.708 144.126L692.303 144.007L692.294 143.778L691.836 143.796L692.101 143.21L692.385 142.743L692.55 142.368L692.816 142.02L693.201 142.303L693.594 141.919L693.658 141.461L693.127 141.498L692.569 142.01L692.239 142.075L691.909 143.036L691.369 143.283L691.103 143.888L690.572 144.3L689.958 145.317L688.612 145.921L687.632 146.315L686.121 146.699L684.28 147.157L683.245 147.286L682.705 147.57L682.971 148.201L682.137 148.815L681.093 148.669L680.489 148.797L679.994 148.586L679.692 148.495L679.765 149.108L680.397 148.98L680.461 149.163L679.5 149.337L679.371 148.998L678.666 148.925L678.556 149.2L679.353 150.244L679.106 150.161L678.868 150.006L678.794 149.841L678.483 149.969L678.52 149.749L678.355 149.529L678.043 149.676L677.796 149.713L677.018 150.152L676.752 150.656L677.1 151.59L676.569 150.958C676.569 150.958 676.129 150.912 676.12 150.912C675.809 150.885 675.818 151.553 676.358 151.535L676.267 151.801L675.653 151.645L675.644 152.085L675.964 152.533L675.909 152.662L675.552 152.359L675.433 152.506L675.323 152.414L675.149 152.451L674.957 152.414L674.847 152.561L674.719 152.588L674.636 152.762L674.783 153.046L674.728 153.129L674.417 152.909L674.298 152.927L674.252 153.046L674.151 153.028L674.133 152.881L673.922 152.762L673.995 152.625L674.087 152.543L674.178 152.598L674.124 152.652L674.142 152.817L674.279 152.854L674.389 152.79V152.57L674.417 152.414L674.618 152.433L674.691 152.25L674.875 152.35L674.929 152.25L675.131 152.195L675.378 152.259L675.406 152.231L675.25 152.075L675.103 151.947L675.021 151.956L674.911 151.489L675.076 151.398L675.186 151.526L675.277 151.691L675.378 151.682L675.488 151.48L675.506 151.288L675.277 151.27L675.213 151.031L676.294 149.053L675.122 147.542C674.636 146.892 674.746 146.635 675.168 146.242Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M641.762 124.703H643.315V117.673L647.445 124.703H649.215V115.531H647.663V122.163L643.802 115.531H641.762V124.703ZM653.527 124.703H655.246V120.739L658.119 115.531H656.452L654.438 119.328L652.373 115.531H650.487L653.527 120.726V124.703Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.OH = function () {
	    var _ref36 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref36$color = _ref36.color,
	        color = _ref36$color === undefined ? "#6496c2" : _ref36$color,
	        _ref36$labelColor = _ref36.labelColor,
	        labelColor = _ref36$labelColor === undefined ? "white" : _ref36$labelColor,
	        _ref36$tooltip = _ref36.tooltip,
	        tooltip = _ref36$tooltip === undefined ? {} : _ref36$tooltip,
	        _ref36$labelTooltip = _ref36.labelTooltip,
	        labelTooltip = _ref36$labelTooltip === undefined ? {} : _ref36$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M535.254 161.6L532.296 162.049C532.269 162.049 532.223 162.067 532.168 162.076C532.095 162.095 532.022 162.113 531.948 162.131C532.699 168.194 533.377 173.79 534.018 179.221C534.384 182.372 534.723 185.522 535.053 188.673C535.337 191.402 535.63 194.14 535.941 196.869C536.124 198.5 536.308 200.121 536.482 201.751C536.656 203.381 536.839 205.011 537.022 206.641C537.297 206.614 537.617 206.669 537.901 206.715C538.029 206.733 538.158 206.751 538.258 206.76L538.542 206.788C539 206.834 539.321 206.87 539.724 206.715C539.834 206.678 539.934 206.632 540.026 206.596C540.456 206.422 540.859 206.257 541.455 206.476C541.647 206.55 541.876 206.614 542.114 206.678C542.654 206.834 543.259 207.008 543.68 207.31C544.028 207.566 544.266 208.015 544.477 208.418C544.55 208.555 544.614 208.693 544.688 208.803C545.026 209.352 545.246 209.774 545.448 210.424C545.466 210.479 545.475 210.525 545.484 210.561C545.521 210.579 545.558 210.598 545.603 210.616C545.805 210.717 546.08 210.781 546.345 210.836C546.492 210.873 546.638 210.9 546.767 210.937L546.849 210.964C547.38 211.12 547.701 211.202 548.204 211.147C548.333 211.129 548.479 211.111 548.635 211.083C549.157 210.992 549.752 210.891 550.247 211.074C550.787 211.276 551.163 211.688 551.483 212.045C551.904 212.503 552.252 212.897 552.912 212.897C553.04 212.897 553.077 212.869 553.077 212.869C553.077 212.86 553.095 212.787 553.104 212.741C553.15 212.549 553.214 212.255 553.525 212.017C553.928 211.715 554.643 211.431 555.229 211.504C555.769 211.569 556.475 211.733 557.143 211.962C557.354 212.036 557.592 212.219 557.839 212.411C557.967 212.512 558.178 212.668 558.288 212.732C558.315 212.704 558.343 212.668 558.37 212.649C558.462 212.539 558.572 212.42 558.718 212.356C558.947 212.246 559.195 212.246 559.414 212.255C559.579 212.255 559.735 212.255 559.817 212.219C559.918 212.164 560.019 211.935 560.101 211.724C560.193 211.495 560.294 211.239 560.477 211.028C560.925 210.497 561.31 210.204 561.878 209.948C561.933 209.92 562.006 209.883 562.098 209.828C562.547 209.581 563.114 209.27 563.526 209.48C563.856 209.654 563.902 209.984 563.92 210.186L563.929 210.286C564.039 210.918 564.158 211.495 564.387 212.017C564.607 212.521 565.129 212.677 565.734 212.851C566.155 212.97 566.585 213.098 566.952 213.354C567.437 213.702 567.922 214.554 568.097 214.957C568.481 215.04 568.765 214.884 569.223 214.627C569.452 214.49 569.681 214.362 569.965 214.252C570.176 214.17 570.386 214.142 570.578 214.105C571.036 214.032 571.229 213.986 571.32 213.62C571.375 213.409 571.375 213.144 571.375 212.887C571.375 212.768 571.375 212.658 571.375 212.549C571.375 212.484 571.366 212.384 571.357 212.283C571.329 211.935 571.302 211.614 571.458 211.395C571.696 211.056 572.08 211.092 572.309 211.12C572.383 211.129 572.493 211.138 572.529 211.129C572.676 211.056 572.712 211.047 572.538 210.579C572.401 210.204 572.401 209.993 572.401 209.801C572.401 209.7 572.401 209.6 572.383 209.462C572.392 209.508 572.364 209.471 572.337 209.453C572.273 209.38 572.199 209.306 572.154 209.197C572.117 209.114 572.08 209.032 572.053 208.949C572.016 208.849 571.98 208.757 571.934 208.665C571.906 208.62 571.897 208.61 571.87 208.583C571.714 208.446 571.668 208.299 571.677 208.052C571.687 207.759 571.769 207.612 571.961 207.493C571.989 207.475 572.007 207.466 572.044 207.429C572.117 207.347 572.181 207.273 572.254 207.209C572.438 207.026 572.511 206.944 572.52 206.742C572.52 206.705 572.502 206.632 572.493 206.568C572.465 206.449 572.428 206.302 572.447 206.147C572.474 205.964 572.566 205.835 572.63 205.735C572.657 205.698 572.685 205.661 572.703 205.616C572.758 205.478 572.795 205.313 572.822 205.139C572.859 204.938 572.896 204.727 572.978 204.517C573.097 204.233 573.298 203.921 573.482 203.656L573.546 203.564C573.628 203.225 573.802 203.097 574.086 203.097C574.443 203.097 574.599 203.381 574.672 203.518C574.691 203.555 574.718 203.601 574.727 203.61C574.773 203.592 574.929 203.546 575.176 203.619C575.396 203.692 575.524 203.894 575.616 204.04L575.744 204.224C575.881 204.407 576.055 204.636 576.055 204.883C576.055 205.084 575.927 205.24 575.826 205.368C575.808 205.387 575.79 205.423 575.762 205.442C575.771 205.451 575.78 205.46 575.799 205.46C575.89 205.497 576.037 205.469 576.11 205.405C576.275 205.268 576.33 204.965 576.385 204.663L576.422 204.462C576.449 204.343 576.531 204.251 576.641 204.214C576.751 204.178 576.879 204.196 576.971 204.269L577.099 204.379C577.2 204.471 577.456 204.709 577.548 204.663C577.594 204.636 577.53 204.562 577.493 204.507C577.383 204.37 577.246 204.196 577.246 203.967C577.237 203.729 577.292 203.564 577.328 203.436C577.374 203.289 577.374 203.289 577.209 203.125C577.127 203.042 577.044 202.978 576.962 202.914C576.779 202.776 576.577 202.621 576.412 202.319C576.357 202.218 576.357 202.099 576.403 201.998C576.458 201.897 576.55 201.824 576.66 201.815C577.145 201.751 577.227 201.714 577.264 201.558C577.31 201.375 577.246 201.174 577.163 200.945C577.09 200.725 577.008 200.469 577.017 200.194C577.035 199.791 577.273 199.562 577.429 199.415C577.475 199.37 577.539 199.315 577.548 199.278C577.603 199.168 577.621 199.077 577.64 198.985C577.704 198.628 577.841 198.408 578.372 198.298C578.491 198.271 578.638 198.271 578.784 198.28C578.894 198.28 579.068 198.28 579.132 198.261C579.132 198.252 579.142 198.234 579.142 198.225C579.187 198.069 579.169 197.923 579.142 197.758C579.105 197.492 579.059 197.153 579.334 196.769C579.425 196.631 579.554 196.54 579.654 196.448C579.728 196.384 579.801 196.329 579.847 196.274C579.883 196.237 579.911 196.164 579.938 196.1C579.993 195.99 580.048 195.862 580.149 195.752C580.231 195.67 580.479 195.377 580.808 195.422C581.129 195.441 581.34 195.697 581.504 195.944C581.569 196.036 581.614 196.127 581.66 196.219C581.697 196.292 581.761 196.411 581.798 196.439C581.798 196.439 581.825 196.439 581.889 196.421C582.026 196.375 582.191 196.182 582.347 195.999C582.539 195.77 582.759 195.505 583.071 195.386C583.217 195.331 583.382 195.349 583.519 195.376C583.519 195.367 583.519 195.367 583.519 195.358C583.528 195.239 583.538 195.129 583.583 195.038C583.748 194.653 584.014 194.479 584.234 194.342C584.362 194.259 584.481 194.186 584.563 194.067C584.774 193.783 584.93 193.453 585.085 193.105C585.259 192.73 585.433 192.345 585.699 191.997C585.745 191.933 585.791 191.86 585.855 191.786C586.084 191.457 586.358 191.054 586.679 190.889C586.89 190.779 587.064 190.751 587.192 190.733C587.238 190.724 587.302 190.715 587.32 190.706C587.32 190.706 587.357 190.66 587.402 190.449C587.412 190.394 587.393 190.275 587.375 190.175C587.338 189.982 587.302 189.753 587.384 189.533C587.476 189.286 587.668 189.204 587.778 189.158C587.796 189.103 587.65 188.975 587.567 188.911C587.393 188.764 587.21 188.608 587.174 188.37C587.137 188.105 587.311 187.885 587.467 187.693C587.512 187.628 587.595 187.528 587.613 187.491C587.613 187.482 587.586 187.409 587.576 187.363C587.54 187.226 587.485 187.061 587.522 186.868C587.567 186.639 587.723 186.484 587.842 186.374C587.851 186.365 587.87 186.346 587.888 186.328C587.833 186.236 587.741 186.09 587.686 186.026C587.631 185.943 587.576 185.87 587.549 185.824C587.485 185.705 587.494 185.559 587.567 185.458C587.65 185.348 587.778 185.293 587.915 185.321C587.97 185.33 588.025 185.348 588.08 185.357C588.099 185.366 588.126 185.366 588.153 185.376C588.08 185.238 587.998 185.064 588.025 184.863C588.044 184.689 588.08 184.579 588.108 184.487C588.135 184.386 588.153 184.341 588.135 184.194C588.108 183.956 588.117 183.754 588.117 183.544V183.26C588.117 183.214 588.089 183.113 588.071 183.04C588.034 182.884 587.998 182.729 588.025 182.591C588.062 182.381 588.153 182.243 588.218 182.133C588.273 182.042 588.3 182.005 588.3 181.904C588.3 181.831 588.263 181.712 588.236 181.611C588.181 181.428 588.117 181.218 588.153 180.989C588.181 180.815 588.254 180.631 588.327 180.467C588.373 180.357 588.419 180.256 588.437 180.155L588.483 179.954C588.529 179.725 588.584 179.487 588.758 179.239C588.822 179.148 588.904 179.084 588.969 179.029C588.978 179.02 588.987 179.01 588.996 179.001C588.969 178.91 588.959 178.818 588.978 178.717C588.987 178.644 589.005 178.58 589.024 178.516C589.06 178.351 589.078 178.269 589.06 178.168C589.06 178.159 589.024 178.113 589.005 178.085C588.95 178.012 588.877 177.911 588.84 177.783C588.804 177.655 588.813 177.536 588.831 177.444C588.685 177.389 588.547 177.316 588.483 177.151C588.392 176.931 588.529 176.757 588.593 176.675C588.566 176.4 588.584 176.235 588.611 176.006L588.621 175.897C588.666 175.503 588.401 175.081 588.163 174.715C588.099 174.605 587.989 174.504 587.879 174.413C587.668 174.221 587.43 174.001 587.421 173.653C587.412 173.415 587.531 173.167 587.778 172.92C588.071 172.627 588.337 172.618 588.52 172.609C588.602 172.609 588.648 172.6 588.694 172.581C588.776 172.545 588.941 172.389 589.051 172.279C589.088 172.242 589.133 172.206 589.17 172.169L589.078 171.61C588.547 168.341 588.007 165.071 587.467 161.811C586.899 158.358 586.322 154.896 585.763 151.444L585.443 149.493L579.874 152.469L579.297 152.836L576.504 154.676L575.744 155.373L575.35 155.794L574.755 156.49L574.278 157.314L574.15 157.47L573.683 157.607L573.042 158.752L572.667 159.164L571.769 159.988L571.449 160.272L571.375 160.309L570.496 160.272L569.681 160.629L568.884 160.611L568.6 160.52L568.545 160.483L568.454 160.401L567.574 160.245L565.55 161.417L564.799 162.196L563.774 162.47L562.785 163.176L562.437 163.404L562.18 163.533L561.951 163.569L561.759 163.542L561.145 163.35L560.321 162.965L559.167 161.976L559.13 162.205L559.671 162.69L558.727 162.663L558.324 162.974L557.876 162.553L557.509 162.589L557.445 162.901L556.887 163.194L556.566 163.469L556.502 163.478L556.218 163.624L555.888 163.524L555.632 163.23L555.43 163.285L555.54 163.524L555.357 163.606L555.137 163.313H554.927L554.689 163.423L554.45 163.276L555.531 162.965L555.623 162.663L556.978 162.269L558.892 161.747L558.718 161.243L557.61 161.261L557.042 160.529L556.722 160.831L556.813 161.326L556.429 161.756L555.925 162.031L554.991 161.701L554.139 160.877L552.747 160.547L550.961 159.86L550.402 159.485L550.119 159.833L549.239 159.906L548.607 159.567L548.745 159.338C545.402 159.906 542.068 160.474 538.725 161.023C537.535 161.243 536.399 161.426 535.254 161.6Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M557.752 188.284C560.536 188.284 562.37 186.27 562.37 183.589V183.486C562.37 180.792 560.485 178.855 557.752 178.855C555.033 178.855 553.109 180.843 553.109 183.524V183.627C553.109 186.27 554.943 188.284 557.752 188.284ZM557.778 186.911C556.11 186.911 554.892 185.615 554.892 183.614V183.512C554.892 181.536 555.956 180.215 557.752 180.215C559.548 180.215 560.6 181.613 560.6 183.499V183.601C560.6 185.59 559.51 186.911 557.778 186.911ZM564.018 188.155H565.724V184.256H569.842V188.155H571.561V178.983H569.842V182.883H565.724V178.983H564.018V188.155Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.OK = function () {
	    var _ref37 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref37$color = _ref37.color,
	        color = _ref37$color === undefined ? "#6496c2" : _ref37$color,
	        _ref37$labelColor = _ref37.labelColor,
	        labelColor = _ref37$labelColor === undefined ? "white" : _ref37$labelColor,
	        _ref37$tooltip = _ref37.tooltip,
	        tooltip = _ref37$tooltip === undefined ? {} : _ref37$tooltip,
	        _ref37$labelTooltip = _ref37.labelTooltip,
	        labelTooltip = _ref37$labelTooltip === undefined ? {} : _ref37$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M408.246 276.767C408.127 276.117 408.008 275.467 407.907 274.826L407.641 273.067C407.147 269.862 406.661 266.656 406.194 263.451C406.112 262.883 406.048 262.306 405.993 261.729H405.91L405.901 261.042H405.938C405.791 259.055 405.791 257.058 405.791 255.108C405.791 254.402 405.791 253.688 405.782 252.983L402.787 253.01C397.521 253.056 392.072 253.111 386.714 253.093C380.065 253.075 373.196 253.056 366.438 252.946C359.395 252.827 312.037 251.023 305.598 250.666L305.03 250.638C304.618 250.62 304.206 250.593 303.794 250.565C303.739 250.593 303.684 250.602 303.62 250.593C300.772 250.391 297.933 250.162 295.093 249.942C293.646 249.823 292.199 249.713 290.743 249.594L290.185 257.187C290.185 257.242 290.185 257.306 290.185 257.379C290.185 257.461 290.185 257.544 290.185 257.626L294.278 257.91C297.887 258.167 301.504 258.414 305.122 258.643C308.685 258.872 313.374 259.156 318.081 259.394L319.638 259.476C321.067 259.55 322.495 259.623 323.924 259.687L327.111 259.833C328.393 259.898 329.831 259.778 331.123 260.017C331.196 260.035 331.242 260.035 331.269 260.035C331.526 260.035 331.617 260.172 331.691 260.319C331.846 260.63 331.81 261.024 331.736 261.555C331.718 261.693 331.7 261.812 331.7 261.894L331.535 266.373C331.48 267.765 331.425 269.166 331.37 270.558L331.269 272.939C331.114 276.667 330.967 280.394 330.802 284.122L330.738 285.578C330.656 287.382 330.582 289.186 330.509 290.99C330.5 291.302 330.472 291.631 330.436 291.97C330.372 292.666 330.308 293.39 330.408 294.003C330.436 294.177 330.436 294.177 330.656 294.278C330.738 294.315 330.83 294.361 330.949 294.416C331.077 294.48 331.223 294.544 331.37 294.599C331.727 294.745 332.093 294.901 332.377 295.139C332.744 295.441 333.028 295.844 333.293 296.238C333.623 296.714 333.943 297.172 334.401 297.42C334.594 297.52 335.116 297.548 335.235 297.475C335.381 297.383 335.445 297.301 335.51 297.2C335.684 296.953 335.867 296.742 336.453 296.815C337.021 296.888 337.314 297.099 337.662 297.337L337.891 297.493C338.184 297.685 338.239 297.649 338.312 297.584C338.431 297.484 338.486 297.328 338.541 297.163C338.614 296.962 338.706 296.705 338.962 296.604C339.219 296.504 339.484 296.623 339.658 296.714L339.878 296.824C340.226 297.007 340.592 297.191 340.867 297.566C341.206 298.042 341.444 298.473 341.453 299.041C341.463 299.553 341.481 299.975 341.609 300.387C341.682 300.643 341.701 300.652 342.223 300.726C342.452 300.762 342.69 300.753 342.946 300.753C343.12 300.753 343.294 300.753 343.468 300.762L343.606 300.772C344.118 300.799 344.595 300.817 345.089 301.101C345.236 301.184 345.382 301.275 345.52 301.358C345.813 301.541 346.088 301.706 346.381 301.806C346.875 301.971 347.37 302.063 347.873 302.081C348.166 302.1 348.414 302.017 348.698 301.935C348.908 301.871 349.128 301.806 349.385 301.77C350.264 301.642 350.621 302.283 350.877 302.759C351.07 303.107 351.198 303.327 351.409 303.382C351.601 303.437 351.802 303.18 352.095 302.786C352.398 302.374 352.746 301.898 353.277 301.88C353.652 301.889 354.101 302.035 354.486 302.182C354.614 302.237 354.742 302.283 354.852 302.319C354.953 302.347 355.054 302.374 355.163 302.402C355.539 302.502 355.96 302.612 356.263 302.896C356.592 303.208 356.766 303.592 356.922 303.931C357.197 304.526 357.352 304.81 357.902 304.82C357.975 304.829 358.067 304.801 358.177 304.783C358.534 304.719 359.129 304.6 359.404 305.113C359.633 305.543 359.395 306.038 359.202 306.431C359.129 306.587 359.047 306.761 359.038 306.844V306.88L359.092 306.926C359.193 307.018 359.441 307.1 359.624 307.173C359.706 307.201 359.789 307.228 359.853 307.256C360.21 307.402 360.347 307.384 360.704 307.146C361.135 306.853 361.51 306.45 361.858 306.056C361.95 305.946 362.014 305.854 362.069 305.781C362.353 305.378 362.628 305.223 363.205 305.607C363.36 305.708 363.507 305.818 363.663 305.937C363.937 306.138 364.23 306.349 364.514 306.496C364.752 306.615 364.936 306.569 365.32 306.45C365.421 306.422 365.531 306.386 365.641 306.358C365.732 306.331 365.833 306.349 365.906 306.395C365.989 306.441 366.044 306.523 366.062 306.615L366.117 306.862C366.209 307.311 366.346 307.988 366.639 308.144C366.749 308.199 366.914 308.19 367.115 308.098C367.381 307.988 367.646 307.686 367.912 307.393C368.306 306.953 368.718 306.496 369.267 306.477C369.597 306.486 369.918 306.624 370.229 306.926C370.284 306.981 370.312 306.999 370.321 307.008C370.449 307.091 370.531 307.283 370.486 307.439C370.486 307.457 370.476 307.485 370.467 307.567C370.449 307.814 370.357 308.043 370.266 308.245C370.211 308.382 370.147 308.51 370.128 308.62C370.064 308.959 370.211 309.161 370.531 309.6C370.705 309.829 370.779 309.866 370.824 309.875C371.008 309.866 371.328 309.289 371.465 309.042L372.702 306.88C372.739 306.816 372.775 306.743 372.812 306.66C372.958 306.367 373.132 305.992 373.471 305.827C373.554 305.79 373.645 305.781 373.737 305.809C373.819 305.836 373.892 305.9 373.938 305.983C374.021 306.148 374.094 306.322 374.167 306.496C374.305 306.825 374.451 307.155 374.634 307.421C374.808 307.668 375.019 307.741 375.404 307.851L375.614 307.915C376.402 308.153 376.961 307.888 377.73 307.53L378.124 307.347C378.243 307.292 378.389 307.311 378.49 307.402C378.591 307.485 378.637 307.622 378.6 307.75C378.508 308.098 378.655 308.236 379.259 308.575C379.397 308.657 379.543 308.73 379.671 308.822C379.919 308.987 379.919 308.987 380.157 308.977C380.23 308.968 380.303 308.959 380.367 308.95C380.587 308.904 380.871 308.858 381.183 309.051C381.402 309.188 381.531 309.435 381.65 309.674C381.714 309.793 381.814 310.003 381.879 310.04C381.924 310.031 382.245 309.921 382.382 309.866C382.492 309.829 382.593 309.793 382.657 309.774C382.776 309.747 382.923 309.719 383.078 309.692C383.481 309.619 384.159 309.5 384.333 309.261C384.425 309.142 384.443 308.987 384.47 308.813C384.516 308.501 384.571 308.071 385.102 307.86C385.624 307.65 386.238 307.631 386.778 307.613C386.971 307.604 387.163 307.604 387.346 307.585C387.722 307.558 388.088 307.631 388.436 307.704C388.775 307.778 389.105 307.851 389.388 307.796C389.617 307.759 390.185 307.448 390.68 307.173C391.944 306.477 393.143 305.818 393.693 306.431C393.968 306.734 393.977 306.999 393.959 307.164C394.013 307.173 394.096 307.192 394.206 307.21C394.92 307.302 395.689 307.393 396.495 307.329C397.164 307.274 397.485 307.201 397.539 306.917C397.549 306.862 397.539 306.779 397.539 306.688C397.521 306.422 397.485 305.873 398.162 305.69C398.245 305.671 398.327 305.662 398.41 305.662C399.069 305.662 399.737 306.285 400.205 306.715C400.287 306.789 400.36 306.853 400.415 306.908C400.937 307.356 401.468 307.787 402 308.217C402.155 308.346 402.311 308.474 402.467 308.611C402.87 308.959 403.291 309.316 403.74 309.536C404.308 309.82 404.949 310.058 405.636 310.269C406.267 310.461 406.909 310.635 407.55 310.818L408.585 311.111L408.603 308.758C408.649 301.44 408.704 294.123 408.786 286.805C408.795 286.136 408.813 285.468 408.841 284.79C408.887 283.462 408.933 282.088 408.85 280.77C408.722 279.405 408.484 278.068 408.246 276.767Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M363.5 282.432C366.284 282.432 368.118 280.418 368.118 277.737V277.634C368.118 274.94 366.233 273.003 363.5 273.003C360.781 273.003 358.857 274.991 358.857 277.673V277.775C358.857 280.418 360.691 282.432 363.5 282.432ZM363.526 281.059C361.858 281.059 360.64 279.763 360.64 277.762V277.66C360.64 275.684 361.704 274.363 363.5 274.363C365.296 274.363 366.348 275.761 366.348 277.647V277.749C366.348 279.738 365.258 281.059 363.526 281.059ZM369.766 282.303H371.472V278.019L375 282.303H377.014L373.025 277.506L376.822 273.131H374.987L371.472 277.288V273.131H369.766V282.303Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.OR = function () {
	    var _ref38 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref38$color = _ref38.color,
	        color = _ref38$color === undefined ? "#6496c2" : _ref38$color,
	        _ref38$labelColor = _ref38.labelColor,
	        labelColor = _ref38$labelColor === undefined ? "white" : _ref38$labelColor,
	        _ref38$tooltip = _ref38.tooltip,
	        tooltip = _ref38$tooltip === undefined ? {} : _ref38$tooltip,
	        _ref38$labelTooltip = _ref38.labelTooltip,
	        labelTooltip = _ref38$labelTooltip === undefined ? {} : _ref38$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M40.6359 114.563C47.2208 116.403 54.0621 118.382 61.5537 120.607C68.6423 122.723 75.7584 124.554 81.1619 125.919C81.226 125.937 81.2901 125.974 81.3359 126.02L82.2243 126.249C83.6988 126.624 85.1733 127.009 86.6478 127.394C89.9998 128.264 93.4616 129.17 96.8777 129.958C102.162 131.176 107.447 132.376 112.731 133.585C114.251 133.933 115.772 134.29 117.292 134.647C117.548 134.711 117.796 134.766 118.052 134.83L124.335 106.879C124.71 105.212 125.553 103.582 126.24 102.336C126.505 101.86 126.725 101.466 126.844 100.99C126.881 100.843 126.908 100.688 126.945 100.532C127.036 100.092 127.128 99.6436 127.357 99.2498C127.449 99.0941 127.558 98.975 127.668 98.8651C127.842 98.6728 127.916 98.5903 127.906 98.4713C127.897 98.2515 127.494 97.473 127.32 97.3082C127.229 97.2166 127.091 97.1983 126.881 97.18C126.762 97.1708 126.652 97.1616 126.551 97.1342C125.553 96.896 124.957 96.548 124.774 96.0993C124.646 95.7879 124.719 95.4307 124.774 95.1468C124.793 95.0735 124.802 95.0002 124.811 94.9361C124.848 94.698 124.875 94.4599 124.902 94.2126C124.967 93.7181 125.022 93.196 125.141 92.7015C125.324 91.9047 125.919 91.1903 126.441 90.5493C126.615 90.3295 126.789 90.1188 126.945 89.9173C127.055 89.7616 127.165 89.6059 127.265 89.4502C127.705 88.7817 128.163 88.104 129.024 87.8384C129.619 87.6552 129.949 87.5545 130.324 87.1515C130.425 87.0507 130.526 86.9408 130.627 86.8401C130.865 86.5928 131.094 86.3639 131.268 86.1166C131.497 85.7869 131.487 85.7319 131.46 85.5213C131.442 85.3931 131.423 85.2374 131.432 85.0176C131.451 84.3124 131.945 83.8728 132.302 83.5431C132.962 82.9478 133.401 82.1693 133.878 81.3542C134.015 81.1069 134.162 80.8596 134.308 80.6215C134.436 80.4109 134.565 80.2002 134.684 79.9988C135.059 79.3668 135.416 78.7624 135.902 78.1488C136.589 77.2696 137.303 76.4361 138.237 75.4379C138.75 74.8975 138.411 73.8168 138.173 73.0292L138.136 72.9101C137.999 72.4705 137.816 72.3515 137.385 72.0859C137.028 71.8661 136.744 71.5822 136.479 71.3074C136.369 71.1975 136.25 71.0785 136.14 70.9777C135.49 70.3824 135.288 69.6589 135.087 68.9537C134.986 68.6057 134.885 68.2485 134.729 67.9005L134.693 67.8089C134.693 67.7998 134.684 67.7906 134.684 67.7906H134.62L134.61 67.7082C134.592 67.7082 134.574 67.699 134.546 67.699L128.419 66.2703C127.192 65.9772 125.974 65.6842 124.747 65.3911L111.559 62.2223C111.458 62.1948 111.339 62.1582 111.211 62.1124C111.009 62.0483 110.734 61.9567 110.597 61.9658C110.524 61.975 110.405 62.0483 110.295 62.1215C110.176 62.1948 110.038 62.2864 109.883 62.3505C109.196 62.6161 108.601 62.7077 108.078 62.6436C107.831 62.6161 107.611 62.5428 107.401 62.4696C107.236 62.4146 107.062 62.3505 106.879 62.323C106.54 62.2681 106.174 62.2498 105.807 62.2223C105.01 62.1673 104.177 62.1124 103.453 61.7918L103.252 61.7002C102.867 61.5262 102.867 61.5262 102.492 61.8193C101.869 62.3139 101.732 62.3413 100.944 62.2589L100.569 62.2223C99.5886 62.1307 98.6728 62.0391 97.7203 62.0941C97.2258 62.1215 96.6763 62.1948 96.0352 62.2955C95.8428 62.3322 95.6963 62.4238 95.5223 62.552C95.3574 62.671 95.1743 62.7993 94.9178 62.8817C94.4874 63.0099 93.9196 62.9275 93.4067 62.8451C93.2052 62.8176 93.0129 62.7809 92.848 62.7718L92.6008 62.7626C92.1795 62.7443 91.6941 62.726 91.3277 62.552C90.9706 62.378 90.8057 62.0757 90.6683 61.8193C90.5767 61.6545 90.5035 61.5079 90.3844 61.4255C90.1097 61.2148 89.9723 61.2698 89.6151 61.4163C89.5144 61.4621 89.4045 61.4988 89.2762 61.5445C88.9282 61.6545 88.5527 61.7002 88.1956 61.7277C88.0399 61.746 87.8842 61.7644 87.7285 61.7827C87.6277 61.801 87.4629 61.8376 87.2797 61.8926C86.6569 62.0483 86.2265 62.149 85.9609 62.0574C85.851 62.0208 85.7503 61.9384 85.5854 61.7735C85.5121 61.7002 85.4389 61.627 85.3839 61.5995L85.274 61.5354C85.1641 61.4713 84.8711 61.3064 84.7795 61.2973C84.5597 61.3064 84.1567 61.5079 83.8545 61.6636C83.6805 61.7552 83.5064 61.8468 83.3691 61.9017C83.2683 61.9384 83.1584 61.9292 83.0668 61.8834C82.9753 61.8285 82.9111 61.7369 82.8928 61.6361C82.8745 61.4896 82.8562 61.3522 82.8379 61.2332C82.7829 60.7295 82.7646 60.5554 82.3525 60.3173C81.6748 59.9144 81.2718 59.6762 80.6307 59.5755C80.2003 59.5114 79.898 59.2916 79.6324 59.1084C79.4126 58.9527 79.2203 58.8153 78.9822 58.7787C78.7074 58.7421 78.4235 58.7421 78.1213 58.7512C77.7458 58.7604 77.3611 58.7604 76.9673 58.6871C76.6559 58.623 76.4087 58.4948 76.1797 58.3849C75.8408 58.2109 75.5936 58.0918 75.2364 58.1834C75.1082 58.22 75.0074 58.3025 74.8792 58.4124C74.7693 58.504 74.6503 58.6047 74.4854 58.6871C74.2931 58.7879 74.0916 58.8062 73.9084 58.8245L73.7802 58.8428L71.0419 59.2275C70.9411 59.2458 70.8404 59.2549 70.7396 59.2733C70.2909 59.3465 69.778 59.4381 69.2743 59.2641C68.8347 59.1176 68.4409 58.8428 68.0562 58.5864C67.9188 58.4948 67.7814 58.4032 67.6532 58.3208C67.4151 58.1743 67.177 58.0369 66.9389 57.8903C66.4535 57.5973 65.9681 57.3134 65.501 56.9928C64.9332 56.6082 64.5302 56.2235 64.3013 55.8389C63.9441 55.2527 64.1547 54.8131 64.3196 54.4559C64.3745 54.3369 64.4386 54.2087 64.4844 54.0621C64.5943 53.6866 64.6493 53.247 64.6951 52.8257C64.7225 52.551 64.7592 52.2762 64.805 52.0198C64.9057 51.452 65.0065 50.8017 64.9698 50.2156C64.9332 49.6111 64.7958 48.8876 64.6126 48.2649C64.4844 47.8344 64.1272 47.4406 63.7975 47.0651C63.6785 46.9277 63.5594 46.7995 63.4495 46.6621C63.3762 46.5705 63.2938 46.4606 63.2206 46.3599C62.9275 45.9661 62.6527 45.5906 62.2589 45.5631C62.0116 45.5448 61.7277 45.5814 61.4255 45.6272C60.9035 45.7005 60.3173 45.7829 59.7862 45.5723C59.4381 45.4349 59.1634 45.1235 59.026 44.7205C58.9069 44.3725 59.0077 44.1252 59.0718 43.9421C59.1176 43.8322 59.1359 43.7498 59.1451 43.6399C59.1909 43.2827 59.0718 43.1636 58.1468 43.0903V43.0995L57.6064 43.2918L57.35 43.7406L55.8938 43.5757L55.4909 42.9621L54.6758 42.9713L54.1079 43.3101L53.6866 42.8889L53.2837 42.0921L52.9815 42.0097L52.7708 42.1837C52.7067 42.2386 52.8624 43.2186 52.8715 43.3193C52.899 43.9329 52.8624 44.5465 52.78 45.151C52.6609 46.0851 52.3678 46.1218 51.5527 46.4423C51.6443 46.6347 51.8824 46.9644 51.8824 47.175C51.8916 47.9535 50.9116 48.6037 50.9116 49.3639L50.9391 50.2705V50.3896L50.8933 50.7101L50.6552 51.4886C50.179 52.8257 49.7119 54.172 49.2448 55.5092C48.4847 57.6797 47.6421 59.722 46.6621 61.801C45.1235 65.0522 44.1161 68.5233 42.6508 71.802C41.3411 74.751 40.1139 77.7 38.9508 80.704C38.9508 80.704 36.9634 84.6329 36.9268 84.7062C36.6245 85.3015 36.5512 85.9151 36.13 86.4921C35.5621 87.2797 34.8753 87.9849 34.2891 88.7634L33.0894 89.1022L33.3366 90.2104L30.4151 94.698L28.9314 96.3374L28.9223 97.9309L28.904 98.3705L29.7923 100.239C29.9114 100.486 29.5176 101.823 29.3711 102.061C29.2337 102.281 28.9314 102.409 28.7758 102.62C28.5376 102.941 28.4186 103.417 28.2904 103.792C27.7225 105.459 27.7683 107.245 27.7134 108.985L28.2812 110.698L28.4369 111.027L28.9131 111.174C32.897 112.374 36.8993 113.519 40.6359 114.563Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M73.955 95.51C76.7387 95.51 78.5731 93.496 78.5731 90.815V90.7124C78.5731 88.0185 76.6874 86.0815 73.955 86.0815C71.2355 86.0815 69.3113 88.0698 69.3113 90.7508V90.8535C69.3113 93.496 71.1457 95.51 73.955 95.51ZM73.9807 94.1374C72.313 94.1374 71.0944 92.8418 71.0944 90.8406V90.738C71.0944 88.7625 72.1591 87.4412 73.955 87.4412C75.7509 87.4412 76.8028 88.8395 76.8028 90.7252V90.8278C76.8028 92.8161 75.7124 94.1374 73.9807 94.1374ZM80.2209 95.3817H81.927V91.6744H83.0174L85.4162 95.3817H87.2634L84.685 91.4179C85.8267 91.1228 86.7246 90.3917 86.7246 88.9549V88.9036C86.7246 87.0307 85.3136 86.2097 83.2996 86.2097H80.2209V95.3817ZM81.927 90.4558V87.531H83.2996C84.3899 87.531 85.0442 87.8902 85.0442 88.9421V88.9934C85.0442 89.9683 84.4413 90.4558 83.2996 90.4558H81.927Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.PA = function () {
	    var _ref39 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref39$color = _ref39.color,
	        color = _ref39$color === undefined ? "#6496c2" : _ref39$color,
	        _ref39$labelColor = _ref39.labelColor,
	        labelColor = _ref39$labelColor === undefined ? "white" : _ref39$labelColor,
	        _ref39$tooltip = _ref39.tooltip,
	        tooltip = _ref39$tooltip === undefined ? {} : _ref39$tooltip,
	        _ref39$labelTooltip = _ref39.labelTooltip,
	        labelTooltip = _ref39$labelTooltip === undefined ? {} : _ref39$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M588.099 161.738C588.639 165.007 589.179 168.277 589.711 171.546L589.82 172.215L589.976 172.416L589.866 172.499L590.352 175.42C590.645 177.224 590.947 179.029 591.24 180.833L592.366 187.748C592.376 187.784 592.376 187.83 592.385 187.857H592.394C592.66 187.903 593.227 187.766 593.639 187.665C593.859 187.61 594.07 187.564 594.235 187.537C600.71 186.456 607.322 185.293 614.466 183.983C621.554 182.683 627.956 181.501 634.44 180.21C640.613 178.992 646.868 177.646 652.913 176.354L653.819 176.162C653.856 176.089 653.966 175.759 654.03 175.576C654.122 175.32 654.195 175.1 654.296 174.953C654.616 174.459 655.056 174.074 655.559 173.836C656.375 173.451 657.382 173.424 658.344 173.763C658.444 173.616 658.545 173.47 658.655 173.323C659.076 172.755 659.388 172.627 659.946 172.38L660.029 172.343C660.606 172.096 660.734 172.013 661.055 171.5C661.247 171.198 661.412 170.878 661.577 170.557L661.787 170.154C662.364 169.083 662.95 168.323 663.701 167.7C663.775 167.645 663.857 167.581 663.939 167.517C664.086 167.416 664.242 167.297 664.315 167.196C664.324 167.178 664.333 167.104 664.352 167.059C664.379 166.903 664.425 166.692 664.599 166.555C664.736 166.454 664.91 166.427 665.075 166.399C665.148 166.39 665.267 166.372 665.304 166.344C665.386 166.299 665.469 166.225 665.551 166.152L662.996 164.192C662.776 164.027 662.502 163.872 662.199 163.707C661.741 163.45 661.274 163.194 660.963 162.846C660.688 162.544 660.505 162.086 660.34 161.683C660.267 161.509 660.203 161.344 660.13 161.197C659.983 160.904 659.983 160.904 659.644 160.767C659.47 160.694 659.342 160.657 659.214 160.611C658.811 160.474 658.344 160.327 658.078 160.043C657.794 159.741 657.703 159.274 657.629 158.899C657.611 158.816 657.593 158.734 657.583 158.66L657.519 158.422C657.409 158.01 657.29 157.534 657.336 157.113C657.409 156.508 657.675 156.362 658.032 156.343C658.115 156.334 658.17 156.334 658.225 156.307C658.536 156.142 658.783 155.024 658.637 154.713C658.573 154.585 658.371 154.411 658.197 154.255C657.877 153.971 657.547 153.678 657.483 153.303C657.437 153.028 657.638 152.689 657.959 152.213C658.023 152.121 658.069 152.048 658.096 152.002C658.188 151.837 658.28 151.673 658.371 151.499C658.554 151.178 658.747 150.839 658.893 150.509C658.966 150.345 659.095 150.116 659.223 149.887L659.369 149.63C659.626 149.172 659.653 148.769 659.69 148.302C659.708 148.027 659.736 147.734 659.809 147.423C660.047 146.388 660.578 145.82 661.229 145.326C661.091 145.216 660.954 145.078 660.789 144.923C660.56 144.703 660.359 144.721 659.946 144.776C659.662 144.813 659.333 144.859 658.966 144.776C658.17 144.584 657.345 143.989 656.878 143.54C656.063 142.752 655.505 141.626 654.973 140.536C654.781 140.133 654.589 139.748 654.387 139.391C654.351 139.318 654.296 139.208 654.25 139.089C654.186 138.933 654.048 138.622 653.966 138.558C653.893 138.53 653.563 138.567 653.407 138.585C653.307 138.594 653.215 138.613 653.133 138.613L652.995 138.622C652.528 138.658 652.4 138.576 652.189 138.155C652.088 137.953 652.034 137.825 651.988 137.706C651.887 137.468 651.814 137.276 651.649 137.111C651.081 136.57 650.834 136.625 650.009 136.808L648.48 137.147C643.241 138.283 637.609 139.455 630.209 140.957C624.412 142.139 617.561 143.512 610.729 144.767L608.394 145.198C606.452 145.555 604.51 145.912 602.569 146.26L600.801 146.571C599.602 146.782 598.402 146.993 597.202 147.212C597.101 147.231 596.946 147.267 596.772 147.313C595.856 147.551 595.279 147.679 594.986 147.423C594.757 147.231 594.702 146.791 594.656 146.15C594.647 146.022 594.638 145.912 594.629 145.857L594.39 144.492C594.299 143.961 594.207 143.439 594.125 142.908L593.136 143.641L590.8 145.546L590.736 145.28L590.287 145.362L589.994 145.701L589.866 146.324L587.851 148L585.992 149.172L586.358 151.389C586.963 154.823 587.531 158.285 588.099 161.738Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M616.336 166.394H618.042V162.904H619.324C621.287 162.904 622.685 162.045 622.685 160.108V160.057C622.685 158.132 621.338 157.222 619.286 157.222H616.336V166.394ZM618.042 161.673V158.543H619.286C620.376 158.543 621.018 158.966 621.018 160.057V160.108C621.018 161.121 620.415 161.673 619.286 161.673H618.042ZM622.808 166.394H624.412L625.13 164.123H628.632L629.363 166.394H631.134L628.106 157.222H625.874L622.808 166.394ZM626.887 158.62L628.234 162.879H625.528L626.887 158.62Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.RI = function () {
	    var _ref40 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref40$color = _ref40.color,
	        color = _ref40$color === undefined ? "#6496c2" : _ref40$color,
	        _ref40$labelColor = _ref40.labelColor,
	        labelColor = _ref40$labelColor === undefined ? "white" : _ref40$labelColor,
	        _ref40$tooltip = _ref40.tooltip,
	        tooltip = _ref40$tooltip === undefined ? {} : _ref40$tooltip,
	        _ref40$labelTooltip = _ref40.labelTooltip,
	        labelTooltip = _ref40$labelTooltip === undefined ? {} : _ref40$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M702.826 128.117C702.881 128.117 702.927 128.135 702.973 128.145C702.954 128.227 702.909 128.264 702.918 128.355C702.643 128.309 702.771 128.071 702.506 128.08C702.451 128.566 703.119 128.465 702.973 128.96C702.844 128.749 702.661 128.877 702.533 128.795C702.387 128.694 702.313 128.529 702.148 128.41C702.13 128.401 702.112 128.447 702.084 128.447C701.901 128.2 701.672 127.925 701.581 127.632C701.498 127.394 701.59 127.201 701.544 126.981C701.544 126.972 701.498 126.743 701.498 126.743L701.37 126.679L701.333 126.835L701.352 127.036L701.324 127.43L701.214 127.421L701.178 127.467L701.361 127.723L701.489 127.76L701.562 127.833L701.526 127.916L701.672 128.309C701.672 128.319 701.69 128.401 701.69 128.401L701.755 128.456L701.81 128.566L701.901 128.593L701.864 128.667L701.919 128.813L701.938 128.914C702.084 128.978 702.194 129.015 702.359 128.978C702.304 129.024 702.24 129.079 702.176 129.115C702.286 129.381 702.203 129.637 702.231 129.903C702.167 129.866 702.084 129.848 702.02 129.811C702.02 129.766 702.039 129.72 702.039 129.665C701.974 129.637 701.819 129.573 701.773 129.555C701.764 129.582 701.773 129.628 701.764 129.665C701.599 129.683 701.425 129.701 701.26 129.72C701.288 130.278 701.471 129.912 701.681 130.059C701.901 130.205 701.901 130.398 702.066 130.654C702.066 130.663 701.993 130.782 701.984 130.801C702.103 130.819 702.066 130.846 702.167 130.883C702.121 130.938 702.084 131.011 702.029 131.057C702.121 131.066 702.13 131.103 702.24 131.094C702.341 131.387 701.91 131.497 701.745 131.606C701.965 131.845 702.24 131.991 702.359 132.312C702.478 132.65 702.46 132.953 702.579 133.301C702.442 133.42 702.451 133.484 702.579 133.612C702.561 133.795 702.469 133.951 702.313 134.061C702.625 134.565 702.13 134.867 702.295 135.38C702.167 135.325 702.02 135.279 701.874 135.251C702.048 134.913 701.965 134.784 701.846 134.436C701.81 134.455 701.755 134.473 701.709 134.491C701.745 134.748 701.672 135.023 701.745 135.261C701.251 135.563 700.701 135.764 700.216 136.103C699.95 136.296 699.712 136.561 699.465 136.726C699.126 136.955 698.668 137.083 698.274 137.266C698.366 136.909 698.265 136.506 698.183 136.314C698.091 136.094 698.045 135.929 698.036 135.828C698.045 135.828 698.055 135.838 698.073 135.838C698.192 135.874 698.32 135.847 698.412 135.764C698.503 135.682 698.54 135.554 698.513 135.435C697.752 132.348 696.901 129.143 695.902 125.653C695.976 125.626 696.049 125.599 696.113 125.571C696.177 125.544 696.232 125.516 696.305 125.498C697.652 125.086 699.044 124.655 700.427 124.271C700.555 124.802 700.692 125.324 700.83 125.855L700.894 126.111C700.921 126.212 700.985 126.295 701.077 126.331C701.168 126.377 701.269 126.377 701.37 126.331L701.471 126.285C701.498 126.359 701.526 126.432 701.553 126.505C701.599 126.615 701.645 126.725 701.663 126.835L701.681 126.926C701.736 127.201 701.81 127.586 702.103 127.861C702.359 128.08 702.615 128.099 702.826 128.117ZM705.391 130.169C705.372 130.114 705.354 130.049 705.326 129.958C705.29 129.83 705.198 129.5 705.125 129.427C705.061 129.372 704.878 129.344 704.722 129.326C704.649 129.317 704.585 129.308 704.52 129.299L704.401 129.28L704.383 129.344L704.438 129.775L704.466 129.885L704.493 129.958L704.484 129.967L704.575 130.315L704.74 130.416L704.658 130.727L704.814 131.084L704.694 131.167L704.768 131.387L704.951 131.414L705.042 131.835L705.143 131.89L705.088 132.083L705.445 132.449L705.491 132.87L705.757 132.65L705.839 132.394L706.068 132.248L706.059 132.22L706.004 132.055C705.821 131.423 705.61 130.773 705.391 130.169ZM703.128 128.163C703.083 128.154 703.046 128.154 703 128.145C703.44 128.584 702.918 129.408 703.211 129.866C703.22 129.857 703.284 129.848 703.293 129.848C703.293 129.701 703.302 129.592 703.412 129.5C703.467 129.555 703.55 129.592 703.605 129.647L703.678 129.793L703.742 129.839L703.788 129.811L703.779 129.601L703.806 129.491L703.925 129.372L703.916 129.216L703.788 129.079L703.55 128.859L703.531 128.712L703.568 128.676L703.696 128.85L703.788 128.905L703.898 128.831L703.889 128.74L703.715 128.575C703.513 128.374 703.357 128.227 703.128 128.163ZM704.31 129.5L704.218 129.701L703.98 129.866L703.925 130.095L703.834 130.214L703.843 130.517L703.788 130.736L703.797 131.075L703.696 131.533L703.779 132.037L703.614 132.009L703.623 132.147L703.687 132.183L703.724 132.293L703.769 132.486L703.925 132.724L703.705 132.898L703.632 132.825L703.458 133.118L703.449 133.255L703.605 133.392L703.705 133.292L703.779 133.301L703.962 133.108L704.172 133.163L704.182 132.98L704.218 132.843L704.182 132.705L704.2 132.586L704.328 132.495L704.374 132.568L704.475 132.541V132.431L704.585 132.394L704.676 132.403L704.814 132.486L704.832 132.605H704.887L704.896 132.403L704.777 132.293V132.028L704.823 131.872V131.551L704.713 131.487L704.575 131.149L704.53 130.819L704.337 130.654L704.291 130.141L704.484 129.976L704.466 129.894L704.31 129.5ZM704.466 129.894L704.484 129.976L704.493 129.967L704.466 129.894Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M716.991 143.627L700.498 132.632", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M720.563 148.526H722.269V144.819H723.359L725.758 148.526H727.605L725.027 144.562C726.168 144.267 727.066 143.536 727.066 142.099V142.048C727.066 140.175 725.655 139.354 723.641 139.354H720.563V148.526ZM722.269 143.6V140.675H723.641C724.732 140.675 725.386 141.035 725.386 142.086V142.138C725.386 143.113 724.783 143.6 723.641 143.6H722.269ZM729.02 148.526H730.739V139.354H729.02V148.526Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "715", y: "135", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.SC = function () {
	    var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref41$color = _ref41.color,
	        color = _ref41$color === undefined ? "#6496c2" : _ref41$color,
	        _ref41$labelColor = _ref41.labelColor,
	        labelColor = _ref41$labelColor === undefined ? "white" : _ref41$labelColor,
	        _ref41$tooltip = _ref41.tooltip,
	        tooltip = _ref41$tooltip === undefined ? {} : _ref41$tooltip,
	        _ref41$labelTooltip = _ref41.labelTooltip,
	        labelTooltip = _ref41$labelTooltip === undefined ? {} : _ref41$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M618.166 272.106L618.01 271.996C617.717 271.794 617.699 271.776 617.397 271.822C616.856 271.895 616.316 271.987 615.775 272.078C615.51 272.124 615.235 272.17 614.97 272.216C614.127 272.353 613.275 272.472 612.424 272.591L611.489 272.728C609.639 272.994 607.798 273.269 605.948 273.544L604.511 273.754C604.346 273.782 604.144 273.827 603.934 273.873C603.421 273.992 602.835 274.139 602.377 274.047C601.681 273.91 601.708 273.131 601.726 272.619C601.726 272.5 601.736 272.38 601.726 272.28C601.699 271.822 601.516 271.648 601.149 271.3C601.058 271.217 600.966 271.126 600.866 271.025C600.737 270.888 600.6 270.741 600.472 270.595C600.234 270.32 599.986 270.036 599.73 269.862C599.51 269.706 599.473 269.706 599.162 270.1C599.052 270.237 598.933 270.384 598.796 270.503C598.741 270.549 598.704 270.595 598.677 270.622C598.374 270.961 598.127 270.833 597.871 270.659C597.367 270.32 597.532 269.926 597.623 269.706C597.651 269.633 597.688 269.55 597.715 269.459C597.779 269.193 597.724 269.093 597.706 269.074C597.669 269.028 597.578 269.001 597.449 268.992C596.964 268.973 596.433 269.038 595.911 269.111C595.645 269.148 595.38 269.184 595.123 269.202C593.264 269.376 591.414 269.569 589.555 269.77L587.705 269.963C587.009 270.036 586.322 270.118 585.626 270.201C584.097 270.384 582.503 270.567 580.937 270.649C580.406 270.686 579.765 270.613 579.298 270.759C578.867 270.897 578.409 271.172 577.97 271.428C577.741 271.565 577.521 271.694 577.301 271.813C576.77 272.087 576.266 272.445 575.781 272.793C575.277 273.15 574.755 273.525 574.187 273.818C573.812 274.02 573.399 274.102 573.006 274.194C572.813 274.24 572.63 274.276 572.447 274.331C572.035 274.45 571.659 274.643 571.247 274.844L570.899 275.018C570.762 275.082 570.579 275.146 570.386 275.22C570.121 275.32 569.773 275.448 569.59 275.577L569.608 275.714L569.443 275.742C569.388 275.861 569.37 276.035 569.342 276.209C569.306 276.529 569.26 276.886 569.013 277.179C568.811 277.408 568.591 277.564 568.371 277.72C568.133 277.894 567.904 278.059 567.758 278.288C567.419 278.81 567.089 279.368 566.952 279.936L566.924 280.055C566.796 280.586 566.741 280.852 567.016 281.108C567.309 281.383 567.749 281.621 568.17 281.841C568.39 281.96 568.6 282.07 568.793 282.189C569.022 282.336 569.287 282.519 569.571 282.72C570.267 283.215 571.128 283.828 571.769 283.883C571.962 283.902 572.191 283.838 572.42 283.783C572.685 283.709 572.997 283.627 573.326 283.654C573.931 283.709 574.178 284.149 574.379 284.497C574.434 284.589 574.48 284.68 574.544 284.772L574.938 285.34C575.524 286.173 576.074 286.961 576.477 287.968C576.797 288.756 577.448 289.488 578.089 290.194C578.345 290.477 578.592 290.752 578.812 291.027C578.949 291.201 579.078 291.402 579.197 291.604C579.352 291.851 579.49 292.089 579.655 292.245C579.939 292.511 580.351 292.721 580.754 292.932C580.955 293.033 581.157 293.143 581.331 293.243C581.541 293.372 581.66 293.39 581.844 293.417C581.953 293.436 582.072 293.454 582.228 293.5C582.86 293.683 583.492 294.141 583.913 294.48C584.545 294.974 584.765 295.341 585.131 295.927L585.186 296.009C585.406 296.366 585.736 296.641 586.093 296.925C586.203 297.017 586.313 297.108 586.414 297.2C586.862 297.594 587.22 297.749 587.778 297.987C588.392 298.244 588.804 298.656 589.234 299.086L589.454 299.306C589.802 299.645 590.196 300.03 590.416 300.451C590.553 300.717 590.608 300.991 590.663 301.257C590.709 301.504 590.755 301.733 590.865 301.916C591.405 302.878 592.266 303.666 593.282 304.16C593.539 304.279 593.85 304.407 594.18 304.536C595.059 304.884 596.057 305.287 596.634 305.873C596.927 306.175 597.138 306.624 597.33 307.027C597.413 307.201 597.486 307.366 597.569 307.503L598.897 309.857C598.951 309.948 599.006 310.04 599.061 310.131C599.208 310.379 599.364 310.635 599.473 310.91C599.611 311.267 599.675 311.643 599.739 312.009C599.803 312.403 599.867 312.778 600.014 313.099C600.133 313.355 600.408 313.456 600.847 313.602C600.975 313.648 601.104 313.685 601.232 313.74C601.772 313.95 602.148 314.271 602.551 314.601L602.697 314.729C603.137 315.095 603.311 315.443 603.521 315.883L603.586 316.02C603.696 316.249 603.824 316.487 603.943 316.716C604.199 317.193 604.456 317.687 604.648 318.2C604.776 318.53 604.831 318.969 604.886 319.418C604.959 320.032 605.051 320.728 605.326 321.002C605.491 321.167 606.086 321.259 606.406 321.305C606.516 321.323 606.608 321.332 606.69 321.35L608.54 321.699V321.415L608.989 320.728L609.401 320.764L610.235 320.087C610.573 319.473 610.848 318.777 611.178 318.182C611.709 317.229 612.826 317.165 613.596 316.478C614.548 315.626 614.1 314.958 613.642 314.262L614.109 313.364L614.365 313.319L614.704 313.035L615.226 313.254H615.308C616.526 311.991 617.763 310.983 619.338 310.168C620.071 309.793 621.573 308.419 621.179 307.375C621.573 307.063 621.976 306.752 622.37 306.441C622.8 306.102 622.846 305.919 623.093 305.58C623.331 305.259 623.652 304.856 623.954 304.591C624.311 304.27 625.071 304.142 624.943 303.537C623.505 303.885 624.705 301.486 625.667 301.605C625.694 301.761 625.868 301.898 625.896 302.045C626.582 301.935 627.059 301.678 627.8 301.642C627.993 300.341 628.139 300.25 629.028 299.407C629.925 298.555 629.65 297.905 629.559 296.87C629.394 294.947 629.989 293.262 630.859 291.595C632.197 289.03 633.644 286.86 636.162 285.358L636.51 285.166C632.233 282.116 628.359 279.359 624.485 276.529C622.397 274.981 620.318 273.534 618.166 272.106Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M599.753 297.092C601.78 297.092 603.127 295.848 603.127 294.257C603.127 292.423 602.011 291.807 599.856 291.512C598.265 291.281 597.957 290.909 597.957 290.165C597.957 289.46 598.496 288.959 599.535 288.959C600.587 288.959 601.138 289.37 601.305 290.332H602.87C602.691 288.574 601.511 287.676 599.535 287.676C597.624 287.676 596.341 288.805 596.341 290.306C596.341 292.025 597.38 292.692 599.573 292.987C601.062 293.231 601.485 293.552 601.485 294.398C601.485 295.245 600.766 295.809 599.753 295.809C598.201 295.809 597.829 295.04 597.713 294.116H596.071C596.2 295.848 597.252 297.092 599.753 297.092ZM608.744 297.092C610.924 297.092 612.489 295.976 612.759 293.77H611.091C610.912 295.065 610.014 295.707 608.744 295.707C607.05 295.707 606.063 294.488 606.063 292.423V292.32C606.063 290.268 607.115 289.011 608.731 289.011C610.052 289.011 610.732 289.639 610.924 290.858H612.656C612.451 288.703 610.822 287.651 608.718 287.651C606.165 287.651 604.267 289.575 604.267 292.333V292.436C604.267 295.258 605.87 297.092 608.744 297.092Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.SD = function () {
	    var _ref42 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref42$color = _ref42.color,
	        color = _ref42$color === undefined ? "#6496c2" : _ref42$color,
	        _ref42$labelColor = _ref42.labelColor,
	        labelColor = _ref42$labelColor === undefined ? "white" : _ref42$labelColor,
	        _ref42$tooltip = _ref42.tooltip,
	        tooltip = _ref42$tooltip === undefined ? {} : _ref42$tooltip,
	        _ref42$labelTooltip = _ref42.labelTooltip,
	        labelTooltip = _ref42$labelTooltip === undefined ? {} : _ref42$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M286.136 132.248C285.898 135.114 285.66 137.981 285.422 140.856L285.257 142.835L287.226 143C291.75 143.375 296.43 143.76 301.037 144.08C307.072 144.511 328.988 145.793 334.053 146.022C339.804 146.278 345.739 146.489 351.692 146.663L354.293 146.736C354.375 146.736 354.467 146.736 354.568 146.727C354.861 146.718 355.191 146.7 355.465 146.809C355.713 146.91 355.932 147.139 356.125 147.35C356.198 147.423 356.262 147.496 356.317 147.551L357.471 148.586C357.865 148.934 358.259 149.117 358.762 149.337L358.936 149.41C359.348 149.594 359.724 149.905 360.081 150.207C360.731 150.748 361.281 151.215 361.977 150.967C362.389 150.821 362.801 150.271 363.03 149.786C363.048 149.74 363.067 149.703 363.085 149.658C363.204 149.346 363.396 149.035 364.065 149.172C364.312 149.227 364.45 149.383 364.56 149.493C364.633 149.575 364.66 149.603 364.688 149.612C364.761 149.447 364.862 149.255 365.118 149.154C365.53 148.998 365.842 149.264 366.052 149.511C366.19 149.392 366.364 149.291 366.62 149.273C367.051 149.236 367.215 149.401 367.344 149.584C367.417 149.621 367.527 149.557 367.6 149.52C367.738 149.447 367.893 149.355 368.076 149.346C368.287 149.328 368.47 149.383 368.635 149.438C368.745 149.474 368.864 149.511 368.937 149.502C369.029 149.493 369.148 149.429 369.267 149.374C369.414 149.3 369.578 149.218 369.762 149.181C370.21 149.09 370.448 149.209 370.668 149.319C370.76 149.365 370.861 149.42 371.007 149.456C371.044 149.465 371.172 149.465 371.264 149.456C371.318 149.456 371.383 149.456 371.438 149.456C371.666 149.456 371.868 149.484 372.015 149.621C372.234 149.832 372.17 150.125 372.124 150.326C372.115 150.381 372.088 150.482 372.097 150.509C372.234 150.812 373.031 151.013 373.452 151.123C373.562 151.15 373.654 151.178 373.736 151.196C374.24 151.343 374.735 151.526 375.211 151.709L375.824 151.938C376.301 152.112 376.795 152.286 377.253 152.561L377.409 152.652C377.656 152.79 377.94 152.955 378.123 153.202C378.325 153.486 378.306 153.761 378.297 153.953C378.288 154.035 378.288 154.118 378.297 154.182C378.389 154.594 378.874 155.354 379.158 155.537C379.497 155.757 380.12 155.858 380.669 155.95C380.733 155.959 380.797 155.968 380.852 155.977C380.825 155.904 380.807 155.83 380.779 155.748C380.541 154.979 380.294 154.191 379.863 153.66C379.799 153.587 379.726 153.532 379.653 153.468C379.561 153.394 379.469 153.312 379.387 153.22C379.323 153.147 379.277 153.11 379.25 153.083C379.103 152.955 379.076 152.854 379.076 152.671V152.543C379.057 152.011 379.259 151.343 379.424 150.802L379.524 150.445C379.671 149.914 379.854 149.392 380.037 148.861C380.202 148.394 380.367 147.927 380.504 147.45L380.642 146.974C380.742 146.608 380.843 146.242 380.962 145.884C381.145 145.326 381.136 145.289 380.962 144.666C380.944 144.593 380.926 144.483 380.898 144.364C380.871 144.227 380.825 143.934 380.779 143.86C380.779 143.879 380.669 143.888 380.605 143.897C380.486 143.906 380.358 143.924 380.22 143.897C379.689 143.787 379.57 143.622 379.415 143.073C379.35 142.844 379.332 142.615 379.323 142.386L379.305 142.157C379.295 142.065 379.332 141.974 379.387 141.9C379.451 141.827 379.543 141.791 379.634 141.781C379.698 141.781 379.781 141.781 379.872 141.791C379.946 141.8 380.065 141.8 380.138 141.8C380.138 141.791 380.147 141.781 380.147 141.763C380.193 141.617 380.156 141.113 380.092 140.966C380.046 140.866 379.9 140.765 379.763 140.655C379.561 140.499 379.332 140.325 379.213 140.06C379.094 139.776 379.121 139.4 379.14 139.071C379.149 138.951 379.158 138.832 379.158 138.741C379.158 138.649 379.195 138.558 379.259 138.494C379.323 138.429 379.424 138.411 379.506 138.393L380.999 138.402L381.008 136.424C381.017 133.008 381.045 129.582 381.063 126.166C381.081 122.649 381.109 119.142 381.118 115.625L381.136 110.698C381.136 110.46 381.155 110.185 381.173 109.874C381.246 108.6 381.338 106.87 380.449 106.302C380.065 106.064 379.653 105.862 379.35 105.78C379.24 105.743 379.131 105.743 379.03 105.734C378.783 105.716 378.48 105.688 378.224 105.413C377.958 105.129 377.83 104.745 377.693 104.36C377.619 104.14 377.546 103.939 377.464 103.792C377.336 103.563 377.171 103.344 376.997 103.115L376.759 102.794C376.401 102.327 375.989 101.805 376.603 101.008C376.951 100.559 377.436 100.285 377.894 100.01C378.178 99.845 378.444 99.6985 378.664 99.5153C379.561 98.7644 379.827 97.6287 379.854 96.6488C378.654 96.6396 377.445 96.6304 376.246 96.6213C371.767 96.5847 367.133 96.548 362.59 96.3923C360.035 96.3007 357.48 96.2183 354.916 96.1359C351.097 96.0077 347.268 95.8886 343.449 95.7421C338.449 95.5498 333.119 95.2933 326.68 94.9453C320.755 94.6156 315.26 94.2767 309.865 93.9012C303.006 93.425 296.137 92.8938 290.321 92.4267L289.671 92.3718C289.488 94.8537 289.287 97.3356 289.076 99.8176L288.81 103.023C288.691 104.525 288.508 106.036 288.334 107.501C288.16 108.93 287.986 110.405 287.867 111.861C287.491 116.458 287.098 121.056 286.713 125.653L286.136 132.248Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M329.449 124.831C331.476 124.831 332.823 123.587 332.823 121.996C332.823 120.162 331.707 119.546 329.552 119.251C327.961 119.02 327.653 118.648 327.653 117.904C327.653 117.198 328.192 116.698 329.231 116.698C330.283 116.698 330.835 117.109 331.002 118.071H332.567C332.387 116.313 331.207 115.415 329.231 115.415C327.32 115.415 326.037 116.544 326.037 118.045C326.037 119.764 327.076 120.431 329.27 120.726C330.758 120.97 331.181 121.291 331.181 122.137C331.181 122.984 330.463 123.548 329.449 123.548C327.897 123.548 327.525 122.779 327.41 121.855H325.768C325.896 123.587 326.948 124.831 329.449 124.831ZM334.475 124.703H337.233C340.453 124.703 342.005 122.804 342.005 120.136V120.021C342.005 117.352 340.453 115.531 337.259 115.531H334.475V124.703ZM336.181 123.356V116.878H337.169C339.324 116.878 340.222 118.071 340.222 120.046V120.149C340.222 122.176 339.234 123.356 337.182 123.356H336.181Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.TN = function () {
	    var _ref43 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref43$color = _ref43.color,
	        color = _ref43$color === undefined ? "#6496c2" : _ref43$color,
	        _ref43$labelColor = _ref43.labelColor,
	        labelColor = _ref43$labelColor === undefined ? "white" : _ref43$labelColor,
	        _ref43$tooltip = _ref43.tooltip,
	        tooltip = _ref43$tooltip === undefined ? {} : _ref43$tooltip,
	        _ref43$labelTooltip = _ref43.labelTooltip,
	        labelTooltip = _ref43$labelTooltip === undefined ? {} : _ref43$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M557.774 249.031L557.627 249.113L557.6 249.068C557.114 249.15 556.638 249.242 556.162 249.342C555.585 249.452 555.008 249.571 554.431 249.663C553.506 249.81 552.562 249.901 551.647 249.993C551.207 250.038 550.767 250.075 550.337 250.13C547.681 250.432 544.988 250.735 542.342 250.872L540.968 250.945C539.942 251 538.926 251.046 537.9 251.11C536.444 251.202 535.07 251.403 533.669 251.614C531.004 252.017 528.201 252.182 525.582 252.291C523.988 252.356 522.385 252.42 520.792 252.484C520.197 252.502 519.62 252.621 519.015 252.749C518.347 252.887 517.66 253.024 516.927 253.024C514.894 253.024 512.833 253.271 510.837 253.51C509.976 253.61 509.106 253.711 508.245 253.803C505.653 254.059 502.988 254.343 500.103 254.682C500.011 254.691 499.911 254.663 499.837 254.599C499.764 254.535 499.718 254.444 499.728 254.343C499.728 254.26 499.728 254.196 499.737 254.141C499.737 254.132 499.737 254.114 499.737 254.105C499.59 254.068 499.27 254.096 499.105 254.105C498.967 254.114 498.839 254.123 498.757 254.123C498.28 254.114 497.859 254.114 497.456 254.132C497.493 254.251 497.539 254.37 497.584 254.489C497.804 255.112 498.042 255.762 498.042 256.358C498.042 257.356 497.191 257.365 496.733 257.365C496.632 257.365 496.531 257.365 496.43 257.374L492.657 257.64C490.771 257.777 488.884 257.906 487.006 258.034C486.283 258.08 485.55 258.125 484.818 258.162C482.876 258.263 480.87 258.373 478.938 258.675C478.791 259.05 478.572 259.582 478.123 259.618C477.592 259.673 477.427 259.16 477.363 258.821C477.354 258.821 477.344 258.821 477.335 258.821C477.344 258.904 477.354 258.977 477.363 259.05C477.381 259.279 477.399 259.472 477.509 259.655L477.601 259.801C477.848 260.177 478.297 260.873 477.885 261.395C477.775 261.532 477.582 261.615 477.17 261.697C477.61 262.036 477.995 262.494 477.692 262.988C477.335 263.575 476.648 263.602 476.08 263.547C476.145 263.648 476.209 263.739 476.273 263.804C476.309 263.84 476.465 263.913 476.557 263.95C476.813 264.06 477.097 264.188 477.207 264.454C477.518 265.177 476.896 265.58 476.52 265.818C476.383 265.91 476.172 266.038 476.145 266.111C476.099 266.231 476.09 266.34 476.071 266.46C476.044 266.652 476.016 266.881 475.861 267.137C475.833 267.183 475.806 267.229 475.769 267.284C475.732 267.348 475.678 267.43 475.632 267.504L475.641 267.705H475.613C475.659 267.723 475.732 267.742 475.787 267.76C475.989 267.824 476.264 267.907 476.438 268.145C476.74 268.557 476.63 268.886 476.538 269.17C476.52 269.234 476.493 269.308 476.474 269.381C476.447 269.473 476.383 269.546 476.3 269.592C476.218 269.637 476.117 269.647 476.026 269.61C475.952 269.583 475.879 269.555 475.797 269.518C475.577 269.427 475.311 269.317 475.165 269.372C475.137 269.381 475.101 269.418 475.082 269.473C475.119 269.592 475.174 269.61 475.311 269.647C475.513 269.702 475.879 269.802 475.943 270.251C475.98 270.508 475.934 270.709 475.815 270.865C475.632 271.094 475.366 271.121 475.146 271.149C475.046 271.158 474.936 271.167 474.881 271.204C474.826 271.24 474.771 271.304 474.698 271.423C474.615 271.552 474.514 271.707 474.35 271.845C473.965 272.156 473.425 272.257 473.214 272.284L473.086 272.293C472.756 272.321 472.573 272.367 472.545 272.495C472.555 272.55 472.692 272.77 472.774 272.907C473.003 272.77 473.241 272.641 473.47 272.696C473.937 272.788 474.203 273.383 474.176 273.731C474.121 274.363 473.452 274.702 472.939 274.949C473.168 275.325 473.287 275.655 473.425 276.085C473.461 276.204 473.434 276.332 473.351 276.424C473.269 276.515 473.141 276.552 473.022 276.525C472.948 276.506 472.857 276.497 472.756 276.488C472.445 276.451 472.097 276.406 471.886 276.232C471.749 276.122 471.684 275.966 471.648 275.847C471.639 275.838 471.639 275.819 471.629 275.801C471.629 275.847 471.62 275.92 471.629 276.021C471.639 276.177 471.657 276.204 471.721 276.296C471.776 276.378 471.858 276.497 471.923 276.699C472.032 277.01 471.978 277.962 471.739 278.356C471.62 278.549 471.474 278.604 471.373 278.622C471.254 278.64 471.135 278.622 471.025 278.576C471.007 278.631 470.988 278.677 470.952 278.723C470.952 278.75 470.952 278.778 470.961 278.805C470.97 278.924 470.979 279.061 470.979 279.153C470.952 279.583 470.851 279.812 470.567 280.078C470.512 280.124 470.457 280.17 470.393 280.206C470.503 280.206 470.64 280.206 470.769 280.261C471.117 280.389 471.336 280.6 471.419 280.875C471.52 281.214 471.41 281.553 471.227 281.873C471.474 281.974 471.648 282.148 471.639 282.606C471.63 282.954 471.373 283.622 470.879 283.714C470.595 283.769 470.356 283.595 470.155 283.458C470.091 283.412 469.972 283.329 469.935 283.32C469.871 283.375 469.761 283.842 469.715 283.998C469.688 284.089 469.67 284.172 469.651 284.236L469.605 284.392C469.45 284.886 469.312 284.95 468.781 285.005C468.543 285.033 468.287 285.014 468.204 285.033C468.204 285.033 468.195 285.06 468.177 285.133L469.899 285.024C475.348 284.694 480.989 284.346 486.521 283.915C489.653 283.668 492.785 283.421 495.927 283.164C496.467 283.119 497.007 283.055 497.539 282.99L497.649 282.881L497.722 282.963C498.033 282.926 498.345 282.881 498.647 282.835C499.306 282.743 499.966 282.652 500.625 282.578C501.779 282.45 502.96 282.377 504.105 282.294C504.691 282.258 505.278 282.212 505.855 282.166C511.615 281.717 517.339 281.232 524.162 280.637C527.514 280.344 530.921 280.014 534.429 279.629L534.511 279.611V279.62C537.25 279.327 540.052 278.997 542.955 278.649L550.969 277.679C551.051 277.669 551.179 277.669 551.326 277.66C551.473 277.66 551.793 277.651 551.958 277.614L551.949 277.55L552.05 277.541C552.086 277.303 552.013 276.543 551.995 276.241C551.976 276.039 551.958 275.865 551.958 275.764C551.958 275.6 551.94 275.444 551.931 275.279C551.885 274.675 551.821 273.997 552.361 273.484C552.407 273.438 552.462 273.383 552.517 273.328C552.764 273.072 553.048 272.788 553.332 272.678C553.616 272.577 553.918 272.614 554.183 272.641C554.394 272.669 554.586 272.687 554.724 272.641C555.264 272.467 555.475 271.9 555.557 271.46L556.024 268.896C556.043 268.804 556.098 268.722 556.18 268.667C556.262 268.612 556.354 268.603 556.446 268.621C556.61 268.621 557.133 268.227 557.325 268.071C557.453 267.971 557.572 267.888 557.655 267.833C557.893 267.687 558.122 267.522 558.369 267.357C558.873 267.009 559.395 266.643 559.944 266.395C560.402 266.185 560.887 266.166 561.364 266.148C561.895 266.13 562.399 266.102 562.783 265.809C562.957 265.681 563.131 265.544 563.305 265.415C563.809 265.04 564.34 264.646 564.78 264.225C564.935 264.078 565.054 263.941 565.174 263.739L565.256 263.611C565.283 263.575 565.302 263.538 565.329 263.501C565.293 263.391 565.265 263.227 565.375 263.071C565.503 262.879 565.751 262.778 566.08 262.65C566.154 262.622 566.218 262.595 566.263 262.576L567.564 261.926C567.692 261.862 567.884 261.789 568.104 261.706C568.471 261.569 569.075 261.34 569.212 261.148C569.249 261.084 569.277 260.836 569.286 260.717C569.295 260.607 569.304 260.507 569.322 260.433L569.625 258.885C569.68 258.565 569.734 258.464 570.009 258.299L570.083 258.254C570.22 258.171 570.33 258.125 570.431 258.08C570.559 258.025 570.641 257.988 570.779 257.86C571.017 257.64 571.246 257.411 571.475 257.191C571.768 256.907 572.061 256.614 572.363 256.339L572.482 256.23C572.748 255.973 573.077 255.653 573.48 255.698C573.636 255.717 573.856 255.79 574.039 256.065C574.259 256.394 574.176 256.687 574.121 256.889C574.085 257.008 574.066 257.09 574.076 257.173C574.103 257.31 574.213 257.521 574.387 257.548C574.378 257.548 574.414 257.493 574.442 257.457C574.515 257.356 574.616 257.21 574.79 257.1C574.918 257.017 575.01 256.971 575.083 256.935C575.165 256.898 575.175 256.898 575.257 256.788C575.404 256.587 575.523 256.358 575.642 256.101C575.816 255.744 575.99 255.369 576.301 255.066C576.86 254.526 577.748 253.821 578.472 253.455C579.021 253.18 579.525 253.4 579.937 253.574C580.212 253.693 580.459 253.793 580.715 253.784H580.761C580.78 253.748 580.807 253.711 580.844 253.656C581.018 253.4 581.164 253.097 581.311 252.804C581.384 252.649 581.466 252.493 581.549 252.337C581.732 251.989 581.897 251.632 582.062 251.275C582.199 250.982 582.327 250.698 582.474 250.414C582.831 249.709 583.481 249.278 584.058 248.894C584.15 248.83 584.278 248.82 584.379 248.857C584.489 248.903 584.562 248.994 584.589 249.104C584.626 249.141 584.818 249.187 584.937 249.168C584.937 249.04 584.901 248.83 584.882 248.701C584.864 248.555 584.846 248.417 584.846 248.326C584.828 247.621 584.837 246.915 584.837 246.219V244.983C584.351 245.047 583.857 245.12 583.371 245.185L582.428 245.294C582.364 245.304 582.263 245.294 582.117 245.304C582.107 245.413 582.08 245.523 581.998 245.615C581.75 245.926 581.64 245.963 581.265 246.018L579.681 246.256C578.984 246.357 578.288 246.458 577.592 246.558L576.173 246.76C573.902 247.089 571.585 247.355 569.35 247.611L567.307 247.85C566.034 247.996 564.771 248.161 563.498 248.326C561.895 248.527 560.292 248.738 558.68 248.912C558.387 248.93 558.085 248.976 557.774 249.031Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M517.15 272.453H518.869V264.628H521.422V263.281H514.597V264.628H517.15V272.453ZM522.794 272.453H524.347V265.424L528.477 272.453H530.247V263.281H528.695V269.913L524.834 263.281H522.794V272.453Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.TX = function () {
	    var _ref44 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref44$color = _ref44.color,
	        color = _ref44$color === undefined ? "#6496c2" : _ref44$color,
	        _ref44$labelColor = _ref44.labelColor,
	        labelColor = _ref44$labelColor === undefined ? "white" : _ref44$labelColor,
	        _ref44$tooltip = _ref44.tooltip,
	        tooltip = _ref44$tooltip === undefined ? {} : _ref44$tooltip,
	        _ref44$labelTooltip = _ref44.labelTooltip,
	        labelTooltip = _ref44$labelTooltip === undefined ? {} : _ref44$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M419.346 380.285C419.383 380.303 419.419 380.322 419.447 380.34C419.099 380.468 418.741 380.55 418.348 380.55H417.276L416.443 380.752L415.298 381.201L411.964 382.739C411.964 382.721 411.717 382.831 411.717 382.831L409.363 382.922L406.185 382.419L406.57 381.695L406.79 380.496L406.799 380.331L406.744 379.992L406.295 379.103L406.13 378.92L406.048 378.893L405.279 379.241L404.921 379.433L403.172 380.871C402.842 381.411 402.32 382.007 402.119 382.602C401.908 383.216 402.156 383.28 402.641 383.82C403.071 384.296 403.52 384.763 403.96 385.24C404.811 386.155 405.105 386.458 406.295 386.806C404.5 388.381 402.265 389.407 400.571 391.101L400.434 391.266C400.434 391.275 400.342 391.458 400.342 391.458C399.225 392.438 398.126 393.436 396.981 394.398C396.349 394.929 395.662 395.158 394.92 395.524C392.805 396.559 390.936 398.116 388.766 399.041C388.656 399.087 386.98 399.811 386.98 399.811L385.799 400.36L383.601 401.487L382.831 401.999L382.776 402.036L381.732 402.769L381.274 403.108L381.155 403.309L381.119 403.181L381.201 403.034L383.683 401.175L384.058 397.979L383.985 397.906L383.884 397.86L383.573 397.906L382.877 398.071L382.575 398.171L382.328 398.373L382.035 398.886L381.082 399.325L379.571 399.939L378.344 398.822L378.206 398.419L378.106 397.613L377.116 397.658L377.025 397.704L376.796 397.906L377.611 399.829L377.648 399.875L378.325 399.994L378.756 400.287L380.542 401.899L380.679 402.036L380.807 402.21L380.78 402.329L377.886 403.785L377.748 403.831L376.631 404.152L376.237 404.023L376.127 403.923L375.147 402.86L374.809 404.426C374.809 404.436 374.68 405.232 374.68 405.232L374.854 405.525V405.626L374.653 406.075L374.497 406.185L372.556 407.504H372.125L371.447 407.44L371.09 407.962L370.779 409.528L369.423 411.579C369.423 411.588 368.361 412.477 368.361 412.477L367.216 411.918L366.941 411.973C366.209 412.303 365.165 412.66 365.485 413.64C365.595 413.96 367.335 415.435 367.344 415.426C366.648 417.019 366.181 418.567 365.604 420.216C364.881 422.267 363.425 422.368 361.465 422.24C361.153 423 362.417 423.155 362.921 423.119C363.599 423.073 364.057 422.469 364.789 422.551C364.817 423.375 364.56 424.273 364.441 425.088C364.066 425.161 363.699 425.225 363.324 425.298C363.47 425.894 363.626 426.48 363.773 427.075C363.296 427.084 362.811 427.084 362.335 427.094C362.463 427.753 362.609 428.421 362.646 429.09C362.655 429.182 362.564 430.427 362.609 430.464C362.628 430.473 363.91 431.242 363.91 431.242L364.295 433.413L364.331 433.972V433.981L364.148 435.565L363.241 435.684L363.745 437.223L364.853 437.836C364.862 437.827 364.936 437.873 364.936 437.873L365 438.761L365.357 440.126L365.339 441.417L366.035 442.846L366.996 443.762L367.692 444.43L367.729 444.476C367.436 445.438 366.648 444.952 365.824 445.2C365.568 445.273 364.111 446.628 364.67 446.802C363.049 446.308 361.978 445.566 360.915 444.22C360.366 443.524 359.889 443.57 358.964 443.405C358.342 443.295 357.71 443.13 357.078 443.084C356.116 443.011 355.31 443.341 354.459 443.359C353.708 443.368 352.251 443.066 351.537 442.782C350.786 442.489 349.87 441.811 349.284 441.289C348.899 440.941 348.698 440.511 348.249 440.245C347.727 439.934 346.894 439.622 346.289 439.558C346.06 439.531 345.63 439.705 345.447 439.622C345.373 439.595 344.311 439.119 344.311 439.119L342.772 437.571L340.986 437.049L338.99 436.728L338.092 436.151L338.285 435.043L337.36 434.466L337.186 434.063L337.149 433.944L337.131 433.862C337.131 433.852 336.618 431.801 336.618 431.801C336.618 431.783 336.151 430.061 336.151 430.061L335.775 429.108L334.979 427.982L334.099 427.469L334.429 426.773L333.76 425.921L333.092 425.903L333.037 425.216L333.055 425.152L333.129 425.088L333.403 424.685L333.504 423.274L333.312 421.992L333.156 421.745H333.129C333.129 421.736 332.872 421.708 332.872 421.708L332.533 421.498L332.506 421.489L332.405 421.177L332.332 421.095L332.313 421.067C332.295 421.049 332.277 420.985 332.277 420.985L332.35 420.884L332.359 420.115L332.607 419.538L332.698 419.199C332.735 418.924 332.881 418.503 332.826 418.237C332.744 417.834 332.561 417.953 332.414 417.633C332.341 417.477 332.396 417.212 332.368 417.047C332.03 414.766 329.795 415.462 328.604 413.85C328.311 413.457 328.036 413.035 327.688 412.751C327.331 412.449 327.002 412.339 326.809 411.799C326.654 411.35 326.828 410.911 326.69 410.526C326.617 410.324 326.333 410.205 326.26 409.995C326.186 409.793 326.251 409.454 326.251 409.235C326.022 409.134 325.49 409.015 325.335 408.823C325.097 408.529 325.207 407.907 325.042 407.549C324.84 407.147 324.364 406.542 324.025 406.249C323.393 405.69 322.477 405.516 321.845 404.949C321.589 404.72 320.984 404.133 320.875 403.804C320.765 403.437 320.984 402.998 320.856 402.631C320.71 402.192 320.27 401.945 320.224 401.487C320.188 401.029 320.472 400.388 320.582 399.93C319.803 399.344 319.528 399.334 319.657 398.364C319.162 398.089 319.07 398.043 318.988 397.494L318.219 396.761L318.164 395.644L317.678 394.206L316.936 392.923L316.231 391.953L315.773 389.471L314.024 386.659C314.015 386.659 310.443 383.463 310.443 383.463L310.214 382.428L309.024 381.933L308.721 381.43L307.769 381.027L307.879 379.644L306.99 379.351L306.89 378.893L305.873 378.435L305.223 377.208L304.472 376.951L304.6 376.448L303.657 376.594L303.29 375.779L302.228 376.814L301.889 376.796L299.856 376.567C299.856 376.557 299.581 376.475 299.581 376.475L299.471 376.438C298.867 376.301 298.244 376.109 297.621 376.054C296.605 375.962 295.561 376.301 294.572 375.953C293.537 375.596 292.538 374.845 291.586 374.304C290.835 374.79 290.606 375.156 290.148 375.935C289.773 375.788 289.241 375.449 288.848 375.44C288.381 375.431 287.703 375.816 287.263 375.962C286.219 376.31 285.844 376.438 285.276 377.363C284.204 379.113 283.206 380.789 282.492 382.73C282.189 383.554 282.153 384.608 281.457 385.23C281.081 385.569 280.706 385.395 280.33 385.661C279.955 385.926 280.019 386.494 279.708 386.824C279.46 387.09 278.984 387.227 278.663 387.392C278.48 388.289 278.599 388.995 277.5 388.976C276.987 388.967 276.511 388.821 276.072 388.537C275.953 388.463 274.963 387.538 274.991 387.52C274.771 387.639 274.56 387.749 274.341 387.868C273.828 387.218 273.324 386.577 272.811 385.926C272.28 385.258 272.17 385.249 271.318 385.075C270.558 384.919 269.816 384.892 269.23 384.406C268.617 383.902 268.635 383.371 267.902 383.06C267.005 382.684 266.162 382.602 265.411 381.988C264.724 381.43 263.598 380.77 263.167 380.001C262.929 379.571 262.993 379.058 262.7 378.673C262.371 378.243 261.904 378.087 261.427 377.922C260.502 377.592 259.944 376.933 259.229 376.274C258.918 375.99 258.515 375.706 258.332 375.339C258.13 374.927 258.204 374.369 258.048 373.938C257.691 372.912 256.967 372.006 256.546 371.007C256.253 370.302 256.042 369.267 256.161 368.507C256.216 368.15 256.518 367.839 256.564 367.481C256.637 366.959 256.555 366.172 256.454 365.65C256.299 364.835 255.658 364.084 255.264 363.333C255.062 362.957 254.65 362.527 254.494 362.16C254.311 361.721 254.421 361.098 254.348 360.631C254.21 359.807 254.027 358.845 253.487 358.268C253.34 358.112 253.093 358.057 252.974 357.883C252.809 357.645 252.883 357.261 252.727 357.022C252.315 356.372 251.536 355.978 250.987 355.447C250.52 354.998 250.153 354.504 249.512 354.302C249.137 354.183 248.862 354.312 248.45 354.138C247.946 353.918 247.47 353.487 247.012 353.185C247.14 353.075 247.149 352.837 247.278 352.727C246.545 352.123 245.418 351.5 244.878 350.74C244.356 350.016 244.64 349.247 243.861 348.56C243.541 348.285 243.12 348.148 242.808 347.882C242.689 347.782 242.534 347.489 242.396 347.351C242.222 347.186 242.048 347.196 241.902 347.012C241.315 346.298 240.885 345.4 240.244 344.686C239.978 344.393 239.868 343.871 239.594 343.624C239.374 343.431 238.65 343.202 238.357 343.093C237.533 342.809 236.599 342.451 236.022 341.71C235.701 341.298 235.72 340.803 235.472 340.373C235.234 339.96 235.005 339.805 234.822 339.356C234.538 338.66 234.52 337.277 233.686 337.039C233.741 336.947 233.723 336.81 233.778 336.709C233.503 336.324 233.219 336.361 232.844 336.325L231.782 334.896C231.479 334.584 231.186 334.264 230.857 333.879C230.701 333.696 230.655 333.632 230.637 333.504C230.637 333.476 230.637 333.458 230.637 333.44C230.692 333.385 230.774 333.293 230.847 333.128C230.957 332.89 231.04 332.286 230.976 332.02C230.966 331.974 230.948 331.928 230.921 331.892C231.14 331.892 231.461 331.947 231.608 331.974C231.727 331.993 231.836 332.011 231.928 332.02L239.786 332.844C243.202 333.201 246.618 333.549 250.043 333.898L254.971 334.401C258.433 334.758 261.959 335.061 265.365 335.354L268.672 335.647C271.483 335.894 274.295 336.105 277.116 336.325C278.709 336.444 280.294 336.563 281.887 336.691C281.96 336.7 282.052 336.709 282.134 336.727C282.354 336.764 282.592 336.801 282.821 336.755L282.94 336.737C283.307 336.682 283.426 336.544 283.444 336.169L284.387 323.393C284.726 318.804 285.157 314.143 285.578 309.628L285.624 309.133C285.99 305.14 286.357 300.762 286.741 295.753C287.117 290.816 287.492 285.889 287.868 280.953L288.216 276.383C288.472 272.948 288.738 269.505 288.994 266.061C289.067 265.026 289.15 263.982 289.223 262.947C289.306 261.757 289.397 260.557 289.489 259.366C289.498 259.284 289.498 259.174 289.498 259.064C289.498 258.908 289.498 258.634 289.535 258.542C289.544 258.524 289.599 258.496 289.654 258.469C289.736 258.423 289.855 258.368 289.956 258.267L294.251 258.57C297.869 258.826 301.477 259.073 305.095 259.302C308.657 259.531 313.346 259.815 318.063 260.053L319.62 260.136C321.049 260.209 322.477 260.282 323.906 260.346L327.093 260.493C328.357 260.548 329.786 260.438 331.013 260.667C331.05 260.676 331.086 260.676 331.123 260.685C331.15 260.85 331.095 261.235 331.068 261.436C331.05 261.601 331.031 261.738 331.022 261.839L330.857 266.318C330.802 267.71 330.747 269.102 330.692 270.494L330.592 272.875C330.436 276.602 330.28 280.33 330.125 284.048L330.061 285.504C329.978 287.309 329.905 289.113 329.832 290.917C329.822 291.219 329.795 291.531 329.758 291.86C329.694 292.602 329.621 293.372 329.74 294.068C329.822 294.58 330.042 294.709 330.39 294.864C330.463 294.892 330.546 294.928 330.647 294.983C330.784 295.057 330.94 295.121 331.105 295.185C331.416 295.313 331.736 295.451 331.947 295.625C332.24 295.872 332.487 296.211 332.735 296.577C333.101 297.099 333.477 297.649 334.081 297.969C334.447 298.171 335.244 298.226 335.601 298.006C335.876 297.841 336.004 297.649 336.087 297.529C336.105 297.493 336.142 297.447 336.151 297.447C336.151 297.447 336.197 297.429 336.38 297.447C336.774 297.493 336.966 297.63 337.277 297.85L337.515 298.015C337.717 298.143 338.248 298.5 338.77 298.051C339.027 297.832 339.127 297.548 339.201 297.337C339.21 297.3 339.228 297.255 339.246 297.218C339.274 297.227 339.31 297.246 339.347 297.264L339.576 297.383C339.897 297.548 340.144 297.676 340.318 297.923C340.602 298.308 340.767 298.61 340.776 299.013C340.785 299.453 340.794 300.011 340.959 300.552C341.16 301.229 341.591 301.294 342.131 301.376C342.415 301.422 342.699 301.413 342.965 301.413C343.12 301.413 343.285 301.413 343.441 301.422L343.587 301.431C344.055 301.458 344.421 301.477 344.778 301.669C344.915 301.742 345.044 301.825 345.181 301.907C345.492 302.099 345.813 302.301 346.188 302.429C346.738 302.612 347.306 302.713 347.864 302.741C348.286 302.759 348.597 302.658 348.918 302.567C349.101 302.512 349.284 302.457 349.504 302.42C349.879 302.365 350.017 302.548 350.291 303.052C350.502 303.437 350.74 303.876 351.244 304.004C351.903 304.178 352.325 303.611 352.663 303.153C352.874 302.86 353.112 302.539 353.323 302.53C353.588 302.502 353.936 302.658 354.257 302.786C354.404 302.841 354.541 302.896 354.66 302.933C354.77 302.97 354.889 302.997 355.008 303.034C355.31 303.116 355.631 303.199 355.805 303.354C356.034 303.574 356.18 303.876 356.318 304.188C356.583 304.746 356.904 305.451 357.902 305.479C358.039 305.488 358.177 305.451 358.323 305.424C358.47 305.397 358.781 305.332 358.818 305.406C358.882 305.534 358.717 305.873 358.607 306.102C358.497 306.322 358.397 306.532 358.369 306.816C358.333 307.063 358.378 307.192 358.58 307.338L358.671 307.411C358.864 307.576 359.157 307.686 359.404 307.778C359.477 307.805 359.541 307.833 359.606 307.851C360.183 308.089 360.558 308.043 361.108 307.668C361.602 307.329 362.014 306.889 362.39 306.468C362.5 306.34 362.582 306.221 362.655 306.129C362.674 306.102 362.692 306.074 362.71 306.047C362.738 306.065 362.784 306.083 362.848 306.129C362.994 306.23 363.141 306.331 363.287 306.441C363.589 306.66 363.901 306.889 364.231 307.054C364.707 307.292 365.11 307.192 365.494 307.063C365.613 307.659 365.797 308.4 366.346 308.684C366.648 308.84 367.006 308.84 367.409 308.666C367.811 308.492 368.132 308.135 368.443 307.787C368.746 307.448 369.048 307.109 369.313 307.1C369.414 307.109 369.597 307.182 369.762 307.347C369.781 307.366 369.799 307.375 369.808 307.393C369.808 307.411 369.808 307.43 369.808 307.457C369.799 307.585 369.735 307.741 369.661 307.906C369.588 308.071 369.515 308.245 369.478 308.428C369.359 309.069 369.671 309.5 370.037 309.994C370.293 310.342 370.568 310.525 370.889 310.489C371.447 310.452 371.805 309.811 372.088 309.298L373.325 307.155C373.371 307.082 373.416 306.99 373.462 306.889C373.49 306.825 373.526 306.761 373.563 306.697C373.719 307.054 373.874 307.421 374.094 307.741C374.415 308.199 374.836 308.327 375.239 308.437L375.431 308.492C376.43 308.794 377.162 308.483 377.941 308.117C378.078 308.602 378.554 308.877 378.939 309.087C379.067 309.161 379.186 309.225 379.314 309.316C379.672 309.554 379.782 309.6 380.212 309.573C380.322 309.564 380.413 309.545 380.505 309.536C380.697 309.5 380.752 309.499 380.835 309.545C380.89 309.582 380.99 309.774 381.045 309.893C381.183 310.168 381.338 310.479 381.641 310.589C381.879 310.672 382.181 310.58 382.621 310.425C382.703 310.397 382.785 310.37 382.831 310.351C382.932 310.324 383.069 310.305 383.216 310.278C383.82 310.168 384.571 310.04 384.901 309.582C385.093 309.316 385.13 309.042 385.158 308.822C385.203 308.529 385.222 308.465 385.368 308.4C385.771 308.236 386.293 308.226 386.806 308.208C387.017 308.199 387.218 308.199 387.41 308.181C387.685 308.153 387.987 308.217 388.299 308.291C388.683 308.373 389.086 308.455 389.499 308.391C389.828 308.336 390.286 308.089 391.01 307.695C391.587 307.375 392.942 306.633 393.18 306.807C393.29 306.926 393.281 306.972 393.272 307.073C393.254 307.164 393.226 307.347 393.354 307.503C393.492 307.686 393.739 307.75 394.124 307.805C394.875 307.906 395.681 307.998 396.615 307.924C397.155 307.878 398.053 307.814 398.217 306.963C398.245 306.816 398.236 306.679 398.227 306.56C398.208 306.312 398.208 306.312 398.336 306.276C398.694 306.184 399.399 306.825 399.738 307.137C399.829 307.219 399.903 307.292 399.967 307.347C400.498 307.796 401.029 308.236 401.569 308.666C401.725 308.785 401.872 308.913 402.027 309.042C402.467 309.417 402.916 309.802 403.447 310.058C404.051 310.351 404.729 310.617 405.453 310.827C406.094 311.02 406.735 311.203 407.376 311.386L408.457 311.698C408.521 311.716 408.566 311.725 408.603 311.734V311.844H408.704L408.887 312.1C409.061 312.357 409.162 312.485 409.528 312.723L409.693 312.833C409.913 312.98 410.142 313.126 410.398 313.236C410.883 313.438 411.067 313.383 411.433 313.181L411.772 313.007C412.331 312.723 412.761 312.503 413.356 312.522C414.043 312.549 414.932 312.769 415.041 312.998C415.069 313.071 415.051 313.328 415.041 313.447C415.032 313.557 415.023 313.648 415.032 313.722L415.234 323.301C415.27 325.014 415.298 326.726 415.344 328.439C415.362 329.282 415.362 330.124 415.371 330.976C415.38 333.22 415.389 335.537 415.673 337.772C415.701 338 415.719 338.275 415.728 338.55C415.756 339.182 415.792 339.896 416.021 340.427C416.241 340.94 416.763 341.426 417.221 341.865C417.413 342.049 417.597 342.223 417.743 342.378C418.1 342.781 418.128 342.946 418.219 343.505L418.751 346.701C418.86 347.36 419.273 347.763 419.666 348.139C419.767 348.23 419.868 348.331 419.969 348.441C420.5 349 420.912 349.604 421.37 350.264C422.02 351.207 422.203 352.397 422.386 353.561C422.423 353.79 422.46 354.009 422.496 354.229C422.515 354.321 422.57 354.412 422.652 354.458C422.734 354.513 422.835 354.531 422.927 354.504L423.192 354.431L423.229 357.636C423.229 357.819 423.238 357.993 423.238 358.176C423.257 359.001 423.284 359.788 423.009 360.521C422.771 361.153 422.405 361.785 422.048 362.399C421.874 362.701 421.7 363.003 421.535 363.305C421.48 363.415 421.407 363.525 421.333 363.653C420.976 364.249 420.527 364.99 420.857 365.641C420.912 365.76 420.985 365.87 421.049 365.989C421.232 366.291 421.388 366.556 421.342 366.868C421.333 366.932 421.306 366.959 421.168 367.06C421.031 367.152 420.857 367.28 420.756 367.527C420.619 367.875 420.747 368.388 420.866 368.846C420.903 368.983 420.93 369.102 420.949 369.203C420.976 369.341 421.004 369.487 421.031 369.634C421.086 369.908 421.141 370.192 421.159 370.476C421.187 370.824 421.178 371.2 421.168 371.557C421.159 371.74 421.159 371.932 421.159 372.116C421.159 372.28 421.168 372.454 421.187 372.638C421.214 372.986 421.232 373.343 421.168 373.599C421.059 374.03 420.71 374.424 420.344 374.845C420.042 375.193 419.721 375.559 419.529 375.962C419.428 376.164 419.419 376.383 419.401 376.567C419.392 376.704 419.383 376.841 419.337 376.915C419.273 377.024 419.053 377.153 418.86 377.263C418.558 377.427 418.219 377.62 418.082 377.959C417.908 378.389 418.421 379.415 418.586 379.625C418.696 379.955 419.044 380.129 419.346 380.285ZM378.847 404.408L378.041 404.756L377.858 404.839L374.387 407.22L374.177 408.007V408.017H374.167L370.715 412.513V412.522L367.601 417.111L365.586 422.331V422.34L365.43 423.165L365.348 423.586L365.284 424.419L365.265 425.491L365.256 426.214L365.238 428.046V430.207L366.273 434.017H366.282L367.436 437.214V437.223L367.647 437.662L367.83 438.221L368.132 439.641L368.288 440.62L368.361 441.262L368.343 441.802L368.48 442.974L368.608 443.148H368.654L368.727 443.167L368.453 440.996L368.269 439.714L368.132 439.027L367.702 437.214L366.731 433.953H366.722L366.603 433.559L366.584 433.486L366.557 433.422L366.081 431.673L365.806 430.427L365.613 429.328L365.604 429.273L365.531 428.687L365.43 427.249V426.288L365.476 425.381L365.586 424.346L365.714 423.494L365.934 422.496L365.989 422.34V422.331L368.004 417.212L370.797 412.742V412.733L373.801 408.896L373.838 408.859L373.865 408.823L375.294 407.586L376.274 406.817L377.409 406.002L378.527 405.306L378.545 405.297L378.756 405.196L380.23 404.472L380.047 404.161L378.847 404.408Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M336.413 354.69H338.132V346.865H340.685V345.518H333.86V346.865H336.413V354.69ZM341.38 354.69H343.124L345.279 351.111L347.435 354.69H349.384L346.447 349.943L349.154 345.518H347.396L345.459 348.776L343.509 345.518H341.585L344.33 349.982L341.38 354.69Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.UT = function () {
	    var _ref45 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref45$color = _ref45.color,
	        color = _ref45$color === undefined ? "#6496c2" : _ref45$color,
	        _ref45$labelColor = _ref45.labelColor,
	        labelColor = _ref45$labelColor === undefined ? "white" : _ref45$labelColor,
	        _ref45$tooltip = _ref45.tooltip,
	        tooltip = _ref45$tooltip === undefined ? {} : _ref45$tooltip,
	        _ref45$labelTooltip = _ref45.labelTooltip,
	        labelTooltip = _ref45$labelTooltip === undefined ? {} : _ref45$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M209.417 224.161C209.746 221.799 210.03 219.39 210.305 217.054C210.69 213.849 211.083 210.525 211.587 207.264C212.091 204.013 212.54 200.698 212.979 197.492C213.19 195.935 213.4 194.387 213.62 192.84L214.353 187.638C214.939 183.498 215.525 179.358 216.084 175.21L216.633 171.134C210.708 170.31 195.944 168.176 194.928 168.011L192.483 167.608C192.437 167.599 192.336 167.59 192.226 167.59C191.466 167.535 191.118 167.48 190.944 167.278C190.77 167.077 190.807 166.775 190.999 165.969C191.026 165.868 191.045 165.795 191.054 165.749L193.289 151.727C193.38 151.132 193.481 150.546 193.572 149.951C189.698 149.337 179.148 147.551 171.391 146.232C168.085 145.674 165.319 145.207 163.853 144.959L162.544 144.74C160.456 144.401 158.313 144.044 156.215 143.54L156.206 143.567H156.197L153.422 157.974C153.101 159.659 151.105 169.889 148.824 181.648C145.619 198.133 141.626 218.639 141.195 220.938C140.857 222.714 140.518 224.491 140.17 226.277C140.005 227.156 139.831 228.026 139.666 228.905L145.646 230.023C150.226 230.875 154.951 231.763 159.613 232.578C164.549 233.439 169.797 234.327 175.192 235.206L179.468 235.912C183.196 236.525 187.061 237.157 190.852 237.734C195.926 238.503 201.266 239.273 207.164 240.088C207.447 238.073 207.731 236.049 208.015 234.034C208.501 230.737 208.968 227.449 209.417 224.161Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M175.008 199.966C177.433 199.966 178.728 198.645 178.728 196.246V190.666H177.009V196.105C177.009 198.004 176.342 198.594 175.021 198.594C173.661 198.594 173.123 197.901 173.123 196.22V190.666H171.404V196.349C171.404 198.709 172.712 199.966 175.008 199.966ZM182.585 199.838H184.304V192.013H186.857V190.666H180.032V192.013H182.585V199.838Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.VA = function () {
	    var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref46$color = _ref46.color,
	        color = _ref46$color === undefined ? "#6496c2" : _ref46$color,
	        _ref46$labelColor = _ref46.labelColor,
	        labelColor = _ref46$labelColor === undefined ? "white" : _ref46$labelColor,
	        _ref46$tooltip = _ref46.tooltip,
	        tooltip = _ref46$tooltip === undefined ? {} : _ref46$tooltip,
	        _ref46$labelTooltip = _ref46.labelTooltip,
	        labelTooltip = _ref46$labelTooltip === undefined ? {} : _ref46$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M639.166 198.527L639.697 199.086L639.716 199.351L639.303 199.489L639.093 199.25L639.303 199.04L639.148 198.848L638.855 199.022L638.342 201.751C638.333 201.751 638.378 202.722 638.378 202.722L638.635 203.555L638.461 203.537L637.765 203.024L637.692 203.07L638.186 203.582L639.047 204.022L638.836 204.315L638.131 204.434L638.14 204.535L638.653 204.626L639.633 204.645L640.183 204.333L640.705 204.178L640.915 203.701L641.685 203.546L641.969 202.905L642.161 202.767L642.692 203.152L642.829 203.921L642.72 204.169L642.289 204.15L642.161 204.352V204.553L642.317 204.443L642.6 204.416L642.93 204.581L643.223 204.746L643.791 204.965L643.928 205.79L643.516 205.964L643.544 206.037L643.809 205.973L644.084 205.863L644.615 205.936L644.579 206.312L644.689 206.321L644.808 206.028L645.183 206.284L645.897 206.257L646.63 206.046C646.594 206.055 647.28 206.605 647.335 206.641C647.418 206.696 647.473 206.879 647.583 206.953C647.638 206.934 647.693 206.889 647.738 206.852C647.61 206.577 647.628 206.275 647.61 205.982C647.958 205.964 648.288 206.33 648.553 206.513C648.499 206.357 648.444 206.202 648.389 206.046C648.7 205.954 648.911 206.019 649.085 206.293C648.993 206.367 648.966 206.513 648.874 206.577C649.195 206.669 649.579 206.724 649.872 206.879C650.138 207.017 650.174 207.173 650.431 207.347C650.385 207.383 650.275 207.429 650.22 207.447C650.165 207.365 650.037 207.337 649.982 207.255C649.936 207.31 649.881 207.447 649.872 207.511C649.909 207.594 649.982 207.713 650.028 207.795C650.449 207.814 650.871 207.804 651.292 207.804C651.182 207.942 651.072 208.07 650.962 208.207C651.191 208.427 651.274 208.189 651.53 208.198C651.713 208.207 651.878 208.308 652.061 208.363C652.382 208.464 652.721 208.482 653.05 208.565C653.444 208.665 653.838 208.803 654.213 208.968C654.552 209.123 654.635 209.279 654.699 209.627C654.717 209.737 654.763 210.479 654.708 210.515L654.497 210.653L654.25 210.497L653.765 210.021L653.572 210.14L653.243 210.112L652.785 209.948L652.455 209.957L652.418 210.057L652.821 210.122L653.004 210.259L653.581 210.332L653.746 210.277L653.975 210.534L654.14 211.028L654.47 211.074L654.506 211.239L654.314 211.422L654.488 211.907L654.232 212.045L654.195 212.246L654.479 212.448L654.506 212.796L653.81 212.741L653.545 212.64C653.545 212.649 653.81 212.75 653.81 212.75L654.342 213.052L654.369 213.235L654.186 213.327L654.397 213.519L654.442 213.822L654.616 213.785L654.882 213.565L655.312 213.968L655.248 214.124L655.074 214.197L654.937 214.078L654.873 213.931L654.699 214.17L654.223 214.105C654.186 214.179 654.158 214.243 654.122 214.316C653.884 214.142 653.691 214.215 653.435 214.16C653.288 214.124 653.233 213.986 653.023 214.005C653.05 213.941 653.069 213.858 653.105 213.803C653.169 213.803 653.233 213.812 653.298 213.812C653.298 213.757 653.298 213.693 653.307 213.638C653.178 213.565 653.133 213.538 653.014 213.455C652.895 213.638 652.904 213.904 652.684 213.95C652.666 213.904 652.675 213.84 652.656 213.785C652.601 213.776 652.528 213.767 652.473 213.748C652.519 213.611 652.583 213.464 652.675 213.327C652.547 213.226 652.601 213.162 652.528 213.043C652.757 212.933 652.858 212.668 652.931 212.429C652.867 212.42 652.785 212.429 652.721 212.439C652.711 212.649 652.592 212.787 652.372 212.777C652.382 212.832 652.391 212.906 652.409 212.961L652.327 212.997C652.098 212.805 651.869 212.805 651.832 212.411C651.777 212.393 651.658 212.393 651.603 212.411C651.585 212.494 651.594 212.686 651.622 212.768C651.649 212.796 651.75 212.805 651.786 212.805C651.805 212.842 651.768 212.915 651.796 212.951C651.97 212.924 652.107 213.025 652.18 213.19C652.189 213.208 652.134 213.226 652.125 213.245C652.198 213.281 652.253 213.382 652.308 213.437C652.18 213.547 652.162 213.693 652.226 213.858C652.208 213.886 652.134 213.876 652.107 213.895C652.18 213.931 652.217 214.023 652.29 214.069C652.244 214.124 652.125 214.206 652.061 214.234C651.979 214.188 651.594 214.032 651.567 213.959C651.567 213.95 651.328 213.226 651.328 213.226L650.99 213.153L650.77 212.851L650.733 212.521L650.577 212.127L650.312 212.2L649.808 212.017L650.01 211.743C650.01 211.733 649.826 211.688 649.826 211.688L649.652 211.669L649.543 211.935L649.167 211.743V211.624L649.075 211.532L648.966 211.724L648.773 211.752L648.517 211.587L648.398 211.55L648.297 211.303L648.16 211.257L648.086 211.047L647.995 210.9L648.233 210.744L648.141 210.671L648.004 210.717L647.775 210.946L647.638 210.552L647.07 210.222L646.905 210.259L646.768 210.103L646.557 210.131L646.291 209.883L646.3 209.664L646.246 209.517L646.117 209.407L645.998 209.545L645.879 209.407L645.623 209.38L645.504 209.023L645.33 208.665L645.211 208.354L644.734 207.942L644.496 207.896L644.139 207.887L643.974 207.777V207.621L643.764 207.594L643.617 207.658V207.74L643.443 207.914L643.333 207.814L643.141 207.786L643.077 207.365L642.985 206.953L642.738 206.834L642.619 206.999L642.372 206.934L642.198 207.099L642.024 207.145L641.904 206.907L641.73 207.072L641.538 206.944L641.254 207.127L640.924 207.035L641.126 207.227L641.218 207.319L641.364 207.328L641.63 207.145L641.813 207.282L641.969 207.575L642.271 207.704L642.307 207.383H642.408L642.472 207.594L642.71 207.566L642.729 207.374L642.894 207.429L642.976 207.997L643.223 208.043L643.416 208.253L643.617 208.262L643.828 207.933L644.075 208.107L644.78 208.226L645.192 208.903L645.073 209.169L645.275 209.343L645.174 209.636L645.366 209.764L645.852 209.755L645.778 210.048L645.907 210.14L646.044 210.186L646.438 210.497L646.841 210.579V210.744L647.042 210.9L647.244 210.863L647.601 211.33C647.821 211.651 648.077 211.953 648.407 212.191C648.627 212.347 648.819 212.31 649.011 212.439C649.231 212.585 649.167 212.787 649.414 212.906C649.588 212.988 649.9 212.897 650.092 212.887C650.101 212.979 650.193 213.08 650.202 213.171C650.697 213.135 650.614 213.968 650.944 214.188C650.797 214.151 650.651 214.142 650.504 214.105C650.486 214.151 650.458 214.206 650.449 214.261C650.614 214.279 650.779 214.298 650.944 214.316C650.925 214.371 650.935 214.435 650.916 214.49C651.209 214.646 651.512 214.856 651.832 214.875C652.244 214.893 652.739 214.701 653.151 214.627C653.243 215.131 653.581 215.122 654.021 215.085C654.47 215.049 654.744 215.113 655.202 215.085C655.193 215.186 655.129 215.369 655.074 215.461C655.001 215.406 654.891 215.406 654.818 215.351C654.864 215.452 654.836 215.589 654.873 215.699C654.543 215.562 653.673 215.681 653.655 216.111C653.435 216.129 653.472 216.111 653.307 216.221C653.133 216.12 652.949 216.01 652.775 215.91C652.73 215.965 652.647 215.992 652.601 216.047C652.327 215.809 652.006 215.855 651.658 215.781C652.308 215.919 653.417 216.816 653.984 216.084C653.966 216.038 653.957 215.983 653.939 215.937C654.103 215.928 654.259 215.91 654.424 215.9C654.433 215.983 654.506 216.056 654.516 216.139C654.735 216.102 655.019 216.12 655.065 216.358C654.973 216.358 654.864 216.395 654.772 216.377C654.781 216.386 654.799 216.468 654.799 216.468C654.964 216.477 655.138 216.487 655.303 216.468C655.312 216.212 655.285 215.974 655.248 215.726L655.578 215.772L656.155 216.322L655.99 216.395L655.697 216.249L655.486 216.34L655.67 216.514L655.541 216.661L655.303 216.67L655.422 216.954L655.633 216.761L655.77 216.825L656.127 216.835L656.155 216.578L656.375 216.771L656.356 217.119L656.631 217.723L656.439 218.007L656.356 218.392V219.024L656.475 219.124L656.375 219.436L656.182 219.372L656.246 219.188L655.706 218.785L655.367 218.575L655.303 217.943L655.093 217.824L655.074 217.549L654.928 217.613L654.909 217.906L655.056 217.998L655.276 218.208L655.193 218.346L655.028 218.364L654.717 218.254L654.497 218.163L654.387 217.943V217.576L654.03 217.558L654.076 217.787L653.765 217.815L653.682 217.467C653.673 217.457 653.481 217.302 653.481 217.302L653.609 217.668L653.444 217.925L653.609 217.943L654.113 218.025L654.378 218.621L653.939 218.511L653.517 218.337L653.078 218.153L653.105 218.346L653.453 218.474L653.426 218.941L653.902 218.895L654.406 219.106L654.506 219.481L654.039 219.399L653.82 219.39L654.012 219.628L654.168 219.729L654.525 219.655L655.019 219.857L654.9 220.416L654.543 220.58L653.92 220.864C653.444 221.102 653.004 220.59 652.647 220.361C652.473 220.251 652.272 220.123 652.125 219.985C652.07 219.93 652.098 219.775 652.043 219.72C651.97 219.655 651.832 219.674 651.75 219.61C651.475 219.39 651.145 219.024 650.861 218.868C650.733 218.804 650.541 218.813 650.422 218.721C650.284 218.611 650.174 218.309 650.083 218.153C650.284 218.053 650.495 217.952 650.696 217.851C650 218.163 650.092 218.144 649.588 217.65C649.259 217.338 648.993 217.164 648.709 216.816C648.627 216.972 648.553 216.945 648.434 217.036C648.389 216.88 648.297 216.78 648.169 216.679C647.921 216.78 647.839 217 647.665 217.164C647.647 217.137 647.61 217.091 647.583 217.073C647.821 216.816 647.72 216.468 647.491 216.249C647.39 216.276 647.216 216.377 647.143 216.45C647.216 216.551 647.216 216.716 647.29 216.816C647.244 216.844 647.161 216.871 647.106 216.88C646.997 216.313 646.374 216.908 646.392 217.256C646.346 217.238 646.3 217.238 646.246 217.219C646.401 216.844 646.09 216.404 645.705 216.697C645.742 216.752 645.742 216.835 645.778 216.89C645.714 216.908 645.577 216.908 645.513 216.899C645.54 216.816 645.485 216.697 645.513 216.615C645.348 216.569 645.284 216.587 645.165 216.697C645.229 216.853 645.32 217.009 645.421 217.146C645.577 217.082 645.696 217.091 645.843 217.192C645.989 217.091 646.007 216.945 645.925 216.78C645.934 216.78 645.998 216.752 645.998 216.743C646.401 217.21 645.723 217.302 646.557 217.512C646.594 217.256 646.575 217.009 646.813 216.853C647.253 217.622 647.345 216.551 647.454 216.423C647.5 216.734 647.28 217.155 647.418 217.393C647.537 217.393 647.702 217.375 647.83 217.366C647.876 217.155 647.94 216.954 648.123 216.825C648.324 217.128 648.489 217.247 648.462 217.641C649.204 217.888 649.927 218.474 650.431 219.06C650.733 219.417 651.026 219.6 651.319 219.939C651.557 220.223 651.786 220.663 652.226 220.69C652.235 220.736 652.253 220.809 652.272 220.855C652.885 220.846 653.087 221.286 653.655 221.451C654.342 221.661 654.534 221.029 655.12 220.956C655.129 221.011 655.138 221.093 655.129 221.148C654.946 221.194 654.772 221.295 654.754 221.487C655.102 221.267 655.184 221.679 655.193 221.945C655.001 221.835 654.809 221.716 654.598 221.863C654.598 221.863 654.635 221.927 654.635 221.936C654.708 221.89 654.827 221.872 654.9 221.844C655.202 222.119 654.754 222.284 654.845 222.586C654.781 222.595 654.69 222.623 654.616 222.623C654.625 222.632 654.662 222.705 654.671 222.705C654.754 222.705 654.854 222.678 654.937 222.669C654.955 222.632 654.955 222.55 654.955 222.504C655.001 222.476 655.074 222.495 655.129 222.467C655.12 222.412 655.129 222.33 655.129 222.266C655.202 222.229 655.395 222.201 655.477 222.211C655.459 222.302 655.505 222.403 655.486 222.495C655.55 222.485 655.67 222.449 655.724 222.412C655.67 222.321 655.688 222.183 655.633 222.092C655.688 222.055 655.853 222.009 655.917 222.009C655.953 222.211 656.182 222.421 656.338 222.513C656.366 222.476 656.375 222.44 656.402 222.403C656.567 222.476 656.732 222.577 656.888 222.678L656.814 222.788L656.558 222.907L656.402 222.916L656.201 223.044L655.963 222.943L655.834 222.898L655.578 222.989L655.422 223.136L655.642 223.108L655.67 223.191H656.018L656.118 223.337L656.311 223.365L656.283 223.52L656.027 223.713L656.054 224.033L656.164 224.152L656.201 224.033L656.182 223.932L656.384 223.649L656.356 223.465L656.457 223.42L656.448 223.218L656.576 223.172L656.677 223.401L656.778 223.484V223.374L656.732 223.163L656.906 223.062L656.97 222.934L657.126 222.98L657.199 223.301L657.098 224.253L657.126 224.528L657.007 224.766L656.851 224.839L656.833 224.711L656.979 224.5L656.961 224.308L656.888 224.317L656.851 224.473L656.769 224.592L656.549 224.61L656.475 224.601L656.402 224.821L656.137 224.976L655.908 225.132L655.734 225.48L655.651 225.792L655.395 225.709L655.12 225.306L655.129 225.096L654.955 225.004C654.726 224.638 654.571 224.656 654.213 224.5C654.085 224.445 653.481 224.171 653.792 223.905C653.673 224.006 653.572 223.96 653.453 224.006C653.417 223.813 653.27 223.694 653.142 223.548C653.123 223.557 653.078 223.584 653.059 223.584C653.078 223.841 653.38 223.923 653.398 224.189C653.261 224.216 652.565 223.813 652.446 223.713C652.144 223.456 652.29 223.2 652.345 222.742C651.942 222.55 651.997 222.055 651.438 222C651.072 221.963 651.09 222.174 650.898 222.247C650.697 222.321 650.449 222.348 650.239 222.385C650.239 222.385 650.22 222.449 650.211 222.458C650.284 222.467 650.376 222.531 650.449 222.55C650.449 222.614 650.431 222.705 650.403 222.76C650.028 222.852 649.845 222.311 649.552 222.174C649.222 222.018 648.874 222.165 648.544 222.229C648.563 221.973 648.398 221.762 648.361 221.505C648.517 221.45 648.453 221.414 648.572 221.331C648.434 221.304 648.389 221.203 648.297 221.157C648.306 221.121 648.361 221.093 648.389 221.066C648.334 221.02 648.27 220.983 648.205 220.947C648.041 221.084 648.041 221.212 648.224 221.313C648.141 221.606 648.489 222.064 648.132 222.147C648.105 222.183 648.141 222.256 648.114 222.293C648.068 222.321 648.004 222.302 647.949 222.321C647.949 222.394 647.912 222.476 647.903 222.55C647.564 222.568 647.207 222.339 646.987 222.101C646.758 221.844 646.749 221.496 646.355 221.405C646.099 221.634 645.898 221.908 645.687 222.174C645.403 222.064 645.449 221.606 645.522 221.359C644.707 222.082 643.846 221.579 642.994 222.037C642.967 221.89 642.875 221.771 642.839 221.634C642.793 221.808 642.674 221.918 642.509 221.963C642.481 222.037 642.472 222.211 642.491 222.284C642.61 222.201 642.683 222.229 642.793 222.101C642.93 222.44 643.562 222.485 643.452 222.046C643.608 222.082 643.654 222.082 643.8 222.092C643.809 222.669 644.249 222.238 644.441 222.147C644.707 222.027 645.082 222.064 645.229 221.725C645.394 221.899 645.412 222.595 645.843 222.467C645.998 222.421 646.31 221.789 646.438 221.634C646.502 221.643 646.575 221.661 646.63 221.689C646.539 221.954 646.859 222.266 646.942 222.54C646.694 222.595 646.594 222.806 646.676 223.044C647.198 222.293 647.345 222.797 648.031 222.971C648.407 223.062 649.112 222.751 649.552 222.659C649.543 222.751 649.607 222.852 649.588 222.943C650.028 222.769 650.266 223.575 650.678 223.548C651.09 223.511 651.026 222.797 651.154 222.531C651.283 222.614 651.411 222.705 651.521 222.797C651.393 223.09 651.53 223.355 651.649 223.612C651.832 224.024 651.823 224.097 651.832 224.555C651.869 225.572 652.611 224.821 653.16 225.178C653.169 225.242 653.16 225.389 653.142 225.444C652.94 225.471 652.775 225.581 652.748 225.782C653.023 225.673 653.389 225.444 653.664 225.508C654.039 225.608 654.204 225.92 654.644 225.993C654.68 226.057 654.735 226.213 654.735 226.286C654.644 226.268 654.525 226.314 654.433 226.286C654.699 226.552 654.58 226.826 654.259 226.964C654.479 226.964 654.717 226.9 654.854 226.726C654.891 227.019 654.424 228.209 654.085 228.283C654.103 228.466 654.177 228.548 654.36 228.567C654.323 228.512 654.314 228.429 654.287 228.365C654.497 228.301 654.717 228.127 654.644 227.916C654.662 227.825 654.726 227.742 654.744 227.632C654.809 227.632 654.873 227.614 654.937 227.605C654.891 227.175 655.459 227.312 655.413 226.863C655.697 226.726 656.008 226.845 656.311 226.781C656.311 226.625 656.301 226.478 656.301 226.323C656.43 226.286 656.604 226.277 656.732 226.277C656.759 226.524 657.043 227.193 656.97 227.339C657.08 227.303 657.226 227.358 657.336 227.321C657.364 227.349 657.373 227.413 657.391 227.458C657.574 227.422 657.648 227.44 657.73 227.614C657.822 227.614 658.014 227.55 658.097 227.504C658.106 227.449 658.115 227.403 658.115 227.349C657.593 227.477 657.602 227.019 657.172 226.964C657.309 226.845 657.346 226.689 657.281 226.515C657.474 226.405 657.675 226.497 657.803 226.671C657.831 226.625 657.858 226.57 657.877 226.515C657.538 226.213 657.217 226.506 656.952 226.341C656.778 226.231 656.769 225.627 656.732 225.407C656.759 225.425 656.851 225.389 656.888 225.389C656.897 225.434 656.906 225.508 656.924 225.553C657.016 225.517 657.144 225.553 657.236 225.517C657.245 225.572 657.272 225.618 657.281 225.673C657.364 225.663 657.547 225.599 657.62 225.544C657.62 225.489 657.602 225.425 657.584 225.37C657.455 225.416 657.309 225.398 657.181 225.444C657.162 225.398 657.144 225.343 657.126 225.297C657.794 225.205 658.197 225.7 658.893 225.608C658.866 225.901 659.232 226.176 659.397 226.405C659.461 226.387 659.589 226.314 659.635 226.268C659.424 226.075 659.159 225.929 659.177 225.618C659.507 225.59 659.818 225.682 660.13 225.746C660.066 225.947 659.992 226.14 659.928 226.341C659.983 226.341 660.038 226.341 660.093 226.341C660.056 226.442 660.075 226.57 660.029 226.671C660.093 226.652 660.194 226.588 660.249 226.543C660.23 226.369 660.203 226.195 660.185 226.021C660.551 225.947 660.615 226.268 660.597 226.561C660.652 226.543 660.697 226.543 660.752 226.524C660.78 226.341 660.789 226.314 660.881 226.158C660.716 226.085 660.652 226.03 660.633 225.837C660.524 225.874 660.386 225.81 660.276 225.847C660.093 225.535 660.514 225.663 660.606 225.526L660.807 225.224L661.146 225.141L661.549 225.251L661.659 225.526L662.254 226.955L662.703 227.806L663.179 228.521L663.738 229.382L664.26 230.407L664.443 230.829L664.498 231.058C664.425 231.076 664.352 231.085 664.278 231.103L664.223 230.82L664.068 230.526L663.995 230.316L663.619 229.766L663.408 229.528L663.399 229.757L663.335 229.959L663.051 229.693L662.996 229.336L663.234 229.153L662.987 229.015L662.676 229.153L662.712 229.601L662.639 230.069L662.886 230.957L662.914 231.36L662.941 231.397C662.813 231.424 662.685 231.451 662.557 231.479L662.511 231.387L661.989 231.039L661.943 231.14L662.209 231.516L662.227 231.552C657.794 232.486 653.92 233.256 650.193 233.952C650.083 233.97 649.982 234.052 649.936 234.153C649.936 234.162 649.927 234.172 649.927 234.181L648.764 234.419C645.073 235.179 641.373 235.912 637.682 236.644L636.061 236.965C632.041 237.771 602.468 242.753 597.697 243.495C593.924 244.09 590.049 244.456 586.304 244.814L585.718 244.869L585.772 244.777C585.846 244.667 585.846 244.521 585.772 244.411C585.699 244.301 585.571 244.227 585.434 244.255L584.664 244.365C584.161 244.438 583.657 244.502 583.153 244.566L582.219 244.676C582.192 244.676 582.146 244.676 582.109 244.676C581.908 244.676 581.679 244.685 581.523 244.804C581.34 244.933 581.331 245.143 581.349 245.244C581.322 245.272 581.257 245.354 581.248 245.363C581.23 245.372 581.148 245.381 581.065 245.391L579.472 245.629C578.775 245.729 578.089 245.83 577.393 245.931L575.973 246.132C573.711 246.462 571.403 246.728 569.177 246.975L567.126 247.213C565.853 247.36 564.58 247.525 563.307 247.689C561.933 247.863 560.569 248.037 559.195 248.193C559.644 247.937 560.092 247.689 560.541 247.525C560.669 247.479 560.798 247.451 560.935 247.424C561.136 247.387 561.356 247.341 561.567 247.241C561.97 247.048 562.354 246.801 562.73 246.554C562.904 246.435 563.087 246.325 563.261 246.215L563.481 246.077C563.783 245.885 564.049 245.72 564.36 245.647C564.415 245.629 564.47 245.629 564.507 245.62C564.653 245.592 564.836 245.565 565.02 245.345C565.184 245.143 565.249 244.832 565.303 244.557C565.322 244.466 565.34 244.383 565.358 244.319C565.395 244.191 565.423 244.072 565.45 243.971C565.477 243.87 565.505 243.742 565.532 243.715C565.532 243.715 565.578 243.678 565.78 243.669C566.567 243.614 566.851 243.531 567.465 242.991C567.923 242.588 568.115 242.222 568.152 241.645L568.17 241.352C568.188 240.876 568.198 240.775 568.582 240.491C568.665 240.427 568.848 240.353 569.013 240.289C569.379 240.134 569.764 239.978 569.91 239.694C570.066 239.392 569.993 239.035 569.919 238.723C569.883 238.549 569.828 238.311 569.864 238.22C569.956 238.009 570.341 237.698 570.634 237.478C570.799 237.35 570.945 237.23 571.073 237.111C571.385 236.818 571.669 236.544 572.007 236.305C572.31 236.095 572.648 235.921 573.006 235.738C573.528 235.472 574.068 235.197 574.498 234.794C575.021 234.3 575.488 233.686 575.936 233.091C576.165 232.779 576.394 232.477 576.632 232.193L578.144 230.371C578.18 230.765 578.556 230.948 578.766 231.058L579.032 231.204C579.224 231.305 579.307 231.351 579.343 231.442C579.371 231.497 579.371 231.635 579.362 231.745C579.352 231.955 579.352 232.184 579.472 232.404C579.728 232.88 580.525 233.411 580.964 233.631C581.257 233.778 581.55 233.878 581.844 233.97C582.164 234.08 582.475 234.181 582.759 234.346C583.593 234.813 584.069 234.712 584.902 234.483C586.066 234.162 586.872 232.953 587.458 231.827L588.199 232.34C588.264 232.386 588.355 232.459 588.456 232.55C588.914 232.935 589.271 233.21 589.582 233.228C589.894 233.237 590.178 233.027 590.581 232.734C590.672 232.67 590.746 232.615 590.801 232.578C591.121 232.386 591.368 232.248 591.707 232.12C591.9 232.047 592.101 231.983 592.312 231.919C592.953 231.717 593.685 231.479 594.207 230.966C594.537 230.646 594.675 230.481 594.675 230.279C594.665 230.004 594.436 229.858 594.253 229.739C594.226 229.721 594.189 229.693 594.162 229.675C594.189 229.574 594.235 229.418 594.272 229.318V229.308C594.729 229.638 595.087 229.867 595.398 229.867C595.398 229.867 595.398 229.867 595.407 229.867C595.728 229.867 596.067 229.583 596.515 229.18C596.616 229.098 596.699 229.015 596.753 228.97C597.358 228.512 597.953 228.045 598.548 227.568L598.988 228.209C599.043 228.292 599.135 228.347 599.226 228.356C599.318 228.365 599.419 228.338 599.492 228.274L599.583 228.191C600.087 227.742 600.609 227.275 601.131 226.927C601.369 226.772 602.02 226.341 601.836 225.801C601.754 225.544 601.598 225.471 601.479 225.453C601.36 225.434 601.269 225.471 601.195 225.535C601.186 225.517 601.177 225.489 601.159 225.471C601.177 225.434 601.278 225.352 601.342 225.306C601.415 225.251 601.479 225.187 601.543 225.132C601.763 224.912 601.955 224.665 602.148 224.427L602.386 224.125C602.441 224.051 602.468 223.96 602.459 223.868C602.45 223.777 602.404 223.694 602.331 223.639C602.221 223.557 602.102 223.475 601.974 223.383C601.69 223.191 601.333 222.952 601.333 222.76C601.333 222.586 601.47 222.275 601.589 222.027C601.653 221.881 601.717 221.753 601.754 221.634C601.8 221.515 601.836 221.396 601.873 221.267C601.946 221.038 602.02 220.8 602.12 220.59C602.368 220.068 602.688 219.591 603.018 219.088C603.393 218.52 603.778 217.943 604.062 217.293C604.135 217.119 604.236 216.935 604.337 216.734C604.584 216.258 604.859 215.726 604.932 215.232C604.969 214.975 604.914 214.728 604.859 214.499C604.831 214.399 604.813 214.289 604.804 214.188C604.795 214.078 604.776 213.959 604.785 213.931C604.795 213.904 604.868 213.822 604.978 213.693C605.033 213.629 605.124 213.538 605.234 213.419C605.839 212.796 606.306 212.283 606.306 211.862C606.306 211.642 606.187 211.468 606.095 211.33C606.058 211.285 606.013 211.211 606.003 211.202C606.022 211.101 606.223 210.845 606.324 210.717C606.397 210.616 606.471 210.534 606.507 210.46C607.276 209.261 607.276 207.859 607.286 206.504V206.312C607.295 206.312 607.304 206.312 607.322 206.321C607.734 206.394 608.165 206.467 608.421 206.678C608.577 206.797 608.696 207.026 608.824 207.264C608.989 207.575 609.154 207.905 609.465 208.107C609.85 208.363 610.656 208.436 611.444 208.482L611.59 208.491C611.672 208.5 611.718 208.5 611.764 208.51C611.984 208.537 612.075 208.5 612.304 208.317C612.588 208.098 612.836 207.649 613.019 207.319L613.074 207.227C613.522 206.44 613.724 205.478 613.916 204.535C613.99 204.178 614.063 203.83 614.145 203.5C614.448 202.355 614.722 201.494 615.079 200.652L616.618 201.449C616.71 201.494 616.81 201.503 616.902 201.458C616.994 201.421 617.067 201.348 617.094 201.247C617.168 201.036 617.232 200.817 617.296 200.588C617.424 200.166 617.552 199.727 617.735 199.351L617.79 199.232C617.864 199.076 617.964 198.875 618.074 198.701C618.111 198.756 618.166 198.802 618.23 198.829C618.367 198.884 618.514 198.848 618.615 198.747C618.972 198.353 619.082 198.124 619.256 197.73L619.311 197.611C619.338 197.547 619.402 197.41 619.457 197.327C619.53 197.391 619.631 197.41 619.732 197.4C619.842 197.382 619.943 197.309 619.988 197.199L620.281 196.549C620.373 196.384 620.437 196.247 620.446 196.109C620.446 196.036 620.437 195.908 620.318 195.798C620.336 195.752 620.364 195.715 620.373 195.679C620.419 195.56 620.483 195.45 620.538 195.34L620.611 195.212C620.712 195.01 620.794 194.946 620.941 194.836C621.042 194.754 621.161 194.662 621.289 194.525C621.463 194.332 621.564 194.113 621.655 193.911C621.728 193.755 621.802 193.6 621.902 193.472C621.967 193.389 621.985 193.27 621.957 193.169C621.93 193.069 621.848 192.977 621.747 192.94C621.646 192.904 621.573 192.858 621.554 192.821C621.509 192.73 621.609 192.482 621.683 192.281L621.765 192.052C621.802 191.951 621.765 191.832 621.71 191.741C621.692 191.713 621.674 191.695 621.646 191.676C621.683 191.576 621.719 191.484 621.756 191.383C621.793 191.292 621.82 191.2 621.857 191.136C622.012 190.806 622.113 190.513 622.214 190.101C622.241 189.991 622.186 189.863 622.104 189.781C622.076 189.753 622.04 189.726 622.003 189.707C622.04 189.579 622.049 189.469 622.022 189.359C621.976 189.185 621.847 189.085 621.719 189.011C621.683 188.911 621.701 188.7 621.719 188.517C623.835 189.57 625.95 190.687 627.993 191.777L629.202 192.418C629.293 192.464 629.412 192.473 629.504 192.427C629.605 192.382 629.669 192.299 629.696 192.189L630.456 188.929C630.539 188.92 630.621 188.92 630.685 188.929C630.749 188.938 630.832 188.975 630.914 189.021C631.033 189.085 631.171 189.149 631.326 189.176C631.519 189.204 631.665 189.176 631.784 189.158C631.839 189.149 631.894 189.13 631.968 189.13C632.096 189.13 632.096 189.121 632.187 189.249C632.27 189.369 632.389 189.533 632.609 189.68C632.773 189.79 632.984 189.826 633.158 189.863C633.241 189.881 633.323 189.891 633.387 189.918C633.433 189.936 633.47 189.946 633.506 189.955V189.991C633.515 190.101 633.515 190.101 633.396 190.174C633.286 190.248 633.112 190.358 633.002 190.596C632.792 191.045 632.966 191.539 633.231 191.832C633.937 192.62 634.798 192.62 635.622 192.556C636.08 192.519 636.171 192.556 636.593 192.73L636.757 192.794C636.822 192.821 636.904 192.84 636.996 192.858C637.023 192.867 637.05 192.867 637.078 192.876C637.078 192.885 637.078 192.895 637.078 192.895C637.069 193.023 637.05 193.206 637.16 193.38C637.435 193.82 637.948 193.792 638.287 193.765C638.369 193.765 638.452 193.755 638.525 193.755C638.644 193.765 638.745 193.792 638.827 193.829L638.818 193.847L639.139 194.039C639.148 194.048 639.157 194.058 639.166 194.067C639.267 194.149 639.377 194.232 639.514 194.323C639.615 194.397 639.716 194.451 639.807 194.506C640.091 194.671 640.228 194.763 640.366 195.047C640.494 195.322 640.567 195.633 640.576 195.935L640.467 196.1L640.567 196.164C640.521 196.659 640.375 197.144 640.173 197.391L640.109 197.483C640.027 197.602 639.88 197.794 639.825 197.858C639.716 197.95 639.716 197.95 639.422 197.968C639.285 197.977 639.175 198.06 639.12 198.188C639.047 198.289 639.075 198.426 639.166 198.527ZM666.76 205.103L666.431 205.9L665.854 206.98L666.476 206.971L666.467 207.099L665.909 207.237L666.687 207.502L667.163 205.542L667.53 204.315L666.98 204.507L666.76 205.103ZM663.811 205.561C663.463 205.652 663.07 205.753 662.831 205.909C662.694 206 662.593 206.238 662.502 206.458C662.465 206.55 662.419 206.641 662.383 206.733L661.943 207.411L662.181 207.392L662.117 208.098L662.108 208.308L661.879 208.995L661.815 209.114L661.595 209.407L661.119 209.142L660.624 209.618L660.862 209.819L661.073 209.6L661.311 209.828L660.963 210.341L660.056 213.043L659.928 213.474L659.846 214.142L659.864 214.234L659.947 214.38L659.882 214.893L659.837 215.287L659.782 216.487L659.718 218.337L659.708 218.584L659.745 219.097L659.837 219.646L660.194 220.507L660.972 221.689L660.991 222.073L661.43 221.963L661.531 221.927L661.329 221.231L661.091 218.41L661.604 217.064L662.465 216.734L662.044 216.377L662.035 215.47L661.943 215.415L661.888 215.287L661.906 215.241L661.989 215.186L662.099 215.012L662.053 215.186L662.025 215.333L662.099 215.498L662.264 215.324L662.438 215.058L663.124 214.911L663.134 214.737L662.621 214.609L662.859 213.757L663.097 213.904L663.124 214.151L663.289 214.27L663.17 214.499L663.326 214.618L663.427 214.334L663.527 214.371L663.555 214.792L663.921 215.076L663.866 214.921L664.251 214.554L664.434 213.327L664.214 211.047L664.269 210.708L664.663 208.867L664.91 208.226L665.094 207.841L665.203 207.676L665.258 207.585L665.341 207.484L665.387 207.438L665.423 207.392L665.533 207.319L665.57 207.31L665.332 207.163V206.751L665.487 205.643L665.451 205.341L665.927 205.011L665.936 204.865L664.352 205.414C664.187 205.469 664.004 205.515 663.811 205.561ZM663.601 231.186L663.381 231.259C663.546 231.223 663.701 231.186 663.866 231.158L663.848 230.994L663.601 231.186Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M617.754 226.41H619.73L622.834 217.238H621.231L618.832 224.678L616.446 217.238H614.663L617.754 226.41ZM622.569 226.41H624.172L624.891 224.14H628.393L629.124 226.41H630.894L627.867 217.238H625.635L622.569 226.41ZM626.648 218.636L627.995 222.895H625.288L626.648 218.636Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.VT = function () {
	    var _ref47 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref47$color = _ref47.color,
	        color = _ref47$color === undefined ? "#6496c2" : _ref47$color,
	        _ref47$labelColor = _ref47.labelColor,
	        labelColor = _ref47$labelColor === undefined ? "white" : _ref47$labelColor,
	        _ref47$tooltip = _ref47.tooltip,
	        tooltip = _ref47$tooltip === undefined ? {} : _ref47$tooltip,
	        _ref47$labelTooltip = _ref47.labelTooltip,
	        labelTooltip = _ref47$labelTooltip === undefined ? {} : _ref47$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M664.608 80.4384C664.663 80.7681 664.599 81.0611 664.535 81.3176C664.489 81.5191 664.452 81.7022 664.461 81.8854C664.48 82.096 664.553 82.1418 664.727 82.2609C664.883 82.3708 665.102 82.5173 665.221 82.8287C665.35 83.1584 665.286 83.5705 665.221 83.9827C665.194 84.1658 665.167 84.349 665.167 84.4955C665.167 85.2099 665.167 86.1807 665.679 86.6661L665.743 86.7302C666.32 87.2705 666.98 87.8842 667.071 88.8458C667.099 89.1114 667.035 89.377 666.989 89.6059C666.943 89.7983 666.907 89.9814 666.916 90.128C666.934 90.3203 667.026 90.5401 667.117 90.7599C667.227 91.0255 667.346 91.3094 667.374 91.6208C667.401 92.0146 667.273 92.3535 667.145 92.6923C667.099 92.8114 667.053 92.9304 667.017 93.0495C666.916 93.3884 666.916 93.6906 666.916 94.0752L666.907 94.5332C666.897 95.101 666.888 95.6413 667.081 96.145L667.126 96.2549C667.511 97.2349 667.914 98.2423 668.372 99.1856C668.436 99.3139 668.509 99.4421 668.583 99.5703C668.72 99.7901 668.857 100.028 668.94 100.285C669.086 100.715 669.004 101.091 668.931 101.457C668.912 101.567 668.885 101.677 668.867 101.787L668.848 101.887C668.802 102.217 668.757 102.51 668.757 102.767C668.784 102.721 668.812 102.684 668.848 102.648C669.233 102.29 669.892 102.501 670.14 102.721C670.259 102.822 670.314 102.959 670.359 103.06C670.369 103.087 670.387 103.115 670.396 103.142C670.405 103.133 670.433 103.133 670.451 103.133C670.57 103.142 670.735 103.142 670.881 103.252C671.074 103.389 671.229 103.682 671.413 104.223C671.678 104.992 671.825 105.816 671.962 106.622C672.026 106.989 672.09 107.346 672.164 107.694C672.338 108.536 672.512 109.37 672.676 110.212L673.079 112.209C673.244 113.024 673.409 113.839 673.583 114.645C673.601 114.737 673.638 114.837 673.666 114.947C673.748 115.222 673.849 115.543 673.821 115.826C673.803 116.019 673.711 116.184 673.629 116.33C673.592 116.403 673.528 116.513 673.528 116.55C673.528 116.788 673.766 117.164 673.867 117.173L674.169 116.999L674.224 117.09C674.801 116.843 675.479 116.742 676.138 116.632C676.431 116.587 676.724 116.541 676.999 116.486L683.319 115.14C682.595 114.608 681.734 113.931 681.707 113.171C681.697 112.96 681.78 112.786 681.853 112.621C681.89 112.539 681.936 112.438 681.936 112.383C681.936 112.3 681.917 112.236 681.899 112.154C681.853 111.998 681.798 111.778 681.917 111.504C682 111.311 682.174 111.174 682.329 111.064C682.394 111.018 682.503 110.927 682.531 110.89C682.531 110.853 682.467 110.689 682.43 110.597C682.384 110.478 682.348 110.368 682.329 110.276C682.275 109.974 682.302 109.69 682.339 109.434C682.366 109.232 682.384 109.049 682.366 108.875C682.339 108.674 682.274 108.491 682.201 108.289C682.1 108.033 681.991 107.73 681.981 107.373C681.963 106.87 681.963 106.366 681.981 105.771C681.991 105.624 681.991 105.423 681.963 105.258C681.881 105.203 681.789 105.129 681.743 104.992C681.707 104.882 681.707 104.772 681.716 104.662C681.423 104.415 681.331 103.801 681.258 102.712C681.249 102.583 681.24 102.474 681.23 102.419C681.212 102.29 681.185 102.153 681.157 102.016C681.066 101.53 680.956 100.981 681.194 100.514C681.258 100.395 681.349 100.303 681.432 100.211C681.45 100.193 681.469 100.175 681.496 100.147C681.459 100.074 681.45 99.9916 681.45 99.8817C681.459 99.7351 681.496 99.5703 681.533 99.4054C681.569 99.2406 681.615 99.0574 681.606 98.9384C681.597 98.8285 681.578 98.7552 681.56 98.6819C681.496 98.4255 681.459 98.1965 681.734 97.8027C681.798 97.7111 681.862 97.6287 681.926 97.5463C682.036 97.3997 682.128 97.2898 682.21 97.0975C682.384 96.7037 682.348 96.4106 682.293 95.9985C682.274 95.8245 682.247 95.6322 682.238 95.4307C682.22 95.0277 682.384 94.7072 682.531 94.4324C682.632 94.2309 682.732 94.0386 682.76 93.8188L682.778 93.6997C682.787 93.654 682.806 93.5441 682.815 93.4708C682.696 93.3975 682.586 93.3243 682.522 93.196C682.384 92.903 682.467 92.6282 682.531 92.3809L682.577 92.2344C682.659 91.923 682.742 91.6116 682.833 91.3002C682.851 91.2544 682.87 91.1995 682.897 91.1354C682.897 91.1354 682.897 91.1262 682.906 91.1171C682.796 91.053 682.696 90.9705 682.668 90.824C682.623 90.6225 682.659 90.4119 682.696 90.2287C682.714 90.1188 682.751 89.954 682.732 89.899C682.723 89.8898 682.65 89.8257 682.604 89.7799C682.494 89.6792 682.375 89.5693 682.302 89.4319C682.091 89.0106 681.771 88.1314 681.936 87.5178C682.155 86.6936 682.851 86.2814 683.465 85.9242C683.841 85.7044 684.207 85.4846 684.436 85.2007C684.491 85.1275 684.546 85.0542 684.601 84.9809C684.756 84.7611 684.921 84.5413 685.15 84.3948C685.251 84.3307 685.352 84.2941 685.443 84.2574C685.572 84.2116 685.654 84.175 685.727 84.1017C686.048 83.7537 686.313 83.2134 686.524 82.7829C686.634 82.554 686.606 82.4257 686.57 82.2151C686.533 82.0319 686.478 81.8121 686.533 81.5191C686.579 81.2718 686.671 81.1252 686.735 81.0153C686.799 80.9054 686.799 80.9054 686.744 80.7772C686.68 80.6307 686.551 80.475 686.423 80.3193L686.323 80.1911C686.231 80.072 686.094 79.9346 685.947 79.7973C685.645 79.495 685.333 79.1928 685.196 78.8814C684.976 78.3686 685.214 77.7183 685.416 77.2054C685.471 77.0589 685.526 76.9215 685.553 76.8025C685.59 76.6743 685.636 76.5369 685.691 76.3995C685.819 76.0423 685.956 75.6668 685.865 75.4287C685.828 75.328 685.709 75.1997 685.599 75.0807C685.416 74.8792 685.214 74.6502 685.159 74.3663C685.132 74.2198 685.15 74.0824 685.196 73.9542C683.996 74.2931 681.001 75.1265 681.001 75.1173L679.509 75.6119L676.926 76.3812L676.404 76.4087L673.244 77.0955C673.244 77.0955 665.505 78.9455 665.505 78.9547L664.077 79.3393C664.049 79.4492 664.104 79.55 664.251 79.7606C664.416 79.9438 664.571 80.1544 664.608 80.4384Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M672.551 83.8399L657.204 68.7212", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M643.41 70.413H645.386L648.49 61.241H646.886L644.488 68.6812L642.102 61.241H640.318L643.41 70.413ZM651.792 70.413H653.511V62.588H656.063V61.241H649.239V62.588H651.792V70.413Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "638", y: "58", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	MAP.WA = function () {
	    var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref48$color = _ref48.color,
	        color = _ref48$color === undefined ? "#6496c2" : _ref48$color,
	        _ref48$labelColor = _ref48.labelColor,
	        labelColor = _ref48$labelColor === undefined ? "white" : _ref48$labelColor,
	        _ref48$tooltip = _ref48.tooltip,
	        tooltip = _ref48$tooltip === undefined ? {} : _ref48$tooltip,
	        _ref48$labelTooltip = _ref48.labelTooltip,
	        labelTooltip = _ref48$labelTooltip === undefined ? {} : _ref48$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M59.887 43.6032C59.8596 43.8413 59.8138 44.0245 59.7588 44.1619C59.6947 44.3176 59.6856 44.3542 59.7222 44.455C59.7955 44.6656 59.9328 44.8304 60.0885 44.8946C60.4457 45.0411 60.9219 44.977 61.3799 44.9129C61.7004 44.8671 62.0393 44.8213 62.3598 44.8488C63.065 44.8946 63.4863 45.4624 63.8252 45.9203C63.8984 46.021 63.9625 46.1126 64.0358 46.195C64.1365 46.3233 64.2556 46.4515 64.3655 46.5797C64.7502 47.0102 65.1531 47.4589 65.3271 48.0359C65.5286 48.7045 65.6752 49.4921 65.7118 50.1423C65.7484 50.8109 65.6385 51.5069 65.5378 52.1114C65.492 52.3587 65.4645 52.6151 65.437 52.8807C65.3912 53.3295 65.3363 53.7965 65.2081 54.2361C65.1531 54.4193 65.0799 54.5842 65.0066 54.7307C64.8509 55.0512 64.7868 55.1886 64.9516 55.4542C65.1256 55.7473 65.4737 56.0678 65.9499 56.3884C66.4078 56.6998 66.8841 56.9837 67.3603 57.2676C67.5984 57.4141 67.8457 57.5606 68.0838 57.7072C68.2212 57.7896 68.3677 57.8904 68.5143 57.9911C68.8623 58.2201 69.2195 58.4673 69.5766 58.5864C69.9155 58.7055 70.3002 58.6413 70.7031 58.5681C70.813 58.5498 70.9229 58.5314 71.0328 58.5131L73.9086 58.1102C74.0459 58.0918 74.1742 58.0827 74.2566 58.0369C74.339 57.9911 74.4214 57.927 74.513 57.8537C74.6596 57.7255 74.8519 57.5698 75.1266 57.4874C75.7403 57.3225 76.1799 57.5423 76.5645 57.7347C76.766 57.8354 76.9583 57.9361 77.1781 57.9819C77.4987 58.046 77.8284 58.046 78.1855 58.0369C78.4969 58.0277 78.8266 58.0277 79.1563 58.0735C79.5685 58.1285 79.8524 58.3391 80.1088 58.5223C80.3378 58.6871 80.5393 58.8245 80.8049 58.8703C81.5833 58.9894 82.0779 59.2824 82.7007 59.6488C83.4333 60.0792 83.5157 60.5097 83.5799 61.0317C83.5799 61.0317 83.589 61.0317 83.589 61.0225C83.992 60.8119 84.4408 60.5738 84.8346 60.5738C84.8346 60.5738 84.8437 60.5738 84.8529 60.5738C85.1001 60.5738 85.3749 60.7295 85.6863 60.9126L85.787 60.9676C85.8878 61.0225 85.9977 61.1233 86.1167 61.2332C86.19 61.2973 86.2541 61.3614 86.2999 61.3889C86.4098 61.398 86.9318 61.2606 87.1883 61.1874C87.3989 61.1324 87.5912 61.0866 87.7103 61.0683C87.8752 61.0408 88.04 61.0317 88.2049 61.0134C88.5437 60.9767 88.8643 60.9493 89.1482 60.8577C89.2489 60.821 89.3497 60.7844 89.4412 60.7478C89.8351 60.5921 90.2838 60.4089 90.87 60.8485C91.1081 61.0225 91.2363 61.2607 91.3462 61.4713C91.4653 61.6911 91.5477 61.8376 91.6942 61.9017C91.9323 62.0208 92.3628 62.0391 92.7016 62.0483L92.9672 62.0574C93.1412 62.0666 93.361 62.1032 93.5808 62.1307C93.993 62.1948 94.5058 62.2681 94.7898 62.1856C94.9271 62.1399 95.0554 62.0574 95.1927 61.9567C95.4034 61.8102 95.6323 61.6453 95.9895 61.5812C96.6581 61.4713 97.2259 61.398 97.7479 61.3706C98.7462 61.3064 99.7445 61.4072 100.697 61.4988L100.99 61.5262C101.668 61.5904 101.668 61.5904 102.116 61.2332C102.758 60.7203 103.014 60.7661 103.591 61.0225L103.783 61.105C104.397 61.3705 105.166 61.4255 105.908 61.4804C106.293 61.5079 106.677 61.5354 107.035 61.5904C107.273 61.627 107.474 61.6911 107.676 61.7644C107.859 61.8285 108.033 61.8834 108.216 61.9109C108.628 61.9658 109.114 61.8834 109.691 61.6636C109.782 61.627 109.874 61.572 109.974 61.5079C110.148 61.398 110.341 61.2698 110.579 61.2423C110.863 61.2057 111.192 61.3248 111.486 61.4163C111.595 61.453 111.696 61.4896 111.779 61.5079L124.976 64.6767C126.194 64.9698 127.421 65.272 128.639 65.5559L134.601 66.948C134.565 66.6824 134.537 66.3802 134.583 66.1146C134.629 65.8032 134.757 65.5285 134.885 65.2537C134.986 65.0248 135.087 64.8141 135.123 64.6035C135.252 63.9257 135.087 62.9275 134.986 62.323C134.949 62.1032 134.894 61.8926 134.83 61.6819C134.684 61.1416 134.528 60.5829 134.73 59.951C134.904 59.4106 135.023 58.8428 135.142 58.2933L136.177 53.6683C136.616 51.6901 137.065 49.7119 137.514 47.7428C138.045 45.4074 138.567 43.0629 139.089 40.7275C139.996 36.652 140.912 32.5765 141.855 28.501L142.505 25.7077C143.219 22.6396 143.934 19.5624 144.639 16.4851C143.604 16.247 140.49 15.5327 140.49 15.5235L131.817 13.4995C117.109 10.0651 102.474 6.44753 88.0125 2.08812L84.5781 1.10817L80.6125 0C80.2828 0.183168 79.7058 0.393812 79.6143 0.805941C79.8615 0.851733 80.0997 0.915842 80.3378 0.970792C80.3378 1.13564 80.3286 1.29134 80.3286 1.45619C80.1546 1.53861 79.9806 1.61188 79.8066 1.69431C79.9623 1.96906 80.3103 2.37203 80.3561 2.68342C80.4019 2.96733 80.2096 3.40693 80.1546 3.69084C80.2187 3.59926 80.3469 3.55347 80.4202 3.47104C80.9239 4.03886 80.5667 4.0755 80.3469 4.60668C80.1546 5.07376 80.3836 5.36683 80.7408 5.63243C80.8598 5.44926 80.9697 5.32104 80.8323 5.1104L80.5667 5.09208L81.2445 4.42351H81.8489L82.3893 5.05545L81.8947 5.55L81.9313 6.83218C82.1512 7.13441 82.2977 7.38168 82.4167 7.73886C82.1969 7.93119 81.9771 8.11436 81.7573 8.30668C81.5192 7.9953 81.217 7.76634 80.9239 7.51906C80.8781 7.55569 80.7865 7.66559 80.7591 7.72055C81.1895 8.03193 81.4368 8.14183 81.3727 8.70965C81.3361 9.08515 81.3452 9.77203 80.988 9.96436C80.6492 10.1475 80.4935 9.01188 80.466 8.89282L80.1454 9.06683L80.0539 8.47153L79.77 8.42574L79.2021 8.53564L78.8633 8.47153L78.8083 8.70965L79.0922 8.84703L79.1655 9.09431L79.0922 9.42401L78.8999 9.57055L78.9365 10.0834L79.138 10.1658H79.4586L79.715 10.1017L79.9348 9.8453L80.1546 10.0101L79.9623 10.4772C79.9623 10.4772 80.0355 11.1641 80.0355 11.1733C80.0539 11.3381 80.7133 11.7411 80.8415 11.851C81.162 12.1349 81.5467 12.5012 81.4826 12.9775C81.4459 13.2889 81.2078 13.6002 81.1529 13.9391C81.1071 14.2597 81.1437 14.5802 81.0979 14.9007C81.0063 15.5235 80.7865 15.8441 81.0338 16.476C81.2353 16.9889 81.913 17.6208 81.9039 18.1062C81.8947 18.6923 81.6016 18.8572 81.1254 18.8938C80.6492 18.9304 80.6583 18.9304 80.3561 19.3151C79.9348 19.8554 79.367 20.3042 79.0556 20.927C78.7809 21.4765 78.8816 22.0809 78.9091 22.6671C78.4603 22.9876 77.8192 23.2715 78.1031 23.876C78.3138 24.3156 79.2113 24.9109 78.268 25.3047C78.1764 25.1582 78.0848 25.0025 77.9932 24.8559C77.4712 25.0208 77.7917 26.422 77.7459 26.825C77.7185 27.0173 77.636 27.0814 77.6452 27.2646C77.6544 27.4936 77.8558 27.7225 77.8467 27.9515C77.8375 28.2537 77.5903 28.6384 77.4712 28.9223C76.7935 28.9772 76.015 28.8948 76.5004 29.7282C76.2531 30.0304 76.0974 30.0762 75.7311 30.1678C75.5021 29.7282 75.2823 29.2886 75.0808 28.8399C74.9618 29.4901 74.7878 29.6824 74.3482 30.1678C73.9635 30.5983 73.5514 30.9188 73.295 31.4408C73.3407 31.3493 72.7271 31.6698 72.6905 31.7064C71.6006 32.5673 71.216 31.4958 70.9138 30.5158C70.8497 30.8547 70.7764 31.2027 70.7123 31.5416C70.6482 31.5416 70.5291 31.5141 70.4742 31.4866C70.4009 31.102 70.3734 30.754 70.3643 30.3693C69.6316 30.5067 70.0529 32.0087 69.311 31.9354C69.311 31.5782 69.2927 31.2852 69.4026 30.9646C69.5308 30.5983 69.9063 30.2869 69.6407 29.8931C69.3385 29.9022 68.9539 30.1495 68.7157 30.2594C68.4227 30.3876 68.0563 30.58 67.7724 30.7723C67.9281 30.4517 67.9739 30.1495 68.4044 30.2228C68.2945 29.4168 69.7415 29.5725 70.1536 29.6824C70.0529 29.0505 69.8239 28.272 70.4192 27.8782C70.7031 27.6951 71.1244 27.7134 71.3992 27.4936C71.6464 27.3012 71.8296 26.88 72.0128 26.6144C72.2967 27.2646 72.2417 27.8507 71.8113 28.4186C71.3259 29.0597 71.4816 29.5725 71.7747 30.296C72.0952 29.6 72.2509 28.9223 72.5257 28.2262C72.9286 27.2097 73.3774 27.1181 74.4031 27.3287C73.762 27.8691 73.4323 28.1163 73.2583 28.9589C73.6338 29.078 73.8628 29.2978 74.165 29.545C74.568 29.0322 74.513 28.9498 74.3848 28.2995C75.0259 28.0339 74.8702 27.7408 75.1633 27.1547C75.4472 26.6052 75.8776 26.0923 76.2256 25.5795C76.1066 25.4787 75.9875 25.3871 75.8685 25.2864C75.9692 24.9475 76.1799 24.6178 75.841 24.3522C75.612 24.7552 74.4123 25.1582 74.1558 24.6636C74.6046 24.3339 74.8885 24.2332 74.9435 23.6653C74.6412 23.7661 74.5588 23.5188 74.4398 23.2899C74.6046 23.0609 74.7786 22.8228 74.9435 22.5938C75.0992 23.1158 75.09 23.528 75.0808 24.0775C75.3922 23.9676 75.5205 23.9493 75.7036 23.6928C75.9875 23.2807 75.7403 23.3082 75.6853 22.8777C75.6487 22.6213 75.8959 22.374 75.8685 22.1359C75.841 21.9344 75.4838 21.8062 75.4655 21.623C75.4472 21.4765 75.8227 21.1468 75.7952 21.101L76.189 21.9985L76.5553 21.8886L77.0133 21.3391L77.4529 21.6322L77.8742 21.6139L77.691 20.9819L77.8925 20.7804L77.7826 20.3592L78.0115 19.3884L77.9749 18.9213L77.8009 18.6374L77.3247 18.4359L77.4254 19.3975L76.8942 19.8463L75.9326 20.2309L75.6945 20.5973L74.8519 21.1376C74.8519 21.1376 74.568 21.8978 74.5405 21.9619C74.2474 22.7403 72.8645 22.5297 72.2784 22.5572C72.2509 22.6854 72.1502 22.8045 72.1318 22.9418C71.3076 23.0059 70.8313 23.3906 70.3368 24.0408C69.888 24.6361 69.2927 25.1032 68.7432 25.6069C69.7781 26.303 71.0603 25.7077 72.1776 25.4329C72.0769 25.9 72.0861 25.9916 71.6281 26.1564C71.1611 26.3213 70.8863 26.3213 70.4375 26.3488C70.1078 26.3671 69.7781 26.6052 69.4667 26.596C68.8714 26.5869 68.8898 26.2114 68.3403 26.596C68.212 26.4037 68.0838 26.2205 67.9556 26.0282C68.2853 25.4054 68.6242 24.9384 69.137 24.4438C69.3477 24.2423 69.6407 24.0958 69.8148 23.876C69.9888 23.6745 69.9979 23.3631 70.1628 23.1525C70.5658 22.6304 71.2618 22.4198 71.7747 22.0626C72.3242 21.6688 72.7638 21.3574 73.1301 20.7804C73.4781 20.2309 73.295 19.1502 74.0185 19.0312C73.9727 19.3243 73.9269 19.6173 73.8811 19.9012C73.936 19.9104 74.0002 19.9104 74.0551 19.9104C74.1375 19.5349 74.22 19.1594 74.3024 18.7839C74.4214 18.7748 74.6046 18.7839 74.7237 18.8205C74.5863 19.8554 74.1101 20.6156 73.6247 21.5406C73.6979 21.5772 73.8903 21.5955 73.9727 21.5864C74.2383 21.0002 74.4947 20.6156 74.8702 20.121C75.0625 19.8738 75.319 19.8005 75.5388 19.5807C75.7494 19.3701 75.7586 19.2235 75.8318 18.903C76.0425 18.9579 76.2531 19.0037 76.4638 19.0587C76.4638 18.5458 76.3722 18.2161 76.2714 17.7215C76.189 17.3186 76.2806 16.8149 76.1432 16.4394C76.0974 16.3111 75.9509 16.2196 75.8868 16.0455C75.8318 15.8899 75.7769 15.551 75.7586 15.3861C75.6761 14.7908 75.8135 14.6626 76.418 14.6077C76.4546 14.5252 76.4912 14.3238 76.4821 14.2322C75.9784 14.0215 75.1816 14.1406 75.0717 14.8183C75.0351 15.0656 75.4014 15.377 75.3831 15.6334C75.3648 15.8899 75.0259 16.2745 74.8977 16.4943C74.7511 16.4394 74.5954 16.3936 74.4489 16.3386C74.742 15.7983 74.5954 15.5418 74.1925 15.1663C74.2566 14.974 74.3115 14.7817 74.3757 14.5894C74.1467 14.2505 73.8811 14.3787 73.5331 14.4428C73.4781 14.8824 73.5697 15.3312 73.0843 15.496C73.1301 15.4777 72.9469 13.9391 72.9103 13.8017C72.7363 13.1332 72.3974 12.9958 71.738 12.9866C71.738 12.9866 70.9321 13.124 70.9138 13.124C70.3001 13.2248 69.1737 12.5928 68.6425 12.3455C68.3403 12.199 68.038 12.0616 67.7724 11.8693C67.6534 11.7869 67.6442 11.6587 67.516 11.6037C67.342 11.5213 67.0672 11.6403 66.8749 11.5671C66.6185 11.4663 66.4994 11.1458 66.2247 10.9993C66.014 10.8894 65.7393 10.8894 65.5103 10.8252C64.8875 10.6604 64.2648 10.4406 63.6878 10.1842C61.3524 9.14926 59.539 7.02451 57.863 5.12871C57.3593 4.56089 56.5259 3.43441 55.6467 3.58094C55.7383 4.09381 56.5442 4.48762 56.1504 5.11955C56.068 5.25693 55.8756 5.39431 55.7657 5.51337C55.5917 5.71485 55.6192 5.86139 55.3353 5.99876C55.5551 6.50248 55.088 7.0703 54.6301 7.15272C54.6942 7.44579 54.8774 7.87624 54.8408 8.16015C54.8133 8.38911 54.5935 8.5448 54.4927 8.77376C54.2729 9.28663 54.1722 10.0193 54.1356 10.578C54.0898 11.329 54.0714 11.9059 54.511 12.428C54.8591 12.8401 55.1704 13.3621 55.3445 13.875C55.9947 15.8166 55.6009 18.0512 55.2071 20.002C55.088 20.579 54.914 21.2201 54.9049 21.8153C54.9049 22.0993 54.9323 22.5572 55.0605 22.8136C55.1613 22.9968 55.4086 23.0884 55.4727 23.2807C55.6192 23.7111 55.4086 24.5537 55.3902 25.0025C55.3719 25.4421 55.3903 25.9 55.3261 26.3396C55.1796 27.2738 54.795 28.2446 54.5294 29.1512C54.5843 29.1696 54.6851 29.1787 54.74 29.1787C54.8133 28.7116 54.8957 28.2446 54.969 27.7775C55.5368 27.7317 55.7108 27.7683 56.187 28.1072C56.6541 28.4369 56.59 28.5468 56.5442 29.1054C57.3044 29.5267 57.9363 30.0213 58.8155 30.0121C58.8063 30.1129 58.7422 30.296 58.6873 30.3785C58.0554 30.3601 57.2769 30.3418 56.6633 30.4609C55.9398 30.5983 55.6833 30.9829 55.6925 31.6881C55.5276 31.7156 55.3719 31.7339 55.2071 31.7614C55.1521 31.6057 55.0972 31.4592 55.0422 31.3035C54.9507 31.3859 54.8041 31.4134 54.7125 31.4958C54.7217 31.4042 54.914 30.296 54.8316 30.2502L54.5843 30.1312V32.0911L54.2821 33.0802L54.5294 33.3092L54.8133 33.1809L55.1705 33.4832L55.4269 33.2084L55.8848 33.648L56.1962 33.4007L56.6266 33.3641L56.645 33.822L57.0113 34.1884L57.2403 34.9027L57.6615 34.9302L57.7073 35.2233L57.0937 35.3332L56.8464 35.2233L56.8007 34.7012L55.839 34.7745L55.7932 35.5163L55.9947 35.9101L55.665 36.2765L55.2895 35.7178L55.4544 36.6428C55.4544 36.6428 55.4727 37.2106 55.4727 37.229C55.4818 37.5861 54.969 37.6869 54.74 37.7418C54.8133 38.0166 54.9506 38.2913 54.8041 38.5661C55.3445 38.9141 55.436 39.1431 55.2804 39.7475C55.2162 39.7384 55.0972 39.6926 55.0422 39.6559C55.0606 39.253 54.9873 39.1705 54.6759 38.9324C54.2088 39.2072 54.1172 39.253 53.9524 39.7475L53.5403 39.4361L53.1831 39.3446L53.6044 36.9542L53.9341 35.7361L53.9432 34.8569L52.5054 39.8666L52.2031 40.2787L52.7435 40.1413L53.1464 40.352L53.4303 40.6267L53.3937 41.0205L53.9982 41.8448L54.3554 42.0554C54.3554 42.0554 56.3244 41.7441 56.3244 41.7349L57.3044 42.321C59.0903 42.3852 60.0153 42.4676 59.887 43.6032Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M92.4123 44.0699H94.0415L95.9015 37.3865L97.7103 44.0699H99.4164L101.713 34.8979H100.122L98.4799 41.6711L96.6584 34.8979H95.2473L93.4642 41.6326L91.8735 34.8979H90.1289L92.4123 44.0699ZM101.579 44.0699H103.183L103.901 41.7993H107.403L108.134 44.0699H109.905L106.877 34.8979H104.645L101.579 44.0699ZM105.658 36.2961L107.005 40.555H104.299L105.658 36.2961Z",
	            fill: labelColor }, labelTooltip)),
	        _react2.default.createElement("path", { d: "M80.3561 14.3055L80.4935 13.9116L80.5667 13.6552L80.7774 13.7193L80.8781 13.9116L81.0246 13.9483L81.0704 13.527L80.5393 12.9408L80.292 13.2431L80.0447 13.0691L79.6509 13.1423L79.2846 13.8384L79.3944 14.1314L79.2662 14.278L79.3212 15.148L79.4769 15.4045L79.7242 15.3587L79.8982 15.7525L80.1271 15.9906L80.3286 16.4302L80.3744 16.8332L80.6583 16.879L80.6034 16.3386L80.1821 15.4228L79.9348 14.7725L79.9623 14.3329L80.3561 14.3055Z",
	            fill: color }),
	        _react2.default.createElement("path", { d: "M76.7202 25.6802L76.592 26.0465L76.3264 26.3305L76.07 26.7701L75.7311 27.5394L75.438 28.3911L75.8959 28.327L76.3081 28.0614L76.8667 27.9607L77.2148 27.8141L76.7294 27.5394L76.821 27.1456L76.7843 26.2022L76.9034 25.7809L76.7202 25.6802Z",
	            fill: color }),
	        _react2.default.createElement("path", { d: "M76.244 5.87971L76.3722 5.64159V5.2661L76.6378 5.34852L76.5737 5.67822L76.6195 6.04456L76.8484 6.39258L77.3796 6.31931L77.462 6.1453L77.4437 5.69654L77.3246 4.97303L77.3613 4.49679L77.6818 4.58837L77.6269 5.40347L77.8741 5.9255L77.9383 6.42921L78.2496 6.42006L78.2588 6.05372L78.616 5.94382V5.93466L79.0098 5.79728L79.2113 5.65991L79.2021 5.63243L78.3687 4.73491L77.9566 4.36857L77.7551 4.26783L77.4895 4.21288L77.1873 4.24951L76.1798 4.88144L75.7128 5.21114V5.49506L76.0699 5.50421L76.244 5.87971Z",
	            fill: color }),
	        _react2.default.createElement("path", { d: "M76.5004 9.12179L76.6103 9.16758L77.3246 9.30496L77.4529 9.22253L77.517 8.86535L77.5444 8.3708L78.0756 7.98615L78.0298 7.59233L77.4529 7.53738L77.4345 8.00446L77.233 8.50817L77.1598 8.38911L77.2239 8.11436L76.9858 7.7755L77.2056 7.52822L77.5536 7.21684L77.3063 7.10694L77.3246 6.8505L77.2605 6.50248L77.114 6.57575L76.9491 6.80471L76.7202 6.78639L76.3905 7.37253L76.1432 7.72971L76.0974 8.18763L76.3996 8.38911L76.3264 8.99357L76.5004 9.12179Z",
	            fill: color }),
	        _react2.default.createElement("path", { d: "M73.7437 5.75149L73.817 6.33763L73.8719 6.6307L73.9452 6.81386L74.1284 7.08862L74.8794 7.89456L75.2091 8.15099L75.6487 8.325L75.7403 8.05941L75.3098 7.91287L75.2823 7.41832L75.4289 7.08862L75.7219 7.17104L75.9692 6.9604L75.786 6.76807L75.5113 6.68565L75.5479 6.34678L75.1908 5.8156L74.8336 5.35768L74.9984 5.01881L74.4031 4.82649L74.0917 4.75322L73.8261 4.94555L73.6888 5.10124L73.6705 5.20198L73.8719 5.48589L73.7437 5.75149Z",
	            fill: color }),
	        _react2.default.createElement("path", { d: "M79.6601 10.3673L79.6234 10.2849L79.541 10.2299L79.4311 10.2757L79.3761 10.3215L79.1197 10.2116L79.0281 10.2483L78.9549 10.5505L78.7809 10.8436L77.8284 11.7319L77.6727 12.025L77.1415 12.4371L76.9308 12.895L77.1232 13.1423L77.1964 13.3804L77.4346 13.5545L77.5719 14.278L78.0207 14.2047L78.3596 14.4337V15.1572L77.8375 15.7983L77.9841 16.3569L77.7826 16.5218L77.8925 16.9247L78.1764 17.0713L78.3046 17.4193L78.1672 17.6849L78.3046 17.8681L78.5702 17.7673L78.8907 17.6666L79.1014 17.7948L79.2754 18.1703L79.3487 18.5183L79.193 18.7564V19.0495L79.7242 19.1319L80.1912 18.903L80.4202 18.3993L80.3378 17.8955L80.4935 17.3186L80.118 17.1171L79.8157 16.7416L79.6601 16.247L79.4494 15.8349L79.138 15.7342L79.0006 16.1921L79.019 16.7965L78.6343 17.1354L78.561 16.7141L78.7351 16.0639L78.5061 15.5418L78.8083 15.2304L78.7534 14.2139L78.6343 13.5636L78.1489 13.2156L77.4437 13.1973L77.4346 12.7577L78.0482 12.8584L78.3596 12.5104L78.7625 12.199L78.8816 12.1349H79.1197L79.2846 12.1898L79.3761 12.2723L79.4952 12.5379L79.5776 12.5653L79.8066 12.6203L79.9165 12.602L80.1729 12.4463L80.1912 12.4096L80.2187 12.2356L80.1638 12.0433L79.4311 11.2007L79.7425 10.578L79.6601 10.3673Z",
	            fill: color }),
	        _react2.default.createElement("path", { d: "M528.56 78.5059L528.935 79.5225L529.576 79.898L529.952 80.6032L530.584 80.5941L529.97 79.9438L529.42 79.0188L529.567 78.3594L529.75 78.2587L529.878 77.7275L529.906 77.4069L529.741 77.2054L529.613 77.1871L528.953 77.1322L528.688 77.6725L528.147 77.9198L528.175 78.3411L528.56 78.5059Z",
	            fill: color })
	    );
	};
	
	MAP.WI = function () {
	    var _ref49 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref49$color = _ref49.color,
	        color = _ref49$color === undefined ? "#6496c2" : _ref49$color,
	        _ref49$labelColor = _ref49.labelColor,
	        labelColor = _ref49$labelColor === undefined ? "white" : _ref49$labelColor,
	        _ref49$tooltip = _ref49.tooltip,
	        tooltip = _ref49$tooltip === undefined ? {} : _ref49$tooltip,
	        _ref49$labelTooltip = _ref49.labelTooltip,
	        labelTooltip = _ref49$labelTooltip === undefined ? {} : _ref49$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M434.988 82.2609L435.116 82.2426L435.226 82.3158L435.4 82.4166L435.547 82.4807L435.776 82.5173L437.241 82.2701L437.598 82.1785L440.419 80.9879L440.593 81.0062L440.895 80.9329C441.701 80.7314 444.11 78.3594 444.806 79.2753C444.879 79.0646 445.108 78.8906 445.181 78.6891C445.447 78.9089 445.539 78.7899 445.777 78.8998C445.841 78.8357 445.731 78.6342 445.768 78.5517C445.832 78.5609 446.18 78.68 446.216 78.6708C446.464 78.2129 446.775 77.8191 447.178 77.4436C447.352 77.5443 447.59 77.5535 447.764 77.6542C448.442 76.4819 449.458 77.3795 449.898 78.2129C449.403 78.8448 449.403 79.8248 448.634 80.1178C448.286 80.7772 448.79 81.2626 448.68 81.8854C448.625 82.1876 447.892 82.9386 447.773 83.3416C448.598 84.1842 450.081 82.4899 450.209 81.6381C451.208 82.38 452.215 83.3691 453.433 83.4423C453.497 83.4423 453.552 83.4332 453.616 83.4332L454.093 83.6805C454.221 83.7537 454.349 83.8178 454.468 83.8819C454.899 84.1017 455.302 84.3032 455.595 84.6421C456.043 85.1366 456.465 85.677 456.877 86.199C457.087 86.4646 457.298 86.7302 457.509 86.9866C458.077 87.6827 459.148 87.8201 460.091 87.9483C460.366 87.9849 460.623 88.0215 460.852 88.0673L466.795 89.2854C467.153 89.3587 467.519 89.4228 467.885 89.496C468.755 89.6517 469.653 89.8257 470.477 90.0822C470.862 90.2012 471.228 90.3844 471.613 90.5767C471.933 90.7324 472.245 90.8973 472.583 91.0255C473.105 91.227 473.673 91.346 474.214 91.4743C474.461 91.5292 474.708 91.5842 474.946 91.6483C475.02 91.6666 475.111 91.6849 475.212 91.6941C475.322 91.7124 475.56 91.749 475.624 91.7857C475.725 91.8681 475.752 91.9139 475.771 91.9505C475.917 92.2894 476.192 92.271 476.512 92.2619C476.778 92.2527 477.053 92.2161 477.309 92.1886C477.74 92.1337 478.152 92.0879 478.555 92.1245C479.205 92.1886 479.855 92.2802 480.505 92.3626L481.458 92.4908C481.852 92.5366 482.42 92.6465 482.786 93.0129C483.07 93.2876 483.07 93.2876 482.878 93.5441C482.804 93.654 482.713 93.773 482.63 93.9287C482.484 94.1943 482.456 94.4416 482.557 94.6614C482.722 95.046 483.171 95.1834 483.583 95.2842C483.839 95.3483 484.132 95.4032 484.434 95.4582C485.881 95.7146 486.907 95.971 486.944 96.9693C486.953 97.2257 486.98 97.5005 487.008 97.7936C487.072 98.398 487.136 99.0208 487.026 99.5154C486.916 100.047 486.605 100.614 486.303 101.173C486.147 101.457 486.001 101.732 485.881 101.997C485.836 102.107 485.845 102.226 485.9 102.327C485.964 102.428 486.065 102.483 486.184 102.492C486.321 102.492 486.468 102.501 486.614 102.51C486.926 102.528 487.246 102.547 487.567 102.519C487.96 102.483 488.144 102.281 488.272 102.144C488.354 102.061 488.4 101.997 488.455 101.97C488.574 101.979 488.895 102.171 488.931 102.245C488.94 102.345 488.803 102.675 488.739 102.812C488.693 102.922 488.656 103.014 488.629 103.087C488.583 103.215 488.528 103.353 488.473 103.49C488.244 104.049 487.951 104.754 488.345 105.377C488.904 106.265 489.508 106.531 490.369 106.668L490.149 107.153L490.039 107.465L490.113 108.72L489.572 108.82L488.537 109.049L488.464 109.068L487.915 109.223L487.841 109.287L487.631 109.635L487.53 110.029L487.86 110.368L487.832 110.67L487.521 110.982L487.466 111.339L487.191 111.412L487.035 111.714L486.687 112.823L486.165 113.464L486.129 114.059L486.138 114.361L485.991 114.581L485.955 115.176L486.165 115.341L486.065 115.598L485.826 116.074L485.662 116.092L485.653 116.202L486.156 116.642L486.596 116.761L486.935 116.742L487.1 116.623L487.237 116.394L487.402 116.019L487.42 115.927L487.356 115.808L487.374 115.744L487.768 115.295L488.446 114.746L489.004 114.563C489.004 114.553 489.279 113.976 489.279 113.976C489.279 113.967 489.389 113.116 489.389 113.116C489.948 112.108 490.378 111.44 491.358 110.808C491.871 110.478 492.384 110.432 492.723 109.883C492.814 110.038 493.034 110.276 493.089 110.451C493.41 109.809 493.144 108.646 493.684 107.648C494.261 106.586 494.555 106.146 494.582 104.91C494.573 104.91 494.838 104.791 494.829 104.791C496.084 105.303 495.873 103.188 496.551 102.702C497.668 101.897 498.035 103.069 497.476 103.902C497.357 103.838 497.275 103.737 497.146 103.673C496.844 104.131 496.89 104.708 497.238 105.139C497.201 105.285 497.027 105.358 496.963 105.487C497.275 106.064 496.908 106.696 496.23 106.696C496.258 107.584 495.223 108.161 495.873 109.031C495.571 109.141 495.562 109.333 495.305 109.507C495.69 110.157 494.518 110.853 494.261 111.54C493.831 112.694 493.904 113.931 493.071 114.883L492.778 115.836L492.65 116.568L492.457 119.124L492.201 119.829L492.787 121.486L492.824 121.816L492.787 122.137L492.723 122.356L492.503 122.732L492.237 123.025L491.789 123.291L491.551 123.474L491.257 123.803L491.239 124.829L490.928 125.315L490.827 125.864L490.882 126.322L490.525 127.577C490.909 129.005 491.294 130.196 491.065 131.698C490.68 134.235 488.876 136.552 489.27 139.208C489.371 139.913 489.609 140.49 489.728 141.14C489.792 141.498 490.149 141.717 490.195 142.111C490.241 142.505 489.755 142.477 489.911 143.054C490.03 143.494 490.479 143.467 490.635 143.915C490.735 144.208 490.571 144.547 490.653 144.859C490.882 145.701 490.9 146.48 491.853 146.8C491.761 148.531 491.624 149.85 491.734 151.563C489.206 151.737 486.678 151.938 484.151 152.149C479.938 152.497 475.478 152.79 470.129 153.065C467.94 153.175 465.742 153.303 463.553 153.431C461.007 153.577 458.452 153.724 455.906 153.852C455.787 153.055 454.99 152.048 454.981 152.039C454.587 151.544 453.909 151.444 453.369 151.37C453.241 151.352 453.122 151.334 453.003 151.315L452.728 151.26C452.133 151.15 451.574 151.05 451.08 150.748C450.383 150.326 450.228 150.033 449.88 149.273C449.797 149.099 449.715 148.916 449.632 148.742C449.376 148.201 449.129 147.689 449.001 147.148L448.9 146.754C448.726 146.077 448.533 145.298 448.543 144.685C448.552 144.153 448.744 143.586 449.165 142.89C449.211 142.816 449.275 142.734 449.339 142.633C449.578 142.303 449.852 141.928 449.861 141.571C449.871 141.177 449.568 140.774 449.275 140.426C449.019 140.133 448.707 139.922 448.405 139.721L448.057 139.483C447.984 139.428 447.892 139.373 447.883 139.354C447.874 139.327 447.865 139.235 447.874 139.08C447.883 138.375 447.792 137.66 447.645 136.955V136.882H447.636C447.535 136.369 447.407 135.856 447.288 135.352C447.187 134.949 447.096 134.546 447.013 134.162C446.857 133.411 446.738 132.66 446.656 132.101C446.519 131.13 446.262 130.81 445.658 130.04C445.557 129.912 445.475 129.793 445.383 129.674C445.007 129.161 444.659 128.685 443.899 128.465L443.643 128.392C443.048 128.227 442.58 128.09 442.095 127.742L439.375 125.791C438.816 125.388 438.642 125.269 438.468 124.655C438.404 124.445 438.313 124.252 438.23 124.087C438.157 123.95 438.093 123.822 438.075 123.73C438.056 123.611 438.056 123.538 438.056 123.465C438.065 123.19 438.02 123.007 437.69 122.695C437.159 122.182 436.481 121.899 435.831 121.633L435.73 121.587C435.492 121.486 435.254 121.404 435.016 121.322C434.512 121.138 434.036 120.974 433.624 120.69C433.239 120.433 433.239 120.433 433.184 120.186C433.166 120.103 433.147 120.012 433.111 119.847C433.028 119.508 432.955 119.288 432.46 119.142C432.057 119.023 431.645 119.05 431.242 119.069C430.849 119.087 430.482 119.114 430.18 118.995C429.832 118.858 429.576 118.51 429.328 118.162C429.2 117.979 429.072 117.805 428.934 117.658C428.559 117.255 428.074 116.88 427.726 116.632C427.616 116.559 427.478 116.495 427.332 116.431C427.213 116.376 427.002 116.284 426.965 116.257C426.892 116.092 427.103 115.414 427.204 115.085C427.295 114.792 427.368 114.544 427.396 114.343C427.533 113.381 427.478 112.557 427.222 111.751C426.993 111.018 426.874 110.643 426.956 109.901C427.057 109.031 427.149 108.17 427.258 107.3C427.295 106.97 427.469 106.686 427.671 106.357C427.817 106.119 427.964 105.871 428.074 105.587C428.33 104.937 428.238 104.195 427.808 103.307C427.341 102.354 426.819 101.951 425.857 101.832C425.729 101.814 425.518 101.787 425.482 101.759C425.482 101.759 425.445 101.713 425.418 101.503C425.381 101.21 425.381 100.972 425.418 100.779C425.546 100.101 425.866 99.4054 426.141 98.8651C426.251 98.6361 426.361 98.398 426.471 98.1507C426.7 97.6379 426.938 97.0975 427.249 96.6854C427.57 96.2641 428.074 95.9436 428.568 95.6322L429.319 95.1468C429.795 94.8354 430.262 94.524 430.748 94.2218C430.849 94.1577 430.977 94.0936 431.123 94.0203C431.526 93.8188 431.975 93.5899 432.186 93.2876C432.369 93.022 432.351 92.729 432.332 92.4634L431.993 83.3599C432.332 83.4332 432.717 83.3874 432.946 83.1676C433.33 82.8012 433.202 82.4166 433.138 82.2151C433.12 82.1602 433.092 82.0777 433.092 82.0594C433.166 81.9037 433.697 81.574 433.871 81.574C433.917 81.5832 434.045 81.7297 434.109 81.8121C434.292 82.0136 434.558 82.3433 434.988 82.2609ZM499.427 100.175L499.564 100.166L499.555 99.8634L499.353 99.7901L499.344 99.9824L499.207 100.193L498.996 100.211L498.914 100.092L498.657 100.111L498.566 100.211L498.19 100.248L498.062 100.101H497.925L497.833 100.624L497.852 100.935L497.943 100.999L497.952 101.146L497.888 101.164L497.925 101.466L498.254 101.704L498.667 102.144V101.631L499.024 101.439L499.005 100.907L499.207 100.477L499.427 100.175Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M458.009 125.619H459.639L461.499 118.936L463.307 125.619H465.014L467.31 116.447H465.719L464.077 123.22L462.256 116.447H460.844L459.061 123.182L457.471 116.447H455.726L458.009 125.619ZM468.747 125.619H470.466V116.447H468.747V125.619Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.WV = function () {
	    var _ref50 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref50$color = _ref50.color,
	        color = _ref50$color === undefined ? "#6496c2" : _ref50$color,
	        _ref50$labelColor = _ref50.labelColor,
	        labelColor = _ref50$labelColor === undefined ? "white" : _ref50$labelColor,
	        _ref50$tooltip = _ref50.tooltip,
	        tooltip = _ref50$tooltip === undefined ? {} : _ref50$tooltip,
	        _ref50$labelTooltip = _ref50.labelTooltip,
	        labelTooltip = _ref50$labelTooltip === undefined ? {} : _ref50$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M622.937 183.599C622.818 183.672 622.699 183.938 622.608 184.157C622.516 184.35 622.434 184.542 622.324 184.689C622.287 184.734 622.269 184.771 622.259 184.799C622.168 184.954 622.076 185.055 621.838 185.128C621.637 185.192 621.435 185.11 621.27 185.046C621.234 185.037 621.197 185.018 621.16 185C621.041 185.147 620.849 185.55 620.767 185.742C620.693 185.898 620.638 186.026 620.593 186.108C620.556 186.181 620.501 186.282 620.455 186.401C620.254 186.841 620.08 187.189 619.832 187.345C619.53 187.537 619.027 187.528 618.386 187.5C618.211 187.491 618.056 187.491 617.955 187.491L617.818 187.5C617.515 187.519 617.204 187.537 616.865 187.464C616.7 187.427 616.49 187.317 616.252 187.189C616.059 187.088 615.711 186.868 615.574 186.896C615.574 186.932 615.391 187.235 615.308 187.372C615.244 187.482 615.189 187.583 615.143 187.628L613.797 189.488C613.568 189.808 613.458 189.863 613.055 189.845C612.79 189.826 612.607 189.772 612.423 189.717C612.277 189.671 612.039 189.588 611.965 189.625C611.791 189.707 611.535 190.101 611.361 190.358C611.26 190.513 611.159 190.651 611.077 190.751L610.702 191.191C610.207 191.777 609.74 192.327 609.392 192.968C609.035 193.618 608.375 194.836 607.322 195.175C607.231 195.202 607.121 195.193 607.038 195.138C606.956 195.083 606.892 195.001 606.883 194.9L605.509 186.31C601.708 186.978 598.008 187.619 594.363 188.224C594.207 188.251 594.024 188.297 593.823 188.343C593.301 188.471 592.705 188.618 592.293 188.544L592.183 188.526C591.844 188.48 591.762 188.315 591.734 188.041C591.725 187.995 591.725 187.94 591.707 187.857L590.581 180.943C590.287 179.139 589.985 177.334 589.692 175.539L589.28 173.039C589.17 173.14 589.06 173.222 588.941 173.268C588.776 173.341 588.63 173.341 588.529 173.351C588.401 173.36 588.355 173.36 588.254 173.46C588.089 173.625 588.089 173.699 588.089 173.699C588.089 173.753 588.236 173.891 588.328 173.964C588.456 174.083 588.602 174.221 588.721 174.404C589.005 174.843 589.362 175.402 589.289 176.034L589.28 176.144C589.253 176.373 589.243 176.483 589.271 176.739C589.28 176.812 589.271 176.876 589.243 176.941C589.326 176.986 589.399 177.051 589.445 177.142C589.527 177.307 589.509 177.472 589.491 177.573C589.491 177.664 589.518 177.701 589.536 177.728C589.601 177.811 589.674 177.911 589.701 178.04C589.775 178.314 589.72 178.534 589.674 178.726L589.637 178.891C589.674 178.965 589.729 179.12 589.656 179.285C589.591 179.432 589.472 179.532 589.381 179.606C589.353 179.624 589.317 179.661 589.298 179.67C589.207 179.807 589.179 179.945 589.134 180.137L589.079 180.366C589.042 180.494 588.987 180.631 588.932 180.769C588.877 180.897 588.822 181.034 588.804 181.126C588.795 181.199 588.831 181.327 588.868 181.456C588.914 181.602 588.96 181.776 588.96 181.95C588.96 182.234 588.85 182.408 588.767 182.536C588.721 182.619 588.685 182.665 588.666 182.756C588.666 182.765 588.694 182.857 588.703 182.921C588.731 183.04 588.767 183.177 588.767 183.297V183.59C588.767 183.782 588.767 183.965 588.785 184.167C588.813 184.46 588.767 184.606 588.731 184.734C588.712 184.799 588.694 184.863 588.676 184.982C588.676 184.991 588.721 185.073 588.74 185.119C588.831 185.302 588.96 185.577 588.795 185.843C588.703 185.98 588.593 186.053 588.483 186.09C588.547 186.227 588.584 186.346 588.566 186.465C588.538 186.667 588.401 186.795 588.291 186.905C588.254 186.942 588.181 187.015 588.172 187.042C588.172 187.061 588.19 187.143 588.209 187.198C588.245 187.326 588.3 187.482 588.263 187.665C588.227 187.857 588.108 188.013 587.98 188.169C587.943 188.215 587.897 188.279 587.86 188.325C587.897 188.361 587.952 188.398 587.989 188.434C588.218 188.627 588.685 189.011 588.383 189.552C588.282 189.735 588.117 189.808 588.025 189.845C587.998 189.872 588.016 190.01 588.034 190.11C588.062 190.275 588.099 190.458 588.053 190.642C587.934 191.246 587.686 191.393 587.283 191.466C587.183 191.484 587.082 191.502 586.972 191.557C586.807 191.64 586.551 192.006 586.404 192.226C586.34 192.318 586.285 192.4 586.239 192.464C586.02 192.757 585.864 193.087 585.699 193.444C585.534 193.81 585.351 194.186 585.104 194.525C584.948 194.735 584.756 194.864 584.6 194.964C584.417 195.083 584.289 195.166 584.215 195.358C584.215 195.376 584.206 195.422 584.206 195.477C584.188 195.679 584.17 195.899 583.986 196.036C583.812 196.173 583.593 196.137 583.41 196.109C583.364 196.1 583.309 196.091 583.263 196.091C583.171 196.137 583.016 196.32 582.869 196.494C582.658 196.741 582.43 197.025 582.091 197.126C581.44 197.327 581.193 196.842 581.056 196.585C581.019 196.521 580.983 196.448 580.937 196.375C580.836 196.228 580.781 196.173 580.754 196.155C580.744 196.164 580.708 196.192 580.662 196.256C580.625 196.292 580.598 196.366 580.561 196.439C580.515 196.54 580.46 196.65 580.378 196.759C580.286 196.869 580.186 196.952 580.094 197.034C580.012 197.098 579.938 197.162 579.893 197.227C579.783 197.382 579.792 197.483 579.819 197.721C579.847 197.923 579.884 198.17 579.792 198.481H579.774C579.792 198.573 579.774 198.674 579.709 198.756C579.655 198.829 579.581 198.875 579.499 198.884C579.261 199.022 578.995 199.022 578.766 199.012C578.675 199.012 578.556 199.012 578.51 199.022C578.372 199.049 578.327 199.076 578.317 199.076C578.327 199.076 578.317 199.122 578.317 199.15C578.299 199.269 578.262 199.434 578.162 199.635C578.098 199.773 577.988 199.873 577.896 199.956C577.768 200.084 577.695 200.148 577.695 200.276C577.686 200.423 577.74 200.588 577.805 200.771C577.905 201.064 578.015 201.394 577.924 201.769C577.832 202.135 577.612 202.319 577.356 202.419C577.356 202.419 577.365 202.419 577.365 202.428C577.466 202.502 577.566 202.584 577.676 202.694C578.098 203.115 578.061 203.399 577.969 203.692C577.942 203.793 577.914 203.876 577.914 204.004C577.924 204.013 577.979 204.086 578.015 204.141C578.143 204.306 578.455 204.7 578.116 205.112C577.933 205.332 577.731 205.387 577.594 205.405C577.365 205.432 577.145 205.332 576.971 205.213C576.898 205.506 576.779 205.79 576.532 206C576.266 206.22 575.854 206.284 575.542 206.165C575.277 206.064 575.094 205.845 575.048 205.561C575.011 205.323 575.158 205.13 575.268 204.993C575.295 204.956 575.341 204.892 575.359 204.874C575.332 204.901 575.24 204.773 575.185 204.7C575.149 204.654 575.112 204.599 575.084 204.562L575.02 204.462C574.993 204.416 574.947 204.343 574.92 204.315C574.727 204.379 574.553 204.398 574.315 204.224C574.224 204.159 574.169 204.077 574.123 204.004L574.059 204.095C573.903 204.333 573.72 204.608 573.619 204.846C573.564 204.975 573.537 205.139 573.5 205.313C573.463 205.524 573.427 205.735 573.335 205.945C573.299 206.028 573.244 206.11 573.198 206.174C573.17 206.211 573.134 206.266 573.125 206.284C573.125 206.312 573.143 206.394 573.152 206.449C573.18 206.559 573.216 206.687 573.198 206.834C573.161 207.292 572.941 207.53 572.74 207.731C572.685 207.786 572.63 207.841 572.566 207.914C572.493 208.006 572.419 208.061 572.364 208.098C572.364 208.107 572.364 208.116 572.364 208.125C572.364 208.134 572.364 208.143 572.355 208.143C572.419 208.198 572.474 208.272 572.538 208.381C572.603 208.501 572.648 208.62 572.694 208.748C572.722 208.821 572.749 208.885 572.777 208.958C572.786 208.968 572.813 208.995 572.831 209.013C572.914 209.105 573.024 209.215 573.051 209.371C573.088 209.563 573.088 209.7 573.079 209.838C573.079 209.993 573.079 210.103 573.143 210.296C573.308 210.726 573.564 211.422 572.795 211.779C572.603 211.871 572.392 211.843 572.218 211.834C572.145 211.825 572.016 211.816 571.98 211.825C571.98 211.862 572.007 212.118 572.016 212.246C572.026 212.384 572.035 212.512 572.035 212.594C572.035 212.695 572.035 212.796 572.035 212.906C572.035 213.19 572.035 213.51 571.961 213.803C571.76 214.618 571.128 214.719 570.661 214.801C570.496 214.829 570.331 214.856 570.176 214.911C569.956 214.994 569.745 215.113 569.544 215.232C569.177 215.443 568.774 215.681 568.28 215.681H568.271C568.28 215.717 568.28 215.745 568.289 215.781C568.326 216.038 568.362 216.267 568.481 216.477C568.838 217.128 568.765 217.586 568.619 218.218C568.591 218.309 568.555 218.437 568.5 218.593C568.417 218.85 568.161 219.61 568.243 219.793C568.234 219.765 568.344 219.811 568.399 219.839C568.536 219.894 568.683 219.958 568.793 220.058C568.893 220.168 568.939 220.287 568.985 220.388C568.994 220.425 569.012 220.471 569.031 220.489C569.168 220.535 569.287 220.571 569.388 220.663C569.599 220.855 569.736 221.084 569.855 221.277C570.002 221.524 570.13 221.725 570.359 221.835C570.386 221.844 570.432 221.853 570.478 221.872C570.771 221.945 571.064 222.028 571.165 222.284C571.293 222.604 571.064 222.87 570.927 223.026C570.908 223.053 570.881 223.081 570.853 223.108C570.963 223.273 571.348 223.594 571.54 223.758C571.733 223.914 571.897 224.061 571.989 224.161C572.346 224.564 572.685 224.995 573.024 225.425L573.317 225.792C573.454 225.966 573.573 226.167 573.683 226.369C573.811 226.598 573.94 226.817 574.095 226.973C574.214 227.092 574.562 227.294 574.746 227.349C574.846 227.376 574.892 227.385 574.901 227.385C574.901 227.385 574.965 227.339 575.02 227.312L575.149 227.229C575.231 227.184 575.323 227.165 575.414 227.193C575.506 227.22 575.579 227.275 575.625 227.367C575.945 227.98 576.193 228.411 576.706 228.704C577.072 228.924 577.282 228.878 577.658 228.796C577.786 228.768 577.933 228.741 578.088 228.713C578.217 228.695 578.4 228.695 578.583 228.722L578.638 228.649L578.775 228.768C578.986 228.832 579.187 228.942 579.306 229.116C579.453 229.327 579.462 229.583 579.325 229.83C579.233 229.995 579.087 230.096 578.949 230.188C578.894 230.224 578.803 230.288 578.775 230.316C578.775 230.316 578.775 230.316 578.784 230.316C578.83 230.316 578.968 230.38 579.032 230.417C579.087 230.444 579.133 230.462 579.169 230.49L579.316 230.572C579.535 230.691 579.792 230.82 579.929 231.131C580.021 231.332 580.021 231.552 580.012 231.745C580.012 231.854 580.003 232.001 580.03 232.056C580.177 232.331 580.781 232.77 581.221 232.999C581.468 233.118 581.733 233.21 582.008 233.302C582.347 233.421 582.704 233.54 583.034 233.723C583.629 234.062 583.877 234.007 584.655 233.796C585.69 233.512 586.468 232.148 586.963 231.149C587.009 231.058 587.091 230.994 587.183 230.966C587.284 230.939 587.384 230.957 587.467 231.012L588.538 231.745C588.611 231.79 588.721 231.882 588.85 231.992C589.024 232.138 589.436 232.477 589.573 232.505C589.656 232.486 589.976 232.239 590.113 232.138C590.223 232.056 590.324 231.983 590.388 231.946C590.736 231.735 591.029 231.571 591.405 231.433C591.606 231.36 591.817 231.287 592.037 231.223C592.632 231.03 593.255 230.829 593.63 230.462C593.713 230.38 593.768 230.325 593.813 230.279C593.813 230.279 593.804 230.279 593.804 230.27C593.63 230.16 593.429 230.032 593.383 229.794C593.356 229.638 593.401 229.464 593.53 229.061C593.575 228.905 593.63 228.75 593.639 228.658C593.658 228.548 593.722 228.448 593.832 228.393C593.933 228.338 594.061 228.347 594.152 228.402C594.253 228.457 594.381 228.557 594.537 228.658C594.748 228.805 595.178 229.116 595.325 229.125C595.435 229.098 595.81 228.759 595.975 228.612C596.094 228.512 596.195 228.42 596.259 228.365C596.872 227.907 597.477 227.431 598.081 226.955L598.338 226.753C598.411 226.698 598.503 226.671 598.603 226.68C598.695 226.698 598.777 226.744 598.832 226.827L599.263 227.44C599.721 227.028 600.197 226.616 600.691 226.295C600.655 226.286 600.627 226.277 600.591 226.268C600.453 226.231 600.343 226.112 600.334 225.966C600.325 225.837 600.38 225.718 600.481 225.654C600.435 225.544 600.408 225.425 600.435 225.27C600.481 225.004 600.691 224.839 600.856 224.702C600.902 224.665 600.957 224.619 601.003 224.574C601.204 224.372 601.378 224.143 601.561 223.923L601.58 223.905C601.571 223.896 601.561 223.887 601.543 223.887C601.122 223.603 600.6 223.255 600.6 222.696C600.6 222.376 600.765 222.009 600.911 221.679C600.966 221.56 601.021 221.441 601.058 221.341C601.094 221.231 601.131 221.112 601.168 220.993C601.25 220.736 601.332 220.471 601.452 220.223C601.717 219.655 602.065 219.143 602.395 218.639C602.77 218.071 603.118 217.54 603.384 216.945C603.466 216.761 603.567 216.56 603.677 216.349C603.897 215.928 604.144 215.443 604.199 215.067C604.217 214.939 604.181 214.756 604.135 214.582C604.108 214.453 604.08 214.325 604.062 214.197C604.007 213.684 604.034 213.593 604.355 213.226C604.456 213.107 604.556 212.997 604.675 212.878C604.904 212.64 605.527 211.999 605.555 211.779C605.545 211.779 605.5 211.706 605.463 211.66C605.362 211.523 605.234 211.33 605.243 211.092C605.261 210.818 605.454 210.552 605.71 210.231C605.774 210.158 605.829 210.085 605.857 210.03C606.516 209.004 606.525 207.704 606.525 206.44V205.826C606.525 205.726 606.58 205.625 606.663 205.561C606.745 205.497 606.855 205.469 606.956 205.497C607.084 205.524 607.231 205.552 607.368 205.579C607.844 205.661 608.375 205.762 608.769 206.074C609.044 206.284 609.209 206.605 609.355 206.889C609.483 207.136 609.603 207.365 609.758 207.475C610.024 207.649 611.031 207.722 611.407 207.74L611.562 207.75C611.645 207.759 611.7 207.759 611.746 207.768C611.773 207.75 611.801 207.722 611.801 207.722C611.975 207.585 612.213 207.163 612.341 206.934L612.396 206.843C612.79 206.156 612.982 205.24 613.165 204.352C613.238 203.985 613.312 203.619 613.403 203.289C613.751 201.952 614.072 201 614.521 199.992C614.557 199.91 614.631 199.837 614.722 199.809C614.814 199.782 614.905 199.782 614.997 199.827L616.499 200.606C616.526 200.524 616.545 200.441 616.572 200.359C616.709 199.91 616.847 199.443 617.058 199.012L617.112 198.893C617.323 198.454 617.616 197.849 618.166 197.721C618.248 197.703 618.331 197.712 618.413 197.758C618.468 197.657 618.514 197.556 618.569 197.419L618.614 197.309C618.743 197.025 618.926 196.622 619.292 196.567C619.338 196.558 619.384 196.558 619.439 196.567L619.549 196.311C619.558 196.283 619.585 196.247 619.604 196.201C619.613 196.192 619.613 196.182 619.622 196.164C619.503 196.054 619.484 195.944 619.484 195.853C619.484 195.715 619.558 195.587 619.613 195.486C619.704 195.267 619.778 195.129 619.86 194.983L619.924 194.864C620.098 194.534 620.272 194.397 620.437 194.268C620.519 194.204 620.602 194.14 620.693 194.03C620.794 193.92 620.867 193.765 620.95 193.591C620.986 193.517 621.023 193.435 621.06 193.352C620.959 193.27 620.886 193.178 620.84 193.069C620.693 192.757 620.794 192.427 620.904 192.125C620.831 192.079 620.776 192.015 620.748 191.942C620.703 191.805 620.721 191.649 620.831 191.557C620.895 191.502 620.977 191.255 621.023 191.127C621.06 191.008 621.106 190.898 621.142 190.816C621.225 190.642 621.289 190.477 621.353 190.294C621.307 190.275 621.261 190.248 621.225 190.211C621.142 190.129 621.096 190.001 621.124 189.891C621.133 189.845 621.16 189.79 621.179 189.717C621.197 189.671 621.225 189.588 621.243 189.533C621.124 189.442 621.032 189.35 620.986 189.222C620.886 188.947 620.922 188.59 620.959 188.27C620.968 188.151 620.986 188.041 620.986 187.949C620.986 187.83 621.051 187.72 621.151 187.665C621.252 187.601 621.38 187.601 621.481 187.647C623.752 188.764 626.033 189.973 628.231 191.136L629.046 191.567L629.678 188.837C629.522 188.773 629.376 188.673 629.266 188.489C629.11 188.224 629.192 187.894 629.266 187.564C629.293 187.436 629.348 187.216 629.339 187.143C629.339 187.189 629.229 187.18 629.147 187.18C628.936 187.18 628.615 187.161 628.423 186.859C628.304 186.676 628.295 186.465 628.286 186.291C628.286 186.246 628.277 186.191 628.277 186.145C628.258 186.145 628.24 186.136 628.222 186.136C628.084 186.117 627.947 186.09 627.837 186.035C627.471 185.824 627.26 185.467 627.086 185.156C627.04 185.073 626.985 184.982 626.939 184.899C626.884 184.817 626.866 184.707 626.903 184.615C626.912 184.579 626.93 184.551 626.949 184.524C626.949 184.524 626.939 184.524 626.93 184.524C626.692 184.579 626.463 184.634 626.225 184.67C626.188 184.679 626.097 184.716 626.042 184.753C625.877 184.835 625.685 184.918 625.483 184.899C625.218 184.863 625.053 184.652 624.915 184.478C624.879 184.432 624.842 184.386 624.806 184.35C624.338 183.846 623.395 183.306 622.937 183.599Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M580.333 220.454H581.962L583.822 213.771L585.631 220.454H587.337L589.633 211.282H588.043L586.401 218.056L584.579 211.282H583.168L581.385 218.017L579.794 211.282H578.05L580.333 220.454ZM593.405 220.454H595.38L598.485 211.282H596.881L594.482 218.723L592.096 211.282H590.313L593.405 220.454Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.WY = function () {
	    var _ref51 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref51$color = _ref51.color,
	        color = _ref51$color === undefined ? "#6496c2" : _ref51$color,
	        _ref51$labelColor = _ref51.labelColor,
	        labelColor = _ref51$labelColor === undefined ? "white" : _ref51$labelColor,
	        _ref51$tooltip = _ref51.tooltip,
	        tooltip = _ref51$tooltip === undefined ? {} : _ref51$tooltip,
	        _ref51$labelTooltip = _ref51.labelTooltip,
	        labelTooltip = _ref51$labelTooltip === undefined ? {} : _ref51$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M191.686 166.125C191.649 166.28 191.557 166.647 191.539 166.839C191.695 166.857 192.116 166.894 192.29 166.903C192.437 166.912 192.556 166.921 192.611 166.93L195.056 167.333C196.063 167.498 210.818 169.632 216.743 170.456L217.421 170.548V170.557C217.732 170.603 218.016 170.64 218.254 170.667C222.879 171.29 271.364 176.831 276.163 177.234L278.278 177.417C279.396 177.508 280.504 177.609 281.621 177.701L281.786 175.842C281.933 174.102 282.088 172.361 282.235 170.621C282.464 167.837 282.702 165.044 282.94 162.26L284.561 143.155C284.561 143.146 284.561 143.137 284.561 143.119L284.753 140.801C284.992 137.935 285.23 135.059 285.468 132.193L286.026 125.589C286.411 120.992 286.805 116.394 287.18 111.797C287.263 110.771 287.373 109.745 287.492 108.729L283.563 108.362C280.495 108.078 277.436 107.795 274.377 107.483C272.472 107.291 270.558 107.126 268.653 106.961C265.86 106.714 262.966 106.467 260.126 106.137C255.007 105.542 212.246 99.8817 210.158 99.5978L209.233 99.4787C208.381 99.3688 207.493 99.2589 206.632 99.0941C206.183 99.0116 205.744 98.9109 205.304 98.801C204.7 98.6636 204.086 98.5171 203.463 98.4255C203.344 98.4072 203.225 98.3797 203.097 98.3431C202.932 98.3064 202.63 98.2332 202.557 98.2698C202.41 98.4804 202.355 99.1032 202.319 99.5062C202.3 99.7443 202.282 99.9549 202.245 100.12C202.172 100.514 202.099 100.907 202.016 101.31C201.861 102.116 201.705 102.922 201.577 103.737C201.412 104.754 201.265 105.771 201.119 106.787L201.274 106.934L201.073 107.153C201.064 107.199 201.064 107.245 201.055 107.291C200.89 108.463 200.716 109.635 200.533 110.808L199.763 115.662C198.564 123.263 196.549 135.993 195.917 139.922C195.267 143.888 194.635 147.863 194.003 151.837L191.768 165.859C191.741 165.905 191.713 166.005 191.686 166.125Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", Object.assign({ d: "M233.52 143.028H235.149L237.009 136.345L238.818 143.028H240.524L242.82 133.856H241.23L239.588 140.63L237.766 133.856H236.355L234.572 140.591L232.981 133.856H231.237L233.52 143.028ZM246.539 143.028H248.258V139.065L251.131 133.856H249.463L247.449 137.654L245.384 133.856H243.498L246.539 139.052V143.028Z",
	            fill: labelColor }, labelTooltip))
	    );
	};
	
	MAP.PR = function () {
	    var _ref52 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref52$color = _ref52.color,
	        color = _ref52$color === undefined ? "#6496c2" : _ref52$color,
	        _ref52$labelColor = _ref52.labelColor,
	        labelColor = _ref52$labelColor === undefined ? "white" : _ref52$labelColor,
	        _ref52$tooltip = _ref52.tooltip,
	        tooltip = _ref52$tooltip === undefined ? {} : _ref52$tooltip,
	        _ref52$labelTooltip = _ref52.labelTooltip,
	        labelTooltip = _ref52$labelTooltip === undefined ? {} : _ref52$labelTooltip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement("path", Object.assign({ d: "M692.368 447.427C692.368 447.427 692.443 447.283 692.292 447.152C692.142 447.023 691.946 446.835 691.946 446.835C691.946 446.835 691.691 446.892 691.676 446.835C691.662 446.777 691.601 446.648 691.586 446.56C691.571 446.473 691.421 446.242 691.421 446.242C691.421 446.242 691.226 446.199 691.12 446.185C691.015 446.171 690.594 446.142 690.594 446.142C690.594 446.142 690.519 446.286 690.444 446.272C690.369 446.258 690.264 446.128 690.264 446.128C690.264 446.128 690.129 446.214 690.069 446.185C690.01 446.156 690.114 446.113 689.783 446.113C689.452 446.113 689.002 446.099 689.002 446.099L688.897 446.128C688.897 446.128 688.837 446.272 688.672 446.287C688.506 446.301 688.356 446.416 688.356 446.416L688.191 446.575C688.191 446.575 688.296 446.662 688.236 446.734C688.176 446.806 688.011 446.921 687.921 446.921C687.83 446.921 687.681 446.921 687.635 446.907C687.589 446.893 687.544 446.806 687.544 446.806L687.319 446.893L687.259 446.763L686.854 446.749C686.854 446.749 686.568 446.62 686.478 446.649C686.388 446.678 686.312 446.721 686.298 446.635C686.283 446.548 686.148 446.317 686.012 446.332C685.877 446.346 685.471 446.389 685.41 446.607C685.351 446.823 685.38 447.054 685.38 447.054C685.38 447.054 685.62 447.213 685.56 447.284C685.5 447.356 685.47 447.327 685.425 447.313C685.38 447.299 685.185 447.313 685.185 447.313C685.185 447.313 685.14 447.299 685.171 447.213C685.171 447.213 685.216 446.795 685.216 446.938C685.216 446.938 685.216 446.751 685.095 446.708C684.975 446.665 684.825 446.622 684.735 446.751C684.735 446.751 684.704 446.579 684.704 446.492C684.704 446.406 684.69 445.858 684.704 445.728C684.719 445.599 684.78 445.426 684.899 445.367C685.02 445.31 685.681 445.079 685.681 445.079L685.695 445.252C685.695 445.252 686.101 445.151 686.101 445.093C686.101 445.036 686.07 444.906 685.996 444.934C685.921 444.963 685.846 445.035 685.846 445.035C685.846 445.035 686.041 444.646 685.861 444.544C685.681 444.442 685.02 444.328 684.854 444.198C684.854 444.198 685.02 444.039 685.049 443.953C685.078 443.867 685.109 443.78 685.109 443.78C685.109 443.78 685.033 443.665 685.078 443.607C685.123 443.55 685.154 443.348 685.154 443.348C685.154 443.348 685.544 443.334 685.575 443.248C685.605 443.161 685.305 442.973 685.305 442.973C685.305 442.973 685.335 443.16 685.259 443.175C685.184 443.189 685.155 443.002 685.155 442.916C685.155 442.829 685.23 442.714 685.214 442.671C685.2 442.627 685.2 442.627 685.2 442.627C685.2 442.627 685.259 442.469 685.365 442.411C685.471 442.354 685.576 442.296 685.591 442.209C685.605 442.123 685.515 441.186 685.515 441.186C685.515 441.186 685.861 440.956 685.801 440.84C685.741 440.725 685.726 440.552 685.726 440.552C685.726 440.552 685.515 440.495 685.531 440.422C685.547 440.35 685.681 440.292 685.726 440.249C685.771 440.206 685.921 439.932 686.057 439.817C686.192 439.701 686.538 439.558 686.552 439.442C686.567 439.327 686.432 439.038 686.357 438.952C686.282 438.865 685.997 438.677 685.967 438.591C685.936 438.504 685.877 437.943 685.877 437.943C685.877 437.943 685.772 437.756 685.682 437.654C685.592 437.554 685.516 437.538 685.502 437.424C685.487 437.309 685.457 436.977 685.411 436.919C685.366 436.862 685.262 436.717 685.125 436.689C684.99 436.66 684.96 436.632 684.765 436.603C684.57 436.574 684.239 436.632 684.134 436.502C684.03 436.373 683.954 436.185 683.909 436.098C683.864 436.012 683.684 435.796 683.684 435.796C683.684 435.796 683.609 435.55 683.518 435.435C683.428 435.319 683.443 435.233 683.383 435.19C683.324 435.146 683.324 435.146 683.324 435.146C683.324 435.146 683.248 434.959 683.188 434.901C683.129 434.843 683.023 434.728 683.039 434.642C683.054 434.555 682.934 434.44 683.053 434.397C683.174 434.353 683.234 434.31 683.399 434.296C683.565 434.282 683.88 434.21 683.97 434.196C684.06 434.182 684.676 433.994 684.782 433.95C684.887 433.907 685.293 433.734 685.383 433.633C685.473 433.532 685.504 433.373 685.564 433.358C685.623 433.344 686.165 433.113 686.239 433.084C686.315 433.055 686.479 432.954 686.509 432.752C686.54 432.55 686.299 431.902 686.284 431.829C686.27 431.757 686.149 431.541 686.134 431.469C686.12 431.396 686.12 430.993 686.18 430.935C686.239 430.878 686.419 430.791 686.525 430.69C686.631 430.588 686.72 430.401 687.006 430.285C687.292 430.17 687.532 430.099 687.712 430.099C687.892 430.099 687.952 430.128 688.133 430.069C688.314 430.012 688.51 429.969 688.749 430.055C688.749 430.055 688.885 429.969 688.96 430.012C689.035 430.055 689.14 430.113 689.14 430.113C689.14 430.113 689.306 429.997 689.41 430.026C689.515 430.055 689.756 430.113 689.906 430.113C690.056 430.113 690.266 430.185 690.311 430.213C690.356 430.241 690.356 430.242 690.356 430.242C690.356 430.242 690.401 430.315 690.537 430.199C690.537 430.199 690.972 430.372 691.138 430.444C691.303 430.517 691.574 430.56 691.619 430.631C691.664 430.704 691.889 430.732 692.024 430.732C692.159 430.732 692.475 430.832 692.52 430.832C692.565 430.832 692.624 430.76 692.775 430.775C692.925 430.789 692.925 430.789 692.925 430.789C692.925 430.789 693.391 430.919 693.481 430.933C693.572 430.947 693.932 431.033 694.038 431.005C694.142 430.976 694.233 430.991 694.338 430.962C694.443 430.933 694.564 430.889 694.684 430.889C694.805 430.889 694.924 430.86 695.015 430.789C695.106 430.718 695.301 430.861 695.376 430.846C695.451 430.832 695.525 430.789 695.676 430.817C695.827 430.845 696.143 430.961 696.202 430.918C696.262 430.874 696.368 430.817 696.413 430.802C696.458 430.788 696.863 430.845 696.984 430.773C697.104 430.7 697.42 430.744 697.54 430.773C697.661 430.802 697.841 430.83 698.021 430.902C698.201 430.975 698.577 431.248 698.712 431.277C698.847 431.306 698.923 431.407 699.073 431.378C699.223 431.349 699.418 431.291 699.539 431.291C699.659 431.291 699.75 431.248 699.734 431.407C699.734 431.407 700.02 431.35 700.034 431.234C700.049 431.118 700.079 431.032 700.079 431.032L700.456 431.133C700.456 431.133 700.816 430.974 700.891 430.887C700.891 430.887 701.117 430.93 701.207 430.916C701.297 430.902 701.493 430.902 701.628 430.887C701.763 430.873 701.823 430.772 701.898 430.744C701.974 430.715 702.214 430.744 702.424 430.773C702.635 430.802 702.965 430.845 703.13 430.916C703.296 430.989 703.581 431.032 703.806 431.017C704.031 431.002 704.166 431.06 704.166 430.988C704.166 430.915 704.166 430.915 704.166 430.915C704.166 430.915 704.181 430.843 704.346 430.872C704.512 430.901 704.782 431.031 704.858 431.059C704.933 431.088 705.023 431.16 705.023 431.16C705.023 431.16 705.113 431.016 705.203 431.044C705.294 431.073 705.308 431.188 705.384 431.174C705.459 431.16 705.488 431.13 705.578 431.174C705.669 431.217 705.714 431.217 705.789 431.231C705.864 431.245 705.939 431.217 706.029 431.245C706.119 431.274 706.36 431.302 706.405 431.317C706.45 431.332 706.736 431.519 706.931 431.49C707.126 431.461 707.502 431.49 707.592 431.39C707.682 431.289 707.758 431.217 707.727 431.001C707.727 431.001 707.907 431.001 708.193 430.972C708.479 430.942 708.615 430.914 708.615 430.914C708.615 430.914 708.66 430.871 708.674 430.799C708.689 430.726 708.99 430.799 709.2 430.914C709.411 431.03 709.47 431.101 709.531 431.073C709.591 431.044 709.591 430.943 709.591 430.943C709.591 430.943 709.847 431.001 709.951 431.073C710.056 431.145 710.207 431.059 710.312 431.073C710.416 431.087 710.567 431.232 710.672 431.189C710.777 431.145 710.747 431.059 710.747 431.059C710.747 431.059 710.838 431.073 711.003 431.131C711.169 431.189 711.153 431.218 711.243 431.161C711.333 431.103 711.273 431.319 711.408 431.333C711.544 431.348 711.603 431.319 711.724 431.348C711.844 431.377 711.844 431.247 711.934 431.29C712.024 431.333 712.16 431.463 712.295 431.449C712.43 431.435 712.595 431.29 712.64 431.262C712.686 431.233 712.851 431.147 712.956 431.205C713.061 431.262 713.196 431.407 713.316 431.45C713.437 431.493 713.437 431.551 713.647 431.551C713.858 431.551 714.068 431.623 714.233 431.623C714.397 431.623 714.924 431.637 714.924 431.637C715.029 431.594 715.104 431.666 715.164 431.637C715.224 431.608 715.375 431.464 715.375 431.464C715.375 431.464 715.24 431.724 715.434 431.839C715.629 431.955 715.66 432.084 715.901 432.069C716.142 432.054 716.322 432.04 716.396 431.969C716.472 431.896 716.562 431.739 716.562 431.739L716.727 431.709C716.727 431.709 716.697 432.055 716.832 432.171C716.967 432.286 716.998 432.445 717.538 432.271C717.538 432.271 717.614 432.43 717.508 432.546C717.508 432.546 717.612 432.603 717.567 432.762C717.567 432.762 717.717 432.891 717.793 432.791C717.868 432.691 717.868 432.691 717.868 432.691L718.154 432.661L718.289 432.518H718.424C718.424 432.518 718.455 432.288 718.365 432.2C718.275 432.114 718.034 432.143 718.034 432.143L717.763 431.854C717.763 431.854 718.139 431.883 718.244 431.868C718.349 431.853 718.484 431.782 718.484 431.782C718.484 431.782 718.709 431.912 718.83 431.912C718.95 431.912 718.965 431.998 719.116 432.012C719.267 432.026 719.386 432.041 719.462 432.041C719.537 432.041 719.701 432.041 719.701 432.041C719.701 432.041 720.047 432.257 720.213 432.3C720.378 432.344 720.648 432.33 720.798 432.2C720.948 432.07 721.023 431.854 721.023 431.854L721.384 431.912L721.474 431.796C721.474 431.796 721.579 431.955 721.699 431.983C721.82 432.012 722.42 432.156 722.481 432.17C722.54 432.184 723.037 432.299 723.172 432.299C723.307 432.299 723.307 432.285 723.428 432.285C723.548 432.285 723.608 432.228 723.653 432.228C723.698 432.228 723.653 432.069 723.653 432.069C723.653 432.069 723.819 432.04 723.909 432.098C723.999 432.156 724.149 432.329 724.254 432.358C724.36 432.387 724.435 432.458 724.435 432.458C724.435 432.458 724.285 432.617 724.375 432.617C724.465 432.617 724.585 432.487 724.585 432.487C724.585 432.487 724.661 432.501 724.991 432.56C725.321 432.618 725.351 432.632 725.441 432.632C725.531 432.632 725.817 432.675 725.817 432.675C725.817 432.675 725.922 433.036 726.163 433.05C726.163 433.05 726.133 433.296 726.374 433.325C726.615 433.354 726.614 433.354 726.614 433.354L727.08 432.979C727.14 433.022 727.095 433.095 727.065 433.138C727.035 433.181 726.779 433.397 726.87 433.455C726.961 433.513 727.171 433.47 727.292 433.383C727.412 433.297 727.578 433.196 727.578 433.196L727.727 433.269C727.727 433.269 727.517 433.514 727.697 433.6C727.877 433.687 727.967 433.701 727.967 433.701C727.967 433.701 728.268 433.96 728.328 434.032C728.387 434.105 728.598 434.162 728.643 434.176C728.688 434.19 728.763 434.205 728.793 434.162C728.823 434.119 728.762 434.018 728.897 433.989C729.033 433.96 729.184 433.946 729.184 433.946C729.184 433.946 729.108 434.35 729.378 434.48C729.649 434.609 729.935 434.653 730.025 434.667C730.115 434.681 730.295 434.623 730.43 434.696C730.565 434.768 730.641 434.811 730.776 434.811C730.911 434.811 731.032 434.797 731.091 434.711C731.151 434.625 731.316 434.336 731.377 434.322C731.438 434.308 731.422 434.581 731.572 434.581C731.722 434.581 731.842 434.438 731.842 434.438C731.842 434.438 731.828 434.625 731.887 434.61C731.947 434.596 732.158 434.394 732.158 434.394C732.158 434.394 732.233 434.495 732.172 434.596C732.113 434.697 731.977 434.783 731.977 434.783C731.977 434.783 731.963 434.956 731.857 435.072C731.752 435.187 731.662 435.288 731.662 435.288L731.783 435.331C731.783 435.331 731.662 435.49 731.768 435.576C731.873 435.663 731.889 435.72 731.889 435.807C731.889 435.893 731.919 436.023 731.903 436.152C731.887 436.282 731.963 436.368 731.948 436.47C731.934 436.571 731.934 436.715 731.813 436.788C731.693 436.86 731.588 436.99 731.708 437.148C731.829 437.307 731.979 437.062 731.979 437.062L732.024 437.264L731.858 437.394C731.858 437.394 731.693 437.567 731.873 437.783C732.053 437.999 732.233 437.97 732.429 437.753L732.579 437.783C732.579 437.783 732.384 437.912 732.474 438.057C732.564 438.201 732.624 438.244 732.654 438.331C732.685 438.418 732.804 438.634 732.88 438.663C732.955 438.692 733 438.75 733 438.75L732.895 438.807C732.895 438.807 732.67 438.562 732.595 438.62C732.519 438.677 732.445 438.779 732.445 438.779L732.595 438.952C732.595 438.952 732.55 439.067 732.49 439.024C732.43 438.981 732.31 438.908 732.265 438.837C732.22 438.766 731.979 438.462 731.889 438.505C731.798 438.549 731.618 438.649 731.633 438.78C731.648 438.91 731.663 439.039 731.663 439.039C731.663 439.039 731.768 439.082 731.723 439.183C731.678 439.283 731.573 439.572 731.467 439.572C731.361 439.572 731.272 439.543 731.227 439.515C731.182 439.485 730.927 439.269 730.927 439.269C730.927 439.269 730.687 439.572 730.581 439.587C730.475 439.602 730.145 439.587 730.086 439.659C730.026 439.732 729.95 439.861 729.95 439.919C729.95 439.976 730.055 440.193 729.995 440.207C729.936 440.221 729.875 440.077 729.83 440.077C729.785 440.077 729.515 440.034 729.515 440.034C729.515 440.034 729.5 439.861 729.349 439.891C729.199 439.92 729.003 439.92 728.854 440.136C728.704 440.352 728.673 440.583 728.553 440.654C728.432 440.727 728.132 440.755 727.967 440.914C727.802 441.073 727.712 441.332 727.636 441.404C727.561 441.477 727.381 441.722 727.441 441.966C727.441 441.966 727.576 442.038 727.531 442.082C727.486 442.125 727.245 442.312 727.216 442.471C727.186 442.629 727.156 442.788 727.247 442.875C727.247 442.875 727.021 442.861 726.976 442.99C726.931 443.12 726.962 443.322 726.946 443.408C726.931 443.495 726.78 443.827 726.706 443.841C726.631 443.855 726.54 443.855 726.481 443.783C726.421 443.711 726.346 443.567 726.225 443.654C726.105 443.74 725.865 443.942 725.865 444.058C725.865 444.173 725.82 444.375 725.865 444.505C725.91 444.635 725.82 444.837 725.82 444.837C725.82 444.837 725.955 444.937 725.834 445.039C725.714 445.139 725.714 445.154 725.579 445.096C725.444 445.039 725.353 445.125 725.308 445.197C725.263 445.268 725.143 445.442 725.038 445.399C724.933 445.355 724.752 445.169 724.557 445.514C724.362 445.86 724.242 445.86 724.242 445.86C724.242 445.86 724.212 445.788 724.107 445.788C724.002 445.788 723.941 445.758 723.867 445.817C723.792 445.874 723.507 446.148 723.417 446.206C723.326 446.263 723.206 446.306 723.13 446.306C723.055 446.306 722.875 446.234 722.754 446.292C722.634 446.349 722.468 446.408 722.333 446.408C722.198 446.408 721.987 446.465 721.942 446.422C721.897 446.379 721.822 446.278 721.717 446.292C721.612 446.306 721.537 446.494 721.462 446.508C721.386 446.522 721.417 446.436 721.267 446.335C721.117 446.235 721.027 446.163 720.891 446.192C720.754 446.221 720.62 446.076 720.5 446.105C720.379 446.134 719.959 446.278 719.808 446.682C719.808 446.682 719.643 446.668 719.598 446.739C719.553 446.812 719.387 446.926 719.387 446.926C719.387 446.926 719.373 446.854 719.297 446.811C719.222 446.768 719.147 446.811 719.072 446.768C718.996 446.724 718.922 446.638 718.877 446.624C718.832 446.61 718.666 446.537 718.531 446.551C718.396 446.566 718.321 446.566 718.186 446.652C718.05 446.738 717.674 446.926 717.615 446.97C717.555 447.013 717.48 447.113 717.299 447.099C717.119 447.085 716.864 447.157 716.773 447.229C716.683 447.301 716.487 447.416 716.428 447.474C716.368 447.531 716.233 447.647 716.233 447.647C716.233 447.647 715.797 447.531 715.752 447.503C715.707 447.475 715.722 447.388 715.647 447.388C715.572 447.388 715.437 447.445 715.361 447.417C715.286 447.388 715.421 447.403 715.437 447.287C715.451 447.172 715.347 447.201 715.451 447.172C715.556 447.142 715.662 447.244 715.662 447.128C715.662 447.013 715.586 447.028 715.437 446.985C715.287 446.942 715.151 446.841 715.091 446.812C715.031 446.783 714.866 446.523 714.686 446.625C714.505 446.725 714.325 446.855 714.28 446.884C714.235 446.913 713.994 447.057 713.994 447.057C713.994 447.057 713.934 447.173 713.799 447.201C713.664 447.229 713.65 447.172 713.604 447.258C713.559 447.345 713.529 447.517 713.484 447.533C713.439 447.547 713.559 447.59 713.439 447.547C713.318 447.503 713.214 447.503 713.124 447.446C713.034 447.389 712.958 447.302 712.913 447.244C712.868 447.187 712.718 447.114 712.718 447.114C712.718 447.114 712.553 447.114 712.508 447.114C712.463 447.114 712.252 447.23 712.252 447.23L712.147 447.1C712.147 447.1 712.207 446.985 712.192 446.927C712.178 446.87 712.178 446.755 712.178 446.755C712.178 446.755 712.208 446.654 712.163 446.639C712.118 446.625 711.938 446.725 711.938 446.725L711.698 446.523C711.698 446.523 711.458 446.264 711.262 446.249C711.067 446.235 710.706 446.192 710.601 446.249C710.496 446.306 710.225 446.523 710.225 446.523C710.225 446.523 709.985 446.408 709.939 446.494C709.894 446.581 710.044 446.724 710.044 446.724C710.044 446.724 710.013 446.782 709.923 446.754C709.833 446.725 709.833 446.724 709.833 446.724L709.713 446.897C709.713 446.897 709.577 447.099 709.532 447.157C709.487 447.214 709.412 447.329 709.412 447.329C709.412 447.329 709.217 447.243 709.111 447.157C709.006 447.07 708.825 446.954 708.825 446.954C708.825 446.954 708.675 446.825 708.63 446.811C708.585 446.797 708.375 446.754 708.375 446.754L708.059 446.724L707.714 446.277C707.714 446.277 707.548 446.177 707.443 446.047C707.339 445.917 707.233 445.831 707.067 445.802C706.902 445.772 706.617 445.902 706.617 445.902C706.617 445.902 706.392 445.672 706.091 445.772C705.79 445.873 704.949 446.234 704.873 446.248C704.798 446.262 704.573 446.191 704.513 446.234C704.453 446.277 704.198 446.378 704.122 446.393C704.047 446.407 703.912 446.349 703.836 446.436C703.761 446.522 703.596 446.638 703.596 446.638H703.476C703.476 446.638 703.416 446.393 703.206 446.379C702.995 446.365 702.905 446.365 702.86 446.379C702.815 446.393 702.725 446.436 702.725 446.436L702.665 446.595C702.665 446.595 702.605 446.566 702.485 446.508C702.364 446.451 702.364 446.451 702.364 446.451C702.364 446.451 702.5 446.321 702.469 446.206C702.439 446.09 702.093 445.99 701.958 446.019C701.823 446.048 701.537 446.005 701.372 446.134C701.207 446.264 700.877 446.509 700.771 446.466C700.665 446.423 700.695 446.279 700.515 446.25C700.335 446.221 699.914 446.106 699.914 446.106C699.914 446.106 699.538 445.89 699.493 445.847C699.448 445.804 699.282 445.688 699.177 445.688C699.073 445.688 698.891 445.702 698.832 445.717C698.772 445.731 698.697 445.717 698.637 445.731C698.577 445.745 698.471 445.761 698.471 445.761L698.412 446.035L698.336 446.151L698.126 445.949C698.126 445.949 698.291 445.992 698.291 445.935C698.291 445.877 698.306 445.589 698.306 445.589L698.471 445.603C698.471 445.603 698.441 445.459 698.322 445.43C698.201 445.401 698.111 445.473 698.111 445.473C698.111 445.473 698.186 445.142 697.9 445.271C697.614 445.401 697.434 445.617 697.299 445.603C697.164 445.589 697.013 445.589 697.013 445.589C697.013 445.589 697.163 445.834 697.088 445.891C697.013 445.949 696.849 445.891 696.849 445.891C696.849 445.891 696.654 446.093 696.849 446.107C697.043 446.121 697.088 446.137 697.18 446.05C697.27 445.964 697.405 445.834 697.405 445.834C697.405 445.834 697.51 445.82 697.495 445.95C697.48 446.079 697.3 446.195 697.194 446.252C697.09 446.309 696.863 446.353 696.789 446.396C696.715 446.439 696.668 446.526 696.503 446.612C696.337 446.698 695.947 446.799 695.872 446.828C695.798 446.857 695.752 446.929 695.602 446.871C695.452 446.814 695.377 446.771 695.256 446.799C695.136 446.827 695.197 446.727 695.136 446.828C695.075 446.93 695.091 447.058 695.046 447.058C695.001 447.058 694.88 447.072 694.88 447.072C694.88 447.072 695.03 446.77 694.911 446.784C694.79 446.798 694.775 446.884 694.671 446.884C694.566 446.884 694.49 446.855 694.34 446.87C694.189 446.885 693.949 446.927 693.949 446.927L693.814 446.553L693.483 446.366L693.333 446.222L693.198 446.279L693.273 446.38L693.093 446.48C693.093 446.48 693.273 446.509 693.408 446.567C693.543 446.624 693.784 446.682 693.724 446.855C693.664 447.028 693.648 446.999 693.438 447.028C693.227 447.057 693.002 447.085 693.032 447.187C693.063 447.287 693.453 447.389 693.453 447.389C693.453 447.389 693.349 447.562 693.288 447.562C693.227 447.562 693.032 447.375 692.822 447.375C692.611 447.375 692.368 447.427 692.368 447.427Z",
	            fill: color }, tooltip, { className: "clickable" })),
	        _react2.default.createElement("path", { d: "M710.5 407.5V428.5", stroke: "#444444", strokeWidth: "0.916283" }),
	        _react2.default.createElement("path", Object.assign({ d: "M705.581 405.789H707.287V402.3H708.57C710.533 402.3 711.931 401.441 711.931 399.503V399.452C711.931 397.528 710.584 396.617 708.532 396.617H705.581V405.789ZM707.287 401.068V397.938H708.532C709.622 397.938 710.263 398.362 710.263 399.452V399.503C710.263 400.517 709.66 401.068 708.532 401.068H707.287ZM713.398 405.789H715.104V402.082H716.195L718.594 405.789H720.441L717.862 401.825C719.004 401.53 719.902 400.799 719.902 399.362V399.311C719.902 397.438 718.491 396.617 716.477 396.617H713.398V405.789ZM715.104 400.863V397.938H716.477C717.567 397.938 718.222 398.298 718.222 399.35V399.401C718.222 400.376 717.619 400.863 716.477 400.863H715.104Z",
	            fill: "#444444" }, labelTooltip, { className: "clickable" })),
	        _react2.default.createElement("rect", Object.assign({ x: "703", y: "393", width: "20", height: "15", fill: "#ffffff", fillOpacity: "0" }, tooltip, { className: "clickable" }))
	    );
	};
	
	exports.default = MAP;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _values = __webpack_require__(490);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var values = _ref.values;
	
	
	    var states = Object.entries(values).map(function (_ref2) {
	        var _ref3 = _slicedToArray(_ref2, 2),
	            state = _ref3[0],
	            data = _ref3[1];
	
	        return [_values.STATE_NAMES[state], data.tradeCount];
	    }).sort(function (a, b) {
	        return ('' + a[0]).localeCompare('' + b[0]);
	    });
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	                'caption',
	                null,
	                'Municpal map based upon the number of MSRB-reported trades from the previous trading day.'
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { scope: 'col' },
	                        'State'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { scope: 'col' },
	                        'Trade Count'
	                    )
	                ),
	                states.map(function (_ref4, i) {
	                    var _ref5 = _slicedToArray(_ref4, 2),
	                        state = _ref5[0],
	                        cnt = _ref5[1];
	
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            state
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            cnt
	                        )
	                    );
	                })
	            )
	        )
	    );
	};

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.onMouseOutFn = exports.onMouseOverFn = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _loader = __webpack_require__(954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var showState = (0, _twd.bufferedFn)(function (el) {
	    if (!el) return;
	    (0, _twd.publish)('show_flyout', {
	        el: el,
	        showIcon: false,
	        html: _react2.default.createElement(_loader.Loader, { state: el.dataset.state }),
	        contentStyle: { maxWidth: '600px', width: 'fit-content' },
	        popperStyles: {
	            maxWidth: Math.min(_twd.mediaQueries.width() - 40, 600) + 'px'
	        }
	    });
	}, 100); /* eslint-disable no-use-before-define */
	
	
	var hideState = (0, _twd.bufferedFn)(function (event) {
	    var ce = (0, _twd.$)(document.elementFromPoint(event.clientX, event.clientY));
	    var b = ce.data().tooltipId || ce.is('.flyout *');
	    if (b) return;
	
	    (0, _twd.publish)('hide_flyout');
	}, 200);
	
	var onMouseOverFn = exports.onMouseOverFn = function onMouseOverFn(event) {
	    var te = (0, _twd.$)(event.target);
	    var id = te.data().tooltipId;
	    var el = (0, _twd.$)('#' + id);
	    if (!el.length === 0) return;
	
	    showState(el['0']);
	};
	
	var onMouseOutFn = exports.onMouseOutFn = function onMouseOutFn(event) {
	
	    var te = (0, _twd.$)(event.target);
	    var id = te.data().tooltipId;
	    var el = (0, _twd.$)('#' + id);
	    if (!el.length === 0) return;
	
	    event.persist();
	    hideState(event);
	};

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Detail = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n    dt, dd {\n        white-space: nowrap;\n        margin: 0;\n        font-weight:400;\n        line-height: 1.4;\n    }\n    dt {\n        padding: 6px;\n        padding-top: 0px;\n    }\n    dd {\n        padding: 6px;\n        padding-top: 0px;\n        font-weight:500;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    div {\n        display: grid;\n        grid-template-columns: 1fr;\n    }\n'], ['\n    dt, dd {\n        white-space: nowrap;\n        margin: 0;\n        font-weight:400;\n        line-height: 1.4;\n    }\n    dt {\n        padding: 6px;\n        padding-top: 0px;\n    }\n    dd {\n        padding: 6px;\n        padding-top: 0px;\n        font-weight:500;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    div {\n        display: grid;\n        grid-template-columns: 1fr;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _statesMap = __webpack_require__(470);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var offerCss = (0, _core.css)(_templateObject);
	
	var Detail = exports.Detail = function Detail(_ref) {
	    var state = _ref.state,
	        tradeCount = _ref.tradeCount,
	        cusipCount = _ref.cusipCount,
	        revenueCount = _ref.revenueCount,
	        generalObligationCount = _ref.generalObligationCount,
	        avgYTM = _ref.avgYTM,
	        avgYTW = _ref.avgYTW;
	
	    var stateName = _twd.STATE_NAMES[state];
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        btnEl = _React$useState2[0],
	        setBtnEl = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        if (!btnEl) return;
	
	        setTimeout(function () {
	            btnEl.focus();
	        }, 300);
	    }, [btnEl]);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)(
	                    'button',
	                    {
	                        ref: setBtnEl,
	                        className: 'close material-icons',
	                        'aria-label': 'Close',
	                        onClick: function onClick() {
	                            (0, _twd.publish)('hide_flyout');
	                        }
	                    },
	                    'close'
	                ),
	                (0, _core.jsx)(
	                    'h3',
	                    { className: 'text-bold', style: { display: 'inline' } },
	                    stateName
	                ),
	                '\xA0',
	                formatTradeCount(tradeCount)
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)(
	                'dl',
	                { css: offerCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Unique CUSIPs'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.format.count(cusipCount, '-')
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)(
	                'dl',
	                { css: offerCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6', style: { paddingRight: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'General Obligation'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.format.count(generalObligationCount, _twd.format.empty()),
	                        ' Offerings'
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6', style: { paddingLeft: 0 } },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Revenue'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.format.count(revenueCount, _twd.format.empty()),
	                        ' Offerings'
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12 text-right' },
	                (0, _core.jsx)(
	                    'button',
	                    { className: 'btn-link',
	                        'data-name': 'municipal-map-offerings-link',
	                        onClick: function onClick() {
	                            (0, _twd.show)("offerings", {
	                                searchParams: {
	                                    holdInvType: ['M'],
	                                    holdState: [state],
	                                    persistToPreviousSearches: false,
	                                    offeringType: ['ask-side']
	                                },
	                                _ts: Date.now(),
	                                from: 'municipals/municipal-map'
	                            });
	                        } },
	                    'View State Offerings'
	                )
	            )
	        )
	    );
	};
	
	var formatTradeCount = function formatTradeCount(tradeCount) {
	    var color = (0, _statesMap.getColor)(tradeCount);
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'svg',
	            { height: '10', width: '10' },
	            (0, _core.jsx)('circle', { cx: '5', cy: '5', r: '5', stroke: color, strokeWidth: '1', fill: color })
	        ),
	        '\xA0',
	        _twd.format.count(tradeCount, _twd.format.empty()),
	        ' Trades'
	    );
	};

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getTooltipData = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var lastStates = {};
	var lastAjaxAbort;
	var getTooltipData = exports.getTooltipData = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	        var state = _ref.state;
	
	        var last, _ref3, data, abort, info;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	
	                        if (lastAjaxAbort) {
	                            lastAjaxAbort();
	                            lastAjaxAbort = null;
	                        }
	
	                        last = lastStates[state];
	
	                        if (!(last && Date.now() - last.ts < 60000)) {
	                            _context.next = 5;
	                            break;
	                        }
	
	                        return _context.abrupt('return', Object.assign({}, last.data));
	
	                    case 5:
	
	                        delete lastStates[state];
	
	                        _context.next = 8;
	                        return (0, _twd.ajax)({
	                            url: '/esb/retailservice/marketSnapshotService/getMuniMapToolTipData',
	                            method: 'POST',
	                            params: {
	                                marketSnapshotsType: 'MUNI_MAP_DATA',
	                                state: state
	                            }
	                        });
	
	                    case 8:
	                        _ref3 = _context.sent;
	                        data = _ref3.data;
	                        abort = _ref3.abort;
	
	
	                        lastAjaxAbort = abort;
	                        _context.next = 14;
	                        return data;
	
	                    case 14:
	                        _context.t2 = _context.sent;
	
	                        if (_context.t2) {
	                            _context.next = 17;
	                            break;
	                        }
	
	                        _context.t2 = {};
	
	                    case 17:
	                        _context.t1 = _context.t2.states;
	
	                        if (_context.t1) {
	                            _context.next = 20;
	                            break;
	                        }
	
	                        _context.t1 = {};
	
	                    case 20:
	                        _context.t3 = state;
	                        _context.t0 = _context.t1[_context.t3];
	
	                        if (_context.t0) {
	                            _context.next = 24;
	                            break;
	                        }
	
	                        _context.t0 = { state: state };
	
	                    case 24:
	                        info = _context.t0;
	
	                        lastAjaxAbort = null;
	
	                        lastStates[state] = { ts: Date.now(), data: info };
	
	                        return _context.abrupt('return', info);
	
	                    case 30:
	                        _context.prev = 30;
	                        _context.t4 = _context['catch'](0);
	                        return _context.abrupt('return', undefined);
	
	                    case 33:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[0, 30]]);
	    }));
	
	    return function getTooltipData(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Loader = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _getTooltipData = __webpack_require__(953);
	
	var _detail = __webpack_require__(952);
	
	var _loading = __webpack_require__(955);
	
	var _notFound = __webpack_require__(956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Loader = exports.Loader = function Loader(_ref) {
	    var state = _ref.state;
	
	    var _React$useState = _react2.default.useState('loading'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(null),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        tooltipData = _React$useState4[0],
	        setTooltipData = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        var cancelled = false;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var data_;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return (0, _getTooltipData.getTooltipData)({ state: state });
	
	                        case 2:
	                            data_ = _context.sent;
	
	                            if (!cancelled) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 5:
	                            if (!(data_ === undefined)) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            setStatus('failed');
	                            return _context.abrupt('return');
	
	                        case 8:
	                            if (data_) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            setStatus('not-found');
	                            return _context.abrupt('return');
	
	                        case 11:
	
	                            setStatus('found');
	                            setTooltipData(data_);
	
	                        case 13:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }))();
	
	        return function () {
	            cancelled = true;
	        };
	    }, []);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            status === 'loading' ? _react2.default.createElement(_loading.Loading, null) : status === 'not-found' ? _react2.default.createElement(_notFound.NotFound, { stateName: _twd.STATE_NAMES[state] }) : status === 'found' ? _react2.default.createElement(_detail.Detail, tooltipData) : null
	        )
	    );
	};

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Loading = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Loading = exports.Loading = function Loading() {
	    return _react2.default.createElement(
	        "div",
	        { "data-name": "loading-spinner", className: "spinner", style: { width: '45px' }, "aria-busy": "true" },
	        _react2.default.createElement(
	            "svg",
	            { className: "circular", viewBox: "25 25 50 50" },
	            _react2.default.createElement("circle", { className: "background", cx: "50", cy: "50", fill: "none", r: "20", strokeMiterlimit: "10", strokeWidth: "2" }),
	            _react2.default.createElement("circle", { className: "path", cx: "50", cy: "50", fill: "none", r: "20", strokeMiterlimit: "10", strokeWidth: "2" })
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NotFound = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFound = exports.NotFound = function NotFound(_ref) {
	    var stateName = _ref.stateName;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-12" },
	                _react2.default.createElement(
	                    "h3",
	                    { className: "text-bold", style: { display: 'inline' } },
	                    stateName
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { "data-name": "loading-fail", className: "row" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-12 text-center" },
	                _react2.default.createElement("i", { className: "et-icon et-alert et-icon-md", "aria-hidden": "true" }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "small-header" },
	                    "No trades found."
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('municipals.map', {
	    values: {}
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.values || '{}'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        values = _React$useState2[0],
	        setValues_ = _React$useState2[1];
	
	    var setValues = _react2.default.useCallback(function (a) {
	        state.set({ values: a });
	        setValues_(a);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(''),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        error = _React$useState6[0],
	        setError = _React$useState6[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        ;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, abort, _ref3, states;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setValues({});
	                            setError('');
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.prev = 3;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 7;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/marketSnapshotService/getMuniMapData',
	                                method: 'POST',
	                                params: {
	                                    marketSnapshotsType: 'MUNI_MAP_DATA'
	                                }
	                            });
	
	                        case 7:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 13;
	                            return data;
	
	                        case 13:
	                            _ref3 = _context.sent;
	                            states = _ref3.states;
	
	                            lastAbort.current = null;
	
	                            setValues(states);
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 23;
	                            break;
	
	                        case 20:
	                            _context.prev = 20;
	                            _context.t0 = _context['catch'](3);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 23:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[3, 20]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) {
	                lastAbort.current();
	            }
	        };
	    }, []);
	
	    return {
	        values: values,
	        error: error,
	        status: status
	    };
	};

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _customSearch = __webpack_require__(960);
	
	var _customSearch2 = _interopRequireDefault(_customSearch);
	
	var _holdingSearch = __webpack_require__(963);
	
	var _holdingSearch2 = _interopRequireDefault(_holdingSearch);
	
	var _useMarketNews2 = __webpack_require__(139);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        isModal = _useMarketNews.isModal,
	        tab = _useMarketNews.tab,
	        setTab = _useMarketNews.setTab;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'municipals-market-news-nav-tabs',
	                className: 'nav-tabs' },
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    { className: tab === 'CUSTOM' ? 'active' : '' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'municipals-market-news-custom-search-nav-tab',
	                            onClick: function onClick() {
	                                return setTab('CUSTOM');
	                            } },
	                        'Custom Search'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { className: tab === 'HOLDING' ? 'active' : '' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'municipals-market-news-holding-search-nav-tab',
	                            onClick: function onClick() {
	                                return setTab('HOLDING');
	                            } },
	                        'Holdings Search'
	                    )
	                )
	            )
	        ),
	        tab === 'CUSTOM' && _react2.default.createElement(_customSearch2.default, { isModal: isModal }),
	        tab === 'HOLDING' && _react2.default.createElement(_holdingSearch2.default, null)
	    );
	};

/***/ },
/* 959 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var Counties = [{
	  "fip": 1001,
	  "county_name": "Autauga",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1003,
	  "county_name": "Baldwin",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1005,
	  "county_name": "Barbour",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1007,
	  "county_name": "Bibb",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1009,
	  "county_name": "Blount",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1011,
	  "county_name": "Bullock",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1013,
	  "county_name": "Butler",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1015,
	  "county_name": "Calhoun",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1017,
	  "county_name": "Chambers",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1019,
	  "county_name": "Cherokee",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1021,
	  "county_name": "Chilton",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1023,
	  "county_name": "Choctaw",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1025,
	  "county_name": "Clarke",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1027,
	  "county_name": "Clay",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1029,
	  "county_name": "Cleburne",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1031,
	  "county_name": "Coffee",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1033,
	  "county_name": "Colbert",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1035,
	  "county_name": "Conecuh",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1037,
	  "county_name": "Coosa",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1039,
	  "county_name": "Covington",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1041,
	  "county_name": "Crenshaw",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1043,
	  "county_name": "Cullman",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1045,
	  "county_name": "Dale",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1047,
	  "county_name": "Dallas",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1049,
	  "county_name": "DeKalb",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1051,
	  "county_name": "Elmore",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1053,
	  "county_name": "Escambia",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1055,
	  "county_name": "Etowah",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1057,
	  "county_name": "Fayette",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1059,
	  "county_name": "Franklin",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1061,
	  "county_name": "Geneva",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1063,
	  "county_name": "Greene",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1065,
	  "county_name": "Hale",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1067,
	  "county_name": "Henry",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1069,
	  "county_name": "Houston",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1071,
	  "county_name": "Jackson",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1073,
	  "county_name": "Jefferson",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1075,
	  "county_name": "Lamar",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1077,
	  "county_name": "Lauderdale",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1079,
	  "county_name": "Lawrence",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1081,
	  "county_name": "Lee",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1083,
	  "county_name": "Limestone",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1085,
	  "county_name": "Lowndes",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1087,
	  "county_name": "Macon",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1089,
	  "county_name": "Madison",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1091,
	  "county_name": "Marengo",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1093,
	  "county_name": "Marion",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1095,
	  "county_name": "Marshall",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1097,
	  "county_name": "Mobile",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1099,
	  "county_name": "Monroe",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1101,
	  "county_name": "Montgomery",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1103,
	  "county_name": "Morgan",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1105,
	  "county_name": "Perry",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1107,
	  "county_name": "Pickens",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1109,
	  "county_name": "Pike",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1111,
	  "county_name": "Randolph",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1113,
	  "county_name": "Russell",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1115,
	  "county_name": "St. Clair",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1117,
	  "county_name": "Shelby",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1119,
	  "county_name": "Sumter",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1121,
	  "county_name": "Talladega",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1123,
	  "county_name": "Tallapoosa",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1125,
	  "county_name": "Tuscaloosa",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1127,
	  "county_name": "Walker",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1129,
	  "county_name": "Washington",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1131,
	  "county_name": "Wilcox",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 1133,
	  "county_name": "Winston",
	  "state": "AL",
	  "state_name": "Alabama"
	}, {
	  "fip": 2013,
	  "county_name": "Aleutians East Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2016,
	  "county_name": "Aleutians West Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2020,
	  "county_name": "Anchorage Municipality",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2050,
	  "county_name": "Bethel Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2060,
	  "county_name": "Bristol Bay Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2068,
	  "county_name": "Denali Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2070,
	  "county_name": "Dillingham Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2090,
	  "county_name": "Fairbanks North Star Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2100,
	  "county_name": "Haines Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2105,
	  "county_name": "Hoonah-Angoon Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2110,
	  "county_name": "Juneau City and Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2122,
	  "county_name": "Kenai Peninsula Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2130,
	  "county_name": "Ketchikan Gateway Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2150,
	  "county_name": "Kodiak Island Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2158,
	  "county_name": "Kusilvak Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2164,
	  "county_name": "Lake and Peninsula Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2170,
	  "county_name": "Matanuska-Susitna Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2180,
	  "county_name": "Nome Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2185,
	  "county_name": "North Slope Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2188,
	  "county_name": "Northwest Arctic Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2195,
	  "county_name": "Petersburg Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2198,
	  "county_name": "Prince of Wales-Hyder Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2220,
	  "county_name": "Sitka City and Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2230,
	  "county_name": "Skagway Municipality",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2240,
	  "county_name": "Southeast Fairbanks Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2261,
	  "county_name": "Valdez-Cordova Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2270,
	  "county_name": "Wade Hampton Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2275,
	  "county_name": "Wrangell City and Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2282,
	  "county_name": "Yakutat City and Borough",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 2290,
	  "county_name": "Yukon-Koyukuk Census Area",
	  "state": "AK",
	  "state_name": "Alaska"
	}, {
	  "fip": 4001,
	  "county_name": "Apache",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4003,
	  "county_name": "Cochise",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4005,
	  "county_name": "Coconino",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4007,
	  "county_name": "Gila",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4009,
	  "county_name": "Graham",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4011,
	  "county_name": "Greenlee",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4012,
	  "county_name": "La Paz",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4013,
	  "county_name": "Maricopa",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4015,
	  "county_name": "Mohave",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4017,
	  "county_name": "Navajo",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4019,
	  "county_name": "Pima",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4021,
	  "county_name": "Pinal",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4023,
	  "county_name": "Santa Cruz",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4025,
	  "county_name": "Yavapai",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 4027,
	  "county_name": "Yuma",
	  "state": "AZ",
	  "state_name": "Arizona"
	}, {
	  "fip": 5001,
	  "county_name": "Arkansas",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5003,
	  "county_name": "Ashley",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5005,
	  "county_name": "Baxter",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5007,
	  "county_name": "Benton",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5009,
	  "county_name": "Boone",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5011,
	  "county_name": "Bradley",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5013,
	  "county_name": "Calhoun",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5015,
	  "county_name": "Carroll",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5017,
	  "county_name": "Chicot",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5019,
	  "county_name": "Clark",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5021,
	  "county_name": "Clay",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5023,
	  "county_name": "Cleburne",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5025,
	  "county_name": "Cleveland",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5027,
	  "county_name": "Columbia",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5029,
	  "county_name": "Conway",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5031,
	  "county_name": "Craighead",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5033,
	  "county_name": "Crawford",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5035,
	  "county_name": "Crittenden",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5037,
	  "county_name": "Cross",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5039,
	  "county_name": "Dallas",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5041,
	  "county_name": "Desha",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5043,
	  "county_name": "Drew",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5045,
	  "county_name": "Faulkner",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5047,
	  "county_name": "Franklin",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5049,
	  "county_name": "Fulton",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5051,
	  "county_name": "Garland",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5053,
	  "county_name": "Grant",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5055,
	  "county_name": "Greene",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5057,
	  "county_name": "Hempstead",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5059,
	  "county_name": "Hot Spring",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5061,
	  "county_name": "Howard",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5063,
	  "county_name": "Independence",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5065,
	  "county_name": "Izard",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5067,
	  "county_name": "Jackson",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5069,
	  "county_name": "Jefferson",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5071,
	  "county_name": "Johnson",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5073,
	  "county_name": "Lafayette",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5075,
	  "county_name": "Lawrence",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5077,
	  "county_name": "Lee",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5079,
	  "county_name": "Lincoln",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5081,
	  "county_name": "Little River",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5083,
	  "county_name": "Logan",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5085,
	  "county_name": "Lonoke",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5087,
	  "county_name": "Madison",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5089,
	  "county_name": "Marion",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5091,
	  "county_name": "Miller",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5093,
	  "county_name": "Mississippi",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5095,
	  "county_name": "Monroe",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5097,
	  "county_name": "Montgomery",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5099,
	  "county_name": "Nevada",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5101,
	  "county_name": "Newton",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5103,
	  "county_name": "Ouachita",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5105,
	  "county_name": "Perry",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5107,
	  "county_name": "Phillips",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5109,
	  "county_name": "Pike",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5111,
	  "county_name": "Poinsett",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5113,
	  "county_name": "Polk",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5115,
	  "county_name": "Pope",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5117,
	  "county_name": "Prairie",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5119,
	  "county_name": "Pulaski",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5121,
	  "county_name": "Randolph",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5123,
	  "county_name": "St. Francis",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5125,
	  "county_name": "Saline",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5127,
	  "county_name": "Scott",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5129,
	  "county_name": "Searcy",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5131,
	  "county_name": "Sebastian",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5133,
	  "county_name": "Sevier",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5135,
	  "county_name": "Sharp",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5137,
	  "county_name": "Stone",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5139,
	  "county_name": "Union",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5141,
	  "county_name": "Van Buren",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5143,
	  "county_name": "Washington",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5145,
	  "county_name": "White",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5147,
	  "county_name": "Woodruff",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 5149,
	  "county_name": "Yell",
	  "state": "AR",
	  "state_name": "Arkansas"
	}, {
	  "fip": 6001,
	  "county_name": "Alameda",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6003,
	  "county_name": "Alpine",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6005,
	  "county_name": "Amador",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6007,
	  "county_name": "Butte",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6009,
	  "county_name": "Calaveras",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6011,
	  "county_name": "Colusa",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6013,
	  "county_name": "Contra Costa",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6015,
	  "county_name": "Del Norte",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6017,
	  "county_name": "El Dorado",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6019,
	  "county_name": "Fresno",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6021,
	  "county_name": "Glenn",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6023,
	  "county_name": "Humboldt",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6025,
	  "county_name": "Imperial",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6027,
	  "county_name": "Inyo",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6029,
	  "county_name": "Kern",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6031,
	  "county_name": "Kings",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6033,
	  "county_name": "Lake",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6035,
	  "county_name": "Lassen",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6037,
	  "county_name": "Los Angeles",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6039,
	  "county_name": "Madera",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6041,
	  "county_name": "Marin",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6043,
	  "county_name": "Mariposa",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6045,
	  "county_name": "Mendocino",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6047,
	  "county_name": "Merced",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6049,
	  "county_name": "Modoc",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6051,
	  "county_name": "Mono",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6053,
	  "county_name": "Monterey",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6055,
	  "county_name": "Napa",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6057,
	  "county_name": "Nevada",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6059,
	  "county_name": "Orange",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6061,
	  "county_name": "Placer",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6063,
	  "county_name": "Plumas",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6065,
	  "county_name": "Riverside",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6067,
	  "county_name": "Sacramento",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6069,
	  "county_name": "San Benito",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6071,
	  "county_name": "San Bernardino",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6073,
	  "county_name": "San Diego",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6075,
	  "county_name": "San Francisco",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6077,
	  "county_name": "San Joaquin",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6079,
	  "county_name": "San Luis Obispo",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6081,
	  "county_name": "San Mateo",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6083,
	  "county_name": "Santa Barbara",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6085,
	  "county_name": "Santa Clara",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6087,
	  "county_name": "Santa Cruz",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6089,
	  "county_name": "Shasta",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6091,
	  "county_name": "Sierra",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6093,
	  "county_name": "Siskiyou",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6095,
	  "county_name": "Solano",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6097,
	  "county_name": "Sonoma",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6099,
	  "county_name": "Stanislaus",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6101,
	  "county_name": "Sutter",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6103,
	  "county_name": "Tehama",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6105,
	  "county_name": "Trinity",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6107,
	  "county_name": "Tulare",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6109,
	  "county_name": "Tuolumne",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6111,
	  "county_name": "Ventura",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6113,
	  "county_name": "Yolo",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 6115,
	  "county_name": "Yuba",
	  "state": "CA",
	  "state_name": "California"
	}, {
	  "fip": 8001,
	  "county_name": "Adams",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8003,
	  "county_name": "Alamosa",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8005,
	  "county_name": "Arapahoe",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8007,
	  "county_name": "Archuleta",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8009,
	  "county_name": "Baca",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8011,
	  "county_name": "Bent",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8013,
	  "county_name": "Boulder",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8014,
	  "county_name": "Broomfield",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8015,
	  "county_name": "Chaffee",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8017,
	  "county_name": "Cheyenne",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8019,
	  "county_name": "Clear Creek",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8021,
	  "county_name": "Conejos",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8023,
	  "county_name": "Costilla",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8025,
	  "county_name": "Crowley",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8027,
	  "county_name": "Custer",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8029,
	  "county_name": "Delta",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8031,
	  "county_name": "Denver",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8033,
	  "county_name": "Dolores",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8035,
	  "county_name": "Douglas",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8037,
	  "county_name": "Eagle",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8039,
	  "county_name": "Elbert",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8041,
	  "county_name": "El Paso",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8043,
	  "county_name": "Fremont",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8045,
	  "county_name": "Garfield",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8047,
	  "county_name": "Gilpin",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8049,
	  "county_name": "Grand",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8051,
	  "county_name": "Gunnison",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8053,
	  "county_name": "Hinsdale",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8055,
	  "county_name": "Huerfano",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8057,
	  "county_name": "Jackson",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8059,
	  "county_name": "Jefferson",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8061,
	  "county_name": "Kiowa",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8063,
	  "county_name": "Kit Carson",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8065,
	  "county_name": "Lake",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8067,
	  "county_name": "La Plata",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8069,
	  "county_name": "Larimer",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8071,
	  "county_name": "Las Animas",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8073,
	  "county_name": "Lincoln",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8075,
	  "county_name": "Logan",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8077,
	  "county_name": "Mesa",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8079,
	  "county_name": "Mineral",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8081,
	  "county_name": "Moffat",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8083,
	  "county_name": "Montezuma",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8085,
	  "county_name": "Montrose",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8087,
	  "county_name": "Morgan",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8089,
	  "county_name": "Otero",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8091,
	  "county_name": "Ouray",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8093,
	  "county_name": "Park",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8095,
	  "county_name": "Phillips",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8097,
	  "county_name": "Pitkin",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8099,
	  "county_name": "Prowers",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8101,
	  "county_name": "Pueblo",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8103,
	  "county_name": "Rio Blanco",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8105,
	  "county_name": "Rio Grande",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8107,
	  "county_name": "Routt",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8109,
	  "county_name": "Saguache",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8111,
	  "county_name": "San Juan",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8113,
	  "county_name": "San Miguel",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8115,
	  "county_name": "Sedgwick",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8117,
	  "county_name": "Summit",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8119,
	  "county_name": "Teller",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8121,
	  "county_name": "Washington",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8123,
	  "county_name": "Weld",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 8125,
	  "county_name": "Yuma",
	  "state": "CO",
	  "state_name": "Colorado"
	}, {
	  "fip": 9001,
	  "county_name": "Fairfield",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 9003,
	  "county_name": "Hartford",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 9005,
	  "county_name": "Litchfield",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 9007,
	  "county_name": "Middlesex",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 9009,
	  "county_name": "New Haven",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 9011,
	  "county_name": "New London",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 9013,
	  "county_name": "Tolland",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 9015,
	  "county_name": "Windham",
	  "state": "CT",
	  "state_name": "Connecticut"
	}, {
	  "fip": 10001,
	  "county_name": "Kent",
	  "state": "DE",
	  "state_name": "Delaware"
	}, {
	  "fip": 10003,
	  "county_name": "New Castle",
	  "state": "DE",
	  "state_name": "Delaware"
	}, {
	  "fip": 10005,
	  "county_name": "Sussex",
	  "state": "DE",
	  "state_name": "Delaware"
	}, {
	  "fip": 11001,
	  "county_name": "District of Columbia",
	  "state": "DC",
	  "state_name": "District of Columbia"
	}, {
	  "fip": 12001,
	  "county_name": "Alachua",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12003,
	  "county_name": "Baker",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12005,
	  "county_name": "Bay",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12007,
	  "county_name": "Bradford",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12009,
	  "county_name": "Brevard",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12011,
	  "county_name": "Broward",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12013,
	  "county_name": "Calhoun",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12015,
	  "county_name": "Charlotte",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12017,
	  "county_name": "Citrus",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12019,
	  "county_name": "Clay",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12021,
	  "county_name": "Collier",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12023,
	  "county_name": "Columbia",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12027,
	  "county_name": "DeSoto",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12029,
	  "county_name": "Dixie",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12031,
	  "county_name": "Duval",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12033,
	  "county_name": "Escambia",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12035,
	  "county_name": "Flagler",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12037,
	  "county_name": "Franklin",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12039,
	  "county_name": "Gadsden",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12041,
	  "county_name": "Gilchrist",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12043,
	  "county_name": "Glades",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12045,
	  "county_name": "Gulf",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12047,
	  "county_name": "Hamilton",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12049,
	  "county_name": "Hardee",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12051,
	  "county_name": "Hendry",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12053,
	  "county_name": "Hernando",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12055,
	  "county_name": "Highlands",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12057,
	  "county_name": "Hillsborough",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12059,
	  "county_name": "Holmes",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12061,
	  "county_name": "Indian River",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12063,
	  "county_name": "Jackson",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12065,
	  "county_name": "Jefferson",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12067,
	  "county_name": "Lafayette",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12069,
	  "county_name": "Lake",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12071,
	  "county_name": "Lee",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12073,
	  "county_name": "Leon",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12075,
	  "county_name": "Levy",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12077,
	  "county_name": "Liberty",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12079,
	  "county_name": "Madison",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12081,
	  "county_name": "Manatee",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12083,
	  "county_name": "Marion",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12085,
	  "county_name": "Martin",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12086,
	  "county_name": "Miami-Dade",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12087,
	  "county_name": "Monroe",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12089,
	  "county_name": "Nassau",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12091,
	  "county_name": "Okaloosa",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12093,
	  "county_name": "Okeechobee",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12095,
	  "county_name": "Orange",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12097,
	  "county_name": "Osceola",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12099,
	  "county_name": "Palm Beach",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12101,
	  "county_name": "Pasco",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12103,
	  "county_name": "Pinellas",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12105,
	  "county_name": "Polk",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12107,
	  "county_name": "Putnam",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12109,
	  "county_name": "St. Johns",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12111,
	  "county_name": "St. Lucie",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12113,
	  "county_name": "Santa Rosa",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12115,
	  "county_name": "Sarasota",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12117,
	  "county_name": "Seminole",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12119,
	  "county_name": "Sumter",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12121,
	  "county_name": "Suwannee",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12123,
	  "county_name": "Taylor",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12125,
	  "county_name": "Union",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12127,
	  "county_name": "Volusia",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12129,
	  "county_name": "Wakulla",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12131,
	  "county_name": "Walton",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 12133,
	  "county_name": "Washington",
	  "state": "FL",
	  "state_name": "Florida"
	}, {
	  "fip": 13001,
	  "county_name": "Appling",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13003,
	  "county_name": "Atkinson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13005,
	  "county_name": "Bacon",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13007,
	  "county_name": "Baker",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13009,
	  "county_name": "Baldwin",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13011,
	  "county_name": "Banks",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13013,
	  "county_name": "Barrow",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13015,
	  "county_name": "Bartow",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13017,
	  "county_name": "Ben Hill",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13019,
	  "county_name": "Berrien",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13021,
	  "county_name": "Bibb",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13023,
	  "county_name": "Bleckley",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13025,
	  "county_name": "Brantley",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13027,
	  "county_name": "Brooks",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13029,
	  "county_name": "Bryan",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13031,
	  "county_name": "Bulloch",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13033,
	  "county_name": "Burke",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13035,
	  "county_name": "Butts",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13037,
	  "county_name": "Calhoun",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13039,
	  "county_name": "Camden",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13043,
	  "county_name": "Candler",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13045,
	  "county_name": "Carroll",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13047,
	  "county_name": "Catoosa",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13049,
	  "county_name": "Charlton",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13051,
	  "county_name": "Chatham",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13053,
	  "county_name": "Chattahoochee",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13055,
	  "county_name": "Chattooga",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13057,
	  "county_name": "Cherokee",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13059,
	  "county_name": "Clarke",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13061,
	  "county_name": "Clay",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13063,
	  "county_name": "Clayton",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13065,
	  "county_name": "Clinch",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13067,
	  "county_name": "Cobb",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13069,
	  "county_name": "Coffee",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13071,
	  "county_name": "Colquitt",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13073,
	  "county_name": "Columbia",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13075,
	  "county_name": "Cook",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13077,
	  "county_name": "Coweta",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13079,
	  "county_name": "Crawford",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13081,
	  "county_name": "Crisp",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13083,
	  "county_name": "Dade",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13085,
	  "county_name": "Dawson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13087,
	  "county_name": "Decatur",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13089,
	  "county_name": "DeKalb",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13091,
	  "county_name": "Dodge",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13093,
	  "county_name": "Dooly",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13095,
	  "county_name": "Dougherty",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13097,
	  "county_name": "Douglas",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13099,
	  "county_name": "Early",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13101,
	  "county_name": "Echols",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13103,
	  "county_name": "Effingham",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13105,
	  "county_name": "Elbert",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13107,
	  "county_name": "Emanuel",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13109,
	  "county_name": "Evans",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13111,
	  "county_name": "Fannin",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13113,
	  "county_name": "Fayette",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13115,
	  "county_name": "Floyd",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13117,
	  "county_name": "Forsyth",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13119,
	  "county_name": "Franklin",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13121,
	  "county_name": "Fulton",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13123,
	  "county_name": "Gilmer",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13125,
	  "county_name": "Glascock",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13127,
	  "county_name": "Glynn",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13129,
	  "county_name": "Gordon",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13131,
	  "county_name": "Grady",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13133,
	  "county_name": "Greene",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13135,
	  "county_name": "Gwinnett",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13137,
	  "county_name": "Habersham",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13139,
	  "county_name": "Hall",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13141,
	  "county_name": "Hancock",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13143,
	  "county_name": "Haralson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13145,
	  "county_name": "Harris",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13147,
	  "county_name": "Hart",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13149,
	  "county_name": "Heard",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13151,
	  "county_name": "Henry",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13153,
	  "county_name": "Houston",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13155,
	  "county_name": "Irwin",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13157,
	  "county_name": "Jackson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13159,
	  "county_name": "Jasper",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13161,
	  "county_name": "Jeff Davis",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13163,
	  "county_name": "Jefferson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13165,
	  "county_name": "Jenkins",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13167,
	  "county_name": "Johnson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13169,
	  "county_name": "Jones",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13171,
	  "county_name": "Lamar",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13173,
	  "county_name": "Lanier",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13175,
	  "county_name": "Laurens",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13177,
	  "county_name": "Lee",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13179,
	  "county_name": "Liberty",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13181,
	  "county_name": "Lincoln",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13183,
	  "county_name": "Long",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13185,
	  "county_name": "Lowndes",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13187,
	  "county_name": "Lumpkin",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13189,
	  "county_name": "McDuffie",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13191,
	  "county_name": "McIntosh",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13193,
	  "county_name": "Macon",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13195,
	  "county_name": "Madison",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13197,
	  "county_name": "Marion",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13199,
	  "county_name": "Meriwether",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13201,
	  "county_name": "Miller",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13205,
	  "county_name": "Mitchell",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13207,
	  "county_name": "Monroe",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13209,
	  "county_name": "Montgomery",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13211,
	  "county_name": "Morgan",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13213,
	  "county_name": "Murray",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13215,
	  "county_name": "Muscogee",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13217,
	  "county_name": "Newton",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13219,
	  "county_name": "Oconee",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13221,
	  "county_name": "Oglethorpe",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13223,
	  "county_name": "Paulding",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13225,
	  "county_name": "Peach",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13227,
	  "county_name": "Pickens",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13229,
	  "county_name": "Pierce",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13231,
	  "county_name": "Pike",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13233,
	  "county_name": "Polk",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13235,
	  "county_name": "Pulaski",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13237,
	  "county_name": "Putnam",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13239,
	  "county_name": "Quitman",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13241,
	  "county_name": "Rabun",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13243,
	  "county_name": "Randolph",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13245,
	  "county_name": "Richmond",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13247,
	  "county_name": "Rockdale",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13249,
	  "county_name": "Schley",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13251,
	  "county_name": "Screven",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13253,
	  "county_name": "Seminole",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13255,
	  "county_name": "Spalding",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13257,
	  "county_name": "Stephens",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13259,
	  "county_name": "Stewart",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13261,
	  "county_name": "Sumter",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13263,
	  "county_name": "Talbot",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13265,
	  "county_name": "Taliaferro",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13267,
	  "county_name": "Tattnall",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13269,
	  "county_name": "Taylor",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13271,
	  "county_name": "Telfair",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13273,
	  "county_name": "Terrell",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13275,
	  "county_name": "Thomas",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13277,
	  "county_name": "Tift",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13279,
	  "county_name": "Toombs",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13281,
	  "county_name": "Towns",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13283,
	  "county_name": "Treutlen",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13285,
	  "county_name": "Troup",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13287,
	  "county_name": "Turner",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13289,
	  "county_name": "Twiggs",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13291,
	  "county_name": "Union",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13293,
	  "county_name": "Upson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13295,
	  "county_name": "Walker",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13297,
	  "county_name": "Walton",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13299,
	  "county_name": "Ware",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13301,
	  "county_name": "Warren",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13303,
	  "county_name": "Washington",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13305,
	  "county_name": "Wayne",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13307,
	  "county_name": "Webster",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13309,
	  "county_name": "Wheeler",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13311,
	  "county_name": "White",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13313,
	  "county_name": "Whitfield",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13315,
	  "county_name": "Wilcox",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13317,
	  "county_name": "Wilkes",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13319,
	  "county_name": "Wilkinson",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 13321,
	  "county_name": "Worth",
	  "state": "GA",
	  "state_name": "Georgia"
	}, {
	  "fip": 15001,
	  "county_name": "Hawaii",
	  "state": "HI",
	  "state_name": "Hawaii"
	}, {
	  "fip": 15003,
	  "county_name": "Honolulu",
	  "state": "HI",
	  "state_name": "Hawaii"
	}, {
	  "fip": 15005,
	  "county_name": "Kalawao",
	  "state": "HI",
	  "state_name": "Hawaii"
	}, {
	  "fip": 15007,
	  "county_name": "Kauai",
	  "state": "HI",
	  "state_name": "Hawaii"
	}, {
	  "fip": 15009,
	  "county_name": "Maui",
	  "state": "HI",
	  "state_name": "Hawaii"
	}, {
	  "fip": 16001,
	  "county_name": "Ada",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16003,
	  "county_name": "Adams",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16005,
	  "county_name": "Bannock",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16007,
	  "county_name": "Bear Lake",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16009,
	  "county_name": "Benewah",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16011,
	  "county_name": "Bingham",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16013,
	  "county_name": "Blaine",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16015,
	  "county_name": "Boise",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16017,
	  "county_name": "Bonner",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16019,
	  "county_name": "Bonneville",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16021,
	  "county_name": "Boundary",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16023,
	  "county_name": "Butte",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16025,
	  "county_name": "Camas",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16027,
	  "county_name": "Canyon",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16029,
	  "county_name": "Caribou",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16031,
	  "county_name": "Cassia",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16033,
	  "county_name": "Clark",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16035,
	  "county_name": "Clearwater",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16037,
	  "county_name": "Custer",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16039,
	  "county_name": "Elmore",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16041,
	  "county_name": "Franklin",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16043,
	  "county_name": "Fremont",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16045,
	  "county_name": "Gem",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16047,
	  "county_name": "Gooding",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16049,
	  "county_name": "Idaho",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16051,
	  "county_name": "Jefferson",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16053,
	  "county_name": "Jerome",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16055,
	  "county_name": "Kootenai",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16057,
	  "county_name": "Latah",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16059,
	  "county_name": "Lemhi",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16061,
	  "county_name": "Lewis",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16063,
	  "county_name": "Lincoln",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16065,
	  "county_name": "Madison",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16067,
	  "county_name": "Minidoka",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16069,
	  "county_name": "Nez Perce",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16071,
	  "county_name": "Oneida",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16073,
	  "county_name": "Owyhee",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16075,
	  "county_name": "Payette",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16077,
	  "county_name": "Power",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16079,
	  "county_name": "Shoshone",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16081,
	  "county_name": "Teton",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16083,
	  "county_name": "Twin Falls",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16085,
	  "county_name": "Valley",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 16087,
	  "county_name": "Washington",
	  "state": "ID",
	  "state_name": "Idaho"
	}, {
	  "fip": 17001,
	  "county_name": "Adams",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17003,
	  "county_name": "Alexander",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17005,
	  "county_name": "Bond",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17007,
	  "county_name": "Boone",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17009,
	  "county_name": "Brown",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17011,
	  "county_name": "Bureau",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17013,
	  "county_name": "Calhoun",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17015,
	  "county_name": "Carroll",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17017,
	  "county_name": "Cass",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17019,
	  "county_name": "Champaign",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17021,
	  "county_name": "Christian",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17023,
	  "county_name": "Clark",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17025,
	  "county_name": "Clay",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17027,
	  "county_name": "Clinton",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17029,
	  "county_name": "Coles",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17031,
	  "county_name": "Cook",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17033,
	  "county_name": "Crawford",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17035,
	  "county_name": "Cumberland",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17037,
	  "county_name": "DeKalb",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17039,
	  "county_name": "De Witt",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17041,
	  "county_name": "Douglas",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17043,
	  "county_name": "DuPage",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17045,
	  "county_name": "Edgar",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17047,
	  "county_name": "Edwards",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17049,
	  "county_name": "Effingham",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17051,
	  "county_name": "Fayette",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17053,
	  "county_name": "Ford",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17055,
	  "county_name": "Franklin",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17057,
	  "county_name": "Fulton",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17059,
	  "county_name": "Gallatin",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17061,
	  "county_name": "Greene",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17063,
	  "county_name": "Grundy",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17065,
	  "county_name": "Hamilton",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17067,
	  "county_name": "Hancock",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17069,
	  "county_name": "Hardin",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17071,
	  "county_name": "Henderson",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17073,
	  "county_name": "Henry",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17075,
	  "county_name": "Iroquois",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17077,
	  "county_name": "Jackson",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17079,
	  "county_name": "Jasper",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17081,
	  "county_name": "Jefferson",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17083,
	  "county_name": "Jersey",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17085,
	  "county_name": "Jo Daviess",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17087,
	  "county_name": "Johnson",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17089,
	  "county_name": "Kane",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17091,
	  "county_name": "Kankakee",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17093,
	  "county_name": "Kendall",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17095,
	  "county_name": "Knox",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17097,
	  "county_name": "Lake",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17099,
	  "county_name": "LaSalle",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17101,
	  "county_name": "Lawrence",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17103,
	  "county_name": "Lee",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17105,
	  "county_name": "Livingston",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17107,
	  "county_name": "Logan",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17109,
	  "county_name": "McDonough",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17111,
	  "county_name": "McHenry",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17113,
	  "county_name": "McLean",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17115,
	  "county_name": "Macon",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17117,
	  "county_name": "Macoupin",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17119,
	  "county_name": "Madison",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17121,
	  "county_name": "Marion",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17123,
	  "county_name": "Marshall",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17125,
	  "county_name": "Mason",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17127,
	  "county_name": "Massac",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17129,
	  "county_name": "Menard",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17131,
	  "county_name": "Mercer",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17133,
	  "county_name": "Monroe",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17135,
	  "county_name": "Montgomery",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17137,
	  "county_name": "Morgan",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17139,
	  "county_name": "Moultrie",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17141,
	  "county_name": "Ogle",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17143,
	  "county_name": "Peoria",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17145,
	  "county_name": "Perry",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17147,
	  "county_name": "Piatt",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17149,
	  "county_name": "Pike",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17151,
	  "county_name": "Pope",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17153,
	  "county_name": "Pulaski",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17155,
	  "county_name": "Putnam",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17157,
	  "county_name": "Randolph",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17159,
	  "county_name": "Richland",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17161,
	  "county_name": "Rock Island",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17163,
	  "county_name": "St. Clair",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17165,
	  "county_name": "Saline",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17167,
	  "county_name": "Sangamon",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17169,
	  "county_name": "Schuyler",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17171,
	  "county_name": "Scott",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17173,
	  "county_name": "Shelby",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17175,
	  "county_name": "Stark",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17177,
	  "county_name": "Stephenson",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17179,
	  "county_name": "Tazewell",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17181,
	  "county_name": "Union",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17183,
	  "county_name": "Vermilion",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17185,
	  "county_name": "Wabash",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17187,
	  "county_name": "Warren",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17189,
	  "county_name": "Washington",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17191,
	  "county_name": "Wayne",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17193,
	  "county_name": "White",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17195,
	  "county_name": "Whiteside",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17197,
	  "county_name": "Will",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17199,
	  "county_name": "Williamson",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17201,
	  "county_name": "Winnebago",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 17203,
	  "county_name": "Woodford",
	  "state": "IL",
	  "state_name": "Illinois"
	}, {
	  "fip": 18001,
	  "county_name": "Adams",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18003,
	  "county_name": "Allen",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18005,
	  "county_name": "Bartholomew",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18007,
	  "county_name": "Benton",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18009,
	  "county_name": "Blackford",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18011,
	  "county_name": "Boone",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18013,
	  "county_name": "Brown",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18015,
	  "county_name": "Carroll",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18017,
	  "county_name": "Cass",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18019,
	  "county_name": "Clark",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18021,
	  "county_name": "Clay",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18023,
	  "county_name": "Clinton",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18025,
	  "county_name": "Crawford",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18027,
	  "county_name": "Daviess",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18029,
	  "county_name": "Dearborn",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18031,
	  "county_name": "Decatur",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18033,
	  "county_name": "DeKalb",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18035,
	  "county_name": "Delaware",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18037,
	  "county_name": "Dubois",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18039,
	  "county_name": "Elkhart",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18041,
	  "county_name": "Fayette",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18043,
	  "county_name": "Floyd",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18045,
	  "county_name": "Fountain",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18047,
	  "county_name": "Franklin",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18049,
	  "county_name": "Fulton",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18051,
	  "county_name": "Gibson",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18053,
	  "county_name": "Grant",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18055,
	  "county_name": "Greene",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18057,
	  "county_name": "Hamilton",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18059,
	  "county_name": "Hancock",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18061,
	  "county_name": "Harrison",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18063,
	  "county_name": "Hendricks",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18065,
	  "county_name": "Henry",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18067,
	  "county_name": "Howard",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18069,
	  "county_name": "Huntington",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18071,
	  "county_name": "Jackson",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18073,
	  "county_name": "Jasper",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18075,
	  "county_name": "Jay",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18077,
	  "county_name": "Jefferson",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18079,
	  "county_name": "Jennings",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18081,
	  "county_name": "Johnson",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18083,
	  "county_name": "Knox",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18085,
	  "county_name": "Kosciusko",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18087,
	  "county_name": "LaGrange",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18089,
	  "county_name": "Lake",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18091,
	  "county_name": "LaPorte",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18093,
	  "county_name": "Lawrence",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18095,
	  "county_name": "Madison",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18097,
	  "county_name": "Marion",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18099,
	  "county_name": "Marshall",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18101,
	  "county_name": "Martin",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18103,
	  "county_name": "Miami",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18105,
	  "county_name": "Monroe",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18107,
	  "county_name": "Montgomery",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18109,
	  "county_name": "Morgan",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18111,
	  "county_name": "Newton",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18113,
	  "county_name": "Noble",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18115,
	  "county_name": "Ohio",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18117,
	  "county_name": "Orange",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18119,
	  "county_name": "Owen",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18121,
	  "county_name": "Parke",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18123,
	  "county_name": "Perry",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18125,
	  "county_name": "Pike",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18127,
	  "county_name": "Porter",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18129,
	  "county_name": "Posey",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18131,
	  "county_name": "Pulaski",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18133,
	  "county_name": "Putnam",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18135,
	  "county_name": "Randolph",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18137,
	  "county_name": "Ripley",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18139,
	  "county_name": "Rush",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18141,
	  "county_name": "St. Joseph",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18143,
	  "county_name": "Scott",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18145,
	  "county_name": "Shelby",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18147,
	  "county_name": "Spencer",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18149,
	  "county_name": "Starke",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18151,
	  "county_name": "Steuben",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18153,
	  "county_name": "Sullivan",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18155,
	  "county_name": "Switzerland",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18157,
	  "county_name": "Tippecanoe",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18159,
	  "county_name": "Tipton",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18161,
	  "county_name": "Union",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18163,
	  "county_name": "Vanderburgh",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18165,
	  "county_name": "Vermillion",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18167,
	  "county_name": "Vigo",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18169,
	  "county_name": "Wabash",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18171,
	  "county_name": "Warren",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18173,
	  "county_name": "Warrick",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18175,
	  "county_name": "Washington",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18177,
	  "county_name": "Wayne",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18179,
	  "county_name": "Wells",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18181,
	  "county_name": "White",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 18183,
	  "county_name": "Whitley",
	  "state": "IN",
	  "state_name": "Indiana"
	}, {
	  "fip": 19001,
	  "county_name": "Adair",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19003,
	  "county_name": "Adams",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19005,
	  "county_name": "Allamakee",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19007,
	  "county_name": "Appanoose",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19009,
	  "county_name": "Audubon",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19011,
	  "county_name": "Benton",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19013,
	  "county_name": "Black Hawk",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19015,
	  "county_name": "Boone",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19017,
	  "county_name": "Bremer",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19019,
	  "county_name": "Buchanan",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19021,
	  "county_name": "Buena Vista",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19023,
	  "county_name": "Butler",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19025,
	  "county_name": "Calhoun",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19027,
	  "county_name": "Carroll",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19029,
	  "county_name": "Cass",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19031,
	  "county_name": "Cedar",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19033,
	  "county_name": "Cerro Gordo",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19035,
	  "county_name": "Cherokee",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19037,
	  "county_name": "Chickasaw",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19039,
	  "county_name": "Clarke",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19041,
	  "county_name": "Clay",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19043,
	  "county_name": "Clayton",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19045,
	  "county_name": "Clinton",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19047,
	  "county_name": "Crawford",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19049,
	  "county_name": "Dallas",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19051,
	  "county_name": "Davis",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19053,
	  "county_name": "Decatur",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19055,
	  "county_name": "Delaware",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19057,
	  "county_name": "Des Moines",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19059,
	  "county_name": "Dickinson",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19061,
	  "county_name": "Dubuque",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19063,
	  "county_name": "Emmet",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19065,
	  "county_name": "Fayette",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19067,
	  "county_name": "Floyd",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19069,
	  "county_name": "Franklin",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19071,
	  "county_name": "Fremont",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19073,
	  "county_name": "Greene",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19075,
	  "county_name": "Grundy",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19077,
	  "county_name": "Guthrie",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19079,
	  "county_name": "Hamilton",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19081,
	  "county_name": "Hancock",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19083,
	  "county_name": "Hardin",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19085,
	  "county_name": "Harrison",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19087,
	  "county_name": "Henry",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19089,
	  "county_name": "Howard",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19091,
	  "county_name": "Humboldt",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19093,
	  "county_name": "Ida",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19095,
	  "county_name": "Iowa",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19097,
	  "county_name": "Jackson",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19099,
	  "county_name": "Jasper",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19101,
	  "county_name": "Jefferson",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19103,
	  "county_name": "Johnson",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19105,
	  "county_name": "Jones",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19107,
	  "county_name": "Keokuk",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19109,
	  "county_name": "Kossuth",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19111,
	  "county_name": "Lee",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19113,
	  "county_name": "Linn",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19115,
	  "county_name": "Louisa",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19117,
	  "county_name": "Lucas",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19119,
	  "county_name": "Lyon",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19121,
	  "county_name": "Madison",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19123,
	  "county_name": "Mahaska",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19125,
	  "county_name": "Marion",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19127,
	  "county_name": "Marshall",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19129,
	  "county_name": "Mills",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19131,
	  "county_name": "Mitchell",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19133,
	  "county_name": "Monona",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19135,
	  "county_name": "Monroe",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19137,
	  "county_name": "Montgomery",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19139,
	  "county_name": "Muscatine",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19141,
	  "county_name": "O'Brien",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19143,
	  "county_name": "Osceola",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19145,
	  "county_name": "Page",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19147,
	  "county_name": "Palo Alto",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19149,
	  "county_name": "Plymouth",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19151,
	  "county_name": "Pocahontas",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19153,
	  "county_name": "Polk",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19155,
	  "county_name": "Pottawattamie",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19157,
	  "county_name": "Poweshiek",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19159,
	  "county_name": "Ringgold",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19161,
	  "county_name": "Sac",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19163,
	  "county_name": "Scott",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19165,
	  "county_name": "Shelby",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19167,
	  "county_name": "Sioux",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19169,
	  "county_name": "Story",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19171,
	  "county_name": "Tama",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19173,
	  "county_name": "Taylor",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19175,
	  "county_name": "Union",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19177,
	  "county_name": "Van Buren",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19179,
	  "county_name": "Wapello",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19181,
	  "county_name": "Warren",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19183,
	  "county_name": "Washington",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19185,
	  "county_name": "Wayne",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19187,
	  "county_name": "Webster",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19189,
	  "county_name": "Winnebago",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19191,
	  "county_name": "Winneshiek",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19193,
	  "county_name": "Woodbury",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19195,
	  "county_name": "Worth",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 19197,
	  "county_name": "Wright",
	  "state": "IA",
	  "state_name": "Iowa"
	}, {
	  "fip": 20001,
	  "county_name": "Allen",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20003,
	  "county_name": "Anderson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20005,
	  "county_name": "Atchison",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20007,
	  "county_name": "Barber",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20009,
	  "county_name": "Barton",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20011,
	  "county_name": "Bourbon",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20013,
	  "county_name": "Brown",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20015,
	  "county_name": "Butler",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20017,
	  "county_name": "Chase",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20019,
	  "county_name": "Chautauqua",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20021,
	  "county_name": "Cherokee",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20023,
	  "county_name": "Cheyenne",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20025,
	  "county_name": "Clark",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20027,
	  "county_name": "Clay",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20029,
	  "county_name": "Cloud",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20031,
	  "county_name": "Coffey",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20033,
	  "county_name": "Comanche",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20035,
	  "county_name": "Cowley",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20037,
	  "county_name": "Crawford",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20039,
	  "county_name": "Decatur",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20041,
	  "county_name": "Dickinson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20043,
	  "county_name": "Doniphan",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20045,
	  "county_name": "Douglas",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20047,
	  "county_name": "Edwards",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20049,
	  "county_name": "Elk",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20051,
	  "county_name": "Ellis",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20053,
	  "county_name": "Ellsworth",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20055,
	  "county_name": "Finney",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20057,
	  "county_name": "Ford",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20059,
	  "county_name": "Franklin",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20061,
	  "county_name": "Geary",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20063,
	  "county_name": "Gove",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20065,
	  "county_name": "Graham",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20067,
	  "county_name": "Grant",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20069,
	  "county_name": "Gray",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20071,
	  "county_name": "Greeley",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20073,
	  "county_name": "Greenwood",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20075,
	  "county_name": "Hamilton",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20077,
	  "county_name": "Harper",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20079,
	  "county_name": "Harvey",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20081,
	  "county_name": "Haskell",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20083,
	  "county_name": "Hodgeman",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20085,
	  "county_name": "Jackson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20087,
	  "county_name": "Jefferson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20089,
	  "county_name": "Jewell",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20091,
	  "county_name": "Johnson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20093,
	  "county_name": "Kearny",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20095,
	  "county_name": "Kingman",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20097,
	  "county_name": "Kiowa",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20099,
	  "county_name": "Labette",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20101,
	  "county_name": "Lane",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20103,
	  "county_name": "Leavenworth",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20105,
	  "county_name": "Lincoln",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20107,
	  "county_name": "Linn",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20109,
	  "county_name": "Logan",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20111,
	  "county_name": "Lyon",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20113,
	  "county_name": "McPherson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20115,
	  "county_name": "Marion",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20117,
	  "county_name": "Marshall",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20119,
	  "county_name": "Meade",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20121,
	  "county_name": "Miami",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20123,
	  "county_name": "Mitchell",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20125,
	  "county_name": "Montgomery",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20127,
	  "county_name": "Morris",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20129,
	  "county_name": "Morton",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20131,
	  "county_name": "Nemaha",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20133,
	  "county_name": "Neosho",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20135,
	  "county_name": "Ness",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20137,
	  "county_name": "Norton",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20139,
	  "county_name": "Osage",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20141,
	  "county_name": "Osborne",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20143,
	  "county_name": "Ottawa",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20145,
	  "county_name": "Pawnee",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20147,
	  "county_name": "Phillips",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20149,
	  "county_name": "Pottawatomie",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20151,
	  "county_name": "Pratt",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20153,
	  "county_name": "Rawlins",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20155,
	  "county_name": "Reno",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20157,
	  "county_name": "Republic",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20159,
	  "county_name": "Rice",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20161,
	  "county_name": "Riley",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20163,
	  "county_name": "Rooks",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20165,
	  "county_name": "Rush",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20167,
	  "county_name": "Russell",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20169,
	  "county_name": "Saline",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20171,
	  "county_name": "Scott",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20173,
	  "county_name": "Sedgwick",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20175,
	  "county_name": "Seward",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20177,
	  "county_name": "Shawnee",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20179,
	  "county_name": "Sheridan",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20181,
	  "county_name": "Sherman",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20183,
	  "county_name": "Smith",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20185,
	  "county_name": "Stafford",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20187,
	  "county_name": "Stanton",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20189,
	  "county_name": "Stevens",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20191,
	  "county_name": "Sumner",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20193,
	  "county_name": "Thomas",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20195,
	  "county_name": "Trego",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20197,
	  "county_name": "Wabaunsee",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20199,
	  "county_name": "Wallace",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20201,
	  "county_name": "Washington",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20203,
	  "county_name": "Wichita",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20205,
	  "county_name": "Wilson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20207,
	  "county_name": "Woodson",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 20209,
	  "county_name": "Wyandotte",
	  "state": "KS",
	  "state_name": "Kansas"
	}, {
	  "fip": 21001,
	  "county_name": "Adair",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21003,
	  "county_name": "Allen",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21005,
	  "county_name": "Anderson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21007,
	  "county_name": "Ballard",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21009,
	  "county_name": "Barren",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21011,
	  "county_name": "Bath",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21013,
	  "county_name": "Bell",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21015,
	  "county_name": "Boone",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21017,
	  "county_name": "Bourbon",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21019,
	  "county_name": "Boyd",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21021,
	  "county_name": "Boyle",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21023,
	  "county_name": "Bracken",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21025,
	  "county_name": "Breathitt",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21027,
	  "county_name": "Breckinridge",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21029,
	  "county_name": "Bullitt",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21031,
	  "county_name": "Butler",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21033,
	  "county_name": "Caldwell",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21035,
	  "county_name": "Calloway",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21037,
	  "county_name": "Campbell",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21039,
	  "county_name": "Carlisle",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21041,
	  "county_name": "Carroll",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21043,
	  "county_name": "Carter",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21045,
	  "county_name": "Casey",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21047,
	  "county_name": "Christian",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21049,
	  "county_name": "Clark",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21051,
	  "county_name": "Clay",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21053,
	  "county_name": "Clinton",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21055,
	  "county_name": "Crittenden",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21057,
	  "county_name": "Cumberland",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21059,
	  "county_name": "Daviess",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21061,
	  "county_name": "Edmonson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21063,
	  "county_name": "Elliott",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21065,
	  "county_name": "Estill",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21067,
	  "county_name": "Fayette",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21069,
	  "county_name": "Fleming",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21071,
	  "county_name": "Floyd",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21073,
	  "county_name": "Franklin",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21075,
	  "county_name": "Fulton",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21077,
	  "county_name": "Gallatin",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21079,
	  "county_name": "Garrard",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21081,
	  "county_name": "Grant",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21083,
	  "county_name": "Graves",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21085,
	  "county_name": "Grayson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21087,
	  "county_name": "Green",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21089,
	  "county_name": "Greenup",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21091,
	  "county_name": "Hancock",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21093,
	  "county_name": "Hardin",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21095,
	  "county_name": "Harlan",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21097,
	  "county_name": "Harrison",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21099,
	  "county_name": "Hart",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21101,
	  "county_name": "Henderson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21103,
	  "county_name": "Henry",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21105,
	  "county_name": "Hickman",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21107,
	  "county_name": "Hopkins",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21109,
	  "county_name": "Jackson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21111,
	  "county_name": "Jefferson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21113,
	  "county_name": "Jessamine",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21115,
	  "county_name": "Johnson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21117,
	  "county_name": "Kenton",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21119,
	  "county_name": "Knott",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21121,
	  "county_name": "Knox",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21123,
	  "county_name": "Larue",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21125,
	  "county_name": "Laurel",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21127,
	  "county_name": "Lawrence",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21129,
	  "county_name": "Lee",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21131,
	  "county_name": "Leslie",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21133,
	  "county_name": "Letcher",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21135,
	  "county_name": "Lewis",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21137,
	  "county_name": "Lincoln",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21139,
	  "county_name": "Livingston",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21141,
	  "county_name": "Logan",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21143,
	  "county_name": "Lyon",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21145,
	  "county_name": "McCracken",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21147,
	  "county_name": "McCreary",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21149,
	  "county_name": "McLean",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21151,
	  "county_name": "Madison",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21153,
	  "county_name": "Magoffin",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21155,
	  "county_name": "Marion",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21157,
	  "county_name": "Marshall",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21159,
	  "county_name": "Martin",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21161,
	  "county_name": "Mason",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21163,
	  "county_name": "Meade",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21165,
	  "county_name": "Menifee",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21167,
	  "county_name": "Mercer",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21169,
	  "county_name": "Metcalfe",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21171,
	  "county_name": "Monroe",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21173,
	  "county_name": "Montgomery",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21175,
	  "county_name": "Morgan",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21177,
	  "county_name": "Muhlenberg",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21179,
	  "county_name": "Nelson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21181,
	  "county_name": "Nicholas",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21183,
	  "county_name": "Ohio",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21185,
	  "county_name": "Oldham",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21187,
	  "county_name": "Owen",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21189,
	  "county_name": "Owsley",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21191,
	  "county_name": "Pendleton",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21193,
	  "county_name": "Perry",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21195,
	  "county_name": "Pike",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21197,
	  "county_name": "Powell",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21199,
	  "county_name": "Pulaski",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21201,
	  "county_name": "Robertson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21203,
	  "county_name": "Rockcastle",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21205,
	  "county_name": "Rowan",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21207,
	  "county_name": "Russell",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21209,
	  "county_name": "Scott",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21211,
	  "county_name": "Shelby",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21213,
	  "county_name": "Simpson",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21215,
	  "county_name": "Spencer",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21217,
	  "county_name": "Taylor",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21219,
	  "county_name": "Todd",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21221,
	  "county_name": "Trigg",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21223,
	  "county_name": "Trimble",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21225,
	  "county_name": "Union",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21227,
	  "county_name": "Warren",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21229,
	  "county_name": "Washington",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21231,
	  "county_name": "Wayne",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21233,
	  "county_name": "Webster",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21235,
	  "county_name": "Whitley",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21237,
	  "county_name": "Wolfe",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 21239,
	  "county_name": "Woodford",
	  "state": "KY",
	  "state_name": "Kentucky"
	}, {
	  "fip": 22001,
	  "county_name": "Acadia Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22003,
	  "county_name": "Allen Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22005,
	  "county_name": "Ascension Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22007,
	  "county_name": "Assumption Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22009,
	  "county_name": "Avoyelles Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22011,
	  "county_name": "Beauregard Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22013,
	  "county_name": "Bienville Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22015,
	  "county_name": "Bossier Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22017,
	  "county_name": "Caddo Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22019,
	  "county_name": "Calcasieu Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22021,
	  "county_name": "Caldwell Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22023,
	  "county_name": "Cameron Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22025,
	  "county_name": "Catahoula Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22027,
	  "county_name": "Claiborne Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22029,
	  "county_name": "Concordia Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22031,
	  "county_name": "De Soto Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22033,
	  "county_name": "East Baton Rouge Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22035,
	  "county_name": "East Carroll Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22037,
	  "county_name": "East Feliciana Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22039,
	  "county_name": "Evangeline Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22041,
	  "county_name": "Franklin Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22043,
	  "county_name": "Grant Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22045,
	  "county_name": "Iberia Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22047,
	  "county_name": "Iberville Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22049,
	  "county_name": "Jackson Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22051,
	  "county_name": "Jefferson Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22053,
	  "county_name": "Jefferson Davis Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22055,
	  "county_name": "Lafayette Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22057,
	  "county_name": "Lafourche Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22059,
	  "county_name": "La Salle Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22061,
	  "county_name": "Lincoln Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22063,
	  "county_name": "Livingston Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22065,
	  "county_name": "Madison Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22067,
	  "county_name": "Morehouse Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22069,
	  "county_name": "Natchitoches Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22071,
	  "county_name": "Orleans Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22073,
	  "county_name": "Ouachita Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22075,
	  "county_name": "Plaquemines Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22077,
	  "county_name": "Pointe Coupee Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22079,
	  "county_name": "Rapides Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22081,
	  "county_name": "Red River Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22083,
	  "county_name": "Richland Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22085,
	  "county_name": "Sabine Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22087,
	  "county_name": "St. Bernard Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22089,
	  "county_name": "St. Charles Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22091,
	  "county_name": "St. Helena Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22093,
	  "county_name": "St. James Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22095,
	  "county_name": "St. John the Baptist Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22097,
	  "county_name": "St. Landry Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22099,
	  "county_name": "St. Martin Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22101,
	  "county_name": "St. Mary Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22103,
	  "county_name": "St. Tammany Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22105,
	  "county_name": "Tangipahoa Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22107,
	  "county_name": "Tensas Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22109,
	  "county_name": "Terrebonne Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22111,
	  "county_name": "Union Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22113,
	  "county_name": "Vermilion Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22115,
	  "county_name": "Vernon Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22117,
	  "county_name": "Washington Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22119,
	  "county_name": "Webster Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22121,
	  "county_name": "West Baton Rouge Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22123,
	  "county_name": "West Carroll Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22125,
	  "county_name": "West Feliciana Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 22127,
	  "county_name": "Winn Parish",
	  "state": "LA",
	  "state_name": "Louisiana"
	}, {
	  "fip": 23001,
	  "county_name": "Androscoggin",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23003,
	  "county_name": "Aroostook",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23005,
	  "county_name": "Cumberland",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23007,
	  "county_name": "Franklin",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23009,
	  "county_name": "Hancock",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23011,
	  "county_name": "Kennebec",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23013,
	  "county_name": "Knox",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23015,
	  "county_name": "Lincoln",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23017,
	  "county_name": "Oxford",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23019,
	  "county_name": "Penobscot",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23021,
	  "county_name": "Piscataquis",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23023,
	  "county_name": "Sagadahoc",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23025,
	  "county_name": "Somerset",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23027,
	  "county_name": "Waldo",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23029,
	  "county_name": "Washington",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 23031,
	  "county_name": "York",
	  "state": "ME",
	  "state_name": "Maine"
	}, {
	  "fip": 24001,
	  "county_name": "Allegany",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24003,
	  "county_name": "Anne Arundel",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24005,
	  "county_name": "Baltimore",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24009,
	  "county_name": "Calvert",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24011,
	  "county_name": "Caroline",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24013,
	  "county_name": "Carroll",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24015,
	  "county_name": "Cecil",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24017,
	  "county_name": "Charles",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24019,
	  "county_name": "Dorchester",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24021,
	  "county_name": "Frederick",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24023,
	  "county_name": "Garrett",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24025,
	  "county_name": "Harford",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24027,
	  "county_name": "Howard",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24029,
	  "county_name": "Kent",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24031,
	  "county_name": "Montgomery",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24033,
	  "county_name": "Prince George's",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24035,
	  "county_name": "Queen Anne's",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24037,
	  "county_name": "St. Mary's",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24039,
	  "county_name": "Somerset",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24041,
	  "county_name": "Talbot",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24043,
	  "county_name": "Washington",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24045,
	  "county_name": "Wicomico",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24047,
	  "county_name": "Worcester",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 24510,
	  "county_name": "Baltimore city",
	  "state": "MD",
	  "state_name": "Maryland"
	}, {
	  "fip": 25001,
	  "county_name": "Barnstable",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25003,
	  "county_name": "Berkshire",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25005,
	  "county_name": "Bristol",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25007,
	  "county_name": "Dukes",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25009,
	  "county_name": "Essex",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25011,
	  "county_name": "Franklin",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25013,
	  "county_name": "Hampden",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25015,
	  "county_name": "Hampshire",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25017,
	  "county_name": "Middlesex",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25019,
	  "county_name": "Nantucket",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25021,
	  "county_name": "Norfolk",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25023,
	  "county_name": "Plymouth",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25025,
	  "county_name": "Suffolk",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 25027,
	  "county_name": "Worcester",
	  "state": "MA",
	  "state_name": "Massachusetts"
	}, {
	  "fip": 26001,
	  "county_name": "Alcona",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26003,
	  "county_name": "Alger",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26005,
	  "county_name": "Allegan",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26007,
	  "county_name": "Alpena",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26009,
	  "county_name": "Antrim",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26011,
	  "county_name": "Arenac",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26013,
	  "county_name": "Baraga",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26015,
	  "county_name": "Barry",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26017,
	  "county_name": "Bay",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26019,
	  "county_name": "Benzie",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26021,
	  "county_name": "Berrien",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26023,
	  "county_name": "Branch",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26025,
	  "county_name": "Calhoun",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26027,
	  "county_name": "Cass",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26029,
	  "county_name": "Charlevoix",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26031,
	  "county_name": "Cheboygan",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26033,
	  "county_name": "Chippewa",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26035,
	  "county_name": "Clare",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26037,
	  "county_name": "Clinton",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26039,
	  "county_name": "Crawford",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26041,
	  "county_name": "Delta",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26043,
	  "county_name": "Dickinson",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26045,
	  "county_name": "Eaton",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26047,
	  "county_name": "Emmet",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26049,
	  "county_name": "Genesee",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26051,
	  "county_name": "Gladwin",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26053,
	  "county_name": "Gogebic",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26055,
	  "county_name": "Grand Traverse",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26057,
	  "county_name": "Gratiot",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26059,
	  "county_name": "Hillsdale",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26061,
	  "county_name": "Houghton",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26063,
	  "county_name": "Huron",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26065,
	  "county_name": "Ingham",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26067,
	  "county_name": "Ionia",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26069,
	  "county_name": "Iosco",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26071,
	  "county_name": "Iron",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26073,
	  "county_name": "Isabella",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26075,
	  "county_name": "Jackson",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26077,
	  "county_name": "Kalamazoo",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26079,
	  "county_name": "Kalkaska",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26081,
	  "county_name": "Kent",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26083,
	  "county_name": "Keweenaw",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26085,
	  "county_name": "Lake",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26087,
	  "county_name": "Lapeer",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26089,
	  "county_name": "Leelanau",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26091,
	  "county_name": "Lenawee",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26093,
	  "county_name": "Livingston",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26095,
	  "county_name": "Luce",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26097,
	  "county_name": "Mackinac",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26099,
	  "county_name": "Macomb",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26101,
	  "county_name": "Manistee",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26103,
	  "county_name": "Marquette",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26105,
	  "county_name": "Mason",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26107,
	  "county_name": "Mecosta",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26109,
	  "county_name": "Menominee",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26111,
	  "county_name": "Midland",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26113,
	  "county_name": "Missaukee",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26115,
	  "county_name": "Monroe",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26117,
	  "county_name": "Montcalm",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26119,
	  "county_name": "Montmorency",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26121,
	  "county_name": "Muskegon",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26123,
	  "county_name": "Newaygo",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26125,
	  "county_name": "Oakland",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26127,
	  "county_name": "Oceana",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26129,
	  "county_name": "Ogemaw",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26131,
	  "county_name": "Ontonagon",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26133,
	  "county_name": "Osceola",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26135,
	  "county_name": "Oscoda",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26137,
	  "county_name": "Otsego",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26139,
	  "county_name": "Ottawa",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26141,
	  "county_name": "Presque Isle",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26143,
	  "county_name": "Roscommon",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26145,
	  "county_name": "Saginaw",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26147,
	  "county_name": "St. Clair",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26149,
	  "county_name": "St. Joseph",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26151,
	  "county_name": "Sanilac",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26153,
	  "county_name": "Schoolcraft",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26155,
	  "county_name": "Shiawassee",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26157,
	  "county_name": "Tuscola",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26159,
	  "county_name": "Van Buren",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26161,
	  "county_name": "Washtenaw",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26163,
	  "county_name": "Wayne",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 26165,
	  "county_name": "Wexford",
	  "state": "MI",
	  "state_name": "Michigan"
	}, {
	  "fip": 27001,
	  "county_name": "Aitkin",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27003,
	  "county_name": "Anoka",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27005,
	  "county_name": "Becker",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27007,
	  "county_name": "Beltrami",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27009,
	  "county_name": "Benton",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27011,
	  "county_name": "Big Stone",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27013,
	  "county_name": "Blue Earth",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27015,
	  "county_name": "Brown",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27017,
	  "county_name": "Carlton",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27019,
	  "county_name": "Carver",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27021,
	  "county_name": "Cass",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27023,
	  "county_name": "Chippewa",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27025,
	  "county_name": "Chisago",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27027,
	  "county_name": "Clay",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27029,
	  "county_name": "Clearwater",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27031,
	  "county_name": "Cook",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27033,
	  "county_name": "Cottonwood",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27035,
	  "county_name": "Crow Wing",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27037,
	  "county_name": "Dakota",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27039,
	  "county_name": "Dodge",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27041,
	  "county_name": "Douglas",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27043,
	  "county_name": "Faribault",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27045,
	  "county_name": "Fillmore",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27047,
	  "county_name": "Freeborn",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27049,
	  "county_name": "Goodhue",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27051,
	  "county_name": "Grant",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27053,
	  "county_name": "Hennepin",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27055,
	  "county_name": "Houston",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27057,
	  "county_name": "Hubbard",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27059,
	  "county_name": "Isanti",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27061,
	  "county_name": "Itasca",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27063,
	  "county_name": "Jackson",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27065,
	  "county_name": "Kanabec",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27067,
	  "county_name": "Kandiyohi",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27069,
	  "county_name": "Kittson",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27071,
	  "county_name": "Koochiching",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27073,
	  "county_name": "Lac qui Parle",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27075,
	  "county_name": "Lake",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27077,
	  "county_name": "Lake of the Woods",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27079,
	  "county_name": "Le Sueur",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27081,
	  "county_name": "Lincoln",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27083,
	  "county_name": "Lyon",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27085,
	  "county_name": "McLeod",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27087,
	  "county_name": "Mahnomen",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27089,
	  "county_name": "Marshall",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27091,
	  "county_name": "Martin",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27093,
	  "county_name": "Meeker",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27095,
	  "county_name": "Mille Lacs",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27097,
	  "county_name": "Morrison",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27099,
	  "county_name": "Mower",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27101,
	  "county_name": "Murray",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27103,
	  "county_name": "Nicollet",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27105,
	  "county_name": "Nobles",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27107,
	  "county_name": "Norman",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27109,
	  "county_name": "Olmsted",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27111,
	  "county_name": "Otter Tail",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27113,
	  "county_name": "Pennington",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27115,
	  "county_name": "Pine",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27117,
	  "county_name": "Pipestone",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27119,
	  "county_name": "Polk",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27121,
	  "county_name": "Pope",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27123,
	  "county_name": "Ramsey",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27125,
	  "county_name": "Red Lake",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27127,
	  "county_name": "Redwood",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27129,
	  "county_name": "Renville",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27131,
	  "county_name": "Rice",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27133,
	  "county_name": "Rock",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27135,
	  "county_name": "Roseau",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27137,
	  "county_name": "St. Louis",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27139,
	  "county_name": "Scott",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27141,
	  "county_name": "Sherburne",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27143,
	  "county_name": "Sibley",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27145,
	  "county_name": "Stearns",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27147,
	  "county_name": "Steele",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27149,
	  "county_name": "Stevens",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27151,
	  "county_name": "Swift",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27153,
	  "county_name": "Todd",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27155,
	  "county_name": "Traverse",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27157,
	  "county_name": "Wabasha",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27159,
	  "county_name": "Wadena",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27161,
	  "county_name": "Waseca",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27163,
	  "county_name": "Washington",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27165,
	  "county_name": "Watonwan",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27167,
	  "county_name": "Wilkin",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27169,
	  "county_name": "Winona",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27171,
	  "county_name": "Wright",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 27173,
	  "county_name": "Yellow Medicine",
	  "state": "MN",
	  "state_name": "Minnesota"
	}, {
	  "fip": 28001,
	  "county_name": "Adams",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28003,
	  "county_name": "Alcorn",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28005,
	  "county_name": "Amite",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28007,
	  "county_name": "Attala",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28009,
	  "county_name": "Benton",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28011,
	  "county_name": "Bolivar",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28013,
	  "county_name": "Calhoun",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28015,
	  "county_name": "Carroll",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28017,
	  "county_name": "Chickasaw",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28019,
	  "county_name": "Choctaw",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28021,
	  "county_name": "Claiborne",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28023,
	  "county_name": "Clarke",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28025,
	  "county_name": "Clay",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28027,
	  "county_name": "Coahoma",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28029,
	  "county_name": "Copiah",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28031,
	  "county_name": "Covington",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28033,
	  "county_name": "DeSoto",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28035,
	  "county_name": "Forrest",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28037,
	  "county_name": "Franklin",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28039,
	  "county_name": "George",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28041,
	  "county_name": "Greene",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28043,
	  "county_name": "Grenada",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28045,
	  "county_name": "Hancock",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28047,
	  "county_name": "Harrison",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28049,
	  "county_name": "Hinds",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28051,
	  "county_name": "Holmes",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28053,
	  "county_name": "Humphreys",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28055,
	  "county_name": "Issaquena",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28057,
	  "county_name": "Itawamba",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28059,
	  "county_name": "Jackson",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28061,
	  "county_name": "Jasper",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28063,
	  "county_name": "Jefferson",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28065,
	  "county_name": "Jefferson Davis",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28067,
	  "county_name": "Jones",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28069,
	  "county_name": "Kemper",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28071,
	  "county_name": "Lafayette",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28073,
	  "county_name": "Lamar",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28075,
	  "county_name": "Lauderdale",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28077,
	  "county_name": "Lawrence",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28079,
	  "county_name": "Leake",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28081,
	  "county_name": "Lee",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28083,
	  "county_name": "Leflore",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28085,
	  "county_name": "Lincoln",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28087,
	  "county_name": "Lowndes",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28089,
	  "county_name": "Madison",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28091,
	  "county_name": "Marion",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28093,
	  "county_name": "Marshall",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28095,
	  "county_name": "Monroe",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28097,
	  "county_name": "Montgomery",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28099,
	  "county_name": "Neshoba",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28101,
	  "county_name": "Newton",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28103,
	  "county_name": "Noxubee",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28105,
	  "county_name": "Oktibbeha",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28107,
	  "county_name": "Panola",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28109,
	  "county_name": "Pearl River",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28111,
	  "county_name": "Perry",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28113,
	  "county_name": "Pike",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28115,
	  "county_name": "Pontotoc",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28117,
	  "county_name": "Prentiss",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28119,
	  "county_name": "Quitman",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28121,
	  "county_name": "Rankin",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28123,
	  "county_name": "Scott",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28125,
	  "county_name": "Sharkey",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28127,
	  "county_name": "Simpson",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28129,
	  "county_name": "Smith",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28131,
	  "county_name": "Stone",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28133,
	  "county_name": "Sunflower",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28135,
	  "county_name": "Tallahatchie",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28137,
	  "county_name": "Tate",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28139,
	  "county_name": "Tippah",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28141,
	  "county_name": "Tishomingo",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28143,
	  "county_name": "Tunica",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28145,
	  "county_name": "Union",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28147,
	  "county_name": "Walthall",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28149,
	  "county_name": "Warren",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28151,
	  "county_name": "Washington",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28153,
	  "county_name": "Wayne",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28155,
	  "county_name": "Webster",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28157,
	  "county_name": "Wilkinson",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28159,
	  "county_name": "Winston",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28161,
	  "county_name": "Yalobusha",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 28163,
	  "county_name": "Yazoo",
	  "state": "MS",
	  "state_name": "Mississippi"
	}, {
	  "fip": 29001,
	  "county_name": "Adair",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29003,
	  "county_name": "Andrew",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29005,
	  "county_name": "Atchison",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29007,
	  "county_name": "Audrain",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29009,
	  "county_name": "Barry",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29011,
	  "county_name": "Barton",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29013,
	  "county_name": "Bates",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29015,
	  "county_name": "Benton",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29017,
	  "county_name": "Bollinger",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29019,
	  "county_name": "Boone",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29021,
	  "county_name": "Buchanan",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29023,
	  "county_name": "Butler",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29025,
	  "county_name": "Caldwell",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29027,
	  "county_name": "Callaway",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29029,
	  "county_name": "Camden",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29031,
	  "county_name": "Cape Girardeau",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29033,
	  "county_name": "Carroll",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29035,
	  "county_name": "Carter",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29037,
	  "county_name": "Cass",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29039,
	  "county_name": "Cedar",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29041,
	  "county_name": "Chariton",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29043,
	  "county_name": "Christian",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29045,
	  "county_name": "Clark",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29047,
	  "county_name": "Clay",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29049,
	  "county_name": "Clinton",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29051,
	  "county_name": "Cole",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29053,
	  "county_name": "Cooper",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29055,
	  "county_name": "Crawford",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29057,
	  "county_name": "Dade",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29059,
	  "county_name": "Dallas",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29061,
	  "county_name": "Daviess",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29063,
	  "county_name": "DeKalb",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29065,
	  "county_name": "Dent",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29067,
	  "county_name": "Douglas",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29069,
	  "county_name": "Dunklin",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29071,
	  "county_name": "Franklin",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29073,
	  "county_name": "Gasconade",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29075,
	  "county_name": "Gentry",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29077,
	  "county_name": "Greene",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29079,
	  "county_name": "Grundy",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29081,
	  "county_name": "Harrison",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29083,
	  "county_name": "Henry",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29085,
	  "county_name": "Hickory",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29087,
	  "county_name": "Holt",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29089,
	  "county_name": "Howard",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29091,
	  "county_name": "Howell",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29093,
	  "county_name": "Iron",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29095,
	  "county_name": "Jackson",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29097,
	  "county_name": "Jasper",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29099,
	  "county_name": "Jefferson",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29101,
	  "county_name": "Johnson",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29103,
	  "county_name": "Knox",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29105,
	  "county_name": "Laclede",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29107,
	  "county_name": "Lafayette",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29109,
	  "county_name": "Lawrence",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29111,
	  "county_name": "Lewis",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29113,
	  "county_name": "Lincoln",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29115,
	  "county_name": "Linn",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29117,
	  "county_name": "Livingston",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29119,
	  "county_name": "McDonald",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29121,
	  "county_name": "Macon",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29123,
	  "county_name": "Madison",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29125,
	  "county_name": "Maries",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29127,
	  "county_name": "Marion",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29129,
	  "county_name": "Mercer",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29131,
	  "county_name": "Miller",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29133,
	  "county_name": "Mississippi",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29135,
	  "county_name": "Moniteau",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29137,
	  "county_name": "Monroe",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29139,
	  "county_name": "Montgomery",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29141,
	  "county_name": "Morgan",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29143,
	  "county_name": "New Madrid",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29145,
	  "county_name": "Newton",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29147,
	  "county_name": "Nodaway",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29149,
	  "county_name": "Oregon",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29151,
	  "county_name": "Osage",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29153,
	  "county_name": "Ozark",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29155,
	  "county_name": "Pemiscot",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29157,
	  "county_name": "Perry",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29159,
	  "county_name": "Pettis",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29161,
	  "county_name": "Phelps",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29163,
	  "county_name": "Pike",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29165,
	  "county_name": "Platte",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29167,
	  "county_name": "Polk",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29169,
	  "county_name": "Pulaski",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29171,
	  "county_name": "Putnam",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29173,
	  "county_name": "Ralls",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29175,
	  "county_name": "Randolph",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29177,
	  "county_name": "Ray",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29179,
	  "county_name": "Reynolds",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29181,
	  "county_name": "Ripley",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29183,
	  "county_name": "St. Charles",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29185,
	  "county_name": "St. Clair",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29186,
	  "county_name": "Ste. Genevieve",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29187,
	  "county_name": "St. Francois",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29189,
	  "county_name": "St. Louis",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29195,
	  "county_name": "Saline",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29197,
	  "county_name": "Schuyler",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29199,
	  "county_name": "Scotland",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29201,
	  "county_name": "Scott",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29203,
	  "county_name": "Shannon",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29205,
	  "county_name": "Shelby",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29207,
	  "county_name": "Stoddard",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29209,
	  "county_name": "Stone",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29211,
	  "county_name": "Sullivan",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29213,
	  "county_name": "Taney",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29215,
	  "county_name": "Texas",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29217,
	  "county_name": "Vernon",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29219,
	  "county_name": "Warren",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29221,
	  "county_name": "Washington",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29223,
	  "county_name": "Wayne",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29225,
	  "county_name": "Webster",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29227,
	  "county_name": "Worth",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29229,
	  "county_name": "Wright",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 29510,
	  "county_name": "St. Louis city",
	  "state": "MO",
	  "state_name": "Missouri"
	}, {
	  "fip": 30001,
	  "county_name": "Beaverhead",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30003,
	  "county_name": "Big Horn",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30005,
	  "county_name": "Blaine",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30007,
	  "county_name": "Broadwater",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30009,
	  "county_name": "Carbon",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30011,
	  "county_name": "Carter",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30013,
	  "county_name": "Cascade",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30015,
	  "county_name": "Chouteau",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30017,
	  "county_name": "Custer",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30019,
	  "county_name": "Daniels",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30021,
	  "county_name": "Dawson",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30023,
	  "county_name": "Deer Lodge",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30025,
	  "county_name": "Fallon",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30027,
	  "county_name": "Fergus",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30029,
	  "county_name": "Flathead",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30031,
	  "county_name": "Gallatin",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30033,
	  "county_name": "Garfield",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30035,
	  "county_name": "Glacier",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30037,
	  "county_name": "Golden Valley",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30039,
	  "county_name": "Granite",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30041,
	  "county_name": "Hill",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30043,
	  "county_name": "Jefferson",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30045,
	  "county_name": "Judith Basin",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30047,
	  "county_name": "Lake",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30049,
	  "county_name": "Lewis and Clark",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30051,
	  "county_name": "Liberty",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30053,
	  "county_name": "Lincoln",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30055,
	  "county_name": "McCone",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30057,
	  "county_name": "Madison",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30059,
	  "county_name": "Meagher",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30061,
	  "county_name": "Mineral",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30063,
	  "county_name": "Missoula",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30065,
	  "county_name": "Musselshell",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30067,
	  "county_name": "Park",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30069,
	  "county_name": "Petroleum",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30071,
	  "county_name": "Phillips",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30073,
	  "county_name": "Pondera",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30075,
	  "county_name": "Powder River",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30077,
	  "county_name": "Powell",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30079,
	  "county_name": "Prairie",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30081,
	  "county_name": "Ravalli",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30083,
	  "county_name": "Richland",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30085,
	  "county_name": "Roosevelt",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30087,
	  "county_name": "Rosebud",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30089,
	  "county_name": "Sanders",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30091,
	  "county_name": "Sheridan",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30093,
	  "county_name": "Silver Bow",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30095,
	  "county_name": "Stillwater",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30097,
	  "county_name": "Sweet Grass",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30099,
	  "county_name": "Teton",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30101,
	  "county_name": "Toole",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30103,
	  "county_name": "Treasure",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30105,
	  "county_name": "Valley",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30107,
	  "county_name": "Wheatland",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30109,
	  "county_name": "Wibaux",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 30111,
	  "county_name": "Yellowstone",
	  "state": "MT",
	  "state_name": "Montana"
	}, {
	  "fip": 31001,
	  "county_name": "Adams",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31003,
	  "county_name": "Antelope",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31005,
	  "county_name": "Arthur",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31007,
	  "county_name": "Banner",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31009,
	  "county_name": "Blaine",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31011,
	  "county_name": "Boone",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31013,
	  "county_name": "Box Butte",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31015,
	  "county_name": "Boyd",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31017,
	  "county_name": "Brown",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31019,
	  "county_name": "Buffalo",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31021,
	  "county_name": "Burt",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31023,
	  "county_name": "Butler",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31025,
	  "county_name": "Cass",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31027,
	  "county_name": "Cedar",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31029,
	  "county_name": "Chase",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31031,
	  "county_name": "Cherry",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31033,
	  "county_name": "Cheyenne",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31035,
	  "county_name": "Clay",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31037,
	  "county_name": "Colfax",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31039,
	  "county_name": "Cuming",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31041,
	  "county_name": "Custer",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31043,
	  "county_name": "Dakota",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31045,
	  "county_name": "Dawes",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31047,
	  "county_name": "Dawson",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31049,
	  "county_name": "Deuel",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31051,
	  "county_name": "Dixon",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31053,
	  "county_name": "Dodge",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31055,
	  "county_name": "Douglas",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31057,
	  "county_name": "Dundy",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31059,
	  "county_name": "Fillmore",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31061,
	  "county_name": "Franklin",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31063,
	  "county_name": "Frontier",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31065,
	  "county_name": "Furnas",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31067,
	  "county_name": "Gage",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31069,
	  "county_name": "Garden",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31071,
	  "county_name": "Garfield",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31073,
	  "county_name": "Gosper",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31075,
	  "county_name": "Grant",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31077,
	  "county_name": "Greeley",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31079,
	  "county_name": "Hall",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31081,
	  "county_name": "Hamilton",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31083,
	  "county_name": "Harlan",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31085,
	  "county_name": "Hayes",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31087,
	  "county_name": "Hitchcock",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31089,
	  "county_name": "Holt",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31091,
	  "county_name": "Hooker",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31093,
	  "county_name": "Howard",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31095,
	  "county_name": "Jefferson",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31097,
	  "county_name": "Johnson",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31099,
	  "county_name": "Kearney",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31101,
	  "county_name": "Keith",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31103,
	  "county_name": "Keya Paha",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31105,
	  "county_name": "Kimball",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31107,
	  "county_name": "Knox",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31109,
	  "county_name": "Lancaster",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31111,
	  "county_name": "Lincoln",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31113,
	  "county_name": "Logan",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31115,
	  "county_name": "Loup",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31117,
	  "county_name": "McPherson",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31119,
	  "county_name": "Madison",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31121,
	  "county_name": "Merrick",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31123,
	  "county_name": "Morrill",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31125,
	  "county_name": "Nance",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31127,
	  "county_name": "Nemaha",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31129,
	  "county_name": "Nuckolls",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31131,
	  "county_name": "Otoe",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31133,
	  "county_name": "Pawnee",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31135,
	  "county_name": "Perkins",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31137,
	  "county_name": "Phelps",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31139,
	  "county_name": "Pierce",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31141,
	  "county_name": "Platte",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31143,
	  "county_name": "Polk",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31145,
	  "county_name": "Red Willow",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31147,
	  "county_name": "Richardson",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31149,
	  "county_name": "Rock",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31151,
	  "county_name": "Saline",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31153,
	  "county_name": "Sarpy",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31155,
	  "county_name": "Saunders",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31157,
	  "county_name": "Scotts Bluff",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31159,
	  "county_name": "Seward",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31161,
	  "county_name": "Sheridan",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31163,
	  "county_name": "Sherman",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31165,
	  "county_name": "Sioux",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31167,
	  "county_name": "Stanton",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31169,
	  "county_name": "Thayer",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31171,
	  "county_name": "Thomas",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31173,
	  "county_name": "Thurston",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31175,
	  "county_name": "Valley",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31177,
	  "county_name": "Washington",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31179,
	  "county_name": "Wayne",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31181,
	  "county_name": "Webster",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31183,
	  "county_name": "Wheeler",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 31185,
	  "county_name": "York",
	  "state": "NE",
	  "state_name": "Nebraska"
	}, {
	  "fip": 32001,
	  "county_name": "Churchill",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32003,
	  "county_name": "Clark",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32005,
	  "county_name": "Douglas",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32007,
	  "county_name": "Elko",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32009,
	  "county_name": "Esmeralda",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32011,
	  "county_name": "Eureka",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32013,
	  "county_name": "Humboldt",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32015,
	  "county_name": "Lander",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32017,
	  "county_name": "Lincoln",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32019,
	  "county_name": "Lyon",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32021,
	  "county_name": "Mineral",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32023,
	  "county_name": "Nye",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32027,
	  "county_name": "Pershing",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32029,
	  "county_name": "Storey",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32031,
	  "county_name": "Washoe",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32033,
	  "county_name": "White Pine",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 32510,
	  "county_name": "Carson City",
	  "state": "NV",
	  "state_name": "Nevada"
	}, {
	  "fip": 33001,
	  "county_name": "Belknap",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33003,
	  "county_name": "Carroll",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33005,
	  "county_name": "Cheshire",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33007,
	  "county_name": "Coos",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33009,
	  "county_name": "Grafton",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33011,
	  "county_name": "Hillsborough",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33013,
	  "county_name": "Merrimack",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33015,
	  "county_name": "Rockingham",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33017,
	  "county_name": "Strafford",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 33019,
	  "county_name": "Sullivan",
	  "state": "NH",
	  "state_name": "New Hampshire"
	}, {
	  "fip": 34001,
	  "county_name": "Atlantic",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34003,
	  "county_name": "Bergen",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34005,
	  "county_name": "Burlington",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34007,
	  "county_name": "Camden",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34009,
	  "county_name": "Cape May",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34011,
	  "county_name": "Cumberland",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34013,
	  "county_name": "Essex",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34015,
	  "county_name": "Gloucester",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34017,
	  "county_name": "Hudson",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34019,
	  "county_name": "Hunterdon",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34021,
	  "county_name": "Mercer",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34023,
	  "county_name": "Middlesex",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34025,
	  "county_name": "Monmouth",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34027,
	  "county_name": "Morris",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34029,
	  "county_name": "Ocean",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34031,
	  "county_name": "Passaic",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34033,
	  "county_name": "Salem",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34035,
	  "county_name": "Somerset",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34037,
	  "county_name": "Sussex",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34039,
	  "county_name": "Union",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 34041,
	  "county_name": "Warren",
	  "state": "NJ",
	  "state_name": "New Jersey"
	}, {
	  "fip": 35001,
	  "county_name": "Bernalillo",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35003,
	  "county_name": "Catron",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35005,
	  "county_name": "Chaves",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35006,
	  "county_name": "Cibola",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35007,
	  "county_name": "Colfax",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35009,
	  "county_name": "Curry",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35011,
	  "county_name": "De Baca",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35013,
	  "county_name": "Do�a Ana",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35015,
	  "county_name": "Eddy",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35017,
	  "county_name": "Grant",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35019,
	  "county_name": "Guadalupe",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35021,
	  "county_name": "Harding",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35023,
	  "county_name": "Hidalgo",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35025,
	  "county_name": "Lea",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35027,
	  "county_name": "Lincoln",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35028,
	  "county_name": "Los Alamos",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35029,
	  "county_name": "Luna",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35031,
	  "county_name": "McKinley",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35033,
	  "county_name": "Mora",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35035,
	  "county_name": "Otero",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35037,
	  "county_name": "Quay",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35039,
	  "county_name": "Rio Arriba",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35041,
	  "county_name": "Roosevelt",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35043,
	  "county_name": "Sandoval",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35045,
	  "county_name": "San Juan",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35047,
	  "county_name": "San Miguel",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35049,
	  "county_name": "Santa Fe",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35051,
	  "county_name": "Sierra",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35053,
	  "county_name": "Socorro",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35055,
	  "county_name": "Taos",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35057,
	  "county_name": "Torrance",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35059,
	  "county_name": "Union",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 35061,
	  "county_name": "Valencia",
	  "state": "NM",
	  "state_name": "New Mexico"
	}, {
	  "fip": 36001,
	  "county_name": "Albany",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36003,
	  "county_name": "Allegany",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36005,
	  "county_name": "Bronx",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36007,
	  "county_name": "Broome",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36009,
	  "county_name": "Cattaraugus",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36011,
	  "county_name": "Cayuga",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36013,
	  "county_name": "Chautauqua",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36015,
	  "county_name": "Chemung",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36017,
	  "county_name": "Chenango",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36019,
	  "county_name": "Clinton",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36021,
	  "county_name": "Columbia",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36023,
	  "county_name": "Cortland",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36025,
	  "county_name": "Delaware",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36027,
	  "county_name": "Dutchess",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36029,
	  "county_name": "Erie",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36031,
	  "county_name": "Essex",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36033,
	  "county_name": "Franklin",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36035,
	  "county_name": "Fulton",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36037,
	  "county_name": "Genesee",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36039,
	  "county_name": "Greene",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36041,
	  "county_name": "Hamilton",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36043,
	  "county_name": "Herkimer",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36045,
	  "county_name": "Jefferson",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36047,
	  "county_name": "Kings",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36049,
	  "county_name": "Lewis",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36051,
	  "county_name": "Livingston",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36053,
	  "county_name": "Madison",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36055,
	  "county_name": "Monroe",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36057,
	  "county_name": "Montgomery",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36059,
	  "county_name": "Nassau",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36061,
	  "county_name": "New York",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36063,
	  "county_name": "Niagara",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36065,
	  "county_name": "Oneida",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36067,
	  "county_name": "Onondaga",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36069,
	  "county_name": "Ontario",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36071,
	  "county_name": "Orange",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36073,
	  "county_name": "Orleans",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36075,
	  "county_name": "Oswego",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36077,
	  "county_name": "Otsego",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36079,
	  "county_name": "Putnam",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36081,
	  "county_name": "Queens",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36083,
	  "county_name": "Rensselaer",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36085,
	  "county_name": "Richmond",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36087,
	  "county_name": "Rockland",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36089,
	  "county_name": "St. Lawrence",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36091,
	  "county_name": "Saratoga",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36093,
	  "county_name": "Schenectady",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36095,
	  "county_name": "Schoharie",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36097,
	  "county_name": "Schuyler",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36099,
	  "county_name": "Seneca",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36101,
	  "county_name": "Steuben",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36103,
	  "county_name": "Suffolk",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36105,
	  "county_name": "Sullivan",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36107,
	  "county_name": "Tioga",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36109,
	  "county_name": "Tompkins",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36111,
	  "county_name": "Ulster",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36113,
	  "county_name": "Warren",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36115,
	  "county_name": "Washington",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36117,
	  "county_name": "Wayne",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36119,
	  "county_name": "Westchester",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36121,
	  "county_name": "Wyoming",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 36123,
	  "county_name": "Yates",
	  "state": "NY",
	  "state_name": "New York"
	}, {
	  "fip": 37001,
	  "county_name": "Alamance",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37003,
	  "county_name": "Alexander",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37005,
	  "county_name": "Alleghany",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37007,
	  "county_name": "Anson",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37009,
	  "county_name": "Ashe",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37011,
	  "county_name": "Avery",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37013,
	  "county_name": "Beaufort",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37015,
	  "county_name": "Bertie",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37017,
	  "county_name": "Bladen",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37019,
	  "county_name": "Brunswick",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37021,
	  "county_name": "Buncombe",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37023,
	  "county_name": "Burke",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37025,
	  "county_name": "Cabarrus",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37027,
	  "county_name": "Caldwell",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37029,
	  "county_name": "Camden",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37031,
	  "county_name": "Carteret",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37033,
	  "county_name": "Caswell",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37035,
	  "county_name": "Catawba",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37037,
	  "county_name": "Chatham",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37039,
	  "county_name": "Cherokee",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37041,
	  "county_name": "Chowan",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37043,
	  "county_name": "Clay",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37045,
	  "county_name": "Cleveland",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37047,
	  "county_name": "Columbus",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37049,
	  "county_name": "Craven",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37051,
	  "county_name": "Cumberland",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37053,
	  "county_name": "Currituck",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37055,
	  "county_name": "Dare",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37057,
	  "county_name": "Davidson",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37059,
	  "county_name": "Davie",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37061,
	  "county_name": "Duplin",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37063,
	  "county_name": "Durham",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37065,
	  "county_name": "Edgecombe",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37067,
	  "county_name": "Forsyth",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37069,
	  "county_name": "Franklin",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37071,
	  "county_name": "Gaston",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37073,
	  "county_name": "Gates",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37075,
	  "county_name": "Graham",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37077,
	  "county_name": "Granville",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37079,
	  "county_name": "Greene",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37081,
	  "county_name": "Guilford",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37083,
	  "county_name": "Halifax",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37085,
	  "county_name": "Harnett",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37087,
	  "county_name": "Haywood",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37089,
	  "county_name": "Henderson",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37091,
	  "county_name": "Hertford",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37093,
	  "county_name": "Hoke",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37095,
	  "county_name": "Hyde",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37097,
	  "county_name": "Iredell",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37099,
	  "county_name": "Jackson",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37101,
	  "county_name": "Johnston",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37103,
	  "county_name": "Jones",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37105,
	  "county_name": "Lee",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37107,
	  "county_name": "Lenoir",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37109,
	  "county_name": "Lincoln",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37111,
	  "county_name": "McDowell",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37113,
	  "county_name": "Macon",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37115,
	  "county_name": "Madison",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37117,
	  "county_name": "Martin",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37119,
	  "county_name": "Mecklenburg",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37121,
	  "county_name": "Mitchell",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37123,
	  "county_name": "Montgomery",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37125,
	  "county_name": "Moore",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37127,
	  "county_name": "Nash",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37129,
	  "county_name": "New Hanover",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37131,
	  "county_name": "Northampton",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37133,
	  "county_name": "Onslow",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37135,
	  "county_name": "Orange",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37137,
	  "county_name": "Pamlico",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37139,
	  "county_name": "Pasquotank",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37141,
	  "county_name": "Pender",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37143,
	  "county_name": "Perquimans",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37145,
	  "county_name": "Person",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37147,
	  "county_name": "Pitt",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37149,
	  "county_name": "Polk",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37151,
	  "county_name": "Randolph",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37153,
	  "county_name": "Richmond",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37155,
	  "county_name": "Robeson",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37157,
	  "county_name": "Rockingham",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37159,
	  "county_name": "Rowan",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37161,
	  "county_name": "Rutherford",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37163,
	  "county_name": "Sampson",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37165,
	  "county_name": "Scotland",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37167,
	  "county_name": "Stanly",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37169,
	  "county_name": "Stokes",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37171,
	  "county_name": "Surry",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37173,
	  "county_name": "Swain",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37175,
	  "county_name": "Transylvania",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37177,
	  "county_name": "Tyrrell",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37179,
	  "county_name": "Union",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37181,
	  "county_name": "Vance",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37183,
	  "county_name": "Wake",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37185,
	  "county_name": "Warren",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37187,
	  "county_name": "Washington",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37189,
	  "county_name": "Watauga",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37191,
	  "county_name": "Wayne",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37193,
	  "county_name": "Wilkes",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37195,
	  "county_name": "Wilson",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37197,
	  "county_name": "Yadkin",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 37199,
	  "county_name": "Yancey",
	  "state": "NC",
	  "state_name": "North Carolina"
	}, {
	  "fip": 38001,
	  "county_name": "Adams",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38003,
	  "county_name": "Barnes",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38005,
	  "county_name": "Benson",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38007,
	  "county_name": "Billings",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38009,
	  "county_name": "Bottineau",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38011,
	  "county_name": "Bowman",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38013,
	  "county_name": "Burke",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38015,
	  "county_name": "Burleigh",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38017,
	  "county_name": "Cass",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38019,
	  "county_name": "Cavalier",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38021,
	  "county_name": "Dickey",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38023,
	  "county_name": "Divide",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38025,
	  "county_name": "Dunn",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38027,
	  "county_name": "Eddy",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38029,
	  "county_name": "Emmons",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38031,
	  "county_name": "Foster",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38033,
	  "county_name": "Golden Valley",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38035,
	  "county_name": "Grand Forks",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38037,
	  "county_name": "Grant",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38039,
	  "county_name": "Griggs",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38041,
	  "county_name": "Hettinger",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38043,
	  "county_name": "Kidder",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38045,
	  "county_name": "LaMoure",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38047,
	  "county_name": "Logan",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38049,
	  "county_name": "McHenry",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38051,
	  "county_name": "McIntosh",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38053,
	  "county_name": "McKenzie",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38055,
	  "county_name": "McLean",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38057,
	  "county_name": "Mercer",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38059,
	  "county_name": "Morton",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38061,
	  "county_name": "Mountrail",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38063,
	  "county_name": "Nelson",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38065,
	  "county_name": "Oliver",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38067,
	  "county_name": "Pembina",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38069,
	  "county_name": "Pierce",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38071,
	  "county_name": "Ramsey",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38073,
	  "county_name": "Ransom",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38075,
	  "county_name": "Renville",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38077,
	  "county_name": "Richland",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38079,
	  "county_name": "Rolette",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38081,
	  "county_name": "Sargent",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38083,
	  "county_name": "Sheridan",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38085,
	  "county_name": "Sioux",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38087,
	  "county_name": "Slope",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38089,
	  "county_name": "Stark",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38091,
	  "county_name": "Steele",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38093,
	  "county_name": "Stutsman",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38095,
	  "county_name": "Towner",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38097,
	  "county_name": "Traill",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38099,
	  "county_name": "Walsh",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38101,
	  "county_name": "Ward",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38103,
	  "county_name": "Wells",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 38105,
	  "county_name": "Williams",
	  "state": "ND",
	  "state_name": "North Dakota"
	}, {
	  "fip": 39001,
	  "county_name": "Adams",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39003,
	  "county_name": "Allen",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39005,
	  "county_name": "Ashland",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39007,
	  "county_name": "Ashtabula",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39009,
	  "county_name": "Athens",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39011,
	  "county_name": "Auglaize",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39013,
	  "county_name": "Belmont",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39015,
	  "county_name": "Brown",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39017,
	  "county_name": "Butler",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39019,
	  "county_name": "Carroll",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39021,
	  "county_name": "Champaign",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39023,
	  "county_name": "Clark",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39025,
	  "county_name": "Clermont",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39027,
	  "county_name": "Clinton",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39029,
	  "county_name": "Columbiana",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39031,
	  "county_name": "Coshocton",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39033,
	  "county_name": "Crawford",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39035,
	  "county_name": "Cuyahoga",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39037,
	  "county_name": "Darke",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39039,
	  "county_name": "Defiance",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39041,
	  "county_name": "Delaware",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39043,
	  "county_name": "Erie",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39045,
	  "county_name": "Fairfield",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39047,
	  "county_name": "Fayette",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39049,
	  "county_name": "Franklin",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39051,
	  "county_name": "Fulton",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39053,
	  "county_name": "Gallia",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39055,
	  "county_name": "Geauga",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39057,
	  "county_name": "Greene",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39059,
	  "county_name": "Guernsey",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39061,
	  "county_name": "Hamilton",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39063,
	  "county_name": "Hancock",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39065,
	  "county_name": "Hardin",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39067,
	  "county_name": "Harrison",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39069,
	  "county_name": "Henry",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39071,
	  "county_name": "Highland",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39073,
	  "county_name": "Hocking",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39075,
	  "county_name": "Holmes",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39077,
	  "county_name": "Huron",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39079,
	  "county_name": "Jackson",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39081,
	  "county_name": "Jefferson",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39083,
	  "county_name": "Knox",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39085,
	  "county_name": "Lake",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39087,
	  "county_name": "Lawrence",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39089,
	  "county_name": "Licking",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39091,
	  "county_name": "Logan",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39093,
	  "county_name": "Lorain",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39095,
	  "county_name": "Lucas",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39097,
	  "county_name": "Madison",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39099,
	  "county_name": "Mahoning",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39101,
	  "county_name": "Marion",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39103,
	  "county_name": "Medina",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39105,
	  "county_name": "Meigs",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39107,
	  "county_name": "Mercer",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39109,
	  "county_name": "Miami",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39111,
	  "county_name": "Monroe",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39113,
	  "county_name": "Montgomery",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39115,
	  "county_name": "Morgan",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39117,
	  "county_name": "Morrow",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39119,
	  "county_name": "Muskingum",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39121,
	  "county_name": "Noble",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39123,
	  "county_name": "Ottawa",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39125,
	  "county_name": "Paulding",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39127,
	  "county_name": "Perry",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39129,
	  "county_name": "Pickaway",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39131,
	  "county_name": "Pike",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39133,
	  "county_name": "Portage",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39135,
	  "county_name": "Preble",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39137,
	  "county_name": "Putnam",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39139,
	  "county_name": "Richland",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39141,
	  "county_name": "Ross",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39143,
	  "county_name": "Sandusky",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39145,
	  "county_name": "Scioto",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39147,
	  "county_name": "Seneca",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39149,
	  "county_name": "Shelby",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39151,
	  "county_name": "Stark",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39153,
	  "county_name": "Summit",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39155,
	  "county_name": "Trumbull",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39157,
	  "county_name": "Tuscarawas",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39159,
	  "county_name": "Union",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39161,
	  "county_name": "Van Wert",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39163,
	  "county_name": "Vinton",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39165,
	  "county_name": "Warren",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39167,
	  "county_name": "Washington",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39169,
	  "county_name": "Wayne",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39171,
	  "county_name": "Williams",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39173,
	  "county_name": "Wood",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 39175,
	  "county_name": "Wyandot",
	  "state": "OH",
	  "state_name": "Ohio"
	}, {
	  "fip": 40001,
	  "county_name": "Adair",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40003,
	  "county_name": "Alfalfa",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40005,
	  "county_name": "Atoka",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40007,
	  "county_name": "Beaver",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40009,
	  "county_name": "Beckham",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40011,
	  "county_name": "Blaine",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40013,
	  "county_name": "Bryan",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40015,
	  "county_name": "Caddo",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40017,
	  "county_name": "Canadian",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40019,
	  "county_name": "Carter",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40021,
	  "county_name": "Cherokee",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40023,
	  "county_name": "Choctaw",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40025,
	  "county_name": "Cimarron",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40027,
	  "county_name": "Cleveland",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40029,
	  "county_name": "Coal",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40031,
	  "county_name": "Comanche",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40033,
	  "county_name": "Cotton",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40035,
	  "county_name": "Craig",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40037,
	  "county_name": "Creek",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40039,
	  "county_name": "Custer",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40041,
	  "county_name": "Delaware",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40043,
	  "county_name": "Dewey",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40045,
	  "county_name": "Ellis",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40047,
	  "county_name": "Garfield",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40049,
	  "county_name": "Garvin",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40051,
	  "county_name": "Grady",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40053,
	  "county_name": "Grant",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40055,
	  "county_name": "Greer",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40057,
	  "county_name": "Harmon",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40059,
	  "county_name": "Harper",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40061,
	  "county_name": "Haskell",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40063,
	  "county_name": "Hughes",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40065,
	  "county_name": "Jackson",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40067,
	  "county_name": "Jefferson",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40069,
	  "county_name": "Johnston",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40071,
	  "county_name": "Kay",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40073,
	  "county_name": "Kingfisher",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40075,
	  "county_name": "Kiowa",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40077,
	  "county_name": "Latimer",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40079,
	  "county_name": "Le Flore",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40081,
	  "county_name": "Lincoln",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40083,
	  "county_name": "Logan",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40085,
	  "county_name": "Love",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40087,
	  "county_name": "McClain",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40089,
	  "county_name": "McCurtain",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40091,
	  "county_name": "McIntosh",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40093,
	  "county_name": "Major",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40095,
	  "county_name": "Marshall",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40097,
	  "county_name": "Mayes",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40099,
	  "county_name": "Murray",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40101,
	  "county_name": "Muskogee",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40103,
	  "county_name": "Noble",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40105,
	  "county_name": "Nowata",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40107,
	  "county_name": "Okfuskee",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40109,
	  "county_name": "Oklahoma",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40111,
	  "county_name": "Okmulgee",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40113,
	  "county_name": "Osage",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40115,
	  "county_name": "Ottawa",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40117,
	  "county_name": "Pawnee",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40119,
	  "county_name": "Payne",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40121,
	  "county_name": "Pittsburg",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40123,
	  "county_name": "Pontotoc",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40125,
	  "county_name": "Pottawatomie",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40127,
	  "county_name": "Pushmataha",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40129,
	  "county_name": "Roger Mills",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40131,
	  "county_name": "Rogers",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40133,
	  "county_name": "Seminole",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40135,
	  "county_name": "Sequoyah",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40137,
	  "county_name": "Stephens",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40139,
	  "county_name": "Texas",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40141,
	  "county_name": "Tillman",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40143,
	  "county_name": "Tulsa",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40145,
	  "county_name": "Wagoner",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40147,
	  "county_name": "Washington",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40149,
	  "county_name": "Washita",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40151,
	  "county_name": "Woods",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 40153,
	  "county_name": "Woodward",
	  "state": "OK",
	  "state_name": "Oklahoma"
	}, {
	  "fip": 41001,
	  "county_name": "Baker",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41003,
	  "county_name": "Benton",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41005,
	  "county_name": "Clackamas",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41007,
	  "county_name": "Clatsop",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41009,
	  "county_name": "Columbia",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41011,
	  "county_name": "Coos",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41013,
	  "county_name": "Crook",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41015,
	  "county_name": "Curry",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41017,
	  "county_name": "Deschutes",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41019,
	  "county_name": "Douglas",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41021,
	  "county_name": "Gilliam",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41023,
	  "county_name": "Grant",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41025,
	  "county_name": "Harney",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41027,
	  "county_name": "Hood River",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41029,
	  "county_name": "Jackson",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41031,
	  "county_name": "Jefferson",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41033,
	  "county_name": "Josephine",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41035,
	  "county_name": "Klamath",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41037,
	  "county_name": "Lake",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41039,
	  "county_name": "Lane",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41041,
	  "county_name": "Lincoln",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41043,
	  "county_name": "Linn",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41045,
	  "county_name": "Malheur",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41047,
	  "county_name": "Marion",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41049,
	  "county_name": "Morrow",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41051,
	  "county_name": "Multnomah",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41053,
	  "county_name": "Polk",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41055,
	  "county_name": "Sherman",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41057,
	  "county_name": "Tillamook",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41059,
	  "county_name": "Umatilla",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41061,
	  "county_name": "Union",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41063,
	  "county_name": "Wallowa",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41065,
	  "county_name": "Wasco",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41067,
	  "county_name": "Washington",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41069,
	  "county_name": "Wheeler",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 41071,
	  "county_name": "Yamhill",
	  "state": "OR",
	  "state_name": "Oregon"
	}, {
	  "fip": 42001,
	  "county_name": "Adams",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42003,
	  "county_name": "Allegheny",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42005,
	  "county_name": "Armstrong",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42007,
	  "county_name": "Beaver",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42009,
	  "county_name": "Bedford",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42011,
	  "county_name": "Berks",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42013,
	  "county_name": "Blair",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42015,
	  "county_name": "Bradford",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42017,
	  "county_name": "Bucks",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42019,
	  "county_name": "Butler",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42021,
	  "county_name": "Cambria",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42023,
	  "county_name": "Cameron",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42025,
	  "county_name": "Carbon",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42027,
	  "county_name": "Centre",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42029,
	  "county_name": "Chester",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42031,
	  "county_name": "Clarion",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42033,
	  "county_name": "Clearfield",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42035,
	  "county_name": "Clinton",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42037,
	  "county_name": "Columbia",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42039,
	  "county_name": "Crawford",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42041,
	  "county_name": "Cumberland",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42043,
	  "county_name": "Dauphin",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42045,
	  "county_name": "Delaware",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42047,
	  "county_name": "Elk",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42049,
	  "county_name": "Erie",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42051,
	  "county_name": "Fayette",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42053,
	  "county_name": "Forest",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42055,
	  "county_name": "Franklin",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42057,
	  "county_name": "Fulton",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42059,
	  "county_name": "Greene",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42061,
	  "county_name": "Huntingdon",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42063,
	  "county_name": "Indiana",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42065,
	  "county_name": "Jefferson",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42067,
	  "county_name": "Juniata",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42069,
	  "county_name": "Lackawanna",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42071,
	  "county_name": "Lancaster",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42073,
	  "county_name": "Lawrence",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42075,
	  "county_name": "Lebanon",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42077,
	  "county_name": "Lehigh",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42079,
	  "county_name": "Luzerne",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42081,
	  "county_name": "Lycoming",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42083,
	  "county_name": "McKean",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42085,
	  "county_name": "Mercer",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42087,
	  "county_name": "Mifflin",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42089,
	  "county_name": "Monroe",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42091,
	  "county_name": "Montgomery",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42093,
	  "county_name": "Montour",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42095,
	  "county_name": "Northampton",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42097,
	  "county_name": "Northumberland",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42099,
	  "county_name": "Perry",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42101,
	  "county_name": "Philadelphia",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42103,
	  "county_name": "Pike",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42105,
	  "county_name": "Potter",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42107,
	  "county_name": "Schuylkill",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42109,
	  "county_name": "Snyder",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42111,
	  "county_name": "Somerset",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42113,
	  "county_name": "Sullivan",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42115,
	  "county_name": "Susquehanna",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42117,
	  "county_name": "Tioga",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42119,
	  "county_name": "Union",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42121,
	  "county_name": "Venango",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42123,
	  "county_name": "Warren",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42125,
	  "county_name": "Washington",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42127,
	  "county_name": "Wayne",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42129,
	  "county_name": "Westmoreland",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42131,
	  "county_name": "Wyoming",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 42133,
	  "county_name": "York",
	  "state": "PA",
	  "state_name": "Pennsylvania"
	}, {
	  "fip": 44001,
	  "county_name": "Bristol",
	  "state": "RI",
	  "state_name": "Rhode Island"
	}, {
	  "fip": 44003,
	  "county_name": "Kent",
	  "state": "RI",
	  "state_name": "Rhode Island"
	}, {
	  "fip": 44005,
	  "county_name": "Newport",
	  "state": "RI",
	  "state_name": "Rhode Island"
	}, {
	  "fip": 44007,
	  "county_name": "Providence",
	  "state": "RI",
	  "state_name": "Rhode Island"
	}, {
	  "fip": 44009,
	  "county_name": "Washington",
	  "state": "RI",
	  "state_name": "Rhode Island"
	}, {
	  "fip": 45001,
	  "county_name": "Abbeville",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45003,
	  "county_name": "Aiken",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45005,
	  "county_name": "Allendale",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45007,
	  "county_name": "Anderson",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45009,
	  "county_name": "Bamberg",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45011,
	  "county_name": "Barnwell",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45013,
	  "county_name": "Beaufort",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45015,
	  "county_name": "Berkeley",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45017,
	  "county_name": "Calhoun",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45019,
	  "county_name": "Charleston",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45021,
	  "county_name": "Cherokee",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45023,
	  "county_name": "Chester",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45025,
	  "county_name": "Chesterfield",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45027,
	  "county_name": "Clarendon",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45029,
	  "county_name": "Colleton",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45031,
	  "county_name": "Darlington",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45033,
	  "county_name": "Dillon",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45035,
	  "county_name": "Dorchester",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45037,
	  "county_name": "Edgefield",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45039,
	  "county_name": "Fairfield",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45041,
	  "county_name": "Florence",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45043,
	  "county_name": "Georgetown",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45045,
	  "county_name": "Greenville",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45047,
	  "county_name": "Greenwood",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45049,
	  "county_name": "Hampton",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45051,
	  "county_name": "Horry",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45053,
	  "county_name": "Jasper",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45055,
	  "county_name": "Kershaw",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45057,
	  "county_name": "Lancaster",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45059,
	  "county_name": "Laurens",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45061,
	  "county_name": "Lee",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45063,
	  "county_name": "Lexington",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45065,
	  "county_name": "McCormick",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45067,
	  "county_name": "Marion",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45069,
	  "county_name": "Marlboro",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45071,
	  "county_name": "Newberry",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45073,
	  "county_name": "Oconee",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45075,
	  "county_name": "Orangeburg",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45077,
	  "county_name": "Pickens",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45079,
	  "county_name": "Richland",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45081,
	  "county_name": "Saluda",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45083,
	  "county_name": "Spartanburg",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45085,
	  "county_name": "Sumter",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45087,
	  "county_name": "Union",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45089,
	  "county_name": "Williamsburg",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 45091,
	  "county_name": "York",
	  "state": "SC",
	  "state_name": "South Carolina"
	}, {
	  "fip": 46003,
	  "county_name": "Aurora",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46005,
	  "county_name": "Beadle",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46007,
	  "county_name": "Bennett",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46009,
	  "county_name": "Bon Homme",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46011,
	  "county_name": "Brookings",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46013,
	  "county_name": "Brown",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46015,
	  "county_name": "Brule",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46017,
	  "county_name": "Buffalo",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46019,
	  "county_name": "Butte",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46021,
	  "county_name": "Campbell",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46023,
	  "county_name": "Charles Mix",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46025,
	  "county_name": "Clark",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46027,
	  "county_name": "Clay",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46029,
	  "county_name": "Codington",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46031,
	  "county_name": "Corson",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46033,
	  "county_name": "Custer",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46035,
	  "county_name": "Davison",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46037,
	  "county_name": "Day",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46039,
	  "county_name": "Deuel",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46041,
	  "county_name": "Dewey",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46043,
	  "county_name": "Douglas",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46045,
	  "county_name": "Edmunds",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46047,
	  "county_name": "Fall River",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46049,
	  "county_name": "Faulk",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46051,
	  "county_name": "Grant",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46053,
	  "county_name": "Gregory",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46055,
	  "county_name": "Haakon",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46057,
	  "county_name": "Hamlin",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46059,
	  "county_name": "Hand",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46061,
	  "county_name": "Hanson",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46063,
	  "county_name": "Harding",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46065,
	  "county_name": "Hughes",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46067,
	  "county_name": "Hutchinson",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46069,
	  "county_name": "Hyde",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46071,
	  "county_name": "Jackson",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46073,
	  "county_name": "Jerauld",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46075,
	  "county_name": "Jones",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46077,
	  "county_name": "Kingsbury",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46079,
	  "county_name": "Lake",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46081,
	  "county_name": "Lawrence",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46083,
	  "county_name": "Lincoln",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46085,
	  "county_name": "Lyman",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46087,
	  "county_name": "McCook",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46089,
	  "county_name": "McPherson",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46091,
	  "county_name": "Marshall",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46093,
	  "county_name": "Meade",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46095,
	  "county_name": "Mellette",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46097,
	  "county_name": "Miner",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46099,
	  "county_name": "Minnehaha",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46101,
	  "county_name": "Moody",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46102,
	  "county_name": "Oglala Lakota",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46103,
	  "county_name": "Pennington",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46105,
	  "county_name": "Perkins",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46107,
	  "county_name": "Potter",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46109,
	  "county_name": "Roberts",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46111,
	  "county_name": "Sanborn",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46113,
	  "county_name": "Shannon",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46115,
	  "county_name": "Spink",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46117,
	  "county_name": "Stanley",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46119,
	  "county_name": "Sully",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46121,
	  "county_name": "Todd",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46123,
	  "county_name": "Tripp",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46125,
	  "county_name": "Turner",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46127,
	  "county_name": "Union",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46129,
	  "county_name": "Walworth",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46135,
	  "county_name": "Yankton",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 46137,
	  "county_name": "Ziebach",
	  "state": "SD",
	  "state_name": "South Dakota"
	}, {
	  "fip": 47001,
	  "county_name": "Anderson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47003,
	  "county_name": "Bedford",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47005,
	  "county_name": "Benton",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47007,
	  "county_name": "Bledsoe",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47009,
	  "county_name": "Blount",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47011,
	  "county_name": "Bradley",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47013,
	  "county_name": "Campbell",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47015,
	  "county_name": "Cannon",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47017,
	  "county_name": "Carroll",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47019,
	  "county_name": "Carter",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47021,
	  "county_name": "Cheatham",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47023,
	  "county_name": "Chester",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47025,
	  "county_name": "Claiborne",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47027,
	  "county_name": "Clay",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47029,
	  "county_name": "Cocke",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47031,
	  "county_name": "Coffee",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47033,
	  "county_name": "Crockett",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47035,
	  "county_name": "Cumberland",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47037,
	  "county_name": "Davidson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47039,
	  "county_name": "Decatur",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47041,
	  "county_name": "DeKalb",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47043,
	  "county_name": "Dickson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47045,
	  "county_name": "Dyer",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47047,
	  "county_name": "Fayette",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47049,
	  "county_name": "Fentress",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47051,
	  "county_name": "Franklin",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47053,
	  "county_name": "Gibson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47055,
	  "county_name": "Giles",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47057,
	  "county_name": "Grainger",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47059,
	  "county_name": "Greene",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47061,
	  "county_name": "Grundy",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47063,
	  "county_name": "Hamblen",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47065,
	  "county_name": "Hamilton",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47067,
	  "county_name": "Hancock",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47069,
	  "county_name": "Hardeman",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47071,
	  "county_name": "Hardin",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47073,
	  "county_name": "Hawkins",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47075,
	  "county_name": "Haywood",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47077,
	  "county_name": "Henderson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47079,
	  "county_name": "Henry",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47081,
	  "county_name": "Hickman",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47083,
	  "county_name": "Houston",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47085,
	  "county_name": "Humphreys",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47087,
	  "county_name": "Jackson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47089,
	  "county_name": "Jefferson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47091,
	  "county_name": "Johnson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47093,
	  "county_name": "Knox",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47095,
	  "county_name": "Lake",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47097,
	  "county_name": "Lauderdale",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47099,
	  "county_name": "Lawrence",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47101,
	  "county_name": "Lewis",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47103,
	  "county_name": "Lincoln",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47105,
	  "county_name": "Loudon",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47107,
	  "county_name": "McMinn",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47109,
	  "county_name": "McNairy",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47111,
	  "county_name": "Macon",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47113,
	  "county_name": "Madison",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47115,
	  "county_name": "Marion",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47117,
	  "county_name": "Marshall",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47119,
	  "county_name": "Maury",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47121,
	  "county_name": "Meigs",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47123,
	  "county_name": "Monroe",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47125,
	  "county_name": "Montgomery",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47127,
	  "county_name": "Moore",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47129,
	  "county_name": "Morgan",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47131,
	  "county_name": "Obion",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47133,
	  "county_name": "Overton",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47135,
	  "county_name": "Perry",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47137,
	  "county_name": "Pickett",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47139,
	  "county_name": "Polk",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47141,
	  "county_name": "Putnam",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47143,
	  "county_name": "Rhea",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47145,
	  "county_name": "Roane",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47147,
	  "county_name": "Robertson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47149,
	  "county_name": "Rutherford",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47151,
	  "county_name": "Scott",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47153,
	  "county_name": "Sequatchie",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47155,
	  "county_name": "Sevier",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47157,
	  "county_name": "Shelby",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47159,
	  "county_name": "Smith",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47161,
	  "county_name": "Stewart",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47163,
	  "county_name": "Sullivan",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47165,
	  "county_name": "Sumner",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47167,
	  "county_name": "Tipton",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47169,
	  "county_name": "Trousdale",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47171,
	  "county_name": "Unicoi",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47173,
	  "county_name": "Union",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47175,
	  "county_name": "Van Buren",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47177,
	  "county_name": "Warren",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47179,
	  "county_name": "Washington",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47181,
	  "county_name": "Wayne",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47183,
	  "county_name": "Weakley",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47185,
	  "county_name": "White",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47187,
	  "county_name": "Williamson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 47189,
	  "county_name": "Wilson",
	  "state": "TN",
	  "state_name": "Tennessee"
	}, {
	  "fip": 48001,
	  "county_name": "Anderson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48003,
	  "county_name": "Andrews",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48005,
	  "county_name": "Angelina",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48007,
	  "county_name": "Aransas",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48009,
	  "county_name": "Archer",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48011,
	  "county_name": "Armstrong",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48013,
	  "county_name": "Atascosa",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48015,
	  "county_name": "Austin",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48017,
	  "county_name": "Bailey",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48019,
	  "county_name": "Bandera",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48021,
	  "county_name": "Bastrop",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48023,
	  "county_name": "Baylor",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48025,
	  "county_name": "Bee",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48027,
	  "county_name": "Bell",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48029,
	  "county_name": "Bexar",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48031,
	  "county_name": "Blanco",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48033,
	  "county_name": "Borden",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48035,
	  "county_name": "Bosque",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48037,
	  "county_name": "Bowie",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48039,
	  "county_name": "Brazoria",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48041,
	  "county_name": "Brazos",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48043,
	  "county_name": "Brewster",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48045,
	  "county_name": "Briscoe",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48047,
	  "county_name": "Brooks",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48049,
	  "county_name": "Brown",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48051,
	  "county_name": "Burleson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48053,
	  "county_name": "Burnet",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48055,
	  "county_name": "Caldwell",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48057,
	  "county_name": "Calhoun",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48059,
	  "county_name": "Callahan",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48061,
	  "county_name": "Cameron",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48063,
	  "county_name": "Camp",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48065,
	  "county_name": "Carson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48067,
	  "county_name": "Cass",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48069,
	  "county_name": "Castro",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48071,
	  "county_name": "Chambers",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48073,
	  "county_name": "Cherokee",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48075,
	  "county_name": "Childress",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48077,
	  "county_name": "Clay",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48079,
	  "county_name": "Cochran",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48081,
	  "county_name": "Coke",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48083,
	  "county_name": "Coleman",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48085,
	  "county_name": "Collin",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48087,
	  "county_name": "Collingsworth",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48089,
	  "county_name": "Colorado",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48091,
	  "county_name": "Comal",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48093,
	  "county_name": "Comanche",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48095,
	  "county_name": "Concho",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48097,
	  "county_name": "Cooke",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48099,
	  "county_name": "Coryell",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48101,
	  "county_name": "Cottle",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48103,
	  "county_name": "Crane",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48105,
	  "county_name": "Crockett",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48107,
	  "county_name": "Crosby",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48109,
	  "county_name": "Culberson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48111,
	  "county_name": "Dallam",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48113,
	  "county_name": "Dallas",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48115,
	  "county_name": "Dawson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48117,
	  "county_name": "Deaf Smith",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48119,
	  "county_name": "Delta",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48121,
	  "county_name": "Denton",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48123,
	  "county_name": "DeWitt",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48125,
	  "county_name": "Dickens",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48127,
	  "county_name": "Dimmit",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48129,
	  "county_name": "Donley",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48131,
	  "county_name": "Duval",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48133,
	  "county_name": "Eastland",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48135,
	  "county_name": "Ector",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48137,
	  "county_name": "Edwards",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48139,
	  "county_name": "Ellis",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48141,
	  "county_name": "El Paso",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48143,
	  "county_name": "Erath",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48145,
	  "county_name": "Falls",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48147,
	  "county_name": "Fannin",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48149,
	  "county_name": "Fayette",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48151,
	  "county_name": "Fisher",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48153,
	  "county_name": "Floyd",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48155,
	  "county_name": "Foard",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48157,
	  "county_name": "Fort Bend",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48159,
	  "county_name": "Franklin",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48161,
	  "county_name": "Freestone",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48163,
	  "county_name": "Frio",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48165,
	  "county_name": "Gaines",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48167,
	  "county_name": "Galveston",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48169,
	  "county_name": "Garza",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48171,
	  "county_name": "Gillespie",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48173,
	  "county_name": "Glasscock",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48175,
	  "county_name": "Goliad",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48177,
	  "county_name": "Gonzales",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48179,
	  "county_name": "Gray",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48181,
	  "county_name": "Grayson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48183,
	  "county_name": "Gregg",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48185,
	  "county_name": "Grimes",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48187,
	  "county_name": "Guadalupe",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48189,
	  "county_name": "Hale",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48191,
	  "county_name": "Hall",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48193,
	  "county_name": "Hamilton",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48195,
	  "county_name": "Hansford",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48197,
	  "county_name": "Hardeman",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48199,
	  "county_name": "Hardin",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48201,
	  "county_name": "Harris",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48203,
	  "county_name": "Harrison",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48205,
	  "county_name": "Hartley",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48207,
	  "county_name": "Haskell",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48209,
	  "county_name": "Hays",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48211,
	  "county_name": "Hemphill",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48213,
	  "county_name": "Henderson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48215,
	  "county_name": "Hidalgo",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48217,
	  "county_name": "Hill",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48219,
	  "county_name": "Hockley",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48221,
	  "county_name": "Hood",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48223,
	  "county_name": "Hopkins",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48225,
	  "county_name": "Houston",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48227,
	  "county_name": "Howard",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48229,
	  "county_name": "Hudspeth",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48231,
	  "county_name": "Hunt",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48233,
	  "county_name": "Hutchinson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48235,
	  "county_name": "Irion",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48237,
	  "county_name": "Jack",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48239,
	  "county_name": "Jackson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48241,
	  "county_name": "Jasper",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48243,
	  "county_name": "Jeff Davis",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48245,
	  "county_name": "Jefferson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48247,
	  "county_name": "Jim Hogg",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48249,
	  "county_name": "Jim Wells",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48251,
	  "county_name": "Johnson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48253,
	  "county_name": "Jones",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48255,
	  "county_name": "Karnes",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48257,
	  "county_name": "Kaufman",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48259,
	  "county_name": "Kendall",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48261,
	  "county_name": "Kenedy",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48263,
	  "county_name": "Kent",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48265,
	  "county_name": "Kerr",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48267,
	  "county_name": "Kimble",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48269,
	  "county_name": "King",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48271,
	  "county_name": "Kinney",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48273,
	  "county_name": "Kleberg",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48275,
	  "county_name": "Knox",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48277,
	  "county_name": "Lamar",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48279,
	  "county_name": "Lamb",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48281,
	  "county_name": "Lampasas",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48283,
	  "county_name": "La Salle",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48285,
	  "county_name": "Lavaca",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48287,
	  "county_name": "Lee",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48289,
	  "county_name": "Leon",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48291,
	  "county_name": "Liberty",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48293,
	  "county_name": "Limestone",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48295,
	  "county_name": "Lipscomb",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48297,
	  "county_name": "Live Oak",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48299,
	  "county_name": "Llano",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48301,
	  "county_name": "Loving",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48303,
	  "county_name": "Lubbock",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48305,
	  "county_name": "Lynn",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48307,
	  "county_name": "McCulloch",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48309,
	  "county_name": "McLennan",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48311,
	  "county_name": "McMullen",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48313,
	  "county_name": "Madison",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48315,
	  "county_name": "Marion",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48317,
	  "county_name": "Martin",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48319,
	  "county_name": "Mason",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48321,
	  "county_name": "Matagorda",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48323,
	  "county_name": "Maverick",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48325,
	  "county_name": "Medina",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48327,
	  "county_name": "Menard",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48329,
	  "county_name": "Midland",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48331,
	  "county_name": "Milam",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48333,
	  "county_name": "Mills",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48335,
	  "county_name": "Mitchell",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48337,
	  "county_name": "Montague",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48339,
	  "county_name": "Montgomery",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48341,
	  "county_name": "Moore",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48343,
	  "county_name": "Morris",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48345,
	  "county_name": "Motley",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48347,
	  "county_name": "Nacogdoches",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48349,
	  "county_name": "Navarro",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48351,
	  "county_name": "Newton",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48353,
	  "county_name": "Nolan",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48355,
	  "county_name": "Nueces",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48357,
	  "county_name": "Ochiltree",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48359,
	  "county_name": "Oldham",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48361,
	  "county_name": "Orange",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48363,
	  "county_name": "Palo Pinto",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48365,
	  "county_name": "Panola",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48367,
	  "county_name": "Parker",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48369,
	  "county_name": "Parmer",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48371,
	  "county_name": "Pecos",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48373,
	  "county_name": "Polk",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48375,
	  "county_name": "Potter",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48377,
	  "county_name": "Presidio",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48379,
	  "county_name": "Rains",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48381,
	  "county_name": "Randall",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48383,
	  "county_name": "Reagan",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48385,
	  "county_name": "Real",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48387,
	  "county_name": "Red River",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48389,
	  "county_name": "Reeves",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48391,
	  "county_name": "Refugio",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48393,
	  "county_name": "Roberts",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48395,
	  "county_name": "Robertson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48397,
	  "county_name": "Rockwall",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48399,
	  "county_name": "Runnels",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48401,
	  "county_name": "Rusk",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48403,
	  "county_name": "Sabine",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48405,
	  "county_name": "San Augustine",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48407,
	  "county_name": "San Jacinto",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48409,
	  "county_name": "San Patricio",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48411,
	  "county_name": "San Saba",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48413,
	  "county_name": "Schleicher",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48415,
	  "county_name": "Scurry",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48417,
	  "county_name": "Shackelford",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48419,
	  "county_name": "Shelby",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48421,
	  "county_name": "Sherman",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48423,
	  "county_name": "Smith",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48425,
	  "county_name": "Somervell",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48427,
	  "county_name": "Starr",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48429,
	  "county_name": "Stephens",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48431,
	  "county_name": "Sterling",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48433,
	  "county_name": "Stonewall",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48435,
	  "county_name": "Sutton",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48437,
	  "county_name": "Swisher",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48439,
	  "county_name": "Tarrant",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48441,
	  "county_name": "Taylor",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48443,
	  "county_name": "Terrell",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48445,
	  "county_name": "Terry",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48447,
	  "county_name": "Throckmorton",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48449,
	  "county_name": "Titus",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48451,
	  "county_name": "Tom Green",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48453,
	  "county_name": "Travis",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48455,
	  "county_name": "Trinity",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48457,
	  "county_name": "Tyler",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48459,
	  "county_name": "Upshur",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48461,
	  "county_name": "Upton",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48463,
	  "county_name": "Uvalde",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48465,
	  "county_name": "Val Verde",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48467,
	  "county_name": "Van Zandt",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48469,
	  "county_name": "Victoria",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48471,
	  "county_name": "Walker",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48473,
	  "county_name": "Waller",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48475,
	  "county_name": "Ward",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48477,
	  "county_name": "Washington",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48479,
	  "county_name": "Webb",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48481,
	  "county_name": "Wharton",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48483,
	  "county_name": "Wheeler",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48485,
	  "county_name": "Wichita",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48487,
	  "county_name": "Wilbarger",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48489,
	  "county_name": "Willacy",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48491,
	  "county_name": "Williamson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48493,
	  "county_name": "Wilson",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48495,
	  "county_name": "Winkler",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48497,
	  "county_name": "Wise",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48499,
	  "county_name": "Wood",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48501,
	  "county_name": "Yoakum",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48503,
	  "county_name": "Young",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48505,
	  "county_name": "Zapata",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 48507,
	  "county_name": "Zavala",
	  "state": "TX",
	  "state_name": "Texas"
	}, {
	  "fip": 49001,
	  "county_name": "Beaver",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49003,
	  "county_name": "Box Elder",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49005,
	  "county_name": "Cache",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49007,
	  "county_name": "Carbon",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49009,
	  "county_name": "Daggett",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49011,
	  "county_name": "Davis",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49013,
	  "county_name": "Duchesne",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49015,
	  "county_name": "Emery",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49017,
	  "county_name": "Garfield",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49019,
	  "county_name": "Grand",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49021,
	  "county_name": "Iron",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49023,
	  "county_name": "Juab",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49025,
	  "county_name": "Kane",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49027,
	  "county_name": "Millard",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49029,
	  "county_name": "Morgan",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49031,
	  "county_name": "Piute",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49033,
	  "county_name": "Rich",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49035,
	  "county_name": "Salt Lake",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49037,
	  "county_name": "San Juan",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49039,
	  "county_name": "Sanpete",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49041,
	  "county_name": "Sevier",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49043,
	  "county_name": "Summit",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49045,
	  "county_name": "Tooele",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49047,
	  "county_name": "Uintah",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49049,
	  "county_name": "Utah",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49051,
	  "county_name": "Wasatch",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49053,
	  "county_name": "Washington",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49055,
	  "county_name": "Wayne",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 49057,
	  "county_name": "Weber",
	  "state": "UT",
	  "state_name": "Utah"
	}, {
	  "fip": 50001,
	  "county_name": "Addison",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50003,
	  "county_name": "Bennington",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50005,
	  "county_name": "Caledonia",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50007,
	  "county_name": "Chittenden",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50009,
	  "county_name": "Essex",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50011,
	  "county_name": "Franklin",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50013,
	  "county_name": "Grand Isle",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50015,
	  "county_name": "Lamoille",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50017,
	  "county_name": "Orange",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50019,
	  "county_name": "Orleans",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50021,
	  "county_name": "Rutland",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50023,
	  "county_name": "Washington",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50025,
	  "county_name": "Windham",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 50027,
	  "county_name": "Windsor",
	  "state": "VT",
	  "state_name": "Vermont"
	}, {
	  "fip": 51001,
	  "county_name": "Accomack",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51003,
	  "county_name": "Albemarle",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51005,
	  "county_name": "Alleghany",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51007,
	  "county_name": "Amelia",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51009,
	  "county_name": "Amherst",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51011,
	  "county_name": "Appomattox",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51013,
	  "county_name": "Arlington",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51015,
	  "county_name": "Augusta",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51017,
	  "county_name": "Bath",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51019,
	  "county_name": "Bedford",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51021,
	  "county_name": "Bland",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51023,
	  "county_name": "Botetourt",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51025,
	  "county_name": "Brunswick",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51027,
	  "county_name": "Buchanan",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51029,
	  "county_name": "Buckingham",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51031,
	  "county_name": "Campbell",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51033,
	  "county_name": "Caroline",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51035,
	  "county_name": "Carroll",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51036,
	  "county_name": "Charles City",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51037,
	  "county_name": "Charlotte",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51041,
	  "county_name": "Chesterfield",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51043,
	  "county_name": "Clarke",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51045,
	  "county_name": "Craig",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51047,
	  "county_name": "Culpeper",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51049,
	  "county_name": "Cumberland",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51051,
	  "county_name": "Dickenson",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51053,
	  "county_name": "Dinwiddie",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51057,
	  "county_name": "Essex",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51059,
	  "county_name": "Fairfax",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51061,
	  "county_name": "Fauquier",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51063,
	  "county_name": "Floyd",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51065,
	  "county_name": "Fluvanna",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51067,
	  "county_name": "Franklin",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51069,
	  "county_name": "Frederick",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51071,
	  "county_name": "Giles",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51073,
	  "county_name": "Gloucester",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51075,
	  "county_name": "Goochland",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51077,
	  "county_name": "Grayson",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51079,
	  "county_name": "Greene",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51081,
	  "county_name": "Greensville",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51083,
	  "county_name": "Halifax",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51085,
	  "county_name": "Hanover",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51087,
	  "county_name": "Henrico",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51089,
	  "county_name": "Henry",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51091,
	  "county_name": "Highland",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51093,
	  "county_name": "Isle of Wight",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51095,
	  "county_name": "James City",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51097,
	  "county_name": "King and Queen",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51099,
	  "county_name": "King George",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51101,
	  "county_name": "King William",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51103,
	  "county_name": "Lancaster",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51105,
	  "county_name": "Lee",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51107,
	  "county_name": "Loudoun",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51109,
	  "county_name": "Louisa",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51111,
	  "county_name": "Lunenburg",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51113,
	  "county_name": "Madison",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51115,
	  "county_name": "Mathews",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51117,
	  "county_name": "Mecklenburg",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51119,
	  "county_name": "Middlesex",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51121,
	  "county_name": "Montgomery",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51125,
	  "county_name": "Nelson",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51127,
	  "county_name": "New Kent",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51131,
	  "county_name": "Northampton",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51133,
	  "county_name": "Northumberland",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51135,
	  "county_name": "Nottoway",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51137,
	  "county_name": "Orange",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51139,
	  "county_name": "Page",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51141,
	  "county_name": "Patrick",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51143,
	  "county_name": "Pittsylvania",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51145,
	  "county_name": "Powhatan",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51147,
	  "county_name": "Prince Edward",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51149,
	  "county_name": "Prince George",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51153,
	  "county_name": "Prince William",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51155,
	  "county_name": "Pulaski",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51157,
	  "county_name": "Rappahannock",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51159,
	  "county_name": "Richmond",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51161,
	  "county_name": "Roanoke",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51163,
	  "county_name": "Rockbridge",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51165,
	  "county_name": "Rockingham",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51167,
	  "county_name": "Russell",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51169,
	  "county_name": "Scott",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51171,
	  "county_name": "Shenandoah",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51173,
	  "county_name": "Smyth",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51175,
	  "county_name": "Southampton",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51177,
	  "county_name": "Spotsylvania",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51179,
	  "county_name": "Stafford",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51181,
	  "county_name": "Surry",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51183,
	  "county_name": "Sussex",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51185,
	  "county_name": "Tazewell",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51187,
	  "county_name": "Warren",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51191,
	  "county_name": "Washington",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51193,
	  "county_name": "Westmoreland",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51195,
	  "county_name": "Wise",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51197,
	  "county_name": "Wythe",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51199,
	  "county_name": "York",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51510,
	  "county_name": "Alexandria city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51515,
	  "county_name": "Bedford city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51520,
	  "county_name": "Bristol city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51530,
	  "county_name": "Buena Vista city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51540,
	  "county_name": "Charlottesville city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51550,
	  "county_name": "Chesapeake city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51570,
	  "county_name": "Colonial Heights city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51580,
	  "county_name": "Covington city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51590,
	  "county_name": "Danville city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51595,
	  "county_name": "Emporia city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51600,
	  "county_name": "Fairfax city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51610,
	  "county_name": "Falls Church city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51620,
	  "county_name": "Franklin city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51630,
	  "county_name": "Fredericksburg city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51640,
	  "county_name": "Galax city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51650,
	  "county_name": "Hampton city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51660,
	  "county_name": "Harrisonburg city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51670,
	  "county_name": "Hopewell city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51678,
	  "county_name": "Lexington city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51680,
	  "county_name": "Lynchburg city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51683,
	  "county_name": "Manassas city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51685,
	  "county_name": "Manassas Park city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51690,
	  "county_name": "Martinsville city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51700,
	  "county_name": "Newport News city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51710,
	  "county_name": "Norfolk city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51720,
	  "county_name": "Norton city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51730,
	  "county_name": "Petersburg city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51735,
	  "county_name": "Poquoson city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51740,
	  "county_name": "Portsmouth city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51750,
	  "county_name": "Radford city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51760,
	  "county_name": "Richmond city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51770,
	  "county_name": "Roanoke city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51775,
	  "county_name": "Salem city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51790,
	  "county_name": "Staunton city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51800,
	  "county_name": "Suffolk city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51810,
	  "county_name": "Virginia Beach city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51820,
	  "county_name": "Waynesboro city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51830,
	  "county_name": "Williamsburg city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 51840,
	  "county_name": "Winchester city",
	  "state": "VA",
	  "state_name": "Virginia"
	}, {
	  "fip": 53001,
	  "county_name": "Adams",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53003,
	  "county_name": "Asotin",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53005,
	  "county_name": "Benton",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53007,
	  "county_name": "Chelan",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53009,
	  "county_name": "Clallam",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53011,
	  "county_name": "Clark",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53013,
	  "county_name": "Columbia",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53015,
	  "county_name": "Cowlitz",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53017,
	  "county_name": "Douglas",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53019,
	  "county_name": "Ferry",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53021,
	  "county_name": "Franklin",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53023,
	  "county_name": "Garfield",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53025,
	  "county_name": "Grant",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53027,
	  "county_name": "Grays Harbor",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53029,
	  "county_name": "Island",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53031,
	  "county_name": "Jefferson",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53033,
	  "county_name": "King",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53035,
	  "county_name": "Kitsap",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53037,
	  "county_name": "Kittitas",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53039,
	  "county_name": "Klickitat",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53041,
	  "county_name": "Lewis",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53043,
	  "county_name": "Lincoln",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53045,
	  "county_name": "Mason",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53047,
	  "county_name": "Okanogan",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53049,
	  "county_name": "Pacific",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53051,
	  "county_name": "Pend Oreille",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53053,
	  "county_name": "Pierce",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53055,
	  "county_name": "San Juan",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53057,
	  "county_name": "Skagit",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53059,
	  "county_name": "Skamania",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53061,
	  "county_name": "Snohomish",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53063,
	  "county_name": "Spokane",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53065,
	  "county_name": "Stevens",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53067,
	  "county_name": "Thurston",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53069,
	  "county_name": "Wahkiakum",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53071,
	  "county_name": "Walla Walla",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53073,
	  "county_name": "Whatcom",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53075,
	  "county_name": "Whitman",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 53077,
	  "county_name": "Yakima",
	  "state": "WA",
	  "state_name": "Washington"
	}, {
	  "fip": 54001,
	  "county_name": "Barbour",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54003,
	  "county_name": "Berkeley",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54005,
	  "county_name": "Boone",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54007,
	  "county_name": "Braxton",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54009,
	  "county_name": "Brooke",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54011,
	  "county_name": "Cabell",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54013,
	  "county_name": "Calhoun",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54015,
	  "county_name": "Clay",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54017,
	  "county_name": "Doddridge",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54019,
	  "county_name": "Fayette",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54021,
	  "county_name": "Gilmer",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54023,
	  "county_name": "Grant",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54025,
	  "county_name": "Greenbrier",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54027,
	  "county_name": "Hampshire",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54029,
	  "county_name": "Hancock",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54031,
	  "county_name": "Hardy",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54033,
	  "county_name": "Harrison",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54035,
	  "county_name": "Jackson",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54037,
	  "county_name": "Jefferson",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54039,
	  "county_name": "Kanawha",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54041,
	  "county_name": "Lewis",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54043,
	  "county_name": "Lincoln",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54045,
	  "county_name": "Logan",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54047,
	  "county_name": "McDowell",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54049,
	  "county_name": "Marion",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54051,
	  "county_name": "Marshall",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54053,
	  "county_name": "Mason",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54055,
	  "county_name": "Mercer",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54057,
	  "county_name": "Mineral",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54059,
	  "county_name": "Mingo",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54061,
	  "county_name": "Monongalia",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54063,
	  "county_name": "Monroe",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54065,
	  "county_name": "Morgan",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54067,
	  "county_name": "Nicholas",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54069,
	  "county_name": "Ohio",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54071,
	  "county_name": "Pendleton",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54073,
	  "county_name": "Pleasants",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54075,
	  "county_name": "Pocahontas",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54077,
	  "county_name": "Preston",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54079,
	  "county_name": "Putnam",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54081,
	  "county_name": "Raleigh",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54083,
	  "county_name": "Randolph",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54085,
	  "county_name": "Ritchie",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54087,
	  "county_name": "Roane",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54089,
	  "county_name": "Summers",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54091,
	  "county_name": "Taylor",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54093,
	  "county_name": "Tucker",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54095,
	  "county_name": "Tyler",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54097,
	  "county_name": "Upshur",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54099,
	  "county_name": "Wayne",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54101,
	  "county_name": "Webster",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54103,
	  "county_name": "Wetzel",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54105,
	  "county_name": "Wirt",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54107,
	  "county_name": "Wood",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 54109,
	  "county_name": "Wyoming",
	  "state": "WV",
	  "state_name": "West Virginia"
	}, {
	  "fip": 55001,
	  "county_name": "Adams",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55003,
	  "county_name": "Ashland",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55005,
	  "county_name": "Barron",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55007,
	  "county_name": "Bayfield",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55009,
	  "county_name": "Brown",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55011,
	  "county_name": "Buffalo",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55013,
	  "county_name": "Burnett",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55015,
	  "county_name": "Calumet",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55017,
	  "county_name": "Chippewa",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55019,
	  "county_name": "Clark",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55021,
	  "county_name": "Columbia",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55023,
	  "county_name": "Crawford",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55025,
	  "county_name": "Dane",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55027,
	  "county_name": "Dodge",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55029,
	  "county_name": "Door",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55031,
	  "county_name": "Douglas",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55033,
	  "county_name": "Dunn",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55035,
	  "county_name": "Eau Claire",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55037,
	  "county_name": "Florence",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55039,
	  "county_name": "Fond du Lac",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55041,
	  "county_name": "Forest",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55043,
	  "county_name": "Grant",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55045,
	  "county_name": "Green",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55047,
	  "county_name": "Green Lake",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55049,
	  "county_name": "Iowa",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55051,
	  "county_name": "Iron",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55053,
	  "county_name": "Jackson",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55055,
	  "county_name": "Jefferson",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55057,
	  "county_name": "Juneau",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55059,
	  "county_name": "Kenosha",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55061,
	  "county_name": "Kewaunee",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55063,
	  "county_name": "La Crosse",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55065,
	  "county_name": "Lafayette",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55067,
	  "county_name": "Langlade",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55069,
	  "county_name": "Lincoln",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55071,
	  "county_name": "Manitowoc",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55073,
	  "county_name": "Marathon",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55075,
	  "county_name": "Marinette",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55077,
	  "county_name": "Marquette",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55078,
	  "county_name": "Menominee",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55079,
	  "county_name": "Milwaukee",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55081,
	  "county_name": "Monroe",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55083,
	  "county_name": "Oconto",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55085,
	  "county_name": "Oneida",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55087,
	  "county_name": "Outagamie",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55089,
	  "county_name": "Ozaukee",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55091,
	  "county_name": "Pepin",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55093,
	  "county_name": "Pierce",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55095,
	  "county_name": "Polk",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55097,
	  "county_name": "Portage",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55099,
	  "county_name": "Price",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55101,
	  "county_name": "Racine",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55103,
	  "county_name": "Richland",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55105,
	  "county_name": "Rock",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55107,
	  "county_name": "Rusk",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55109,
	  "county_name": "St. Croix",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55111,
	  "county_name": "Sauk",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55113,
	  "county_name": "Sawyer",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55115,
	  "county_name": "Shawano",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55117,
	  "county_name": "Sheboygan",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55119,
	  "county_name": "Taylor",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55121,
	  "county_name": "Trempealeau",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55123,
	  "county_name": "Vernon",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55125,
	  "county_name": "Vilas",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55127,
	  "county_name": "Walworth",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55129,
	  "county_name": "Washburn",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55131,
	  "county_name": "Washington",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55133,
	  "county_name": "Waukesha",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55135,
	  "county_name": "Waupaca",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55137,
	  "county_name": "Waushara",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55139,
	  "county_name": "Winnebago",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 55141,
	  "county_name": "Wood",
	  "state": "WI",
	  "state_name": "Wisconsin"
	}, {
	  "fip": 56001,
	  "county_name": "Albany",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56003,
	  "county_name": "Big Horn",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56005,
	  "county_name": "Campbell",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56007,
	  "county_name": "Carbon",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56009,
	  "county_name": "Converse",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56011,
	  "county_name": "Crook",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56013,
	  "county_name": "Fremont",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56015,
	  "county_name": "Goshen",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56017,
	  "county_name": "Hot Springs",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56019,
	  "county_name": "Johnson",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56021,
	  "county_name": "Laramie",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56023,
	  "county_name": "Lincoln",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56025,
	  "county_name": "Natrona",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56027,
	  "county_name": "Niobrara",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56029,
	  "county_name": "Park",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56031,
	  "county_name": "Platte",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56033,
	  "county_name": "Sheridan",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56035,
	  "county_name": "Sublette",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56037,
	  "county_name": "Sweetwater",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56039,
	  "county_name": "Teton",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56041,
	  "county_name": "Uinta",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56043,
	  "county_name": "Washakie",
	  "state": "WY",
	  "state_name": "Wyoming"
	}, {
	  "fip": 56045,
	  "county_name": "Weston",
	  "state": "WY",
	  "state_name": "Wyoming"
	}];
	
	exports.default = Counties.map(function (a) {
	  var label = a.county_name + ', ' + a.state;
	  var value = (a.fip < 10000 ? '0' : '') + String(a.fip);
	  var state = a.state;
	  return { value: value, label: label, state: state };
	});

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-top: 20px;\n    }\n'], ['\n    ', ' {\n        text-align:center;\n    }\n    ', ' {\n        margin-top: 20px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    ', ' {\n        display:none;\n    }\n\n    ', ' {\n        display:block;\n    }\n'], ['\n    ', ' {\n        display:none;\n    }\n\n    ', ' {\n        display:block;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    .control-label { text-align:center; }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { margin-top: 20px; }\n    }\n\n'], ['\n    .control-label { text-align:center; }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { padding-bottom: 5px; }\n    }\n    ', ' {\n        .radio, .radio-inline { margin-top: 20px; }\n    }\n\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	var _datePicker = __webpack_require__(471);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _useMarketNews2 = __webpack_require__(139);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	var _searchCounty = __webpack_require__(961);
	
	var _searchCounty2 = _interopRequireDefault(_searchCounty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var isModal = _ref.isModal;
	
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        customSearchType = _useMarketNews.customSearchType,
	        setCustomSearchType = _useMarketNews.setCustomSearchType,
	        customKeyword = _useMarketNews.customKeyword,
	        setCustomKeyword = _useMarketNews.setCustomKeyword,
	        customCusip = _useMarketNews.customCusip,
	        setCustomCusip = _useMarketNews.setCustomCusip,
	        customPurpose = _useMarketNews.customPurpose,
	        setCustomPurpose = _useMarketNews.setCustomPurpose,
	        customState = _useMarketNews.customState,
	        setCustomState = _useMarketNews.setCustomState,
	        customCity = _useMarketNews.customCity,
	        setCustomCity = _useMarketNews.setCustomCity;
	
	    var isKeyword = customSearchType === 'keyword';
	    var id = (0, _twd.getId)();
	
	    _react2.default.useEffect(function () {
	        var _id = id + '-search-type-' + (isKeyword ? 'keyword' : 'cusip');
	        var el = document.getElementById(_id);
	
	        if (!el) return;
	        el.checked = true;
	    });
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'vertical-offset-xs',
	                style: {
	                    padding: '10px',
	                    backgroundColor: "#f6f6f6"
	                } },
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-lg-9 col-md-10 col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row', css: formCss },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-5' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'radio radio-inline' },
	                                (0, _core.jsx)('input', { type: 'radio',
	                                    id: id + '-search-type-cusip',
	                                    name: 'corporates-market-news-custom-search-type',
	                                    defaultChecked: !isKeyword,
	                                    onChange: function onChange() {
	                                        setCustomSearchType('cusip');
	                                    }
	                                }),
	                                (0, _core.jsx)(
	                                    'label',
	                                    { htmlFor: id + '-search-type-cusip' },
	                                    'Issuer/CUSIP'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'radio radio-inline' },
	                                (0, _core.jsx)('input', { type: 'radio',
	                                    id: id + '-search-type-keyword',
	                                    name: 'corporates-market-news-custom-search-type',
	                                    defaultChecked: isKeyword,
	                                    onChange: function onChange() {
	                                        setCustomSearchType('keyword');
	                                    }
	                                }),
	                                (0, _core.jsx)(
	                                    'label',
	                                    { htmlFor: id + '-search-type-keyword' },
	                                    'Keyword'
	                                )
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-7' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'row' },
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'form-group col-md-5', style: { marginBottom: 0 } },
	                                    isKeyword ? (0, _core.jsx)(
	                                        _react2.default.Fragment,
	                                        null,
	                                        (0, _core.jsx)(
	                                            'label',
	                                            { htmlFor: id + '-search-keyword' },
	                                            'Keyword'
	                                        ),
	                                        (0, _core.jsx)('input', {
	                                            type: 'text',
	                                            id: id + '-keyword-input',
	                                            className: 'form-control',
	                                            value: customKeyword,
	                                            onChange: function onChange(e) {
	                                                setCustomKeyword(e.target.value);
	                                            }
	                                        })
	                                    ) : (0, _core.jsx)(
	                                        _react2.default.Fragment,
	                                        null,
	                                        (0, _core.jsx)(
	                                            'label',
	                                            { htmlFor: id + '-search-cusip' },
	                                            'Issuer/CUSIP'
	                                        ),
	                                        (0, _core.jsx)(_twd.Fields.SearchCusip, {
	                                            id: id + '-search-cusip',
	                                            dataName: 'municipals-market-news-search-cusip',
	                                            value: customCusip,
	                                            onSelect: function onSelect(a) {
	                                                return setCustomCusip(a.value);
	                                            },
	                                            onClear: function onClear() {
	                                                return setCustomCusip('');
	                                            },
	                                            filter: function filter(a) {
	                                                return a.type === 'M';
	                                            },
	                                            map: function map(a) {
	                                                return { value: a.cusip, label: a.cusip + ' - ' + a.issue };
	                                            },
	                                            showIcon: true,
	                                            className: 'form-control vertical-offset-xxs'
	                                        })
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'label',
	                                    { className: 'control-label col-md-1 col-xs-12',
	                                        css: labelCss },
	                                    'or'
	                                ),
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'col-md-5 col-xs-12' },
	                                    (0, _core.jsx)(_twd.Fields.SelectMulti, {
	                                        dataName: 'municipals-market-news-search-purpose',
	                                        label: 'Purpose',
	                                        style: { marginBottom: 0 },
	                                        showSelectAll: true,
	                                        options: BITVORE_PURPOSES,
	                                        values: customPurpose,
	                                        listConfig: { style: { minWidth: '240px' } },
	                                        onSelect: function onSelect(a) {
	                                            if (a.value === '*') {
	                                                var isAll = customPurpose.length === BITVORE_PURPOSES.length;
	                                                var _arr = isAll ? [] : BITVORE_PURPOSES.map(function (a) {
	                                                    return a.value;
	                                                });
	                                                setCustomPurpose(_arr);
	                                                return;
	                                            }
	
	                                            var arr = (0, _twd.arrayToggle)(customPurpose, a.value);
	                                            setCustomPurpose([].concat(arr));
	                                        } })
	                                )
	                            )
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-lg-3 col-md-2 col-xs-12' },
	                    (0, _core.jsx)(_datePicker2.default, {
	                        dataName: 'municipals-market-news-search-data-range',
	                        type: 'custom',
	                        size: 10,
	                        style: { marginBottom: 0 } })
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-lg-9 col-md-10 col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'form-group col-md-5', style: { marginBottom: 0 } },
	                            (0, _core.jsx)(
	                                'label',
	                                null,
	                                'Location'
	                            ),
	                            (0, _core.jsx)(_twd.Fields.Select, {
	                                dataName: 'municipals-market-news-search-state',
	                                placeholder: 'State',
	                                value: customState,
	                                options: BITVORE_STATES,
	                                onChange: function onChange(a) {
	                                    var s = a.target.value;
	                                    setCustomState(s);
	                                } })
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-7 col-xs-12' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'row' },
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'form-group col-md-5', style: { marginBottom: 0 } },
	                                    (0, _core.jsx)(
	                                        'label',
	                                        { htmlFor: id + '-search-county' },
	                                        'County'
	                                    ),
	                                    (0, _core.jsx)(_searchCounty2.default, {
	                                        id: id + '-search-county'
	                                    })
	                                ),
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'col-md-1', css: separatorCss },
	                                    '\xA0'
	                                ),
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'form-group col-md-5', style: { marginBottom: 0 } },
	                                    (0, _core.jsx)(
	                                        'label',
	                                        { htmlFor: id + '-search-city' },
	                                        'City'
	                                    ),
	                                    (0, _core.jsx)('input', {
	                                        type: 'text',
	                                        id: id + '-search-city',
	                                        'data-name': 'municipals-market-news-search-city',
	                                        value: customCity,
	                                        className: 'form-control vertical-offset-xxs',
	                                        onChange: function onChange(a) {
	                                            setCustomCity(a.target.value);
	                                        }
	                                    })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var labelCss = (0, _core.css)(_templateObject, _twd.mediaQueries.xs, _twd.mediaQueries.notXs);
	
	var separatorCss = (0, _core.css)(_templateObject2, _twd.mediaQueries.xs, _twd.mediaQueries.notXs);
	
	var formCss = (0, _core.css)(_templateObject3, _twd.mediaQueries.xs, _twd.mediaQueries.sm, _twd.mediaQueries.sm, _twd.mediaQueries.notXs);
	
	var BITVORE_PURPOSES = [{ label: 'Development', value: 'Development' }, { label: 'Education', value: 'Education' }, { label: 'Higher Education', value: 'HigherEducation' }, { label: 'Primary Secondary Education', value: 'PrimarySecondaryEducation' }, { label: 'Health', value: 'Health' }, { label: 'Housing', value: 'Housing' }, { label: 'Local Government', value: 'LocalGov' }, { label: 'Tax Revenue', value: 'TaxRevenue' }, { label: 'Transportation', value: 'Transportation' }, { label: 'Utility', value: 'Utility' }];
	
	var BITVORE_STATES = [{ label: 'Any State', value: ' ' }].concat(_twd.MUNI_STATES.map(function (a) {
	    return Object.assign({}, a, { value: a.value.split('=')[1] });
	}));

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _counties = __webpack_require__(959);
	
	var _counties2 = _interopRequireDefault(_counties);
	
	var _useMarketNews2 = __webpack_require__(139);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var COUNTY_NAMES = _counties2.default.reduce(function (x, a) {
	    x[a.value] = a.label;
	    return x;
	}, {});
	
	exports.default = function (_ref) {
	    var id = _ref.id;
	
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        customState = _useMarketNews.customState,
	        customCounty = _useMarketNews.customCounty,
	        setCustomCounty = _useMarketNews.setCustomCounty;
	
	    var id_ = id || (0, _twd.getId)();
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Fields.Search,
	            {
	                id: id_,
	                dataName: 'municipals-market-news-search-county',
	                multiple: false,
	                showIcon: false,
	                listConfig: { style: { minWidth: '200px' } },
	                value: COUNTY_NAMES[customCounty] || '',
	                onSelect: function onSelect(a) {
	                    setCustomCounty(a.value);
	                },
	                onClear: function onClear() {
	                    setCustomCounty('');
	                }
	            },
	            function (_ref2) {
	                var keyword = _ref2.keyword;
	
	                return _react2.default.createElement(Options, { keyword: keyword, state: customState });
	            }
	        )
	    );
	};
	
	var Options = function Options(_ref3) {
	    var keyword = _ref3.keyword,
	        state = _ref3.state;
	
	    var searchResults = getOptions({ keyword: keyword, state: state });
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        searchResults.map(function (a, i) {
	            return _react2.default.createElement('div', {
	                dataName: 'municipals-market-news-search-county-option',
	                key: i,
	                className: 'auto-suggest-menu-item text-truncate',
	                style: { color: "var(--primary-base-color)" },
	                item: a,
	                dangerouslySetInnerHTML: {
	                    __html: highlightText(a.label, keyword)
	                } });
	        })
	    );
	};
	
	var highlightText = function highlightText(text, keyword) {
	    var s = ('' + keyword).trim();
	    return s ? text.split(s).join('<b>' + s + '</b>') : text;
	};
	
	var getOptions = function getOptions(_ref4) {
	    var keyword = _ref4.keyword,
	        state = _ref4.state;
	
	    var s = (state || '').trim();
	    return _counties2.default.filter(function (a) {
	        var k = String(keyword).toLowerCase();
	        var f = String(a.value).indexOf(k) >= 0 || a.label.toLowerCase().indexOf(k) >= 0;
	        f = f && (!state || a.state === s);
	        return f;
	    }).sort(function (a, b) {
	        return (0, _twd.compareString)(a.label, b.label);
	    });
	};

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var dateRange = _ref.dateRange,
	        setDateRange = _ref.setDateRange,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'municipals-market-news-date-picker-select' : _ref$dataName,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 6 : _ref$size;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'col-lg-' + (12 - size) + ' col-md-2' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'form-group col-lg-' + size + ' col-md-10', style: { marginBottom: 0 } },
	            _react2.default.createElement(
	                'label',
	                null,
	                'Date Range'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'select-wrapper' },
	                _react2.default.createElement(
	                    'select',
	                    {
	                        className: 'form-control',
	                        'data-name': dataName + '-select',
	                        value: dateRange,
	                        onChange: function onChange(e) {
	                            return setDateRange(e.target.value);
	                        }
	                    },
	                    dateRanges.map(function (a, i) {
	                        return _react2.default.createElement(
	                            'option',
	                            {
	                                'data-name': dataName + '-option',
	                                key: i,
	                                value: a.value },
	                            a.label
	                        );
	                    })
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var dateRanges = [{ value: 'today', label: 'Today' }, { value: 'this_week', label: 'This week' }, { value: 'this_month', label: 'This month' }];

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _searchHolding = __webpack_require__(964);
	
	var _searchHolding2 = _interopRequireDefault(_searchHolding);
	
	var _datePicker = __webpack_require__(471);
	
	var _datePicker2 = _interopRequireDefault(_datePicker);
	
	var _tags = __webpack_require__(965);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _useHoldingSearch2 = __webpack_require__(966);
	
	var _useHoldingSearch3 = _interopRequireDefault(_useHoldingSearch2);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useHoldingSearch = (0, _useHoldingSearch3.default)(),
	        status = _useHoldingSearch.status,
	        error = _useHoldingSearch.error,
	        selected = _useHoldingSearch.selected,
	        setSelected = _useHoldingSearch.setSelected;
	
	    return _react2.default.createElement(
	        _twd.Loading,
	        { status: status, error: error },
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-xs',
	                style: {
	                    padding: '10px',
	                    backgroundColor: "#f6f6f6"
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-7 col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-horizontal' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-group col-md-7', style: { marginBottom: 0 } },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Issuer'
	                            ),
	                            _react2.default.createElement(_searchHolding2.default, { selected: selected, setSelected: setSelected })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-5 col-xs-12' },
	                    _react2.default.createElement(_datePicker2.default, { type: 'holding' })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(_tags2.default, { selected: selected, setSelected: setSelected })
	            )
	        )
	    );
	};

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var state = (0, _twd.getState)('municipals.use-search-holding');
	
	exports.default = function (_ref) {
	    var selected = _ref.selected,
	        setSelected = _ref.setSelected;
	
	    var _React$useState = _react2.default.useState(''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        text = _React$useState2[0],
	        setText = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        searchResults = _React$useState4[0],
	        setSearchResults = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        var a = getHoldings({ text: text, selected: selected });
	        setSearchResults(a);
	    }, [text, selected]);
	
	    var isAll = selected.length === (0, _twd.arrayFrom)(state.value.holdings).length;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Fields.Search,
	            {
	                dataName: 'municipals-market-news-holdings',
	                placeholder: isAll ? 'All' : 'Selected',
	                type: 'select',
	                onSelect: function onSelect(a) {
	                    var arr = a.value === '*' ? isAll ? [] : [].concat(_toConsumableArray(searchResults)) : (0, _twd.arrayToggle)([].concat(_toConsumableArray(selected)), function (b) {
	                        return isEq(a, b);
	                    }, a);
	
	                    setSelected([].concat(_toConsumableArray(arr)));
	                }
	            },
	            function (_ref2) {
	                var text = _ref2.keyword;
	
	                setText(text);
	
	                return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    searchResults.length > 1 && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(
	                            _twd.Fields.SearchOption,
	                            {
	                                dataName: 'municipals-market-news-holding-select-all',
	                                item: { value: '*' } },
	                            _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                                dataName: 'municipals-market-news-holding-select-all-label',
	                                checked: isAll,
	                                label: 'Select all' })
	                        ),
	                        _react2.default.createElement('hr', { 'aria-hidden': 'true' })
	                    ),
	                    searchResults.map(function (a, i) {
	                        return _react2.default.createElement(
	                            _twd.Fields.SearchOption,
	                            {
	                                dataName: 'municipals-market-news-holding',
	                                item: a,
	                                key: i },
	                            _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                                dataName: 'municipals-market-news-holding-label',
	                                checked: a.selected,
	                                label: a.label,
	                                className: 'text-truncate' })
	                        );
	                    })
	                );
	            }
	        )
	    );
	};
	
	var getHoldings = function getHoldings() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$text = _ref3.text,
	        text = _ref3$text === undefined ? '' : _ref3$text,
	        _ref3$selected = _ref3.selected,
	        selected = _ref3$selected === undefined ? [] : _ref3$selected;
	
	    var t = text.toLowerCase();
	    return (0, _twd.arrayFrom)(state.value.holdings).map(function (a) {
	        return Object.assign(Object.assign({}, a), {
	            selected: !!selected.find(function (b) {
	                return isEq(a, b);
	            })
	        });
	    }).filter(function (a) {
	        return !text || a.label.toLowerCase().indexOf(t) >= 0;
	    });
	};
	
	var isEq = function isEq(a, b) {
	    return a.label === b.label;
	};

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var selected = _ref.selected,
	        setSelected = _ref.setSelected;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        selected.length > 0 && selected.map(function (a, i) {
	            return _react2.default.createElement(
	                'button',
	                {
	                    key: i,
	                    'data-name': 'municipals-market-news-holdings-tag',
	                    className: 'tag tag-dismissible',
	                    onClick: function onClick() {
	                        var n = (0, _twd.arrayToggle)(selected, a);
	                        setSelected([].concat(_toConsumableArray(n)));
	                    }
	                },
	                a.label
	            );
	        }),
	        selected.length === 0 && _react2.default.createElement(
	            'div',
	            { className: 'text-muted' },
	            _react2.default.createElement(
	                'p',
	                null,
	                'You have no active municipal bond holdings at this time. Within Holdings Search, existing positions are accessible within the Issuer dropdown - allowing for customized news searches aligned with your municipal holdings.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'For more information on municipal bond investing, please reference the Municipal Bond Resources module.'
	            )
	        )
	    );
	};

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useMarketNews2 = __webpack_require__(139);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('municipals.use-search-holding', {
	    holdings: []
	});
	
	exports.default = function () {
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        selected = _useMarketNews.holdings,
	        setSelected = _useMarketNews.setHoldings;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(''),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        error = _React$useState4[0],
	        setError = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, a, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setError('');
	                            setStatus(_twd.Status.LOADING);
	                            _context.next = 5;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/bitvoreNewsAPIService/getUserHoldingsList',
	                                method: 'POST',
	                                params: {
	                                    invTypes: ['M']
	                                }
	                            });
	
	                        case 5:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            _context.t0 = _twd.arrayFrom;
	                            _context.next = 10;
	                            return data;
	
	                        case 10:
	                            _context.t1 = _context.sent;
	                            a = (0, _context.t0)(_context.t1);
	                            rs = Object.values(a.filter(function (i) {
	                                return i.issue;
	                            }).reduce(function (x, i) {
	                                var d = i.issue;
	                                if (!d || !d.trim()) return x;
	
	                                var n = i.cusip;
	                                if (!x[n]) {
	                                    x[n] = { qty: 0, cusip: n, label: d.trim() };
	                                }
	
	                                x[n].qty += i.qty;
	                                return x;
	                            }, {})).sort(function (a, b) {
	                                return b.qty - a.qty;
	                            }).slice(0, 10).sort(function (a, b) {
	                                if (b.label > a.label) return -1;
	                                if (b.label < a.label) return 1;
	                                return 0;
	                            });
	
	
	                            state.set({ holdings: rs });
	
	                            if ((0, _twd.isEmpty)(selected)) {
	                                setSelected(rs);
	                            }
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 21;
	                            break;
	
	                        case 18:
	                            _context.prev = 18;
	                            _context.t2 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 21:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 18]]);
	        }))();
	    }, []);
	
	    return {
	        selected: selected, setSelected: setSelected,
	        status: status, error: error
	    };
	};

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _marketNews = __webpack_require__(472);
	
	var _marketNews2 = _interopRequireDefault(_marketNews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'municipals-market-news-modal',
	                className: 'modal-dialog',
	                style: {
	                    verticalAlign: 'top',
	                    minWidth: '70%'
	                }
	            },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content',
	                    style: {
	                        background: "#ffffff",
	                        paddingBottom: '0px'
	                    } },
	                _react2.default.createElement(_twd.MinimalNavigation, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement('div', { className: 'col-md-3' }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-6 text-center' },
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'medium-header ' },
	                            'Municipal Market news'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-3' },
	                        _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'close',
	                                'aria-label': 'close',
	                                'data-name': 'municipals-market-news-modal-close-link',
	                                type: 'button',
	                                onClick: _twd.hideModal },
	                            _react2.default.createElement(
	                                'i',
	                                { className: 'material-icons', 'aria-hidden': 'true' },
	                                'close'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(_marketNews2.default, { modal: true })
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _format = __webpack_require__(221);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var modal = _ref.modal,
	        rows = _ref.rows;
	
	
	    var rs = modal ? rows : rows.slice(0, 5);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        rs.map(function (r, i) {
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                { key: i },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xxs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12', style: {
	                                overflow: 'hidden',
	                                textOverflow: 'ellipsis',
	                                display: '-webkit-box',
	                                WebkitBoxOrient: 'vertical',
	                                WebkitLineClamp: '1',
	                                maxHeight: '1.6em',
	                                lineHeight: '1.4em'
	                            } },
	                        _react2.default.createElement(
	                            'a',
	                            { href: r.sourceUrl,
	                                'data-name': 'municipals-market-news-row',
	                                className: 'text-bold',
	                                target: '_blank'
	                            },
	                            r.title
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 vertical-offset-xxs', style: {
	                                overflow: 'hidden',
	                                textOverflow: 'ellipsis',
	                                display: '-webkit-box',
	                                WebkitBoxOrient: 'vertical',
	                                WebkitLineClamp: '2',
	                                maxHeight: '3.0em',
	                                lineHeight: '1.4em'
	                            } },
	                        r.excerpt
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 vertical-offset-xs text-muted' },
	                        (0, _format2.default)(new Date(r.publishedAt), 'EEEE, MMMM dd, yyyy kk:mm a'),
	                        ' - ',
	                        r.sourceName
	                    )
	                )
	            );
	        })
	    );
	};

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useNews2 = __webpack_require__(971);
	
	var _useNews3 = _interopRequireDefault(_useNews2);
	
	var _items = __webpack_require__(968);
	
	var _items2 = _interopRequireDefault(_items);
	
	var _paging = __webpack_require__(970);
	
	var _paging2 = _interopRequireDefault(_paging);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var modal = _ref.modal;
	
	    var _useNews = (0, _useNews3.default)({ modal: modal }),
	        rows = _useNews.rows,
	        status = _useNews.status,
	        error = _useNews.error,
	        page = _useNews.page,
	        setPage = _useNews.setPage,
	        total = _useNews.total;
	
	    var n = (0, _twd.arrayFrom)(rows).length;
	    var isMore = !modal && n > 5;
	
	    return _react2.default.createElement(
	        _twd.Loading,
	        { status: status, error: error },
	        _react2.default.createElement(_items2.default, { rows: rows, modal: modal }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xxs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                isMore && _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'municipals-market-news-more-stories-link',
	                        className: 'text-bold link-button',
	                        onClick: function onClick(e) {
	                            return (0, _twd.showModal)('municipals-market-news-modal', { source: e.target });
	                        } },
	                    'More Stories...'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6 text-right' },
	                _react2.default.createElement(_twd.Disclosures, {
	                    dataName: 'corporates-market-news-disclosures-link',
	                    html: DISCLOSURES })
	            )
	        ),
	        modal && _react2.default.createElement(_paging2.default, { page: page, setPage: setPage, total: total })
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var DISCLOSURES = '\n    Please review <a href="#" style="cursor:pointer"\n    onclick="twd.hideModal();twd.openWindow(\'https://www.lexisnexis.com/en-us/terms/general/default.page\', \'_blank\')">LexisNexis terms and conditions</a>\n    in order to access the full text for LexisNexis licensed articles.\n';

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        page = _ref.page,
	        total = _ref.total,
	        setPage = _ref.setPage;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'row vertical-offset-xxs' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 text-center' },
	            _react2.default.createElement(
	                'div',
	                { className: 'pagination-with-label' },
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'pagination' },
	                    function () {
	                        if (total === 0) return null;
	
	                        var ps = paging({ page: page, total: total });
	
	                        var maxPage = ps[ps.length - 1];
	                        var arr = [];
	
	                        if (page !== 1) arr.push(_react2.default.createElement(
	                            'li',
	                            { key: 0, className: 'previous' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn-link',
	                                    'aria-label': 'previous',
	                                    'data-name': 'municipals-market-news-paging-left',
	                                    onClick: function onClick() {
	                                        return setPage(page - 1);
	                                    } },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'chevron_left'
	                                )
	                            )
	                        ));
	
	                        var _loop = function _loop(i, n) {
	                            var p = ps[i];
	                            var c = p === page;
	                            arr.push(_react2.default.createElement(
	                                'li',
	                                { key: arr.length + 1,
	                                    className: c ? 'active' : '' },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn-link',
	                                        'aria-label': 'page ' + (i + 1),
	                                        'data-name': 'municipals-market-news-paging-page',
	                                        disabled: c, onClick: function onClick() {
	                                            return setPage(p);
	                                        } },
	                                    i === n - 2 && ps[i] + 1 !== ps[i + 1] ? '...' : _twd.fmt.count(p)
	                                )
	                            ));
	                        };
	
	                        for (var i = 0, n = ps.length; i < n; i++) {
	                            _loop(i, n);
	                        }
	
	                        if (page !== maxPage) arr.push(_react2.default.createElement(
	                            'li',
	                            { key: arr.length + 1, className: 'next' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'btn-link',
	                                    'aria-label': 'next',
	                                    'data-name': 'municipals-market-news-paging-right',
	                                    onClick: function onClick() {
	                                        return setPage(page + 1);
	                                    } },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'chevron_right'
	                                )
	                            )
	                        ));
	
	                        return arr;
	                    }()
	                )
	            )
	        )
	    );
	};
	
	var paging = function paging() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$page = _ref2.page,
	        page = _ref2$page === undefined ? 0 : _ref2$page,
	        _ref2$total = _ref2.total,
	        total = _ref2$total === undefined ? 0 : _ref2$total,
	        _ref2$size = _ref2.size,
	        size = _ref2$size === undefined ? 10 : _ref2$size;
	
	    var nPages = Math.ceil(total / size);
	    var pages = [];
	    if (nPages === 0) return pages;
	
	    if (page < 5) {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return i + 1;
	        });
	    } else if (page + 5 >= nPages) {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return nPages - 6 + i;
	        });
	    } else {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return page - 3 + i;
	        });
	    }
	    pages = pages.filter(function (a) {
	        return a < nPages;
	    });
	    pages.push(nPages);
	
	    return pages;
	};

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useBitvore = __webpack_require__(972);
	
	var _useMarketNews2 = __webpack_require__(139);
	
	var _useMarketNews3 = _interopRequireDefault(_useMarketNews2);
	
	var _dateFns = __webpack_require__(396);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var NO_RESULT = 'There are no results that match your search. Please review your search criteria and try again';
	var TIMED_OUT = 'Timed-out';
	
	exports.default = function (_ref) {
	    var modal = _ref.modal;
	
	    var _React$useState = _react2.default.useState([]),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        rows = _React$useState2[0],
	        setRows = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(''),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        error = _React$useState6[0],
	        setError = _React$useState6[1];
	
	    var _useMarketNews = (0, _useMarketNews3.default)(),
	        tab = _useMarketNews.tab,
	        customSearchType = _useMarketNews.customSearchType,
	        customKeyword = _useMarketNews.customKeyword,
	        customCusip = _useMarketNews.customCusip,
	        customPurpose = _useMarketNews.customPurpose,
	        customState = _useMarketNews.customState,
	        customCounty = _useMarketNews.customCounty,
	        customCity = _useMarketNews.customCity,
	        customDate = _useMarketNews.customDate,
	        holdings = _useMarketNews.holdings,
	        holdingDate = _useMarketNews.holdingDate;
	
	    var _React$useState7 = _react2.default.useState(1),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        page = _React$useState8[0],
	        setPage = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(0),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        total = _React$useState10[0],
	        setTotal = _React$useState10[1];
	
	    var timerId = _react2.default.useRef();
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        setPage(1);
	        setTotal(0);
	        setRows([]);
	    }, [tab, customSearchType, customKeyword, customCusip, customPurpose, customState, customCounty, customCity, customDate, holdings, holdingDate]);
	
	    var _React$useState11 = _react2.default.useState(),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        params = _React$useState12[0],
	        setParams = _React$useState12[1];
	
	    _react2.default.useEffect(function () {
	        var p = getParams({
	            modal: modal,
	            page: page,
	            tab: tab,
	            customSearchType: customSearchType,
	            customKeyword: customKeyword,
	            customCusip: customCusip,
	            customPurpose: customPurpose,
	            customState: customState,
	            customCounty: customCounty,
	            customCity: customCity,
	            customDate: customDate,
	
	            holdings: holdings,
	            holdingDate: holdingDate
	        });
	        setParams(p);
	    }, [page, tab, customSearchType, customKeyword, customCusip, customPurpose, customState, customCounty, customCity, customDate, holdings, holdingDate]);
	
	    _react2.default.useEffect(function () {
	        if (timerId.current) {
	            clearInterval(timerId.current);
	            timerId.current = 0;
	        }
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var isTimedOut, auth, _ref3, data, abort, isTO, _ref4, response, _total, f;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setRows([]);
	                            setError('');
	                            setStatus(_twd.Status.LOADING);
	
	                            if (params) {
	                                _context.next = 7;
	                                break;
	                            }
	
	                            setRows([]);
	                            setStatus(_twd.Status.LOADED);
	                            return _context.abrupt('return');
	
	                        case 7:
	                            isTimedOut = void 0;
	                            _context.prev = 8;
	                            _context.next = 11;
	                            return (0, _useBitvore.getAuth)();
	
	                        case 11:
	                            auth = _context.sent;
	
	                            if (auth) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            setStatus(_twd.Status.UNAVAILABLE);
	                            return _context.abrupt('return');
	
	                        case 15:
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 18;
	                            return (0, _twd.ajax)({
	                                url: 'https://api.bitvore.com/muninews',
	                                method: 'POST',
	                                headers: Object.assign({
	                                    'Content-Type': 'application/json',
	                                    'Accept': '*/*'
	                                }, auth),
	                                params: params
	                            });
	
	                        case 18:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            abort = _ref3.abort;
	                            isTO = _ref3.isTimedOut;
	
	                            isTimedOut = isTO;
	                            lastAbort.current = abort;
	                            _context.next = 26;
	                            return data;
	
	                        case 26:
	                            _ref4 = _context.sent;
	                            response = _ref4.response;
	                            _total = _ref4.total;
	
	                            lastAbort.current = null;
	
	                            (0, _twd.publish)('municipals-market-news-unavailable', false);
	
	                            f = !response || !Array.isArray(response) || response.length === 0;
	
	                            if (!f) {
	                                _context.next = 36;
	                                break;
	                            }
	
	                            setError(NO_RESULT);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	                            return _context.abrupt('return');
	
	                        case 36:
	
	                            setRows(response);
	                            setTotal(_total);
	
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 52;
	                            break;
	
	                        case 41:
	                            _context.prev = 41;
	                            _context.t0 = _context['catch'](8);
	
	                            if (!(_context.t0.name === 'SyntaxError')) {
	                                _context.next = 46;
	                                break;
	                            }
	
	                            (0, _twd.publish)('municipals-market-news-unavailable', true);
	                            return _context.abrupt('return');
	
	                        case 46:
	                            if (!(_context.t0.name === 'AbortError')) {
	                                _context.next = 49;
	                                break;
	                            }
	
	                            if (isTimedOut()) {
	                                setError(TIMED_OUT);
	                                setStatus(_twd.Status.FAILED_TO_LOAD);
	                            }
	                            return _context.abrupt('return');
	
	                        case 49:
	
	                            setPage(1);
	                            setTotal(0);
	                            setStatus(_twd.Status.LOADING);
	
	                        case 52:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[8, 41]]);
	        })), 500);
	
	        return function () {
	            if (lastAbort.current) {
	                lastAbort.current();
	            }
	            if (timerId.current) {
	                clearInterval(timerId.current);
	            }
	        };
	    }, [params]);
	
	    return {
	        rows: rows, status: status, error: error,
	        page: page, setPage: setPage,
	        total: total
	    };
	};
	
	var getParams = function getParams(_ref5) {
	    var modal = _ref5.modal,
	        page = _ref5.page,
	        tab = _ref5.tab,
	        customSearchType = _ref5.customSearchType,
	        customKeyword = _ref5.customKeyword,
	        customCusip = _ref5.customCusip,
	        customPurpose = _ref5.customPurpose,
	        customState = _ref5.customState,
	        customCounty = _ref5.customCounty,
	        customCity = _ref5.customCity,
	        customDate = _ref5.customDate,
	        holdings = _ref5.holdings,
	        holdingDate = _ref5.holdingDate;
	
	    var pageNo = modal ? Math.max(page, 1) : 1;
	    var pageSize = modal ? 10 : 6;
	
	    var isCustom = tab === 'CUSTOM';
	    var isHolding = !isCustom;
	
	    var startDate = ymd(getInitialDate(isCustom ? customDate : holdingDate));
	    var endDate = ymd(new Date());
	    var params = {
	        startDate: startDate,
	        endDate: endDate,
	        timezone: 'America/New_York',
	        pageNo: pageNo,
	        pageSize: pageSize
	    };
	
	    if (isCustom && customSearchType === 'cusip' && !(0, _twd.isEmpty)(customCusip)) {
	        params.cusip = (0, _twd.arrayFrom)(customCusip);
	    }
	
	    if (isCustom && customSearchType === 'keyword' && !(0, _twd.isEmpty)(customKeyword)) {
	        params.text = customKeyword;
	    }
	
	    if (isCustom && !(0, _twd.isEmpty)(customPurpose)) {
	        params.sector = customPurpose;
	    }
	
	    var loc = [customCity || '', (customState || '').trim(), ''];
	    if (isCustom && loc.filter(Boolean).length > 0) {
	        params.location = [loc.join('/')];
	    }
	
	    if (isCustom && customCounty) {
	        params.fips = [customCounty];
	        if (!customCity) {
	            delete params.location;
	        }
	    }
	
	    if (isHolding && !(0, _twd.isEmpty)(holdings)) {
	        params.cusip = holdings.map(function (a) {
	            return a.cusip;
	        }).filter(Boolean);
	    }
	
	    if (isHolding && (0, _twd.isEmpty)(holdings)) {
	        return;
	    }
	
	    return params;
	};
	
	var ymd = function ymd(d) {
	    return (0, _dateFns.format)(d, 'yyyy-MM-dd');
	};
	
	var getInitialDate = function getInitialDate(dateType) {
	    var today = new Date();
	    switch (dateType) {
	        case "today":
	            return (0, _dateFns.startOfDay)(today);
	        case "this_month":
	            return (0, _dateFns.addDays)(today, -29);
	        case "last_90_days":
	            return (0, _dateFns.addDays)(today, -90);
	        case "this_year":
	            return (0, _dateFns.startOfYear)(today);
	        case "this_week":
	        default:
	            return (0, _dateFns.addDays)(today, -7);
	    }
	};

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAuth = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	(0, _twd.getState)('municipals.market-news.use-bitvore', {
	    token: '',
	    expired: 0
	});
	
	var getAuth = exports.getAuth = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var state, _state$value, token, expired, now, _ajax, data, a;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	                        state = (0, _twd.getState)('municipals.market-news.use-bitvore');
	                        _state$value = state.value, token = _state$value.token, expired = _state$value.expired;
	                        now = Date.now();
	
	                        if (!(token && expired > now)) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return', { Authorization: 'Bearer ' + token });
	
	                    case 6:
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/retailservice/bitvoreNewsAPIService/getAccessTokenByAPIType',
	                            method: 'POST',
	                            params: { bondType: 'MUNI' }
	                        }), data = _ajax.data;
	                        _context.next = 9;
	                        return data;
	
	                    case 9:
	                        a = _context.sent;
	
	                        if (a.access_token) {
	                            _context.next = 12;
	                            break;
	                        }
	
	                        throw new Error('no access token');
	
	                    case 12:
	
	                        state.set({
	                            token: a.access_token,
	                            expired: now + a.expires_in * 1000
	                        });
	
	                        (0, _twd.publish)('municipals-market-news-unavailable', false);
	
	                        return _context.abrupt('return', { Authorization: 'Bearer ' + state.value.token });
	
	                    case 17:
	                        _context.prev = 17;
	                        _context.t0 = _context['catch'](0);
	
	                        (0, _twd.publish)('municipals-market-news-unavailable', true);
	
	                    case 20:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[0, 17]]);
	    }));
	
	    return function getAuth() {
	        return _ref.apply(this, arguments);
	    };
	}();

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _yieldGrids = __webpack_require__(1001);
	
	var _yieldGrids2 = _interopRequireDefault(_yieldGrids);
	
	var _scatterGraph = __webpack_require__(990);
	
	var _scatterGraph2 = _interopRequireDefault(_scatterGraph);
	
	var _map = __webpack_require__(948);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _marketNews = __webpack_require__(472);
	
	var _marketNews2 = _interopRequireDefault(_marketNews);
	
	var _tickers = __webpack_require__(996);
	
	var _tickers2 = _interopRequireDefault(_tickers);
	
	var _quickScreener = __webpack_require__(975);
	
	var _quickScreener2 = _interopRequireDefault(_quickScreener);
	
	var _resources = __webpack_require__(979);
	
	var _resources2 = _interopRequireDefault(_resources);
	
	var _greenBonds = __webpack_require__(945);
	
	var _greenBonds2 = _interopRequireDefault(_greenBonds);
	
	var _education = __webpack_require__(943);
	
	var _education2 = _interopRequireDefault(_education);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    (0, _twd.trackPage)('municipals');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container', style: { padding: 0 } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(_yieldGrids2.default, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8 col-xs-12' },
	                        _react2.default.createElement(_scatterGraph2.default, null),
	                        _react2.default.createElement(_map2.default, null),
	                        _react2.default.createElement(_marketNews2.default, null),
	                        _react2.default.createElement(_tickers2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-xs-12' },
	                        _react2.default.createElement(_quickScreener2.default, null),
	                        _react2.default.createElement(_resources2.default, null),
	                        _react2.default.createElement(_greenBonds2.default, null),
	                        _react2.default.createElement(_education2.default, null)
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _submitButton = __webpack_require__(976);
	
	var _submitButton2 = _interopRequireDefault(_submitButton);
	
	var _toSearchParams = __webpack_require__(320);
	
	var _useQuickScreener = __webpack_require__(321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	
	var Labels = _twd.Fields.Labels;
	
	
	var getResetValues = function getResetValues(curr) {
	
	    var a = Object.assign({}, curr);
	    var b = Object.assign({}, _useQuickScreener.initialValues);
	
	    if (!(0, _twd.isEquals)(a, b)) {
	        return Object.assign({}, _useQuickScreener.initialValues, {
	            holdSpRatingMin: 'BBB-',
	            holdSpRatingMax: 'AAA',
	            holdMoodyRatingMin: 'Baa3',
	            holdMoodyRatingMax: 'Aaa'
	        });
	    }
	
	    return Object.assign(b, {
	        rating: "all-ratings",
	        holdMoodyRatingMin: "ALL",
	        holdMoodyRatingMax: "ALL",
	        holdSpRatingMin: "ALL",
	        holdSpRatingMax: "ALL",
	        holdMuniTypeG: false,
	        holdMuniTypeR: false,
	        holdTaxableY: false,
	        holdTaxableN: false,
	        states: []
	    });
	};
	
	exports.default = function (_ref) {
	    var handleSubmit = _ref.handleSubmit,
	        values = _ref.values,
	        errors = _ref.errors,
	        resetForm = _ref.resetForm,
	        validateForm = _ref.validateForm;
	
	
	    _react2.default.useEffect(function () {
	        validateForm();
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('municipals_quick_screener_clear_all.municipals_quick_screener_form', function () {
	            resetForm(getResetValues(values));
	            setTimeout(function () {
	                validateForm();
	            });
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, [values]);
	
	    return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, {
	                            label: 'State / Territory',
	                            info: Labels.MuniStates
	                        })
	                    )
	                ),
	                _react2.default.createElement(_formik.FieldArray, {
	                    name: 'states',
	                    render: function render(args) {
	                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                            dataName: 'municipals-quick-screener-state',
	                            showSelectAll: true,
	                            options: _twd.MUNI_STATES_AND_TERRITORIES,
	                            style: { marginBottom: '10px' }
	                        }));
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, {
	                            label: 'Use of proceeds',
	                            info: Labels.MuniPurposes
	                        })
	                    )
	                ),
	                _react2.default.createElement(_formik.FieldArray, {
	                    name: 'purposes',
	                    render: function render(args) {
	                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                            dataName: 'municipals-quick-screener-use-of-proceeds',
	                            showSelectAll: true,
	                            options: _twd.MUNI_PURPOSES,
	                            style: { marginBottom: '10px' }
	                        }));
	                    }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12 col-lg-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Category', info: Labels.MuniCategories })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-general-obligation',
	                            name: 'holdMuniTypeG',
	                            component: _twd.Fields.Checkbox,
	                            label: 'General Obligation'
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-revenue',
	                            name: 'holdMuniTypeR',
	                            component: _twd.Fields.Checkbox,
	                            label: 'Revenue'
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12 col-lg-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Tax Treatment', info: Labels.MuniTaxTreatments })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-tax-exempt',
	                            name: 'holdTaxableN',
	                            component: _twd.Fields.Checkbox,
	                            label: 'Tax-Exempt'
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-taxable',
	                            name: 'holdTaxableY',
	                            component: _twd.Fields.Checkbox,
	                            label: 'Taxable'
	                        })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Maturity Date', info: _twd.Fields.Labels.Maturity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-maturity-date-min',
	                            name: 'holdMaturityMin',
	                            component: _twd.Fields.Maturity,
	                            label: 'Min',
	                            error: errors.holdMaturity
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-maturity-date-max',
	                            name: 'holdMaturityMax',
	                            component: _twd.Fields.Maturity,
	                            label: 'Max',
	                            error: errors.holdMaturity
	                        })
	                    ),
	                    errors.holdMaturity && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.holdMaturity
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Quantity', info: _twd.Fields.Labels.Quantity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-quantity-min',
	                            name: 'quantityMin',
	                            component: _twd.Fields.Quantity,
	                            label: 'Min',
	                            error: errors.quantity
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-quantity-max',
	                            name: 'quantityMax',
	                            component: _twd.Fields.Quantity,
	                            label: 'Max',
	                            error: errors.quantity })
	                    ),
	                    errors.quantity && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.quantity
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Yield', info: _twd.Fields.Labels.Yield })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-yield-min',
	                            name: 'offerYtwMin',
	                            component: _twd.Fields.Yield,
	                            placeholder: '%',
	                            error: errors.offerYtw,
	                            label: 'Min'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-yield-max',
	                            name: 'offerYtwMax',
	                            component: _twd.Fields.Yield,
	                            placeholder: '%',
	                            error: errors.offerYtw,
	                            label: 'Max'
	                        })
	                    ),
	                    errors.offerYtw && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.offerYtw
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Price', info: _twd.Fields.Labels.Price })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-price-min',
	                            name: 'clientPriceMin',
	                            component: _twd.Fields.Price,
	                            placeholder: '$',
	                            error: errors.clientPrice,
	                            label: 'Min'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-price-max',
	                            name: 'clientPriceMax',
	                            component: _twd.Fields.Price,
	                            placeholder: '$',
	                            error: errors.clientPrice,
	                            label: 'Max'
	                        })
	                    ),
	                    errors.clientPrice && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.clientPrice
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, {
	                            id: 'municipals-quick-screener-rating-label',
	                            label: 'Rating', info: _twd.Fields.Labels.Rating })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12 col-md-12' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-rating-investment-grade',
	                            'aria-describedby': 'municipals-quick-screener-rating-label',
	                            name: 'rating',
	                            component: _twd.Fields.Radio,
	                            value: 'investment-grade',
	                            label: 'Investment Grade',
	                            className: 'radio-inline',
	                            onClick: function onClick() {
	                                Object.assign(values, {
	                                    holdSpRatingMin: 'BBB-',
	                                    holdSpRatingMax: 'AAA',
	                                    holdMoodyRatingMin: 'Baa3',
	                                    holdMoodyRatingMax: 'Aaa'
	                                });
	                            } }),
	                        '\xA0 \xA0',
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-rating-high-yield',
	                            'aria-describedby': 'municipals-quick-screener-rating-label',
	                            name: 'rating',
	                            component: _twd.Fields.Radio,
	                            value: 'high-yield',
	                            label: 'High Yield',
	                            className: 'radio-inline',
	                            onClick: function onClick() {
	                                Object.assign(values, {
	                                    holdSpRatingMin: 'C',
	                                    holdSpRatingMax: 'BB+',
	                                    holdMoodyRatingMin: 'C',
	                                    holdMoodyRatingMax: 'Ba1'
	                                });
	                            } }),
	                        '\xA0 \xA0',
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'municipals-quick-screener-raring-all-ratings',
	                            name: 'rating', component: _twd.Fields.Radio,
	                            value: 'all-ratings',
	                            label: 'All ratings',
	                            className: 'radio-inline',
	                            onClick: function onClick() {
	                                Object.assign(values, {
	                                    holdSpRatingMin: 'ALL',
	                                    holdSpRatingMax: 'ALL',
	                                    holdMoodyRatingMin: 'ALL',
	                                    holdMoodyRatingMax: 'ALL'
	                                });
	                            } })
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12 col-lg-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Moody\'s' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'municipals-quick-screener-moodys-credit-rating-min',
	                            name: 'holdMoodyRatingMin',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'moodys',
	                            error: errors.holdMoodyRating,
	                            label: 'Min',
	                            ariaLabel: 'Minimum Moody\'s Rating'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'municipals-quick-screener-moodys-credit-rating-max',
	                            name: 'holdMoodyRatingMax',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'moodys',
	                            error: errors.holdMoodyRating,
	                            label: 'Max',
	                            ariaLabel: 'Maximum Moody\'s Rating'
	                        })
	                    ),
	                    errors.holdMoodyRating && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.holdMoodyRating
	                    ),
	                    _react2.default.createElement(_twd.Dash, { margin: 10 })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12 col-lg-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'S&P' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'municipals-quick-screener-sp-credit-rating-min',
	                            name: 'holdSpRatingMin',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'sp',
	                            error: errors.holdSpRating,
	                            label: 'Min',
	                            ariaLabel: 'Minimum S&ampP Rating'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            dataName: 'municipals-quick-screener-sp-credit-rating-max',
	                            name: 'holdSpRatingMax',
	                            component: _twd.Fields.Rating,
	                            ratingType: 'sp',
	                            error: errors.holdSpRating,
	                            label: 'Max',
	                            ariaLabel: 'Maximum S&ampP Rating'
	                        })
	                    ),
	                    errors.holdSpRating && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.holdSpRating
	                    ),
	                    _react2.default.createElement(_twd.Dash, { margin: 10 })
	                )
	            )
	        ),
	        _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'municipals-quick-screener-credit-ratings-and-or',
	                    name: 'holdRatingAndOr',
	                    component: _twd.Fields.Checkbox,
	                    label: 'Results can match Moody\'s or S&P ratings selection'
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'municipals-quick-screener-exclude-callable',
	                    name: 'holdCallableInd',
	                    component: _twd.Fields.Checkbox,
	                    label: 'Exclude Callable'
	                })
	            )
	        ),
	        _react2.default.createElement('div', { className: 'row vertical-offset-base' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_submitButton2.default, { errors: errors, values: values })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 text-center' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'municipals-quick-screener-advanced-screener',
	                        className: 'btn btn-link',
	                        onClick: function onClick() {
	                            var p = (0, _toSearchParams.toSearchParams)(values);
	                            if (!p.holdState) {
	                                p.holdState = [];
	                            }
	                            p.isEdit = true;
	
	                            (0, _twd.show)('advanced-screener', Object.assign({
	                                searchParams: p,
	                                _ts: Date.now(),
	                                from: 'municipals'
	                            }));
	                        }
	                    },
	                    'Advanced Screener'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _form = __webpack_require__(974);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _formik = __webpack_require__(62);
	
	var _useQuickScreener2 = __webpack_require__(321);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'municipal-quick-screener', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                _useQuickScreener2.ContextProvider,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-8' },
	                        (0, _core.jsx)(
	                            'h3',
	                            { className: 'medium-header' },
	                            'Municipal Quick Screener'
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-4 text-right' },
	                        (0, _core.jsx)(
	                            'button',
	                            {
	                                type: 'button',
	                                'data-name': 'municipals-quick-screener-clear-all',
	                                className: 'link-button',
	                                onClick: function onClick() {
	                                    (0, _twd.publish)('municipals_quick_screener_clear_all', true);
	                                }
	                            },
	                            'Clear All '
	                        )
	                    )
	                ),
	                (0, _core.jsx)(FormMain, null)
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var FormMain = function FormMain() {
	    var _useQuickScreener = (0, _useQuickScreener2.useQuickScreener)(),
	        state = _useQuickScreener.state,
	        onValidate = _useQuickScreener.onValidate,
	        onSubmit = _useQuickScreener.onSubmit;
	
	    var values = state.value.currentValues;
	    if (!values.states) {
	        var defaultState = (0, _twd.getConfig)('account_states.0.stateOfResidence', '');
	        values.states = defaultState ? ['holdState=' + defaultState] : [];
	    }
	
	    return (0, _core.jsx)(_formik.Formik, {
	        initialValues: values,
	        onSubmit: onSubmit,
	        component: _form2.default,
	        validate: onValidate,
	        validateOnBlur: true,
	        validateOnChange: true
	    });
	};

/***/ },
/* 976 */
[2038, 321, 320],
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toSearchParams = __webpack_require__(320);
	
	var _twd = __webpack_require__(2);
	
	exports.default = function (values) {
	    if (!values) return;
	
	    var p = (0, _toSearchParams.toSearchParams)(values);
	    setTimeout(function () {
	        (0, _twd.trackSearch)('Municipal Quick Screener', p);
	    });
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: Object.assign(p, { persistToPreviousSearches: true }),
	        _ts: Date.now(),
	        from: 'municipals'
	    }));
	};

/***/ },
/* 978 */
888,
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _templateObject = _taggedTemplateLiteral(['{\n\n    \'li\': {\n        \'padding-left\': \'10px\'\n    },\n    \'img\': {\n        \'max-width\': \'100%\'\n    }\n}'], ['{\n\n    \'li\': {\n        \'padding-left\': \'10px\'\n    },\n    \'img\': {\n        \'max-width\': \'100%\'\n    }\n}']);
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var items = __webpack_require__(1831);
	
	var state = (0, _twd.getState)('municipals.resources', {
	    tab: 'why',
	    index: 0
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.tab || 'why'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tab = _React$useState2[0],
	        setTab_ = _React$useState2[1];
	
	    var setTab = _react2.default.useCallback(function (m) {
	        state.set({ tab: m });
	        setTab_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(state.value.index || -1),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        index = _React$useState4[0],
	        setIndex_ = _React$useState4[1];
	
	    var setIndex = _react2.default.useCallback(function (m) {
	        state.set({ index: m });
	        setIndex_(m);
	    }, []);
	
	    var tabItems = items[tab] || [];
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'municipal-bond-resources', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header', style: { marginBottom: 0 } },
	                        'Municipal Bond Resources'
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { 'data-name': 'municipals-bond-resources-nav-tabs', className: 'nav-tabs' },
	                        (0, _core.jsx)(
	                            'ul',
	                            null,
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'why' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'municipals-bond-resources-why-invest-nav-tab',
	                                        className: 'subhead', onClick: function onClick() {
	                                            return setTab('why');
	                                        } },
	                                    'Why invest?'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'faq' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'municipals-bond-resources-faq-nav-tab',
	                                        className: 'subhead', onClick: function onClick() {
	                                            return setTab('faq');
	                                        } },
	                                    'FAQ'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'li',
	                                { className: tab === 'risk' ? 'active' : '' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        'data-name': 'municipals-bond-resources-risks-nav-tab',
	                                        className: 'subhead', onClick: function onClick() {
	                                            return setTab('risk');
	                                        } },
	                                    'Risks'
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            Array.isArray(tabItems) ? renderItems(tabItems, index, setIndex) : (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)('div', { className: 'col-md-12', dangerouslySetInnerHTML: { __html: tabItems } })
	            )
	        )
	    );
	};
	
	var renderItems = function renderItems(items, index, setIndex) {
	    return items.map(function (item, idx) {
	        var _item = _slicedToArray(item, 3),
	            title = _item[0],
	            content = _item[1],
	            disclosure = _item[2];
	
	        var showItem = idx === index;
	        return (0, _core.jsx)(
	            _react2.default.Fragment,
	            { key: idx },
	            (0, _core.jsx)(
	                'div',
	                null,
	                (0, _core.jsx)(
	                    'button',
	                    {
	                        'data-name': 'municipals-bond-resources-item-arrow',
	                        style: { position: 'relative', top: -2, zIndex: 1 },
	                        className: 'btn-link text-muted',
	                        onClick: function onClick() {
	                            return setIndex(showItem ? -1 : idx);
	                        } },
	                    (0, _core.jsx)(
	                        'i',
	                        { style: { color: 'var(--primary-base-color)' }, className: 'material-icons' },
	                        showItem ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { style: { position: 'relative', top: '-20px', paddingLeft: 20 } },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'municipals-bond-resources-item-title',
	                            className: "btn-link text-muted" + (showItem ? " vertical-offset-sm" : ''),
	                            onClick: function onClick() {
	                                return setIndex(showItem ? -1 : idx);
	                            } },
	                        (0, _core.jsx)(
	                            'b',
	                            { style: { color: 'var(--primary-base-color)' } },
	                            (0, _core.jsx)(
	                                'span',
	                                null,
	                                title
	                            )
	                        )
	                    ),
	                    showItem && (0, _core.jsx)('div', { css: itemCss, dangerouslySetInnerHTML: { __html: content } }),
	                    showItem && disclosure && (0, _core.jsx)(
	                        'div',
	                        { className: 'text-right' },
	                        (0, _core.jsx)(_twd.Disclosures, { html: disclosure })
	                    )
	                )
	            )
	        );
	    });
	};
	
	var itemCss = (0, _core.css)(_templateObject);

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' {\n        display: inline-block;\n    }\n    ', ' {\n        text-align:left;\n        width: 100%;\n        display: block;\n        padding: 1px 0;\n        margin-bottom: 5px;\n    }\n'], ['\n    ', ' {\n        display: inline-block;\n    }\n    ', ' {\n        text-align:left;\n        width: 100%;\n        display: block;\n        padding: 1px 0;\n        margin-bottom: 5px;\n    }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	var _useScatterGraph2 = __webpack_require__(140);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        benchmarks = _useScatterGraph.benchmarks,
	        selectedBenchmarks = _useScatterGraph.selectedBenchmarks,
	        setSelectedBenchmarks = _useScatterGraph.setSelectedBenchmarks,
	        colors = _useScatterGraph.colors;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)('div', { className: 'col-md-1' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-9 col-xs-12 text-center' },
	                (0, _core.jsx)(
	                    'div',
	                    { css: legendCss },
	                    (0, _core.jsx)(
	                        'label',
	                        { className: 'text-small' },
	                        'Yield curves: \xA0\xA0'
	                    )
	                ),
	                benchmarks.map(function (a, index) {
	                    return (0, _core.jsx)(
	                        'div',
	                        { css: legendCss, key: index },
	                        (0, _core.jsx)(_twd.Fields.CheckboxLabel, {
	                            dataName: 'municipals-scatter-graph-benchmark',
	                            key: index,
	                            value: a,
	                            label: a,
	                            checked: selectedBenchmarks.indexOf(a) >= 0,
	
	                            onChange: function onChange(e) {
	                                var v = e.target.value;
	                                var f = e.target.checked;
	                                var a = [].concat(_toConsumableArray(selectedBenchmarks));
	                                var n = f ? (0, _twd.arrayInsert)(a, v) : (0, _twd.arrayRemove)(a, v);
	                                setSelectedBenchmarks(n);
	                            },
	
	                            className: 'label-small',
	                            style: {
	                                borderLeft: '4px solid ' + colors[index],
	                                paddingLeft: '5px',
	                                paddingRight: '10px'
	                            } })
	                    );
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12 col-md-2 text-right' },
	                (0, _core.jsx)(_twd.Disclosures, {
	                    dataName: 'municipals-scatter-graph-disclosures-link',
	                    html: DISCLOSURES })
	            )
	        )
	    );
	};
	
	var legendCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs, _twd.mediaQueries.xs);
	
	var DISCLOSURES = '\n    <p>This graph allows you to see whether a bond is yielding more or less than\n    the prevailing yields for comparable bonds.\n    By default, the scatter graph will plot offerings from the most heavily traded issuers\n    by credit rating currently available on the Bond Resource Center.\n    Each bond is depicted as an individual point on the graph.\n    The chart also displays color-coded Treasury and Municipal yield curves to analyze against the plotted offerings.\n    </p>\n\n    <p>To amend the issuers displayed in your scatter graph view,\n    click the \u201CTop Yielding Offerings by Credit Rating\u201D dropdown and use the checkboxes\n    to alter your active selections.\n    Additionally, you may update the displayed offerings by using the \u201CActive State\u201D dropdown\n    to search for offerings in the selected state.\n    The \u201CActive State\u201D dropdown will default to your physical state of residence that E*TRADE has on file.\n    Users can also customize the active yield curves by interacting with the yield curve checkboxes at the base of the graph.\n    </p>\n';

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(135);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var props = _objectWithoutProperties(_ref, []);
	
	    var payload = props.payload;
	
	
	    return _react2.default.createElement(_recharts.Dot, Object.assign({
	        onMouseOver: activateBenchmarkShape,
	        onMouseOut: deactivateBenchmarkShape,
	        className: 'benchmarks-dot-' + payload.x + ' benchmark-' + payload.benchmark
	    }, props));
	};
	
	var activateBenchmarkShape = function activateBenchmarkShape(e, ev) {
	    var el = (0, _all.$)(ev.currentTarget);
	    var p = e.payload || {};
	    el.attr('data-benchmark', p.benchmark);
	    el.attr('data-maturity-years', p.maturityYearValue);
	    el.attr('data-yield', p.yieldValue);
	
	    (0, _all.$)('.' + e.className).each(function (i, a) {
	        var j = (0, _all.$)(a);
	        var c = (0, _all.$)(a).attr('fill');
	        j.attr({ r: 4, stroke: c, fill: '#fff' });
	    });
	};
	
	var deactivateBenchmarkShape = function deactivateBenchmarkShape(e) {
	    (0, _all.$)('.' + e.className).each(function (i, a) {
	        var j = (0, _all.$)(a);
	        var c = (0, _all.$)(a).attr('stroke');
	        j.attr({ r: 2, stroke: c, fill: c });
	    });
	};

/***/ },
/* 982 */
892,
/* 983 */
893,
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(135);
	
	var _useScatterGraph = __webpack_require__(140);
	
	var _useScatterGraph2 = _interopRequireDefault(_useScatterGraph);
	
	var _benchmark = __webpack_require__(473);
	
	var _tooltip = __webpack_require__(992);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var ctx = (0, _useScatterGraph2.default)();
	    var colors = ctx.colors,
	        benchmarks = ctx.benchmarks,
	        selectedBenchmarks = ctx.selectedBenchmarks,
	        benchmarksData = ctx.benchmarksData,
	        RATING_VALUES = ctx.RATING_VALUES,
	        ratings = ctx.ratings,
	        offersData = ctx.offersData;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _recharts.ResponsiveContainer,
	            { width: '100%', height: 350 },
	            _react2.default.createElement(
	                _recharts.ScatterChart,
	                {
	                    margin: {
	                        top: 5, right: 40, left: 0, bottom: 5
	                    }
	                },
	                _react2.default.createElement(_recharts.CartesianGrid, { vertical: false }),
	                _react2.default.createElement(_recharts.XAxis, { dataKey: 'x',
	                    type: 'number',
	                    domain: [0, 30],
	                    scale: 'linear',
	                    unit: ' yr',
	                    ticks: [0, 5, 10, 15, 20, 25, 30]
	                }),
	                _react2.default.createElement(_recharts.YAxis, { dataKey: 'y',
	                    domain: [0, function (dataMax) {
	                        return Math.floor(dataMax) + 2;
	                    }],
	                    width: 5,
	                    unit: '.0%',
	                    scale: 'linear',
	                    axisLine: false,
	                    orientation: 'right' }),
	                benchmarks.map(function (a, i) {
	                    return {
	                        label: a,
	                        data: benchmarksData[a] || [],
	                        color: colors[i],
	                        selected: selectedBenchmarks.indexOf(a) >= 0
	                    };
	                }).filter(function (a) {
	                    return a.selected;
	                }).map(function (a, i) {
	                    return _react2.default.createElement(_recharts.Scatter, { key: i,
	                        data: a.data,
	                        dot: true,
	                        shape: _react2.default.createElement(_benchmark.BenchmarkShape, { r: 2, fill: a.color }),
	                        line: { stroke: a.color, strokeWidth: 2 }
	                    });
	                }),
	                RATING_VALUES.map(function (a, i) {
	                    return {
	                        label: a,
	                        data: offersData[a] || [],
	                        color: colors[5 + i],
	                        selected: ratings.indexOf(a) >= 0
	                    };
	                }).filter(function (a) {
	                    return a.selected;
	                }).map(function (a, i) {
	                    return _react2.default.createElement(_recharts.Scatter, Object.assign({ key: 5 + i,
	                        data: a.data,
	                        fill: a.color
	                    }, _tooltip2.default));
	                }),
	                _react2.default.createElement(_recharts.Tooltip, {
	                    position: { y: 0 },
	                    offset: 1,
	                    content: _react2.default.createElement(_benchmark.BenchmarkTooltipContent, ctx),
	                    isAnimationActive: false,
	                    cursor: _react2.default.createElement(_benchmark.BenchmarkTooltipCursor, null),
	                    wrapperStyle: { zIndex: 3 }
	                })
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useScatterGraph2 = __webpack_require__(140);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var id = _ref.id;
	
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        activeState = _useScatterGraph.activeState,
	        setActiveState = _useScatterGraph.setActiveState;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'select-wrapper' },
	            _react2.default.createElement(
	                'select',
	                {
	                    id: id,
	                    'data-name': 'municipals-scatter-graph-active-state',
	                    className: 'form-control',
	                    value: activeState,
	                    onChange: function onChange(e) {
	                        var a = e.target.value;
	                        setActiveState(a);
	                    }
	                },
	                [{
	                    label: 'All',
	                    value: ''
	                }].concat(_twd.MUNI_STATES_AND_TERRITORIES).map(function (a, i) {
	                    var s = a.value.split('=')[1] || '';
	                    return _react2.default.createElement(
	                        'option',
	                        { key: i, value: s },
	                        a.label
	                    );
	                })
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 986 */
[2040, 987, 989],
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ratings = __webpack_require__(988);
	
	var _ratings2 = _interopRequireDefault(_ratings);
	
	var _activeState = __webpack_require__(985);
	
	var _activeState2 = _interopRequireDefault(_activeState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'vertical-offset-xs',
	                style: {
	                    backgroundColor: "#f6f6f6",
	                    padding: "10px"
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-5 col-lg-4', style: { marginBottom: 0 } },
	                        _react2.default.createElement(
	                            'label',
	                            {
	                                htmlFor: 'municipals-scatter-graph-crriteria-rating'
	                            },
	                            'Top Yielding Offerings by Credit Rating'
	                        ),
	                        _react2.default.createElement(_ratings2.default, {
	                            id: 'municipals-scatter-graph-crriteria-rating'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-lg-5' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-group col-md-3 col-lg-3', style: { marginBottom: 0 } },
	                        _react2.default.createElement(
	                            'label',
	                            {
	                                htmlFor: 'municipals-scatter-graph-crriteria-state'
	                            },
	                            'Active State'
	                        ),
	                        _react2.default.createElement(_activeState2.default, {
	                            id: 'municipals-scatter-graph-crriteria-state'
	                        })
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useScatterGraph2 = __webpack_require__(140);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	var _circleLabel = __webpack_require__(474);
	
	var _circleLabel2 = _interopRequireDefault(_circleLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var id = _ref.id;
	
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        colors = _useScatterGraph.colors,
	        RATINGS = _useScatterGraph.RATINGS,
	        ratings = _useScatterGraph.ratings,
	        setRatings = _useScatterGraph.setRatings;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Fields.Search,
	            {
	                id: id,
	                dataName: 'municipals-scatter-graph-credit-rating',
	                placeholder: getPlaceholder(ratings, 'Select'),
	                type: 'select',
	                onSelect: function onSelect(a) {
	                    var arr = (0, _twd.arrayToggle)(ratings, a.value);
	                    setRatings([].concat(_toConsumableArray(arr)));
	                }
	            },
	            function () {
	                return _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        RATINGS.map(function (a, i) {
	                            return {
	                                value: a.value,
	                                label: a.label,
	                                color: colors[5 + i],
	                                selected: ratings.indexOf(a.value) >= 0
	                            };
	                        }).map(function (a, i) {
	                            return _react2.default.createElement(
	                                _twd.Fields.SearchOption,
	                                {
	                                    dataName: 'municipals-scatter-graph-rating',
	                                    item: a, key: i },
	                                _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                                    dataName: 'municipals-scatter-graph-rating-option',
	                                    checked: a.selected,
	                                    label: _react2.default.createElement(_circleLabel2.default, { color: a.color, label: a.label }) })
	                            );
	                        })
	                    )
	                );
	            }
	        )
	    );
	};
	
	var getPlaceholder = function getPlaceholder(arr, emptyText) {
	    arr = (0, _twd.arrayFrom)(arr);
	    var n = arr.length;
	    if (n === 0) return emptyText;
	
	    var a = _useScatterGraph2.RATINGS.filter(function (a) {
	        return a.value === arr[0];
	    })[0];
	    if (!a) return emptyText;
	
	    return a.label + (n > 1 ? ' + ' + (n - 1) + ' selected' : '');
	};

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useScatterGraph2 = __webpack_require__(140);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	var _circleLabel = __webpack_require__(474);
	
	var _circleLabel2 = _interopRequireDefault(_circleLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        colors = _useScatterGraph.colors,
	        RATINGS = _useScatterGraph.RATINGS,
	        ratings = _useScatterGraph.ratings,
	        setRatings = _useScatterGraph.setRatings;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        RATINGS.map(function (a, i) {
	            return {
	                label: a.label,
	                value: a.value,
	                color: colors[5 + i],
	                selected: ratings.indexOf(a.value) >= 0
	            };
	        }).filter(function (a) {
	            return a.selected;
	        }).map(function (a, i) {
	            return _react2.default.createElement(
	                'a',
	                { href: '#',
	                    key: i,
	                    'data-name': 'municipals-scatter-graph-tag',
	                    className: 'tag tag-dismissible',
	                    style: {
	                        margin: '1px'
	                    },
	                    onClick: function onClick() {
	                        var n = (0, _twd.arrayToggle)(ratings, a.value);
	                        setRatings([].concat(_toConsumableArray(n)));
	                    }
	                },
	                _react2.default.createElement(_circleLabel2.default, { color: a.color, label: a.label })
	            );
	        })
	    );
	};

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useScatterGraph2 = __webpack_require__(140);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	var _twd = __webpack_require__(2);
	
	var _chart = __webpack_require__(984);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _table = __webpack_require__(991);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _criteria = __webpack_require__(986);
	
	var _benchmark = __webpack_require__(473);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _core.jsx)(
	        _useScatterGraph2.ContextProvider,
	        null,
	        (0, _core.jsx)(Main, null)
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var Main = function Main() {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        offersStatus = _useScatterGraph.offersStatus,
	        offersError = _useScatterGraph.offersError;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'scatter-graph-offering-search', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'municipals-scatter-graph-offering-search', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Scatter Graph Offering Search'
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)(_criteria.CriteriaForm, null)
	                )
	            ),
	            (0, _core.jsx)(
	                _twd.Loading,
	                { status: offersStatus, error: offersError },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-12', style: { position: 'relative' } },
	                        (0, _core.jsx)(
	                            'figure',
	                            null,
	                            (0, _core.jsx)(
	                                'div',
	                                { 'aria-hidden': 'true' },
	                                (0, _core.jsx)(_chart2.default, null)
	                            ),
	                            (0, _core.jsx)(
	                                'figcaption',
	                                { className: 'screen-reader-only' },
	                                (0, _core.jsx)(_table2.default, null)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { style: { position: 'absolute', top: 0, zIndex: 2 } },
	                            (0, _core.jsx)(_criteria.CriteriaTags, null)
	                        )
	                    )
	                ),
	                (0, _core.jsx)(_benchmark.BenchmarkLegends, null)
	            )
	        )
	    );
	};

/***/ },
/* 991 */
[2041, 140],
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _twd = __webpack_require__(2);
	
	var onMouseOver = function onMouseOver(payload, _, event) {
	    (0, _twd.publish)('show_flyout', {
	        el: event.target,
	        showIcon: false,
	        html: _twd.format.IssuerDetail(Object.assign({ from: 'municipals/scatter-graph-offering-search' }, payload))
	    });
	}; /* eslint-disable no-use-before-define */
	exports.default = {
	    onMouseOver: onMouseOver,
	    onClick: onMouseOver
	};

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var state = (0, _twd.getState)('municipals.scatter-graph');
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var benchmarks = ['Treasury', 'AAA', 'AA', 'A', 'BBB'];
	
	    var _React$useState3 = _react2.default.useState({}),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        benchmarksData = _React$useState4[0],
	        setBenchmarksData = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(state.value.selectedBenchmarks || benchmarks),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        selectedBenchmarks = _React$useState6[0],
	        setSelectedBenchmarks_ = _React$useState6[1];
	
	    var setSelectedBenchmarks = _react2.default.useCallback(function (a) {
	        state.set({ selectedBenchmarks: a });
	        setSelectedBenchmarks_(a);
	    }, []);
	
	    var lastAbort = _react2.default.useRef();
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, abort, a, m, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref3, _ref4, k, v, _ret;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	                            _context.next = 4;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/yieldCurveService/getBenchmarkDataByType',
	                                method: 'POST',
	                                params: {
	                                    bondType: 'MUNI',
	                                    muniType: 'GO',
	                                    marketSnapshotType: 'MUNICIPAL_GO_BENCHMARK_DATA'
	                                }
	                            });
	
	                        case 4:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 10;
	                            return data;
	
	                        case 10:
	                            _context.t0 = _context.sent.benchmarkYieldValues;
	
	                            if (_context.t0) {
	                                _context.next = 13;
	                                break;
	                            }
	
	                            _context.t0 = {};
	
	                        case 13:
	                            a = _context.t0;
	
	                            lastAbort.current = null;
	
	                            m = {
	                                'Treas': 'Treasury',
	                                'MuniGOAAA': 'AAA',
	                                'MuniGOAA': 'AA',
	                                'MuniGOA': 'A',
	                                'MuniGOBBB': 'BBB'
	                            };
	
	                            _loop = function _loop(k, v) {
	
	                                var n = m[k];
	                                if (!n) return 'continue';
	
	                                a[n] = (0, _twd.arrayFrom)(v).map(function (i) {
	                                    i.benchmark = n;
	                                    i.x = i.maturityYearValue;
	                                    i.y = i.yieldValue;
	                                    return i;
	                                }).filter(function (a) {
	                                    return a.x <= 30;
	                                });
	                            };
	
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context.prev = 20;
	                            _iterator = Object.entries(a)[Symbol.iterator]();
	
	                        case 22:
	                            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
	                                _context.next = 33;
	                                break;
	                            }
	
	                            _ref3 = _step.value;
	                            _ref4 = _slicedToArray(_ref3, 2);
	                            k = _ref4[0];
	                            v = _ref4[1];
	                            _ret = _loop(k, v);
	
	                            if (!(_ret === 'continue')) {
	                                _context.next = 30;
	                                break;
	                            }
	
	                            return _context.abrupt('continue', 30);
	
	                        case 30:
	                            _iteratorNormalCompletion = true;
	                            _context.next = 22;
	                            break;
	
	                        case 33:
	                            _context.next = 39;
	                            break;
	
	                        case 35:
	                            _context.prev = 35;
	                            _context.t1 = _context['catch'](20);
	                            _didIteratorError = true;
	                            _iteratorError = _context.t1;
	
	                        case 39:
	                            _context.prev = 39;
	                            _context.prev = 40;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 42:
	                            _context.prev = 42;
	
	                            if (!_didIteratorError) {
	                                _context.next = 45;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 45:
	                            return _context.finish(42);
	
	                        case 46:
	                            return _context.finish(39);
	
	                        case 47:
	                            setBenchmarksData(a);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 55;
	                            break;
	
	                        case 51:
	                            _context.prev = 51;
	                            _context.t2 = _context['catch'](0);
	
	                            if (lastAbort.current) lastAbort.current();
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 55:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 51], [20, 35, 39, 47], [40,, 42, 46]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) lastAbort.current();
	        };
	    }, []);
	
	    return {
	        benchmarks: benchmarks,
	        benchmarksStatus: status,
	        benchmarksData: benchmarksData,
	        selectedBenchmarks: selectedBenchmarks,
	        setSelectedBenchmarks: setSelectedBenchmarks
	    };
	};

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var NO_RESULT = '\n    <div class="text-center text-body">' + _twd.NO_RESULT_ICON_HTML + '\n    <br/>\n    <h4 class="small-header">No offerings available</h4>\n    No offerings align with your search criteria. Please try an alternate search.\n    </div>\n';
	
	exports.default = function (_ref) {
	    var activeState = _ref.activeState;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(''),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        error = _React$useState4[0],
	        setError = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState({}),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        offersData = _React$useState6[0],
	        setOffersData = _React$useState6[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        ;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref3, data, abort, a, ks, ds, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref4, _ref5, k, v, n;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setError('');
	                            setStatus(_twd.Status.LOADING);
	                            if (lastAbort.current) lastAbort.current();
	
	                            _context.next = 6;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/yieldCurveService/getScatterGraphOfferingSearchData',
	                                method: 'POST',
	                                params: {
	                                    bondType: 'MUNI',
	                                    muniType: 'GO',
	                                    marketSnapshotType: 'MUNI_GO_SCATTER_GRAPH_DATA',
	                                    maxYield: 20,
	                                    state: activeState || null
	                                }
	                            });
	
	                        case 6:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            abort = _ref3.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 12;
	                            return data;
	
	                        case 12:
	                            _context.t1 = _context.sent.topIssuerBondsDto;
	
	                            if (_context.t1) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            _context.t1 = {};
	
	                        case 15:
	                            _context.t0 = _context.t1.topBondYieldValues;
	
	                            if (_context.t0) {
	                                _context.next = 18;
	                                break;
	                            }
	
	                            _context.t0 = {};
	
	                        case 18:
	                            a = _context.t0;
	
	                            lastAbort.current = null;
	
	                            ks = [];
	                            ds = {};
	
	                            _loop = function _loop(k, v) {
	                                ks.push(k);
	                                ds[k] = (0, _twd.arrayFrom)(v).filter(function (i) {
	                                    return i.yieldValue >= 0.0;
	                                }).map(function (i) {
	                                    var r = i.scatterOfferRow;
	                                    r.x = i.maturityYearValue;
	                                    r.y = i.yieldValue;
	                                    r.maturityYearValue = i.maturityYearValue;
	                                    r.yieldValue = i.yieldValue;
	                                    r.rating = k;
	                                    return r;
	                                }).filter(function (a) {
	                                    return a.x <= 30;
	                                });
	                            };
	
	                            _iteratorNormalCompletion = true;
	                            _didIteratorError = false;
	                            _iteratorError = undefined;
	                            _context.prev = 26;
	
	                            for (_iterator = Object.entries(a)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                                _ref4 = _step.value;
	                                _ref5 = _slicedToArray(_ref4, 2);
	                                k = _ref5[0];
	                                v = _ref5[1];
	
	                                _loop(k, v);
	                            }
	
	                            _context.next = 34;
	                            break;
	
	                        case 30:
	                            _context.prev = 30;
	                            _context.t2 = _context['catch'](26);
	                            _didIteratorError = true;
	                            _iteratorError = _context.t2;
	
	                        case 34:
	                            _context.prev = 34;
	                            _context.prev = 35;
	
	                            if (!_iteratorNormalCompletion && _iterator.return) {
	                                _iterator.return();
	                            }
	
	                        case 37:
	                            _context.prev = 37;
	
	                            if (!_didIteratorError) {
	                                _context.next = 40;
	                                break;
	                            }
	
	                            throw _iteratorError;
	
	                        case 40:
	                            return _context.finish(37);
	
	                        case 41:
	                            return _context.finish(34);
	
	                        case 42:
	                            setOffersData(ds);
	
	                            n = Object.values(ds).reduce(function (n, a) {
	                                return n + a.length;
	                            }, 0);
	
	                            if (!(n === 0 && activeState)) {
	                                _context.next = 48;
	                                break;
	                            }
	
	                            setError(NO_RESULT);
	                            setStatus(_twd.Status.UNAVAILABLE);
	                            return _context.abrupt('return');
	
	                        case 48:
	
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 57;
	                            break;
	
	                        case 51:
	                            _context.prev = 51;
	                            _context.t3 = _context['catch'](0);
	
	                            if (!(_context.t3.name === 'AbortError')) {
	                                _context.next = 55;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 55:
	                            if (lastAbort.current) lastAbort.current();
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 57:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 51], [26, 30, 34, 42], [35,, 37, 41]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) lastAbort.current();
	        };
	    }, [activeState]);
	
	    return {
	        offersData: offersData,
	        offersStatus: status,
	        offersError: error
	    };
	};

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var rows = _ref.rows;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            {
	                'data-name': 'municipals-ticker-table',
	                className: 'table table-hover align-top table-striped' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Date'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Trade'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { width: '30%' },
	                        'Issuer'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'State'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Coupon'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Maturity'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Price/Yield'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Actions'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rows.map(function (r, i) {
	                    var ts = new Date(r.tradeDate);
	                    if (isNaN(ts.valueOf())) ts = null;
	
	                    var _ref2 = ts ? r.tradeDate.split(' ') : ['', []],
	                        _ref3 = _toArray(_ref2),
	                        dt = _ref3[0],
	                        tm = _ref3.slice(1);
	
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            dt,
	                            _react2.default.createElement('br', null),
	                            tm.join(' ')
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _twd.format.qty(r.trade)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-bold' },
	                            _twd.format.issuer({
	                                issuer: r.issue,
	                                cusip: r.cusip,
	                                from: 'municipals/municipal-ticker',
	                                className: 'link-button text-left'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            r.state
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.format.cpn(r.coupon)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.format.mdy(new Date(r.maturity))
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right', style: { whiteSpace: 'nowrap' } },
	                            _twd.format.price(r.price),
	                            ' / ',
	                            _twd.format.ytw(r.yield)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-center' },
	                            r.tradeHistory && _react2.default.createElement(TradeHistoryButton, { cusip: r.cusip }),
	                            r.buyAction && _react2.default.createElement(BuyButton, { cusip: r.cusip })
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var TradeHistoryButton = function TradeHistoryButton(_ref4) {
	    var cusip = _ref4.cusip;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            type: 'button',
	            'data-name': 'municipals-ticker-trade-history-button',
	            className: 'btn btn-block btn-sm btn-primary-outline vertical-offset-xxs',
	            onClick: function onClick(e) {
	                var p = {
	                    view: 'trade-history',
	                    cusip: cusip,
	                    source: e.target
	                };
	                (0, _twd.showModal)(p);
	            }
	        },
	        'Trade history'
	    );
	};
	
	var BuyButton = function BuyButton(_ref5) {
	    var cusip = _ref5.cusip;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            type: 'button',
	            'data-name': 'municipals-ticker-buybutton',
	            className: 'btn btn-block btn-sm btn-primary',
	            onClick: function onClick() {
	                (0, _twd.showBondOrder)({
	                    cusip: cusip,
	                    action: 'B',
	                    from: 'municipals/municipal-ticker'
	                });
	            }
	        },
	        'Buy'
	    );
	};

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(117);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(995);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _twd = __webpack_require__(2);
	
	var _useTickers2 = __webpack_require__(997);
	
	var _useTickers3 = _interopRequireDefault(_useTickers2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useTickers = (0, _useTickers3.default)(),
	        tickerData = _useTickers.tickerData,
	        status = _useTickers.status;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'municipal-ticker', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'municipals-ticker', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Municipal Ticker'
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                _twd.Loading,
	                { status: status },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-12' },
	                        (0, _core.jsx)(_grid2.default, { rows: tickerData })
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12 text-right' },
	                    (0, _core.jsx)(_twd.Disclosures, {
	                        dataName: 'municipals-ticker-disclosures-link',
	                        html: DISCLOSURES
	                    })
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};
	
	var DISCLOSURES = '\n<p>We are providing certain data supplied to us by\nthe Municipal Securities Rulemaking Board ("the Service") without warranties\nor representations and on an "as is" basis.\nWE HEREBY DISCLAIM ALL REPRESENTATIONS AND WARRANTIES (EXPRESS OR IMPLIED), INCLUDING,\nBUT NOT LIMITED TO, WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE REGARDING\nTHE Service. You shall bear all risk, related costs and liability and be responsible\nfor your use of the Service.\nWe assume no responsibility for the consequences of any intentional or unintentional error,\nomission, inaccuracy, incompleteness or untimeliness in or with respect to the Service.</p>\n\n<p style="font-weight:bold">Real-Time Transaction Data Subscription Service</p>\n\n<p>The Transaction data provided through the Real-Time Transaction Data Subscription Service\nrepresents municipal securities transaction data made available by brokers,\ndealers and municipal securities dealers to the MSRB and related information.\nSuch transaction data and/or related information may not exist for all municipal securities\nand may not be required to be submitted to the MSRB for certain types of municipal securities transactions.\nThe MSRB does not review transaction data submitted by submitters for accuracy, completeness or any other purpose,\nand does not warrant or guarantee the accuracy of any such transaction data and/or related information.</p>\n\n\n<p style="font-weight:bold">Comprehensive Transaction Data Subscription Service</p>\n\n<p>The Transaction data provided through the Comprehensive Transaction Data Subscription Service\nrepresents trade reports for specific trade dates: (1) made available at approximately 6.00 a.m.\non the business day following trade date ("T+1"); (ii) made available five business days after that trade date ("T+5");\nand (iii) made available 20 days after that trade date ("T+20"). Such transaction data and/or related information\nmay not exist for all municipal securities. The MSRB does not review the transaction data for accuracy,\ncompleteness or any other purpose, and does not warrantor guarantee the accuracy of\nany such transaction data and/or related information.</p>\n\n<p>The MSRB, its officers, directors, employees, agents, consultants and licensors\nshall not be liable of responsible to you or anyone else for any losses, injuries, damages, costs,\nexpenses or claims caused by, arising out of or relating to the following:\n(a) acts, omissions, occurrences or contingencies beyond their control;\n(b) service interruptions or performance failures, such as those that result from the use of telecommunications facilities\nthat are outside their control, including the internet;\n(c) negligence, gross negligence or willful misconduct in procuring, compiling, interpreting, editing, writing reporting\nor delivering any of the content and material;\n(d) lost, stolen, late, corrupted, misdirected, failed, incomplete or delayed transmissions\nby anyone using the Service, including, but not limited to, any technical malfunctions, human error, computer viruses,\nlost data transmissions, omissions, interruptions, deletions, defects, hyperlink failures or line failures of any telephone network,\ncomputer equipment, software or any combination thereof;\n(e) damage to your computer systems, equipment, software, data or other tangible or intangible property resulting from\nor sustained in connection with your use of the Service, and/or\n(f) any disruption of business, lost sales or lost profits or any punitive, exemplary, indirect, special,\nincidental or consequential damages associated or in connection with, resulting from or arising out of\nany use of the Service or the content and material in the Service.\n</p>\n\n<p>The MSRB and its officers, directors, employees, agents consultants and licensors shall have not liability\nin tort, contract or otherwise (and as permitted by law, product liability) to you or anyone else\nfor any reason associated or in connection with, resulting from or arising out of your use of the Service.\nThe MSRB, its officers, directors, employees, agents, consultants and licensors make, and have made,\nno recommendations regarding any of the securities or other investment vehicles identified, referred to\nor described in the Service.</p>\n\n<p>The Service is reproduced by permission of the MSRB under a non-exclusive license.\nThe MSRB accepts no responsibility for the accuracy of the reproduction of the Service\nor that such Service is current.</p>\n';

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('municipals.muni-tickers', {
	    tickerData: []
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.tickerData || []),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tickerData = _React$useState2[0],
	        setTickerData_ = _React$useState2[1];
	
	    var setTickerData = _react2.default.useCallback(function (m) {
	        state.set({ tickerData: m });
	        setTickerData_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        setTickerData([]);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, abort, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            setStatus(_twd.Status.LOADING);
	                            _context.next = 5;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/marketSnapshotService/getMarketSnapshotByType',
	                                method: 'POST',
	                                params: {
	                                    marketSnapshotsType: 'MUNI_TICKER_DATA'
	                                }
	                            });
	
	                        case 5:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            abort = _ref2.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 11;
	                            return data;
	
	                        case 11:
	                            rs = _context.sent;
	
	                            setTickerData(rs);
	                            lastAbort.current = null;
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 21;
	                            break;
	
	                        case 17:
	                            _context.prev = 17;
	                            _context.t0 = _context['catch'](0);
	
	                            setTickerData([]);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 21:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 17]]);
	        }))();
	
	        return function () {
	            if (lastAbort.current) lastAbort.current();
	        };
	    }, []);
	
	    return {
	        status: status,
	        tickerData: tickerData
	    };
	};

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        index = _ref.index,
	        table = _ref.table;
	
	    var t = index === 0 ? data.displayName : formatYield(data.yield);
	
	    var _React$useState = _react2.default.useState(t),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        text = _React$useState2[0],
	        setText = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(data.id),
	        _React$useState4 = _slicedToArray(_React$useState3, 1),
	        cellId = _React$useState4[0];
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('yield_bucket.yield_grid_' + cellId, function (_ref2) {
	            var id = _ref2.id,
	                value = _ref2.value;
	
	            return id === cellId && setText(formatYield(value));
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var q = data.queryText;
	    if (!q) return text;
	
	    if (text === '-') return text;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'municipals-yield-grid-cell',
	            'data-cell-id': cellId,
	            'data-table': table,
	            'data-row': data.headerName,
	            'data-column': data.colName,
	            onClick: function onClick() {
	                return onSearch((0, _twd.parseJson)(q));
	            },
	            className: 'link-button text-left' },
	        text
	    );
	};
	
	var formatYield = function formatYield(x) {
	    var a = parseFloat(x);
	    if (isNaN(a)) return '-';
	
	    var s = a.toFixed(3);
	    if (s === '0.000') return '-';
	    return s + '%';
	};
	
	var onSearch = function onSearch(p) {
	    if (!p) return;
	    Object.assign(p, {
	        respectSplitRating: true,
	        persistToPreviousSearches: false,
	        sort: [{ field: 'askYield', direction: 'DESC' }]
	    });
	    delete p['savedQuickPickId'];
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: p,
	        _ts: Date.now(),
	        from: 'municipals'
	    }));
	};

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var s = (0, _twd.yieldGridLastUpdated)();
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-8' },
	            s ? s + ' \xA0 | \xA0 ' : '',
	            'Yields update as prices change, and may be delayed.  Please see disclosures.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-4 text-right' },
	            _react2.default.createElement(_twd.Disclosures, {
	                dataName: 'municipals-yield-grid-disclosures-link',
	                html: DISCLOSURES
	            })
	        )
	    );
	};
	
	var DISCLOSURES = '\n    <p>\n    The Yield by Category table can be sorted by highest or average yield.\n    By default, the table is configured to display the highest available yield on\n    the Tradeweb dealer network aligned with each municipal bond category (general obligation or revenue)\n    and maturity.\n    Offerings within each municipal bond category are further organized by\n    investment grade or high yield credit quality.\n    Split-rated offerings with an investment grade rating from one agency\n    and high yield rating from the other will be categorized as high yield within the grid.\n    To view the average yield amongst available offers for a given municipal bond category and maturity,\n    simply click the "Average Yield" toggle above the table.\n    </p>\n    <p>\n    The yield values displayed represent the existence of a minimum of 10 bonds ($1,000 face value)\n    available at the respective credit ratings (as designated by Moody\'s or S&P) for which the ask price\n    is between 85 and 120, excluding zero-coupon bonds (US Treasury Zeroes).\n    </p>\n    <p>\n    Yields displayed within the grid will update in response to changes in available offerings and offering prices.\n    These yields will update as offer pricing changes throughout the trading day and may be delayed.\n    </p>';

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('municipals.yield-grids', {
	    method: 'HIGHEST'
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.method || 'HIGHEST'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        method = _React$useState2[0],
	        setMethod_ = _React$useState2[1];
	
	    var setMethod = _react2.default.useCallback(function (m) {
	        state.set({ method: m });
	        setMethod_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        grids = _React$useState4[0],
	        setGrids = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        status = _React$useState6[0],
	        setStatus = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(Date.now()),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        ts = _React$useState8[0],
	        setTs = _React$useState8[1];
	
	    _react2.default.useEffect(function () {
	
	        setGrids([]);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, x, t, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.next = 4;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/yieldGridService/getYieldGridDataByType',
	                                method: 'POST',
	                                params: {
	                                    brand: 'etrade' || (0, _twd.getBrand)(),
	                                    yieldGridTypeList: [{
	                                        gridType: 'MUNICIPALS',
	                                        yieldType: method
	                                    }]
	                                }
	                            });
	
	                        case 4:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            x = _context.sent;
	                            t = method === 'HIGHEST' ? 'Highest Yield' : 'Average Yield';
	                            rs = (0, _twd.arrayFrom)(x[0].tables).map(function (a) {
	                                return Object.assign(a, { table: t });
	                            });
	
	                            setGrids(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 18;
	                            break;
	
	                        case 15:
	                            _context.prev = 15;
	                            _context.t0 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 18:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 15]]);
	        }))();
	    }, [method, ts]);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('atmosphere_reconnected.corporates_yield_grids', function (_ref3) {
	            var ts = _ref3.ts;
	
	            setTs(ts);
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    return { method: method, setMethod: setMethod, grids: grids, status: status };
	};

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useYieldGrids = __webpack_require__(1000);
	
	var _useYieldGrids2 = _interopRequireDefault(_useYieldGrids);
	
	var _twd = __webpack_require__(2);
	
	var _footer = __webpack_require__(999);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _cell = __webpack_require__(998);
	
	var _cell2 = _interopRequireDefault(_cell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useYieldGrid = (0, _useYieldGrids2.default)(),
	        method = _useYieldGrid.method,
	        setMethod = _useYieldGrid.setMethod,
	        grids = _useYieldGrid.grids,
	        status = _useYieldGrid.status;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { 'data-name': 'municipals-yield-grid', style: { background: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                'data-name': 'municipals-yield-grid-nav-tabs',
	                                className: 'nav-tabs' },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: method === 'HIGHEST' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'municipals-yield-grid-highest-yield-nav-tab',
	                                            onClick: function onClick() {
	                                                return setMethod('HIGHEST');
	                                            } },
	                                        'Highest Yield'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: method === 'AVERAGE_10' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'municipals-yield-grid-average-yield-nav-tab',
	                                            onClick: function onClick() {
	                                                return setMethod('AVERAGE_10');
	                                            } },
	                                        'Average Yield'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _twd.Loading,
	                { status: status },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Grids, { grids: grids }),
	                            _react2.default.createElement(_footer2.default, { grids: grids })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Grids = function Grids(_ref) {
	    var grids = _ref.grids;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        grids && grids.map(function (g, i) {
	            return _react2.default.createElement(Grid, { key: i, grid: g, index: i });
	        })
	    );
	};
	
	var Grid = function Grid(_ref2) {
	    var grid = _ref2.grid,
	        index = _ref2.index;
	
	    var w = (83.34 / (grid.columns.length - 1)).toFixed(2) + '%';
	
	    var rs = (grid.rows && [].concat(_toConsumableArray(grid.rows)) || []).map(function (r) {
	        return Object.assign(r, { table: grid.table });
	    });
	    rs.shift();
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            { 'data-name': 'municipals-yield-grid-table-' + index, className: 'table' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    grid.columns && grid.columns.map(function (c, i) {
	                        return _react2.default.createElement(
	                            'th',
	                            { key: i,
	                                width: i === 0 ? '16.66%' : w,
	                                className: i === 0 ? 'text-left' : 'text-right' },
	                            i === 0 ? _react2.default.createElement(
	                                'h6',
	                                { className: 'subhead', style: { marginBottom: 0 } },
	                                c
	                            ) : c
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rs && rs.map(function (r, i) {
	                    return _react2.default.createElement(Row, { key: i, row: r });
	                })
	            )
	        )
	    );
	};
	
	var Row = function Row(_ref3) {
	    var row = _ref3.row;
	
	    return _react2.default.createElement(
	        'tr',
	        { 'data-name': 'municipals-yield-grid-row' },
	        row.row && row.row.map(function (a, i) {
	            return _react2.default.createElement(
	                'td',
	                { key: i,
	                    className: i === 0 ? 'text-left' : 'text-right' },
	                _react2.default.createElement(_cell2.default, { data: a, index: i, table: row.table })
	            );
	        })
	    );
	};

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isInvType = function isInvType(s) {
	    return s.indexOf('holdInvType') >= 0;
	};
	
	exports.default = function (_ref) {
	    var Last = _ref.Last;
	
	    var cs = Last.value.searchCriteria || [];
	
	    var singleInvType = cs.filter(function (c) {
	        return isInvType(c.code);
	    }).length < 2;
	
	    var ps = Last.value.params || {};
	    var isCusipSearch = !('holdInvType' in ps) && 'holdCusip' in ps;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        cs.map(updateCriteriaDescription).filter(Boolean).map(function (a, i) {
	            var f = isInvType(a.code) && (singleInvType || isCusipSearch);
	            var cls = 'tag ' + (f ? '' : 'tag-dismissible');
	
	            return _react2.default.createElement(
	                'button',
	                {
	                    'data-name': 'offerings-criteria',
	                    'data-label': a.description,
	                    key: i,
	                    className: cls,
	                    onClick: function onClick() {
	                        if (f) return;
	                        onRemoveCriteria(Last, a);
	                    }
	                },
	                a.description
	            );
	        })
	    );
	};
	
	var identityFn = function identityFn(a) {
	    return a;
	};
	
	var updateCriteriaDescription = function updateCriteriaDescription() {
	    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _String$split = String(a.code).split('-'),
	        _String$split2 = _slicedToArray(_String$split, 2),
	        key = _String$split2[0],
	        value = _String$split2[1];
	
	    var fn = CRITERIA_DESCRIPTION_UPDATER[key] || identityFn;
	    var description = fn(a.description, value);
	    if (!description) return;
	
	    return Object.assign({}, a, { description: description });
	};
	
	var CRITERIA_DESCRIPTION_UPDATER = {
	    holdInvType: function holdInvType(a) {
	        return 'Securities: ' + a;
	    },
	    holdIssue: function holdIssue(a) {
	        return 'Issuer: ' + a;
	    },
	    offeringType: function offeringType(a) {
	        return 'Market: ' + (a === 'Primary' ? 'New Issue' : a);
	    },
	
	    holdCouponPayFrequency: function holdCouponPayFrequency(a) {
	        return 'Coupon: ' + a;
	    },
	    holdCouponPayMonths: function holdCouponPayMonths(a) {
	        return 'Coupon: ' + a;
	    },
	    holdCouponTypeCode: function holdCouponTypeCode(a) {
	        return 'Coupon: ' + a;
	    },
	
	    holdCorpSectorCode: function holdCorpSectorCode(a) {
	        return a.replace('Corp-', 'Sector: ');
	    },
	    holdCorpType: function holdCorpType(a) {
	        return 'Type: ' + a;
	    },
	    holdConvertible: function holdConvertible(a) {
	        return 'Type: ' + a;
	    },
	    holdDrnk: function holdDrnk(a) {
	        return 'Debt: ' + a.replace('Other DRNK', 'Other');
	    },
	    holdSymbol: function holdSymbol(a) {
	        return 'Symbol: ' + a;
	    },
	
	    holdState: function holdState(a) {
	        return 'State: ' + a;
	    },
	    holdMuniType: function holdMuniType(a) {
	        return 'Category: ' + a.replace('Muni-', '');
	    },
	    holdRefundInd: function holdRefundInd(a) {
	        return 'Category: ' + a;
	    },
	    holdRefundType: function holdRefundType(a) {
	        return 'Category: ' + a;
	    },
	    holdTaxable: function holdTaxable(a) {
	        return 'Tax: ' + a;
	    },
	    holdAltMinTax: function holdAltMinTax(a) {
	        return 'Tax: ' + a;
	    },
	    holdStateTaxExempt: function holdStateTaxExempt(a) {
	        return 'Tax: ' + a.replace('St-Tax', 'State-Tax').replace('St-Exempt', 'State-Exempt');
	    },
	    holdUseOfProceeds: function holdUseOfProceeds(a) {
	        return 'Proceeds: ' + a.replace('Muni-', '');
	    },
	    holdIssueType: function holdIssueType(a) {
	        return 'Env: ' + a;
	    },
	
	    holdBlueSkyStateCD: function holdBlueSkyStateCD(a, v) {
	        return !v ? '' : a.replace('Blue Sky', 'Blue Sky State:');
	    },
	    holdFdicNum: function holdFdicNum(a) {
	        return 'FDIC ' + a;
	    },
	
	    holdAgencyType: function holdAgencyType(a) {
	        return 'Issuer: ' + a;
	    },
	    holdTreasuryType: function holdTreasuryType(a) {
	        return 'Type: ' + a;
	    },
	
	    holdMaturity: function holdMaturity(a) {
	        return a.replace('Mat:', 'Maturity:');
	    },
	    holdCoupon: function holdCoupon(a) {
	        return a.replace('Cpn:', 'Coupon:');
	    },
	    clientPrice: function clientPrice(a) {
	        return a.replace('Client Price:', 'Price:');
	    },
	
	    holdCallableInd: function holdCallableInd(a) {
	        return 'Call: ' + a;
	    },
	    holdWholeCallInd: function holdWholeCallInd(a) {
	        return 'Call: ' + a;
	    },
	    holdPutableInd: function holdPutableInd(a) {
	        return 'Put: ' + a;
	    },
	    holdPutType: function holdPutType(a) {
	        return 'Put: ' + a;
	    },
	    holdNextSink: function holdNextSink(a) {
	        return 'Other: ' + a;
	    },
	    holdErpInd: function holdErpInd(a) {
	        return 'Other: ' + a;
	    }
	};
	
	var onRemoveCriteria = function onRemoveCriteria(Last, _ref2) {
	    var code = _ref2.code;
	
	    var _ref3 = function () {
	        var arr = code.split('-');
	        return [arr.shift(), arr.join('-')];
	    }(),
	        _ref4 = _slicedToArray(_ref3, 2),
	        k = _ref4[0],
	        v = _ref4[1];
	
	    var ks = [];
	    if (k === 'offeringType') {
	        ks.push(['primarySecondary', v]);
	    } else if (k === 'offeringNewToday') {
	        v = v === 'Y';
	    } else if (k === 'holdCusip') {
	        ks.push(['holdIdentifiers']);
	    } else if (k === 'holdPutableInd' && v === 'Y') {
	        ks.push(['holdPutType', 'MAN'], ['holdPutType', 'COND'], ['holdPutType', 'SUR']);
	    } else if (k === 'holdRefundInd' && v === 'Y') {
	        ks.push(['holdRefundType', 'PRE'], ['holdRefundType', 'ETM']);
	    } else if (k === 'holdTaxable' && v === 'Y') {
	        ks.push(['holdTaxable', 'BAB']);
	    } else if (k === 'holdMoodyRating' || k === 'holdSpRating') {
	        ks.push(['respectSplitRating', true]);
	    }
	    ks.push([k, v]);
	
	    var ps = Object.assign({}, Last.clone().params || {});
	    var f = removeCriteria(ps, ks);
	    if (!f) return;
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: (0, _twd.cleanObject)(ps),
	        _ts: Date.now(),
	        from: Last.value.from
	    }));
	};
	
	var removeCriteria = function removeCriteria(params, keyValues) {
	    var removed = false;
	    (0, _twd.arrayFrom)(keyValues).filter(Boolean).forEach(function (a) {
	        var _a = _slicedToArray(a, 2),
	            key = _a[0],
	            value = _a[1];
	
	        var p = params[key];
	        var b = false;
	        if (!p) {
	            b = delete params[key + 'Min'] + delete params[key + 'Max'] > 0;
	        } else if (Array.isArray(p)) {
	            var i = p.indexOf(value);
	            b = p.splice(i, 1).length > 0;
	        } else if (p && p === value) {
	            b = delete params[key] > 0;
	        } else {
	            var arr = String(p).split(',');
	            var _i = arr.indexOf(value);
	            b = arr.splice(_i, 1).length > 0;
	            if (b) {
	                params[key] = arr.join(',');
	            }
	        }
	        removed = removed || b;
	    });
	    return removed;
	};

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _header = __webpack_require__(1005);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _grid = __webpack_require__(1004);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _useDepthOfMarket2 = __webpack_require__(1006);
	
	var _useDepthOfMarket3 = _interopRequireDefault(_useDepthOfMarket2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var cusip = _ref.cusip,
	        allowTrading = _ref.allowTrading;
	
	    var _useDepthOfMarket = (0, _useDepthOfMarket3.default)({ cusip: cusip }),
	        issueData = _useDepthOfMarket.issueData,
	        askRows = _useDepthOfMarket.askRows,
	        bidRows = _useDepthOfMarket.bidRows;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container', style: { background: "#ffffff" } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'close',
	                                    'aria-label': 'close',
	                                    'data-name': 'offerings-depth-of-market-close',
	                                    type: 'button',
	                                    onClick: _twd.hideModal },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'close'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                'Depth of Market'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(_header2.default, Object.assign({ cusip: cusip }, issueData))
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container', style: {
	                            background: '#ffffff',
	                            border: 'solid 1px #e4e4e4',
	                            padding: '10px'
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6 col-xs-12' },
	                            _react2.default.createElement(_grid2.default, { type: 'bid', rows: bidRows, allowTrading: allowTrading })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6 col-xs-12' },
	                            _react2.default.createElement(_grid2.default, { type: 'ask', rows: askRows, allowTrading: allowTrading })
	                        )
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$type = _ref.type,
	        type = _ref$type === undefined ? 'ask' : _ref$type,
	        _ref$rows = _ref.rows,
	        rows = _ref$rows === undefined ? [] : _ref$rows,
	        _ref$allowTrading = _ref.allowTrading,
	        allowTrading = _ref$allowTrading === undefined ? true : _ref$allowTrading;
	
	    var header = type === 'ask' ? { backgroundColor: 'green' } : { backgroundColor: 'red' };
	    var title = type === 'ask' ? 'OFFERS' : 'BIDS';
	    var action = allowTrading === false ? _twd.format.orderPhone : type === 'ask' ? _twd.format.buy : _twd.format.sell;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'text-center vertical-offset-xxs', style: Object.assign({
	                    color: '#ffffff'
	                }, header) },
	            title
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-name': 'offerings-depth-of-market-table-' + type,
	                    className: 'table table-striped',
	                    style: {
	                        marginBottom: 0
	                    }
	                },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Qty'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Min'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Price'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Yield'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Updated'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Action'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    rows && rows.map(function (r, i) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: i },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _twd.format.qty(r.quantity)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _twd.format.qty(r.qty_min)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _twd.format.price(r.price)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.format.ytw(r.yield)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                r.price_status
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                action({ cusip: '' + r.cusip, from: 'offerings' })
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref.cusip,
	        _ref$holdIssue = _ref.holdIssue,
	        holdIssue = _ref$holdIssue === undefined ? '' : _ref$holdIssue,
	        _ref$holdWarningText = _ref.holdWarningText,
	        holdWarningText = _ref$holdWarningText === undefined ? '' : _ref$holdWarningText,
	        _ref$maturity = _ref.maturity,
	        maturity = _ref$maturity === undefined ? '' : _ref$maturity,
	        _ref$holdCoupon = _ref.holdCoupon,
	        holdCoupon = _ref$holdCoupon === undefined ? '' : _ref$holdCoupon,
	        _ref$moodyRating = _ref.moodyRating,
	        moodyRating = _ref$moodyRating === undefined ? '' : _ref$moodyRating,
	        _ref$spRating = _ref.spRating,
	        spRating = _ref$spRating === undefined ? '' : _ref$spRating,
	        _ref$floaterInd = _ref.floaterInd,
	        floaterInd = _ref$floaterInd === undefined ? '' : _ref$floaterInd;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    holdIssue
	                ),
	                _react2.default.createElement('label', {
	                    style: { whiteSpace: 'normal' },
	                    dangerouslySetInnerHTML: { __html: _twd.fmt.warningText(holdWarningText) }
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'CUSIP'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right text-bold' },
	                                cusip
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Coupon'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right text-bold' },
	                                _twd.format.cpn(holdCoupon, floaterInd)
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Maturity'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right text-bold' },
	                                maturity || '-'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Moody/S&P'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right text-bold' },
	                                moodyRating || '-',
	                                ' / ',
	                                spRating || '-'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var lastAjaxAbort;
	
	exports.default = function (_ref) {
	    var cusip = _ref.cusip;
	
	    var _React$useState = _react2.default.useState({}),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        issueData = _React$useState2[0],
	        setIssueData = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        askRows = _React$useState4[0],
	        setAskRows = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        bidRows = _React$useState6[0],
	        setBidRows = _React$useState6[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref3, asks, bids;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.t0 = setIssueData;
	                            _context.next = 3;
	                            return getIssueData(cusip);
	
	                        case 3:
	                            _context.t1 = _context.sent;
	
	                            if (_context.t1) {
	                                _context.next = 6;
	                                break;
	                            }
	
	                            _context.t1 = {};
	
	                        case 6:
	                            _context.t2 = _context.t1;
	                            (0, _context.t0)(_context.t2);
	                            _context.next = 10;
	                            return getBook(cusip);
	
	                        case 10:
	                            _ref3 = _context.sent;
	                            asks = _ref3.asks;
	                            bids = _ref3.bids;
	
	                            setAskRows(asks);
	                            setBidRows(bids);
	
	                        case 15:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }))();
	
	        return function () {
	            if (lastAjaxAbort) lastAjaxAbort();
	        };
	    }, [cusip]);
	
	    return { issueData: issueData, askRows: askRows, bidRows: bidRows };
	};
	
	var getBook = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(cusip) {
	        var _ref5, data, abort, book;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.prev = 0;
	
	                        if (lastAjaxAbort) lastAjaxAbort();
	
	                        _context2.next = 4;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/offerbook',
	                            method: 'POST',
	                            params: { cusip: cusip }
	                        });
	
	                    case 4:
	                        _ref5 = _context2.sent;
	                        data = _ref5.data;
	                        abort = _ref5.abort;
	
	
	                        lastAjaxAbort = abort;
	                        _context2.next = 10;
	                        return data;
	
	                    case 10:
	                        _context2.t0 = _context2.sent;
	
	                        if (_context2.t0) {
	                            _context2.next = 13;
	                            break;
	                        }
	
	                        _context2.t0 = {};
	
	                    case 13:
	                        book = _context2.t0;
	
	                        lastAjaxAbort = null;
	
	                        return _context2.abrupt('return', {
	                            asks: (0, _twd.arrayFrom)(book.askRows).map(function (r) {
	                                return Object.assign({ cusip: cusip }, r);
	                            }),
	                            bids: (0, _twd.arrayFrom)(book.bidRows).map(function (r) {
	                                return Object.assign({ cusip: cusip }, r);
	                            })
	                        });
	
	                    case 18:
	                        _context2.prev = 18;
	                        _context2.t1 = _context2['catch'](0);
	                        return _context2.abrupt('return', {
	                            asks: [],
	                            bids: []
	                        });
	
	                    case 21:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined, [[0, 18]]);
	    }));
	
	    return function getBook(_x) {
	        return _ref4.apply(this, arguments);
	    };
	}();
	
	var getIssueData = function () {
	    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(cusip) {
	        var _ref7, data, abort, info;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        _context3.prev = 0;
	
	                        if (lastAjaxAbort) lastAjaxAbort();
	
	                        _context3.next = 4;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/cusip/issuedata',
	                            method: 'GET',
	                            params: { cusip: cusip }
	                        });
	
	                    case 4:
	                        _ref7 = _context3.sent;
	                        data = _ref7.data;
	                        abort = _ref7.abort;
	
	
	                        lastAjaxAbort = abort;
	                        _context3.next = 10;
	                        return data;
	
	                    case 10:
	                        _context3.t1 = _context3.sent;
	
	                        if (_context3.t1) {
	                            _context3.next = 13;
	                            break;
	                        }
	
	                        _context3.t1 = {};
	
	                    case 13:
	                        _context3.t0 = _context3.t1.IssueData;
	
	                        if (_context3.t0) {
	                            _context3.next = 16;
	                            break;
	                        }
	
	                        _context3.t0 = {};
	
	                    case 16:
	                        info = _context3.t0;
	
	                        lastAjaxAbort = null;
	
	                        return _context3.abrupt('return', {
	                            holdCusip: info.cusip,
	                            holdIssue: info.issueDisplay,
	                            holdInvType: info.type,
	                            maturity: info.maturity,
	                            moodyRating: info.moodyRating,
	                            spRating: info.spRating,
	                            holdCoupon: info.coupon,
	                            firstCouponDate: info.firstCoupon,
	                            nextCouponDate: info.nextCoupon,
	                            datedDate: info.dated,
	                            holdWarningText: info.warningText,
	                            floaterInd: info.floaterInd
	                        });
	
	                    case 21:
	                        _context3.prev = 21;
	                        _context3.t2 = _context3['catch'](0);
	                        return _context3.abrupt('return', null);
	
	                    case 24:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, undefined, [[0, 21]]);
	    }));
	
	    return function getIssueData(_x2) {
	        return _ref6.apply(this, arguments);
	    };
	}();

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(arg) {
	        var params, _ajax, data, csv, txt, filename, blob, a;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        params = getParams(arg);
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/portfolio/offersearch/export',
	                            method: 'POST',
	                            type: 'text',
	                            headers_: {
	                                'Content-Type': 'application/x-www-form-urlencoded'
	                            },
	                            body: (0, _twd.toQueryString)({
	                                'DATA': JSON.stringify(params),
	                                'BRAND': (0, _twd.getBrand)(),
	                                'SESSIONID': (0, _twd.getSessionId)()
	                            })
	                        }), data = _ajax.data;
	                        _context.next = 4;
	                        return data;
	
	                    case 4:
	                        csv = _context.sent;
	                        txt = csv.split('\n').slice(2).join('\n');
	                        filename = 'Download.csv';
	
	                        if (!navigator.msSaveBlob) {
	                            _context.next = 11;
	                            break;
	                        }
	
	                        blob = new Blob([txt], { type: 'text/csv;charset=utf-8;' });
	
	                        navigator.msSaveBlob(blob, filename);
	                        return _context.abrupt('return');
	
	                    case 11:
	                        a = document.createElement('a');
	
	                        a.download = filename;
	                        a.href = 'data:text/csv;base64,' + btoa(txt);
	                        document.body.appendChild(a);
	                        a.click();
	                        document.body.removeChild(a);
	
	                    case 17:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function (_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var getParams = function getParams(_ref2) {
	    var selection = _ref2.selection,
	        invType = _ref2.invType;
	
	    var cusips = selection.map(function (a) {
	        return a.holdCusip;
	    }).filter(Boolean);
	    var filtered = (0, _twd.getConfig)('entitlements.SuppressedFieldsOnExcelExport', '');
	
	    return {
	        format: "csv",
	        exportName: "offerings",
	        columns: [{ "field": "holdIssue", "text": "Issue" }, { "field": "moodyRating", "text": "Mdy/S&P", "code": { "type": "join", "fields": ["moodyRating", "spRating"], "joiner": " / " } }, { "field": "holdCoupon", "text": "Coupon", "code": { "type": "numFormat", "value": "0.000" } }, { "field": "couponPaymentFreq", "text": "Frequency" }, { "field": "holdMaturity", "text": "Maturity", "code": { "type": "mat" } }, { "field": "holdFirstCall", "text": "Next Call", "code": { "type": "call" } }, { "type": "C", "field": "corpType", "text": "Corp Type" }, { "type": "C", "field": "holdCorpSector", "text": "Corp Sector" }, filtered.indexOf('IDC-FP/FedFIS') >= 0 ? null : { "type": "S", "field": "holdFdicNum", "text": "FDIC Cert #" }, { "type": "M", "field": "holdState", "text": "State" }, { "type": "M", "field": "muniType", "text": "Muni Type" }, { "type": "M", "field": "holdUseOfProceeds", "text": "Muni Purpose" }, { "type": "M", "field": "muniInsurance", "text": "Muni Insurance" }, { "field": "askQuantity", "text": "Ask Qty" }, { "field": "askQtyMin", "text": "Ask Qty Min" }, { "field": "askQtyIncr", "text": "Ask Qty Incr" }, { "field": "askPrice", "text": "Ask Price" }, { "field": "askYield", "text": "Ask YTW", "code": { "type": "yieldInd", "fields": ["askYield", "askYtwInd"] } }, { "field": "askYieldmat", "text": "Ask YTM", "code": { "type": "numFormat", "value": "0.000" } }, { "field": "askSettlement", "text": "Ask Settle" }, { "field": "bidQuantity", "text": "Bid Qty" }, { "field": "bidQtyMin", "text": "Bid Qty Min" }, { "field": "bidQtyIncr", "text": "Bid Qty Incr" }, { "field": "bidPrice", "text": "Bid Price" }, { "field": "bidYield", "text": "Bid YTW", "code": { "type": "yieldInd", "fields": ["bidYield", "bidYtwInd"] } }, { "field": "bidYieldmat", "text": "Bid YTM", "code": { "type": "numFormat", "value": "0.000" } }, { "field": "bidSettlement", "text": "Bid Settle" }].filter(Boolean).filter(function (a) {
	            return !a.type || a.type === invType;
	        }).map(function (_ref3) {
	            var field = _ref3.field,
	                text = _ref3.text,
	                code = _ref3.code;
	            return (0, _twd.cleanObject)({ field: field, text: text, code: code });
	        }),
	
	        searchCriteria: {
	            searchType: "offers",
	            offeringType: ["ask-side", "bid-side"],
	            holdCusip: cusips,
	            holdIdentifiers: cusips,
	            holdIdentifierLabel: "holdCusip",
	            pageNumber: 1,
	            resultsPerPage: cusips.length,
	            sort: [{ "field": "holdMaturitySortDt", "direction": "ASC" }],
	            persistToPreviousSearches: false,
	            marketCheckRequired: false
	        }
	    };
	};

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fixParams = undefined;
	
	var _twd = __webpack_require__(2);
	
	var fixParams = exports.fixParams = function fixParams(values) {
	
	    var p = Object.assign({}, values || {});
	
	    if (p.holdIdentifierLabel === 'holdIsin') {
	        p.holdIsin = getUniqueTexts(p.holdIdentifiers);
	        p.holdIsinExclude = p.holdCusipExclude;
	    }
	    if (p.holdIdentifierLabel === 'holdCusip') {
	        p.holdCusip = getUniqueTexts(p.holdIdentifiers);
	    }
	
	    p.holdIssue = getUniqueTexts(p.holdIssue);
	    p.holdIssueSp = getUniqueTexts(p.holdIssueSp);
	    p.holdSymbol = getUniqueTexts(p.holdSymbol);
	    p.holdSymbolPref = getUniqueTexts(p.holdSymbolPref);
	    p.holdSymbolSp = getUniqueTexts(p.holdSymbolSp);
	
	    var invTypes = (0, _twd.arrayFrom)(p.holdInvType);
	    var cf;
	
	    cf = (0, _twd.arrayFrom)(p.holdCallFeatures);
	    fixParam(cf, p, 'holdCallableInd');
	    fixParam(cf, p, 'holdWholeCallInd');
	    fixParam(cf, p, 'holdPutableInd');
	    fixParam(cf, p, 'holdPutType');
	    if ((0, _twd.isEmpty)(p.holdPutableInd)) p.holdPutType = [];
	    fixParam(cf, p, 'holdErpInd');
	    fixParam(cf, p, 'holdErpInd');
	    if ((0, _twd.isEmpty)(p.holdErpInd)) p.holdErpInd = [];
	    fixParam(cf, p, 'holdNextSink');
	    fixParam(cf, p, 'holdSinkType');
	
	    if (invTypes.indexOf('M') < 0) {
	        p.holdMuniTypePurpose = [];
	        p.holdMuniPurpose = [];
	        p.holdState = [];
	        p.holdTaxability = [];
	        p.holdCorpBacked = [];
	        p.holdCorporationName = [];
	        p.holdInsurance = [];
	    } else {
	        cf = (0, _twd.arrayFrom)(p.holdMuniTypePurpose);
	        fixParam(cf, p, 'holdMuniType');
	        fixParam(cf, p, 'holdBankQualified');
	        fixParam(cf, p, 'holdRefundInd');
	        fixParam(cf, p, 'holdRefundType');
	        if ((0, _twd.isEmpty)(p.holdRefundInd)) p.holdRefundType = [];
	        fixParam(cf, p, 'holdRevenueType');
	        fixParam(cf, p, 'holdFinancingInd');
	        p.holdInsurance = (0, _twd.isEmpty)(p.holdInsurance) ? (0, _twd.arrayFrom)(p.holdInsurance) : p.holdInsurance;
	
	        cf = (0, _twd.arrayFrom)(p.holdMuniPurpose);
	        fixParam(cf, p, 'holdUseOfProceeds');
	        fixParam(cf, p, 'holdIssueType');
	
	        cf = (0, _twd.arrayFrom)(p.holdTaxability);
	        fixParam(cf, p, 'holdTaxable');
	        fixParam(cf, p, 'holdStateTaxExempt');
	        fixParam(cf, p, 'holdAltMinTax');
	    }
	
	    if (invTypes.indexOf('C') < 0) {
	        p.holdCorpTypeValues = [];
	        p.holdIndustryCode = [];
	        p.holdCorpSectorCode = [];
	        p.holdBlueSkyState = [];
	        p.holdRegS = [];
	        p.holdReligiousOrg = [];
	        p.holdSeasonedRegS = [];
	        p.holdCorpType = [];
	        p.holdCorpDebtRanking = [];
	        p.holdSymbol = [];
	        p.holdConvertible = [];
	        p.holdDrnk = [];
	    } else {
	        cf = (0, _twd.arrayFrom)(p.holdCorpTypeValues);
	        fixParam(cf, p, 'holdRegS');
	        fixParam(cf, p, 'holdReligiousOrg');
	        fixParam(cf, p, 'holdConvertible');
	        fixParam(cf, p, 'holdSeasonedRegS');
	        fixParam(cf, p, 'holdCorpType');
	    }
	
	    if (invTypes.indexOf('A') < 0) {
	        p.holdAgencyType = [];
	    }
	
	    if (invTypes.indexOf('T') < 0) {
	        p.holdTreasuryType = [];
	    }
	
	    if (invTypes.indexOf('S') < 0) {
	        p.holdIDCRankMax = [];
	        p.holdIDCRankMin = [];
	        p.holdFedFisRatingMax = [];
	        p.holdFedFisRatingMin = [];
	        p.holdFdicNum = [];
	        p.holdBlueSkyStateCD = [];
	    }
	
	    if (invTypes.indexOf('P') < 0) {
	        p.holdHybridCapital = [];
	        p.holdDrnkPref = [];
	        p.holdSymbolPref = [];
	        p.holdPrefSectorCode = [];
	    }
	
	    if (invTypes.indexOf('L') < 0) {
	        p.holdSymbolSp = [];
	        p.holdIssueSp = [];
	        p.holdIDCRankSpMax = [];
	        p.holdIDCRankSpMin = [];
	        p.holdParticipationClass = [];
	        p.holdPrincipalStatus = [];
	        p.holdStructType = [];
	    }
	
	    var labels = ['holdAcqYtw', 'portTotalValue', 'portAvgDuration', 'portTotalCashValue', 'portCountValue', 'offerYtw', 'offerYtc', 'offerYtm', 'duration', 'convexity'];
	
	    labels.forEach(function (l) {
	        var n = p[l + 'Label'];
	        if (!n) return;
	
	        if (!p.hasOwnProperty(n + 'Min')) {
	            p[n + 'Min'] = p[l + 'Min'];
	        }
	        if (!p.hasOwnProperty(n + 'Max')) {
	            p[n + 'Max'] = p[l + 'Max'];
	        }
	
	        delete p[l + 'Label'];
	    });
	
	    if (Array.isArray(p.holdRatingWatch) && p.holdRatingWatch.length > 0) {
	        var arr = p.holdRatingWatch;
	        p.holdRatingWatchMoodySpAndOr = arr.indexOf('MDY_AND') ? 'AND' : 'OR';
	        p.holdRatingWatchSpFitchAndOr = arr.indexOf('SP_AND') ? 'AND' : 'OR';
	        (0, _twd.arrayRemove)(arr, 'MDY_AND');
	        (0, _twd.arrayRemove)(arr, 'SP_AND');
	    }
	
	    if (Array.isArray(p.holdRatingOutlook) && p.holdRatingOutlook.length > 0) {
	        var _arr = p.holdRatingOutlook;
	        p.holdRatingOutlookMoodySpAndOr = _arr.indexOf('MDY_AND') ? 'AND' : 'OR';
	        (0, _twd.arrayRemove)(_arr, 'MDY_AND');
	    }
	
	    if (!(0, _twd.isEmpty)(p.holdCorpType)) {
	        var _arr2 = p.holdCorpType;
	        var hasForeign = _arr2.indexOf('Supranational') >= 0 || _arr2.indexOf('Emerging') >= 0;
	        if (hasForeign) {
	            (0, _twd.arrayRemove)(_arr2, 'Foreign');
	        }
	    }
	
	    return (0, _twd.cleanObject)(p);
	}; /* eslint-disable no-use-before-define */
	
	
	var fixParam = function fixParam(cf, p, id) {
	    p[id] = p[id] || collectCriteria(cf, id + '-');
	    return p[id];
	};
	
	var getUniqueTexts = function getUniqueTexts(a) {
	    if (Array.isArray(a)) return a;
	
	    if (!(0, _twd.isString)(a)) return [];
	
	    var s = a.split(',').map(function (a) {
	        return a.trim();
	    }).filter(Boolean);
	    return (0, _twd.arrayUnique)(s);
	};
	
	var collectCriteria = function collectCriteria(array, prefix) {
	    var n = prefix.length;
	    return (0, _twd.arrayFrom)(array).filter(function (a) {
	        return (a || "").indexOf(prefix) === 0;
	    }).map(function (a) {
	        return a.substring(n);
	    });
	};

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var showBook = _ref.showBook,
	        allowTrading = _ref.allowTrading,
	        cusip = _ref.holdCusip;
	
	
	    if (!showBook) return '';
	
	    return _react2.default.createElement(
	        'span',
	        {
	            'data-name': 'offerings-book-icon',
	            'data-cusip': cusip,
	            style: { cursor: 'pointer' },
	            onClick: function onClick(e) {
	                (0, _twd.showModal)({
	                    view: 'depth-of-market',
	                    cusip: cusip,
	                    allowTrading: allowTrading,
	                    from: 'offerings',
	                    source: e.target
	                });
	            }
	        },
	        BOOK_ICON
	    );
	};
	
	var BOOK_ICON = _react2.default.createElement(
	    'svg',
	    { viewBox: '0 0 18 14', width: '18', height: '18', 'aria-label': 'Book' },
	    _react2.default.createElement('path', { d: 'M 15 0.375 C 14.167 0.112 13.252 0 12.375 0 C 10.912 0 9.337 0.3 8.25 1.125 C 7.162 0.3 5.587 0 4.125 0 C 2.662 0 1.087 0.3 0 1.125 L 0 12.112 C 0 12.3 0.188 12.487 0.375 12.487 C 0.45 12.487 0.487 12.45 0.562 12.45 C 1.575 11.962 3.037 11.625 4.125 11.625 C 5.587 11.625 7.162 11.925 8.25 12.75 C 9.262 12.112 11.1 11.625 12.375 11.625 C 13.612 11.625 14.887 11.85 15.937 12.412 C 16.012 12.45 16.05 12.45 16.125 12.45 C 16.312 12.45 16.5 12.262 16.5 12.075 L 16.5 1.125 C 16.05 0.787 15.562 0.562 15 0.375 Z M 15 10.5 C 14.175 10.237 13.275 10.125 12.375 10.125 C 11.1 10.125 9.262 10.612 8.25 11.25 L 8.25 2.625 C 9.262 1.987 11.1 1.5 12.375 1.5 C 13.275 1.5 14.175 1.612 15 1.875 L 15 10.5 Z', fill: 'var(--primary-base-color)', 'data-bx-origin': '0 0' }),
	    _react2.default.createElement('path', { d: 'M 12.089 4.058 C 12.749 4.058 13.387 4.125 13.964 4.253 L 13.964 3.113 C 13.372 3 12.734 2.933 12.089 2.933 C 10.814 2.933 9.659 3.15 8.714 3.555 L 8.714 4.8 C 9.562 4.32 10.739 4.058 12.089 4.058 Z', fill: 'var(--primary-base-color)', 'data-bx-origin': '-1.659809 -1.570969' }),
	    _react2.default.createElement('path', { d: 'M 12.15 6.407 C 12.81 6.407 13.448 6.474 14.025 6.602 L 14.025 5.462 C 13.433 5.349 12.795 5.282 12.15 5.282 C 10.875 5.282 9.72 5.499 8.775 5.904 L 8.775 7.149 C 9.623 6.669 10.8 6.407 12.15 6.407 Z', fill: 'var(--primary-base-color)', 'data-bx-origin': '-1.671428 -2.829138' }),
	    _react2.default.createElement('path', { d: 'M 12.263 8.594 C 12.923 8.594 13.561 8.661 14.138 8.789 L 14.138 7.649 C 13.546 7.536 12.908 7.469 12.263 7.469 C 10.988 7.469 9.833 7.686 8.888 8.091 L 8.888 9.336 C 9.736 8.856 10.913 8.594 12.263 8.594 Z', fill: 'var(--primary-base-color)', 'data-bx-origin': '-1.692953 -4.000534' })
	);

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var Last = _ref.Last,
	        invType = _ref.invType,
	        sort = _ref.sort,
	        rows = _ref.rows,
	        selection = _ref.selection,
	        onSelect = _ref.onSelect;
	
	
	    var isNone = invType === '-';
	    var isMuni = invType === 'M';
	    var isCorp = invType === 'C';
	    var isCd = invType === 'S';
	    var isTreasury = invType === 'T';
	    var isAgency = invType === 'A';
	    var showRating = !isNone && !isCd && !isTreasury;
	    var showMarket = !isNone && (isMuni || isCorp || isAgency);
	    return _react2.default.createElement(
	        'thead',
	        null,
	        _react2.default.createElement(
	            'tr',
	            null,
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body', style: { width: '25px', maxWidth: '25px' } },
	                _react2.default.createElement(SelectAll, { rows: rows, selection: selection, onSelect: onSelect })
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                'Qty'
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                'Min'
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                'Incr'
	            ),
	            isMuni && _react2.default.createElement(
	                'th',
	                { className: 'text-body' },
	                'State'
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body', style: { maxWidth: '250px' } },
	                _react2.default.createElement(
	                    SortLink,
	                    { Last: Last, sort: sort, field: 'holdIssue' },
	                    'Issuer'
	                )
	            ),
	            isCd && _react2.default.createElement(
	                'th',
	                { className: 'text-body' },
	                'FDIC #'
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                _react2.default.createElement(
	                    SortLink,
	                    { Last: Last, sort: sort, field: 'holdCoupon' },
	                    'Coupon'
	                )
	            ),
	            isCd && _react2.default.createElement(
	                'th',
	                { className: 'text-body' },
	                'Coupon frequency'
	            ),
	            isCd && _react2.default.createElement(
	                'th',
	                { className: 'text-body' },
	                'Coupon type'
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                _react2.default.createElement(
	                    SortLink,
	                    { Last: Last, sort: sort, field: 'holdMaturitySortDt' },
	                    'Maturity'
	                )
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                _react2.default.createElement(
	                    SortLink,
	                    { Last: Last, sort: sort, field: 'askPrice' },
	                    'Price'
	                )
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-center' },
	                'Book'
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                _react2.default.createElement(
	                    SortLink,
	                    { Last: Last, sort: sort, field: 'askYieldmat' },
	                    'YTM'
	                )
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-right' },
	                _react2.default.createElement(
	                    SortLink,
	                    { Last: Last, sort: sort, field: 'askYield' },
	                    'YTW'
	                )
	            ),
	            showRating && _react2.default.createElement(
	                'th',
	                { className: 'text-body', colSpan: '2', style: { whiteSpace: 'nowrap' } },
	                'Moody\'s / S&P'
	            ),
	            showMarket && _react2.default.createElement(
	                'th',
	                { className: 'text-body' },
	                'Market check'
	            ),
	            _react2.default.createElement(
	                'th',
	                { className: 'text-body text-center', style: { maxWidth: '55px' } },
	                '\xA0'
	            )
	        )
	    );
	};
	
	var SelectAll = function SelectAll(_ref2) {
	    var rows = _ref2.rows,
	        selection = _ref2.selection,
	        onSelect = _ref2.onSelect;
	
	    var id = (0, _twd.getId)();
	    var n = (0, _twd.arrayFrom)(selection).length;
	    var isAll = n > 0 && n >= (0, _twd.arrayFrom)(rows).length;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'checkbox', style: { margin: 0 } },
	        _react2.default.createElement('input', {
	            'data-name': 'offerings-header-select-all',
	
	            type: 'checkbox',
	            id: id,
	            checked: isAll,
	            onChange: function onChange() {
	                return setTimeout(onSelect(!isAll));
	            }
	        }),
	        _react2.default.createElement('label', { htmlFor: id })
	    );
	};
	
	var SortLink = function SortLink(_ref3) {
	    var Last = _ref3.Last,
	        field = _ref3.field,
	        sort = _ref3.sort,
	        children = _ref3.children;
	
	    var _ref4 = sort || { field: 'holdMaturitySortDt', direction: 'ASC' },
	        sortField = _ref4.field,
	        sortDirection = _ref4.direction;
	
	    var isSorted = field === sortField;
	    var isAsc = sortDirection === 'ASC';
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'button',
	            {
	                'data-name': 'offerings-header-sort',
	                'data-field': field,
	                'data-direction': isSorted && isAsc ? 'DESC' : 'ASC',
	
	                className: 'btn-link text-body',
	                style: { cursor: 'pointer', color: '#767676', whiteSpace: 'nowrap' },
	                onClick: function onClick() {
	                    var direction = isSorted && isAsc ? 'DESC' : 'ASC';
	                    onSortChange(Last, { field: field, direction: direction });
	                }
	            },
	            children,
	            isSorted && (sortDirection === 'ASC' ? _react2.default.createElement(
	                'i',
	                { className: 'material-icons' },
	                'arrow_drop_up'
	            ) : _react2.default.createElement(
	                'i',
	                { className: 'material-icons' },
	                'arrow_drop_down'
	            ))
	        )
	    );
	};
	
	var onSortChange = function onSortChange(Last, _ref5) {
	    var field = _ref5.field,
	        direction = _ref5.direction;
	
	
	    var ps = Object.assign({}, Last.clone().params || {});
	    ps.sort = [{ field: field, direction: direction }];
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: (0, _twd.cleanObject)(ps),
	        _ts: Date.now(),
	        from: Last.value.from
	    }));
	};

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _formatBook = __webpack_require__(1009);
	
	var _formatBook2 = _interopRequireDefault(_formatBook);
	
	var _gridHeader = __webpack_require__(1010);
	
	var _gridHeader2 = _interopRequireDefault(_gridHeader);
	
	var _marketCheck = __webpack_require__(1012);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var Last = _ref.Last,
	        invType = _ref.invType,
	        rows = _ref.rows,
	        sort = _ref.sort,
	        status = _ref.status,
	        selection = _ref.selection,
	        onSelect = _ref.onSelect;
	
	
	    if (status !== _twd.Status.LOADED && rows.length === 0) {
	        return null;
	    }
	
	    var isNone = invType === '-';
	    var isMuni = invType === 'M';
	    var isCorp = invType === 'C';
	    var isCd = invType === 'S';
	    var isTreasury = invType === 'T';
	    var isAgency = invType === 'A';
	    var showRating = !isNone && !isCd && !isTreasury;
	    var showMarket = !isNone && (isMuni || isCorp || isAgency);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            {
	                'data-name': 'offerings-table',
	                style: { borderTop: '2px solid #e4e4e4' },
	                className: 'table table-hover table-striped align-top'
	            },
	            _react2.default.createElement(_gridHeader2.default, { Last: Last, invType: invType, sort: sort, rows: rows, selection: selection, onSelect: onSelect }),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rows && rows.map(function (r, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        {
	                            'data-name': 'offerings-row',
	                            key: i },
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-center',
	                                style: { width: '25px', maxWidth: '25px', verticalAlign: 'middle' } },
	                            formatCheckbox({ row: r, selection: selection, onSelect: onSelect })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(_twd.fmt.qty(r.askQuantity)),
	                            _react2.default.createElement('br', null),
	                            bidItem(_twd.fmt.qty(r.bidQuantity))
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(_twd.fmt.qty(r.askQtyMin)),
	                            _react2.default.createElement('br', null),
	                            bidItem(_twd.fmt.qty(r.bidQtyMin))
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(_twd.fmt.qty(r.askQtyIncr)),
	                            _react2.default.createElement('br', null),
	                            bidItem(_twd.fmt.qty(r.bidQtyIncr))
	                        ),
	                        isMuni && _react2.default.createElement(
	                            'td',
	                            { className: 'text-center' },
	                            r.holdState
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { style: { maxWidth: '250px' } },
	                            _twd.fmt.issuer({
	                                issuer: r.holdIssue,
	                                cusip: r.holdCusip,
	                                offers: r,
	                                showTradeHistory: 'Y',
	                                from: 'offerings'
	                            }),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('label', { className: 'label-small',
	                                style: { whiteSpace: 'normal' },
	                                dangerouslySetInnerHTML: { __html: _twd.fmt.warningText(r.holdWarningText) }
	                            })
	                        ),
	                        isCd && _react2.default.createElement(
	                            'td',
	                            null,
	                            r.holdFdicNum
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            formatCoupon(r)
	                        ),
	                        isCd && _react2.default.createElement(
	                            'td',
	                            null,
	                            r.couponPaymentFreq
	                        ),
	                        isCd && _react2.default.createElement(
	                            'td',
	                            null,
	                            formatCouponType(r)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            r.holdMaturity
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(_twd.fmt.price(r.askPrice)),
	                            _react2.default.createElement('br', null),
	                            bidItem(_twd.fmt.price(r.bidPrice))
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-center' },
	                            (0, _formatBook2.default)(r)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(_twd.fmt.ytw(r.askYieldmat)),
	                            _react2.default.createElement('br', null),
	                            bidItem(_twd.fmt.ytw(r.bidYieldmat))
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(formatYield(r.askYield, r.askYtwInd)),
	                            _react2.default.createElement('br', null),
	                            bidItem(formatYield(r.bidYield, r.bidYtwInd))
	                        ),
	                        showRating && _react2.default.createElement(
	                            'td',
	                            { style: { whiteSpace: 'nowrap' } },
	                            pdfIcon(r),
	                            ' ',
	                            r.moodyRating
	                        ),
	                        showRating && _react2.default.createElement(
	                            'td',
	                            null,
	                            r.spRating
	                        ),
	                        showMarket && _react2.default.createElement(
	                            'td',
	                            { style: { maxWidth: '120px' } },
	                            _react2.default.createElement(_marketCheck.MarketCheck, r)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-center', style: { maxWidth: '55px' } },
	                            formatOrder(r)
	                        )
	                    );
	                })
	            ),
	            _react2.default.createElement(
	                'tfoot',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        { colSpan: '18' },
	                        '(c) Yield to Call, (dis) Discount Yield, (f) Called in Full, (n) Floating/Variable Rate, (p) Yield to Par Call, (r) Pre-Refund, (t) Put, (w) Yield to Middle Call'
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var askItem = function askItem(txt) {
	    return _react2.default.createElement(
	        'span',
	        { style: { color: 'green' } },
	        txt
	    );
	};
	var bidItem = function bidItem(txt) {
	    return _react2.default.createElement(
	        'span',
	        { style: { color: 'red' } },
	        txt
	    );
	};
	
	var formatCheckbox = function formatCheckbox(_ref2) {
	    var row = _ref2.row,
	        selection = _ref2.selection,
	        onSelect = _ref2.onSelect;
	
	    var id = (0, _twd.getId)();
	    return _react2.default.createElement(
	        'div',
	        { className: 'checkbox' },
	        _react2.default.createElement('input', {
	            'data-name': 'offerings-select',
	            type: 'checkbox',
	            id: id,
	            checked: (0, _twd.arrayFrom)(selection).indexOf(row) >= 0,
	            onChange: function onChange() {
	                return onSelect(row);
	            }
	        }),
	        _react2.default.createElement('label', { htmlFor: id })
	    );
	};
	
	var formatCoupon = function formatCoupon(_ref3) {
	    var holdCoupon = _ref3.holdCoupon,
	        holdCouponTypeCode = _ref3.holdCouponTypeCode,
	        holdCouponFixedToFloat = _ref3.holdCouponFixedToFloat;
	
	    var isFLT = holdCouponTypeCode === 'E';
	    var isF2F = holdCouponFixedToFloat === 'Y';
	
	    if (isFLT) {
	        return !isF2F ? 'FLT' : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _twd.fmt.cpn(holdCoupon),
	            _react2.default.createElement('br', null),
	            'F2F'
	        );
	    }
	    return _twd.fmt.cpn(holdCoupon);
	};
	
	var formatCouponType = function formatCouponType(r) {
	    var c = r.holdCouponTypeCode;
	    if (c === 'B') return 'Zero';
	    if (['A', 'C', 'F', 'K', 'N'].indexOf(c) >= 0) return 'Fixed, Non-Zero';
	    if (r.holdCouponFixedToFloat === 'Y') return 'Fixed to Float, Fixed';
	    if ((0, _twd.arrayFrom)(r.holdStepSchedule).length > 1) return 'Multi-Step';
	    if (['D', 'I', 'G'].indexOf(c) >= 0) return 'Floating';
	    return '-';
	};
	
	var formatYield = function formatYield(val, ind) {
	    var x = Number.parseFloat(val);
	    if (isNaN(x)) return _twd.fmt.empty();
	
	    var y = _twd.fmt.ytw(x);
	    if (!ind) return y;
	    ind = ind.toLowerCase();
	    if (['c', 'dis', 'f', 'n', 'p', 'r', 't', 'w'].indexOf(ind) < 0) return y;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        y,
	        ' (',
	        ind,
	        ')'
	    );
	};
	
	var formatOrder = function formatOrder(r) {
	    if (r.allowTrading === false) return _twd.fmt.orderPhone();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            r.askQuantity && _twd.fmt.buy({ cusip: r.holdCusip, from: 'offerings', extraClassName: 'vertical-offset-xxs' }),
	            !r.askQuantity && _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            r.bidQuantity && _twd.fmt.sell({ cusip: r.holdCusip, from: 'offerings' })
	        )
	    );
	};
	
	var pdfIcon = function pdfIcon(_ref4) {
	    var moodyRating = _ref4.moodyRating,
	        cusip = _ref4.holdCusip;
	
	    if (!moodyRating) return null;
	
	    return _react2.default.createElement(
	        'a',
	        { href: '#',
	            'data-name': 'offerings-pdf-icon',
	            style: { cursor: 'pointer' },
	            onClick: function onClick() {
	                var url = '/esb/moodysreport/getBondReport?cusip=' + cusip;
	                (0, _twd.openWindow)(url);
	            }
	        },
	        _react2.default.createElement(
	            'i',
	            { className: 'material-icons', 'aria-hidden': 'true' },
	            'picture_as_pdf'
	        )
	    );
	};

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MarketCheck = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1780);
	
	var _twd = __webpack_require__(2);
	
	var _loader = __webpack_require__(1014);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var MarketCheck = exports.MarketCheck = function MarketCheck(_ref) {
	    var askId = _ref.askId,
	        askPrice = _ref.askPrice,
	        askQuantity = _ref.askQuantity,
	        highYieldInd = _ref.highYieldInd,
	        holdCusip = _ref.holdCusip,
	        holdInvType = _ref.holdInvType,
	        marketCheck = _ref.marketCheck,
	        askOwn = _ref.askOwn;
	
	
	    var icon = void 0,
	        label = void 0;
	    switch (marketCheck) {
	        case 'P':
	        case 'p':
	            icon = iconAligned;
	            label = 'Aligned';
	            break;
	        case 'F':
	        case 'f':
	            icon = iconHigher;
	            label = 'Higher';
	            break;
	        case 'I':
	        case 'i':
	            icon = iconIssuficientData;
	            label = 'Insufficient data';break;
	        case 'Z':
	        case 'z':
	            icon = askOwn === 'Y' ? iconHigher : '';
	            label = askOwn === 'Y' ? 'Higher' : '';
	            break;
	        default:
	            icon = '';
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'span',
	            {
	                style: {
	                    display: 'inline-block',
	                    whiteSpace: 'nowrap'
	                },
	                'data-cusip': holdCusip,
	
	                onMouseOver: function onMouseOver(event) {
	                    event.persist();
	                    showMarketcheck(event, askId, askPrice, askQuantity, highYieldInd, holdCusip, holdInvType);
	                }
	            },
	            icon && _react2.default.createElement(
	                'div',
	                { style: iconStyle },
	                icon
	            ),
	            label && _react2.default.createElement(
	                'div',
	                { style: labelStyle },
	                label
	            )
	        )
	    );
	};
	
	var showMarketcheck = (0, _twd.bufferedFn)(function (event, askId, askPrice, askQuantity, highYieldInd, holdCusip, holdInvType) {
	    (0, _twd.publish)('show_flyout', {
	        el: event.target,
	        showIcon: false,
	        html: _react2.default.createElement(_loader.Loader, { askId: askId, askPrice: askPrice, askQuantity: askQuantity, highYieldInd: highYieldInd, holdCusip: holdCusip, holdInvType: holdInvType }),
	        contentStyle: { maxWidth: '600px', width: '597px' },
	        popperStyles: {
	            maxWidth: Math.min(_twd.mediaQueries.width() - 40, 600) + 'px'
	        }
	    });
	}, 100);
	
	var iconAligned = _react2.default.createElement(
	    'svg',
	    { width: '10', height: '10', viewBox: '0 0 10 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement('circle', { cx: '5', cy: '5', r: '5', fill: '#63AD02' })
	);
	var iconHigher = _react2.default.createElement(
	    'svg',
	    { width: '14', height: '11', viewBox: '0 0 14 11', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement('path', { d: 'M7 0L13.0622 10.5H0.937822L7 0Z', fill: '#D28720' })
	);
	var iconIssuficientData = _react2.default.createElement(
	    'svg',
	    { width: '10', height: '10', viewBox: '0 0 10 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	    _react2.default.createElement('circle', { cx: '5', cy: '5', r: '4.5', fill: 'white', stroke: 'black' })
	);
	
	var iconStyle = {
	    display: 'inline-block',
	    paddingRight: '5px',
	    verticalAlign: 'top'
	};
	
	var labelStyle = {
	    display: 'inline-block',
	    maxWidth: '75px',
	    whiteSpace: 'normal'
	};

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getMarketCheckData = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var lastAjaxAbort;
	
	var lastSign = '';
	var lastHtml = '';
	var lastTs = 0;
	
	var getMarketCheckData = exports.getMarketCheckData = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	        var askId = _ref.askId,
	            askPrice = _ref.askPrice,
	            askQuantity = _ref.askQuantity,
	            highYieldInd = _ref.highYieldInd,
	            holdCusip = _ref.holdCusip,
	            holdInvType = _ref.holdInvType;
	
	        var params, sign, _ref3, data, abort, html;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	
	                        if (lastAjaxAbort) lastAjaxAbort();
	
	                        params = {
	                            cusip: holdCusip,
	                            askId: askId || '',
	                            invType: holdInvType,
	                            askQty: numberFrom(askQuantity, null),
	                            price: numberFrom(askPrice, null),
	                            highYield: highYieldInd || 'N',
	                            action: 'B',
	                            outputFormat: 'HTMLBW'
	                        };
	                        sign = Object.values(params).join('');
	
	                        if (!(lastSign === sign && Date.now() - lastTs < 60000)) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return', lastHtml);
	
	                    case 6:
	
	                        lastSign = '';
	                        lastTs = 0;
	
	                        _context.next = 10;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/marketcheckpopup',
	                            method: 'POST',
	                            type: 'text',
	                            params: params
	                        });
	
	                    case 10:
	                        _ref3 = _context.sent;
	                        data = _ref3.data;
	                        abort = _ref3.abort;
	
	
	                        lastAjaxAbort = abort;
	                        _context.t0 = formatHtml;
	                        _context.next = 17;
	                        return data;
	
	                    case 17:
	                        _context.t1 = _context.sent;
	
	                        if (_context.t1) {
	                            _context.next = 20;
	                            break;
	                        }
	
	                        _context.t1 = '';
	
	                    case 20:
	                        _context.t2 = _context.t1;
	                        html = (0, _context.t0)(_context.t2);
	
	                        lastAjaxAbort = null;
	
	                        lastSign = sign;
	                        lastHtml = html;
	                        lastTs = Date.now();
	
	                        return _context.abrupt('return', html);
	
	                    case 29:
	                        _context.prev = 29;
	                        _context.t3 = _context['catch'](0);
	                        return _context.abrupt('return', null);
	
	                    case 32:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[0, 29]]);
	    }));
	
	    return function getMarketCheckData(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var numberFrom = function numberFrom(a, b) {
	    if (isFinite(a)) a = parseFloat(a);
	    return !isNaN(a) ? a : b;
	};
	
	var formatHtml = function formatHtml(html) {
	    if (!html) return '';
	
	    html = html.replace('/styles/monarch/images/bd-', 'resources/images/twd-');
	
	    html = html.replace(/<span [^>]*>Go to MarketView<\/span>/, '');
	
	    return html.replace(/<span [^>]*>View All<\/span>/g, '');
	};

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Loader = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	/* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _parse = __webpack_require__(332);
	
	var _getMarketCheckData = __webpack_require__(1013);
	
	var _loading = __webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Loader = exports.Loader = function Loader(_ref) {
	    var askId = _ref.askId,
	        askPrice = _ref.askPrice,
	        askQuantity = _ref.askQuantity,
	        highYieldInd = _ref.highYieldInd,
	        holdCusip = _ref.holdCusip,
	        holdInvType = _ref.holdInvType;
	
	    var _React$useState = _react2.default.useState('loading'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(null),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        marketcheckData = _React$useState4[0],
	        setMarketcheckData = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        var cancelled = false;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var data_;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return (0, _getMarketCheckData.getMarketCheckData)({
	                                askId: askId,
	                                askPrice: askPrice,
	                                askQuantity: askQuantity,
	                                highYieldInd: highYieldInd,
	                                holdCusip: holdCusip,
	                                holdInvType: holdInvType
	                            });
	
	                        case 2:
	                            data_ = _context.sent;
	
	                            if (!cancelled) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 5:
	                            if (!(data_ === undefined)) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            setStatus('failed');
	                            return _context.abrupt('return');
	
	                        case 8:
	                            if (data_) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            setStatus('not-found');
	                            return _context.abrupt('return');
	
	                        case 11:
	
	                            setStatus('found');
	                            setMarketcheckData(data_);
	
	                        case 13:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }))();
	
	        return function () {
	            cancelled = true;
	        };
	    }, []);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            status === 'loading' ? _react2.default.createElement(_loading.Loading, null) : status === 'found' ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _parse.parseHtml)(marketcheckData) } }) : null
	        )
	    );
	};

/***/ },
/* 1015 */
955,
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var rows = _ref.rows,
	        from = _ref.from;
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            {
	                'data-name': 'offerings-modal-table',
	                className: 'table align-top' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'CUSIP'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Maturity date'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Price'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Coupon'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Yield'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Moody\'s'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'S&P'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Action'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rows && rows.map(function (r, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        {
	                            'data-name': 'offerings-modal-row',
	                            key: i },
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-bold' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#',
	                                    type: 'button',
	                                    'data-name': 'offerings-modal-cusip-link',
	                                    style: { cursor: 'pointer' },
	                                    onClick: function onClick() {
	                                        (0, _twd.hideModal)();
	                                        (0, _twd.show)('bond-detail', { cusip: r.holdCusip, from: from });
	                                    }
	                                },
	                                r.holdCusip
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            r.holdMaturity
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _twd.fmt.price(r.askPrice)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _twd.fmt.cpn(r.holdCoupon)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _twd.fmt.ytw(r.askYield)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            r.moodyRating || _twd.fmt.empty()
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            r.spRating || _twd.fmt.empty()
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _twd.fmt.buy({ cusip: r.holdCusip, from: from })
	                        )
	                    );
	                })
	            )
	        )
	    );
	};

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _grid = __webpack_require__(1016);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _viewMore = __webpack_require__(475);
	
	var _viewMore2 = _interopRequireDefault(_viewMore);
	
	var _useOfferingsModal2 = __webpack_require__(1018);
	
	var _useOfferingsModal3 = _interopRequireDefault(_useOfferingsModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var name = _ref.name,
	        maturity = _ref.maturity,
	        ts = _ref.ts,
	        params = _ref.params,
	        from = _ref.from;
	
	    var _useOfferingsModal = (0, _useOfferingsModal3.default)({ name: name, ts: ts, params: params, maturity: maturity }),
	        matTerm = _useOfferingsModal.matTerm,
	        status = _useOfferingsModal.status,
	        rows = _useOfferingsModal.rows,
	        count = _useOfferingsModal.count,
	        page = _useOfferingsModal.page,
	        reset = _useOfferingsModal.reset,
	        setPage = _useOfferingsModal.setPage;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'offerings-modal-close-link',
	                className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container', style: { background: "#ffffff" } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'close',
	                                    'aria-label': 'close',
	                                    'data-name': 'offerings-modal-close-link',
	                                    type: 'button',
	                                    onClick: function onClick() {
	                                        reset();
	                                        (0, _twd.hideModal)();
	                                    } },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'close'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-9' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    name
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-3 text-right text-small' },
	                            'As of ',
	                            _twd.fmt.mdy(new Date())
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6 col-xs-12' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'select-wrapper' },
	                                _react2.default.createElement(_twd.Fields.Select, {
	                                    label: 'Maturity range',
	                                    'data-name': 'offerings-modal-maturity-range',
	                                    id: 'offerings-modal-maturity-range',
	                                    value: matTerm,
	                                    className: 'form-control',
	                                    onChange: function onChange() {},
	                                    options: [{
	                                        value: 'LT_3', label: 'Shorter term (<3 years)'
	                                    }, {
	                                        value: "3_TO_5", label: "Shorter term (3-5 years)"
	                                    }, {
	                                        value: "5_TO_10", label: "Medium term (5-10 years)"
	                                    }, {
	                                        value: "10_TO_20", label: "Longer term (10-20 years)"
	                                    }, {
	                                        value: "GT_20", label: "Longer term (>20 years)"
	                                    }, {
	                                        value: "ALL", label: "All"
	                                    }]
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-3 col-xs-12' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'button',
	                                    'data-name': 'offerings-modal-update-results-button',
	                                    className: 'btn btn-primary-outline btn-block',
	                                    onClick: function onClick() {
	                                        var v = (0, _twd.$)('#offerings-modal-maturity-range').val();
	                                        reset(v);
	                                    }
	                                },
	                                'Update results'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(_grid2.default, { rows: rows, from: from }),
	                        _react2.default.createElement(_viewMore2.default, {
	                            rows: rows,
	                            status: status,
	                            count: count,
	                            onLoadMore: function onLoadMore() {
	                                setPage(page + 1);
	                            } })
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function (_ref) {
	    var name = _ref.name,
	        maturity = _ref.maturity,
	        _ts = _ref.ts,
	        params = _ref.params;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        rows = _React$useState4[0],
	        setRows = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(0),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        count = _React$useState6[0],
	        setCount = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(1),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        page = _React$useState8[0],
	        setPage = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(maturity || 'LT_3'),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        matTerm = _React$useState10[0],
	        setMatTerm = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState(_ts || 0),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        ts = _React$useState12[0],
	        setTs = _React$useState12[1];
	
	    _react2.default.useEffect(function () {
	        setStatus(_twd.Status.LOADING);
	        if (ts === 0) return;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var p, _ref3, data, a, filtered;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            p = Object.assign({
	                                searchType: 'offers',
	                                pageNumber: page,
	                                resultsPerPage: 10,
	                                offeringType: ['ask-side'],
	                                marketCheckRequired: true,
	                                sort: [{
	                                    field: 'askYield',
	                                    direction: 'DESC'
	                                }]
	                            }, params, getMatTermParams(matTerm));
	                            _context.next = 4;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/offersearch',
	                                method: 'POST',
	                                params: p
	                            });
	
	                        case 4:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            a = _context.sent;
	                            filtered = 0;
	
	                            a.rows = (rows || []).concat(a.rows).map(function (r) {
	                                var marketCheck = r.marketCheck;
	
	                                if (marketCheck === 'z' || marketCheck === 'Z') {
	                                    filtered++;
	                                    return null;
	                                }
	                                return r;
	                            }).filter(Boolean);
	
	                            setRows(a.rows);
	                            setCount(a.resultSetCount - filtered);
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 19;
	                            break;
	
	                        case 16:
	                            _context.prev = 16;
	                            _context.t0 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 19:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 16]]);
	        }))();
	    }, [ts, name, page, matTerm]);
	
	    var reset = function reset(matTerm) {
	        setRows([]);
	        setPage(1);
	        setCount(0);
	        setMatTerm(matTerm || 'LT_3');
	        setTs(matTerm ? Date.now() : 0);
	    };
	
	    return { status: status, rows: rows, count: count, page: page, setPage: setPage, setRows: setRows, setMatTerm: setMatTerm, matTerm: matTerm, reset: reset, setTs: setTs };
	};
	
	var getMatTermParams = function getMatTermParams(term) {
	    return {
	        'LT_3': { holdMaturityMax: '3y' },
	        '3_TO_5': { holdMaturityMin: '3y', holdMaturityMax: '5y' },
	        '5_TO_10': { holdMaturityMin: '5y', holdMaturityMax: '10y' },
	        '10_TO_20': { holdMaturityMin: '10y', holdMaturityMax: '20y' },
	        'GT_20': { holdMaturityMin: '20y' }
	    }[term] || {};
	};

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOfferings2 = __webpack_require__(1021);
	
	var _useOfferings3 = _interopRequireDefault(_useOfferings2);
	
	var _criteria = __webpack_require__(1002);
	
	var _criteria2 = _interopRequireDefault(_criteria);
	
	var _grid = __webpack_require__(1011);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _viewMore = __webpack_require__(475);
	
	var _viewMore2 = _interopRequireDefault(_viewMore);
	
	var _twd = __webpack_require__(2);
	
	var _saveSearchButton = __webpack_require__(461);
	
	var _selection = __webpack_require__(1020);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var searchParams = _ref.searchParams,
	        _ts = _ref._ts,
	        from = _ref.from,
	        backFrom = _ref.backFrom;
	
	    (0, _twd.trackPage)('search-results');
	
	    var _useOfferings = (0, _useOfferings3.default)({ searchParams: searchParams, _ts: _ts, from: from, backFrom: backFrom }),
	        Last = _useOfferings.Last,
	        params = _useOfferings.params,
	        status = _useOfferings.status,
	        rows = _useOfferings.rows,
	        invType = _useOfferings.invType,
	        count = _useOfferings.count,
	        selection = _useOfferings.selection,
	        onSelect = _useOfferings.onSelect,
	        clearSelection = _useOfferings.clearSelection,
	        onLoadMore = _useOfferings.onLoadMore;
	
	    var invTypeTitle = {
	        'C': 'Corporate bonds',
	        'M': 'Municipal bonds',
	        'S': 'CDs',
	        'T': 'U.S. Treasuries',
	        'A': 'Agency bonds'
	    }[invType] || '';
	
	    var sortType = (0, _twd.arrayFrom)((params || {}).sort)[0];
	
	    var hasHighYield = (0, _twd.arrayFrom)(rows).find(function (r) {
	        return r.highYieldInd === 'Y';
	    });
	    var hasStructuredProduct = (0, _twd.arrayFrom)(rows).find(function (r) {
	        return r.holdSpInd === 'Y';
	    });
	    var isBondLookup = invType === '-';
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        { style: { display: 'inline' } },
	                        invTypeTitle || 'Bonds'
	                    ),
	                    '\xA0\xA0',
	                    _twd.fmt.count(count),
	                    ' results \xA0\xA0',
	                    !isBondLookup && _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            'data-name': 'offerings-edit-search-criteria',
	                            style: { cursor: 'pointer' },
	                            onClick: function onClick() {
	                                var sp = (0, _useOfferings2.toParams)(Last.value.params, 1);
	                                if (invType === 'M' && !sp.holdCusip && !sp.holdState) {
	                                    sp.holdState = [];
	                                }
	                                if (invType === 'S' && !sp.holdCusip && !sp.holdBlueSkyStateCD) {
	                                    sp.holdBlueSkyStateCD = [];
	                                }
	                                sp.isEdit = true;
	
	                                if (!('holdInvType' in sp)) {
	                                    var cs = Last.value.searchCriteria || [];
	                                    var ts = cs.filter(function (c) {
	                                        return c.code.indexOf('holdInvType') === 0;
	                                    }).map(function (c) {
	                                        return c.code.split('-')[1];
	                                    }).filter(Boolean);
	                                    if (ts.length === 1) sp.holdInvType = ts[0];
	                                }
	
	                                if (!('holdInvType' in sp)) {
	                                    var _ts2 = (0, _twd.arrayUnique)((0, _twd.arrayFrom)(rows).map(function (r) {
	                                        return r.holdInvType;
	                                    }));
	                                    if (_ts2.length === 1) sp.holdInvType = _ts2[0];
	                                }
	
	                                (0, _twd.show)('advanced-screener', {
	                                    searchParams: sp,
	                                    _ts: Date.now(),
	                                    from: Last.value.from
	                                });
	                            }
	                        },
	                        'Edit search criteria'
	                    ),
	                    '\xA0 \xA0',
	                    _react2.default.createElement(
	                        'a',
	                        { href: '#',
	                            'data-name': 'offerings-save-this-search',
	                            style: { cursor: 'pointer' },
	                            onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                        switch (_context.prev = _context.next) {
	                                            case 0:
	                                                _context.next = 2;
	                                                return (0, _saveSearchButton.saveSearch)({ values: Last.value.params });
	
	                                            case 2:
	                                            case 'end':
	                                                return _context.stop();
	                                        }
	                                    }
	                                }, _callee, undefined);
	                            }))
	                        },
	                        'Save this search'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'container', style: { background: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: hasHighYield ? "row vertical-offset-xs" : "row vertical-offset-base" },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(_criteria2.default, { Last: Last })
	                )
	            ),
	            hasHighYield && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'universal-message universal-message-info', role: 'status' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'universal-message-content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'universal-message-heading' },
	                                'High yield bonds are riskier than investment grade bonds.'
	                            )
	                        )
	                    )
	                )
	            ),
	            hasStructuredProduct && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'universal-message universal-message-info', role: 'status' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'universal-message-content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'universal-message-heading' },
	                                'Search results include Structured Products, which have unique risks.'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(_grid2.default, {
	                        Last: Last,
	                        invType: invType,
	                        rows: rows, sort: sortType,
	                        status: status,
	                        selection: selection,
	                        onSelect: onSelect }),
	                    _react2.default.createElement(_viewMore2.default, {
	                        pageSize: params.resultsPerPage || 10,
	                        rows: rows,
	                        status: status,
	                        count: count,
	                        onLoadMore: onLoadMore })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-lg' },
	                '\xA0'
	            ),
	            _react2.default.createElement(_selection2.default, {
	                invType: invType,
	                selection: selection,
	                clearSelection: clearSelection })
	        )
	    );
	};

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _download = __webpack_require__(1007);
	
	var _download2 = _interopRequireDefault(_download);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function (_ref) {
	    var selection = _ref.selection,
	        clearSelection = _ref.clearSelection,
	        invType = _ref.invType;
	
	
	    var barRef = _react2.default.useRef();
	    _react2.default.useEffect(function () {
	        var el = (0, _twd.$)(barRef.current);
	        var fn = function fn() {
	            var w = el.parent().width() - 30 - (_twd.mediaQueries.isNotXs() ? 5 : 0);
	            el.width(w);
	        };
	
	        fn();
	        el.show();
	        (0, _twd.$)(window).resize(fn);
	
	        return function () {
	            (0, _twd.$)(window).off('resize', fn);
	        };
	    }, [selection]);
	
	    var _React$useState = _react2.default.useState(''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var arr = (0, _twd.arrayFrom)(selection);
	    if (arr.length === 0) return '';
	
	    var isBlue = (0, _twd.getConfig)('entitlements.ETradeBlue', 'No') === 'Yes';
	    return _react2.default.createElement(
	        'div',
	        {
	            ref: barRef,
	            style: { display: 'none' },
	            className: 'snackbar-fixed vertical-offset-xs snackbar' },
	        _react2.default.createElement(
	            'div',
	            { className: 'snackbar-left vertical-offset-xs-xs vertical-offset-sm-clear' },
	            _react2.default.createElement(
	                'span',
	                { className: isBlue ? 'snackbar-blue-label' : '' },
	                arr.length,
	                ' selected'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'snackbar-right' },
	            _react2.default.createElement(
	                'button',
	                {
	                    'data-name': 'offerings-selection-download-to-csv',
	                    className: "btn btn-lg vertical-offset-xs-xs vertical-offset-sm-clear btn-primary" + (isBlue ? ' snackbar-blue-btn-action' : ''),
	                    type: 'button',
	                    disabled: status === 'DOWNLOADING',
	                    onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                        return _regenerator2.default.wrap(function _callee$(_context) {
	                            while (1) {
	                                switch (_context.prev = _context.next) {
	                                    case 0:
	                                        setStatus('DOWNLOADING');
	                                        _context.next = 3;
	                                        return (0, _download2.default)({ invType: invType, selection: selection });
	
	                                    case 3:
	                                        setStatus('');
	
	                                    case 4:
	                                    case 'end':
	                                        return _context.stop();
	                                }
	                            }
	                        }, _callee, undefined);
	                    }))
	                },
	                'Download to .csv'
	            ),
	            _react2.default.createElement(
	                'span',
	                {
	                    style: isBlue ? { paddingRight: '5px' } : {},
	                    className: 'text-center' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'offerings-selection-cancel',
	                        className: isBlue ? 'btn btn-lg vertical-offset-xs-xs vertical-offset-sm-clear btn-primary snackbar-blue-btn-action-alt' : "btn-link",
	                        type: 'button',
	                        onClick: clearSelection
	                    },
	                    'Cancel'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toParams = exports.search = exports.getCusips = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _fixParams = __webpack_require__(1008);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var Last = (0, _twd.getState)('offerings.last', { ts: 0, params: {} });
	
	var getInvType = function getInvType(searchParams) {
	    var types = (0, _twd.arrayFrom)((searchParams || {}).holdInvType);
	    return types.length === 1 ? types[0] : '';
	};
	
	var getCusips = exports.getCusips = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(cusips) {
	        var _ref2, data, cs, _ref3, bookdata, ws;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.next = 2;
	                        return (0, _twd.ajax)({
	                            url: '/esb/repattributes/accountPositions/cusipInfo',
	                            method: 'POST',
	                            params: cusips
	                        });
	
	                    case 2:
	                        _ref2 = _context.sent;
	                        data = _ref2.data;
	                        _context.next = 6;
	                        return data;
	
	                    case 6:
	                        cs = _context.sent;
	
	                        if (cs) {
	                            _context.next = 9;
	                            break;
	                        }
	
	                        return _context.abrupt('return', []);
	
	                    case 9:
	
	                        Object.values(cs).forEach(function (c) {
	                            c.holdInvType = c.type;
	                            c.holdCusip = c.cusip;
	                            c.holdIssue = c.issue_display;
	                            c.holdCoupon = c.coupon;
	                            c.holdMaturity = c.maturity_eff;
	                            c.spRating = '-';
	                            c.moodyRating = '-';
	                            c.hodlState = '-';
	                        });
	
	                        _context.next = 12;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/cusip/warningAndBook',
	                            method: 'POST',
	                            params: {
	                                "p_criteria_fmt": "ADVANCED",
	                                "p_cusip": cusips.join(),
	                                "p_maxrows": cusips.length,
	                                "p_monarch": "Y",
	                                "p_output_fmt": "JSON",
	                                "p_multiple": ["BOL-UOR", "BOL-ROR"],
	                                "p_submit": "JSON",
	                                "p_redirect_output": "Y",
	                                "p_type": "0",
	                                "p_min_qty": 1,
	                                "p_is_offer_search": false,
	                                "p_search_criteria": {},
	                                "p_mode": "RP"
	                            }
	                        });
	
	                    case 12:
	                        _ref3 = _context.sent;
	                        bookdata = _ref3.data;
	                        _context.next = 16;
	                        return bookdata;
	
	                    case 16:
	                        _context.t0 = _context.sent;
	
	                        if (_context.t0) {
	                            _context.next = 19;
	                            break;
	                        }
	
	                        _context.t0 = [];
	
	                    case 19:
	                        ws = _context.t0;
	
	
	                        ws.forEach(function (w) {
	                            var n = w.cusip.substring(0, 8);
	                            var c = cs[n];
	                            if (!c) return;
	
	                            c.holdWarningText = w.warningText;
	                        });
	
	                        return _context.abrupt('return', Object.values(cs));
	
	                    case 22:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function getCusips(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var search = exports.search = function search(_ref4) {
	    var searchParams = _ref4.searchParams,
	        _ts = _ref4._ts,
	        from = _ref4.from,
	        backFrom = _ref4.backFrom;
	
	
	    var isReset = _ts && Last.value.ts < _ts;
	    if (isReset) {
	        Last.reset();
	        Last.set({ ts: _ts, from: from });
	    }
	
	    var _React$useState = _react2.default.useState(searchParams && !isReset && !backFrom ? _twd.Status.LOADING : _twd.Status.LOADED),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(searchParams || Last.value.params || {}),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        params = _React$useState4[0],
	        setParams = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(Last.value.rows || []),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        rows = _React$useState6[0],
	        setRows = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(Last.value.resultSetCount || 0),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        count = _React$useState8[0],
	        setCount = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(Last.value.page || 1),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        page = _React$useState10[0],
	        setPage = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState(_ts || Last.value.ts || 0),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        ts = _React$useState12[0],
	        setTs = _React$useState12[1];
	
	    var _React$useState13 = _react2.default.useState(Last.value.selection || []),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        selection = _React$useState14[0],
	        setSelection = _React$useState14[1];
	
	    var _React$useState15 = _react2.default.useState(getInvType(searchParams)),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        invType = _React$useState16[0],
	        setInvType = _React$useState16[1];
	
	    _react2.default.useEffect(function () {
	        if (!_ts || ts >= _ts) return;
	        Last.reset();
	        setRows([]);
	        setSelection([]);
	        setCount(0);
	        setPage(1);
	        setParams(searchParams);
	        setTs(_ts);
	        setInvType(getInvType(searchParams));
	    }, [_ts]);
	
	    _react2.default.useEffect(function () {
	        if (!ts || !params || page === Last.value.page) return;
	
	        setStatus(_twd.Status.LOADING);_asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var isGlobalSearch, p, _ref6, data, a, hasOffers, cs, i, filtered;
	
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            _context2.prev = 0;
	                            isGlobalSearch = params.origin === 'global-search';
	
	                            if (isGlobalSearch) {
	                                delete params.origin;
	                            }
	
	                            p = toParams(params, page);
	
	                            if (page === 1) {
	                                p.metadata = Object.assign({ searchType: 'offers' }, params);
	                            }
	
	                            _context2.next = 7;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/offersearch',
	                                method: 'POST',
	                                params: p
	                            });
	
	                        case 7:
	                            _ref6 = _context2.sent;
	                            data = _ref6.data;
	                            _context2.next = 11;
	                            return data;
	
	                        case 11:
	                            a = _context2.sent;
	                            hasOffers = true;
	
	                            if (!((0, _twd.arrayFrom)(a.rows).length === 0 && (0, _twd.arrayFrom)(p.holdCusip).length > 0 && isGlobalSearch)) {
	                                _context2.next = 20;
	                                break;
	                            }
	
	                            hasOffers = false;
	                            _context2.next = 17;
	                            return getCusips(p.holdCusip);
	
	                        case 17:
	                            a.rows = _context2.sent;
	
	                            a.searchCriteria = [];
	                            a.resultSetCount = a.rows.length;
	
	                        case 20:
	
	                            if (hasOffers) {
	                                cs = Object.keys(a.offerSearchColumnSettings || {});
	                                i = cs.length === 1 ? cs[0] : '';
	
	                                if (i) setInvType(i);
	                            } else {
	                                setInvType('-');
	                            }
	
	                            filtered = 0;
	
	                            a.rows = (0, _twd.arrayFrom)(a.rows).map(function (r) {
	                                var holdWarningText = r.holdWarningText,
	                                    holdFirstCall = r.holdFirstCall,
	                                    holdFirstCallCost = r.holdFirstCallCost,
	                                    marketCheck = r.marketCheck;
	
	                                if (marketCheck === 'z' || marketCheck === 'Z') {
	                                    filtered++;
	                                    return null;
	                                }
	
	                                var ct = holdFirstCall ? 'Callable ' + _twd.format.fmtDt(holdFirstCall, 'MM/yy') + '@' + holdFirstCallCost + (holdWarningText ? ' | ' : '') : '';
	
	                                Object.assign(r, { holdWarningText: ct + holdWarningText });
	                                return r;
	                            }).filter(Boolean);
	                            a.rows = (Last.value.rows || []).concat(a.rows);
	
	                            Last.set({ params: params, page: page }, a);
	
	                            setRows(a.rows);
	                            setCount(a.resultSetCount - filtered);
	                            setStatus(_twd.Status.LOADED);
	                            _context2.next = 33;
	                            break;
	
	                        case 30:
	                            _context2.prev = 30;
	                            _context2.t0 = _context2['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 33:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[0, 30]]);
	        }))();
	    }, [ts, params, page]);
	
	    var onLoadMore = function onLoadMore() {
	        setPage(page + 1);
	        setTs(Date.now());
	    };
	
	    var onSelect = function onSelect(row) {
	        if (row === false) {
	            setSelection([]);
	        } else if (row === true) {
	            setSelection([].concat(rows));
	        } else {
	            var s = (0, _twd.arrayToggle)(selection, row);
	            setSelection([].concat(s));
	        }
	    };
	
	    var clearSelection = function clearSelection() {
	        return onSelect(false);
	    };
	
	    return {
	        params: params, status: status,
	        rows: rows, invType: invType,
	        count: count, onLoadMore: onLoadMore,
	        selection: selection, onSelect: onSelect, clearSelection: clearSelection,
	        Last: Last
	    };
	};
	
	exports.default = search;
	var toParams = exports.toParams = function toParams(p, page) {
	    return (0, _twd.cleanObject)(Object.assign({
	        searchType: 'offers',
	        pageNumber: 1,
	        resultsPerPage: 10,
	        marketCheckRequired: true,
	        sort: [{
	            field: 'holdMaturitySortDt',
	            direction: 'ASC'
	        }]
	    }, (0, _fixParams.fixParams)(p), Object.assign({}, page && { pageNumber: page })));
	};

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Confirm = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(324);
	
	var _account = __webpack_require__(322);
	
	var _footer = __webpack_require__(323);
	
	var _useOrderTicket5 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	var Confirm = exports.Confirm = function Confirm() {
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'container order-ticket' },
	            (0, _core.jsx)(_header.Header, null)
	        ),
	        (0, _core.jsx)(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            (0, _core.jsx)(
	                'div',
	                { className: 'container' },
	                (0, _core.jsx)(_account.Account, null)
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { css: _style.backgroundColor },
	            (0, _core.jsx)(
	                'div',
	                { className: 'xs-hide container' },
	                (0, _core.jsx)(Content, null)
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'xs-show container' },
	                (0, _core.jsx)(ContentMobile, null)
	            )
	        ),
	        (0, _core.jsx)(_footer.Footer, null)
	    );
	};
	
	var ContentMobile = function ContentMobile() {
	    var _useOrderTicket = (0, _useOrderTicket5.useOrderTicket)(),
	        cusip = _useOrderTicket.cusip,
	        bondInfo = _useOrderTicket.bondInfo,
	        orderInfo = _useOrderTicket.orderInfo,
	        isRfq = _useOrderTicket.isRfq,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var netMoneyLabel = ['W', 'S'].indexOf(orderInfo.action) >= 0 ? 'Estimated proceeds' : 'Estimated total cost';
	
	    var issue = bondInfo.issue || {};
	    var title = 'Your ' + (isRfq ? 'quote request' : 'bond order') + ' has been placed';
	    var priceUi = orderInfo.primary === 'Y' ? orderInfo.price : orderInfo.dealerPrice;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'vertical-offset-base', style: { backgroundColor: '#ffffff' } },
	                    (0, _core.jsx)('div', { className: 'row vertical-offset-base' }),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            (0, _core.jsx)(
	                                'p',
	                                null,
	                                Icons.ok
	                            ),
	                            (0, _core.jsx)(
	                                'h2',
	                                null,
	                                title
	                            )
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12' },
	                            (0, _core.jsx)(
	                                'h3',
	                                null,
	                                'Order# ',
	                                orderInfo.orderNo,
	                                ': ',
	                                (0, _core.jsx)(
	                                    'span',
	                                    { style: { color: 'green' } },
	                                    orderInfo.orderStatusDesc
	                                )
	                            )
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                _twd.fmt.mdy(new Date())
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                (0, _twd.parseHtml)(orderInfo.accountName)
	                            )
	                        )
	                    ),
	                    (0, _core.jsx)('hr', { 'aria-hidden': true, className: 'vertical-offset-base' }),
	                    (0, _core.jsx)(Labeled, { label: 'Action', value: getAction(orderInfo.action) }),
	                    (0, _core.jsx)(Labeled, { label: 'Issuer', value: _twd.fmt.issuer({
	                            issuer: (0, _twd.parseHtml)(issue.issue),
	                            cusip: cusip,
	                            showTradeHistory: 'Y',
	                            showBondDetail: 'Y',
	                            isTreasuryAuction: isTreasuryAuction,
	                            from: 'order-ticket'
	                        }) }),
	                    (0, _core.jsx)(Labeled, { label: 'CUSIP', value: orderInfo.cusip }),
	                    (0, _core.jsx)(Labeled, { label: 'Quantity', value: _twd.fmt.qty(orderInfo.qty) }),
	                    (0, _core.jsx)(Labeled, { label: 'Execution Type', value: orderInfo.executionType }),
	                    (0, _core.jsx)(Labeled, { label: 'Settlement Date', value: orderInfo.settlement }),
	                    (0, _core.jsx)(Labeled, { label: 'Status', value: orderInfo.orderStatusDesc ? (0, _core.jsx)(
	                            'span',
	                            { style: { color: 'green' } },
	                            orderInfo.orderStatusDesc
	                        ) : _twd.fmt.empty() }),
	                    (0, _core.jsx)(Labeled, { label: 'Price', value: isTreasuryAuction ? 'Auction' : (0, _twd.isNumeric)(priceUi) ? '$' + _twd.fmt.price3(priceUi) : _twd.fmt.empty() }),
	                    (0, _core.jsx)('hr', { 'aria-hidden': true, className: 'vertical-offset-base' }),
	                    (0, _core.jsx)(Labeled, { label: 'Principal', value: isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.principal) }),
	                    (0, _core.jsx)(Labeled, { label: 'Accrued interest', value: isTreasuryAuction ? _twd.fmt.empty() : orderInfo.accruedInterest ? (0, _core.jsx)(
	                            _react2.default.Fragment,
	                            null,
	                            _twd.fmt.money(orderInfo.accruedInterest),
	                            ' (',
	                            _twd.fmt.count(orderInfo.accruedInterestDays),
	                            ' days)'
	                        ) : _twd.fmt.money(isRfq ? 0 : null) }),
	                    (0, _core.jsx)(Labeled, { label: 'Commission', value: isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt) }),
	                    (0, _core.jsx)(Labeled, { label: netMoneyLabel, value: isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.netMoney) }),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            (0, _core.jsx)(Buttons, null)
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row vertical-offset-base' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12 text-center' },
	                        (0, _core.jsx)(PlaceAnotherButton, null)
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Labeled = function Labeled(_ref) {
	    var label = _ref.label,
	        value = _ref.value,
	        _ref$style = _ref.style,
	        style = _ref$style === undefined ? {} : _ref$style;
	
	    return (0, _core.jsx)(
	        'div',
	        { className: 'row vertical-offset-base' },
	        (0, _core.jsx)(
	            'div',
	            { className: 'col-md-12' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'text-body' },
	                label
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'label text-body text-bold' },
	                (0, _core.jsx)(
	                    'span',
	                    { style: style },
	                    value
	                )
	            )
	        )
	    );
	};
	
	var Content = function Content() {
	    var _useOrderTicket2 = (0, _useOrderTicket5.useOrderTicket)(),
	        orderInfo = _useOrderTicket2.orderInfo,
	        isRfq = _useOrderTicket2.isRfq;
	
	    var title = 'Your ' + (isRfq ? 'quote request' : 'bond order') + ' has been placed';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-md' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'container vertical-offset-base', style: { backgroundColor: '#ffffff' } },
	                    (0, _core.jsx)('div', { className: 'row vertical-offset-base' }),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            (0, _core.jsx)(
	                                'p',
	                                null,
	                                Icons.ok
	                            ),
	                            (0, _core.jsx)(
	                                'h2',
	                                null,
	                                title
	                            )
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-6' },
	                            (0, _core.jsx)(
	                                'h3',
	                                null,
	                                'Order# ',
	                                orderInfo.orderNo,
	                                ': ',
	                                (0, _core.jsx)(
	                                    'span',
	                                    { style: { color: 'green' } },
	                                    orderInfo.orderStatusDesc
	                                )
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-6 text-right' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                _twd.fmt.mdy(new Date())
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                (0, _twd.parseHtml)(orderInfo.accountName)
	                            )
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12' },
	                            (0, _core.jsx)(Detail, null)
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)('div', { className: 'col-md-4' }),
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-4 text-center' },
	                            (0, _core.jsx)(PlaceAnotherButton, null)
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Detail = function Detail() {
	    var _useOrderTicket3 = (0, _useOrderTicket5.useOrderTicket)(),
	        orderInfo = _useOrderTicket3.orderInfo,
	        isRfq = _useOrderTicket3.isRfq,
	        isTreasuryAuction = _useOrderTicket3.isTreasuryAuction;
	
	    var netMoneyLabel = ['W', 'S'].indexOf(orderInfo.action) >= 0 ? 'Estimated proceeds' : 'Estimated total cost';
	
	    var priceUi = orderInfo.primary === 'Y' ? orderInfo.price : orderInfo.dealerPrice;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'table-responsive' },
	            (0, _core.jsx)(
	                'table',
	                { className: 'table align-top' },
	                (0, _core.jsx)(
	                    'thead',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'Action'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body', style: { maxWidth: '250px' } },
	                            'Issuer'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'CUSIP'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'Quantity'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'Execution type'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Settlement',
	                            (0, _core.jsx)('br', null),
	                            'Date'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Status'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Price'
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'tbody',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            getAction(orderInfo.action)
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-bold', style: { maxWidth: '250px' } },
	                            _twd.fmt.issuer({
	                                issuer: (0, _twd.parseHtml)(orderInfo.issue),
	                                cusip: (0, _twd.arrayFrom)(orderInfo.cusip).join(''),
	                                showTradeHistory: 'Y',
	                                isTreasuryAuction: isTreasuryAuction,
	                                from: 'orders-cancel'
	                            })
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-bold' },
	                            orderInfo.cusip
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            _twd.fmt.qty(orderInfo.qty)
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            orderInfo.executionType
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right' },
	                            orderInfo.settlement
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right text-bold' },
	                            orderInfo.orderStatusDesc ? (0, _core.jsx)(
	                                'span',
	                                { style: { color: 'green' } },
	                                orderInfo.orderStatusDesc
	                            ) : _twd.fmt.empty()
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right text-bold' },
	                            isTreasuryAuction ? 'Auction' : (0, _twd.isNumeric)(priceUi) ? '$' + _twd.fmt.price3(priceUi) : _twd.fmt.empty()
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'table',
	                {
	                    className: 'table align-top',
	                    style: { borderBottom: 0 }
	                },
	                (0, _core.jsx)(
	                    'tbody',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                'Principal'
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.principal)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                'Accrued interest'
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : orderInfo.accruedInterest ? (0, _core.jsx)(
	                                    _react2.default.Fragment,
	                                    null,
	                                    _twd.fmt.money(orderInfo.accruedInterest),
	                                    ' (',
	                                    _twd.fmt.count(orderInfo.accruedInterestDays),
	                                    ' days)'
	                                ) : _twd.fmt.money(isRfq ? 0 : null)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                'Commission'
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                netMoneyLabel
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.netMoney)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right', colSpan: 4, style: { verticalAlign: 'middle' } },
	                            (0, _core.jsx)(Buttons, null)
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Buttons = function Buttons() {
	    var _useOrderTicket4 = (0, _useOrderTicket5.useOrderTicket)(),
	        orderInfo = _useOrderTicket4.orderInfo;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        [(0, _core.jsx)(
	            _react2.default.Fragment,
	            { key: 1 },
	            (0, _core.jsx)(
	                'button',
	                {
	                    'data-name': 'cancel-link',
	                    className: 'btn btn-link text-bold',
	                    onClick: function onClick(e) {
	                        (0, _twd.showModal)({
	                            view: 'order-detail',
	                            action: 'cancel',
	                            orderNo: orderInfo.orderNo,
	                            source: e.target
	                        });
	                    }
	                },
	                'Cancel'
	            )
	        ), (0, _core.jsx)(
	            'a',
	            { href: '#',
	                key: 2,
	                'data-name': 'orders-link',
	                className: 'btn btn-link text-bold',
	                onClick: function onClick() {
	                    (0, _twd.show)('orders', { backFrom: true, _ts: Date.now() });
	                }
	            },
	            'View orders'
	        ), (0, _core.jsx)(
	            _react2.default.Fragment,
	            { key: 3 },
	            (0, _core.jsx)(
	                'button',
	                {
	                    'data-name': 'orders-link',
	                    className: 'btn btn-link text-bold',
	                    onClick: function onClick(e) {
	                        (0, _twd.openWindow)('https://us.etrade.com/etx/pxy/portfolios/positions');
	                    }
	                },
	                'View portfolio'
	            )
	        )].filter(Boolean).flatMap(function (a, i) {
	            return [a, (0, _core.jsx)(Sep, { key: i })];
	        }).slice(0, -1)
	    );
	};
	
	var PlaceAnotherButton = function PlaceAnotherButton() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$cls = _ref2.cls,
	        cls = _ref2$cls === undefined ? "btn btn-block btn-primary" : _ref2$cls;
	
	    return (0, _core.jsx)(
	        'button',
	        {
	            className: cls,
	            onClick: function onClick() {
	                (0, _twd.show)('order-ticket', { ts: Date.now() });
	            }
	        },
	        'Place another trade'
	    );
	};
	
	var Sep = function Sep() {
	    return (0, _core.jsx)(
	        'span',
	        { 'aria-hidden': true, style: { padding: '0 10px 0 10px' } },
	        '|'
	    );
	};
	
	var getAction = function getAction(a) {
	    return a === 'F' ? (0, _core.jsx)(
	        'span',
	        null,
	        (0, _core.jsx)(
	            'span',
	            { className: 'text-bold', style: { color: '#107A1B' } },
	            'Buy Quote'
	        ),
	        (0, _core.jsx)('br', null),
	        (0, _core.jsx)(
	            'span',
	            { style: { fontWeight: '400' } },
	            '(Offer wanted)'
	        )
	    ) : a === 'W' ? (0, _core.jsx)(
	        'span',
	        null,
	        (0, _core.jsx)(
	            'span',
	            { className: 'text-bold', style: { color: '#CC0000' } },
	            'Sell Quote'
	        ),
	        (0, _core.jsx)('br', null),
	        (0, _core.jsx)(
	            'span',
	            { style: { fontWeight: '400' } },
	            '(Bid wanted)'
	        )
	    ) : a === 'B' ? (0, _core.jsx)(
	        'span',
	        { className: 'text-bold', style: { color: '#107A1B' } },
	        'Buy'
	    ) : a === 'S' ? (0, _core.jsx)(
	        'span',
	        { className: 'text-bold', style: { color: '#CC0000' } },
	        'Sell'
	    ) : null;
	};
	
	var Icons = {
	    "ok": (0, _core.jsx)(
	        'svg',
	        { 'aria-hidden': 'true', width: '83', height: '81', viewBox: '0 0 83 81', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
	        (0, _core.jsx)('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z', fill: '#242424' }),
	        (0, _core.jsx)(
	            'mask',
	            { id: 'mask0_2300_45833', style: { "maskType": "luminance" }, maskUnits: 'userSpaceOnUse', x: '0', y: '0', width: '83', height: '81' },
	            (0, _core.jsx)('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z', fill: 'white' })
	        ),
	        (0, _core.jsx)('g', { mask: 'url(#mask0_2300_45833)' })
	    )
	
	};

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useModals = __webpack_require__(325);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var from = _ref.from;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'order-ticket-duplicate-order-modal',
	                className: 'modal-dialog modal-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'close',
	                            'aria-label': 'close',
	                            'data-name': 'order-ticket-duplicate-order-modal-close-button',
	                            type: 'button',
	                            onClick: function onClick() {
	                                (0, _useModals.hideModals)();
	                            } },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Duplicate Order Notice'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12 text-body' },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'You have an existing open (or recently executed) order for this CUSIP on the same side of the market.'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'If you did not intend to place a second order for this CUSIP, please select \u201CCancel order\u201D to return to modify your order now. Otherwise, select \u201CAcknowledge duplicate\u201D to proceed with this trade.'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container', style: { background: "#ffffff" } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row vertical-offset-sm' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 text-center' },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-block btn-primary',
	                                        'aria-label': 'acknowledge duplicate',
	                                        'data-name': 'order-ticket-duplicate-order-modal-acknowledge-button',
	                                        type: 'button',
	                                        onClick: function onClick() {
	                                            (0, _useModals.hideModals)();
	                                        } },
	                                    'Acknowledge duplicate'
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 text-center' },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn btn-primary-outline',
	                                        'aria-label': 'cancel order',
	                                        'data-name': 'order-ticket-duplicate-order-modal-cancel-button',
	                                        type: 'button',
	                                        onClick: function onClick() {
	                                            (0, _useModals.resetModals)();
	
	                                            if (!from) {
	                                                (0, _twd.show)('overview');
	                                                return;
	                                            }
	
	                                            var u = (0, _twd.safeURL)(from);
	                                            if (u) {
	                                                (0, _twd.openWindow)(u.toString());
	                                                return;
	                                            }
	
	                                            (0, _twd.viewBack)();
	                                        } },
	                                    'Cancel order'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Entry = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _account = __webpack_require__(322);
	
	var _form = __webpack_require__(1034);
	
	var _snapshot = __webpack_require__(1055);
	
	var _header = __webpack_require__(324);
	
	var _footer = __webpack_require__(323);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	var Entry = exports.Entry = function Entry() {
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'order-ticket' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'container' },
	                (0, _core.jsx)(_header.Header, null)
	            ),
	            (0, _core.jsx)(
	                'div',
	                { style: { backgroundColor: "#f6f6f6" } },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'container' },
	                    (0, _core.jsx)(_account.Account, null)
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { css: _style.backgroundColor },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'container' },
	                    (0, _core.jsx)(Content, null)
	                )
	            ),
	            (0, _core.jsx)(_footer.Footer, null)
	        )
	    );
	};
	
	var Content = function Content() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        orderInfoStatus = _useOrderTicket.orderInfoStatus;
	
	    return (0, _core.jsx)(
	        _twd.Loading,
	        { status: orderInfoStatus },
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-6 col-xs-12' },
	                (0, _core.jsx)(_form.Form, null)
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-6 col-xs-12' },
	                (0, _core.jsx)(_snapshot.Snapshot, null)
	            )
	        )
	    );
	};

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Errors = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Errors = exports.Errors = function Errors() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        orderInfo = _useOrderTicket.orderInfo,
	        hasBondInfo = _useOrderTicket.hasBondInfo,
	        bondInfo = _useOrderTicket.bondInfo,
	        isPreviewed = _useOrderTicket.isPreviewed,
	        isRestricted = _useOrderTicket.isRestricted,
	        isChangeToRfq = _useOrderTicket.isChangeToRfq,
	        action = _useOrderTicket.action,
	        step = _useOrderTicket.step,
	        attested = _useOrderTicket.attested,
	        errors_ = _useOrderTicket.errors;
	
	    var _React$useState = _react2.default.useState([]),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        errors = _React$useState2[0],
	        setErrors = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        var arr = [].concat(fromBondInfo({ step: step, hasBondInfo: hasBondInfo, action: action, bondInfo: bondInfo, isRestricted: isRestricted, isPreviewed: isPreviewed })).concat(fromOrderInfo(orderInfo, isChangeToRfq, attested)).concat(fromErrors(errors_)).filter(Boolean);
	
	        setErrors(arr);
	    }, [orderInfo, errors_, hasBondInfo, bondInfo, action, isRestricted, isPreviewed, isChangeToRfq, attested]);
	
	    if (errors.length === 0) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            errors.map(function (_ref, i) {
	                var type = _ref.type,
	                    message = _ref.message;
	
	                return _react2.default.createElement(
	                    'div',
	                    {
	                        key: "order-ticket-error-" + i,
	                        className: "universal-message universal-message-" + type,
	                        role: 'alert' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'universal-message-content' },
	                        _react2.default.createElement('div', { className: 'universal-message-heading', dangerouslySetInnerHTML: { __html: message } })
	                    )
	                );
	            })
	        )
	    );
	};
	
	var ERROR_TYPES = {
	    INFO: 'info',
	    WARNING: 'warning',
	    ERROR: 'danger'
	};
	
	var fromBondInfo = function fromBondInfo(_ref2) {
	    var step = _ref2.step,
	        hasBondInfo = _ref2.hasBondInfo,
	        bondInfo = _ref2.bondInfo,
	        action = _ref2.action,
	        isRestricted = _ref2.isRestricted,
	        isPreviewed = _ref2.isPreviewed;
	
	    var errs = [];
	    if (step !== _useOrderTicket2.STEPS.CONFIRM && hasBondInfo && bondInfo.bestoffer && bondInfo.bestoffer.highYldInd === 'Y') {
	        errs.push({
	            type: ERROR_TYPES.INFO,
	            message: 'High Yield Bonds are Riskier than Investment Grade Bonds.'
	        });
	    }
	
	    if (isRestricted && isPreviewed) {
	        var t = ['B', 'F'].indexOf(action) >= 0 ? 'Buy orders and offer wanted quote requests' : 'Orders and quote requests';
	
	        errs.push({
	            type: ERROR_TYPES.ERROR,
	            message: t + ' for this asset class are not available for online trading.\n                Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders.'
	        });
	    }
	
	    return errs;
	};
	
	var fromOrderInfo = function fromOrderInfo(_ref3, isChangeToRfq, attested) {
	    var status = _ref3.status,
	        statusMsg = _ref3.statusMsg,
	        executionType = _ref3.executionType;
	
	    var invalidMsg = !statusMsg || statusMsg.indexOf('NO OFFERINGS FOR TICKET') > 0 || statusMsg.indexOf('NO ORDER CONFIGURED FOR TICKET') > 0 || statusMsg.indexOf('12697') > 0 && attested // cd-attestation
	    || statusMsg.indexOf('29353') > 0 && attested // corp prospectus-attestation
	    || isChangeToRfq && statusMsg.indexOf('10329') > 0 || executionType === 'Firm' && statusMsg.indexOf('10880') > 0; // subject order
	
	    if (invalidMsg) return;
	
	    return [status === 'Fail' && { type: ERROR_TYPES.ERROR, message: statusMsg }, status === 'Alert' && { type: ERROR_TYPES.INFO, message: statusMsg }].filter(Boolean);
	};
	
	var fromErrors = function fromErrors(errs) {
	    if (Object.keys(errs).length === 0) return;
	
	    return [{
	        type: ERROR_TYPES.ERROR,
	        message: 'Please fill out the required information and try again. If you need assistance, please contact the Fixed Income Service Desk at 1-877-355-3237.'
	    }];
	};

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AttestationsCD = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// content from https://us.etrade.com/l/f/agreement-library/brokered-cd-disclosure
	
	var AttestationsCD = exports.AttestationsCD = _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	        "div",
	        { className: "aem-Grid aem-Grid--12 aem-Grid--default--12 " },
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "i",
	                                null,
	                                "The information contained in this Disclosure Statement may not be modified by any oral representation made prior or subsequent to the purchase of your Certificate of Deposit."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "CERTIFICATE OF DEPOSIT DISCLOSURE STATEMENT"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Your broker-dealer (the \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "Firm"
	                            ),
	                            "\u201D) is making the certificates of deposit (the \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "CDs"
	                            ),
	                            "\u201D) available to you, the terms of which are described below.\xA0 The CDs may be made available pursuant to an arrangement between the Firm and another broker-dealer.\xA0 Each CD is a deposit obligation of a depository institution in the United States or one of its territories (an \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "Issuer"
	                            ),
	                            "\u201D), the deposits of which are insured by the Federal Deposit Insurance Corporation (the \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "FDIC"
	                            ),
	                            "\u201D) within the limits described below.\xA0 ",
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Each CD is a direct obligation of the Issuer and is not, either directly or indirectly, an obligation of the Firm.\xA0 "
	                            ),
	                            "CDs may be purchased both upon issuance (the \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "primary market"
	                            ),
	                            "\u201D) and after issuance (the \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "secondary market"
	                            ),
	                            "\u201D)."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The Firm will advise you of the names of Issuers currently making CDs available and, if your CD is purchased in the primary market, the date on which your CD will be established with the Issuer (the \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "Settlement Date"
	                            ),
	                            "\u201D).\xA0 Upon request, you will be provided with financial information concerning the Issuer of a CD that you would receive upon request if you established a deposit account directly with the Issuer.\xA0 The Firm does not guarantee in any way the financial condition of any Issuer or the accuracy of any financial information provided by the Issuer."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The Issuer may use proceeds from the sale of the CDs for any purpose permitted by law and its charter, including making loans to eligible borrowers and investing in permissible financial products.\xA0 The Firm or one of its affiliates may from time to time act as a broker or dealer in the sale of permissible financial products to the Issuer."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Your deposits at any one Issuer, including any CDs of the Issuer that you purchase, are eligible for FDIC insurance up to $250,000 (including principal and accrued interest) for each insurable capacity (e.g., individual, joint, IRA, etc.).\xA0 For purposes of the $250,000 federal deposit insurance limit, you must aggregate all deposits that you maintain with the Issuer in the same insurable capacity, including deposits you hold directly with an Issuer and deposits you hold through the Firm and other intermediaries."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Please see the sections headed \u201CDeposit Insurance: General\u201D"
	                            ),
	                            " ",
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "and \u201CDeposit Insurance: Retirement Plans and Accounts\u201D below for more information about federal deposit insurance."
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Terms of CDs"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The maturities, rates of interest and interest payment terms of CDs available through the Firm will vary.\xA0 Both interest-bearing and zero-coupon CDs may be available.\xA0 You should review carefully the trade confirmation and any supplement to this Disclosure Statement for a description of the terms of the CD.\xA0 You should also review the investment considerations discussed below in the section headed \u201CImportant Investment Considerations.\u201D"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The CDs will mature on the date indicated on the trade confirmation.\xA0 The CDs will not be automatically renewed or rolled over and interest on the CDs will not continue to accrue or (in the case of zero-coupon CDs) accrete after maturity.\xA0 At maturity the CD balances will be remitted by the Issuer to the Firm and credited to your account with the Firm.\xA0 If the maturity date is not a business day, the CD balances will be paid on the next succeeding business day. A \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "business day"
	                            ),
	                            "\u201D is any day the Firm and the Issuer are both open for business."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Interest-Bearing CDs"
	                            ),
	                            ". Interest-bearing CDs are offered in a wide range of maturities and are made available in minimum denominations and increments of $1,000. Unless otherwise specified in the trade confirmation or any supplement to this Disclosure Statement, interest earned on interest-bearing CDs with original maturities of one year or less will be paid at the maturity of such CDs and interest earned on interest-bearing CDs with original maturities of more than one year will be paid monthly, quarterly, semiannually or annually and at maturity."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Interest payments on interest-bearing CDs are credited to your account with the Firm.\xA0 Interest will accrue up to, but not including the interest payment date, the maturity date, or any call date.\xA0 If an interest payment date falls on a day that is not a business day, interest will be paid on the first business day following the interest payment date."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Interest on CDs is not compounded.\xA0 Interest on CDs in the primary market is calculated on the basis of the actual number of days elapsed over a 365-day year.\xA0 However, the amount of interest on CDs that are purchased in the secondary market may be based on other interest rate calculations.\xA0 Please contact the Firm with questions about interest on your CDs."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Interest-bearing CDs pay interest at either a fixed-rate or at a variable rate. A fixed-rate CD will pay the same interest rate throughout the life of the CD. The interest rate on variable rate CDs may increase or decrease from the initial rate at pre-determined time periods (\u201Cstep-rates\u201D) or may be re-set at specified times based upon the change in a specific index or indices (\u201Cfloating rates\u201D). The dates on which the rates on step-rate CDs will change or the rates on floating rate CDs will re-set, as well as a description of the basis on which the rate will be re-set, are provided on the trade confirmation or a supplement to this Disclosure Statement."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Zero-Coupon CDs.\xA0 "
	                            ),
	                            "Zero-coupon CDs do not bear interest, but rather are issued at a discount from the face or par amount, the minimum amount of which is $1,000.\xA0 Interest on the CD will \u201Caccrete\u201D at an established rate and the holder will be paid the par amount at maturity."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Call Feature"
	                            ),
	                            ".\xA0 Some CDs may be subject to redemption on a specified date or dates at the sole discretion of the Issuer (a \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "call"
	                            ),
	                            "\u201D feature).\xA0 If the CD is called, you will be paid the outstanding principal amount and interest accrued or accreted up to, but not including, the call date, and no interest will be earned after the call date.\xA0 The dates on which the CD may be called will be specified in the trade confirmation or a supplement to this Disclosure Statement.\xA0 In general, a call is most likely to be exercised when prevailing interest rates are lower than the interest rate payable on the CD.\xA0 The Issuer is required to notify the Firm of its intent to call the CD prior to exercising the call.\xA0 The Firm will use reasonable efforts to notify you of the Issuer\u2019s intent to call the CD, but the Firm\u2019s failure to notify you will not affect the validity of the call. "
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Important Investment Considerations"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Buy and Hold.\xA0 "
	                            ),
	                            "CDs are most appropriate for purchasing and holding to maturity.\xA0 If your CD is callable by the Issuer, you should be prepared to hold your CD according to its terms.\xA0 Though not obligated to do so, the Firm may maintain a secondary market in the CDs after their Settlement Date.\xA0 If you are able to sell your CD in the secondary market, the price you receive will reflect prevailing market conditions and your sales proceeds may be less than the amount you paid for your CD.\xA0 If you wish to sell or withdraw funds from your CD prior to maturity, you should review the sections headed \u201CAdditions or Withdrawals\u201D and \u201CSecondary Market.\u201D"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Compare Features."
	                            ),
	                            "\xA0 You should compare the rates of return and other features of the CDs to other available investments before deciding to purchase a CD.\xA0 The rates paid on the CDs may be higher or lower than the rates on deposits or other instruments available directly from the Issuer or through the Firm."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Callable CDs.\xA0 "
	                            ),
	                            "Callable CDs present different investment considerations than CDs not subject to call by the Issuer.\xA0 You face the risk that: (i) the CD may be paid off prior to maturity as a result of a call by the Issuer and your return would be less than the yield that the CD would have earned had it been held to maturity; (ii) if the CD is called, you may be unable to reinvest the funds at the same rate as the original CD; or (iii) the CD is never called and you may be required to hold the CD until maturity.\xA0 You should carefully review any supplement to this Disclosure Statement or your trade confirmation for the terms of your CD, including the time periods when the Issuer may call your CD."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Variable-Rate CDs."
	                            ),
	                            "\xA0 Variable-rate CDs present different investment considerations than fixed-rate CDs and may not be appropriate for every investor.\xA0 Depending on the type of variable rate CD (step-rate or floating-rate) and the interest rate environment, the CD may pay substantially more or substantially less interest over the term of the CD than would be paid on a fixed-rate CD of the same maturity.\xA0 Furthermore, if the CD is subject to call by the Issuer, (i) you may not receive the benefits of any anticipated increase in rates paid on a variable rate CD if the CD is called or (ii) you may be required to hold the CD at a lower rate than prevailing market interest rates if the CD is not called.\xA0 You should carefully review your trade confirmation and any supplement to this Disclosure Statement that describes the step-rate or the basis for re-setting a floating rate and, if the CD is subject to call by the Issuer, the time periods when the Issuer may call the CD."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Insolvency of the Issuer."
	                            ),
	                            "\xA0 If the Issuer becomes insolvent, the FDIC will be appointed to manage the Issuer\u2019s affairs.\xA0 The FDIC may, in its discretion, pay off the CDs prior to maturity or transfer the CDs to another depository institution.\xA0 If the CDs are transferred to another institution, you may be offered a choice of retaining the CDs at a lower interest rate or having the CDs paid off.\xA0 See the sections headed \u201CDeposit Insurance: General\u201D and \u201CPayments Under Adverse Circumstances.\u201D"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Reinvestment Risk."
	                            ),
	                            "\xA0 If your CD is paid off prior to maturity as a result of the Issuer\u2019s insolvency, exercise by the Issuer of any right to call the CD or a voluntary early withdrawal (see the section headed \u201CAdditions or Withdrawals\u201D), you may be unable to reinvest your funds at the same rate as the original CD.\xA0 The Firm is not responsible to you for any losses you may incur as a result of a lower interest rate on an investment replacing your CD."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "SEC Investor Tips."
	                            ),
	                            "\xA0 The Securities and Exchange Commission periodically publishes tips for investors in various financial products, including CDs, on its website.\xA0 You may access these investor tips at ",
	                            _react2.default.createElement(
	                                "a",
	                                { href: "http://www.sec.gov/", target: "_blank", alt: "Visit S E C website", "aria-label": "Visit S E C website" },
	                                "www.sec.gov"
	                            ),
	                            "."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Your Relationship with the Firm and the Issuer"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "You will not receive a certificate or other evidence of ownership of the CD from the Issuer. All CDs issued on the same settlement date with the same terms by an Issuer will be evidenced by one or more master certificates held by The Depository Trust Company (\u201CDTC\u201D), a regulated entity that holds master certificates. The Firm, acting as your custodian, keeps records of your ownership of each CD you purchase and will provide you with a written confirmation of your purchase. The Firm will also provide you with a periodic account statement showing your CD ownership. You should retain the trade confirmation and the account statement(s) for your records."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Your account statement from the Firm may provide an estimate of the price you might receive on your CDs if you were able to sell them in the secondary market prior to maturity. Any prices on your statement are estimates and are not based on actual market prices. You may ask the Firm to explain its statement pricing policies. Your deposit insurance coverage and, if your CD is callable, the amount you would receive if your CD were called will be determined based on the outstanding principal amount of your CD, or the accreted value in the case of a zero-coupon CD, not the estimated price. See the sections headed ",
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "\u201C"
	                            ),
	                            "Deposit Insurance: General\u201D and \u201CSecondary Market\u201D for more information."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Each CD is a direct obligation of the Issuer and is not, either directly or indirectly, an obligation of the Firm. No deposit relationship shall be deemed to exist prior to the receipt and acceptance of your funds by the Issuer."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "You have the right to dismiss the Firm as your agent. If you do so, you may (i) transfer your CD to another agent, provided that the agent is a member of DTC (most major brokerage firms are members; many banks and savings institutions are not); or (ii) request that your ownership of the CD be evidenced directly on the books of the Issuer, subject to applicable law and the Issuer\u2019s terms and conditions. If you remove the Firm as your agent, the Firm will have no further responsibility for payments made on your CD. If you establish your CD directly on the books of the Issuer, you may enforce your rights in the CD directly against the Issuer."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Deposit Insurance: General"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Your deposits, including your CDs, at each Issuer are insured by the FDIC, an independent agency of the United States Government, up to $250,000 (including principal and accrued interest to the date the bank is closed) for all deposits held in the same insurable capacity at the Issuer.\xA0 Any deposits that you may maintain directly with a particular Issuer, or through any other intermediary in the same insurable capacity in which the CDs are maintained, will be aggregated with the CDs for purposes of the $250,000 federal deposit insurance limit.\xA0"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The FDIC\u2019s regulations impose conditions for obtaining FDIC insurance coverage for deposits held through agents, such as the Firm. These conditions include recordkeeping requirements applicable to the Firm as your agent and custodian. See the section headed \u201CPayments Upon Issuer Insolvency\u201D below."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If an Issuer fails, interest-bearing CDs are insured, up to $250,000, for principal and interest accrued to the date the Issuer is closed.\xA0 Zero-coupon CDs are insured to the extent of the original offering price plus interest at the rate quoted to the depositor on the original offering, accreted to the date of the closing of the Issuer.\xA0 The original offering price of a zero-coupon CD plus accreted interest is hereinafter called the \u201Caccreted value.\u201D"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Under certain circumstances, if you become the owner of a CD or other deposit account at an Issuer after another depositor dies, as a result of a survivorship feature of the account, such as a joint account or a \u201Cpayable on death\u201D account, the FDIC provides a six-month \u201Cgrace period\u201D after the death of the other depositor during which time your deposits are eligible for the pre-death coverage in order to permit you to restructure your deposits to obtain the maximum amount of deposit insurance for which you are eligible."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "You are responsible for monitoring the total amount of deposits that you hold with any one Issuer, directly or through an intermediary, in order for you to determine the amount of deposit insurance coverage available to you on your deposits, including the CDs.\xA0 The Firm is not responsible for any insured or uninsured portion of the CDs or any other deposits."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "BY YOUR PURCHASE OF A CD YOU ARE DEEMED TO REPRESENT TO THE ISSUER AND THE FIRM THAT YOUR DEPOSITS WITH THE ISSUER (OR IF YOU ARE ACTING AS A CUSTODIAN, THE DEPOSITS OF THE BENEFICIARIES), INCLUDING THE CD, WHEN AGGREGATED IN ACCORDANCE WITH FDIC REGULATIONS, ARE WITHIN THE $250,000 FEDERAL DEPOSIT INSURANCE LIMIT."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If your CDs or other deposits at the Issuer are assumed by another depository institution pursuant to a merger, consolidation or acquisition of the CDs or other deposits, such CDs or deposits will continue to be separately insured from the deposits that you have established with the acquiror until (i) the maturity date of the CDs or other time deposits that were assumed, or (ii) with respect to deposits that are not time deposits, the expiration of a six-month period from the date of the acquisition.\xA0 Thereafter, any assumed deposits will be aggregated with your existing deposits with the acquiror held in the same insurable capacity for purposes of federal deposit insurance.\xA0 Any deposit account opened at, or CD issued by, the acquiror after the acquisition will be aggregated with deposits established with the acquiror for purposes of federal deposit insurance."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "If you purchase a CD in the secondary market at a premium over the par amount (or accreted value in the case of a zero-coupon CD), that premium is not insured.\xA0 Similarly, you are not insured for any premium reflected in the estimated market value of your CD on your account statement.\xA0 If deposit insurance payments become necessary for the Issuer, you can lose the\xA0 premium paid for your CD and will not receive any premium shown on your account statement.\xA0 See the section headed \u201CSecondary Market.\u201D"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The application of the $250,000 federal deposit insurance limit is illustrated by several common factual situations discussed below.\xA0 Please review the section headed \u201CDeposit Insurance:\xA0 Retirement Plans and Accounts\u201D for the application of the $250,000 federal deposit insurance limit to retirement plans and accounts. The following factual situations are provided for your information and are not legal advice. Please see the section titled \u201CQuestions About FDIC Deposit Insurance Coverage\u201D for more information."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Individual Customer Accounts.\xA0 "
	                            ),
	                            "Deposits of any one Issuer held by an individual are added together with other deposits owned by the individual and insured up to $250,000 in the aggregate. An individual may hold deposits through an agent or nominee (such as the CDs held in a Firm account) or",
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                " "
	                            ),
	                            "through a custodian (for example, under the Uniform Gifts to Minors Act or the Uniform Transfers to Minors Act). In such cases, the individual\u2019s deposits will be added together with other deposits owned by the individual and insured up to $250,000 in the aggregate.\xA0"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Corporate, Partnership and Unincorporated Association Accounts.\xA0 "
	                            ),
	                            "Deposits of any one Issuer held by corporations (including Subchapter S corporations), partnerships and unincorporated associations, operated for a purpose other than to increase deposit insurance, are added together with other deposits owned by such corporation, partnership and unincorporated association, respectively, and are insured up to $250,000 in the aggregate."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Joint Accounts.\xA0 "
	                            ),
	                            "An individual\u2019s interest in deposits of any one Issuer held under any form of joint ownership valid under applicable state law (a \u201CJoint Account\u201D) may be insured up to $250,000 in the aggregate. This insurance is in addition to the $250,000 provided for other deposits individually owned by any of the co-owners of such accounts.\xA0 For example, a Joint Account owned by two persons would be eligible for insurance coverage of up to $500,000 ($250,000 for each person), subject to aggregation with each owner\u2019s interests in other Joint Accounts at the same depository institution.\xA0 Joint Accounts will be insured separately from individually owned accounts only if each of the co-owners is an individual person and has a right of withdrawal on the same basis as the other co-owners."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Trust Accounts.\xA0 "
	                            ),
	                            "Effective April 1, 2024, deposits",
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                " "
	                            ),
	                            "of any one Issuer held pursuant to any of the following trust arrangements established by the same grantor are insured for up to $250,000 per eligible beneficiary, multiplied by the number of beneficiaries, up to a maximum of five eligible beneficiaries:"
	                        ),
	                        _react2.default.createElement(
	                            "ul",
	                            null,
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "i",
	                                    null,
	                                    "Informal revocable trusts"
	                                ),
	                                ", which include accounts in which the grantor evidences an intent that, at his or her death, the funds shall belong to one or more specified beneficiaries.\xA0 These trusts may be referred to as a \u201CTotten trust\u201D account, \u201Cpayable upon death\u201D account or \u201Ctransfer on death\u201D account.\xA0 Each beneficiary must be included in the Firm\u2019s account records."
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "i",
	                                    null,
	                                    "Formal"
	                                ),
	                                " ",
	                                _react2.default.createElement(
	                                    "i",
	                                    null,
	                                    "revocable trusts"
	                                ),
	                                ", which",
	                                _react2.default.createElement(
	                                    "i",
	                                    null,
	                                    " "
	                                ),
	                                "are written trust arrangements in which the grantor retains ownership and control of the assets and designation of beneficiaries during his or her lifetime and the assets pass to the beneficiaries upon the death of the grantor.\xA0 The trusts may be referred to as \u201Cliving\u201D or \u201Cfamily\u201D trusts.\xA0"
	                            ),
	                            _react2.default.createElement(
	                                "li",
	                                null,
	                                _react2.default.createElement(
	                                    "i",
	                                    null,
	                                    "Irrevocable"
	                                ),
	                                " ",
	                                _react2.default.createElement(
	                                    "i",
	                                    null,
	                                    "trust accounts"
	                                ),
	                                ", which are trust arrangements established by statute or written trust agreement. ",
	                                _react2.default.createElement(
	                                    "i",
	                                    null,
	                                    "Coverdell Education Savings Accounts"
	                                ),
	                                " are irrevocable trust accounts."
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "A beneficiary\u2019s interest in any trust account will be aggregated with the beneficiary\u2019s interest in all other trust accounts created by the same grantor at the same Issuer and insured up to $250,000."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Deposit Insurance: Retirement Plans and Accounts"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Retirement Plans and Accounts \u2013 Generally."
	                            ),
	                            "\xA0 The amount of deposit insurance available on CDs of any one Issuer held through one or more retirement plans or accounts will vary depending on the type of plan or account.\xA0 It is therefore important to understand the type of plan or account holding the CDs.\xA0 The following sections generally discuss the rules that apply to deposits held by retirement plans and accounts."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Individual Retirement Accounts (\u201C",
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "IRAs"
	                                ),
	                                "\u201D)."
	                            ),
	                            "\xA0 Deposits of any one Issuer held in an IRA will be insured up to $250,000 in the aggregate. However, as described below, the deposits of any one Issuer held by an IRA will be aggregated with the deposits of the same Issuer held by certain employee benefit plans in which the owner of the IRA has an interest. Thus, the owner of an IRA will only be eligible for insurance of $250,000 for deposits at any one Issuer held in plans and accounts that are subject to aggregation. See the section below headed \u201CAggregation of Retirement Plan and Account Deposits.\u201D"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Pass-Through Deposit Insurance for Employee Benefit Plan Deposits.\xA0 "
	                            ),
	                            "Subject to the limitations discussed below, a plan participant\u2019s non-contingent interests in the deposits of any one Issuer held by many types of employee benefit plans are eligible for insurance up to $250,000 on a \u201Cpass-through\u201D basis.\xA0 This means that instead of the deposits of one Issuer held by an employee benefit plan being eligible for only $250,000 of insurance in total, each employee benefit plan participant is eligible for insurance up to $250,000, subject to the aggregation of the participant\u2019s interests in different plans, as discussed below under \u201CAggregation of Retirement Plan and Account Deposits.\u201D\xA0 The pass-through insurance provided to an employee benefit plan participant is separate from the $250,000 federal deposit insurance limit allowed on deposits held by the individual in different insurable capacities at the same Issuer (e.g., individual accounts, joint accounts, etc.)."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The types of plans for which deposits may receive pass-through treatment are employee benefit plans, as defined in Section 3(3) of the Employee Retirement Income Security Act of 1974 (\u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "ERISA"
	                            ),
	                            "\u201D) (including Keogh plans, whether or not they are technically \u201Cemployee benefit plans\u201D under ERISA) and eligible deferred compensation plans described in Section 457 of the Internal Revenue Code of 1986 (the \u201C",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "Code"
	                            ),
	                            "\u201D).\xA0 For purposes of Section 3(3) of ERISA, employee benefit plans are broadly defined to include most employee benefit plans, including most defined benefit plans and most defined contribution plans."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "i",
	                                null,
	                                "Defined Benefit Plans"
	                            ),
	                            ".\xA0 The value of an employee\u2019s non-contingent interest in a defined benefit plan will be equal to the present value of the employee\u2019s interest in the plan, evaluated in accordance with the calculation ordinarily used under such plan.\xA0 Deposits of any one Issuer held by a defined benefit plan that is eligible for pass-through treatment are ",
	                            _react2.default.createElement(
	                                "u",
	                                null,
	                                "not"
	                            ),
	                            " insured for an amount equal to the number of plan participants multiplied by $250,000.\xA0 For example, a plan has on deposit $500,000 of CDs of a single Issuer.\xA0 The employee benefit plan has two participants, one with a non-contingent interest of $425,000 and one with a non-contingent interest of $75,000.\xA0 In this case, the plan would be eligible for up to $250,000 for the participant with the $425,000 non-contingent interest and up to $75,000 for the participant with the $75,000 non-contingent interest."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Overfunded amounts, which are any portion of a plan\u2019s deposits not attributable to the interests of beneficiaries under the plan, are insured, in the aggregate, up to $250,000 separately from the insurance provided for any other funds owned by or attributable to the employer or a plan participant."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "i",
	                                null,
	                                "Defined Contribution Plans"
	                            ),
	                            ".\xA0 The value of an employee\u2019s non-contingent interest in deposits of any one Issuer\xA0 held through a defined contribution plan will be equal to the amount of funds on deposit attributable to the employee\u2019s account with the plan, regardless of whether the funds on deposit resulted from contributions made by the employee, the employer, or both."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Portions of deposits of any one Issuer held by an employee benefit plan that are attributable to the contingent interests of employees in the plan are not insured on a pass-through basis.\xA0 Contingent interests of employees in an employee benefit plan are interests that are not capable of evaluation in accordance with FDIC rules and are insured up to $250,000 per plan."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "Aggregation of Retirement Plan and Account Deposits.\xA0 "
	                            ),
	                            "Under FDIC regulations, an individual's interests in plans maintained by the same employer or employee organization (for example, a union) that are holding deposits of the same Issuer will be insured for $250,000 in the aggregate.\xA0 In addition, under FDIC regulations, an individual's interest in the deposits of one Issuer held by (i)\xA0IRAs, (ii)\xA0deferred compensation plans for certain employees of state or local governments or tax-exempt organizations (i.e., Section 457 Plans), (iii)\xA0self-directed \u201CKeogh Plans\u201D of owner-employees described in Section 401(d) of the Code, and (iv)\xA0self-directed defined contribution plans, will be insured for up to $250,000 in the aggregate whether or not maintained by the same employer or employee organization."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Questions About FDIC Deposit Insurance Coverage"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If you have questions about basic FDIC insurance coverage, please contact the Firm.\xA0 You may wish to seek advice from your own attorney concerning FDIC insurance coverage of deposits held in more than one insurable capacity.\xA0 You may also obtain information by contacting the FDIC, Deposit Insurance Outreach, Division of Depositor and Consumer Protection, by letter (550 17th Street, N.W., Washington, D.C. 20429), by phone (877-275-3342 or 800-925-4618 (TDD)), by visiting the FDIC website at ",
	                            _react2.default.createElement(
	                                "a",
	                                { alt: "Visit the F D I C website", href: "https://www.fdic.gov/deposit/index.html", target: "_blank", "aria-label": "Visit the F D I C website" },
	                                "www.fdic.gov/deposit/index.html"
	                            ),
	                            ", or by e-mail using the FDIC\u2019s On-line Customer Assistance Form available on its website."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Payments Upon Issuer Insolvency"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "As with all deposits, if it becomes necessary for federal deposit insurance payments to be made on the CDs, there is no specific time period during which the FDIC must make insurance payments available."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The records maintained by the Firm regarding ownership of CDs will be used to establish your eligibility for federal deposit insurance payments and will be submitted to the FDIC in connection with your claim for deposit insurance.\xA0 In addition, you may be required to provide certain documentation to the FDIC and to the Firm before insurance payments are released to you.\xA0 For example, if you hold CDs as trustee for the benefit of trust participants, you may also be required to furnish an affidavit to that effect; you may be required to furnish other affidavits and provide indemnities regarding an insurance payment. You should be prepared for the possibility of a delay in obtaining insurance payments."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If deposit insurance payments become necessary for your CDs, the FDIC is required to pay the original par amount plus accrued interest (or the accreted value in the case of zero-coupon CDs) to the date of the closing of the relevant Issuer, as prescribed by law, and subject to the $250,000 federal deposit insurance limit.\xA0 No interest or accreted value is earned on deposits from the time an Issuer is closed until insurance payments are received."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "As an alternative to a direct deposit insurance payment from the FDIC, the FDIC may transfer the insured deposits of an insolvent institution to a healthy institution.\xA0 Subject to insurance verification requirements and the limits on deposit insurance coverage, the healthy institution may assume the CDs under the original terms or offer you a choice between paying the CD off and maintaining the deposit at a different rate.\xA0 There may be a delay in receiving notification from the healthy institution, and the healthy institution may lower the rate on the CDs prior to providing notice.\xA0 The Firm will advise you of your options in the event of a deposit transfer as information becomes available."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                "The Firm will not be obligated to you for amounts not covered by deposit insurance, nor will the Firm be obligated to make any payments to you in satisfaction of a loss you might incur as a result of (i) a delay in insurance payouts applicable to your CD, (ii) your receipt of a decreased interest rate on an investment replacing your CD as a result of the payment of the principal and accrued interest or the accreted value of a CD prior to its scheduled maturity or (iii) payment in cash of the principal and accrued interest or the accreted value of your CDs prior to maturity in connection with the liquidation of an Issuer or the assumption of all or a portion of its deposit liabilities.\xA0 The amount of a payment on a CD that had been purchased at a premium in the secondary market is based on the original par amount (or, in the case of a zero-coupon CD, its accreted value), not on any premium amount, and you may lose up to the full amount of the premium as a result of such a payment.\xA0 Further, the Firm will not be obligated to credit your account with funds in advance of payments received from the FDIC."
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Additions or Withdrawals"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "No additions are permitted to be made to any CD, although additional CDs may be available for purchase.\xA0 When you purchase a CD, you agree with the Issuer to keep your funds on deposit for the term of the CD.\xA0 Except as set forth below, no early withdrawals of interest-bearing CDs will be available.\xA0 The early withdrawal provisions, if any, applicable to your CD may be more or less advantageous than the provisions applicable to other deposits available from the Issuer.\xA0 For a discussion on selling your CD in the secondary market prior to maturity, see \u201CSecondary Market\u201D below.\xA0\xA0"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "In the event of death or the adjudication of incompetence of the owner of a CD, early withdrawal of the entire CD will generally be permitted without penalty.\xA0 Withdrawal of a portion of the owner\u2019s interest will not be permitted.\xA0 Written verification acceptable to the Issuer will generally be required to permit early withdrawal under these circumstances."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "Some Issuers of callable CDs may limit permissible early withdrawal of their callable CDs to the FDIC insurance limit of $250,000.\xA0 In this case, the Issuer would limit the total amount that could be withdrawn from all its callable CDs subject to this limit to $250,000 (principal plus accrued interest) for each insurable capacity in which you hold the CDs.\xA0 You may contact the Firm for information on whether the Issuer of your callable CD has imposed a limit on early withdrawal."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "By law, the beneficiary of an IRA (but not a Roth IRA) must generally begin making withdrawals from the IRA after age 73.\xA0 CDs held in an IRA are not eligible for early withdrawal simply because the beneficiary must begin making mandatory withdrawals from the IRA.\xA0 IRA beneficiaries should purchase CDs with maturities that correspond to the mandatory withdrawal requirements or look to the secondary market for liquidity.\xA0 See the section headed \u201CSecondary Market.\u201D"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If a customer wishes to make an early withdrawal, and such withdrawal is permitted, the Firm endeavors to obtain funds for the customer as soon as possible.\xA0 However, the Firm will not advance funds in connection with early withdrawals and can give no assurances that payment pursuant to early withdrawals will be made by a specified date."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Secondary Market"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The Firm, though not obligated to do so, may maintain a secondary market in the CDs after their Settlement Date.\xA0 If you wish to sell your CD prior to maturity and the Firm does not maintain a secondary market, the Firm may attempt to sell your CD in a secondary market maintained by another broker-dealer.\xA0 The Firm cannot provide assurance that you will be able to sell your CDs prior to their maturity.\xA0 In addition, a secondary market for the CDs may be discontinued at any time without notice.\xA0 Therefore, you should not rely on any such ability to sell your CDs for any benefits, including achieving trading profits, limiting trading or other losses, realizing income prior to maturity, or having access to proceeds prior to maturity."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If a buyer is available at a time you attempt to sell your CD prior to its maturity, the price at which your CD is sold may result in a return to you that may differ from the yield that the CD would have earned had it been held to maturity, since the selling price for a CD in such circumstances will likely be based on a number of factors such as interest rate movements, time remaining until maturity, and other market conditions.\xA0 Also, the price at which a CD may be sold in the secondary market will reflect a commission charged by the Firm.\xA0 Similarly, the price you may pay for any CD purchased in the secondary market will include a commission established by the Firm.\xA0 If you sell a CD in the secondary market, you may receive less in sale proceeds than the original principal (par) amount of the CD or the estimated price on your account statement."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If a CD is purchased in the secondary market at a premium over the par amount (or accreted value in the case of a zero-coupon CD), the premium is not insured.\xA0 Therefore, if deposit insurance payments become necessary for the Issuer, the owner of a CD purchased in the secondary market can incur a loss of up to the amount of the premium paid for the CD.\xA0 (Also see the section headed \u201CDeposit Insurance: General.\u201D)"
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The uninsured premium being paid for an interest-bearing CD can be determined from the price set forth in your trade confirmation.\xA0 A CD price is expressed in relation to par (100.00).\xA0 Any amount over 100.00 represents the premium.\xA0 For example, if your trade confirmation states that the price for a CD purchased in the secondary market is 100.25, there is a premium that will not be insured by the FDIC.\xA0 A price of 99.75 would not include a premium.\xA0 The trade confirmation will also inform you if the CD has accrued interest, which will be insured as long as the par amount of CDs held by you in one insurable capacity at the Issuer plus the accrued interest does not exceed the $250,000 federal deposit insurance limit."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "In the case of a zero-coupon CD purchased in the secondary market, the uninsured premium can initially be calculated by subtracting the accreted value from the \u201CGross Amount\u201D paid.\xA0 This uninsured premium does, however, decline over time.\xA0 The accreted value of a zero-coupon CD, which is based upon the original issue yield and price, can be obtained at the time of purchase from the Firm."
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "If you purchase a callable CD in the secondary market at a premium, you will receive only the par amount if the CD is called."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Fees"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The Firm may receive a concession for CDs purchased by you in the primary market; however, you will not be charged a fee or a commission for such purchase (i.e., such purchase will be at par). You will be charged a commission in connection with your purchase of a CD in the secondary market. Handling fees, if any, will be disclosed on your trade confirmation."
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "richTextEditor aem-GridColumn aem-GridColumn--default--12" },
	            _react2.default.createElement(
	                "div",
	                null,
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        null,
	                        _react2.default.createElement(
	                            "p",
	                            { className: "text-center" },
	                            _react2.default.createElement(
	                                "b",
	                                null,
	                                _react2.default.createElement(
	                                    "u",
	                                    null,
	                                    "Federal Income Tax Consequences"
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "p",
	                            null,
	                            "The federal income tax consequences of owning CDs will vary depending upon the terms of your CD and the type of account in which you hold your CD.\xA0 In addition, there may be tax consequences upon the sale, early withdrawal or other disposition of your CD.\xA0 These tax consequences may differ for non-U.S. persons.\xA0 You should consult your own tax advisor to determine the federal, state, local and other income and estate tax consequences of your CD purchase."
	                        )
	                    )
	                )
	            )
	        )
	    )
	); /* eslint-disable no-use-before-define */

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var content = _ref.content,
	        src = _ref.src,
	        title = _ref.title,
	        label = _ref.label,
	        value = _ref.value,
	        onAttest = _ref.onAttest;
	
	    var _React$useState = _react2.default.useState(value || false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        attested = _React$useState2[0],
	        setAttested = _React$useState2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'date-name': 'attestations-modal',
	                className: 'attestations-modal order-ticket-form modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'date-name': 'attestations-modal-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'modal-title large-header text-center' },
	                        title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-body', style: { width: '100%' } },
	                    content && _react2.default.createElement(
	                        'div',
	                        { style: {
	                                background: "#fff",
	                                border: '1px solid rgb(228, 228, 228)',
	                                padding: '10px',
	                                maxHeight: '600px',
	                                overflowY: 'auto'
	                            } },
	                        content
	                    ),
	                    !content && src && _react2.default.createElement('iframe', {
	                        'date-name': 'attestations-modal-frame',
	                        src: (0, _twd.fixURL)(src).toString(),
	                        marginHeight: '0', marginWidth: '0',
	                        frameBorder: '0', scrolling: 'no',
	                        style: { height: '600px', width: '100%' }
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'text-center', style: { width: '100%' } },
	                        _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                            label: label,
	                            checkboxStyle: {},
	                            style: { width: '100%' },
	                            checked: attested,
	                            onChange: function onChange() {
	                                return setAttested(!attested);
	                            }
	                        }),
	                        _react2.default.createElement('div', { 'aria-hidden': true, className: 'vertical-offset-sm' }),
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                disabled: !attested,
	                                className: 'btn btn-primary',
	                                type: 'button',
	                                onClick: function onClick() {
	                                    (0, _twd.hideModal)();
	                                    onAttest(attested);
	                                }
	                            },
	                            'Submit'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Attestation = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Attestation = exports.Attestation = function Attestation() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        hasAttestCD = _useOrderTicket.hasAttestCD,
	        attestCD = _useOrderTicket.attestCD,
	        setAttestCD = _useOrderTicket.setAttestCD,
	        hasAttestCorp = _useOrderTicket.hasAttestCorp,
	        attestCorp = _useOrderTicket.attestCorp,
	        setAttestCorp = _useOrderTicket.setAttestCorp,
	        bondInfo = _useOrderTicket.bondInfo;
	
	    var prospectus = bondInfo && bondInfo.issue && bondInfo.issue.prospectus;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        hasAttestCD && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    { style: GreyBackground },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vertical-offset-xs' },
	                        'You must acknowledge the ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#',
	                                style: { cursor: 'pointer', textDecoration: 'underline' },
	                                onClick: function onClick() {
	                                    return (0, _twd.openWindow)("https://us.etrade.com/l/f/agreement-library/brokered-cd-disclosure", '_blank');
	                                }
	                            },
	                            'Brokerage CD Disclosure'
	                        ),
	                        ' before placing this order.'
	                    ),
	                    _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                        label: 'I have accessed the Brokerage CD Disclosure and agree to its terms.',
	                        checked: attestCD,
	                        onChange: function onChange() {
	                            return setAttestCD(!attestCD);
	                        }
	                    })
	                )
	            )
	        ),
	        hasAttestCorp && prospectus && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    { style: GreyBackground },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vertical-offset-xs' },
	                        'You must acknowledge the ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '#',
	                                style: { cursor: 'pointer', textDecoration: 'underline' },
	                                onClick: function onClick() {
	                                    return (0, _twd.openWindow)(prospectus, '_blank');
	                                }
	                            },
	                            'prospectus / offering document'
	                        ),
	                        ' before placing this order.'
	                    ),
	                    _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                        label: 'I have reviewed the prospectus / offering document before placing this order.',
	                        checkboxStyle: {},
	                        style: { width: '100%' },
	                        checked: attestCorp,
	                        onChange: function onChange() {
	                            return setAttestCorp(!attestCorp);
	                        }
	                    })
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var GreyBackground = {
	    padding: '10px',
	    backgroundColor: "rgb(246, 246, 246)"
	};

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Buttons = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Buttons = exports.Buttons = function Buttons() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        previewTicket = _useOrderTicket.previewTicket,
	        from = _useOrderTicket.from,
	        isRfq = _useOrderTicket.isRfq,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var label = isRfq && !isTreasuryAuction ? 'Preview quote request' : 'Preview order';
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'button',
	            {
	                'data-name': 'order-ticket-back-button',
	                className: 'btn btn-primary-outline',
	                onClick: function onClick() {
	
	                    if (!from || from === 'order-ticket') {
	                        (0, _twd.show)('overview');
	                        return;
	                    }
	
	                    var u = (0, _twd.safeURL)(from);
	                    if (u) {
	                        (0, _twd.openWindow)(u.toString());
	                        return;
	                    }
	
	                    (0, _twd.viewBack)();
	                }
	            },
	            'Back'
	        ),
	        _react2.default.createElement(Sep, null),
	        _react2.default.createElement(
	            'button',
	            {
	                className: 'btn btn-primary',
	                onClick: function onClick() {
	                    previewTicket();
	                }
	            },
	            label
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var Sep = function Sep() {
	    return _react2.default.createElement('span', { 'aria-hidden': true, style: { padding: '0 0 0 10px' } });
	};

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CusipInfo = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CusipInfo = exports.CusipInfo = function CusipInfo() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        cusip = _useOrderTicket.cusip,
	        bondInfo = _useOrderTicket.bondInfo,
	        bondInfoStatus = _useOrderTicket.bondInfoStatus,
	        hasBondInfo = _useOrderTicket.hasBondInfo,
	        hasAttestCD = _useOrderTicket.hasAttestCD,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var issue = bondInfo.issue || {};
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        show = _React$useState2[0],
	        setShow = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        setShow(cusip && hasBondInfo);
	    }, [cusip, hasBondInfo]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: bondInfoStatus },
	            show && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                !isTreasuryAuction && _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        _react2.default.createElement('hr', { 'aria-hidden': true })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_twd.Flyout, {
	                                label: 'Issuer',
	                                html: IssuerTooltip
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'h3 text-truncate', style: { marginBottom: '0px', maxWidth: '300px' } },
	                            _twd.fmt.issuer({
	                                issuer: (0, _twd.parseHtml)(issue.issue),
	                                cusip: cusip,
	                                showTradeHistory: 'Y',
	                                showBondDetail: 'Y',
	                                isTreasuryAuction: isTreasuryAuction,
	                                from: 'order-ticket'
	                            })
	                        ),
	                        _react2.default.createElement('div', { className: 'text-bold', dangerouslySetInnerHTML: { __html: issue.warningText } })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(_twd.Flyout, {
	                                label: 'Cusip',
	                                html: CusipTooltip
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'label text-bold' },
	                                cusip
	                            )
	                        )
	                    )
	                ),
	                hasAttestCD && _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'universal-message universal-message-info',
	                                style: { backgroundColor: '#ffffff' },
	                                role: 'alert' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'universal-message-content',
	                                    style: { width: '100%' } },
	                                'Brokerage CD\'s are FDIC insured up to $250,000'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var IssuerTooltip = '\n    A legal entity (such as a corporation, government, or municipality) which borrows money by issuing bonds.\n    The issuer is obligated to pay the principal and interest on the bond.\n';
	
	var CusipTooltip = '\n    CUSIP stands for Committee on Uniform Securities Identification Procedures. When issued,\n    each bond is assigned a CUSIP number, comprised of nine alphanumeric characters to uniquely\n    identify the security.\n';

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSearchResultCusips = exports.getSearchResultIssuers = exports.getSearchResultSymbols = exports.CusipSearch = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useCusipSearch2 = __webpack_require__(1032);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CusipSearch = exports.CusipSearch = function CusipSearch() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        acctNo = _ref.acctNo,
	        cusip = _ref.cusip,
	        setCusip = _ref.setCusip,
	        _ref$readOnly = _ref.readOnly,
	        readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
	        _ref$errors = _ref.errors,
	        errors = _ref$errors === undefined ? {} : _ref$errors,
	        _ref$isQrt = _ref.isQrt,
	        isQrt = _ref$isQrt === undefined ? false : _ref$isQrt;
	
	    var elId = (0, _twd.getId)();
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        show = _React$useState2[0],
	        setShow = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(null),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        inputEl = _React$useState4[0],
	        setInputEl = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(null),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        resultEl = _React$useState6[0],
	        setResultEl = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(cusip),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        keyword = _React$useState8[0],
	        setKeyword = _React$useState8[1];
	
	    _react2.default.useEffect(function () {
	        setKeyword(cusip);
	    }, [cusip]);
	
	    var _useCusipSearch = (0, _useCusipSearch2.useCusipSearch)({ keyword: keyword, isQrt: isQrt }),
	        status = _useCusipSearch.status,
	        error = _useCusipSearch.error,
	        searchResults = _useCusipSearch.searchResults;
	
	    var symbols = _react2.default.useMemo(function () {
	        return getSearchResultSymbols(searchResults);
	    }, [searchResults]);
	    var issuers = _react2.default.useMemo(function () {
	        return getSearchResultIssuers(searchResults);
	    }, [searchResults]);
	    var cusips = _react2.default.useMemo(function () {
	        return getSearchResultCusips(searchResults, keyword);
	    }, [searchResults]);
	
	    var onSearch = function onSearch(_ref2) {
	        var label = _ref2.label,
	            searchParams = _ref2.searchParams;
	
	        (0, _twd.showModal)({
	            view: 'order-ticket-search-modal',
	            title: label,
	            searchParams: searchParams,
	            from: 'order-ticket',
	            source: inputEl,
	            acctNo: acctNo
	        });
	    };
	
	    var id = (0, _twd.getId)();
	    var err = errors && errors.cusip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'from-group',
	                style: { paddingLeft: '0px', paddingRight: '0px' }
	            },
	            _react2.default.createElement(
	                'label',
	                { htmlFor: id, className: 'label' },
	                isQrt ? "CUSIP" : "CUSIP, symbol or company name"
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: err ? ' has-error' : '' },
	                _react2.default.createElement('input', Object.assign({
	                    ref: setInputEl,
	                    type: 'text',
	                    id: id,
	
	                    className: 'form-control'
	                }, show && { "aria-controls": elId }, {
	                    'aria-autocomplete': 'list',
	                    'aria-haspopup': 'listbox',
	                    'aria-expanded': show,
	                    role: 'combobox',
	                    autoComplete: 'off',
	                    readOnly: readOnly,
	                    'aria-readonly': readOnly,
	                    value: keyword,
	
	                    onChange: function onChange(e) {
	                        var val = e.target.value || '';
	                        setKeyword(val);
	                        if (!isQrt) {
	                            setShow(!!val);
	                        }
	                    },
	
	                    onPaste: function onPaste(e) {
	                        var v = e.clipboardData.getData('text/plain');
	                        if (!v) return;
	                        v = v.toUpperCase().trim();
	
	                        if (!(0, _twd.isCusip)(v)) return;
	                        e.preventDefault();
	                        setCusip(v);
	                    },
	
	                    onBlur: function onBlur(e) {
	                        if (!show && !isQrt) return;
	                        if (resultEl && resultEl.getAttribute('mouse-on-result')) {
	                            inputEl.focus();
	                            return;
	                        }
	                        setShow(false);
	
	                        var v = e.target.value || '';
	                        if (!v) return;
	                        v = v.toUpperCase().trim();
	
	                        if (!(0, _twd.isCusip)(v)) return;
	                        setCusip(v);
	                    },
	
	                    onKeyUp: function onKeyUp(e) {
	                        var key = e.keyCode || e.key || e.which;
	                        if (!(key === 13 || key === 'Enter')) return;
	
	                        var v = e.target.value;
	                        if (!v) return;
	                        v = v.toUpperCase().trim();
	
	                        if ((0, _twd.isCusip)(v)) {
	                            e.preventDefault();
	                            e.target.blur();
	                            return;
	                        }
	
	                        if (!resultEl) {
	                            return;
	                        }
	
	                        var el = resultEl.querySelector('.auto-suggest-menu-item');
	                        if (!el) return;
	
	                        var i = (0, _twd.getEventHandlers)(el).item;
	                        if (!i) return;
	
	                        e.preventDefault();
	                        e.target.blur();
	                        onSearch(i);
	                    },
	
	                    onKeyDown: function onKeyDown(e) {
	                        var key = e.keyCode || e.key || e.which;
	
	                        var isEsc = key === 27 || key === 'Escape';
	                        var isTab = key === 9 || key === 'Tab';
	
	                        if (isTab) {
	                            if (show) resultEl.removeAttribute('mouse-on-result');
	                            setKeyword(cusip || '');
	                            inputEl.blur();
	                            return;
	                        }
	
	                        if (isEsc) {
	                            inputEl.value = '';
	                            setKeyword('');
	                            return;
	                        }
	
	                        if (!show) return;
	
	                        if (key === 38 || key === 'ArrowUp') {
	                            moveSearchResultItemFocus(resultEl, -1);
	                            return;
	                        }
	
	                        if (key === 40 || key === 'ArrowDown') {
	                            moveSearchResultItemFocus(resultEl, 1);
	                            return;
	                        }
	                    }
	                })),
	                err && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    err
	                )
	            ),
	            show && _react2.default.createElement(
	                'div',
	                {
	                    ref: setResultEl,
	                    className: 'auto-suggest-menu',
	                    id: elId,
	                    role: 'listbox',
	                    style: { margin: '6px 12px', padding: '6px 12px', top: 'auto' },
	                    onMouseOver: function onMouseOver() {
	                        resultEl.setAttribute('mouse-on-result', 'Y');
	                    },
	                    onMouseOut: function onMouseOut() {
	                        resultEl.removeAttribute('mouse-on-result');
	                    }
	                },
	                _react2.default.createElement(
	                    _twd.Loading,
	                    { status: status, error: error, spinner: false },
	                    !isQrt && symbols.map(function (a, i) {
	                        return formatSearchResultItem('Symbol(s)', a, i, onSearch);
	                    }),
	                    !isQrt && issuers.map(function (a, i) {
	                        return formatSearchResultItem('Issuer(s)', a, i, onSearch);
	                    }),
	                    cusips.map(function (a, i) {
	                        return formatSearchResultItem('CUSIP(s)', a, i, onSearch);
	                    })
	                )
	            )
	        ),
	        !isQrt && _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                'a',
	                { href: '#', onClick: function onClick() {
	                        (0, _twd.show)('advanced-screener', Object.assign({
	                            _ts: Date.now(),
	                            from: 'order-ticket'
	                        }));
	                    } },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'material-icons', 'aria-hidden': 'true', style: { color: 'var(--primary-base-color)' } },
	                    'search'
	                ),
	                'Advanced lookup'
	            )
	        )
	    );
	};
	
	var formatSearchResultItem = function formatSearchResultItem(title, item, i, onSearch) {
	    var id = (0, _twd.getId)();
	    if (i === 0) {
	        return _react2.default.createElement(
	            'div',
	            { key: title + '-' + i, 'aria-labelledby': id, role: 'group' },
	            _react2.default.createElement(
	                'div',
	                { className: 'auto-suggest-menu-header',
	                    id: id,
	                    role: 'presentation'
	                },
	                title
	            ),
	            formatItem(item, i, onSearch)
	        );
	    }
	    return formatItem(item, i, onSearch);
	};
	
	var formatItem = function formatItem(item, i, onSearch) {
	    return _react2.default.createElement(
	        'div',
	        {
	            key: 'cusip-search-' + i,
	            'aria-selected': 'false',
	            className: 'auto-suggest-menu-item text-truncate',
	            style: { color: "var(--primary-base-color)" },
	            role: 'option',
	            item: item,
	            onClick: function onClick() {
	                return onSearch(item);
	            }
	        },
	        item.label
	    );
	};
	
	var moveSearchResultItemFocus = function moveSearchResultItemFocus(resultEl, k) {
	    var arr = Array.from(resultEl.querySelectorAll('.auto-suggest-menu-item'));
	    var n = arr.length;
	    if (n === 0) return;
	
	    var i = arr.findIndex(function (e) {
	        return e.classList.contains('focus');
	    });
	    if (i >= 0) {
	        arr[i].classList.remove('focus');
	        arr[i].setAttribute('aria-selected', 'false');
	    }
	
	    i = (n + i + k) % n;
	    arr[i].classList.add('focus');
	    arr[i].setAttribute('aria-selected', 'true');
	};
	
	var getSearchResultSymbols = exports.getSearchResultSymbols = function getSearchResultSymbols(rs) {
	    return Object.values(rs.reduce(function (x, r) {
	        var t = r.type;
	        if (t !== 'C') return x;
	
	        var k = r.symbol;
	        if (!k || k in x) return x;
	
	        x[k] = {
	            type: 'symbol',
	            label: k,
	            value: r.cusip,
	            searchParams: {
	                holdInvType: ['C'],
	                holdSymbol: [k]
	            }
	        };
	        return x;
	    }, {}));
	};
	
	var getSearchResultIssuers = exports.getSearchResultIssuers = function getSearchResultIssuers(rs) {
	    return Object.values(rs.reduce(function (x, r) {
	        var k = r.issue;
	        if (!k || k in x) return x;
	
	        x[k] = {
	            type: 'issuer',
	            label: k,
	            value: r.cusip,
	            searchParams: {
	                holdIssue: [k]
	            }
	        };
	        return x;
	    }, {}));
	};
	
	var getSearchResultCusips = exports.getSearchResultCusips = function getSearchResultCusips(rs, keyword) {
	    return Object.values(rs.reduce(function (x, r) {
	        var k = r.cusip;
	        if (!k || k in x) return x;
	
	        x[k] = {
	            type: 'cusip',
	            label: k,
	            value: k,
	            searchParams: {
	                holdCusip: [k],
	                holdIdentifierLabel: "holdCusip",
	                holdIdentifiers: [k]
	            }
	        };
	        return x;
	    }, {}));
	};

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useCusipSearch = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('order-ticket.cusip-search', {});
	
	var useCusipSearch = exports.useCusipSearch = function useCusipSearch(_ref) {
	    var keyword = _ref.keyword,
	        isQrt = _ref.isQrt;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(''),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        error = _React$useState4[0],
	        setError = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        searchResults = _React$useState6[0],
	        setSearchResults = _React$useState6[1];
	
	    var timerId = _react2.default.useRef();
	    var lastKeyword = _react2.default.useRef(state.value.lastKeyword);
	    var lastAbort = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	        if (isQrt) return;
	
	        if (timerId.current) {
	            clearTimeout(timerId.current);
	            timerId.current = 0;
	        }
	
	        var dismounted = false;
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref3, data, abort, a, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (keyword) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            if (!(lastKeyword.current === keyword && searchResults.length > 0)) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 4:
	
	                            state.set({ lastKeyword: keyword });
	                            setStatus(_twd.Status.LOADING);
	                            setError('');
	                            lastKeyword.current = keyword;
	
	                            _context.prev = 8;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 12;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/securitysuggestions',
	                                method: 'GET',
	                                params: {
	                                    keyword: keyword.trim(),
	                                    page: 1,
	                                    start: 0,
	                                    limit: 10
	                                }
	                            });
	
	                        case 12:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            abort = _ref3.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 18;
	                            return data;
	
	                        case 18:
	                            a = _context.sent;
	
	                            if (!dismounted) {
	                                _context.next = 21;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 21:
	
	                            (0, _twd.track)('Bond Resource Center Search', { search_term: keyword.trim() });
	
	                            rs = (a.securities || []).slice(0, 10).map(function (a) {
	                                a.searchParams = {
	                                    holdCusip: [a.cusip],
	                                    holdIdentifierLabel: "holdCusip",
	                                    holdIdentifiers: [a.cusip],
	                                    offeringType: ['ask-side']
	                                };
	                                return a;
	                            });
	
	                            if (!(rs.length === 0)) {
	                                _context.next = 25;
	                                break;
	                            }
	
	                            throw new Error('empty-result');
	
	                        case 25:
	
	                            setSearchResults(rs);
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 36;
	                            break;
	
	                        case 29:
	                            _context.prev = 29;
	                            _context.t0 = _context['catch'](8);
	
	                            if (!dismounted) {
	                                _context.next = 33;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 33:
	
	                            setSearchResults([]);
	                            setError('\n                    There are no results that match your search for\n                    <span class="text-bold"><u>' + keyword + '</u></span>.\n                    Please review your search criteria and try again.\n                ');
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 36:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[8, 29]]);
	        })), 500);
	
	        return function () {
	            dismounted = true;
	
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	            if (timerId.current) {
	                clearTimeout(timerId.current);
	                timerId.current = 0;
	            }
	        };
	    }, [keyword]);
	
	    return { status: status, error: error, keyword: keyword, searchResults: searchResults };
	};

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ExecutionType = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExecutionTypeTooltip = '\n    A Fill or Kill order is an order that is either immediately executed, or rejected if it cannot be filled at the specified price.\n    Occasionally, E*TRADE will find a better price than what was originally quoted, and will execute the order at the improved price.\n    These improved prices are displayed in your order status. A Subject bond order is an order whose both price and availability\n    are subject to change after order entry. All secondary market prices you see in search results are external dealer prices.\n    No markup is added to these prices by E*TRADE\n'; /* eslint-disable no-use-before-define */
	var ExecutionType = exports.ExecutionType = function ExecutionType() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        action = _useOrderTicket.action,
	        orderInfo = _useOrderTicket.orderInfo,
	        hasOrderInfo = _useOrderTicket.hasOrderInfo,
	        hasBondInfo = _useOrderTicket.hasBondInfo,
	        executionType_ = _useOrderTicket.executionType_,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var isRFQ = action === 'W' || action === 'F';
	    var et = orderInfo.executionType || executionType_;
	    var txt = !hasOrderInfo || !hasBondInfo ? _twd.fmt.empty() : isRFQ || isTreasuryAuction ? 'Subject' : orderInfo.primary === 'Y' ? 'Firm' : et === 'Firm' ? 'Firm (Fill or Kill)' : et === 'Limit' ? 'Limit (Fill or Kill)' : 'Fill or Kill';
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'from-group', style: { paddingLeft: '0px', paddingRight: '0px' } },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_twd.Flyout, {
	                    label: 'Execution Type',
	                    html: ExecutionTypeTooltip
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'input-group  vertical-offset-xxs' },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'label text-bold' },
	                    txt
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Form = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectCusip = __webpack_require__(1039);
	
	var _cusipInfo = __webpack_require__(1030);
	
	var _selectAction = __webpack_require__(1038);
	
	var _quantity = __webpack_require__(1036);
	
	var _executionType = __webpack_require__(1033);
	
	var _price = __webpack_require__(1035);
	
	var _yield = __webpack_require__(1041);
	
	var _salesCredit = __webpack_require__(1037);
	
	var _buttons = __webpack_require__(1029);
	
	var _attestations = __webpack_require__(1028);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define,no-mixed-operators */
	var Form = exports.Form = function Form() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        action = _useOrderTicket.action,
	        isRfq = _useOrderTicket.isRfq,
	        mode = _useOrderTicket.mode,
	        errors = _useOrderTicket.errors,
	        noMarketRfq = _useOrderTicket.noMarketRfq,
	        isRestricted = _useOrderTicket.isRestricted,
	        isChangeToRfq = _useOrderTicket.isChangeToRfq,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var hasFormError = Object.keys(errors).length > 0;
	    var hasPriceYield = !isRfq && !isRestricted || mode === _useOrderTicket2.MODES.ORDER_Z;
	
	    var msg = null;
	    var hasMsg = !isRestricted && noMarketRfq || isChangeToRfq;
	    if (hasMsg && !isTreasuryAuction) {
	        msg = action === 'S' ? NO_BID_MSG : action === 'B' ? NO_OFFER_MSG : action === 'W' ? NO_BID_MSG : action === 'F' ? NO_OFFER_MSG : null;
	    }
	
	    var hasSC = !isRfq || isTreasuryAuction;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'order-ticket-form',
	                className: 'container order-ticket-form vertical-offset-sm',
	                css: _style.sectionCss },
	            !isTreasuryAuction && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	                (0, _core.jsx)(_selectCusip.SelectCusip, null)
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(_cusipInfo.CusipInfo, null),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)('hr', { 'aria-hidden': true })
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-sm-6 col-xs-12 vertical-offset-sm' },
	                    (0, _core.jsx)(_selectAction.SelectAction, null)
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-sm-6 col-xs-12 vertical-offset-sm' },
	                    (0, _core.jsx)(_quantity.Quantity, null)
	                )
	            ),
	            (hasPriceYield || isTreasuryAuction) && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12 col-xs-12  vertical-offset-sm' },
	                        (0, _core.jsx)(_executionType.ExecutionType, null)
	                    )
	                )
	            ),
	            hasPriceYield && !isTreasuryAuction && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12 col-xs-12 vertical-offset-sm' },
	                        (0, _core.jsx)(_price.Price, null)
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12 col-xs-12 vertical-offset-md' },
	                        (0, _core.jsx)(_yield.Yield, null)
	                    )
	                )
	            ),
	            hasFormError && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12 col-xs-12 text-center' },
	                        (0, _core.jsx)(
	                            'label',
	                            { className: 'has-error' },
	                            'Please fill out the required information'
	                        )
	                    )
	                )
	            ),
	            msg && (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'universal-message universal-message-warning', role: 'alert' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'universal-message-content' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'universal-message-heading' },
	                                msg
	                            )
	                        )
	                    )
	                )
	            ),
	            isRestricted && function () {
	                var t = ['B', 'F'].indexOf(action) >= 0 ? 'Buy orders and offer wanted quote requests'
	                // : ['S','W'].indexOf(action)>=0 ? 'Sell orders and bid wanted quote requests'
	                : 'Orders and quote requests';
	
	                var msg = t + ' for this asset class are not available for online trading.\n                Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders.';
	
	                return (0, _core.jsx)(
	                    _react2.default.Fragment,
	                    null,
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'universal-message universal-message-warning', role: 'alert' },
	                                (0, _core.jsx)(
	                                    'div',
	                                    { className: 'universal-message-content' },
	                                    (0, _core.jsx)(
	                                        'div',
	                                        { className: 'universal-message-heading' },
	                                        msg
	                                    )
	                                )
	                            )
	                        )
	                    )
	                );
	            }(),
	            hasPriceYield && (0, _core.jsx)(_attestations.Attestation, null),
	            (hasPriceYield || hasFormError || isTreasuryAuction) && (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)('hr', { 'aria-hidden': true })
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                hasSC && (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-7 col-xs-12 vertical-offset-sm', style: { display: 'flex' } },
	                    (0, _core.jsx)(_salesCredit.SalesCredit, null)
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: (!hasSC ? "" : "col-md-5") + ' col-xs-12 text-center vertical-offset-sm', css: _style.textAlignRight },
	                    (0, _core.jsx)(_buttons.Buttons, null)
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	};
	
	var NO_BID_MSG = "There is no bid for this quantity. Please click ‘Preview Order’ to submit this order as a bid wanted quote request.";
	
	var NO_OFFER_MSG = "There is no offer for this quantity. Please click ‘Preview Order’ to submit this order as an offer wanted quote request.";

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Price = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Price = exports.Price = function Price() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        action = _useOrderTicket.action,
	        price = _useOrderTicket.price,
	        setPrice = _useOrderTicket.setPrice,
	        priceOrYield = _useOrderTicket.priceOrYield,
	        setPriceOrYield = _useOrderTicket.setPriceOrYield,
	        orderInfo = _useOrderTicket.orderInfo,
	        hasOrderInfo = _useOrderTicket.hasOrderInfo,
	        hasBondInfo = _useOrderTicket.hasBondInfo,
	        mode = _useOrderTicket.mode,
	        errors = _useOrderTicket.errors,
	        setPriceEl = _useOrderTicket.setPriceEl,
	        isRestricted = _useOrderTicket.isRestricted,
	        bestPrice = _useOrderTicket.bestPrice;
	
	    var s = orderInfo.statusMsg || '';
	    var hasMarket = s.indexOf('NO OFFERINGS FOR TICKET') < 0 && s.indexOf('NO ORDER CONFIGURED FOR TICKET') < 0;
	
	    var canTrade = hasBondInfo && !isRestricted;
	    var isLift = mode === _useOrderTicket2.MODES.ORDER_Z;
	    var isDisabled = !canTrade || !hasMarket;
	    var isCounterDisallowed = canTrade && (orderInfo.countersAllowed === 'N' || orderInfo.primary === 'Y');
	    var isReadOnly = isLift || isCounterDisallowed;
	
	    var id = (0, _twd.getId)();
	    var err = !isDisabled && errors && errors.price;
	    var priceLabel = action === 'B' ? 'Offer' : action === 'S' ? 'Bid' : '';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: isReadOnly ? "" : "row" },
	            !isReadOnly && (0, _core.jsx)(
	                'div',
	                { className: 'col-md-1 col-xs-1 col-auto', style: { minWidth: '25px', maxWidth: '25px', marginTop: '20px' } },
	                (0, _core.jsx)('input', {
	                    type: 'radio',
	                    'aria-label': 'Choose price',
	                    name: "order-ticket-form-price-or-yield",
	                    value: 1,
	                    checked: priceOrYield === 1,
	                    onChange: function onChange() {
	                        return setPriceOrYield(1);
	                    }
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-1 col-xs-5 col-auto',
	                    style: Object.assign({
	                        minWidth: '130px'
	                    }, isReadOnly ? { paddingLeft: 0 } : {})
	                },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'from-group', style: { paddingLeft: '0px', paddingRight: '0px' } },
	                    (0, _core.jsx)(
	                        'div',
	                        null,
	                        (0, _core.jsx)(_twd.Flyout, {
	                            label: 'Price',
	                            labelAttrs: { htmlFor: id },
	                            isLabel: true,
	                            html: PriceTooltip
	                        })
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: err ? ' has-error' : '' },
	                        isReadOnly && (0, _core.jsx)(
	                            'div',
	                            { className: 'input-group' },
	                            (0, _core.jsx)(
	                                'label',
	                                { className: 'label text-bold' },
	                                '$',
	                                _twd.fmt.price3N(isCounterDisallowed ? bestPrice : orderInfo.price)
	                            )
	                        ),
	                        !isReadOnly && (0, _core.jsx)('input', {
	                            type: 'number',
	                            ref: setPriceEl,
	                            id: id,
	                            className: 'form-control',
	                            value: price,
	                            min: '0',
	                            step: 'any',
	                            disabled: isDisabled,
	                            'aria-disabled': isDisabled,
	                            style: { paddingLeft: '20px' },
	                            onChange: function onChange(e) {
	                                setPrice(e.target.value || '');
	                            }
	                        })
	                    ),
	                    err && (0, _core.jsx)(
	                        'label',
	                        { className: 'field-status has-error' },
	                        err
	                    )
	                )
	            ),
	            hasOrderInfo && canTrade && priceLabel && !isReadOnly && (0, _core.jsx)(
	                'div',
	                { className: 'col-md-1 col-xs-5 col-auto', style: { minWidth: '200px', marginTop: '20px' } },
	                (0, _core.jsx)(
	                    'div',
	                    { css: _style.displayInline },
	                    priceLabel,
	                    ' Price: '
	                ),
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    '$',
	                    _twd.fmt.price3N(bestPrice)
	                )
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var PriceTooltip = '\n    The price displayed on your bond order ticket is typically firm from the participating dealer.\n    In some instances, a dealer may allow for limit pricing to be submitted with your order.\n    In these instances where a dealer will evaluate limit prices, you may set the maximum or minimum price\n    you\u2019re willing to buy or sell a security with your order. Limit price orders may be rejected by the dealer.\n    Please note, bond prices are usually expressed as a percentage of the bond\u2019s face value, or par value\n    (e.g. a bond with a par value of $1,000, quoted at a price of $99, will cost $990 per bond).\n';

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Quantity = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Quantity = exports.Quantity = function Quantity() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        qty = _useOrderTicket.qty,
	        setQty = _useOrderTicket.setQty,
	        price = _useOrderTicket.price,
	        priceOrYield = _useOrderTicket.priceOrYield,
	        yld = _useOrderTicket.yld,
	        action = _useOrderTicket.action,
	        orderInfo = _useOrderTicket.orderInfo,
	        mode = _useOrderTicket.mode,
	        cusip = _useOrderTicket.cusip,
	        hasMarket = _useOrderTicket.hasMarket,
	        isRfq = _useOrderTicket.isRfq,
	        errors = _useOrderTicket.errors,
	        hasBondInfo = _useOrderTicket.hasBondInfo,
	        positionsTotalQty = _useOrderTicket.positionsTotalQty,
	        bondInfo = _useOrderTicket.bondInfo,
	        isRestricted = _useOrderTicket.isRestricted,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var canTrade = hasBondInfo && !isRestricted;
	    var isLift = mode === _useOrderTicket2.MODES.ORDER_Z;
	    var isDisabled = !canTrade;
	    var isReadOnly = isLift;
	
	    var id = (0, _twd.getId)();
	    var err = !isReadOnly && !isRestricted && errors && errors.qty;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'from-group',
	                style: { paddingLeft: '0px', paddingRight: '0px' }
	            },
	            _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'space-between' } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_twd.Flyout, {
	                        label: 'Quantity',
	                        labelAttrs: { htmlFor: id },
	                        isLabel: true,
	                        html: QuantityTooltip
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    !isTreasuryAuction && _react2.default.createElement(
	                        'button',
	                        {
	                            style: { minHeight: '20px' },
	                            'data-name': 'bond-detail-bond-offerings-price-yield-calculator',
	                            className: 'link-button',
	                            onClick: function onClick() {
	
	                                var best = hasBondInfo && bondInfo.bestoffer || {};
	                                var off = action === 'B' || action === 'F' ? best.ask : best.bid;
	                                var pxType = off ? '1' : priceOrYield;
	                                var px = pxType === '1' ? off && off.price || price || 100 : yld;
	
	                                if ((0, _twd.getConfig)('entitlements.ETradeCalculator', 'No') === 'Yes') {
	                                    (0, _twd.showModal)((0, _twd.cleanObject)({
	                                        view: 'calculator',
	                                        cusip: cusip,
	                                        from: 'order-ticket'
	                                        // action: (action === 'B' || action==='F') ? 'B' : 'S',
	                                        // price: price || (off && off.price) || 100,
	                                        // yld,
	                                        // priceOrYield,
	                                        // qty: qty || (off && off.quantity) || null,
	                                    }));
	                                    return;
	                                }
	
	                                var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	                                var sp = new URLSearchParams();
	
	                                sp.set('p_javascript', 2);
	                                sp.set('p_data_source', off && off.id ? 'I' : 'D');
	                                sp.set('p_id', off && off.id || cusip);
	                                sp.set('p_price_type', pxType);
	                                sp.set('p_price', px);
	                                sp.set('p_quantity', off && off.quantity || qty || 0);
	                                sp.set('p_commission', '');
	                                sp.set('p_ts', Date.now());
	
	                                var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	                                var url = base + '/' + owaTcDaoContext + '/pkg_calc_bond_online.seed?' + sp.toString();
	
	                                (0, _twd.publish)('open', {
	                                    url: url,
	                                    name: '_blank',
	                                    options: "toolbar=no,width=760,height=490,directories=no,status=no,scrollbars=no,resizable=yes,menubar=no"
	                                });
	                            }
	                        },
	                        (0, _twd.iconLabel)(_twd.icons.calculate, 'Price/yield calculator')
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: err ? ' has-error' : '' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'input-group vertical-offset-xxs' },
	                    _react2.default.createElement('input', {
	                        type: 'number',
	                        id: id,
	                        className: 'form-control',
	                        value: qty,
	                        readOnly: isReadOnly,
	                        'aria-readonly': isReadOnly,
	                        disabled: isDisabled || isReadOnly,
	                        step: '1',
	                        min: '0',
	                        style: { paddingLeft: '20px' },
	                        onChange: function onChange(e) {
	                            setQty(e.target.value || '');
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'input-group-addon text-body' },
	                        ',000'
	                    )
	                ),
	                err && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    err
	                )
	            )
	        ),
	        cusip && !isRfq && (hasMarket || isTreasuryAuction) && !isLift && function () {
	            var qty_min = orderInfo.qty_min,
	                qty_max = orderInfo.qty_max;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                'Min: ',
	                _twd.fmt.qty(qty_min),
	                qty_max && _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    ' - Max: ',
	                    _twd.fmt.qty(qty_max)
	                )
	            );
	        }(),
	        cusip && _react2.default.createElement(
	            'div',
	            null,
	            'Total position: ',
	            _twd.fmt.qty(positionsTotalQty)
	        )
	    );
	}; /* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var QuantityTooltip = '\n    Utilize the variable quantity field to input the number of bonds you wish to buy or sell.\n    For buy and sell orders, the quantity range displayed below the input field represents the minimum\n    and maximum quantity available from the offering dealer.\n    Entering a quantity below the dealer minimum or exceeding the dealer maximum will cause a bond order to convert\n    into a quote request.\n    The \u201CMy total position:\u201D (displayed below the input field after a bond is loaded into the ticket)\n    represents the number of bonds held in the active account for the CUSIP shown.\n';

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SalesCredit = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var SalesCredit = exports.SalesCredit = function SalesCredit() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        orderInfo = _useOrderTicket.orderInfo,
	        hasMarket = _useOrderTicket.hasMarket,
	        isRfq = _useOrderTicket.isRfq,
	        calculateTicket = _useOrderTicket.calculateTicket,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        calculating = _React$useState2[0],
	        setCalculating = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState({
	        comm: 0,
	        netMoney: 0
	    }),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        calc = _React$useState4[0],
	        setCalc = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        if (calculating) {
	            setCalc({ comm: 0, netMoney: 0 });
	            return;
	        }
	        setCalc({
	            comm: orderInfo.sugg_comm_in_dlrs_per_tckt || 0,
	            netMoney: orderInfo.netMoney || 0
	        });
	    }, [calculating, orderInfo]);
	
	    var calcTotals = function () {
	        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	            var isSkipErrors = _ref.isSkipErrors;
	            var a;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            setCalculating(true);
	                            _context.next = 3;
	                            return calculateTicket({ isSkipErrors: isSkipErrors });
	
	                        case 3:
	                            a = _context.sent;
	
	                            if (a) {
	                                orderInfo.sugg_comm_in_dlrs_per_tckt = a.sugg_comm_in_dlrs_per_tckt;
	                                orderInfo.netMoney = a.netMoney;
	                            }
	                            setCalculating(false);
	
	                        case 6:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }));
	
	        return function calcTotals(_x) {
	            return _ref2.apply(this, arguments);
	        };
	    }();
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('order_ticket_recalc_totals.order_ticket_form_sales_credit', function () {
	            calcTotals({ isSkipErrors: true });
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    if (!isTreasuryAuction && (isRfq || !hasMarket)) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { minWidth: '90px', display: 'inline-block' } },
	            _react2.default.createElement(
	                'div',
	                null,
	                'Comm.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'text-bold' },
	                _twd.fmt.money(calc.comm)
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { minWidth: '90px', display: 'inline-block' } },
	            _react2.default.createElement(
	                'div',
	                null,
	                'Est. Total'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'text-bold' },
	                isTreasuryAuction ? 'Auction' : _twd.fmt.money(calc.netMoney)
	            )
	        ),
	        !isTreasuryAuction && _react2.default.createElement(
	            'div',
	            { style: { minWidth: '90px', display: 'inline-flex', verticalAlign: 'middle' } },
	            !calculating && _react2.default.createElement(
	                'button',
	                {
	                    className: 'link-button',
	                    onClick: calcTotals
	                },
	                'Calculate totals'
	            ),
	            calculating && _react2.default.createElement(Calculating, null)
	        )
	    );
	};
	
	var Calculating = function Calculating() {
	    return _react2.default.createElement(
	        'div',
	        { 'data-name': 'calculating-spinner', className: 'spinner', style: { width: '30px' }, 'aria-busy': 'true' },
	        _react2.default.createElement(
	            'svg',
	            { className: 'circular', viewBox: '25 25 50 50' },
	            _react2.default.createElement('circle', { className: 'background', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' }),
	            _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' })
	        )
	    );
	};

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectAction = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTooltip = '\n    Select Buy to purchase a security.<br/>\n    Select Sell to sell a security.<br/>\n    Select Buy Quote (Offer Wanted) to request a price quote to purchase a security.<br/>\n    Select Sell Quote (Bid Wanted) to request a price quote to sell a security.\n'; /* eslint-disable no-use-before-define */
	var SelectAction = exports.SelectAction = function SelectAction() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        action_ = _useOrderTicket.action,
	        setAction = _useOrderTicket.setAction,
	        mode = _useOrderTicket.mode,
	        errors = _useOrderTicket.errors,
	        hasBondInfo = _useOrderTicket.hasBondInfo,
	        noMarketRfq = _useOrderTicket.noMarketRfq,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var canTrade = hasBondInfo;
	    var isLift = mode === _useOrderTicket2.MODES.ORDER_Z;
	    var isDisabled = !canTrade;
	    var isReadOnly = isLift || isTreasuryAuction;
	    var isRqt = mode === _useOrderTicket2.MODES.RFQ || noMarketRfq;
	
	    var id = (0, _twd.getId)();
	    var err = errors && errors.action;
	
	    var action = isTreasuryAuction ? 'B' : action_;
	    var borderLeftColor = action === 'B' || action === 'F' ? '#107A1B' : action === 'S' || action === 'W' ? '#CC0000' : '';
	    var selectStyle = !hasBondInfo || err ? {} : {
	        borderLeftWidth: '4px',
	        borderLeftColor: borderLeftColor,
	        paddingLeft: '9px'
	    };
	
	    var hasBuy = !isRqt || isTreasuryAuction;
	    var hasSell = !isRqt && !isTreasuryAuction;
	    var hasBid = !isTreasuryAuction;
	    var hasAsk = !isTreasuryAuction;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'from-group',
	                style: { paddingLeft: '0px', paddingRight: '0px' }
	            },
	            _react2.default.createElement(
	                'div',
	                { style: { lineHeight: '20px', display: 'inline', paddingBottom: '2px' } },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_twd.Flyout, {
	                        label: 'Action',
	                        labelAttrs: { htmlFor: id },
	                        isLabel: true,
	                        html: ActionTooltip
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'select-wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: err ? ' has-error' : '' },
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            id: id,
	                            'data-name': 'order-ticket-account-select',
	                            defaultValue: action,
	                            onChange: function onChange(e) {
	                                return setAction(e.target.value);
	                            },
	                            className: 'form-control',
	                            readOnly: isReadOnly,
	                            'aria-readonly': isReadOnly,
	                            disabled: isDisabled || isReadOnly,
	                            style: selectStyle
	                        },
	                        isDisabled && _react2.default.createElement(
	                            'option',
	                            { value: '', selected: !action },
	                            'Select'
	                        ),
	                        hasBuy && _react2.default.createElement(
	                            'option',
	                            { value: 'B', selected: action === 'B' },
	                            'Buy'
	                        ),
	                        hasSell && _react2.default.createElement(
	                            'option',
	                            { value: 'S', selected: action === 'S' },
	                            'Sell'
	                        ),
	                        hasBid && _react2.default.createElement(
	                            'option',
	                            { value: 'W', selected: action === 'W' },
	                            'Sell Quote (Bid Wanted)'
	                        ),
	                        hasAsk && _react2.default.createElement(
	                            'option',
	                            { value: 'F', selected: action === 'F' },
	                            'Buy Quote (Offer Wanted)'
	                        )
	                    )
	                ),
	                err && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    err
	                )
	            )
	        ),
	        _react2.default.createElement('div', { className: 'col-md-2 col-xs' })
	    );
	};

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectCusip = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' {\n        float: left;\n        width: calc(50% - 10px);\n        padding-right: 0px;\n    }\n'], ['\n    ', ' {\n        float: left;\n        width: calc(50% - 10px);\n        padding-right: 0px;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    font-weight: 500;\n    ', ' {\n        display: inline-block;\n        max-width: 20px;\n        margin-top: 20px;\n        margin-left: 5px;\n    }\n    ', ' {\n        margin-bottom:15px;\n    }\n'], ['\n    font-weight: 500;\n    ', ' {\n        display: inline-block;\n        max-width: 20px;\n        margin-top: 20px;\n        margin-left: 5px;\n    }\n    ', ' {\n        margin-bottom:15px;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    ', ' {\n        float: right;\n        padding-left: 0px;\n        width: calc(50% - 10px);\n    }\n'], ['\n    ', ' {\n        float: right;\n        padding-left: 0px;\n        width: calc(50% - 10px);\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _cusipSearch = __webpack_require__(1031);
	
	var _selectHolding = __webpack_require__(1040);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var SelectCusip = exports.SelectCusip = function SelectCusip() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        cusip = _useOrderTicket.cusip,
	        acctNo = _useOrderTicket.acctNo,
	        mode = _useOrderTicket.mode,
	        errors = _useOrderTicket.errors,
	        setCusip = _useOrderTicket.setCusip,
	        positions = _useOrderTicket.positions,
	        actionSubset_ = _useOrderTicket.actionSubset_;
	
	    var canEdit = mode !== _useOrderTicket2.MODES.ORDER_Z;
	
	    var updateCusip = function updateCusip(newCusip) {
	        if (!newCusip) return;
	        newCusip = newCusip.toUpperCase().trim();
	
	        if (cusip && cusip === newCusip) return;
	
	        var hasCusip = (0, _twd.arrayFrom)(positions).map(function (_ref) {
	            var cusip = _ref.cusip;
	            return cusip;
	        }).indexOf(newCusip) >= 0;
	
	        var isRqt = mode === _useOrderTicket2.MODES.RFQ;
	        var act = isRqt ? 'W' : !isRqt && hasCusip ? 'S' : 'B';
	
	        var isBuySell = act === 'B' || act === 'S';
	
	        setCusip(newCusip);
	
	        setTimeout(function () {
	            (0, _twd.show)('order-ticket', {
	                acctNo: acctNo,
	                cusip: newCusip,
	                action: act,
	                actionSubset: isBuySell ? '' : actionSubset_,
	                ts: Date.now()
	            });
	        }, 200);
	    };
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-6 col-xs-12 vertical-offset-xs', css: selectCusipCss },
	                (0, _core.jsx)(_cusipSearch.CusipSearch, {
	                    acctNo: acctNo,
	                    cusip: cusip,
	                    setCusip: updateCusip,
	                    readOnly: !canEdit,
	                    errors: errors,
	                    isQrt: actionSubset_ === 'WF'
	                })
	            ),
	            canEdit && (0, _core.jsx)(
	                'div',
	                { className: 'text-center', css: orCss },
	                'or'
	            ),
	            canEdit && (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 col-xs-12 vertical-offset-xs', css: selectHoldingCss },
	                    (0, _core.jsx)(_selectHolding.SelectHolding, null)
	                )
	            )
	        )
	    );
	};
	
	var selectCusipCss = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);
	
	var orCss = (0, _core.css)(_templateObject2, _twd.mediaQueries.notXs, _twd.mediaQueries.xs);
	
	var selectHoldingCss = (0, _core.css)(_templateObject3, _twd.mediaQueries.notXs);

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SelectHolding = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectHolding = exports.SelectHolding = function SelectHolding() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        positions = _useOrderTicket.positions,
	        mode = _useOrderTicket.mode,
	        cusip = _useOrderTicket.cusip,
	        setCusip = _useOrderTicket.setCusip,
	        acctNo = _useOrderTicket.acctNo,
	        actionSubset_ = _useOrderTicket.actionSubset_;
	
	    var rs = (0, _twd.arrayFrom)(positions).filter(function (_ref) {
	        var maturity = _ref.maturity;
	
	        var isMatured = (0, _twd.parseDate)(maturity) < Date.now();
	        return !isMatured;
	    }).sort((0, _twd.sortFn)(function (_ref2) {
	        var issue = _ref2.issue,
	            maturity = _ref2.maturity;
	
	        return (issue || '').trim() + _twd.fmt.fmtDt((0, _twd.parseDate)(maturity), 'yyyy-MM-dd');
	    }));
	    var isDisabled = rs.length === 0;
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'from-group',
	            style: { paddingLeft: '0px', paddingRight: '0px' }
	        },
	        _react2.default.createElement(
	            'label',
	            { className: 'label', htmlFor: id },
	            'Choose from existing holdings'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'select-wrapper' },
	            _react2.default.createElement(
	                'select',
	                {
	                    id: id,
	                    'data-name': 'order-ticket-select-holdings',
	                    defaultValue: cusip || '',
	                    disabled: isDisabled,
	                    'aria-disabled': isDisabled,
	                    onChange: function onChange(e) {
	                        var newCusip = e.target.value;
	                        if (!newCusip) return;
	
	                        var isRqt = mode === _useOrderTicket2.MODES.RFQ;
	                        var act = isRqt ? 'W' : 'S';
	                        var isBuySell = act === 'S';
	
	                        setCusip(newCusip);
	                        setTimeout(function () {
	                            (0, _twd.show)('order-ticket', {
	                                acctNo: acctNo,
	                                cusip: newCusip,
	                                action: act,
	                                actionSubset: isBuySell ? '' : actionSubset_,
	                                ts: Date.now()
	                            });
	                        });
	                    },
	                    className: 'form-control text-truncate',
	                    style: { paddingRight: '25px' }
	                },
	                rs.length > 0 && [{ cusip: '', issue: 'Select' }].concat(rs).map(function (a, i) {
	                    return _react2.default.createElement(
	                        'option',
	                        {
	                            'data-name': 'order-ticket-select-holdings-option',
	                            key: i,
	                            value: a.cusip || '',
	                            selected: a.cusip === cusip
	                        },
	                        (0, _twd.parseHtml)(a.issue || '')
	                    );
	                })
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Yield = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Yield = exports.Yield = function Yield() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        action = _useOrderTicket.action,
	        yld = _useOrderTicket.yld,
	        setYld = _useOrderTicket.setYld,
	        priceOrYield = _useOrderTicket.priceOrYield,
	        setPriceOrYield = _useOrderTicket.setPriceOrYield,
	        orderInfo = _useOrderTicket.orderInfo,
	        hasOrderInfo = _useOrderTicket.hasOrderInfo,
	        hasBondInfo = _useOrderTicket.hasBondInfo,
	        mode = _useOrderTicket.mode,
	        errors = _useOrderTicket.errors,
	        setYieldEl = _useOrderTicket.setYieldEl,
	        isRestricted = _useOrderTicket.isRestricted,
	        bestYield = _useOrderTicket.bestYield,
	        bondInfo = _useOrderTicket.bondInfo;
	
	    var s = orderInfo.statusMsg || '';
	    var hasMarket = s.indexOf('NO OFFERINGS FOR TICKET') < 0 && s.indexOf('NO ORDER CONFIGURED FOR TICKET') < 0;
	
	    var canTrade = hasBondInfo && !isRestricted;
	    var isLift = mode === _useOrderTicket2.MODES.ORDER_Z;
	    var isDisabled = !canTrade || !hasMarket;
	    var isCounterDisallowed = canTrade && (orderInfo.countersAllowed === 'N' || orderInfo.primary === 'Y');
	    var isReadOnly = isLift || isCounterDisallowed;
	
	    var id = (0, _twd.getId)();
	    var err = !isDisabled && errors && errors.yld;
	    var yldLabel = action === 'B' ? 'Offer' : action === 'S' ? 'Bid' : '';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: isReadOnly ? "" : "row" },
	            !isReadOnly && (0, _core.jsx)(
	                'div',
	                { className: 'col-md-1 col-xs-1 col-auto', style: { minWidth: '25px', maxWidth: '25px', marginTop: '20px' } },
	                (0, _core.jsx)('input', {
	                    type: 'radio',
	                    'aria-label': 'Choose yield',
	                    name: "order-ticket-form-price-or-yield",
	                    value: 0,
	                    checked: priceOrYield === 0,
	                    onChange: function onChange() {
	                        return setPriceOrYield(0);
	                    }
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-1 col-xs-5 col-auto',
	                    style: Object.assign({
	                        minWidth: '130px'
	                    }, isReadOnly ? { paddingLeft: 0 } : {})
	                },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'from-group', style: { paddingLeft: '0px', paddingRight: '0px' } },
	                    (0, _core.jsx)(
	                        'div',
	                        null,
	                        (0, _core.jsx)(_twd.Flyout, {
	                            label: 'Yield',
	                            labelAttrs: { htmlFor: id },
	                            isLabel: true,
	                            html: YieldTooltip
	                        })
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: err ? ' has-error' : '' },
	                        isReadOnly && (0, _core.jsx)(
	                            'div',
	                            { className: 'input-group' },
	                            (0, _core.jsx)(
	                                'label',
	                                { className: 'label text-bold' },
	                                formatYield(isCounterDisallowed ? bestYield : orderInfo.yield, bondInfo)
	                            )
	                        ),
	                        !isReadOnly && (0, _core.jsx)('input', {
	                            type: 'number',
	                            ref: setYieldEl,
	                            id: id,
	                            className: 'form-control',
	                            value: yld,
	                            min: '0',
	                            step: 'any',
	                            disabled: isDisabled,
	                            'aria-disabled': isDisabled,
	                            style: { paddingLeft: '20px' },
	                            onChange: function onChange(e) {
	                                setYld(e.target.value || '');
	                            }
	                        })
	                    ),
	                    err && (0, _core.jsx)(
	                        'label',
	                        { className: 'field-status has-error' },
	                        err
	                    )
	                )
	            ),
	            hasOrderInfo && canTrade && yldLabel && !isReadOnly && (0, _core.jsx)(
	                'div',
	                { className: 'col-md-5 col-xs-1 col-auto', style: { minWidth: '200px', marginTop: '20px' } },
	                (0, _core.jsx)(
	                    'div',
	                    { css: _style.displayInline },
	                    yldLabel,
	                    ' Yield: '
	                ),
	                (0, _core.jsx)(
	                    'span',
	                    { className: 'text-bold' },
	                    formatYield(bestYield, bondInfo)
	                )
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define, eqeqeq */
	
	
	var formatYield = function formatYield(ytw, bondInfo) {
	    var isNoCalc = bondInfo && bondInfo.issue && ['O', 'K'].includes(bondInfo.issue.type);
	    var a = !(0, _twd.isNumeric)(ytw) ? null : ytw == 0.0 && isNoCalc ? null : ytw;
	    return _twd.fmt.price3N(a);
	};
	
	var YieldTooltip = '\n    A bond\u2019s yield is the expected return an investor receives from a bond over its term to maturity/redemption,\n    expressed as an annual percentage of the bond\u2019s face value. The calculation of a bond\u2019s yield considers\n    its price, coupon payments, and time remaining until maturity/redemption.\n    A bond\u2019s yield to worst is a measure of the lowest possible expected return an investor can receive on\n    a bond \u2013 assuming no default event. If the yield value displayed on your ticket is not firm,\n    a custom limit yield can be entered in attempt to trade the bond at an improved price than the current best offer.\n    Limit price orders may be rejected by the dealer.\n';

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(1781);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _entry = __webpack_require__(1024);
	
	var _preview = __webpack_require__(1043);
	
	var _confirm = __webpack_require__(1022);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (args) {
	    (0, _twd.trackPage)('order-ticket');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _useOrderTicket2.ContextProvider,
	            args,
	            _react2.default.createElement(Content, null)
	        )
	    );
	};
	
	var Content = function Content() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        step = _useOrderTicket.step,
	        ticketStatus = _useOrderTicket.ticketStatus,
	        autoPreview = _useOrderTicket.autoPreview;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: autoPreview ? _twd.Status.LOADING : ticketStatus },
	            step === _useOrderTicket2.STEPS.ENTRY && _react2.default.createElement(_entry.Entry, null),
	            step === _useOrderTicket2.STEPS.PREVIEW && _react2.default.createElement(_preview.Preview, null),
	            step === _useOrderTicket2.STEPS.CONFIRM && _react2.default.createElement(_confirm.Confirm, null)
	        )
	    );
	};

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Preview = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _header = __webpack_require__(324);
	
	var _account = __webpack_require__(322);
	
	var _footer = __webpack_require__(323);
	
	var _useOrderTicket6 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	var Preview = exports.Preview = function Preview() {
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'container order-ticket' },
	            (0, _core.jsx)(_header.Header, null)
	        ),
	        (0, _core.jsx)(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            (0, _core.jsx)(
	                'div',
	                { className: 'container' },
	                (0, _core.jsx)(_account.Account, null)
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { css: _style.backgroundColor },
	            (0, _core.jsx)(
	                'div',
	                { className: 'xs-hide container' },
	                (0, _core.jsx)(Content, null)
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'xs-show container' },
	                (0, _core.jsx)(ContentMobile, null)
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            (0, _core.jsx)(
	                'div',
	                { className: 'container' },
	                (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' }),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12' },
	                        'Important: Your are placing an order. Click only once to avoid placing multiple orders.'
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(_footer.Footer, null)
	    );
	};
	
	var ContentMobile = function ContentMobile() {
	    var _useOrderTicket = (0, _useOrderTicket6.useOrderTicket)(),
	        bondInfo = _useOrderTicket.bondInfo,
	        orderInfo = _useOrderTicket.orderInfo,
	        isRfq = _useOrderTicket.isRfq,
	        mode = _useOrderTicket.mode,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var netMoneyLabel = ['W', 'S'].indexOf(orderInfo.action) >= 0 ? 'Estimated proceeds' : 'Estimated total cost';
	
	    var issue = bondInfo.issue || {};
	    var isLift = mode === _useOrderTicket6.MODES.ORDER_Z;
	    var priceUi = orderInfo.primary === 'Y' || isLift ? orderInfo.price : orderInfo.dealerPrice;
	    var isNoCalc = bondInfo.issue && ['O', 'K'].includes(bondInfo.issue.type);
	    var ytm = !(0, _twd.isNumeric)(orderInfo.YTM) ? null : orderInfo.YTM === 0.0 && isNoCalc ? null : orderInfo.YTM;
	    var ytw = !(0, _twd.isNumeric)(orderInfo.YTW) ? null : orderInfo.YTW === 0.0 && isNoCalc ? null : orderInfo.YTW;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'vertical-offset-base', style: { backgroundColor: '#ffffff' } },
	                    (0, _core.jsx)('div', { className: 'row vertical-offset-base' }),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                (0, _core.jsx)(_twd.Flyout, {
	                                    label: 'Issuer',
	                                    html: 'A legal entity (such as a corporation, government, or municipality) which borrows money by issuing bonds.\n                        The issuer is obligated to pay the principal and interest on the bond.'
	                                })
	                            ),
	                            (0, _core.jsx)(
	                                'h2',
	                                null,
	                                (0, _twd.parseHtml)(issue.issue)
	                            )
	                        )
	                    ),
	                    (0, _core.jsx)('hr', { 'aria-hidden': true, className: 'vertical-offset-base' }),
	                    (0, _core.jsx)(Labeled, { label: 'Action', value: getAction(orderInfo.action) }),
	                    (0, _core.jsx)(Labeled, { label: 'CUSIP', value: orderInfo.cusip }),
	                    (0, _core.jsx)(Labeled, { label: 'Quantity', value: _twd.fmt.qty(orderInfo.qty) }),
	                    (0, _core.jsx)(Labeled, { label: 'Execution Type', value: orderInfo.executionType }),
	                    (0, _core.jsx)(Labeled, { label: 'Settlement Date', value: orderInfo.settlement }),
	                    (0, _core.jsx)(Labeled, { label: 'Maturity Date', value: orderInfo.maturity }),
	                    (0, _core.jsx)(Labeled, { label: 'Yield to maturity', value: (0, _twd.isNumeric)(ytm) ? _twd.fmt.ytw3(ytm) : _twd.fmt.empty() }),
	                    (0, _core.jsx)(Labeled, { label: 'Yield to worst', value: (0, _twd.isNumeric)(ytw) ? _twd.fmt.ytw3(ytw) : _twd.fmt.empty() }),
	                    (0, _core.jsx)(Labeled, { label: 'Price', value: isTreasuryAuction ? 'Auction' : (0, _twd.isNumeric)(priceUi) ? '$' + _twd.fmt.price3(priceUi) : _twd.fmt.empty() }),
	                    (0, _core.jsx)('hr', { 'aria-hidden': true, className: 'vertical-offset-base' }),
	                    (0, _core.jsx)(Labeled, { label: 'Principal', value: isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.principal) }),
	                    (0, _core.jsx)(Labeled, { label: 'Accrued interest', value: isTreasuryAuction ? _twd.fmt.empty() : orderInfo.accruedInterest ? (0, _core.jsx)(
	                            _react2.default.Fragment,
	                            null,
	                            _twd.fmt.money(orderInfo.accruedInterest),
	                            ' (',
	                            _twd.fmt.count(orderInfo.accruedInterestDays),
	                            ' days)'
	                        ) : _twd.fmt.money(isRfq ? 0 : null) }),
	                    (0, _core.jsx)(Labeled, { label: 'Commission', value: isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt) }),
	                    (0, _core.jsx)(Labeled, { label: netMoneyLabel, value: isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.netMoney) }),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-sm' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            (0, _core.jsx)(Buttons, null)
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row vertical-offset-base' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-md-12 text-center' },
	                        (0, _core.jsx)(ConfirmTicketButton, null)
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Labeled = function Labeled(_ref) {
	    var label = _ref.label,
	        value = _ref.value,
	        _ref$style = _ref.style,
	        style = _ref$style === undefined ? {} : _ref$style;
	
	    return (0, _core.jsx)(
	        'div',
	        { className: 'row vertical-offset-base' },
	        (0, _core.jsx)(
	            'div',
	            { className: 'col-md-12' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'text-body' },
	                label
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'label text-body text-bold' },
	                (0, _core.jsx)(
	                    'span',
	                    { style: style },
	                    value
	                )
	            )
	        )
	    );
	};
	
	var Content = function Content() {
	    var _useOrderTicket2 = (0, _useOrderTicket6.useOrderTicket)(),
	        bondInfo = _useOrderTicket2.bondInfo;
	
	    var issue = bondInfo.issue || {};
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'container vertical-offset-base', style: { backgroundColor: '#ffffff' } },
	                    (0, _core.jsx)('div', { className: 'row vertical-offset-base' }),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                (0, _core.jsx)(
	                                    'label',
	                                    { className: 'label' },
	                                    'Issuer'
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'h2',
	                                null,
	                                (0, _twd.parseHtml)(issue.issue)
	                            )
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-md-12' },
	                            (0, _core.jsx)(Detail, null)
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Detail = function Detail() {
	    var _useOrderTicket3 = (0, _useOrderTicket6.useOrderTicket)(),
	        bondInfo = _useOrderTicket3.bondInfo,
	        orderInfo = _useOrderTicket3.orderInfo,
	        isRfq = _useOrderTicket3.isRfq,
	        mode = _useOrderTicket3.mode,
	        isTreasuryAuction = _useOrderTicket3.isTreasuryAuction;
	
	    var netMoneyLabel = ['W', 'S'].indexOf(orderInfo.action) >= 0 ? 'Estimated proceeds' : 'Estimated total cost';
	
	    var isLift = mode === _useOrderTicket6.MODES.ORDER_Z;
	    var priceUi = orderInfo.primary === 'Y' || isLift ? orderInfo.price : orderInfo.dealerPrice;
	
	    var isNoCalc = bondInfo.issue && ['O', 'K'].includes(bondInfo.issue.type);
	    var ytm = !(0, _twd.isNumeric)(orderInfo.YTM) ? null : orderInfo.YTM === 0.0 && isNoCalc ? null : orderInfo.YTM;
	    var ytw = !(0, _twd.isNumeric)(orderInfo.YTW) ? null : orderInfo.YTW === 0.0 && isNoCalc ? null : orderInfo.YTW;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'table-responsive' },
	            (0, _core.jsx)(
	                'table',
	                {
	                    className: 'table align-top'
	                },
	                (0, _core.jsx)(
	                    'thead',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'Action'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'CUSIP'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'Quantity'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body' },
	                            'Execution type'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Settlement Date'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Maturity Date'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Yield to maturity'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Yield to worst'
	                        ),
	                        (0, _core.jsx)(
	                            'th',
	                            { className: 'text-body text-right' },
	                            'Price'
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'tbody',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            getAction(orderInfo.action)
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-bold' },
	                            orderInfo.cusip
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            _twd.fmt.qty(orderInfo.qty)
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            orderInfo.executionType
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right' },
	                            orderInfo.settlement
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right' },
	                            orderInfo.maturity
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right' },
	                            (0, _twd.isNumeric)(ytm) ? _twd.fmt.ytw3(ytm) : _twd.fmt.empty()
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right' },
	                            (0, _twd.isNumeric)(ytw) ? _twd.fmt.ytw3(ytw) : _twd.fmt.empty()
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right text-bold' },
	                            isTreasuryAuction ? 'Auction' : (0, _twd.isNumeric)(priceUi) ? '$' + _twd.fmt.price3(priceUi) : _twd.fmt.empty()
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'table',
	                {
	                    className: 'table align-top',
	                    style: { borderBottom: 0 }
	                },
	                (0, _core.jsx)(
	                    'tbody',
	                    null,
	                    (0, _core.jsx)(
	                        'tr',
	                        null,
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                'Principal'
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.principal)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                'Accrued interest'
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : orderInfo.accruedInterest ? (0, _core.jsx)(
	                                    _react2.default.Fragment,
	                                    null,
	                                    _twd.fmt.money(orderInfo.accruedInterest),
	                                    ' (',
	                                    _twd.fmt.count(orderInfo.accruedInterestDays),
	                                    ' days)'
	                                ) : _twd.fmt.money(isRfq ? 0 : null)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                'Commission'
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.sugg_comm_in_dlrs_per_tckt)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body' },
	                            (0, _core.jsx)(
	                                'div',
	                                null,
	                                netMoneyLabel
	                            ),
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'text-bold' },
	                                isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.money(isRfq ? 0 : orderInfo.netMoney)
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'td',
	                            { className: 'text-body text-right', colSpan: 5, style: { verticalAlign: 'middle' } },
	                            (0, _core.jsx)(Buttons, null),
	                            (0, _core.jsx)('span', { 'aria-hidden': true, style: { padding: '0 10px 0 10px' } }),
	                            (0, _core.jsx)(ConfirmTicketButton, { cls: "btn btn-primary" })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Buttons = function Buttons() {
	    var _useOrderTicket4 = (0, _useOrderTicket6.useOrderTicket)(),
	        setStep = _useOrderTicket4.setStep,
	        from = _useOrderTicket4.from,
	        isRfq = _useOrderTicket4.isRfq,
	        mode = _useOrderTicket4.mode,
	        reloadTicket = _useOrderTicket4.reloadTicket;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        [(0, _core.jsx)(
	            _react2.default.Fragment,
	            { key: 1 },
	            (0, _core.jsx)(
	                'button',
	                {
	                    className: 'btn btn-link text-bold',
	                    onClick: function onClick(e) {
	                        setStep(_useOrderTicket6.STEPS.ENTRY);
	
	                        if (isRfq || mode === _useOrderTicket6.MODES.ORDER_Z) {
	                            return;
	                        }
	
	                        reloadTicket();
	                    }
	                },
	                isRfq ? 'Change quote request' : 'Change order'
	            )
	        ), (0, _core.jsx)(
	            _react2.default.Fragment,
	            { key: 3 },
	            (0, _core.jsx)(
	                'button',
	                {
	                    'data-name': 'orders-link',
	                    className: 'btn btn-link text-bold',
	                    onClick: function onClick(e) {
	                        if (!from) {
	                            (0, _twd.show)('overview');
	                            return;
	                        }
	
	                        var u = (0, _twd.safeURL)(from);
	                        if (u) {
	                            (0, _twd.openWindow)(u.toString());
	                            return;
	                        }
	
	                        (0, _twd.viewBack)();
	                    }
	                },
	                'Cancel'
	            )
	        )].filter(Boolean).flatMap(function (a, i) {
	            return [a, (0, _core.jsx)(Sep, { key: i })];
	        }).slice(0, -1)
	    );
	};
	
	var ConfirmTicketButton = function ConfirmTicketButton() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$cls = _ref2.cls,
	        cls = _ref2$cls === undefined ? "btn btn-block btn-primary" : _ref2$cls;
	
	    var _useOrderTicket5 = (0, _useOrderTicket6.useOrderTicket)(),
	        confirmTicket = _useOrderTicket5.confirmTicket,
	        isRfq = _useOrderTicket5.isRfq;
	
	    return (0, _core.jsx)(
	        'button',
	        {
	            className: cls,
	            onClick: function onClick() {
	                confirmTicket();
	            }
	        },
	        isRfq ? 'Place quote request' : 'Place order'
	    );
	};
	
	var Sep = function Sep() {
	    return (0, _core.jsx)(
	        'span',
	        { 'aria-hidden': true, style: { padding: '0 10px 0 10px' } },
	        '|'
	    );
	};
	
	var getAction = function getAction(a) {
	    return a === 'F' ? (0, _core.jsx)(
	        'span',
	        null,
	        (0, _core.jsx)(
	            'span',
	            { className: 'text-bold', style: { color: '#107A1B' } },
	            'Buy Quote'
	        ),
	        (0, _core.jsx)('br', null),
	        (0, _core.jsx)(
	            'span',
	            { style: { fontWeight: '400' } },
	            '(Offer wanted)'
	        )
	    ) : a === 'W' ? (0, _core.jsx)(
	        'span',
	        null,
	        (0, _core.jsx)(
	            'span',
	            { className: 'text-bold', style: { color: '#CC0000' } },
	            'Sell Quote'
	        ),
	        (0, _core.jsx)('br', null),
	        (0, _core.jsx)(
	            'span',
	            { style: { fontWeight: '400' } },
	            '(Bid wanted)'
	        )
	    ) : a === 'B' ? (0, _core.jsx)(
	        'span',
	        { className: 'text-bold', style: { color: '#107A1B' } },
	        'Buy'
	    ) : a === 'S' ? (0, _core.jsx)(
	        'span',
	        { className: 'text-bold', style: { color: '#CC0000' } },
	        'Sell'
	    ) : null;
	};

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.sectionListCss = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    & {\n        display:grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n        color: #767676;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n        color: #242424;\n    }\n'], ['\n    & {\n        display:grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        border-bottom: 1px solid #e4e4e4;\n    }\n    dt {\n        text-align: left;\n        color: #767676;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n        color: #242424;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useModals = __webpack_require__(325);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref.cusip,
	        issue = _ref.issue,
	        initialPrice = _ref.initialPrice,
	        currentPrice = _ref.currentPrice,
	        pricePrecision = _ref.pricePrecision,
	        callback = _ref.callback;
	
	    var precision = pricePrecision || getPrecision(initialPrice);
	    var closeFn = function closeFn() {
	        if (!callback) {
	            (0, _useModals.hideModals)();
	            return;
	        }
	        (0, _useModals.resetModals)();
	        callback();
	    };
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            {
	                'data-name': 'order-ticket-price-change-notice-modal',
	                className: 'modal-dialog modal-sm' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'modal-content' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'modal-header' },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            className: 'close',
	                            'aria-label': 'close',
	                            'data-name': 'order-ticket-price-change-notice-modal-close-button',
	                            type: 'button',
	                            onClick: closeFn },
	                        (0, _core.jsx)(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'h2',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Price change notice'
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12 col-md-12 text-body' },
	                            (0, _core.jsx)(
	                                'p',
	                                null,
	                                'The price for the security you are trading has changed since you began the order process.'
	                            ),
	                            (0, _core.jsx)(
	                                'dl',
	                                { css: sectionListCss },
	                                (0, _core.jsx)(
	                                    'dt',
	                                    null,
	                                    'Issuer'
	                                ),
	                                (0, _core.jsx)(
	                                    'dd',
	                                    null,
	                                    issue || _twd.fmt.empty()
	                                ),
	                                (0, _core.jsx)(
	                                    'dt',
	                                    null,
	                                    'CUSIP'
	                                ),
	                                (0, _core.jsx)(
	                                    'dd',
	                                    null,
	                                    cusip || _twd.fmt.empty()
	                                ),
	                                (0, _core.jsx)(
	                                    'dt',
	                                    null,
	                                    'Initial price'
	                                ),
	                                (0, _core.jsx)(
	                                    'dd',
	                                    null,
	                                    formatPrice$(initialPrice, precision)
	                                ),
	                                (0, _core.jsx)(
	                                    'dt',
	                                    null,
	                                    'Current price'
	                                ),
	                                (0, _core.jsx)(
	                                    'dd',
	                                    null,
	                                    formatPrice$(currentPrice, precision)
	                                ),
	                                (0, _core.jsx)(
	                                    'dt',
	                                    null,
	                                    'Change'
	                                ),
	                                (0, _core.jsx)(
	                                    'dd',
	                                    null,
	                                    formatPrice$(currentPrice - initialPrice, precision)
	                                )
	                            )
	                        )
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'modal-footer' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'container', style: { background: "#ffffff" } },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'row' },
	                            (0, _core.jsx)(
	                                'div',
	                                { className: 'col-md-12 text-center' },
	                                (0, _core.jsx)(
	                                    'button',
	                                    {
	                                        className: 'btn btn-primary-outline',
	                                        'aria-label': 'close',
	                                        'data-name': 'order-ticket-price-change-notice-modal-close-button',
	                                        type: 'button',
	                                        onClick: closeFn },
	                                    'Close'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var getPrecision = function getPrecision(a) {
	    return Math.max(((a + '').split('.')[1] || []).length || 3, 3);
	};
	
	var formatPrice$ = function formatPrice$(a, n) {
	    n = n || getPrecision(a);
	    var x = Number.parseFloat(a);
	    if (isNaN(x)) return _twd.fmt.empty();
	
	    var p = x < 0 ? '-$' : '$';
	    return p + Math.abs(x).toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: n });
	};
	
	var sectionListCss = exports.sectionListCss = (0, _core.css)(_templateObject);

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (_ref) {
	    var rows = _ref.rows,
	        title = _ref.title,
	        searchParams = _ref.searchParams,
	        sort = _ref.sort,
	        from = _ref.from,
	        acctNo = _ref.acctNo;
	
	
	    var p = { sort: sort, searchParams: searchParams, title: title, from: from };
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive vertical-offset-sm',
	            style: { display: "block", maxHeight: "450px" }
	        },
	        _react2.default.createElement(
	            'table',
	            {
	                'data-name': 'offerings-modal-table',
	                className: 'table align-top' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(
	                            SortLink,
	                            Object.assign({}, p, { field: 'holdCusip' }),
	                            'CUSIP'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(
	                            SortLink,
	                            Object.assign({}, p, { field: 'holdMaturitySortDt' }),
	                            'Maturity date'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        _react2.default.createElement(
	                            SortLink,
	                            Object.assign({}, p, { field: 'askPrice' }),
	                            'Price'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        _react2.default.createElement(
	                            SortLink,
	                            Object.assign({}, p, { field: 'holdCoupon' }),
	                            'Coupon'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        _react2.default.createElement(
	                            SortLink,
	                            Object.assign({}, p, { field: 'askYield' }),
	                            'Yield'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        _react2.default.createElement(
	                            SortLink,
	                            Object.assign({}, p, { field: 'moodyRating' }),
	                            'Moody\'s'
	                        ),
	                        ' / ',
	                        _react2.default.createElement(
	                            SortLink,
	                            Object.assign({}, p, { field: 'spRating' }),
	                            'S&P'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Callable'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Action'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rows && rows.map(function (r, i) {
	                    var isMBS = ['O', 'R', 'K'].indexOf(r.holdInvType) >= 0;
	                    var isCallable = !isMBS && !(0, _twd.isEmpty)(r.holdFirstCall);
	                    return _react2.default.createElement(
	                        'tr',
	                        {
	                            'data-name': 'offerings-modal-row',
	                            key: i },
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-bold' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#',
	                                    type: 'button',
	                                    'data-name': 'offerings-modal-cusip-link',
	                                    style: { cursor: 'pointer' },
	                                    onClick: function onClick() {
	                                        (0, _twd.hideModal)();
	                                        (0, _twd.show)('bond-detail', { cusip: r.holdCusip, from: from });
	                                    }
	                                },
	                                r.holdCusip
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            r.holdMaturity
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(_twd.fmt.price(r.askPrice)),
	                            _react2.default.createElement('br', null),
	                            bidItem(_twd.fmt.price(r.bidPrice))
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.cpn(r.holdCoupon)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            askItem(formatYield(r.askYield, r.askYtwInd)),
	                            _react2.default.createElement('br', null),
	                            bidItem(formatYield(r.bidYield, r.bidYtwInd))
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            r.moodyRating || _twd.fmt.empty(),
	                            ' / ',
	                            r.spRating || _twd.fmt.empty()
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            isCallable ? 'Yes' : 'No'
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-center', style: { maxWidth: '45px', verticalAlign: 'middle' } },
	                            formatOrder(r, acctNo)
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var SortLink = function SortLink(_ref2) {
	    var title = _ref2.title,
	        searchParams = _ref2.searchParams,
	        field = _ref2.field,
	        sort = _ref2.sort,
	        from = _ref2.from,
	        children = _ref2.children;
	
	    var _ref3 = sort || { field: 'askYield', direction: 'DESC' },
	        sortField = _ref3.field,
	        sortDirection = _ref3.direction;
	
	    var isSorted = field === sortField;
	    var isAsc = sortDirection === 'ASC';
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'button',
	            {
	                'data-name': 'search-modal-header-sort',
	                'data-field': field,
	                'data-direction': isSorted && isAsc ? 'DESC' : 'ASC',
	
	                className: 'btn-link text-body',
	                style: { cursor: 'pointer', color: '#767676', whiteSpace: 'nowrap' },
	                onClick: function onClick() {
	                    var direction = isSorted && isAsc ? 'DESC' : 'ASC';
	                    onSortChange(title, searchParams, from, { field: field, direction: direction });
	                }
	            },
	            children,
	            isSorted && (sortDirection === 'ASC' ? _react2.default.createElement(
	                'i',
	                { className: 'material-icons' },
	                'arrow_drop_up'
	            ) : _react2.default.createElement(
	                'i',
	                { className: 'material-icons' },
	                'arrow_drop_down'
	            ))
	        )
	    );
	};
	
	var onSortChange = function onSortChange(title, searchParams, from, _ref4) {
	    var field = _ref4.field,
	        direction = _ref4.direction;
	
	    var ps = Object.assign({}, searchParams || {});
	    ps.sort = [{ field: field, direction: direction }];
	    (0, _twd.showModal)({
	        view: 'order-ticket-search-modal',
	        searchParams: (0, _twd.cleanObject)(ps),
	        title: title,
	        sort: { field: field, direction: direction },
	        from: from,
	        _ts: Date.now()
	    });
	};
	
	var askItem = function askItem(txt) {
	    return _react2.default.createElement(
	        'span',
	        { style: { color: 'green' } },
	        txt
	    );
	};
	var bidItem = function bidItem(txt) {
	    return _react2.default.createElement(
	        'span',
	        { style: { color: 'red' } },
	        txt
	    );
	};
	
	var formatYield = function formatYield(val, ind) {
	    var x = Number.parseFloat(val);
	    if (isNaN(x)) return _twd.fmt.empty();
	
	    var y = _twd.fmt.ytw(x);
	    if (!ind) return y;
	    ind = ind.toLowerCase();
	    if (['c', 'dis', 'f', 'n', 'p', 'r', 't', 'w'].indexOf(ind) < 0) return y;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        y,
	        ' (',
	        ind,
	        ')'
	    );
	};
	
	var formatOrder = function formatOrder(r, acctNo) {
	    if (r.allowTrading === false) return _twd.fmt.orderPhone();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            r.askQuantity && _twd.fmt.buy({ acctNo: acctNo, cusip: r.holdCusip, extraClassName: 'vertical-offset-xxs' }),
	            !r.askQuantity && _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            r.bidQuantity && _twd.fmt.sell({ acctNo: acctNo, cusip: r.holdCusip, qty: r.bidQuantity })
	        )
	    );
	};

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _grid = __webpack_require__(1045);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _useSearchModal2 = __webpack_require__(1047);
	
	var _useSearchModal3 = _interopRequireDefault(_useSearchModal2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        title = _ref.title,
	        ts = _ref.ts,
	        searchParams = _ref.searchParams,
	        sort = _ref.sort,
	        from = _ref.from,
	        _ref$acctNo = _ref.acctNo,
	        acctNo = _ref$acctNo === undefined ? '' : _ref$acctNo;
	
	    var _useSearchModal = (0, _useSearchModal3.default)({ ts: ts, searchParams: searchParams, sort: sort }),
	        status = _useSearchModal.status,
	        rows = _useSearchModal.rows,
	        count = _useSearchModal.count;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'offerings-modal-close-link',
	                className: 'modal-dialog modal-lg' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container', style: { background: "#ffffff" } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'close',
	                                    'aria-label': 'close',
	                                    'data-name': 'offerings-modal-close-link',
	                                    type: 'button',
	                                    onClick: function onClick() {
	                                        (0, _twd.hideModal)();
	                                    } },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'close'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    title
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            _twd.Loading,
	                            { status: status },
	                            count === 0 && _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-12 text-center' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'vertical-offset-xs' },
	                                        _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' })
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'vertical-offset-xs' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'small-header vertical-offset-xxs' },
	                                            'No security found.'
	                                        )
	                                    )
	                                )
	                            ),
	                            count > 0 && _react2.default.createElement(_grid2.default, { rows: rows, sort: sort, searchParams: searchParams, title: title, from: from, acctNo: acctNo })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: '#', onClick: function onClick() {
	                                        (0, _twd.hideModal)();
	                                        (0, _twd.show)('advanced-screener', {
	                                            searchParams: searchParams,
	                                            _ts: Date.now(),
	                                            from: from
	                                        });
	                                    }
	                                },
	                                'Open search in advanced screener'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function (_ref) {
	    var sort_ = _ref.sort,
	        _ts = _ref.ts,
	        searchParams = _ref.searchParams;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        rows = _React$useState4[0],
	        setRows = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(0),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        count = _React$useState6[0],
	        setCount = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(_ts || 0),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        ts = _React$useState8[0],
	        setTs = _React$useState8[1];
	
	    _react2.default.useEffect(function () {
	        setStatus(_twd.Status.LOADING);
	        if (ts === 0) return;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var p, _ref3, data, a;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            p = Object.assign({
	                                searchType: 'offers',
	                                pageNumber: 1,
	                                resultsPerPage: 400,
	                                offeringType: ['ask-side'],
	                                marketCheckRequired: true,
	                                sort: [sort_ || { field: 'askYield', direction: 'DESC' }]
	                            }, searchParams);
	                            _context.next = 4;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/offersearch',
	                                method: 'POST',
	                                params: p
	                            });
	
	                        case 4:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            a = _context.sent;
	
	                            a.rows = a.rows.map(function (r) {
	                                var marketCheck = r.marketCheck;
	
	                                if (marketCheck === 'z' || marketCheck === 'Z') {
	                                    return null;
	                                }
	                                return r;
	                            }).filter(Boolean);
	
	                            setRows(a.rows);
	                            setCount(a.resultSetCount);
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 18;
	                            break;
	
	                        case 15:
	                            _context.prev = 15;
	                            _context.t0 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 18:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 15]]);
	        }))();
	    }, [ts, searchParams, sort_]);
	
	    return { status: status, rows: rows, count: count, setRows: setRows, setTs: setTs };
	};

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.AdditionalDetails = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AdditionalDetails = exports.AdditionalDetails = function AdditionalDetails() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        bondInfo = _useOrderTicket.bondInfo,
	        orderInfo = _useOrderTicket.orderInfo,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    var issue = bondInfo.issue || {};
	    var ask = (bondInfo.bestoffer || {}).ask || {};
	    var docs = Documents.map(function (f) {
	        return f({ issue: issue, ask: ask, events: bondInfo.events, orderInfo: orderInfo, isTreasuryAuction: isTreasuryAuction });
	    }).filter(Boolean);
	    if (docs.length === 0) return null;
	
	    var holdInvType = bondInfo.issue && bondInfo.issue.type;
	    var hasTradeHistory = ['A', 'C', 'M'].indexOf(holdInvType) >= 0;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        !hasTradeHistory && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement('hr', { 'aria-hidden': true })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(_twd.Flyout, {
	                    label: 'Additional details',
	                    labelAttrs: { className: "h3" },
	                    html: '\n                As available, this section will populate with the following information pertaining to your bond:\n                individual bond report provided by Moody\u2019s Investor Service, disclosure documentation,\n                material event information, depth of market, and prospectus/offering document.\n                This information may be unavailable for certain securities.\n                '
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                docs.flatMap(function (a, i) {
	                    return [a, _react2.default.createElement(Sep, { key: i })];
	                }).slice(0, -1)
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var Sep = function Sep() {
	    return _react2.default.createElement(
	        'span',
	        { 'aria-hidden': true, style: { padding: '0 10px 0 10px' } },
	        '|'
	    );
	};
	
	var Documents = [
	// factsheet
	function (_ref) {
	    var issue = _ref.issue,
	        ask = _ref.ask;
	
	    var f = (0, _twd.hasSvc)('FACT') && ['M', 'C'].indexOf(issue.type) >= 0 && issue.currencyCode === 'USD' && issue.floaterInd === 'N' && issue.linkedIndexInd === 'N';
	    if (!f) return;
	
	    var sp = new URLSearchParams([['p_id', ask.id || ''], ['p_type', issue.type || ''], ['p_cusip', issue.cusip || '']]);
	
	    var url = 'https://www.bonddesk.com/' + (0, _twd.getBrand)() + '/servlet/rtresult/factsheet.pdf?' + sp.toString();
	
	    return _react2.default.createElement(
	        'button',
	        {
	            key: 'document-1',
	            'data-name': 'order-ticket-factsheet-button',
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)(url, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('picture_as_pdf'), 'Factsheet'),
	        ' '
	    );
	},
	
	// moody rating
	function (_ref2) {
	    var issue = _ref2.issue,
	        orderInfo = _ref2.orderInfo;
	
	    var f1 = (0, _twd.hasSvc)('MDBR') && ['M', 'C', 'A', 'P'].indexOf(issue.type) >= 0 && issue.moodyRating && ['-', 'Nr', 'Nr-A', 'NR', 'WR', 'Wr'].indexOf(issue.moodyRating) < 0;
	    var f2 = orderInfo.p_show_mdy_br === 'true';
	    if (!f1 || !f2) return;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            key: 'document-2',
	            'data-name': 'order-ticket-moody-rating-button',
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)('/esb/moodysreport/getBondReport?cusip=' + issue.cusip, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('picture_as_pdf'), "Moody's Bond Report"),
	        ' '
	    );
	},
	
	// prospectus
	function (_ref3) {
	    var issue = _ref3.issue;
	    var researchLinks = issue.researchLinks;
	
	    var f = researchLinks && researchLinks.indexOf('"research"') > 0 && (researchLinks.indexOf('LEGAL') > 0 || researchLinks.indexOf('SALES') > 0);
	    if (!f) return;
	
	    var t = '"BDResearch.showViewer(\'';
	    var m = researchLinks.indexOf(t);
	    if (m < 0) return;
	
	    var n = m + t.length;
	    var url = researchLinks.slice(n, researchLinks.indexOf("');", m));
	    if (!url) return;
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    url = 'https:/www.bonddesk.com/' + (0, _twd.getBrand)() + '/' + owaTcDaoContext + '/' + url;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            key: 'document-3',
	            'data-name': 'order-ticket-prospectus-button',
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)(url, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('open_in_new'), 'Prospectus/Offering Document')
	    );
	},
	
	// emma
	function (_ref4) {
	    var issue = _ref4.issue;
	
	    var f = (0, _twd.hasSvc)('EMMA') && ['M'].indexOf(issue.type) >= 0 && issue.currencyCode === 'USD';
	    if (!f) return;
	
	    var url = (0, _twd.fixURL)('https://us.etrade.com/e/t/jumppage/viewjumppage?PageName=speedbump&comp=https%3A%2F%2Femma.msrb.org' + '%2FSecurityView%2FSecurityDetails.aspx%3Fcusip=' + issue.cusip);
	
	    return _react2.default.createElement(
	        'button',
	        {
	            key: 'document-4',
	            'data-name': 'order-ticket-emma-button',
	            type: 'button',
	            className: 'link-button',
	            onClick: function onClick() {
	                return (0, _twd.openWindow)(url, '_blank');
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('open_in_new'), 'Disclosure info/EMMA')
	    );
	},
	
	// material-events
	function (_ref5) {
	    var issue = _ref5.issue,
	        events = _ref5.events;
	
	    var invType = issue.spInd === 'Y' ? 'L' : issue.type;
	    var hasEvents = ['C', 'M', 'A', 'L'].indexOf(invType) >= 0 && !(issue.type === 'S' && issue.spInd === 'Y' && issue.category === 'N');
	    if (!hasEvents) return;
	
	    var tab = invType === 'A' ? 'redemptions' : invType === 'M' ? 'material-event-filings' : 'default-events';
	
	    var lbl = invType === 'M' ? 'View all Material Events' : 'View all events';
	
	    return _react2.default.createElement(
	        'button',
	        {
	            key: 'document-5',
	            'data-name': 'order-ticket-material-events-button',
	            className: 'link-button',
	            onClick: function onClick(e) {
	                (0, _twd.showModal)({
	                    view: 'events',
	                    tab: tab,
	                    issue: issue,
	                    events: events,
	                    from: 'bond-detail',
	                    source: e.target
	                });
	            } },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('timeline'), lbl)
	    );
	},
	
	// depth of market
	function (_ref6) {
	    var issue = _ref6.issue,
	        isTreasuryAuction = _ref6.isTreasuryAuction;
	
	    if (!issue.showBook || isTreasuryAuction) return;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            key: 'document-6',
	            'data-name': 'order-ticket-depth-of-market-button',
	            className: 'link-button',
	            style: { minHeight: '20px' },
	            onClick: function onClick(e) {
	                (0, _twd.showModal)({
	                    view: 'depth-of-market',
	                    cusip: issue.cusip,
	                    allowTrading: issue.allowTrading,
	                    from: 'bond-detail',
	                    source: e.target
	                });
	            }
	        },
	        (0, _twd.iconLabel)((0, _twd.matIcon)('layers'), 'Depth of Market')
	    );
	}];

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BondInfo = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        white-space: nowrap;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n'], ['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        white-space: nowrap;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    ', ' {\n        paddingRight: 0px;\n        paddingLeft: 0px;\n    }\n'], ['\n    ', ' {\n        paddingRight: 0px;\n        paddingLeft: 0px;\n    }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var listCss = (0, _core.css)(_templateObject);
	
	var sectionCss = (0, _core.css)(_templateObject2, _twd.mediaQueries.notXs);
	
	var issueTooltip = '\n    Utilize this table to review the following details pertaining to your bond:\n    <ul>\n    <li>Coupon: The bond\'s interest rate, expressed as a percentage of face value.</li>\n    <li>Maturity: The date the investor receives their principal due by the issuer, and the issuer\'s obligation ends.</li>\n    <li>Yield to worst: The lowest potential yield for a bond, assuming the issuer doesn\'t default.</li>\n    <li>Yield to maturity: The total return received by holding a bond until its maturity date.</li>\n    <li>Credit Ratings: Designations provided by credit rating agencies (Moody\'s and S&P) that indicate issuer credit quality and likelihood of default.</li>\n    <li>Settlement date: The date when ownership of a bond is legally transferred from seller to buyer. Most bonds settle one business day after the trade date.</li>\n    <li>Callable: An indication if the bond can be redeemed (called) by the issuer prior to its maturity.</li>\n    </ul>\n    For additional bond details, please click the \u201CBond detail\u201D link above the table.\n';
	
	var BondInfo = exports.BondInfo = function BondInfo() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        bondInfo = _useOrderTicket.bondInfo,
	        action = _useOrderTicket.action,
	        cusip = _useOrderTicket.cusip,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction,
	        settlement_ = _useOrderTicket.settlement_;
	
	    var issue = bondInfo.issue || {};
	    var n = action === 'B' ? 'ask' : 'bid';
	    var offer = (bondInfo.bestoffer || {})[n] || {};
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xxs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-8 col-xs-12', css: sectionCss },
	                (0, _core.jsx)(_twd.Flyout, {
	                    label: (0, _twd.parseHtml)(issue.issue),
	                    labelStyle: {
	                        display: 'inline-block',
	                        maxWidth: '300px',
	                        overflow: 'hidden',
	                        textOverflow: 'ellipsis',
	                        whiteSpace: 'nowrap'
	                    },
	                    iconStyle: {
	                        marginTop: '-10px'
	                    },
	                    className: 'btn-label btn-flyout text-truncate h3',
	                    html: issueTooltip
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-4 col-xs-12 text-right' },
	                !isTreasuryAuction && (0, _core.jsx)(
	                    'a',
	                    { href: '#', onClick: function onClick() {
	                            (0, _twd.show)('bond-detail', { cusip: cusip, from: 'order-ticket' });
	                        } },
	                    'Bond detail'
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12' },
	                (0, _core.jsx)('hr', { 'aria-hidden': true })
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)(
	                'dl',
	                { css: listCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6', css: sectionCss },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.cpn(issue.coupon, undefined, '%')
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Maturity'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        issue.maturity || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Yield to worst'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.ytw3(offer.ytw)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Yield to maturity'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        isTreasuryAuction ? _twd.fmt.empty() : _twd.fmt.ytw3(offer.ytm)
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6', css: sectionCss },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Moody\'s Rating'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (issue.moodyRating !== '-' ? (0, _twd.parseHtml)(issue.moodyRating) : '') || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'S&P Rating'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (issue.spRating !== '-' ? (0, _twd.parseHtml)(issue.spRating) : '') || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Settlement date'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (isTreasuryAuction ? _twd.fmt.mdy(settlement_) : offer.settlement) || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Callable'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        issue.callableInd === 'Y' ? 'Yes' : 'No'
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Context = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bondInfo = __webpack_require__(1049);
	
	var _additionalDetails = __webpack_require__(1048);
	
	var _recentTrades = __webpack_require__(1051);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	var _index = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Context = exports.Context = function Context() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        bondInfoStatus = _useOrderTicket.bondInfoStatus,
	        isTreasuryAuction = _useOrderTicket.isTreasuryAuction;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: bondInfoStatus },
	            _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	            _react2.default.createElement(_bondInfo.BondInfo, null),
	            _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	            isTreasuryAuction ? _react2.default.createElement(_index.ChartTable, null) : _react2.default.createElement(_recentTrades.RecentTrades, null),
	            _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_additionalDetails.AdditionalDetails, null)
	            ),
	            _react2.default.createElement('div', { className: 'row vertical-offset-sm' })
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.RecentTrades = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recentTradesTooltip = '\n    This table serves as a quick reference point to observe price and yield information related to\n    recently reported FINRA TRACE or MSRB trades. For expanded historical trace data, please click the \u201CExpand trade history\u201D link\n    located above the table. Trade details may be unavailable for inactively traded CUSIPs, or non-reportable securities.\n'; /* eslint-disable no-use-before-define */
	var RecentTrades = exports.RecentTrades = function RecentTrades() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        cusip = _useOrderTicket.cusip,
	        bondInfo = _useOrderTicket.bondInfo;
	
	    var recentTrades = bondInfo.recentTrades;
	
	    var holdInvType = bondInfo.issue && bondInfo.issue.type;
	    var hasTradeHistory = ['A', 'C', 'M'].indexOf(holdInvType) >= 0;
	
	    if (!hasTradeHistory) return null;
	
	    var hasRecentTrades = !(0, _twd.isEmpty)(recentTrades);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6' },
	                _react2.default.createElement(_twd.Flyout, {
	                    label: 'Recent trade activity',
	                    className: 'btn-label btn-flyout h3',
	                    html: recentTradesTooltip
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-6 text-right' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: 'btn-link',
	                        onClick: function onClick(e) {
	                            var p = {
	                                view: 'trade-history',
	                                cusip: cusip,
	                                source: e.target
	                            };
	                            (0, _twd.showModal)(p);
	                        }
	                    },
	                    'Expand trade history'
	                )
	            )
	        ),
	        !hasRecentTrades && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row text-center vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-xs' },
	                    _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'small-header vertical-offset-xxs' },
	                        'No trade activity in the last 30 days'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement('hr', { 'aria-hidden': true })
	                )
	            )
	        ),
	        hasRecentTrades && _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                { className: 'table table-striped',
	                    style: { display: "block", maxHeight: "250px", overflowY: "auto" }
	                },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'col-md-3' },
	                            'Trade Date'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'col-md-2 text-right' },
	                            'Quantity'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'col-md-1 text-right' },
	                            'Price'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'col-md-1 text-right' },
	                            'Yield'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'col-md-3' },
	                            'Type'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    (0, _twd.arrayFrom)(recentTrades).map(function (_ref, i) {
	                        var trade_date_time = _ref.trade_date_time,
	                            timeofTrade = _ref.timeofTrade,
	                            quantity = _ref.quantity,
	                            price = _ref.price,
	                            yield_ = _ref.yield,
	                            tradeType = _ref.tradeType,
	                            estimate_flag = _ref.estimate_flag;
	
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: i },
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-nowrap' },
	                                _twd.fmt.ts(trade_date_time + ' ' + timeofTrade)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                estimate_flag ? '* 1,000' : _twd.fmt.qty(quantity)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.price3(price)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-right' },
	                                _twd.fmt.price3(yield_)
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'text-nowrap' },
	                                TradeTypeMap[tradeType] || tradeType
	                            )
	                        );
	                    })
	                )
	            )
	        )
	    );
	};
	
	var TradeTypeMap = {
	    'Customer Bought': 'Customer Buy',
	    'Customer Sold': 'Customer Sell',
	    'Inter-dealer Trade': 'Dealer to Dealer'
	};

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        view = _useOrderTicket.snapshotView,
	        setView = _useOrderTicket.setSnapshotView,
	        positionsCount = _useOrderTicket.positionsCount,
	        openOrdersCount = _useOrderTicket.openOrdersCount;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { 'data-name': 'order-ticket-snapshot-nav-tabs', className: 'nav-tabs nav-tabs-border' },
	            _react2.default.createElement(
	                'ul',
	                { role: 'tablist' },
	                _react2.default.createElement(
	                    'li',
	                    { role: 'presentation',
	                        className: !view || view === 'snapshot' ? 'active' : '' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'order-ticket-snapshot-nav-tab',
	                            'data-toggle': 'tab',
	                            role: 'tab',
	                            'aria-selected': !view || view === 'snapshot',
	                            onClick: function onClick() {
	                                return setView('snapshot');
	                            }
	                        },
	                        'Snapshot'
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { role: 'presentation',
	                        className: view === 'positions' ? 'active' : '' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'order-ticket-snapshot-positions-nav-tab',
	                            'data-toggle': 'tab',
	                            role: 'tab',
	                            'aria-selected': view === 'positions',
	                            onClick: function onClick() {
	                                return setView('positions');
	                            }
	                        },
	                        'Positions ',
	                        '(' + positionsCount + ')',
	                        ' '
	                    )
	                ),
	                _react2.default.createElement(
	                    'li',
	                    { role: 'presentation',
	                        className: view === 'open-orders' ? 'active' : '' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'order-ticket-snapshot-open-orders-nav-tab',
	                            'data-toggle': 'tab',
	                            role: 'tab',
	                            'aria-selected': view === 'open-orders',
	                            onClick: function onClick() {
	                                return setView('open-orders');
	                            }
	                        },
	                        'Open Orders ',
	                        '(' + openOrdersCount + ')'
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.OpenOrders = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OpenOrders = exports.OpenOrders = function OpenOrders() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        openOrders = _useOrderTicket.openOrders,
	        openOrdersStatus = _useOrderTicket.openOrdersStatus,
	        openOrdersCount = _useOrderTicket.openOrdersCount;
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        selected = _React$useState2[0],
	        setSelected = _React$useState2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: openOrdersStatus },
	            _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	            openOrdersCount === 0 && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row text-center vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vertical-offset-xs' },
	                        _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vertical-offset-xs' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'small-header vertical-offset-xxs' },
	                            'There are no open orders in this account.'
	                        )
	                    )
	                )
	            ),
	            openOrdersCount > 0 && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        'Select an open order to view or request cancellation.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12 table-responsive',
	                            style: { display: "block", maxHeight: "450px" } },
	                        _react2.default.createElement(Grid, { openOrders: openOrders, setSelected: setSelected })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        'Showing all open orders for the active account.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(Buttons, { selected: selected })
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Grid = function Grid(_ref) {
	    var openOrders = _ref.openOrders,
	        setSelected = _ref.setSelected;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'table',
	            {
	                className: 'table align-top' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-1' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-5' },
	                        'Issuer/CUSIP'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-1' },
	                        'Action'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-1 text-right' },
	                        'Qty'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-2 text-right' },
	                        'Exec Price'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-2 text-right', style: { whiteSpace: "nowrap" } },
	                        'Est Total Cost'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _twd.arrayFrom)(openOrders).map(function (_ref2, i) {
	                    var tradeNum = _ref2.tradeNum,
	                        tradeActions = _ref2.tradeActions,
	                        holdIssue = _ref2.holdIssue,
	                        holdCusip = _ref2.holdCusip,
	                        tradeType = _ref2.tradeType,
	                        tradeQtyBond = _ref2.tradeQtyBond,
	                        tradeFilledPx = _ref2.tradeFilledPx,
	                        propTransNetMoney = _ref2.propTransNetMoney,
	                        propTransNetMoneyStr = _ref2.propTransNetMoneyStr;
	
	                    var _React$useState3 = _react2.default.useState(null),
	                        _React$useState4 = _slicedToArray(_React$useState3, 2),
	                        el = _React$useState4[0],
	                        setEl = _React$useState4[1];
	
	                    var isAuction = String(propTransNetMoneyStr).toLowerCase() === 'auction';
	
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                                ref: setEl,
	                                type: 'radio',
	                                name: 'order-ticket-open-orders-select',
	                                value: { tradeNum: tradeNum, tradeActions: tradeActions },
	                                onChange: function onChange() {
	                                    setSelected({ tradeNum: tradeNum, tradeActions: tradeActions });
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { style: { maxWidth: '200px' } },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'link-button text-truncate text-left',
	                                    style: { width: '100%' },
	                                    onClick: function onClick() {
	                                        if (!el) return;
	                                        el.checked = true;
	                                        setSelected({ tradeNum: tradeNum, tradeActions: tradeActions });
	                                    }
	                                },
	                                (0, _twd.parseHtml)(holdIssue)
	                            ),
	                            _react2.default.createElement('br', null),
	                            holdCusip.join('')
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { style: { whiteSpace: "nowrap" } },
	                            formatTradeType(tradeType[0])
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.qty(tradeQtyBond)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            isAuction ? 'Auction' : _twd.fmt.money(tradeFilledPx)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            isAuction ? 'Auction' : _twd.fmt.money(propTransNetMoney)
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var formatTradeType = function formatTradeType(a) {
	    return a === 'Offer-W' ? _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	            'span',
	            { className: 'text-bold', style: { color: '#107A1B' } },
	            'Buy Quote'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'span',
	            { style: { fontWeight: '400' } },
	            '(Offer wanted)'
	        )
	    ) : a === 'Bid-W' ? _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	            'span',
	            { className: 'text-bold', style: { color: '#CC0000' } },
	            'Sell Quote'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'span',
	            { style: { fontWeight: '400' } },
	            '(Bid wanted)'
	        )
	    ) : a === 'Buy' ? _react2.default.createElement(
	        'span',
	        { className: 'text-bold', style: { color: '#107A1B' } },
	        'Buy'
	    ) : a === 'Sell' ? _react2.default.createElement(
	        'span',
	        { className: 'text-bold', style: { color: '#CC0000' } },
	        'Sell'
	    ) : null;
	};
	
	var Buttons = function Buttons(_ref3) {
	    var selected = _ref3.selected;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'button',
	            {
	                disabled: !selected,
	                'aria-disabled': !selected,
	                className: 'btn btn-primary-outline',
	                onClick: function onClick(e) {
	                    (0, _twd.showModal)({
	                        view: 'order-detail',
	                        action: 'view',
	                        orderNo: selected.tradeNum,
	                        source: e.target
	                    });
	                } },
	            'View'
	        ),
	        _react2.default.createElement('span', { 'aria-hidden': true, style: { padding: '0 0 0 10px' } }),
	        _react2.default.createElement(
	            'button',
	            {
	                disabled: !selected || selected.tradeActions.split(',').indexOf('cancel') < 0,
	                'aria-disabled': !selected || selected.tradeActions.split(',').indexOf('cancel') < 0,
	                className: 'btn btn-primary-outline',
	                onClick: function onClick(e) {
	                    (0, _twd.showModal)({
	                        view: 'order-detail',
	                        action: 'cancel',
	                        orderNo: selected.tradeNum,
	                        source: e.target
	                    });
	                } },
	            'Request to Cancel'
	        )
	    );
	};

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Positions = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Positions = exports.Positions = function Positions() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        positions = _useOrderTicket.positions,
	        positionsStatus = _useOrderTicket.positionsStatus,
	        positionsCount = _useOrderTicket.positionsCount,
	        cusip = _useOrderTicket.cusip,
	        qty = _useOrderTicket.qty,
	        action = _useOrderTicket.action;
	
	    var _React$useState = _react2.default.useState((0, _twd.arrayFrom)(positions).filter(function (p) {
	        return p.cusip === cusip;
	    })[0] || null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        selected = _React$useState2[0],
	        setSelected = _React$useState2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: positionsStatus },
	            _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	            positionsCount === 0 && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row text-center vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vertical-offset-xs' },
	                        _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'vertical-offset-xs' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'small-header vertical-offset-xxs' },
	                            'There are no positions in this account.'
	                        )
	                    )
	                )
	            ),
	            positionsCount > 0 && _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        'Select a fixed income position to sell or buy. (Note: This may clear any order information already entered.)'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12 table-responsive',
	                            style: { display: "block", maxHeight: "450px" } },
	                        _react2.default.createElement(Grid, { positions: positions, cusip: cusip, qty: qty, action: action, setSelected: setSelected })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        'Showing all positions for the active account.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(Buttons, { selected: selected })
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Grid = function Grid(_ref) {
	    var positions = _ref.positions,
	        cusip = _ref.cusip,
	        qty = _ref.qty,
	        action = _ref.action,
	        setSelected = _ref.setSelected;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'table',
	            {
	                className: 'table align-top'
	            },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-1' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-5' },
	                        'Issuer/CUSIP'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-2 text-right' },
	                        'Quantity'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-2 text-right' },
	                        'Coupon'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'col-md-2 text-right' },
	                        'Maturity'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                (0, _twd.arrayFrom)(positions).filter(function (_ref2) {
	                    var maturity = _ref2.maturity;
	
	                    var isMatured = (0, _twd.parseDate)(maturity) < Date.now();
	                    return !isMatured;
	                }).sort((0, _twd.sortFn)(function (_ref3) {
	                    var issue = _ref3.issue,
	                        maturity = _ref3.maturity;
	
	                    return (issue || '').trim() + _twd.fmt.fmtDt((0, _twd.parseDate)(maturity), 'yyyy-MM-dd');
	                })).map(function (p, i) {
	                    var _React$useState3 = _react2.default.useState(null),
	                        _React$useState4 = _slicedToArray(_React$useState3, 2),
	                        el = _React$useState4[0],
	                        setEl = _React$useState4[1];
	
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('input', {
	                                ref: setEl,
	                                type: 'radio',
	                                name: 'order-ticket-positions-select',
	                                value: p,
	                                'aria-label': p.issue + '/' + p.cusip,
	                                defaultChecked: p.cusip === cusip && (action === 'B' || p.qty === qty),
	                                onChange: function onChange() {
	                                    setSelected(p);
	                                }
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { style: { maxWidth: '200px' } },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'link-button text-truncate text-left',
	                                    style: { width: '100%' },
	                                    onClick: function onClick() {
	                                        if (!el) return;
	                                        el.checked = true;
	                                        setSelected(p);
	                                    }
	                                },
	                                (0, _twd.parseHtml)(p.issue)
	                            ),
	                            _react2.default.createElement('br', null),
	                            p.cusip
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.qty(p.qty)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.cpn3(p.coupon)
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.mdy(p.maturity)
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var Buttons = function Buttons(_ref4) {
	    var selected = _ref4.selected;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'button',
	            {
	                disabled: !selected,
	                'aria-disabled': !selected,
	                className: 'btn btn-primary-outline',
	                onClick: function onClick() {
	                    (0, _twd.show)('order-ticket', {
	                        action: 'S',
	                        acctNo: selected.acct_no,
	                        cusip: selected.cusip,
	                        qty: selected.qty,
	                        sourceAction: 'H',
	                        ts: Date.now()
	                    });
	                } },
	            'Sell'
	        ),
	        _react2.default.createElement('span', { 'aria-hidden': true, style: { padding: '0 0 0 10px' } }),
	        _react2.default.createElement(
	            'button',
	            {
	                disabled: !selected,
	                'aria-disabled': !selected,
	                className: 'btn btn-primary-outline',
	                onClick: function onClick() {
	                    (0, _twd.show)('order-ticket', {
	                        action: 'B',
	                        acctNo: selected.acct_no,
	                        cusip: selected.cusip,
	                        ts: Date.now()
	                    });
	                } },
	            'Buy'
	        )
	    );
	};

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Snapshot = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(118);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _navTabs = __webpack_require__(1052);
	
	var _navTabs2 = _interopRequireDefault(_navTabs);
	
	var _index = __webpack_require__(240);
	
	var _context = __webpack_require__(1050);
	
	var _positions = __webpack_require__(1054);
	
	var _openOrders = __webpack_require__(1053);
	
	var _useOrderTicket2 = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Snapshot = exports.Snapshot = function Snapshot() {
	    var _useOrderTicket = (0, _useOrderTicket2.useOrderTicket)(),
	        view = _useOrderTicket.snapshotView,
	        cusip = _useOrderTicket.cusip;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'order-ticket-form',
	                className: 'container vertical-offset-sm',
	                css: _style.sectionCss
	            },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(_navTabs2.default, null)
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    view === 'snapshot' && !cusip ? (0, _core.jsx)(_index.ChartTable, null) : view === 'snapshot' && cusip ? (0, _core.jsx)(_context.Context, null) : view === 'positions' ? (0, _core.jsx)(_positions.Positions, null) : view === 'open-orders' ? (0, _core.jsx)(_openOrders.OpenOrders, null) : null
	                )
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetLastAccountInfo = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _twd.getState)('order-ticket-account-info.last', {
	    ts: 0,
	    accountInfo: {},
	    hasAccountInfo: false,
	    accountInfoStatus: _twd.Status.NULL
	});
	
	var resetLastAccountInfo = exports.resetLastAccountInfo = function resetLastAccountInfo() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$ts = _ref.ts,
	        ts = _ref$ts === undefined ? 0 : _ref$ts;
	
	    Last.reset();
	    Last.set({
	        ts: ts,
	        accountInfo: {},
	        hasAccountInfo: false,
	        accountInfoStatus: _twd.Status.NULL
	    });
	};
	
	exports.default = function (_ref2) {
	    var acctNo = _ref2.acctNo,
	        ts = _ref2.ts;
	
	    var _React$useState = _react2.default.useState(Last.value.orderInfo || {}),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        accountInfo = _React$useState2[0],
	        setAccountInfo_ = _React$useState2[1];
	
	    var setAccountInfo = _react2.default.useCallback(function (accountInfo_) {
	        accountInfo_ = accountInfo_ || {};
	        var x = Number.parseFloat(accountInfo_.BuyingPower);
	        accountInfo_.purchasingPower = isNaN(x) ? accountInfo_.purchasingPower || null : x;
	
	        Last.set({ accountInfo: accountInfo_ });
	        setAccountInfo_(accountInfo_);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.hasOrderInfo || false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        hasAccountInfo = _React$useState4[0],
	        setHasAccountInfo_ = _React$useState4[1];
	
	    var setHasAccountInfo = _react2.default.useCallback(function (hasAccountInfo_) {
	        Last.set({ hasAccountInfo: hasAccountInfo_ });
	        setHasAccountInfo_(hasAccountInfo_);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(Last.value.orderInfoStatus || _twd.Status.NULL),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        accountInfoStatus = _React$useState6[0],
	        setAccountInfoStatus_ = _React$useState6[1];
	
	    var setAccountInfoStatus = _react2.default.useCallback(function (accountInfoStatus_) {
	        Last.set({ accountInfoStatus: accountInfoStatus_ });
	        setAccountInfoStatus_(accountInfoStatus_);
	    }, []);
	
	    var reset = function reset() {
	        Last.reset();
	        setHasAccountInfo(false);
	        setAccountInfo({});
	        setAccountInfoStatus(_twd.Status.NULL);
	    };
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var params, _ref4, acct_, info;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (ts) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	
	                            setHasAccountInfo(false);
	
	                            if (acctNo) {
	                                _context.next = 7;
	                                break;
	                            }
	
	                            setAccountInfoStatus(_twd.Status.NULL);
	                            return _context.abrupt('return');
	
	                        case 7:
	
	                            setAccountInfoStatus(_twd.Status.LOADING);
	
	                            params = (0, _twd.cleanObject)({
	                                acctId: acctNo.replace('-', '')
	                            });
	                            _context.next = 11;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/trades/accountInfo',
	                                method: 'POST',
	                                headers_: {
	                                    'Content-Type': 'application/x-www-form-urlencoded'
	                                },
	                                body: (0, _twd.toQueryString)(params)
	                            });
	
	                        case 11:
	                            _ref4 = _context.sent;
	                            acct_ = _ref4.data;
	                            _context.next = 15;
	                            return acct_;
	
	                        case 15:
	                            info = _context.sent;
	
	                            setAccountInfo(info);
	                            setHasAccountInfo(true);
	                            setAccountInfoStatus(_twd.Status.LOADED);
	
	                            _context.next = 26;
	                            break;
	
	                        case 21:
	                            _context.prev = 21;
	                            _context.t0 = _context['catch'](2);
	
	                            setAccountInfo({});
	                            setHasAccountInfo(false);
	                            setAccountInfoStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 26:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 21]]);
	        }))();
	    }, [acctNo, ts]);
	
	    return {
	        accountInfo: accountInfo,
	        setAccountInfo: setAccountInfo,
	        hasAccountInfo: hasAccountInfo,
	        setHasAccountInfo: setHasAccountInfo,
	        accountInfoStatus: accountInfoStatus,
	        setAccountInfoStatus: setAccountInfoStatus,
	        reset: reset
	    };
	};

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var orderInfo = _ref.orderInfo,
	        bondInfo = _ref.bondInfo;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        hasAttestCD = _React$useState2[0],
	        setHasAttestCD = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        hasAttestCorp = _React$useState4[0],
	        setHasAttestCorp = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(false),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        attestCD = _React$useState6[0],
	        setAttestCD = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(false),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        attestCorp = _React$useState8[0],
	        setAttestCorp = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(false),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        attested = _React$useState10[0],
	        setAttested = _React$useState10[1];
	
	    var updateAttested = function updateAttested(_ref2) {
	        var bondInfo = _ref2.bondInfo,
	            hasAttestCD_ = _ref2.hasAttestCD_,
	            hasAttestCorp_ = _ref2.hasAttestCorp_,
	            attestCD_ = _ref2.attestCD_,
	            attestCorp_ = _ref2.attestCorp_;
	
	
	        var prospectus = bondInfo && bondInfo.issue && bondInfo.issue.prospectus;
	        var isAttestCorp = hasAttestCorp_ && prospectus;
	        var a = !hasAttestCD_ && !hasAttestCorp_ || hasAttestCD_ && attestCD_ || isAttestCorp && attestCorp_;
	        setAttested(a);
	    };
	
	    _react2.default.useEffect(function () {
	        if (!bondInfo) return;
	
	        updateAttested({
	            bondInfo: bondInfo,
	            hasAttestCD_: hasAttestCD,
	            hasAttestCorp_: hasAttestCorp,
	            attestCD_: attestCD,
	            attestCorp_: attestCorp
	        });
	    }, [bondInfo, hasAttestCD, hasAttestCorp, attestCD, attestCorp]);
	
	    _react2.default.useEffect(function () {
	        if (!bondInfo || !orderInfo) return;
	
	        var issue = bondInfo.issue;
	
	        if (!issue) return;
	
	        var hasCD = orderInfo.action === 'B' && issue.type === 'S';
	        setHasAttestCD(hasCD);
	
	        var hasCorp = orderInfo.action === 'B' && issue.type === 'C' && orderInfo.primary === 'Y';
	        setHasAttestCorp(hasCorp);
	
	        updateAttested({
	            bondInfo: bondInfo,
	            hasAttestCD_: hasCD,
	            hasAttestCorp_: hasCorp,
	            attestCD_: attestCD,
	            attestCorp_: attestCorp
	        });
	    }, [bondInfo, orderInfo]);
	
	    return {
	        attested: attested,
	        hasAttestCD: hasAttestCD,
	        hasAttestCorp: hasAttestCorp,
	        attestCD: attestCD, setAttestCD: setAttestCD,
	        attestCorp: attestCorp, setAttestCorp: setAttestCorp
	    };
	};

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetLastBondInfo = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _twd.getState)('order-ticket-bond-info.last', {
	    ts: 0,
	    bondInfo: {},
	    hasBondInfo: false,
	    bondInfoStatus: _twd.Status.NULL,
	    isBondRestricted: false
	});
	
	var Last30Days = 30 * 24 * 60 * 60 * 1000;
	
	var resetLastBondInfo = exports.resetLastBondInfo = function resetLastBondInfo() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$ts = _ref.ts,
	        ts = _ref$ts === undefined ? 0 : _ref$ts;
	
	    Last.reset();
	    Last.set({
	        ts: ts,
	        bondInfo: {},
	        hasBondInfo: false,
	        bondInfoStatus: _twd.Status.NULL,
	        isBondRestricted: false
	    });
	};
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(Last.value.bondInfo || {}),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        bondInfo = _React$useState2[0],
	        setBondInfo_ = _React$useState2[1];
	
	    var setBondInfo = _react2.default.useCallback(function (bondInfo) {
	        Last.set({ bondInfo: bondInfo });
	        setBondInfo_(bondInfo);
	
	        var _ref2 = bondInfo || {},
	            issue = _ref2.issue;
	
	        var _ref3 = issue || {},
	            type = _ref3.type,
	            category = _ref3.category;
	
	        var a = ['O', 'R', 'K', 'P'].indexOf(type) >= 0 || type === 'C' && category === 'N' || issue && !issue.allowTrading;
	        setIsBondRestricted(a);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.hasBondInfo || false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        hasBondInfo = _React$useState4[0],
	        setHasBondInfo_ = _React$useState4[1];
	
	    var setHasBondInfo = _react2.default.useCallback(function (hasBondInfo) {
	        Last.set({ hasBondInfo: hasBondInfo });
	        setHasBondInfo_(hasBondInfo);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(Last.value.bondInfoStatus || _twd.Status.NULL),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        bondInfoStatus = _React$useState6[0],
	        setBondInfoStatus_ = _React$useState6[1];
	
	    var setBondInfoStatus = _react2.default.useCallback(function (bondInfoStatus) {
	        Last.set({ bondInfoStatus: bondInfoStatus });
	        setBondInfoStatus_(bondInfoStatus);
	    }, []);
	
	    var _React$useState7 = _react2.default.useState(Last.value.isBondRestricted || false),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        isBondRestricted = _React$useState8[0],
	        setIsBondRestricted_ = _React$useState8[1];
	
	    var setIsBondRestricted = _react2.default.useCallback(function (isBondRestricted) {
	        Last.set({ isBondRestricted: isBondRestricted });
	        setIsBondRestricted_(isBondRestricted);
	    }, []);
	
	    var lastAbortBond = _react2.default.useRef();
	    var lastAbortBook = _react2.default.useRef();
	    var lastAbortEvent = _react2.default.useRef();
	    var lastAbortRecent = _react2.default.useRef();
	
	    var _React$useState9 = _react2.default.useState(0),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        bondTs = _React$useState10[0],
	        setBondTs = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState(null),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        bondCusip = _React$useState12[0],
	        setBondCusip = _React$useState12[1];
	
	    var updateBondInfo = function () {
	        var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref4) {
	            var cusip = _ref4.cusip,
	                ts = _ref4.ts,
	                isReset = _ref4.isReset;
	
	            var _ref6, bond_, abort_bond_, bond, issue, _ref7, book_, abort_book_, book, _ref8, event_, abort_event_, _ref9, recent_, abort_recent_, _ref10, type, category, couponTypeCode, hasTradeYield;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (cusip) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            if (isReset) {
	                                _context.next = 9;
	                                break;
	                            }
	
	                            if (!(bondTs && ts === bondTs)) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 5:
	                            if (!(bondInfo.cusip === cusip)) {
	                                _context.next = 7;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 7:
	                            if (!(!bondTs && bondCusip === cusip)) {
	                                _context.next = 9;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 9:
	
	                            setBondCusip(cusip);
	
	                            if (lastAbortBond.current) {
	                                lastAbortBond.current();
	                            }
	                            if (lastAbortBook.current) {
	                                lastAbortBook.current();
	                            }
	                            if (lastAbortEvent.current) {
	                                lastAbortEvent.current();
	                            }
	                            if (lastAbortRecent.current) {
	                                lastAbortRecent.current();
	                            }
	
	                            _context.prev = 14;
	
	                            setHasBondInfo(false);
	
	                            if (cusip) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            setBondInfoStatus(_twd.Status.NULL);
	                            setBondInfo({});
	                            return _context.abrupt('return');
	
	                        case 20:
	
	                            setBondInfoStatus(_twd.Status.LOADING);
	
	                            _context.next = 23;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/bondDetailService/getIssueDesc',
	                                method: 'POST',
	                                params: {
	                                    p_cusip: cusip,
	                                    p_id_type: 'I',
	                                    p_brand: (0, _twd.getBrand)(),
	                                    p_alloc_id: '',
	                                    p_watch_id: '',
	                                    p_ngw: 'Y'
	                                }
	                            });
	
	                        case 23:
	                            _ref6 = _context.sent;
	                            bond_ = _ref6.data;
	                            abort_bond_ = _ref6.abort;
	
	
	                            lastAbortBond.current = abort_bond_;
	                            _context.next = 29;
	                            return bond_;
	
	                        case 29:
	                            bond = _context.sent;
	                            issue = bond.issue = bond.issue || {};
	
	                            issue.prospectus = function () {
	                                var t = issue && issue.researchLinks;
	                                if (!t) {
	                                    return;
	                                }
	                                if (t.indexOf('LEGAL(' + issue.cusip + ')') < 0 && t.indexOf('SALES(' + issue.cusip + ')') < 0) {
	                                    return;
	                                }
	
	                                var a = t.indexOf('BDResearch.showViewer(');
	                                var s = t.substring(a, t.indexOf(')', a));
	                                var u = String(s).replace("BDResearch.showViewer('", '').replaceAll("'", '');
	                                var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	                                return u ? 'https://www.bonddesk.com/etrade/' + owaTcDaoContext + '/' + u : '';
	                            }();
	
	                            _context.next = 34;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/cusip/warningAndBook',
	                                method: 'POST',
	                                params: {
	                                    "p_criteria_fmt": "ADVANCED",
	                                    "p_cusip": cusip,
	                                    "p_maxrows": 1,
	                                    "p_monarch": "Y",
	                                    "p_output_fmt": "JSON",
	                                    "p_multiple": ["BOL-UOR", "BOL-ROR"],
	                                    "p_submit": "JSON",
	                                    "p_redirect_output": "Y",
	                                    "p_type": "0",
	                                    "p_min_qty": 1,
	                                    "p_is_offer_search": false,
	                                    "p_search_criteria": {},
	                                    "p_mode": "RP"
	                                }
	                            });
	
	                        case 34:
	                            _ref7 = _context.sent;
	                            book_ = _ref7.data;
	                            abort_book_ = _ref7.abort;
	
	                            lastAbortBook.current = abort_book_;
	                            _context.next = 40;
	                            return book_;
	
	                        case 40:
	                            _context.t0 = _context.sent[0];
	
	                            if (_context.t0) {
	                                _context.next = 43;
	                                break;
	                            }
	
	                            _context.t0 = {};
	
	                        case 43:
	                            book = _context.t0;
	
	                            bond.issue.showBook = book.showBook;
	                            bond.issue.allowTrading = book.allowTrading;
	                            bond.issue.warningText = book.warningText;
	
	                            _context.next = 49;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/bondDetailService/getSecurityEvents',
	                                method: 'POST',
	                                params: {
	                                    cusip: cusip,
	                                    invType: bond.issue.type
	                                }
	                            });
	
	                        case 49:
	                            _ref8 = _context.sent;
	                            event_ = _ref8.data;
	                            abort_event_ = _ref8.abort;
	
	
	                            lastAbortEvent.current = abort_event_;
	                            _context.t2 = _twd.evalJson;
	                            _context.next = 56;
	                            return event_;
	
	                        case 56:
	                            _context.t3 = _context.sent;
	                            _context.t4 = {};
	                            _context.t1 = (0, _context.t2)(_context.t3, _context.t4).securityeventsjson;
	
	                            if (_context.t1) {
	                                _context.next = 61;
	                                break;
	                            }
	
	                            _context.t1 = [];
	
	                        case 61:
	                            bond.events = _context.t1;
	                            _context.next = 64;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/trades/recent',
	                                method: 'GET',
	                                params: {
	                                    cusip: cusip,
	                                    pageNo: 1,
	                                    noOfRecords: 100
	                                }
	                            });
	
	                        case 64:
	                            _ref9 = _context.sent;
	                            recent_ = _ref9.data;
	                            abort_recent_ = _ref9.abort;
	                            _ref10 = bond.issue || {}, type = _ref10.type, category = _ref10.category, couponTypeCode = _ref10.couponTypeCode;
	                            hasTradeYield = !(['P', 'O', 'R', 'K'].includes(type) || ['C', 'S'].includes(type) && category === 'N' || ['E', '0'].includes(couponTypeCode));
	
	
	                            lastAbortRecent.current = abort_recent_;
	                            _context.t5 = _twd.arrayFrom;
	                            _context.next = 73;
	                            return recent_;
	
	                        case 73:
	                            _context.t6 = _context.sent['detailRecords'];
	
	                            _context.t7 = function (_ref11) {
	                                var trade_date_time = _ref11.trade_date_time;
	
	                                return Date.now() - (0, _twd.parseDate)(trade_date_time) < Last30Days;
	                            };
	
	                            _context.t8 = function (r) {
	                                return Object.assign({}, r, { yield: hasTradeYield ? r.yield : null });
	                            };
	
	                            bond.recentTrades = (0, _context.t5)(_context.t6).filter(_context.t7).slice(0, 20).map(_context.t8);
	
	
	                            setBondInfo(bond);
	                            setHasBondInfo(true);
	                            setBondInfoStatus(_twd.Status.LOADED);
	                            setBondTs(ts);
	
	                            _context.next = 88;
	                            break;
	
	                        case 83:
	                            _context.prev = 83;
	                            _context.t9 = _context['catch'](14);
	
	                            setBondInfo({});
	                            setHasBondInfo(false);
	                            setBondInfoStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 88:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[14, 83]]);
	        }));
	
	        return function updateBondInfo(_x2) {
	            return _ref5.apply(this, arguments);
	        };
	    }();
	
	    var reset = function reset() {
	        Last.reset();
	        setHasBondInfo(false);
	        (0, _twd.clearObject)(bondInfo);
	        setBondInfo({});
	        setBondTs(0);
	    };
	
	    return {
	        bondInfo: bondInfo,
	        setBondInfo: setBondInfo,
	        hasBondInfo: hasBondInfo,
	        setHasBondInfo: setHasBondInfo,
	        bondInfoStatus: bondInfoStatus,
	        setBondInfoStatus: setBondInfoStatus,
	        isBondRestricted: isBondRestricted,
	        setBondTs: setBondTs,
	        reset: reset,
	        updateBondInfo: updateBondInfo
	    };
	};

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetLastOpenOrdersInfo = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _twd.getState)('order-ticket-open-orders.last', {
	    ts: 0,
	    openOrders: [],
	    openOrdersCount: 0,
	    openOrdersStatus: _twd.Status.NULL
	});
	
	var resetLastOpenOrdersInfo = exports.resetLastOpenOrdersInfo = function resetLastOpenOrdersInfo() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$ts = _ref.ts,
	        ts = _ref$ts === undefined ? 0 : _ref$ts;
	
	    Last.reset();
	    Last.set({
	        ts: ts,
	        openOrders: [],
	        openOrdersCount: 0,
	        openOrdersStatus: _twd.Status.NULL
	    });
	};
	
	exports.default = function (_ref2) {
	    var acctNo = _ref2.acctNo,
	        ts = _ref2.ts;
	
	    var _React$useState = _react2.default.useState(Last.value.openOrders || []),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        openOrders = _React$useState2[0],
	        setOpenOrders_ = _React$useState2[1];
	
	    var setOpenOrders = _react2.default.useCallback(function (openOrders) {
	        Last.set({ openOrders: openOrders });
	        setOpenOrders_(openOrders);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.openOrdersCount || []),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        openOrdersCount = _React$useState4[0],
	        setOpenOrdersCount_ = _React$useState4[1];
	
	    var setOpenOrdersCount = _react2.default.useCallback(function (openOrdersCount) {
	        Last.set({ openOrdersCount: openOrdersCount });
	        setOpenOrdersCount_(openOrdersCount);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(Last.value.openOrdersStatus || _twd.Status.NULL),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        openOrdersStatus = _React$useState6[0],
	        setOpenOrdersStatus_ = _React$useState6[1];
	
	    var setOpenOrdersStatus = _react2.default.useCallback(function (openOrdersStatus) {
	        Last.set({ openOrdersStatus: openOrdersStatus });
	        setOpenOrdersStatus_(openOrdersStatus);
	    }, []);
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var now, firstDate, _ref4, data_, data, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	
	                            setOpenOrdersCount(0);
	
	                            if (acctNo) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            setOpenOrdersStatus(_twd.Status.NULL);
	                            return _context.abrupt('return');
	
	                        case 5:
	
	                            setOpenOrdersStatus(_twd.Status.LOADING);
	
	                            now = new Date();
	                            firstDate = new Date(now.getFullYear() - 3, now.getMonth(), now.getDate());
	                            _context.next = 10;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/trades',
	                                method: 'POST',
	                                params: {
	                                    tradeRow: {
	                                        tradeStatus: ["OPEN_ORDER"],
	                                        type: "traderow",
	                                        acctNo: [acctNo],
	                                        tradeSubmitDateRange: _twd.fmt.mdy(firstDate) + ',' + _twd.fmt.mdy(now)
	                                    },
	                                    sort: [{
	                                        field: "tradeSubmitDate",
	                                        direction: "DESC"
	                                    }],
	                                    pageNumber: 1,
	                                    resultsPerPage: 50,
	                                    excludeBlockOrders: true,
	                                    tradeSource: "ATSSOURCE"
	                                }
	                            });
	
	                        case 10:
	                            _ref4 = _context.sent;
	                            data_ = _ref4.data;
	                            _context.next = 14;
	                            return data_;
	
	                        case 14:
	                            data = _context.sent;
	                            rs = (0, _twd.arrayFrom)(data.rows);
	
	                            setOpenOrders(rs);
	                            setOpenOrdersCount(rs.length);
	                            setOpenOrdersStatus(_twd.Status.LOADED);
	
	                            _context.next = 26;
	                            break;
	
	                        case 21:
	                            _context.prev = 21;
	                            _context.t0 = _context['catch'](0);
	
	                            setOpenOrders([]);
	                            setOpenOrdersCount(0);
	                            setOpenOrdersStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 26:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 21]]);
	        }))();
	    }, [acctNo, ts]);
	
	    return {
	        openOrders: openOrders,
	        openOrdersCount: openOrdersCount,
	        openOrdersStatus: openOrdersStatus
	    };
	};

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetLastOrderForm = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Last = (0, _twd.getState)('order-ticket-form.last', {
	    ts: 0
	});
	
	var resetLastOrderForm = exports.resetLastOrderForm = function resetLastOrderForm() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$ts = _ref.ts,
	        ts = _ref$ts === undefined ? 0 : _ref$ts;
	
	    Last.reset();
	    Last.set({ ts: ts });
	};
	
	exports.default = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$acctNo_ = _ref2.acctNo_,
	        acctNo_ = _ref2$acctNo_ === undefined ? '' : _ref2$acctNo_,
	        _ref2$cusip_ = _ref2.cusip_,
	        cusip_ = _ref2$cusip_ === undefined ? '' : _ref2$cusip_,
	        _ref2$action_ = _ref2.action_,
	        action_ = _ref2$action_ === undefined ? '' : _ref2$action_,
	        _ref2$qty_ = _ref2.qty_,
	        qty_ = _ref2$qty_ === undefined ? '' : _ref2$qty_,
	        _ref2$price_ = _ref2.price_,
	        price_ = _ref2$price_ === undefined ? '' : _ref2$price_,
	        _ref2$yld_ = _ref2.yld_,
	        yld_ = _ref2$yld_ === undefined ? '' : _ref2$yld_,
	        _ref2$sourceAction_ = _ref2.sourceAction_,
	        sourceAction_ = _ref2$sourceAction_ === undefined ? '' : _ref2$sourceAction_,
	        _ref2$actionSubset_ = _ref2.actionSubset_,
	        actionSubset_ = _ref2$actionSubset_ === undefined ? '' : _ref2$actionSubset_;
	
	    var _React$useState = _react2.default.useState(Last.value.acctNo || acctNo_ || (0, _useOrderTicket.getDefaultAcctNo)()),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        acctNo = _React$useState2[0],
	        setAcctNo_ = _React$useState2[1];
	
	    var setAcctNo = _react2.default.useCallback(function (acctNo) {
	        Last.set({ acctNo: acctNo });
	        setAcctNo_(acctNo);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.mode || getMode({ action: action_, sourceAction_: sourceAction_, actionSubset_: actionSubset_ })),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        mode = _React$useState4[0],
	        setMode_ = _React$useState4[1];
	
	    var setMode = _react2.default.useCallback(function (mode) {
	        Last.set({ mode: mode });
	        setMode_(mode);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(Last.value.cusip || cusip_ || ''),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        cusip = _React$useState6[0],
	        setCusip_ = _React$useState6[1];
	
	    var setCusip = _react2.default.useCallback(function (cusip) {
	        Last.set({ cusip: cusip });
	        setCusip_(cusip);
	    }, []);
	
	    var _React$useState7 = _react2.default.useState(Last.value.action || action_ || 'B'),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        action = _React$useState8[0],
	        setAction_ = _React$useState8[1];
	
	    var setAction = _react2.default.useCallback(function (action) {
	        Last.set({ action: action });
	        setAction_(action);
	        setIsRfq(action === 'W' || action === 'F' || actionSubset_ === 'WF');
	    }, []);
	
	    var _React$useState9 = _react2.default.useState(Last.value.isRfq || action_ === 'W' || action_ === 'F' || actionSubset_ === 'WF'),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        isRfq = _React$useState10[0],
	        setIsRfq_ = _React$useState10[1];
	
	    var setIsRfq = _react2.default.useCallback(function (isRfq) {
	        Last.set({ isRfq: isRfq });
	        setIsRfq_(isRfq);
	    }, []);
	
	    var _React$useState11 = _react2.default.useState(Last.value.qty || qty_ || ''),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        qty = _React$useState12[0],
	        setQty_ = _React$useState12[1];
	
	    var setQty = _react2.default.useCallback(function (qty) {
	        Last.set({ qty: qty });
	        setQty_(qty);
	    }, []);
	
	    var _React$useState13 = _react2.default.useState(Last.value.price || price_ || ''),
	        _React$useState14 = _slicedToArray(_React$useState13, 2),
	        price = _React$useState14[0],
	        setPrice_ = _React$useState14[1];
	
	    var setPrice = _react2.default.useCallback(function (price) {
	        Last.set({ price: price });
	        setPrice_(price);
	    }, []);
	
	    var _React$useState15 = _react2.default.useState(Last.value.yld || yld_ || ''),
	        _React$useState16 = _slicedToArray(_React$useState15, 2),
	        yld = _React$useState16[0],
	        setYld_ = _React$useState16[1];
	
	    var setYld = _react2.default.useCallback(function (yld) {
	        Last.set({ yld: yld });
	        setYld_(yld);
	    }, []);
	
	    var _React$useState17 = _react2.default.useState(Last.value.priceOrYield || 1),
	        _React$useState18 = _slicedToArray(_React$useState17, 2),
	        priceOrYield = _React$useState18[0],
	        setPriceOrYield_ = _React$useState18[1];
	
	    var setPriceOrYield = _react2.default.useCallback(function (priceOrYield) {
	        Last.set({ priceOrYield: priceOrYield });
	        setPriceOrYield_(priceOrYield);
	    }, []);
	
	    var _React$useState19 = _react2.default.useState(null),
	        _React$useState20 = _slicedToArray(_React$useState19, 2),
	        priceEl = _React$useState20[0],
	        setPriceEl = _React$useState20[1];
	
	    var _React$useState21 = _react2.default.useState(null),
	        _React$useState22 = _slicedToArray(_React$useState21, 2),
	        yieldEl = _React$useState22[0],
	        setYieldEl = _React$useState22[1];
	
	    var _React$useState23 = _react2.default.useState(Last.value.bestPrice || null),
	        _React$useState24 = _slicedToArray(_React$useState23, 2),
	        bestPrice = _React$useState24[0],
	        setBestPrice_ = _React$useState24[1];
	
	    var setBestPrice = _react2.default.useCallback(function (bestPrice) {
	        Last.set({ bestPrice: bestPrice });
	        setBestPrice_(bestPrice);
	    }, []);
	
	    var _React$useState25 = _react2.default.useState(Last.value.bestYield || null),
	        _React$useState26 = _slicedToArray(_React$useState25, 2),
	        bestYield = _React$useState26[0],
	        setBestYield_ = _React$useState26[1];
	
	    var setBestYield = _react2.default.useCallback(function (bestYield) {
	        Last.set({ bestYield: bestYield });
	        setBestYield_(bestYield);
	    }, []);
	
	    var _React$useState27 = _react2.default.useState(false),
	        _React$useState28 = _slicedToArray(_React$useState27, 2),
	        noMarketRfq = _React$useState28[0],
	        setNoMarketRfq = _React$useState28[1];
	
	    var reset = function reset(_ref3) {
	        var acctNo = _ref3.acctNo,
	            cusip = _ref3.cusip,
	            action = _ref3.action,
	            qty = _ref3.qty,
	            price = _ref3.price,
	            yld = _ref3.yld,
	            actionSubset_ = _ref3.actionSubset_,
	            sourceAction_ = _ref3.sourceAction_;
	
	        Last.reset();
	        setAcctNo(acctNo || (0, _useOrderTicket.getDefaultAcctNo)());
	        setCusip(cusip);
	        setAction(action);
	        setQty(qty);
	        setPrice(price);
	        setYld(yld);
	        setBestPrice(null);
	        setBestYield(null);
	        setNoMarketRfq(false);
	        setMode(getMode({ action: action, actionSubset_: actionSubset_, sourceAction_: sourceAction_ }));
	        setIsRfq(action === 'W' || action === 'F' || actionSubset_ === 'WF');
	    };
	
	    return {
	        acctNo: acctNo, setAcctNo: setAcctNo,
	        mode: mode, setMode: setMode,
	        cusip: cusip, setCusip: setCusip,
	        action: action, setAction: setAction,
	        isRfq: isRfq,
	        qty: qty, setQty: setQty,
	        price: price, setPrice: setPrice,
	        yld: yld, setYld: setYld,
	        priceOrYield: priceOrYield, setPriceOrYield: setPriceOrYield,
	        bestPrice: bestPrice, setBestPrice: setBestPrice,
	        bestYield: bestYield, setBestYield: setBestYield,
	        noMarketRfq: noMarketRfq, setNoMarketRfq: setNoMarketRfq,
	        reset: reset,
	        priceEl: priceEl, setPriceEl: setPriceEl,
	        yieldEl: yieldEl, setYieldEl: setYieldEl
	    };
	};
	
	var getMode = function getMode() {
	    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref4$action = _ref4.action,
	        action = _ref4$action === undefined ? '' : _ref4$action,
	        sourceAction_ = _ref4.sourceAction_,
	        actionSubset_ = _ref4.actionSubset_;
	
	    return sourceAction_ === 'Z' || sourceAction_ === 'Y' ? _useOrderTicket.MODES.ORDER_Z : actionSubset_ === 'WF' ? _useOrderTicket.MODES.RFQ : action.length === 1 ? _useOrderTicket.MODES.ORDER : _useOrderTicket.MODES.NEW;
	};

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetLastOrderInfo = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Last = (0, _twd.getState)('order-ticket-order-info.last', {
	    ts: 0,
	    orderInfo: {},
	    hasOrderInfo: false,
	    orderInfoStatus: _twd.Status.NULL
	});
	
	var resetLastOrderInfo = exports.resetLastOrderInfo = function resetLastOrderInfo() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$ts = _ref.ts,
	        ts = _ref$ts === undefined ? 0 : _ref$ts;
	
	    Last.reset();
	    Last.set({
	        ts: ts,
	        orderInfo: {},
	        hasOrderInfo: false,
	        orderInfoStatus: _twd.Status.NULL
	    });
	};
	
	var TransactionType = {
	    'W': 'Sell Quote (Bid Wanted)',
	    'F': 'Buy Quote (Offer Wanted)',
	    'B': 'Buy',
	    'S': 'Sell'
	};
	
	exports.default = function () {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        setModals = _ref2.setModals,
	        from = _ref2.from;
	
	    var _React$useState = _react2.default.useState(Last.value.orderInfo || {}),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        orderInfo = _React$useState2[0],
	        setOrderInfo_ = _React$useState2[1];
	
	    var setOrderInfo = _react2.default.useCallback(function (orderInfo_) {
	        orderInfo_ = orderInfo_ || {};
	        var _orderInfo_ = orderInfo_,
	            statusMsg = _orderInfo_.statusMsg,
	            offerings = _orderInfo_.offerings,
	            action = _orderInfo_.action;
	
	
	        orderInfo_.max_qty_avail = orderInfo_.qty_max;
	        orderInfo_.sugg_comm_in_dlrs_per_tckt = orderInfo_.sugg_comm_in_dlrs_per_tckt || 0;
	        orderInfo_.netMoney = orderInfo_.netMoney || 0;
	        orderInfo_.transactionType = TransactionType[action];
	
	        if (!(0, _twd.isEmpty)(offerings)) {
	            var o = (0, _twd.arrayFrom)(offerings).sort(function (_ref3, _ref4) {
	                var a = _ref3.availQty;
	                var b = _ref4.availQty;
	                return b - a;
	            })[0] || {};
	
	            var availQty = parseFloat(o.availQty);
	            orderInfo_.max_qty_avail = Math.max(orderInfo_.max_qty_avail, !isNaN(availQty) ? availQty : 0);
	        }
	
	        if (statusMsg) {
	
	            // remove max qty error
	            if (statusMsg.indexOf('12105') >= 0) {
	                orderInfo_.statusMsg = '';
	            }
	
	            // check if duplicate order
	            if (orderInfo_.statusMsg.indexOf('12891') >= 0) {
	                orderInfo_.statusMsg = orderInfo_.statusMsg.replaceAll('(12891)', '');
	                setModals({
	                    view: 'order-ticket-duplicate-order-modal',
	                    from: from
	                });
	            }
	
	            if (orderInfo_.statusMsg.startsWith("ERROR:")) {
	                orderInfo_.statusMsg = orderInfo_.statusMsg.replace("ERROR:", "ERROR: ");
	            }
	
	            orderInfo_.statusMsg = orderInfo_.statusMsg.replace('Click Save & Preview or Save & Enter Another Account', 'Click Preview');
	        }
	
	        Last.set({ orderInfo: orderInfo_ });
	        setOrderInfo_(orderInfo_);
	
	        setHasOrderInfo(Object.keys(orderInfo_).length > 0);
	
	        var s = orderInfo_.statusMsg || '';
	        var f = s.indexOf('NO OFFERINGS FOR TICKET') > 0 || s.indexOf('NO ORDER CONFIGURED FOR TICKET') > 0;
	        orderInfo_.hasMarket = !f;
	        setHasMarket(!f);
	
	        // remove any additions added to the issuer name
	        if (orderInfo_.issue) {
	            orderInfo_.issue = orderInfo_.issue.replaceAll(/<span.*/g, '');
	        }
	
	        return orderInfo_;
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.hasMarket || false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        hasMarket = _React$useState4[0],
	        setHasMarket_ = _React$useState4[1];
	
	    var setHasMarket = _react2.default.useCallback(function (hasMarket) {
	        Last.set({ hasMarket: hasMarket });
	        setHasMarket_(hasMarket);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(Last.value.hasOrderInfo || false),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        hasOrderInfo = _React$useState6[0],
	        setHasOrderInfo_ = _React$useState6[1];
	
	    var setHasOrderInfo = _react2.default.useCallback(function (hasOrderInfo) {
	        Last.set({ hasOrderInfo: hasOrderInfo });
	        setHasOrderInfo_(hasOrderInfo);
	    }, []);
	
	    var _React$useState7 = _react2.default.useState(Last.value.orderInfoStatus || _twd.Status.NULL),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        orderInfoStatus = _React$useState8[0],
	        setOrderInfoStatus_ = _React$useState8[1];
	
	    var setOrderInfoStatus = _react2.default.useCallback(function (orderInfoStatus) {
	        Last.set({ orderInfoStatus: orderInfoStatus });
	        setOrderInfoStatus_(orderInfoStatus);
	    }, []);
	
	    var _React$useState9 = _react2.default.useState(Last.value.hiddenStates || {}),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        hiddenState = _React$useState10[0],
	        setHiddenState_ = _React$useState10[1];
	
	    var setHiddenState = _react2.default.useCallback(function (hiddenState) {
	        Last.set({ hiddenState: hiddenState });
	        setHiddenState_(hiddenState);
	    }, []);
	
	    var reset = function reset() {
	        Last.reset();
	        setHasOrderInfo(false);
	        setOrderInfo({});
	        setOrderInfoStatus(_twd.Status.NULL);
	        setHiddenState({});
	    };
	
	    return {
	        orderInfo: orderInfo, setOrderInfo: setOrderInfo,
	        hasOrderInfo: hasOrderInfo, setHasOrderInfo: setHasOrderInfo,
	        orderInfoStatus: orderInfoStatus, setOrderInfoStatus: setOrderInfoStatus,
	        hiddenState: hiddenState, setHiddenState: setHiddenState,
	        hasMarket: hasMarket, setHasMarket: setHasMarket,
	        reset: reset
	    };
	};

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.confirm = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define,no-eval */
	
	
	var confirm = exports.confirm = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	        var acctNo = _ref.acctNo,
	            action = _ref.action,
	            cusip = _ref.cusip,
	            qty = _ref.qty,
	            price = _ref.price,
	            yld = _ref.yld,
	            priceOrYield = _ref.priceOrYield,
	            attested = _ref.attested,
	            orderInfo = _ref.orderInfo,
	            setOrderInfo = _ref.setOrderInfo,
	            hiddenState = _ref.hiddenState,
	            sourceAction_ = _ref.sourceAction_,
	            actionSubset_ = _ref.actionSubset_,
	            sourceOrderNo_ = _ref.sourceOrderNo_,
	            mode = _ref.mode,
	            isTreasuryAuction = _ref.isTreasuryAuction,
	            bestPrice = _ref.bestPrice,
	            bestYield = _ref.bestYield;
	
	        var f, p_dealer_code, p_trade_type, p_settlement, p_submit, p_ovalcdata, statusMsg, p_price_init, p_yield_init, p_discount_init, p_settlement_init, p_id, p_order_type, p_wrap_acct, p_exec_type, p_seeded, p_validated, p_warning, p_mm, p_dd, p_yy, p_old_dlr_price, p_timestamp, p_validate_resp, p_valreq_id, p_order_trans_id, p_ocfg_order_no, isContinue, isLift, isCounterDisallowed, params, _ref3, order_, info;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        f = (orderInfo.submit || '').indexOf('Place') === 0;
	
	                        if (f) {
	                            _context.next = 3;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 3:
	                        p_dealer_code = orderInfo.dealerCode, p_trade_type = orderInfo.tradeType, p_settlement = orderInfo.settlement, p_submit = orderInfo.submit, p_ovalcdata = orderInfo.ovalcdata, statusMsg = orderInfo.statusMsg;
	                        p_price_init = hiddenState.p_price_init, p_yield_init = hiddenState.p_yield_init, p_discount_init = hiddenState.p_discount_init, p_settlement_init = hiddenState.p_settlement_init, p_id = hiddenState.p_id, p_order_type = hiddenState.p_order_type, p_wrap_acct = hiddenState.p_wrap_acct, p_exec_type = hiddenState.p_exec_type, p_seeded = hiddenState.p_seeded, p_validated = hiddenState.p_validated, p_warning = hiddenState.p_warning, p_mm = hiddenState.p_mm, p_dd = hiddenState.p_dd, p_yy = hiddenState.p_yy, p_old_dlr_price = hiddenState.p_old_dlr_price, p_timestamp = hiddenState.p_timestamp, p_validate_resp = hiddenState.p_validate_resp, p_valreq_id = hiddenState.p_valreq_id, p_order_trans_id = hiddenState.p_order_trans_id, p_ocfg_order_no = hiddenState.p_ocfg_order_no;
	                        isContinue = (statusMsg || '').toLowerCase().indexOf('click preview to continue') > 0;
	                        isLift = mode === _useOrderTicket.MODES.ORDER_Z;
	                        isCounterDisallowed = orderInfo && orderInfo.countersAllowed === 'N';
	                        params = (0, _twd.cleanObject)({
	                            p_acct_no: acctNo,
	                            p_action: isTreasuryAuction ? 'B' : action,
	                            p_cusip: cusip,
	                            p_qty_bond: qty,
	                            p_price: isTreasuryAuction ? null : isCounterDisallowed ? bestPrice : price,
	                            p_yield: isTreasuryAuction ? null : isCounterDisallowed ? bestYield : yld,
	                            p_price_type: isTreasuryAuction ? 'A' : priceOrYield,
	                            p_misc4: attested ? 'Y' : '',
	
	                            p_submit: p_submit,
	                            p_ovalcdata: p_ovalcdata,
	                            p_valreq_id: p_valreq_id,
	                            p_validate_resp: p_validate_resp,
	
	                            // from hidden-states
	                            p_dd: p_dd,
	                            p_dealer_code: p_dealer_code,
	                            p_discount_init: p_discount_init,
	                            p_exec_type: p_exec_type,
	                            p_id: p_id,
	                            p_mm: p_mm,
	                            p_ocfg_order_no: isLift ? '' : p_ocfg_order_no,
	                            p_old_dlr_price: p_old_dlr_price,
	                            p_order_trans_id: p_order_trans_id,
	                            p_order_type: isTreasuryAuction ? 'A' : p_order_type,
	                            p_price_init: isLift ? price : p_price_init,
	                            p_seeded: isTreasuryAuction ? 1 : p_seeded,
	                            p_settlement: p_settlement,
	                            p_settlement_init: p_settlement_init,
	                            p_timestamp: p_timestamp,
	                            p_trade_type: p_trade_type,
	                            p_validated: isContinue ? 'Y' : p_validated,
	                            p_warning: isContinue ? 'Y' : p_warning,
	                            p_wrap_acct: p_wrap_acct,
	                            p_yield_init: p_yield_init,
	                            p_yy: p_yy,
	
	                            // from origin actionSubset_, sourceOrderNo_
	                            p_action_subset: actionSubset_,
	                            p_source_order_no: sourceOrderNo_,
	                            p_source_action: sourceAction_,
	
	                            // p_alloc_id: '',
	                            // p_broker_text: '',
	                            // p_called_from: '',
	                            // p_dtc: '',
	                            // p_execbroker: '',
	                            // p_javascript: '',
	                            // p_limittext: '',
	                            // p_markup_quantity: '',
	                            // p_max_bid_sc: '',
	                            // p_miscdata: '',
	                            // p_order_xref: '',
	                            // p_ovalcdata: '',
	                            // p_price_change_ind: '',
	                            // p_settlement_ent_val: '',
	                            // p_ticket_source: '',
	                            p_output_format: 'JSON',
	                            p_transdata: 'ETRADENOE(Y)'
	                        });
	                        _context.prev = 9;
	                        _context.next = 12;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/trades/orderInput',
	                            method: 'POST',
	                            headers_: {
	                                'Content-Type': 'text/plain'
	                            },
	                            body: (0, _twd.toQueryString)(params).replace('%20', '+'),
	                            type: 'text'
	                        });
	
	                    case 12:
	                        _ref3 = _context.sent;
	                        order_ = _ref3.data;
	                        _context.t0 = eval;
	                        _context.next = 17;
	                        return order_;
	
	                    case 17:
	                        _context.t1 = _context.sent;
	                        info = (0, _context.t0)(_context.t1);
	
	                        info.orderStatusDesc = ORDER_STATUS[info.ordstatus];
	
	                        if (info.orderStatusDesc) {
	                            _context.next = 22;
	                            break;
	                        }
	
	                        throw new Error("unknown order status");
	
	                    case 22:
	
	                        setOrderInfo(info);
	                        return _context.abrupt('return', info);
	
	                    case 26:
	                        _context.prev = 26;
	                        _context.t2 = _context['catch'](9);
	
	                        Object.assign(orderInfo, {
	                            status: 'Fail',
	                            statusMsg: 'ERROR: There was an error processing your request.'
	                        });
	                        console.error('use-order-ticket-confirm', _context.t2);
	
	                    case 30:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[9, 26]]);
	    }));
	
	    return function confirm(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var ORDER_STATUS = {
	    "0": "Open",
	    "1": "Partially Filled (Pending Fill)",
	    "2": "Filled",
	    "3": "Done for day",
	    "4": "Cancelled",
	    "5": "Replaced",
	    "6": "Pending Cancel",
	    "8": "Rejected",
	    "9": "Trade Cancelled",
	    "A": "Pending New (Accepted)",
	    "X": "Approved",
	    "C": "Expired",
	    "P": "Passed Update",
	    "Y": "Pending Fill",
	    "U": "Status Update",
	    "S": "Showing"
	};

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.preview = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define,no-eval */
	
	
	var preview = exports.preview = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	        var step = _ref.step,
	            acctNo = _ref.acctNo,
	            action = _ref.action,
	            cusip = _ref.cusip,
	            qty = _ref.qty,
	            price = _ref.price,
	            yld = _ref.yld,
	            priceOrYield = _ref.priceOrYield,
	            isRfq = _ref.isRfq,
	            isCalc = _ref.isCalc,
	            attested = _ref.attested,
	            hasMarket = _ref.hasMarket,
	            hasOrderInfo = _ref.hasOrderInfo,
	            orderInfo = _ref.orderInfo,
	            hiddenState = _ref.hiddenState,
	            setOrderInfo = _ref.setOrderInfo,
	            setHiddenState = _ref.setHiddenState,
	            sourceAction_ = _ref.sourceAction_,
	            actionSubset_ = _ref.actionSubset_,
	            sourceOrderNo_ = _ref.sourceOrderNo_,
	            isTreasuryAuction = _ref.isTreasuryAuction,
	            bestPrice = _ref.bestPrice,
	            bestYield = _ref.bestYield,
	            mode = _ref.mode;
	
	        var f, p_dealer_code, p_trade_type, p_settlement, statusMsg, p_price_init, p_yield_init, p_discount_init, p_settlement_init, p_id, p_order_type, p_wrap_acct, p_exec_type, p_seeded, p_validated, p_warning, p_mm, p_dd, p_yy, p_old_dlr_price, p_timestamp, p_validate_resp, p_valreq_id, p_order_trans_id, p_ocfg_order_no, isLift, isCounterDisallowed, params, _ref3, order_, info;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        f = step === _useOrderTicket.STEPS.ENTRY && qty && (isRfq || price || yld || !hasMarket || isTreasuryAuction) && hasOrderInfo;
	
	                        if (f) {
	                            _context.next = 3;
	                            break;
	                        }
	
	                        return _context.abrupt('return');
	
	                    case 3:
	                        p_dealer_code = orderInfo.dealerCode, p_trade_type = orderInfo.tradeType, p_settlement = orderInfo.settlement, statusMsg = orderInfo.statusMsg;
	                        p_price_init = hiddenState.p_price_init, p_yield_init = hiddenState.p_yield_init, p_discount_init = hiddenState.p_discount_init, p_settlement_init = hiddenState.p_settlement_init, p_id = hiddenState.p_id, p_order_type = hiddenState.p_order_type, p_wrap_acct = hiddenState.p_wrap_acct, p_exec_type = hiddenState.p_exec_type, p_seeded = hiddenState.p_seeded, p_validated = hiddenState.p_validated, p_warning = hiddenState.p_warning, p_mm = hiddenState.p_mm, p_dd = hiddenState.p_dd, p_yy = hiddenState.p_yy, p_old_dlr_price = hiddenState.p_old_dlr_price, p_timestamp = hiddenState.p_timestamp, p_validate_resp = hiddenState.p_validate_resp, p_valreq_id = hiddenState.p_valreq_id, p_order_trans_id = hiddenState.p_order_trans_id, p_ocfg_order_no = hiddenState.p_ocfg_order_no;
	                        isLift = mode === _useOrderTicket.MODES.ORDER_Z;
	                        isCounterDisallowed = orderInfo && orderInfo.countersAllowed === 'N';
	                        params = (0, _twd.cleanObject)({
	                            // user-entered
	                            p_acct_no: acctNo,
	                            p_action: isTreasuryAuction ? 'B' : action,
	                            p_cusip: cusip,
	                            p_qty_bond: qty,
	                            p_price: isTreasuryAuction ? null : isCounterDisallowed ? bestPrice : price,
	                            p_yield: isTreasuryAuction ? null : isCounterDisallowed ? bestYield : yld,
	                            p_price_type: isTreasuryAuction ? 'A' : priceOrYield,
	                            p_misc4: isCalc || attested ? 'Y' : '',
	
	                            // from hidden-states
	                            p_dd: p_dd,
	                            p_dealer_code: p_dealer_code,
	                            p_discount_init: p_discount_init,
	                            p_exec_type: p_exec_type,
	                            p_id: p_id,
	                            p_mm: p_mm,
	                            p_ocfg_order_no: isLift ? '' : p_ocfg_order_no,
	                            p_old_dlr_price: p_old_dlr_price,
	                            p_order_trans_id: p_order_trans_id,
	                            p_order_type: isTreasuryAuction ? 'A' : p_order_type,
	                            p_price_init: isLift ? price : p_price_init,
	                            p_seeded: isTreasuryAuction ? 1 : p_seeded,
	                            p_settlement: p_settlement,
	                            p_settlement_init: p_settlement_init,
	                            p_timestamp: p_timestamp,
	                            p_trade_type: p_trade_type,
	                            p_validated: statusMsg && statusMsg.toLowerCase().indexOf('click preview to continue') >= 0 ? 'Y' : p_validated,
	                            p_validate_resp: p_validate_resp,
	                            p_valreq_id: p_valreq_id,
	                            p_warning: p_warning,
	                            p_wrap_acct: p_wrap_acct,
	                            p_yield_init: p_yield_init,
	                            p_yy: p_yy,
	
	                            // from origin actionSubset_, sourceOrderNo_
	                            p_action_subset: actionSubset_,
	                            p_source_order_no: sourceOrderNo_,
	                            p_source_action: sourceAction_,
	
	                            // p_alloc_id: '',
	                            // p_broker_text: '',
	                            // p_called_from: '',
	                            // p_dtc: '',
	                            // p_execbroker: '',
	                            // p_javascript: '',
	                            // p_limittext: '',
	                            // p_markup_quantity: '',
	                            // p_max_bid_sc: '',
	                            // p_miscdata: '',
	                            // p_order_xref: '',
	                            // p_ovalcdata: '',
	                            // p_price_change_ind: '',
	                            // p_settlement_ent_val: '',
	                            // p_ticket_source: '',
	
	                            p_output_format: 'JSON',
	                            p_transdata: 'ETRADENOE(Y)',
	                            p_submit: 'Preview Order'
	                        });
	                        _context.prev = 8;
	                        _context.next = 11;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/trades/orderInput',
	                            method: 'POST',
	                            headers_: {
	                                'Content-Type': 'text/plain'
	                            },
	                            body: (0, _twd.toQueryString)(params).replace('%20', '+'),
	                            type: 'text'
	                        });
	
	                    case 11:
	                        _ref3 = _context.sent;
	                        order_ = _ref3.data;
	                        _context.t0 = eval;
	                        _context.next = 16;
	                        return order_;
	
	                    case 16:
	                        _context.t1 = _context.sent;
	                        info = (0, _context.t0)(_context.t1);
	
	                        if (!isCalc) {
	                            _context.next = 20;
	                            break;
	                        }
	
	                        return _context.abrupt('return', info);
	
	                    case 20:
	
	                        info.executionType = info.primary === 'Y' ? 'Firm' : info.executionType;
	
	                        if (info.statusMsg) {
	                            info.statusMsg = info.statusMsg.replace('Click Save & Preview or Save & Enter Another Account', 'Click Preview');
	                        }
	
	                        if (info.hiddenState && info.statusMsg && info.statusMsg.toLowerCase().indexOf('click preview to continue') >= 0) {
	                            Object.assign(hiddenState, info.hiddenState);
	                            info.status = 'Alert';
	                            setHiddenState(Object.assign({}, hiddenState));
	                        }
	
	                        return _context.abrupt('return', setOrderInfo(info));
	
	                    case 26:
	                        _context.prev = 26;
	                        _context.t2 = _context['catch'](8);
	
	                        Object.assign(orderInfo, {
	                            status: 'Fail',
	                            statusMsg: 'ERROR: There was an error processing your request.'
	                        });
	                        console.error('use-order-ticket-preview', _context.t2);
	
	                    case 30:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[8, 26]]);
	    }));
	
	    return function preview(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.reset = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderTicket = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var lastAbortAjax = null;
	
	var reset = exports.reset = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref) {
	        var action = _ref.action,
	            acctNo = _ref.acctNo,
	            cusip = _ref.cusip,
	            qty = _ref.qty,
	            priceOrYield = _ref.priceOrYield,
	            price = _ref.price,
	            yld = _ref.yld,
	            mode = _ref.mode,
	            sourceAction_ = _ref.sourceAction_,
	            sourceOrderNo_ = _ref.sourceOrderNo_,
	            setPrice = _ref.setPrice,
	            setYld = _ref.setYld,
	            setBestPrice = _ref.setBestPrice,
	            setBestYield = _ref.setBestYield,
	            setOrderInfoStatus = _ref.setOrderInfoStatus,
	            setOrderInfo = _ref.setOrderInfo,
	            setHiddenState = _ref.setHiddenState,
	            setErrors = _ref.setErrors,
	            callback = _ref.callback,
	            isPreview = _ref.isPreview,
	            isTreasuryAuction = _ref.isTreasuryAuction;
	
	        var params, _ref3, order_, abort_, info, isLift, isAbort;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        if (!(!cusip || !action || !acctNo)) {
	                            _context.next = 7;
	                            break;
	                        }
	
	                        setOrderInfo({});
	                        setHiddenState({});
	                        setOrderInfoStatus(_twd.Status.LOADED);
	                        setErrors({});
	                        if (callback) {
	                            callback({});
	                        }
	                        return _context.abrupt('return');
	
	                    case 7:
	                        _context.prev = 7;
	
	                        if (lastAbortAjax) {
	                            lastAbortAjax();
	                        }
	
	                        setErrors({});
	                        setOrderInfoStatus(_twd.Status.LOADING);
	
	                        params = (0, _twd.cleanObject)({
	                            p_acct_no: acctNo,
	                            p_action: action,
	                            p_cusip: cusip,
	                            p_qty_bond: qty,
	                            p_output_format: 'JSON',
	                            p_source_action: isTreasuryAuction ? 'A' : sourceAction_,
	                            p_source_order_no: sourceOrderNo_
	                        });
	                        _context.next = 14;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/trades/orderOutput',
	                            method: 'POST',
	                            headers_: {
	                                'Content-Type': 'application/x-www-form-urlencoded'
	                            },
	                            body: (0, _twd.toQueryString)(params),
	                            type: 'text'
	                        });
	
	                    case 14:
	                        _ref3 = _context.sent;
	                        order_ = _ref3.data;
	                        abort_ = _ref3.abort;
	
	
	                        lastAbortAjax = abort_;
	
	                        _context.t0 = _twd.evalJson;
	                        _context.next = 21;
	                        return order_;
	
	                    case 21:
	                        _context.t1 = _context.sent;
	                        _context.t2 = {};
	                        info = (0, _context.t0)(_context.t1, _context.t2);
	
	                        if (!isPreview) {
	                            _context.next = 27;
	                            break;
	                        }
	
	                        setOrderInfoStatus(_twd.Status.LOADED);
	                        return _context.abrupt('return', info);
	
	                    case 27:
	                        isLift = mode === _useOrderTicket.MODES.ORDER_Z;
	
	                        info.netMoney = null;
	                        info.sugg_comm_in_dlrs_per_tckt = null;
	
	                        setOrderInfo(info);
	                        setHiddenState(Object.assign({}, info.hiddenState));
	
	                        if (isTreasuryAuction) {
	                            info.qty_max = 10000;
	                        }
	                        if ((0, _twd.isEmpty)(price) && !(0, _twd.isEmpty)(info.price) && priceOrYield === 1) {
	                            setPrice(info.price);
	                        }
	                        if ((0, _twd.isEmpty)(yld) && !(0, _twd.isEmpty)(info.yield) && (priceOrYield === 0 || isLift)) {
	                            setYld(info.yield);
	                        }
	                        if (!(0, _twd.isEmpty)(info.price)) {
	                            setBestPrice(info.price);
	                        }
	                        if (!(0, _twd.isEmpty)(info.yield)) {
	                            setBestYield(info.yield);
	                        }
	
	                        setOrderInfoStatus(_twd.Status.LOADED);
	
	                        if (callback) {
	                            callback(info);
	                        }
	
	                        _context.next = 47;
	                        break;
	
	                    case 41:
	                        _context.prev = 41;
	                        _context.t3 = _context['catch'](7);
	                        isAbort = _context.t3.toString().indexOf('AbortError') >= 0;
	
	                        if (!isAbort) {
	                            console.error('use-order-ticket-reset', _context.t3);
	                            setOrderInfoStatus(_twd.Status.FAILED_TO_LOAD);
	                        }
	                        setOrderInfo({});
	
	                        if (callback) {
	                            callback({});
	                        }
	
	                    case 47:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[7, 41]]);
	    }));
	
	    return function reset(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.resetLastPositionsInfo = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _twd.getState)('order-ticket-positions.last', {
	    ts: 0,
	    positions: [],
	    positionsCount: 0,
	    positionsStatus: _twd.Status.NULL
	});
	
	var resetLastPositionsInfo = exports.resetLastPositionsInfo = function resetLastPositionsInfo() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$ts = _ref.ts,
	        ts = _ref$ts === undefined ? 0 : _ref$ts;
	
	    Last.reset();
	    Last.set({
	        ts: ts,
	        positions: [],
	        positionsCount: 0,
	        positionsStatus: _twd.Status.NULL
	    });
	};
	
	exports.default = function (_ref2) {
	    var acctNo = _ref2.acctNo,
	        cusip = _ref2.cusip,
	        ts = _ref2.ts;
	
	    var _React$useState = _react2.default.useState(Last.value.positions || []),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        positions = _React$useState2[0],
	        setPositions_ = _React$useState2[1];
	
	    var setPositions = _react2.default.useCallback(function (positions) {
	        Last.set({ positions: positions });
	        setPositions_(positions);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState(Last.value.positionsCount || 0),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        positionsCount = _React$useState4[0],
	        setPositionsCount_ = _React$useState4[1];
	
	    var setPositionsCount = _react2.default.useCallback(function (positionsCount) {
	        Last.set({ positionsCount: positionsCount });
	        setPositionsCount_(positionsCount);
	    }, []);
	
	    var _React$useState5 = _react2.default.useState(Last.value.positionsStatus || _twd.Status.NULL),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        positionsStatus = _React$useState6[0],
	        setPositionsStatus_ = _React$useState6[1];
	
	    var setPositionsStatus = _react2.default.useCallback(function (positionsStatus) {
	        Last.set({ positionsStatus: positionsStatus });
	        setPositionsStatus_(positionsStatus);
	    }, []);
	
	    var lastAbort = _react2.default.useRef();
	
	    var _React$useState7 = _react2.default.useState(null),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        positionsAcctNo = _React$useState8[0],
	        setPositionsAcctNo = _React$useState8[1];
	
	    var updatePositions = function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee(_ref3) {
	            var acctNo = _ref3.acctNo,
	                isReset = _ref3.isReset;
	
	            var _ref5, data_, abort_, data, ps;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(!isReset && positionsAcctNo && positionsAcctNo === acctNo)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	
	                            setPositionsAcctNo(acctNo);
	                            setPositionsCount(0);
	
	                            if (acctNo) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            setPositionsStatus(_twd.Status.NULL);
	                            return _context.abrupt('return');
	
	                        case 8:
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            setPositionsStatus(_twd.Status.LOADING);
	
	                            _context.next = 12;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/trades/holdings',
	                                type: 'text',
	                                method: 'POST',
	                                params: { p_acct_no: acctNo }
	                            });
	
	                        case 12:
	                            _ref5 = _context.sent;
	                            data_ = _ref5.data;
	                            abort_ = _ref5.abort;
	
	
	                            lastAbort.current = abort_;
	                            _context.t0 = _twd.evalJson;
	                            _context.next = 19;
	                            return data_;
	
	                        case 19:
	                            _context.t1 = _context.sent;
	                            _context.t2 = {
	                                position: global.app.config.holdings.filter(function (_ref6) {
	                                    var acctNo_ = _ref6.acctNo;
	                                    return acctNo_ === acctNo;
	                                })
	                            };
	                            data = (0, _context.t0)(_context.t1, _context.t2);
	                            ps = (0, _twd.arrayFrom)(data.position).filter(function (_ref7) {
	                                var maturity = _ref7.maturity;
	
	                                var isMatured = (0, _twd.parseDate)(maturity) < Date.now();
	                                return !isMatured;
	                            }).sort((0, _twd.sortFn)(function (_ref8) {
	                                var issue = _ref8.issue;
	                                return (issue || '').trim();
	                            }));
	
	
	                            setPositions(ps);
	                            setPositionsCount(ps.length);
	                            setPositionsStatus(_twd.Status.LOADED);
	
	                            _context.next = 33;
	                            break;
	
	                        case 28:
	                            _context.prev = 28;
	                            _context.t3 = _context['catch'](2);
	
	
	                            setPositions([]);
	                            setPositionsCount(0);
	                            setPositionsStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 33:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 28]]);
	        }));
	
	        return function updatePositions(_x2) {
	            return _ref4.apply(this, arguments);
	        };
	    }();
	
	    var _React$useState9 = _react2.default.useState(0),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        positionsTotalQty = _React$useState10[0],
	        setPositionsTotalQty = _React$useState10[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var v;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            try {
	                                v = positions.filter(function (_ref10) {
	                                    var cusip_ = _ref10.cusip;
	                                    return cusip === cusip_;
	                                }).reduce(function (x, _ref11) {
	                                    var qty = _ref11.qty;
	                                    return x + (0, _twd.numberFrom)(qty, 0);
	                                }, 0);
	
	                                setPositionsTotalQty(v);
	                            } catch (e) {
	                                setPositionsTotalQty(0);
	                            }
	
	                        case 1:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined);
	        }))();
	    }, [positions, cusip]);
	
	    var reset = function reset() {
	        Last.reset();
	        setPositionsAcctNo(null);
	        setPositions([]);
	        setPositionsCount(0);
	        setPositionsStatus(_twd.Status.NULL);
	    };
	
	    return {
	        positions: positions,
	        positionsCount: positionsCount,
	        positionsStatus: positionsStatus,
	        positionsTotalQty: positionsTotalQty,
	        updatePositions: updatePositions,
	        reset: reset
	    };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState({}),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        errors = _React$useState2[0],
	        setErrors = _React$useState2[1];
	
	    var validate = function validate(_ref) {
	        var cusip = _ref.cusip,
	            action = _ref.action,
	            isRfq = _ref.isRfq,
	            qty = _ref.qty,
	            price = _ref.price,
	            yld = _ref.yld,
	            priceOrYield = _ref.priceOrYield,
	            orderInfoStatus = _ref.orderInfoStatus,
	            isChangeToRfq = _ref.isChangeToRfq,
	            hasMarket = _ref.hasMarket,
	            isRestricted = _ref.isRestricted,
	            isTreasuryAuction = _ref.isTreasuryAuction,
	            isSkipErrors = _ref.isSkipErrors;
	
	        if (!isSkipErrors && orderInfoStatus !== _twd.Status.LOADED) {
	            setErrors({});
	            return true;
	        }
	
	        var errs = {};
	
	        if (!(0, _twd.isCusip)(cusip)) {
	            errs.cusip = isRfq ? "Please enter a valid CUSIP" : "Please enter a valid CUSIP, symbol or company name";
	        }
	
	        if (!action) {
	            errs.action = "Please select an action";
	        }
	
	        var q = parseFloat(qty);
	        if (!isRestricted && (isNaN(q) || q <= 0)) {
	            errs.qty = "Please enter a quantity";
	        }
	
	        if (!isTreasuryAuction) {
	            var rfq = isRfq || isChangeToRfq || !hasMarket;
	            var p = parseFloat(price);
	            if (!rfq && priceOrYield === 1 && (isNaN(p) || p <= 0)) {
	                errs.price = "Please enter a price";
	            }
	
	            var y = parseFloat(yld);
	            if (!rfq && priceOrYield === 0 && isNaN(y)) {
	                errs.yld = "Please enter a yield";
	            }
	        }
	
	        if (!isSkipErrors) {
	            setErrors(errs);
	        }
	
	        return Object.keys(errs).length === 0;
	    };
	
	    var reset = function reset() {
	        setErrors({});
	    };
	
	    return {
	        errors: errors, setErrors: setErrors,
	        validate: validate,
	        reset: reset
	    };
	};

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Accounts = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _form = __webpack_require__(1068);
	
	var _twd = __webpack_require__(2);
	
	var _errorBoundary = __webpack_require__(476);
	
	var _useOrders2 = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	var Accounts = exports.Accounts = function Accounts() {
	    var _useOrders = (0, _useOrders2.useOrders)(),
	        accounts = _useOrders.accounts,
	        setAccounts = _useOrders.setAccounts,
	        setAccountsRef = _useOrders.setAccountsRef;
	
	    return _react2.default.createElement(
	        _errorBoundary.ErrorBoundary,
	        null,
	        _react2.default.createElement(_formik.Formik, {
	            ref: setAccountsRef,
	
	            initialValues: {
	                accounts: [].concat(_toConsumableArray((0, _twd.isEmpty)(accounts) ? (0, _useOrders2.allAccounts)() : accounts))
	            },
	            enableReinitialize: true,
	
	            onSubmit: function onSubmit(values) {
	                var curr = (0, _twd.isEmpty)(accounts) ? (0, _useOrders2.allAccounts)() : accounts.sort();
	                var accts = (0, _twd.arrayFrom)(values.accounts).sort();
	                if ((0, _twd.isEquals)(accts, curr)) return;
	                setAccounts(accts);
	            },
	
	            component: _form.Form,
	            validateOnBlur: true,
	            validateOnChange: true,
	            validate: function validate(values) {
	                var accounts = (0, _twd.arrayFrom)(values.accounts);
	                var errors = (0, _twd.cleanObject)({
	                    accounts: accounts.length > 0 ? null : 'Please select at least 1 account'
	                });
	
	                (0, _twd.publish)('orders_accounts_changed', { accounts: accounts });
	                return errors;
	            }
	        })
	    );
	};

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Form = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _useOrders = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Form = exports.Form = function Form(_ref) {
	    var handleSubmit = _ref.handleSubmit,
	        errors = _ref.errors;
	
	
	    var hasAccount = (0, _useOrders.getAccounts)().length > 0;
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        btnEl = _React$useState2[0],
	        setBtnEl = _React$useState2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: "col-md-5" },
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(_formik.FieldArray, {
	                                name: 'accounts',
	                                disabled: !hasAccount,
	                                render: function render(args) {
	                                    return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({
	                                        dataName: 'orders-accounts',
	                                        label: 'Select one or more accounts',
	
	                                        emptyText: '',
	                                        error: errors.accounts,
	
	                                        showSelectAll: hasAccount,
	                                        allText: 'All accounts selected',
	                                        options: (0, _useOrders.getAccounts)().map(function (a) {
	                                            return { label: a.title, value: a.acctNo };
	                                        }),
	                                        style: { marginBottom: '0px' },
	                                        optionCheckboxLabelConfig: {
	                                            className: "text-truncate"
	                                        },
	
	                                        placeholder: function placeholder(_ref2) {
	                                            var emptyText = _ref2.emptyText,
	                                                allText = _ref2.allText,
	                                                values = _ref2.values,
	                                                options = _ref2.options;
	
	                                            var isNone = (0, _twd.isEmpty)(values);
	                                            if (isNone) return emptyText;
	
	                                            var isAll = values.length > 0 && values.length === options.length;
	                                            if (isAll) return allText;
	
	                                            var selected = options.filter(function (a) {
	                                                return values.indexOf(a.value) >= 0;
	                                            });
	
	                                            var n = selected.length;
	                                            if (n === 0) return emptyText;
	
	                                            return n + ' of ' + options.length + ' accounts selected';
	                                        },
	
	                                        onBlur: function onBlur() {
	                                            if (errors.accounts || !btnEl) return;
	                                            btnEl.click();
	                                        }
	
	                                    }, args));
	                                }
	                            }),
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'field-status has-error' },
	                                errors.accounts
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'button',
	                            { ref: setBtnEl, type: 'submit', name: 'ts', style: { display: 'none' } },
	                            'Change Account'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Body = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _formatStatus = __webpack_require__(1070);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Body = exports.Body = function Body(_ref) {
	    var rows = _ref.rows,
	        shown = _ref.shown,
	        setShown = _ref.setShown;
	
	
	    return _react2.default.createElement(
	        'tbody',
	        null,
	        rows.map(function (r, i) {
	            var isAuction = String(r.propTransNetMoneyStr).toLowerCase() === 'auction';
	
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                { key: 'orders-blotter-' + i },
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        r.tradeNum
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'text-center' },
	                        formatTradeActions(r)
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        r.tradeStatus
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { style: { whiteSpace: 'nowrap' } },
	                        formatDateTime(r.tradeSubmitDateAts) || r.tradeSubmitDate
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        formatTradeType(r)
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        _twd.fmt.qty(r.tradeQtyBond)
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _twd.fmt.issuer({
	                                issuer: r.holdIssue,
	                                cusip: (0, _twd.arrayFrom)(r.holdCusip).join(''),
	                                showBondDetail: 'Y',
	                                isTreasuryAuction: isAuction,
	                                from: 'orders'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement('label', { className: 'label-small',
	                                style: { whiteSpace: 'normal' },
	                                dangerouslySetInnerHTML: { __html: _twd.fmt.warningText(r.holdWarningText) }
	                            })
	                        ),
	                        ['A', 'C', 'M'].indexOf(r.holdInvType.join('')) >= 0 ? _react2.default.createElement(
	                            'button',
	                            {
	                                'data-name': 'trade-history-link',
	                                className: 'btn-link',
	                                onClick: function onClick(e) {
	                                    (0, _twd.showModal)({
	                                        view: 'trade-history',
	                                        cusip: r.holdCusip,
	                                        source: e.target
	                                    });
	                                }
	                            },
	                            'Trade history'
	                        ) : null
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        r.holdCusip
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            formatCoupon(r)
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            r.holdMaturity
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        isAuction ? 'Auction' : _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _twd.fmt.price3N(r.tradeFilledPx)
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                _twd.fmt.ytw3(r.tradeFilledYtw)
	                            ),
	                            r.tradeFilledDiscount ? _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    _twd.fmt.ytw3(r.tradeFilledDiscount),
	                                    '\xA0(',
	                                    r.holdYieldInd,
	                                    ')'
	                                )
	                            ) : null
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'text-nowrap' },
	                        r.acctNo
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        r.tradeSubmitByName
	                    ),
	                    _react2.default.createElement(
	                        'td',
	                        { className: 'text-right' },
	                        isAuction ? 'Auction' : _twd.fmt.money(r.propTransNetMoney)
	                    )
	                ),
	                (0, _formatStatus.formatStatus)(Object.assign({ rec: r }, r, { shown: shown, setShown: setShown }))
	            );
	        })
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var formatDateTime = function formatDateTime(ts) {
	    if (!ts) return null;
	    var dt = new Date(ts);
	    if (isNaN(dt)) return null;
	
	    var tm = (0, _twd.getServerTime)(dt);
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            null,
	            _twd.fmt.mdy(tm)
	        ),
	        _react2.default.createElement(
	            'div',
	            null,
	            _twd.fmt.fmtDt(tm, 'hh:mm:ss a').toLowerCase()
	        )
	    );
	};
	
	var formatTradeActions = function formatTradeActions(_ref2) {
	    var tradeActions = _ref2.tradeActions,
	        orderNo = _ref2.tradeNum;
	
	    var acts = tradeActions.split(',');
	    var action = acts.indexOf('cancel') >= 0 ? 'Cancel' : 'View';
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'trade-detail-button',
	            className: 'btn-link',
	            onClick: function onClick(e) {
	                (0, _twd.showModal)({
	                    view: 'order-detail',
	                    action: action.toLowerCase(),
	                    orderNo: orderNo,
	                    source: e.target
	                });
	            }
	        },
	        action
	    );
	};
	
	var tradeTypeMap = {
	    'Offer-W': { label: 'Offer Quote Request', color: 'green' },
	    'Buy': { color: 'green' },
	    'Bid-W': { label: 'Bid Quote Request', color: 'red' },
	    'Sell': { color: 'red' }
	};
	
	var formatTradeType = function formatTradeType(_ref3) {
	    var tradeType = _ref3.tradeType;
	
	    var a = tradeTypeMap[tradeType] || { color: '#242424' };
	    return _react2.default.createElement(
	        'span',
	        { style: { color: a.color } },
	        a.label || tradeType
	    );
	};
	
	var formatCoupon = function formatCoupon(_ref4) {
	    var holdCoupon = _ref4.holdCoupon,
	        holdCouponTypeCode = _ref4.holdCouponTypeCode,
	        holdCouponFixedToFloat = _ref4.holdCouponFixedToFloat;
	
	    var isFLT = holdCouponTypeCode === 'E';
	    var isF2F = holdCouponFixedToFloat === 'Y';
	
	    if (isFLT) {
	        return !isF2F ? 'FLT' : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _twd.fmt.cpn(holdCoupon),
	            ' F2F'
	        );
	    }
	    return _twd.fmt.cpn(holdCoupon);
	};

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formatStatus = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-use-before-define */
	
	
	var formatStatus = exports.formatStatus = function formatStatus(_ref) {
	    var orderNo = _ref.tradeNum,
	        shown = _ref.shown,
	        setShown = _ref.setShown,
	        rec = _ref.rec;
	
	
	    var rs = (0, _twd.arrayFrom)(rec.tradeExecStatus).filter(Boolean);
	
	    if (rs.length < 1) {
	        return _react2.default.createElement('tr', { style: { display: 'none' } });
	    }
	
	    var isShown = shown[orderNo];
	    if (!isShown) {
	        rs = rs.slice(0, 1);
	    }
	
	    return _react2.default.createElement(
	        'tr',
	        null,
	        _react2.default.createElement(
	            'td',
	            { className: 'text-center', style: { verticalAlign: "top" } },
	            formatExpandButton({ rec: rec, orderNo: orderNo, shown: shown, setShown: setShown })
	        ),
	        _react2.default.createElement(
	            'td',
	            { colSpan: 13, style: { verticalAlign: "top" } },
	            rs.map(function (r, i) {
	                return _react2.default.createElement(
	                    'div',
	                    { key: i },
	                    formatStatusActionButton(Object.assign({}, rec, {
	                        action: r.action,
	                        qty: r.qty || rec.tradeQtyBond,
	                        orderNo: orderNo,
	                        quoteId: r.quoteId,
	                        yld: r.yield,
	                        price: r.price
	                    })),
	                    formatStatusNotes(r)
	                );
	            })
	        )
	    );
	};
	
	var formatStatusActionButton = function formatStatusActionButton(_ref2) {
	    var holdCusip = _ref2.holdCusip,
	        acctNo = _ref2.acctNo,
	        action = _ref2.action,
	        price = _ref2.price,
	        qty = _ref2.qty,
	        yld = _ref2.yld,
	        orderNo = _ref2.orderNo,
	        quoteId = _ref2.quoteId;
	
	    var isNote = String(action).toLowerCase().indexOf('accept') === 0;
	
	    switch (action) {
	        case 'accept':
	        case 'accept-buy':
	        case 'accept-sell':
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'orders-blotter-action-button',
	                        className: 'btn btn-sm btn-primary',
	                        style: { width: '65px' },
	                        onClick: function onClick(e) {
	                            return (0, _twd.showModal)({
	                                view: 'order-detail',
	                                action: action,
	                                orderNo: orderNo,
	                                isNote: isNote,
	                                source: e.target
	                            });
	                        }
	                    },
	                    'Accept'
	                ),
	                _react2.default.createElement(Sep, null)
	            );
	
	        case 'buy':
	        case 'limitbuy':
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'orders-blotter-action-button',
	                        className: 'btn btn-sm btn-primary',
	                        style: { width: '65px' },
	                        onClick: function onClick() {
	                            return (0, _twd.showBondOrder)({
	                                action: 'B',
	                                cusip: holdCusip[0],
	                                acctNo: acctNo[0],
	                                from: 'orders',
	                                qty: qty,
	                                price: price,
	                                yld: yld,
	                                executionType: action === 'limitbuy' ? 'Limit' : 'Firm',
	                                sourceAction: 'Z',
	                                sourceOrderNo: orderNo + '|' + (quoteId || '')
	                            });
	                        }
	                    },
	                    'Buy'
	                ),
	                _react2.default.createElement(Sep, null)
	            );
	
	        case 'sell':
	        case 'limitsell':
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'orders-blotter-action-button',
	                        className: 'btn btn-sm btn-primary',
	                        style: { width: '65px' },
	                        onClick: function onClick() {
	                            return (0, _twd.showBondOrder)({
	                                action: 'S',
	                                cusip: holdCusip[0],
	                                acctNo: acctNo[0],
	                                from: 'orders',
	                                qty: qty,
	                                price: price,
	                                yld: yld,
	                                executionType: action === 'limitsell' ? 'Limit' : 'Firm',
	                                sourceAction: 'Y',
	                                sourceOrderNo: orderNo + '|' + (quoteId || '')
	                            });
	                        }
	                    },
	                    'Sell'
	                ),
	                _react2.default.createElement(Sep, null)
	            );
	
	        default:
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement('span', { 'aria-hidden': true, style: { padding: '0 0 0 70px' } })
	            );
	    }
	};
	
	var formatExpandButton = function formatExpandButton(_ref3) {
	    var orderNo = _ref3.orderNo,
	        shown = _ref3.shown,
	        setShown = _ref3.setShown,
	        rec = _ref3.rec;
	
	
	    if ((0, _twd.arrayFrom)(rec.tradeExecStatus).length < 2) {
	        return null;
	    }
	
	    var isShown = shown[orderNo];
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'orders-blotter-expand-button',
	            className: 'btn-link',
	            'data-order-no': orderNo,
	            onClick: function onClick() {
	                setShown(Object.assign({}, shown, _defineProperty({}, orderNo, !!!isShown)));
	            }
	        },
	        isShown ? _twd.icons.minus : _twd.icons.plus
	    );
	};
	
	var Sep = function Sep() {
	    return _react2.default.createElement('span', { 'aria-hidden': true, style: { padding: '0 0 0 5px' } });
	};
	
	var formatStatusNotes = function formatStatusNotes(_ref4) {
	    var execId = _ref4.execId,
	        status = _ref4.status,
	        text = _ref4.text,
	        time = _ref4.time,
	        price = _ref4.price,
	        yield_ = _ref4.yield,
	        bestOf = _ref4.bestOf,
	        passes = _ref4.passes,
	        commission = _ref4.commission;
	
	
	    switch (status) {
	        case 'Bid':
	        case 'Offer':
	        case 'Executed':
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { 'data-exec-id': execId },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        status
	                    ),
	                    ': ',
	                    time,
	                    (0, _twd.isNumeric)(price) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(Sep, null),
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Price'
	                        ),
	                        ': ',
	                        _twd.format.price3N(price)
	                    ),
	                    (0, _twd.isNumeric)(yield_) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(Sep, null),
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Yield'
	                        ),
	                        ': ',
	                        _twd.format.ytw3(yield_)
	                    ),
	                    !(0, _twd.isEmpty)(commission) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(Sep, null),
	                        formatText(commission)
	                    ),
	                    !(0, _twd.isEmpty)(text) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(Sep, null),
	                        formatText(updateExpireText(text))
	                    ),
	                    (0, _twd.isNumeric)(bestOf) && (0, _twd.isNumeric)(passes) && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        ' (Best of ' + bestOf + ', ' + passes + ' Passes)'
	                    )
	                )
	            );
	        case null:
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { 'data-exec-id': execId },
	                    formatText(text)
	                )
	            );
	        default:
	            return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _react2.default.createElement(
	                    'span',
	                    { 'data-exec-id': execId },
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        status
	                    ),
	                    ': ',
	                    time,
	                    text && _react2.default.createElement(
	                        _react2.default.Fragment,
	                        null,
	                        _react2.default.createElement(Sep, null),
	                        _react2.default.createElement(
	                            'b',
	                            null,
	                            'Text'
	                        ),
	                        ': ',
	                        formatText(text)
	                    )
	                )
	            );
	    }
	};
	
	var updateExpireText = function updateExpireText(text) {
	    return (text || '').replace('Expires', '<b>Expires:</b>').replace('Expired', '<b>Expired:</b>');
	};
	
	var formatText = function formatText(html) {
	    return _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: html } });
	};

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Grid = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _head = __webpack_require__(1072);
	
	var _body = __webpack_require__(1069);
	
	var _more = __webpack_require__(1073);
	
	var _useOrders2 = __webpack_require__(119);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Grid = exports.Grid = function Grid(args) {
	    var _useOrders = (0, _useOrders2.useOrders)(),
	        rows = _useOrders.rows,
	        status = _useOrders.status,
	        onLoadMore = _useOrders.onLoadMore,
	        count = _useOrders.count,
	        shown = _useOrders.shown,
	        setShown = _useOrders.setShown;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        status === _twd.Status.LOADED && rows.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'table-responsive' },
	            _react2.default.createElement(
	                'table',
	                {
	                    'data-name': 'orders-table',
	                    className: 'table table-striped align-top'
	                },
	                _react2.default.createElement(_head.Head, null),
	                _react2.default.createElement(_body.Body, { rows: rows, shown: shown, setShown: setShown })
	            )
	        ),
	        _react2.default.createElement(_more.More, {
	            rows: rows,
	            status: status,
	            count: count,
	            onLoadMore: onLoadMore
	        })
	    );
	};

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Head = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Head = exports.Head = function Head() {
	    return _react2.default.createElement(
	        "thead",
	        null,
	        _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "Order"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body text-center", style: { width: '70px' } },
	                "Action"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "Status"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "Time (ET)"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "Trans"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "Qty"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body", style: { maxWidth: '250px' } },
	                "Issue"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "CUSIP"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "Coupon/"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "Maturity"
	                )
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body text-right" },
	                "Price/Yield"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "Acct No"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body" },
	                "Contact"
	            ),
	            _react2.default.createElement(
	                "th",
	                { className: "text-body text-right" },
	                "Net Money"
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.More = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrders = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var More = exports.More = function More() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        rows = _ref.rows,
	        status = _ref.status,
	        count = _ref.count,
	        onLoadMore = _ref.onLoadMore,
	        _ref$pageSize = _ref.pageSize,
	        pageSize = _ref$pageSize === undefined ? _useOrders.PAGESIZE : _ref$pageSize;
	
	    var moreCount = Math.min(pageSize, count - rows.length);
	
	    return _react2.default.createElement(
	        _twd.Loading,
	        { status: status },
	        rows.length ? _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-3 text-bold' },
	                moreCount > 0 ? _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    '1 - ',
	                    _twd.format.count(rows.length),
	                    ' of ',
	                    _twd.format.count(count)
	                ) : _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    _twd.format.count(count)
	                ),
	                ' ',
	                'Order' + (count > 1 ? 's' : '')
	            ),
	            moreCount > 0 ? _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-sm-6' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'offerings-view-more',
	                        onClick: onLoadMore,
	                        className: 'btn btn-primary btn-block'
	                    },
	                    'View ',
	                    _twd.format.count(moreCount),
	                    ' more'
	                )
	            ) : null
	        ) : _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 text-center' },
	            _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'small-header' },
	                'There are no orders that match the dates and filters above'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Please select another date range and/or try different filters. You can also ',
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'orders-reset-all-filters',
	                        className: 'btn-label link-button',
	                        onClick: function onClick() {
	                            (0, _twd.publish)('orders_reset_filters', { isApply: true });
	                        }
	                    },
	                    'reset all filters'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(64);
	
	var _header = __webpack_require__(1076);
	
	var _detail2 = __webpack_require__(1075);
	
	var _style = __webpack_require__(326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Last = (0, _all.getState)('orders-confirm.last', {
	    detail: {}
	});
	
	exports.default = function (_ref) {
	    var orderNo = _ref.orderNo,
	        action = _ref.action,
	        acctNo = _ref.acctNo,
	        cusip = _ref.cusip,
	        note = _ref.note,
	        backFrom = _ref.backFrom;
	
	    var _React$useState = _react2.default.useState({}),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        detail = _React$useState2[0],
	        setDetail = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(_all.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        if (backFrom) {
	            setDetail(Last.value.detail);
	            setStatus(_all.Status.LOADED);
	            return;
	        }
	
	        ;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var postPowerPurchasing, p_action, params, _ref3, actionData, _data, _ref4, data, _detail;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            postPowerPurchasing = void 0;
	                            p_action = action === 'cancel' ? '4' : action === 'accept' ? 'A' : null;
	
	                            if (!p_action) {
	                                _context.next = 15;
	                                break;
	                            }
	
	                            params = {
	                                p_submit: 'Submit',
	                                p_validated: 'Y',
	                                p_action: p_action,
	                                p_order_no: (0, _all.arrayFrom)(orderNo).join(),
	                                p_cusip: cusip,
	                                p_acct: acctNo || '',
	                                p_text: note || ''
	                            };
	                            _context.next = 7;
	                            return (0, _all.ajax)({
	                                url: '/esb/portfolio/trades/actions',
	                                method: 'POST',
	                                params: params
	                            });
	
	                        case 7:
	                            _ref3 = _context.sent;
	                            actionData = _ref3.data;
	                            _context.next = 11;
	                            return actionData;
	
	                        case 11:
	                            _data = _context.sent;
	
	                            if (!(_data.actionStatus === 'Error')) {
	                                _context.next = 14;
	                                break;
	                            }
	
	                            throw new Error('unable to execute action, ' + JSON.stringify(params));
	
	                        case 14:
	
	                            postPowerPurchasing = _data.postPowerPurchasing;
	
	                        case 15:
	                            _context.next = 17;
	                            return (0, _all.ajax)({
	                                url: '/esb/portfolio/trades/details',
	                                method: 'GET',
	                                isDc: false,
	                                type: 'text',
	                                params: { orderNo: orderNo }
	                            });
	
	                        case 17:
	                            _ref4 = _context.sent;
	                            data = _ref4.data;
	                            _context.t0 = parseDetail;
	                            _context.next = 22;
	                            return data;
	
	                        case 22:
	                            _context.t1 = _context.sent;
	                            _detail = (0, _context.t0)(_context.t1);
	
	
	                            _detail.postPowerPurchasing = postPowerPurchasing;
	
	                            Last.set({ detail: _detail });
	                            setDetail(_detail);
	                            setStatus(_all.Status.LOADED);
	
	                            _context.next = 34;
	                            break;
	
	                        case 30:
	                            _context.prev = 30;
	                            _context.t2 = _context['catch'](0);
	
	                            console.log(_context.t2);
	                            setStatus(_all.Status.FAILED_TO_LOAD);
	
	                        case 34:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 30]]);
	        }))();
	    }, []);
	
	    var isCancel = action === 'cancel';
	    var isAccept = action === 'accept';
	    var title = isCancel ? 'Cancellation request submitted' : isAccept ? 'Order confirmation' : '';
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container orders-confirm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'h1',
	                        null,
	                        title
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _all.Loading,
	            { status: status },
	            _react2.default.createElement(
	                'div',
	                { style: { backgroundColor: "#f6f6f6" } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(_header.Header, { detail: detail, action: action }),
	                    _react2.default.createElement('div', { className: 'vertical-offset-base' })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { css: _style.backgroundColor },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'xs-hide container' },
	                    _react2.default.createElement(_detail2.Detail, { detail: detail, action: action })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'xs-show container' },
	                    _react2.default.createElement(_detail2.DetailMobile, { detail: detail, action: action })
	                )
	            ),
	            _react2.default.createElement('div', { className: 'vertical-offset-base' })
	        )
	    );
	};
	
	var parseDetail = function parseDetail(txt) {
	    var d = (0, _all.evalJson)(txt, { orderDetails: [] }).orderDetails[0];
	    if (!d) return;
	
	    (0, _all.arrayFrom)(d.AccountList).concat((0, _all.arrayFrom)(d.OrderList)).concat((0, _all.arrayFrom)(d.PriceList)).forEach(function (_ref5) {
	        var label = _ref5.label,
	            value = _ref5.value,
	            order = _ref5.order;
	
	        var v = value || order;
	        var n = (0, _all.toCamel)(String(label).trim());
	        d[n] = v;
	    });
	
	    return d;
	};

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Detail = exports.DetailMobile = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(326);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icons = __webpack_require__(1077);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailMobile = exports.DetailMobile = function DetailMobile(_ref) {
	    var detail = _ref.detail,
	        action = _ref.action;
	
	    var isCancel = action === 'cancel';
	    var isConfirm = action === 'confirm';
	
	    var title = isCancel ? 'Your request to cancel this order has been submitted' : isConfirm ? 'Your bonds order has been placed' : '';
	    var status = isCancel ? 'Cancellation request in process' : isConfirm ? 'Open' : '';
	
	    var netMoneyLabel = ['B', 'S'].indexOf(detail.action) >= 0 ? 'Estimated proceeds' : 'Estimated total cost';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'vertical-offset-base' }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12 text-center' },
	                (0, _core.jsx)(
	                    'p',
	                    null,
	                    _icons2.default.ok
	                ),
	                (0, _core.jsx)(
	                    'h2',
	                    null,
	                    title
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12' },
	                (0, _core.jsx)(
	                    'h3',
	                    null,
	                    'Order# ',
	                    detail.orderNo,
	                    ': ',
	                    status
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12' },
	                (0, _core.jsx)(
	                    'div',
	                    null,
	                    _all.format.mdy(new Date())
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    null,
	                    detail.accountNo,
	                    ' ',
	                    (0, _all.parseHtml)(detail.accountName)
	                )
	            )
	        ),
	        (0, _core.jsx)('hr', { 'aria-hidden': true, className: 'vertical-offset-base' }),
	        (0, _core.jsx)(Labeled, { label: 'Action', value: detail.transactionType, style: { color: actionTypeColor(detail.action) } }),
	        (0, _core.jsx)(Labeled, { label: 'Issuer', value: _all.fmt.issuer({
	                issuer: (0, _all.parseHtml)(detail.issue),
	                cusip: (0, _all.arrayFrom)(detail.cusip).join(''),
	                showTradeHistory: 'Y',
	                from: 'order-cancel'
	            }) }),
	        (0, _core.jsx)(Labeled, { label: 'CUSIP', value: detail.cusip }),
	        (0, _core.jsx)(Labeled, { label: 'Quantity', value: _all.fmt.qty(detail.quantity) }),
	        (0, _core.jsx)(Labeled, { label: 'Settlement date', value: detail.settlement }),
	        (0, _core.jsx)(Labeled, { label: 'Status', value: detail.ordStatusDesc || _all.fmt.empty() }),
	        (0, _core.jsx)(Labeled, { label: 'Price', value: (0, _all.isNumeric)(detail.clientPrice) ? '$' + _all.fmt.price3(detail.clientPrice) : _all.fmt.empty() }),
	        (0, _core.jsx)('hr', { 'aria-hidden': true, className: 'vertical-offset-base' }),
	        (0, _core.jsx)(Labeled, { label: 'Principal', value: detail.principal || _all.fmt.empty() }),
	        (0, _core.jsx)(Labeled, { label: 'Accrued interest', value: detail.accruedInterest ? (0, _core.jsx)(
	                _react2.default.Fragment,
	                null,
	                detail.accruedInterest,
	                ' (',
	                detail.accIntDays,
	                ' days)'
	            ) : _all.fmt.empty() }),
	        (0, _core.jsx)(Labeled, { label: 'Commission', value: detail.estCommission || _all.fmt.empty() }),
	        (0, _core.jsx)(Labeled, { label: netMoneyLabel, value: detail.netMoney || _all.fmt.empty() }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-12 text-center' },
	                [isConfirm && (0, _core.jsx)(
	                    _react2.default.Fragment,
	                    { key: 1 },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'cancel-link',
	                            className: 'btn btn-link text-bold',
	                            onClick: function onClick(e) {
	                                (0, _all.showModal)({
	                                    view: 'order-detail',
	                                    action: 'cancel',
	                                    orderNo: detail.orderNo,
	                                    source: e.target
	                                });
	                            }
	                        },
	                        'Cancel'
	                    )
	                ), isCancel && (0, _core.jsx)(
	                    _react2.default.Fragment,
	                    { key: 2 },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'cancel-link',
	                            className: 'btn btn-link text-bold',
	                            onClick: function onClick(e) {
	                                (0, _all.show)('overview');
	                            }
	                        },
	                        'Bond Resource Center'
	                    )
	                ), (0, _core.jsx)(
	                    'a',
	                    { href: '#',
	                        key: 3,
	                        'data-name': 'orders-link',
	                        className: 'btn btn-link text-bold',
	                        onClick: function onClick() {
	                            (0, _all.show)('orders', { backFrom: true, _ts: Date.now() });
	                        }
	                    },
	                    'View orders'
	                ), isConfirm && (0, _core.jsx)(
	                    _react2.default.Fragment,
	                    { key: 4 },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'orders-link',
	                            className: 'btn btn-link text-bold',
	                            onClick: function onClick(e) {
	                                (0, _all.showModal)({
	                                    view: 'holdings',
	                                    acctNo: detail.accountNo,
	                                    source: e.target
	                                });
	                            }
	                        },
	                        'View portfolio'
	                    )
	                )].filter(Boolean).flatMap(function (a, i) {
	                    return [a, (0, _core.jsx)(Sep, { key: i })];
	                }).slice(0, -1)
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var Labeled = function Labeled(_ref2) {
	    var label = _ref2.label,
	        value = _ref2.value,
	        _ref2$style = _ref2.style,
	        style = _ref2$style === undefined ? {} : _ref2$style;
	
	    return (0, _core.jsx)(
	        'div',
	        { className: 'row vertical-offset-base' },
	        (0, _core.jsx)(
	            'div',
	            { className: 'col-md-12' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'text-body' },
	                label
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'label text-body text-bold' },
	                (0, _core.jsx)(
	                    'span',
	                    { style: style },
	                    value
	                )
	            )
	        )
	    );
	};
	
	var Detail = exports.Detail = function Detail(_ref3) {
	    var detail = _ref3.detail,
	        action = _ref3.action;
	
	    var isCancel = action === 'cancel';
	    var isConfirm = action === 'confirm';
	
	    var title = isCancel ? 'Your request to cancel this order has been submitted' : isConfirm ? 'Your bonds order has been placed' : '';
	    var status = isCancel ? 'Cancellation request in process' : isConfirm ? 'Open' : '';
	
	    var netMoneyLabel = ['B', 'S'].indexOf(detail.action) >= 0 ? 'Estimated proceeds' : 'Estimated total cost';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'vertical-offset-base' }),
	        (0, _core.jsx)(
	            'div',
	            { css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-base' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-base' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 text-center' },
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        _icons2.default.ok
	                    ),
	                    (0, _core.jsx)(
	                        'h2',
	                        null,
	                        title
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-base' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6' },
	                    (0, _core.jsx)(
	                        'h3',
	                        null,
	                        'Order# ',
	                        detail.orderNo,
	                        ': ',
	                        status
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-6 text-right' },
	                    (0, _core.jsx)(
	                        'div',
	                        null,
	                        _all.format.mdy(new Date())
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        null,
	                        detail.accountNo,
	                        ' ',
	                        (0, _all.parseHtml)(detail.accountName)
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'table-responsive' },
	                    (0, _core.jsx)(
	                        'table',
	                        {
	                            'data-name': 'orders-cancel-table',
	                            className: 'table align-top'
	                        },
	                        (0, _core.jsx)(
	                            'thead',
	                            null,
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'th',
	                                    { className: 'text-body' },
	                                    'Action'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { className: 'text-body', style: { maxWidth: '250px' } },
	                                    'Issuer'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { className: 'text-body' },
	                                    'CUSIP'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { className: 'text-body' },
	                                    'Quantity'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { className: 'text-body text-right' },
	                                    'Settlement Date'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { className: 'text-body text-right' },
	                                    'Status'
	                                ),
	                                (0, _core.jsx)(
	                                    'th',
	                                    { className: 'text-body text-right' },
	                                    'Price'
	                                )
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'tbody',
	                            null,
	                            (0, _core.jsx)(
	                                'tr',
	                                { style: { height: '50px' } },
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body text-bold' },
	                                    (0, _core.jsx)(
	                                        'span',
	                                        { style: { color: actionTypeColor(detail.action) } },
	                                        detail.transactionType
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body text-bold', style: { maxWidth: '250px' } },
	                                    _all.fmt.issuer({
	                                        issuer: detail.issue,
	                                        cusip: (0, _all.arrayFrom)(detail.cusip).join(''),
	                                        showTradeHistory: 'Y',
	                                        from: 'orders-cancel'
	                                    })
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body text-bold' },
	                                    detail.cusip
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body' },
	                                    _all.fmt.qty(detail.quantity)
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body text-right' },
	                                    detail.settlement
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body text-right' },
	                                    detail.ordStatusDesc || _all.fmt.empty()
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body text-right text-bold' },
	                                    (0, _all.isNumeric)(detail.clientPrice) ? '$' + _all.fmt.price3(detail.clientPrice) : _all.fmt.empty()
	                                )
	                            ),
	                            (0, _core.jsx)(
	                                'tr',
	                                null,
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body' },
	                                    (0, _core.jsx)(
	                                        'div',
	                                        null,
	                                        'Principal'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'div',
	                                        { className: 'text-bold' },
	                                        detail.principal || _all.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body' },
	                                    (0, _core.jsx)(
	                                        'div',
	                                        null,
	                                        'Accrued interest'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'div',
	                                        { className: 'text-bold' },
	                                        detail.accruedInterest ? (0, _core.jsx)(
	                                            _react2.default.Fragment,
	                                            null,
	                                            detail.accruedInterest,
	                                            ' (',
	                                            detail.accIntDays,
	                                            ' days)'
	                                        ) : _all.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body' },
	                                    (0, _core.jsx)(
	                                        'div',
	                                        null,
	                                        'Commission'
	                                    ),
	                                    (0, _core.jsx)(
	                                        'div',
	                                        { className: 'text-bold' },
	                                        detail.estCommission || _all.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body' },
	                                    (0, _core.jsx)(
	                                        'div',
	                                        null,
	                                        netMoneyLabel
	                                    ),
	                                    (0, _core.jsx)(
	                                        'div',
	                                        { className: 'text-bold' },
	                                        detail.netMoney || _all.fmt.empty()
	                                    )
	                                ),
	                                (0, _core.jsx)(
	                                    'td',
	                                    { className: 'text-body text-right', colSpan: 3, style: { verticalAlign: 'middle' } },
	                                    [isConfirm && (0, _core.jsx)(
	                                        _react2.default.Fragment,
	                                        { key: 1 },
	                                        (0, _core.jsx)(
	                                            'button',
	                                            {
	                                                'data-name': 'cancel-link',
	                                                className: 'btn btn-link text-bold',
	                                                onClick: function onClick(e) {
	                                                    (0, _all.showModal)({
	                                                        view: 'order-detail',
	                                                        action: 'cancel',
	                                                        orderNo: detail.orderNo,
	                                                        source: e.target
	                                                    });
	                                                }
	                                            },
	                                            'Cancel'
	                                        )
	                                    ), isCancel && (0, _core.jsx)(
	                                        _react2.default.Fragment,
	                                        { key: 2 },
	                                        (0, _core.jsx)(
	                                            'button',
	                                            {
	                                                'data-name': 'cancel-link',
	                                                className: 'btn btn-link text-bold',
	                                                onClick: function onClick(e) {
	                                                    (0, _all.show)('overview');
	                                                }
	                                            },
	                                            'Bond Resource Center'
	                                        )
	                                    ), (0, _core.jsx)(
	                                        'a',
	                                        { href: '#',
	                                            key: 3,
	                                            'data-name': 'orders-link',
	                                            className: 'btn btn-link text-bold',
	                                            onClick: function onClick() {
	                                                (0, _all.show)('orders', { backFrom: true, _ts: Date.now() });
	                                            }
	                                        },
	                                        'View orders'
	                                    ), isConfirm && (0, _core.jsx)(
	                                        _react2.default.Fragment,
	                                        { key: 4 },
	                                        (0, _core.jsx)(
	                                            'button',
	                                            {
	                                                'data-name': 'orders-link',
	                                                className: 'btn btn-link text-bold',
	                                                onClick: function onClick(e) {
	                                                    (0, _all.showModal)({
	                                                        view: 'holdings',
	                                                        acctNo: detail.accountNo,
	                                                        source: e.target
	                                                    });
	                                                }
	                                            },
	                                            'View portfolio'
	                                        )
	                                    )].filter(Boolean).flatMap(function (a, i) {
	                                        return [a, (0, _core.jsx)(Sep, { key: i })];
	                                    }).slice(0, -1)
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Sep = function Sep() {
	    return (0, _core.jsx)(
	        'span',
	        { 'aria-hidden': true, style: { padding: '0 10px 0 10px' } },
	        '|'
	    );
	};
	
	var actionType = {
	    'F': { label: 'Offer Quote Request', color: 'green' },
	    'B': { color: 'green' },
	    'W': { label: 'Bid Quote Request', color: 'red' },
	    'S': { color: 'red' }
	};
	
	var actionTypeColor = function actionTypeColor(action) {
	    return (actionType[action] || {}).color || '';
	};

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(326);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	var Header = exports.Header = function Header(_ref) {
	    var detail = _ref.detail,
	        action = _ref.action;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'row vertical-offset-base' }),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-3 col-xs-12 vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    null,
	                    'Account'
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'text-truncate' },
	                    (0, _core.jsx)(
	                        'b',
	                        null,
	                        detail.accountNo,
	                        ' ',
	                        (0, _all.parseHtml)(detail.accountName)
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'col-md-6 col-xs-12' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-3 col-xs-12 vertical-offset-sm', css: _style.textAlignRight },
	                (0, _core.jsx)(
	                    'div',
	                    null,
	                    'Post trade purchasing power'
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'text-bold' },
	                    _all.fmt.money(detail.postPowerPurchasing)
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    "ok": _react2.default.createElement(
	        "svg",
	        { width: "83", height: "81", viewBox: "0 0 83 81", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	        _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z", fill: "#242424" }),
	        _react2.default.createElement(
	            "mask",
	            { id: "mask0_2300_45833", style: { "maskType": "luminance" }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "83", height: "81" },
	            _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M41.5284 78.3871C20.1813 78.3871 2.81263 61.3915 2.81263 40.5C2.81263 19.6085 20.1813 2.6129 41.5284 2.6129C62.8755 2.6129 80.2442 19.6085 80.2442 40.5C80.2442 61.3915 62.8755 78.3871 41.5284 78.3871ZM41.5284 0C18.7075 0 0.142578 18.1688 0.142578 40.5C0.142578 62.8312 18.7075 81 41.5284 81C64.3493 81 82.9142 62.8312 82.9142 40.5C82.9142 18.1688 64.3493 0 41.5284 0ZM35.687 48.4667L28.1174 41.1689L25.5942 43.6015L35.687 53.332L57.3144 32.481L54.7912 30.0484L35.687 48.4667Z", fill: "white" })
	        ),
	        _react2.default.createElement("g", { mask: "url(#mask0_2300_45833)" })
	    )
	
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Filters = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _form = __webpack_require__(1079);
	
	var _twd = __webpack_require__(2);
	
	var _errorBoundary = __webpack_require__(476);
	
	var _useOrders2 = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Filters = exports.Filters = function Filters() {
	    var _useOrders = (0, _useOrders2.useOrders)(),
	        filters = _useOrders.filters,
	        accountsRef = _useOrders.accountsRef,
	        showFilters = _useOrders.showFilters;
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        formRef = _React$useState2[0],
	        setFormRef = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        if (!formRef || !showFilters) return;
	        formRef.validateForm();
	    }, [formRef, showFilters]);
	
	    _react2.default.useEffect(function () {
	        if (!formRef || !showFilters) return;
	
	        var subId = (0, _twd.subscribe)('orders_accounts_changed.orders_filters', function () {
	            formRef.validateForm();
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, [formRef, showFilters]);
	
	    return _react2.default.createElement(
	        _errorBoundary.ErrorBoundary,
	        null,
	        _react2.default.createElement(_formik.Formik, {
	            ref: setFormRef,
	            initialValues: Object.assign({}, filters),
	            enableReinitialize: true,
	
	            component: _form.Form,
	            validate: function validate(values) {
	                var errors = {};
	
	                if ((0, _twd.arrayFrom)(accountsRef.state.values.accounts).length === 0) {
	                    errors.accounts = "select one or more account";
	                }
	
	                var now = new Date();
	                var minDt = (0, _twd.parseDate)(values.tradeSubmitDateRangeMin);
	                var maxDt = (0, _twd.parseDate)(values.tradeSubmitDateRangeMax, true);
	
	                if (!minDt) {
	                    errors.tradeSubmitDateRangeMin = "Please enter date";
	                }
	                if (!maxDt) {
	                    errors.tradeSubmitDateRangeMax = "3 year max date range";
	                }
	                if (minDt && maxDt) {
	                    if (minDt > now) {
	                        errors.tradeSubmitDateRangeMin = "Please enter later date";
	                    }
	                    if (maxDt > now) {
	                        errors.tradeSubmitDateRangeMax = "Please enter earlier date";
	                    }
	
	                    if (maxDt < minDt) {
	                        errors.tradeSubmitDateRangeMax = "Please enter later date";
	                    } else if (maxDt > minDt) {
	                        var nextDt = new Date(minDt.getFullYear() + 3, minDt.getMonth(), minDt.getDate());
	                        if (maxDt > nextDt) {
	                            errors.tradeSubmitDateRangeMax = "3 year max date range";
	                        }
	                    }
	                }
	
	                if (values.holdCusip && values.holdCusip.split(',').filter(Boolean).map(function (a) {
	                    return a.trim();
	                }).filter(Boolean).findIndex(function (a) {
	                    var n = a.length;
	                    return n < 5 || n > 9 || n === 9 && !(0, _twd.isCusip)(a);
	                }) >= 0) {
	                    errors.holdCusip = "Invalid cusip";
	                }
	
	                errors = (0, _twd.cleanObject)(errors);
	                errors.length = Object.keys(errors).length;
	                return errors;
	            },
	
	            validateOnBlur: true,
	            validateOnChange: true
	        })
	    );
	};

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Form = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _useOrders2 = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Form = exports.Form = function Form(_ref) {
	    var handleSubmit = _ref.handleSubmit,
	        resetForm = _ref.resetForm,
	        values = _ref.values,
	        errors = _ref.errors,
	        validateForm = _ref.validateForm;
	
	    var _useOrders = (0, _useOrders2.useOrders)(),
	        showFilters = _useOrders.showFilters,
	        setShowFilters = _useOrders.setShowFilters,
	        setFilters = _useOrders.setFilters;
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('orders_reset_filters.orders_form', function () {
	            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	                _ref2$isApply = _ref2.isApply,
	                isApply = _ref2$isApply === undefined ? false : _ref2$isApply;
	
	            resetForm({
	                tradeSubmitDateRangeMin: (0, _useOrders2.TODAY)(),
	                tradeSubmitDateRangeMax: (0, _useOrders2.TODAY)(),
	                holdInvType: [],
	                holdCusip: '',
	                tradeType: [],
	                tradeStatus: []
	            });
	            setTimeout(function () {
	                validateForm();
	                if (isApply) {
	                    setFilters(values);
	                }
	            }, 10);
	        });
	
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: "col-md-12" },
	                    _react2.default.createElement(_twd.SectionHeader, {
	                        title: 'Show filters',
	                        cls: 'subhead',
	                        arrowSize: 'medium',
	                        show: showFilters,
	                        setShow: setShowFilters
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                _twd.SectionBody,
	                { show: showFilters },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: function onSubmit(e) {
	                            handleSubmit(e);
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: "col-md-10" },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(_formik.Field, {
	                                        'data-name': 'view-orders-date-min',
	                                        name: 'tradeSubmitDateRangeMin',
	                                        component: _twd.Fields.Maturity,
	                                        label: _react2.default.createElement(_twd.Flyout, {
	                                            label: 'From date',
	                                            html: 'Select your preferred date range using the following format: "mm/dd/yyyy" (e.g., January 1, 2028 should be entered as "01/01/2028"). The date range cannot exceed 3 years.'
	                                        }),
	                                        error: errors.tradeSubmitDateRangeMin
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(_formik.Field, {
	                                        'data-name': 'view-orders-date-min',
	                                        name: 'tradeSubmitDateRangeMax',
	                                        component: _twd.Fields.Maturity,
	                                        label: _react2.default.createElement(_twd.Flyout, {
	                                            label: 'To date',
	                                            html: 'Select your preferred date range using the following format: "mm/dd/yyyy" (e.g., January 1, 2028 should be entered as "01/01/2028"). The date range cannot exceed 3 years.'
	                                        }),
	                                        error: errors.tradeSubmitDateRangeMax
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(_formik.Field, {
	                                        'data-name': 'view-orders-product',
	                                        name: 'holdInvType',
	                                        component: _twd.Fields.Select,
	                                        options: [{ label: 'All', value: [] }, { label: 'Agency', value: 'A' }, { label: 'Brokered CD', value: 'S' }, { label: 'Corporate', value: 'C' }, { label: 'Municipal', value: 'M' }, { label: 'Treasury', value: 'T' }, { label: 'Other', value: ['P', 'L', 'O', 'K', 'R'] }],
	                                        label: "Product",
	                                        error: errors.holdInvType
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(_formik.Field, {
	                                        'data-name': 'view-orders-cusip',
	                                        name: 'holdCusip',
	                                        component: _twd.Fields.Text,
	                                        label: _react2.default.createElement(_twd.Flyout, {
	                                            label: 'CUSIP',
	                                            html: 'To search for orders by CUSIP, enter a full or partial (5 character minimum) CUSIP number. For example, entering "36966" will return all orders with a CUSIP beginning with 36966. To conduct a multi-CUSIP search, enter full CUSIP numbers separated by commas.'
	                                        }),
	                                        error: errors.holdCusip
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(_formik.Field, {
	                                        'data-name': 'view-orders-trade-type',
	                                        name: 'tradeType',
	                                        component: _twd.Fields.Select,
	                                        options: [{ label: 'All', value: [] }, { label: 'Buy', value: 'B' }, { label: 'Sell', value: 'S' }, { label: 'Offer Quote Request', value: 'F' }, { label: 'Bid Quote Request', value: 'W' }],
	                                        label: "Type",
	                                        error: errors.tradeType
	                                    })
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-2' },
	                                    _react2.default.createElement(_formik.Field, {
	                                        'data-name': 'view-orders-trade-status',
	                                        name: 'tradeStatus',
	                                        component: _twd.Fields.Select,
	                                        options: [{ label: 'All', value: [] }, { label: 'Open Order', value: 'OPEN_ORDER' }, { label: 'Executed', value: 'EXECUTED' }, { label: 'Change', value: 'CHANGE' }, { label: 'Expired', value: 'EXPIRED' }, { label: 'Canceled', value: 'CANCELLED' }, { label: 'Pending Canceled', value: 'PENDING_CANCELED' }, { label: 'Rejected', value: 'REJECTED' }],
	                                        label: "Status",
	                                        error: errors.tradeStatus
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: "col-md-2" },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'xs-hide' },
	                                '\xA0'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'view-orders-apply-filters',
	                                    type: 'button',
	                                    className: 'btn btn-primary-outline btn-block',
	                                    disabled: errors.length > 0,
	                                    onClick: function onClick() {
	                                        setFilters(Object.assign({}, values, { ts: Date.now() }));
	                                    }
	                                },
	                                'Apply filters'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'view-orders-reset-filters',
	                                    type: 'button',
	                                    className: 'btn btn-link btn-block text-center',
	                                    onClick: function onClick() {
	                                        (0, _twd.publish)('orders_reset_filters');
	                                    }
	                                },
	                                'Reset filters'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fixParams = undefined;
	
	var _twd = __webpack_require__(2);
	
	var fixParams = exports.fixParams = function fixParams(accounts, filters) {
	    var pageNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    var resultsPerPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
	
	
	    var searchParams = toSearchParams(accounts, filters);
	
	    return {
	        "tradeRow": (0, _twd.cleanObject)(Object.assign({
	            "tradeStatus": [],
	            "type": "traderow"
	        }, searchParams)),
	        "sort": [{ "field": "tradeSubmitDate", "direction": "DESC" }],
	        pageNumber: pageNumber,
	        resultsPerPage: resultsPerPage,
	        "excludeBlockOrders": true,
	        "tradeSource": "ATSSOURCE"
	    };
	}; /* eslint-disable no-use-before-define */
	
	
	var toSearchParams = function toSearchParams() {
	    var accounts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var minDt = (0, _twd.parseDate)(filters.tradeSubmitDateRangeMin);
	    var maxDt = (0, _twd.parseDate)(filters.tradeSubmitDateRangeMax, true);
	    var tradeSubmitDateRange = [_twd.fmt.mdy(minDt), _twd.fmt.mdy(maxDt)].join(',');
	
	    return (0, _twd.cleanObject)({
	        acctNo: (0, _twd.arrayFrom)(accounts),
	
	        tradeSubmitDateRange: tradeSubmitDateRange,
	
	        holdInvType: (0, _twd.arrayFrom)(filters.holdInvType).filter(Boolean),
	        holdCusip: (filters.holdCusip || '').split(',').map(function (a) {
	            return a.trim();
	        }).filter(Boolean),
	
	        tradeType: (0, _twd.arrayFrom)(filters.tradeType).filter(Boolean),
	        tradeStatus: (0, _twd.arrayFrom)(filters.tradeStatus).filter(Boolean),
	
	        type: "traderow"
	    });
	};

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Footer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = exports.Footer = function Footer() {
	    return _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement("div", { className: "row vertical-offset-lg" }),
	        _react2.default.createElement(
	            "div",
	            { className: "row xs-hide" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-6", style: { height: '25px' } },
	                _react2.default.createElement(
	                    "div",
	                    { style: { display: 'inline', verticalAlign: 'bottom', height: '25px' } },
	                    "The bond resource center is powered by"
	                ),
	                _react2.default.createElement("img", { alt: "tradeweb", "aria-hidden": true, src: "./resources/images/tradeweb-logo.svg" })
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-6", style: { height: '25px' } },
	                _react2.default.createElement(
	                    "div",
	                    { style: { position: 'absolute', right: 0, bottom: 0 } },
	                    "All data provided by Tradeweb Markets LLC unless otherwise noted."
	                )
	            )
	        ),
	        _react2.default.createElement(
	            "div",
	            { className: "row xs-show" },
	            _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 text-center" },
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "The bond resource"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "center is powered by"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "vertical-offset-lg" },
	                    _react2.default.createElement("img", { alt: "tradeweb", "aria-hidden": true, src: "./resources/images/tradeweb-logo.svg" })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "All data provided by Tradeweb Market"
	                ),
	                _react2.default.createElement(
	                    "div",
	                    null,
	                    "LLC unless otherwise noted."
	                )
	            )
	        ),
	        _react2.default.createElement("div", { className: "row vertical-offset-lg" })
	    );
	};

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Detail = undefined;
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(1084);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define,no-empty-pattern */
	var Detail = exports.Detail = function Detail(_ref) {
	    var detail = _ref.detail,
	        note = _ref.note,
	        setNote = _ref.setNote,
	        isNote = _ref.isNote;
	
	
	    var ordStatusDesc = !detail.ordStatusDesc ? _twd.fmt.empty() : detail.ordStatusDesc === 'Filled' ? 'Executed' : detail.ordStatusDesc;
	
	    var isAuction = detail.netMoney === 'Auction';
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row bottom-border-row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-9 col-xs-12' },
	                (0, _core.jsx)(
	                    'h3',
	                    { style: { margin: 0 } },
	                    (0, _core.jsx)(
	                        'b',
	                        null,
	                        detail.issue
	                    )
	                ),
	                detail.issuedata.warningText
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-md-3 col-xs-12 text-right' },
	                (0, _core.jsx)(
	                    'b',
	                    null,
	                    detail.cusip
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            (0, _core.jsx)(
	                'dl',
	                { className: 'order-detail-list', css: _style.listCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-4 col-xs-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Order'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.orderNo
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Status'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        ordStatusDesc
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Time (ET)'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        String(detail.placed).replace('ET', '').trim()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Transaction'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.transactionType
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Quantity'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.qty(detail.quantity)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Price'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        isAuction ? 'Auction' : (0, _twd.isNumeric)(detail.clientPrice) ? '$' + _twd.fmt.price3(detail.clientPrice) : _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Acct No'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail['account#']
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Solicited'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.solicited || _twd.fmt.empty()
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-4 col-xs-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'CUSIP'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.cusip
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Coupon'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.cpn3(detail.coupon)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Maturity'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.mdy(detail.maturity)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Trade Date'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.mdy(detail.tradeDate)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Settlement'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.mdy(detail.settlement)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Factor'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.factor
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Exec Type'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.executionType || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Trade Type'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.tradeType
	                    )
	                ),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-4 col-xs-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'YTM'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.ytw3(detail.ytm)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'YTC'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.ytw3(detail.ytc)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'YTP'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.ytw3(detail.ytp)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'YTW'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (0, _twd.isNumeric)(detail.ytw) ? (0, _core.jsx)(
	                            _react2.default.Fragment,
	                            null,
	                            _twd.fmt.ytw3(detail.ytw),
	                            ' ',
	                            _twd.fmt.mdy(detail.ytwDt)
	                        ) : _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Principal'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.principal || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Accrued Int.'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.accruedInterest ? (0, _core.jsx)(
	                            _react2.default.Fragment,
	                            null,
	                            detail.accruedInterest,
	                            ' (',
	                            detail.accIntDays,
	                            ' days)'
	                        ) : _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Trans. Fee'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        detail.estCommission || _twd.fmt.empty()
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Net Money'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        isAuction ? _twd.fmt.empty() : detail.netMoney || _twd.fmt.empty()
	                    )
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'col-md-12 text-right text-small' },
	            'Yields are inclusive of Transaction Fee'
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-base' },
	            isNote && (0, _core.jsx)(
	                'div',
	                {
	                    className: 'col-md-8 col-xs-12 from-group',
	                    style: {
	                        paddingLeft: '0px',
	                        paddingRight: '0px',
	                        display: 'none' // hide for now
	                    }
	                },
	                (0, _core.jsx)(_twd.Flyout, {
	                    label: 'Add a note to your order (optional)',
	                    html: 'Add a note to your order (optional)'
	                }),
	                (0, _core.jsx)('input', { type: 'text',
	                    'data-name': 'order-detail-note',
	                    defaultValue: note,
	                    onChange: function onChange(e) {
	                        return setNote(e.target.value);
	                    },
	                    className: 'form-control'
	                })
	            )
	        )
	    );
	};

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define,no-empty-pattern */
	// import { jsx } from '@emotion/core'
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrderDetail2 = __webpack_require__(1085);
	
	var _useOrderDetail3 = _interopRequireDefault(_useOrderDetail2);
	
	var _detail = __webpack_require__(1082);
	
	__webpack_require__(1782);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        orderNo = _ref.orderNo,
	        _ref$action = _ref.action,
	        action_ = _ref$action === undefined ? '' : _ref$action,
	        _ref$isNote = _ref.isNote,
	        isNote_ = _ref$isNote === undefined ? false : _ref$isNote;
	
	    var _useOrderDetail = (0, _useOrderDetail3.default)({ orderNo: orderNo, action: action_, isNote: isNote_ }),
	        status = _useOrderDetail.status,
	        detail = _useOrderDetail.detail,
	        action = _useOrderDetail.action,
	        isNote = _useOrderDetail.isNote,
	        title = _useOrderDetail.title;
	
	    var _React$useState = _react2.default.useState(''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        note = _React$useState2[0],
	        setNote = _React$useState2[1];
	
	    var message = {
	        'cancel': 'This is a cancel request and must be reviewed and approved before taking effect.'
	    }[action];
	
	    var button = {
	        'cancel': 'Request Cancel Order',
	        'accept': 'Accept',
	        'accept-buy': 'Accept',
	        'accept-sell': 'Accept'
	    }[action];
	
	    var buttonAction = {
	        'cancel': 'cancel',
	        'accept': 'accept',
	        'accept-buy': 'accept',
	        'accept-sell': 'accept'
	    }[action];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-lg order-detail-modal' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container', style: { background: "#ffffff" } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-md' }),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    className: 'close',
	                                    'aria-label': 'close',
	                                    'data-name': 'order-detail-close-button',
	                                    type: 'button',
	                                    onClick: function onClick() {
	                                        (0, _twd.hideModal)();
	                                    } },
	                                _react2.default.createElement(
	                                    'i',
	                                    { className: 'material-icons', 'aria-hidden': 'true' },
	                                    'close'
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            _react2.default.createElement(
	                                'h2',
	                                null,
	                                _react2.default.createElement(
	                                    'b',
	                                    null,
	                                    title
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _twd.Loading,
	                        { status: status },
	                        message && _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-xs-12' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { 'data-name': 'messages-message',
	                                            className: 'universal-message universal-message-info universal-message-dismissible',
	                                            role: 'alert' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { 'data-name': 'messages-message-content',
	                                                className: 'universal-message-content',
	                                                style: { width: '100%' }
	                                            },
	                                            message
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_detail.Detail, { detail: detail, note: note, setNote: setNote, isNote: isNote }),
	                        button && _react2.default.createElement(
	                            _react2.default.Fragment,
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'col-md-6 text-center', style: { float: 'none', margin: '0 auto' } },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'aria-label': 'Request Cancel Order',
	                                            'data-name': 'order-detail-cancel-order-button',
	                                            className: 'btn btn-primary btn-block',
	                                            type: 'button',
	                                            onClick: function onClick() {
	                                                (0, _twd.hideModal)();
	                                                (0, _twd.show)('orders-confirm', {
	                                                    action: buttonAction,
	                                                    orderNo: orderNo,
	                                                    cusip: detail.cusip,
	                                                    acctNo: detail['account#'],
	                                                    note: note
	                                                });
	                                            }
	                                        },
	                                        button
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.listCss = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dl {\n        display: flex;\n        flex-direction: row;\n    }\n    dt, dd {\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        padding: 6px 3px 6px 0px;        \n    }\n    dt {\n        flex-basis: fit-content;\n        flex-grow: 1;\n        text-align: left;\n    }\n    dd {\n        flex-basis: auto;\n        flex-grow: 2;\n        text-align: right;\n        font-weight: 500;\n        white-space: nowrap;\n    }\n'], ['\n    div {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n    }\n    dl {\n        display: flex;\n        flex-direction: row;\n    }\n    dt, dd {\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        padding: 6px 3px 6px 0px;        \n    }\n    dt {\n        flex-basis: fit-content;\n        flex-grow: 1;\n        text-align: left;\n    }\n    dd {\n        flex-basis: auto;\n        flex-grow: 2;\n        text-align: right;\n        font-weight: 500;\n        white-space: nowrap;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	
	
	var listCss = exports.listCss = (0, _core.css)(_templateObject);

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useOrders = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        orderNo = _ref.orderNo,
	        _ref$action = _ref.action,
	        action_ = _ref$action === undefined ? 'view' : _ref$action,
	        isNote_ = _ref.isNote;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(null),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        detail = _React$useState4[0],
	        setDetail = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(action_),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        action = _React$useState6[0],
	        setAction = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(isNote_),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        isNote = _React$useState8[0],
	        setIsNote = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState({
	        'view': 'View Order',
	        'cancel': 'Request Cancel Order',
	        'accept': 'Accept Order',
	        'accept-buy': 'Accept Buy Order',
	        'accept-sell': 'Accept Sell Order',
	        'sell': 'Sell Order',
	        'buy': 'Buy Order'
	    }[action]),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        title = _React$useState10[0],
	        setTitle = _React$useState10[1];
	
	    _react2.default.useEffect(function () {
	        if (!orderNo) {
	            (0, _twd.hideModal)();
	            return;
	        }
	
	        setStatus(_twd.Status.LOADING);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref3, data, _detail, a, _ref4, issuedata, sd, od, _a;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            _context.next = 3;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/trades/details',
	                                method: 'GET',
	                                isDc: false,
	                                type: 'text',
	                                params: { orderNo: orderNo }
	                            });
	
	                        case 3:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            _context.t0 = _useOrders.parseDetail;
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            _context.t1 = _context.sent;
	                            _detail = (0, _context.t0)(_context.t1);
	
	                            if (!(!_detail.cusip && _detail.WARNING)) {
	                                _context.next = 12;
	                                break;
	                            }
	
	                            throw new Error(_detail.WARNING);
	
	                        case 12:
	                            a = parseYield(_detail.ytm);
	
	                            Object.assign(_detail, { ytm: a.yld, ytmDt: a.dt });
	                            a = parseYield(_detail.yldCall);
	                            Object.assign(_detail, { ytc: a.yld, ytcDt: a.dt });
	                            a = parseYield(_detail.yldParCall);
	                            Object.assign(_detail, { ytp: a.yld, ytpDt: a.dt });
	                            a = parseYield(_detail.yieldToWorst);
	                            Object.assign(_detail, { ytw: a.yld, ytwDt: a.dt });
	
	                            if (_detail.accruedInterest === null) {
	                                _detail.accruedInterest = "$0";
	                            }
	                            if (_detail.accruedInterest === '-') {
	                                _detail.accruedInterest = null;
	                            }
	                            if (_detail.principal === '-') {
	                                _detail.principal = null;
	                            }
	
	                            if (!_detail.ytwDt) {
	                                _detail.ytwDt = _detail.ytm === _detail.ytw ? _detail.ytmDt : _detail.ytc === _detail.ytw ? _detail.ytcDt : _detail.ytp === _detail.ytw ? _detail.ytpDt : _detail.ytwDt;
	                            }
	
	                            _context.next = 26;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/cusip/issuedata',
	                                method: 'GET',
	                                params: { cusip: _detail.cusip }
	                            });
	
	                        case 26:
	                            _ref4 = _context.sent;
	                            issuedata = _ref4.data;
	                            _context.next = 30;
	                            return issuedata;
	
	                        case 30:
	                            _context.t2 = _context.sent.IssueData;
	
	                            if (_context.t2) {
	                                _context.next = 33;
	                                break;
	                            }
	
	                            _context.t2 = {};
	
	                        case 33:
	                            _detail.issuedata = _context.t2;
	
	                            setDetail(_detail);
	
	                            if (action_ === '?') {
	                                sd = _detail.ordStatusDesc;
	                                od = _detail.ordStatus;
	                                _a = sd === "Pending" && od === '0' ? 'accept' : ['Pending', 'Accepted', 'Showing'].indexOf(sd) >= 0 ? 'cancel' : ['X', 'Y', 'A', '0'].indexOf(od) >= 0 ? 'cancel' : '';
	
	                                setAction(_a);
	                                setIsNote(_a === 'accept' && _detail.ordSubStatus === 'C');
	                            }
	
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 44;
	                            break;
	
	                        case 39:
	                            _context.prev = 39;
	                            _context.t3 = _context['catch'](0);
	
	                            console.log(_context.t3);
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	                            (0, _twd.hideModal)();
	
	                        case 44:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 39]]);
	        }))();
	    }, [orderNo]);
	
	    _react2.default.useEffect(function () {
	        if (!detail) return;
	
	        if (action === 'accept') {
	            var t = detail.action === 'F' || detail.action === 'B' ? 'Accept Buy Order' : detail.action === 'W' || detail.action === 'S' ? 'Accept Sell Order' : 'Accept Order';
	            setTitle(t);
	        } else if (action === 'cancel') {
	            setTitle('Request Cancel Order');
	        }
	    }, [action, detail]);
	
	    return { status: status, detail: detail, action: action, isNote: isNote, title: title };
	};
	
	var parseYield = function parseYield(t) {
	    return { yld: parseNumber(t), dt: parseDate(t) };
	};
	var parseNumber = function parseNumber(t) {
	    var n = Number.parseFloat(t);
	    return isNaN(n) ? null : n;
	};
	
	var parseDate = function parseDate(t) {
	    return !t ? null : _twd.fmt.mdy(new Date((String(t || '').split("<br>")[1] || '').split('@')[0]));
	};

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	__webpack_require__(1783);
	
	var _accounts = __webpack_require__(1067);
	
	var _filters = __webpack_require__(1078);
	
	var _blotter = __webpack_require__(1071);
	
	var _footer = __webpack_require__(1081);
	
	var _useOrders = __webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (args) {
	    (0, _twd.trackPage)('orders');
	
	    if ((0, _twd.getConfig)('entitlements.ETradeViewOrders', 'No') === 'Yes') {
	        return _react2.default.createElement(Main, args);
	    }
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-lg' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12 bottom-border' },
	                    _react2.default.createElement(_twd.FrameIn, {
	                        dataName: 'orders-frame',
	                        src: (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)() + '/' + (0, _twd.getOwaTcdaoContext)() + '/pkg_blotter_bond.order_status_output?p_first_time=Y'
	                    })
	                )
	            )
	        )
	    );
	};
	
	var Main = function Main(args) {
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container view-orders' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'data-name': 'messages-message',
	                            className: 'universal-message universal-message-info universal-message-dismissible',
	                            role: 'alert' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'data-name': 'messages-message-content',
	                                className: 'universal-message-content',
	                                style: { width: '100%' }
	                            },
	                            'Cancel requests for open Treasury Auction orders must be submitted prior to 9 a.m. ET; cancellation of an order is not guaranteed even if submitted prior to 9 a.m. ET. Please consult your E*TRADE from Morgan Stanley Client Agreement for Self-Directed Accounts for further information on order cancellations.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'large-header' },
	                        'View Orders'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _useOrders.ContextProvider,
	                args,
	                _react2.default.createElement(_accounts.Accounts, null),
	                _react2.default.createElement(_filters.Filters, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 col-xs-12' },
	                        _react2.default.createElement(_blotter.Grid, null)
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_footer.Footer, null)
	    );
	};

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _knowledgeCenter = __webpack_require__(457);
	
	var _knowledgeCenter2 = _interopRequireDefault(_knowledgeCenter);
	
	var _quickIdeas = __webpack_require__(1092);
	
	var _quickIdeas2 = _interopRequireDefault(_quickIdeas);
	
	var _quickScreener = __webpack_require__(1096);
	
	var _quickScreener2 = _interopRequireDefault(_quickScreener);
	
	var _recentSearches = __webpack_require__(458);
	
	var _recentSearches2 = _interopRequireDefault(_recentSearches);
	
	var _savedSearches = __webpack_require__(459);
	
	var _savedSearches2 = _interopRequireDefault(_savedSearches);
	
	var _yieldCharts = __webpack_require__(1100);
	
	var _yieldCharts2 = _interopRequireDefault(_yieldCharts);
	
	var _yieldGrids = __webpack_require__(1104);
	
	var _yieldGrids2 = _interopRequireDefault(_yieldGrids);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    (0, _twd.trackPage)('overview');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container', style: { padding: 0 } },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(_yieldGrids2.default, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-8 col-xs-12' },
	                        _react2.default.createElement(_quickIdeas2.default, null),
	                        _react2.default.createElement(_yieldCharts2.default, null)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 col-xs-12' },
	                        _react2.default.createElement(_quickScreener2.default, null),
	                        _react2.default.createElement(_recentSearches2.default, { dataName: 'overview-recent-searches' }),
	                        _react2.default.createElement(_savedSearches2.default, { dataName: 'overview-saved-searches' }),
	                        _react2.default.createElement(_knowledgeCenter2.default, { dataName: 'overview-knowledge-center' })
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(237);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _useQuickIdeas3 = __webpack_require__(238);
	
	var _useQuickIdeas4 = _interopRequireDefault(_useQuickIdeas3);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    var Last = (0, _twd.getState)('overview.quick-ideas');
	
	    var _React$useState = _react2.default.useState(Last.value.invType || 'S'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        invType = _React$useState2[0],
	        setInvType_ = _React$useState2[1];
	
	    var setInvType = _react2.default.useCallback(function (s) {
	        Last.set({ invType: s });
	        setInvType_(s);
	    }, []);
	
	    var _useQuickIdeas = (0, _useQuickIdeas4.default)({
	        id: 'QUICK_IDEAS_SAFEST_CDS',
	        url: '/esb/retailservice/quickIdeasService/getSafest',
	        params: { state: null, quickPickGroupSubTypeList: ['QUICK_IDEAS_SAFEST_CDS'] }
	    }),
	        status_s = _useQuickIdeas.status,
	        data_s = _useQuickIdeas.data;
	
	    var _useQuickIdeas2 = (0, _useQuickIdeas4.default)({
	        id: 'QUICK_IDEAS_SAFEST_TREAS',
	        url: '/esb/retailservice/quickIdeasService/getSafest',
	        params: { state: null, quickPickGroupSubTypeList: ['QUICK_IDEAS_SAFEST_TREAS'] }
	    }),
	        status_t = _useQuickIdeas2.status,
	        data_t = _useQuickIdeas2.data;
	
	    var isCD = invType === 'S';
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'h3',
	                    { style: { display: 'inline-block', paddingRight: '10px' }, className: 'medium-header' },
	                    'Conservative'
	                ),
	                _react2.default.createElement(_twd.Disclosures, {
	                    dataModule: 'overview-quick-ideas',
	                    dataCategory: 'conservative',
	                    dataName: 'overview-quick-ideas-conservative-learn-more-link',
	                    label: 'Learn more',
	                    html: DISCLOSURES })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                'Short and medium-term Treasuries and new issue CDs which provide strong principal preservation.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                {
	                    'data-name': 'overview-quick-ideas-conservative-nav-tabs',
	                    className: 'col-md-6 col-xs-12 nav-tabs' },
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        { className: isCD ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                'data-module': 'overview-quick-ideas',
	                                'data-category': 'conservative',
	                                'data-name': 'overview-quick-ideas-conservative-cds-nav-tab',
	                                onClick: function onClick() {
	                                    return setInvType('S');
	                                } },
	                            'CDs'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: !isCD ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                'data-module': 'overview-quick-ideas',
	                                'data-category': 'conservative',
	                                'data-name': 'overview-quick-ideas-conservative-treasuries-nav-tab',
	                                onClick: function onClick() {
	                                    return setInvType('T');
	                                } },
	                            'Treasuries'
	                        )
	                    )
	                )
	            ),
	            isCD && _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12 equally-spaced' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Additional Offerings:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'conservative',
	                            'data-name': 'overview-quick-ideas-conservative-cds-3-months-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onViewCD({ holdMaturityMin: '3m', holdMaturityMax: '4m' });
	                            }
	                        },
	                        '3 months'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'conservative',
	                            'data-name': 'overview-quick-ideas-conservative-cds-6-months-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onViewCD({ holdMaturityMin: '6m', holdMaturityMax: '7m' });
	                            }
	                        },
	                        '6 months'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'conservative',
	                            'data-name': 'overview-quick-ideas-conservative-cds-1-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onViewCD({ holdMaturityMin: '11m', holdMaturityMax: '13m' });
	                            }
	                        },
	                        '1 year'
	                    )
	                )
	            ),
	            !isCD && _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12 equally-spaced' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Additional Offerings:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'conservative',
	                            'data-name': 'overview-quick-ideas-conservative-treasuris-less-than-1-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onViewTreasury({ holdTreasuryType: ['Bills'], holdMaturityMax: '1y' });
	                            }
	                        },
	                        '<1 year'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'conservative',
	                            'data-name': 'overview-quick-ideas-conservative-treasuris-between-1-year-to-5-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onViewTreasury({ holdTreasuryType: ['Notes'], holdMaturityMin: '1y', holdMaturityMax: '5y' });
	                            }
	                        },
	                        '1 - 5 years'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'conservative',
	                            'data-name': 'overview-quick-ideas-conservative-treasuris-between-5-year-to-10-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onViewTreasury({ holdTreasuryType: ['Notes', 'Bonds'], holdMaturityMin: '5y', holdMaturityMax: '10y' });
	                            }
	                        },
	                        '>5 - 10 years'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    _twd.Loading,
	                    { status: isCD ? status_s : status_t },
	                    _react2.default.createElement(_grid2.default, {
	                        dataCategory: 'conservative',
	                        dataName: 'overview-quick-ideas-convservative',
	                        rows: isCD ? data_s : data_t,
	                        showFrequency: true })
	                )
	            )
	        )
	    );
	};
	
	var onViewCD = function onViewCD(p) {
	    var searchParams = Object.assign({
	        holdInvType: ['S'],
	        offeringType: ['primary', 'ask-side'],
	        quantityMin: 10,
	        holdCouponTypeCode: ['FNZR'],
	        holdCallableInd: ['N'],
	        persistToPreviousSearches: false,
	        sort: [{ field: 'askYield', direction: 'DESC' }]
	    }, p);
	    (0, _useQuickIdeas3.onViewAll)({ searchParams: searchParams });
	};
	
	var onViewTreasury = function onViewTreasury(p) {
	    var searchParams = Object.assign({
	        holdInvType: ['T'],
	        offeringType: ['ask-side'],
	        holdTreasuryType: ['Bills', 'Notes'],
	        holdMaturityMax: '10y',
	        quantityMin: 10,
	        clientPriceMin: 95,
	        clientPriceMax: 120,
	        persistToPreviousSearches: false,
	        sort: [{ field: 'askYield', direction: 'DESC' }]
	    }, p);
	    (0, _useQuickIdeas3.onViewAll)({ searchParams: searchParams });
	};
	
	var DISCLOSURES = '\n    <p>\n    This category features more conservative CD and Treasury bond search results.\n    By default, the module will default to CD results.\n    Click the \u201CTreasuries\u201D tab to load Treasury results.\n    The results displayed will adhere to the following criteria:\n    </p>\n\n    <p>\n    <b>CD Result Criteria:</b>  New issue CDs with maturities ranging from three months to one year.\n    All results displayed are from dealers offering a minimum of 10 bonds.\n    The result displayed in each row represents the highest yielding offering within its designated maturity range.\n    Each of the three rows will feature a unique maturity range.  Row 1: (3m - 4m), Row 2: (6m - 7m), Row 3: (11m-13m).\n    </p>\n\n    <p>\n    <b>Treasury Result Criteria:</b>  Short-term Treasury bills with maturities of less than one year\n    to medium-term Treasury notes with maturities upwards of 10 years.\n    All results displayed are from dealers offering a minimum of 10 bonds, with an offering price between 95 and 120.\n    The result displayed in each row represents the highest yielding offering within its designated maturity range.\n    Each of the three rows feature a unique maturity range.  Row 1: (<1yr), Row 2: (>1yr \u2013 5yr), Row 3: (>5yr - 10yr).\n    </p>';

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        data = _ref.data,
	        _ref$dataModule = _ref.dataModule,
	        dataModule = _ref$dataModule === undefined ? 'overview-quick-ideas' : _ref$dataModule,
	        _ref$dataCategory = _ref.dataCategory,
	        dataCategory = _ref$dataCategory === undefined ? 'quick-ideas' : _ref$dataCategory,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'overview-quick-ideas' : _ref$dataName,
	        _ref$showFrequency = _ref.showFrequency,
	        showFrequency = _ref$showFrequency === undefined ? false : _ref$showFrequency;
	
	    return _react2.default.createElement(
	        'tr',
	        {
	            'data-module': dataModule,
	            'data-category': dataCategory,
	            'data-name': dataName + '-row' },
	        _react2.default.createElement(
	            'td',
	            { className: 'text-left text-truncate', style: { maxWidth: '240px' } },
	            _twd.fmt.issuer({
	                issuer: data.holdIssue,
	                cusip: data.holdCusip,
	                from: 'overview',
	                dataModule: dataModule,
	                dataCategory: dataCategory
	            })
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            data.holdMaturity
	        ),
	        _react2.default.createElement(
	            'td',
	            null,
	            formatYield(data.askYield)
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: 'text-right' },
	            showFrequency ? data.couponPaymentFreq || freq(data.holdCouponFrequency) : _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                _twd.fmt.nvl(data.moodyRating),
	                '/',
	                _twd.fmt.nvl(data.spRating)
	            )
	        ),
	        _react2.default.createElement(
	            'td',
	            { className: 'text-right' },
	            _twd.fmt.price(data.askPrice)
	        )
	    );
	};
	
	var freq = function freq(a) {
	    return a === null ? 'At Maturity' : a >= 365 ? 'Annually' : a >= 182 ? 'Semiannual' : a >= 80 ? 'Quarterly' : a >= 28 ? 'Monthly' : '';
	};
	
	var formatYield = function formatYield(x) {
	    var a = parseFloat(x);
	    if (isNaN(a)) return '-';
	
	    var s = a.toFixed(3);
	    if (s === '0.000') return '-';
	    return s + '%';
	};

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useQuickIdeas2 = __webpack_require__(238);
	
	var _useQuickIdeas3 = _interopRequireDefault(_useQuickIdeas2);
	
	var _grid = __webpack_require__(237);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useQuickIdeas = (0, _useQuickIdeas3.default)({
	        id: 'QUICK_IDEAS_HIGH_YIELD_CORPS',
	        url: '/esb/retailservice/quickIdeasService/getHighYielding',
	        params: {
	            state: null,
	            quickPickGroupSubTypeList: ['QUICK_IDEAS_HIGH_YIELD_CORPS']
	        }
	    }),
	        status = _useQuickIdeas.status,
	        data = _useQuickIdeas.data;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'h3',
	                    { style: { display: 'inline-block', paddingRight: '10px' }, className: 'medium-header' },
	                    'High Yielding'
	                ),
	                _react2.default.createElement(_twd.Disclosures, {
	                    dataModule: 'overview-quick-ideas',
	                    dataCategory: 'high-yielding',
	                    dataName: 'overview-quick-ideas-high-yielding-learn-more-link',
	                    label: 'Learn more',
	                    html: DISCLOSURES })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                'Short and medium-term high yield corporates with high coupons and a focus on income generation.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6' },
	                '\xA0'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 equally-spaced' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Additional Offerings:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'high-yielding',
	                            'data-name': 'overview-quick-ideas-high-yielding-less-than-2-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onView({ holdMaturityMax: '2y' });
	                            }
	                        },
	                        '<2 years'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'high-yielding',
	                            'data-name': 'overview-quick-ideas-high-yielding-between-2-year-to-5-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onView({ holdMaturityMin: '2y', holdMaturityMax: '5y' });
	                            }
	                        },
	                        '2 - 5 years'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'high-yielding',
	                            'data-name': 'overview-quick-ideas-high-yielding-between-5-year-to-10-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onView({ holdMaturityMin: '5y', holdMaturityMax: '10y' });
	                            }
	                        },
	                        '>5 - 10 years'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    _twd.Loading,
	                    { status: status },
	                    _react2.default.createElement(_grid2.default, {
	                        dataCategory: 'high-yielding',
	                        dataName: 'overview-quick-ideas-high-yielding',
	                        rows: data })
	                )
	            )
	        )
	    );
	};
	
	var onView = function onView(p) {
	    var searchParams = Object.assign({
	        holdInvType: ['C'],
	        offeringType: ['secondary', 'ask-side'],
	        holdMoodyRatingMin: 'C',
	        holdMoodyRatingMax: 'Ba1',
	        holdSpRatingMin: 'C',
	        holdSpRatingMax: 'BB+',
	        holdCouponTypeCode: ['FNZR'],
	        holdCallableInd: ['N'],
	        quantityMin: 10,
	        clientPriceMin: 95,
	        clientPriceMax: 120,
	        holdCouponMin: 7,
	        holdCouponPayFrequency: ['S'],
	        persistToPreviousSearches: false,
	        sort: [{ field: 'askYield', direction: 'DESC' }]
	    }, p);
	    (0, _useQuickIdeas2.onViewAll)({ searchParams: searchParams });
	};
	
	var DISCLOSURES = '\n    <p>\n    This category features high yield (includes ratings between C/C to Ba1/BB+)\n    corporate bond search results with maturities ranging between 2 and 10 years.\n    All results displayed are from dealers offering a minimum of 10 bonds,\n    with an offering price between 95 and 120.\n    All bonds feature a minimum 7% coupon and semi-annual interest payments.\n    Each of the three rows feature a unique maturity range.\n    Row 1: (<2yr), Row 2: (2yr \u2013 5yr), Row 3: (5yr - 10yr).\n    </p>';

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(237);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _useQuickIdeas2 = __webpack_require__(238);
	
	var _useQuickIdeas3 = _interopRequireDefault(_useQuickIdeas2);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var _useQuickIdeas = (0, _useQuickIdeas3.default)({
	        id: 'QUICK_IDEAS_MOST_ACTIVE',
	        url: '/esb/retailservice/quickIdeasService/getMostActivelyTraded',
	        params: {
	            state: null,
	            quickPickGroupSubTypeList: ['QUICK_IDEAS_MOST_ACTIVELY_TRADED_CORPS']
	        },
	        rowCount: 3
	    }),
	        status = _useQuickIdeas.status,
	        data = _useQuickIdeas.data,
	        onViewAll = _useQuickIdeas.onViewAll;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'h3',
	                    { style: { display: 'inline-block', paddingRight: '10px' }, className: 'medium-header' },
	                    'Most Actively Traded'
	                ),
	                _react2.default.createElement(_twd.Disclosures, {
	                    dataModule: 'overview-quick-ideas',
	                    dataCategory: 'most-actively-traded',
	                    dataName: 'overview-quick-ideas-most-actively-traded-learn-more-link',
	                    label: 'Learn more',
	                    html: DISCLOSURES }),
	                _react2.default.createElement('p', { className: 'text-body' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-10 col-xs-12' },
	                'The most actively traded corporate bonds based on FINRA TRACE reported trades.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-2 col-xs-12 text-right' },
	                _react2.default.createElement(
	                    'a',
	                    { href: '#',
	                        'data-module': 'overview-quick-ideas',
	                        'data-category': 'most-actively-traded',
	                        'data-name': 'overview-quick-ideas-most-actively-traded-view-all-link',
	                        style: { cursor: 'pointer' },
	                        onClick: function onClick() {
	                            var searchParams = {
	                                holdInvType: ['C'],
	                                holdMoodyRatingMin: 'Baa3',
	                                holdSpRatingMin: 'BBB-',
	                                offeringType: ['ask-side'],
	                                persistToPreviousSearches: false,
	                                sort: [{ field: 'traceTradeCount', direction: 'DESC' }]
	                            };
	                            onViewAll({ searchParams: searchParams });
	                        }
	                    },
	                    'View all'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    _twd.Loading,
	                    { status: status },
	                    _react2.default.createElement(_grid2.default, {
	                        dataCategory: 'most-actively-traded',
	                        dataName: 'overview-quick-ideas-most-actively-traded',
	                        rows: data })
	                )
	            )
	        )
	    );
	};
	
	var DISCLOSURES = '\n    <p>\n    This category features actively traded investment-grade corporate bond\n    search results based upon TRACE Market Aggregate Information.\n    </p>';

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(329);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _conservative = __webpack_require__(1088);
	
	var _conservative2 = _interopRequireDefault(_conservative);
	
	var _highYielding = __webpack_require__(1090);
	
	var _highYielding2 = _interopRequireDefault(_highYielding);
	
	var _mostActivelyTraded = __webpack_require__(1091);
	
	var _mostActivelyTraded2 = _interopRequireDefault(_mostActivelyTraded);
	
	var _taxAdvantaged = __webpack_require__(1093);
	
	var _taxAdvantaged2 = _interopRequireDefault(_taxAdvantaged);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'quick-ideas', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'overview-quick-ideas', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Quick ideas'
	                    ),
	                    (0, _core.jsx)(
	                        'p',
	                        { className: 'text-body' },
	                        'Here are some bond ideas to help simplify your investing experience.'
	                    )
	                )
	            ),
	            (0, _core.jsx)(_conservative2.default, null),
	            (0, _core.jsx)(_taxAdvantaged2.default, null),
	            (0, _core.jsx)(_mostActivelyTraded2.default, null),
	            (0, _core.jsx)(_highYielding2.default, null)
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(237);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _useQuickIdeas2 = __webpack_require__(238);
	
	var _useQuickIdeas3 = _interopRequireDefault(_useQuickIdeas2);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var defaultState = (0, _twd.getConfig)('account_states.0.stateOfResidence', '');
	    var Last = (0, _twd.getState)('overview.quick-ideas');
	
	    var _React$useState = _react2.default.useState(Last.value.stateTs ? Last.value.state : defaultState),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        state = _React$useState2[0],
	        setState_ = _React$useState2[1];
	
	    var _useQuickIdeas = (0, _useQuickIdeas3.default)({
	        id: 'QUICK_IDEAS_TAX_ADVANTAGED_MUNIS',
	        url: '/esb/retailservice/quickIdeasService/getTaxAdvantaged',
	        params: {
	            state: state,
	            quickPickGroupSubTypeList: ['QUICK_IDEAS_TAX_ADVANTAGED_MUNIS']
	        }
	    }),
	        status = _useQuickIdeas.status,
	        data = _useQuickIdeas.data,
	        Status = _useQuickIdeas.Status,
	        setStatus = _useQuickIdeas.setStatus;
	
	    var setState = _react2.default.useCallback(function (s) {
	        Last.set({ state: s, stateTs: Date.now() });
	        setState_(s);
	        setStatus(Status.LOADING);
	    }, []);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row vertical-offset-sm' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'h3',
	                    { style: { display: 'inline-block', paddingRight: '10px' }, className: 'medium-header' },
	                    'Tax Advantaged'
	                ),
	                _react2.default.createElement(_twd.Disclosures, {
	                    dataModule: 'overview-quick-ideas',
	                    dataCategory: 'tax-advantaged',
	                    dataName: 'overview-quick-ideas-tax-advantaged-learn-more-link',
	                    label: 'Learn more',
	                    html: DISCLOSURES })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                'Short and medium-term tax-advantaged municipal bonds offered in your state of residence.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-4 col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'select-wrapper' },
	                    _react2.default.createElement(
	                        'select',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'tax-advantaged',
	                            'data-name': 'overview-quick-ideas-tax-advantaged-state',
	                            'aria-label': 'Select state',
	                            defaultValue: state,
	                            onChange: function onChange(e) {
	                                return setState(e.target.value);
	                            },
	                            className: 'form-control' },
	                        [{ label: 'All', value: '' }].concat(_twd.STATES_AND_TERRITORIES).map(function (a, i) {
	                            return _react2.default.createElement(
	                                'option',
	                                { key: i, value: a.value },
	                                a.label
	                            );
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-2 col-xs-12' },
	                '\xA0'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6  col-xs-12 equally-spaced' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    'Additional Offerings:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'tax-advantaged',
	                            'data-name': 'overview-quick-ideas-tax-advantaged-less-than-2-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onView(state, { holdMaturityMax: '2y' });
	                            }
	                        },
	                        '<2 years'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'tax-advantaged',
	                            'data-name': 'overview-quick-ideas-tax-advantaged-between-2-year-to-5-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onView(state, { holdMaturityMin: '2y', holdMaturityMax: '5y' });
	                            }
	                        },
	                        '2 - 5 years'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-module': 'overview-quick-ideas',
	                            'data-category': 'tax-advantaged',
	                            'data-name': 'overview-quick-ideas-tax-advantaged-between-5-year-to-10-year-link',
	                            className: 'link-button',
	                            onClick: function onClick() {
	                                return onView(state, { holdMaturityMin: '5y', holdMaturityMax: '10y' });
	                            }
	                        },
	                        '>5 - 10 years'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    _twd.Loading,
	                    { status: status },
	                    _react2.default.createElement(_grid2.default, {
	                        dataCategory: 'tax-advantaged',
	                        dataName: 'overview-quick-ideas-tax-advantaged',
	                        rows: data })
	                )
	            )
	        )
	    );
	};
	
	var onView = function onView(state, p) {
	    var searchParams = Object.assign(Object.assign({
	        holdInvType: ['M'],
	        offeringType: ['ask-side'],
	        holdMoodyRatingMin: 'Baa3',
	        holdSpRatingMin: 'BBB-',
	        quantityMin: 10,
	        clientPriceMin: 95,
	        clientPriceMax: 120,
	        holdCouponMin: 4,
	        holdCouponPayFrequency: ['S'],
	        holdCouponTypeCode: ['FNZR'],
	        holdCallableInd: ['N'],
	        holdRefundInd: ['N'],
	        holdTaxable: ['N'],
	        holdAltMinTax: ['N']
	    }, state && { holdState: [state] }, {
	        persistToPreviousSearches: false,
	        sort: [{ field: 'askYield', direction: 'DESC' }]
	    }), p);
	    (0, _useQuickIdeas2.onViewAll)({ searchParams: searchParams });
	};
	
	var DISCLOSURES = '\n    <p>\n    This category features investment-grade (Baa3/BBB- and above) municipal bond\n    results with maturities ranging from 2 to 10 years \u2013 based upon\n    the physical state of residence we have on file for your account*.\n    All results displayed are from dealers offering a minimum of 10 bonds,\n    with an offering price between 95 and 120.\n    All bonds feature a minimum 4% coupon and semi-annual interest payments.\n    Each of the three rows will feature a unique maturity range.\n    Row 1: (<2yr), Row 2: (2yr \u2013 5yr), Row 3: (5yr - 10yr).\n    </p>\n\n    <p>\n    Interest income on bonds issued by U.S. states, cities, and counties,\n    is generally federal-tax-exempt and state-tax-exempt for residents of the state\n    in which the issuer resides, however, tax-exempt status depends on several factors,\n    please consult your tax advisor regarding your personal situation.\n    </p>\n\n    <p class="text-small">\n    *Note: If E*TRADE has no physical state of residence on file,\n    national municipal bonds will populate which adhere to the aforementioned criteria.\n    </p>';

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _submitButton = __webpack_require__(1097);
	
	var _submitButton2 = _interopRequireDefault(_submitButton);
	
	var _toSearchParams = __webpack_require__(327);
	
	var _predefinedSearches = __webpack_require__(1095);
	
	var _predefinedSearches2 = _interopRequireDefault(_predefinedSearches);
	
	var _useQuickScreener = __webpack_require__(328);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = _twd.Fields.Label,
	    Labels = _twd.Fields.Labels; /* eslint-disable no-use-before-define */
	
	var getResetValues = function getResetValues(curr) {
	    var invType = curr.invType;
	    var a = Object.assign({}, curr);delete a.invType;
	    var b = Object.assign({}, _useQuickScreener.initialValues);delete b.invType;
	
	    if (!(0, _twd.isEquals)(a, b)) {
	        return Object.assign({}, _useQuickScreener.initialValues, {
	            invType: invType,
	            holdSpRatingMin: 'BBB-',
	            holdSpRatingMax: 'AAA',
	            holdMoodyRatingMin: 'Baa3',
	            holdMoodyRatingMax: 'Aaa'
	        });
	    }
	
	    return Object.assign(b, {
	        invType: invType,
	        rating: "all-ratings",
	        holdMoodyRatingMin: "ALL",
	        holdMoodyRatingMax: "ALL",
	        holdSpRatingMin: "ALL",
	        holdSpRatingMax: "ALL",
	        muniGeneralObligation: false,
	        muniRevenue: false,
	        muniStates: [],
	        muniTaxExempt: false,
	        muniTaxable: false,
	        cdBlueSky: [],
	        cdNewIssue: false,
	        cdSecondary: false,
	        holdCallableInd: false
	    });
	};
	
	exports.default = function (_ref) {
	    var handleSubmit = _ref.handleSubmit,
	        values = _ref.values,
	        errors = _ref.errors,
	        resetForm = _ref.resetForm,
	        validateForm = _ref.validateForm;
	
	
	    _react2.default.useEffect(function () {
	        validateForm();
	    }, []);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('overview_quick_screener_clear_all.overview_quick_screener_form', function () {
	            resetForm(getResetValues(values));
	            setTimeout(function () {
	                validateForm();
	            });
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, [values]);
	
	    var invType = values.invType;
	    var isCorp = invType === 'C';
	    var isMuni = invType === 'M';
	    var isCD = invType === 'S';
	    var isTreasury = invType === 'T';
	    var isAgency = invType === 'A';
	    var hasRating = !(isCD || isTreasury);
	
	    return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(Label, {
	                            htmlFor: 'overview-quick-screener-securities',
	                            label: 'Securities',
	                            info: Labels.Securities })
	                    )
	                ),
	                _react2.default.createElement(_formik.Field, {
	                    id: 'overview-quick-screener-securities',
	                    dataName: 'overview-quick-screener-securities',
	                    name: 'invType',
	                    component: _twd.Fields.Select,
	                    options: [{ label: 'Corporates', value: 'C' }, { label: 'Municipals', value: 'M' }, { label: 'CDs', value: 'S' }, { label: 'Agencies', value: 'A' }, { label: 'U.S. Treasuries', value: 'T' }]
	                })
	            )
	        ),
	        isCorp && _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(Label, {
	                            htmlFor: 'overview-quick-screener-corp-sectors',
	                            label: 'Sectors',
	                            info: Labels.CorpSector })
	                    )
	                ),
	                _react2.default.createElement(_formik.FieldArray, {
	                    name: 'corpSectors',
	                    render: function render(args) {
	                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                            id: 'overview-quick-screener-corp-sectors',
	                            dataName: 'overview-quick-screener-corp-sectors',
	                            emptyText: 'All',
	                            showSelectAll: true,
	                            options: _twd.CORP_SECTORS,
	                            style: { marginBottom: '10px' }
	                        }));
	                    }
	                })
	            )
	        ),
	        isMuni && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, {
	                                htmlFor: 'overview-quick-screener-muni-states',
	                                label: 'State / Territory',
	                                info: Labels.MuniStates })
	                        )
	                    ),
	                    _react2.default.createElement(_formik.FieldArray, { name: 'muniStates',
	                        render: function render(args) {
	                            return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                id: 'overview-quick-screener-muni-states',
	                                dataName: 'overview-quick-screener-muni-states',
	                                showSelectAll: true,
	                                options: _twd.MUNI_STATES_AND_TERRITORIES,
	                                style: { marginBottom: '10px' }
	                            }));
	                        }
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, {
	                                htmlFor: 'overview-quick-screener-muni-states',
	                                label: 'Use of proceeds',
	                                info: Labels.MuniPurposes })
	                        )
	                    ),
	                    _react2.default.createElement(_formik.FieldArray, { name: 'muniPurposes',
	                        render: function render(args) {
	                            return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                id: 'overview-quick-screener-muni-use-of-proceeds',
	                                dataName: 'overview-quick-screener-muni-use-of-proceeds',
	                                showSelectAll: true,
	                                options: _twd.MUNI_PURPOSES,
	                                style: { marginBottom: '10px' }
	                            }));
	                        }
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12 col-lg-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, {
	                                htmlFor: 'overview-quick-screener-muni-general-obligation',
	                                label: 'Category',
	                                info: Labels.MuniCategories })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                            _react2.default.createElement(_formik.Field, {
	                                id: 'overview-quick-screener-muni-general-obligation',
	                                'data-name': 'overview-quick-screener-muni-general-obligation',
	                                name: 'muniGeneralObligation',
	                                component: _twd.Fields.Checkbox,
	                                label: 'General Obligation'
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-muni-revenue',
	                                name: 'muniRevenue',
	                                component: _twd.Fields.Checkbox,
	                                label: 'Revenue'
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12 col-lg-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, {
	                                label: 'Tax Treatment',
	                                info: Labels.MuniTaxTreatments })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-muni-tax-exempt',
	                                name: 'muniTaxExempt',
	                                component: _twd.Fields.Checkbox,
	                                label: 'Tax-Exempt'
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 col-xs-12' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-muni-taxable',
	                                name: 'muniTaxable',
	                                component: _twd.Fields.Checkbox,
	                                label: 'Taxable'
	                            })
	                        )
	                    )
	                )
	            )
	        ),
	        isCD && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, {
	                                htmlFor: 'overview-quick-screener-cd-bluesky',
	                                label: 'Blue Sky Restriction',
	                                info: CD_BLUESKY_INFO })
	                        )
	                    ),
	                    _react2.default.createElement(_formik.FieldArray, { name: 'cdBlueSky',
	                        render: function render(args) {
	                            return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                id: 'overview-quick-screener-cd-bluesky',
	                                dataName: 'overview-quick-screener-cd-bluesky',
	                                emptyText: 'All',
	                                showSelectAll: true,
	                                options: _twd.CD_STATES_AND_TERRITORIES,
	                                style: { marginBottom: '10px' }
	                            }));
	                        }
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, {
	                                label: 'Market type',
	                                info: Labels.CorpMarketTypes })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-cd-new-issue',
	                                name: 'cdNewIssue',
	                                component: _twd.Fields.Checkbox,
	                                label: 'New Issue'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6' },
	                            _react2.default.createElement('div', { className: 'vertical-offset-xxs' }),
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-cd-secondary',
	                                name: 'cdSecondary',
	                                component: _twd.Fields.Checkbox,
	                                label: 'Secondary'
	                            })
	                        )
	                    )
	                )
	            )
	        ),
	        isAgency && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, { label: 'Agency/GSE', info: Labels.AgencyTypes })
	                        )
	                    ),
	                    _react2.default.createElement(_formik.FieldArray, { name: 'agencyTypes',
	                        render: function render(args) {
	                            return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                dataName: 'overview-quick-screener-agency-issuer',
	                                emptyText: 'All',
	                                showSelectAll: true,
	                                options: _twd.AGENCY_TYPES,
	                                listConfig: { style: { minWidth: '325px' } },
	                                style: { marginBottom: '10px' }
	                            }));
	                        }
	                    })
	                )
	            )
	        ),
	        isTreasury && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Label, { label: 'Type', info: Labels.TreasuryTypes })
	                        )
	                    ),
	                    _react2.default.createElement(_formik.FieldArray, { name: 'treasuryTypes',
	                        render: function render(args) {
	                            return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                                dataName: 'overview-quick-screener-treasury-type',
	                                emptyText: 'All',
	                                showSelectAll: true,
	                                options: _twd.TREASURY_TYPES,
	                                style: { marginBottom: '10px' }
	                            }));
	                        }
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Maturity Date', info: _twd.Fields.Labels.Maturity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-maturity-min',
	                            name: 'holdMaturityMin',
	                            component: _twd.Fields.Maturity,
	                            label: 'Min',
	                            error: errors.holdMaturity
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-maturity-min',
	                            name: 'holdMaturityMax',
	                            component: _twd.Fields.Maturity,
	                            label: 'Max',
	                            error: errors.holdMaturity
	                        })
	                    ),
	                    errors.holdMaturity && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.holdMaturity
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Quantity', info: _twd.Fields.Labels.Quantity })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-quantity-min',
	                            name: 'quantityMin',
	                            component: _twd.Fields.Quantity,
	                            label: 'Min',
	                            error: errors.quantity
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-quantity-max',
	                            name: 'quantityMax',
	                            component: _twd.Fields.Quantity,
	                            label: 'Max',
	                            error: errors.quantity
	                        })
	                    ),
	                    errors.quantity && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.quantity
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Yield', info: _twd.Fields.Labels.Yield })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-yield-min',
	                            name: 'offerYtwMin',
	                            component: _twd.Fields.Yield,
	                            placeholder: '%',
	                            error: errors.offerYtw,
	                            label: 'Min'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-yield-max',
	                            name: 'offerYtwMax',
	                            component: _twd.Fields.Yield,
	                            placeholder: '%',
	                            error: errors.offerYtw,
	                            label: 'Max'
	                        })
	                    ),
	                    errors.offerYtw && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.offerYtw
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-6' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(_twd.Fields.Label, { label: 'Price', info: _twd.Fields.Labels.Price })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-price-min',
	                            name: 'clientPriceMin',
	                            component: _twd.Fields.Price,
	                            placeholder: '$',
	                            error: errors.clientPrice,
	                            label: 'Min'
	                        })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-6 col-md-6' },
	                        _react2.default.createElement(_formik.Field, {
	                            'data-name': 'overview-quick-screener-price-max',
	                            name: 'clientPriceMax',
	                            component: _twd.Fields.Price,
	                            placeholder: '$',
	                            error: errors.clientPrice,
	                            label: 'Max'
	                        })
	                    ),
	                    errors.clientPrice && _react2.default.createElement(
	                        'label',
	                        { className: 'field-status has-error' },
	                        errors.clientPrice
	                    ),
	                    _react2.default.createElement(_twd.Dash, null)
	                )
	            )
	        ),
	        hasRating && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(_twd.Fields.Label, {
	                                id: 'overview-quick-screener-rating-label',
	                                label: 'Rating', info: _twd.Fields.Labels.Rating })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-rating-investment-grade',
	                                'aria-describedby': 'overview-quick-screener-rating-label',
	                                name: 'rating',
	                                component: _twd.Fields.Radio,
	                                value: 'investment-grade',
	                                label: 'Investment Grade',
	                                className: 'radio-inline',
	                                onClick: function onClick() {
	                                    Object.assign(values, {
	                                        holdSpRatingMin: 'BBB-',
	                                        holdSpRatingMax: 'AAA',
	                                        holdMoodyRatingMin: 'Baa3',
	                                        holdMoodyRatingMax: 'Aaa'
	                                    });
	                                } }),
	                            '\xA0 \xA0',
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-rating-high-yield',
	                                'aria-describedby': 'overview-quick-screener-rating-label',
	                                name: 'rating',
	                                component: _twd.Fields.Radio,
	                                value: 'high-yield',
	                                label: 'High Yield',
	                                className: 'radio-inline',
	                                onClick: function onClick() {
	                                    Object.assign(values, {
	                                        holdSpRatingMin: 'C',
	                                        holdSpRatingMax: 'BB+',
	                                        holdMoodyRatingMin: 'C',
	                                        holdMoodyRatingMax: 'Ba1'
	                                    });
	                                } }),
	                            '\xA0 \xA0',
	                            _react2.default.createElement(_formik.Field, {
	                                'data-name': 'overview-quick-screener-rating-all-ratings',
	                                name: 'rating', component: _twd.Fields.Radio,
	                                value: 'all-ratings',
	                                label: 'All ratings',
	                                className: 'radio-inline',
	                                onClick: function onClick() {
	                                    Object.assign(values, {
	                                        holdSpRatingMin: 'ALL',
	                                        holdSpRatingMax: 'ALL',
	                                        holdMoodyRatingMin: 'ALL',
	                                        holdMoodyRatingMax: 'ALL'
	                                    });
	                                } })
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12 col-lg-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(_twd.Fields.Label, { label: 'Moody\'s' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-6' },
	                            _react2.default.createElement(_formik.Field, {
	                                dataName: 'overview-quick-screener-moodys-credit-rating-min',
	                                name: 'holdMoodyRatingMin',
	                                component: _twd.Fields.Rating,
	                                ratingType: 'moodys',
	                                error: errors.holdMoodyRating,
	                                label: 'Min',
	                                ariaLabel: 'Minimum Moody\'s Rating'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-6' },
	                            _react2.default.createElement(_formik.Field, {
	                                dataName: 'overview-quick-screener-moodys-credit-rating-max',
	                                name: 'holdMoodyRatingMax',
	                                component: _twd.Fields.Rating,
	                                ratingType: 'moodys',
	                                error: errors.holdMoodyRating,
	                                label: 'Max',
	                                ariaLabel: 'Maximum Moody\'s Rating'
	                            })
	                        ),
	                        errors.holdMoodyRating && _react2.default.createElement(
	                            'label',
	                            { className: 'field-status has-error' },
	                            errors.holdMoodyRating
	                        ),
	                        _react2.default.createElement(_twd.Dash, { margin: 10 })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12 col-lg-6' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(_twd.Fields.Label, { label: 'S&P' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-6 col-md-6' },
	                            _react2.default.createElement(_formik.Field, {
	                                dataName: 'overview-quick-screener-sp-credit-rating-min',
	                                name: 'holdSpRatingMin',
	                                component: _twd.Fields.Rating,
	                                ratingType: 'sp',
	                                error: errors.holdSpRating,
	                                label: 'Min',
	                                ariaLabel: 'Minimum S&ampP Rating'
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-6 col-md-6' },
	                            _react2.default.createElement(_formik.Field, {
	                                dataName: 'overview-quick-screener-sp-credit-rating-max',
	                                name: 'holdSpRatingMax',
	                                component: _twd.Fields.Rating,
	                                ratingType: 'sp',
	                                error: errors.holdSpRating,
	                                label: 'Max',
	                                ariaLabel: 'Maximum S&ampP Rating'
	                            })
	                        ),
	                        errors.holdSpRating && _react2.default.createElement(
	                            'label',
	                            { className: 'field-status has-error' },
	                            errors.holdSpRating
	                        ),
	                        _react2.default.createElement(_twd.Dash, { margin: 10 })
	                    )
	                )
	            ),
	            _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12' },
	                    _react2.default.createElement(_formik.Field, {
	                        'data-name': 'overview-quick-screener-credit-ratings-and-or',
	                        name: 'holdRatingAndOr',
	                        component: _twd.Fields.Checkbox,
	                        label: 'Results can match Moody\'s or S&P ratings selection'
	                    })
	                )
	            )
	        ),
	        !isTreasury && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            !hasRating && _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 col-md-12', hidden: isTreasury },
	                    _react2.default.createElement(_formik.Field, {
	                        'data-name': 'overview-quick-screener-exclude-callable',
	                        name: 'holdCallableInd',
	                        component: _twd.Fields.Checkbox,
	                        label: 'Exclude Callable'
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement('div', { className: 'row vertical-offset-base' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-md-12' },
	                _react2.default.createElement(_submitButton2.default, { errors: errors, values: values })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 text-center' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        'data-name': 'overview-quick-screener-advanced-screener',
	                        className: 'btn btn-link',
	                        onClick: function onClick() {
	                            var p = (0, _toSearchParams.toSearchParams)(values);
	                            if (!p.holdState) {
	                                p.holdState = [];
	                            }
	                            p.isEdit = true;
	
	                            (0, _twd.show)('advanced-screener', Object.assign({
	                                searchParams: p,
	                                _ts: Date.now(),
	                                from: 'overview'
	                            }));
	                        }
	                    },
	                    'Advanced Screener'
	                )
	            )
	        ),
	        _react2.default.createElement(_predefinedSearches2.default, { invType: values.invType })
	    );
	};
	
	var CD_BLUESKY_INFO = '\n<p>This filter ensures your search results do not contain any brokered CD offers which have\nBlue Sky restrictions in your state of residence.</p>\n\n<p>What are Blue Sky restrictions? Individual states have a set of securities laws,\ncommonly referred to as Blue Sky Laws, which govern the sale of securities in their state.\nThese laws, which vary by state, are established to protect investors from securities fraud.\nCD offerings from issuing banks that do not comply with a state\'s Blue Sky Laws\nare restricted from sale to residents of that state.</p>\n';

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var invType = _ref.invType;
	
	
	    var invTypeText = {
	        'C': 'Corporates',
	        'M': 'Municipals',
	        'S': 'CDs',
	        'T': 'U.S. Treasuries',
	        'A': 'Agencies'
	    }[invType] || '';
	
	    var searches = Searches.filter(function (s) {
	        return s.invType === invType;
	    });
	
	    var tip = ['<ul>Predefined Searches for ', invTypeText].concat(searches.map(function (a) {
	        return '<li><u>' + a.label + '</u>: ' + a.tip + '</li>';
	    })).concat('</ul>').join('');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(_twd.Flyout, {
	                    label: 'Predefined Searches',
	                    className: 'btn-label btn-flyout tiny-header vertical-offset-xs',
	                    dataName: 'overview-predefined-searches-info',
	                    html: tip
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                (0, _twd.arraySplit)(searches, 2).map(function (arr, i) {
	                    var _arr = _slicedToArray(arr, 2),
	                        a = _arr[0],
	                        b = _arr[1];
	
	                    return _react2.default.createElement(
	                        'div',
	                        { key: i, className: 'row' },
	                        a && _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6 col-xs-12 vertical-offset-xs' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'predefined-searches-row',
	                                    className: 'link-button text-left',
	                                    onClick: function onClick() {
	                                        return onSearch(a.searchParams, a.show);
	                                    }
	                                },
	                                a.label
	                            )
	                        ),
	                        b && _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-6 col-xs-12 vertical-offset-xs' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'predefined-searches-row',
	                                    className: 'link-button text-left',
	                                    onClick: function onClick() {
	                                        return onSearch(b.searchParams, b.show);
	                                    }
	                                },
	                                b.label
	                            )
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var onSearch = function onSearch(sp, nav) {
	    if (nav) return (0, _twd.show)(nav);
	    if (!sp) return;
	
	    (0, _twd.show)('offerings', {
	        searchParams: Object.assign({
	            persistToPreviousSearches: false
	        }, sp),
	        _ts: Date.now(),
	        from: 'overview'
	    });
	};
	
	var Searches = [{
	    invType: 'C',
	    label: 'High-Yield, Medium Term',
	    tip: 'This category features high yield (includes ratings between C/C \u2013 Ba1/BB+)\n        corporate bonds with a minimum 7% coupon rate, maturities ranging\n        between 5 and 10 years, and a semi-annual payment frequency.\n        All results displayed are from dealers offering a minimum of 10 bonds,\n        with an offering price between 95 and 120.',
	    searchParams: {
	        holdInvType: ['C'],
	        holdMoodyRatingMin: 'C',
	        holdMoodyRatingMax: 'Ba1',
	        holdSpRatingMin: 'C',
	        holdSpRatingMax: 'BB+',
	        holdCouponMin: 7,
	        holdMaturityMin: '5y',
	        holdMaturityMax: '10y',
	        holdCouponPayFrequency: ['S'],
	        clientPriceMin: 95,
	        clientPriceMax: 120,
	        quantityMin: 10,
	        holdCallableInd: ['N'],
	        holdConvertible: ['N'],
	        holdCouponTypeCode: ['FNZR'],
	        offeringType: ['secondary', 'ask-side'],
	        primarySecondary: ['secondary']
	    }
	}, {
	    invType: 'C',
	    label: 'New Issue Corp Notes',
	    tip: 'This category features new issue corporate notes.',
	    searchParams: {
	        holdInvType: ['C'],
	        offeringType: ['primary', 'ask-side'],
	        primarySecondary: ['primary']
	    }
	}, {
	    invType: 'C',
	    label: 'Convertibles',
	    tip: 'This category features convertible corporate bonds.',
	    searchParams: {
	        holdInvType: ['C'],
	        holdConvertible: ['Y'],
	        offeringType: ['secondary', 'ask-side'],
	        primarySecondary: ['secondary']
	    }
	}, {
	    invType: 'C',
	    label: 'Step-Ups',
	    tip: 'This category features investment grade (Baa3/BBB- and above)\n        corporate bonds with step-up coupon rates. Non-callable bonds\n        and those featuring a make-whole call provision are included.',
	    searchParams: {
	        holdInvType: ['C'],
	        holdMoodyRatingMin: 'Baa3',
	        holdSpRatingMin: 'BBB-',
	        holdCouponTypeCode: ['MULTI-STEP'],
	        holdCallableInd: ['N'],
	        holdWholeCallInd: ['Y'],
	        offeringType: ['secondary', 'ask-side'],
	        primarySecondary: ['secondary']
	    }
	}, {
	    invType: 'M',
	    label: 'Nationals Priced Near Par',
	    tip: 'This category features investment grade (Baa3/BBB- and above)\n        municipal bonds with a minimum 4% coupon and minimum yield-to-worst\n        of 1% available across all US states.  All bonds feature maturities\n        ranging between 5 and 10 years, and a semi-annual payment frequency.\n        All results displayed are from dealers offering a minimum of 10 bonds,\n        with an offering price between 95 and 105.',
	    searchParams: {
	        holdInvType: ['M'],
	        holdMoodyRatingMin: 'Baa3',
	        holdSpRatingMin: 'BBB-',
	        holdCouponMin: 4,
	        offerYtwMin: 1,
	        ytwMin: 1,
	        holdMaturityMin: '5y',
	        holdMaturityMax: '10y',
	        holdCouponPayFrequency: ['S'],
	        clientPriceMin: 95,
	        clientPriceMax: 105,
	        quantityMin: 10,
	        holdCouponTypeCode: ["FNZR"],
	        holdTaxable: ['N'],
	        holdStateTaxExempt: ['Y'],
	        holdAltMinTax: ['N'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'M',
	    label: 'Pre-Refunded, Short-Term',
	    tip: 'This category features investment grade (Baa3/BBB- and above)\n        pre-refunded municipal bonds with maturities ranging between 1 and 5 years,\n        and a semi-annual payment frequency. All results displayed are from dealers\n        offering a minimum of 10 bonds, with an offering price between 95 and 120.',
	    searchParams: {
	        holdInvType: ['M'],
	        holdMoodyRatingMin: 'Baa3',
	        holdSpRatingMin: 'BBB-',
	        holdRefundInd: ['Y'],
	        holdRefundType: ['PRE'],
	        holdMaturityMin: '1y',
	        holdMaturityMax: '5y',
	        holdCouponPayFrequency: ['S'],
	        quantityMin: 10,
	        clientPriceMin: 95,
	        clientPriceMax: 120,
	        holdTaxable: ['N'],
	        holdStateTaxExempt: ['Y'],
	        holdAltMinTax: ['N'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'M',
	    label: 'Zeroes, Medium-Term',
	    tip: 'This category features investment grade (Baa3/BBB- and above)\n        zero coupon municipal bonds with maturities ranging between 5 and 10 years,\n        and semi-annual interest payments. All results displayed are\n        from dealers offering a minimum of 10 bonds.',
	    searchParams: {
	        holdInvType: ['M'],
	        holdMoodyRatingMin: 'Baa3',
	        holdSpRatingMin: 'BBB-',
	        holdCouponTypeCode: ['ZR'],
	        holdMaturityMin: '5y',
	        holdMaturityMax: '10y',
	        holdCouponPayFrequency: ['S'],
	        quantityMin: 10,
	        holdTaxable: ['N'],
	        holdStateTaxExempt: ['Y'],
	        holdAltMinTax: ['N'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'M',
	    label: 'Green Bonds',
	    tip: 'This category includes municipal bonds classified as green bonds,\n        clean renewable energy bonds or qualified energy conservation bonds.',
	    searchParams: {
	        holdInvType: ['M'],
	        holdIssueType: ['Envrnmntl', 'Green', 'NCREB', 'NCRED', 'QECB', 'QECBD'],
	        holdTaxable: ['N'],
	        holdStateTaxExempt: ['Y'],
	        holdAltMinTax: ['N'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'T',
	    label: 'T-Bills',
	    tip: 'This category includes US Treasury Bills with maturities up to one year.',
	    searchParams: {
	        holdInvType: ['T'],
	        holdTreasuryType: ['Bills'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'T',
	    label: 'T-Notes',
	    tip: 'This category includes US Treasury Notes with maturities ranging\n        from 2 to 10 years.',
	    searchParams: {
	        holdInvType: ['T'],
	        holdTreasuryType: ['Notes'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'T',
	    label: 'Inflation-Protected TIPS',
	    tip: 'This category includes Treasury Inflation-Protected Securities.',
	    searchParams: {
	        holdInvType: ['T'],
	        holdTreasuryType: ['TIPS'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'T',
	    label: 'Zeroes, Short-term',
	    tip: 'This category includes short-term zero-coupon treasury bonds (STRIPS)\n        with maturities ranging between 1 to 5 years.',
	    searchParams: {
	        holdInvType: ['T'],
	        holdTreasuryType: ['STRIPS'],
	        holdMaturityMin: '1y',
	        holdMaturityMax: '5y',
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'T',
	    label: 'New Issue Auctions',
	    tip: 'This category includes new issue Treasury Auctions.',
	    show: 'tools.treasury-auctions'
	}, {
	    invType: 'S',
	    label: 'New Issue, Short-Term',
	    tip: 'This category includes short-term new issue CDs with maturities\n        up to one year.',
	    searchParams: {
	        holdInvType: ['S'],
	        holdMaturityMax: '1y',
	        offeringType: ['primary', 'ask-side'],
	        primarySecondary: ['primary']
	    }
	}, {
	    invType: 'S',
	    label: 'New Issue, Medium-Term',
	    tip: 'This category includes medium-term new issue CDs with maturities\n        ranging between 1 and 3 years.',
	    searchParams: {
	        holdInvType: ['S'],
	        holdMaturityMin: '1y',
	        holdMaturityMax: '3y',
	        offeringType: ['primary', 'ask-side'],
	        primarySecondary: ['primary']
	    }
	}, {
	    invType: 'S',
	    label: 'Monthly Coupon Payers',
	    tip: 'This category includes CDs only with monthly interest payments',
	    searchParams: {
	        holdInvType: ['S'],
	        holdCouponPayFrequency: ['M'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'S',
	    label: 'Step-ups',
	    tip: 'This category includes CDs with step-up coupons.',
	    searchParams: {
	        holdInvType: ['S'],
	        holdCouponTypeCode: ['MULTI-STEP'],
	        offeringType: ['ask-side']
	    }
	}, {
	    invType: 'A',
	    label: 'Tax-Advantaged',
	    tip: 'This category includes tax-advantaged agency bonds issued by\n        the Federal Home Loan Banks (FHLB), Federal Farm Credit Banks (FFCB)\n        and the Tennessee Valley Authority (TVA).',
	    searchParams: {
	        holdInvType: ['A'],
	        holdAgencyType: ['FHLB', 'FFCB', 'TVA'],
	        offeringType: ['ask-side']
	    }
	
	}];

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(329);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _form = __webpack_require__(1094);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _formik = __webpack_require__(62);
	
	var _useQuickScreener2 = __webpack_require__(328);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'quick-screener', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'overview-quick-screener', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                _useQuickScreener2.ContextProvider,
	                null,
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'row' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-8' },
	                        (0, _core.jsx)(
	                            'h3',
	                            { className: 'medium-header' },
	                            'Quick Screener'
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'col-xs-4 text-right' },
	                        (0, _core.jsx)(
	                            'button',
	                            {
	                                type: 'button',
	                                'data-name': 'overview-quick-screener-clear-all',
	                                className: 'link-button',
	                                onClick: function onClick() {
	                                    (0, _twd.publish)('overview_quick_screener_clear_all', true);
	                                }
	                            },
	                            'Clear All '
	                        )
	                    )
	                ),
	                (0, _core.jsx)(FormMain, null)
	            )
	        )
	    );
	}; /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var FormMain = function FormMain() {
	    var _useQuickScreener = (0, _useQuickScreener2.useQuickScreener)(),
	        state = _useQuickScreener.state,
	        onValidate = _useQuickScreener.onValidate,
	        onSubmit = _useQuickScreener.onSubmit;
	
	    var values = state.value.currentValues;
	    if (!values.muniStates) {
	        var defaultState = (0, _twd.getConfig)('account_states.0.stateOfResidence', '');
	        values.muniStates = defaultState ? ['holdState=' + defaultState] : [];
	        values.cdBlueSky = defaultState ? ['holdBlueSkyStateCD=' + defaultState] : [];
	    }
	
	    return (0, _core.jsx)(_formik.Formik, {
	        initialValues: values,
	        onSubmit: onSubmit,
	        component: _form2.default,
	        validate: onValidate,
	        validateOnBlur: true,
	        validateOnChange: true
	    });
	};

/***/ },
/* 1097 */
[2038, 328, 327],
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toSearchParams = __webpack_require__(327);
	
	var _twd = __webpack_require__(2);
	
	exports.default = function (values) {
	    if (!values) return;
	
	    var p = (0, _toSearchParams.toSearchParams)(values);
	    setTimeout(function () {
	        (0, _twd.trackSearch)('Overview Quick Screener', p);
	    });
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: Object.assign(p, { persistToPreviousSearches: true }),
	        _ts: Date.now(),
	        from: 'overview'
	    }));
	};

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ratings = __webpack_require__(197);
	
	var _twd = __webpack_require__(2);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-use-before-define */
	
	exports.default = function (values) {
	    checkRatingIndicator(values);
	
	    return Object.assign({}, validateMaturity(values, 'holdMaturity'), validateNumbers(values, 'quantity'), validateNumbers(values, 'offerYtw'), validateNumbers(values, 'clientPrice'), validateRatings(values, 'holdSpRating', _ratings.spRatings), validateRatings(values, 'holdMoodyRating', _ratings.moodysRatings));
	};
	
	var checkRatingIndicator = function checkRatingIndicator(values) {
	    var sMin = values.holdSpRatingMin,
	        sMax = values.holdSpRatingMax,
	        mMin = values.holdMoodyRatingMin,
	        mMax = values.holdMoodyRatingMax;
	
	
	    if (sMin === 'BBB-' && sMax === 'AAA' && mMin === 'Baa3' && mMax === 'Aaa') {
	        values.rating = 'investment-grade';
	    } else if (sMin === 'C' && sMax === 'BB+' && mMin === 'C' && mMax === 'Ba1') {
	        values.rating = 'high-yield';
	    } else if (sMin === 'ALL' && sMax === 'ALL' && mMin === 'ALL' && mMax === 'ALL') {
	        values.rating = 'all-ratings';
	    } else {
	        values.rating = '';
	    }
	};
	
	var validateRatings = function validateRatings(values, name, ratings) {
	    var min = ratings.indexOf(values[name + 'Min']);
	    var max = ratings.indexOf(values[name + 'Max']);
	    var e = {};
	    if (max > min) {
	        e[name] = 'Please enter higher ratings';
	    }
	    return e;
	};
	
	var validateMaturity = function validateMaturity(values, name) {
	    var min = (0, _twd.parseDate)(values[name + 'Min']);
	    var max = (0, _twd.parseDate)(values[name + 'Max'], true);
	    if (max < min) {
	        return _defineProperty({}, name, 'Please select later date');
	    }
	};
	
	var validateNumbers = function validateNumbers(values, name) {
	    var min = parseFloat(values[name + 'Min']);
	    var max = parseFloat(values[name + 'Max']);
	    var e = {};
	    if (max < min) {
	        e[name] = 'Please enter max > min';
	    }
	    return e;
	};

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _core = __webpack_require__(9);
	
	var _style = __webpack_require__(329);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _treasuryChart = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** @jsx jsx */
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { id: 'charts', className: 'vertical-offset-sm' }),
	        (0, _core.jsx)(
	            'div',
	            { 'data-name': 'overview-charts', className: 'container vertical-offset-sm', css: _style.sectionCss },
	            (0, _core.jsx)('div', { className: 'row vertical-offset-sm' }),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'medium-header' },
	                        'Charts'
	                    )
	                )
	            ),
	            (0, _core.jsx)(_treasuryChart.ChartTable, null)
	        )
	    );
	};

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var data = _ref.data,
	        index = _ref.index,
	        table = _ref.table;
	
	    var t = index === 0 ? data.displayName : formatYield(data.yield);
	
	    var _React$useState = _react2.default.useState(t),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        text = _React$useState2[0],
	        setText = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(data.id),
	        _React$useState4 = _slicedToArray(_React$useState3, 1),
	        cellId = _React$useState4[0];
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('yield_bucket.yield_grid_' + cellId, function (_ref2) {
	            var id = _ref2.id,
	                value = _ref2.value;
	
	            return id === cellId && setText(formatYield(value));
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    var q = data.queryText;
	    if (!q) return text;
	
	    if (text === '-') return text;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'overview-yield-grids-cell',
	            'data-cell-id': cellId,
	            'data-table': table,
	            'data-row': data.headerName,
	            'data-column': data.colName,
	            onClick: function onClick() {
	                return onSearch((0, _twd.parseJson)(q));
	            },
	            className: 'link-button text-left' },
	        text
	    );
	};
	
	var formatYield = function formatYield(x) {
	    var a = parseFloat(x);
	    if (isNaN(a)) return '-';
	
	    var s = a.toFixed(3);
	    if (s === '0.000') return '-';
	    return s + '%';
	};
	
	var onSearch = function onSearch(p) {
	    if (!p) return;
	    Object.assign(p, {
	        respectSplitRating: true,
	        persistToPreviousSearches: false,
	        sort: [{ field: 'askYield', direction: 'DESC' }]
	    });
	    delete p['savedQuickPickId'];
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: p,
	        _ts: Date.now(),
	        from: 'overview'
	    }));
	};

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    var s = (0, _twd.yieldGridLastUpdated)();
	    return _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-8' },
	            s ? s + ' \xA0 | \xA0 ' : '',
	            'Yields update as prices change, and may be delayed.  Please see disclosures.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12 col-md-4 text-right' },
	            _react2.default.createElement(_twd.Disclosures, {
	                dataName: 'overview-yield-grid-disclosures-link',
	                label: 'Disclosures',
	                html: DISCLOSURES })
	        )
	    );
	};
	
	var DISCLOSURES = '\n    <p>\n    The Yield by Category table can be sorted by highest or average yield.\n    By default, the table is configured to display the highest available yield on\n    the Tradeweb dealer network aligned with each asset class and maturity.\n    To view the average yield amongst available offers for a given asset class and maturity,\n    simply click the "Average Yield" toggle above the table.\n    </p>\n    <p>\n    The yield values displayed represent the existence of a minimum of 10 bonds ($1,000 face value)\n    available at the respective credit ratings (as designated by Moody\'s or S&P) for which the ask price\n    is between 85 and 120, excluding zero-coupon bonds (US Treasury Zeroes).\n    </p>\n    <p>\n    Yields displayed within the grid will update in response to changes in available offerings and offering prices.\n    These yields will update as offer pricing changes throughout the trading day and may be delayed.\n    </p>';

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var state = (0, _twd.getState)('overview.yield-grids', {
	    method: 'HIGHEST'
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.method || 'HIGHEST'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        method = _React$useState2[0],
	        setMethod_ = _React$useState2[1];
	
	    var setMethod = _react2.default.useCallback(function (m) {
	        state.set({ method: m });
	        setMethod_(m);
	    }, []);
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        grids = _React$useState4[0],
	        setGrids = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        status = _React$useState6[0],
	        setStatus = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(Date.now()),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        ts = _React$useState8[0],
	        setTs = _React$useState8[1];
	
	    _react2.default.useEffect(function () {
	
	        setGrids([]);_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref2, data, x, t, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	
	                            setStatus(_twd.Status.LOADING);
	
	                            _context.next = 4;
	                            return (0, _twd.ajax)({
	                                url: '/esb/retailservice/yieldGridService/getYieldGridDataByType',
	                                method: 'POST',
	                                params: {
	                                    brand: 'etrade' || (0, _twd.getBrand)(),
	                                    yieldGridTypeList: [{
	                                        gridType: 'OVERVIEW',
	                                        yieldType: method
	                                    }]
	                                }
	                            });
	
	                        case 4:
	                            _ref2 = _context.sent;
	                            data = _ref2.data;
	                            _context.next = 8;
	                            return data;
	
	                        case 8:
	                            x = _context.sent;
	                            t = method === 'HIGHEST' ? 'Highest Yield' : 'Average Yield';
	                            rs = (0, _twd.arrayFrom)(x[0].tables).map(function (a) {
	                                return Object.assign(a, { table: t });
	                            });
	
	                            setGrids(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 18;
	                            break;
	
	                        case 15:
	                            _context.prev = 15;
	                            _context.t0 = _context['catch'](0);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 18:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 15]]);
	        }))();
	    }, [method, ts]);
	
	    _react2.default.useEffect(function () {
	        var subId = (0, _twd.subscribe)('atmosphere_reconnected.overview_yield_grids', function (_ref3) {
	            var ts = _ref3.ts;
	
	            setTs(ts);
	        });
	        return function () {
	            (0, _twd.unsubscribe)(subId);
	        };
	    }, []);
	
	    return { method: method, setMethod: setMethod, grids: grids, status: status };
	};

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useYieldGrids = __webpack_require__(1103);
	
	var _useYieldGrids2 = _interopRequireDefault(_useYieldGrids);
	
	var _twd = __webpack_require__(2);
	
	var _footer = __webpack_require__(1102);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _cell = __webpack_require__(1101);
	
	var _cell2 = _interopRequireDefault(_cell);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _useYieldGrid = (0, _useYieldGrids2.default)(),
	        method = _useYieldGrid.method,
	        setMethod = _useYieldGrid.setMethod,
	        grids = _useYieldGrid.grids,
	        status = _useYieldGrid.status;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { 'data-name': 'overview-yield-grids', style: { background: "#ffffff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(
	                            'div',
	                            {
	                                'data-name': 'overview-yield-grids-nav-tabs',
	                                className: 'nav-tabs' },
	                            _react2.default.createElement(
	                                'ul',
	                                null,
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: method === 'HIGHEST' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'overview-yield-grids-highest-yield-nav-tab',
	                                            onClick: function onClick() {
	                                                return setMethod('HIGHEST');
	                                            } },
	                                        'Highest Yield'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: method === 'AVERAGE_10' ? 'active' : '' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        {
	                                            'data-name': 'overview-yield-grids-average-yield-nav-tab',
	                                            onClick: function onClick() {
	                                                return setMethod('AVERAGE_10');
	                                            } },
	                                        'Average Yield'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                _twd.Loading,
	                { status: status },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-base' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12' },
	                            _react2.default.createElement(Grids, { grids: grids }),
	                            _react2.default.createElement(_footer2.default, { grids: grids })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Grids = function Grids(_ref) {
	    var grids = _ref.grids;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        grids && grids.map(function (g, i) {
	            return _react2.default.createElement(Grid, { key: i, grid: g, index: i });
	        })
	    );
	};
	
	var Grid = function Grid(_ref2) {
	    var index = _ref2.index,
	        grid = _ref2.grid;
	
	    var w = (83.34 / (grid.columns.length - 1)).toFixed(2) + '%';
	
	    var rs = (grid.rows && [].concat(_toConsumableArray(grid.rows)) || []).map(function (r) {
	        return Object.assign(r, { table: grid.table });
	    });
	    rs.shift();
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            { 'data-name': 'overview-yield-grids-table-' + index, className: 'table' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    grid.columns && grid.columns.map(function (c, i) {
	                        return _react2.default.createElement(
	                            'th',
	                            { key: i,
	                                style: i === 0 ? { minWidth: '160px' } : {},
	                                width: i === 0 ? '16.66%' : w,
	                                className: i === 0 ? 'text-left' : 'text-right'
	                            },
	                            i === 0 ? _react2.default.createElement(
	                                'h6',
	                                { className: 'subhead', style: { marginBottom: 0 } },
	                                c
	                            ) : c
	                        );
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rs && rs.map(function (r, i) {
	                    return _react2.default.createElement(Row, { key: i, row: r });
	                })
	            )
	        )
	    );
	};
	
	var Row = function Row(_ref3) {
	    var row = _ref3.row;
	
	    return _react2.default.createElement(
	        'tr',
	        { 'data-name': 'overview-yield-grids-row' },
	        row.row && row.row.map(function (a, i) {
	            return _react2.default.createElement(
	                'td',
	                { key: i,
	                    className: i === 0 ? 'text-left' : 'text-right' },
	                _react2.default.createElement(_cell2.default, { data: a, index: i, table: row.table })
	            );
	        })
	    );
	};

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icons = __webpack_require__(330);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row text-center prospect vertical-offset-sm' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'flex-xs-12 flex-md-6 auto-margin' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Instant analysis of your portfolio'
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'View market data, performance reports, and income outlook of your bond portfolio holdings.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-group' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 purple-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.executive_summary,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'Executive',
	                                    _react2.default.createElement('br', null),
	                                    'summary'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'Get a snapshot view of your complete portfolio, including:',
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Summary totals and averages for portfolio holdings'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Asset class and credit quality diversification'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Maturity and duration exposure'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'executive_summary',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 purple-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.position_details,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'Position',
	                                    _react2.default.createElement('br', null),
	                                    'details'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'In-depth view on all fixed income positions in your portfolio, current evaluated pricing, and unrealized gain or loss calculations'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'position_details',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 purple-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.reinvestment_proceeds,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'Reinvestment',
	                                    _react2.default.createElement('br', null),
	                                    'proceeds'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'Gain quick perspective on upcoming reinvestment proceeds (coupon payments, maturing principal, called bond proceeds) due from your holdings'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'reinvestment_proceeds',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 purple-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.coupon_cashflow,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'Coupon',
	                                    _react2.default.createElement('br', null),
	                                    'cash flow'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'Easily review and analyze your portfolio\u2019s income and forward-looking monthly cash flows based on:',
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Asset Class'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Distribution by taxable or tax-exempt positions'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Coupon payment date'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'coupon_cashflow',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 yellow-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.credit_ratings_history,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'Credit ratings',
	                                    _react2.default.createElement('br', null),
	                                    'history'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'Access current and historical credit rating history from Moody\u2019s and S&P, along with credit watch and outlook expectations'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'credit_ratings_history',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 yellow-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.muni_position_attributes,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'Muni position',
	                                    _react2.default.createElement('br', null),
	                                    'attributes'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'Acquire further insights on your municipal holdings with position analysis covering:',
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Type of Muni and Funding Purpose'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Holdings distribution by state'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Insurance and credit enhancements'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'muni_position_attributes',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 yellow-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.corp_position_attributes,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'Corp position',
	                                    _react2.default.createElement('br', null),
	                                    'attributes'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'Acquire further insights on your corporate holdings with position analysis covering:',
	                                _react2.default.createElement(
	                                    'ul',
	                                    null,
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Sector distribution'
	                                    ),
	                                    _react2.default.createElement(
	                                        'li',
	                                        null,
	                                        'Debt ranking distribution'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'corp_position_attributes',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3 yellow-top' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-body' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'prospect text-center' },
	                                _icons2.default.fdic_certificate_concentration,
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'card-title' },
	                                    'FDIC certificate #',
	                                    _react2.default.createElement('br', null),
	                                    'concentration'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-text vertical-offset-base' },
	                                'Understand your CD position concentration by individual FDIC Certificate Number'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-footer text-center' },
	                            _react2.default.createElement(
	                                'button',
	                                { className: 'btn-link',
	                                    onClick: function onClick(e) {
	                                        return (0, _all.showModal)({
	                                            view: 'portfolio-report-modal',
	                                            name: 'fdic_certificate_concentration',
	                                            source: e.target
	                                        });
	                                    }
	                                },
	                                'View example'
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement('div', { className: 'row vertical-offset-xxxl' })
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement('div', { className: 'row vertical-offset-xxxl' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card-group card-group-center' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card card-primary flex-xs-12 flex-md-5' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-body text-center' },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    'Questions regarding your Fixed Income Portfolio Report?'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'vertical-offset-sm' },
	                                    'Our Fixed Income Specialists can help provide additional clarity on your report. Call us at ',
	                                    _react2.default.createElement(
	                                        'a',
	                                        { style: { textDecoration: 'underline' }, alt: '877-355-3237', href: 'tel:18773553237', 'aria-label': '877-355-3237' },
	                                        '877-355-3237'
	                                    ),
	                                    ' for assistance.'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-lg btn-primary-outline',
	                                            onClick: function onClick() {
	                                                window.open("tel:18773553237");
	                                            }
	                                        },
	                                        'Call now'
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card card-primary flex-xs-12 flex-md-5' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'card-body text-center' },
	                                _react2.default.createElement(
	                                    'h2',
	                                    null,
	                                    'Personalized advice from a Morgan Stanley Financial Advisor'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'vertical-offset-sm' },
	                                    'Now that E*TRADE and Morgan Stanley have joined forces, you can work with a Morgan Stanley Financial Advisor for additional guidance and support managing your fixed income investments.'
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    null,
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-lg btn-primary-outline',
	                                            onClick: function onClick() {
	                                                (0, _twd.openWindow)("https://us.etrade.com/c/s/what-we-offer/msfa");
	                                            }
	                                        },
	                                        'Get advice'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'p',
	                                    { className: 'text-muted small' },
	                                    'Eligibility requirements apply.'
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'row vertical-offset-xxxl' })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement('div', { className: 'row vertical-offset-lg' }),
	            _react2.default.createElement(
	                'div',
	                { className: 'row xs-hide' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6', style: { height: '25px' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { display: 'inline', verticalAlign: 'bottom', height: '25px' } },
	                        'The bond resource center is powered by'
	                    ),
	                    _react2.default.createElement('img', { alt: 'tradeweb', 'aria-hidden': true, src: './resources/images/tradeweb-logo.svg' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6', style: { height: '25px' } },
	                    _react2.default.createElement(
	                        'div',
	                        { style: { position: 'absolute', right: 0, bottom: 0 } },
	                        'All data provided by Tradeweb Markets LLC unless otherwise noted.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row xs-show' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12 text-center' },
	                    'The bond resource',
	                    _react2.default.createElement('br', null),
	                    'center is powered by',
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('img', { alt: 'tradeweb', 'aria-hidden': true, src: './resources/images/tradeweb-logo.svg' }),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement('br', null),
	                    'All data provided by Tradeweb Market',
	                    _react2.default.createElement('br', null),
	                    'LLC unless otherwise noted.'
	                )
	            ),
	            _react2.default.createElement('div', { className: 'row vertical-offset-lg' })
	        )
	    );
	};

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _icons = __webpack_require__(330);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	var _formik = __webpack_require__(62);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var getAccounts = function getAccounts() {
	    return (0, _twd.arrayFrom)(global.app.config.accounts).filter(function (a) {
	        return a.positionCount > 0;
	    });
	};
	
	exports.default = function () {
	
	    var formRef = _react2.default.useRef(null);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_formik.Formik, {
	            component: Form,
	            initialValues: {
	                accounts: getAccounts().map(function (a) {
	                    return a.acctNo;
	                })
	            },
	            validate: function validate(values) {
	                return (0, _twd.cleanObject)({
	                    accounts: (0, _twd.arrayFrom)(values.accounts).length > 0 ? null : 'Please select at least 1 account'
	                });
	            },
	            validateOnBlur: true,
	            validateOnChange: true,
	            onSubmit: function onSubmit(values) {
	                var frm = formRef.current;
	                frm.accounts.value = (0, _twd.arrayFrom)(values.accounts).filter(Boolean).join();
	                frm.submit();
	            }
	        }),
	        _react2.default.createElement(
	            'form',
	            { ref: formRef,
	                method: 'POST',
	                action: (0, _twd.fixURL)('https://www.bonddesk.com/etrade/servlet/rtresult/dareport.pdf').toString(),
	                target: 'PortfolioReportWindow'
	            },
	            _react2.default.createElement('input', { type: 'hidden', name: 'dbname', value: 'SEC' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'reportname', value: 'CR_ANALYTICS_DEV.rpt' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'format', value: '5' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'accounts', value: '' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p1', value: 'Contact 1 is here' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p2', value: 'Contact 2 is here' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p3', value: 'Contact 3 is here' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p4', value: 'Contact 4 is here' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p5', value: 'Contact 5 is here' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p6', value: 'Contact 6 is here' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p7', value: '1' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p8', value: '1' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p9', value: '0' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p10', value: '3' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p11', value: '4' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p12', value: '5' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p13', value: '0' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p14', value: '6' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p15', value: '0' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p16', value: '1' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p17', value: '1' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p18', value: '16' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p19', value: '17' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p20', value: '' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p21', value: 'false' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p22', value: '' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p23', value: 'false' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p24', value: '0ACKMPROST' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p25', value: 'da_etrade_logo.jpg' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p26', value: 'da_etrade_logo.jpg' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p27', value: '0' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p28', value: '0' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p29', value: '0' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p30', value: 'pintroduction=0_pwatermark=0' }),
	            _react2.default.createElement('input', { type: 'hidden', name: 'p31', value: '0' })
	        )
	    );
	};
	
	var Form = function Form(_ref) {
	    var handleSubmit = _ref.handleSubmit,
	        values = _ref.values,
	        errors = _ref.errors;
	
	
	    var hasAccount = getAccounts().length > 0;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(
	                'div',
	                { className: 'card card-primary purple-top' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card-body' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row text-center' },
	                        _icons2.default.computerIcon,
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Generate a portfolio report'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-xxs' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'fieldset',
	                                null,
	                                _react2.default.createElement(_formik.FieldArray, {
	                                    name: 'accounts',
	                                    disabled: !hasAccount,
	                                    render: function render(args) {
	                                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({
	                                            dataName: 'portfolio-report-accounts',
	                                            label: 'Select one or more accounts to analyze',
	
	                                            emptyText: '',
	                                            error: errors.accounts,
	
	                                            showSelectAll: hasAccount,
	                                            allText: 'All accounts selected',
	                                            options: getAccounts().map(function (a) {
	                                                return { label: a.title, value: a.acctNo };
	                                            }),
	                                            style: { marginBottom: '0px' },
	                                            optionCheckboxLabelConfig: {
	                                                className: "text-truncate"
	                                            },
	
	                                            placeholder: function placeholder(_ref2) {
	                                                var emptyText = _ref2.emptyText,
	                                                    allText = _ref2.allText,
	                                                    values = _ref2.values,
	                                                    options = _ref2.options;
	
	                                                var isNone = (0, _twd.isEmpty)(values);
	                                                if (isNone) return emptyText;
	
	                                                var isAll = values.length > 0 && values.length === options.length;
	                                                if (isAll) return allText;
	
	                                                var selected = options.filter(function (a) {
	                                                    return values.indexOf(a.value) >= 0;
	                                                });
	
	                                                var n = selected.length;
	                                                if (n === 0) return emptyText;
	
	                                                return n + ' of ' + options.length + ' accounts selected';
	                                            }
	
	                                        }, args));
	                                    }
	                                }),
	                                _react2.default.createElement(
	                                    'label',
	                                    { className: 'field-status has-error' },
	                                    '\xA0 ',
	                                    errors.accounts
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row vertical-offset-sm' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    type: 'submit',
	                                    className: 'btn btn-primary btn-block',
	                                    disabled: Object.keys(errors).length > 0 || !hasAccount
	                                },
	                                'Generate report'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row ' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-md-12 text-center' },
	                            _react2.default.createElement(
	                                'div',
	                                { style: {
	                                        display: 'inline-flex',
	                                        alignItems: 'center',
	                                        verticalAlign: 'middle'
	                                    } },
	                                'Reports are in PDF format',
	                                _react2.default.createElement(
	                                    'span',
	                                    { style: {
	                                            display: 'inline-flex',
	                                            alignItems: 'center',
	                                            verticalAlign: 'middle',
	                                            marginLeft: '5px'
	                                        } },
	                                    _icons2.default.pdf
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-use-before-define */
	
	
	var sectionArray = [{
	    id: 'executive_summary',
	    label: 'Executive summary',
	    summary: 'Get a snapshot view of your complete portfolio, including summary totals, averages for portfolio holdings, asset class and credit quality diversification and maturity and duration exposure'
	}, {
	    id: 'position_details',
	    label: 'Position details',
	    summary: 'In-depth view on all fixed income positions in your portfolio, current evaluated pricing, and unrealized gains/loss calculations'
	}, {
	    id: 'reinvestment_proceeds',
	    label: 'Reinvestment proceeds',
	    summary: 'Gain quick perspective on upcoming reinvestment proceeds (coupon payments, maturing principal, called bond proceeds) due from your holdings'
	}, {
	    id: 'coupon_cashflow',
	    label: 'Coupon cash flow',
	    summary: 'Easily review and analyze your portfolios income and forward-looking monthly cash flows based on asset class, distribution by taxable or tax-exempt positions, and coupon payment date'
	}, {
	    id: 'credit_ratings_history',
	    label: 'Credit ratings history',
	    summary: 'Access current and historical credit rating history from Moody’s and S&P, along with credit watch and outlook expectations'
	}, {
	    id: 'muni_position_attributes',
	    label: 'Muni position attributes',
	    summary: 'Acquire further insights on your municipal holdings with position analysis covering the type of muni and funding purpose, the holdings distribution by state, and insurance and credit enhancements'
	}, {
	    id: 'corp_position_attributes',
	    label: 'Corp position attributes',
	    summary: 'Acquire further insights on your corporate holdings with position analysis covering sector distribution and debt ranking distribution'
	}, {
	    id: 'fdic_certificate_concentration',
	    label: 'FDIC certificate # concentration',
	    summary: 'Understand your CD position concentration by individual FDIC Certificate Number'
	}].map(function (r, i) {
	    return Object.assign({}, r, {
	        index: i,
	        src: './resources/images/portfolio-report-modal/' + r.id + '.jpg'
	    });
	});
	
	var sections = sectionArray.reduce(function (x, s) {
	    return Object.assign({}, x, _defineProperty({}, s.id, s));
	}, {});
	
	exports.default = function (_ref) {
	    var name = _ref.name,
	        from = _ref.from;
	
	    var _React$useState = _react2.default.useState(sections[name] || sectionArray[0]),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        section = _React$useState2[0],
	        setSection = _React$useState2[1];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'offerings-modal-close-link',
	                className: 'modal-dialog modal-lg report' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content', style: { padding: '30px 14px' } },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'close',
	                            'aria-label': 'close',
	                            'data-name': 'offerings-modal-close-link',
	                            type: 'button',
	                            onClick: function onClick() {
	                                (0, _twd.hideModal)();
	                            } },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'flex-xs-12 flex-md-8 text-center prospect auto-margin' },
	                            _react2.default.createElement(
	                                'h3',
	                                null,
	                                section.label
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                section.summary
	                            )
	                        )
	                    ),
	                    _react2.default.createElement('img', {
	                        alt: section.label,
	                        style: { width: '100%', objectFit: 'contain' },
	                        src: section.src
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container', style: { background: "#ffffff" } },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row vertical-offset-xs' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 select-wrapper text-center' },
	                                _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'portfolio-report-modal-select' },
	                                    'Explore other features:'
	                                ),
	                                '\xA0',
	                                _react2.default.createElement(
	                                    'select',
	                                    {
	                                        id: 'portfolio-report-modal-select',
	                                        className: 'form-control',
	                                        style: {
	                                            display: 'inline-block',
	                                            width: 'fit-content',
	                                            paddingRight: '25px',
	                                            marginLeft: '5px'
	                                        },
	                                        value: section.id,
	                                        onChange: function onChange(e) {
	                                            setSection(sections[e.target.value]);
	                                        }
	                                    },
	                                    sectionArray.map(function (a, i) {
	                                        return _react2.default.createElement(
	                                            'option',
	                                            { key: i, value: a.id },
	                                            a.label
	                                        );
	                                    })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row vertical-offset-sm' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 text-center' },
	                                _react2.default.createElement(
	                                    'ul',
	                                    { className: 'pagination' },
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'previous' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            {
	                                                className: 'btn-link',
	                                                disabled: section.index === 0,
	                                                'aria-label': 'previous',
	                                                onClick: function onClick() {
	                                                    setSection(sectionArray[section.index - 1]);
	                                                } },
	                                            _react2.default.createElement(
	                                                'i',
	                                                { className: 'material-icons', 'aria-hidden': 'true' },
	                                                'chevron_left'
	                                            )
	                                        )
	                                    ),
	                                    sectionArray.map(function (s, i) {
	                                        var isCurrent = section.index === i;
	                                        return _react2.default.createElement(
	                                            'li',
	                                            {
	                                                key: 'portfolio-report-modal-section-' + i,
	                                                className: isCurrent ? 'active' : ''
	                                            },
	                                            _react2.default.createElement(
	                                                'button',
	                                                Object.assign({
	                                                    className: 'btn-link'
	                                                }, isCurrent ? {
	                                                    'aria-current': 'page',
	                                                    style: {
	                                                        color: '#242424',
	                                                        fontWeight: '500',
	                                                        textDecoration: 'none',
	                                                        cursor: 'not-allowed',
	                                                        pointerEvents: 'none'
	                                                    } } : {}, {
	                                                    'aria-label': 'page ' + (i + 1) + ' ' + s.label,
	                                                    onClick: function onClick() {
	                                                        if (isCurrent) return;
	                                                        setSection(sectionArray[i]);
	                                                    }
	                                                }),
	                                                i + 1
	                                            )
	                                        );
	                                    }),
	                                    _react2.default.createElement(
	                                        'li',
	                                        { className: 'next' },
	                                        _react2.default.createElement(
	                                            'button',
	                                            {
	                                                className: 'btn-link',
	                                                disabled: section.index === sectionArray.length - 1,
	                                                'aria-label': 'next',
	                                                onClick: function onClick() {
	                                                    setSection(sectionArray[section.index + 1]);
	                                                } },
	                                            _react2.default.createElement(
	                                                'i',
	                                                { className: 'material-icons', 'aria-hidden': 'true' },
	                                                'chevron_right'
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'row vertical-offset-xs' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'col-md-12 text-center' },
	                                _react2.default.createElement(
	                                    'button',
	                                    {
	                                        className: 'btn-link',
	                                        'aria-label': 'close',
	                                        'data-name': 'portfolio-report-modal-close-link',
	                                        type: 'button',
	                                        onClick: function onClick() {
	                                            (0, _twd.hideModal)();
	                                        } },
	                                    'Close'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _icons = __webpack_require__(330);
	
	var _icons2 = _interopRequireDefault(_icons);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'card card-primary purple-top' },
	            _react2.default.createElement(
	                'div',
	                { className: 'card-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row text-center' },
	                    _icons2.default.dollarIcon,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Add fixed income positions to access this report'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-sm' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12' },
	                        'View market data, performance reports, and income outlook of fixed income positions in your portfolio.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-xs' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 text-center' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-lg btn-primary-outline',
	                                onClick: function onClick() {
	                                    (0, _twd.openWindow)("https://us.etrade.com/knowledge/library/bonds-cds");
	                                }
	                            },
	                            'Knowledge Library'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row ' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-12 text-center' },
	                        _react2.default.createElement(
	                            'button',
	                            { className: 'btn btn-lg btn-primary-outline',
	                                onClick: function onClick() {
	                                    (0, _twd.show)('advanced-screener');
	                                }
	                            },
	                            'Advanced Screener'
	                        )
	                    )
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	__webpack_require__(1784);
	
	var _examples = __webpack_require__(1105);
	
	var _examples2 = _interopRequireDefault(_examples);
	
	var _footer = __webpack_require__(1106);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _form = __webpack_require__(1107);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _noAccount = __webpack_require__(1109);
	
	var _noAccount2 = _interopRequireDefault(_noAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getAccounts = function getAccounts() {
	    return (0, _twd.arrayFrom)(global.app.config.accounts).filter(function (a) {
	        return a.positionCount > 0;
	    });
	}; /* eslint-disable no-use-before-define */
	
	exports.default = function () {
	    (0, _twd.trackPage)('portfolio-report');
	
	    var hasAccount = getAccounts().length > 0;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'report' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container Top vertical-offset-lg' },
	                _react2.default.createElement('div', { className: 'row vertical-offset-md' }),
	                _react2.default.createElement('div', { className: 'row vertical-offset-md xs-hide' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-7 prospect' },
	                        _react2.default.createElement('div', { className: 'row vertical-offset-md' }),
	                        _react2.default.createElement('div', { className: 'row vertical-offset-md xs-hide' }),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Fixed Income Portfolio Report'
	                        ),
	                        _react2.default.createElement(
	                            'h1',
	                            null,
	                            'Complete Insight,',
	                            _react2.default.createElement('br', null),
	                            'Clearly Delivered'
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            null,
	                            'Without the right tools, managing and tracking a sizable bond portfolio can be a challenge. E*TRADE\'s new and improved',
	                            _react2.default.createElement('br', null),
	                            'Fixed Income Portfolio Report can give you the robust analysis',
	                            _react2.default.createElement('br', null),
	                            'you need\u2014right at your fingertips.'
	                        ),
	                        _react2.default.createElement('div', { className: 'row vertical-offset-sm' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-md-4 half-col' },
	                        hasAccount ? _react2.default.createElement(_form2.default, null) : _react2.default.createElement(_noAccount2.default, null)
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'row vertical-offset-md' }),
	                _react2.default.createElement('div', { className: 'row vertical-offset-md xs-hide' })
	            ),
	            _react2.default.createElement(_examples2.default, null),
	            _react2.default.createElement(_footer2.default, null)
	        )
	    );
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _core = __webpack_require__(9);
	
	var _useManageSavedSearches = __webpack_require__(1112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        saving = _React$useState2[0],
	        setSaving = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(1),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        page = _React$useState4[0],
	        setPage = _React$useState4[1];
	
	    var _useManageSavedSearch = (0, _useManageSavedSearches.useManageSavedSearches)(),
	        rows = _useManageSavedSearch.rows,
	        setRows = _useManageSavedSearch.setRows,
	        status = _useManageSavedSearch.status;
	
	    var pageSize = 10;
	    var rowsNotDeleted = rows.filter(function (r) {
	        return !r.deleted;
	    });
	    var hasDeleted = rowsNotDeleted.length !== rows.length;
	
	    _react2.default.useEffect(function () {
	        setTimeout(function () {
	            (0, _twd.$)('#modal :focusable').eq(0).focus();
	        }, 200);
	    }, [status]);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'modal-dialog modal-md' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'modal-content' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'modal-header' },
	                    (0, _core.jsx)(
	                        'button',
	                        {
	                            'data-name': 'saved-searches-manage-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        (0, _core.jsx)(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    (0, _core.jsx)(
	                        'h3',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        'Manage saved searches'
	                    ),
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-xs-12 col-md-12 table-responsive' },
	                            (0, _core.jsx)(
	                                _twd.Loading,
	                                { status: status },
	                                (0, _core.jsx)(
	                                    'table',
	                                    {
	                                        'data-name': 'saved-searches-manage-table',
	                                        className: 'table table-hover align-top',
	                                        css: tableCss
	                                    },
	                                    (0, _core.jsx)(
	                                        'thead',
	                                        null,
	                                        (0, _core.jsx)(
	                                            'tr',
	                                            null,
	                                            (0, _core.jsx)(
	                                                'th',
	                                                null,
	                                                'Name'
	                                            ),
	                                            (0, _core.jsx)(
	                                                'th',
	                                                null,
	                                                'Last Modified'
	                                            ),
	                                            (0, _core.jsx)('th', { style: { width: "65px" } })
	                                        )
	                                    ),
	                                    (0, _core.jsx)(
	                                        'tbody',
	                                        null,
	                                        (0, _core.jsx)(List, { rows: rows, setRows: setRows, saving: saving, page: page, size: pageSize })
	                                    )
	                                ),
	                                rowsNotDeleted.length > pageSize && (0, _core.jsx)(
	                                    'div',
	                                    { className: 'text-center' },
	                                    (0, _core.jsx)(_twd.Paging, { total: rowsNotDeleted.length, page: page, setPage: setPage, size: pageSize })
	                                )
	                            )
	                        )
	                    )
	                ),
	                status !== _twd.Status.LOADING && (0, _core.jsx)(
	                    'div',
	                    { className: 'modal-footer' },
	                    (0, _core.jsx)(
	                        'div',
	                        { className: 'row' },
	                        (0, _core.jsx)(
	                            'div',
	                            { className: 'col-centered-8' },
	                            (0, _core.jsx)(
	                                'button',
	                                {
	                                    'data-name': 'saved-searches-manage-save',
	                                    className: 'btn btn-block btn-lg btn-primary',
	                                    type: 'button',
	                                    disabled: saving || !hasDeleted,
	                                    onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                                        var deletedIds;
	                                        return _regenerator2.default.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        setSaving(true);
	                                                        _context.next = 3;
	                                                        return (0, _useManageSavedSearches.deleteSavedSearches)(rows);
	
	                                                    case 3:
	                                                        deletedIds = _context.sent;
	
	                                                        (0, _twd.hideModal)();
	                                                        (0, _twd.publish)('manage_saved_searches', { deletedIds: deletedIds });
	
	                                                    case 6:
	                                                    case 'end':
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, undefined);
	                                    }))
	                                },
	                                'Save'
	                            ),
	                            (0, _core.jsx)(
	                                'button',
	                                {
	                                    'data-name': 'saved-searches-manage-cancel',
	                                    className: 'btn btn-block btn-lg btn-link',
	                                    type: 'button',
	                                    onClick: _twd.hideModal
	                                },
	                                'Cancel'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var List = function List() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        rows = _ref2.rows,
	        setRows = _ref2.setRows,
	        saving = _ref2.saving,
	        _ref2$page = _ref2.page,
	        page = _ref2$page === undefined ? 1 : _ref2$page,
	        _ref2$size = _ref2.size,
	        size = _ref2$size === undefined ? 3 : _ref2$size;
	
	    var n = Math.max((page - 1) * size, 0);
	
	    return rows.filter(function (r) {
	        return !r.deleted;
	    }).slice(n, n + size).map(function (r, i) {
	        return (0, _core.jsx)(
	            'tr',
	            {
	                'data-name': 'saved-searches-manage-row',
	                key: i
	            },
	            (0, _core.jsx)(
	                'td',
	                { className: 'text-truncate text-bold' },
	                (0, _core.jsx)(Item, { row: r })
	            ),
	            (0, _core.jsx)(
	                'td',
	                null,
	                _twd.fmt.date(r.modified)
	            ),
	            (0, _core.jsx)(
	                'td',
	                null,
	                (0, _core.jsx)(
	                    'button',
	                    {
	                        'data-name': 'saved-searches-manage-delete',
	                        className: 'btn btn-sm btn-primary-outline',
	                        disabled: saving,
	                        onClick: function onClick() {
	                            r.deleted = true;
	                            setRows([].concat(rows));
	                        }
	                    },
	                    'Delete'
	                )
	            )
	        );
	    });
	};
	
	var tableCss = _defineProperty({}, _twd.mediaQueries.notXs, {
	    tableLayout: 'fixed',
	
	    '& td': {
	        whiteSpace: 'nowrap',
	        overflow: 'hidden',
	        textOverflow: 'ellipsis'
	    }
	});
	
	var Item = function Item(_ref3) {
	    var row = _ref3.row;
	
	    return (0, _core.jsx)(
	        'button',
	        {
	            'data-name': 'saved-searches-manage-item',
	            className: 'btn-link',
	            onClick: function onClick() {
	                onSearch(row);
	            }
	        },
	        row.description
	    );
	};
	
	var onSearch = function onSearch(_ref4) {
	    var searchParams = _ref4.searchParams;
	
	    (0, _twd.hideModal)();
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: (0, _twd.cleanObject)(searchParams),
	        _ts: Date.now(),
	        from: 'advanced-screener'
	    }));
	};

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.useManageSavedSearches = exports.deleteSavedSearches = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var deleteSavedSearches = exports.deleteSavedSearches = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(rows) {
	        var deletedIds, _ajax, data, _;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        deletedIds = (0, _twd.arrayFrom)(rows).filter(function (r) {
	                            return r.deleted;
	                        }).map(function (r) {
	                            return r.id;
	                        });
	
	                        if (!(0, _twd.isEmpty)(deletedIds)) {
	                            _context.next = 3;
	                            break;
	                        }
	
	                        return _context.abrupt('return', deletedIds);
	
	                    case 3:
	                        _ajax = (0, _twd.ajax)({
	                            url: '/esb/portfolio/savedQueryDeleteList',
	                            method: 'POST',
	                            params: deletedIds
	                        }), data = _ajax.data;
	                        _context.next = 6;
	                        return data;
	
	                    case 6:
	                        _ = _context.sent;
	                        return _context.abrupt('return', deletedIds);
	
	                    case 8:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function deleteSavedSearches(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var useManageSavedSearches = exports.useManageSavedSearches = function useManageSavedSearches() {
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState([]),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        rows = _React$useState4[0],
	        setRows = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	            var _ajax2, data, rs;
	
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            if (!(status !== _twd.Status.LOADING)) {
	                                _context2.next = 2;
	                                break;
	                            }
	
	                            return _context2.abrupt('return');
	
	                        case 2:
	                            _context2.prev = 2;
	                            _ajax2 = (0, _twd.ajax)({
	                                url: '/esb/portfolio/savedQuerySearchByCurrentUser',
	                                method: 'GET'
	                            }), data = _ajax2.data;
	                            _context2.next = 6;
	                            return data;
	
	                        case 6:
	                            _context2.t0 = _context2.sent;
	
	                            if (_context2.t0) {
	                                _context2.next = 9;
	                                break;
	                            }
	
	                            _context2.t0 = [];
	
	                        case 9:
	                            _context2.t1 = function (a) {
	                                a.modified = new Date(a.modified + ' GMT');
	                                a.queryText = (0, _twd.parseJson)(a.formText);
	                                a.searchParams = (a.queryText || {}).metadata || a.queryText || {};
	                                return a;
	                            };
	
	                            _context2.t2 = function (a) {
	                                return a.searchParams.searchType === 'offers';
	                            };
	
	                            _context2.t3 = function (a, b) {
	                                return b.modified.valueOf() - a.modified.valueOf();
	                            };
	
	                            rs = _context2.t0.map(_context2.t1).filter(_context2.t2).sort(_context2.t3);
	
	
	                            setRows(rs);
	                            setStatus(_twd.Status.LOADED);
	                            _context2.next = 20;
	                            break;
	
	                        case 17:
	                            _context2.prev = 17;
	                            _context2.t4 = _context2['catch'](2);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 20:
	                        case 'end':
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, undefined, [[2, 17]]);
	        }))();
	    }, [status]);
	
	    return { status: status, rows: rows, setRows: setRows };
	};

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$params = _ref.params,
	        params = _ref$params === undefined ? {} : _ref$params;
	
	    var _React$useState = _react2.default.useState(params.description || ''),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        searchName = _React$useState2[0],
	        setSearchName = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        saving = _React$useState4[0],
	        setSaving = _React$useState4[1];
	
	    var title = params.id ? 'Update search' : 'Save search';
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-dialog modal-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'data-name': 'saved-searches-save-search-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'modal-title text-center vertical-offset-sm' },
	                        title
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row form-group subhead' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-xs-12 col-md-12' },
	                            _react2.default.createElement(
	                                'label',
	                                null,
	                                'Name'
	                            ),
	                            _react2.default.createElement('input', {
	                                'data-name': 'saved-searches-save-search-name',
	                                type: 'text',
	                                className: 'form-control',
	                                value: searchName,
	                                disabled: saving,
	                                onChange: function onChange(e) {
	                                    var s = e.target.value;
	                                    setSearchName(s);
	                                }
	                            })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'row' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'col-centered-8' },
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'saved-searches-save-search-save',
	                                    className: 'btn btn-block btn-lg btn-primary',
	                                    type: 'button',
	                                    disabled: !searchName || saving,
	                                    onClick: _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                                        var p, r;
	                                        return _regenerator2.default.wrap(function _callee$(_context) {
	                                            while (1) {
	                                                switch (_context.prev = _context.next) {
	                                                    case 0:
	                                                        setSaving(true);
	                                                        p = Object.assign({}, params, { description: searchName.trim() });
	                                                        _context.next = 4;
	                                                        return onSave({ params: p });
	
	                                                    case 4:
	                                                        r = _context.sent;
	
	                                                        (0, _twd.hideModal)();
	                                                        (0, _twd.publish)('search_saved', r);
	
	                                                    case 7:
	                                                    case 'end':
	                                                        return _context.stop();
	                                                }
	                                            }
	                                        }, _callee, undefined);
	                                    }))
	                                },
	                                'Save'
	                            ),
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    'data-name': 'saved-searches-save-search-cancel',
	                                    className: 'btn btn-block btn-lg btn-link',
	                                    type: 'button',
	                                    onClick: _twd.hideModal
	                                },
	                                'Cancel'
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var onSave = function () {
	    var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(_ref3) {
	        var params = _ref3.params;
	
	        var qId, url, _ajax, data, r, s;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        qId = params.id;
	                        url = qId ? '/esb/portfolio/savedQueryUpdate' : '/esb/portfolio/savedQueryInsert';
	                        _context2.prev = 2;
	                        _ajax = (0, _twd.ajax)({
	                            url: url,
	                            method: 'POST',
	                            params: params
	                        }), data = _ajax.data;
	                        _context2.next = 6;
	                        return data;
	
	                    case 6:
	                        _context2.t0 = _context2.sent;
	
	                        if (_context2.t0) {
	                            _context2.next = 9;
	                            break;
	                        }
	
	                        _context2.t0 = {};
	
	                    case 9:
	                        r = _context2.t0;
	                        s = r[0] || {};
	                        return _context2.abrupt('return', { savedQueryId: s.id });
	
	                    case 14:
	                        _context2.prev = 14;
	                        _context2.t1 = _context2['catch'](2);
	
	                    case 16:
	                        return _context2.abrupt('return', {});
	
	                    case 17:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined, [[2, 14]]);
	    }));
	
	    return function onSave(_x2) {
	        return _ref4.apply(this, arguments);
	    };
	}();

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useSavedSearches2 = __webpack_require__(1115);
	
	var _useSavedSearches3 = _interopRequireDefault(_useSavedSearches2);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useSavedSearches = (0, _useSavedSearches3.default)({}),
	        rows = _useSavedSearches.rows;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { background: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement('div', { className: 'row vertical-offset-lg' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row', style: { background: "#ffffff" } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement(Grid, { rows: rows })
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'row vertical-offset-lg' })
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var Grid = function Grid(_ref) {
	    var rows = _ref.rows;
	    return _react2.default.createElement(
	        'div',
	        { className: 'table-responsive' },
	        _react2.default.createElement(
	            'table',
	            {
	                'data-name': 'saved-searches-table',
	                className: 'table table-hover align-top'
	            },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Name'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right' },
	                        'Last Modified'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                rows && rows.map(function (r, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        {
	                            'data-name': 'saved-searches-row',
	                            className: 'row-has-checkbox', key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(Item, { row: r })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'text-right' },
	                            _twd.fmt.ts(r.modified)
	                        )
	                    );
	                })
	            )
	        )
	    );
	};
	
	var Item = function Item(_ref2) {
	    var row = _ref2.row;
	
	    return _react2.default.createElement(
	        'button',
	        {
	            'data-name': 'saved-searches-item',
	            'data-label': row.description,
	
	            className: 'btn-link',
	            onClick: function onClick() {
	                onSearch(row);
	            }
	        },
	        row.description
	    );
	};
	
	var onSearch = function onSearch(_ref3) {
	    var searchParams = _ref3.searchParams;
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: (0, _twd.cleanObject)(searchParams),
	        _ts: Date.now(),
	        from: 'saved-searches'
	    }));
	};

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var last = (0, _twd.getState)('saved-searches.last', { ts: 0 });
	
	exports.default = function (_ref) {
	    var _ref$refresh = _ref.refresh,
	        refresh = _ref$refresh === undefined ? true : _ref$refresh;
	
	    var _React$useState = _react2.default.useState(refresh ? _twd.Status.LOADING : _twd.Status.LOADED),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(refresh ? [] : last.value.rows),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        rows = _React$useState4[0],
	        setRows = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ajax, data, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!(status !== _twd.Status.LOADING)) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            _context.prev = 2;
	                            _ajax = (0, _twd.ajax)({
	                                url: '/esb/portfolio/savedQuerySearchByCurrentUser',
	                                method: 'GET'
	                            }), data = _ajax.data;
	                            _context.next = 6;
	                            return data;
	
	                        case 6:
	                            _context.t0 = _context.sent;
	
	                            if (_context.t0) {
	                                _context.next = 9;
	                                break;
	                            }
	
	                            _context.t0 = [];
	
	                        case 9:
	                            _context.t1 = function (a) {
	                                a.modified = new Date(a.modified);
	                                a.queryText = (0, _twd.parseJson)(a.formText);
	                                a.searchParams = (a.queryText || {}).metadata || a.queryText || {};
	                                return a;
	                            };
	
	                            _context.t2 = function (a) {
	                                return a.searchParams.searchType === 'offers';
	                            };
	
	                            _context.t3 = function (a, b) {
	                                return b.modified.valueOf() - a.modified.valueOf();
	                            };
	
	                            rs = _context.t0.map(_context.t1).filter(_context.t2).sort(_context.t3);
	
	
	                            // state.savedSearches = rs
	                            setRows(rs);
	
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 20;
	                            break;
	
	                        case 17:
	                            _context.prev = 17;
	                            _context.t4 = _context['catch'](2);
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 20:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[2, 17]]);
	        }))();
	    }, [status]);
	
	    _react2.default.useEffect(function () {
	        return function () {
	            (0, _twd.$)('.tooltip').remove();
	        };
	    });
	
	    return { status: status, rows: rows };
	};

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    (0, _twd.trackPage)('sell-your-bond');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-lg bottom-border-row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(_twd.FrameIn, {
	                        src: (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)() + '/' + (0, _twd.getOwaTcdaoContext)() + '/pkg_order_bond.output?p_action=S&p_source_action=H'
	                    })
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.calculate = exports.getStateTaxRate = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var orders = {
	    corp: ['corp', 'tsy', 'muni_in', 'muni_out'],
	    muni_in: ['muni_in', 'muni_out', 'corp', 'tsy'],
	    muni_out: ['muni_out', 'muni_in', 'corp', 'tsy'],
	    tsy: ['tsy', 'corp', 'muni_in', 'muni_out']
	};
	
	var getStateTaxRate = exports.getStateTaxRate = function getStateTaxRate(_ref) {
	    var taxState = _ref.taxState,
	        customTaxRate = _ref.customTaxRate;
	
	    return taxState === 'OTHER' ? parseFloat(customTaxRate) / 100.0 : parseFloat((global.app.config.state_tax_rates || {})[taxState] || 0);
	};
	
	var calculate = exports.calculate = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(values) {
	        var bondProductType, bondYield, federalTaxRate, yld, fed, st, _ref3, data, val;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        bondProductType = values.bondProductType, bondYield = values.bondYield, federalTaxRate = values.federalTaxRate;
	                        yld = parseFloat(bondYield) / 100.0;
	                        fed = parseFloat(federalTaxRate);
	                        st = getStateTaxRate(values);
	
	                        if (!(isNaN(yld) || isNaN(fed) || isNaN(st))) {
	                            _context.next = 6;
	                            break;
	                        }
	
	                        return _context.abrupt('return', null);
	
	                    case 6:
	                        _context.next = 8;
	                        return (0, _twd.ajax)({
	                            url: '/esb/retailservice/teyCalculatorService/getTeyCalculations',
	                            method: 'POST',
	                            body: JSON.stringify({
	                                bondProductType: bondProductType,
	                                noOfVariance: 3,
	                                variance: 0.05,
	                                bondYield: yld * 100.0,
	                                federalTaxRate: fed * 100.0,
	                                stateTaxRate: st * 100.0
	                            })
	                        });
	
	                    case 8:
	                        _ref3 = _context.sent;
	                        data = _ref3.data;
	                        _context.next = 12;
	                        return data;
	
	                    case 12:
	                        _context.t1 = _context.sent;
	
	                        if (_context.t1) {
	                            _context.next = 15;
	                            break;
	                        }
	
	                        _context.t1 = {};
	
	                    case 15:
	                        _context.t0 = _context.t1.values;
	
	                        if (_context.t0) {
	                            _context.next = 18;
	                            break;
	                        }
	
	                        _context.t0 = [];
	
	                    case 18:
	                        _context.t2 = function (r) {
	                            for (var k in r) {
	                                r[k] /= 100.0;
	                            }
	                            return r;
	                        };
	
	                        _context.t3 = function (a, b) {
	                            return b[bondProductType] - a[bondProductType];
	                        };
	
	                        val = _context.t0.map(_context.t2).sort(_context.t3);
	
	                        if (!(val.length === 0)) {
	                            _context.next = 23;
	                            break;
	                        }
	
	                        throw new Error("Unable to calculate");
	
	                    case 23:
	                        return _context.abrupt('return', {
	                            values: val,
	                            order: orders[bondProductType],
	                            fedTax: fed,
	                            stateTax: st,
	                            totalTax: fed + st
	                        });
	
	                    case 24:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function calculate(_x) {
	        return _ref2.apply(this, arguments);
	    };
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Chart = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(135);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var COLORS = ['#8B06B9', // muni-in
	'#2320BB', // muni-out
	'#1192E9', // corp
	'#00A3A0'];
	
	var SHORT_LABELS = {
	    muni_in: 'In-state muni',
	    muni_out: 'Out-of-state muni',
	    corp: 'Corporate',
	    tsy: 'Treasury'
	};
	
	var pct2 = function pct2(a) {
	    var x = Number.parseFloat(a);
	    return isNaN(x) ? '-' : x.toFixed(2) + '%';
	};
	
	var XAxisTick = function XAxisTick(props) {
	    var x = props.x,
	        y = props.y,
	        width = props.width,
	        index = props.index,
	        data = props.data;
	
	
	    var value = data[index] || {};
	    var color = COLORS[index];
	    var label = SHORT_LABELS[value.name];
	    var w = Math.max(width / 4 - 25, 65);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'foreignObject',
	            { x: x - w / 2 + 5, y: y + 1, width: w, height: 30 },
	            _react2.default.createElement(
	                'div',
	                { style: {
	                        height: 35,
	                        fontSize: '11px',
	                        borderLeft: '5px solid ' + color,
	                        paddingLeft: '5px',
	                        lineHeight: 'normal'
	                    } },
	                label
	            )
	        )
	    );
	};
	
	var Chart = exports.Chart = function Chart(_ref) {
	    var calculation = _ref.calculation;
	
	    var _ref2 = calculation || {},
	        order = _ref2.order,
	        values = _ref2.values;
	
	    if (!order || !values) return null;
	
	    var vs = values[3];
	    var data = order.map(function (a) {
	        return {
	            name: a,
	            value: vs[a] * 100
	        };
	    });
	
	    var maxValue = data.reduce(function (x, a) {
	        return a.value > x ? a.value : x;
	    }, 0);
	
	    return _react2.default.createElement(
	        _recharts.ResponsiveContainer,
	        { width: '100%', height: 275 },
	        _react2.default.createElement(
	            _recharts.BarChart,
	            {
	                margin: { bottom: 25 },
	                data: data
	            },
	            _react2.default.createElement(_recharts.CartesianGrid, { vertical: false }),
	            _react2.default.createElement(_recharts.YAxis, {
	                domain: [0, function (dataMax) {
	                    var m = Math.ceil(dataMax);
	                    var y = m > 100 ? m + Math.ceil(m / 25) * 2 : m > 20 ? m + Math.ceil(m / 20) * 2 : m > 12 ? m + 2 : m > 5 ? m + 1 : m > 3 ? m + 0.75 : m > 2 ? m + 0.5 : m > 1 ? m + 0.25 : m > 0.5 ? m + 0.125 : m;
	                    return y;
	                }],
	                orientation: 'right',
	                unit: '%',
	                axisLine: false,
	                tickLine: false,
	                tickCount: 4,
	                scale: 'linear',
	                width: Math.ceil(maxValue) > 90 ? 45 : 35
	            }),
	            _react2.default.createElement(_recharts.XAxis, {
	                tickLine: false,
	                tick: _react2.default.createElement(XAxisTick, { data: data })
	            }),
	            _react2.default.createElement(
	                _recharts.Bar,
	                {
	                    dataKey: 'value',
	                    label: {
	                        formatter: pct2,
	                        value: 'value',
	                        position: 'top',
	                        stroke: 'none',
	                        fill: '#666',
	                        fontSize: '13px',
	                        fontWeight: 400
	                    }
	                },
	                data.map(function (e, i) {
	                    return _react2.default.createElement(_recharts.Cell, {
	                        key: 'cell-' + i,
	                        fill: COLORS[i],
	                        stroke: '#e9e9e9'
	                    });
	                })
	            )
	        )
	    );
	};

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Disclosures = exports.listCss = exports.Assumptions = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var _templateObject = _taggedTemplateLiteral(['\n    li { padding: 0 }\n'], ['\n    li { padding: 0 }\n']);
	
	var _core = __webpack_require__(9);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Assumptions = exports.Assumptions = function Assumptions() {
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showSection = _React$useState2[0],
	        setShowSection_ = _React$useState2[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        setShowSection_(m);
	    }, []);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12' },
	                (0, _core.jsx)(_twd.SectionHeader, {
	                    title: 'Assumptions',
	                    cls: 'subhead',
	                    arrowSize: 'medium',
	                    show: showSection, setShow: setShowSection
	                })
	            )
	        ),
	        (0, _core.jsx)(
	            _twd.SectionBody,
	            { show: showSection },
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12', css: listCss },
	                    'The Taxable Equivalent Yield Calculator Tool (the \u201CTool\u201D) assumes the following:',
	                    (0, _core.jsx)(
	                        'ul',
	                        null,
	                        (0, _core.jsx)(
	                            'li',
	                            null,
	                            (0, _core.jsx)(
	                                'u',
	                                null,
	                                'In-State Municipal Bonds'
	                            ),
	                            ' will always be treated as fully tax exempt from federal, state, and local taxes.'
	                        ),
	                        (0, _core.jsx)(
	                            'li',
	                            null,
	                            (0, _core.jsx)(
	                                'u',
	                                null,
	                                'Out-of-State Municipal Bonds'
	                            ),
	                            ' will always be treated as subject to state and local income tax.'
	                        ),
	                        (0, _core.jsx)(
	                            'li',
	                            null,
	                            (0, _core.jsx)(
	                                'u',
	                                null,
	                                'Treasury Bonds'
	                            ),
	                            ' will always be treated as federally taxable and exempt from state and local taxes.'
	                        ),
	                        (0, _core.jsx)(
	                            'li',
	                            null,
	                            (0, _core.jsx)(
	                                'u',
	                                null,
	                                'Corporate Bonds'
	                            ),
	                            ' will always be treated as fully taxable, subject to federal, state, and local taxes.'
	                        ),
	                        (0, _core.jsx)(
	                            'li',
	                            null,
	                            'The Tool and its corresponding calculations does not take into consideration:',
	                            (0, _core.jsx)(
	                                'ul',
	                                null,
	                                (0, _core.jsx)(
	                                    'li',
	                                    null,
	                                    'Federal Net Investment Income Tax'
	                                ),
	                                (0, _core.jsx)(
	                                    'li',
	                                    null,
	                                    'Federal or State Alternative Minimum Tax (AMT)'
	                                ),
	                                (0, _core.jsx)(
	                                    'li',
	                                    null,
	                                    'Effects of capital gains taxes (all bonds remain at par value)'
	                                ),
	                                (0, _core.jsx)(
	                                    'li',
	                                    null,
	                                    'The effects of investment fees or related expenses'
	                                ),
	                                (0, _core.jsx)(
	                                    'li',
	                                    null,
	                                    'Other specialized/unique tax treatments'
	                                )
	                            )
	                        ),
	                        (0, _core.jsx)(
	                            'li',
	                            null,
	                            'The Tool assumes positions are held outside of retirement and other tax-deferred/sheltered investment accounts.'
	                        ),
	                        (0, _core.jsx)(
	                            'li',
	                            null,
	                            'All tax rates are rounded to nearest hundredth of a percent.'
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' })
	        )
	    );
	};
	
	var listCss = exports.listCss = (0, _core.css)(_templateObject);
	
	var Disclosures = exports.Disclosures = function Disclosures() {
	    var _React$useState3 = _react2.default.useState(false),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        showSection = _React$useState4[0],
	        setShowSection_ = _React$useState4[1];
	
	    var setShowSection = _react2.default.useCallback(function (m) {
	        setShowSection_(m);
	    }, []);
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12' },
	                (0, _core.jsx)(_twd.SectionHeader, {
	                    title: 'Important disclosures and footnotes',
	                    cls: 'subhead',
	                    arrowSize: 'medium',
	                    show: showSection, setShow: setShowSection
	                })
	            )
	        ),
	        (0, _core.jsx)(
	            _twd.SectionBody,
	            { show: showSection },
	            (0, _core.jsx)(
	                'div',
	                { className: 'row' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        'The Tool is provided by a third party that is not affiliated with Morgan Stanley.  The Tool and its corresponding calculations are for educational purposes only. The information provided by the Tool neither is, nor should be construed as, an offer, or a solicitation of an offer, or a recommendation, to buy or sell securities or other instruments by Morgan Stanley. Unless stated otherwise, no information presented by the Tool constitutes a recommendation by Morgan Stanley to buy, sell, or hold any security, financial product, or instrument discussed therein, or to open a particular account or to engage in any specific investment strategy.  You understand and agree that Morgan Stanley has no liability whatsoever for the results of your investment strategies, transactions, and decisions.'
	                    ),
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        'The results provided by the Tool are estimates based on the client\u2019s inputs and the assumptions made by the Tool as described in \u201CAssumptions\u201D.'
	                    ),
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        'This Tool is intended for US individual investors and taxpayers. It is not applicable to persons or entities residing outside of the US or otherwise subject to special income tax regulations.  Each client\u2019s tax implications are unique and may not be fully represented by this Tool.  Morgan Stanley and its affiliates do not provide tax advice, and nothing in this section should be construed as tax advice.  Please consult with your tax professional before acting on any such information.'
	                    ),
	                    (0, _core.jsx)(
	                        'p',
	                        null,
	                        'Morgan Stanley does not guarantee that the content and yields are accurate, complete, or timely.  Federal, state, and local tax laws are subject to frequent change.  Morgan Stanley is not liable for any losses arising out of or related to your use of the Tool.'
	                    )
	                )
	            ),
	            (0, _core.jsx)('div', { className: 'xs-show row vertical-offset-sm' })
	        )
	    );
	};

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _teyCalculator = __webpack_require__(331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var onValidate = function onValidate(values) {
	    var err = {};
	
	    if (!values.bondProductType) {
	        err.bondProductType = 'Select value';
	    }
	
	    var bondYield = parseFloat(values.bondYield);
	    if (isNaN(bondYield) || bondYield < 0) {
	        err.bondYield = 'Enter value';
	    }
	
	    if (values.federalTaxRate === '') {
	        err.federalTaxRate = 'Select value';
	    }
	
	    if (!values.taxState) {
	        err.taxState = 'Select value';
	    }
	
	    if (values.taxState === 'OTHER') {
	        var customTaxRate = parseFloat(values.customTaxRate);
	        if (isNaN(customTaxRate) || customTaxRate < 0) {
	            err.customTaxRate = 'Enter value';
	        }
	    }
	
	    return err;
	};
	
	exports.default = function (_ref) {
	    var bondType = _ref.bondType,
	        bondYield = _ref.bondYield,
	        taxState = _ref.taxState,
	        issueState = _ref.issueState,
	        onCalcTs = _ref.onCalcTs,
	        isReset = _ref.isReset;
	
	    var _useTeyCalculator = (0, _teyCalculator.useTeyCalculator)(),
	        state = _useTeyCalculator.state;
	
	    var bondProductType = {
	        'T': 'tsy',
	        'M': 'muni_in',
	        'Mo': 'muni_out',
	        'C': 'corp'
	    }[bondType + (bondType === 'M' && issueState && issueState !== (0, _twd.getConfig)('account_states.0.stateOfResidence', '') ? 'o' : '')];
	
	    return _react2.default.createElement(
	        _teyCalculator.ErrorBoundary,
	        null,
	        _react2.default.createElement(_formik.Formik, {
	            initialValues: Object.assign({}, (0, _teyCalculator.getDefaultValues)().input, !bondProductType || isReset ? {} : state.value.input, bondProductType && taxState ? { taxState: taxState } : {}, bondProductType && bondYield ? { bondYield: bondYield } : {}, bondProductType ? { bondProductType: bondProductType } : {}),
	            onSubmit: function () {
	                var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(values) {
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                        while (1) {
	                            switch (_context.prev = _context.next) {
	                                case 0:
	                                    state.set(Object.assign({}, state.value, {
	                                        input: Object.assign({}, values)
	                                    }));
	                                    onCalcTs(Date.now());
	
	                                case 2:
	                                case 'end':
	                                    return _context.stop();
	                            }
	                        }
	                    }, _callee, undefined);
	                }));
	
	                return function (_x) {
	                    return _ref2.apply(this, arguments);
	                };
	            }(),
	            onReset: _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	                var a;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                a = (0, _teyCalculator.getDefaultValues)();
	
	                                state.set(Object.assign({}, a));
	                                onCalcTs(null);
	                                return _context2.abrupt('return', a.input);
	
	                            case 4:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, undefined);
	            })),
	            component: Form,
	
	            validate: onValidate,
	            validateOnBlur: true,
	            validateOnChange: true
	        })
	    );
	};
	
	var TaxInfo = '\n    <table class="table">\n    <tbody>\n    <tr><td>In-state municipal</td><td class="text-bold">None</td></tr>\n    <tr><td>Out-of-state municipal</td><td class="text-bold">State &amp; Local</td></tr>\n    <tr><td>Corporate</td><td class="text-bold">Fed, State &amp; Local</td></tr>\n    <tr><td>Treasury</td><td class="text-bold">Federal</td></tr>\n    </tbody>\n    </table>\n';
	
	var Form = function Form(_ref4) {
	    var handleSubmit = _ref4.handleSubmit,
	        handleReset = _ref4.handleReset,
	        values = _ref4.values,
	        errors = _ref4.errors,
	        validateForm = _ref4.validateForm;
	
	
	    var isOtherState = values.taxState === 'OTHER';
	
	    return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    _react2.default.createElement(
	                        'legend',
	                        { className: 'h5' },
	                        'Step 1: Select your starting product and pretax yield'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12 text-right' },
	                    _react2.default.createElement(_twd.Flyout, {
	                        label: 'Applicable taxes on interest income',
	                        className: 'btn-label btn-flyout tiny-header',
	                        html: TaxInfo
	                    })
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 vertical-offset-base' },
	                    _react2.default.createElement(_formik.Field, {
	                        dataName: 'tey-calculator-bond-product-type',
	                        name: 'bondProductType',
	                        component: _twd.Fields.Select,
	                        label: 'Bond product type',
	                        options: [{ label: '', value: '' }, { label: 'In-state municipal', value: 'muni_in' }, { label: 'Out-of-state municipal', value: 'muni_out' }, { label: 'Corporate', value: 'corp' }, { label: 'Treasury', value: 'tsy' }]
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 vertical-offset-base' },
	                    _react2.default.createElement(_formik.Field, {
	                        'data-name': 'tey-calculator-bond-yield',
	                        name: 'bondYield',
	                        component: _twd.Fields.Yield,
	                        label: 'Bond yield',
	                        suffix: '%',
	                        error: errors.bondYield
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'legend',
	                        { className: 'h5' },
	                        'Step 2: Choose your federal and state income tax rates'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: (isOtherState ? "col-md-3" : "col-md-4") + " vertical-offset-base" },
	                    _react2.default.createElement(_formik.Field, {
	                        dataName: 'tey-calculator-federal-tax-rate',
	                        name: 'federalTaxRate',
	                        component: _twd.Fields.Select,
	                        label: 'Federal tax rate',
	                        options: ['', 0, .1, .12, .22, .24, .32, .35, .37].map(function (a) {
	                            return {
	                                label: Number.isFinite(a) ? _twd.format.pct(a * 100) : '',
	                                value: String(a)
	                            };
	                        })
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: (isOtherState ? "col-md-3" : "col-md-4") + "  vertical-offset-base" },
	                    _react2.default.createElement(_formik.Field, {
	                        dataName: 'tey-calculator-state-tax-rate',
	                        name: 'taxState',
	                        component: _twd.Fields.Select,
	                        label: 'State tax rate',
	                        options: [{
	                            label: '',
	                            value: ''
	                        }, {
	                            label: 'Other',
	                            value: 'OTHER'
	                        }].concat(_twd.STATES.map(function (a) {
	                            var s = a.value;
	                            var r = (global.app.config.state_tax_rates || {})[s] || 0;
	                            return {
	                                label: a.label + ' - ' + _twd.format.pct(r * 100),
	                                value: '' + s
	                            };
	                        }).sort(function (a, b) {
	                            return a.label.localeCompare(b.label, 'en', { sensitivity: 'base' });
	                        }))
	                    })
	                ),
	                isOtherState && _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-3 vertical-offset-base' },
	                    _react2.default.createElement(_formik.Field, {
	                        'data-name': 'tey-calculator-custom-tax-rate',
	                        name: 'customTaxRate',
	                        component: _twd.Fields.Yield,
	                        label: 'Custom tax rate',
	                        suffix: '%',
	                        error: errors.customTaxRate
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: isOtherState ? "col-md-3" : "col-md-4" },
	                    _react2.default.createElement(
	                        'label',
	                        { className: 'xs-hide' },
	                        '\xA0'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'submit',
	                            className: 'btn btn-primary btn-block',
	                            disabled: errors.length > 0
	                        },
	                        'Calculate'
	                    ),
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            type: 'button',
	                            className: 'btn btn-link btn-block text-center',
	                            onClick: function onClick() {
	                                handleReset();
	                                setTimeout(function () {
	                                    return validateForm;
	                                }, 10);
	                            }
	                        },
	                        'Clear form'
	                    )
	                )
	            )
	        )
	    );
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _formik = __webpack_require__(62);
	
	var _twd = __webpack_require__(2);
	
	var _table = __webpack_require__(1124);
	
	var _chart = __webpack_require__(1118);
	
	var _summary = __webpack_require__(1123);
	
	var _teyCalculator = __webpack_require__(331);
	
	var _calculate = __webpack_require__(1117);
	
	var _submit = __webpack_require__(1122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	exports.default = function (_ref) {
	    var _ts = _ref.ts;
	
	    var _React$useState = _react2.default.useState(_ts),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        ts = _React$useState2[0],
	        setTs = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        status = _React$useState4[0],
	        setStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(''),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        error = _React$useState6[0],
	        setError = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState(null),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        calculation = _React$useState8[0],
	        setCalculation = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(''),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        taxState = _React$useState10[0],
	        setTaxState = _React$useState10[1];
	
	    var _useTeyCalculator = (0, _teyCalculator.useTeyCalculator)(),
	        state = _useTeyCalculator.state;
	
	    _react2.default.useEffect(function () {
	        if (!_ts || ts >= _ts) return;
	        setTs(_ts);
	        setStatus(_twd.Status.LOADING);
	        setError('');
	        setCalculation(null);
	    }, [_ts]);
	
	    _react2.default.useEffect(function () {
	        if (!ts) return;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var values, calc;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.prev = 0;
	                            values = Object.assign({}, state.value.input);
	                            _context.next = 4;
	                            return (0, _calculate.calculate)(values);
	
	                        case 4:
	                            calc = _context.sent;
	
	                            setCalculation(calc);
	                            setTaxState(values.taxState || '');
	                            setStatus(_twd.Status.LOADED);
	                            _context.next = 14;
	                            break;
	
	                        case 10:
	                            _context.prev = 10;
	                            _context.t0 = _context['catch'](0);
	
	                            setError('Unable to calculate');
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 14:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[0, 10]]);
	        }))();
	    }, [ts]);
	
	    if (!_ts) return null;
	
	    return _react2.default.createElement(
	        _twd.Loading,
	        { status: status, error: error },
	        _react2.default.createElement(
	            _teyCalculator.ErrorBoundary,
	            null,
	            _react2.default.createElement(_formik.Formik, {
	                initialValues: Object.assign({}, (0, _teyCalculator.getDefaultValues)().search, state.value.search, {
	                    calculation: calculation,
	                    taxState: taxState
	                }),
	                onSubmit: function onSubmit(values) {
	                    state.set(Object.assign({}, (0, _teyCalculator.getDefaultValues)()));
	                    (0, _submit.onSubmit)(values);
	                },
	                component: Form,
	                validate: function validate(values) {
	                    state.set(Object.assign({}, state.value, {
	                        search: Object.assign({}, values)
	                    }));
	                    return onValidate(values);
	                },
	                validateOnBlur: true,
	                validateOnChange: true
	            })
	        )
	    );
	};
	
	var onValidate = function onValidate(values) {
	    var err = {};
	
	    var minMat = (0, _twd.parseDate)(values.holdMaturityMin);
	    if (values.holdMaturityMin && !minMat) {
	        err.holdMaturityMin = 'Enter date';
	    }
	
	    var maxMat = (0, _twd.parseDate)(values.holdMaturityMax);
	    if (values.holdMaturityMax && !maxMat) {
	        err.holdMaturityMax = 'Enter date';
	    }
	
	    if (maxMat < minMat) {
	        err.holdMaturityMax = 'Enter later date';
	    }
	
	    if (!values.searchFor) {
	        err.searchFor = 'Select value';
	    }
	
	    if (values.searchFor === 'muni_in' && (0, _twd.isEmpty)(values.muniInStates)) {
	        err.muniInStates = 'Select state';
	    }
	
	    if (values.searchFor === 'muni_out' && (0, _twd.isEmpty)(values.muniOutStates)) {
	        err.muniOutStates = 'Select state';
	    }
	
	    return err;
	};
	
	var Form = function Form(_ref3) {
	    var handleSubmit = _ref3.handleSubmit,
	        values = _ref3.values,
	        errors = _ref3.errors;
	
	
	    var hasError = Object.keys(errors).length > 0;
	    var isMuniIn = values.searchFor === 'muni_in';
	    var isMuniOut = values.searchFor === 'muni_out';
	    var isTsy = values.searchFor === 'tsy';
	
	    return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    'Tax-equivalent yields by bond product type'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 table-responsive vertical-offset-base' },
	                _react2.default.createElement(_table.Table, { calculation: values.calculation })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 vertical-offset-base' },
	                _react2.default.createElement(_chart.Chart, { calculation: values.calculation })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'h5',
	                    null,
	                    'Search for comparable bonds'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(_summary.Summary, { calculation: values.calculation })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: "col-xs-12 col-auto vertical-offset-xs", style: { minWidth: '160px' } },
	                _react2.default.createElement(_formik.Field, {
	                    dataName: 'tey-calculator-securities',
	                    name: 'searchFor',
	                    component: _twd.Fields.Select,
	                    label: 'Search for',
	                    options: [{ label: '', value: '' }, { label: 'In-state municipal', value: 'muni_in' }, { label: 'Out-of-state muni', value: 'muni_out' }, { label: 'Corporate', value: 'corp' }, { label: 'Treasury', value: 'tsy' }]
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-auto vertical-offset-xs' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'tey-calculator-maturity-min',
	                    name: 'holdMaturityMin',
	                    component: _twd.Fields.Maturity,
	                    label: _react2.default.createElement(_twd.Flyout, { label: 'Maturity Min', html: _twd.Fields.Labels.Maturity }),
	                    error: errors.holdMaturityMin
	                })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-auto vertical-offset-xs' },
	                _react2.default.createElement(_formik.Field, {
	                    'data-name': 'tey-calculator-maturity-max',
	                    name: 'holdMaturityMax',
	                    component: _twd.Fields.Maturity,
	                    label: _react2.default.createElement(_twd.Flyout, { label: 'Maturity Max', html: _twd.Fields.Labels.Maturity }),
	                    error: errors.holdMaturityMax
	                })
	            ),
	            !isTsy && _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-auto vertical-offset-xs', style: { minWidth: '100px' } },
	                _react2.default.createElement(_formik.FieldArray, {
	                    name: 'callFeatures',
	                    render: function render(args) {
	                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                            dataName: 'tey-calculator-features',
	                            options: _twd.CALL_FEATURES,
	                            label: _react2.default.createElement(_twd.Flyout, { label: 'Call features', html: _twd.Fields.Labels.CallFeatures }),
	                            listConfig: { style: { minWidth: '150px' } },
	                            style: { marginBottom: '0px' }
	                        }));
	                    }
	                })
	            ),
	            isMuniIn && _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-auto vertical-offset-xs', style: { minWidth: '100px' } },
	                _react2.default.createElement(_formik.FieldArray, {
	                    name: 'muniInStates',
	                    render: function render(args) {
	                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                            dataName: 'tey-calculator-muni-in-states',
	                            emptyText: '',
	                            showSelectAll: true,
	                            options: _twd.STATES,
	                            label: 'State',
	                            listConfig: { style: { minWidth: '200px' } },
	                            error: errors.muniInStates,
	                            style: { marginBottom: '0px' }
	                        }));
	                    }
	                }),
	                errors.muniInStates && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    errors.muniInStates
	                )
	            ),
	            isMuniOut && _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 col-auto vertical-offset-xs', style: { minWidth: '100px' } },
	                _react2.default.createElement(_formik.FieldArray, {
	                    name: 'muniOutStates',
	                    render: function render(args) {
	                        return _react2.default.createElement(_twd.Fields.SelectMulti, Object.assign({}, args, {
	                            dataName: 'tey-calculator-muni-out-states',
	                            emptyText: '',
	                            showSelectAll: true,
	                            options: _twd.STATES,
	                            label: 'State',
	                            listConfig: { style: { minWidth: '200px' } },
	                            error: errors.muniOutStates,
	                            style: { marginBottom: '0px' }
	                        }));
	                    }
	                }),
	                errors.muniOutStates && _react2.default.createElement(
	                    'label',
	                    { className: 'field-status has-error' },
	                    errors.muniOutStates
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: "col-xs-12 col-auto vertical-offset-xs", style: { minWidth: '100px' } },
	                _react2.default.createElement(
	                    'label',
	                    null,
	                    '\xA0'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'submit',
	                        disabled: hasError,
	                        className: 'btn btn-primary-outline btn-block'
	                    },
	                    'Search'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(_summary.SearchSummary, values)
	            )
	        )
	    );
	};

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.onSubmit = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _twd = __webpack_require__(2);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var pct = function pct(a) {
	    var v = parseFloat(a);
	    return isNaN(v) ? null : Math.round(v * 10000) / 100;
	};
	
	var onSubmit = exports.onSubmit = function onSubmit(values) {
	
	    var searchFor = values.searchFor;
	    var isMuniIn = searchFor === 'muni_in';
	    var isMuniOut = searchFor === 'muni_out';
	    var isCorp = searchFor === 'corp';
	    var isTsy = searchFor === 'tsy';
	
	    var calcs = values.calculation.values;
	    var minYield = calcs[6][searchFor];
	    var maxYield = calcs[0][searchFor];
	
	    var holdState = [];
	    if (isMuniIn) {
	        holdState = (0, _twd.arrayFrom)(values.muniInStates);
	        if (holdState.length === _twd.STATES_AND_TERRITORIES.length) {
	            holdState = [];
	        }
	    } else if (isMuniOut) {
	        holdState = (0, _twd.arrayFrom)(values.muniOutStates);
	        if (holdState.length === _twd.STATES_AND_TERRITORIES.length) {
	            holdState = [];
	        }
	        if (holdState.length === 0 && values.taxState !== 'OTHER') {
	            holdState = _twd.STATES_AND_TERRITORIES.map(function (a) {
	                return a.value === values.taxState ? null : a.value;
	            }).filter(Boolean);
	        }
	    }
	
	    var p = Object.assign({
	        holdInvType: [isMuniIn || isMuniOut ? 'M' : isCorp ? 'C' : isTsy ? 'T' : ''],
	        holdMaturityMin: (0, _twd.formatDate)(values.holdMaturityMin),
	        holdMaturityMax: (0, _twd.formatDate)(values.holdMaturityMax, true),
	        offerYtwMin: pct(minYield),
	        offerYtwMax: pct(maxYield),
	        offeringNewToday: false,
	        offeringType: ['ask-side'],
	        marketCheckRequired: true,
	        ytwMin: pct(minYield),
	        ytwMax: pct(maxYield),
	        holdState: holdState
	    }, (0, _twd.arrayFrom)(isTsy ? [] : values.callFeatures || []).map(function (a) {
	        return a.split('=');
	    }).reduce(function (x, _ref) {
	        var _ref2 = _slicedToArray(_ref, 2),
	            a = _ref2[0],
	            b = _ref2[1];
	
	        return Object.assign({}, x, _defineProperty({}, a, [].concat(_toConsumableArray(x[a] || []), [b])));
	    }, {}));
	
	    (0, _twd.hideModal)();
	
	    (0, _twd.show)('offerings', Object.assign({
	        searchParams: (0, _twd.cleanObject)(p),
	        _ts: Date.now(),
	        from: 'tey-calculator'
	    }));
	};

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SearchSummary = exports.Summary = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SINGULAR_LABELS = {
	    muni_in: 'an in-state tax-exempt municipal bond',
	    muni_out: 'an out-of-state municipal bond',
	    corp: 'a fully taxable corporate bond',
	    tsy: 'a federally taxable treasury bond'
	}; /* eslint-disable no-use-before-define */
	
	
	var EQUIVALENT_LABELS = {
	    muni_in: 'an in-state tax-exempt municipal bond',
	    muni_out: 'an out-of-state municipal bond (state/local taxable)',
	    corp: 'a fully taxable corporate bond',
	    tsy: 'a federally taxable treasury bond'
	};
	
	var pct2 = function pct2(a) {
	    var x = Number.parseFloat(a);
	    return isNaN(x) ? '-' : x.toFixed(2) + '%';
	};
	
	var cap = function cap(s) {
	    return s.charAt(0).toUpperCase() + s.slice(1);
	};
	
	var Summary = exports.Summary = function Summary(_ref) {
	    var calculation = _ref.calculation;
	
	    var _ref2 = calculation || {},
	        order = _ref2.order,
	        values = _ref2.values,
	        totalTax = _ref2.totalTax,
	        fedTax = _ref2.fedTax,
	        stateTax = _ref2.stateTax;
	
	    if (!order || !values) return null;
	
	    var productType = order[0];
	    var vs = values[3];
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        'Given your inputs, if you invested in ',
	        SINGULAR_LABELS[productType],
	        ' with a yield of ',
	        pct2(vs[order[0]] * 100),
	        productType === 'corp' ? ' which is subject to a combined tax rate of ' + pct2(totalTax * 100) : '',
	        productType === 'muni_out' ? ' which is subject to a state tax rate of ' + pct2(stateTax * 100) : '',
	        productType === 'tsy' ? ' which is subject to a federal tax rate of ' + pct2(fedTax * 100) : '',
	        ', this would be equivalent to investing in:',
	        _react2.default.createElement(
	            'li',
	            null,
	            cap(EQUIVALENT_LABELS[order[1]]),
	            ' with a yield of ',
	            pct2(vs[order[1]] * 100),
	            '.'
	        ),
	        _react2.default.createElement(
	            'li',
	            null,
	            cap(EQUIVALENT_LABELS[order[2]]),
	            ' with a yield of ',
	            pct2(vs[order[2]] * 100),
	            '.'
	        ),
	        _react2.default.createElement(
	            'li',
	            null,
	            cap(EQUIVALENT_LABELS[order[3]]),
	            ' with a yield of ',
	            pct2(vs[order[3]] * 100),
	            '.'
	        )
	    );
	};
	
	var PLURAL_LABELS = {
	    muni_in: 'in-state municipal bonds',
	    muni_out: 'out-of-state municipal bonds',
	    corp: 'corporate bonds',
	    tsy: 'treasury bonds'
	};
	
	var SearchSummary = exports.SearchSummary = function SearchSummary(_ref3) {
	    var calculation = _ref3.calculation,
	        searchFor = _ref3.searchFor;
	
	
	    if (!searchFor) return null;
	
	    var values = calculation.values;
	    var minYield = values[6][searchFor];
	    var maxYield = values[0][searchFor];
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'text-italic text-small' },
	        'This search will open a new window and display ',
	        PLURAL_LABELS[searchFor],
	        ' with a comparable yield range between ',
	        pct2(minYield * 100),
	        ' - ',
	        pct2(maxYield * 100),
	        '.'
	    );
	};

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Table = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var SHORT_LABELS = {
	    muni_in: 'In-state muni',
	    muni_out: 'Out-of-state muni',
	    corp: 'Corporate',
	    tsy: 'Treasury'
	};
	
	var pct2 = function pct2(a) {
	    var x = Number.parseFloat(a);
	    return isNaN(x) ? '-' : x.toFixed(2) + '%';
	};
	
	var Table = exports.Table = function Table(_ref) {
	    var calculation = _ref.calculation;
	
	    var _ref2 = calculation || {},
	        order = _ref2.order,
	        values = _ref2.values;
	
	    if (!order || !values) return null;
	
	    var isBlue = (0, _twd.getConfig)('entitlements.ETradeBlue', 'No') === 'Yes';
	    var color = isBlue ? '#e9f2f9' : '#f1ecff';
	
	    return _react2.default.createElement(
	        'table',
	        {
	            style: { padding: '5px', border: '1px solid #c4c4c4' },
	            className: 'table align-top table-striped' },
	        _react2.default.createElement(
	            'thead',
	            null,
	            _react2.default.createElement(
	                'tr',
	                null,
	                order.map(function (a, i) {
	                    return _react2.default.createElement(
	                        'th',
	                        {
	                            key: i,
	                            style: { width: '25%', verticalAlign: 'top', paddingRight: '5px' },
	                            className: 'text-right text-muted text-body'
	                        },
	                        SHORT_LABELS[a]
	                    );
	                })
	            )
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            values.map(function (vs, ri) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: ri, style: ri === 3 ? { backgroundColor: color } : {} },
	                    order.map(function (a, ci) {
	                        return _react2.default.createElement(
	                            'td',
	                            {
	                                key: ri + '-' + ci,
	                                className: "text-right" + (ri === 3 || ci === 0 ? " text-bold" : "")
	                            },
	                            pct2(vs[a] * 100)
	                        );
	                    })
	                );
	            })
	        )
	    );
	};

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var _require = __webpack_require__(1832),
	    tools = _require.tools,
	    resources = _require.resources;
	
	exports.default = function () {
	    (0, _twd.trackPage)('tools-and-resources');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        tools.length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-lg' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement('div', { className: 'vertical-offset-lg' }),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'h1 vertical-offset-sm text-center' },
	                        'Bond Tools'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card-group' },
	                        tools.map(function (a, i) {
	                            return _react2.default.createElement(Card, { key: i, card: a });
	                        })
	                    )
	                )
	            )
	        ),
	        resources.length > 0 && _react2.default.createElement(
	            'div',
	            { style: { background: "#f6f6f6" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row vertical-offset-lg' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'col-xs-12' },
	                        _react2.default.createElement('div', { className: 'vertical-offset-lg' }),
	                        _react2.default.createElement(
	                            'h2',
	                            { className: 'h1 vertical-offset-sm text-center' },
	                            'Bond Resources'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-group' },
	                            resources.map(function (a, i) {
	                                return _react2.default.createElement(Card, { key: i, card: a });
	                            })
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Card = function Card(_ref) {
	    var card = _ref.card;
	    var title = card.title,
	        description = card.description,
	        tag = card.tag,
	        img = card.img,
	        nav = card.nav,
	        navArg = card.navArg;
	
	
	    var Tag = '' + (tag === 'button' ? 'button' : 'a');
	
	    return _react2.default.createElement(
	        'div',
	        {
	            'data-name': 'tools-and-resources-card',
	            'data-label': title,
	            className: 'card card-primary flex-xs-12 flex-sm-6 flex-md-4 flex-lg-3',
	            style: { cursor: 'pointer' },
	            onClick: function onClick(e) {
	                if (!nav) return;
	                (0, _twd.publish)(nav, (0, _twd.isObject)(navArg) ? Object.assign({ source: e.target }, navArg) : navArg);
	            }
	        },
	        img && _react2.default.createElement('img', { 'aria-hidden': 'true', src: img, alt: title, className: 'vertical-offset-sm' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'card-body' },
	            _react2.default.createElement(
	                'h3',
	                { className: 'card-title' },
	                _react2.default.createElement(
	                    Tag,
	                    {
	                        href: '#',
	                        className: 'btn-link',
	                        'data-name': 'tools-and-resources-card-link',
	                        'data-label': title,
	                        'aria-label': title
	                    },
	                    title
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'vertical-offset-base' },
	                description
	            )
	        )
	    );
	};

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define no-throw-literal */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('tols.bond_details', {
	    url: ''
	});
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref.cusip,
	        url = _ref.url,
	        showBackLink = _ref.showBackLink,
	        _ref$from = _ref.from,
	        from = _ref$from === undefined ? '' : _ref$from;
	
	    var _React$useState = _react2.default.useState(state.value.url || url),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        url_ = _React$useState2[0],
	        setUrl_ = _React$useState2[1];
	
	    (0, _twd.trackPage)('tools.bond-detail');
	
	    _react2.default.useEffect(function () {
	
	        if (!cusip) return;
	        var sp = new URLSearchParams();
	        sp.set('p_cusip', cusip);
	        sp.set('p_id_type', 'I');
	        sp.set('p_actn', '');
	        sp.set('p_showBackLink', showBackLink === 'N' ? 'N' : 'Y');
	        sp.set('p_ask_id', '');
	        sp.set('p_bid_id', '');
	        sp.set('p_ts', Date.now());
	
	        var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	        var url = base + '/servlet/issuedesc/issuedesc.htm?' + sp.toString();
	        setUrl_(url);
	
	        if (from) (0, _twd.setBackFrom)('tools.bond-detail', from);
	    }, [cusip]);
	
	    if (!url_ && !cusip) {
	        throw new Error("tools.bond-detail: missing cusip");
	    }
	
	    if (!url_) return null;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_twd.FrameIn, { dataName: 'tools-bond-details-frame', src: url_ })
	    );
	};

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define no-throw-literal */
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref.cusip,
	        _ref$action = _ref.action,
	        action = _ref$action === undefined ? 'B' : _ref$action,
	        _ref$comm = _ref.comm,
	        comm = _ref$comm === undefined ? '' : _ref$comm,
	        _ref$comm_basis = _ref.comm_basis,
	        comm_basis = _ref$comm_basis === undefined ? '' : _ref$comm_basis,
	        _ref$acctNo = _ref.acctNo,
	        acctNo = _ref$acctNo === undefined ? '' : _ref$acctNo,
	        _ref$qty = _ref.qty,
	        qty = _ref$qty === undefined ? '' : _ref$qty,
	        _ref$sourceAction = _ref.sourceAction,
	        sourceAction = _ref$sourceAction === undefined ? '' : _ref$sourceAction,
	        _ref$sourceOrderNo = _ref.sourceOrderNo,
	        sourceOrderNo = _ref$sourceOrderNo === undefined ? '' : _ref$sourceOrderNo,
	        _ref$price = _ref.price,
	        price = _ref$price === undefined ? '' : _ref$price,
	        from = _ref.from;
	
	    if (!cusip) {
	        throw new Error('tools.bond-order: missing cusip');
	    }
	
	    (0, _twd.trackPage)('tools.bond-order');
	
	    var sp = new URLSearchParams();
	    sp.set('p_cusip', cusip);
	    sp.set('p_action', action);
	    sp.set('p_acct_no', acctNo);
	    sp.set('p_qty_bond', qty);
	    if (comm) sp.set('p_comm', comm);
	    if (comm_basis) sp.set('p_comm_basis', comm_basis);
	    if (price) {
	        sp.set('p_price', price);
	        sp.set('p_price_type', 1);
	    }
	    if (sourceAction) sp.set('p_source_action', sourceAction);
	    if (sourceOrderNo) sp.set('p_source_order_no', sourceOrderNo);
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    var url = base + '/' + owaTcDaoContext + '/pkg_order_bond.output?' + sp.toString();
	
	    if (from) (0, _twd.setBackFrom)('tools.bond-order', from);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_twd.FrameIn, { dataName: 'tools-bond-order-frame', src: url })
	    );
	};

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _bondDetail = __webpack_require__(1126);
	
	var _bondDetail2 = _interopRequireDefault(_bondDetail);
	
	var _bondOrder = __webpack_require__(1127);
	
	var _bondOrder2 = _interopRequireDefault(_bondOrder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define no-throw-literal */
	
	
	exports.default = function (_ref) {
	    var view = _ref.view,
	        args = _objectWithoutProperties(_ref, ['view']);
	
	    var dest = view.split('.')[1];
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { background: "#fff" } },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement('div', { className: 'row vertical-offset-lg' }),
	                dest === 'bond-detail' ? _react2.default.createElement(_bondDetail2.default, args) :
	                // dest === 'bond-ladder-builder' ? <LadderBuilder {...args} /> :
	                dest === 'bond-order' ? _react2.default.createElement(_bondOrder2.default, args) : dest === 'bond-portfolio-report' ? _react2.default.createElement(PortfolioReport, null) : dest === 'get-a-bond-quote' ? _react2.default.createElement(BondQuote, args) : dest === 'load-url' ? _react2.default.createElement(LoadUrl, args) : dest === 'order-detail' ? _react2.default.createElement(OrderDetail, args) : dest === 'price-yield-calculator' ? _react2.default.createElement(PriceYieldCalculator, null) : dest === 'treasury-auctions' ? _react2.default.createElement(TreasuryAuctions, args) : _react2.default.createElement(
	                    'div',
	                    { className: 'universal-message universal-message-danger' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'universal-message-content' },
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'universal-message-heading' },
	                            'tool is not yet available'
	                        )
	                    )
	                ),
	                _react2.default.createElement('div', { className: 'row vertical-offset-lg' }),
	                _react2.default.createElement('hr', { 'aria-hidden': 'true' })
	            )
	        )
	    );
	};
	
	var LoadUrl = function LoadUrl(_ref2) {
	    var url = _ref2.url,
	        frameName = _ref2.frameName;
	
	    return _react2.default.createElement(_twd.FrameIn, { src: url, frameName: frameName });
	};
	
	var BondQuote = function BondQuote(_ref3) {
	    var url = _ref3.url;
	
	    (0, _twd.trackPage)('tools.get-a-bond-quote');
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    url = url || base + '/' + owaTcDaoContext + '/pkg_order_wrapper.output?p_action_subset=WF';
	    return _react2.default.createElement(_twd.FrameIn, { dataName: 'tools-get-a-bond-quote-frame', src: url, frameName: 'content' });
	};
	
	var OrderDetail = function OrderDetail(_ref4) {
	    var orderNo = _ref4.orderNo;
	
	    if (!orderNo) {
	        throw new Error('tools.order-detail: missing order-no');
	    }
	
	    (0, _twd.trackPage)('tools.order-detail');
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    var url = base + '/' + owaTcDaoContext + '/pkg_exec_bond.output?p_order_no=' + orderNo;
	    return _react2.default.createElement(_twd.FrameIn, { dataName: 'tools-order-detail-frame', src: url, height: 1650 });
	};
	
	var PortfolioReport = function PortfolioReport() {
	    (0, _twd.trackPage)('tools.bond-portfolio-report');
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    var url = base + '/' + owaTcDaoContext + '/pkg_portfolio_etrade.output';
	    return _react2.default.createElement(_twd.FrameIn, { dataName: 'tools-bond-portfolio-report-frame', src: url });
	};
	
	var TreasuryAuctions = function TreasuryAuctions(_ref5) {
	    var from = _ref5.from;
	
	    (0, _twd.trackPage)('tools.treasury-auctions');
	
	    if (from) (0, _twd.setBackFrom)('treasury-auctions', from);
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    var url = base + '/' + owaTcDaoContext + '/pkg_order_wrapper.output?p_action=B&p_price_type=A';
	    return _react2.default.createElement(_twd.FrameIn, { dataName: 'tools-treasury-auctions-frame', src: url });
	};
	
	var PriceYieldCalculator = function PriceYieldCalculator() {
	    (0, _twd.trackPage)('tools.price-yield-calculator');
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var owaTcDaoContext = (0, _twd.getOwaTcdaoContext)();
	    var url = base + '/' + owaTcDaoContext + '/pkg_calc_bond_online.seed?p_javascript=2&p_id=null&p_data_source=I';
	    return _react2.default.createElement(_twd.FrameIn, { dataName: 'tools-price-yield-calculator-frame', src: url });
	};

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.controller = exports.Errors = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define,eqeqeq */
	
	
	var Errors = exports.Errors = {
	    UNEXPECTED: "Currently not available. Please try again later",
	    NO_CUSIP: "No data found for this CUSIP",
	    NO_LAST_TRADE: "There have been no trades within the past 180 days for this security.",
	    NO_TRADE_DATA: "There were no reported trades during the date range specified."
	};
	
	var controller = exports.controller = (0, _twd.define)("app.trade-history", {
	    refresh: function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(ctx) {
	            var _this = this;
	
	            var setStatus, status, cusip, setReloadStatus, setError, isReload, statusFn;
	            return _regenerator2.default.wrap(function _callee2$(_context2) {
	                while (1) {
	                    switch (_context2.prev = _context2.next) {
	                        case 0:
	                            setStatus = ctx.setStatus, status = ctx.status, cusip = ctx.cusip, setReloadStatus = ctx.setReloadStatus, setError = ctx.setError;
	                            isReload = status !== _twd.Status.LOADING && this.issueData && this.issueData.cusip === cusip;
	                            statusFn = isReload ? setReloadStatus : setStatus;
	
	                            statusFn(_twd.Status.LOADING);
	                            setError(null);
	
	                            setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                                var err;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                        switch (_context.prev = _context.next) {
	                                            case 0:
	                                                _context.prev = 0;
	                                                _context.next = 3;
	                                                return _this.refreshIssueData(ctx);
	
	                                            case 3:
	                                                _context.t0 = _context.sent;
	
	                                                if (_context.t0) {
	                                                    _context.next = 8;
	                                                    break;
	                                                }
	
	                                                _context.next = 7;
	                                                return _this.refreshTradeData(ctx);
	
	                                            case 7:
	                                                _context.t0 = _context.sent;
	
	                                            case 8:
	                                                err = _context.t0;
	
	
	                                                if (err) {
	                                                    console.log('trade-history error', err);
	                                                }
	
	                                                statusFn(_twd.Status.LOADED);
	                                                _context.next = 17;
	                                                break;
	
	                                            case 13:
	                                                _context.prev = 13;
	                                                _context.t1 = _context["catch"](0);
	
	                                                console.log('trade-history error', _context.t1);
	                                                setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                                            case 17:
	                                            case "end":
	                                                return _context.stop();
	                                        }
	                                    }
	                                }, _callee, _this, [[0, 13]]);
	                            })), 1000);
	
	                        case 6:
	                        case "end":
	                            return _context2.stop();
	                    }
	                }
	            }, _callee2, this);
	        }));
	
	        function refresh(_x) {
	            return _ref.apply(this, arguments);
	        }
	
	        return refresh;
	    }(),
	    refreshIssueData: function () {
	        var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(_ref3) {
	            var cusip = _ref3.cusip,
	                setError = _ref3.setError,
	                setIsDisclaimer = _ref3.setIsDisclaimer;
	
	            var _ref5, issueData, data_;
	
	            return _regenerator2.default.wrap(function _callee3$(_context3) {
	                while (1) {
	                    switch (_context3.prev = _context3.next) {
	                        case 0:
	                            if (!(this.issueData && this.issueData.cusip === cusip)) {
	                                _context3.next = 2;
	                                break;
	                            }
	
	                            return _context3.abrupt("return");
	
	                        case 2:
	
	                            this.issueData = {};
	                            this.fromDate = '';
	                            this.tradeData = [];
	                            this.lastTradeData = null;
	
	                            _context3.next = 8;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/cusip/issuedata',
	                                method: 'GET',
	                                params: { cusip: cusip }
	                            });
	
	                        case 8:
	                            _ref5 = _context3.sent;
	                            issueData = _ref5.data;
	                            _context3.next = 12;
	                            return issueData;
	
	                        case 12:
	                            _context3.t0 = _context3.sent.IssueData;
	
	                            if (_context3.t0) {
	                                _context3.next = 15;
	                                break;
	                            }
	
	                            _context3.t0 = {};
	
	                        case 15:
	                            data_ = this.issueData = _context3.t0;
	
	                            if (!(Object.keys(data_).length === 0)) {
	                                _context3.next = 19;
	                                break;
	                            }
	
	                            setError(Errors.NO_CUSIP);
	                            return _context3.abrupt("return", Errors.NO_CUSIP);
	
	                        case 19:
	
	                            if (['A', 'C'].includes(data_.type) && !(0, _twd.getUserParm)('HISTORY-DISCLAIMER')) {
	                                setIsDisclaimer(true);
	                            }
	
	                        case 20:
	                        case "end":
	                            return _context3.stop();
	                    }
	                }
	            }, _callee3, this);
	        }));
	
	        function refreshIssueData(_x2) {
	            return _ref4.apply(this, arguments);
	        }
	
	        return refreshIssueData;
	    }(),
	    attestDisclaimer: function attestDisclaimer(_ref6) {
	        var setIsDisclaimer = _ref6.setIsDisclaimer;
	
	        var a = _twd.fmt.mdy(new Date());
	        (0, _twd.setUserParm)('HISTORY-DISCLAIMER', a);
	        (0, _twd.ajax)({
	            url: "/esb/administration/userservice/historyDisclaimer?userId=" + (0, _twd.getUserId)() + "&value=" + a,
	            method: 'POST',
	            params: {}
	        });
	        setIsDisclaimer(false);
	    },
	    refreshTradeData: function () {
	        var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(_ref7) {
	            var _this2 = this;
	
	            var cusip = _ref7.cusip,
	                filterByDate = _ref7.filterByDate,
	                setError = _ref7.setError;
	
	            var fromDate, _ref9, tradedata, _ref10, last, details, hasTradeYield, detailsByDate;
	
	            return _regenerator2.default.wrap(function _callee4$(_context4) {
	                while (1) {
	                    switch (_context4.prev = _context4.next) {
	                        case 0:
	                            fromDate = String(filterByDate);
	
	                            if (!(!(0, _twd.isEmpty)(this.tradeData) && !(0, _twd.isEmpty)(this.lastTradeData) && this.cusip === cusip && this.fromDate && this.fromDate === fromDate)) {
	                                _context4.next = 3;
	                                break;
	                            }
	
	                            return _context4.abrupt("return");
	
	                        case 3:
	
	                            this.fromDate = fromDate;
	                            this.tradeData = [];
	                            this.lastTradeData = null;
	
	                            _context4.prev = 6;
	                            _context4.next = 9;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/tradehistory',
	                                method: 'POST',
	                                params: { cusip: cusip, fromDate: fromDate }
	                            });
	
	                        case 9:
	                            _ref9 = _context4.sent;
	                            tradedata = _ref9.data;
	                            _context4.next = 13;
	                            return tradedata;
	
	                        case 13:
	                            _context4.t0 = _context4.sent;
	
	                            if (_context4.t0) {
	                                _context4.next = 16;
	                                break;
	                            }
	
	                            _context4.t0 = {};
	
	                        case 16:
	                            _ref10 = _context4.t0;
	                            last = _ref10.last;
	                            details = _ref10.details;
	
	                            if (!(0, _twd.isEmpty)(last)) {
	                                _context4.next = 22;
	                                break;
	                            }
	
	                            setError(Errors.NO_LAST_TRADE);
	                            return _context4.abrupt("return", Errors.NO_LAST_TRADE);
	
	                        case 22:
	                            hasTradeYield = this.hasTradeYield;
	
	
	                            this.lastTradeData = this.adjustTradeType(last, hasTradeYield);
	
	                            detailsByDate = Array.from(details).map(function (r) {
	                                return _this2.adjustTradeType(r, hasTradeYield);
	                            }).map(function (r) {
	                                return Object.assign({
	                                    tradeDateTimeValue: new Date(r.tradeDateTime).getTime(),
	                                    tradeDate: _twd.fmt.mdy(r.tradeDateTime)
	                                }, r);
	                            }).map(function (r) {
	                                return Object.assign({
	                                    tradeDateValue: new Date(r.tradeDate).getTime()
	                                }, r);
	                            }).filter(function (_ref11) {
	                                var tradeDateValue = _ref11.tradeDateValue;
	                                return tradeDateValue;
	                            }).sort(function (_ref12, _ref13) {
	                                var a = _ref12.tradeDateTimeValue;
	                                var b = _ref13.tradeDateTimeValue;
	                                return b - a;
	                            }).reduce(function (x, r) {
	                                var id = r.tradeDateValue,
	                                    tradeDate = r.tradeDate;
	
	                                if (!(id in x)) {
	                                    x[id] = { tradeDate: tradeDate, tradeDateValue: id, details: [] };
	                                }
	                                x[id].details.push(r);
	                                return x;
	                            }, {});
	
	
	                            this.tradeData = Array.from(Object.entries(detailsByDate)).sort(function (tradeDateValue1, tradeDateValue2) {
	                                return tradeDateValue2[0] - tradeDateValue1[0];
	                            }).map(function (_ref14) {
	                                var _ref15 = _slicedToArray(_ref14, 2),
	                                    _ = _ref15[0],
	                                    a = _ref15[1];
	
	                                return a;
	                            }).map(function (r) {
	                                return Object.assign({
	                                    tradeDateValue: r.tradeDateValue,
	                                    tradeDate: r.tradeDate,
	                                    totalTrades: r.details.length,
	                                    hasEstimates: r.details.some(function (a) {
	                                        return a.isEstimate;
	                                    }),
	                                    details: r.details
	                                }, r.details.reduce(function (s, a) {
	                                    if (!('highPrice' in s) || s.highPrice < a.tradePrice) {
	                                        s = Object.assign({}, s, { highPrice: a.tradePrice, highYield: a.tradeYield, highQuantity: a.tradeQuantity, highIsEstimate: a.isEstimate });
	                                    }
	                                    if (!('lowPrice' in s) || s.lowPrice > a.tradePrice) {
	                                        s = Object.assign({}, s, { lowPrice: a.tradePrice, lowYield: a.tradeYield, lowQuantity: a.tradeQuantity, lowIsEstimate: a.isEstimate });
	                                    }
	                                    return s;
	                                }, {}));
	                            });
	
	                            if (!(this.tradeData.length === 0)) {
	                                _context4.next = 29;
	                                break;
	                            }
	
	                            setError(Errors.NO_TRADE_DATA);
	                            return _context4.abrupt("return", Errors.NO_TRADE_DATA);
	
	                        case 29:
	                            _context4.next = 36;
	                            break;
	
	                        case 31:
	                            _context4.prev = 31;
	                            _context4.t1 = _context4["catch"](6);
	
	                            console.log('trade-history error', _context4.t1);
	                            setError(Errors.NO_TRADE_DATA);
	                            return _context4.abrupt("return", Errors.NO_TRADE_DATA);
	
	                        case 36:
	                        case "end":
	                            return _context4.stop();
	                    }
	                }
	            }, _callee4, this, [[6, 31]]);
	        }));
	
	        function refreshTradeData(_x3) {
	            return _ref8.apply(this, arguments);
	        }
	
	        return refreshTradeData;
	    }(),
	
	
	    tradeTypesMapping: {
	        "SALES": "Customer Buy",
	        "PURCHASE": "Customer Sell",
	        "DEALER": "Dealer to Dealer",
	        "SALES.HISTORY": "Customer Buy",
	        "PURCHASE.HISTORY": "Customer Sell",
	        "DEALER.HISTORY": "Dealer to Dealer"
	    },
	
	    adjustTradeType: function adjustTradeType(r, hasTradeYield) {
	        var a = r.tradeType;
	        return Object.assign({}, r, {
	            tradeType: this.tradeTypesMapping[a] || a,
	            isEstimate: r.estimateFlag === 'Y',
	            tradeYield: hasTradeYield ? r.tradeYield : null
	        });
	    },
	
	
	    get cusip() {
	        return this.issueData.cusip;
	    },
	
	    get issuer() {
	        return this.issueData.issueDisplay;
	    },
	
	    get lastTrade() {
	        return this.lastTradeData || {};
	    },
	
	    get highestTrade() {
	        return this.tradeData.reduce(function (r, t) {
	            return !r || t.highPrice > r.tradePrice ? Object.assign({}, t, { tradePrice: t.highPrice, tradeYield: t.highYield }) : r;
	        }, null);
	    },
	
	    get lowestTrade() {
	        return this.tradeData.reduce(function (r, t) {
	            return !r || t.lowPrice < r.tradePrice ? Object.assign({}, t, { tradePrice: t.lowPrice, tradeYield: t.lowYield }) : r;
	        }, null);
	    },
	
	    get trades() {
	        return this.tradeData || [];
	    },
	
	    get tradeDates() {
	        return this.trades.map(function (trade) {
	            return trade.tradeDate;
	        });
	    },
	
	    get lastTradeDate() {
	        return (this.trades[0] || {}).tradeDate;
	    },
	
	    get hasEstimates() {
	        return this.trades.some(function (trade) {
	            return trade.hasEstimates;
	        });
	    },
	
	    get tradeDetails() {
	        var details = this.trades.flatMap(function (trade) {
	            return trade.details;
	        });
	        var prices = details.map(function (a) {
	            return a.tradePrice;
	        });
	        var yields = details.map(function (a) {
	            return a.tradeYield;
	        }).filter(function (a) {
	            return (0, _twd.isNumeric)(a);
	        });
	        var quantities = details.map(function (a) {
	            return a.tradeQuantity;
	        });
	        var n = details.length;
	        return {
	            details: details,
	            summary: {
	                totalTrades: n,
	                averagePrice: prices.reduce(function (acc, a) {
	                    return acc + a;
	                }, 0) / n,
	                averageYield: yields.length > 0 ? yields.reduce(function (acc, a) {
	                    return acc + a;
	                }, 0) / yields.length : null,
	                averageQuantity: quantities.reduce(function (acc, a) {
	                    return acc + a;
	                }, 0) / n,
	                hasEstimates: details.some(function (a) {
	                    return a.isEstimate;
	                })
	            }
	        };
	    },
	
	    customerBuys: function customerBuys(_ref16) {
	        var showDataAs = _ref16.showDataAs;
	
	        return this.chartData("Customer Buy", this.getValueField(showDataAs));
	    },
	    customerSells: function customerSells(_ref17) {
	        var showDataAs = _ref17.showDataAs;
	
	        return this.chartData("Customer Sell", this.getValueField(showDataAs));
	    },
	    dealerToDealers: function dealerToDealers(_ref18) {
	        var showDataAs = _ref18.showDataAs;
	
	        return this.chartData("Dealer to Dealer", this.getValueField(showDataAs));
	    },
	
	
	    getValueField: function getValueField(showDataAs) {
	        return showDataAs === 'price-history' ? 'tradePrice' : 'tradeYield';
	    },
	
	    get hasTradeYield() {
	        var _ref19 = this.issueData || {},
	            type = _ref19.type,
	            category = _ref19.category,
	            couponTypeCode = _ref19.couponTypeCode;
	
	        var a = ['P', 'O', 'R', 'K'].includes(type) || ['C', 'S'].includes(type) && category === 'N' || ['E', '0'].includes(couponTypeCode);
	        return !a;
	    },
	
	    chartData: function chartData(tradeType, valueField) {
	        return this.trades.map(function (trade) {
	            return trade.details.filter(function (a) {
	                return a.tradeType === tradeType;
	            }).map(function (a) {
	                return Object.assign({
	                    x: a.tradeDateTimeValue,
	                    y: a[valueField]
	                }, a);
	            });
	        }).flat().sort(function (a, b) {
	            return a.x - b.x;
	        });
	    },
	    chartYDomain: function chartYDomain(_ref20, _ref21) {
	        var showDataAs = _ref20.showDataAs;
	        var showCustomerBuys = _ref21.showCustomerBuys,
	            showCustomerSells = _ref21.showCustomerSells,
	            showDealerToDealers = _ref21.showDealerToDealers;
	
	        var rs = [];
	        if (showCustomerBuys) {
	            rs.push.apply(rs, _toConsumableArray((this.customerBuys({ showDataAs: showDataAs }) || []).map(function (a) {
	                return a.y;
	            }).filter(function (y) {
	                return y != null;
	            })));
	        }
	        if (showCustomerSells) {
	            rs.push.apply(rs, _toConsumableArray((this.customerSells({ showDataAs: showDataAs }) || []).map(function (a) {
	                return a.y;
	            }).filter(function (y) {
	                return y != null;
	            })));
	        }
	        if (showDealerToDealers) {
	            rs.push.apply(rs, _toConsumableArray((this.dealerToDealers({ showDataAs: showDataAs }) || []).map(function (a) {
	                return a.y;
	            }).filter(function (y) {
	                return y != null;
	            })));
	        }
	
	        if (rs.length === 0) {
	            return [0, 1];
	        }
	
	        var min = Math.min.apply(Math, rs);
	        var max = Math.max.apply(Math, rs);
	        var range = max - min;
	        var padding = range > 0 ? range * 0.1 : Math.max(Math.abs(min) * 0.1, Math.abs(max) * 0.1, 1);
	        return [min - padding, max + padding];
	    },
	    chartXDomain: function chartXDomain(_ref22, _ref23) {
	        var showDataAs = _ref22.showDataAs,
	            filterByDate = _ref22.filterByDate;
	        var showCustomerBuys = _ref23.showCustomerBuys,
	            showCustomerSells = _ref23.showCustomerSells,
	            showDealerToDealers = _ref23.showDealerToDealers;
	
	        var rs = [];
	        if (showCustomerBuys) {
	            rs.push.apply(rs, _toConsumableArray((this.customerBuys({ showDataAs: showDataAs }) || []).map(function (a) {
	                return a.x;
	            }).filter(function (x) {
	                return x != null;
	            })));
	        }
	        if (showCustomerSells) {
	            rs.push.apply(rs, _toConsumableArray((this.customerSells({ showDataAs: showDataAs }) || []).map(function (a) {
	                return a.x;
	            }).filter(function (x) {
	                return x != null;
	            })));
	        }
	        if (showDealerToDealers) {
	            rs.push.apply(rs, _toConsumableArray((this.dealerToDealers({ showDataAs: showDataAs }) || []).map(function (a) {
	                return a.x;
	            }).filter(function (x) {
	                return x != null;
	            })));
	        }
	
	        var now = new Date();
	        var from = new Date(now);
	        from.setDate(from.getDate() - parseInt(filterByDate, 10));
	        return [from.getTime(), now.getTime()];
	    },
	    chartXTicks: function chartXTicks(_, _ref24) {
	        var _ref25 = _slicedToArray(_ref24, 2),
	            minx = _ref25[0],
	            maxx = _ref25[1];
	
	        var maxTicks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 9;
	
	        var dayMs = 24 * 60 * 60 * 1000;
	        var ts = [];
	        var t = minx;
	        while (t <= maxx) {
	            ts.push(t);
	            t += dayMs;
	        }
	
	        if (ts.length > maxTicks) {
	            var _step = Math.ceil(ts.length / maxTicks);
	            return ts.filter(function (_, i) {
	                return i % _step === 0;
	            });
	        }
	        return ts;
	    }
	});

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Disclaimer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Disclaimer = exports.Disclaimer = function Disclaimer(_ref) {
	    var context = _ref.context;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12 col-xs-12' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'modal-title text-center vertical-offset-sm' },
	                    'TRACE Real-Time Data Agreement'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'I hereby certify, for the purpose of using the Trade Reporting and Compliance Engine (TRACE) Data ("Data") supplied by Financial Industry Regulatory Authority ("FINRA") that I am accessing via this website, that ',
	                    _react2.default.createElement(
	                        'b',
	                        null,
	                        'I am using the Data for personal, non-commercial purposes only.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'I agree that FINRA owns the Data and that I will not: 1) duplicate or download the Data, other than for my own personal individual use; 2) use any robot, spider, other automatic device or manual process to monitor or copy the Data; or 3) otherwise distribute the Data.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'I understand that FINRA may track my use to confirm compliance with these Terms of Use and that my access to this Data may be terminated at any time for any reason.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'By clicking the "Agree" button, I certify that I understand and agree to all the terms set forth above.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-12 text-center' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: 'btn btn-primary',
	                        style: { margin: '5px' },
	                        onClick: function onClick() {
	                            _all.ProxyContext.destroy('trade-history');
	                            (0, _all.hideModal)();
	                        }
	                    },
	                    'Decline'
	                ),
	                _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: 'btn btn-primary',
	                        style: { margin: '5px' },
	                        onClick: function onClick() {
	                            _all.ProxyContext.get('trade-history').attestDisclaimer();
	                        }
	                    },
	                    'Agree'
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ErrorMessage = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    min-height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    border: solid 1px #e4e4e4;\n    ', ' {\n        min-height: 550px;\n    }\n'], ['\n    min-height: 200px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    border: solid 1px #e4e4e4;\n    ', ' {\n        min-height: 550px;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _mediaQueries = __webpack_require__(162);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var errorMessageCss = (0, _core.css)(_templateObject, _mediaQueries.mediaQueries.notXs);
	
	var ErrorMessage = exports.ErrorMessage = function ErrorMessage(_ref) {
	    var error = _ref.error,
	        subError = _ref.subError;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12 text-center', css: errorMessageCss },
	                (0, _core.jsx)('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' }),
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'small-header' },
	                    error
	                ),
	                subError && (0, _core.jsx)(
	                    'p',
	                    null,
	                    subError
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-xs' },
	            (0, _core.jsx)(
	                'div',
	                { className: 'col-xs-12 text-right text-small' },
	                'Source: FINRA TRACE/MSRB'
	            )
	        )
	    );
	};

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Filter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Filter = exports.Filter = function Filter(_ref) {
	    var context = _ref.context;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'form-group col-md-3 col-xs-12', style: { marginBottom: 0 } },
	                _react2.default.createElement(_twd.Fields.Select, {
	                    label: 'Filter by date',
	                    labelStyle: { fontSize: 'inherit', marginBottom: '0' },
	
	                    value: context.filterByDate,
	                    options: [{ label: 'Today', value: '0' }, { label: 'Last 7 days', value: '7' }, { label: 'Last 30 days', value: '30' }, { label: 'Last 60 days', value: '60' }, { label: 'Last 90 days', value: '90' }, { label: 'Last 180 days', value: '180' }],
	                    style: getSelectStyle(),
	                    optionStyle: optionStyle,
	                    onChange: function onChange(a) {
	                        var s = a.target.value;
	                        context.setFilterByDate(s);
	                        location.hash = '';
	                    } })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'form-group col-md-3 col-xs-12', style: { marginBottom: 0 } },
	                _react2.default.createElement(_twd.Fields.Select, {
	                    label: 'Show data as',
	                    labelStyle: { fontSize: 'inherit', marginBottom: '0' },
	                    value: context.showDataAs,
	                    options: [{ label: 'Summary table', value: 'summary-table' }, { label: 'Price history', value: 'price-history' }, context.hasTradeYield && { label: 'Yield history', value: 'yield-history' }].filter(Boolean),
	                    style: getSelectStyle(),
	                    optionStyle: optionStyle,
	                    onChange: function onChange(a) {
	                        var s = a.target.value;
	                        context.setShowDataAs(s);
	                        location.hash = '';
	                    } })
	            )
	        )
	    );
	};
	
	var getSelectStyle = function getSelectStyle() {
	    var color = getComputedStyle(document.documentElement).getPropertyValue('--primary-base-color').trim() || '#5627d8';
	
	    return {
	        border: '1px solid ' + color,
	        color: color,
	        'marginBottom': '0',
	        backgroundImage: "url(\"data:image/svg+xml;charset=utf8,%3Csvg width='12px' height='10px' viewBox='258 91 12 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg id='chevron-right' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' transform='translate(264.000000, 96.000000) rotate(90.000000) translate(-264.000000, -96.000000) translate(260.500000, 90.000000)'%3E%3Cpolygon id='Shape' fill='" + color.replace('#', '%23') + "' points='1 0 -0.4 1.4 4.2 6 -0.4 10.6 1 12 7 6'%3E%3C/polygon%3E%3C/g%3E%3C/svg%3E\")",
	        display: 'block',
	        fontSize: '15px',
	        fontWeight: '500',
	        padding: '5px 20px'
	    };
	};
	
	var optionStyle = {
	    color: 'var(--primary-base-color)',
	    fontSize: '13px'
	};

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Header = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = exports.Header = function Header(_ref) {
	    var context = _ref.context;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            "div",
	            { className: "row vertical-offset-sm", style: { borderBottom: "2px solid #e4e4e4" } },
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-10" },
	                _react2.default.createElement(
	                    "h3",
	                    { className: "medium-header" },
	                    context.issuer
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "col-md-2 text-right text-medium trade-history-header-cusip" },
	                context.cusip
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1134 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable no-use-before-define,eqeqeq */
	
	var formatXAxisTicks = exports.formatXAxisTicks = function formatXAxisTicks(value, filterByDate, hasData) {
	    if (!value) return '';
	    var d = new Date(value);
	    if (isNaN(d.getTime())) return value;
	    if (filterByDate == 0 && hasData) {
	        var h = d.getHours();
	        var m = d.getMinutes();
	        var ampm = h >= 12 ? 'PM' : 'AM';
	        var h12 = h % 12 || 12;
	        return String(h12).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ' ' + ampm;
	    }
	    return String(d.getMonth() + 1).padStart(2, '0') + '/' + String(d.getDate()).padStart(2, '0');
	};
	
	var formatYAxisTicks = exports.formatYAxisTicks = function formatYAxisTicks(value, showDataAs) {
	    var formatted = value.toLocaleString("en-US", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
	    return showDataAs === 'price-history' ? formatted : formatted + '%';
	};

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ChartTooltip = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    div {\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        white-space: nowrap;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n'], ['\n    div {\n        display: grid;\n        grid-template-columns: auto 1fr;\n    }\n    dt, dd {\n        padding: 6px;\n        line-height: 1.4;\n        font-weight:400;\n        color: #242424;\n        border-bottom: 1px solid #e4e4e4;\n        white-space: nowrap;\n    }\n    dt {\n        text-align: left;\n    }\n    dd {\n        text-align: right;\n        font-weight: 500;\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	var _chartShapes = __webpack_require__(477);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var listCss = (0, _core.css)(_templateObject);
	
	var onMouseOver = function onMouseOver(payload, _, event) {
	    var tradeDateTime = payload.tradeDateTime,
	        tradePrice = payload.tradePrice,
	        tradeYield = payload.tradeYield,
	        tradeType = payload.tradeType;
	
	
	    (0, _twd.publish)('show_flyout', {
	        el: event.target,
	        showIcon: false,
	        html: (0, _core.jsx)(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            (0, _core.jsx)(
	                'dl',
	                { css: listCss },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12' },
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Trade Date'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.mdy(tradeDateTime)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Price'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.price3(tradePrice)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Yield'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        _twd.fmt.ytw3(tradeYield)
	                    ),
	                    (0, _core.jsx)(
	                        'dt',
	                        null,
	                        'Trade Type'
	                    ),
	                    (0, _core.jsx)(
	                        'dd',
	                        null,
	                        (0, _core.jsx)(
	                            'span',
	                            { style: { marginRight: '5px' } },
	                            (0, _chartShapes.getIcon)(tradeType)
	                        ),
	                        ' ',
	                        tradeType
	                    )
	                )
	            )
	        )
	    });
	};
	
	var ChartTooltip = exports.ChartTooltip = {
	    onMouseOver: onMouseOver
	};

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.LastTrade = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var LastTrade = exports.LastTrade = function LastTrade(_ref) {
	    var context = _ref.context;
	    var _context$lastTrade = context.lastTrade,
	        tradeDateTime = _context$lastTrade.tradeDateTime,
	        tradePrice = _context$lastTrade.tradePrice,
	        tradeYield = _context$lastTrade.tradeYield,
	        tradeQuantity = _context$lastTrade.tradeQuantity,
	        tradeType = _context$lastTrade.tradeType,
	        isEstimate = _context$lastTrade.isEstimate;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'h4',
	                { className: 'col-md-12 text-medium last-trade-heading' },
	                'Last reported trade'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm last-trade-container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                _react2.default.createElement(
	                    'dl',
	                    { className: 'last-trade-dl' },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'dt',
	                            null,
	                            'Trade Date'
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            { className: 'text-medium', style: { whiteSpace: 'nowrap' } },
	                            _twd.fmt.ts(tradeDateTime)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'dt',
	                            { className: 'text-right' },
	                            'Price'
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            { className: 'text-right text-medium' },
	                            _twd.fmt.price3(tradePrice)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'dt',
	                            { className: 'text-right' },
	                            'Yield'
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            { className: 'text-right text-medium' },
	                            _twd.fmt.ytw3(context.hasTradeYield ? tradeYield : null)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'dt',
	                            { className: 'text-right' },
	                            'Quantity'
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            { className: 'text-right text-medium' },
	                            isEstimate ? '* 1,000' : _twd.fmt.qty(tradeQuantity)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'dt',
	                            null,
	                            'Trade Type ',
	                            _react2.default.createElement(
	                                'span',
	                                { className: 'xs-hide' },
	                                '(Special Notes)'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'dd',
	                            { className: 'text-medium' },
	                            tradeType || _twd.fmt.empty()
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Legacy = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var Legacy = exports.Legacy = function Legacy(_ref) {
	    var cusip = _ref.cusip;
	
	
	    var base = (0, _twd.getConfig)('bw_service_host') + '/' + (0, _twd.getBrand)();
	    var src = base + '/servlet/msrbhist/history.htm?p_cusip=' + cusip;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'date-name': 'trade-history',
	                className: 'modal-dialog' },
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'date-name': 'trade-history-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: _twd.hideModal },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'modal-title large-header text-center' },
	                        'Trade History Details'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'subhead', style: { textAlign: 'center' } },
	                        'Source: FINRA TRACE/MSRB'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-body', style: { width: '100%' } },
	                    _react2.default.createElement('iframe', {
	                        'date-name': 'trade-history-frame',
	                        src: src,
	                        marginHeight: '0', marginWidth: '0',
	                        frameBorder: '0', scrolling: 'no',
	                        style: { height: '456px', width: '100%' }
	                    })
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Main = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	__webpack_require__(1786);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _controller = __webpack_require__(1129);
	
	var _header = __webpack_require__(1133);
	
	var _filter = __webpack_require__(1132);
	
	var _lastTrade = __webpack_require__(1136);
	
	var _summaryTable = __webpack_require__(1140);
	
	var _priceHistory = __webpack_require__(1139);
	
	var _yieldHistory = __webpack_require__(1144);
	
	var _errorMessage = __webpack_require__(1131);
	
	var _disclaimer = __webpack_require__(1130);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Main = exports.Main = function Main(_ref) {
	    var cusip_ = _ref.cusip;
	
	    var cusip = Array.isArray(cusip_) ? cusip_[0] : cusip_;
	
	    var _React$useState = _react2.default.useState(_twd.Status.LOADING),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(_twd.Status.NULL),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        reloadStatus = _React$useState4[0],
	        setReloadStatus = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState(30),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        filterByDate = _React$useState6[0],
	        setFilterByDate = _React$useState6[1];
	
	    var _React$useState7 = _react2.default.useState("summary-table"),
	        _React$useState8 = _slicedToArray(_React$useState7, 2),
	        showDataAs = _React$useState8[0],
	        setShowDataAs = _React$useState8[1];
	
	    var _React$useState9 = _react2.default.useState(_controller.Errors.NO_TRADE_DATA),
	        _React$useState10 = _slicedToArray(_React$useState9, 2),
	        error = _React$useState10[0],
	        setError = _React$useState10[1];
	
	    var _React$useState11 = _react2.default.useState(false),
	        _React$useState12 = _slicedToArray(_React$useState11, 2),
	        isDisclaimer = _React$useState12[0],
	        setIsDisclaimer = _React$useState12[1];
	
	    var proxy = (0, _twd.proxyContext)(_controller.controller, {
	        cusip: cusip,
	        status: status, setStatus: setStatus,
	        reloadStatus: reloadStatus, setReloadStatus: setReloadStatus,
	        filterByDate: filterByDate, setFilterByDate: setFilterByDate,
	        showDataAs: showDataAs, setShowDataAs: setShowDataAs,
	        error: error, setError: setError,
	        isDisclaimer: isDisclaimer, setIsDisclaimer: setIsDisclaimer
	    }, "trade-history");
	
	    _react2.default.useEffect(function () {
	        proxy.refresh();
	    }, [cusip, filterByDate]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            {
	                'date-name': 'trade-history',
	                className: 'modal-dialog modal-lg trade-history trade-history-dialog' },
	            reloadStatus === _twd.Status.LOADING && _react2.default.createElement(
	                'div',
	                { className: 'trade-history-mask', 'aria-hidden': 'true' },
	                _react2.default.createElement(_twd.Loading, { status: reloadStatus })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'modal-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-header' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            'date-name': 'trade-history-close',
	                            className: 'close',
	                            'aria-label': 'close',
	                            type: 'button',
	                            onClick: function onClick() {
	                                _twd.ProxyContext.destroy('trade-history');
	                                (0, _twd.hideModal)();
	                            } },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'close'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'modal-title large-header text-center' },
	                        'Trade history details'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'modal-body', style: { width: '100%' } },
	                    _react2.default.createElement(
	                        _twd.Loading,
	                        { status: status },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            isDisclaimer && _react2.default.createElement(_disclaimer.Disclaimer, null),
	                            !isDisclaimer && _react2.default.createElement(
	                                _react2.default.Fragment,
	                                null,
	                                !error && _react2.default.createElement(
	                                    _react2.default.Fragment,
	                                    null,
	                                    _react2.default.createElement(_header.Header, { context: proxy }),
	                                    _react2.default.createElement(_lastTrade.LastTrade, { context: proxy }),
	                                    _react2.default.createElement(_filter.Filter, { context: proxy }),
	                                    showDataAs === 'summary-table' && _react2.default.createElement(_summaryTable.SummaryTable, { context: proxy }),
	                                    showDataAs === 'price-history' && _react2.default.createElement(_priceHistory.PriceHistory, { context: proxy }),
	                                    showDataAs === 'yield-history' && _react2.default.createElement(_yieldHistory.YieldHistory, { context: proxy })
	                                ),
	                                error === _controller.Errors.NO_CUSIP && _react2.default.createElement(_errorMessage.ErrorMessage, { error: error }),
	                                error === _controller.Errors.NO_LAST_TRADE && _react2.default.createElement(
	                                    _react2.default.Fragment,
	                                    null,
	                                    _react2.default.createElement(_header.Header, { context: proxy }),
	                                    _react2.default.createElement(_errorMessage.ErrorMessage, { error: error })
	                                ),
	                                error === _controller.Errors.NO_TRADE_DATA && _react2.default.createElement(
	                                    _react2.default.Fragment,
	                                    null,
	                                    _react2.default.createElement(_header.Header, { context: proxy }),
	                                    _react2.default.createElement(_lastTrade.LastTrade, { context: proxy }),
	                                    _react2.default.createElement(_filter.Filter, { context: proxy }),
	                                    _react2.default.createElement(_errorMessage.ErrorMessage, { error: error, subError: "Please select another date range." })
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.PriceHistory = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(478);
	
	var _table = __webpack_require__(479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PriceHistory = exports.PriceHistory = function PriceHistory(_ref) {
	    var context = _ref.context;
	
	    var n = context.filterByDate;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'h4',
	                { className: 'col-md-12 text-medium', style: { fontSize: 'inherit' } },
	                'Price history chart for ',
	                n == 0 ? 'today' : 'last ' + n + ' days'
	            )
	        ),
	        _react2.default.createElement(_chart.Chart, { context: context }),
	        _react2.default.createElement(_table.Table, { context: context })
	    );
	}; /* eslint-disable no-use-before-define,eqeqeq */

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SummaryTable = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _summary = __webpack_require__(1141);
	
	var _table = __webpack_require__(1142);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SummaryTable = exports.SummaryTable = function SummaryTable(_ref) {
	    var context = _ref.context;
	
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_summary.Summary, { context: context }),
	        _react2.default.createElement(_table.Table, { context: context })
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Summary = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define, eqeqeq */
	var Summary = exports.Summary = function Summary(_ref) {
	    var context = _ref.context;
	
	    var n = context.filterByDate;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'h4',
	                { className: 'col-md-12 text-medium' },
	                'Trade summary for ',
	                n == 0 ? 'today' : 'last ' + n + ' days',
	                ' '
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm',
	                style: {
	                    margin: 0,
	                    paddingTop: '10px',
	                    paddingBottom: '10px',
	                    paddingLeft: '5px',
	                    backgroundColor: "rgb(246, 246, 246)"
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-6' },
	                _react2.default.createElement(Col, Object.assign({ title: 'Highest trade price' }, context.highestTrade))
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-6' },
	                _react2.default.createElement(Col, Object.assign({ title: 'Lowest trade price' }, context.lowestTrade))
	            )
	        )
	    );
	};
	
	var Col = function Col() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        title = _ref2.title,
	        tradePrice = _ref2.tradePrice,
	        tradeYield = _ref2.tradeYield,
	        tradeDate = _ref2.tradeDate;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h5',
	            { className: 'vertical-offset-xs summary-trade-title' },
	            title
	        ),
	        _react2.default.createElement(
	            'dl',
	            { className: 'summary-trade-dl' },
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Price'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    { className: 'text-medium' },
	                    _twd.fmt.price3(tradePrice)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Yield'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    { className: 'text-medium' },
	                    _twd.fmt.ytw3(tradeYield)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Date'
	                ),
	                _react2.default.createElement(
	                    'dd',
	                    { className: 'text-medium' },
	                    tradeDate
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'xs-show text-medium' },
	            _twd.fmt.price3(tradePrice),
	            '/',
	            _twd.fmt.ytw3(tradeYield),
	            _react2.default.createElement('br', null),
	            tradeDate
	        )
	    );
	};

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Table = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var borderBottom0 = {
	    borderBottom: 0
	};
	var borderTop0 = {
	    borderTop: 0
	};
	var marginBottom0 = {
	    marginBottom: 0
	};
	var Table = exports.Table = function Table(_ref) {
	    var context = _ref.context;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs table-responsive trade-history-table-scroll',
	                style: {
	                    margin: 0,
	                    background: '#ffffff',
	                    border: 'solid 1px #e4e4e4',
	                    minHeight: '575PX',
	                    maxHeight: '575px',
	                    overflowY: 'auto'
	                } },
	            _react2.default.createElement(
	                'table',
	                { className: 'table table-summary trade-history-sticky-table', style: marginBottom0 },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        { style: borderBottom0 },
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-center text-medium', colSpan: '2', style: borderBottom0 },
	                            'Trade activity'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-center text-medium', colSpan: '3', style: borderBottom0 },
	                            'Highest reported trade'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-center text-medium', colSpan: '3', style: borderBottom0 },
	                            'Lowest reported trade'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            'Date'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right trade-history-summary-col-sep' },
	                            'Total trades'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Price'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Yield'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right trade-history-summary-col-sep' },
	                            'Quantity'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Price'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Yield'
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            { className: 'text-right' },
	                            'Quantity'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    (context.trades || []).map(function (r, i) {
	                        return _react2.default.createElement(SummaryRow, Object.assign({ key: 'summary-' + i, idx: i }, r));
	                    })
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-xs text-right text-small' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-12' },
	                context.hasEstimates ? _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    '* Total quantity traded may be greater due to 1MM+ trades',
	                    _react2.default.createElement('br', null)
	                ) : null,
	                'Source: FINRA TRACE/MSRB'
	            )
	        )
	    );
	};
	
	var SummaryRow = function SummaryRow() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        idx = _ref2.idx,
	        tradeDate = _ref2.tradeDate,
	        totalTrades = _ref2.totalTrades,
	        highPrice = _ref2.highPrice,
	        highYield = _ref2.highYield,
	        highQuantity = _ref2.highQuantity,
	        lowPrice = _ref2.lowPrice,
	        lowYield = _ref2.lowYield,
	        lowQuantity = _ref2.lowQuantity,
	        lowIsEstimate = _ref2.lowIsEstimate,
	        highIsEstimate = _ref2.highIsEstimate,
	        _ref2$details = _ref2.details,
	        details = _ref2$details === undefined ? [] : _ref2$details;
	
	    var _React$useState = _react2.default.useState(idx === 0),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        showDetails = _React$useState2[0],
	        setShowDetails = _React$useState2[1];
	
	    var toggleDetails = function toggleDetails() {
	        return setShowDetails(!showDetails);
	    };
	
	    var c = "text-right";
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'tr',
	            { key: 'summary-' + idx, className: showDetails ? "text-medium" : "" },
	            _react2.default.createElement(
	                'td',
	                { className: 'trade-history-summary-col-sep' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        type: 'button',
	                        className: 'btn-link',
	                        'aria-label': 'toggle details for ' + tradeDate,
	                        onClick: toggleDetails
	                    },
	                    _react2.default.createElement(
	                        'i',
	                        {
	                            style: { color: 'var(--primary-base-color)', fontSize: "large" },
	                            className: 'toggle-button-icon-open material-icons',
	                            'aria-hidden': true
	                        },
	                        showDetails ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
	                    ),
	                    tradeDate
	                )
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: c + ' trade-history-summary-col-sep' },
	                totalTrades
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: c },
	                _twd.fmt.price3(highPrice)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: c },
	                _twd.fmt.ytw3(highYield)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: c + ' trade-history-summary-col-sep' },
	                highIsEstimate ? '* 1,000' : _twd.fmt.qty(highQuantity)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: c },
	                _twd.fmt.price3(lowPrice)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: c },
	                _twd.fmt.ytw3(lowYield)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: c },
	                lowIsEstimate ? '* 1,000' : _twd.fmt.qty(lowQuantity)
	            )
	        ),
	        _react2.default.createElement(
	            'tr',
	            { key: 'summary-detail-' + idx, style: { backgroundColor: '#ffffff', display: showDetails ? 'table-row' : 'none' } },
	            _react2.default.createElement(
	                'td',
	                { colSpan: '8', style: { paddingLeft: '25px', backgroundColor: '#ffffff' } },
	                _react2.default.createElement(Details, { tradeDate: tradeDate, details: details })
	            )
	        )
	    );
	};
	
	var Details = function Details() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        tradeDate = _ref3.tradeDate,
	        _ref3$details = _ref3.details,
	        details = _ref3$details === undefined ? [] : _ref3$details;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'table',
	            { className: 'table table-striped trade-history-detail-table' },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { colSpan: '5', className: 'text-medium', style: borderBottom0 },
	                        'Trade details for ',
	                        tradeDate
	                    )
	                ),
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { style: borderTop0 },
	                        'Trade time'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right', style: borderTop0 },
	                        'Price'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right', style: borderTop0 },
	                        'Yield'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { className: 'text-right', style: borderTop0 },
	                        'Quantity'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        { style: borderTop0 },
	                        'Trade Type (Special Notes)'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                details.map(function (r, i) {
	                    return _react2.default.createElement(DetailRow, Object.assign({ key: 'details-' + i, idx: i }, r));
	                })
	            )
	        )
	    );
	};
	
	var DetailRow = function DetailRow(_ref4) {
	    var idx = _ref4.idx,
	        tradeDateTime = _ref4.tradeDateTime,
	        tradePrice = _ref4.tradePrice,
	        tradeYield = _ref4.tradeYield,
	        tradeQuantity = _ref4.tradeQuantity,
	        tradeType = _ref4.tradeType,
	        tradeNotes = _ref4.tradeNotes,
	        isEstimate = _ref4.isEstimate;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'tr',
	            { key: 'detail-row-' + idx },
	            _react2.default.createElement(
	                'td',
	                { style: { whiteSpace: 'nowrap', verticalAlign: 'top' } },
	                _twd.fmt.ts(tradeDateTime)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: 'text-right', style: { verticalAlign: 'top' } },
	                _twd.fmt.price3(tradePrice)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: 'text-right', style: { verticalAlign: 'top' } },
	                _twd.fmt.ytw3(tradeYield)
	            ),
	            _react2.default.createElement(
	                'td',
	                { className: 'text-right', style: { verticalAlign: 'top' } },
	                isEstimate ? '* 1,000' : _twd.fmt.qty(tradeQuantity)
	            ),
	            _react2.default.createElement(
	                'td',
	                { style: { verticalAlign: 'top' } },
	                tradeType,
	                ' ',
	                tradeNotes ? '(' + tradeNotes + ')' : ''
	            )
	        )
	    );
	};

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _legacy = __webpack_require__(1137);
	
	var _main = __webpack_require__(1138);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	exports.default = function (args) {
	    return (0, _twd.getConfig)('entitlements.ETradeTradeHistory', 'No') === 'Yes' ? _react2.default.createElement(_main.Main, args) : _react2.default.createElement(_legacy.Legacy, args);
	};

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.YieldHistory = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chart = __webpack_require__(478);
	
	var _table = __webpack_require__(479);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var YieldHistory = exports.YieldHistory = function YieldHistory(_ref) {
	    var context = _ref.context;
	
	    var n = context.filterByDate;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'h4',
	                { className: 'col-md-12 text-medium', style: { fontSize: 'inherit' } },
	                'Yield history chart for ',
	                n === 0 ? 'today' : 'last ' + n + ' days'
	            )
	        ),
	        _react2.default.createElement(_chart.Chart, { context: context }),
	        _react2.default.createElement(_table.Table, { context: context })
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useTreasuryAuctions3 = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useTreasuryAuctions = (0, _useTreasuryAuctions3.useTreasuryAuctions)(),
	        auctions = _useTreasuryAuctions.auctions;
	
	    var hasAuctions = auctions.length > 0;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	        !hasAuctions && _react2.default.createElement(EmptyMsg, null),
	        hasAuctions && _react2.default.createElement(Table, null)
	    );
	};
	
	var EmptyMsg = function EmptyMsg() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 text-center' },
	        _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'small-header' },
	            'There are currently no live Treasury auctions.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Check the upcoming auctions table for the tentative schedule.'
	        )
	    );
	};
	
	var monthsDaysFromToday = function monthsDaysFromToday(s) {
	    var d = (0, _twd.parseDate)(s);
	    if (!d || isNaN(d)) return null;
	    var n = new Date();
	    if (n > d) return null;
	
	    var dy = d.getFullYear() - n.getFullYear();
	    var dm = d.getMonth() - n.getMonth();
	
	    var dd = d.getDate() - n.getDate();
	    var isLess = dd < 0;
	
	    var months = dy * 12 + dm + (isLess ? -1 : 0);
	    n.setMonth(n.getMonth() + months);
	
	    var days = !isLess ? dd : Math.floor(Math.abs(d - n) / (24 * 60 * 60 * 1000));
	
	    return { months: months, days: days };
	};
	
	var fmtTimes = function fmtTimes(n, l) {
	    return n ? n + ' ' + l + (n > 1 ? 's' : '') : '';
	};
	
	var Table = function Table() {
	    var _useTreasuryAuctions2 = (0, _useTreasuryAuctions3.useTreasuryAuctions)(),
	        auctions = _useTreasuryAuctions2.auctions;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table auctions-table' },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Issue'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'CUSIP'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Auction date'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Maturity date'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Min Qty',
	                                _react2.default.createElement('br', null),
	                                '(,000)'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Max Qty^',
	                                _react2.default.createElement('br', null),
	                                '(,000)'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Auction close'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Settlement date'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-right' },
	                                'Indicative yield\u2020'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'text-center' },
	                                'Action'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        (0, _twd.arrayFrom)(auctions).sort((0, _twd.sortFn)(function (_ref) {
	                            var maturity = _ref.maturity;
	
	                            return _twd.fmt.fmtDt((0, _twd.parseDate)(maturity), 'yyyy-MM-dd');
	                        })).map(function (r, i) {
	                            var issue = r.issue,
	                                cusip = r.cusip,
	                                auctionDate = r.auctionDate,
	                                maturity = r.maturity,
	                                minQty = r.minQty,
	                                maxQty = r.maxQty,
	                                auctionCloseText = r.auctionCloseText,
	                                settlement = r.settlement,
	                                ctfYield = r.ctfYield;
	
	
	                            var a = monthsDaysFromToday(maturity);
	                            var matSubText = !a ? '' : [fmtTimes(a.months, 'month'), fmtTimes(a.days, 'day')].filter(Boolean).join(', ') + ' from today';
	
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: i },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    issue
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    cusip
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    _twd.fmt.mdy(auctionDate)
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    _twd.fmt.mdy(maturity),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'text-muted' },
	                                        matSubText
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    _twd.fmt.qty(minQty)
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    _twd.fmt.qty(maxQty)
	                                ),
	                                _react2.default.createElement('td', { className: 'text-right', dangerouslySetInnerHTML: { __html: auctionCloseText.replace(', ', '<br/>') } }),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    _twd.fmt.mdy(settlement)
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    _twd.fmt.ytw3(ctfYield)
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-center' },
	                                    _react2.default.createElement(
	                                        'button',
	                                        { className: 'btn btn-primary',
	                                            onClick: function onClick() {
	                                                (0, _twd.hideModal)();
	                                                (0, _twd.showBondOrder)({
	                                                    action: 'B',
	                                                    cusip: cusip,
	                                                    isTreasuryAuction: true,
	                                                    settlement: settlement,
	                                                    from: 'treasury-auctions',
	                                                    ts: Date.now()
	                                                });
	                                            }
	                                        },
	                                        'Buy'
	                                    )
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _treasuryChart = __webpack_require__(240);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_treasuryChart.ChartTable, {
	            headerLabel: 'US yield curve',
	            headerClassName: 'btn-label btn-flyout medium-header'
	        })
	    );
	};

/***/ },
/* 1147 */
1081,
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useTreasuryAuctions2 = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = (0, _twd.getState)('treasury-auctions.schedules', {
	    tab: 'bills'
	});
	
	exports.default = function () {
	    var _React$useState = _react2.default.useState(state.value.tab || 'bills'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        tab = _React$useState2[0],
	        setTab_ = _React$useState2[1];
	
	    var setTab = _react2.default.useCallback(function (m) {
	        state.set({ tab: m });
	        setTab_(m);
	    }, []);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'medium-header' },
	                    'Treasury auction schedules'
	                )
	            )
	        ),
	        _react2.default.createElement(Tabs, { tab: tab, setTab: setTab }),
	        _react2.default.createElement(Table, { tab: tab }),
	        tab === 'bills' && _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                'Cash Management Bills (CMBs) are not auctioned on an established schedule; they are offered as needed by the Treasury to manage cash flows.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                'The treasury auction schedule is subject to change, and may be impacted by market holidays. Please reference ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'https://treasurydirect.gov/auctions/when-auctions-happen/',
	                        target: '_blank',
	                        style: { textDecoration: 'underline' } },
	                    'this page'
	                ),
	                ' for current information.'
	            )
	        )
	    );
	};
	
	var Tabs = function Tabs(_ref) {
	    var tab = _ref.tab,
	        setTab = _ref.setTab;
	    return _react2.default.createElement(
	        'div',
	        { className: 'row vertical-offset-sm' },
	        _react2.default.createElement(
	            'div',
	            { className: 'col-xs-12' },
	            _react2.default.createElement(
	                'div',
	                { className: 'nav-tabs nav-tabs-border' },
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'li',
	                        { className: tab === 'bills' ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'subhead',
	                                onClick: function onClick() {
	                                    return setTab('bills');
	                                } },
	                            'Bills'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: tab === 'notes' ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'subhead',
	                                onClick: function onClick() {
	                                    return setTab('notes');
	                                } },
	                            'Notes'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: tab === 'bonds' ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'subhead',
	                                onClick: function onClick() {
	                                    return setTab('bonds');
	                                } },
	                            'Bonds'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: tab === 'tips' ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'subhead',
	                                onClick: function onClick() {
	                                    return setTab('tips');
	                                } },
	                            'TIPS'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        { className: tab === 'frns' ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'subhead',
	                                onClick: function onClick() {
	                                    return setTab('frns');
	                                } },
	                            'FRNs'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Table = function Table(_ref2) {
	    var tab = _ref2.tab;
	
	    var _useTreasuryAuctions = (0, _useTreasuryAuctions2.useTreasuryAuctions)(),
	        schedules = _useTreasuryAuctions.schedules;
	
	    var rs = schedules.filter(function (_ref3) {
	        var type = _ref3.type;
	        return (type || '').toLowerCase() === tab;
	    });
	
	    var hasSchedules = !(0, _twd.isEmpty)(rs);
	
	    if (!hasSchedules) return _react2.default.createElement(EmptyMsg, null);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table' },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Term'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Auction',
	                                _react2.default.createElement('br', null),
	                                'frequency'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Announcement',
	                                _react2.default.createElement('br', null),
	                                'day'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Auction day'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                null,
	                                'Issue day'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        (0, _twd.arrayFrom)(rs).map(function (_ref4, i) {
	                            var term = _ref4.term,
	                                auctionFrequency = _ref4.auctionFrequency,
	                                announcementDay = _ref4.announcementDay,
	                                auctionDay = _ref4.auctionDay,
	                                issueDay = _ref4.issueDay;
	
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: i },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    term
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    auctionFrequency
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    announcementDay
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    auctionDay
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    issueDay
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	};
	
	var EmptyMsg = function EmptyMsg() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 text-center' },
	        _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'small-header' },
	            'There are currently no upcoming Treasury auctions.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Check the upcoming auctions table for the tentative schedule.'
	        )
	    );
	};

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useTreasuryAuctions2 = __webpack_require__(239);
	
	var _footer = __webpack_require__(1147);
	
	var _auctions = __webpack_require__(1145);
	
	var _auctions2 = _interopRequireDefault(_auctions);
	
	var _chart = __webpack_require__(1146);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _upcoming = __webpack_require__(1150);
	
	var _upcoming2 = _interopRequireDefault(_upcoming);
	
	var _schedules = __webpack_require__(1148);
	
	var _schedules2 = _interopRequireDefault(_schedules);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	
	exports.default = function (args) {
	    (0, _twd.trackPage)('treasury-auctions');
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _useTreasuryAuctions2.ContextProvider,
	            args,
	            _react2.default.createElement(Main, null)
	        )
	    );
	};
	
	var Main = function Main(args) {
	    var _useTreasuryAuctions = (0, _useTreasuryAuctions2.useTreasuryAuctions)(),
	        status = _useTreasuryAuctions.status;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: status },
	            _react2.default.createElement(Content, null)
	        )
	    );
	};
	
	var Content = function Content() {
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'container treasury-auctions' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-xs-12' },
	                    _react2.default.createElement(
	                        'div',
	                        { 'data-name': 'messages-message',
	                            className: 'universal-message universal-message-info universal-message-dismissible',
	                            role: 'alert' },
	                        _react2.default.createElement(
	                            'div',
	                            { 'data-name': 'messages-message-content',
	                                className: 'universal-message-content',
	                                style: { width: '100%' }
	                            },
	                            'Cancel requests for open Treasury auction orders must be submitted prior to 9 AM ET; cancellation of an order is not guaranteed even if submitted prior to 9 AM ET. Please consult your E*TRADE from Morgan Stanley Client Agreement for Self-Directed Accounts for further information on order cancellations and other applicable terms and conditions.'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'large-header' },
	                        'Treasury Auctions'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12 text-right' },
	                    _react2.default.createElement(
	                        'a',
	                        { href: 'https://www.treasurydirect.gov/auctions/announcements-data-results/announcement-results-press-releases/auction-results/',
	                            target: '_blank',
	                            style: { textDecoration: 'underline' }
	                        },
	                        'Today\'s auction results'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    _react2.default.createElement(_auctions2.default, null)
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row vertical-offset-xs' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    _react2.default.createElement(_upcoming2.default, null)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-6 col-xs-12' },
	                    _react2.default.createElement(_chart2.default, null),
	                    _react2.default.createElement('br', null),
	                    _react2.default.createElement(_schedules2.default, null)
	                )
	            )
	        ),
	        _react2.default.createElement(_footer.Footer, null)
	    );
	};

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _useTreasuryAuctions3 = __webpack_require__(239);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var download = function download(url) {
	    var a = document.createElement("a");
	    a.href = url;
	    a.download = url.split('/').pop();
	    a.target = "_blank";
	    document.body.appendChild(a);
	    a.click();
	    document.body.removeChild(a);
	};
	
	exports.default = function () {
	    var _useTreasuryAuctions = (0, _useTreasuryAuctions3.useTreasuryAuctions)(),
	        upcoming = _useTreasuryAuctions.upcoming;
	
	    var hasUpcoming = !(0, _twd.isEmpty)(upcoming);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement('div', { className: 'row vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'medium-header' },
	                    'Upcoming auctions'
	                )
	            )
	        ),
	        !hasUpcoming && _react2.default.createElement(EmptyMsg, null),
	        hasUpcoming && _react2.default.createElement(Table, null),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 text-center' },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        className: 'btn btn-lg btn-primary-outline',
	                        onClick: function onClick() {
	                            return download('https://home.treasury.gov/system/files/221/Tentative-Auction-Schedule.pdf');
	                        }
	                    },
	                    'Download the Treasury\'s tentative auction schedule'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 ' },
	                '^ The Treasury establishes a maximum non-competitive bid limit of $10 million per household, per auction.'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-sm' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 ' },
	                '\u2020 The indicative yield value is an estimated yield that is derived from the most recently issued treasury security of a similar maturity. The indicative yield may be unavailable for some auctions (TIPS, FRNs). Please note indicative yields are for informational purposes and do not necessarily represent the final yield level at which the auction will be issued. The actual yield for a given auction may be higher or lower than the indicative yield. The indicative yield is not a commitment by Morgan Stanley Wealth Management to trade at any price.'
	            )
	        )
	    );
	};
	
	var EmptyMsg = function EmptyMsg() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'col-md-12 text-center' },
	        _react2.default.createElement('i', { className: 'et-icon et-alert et-icon-md', 'aria-hidden': 'true' }),
	        _react2.default.createElement(
	            'div',
	            { className: 'small-header' },
	            'There are currently no upcoming Treasury auctions.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Check the upcoming auctions table for the tentative schedule.'
	        )
	    );
	};
	
	var Table = function Table() {
	    var _useTreasuryAuctions2 = (0, _useTreasuryAuctions3.useTreasuryAuctions)(),
	        upcoming = _useTreasuryAuctions2.upcoming;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'row vertical-offset-base' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-xs-12 table-responsive' },
	                _react2.default.createElement(
	                    'table',
	                    { className: 'table table-striped' },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'col-md-9' },
	                                'Issue'
	                            ),
	                            _react2.default.createElement(
	                                'th',
	                                { className: 'col-md-3 text-right' },
	                                'Auction Open'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        (0, _twd.arrayFrom)(upcoming).map(function (_ref, i) {
	                            var description = _ref.description,
	                                auctionDate = _ref.auctionDate;
	
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: i },
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    description
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    { className: 'text-right' },
	                                    _twd.fmt.mdy(auctionDate)
	                                )
	                            );
	                        })
	                    )
	                )
	            )
	        )
	    );
	};

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Chart = undefined;
	
	var _legendCss;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	var _recharts = __webpack_require__(135);
	
	var _useChart2 = __webpack_require__(480);
	
	var _useChart3 = _interopRequireDefault(_useChart2);
	
	var _style = __webpack_require__(1152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var yieldCurveTooltip = '\n    A yield curve is a type of line graph that compares yields of bonds (of equal credit quality)\n    across a range of maturity dates.  These points are plotted on the graph and connected with a line.\n    Investors can think of these yield curves as expressing how much it costs an issuer to borrow\n    money for a stated term. This US Treasury Yield Curve chart is a visual representation of short,\n    medium, and long-term rates for US treasuries. As treasury bonds are backed by the full faith and\n    credit of the US government, the US Treasury Yield Curve is often referred to as the \u201Crisk-free\u201D benchmark\n    curve. Investors often compare the US Treasury Curve against the yield curve of other (riskier) assets\n    to analyze yield spread and assess relative value. This US Treasury Yield curve chart presents\n    the current (as of the last trading session\u2019s close), 1-month, 6-month, and 1-year historical curves.\n';
	
	var Chart = exports.Chart = function Chart() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$headerLabel = _ref.headerLabel,
	        headerLabel = _ref$headerLabel === undefined ? "US Yield Curve" : _ref$headerLabel,
	        _ref$headerClassName = _ref.headerClassName,
	        headerClassName = _ref$headerClassName === undefined ? "btn-label btn-flyout text-bold" : _ref$headerClassName;
	
	    var _useChart = (0, _useChart3.default)(),
	        chartData = _useChart.chartData,
	        chartDataStatus = _useChart.chartDataStatus;
	
	    return (0, _core.jsx)(
	        _react2.default.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'row vertical-offset-xs' }),
	        (0, _core.jsx)(
	            _twd.Loading,
	            { status: chartDataStatus },
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-xs', style: { marginLeft: '10px' } },
	                (0, _core.jsx)(_twd.Flyout, {
	                    label: headerLabel,
	                    className: headerClassName,
	                    html: yieldCurveTooltip
	                })
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12' },
	                    Array.isArray(chartData) && (0, _core.jsx)(
	                        _recharts.ResponsiveContainer,
	                        { width: '100%', height: 300 },
	                        (0, _core.jsx)(
	                            _recharts.ScatterChart,
	                            {
	                                margin: {
	                                    top: 5, right: 30, left: 10, bottom: 5
	                                }
	                            },
	                            (0, _core.jsx)(_recharts.CartesianGrid, { strokeDasharray: '3 3', vertical: false }),
	                            (0, _core.jsx)(_recharts.XAxis, {
	                                dataKey: 'x',
	                                domain: [0, 10],
	                                padding: { left: 10, right: 10 },
	                                type: 'number',
	                                scale: 'linear',
	                                tickFormatter: function tickFormatter(i) {
	                                    return formatXAxisTicks(chartData, i);
	                                }
	                            }),
	                            (0, _core.jsx)(_recharts.YAxis, {
	                                dataKey: 'y',
	                                domain: ['auto', 'auto'],
	                                padding: { top: 10, bottom: 10 },
	                                width: 15,
	                                scale: 'linear',
	                                orientation: 'right',
	                                tickFormatter: formatYAxisTicks
	                            }),
	                            (0, _core.jsx)(_recharts.Legend, {
	                                verticalAlign: 'top',
	                                align: 'left',
	                                content: renderLegend
	                            }),
	                            (0, _core.jsx)(_recharts.Scatter, { name: 'current',
	                                data: getData(chartData, 'current', '#8b06b9'),
	                                line: { strokeWidth: 3 },
	                                fill: '#8b06b9',
	                                shape: renderShape }),
	                            (0, _core.jsx)(_recharts.Scatter, { name: '1mo',
	                                data: getData(chartData, '1mo', '#ef6f06'),
	                                line: true, fill: '#ef6f06',
	                                shape: renderShape }),
	                            (0, _core.jsx)(_recharts.Scatter, { name: '6mo',
	                                data: getData(chartData, '6mo', '#1192e9'),
	                                line: true, fill: '#1192e9',
	                                shape: renderShape }),
	                            (0, _core.jsx)(_recharts.Scatter, { name: '1yr',
	                                data: getData(chartData, '1yr', '#00a3a0'),
	                                line: true, fill: '#00a3a0',
	                                shape: renderShape }),
	                            (0, _core.jsx)(_recharts.Tooltip, {
	                                position: { y: 25 },
	                                offset: 1,
	                                content: (0, _core.jsx)(TooltipContent, { chartData: chartData }),
	                                isAnimationActive: false,
	                                cursor: (0, _core.jsx)(TooltipCursor, null),
	                                wrapperStyle: { zIndex: 3 }
	                            })
	                        )
	                    )
	                )
	            ),
	            (0, _core.jsx)(
	                'div',
	                { className: 'row vertical-offset-sm' },
	                (0, _core.jsx)(
	                    'div',
	                    { className: 'col-md-12 col-xs-12 text-muted', style: { marginLeft: '10px' } },
	                    'Current yield is indicative of last trade session\'s closing level.'
	                )
	            )
	        )
	    );
	};
	
	var getData = function getData(data, key, color) {
	    return data.filter(function (a) {
	        return !(0, _twd.isEmpty)(a[key]);
	    }).map(function (a) {
	        return {
	            key: key, color: color, x: a['x'], y: a[key]
	        };
	    });
	};
	
	var renderShape = function renderShape(_ref2) {
	    var cx = _ref2.cx,
	        cy = _ref2.cy,
	        x = _ref2.x,
	        y = _ref2.y,
	        width = _ref2.width,
	        height = _ref2.height,
	        color = _ref2.color;
	
	    var p = {
	        cx: cx, cy: cy, x: x, y: y, width: width, height: height,
	        stroke: color,
	        fill: '#fff',
	        r: 4,
	        className: 'recharts-dot'
	    };
	    return (0, _core.jsx)('circle', Object.assign({}, p, {
	        onMouseOver: function onMouseOver(e) {
	            return (0, _twd.domAttrSet)(e.target, { fill: color });
	        },
	        onMouseOut: function onMouseOut(e) {
	            return (0, _twd.domAttrSet)(e.target, { fill: '#fff' });
	        }
	    }));
	};
	
	var legends = {
	    'current': 'Current',
	    '1mo': '1M Ago',
	    '6mo': '6M Ago',
	    '1yr': '1Y Ago'
	};
	
	var renderLegend = function renderLegend(_ref3) {
	    var payload = _ref3.payload;
	    return (0, _core.jsx)(
	        'div',
	        { style: { width: '100%', textAlign: 'left', marginBottom: '10px' } },
	        payload.map(function (entry, index) {
	            var v = entry.value;
	            return (0, _core.jsx)(
	                'span',
	                { key: index,
	                    style: { borderLeft: '4px solid ' + entry.color },
	                    css: legendCss },
	                '\xA0 ',
	                legends[v] || v
	            );
	        })
	    );
	};
	
	var legendCss = (_legendCss = {}, _defineProperty(_legendCss, _twd.mediaQueries.notXs, {
	    paddingRight: '40px'
	}), _defineProperty(_legendCss, _twd.mediaQueries.xs, {
	    paddingRight: '20px'
	}), _legendCss);
	
	var formatXAxisTicks = function formatXAxisTicks(chartData, i) {
	    return chartData[i].name;
	};
	
	var formatYAxisTicks = function formatYAxisTicks(x) {
	    return x.toLocaleString("en-US", { minimumFractionDigits: 3, maximumFractionDigits: 3 });
	};
	
	var TooltipContent = function TooltipContent(_ref4) {
	    var payload = _ref4.payload,
	        active = _ref4.active,
	        chartData = _ref4.chartData;
	
	    if (!active) return null;
	
	    var p = payload[0];
	    var a = p && p.payload;
	    if (!a) return null;
	
	    var b = chartData.filter(function (_ref5) {
	        var x = _ref5.x;
	        return x === a.x;
	    })[0];
	    if (!b) return null;
	
	    return (0, _core.jsx)(
	        'div',
	        { className: 'custom-tooltip',
	            style: { border: '1px solid #e4e4e4', backgroundColor: '#fff', textAlign: 'left', padding: '5px' } },
	        (0, _core.jsx)(
	            'div',
	            { className: 'text-bold' },
	            formatTooltipTitle(chartData, a.x)
	        ),
	        (0, _core.jsx)(
	            'div',
	            { css: _style.displayInline },
	            (0, _core.jsx)(
	                'span',
	                { style: { borderLeft: '4px solid #8b06b9', paddingLeft: '5px', paddingRight: '5px' } },
	                'Current  ',
	                (0, _core.jsx)(
	                    'b',
	                    null,
	                    _twd.format.ytw3(b['current'])
	                )
	            ),
	            (0, _core.jsx)(
	                'span',
	                { style: { borderLeft: '4px solid #ef6f06', paddingLeft: '5px', paddingRight: '5px' } },
	                '1M Ago ',
	                (0, _core.jsx)(
	                    'b',
	                    null,
	                    _twd.format.ytw3(b['1mo'])
	                )
	            )
	        ),
	        (0, _core.jsx)(
	            'span',
	            { style: { borderLeft: '4px solid #1192e9', paddingLeft: '5px', paddingRight: '5px' } },
	            '6M Ago ',
	            (0, _core.jsx)(
	                'b',
	                null,
	                _twd.format.ytw3(b['6mo'])
	            )
	        ),
	        (0, _core.jsx)(
	            'span',
	            { style: { borderLeft: '4px solid #00a3a0', paddingLeft: '5px', paddingRight: '5px' } },
	            '1Y Ago ',
	            (0, _core.jsx)(
	                'b',
	                null,
	                _twd.format.ytw3(b['1yr'])
	            )
	        )
	    );
	};
	
	var formatTooltipTitle = function formatTooltipTitle(chartData, i) {
	    var n = chartData[i].name;
	    return parseInt(n, 10) + ' ' + (n.endsWith('M') ? 'Month' : 'Year') + ' Note';
	};
	
	var TooltipCursor = function TooltipCursor(_ref6) {
	    var stroke = _ref6.stroke,
	        width = _ref6.width,
	        height = _ref6.height,
	        x = _ref6.x,
	        y = _ref6.y,
	        top = _ref6.top;
	
	
	    if (!x) return null;
	
	    var args = {
	        x: x, y: y, stroke: stroke, width: width, height: height,
	        className: 'recharts-cross recharts-tooltip-cursor',
	        pointerEvents: 'none',
	        strokeDasharray: '5',
	        d: 'M' + x + ',' + top + 'v' + height
	    };
	    return (0, _core.jsx)('path', args);
	};

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.displayInline = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' { display: inline; }\n'], ['\n    ', ' { display: inline; }\n']);
	
	var _core = __webpack_require__(9);
	
	var _twd = __webpack_require__(2);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable no-use-before-define */
	
	
	var displayInline = exports.displayInline = (0, _core.css)(_templateObject, _twd.mediaQueries.notXs);

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Table = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useChart2 = __webpack_require__(480);
	
	var _useChart3 = _interopRequireDefault(_useChart2);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var formatName = function formatName(n) {
	    return parseInt(n, 10) + ' ' + (n.endsWith('M') ? 'Month' : 'Year') + ' Note';
	}; /* eslint-disable no-use-before-define */
	var Table = exports.Table = function Table() {
	    var _useChart = (0, _useChart3.default)(),
	        chartData = _useChart.chartData,
	        chartDataStatus = _useChart.chartDataStatus;
	
	    if (chartDataStatus !== _twd.Status.LOADED) return null;
	
	    return _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	            'caption',
	            null,
	            'U.S. Yield Curve'
	        ),
	        _react2.default.createElement(
	            'tbody',
	            null,
	            chartData.map(function (a, i) {
	                return _react2.default.createElement(
	                    'tr',
	                    { key: i },
	                    _react2.default.createElement(
	                        'td',
	                        null,
	                        formatName(a['name']),
	                        'Current ',
	                        a.current !== null ? a.current + '%' : 'Empty',
	                        '1 Month Ago ',
	                        a['1mo'] !== null ? a['1mo'] + '%' : 'Empty',
	                        '6 Months Ago ',
	                        a['6mo'] !== null ? a['6mo'] + '%' : 'Empty',
	                        '1 Year Ago ',
	                        a['1yr'] !== null ? a['1yr'] + '%' : 'Empty'
	                    )
	                );
	            })
	        )
	    );
	};

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toQueryString = exports.ajax = exports.initTwdToken = exports.refreshTwdToken = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	var AbortController = window.AbortController;
	
	var TWDTOKEN = null;
	var tokenRefreshInterval;
	
	var refreshTwdToken = exports.refreshTwdToken = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var u, r, token;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        u = '/esb/generic/masterConfig/refreshToken?firstLoad=true&_dc=' + new Date().valueOf();
	                        _context.next = 3;
	                        return fetch(u, {
	                            method: 'GET',
	                            headers: {
	                                SESSIONID: (0, _twd.getSessionId)()
	                            }
	                        });
	
	                    case 3:
	                        r = _context.sent;
	                        token = 'CSRFTOKENERR';
	
	                        if (r.status === 200) {
	                            token = r.headers.get('TWDTOKEN') || token;
	                            if (token === 'CSRFDISABLE' && tokenRefreshInterval) {
	                                clearInterval(tokenRefreshInterval);
	                            }
	                        }
	                        TWDTOKEN = token;
	
	                    case 7:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function refreshTwdToken() {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var initTwdToken = exports.initTwdToken = function () {
	    var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	            while (1) {
	                switch (_context2.prev = _context2.next) {
	                    case 0:
	                        _context2.next = 2;
	                        return refreshTwdToken();
	
	                    case 2:
	                        tokenRefreshInterval = setInterval(function () {
	                            refreshTwdToken();
	                        }, 30000);
	
	                    case 3:
	                    case 'end':
	                        return _context2.stop();
	                }
	            }
	        }, _callee2, undefined);
	    }));
	
	    return function initTwdToken() {
	        return _ref2.apply(this, arguments);
	    };
	}();
	
	var ajax = exports.ajax = function ajax() {
	    var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var url = cfg.method === 'GET' ? toGetURL(cfg) : cfg.url;
	
	    var sid = (0, _twd.getSessionId)();
	
	    var p = Object.assign({
	        method: 'POST',
	        headers: Object.assign({
	            BRAND: (0, _twd.getBrand)(),
	            SESSIONID: sid,
	            BD_REQUEST_ID: sid + '.' + new Date().getTime(),
	            'Content-Type': 'application/json',
	            'Accept': '*/*',
	            'Cookie': document.cookie + ''
	        }, TWDTOKEN && { TWDTOKEN: TWDTOKEN }, cfg.headers_ || {})
	    }, cfg);
	
	    if (p.method === 'POST' && !('body' in p) && 'params' in p) {
	        var params = Array.isArray(p.params) ? p.params : (0, _twd.isObject)(p.params) && Object.keys(p.params).length > 0 ? Object.fromEntries(Array.from(Object.entries(p.params)).filter(function (_ref3) {
	            var _ref4 = _slicedToArray(_ref3, 2),
	                _ = _ref4[0],
	                v = _ref4[1];
	
	            return !(v instanceof HTMLElement);
	        })) : p.params;
	        p.body = JSON.stringify(params);
	    }
	
	    var timedOut = false;
	    var _abort = new AbortController();
	    p.signal = _abort.signal;
	    if (p.timeout) {
	        setTimeout(function () {
	            timedOut = true;
	            _abort.abort();
	        }, p.timeout);
	    }
	
	    var data = fetch(url, p).then(function (r) {
	        if (r.status === 401 && r.url.indexOf('bonddesk.com') >= 0) {
	            (0, _twd.show)('401');
	            return;
	        }
	
	        if (cfg.ignoreResponse) return;
	
	        return r;
	    }).then(function (r) {
	        return r && (cfg.type === 'text' ? r.text() : r.json());
	    });
	
	    return {
	        data: data,
	        abort: function abort() {
	            _abort.abort();
	        },
	        isTimedOut: function isTimedOut() {
	            return timedOut;
	        }
	    };
	};
	
	var toGetURL = function toGetURL(_ref5) {
	    var url = _ref5.url,
	        _ref5$isDc = _ref5.isDc,
	        isDc = _ref5$isDc === undefined ? true : _ref5$isDc,
	        _ref5$params = _ref5.params,
	        params = _ref5$params === undefined ? {} : _ref5$params;
	
	    var urls = url.split('?');
	    var a = new URLSearchParams(urls[1] || '');
	    var i = isDc ? { _dc: Date.now() } : {};
	    var p = Object.assign(i, Object.fromEntries(a), params);
	    var q = toQueryString(p);
	    return urls[0] + '?' + q;
	};
	
	var toQueryString = exports.toQueryString = function toQueryString() {
	    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return Object.keys(p).map(function (k) {
	        return encodeURIComponent(k) + '=' + encodeURIComponent(p[k]);
	    }).join('&');
	};

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.processAtmosphereMessage = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* eslint-disable no-use-before-define */
	
	
	var _twd = __webpack_require__(2);
	
	var _getConfig = __webpack_require__(485);
	
	var _processors = __webpack_require__(1156);
	
	var _parse = __webpack_require__(332);
	
	exports.default = function (cfg) {
	    var eventCodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['user.logout'];
	
	
	    var url = cfg.notifier_url;
	    if (!url) return;
	
	    var sid = (0, _getConfig.getSessionId)();
	    if (!sid) return;
	
	    var subscriptions = eventCodes.map(function (e) {
	        return sid + '.' + e;
	    }).join();
	    subscribeToAtmosphere(cfg.notifier_url, subscriptions);
	
	    // let brand = getBrand()
	    // setInterval(() => {
	    //     ajax({
	    //         url: cfg.bw_service_host + '/' + brand + '/servlet/rtresult/longpoll.htm',
	    //         method:'POST',
	    //         body: JSON.stringify({ brand, sessionid:sid }),
	    //         ignoreResponse: true
	    //     })
	    // }, 120000)
	};
	
	var subscribeToAtmosphere = function subscribeToAtmosphere(url, subscriptions) {
	    if (!url) return;
	
	    var req = Object.assign(new global.atmosphere.AtmosphereRequest(), {
	        url: url,
	        contentType: 'application/json',
	        logLevel: 'error',
	        withCredentials: true,
	        transport: 'websocket',
	        trackMessagelength: true,
	        reconnectInterval: 180000,
	        fallbackTransport: 'long-polling',
	
	        headers: {
	            brand: (0, _getConfig.getBrand)(),
	            environment: (0, _getConfig.getEnvironment)(),
	            user: (0, _getConfig.getUserId)()
	        },
	
	        onOpen: function onOpen(r) {
	            r = r || {};
	            if (r.status !== 200) return;
	            socket.push({ data: subscriptions });
	        },
	        onReopen: function onReopen(r) {
	            socket.push({ data: subscriptions });
	        },
	
	        onError: function onError(r) {},
	        onMessage: function onMessage(r) {
	            r = r || {};
	            if (r.status !== 200) return;
	
	            (0, _parse.parseStringBlocks)(r.responseBody).forEach(function (a) {
	                try {
	                    var msg = (typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object' ? a : (0, _parse.parseJson)(a);
	                    if (!msg) return;
	
	                    if (msg.value === 'READY' && msg.tag === 'READY') {
	                        socket.push({ data: subscriptions });
	                        return;
	                    }
	
	                    processAtmosphereMessage(msg);
	                } catch (x) {}
	            });
	        },
	
	        onReconnect: function onReconnect() {
	            (0, _twd.publish)('atmosphere_reconnected', { ts: Date.now() });
	        },
	        onTransportFailure: function onTransportFailure(err, req) {
	            req.fallbackTransport = 'long-polling';
	        }
	    });
	
	    var socket = global.atmosphere.subscribe(req);
	    return socket;
	};
	
	var processAtmosphereMessage = exports.processAtmosphereMessage = function processAtmosphereMessage(_ref) {
	    var tag = _ref.tag,
	        key = _ref.key,
	        value = _ref.value;
	
	    if (!key && tag) {
	        key = 'Order';
	    }
	
	    if (!key) return;
	
	    var p = _processors.processors[key];
	    if (!p) return;
	
	    var v = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? value : JSON.parse(value);
	    p(v);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.processors = undefined;
	
	var _twd = __webpack_require__(2);
	
	var processors = exports.processors = {};
	
	processors.YieldBucket = function (_ref) {
	    var yieldTypeMap = _ref.yieldTypeMap;
	
	
	    if (!yieldTypeMap) return;
	
	    Object.values(yieldTypeMap).forEach(function (a) {
	        (0, _twd.publish)('yield_bucket', {
	            id: a.bucketId,
	            value: a.averageYield
	        });
	    });
	};
	
	processors.Order = function (value) {
	    (0, _twd.publish)('order_status', value);
	};

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.viewBack = exports.trackView = exports.setOrigin = exports.Views = exports.setLastLoc = exports.setBackFrom = exports.backFrom = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define,no-mixed-operators */
	
	
	var _all = __webpack_require__(64);
	
	var _url = __webpack_require__(488);
	
	var _util = __webpack_require__(489);
	
	var backFromArgs = {
	    '-': { args: 'overview' }
	};
	
	var backFrom = exports.backFrom = function backFrom(from) {
	    var loc = from || '-';
	
	    if (loc && (0, _util.isObject)(loc) && loc.url) {
	        try {
	            var _a = new URL(loc.url);
	            var isEtrade = _a.host.indexOf('etrade.com') >= 0;
	            var isHome = _a.host.indexOf('bonddesk.com') >= 0 && _a.pathname.indexOf('pkg_static.home') >= 0 && _a.search.indexOf('pkg_welcome.output') >= 0;
	
	            if (isEtrade || isHome) {
	                location.href = loc.url;
	                return true;
	            }
	        } catch (x) {}
	
	        (0, _all.show)('tools', { view: 'tools.load-url', url: loc.url });
	        return true;
	    }
	
	    loc = loc === 'bond-order' ? 'tools.bond-order' : loc;
	    var a = backFromArgs[loc] || backFromArgs['-'];
	    if (loc !== '-') {
	        delete backFromArgs[loc];
	    }
	
	    setTimeout(function () {
	        var args = a.args || {};
	        var loc = args.view || 'overview';
	        if (!backFromHash(loc)) {
	            (0, _all.show)(loc, Object.assign({ backFrom: true }, args));
	        }
	    }, 1);
	    return true;
	};
	
	var setBackFrom = exports.setBackFrom = function setBackFrom(loc, args) {
	    backFromArgs[loc] = {
	        ts: Date.now(),
	        args: (0, _util.isString)(args) ? { view: args } : args
	    };
	};
	
	var setLastLoc = exports.setLastLoc = function setLastLoc(loc) {
	    var args = (0, _util.isString)(loc) ? { view: loc } : loc;
	    backFromArgs['-'] = { args: args };
	};
	
	var Views = exports.Views = {
	    history: [],
	    index: 0,
	    map: {
	        'search-results': 'offerings',
	        'tools.bond-portfolio-report': 'portfolio-report'
	    },
	    enabled: true,
	    origin: ''
	};
	
	var setOrigin = exports.setOrigin = function setOrigin(href) {
	    Views.origin = (0, _util.coalesce)(href, (0, _url.fixURL)('https://us.etrade.com/etx/hw/v2/accountshome?cnt=header_logon_startin_accounts').toString());
	    return Views.origin;
	};
	
	setOrigin((0, _url.safeURL)(global.location.href).searchParams.get('from'));
	
	var trackView = exports.trackView = function trackView(view, args) {
	    if (!Views.enabled) return;
	
	    view = args && args.view || view;
	    view = view === 'bond-detail' ? 'bond-detail.' + args.cusip : view;
	
	    var hs = Views.history;
	    if (hs.length === 50) {
	        hs.splice(1, 1);
	        Views.index = Math.max(Views.index - 1, 0);
	    }
	
	    var cur = hs[Views.index];
	    if (cur && cur[0] === view) {
	        cur[1] = args;
	        return;
	    }
	
	    var i = ++Views.index;
	    hs[i] = [view, args || {}];
	    hs.length = i + 1;
	};
	
	var isEq = function isEq(p, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        view = _ref2[0],
	        args = _ref2[1];
	
	    return p && (p === view || p === args.view);
	};
	
	var view = function view(_ref3) {
	    var _ref4 = _slicedToArray(_ref3, 2),
	        view = _ref4[0],
	        args = _ref4[1];
	
	    Views.viewing = true;
	    setTimeout(function () {
	        delete Views.viewing;
	    });
	
	    Views.enabled = false;
	    setTimeout(function () {
	        Views.enabled = true;
	    }, 200);
	    (0, _all.show)(view, Object.assign({ backFrom: true }, args));
	};
	
	var viewBack = exports.viewBack = function viewBack() {
	    if (!Views.enabled) return;
	
	    var prev = Views.history[Views.index - 1];
	    if (!prev) return;
	    Views.index--;
	    view(prev);
	};
	
	var backFromHash = function backFromHash(hash) {
	    hash = hash[0] === '#' ? hash.slice(1) : hash;
	    var cur = Views.map[hash] || hash;
	    var prev = Views.history[Views.index - 1];
	    if (prev && isEq(cur, prev)) {
	        Views.index--;
	        view(prev);
	        return true;
	    }
	};
	
	global.onhashchange = function (event) {
	    if (!Views.enabled) return;
	
	    var hash = new URL(event.newURL).hash.slice(1);
	    var cur = Views.map[hash] || hash;
	
	    var prev = Views.history[Views.index - 1];
	    if (prev && isEq(cur, prev)) {
	        Views.index--;
	        view(prev);
	        return;
	    }
	
	    var next = Views.history[Views.index + 1];
	    if (next && isEq(cur, next)) {
	        Views.index++;
	        view(next);
	        return;
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1158 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var compareString = exports.compareString = function compareString(a, b) {
	    if (a < b) return -1;
	    if (b > a) return 1;
	    return 0;
	};

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Dash = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: absolute;\n    width: 100%;\n    text-align: center;\n    pointer-events: none;\n    ', ' {\n        bottom: ', 'px\n    }\n    ', ' {\n        bottom: ', 'px\n    }\n'], ['\n    position: absolute;\n    width: 100%;\n    text-align: center;\n    pointer-events: none;\n    ', ' {\n        bottom: ', 'px\n    }\n    ', ' {\n        bottom: ', 'px\n    }\n']);
	
	var _core = __webpack_require__(9);
	
	var _mediaQueries = __webpack_require__(162);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	
	var Dash = exports.Dash = function Dash(_ref) {
	    var _ref$margin = _ref.margin,
	        margin = _ref$margin === undefined ? 15 : _ref$margin;
	
	    return (0, _core.jsx)(
	        'div',
	        { css: dashCss(margin) },
	        '-'
	    );
	};
	
	var dashCss = function dashCss() {
	    var margin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;
	    return (0, _core.css)(_templateObject, _mediaQueries.mediaQueries.notXs, margin, _mediaQueries.mediaQueries.xs, margin + 5);
	};

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Disclosures = exports.disclosures = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _all = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var disclosures = exports.disclosures = function disclosures(arg) {
	    var p = Object.assign({ view: 'disclosures' }, (0, _all.isString)(arg) ? { html: arg } : arg);
	    (0, _all.showModal)(p);
	};
	
	var Disclosures = exports.Disclosures = function Disclosures() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$label = _ref.label,
	        label = _ref$label === undefined ? 'Disclosures' : _ref$label,
	        _ref$html = _ref.html,
	        html = _ref$html === undefined ? '' : _ref$html,
	        _ref$dataModule = _ref.dataModule,
	        dataModule = _ref$dataModule === undefined ? '' : _ref$dataModule,
	        _ref$dataCategory = _ref.dataCategory,
	        dataCategory = _ref$dataCategory === undefined ? '' : _ref$dataCategory,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-disclosures-link' : _ref$dataName,
	        _ref$modalClass = _ref.modalClass,
	        modalClass = _ref$modalClass === undefined ? 'modal-dialog modal-md' : _ref$modalClass,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? 'Important Disclosures' : _ref$title;
	
	    return _react2.default.createElement(
	        'button',
	        Object.assign({}, dataModule ? { 'data-module': dataModule } : {}, dataCategory ? { 'data-category': dataCategory } : {}, {
	            'data-name': dataName,
	            className: 'btn-link',
	            style: { cursor: 'pointer' },
	            onClick: function onClick(e) {
	                return disclosures({ html: html, modalClass: modalClass, title: title, source: e.target });
	            }
	        }),
	        label ? label : _react2.default.createElement(
	            'i',
	            { style: { marginLeft: '5px' },
	                className: 'text-muted material-icons',
	                'aria-hidden': 'true' },
	            'info_outline'
	        )
	    );
	};

/***/ },
/* 1161 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var domAttrSet = exports.domAttrSet = function domAttrSet(dom, attrs) {
	    for (var a in attrs) {
	        var v = attrs[a];
	        if (v === undefined) {
	            dom.removeAttribute(a);
	        } else {
	            dom.setAttribute(a, v);
	        }
	    }
	};

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-fields-checkbox-label' : _ref$dataName,
	        value = _ref.value,
	        checked = _ref.checked,
	        label = _ref.label,
	        checkboxStyle = _ref.checkboxStyle,
	        _ref$showCheckbox = _ref.showCheckbox,
	        showCheckbox = _ref$showCheckbox === undefined ? true : _ref$showCheckbox,
	        labelStyle = _ref.labelStyle,
	        _ref$onChange = _ref.onChange,
	        onChange = _ref$onChange === undefined ? function () {} : _ref$onChange,
	        props = _objectWithoutProperties(_ref, ['dataName', 'value', 'checked', 'label', 'checkboxStyle', 'showCheckbox', 'labelStyle', 'onChange']);
	
	    var id = (0, _twd.getId)();
	
	    if (!showCheckbox) {
	        return _react2.default.createElement(
	            'div',
	            props,
	            label
	        );
	    }
	
	    return _react2.default.createElement(
	        'span',
	        {
	            className: 'checkbox',
	            role: 'option',
	            style: Object.assign({
	                display: 'inline',
	                paddingTop: '1px'
	            }, checkboxStyle) },
	        _react2.default.createElement('input', Object.assign({
	            'data-name': dataName + '-checkbox',
	            id: id,
	            type: 'checkbox',
	            value: value,
	            'aria-label': label
	        }, typeof checked === 'boolean' && { checked: checked, 'aria-selected': checked }, {
	            onChange: onChange })),
	        _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: Object.assign({
	                    whiteSpace: 'normal',
	                    verticalAlign: 'text-top'
	                }, labelStyle) },
	            _react2.default.createElement(
	                'div',
	                props,
	                label
	            )
	        )
	    );
	};

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = _ref.field,
	        form = _ref.form,
	        label = _ref.label,
	        info = _ref.info,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'label', 'info']);
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'checkbox' },
	        _react2.default.createElement('input', Object.assign({
	            id: id,
	            type: 'checkbox',
	            checked: field.value || false
	        }, field, props)),
	        _react2.default.createElement(
	            'label',
	            { htmlFor: id },
	            label
	        ),
	        '\xA0 ',
	        info && _react2.default.createElement(_twd.Flyout, { html: info })
	    );
	};

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = _react2.default.forwardRef(function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var ref = arguments[1];
	
	    var _ref$value = _ref.value,
	        value = _ref$value === undefined ? '' : _ref$value,
	        props = _objectWithoutProperties(_ref, ['value']);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'form-icon-group icon-left' },
	        _react2.default.createElement(
	            'i',
	            { className: 'material-icons', 'aria-hidden': 'true' },
	            'event'
	        ),
	        _react2.default.createElement('input', { type: 'text', className: 'form-control',
	            ref: ref,
	            value: value,
	            onChange: function onChange() {},
	            onClick: function onClick(e) {
	                _onClick(e, props);
	            }
	        })
	    );
	});
	
	
	var _onClick = function _onClick(e, _ref2) {
	    var onChange = _ref2.onChange,
	        props = _objectWithoutProperties(_ref2, ['onChange']);
	
	    var el = (0, _twd.$)(e.target);
	    if (el.data('datepicker')) return;
	    e.preventDefault();
	
	    el.datepicker(Object.assign({ autoclose: true }, props));
	
	    if (onChange) {
	        el.on('changeDate', function () {
	            var a = el.datepicker('getFormattedDate');
	            onChange({ target: { value: a } });
	        });
	    }
	
	    el.datepicker('show');
	};

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Fields = undefined;
	
	var _selectButton = __webpack_require__(1175);
	
	var _selectButton2 = _interopRequireDefault(_selectButton);
	
	var _checkbox = __webpack_require__(1163);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _checkboxLabel = __webpack_require__(1162);
	
	var _checkboxLabel2 = _interopRequireDefault(_checkboxLabel);
	
	var _date = __webpack_require__(1164);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _label = __webpack_require__(1166);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _labels = __webpack_require__(1167);
	
	var _labels2 = _interopRequireDefault(_labels);
	
	var _maturityDate = __webpack_require__(1168);
	
	var _maturityDate2 = _interopRequireDefault(_maturityDate);
	
	var _number = __webpack_require__(1169);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _price = __webpack_require__(1170);
	
	var _price2 = _interopRequireDefault(_price);
	
	var _quantity = __webpack_require__(1171);
	
	var _quantity2 = _interopRequireDefault(_quantity);
	
	var _radio = __webpack_require__(1172);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _ratings = __webpack_require__(197);
	
	var _ratings2 = _interopRequireDefault(_ratings);
	
	var _search = __webpack_require__(1174);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _searchCusip = __webpack_require__(1173);
	
	var _searchCusip2 = _interopRequireDefault(_searchCusip);
	
	var _select = __webpack_require__(1177);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _selectMulti = __webpack_require__(1176);
	
	var _selectMulti2 = _interopRequireDefault(_selectMulti);
	
	var _text = __webpack_require__(1178);
	
	var _text2 = _interopRequireDefault(_text);
	
	var _yield = __webpack_require__(1179);
	
	var _yield2 = _interopRequireDefault(_yield);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fields = exports.Fields = {
	    Checkbox: _checkbox2.default,
	    CheckboxLabel: _checkboxLabel2.default,
	    Date: _date2.default,
	    Label: _label2.default,
	    Labels: _labels2.default,
	    Maturity: _maturityDate2.default,
	    Number: _number2.default,
	    Price: _price2.default,
	    Quantity: _quantity2.default,
	    Radio: _radio2.default,
	    Rating: _ratings2.default,
	    SelectButton: _selectButton2.default,
	    Search: _search2.default,
	    SearchOption: _search.SearchOption,
	    SearchCusip: _searchCusip2.default,
	    Select: _select2.default,
	    SelectMulti: _selectMulti2.default,
	    Text: _text2.default,
	    Yield: _yield2.default
	};

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    ', ' { text-align: right }\n'], ['\n    ', ' { text-align: right }\n']);
	
	var _react = __webpack_require__(1);
	
	var _core = __webpack_require__(9);
	
	var _flyout = __webpack_require__(482);
	
	var _mediaQueries = __webpack_require__(162);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /** @jsx jsx */
	/* eslint-disable no-use-before-define */
	
	exports.default = function (_ref) {
	    var label = _ref.label,
	        align = _ref.align,
	        info = _ref.info,
	        htmlFor = _ref.htmlFor;
	    return (0, _core.jsx)(
	        _react.Fragment,
	        null,
	        (0, _core.jsx)('div', { className: 'vertical-offset-xxs' }),
	        !info && (0, _core.jsx)(
	            'h5',
	            {
	                style: { display: 'inline' },
	                htmlFor: htmlFor,
	                css: [align === 'right' && textAlignRight]
	            },
	            label
	        ),
	        info && (0, _core.jsx)(_flyout.Flyout, {
	            label: label,
	            html: info,
	            className: 'btn-label btn-flyout tiny-header',
	            labelAttrs: {
	                htmlFor: htmlFor,
	                css: [align === 'right' && textAlignRight]
	            } })
	    );
	};
	
	var textAlignRight = (0, _core.css)(_templateObject, _mediaQueries.mediaQueries.notXs);

/***/ },
/* 1167 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var labels = {};
	labels.Securities = "\n    Fixed income securities are a type of debt instrument\n    which typically offers an investor regular (fixed) interest payments,\n    and the return of their principal upon maturity.\n    Select the type of bond you want to search for.\n";
	
	labels.Issuer = "\n    Enter a full name to search for offerings by issuer.\n";
	
	labels.Cusip = "\n    To search for offerings by CUSIP, enter a full or partial (5 character minimum)\n    CUSIP number.  For example, entering \"36966\" will return all offerings with a CUSIP\n    beginning with 36966.  To conduct a multi-CUSIP search, enter full CUSIP numbers\n    separated by commas.\n";
	
	labels.CorpSector = "\n    Search results will only show offerings within the selected sector(s).\n";
	
	labels.CorpFeatures = "\n    Convertible bonds give the bondholder the option to convert their bonds to\n    a predetermined number of shares in the issuing company's common stock.\n";
	
	labels.CorpDebtRanks = "\n    Debt ranking is the order repayment is made to bondholders in the event\n    of a company's bankruptcy or liquidation. Secured/Senior bonds rank highest\n    in safety and repayment order over subordinated/junior debt.\n";
	
	labels.CorpMarketTypes = "\n    Fixed income securities are initially created and sold to investors on\n    the new issue (primary) market.  The secondary market is where investors buy\n    and sell securities that have been previously owned by other investors.\n    Select whether you want to search for new issue or secondary market bonds.\n";
	
	labels.CorpSymbol = "\n    View debt offerings from publicly traded companies via ticker symbol search.\n";
	
	labels.MuniStates = "\n    Search results will only show offerings within the selected state(s).\n";
	
	labels.MuniCategories = "\n    Municipal bonds are typically classified into two main categories:\n    <ol>\n    <li>General Obligation: bonds are secured by the taxing authority of the issuing state or municipality </li>\n    <li>Revenue: bonds are backed by the income generated by the public project the bond is funding </li>\n    </ol>\n";
	
	labels.MuniTaxTreatments = "\n    Select any special tax considerations for your municipal bond search.\n    Tax-exempt bonds do not tax the interest earned on bonds purchased by residents\n    of the issuing state and may also be exempt from local taxes.\n    Taxable bonds are subject to state and local taxes.\n";
	
	labels.MuniPurposes = "\n    The general purpose or project category the issuer is financing\n";
	
	labels.MuniEnvironmentals = "\n    Municipal bonds which allocate proceeds to fund environmentally-sustainable\n    projects. Make a selection to view results within the chosen environmental category.\n";
	
	labels.MuniDeminimis = "\n    The De Minimis rule states that Capital Gains Tax must be paid on a bond Purchased at a discount \n    of the Face Value in excess of a quarter point per year between the time of Acquisition and Maturity. \n    If the Acquisition Price is above the De Minimis Threshold, then the bondholder will be entitled to\n    preferential Tax treatment on the Appreciation to Par. \n    If the Acquisition Price is below the De Minimis Threshold, then all Appreciation to Par is subject \n    to ordinary tax rates. \n    The tax treatment to existing client holdings is determined by the Acquisition Price and will not change\n    during the life of the bond if held to Maturity. However, as Market Prices change, the different tax treatment \n    to a new owner may materially impact the Market Price and/or Marketability of the bond if a sale is anticipated.\n";
	
	labels.MuniInsured = "\n    Insured municipal bonds provide investors with additional security that the bond's\n    interest and principal payments will be made in the event of an issuer default.\n    To search for Insured bonds, click the checkbox.\n";
	
	labels.CdBlueSky = "\n    This filter ensures your search results do not contain any brokered CD offers which have\n    Blue Sky restrictions in your state of residence.\n";
	
	labels.BlueSkyRestriction = "\n    What are Blue Sky restrictions? Individual states have a set of securities laws,\n    commonly referred to as Blue Sky Laws, which govern the sale of securities in their state.\n    These laws, which vary by state, are established to protect investors from securities fraud.\n    CD offerings from issuing banks that do not comply with a state's Blue Sky Laws\n    are restricted from sale to residents of that state.\n";
	
	labels.CdFdic = "\n    Search results will only display offerings from the banking institution aligned\n    the FDIC certificate number input.\n";
	
	labels.TreasuryTypes = "\n    Search results will only display offerings from the selected treasury type(s).\n    T-Bills feature shorter-term maturities ranging from 4-52 weeks.\n    T-Notes feature medium-term maturities ranging from 2-10 years.\n    T-Bonds feature longer-term maturities of 10 years or greater.\n";
	
	labels.AgencyTypes = "\n    Search results will only display offerings from the selected issuer(s).\n";
	
	labels.MarketType = "\n    Fixed income securities are initially created and sold to investors\n    on the new issue (primary) market.\n    The secondary market is where investors buy and sell securities\n    that have been previously owned by other investors.\n    Select whether you want to search for new issue or secondary market bonds.\n";
	
	labels.Maturity = "\n    Maturity date is the date the principal amount of\n    a security becomes due and payable to the investor.\n    Select your preferred maturity date range using the following criteria:\n    <ul>\n    <li>Days: Enter the number of days in the future, followed by \"d\" (e.g., \"365d\" for one year)</li>\n    <li>Months: Enter the number of months in the future, followed by \"m\" (e.g., \"24m\" for two years)</li>\n    <li>Years: Enter the number of years in the future, followed by \"y\" (e.g., \"3y\" for 3 years)</li>\n    <li>The following formats are also acceptable: \"mm/yy\" or \"mm/yyyy\" (e.g., January 2028 could be entered as \"01/28\")</li>\n    </ul>\n";
	
	labels.Yield = "\n    The yield-to-worst metric is used to evaluate\n    the lowest (worst-case scenario) yield an investor could experience\n    &mdash; with the assumption the issuer does not default.\n    Select your range for yield-to-worst.\n";
	
	labels.YieldToMaturity = "\n    Yield to maturity represents the annualized rate of return for\n    the bond if held to the maturity date.\n";
	
	labels.Coupon = "\n    A bond\u2019s coupon is its annual interest rate, which is expressed as a percentage\n    of the bond\u2019s face value. For example: a $1,000 bond with a 5% coupon would\n    pay $50 a year, typically in semi-annual payments.\n";
	
	labels.CouponFrequencies = "\n    Refine your results to bonds with specific coupon payment frequencies.\n";
	
	labels.CouponPayMonths = "\n    Select the month(s) you wish to receive your coupon payments.\n";
	
	labels.CouponFeatures = "\n    Most bonds feature predetermined fixed-rate coupons that remain static over\n    the life of the bond.  Alternatively, some bonds have variable or floating rate structures\n    linked to a reference benchmark rate which adjusts over the life of the bond \u2013 or even a step-up\n    coupon structure which can feature increasing rates as the bond nears maturity.\n    Lastly, we have zero-coupon bonds which do not pay interest over the life of the bond,\n    but instead are issued at a discount and pay full face value upon maturity.\n";
	
	labels.Rating = "\n    Credit ratings are designations provided by ratings agencies (like Moody's and S&P)\n    to help investors assess the relative credit quality of individual bonds.\n    A rating of BBB- or higher by S&P or Baa3 or higher by Moody's is considered investment-grade.\n    Ratings below that tier are considered speculative (high-yield).\n    Select the minimum and/or maximum credit rating for your bond search.\n    By default, searches will return results that match the selections made in either the Moody\u2019s or S&P credit ratings dropdowns.\n    The checkbox labeled \"Results can match Moody\u2019s or S&P ratings selection\" can be unselected to only return results\n    that match the selections made in both the Moody\u2019s and S&P credit ratings dropdowns.\n";
	
	labels.Quantity = "\n    Search results will only contain offers from dealers with enough bonds\n    to meet to your requested quantity criteria.\n    Select the minimum and/or maximum number of bonds you want to trade.\n";
	
	labels.Price = "\n    Par value for bonds is typically set at 100,\n    meaning 100% of the bond\u2019s face value of $1,000.\n    As an example, entering a maximum price value of \u201C98\u201D,\n    will return bonds trading at up to 98% of their face value, or $980.\n    Select your preferred price range, expressed as a percentage of the bond\u2019s face value.\n";
	
	labels.Category = "\n    Municipal bonds are classified as either of the following:\n    <ul>\n    <li>General Obligation Bonds:  Secured by the full faith, credit, and taxing power of the issuer.</li>\n    <li>Revenue Bonds: Backed by the operational revenue from the projects financed by the bonds.</li>\n    </ul>\n    Select the type of municipal bond you would like to search for.\n";
	
	labels.TaxTreatment = "\n    Municipal bonds may be exempt from federal, state, and local taxes\n    if purchased from the state or city in which you reside.\n    However, some municipal bonds may be subject to federal income tax or AMT (Alternative Minimum Tax).\n    Select the tax considerations for your search.\n";
	
	labels.CallFeatures = "\n    A callable bond gives the issuer the right to redeem (call) the bond prior to maturity.\n";
	
	labels.PutFeatures = "\n    A puttable bond gives the bondholder the right to require the issuer redeem (repurchase)\n    the bond prior to maturity.\n";
	
	labels.OtherFeatures = "\n    Search results will display offerings aligned with the selected criteria.\n";
	
	labels.NextCall = "\n    The call date is the date which an issuer has the right to redeem (call) a bond prior to maturity.\n    The \"Next Call\" search feature allows you to refine search results for callable bonds\n    with minimum or maximum call date timeframes. For example, if you wanted to ensure the bonds in\n    your search results will not encounter a call date for the next 10 years, you could enter \"10y\"\n    within the \"Next call min\" field.\n    Select your preferred next call date range using the following criteria:\n    <ul>\n    <li>Days: Enter the number of days in the future, followed by \"d\" (e.g., \"365d\" for one year)</li>\n    <li>Months: Enter the number of months in the future, followed by \"m\" (e.g., \"24m\" for two years)</li>\n    <li>Years: Enter the number of years in the future, followed by \"y\" (e.g., \"3y\" for 3 years)</li>\n    <li>The following formats are also acceptable: \"mm/yy\" or \"mm/yyyy\" (e.g., January 2028 could be entered as \"01/28\")</li>\n    </ul>\n";
	exports.default = labels;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var field = _ref.field,
	        form = _ref.form,
	        error = _ref.error,
	        label = _ref.label,
	        labelStyle = _ref.labelStyle,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'error', 'label', 'labelStyle']);
	
	    var id = (0, _twd.getId)();
	    var err = form.errors && form.errors[field.name];
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: labelStyle },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: err || error ? ' has-error' : '' },
	            _react2.default.createElement('input', Object.assign({ type: 'text',
	                className: 'form-control vertical-offset-xxs',
	                id: id,
	                name: field.name,
	                value: field.value
	            }, field, props, err || error ? { "aria-invalid": true } : {}, {
	                onChange: function onChange(e) {
	                    form.setFieldValue(field.name, e.target.value || '');
	                }
	            })),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var field = _ref.field,
	        form = _ref.form,
	        error = _ref.error,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'error']);
	
	    var id = (0, _twd.getId)();
	
	    var err = form.errors && form.errors[field.name];
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'form-group ' + (err || error ? ' has-error' : '') },
	        _react2.default.createElement('input', Object.assign({ type: 'number',
	            className: 'form-control vertical-offset-xxs',
	            id: id,
	            name: field.name,
	            value: field.value,
	            step: '0.001'
	        }, field, props, err || error ? { "aria-invalid": true } : {}, {
	            onChange: function onChange(e) {
	                form.setFieldValue(field.name, e.target.value || '');
	            }
	        })),
	        err && _react2.default.createElement(
	            'label',
	            { className: 'field-status has-error' },
	            err
	        )
	    );
	};

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = _ref.field,
	        form = _ref.form,
	        _ref$cls = _ref.cls,
	        cls = _ref$cls === undefined ? '' : _ref$cls,
	        error = _ref.error,
	        _ref$prefix = _ref.prefix,
	        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
	        _ref$suffix = _ref.suffix,
	        suffix = _ref$suffix === undefined ? '' : _ref$suffix,
	        label = _ref.label,
	        labelStyle = _ref.labelStyle,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'cls', 'error', 'prefix', 'suffix', 'label', 'labelStyle']);
	
	    var id = (0, _twd.getId)();
	
	    var err = form.errors && form.errors[field.name];
	    var style = { padding: '0 0 0 10px' };
	    var isGroup = prefix || suffix;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: labelStyle },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: cls + (err || error ? ' has-error' : '') },
	            _react2.default.createElement(
	                'div',
	                { className: (isGroup ? 'input-group ' : '') + 'vertical-offset-xxs' },
	                isGroup && _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-addon', htmlFor: id },
	                    prefix
	                ),
	                _react2.default.createElement('input', Object.assign({ type: 'number',
	                    className: 'form-control',
	                    id: id,
	                    name: field.name,
	                    value: field.value,
	                    step: '0.01',
	                    min: '0',
	                    style: prefix ? { paddingLeft: '20px' } : style
	                }, field, props, err || error ? { "aria-invalid": true } : {}, {
	                    onChange: function onChange(e) {
	                        form.setFieldValue(field.name, e.target.value || '');
	                    }
	                })),
	                isGroup && _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-addon', htmlFor: id },
	                    suffix
	                )
	            ),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = _ref.field,
	        form = _ref.form,
	        _ref$cls = _ref.cls,
	        cls = _ref$cls === undefined ? '' : _ref$cls,
	        error = _ref.error,
	        _ref$prefix = _ref.prefix,
	        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
	        _ref$suffix = _ref.suffix,
	        suffix = _ref$suffix === undefined ? '' : _ref$suffix,
	        label = _ref.label,
	        labelStyle = _ref.labelStyle,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'cls', 'error', 'prefix', 'suffix', 'label', 'labelStyle']);
	
	    var id = (0, _twd.getId)();
	
	    var err = form.errors && form.errors[field.name];
	    var style = { padding: '0 0 0 10px' };
	    var isGroup = prefix || suffix;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: labelStyle },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: cls + (err || error ? ' has-error' : '') },
	            _react2.default.createElement(
	                'div',
	                { className: (isGroup ? 'input-group ' : '') + 'vertical-offset-xxs' },
	                isGroup && _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-addon' },
	                    prefix
	                ),
	                _react2.default.createElement('input', Object.assign({ type: 'number',
	                    className: 'form-control',
	                    id: id,
	                    name: field.name,
	                    value: field.value,
	                    step: '1',
	                    min: '0',
	                    style: prefix ? { paddingLeft: '20px' } : style
	                }, field, props, err || error ? { "aria-invalid": true } : {}, {
	                    onChange: function onChange(e) {
	                        var v = e.target.value || '';
	                        form.setFieldValue(field.name, v);
	                    }
	                })),
	                isGroup && _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-addon' },
	                    suffix
	                )
	            ),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	exports.default = function (_ref) {
	    var field = _ref.field,
	        form = _ref.form,
	        label = _ref.label,
	        value = _ref.value,
	        className = _ref.className,
	        style = _ref.style,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'label', 'value', 'className', 'style']);
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        'div',
	        { className: "radio " + (className || ''), style: style },
	        _react2.default.createElement('input', Object.assign({ type: 'radio',
	            id: id,
	            name: field.name,
	            value: value,
	            checked: field.value === value
	        }, props, {
	            onChange: field.onChange,
	            onBlur: field.onBlur
	        })),
	        _react2.default.createElement(
	            'label',
	            { htmlFor: id },
	            label
	        )
	    );
	};

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var onSelect = _ref.onSelect,
	        onClear = _ref.onClear,
	        filter = _ref.filter,
	        map = _ref.map,
	        _ref$showIcon = _ref.showIcon,
	        showIcon = _ref$showIcon === undefined ? true : _ref$showIcon,
	        id = _ref.id,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-fields-search-cusip' : _ref$dataName,
	        props = _objectWithoutProperties(_ref, ['onSelect', 'onClear', 'filter', 'map', 'showIcon', 'id', 'dataName']);
	
	    var id_ = id || (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Fields.Search,
	            Object.assign({
	                id: id_,
	                multiple: false,
	                showIcon: showIcon,
	                onSelect: onSelect,
	                onClear: onClear,
	                dataName: dataName
	            }, props),
	            function (_ref2) {
	                var keyword = _ref2.keyword;
	
	                return _react2.default.createElement(Options, { dataName: dataName + '-option', keyword: keyword, filter: filter, map: map });
	            }
	        )
	    );
	};
	
	var Options = function Options() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        keyword = _ref3.keyword,
	        filter = _ref3.filter,
	        map = _ref3.map,
	        _ref3$dataName = _ref3.dataName,
	        dataName = _ref3$dataName === undefined ? 'twd-field-search-cusip-option' : _ref3$dataName;
	
	    var _useOptions = useOptions({ keyword: keyword, filter: filter, map: map }),
	        status = _useOptions.status,
	        error = _useOptions.error,
	        searchResults = _useOptions.searchResults;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _twd.Loading,
	            { status: status, error: error, spinner: false },
	            searchResults.map(function (a, i) {
	                return _react2.default.createElement('div', { key: i,
	                    'data-name': dataName,
	                    className: 'auto-suggest-menu-item text-truncate',
	                    style: { color: "var(--primary-base-color)" },
	                    item: a,
	                    dangerouslySetInnerHTML: {
	                        __html: highlightText(a.label, keyword)
	                    } });
	            })
	        )
	    );
	};
	
	var highlightText = function highlightText(text, keyword) {
	    var s = ('' + keyword).trim();
	    return s ? text.split(s).join('<b>' + s + '</b>') : text;
	};
	
	var useOptions = function useOptions(_ref4) {
	    var keyword = _ref4.keyword,
	        filter = _ref4.filter,
	        map = _ref4.map;
	
	    var _React$useState = _react2.default.useState(_twd.Status.Loading),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(''),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        error = _React$useState4[0],
	        setError = _React$useState4[1];
	
	    var _React$useState5 = _react2.default.useState([]),
	        _React$useState6 = _slicedToArray(_React$useState5, 2),
	        searchResults = _React$useState6[0],
	        setSearchResults = _React$useState6[1];
	
	    var timerId = _react2.default.useRef();
	    var lastAbort = _react2.default.useRef();
	    var lastKeyword = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        if (timerId.current) {
	            clearTimeout(timerId.current);
	            timerId.current = 0;
	        }
	
	        var dismounted = false;
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var _ref6, data, abort, a, rs_, rs;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (keyword) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            if (!(lastKeyword.current === keyword && searchResults.length > 0)) {
	                                _context.next = 4;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 4:
	
	                            setStatus(_twd.Status.LOADING);
	                            setError('');
	                            lastKeyword.current = keyword;
	
	                            _context.prev = 7;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 11;
	                            return (0, _twd.ajax)({
	                                url: '/esb/portfolio/securitysuggestions',
	                                method: 'GET',
	                                params: {
	                                    keyword: keyword.trim(),
	                                    page: 1,
	                                    start: 0,
	                                    limit: 100
	                                }
	                            });
	
	                        case 11:
	                            _ref6 = _context.sent;
	                            data = _ref6.data;
	                            abort = _ref6.abort;
	
	
	                            lastAbort.current = abort;
	                            _context.next = 17;
	                            return data;
	
	                        case 17:
	                            a = _context.sent;
	
	                            if (!dismounted) {
	                                _context.next = 20;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 20:
	                            rs_ = (a.securities || []).filter(filter).reduce(function (x, a) {
	                                var lv = map(a);
	                                var v = lv.value;
	                                if (!(v in x)) {
	                                    x[v] = lv.label;
	                                }
	                                return x;
	                            }, {});
	                            rs = Object.keys(rs_).sort().map(function (k) {
	                                return {
	                                    label: rs_[k],
	                                    value: k
	                                };
	                            });
	
	                            if (!(rs.length === 0)) {
	                                _context.next = 24;
	                                break;
	                            }
	
	                            throw new Error('empty-result');
	
	                        case 24:
	
	                            setSearchResults(rs);
	                            setStatus(_twd.Status.LOADED);
	
	                            _context.next = 35;
	                            break;
	
	                        case 28:
	                            _context.prev = 28;
	                            _context.t0 = _context['catch'](7);
	
	                            if (!dismounted) {
	                                _context.next = 32;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 32:
	
	                            setSearchResults([]);
	                            setError('\n                    There are no results that match your search for\n                    <span class="text-bold"><u>' + keyword + '</u></span>.\n                    Please review your search criteria and try again.\n                ');
	
	                            setStatus(_twd.Status.FAILED_TO_LOAD);
	
	                        case 35:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[7, 28]]);
	        })), 500);
	
	        return function () {
	            dismounted = true;
	            if (lastAbort.current) {
	                lastAbort.current();
	                lastAbort.current = null;
	            }
	            if (timerId.current) {
	                clearTimeout(timerId.current);
	                timerId.current = 0;
	            }
	        };
	    }, [keyword]);
	
	    return { status: status, error: error, searchResults: searchResults };
	};

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SearchOption = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Modes = {
	    'NONE': 'none',
	    'SEARCH': 'search'
	};
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$multiple = _ref.multiple,
	        multiple = _ref$multiple === undefined ? true : _ref$multiple,
	        _ref$placeholder = _ref.placeholder,
	        placeholder = _ref$placeholder === undefined ? '' : _ref$placeholder,
	        onSelect = _ref.onSelect,
	        _ref$value = _ref.value,
	        value = _ref$value === undefined ? '' : _ref$value,
	        _ref$type = _ref.type,
	        type = _ref$type === undefined ? "search" : _ref$type,
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled,
	        onBlur = _ref.onBlur,
	        onFocus = _ref.onFocus,
	        onClear = _ref.onClear,
	        onChange = _ref.onChange,
	        _ref$clearOnBlur = _ref.clearOnBlur,
	        clearOnBlur = _ref$clearOnBlur === undefined ? true : _ref$clearOnBlur,
	        _ref$showIcon = _ref.showIcon,
	        showIcon = _ref$showIcon === undefined ? true : _ref$showIcon,
	        inputConfig = _ref.inputConfig,
	        listConfig = _ref.listConfig,
	        id = _ref.id,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-fields-search' : _ref$dataName,
	        children = _ref.children;
	
	    var inputRef = _react2.default.useRef();
	    var resultRef = _react2.default.useRef();
	
	    var _React$useState = _react2.default.useState(null),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        keyword = _React$useState2[0],
	        setKeyword = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(Modes.NONE),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        mode = _React$useState4[0],
	        setMode = _React$useState4[1];
	
	    var lock = false;
	    var onFocus_ = function onFocus_(e) {
	        if (onFocus) onFocus(e);
	        onChange_(e);
	    };
	
	    var onClear_ = function onClear_() {
	        lock = true;
	        var e = inputRef.current;
	        e.value = '';
	        e.placeholder = '';
	        e.focus();
	        if (onClear) onClear();
	    };
	
	    var onBlur_ = function onBlur_(e) {
	        setTimeout(function () {
	            var el = inputRef.current;
	
	            if (el && lock) {
	                lock = false;
	                el.focus();
	                return;
	            }
	
	            if (el && onBlur) {
	                var t = onBlur({
	                    keyword: keyword,
	                    inputEl: el
	                });
	                if (typeof t === "string") {
	                    el.value = t;
	                } else if (t === false) {
	                    return;
	                } else if (clearOnBlur) {
	                    el.value = '';
	                }
	            } else if (el && clearOnBlur) {
	                el.value = '';
	            }
	
	            setKeyword('');
	            setMode(Modes.NONE);
	        }, 250);
	    };
	
	    var onChange_ = function onChange_(e) {
	        var txt = inputRef.current.value;
	        setKeyword(txt);
	        setMode(Modes.SEARCH);
	        if (onChange) onChange(txt);
	    };
	
	    var select = function select(itm) {
	        if (!onSelect) return;
	        var s = onSelect(itm) || '';
	        var e = inputRef.current;
	        e.placeholder = s || placeholder;
	        e.value = s;
	        setKeyword(s);
	    };
	
	    var onKeyPress = function onKeyPress(e) {
	        var key = e.keyCode || e.key || e.which;
	
	        var isSelected = key === 13 || key === 'Enter';
	        if (!isSelected) return;
	
	        e.preventDefault();
	
	        var el = resultRef.current;
	        var a = (0, _twd.$)(el).find('.auto-suggest-menu-item.focus')[0];
	        if (a) {
	            var i = (0, _twd.getEventHandlers)(a).item;
	            if (!i) return;
	
	            if (multiple) {
	                lock = true;
	            } else {
	                e.target.blur();
	            }
	            select(i);
	            return;
	        }
	
	        var txt = e.target.value;
	        if (!txt) return;
	
	        if (multiple) {
	            lock = true;
	        } else {
	            e.target.blur();
	        }
	        select(txt);
	    };
	
	    var onKeyDown = function onKeyDown(e) {
	        if (mode !== Modes.SEARCH) return;
	
	        var key = e.keyCode || e.key || e.which;
	
	        if (key === 9 || key === 27 || key === 'Escape') {
	            onBlur_();
	            return;
	        }
	
	        if (key === 38 || key === 'ArrowUp') {
	            var el = resultRef.current;
	            var a = (0, _twd.$)(el).find('.auto-suggest-menu-item.focus').removeClass('focus').prevAll('.auto-suggest-menu-item').first().addClass('focus');
	            if (a.length > 0) return;
	
	            (0, _twd.$)(el).find('.auto-suggest-menu-item').last().addClass('focus');
	
	            return;
	        }
	
	        if (key === 40 || key === 'ArrowDown') {
	            var _el = resultRef.current;
	
	            var _a = (0, _twd.$)(_el).find('.auto-suggest-menu-item.focus').removeClass('focus').nextAll('.auto-suggest-menu-item').first().addClass('focus');
	
	            if (_a.length > 0) return;
	
	            (0, _twd.$)(_el).find('.auto-suggest-menu-item').first().addClass('focus');
	
	            return;
	        }
	    };
	
	    var onItemClick = function onItemClick(e) {
	        e.preventDefault();
	
	        var _loop = function _loop() {
	            var el = (0, _twd.$)(e.target);
	            var a = el.hasClass('auto-suggest-menu-item') && el[0] || el.parents('.auto-suggest-menu-item')[0];
	            if (!a) return 'break';
	
	            var ee = el[0];
	            if (ee && ee.nodeName === 'INPUT' && 'checked' in ee) {
	                setTimeout(function () {
	                    return a.click();
	                });
	                return {
	                    v: void 0
	                };
	            }
	
	            var i = (0, _twd.getEventHandlers)(a).item;
	            if (!i) return 'break';
	
	            select(i);
	        };
	
	        _loop2: do {
	            var _ret = _loop();
	
	            switch (_ret) {
	                case 'break':
	                    break _loop2;
	
	                default:
	                    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	            }
	        } while (false);
	
	        if (multiple) lock = true;
	    };
	
	    var isSearch = type === 'search';
	    var icon = showIcon ? isSearch ? 'search' : 'keyboard_arrow_down' : '';
	    var iconAlign = showIcon ? isSearch ? 'icon-left' : 'icon-right' : '';
	    var iconStyle = icon === 'search' ? { color: 'var(--primary-base-color)' } : {};
	    var _id = id || (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { className: 'form-icon-group ' + iconAlign, style: { overflow: "visible" } },
	            !disabled && _react2.default.createElement(
	                'i',
	                {
	                    className: 'material-icons',
	                    'aria-hidden': 'true',
	                    style: Object.assign(isSearch ? {} : { pointerEvents: 'all' }, iconStyle),
	                    onClick: function onClick(e) {
	                        if (mode === Modes.NONE) {
	                            onFocus_(e);
	                            inputRef.current.focus();
	                        } else {
	                            setTimeout(function () {
	                                return onBlur_(e);
	                            });
	                        }
	                    }
	                },
	                icon
	            ),
	            _react2.default.createElement('input', Object.assign({
	                ref: inputRef,
	                type: 'text',
	                className: 'form-control text-truncate',
	                id: _id,
	                'data-name': dataName + '-input',
	                disabled: disabled,
	                'aria-disabled': disabled,
	                onFocus: onFocus_,
	                onBlur: onBlur_,
	                onKeyPress: onKeyPress,
	                onKeyDown: onKeyDown,
	                onChange: onChange_,
	                placeholder: placeholder
	            }, inputConfig, {
	                value: mode === Modes.NONE ? value || '' : inputRef.current.value
	            })),
	            isSearch && mode !== Modes.NONE && _react2.default.createElement(
	                'button',
	                {
	                    'data-name': dataName + '-clear',
	                    type: 'button',
	                    onClick: onClear_, style: {
	                        position: 'absolute',
	                        top: 0,
	                        right: '25px',
	                        zIndex: 2,
	                        cursor: 'pointer',
	                        background: '0 0',
	                        border: 'none'
	                    } },
	                _react2.default.createElement(
	                    'i',
	                    { className: 'material-icons', 'aria-hidden': 'true', style: {
	                            pointerEvents: 'auto'
	                        } },
	                    'clear'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { 'aria-live': 'polite', ref: resultRef },
	                mode !== Modes.NONE && (!isSearch || keyword) && children && _react2.default.createElement(
	                    'div',
	                    Object.assign({
	                        'data-name': dataName + '-selections',
	                        className: 'auto-suggest-menu',
	                        style: { paddingBottom: '10px' },
	                        onFocus: function onFocus() {
	                            lock = true;
	                        },
	                        onMouseDown: function onMouseDown() {
	                            return false;
	                        }
	                    }, listConfig, {
	                        onClick: onItemClick }),
	                    children({ keyword: keyword })
	                )
	            )
	        )
	    );
	};
	
	var SearchOption = exports.SearchOption = function SearchOption() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        item = _ref2.item,
	        children = _ref2.children,
	        props = _ref2.props,
	        _ref2$dataName = _ref2.dataName,
	        dataName = _ref2$dataName === undefined ? 'twd-fields-search' : _ref2$dataName;
	
	    return _react2.default.createElement(
	        'div',
	        Object.assign({
	            'data-name': dataName + '-option',
	            className: 'auto-suggest-menu-item text-truncate',
	            style: { paddingLeft: '10px' }
	        }, props, {
	            item: item }),
	        children
	    );
	};

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$placeholder = _ref.placeholder,
	        placeholder = _ref$placeholder === undefined ? "Select" : _ref$placeholder,
	        _ref$multiple = _ref.multiple,
	        multiple = _ref$multiple === undefined ? true : _ref$multiple,
	        children = _ref.children;
	
	    var id = (0, _twd.getId)();
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'dropdown', style: { width: '100%' } },
	        _react2.default.createElement(
	            'button',
	            {
	                id: id,
	                type: 'button',
	                'data-toggle': 'dropdown',
	                className: 'dropdown-toggle form-control text-left text-muted',
	                style: {
	                    borderRadius: 0,
	                    marginBottom: '10px'
	                } },
	            _react2.default.createElement(
	                'label',
	                { className: 'label-large' },
	                placeholder
	            ),
	            _react2.default.createElement(
	                'i',
	                { className: 'material-icons', style: {
	                        position: 'absolute',
	                        fontSize: '24px',
	                        right: '5px',
	                        top: '5px'
	                    } },
	                'keyboard_arrow_down'
	            )
	        ),
	        _react2.default.createElement(
	            'ul',
	            { className: 'dropdown-menu',
	                role: 'menu',
	                'aria-labelledby': id,
	                style: {
	                    backgroundColor: '#fff',
	                    border: '1px solid #eaeaea'
	                }
	            },
	            multiple ? _react2.default.createElement(
	                'form',
	                null,
	                children
	            ) : children
	        )
	    );
	};

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var name = _ref.name,
	        form = _ref.form,
	        _ref$cls = _ref.cls,
	        cls = _ref$cls === undefined ? '' : _ref$cls,
	        error = _ref.error,
	        _ref$prefix = _ref.prefix,
	        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
	        _ref$suffix = _ref.suffix,
	        suffix = _ref$suffix === undefined ? '' : _ref$suffix,
	        _ref$options = _ref.options,
	        options = _ref$options === undefined ? [] : _ref$options,
	        _ref$emptyText = _ref.emptyText,
	        emptyText = _ref$emptyText === undefined ? 'Any' : _ref$emptyText,
	        _ref$allText = _ref.allText,
	        allText = _ref$allText === undefined ? 'All' : _ref$allText,
	        remove = _ref.remove,
	        push = _ref.push,
	        style = _ref.style,
	        label = _ref.label,
	        listConfig = _ref.listConfig,
	        inputConfig = _ref.inputConfig,
	        optionCheckboxLabelConfig = _ref.optionCheckboxLabelConfig,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-fields-select-multi' : _ref$dataName,
	        _ref$showSelectAll = _ref.showSelectAll,
	        showSelectAll = _ref$showSelectAll === undefined ? false : _ref$showSelectAll,
	        _ref$isMultiSelect = _ref.isMultiSelect,
	        isMultiSelect = _ref$isMultiSelect === undefined ? true : _ref$isMultiSelect,
	        id_ = _ref.id,
	        _ref$placeholder = _ref.placeholder,
	        placeholder = _ref$placeholder === undefined ? getPlaceHolder : _ref$placeholder,
	        onBlur = _ref.onBlur,
	        onFocus = _ref.onFocus,
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled,
	        props = _objectWithoutProperties(_ref, ['name', 'form', 'cls', 'error', 'prefix', 'suffix', 'options', 'emptyText', 'allText', 'remove', 'push', 'style', 'label', 'listConfig', 'inputConfig', 'optionCheckboxLabelConfig', 'dataName', 'showSelectAll', 'isMultiSelect', 'id', 'placeholder', 'onBlur', 'onFocus', 'disabled']);
	
	    var err = form && form.errors && form.errors[name];
	    var values = form && form.values[name] || props.values || [];
	
	    var chg = props.onSelect || function (a) {
	        var v = a.value;
	        if (showSelectAll && v === '*') {
	            var isAll = values.length > 0 && values.length === options.length;
	            if (isAll) {
	                [].concat(_toConsumableArray(values)).forEach(function (a) {
	                    return (0, _twd.arrayRemove)(values, a);
	                });
	
	                form.setFieldValue(name, values);
	            } else {
	                options.map(function (a) {
	                    return a.value;
	                }).filter(function (a) {
	                    return values.indexOf(a) < 0;
	                }).forEach(function (a) {
	                    return push(a);
	                });
	            }
	            return;
	        }
	
	        var i = values.indexOf(v);
	        if (i >= 0) {
	            (0, _twd.arrayRemove)(values, v);
	            options.filter(function (a) {
	                return a.oneOf === v;
	            }).forEach(function (a) {
	                return (0, _twd.arrayRemove)(values, a.value);
	            });
	
	            form.setFieldValue(name, values);
	        } else {
	            push(v);
	            var b = a.oneOf;
	            if (b && values.indexOf(b) < 0) {
	                push(b);
	            }
	        }
	    };
	
	    var id = id_ || (0, _twd.getId)();
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { style: { whiteSpace: 'nowrap' }, htmlFor: id },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'form-group' + (err || error ? ' has-error' : ''),
	                style: Object.assign({ whiteSpace: 'nowrap' }, style)
	            },
	            _react2.default.createElement(
	                _twd.Fields.Search,
	                {
	                    id: id,
	                    dataName: dataName,
	                    placeholder: placeholder({ values: values, options: options, emptyText: emptyText, allText: allText }),
	                    type: 'select',
	                    listConfig: listConfig,
	                    inputConfig: Object.assign({}, inputConfig, {
	                        role: 'list'
	                    }, err || error ? { "aria-invalid": true } : {}),
	                    onSelect: chg,
	                    onBlur: onBlur,
	                    onFocus: onFocus,
	                    multiple: isMultiSelect,
	                    disabled: disabled
	                },
	                function (_ref2) {
	                    var text = _ref2.keyword;
	
	                    return _react2.default.createElement(Options, {
	                        text: text,
	                        values: values,
	                        options: options,
	                        showSelectAll: showSelectAll,
	                        isMultiSelect: isMultiSelect,
	                        optionCheckboxLabelConfig: optionCheckboxLabelConfig
	                    });
	                }
	            )
	        )
	    );
	};
	
	var getPlaceHolder = function getPlaceHolder(_ref3) {
	    var emptyText = _ref3.emptyText,
	        allText = _ref3.allText,
	        values = _ref3.values,
	        options = _ref3.options;
	
	    var isNone = (0, _twd.isEmpty)(values);
	    if (isNone) return emptyText;
	
	    var isAll = values.length > 0 && values.length === options.length;
	    if (isAll) return allText;
	
	    var selected = options.filter(function (a) {
	        return values.indexOf(a.value) >= 0;
	    });
	
	    var n = selected.length;
	    if (n === 0) return emptyText;
	
	    var s = selected[0];
	    var t = s.label + (n > 1 ? ' + ' + (n - 1) + ' selected' : '');
	    return t;
	};
	
	var Options = function Options() {
	    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        text = _ref4.text,
	        values = _ref4.values,
	        options = _ref4.options,
	        optionCheckboxLabelConfig = _ref4.optionCheckboxLabelConfig,
	        _ref4$dataName = _ref4.dataName,
	        dataName = _ref4$dataName === undefined ? 'twd-fields-select-multi' : _ref4$dataName,
	        _ref4$isMultiSelect = _ref4.isMultiSelect,
	        isMultiSelect = _ref4$isMultiSelect === undefined ? true : _ref4$isMultiSelect,
	        _ref4$showSelectAll = _ref4.showSelectAll,
	        showSelectAll = _ref4$showSelectAll === undefined ? false : _ref4$showSelectAll;
	
	    var isAll = values.length === options.length;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        showSelectAll && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                _twd.Fields.SearchOption,
	                {
	                    dataName: dataName + '-option-select-all',
	                    item: { value: '*' }
	                },
	                _react2.default.createElement(_twd.Fields.CheckboxLabel, {
	                    dataName: dataName + '-option-select-all-checkbox',
	                    checkboxStyle: { marginLeft: '' },
	                    checked: isAll ? true : false,
	                    'aria-hidden': true,
	                    label: 'Select all' })
	            ),
	            _react2.default.createElement('hr', { 'aria-hidden': 'true' })
	        ),
	        getOptions({ text: text, values: values, options: options }).map(function (a, i) {
	            var checked = values.indexOf(a.value) >= 0;
	            return _react2.default.createElement(
	                _twd.Fields.SearchOption,
	                {
	                    dataName: dataName + '-option',
	                    item: a, key: i },
	                _react2.default.createElement(_twd.Fields.CheckboxLabel, Object.assign({
	                    dataName: dataName + '-option-checkbox',
	                    checkboxStyle: { marginLeft: a.oneOf ? '20px' : '' },
	                    checked: checked,
	                    'aria-hidden': true,
	                    label: a.label,
	                    showCheckbox: isMultiSelect
	                }, optionCheckboxLabelConfig))
	            );
	        })
	    );
	};
	
	var getOptions = function getOptions() {
	    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref5$text = _ref5.text,
	        text = _ref5$text === undefined ? '' : _ref5$text,
	        _ref5$values = _ref5.values,
	        values = _ref5$values === undefined ? [] : _ref5$values,
	        _ref5$options = _ref5.options,
	        options = _ref5$options === undefined ? [] : _ref5$options;
	
	    var t = text.toLowerCase();
	    return options.map(function (a) {
	        return Object.assign(Object.assign({}, a), {
	            selected: values.indexOf(a.value) >= 0
	        });
	    }).filter(function (a) {
	        return !text || a.label.toLowerCase().indexOf(t) >= 0;
	    });
	};

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = _ref.field,
	        form = _ref.form,
	        id_ = _ref.id,
	        _ref$cls = _ref.cls,
	        cls = _ref$cls === undefined ? '' : _ref$cls,
	        error = _ref.error,
	        _ref$prefix = _ref.prefix,
	        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
	        _ref$suffix = _ref.suffix,
	        suffix = _ref$suffix === undefined ? '' : _ref$suffix,
	        _ref$options = _ref.options,
	        options = _ref$options === undefined ? [] : _ref$options,
	        value = _ref.value,
	        label = _ref.label,
	        _ref$labelStyle = _ref.labelStyle,
	        labelStyle = _ref$labelStyle === undefined ? {} : _ref$labelStyle,
	        _ref$labelClass = _ref.labelClass,
	        labelClass = _ref$labelClass === undefined ? '' : _ref$labelClass,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-fields-select' : _ref$dataName,
	        _ref$optionStyle = _ref.optionStyle,
	        optionStyle = _ref$optionStyle === undefined ? {} : _ref$optionStyle,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'id', 'cls', 'error', 'prefix', 'suffix', 'options', 'value', 'label', 'labelStyle', 'labelClass', 'dataName', 'optionStyle']);
	
	    var id = id_ || (0, _twd.getId)();
	
	    var err = form && form.errors && form.errors[field.name];
	
	    var chg = props.onChange || function (e) {
	        form.setFieldValue(field.name, e.target.value || '');
	    };
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: labelStyle, className: labelClass },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'select-wrapper' + (err || error ? ' has-error' : '') },
	            _react2.default.createElement(
	                'select',
	                Object.assign({
	                    'data-name': dataName,
	                    className: 'form-control',
	                    id: id
	                }, field, props, err || error ? { "aria-invalid": true } : {}, {
	                    onChange: chg,
	                    defaultValue: value
	                }),
	                options.map(function (a) {
	                    return (0, _twd.isObject)(a) ? a : { label: a, value: a };
	                }).map(function (a, i) {
	                    return _react2.default.createElement(
	                        'option',
	                        {
	                            'data-name': dataName + '-option',
	                            key: i,
	                            hidden: !a.value,
	                            disabled: !a.value,
	                            'aria-hidden': !a.value,
	                            style: optionStyle,
	                            value: a.value },
	                        a.label
	                    );
	                })
	            ),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function (_ref) {
	    var field = _ref.field,
	        form = _ref.form,
	        error = _ref.error,
	        label = _ref.label,
	        labelStyle = _ref.labelStyle,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'error', 'label', 'labelStyle']);
	
	    var id = (0, _twd.getId)();
	
	    var err = form.errors && form.errors[field.name];
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: labelStyle },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'form-group ' + (err || error ? ' has-error' : '') },
	            _react2.default.createElement('input', Object.assign({ type: 'text',
	                className: 'form-control vertical-offset-xxs',
	                id: id,
	                name: field.name,
	                value: field.value
	            }, field, props, err || error ? { "aria-invalid": true } : {}, {
	                onChange: function onChange(e) {
	                    form.setFieldValue(field.name, e.target.value || '');
	                }
	            })),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = _ref.field,
	        form = _ref.form,
	        _ref$cls = _ref.cls,
	        cls = _ref$cls === undefined ? '' : _ref$cls,
	        error = _ref.error,
	        _ref$prefix = _ref.prefix,
	        prefix = _ref$prefix === undefined ? '' : _ref$prefix,
	        _ref$suffix = _ref.suffix,
	        suffix = _ref$suffix === undefined ? '' : _ref$suffix,
	        label = _ref.label,
	        labelStyle = _ref.labelStyle,
	        props = _objectWithoutProperties(_ref, ['field', 'form', 'cls', 'error', 'prefix', 'suffix', 'label', 'labelStyle']);
	
	    var id = (0, _twd.getId)();
	
	    var err = form.errors && form.errors[field.name];
	    var style = { padding: '0 0 0 10px' };
	    var isGroup = prefix || suffix;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        label && _react2.default.createElement(
	            'label',
	            { htmlFor: id, style: labelStyle },
	            label
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: cls + (err || error ? ' has-error' : '') },
	            _react2.default.createElement(
	                'div',
	                { className: (isGroup ? 'input-group ' : '') + 'vertical-offset-xxs' },
	                isGroup && _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-addon' },
	                    prefix
	                ),
	                _react2.default.createElement('input', Object.assign({ type: 'number',
	                    className: 'form-control',
	                    id: id,
	                    name: field.name,
	                    value: field.value,
	                    step: '0.001',
	                    style: style
	                }, field, props, err || error ? { "aria-invalid": true } : {}, {
	                    onChange: function onChange(e) {
	                        form.setFieldValue(field.name, e.target.value || '');
	                    }
	                })),
	                isGroup && _react2.default.createElement(
	                    'label',
	                    { className: 'input-group-addon' },
	                    suffix
	                )
	            ),
	            err && _react2.default.createElement(
	                'label',
	                { className: 'field-status has-error' },
	                err
	            )
	        )
	    );
	};

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	var _mediaQueries = __webpack_require__(162);
	
	var _loader = __webpack_require__(1182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	
	exports.default = function () {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        issuer = _ref.issuer,
	        _ref$className = _ref.className,
	        className = _ref$className === undefined ? "btn-label link-button text-left" : _ref$className,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? "bond-issuer-link" : _ref$dataName,
	        cusip = _ref.cusip,
	        offers = _ref.offers,
	        from = _ref.from,
	        _ref$showBackLink = _ref.showBackLink,
	        showBackLink = _ref$showBackLink === undefined ? 'Y' : _ref$showBackLink,
	        _ref$showTradeHistory = _ref.showTradeHistory,
	        showTradeHistory = _ref$showTradeHistory === undefined ? 'N' : _ref$showTradeHistory,
	        _ref$showBondDetail = _ref.showBondDetail,
	        showBondDetail = _ref$showBondDetail === undefined ? '' : _ref$showBondDetail,
	        _ref$isTreasuryAuctio = _ref.isTreasuryAuction,
	        isTreasuryAuction = _ref$isTreasuryAuctio === undefined ? false : _ref$isTreasuryAuctio;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        isTreasuryAuction && _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: "text-left" },
	                _react2.default.createElement(
	                    'span',
	                    { style: { display: 'inline' } },
	                    issuer || _twd.format.empty()
	                )
	            )
	        ),
	        !isTreasuryAuction && _react2.default.createElement(_twd.Flyout, {
	            html: _react2.default.createElement(_loader.Loader, { cusip: cusip, offers: offers, showTradeHistory: showTradeHistory, showBackLink: showBackLink, showBondDetail: showBondDetail, isTreasuryAuction: isTreasuryAuction, from: from }),
	            trigger: ["hover"],
	            isButton: false,
	            className: className,
	            dataName: dataName,
	            showIcon: false,
	            contentStyle: { maxWidth: '600px', width: 'fit-content' },
	            popperStyles: {
	                maxWidth: Math.min(_mediaQueries.mediaQueries.width() - 40, 600) + 'px'
	            },
	            label: issuer || _twd.format.empty(),
	            onClick: function onClick() {
	                (0, _twd.hideModal)();
	                (0, _twd.show)('bond-detail', { cusip: cusip, showBackLink: showBackLink, from: from });
	            }
	
	        })
	    );
	};

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getIssueData = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	var lastAjaxAbort;
	var getIssueData = exports.getIssueData = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(cusip) {
	        var _ref2, data, abort, info;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        _context.prev = 0;
	
	                        if (lastAjaxAbort) lastAjaxAbort();
	
	                        _context.next = 4;
	                        return (0, _twd.ajax)({
	                            url: '/esb/portfolio/cusip/issuedata',
	                            method: 'GET',
	                            params: { cusip: cusip }
	                        });
	
	                    case 4:
	                        _ref2 = _context.sent;
	                        data = _ref2.data;
	                        abort = _ref2.abort;
	
	
	                        lastAjaxAbort = abort;
	                        _context.next = 10;
	                        return data;
	
	                    case 10:
	                        _context.t0 = _context.sent;
	
	                        if (_context.t0) {
	                            _context.next = 13;
	                            break;
	                        }
	
	                        _context.t0 = {};
	
	                    case 13:
	                        info = _context.t0.IssueData;
	
	                        lastAjaxAbort = null;
	
	                        if (info) {
	                            _context.next = 17;
	                            break;
	                        }
	
	                        return _context.abrupt('return', null);
	
	                    case 17:
	                        return _context.abrupt('return', {
	                            holdCusip: info.cusip,
	                            holdIssue: info.issueDisplay,
	                            holdInvType: info.type,
	                            moodyRating: info.moodyRating,
	                            spRating: info.spRating,
	                            holdCoupon: info.coupon,
	                            firstCouponDate: info.firstCoupon,
	                            holdCorpSector: fmtSectorCode(info.sectorCode),
	                            nextCouponDate: info.nextCoupon,
	                            deliveryType: info.delivery === 'C' ? 'Cash' : 'Book Entry',
	                            datedDate: info.dated,
	                            holdUseOfProceeds: fmtUseOfProceeds(info.useOfProceeds),
	                            research: info.research
	                        });
	
	                    case 20:
	                        _context.prev = 20;
	                        _context.t1 = _context['catch'](0);
	                        return _context.abrupt('return', undefined);
	
	                    case 23:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined, [[0, 20]]);
	    }));
	
	    return function getIssueData(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var USE_OF_PROCEEDS = {
	    'Z': 'Agriculture',
	    'E': 'Education',
	    'G': 'Government',
	    'H': 'Healthcare',
	    'A': 'Housing',
	    'I': 'Industrial',
	    'R': 'Recreation',
	    'T': 'Transporation',
	    'U': 'Utilities'
	};
	var fmtUseOfProceeds = function fmtUseOfProceeds(v) {
	    var c = ('' + v)[0];
	    return USE_OF_PROCEEDS[c] || '';
	};
	
	var SECTOR_CODE = {
	    BM: 'Basic Materials',
	    CG: 'Consumer Goods',
	    CS: 'Consumer Services',
	    FI: 'Financials',
	    HC: 'Healthcare',
	    IN: 'Industrials',
	    OG: 'Oil & Gas',
	    OT: 'Other',
	    TY: 'Technology',
	    TE: 'Telecommunications',
	    TR: 'Transportation',
	    UT: 'Utilities'
	};
	
	var fmtSectorCode = function fmtSectorCode(v) {
	    return SECTOR_CODE[v] || '';
	};

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Loader = undefined;
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _detail = __webpack_require__(484);
	
	var _loading = __webpack_require__(1183);
	
	var _notFound = __webpack_require__(1184);
	
	var _getIssueData = __webpack_require__(1181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var Loader = exports.Loader = function Loader(_ref) {
	    var cusip = _ref.cusip,
	        offers = _ref.offers,
	        showTradeHistory = _ref.showTradeHistory,
	        showBackLink = _ref.showBackLink,
	        showBondDetail = _ref.showBondDetail,
	        isTreasuryAuction = _ref.isTreasuryAuction,
	        from = _ref.from;
	
	    var _React$useState = _react2.default.useState('loading'),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        status = _React$useState2[0],
	        setStatus = _React$useState2[1];
	
	    var _React$useState3 = _react2.default.useState(null),
	        _React$useState4 = _slicedToArray(_React$useState3, 2),
	        issueData = _React$useState4[0],
	        setIssueData = _React$useState4[1];
	
	    _react2.default.useEffect(function () {
	        var cancelled = false;_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var data_;
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            _context.next = 2;
	                            return (0, _getIssueData.getIssueData)(cusip);
	
	                        case 2:
	                            data_ = _context.sent;
	
	                            if (!cancelled) {
	                                _context.next = 5;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 5:
	                            if (!(data_ === undefined)) {
	                                _context.next = 8;
	                                break;
	                            }
	
	                            setStatus('failed');
	                            return _context.abrupt('return');
	
	                        case 8:
	                            if (data_) {
	                                _context.next = 11;
	                                break;
	                            }
	
	                            setStatus('not-found');
	                            return _context.abrupt('return');
	
	                        case 11:
	
	                            setStatus('found');
	                            setIssueData(Object.assign({ showTradeHistory: showTradeHistory, showBackLink: showBackLink, showBondDetail: showBondDetail, isTreasuryAuction: isTreasuryAuction, from: from }, offers, data_));
	
	                        case 13:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined);
	        }))();
	
	        return function () {
	            cancelled = true;
	        };
	    }, []);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        status === 'loading' ? _react2.default.createElement(_loading.Loading, null) : status === 'not-found' ? _react2.default.createElement(_notFound.NotFound, null) : status === 'found' ? _react2.default.createElement(_detail.Detail, issueData) : null
	    );
	};

/***/ },
/* 1183 */
955,
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NotFound = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFound = exports.NotFound = function NotFound() {
	    return _react2.default.createElement(
	        "div",
	        { "data-name": "loading-fail", className: "row" },
	        _react2.default.createElement(
	            "div",
	            { className: "col-md-12 text-center" },
	            _react2.default.createElement("i", { className: "et-icon et-alert et-icon-md", "aria-hidden": "true" }),
	            _react2.default.createElement(
	                "div",
	                { className: "small-header" },
	                "Data not found."
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.orderPhone = exports.orderDetail = exports.sell = exports.buy = exports.showBondOrder = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var showBondOrder = exports.showBondOrder = function showBondOrder(arg) {
	    var f = (0, _twd.getConfig)('entitlements.ETradeOrderTicket', 'No') === 'Yes';
	    var nav = f ? 'order-ticket' : 'tools.bond-order';
	    (0, _twd.show)(nav, arg);
	};
	
	var buy = exports.buy = function buy() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref.cusip,
	        _ref$acctNo = _ref.acctNo,
	        acctNo = _ref$acctNo === undefined ? '' : _ref$acctNo,
	        _ref$qty = _ref.qty,
	        qty = _ref$qty === undefined ? '' : _ref$qty,
	        from = _ref.from,
	        _ref$action = _ref.action,
	        action = _ref$action === undefined ? 'B' : _ref$action,
	        _ref$sourceAction = _ref.sourceAction,
	        sourceAction = _ref$sourceAction === undefined ? '' : _ref$sourceAction,
	        _ref$style = _ref.style,
	        style = _ref$style === undefined ? {} : _ref$style,
	        _ref$extraClassName = _ref.extraClassName,
	        extraClassName = _ref$extraClassName === undefined ? '' : _ref$extraClassName;
	
	    return _react2.default.createElement(
	        'a',
	        { href: '#',
	            'data-name': 'buy-button',
	            'data-from': from,
	            type: 'button',
	            className: "btn btn-sm btn-primary-outline " + extraClassName,
	
	            style: Object.assign({ display: 'inline-block', maxWidth: '100%' }, style),
	
	            onClick: function onClick() {
	                (0, _twd.hideModal)();
	                showBondOrder({
	                    action: action,
	                    cusip: cusip,
	                    acctNo: acctNo,
	                    qty: qty,
	                    sourceAction: sourceAction,
	                    from: from,
	                    ts: Date.now()
	                });
	            }
	        },
	        'Buy'
	    );
	};
	
	var sell = exports.sell = function sell() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        cusip = _ref2.cusip,
	        _ref2$acctNo = _ref2.acctNo,
	        acctNo = _ref2$acctNo === undefined ? '' : _ref2$acctNo,
	        _ref2$qty = _ref2.qty,
	        qty = _ref2$qty === undefined ? '' : _ref2$qty,
	        from = _ref2.from,
	        _ref2$action = _ref2.action,
	        action = _ref2$action === undefined ? 'S' : _ref2$action,
	        _ref2$sourceAction = _ref2.sourceAction,
	        sourceAction = _ref2$sourceAction === undefined ? '' : _ref2$sourceAction,
	        _ref2$style = _ref2.style,
	        style = _ref2$style === undefined ? {} : _ref2$style,
	        _ref2$extraClassName = _ref2.extraClassName,
	        extraClassName = _ref2$extraClassName === undefined ? '' : _ref2$extraClassName;
	
	    var cs = (0, _twd.getConfig)('cusips_held', {});
	    var h = cs[cusip];
	    if (!h) return null;
	
	    var n = h.length > 0;
	    acctNo = acctNo || (n ? h[0].acctNo : '');
	    sourceAction = sourceAction || (n ? 'H' : '');
	
	    return _react2.default.createElement(
	        'a',
	        { href: '#',
	            'data-name': 'sell-button',
	            'data-from': from,
	            type: 'button',
	            className: "btn btn-sm btn-primary-outline " + extraClassName,
	
	            style: Object.assign({ display: 'inline-block', maxWidth: '100%' }, style),
	
	            onClick: function onClick() {
	                (0, _twd.hideModal)();
	                showBondOrder({
	                    action: action,
	                    cusip: cusip,
	                    acctNo: acctNo,
	                    qty: qty,
	                    sourceAction: sourceAction,
	                    from: from,
	                    ts: Date.now()
	                });
	            }
	        },
	        'Sell'
	    );
	};
	
	var orderDetail = exports.orderDetail = function orderDetail() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        orderNo = _ref3.orderNo;
	
	    return _react2.default.createElement(
	        'a',
	        { href: '#',
	            'data-name': 'order-detail-link',
	            className: 'link-button',
	            style: { cursor: 'pointer' },
	            onClick: function onClick() {
	                (0, _twd.show)('tools.order-detail', { orderNo: orderNo });
	            }
	        },
	        orderNo
	    );
	};
	
	var orderPhone = exports.orderPhone = function orderPhone() {
	    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref4$style = _ref4.style,
	        style = _ref4$style === undefined ? {} : _ref4$style;
	
	    return _react2.default.createElement(
	        'a',
	        { href: '#',
	            'data-name': 'order-call-link',
	            style: Object.assign({ cursor: 'pointer' }, style),
	            onClick: orderPhoneModal,
	            alt: 'Order by telephone'
	        },
	        _react2.default.createElement(
	            'i',
	            { className: 'material-icons et-icon-xs', 'aria-hidden': 'true' },
	            'phone'
	        )
	    );
	};
	
	var orderPhoneModal = function orderPhoneModal() {
	    (0, _twd.disclosures)({
	        title: 'This asset class is not available for online trading',
	        html: '\n        <p class="text-center text-bold">\n        Please call our Fixed Income Specialists at<br/>\n        877-355-3237 with inquiries or for support placing orders.\n        </p>\n        ',
	        buttonClass: 'text-center',
	        buttonStyle: { display: 'block' },
	        buttons: [{
	            label: 'Call 877-355-3237',
	            onClick: function onClick() {
	                (0, _twd.hideModal)();
	                location.href = 'tel:18773553237';
	            }
	        }],
	        modalClass: "modal-dialog modal-sm"
	    });
	};

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.FrameIn = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FrameIn = exports.FrameIn = function FrameIn() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        src = _ref.src,
	        _ref$height = _ref.height,
	        height = _ref$height === undefined ? 200 : _ref$height,
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-frame' : _ref$dataName,
	        frameName = _ref.frameName,
	        getHeight = _ref.getHeight;
	
	    var _React$useState = _react2.default.useState(false),
	        _React$useState2 = _slicedToArray(_React$useState, 2),
	        loading = _React$useState2[0],
	        setLoading = _React$useState2[1];
	
	    _react2.default.useEffect(function () {
	        setLoading(true);
	    }, [src]);
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        loading && _react2.default.createElement(
	            'div',
	            { style: { minWidth: '150px' } },
	            _react2.default.createElement(
	                'div',
	                { 'data-name': 'loading-spinner', className: 'spinner', style: { width: "45px" } },
	                _react2.default.createElement(
	                    'svg',
	                    { className: 'circular', viewBox: '25 25 50 50' },
	                    _react2.default.createElement('circle', { className: 'background', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' }),
	                    _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' })
	                )
	            )
	        ),
	        _react2.default.createElement('iframe', {
	            'data-name': dataName,
	            src: src,
	
	            style: {
	                width: '100%',
	                minHeight: '250px',
	                visibility: 'hidden'
	            },
	            marginWidth: '0',
	            marginHeight: '0',
	            frameBorder: '0',
	            onLoad: function onLoad(ev) {
	                ev.persist();
	                var e = ev.target;
	                e.style.visibility = 'visible';
	
	                var fn = function fn() {
	                    try {
	                        var w = e.contentWindow;
	                        var d = w.document;
	                        var b = d.body;
	                        var de = d.documentElement;
	
	                        var frameHeight = 0;
	                        if (frameName) try {
	                            var fr = w.frames[frameName];
	                            var fd = fr.document;
	                            var fb = fd.body;
	                            var fde = fd.documentElement;
	                            frameHeight = Math.max(fb.scrollHeight, fb.offsetHeight, fde.clientHeight, fde.scrollHeight, fde.offsetHeight);
	                        } catch (e) {}
	
	                        var calcHeight = 0;
	                        if (getHeight) try {
	                            calcHeight = getHeight(w);
	                        } catch (e) {}
	
	                        var h = calcHeight || Math.max(b.scrollHeight, b.offsetHeight, de.clientHeight, de.scrollHeight, de.offsetHeight, frameHeight);
	                        if (parseInt(h, 10)) {
	                            e.style.height = Math.max(h, height) + 'px';
	                        }
	                    } catch (x) {
	                        clearInterval(resizeInt);
	                        e.style.height = '100%';
	                    }
	                };
	
	                var resizeInt = setInterval(function () {
	                    fn();
	                }, 1000);
	                fn();
	
	                setLoading(false);
	            }
	        })
	    );
	};

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.iconLabel = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icons = __webpack_require__(487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	var iconLabel = exports.iconLabel = function iconLabel(icon, label) {
	    var isSvgIcon = Object.values(_icons.icons).includes(icon);
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: {
	                    display: isSvgIcon ? 'inline-flex' : 'inline',
	                    alignItems: 'center',
	                    verticalAlign: 'middle'
	                } },
	            isSvgIcon ? _react2.default.createElement(
	                'span',
	                { style: {
	                        display: 'inline-flex',
	                        alignItems: 'center',
	                        verticalAlign: 'middle',
	                        marginRight: '5px'
	                    } },
	                icon
	            ) : icon,
	            label
	        )
	    );
	};

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.NO_RESULT_ICON = exports.NO_RESULT_ICON_HTML = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NO_RESULT_ICON_HTML = exports.NO_RESULT_ICON_HTML = "\n    <svg width=\"40\" height=\"33\" viewBox=\"0 0 40 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M0.319946 0.120117V25.0801H7.51995V32.9521L15.3919 25.0801H39.6799V0.120117H0.319946ZM38.7199 24.1201H15.0079L8.47995 30.6481V24.1201H1.27995V1.08012H38.7199V24.1201ZM20.4799 16.1041L20.5759 5.01612H19.4239L19.5199 16.1041H20.4799ZM19.9999 20.3761C20.5279 20.3761 20.9599 19.9921 21.0079 19.4641C21.0559 18.9361 20.6239 18.5041 20.0959 18.4561C19.5679 18.4081 19.1359 18.8401 19.0879 19.3681C19.0879 19.3681 19.0879 19.3681 19.0879 19.4161C19.0879 19.9441 19.4719 20.3281 19.9999 20.3761Z\" fill=\"#242424\"/>\n    </svg>"; /* eslint-disable no-use-before-define */
	var NO_RESULT_ICON = exports.NO_RESULT_ICON = _react2.default.createElement(
	    "svg",
	    { width: "40", height: "33", viewBox: "0 0 40 33", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
	    _react2.default.createElement("path", { d: "M0.319946 0.120117V25.0801H7.51995V32.9521L15.3919 25.0801H39.6799V0.120117H0.319946ZM38.7199 24.1201H15.0079L8.47995 30.6481V24.1201H1.27995V1.08012H38.7199V24.1201ZM20.4799 16.1041L20.5759 5.01612H19.4239L19.5199 16.1041H20.4799ZM19.9999 20.3761C20.5279 20.3761 20.9599 19.9921 21.0079 19.4641C21.0559 18.9361 20.6239 18.5041 20.0959 18.4561C19.5679 18.4081 19.1359 18.8401 19.0879 19.3681C19.0879 19.3681 19.0879 19.3681 19.0879 19.4161C19.0879 19.9441 19.4719 20.3281 19.9999 20.3761Z", fill: "#242424" })
	);

/***/ },
/* 1189 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/* eslint-disable */
	var isNumeric = function isNumeric(a) {
	    return !isNaN(parseFloat(a)) && isFinite(a);
	};
	
	var getCheckDigit = exports.getCheckDigit = function getCheckDigit(cusip8) {
	
	    if (cusip8.length != 8) {}
	
	    //Side Note - this was translated from the the VB6 code so the code may appear
	    //  a little disjointed.
	
	    var lLoop; // Looping varaiable
	    var currentChar; // The current character being checked
	    var lCheckSum; // The checksum value
	    var lASCVal; // The ascii value of the current character
	    var lCharCheck; // The value of the checksum for the current character
	    var lMultiplier; // The check value multiplier
	
	    lCheckSum = 0; //Init the value
	
	    // convert to upper case
	    cusip8 = cusip8.toUpperCase();
	    // --Calculate the checksum for the odd characters up to the 7th character
	    for (lLoop = 1; lLoop <= 8; lLoop++) {
	        currentChar = cusip8.charAt(lLoop - 1);
	
	        // Get the multiplier.  The checksum from odd characters are multiplied by 2
	        if (lLoop % 2 == 0) {
	            lMultiplier = 2;
	        } else {
	            lMultiplier = 1;
	        }
	
	        // Check if the letter is numeric
	        var numericCusipChar = {}; //Will contain the current cusip character if it is numeric
	
	        //if (System.Int32.TryParse(String.fromCharCode(currentChar), numericCusipChar)) {
	        if (isNumeric(currentChar)) {
	            numericCusipChar = parseInt(currentChar);
	            lCharCheck = numericCusipChar * lMultiplier;
	
	            // --add the 10 and 1 digits together
	            if (lCharCheck > 9) {
	                lCheckSum += (lCharCheck / 10 | 0) + lCharCheck % 10;
	            } else {
	                lCheckSum += lCharCheck;
	            }
	        } else {
	            lASCVal = currentChar.charCodeAt();
	            // Check if this a letter
	            if (lASCVal < 65 /* Keys.A */
	            || lASCVal > 90 /* Keys.Z */
	            ) {
	
	                // This is in invalid character, exit
	                return -1;
	            }
	
	            // --Get the checksum value
	            // Get the offset from the letter A and add 10
	            lCharCheck = (lASCVal - 65 /* Keys.A */
	            + 10) * lMultiplier;
	
	            // --add the 10 and 1 digits together
	            if (lCharCheck > 9) {
	                lCheckSum += (lCharCheck / 10 | 0) + lCharCheck % 10;
	            } else {
	                lCheckSum += lCharCheck;
	            }
	        }
	    }
	    // --Get the right most value of the checksum
	    lCheckSum = lCheckSum % 10;
	
	    // Subtract from 10 if it is not 0
	    if (lCheckSum != 0) {
	        lCheckSum = 10 - lCheckSum;
	    }
	
	    return lCheckSum;
	};
	
	var isCusip = exports.isCusip = function isCusip(cusip9) {
	    if (!cusip9) return false;
	
	    // Must be at 9 characters
	    if (cusip9.length !== 9) {
	        return false;
	    }
	
	    var checkDigit = cusip9.substring(8, 9);
	
	    if (!isNumeric(checkDigit)) {
	        return false;
	    }
	
	    // Check the checksum against the check digit (the last digit in the string)
	    return getCheckDigit(cusip9.substring(0, 8)) == checkDigit;
	};

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.yieldGridLastUpdated = exports.isHoliday = exports.toMdy = exports.getServerTime = undefined;
	
	var _all = __webpack_require__(64);
	
	var getServerTime = exports.getServerTime = function getServerTime() {
	    var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
	
	    d = d || new Date();
	    var off = (0, _all.getConfig)('timezoneOffset', 0);
	    d.setHours(d.getHours() + off);
	    return d;
	}; /* eslint-disable no-use-before-define */
	
	
	var getYieldGridEndOfDayTime = function getYieldGridEndOfDayTime() {
	    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'endOfDayTime';
	
	    var eod = Math.min((0, _all.getConfig)(id, 1700), 1700);
	    return eod === 1700 ? 1655 : eod;
	};
	
	var getYieldGridOffHours = function getYieldGridOffHours() {
	    var d = getServerTime();
	
	    if (isHoliday(d)) return 'holiday';
	
	    var hm = d.getHours() * 100 + d.getMinutes();
	    var sod = 800;
	    var eod = getYieldGridEndOfDayTime();
	
	    return hm < sod ? 'before' : hm > eod ? 'after' : null;
	};
	
	var toMdy = exports.toMdy = function toMdy(dt) {
	    return dt.toLocaleDateString("en-US").replace(/\u200E/g, '');
	};
	
	var isHoliday = exports.isHoliday = function isHoliday(dt) {
	    return dt.getDay() === 6 // sat
	    || dt.getDay() === 0 // sun
	    || (0, _all.getConfig)('next_holiday', []).indexOf(toMdy(dt)) >= 0;
	};
	
	var yieldGridLastUpdated = exports.yieldGridLastUpdated = function yieldGridLastUpdated() {
	    var hr = getYieldGridOffHours();
	    if (!hr) return '';
	
	    var isPrevious = hr === 'holiday' || hr === 'before';
	    var d = isPrevious ? new Date((0, _all.getConfig)('previous_business_day')) : new Date(getServerTime().setHours(0, 0, 0, 0));
	
	    var eod = getYieldGridEndOfDayTime(isPrevious ? 'previousEndOfDayTime' : 'endOfDayTime');
	
	    return 'Last Updated: ' + _all.format.date(d) + ' ' + hhmmToString(eod) + ' ET';
	};
	
	var hhmmToString = function hhmmToString(hhmm) {
	    var hh = Math.floor(hhmm / 100);
	    var mm = Math.floor(hhmm % 100);
	    var pm = 'AM';
	    if (hh > 12) {
	        hh -= 12;
	        pm = 'PM';
	    }
	    return hh + ':' + (mm < 10 ? '0' : '') + mm + ' ' + pm;
	};

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MinimalNavigation = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MinimalNavigation = exports.MinimalNavigation = function MinimalNavigation() {
	    return _react2.default.createElement(
	        "nav",
	        { className: "minimal-navigation" },
	        _react2.default.createElement(
	            "div",
	            { className: "row vertical-offset-xs", style: {
	                    borderBottom: '1px solid #e4e4e4'
	                } },
	            _react2.default.createElement(
	                "div",
	                { className: "col-xs-12 vertical-offset-xs" },
	                _react2.default.createElement(
	                    "a",
	                    { href: "https://etrade.com" },
	                    _react2.default.createElement("img", { src: "resources/images/logo.svg", alt: "etrade", width: "150" })
	                )
	            )
	        )
	    );
	}; /* eslint-disable no-use-before-define */

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Paging = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable no-use-before-define */
	
	
	var Paging = exports.Paging = function Paging() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref$dataName = _ref.dataName,
	        dataName = _ref$dataName === undefined ? 'twd-paging' : _ref$dataName,
	        page = _ref.page,
	        total = _ref.total,
	        setPage = _ref.setPage,
	        _ref$size = _ref.size,
	        size = _ref$size === undefined ? 10 : _ref$size;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'pagination-with-label text-bold' },
	        _react2.default.createElement(
	            'ul',
	            { className: 'pagination' },
	            function () {
	                if (total === 0) return null;
	
	                var ps = pages({ page: page, total: total, size: size });
	
	                var maxPage = ps[ps.length - 1];
	                var arr = [];
	
	                if (page !== 1) arr.push(_react2.default.createElement(
	                    'li',
	                    { key: 0, className: 'previous' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'btn-link',
	                            'aria-label': 'previous',
	                            'data-name': dataName + '-left',
	                            style: { cursor: 'pointer' },
	                            onClick: function onClick() {
	                                return setPage(page - 1);
	                            } },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'chevron_left'
	                        )
	                    )
	                ));
	
	                var _loop = function _loop(i, n) {
	                    var p = ps[i];
	                    var c = p === page;
	                    arr.push(_react2.default.createElement(
	                        'li',
	                        { key: arr.length + 1,
	                            className: c ? 'active' : '' },
	                        _react2.default.createElement(
	                            'button',
	                            {
	                                className: 'btn-link',
	                                'aria-label': 'page ' + (i + 1),
	                                'data-name': dataName + '-page',
	                                style: c ? {} : { cursor: 'pointer' },
	                                disabled: c,
	                                onClick: function onClick() {
	                                    return setPage(p);
	                                } },
	                            i === n - 2 && ps[i] + 1 !== ps[i + 1] ? '...' : _twd.fmt.count(p)
	                        )
	                    ));
	                };
	
	                for (var i = 0, n = ps.length; i < n; i++) {
	                    _loop(i, n);
	                }
	
	                if (page !== maxPage) arr.push(_react2.default.createElement(
	                    'li',
	                    { key: arr.length + 1, className: 'next' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            className: 'btn-link',
	                            'aria-label': 'next',
	                            'data-name': dataName + '-right',
	                            style: { cursor: 'pointer' }, onClick: function onClick() {
	                                return setPage(page + 1);
	                            } },
	                        _react2.default.createElement(
	                            'i',
	                            { className: 'material-icons', 'aria-hidden': 'true' },
	                            'chevron_right'
	                        )
	                    )
	                ));
	
	                return arr;
	            }()
	        )
	    );
	};
	
	var pages = function pages() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref2$page = _ref2.page,
	        page = _ref2$page === undefined ? 0 : _ref2$page,
	        _ref2$total = _ref2.total,
	        total = _ref2$total === undefined ? 0 : _ref2$total,
	        _ref2$size = _ref2.size,
	        size = _ref2$size === undefined ? 10 : _ref2$size;
	
	    var nPages = Math.ceil(total / size);
	    var pages = [];
	    if (nPages === 0) return pages;
	
	    if (page < 5) {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return i + 1;
	        });
	    } else if (page + 5 >= nPages) {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return nPages - 6 + i;
	        });
	    } else {
	        pages = [].concat(_toConsumableArray(Array(6).keys())).map(function (i) {
	            return page - 3 + i;
	        });
	    }
	    pages = pages.filter(function (a) {
	        return a < nPages;
	    });
	    pages.push(nPages);
	
	    return pages;
	};

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.formatDate = exports.parseDate = exports.newDate = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-use-before-define */
	
	
	var _dateFns = __webpack_require__(396);
	
	var _format = __webpack_require__(483);
	
	var Patterns = [{
	    // mm/dd/yyyy
	    re: /^(0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])[/-](\d{4})$/ig,
	    fn: function fn(_ref) {
	        var _ref2 = _slicedToArray(_ref, 1),
	            s = _ref2[0];
	
	        return newDate(s);
	    },
	    fmt: function fmt(dt) {
	        return _format.format.mdy(dt);
	    }
	}, {
	    // yyyy/mm/dd
	    re: /^(\d{4})[/-](0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])$/ig,
	    fn: function fn(_ref3) {
	        var _ref4 = _slicedToArray(_ref3, 1),
	            s = _ref4[0];
	
	        return newDate(s);
	    },
	    fmt: function fmt(dt) {
	        return _format.format.mdy(dt);
	    }
	}, {
	    // mm/yy mm/yyyy
	    re: /^(0?[1-9]|1[012])[/-](\d{2,4})$/ig,
	    fn: function fn(_ref5) {
	        var _ref6 = _slicedToArray(_ref5, 3),
	            _ = _ref6[0],
	            m = _ref6[1],
	            y = _ref6[2];
	
	        var eom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var fn = eom ? _dateFns.endOfMonth : _dateFns.startOfMonth;
	        return fn(newDate(m + '/1/' + y));
	    },
	    fmt: function fmt(dt) {
	        return _format.format.mdy(dt);
	    }
	}, {
	    // #mdy
	    re: /(^[0-9]{1,4})([mdy])$/ig,
	    fn: function fn(_ref7) {
	        var _ref8 = _slicedToArray(_ref7, 3),
	            _ = _ref8[0],
	            n = _ref8[1],
	            t = _ref8[2];
	
	        var d = (0, _dateFns.startOfToday)();
	        if (t === 'd' || t === 'D') return (0, _dateFns.addDays)(d, n);
	        if (t === 'm' || t === 'M') return (0, _dateFns.addMonths)(d, n);
	        if (t === 'y' || t === 'Y') return (0, _dateFns.addYears)(d, n);
	    },
	    fmt: function fmt(dt, str) {
	        return str.toLowerCase();
	    }
	}, {
	    // # ####
	    re: /(^[0-9]{1,4})$/ig,
	    fn: function fn(_ref9, eom) {
	        var _ref10 = _slicedToArray(_ref9, 1),
	            y = _ref10[0];
	
	        var n = y.length;
	        if (n < 4) return (0, _dateFns.addYears)((0, _dateFns.startOfToday)(), y);
	        if (n === 4) return newDate((eom ? '12/31/' : '1/1/') + y);
	    },
	    fmt: function fmt(dt, str) {
	        return str;
	    }
	}];
	
	var newDate = exports.newDate = function newDate(s) {
	    var a = Date.parse(s);
	    return isNaN(a) ? null : new Date(a);
	};
	
	var parseDate = exports.parseDate = function parseDate(str) {
	    var eom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (!str) return;
	
	    for (var i = 0, n = Patterns.length; i < n; i++) {
	        var p = Patterns[i];
	        p.re.lastIndex = 0;
	
	        var a = p.re.exec(str);
	        if (!a) continue;
	
	        return p.fn ? p.fn(a, eom) : a;
	    }
	};
	
	var formatDate = exports.formatDate = function formatDate(str) {
	    var eom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (!str) return '';
	
	    for (var i = 0, n = Patterns.length; i < n; i++) {
	        var p = Patterns[i];
	        p.re.lastIndex = 0;
	
	        var a = p.re.exec(str);
	        if (!a) continue;
	
	        var d = p.fn(a, eom);
	        return p.fmt(d, str);
	    }
	
	    return '';
	};

/***/ },
/* 1194 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable */
	
	if (!String.prototype.replaceAll) {
	    String.prototype.replaceAll = function (str, newStr) {
	        if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
	            return this.replace(str, newStr);
	        }
	        var reg = String(str).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	        return this.replace(new RegExp(reg, 'g'), newStr);
	    };
	}

/***/ },
/* 1195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var listeners = {};
	var nextId = 0;
	
	var subscribe = exports.subscribe = function subscribe(name, fn) {
	    var _name$split = name.split('.'),
	        _name$split2 = _slicedToArray(_name$split, 2),
	        evt = _name$split2[0],
	        id = _name$split2[1];
	
	    id = id && id.trim() || '_' + ++nextId;
	
	    var ls = listeners[evt] || (listeners[evt] = {});
	    ls[id] = fn;
	    return evt + '.' + id;
	};
	
	var publish = exports.publish = function publish(evt) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	    }
	
	    var ls = listeners[evt];
	    return ls && Object.values(ls).map(function (fn) {
	        return fn.call.apply(fn, [null].concat(args));
	    });
	};
	
	var unsubscribe = exports.unsubscribe = function unsubscribe(name) {
	    var _name$split3 = name.split('.'),
	        _name$split4 = _slicedToArray(_name$split3, 2),
	        evt = _name$split4[0],
	        id = _name$split4[1];
	
	    var ls = listeners[evt];
	    return ls && delete ls[id];
	};
	
	var execute = exports.execute = function execute(name) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	    }
	
	    var _name$split5 = name.split('.'),
	        _name$split6 = _slicedToArray(_name$split5, 2),
	        evt = _name$split6[0],
	        id = _name$split6[1];
	
	    var ls = listeners[evt];
	    var fn = ls && ls[id];
	    return fn ? fn.call.apply(fn, [null].concat(args)) : undefined;
	};
	
	var assignProperties = exports.assignProperties = function assignProperties(obj) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	        args[_key3 - 1] = arguments[_key3];
	    }
	
	    return args.reduce(function (x, a) {
	        return Object.defineProperties(x, Object.getOwnPropertyDescriptors(a));
	    }, obj);
	};
	
	var define = exports.define = function define(ns, value) {
	    var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
	
	    var a = ns.split(".").reduce(function (curr, n) {
	        if (!(n in curr)) curr[n] = {};
	        return curr[n];
	    }, root) || {};
	    return assignProperties(a, value);
	};
	
	var ProxyContext = exports.ProxyContext = {
	    proxies: {},
	    id: 0,
	    build: function build(id, target, context) {
	        var _this = this;
	
	        return new Proxy(target, {
	            id: id,
	            context: context,
	            get: function get(obj, prop) {
	                if (prop !== '_destroyed' && this.destroyed) return;
	                if (prop.startsWith("_")) return this[prop.substring(1)];
	
	                var fo = Reflect.get(obj, prop);
	                var fc = context[prop];
	                return typeof fo === 'function' ? function () {
	                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                        args[_key4] = arguments[_key4];
	                    }
	
	                    return fo.apply(obj, [context].concat(args));
	                } : fo !== undefined ? fo : typeof fc === 'function' ? function () {
	                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	                        args[_key5] = arguments[_key5];
	                    }
	
	                    return fc.apply(context, [].concat(args));
	                } : fc;
	            },
	            set: function set(obj, prop, value) {
	                if (prop.startsWith("_")) {
	                    this[prop.substring(1)] = value;
	                    return true;
	                } else {
	                    return Reflect.set(obj, prop, value);
	                }
	            },
	
	            destroy: function destroy() {
	                return _this.destroy(id);
	            }
	        });
	    },
	    init: function init(target, context) {
	        var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
	        id = id || 'proxy-context-' + ++this.id;
	        this.destroy(id);
	        var p = this.build(id, target, context);
	        this.proxies[id] = p;
	        return p;
	    },
	    get: function get(id) {
	        return this.proxies[id];
	    },
	    destroy: function destroy(id) {
	        var p = this.proxies[id];
	        if (p) {
	            p._destroyed = true;
	        }
	        delete this.proxies[id];
	    }
	};
	
	var proxyContext = exports.proxyContext = function proxyContext(target, context) {
	    var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	    return ProxyContext.init(target, context, id);
	};

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.SectionBody = exports.SectionHeader = exports.Section = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _getId = __webpack_require__(486);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Section = exports.Section = function Section() {
	    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        title = _ref.title,
	        show = _ref.show,
	        setShow = _ref.setShow,
	        _ref$cls = _ref.cls,
	        cls = _ref$cls === undefined ? "medium-header" : _ref$cls,
	        _ref$arrowSize = _ref.arrowSize,
	        arrowSize = _ref$arrowSize === undefined ? "x-large" : _ref$arrowSize,
	        children = _ref.children,
	        _ref$headerStyle = _ref.headerStyle,
	        headerStyle = _ref$headerStyle === undefined ? {} : _ref$headerStyle;
	
	    var id = (0, _getId.getId)();
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'h3',
	            { className: cls, style: Object.assign({ marginBottom: 0 }, headerStyle) },
	            _react2.default.createElement(
	                'button',
	                {
	                    'aria-controls': id,
	                    style: { position: 'relative', top: 0, zIndex: 1 },
	                    className: 'btn-link',
	                    onClick: function onClick() {
	                        setShow(!show);
	                    }
	                },
	                _react2.default.createElement(
	                    'i',
	                    {
	                        style: { color: 'var(--primary-base-color)', fontSize: arrowSize },
	                        className: 'toggle-button-icon-open material-icons',
	                        'aria-hidden': true
	                    },
	                    show ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
	                ),
	                _react2.default.createElement(
	                    'span',
	                    {
	                        className: 'expand-colapse-label',
	                        'aria-expanded': show },
	                    title
	                )
	            )
	        ),
	        !show && _react2.default.createElement('div', { className: 'vertical-offset-sm' }),
	        show && _react2.default.createElement('div', { className: 'vertical-offset-xs' }),
	        _react2.default.createElement(
	            'div',
	            { id: id, collapsed: show ? "no" : "yes", className: 'section-collapsible' },
	            children
	        )
	    );
	};
	
	var SectionHeader = exports.SectionHeader = function SectionHeader() {
	    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        title = _ref2.title,
	        show = _ref2.show,
	        setShow = _ref2.setShow,
	        _ref2$cls = _ref2.cls,
	        cls = _ref2$cls === undefined ? "medium-header" : _ref2$cls,
	        _ref2$arrowSize = _ref2.arrowSize,
	        arrowSize = _ref2$arrowSize === undefined ? "x-large" : _ref2$arrowSize,
	        _ref2$afterTitle = _ref2.afterTitle,
	        afterTitle = _ref2$afterTitle === undefined ? null : _ref2$afterTitle,
	        _ref2$headerStyle = _ref2.headerStyle,
	        headerStyle = _ref2$headerStyle === undefined ? {} : _ref2$headerStyle;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { display: 'flex' } },
	            _react2.default.createElement(
	                'h3',
	                { className: cls, style: Object.assign({ marginBottom: 0 }, headerStyle) },
	                _react2.default.createElement(
	                    'button',
	                    {
	                        style: { position: 'relative', top: 0, zIndex: 1 },
	                        className: 'btn-link',
	                        'aria-expanded': show,
	                        onClick: function onClick() {
	                            setShow(!show);
	                        }
	                    },
	                    _react2.default.createElement(
	                        'i',
	                        {
	                            style: { color: 'var(--primary-base-color)', fontSize: arrowSize },
	                            className: 'material-icons',
	                            'aria-hidden': true
	                        },
	                        show ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
	                    ),
	                    title
	                )
	            ),
	            afterTitle
	        ),
	        !show && _react2.default.createElement('div', { className: 'vertical-offset-sm' }),
	        show && _react2.default.createElement('div', { className: 'vertical-offset-xs' })
	    );
	};
	
	var SectionBody = exports.SectionBody = function SectionBody(_ref3) {
	    var show = _ref3.show,
	        children = _ref3.children,
	        _ref3$className = _ref3.className,
	        className = _ref3$className === undefined ? "" : _ref3$className;
	
	    return _react2.default.createElement(
	        'div',
	        {
	            collapsed: show ? "no" : "yes",
	            className: 'section-collapsible ' + className
	        },
	        children
	    );
	};

/***/ },
/* 1197 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var states = exports.states = {};
	
	var State = function () {
	    function State(id) {
	        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, State);
	
	        this.id = id;
	        this.initialValue = Object.assign({}, value);
	        this._value = Object.assign({}, value);
	    }
	
	    _createClass(State, [{
	        key: "set",
	        value: function set() {
	            var a = this._value;
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return Object.assign.apply(a, [a].concat(args));
	        }
	    }, {
	        key: "reset",
	        value: function reset() {
	            this._value = Object.assign({}, this.initialValue);
	            return this._value;
	        }
	    }, {
	        key: "clone",
	        value: function clone() {
	            var elseValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	            try {
	                return JSON.parse(JSON.stringify(this._value));
	            } catch (_) {
	                return elseValue;
	            }
	        }
	    }, {
	        key: "value",
	        set: function set(a) {
	            this._value = a;
	        },
	        get: function get() {
	            return this._value;
	        }
	    }]);
	
	    return State;
	}();
	
	var getState = exports.getState = function getState(id, cfg) {
	    if (id in states) return states[id];
	
	    var s = new State(id, cfg);
	    states[id] = s;
	    return s;
	};

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Loading = exports.Status = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Status = exports.Status = {
	    LOADING: 'Loading',
	    FAILED_TO_LOAD: 'Failed to Load',
	    LOADED: 'Loaded',
	    ABORTED: 'Aborted',
	    UNAVAILABLE: 'Unavailable',
	    NULL: 'Null'
	};
	
	var Loading = exports.Loading = function Loading(_ref) {
	    var status = _ref.status,
	        _ref$spinner = _ref.spinner,
	        spinner = _ref$spinner === undefined ? true : _ref$spinner,
	        error = _ref.error,
	        children = _ref.children;
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        status === Status.LOADING && spinner ? _react2.default.createElement(
	            'div',
	            { style: { minWidth: '150px' } },
	            _react2.default.createElement(
	                'div',
	                {
	                    'data-name': 'loading-spinner',
	                    className: 'spinner',
	                    style: { width: "45px", minHeight: "100px", verticalAlign: "top" } },
	                _react2.default.createElement(
	                    'svg',
	                    { className: 'circular', viewBox: '25 25 50 50' },
	                    _react2.default.createElement('circle', { className: 'background', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' }),
	                    _react2.default.createElement('circle', { className: 'path', cx: '50', cy: '50', fill: 'none', r: '20', strokeMiterlimit: '10', strokeWidth: '2' })
	                )
	            )
	        ) : status === Status.FAILED_TO_LOAD ? _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'loading-fail',
	                className: 'universal-message universal-message-danger' },
	            _react2.default.createElement(
	                'div',
	                { className: 'universal-message-content' },
	                _react2.default.createElement('h4', { className: 'universal-message-heading text-left',
	                    dangerouslySetInnerHTML: { __html: error || 'Fails to retrieve data' }
	                })
	            )
	        ) : status === Status.UNAVAILABLE ? _react2.default.createElement(
	            'div',
	            {
	                'data-name': 'loading-unavailable',
	                className: 'universal-message' },
	            _react2.default.createElement(
	                'div',
	                { className: 'universal-message-content' },
	                _react2.default.createElement('h4', { className: 'universal-message-heading text-muted',
	                    dangerouslySetInnerHTML: { __html: error || 'Unavailable' }
	                })
	            )
	        ) : status === Status.NULL ? null : status === Status.LOADED ? _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            children
	        ) : _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            children
	        )
	    );
	};

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.trackSearch = undefined;
	
	var _all = __webpack_require__(64);
	
	var trackSearch = exports.trackSearch = function trackSearch(name, sp) {
	    var isAdvanced = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var a = getData(sp, isAdvanced);
	    (0, _all.track)(name, a);
	}; /* eslint-disable no-use-before-define */
	
	
	var getData = function getData() {
	    var sp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var isAdvanced = arguments[1];
	
	    var p = {};
	    p.securities = wrap((0, _all.arrayFrom)(sp.holdInvType).map(function (a) {
	        return _all.INV_TYPE_LABELS[a];
	    }));
	
	    p.issuer = wrap((0, _all.arrayFrom)(sp.holdIssue));
	    p.cusip = wrap((0, _all.arrayFrom)(sp.holdCusip));
	
	    // corporates
	    p.sector = wrap((0, _all.arrayFrom)(sp.holdCorpSectorCode).map(function (a) {
	        return _all.CORP_SECTOR_LABELS[a];
	    }));
	    p.corp_type = wrap((0, _all.arrayFrom)(sp.holdConvertible).map(function (a) {
	        return CONVERTIBLE_LABELS[a];
	    }));
	    p.debt_ranking = wrap((0, _all.arrayFrom)(sp.holdDrnk).map(function (a) {
	        return _all.CORP_DEBT_RANK_LABELS[a];
	    }));
	    p.market_type = wrap((0, _all.arrayFrom)(sp.primarySecondary).map(function (a) {
	        return MARKET_TYPES[a];
	    }));
	    p.symbol = wrap((0, _all.arrayFrom)(sp.holdSymbol));
	
	    // municipals
	    p.state = wrap((0, _all.arrayFrom)(sp.holdState));
	    p.category = wrap((0, _all.arrayFrom)(sp.holdMuniType).concat((0, _all.arrayFrom)(sp.holdRefundInd)).concat((0, _all.arrayFrom)(sp.holdRefundType)).map(function (a) {
	        return CATEGORY_LABELS[a];
	    }));
	    p.tax_treatment = wrap((0, _all.arrayFrom)(sp.holdTaxable).map(function (a) {
	        return FEDERAL_TAX_LABELS[a];
	    }).concat((0, _all.arrayFrom)(sp.holdStateTaxExempt).map(function (a) {
	        return STATE_TAX_LABELS[a];
	    })).concat((0, _all.arrayFrom)(sp.holdAltMinTax).map(function (a) {
	        return AMT_TAX_LABELS[a];
	    })));
	    p.use_of_proceeds = wrap((0, _all.arrayFrom)(sp.holdUseOfProceeds));
	    p.environmental = wrap((0, _all.arrayFrom)(sp.holdIssueType).map(function (a) {
	        return _all.MUNI_ENVIRONMENTAL_LABELS[a];
	    }));
	    p.deminimis = wrap((0, _all.arrayFrom)(sp.offeringDeMinStatus));
	    if (sp.holdInsurance) p.insured = (0, _all.arrayFrom)(sp.holdInsurance).length > 0;
	
	    // cds
	    p.bluesky_state = wrap((0, _all.arrayFrom)(sp.holdBlueSkyStateCD));
	    p.fdic = sp.holdFdicNum;
	
	    // agencies
	    p.agency = wrap((0, _all.arrayFrom)(sp.holdAgencyType).map(function (a) {
	        return _all.AGENCY_TYPE_LABELS[a];
	    }));
	
	    // treasuries
	    p.ust_type = wrap((0, _all.arrayFrom)(sp.holdTreasuryType));
	
	    // common fields
	    p.maturity_min = sp.holdMaturityMin;
	    p.maturity_max = sp.holdMaturityMax;
	
	    p.rating = RATING_LABELS[sp.rating];
	    p.moody_credit_rating_min = sp.holdMoodyRatingMin;
	    p.moody_credit_rating_max = sp.holdMoodyRatingMax;
	    p.sp_credit_rating_min = sp.holdSpRatingMin;
	    p.sp_credit_rating_max = sp.holdSpRatingMax;
	
	    p.price_min = sp.clientPriceMin;
	    p.price_max = sp.clientPriceMax;
	    p.quantity_min = sp.quantityMin;
	    p.quantity_max = sp.quantityMax;
	
	    p.yield_to_worst_min = sp.ytwMin;
	    p.yield_to_worst_max = sp.ytwMax;
	    p.yield_to_maturity_min = sp.ytmMin;
	    p.yield_to_maturity_max = sp.ytmMax;
	
	    p.coupon_min = sp.holdCouponMin;
	    p.coupon_max = sp.holdCouponMax;
	    p.coupon_frequeny = wrap((0, _all.arrayFrom)(sp.holdCouponPayFrequency).map(function (a) {
	        return _all.COUPON_FREQUENCY_LABELS[a];
	    }));
	    p.coupon_pay_month = wrap((0, _all.arrayFrom)(sp.holdCouponPayMonths).map(function (a) {
	        return _all.COUPON_MONTH_LABELS[a];
	    }));
	    p.coupon_features = wrap((0, _all.arrayFrom)(sp.holdCouponTypeCode).map(function (a) {
	        return _all.COUPON_FEATURE_LABELS[a];
	    }));
	
	    p.call_features = wrap((0, _all.arrayFrom)(sp.holdCallableInd).map(function (a) {
	        return CALLABLE_LABELS[a];
	    }).concat((0, _all.arrayFrom)(sp.holdWholeCallInd).map(function (a) {
	        return MAKE_WHOELE_CALL_LABELS[a];
	    })));
	
	    p.put_features = wrap((0, _all.arrayFrom)(sp.holdPutableInd).concat((0, _all.arrayFrom)(sp.holdPutType)).map(function (a) {
	        return PUTTABLE_LABELS[a];
	    }));
	
	    p.other_features = wrap((0, _all.arrayFrom)(sp.holdNextSink).map(function (a) {
	        return SINK_LABELS[a];
	    }).concat((0, _all.arrayFrom)(sp.holdErpInd).map(function (a) {
	        return ERP_LABELS[a];
	    })));
	
	    p.next_call_min = sp.holdFirstCallMin;
	    p.next_call_max = sp.holdFirstCallMax;
	
	    if (isAdvanced) {
	        p.offering_posted = sp.offeringNewToday ? 'New Today' : 'Any Time';
	
	        var _arrayFrom$ = (0, _all.arrayFrom)(sp.sort)[0],
	            field = _arrayFrom$.field,
	            direction = _arrayFrom$.direction;
	
	        p.sort_by = SORT_BY_LABELS[field];
	        p.sort_order = SORT_ORDER_LABELS[direction];
	        p.results_per_page = sp.resultsPerPage;
	    }
	
	    return (0, _all.cleanObject)(p);
	};
	
	var wrap = function wrap(arr) {
	    return arr.filter(Boolean).join('|');
	};
	
	var CONVERTIBLE_LABELS = {
	    'Y': 'Convertible',
	    'N': 'Non-Convertible'
	};
	
	var MARKET_TYPES = {
	    'primary': 'New Issue',
	    'secondary': 'Secondary'
	};
	
	var CATEGORY_LABELS = {
	    'G': 'General Obligation',
	    'R': 'Revenue',
	    'Y': 'Refunded',
	    'PRE': 'Pre-Refunded',
	    'ETM': 'Escrowed To Maturity'
	};
	
	var FEDERAL_TAX_LABELS = {
	    'BAB': 'Build America Bonds',
	    'Y': 'Federally Taxable',
	    'N': 'Federally Tax-Exempt'
	};
	
	var STATE_TAX_LABELS = {
	    'Y': 'State Taxable',
	    'N': 'State Tax-Exempt'
	};
	
	var AMT_TAX_LABELS = {
	    'Y': 'Subject to AMT',
	    'N': 'Exempt from AMT'
	};
	
	var RATING_LABELS = {
	    'high-yield': 'High Yield',
	    'investment-grade': 'Investment Grade'
	};
	
	var CALLABLE_LABELS = {
	    'Y': 'Callable',
	    'N': 'Non-Callable'
	};
	
	var MAKE_WHOELE_CALL_LABELS = {
	    'Y': 'Make Whole Call'
	};
	
	var PUTTABLE_LABELS = {
	    'Y': 'Puttable',
	    'N': 'Non-Puttable',
	    'MAN': 'Mandatory',
	    'COND': 'Conditional',
	    'SUR': 'Survivor'
	};
	
	var SINK_LABELS = {
	    'Y': 'Sinking Fund',
	    'N': 'No Sinking Fund'
	};
	
	var ERP_LABELS = {
	    'Y': 'Extraordinary Redemption Provision',
	    'N': 'Non-Extraordinary Redemption Provision'
	};
	
	var SORT_BY_LABELS = Object.fromEntries([{ label: 'Quantity', value: 'askQuantity' }, { label: 'Issuer', value: 'holdIssue' }, { label: 'Coupon', value: 'holdCoupon' }, { label: 'Maturity', value: 'holdMaturitySortDt' }, { label: 'Price', value: 'askPrice' }, { label: 'Yield to worst', value: 'askYield' }, { label: 'Yield to maturity', value: 'askYieldmat' }].map(function (_ref) {
	    var label = _ref.label,
	        value = _ref.value;
	    return [value, label];
	}));
	
	var SORT_ORDER_LABELS = {
	    'ASC': 'Ascending',
	    'DESC': 'Descending'
	};

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.track = exports.trackPage = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var trackPage = exports.trackPage = function trackPage(name) {
	    _react2.default.useEffect(function () {
	        location.hash = name;
	    }, []);
	};
	
	var track = exports.track = function track(name, property) {
	    try {
	        global.heap.track(name, property);
	    } catch (e) {}
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.trapFocus = undefined;
	
	var _all = __webpack_require__(64);
	
	var trapFocus = exports.trapFocus = function trapFocus(el, ev) {
	    var isTab = ev.key === 'Tab' || ev.keyCode === 9;
	    if (!isTab) return;
	
	    var elems = (0, _all.$)(':focusable', el);
	    var first = elems.first()[0];
	    var last = elems.last()[0];
	
	    if (first === last) {
	        ev.preventDefault();
	        return;
	    }
	
	    if (ev.target === first && ev.shiftKey) {
	        last.focus();
	        ev.preventDefault();
	        return;
	    }
	
	    if (ev.target === last && !ev.shiftKey) {
	        first.focus();
	        ev.preventDefault();
	        return;
	    }
	};

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.usePrevious = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var usePrevious = exports.usePrevious = function usePrevious(value) {
	    var ref = _react2.default.useRef();
	    _react2.default.useEffect(function () {
	        ref.current = value;
	    }, [value]);
	    return ref.current;
	};

/***/ },
/* 1203 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALUES = [{ value: 'ATI', display: 'ATI - Aid to Israel' }, { value: 'B', display: 'DN - Discount Notes' }, { value: 'FAMC', display: 'FAMC - Federal Agriculture Mortgage Corporation' }, { value: 'FFCB', display: 'FFCB - Federal Farm Credit Banks' }, { value: 'FHA', display: 'FHA - Farmers Home Administration' }, { value: 'FHLB', display: 'FHLB - Federal Home Loan Banks' }, { value: 'FHLMC', display: 'FHLMC - Federal Home Loan Mortgage Corporation' }, { value: 'FICO', display: 'FICO - Financing Corp' }, { value: 'FJOB', display: 'FJOB - Federal Judiciary Office Building' }, { value: 'FNMA', display: 'FNMA - Federal National Mortgage Association' }, { value: 'GNMA', display: 'GNMA - Government National Mortgage Association' }, { value: 'HUD', display: 'HUB - Housing & Urban Development' }, { value: 'SBA', display: 'SBA - Small Business Administration' }, { value: 'SLMA', display: 'SLMA - Student Loan Marketing Association' }, { value: 'TVA', display: 'TVA - Tennessee Valley Authority' }, { value: 'OTHER', display: 'OTHER - All else' }];
	
	var AGENCY_TYPES = exports.AGENCY_TYPES = VALUES.map(function (_ref) {
	    var value = _ref.value,
	        display = _ref.display;
	
	    return {
	        label: display,
	        display: display,
	        value: 'holdAgencyType=' + encodeURIComponent(value)
	    };
	});
	
	var AGENCY_TYPE_LABELS = exports.AGENCY_TYPE_LABELS = Object.fromEntries(VALUES.map(function (a) {
	    return [a.value, a.display];
	}));

/***/ },
/* 1204 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CALL_FEATURES = exports.CALL_FEATURES = [{ display: 'Callable', value: 'holdCallableInd=Y' }, { display: 'Make Whole Call', value: 'holdWholeCallInd=Y' }, { display: 'Non-Callable', value: 'holdCallableInd=N' }].map(function (a) {
	    a.label = a.display;
	    return a;
	});
	
	var PUT_FEATURES = exports.PUT_FEATURES = [{ display: 'Puttable', value: 'holdPutableInd=Y' }, { display: 'Mandatory', value: 'holdPutType=MAN', oneOf: 'holdPutableInd=Y' }, { display: 'Conditional', value: 'holdPutType=COND', oneOf: 'holdPutableInd=Y' }, { display: 'Survivor', value: 'holdPutType=SUR', oneOf: 'holdPutableInd=Y' }, { display: 'Non-Puttable', value: 'holdPutableInd=N' }].map(function (a) {
	    a.label = a.display;
	    return a;
	});
	
	var OTHER_FEATURES = exports.OTHER_FEATURES = [{ display: 'Sinking Fund', value: 'holdNextSink=Y' }, { display: 'No Sinking Fund', value: 'holdNextSink=N' }, { display: 'Extraordinary Redemption Provision', value: 'holdErpInd=Y' }, { display: 'Non-Extraordinary Redemption Provision', value: 'holdErpInd=N' }].map(function (a) {
	    a.label = a.display;
	    return a;
	});

/***/ },
/* 1205 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALUES = [{ display: 'Secured', value: 'SEC' }, { display: 'Senior Unsecured', value: 'SNUN' }, { display: 'Senior Subordinated', value: 'SNSU' }, { display: 'Subordinated', value: 'SU' }, { display: 'Junior Subordinated', value: 'JUSU' }, { display: 'Preferred Shares', value: 'PFD' }, { display: 'Other', value: 'OTHR' }];
	
	var CORP_DEBT_RANKS = exports.CORP_DEBT_RANKS = VALUES.map(function (_ref) {
	    var value = _ref.value,
	        display = _ref.display;
	
	    return {
	        label: display,
	        display: display,
	        value: 'holdDrnk=' + value
	    };
	});
	
	var CORP_DEBT_RANK_LABELS = exports.CORP_DEBT_RANK_LABELS = Object.fromEntries(VALUES.map(function (a) {
	    return [a.value, a.display];
	}));

/***/ },
/* 1206 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var CORP_FEATURES = exports.CORP_FEATURES = [{ display: 'Convertible', value: 'holdConvertible=Y' }, { display: 'Non-Convertible', value: 'holdConvertible=N' }].map(function (a) {
	    a.label = a.display;
	    return a;
	});

/***/ },
/* 1207 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var toArray = function toArray(s) {
	    return s.split(',').map(function (a) {
	        return a.trim();
	    }).filter(Boolean);
	};
	
	var SIC_CODES = {
	    'BM': toArray('0100,0111,0115,0116,0119,0133,0139,0161,0172,0174,0179,0181,0182,0191,0219,0241,0251,0252,0253,0272,0291,0711,0721,0722,0723,0724,0741,0751,0762,0781,0782,0783,0811,0831,0851,0971,1000,1011,1021,1031,1040,1041,1044,1061,1081,1094,1099,1220,1221,1222,1241,1411,1422,1423,1429,1442,1446,1459,1474,1479,1481,1499,2211,2221,2241,2250,2251,2253,2254,2261,2273,2281,2282,2287,2295,2297,2299,2411,2421,2426,2429,2431,2434,2435,2439,2441,2448,2451,2452,2491,2493,2499,2611,2621,2631,2650,2652,2653,2655,2656,2670,2671,2672,2673,2674,2675,2676,2677,2678,2679,2800,2812,2813,2816,2819,2821,2822,2823,2824,2836,2841,2842,2843,2844,2851,2861,2865,2869,2873,2874,2875,2879,2891,2892,2895,2899,3000,3011,3053,3060,3061,3069,3081,3082,3083,3084,3085,3086,3088,3089,3312,3313,3315,3316,3317,3321,3322,3324,3325,3331,3334,3339,3341,3350,3351,3353,3354,3355,3356,3357,3363,3364,3365,3369,3375,3398,3399'),
	
	    'CG': toArray('2000,2005,2011,2013,2015,2020,2021,2022,2023,2024,2026,2030,2032,2033,2034,2035,2037,2038,2040,2041,2043,2044,2046,2047,2048,2051,2052,2061,2062,2063,2064,2066,2067,2074,2075,2076,2077,2079,2082,2084,2085,2086,2087,2090,2091,2092,2095,2096,2097,2098,2099,2111,2121,2131,2141,2311,2321,2322,2325,2326,2329,2331,2337,2339,2341,2353,2381,2385,2389,2392,2396,2399,2500,2511,2512,2514,2515,2519,2521,2522,2531,2541,2542,2591,2599,3021,3142,3143,3144,3149,3151,3161,3199,3211,3221,3229,3231,3241,3251,3253,3255,3261,3262,3264,3271,3272,3273,3275,3290,3291,3295,3296,3297,3299,3400,3411,3412,3420,3421,3423,3425,3429,3431,3432,3433,3441,3442,3443,3444,3448,3449,3451,3452,3460,3462,3463,3465,3469,3479,3482,3483,3484,3489,3490,3491,3492,3493,3494,3495,3496,3498,3499,3911,3914,3931,3942,3944,3949,3952,3965,3990,3993,3995,3996,3999,5110,5111,5112,5113,5131,5136,5137,5139,5141,5142,5143,5144,5145,5146,5147,5148,5149,5153,5159,5162,5166,5169,5171,5172,5181,5182,5191,5192,5193,5194,5198,5199'),
	
	    'CS': toArray('2711,2721,2731,2732,2741,2752,2754,2759,2761,2771,2782,2789,2796,4311,5000,5010,5012,5013,5014,5015,5021,5023,5031,5032,5033,5039,5043,5044,5045,5046,5048,5049,5051,5052,5053,5063,5064,5065,5072,5074,5075,5078,5082,5083,5084,5085,5087,5088,5091,5092,5093,5094,5099,5211,5231,5251,5261,5271,5311,5331,5399,5400,5411,5431,5441,5451,5461,5499,5500,5511,5521,5531,5541,5551,5561,5571,5611,5621,5632,5641,5651,5661,5699,5712,5713,5714,5719,5722,5731,5734,5735,5736,5812,5813,5821,5921,5932,5941,5942,5943,5944,5945,5946,5947,5948,5949,5961,5962,5963,5983,5984,5989,5990,5995,5999,7010,7011,7021,7032,7041,7200,7210,7211,7213,7215,7218,7219,7231,7261,7279,7299,7623,7629,7699,7812,7819,7822,7830,7832,7833,7841'),
	
	    'FI': toArray('6000,6010,6011,6019,6020,6021,6022,6026,6029,6035,6036,6045,6047,6061,6062,6081,6082,6091,6099,6111,6141,6153,6158,6159,6162,6163,6172,6189,6199,6200,6211,6221,6231,6268,6282,6283,6289,6311,6331,6350,6351,6361,6371,6399,6411,6500,6512,6513,6514,6515,6519,6531,6541,6552,6553,6712,6719,6722,6726,6727,6731,6732,6733,6742,6790,6792,6794,6798,6799'),
	
	    'HC': toArray('2833,2834,2835,3841,3842,3843,3844,3845,5047,5122,5912,6321,6324,7352,8011,8021,8049,8051,8052,8059,8062,8063,8069,8071,8082,8092,8093,8099'),
	
	    'IN': toArray('1521,1522,1531,1541,1542,1600,1611,1622,1623,1629,1711,1731,1741,1742,1751,1761,1771,1781,1791,1793,1794,1795,1796,1799,3511,3519,3523,3524,3531,3532,3534,3535,3536,3537,3541,3542,3543,3544,3545,3546,3547,3548,3549,3552,3554,3555,3556,3559,3561,3562,3563,3564,3565,3566,3567,3568,3569,3578,3579,3581,3582,3585,3586,3589,3590,3592,3593,3594,3596,3599,3812,3821,3822,3823,3824,3825,3826,3827,3829,3851,3861,3873'),
	
	    'OG': toArray('1310,1311,1321,1381,1382,1389,2911,2950,2951,2952,2992,2999,3533,4612,4613,4619,4922,4923,4924,4925,4932'),
	
	    'OT': toArray('7900,7922,7929,7933,7941,7948,7990,7991,7992,7993,7996,7997,7999,8111,8211,8221,8222,8231,8243,8244,8249,8299,8319,8322,8331,8351,8361,8399,8412,8422,8611,8621,8641,8651,8661,8699,8711,8712,8721,8731,8732,8733,8734,8741,8742,8743,8744,8748,8749,8811,8880,8881,8990,8999,9100,9111,9121,9131,9191,9199,9222,9223,9311,9411,9441,9511,9531,9532,9611,9621,9631,9641,9651,9661,9711,9721,9999'),
	
	    'TY': toArray('3570,3571,3572,3575,3576,3577,3612,3613,3621,3624,3625,3629,3631,3632,3633,3634,3639,3641,3643,3644,3645,3646,3651,3652,3661,3663,3669,3671,3672,3674,3675,3676,3677,3678,3679,3691,3692,3694,3695,3699,7310,7311,7312,7313,7319,7322,7323,7331,7334,7336,7338,7349,7353,7359,7361,7363,7371,7372,7373,7374,7375,7376,7377,7378,7379,7381,7382,7384,7389'),
	
	    'TE': toArray('4811,4812,4813,4820,4822,4832,4833,4841,4899'),
	
	    'TR': toArray('3711,3713,3714,3715,3716,3721,3724,3728,3731,3732,3743,3751,3761,3764,3792,3795,3799,4011,4013,4111,4119,4131,4141,4142,4151,4173,4212,4213,4215,4220,4221,4222,4225,4226,4231,4412,4424,4432,4449,4481,4482,4489,4491,4492,4493,4499,4512,4513,4522,4581,4593,4724,4725,4729,4731,4741,4783,4785,4789,7510,7513,7514,7515,7519,7521,7533,7534,7536,7537,7538,7539,7542,7549'),
	
	    'UT': toArray('4900,4911,4931,4939,4941,4950,4952,4953,4959,4961,4971,4991')
	};
	
	var CORP_SIC_CODES_LENGTH = exports.CORP_SIC_CODES_LENGTH = Object.values(SIC_CODES).reduce(function (x, a) {
	    return x + a.length;
	}, 0);
	
	var CORP_SECTOR_LABELS = exports.CORP_SECTOR_LABELS = {
	    'BM': 'Basic Materials',
	    'CG': 'Consumer Goods',
	    'CS': 'Consumer Services',
	    'FI': 'Financials',
	    'HC': 'Healthcare',
	    'IN': 'Industrials',
	    'OG': 'Oil & Gas',
	    'OT': 'Other',
	    'TY': 'Technology',
	    'TE': 'Telecommunications',
	    'TR': 'Transportation',
	    'UT': 'Utilities'
	};
	
	var CORP_SECTORS = exports.CORP_SECTORS = [{ value: 'holdCorpSectorCode=BM', sic_code: SIC_CODES.BM, label: CORP_SECTOR_LABELS.BM }, { value: 'holdCorpSectorCode=CG', sic_code: SIC_CODES.CG, label: CORP_SECTOR_LABELS.CG }, { value: 'holdCorpSectorCode=CS', sic_code: SIC_CODES.CS, label: CORP_SECTOR_LABELS.CS }, { value: 'holdCorpSectorCode=FI', sic_code: SIC_CODES.FI, label: CORP_SECTOR_LABELS.FI }, { value: 'holdCorpType=Foreign', label: 'Foreign Issuers' }, { value: 'holdCorpSectorCode=HC', sic_code: SIC_CODES.HC, label: CORP_SECTOR_LABELS.HC }, { value: 'holdCorpSectorCode=IN', sic_code: SIC_CODES.IN, label: CORP_SECTOR_LABELS.IN }, { value: 'holdCorpSectorCode=OG', sic_code: SIC_CODES.OG, label: CORP_SECTOR_LABELS.OG }, { value: 'holdCorpSectorCode=OT', sic_code: SIC_CODES.OT, label: CORP_SECTOR_LABELS.OT }, { value: 'holdCorpSectorCode=TY', sic_code: SIC_CODES.TY, label: CORP_SECTOR_LABELS.TY }, { value: 'holdCorpSectorCode=TE', sic_code: SIC_CODES.TE, label: CORP_SECTOR_LABELS.TE }, { value: 'holdCorpSectorCode=TR', sic_code: SIC_CODES.TR, label: CORP_SECTOR_LABELS.TR }, { value: 'holdCorpSectorCode=UT', sic_code: SIC_CODES.UT, label: CORP_SECTOR_LABELS.UT }].map(function (a) {
	    a.display = a.label;
	    return a;
	});

/***/ },
/* 1208 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALUES = [{ display: 'Zero', value: 'ZR' }, { display: 'Fixed, Non-Zero', value: 'FNZR' }, { display: 'Fixed to Float, Fixed', value: 'F2FF' }, { display: 'Floating', value: 'FLT' }, { display: 'Multi-Step', value: 'MULTI-STEP' }];
	
	var COUPON_FEATURES = exports.COUPON_FEATURES = VALUES.map(function (_ref) {
	    var value = _ref.value,
	        display = _ref.display;
	
	    return {
	        label: display,
	        display: display,
	        value: 'holdCouponTypeCode=' + value
	    };
	});
	
	var COUPON_FEATURE_LABELS = exports.COUPON_FEATURE_LABELS = Object.fromEntries(VALUES.map(function (a) {
	    return [a.value, a.display];
	}));
	
	var COUPON_TYPE_LABELS = exports.COUPON_TYPE_LABELS = {
	    "1": "Adj Rate",
	    "2": "Stripped Conv",
	    "3": "Deferred Int",
	    "4": "Floating Rate at Floor",
	    "5": "Floating Rate",
	    "6": "Inv Floating",
	    "7": "Linked Inv Floater",
	    "8": "Flexible Rate",
	    "9": "O.I.D.",
	    "A": "Regular",
	    "B": "Zero Coupon",
	    "C": "Payment-in-Kind",
	    "D": "Stepped: Known Future Coupon Rates",
	    "E": "Variable or Floating",
	    "F": "Interest-at-Maturity",
	    "G": "Stepped Payment-in-Kind",
	    "H": "Variable Payment-in-Kind",
	    "I": "Stepped Interest-at-Maturity",
	    "J": "Variable Interest-at-Maturity",
	    "K": "Credit Sensitive",
	    "L": "Credit Sensitive Variable or Reset",
	    "M": "Short-term Discount Interest",
	    "N": "Fixed rate of interest",
	    "O": "Stripped Coupon Pay",
	    "S": "Stripped Coupon",
	    "T": "Floating Auction Rate",
	    "X": "Stripped Prin",
	    "Y": "Reserve CUSIP",
	    "Z": "Other situation"
	};
	
	var COUPON_DAY_COUNT_LABELS = exports.COUPON_DAY_COUNT_LABELS = {
	    "1": "30/360",
	    "2": "Actual",
	    "3": "Actual/360",
	    "5": "Actual/365",
	    "6": "30E/360",
	    "8": "Changeable",
	    "9": "Not available"
	};

/***/ },
/* 1209 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALUES = [{ display: 'Monthly', value: 'M' }, { display: 'Quarterly', value: 'Q' }, { display: 'Semi-Annual', value: 'S' }, { display: 'Annual', value: 'A' }, { display: 'At Maturity', value: 'F' }];
	
	var COUPON_FREQUENCIES = exports.COUPON_FREQUENCIES = VALUES.map(function (_ref) {
	    var value = _ref.value,
	        display = _ref.display;
	
	    return {
	        label: display,
	        display: display,
	        value: 'holdCouponPayFrequency=' + value
	    };
	});
	
	var COUPON_FREQUENCY_LABELS = exports.COUPON_FREQUENCY_LABELS = Object.fromEntries(VALUES.map(function (a) {
	    return [a.value, a.display];
	}));

/***/ },
/* 1210 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALUES = exports.VALUES = [{ display: 'January', value: '1' }, { display: 'February', value: '2' }, { display: 'March', value: '3' }, { display: 'April', value: '4' }, { display: 'May', value: '5' }, { display: 'June', value: '6' }, { display: 'July', value: '7' }, { display: 'August', value: '8' }, { display: 'September', value: '9' }, { display: 'October', value: '10' }, { display: 'November', value: '11' }, { display: 'December', value: '12' }];
	
	var COUPON_MONTHS = exports.COUPON_MONTHS = VALUES.map(function (_ref) {
	    var value = _ref.value,
	        display = _ref.display;
	
	    return {
	        label: display,
	        display: display,
	        value: 'holdCouponPayMonths=' + value
	    };
	});
	
	var COUPON_MONTH_LABELS = exports.COUPON_MONTH_LABELS = Object.fromEntries(VALUES.map(function (a) {
	    return [a.value, a.display];
	}));

/***/ },
/* 1211 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MARKET_TYPES = exports.MARKET_TYPES = [{ display: 'New Issue', value: 'primary' }, { display: 'Secondary', value: 'secondary' }].map(function (a) {
	    a.label = a.display;
	    a.value = 'primarySecondary=' + a.value;
	    return a;
	});

/***/ },
/* 1212 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MUNI_CATEGORIES = exports.MUNI_CATEGORIES = [{ display: 'General Obligation', value: 'holdMuniType=G' }, { display: 'Revenue', value: 'holdMuniType=R' }, { display: 'Refunded', value: 'holdRefundInd=Y' }, { display: 'Pre-Refunded', value: 'holdRefundType=PRE', oneOf: 'holdRefundInd=Y' }, { display: 'Escrowed to maturity', value: 'holdRefundType=ETM', oneOf: 'holdRefundInd=Y' }].map(function (a) {
	    a.label = a.display;
	    return a;
	});
	
	var MUNI_CATEGORY_LABELS = exports.MUNI_CATEGORY_LABELS = {
	    "R": "Revenue",
	    "G": "General Obligation"
	};

/***/ },
/* 1213 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MUNI_DEMINIMIS = exports.MUNI_DEMINIMIS = [{ display: 'Above De Minimis Only', value: 'offeringDeMinStatus=above' }, { display: 'Below De Minimis Only', value: 'offeringDeMinStatus=below' }].map(function (a) {
	    a.label = a.display;
	    return a;
	});

/***/ },
/* 1214 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var VALUES = [{ display: 'Green Bond', value: 'Green' }, { display: 'New Clean Renewable Energy - Tax Credit', value: 'NCREB' }, { display: 'New Clean Renewable Energy - Direct', value: 'NCRED' }, { display: 'Qualified Energy Conservation - Tax Credit', value: 'QECB' }, { display: 'Qualified Energy Conservation - Direct', value: 'QECBD' }];
	
	var MUNI_ENVIRONMENTALS = exports.MUNI_ENVIRONMENTALS = VALUES.map(function (_ref) {
	    var value = _ref.value,
	        display = _ref.display;
	
	    return {
	        label: display,
	        display: display,
	        value: 'holdIssueType=' + value
	    };
	});
	
	var MUNI_ENVIRONMENTAL_LABELS = exports.MUNI_ENVIRONMENTAL_LABELS = Object.fromEntries(VALUES.map(function (a) {
	    return [a.value, a.display];
	}));

/***/ },
/* 1215 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MUNI_PURPOSES = exports.MUNI_PURPOSES = [{ label: 'Agriculture', value: 'holdUseOfProceeds=Agriculture' }, { label: 'Education', value: 'holdUseOfProceeds=Education' }, { label: 'Government', value: 'holdUseOfProceeds=Government' }, { label: 'Healthcare', value: 'holdUseOfProceeds=Healthcare' }, { label: 'Housing', value: 'holdUseOfProceeds=Housing' }, { label: 'Industrial', value: 'holdUseOfProceeds=Industrial' }, { label: 'Recreation', value: 'holdUseOfProceeds=Recreation' }, { label: 'Transportation', value: 'holdUseOfProceeds=Transportation' }, { label: 'Utilities', value: 'holdUseOfProceeds=Utilities' }];

/***/ },
/* 1216 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var MUNI_TAXABILITIES = exports.MUNI_TAXABILITIES = [{ display: 'Federally Taxable', value: 'holdTaxable=Y' }, { display: 'Build America Bonds', value: 'holdTaxable=BAB', oneOf: 'holdTaxable=Y' }, { display: 'Federally Tax-Exempt', value: 'holdTaxable=N' }, { display: 'State Taxable', value: 'holdStateTaxExempt=N' }, { display: 'State Tax-Exempt', value: 'holdStateTaxExempt=Y' }, { display: 'Subject to AMT', value: 'holdAltMinTax=Y' }, { display: 'Exempt from AMT', value: 'holdAltMinTax=N' }].map(function (a) {
	    a.label = a.display;
	    return a;
	});

/***/ },
/* 1217 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var sortByLabel = function sortByLabel(a, b) {
	    var x = a.label;
	    var y = b.label;
	    return x > y ? 1 : x < y ? -1 : 0;
	};
	var mapLabel = function mapLabel(a) {
	    a.label = a.display;
	    return a;
	};
	
	var STATES = exports.STATES = [{ display: 'Alabama', value: 'AL' }, { display: 'Alaska', value: 'AK' }, { display: 'Arizona', value: 'AZ' }, { display: 'Arkansas', value: 'AR' }, { display: 'California', value: 'CA' }, { display: 'Colorado', value: 'CO' }, { display: 'Connecticut', value: 'CT' }, { display: 'Delaware', value: 'DE' }, { display: 'Dist of Columbia', value: 'DC' }, { display: 'Florida', value: 'FL' }, { display: 'Georgia', value: 'GA' }, { display: 'Hawaii', value: 'HI' }, { display: 'Idaho', value: 'ID' }, { display: 'Illinois', value: 'IL' }, { display: 'Indiana', value: 'IN' }, { display: 'Iowa', value: 'IA' }, { display: 'Kansas', value: 'KS' }, { display: 'Kentucky', value: 'KY' }, { display: 'Louisiana', value: 'LA' }, { display: 'Maine', value: 'ME' }, { display: 'Maryland', value: 'MD' }, { display: 'Massachusetts', value: 'MA' }, { display: 'Michigan', value: 'MI' }, { display: 'Minnesota', value: 'MN' }, { display: 'Mississippi', value: 'MS' }, { display: 'Missouri', value: 'MO' }, { display: 'Montana', value: 'MT' }, { display: 'Nebraska', value: 'NE' }, { display: 'Nevada', value: 'NV' }, { display: 'New Hampshire', value: 'NH' }, { display: 'New Jersey', value: 'NJ' }, { display: 'New Mexico', value: 'NM' }, { display: 'New York', value: 'NY' }, { display: 'North Carolina', value: 'NC' }, { display: 'North Dakota', value: 'ND' }, { display: 'Ohio', value: 'OH' }, { display: 'Oklahoma', value: 'OK' }, { display: 'Oregon', value: 'OR' }, { display: 'Pennsylvania', value: 'PA' }, { display: 'Rhode Island', value: 'RI' }, { display: 'South Carolina', value: 'SC' }, { display: 'South Dakota', value: 'SD' }, { display: 'Tennessee', value: 'TN' }, { display: 'Texas', value: 'TX' }, { display: 'Utah', value: 'UT' }, { display: 'Vermont', value: 'VT' }, { display: 'Virginia', value: 'VA' }, { display: 'Washington', value: 'WA' }, { display: 'West Virginia', value: 'WV' }, { display: 'Wisconsin', value: 'WI' }, { display: 'Wyoming', value: 'WY' }].map(mapLabel).sort(sortByLabel);
	
	var TERRITORIES = exports.TERRITORIES = [{ display: 'American Samoa', value: 'AS' }, { display: 'Guam', value: 'GU' }, { display: 'Puerto Rico', value: 'PR' }, { display: 'Virgin Islands', value: 'VI' }].map(mapLabel).sort(sortByLabel);
	
	var STATES_AND_TERRITORIES = exports.STATES_AND_TERRITORIES = STATES.concat(TERRITORIES).sort(sortByLabel);
	
	var STATE_NAMES = exports.STATE_NAMES = STATES_AND_TERRITORIES.reduce(function (x, a) {
	    return Object.assign({}, x, _defineProperty({}, a.value, a.label));
	}, {});
	
	var mapCD = function mapCD(a) {
	    return Object.assign({}, a, {
	        value: 'holdBlueSkyStateCD=' + encodeURIComponent(a.value)
	    });
	};
	var CD_STATES = exports.CD_STATES = STATES.map(mapCD);
	var CD_TERRITORIES = exports.CD_TERRITORIES = TERRITORIES.map(mapCD);
	var CD_STATES_AND_TERRITORIES = exports.CD_STATES_AND_TERRITORIES = STATES_AND_TERRITORIES.map(mapCD);
	
	var mapMuni = function mapMuni(a) {
	    return Object.assign({}, a, {
	        value: 'holdState=' + encodeURIComponent(a.value)
	    });
	};
	var MUNI_STATES = exports.MUNI_STATES = STATES.map(mapMuni);
	var MUNI_TERRITORIES = exports.MUNI_TERRITORIES = TERRITORIES.map(mapMuni);
	var MUNI_STATES_AND_TERRITORIES = exports.MUNI_STATES_AND_TERRITORIES = STATES_AND_TERRITORIES.map(mapMuni);

/***/ },
/* 1218 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var TREASURY_TYPES = exports.TREASURY_TYPES = [{ value: 'Bills', display: 'Bills' }, { value: 'Notes', display: 'Notes' }, { value: 'Bonds', display: 'Bonds' }, { value: 'FRN', display: 'FRN' }, { value: 'TIPS', display: 'TIPS' }, { value: 'STRIPS', display: 'STRIPS' }].map(function (a) {
	    a.label = a.display;
	    a.value = 'holdTreasuryType=' + encodeURIComponent(a.value);
	    return a;
	});

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1220);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1220 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1221 */
/***/ function(module, exports) {

	'use strict';
	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    if(a===b) {
	      return [ai, bi];
	    }
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 1222 */
/***/ function(module, exports) {

	/*!
	 * Bootstrap v3.4.1 (https://getbootstrap.com/)
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under the MIT license
	 */
	
	if (typeof jQuery === 'undefined') {
	  throw new Error('Bootstrap\'s JavaScript requires jQuery')
	}
	
	+function ($) {
	  'use strict';
	  var version = $.fn.jquery.split(' ')[0].split('.')
	  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
	    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
	  }
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: alert.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.4.1'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    selector    = selector === '#' ? [] : selector
	    var $parent = $(document).find(selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: carousel.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.4.1'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      if (typeof $next === 'object' && $next.length) {
	        $next[0].offsetWidth // force reflow
	      }
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    if (href) {
	      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	    }
	
	    var target  = $this.attr('data-target') || href
	    var $target = $(document).find(target)
	
	    if (!$target.hasClass('carousel')) return
	
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tooltip.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	+function ($) {
	  'use strict';
	
	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']
	
	  var uriAttrs = [
	    'background',
	    'cite',
	    'href',
	    'itemtype',
	    'longdesc',
	    'poster',
	    'src',
	    'xlink:href'
	  ]
	
	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i
	
	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []
	  }
	
	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi
	
	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i
	
	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase()
	
	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
	      }
	
	      return true
	    }
	
	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp
	    })
	
	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true
	      }
	    }
	
	    return false
	  }
	
	  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	    if (unsafeHtml.length === 0) {
	      return unsafeHtml
	    }
	
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeHtml)
	    }
	
	    // IE 8 and below don't support createHTMLDocument
	    if (!document.implementation || !document.implementation.createHTMLDocument) {
	      return unsafeHtml
	    }
	
	    var createdDocument = document.implementation.createHTMLDocument('sanitization')
	    createdDocument.body.innerHTML = unsafeHtml
	
	    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
	    var elements = $(createdDocument.body).find('*')
	
	    for (var i = 0, len = elements.length; i < len; i++) {
	      var el = elements[i]
	      var elName = el.nodeName.toLowerCase()
	
	      if ($.inArray(elName, whitelistKeys) === -1) {
	        el.parentNode.removeChild(el)
	
	        continue
	      }
	
	      var attributeList = $.map(el.attributes, function (el) { return el })
	      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])
	
	      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
	        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
	          el.removeAttribute(attributeList[j].nodeName)
	        }
	      }
	    }
	
	    return createdDocument.body.innerHTML
	  }
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.4.1'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    },
	    sanitize : true,
	    sanitizeFn : null,
	    whiteList : DefaultWhitelist
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    var dataAttributes = this.$element.data()
	
	    for (var dataAttr in dataAttributes) {
	      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	        delete dataAttributes[dataAttr]
	      }
	    }
	
	    options = $.extend({}, this.getDefaults(), dataAttributes, options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    if (options.sanitize) {
	      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    if (this.options.html) {
	      if (this.options.sanitize) {
	        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
	      }
	
	      $tip.find('.tooltip-inner').html(title)
	    } else {
	      $tip.find('.tooltip-inner').text(title)
	    }
	
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
	    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
	  }
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: popover.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.4.1'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    if (this.options.html) {
	      var typeContent = typeof content
	
	      if (this.options.sanitize) {
	        title = this.sanitizeHtml(title)
	
	        if (typeContent === 'string') {
	          content = this.sanitizeHtml(content)
	        }
	      }
	
	      $tip.find('.popover-title').html(title)
	      $tip.find('.popover-content').children().detach().end()[
	        typeContent === 'string' ? 'html' : 'append'
	      ](content)
	    } else {
	      $tip.find('.popover-title').text(title)
	      $tip.find('.popover-content').children().detach().end().text(content)
	    }
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	        o.content.call($e[0]) :
	        o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.4.1'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	
	/* ========================================================================
	 * Bootstrap: affix.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)
	
	    this.$target = target
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.4.1'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1553);
	
	module.exports = parent;


/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1555);
	__webpack_require__(1478);
	
	module.exports = parent;


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1556);
	__webpack_require__(1494);
	__webpack_require__(1500);
	__webpack_require__(1502);
	__webpack_require__(1504);
	__webpack_require__(1506);
	__webpack_require__(1513);
	__webpack_require__(1515);
	
	module.exports = parent;


/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1557);
	
	__webpack_require__(1470);
	__webpack_require__(1516);
	__webpack_require__(1518);
	__webpack_require__(1525);
	
	module.exports = parent;


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(215);
	__webpack_require__(568);
	var path = __webpack_require__(106);
	
	module.exports = path.Array.from;


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(175);
	__webpack_require__(571);
	__webpack_require__(371);
	__webpack_require__(270);
	__webpack_require__(215);
	var path = __webpack_require__(106);
	
	module.exports = path.Map;


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(575);
	__webpack_require__(576);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(587);
	__webpack_require__(372);
	__webpack_require__(588);
	var path = __webpack_require__(106);
	
	module.exports = path.Math;


/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(589);
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(592);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(598);
	__webpack_require__(599);
	__webpack_require__(600);
	__webpack_require__(601);
	var path = __webpack_require__(106);
	
	module.exports = path.Number;


/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(175);
	__webpack_require__(270);
	__webpack_require__(603);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(379);
	__webpack_require__(380);
	__webpack_require__(215);
	var path = __webpack_require__(106);
	
	module.exports = path.Set;


/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(567);
	__webpack_require__(270);
	__webpack_require__(609);
	__webpack_require__(604);
	__webpack_require__(605);
	__webpack_require__(606);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(611);
	__webpack_require__(610);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(614);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(617);
	__webpack_require__(618);
	__webpack_require__(570);
	__webpack_require__(372);
	__webpack_require__(602);
	var path = __webpack_require__(106);
	
	module.exports = path.Symbol;


/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(1237);


/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(1238);


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(1239);


/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(1240);


/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1223);
	
	module.exports = parent;


/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1224);
	__webpack_require__(1477);
	__webpack_require__(1485);
	__webpack_require__(1471);
	__webpack_require__(1472);
	__webpack_require__(1473);
	__webpack_require__(1474);
	__webpack_require__(1476);
	__webpack_require__(1475);
	__webpack_require__(1479);
	__webpack_require__(1480);
	__webpack_require__(1481);
	__webpack_require__(1482);
	__webpack_require__(1483);
	__webpack_require__(1484);
	__webpack_require__(1486);
	__webpack_require__(1487);
	__webpack_require__(1489);
	// TODO: remove from `core-js@4`
	__webpack_require__(1490);
	// TODO: remove from `core-js@4`
	__webpack_require__(1488);
	
	module.exports = parent;


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1225);
	__webpack_require__(1498);
	__webpack_require__(1509);
	__webpack_require__(1491);
	__webpack_require__(1492);
	__webpack_require__(1495);
	__webpack_require__(1493);
	__webpack_require__(1496);
	__webpack_require__(1497);
	__webpack_require__(1499);
	__webpack_require__(1501);
	__webpack_require__(1503);
	__webpack_require__(1505);
	__webpack_require__(1507);
	__webpack_require__(1508);
	__webpack_require__(1510);
	__webpack_require__(1511);
	__webpack_require__(1512);
	__webpack_require__(1514);
	
	module.exports = parent;


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1226);
	__webpack_require__(1519);
	__webpack_require__(1521);
	__webpack_require__(1517);
	__webpack_require__(1526);
	// TODO: Remove from `core-js@4`
	__webpack_require__(1520);
	__webpack_require__(1522);
	__webpack_require__(1523);
	__webpack_require__(1524);
	__webpack_require__(1527);
	__webpack_require__(1528);
	
	module.exports = parent;


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isArray = __webpack_require__(122);
	var isConstructor = __webpack_require__(167);
	var isObject = __webpack_require__(20);
	var wellKnownSymbol = __webpack_require__(21);
	
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	
	// a part of `ArraySpeciesCreate` abstract operation
	// https://tc39.es/ecma262/#sec-arrayspeciescreate
	module.exports = function (originalArray) {
	  var C;
	  if (isArray(originalArray)) {
	    C = originalArray.constructor;
	    // cross-realm fallback
	    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
	    else if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? $Array : C;
	};


/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(18);
	var iteratorClose = __webpack_require__(254);
	
	// call something on iterator step with safe closing on error
	module.exports = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose(iterator, 'throw', error);
	  }
	};


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var padStart = __webpack_require__(364).start;
	
	var $RangeError = RangeError;
	var $isFinite = isFinite;
	var abs = Math.abs;
	var DatePrototype = Date.prototype;
	var nativeDateToISOString = DatePrototype.toISOString;
	var thisTimeValue = uncurryThis(DatePrototype.getTime);
	var getUTCDate = uncurryThis(DatePrototype.getUTCDate);
	var getUTCFullYear = uncurryThis(DatePrototype.getUTCFullYear);
	var getUTCHours = uncurryThis(DatePrototype.getUTCHours);
	var getUTCMilliseconds = uncurryThis(DatePrototype.getUTCMilliseconds);
	var getUTCMinutes = uncurryThis(DatePrototype.getUTCMinutes);
	var getUTCMonth = uncurryThis(DatePrototype.getUTCMonth);
	var getUTCSeconds = uncurryThis(DatePrototype.getUTCSeconds);
	
	// `Date.prototype.toISOString` method implementation
	// https://tc39.es/ecma262/#sec-date.prototype.toisostring
	// PhantomJS / old WebKit fails here:
	module.exports = (fails(function () {
	  return nativeDateToISOString.call(new Date(-5e13 - 1)) !== '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  nativeDateToISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!$isFinite(thisTimeValue(this))) throw new $RangeError('Invalid time value');
	  var date = this;
	  var year = getUTCFullYear(date);
	  var milliseconds = getUTCMilliseconds(date);
	  var sign = year < 0 ? '-' : year > 9999 ? '+' : '';
	  return sign + padStart(abs(year), sign ? 6 : 4, 0) +
	    '-' + padStart(getUTCMonth(date) + 1, 2, 0) +
	    '-' + padStart(getUTCDate(date), 2, 0) +
	    'T' + padStart(getUTCHours(date), 2, 0) +
	    ':' + padStart(getUTCMinutes(date), 2, 0) +
	    ':' + padStart(getUTCSeconds(date), 2, 0) +
	    '.' + padStart(milliseconds, 3, 0) +
	    'Z';
	} : nativeDateToISOString;


/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(18);
	var ordinaryToPrimitive = __webpack_require__(538);
	
	var $TypeError = TypeError;
	
	// `Date.prototype[@@toPrimitive](hint)` method implementation
	// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
	module.exports = function (hint) {
	  anObject(this);
	  if (hint === 'string' || hint === 'default') hint = 'string';
	  else if (hint !== 'number') throw new $TypeError('Incorrect hint');
	  return ordinaryToPrimitive(this, hint);
	};


/***/ },
/* 1245 */
/***/ function(module, exports) {

	'use strict';
	/* global Bun -- Bun case */
	module.exports = typeof Bun == 'function' && Bun && typeof Bun.version == 'string';


/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(103);
	
	module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var userAgent = __webpack_require__(103);
	
	module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	
	module.exports = function (CONSTRUCTOR, METHOD) {
	  var Constructor = global[CONSTRUCTOR];
	  var Prototype = Constructor && Constructor.prototype;
	  return Prototype && Prototype[METHOD];
	};


/***/ },
/* 1249 */
/***/ function(module, exports) {

	'use strict';
	// `GetIteratorDirect(obj)` abstract operation
	// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
	module.exports = function (obj) {
	  return {
	    iterator: obj,
	    next: obj.next,
	    done: false
	  };
	};


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var isArray = __webpack_require__(122);
	var isCallable = __webpack_require__(22);
	var classof = __webpack_require__(61);
	var toString = __webpack_require__(17);
	
	var push = uncurryThis([].push);
	
	module.exports = function (replacer) {
	  if (isCallable(replacer)) return replacer;
	  if (!isArray(replacer)) return;
	  var rawLength = replacer.length;
	  var keys = [];
	  for (var i = 0; i < rawLength; i++) {
	    var element = replacer[i];
	    if (typeof element == 'string') push(keys, element);
	    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
	  }
	  var keysLength = keys.length;
	  var root = true;
	  return function (key, value) {
	    if (root) {
	      root = false;
	      return value;
	    }
	    if (isArray(this)) return value;
	    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
	  };
	};


/***/ },
/* 1251 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (a, b) {
	  try {
	    // eslint-disable-next-line no-console -- safe
	    arguments.length === 1 ? console.error(a) : console.error(a, b);
	  } catch (error) { /* empty */ }
	};


/***/ },
/* 1252 */
/***/ function(module, exports) {

	'use strict';
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var $Array = Array;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	
	var pack = function (number, mantissaLength, bytes) {
	  var buffer = $Array(bytes);
	  var exponentLength = bytes * 8 - mantissaLength - 1;
	  var eMax = (1 << exponentLength) - 1;
	  var eBias = eMax >> 1;
	  var rt = mantissaLength === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
	  var index = 0;
	  var exponent, mantissa, c;
	  number = abs(number);
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (number !== number || number === Infinity) {
	    // eslint-disable-next-line no-self-compare -- NaN check
	    mantissa = number !== number ? 1 : 0;
	    exponent = eMax;
	  } else {
	    exponent = floor(log(number) / LN2);
	    c = pow(2, -exponent);
	    if (number * c < 1) {
	      exponent--;
	      c *= 2;
	    }
	    if (exponent + eBias >= 1) {
	      number += rt / c;
	    } else {
	      number += rt * pow(2, 1 - eBias);
	    }
	    if (number * c >= 2) {
	      exponent++;
	      c /= 2;
	    }
	    if (exponent + eBias >= eMax) {
	      mantissa = 0;
	      exponent = eMax;
	    } else if (exponent + eBias >= 1) {
	      mantissa = (number * c - 1) * pow(2, mantissaLength);
	      exponent += eBias;
	    } else {
	      mantissa = number * pow(2, eBias - 1) * pow(2, mantissaLength);
	      exponent = 0;
	    }
	  }
	  while (mantissaLength >= 8) {
	    buffer[index++] = mantissa & 255;
	    mantissa /= 256;
	    mantissaLength -= 8;
	  }
	  exponent = exponent << mantissaLength | mantissa;
	  exponentLength += mantissaLength;
	  while (exponentLength > 0) {
	    buffer[index++] = exponent & 255;
	    exponent /= 256;
	    exponentLength -= 8;
	  }
	  buffer[--index] |= sign * 128;
	  return buffer;
	};
	
	var unpack = function (buffer, mantissaLength) {
	  var bytes = buffer.length;
	  var exponentLength = bytes * 8 - mantissaLength - 1;
	  var eMax = (1 << exponentLength) - 1;
	  var eBias = eMax >> 1;
	  var nBits = exponentLength - 7;
	  var index = bytes - 1;
	  var sign = buffer[index--];
	  var exponent = sign & 127;
	  var mantissa;
	  sign >>= 7;
	  while (nBits > 0) {
	    exponent = exponent * 256 + buffer[index--];
	    nBits -= 8;
	  }
	  mantissa = exponent & (1 << -nBits) - 1;
	  exponent >>= -nBits;
	  nBits += mantissaLength;
	  while (nBits > 0) {
	    mantissa = mantissa * 256 + buffer[index--];
	    nBits -= 8;
	  }
	  if (exponent === 0) {
	    exponent = 1 - eBias;
	  } else if (exponent === eMax) {
	    return mantissa ? NaN : sign ? -Infinity : Infinity;
	  } else {
	    mantissa += pow(2, mantissaLength);
	    exponent -= eBias;
	  } return (sign ? -1 : 1) * mantissa * pow(2, exponent - mantissaLength);
	};
	
	module.exports = {
	  pack: pack,
	  unpack: unpack
	};


/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var classof = __webpack_require__(92);
	var hasOwn = __webpack_require__(28);
	var isNullOrUndefined = __webpack_require__(66);
	var wellKnownSymbol = __webpack_require__(21);
	var Iterators = __webpack_require__(168);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var $Object = Object;
	
	module.exports = function (it) {
	  if (isNullOrUndefined(it)) return false;
	  var O = $Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    || hasOwn(Iterators, classof(O));
	};


/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var sign = __webpack_require__(352);
	
	var abs = Math.abs;
	
	var EPSILON = 2.220446049250313e-16; // Number.EPSILON
	var INVERSE_EPSILON = 1 / EPSILON;
	
	var roundTiesToEven = function (n) {
	  return n + INVERSE_EPSILON - INVERSE_EPSILON;
	};
	
	module.exports = function (x, FLOAT_EPSILON, FLOAT_MAX_VALUE, FLOAT_MIN_VALUE) {
	  var n = +x;
	  var absolute = abs(n);
	  var s = sign(n);
	  if (absolute < FLOAT_MIN_VALUE) return s * roundTiesToEven(absolute / FLOAT_MIN_VALUE / FLOAT_EPSILON) * FLOAT_MIN_VALUE * FLOAT_EPSILON;
	  var a = (1 + FLOAT_EPSILON / EPSILON) * absolute;
	  var result = a - (a - absolute);
	  // eslint-disable-next-line no-self-compare -- NaN check
	  if (result > FLOAT_MAX_VALUE || result !== result) return s * Infinity;
	  return s * result;
	};


/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	
	var globalIsFinite = global.isFinite;
	
	// `Number.isFinite` method
	// https://tc39.es/ecma262/#sec-number.isfinite
	// eslint-disable-next-line es/no-number-isfinite -- safe
	module.exports = Number.isFinite || function isFinite(it) {
	  return typeof it == 'number' && globalIsFinite(it);
	};


/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var TO_STRING_TAG_SUPPORT = __webpack_require__(369);
	var classof = __webpack_require__(92);
	
	// `Object.prototype.toString` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.tostring
	module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
	  return '[object ' + classof(this) + ']';
	};


/***/ },
/* 1257 */
/***/ function(module, exports) {

	'use strict';
	// `SameValueZero` abstract operation
	// https://tc39.es/ecma262/#sec-samevaluezero
	module.exports = function (x, y) {
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return x === y || x !== x && y !== y;
	};


/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
	var uncurryThis = __webpack_require__(8);
	
	var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
	var base = 36;
	var tMin = 1;
	var tMax = 26;
	var skew = 38;
	var damp = 700;
	var initialBias = 72;
	var initialN = 128; // 0x80
	var delimiter = '-'; // '\x2D'
	var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
	var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
	var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
	var baseMinusTMin = base - tMin;
	
	var $RangeError = RangeError;
	var exec = uncurryThis(regexSeparators.exec);
	var floor = Math.floor;
	var fromCharCode = String.fromCharCode;
	var charCodeAt = uncurryThis(''.charCodeAt);
	var join = uncurryThis([].join);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var split = uncurryThis(''.split);
	var toLowerCase = uncurryThis(''.toLowerCase);
	
	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 */
	var ucs2decode = function (string) {
	  var output = [];
	  var counter = 0;
	  var length = string.length;
	  while (counter < length) {
	    var value = charCodeAt(string, counter++);
	    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
	      // It's a high surrogate, and there is a next character.
	      var extra = charCodeAt(string, counter++);
	      if ((extra & 0xFC00) === 0xDC00) { // Low surrogate.
	        push(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
	      } else {
	        // It's an unmatched surrogate; only append this code unit, in case the
	        // next code unit is the high surrogate of a surrogate pair.
	        push(output, value);
	        counter--;
	      }
	    } else {
	      push(output, value);
	    }
	  }
	  return output;
	};
	
	/**
	 * Converts a digit/integer into a basic code point.
	 */
	var digitToBasic = function (digit) {
	  //  0..25 map to ASCII a..z or A..Z
	  // 26..35 map to ASCII 0..9
	  return digit + 22 + 75 * (digit < 26);
	};
	
	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 */
	var adapt = function (delta, numPoints, firstTime) {
	  var k = 0;
	  delta = firstTime ? floor(delta / damp) : delta >> 1;
	  delta += floor(delta / numPoints);
	  while (delta > baseMinusTMin * tMax >> 1) {
	    delta = floor(delta / baseMinusTMin);
	    k += base;
	  }
	  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	};
	
	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 */
	var encode = function (input) {
	  var output = [];
	
	  // Convert the input in UCS-2 to an array of Unicode code points.
	  input = ucs2decode(input);
	
	  // Cache the length.
	  var inputLength = input.length;
	
	  // Initialize the state.
	  var n = initialN;
	  var delta = 0;
	  var bias = initialBias;
	  var i, currentValue;
	
	  // Handle the basic code points.
	  for (i = 0; i < input.length; i++) {
	    currentValue = input[i];
	    if (currentValue < 0x80) {
	      push(output, fromCharCode(currentValue));
	    }
	  }
	
	  var basicLength = output.length; // number of basic code points.
	  var handledCPCount = basicLength; // number of code points that have been handled;
	
	  // Finish the basic string with a delimiter unless it's empty.
	  if (basicLength) {
	    push(output, delimiter);
	  }
	
	  // Main encoding loop:
	  while (handledCPCount < inputLength) {
	    // All non-basic code points < n have been handled already. Find the next larger one:
	    var m = maxInt;
	    for (i = 0; i < input.length; i++) {
	      currentValue = input[i];
	      if (currentValue >= n && currentValue < m) {
	        m = currentValue;
	      }
	    }
	
	    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
	    var handledCPCountPlusOne = handledCPCount + 1;
	    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
	      throw new $RangeError(OVERFLOW_ERROR);
	    }
	
	    delta += (m - n) * handledCPCountPlusOne;
	    n = m;
	
	    for (i = 0; i < input.length; i++) {
	      currentValue = input[i];
	      if (currentValue < n && ++delta > maxInt) {
	        throw new $RangeError(OVERFLOW_ERROR);
	      }
	      if (currentValue === n) {
	        // Represent delta as a generalized variable-length integer.
	        var q = delta;
	        var k = base;
	        while (true) {
	          var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
	          if (q < t) break;
	          var qMinusT = q - t;
	          var baseMinusT = base - t;
	          push(output, fromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
	          q = floor(qMinusT / baseMinusT);
	          k += base;
	        }
	
	        push(output, fromCharCode(digitToBasic(q)));
	        bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
	        delta = 0;
	        handledCPCount++;
	      }
	    }
	
	    delta++;
	    n++;
	  }
	  return join(output, '');
	};
	
	module.exports = function (input) {
	  var encoded = [];
	  var labels = split(replace(toLowerCase(input), regexSeparators, '\u002E'), '.');
	  var i, label;
	  for (i = 0; i < labels.length; i++) {
	    label = labels[i];
	    push(encoded, exec(regexNonASCII, label) ? 'xn--' + encode(label) : label);
	  }
	  return join(encoded, '.');
	};


/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toIntegerOrInfinity = __webpack_require__(49);
	
	var $RangeError = RangeError;
	
	module.exports = function (it) {
	  var result = toIntegerOrInfinity(it);
	  if (result < 0) throw new $RangeError("The argument can't be less than 0");
	  return result;
	};


/***/ },
/* 1260 */
/***/ function(module, exports) {

	'use strict';
	var round = Math.round;
	
	module.exports = function (it) {
	  var value = round(it);
	  return value < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
	};


/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var arrayFromConstructorAndList = __webpack_require__(243);
	var typedArraySpeciesConstructor = __webpack_require__(267);
	
	module.exports = function (instance, list) {
	  return arrayFromConstructorAndList(typedArraySpeciesConstructor(instance), list);
	};


/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var apply = __webpack_require__(93);
	var fails = __webpack_require__(7);
	var wrapErrorConstructorWithCause = __webpack_require__(566);
	
	var AGGREGATE_ERROR = 'AggregateError';
	var $AggregateError = getBuiltIn(AGGREGATE_ERROR);
	
	var FORCED = !fails(function () {
	  return $AggregateError([1]).errors[0] !== 1;
	}) && fails(function () {
	  return $AggregateError([1], AGGREGATE_ERROR, { cause: 7 }).cause !== 7;
	});
	
	// https://tc39.es/ecma262/#sec-aggregate-error
	$({ global: true, constructor: true, arity: 2, forced: FORCED }, {
	  AggregateError: wrapErrorConstructorWithCause(AGGREGATE_ERROR, function (init) {
	    // eslint-disable-next-line no-unused-vars -- required for functions `.length`
	    return function AggregateError(errors, message) { return apply(init, this, arguments); };
	  }, FORCED, true)
	});


/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isPrototypeOf = __webpack_require__(77);
	var getPrototypeOf = __webpack_require__(86);
	var setPrototypeOf = __webpack_require__(100);
	var copyConstructorProperties = __webpack_require__(201);
	var create = __webpack_require__(76);
	var createNonEnumerableProperty = __webpack_require__(65);
	var createPropertyDescriptor = __webpack_require__(85);
	var installErrorCause = __webpack_require__(522);
	var installErrorStack = __webpack_require__(514);
	var iterate = __webpack_require__(67);
	var normalizeStringArgument = __webpack_require__(208);
	var wellKnownSymbol = __webpack_require__(21);
	
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var $Error = Error;
	var push = [].push;
	
	var $AggregateError = function AggregateError(errors, message /* , options */) {
	  var isInstance = isPrototypeOf(AggregateErrorPrototype, this);
	  var that;
	  if (setPrototypeOf) {
	    that = setPrototypeOf(new $Error(), isInstance ? getPrototypeOf(this) : AggregateErrorPrototype);
	  } else {
	    that = isInstance ? this : create(AggregateErrorPrototype);
	    createNonEnumerableProperty(that, TO_STRING_TAG, 'Error');
	  }
	  if (message !== undefined) createNonEnumerableProperty(that, 'message', normalizeStringArgument(message));
	  installErrorStack(that, $AggregateError, that.stack, 1);
	  if (arguments.length > 2) installErrorCause(that, arguments[2]);
	  var errorsArray = [];
	  iterate(errors, push, { that: errorsArray });
	  createNonEnumerableProperty(that, 'errors', errorsArray);
	  return that;
	};
	
	if (setPrototypeOf) setPrototypeOf($AggregateError, $Error);
	else copyConstructorProperties($AggregateError, $Error, { name: true });
	
	var AggregateErrorPrototype = $AggregateError.prototype = create($Error.prototype, {
	  constructor: createPropertyDescriptor(1, $AggregateError),
	  message: createPropertyDescriptor(1, ''),
	  name: createPropertyDescriptor(1, 'AggregateError')
	});
	
	// `AggregateError` constructor
	// https://tc39.es/ecma262/#sec-aggregate-error-constructor
	$({ global: true, constructor: true, arity: 2 }, {
	  AggregateError: $AggregateError
	});


/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1263);


/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var arrayBufferModule = __webpack_require__(242);
	var setSpecies = __webpack_require__(170);
	
	var ARRAY_BUFFER = 'ArrayBuffer';
	var ArrayBuffer = arrayBufferModule[ARRAY_BUFFER];
	var NativeArrayBuffer = global[ARRAY_BUFFER];
	
	// `ArrayBuffer` constructor
	// https://tc39.es/ecma262/#sec-arraybuffer-constructor
	$({ global: true, constructor: true, forced: NativeArrayBuffer !== ArrayBuffer }, {
	  ArrayBuffer: ArrayBuffer
	});
	
	setSpecies(ARRAY_BUFFER);


/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var defineBuiltInAccessor = __webpack_require__(54);
	var isDetached = __webpack_require__(493);
	
	var ArrayBufferPrototype = ArrayBuffer.prototype;
	
	if (DESCRIPTORS && !('detached' in ArrayBufferPrototype)) {
	  defineBuiltInAccessor(ArrayBufferPrototype, 'detached', {
	    configurable: true,
	    get: function detached() {
	      return isDetached(this);
	    }
	  });
	}


/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var ArrayBufferViewCore = __webpack_require__(23);
	
	var NATIVE_ARRAY_BUFFER_VIEWS = ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
	
	// `ArrayBuffer.isView` method
	// https://tc39.es/ecma262/#sec-arraybuffer.isview
	$({ target: 'ArrayBuffer', stat: true, forced: !NATIVE_ARRAY_BUFFER_VIEWS }, {
	  isView: ArrayBufferViewCore.isView
	});


/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(141);
	var fails = __webpack_require__(7);
	var ArrayBufferModule = __webpack_require__(242);
	var anObject = __webpack_require__(18);
	var toAbsoluteIndex = __webpack_require__(107);
	var toLength = __webpack_require__(80);
	var speciesConstructor = __webpack_require__(171);
	
	var ArrayBuffer = ArrayBufferModule.ArrayBuffer;
	var DataView = ArrayBufferModule.DataView;
	var DataViewPrototype = DataView.prototype;
	var nativeArrayBufferSlice = uncurryThis(ArrayBuffer.prototype.slice);
	var getUint8 = uncurryThis(DataViewPrototype.getUint8);
	var setUint8 = uncurryThis(DataViewPrototype.setUint8);
	
	var INCORRECT_SLICE = fails(function () {
	  return !new ArrayBuffer(2).slice(1, undefined).byteLength;
	});
	
	// `ArrayBuffer.prototype.slice` method
	// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
	$({ target: 'ArrayBuffer', proto: true, unsafe: true, forced: INCORRECT_SLICE }, {
	  slice: function slice(start, end) {
	    if (nativeArrayBufferSlice && end === undefined) {
	      return nativeArrayBufferSlice(anObject(this), start); // FF fix
	    }
	    var length = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	    var result = new (speciesConstructor(this, ArrayBuffer))(toLength(fin - first));
	    var viewSource = new DataView(this);
	    var viewTarget = new DataView(result);
	    var index = 0;
	    while (first < fin) {
	      setUint8(viewTarget, index++, getUint8(viewSource, first++));
	    } return result;
	  }
	});


/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $transfer = __webpack_require__(494);
	
	// `ArrayBuffer.prototype.transferToFixedLength` method
	// https://tc39.es/proposal-arraybuffer-transfer/#sec-arraybuffer.prototype.transfertofixedlength
	if ($transfer) $({ target: 'ArrayBuffer', proto: true }, {
	  transferToFixedLength: function transferToFixedLength() {
	    return $transfer(this, arguments.length ? arguments[0] : undefined, false);
	  }
	});


/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $transfer = __webpack_require__(494);
	
	// `ArrayBuffer.prototype.transfer` method
	// https://tc39.es/proposal-arraybuffer-transfer/#sec-arraybuffer.prototype.transfer
	if ($transfer) $({ target: 'ArrayBuffer', proto: true }, {
	  transfer: function transfer() {
	    return $transfer(this, arguments.length ? arguments[0] : undefined, true);
	  }
	});


/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var toIntegerOrInfinity = __webpack_require__(49);
	var addToUnscopables = __webpack_require__(71);
	
	// `Array.prototype.at` method
	// https://tc39.es/ecma262/#sec-array.prototype.at
	$({ target: 'Array', proto: true }, {
	  at: function at(index) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var relativeIndex = toIntegerOrInfinity(index);
	    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
	    return (k < 0 || k >= len) ? undefined : O[k];
	  }
	});
	
	addToUnscopables('at');


/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var copyWithin = __webpack_require__(495);
	var addToUnscopables = __webpack_require__(71);
	
	// `Array.prototype.copyWithin` method
	// https://tc39.es/ecma262/#sec-array.prototype.copywithin
	$({ target: 'Array', proto: true }, {
	  copyWithin: copyWithin
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('copyWithin');


/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $every = __webpack_require__(57).every;
	var arrayMethodIsStrict = __webpack_require__(102);
	
	var STRICT_METHOD = arrayMethodIsStrict('every');
	
	// `Array.prototype.every` method
	// https://tc39.es/ecma262/#sec-array.prototype.every
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fill = __webpack_require__(336);
	var addToUnscopables = __webpack_require__(71);
	
	// `Array.prototype.fill` method
	// https://tc39.es/ecma262/#sec-array.prototype.fill
	$({ target: 'Array', proto: true }, {
	  fill: fill
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('fill');


/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $filter = __webpack_require__(57).filter;
	var arrayMethodHasSpeciesSupport = __webpack_require__(199);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
	
	// `Array.prototype.filter` method
	// https://tc39.es/ecma262/#sec-array.prototype.filter
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $findIndex = __webpack_require__(57).findIndex;
	var addToUnscopables = __webpack_require__(71);
	
	var FIND_INDEX = 'findIndex';
	var SKIPS_HOLES = true;
	
	// Shouldn't skip holes
	// eslint-disable-next-line es/no-array-prototype-findindex -- testing
	if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.findIndex` method
	// https://tc39.es/ecma262/#sec-array.prototype.findindex
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND_INDEX);


/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $findLastIndex = __webpack_require__(244).findLastIndex;
	var addToUnscopables = __webpack_require__(71);
	
	// `Array.prototype.findLastIndex` method
	// https://tc39.es/ecma262/#sec-array.prototype.findlastindex
	$({ target: 'Array', proto: true }, {
	  findLastIndex: function findLastIndex(callbackfn /* , that = undefined */) {
	    return $findLastIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	addToUnscopables('findLastIndex');


/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $findLast = __webpack_require__(244).findLast;
	var addToUnscopables = __webpack_require__(71);
	
	// `Array.prototype.findLast` method
	// https://tc39.es/ecma262/#sec-array.prototype.findlast
	$({ target: 'Array', proto: true }, {
	  findLast: function findLast(callbackfn /* , that = undefined */) {
	    return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	addToUnscopables('findLast');


/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $find = __webpack_require__(57).find;
	var addToUnscopables = __webpack_require__(71);
	
	var FIND = 'find';
	var SKIPS_HOLES = true;
	
	// Shouldn't skip holes
	// eslint-disable-next-line es/no-array-prototype-find -- testing
	if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });
	
	// `Array.prototype.find` method
	// https://tc39.es/ecma262/#sec-array.prototype.find
	$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables(FIND);


/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(517);
	var aCallable = __webpack_require__(36);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var arraySpeciesCreate = __webpack_require__(200);
	
	// `Array.prototype.flatMap` method
	// https://tc39.es/ecma262/#sec-array.prototype.flatmap
	$({ target: 'Array', proto: true }, {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen = lengthOfArrayLike(O);
	    var A;
	    aCallable(callbackfn);
	    A = arraySpeciesCreate(O, 0);
	    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return A;
	  }
	});


/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(517);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var toIntegerOrInfinity = __webpack_require__(49);
	var arraySpeciesCreate = __webpack_require__(200);
	
	// `Array.prototype.flat` method
	// https://tc39.es/ecma262/#sec-array.prototype.flat
	$({ target: 'Array', proto: true }, {
	  flat: function flat(/* depthArg = 1 */) {
	    var depthArg = arguments.length ? arguments[0] : undefined;
	    var O = toObject(this);
	    var sourceLen = lengthOfArrayLike(O);
	    var A = arraySpeciesCreate(O, 0);
	    A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toIntegerOrInfinity(depthArg));
	    return A;
	  }
	});


/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var forEach = __webpack_require__(496);
	
	// `Array.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-array.prototype.foreach
	// eslint-disable-next-line es/no-array-prototype-foreach -- safe
	$({ target: 'Array', proto: true, forced: [].forEach !== forEach }, {
	  forEach: forEach
	});


/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $includes = __webpack_require__(198).includes;
	var fails = __webpack_require__(7);
	var addToUnscopables = __webpack_require__(71);
	
	// FF99+ bug
	var BROKEN_ON_SPARSE = fails(function () {
	  // eslint-disable-next-line es/no-array-prototype-includes -- detection
	  return !Array(1).includes();
	});
	
	// `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes
	$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('includes');


/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-array-prototype-indexof -- required for testing */
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(141);
	var $indexOf = __webpack_require__(198).indexOf;
	var arrayMethodIsStrict = __webpack_require__(102);
	
	var nativeIndexOf = uncurryThis([].indexOf);
	
	var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([1], 1, -0) < 0;
	var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');
	
	// `Array.prototype.indexOf` method
	// https://tc39.es/ecma262/#sec-array.prototype.indexof
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? nativeIndexOf(this, searchElement, fromIndex) || 0
	      : $indexOf(this, searchElement, fromIndex);
	  }
	});


/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isArray = __webpack_require__(122);
	
	// `Array.isArray` method
	// https://tc39.es/ecma262/#sec-array.isarray
	$({ target: 'Array', stat: true }, {
	  isArray: isArray
	});


/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var IndexedObject = __webpack_require__(166);
	var toIndexedObject = __webpack_require__(55);
	var arrayMethodIsStrict = __webpack_require__(102);
	
	var nativeJoin = uncurryThis([].join);
	
	var ES3_STRINGS = IndexedObject !== Object;
	var FORCED = ES3_STRINGS || !arrayMethodIsStrict('join', ',');
	
	// `Array.prototype.join` method
	// https://tc39.es/ecma262/#sec-array.prototype.join
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  join: function join(separator) {
	    return nativeJoin(toIndexedObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var lastIndexOf = __webpack_require__(498);
	
	// `Array.prototype.lastIndexOf` method
	// https://tc39.es/ecma262/#sec-array.prototype.lastindexof
	// eslint-disable-next-line es/no-array-prototype-lastindexof -- required for testing
	$({ target: 'Array', proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
	  lastIndexOf: lastIndexOf
	});


/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $map = __webpack_require__(57).map;
	var arrayMethodHasSpeciesSupport = __webpack_require__(199);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
	
	// `Array.prototype.map` method
	// https://tc39.es/ecma262/#sec-array.prototype.map
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var isConstructor = __webpack_require__(167);
	var createProperty = __webpack_require__(120);
	
	var $Array = Array;
	
	var ISNT_GENERIC = fails(function () {
	  function F() { /* empty */ }
	  // eslint-disable-next-line es/no-array-of -- safe
	  return !($Array.of.call(F) instanceof F);
	});
	
	// `Array.of` method
	// https://tc39.es/ecma262/#sec-array.of
	// WebKit Array.of isn't generic
	$({ target: 'Array', stat: true, forced: ISNT_GENERIC }, {
	  of: function of(/* ...args */) {
	    var index = 0;
	    var argumentsLength = arguments.length;
	    var result = new (isConstructor(this) ? this : $Array)(argumentsLength);
	    while (argumentsLength > index) createProperty(result, index, arguments[index++]);
	    result.length = argumentsLength;
	    return result;
	  }
	});


/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var setArrayLength = __webpack_require__(337);
	var doesNotExceedSafeInteger = __webpack_require__(163);
	var fails = __webpack_require__(7);
	
	var INCORRECT_TO_LENGTH = fails(function () {
	  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
	});
	
	// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
	// https://bugs.chromium.org/p/v8/issues/detail?id=12681
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).push();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	
	var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();
	
	// `Array.prototype.push` method
	// https://tc39.es/ecma262/#sec-array.prototype.push
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  push: function push(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    doesNotExceedSafeInteger(len + argCount);
	    for (var i = 0; i < argCount; i++) {
	      O[len] = arguments[i];
	      len++;
	    }
	    setArrayLength(O, len);
	    return len;
	  }
	});


/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $reduceRight = __webpack_require__(245).right;
	var arrayMethodIsStrict = __webpack_require__(102);
	var CHROME_VERSION = __webpack_require__(104);
	var IS_NODE = __webpack_require__(121);
	
	// Chrome 80-82 has a critical bug
	// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
	var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
	var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduceRight');
	
	// `Array.prototype.reduceRight` method
	// https://tc39.es/ecma262/#sec-array.prototype.reduceright
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $reduce = __webpack_require__(245).left;
	var arrayMethodIsStrict = __webpack_require__(102);
	var CHROME_VERSION = __webpack_require__(104);
	var IS_NODE = __webpack_require__(121);
	
	// Chrome 80-82 has a critical bug
	// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
	var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
	var FORCED = CHROME_BUG || !arrayMethodIsStrict('reduce');
	
	// `Array.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-array.prototype.reduce
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    var length = arguments.length;
	    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var isArray = __webpack_require__(122);
	
	var nativeReverse = uncurryThis([].reverse);
	var test = [1, 2];
	
	// `Array.prototype.reverse` method
	// https://tc39.es/ecma262/#sec-array.prototype.reverse
	// fix for Safari 12.0 bug
	// https://bugs.webkit.org/show_bug.cgi?id=188794
	$({ target: 'Array', proto: true, forced: String(test) === String(test.reverse()) }, {
	  reverse: function reverse() {
	    // eslint-disable-next-line no-self-assign -- dirty hack
	    if (isArray(this)) this.length = this.length;
	    return nativeReverse(this);
	  }
	});


/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isArray = __webpack_require__(122);
	var isConstructor = __webpack_require__(167);
	var isObject = __webpack_require__(20);
	var toAbsoluteIndex = __webpack_require__(107);
	var lengthOfArrayLike = __webpack_require__(40);
	var toIndexedObject = __webpack_require__(55);
	var createProperty = __webpack_require__(120);
	var wellKnownSymbol = __webpack_require__(21);
	var arrayMethodHasSpeciesSupport = __webpack_require__(199);
	var nativeSlice = __webpack_require__(91);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
	
	var SPECIES = wellKnownSymbol('species');
	var $Array = Array;
	var max = Math.max;
	
	// `Array.prototype.slice` method
	// https://tc39.es/ecma262/#sec-array.prototype.slice
	// fallback for not array-like ES3 strings and DOM objects
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  slice: function slice(start, end) {
	    var O = toIndexedObject(this);
	    var length = lengthOfArrayLike(O);
	    var k = toAbsoluteIndex(start, length);
	    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
	    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
	    var Constructor, result, n;
	    if (isArray(O)) {
	      Constructor = O.constructor;
	      // cross-realm fallback
	      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
	        Constructor = undefined;
	      } else if (isObject(Constructor)) {
	        Constructor = Constructor[SPECIES];
	        if (Constructor === null) Constructor = undefined;
	      }
	      if (Constructor === $Array || Constructor === undefined) {
	        return nativeSlice(O, k, fin);
	      }
	    }
	    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
	    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
	    result.length = n;
	    return result;
	  }
	});


/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $some = __webpack_require__(57).some;
	var arrayMethodIsStrict = __webpack_require__(102);
	
	var STRICT_METHOD = arrayMethodIsStrict('some');
	
	// `Array.prototype.some` method
	// https://tc39.es/ecma262/#sec-array.prototype.some
	$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(36);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var deletePropertyOrThrow = __webpack_require__(248);
	var toString = __webpack_require__(17);
	var fails = __webpack_require__(7);
	var internalSort = __webpack_require__(338);
	var arrayMethodIsStrict = __webpack_require__(102);
	var FF = __webpack_require__(510);
	var IE_OR_EDGE = __webpack_require__(512);
	var V8 = __webpack_require__(104);
	var WEBKIT = __webpack_require__(343);
	
	var test = [];
	var nativeSort = uncurryThis(test.sort);
	var push = uncurryThis(test.push);
	
	// IE8-
	var FAILS_ON_UNDEFINED = fails(function () {
	  test.sort(undefined);
	});
	// V8 bug
	var FAILS_ON_NULL = fails(function () {
	  test.sort(null);
	});
	// Old WebKit
	var STRICT_METHOD = arrayMethodIsStrict('sort');
	
	var STABLE_SORT = !fails(function () {
	  // feature detection can be too slow, so check engines versions
	  if (V8) return V8 < 70;
	  if (FF && FF > 3) return;
	  if (IE_OR_EDGE) return true;
	  if (WEBKIT) return WEBKIT < 603;
	
	  var result = '';
	  var code, chr, value, index;
	
	  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
	  for (code = 65; code < 76; code++) {
	    chr = String.fromCharCode(code);
	
	    switch (code) {
	      case 66: case 69: case 70: case 72: value = 3; break;
	      case 68: case 71: value = 4; break;
	      default: value = 2;
	    }
	
	    for (index = 0; index < 47; index++) {
	      test.push({ k: chr + index, v: value });
	    }
	  }
	
	  test.sort(function (a, b) { return b.v - a.v; });
	
	  for (index = 0; index < test.length; index++) {
	    chr = test[index].k.charAt(0);
	    if (result.charAt(result.length - 1) !== chr) result += chr;
	  }
	
	  return result !== 'DGBEFHACIJK';
	});
	
	var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
	
	var getSortCompare = function (comparefn) {
	  return function (x, y) {
	    if (y === undefined) return -1;
	    if (x === undefined) return 1;
	    if (comparefn !== undefined) return +comparefn(x, y) || 0;
	    return toString(x) > toString(y) ? 1 : -1;
	  };
	};
	
	// `Array.prototype.sort` method
	// https://tc39.es/ecma262/#sec-array.prototype.sort
	$({ target: 'Array', proto: true, forced: FORCED }, {
	  sort: function sort(comparefn) {
	    if (comparefn !== undefined) aCallable(comparefn);
	
	    var array = toObject(this);
	
	    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
	
	    var items = [];
	    var arrayLength = lengthOfArrayLike(array);
	    var itemsLength, index;
	
	    for (index = 0; index < arrayLength; index++) {
	      if (index in array) push(items, array[index]);
	    }
	
	    internalSort(items, getSortCompare(comparefn));
	
	    itemsLength = lengthOfArrayLike(items);
	    index = 0;
	
	    while (index < itemsLength) array[index] = items[index++];
	    while (index < arrayLength) deletePropertyOrThrow(array, index++);
	
	    return array;
	  }
	});


/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var setSpecies = __webpack_require__(170);
	
	// `Array[@@species]` getter
	// https://tc39.es/ecma262/#sec-get-array-@@species
	setSpecies('Array');


/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var toObject = __webpack_require__(33);
	var toAbsoluteIndex = __webpack_require__(107);
	var toIntegerOrInfinity = __webpack_require__(49);
	var lengthOfArrayLike = __webpack_require__(40);
	var setArrayLength = __webpack_require__(337);
	var doesNotExceedSafeInteger = __webpack_require__(163);
	var arraySpeciesCreate = __webpack_require__(200);
	var createProperty = __webpack_require__(120);
	var deletePropertyOrThrow = __webpack_require__(248);
	var arrayMethodHasSpeciesSupport = __webpack_require__(199);
	
	var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
	
	var max = Math.max;
	var min = Math.min;
	
	// `Array.prototype.splice` method
	// https://tc39.es/ecma262/#sec-array.prototype.splice
	// with adding support of @@species
	$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
	  splice: function splice(start, deleteCount /* , ...items */) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var actualStart = toAbsoluteIndex(start, len);
	    var argumentsLength = arguments.length;
	    var insertCount, actualDeleteCount, A, k, from, to;
	    if (argumentsLength === 0) {
	      insertCount = actualDeleteCount = 0;
	    } else if (argumentsLength === 1) {
	      insertCount = 0;
	      actualDeleteCount = len - actualStart;
	    } else {
	      insertCount = argumentsLength - 2;
	      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
	    }
	    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
	    A = arraySpeciesCreate(O, actualDeleteCount);
	    for (k = 0; k < actualDeleteCount; k++) {
	      from = actualStart + k;
	      if (from in O) createProperty(A, k, O[from]);
	    }
	    A.length = actualDeleteCount;
	    if (insertCount < actualDeleteCount) {
	      for (k = actualStart; k < len - actualDeleteCount; k++) {
	        from = k + actualDeleteCount;
	        to = k + insertCount;
	        if (from in O) O[to] = O[from];
	        else deletePropertyOrThrow(O, to);
	      }
	      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
	    } else if (insertCount > actualDeleteCount) {
	      for (k = len - actualDeleteCount; k > actualStart; k--) {
	        from = k + actualDeleteCount - 1;
	        to = k + insertCount - 1;
	        if (from in O) O[to] = O[from];
	        else deletePropertyOrThrow(O, to);
	      }
	    }
	    for (k = 0; k < insertCount; k++) {
	      O[k + actualStart] = arguments[k + 2];
	    }
	    setArrayLength(O, len - actualDeleteCount + insertCount);
	    return A;
	  }
	});


/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var arrayToReversed = __webpack_require__(499);
	var toIndexedObject = __webpack_require__(55);
	var addToUnscopables = __webpack_require__(71);
	
	var $Array = Array;
	
	// `Array.prototype.toReversed` method
	// https://tc39.es/ecma262/#sec-array.prototype.toreversed
	$({ target: 'Array', proto: true }, {
	  toReversed: function toReversed() {
	    return arrayToReversed(toIndexedObject(this), $Array);
	  }
	});
	
	addToUnscopables('toReversed');


/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(36);
	var toIndexedObject = __webpack_require__(55);
	var arrayFromConstructorAndList = __webpack_require__(243);
	var getBuiltInPrototypeMethod = __webpack_require__(1248);
	var addToUnscopables = __webpack_require__(71);
	
	var $Array = Array;
	var sort = uncurryThis(getBuiltInPrototypeMethod('Array', 'sort'));
	
	// `Array.prototype.toSorted` method
	// https://tc39.es/ecma262/#sec-array.prototype.tosorted
	$({ target: 'Array', proto: true }, {
	  toSorted: function toSorted(compareFn) {
	    if (compareFn !== undefined) aCallable(compareFn);
	    var O = toIndexedObject(this);
	    var A = arrayFromConstructorAndList($Array, O);
	    return sort(A, compareFn);
	  }
	});
	
	addToUnscopables('toSorted');


/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var addToUnscopables = __webpack_require__(71);
	var doesNotExceedSafeInteger = __webpack_require__(163);
	var lengthOfArrayLike = __webpack_require__(40);
	var toAbsoluteIndex = __webpack_require__(107);
	var toIndexedObject = __webpack_require__(55);
	var toIntegerOrInfinity = __webpack_require__(49);
	
	var $Array = Array;
	var max = Math.max;
	var min = Math.min;
	
	// `Array.prototype.toSpliced` method
	// https://tc39.es/ecma262/#sec-array.prototype.tospliced
	$({ target: 'Array', proto: true }, {
	  toSpliced: function toSpliced(start, deleteCount /* , ...items */) {
	    var O = toIndexedObject(this);
	    var len = lengthOfArrayLike(O);
	    var actualStart = toAbsoluteIndex(start, len);
	    var argumentsLength = arguments.length;
	    var k = 0;
	    var insertCount, actualDeleteCount, newLen, A;
	    if (argumentsLength === 0) {
	      insertCount = actualDeleteCount = 0;
	    } else if (argumentsLength === 1) {
	      insertCount = 0;
	      actualDeleteCount = len - actualStart;
	    } else {
	      insertCount = argumentsLength - 2;
	      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
	    }
	    newLen = doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
	    A = $Array(newLen);
	
	    for (; k < actualStart; k++) A[k] = O[k];
	    for (; k < actualStart + insertCount; k++) A[k] = arguments[k - actualStart + 2];
	    for (; k < newLen; k++) A[k] = O[k + actualDeleteCount - insertCount];
	
	    return A;
	  }
	});
	
	addToUnscopables('toSpliced');


/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// this method was added to unscopables after implementation
	// in popular engines, so it's moved to a separate module
	var addToUnscopables = __webpack_require__(71);
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('flatMap');


/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// this method was added to unscopables after implementation
	// in popular engines, so it's moved to a separate module
	var addToUnscopables = __webpack_require__(71);
	
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('flat');


/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var toObject = __webpack_require__(33);
	var lengthOfArrayLike = __webpack_require__(40);
	var setArrayLength = __webpack_require__(337);
	var deletePropertyOrThrow = __webpack_require__(248);
	var doesNotExceedSafeInteger = __webpack_require__(163);
	
	// IE8-
	var INCORRECT_RESULT = [].unshift(0) !== 1;
	
	// V8 ~ Chrome < 71 and Safari <= 15.4, FF < 23 throws InternalError
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', { writable: false }).unshift();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	
	var FORCED = INCORRECT_RESULT || !properErrorOnNonWritableLength();
	
	// `Array.prototype.unshift` method
	// https://tc39.es/ecma262/#sec-array.prototype.unshift
	$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  unshift: function unshift(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    if (argCount) {
	      doesNotExceedSafeInteger(len + argCount);
	      var k = len;
	      while (k--) {
	        var to = k + argCount;
	        if (k in O) O[to] = O[k];
	        else deletePropertyOrThrow(O, to);
	      }
	      for (var j = 0; j < argCount; j++) {
	        O[j] = arguments[j];
	      }
	    } return setArrayLength(O, len + argCount);
	  }
	});


/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var arrayWith = __webpack_require__(500);
	var toIndexedObject = __webpack_require__(55);
	
	var $Array = Array;
	
	// `Array.prototype.with` method
	// https://tc39.es/ecma262/#sec-array.prototype.with
	$({ target: 'Array', proto: true }, {
	  'with': function (index, value) {
	    return arrayWith(toIndexedObject(this), $Array, index, value);
	  }
	});


/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var ArrayBufferModule = __webpack_require__(242);
	var NATIVE_ARRAY_BUFFER = __webpack_require__(334);
	
	// `DataView` constructor
	// https://tc39.es/ecma262/#sec-dataview-constructor
	$({ global: true, constructor: true, forced: !NATIVE_ARRAY_BUFFER }, {
	  DataView: ArrayBufferModule.DataView
	});


/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1306);


/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	
	// IE8- non-standard case
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-date-prototype-getyear-setyear -- detection
	  return new Date(16e11).getYear() !== 120;
	});
	
	var getFullYear = uncurryThis(Date.prototype.getFullYear);
	
	// `Date.prototype.getYear` method
	// https://tc39.es/ecma262/#sec-date.prototype.getyear
	$({ target: 'Date', proto: true, forced: FORCED }, {
	  getYear: function getYear() {
	    return getFullYear(this) - 1900;
	  }
	});


/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	
	var $Date = Date;
	var thisTimeValue = uncurryThis($Date.prototype.getTime);
	
	// `Date.now` method
	// https://tc39.es/ecma262/#sec-date.now
	$({ target: 'Date', stat: true }, {
	  now: function now() {
	    return thisTimeValue(new $Date());
	  }
	});


/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var toIntegerOrInfinity = __webpack_require__(49);
	
	var DatePrototype = Date.prototype;
	var thisTimeValue = uncurryThis(DatePrototype.getTime);
	var setFullYear = uncurryThis(DatePrototype.setFullYear);
	
	// `Date.prototype.setYear` method
	// https://tc39.es/ecma262/#sec-date.prototype.setyear
	$({ target: 'Date', proto: true }, {
	  setYear: function setYear(year) {
	    // validate
	    thisTimeValue(this);
	    var yi = toIntegerOrInfinity(year);
	    var yyyy = yi >= 0 && yi <= 99 ? yi + 1900 : yi;
	    return setFullYear(this, yyyy);
	  }
	});


/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// `Date.prototype.toGMTString` method
	// https://tc39.es/ecma262/#sec-date.prototype.togmtstring
	$({ target: 'Date', proto: true }, {
	  toGMTString: Date.prototype.toUTCString
	});


/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var toISOString = __webpack_require__(1243);
	
	// `Date.prototype.toISOString` method
	// https://tc39.es/ecma262/#sec-date.prototype.toisostring
	// PhantomJS / old WebKit has a broken implementations
	$({ target: 'Date', proto: true, forced: Date.prototype.toISOString !== toISOString }, {
	  toISOString: toISOString
	});


/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var toObject = __webpack_require__(33);
	var toPrimitive = __webpack_require__(266);
	
	var FORCED = fails(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	});
	
	// `Date.prototype.toJSON` method
	// https://tc39.es/ecma262/#sec-date.prototype.tojson
	$({ target: 'Date', proto: true, arity: 1, forced: FORCED }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O, 'number');
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hasOwn = __webpack_require__(28);
	var defineBuiltIn = __webpack_require__(44);
	var dateToPrimitive = __webpack_require__(1244);
	var wellKnownSymbol = __webpack_require__(21);
	
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
	var DatePrototype = Date.prototype;
	
	// `Date.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
	if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
	  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
	}


/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIn = __webpack_require__(44);
	
	var DatePrototype = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var nativeDateToString = uncurryThis(DatePrototype[TO_STRING]);
	var thisTimeValue = uncurryThis(DatePrototype.getTime);
	
	// `Date.prototype.toString` method
	// https://tc39.es/ecma262/#sec-date.prototype.tostring
	if (String(new Date(NaN)) !== INVALID_DATE) {
	  defineBuiltIn(DatePrototype, TO_STRING, function toString() {
	    var value = thisTimeValue(this);
	    // eslint-disable-next-line no-self-compare -- NaN check
	    return value === value ? nativeDateToString(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable no-unused-vars -- required for functions `.length` */
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var apply = __webpack_require__(93);
	var wrapErrorConstructorWithCause = __webpack_require__(566);
	
	var WEB_ASSEMBLY = 'WebAssembly';
	var WebAssembly = global[WEB_ASSEMBLY];
	
	// eslint-disable-next-line es/no-error-cause -- feature detection
	var FORCED = new Error('e', { cause: 7 }).cause !== 7;
	
	var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
	  var O = {};
	  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
	  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
	};
	
	var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
	  if (WebAssembly && WebAssembly[ERROR_NAME]) {
	    var O = {};
	    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
	    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
	  }
	};
	
	// https://tc39.es/ecma262/#sec-nativeerror
	exportGlobalErrorCauseWrapper('Error', function (init) {
	  return function Error(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('EvalError', function (init) {
	  return function EvalError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('RangeError', function (init) {
	  return function RangeError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
	  return function ReferenceError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
	  return function SyntaxError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('TypeError', function (init) {
	  return function TypeError(message) { return apply(init, this, arguments); };
	});
	exportGlobalErrorCauseWrapper('URIError', function (init) {
	  return function URIError(message) { return apply(init, this, arguments); };
	});
	exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
	  return function CompileError(message) { return apply(init, this, arguments); };
	});
	exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
	  return function LinkError(message) { return apply(init, this, arguments); };
	});
	exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
	  return function RuntimeError(message) { return apply(init, this, arguments); };
	});


/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(44);
	var errorToString = __webpack_require__(516);
	
	var ErrorPrototype = Error.prototype;
	
	// `Error.prototype.toString` method fix
	// https://tc39.es/ecma262/#sec-error.prototype.tostring
	if (ErrorPrototype.toString !== errorToString) {
	  defineBuiltIn(ErrorPrototype, 'toString', errorToString);
	}


/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(17);
	
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var exec = uncurryThis(/./.exec);
	var numberToString = uncurryThis(1.0.toString);
	var toUpperCase = uncurryThis(''.toUpperCase);
	
	var raw = /[\w*+\-./@]/;
	
	var hex = function (code, length) {
	  var result = numberToString(code, 16);
	  while (result.length < length) result = '0' + result;
	  return result;
	};
	
	// `escape` method
	// https://tc39.es/ecma262/#sec-escape-string
	$({ global: true }, {
	  escape: function escape(string) {
	    var str = toString(string);
	    var result = '';
	    var length = str.length;
	    var index = 0;
	    var chr, code;
	    while (index < length) {
	      chr = charAt(str, index++);
	      if (exec(raw, chr)) {
	        result += chr;
	      } else {
	        code = charCodeAt(chr, 0);
	        if (code < 256) {
	          result += '%' + hex(code, 2);
	        } else {
	          result += '%u' + toUpperCase(hex(code, 4));
	        }
	      }
	    } return result;
	  }
	});


/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(518);
	
	// `Function.prototype.bind` method
	// https://tc39.es/ecma262/#sec-function.prototype.bind
	// eslint-disable-next-line es/no-function-prototype-bind -- detection
	$({ target: 'Function', proto: true, forced: Function.bind !== bind }, {
	  bind: bind
	});


/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isCallable = __webpack_require__(22);
	var isObject = __webpack_require__(20);
	var definePropertyModule = __webpack_require__(41);
	var isPrototypeOf = __webpack_require__(77);
	var wellKnownSymbol = __webpack_require__(21);
	var makeBuiltIn = __webpack_require__(351);
	
	var HAS_INSTANCE = wellKnownSymbol('hasInstance');
	var FunctionPrototype = Function.prototype;
	
	// `Function.prototype[@@hasInstance]` method
	// https://tc39.es/ecma262/#sec-function.prototype-@@hasinstance
	if (!(HAS_INSTANCE in FunctionPrototype)) {
	  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, { value: makeBuiltIn(function (O) {
	    if (!isCallable(this) || !isObject(O)) return false;
	    var P = this.prototype;
	    return isObject(P) ? isPrototypeOf(P, O) : O instanceof this;
	  }, HAS_INSTANCE) });
	}


/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var FUNCTION_NAME_EXISTS = __webpack_require__(165).EXISTS;
	var uncurryThis = __webpack_require__(8);
	var defineBuiltInAccessor = __webpack_require__(54);
	
	var FunctionPrototype = Function.prototype;
	var functionToString = uncurryThis(FunctionPrototype.toString);
	var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
	var regExpExec = uncurryThis(nameRE.exec);
	var NAME = 'name';
	
	// Function instances `.name` property
	// https://tc39.es/ecma262/#sec-function-instances-name
	if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
	  defineBuiltInAccessor(FunctionPrototype, NAME, {
	    configurable: true,
	    get: function () {
	      try {
	        return regExpExec(nameRE, functionToString(this))[1];
	      } catch (error) {
	        return '';
	      }
	    }
	  });
	}


/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	
	// `globalThis` object
	// https://tc39.es/ecma262/#sec-globalthis
	$({ global: true, forced: global.globalThis !== global }, {
	  globalThis: global
	});


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(247);
	var collectionStrong = __webpack_require__(504);
	
	// `Map` constructor
	// https://tc39.es/ecma262/#sec-map-objects
	collection('Map', function (init) {
	  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var assign = __webpack_require__(535);
	
	// `Object.assign` method
	// https://tc39.es/ecma262/#sec-object.assign
	// eslint-disable-next-line es/no-object-assign -- required for testing
	$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
	  assign: assign
	});


/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var create = __webpack_require__(76);
	
	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
	  create: create
	});


/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var FORCED = __webpack_require__(258);
	var aCallable = __webpack_require__(36);
	var toObject = __webpack_require__(33);
	var definePropertyModule = __webpack_require__(41);
	
	// `Object.prototype.__defineGetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__defineGetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __defineGetter__: function __defineGetter__(P, getter) {
	      definePropertyModule.f(toObject(this), P, { get: aCallable(getter), enumerable: true, configurable: true });
	    }
	  });
	}


/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var defineProperties = __webpack_require__(354).f;
	
	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	$({ target: 'Object', stat: true, forced: Object.defineProperties !== defineProperties, sham: !DESCRIPTORS }, {
	  defineProperties: defineProperties
	});


/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var defineProperty = __webpack_require__(41).f;
	
	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	$({ target: 'Object', stat: true, forced: Object.defineProperty !== defineProperty, sham: !DESCRIPTORS }, {
	  defineProperty: defineProperty
	});


/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var FORCED = __webpack_require__(258);
	var aCallable = __webpack_require__(36);
	var toObject = __webpack_require__(33);
	var definePropertyModule = __webpack_require__(41);
	
	// `Object.prototype.__defineSetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__defineSetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __defineSetter__: function __defineSetter__(P, setter) {
	      definePropertyModule.f(toObject(this), P, { set: aCallable(setter), enumerable: true, configurable: true });
	    }
	  });
	}


/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $entries = __webpack_require__(537).entries;
	
	// `Object.entries` method
	// https://tc39.es/ecma262/#sec-object.entries
	$({ target: 'Object', stat: true }, {
	  entries: function entries(O) {
	    return $entries(O);
	  }
	});


/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var FREEZING = __webpack_require__(164);
	var fails = __webpack_require__(7);
	var isObject = __webpack_require__(20);
	var onFreeze = __webpack_require__(144).onFreeze;
	
	// eslint-disable-next-line es/no-object-freeze -- safe
	var $freeze = Object.freeze;
	var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });
	
	// `Object.freeze` method
	// https://tc39.es/ecma262/#sec-object.freeze
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
	  freeze: function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
	  }
	});


/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var iterate = __webpack_require__(67);
	var createProperty = __webpack_require__(120);
	
	// `Object.fromEntries` method
	// https://github.com/tc39/proposal-object-from-entries
	$({ target: 'Object', stat: true }, {
	  fromEntries: function fromEntries(iterable) {
	    var obj = {};
	    iterate(iterable, function (k, v) {
	      createProperty(obj, k, v);
	    }, { AS_ENTRIES: true });
	    return obj;
	  }
	});


/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var toIndexedObject = __webpack_require__(55);
	var nativeGetOwnPropertyDescriptor = __webpack_require__(58).f;
	var DESCRIPTORS = __webpack_require__(15);
	
	var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });
	
	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
	    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
	  }
	});


/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var ownKeys = __webpack_require__(357);
	var toIndexedObject = __webpack_require__(55);
	var getOwnPropertyDescriptorModule = __webpack_require__(58);
	var createProperty = __webpack_require__(120);
	
	// `Object.getOwnPropertyDescriptors` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIndexedObject(object);
	    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var index = 0;
	    var key, descriptor;
	    while (keys.length > index) {
	      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
	      if (descriptor !== undefined) createProperty(result, key, descriptor);
	    }
	    return result;
	  }
	});


/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var getOwnPropertyNames = __webpack_require__(355).f;
	
	// eslint-disable-next-line es/no-object-getownpropertynames -- required for testing
	var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });
	
	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
	  getOwnPropertyNames: getOwnPropertyNames
	});


/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var NATIVE_SYMBOL = __webpack_require__(173);
	var fails = __webpack_require__(7);
	var getOwnPropertySymbolsModule = __webpack_require__(256);
	var toObject = __webpack_require__(33);
	
	// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });
	
	// `Object.getOwnPropertySymbols` method
	// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
	    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
	  }
	});


/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var toObject = __webpack_require__(33);
	var nativeGetPrototypeOf = __webpack_require__(86);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(340);
	
	var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });
	
	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
	  getPrototypeOf: function getPrototypeOf(it) {
	    return nativeGetPrototypeOf(toObject(it));
	  }
	});
	


/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(36);
	var requireObjectCoercible = __webpack_require__(46);
	var toPropertyKey = __webpack_require__(126);
	var iterate = __webpack_require__(67);
	var fails = __webpack_require__(7);
	
	// eslint-disable-next-line es/no-object-map-groupby -- testing
	var nativeGroupBy = Object.groupBy;
	var create = getBuiltIn('Object', 'create');
	var push = uncurryThis([].push);
	
	var DOES_NOT_WORK_WITH_PRIMITIVES = !nativeGroupBy || fails(function () {
	  return nativeGroupBy('ab', function (it) {
	    return it;
	  }).a.length !== 1;
	});
	
	// `Object.groupBy` method
	// https://github.com/tc39/proposal-array-grouping
	$({ target: 'Object', stat: true, forced: DOES_NOT_WORK_WITH_PRIMITIVES }, {
	  groupBy: function groupBy(items, callbackfn) {
	    requireObjectCoercible(items);
	    aCallable(callbackfn);
	    var obj = create(null);
	    var k = 0;
	    iterate(items, function (value) {
	      var key = toPropertyKey(callbackfn(value, k++));
	      // in some IE versions, `hasOwnProperty` returns incorrect result on integer keys
	      // but since it's a `null` prototype object, we can safely use `in`
	      if (key in obj) push(obj[key], value);
	      else obj[key] = [value];
	    });
	    return obj;
	  }
	});


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var hasOwn = __webpack_require__(28);
	
	// `Object.hasOwn` method
	// https://tc39.es/ecma262/#sec-object.hasown
	$({ target: 'Object', stat: true }, {
	  hasOwn: hasOwn
	});


/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $isExtensible = __webpack_require__(356);
	
	// `Object.isExtensible` method
	// https://tc39.es/ecma262/#sec-object.isextensible
	// eslint-disable-next-line es/no-object-isextensible -- safe
	$({ target: 'Object', stat: true, forced: Object.isExtensible !== $isExtensible }, {
	  isExtensible: $isExtensible
	});


/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var isObject = __webpack_require__(20);
	var classof = __webpack_require__(61);
	var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(335);
	
	// eslint-disable-next-line es/no-object-isfrozen -- safe
	var $isFrozen = Object.isFrozen;
	
	var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isFrozen(1); });
	
	// `Object.isFrozen` method
	// https://tc39.es/ecma262/#sec-object.isfrozen
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  isFrozen: function isFrozen(it) {
	    if (!isObject(it)) return true;
	    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
	    return $isFrozen ? $isFrozen(it) : false;
	  }
	});


/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var fails = __webpack_require__(7);
	var isObject = __webpack_require__(20);
	var classof = __webpack_require__(61);
	var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__(335);
	
	// eslint-disable-next-line es/no-object-issealed -- safe
	var $isSealed = Object.isSealed;
	
	var FORCED = ARRAY_BUFFER_NON_EXTENSIBLE || fails(function () { $isSealed(1); });
	
	// `Object.isSealed` method
	// https://tc39.es/ecma262/#sec-object.issealed
	$({ target: 'Object', stat: true, forced: FORCED }, {
	  isSealed: function isSealed(it) {
	    if (!isObject(it)) return true;
	    if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === 'ArrayBuffer') return true;
	    return $isSealed ? $isSealed(it) : false;
	  }
	});


/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var is = __webpack_require__(544);
	
	// `Object.is` method
	// https://tc39.es/ecma262/#sec-object.is
	$({ target: 'Object', stat: true }, {
	  is: is
	});


/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var toObject = __webpack_require__(33);
	var nativeKeys = __webpack_require__(209);
	var fails = __webpack_require__(7);
	
	var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });
	
	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
	  keys: function keys(it) {
	    return nativeKeys(toObject(it));
	  }
	});


/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var FORCED = __webpack_require__(258);
	var toObject = __webpack_require__(33);
	var toPropertyKey = __webpack_require__(126);
	var getPrototypeOf = __webpack_require__(86);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	// `Object.prototype.__lookupGetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__lookupGetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __lookupGetter__: function __lookupGetter__(P) {
	      var O = toObject(this);
	      var key = toPropertyKey(P);
	      var desc;
	      do {
	        if (desc = getOwnPropertyDescriptor(O, key)) return desc.get;
	      } while (O = getPrototypeOf(O));
	    }
	  });
	}


/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var FORCED = __webpack_require__(258);
	var toObject = __webpack_require__(33);
	var toPropertyKey = __webpack_require__(126);
	var getPrototypeOf = __webpack_require__(86);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	// `Object.prototype.__lookupSetter__` method
	// https://tc39.es/ecma262/#sec-object.prototype.__lookupSetter__
	if (DESCRIPTORS) {
	  $({ target: 'Object', proto: true, forced: FORCED }, {
	    __lookupSetter__: function __lookupSetter__(P) {
	      var O = toObject(this);
	      var key = toPropertyKey(P);
	      var desc;
	      do {
	        if (desc = getOwnPropertyDescriptor(O, key)) return desc.set;
	      } while (O = getPrototypeOf(O));
	    }
	  });
	}


/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isObject = __webpack_require__(20);
	var onFreeze = __webpack_require__(144).onFreeze;
	var FREEZING = __webpack_require__(164);
	var fails = __webpack_require__(7);
	
	// eslint-disable-next-line es/no-object-preventextensions -- safe
	var $preventExtensions = Object.preventExtensions;
	var FAILS_ON_PRIMITIVES = fails(function () { $preventExtensions(1); });
	
	// `Object.preventExtensions` method
	// https://tc39.es/ecma262/#sec-object.preventextensions
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
	  preventExtensions: function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(onFreeze(it)) : it;
	  }
	});


/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var defineBuiltInAccessor = __webpack_require__(54);
	var isObject = __webpack_require__(20);
	var isPossiblePrototype = __webpack_require__(525);
	var toObject = __webpack_require__(33);
	var requireObjectCoercible = __webpack_require__(46);
	
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	var getPrototypeOf = Object.getPrototypeOf;
	// eslint-disable-next-line es/no-object-setprototypeof -- safe
	var setPrototypeOf = Object.setPrototypeOf;
	var ObjectPrototype = Object.prototype;
	var PROTO = '__proto__';
	
	// `Object.prototype.__proto__` accessor
	// https://tc39.es/ecma262/#sec-object.prototype.__proto__
	if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
	  defineBuiltInAccessor(ObjectPrototype, PROTO, {
	    configurable: true,
	    get: function __proto__() {
	      return getPrototypeOf(toObject(this));
	    },
	    set: function __proto__(proto) {
	      var O = requireObjectCoercible(this);
	      if (isPossiblePrototype(proto) && isObject(O)) {
	        setPrototypeOf(O, proto);
	      }
	    }
	  });
	} catch (error) { /* empty */ }


/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isObject = __webpack_require__(20);
	var onFreeze = __webpack_require__(144).onFreeze;
	var FREEZING = __webpack_require__(164);
	var fails = __webpack_require__(7);
	
	// eslint-disable-next-line es/no-object-seal -- safe
	var $seal = Object.seal;
	var FAILS_ON_PRIMITIVES = fails(function () { $seal(1); });
	
	// `Object.seal` method
	// https://tc39.es/ecma262/#sec-object.seal
	$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
	  seal: function seal(it) {
	    return $seal && isObject(it) ? $seal(onFreeze(it)) : it;
	  }
	});


/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var setPrototypeOf = __webpack_require__(100);
	
	// `Object.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.setprototypeof
	$({ target: 'Object', stat: true }, {
	  setPrototypeOf: setPrototypeOf
	});


/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $values = __webpack_require__(537).values;
	
	// `Object.values` method
	// https://tc39.es/ecma262/#sec-object.values
	$({ target: 'Object', stat: true }, {
	  values: function values(O) {
	    return $values(O);
	  }
	});


/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $parseFloat = __webpack_require__(533);
	
	// `parseFloat` method
	// https://tc39.es/ecma262/#sec-parsefloat-string
	$({ global: true, forced: parseFloat !== $parseFloat }, {
	  parseFloat: $parseFloat
	});


/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $parseInt = __webpack_require__(534);
	
	// `parseInt` method
	// https://tc39.es/ecma262/#sec-parseint-string-radix
	$({ global: true, forced: parseInt !== $parseInt }, {
	  parseInt: $parseInt
	});


/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var aCallable = __webpack_require__(36);
	var newPromiseCapabilityModule = __webpack_require__(125);
	var perform = __webpack_require__(210);
	var iterate = __webpack_require__(67);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(259);
	
	// `Promise.allSettled` method
	// https://tc39.es/ecma262/#sec-promise.allsettled
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  allSettled: function allSettled(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aCallable(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        call(promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'fulfilled', value: value };
	          --remaining || resolve(values);
	        }, function (error) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = { status: 'rejected', reason: error };
	          --remaining || resolve(values);
	        });
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var aCallable = __webpack_require__(36);
	var newPromiseCapabilityModule = __webpack_require__(125);
	var perform = __webpack_require__(210);
	var iterate = __webpack_require__(67);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(259);
	
	// `Promise.all` method
	// https://tc39.es/ecma262/#sec-promise.all
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aCallable(C.resolve);
	      var values = [];
	      var counter = 0;
	      var remaining = 1;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyCalled = false;
	        remaining++;
	        call($promiseResolve, C, promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var aCallable = __webpack_require__(36);
	var getBuiltIn = __webpack_require__(35);
	var newPromiseCapabilityModule = __webpack_require__(125);
	var perform = __webpack_require__(210);
	var iterate = __webpack_require__(67);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(259);
	
	var PROMISE_ANY_ERROR = 'No one promise resolved';
	
	// `Promise.any` method
	// https://tc39.es/ecma262/#sec-promise.any
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  any: function any(iterable) {
	    var C = this;
	    var AggregateError = getBuiltIn('AggregateError');
	    var capability = newPromiseCapabilityModule.f(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var promiseResolve = aCallable(C.resolve);
	      var errors = [];
	      var counter = 0;
	      var remaining = 1;
	      var alreadyResolved = false;
	      iterate(iterable, function (promise) {
	        var index = counter++;
	        var alreadyRejected = false;
	        remaining++;
	        call(promiseResolve, C, promise).then(function (value) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyResolved = true;
	          resolve(value);
	        }, function (error) {
	          if (alreadyRejected || alreadyResolved) return;
	          alreadyRejected = true;
	          errors[index] = error;
	          --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	        });
	      });
	      --remaining || reject(new AggregateError(errors, PROMISE_ANY_ERROR));
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var IS_PURE = __webpack_require__(48);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(211).CONSTRUCTOR;
	var NativePromiseConstructor = __webpack_require__(169);
	var getBuiltIn = __webpack_require__(35);
	var isCallable = __webpack_require__(22);
	var defineBuiltIn = __webpack_require__(44);
	
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	
	// `Promise.prototype.catch` method
	// https://tc39.es/ecma262/#sec-promise.prototype.catch
	$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
	  'catch': function (onRejected) {
	    return this.then(undefined, onRejected);
	  }
	});
	
	// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
	if (!IS_PURE && isCallable(NativePromiseConstructor)) {
	  var method = getBuiltIn('Promise').prototype['catch'];
	  if (NativePromisePrototype['catch'] !== method) {
	    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
	  }
	}


/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var IS_PURE = __webpack_require__(48);
	var IS_NODE = __webpack_require__(121);
	var global = __webpack_require__(11);
	var call = __webpack_require__(16);
	var defineBuiltIn = __webpack_require__(44);
	var setPrototypeOf = __webpack_require__(100);
	var setToStringTag = __webpack_require__(73);
	var setSpecies = __webpack_require__(170);
	var aCallable = __webpack_require__(36);
	var isCallable = __webpack_require__(22);
	var isObject = __webpack_require__(20);
	var anInstance = __webpack_require__(98);
	var speciesConstructor = __webpack_require__(171);
	var task = __webpack_require__(264).set;
	var microtask = __webpack_require__(532);
	var hostReportErrors = __webpack_require__(1251);
	var perform = __webpack_require__(210);
	var Queue = __webpack_require__(541);
	var InternalStateModule = __webpack_require__(52);
	var NativePromiseConstructor = __webpack_require__(169);
	var PromiseConstructorDetection = __webpack_require__(211);
	var newPromiseCapabilityModule = __webpack_require__(125);
	
	var PROMISE = 'Promise';
	var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
	var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
	var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
	var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
	var setInternalState = InternalStateModule.set;
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	var PromiseConstructor = NativePromiseConstructor;
	var PromisePrototype = NativePromisePrototype;
	var TypeError = global.TypeError;
	var document = global.document;
	var process = global.process;
	var newPromiseCapability = newPromiseCapabilityModule.f;
	var newGenericPromiseCapability = newPromiseCapability;
	
	var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
	var UNHANDLED_REJECTION = 'unhandledrejection';
	var REJECTION_HANDLED = 'rejectionhandled';
	var PENDING = 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	var HANDLED = 1;
	var UNHANDLED = 2;
	
	var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && isCallable(then = it.then) ? then : false;
	};
	
	var callReaction = function (reaction, state) {
	  var value = state.value;
	  var ok = state.state === FULFILLED;
	  var handler = ok ? reaction.ok : reaction.fail;
	  var resolve = reaction.resolve;
	  var reject = reaction.reject;
	  var domain = reaction.domain;
	  var result, then, exited;
	  try {
	    if (handler) {
	      if (!ok) {
	        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
	        state.rejection = HANDLED;
	      }
	      if (handler === true) result = value;
	      else {
	        if (domain) domain.enter();
	        result = handler(value); // can throw
	        if (domain) {
	          domain.exit();
	          exited = true;
	        }
	      }
	      if (result === reaction.promise) {
	        reject(new TypeError('Promise-chain cycle'));
	      } else if (then = isThenable(result)) {
	        call(then, result, resolve, reject);
	      } else resolve(result);
	    } else reject(value);
	  } catch (error) {
	    if (domain && !exited) domain.exit();
	    reject(error);
	  }
	};
	
	var notify = function (state, isReject) {
	  if (state.notified) return;
	  state.notified = true;
	  microtask(function () {
	    var reactions = state.reactions;
	    var reaction;
	    while (reaction = reactions.get()) {
	      callReaction(reaction, state);
	    }
	    state.notified = false;
	    if (isReject && !state.rejection) onUnhandled(state);
	  });
	};
	
	var dispatchEvent = function (name, promise, reason) {
	  var event, handler;
	  if (DISPATCH_EVENT) {
	    event = document.createEvent('Event');
	    event.promise = promise;
	    event.reason = reason;
	    event.initEvent(name, false, true);
	    global.dispatchEvent(event);
	  } else event = { promise: promise, reason: reason };
	  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
	  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
	};
	
	var onUnhandled = function (state) {
	  call(task, global, function () {
	    var promise = state.facade;
	    var value = state.value;
	    var IS_UNHANDLED = isUnhandled(state);
	    var result;
	    if (IS_UNHANDLED) {
	      result = perform(function () {
	        if (IS_NODE) {
	          process.emit('unhandledRejection', value, promise);
	        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
	      if (result.error) throw result.value;
	    }
	  });
	};
	
	var isUnhandled = function (state) {
	  return state.rejection !== HANDLED && !state.parent;
	};
	
	var onHandleUnhandled = function (state) {
	  call(task, global, function () {
	    var promise = state.facade;
	    if (IS_NODE) {
	      process.emit('rejectionHandled', promise);
	    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
	  });
	};
	
	var bind = function (fn, state, unwrap) {
	  return function (value) {
	    fn(state, value, unwrap);
	  };
	};
	
	var internalReject = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  state.value = value;
	  state.state = REJECTED;
	  notify(state, true);
	};
	
	var internalResolve = function (state, value, unwrap) {
	  if (state.done) return;
	  state.done = true;
	  if (unwrap) state = unwrap;
	  try {
	    if (state.facade === value) throw new TypeError("Promise can't be resolved itself");
	    var then = isThenable(value);
	    if (then) {
	      microtask(function () {
	        var wrapper = { done: false };
	        try {
	          call(then, value,
	            bind(internalResolve, wrapper, state),
	            bind(internalReject, wrapper, state)
	          );
	        } catch (error) {
	          internalReject(wrapper, error, state);
	        }
	      });
	    } else {
	      state.value = value;
	      state.state = FULFILLED;
	      notify(state, false);
	    }
	  } catch (error) {
	    internalReject({ done: false }, error, state);
	  }
	};
	
	// constructor polyfill
	if (FORCED_PROMISE_CONSTRUCTOR) {
	  // 25.4.3.1 Promise(executor)
	  PromiseConstructor = function Promise(executor) {
	    anInstance(this, PromisePrototype);
	    aCallable(executor);
	    call(Internal, this);
	    var state = getInternalPromiseState(this);
	    try {
	      executor(bind(internalResolve, state), bind(internalReject, state));
	    } catch (error) {
	      internalReject(state, error);
	    }
	  };
	
	  PromisePrototype = PromiseConstructor.prototype;
	
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  Internal = function Promise(executor) {
	    setInternalState(this, {
	      type: PROMISE,
	      done: false,
	      notified: false,
	      parent: false,
	      reactions: new Queue(),
	      rejection: false,
	      state: PENDING,
	      value: undefined
	    });
	  };
	
	  // `Promise.prototype.then` method
	  // https://tc39.es/ecma262/#sec-promise.prototype.then
	  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
	    var state = getInternalPromiseState(this);
	    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
	    state.parent = true;
	    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
	    reaction.fail = isCallable(onRejected) && onRejected;
	    reaction.domain = IS_NODE ? process.domain : undefined;
	    if (state.state === PENDING) state.reactions.add(reaction);
	    else microtask(function () {
	      callReaction(reaction, state);
	    });
	    return reaction.promise;
	  });
	
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    var state = getInternalPromiseState(promise);
	    this.promise = promise;
	    this.resolve = bind(internalResolve, state);
	    this.reject = bind(internalReject, state);
	  };
	
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === PromiseConstructor || C === PromiseWrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	
	  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
	    nativeThen = NativePromisePrototype.then;
	
	    if (!NATIVE_PROMISE_SUBCLASSING) {
	      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
	      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
	        var that = this;
	        return new PromiseConstructor(function (resolve, reject) {
	          call(nativeThen, that, resolve, reject);
	        }).then(onFulfilled, onRejected);
	      // https://github.com/zloirock/core-js/issues/640
	      }, { unsafe: true });
	    }
	
	    // make `.constructor === Promise` work for native promise-based APIs
	    try {
	      delete NativePromisePrototype.constructor;
	    } catch (error) { /* empty */ }
	
	    // make `instanceof Promise` work for native promise-based APIs
	    if (setPrototypeOf) {
	      setPrototypeOf(NativePromisePrototype, PromisePrototype);
	    }
	  }
	}
	
	$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
	  Promise: PromiseConstructor
	});
	
	setToStringTag(PromiseConstructor, PROMISE, false, true);
	setSpecies(PROMISE);


/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var IS_PURE = __webpack_require__(48);
	var NativePromiseConstructor = __webpack_require__(169);
	var fails = __webpack_require__(7);
	var getBuiltIn = __webpack_require__(35);
	var isCallable = __webpack_require__(22);
	var speciesConstructor = __webpack_require__(171);
	var promiseResolve = __webpack_require__(539);
	var defineBuiltIn = __webpack_require__(44);
	
	var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
	
	// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
	var NON_GENERIC = !!NativePromiseConstructor && fails(function () {
	  // eslint-disable-next-line unicorn/no-thenable -- required for testing
	  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
	});
	
	// `Promise.prototype.finally` method
	// https://tc39.es/ecma262/#sec-promise.prototype.finally
	$({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
	  'finally': function (onFinally) {
	    var C = speciesConstructor(this, getBuiltIn('Promise'));
	    var isFunction = isCallable(onFinally);
	    return this.then(
	      isFunction ? function (x) {
	        return promiseResolve(C, onFinally()).then(function () { return x; });
	      } : onFinally,
	      isFunction ? function (e) {
	        return promiseResolve(C, onFinally()).then(function () { throw e; });
	      } : onFinally
	    );
	  }
	});
	
	// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
	if (!IS_PURE && isCallable(NativePromiseConstructor)) {
	  var method = getBuiltIn('Promise').prototype['finally'];
	  if (NativePromisePrototype['finally'] !== method) {
	    defineBuiltIn(NativePromisePrototype, 'finally', method, { unsafe: true });
	  }
	}


/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1358);
	__webpack_require__(1355);
	__webpack_require__(1357);
	__webpack_require__(1361);
	__webpack_require__(1362);
	__webpack_require__(1363);


/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var aCallable = __webpack_require__(36);
	var newPromiseCapabilityModule = __webpack_require__(125);
	var perform = __webpack_require__(210);
	var iterate = __webpack_require__(67);
	var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(259);
	
	// `Promise.race` method
	// https://tc39.es/ecma262/#sec-promise.race
	$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapabilityModule.f(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      var $promiseResolve = aCallable(C.resolve);
	      iterate(iterable, function (promise) {
	        call($promiseResolve, C, promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.error) reject(result.value);
	    return capability.promise;
	  }
	});


/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var newPromiseCapabilityModule = __webpack_require__(125);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(211).CONSTRUCTOR;
	
	// `Promise.reject` method
	// https://tc39.es/ecma262/#sec-promise.reject
	$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
	  reject: function reject(r) {
	    var capability = newPromiseCapabilityModule.f(this);
	    var capabilityReject = capability.reject;
	    capabilityReject(r);
	    return capability.promise;
	  }
	});


/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var IS_PURE = __webpack_require__(48);
	var NativePromiseConstructor = __webpack_require__(169);
	var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__(211).CONSTRUCTOR;
	var promiseResolve = __webpack_require__(539);
	
	var PromiseConstructorWrapper = getBuiltIn('Promise');
	var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;
	
	// `Promise.resolve` method
	// https://tc39.es/ecma262/#sec-promise.resolve
	$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
	  resolve: function resolve(x) {
	    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
	  }
	});


/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var newPromiseCapabilityModule = __webpack_require__(125);
	
	// `Promise.withResolvers` method
	// https://github.com/tc39/proposal-promise-with-resolvers
	$({ target: 'Promise', stat: true }, {
	  withResolvers: function withResolvers() {
	    var promiseCapability = newPromiseCapabilityModule.f(this);
	    return {
	      promise: promiseCapability.promise,
	      resolve: promiseCapability.resolve,
	      reject: promiseCapability.reject
	    };
	  }
	});


/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var functionApply = __webpack_require__(93);
	var aCallable = __webpack_require__(36);
	var anObject = __webpack_require__(18);
	var fails = __webpack_require__(7);
	
	// MS Edge argumentsList argument is optional
	var OPTIONAL_ARGUMENTS_LIST = !fails(function () {
	  // eslint-disable-next-line es/no-reflect -- required for testing
	  Reflect.apply(function () { /* empty */ });
	});
	
	// `Reflect.apply` method
	// https://tc39.es/ecma262/#sec-reflect.apply
	$({ target: 'Reflect', stat: true, forced: OPTIONAL_ARGUMENTS_LIST }, {
	  apply: function apply(target, thisArgument, argumentsList) {
	    return functionApply(aCallable(target), thisArgument, anObject(argumentsList));
	  }
	});


/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var apply = __webpack_require__(93);
	var bind = __webpack_require__(518);
	var aConstructor = __webpack_require__(333);
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(20);
	var create = __webpack_require__(76);
	var fails = __webpack_require__(7);
	
	var nativeConstruct = getBuiltIn('Reflect', 'construct');
	var ObjectPrototype = Object.prototype;
	var push = [].push;
	
	// `Reflect.construct` method
	// https://tc39.es/ecma262/#sec-reflect.construct
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	
	var ARGS_BUG = !fails(function () {
	  nativeConstruct(function () { /* empty */ });
	});
	
	var FORCED = NEW_TARGET_BUG || ARGS_BUG;
	
	$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
	  construct: function construct(Target, args /* , newTarget */) {
	    aConstructor(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
	    if (Target === newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      apply(push, $args, args);
	      return new (apply(bind, Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : ObjectPrototype);
	    var result = apply(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var anObject = __webpack_require__(18);
	var toPropertyKey = __webpack_require__(126);
	var definePropertyModule = __webpack_require__(41);
	var fails = __webpack_require__(7);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	var ERROR_INSTEAD_OF_FALSE = fails(function () {
	  // eslint-disable-next-line es/no-reflect -- required for testing
	  Reflect.defineProperty(definePropertyModule.f({}, 1, { value: 1 }), 1, { value: 2 });
	});
	
	// `Reflect.defineProperty` method
	// https://tc39.es/ecma262/#sec-reflect.defineproperty
	$({ target: 'Reflect', stat: true, forced: ERROR_INSTEAD_OF_FALSE, sham: !DESCRIPTORS }, {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    var key = toPropertyKey(propertyKey);
	    anObject(attributes);
	    try {
	      definePropertyModule.f(target, key, attributes);
	      return true;
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var anObject = __webpack_require__(18);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	// `Reflect.deleteProperty` method
	// https://tc39.es/ecma262/#sec-reflect.deleteproperty
	$({ target: 'Reflect', stat: true }, {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var descriptor = getOwnPropertyDescriptor(anObject(target), propertyKey);
	    return descriptor && !descriptor.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var anObject = __webpack_require__(18);
	var getOwnPropertyDescriptorModule = __webpack_require__(58);
	
	// `Reflect.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-reflect.getownpropertydescriptor
	$({ target: 'Reflect', stat: true, sham: !DESCRIPTORS }, {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var anObject = __webpack_require__(18);
	var objectGetPrototypeOf = __webpack_require__(86);
	var CORRECT_PROTOTYPE_GETTER = __webpack_require__(340);
	
	// `Reflect.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-reflect.getprototypeof
	$({ target: 'Reflect', stat: true, sham: !CORRECT_PROTOTYPE_GETTER }, {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return objectGetPrototypeOf(anObject(target));
	  }
	});


/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var isObject = __webpack_require__(20);
	var anObject = __webpack_require__(18);
	var isDataDescriptor = __webpack_require__(524);
	var getOwnPropertyDescriptorModule = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(86);
	
	// `Reflect.get` method
	// https://tc39.es/ecma262/#sec-reflect.get
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var descriptor, prototype;
	  if (anObject(target) === receiver) return target[propertyKey];
	  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
	  if (descriptor) return isDataDescriptor(descriptor)
	    ? descriptor.value
	    : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
	  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
	}
	
	$({ target: 'Reflect', stat: true }, {
	  get: get
	});


/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	
	// `Reflect.has` method
	// https://tc39.es/ecma262/#sec-reflect.has
	$({ target: 'Reflect', stat: true }, {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var anObject = __webpack_require__(18);
	var $isExtensible = __webpack_require__(356);
	
	// `Reflect.isExtensible` method
	// https://tc39.es/ecma262/#sec-reflect.isextensible
	$({ target: 'Reflect', stat: true }, {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible(target);
	  }
	});


/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var ownKeys = __webpack_require__(357);
	
	// `Reflect.ownKeys` method
	// https://tc39.es/ecma262/#sec-reflect.ownkeys
	$({ target: 'Reflect', stat: true }, {
	  ownKeys: ownKeys
	});


/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var anObject = __webpack_require__(18);
	var FREEZING = __webpack_require__(164);
	
	// `Reflect.preventExtensions` method
	// https://tc39.es/ecma262/#sec-reflect.preventextensions
	$({ target: 'Reflect', stat: true, sham: !FREEZING }, {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      var objectPreventExtensions = getBuiltIn('Object', 'preventExtensions');
	      if (objectPreventExtensions) objectPreventExtensions(target);
	      return true;
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var anObject = __webpack_require__(18);
	var aPossiblePrototype = __webpack_require__(491);
	var objectSetPrototypeOf = __webpack_require__(100);
	
	// `Reflect.setPrototypeOf` method
	// https://tc39.es/ecma262/#sec-reflect.setprototypeof
	if (objectSetPrototypeOf) $({ target: 'Reflect', stat: true }, {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    anObject(target);
	    aPossiblePrototype(proto);
	    try {
	      objectSetPrototypeOf(target, proto);
	      return true;
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var anObject = __webpack_require__(18);
	var isObject = __webpack_require__(20);
	var isDataDescriptor = __webpack_require__(524);
	var fails = __webpack_require__(7);
	var definePropertyModule = __webpack_require__(41);
	var getOwnPropertyDescriptorModule = __webpack_require__(58);
	var getPrototypeOf = __webpack_require__(86);
	var createPropertyDescriptor = __webpack_require__(85);
	
	// `Reflect.set` method
	// https://tc39.es/ecma262/#sec-reflect.set
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDescriptor = getOwnPropertyDescriptorModule.f(anObject(target), propertyKey);
	  var existingDescriptor, prototype, setter;
	  if (!ownDescriptor) {
	    if (isObject(prototype = getPrototypeOf(target))) {
	      return set(prototype, propertyKey, V, receiver);
	    }
	    ownDescriptor = createPropertyDescriptor(0);
	  }
	  if (isDataDescriptor(ownDescriptor)) {
	    if (ownDescriptor.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = getOwnPropertyDescriptorModule.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      definePropertyModule.f(receiver, propertyKey, existingDescriptor);
	    } else definePropertyModule.f(receiver, propertyKey, createPropertyDescriptor(0, V));
	  } else {
	    setter = ownDescriptor.set;
	    if (setter === undefined) return false;
	    call(setter, receiver, V);
	  } return true;
	}
	
	// MS Edge 17-18 Reflect.set allows setting the property to object
	// with non-writable property on the prototype
	var MS_EDGE_BUG = fails(function () {
	  var Constructor = function () { /* empty */ };
	  var object = definePropertyModule.f(new Constructor(), 'a', { configurable: true });
	  // eslint-disable-next-line es/no-reflect -- required for testing
	  return Reflect.set(Constructor.prototype, 'a', 1, object) !== false;
	});
	
	$({ target: 'Reflect', stat: true, forced: MS_EDGE_BUG }, {
	  set: set
	});


/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(8);
	var isForced = __webpack_require__(207);
	var inheritIfRequired = __webpack_require__(143);
	var createNonEnumerableProperty = __webpack_require__(65);
	var create = __webpack_require__(76);
	var getOwnPropertyNames = __webpack_require__(145).f;
	var isPrototypeOf = __webpack_require__(77);
	var isRegExp = __webpack_require__(253);
	var toString = __webpack_require__(17);
	var getRegExpFlags = __webpack_require__(213);
	var stickyHelpers = __webpack_require__(260);
	var proxyAccessor = __webpack_require__(540);
	var defineBuiltIn = __webpack_require__(44);
	var fails = __webpack_require__(7);
	var hasOwn = __webpack_require__(28);
	var enforceInternalState = __webpack_require__(52).enforce;
	var setSpecies = __webpack_require__(170);
	var wellKnownSymbol = __webpack_require__(21);
	var UNSUPPORTED_DOT_ALL = __webpack_require__(360);
	var UNSUPPORTED_NCG = __webpack_require__(542);
	
	var MATCH = wellKnownSymbol('match');
	var NativeRegExp = global.RegExp;
	var RegExpPrototype = NativeRegExp.prototype;
	var SyntaxError = global.SyntaxError;
	var exec = uncurryThis(RegExpPrototype.exec);
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var stringIndexOf = uncurryThis(''.indexOf);
	var stringSlice = uncurryThis(''.slice);
	// TODO: Use only proper RegExpIdentifierName
	var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
	var re1 = /a/g;
	var re2 = /a/g;
	
	// "new" should create a new object, old webkit bug
	var CORRECT_NEW = new NativeRegExp(re1) !== re1;
	
	var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	
	var BASE_FORCED = DESCRIPTORS &&
	  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
	    re2[MATCH] = false;
	    // RegExp constructor can alter flags and IsRegExp works correct with @@match
	    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
	  }));
	
	var handleDotAll = function (string) {
	  var length = string.length;
	  var index = 0;
	  var result = '';
	  var brackets = false;
	  var chr;
	  for (; index <= length; index++) {
	    chr = charAt(string, index);
	    if (chr === '\\') {
	      result += chr + charAt(string, ++index);
	      continue;
	    }
	    if (!brackets && chr === '.') {
	      result += '[\\s\\S]';
	    } else {
	      if (chr === '[') {
	        brackets = true;
	      } else if (chr === ']') {
	        brackets = false;
	      } result += chr;
	    }
	  } return result;
	};
	
	var handleNCG = function (string) {
	  var length = string.length;
	  var index = 0;
	  var result = '';
	  var named = [];
	  var names = create(null);
	  var brackets = false;
	  var ncg = false;
	  var groupid = 0;
	  var groupname = '';
	  var chr;
	  for (; index <= length; index++) {
	    chr = charAt(string, index);
	    if (chr === '\\') {
	      chr += charAt(string, ++index);
	    } else if (chr === ']') {
	      brackets = false;
	    } else if (!brackets) switch (true) {
	      case chr === '[':
	        brackets = true;
	        break;
	      case chr === '(':
	        if (exec(IS_NCG, stringSlice(string, index + 1))) {
	          index += 2;
	          ncg = true;
	        }
	        result += chr;
	        groupid++;
	        continue;
	      case chr === '>' && ncg:
	        if (groupname === '' || hasOwn(names, groupname)) {
	          throw new SyntaxError('Invalid capture group name');
	        }
	        names[groupname] = true;
	        named[named.length] = [groupname, groupid];
	        ncg = false;
	        groupname = '';
	        continue;
	    }
	    if (ncg) groupname += chr;
	    else result += chr;
	  } return [result, named];
	};
	
	// `RegExp` constructor
	// https://tc39.es/ecma262/#sec-regexp-constructor
	if (isForced('RegExp', BASE_FORCED)) {
	  var RegExpWrapper = function RegExp(pattern, flags) {
	    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
	    var patternIsRegExp = isRegExp(pattern);
	    var flagsAreUndefined = flags === undefined;
	    var groups = [];
	    var rawPattern = pattern;
	    var rawFlags, dotAll, sticky, handled, result, state;
	
	    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
	      return pattern;
	    }
	
	    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
	      pattern = pattern.source;
	      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
	    }
	
	    pattern = pattern === undefined ? '' : toString(pattern);
	    flags = flags === undefined ? '' : toString(flags);
	    rawPattern = pattern;
	
	    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
	      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
	      if (dotAll) flags = replace(flags, /s/g, '');
	    }
	
	    rawFlags = flags;
	
	    if (MISSED_STICKY && 'sticky' in re1) {
	      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
	      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
	    }
	
	    if (UNSUPPORTED_NCG) {
	      handled = handleNCG(pattern);
	      pattern = handled[0];
	      groups = handled[1];
	    }
	
	    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
	
	    if (dotAll || sticky || groups.length) {
	      state = enforceInternalState(result);
	      if (dotAll) {
	        state.dotAll = true;
	        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
	      }
	      if (sticky) state.sticky = true;
	      if (groups.length) state.groups = groups;
	    }
	
	    if (pattern !== rawPattern) try {
	      // fails in old engines, but we have no alternatives for unsupported regex syntax
	      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
	    } catch (error) { /* empty */ }
	
	    return result;
	  };
	
	  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
	    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
	  }
	
	  RegExpPrototype.constructor = RegExpWrapper;
	  RegExpWrapper.prototype = RegExpPrototype;
	  defineBuiltIn(global, 'RegExp', RegExpWrapper, { constructor: true });
	}
	
	// https://tc39.es/ecma262/#sec-get-regexp-@@species
	setSpecies('RegExp');


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var UNSUPPORTED_DOT_ALL = __webpack_require__(360);
	var classof = __webpack_require__(61);
	var defineBuiltInAccessor = __webpack_require__(54);
	var getInternalState = __webpack_require__(52).get;
	
	var RegExpPrototype = RegExp.prototype;
	var $TypeError = TypeError;
	
	// `RegExp.prototype.dotAll` getter
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
	if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
	  defineBuiltInAccessor(RegExpPrototype, 'dotAll', {
	    configurable: true,
	    get: function dotAll() {
	      if (this === RegExpPrototype) return;
	      // We can't use InternalStateModule.getterFor because
	      // we don't add metadata for regexps created by a literal.
	      if (classof(this) === 'RegExp') {
	        return !!getInternalState(this).dotAll;
	      }
	      throw new $TypeError('Incompatible receiver, RegExp required');
	    }
	  });
	}


/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var DESCRIPTORS = __webpack_require__(15);
	var defineBuiltInAccessor = __webpack_require__(54);
	var regExpFlags = __webpack_require__(359);
	var fails = __webpack_require__(7);
	
	// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
	var RegExp = global.RegExp;
	var RegExpPrototype = RegExp.prototype;
	
	var FORCED = DESCRIPTORS && fails(function () {
	  var INDICES_SUPPORT = true;
	  try {
	    RegExp('.', 'd');
	  } catch (error) {
	    INDICES_SUPPORT = false;
	  }
	
	  var O = {};
	  // modern V8 bug
	  var calls = '';
	  var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
	
	  var addGetter = function (key, chr) {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty(O, key, { get: function () {
	      calls += chr;
	      return true;
	    } });
	  };
	
	  var pairs = {
	    dotAll: 's',
	    global: 'g',
	    ignoreCase: 'i',
	    multiline: 'm',
	    sticky: 'y'
	  };
	
	  if (INDICES_SUPPORT) pairs.hasIndices = 'd';
	
	  for (var key in pairs) addGetter(key, pairs[key]);
	
	  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	  var result = Object.getOwnPropertyDescriptor(RegExpPrototype, 'flags').get.call(O);
	
	  return result !== expected || calls !== expected;
	});
	
	// `RegExp.prototype.flags` getter
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
	if (FORCED) defineBuiltInAccessor(RegExpPrototype, 'flags', {
	  configurable: true,
	  get: regExpFlags
	});


/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var MISSED_STICKY = __webpack_require__(260).MISSED_STICKY;
	var classof = __webpack_require__(61);
	var defineBuiltInAccessor = __webpack_require__(54);
	var getInternalState = __webpack_require__(52).get;
	
	var RegExpPrototype = RegExp.prototype;
	var $TypeError = TypeError;
	
	// `RegExp.prototype.sticky` getter
	// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
	if (DESCRIPTORS && MISSED_STICKY) {
	  defineBuiltInAccessor(RegExpPrototype, 'sticky', {
	    configurable: true,
	    get: function sticky() {
	      if (this === RegExpPrototype) return;
	      // We can't use InternalStateModule.getterFor because
	      // we don't add metadata for regexps created by a literal.
	      if (classof(this) === 'RegExp') {
	        return !!getInternalState(this).sticky;
	      }
	      throw new $TypeError('Incompatible receiver, RegExp required');
	    }
	  });
	}


/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4` since it's moved to entry points
	__webpack_require__(373);
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var isCallable = __webpack_require__(22);
	var anObject = __webpack_require__(18);
	var toString = __webpack_require__(17);
	
	var DELEGATES_TO_EXEC = function () {
	  var execCalled = false;
	  var re = /[ac]/;
	  re.exec = function () {
	    execCalled = true;
	    return /./.exec.apply(this, arguments);
	  };
	  return re.test('abc') === true && execCalled;
	}();
	
	var nativeTest = /./.test;
	
	// `RegExp.prototype.test` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.test
	$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
	  test: function (S) {
	    var R = anObject(this);
	    var string = toString(S);
	    var exec = R.exec;
	    if (!isCallable(exec)) return call(nativeTest, R, string);
	    var result = call(exec, R, string);
	    if (result === null) return false;
	    anObject(result);
	    return true;
	  }
	});


/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var PROPER_FUNCTION_NAME = __webpack_require__(165).PROPER;
	var defineBuiltIn = __webpack_require__(44);
	var anObject = __webpack_require__(18);
	var $toString = __webpack_require__(17);
	var fails = __webpack_require__(7);
	var getRegExpFlags = __webpack_require__(213);
	
	var TO_STRING = 'toString';
	var RegExpPrototype = RegExp.prototype;
	var nativeToString = RegExpPrototype[TO_STRING];
	
	var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
	// FF44- RegExp#toString has a wrong name
	var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;
	
	// `RegExp.prototype.toString` method
	// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
	if (NOT_GENERIC || INCORRECT_NAME) {
	  defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
	    var R = anObject(this);
	    var pattern = $toString(R.source);
	    var flags = $toString(getRegExpFlags(R));
	    return '/' + pattern + '/' + flags;
	  }, { unsafe: true });
	}


/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(247);
	var collectionStrong = __webpack_require__(504);
	
	// `Set` constructor
	// https://tc39.es/ecma262/#sec-set-objects
	collection('Set', function (init) {
	  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionStrong);


/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.anchor` method
	// https://tc39.es/ecma262/#sec-string.prototype.anchor
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('anchor') }, {
	  anchor: function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  }
	});


/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(46);
	var toIntegerOrInfinity = __webpack_require__(49);
	var toString = __webpack_require__(17);
	var fails = __webpack_require__(7);
	
	var charAt = uncurryThis(''.charAt);
	
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-array-string-prototype-at -- safe
	  return '𠮷'.at(-2) !== '\uD842';
	});
	
	// `String.prototype.at` method
	// https://tc39.es/ecma262/#sec-string.prototype.at
	$({ target: 'String', proto: true, forced: FORCED }, {
	  at: function at(index) {
	    var S = toString(requireObjectCoercible(this));
	    var len = S.length;
	    var relativeIndex = toIntegerOrInfinity(index);
	    var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
	    return (k < 0 || k >= len) ? undefined : charAt(S, k);
	  }
	});


/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.big` method
	// https://tc39.es/ecma262/#sec-string.prototype.big
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('big') }, {
	  big: function big() {
	    return createHTML(this, 'big', '', '');
	  }
	});


/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.blink` method
	// https://tc39.es/ecma262/#sec-string.prototype.blink
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('blink') }, {
	  blink: function blink() {
	    return createHTML(this, 'blink', '', '');
	  }
	});


/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.bold` method
	// https://tc39.es/ecma262/#sec-string.prototype.bold
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
	  bold: function bold() {
	    return createHTML(this, 'b', '', '');
	  }
	});


/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var codeAt = __webpack_require__(262).codeAt;
	
	// `String.prototype.codePointAt` method
	// https://tc39.es/ecma262/#sec-string.prototype.codepointat
	$({ target: 'String', proto: true }, {
	  codePointAt: function codePointAt(pos) {
	    return codeAt(this, pos);
	  }
	});


/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(141);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	var toLength = __webpack_require__(80);
	var toString = __webpack_require__(17);
	var notARegExp = __webpack_require__(353);
	var requireObjectCoercible = __webpack_require__(46);
	var correctIsRegExpLogic = __webpack_require__(339);
	var IS_PURE = __webpack_require__(48);
	
	var slice = uncurryThis(''.slice);
	var min = Math.min;
	
	var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
	// https://github.com/zloirock/core-js/pull/702
	var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
	  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
	  return descriptor && !descriptor.writable;
	}();
	
	// `String.prototype.endsWith` method
	// https://tc39.es/ecma262/#sec-string.prototype.endswith
	$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = toString(requireObjectCoercible(this));
	    notARegExp(searchString);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = that.length;
	    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
	    var search = toString(searchString);
	    return slice(that, end - search.length, end) === search;
	  }
	});


/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.fixed` method
	// https://tc39.es/ecma262/#sec-string.prototype.fixed
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fixed') }, {
	  fixed: function fixed() {
	    return createHTML(this, 'tt', '', '');
	  }
	});


/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.fontcolor` method
	// https://tc39.es/ecma262/#sec-string.prototype.fontcolor
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontcolor') }, {
	  fontcolor: function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  }
	});


/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.fontsize` method
	// https://tc39.es/ecma262/#sec-string.prototype.fontsize
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('fontsize') }, {
	  fontsize: function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  }
	});


/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var toAbsoluteIndex = __webpack_require__(107);
	
	var $RangeError = RangeError;
	var fromCharCode = String.fromCharCode;
	// eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
	var $fromCodePoint = String.fromCodePoint;
	var join = uncurryThis([].join);
	
	// length should be 1, old FF problem
	var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;
	
	// `String.fromCodePoint` method
	// https://tc39.es/ecma262/#sec-string.fromcodepoint
	$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  fromCodePoint: function fromCodePoint(x) {
	    var elements = [];
	    var length = arguments.length;
	    var i = 0;
	    var code;
	    while (length > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
	      elements[i] = code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
	    } return join(elements, '');
	  }
	});


/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var notARegExp = __webpack_require__(353);
	var requireObjectCoercible = __webpack_require__(46);
	var toString = __webpack_require__(17);
	var correctIsRegExpLogic = __webpack_require__(339);
	
	var stringIndexOf = uncurryThis(''.indexOf);
	
	// `String.prototype.includes` method
	// https://tc39.es/ecma262/#sec-string.prototype.includes
	$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~stringIndexOf(
	      toString(requireObjectCoercible(this)),
	      toString(notARegExp(searchString)),
	      arguments.length > 1 ? arguments[1] : undefined
	    );
	  }
	});


/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(46);
	var toString = __webpack_require__(17);
	
	var charCodeAt = uncurryThis(''.charCodeAt);
	
	// `String.prototype.isWellFormed` method
	// https://github.com/tc39/proposal-is-usv-string
	$({ target: 'String', proto: true }, {
	  isWellFormed: function isWellFormed() {
	    var S = toString(requireObjectCoercible(this));
	    var length = S.length;
	    for (var i = 0; i < length; i++) {
	      var charCode = charCodeAt(S, i);
	      // single UTF-16 code unit
	      if ((charCode & 0xF800) !== 0xD800) continue;
	      // unpaired surrogate
	      if (charCode >= 0xDC00 || ++i >= length || (charCodeAt(S, i) & 0xFC00) !== 0xDC00) return false;
	    } return true;
	  }
	});


/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.italics` method
	// https://tc39.es/ecma262/#sec-string.prototype.italics
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
	  italics: function italics() {
	    return createHTML(this, 'i', '', '');
	  }
	});


/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.link` method
	// https://tc39.es/ecma262/#sec-string.prototype.link
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
	  link: function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  }
	});


/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/* eslint-disable es/no-string-prototype-matchall -- safe */
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(141);
	var createIteratorConstructor = __webpack_require__(349);
	var createIterResultObject = __webpack_require__(202);
	var requireObjectCoercible = __webpack_require__(46);
	var toLength = __webpack_require__(80);
	var toString = __webpack_require__(17);
	var anObject = __webpack_require__(18);
	var isNullOrUndefined = __webpack_require__(66);
	var classof = __webpack_require__(61);
	var isRegExp = __webpack_require__(253);
	var getRegExpFlags = __webpack_require__(213);
	var getMethod = __webpack_require__(105);
	var defineBuiltIn = __webpack_require__(44);
	var fails = __webpack_require__(7);
	var wellKnownSymbol = __webpack_require__(21);
	var speciesConstructor = __webpack_require__(171);
	var advanceStringIndex = __webpack_require__(241);
	var regExpExec = __webpack_require__(212);
	var InternalStateModule = __webpack_require__(52);
	var IS_PURE = __webpack_require__(48);
	
	var MATCH_ALL = wellKnownSymbol('matchAll');
	var REGEXP_STRING = 'RegExp String';
	var REGEXP_STRING_ITERATOR = REGEXP_STRING + ' Iterator';
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(REGEXP_STRING_ITERATOR);
	var RegExpPrototype = RegExp.prototype;
	var $TypeError = TypeError;
	var stringIndexOf = uncurryThis(''.indexOf);
	var nativeMatchAll = uncurryThis(''.matchAll);
	
	var WORKS_WITH_NON_GLOBAL_REGEX = !!nativeMatchAll && !fails(function () {
	  nativeMatchAll('a', /./);
	});
	
	var $RegExpStringIterator = createIteratorConstructor(function RegExpStringIterator(regexp, string, $global, fullUnicode) {
	  setInternalState(this, {
	    type: REGEXP_STRING_ITERATOR,
	    regexp: regexp,
	    string: string,
	    global: $global,
	    unicode: fullUnicode,
	    done: false
	  });
	}, REGEXP_STRING, function next() {
	  var state = getInternalState(this);
	  if (state.done) return createIterResultObject(undefined, true);
	  var R = state.regexp;
	  var S = state.string;
	  var match = regExpExec(R, S);
	  if (match === null) {
	    state.done = true;
	    return createIterResultObject(undefined, true);
	  }
	  if (state.global) {
	    if (toString(match[0]) === '') R.lastIndex = advanceStringIndex(S, toLength(R.lastIndex), state.unicode);
	    return createIterResultObject(match, false);
	  }
	  state.done = true;
	  return createIterResultObject(match, false);
	});
	
	var $matchAll = function (string) {
	  var R = anObject(this);
	  var S = toString(string);
	  var C = speciesConstructor(R, RegExp);
	  var flags = toString(getRegExpFlags(R));
	  var matcher, $global, fullUnicode;
	  matcher = new C(C === RegExp ? R.source : R, flags);
	  $global = !!~stringIndexOf(flags, 'g');
	  fullUnicode = !!~stringIndexOf(flags, 'u');
	  matcher.lastIndex = toLength(R.lastIndex);
	  return new $RegExpStringIterator(matcher, S, $global, fullUnicode);
	};
	
	// `String.prototype.matchAll` method
	// https://tc39.es/ecma262/#sec-string.prototype.matchall
	$({ target: 'String', proto: true, forced: WORKS_WITH_NON_GLOBAL_REGEX }, {
	  matchAll: function matchAll(regexp) {
	    var O = requireObjectCoercible(this);
	    var flags, S, matcher, rx;
	    if (!isNullOrUndefined(regexp)) {
	      if (isRegExp(regexp)) {
	        flags = toString(requireObjectCoercible(getRegExpFlags(regexp)));
	        if (!~stringIndexOf(flags, 'g')) throw new $TypeError('`.matchAll` does not allow non-global regexes');
	      }
	      if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
	      matcher = getMethod(regexp, MATCH_ALL);
	      if (matcher === undefined && IS_PURE && classof(regexp) === 'RegExp') matcher = $matchAll;
	      if (matcher) return call(matcher, regexp, O);
	    } else if (WORKS_WITH_NON_GLOBAL_REGEX) return nativeMatchAll(O, regexp);
	    S = toString(O);
	    rx = new RegExp(regexp, 'g');
	    return IS_PURE ? call($matchAll, rx, S) : rx[MATCH_ALL](S);
	  }
	});
	
	IS_PURE || MATCH_ALL in RegExpPrototype || defineBuiltIn(RegExpPrototype, MATCH_ALL, $matchAll);


/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(250);
	var anObject = __webpack_require__(18);
	var isNullOrUndefined = __webpack_require__(66);
	var toLength = __webpack_require__(80);
	var toString = __webpack_require__(17);
	var requireObjectCoercible = __webpack_require__(46);
	var getMethod = __webpack_require__(105);
	var advanceStringIndex = __webpack_require__(241);
	var regExpExec = __webpack_require__(212);
	
	// @@match logic
	fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.es/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = requireObjectCoercible(this);
	      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
	      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
	    function (string) {
	      var rx = anObject(this);
	      var S = toString(string);
	      var res = maybeCallNative(nativeMatch, rx, S);
	
	      if (res.done) return res.value;
	
	      if (!rx.global) return regExpExec(rx, S);
	
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = toString(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $padEnd = __webpack_require__(364).end;
	var WEBKIT_BUG = __webpack_require__(552);
	
	// `String.prototype.padEnd` method
	// https://tc39.es/ecma262/#sec-string.prototype.padend
	$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $padStart = __webpack_require__(364).start;
	var WEBKIT_BUG = __webpack_require__(552);
	
	// `String.prototype.padStart` method
	// https://tc39.es/ecma262/#sec-string.prototype.padstart
	$({ target: 'String', proto: true, forced: WEBKIT_BUG }, {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var toIndexedObject = __webpack_require__(55);
	var toObject = __webpack_require__(33);
	var toString = __webpack_require__(17);
	var lengthOfArrayLike = __webpack_require__(40);
	
	var push = uncurryThis([].push);
	var join = uncurryThis([].join);
	
	// `String.raw` method
	// https://tc39.es/ecma262/#sec-string.raw
	$({ target: 'String', stat: true }, {
	  raw: function raw(template) {
	    var rawTemplate = toIndexedObject(toObject(template).raw);
	    var literalSegments = lengthOfArrayLike(rawTemplate);
	    if (!literalSegments) return '';
	    var argumentsLength = arguments.length;
	    var elements = [];
	    var i = 0;
	    while (true) {
	      push(elements, toString(rawTemplate[i++]));
	      if (i === literalSegments) return join(elements, '');
	      if (i < argumentsLength) push(elements, toString(arguments[i]));
	    }
	  }
	});


/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var repeat = __webpack_require__(263);
	
	// `String.prototype.repeat` method
	// https://tc39.es/ecma262/#sec-string.prototype.repeat
	$({ target: 'String', proto: true }, {
	  repeat: repeat
	});


/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(46);
	var isCallable = __webpack_require__(22);
	var isNullOrUndefined = __webpack_require__(66);
	var isRegExp = __webpack_require__(253);
	var toString = __webpack_require__(17);
	var getMethod = __webpack_require__(105);
	var getRegExpFlags = __webpack_require__(213);
	var getSubstitution = __webpack_require__(519);
	var wellKnownSymbol = __webpack_require__(21);
	var IS_PURE = __webpack_require__(48);
	
	var REPLACE = wellKnownSymbol('replace');
	var $TypeError = TypeError;
	var indexOf = uncurryThis(''.indexOf);
	var replace = uncurryThis(''.replace);
	var stringSlice = uncurryThis(''.slice);
	var max = Math.max;
	
	// `String.prototype.replaceAll` method
	// https://tc39.es/ecma262/#sec-string.prototype.replaceall
	$({ target: 'String', proto: true }, {
	  replaceAll: function replaceAll(searchValue, replaceValue) {
	    var O = requireObjectCoercible(this);
	    var IS_REG_EXP, flags, replacer, string, searchString, functionalReplace, searchLength, advanceBy, replacement;
	    var position = 0;
	    var endOfLastMatch = 0;
	    var result = '';
	    if (!isNullOrUndefined(searchValue)) {
	      IS_REG_EXP = isRegExp(searchValue);
	      if (IS_REG_EXP) {
	        flags = toString(requireObjectCoercible(getRegExpFlags(searchValue)));
	        if (!~indexOf(flags, 'g')) throw new $TypeError('`.replaceAll` does not allow non-global regexes');
	      }
	      replacer = getMethod(searchValue, REPLACE);
	      if (replacer) {
	        return call(replacer, searchValue, O, replaceValue);
	      } else if (IS_PURE && IS_REG_EXP) {
	        return replace(toString(O), searchValue, replaceValue);
	      }
	    }
	    string = toString(O);
	    searchString = toString(searchValue);
	    functionalReplace = isCallable(replaceValue);
	    if (!functionalReplace) replaceValue = toString(replaceValue);
	    searchLength = searchString.length;
	    advanceBy = max(1, searchLength);
	    position = indexOf(string, searchString);
	    while (position !== -1) {
	      replacement = functionalReplace
	        ? toString(replaceValue(searchString, position, string))
	        : getSubstitution(searchString, string, position, [], undefined, replaceValue);
	      result += stringSlice(string, endOfLastMatch, position) + replacement;
	      endOfLastMatch = position + searchLength;
	      position = position + advanceBy > string.length ? -1 : indexOf(string, searchString, position + advanceBy);
	    }
	    if (endOfLastMatch < string.length) {
	      result += stringSlice(string, endOfLastMatch);
	    }
	    return result;
	  }
	});


/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var apply = __webpack_require__(93);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(250);
	var fails = __webpack_require__(7);
	var anObject = __webpack_require__(18);
	var isCallable = __webpack_require__(22);
	var isNullOrUndefined = __webpack_require__(66);
	var toIntegerOrInfinity = __webpack_require__(49);
	var toLength = __webpack_require__(80);
	var toString = __webpack_require__(17);
	var requireObjectCoercible = __webpack_require__(46);
	var advanceStringIndex = __webpack_require__(241);
	var getMethod = __webpack_require__(105);
	var getSubstitution = __webpack_require__(519);
	var regExpExec = __webpack_require__(212);
	var wellKnownSymbol = __webpack_require__(21);
	
	var REPLACE = wellKnownSymbol('replace');
	var max = Math.max;
	var min = Math.min;
	var concat = uncurryThis([].concat);
	var push = uncurryThis([].push);
	var stringIndexOf = uncurryThis(''.indexOf);
	var stringSlice = uncurryThis(''.slice);
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// IE <= 11 replaces $0 with the whole match, as if it was $&
	// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
	var REPLACE_KEEPS_$0 = (function () {
	  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
	  return 'a'.replace(/./, '$0') === '$0';
	})();
	
	// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
	var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
	  if (/./[REPLACE]) {
	    return /./[REPLACE]('a', '$0') === '';
	  }
	  return false;
	})();
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	// @@replace logic
	fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
	  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
	
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.es/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = requireObjectCoercible(this);
	      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
	      return replacer
	        ? call(replacer, searchValue, O, replaceValue)
	        : call(nativeReplace, toString(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
	    function (string, replaceValue) {
	      var rx = anObject(this);
	      var S = toString(string);
	
	      if (
	        typeof replaceValue == 'string' &&
	        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
	        stringIndexOf(replaceValue, '$<') === -1
	      ) {
	        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
	        if (res.done) return res.value;
	      }
	
	      var functionalReplace = isCallable(replaceValue);
	      if (!functionalReplace) replaceValue = toString(replaceValue);
	
	      var global = rx.global;
	      var fullUnicode;
	      if (global) {
	        fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	
	      var results = [];
	      var result;
	      while (true) {
	        result = regExpExec(rx, S);
	        if (result === null) break;
	
	        push(results, result);
	        if (!global) break;
	
	        var matchStr = toString(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	
	        var matched = toString(result[0]);
	        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
	        var captures = [];
	        var replacement;
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = concat([matched], captures, position, S);
	          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
	          replacement = toString(apply(replaceValue, undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	
	      return accumulatedResult + stringSlice(S, nextSourcePosition);
	    }
	  ];
	}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(250);
	var anObject = __webpack_require__(18);
	var isNullOrUndefined = __webpack_require__(66);
	var requireObjectCoercible = __webpack_require__(46);
	var sameValue = __webpack_require__(544);
	var toString = __webpack_require__(17);
	var getMethod = __webpack_require__(105);
	var regExpExec = __webpack_require__(212);
	
	// @@search logic
	fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.es/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = requireObjectCoercible(this);
	      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
	      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
	    function (string) {
	      var rx = anObject(this);
	      var S = toString(string);
	      var res = maybeCallNative(nativeSearch, rx, S);
	
	      if (res.done) return res.value;
	
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.small` method
	// https://tc39.es/ecma262/#sec-string.prototype.small
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
	  small: function small() {
	    return createHTML(this, 'small', '', '');
	  }
	});


/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var fixRegExpWellKnownSymbolLogic = __webpack_require__(250);
	var anObject = __webpack_require__(18);
	var isNullOrUndefined = __webpack_require__(66);
	var requireObjectCoercible = __webpack_require__(46);
	var speciesConstructor = __webpack_require__(171);
	var advanceStringIndex = __webpack_require__(241);
	var toLength = __webpack_require__(80);
	var toString = __webpack_require__(17);
	var getMethod = __webpack_require__(105);
	var regExpExec = __webpack_require__(212);
	var stickyHelpers = __webpack_require__(260);
	var fails = __webpack_require__(7);
	
	var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
	var MAX_UINT32 = 0xFFFFFFFF;
	var min = Math.min;
	var push = uncurryThis([].push);
	var stringSlice = uncurryThis(''.slice);
	
	// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	// Weex JS has frozen built-in prototypes, so use try / catch wrapper
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
	});
	
	var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' ||
	  // eslint-disable-next-line regexp/no-empty-group -- required for testing
	  'test'.split(/(?:)/, -1).length !== 4 ||
	  'ab'.split(/(?:ab)*/).length !== 2 ||
	  '.'.split(/(.?)(.?)/).length !== 4 ||
	  // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
	  '.'.split(/()()/).length > 1 ||
	  ''.split(/.?/).length;
	
	// @@split logic
	fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
	  var internalSplit = '0'.split(undefined, 0).length ? function (separator, limit) {
	    return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
	  } : nativeSplit;
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.es/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = requireObjectCoercible(this);
	      var splitter = isNullOrUndefined(separator) ? undefined : getMethod(separator, SPLIT);
	      return splitter
	        ? call(splitter, separator, O, limit)
	        : call(internalSplit, toString(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (string, limit) {
	      var rx = anObject(this);
	      var S = toString(string);
	
	      if (!BUGGY) {
	        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
	        if (res.done) return res.value;
	      }
	
	      var C = speciesConstructor(rx, RegExp);
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (UNSUPPORTED_Y ? 'g' : 'y');
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return regExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
	        var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
	        var e;
	        if (
	          z === null ||
	          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          push(A, stringSlice(S, p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            push(A, z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      push(A, stringSlice(S, p));
	      return A;
	    }
	  ];
	}, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(141);
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	var toLength = __webpack_require__(80);
	var toString = __webpack_require__(17);
	var notARegExp = __webpack_require__(353);
	var requireObjectCoercible = __webpack_require__(46);
	var correctIsRegExpLogic = __webpack_require__(339);
	var IS_PURE = __webpack_require__(48);
	
	var stringSlice = uncurryThis(''.slice);
	var min = Math.min;
	
	var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
	// https://github.com/zloirock/core-js/pull/702
	var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
	  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
	  return descriptor && !descriptor.writable;
	}();
	
	// `String.prototype.startsWith` method
	// https://tc39.es/ecma262/#sec-string.prototype.startswith
	$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = toString(requireObjectCoercible(this));
	    notARegExp(searchString);
	    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = toString(searchString);
	    return stringSlice(that, index, index + search.length) === search;
	  }
	});


/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.strike` method
	// https://tc39.es/ecma262/#sec-string.prototype.strike
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('strike') }, {
	  strike: function strike() {
	    return createHTML(this, 'strike', '', '');
	  }
	});


/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.sub` method
	// https://tc39.es/ecma262/#sec-string.prototype.sub
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
	  sub: function sub() {
	    return createHTML(this, 'sub', '', '');
	  }
	});


/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(46);
	var toIntegerOrInfinity = __webpack_require__(49);
	var toString = __webpack_require__(17);
	
	var stringSlice = uncurryThis(''.slice);
	var max = Math.max;
	var min = Math.min;
	
	// eslint-disable-next-line unicorn/prefer-string-slice -- required for testing
	var FORCED = !''.substr || 'ab'.substr(-1) !== 'b';
	
	// `String.prototype.substr` method
	// https://tc39.es/ecma262/#sec-string.prototype.substr
	$({ target: 'String', proto: true, forced: FORCED }, {
	  substr: function substr(start, length) {
	    var that = toString(requireObjectCoercible(this));
	    var size = that.length;
	    var intStart = toIntegerOrInfinity(start);
	    var intLength, intEnd;
	    if (intStart === Infinity) intStart = 0;
	    if (intStart < 0) intStart = max(size + intStart, 0);
	    intLength = length === undefined ? size : toIntegerOrInfinity(length);
	    if (intLength <= 0 || intLength === Infinity) return '';
	    intEnd = min(intStart + intLength, size);
	    return intStart >= intEnd ? '' : stringSlice(that, intStart, intEnd);
	  }
	});


/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var createHTML = __webpack_require__(75);
	var forcedStringHTMLMethod = __webpack_require__(79);
	
	// `String.prototype.sup` method
	// https://tc39.es/ecma262/#sec-string.prototype.sup
	$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sup') }, {
	  sup: function sup() {
	    return createHTML(this, 'sup', '', '');
	  }
	});


/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var requireObjectCoercible = __webpack_require__(46);
	var toString = __webpack_require__(17);
	var fails = __webpack_require__(7);
	
	var $Array = Array;
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	var join = uncurryThis([].join);
	// eslint-disable-next-line es/no-string-prototype-iswellformed-towellformed -- safe
	var $toWellFormed = ''.toWellFormed;
	var REPLACEMENT_CHARACTER = '\uFFFD';
	
	// Safari bug
	var TO_STRING_CONVERSION_BUG = $toWellFormed && fails(function () {
	  return call($toWellFormed, 1) !== '1';
	});
	
	// `String.prototype.toWellFormed` method
	// https://github.com/tc39/proposal-is-usv-string
	$({ target: 'String', proto: true, forced: TO_STRING_CONVERSION_BUG }, {
	  toWellFormed: function toWellFormed() {
	    var S = toString(requireObjectCoercible(this));
	    if (TO_STRING_CONVERSION_BUG) return call($toWellFormed, S);
	    var length = S.length;
	    var result = $Array(length);
	    for (var i = 0; i < length; i++) {
	      var charCode = charCodeAt(S, i);
	      // single UTF-16 code unit
	      if ((charCode & 0xF800) !== 0xD800) result[i] = charAt(S, i);
	      // unpaired surrogate
	      else if (charCode >= 0xDC00 || i + 1 >= length || (charCodeAt(S, i + 1) & 0xFC00) !== 0xDC00) result[i] = REPLACEMENT_CHARACTER;
	      // surrogate pair
	      else {
	        result[i] = charAt(S, i);
	        result[++i] = charAt(S, i);
	      }
	    } return join(result, '');
	  }
	});


/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this line from `core-js@4`
	__webpack_require__(1419);
	var $ = __webpack_require__(4);
	var trimEnd = __webpack_require__(553);
	
	// `String.prototype.trimEnd` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimend
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimEnd !== trimEnd }, {
	  trimEnd: trimEnd
	});


/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var trimStart = __webpack_require__(554);
	
	// `String.prototype.trimLeft` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimleft
	// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
	$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimLeft !== trimStart }, {
	  trimLeft: trimStart
	});


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var trimEnd = __webpack_require__(553);
	
	// `String.prototype.trimRight` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimend
	// eslint-disable-next-line es/no-string-prototype-trimleft-trimright -- safe
	$({ target: 'String', proto: true, name: 'trimEnd', forced: ''.trimRight !== trimEnd }, {
	  trimRight: trimEnd
	});


/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this line from `core-js@4`
	__webpack_require__(1418);
	var $ = __webpack_require__(4);
	var trimStart = __webpack_require__(554);
	
	// `String.prototype.trimStart` method
	// https://tc39.es/ecma262/#sec-string.prototype.trimstart
	// eslint-disable-next-line es/no-string-prototype-trimstart-trimend -- safe
	$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimStart !== trimStart }, {
	  trimStart: trimStart
	});


/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var $trim = __webpack_require__(172).trim;
	var forcedStringTrimMethod = __webpack_require__(365);
	
	// `String.prototype.trim` method
	// https://tc39.es/ecma262/#sec-string.prototype.trim
	$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
	  trim: function trim() {
	    return $trim(this);
	  }
	});


/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var IS_PURE = __webpack_require__(48);
	var DESCRIPTORS = __webpack_require__(15);
	var NATIVE_SYMBOL = __webpack_require__(173);
	var fails = __webpack_require__(7);
	var hasOwn = __webpack_require__(28);
	var isPrototypeOf = __webpack_require__(77);
	var anObject = __webpack_require__(18);
	var toIndexedObject = __webpack_require__(55);
	var toPropertyKey = __webpack_require__(126);
	var $toString = __webpack_require__(17);
	var createPropertyDescriptor = __webpack_require__(85);
	var nativeObjectCreate = __webpack_require__(76);
	var objectKeys = __webpack_require__(209);
	var getOwnPropertyNamesModule = __webpack_require__(145);
	var getOwnPropertyNamesExternal = __webpack_require__(355);
	var getOwnPropertySymbolsModule = __webpack_require__(256);
	var getOwnPropertyDescriptorModule = __webpack_require__(58);
	var definePropertyModule = __webpack_require__(41);
	var definePropertiesModule = __webpack_require__(354);
	var propertyIsEnumerableModule = __webpack_require__(257);
	var defineBuiltIn = __webpack_require__(44);
	var defineBuiltInAccessor = __webpack_require__(54);
	var shared = __webpack_require__(147);
	var sharedKey = __webpack_require__(261);
	var hiddenKeys = __webpack_require__(206);
	var uid = __webpack_require__(174);
	var wellKnownSymbol = __webpack_require__(21);
	var wrappedWellKnownSymbolModule = __webpack_require__(565);
	var defineWellKnownSymbol = __webpack_require__(47);
	var defineSymbolToPrimitive = __webpack_require__(555);
	var setToStringTag = __webpack_require__(73);
	var InternalStateModule = __webpack_require__(52);
	var $forEach = __webpack_require__(57).forEach;
	
	var HIDDEN = sharedKey('hidden');
	var SYMBOL = 'Symbol';
	var PROTOTYPE = 'prototype';
	
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(SYMBOL);
	
	var ObjectPrototype = Object[PROTOTYPE];
	var $Symbol = global.Symbol;
	var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
	var RangeError = global.RangeError;
	var TypeError = global.TypeError;
	var QObject = global.QObject;
	var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
	var nativeDefineProperty = definePropertyModule.f;
	var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
	var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
	var push = uncurryThis([].push);
	
	var AllSymbols = shared('symbols');
	var ObjectPrototypeSymbols = shared('op-symbols');
	var WellKnownSymbolsStore = shared('wks');
	
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var fallbackDefineProperty = function (O, P, Attributes) {
	  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
	  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
	  nativeDefineProperty(O, P, Attributes);
	  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
	    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
	  }
	};
	
	var setSymbolDescriptor = DESCRIPTORS && fails(function () {
	  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
	    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
	  })).a !== 7;
	}) ? fallbackDefineProperty : nativeDefineProperty;
	
	var wrap = function (tag, description) {
	  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
	  setInternalState(symbol, {
	    type: SYMBOL,
	    tag: tag,
	    description: description
	  });
	  if (!DESCRIPTORS) symbol.description = description;
	  return symbol;
	};
	
	var $defineProperty = function defineProperty(O, P, Attributes) {
	  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
	  anObject(O);
	  var key = toPropertyKey(P);
	  anObject(Attributes);
	  if (hasOwn(AllSymbols, key)) {
	    if (!Attributes.enumerable) {
	      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, nativeObjectCreate(null)));
	      O[HIDDEN][key] = true;
	    } else {
	      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
	      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
	    } return setSymbolDescriptor(O, key, Attributes);
	  } return nativeDefineProperty(O, key, Attributes);
	};
	
	var $defineProperties = function defineProperties(O, Properties) {
	  anObject(O);
	  var properties = toIndexedObject(Properties);
	  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
	  $forEach(keys, function (key) {
	    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
	  });
	  return O;
	};
	
	var $create = function create(O, Properties) {
	  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
	};
	
	var $propertyIsEnumerable = function propertyIsEnumerable(V) {
	  var P = toPropertyKey(V);
	  var enumerable = call(nativePropertyIsEnumerable, this, P);
	  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
	  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
	    ? enumerable : true;
	};
	
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
	  var it = toIndexedObject(O);
	  var key = toPropertyKey(P);
	  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
	  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
	  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
	    descriptor.enumerable = true;
	  }
	  return descriptor;
	};
	
	var $getOwnPropertyNames = function getOwnPropertyNames(O) {
	  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
	  });
	  return result;
	};
	
	var $getOwnPropertySymbols = function (O) {
	  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
	  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
	  var result = [];
	  $forEach(names, function (key) {
	    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
	      push(result, AllSymbols[key]);
	    }
	  });
	  return result;
	};
	
	// `Symbol` constructor
	// https://tc39.es/ecma262/#sec-symbol-constructor
	if (!NATIVE_SYMBOL) {
	  $Symbol = function Symbol() {
	    if (isPrototypeOf(SymbolPrototype, this)) throw new TypeError('Symbol is not a constructor');
	    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
	    var tag = uid(description);
	    var setter = function (value) {
	      var $this = this === undefined ? global : this;
	      if ($this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
	      if (hasOwn($this, HIDDEN) && hasOwn($this[HIDDEN], tag)) $this[HIDDEN][tag] = false;
	      var descriptor = createPropertyDescriptor(1, value);
	      try {
	        setSymbolDescriptor($this, tag, descriptor);
	      } catch (error) {
	        if (!(error instanceof RangeError)) throw error;
	        fallbackDefineProperty($this, tag, descriptor);
	      }
	    };
	    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
	    return wrap(tag, description);
	  };
	
	  SymbolPrototype = $Symbol[PROTOTYPE];
	
	  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
	    return getInternalState(this).tag;
	  });
	
	  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
	    return wrap(uid(description), description);
	  });
	
	  propertyIsEnumerableModule.f = $propertyIsEnumerable;
	  definePropertyModule.f = $defineProperty;
	  definePropertiesModule.f = $defineProperties;
	  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
	  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
	  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
	
	  wrappedWellKnownSymbolModule.f = function (name) {
	    return wrap(wellKnownSymbol(name), name);
	  };
	
	  if (DESCRIPTORS) {
	    // https://github.com/tc39/proposal-Symbol-description
	    defineBuiltInAccessor(SymbolPrototype, 'description', {
	      configurable: true,
	      get: function description() {
	        return getInternalState(this).description;
	      }
	    });
	    if (!IS_PURE) {
	      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
	    }
	  }
	}
	
	$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
	  Symbol: $Symbol
	});
	
	$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
	  defineWellKnownSymbol(name);
	});
	
	$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
	  useSetter: function () { USE_SETTER = true; },
	  useSimple: function () { USE_SETTER = false; }
	});
	
	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
	  // `Object.create` method
	  // https://tc39.es/ecma262/#sec-object.create
	  create: $create,
	  // `Object.defineProperty` method
	  // https://tc39.es/ecma262/#sec-object.defineproperty
	  defineProperty: $defineProperty,
	  // `Object.defineProperties` method
	  // https://tc39.es/ecma262/#sec-object.defineproperties
	  defineProperties: $defineProperties,
	  // `Object.getOwnPropertyDescriptor` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
	});
	
	$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
	  // `Object.getOwnPropertyNames` method
	  // https://tc39.es/ecma262/#sec-object.getownpropertynames
	  getOwnPropertyNames: $getOwnPropertyNames
	});
	
	// `Symbol.prototype[@@toPrimitive]` method
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
	defineSymbolToPrimitive();
	
	// `Symbol.prototype[@@toStringTag]` property
	// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
	setToStringTag($Symbol, SYMBOL);
	
	hiddenKeys[HIDDEN] = true;


/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var hasOwn = __webpack_require__(28);
	var toString = __webpack_require__(17);
	var shared = __webpack_require__(147);
	var NATIVE_SYMBOL_REGISTRY = __webpack_require__(558);
	
	var StringToSymbolRegistry = shared('string-to-symbol-registry');
	var SymbolToStringRegistry = shared('symbol-to-string-registry');
	
	// `Symbol.for` method
	// https://tc39.es/ecma262/#sec-symbol.for
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  'for': function (key) {
	    var string = toString(key);
	    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
	    var symbol = getBuiltIn('Symbol')(string);
	    StringToSymbolRegistry[string] = symbol;
	    SymbolToStringRegistry[symbol] = string;
	    return symbol;
	  }
	});


/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var hasOwn = __webpack_require__(28);
	var isSymbol = __webpack_require__(123);
	var tryToString = __webpack_require__(149);
	var shared = __webpack_require__(147);
	var NATIVE_SYMBOL_REGISTRY = __webpack_require__(558);
	
	var SymbolToStringRegistry = shared('symbol-to-string-registry');
	
	// `Symbol.keyFor` method
	// https://tc39.es/ecma262/#sec-symbol.keyfor
	$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw new TypeError(tryToString(sym) + ' is not a symbol');
	    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
	  }
	});


/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var lengthOfArrayLike = __webpack_require__(40);
	var toIntegerOrInfinity = __webpack_require__(49);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.at` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.at
	exportTypedArrayMethod('at', function at(index) {
	  var O = aTypedArray(this);
	  var len = lengthOfArrayLike(O);
	  var relativeIndex = toIntegerOrInfinity(index);
	  var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
	  return (k < 0 || k >= len) ? undefined : O[k];
	});


/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var uncurryThis = __webpack_require__(8);
	var ArrayBufferViewCore = __webpack_require__(23);
	var $ArrayCopyWithin = __webpack_require__(495);
	
	var u$ArrayCopyWithin = uncurryThis($ArrayCopyWithin);
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.copyWithin` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.copywithin
	exportTypedArrayMethod('copyWithin', function copyWithin(target, start /* , end */) {
	  return u$ArrayCopyWithin(aTypedArray(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	});


/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $every = __webpack_require__(57).every;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.every` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.every
	exportTypedArrayMethod('every', function every(callbackfn /* , thisArg */) {
	  return $every(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $fill = __webpack_require__(336);
	var toBigInt = __webpack_require__(367);
	var classof = __webpack_require__(92);
	var call = __webpack_require__(16);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var slice = uncurryThis(''.slice);
	
	// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
	var CONVERSION_BUG = fails(function () {
	  var count = 0;
	  // eslint-disable-next-line es/no-typed-arrays -- safe
	  new Int8Array(2).fill({ valueOf: function () { return count++; } });
	  return count !== 1;
	});
	
	// `%TypedArray%.prototype.fill` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
	exportTypedArrayMethod('fill', function fill(value /* , start, end */) {
	  var length = arguments.length;
	  aTypedArray(this);
	  var actualValue = slice(classof(this), 0, 3) === 'Big' ? toBigInt(value) : +value;
	  return call($fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
	}, CONVERSION_BUG);


/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $filter = __webpack_require__(57).filter;
	var fromSpeciesAndList = __webpack_require__(1261);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.filter` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.filter
	exportTypedArrayMethod('filter', function filter(callbackfn /* , thisArg */) {
	  var list = $filter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  return fromSpeciesAndList(this, list);
	});


/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $findIndex = __webpack_require__(57).findIndex;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.findIndex` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findindex
	exportTypedArrayMethod('findIndex', function findIndex(predicate /* , thisArg */) {
	  return $findIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $findLastIndex = __webpack_require__(244).findLastIndex;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.findLastIndex` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlastindex
	exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate /* , thisArg */) {
	  return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $findLast = __webpack_require__(244).findLast;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.findLast` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.findlast
	exportTypedArrayMethod('findLast', function findLast(predicate /* , thisArg */) {
	  return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $find = __webpack_require__(57).find;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.find` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.find
	exportTypedArrayMethod('find', function find(predicate /* , thisArg */) {
	  return $find(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Float32Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Float32', function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Float64Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Float64', function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $forEach = __webpack_require__(57).forEach;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.foreach
	exportTypedArrayMethod('forEach', function forEach(callbackfn /* , thisArg */) {
	  $forEach(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(370);
	var exportTypedArrayStaticMethod = __webpack_require__(23).exportTypedArrayStaticMethod;
	var typedArrayFrom = __webpack_require__(561);
	
	// `%TypedArray%.from` method
	// https://tc39.es/ecma262/#sec-%typedarray%.from
	exportTypedArrayStaticMethod('from', typedArrayFrom, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $includes = __webpack_require__(198).includes;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.includes` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.includes
	exportTypedArrayMethod('includes', function includes(searchElement /* , fromIndex */) {
	  return $includes(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $indexOf = __webpack_require__(198).indexOf;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.indexOf` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.indexof
	exportTypedArrayMethod('indexOf', function indexOf(searchElement /* , fromIndex */) {
	  return $indexOf(aTypedArray(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Int16Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Int16', function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Int32Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Int32', function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Int8Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Int8', function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var fails = __webpack_require__(7);
	var uncurryThis = __webpack_require__(8);
	var ArrayBufferViewCore = __webpack_require__(23);
	var ArrayIterators = __webpack_require__(175);
	var wellKnownSymbol = __webpack_require__(21);
	
	var ITERATOR = wellKnownSymbol('iterator');
	var Uint8Array = global.Uint8Array;
	var arrayValues = uncurryThis(ArrayIterators.values);
	var arrayKeys = uncurryThis(ArrayIterators.keys);
	var arrayEntries = uncurryThis(ArrayIterators.entries);
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var TypedArrayPrototype = Uint8Array && Uint8Array.prototype;
	
	var GENERIC = !fails(function () {
	  TypedArrayPrototype[ITERATOR].call([1]);
	});
	
	var ITERATOR_IS_VALUES = !!TypedArrayPrototype
	  && TypedArrayPrototype.values
	  && TypedArrayPrototype[ITERATOR] === TypedArrayPrototype.values
	  && TypedArrayPrototype.values.name === 'values';
	
	var typedArrayValues = function values() {
	  return arrayValues(aTypedArray(this));
	};
	
	// `%TypedArray%.prototype.entries` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.entries
	exportTypedArrayMethod('entries', function entries() {
	  return arrayEntries(aTypedArray(this));
	}, GENERIC);
	// `%TypedArray%.prototype.keys` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.keys
	exportTypedArrayMethod('keys', function keys() {
	  return arrayKeys(aTypedArray(this));
	}, GENERIC);
	// `%TypedArray%.prototype.values` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.values
	exportTypedArrayMethod('values', typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });
	// `%TypedArray%.prototype[@@iterator]` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype-@@iterator
	exportTypedArrayMethod(ITERATOR, typedArrayValues, GENERIC || !ITERATOR_IS_VALUES, { name: 'values' });


/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var uncurryThis = __webpack_require__(8);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var $join = uncurryThis([].join);
	
	// `%TypedArray%.prototype.join` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.join
	exportTypedArrayMethod('join', function join(separator) {
	  return $join(aTypedArray(this), separator);
	});


/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var apply = __webpack_require__(93);
	var $lastIndexOf = __webpack_require__(498);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.lastIndexOf` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.lastindexof
	exportTypedArrayMethod('lastIndexOf', function lastIndexOf(searchElement /* , fromIndex */) {
	  var length = arguments.length;
	  return apply($lastIndexOf, aTypedArray(this), length > 1 ? [searchElement, arguments[1]] : [searchElement]);
	});


/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $map = __webpack_require__(57).map;
	var typedArraySpeciesConstructor = __webpack_require__(267);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.map` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.map
	exportTypedArrayMethod('map', function map(mapfn /* , thisArg */) {
	  return $map(aTypedArray(this), mapfn, arguments.length > 1 ? arguments[1] : undefined, function (O, length) {
	    return new (typedArraySpeciesConstructor(O))(length);
	  });
	});


/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = __webpack_require__(370);
	
	var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor;
	var exportTypedArrayStaticMethod = ArrayBufferViewCore.exportTypedArrayStaticMethod;
	
	// `%TypedArray%.of` method
	// https://tc39.es/ecma262/#sec-%typedarray%.of
	exportTypedArrayStaticMethod('of', function of(/* ...items */) {
	  var index = 0;
	  var length = arguments.length;
	  var result = new (aTypedArrayConstructor(this))(length);
	  while (length > index) result[index] = arguments[index++];
	  return result;
	}, TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS);


/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $reduceRight = __webpack_require__(245).right;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.reduceRight` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduceright
	exportTypedArrayMethod('reduceRight', function reduceRight(callbackfn /* , initialValue */) {
	  var length = arguments.length;
	  return $reduceRight(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $reduce = __webpack_require__(245).left;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reduce
	exportTypedArrayMethod('reduce', function reduce(callbackfn /* , initialValue */) {
	  var length = arguments.length;
	  return $reduce(aTypedArray(this), callbackfn, length, length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var floor = Math.floor;
	
	// `%TypedArray%.prototype.reverse` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.reverse
	exportTypedArrayMethod('reverse', function reverse() {
	  var that = this;
	  var length = aTypedArray(that).length;
	  var middle = floor(length / 2);
	  var index = 0;
	  var value;
	  while (index < middle) {
	    value = that[index];
	    that[index++] = that[--length];
	    that[length] = value;
	  } return that;
	});


/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var call = __webpack_require__(16);
	var ArrayBufferViewCore = __webpack_require__(23);
	var lengthOfArrayLike = __webpack_require__(40);
	var toOffset = __webpack_require__(559);
	var toIndexedObject = __webpack_require__(33);
	var fails = __webpack_require__(7);
	
	var RangeError = global.RangeError;
	var Int8Array = global.Int8Array;
	var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
	var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
	  // eslint-disable-next-line es/no-typed-arrays -- required for testing
	  var array = new Uint8ClampedArray(2);
	  call($set, array, { length: 1, 0: 3 }, 1);
	  return array[1] !== 3;
	});
	
	// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
	var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
	  var array = new Int8Array(2);
	  array.set(1);
	  array.set('2', 1);
	  return array[0] !== 0 || array[1] !== 2;
	});
	
	// `%TypedArray%.prototype.set` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
	exportTypedArrayMethod('set', function set(arrayLike /* , offset */) {
	  aTypedArray(this);
	  var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
	  var src = toIndexedObject(arrayLike);
	  if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS) return call($set, this, src, offset);
	  var length = this.length;
	  var len = lengthOfArrayLike(src);
	  var index = 0;
	  if (len + offset > length) throw new RangeError('Wrong length');
	  while (index < len) this[offset + index] = src[index++];
	}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);


/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var typedArraySpeciesConstructor = __webpack_require__(267);
	var fails = __webpack_require__(7);
	var arraySlice = __webpack_require__(91);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	var FORCED = fails(function () {
	  // eslint-disable-next-line es/no-typed-arrays -- required for testing
	  new Int8Array(1).slice();
	});
	
	// `%TypedArray%.prototype.slice` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.slice
	exportTypedArrayMethod('slice', function slice(start, end) {
	  var list = arraySlice(aTypedArray(this), start, end);
	  var C = typedArraySpeciesConstructor(this);
	  var index = 0;
	  var length = list.length;
	  var result = new C(length);
	  while (length > index) result[index] = list[index++];
	  return result;
	}, FORCED);


/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var $some = __webpack_require__(57).some;
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.some` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.some
	exportTypedArrayMethod('some', function some(callbackfn /* , thisArg */) {
	  return $some(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	});


/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(141);
	var fails = __webpack_require__(7);
	var aCallable = __webpack_require__(36);
	var internalSort = __webpack_require__(338);
	var ArrayBufferViewCore = __webpack_require__(23);
	var FF = __webpack_require__(510);
	var IE_OR_EDGE = __webpack_require__(512);
	var V8 = __webpack_require__(104);
	var WEBKIT = __webpack_require__(343);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var Uint16Array = global.Uint16Array;
	var nativeSort = Uint16Array && uncurryThis(Uint16Array.prototype.sort);
	
	// WebKit
	var ACCEPT_INCORRECT_ARGUMENTS = !!nativeSort && !(fails(function () {
	  nativeSort(new Uint16Array(2), null);
	}) && fails(function () {
	  nativeSort(new Uint16Array(2), {});
	}));
	
	var STABLE_SORT = !!nativeSort && !fails(function () {
	  // feature detection can be too slow, so check engines versions
	  if (V8) return V8 < 74;
	  if (FF) return FF < 67;
	  if (IE_OR_EDGE) return true;
	  if (WEBKIT) return WEBKIT < 602;
	
	  var array = new Uint16Array(516);
	  var expected = Array(516);
	  var index, mod;
	
	  for (index = 0; index < 516; index++) {
	    mod = index % 4;
	    array[index] = 515 - index;
	    expected[index] = index - 2 * mod + 3;
	  }
	
	  nativeSort(array, function (a, b) {
	    return (a / 4 | 0) - (b / 4 | 0);
	  });
	
	  for (index = 0; index < 516; index++) {
	    if (array[index] !== expected[index]) return true;
	  }
	});
	
	var getSortCompare = function (comparefn) {
	  return function (x, y) {
	    if (comparefn !== undefined) return +comparefn(x, y) || 0;
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (y !== y) return -1;
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (x !== x) return 1;
	    if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
	    return x > y;
	  };
	};
	
	// `%TypedArray%.prototype.sort` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
	exportTypedArrayMethod('sort', function sort(comparefn) {
	  if (comparefn !== undefined) aCallable(comparefn);
	  if (STABLE_SORT) return nativeSort(this, comparefn);
	
	  return internalSort(aTypedArray(this), getSortCompare(comparefn));
	}, !STABLE_SORT || ACCEPT_INCORRECT_ARGUMENTS);


/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var toLength = __webpack_require__(80);
	var toAbsoluteIndex = __webpack_require__(107);
	var typedArraySpeciesConstructor = __webpack_require__(267);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	// `%TypedArray%.prototype.subarray` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.subarray
	exportTypedArrayMethod('subarray', function subarray(begin, end) {
	  var O = aTypedArray(this);
	  var length = O.length;
	  var beginIndex = toAbsoluteIndex(begin, length);
	  var C = typedArraySpeciesConstructor(O);
	  return new C(
	    O.buffer,
	    O.byteOffset + beginIndex * O.BYTES_PER_ELEMENT,
	    toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - beginIndex)
	  );
	});


/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var apply = __webpack_require__(93);
	var ArrayBufferViewCore = __webpack_require__(23);
	var fails = __webpack_require__(7);
	var arraySlice = __webpack_require__(91);
	
	var Int8Array = global.Int8Array;
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var $toLocaleString = [].toLocaleString;
	
	// iOS Safari 6.x fails here
	var TO_LOCALE_STRING_BUG = !!Int8Array && fails(function () {
	  $toLocaleString.call(new Int8Array(1));
	});
	
	var FORCED = fails(function () {
	  return [1, 2].toLocaleString() !== new Int8Array([1, 2]).toLocaleString();
	}) || !fails(function () {
	  Int8Array.prototype.toLocaleString.call([1, 2]);
	});
	
	// `%TypedArray%.prototype.toLocaleString` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
	exportTypedArrayMethod('toLocaleString', function toLocaleString() {
	  return apply(
	    $toLocaleString,
	    TO_LOCALE_STRING_BUG ? arraySlice(aTypedArray(this)) : aTypedArray(this),
	    arraySlice(arguments)
	  );
	}, FORCED);


/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var arrayToReversed = __webpack_require__(499);
	var ArrayBufferViewCore = __webpack_require__(23);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	
	// `%TypedArray%.prototype.toReversed` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.toreversed
	exportTypedArrayMethod('toReversed', function toReversed() {
	  return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
	});


/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ArrayBufferViewCore = __webpack_require__(23);
	var uncurryThis = __webpack_require__(8);
	var aCallable = __webpack_require__(36);
	var arrayFromConstructorAndList = __webpack_require__(243);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);
	
	// `%TypedArray%.prototype.toSorted` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tosorted
	exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
	  if (compareFn !== undefined) aCallable(compareFn);
	  var O = aTypedArray(this);
	  var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
	  return sort(A, compareFn);
	});


/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var exportTypedArrayMethod = __webpack_require__(23).exportTypedArrayMethod;
	var fails = __webpack_require__(7);
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(8);
	
	var Uint8Array = global.Uint8Array;
	var Uint8ArrayPrototype = Uint8Array && Uint8Array.prototype || {};
	var arrayToString = [].toString;
	var join = uncurryThis([].join);
	
	if (fails(function () { arrayToString.call({}); })) {
	  arrayToString = function toString() {
	    return join(this);
	  };
	}
	
	var IS_NOT_ARRAY_METHOD = Uint8ArrayPrototype.toString !== arrayToString;
	
	// `%TypedArray%.prototype.toString` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tostring
	exportTypedArrayMethod('toString', arrayToString, IS_NOT_ARRAY_METHOD);


/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Uint16Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint16', function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Uint32Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint32', function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Uint8Array` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint8', function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var createTypedArrayConstructor = __webpack_require__(108);
	
	// `Uint8ClampedArray` constructor
	// https://tc39.es/ecma262/#sec-typedarray-objects
	createTypedArrayConstructor('Uint8', function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var arrayWith = __webpack_require__(500);
	var ArrayBufferViewCore = __webpack_require__(23);
	var isBigIntArray = __webpack_require__(523);
	var toIntegerOrInfinity = __webpack_require__(49);
	var toBigInt = __webpack_require__(367);
	
	var aTypedArray = ArrayBufferViewCore.aTypedArray;
	var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
	var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
	
	var PROPER_ORDER = !!function () {
	  try {
	    // eslint-disable-next-line no-throw-literal, es/no-typed-arrays, es/no-array-prototype-with -- required for testing
	    new Int8Array(1)['with'](2, { valueOf: function () { throw 8; } });
	  } catch (error) {
	    // some early implementations, like WebKit, does not follow the final semantic
	    // https://github.com/tc39/proposal-change-array-by-copy/pull/86
	    return error === 8;
	  }
	}();
	
	// `%TypedArray%.prototype.with` method
	// https://tc39.es/ecma262/#sec-%typedarray%.prototype.with
	exportTypedArrayMethod('with', { 'with': function (index, value) {
	  var O = aTypedArray(this);
	  var relativeIndex = toIntegerOrInfinity(index);
	  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
	  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
	} }['with'], !PROPER_ORDER);


/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(17);
	
	var fromCharCode = String.fromCharCode;
	var charAt = uncurryThis(''.charAt);
	var exec = uncurryThis(/./.exec);
	var stringSlice = uncurryThis(''.slice);
	
	var hex2 = /^[\da-f]{2}$/i;
	var hex4 = /^[\da-f]{4}$/i;
	
	// `unescape` method
	// https://tc39.es/ecma262/#sec-unescape-string
	$({ global: true }, {
	  unescape: function unescape(string) {
	    var str = toString(string);
	    var result = '';
	    var length = str.length;
	    var index = 0;
	    var chr, part;
	    while (index < length) {
	      chr = charAt(str, index++);
	      if (chr === '%') {
	        if (charAt(str, index) === 'u') {
	          part = stringSlice(str, index + 1, index + 5);
	          if (exec(hex4, part)) {
	            result += fromCharCode(parseInt(part, 16));
	            index += 5;
	            continue;
	          }
	        } else {
	          part = stringSlice(str, index, index + 2);
	          if (exec(hex2, part)) {
	            result += fromCharCode(parseInt(part, 16));
	            index += 2;
	            continue;
	          }
	        }
	      }
	      result += chr;
	    } return result;
	  }
	});


/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var FREEZING = __webpack_require__(164);
	var global = __webpack_require__(11);
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIns = __webpack_require__(203);
	var InternalMetadataModule = __webpack_require__(144);
	var collection = __webpack_require__(247);
	var collectionWeak = __webpack_require__(505);
	var isObject = __webpack_require__(20);
	var enforceInternalState = __webpack_require__(52).enforce;
	var fails = __webpack_require__(7);
	var NATIVE_WEAK_MAP = __webpack_require__(564);
	
	var $Object = Object;
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray = Array.isArray;
	// eslint-disable-next-line es/no-object-isextensible -- safe
	var isExtensible = $Object.isExtensible;
	// eslint-disable-next-line es/no-object-isfrozen -- safe
	var isFrozen = $Object.isFrozen;
	// eslint-disable-next-line es/no-object-issealed -- safe
	var isSealed = $Object.isSealed;
	// eslint-disable-next-line es/no-object-freeze -- safe
	var freeze = $Object.freeze;
	// eslint-disable-next-line es/no-object-seal -- safe
	var seal = $Object.seal;
	
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var InternalWeakMap;
	
	var wrapper = function (init) {
	  return function WeakMap() {
	    return init(this, arguments.length ? arguments[0] : undefined);
	  };
	};
	
	// `WeakMap` constructor
	// https://tc39.es/ecma262/#sec-weakmap-constructor
	var $WeakMap = collection('WeakMap', wrapper, collectionWeak);
	var WeakMapPrototype = $WeakMap.prototype;
	var nativeSet = uncurryThis(WeakMapPrototype.set);
	
	// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
	var hasMSEdgeFreezingBug = function () {
	  return FREEZING && fails(function () {
	    var frozenArray = freeze([]);
	    nativeSet(new $WeakMap(), frozenArray, 1);
	    return !isFrozen(frozenArray);
	  });
	};
	
	// IE11 WeakMap frozen keys fix
	// We can't use feature detection because it crash some old IE builds
	// https://github.com/zloirock/core-js/issues/485
	if (NATIVE_WEAK_MAP) if (IS_IE11) {
	  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
	  InternalMetadataModule.enable();
	  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
	  var nativeHas = uncurryThis(WeakMapPrototype.has);
	  var nativeGet = uncurryThis(WeakMapPrototype.get);
	  defineBuiltIns(WeakMapPrototype, {
	    'delete': function (key) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeDelete(this, key) || state.frozen['delete'](key);
	      } return nativeDelete(this, key);
	    },
	    has: function has(key) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeHas(this, key) || state.frozen.has(key);
	      } return nativeHas(this, key);
	    },
	    get: function get(key) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
	      } return nativeGet(this, key);
	    },
	    set: function set(key, value) {
	      if (isObject(key) && !isExtensible(key)) {
	        var state = enforceInternalState(this);
	        if (!state.frozen) state.frozen = new InternalWeakMap();
	        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
	      } else nativeSet(this, key, value);
	      return this;
	    }
	  });
	// Chakra Edge frozen keys fix
	} else if (hasMSEdgeFreezingBug()) {
	  defineBuiltIns(WeakMapPrototype, {
	    set: function set(key, value) {
	      var arrayIntegrityLevel;
	      if (isArray(key)) {
	        if (isFrozen(key)) arrayIntegrityLevel = freeze;
	        else if (isSealed(key)) arrayIntegrityLevel = seal;
	      }
	      nativeSet(this, key, value);
	      if (arrayIntegrityLevel) arrayIntegrityLevel(key);
	      return this;
	    }
	  });
	}


/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1466);


/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var collection = __webpack_require__(247);
	var collectionWeak = __webpack_require__(505);
	
	// `WeakSet` constructor
	// https://tc39.es/ecma262/#sec-weakset-constructor
	collection('WeakSet', function (init) {
	  return function WeakSet() { return init(this, arguments.length ? arguments[0] : undefined); };
	}, collectionWeak);


/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1468);


/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var wellKnownSymbol = __webpack_require__(21);
	var defineProperty = __webpack_require__(41).f;
	
	var METADATA = wellKnownSymbol('metadata');
	var FunctionPrototype = Function.prototype;
	
	// Function.prototype[@@metadata]
	// https://github.com/tc39/proposal-decorator-metadata
	if (FunctionPrototype[METADATA] === undefined) {
	  defineProperty(FunctionPrototype, METADATA, {
	    value: null
	  });
	}


/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aMap = __webpack_require__(70);
	var remove = __webpack_require__(72).remove;
	
	// `Map.prototype.deleteAll` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  deleteAll: function deleteAll(/* ...elements */) {
	    var collection = aMap(this);
	    var allDeleted = true;
	    var wasDeleted;
	    for (var k = 0, len = arguments.length; k < len; k++) {
	      wasDeleted = remove(collection, arguments[k]);
	      allDeleted = allDeleted && wasDeleted;
	    } return !!allDeleted;
	  }
	});


/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aMap = __webpack_require__(70);
	var MapHelpers = __webpack_require__(72);
	
	var get = MapHelpers.get;
	var has = MapHelpers.has;
	var set = MapHelpers.set;
	
	// `Map.prototype.emplace` method
	// https://github.com/tc39/proposal-upsert
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  emplace: function emplace(key, handler) {
	    var map = aMap(this);
	    var value, inserted;
	    if (has(map, key)) {
	      value = get(map, key);
	      if ('update' in handler) {
	        value = handler.update(value, key, map);
	        set(map, key, value);
	      } return value;
	    }
	    inserted = handler.insert(key, map);
	    set(map, key, inserted);
	    return inserted;
	  }
	});


/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(99);
	
	// `Map.prototype.every` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  every: function every(callbackfn /* , thisArg */) {
	    var map = aMap(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return iterate(map, function (value, key) {
	      if (!boundFunction(value, key, map)) return false;
	    }, true) !== false;
	  }
	});


/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aMap = __webpack_require__(70);
	var MapHelpers = __webpack_require__(72);
	var iterate = __webpack_require__(99);
	
	var Map = MapHelpers.Map;
	var set = MapHelpers.set;
	
	// `Map.prototype.filter` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    var map = aMap(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var newMap = new Map();
	    iterate(map, function (value, key) {
	      if (boundFunction(value, key, map)) set(newMap, key, value);
	    });
	    return newMap;
	  }
	});


/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(99);
	
	// `Map.prototype.findKey` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  findKey: function findKey(callbackfn /* , thisArg */) {
	    var map = aMap(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var result = iterate(map, function (value, key) {
	      if (boundFunction(value, key, map)) return { key: key };
	    }, true);
	    return result && result.key;
	  }
	});


/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(99);
	
	// `Map.prototype.find` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  find: function find(callbackfn /* , thisArg */) {
	    var map = aMap(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var result = iterate(map, function (value, key) {
	      if (boundFunction(value, key, map)) return { value: value };
	    }, true);
	    return result && result.value;
	  }
	});


/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var MapHelpers = __webpack_require__(72);
	var createCollectionFrom = __webpack_require__(502);
	
	// `Map.from` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	$({ target: 'Map', stat: true, forced: true }, {
	  from: createCollectionFrom(MapHelpers.Map, MapHelpers.set, true)
	});


/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(371);


/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var sameValueZero = __webpack_require__(1257);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(99);
	
	// `Map.prototype.includes` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  includes: function includes(searchElement) {
	    return iterate(aMap(this), function (value) {
	      if (sameValueZero(value, searchElement)) return true;
	    }, true) === true;
	  }
	});


/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var iterate = __webpack_require__(67);
	var isCallable = __webpack_require__(22);
	var aCallable = __webpack_require__(36);
	var Map = __webpack_require__(72).Map;
	
	// `Map.keyBy` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', stat: true, forced: true }, {
	  keyBy: function keyBy(iterable, keyDerivative) {
	    var C = isCallable(this) ? this : Map;
	    var newMap = new C();
	    aCallable(keyDerivative);
	    var setter = aCallable(newMap.set);
	    iterate(iterable, function (element) {
	      call(setter, newMap, keyDerivative(element), element);
	    });
	    return newMap;
	  }
	});


/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(99);
	
	// `Map.prototype.keyOf` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  keyOf: function keyOf(searchElement) {
	    var result = iterate(aMap(this), function (value, key) {
	      if (value === searchElement) return { key: key };
	    }, true);
	    return result && result.key;
	  }
	});


/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aMap = __webpack_require__(70);
	var MapHelpers = __webpack_require__(72);
	var iterate = __webpack_require__(99);
	
	var Map = MapHelpers.Map;
	var set = MapHelpers.set;
	
	// `Map.prototype.mapKeys` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  mapKeys: function mapKeys(callbackfn /* , thisArg */) {
	    var map = aMap(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var newMap = new Map();
	    iterate(map, function (value, key) {
	      set(newMap, boundFunction(value, key, map), value);
	    });
	    return newMap;
	  }
	});


/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aMap = __webpack_require__(70);
	var MapHelpers = __webpack_require__(72);
	var iterate = __webpack_require__(99);
	
	var Map = MapHelpers.Map;
	var set = MapHelpers.set;
	
	// `Map.prototype.mapValues` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  mapValues: function mapValues(callbackfn /* , thisArg */) {
	    var map = aMap(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var newMap = new Map();
	    iterate(map, function (value, key) {
	      set(newMap, key, boundFunction(value, key, map));
	    });
	    return newMap;
	  }
	});


/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(67);
	var set = __webpack_require__(72).set;
	
	// `Map.prototype.merge` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, arity: 1, forced: true }, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  merge: function merge(iterable /* ...iterables */) {
	    var map = aMap(this);
	    var argumentsLength = arguments.length;
	    var i = 0;
	    while (i < argumentsLength) {
	      iterate(arguments[i++], function (key, value) {
	        set(map, key, value);
	      }, { AS_ENTRIES: true });
	    }
	    return map;
	  }
	});


/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var MapHelpers = __webpack_require__(72);
	var createCollectionOf = __webpack_require__(503);
	
	// `Map.of` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	$({ target: 'Map', stat: true, forced: true }, {
	  of: createCollectionOf(MapHelpers.Map, MapHelpers.set, true)
	});


/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aCallable = __webpack_require__(36);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(99);
	
	var $TypeError = TypeError;
	
	// `Map.prototype.reduce` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    var map = aMap(this);
	    var noInitial = arguments.length < 2;
	    var accumulator = noInitial ? undefined : arguments[1];
	    aCallable(callbackfn);
	    iterate(map, function (value, key) {
	      if (noInitial) {
	        noInitial = false;
	        accumulator = value;
	      } else {
	        accumulator = callbackfn(accumulator, value, key, map);
	      }
	    });
	    if (noInitial) throw new $TypeError('Reduce of empty map with no initial value');
	    return accumulator;
	  }
	});


/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aMap = __webpack_require__(70);
	var iterate = __webpack_require__(99);
	
	// `Map.prototype.some` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  some: function some(callbackfn /* , thisArg */) {
	    var map = aMap(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return iterate(map, function (value, key) {
	      if (boundFunction(value, key, map)) return true;
	    }, true) === true;
	  }
	});


/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: remove from `core-js@4`
	var $ = __webpack_require__(4);
	var upsert = __webpack_require__(527);
	
	// `Map.prototype.updateOrInsert` method (replaced by `Map.prototype.emplace`)
	// https://github.com/thumbsupep/proposal-upsert
	$({ target: 'Map', proto: true, real: true, name: 'upsert', forced: true }, {
	  updateOrInsert: upsert
	});


/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aCallable = __webpack_require__(36);
	var aMap = __webpack_require__(70);
	var MapHelpers = __webpack_require__(72);
	
	var $TypeError = TypeError;
	var get = MapHelpers.get;
	var has = MapHelpers.has;
	var set = MapHelpers.set;
	
	// `Map.prototype.update` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  update: function update(key, callback /* , thunk */) {
	    var map = aMap(this);
	    var length = arguments.length;
	    aCallable(callback);
	    var isPresentInMap = has(map, key);
	    if (!isPresentInMap && length < 3) {
	      throw new $TypeError('Updating absent value');
	    }
	    var value = isPresentInMap ? get(map, key) : aCallable(length > 2 ? arguments[2] : undefined)(key, map);
	    set(map, key, callback(value, key, map));
	    return map;
	  }
	});


/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: remove from `core-js@4`
	var $ = __webpack_require__(4);
	var upsert = __webpack_require__(527);
	
	// `Map.prototype.upsert` method (replaced by `Map.prototype.emplace`)
	// https://github.com/thumbsupep/proposal-upsert
	$({ target: 'Map', proto: true, real: true, forced: true }, {
	  upsert: upsert
	});


/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aSet = __webpack_require__(60);
	var add = __webpack_require__(59).add;
	
	// `Set.prototype.addAll` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  addAll: function addAll(/* ...elements */) {
	    var set = aSet(this);
	    for (var k = 0, len = arguments.length; k < len; k++) {
	      add(set, arguments[k]);
	    } return set;
	  }
	});


/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aSet = __webpack_require__(60);
	var remove = __webpack_require__(59).remove;
	
	// `Set.prototype.deleteAll` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  deleteAll: function deleteAll(/* ...elements */) {
	    var collection = aSet(this);
	    var allDeleted = true;
	    var wasDeleted;
	    for (var k = 0, len = arguments.length; k < len; k++) {
	      wasDeleted = remove(collection, arguments[k]);
	      allDeleted = allDeleted && wasDeleted;
	    } return !!allDeleted;
	  }
	});


/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var toSetLike = __webpack_require__(148);
	var $difference = __webpack_require__(545);
	
	// `Set.prototype.difference` method
	// https://github.com/tc39/proposal-set-methods
	// TODO: Obsolete version, remove from `core-js@4`
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  difference: function difference(other) {
	    return call($difference, this, toSetLike(other));
	  }
	});


/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(374);


/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aSet = __webpack_require__(60);
	var iterate = __webpack_require__(78);
	
	// `Set.prototype.every` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  every: function every(callbackfn /* , thisArg */) {
	    var set = aSet(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return iterate(set, function (value) {
	      if (!boundFunction(value, value, set)) return false;
	    }, true) !== false;
	  }
	});


/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aSet = __webpack_require__(60);
	var SetHelpers = __webpack_require__(59);
	var iterate = __webpack_require__(78);
	
	var Set = SetHelpers.Set;
	var add = SetHelpers.add;
	
	// `Set.prototype.filter` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  filter: function filter(callbackfn /* , thisArg */) {
	    var set = aSet(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var newSet = new Set();
	    iterate(set, function (value) {
	      if (boundFunction(value, value, set)) add(newSet, value);
	    });
	    return newSet;
	  }
	});


/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aSet = __webpack_require__(60);
	var iterate = __webpack_require__(78);
	
	// `Set.prototype.find` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  find: function find(callbackfn /* , thisArg */) {
	    var set = aSet(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var result = iterate(set, function (value) {
	      if (boundFunction(value, value, set)) return { value: value };
	    }, true);
	    return result && result.value;
	  }
	});


/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var SetHelpers = __webpack_require__(59);
	var createCollectionFrom = __webpack_require__(502);
	
	// `Set.from` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	$({ target: 'Set', stat: true, forced: true }, {
	  from: createCollectionFrom(SetHelpers.Set, SetHelpers.add, false)
	});


/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var toSetLike = __webpack_require__(148);
	var $intersection = __webpack_require__(546);
	
	// `Set.prototype.intersection` method
	// https://github.com/tc39/proposal-set-methods
	// TODO: Obsolete version, remove from `core-js@4`
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  intersection: function intersection(other) {
	    return call($intersection, this, toSetLike(other));
	  }
	});


/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(375);


/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var toSetLike = __webpack_require__(148);
	var $isDisjointFrom = __webpack_require__(547);
	
	// `Set.prototype.isDisjointFrom` method
	// https://github.com/tc39/proposal-set-methods
	// TODO: Obsolete version, remove from `core-js@4`
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  isDisjointFrom: function isDisjointFrom(other) {
	    return call($isDisjointFrom, this, toSetLike(other));
	  }
	});


/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(376);


/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var toSetLike = __webpack_require__(148);
	var $isSubsetOf = __webpack_require__(548);
	
	// `Set.prototype.isSubsetOf` method
	// https://github.com/tc39/proposal-set-methods
	// TODO: Obsolete version, remove from `core-js@4`
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  isSubsetOf: function isSubsetOf(other) {
	    return call($isSubsetOf, this, toSetLike(other));
	  }
	});


/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(377);


/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var toSetLike = __webpack_require__(148);
	var $isSupersetOf = __webpack_require__(549);
	
	// `Set.prototype.isSupersetOf` method
	// https://github.com/tc39/proposal-set-methods
	// TODO: Obsolete version, remove from `core-js@4`
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  isSupersetOf: function isSupersetOf(other) {
	    return call($isSupersetOf, this, toSetLike(other));
	  }
	});


/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(378);


/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var uncurryThis = __webpack_require__(8);
	var aSet = __webpack_require__(60);
	var iterate = __webpack_require__(78);
	var toString = __webpack_require__(17);
	
	var arrayJoin = uncurryThis([].join);
	var push = uncurryThis([].push);
	
	// `Set.prototype.join` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  join: function join(separator) {
	    var set = aSet(this);
	    var sep = separator === undefined ? ',' : toString(separator);
	    var array = [];
	    iterate(set, function (value) {
	      push(array, value);
	    });
	    return arrayJoin(array, sep);
	  }
	});


/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aSet = __webpack_require__(60);
	var SetHelpers = __webpack_require__(59);
	var iterate = __webpack_require__(78);
	
	var Set = SetHelpers.Set;
	var add = SetHelpers.add;
	
	// `Set.prototype.map` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  map: function map(callbackfn /* , thisArg */) {
	    var set = aSet(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    var newSet = new Set();
	    iterate(set, function (value) {
	      add(newSet, boundFunction(value, value, set));
	    });
	    return newSet;
	  }
	});


/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var SetHelpers = __webpack_require__(59);
	var createCollectionOf = __webpack_require__(503);
	
	// `Set.of` method
	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	$({ target: 'Set', stat: true, forced: true }, {
	  of: createCollectionOf(SetHelpers.Set, SetHelpers.add, false)
	});


/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var aCallable = __webpack_require__(36);
	var aSet = __webpack_require__(60);
	var iterate = __webpack_require__(78);
	
	var $TypeError = TypeError;
	
	// `Set.prototype.reduce` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    var set = aSet(this);
	    var noInitial = arguments.length < 2;
	    var accumulator = noInitial ? undefined : arguments[1];
	    aCallable(callbackfn);
	    iterate(set, function (value) {
	      if (noInitial) {
	        noInitial = false;
	        accumulator = value;
	      } else {
	        accumulator = callbackfn(accumulator, value, value, set);
	      }
	    });
	    if (noInitial) throw new $TypeError('Reduce of empty set with no initial value');
	    return accumulator;
	  }
	});


/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var bind = __webpack_require__(45);
	var aSet = __webpack_require__(60);
	var iterate = __webpack_require__(78);
	
	// `Set.prototype.some` method
	// https://github.com/tc39/proposal-collection-methods
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  some: function some(callbackfn /* , thisArg */) {
	    var set = aSet(this);
	    var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    return iterate(set, function (value) {
	      if (boundFunction(value, value, set)) return true;
	    }, true) === true;
	  }
	});


/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var toSetLike = __webpack_require__(148);
	var $symmetricDifference = __webpack_require__(550);
	
	// `Set.prototype.symmetricDifference` method
	// https://github.com/tc39/proposal-set-methods
	// TODO: Obsolete version, remove from `core-js@4`
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  symmetricDifference: function symmetricDifference(other) {
	    return call($symmetricDifference, this, toSetLike(other));
	  }
	});


/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(379);


/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	var toSetLike = __webpack_require__(148);
	var $union = __webpack_require__(551);
	
	// `Set.prototype.union` method
	// https://github.com/tc39/proposal-set-methods
	// TODO: Obsolete version, remove from `core-js@4`
	$({ target: 'Set', proto: true, real: true, forced: true }, {
	  union: function union(other) {
	    return call($union, this, toSetLike(other));
	  }
	});


/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	__webpack_require__(380);


/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var defineWellKnownSymbol = __webpack_require__(47);
	var defineProperty = __webpack_require__(41).f;
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	var Symbol = global.Symbol;
	
	// `Symbol.asyncDispose` well-known symbol
	// https://github.com/tc39/proposal-async-explicit-resource-management
	defineWellKnownSymbol('asyncDispose');
	
	if (Symbol) {
	  var descriptor = getOwnPropertyDescriptor(Symbol, 'asyncDispose');
	  // workaround of NodeJS 20.4 bug
	  // https://github.com/nodejs/node/issues/48699
	  // and incorrect descriptor from some transpilers and userland helpers
	  if (descriptor.enumerable && descriptor.configurable && descriptor.writable) {
	    defineProperty(Symbol, 'asyncDispose', { value: descriptor.value, enumerable: false, configurable: false, writable: false });
	  }
	}


/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.customMatcher` well-known symbol
	// https://github.com/tc39/proposal-pattern-matching
	defineWellKnownSymbol('customMatcher');


/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var defineWellKnownSymbol = __webpack_require__(47);
	var defineProperty = __webpack_require__(41).f;
	var getOwnPropertyDescriptor = __webpack_require__(58).f;
	
	var Symbol = global.Symbol;
	
	// `Symbol.dispose` well-known symbol
	// https://github.com/tc39/proposal-explicit-resource-management
	defineWellKnownSymbol('dispose');
	
	if (Symbol) {
	  var descriptor = getOwnPropertyDescriptor(Symbol, 'dispose');
	  // workaround of NodeJS 20.4 bug
	  // https://github.com/nodejs/node/issues/48699
	  // and incorrect descriptor from some transpilers and userland helpers
	  if (descriptor.enumerable && descriptor.configurable && descriptor.writable) {
	    defineProperty(Symbol, 'dispose', { value: descriptor.value, enumerable: false, configurable: false, writable: false });
	  }
	}


/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isRegisteredSymbol = __webpack_require__(556);
	
	// `Symbol.isRegisteredSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
	$({ target: 'Symbol', stat: true }, {
	  isRegisteredSymbol: isRegisteredSymbol
	});


/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isRegisteredSymbol = __webpack_require__(556);
	
	// `Symbol.isRegistered` method
	// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-isregisteredsymbol
	$({ target: 'Symbol', stat: true, name: 'isRegisteredSymbol' }, {
	  isRegistered: isRegisteredSymbol
	});


/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isWellKnownSymbol = __webpack_require__(557);
	
	// `Symbol.isWellKnownSymbol` method
	// https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
	// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
	$({ target: 'Symbol', stat: true, forced: true }, {
	  isWellKnownSymbol: isWellKnownSymbol
	});


/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var isWellKnownSymbol = __webpack_require__(557);
	
	// `Symbol.isWellKnown` method
	// obsolete version of https://tc39.es/proposal-symbol-predicates/#sec-symbol-iswellknownsymbol
	// We should patch it for newly added well-known symbols. If it's not required, this module just will not be injected
	$({ target: 'Symbol', stat: true, name: 'isWellKnownSymbol', forced: true }, {
	  isWellKnown: isWellKnownSymbol
	});


/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.matcher` well-known symbol
	// https://github.com/tc39/proposal-pattern-matching
	defineWellKnownSymbol('matcher');


/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove from `core-js@4`
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.metadataKey` well-known symbol
	// https://github.com/tc39/proposal-decorator-metadata
	defineWellKnownSymbol('metadataKey');


/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.metadata` well-known symbol
	// https://github.com/tc39/proposal-decorators
	defineWellKnownSymbol('metadata');


/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.observable` well-known symbol
	// https://github.com/tc39/proposal-observable
	defineWellKnownSymbol('observable');


/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: remove from `core-js@4`
	var defineWellKnownSymbol = __webpack_require__(47);
	
	// `Symbol.patternMatch` well-known symbol
	// https://github.com/tc39/proposal-pattern-matching
	defineWellKnownSymbol('patternMatch');


/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: remove from `core-js@4`
	var defineWellKnownSymbol = __webpack_require__(47);
	
	defineWellKnownSymbol('replaceAll');


/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var getBuiltIn = __webpack_require__(35);
	var uncurryThis = __webpack_require__(8);
	var call = __webpack_require__(16);
	var fails = __webpack_require__(7);
	var toString = __webpack_require__(17);
	var validateArgumentsLength = __webpack_require__(87);
	var c2i = __webpack_require__(501).c2i;
	
	var disallowed = /[^\d+/a-z]/i;
	var whitespaces = /[\t\n\f\r ]+/g;
	var finalEq = /[=]{1,2}$/;
	
	var $atob = getBuiltIn('atob');
	var fromCharCode = String.fromCharCode;
	var charAt = uncurryThis(''.charAt);
	var replace = uncurryThis(''.replace);
	var exec = uncurryThis(disallowed.exec);
	
	var BASIC = !!$atob && !fails(function () {
	  return $atob('aGk=') !== 'hi';
	});
	
	var NO_SPACES_IGNORE = BASIC && fails(function () {
	  return $atob(' ') !== '';
	});
	
	var NO_ENCODING_CHECK = BASIC && !fails(function () {
	  $atob('a');
	});
	
	var NO_ARG_RECEIVING_CHECK = BASIC && !fails(function () {
	  $atob();
	});
	
	var WRONG_ARITY = BASIC && $atob.length !== 1;
	
	var FORCED = !BASIC || NO_SPACES_IGNORE || NO_ENCODING_CHECK || NO_ARG_RECEIVING_CHECK || WRONG_ARITY;
	
	// `atob` method
	// https://html.spec.whatwg.org/multipage/webappapis.html#dom-atob
	$({ global: true, bind: true, enumerable: true, forced: FORCED }, {
	  atob: function atob(data) {
	    validateArgumentsLength(arguments.length, 1);
	    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
	    if (BASIC && !NO_SPACES_IGNORE && !NO_ENCODING_CHECK) return call($atob, global, data);
	    var string = replace(toString(data), whitespaces, '');
	    var output = '';
	    var position = 0;
	    var bc = 0;
	    var length, chr, bs;
	    if (string.length % 4 === 0) {
	      string = replace(string, finalEq, '');
	    }
	    length = string.length;
	    if (length % 4 === 1 || exec(disallowed, string)) {
	      throw new (getBuiltIn('DOMException'))('The string is not correctly encoded', 'InvalidCharacterError');
	    }
	    while (position < length) {
	      chr = charAt(string, position++);
	      bs = bc % 4 ? bs * 64 + c2i[chr] : c2i[chr];
	      if (bc++ % 4) output += fromCharCode(255 & bs >> (-2 * bc & 6));
	    } return output;
	  }
	});


/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var getBuiltIn = __webpack_require__(35);
	var uncurryThis = __webpack_require__(8);
	var call = __webpack_require__(16);
	var fails = __webpack_require__(7);
	var toString = __webpack_require__(17);
	var validateArgumentsLength = __webpack_require__(87);
	var i2c = __webpack_require__(501).i2c;
	
	var $btoa = getBuiltIn('btoa');
	var charAt = uncurryThis(''.charAt);
	var charCodeAt = uncurryThis(''.charCodeAt);
	
	var BASIC = !!$btoa && !fails(function () {
	  return $btoa('hi') !== 'aGk=';
	});
	
	var NO_ARG_RECEIVING_CHECK = BASIC && !fails(function () {
	  $btoa();
	});
	
	var WRONG_ARG_CONVERSION = BASIC && fails(function () {
	  return $btoa(null) !== 'bnVsbA==';
	});
	
	var WRONG_ARITY = BASIC && $btoa.length !== 1;
	
	// `btoa` method
	// https://html.spec.whatwg.org/multipage/webappapis.html#dom-btoa
	$({ global: true, bind: true, enumerable: true, forced: !BASIC || NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY }, {
	  btoa: function btoa(data) {
	    validateArgumentsLength(arguments.length, 1);
	    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
	    if (BASIC) return call($btoa, global, toString(data));
	    var string = toString(data);
	    var output = '';
	    var position = 0;
	    var map = i2c;
	    var block, charCode;
	    while (charAt(string, position) || (map = '=', position % 1)) {
	      charCode = charCodeAt(string, position += 3 / 4);
	      if (charCode > 0xFF) {
	        throw new (getBuiltIn('DOMException'))('The string contains characters outside of the Latin1 range', 'InvalidCharacterError');
	      }
	      block = block << 8 | charCode;
	      output += charAt(map, 63 & block >> 8 - position % 1 * 8);
	    } return output;
	  }
	});


/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var clearImmediate = __webpack_require__(264).clear;
	
	// `clearImmediate` method
	// http://w3c.github.io/setImmediate/#si-clearImmediate
	$({ global: true, bind: true, enumerable: true, forced: global.clearImmediate !== clearImmediate }, {
	  clearImmediate: clearImmediate
	});


/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(11);
	var DOMIterables = __webpack_require__(508);
	var DOMTokenListPrototype = __webpack_require__(509);
	var forEach = __webpack_require__(496);
	var createNonEnumerableProperty = __webpack_require__(65);
	
	var handlePrototype = function (CollectionPrototype) {
	  // some Chrome versions have non-configurable methods on DOMTokenList
	  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
	    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
	  } catch (error) {
	    CollectionPrototype.forEach = forEach;
	  }
	};
	
	for (var COLLECTION_NAME in DOMIterables) {
	  if (DOMIterables[COLLECTION_NAME]) {
	    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
	  }
	}
	
	handlePrototype(DOMTokenListPrototype);


/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var tryNodeRequire = __webpack_require__(560);
	var getBuiltIn = __webpack_require__(35);
	var fails = __webpack_require__(7);
	var create = __webpack_require__(76);
	var createPropertyDescriptor = __webpack_require__(85);
	var defineProperty = __webpack_require__(41).f;
	var defineBuiltIn = __webpack_require__(44);
	var defineBuiltInAccessor = __webpack_require__(54);
	var hasOwn = __webpack_require__(28);
	var anInstance = __webpack_require__(98);
	var anObject = __webpack_require__(18);
	var errorToString = __webpack_require__(516);
	var normalizeStringArgument = __webpack_require__(208);
	var DOMExceptionConstants = __webpack_require__(507);
	var clearErrorStack = __webpack_require__(345);
	var InternalStateModule = __webpack_require__(52);
	var DESCRIPTORS = __webpack_require__(15);
	var IS_PURE = __webpack_require__(48);
	
	var DOM_EXCEPTION = 'DOMException';
	var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
	var Error = getBuiltIn('Error');
	// NodeJS < 17.0 does not expose `DOMException` to global
	var NativeDOMException = getBuiltIn(DOM_EXCEPTION) || (function () {
	  try {
	    // NodeJS < 15.0 does not expose `MessageChannel` to global
	    var MessageChannel = getBuiltIn('MessageChannel') || tryNodeRequire('worker_threads').MessageChannel;
	    // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe
	    new MessageChannel().port1.postMessage(new WeakMap());
	  } catch (error) {
	    if (error.name === DATA_CLONE_ERR && error.code === 25) return error.constructor;
	  }
	})();
	var NativeDOMExceptionPrototype = NativeDOMException && NativeDOMException.prototype;
	var ErrorPrototype = Error.prototype;
	var setInternalState = InternalStateModule.set;
	var getInternalState = InternalStateModule.getterFor(DOM_EXCEPTION);
	var HAS_STACK = 'stack' in new Error(DOM_EXCEPTION);
	
	var codeFor = function (name) {
	  return hasOwn(DOMExceptionConstants, name) && DOMExceptionConstants[name].m ? DOMExceptionConstants[name].c : 0;
	};
	
	var $DOMException = function DOMException() {
	  anInstance(this, DOMExceptionPrototype);
	  var argumentsLength = arguments.length;
	  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
	  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
	  var code = codeFor(name);
	  setInternalState(this, {
	    type: DOM_EXCEPTION,
	    name: name,
	    message: message,
	    code: code
	  });
	  if (!DESCRIPTORS) {
	    this.name = name;
	    this.message = message;
	    this.code = code;
	  }
	  if (HAS_STACK) {
	    var error = new Error(message);
	    error.name = DOM_EXCEPTION;
	    defineProperty(this, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
	  }
	};
	
	var DOMExceptionPrototype = $DOMException.prototype = create(ErrorPrototype);
	
	var createGetterDescriptor = function (get) {
	  return { enumerable: true, configurable: true, get: get };
	};
	
	var getterFor = function (key) {
	  return createGetterDescriptor(function () {
	    return getInternalState(this)[key];
	  });
	};
	
	if (DESCRIPTORS) {
	  // `DOMException.prototype.code` getter
	  defineBuiltInAccessor(DOMExceptionPrototype, 'code', getterFor('code'));
	  // `DOMException.prototype.message` getter
	  defineBuiltInAccessor(DOMExceptionPrototype, 'message', getterFor('message'));
	  // `DOMException.prototype.name` getter
	  defineBuiltInAccessor(DOMExceptionPrototype, 'name', getterFor('name'));
	}
	
	defineProperty(DOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, $DOMException));
	
	// FF36- DOMException is a function, but can't be constructed
	var INCORRECT_CONSTRUCTOR = fails(function () {
	  return !(new NativeDOMException() instanceof Error);
	});
	
	// Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs
	var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
	  return ErrorPrototype.toString !== errorToString || String(new NativeDOMException(1, 2)) !== '2: 1';
	});
	
	// Deno 1.6.3- DOMException.prototype.code just missed
	var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
	  return new NativeDOMException(1, 'DataCloneError').code !== 25;
	});
	
	// Deno 1.6.3- DOMException constants just missed
	var MISSED_CONSTANTS = INCORRECT_CONSTRUCTOR
	  || NativeDOMException[DATA_CLONE_ERR] !== 25
	  || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;
	
	var FORCED_CONSTRUCTOR = IS_PURE ? INCORRECT_TO_STRING || INCORRECT_CODE || MISSED_CONSTANTS : INCORRECT_CONSTRUCTOR;
	
	// `DOMException` constructor
	// https://webidl.spec.whatwg.org/#idl-DOMException
	$({ global: true, constructor: true, forced: FORCED_CONSTRUCTOR }, {
	  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
	});
	
	var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
	var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;
	
	if (INCORRECT_TO_STRING && (IS_PURE || NativeDOMException === PolyfilledDOMException)) {
	  defineBuiltIn(PolyfilledDOMExceptionPrototype, 'toString', errorToString);
	}
	
	if (INCORRECT_CODE && DESCRIPTORS && NativeDOMException === PolyfilledDOMException) {
	  defineBuiltInAccessor(PolyfilledDOMExceptionPrototype, 'code', createGetterDescriptor(function () {
	    return codeFor(anObject(this).name);
	  }));
	}
	
	// `DOMException` constants
	for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
	  var constant = DOMExceptionConstants[key];
	  var constantName = constant.s;
	  var descriptor = createPropertyDescriptor(6, constant.c);
	  if (!hasOwn(PolyfilledDOMException, constantName)) {
	    defineProperty(PolyfilledDOMException, constantName, descriptor);
	  }
	  if (!hasOwn(PolyfilledDOMExceptionPrototype, constantName)) {
	    defineProperty(PolyfilledDOMExceptionPrototype, constantName, descriptor);
	  }
	}


/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var getBuiltIn = __webpack_require__(35);
	var createPropertyDescriptor = __webpack_require__(85);
	var defineProperty = __webpack_require__(41).f;
	var hasOwn = __webpack_require__(28);
	var anInstance = __webpack_require__(98);
	var inheritIfRequired = __webpack_require__(143);
	var normalizeStringArgument = __webpack_require__(208);
	var DOMExceptionConstants = __webpack_require__(507);
	var clearErrorStack = __webpack_require__(345);
	var DESCRIPTORS = __webpack_require__(15);
	var IS_PURE = __webpack_require__(48);
	
	var DOM_EXCEPTION = 'DOMException';
	var Error = getBuiltIn('Error');
	var NativeDOMException = getBuiltIn(DOM_EXCEPTION);
	
	var $DOMException = function DOMException() {
	  anInstance(this, DOMExceptionPrototype);
	  var argumentsLength = arguments.length;
	  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
	  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
	  var that = new NativeDOMException(message, name);
	  var error = new Error(message);
	  error.name = DOM_EXCEPTION;
	  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
	  inheritIfRequired(that, this, $DOMException);
	  return that;
	};
	
	var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;
	
	var ERROR_HAS_STACK = 'stack' in new Error(DOM_EXCEPTION);
	var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);
	
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);
	
	// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
	// https://github.com/Jarred-Sumner/bun/issues/399
	var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);
	
	var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;
	
	// `DOMException` constructor patch for `.stack` where it's required
	// https://webidl.spec.whatwg.org/#es-DOMException-specialness
	$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
	  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
	});
	
	var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
	var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;
	
	if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
	  if (!IS_PURE) {
	    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
	  }
	
	  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
	    var constant = DOMExceptionConstants[key];
	    var constantName = constant.s;
	    if (!hasOwn(PolyfilledDOMException, constantName)) {
	      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
	    }
	  }
	}


/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var getBuiltIn = __webpack_require__(35);
	var setToStringTag = __webpack_require__(73);
	
	var DOM_EXCEPTION = 'DOMException';
	
	// `DOMException.prototype[@@toStringTag]` property
	setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);


/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1531);
	__webpack_require__(1539);


/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var globalThis = __webpack_require__(11);
	var microtask = __webpack_require__(532);
	var aCallable = __webpack_require__(36);
	var validateArgumentsLength = __webpack_require__(87);
	var fails = __webpack_require__(7);
	var DESCRIPTORS = __webpack_require__(15);
	
	// Bun ~ 1.0.30 bug
	// https://github.com/oven-sh/bun/issues/9249
	var WRONG_ARITY = fails(function () {
	  // getOwnPropertyDescriptor for prevent experimental warning in Node 11
	  // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	  return DESCRIPTORS && Object.getOwnPropertyDescriptor(globalThis, 'queueMicrotask').value.length !== 1;
	});
	
	// `queueMicrotask` method
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-queuemicrotask
	$({ global: true, enumerable: true, dontCallGetSet: true, forced: WRONG_ARITY }, {
	  queueMicrotask: function queueMicrotask(fn) {
	    validateArgumentsLength(arguments.length, 1);
	    microtask(aCallable(fn));
	  }
	});


/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var defineBuiltInAccessor = __webpack_require__(54);
	var DESCRIPTORS = __webpack_require__(15);
	
	var $TypeError = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty = Object.defineProperty;
	var INCORRECT_VALUE = global.self !== global;
	
	// `self` getter
	// https://html.spec.whatwg.org/multipage/window-object.html#dom-self
	try {
	  if (DESCRIPTORS) {
	    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	    var descriptor = Object.getOwnPropertyDescriptor(global, 'self');
	    // some engines have `self`, but with incorrect descriptor
	    // https://github.com/denoland/deno/issues/15765
	    if (INCORRECT_VALUE || !descriptor || !descriptor.get || !descriptor.enumerable) {
	      defineBuiltInAccessor(global, 'self', {
	        get: function self() {
	          return global;
	        },
	        set: function self(value) {
	          if (this !== global) throw new $TypeError('Illegal invocation');
	          defineProperty(global, 'self', {
	            value: value,
	            writable: true,
	            configurable: true,
	            enumerable: true
	          });
	        },
	        configurable: true,
	        enumerable: true
	      });
	    }
	  } else $({ global: true, simple: true, forced: INCORRECT_VALUE }, {
	    self: global
	  });
	} catch (error) { /* empty */ }


/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var setTask = __webpack_require__(264).set;
	var schedulersFix = __webpack_require__(361);
	
	// https://github.com/oven-sh/bun/issues/1633
	var setImmediate = global.setImmediate ? schedulersFix(setTask, false) : setTask;
	
	// `setImmediate` method
	// http://w3c.github.io/setImmediate/#si-setImmediate
	$({ global: true, bind: true, enumerable: true, forced: global.setImmediate !== setImmediate }, {
	  setImmediate: setImmediate
	});


/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var schedulersFix = __webpack_require__(361);
	
	var setInterval = schedulersFix(global.setInterval, true);
	
	// Bun / IE9- setInterval additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
	$({ global: true, bind: true, forced: global.setInterval !== setInterval }, {
	  setInterval: setInterval
	});


/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var schedulersFix = __webpack_require__(361);
	
	var setTimeout = schedulersFix(global.setTimeout, true);
	
	// Bun / IE9- setTimeout additional parameters fix
	// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
	$({ global: true, bind: true, forced: global.setTimeout !== setTimeout }, {
	  setTimeout: setTimeout
	});


/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var IS_PURE = __webpack_require__(48);
	var $ = __webpack_require__(4);
	var global = __webpack_require__(11);
	var getBuiltIn = __webpack_require__(35);
	var uncurryThis = __webpack_require__(8);
	var fails = __webpack_require__(7);
	var uid = __webpack_require__(174);
	var isCallable = __webpack_require__(22);
	var isConstructor = __webpack_require__(167);
	var isNullOrUndefined = __webpack_require__(66);
	var isObject = __webpack_require__(20);
	var isSymbol = __webpack_require__(123);
	var iterate = __webpack_require__(67);
	var anObject = __webpack_require__(18);
	var classof = __webpack_require__(92);
	var hasOwn = __webpack_require__(28);
	var createProperty = __webpack_require__(120);
	var createNonEnumerableProperty = __webpack_require__(65);
	var lengthOfArrayLike = __webpack_require__(40);
	var validateArgumentsLength = __webpack_require__(87);
	var getRegExpFlags = __webpack_require__(213);
	var MapHelpers = __webpack_require__(72);
	var SetHelpers = __webpack_require__(59);
	var setIterate = __webpack_require__(78);
	var detachTransferable = __webpack_require__(506);
	var ERROR_STACK_INSTALLABLE = __webpack_require__(515);
	var PROPER_STRUCTURED_CLONE_TRANSFER = __webpack_require__(366);
	
	var Object = global.Object;
	var Array = global.Array;
	var Date = global.Date;
	var Error = global.Error;
	var TypeError = global.TypeError;
	var PerformanceMark = global.PerformanceMark;
	var DOMException = getBuiltIn('DOMException');
	var Map = MapHelpers.Map;
	var mapHas = MapHelpers.has;
	var mapGet = MapHelpers.get;
	var mapSet = MapHelpers.set;
	var Set = SetHelpers.Set;
	var setAdd = SetHelpers.add;
	var setHas = SetHelpers.has;
	var objectKeys = getBuiltIn('Object', 'keys');
	var push = uncurryThis([].push);
	var thisBooleanValue = uncurryThis(true.valueOf);
	var thisNumberValue = uncurryThis(1.0.valueOf);
	var thisStringValue = uncurryThis(''.valueOf);
	var thisTimeValue = uncurryThis(Date.prototype.getTime);
	var PERFORMANCE_MARK = uid('structuredClone');
	var DATA_CLONE_ERROR = 'DataCloneError';
	var TRANSFERRING = 'Transferring';
	
	var checkBasicSemantic = function (structuredCloneImplementation) {
	  return !fails(function () {
	    var set1 = new global.Set([7]);
	    var set2 = structuredCloneImplementation(set1);
	    var number = structuredCloneImplementation(Object(7));
	    return set2 === set1 || !set2.has(7) || !isObject(number) || +number !== 7;
	  }) && structuredCloneImplementation;
	};
	
	var checkErrorsCloning = function (structuredCloneImplementation, $Error) {
	  return !fails(function () {
	    var error = new $Error();
	    var test = structuredCloneImplementation({ a: error, b: error });
	    return !(test && test.a === test.b && test.a instanceof $Error && test.a.stack === error.stack);
	  });
	};
	
	// https://github.com/whatwg/html/pull/5749
	var checkNewErrorsCloningSemantic = function (structuredCloneImplementation) {
	  return !fails(function () {
	    var test = structuredCloneImplementation(new global.AggregateError([1], PERFORMANCE_MARK, { cause: 3 }));
	    return test.name !== 'AggregateError' || test.errors[0] !== 1 || test.message !== PERFORMANCE_MARK || test.cause !== 3;
	  });
	};
	
	// FF94+, Safari 15.4+, Chrome 98+, NodeJS 17.0+, Deno 1.13+
	// FF<103 and Safari implementations can't clone errors
	// https://bugzilla.mozilla.org/show_bug.cgi?id=1556604
	// FF103 can clone errors, but `.stack` of clone is an empty string
	// https://bugzilla.mozilla.org/show_bug.cgi?id=1778762
	// FF104+ fixed it on usual errors, but not on DOMExceptions
	// https://bugzilla.mozilla.org/show_bug.cgi?id=1777321
	// Chrome <102 returns `null` if cloned object contains multiple references to one error
	// https://bugs.chromium.org/p/v8/issues/detail?id=12542
	// NodeJS implementation can't clone DOMExceptions
	// https://github.com/nodejs/node/issues/41038
	// only FF103+ supports new (html/5749) error cloning semantic
	var nativeStructuredClone = global.structuredClone;
	
	var FORCED_REPLACEMENT = IS_PURE
	  || !checkErrorsCloning(nativeStructuredClone, Error)
	  || !checkErrorsCloning(nativeStructuredClone, DOMException)
	  || !checkNewErrorsCloningSemantic(nativeStructuredClone);
	
	// Chrome 82+, Safari 14.1+, Deno 1.11+
	// Chrome 78-81 implementation swaps `.name` and `.message` of cloned `DOMException`
	// Chrome returns `null` if cloned object contains multiple references to one error
	// Safari 14.1 implementation doesn't clone some `RegExp` flags, so requires a workaround
	// Safari implementation can't clone errors
	// Deno 1.2-1.10 implementations too naive
	// NodeJS 16.0+ does not have `PerformanceMark` constructor
	// NodeJS <17.2 structured cloning implementation from `performance.mark` is too naive
	// and can't clone, for example, `RegExp` or some boxed primitives
	// https://github.com/nodejs/node/issues/40840
	// no one of those implementations supports new (html/5749) error cloning semantic
	var structuredCloneFromMark = !nativeStructuredClone && checkBasicSemantic(function (value) {
	  return new PerformanceMark(PERFORMANCE_MARK, { detail: value }).detail;
	});
	
	var nativeRestrictedStructuredClone = checkBasicSemantic(nativeStructuredClone) || structuredCloneFromMark;
	
	var throwUncloneable = function (type) {
	  throw new DOMException('Uncloneable type: ' + type, DATA_CLONE_ERROR);
	};
	
	var throwUnpolyfillable = function (type, action) {
	  throw new DOMException((action || 'Cloning') + ' of ' + type + ' cannot be properly polyfilled in this engine', DATA_CLONE_ERROR);
	};
	
	var tryNativeRestrictedStructuredClone = function (value, type) {
	  if (!nativeRestrictedStructuredClone) throwUnpolyfillable(type);
	  return nativeRestrictedStructuredClone(value);
	};
	
	var createDataTransfer = function () {
	  var dataTransfer;
	  try {
	    dataTransfer = new global.DataTransfer();
	  } catch (error) {
	    try {
	      dataTransfer = new global.ClipboardEvent('').clipboardData;
	    } catch (error2) { /* empty */ }
	  }
	  return dataTransfer && dataTransfer.items && dataTransfer.files ? dataTransfer : null;
	};
	
	var cloneBuffer = function (value, map, $type) {
	  if (mapHas(map, value)) return mapGet(map, value);
	
	  var type = $type || classof(value);
	  var clone, length, options, source, target, i;
	
	  if (type === 'SharedArrayBuffer') {
	    if (nativeRestrictedStructuredClone) clone = nativeRestrictedStructuredClone(value);
	    // SharedArrayBuffer should use shared memory, we can't polyfill it, so return the original
	    else clone = value;
	  } else {
	    var DataView = global.DataView;
	
	    // `ArrayBuffer#slice` is not available in IE10
	    // `ArrayBuffer#slice` and `DataView` are not available in old FF
	    if (!DataView && !isCallable(value.slice)) throwUnpolyfillable('ArrayBuffer');
	    // detached buffers throws in `DataView` and `.slice`
	    try {
	      if (isCallable(value.slice) && !value.resizable) {
	        clone = value.slice(0);
	      } else {
	        length = value.byteLength;
	        options = 'maxByteLength' in value ? { maxByteLength: value.maxByteLength } : undefined;
	        // eslint-disable-next-line es/no-resizable-and-growable-arraybuffers -- safe
	        clone = new ArrayBuffer(length, options);
	        source = new DataView(value);
	        target = new DataView(clone);
	        for (i = 0; i < length; i++) {
	          target.setUint8(i, source.getUint8(i));
	        }
	      }
	    } catch (error) {
	      throw new DOMException('ArrayBuffer is detached', DATA_CLONE_ERROR);
	    }
	  }
	
	  mapSet(map, value, clone);
	
	  return clone;
	};
	
	var cloneView = function (value, type, offset, length, map) {
	  var C = global[type];
	  // in some old engines like Safari 9, typeof C is 'object'
	  // on Uint8ClampedArray or some other constructors
	  if (!isObject(C)) throwUnpolyfillable(type);
	  return new C(cloneBuffer(value.buffer, map), offset, length);
	};
	
	var structuredCloneInternal = function (value, map) {
	  if (isSymbol(value)) throwUncloneable('Symbol');
	  if (!isObject(value)) return value;
	  // effectively preserves circular references
	  if (map) {
	    if (mapHas(map, value)) return mapGet(map, value);
	  } else map = new Map();
	
	  var type = classof(value);
	  var C, name, cloned, dataTransfer, i, length, keys, key;
	
	  switch (type) {
	    case 'Array':
	      cloned = Array(lengthOfArrayLike(value));
	      break;
	    case 'Object':
	      cloned = {};
	      break;
	    case 'Map':
	      cloned = new Map();
	      break;
	    case 'Set':
	      cloned = new Set();
	      break;
	    case 'RegExp':
	      // in this block because of a Safari 14.1 bug
	      // old FF does not clone regexes passed to the constructor, so get the source and flags directly
	      cloned = new RegExp(value.source, getRegExpFlags(value));
	      break;
	    case 'Error':
	      name = value.name;
	      switch (name) {
	        case 'AggregateError':
	          cloned = new (getBuiltIn(name))([]);
	          break;
	        case 'EvalError':
	        case 'RangeError':
	        case 'ReferenceError':
	        case 'SuppressedError':
	        case 'SyntaxError':
	        case 'TypeError':
	        case 'URIError':
	          cloned = new (getBuiltIn(name))();
	          break;
	        case 'CompileError':
	        case 'LinkError':
	        case 'RuntimeError':
	          cloned = new (getBuiltIn('WebAssembly', name))();
	          break;
	        default:
	          cloned = new Error();
	      }
	      break;
	    case 'DOMException':
	      cloned = new DOMException(value.message, value.name);
	      break;
	    case 'ArrayBuffer':
	    case 'SharedArrayBuffer':
	      cloned = cloneBuffer(value, map, type);
	      break;
	    case 'DataView':
	    case 'Int8Array':
	    case 'Uint8Array':
	    case 'Uint8ClampedArray':
	    case 'Int16Array':
	    case 'Uint16Array':
	    case 'Int32Array':
	    case 'Uint32Array':
	    case 'Float16Array':
	    case 'Float32Array':
	    case 'Float64Array':
	    case 'BigInt64Array':
	    case 'BigUint64Array':
	      length = type === 'DataView' ? value.byteLength : value.length;
	      cloned = cloneView(value, type, value.byteOffset, length, map);
	      break;
	    case 'DOMQuad':
	      try {
	        cloned = new DOMQuad(
	          structuredCloneInternal(value.p1, map),
	          structuredCloneInternal(value.p2, map),
	          structuredCloneInternal(value.p3, map),
	          structuredCloneInternal(value.p4, map)
	        );
	      } catch (error) {
	        cloned = tryNativeRestrictedStructuredClone(value, type);
	      }
	      break;
	    case 'File':
	      if (nativeRestrictedStructuredClone) try {
	        cloned = nativeRestrictedStructuredClone(value);
	        // NodeJS 20.0.0 bug, https://github.com/nodejs/node/issues/47612
	        if (classof(cloned) !== type) cloned = undefined;
	      } catch (error) { /* empty */ }
	      if (!cloned) try {
	        cloned = new File([value], value.name, value);
	      } catch (error) { /* empty */ }
	      if (!cloned) throwUnpolyfillable(type);
	      break;
	    case 'FileList':
	      dataTransfer = createDataTransfer();
	      if (dataTransfer) {
	        for (i = 0, length = lengthOfArrayLike(value); i < length; i++) {
	          dataTransfer.items.add(structuredCloneInternal(value[i], map));
	        }
	        cloned = dataTransfer.files;
	      } else cloned = tryNativeRestrictedStructuredClone(value, type);
	      break;
	    case 'ImageData':
	      // Safari 9 ImageData is a constructor, but typeof ImageData is 'object'
	      try {
	        cloned = new ImageData(
	          structuredCloneInternal(value.data, map),
	          value.width,
	          value.height,
	          { colorSpace: value.colorSpace }
	        );
	      } catch (error) {
	        cloned = tryNativeRestrictedStructuredClone(value, type);
	      } break;
	    default:
	      if (nativeRestrictedStructuredClone) {
	        cloned = nativeRestrictedStructuredClone(value);
	      } else switch (type) {
	        case 'BigInt':
	          // can be a 3rd party polyfill
	          cloned = Object(value.valueOf());
	          break;
	        case 'Boolean':
	          cloned = Object(thisBooleanValue(value));
	          break;
	        case 'Number':
	          cloned = Object(thisNumberValue(value));
	          break;
	        case 'String':
	          cloned = Object(thisStringValue(value));
	          break;
	        case 'Date':
	          cloned = new Date(thisTimeValue(value));
	          break;
	        case 'Blob':
	          try {
	            cloned = value.slice(0, value.size, value.type);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'DOMPoint':
	        case 'DOMPointReadOnly':
	          C = global[type];
	          try {
	            cloned = C.fromPoint
	              ? C.fromPoint(value)
	              : new C(value.x, value.y, value.z, value.w);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'DOMRect':
	        case 'DOMRectReadOnly':
	          C = global[type];
	          try {
	            cloned = C.fromRect
	              ? C.fromRect(value)
	              : new C(value.x, value.y, value.width, value.height);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'DOMMatrix':
	        case 'DOMMatrixReadOnly':
	          C = global[type];
	          try {
	            cloned = C.fromMatrix
	              ? C.fromMatrix(value)
	              : new C(value);
	          } catch (error) {
	            throwUnpolyfillable(type);
	          } break;
	        case 'AudioData':
	        case 'VideoFrame':
	          if (!isCallable(value.clone)) throwUnpolyfillable(type);
	          try {
	            cloned = value.clone();
	          } catch (error) {
	            throwUncloneable(type);
	          } break;
	        case 'CropTarget':
	        case 'CryptoKey':
	        case 'FileSystemDirectoryHandle':
	        case 'FileSystemFileHandle':
	        case 'FileSystemHandle':
	        case 'GPUCompilationInfo':
	        case 'GPUCompilationMessage':
	        case 'ImageBitmap':
	        case 'RTCCertificate':
	        case 'WebAssembly.Module':
	          throwUnpolyfillable(type);
	          // break omitted
	        default:
	          throwUncloneable(type);
	      }
	  }
	
	  mapSet(map, value, cloned);
	
	  switch (type) {
	    case 'Array':
	    case 'Object':
	      keys = objectKeys(value);
	      for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
	        key = keys[i];
	        createProperty(cloned, key, structuredCloneInternal(value[key], map));
	      } break;
	    case 'Map':
	      value.forEach(function (v, k) {
	        mapSet(cloned, structuredCloneInternal(k, map), structuredCloneInternal(v, map));
	      });
	      break;
	    case 'Set':
	      value.forEach(function (v) {
	        setAdd(cloned, structuredCloneInternal(v, map));
	      });
	      break;
	    case 'Error':
	      createNonEnumerableProperty(cloned, 'message', structuredCloneInternal(value.message, map));
	      if (hasOwn(value, 'cause')) {
	        createNonEnumerableProperty(cloned, 'cause', structuredCloneInternal(value.cause, map));
	      }
	      if (name === 'AggregateError') {
	        cloned.errors = structuredCloneInternal(value.errors, map);
	      } else if (name === 'SuppressedError') {
	        cloned.error = structuredCloneInternal(value.error, map);
	        cloned.suppressed = structuredCloneInternal(value.suppressed, map);
	      } // break omitted
	    case 'DOMException':
	      if (ERROR_STACK_INSTALLABLE) {
	        createNonEnumerableProperty(cloned, 'stack', structuredCloneInternal(value.stack, map));
	      }
	  }
	
	  return cloned;
	};
	
	var tryToTransfer = function (rawTransfer, map) {
	  if (!isObject(rawTransfer)) throw new TypeError('Transfer option cannot be converted to a sequence');
	
	  var transfer = [];
	
	  iterate(rawTransfer, function (value) {
	    push(transfer, anObject(value));
	  });
	
	  var i = 0;
	  var length = lengthOfArrayLike(transfer);
	  var buffers = new Set();
	  var value, type, C, transferred, canvas, context;
	
	  while (i < length) {
	    value = transfer[i++];
	
	    type = classof(value);
	
	    if (type === 'ArrayBuffer' ? setHas(buffers, value) : mapHas(map, value)) {
	      throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);
	    }
	
	    if (type === 'ArrayBuffer') {
	      setAdd(buffers, value);
	      continue;
	    }
	
	    if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	      transferred = nativeStructuredClone(value, { transfer: [value] });
	    } else switch (type) {
	      case 'ImageBitmap':
	        C = global.OffscreenCanvas;
	        if (!isConstructor(C)) throwUnpolyfillable(type, TRANSFERRING);
	        try {
	          canvas = new C(value.width, value.height);
	          context = canvas.getContext('bitmaprenderer');
	          context.transferFromImageBitmap(value);
	          transferred = canvas.transferToImageBitmap();
	        } catch (error) { /* empty */ }
	        break;
	      case 'AudioData':
	      case 'VideoFrame':
	        if (!isCallable(value.clone) || !isCallable(value.close)) throwUnpolyfillable(type, TRANSFERRING);
	        try {
	          transferred = value.clone();
	          value.close();
	        } catch (error) { /* empty */ }
	        break;
	      case 'MediaSourceHandle':
	      case 'MessagePort':
	      case 'OffscreenCanvas':
	      case 'ReadableStream':
	      case 'TransformStream':
	      case 'WritableStream':
	        throwUnpolyfillable(type, TRANSFERRING);
	    }
	
	    if (transferred === undefined) throw new DOMException('This object cannot be transferred: ' + type, DATA_CLONE_ERROR);
	
	    mapSet(map, value, transferred);
	  }
	
	  return buffers;
	};
	
	var detachBuffers = function (buffers) {
	  setIterate(buffers, function (buffer) {
	    if (PROPER_STRUCTURED_CLONE_TRANSFER) {
	      nativeRestrictedStructuredClone(buffer, { transfer: [buffer] });
	    } else if (isCallable(buffer.transfer)) {
	      buffer.transfer();
	    } else if (detachTransferable) {
	      detachTransferable(buffer);
	    } else {
	      throwUnpolyfillable('ArrayBuffer', TRANSFERRING);
	    }
	  });
	};
	
	// `structuredClone` method
	// https://html.spec.whatwg.org/multipage/structured-data.html#dom-structuredclone
	$({ global: true, enumerable: true, sham: !PROPER_STRUCTURED_CLONE_TRANSFER, forced: FORCED_REPLACEMENT }, {
	  structuredClone: function structuredClone(value /* , { transfer } */) {
	    var options = validateArgumentsLength(arguments.length, 1) > 1 && !isNullOrUndefined(arguments[1]) ? anObject(arguments[1]) : undefined;
	    var transfer = options ? options.transfer : undefined;
	    var map, buffers;
	
	    if (transfer !== undefined) {
	      map = new Map();
	      buffers = tryToTransfer(transfer, map);
	    }
	
	    var clone = structuredCloneInternal(value, map);
	
	    // since of an issue with cloning views of transferred buffers, we a forced to detach them later
	    // https://github.com/zloirock/core-js/issues/1265
	    if (buffers) detachBuffers(buffers);
	
	    return clone;
	  }
	});


/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's split to modules listed below
	__webpack_require__(1540);
	__webpack_require__(1541);


/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(44);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(17);
	var validateArgumentsLength = __webpack_require__(87);
	
	var $URLSearchParams = URLSearchParams;
	var URLSearchParamsPrototype = $URLSearchParams.prototype;
	var append = uncurryThis(URLSearchParamsPrototype.append);
	var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
	var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
	var push = uncurryThis([].push);
	var params = new $URLSearchParams('a=1&a=2&b=3');
	
	params['delete']('a', 1);
	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	params['delete']('b', undefined);
	
	if (params + '' !== 'a=2') {
	  defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $delete(this, name);
	    var entries = [];
	    forEach(this, function (v, k) { // also validates `this`
	      push(entries, { key: k, value: v });
	    });
	    validateArgumentsLength(length, 1);
	    var key = toString(name);
	    var value = toString($value);
	    var index = 0;
	    var dindex = 0;
	    var found = false;
	    var entriesLength = entries.length;
	    var entry;
	    while (index < entriesLength) {
	      entry = entries[index++];
	      if (found || entry.key === key) {
	        found = true;
	        $delete(this, entry.key);
	      } else dindex++;
	    }
	    while (dindex < entriesLength) {
	      entry = entries[dindex++];
	      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
	    }
	  }, { enumerable: true, unsafe: true });
	}


/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var defineBuiltIn = __webpack_require__(44);
	var uncurryThis = __webpack_require__(8);
	var toString = __webpack_require__(17);
	var validateArgumentsLength = __webpack_require__(87);
	
	var $URLSearchParams = URLSearchParams;
	var URLSearchParamsPrototype = $URLSearchParams.prototype;
	var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
	var $has = uncurryThis(URLSearchParamsPrototype.has);
	var params = new $URLSearchParams('a=1');
	
	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	if (params.has('a', 2) || !params.has('a', undefined)) {
	  defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $has(this, name);
	    var values = getAll(this, name); // also validates `this`
	    validateArgumentsLength(length, 1);
	    var value = toString($value);
	    var index = 0;
	    while (index < values.length) {
	      if (values[index++] === value) return true;
	    } return false;
	  }, { enumerable: true, unsafe: true });
	}


/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(619);


/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DESCRIPTORS = __webpack_require__(15);
	var uncurryThis = __webpack_require__(8);
	var defineBuiltInAccessor = __webpack_require__(54);
	
	var URLSearchParamsPrototype = URLSearchParams.prototype;
	var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
	
	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
	  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	    get: function size() {
	      var count = 0;
	      forEach(this, function () { count++; });
	      return count;
	    },
	    configurable: true,
	    enumerable: true
	  });
	}


/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var fails = __webpack_require__(7);
	var validateArgumentsLength = __webpack_require__(87);
	var toString = __webpack_require__(17);
	var USE_NATIVE_URL = __webpack_require__(268);
	
	var URL = getBuiltIn('URL');
	
	// https://github.com/nodejs/node/issues/47505
	// https://github.com/denoland/deno/issues/18893
	var THROWS_WITHOUT_ARGUMENTS = USE_NATIVE_URL && fails(function () {
	  URL.canParse();
	});
	
	// Bun ~ 1.0.30 bug
	// https://github.com/oven-sh/bun/issues/9250
	var WRONG_ARITY = fails(function () {
	  return URL.canParse.length !== 1;
	});
	
	// `URL.canParse` method
	// https://url.spec.whatwg.org/#dom-url-canparse
	$({ target: 'URL', stat: true, forced: !THROWS_WITHOUT_ARGUMENTS || WRONG_ARITY }, {
	  canParse: function canParse(url) {
	    var length = validateArgumentsLength(arguments.length, 1);
	    var urlString = toString(url);
	    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
	    try {
	      return !!new URL(urlString, base);
	    } catch (error) {
	      return false;
	    }
	  }
	});


/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
	__webpack_require__(215);
	var $ = __webpack_require__(4);
	var DESCRIPTORS = __webpack_require__(15);
	var USE_NATIVE_URL = __webpack_require__(268);
	var global = __webpack_require__(11);
	var bind = __webpack_require__(45);
	var uncurryThis = __webpack_require__(8);
	var defineBuiltIn = __webpack_require__(44);
	var defineBuiltInAccessor = __webpack_require__(54);
	var anInstance = __webpack_require__(98);
	var hasOwn = __webpack_require__(28);
	var assign = __webpack_require__(535);
	var arrayFrom = __webpack_require__(497);
	var arraySlice = __webpack_require__(91);
	var codeAt = __webpack_require__(262).codeAt;
	var toASCII = __webpack_require__(1258);
	var $toString = __webpack_require__(17);
	var setToStringTag = __webpack_require__(73);
	var validateArgumentsLength = __webpack_require__(87);
	var URLSearchParamsModule = __webpack_require__(619);
	var InternalStateModule = __webpack_require__(52);
	
	var setInternalState = InternalStateModule.set;
	var getInternalURLState = InternalStateModule.getterFor('URL');
	var URLSearchParams = URLSearchParamsModule.URLSearchParams;
	var getInternalSearchParamsState = URLSearchParamsModule.getState;
	
	var NativeURL = global.URL;
	var TypeError = global.TypeError;
	var parseInt = global.parseInt;
	var floor = Math.floor;
	var pow = Math.pow;
	var charAt = uncurryThis(''.charAt);
	var exec = uncurryThis(/./.exec);
	var join = uncurryThis([].join);
	var numberToString = uncurryThis(1.0.toString);
	var pop = uncurryThis([].pop);
	var push = uncurryThis([].push);
	var replace = uncurryThis(''.replace);
	var shift = uncurryThis([].shift);
	var split = uncurryThis(''.split);
	var stringSlice = uncurryThis(''.slice);
	var toLowerCase = uncurryThis(''.toLowerCase);
	var unshift = uncurryThis([].unshift);
	
	var INVALID_AUTHORITY = 'Invalid authority';
	var INVALID_SCHEME = 'Invalid scheme';
	var INVALID_HOST = 'Invalid host';
	var INVALID_PORT = 'Invalid port';
	
	var ALPHA = /[a-z]/i;
	// eslint-disable-next-line regexp/no-obscure-range -- safe
	var ALPHANUMERIC = /[\d+-.a-z]/i;
	var DIGIT = /\d/;
	var HEX_START = /^0x/i;
	var OCT = /^[0-7]+$/;
	var DEC = /^\d+$/;
	var HEX = /^[\da-f]+$/i;
	/* eslint-disable regexp/no-control-character -- safe */
	var FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
	var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
	var LEADING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+/;
	var TRAILING_C0_CONTROL_OR_SPACE = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/;
	var TAB_AND_NEW_LINE = /[\t\n\r]/g;
	/* eslint-enable regexp/no-control-character -- safe */
	var EOF;
	
	// https://url.spec.whatwg.org/#ipv4-number-parser
	var parseIPv4 = function (input) {
	  var parts = split(input, '.');
	  var partsLength, numbers, index, part, radix, number, ipv4;
	  if (parts.length && parts[parts.length - 1] === '') {
	    parts.length--;
	  }
	  partsLength = parts.length;
	  if (partsLength > 4) return input;
	  numbers = [];
	  for (index = 0; index < partsLength; index++) {
	    part = parts[index];
	    if (part === '') return input;
	    radix = 10;
	    if (part.length > 1 && charAt(part, 0) === '0') {
	      radix = exec(HEX_START, part) ? 16 : 8;
	      part = stringSlice(part, radix === 8 ? 1 : 2);
	    }
	    if (part === '') {
	      number = 0;
	    } else {
	      if (!exec(radix === 10 ? DEC : radix === 8 ? OCT : HEX, part)) return input;
	      number = parseInt(part, radix);
	    }
	    push(numbers, number);
	  }
	  for (index = 0; index < partsLength; index++) {
	    number = numbers[index];
	    if (index === partsLength - 1) {
	      if (number >= pow(256, 5 - partsLength)) return null;
	    } else if (number > 255) return null;
	  }
	  ipv4 = pop(numbers);
	  for (index = 0; index < numbers.length; index++) {
	    ipv4 += numbers[index] * pow(256, 3 - index);
	  }
	  return ipv4;
	};
	
	// https://url.spec.whatwg.org/#concept-ipv6-parser
	// eslint-disable-next-line max-statements -- TODO
	var parseIPv6 = function (input) {
	  var address = [0, 0, 0, 0, 0, 0, 0, 0];
	  var pieceIndex = 0;
	  var compress = null;
	  var pointer = 0;
	  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
	
	  var chr = function () {
	    return charAt(input, pointer);
	  };
	
	  if (chr() === ':') {
	    if (charAt(input, 1) !== ':') return;
	    pointer += 2;
	    pieceIndex++;
	    compress = pieceIndex;
	  }
	  while (chr()) {
	    if (pieceIndex === 8) return;
	    if (chr() === ':') {
	      if (compress !== null) return;
	      pointer++;
	      pieceIndex++;
	      compress = pieceIndex;
	      continue;
	    }
	    value = length = 0;
	    while (length < 4 && exec(HEX, chr())) {
	      value = value * 16 + parseInt(chr(), 16);
	      pointer++;
	      length++;
	    }
	    if (chr() === '.') {
	      if (length === 0) return;
	      pointer -= length;
	      if (pieceIndex > 6) return;
	      numbersSeen = 0;
	      while (chr()) {
	        ipv4Piece = null;
	        if (numbersSeen > 0) {
	          if (chr() === '.' && numbersSeen < 4) pointer++;
	          else return;
	        }
	        if (!exec(DIGIT, chr())) return;
	        while (exec(DIGIT, chr())) {
	          number = parseInt(chr(), 10);
	          if (ipv4Piece === null) ipv4Piece = number;
	          else if (ipv4Piece === 0) return;
	          else ipv4Piece = ipv4Piece * 10 + number;
	          if (ipv4Piece > 255) return;
	          pointer++;
	        }
	        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
	        numbersSeen++;
	        if (numbersSeen === 2 || numbersSeen === 4) pieceIndex++;
	      }
	      if (numbersSeen !== 4) return;
	      break;
	    } else if (chr() === ':') {
	      pointer++;
	      if (!chr()) return;
	    } else if (chr()) return;
	    address[pieceIndex++] = value;
	  }
	  if (compress !== null) {
	    swaps = pieceIndex - compress;
	    pieceIndex = 7;
	    while (pieceIndex !== 0 && swaps > 0) {
	      swap = address[pieceIndex];
	      address[pieceIndex--] = address[compress + swaps - 1];
	      address[compress + --swaps] = swap;
	    }
	  } else if (pieceIndex !== 8) return;
	  return address;
	};
	
	var findLongestZeroSequence = function (ipv6) {
	  var maxIndex = null;
	  var maxLength = 1;
	  var currStart = null;
	  var currLength = 0;
	  var index = 0;
	  for (; index < 8; index++) {
	    if (ipv6[index] !== 0) {
	      if (currLength > maxLength) {
	        maxIndex = currStart;
	        maxLength = currLength;
	      }
	      currStart = null;
	      currLength = 0;
	    } else {
	      if (currStart === null) currStart = index;
	      ++currLength;
	    }
	  }
	  if (currLength > maxLength) {
	    maxIndex = currStart;
	    maxLength = currLength;
	  }
	  return maxIndex;
	};
	
	// https://url.spec.whatwg.org/#host-serializing
	var serializeHost = function (host) {
	  var result, index, compress, ignore0;
	  // ipv4
	  if (typeof host == 'number') {
	    result = [];
	    for (index = 0; index < 4; index++) {
	      unshift(result, host % 256);
	      host = floor(host / 256);
	    } return join(result, '.');
	  // ipv6
	  } else if (typeof host == 'object') {
	    result = '';
	    compress = findLongestZeroSequence(host);
	    for (index = 0; index < 8; index++) {
	      if (ignore0 && host[index] === 0) continue;
	      if (ignore0) ignore0 = false;
	      if (compress === index) {
	        result += index ? ':' : '::';
	        ignore0 = true;
	      } else {
	        result += numberToString(host[index], 16);
	        if (index < 7) result += ':';
	      }
	    }
	    return '[' + result + ']';
	  } return host;
	};
	
	var C0ControlPercentEncodeSet = {};
	var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
	  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
	});
	var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
	  '#': 1, '?': 1, '{': 1, '}': 1
	});
	var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
	  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
	});
	
	var percentEncode = function (chr, set) {
	  var code = codeAt(chr, 0);
	  return code > 0x20 && code < 0x7F && !hasOwn(set, chr) ? chr : encodeURIComponent(chr);
	};
	
	// https://url.spec.whatwg.org/#special-scheme
	var specialSchemes = {
	  ftp: 21,
	  file: null,
	  http: 80,
	  https: 443,
	  ws: 80,
	  wss: 443
	};
	
	// https://url.spec.whatwg.org/#windows-drive-letter
	var isWindowsDriveLetter = function (string, normalized) {
	  var second;
	  return string.length === 2 && exec(ALPHA, charAt(string, 0))
	    && ((second = charAt(string, 1)) === ':' || (!normalized && second === '|'));
	};
	
	// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
	var startsWithWindowsDriveLetter = function (string) {
	  var third;
	  return string.length > 1 && isWindowsDriveLetter(stringSlice(string, 0, 2)) && (
	    string.length === 2 ||
	    ((third = charAt(string, 2)) === '/' || third === '\\' || third === '?' || third === '#')
	  );
	};
	
	// https://url.spec.whatwg.org/#single-dot-path-segment
	var isSingleDot = function (segment) {
	  return segment === '.' || toLowerCase(segment) === '%2e';
	};
	
	// https://url.spec.whatwg.org/#double-dot-path-segment
	var isDoubleDot = function (segment) {
	  segment = toLowerCase(segment);
	  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
	};
	
	// States:
	var SCHEME_START = {};
	var SCHEME = {};
	var NO_SCHEME = {};
	var SPECIAL_RELATIVE_OR_AUTHORITY = {};
	var PATH_OR_AUTHORITY = {};
	var RELATIVE = {};
	var RELATIVE_SLASH = {};
	var SPECIAL_AUTHORITY_SLASHES = {};
	var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
	var AUTHORITY = {};
	var HOST = {};
	var HOSTNAME = {};
	var PORT = {};
	var FILE = {};
	var FILE_SLASH = {};
	var FILE_HOST = {};
	var PATH_START = {};
	var PATH = {};
	var CANNOT_BE_A_BASE_URL_PATH = {};
	var QUERY = {};
	var FRAGMENT = {};
	
	var URLState = function (url, isBase, base) {
	  var urlString = $toString(url);
	  var baseState, failure, searchParams;
	  if (isBase) {
	    failure = this.parse(urlString);
	    if (failure) throw new TypeError(failure);
	    this.searchParams = null;
	  } else {
	    if (base !== undefined) baseState = new URLState(base, true);
	    failure = this.parse(urlString, null, baseState);
	    if (failure) throw new TypeError(failure);
	    searchParams = getInternalSearchParamsState(new URLSearchParams());
	    searchParams.bindURL(this);
	    this.searchParams = searchParams;
	  }
	};
	
	URLState.prototype = {
	  type: 'URL',
	  // https://url.spec.whatwg.org/#url-parsing
	  // eslint-disable-next-line max-statements -- TODO
	  parse: function (input, stateOverride, base) {
	    var url = this;
	    var state = stateOverride || SCHEME_START;
	    var pointer = 0;
	    var buffer = '';
	    var seenAt = false;
	    var seenBracket = false;
	    var seenPasswordToken = false;
	    var codePoints, chr, bufferCodePoints, failure;
	
	    input = $toString(input);
	
	    if (!stateOverride) {
	      url.scheme = '';
	      url.username = '';
	      url.password = '';
	      url.host = null;
	      url.port = null;
	      url.path = [];
	      url.query = null;
	      url.fragment = null;
	      url.cannotBeABaseURL = false;
	      input = replace(input, LEADING_C0_CONTROL_OR_SPACE, '');
	      input = replace(input, TRAILING_C0_CONTROL_OR_SPACE, '$1');
	    }
	
	    input = replace(input, TAB_AND_NEW_LINE, '');
	
	    codePoints = arrayFrom(input);
	
	    while (pointer <= codePoints.length) {
	      chr = codePoints[pointer];
	      switch (state) {
	        case SCHEME_START:
	          if (chr && exec(ALPHA, chr)) {
	            buffer += toLowerCase(chr);
	            state = SCHEME;
	          } else if (!stateOverride) {
	            state = NO_SCHEME;
	            continue;
	          } else return INVALID_SCHEME;
	          break;
	
	        case SCHEME:
	          if (chr && (exec(ALPHANUMERIC, chr) || chr === '+' || chr === '-' || chr === '.')) {
	            buffer += toLowerCase(chr);
	          } else if (chr === ':') {
	            if (stateOverride && (
	              (url.isSpecial() !== hasOwn(specialSchemes, buffer)) ||
	              (buffer === 'file' && (url.includesCredentials() || url.port !== null)) ||
	              (url.scheme === 'file' && !url.host)
	            )) return;
	            url.scheme = buffer;
	            if (stateOverride) {
	              if (url.isSpecial() && specialSchemes[url.scheme] === url.port) url.port = null;
	              return;
	            }
	            buffer = '';
	            if (url.scheme === 'file') {
	              state = FILE;
	            } else if (url.isSpecial() && base && base.scheme === url.scheme) {
	              state = SPECIAL_RELATIVE_OR_AUTHORITY;
	            } else if (url.isSpecial()) {
	              state = SPECIAL_AUTHORITY_SLASHES;
	            } else if (codePoints[pointer + 1] === '/') {
	              state = PATH_OR_AUTHORITY;
	              pointer++;
	            } else {
	              url.cannotBeABaseURL = true;
	              push(url.path, '');
	              state = CANNOT_BE_A_BASE_URL_PATH;
	            }
	          } else if (!stateOverride) {
	            buffer = '';
	            state = NO_SCHEME;
	            pointer = 0;
	            continue;
	          } else return INVALID_SCHEME;
	          break;
	
	        case NO_SCHEME:
	          if (!base || (base.cannotBeABaseURL && chr !== '#')) return INVALID_SCHEME;
	          if (base.cannotBeABaseURL && chr === '#') {
	            url.scheme = base.scheme;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	            url.fragment = '';
	            url.cannotBeABaseURL = true;
	            state = FRAGMENT;
	            break;
	          }
	          state = base.scheme === 'file' ? FILE : RELATIVE;
	          continue;
	
	        case SPECIAL_RELATIVE_OR_AUTHORITY:
	          if (chr === '/' && codePoints[pointer + 1] === '/') {
	            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	            pointer++;
	          } else {
	            state = RELATIVE;
	            continue;
	          } break;
	
	        case PATH_OR_AUTHORITY:
	          if (chr === '/') {
	            state = AUTHORITY;
	            break;
	          } else {
	            state = PATH;
	            continue;
	          }
	
	        case RELATIVE:
	          url.scheme = base.scheme;
	          if (chr === EOF) {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	          } else if (chr === '/' || (chr === '\\' && url.isSpecial())) {
	            state = RELATIVE_SLASH;
	          } else if (chr === '?') {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = '';
	            state = QUERY;
	          } else if (chr === '#') {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.query = base.query;
	            url.fragment = '';
	            state = FRAGMENT;
	          } else {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            url.path = arraySlice(base.path);
	            url.path.length--;
	            state = PATH;
	            continue;
	          } break;
	
	        case RELATIVE_SLASH:
	          if (url.isSpecial() && (chr === '/' || chr === '\\')) {
	            state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	          } else if (chr === '/') {
	            state = AUTHORITY;
	          } else {
	            url.username = base.username;
	            url.password = base.password;
	            url.host = base.host;
	            url.port = base.port;
	            state = PATH;
	            continue;
	          } break;
	
	        case SPECIAL_AUTHORITY_SLASHES:
	          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
	          if (chr !== '/' || charAt(buffer, pointer + 1) !== '/') continue;
	          pointer++;
	          break;
	
	        case SPECIAL_AUTHORITY_IGNORE_SLASHES:
	          if (chr !== '/' && chr !== '\\') {
	            state = AUTHORITY;
	            continue;
	          } break;
	
	        case AUTHORITY:
	          if (chr === '@') {
	            if (seenAt) buffer = '%40' + buffer;
	            seenAt = true;
	            bufferCodePoints = arrayFrom(buffer);
	            for (var i = 0; i < bufferCodePoints.length; i++) {
	              var codePoint = bufferCodePoints[i];
	              if (codePoint === ':' && !seenPasswordToken) {
	                seenPasswordToken = true;
	                continue;
	              }
	              var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
	              if (seenPasswordToken) url.password += encodedCodePoints;
	              else url.username += encodedCodePoints;
	            }
	            buffer = '';
	          } else if (
	            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
	            (chr === '\\' && url.isSpecial())
	          ) {
	            if (seenAt && buffer === '') return INVALID_AUTHORITY;
	            pointer -= arrayFrom(buffer).length + 1;
	            buffer = '';
	            state = HOST;
	          } else buffer += chr;
	          break;
	
	        case HOST:
	        case HOSTNAME:
	          if (stateOverride && url.scheme === 'file') {
	            state = FILE_HOST;
	            continue;
	          } else if (chr === ':' && !seenBracket) {
	            if (buffer === '') return INVALID_HOST;
	            failure = url.parseHost(buffer);
	            if (failure) return failure;
	            buffer = '';
	            state = PORT;
	            if (stateOverride === HOSTNAME) return;
	          } else if (
	            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
	            (chr === '\\' && url.isSpecial())
	          ) {
	            if (url.isSpecial() && buffer === '') return INVALID_HOST;
	            if (stateOverride && buffer === '' && (url.includesCredentials() || url.port !== null)) return;
	            failure = url.parseHost(buffer);
	            if (failure) return failure;
	            buffer = '';
	            state = PATH_START;
	            if (stateOverride) return;
	            continue;
	          } else {
	            if (chr === '[') seenBracket = true;
	            else if (chr === ']') seenBracket = false;
	            buffer += chr;
	          } break;
	
	        case PORT:
	          if (exec(DIGIT, chr)) {
	            buffer += chr;
	          } else if (
	            chr === EOF || chr === '/' || chr === '?' || chr === '#' ||
	            (chr === '\\' && url.isSpecial()) ||
	            stateOverride
	          ) {
	            if (buffer !== '') {
	              var port = parseInt(buffer, 10);
	              if (port > 0xFFFF) return INVALID_PORT;
	              url.port = (url.isSpecial() && port === specialSchemes[url.scheme]) ? null : port;
	              buffer = '';
	            }
	            if (stateOverride) return;
	            state = PATH_START;
	            continue;
	          } else return INVALID_PORT;
	          break;
	
	        case FILE:
	          url.scheme = 'file';
	          if (chr === '/' || chr === '\\') state = FILE_SLASH;
	          else if (base && base.scheme === 'file') {
	            switch (chr) {
	              case EOF:
	                url.host = base.host;
	                url.path = arraySlice(base.path);
	                url.query = base.query;
	                break;
	              case '?':
	                url.host = base.host;
	                url.path = arraySlice(base.path);
	                url.query = '';
	                state = QUERY;
	                break;
	              case '#':
	                url.host = base.host;
	                url.path = arraySlice(base.path);
	                url.query = base.query;
	                url.fragment = '';
	                state = FRAGMENT;
	                break;
	              default:
	                if (!startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
	                  url.host = base.host;
	                  url.path = arraySlice(base.path);
	                  url.shortenPath();
	                }
	                state = PATH;
	                continue;
	            }
	          } else {
	            state = PATH;
	            continue;
	          } break;
	
	        case FILE_SLASH:
	          if (chr === '/' || chr === '\\') {
	            state = FILE_HOST;
	            break;
	          }
	          if (base && base.scheme === 'file' && !startsWithWindowsDriveLetter(join(arraySlice(codePoints, pointer), ''))) {
	            if (isWindowsDriveLetter(base.path[0], true)) push(url.path, base.path[0]);
	            else url.host = base.host;
	          }
	          state = PATH;
	          continue;
	
	        case FILE_HOST:
	          if (chr === EOF || chr === '/' || chr === '\\' || chr === '?' || chr === '#') {
	            if (!stateOverride && isWindowsDriveLetter(buffer)) {
	              state = PATH;
	            } else if (buffer === '') {
	              url.host = '';
	              if (stateOverride) return;
	              state = PATH_START;
	            } else {
	              failure = url.parseHost(buffer);
	              if (failure) return failure;
	              if (url.host === 'localhost') url.host = '';
	              if (stateOverride) return;
	              buffer = '';
	              state = PATH_START;
	            } continue;
	          } else buffer += chr;
	          break;
	
	        case PATH_START:
	          if (url.isSpecial()) {
	            state = PATH;
	            if (chr !== '/' && chr !== '\\') continue;
	          } else if (!stateOverride && chr === '?') {
	            url.query = '';
	            state = QUERY;
	          } else if (!stateOverride && chr === '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr !== EOF) {
	            state = PATH;
	            if (chr !== '/') continue;
	          } break;
	
	        case PATH:
	          if (
	            chr === EOF || chr === '/' ||
	            (chr === '\\' && url.isSpecial()) ||
	            (!stateOverride && (chr === '?' || chr === '#'))
	          ) {
	            if (isDoubleDot(buffer)) {
	              url.shortenPath();
	              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
	                push(url.path, '');
	              }
	            } else if (isSingleDot(buffer)) {
	              if (chr !== '/' && !(chr === '\\' && url.isSpecial())) {
	                push(url.path, '');
	              }
	            } else {
	              if (url.scheme === 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
	                if (url.host) url.host = '';
	                buffer = charAt(buffer, 0) + ':'; // normalize windows drive letter
	              }
	              push(url.path, buffer);
	            }
	            buffer = '';
	            if (url.scheme === 'file' && (chr === EOF || chr === '?' || chr === '#')) {
	              while (url.path.length > 1 && url.path[0] === '') {
	                shift(url.path);
	              }
	            }
	            if (chr === '?') {
	              url.query = '';
	              state = QUERY;
	            } else if (chr === '#') {
	              url.fragment = '';
	              state = FRAGMENT;
	            }
	          } else {
	            buffer += percentEncode(chr, pathPercentEncodeSet);
	          } break;
	
	        case CANNOT_BE_A_BASE_URL_PATH:
	          if (chr === '?') {
	            url.query = '';
	            state = QUERY;
	          } else if (chr === '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr !== EOF) {
	            url.path[0] += percentEncode(chr, C0ControlPercentEncodeSet);
	          } break;
	
	        case QUERY:
	          if (!stateOverride && chr === '#') {
	            url.fragment = '';
	            state = FRAGMENT;
	          } else if (chr !== EOF) {
	            if (chr === "'" && url.isSpecial()) url.query += '%27';
	            else if (chr === '#') url.query += '%23';
	            else url.query += percentEncode(chr, C0ControlPercentEncodeSet);
	          } break;
	
	        case FRAGMENT:
	          if (chr !== EOF) url.fragment += percentEncode(chr, fragmentPercentEncodeSet);
	          break;
	      }
	
	      pointer++;
	    }
	  },
	  // https://url.spec.whatwg.org/#host-parsing
	  parseHost: function (input) {
	    var result, codePoints, index;
	    if (charAt(input, 0) === '[') {
	      if (charAt(input, input.length - 1) !== ']') return INVALID_HOST;
	      result = parseIPv6(stringSlice(input, 1, -1));
	      if (!result) return INVALID_HOST;
	      this.host = result;
	    // opaque host
	    } else if (!this.isSpecial()) {
	      if (exec(FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return INVALID_HOST;
	      result = '';
	      codePoints = arrayFrom(input);
	      for (index = 0; index < codePoints.length; index++) {
	        result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
	      }
	      this.host = result;
	    } else {
	      input = toASCII(input);
	      if (exec(FORBIDDEN_HOST_CODE_POINT, input)) return INVALID_HOST;
	      result = parseIPv4(input);
	      if (result === null) return INVALID_HOST;
	      this.host = result;
	    }
	  },
	  // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
	  cannotHaveUsernamePasswordPort: function () {
	    return !this.host || this.cannotBeABaseURL || this.scheme === 'file';
	  },
	  // https://url.spec.whatwg.org/#include-credentials
	  includesCredentials: function () {
	    return this.username !== '' || this.password !== '';
	  },
	  // https://url.spec.whatwg.org/#is-special
	  isSpecial: function () {
	    return hasOwn(specialSchemes, this.scheme);
	  },
	  // https://url.spec.whatwg.org/#shorten-a-urls-path
	  shortenPath: function () {
	    var path = this.path;
	    var pathSize = path.length;
	    if (pathSize && (this.scheme !== 'file' || pathSize !== 1 || !isWindowsDriveLetter(path[0], true))) {
	      path.length--;
	    }
	  },
	  // https://url.spec.whatwg.org/#concept-url-serializer
	  serialize: function () {
	    var url = this;
	    var scheme = url.scheme;
	    var username = url.username;
	    var password = url.password;
	    var host = url.host;
	    var port = url.port;
	    var path = url.path;
	    var query = url.query;
	    var fragment = url.fragment;
	    var output = scheme + ':';
	    if (host !== null) {
	      output += '//';
	      if (url.includesCredentials()) {
	        output += username + (password ? ':' + password : '') + '@';
	      }
	      output += serializeHost(host);
	      if (port !== null) output += ':' + port;
	    } else if (scheme === 'file') output += '//';
	    output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
	    if (query !== null) output += '?' + query;
	    if (fragment !== null) output += '#' + fragment;
	    return output;
	  },
	  // https://url.spec.whatwg.org/#dom-url-href
	  setHref: function (href) {
	    var failure = this.parse(href);
	    if (failure) throw new TypeError(failure);
	    this.searchParams.update();
	  },
	  // https://url.spec.whatwg.org/#dom-url-origin
	  getOrigin: function () {
	    var scheme = this.scheme;
	    var port = this.port;
	    if (scheme === 'blob') try {
	      return new URLConstructor(scheme.path[0]).origin;
	    } catch (error) {
	      return 'null';
	    }
	    if (scheme === 'file' || !this.isSpecial()) return 'null';
	    return scheme + '://' + serializeHost(this.host) + (port !== null ? ':' + port : '');
	  },
	  // https://url.spec.whatwg.org/#dom-url-protocol
	  getProtocol: function () {
	    return this.scheme + ':';
	  },
	  setProtocol: function (protocol) {
	    this.parse($toString(protocol) + ':', SCHEME_START);
	  },
	  // https://url.spec.whatwg.org/#dom-url-username
	  getUsername: function () {
	    return this.username;
	  },
	  setUsername: function (username) {
	    var codePoints = arrayFrom($toString(username));
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    this.username = '';
	    for (var i = 0; i < codePoints.length; i++) {
	      this.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
	    }
	  },
	  // https://url.spec.whatwg.org/#dom-url-password
	  getPassword: function () {
	    return this.password;
	  },
	  setPassword: function (password) {
	    var codePoints = arrayFrom($toString(password));
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    this.password = '';
	    for (var i = 0; i < codePoints.length; i++) {
	      this.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
	    }
	  },
	  // https://url.spec.whatwg.org/#dom-url-host
	  getHost: function () {
	    var host = this.host;
	    var port = this.port;
	    return host === null ? ''
	      : port === null ? serializeHost(host)
	      : serializeHost(host) + ':' + port;
	  },
	  setHost: function (host) {
	    if (this.cannotBeABaseURL) return;
	    this.parse(host, HOST);
	  },
	  // https://url.spec.whatwg.org/#dom-url-hostname
	  getHostname: function () {
	    var host = this.host;
	    return host === null ? '' : serializeHost(host);
	  },
	  setHostname: function (hostname) {
	    if (this.cannotBeABaseURL) return;
	    this.parse(hostname, HOSTNAME);
	  },
	  // https://url.spec.whatwg.org/#dom-url-port
	  getPort: function () {
	    var port = this.port;
	    return port === null ? '' : $toString(port);
	  },
	  setPort: function (port) {
	    if (this.cannotHaveUsernamePasswordPort()) return;
	    port = $toString(port);
	    if (port === '') this.port = null;
	    else this.parse(port, PORT);
	  },
	  // https://url.spec.whatwg.org/#dom-url-pathname
	  getPathname: function () {
	    var path = this.path;
	    return this.cannotBeABaseURL ? path[0] : path.length ? '/' + join(path, '/') : '';
	  },
	  setPathname: function (pathname) {
	    if (this.cannotBeABaseURL) return;
	    this.path = [];
	    this.parse(pathname, PATH_START);
	  },
	  // https://url.spec.whatwg.org/#dom-url-search
	  getSearch: function () {
	    var query = this.query;
	    return query ? '?' + query : '';
	  },
	  setSearch: function (search) {
	    search = $toString(search);
	    if (search === '') {
	      this.query = null;
	    } else {
	      if (charAt(search, 0) === '?') search = stringSlice(search, 1);
	      this.query = '';
	      this.parse(search, QUERY);
	    }
	    this.searchParams.update();
	  },
	  // https://url.spec.whatwg.org/#dom-url-searchparams
	  getSearchParams: function () {
	    return this.searchParams.facade;
	  },
	  // https://url.spec.whatwg.org/#dom-url-hash
	  getHash: function () {
	    var fragment = this.fragment;
	    return fragment ? '#' + fragment : '';
	  },
	  setHash: function (hash) {
	    hash = $toString(hash);
	    if (hash === '') {
	      this.fragment = null;
	      return;
	    }
	    if (charAt(hash, 0) === '#') hash = stringSlice(hash, 1);
	    this.fragment = '';
	    this.parse(hash, FRAGMENT);
	  },
	  update: function () {
	    this.query = this.searchParams.serialize() || null;
	  }
	};
	
	// `URL` constructor
	// https://url.spec.whatwg.org/#url-class
	var URLConstructor = function URL(url /* , base */) {
	  var that = anInstance(this, URLPrototype);
	  var base = validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
	  var state = setInternalState(that, new URLState(url, false, base));
	  if (!DESCRIPTORS) {
	    that.href = state.serialize();
	    that.origin = state.getOrigin();
	    that.protocol = state.getProtocol();
	    that.username = state.getUsername();
	    that.password = state.getPassword();
	    that.host = state.getHost();
	    that.hostname = state.getHostname();
	    that.port = state.getPort();
	    that.pathname = state.getPathname();
	    that.search = state.getSearch();
	    that.searchParams = state.getSearchParams();
	    that.hash = state.getHash();
	  }
	};
	
	var URLPrototype = URLConstructor.prototype;
	
	var accessorDescriptor = function (getter, setter) {
	  return {
	    get: function () {
	      return getInternalURLState(this)[getter]();
	    },
	    set: setter && function (value) {
	      return getInternalURLState(this)[setter](value);
	    },
	    configurable: true,
	    enumerable: true
	  };
	};
	
	if (DESCRIPTORS) {
	  // `URL.prototype.href` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-href
	  defineBuiltInAccessor(URLPrototype, 'href', accessorDescriptor('serialize', 'setHref'));
	  // `URL.prototype.origin` getter
	  // https://url.spec.whatwg.org/#dom-url-origin
	  defineBuiltInAccessor(URLPrototype, 'origin', accessorDescriptor('getOrigin'));
	  // `URL.prototype.protocol` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-protocol
	  defineBuiltInAccessor(URLPrototype, 'protocol', accessorDescriptor('getProtocol', 'setProtocol'));
	  // `URL.prototype.username` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-username
	  defineBuiltInAccessor(URLPrototype, 'username', accessorDescriptor('getUsername', 'setUsername'));
	  // `URL.prototype.password` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-password
	  defineBuiltInAccessor(URLPrototype, 'password', accessorDescriptor('getPassword', 'setPassword'));
	  // `URL.prototype.host` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-host
	  defineBuiltInAccessor(URLPrototype, 'host', accessorDescriptor('getHost', 'setHost'));
	  // `URL.prototype.hostname` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-hostname
	  defineBuiltInAccessor(URLPrototype, 'hostname', accessorDescriptor('getHostname', 'setHostname'));
	  // `URL.prototype.port` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-port
	  defineBuiltInAccessor(URLPrototype, 'port', accessorDescriptor('getPort', 'setPort'));
	  // `URL.prototype.pathname` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-pathname
	  defineBuiltInAccessor(URLPrototype, 'pathname', accessorDescriptor('getPathname', 'setPathname'));
	  // `URL.prototype.search` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-search
	  defineBuiltInAccessor(URLPrototype, 'search', accessorDescriptor('getSearch', 'setSearch'));
	  // `URL.prototype.searchParams` getter
	  // https://url.spec.whatwg.org/#dom-url-searchparams
	  defineBuiltInAccessor(URLPrototype, 'searchParams', accessorDescriptor('getSearchParams'));
	  // `URL.prototype.hash` accessors pair
	  // https://url.spec.whatwg.org/#dom-url-hash
	  defineBuiltInAccessor(URLPrototype, 'hash', accessorDescriptor('getHash', 'setHash'));
	}
	
	// `URL.prototype.toJSON` method
	// https://url.spec.whatwg.org/#dom-url-tojson
	defineBuiltIn(URLPrototype, 'toJSON', function toJSON() {
	  return getInternalURLState(this).serialize();
	}, { enumerable: true });
	
	// `URL.prototype.toString` method
	// https://url.spec.whatwg.org/#URL-stringification-behavior
	defineBuiltIn(URLPrototype, 'toString', function toString() {
	  return getInternalURLState(this).serialize();
	}, { enumerable: true });
	
	if (NativeURL) {
	  var nativeCreateObjectURL = NativeURL.createObjectURL;
	  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
	  // `URL.createObjectURL` method
	  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
	  if (nativeCreateObjectURL) defineBuiltIn(URLConstructor, 'createObjectURL', bind(nativeCreateObjectURL, NativeURL));
	  // `URL.revokeObjectURL` method
	  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
	  if (nativeRevokeObjectURL) defineBuiltIn(URLConstructor, 'revokeObjectURL', bind(nativeRevokeObjectURL, NativeURL));
	}
	
	setToStringTag(URLConstructor, 'URL');
	
	$({ global: true, constructor: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
	  URL: URLConstructor
	});


/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// TODO: Remove this module from `core-js@4` since it's replaced to module below
	__webpack_require__(1549);


/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var getBuiltIn = __webpack_require__(35);
	var validateArgumentsLength = __webpack_require__(87);
	var toString = __webpack_require__(17);
	var USE_NATIVE_URL = __webpack_require__(268);
	
	var URL = getBuiltIn('URL');
	
	// `URL.parse` method
	// https://url.spec.whatwg.org/#dom-url-canparse
	$({ target: 'URL', stat: true, forced: !USE_NATIVE_URL }, {
	  parse: function parse(url) {
	    var length = validateArgumentsLength(arguments.length, 1);
	    var urlString = toString(url);
	    var base = length < 2 || arguments[1] === undefined ? undefined : toString(arguments[1]);
	    try {
	      return new URL(urlString, base);
	    } catch (error) {
	      return null;
	    }
	  }
	});


/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4);
	var call = __webpack_require__(16);
	
	// `URL.prototype.toJSON` method
	// https://url.spec.whatwg.org/#dom-url-tojson
	$({ target: 'URL', proto: true, enumerable: true }, {
	  toJSON: function toJSON() {
	    return call(URL.prototype.toString, this);
	  }
	});


/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1227);
	
	module.exports = parent;


/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(609);
	__webpack_require__(605);
	__webpack_require__(604);
	__webpack_require__(606);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(611);
	__webpack_require__(610);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(614);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(617);
	__webpack_require__(618);
	__webpack_require__(1316);
	__webpack_require__(1317);
	__webpack_require__(1264);
	__webpack_require__(1262);
	__webpack_require__(1271);
	__webpack_require__(567);
	__webpack_require__(1272);
	__webpack_require__(1273);
	__webpack_require__(1274);
	__webpack_require__(1275);
	__webpack_require__(1279);
	__webpack_require__(1276);
	__webpack_require__(1278);
	__webpack_require__(1277);
	__webpack_require__(1281);
	__webpack_require__(1280);
	__webpack_require__(1282);
	__webpack_require__(568);
	__webpack_require__(1283);
	__webpack_require__(1284);
	__webpack_require__(1285);
	__webpack_require__(175);
	__webpack_require__(1286);
	__webpack_require__(1287);
	__webpack_require__(1288);
	__webpack_require__(1289);
	__webpack_require__(1290);
	__webpack_require__(1292);
	__webpack_require__(1291);
	__webpack_require__(1293);
	__webpack_require__(1294);
	__webpack_require__(1295);
	__webpack_require__(1296);
	__webpack_require__(1297);
	__webpack_require__(1298);
	__webpack_require__(1299);
	__webpack_require__(1300);
	__webpack_require__(1301);
	__webpack_require__(1303);
	__webpack_require__(1302);
	__webpack_require__(1304);
	__webpack_require__(1305);
	__webpack_require__(1265);
	__webpack_require__(1267);
	__webpack_require__(1268);
	__webpack_require__(1307);
	__webpack_require__(1266);
	__webpack_require__(1270);
	__webpack_require__(1269);
	__webpack_require__(1308);
	__webpack_require__(1309);
	__webpack_require__(1310);
	__webpack_require__(1311);
	__webpack_require__(1312);
	__webpack_require__(1313);
	__webpack_require__(1314);
	__webpack_require__(1315);
	__webpack_require__(1318);
	__webpack_require__(1319);
	__webpack_require__(1320);
	__webpack_require__(1321);
	__webpack_require__(1322);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(371);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(575);
	__webpack_require__(576);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(587);
	__webpack_require__(372);
	__webpack_require__(588);
	__webpack_require__(589);
	__webpack_require__(590);
	__webpack_require__(591);
	__webpack_require__(592);
	__webpack_require__(593);
	__webpack_require__(594);
	__webpack_require__(595);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(598);
	__webpack_require__(599);
	__webpack_require__(600);
	__webpack_require__(601);
	__webpack_require__(1324);
	__webpack_require__(1325);
	__webpack_require__(1326);
	__webpack_require__(1327);
	__webpack_require__(1328);
	__webpack_require__(1329);
	__webpack_require__(1330);
	__webpack_require__(1331);
	__webpack_require__(1332);
	__webpack_require__(1333);
	__webpack_require__(1334);
	__webpack_require__(1335);
	__webpack_require__(1337);
	__webpack_require__(1338);
	__webpack_require__(1339);
	__webpack_require__(1343);
	__webpack_require__(1340);
	__webpack_require__(1341);
	__webpack_require__(1342);
	__webpack_require__(1344);
	__webpack_require__(1345);
	__webpack_require__(1346);
	__webpack_require__(1347);
	__webpack_require__(1348);
	__webpack_require__(1349);
	__webpack_require__(1350);
	__webpack_require__(270);
	__webpack_require__(1351);
	__webpack_require__(1352);
	__webpack_require__(1353);
	__webpack_require__(1360);
	__webpack_require__(1354);
	__webpack_require__(1356);
	__webpack_require__(1359);
	__webpack_require__(1364);
	__webpack_require__(1365);
	__webpack_require__(1366);
	__webpack_require__(1367);
	__webpack_require__(1368);
	__webpack_require__(1371);
	__webpack_require__(1369);
	__webpack_require__(1370);
	__webpack_require__(1372);
	__webpack_require__(1373);
	__webpack_require__(1374);
	__webpack_require__(1375);
	__webpack_require__(1377);
	__webpack_require__(1376);
	__webpack_require__(602);
	__webpack_require__(1378);
	__webpack_require__(1379);
	__webpack_require__(373);
	__webpack_require__(1380);
	__webpack_require__(1381);
	__webpack_require__(1382);
	__webpack_require__(1383);
	__webpack_require__(603);
	__webpack_require__(374);
	__webpack_require__(375);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(378);
	__webpack_require__(379);
	__webpack_require__(380);
	__webpack_require__(1386);
	__webpack_require__(1390);
	__webpack_require__(1391);
	__webpack_require__(1395);
	__webpack_require__(1396);
	__webpack_require__(1397);
	__webpack_require__(215);
	__webpack_require__(1401);
	__webpack_require__(1400);
	__webpack_require__(1402);
	__webpack_require__(1403);
	__webpack_require__(1404);
	__webpack_require__(1405);
	__webpack_require__(1407);
	__webpack_require__(1406);
	__webpack_require__(1408);
	__webpack_require__(1410);
	__webpack_require__(1411);
	__webpack_require__(1414);
	__webpack_require__(1416);
	__webpack_require__(1421);
	__webpack_require__(1417);
	__webpack_require__(1420);
	__webpack_require__(1385);
	__webpack_require__(1387);
	__webpack_require__(1388);
	__webpack_require__(1389);
	__webpack_require__(1392);
	__webpack_require__(1393);
	__webpack_require__(1394);
	__webpack_require__(1398);
	__webpack_require__(1399);
	__webpack_require__(1409);
	__webpack_require__(1412);
	__webpack_require__(1413);
	__webpack_require__(1415);
	__webpack_require__(1434);
	__webpack_require__(1435);
	__webpack_require__(1442);
	__webpack_require__(1440);
	__webpack_require__(1441);
	__webpack_require__(1462);
	__webpack_require__(1463);
	__webpack_require__(1460);
	__webpack_require__(1461);
	__webpack_require__(1425);
	__webpack_require__(1426);
	__webpack_require__(1427);
	__webpack_require__(1428);
	__webpack_require__(1429);
	__webpack_require__(1433);
	__webpack_require__(1430);
	__webpack_require__(1432);
	__webpack_require__(1431);
	__webpack_require__(1436);
	__webpack_require__(1437);
	__webpack_require__(1438);
	__webpack_require__(1439);
	__webpack_require__(1443);
	__webpack_require__(1444);
	__webpack_require__(1445);
	__webpack_require__(1446);
	__webpack_require__(1447);
	__webpack_require__(1449);
	__webpack_require__(1448);
	__webpack_require__(1450);
	__webpack_require__(1451);
	__webpack_require__(1452);
	__webpack_require__(1453);
	__webpack_require__(1454);
	__webpack_require__(1455);
	__webpack_require__(1456);
	__webpack_require__(1457);
	__webpack_require__(1458);
	__webpack_require__(1459);
	__webpack_require__(1464);
	__webpack_require__(1465);
	__webpack_require__(1467);
	__webpack_require__(1469);
	__webpack_require__(1529);
	__webpack_require__(1530);
	__webpack_require__(1532);
	__webpack_require__(271);
	__webpack_require__(1533);
	__webpack_require__(1534);
	__webpack_require__(1535);
	__webpack_require__(1536);
	__webpack_require__(1537);
	__webpack_require__(1538);
	__webpack_require__(1542);
	__webpack_require__(1543);
	__webpack_require__(1550);
	__webpack_require__(1548);
	__webpack_require__(1551);
	__webpack_require__(1552);
	__webpack_require__(1546);
	__webpack_require__(1544);
	__webpack_require__(1545);
	__webpack_require__(1547);
	
	module.exports = __webpack_require__(106);


/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1228);
	__webpack_require__(271);
	
	module.exports = parent;


/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1231);
	__webpack_require__(271);
	
	module.exports = parent;


/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var parent = __webpack_require__(1232);
	__webpack_require__(271);
	
	module.exports = parent;


/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(1790);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(1788);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(1558);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.1 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.4.5 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.d3 = global.d3 || {}));
	}(this, (function (exports) { 'use strict';
	
	function formatDecimal(x) {
	  return Math.abs(x = Math.round(x)) >= 1e21
	      ? x.toLocaleString("en").replace(/,/g, "")
	      : x.toString(10);
	}
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimalParts(1.23) returns ["123", 0].
	function formatDecimalParts(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  return new FormatSpecifier({
	    fill: match[1],
	    align: match[2],
	    sign: match[3],
	    symbol: match[4],
	    zero: match[5],
	    width: match[6],
	    comma: match[7],
	    precision: match[8] && match[8].slice(1),
	    trim: match[9],
	    type: match[10]
	  });
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	  this.align = specifier.align === undefined ? ">" : specifier.align + "";
	  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	  this.zero = !!specifier.zero;
	  this.width = specifier.width === undefined ? undefined : +specifier.width;
	  this.comma = !!specifier.comma;
	  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	  this.trim = !!specifier.trim;
	  this.type = specifier.type === undefined ? "" : specifier.type + "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimalParts(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": formatDecimal,
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var map = Array.prototype.map,
	    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
	      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
	      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
	      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
	      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
	      percent = locale.percent === undefined ? "%" : locale.percent + "",
	      minus = locale.minus === undefined ? "-" : locale.minus + "",
	      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision === undefined ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
	        var valueNegative = value < 0 || 1 / value < 0;
	
	        // Perform the initial formatting.
	        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
	        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  minus: "-"
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.FormatSpecifier = FormatSpecifier;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(1562)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.9 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r, ccw = !!ccw;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.3.0 Copyright 2020 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(621)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newDate(y, m, d) {
	  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "g": formatYearISO,
	    "G": formatFullYearISO,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "q": formatQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "g": formatUTCYearISO,
	    "G": formatUTCFullYearISO,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "q": formatUTCQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "g": parseYear,
	    "G": parseFullYear,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "q": parseQuarter,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, Z) {
	    return function(string) {
	      var d = newDate(1900, undefined, 1),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
	
	      // If this is utcParse, never use the local timezone.
	      if (Z && !("Z" in d)) d.Z = 0;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // If the month was not specified, inherit from the quarter.
	      if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return localDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatQuarter(d) {
	    return 1 + ~~(d.getMonth() / 3);
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  function formatUTCQuarter(d) {
	    return 1 + ~~(d.getUTCMonth() / 3);
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", false);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier += "", true);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseQuarter(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.s = +n[0], i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function dISO(d) {
	  var day = d.getDay();
	  return (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	}
	
	function formatWeekNumberISO(d, p) {
	  d = dISO(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatYearISO(d, p) {
	  d = dISO(d);
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatFullYearISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function UTCdISO(d) {
	  var day = d.getUTCDay();
	  return (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCYearISO(d, p) {
	  d = UTCdISO(d);
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCFullYearISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1568));
	var _index2 = _interopRequireDefault(__webpack_require__(625));
	var _index3 = _interopRequireDefault(__webpack_require__(626));
	var _index4 = _interopRequireDefault(__webpack_require__(627));
	var _index5 = _interopRequireDefault(__webpack_require__(382));
	var _index6 = _interopRequireDefault(__webpack_require__(176));
	var _index7 = _interopRequireDefault(__webpack_require__(623));
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */
	
	var formatters = {
	  // Era
	  G: function G(date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function y(date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear();
	      // Returns 1 for 1 BC (which is year 0 in JavaScript)
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function Y(date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options);
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
	
	    // Two digit year
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    }
	
	    // Ordinal number
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    }
	
	    // Padding
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function R(date, token) {
	    var isoWeekYear = (0, _index3.default)(date);
	
	    // Padding
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function u(date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function Q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function M(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function L(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function w(date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function I(date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function d(date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function D(date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function E(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function e(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function c(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function i(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function a(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function b(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function B(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function H(date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function K(date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function k(date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function m(date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function s(date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function X(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function x(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);
	
	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);
	
	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function O(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function z(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function t(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function T(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	  return formatTimezone(offset, dirtyDelimiter);
	}
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_DAY = 86400000;
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISODay;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	function setUTCISODay(dirtyDate, dirtyDay) {
	  (0, _index2.default)(2, arguments);
	  var day = (0, _index3.default)(dirtyDay);
	  if (day % 7 === 0) {
	    day = day - 7;
	  }
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var currentDay = date.getUTCDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(625));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setUTCWeek;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(627));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	function setUTCWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index.default)(dirtyWeek);
	  var diff = (0, _index3.default)(date, options) - week;
	  date.setUTCDate(date.getUTCDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(626));
	var _index2 = _interopRequireDefault(__webpack_require__(217));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(382));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(218));
	var _index4 = _interopRequireDefault(__webpack_require__(12));
	var _index5 = __webpack_require__(51);
	function startOfUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = areIntervalsOverlapping;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name areIntervalsOverlapping
	 * @category Interval Helpers
	 * @summary Is the given time interval overlapping with another time interval?
	 *
	 * @description
	 * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
	 * @returns {Boolean} whether the time intervals are overlapping
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> true
	 *
	 * @example
	 * // For non-overlapping time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // For adjacent time intervals:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
	 * )
	 * //=> false
	 *
	 * @example
	 * // Using the inclusive option:
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
	 * )
	 * //=> false
	 * areIntervalsOverlapping(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
	 *   { inclusive: true }
	 * )
	 * //=> true
	 */
	function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
	  (0, _index2.default)(2, arguments);
	  var leftStartTime = (0, _index.default)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.end).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  if (options !== null && options !== void 0 && options.inclusive) {
	    return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
	  }
	  return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	}
	module.exports = exports.default;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = clamp;
	var _index = _interopRequireDefault(__webpack_require__(663));
	var _index2 = _interopRequireDefault(__webpack_require__(664));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name clamp
	 * @category Interval Helpers
	 * @summary Return a date bounded by the start and the end of the given interval
	 *
	 * @description
	 * Clamps a date to the lower bound with the start of the interval and the upper
	 * bound with the end of the interval.
	 *
	 * - When the date is less than the start of the interval, the start is returned.
	 * - When the date is greater than the end of the interval, the end is returned.
	 * - Otherwise the date is returned.
	 *
	 * @example
	 * // What is Mar, 21, 2021 bounded to an interval starting at Mar, 22, 2021 and ending at Apr, 01, 2021
	 * const result = clamp(new Date(2021, 2, 21), {
	 *   start: new Date(2021, 2, 22),
	 *   end: new Date(2021, 3, 1),
	 * })
	 * //=> Mon Mar 22 2021 00:00:00
	 *
	 * @param {Date | Number} date - the date to be bounded
	 * @param {Interval} interval - the interval to bound to
	 * @returns {Date} the date bounded by the start and the end of the interval
	 * @throws {TypeError} 2 arguments required
	 */
	function clamp(date, _ref) {
	  var start = _ref.start,
	    end = _ref.end;
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)([(0, _index.default)([date, start]), end]);
	}
	module.exports = exports.default;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestIndexTo;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name closestIndexTo
	 * @category Common Helpers
	 * @summary Return an index of the closest date from the array comparing to the given date.
	 *
	 * @description
	 * Return an index of the closest date from the array comparing to the given date.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Number | undefined} an index of the date closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const datesArray = [
	 *   new Date(2015, 0, 1),
	 *   new Date(2016, 0, 1),
	 *   new Date(2017, 0, 1)
	 * ]
	 * const result = closestIndexTo(dateToCompare, datesArray)
	 * //=> 1
	 */
	function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return NaN;
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];
	
	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate, index) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (isNaN(Number(currentDate))) {
	      result = NaN;
	      minDistance = NaN;
	      return;
	    }
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	    if (result == null || distance < Number(minDistance)) {
	      result = index;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	module.exports = exports.default;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = closestTo;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name closestTo
	 * @category Common Helpers
	 * @summary Return a date from the array closest to the given date.
	 *
	 * @description
	 * Return a date from the array closest to the given date.
	 *
	 * @param {Date | Number} dateToCompare - the date to compare with
	 * @param {Array<Date> | Array<number>} datesArray - the array to search
	 * @returns {Date | undefined} the date from the array closest to the given date or undefined if no valid value is given
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
	 * const dateToCompare = new Date(2015, 8, 6)
	 * const result = closestTo(dateToCompare, [
	 *   new Date(2000, 0, 1),
	 *   new Date(2030, 0, 1)
	 * ])
	 * //=> Tue Jan 01 2030 00:00:00
	 */
	function closestTo(dirtyDateToCompare, dirtyDatesArray) {
	  (0, _index2.default)(2, arguments);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  if (isNaN(Number(dateToCompare))) return new Date(NaN);
	  var timeToCompare = dateToCompare.getTime();
	  var datesArray;
	  // `dirtyDatesArray` is undefined or null
	  if (dirtyDatesArray == null) {
	    datesArray = [];
	
	    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
	  } else if (typeof dirtyDatesArray.forEach === 'function') {
	    datesArray = dirtyDatesArray;
	
	    // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
	  } else {
	    datesArray = Array.prototype.slice.call(dirtyDatesArray);
	  }
	  var result;
	  var minDistance;
	  datesArray.forEach(function (dirtyDate) {
	    var currentDate = (0, _index.default)(dirtyDate);
	    if (isNaN(Number(currentDate))) {
	      result = new Date(NaN);
	      minDistance = NaN;
	      return;
	    }
	    var distance = Math.abs(timeToCompare - currentDate.getTime());
	    if (result == null || distance < Number(minDistance)) {
	      result = currentDate;
	      minDistance = distance;
	    }
	  });
	  return result;
	}
	module.exports = exports.default;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compareDesc;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name compareDesc
	 * @category Common Helpers
	 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
	 *
	 * @description
	 * Compare the two dates and return -1 if the first date is after the second,
	 * 1 if the first date is before the second or 0 if dates are equal.
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Number} the result of the comparison
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
	 * const result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
	 * //=> 1
	 *
	 * @example
	 * // Sort the array of dates in reverse chronological order:
	 * const result = [
	 *   new Date(1995, 6, 2),
	 *   new Date(1987, 1, 11),
	 *   new Date(1989, 6, 10)
	 * ].sort(compareDesc)
	 * //=> [
	 * //   Sun Jul 02 1995 00:00:00,
	 * //   Mon Jul 10 1989 00:00:00,
	 * //   Wed Feb 11 1987 00:00:00
	 * // ]
	 */
	function compareDesc(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var diff = dateLeft.getTime() - dateRight.getTime();
	  if (diff > 0) {
	    return -1;
	  } else if (diff < 0) {
	    return 1;
	    // Return 0 if diff is 0; return NaN if diff is NaN
	  } else {
	    return diff;
	  }
	}
	module.exports = exports.default;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = daysToWeeks;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name daysToWeeks
	 * @category Conversion Helpers
	 * @summary Convert days to weeks.
	 *
	 * @description
	 * Convert a number of days to a full number of weeks.
	 *
	 * @param {number} days - number of days to be converted
	 *
	 * @returns {number} the number of days converted in weeks
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 14 days to weeks:
	 * const result = daysToWeeks(14)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = daysToWeeks(13)
	 * //=> 1
	 */
	function daysToWeeks(days) {
	  (0, _index.default)(1, arguments);
	  var weeks = days / _index2.daysInWeek;
	  return Math.floor(weeks);
	}
	module.exports = exports.default;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInBusinessDays;
	var _index = _interopRequireDefault(__webpack_require__(110));
	var _index2 = _interopRequireDefault(__webpack_require__(127));
	var _index3 = _interopRequireDefault(__webpack_require__(222));
	var _index4 = _interopRequireDefault(__webpack_require__(128));
	var _index5 = _interopRequireDefault(__webpack_require__(277));
	var _index6 = _interopRequireDefault(__webpack_require__(6));
	var _index7 = _interopRequireDefault(__webpack_require__(5));
	var _index8 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name differenceInBusinessDays
	 * @category Day Helpers
	 * @summary Get the number of business days between the given dates.
	 *
	 * @description
	 * Get the number of business day periods between the given dates.
	 * Business days being days that arent in the weekend.
	 * Like `differenceInCalendarDays`, the function removes the times from
	 * the dates before calculating the difference.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of business days
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many business days are between
	 * // 10 January 2014 and 20 July 2014?
	 * const result = differenceInBusinessDays(
	 *   new Date(2014, 6, 20),
	 *   new Date(2014, 0, 10)
	 * )
	 * //=> 136
	 *
	 * // How many business days are between
	 * // 30 November 2021 and 1 November 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 30),
	 *   new Date(2021, 10, 1)
	 * )
	 * //=> 21
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 December 2021?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 11, 1)
	 * )
	 * //=> -22
	 *
	 * // How many business days are between
	 * // 1 November 2021 and 1 November 2021 ?
	 * const result = differenceInBusinessDays(
	 *   new Date(2021, 10, 1),
	 *   new Date(2021, 10, 1)
	 * )
	 * //=> 0
	 */
	function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
	  (0, _index7.default)(2, arguments);
	  var dateLeft = (0, _index6.default)(dirtyDateLeft);
	  var dateRight = (0, _index6.default)(dirtyDateRight);
	  if (!(0, _index4.default)(dateLeft) || !(0, _index4.default)(dateRight)) return NaN;
	  var calendarDifference = (0, _index2.default)(dateLeft, dateRight);
	  var sign = calendarDifference < 0 ? -1 : 1;
	  var weeks = (0, _index8.default)(calendarDifference / 7);
	  var result = weeks * 5;
	  dateRight = (0, _index.default)(dateRight, weeks * 7);
	
	  // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
	  while (!(0, _index3.default)(dateLeft, dateRight)) {
	    // sign is used to account for both negative and positive differences
	    result += (0, _index5.default)(dateRight) ? 0 : sign;
	    dateRight = (0, _index.default)(dateRight, sign);
	  }
	  return result === 0 ? 0 : result;
	}
	module.exports = exports.default;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInCalendarISOWeeks;
	var _index = _interopRequireDefault(__webpack_require__(109));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name differenceInCalendarISOWeeks
	 * @category ISO Week Helpers
	 * @summary Get the number of calendar ISO weeks between the given dates.
	 *
	 * @description
	 * Get the number of calendar ISO weeks between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of calendar ISO weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
	 * const result = differenceInCalendarISOWeeks(
	 *   new Date(2014, 6, 21),
	 *   new Date(2014, 6, 6)
	 * )
	 * //=> 3
	 */
	function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
	  (0, _index3.default)(2, arguments);
	  var startOfISOWeekLeft = (0, _index2.default)(dirtyDateLeft);
	  var startOfISOWeekRight = (0, _index2.default)(dirtyDateRight);
	  var timestampLeft = startOfISOWeekLeft.getTime() - (0, _index.default)(startOfISOWeekLeft);
	  var timestampRight = startOfISOWeekRight.getTime() - (0, _index.default)(startOfISOWeekRight);
	
	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports.default;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInISOWeekYears;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(634));
	var _index3 = _interopRequireDefault(__webpack_require__(150));
	var _index4 = _interopRequireDefault(__webpack_require__(670));
	var _index5 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name differenceInISOWeekYears
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of full ISO week-numbering years between the given dates.
	 *
	 * @description
	 * Get the number of full ISO week-numbering years between the given dates.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @returns {Number} the number of full ISO week-numbering years
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
	 * const result = differenceInISOWeekYears(
	 *   new Date(2012, 0, 1),
	 *   new Date(2010, 0, 1)
	 * )
	 * //=> 1
	 */
	function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
	  (0, _index5.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyDateLeft);
	  var dateRight = (0, _index.default)(dirtyDateRight);
	  var sign = (0, _index3.default)(dateLeft, dateRight);
	  var difference = Math.abs((0, _index2.default)(dateLeft, dateRight));
	  dateLeft = (0, _index4.default)(dateLeft, sign * difference);
	
	  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
	  // if last calendar ISO year is not full
	  // If so, result must be decreased by 1 in absolute value
	  var isLastISOWeekYearNotFull = Number((0, _index3.default)(dateLeft, dateRight) === -sign);
	  var result = sign * (difference - isLastISOWeekYearNotFull);
	  // Prevent negative zero
	  return result === 0 ? 0 : result;
	}
	module.exports = exports.default;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInQuarters;
	var _index = _interopRequireDefault(__webpack_require__(274));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = __webpack_require__(178);
	/**
	 * @name differenceInQuarters
	 * @category Quarter Helpers
	 * @summary Get the number of quarters between the given dates.
	 *
	 * @description
	 * Get the number of quarters between the given dates.
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full quarters
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full quarters are between 31 December 2013 and 2 July 2014?
	 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
	 * //=> 2
	 */
	function differenceInQuarters(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 3;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports.default;

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = differenceInWeeks;
	var _index = _interopRequireDefault(__webpack_require__(390));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = __webpack_require__(178);
	/**
	 * @name differenceInWeeks
	 * @category Week Helpers
	 * @summary Get the number of full weeks between the given dates.
	 *
	 * @description
	 * Get the number of full weeks between two dates. Fractional weeks are
	 * truncated towards zero by default.
	 *
	 * One "full week" is the distance between a local time in one day to the same
	 * local time 7 days earlier or later. A full week can sometimes be less than
	 * or more than 7*24 hours if a daylight savings change happens between two dates.
	 *
	 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
	 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
	 *
	 *
	 * @param {Date|Number} dateLeft - the later date
	 * @param {Date|Number} dateRight - the earlier date
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Number} the number of full weeks
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // How many full weeks are between 5 July 2014 and 20 July 2014?
	 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
	 * //=> 2
	 *
	 * // How many full weeks are between
	 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
	 * // Note: because local time is used, the
	 * // result will always be 8 weeks (54 days),
	 * // even if DST starts and the period has
	 * // only 54*24-1 hours.
	 * const result = differenceInWeeks(
	 *   new Date(2020, 5, 1),
	 *   new Date(2020, 2, 6)
	 * )
	 * //=> 8
	 */
	function differenceInWeeks(dateLeft, dateRight, options) {
	  (0, _index2.default)(2, arguments);
	  var diff = (0, _index.default)(dateLeft, dateRight) / 7;
	  return (0, _index3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
	}
	module.exports = exports.default;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachHourOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(384));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachHourOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of hours within the specified time interval.
	 *
	 * @description
	 * Return the array of hours within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
	 * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.step` must be a number greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each hour between 6 October 2014, 12:00 and 6 October 2014, 15:00
	 * const result = eachHourOfInterval({
	 *   start: new Date(2014, 9, 6, 12),
	 *   end: new Date(2014, 9, 6, 15)
	 * })
	 * //=> [
	 * //   Mon Oct 06 2014 12:00:00,
	 * //   Mon Oct 06 2014 13:00:00,
	 * //   Mon Oct 06 2014 14:00:00,
	 * //   Mon Oct 06 2014 15:00:00
	 * // ]
	 */
	function eachHourOfInterval(dirtyInterval, options) {
	  var _options$step;
	  (0, _index3.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index2.default)(interval.start);
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setMinutes(0, 0, 0);
	  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	  return dates;
	}
	module.exports = exports.default;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMinuteOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(385));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(400));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachMinuteOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of minutes within the specified time interval.
	 *
	 * @description
	 * Returns the array of minutes within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.step=1] - the step to increment by. The step must be equal to or greater than 1
	 * @throws {TypeError} 1 argument required
	 * @returns {Date[]} the array with starts of minutes from the minute of the interval start to the minute of the interval end
	 * @throws {RangeError} `options.step` must be a number equal to or greater than 1
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each minute between 14 October 2020, 13:00 and 14 October 2020, 13:03
	 * const result = eachMinuteOfInterval({
	 *   start: new Date(2014, 9, 14, 13),
	 *   end: new Date(2014, 9, 14, 13, 3)
	 * })
	 * //=> [
	 * //   Wed Oct 14 2014 13:00:00,
	 * //   Wed Oct 14 2014 13:01:00,
	 * //   Wed Oct 14 2014 13:02:00,
	 * //   Wed Oct 14 2014 13:03:00
	 * // ]
	 */
	function eachMinuteOfInterval(interval, options) {
	  var _options$step;
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index3.default)((0, _index2.default)(interval.start));
	  var endDate = (0, _index2.default)(interval.end);
	  var startTime = startDate.getTime();
	  var endTime = endDate.getTime();
	  if (startTime >= endTime) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
	  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal to or greater than 1');
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index2.default)(currentDate));
	    currentDate = (0, _index.default)(currentDate, step);
	  }
	  return dates;
	}
	module.exports = exports.default;

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachMonthOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachMonthOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of months within the specified time interval.
	 *
	 * @description
	 * Return the array of months within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each month between 6 February 2014 and 10 August 2014:
	 * const result = eachMonthOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Sat Feb 01 2014 00:00:00,
	 * //   Sat Mar 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Thu May 01 2014 00:00:00,
	 * //   Sun Jun 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * //   Fri Aug 01 2014 00:00:00
	 * // ]
	 */
	function eachMonthOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();
	  var dates = [];
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setDate(1);
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setMonth(currentDate.getMonth() + 1);
	  }
	  return dates;
	}
	module.exports = exports.default;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachQuarterOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(386));
	var _index2 = _interopRequireDefault(__webpack_require__(401));
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachQuarterOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of quarters within the specified time interval.
	 *
	 * @description
	 * Return the array of quarters within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each quarter within interval 6 February 2014 - 10 August 2014:
	 * const result = eachQuarterOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2014, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Tue Apr 01 2014 00:00:00,
	 * //   Tue Jul 01 2014 00:00:00,
	 * // ]
	 */
	function eachQuarterOfInterval(dirtyInterval) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var startDateQuarter = (0, _index2.default)(startDate);
	  var endDateQuarter = (0, _index2.default)(endDate);
	  endTime = endDateQuarter.getTime();
	  var quarters = [];
	  var currentQuarter = startDateQuarter;
	  while (currentQuarter.getTime() <= endTime) {
	    quarters.push((0, _index3.default)(currentQuarter));
	    currentQuarter = (0, _index.default)(currentQuarter, 1);
	  }
	  return quarters;
	}
	module.exports = exports.default;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(272));
	var _index2 = _interopRequireDefault(__webpack_require__(131));
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachWeekOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of weeks within the specified time interval.
	 *
	 * @description
	 * Return the array of weeks within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each week within interval 6 October 2014 - 23 November 2014:
	 * const result = eachWeekOfInterval({
	 *   start: new Date(2014, 9, 6),
	 *   end: new Date(2014, 10, 23)
	 * })
	 * //=> [
	 * //   Sun Oct 05 2014 00:00:00,
	 * //   Sun Oct 12 2014 00:00:00,
	 * //   Sun Oct 19 2014 00:00:00,
	 * //   Sun Oct 26 2014 00:00:00,
	 * //   Sun Nov 02 2014 00:00:00,
	 * //   Sun Nov 09 2014 00:00:00,
	 * //   Sun Nov 16 2014 00:00:00,
	 * //   Sun Nov 23 2014 00:00:00
	 * // ]
	 */
	function eachWeekOfInterval(dirtyInterval, options) {
	  (0, _index4.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index3.default)(interval.start);
	  var endDate = (0, _index3.default)(interval.end);
	  var endTime = endDate.getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var startDateWeek = (0, _index2.default)(startDate, options);
	  var endDateWeek = (0, _index2.default)(endDate, options);
	
	  // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
	  startDateWeek.setHours(15);
	  endDateWeek.setHours(15);
	  endTime = endDateWeek.getTime();
	  var weeks = [];
	  var currentWeek = startDateWeek;
	  while (currentWeek.getTime() <= endTime) {
	    currentWeek.setHours(0);
	    weeks.push((0, _index3.default)(currentWeek));
	    currentWeek = (0, _index.default)(currentWeek, 1);
	    currentWeek.setHours(15);
	  }
	  return weeks;
	}
	module.exports = exports.default;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(393));
	var _index2 = _interopRequireDefault(__webpack_require__(279));
	var _index3 = _interopRequireDefault(__webpack_require__(395));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachWeekendOfMonth
	 * @category Month Helpers
	 * @summary List all the Saturdays and Sundays in the given month.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the given month.
	 *
	 * @param {Date|Number} date - the given month
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the given month
	 * const result = eachWeekendOfMonth(new Date(2022, 1, 1))
	 * //=> [
	 * //   Sat Feb 05 2022 00:00:00,
	 * //   Sun Feb 06 2022 00:00:00,
	 * //   Sat Feb 12 2022 00:00:00,
	 * //   Sun Feb 13 2022 00:00:00,
	 * //   Sat Feb 19 2022 00:00:00,
	 * //   Sun Feb 20 2022 00:00:00,
	 * //   Sat Feb 26 2022 00:00:00,
	 * //   Sun Feb 27 2022 00:00:00
	 * // ]
	 */
	function eachWeekendOfMonth(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index2.default)(dirtyDate);
	  if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
	  var endDate = (0, _index3.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	module.exports = exports.default;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachWeekendOfYear;
	var _index = _interopRequireDefault(__webpack_require__(393));
	var _index2 = _interopRequireDefault(__webpack_require__(639));
	var _index3 = _interopRequireDefault(__webpack_require__(403));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachWeekendOfYear
	 * @category Year Helpers
	 * @summary List all the Saturdays and Sundays in the year.
	 *
	 * @description
	 * Get all the Saturdays and Sundays in the year.
	 *
	 * @param {Date|Number} date - the given year
	 * @returns {Date[]} an array containing all the Saturdays and Sundays
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The passed date is invalid
	 *
	 * @example
	 * // Lists all Saturdays and Sundays in the year
	 * const result = eachWeekendOfYear(new Date(2020, 1, 1))
	 * //=> [
	 * //   Sat Jan 03 2020 00:00:00,
	 * //   Sun Jan 04 2020 00:00:00,
	 * //   ...
	 * //   Sun Dec 27 2020 00:00:00
	 * // ]
	 * ]
	 */
	function eachWeekendOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var startDate = (0, _index3.default)(dirtyDate);
	  var endDate = (0, _index2.default)(dirtyDate);
	  return (0, _index.default)({
	    start: startDate,
	    end: endDate
	  });
	}
	module.exports = exports.default;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = eachYearOfInterval;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name eachYearOfInterval
	 * @category Interval Helpers
	 * @summary Return the array of yearly timestamps within the specified time interval.
	 *
	 * @description
	 * Return the array of yearly timestamps within the specified time interval.
	 *
	 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
	 * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // Each year between 6 February 2014 and 10 August 2017:
	 * const result = eachYearOfInterval({
	 *   start: new Date(2014, 1, 6),
	 *   end: new Date(2017, 7, 10)
	 * })
	 * //=> [
	 * //   Wed Jan 01 2014 00:00:00,
	 * //   Thu Jan 01 2015 00:00:00,
	 * //   Fri Jan 01 2016 00:00:00,
	 * //   Sun Jan 01 2017 00:00:00
	 * // ]
	 */
	function eachYearOfInterval(dirtyInterval) {
	  (0, _index2.default)(1, arguments);
	  var interval = dirtyInterval || {};
	  var startDate = (0, _index.default)(interval.start);
	  var endDate = (0, _index.default)(interval.end);
	  var endTime = endDate.getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startDate.getTime() <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var dates = [];
	  var currentDate = startDate;
	  currentDate.setHours(0, 0, 0, 0);
	  currentDate.setMonth(0, 1);
	  while (currentDate.getTime() <= endTime) {
	    dates.push((0, _index.default)(currentDate));
	    currentDate.setFullYear(currentDate.getFullYear() + 1);
	  }
	  return dates;
	}
	module.exports = exports.default;

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfDecade;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfDecade
	 * @category Decade Helpers
	 * @summary Return the end of a decade for the given date.
	 *
	 * @description
	 * Return the end of a decade for the given date.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a decade
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The end of a decade for 12 May 1984 00:00:00:
	 * const result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
	 * //=> Dec 31 1989 23:59:59.999
	 */
	function endOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 11, 31);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfHour;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfHour
	 * @category Hour Helpers
	 * @summary Return the end of an hour for the given date.
	 *
	 * @description
	 * Return the end of an hour for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an hour for 2 September 2014 11:55:00:
	 * const result = endOfHour(new Date(2014, 8, 2, 11, 55))
	 * //=> Tue Sep 02 2014 11:59:59.999
	 */
	function endOfHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMinutes(59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(638));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the end of an ISO week for the given date.
	 *
	 * @description
	 * Return the end of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week for 2 September 2014 11:55:00:
	 * const result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 23:59:59.999
	 */
	function endOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports.default;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(179));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the end of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the end of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of an ISO week-numbering year for 2 July 2005:
	 * const result = endOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 23:59:59.999
	 */
	function endOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuaryOfNextYear);
	  date.setMilliseconds(date.getMilliseconds() - 1);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfMinute;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfMinute
	 * @category Minute Helpers
	 * @summary Return the end of a minute for the given date.
	 *
	 * @description
	 * Return the end of a minute for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a minute for 1 December 2014 22:15:45.400:
	 * const result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:59.999
	 */
	function endOfMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setSeconds(59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfQuarter;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the end of a year quarter for the given date.
	 *
	 * @description
	 * Return the end of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a quarter for 2 September 2014 11:55:00:
	 * const result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 23:59:59.999
	 */
	function endOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfSecond;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name endOfSecond
	 * @category Second Helpers
	 * @summary Return the end of a second for the given date.
	 *
	 * @description
	 * Return the end of a second for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of a second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The end of a second for 1 December 2014 22:15:45.400:
	 * const result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
	 * //=> Mon Dec 01 2014 22:15:45.999
	 */
	function endOfSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  date.setMilliseconds(999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfToday;
	var _index = _interopRequireDefault(__webpack_require__(394));
	/**
	 * @name endOfToday
	 * @category Day Helpers
	 * @summary Return the end of today.
	 * @pure false
	 *
	 * @description
	 * Return the end of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the end of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfToday()
	 * //=> Mon Oct 6 2014 23:59:59.999
	 */
	function endOfToday() {
	  return (0, _index.default)(Date.now());
	}
	module.exports = exports.default;

/***/ },
/* 1601 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfTomorrow;
	/**
	 * @name endOfTomorrow
	 * @category Day Helpers
	 * @summary Return the end of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the end of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the end of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfTomorrow()
	 * //=> Tue Oct 7 2014 23:59:59.999
	 */
	function endOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1602 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endOfYesterday;
	/**
	 * @name endOfYesterday
	 * @category Day Helpers
	 * @summary Return the end of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the end of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the end of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = endOfYesterday()
	 * //=> Sun Oct 5 2014 23:59:59.999
	 */
	function endOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(23, 59, 59, 999);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNow;
	var _index = _interopRequireDefault(__webpack_require__(640));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name formatDistanceToNow
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given date and now in words.
	 *
	 * | Distance to now                                                   | Result              |
	 * |-------------------------------------------------------------------|---------------------|
	 * | 0 ... 30 secs                                                     | less than a minute  |
	 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
	 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
	 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
	 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
	 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
	 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
	 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
	 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
	 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
	 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
	 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
	 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
	 * | N yrs ... N yrs 3 months                                          | about N years       |
	 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
	 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
	 *
	 * With `options.includeSeconds == true`:
	 * | Distance to now     | Result               |
	 * |---------------------|----------------------|
	 * | 0 secs ... 5 secs   | less than 5 seconds  |
	 * | 5 secs ... 10 secs  | less than 10 seconds |
	 * | 10 secs ... 20 secs | less than 20 seconds |
	 * | 20 secs ... 40 secs | half a minute        |
	 * | 40 secs ... 60 secs | less than a minute   |
	 * | 60 secs ... 90 secs | 1 minute             |
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - the object with options
	 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
	 * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * const result = formatDistanceToNow(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * const result = formatDistanceToNow(
	 *   new Date(2015, 0, 1, 0, 0, 15),
	 *   {includeSeconds: true}
	 * )
	 * //=> 'less than 20 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * const result = formatDistanceToNow(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in about 1 year'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 August 2016 in Esperanto?
	 * const eoLocale = require('date-fns/locale/eo')
	 * const result = formatDistanceToNow(
	 *   new Date(2016, 7, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> 'pli ol 1 jaro'
	 */
	function formatDistanceToNow(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	module.exports = exports.default;

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDistanceToNowStrict;
	var _index = _interopRequireDefault(__webpack_require__(641));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name formatDistanceToNowStrict
	 * @category Common Helpers
	 * @summary Return the distance between the given date and now in words.
	 * @pure false
	 *
	 * @description
	 * Return the distance between the given dates in words, using strict units.
	 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
	 * 'less than' and the like.
	 *
	 * | Distance between dates | Result              |
	 * |------------------------|---------------------|
	 * | 0 ... 59 secs          | [0..59] seconds     |
	 * | 1 ... 59 mins          | [1..59] minutes     |
	 * | 1 ... 23 hrs           | [1..23] hours       |
	 * | 1 ... 29 days          | [1..29] days        |
	 * | 1 ... 11 months        | [1..11] months      |
	 * | 1 ... N years          | [1..N]  years       |
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
	 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
	 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {String} the distance in words
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `formatDistance` property
	 *
	 * @example
	 * // If today is 1 January 2015, what is the distance to 2 July 2014?
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2014, 6, 2)
	 * )
	 * //=> '6 months'
	 *
	 * @example
	 * // If now is 1 January 2015 00:00:00,
	 * // what is the distance to 1 January 2015 00:00:15, including seconds?
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2015, 0, 1, 0, 0, 15)
	 * )
	 * //=> '15 seconds'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016, with a suffix?
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {addSuffix: true}
	 * )
	 * //=> 'in 1 year'
	 *
	 * @example
	 * // If today is 28 January 2015,
	 * // what is the distance to 1 January 2015, in months, rounded up??
	 * const result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
	 *   unit: 'month',
	 *   roundingMethod: 'ceil'
	 * })
	 * //=> '1 month'
	 *
	 * @example
	 * // If today is 1 January 2015,
	 * // what is the distance to 1 January 2016 in Esperanto?
	 * const eoLocale = require('date-fns/locale/eo')
	 * const result = formatDistanceToNowStrict(
	 *   new Date(2016, 0, 1),
	 *   {locale: eoLocale}
	 * )
	 * //=> '1 jaro'
	 */
	function formatDistanceToNowStrict(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	module.exports = exports.default;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatDuration;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(177));
	var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
	
	/**
	 * @name formatDuration
	 * @category Common Helpers
	 * @summary Formats a duration in human-readable format
	 *
	 * @description
	 * Return human-readable duration string i.e. "9 months 2 days"
	 *
	 * @param {Duration} duration - the duration to format
	 * @param {Object} [options] - an object with options.
	 * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
	 * @param {boolean} [options.zero=false] - should zeros be included in the output?
	 * @param {string} [options.delimiter=' '] - delimiter string
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @returns {string} the formatted date string
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Format full duration
	 * formatDuration({
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds'
	 *
	 * @example
	 * // Format partial duration
	 * formatDuration({ months: 9, days: 2 })
	 * //=> '9 months 2 days'
	 *
	 * @example
	 * // Customize the format
	 * formatDuration(
	 *   {
	 *     years: 2,
	 *     months: 9,
	 *     weeks: 1,
	 *     days: 7,
	 *     hours: 5,
	 *     minutes: 9,
	 *     seconds: 30
	 *   },
	 *   { format: ['months', 'weeks'] }
	 * ) === '9 months 1 week'
	 *
	 * @example
	 * // Customize the zeros presence
	 * formatDuration({ years: 0, months: 9 })
	 * //=> '9 months'
	 * formatDuration({ years: 0, months: 9 }, { zero: true })
	 * //=> '0 years 9 months'
	 *
	 * @example
	 * // Customize the delimiter
	 * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
	 * //=> '2 years, 9 months, 3 weeks'
	 */
	function formatDuration(duration, options) {
	  var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index2.default;
	  var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
	  var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
	  var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : ' ';
	  if (!locale.formatDistance) {
	    return '';
	  }
	  var result = format.reduce(function (acc, unit) {
	    var token = "x".concat(unit.replace(/(^.)/, function (m) {
	      return m.toUpperCase();
	    }));
	    var value = duration[unit];
	    if (typeof value === 'number' && (zero || duration[unit])) {
	      return acc.concat(locale.formatDistance(token, value));
	    }
	    return acc;
	  }, []).join(delimiter);
	  return result;
	}
	module.exports = exports.default;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(176));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name formatISO
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
	 *
	 * @description
	 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
	 * @returns {String} the formatted date string (in local time zone)
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918T190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, date only:
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
	 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52Z'
	 */
	function formatISO(date, options) {
	  var _options$format, _options$representati;
	  (0, _index3.default)(1, arguments);
	  var originalDate = (0, _index.default)(date);
	  if (isNaN(originalDate.getTime())) {
	    throw new RangeError('Invalid time value');
	  }
	  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
	  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	  var result = '';
	  var tzOffset = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : '';
	
	  // Representation is either 'date' or 'complete'
	  if (representation !== 'time') {
	    var day = (0, _index2.default)(originalDate.getDate(), 2);
	    var month = (0, _index2.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index2.default)(originalDate.getFullYear(), 4);
	
	    // yyyyMMdd or yyyy-MM-dd.
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  }
	
	  // Representation is either 'time' or 'complete'
	  if (representation !== 'date') {
	    // Add the timezone.
	    var offset = originalDate.getTimezoneOffset();
	    if (offset !== 0) {
	      var absoluteOffset = Math.abs(offset);
	      var hourOffset = (0, _index2.default)(Math.floor(absoluteOffset / 60), 2);
	      var minuteOffset = (0, _index2.default)(absoluteOffset % 60, 2);
	      // If less than 0, the sign is +, because it is ahead of time.
	      var sign = offset < 0 ? '+' : '-';
	      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	    } else {
	      tzOffset = 'Z';
	    }
	    var hour = (0, _index2.default)(originalDate.getHours(), 2);
	    var minute = (0, _index2.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index2.default)(originalDate.getSeconds(), 2);
	
	    // If there's also date, separate it with time with 'T'
	    var separator = result === '' ? '' : 'T';
	
	    // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
	    var time = [hour, minute, second].join(timeDelimiter);
	
	    // HHmmss or HH:mm:ss.
	    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
	  }
	  return result;
	}
	module.exports = exports.default;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISO9075;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(128));
	var _index3 = _interopRequireDefault(__webpack_require__(176));
	/**
	 * @name formatISO9075
	 * @category Common Helpers
	 * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
	 *
	 * @description
	 * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
	 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
	 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18 19:00:52'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075, short format:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
	 * //=> '20190918 190052'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, date only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
	 * //=> '2019-09-18'
	 *
	 * @example
	 * // Represent 18 September 2019 in ISO 9075 format, time only:
	 * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
	 * //=> '19:00:52'
	 */
	function formatISO9075(dirtyDate, options) {
	  var _options$format, _options$representati;
	  if (arguments.length < 1) {
	    throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
	  }
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
	  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
	  if (format !== 'extended' && format !== 'basic') {
	    throw new RangeError("format must be 'extended' or 'basic'");
	  }
	  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
	    throw new RangeError("representation must be 'date', 'time', or 'complete'");
	  }
	  var result = '';
	  var dateDelimiter = format === 'extended' ? '-' : '';
	  var timeDelimiter = format === 'extended' ? ':' : '';
	
	  // Representation is either 'date' or 'complete'
	  if (representation !== 'time') {
	    var day = (0, _index3.default)(originalDate.getDate(), 2);
	    var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	    var year = (0, _index3.default)(originalDate.getFullYear(), 4);
	
	    // yyyyMMdd or yyyy-MM-dd.
	    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
	  }
	
	  // Representation is either 'time' or 'complete'
	  if (representation !== 'date') {
	    var hour = (0, _index3.default)(originalDate.getHours(), 2);
	    var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	    var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	
	    // If there's also date, separate it with time with a space
	    var separator = result === '' ? '' : ' ';
	
	    // HHmmss or HH:mm:ss.
	    result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
	  }
	  return result;
	}
	module.exports = exports.default;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatISODuration;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name formatISODuration
	 * @category Common Helpers
	 * @summary Format a duration object according as ISO 8601 duration string
	 *
	 * @description
	 * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
	 *
	 * @param {Duration} duration - the duration to format
	 *
	 * @returns {String} The ISO 8601 duration string
	 * @throws {TypeError} Requires 1 argument
	 * @throws {Error} Argument must be an object
	 *
	 * @example
	 * // Format the given duration as ISO 8601 string
	 * const result = formatISODuration({
	 *   years: 39,
	 *   months: 2,
	 *   days: 20,
	 *   hours: 7,
	 *   minutes: 5,
	 *   seconds: 0
	 * })
	 * //=> 'P39Y2M20DT0H0M0S'
	 */
	function formatISODuration(duration) {
	  (0, _index.default)(1, arguments);
	  if ((0, _typeof2.default)(duration) !== 'object') throw new Error('Duration must be an object');
	  var _duration$years = duration.years,
	    years = _duration$years === void 0 ? 0 : _duration$years,
	    _duration$months = duration.months,
	    months = _duration$months === void 0 ? 0 : _duration$months,
	    _duration$days = duration.days,
	    days = _duration$days === void 0 ? 0 : _duration$days,
	    _duration$hours = duration.hours,
	    hours = _duration$hours === void 0 ? 0 : _duration$hours,
	    _duration$minutes = duration.minutes,
	    minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
	    _duration$seconds = duration.seconds,
	    seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
	  return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
	}
	module.exports = exports.default;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC3339;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(128));
	var _index3 = _interopRequireDefault(__webpack_require__(176));
	var _index4 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name formatRFC3339
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
	 *
	 * @description
	 * Return the formatted date string in RFC 3339 format. Options may be passed to control the parts and notations of the date.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> '2019-09-18T19:00:52Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 2 digits of second fraction:
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
	 * //=> '2019-09-18T19:00:52.23Z'
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 3339 format, 3 digits of second fraction
	 * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
	 * //=> '2019-09-18T19:00:52.234Z'
	 */
	function formatRFC3339(dirtyDate, options) {
	  var _options$fractionDigi;
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	  var fractionDigits = Number((_options$fractionDigi = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options$fractionDigi !== void 0 ? _options$fractionDigi : 0);
	
	  // Test if fractionDigits is between 0 and 3 _and_ is not NaN
	  if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
	    throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
	  }
	  var day = (0, _index3.default)(originalDate.getDate(), 2);
	  var month = (0, _index3.default)(originalDate.getMonth() + 1, 2);
	  var year = originalDate.getFullYear();
	  var hour = (0, _index3.default)(originalDate.getHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getSeconds(), 2);
	  var fractionalSecond = '';
	  if (fractionDigits > 0) {
	    var milliseconds = originalDate.getMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
	    fractionalSecond = '.' + (0, _index3.default)(fractionalSeconds, fractionDigits);
	  }
	  var offset = '';
	  var tzOffset = originalDate.getTimezoneOffset();
	  if (tzOffset !== 0) {
	    var absoluteOffset = Math.abs(tzOffset);
	    var hourOffset = (0, _index3.default)((0, _index4.default)(absoluteOffset / 60), 2);
	    var minuteOffset = (0, _index3.default)(absoluteOffset % 60, 2);
	    // If less than 0, the sign is +, because it is ahead of time.
	    var sign = tzOffset < 0 ? '+' : '-';
	    offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
	  } else {
	    offset = 'Z';
	  }
	  return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
	}
	module.exports = exports.default;

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRFC7231;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(128));
	var _index3 = _interopRequireDefault(__webpack_require__(176));
	var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	
	/**
	 * @name formatRFC7231
	 * @category Common Helpers
	 * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
	 *
	 * @description
	 * Return the formatted date string in RFC 7231 format.
	 * The result will always be in UTC timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 18 September 2019 in RFC 7231 format:
	 * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
	 * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
	 */
	function formatRFC7231(dirtyDate) {
	  if (arguments.length < 1) {
	    throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
	  }
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index2.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	  var dayName = days[originalDate.getUTCDay()];
	  var dayOfMonth = (0, _index3.default)(originalDate.getUTCDate(), 2);
	  var monthName = months[originalDate.getUTCMonth()];
	  var year = originalDate.getUTCFullYear();
	  var hour = (0, _index3.default)(originalDate.getUTCHours(), 2);
	  var minute = (0, _index3.default)(originalDate.getUTCMinutes(), 2);
	  var second = (0, _index3.default)(originalDate.getUTCSeconds(), 2);
	
	  // Result variables.
	  return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
	}
	module.exports = exports.default;

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatRelative;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(127));
	var _index3 = _interopRequireDefault(__webpack_require__(221));
	var _index4 = _interopRequireDefault(__webpack_require__(177));
	var _index5 = _interopRequireDefault(__webpack_require__(224));
	var _index6 = _interopRequireDefault(__webpack_require__(6));
	var _index7 = _interopRequireDefault(__webpack_require__(109));
	var _index8 = _interopRequireDefault(__webpack_require__(5));
	var _index9 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name formatRelative
	 * @category Common Helpers
	 * @summary Represent the date in words relative to the given base date.
	 *
	 * @description
	 * Represent the date in words relative to the given base date.
	 *
	 * | Distance to the base date | Result                    |
	 * |---------------------------|---------------------------|
	 * | Previous 6 days           | last Sunday at 04:30 AM   |
	 * | Last day                  | yesterday at 04:30 AM     |
	 * | Same day                  | today at 04:30 AM         |
	 * | Next day                  | tomorrow at 04:30 AM      |
	 * | Next 6 days               | Sunday at 04:30 AM        |
	 * | Other                     | 12/31/2017                |
	 *
	 * @param {Date|Number} date - the date to format
	 * @param {Date|Number} baseDate - the date to compare with
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {String} the date in words
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.locale` must contain `formatRelative` property
	 *
	 * @example
	 * // Represent the date of 6 days ago in words relative to the given base date. In this example, today is Wednesday
	 * const result = formatRelative(addDays(new Date(), -6), new Date())
	 * //=> "last Thursday at 12:45 AM"
	 */
	function formatRelative(dirtyDate, dirtyBaseDate, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index8.default)(2, arguments);
	  var date = (0, _index6.default)(dirtyDate);
	  var baseDate = (0, _index6.default)(dirtyBaseDate);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index4.default;
	  var weekStartsOn = (0, _index9.default)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  if (!locale.formatRelative) {
	    throw new RangeError('locale must contain formatRelative property');
	  }
	  var diff = (0, _index2.default)(date, baseDate);
	  if (isNaN(diff)) {
	    throw new RangeError('Invalid time value');
	  }
	  var token;
	  if (diff < -6) {
	    token = 'other';
	  } else if (diff < -1) {
	    token = 'lastWeek';
	  } else if (diff < 0) {
	    token = 'yesterday';
	  } else if (diff < 1) {
	    token = 'today';
	  } else if (diff < 2) {
	    token = 'tomorrow';
	  } else if (diff < 7) {
	    token = 'nextWeek';
	  } else {
	    token = 'other';
	  }
	  var utcDate = (0, _index5.default)(date, (0, _index7.default)(date));
	  var utcBaseDate = (0, _index5.default)(baseDate, (0, _index7.default)(baseDate));
	  var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	  return (0, _index3.default)(date, formatStr, {
	    locale: locale,
	    weekStartsOn: weekStartsOn
	  });
	}
	module.exports = exports.default;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = fromUnixTime;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(12));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name fromUnixTime
	 * @category Timestamp Helpers
	 * @summary Create a date from a Unix timestamp.
	 *
	 * @description
	 * Create a date from a Unix timestamp (in seconds). Decimal values will be discarded.
	 *
	 * @param {Number} unixTime - the given Unix timestamp (in seconds)
	 * @returns {Date} the date
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Create the date 29 February 2012 11:45:05:
	 * const result = fromUnixTime(1330515905)
	 * //=> Wed Feb 29 2012 11:45:05
	 */
	function fromUnixTime(dirtyUnixTime) {
	  (0, _index3.default)(1, arguments);
	  var unixTime = (0, _index2.default)(dirtyUnixTime);
	  return (0, _index.default)(unixTime * 1000);
	}
	module.exports = exports.default;

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDayOfYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(403));
	var _index3 = _interopRequireDefault(__webpack_require__(127));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getDayOfYear
	 * @category Day Helpers
	 * @summary Get the day of the year of the given date.
	 *
	 * @description
	 * Get the day of the year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the day of year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which day of the year is 2 July 2014?
	 * const result = getDayOfYear(new Date(2014, 6, 2))
	 * //=> 183
	 */
	function getDayOfYear(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index3.default)(date, (0, _index2.default)(date));
	  var dayOfYear = diff + 1;
	  return dayOfYear;
	}
	module.exports = exports.default;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDaysInYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(652));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getDaysInYear
	 * @category Year Helpers
	 * @summary Get the number of days in a year of the given date.
	 *
	 * @description
	 * Get the number of days in a year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of days in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many days are in 2012?
	 * const result = getDaysInYear(new Date(2012, 0, 1))
	 * //=> 366
	 */
	function getDaysInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  if (String(new Date(date)) === 'Invalid Date') {
	    return NaN;
	  }
	  return (0, _index2.default)(date) ? 366 : 365;
	}
	module.exports = exports.default;

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDecade;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getDecade
	 * @category Decade Helpers
	 * @summary Get the decade of the given date.
	 *
	 * @description
	 * Get the decade of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year of decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which decade belongs 27 November 1942?
	 * const result = getDecade(new Date(1942, 10, 27))
	 * //=> 1940
	 */
	function getDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  return decade;
	}
	module.exports = exports.default;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDefaultOptions;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(216));
	/**
	 * @name getDefaultOptions
	 * @category Common Helpers
	 * @summary Get default options.
	 * @pure false
	 *
	 * @description
	 * Returns an object that contains defaults for
	 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
	 * arguments for all functions.
	 *
	 * You can change these with [setDefaultOptions]{@link https://date-fns.org/docs/setDefaultOptions}.
	 *
	 * @returns {Object} default options
	 *
	 * @example
	 * const result = getDefaultOptions()
	 * //=> {}
	 *
	 * @example
	 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
	 * const result = getDefaultOptions()
	 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
	 */
	function getDefaultOptions() {
	  return (0, _index2.default)({}, (0, _index.getDefaultOptions)());
	}
	module.exports = exports.default;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getHours;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getHours
	 * @category Hour Helpers
	 * @summary Get the hours of the given date.
	 *
	 * @description
	 * Get the hours of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the hours of 29 February 2012 11:45:00:
	 * const result = getHours(new Date(2012, 1, 29, 11, 45))
	 * //=> 11
	 */
	function getHours(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var hours = date.getHours();
	  return hours;
	}
	module.exports = exports.default;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getISOWeeksInYear;
	var _index = _interopRequireDefault(__webpack_require__(223));
	var _index2 = _interopRequireDefault(__webpack_require__(272));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_WEEK = 604800000;
	
	/**
	 * @name getISOWeeksInYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * @description
	 * Get the number of weeks in an ISO week-numbering year of the given date.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the number of ISO weeks in a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // How many weeks are in ISO week-numbering year 2015?
	 * const result = getISOWeeksInYear(new Date(2015, 1, 11))
	 * //=> 53
	 */
	function getISOWeeksInYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var thisYear = (0, _index.default)(dirtyDate);
	  var nextYear = (0, _index.default)((0, _index2.default)(thisYear, 60));
	  var diff = nextYear.valueOf() - thisYear.valueOf();
	  // Round the number of weeks to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK);
	}
	module.exports = exports.default;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getMilliseconds
	 * @category Millisecond Helpers
	 * @summary Get the milliseconds of the given date.
	 *
	 * @description
	 * Get the milliseconds of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the milliseconds of 29 February 2012 11:45:05.123:
	 * const result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 123
	 */
	function getMilliseconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var milliseconds = date.getMilliseconds();
	  return milliseconds;
	}
	module.exports = exports.default;

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMinutes;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getMinutes
	 * @category Minute Helpers
	 * @summary Get the minutes of the given date.
	 *
	 * @description
	 * Get the minutes of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the minutes of 29 February 2012 11:45:05:
	 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 45
	 */
	function getMinutes(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var minutes = date.getMinutes();
	  return minutes;
	}
	module.exports = exports.default;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getMonth
	 * @category Month Helpers
	 * @summary Get the month of the given date.
	 *
	 * @description
	 * Get the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which month is 29 February 2012?
	 * const result = getMonth(new Date(2012, 1, 29))
	 * //=> 1
	 */
	function getMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var month = date.getMonth();
	  return month;
	}
	module.exports = exports.default;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getOverlappingDaysInIntervals;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
	
	/**
	 * @name getOverlappingDaysInIntervals
	 * @category Interval Helpers
	 * @summary Get the number of days that overlap in two time intervals
	 *
	 * @description
	 * Get the number of days that overlap in two time intervals
	 *
	 * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
	 * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
	 * @returns {Number} the number of days that overlap in two time intervals
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For overlapping time intervals adds 1 for each started overlapping day:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
	 * )
	 * //=> 3
	 *
	 * @example
	 * // For non-overlapping time intervals returns 0:
	 * getOverlappingDaysInIntervals(
	 *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
	 *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
	 * )
	 * //=> 0
	 */
	
	function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
	  (0, _index2.default)(2, arguments);
	  var intervalLeft = dirtyIntervalLeft || {};
	  var intervalRight = dirtyIntervalRight || {};
	  var leftStartTime = (0, _index.default)(intervalLeft.start).getTime();
	  var leftEndTime = (0, _index.default)(intervalLeft.end).getTime();
	  var rightStartTime = (0, _index.default)(intervalRight.start).getTime();
	  var rightEndTime = (0, _index.default)(intervalRight.end).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
	  if (!isOverlapping) {
	    return 0;
	  }
	  var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
	  var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
	  var differenceInMs = overlapEndDate - overlapStartDate;
	  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
	}
	module.exports = exports.default;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getSeconds;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getSeconds
	 * @category Second Helpers
	 * @summary Get the seconds of the given date.
	 *
	 * @description
	 * Get the seconds of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the seconds of 29 February 2012 11:45:05.123:
	 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
	 * //=> 5
	 */
	function getSeconds(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds();
	  return seconds;
	}
	module.exports = exports.default;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUnixTime;
	var _index = _interopRequireDefault(__webpack_require__(647));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getUnixTime
	 * @category Timestamp Helpers
	 * @summary Get the seconds timestamp of the given date.
	 *
	 * @description
	 * Get the seconds timestamp of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the timestamp
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Get the timestamp of 29 February 2012 11:45:05 CET:
	 * const result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
	 * //=> 1330512305
	 */
	function getUnixTime(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return Math.floor((0, _index.default)(dirtyDate) / 1000);
	}
	module.exports = exports.default;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeekOfMonth;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(642));
	var _index3 = _interopRequireDefault(__webpack_require__(276));
	var _index4 = _interopRequireDefault(__webpack_require__(279));
	var _index5 = _interopRequireDefault(__webpack_require__(5));
	var _index6 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name getWeekOfMonth
	 * @category Week Helpers
	 * @summary Get the week of the month of the given date.
	 *
	 * @description
	 * Get the week of the month of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the week of month
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6 inclusively
	 *
	 * @example
	 * // Which week of the month is 9 November 2017?
	 * const result = getWeekOfMonth(new Date(2017, 10, 9))
	 * //=> 2
	 */
	function getWeekOfMonth(date, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index5.default)(1, arguments);
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  var weekStartsOn = (0, _index6.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var currentDayOfMonth = (0, _index2.default)(date);
	  if (isNaN(currentDayOfMonth)) return NaN;
	  var startWeekDay = (0, _index3.default)((0, _index4.default)(date));
	  var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
	  if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
	  var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
	  return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWeeksInMonth;
	var _index = _interopRequireDefault(__webpack_require__(388));
	var _index2 = _interopRequireDefault(__webpack_require__(661));
	var _index3 = _interopRequireDefault(__webpack_require__(279));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getWeeksInMonth
	 * @category Week Helpers
	 * @summary Get the number of calendar weeks a month spans.
	 *
	 * @description
	 * Get the number of calendar weeks the month in the given date spans.
	 *
	 * @param {Date|Number} date - the given date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Number} the number of calendar weeks
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // How many calendar weeks does February 2015 span?
	 * const result = getWeeksInMonth(new Date(2015, 1, 8))
	 * //=> 4
	 *
	 * @example
	 * // If the week starts on Monday,
	 * // how many calendar weeks does July 2017 span?
	 * const result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
	 * //=> 6
	 */
	function getWeeksInMonth(date, options) {
	  (0, _index4.default)(1, arguments);
	  return (0, _index.default)((0, _index2.default)(date), (0, _index3.default)(date), options) + 1;
	}
	module.exports = exports.default;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name getYear
	 * @category Year Helpers
	 * @summary Get the year of the given date.
	 *
	 * @description
	 * Get the year of the given date.
	 *
	 * @param {Date|Number} date - the given date
	 * @returns {Number} the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Which year is 2 July 2014?
	 * const result = getYear(new Date(2014, 6, 2))
	 * //=> 2014
	 */
	function getYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getFullYear();
	}
	module.exports = exports.default;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name hoursToMilliseconds
	 * @category  Conversion Helpers
	 * @summary Convert hours to milliseconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of milliseconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted to milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to milliseconds:
	 * const result = hoursToMilliseconds(2)
	 * //=> 7200000
	 */
	function hoursToMilliseconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.millisecondsInHour);
	}
	module.exports = exports.default;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToMinutes;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name hoursToMinutes
	 * @category Conversion Helpers
	 * @summary Convert hours to minutes.
	 *
	 * @description
	 * Convert a number of hours to a full number of minutes.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to minutes:
	 * const result = hoursToMinutes(2)
	 * //=> 120
	 */
	function hoursToMinutes(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.minutesInHour);
	}
	module.exports = exports.default;

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hoursToSeconds;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name hoursToSeconds
	 * @category Conversion Helpers
	 * @summary Convert hours to seconds.
	 *
	 * @description
	 * Convert a number of hours to a full number of seconds.
	 *
	 * @param {number} hours - number of hours to be converted
	 *
	 * @returns {number} the number of hours converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 hours to seconds:
	 * const result = hoursToSeconds(2)
	 * //=> 7200
	 */
	function hoursToSeconds(hours) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(hours * _index2.secondsInHour);
	}
	module.exports = exports.default;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intervalToDuration;
	var _index = _interopRequireDefault(__webpack_require__(150));
	var _index2 = _interopRequireDefault(__webpack_require__(629));
	var _index3 = _interopRequireDefault(__webpack_require__(390));
	var _index4 = _interopRequireDefault(__webpack_require__(391));
	var _index5 = _interopRequireDefault(__webpack_require__(392));
	var _index6 = _interopRequireDefault(__webpack_require__(274));
	var _index7 = _interopRequireDefault(__webpack_require__(275));
	var _index8 = _interopRequireDefault(__webpack_require__(636));
	var _index9 = _interopRequireDefault(__webpack_require__(6));
	var _index10 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name intervalToDuration
	 * @category Common Helpers
	 * @summary Convert interval to duration
	 *
	 * @description
	 * Convert a interval object to a duration object.
	 *
	 * @param {Interval} interval - the interval to convert to duration
	 *
	 * @returns {Duration} The duration Object
	 * @throws {TypeError} Requires 2 arguments
	 * @throws {RangeError} `start` must not be Invalid Date
	 * @throws {RangeError} `end` must not be Invalid Date
	 *
	 * @example
	 * // Get the duration between January 15, 1929 and April 4, 1968.
	 * intervalToDuration({
	 *   start: new Date(1929, 0, 15, 12, 0, 0),
	 *   end: new Date(1968, 3, 4, 19, 5, 0)
	 * })
	 * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
	 */
	function intervalToDuration(interval) {
	  (0, _index10.default)(1, arguments);
	  var start = (0, _index9.default)(interval.start);
	  var end = (0, _index9.default)(interval.end);
	  if (isNaN(start.getTime())) throw new RangeError('Start Date is invalid');
	  if (isNaN(end.getTime())) throw new RangeError('End Date is invalid');
	  var duration = {};
	  duration.years = Math.abs((0, _index8.default)(end, start));
	  var sign = (0, _index.default)(end, start);
	  var remainingMonths = (0, _index2.default)(start, {
	    years: sign * duration.years
	  });
	  duration.months = Math.abs((0, _index6.default)(end, remainingMonths));
	  var remainingDays = (0, _index2.default)(remainingMonths, {
	    months: sign * duration.months
	  });
	  duration.days = Math.abs((0, _index3.default)(end, remainingDays));
	  var remainingHours = (0, _index2.default)(remainingDays, {
	    days: sign * duration.days
	  });
	  duration.hours = Math.abs((0, _index4.default)(end, remainingHours));
	  var remainingMinutes = (0, _index2.default)(remainingHours, {
	    hours: sign * duration.hours
	  });
	  duration.minutes = Math.abs((0, _index5.default)(end, remainingMinutes));
	  var remainingSeconds = (0, _index2.default)(remainingMinutes, {
	    minutes: sign * duration.minutes
	  });
	  duration.seconds = Math.abs((0, _index7.default)(end, remainingSeconds));
	  return duration;
	}
	module.exports = exports.default;

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intlFormat;
	var _index = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name intlFormat
	 * @category Common Helpers
	 * @summary  Format the date with Intl.DateTimeFormat (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat).
	 *
	 * @description
	 * Return the formatted date string in the given format.
	 * The method uses [`Intl.DateTimeFormat`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) inside.
	 * formatOptions are the same as [`Intl.DateTimeFormat` options](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat#using_options)
	 *
	 * > ⚠️ Please note that before Node version 13.0.0, only the locale data for en-US is available by default.
	 *
	 * @param {Date|Number} argument - the original date.
	 * @param {Object} [formatOptions] - an object with options.
	 * @param {'lookup'|'best fit'} [formatOptions.localeMatcher='best fit'] - locale selection algorithm.
	 * @param {'narrow'|'short'|'long'} [formatOptions.weekday] - representation the days of the week.
	 * @param {'narrow'|'short'|'long'} [formatOptions.era] - representation of eras.
	 * @param {'numeric'|'2-digit'} [formatOptions.year] - representation of years.
	 * @param {'numeric'|'2-digit'|'narrow'|'short'|'long'} [formatOptions.month='numeric'] - representation of month.
	 * @param {'numeric'|'2-digit'} [formatOptions.day='numeric'] - representation of day.
	 * @param {'numeric'|'2-digit'} [formatOptions.hour='numeric'] - representation of hours.
	 * @param {'numeric'|'2-digit'} [formatOptions.minute] - representation of minutes.
	 * @param {'numeric'|'2-digit'} [formatOptions.second] - representation of seconds.
	 * @param {'short'|'long'} [formatOptions.timeZoneName] - representation of names of time zones.
	 * @param {'basic'|'best fit'} [formatOptions.formatMatcher='best fit'] - format selection algorithm.
	 * @param {Boolean} [formatOptions.hour12] - determines whether to use 12-hour time format.
	 * @param {String} [formatOptions.timeZone] - the time zone to use.
	 * @param {Object} [localeOptions] - an object with locale.
	 * @param {String|String[]} [localeOptions.locale] - the locale code
	 * @returns {String} the formatted date string.
	 * @throws {TypeError} 1 argument required.
	 * @throws {RangeError} `date` must not be Invalid Date
	 *
	 * @example
	 * // Represent 10 October 2019 in German.
	 * // Convert the date with format's options and locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      weekday: 'long',
	 *      year: 'numeric',
	 *      month: 'long',
	 *      day: 'numeric',
	 *    }, {
	 *      locale: 'de-DE',
	 *  })
	 * //=> Freitag, 4. Oktober 2019
	 *
	 * @example
	 * // Represent 10 October 2019.
	 * // Convert the date with format's options.
	 * const result = intlFormat.default(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      year: 'numeric',
	 *      month: 'numeric',
	 *      day: 'numeric',
	 *      hour: 'numeric',
	 *  })
	 * //=> 10/4/2019, 12 PM
	 *
	 * @example
	 * // Represent 10 October 2019 in Korean.
	 * // Convert the date with locale's options.
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456), {
	 *      locale: 'ko-KR',
	 *  })
	 * //=> 2019. 10. 4.
	 *
	 * @example
	 * // Represent 10 October 2019 in middle-endian format:
	 * const result = intlFormat(new Date(2019, 9, 4, 12, 30, 13, 456))
	 * //=> 10/4/2019
	 */
	function intlFormat(date, formatOrLocale, localeOptions) {
	  var _localeOptions;
	  (0, _index.default)(1, arguments);
	  var formatOptions;
	  if (isFormatOptions(formatOrLocale)) {
	    formatOptions = formatOrLocale;
	  } else {
	    localeOptions = formatOrLocale;
	  }
	  return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
	}
	function isFormatOptions(opts) {
	  return opts !== undefined && !('locale' in opts);
	}
	module.exports = exports.default;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = intlFormatDistance;
	var _index = __webpack_require__(42);
	var _index2 = _interopRequireDefault(__webpack_require__(127));
	var _index3 = _interopRequireDefault(__webpack_require__(387));
	var _index4 = _interopRequireDefault(__webpack_require__(635));
	var _index5 = _interopRequireDefault(__webpack_require__(388));
	var _index6 = _interopRequireDefault(__webpack_require__(389));
	var _index7 = _interopRequireDefault(__webpack_require__(391));
	var _index8 = _interopRequireDefault(__webpack_require__(392));
	var _index9 = _interopRequireDefault(__webpack_require__(275));
	var _index10 = _interopRequireDefault(__webpack_require__(6));
	var _index11 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name intlFormatDistance
	 * @category Common Helpers
	 * @summary Formats distance between two dates in a human-readable format
	 * @description
	 * The function calculates the difference between two dates and formats it as a human-readable string.
	 *
	 * The function will pick the most appropriate unit depending on the distance between dates. For example, if the distance is a few hours, it might return `x hours`. If the distance is a few months, it might return `x months`.
	 *
	 * You can also specify a unit to force using it regardless of the distance to get a result like `123456 hours`.
	 *
	 * See the table below for the unit picking logic:
	 *
	 * | Distance between dates | Result (past)  | Result (future) |
	 * | ---------------------- | -------------- | --------------- |
	 * | 0 seconds              | now            | now             |
	 * | 1-59 seconds           | X seconds ago  | in X seconds    |
	 * | 1-59 minutes           | X minutes ago  | in X minutes    |
	 * | 1-23 hours             | X hours ago    | in X hours      |
	 * | 1 day                  | yesterday      | tomorrow        |
	 * | 2-6 days               | X days ago     | in X days       |
	 * | 7 days                 | last week      | next week       |
	 * | 8 days-1 month         | X weeks ago    | in X weeks      |
	 * | 1 month                | last month     | next month      |
	 * | 2-3 months             | X months ago   | in X months     |
	 * | 1 quarter              | last quarter   | next quarter    |
	 * | 2-3 quarters           | X quarters ago | in X quarters   |
	 * | 1 year                 | last year      | next year       |
	 * | 2+ years               | X years ago    | in X years      |
	 *
	 * @param {Date|Number} date - the date
	 * @param {Date|Number} baseDate - the date to compare with.
	 * @param {Object} [options] - an object with options.
	 * @param {String} [options.unit] - formats the distance with the given unit ('year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second').
	 * @param {String|String[]} [options.locale] - the locale to use.
	 * @param {String} [options.localeMatcher='best fit'] - the locale matching algorithm to use. Other value: 'lookup'.
	 * See MDN for details [Locale identification and negotiation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locale_identification_and_negotiation)
	 * @param {String} [options.numeric='auto'] - the output message format. The values are 'auto' (e.g. `yesterday`), 'always'(e.g. `1 day ago`).
	 * @param {String} [options.style='long'] - the length of the result. The values are: 'long' (e.g. `1 month`), 'short' (e.g. 'in 1 mo.'), 'narrow' (e.g. 'in 1 mo.').
	 * The narrow one could be similar to the short one for some locales.
	 * @returns {String} the distance in words according to language-sensitive relative time formatting.
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `baseDate` must not be Invalid Date
	 * @throws {RangeError} `options.unit` must not be invalid Unit
	 * @throws {RangeError} `options.locale` must not be invalid locale
	 * @throws {RangeError} `options.localeMatcher` must not be invalid localeMatcher
	 * @throws {RangeError} `options.numeric` must not be invalid numeric
	 * @throws {RangeError} `options.style` must not be invalid style
	 *
	 * @example
	 * // What is the distance between the dates when the fist date is after the second?
	 * intlFormatDistance(
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   new Date(1986, 3, 4, 10, 30, 0)
	 * )
	 * //=> 'in 1 hour'
	 *
	 * // What is the distance between the dates when the fist date is before the second?
	 * intlFormatDistance(
	 *   new Date(1986, 3, 4, 10, 30, 0),
	 *   new Date(1986, 3, 4, 11, 30, 0)
	 * )
	 * //=> '1 hour ago'
	 *
	 * @example
	 * // Use the unit option to force the function to output the result in quarters. Without setting it, the example would return "next year"
	 * intlFormatDistance(
	 *   new Date(1987, 6, 4, 10, 30, 0),
	 *   new Date(1986, 3, 4, 10, 30, 0),
	 *   { unit: 'quarter' }
	 * )
	 * //=> 'in 5 quarters'
	 *
	 * @example
	 * // Use the locale option to get the result in Spanish. Without setting it, the example would return "in 1 hour".
	 * intlFormatDistance(
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   new Date(1986, 3, 4, 10, 30, 0),
	 *   { locale: 'es' }
	 * )
	 * //=> 'dentro de 1 hora'
	 *
	 * @example
	 * // Use the numeric option to force the function to use numeric values. Without setting it, the example would return "tomorrow".
	 * intlFormatDistance(
	 *   new Date(1986, 3, 5, 11, 30, 0),
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   { numeric: 'always' }
	 * )
	 * //=> 'in 1 day'
	 *
	 * @example
	 * // Use the style option to force the function to use short values. Without setting it, the example would return "in 2 years".
	 * intlFormatDistance(
	 *   new Date(1988, 3, 4, 11, 30, 0),
	 *   new Date(1986, 3, 4, 11, 30, 0),
	 *   { style: 'short' }
	 * )
	 * //=> 'in 2 yr'
	 */
	function intlFormatDistance(date, baseDate, options) {
	  (0, _index11.default)(2, arguments);
	  var value = 0;
	  var unit;
	  var dateLeft = (0, _index10.default)(date);
	  var dateRight = (0, _index10.default)(baseDate);
	  if (!(options !== null && options !== void 0 && options.unit)) {
	    // Get the unit based on diffInSeconds calculations if no unit is specified
	    var diffInSeconds = (0, _index9.default)(dateLeft, dateRight); // The smallest unit
	
	    if (Math.abs(diffInSeconds) < _index.secondsInMinute) {
	      value = (0, _index9.default)(dateLeft, dateRight);
	      unit = 'second';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInHour) {
	      value = (0, _index8.default)(dateLeft, dateRight);
	      unit = 'minute';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInDay && Math.abs((0, _index2.default)(dateLeft, dateRight)) < 1) {
	      value = (0, _index7.default)(dateLeft, dateRight);
	      unit = 'hour';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInWeek && (value = (0, _index2.default)(dateLeft, dateRight)) && Math.abs(value) < 7) {
	      unit = 'day';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInMonth) {
	      value = (0, _index5.default)(dateLeft, dateRight);
	      unit = 'week';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInQuarter) {
	      value = (0, _index3.default)(dateLeft, dateRight);
	      unit = 'month';
	    } else if (Math.abs(diffInSeconds) < _index.secondsInYear) {
	      if ((0, _index4.default)(dateLeft, dateRight) < 4) {
	        // To filter out cases that are less than a year but match 4 quarters
	        value = (0, _index4.default)(dateLeft, dateRight);
	        unit = 'quarter';
	      } else {
	        value = (0, _index6.default)(dateLeft, dateRight);
	        unit = 'year';
	      }
	    } else {
	      value = (0, _index6.default)(dateLeft, dateRight);
	      unit = 'year';
	    }
	  } else {
	    // Get the value if unit is specified
	    unit = options === null || options === void 0 ? void 0 : options.unit;
	    if (unit === 'second') {
	      value = (0, _index9.default)(dateLeft, dateRight);
	    } else if (unit === 'minute') {
	      value = (0, _index8.default)(dateLeft, dateRight);
	    } else if (unit === 'hour') {
	      value = (0, _index7.default)(dateLeft, dateRight);
	    } else if (unit === 'day') {
	      value = (0, _index2.default)(dateLeft, dateRight);
	    } else if (unit === 'week') {
	      value = (0, _index5.default)(dateLeft, dateRight);
	    } else if (unit === 'month') {
	      value = (0, _index3.default)(dateLeft, dateRight);
	    } else if (unit === 'quarter') {
	      value = (0, _index4.default)(dateLeft, dateRight);
	    } else if (unit === 'year') {
	      value = (0, _index6.default)(dateLeft, dateRight);
	    }
	  }
	  var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
	    localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
	    numeric: (options === null || options === void 0 ? void 0 : options.numeric) || 'auto',
	    style: options === null || options === void 0 ? void 0 : options.style
	  });
	  return rtf.format(value, unit);
	}
	module.exports = exports.default;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isAfter;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isAfter
	 * @category Common Helpers
	 * @summary Is the first date after the second one?
	 *
	 * @description
	 * Is the first date after the second one?
	 *
	 * @param {Date|Number} date - the date that should be after the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is after the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 after 11 February 1987?
	 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> true
	 */
	function isAfter(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() > dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isBefore;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isBefore
	 * @category Common Helpers
	 * @summary Is the first date before the second one?
	 *
	 * @description
	 * Is the first date before the second one?
	 *
	 * @param {Date|Number} date - the date that should be before the other one to return true
	 * @param {Date|Number} dateToCompare - the date to compare with
	 * @returns {Boolean} the first date is before the second date
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Is 10 July 1989 before 11 February 1987?
	 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
	 * //=> false
	 */
	function isBefore(dirtyDate, dirtyDateToCompare) {
	  (0, _index2.default)(2, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var dateToCompare = (0, _index.default)(dirtyDateToCompare);
	  return date.getTime() < dateToCompare.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isEqual;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isEqual
	 * @category Common Helpers
	 * @summary Are the given dates equal?
	 *
	 * @description
	 * Are the given dates equal?
	 *
	 * @param {Date|Number} dateLeft - the first date to compare
	 * @param {Date|Number} dateRight - the second date to compare
	 * @returns {Boolean} the dates are equal
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
	 * const result = isEqual(
	 *   new Date(2014, 6, 2, 6, 30, 45, 0),
	 *   new Date(2014, 6, 2, 6, 30, 45, 500)
	 * )
	 * //=> false
	 */
	function isEqual(dirtyLeftDate, dirtyRightDate) {
	  (0, _index2.default)(2, arguments);
	  var dateLeft = (0, _index.default)(dirtyLeftDate);
	  var dateRight = (0, _index.default)(dirtyRightDate);
	  return dateLeft.getTime() === dateRight.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1637 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isExists;
	/**
	 * @name isExists
	 * @category Common Helpers
	 * @summary Is the given date exists?
	 *
	 * @description
	 * Checks if the given arguments convert to an existing date.
	 *
	 * @param {Number} year of the date to check
	 * @param {Number} month of the date to check
	 * @param {Number} day of the date to check
	 * @returns {Boolean} the date exists
	 * @throws {TypeError} 3 arguments required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isExists(2018, 0, 31)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isExists(2018, 1, 31)
	 * //=> false
	 */
	function isExists(year, month, day) {
	  if (arguments.length < 3) {
	    throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
	  }
	  var date = new Date(year, month, day);
	  return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
	}
	module.exports = exports.default;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFirstDayOfMonth;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isFirstDayOfMonth
	 * @category Month Helpers
	 * @summary Is the given date the first day of a month?
	 *
	 * @description
	 * Is the given date the first day of a month?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is the first day of a month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 1 September 2014 the first day of a month?
	 * const result = isFirstDayOfMonth(new Date(2014, 8, 1))
	 * //=> true
	 */
	function isFirstDayOfMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDate() === 1;
	}
	module.exports = exports.default;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFriday;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isFriday
	 * @category Weekday Helpers
	 * @summary Is the given date Friday?
	 *
	 * @description
	 * Is the given date Friday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 26 September 2014 Friday?
	 * const result = isFriday(new Date(2014, 8, 26))
	 * //=> true
	 */
	function isFriday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 5;
	}
	module.exports = exports.default;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isFuture;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isFuture
	 * @category Common Helpers
	 * @summary Is the given date in the future?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the future?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the future
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 31 December 2014 in the future?
	 * const result = isFuture(new Date(2014, 11, 31))
	 * //=> true
	 */
	function isFuture(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() > Date.now();
	}
	module.exports = exports.default;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMatch;
	var _index = _interopRequireDefault(__webpack_require__(666));
	var _index2 = _interopRequireDefault(__webpack_require__(128));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isMatch
	 * @category Common Helpers
	 * @summary validates the date string against given formats
	 *
	 * @description
	 * Return the true if given date is string correct against the given format else
	 * will return false.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters in the format string wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the format string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 5 below the table).
	 *
	 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
	 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
	 *
	 * ```javascript
	 * isMatch('23 AM', 'HH a')
	 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
	 * ```
	 *
	 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
	 *
	 * Accepted format string patterns:
	 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
	 * |---------------------------------|-----|---------|-----------------------------------|-------|
	 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
	 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 |     | GGGGG   | A, B                              |       |
	 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
	 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
	 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
	 * |                                 |     | yyyyy   | ...                               | 2,4   |
	 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
	 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
	 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
	 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
	 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
	 * |                                 |     | YYYYY   | ...                               | 2,4   |
	 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
	 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
	 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
	 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
	 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
	 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
	 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
	 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
	 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
	 * |                                 |     | uuuuu   | ...                               | 2,4   |
	 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
	 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
	 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
	 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
	 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
	 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
	 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
	 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
	 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
	 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
	 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
	 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
	 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
	 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
	 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
	 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
	 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
	 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
	 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
	 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 |     | DDDD    | ...                               | 2     |
	 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
	 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
	 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
	 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
	 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
	 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
	 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
	 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
	 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
	 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
	 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
	 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
	 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 |     | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
	 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
	 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
	 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
	 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
	 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
	 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
	 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
	 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
	 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
	 * |                                 |     | tt      | ...                               | 2     |
	 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
	 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
	 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
	 * |                                 |     | SSSS    | ...                               | 2     |
	 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
	 * |                                 |     | TT      | ...                               | 2     |
	 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
	 * |                                 |     | XX      | -0800, +0530, Z                   |       |
	 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
	 * |                                 |     | xx      | -0800, +0530, +0000               |       |
	 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
	 * |                                 |     | PP      | May 29, 1453                      |       |
	 * |                                 |     | PPP     | May 29th, 1453                    |       |
	 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
	 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
	 * |                                 |     | pp      | 12:00:00 AM                       |       |
	 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
	 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
	 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
	 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular.
	 *    In `format` function, they will produce different result:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 *    `isMatch` will try to match both formatting and stand-alone units interchangably.
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table:
	 *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
	 *      as wide as the sequence
	 *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
	 *      These variations are marked with "2" in the last column of the table.
	 *
	 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 4. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
	 *
	 *    `isMatch('50', 'yy') //=> true`
	 *
	 *    `isMatch('75', 'yy') //=> true`
	 *
	 *    while `uu` will use the year as is:
	 *
	 *    `isMatch('50', 'uu') //=> true`
	 *
	 *    `isMatch('75', 'uu') //=> true`
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
	 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
	 *
	 * 5. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
	 *    on the given locale.
	 *
	 *    using `en-US` locale: `P` => `MM/dd/yyyy`
	 *    using `en-US` locale: `p` => `hh:mm a`
	 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
	 *    using `pt-BR` locale: `p` => `HH:mm`
	 *
	 * Values will be checked in the descending order of its unit's priority.
	 * Units of an equal priority overwrite each other in the order of appearance.
	 *
	 * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
	 * the values will be taken from today's using `new Date()` date which works as a context of parsing.
	 *
	 * The result may vary by locale.
	 *
	 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
	 *
	 *
	 *
	 * @param {String} dateString - the date string to verify
	 * @param {String} formatString - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {Boolean}
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} `options.locale` must contain `match` property
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Match 11 February 2014 from middle-endian format:
	 * const result = isMatch('02/11/2014', 'MM/dd/yyyy')
	 * //=> true
	 *
	 * @example
	 * // Match 28th of February in Esperanto locale in the context of 2010 year:
	 * import eo from 'date-fns/locale/eo'
	 * const result = isMatch('28-a de februaro', "do 'de' MMMM", {
	 *   locale: eo
	 * })
	 * //=> true
	 */
	function isMatch(dateString, formatString, options) {
	  (0, _index3.default)(2, arguments);
	  return (0, _index2.default)((0, _index.default)(dateString, formatString, new Date(), options));
	}
	module.exports = exports.default;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMonday;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isMonday
	 * @category Weekday Helpers
	 * @summary Is the given date Monday?
	 *
	 * @description
	 * Is the given date Monday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 22 September 2014 Monday?
	 * const result = isMonday(new Date(2014, 8, 22))
	 * //=> true
	 */
	function isMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date).getDay() === 1;
	}
	module.exports = exports.default;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPast;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isPast
	 * @category Common Helpers
	 * @summary Is the given date in the past?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the past?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in the past
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 2 July 2014 in the past?
	 * const result = isPast(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isPast(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getTime() < Date.now();
	}
	module.exports = exports.default;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isSameISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(223));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isSameISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Are the given dates in the same ISO week-numbering year?
	 *
	 * @description
	 * Are the given dates in the same ISO week-numbering year?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} dateLeft - the first date to check
	 * @param {Date|Number} dateRight - the second date to check
	 * @returns {Boolean} the dates are in the same ISO week-numbering year
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
	 * const result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
	 * //=> true
	 */
	function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
	  (0, _index2.default)(2, arguments);
	  var dateLeftStartOfYear = (0, _index.default)(dirtyDateLeft);
	  var dateRightStartOfYear = (0, _index.default)(dirtyDateRight);
	  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
	}
	module.exports = exports.default;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisHour;
	var _index = _interopRequireDefault(__webpack_require__(653));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisHour
	 * @category Hour Helpers
	 * @summary Is the given date in the same hour as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same hour as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this hour
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:00:00 in this hour?
	 * const result = isThisHour(new Date(2014, 8, 25, 18))
	 * //=> true
	 */
	function isThisHour(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports.default;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(654));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisISOWeek
	 * @category ISO Week Helpers
	 * @summary Is the given date in the same ISO week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same ISO week as the current date?
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
	 * const result = isThisISOWeek(new Date(2014, 8, 22))
	 * //=> true
	 */
	
	function isThisISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	module.exports = exports.default;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMinute;
	var _index = _interopRequireDefault(__webpack_require__(655));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisMinute
	 * @category Minute Helpers
	 * @summary Is the given date in the same minute as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same minute as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this minute
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:00 in this minute?
	 * const result = isThisMinute(new Date(2014, 8, 25, 18, 30))
	 * //=> true
	 */
	
	function isThisMinute(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports.default;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisMonth;
	var _index = _interopRequireDefault(__webpack_require__(656));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisMonth
	 * @category Month Helpers
	 * @summary Is the given date in the same month as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same month as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this month
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 15 September 2014 in this month?
	 * const result = isThisMonth(new Date(2014, 8, 15))
	 * //=> true
	 */
	
	function isThisMonth(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports.default;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisQuarter;
	var _index = _interopRequireDefault(__webpack_require__(657));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisQuarter
	 * @category Quarter Helpers
	 * @summary Is the given date in the same quarter as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same quarter as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this quarter
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
	 * const result = isThisQuarter(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports.default;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisSecond;
	var _index = _interopRequireDefault(__webpack_require__(658));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisSecond
	 * @category Second Helpers
	 * @summary Is the given date in the same second as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same second as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this second
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If now is 25 September 2014 18:30:15.500,
	 * // is 25 September 2014 18:30:15.000 in this second?
	 * const result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
	 * //=> true
	 */
	function isThisSecond(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(Date.now(), dirtyDate);
	}
	module.exports = exports.default;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisWeek;
	var _index = _interopRequireDefault(__webpack_require__(397));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisWeek
	 * @category Week Helpers
	 * @summary Is the given date in the same week as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same week as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Object} [options] - the object with options
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Boolean} the date is in this week
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // If today is 25 September 2014, is 21 September 2014 in this week?
	 * const result = isThisWeek(new Date(2014, 8, 21))
	 * //=> true
	 *
	 * @example
	 * // If today is 25 September 2014 and week starts with Monday
	 * // is 21 September 2014 in this week?
	 * const result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
	 * //=> false
	 */
	
	function isThisWeek(dirtyDate, options) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now(), options);
	}
	module.exports = exports.default;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThisYear;
	var _index = _interopRequireDefault(__webpack_require__(659));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThisYear
	 * @category Year Helpers
	 * @summary Is the given date in the same year as the current date?
	 * @pure false
	 *
	 * @description
	 * Is the given date in the same year as the current date?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is in this year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 25 September 2014, is 2 July 2014 in this year?
	 * const result = isThisYear(new Date(2014, 6, 2))
	 * //=> true
	 */
	function isThisYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	module.exports = exports.default;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isThursday;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isThursday
	 * @category Weekday Helpers
	 * @summary Is the given date Thursday?
	 *
	 * @description
	 * Is the given date Thursday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 25 September 2014 Thursday?
	 * const result = isThursday(new Date(2014, 8, 25))
	 * //=> true
	 */
	function isThursday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 4;
	}
	module.exports = exports.default;

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isToday;
	var _index = _interopRequireDefault(__webpack_require__(222));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isToday
	 * @category Day Helpers
	 * @summary Is the given date today?
	 * @pure false
	 *
	 * @description
	 * Is the given date today?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is today
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 6 October 14:00:00 today?
	 * const result = isToday(new Date(2014, 9, 6, 14, 0))
	 * //=> true
	 */
	function isToday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, Date.now());
	}
	module.exports = exports.default;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTomorrow;
	var _index = _interopRequireDefault(__webpack_require__(110));
	var _index2 = _interopRequireDefault(__webpack_require__(222));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isTomorrow
	 * @category Day Helpers
	 * @summary Is the given date tomorrow?
	 * @pure false
	 *
	 * @description
	 * Is the given date tomorrow?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is tomorrow
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
	 * const result = isTomorrow(new Date(2014, 9, 7, 14, 0))
	 * //=> true
	 */
	function isTomorrow(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index2.default)(dirtyDate, (0, _index.default)(Date.now(), 1));
	}
	module.exports = exports.default;

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTuesday;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isTuesday
	 * @category Weekday Helpers
	 * @summary Is the given date Tuesday?
	 *
	 * @description
	 * Is the given date Tuesday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 23 September 2014 Tuesday?
	 * const result = isTuesday(new Date(2014, 8, 23))
	 * //=> true
	 */
	function isTuesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 2;
	}
	module.exports = exports.default;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWednesday;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isWednesday
	 * @category Weekday Helpers
	 * @summary Is the given date Wednesday?
	 *
	 * @description
	 * Is the given date Wednesday?
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Is 24 September 2014 Wednesday?
	 * const result = isWednesday(new Date(2014, 8, 24))
	 * //=> true
	 */
	function isWednesday(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate).getDay() === 3;
	}
	module.exports = exports.default;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isWithinInterval;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isWithinInterval
	 * @category Interval Helpers
	 * @summary Is the given date within the interval?
	 *
	 * @description
	 * Is the given date within the interval? (Including start and end.)
	 *
	 * @param {Date|Number} date - the date to check
	 * @param {Interval} interval - the interval to check
	 * @returns {Boolean} the date is within the interval
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} The start of an interval cannot be after its end
	 * @throws {RangeError} Date in interval cannot be `Invalid Date`
	 *
	 * @example
	 * // For the date within the interval:
	 * isWithinInterval(new Date(2014, 0, 3), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> true
	 *
	 * @example
	 * // For the date outside of the interval:
	 * isWithinInterval(new Date(2014, 0, 10), {
	 *   start: new Date(2014, 0, 1),
	 *   end: new Date(2014, 0, 7)
	 * })
	 * //=> false
	 *
	 * @example
	 * // For date equal to interval start:
	 * isWithinInterval(date, { start, end: date }) // => true
	 *
	 * @example
	 * // For date equal to interval end:
	 * isWithinInterval(date, { start: date, end }) // => true
	 */
	function isWithinInterval(dirtyDate, interval) {
	  (0, _index2.default)(2, arguments);
	  var time = (0, _index.default)(dirtyDate).getTime();
	  var startTime = (0, _index.default)(interval.start).getTime();
	  var endTime = (0, _index.default)(interval.end).getTime();
	
	  // Throw an exception if start date is after end date or if any date is `Invalid Date`
	  if (!(startTime <= endTime)) {
	    throw new RangeError('Invalid interval');
	  }
	  return time >= startTime && time <= endTime;
	}
	module.exports = exports.default;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isYesterday;
	var _index = _interopRequireDefault(__webpack_require__(222));
	var _index2 = _interopRequireDefault(__webpack_require__(280));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name isYesterday
	 * @category Day Helpers
	 * @summary Is the given date yesterday?
	 * @pure false
	 *
	 * @description
	 * Is the given date yesterday?
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @param {Date|Number} date - the date to check
	 * @returns {Boolean} the date is yesterday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
	 * const result = isYesterday(new Date(2014, 9, 5, 14, 0))
	 * //=> true
	 */
	function isYesterday(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, (0, _index2.default)(Date.now(), 1));
	}
	module.exports = exports.default;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfDecade;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name lastDayOfDecade
	 * @category Decade Helpers
	 * @summary Return the last day of a decade for the given date.
	 *
	 * @description
	 * Return the last day of a decade for the given date.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a decade for 21 December 2012 21:12:00:
	 * const result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
	 * //=> Wed Dec 31 2019 00:00:00
	 */
	function lastDayOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = 9 + Math.floor(year / 10) * 10;
	  date.setFullYear(decade + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(662));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name lastDayOfISOWeek
	 * @category ISO Week Helpers
	 * @summary Return the last day of an ISO week for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week for the given date.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of an ISO week
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week for 2 September 2014 11:55:00:
	 * const result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function lastDayOfISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(dirtyDate, {
	    weekStartsOn: 1
	  });
	}
	module.exports = exports.default;

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfISOWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(179));
	var _index2 = _interopRequireDefault(__webpack_require__(151));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name lastDayOfISOWeekYear
	 * @category ISO Week-Numbering Year Helpers
	 * @summary Return the last day of an ISO week-numbering year for the given date.
	 *
	 * @description
	 * Return the last day of an ISO week-numbering year,
	 * which always starts 3 days before the year's first Thursday.
	 * The result will be in the local timezone.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the end of an ISO week-numbering year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of an ISO week-numbering year for 2 July 2005:
	 * const result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
	 * //=> Sun Jan 01 2006 00:00:00
	 */
	function lastDayOfISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setFullYear(year + 1, 0, 4);
	  fourthOfJanuary.setHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  date.setDate(date.getDate() - 1);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfQuarter;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name lastDayOfQuarter
	 * @category Quarter Helpers
	 * @summary Return the last day of a year quarter for the given date.
	 *
	 * @description
	 * Return the last day of a year quarter for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * @returns {Date} the last day of a quarter
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // The last day of a quarter for 2 September 2014 11:55:00:
	 * const result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function lastDayOfQuarter(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var currentMonth = date.getMonth();
	  var month = currentMonth - currentMonth % 3 + 3;
	  date.setMonth(month, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lastDayOfYear;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name lastDayOfYear
	 * @category Year Helpers
	 * @summary Return the last day of a year for the given date.
	 *
	 * @description
	 * Return the last day of a year for the given date.
	 * The result will be in the local timezone.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the last day of a year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The last day of a year for 2 September 2014 11:55:00:
	 * const result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
	 * //=> Wed Dec 31 2014 00:00:00
	 */
	function lastDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  date.setFullYear(year + 1, 0, 0);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = lightFormat;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(623));
	var _index3 = _interopRequireDefault(__webpack_require__(109));
	var _index4 = _interopRequireDefault(__webpack_require__(128));
	var _index5 = _interopRequireDefault(__webpack_require__(224));
	var _index6 = _interopRequireDefault(__webpack_require__(5));
	// This RegExp consists of three parts separated by `|`:
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
	
	/**
	 * @name lightFormat
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. Unlike `format`,
	 * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
	 *
	 * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   |
	 * |---------------------------------|---------|-----------------------------------|
	 * | AM, PM                          | a..aaa  | AM, PM                            |
	 * |                                 | aaaa    | a.m., p.m.                        |
	 * |                                 | aaaaa   | a, p                              |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
	 * |                                 | yy      | 44, 01, 00, 17                    |
	 * |                                 | yyy     | 044, 001, 000, 017                |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |
	 * |                                 | MM      | 01, 02, ..., 12                   |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |
	 * |                                 | dd      | 01, 02, ..., 31                   |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |
	 * | Minute                          | m       | 0, 1, ..., 59                     |
	 * |                                 | mm      | 00, 01, ..., 59                   |
	 * | Second                          | s       | 0, 1, ..., 59                     |
	 * |                                 | ss      | 00, 01, ..., 59                   |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |
	 * |                                 | SS      | 00, 01, ..., 99                   |
	 * |                                 | SSS     | 000, 001, ..., 999                |
	 * |                                 | SSSS    | ...                               |
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * const result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
	 * //=> '2014-02-11'
	 */
	
	function lightFormat(dirtyDate, formatStr) {
	  (0, _index6.default)(2, arguments);
	  var originalDate = (0, _index.default)(dirtyDate);
	  if (!(0, _index4.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }
	
	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index3.default)(originalDate);
	  var utcDate = (0, _index5.default)(originalDate, timezoneOffset);
	  var tokens = formatStr.match(formattingTokensRegExp);
	
	  // The only case when formattingTokensRegExp doesn't match the string is when it's empty
	  if (!tokens) return '';
	  var result = tokens.map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index2.default[firstCharacter];
	    if (formatter) {
	      return formatter(utcDate, substring);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matches = input.match(escapedStringRegExp);
	  if (!matches) {
	    return input;
	  }
	  return matches[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default;

/***/ },
/* 1666 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	module.exports = exports.default;

/***/ },
/* 1667 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, options) {
	    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	    return valuesArray[index];
	  };
	}
	module.exports = exports.default;

/***/ },
/* 1668 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	    if (!matchResult) {
	      return null;
	    }
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	module.exports = exports.default;

/***/ },
/* 1669 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	module.exports = exports.default;

/***/ },
/* 1670 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	var formatDistance = function formatDistance(token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	  return result;
	};
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1666));
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1672 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1667));
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	};
	
	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
	  var number = Number(dirtyNumber);
	
	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.
	
	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function argumentCallback(quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1668));
	var _index2 = _interopRequireDefault(__webpack_require__(1669));
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function valueCallback(value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function valueCallback(index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(__webpack_require__(1670));
	var _index2 = _interopRequireDefault(__webpack_require__(1671));
	var _index3 = _interopRequireDefault(__webpack_require__(1672));
	var _index4 = _interopRequireDefault(__webpack_require__(1673));
	var _index5 = _interopRequireDefault(__webpack_require__(1674));
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = milliseconds;
	var _index = _interopRequireDefault(__webpack_require__(5));
	// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	var daysInYear = 365.2425;
	
	/**
	 * @name milliseconds
	 * @category Millisecond Helpers
	 * @summary
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * @description
	 * Returns the number of milliseconds in the specified, years, months, weeks, days, hours, minutes and seconds.
	 *
	 * One years equals 365.2425 days according to the formula:
	 *
	 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
	 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
	 *
	 * One month is a year divided by 12.
	 *
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {number} the milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // 1 year in milliseconds
	 * milliseconds({ years: 1 })
	 * //=> 31556952000
	 *
	 * // 3 months in milliseconds
	 * milliseconds({ months: 3 })
	 * //=> 7889238000
	 */
	function milliseconds(_ref) {
	  var years = _ref.years,
	    months = _ref.months,
	    weeks = _ref.weeks,
	    days = _ref.days,
	    hours = _ref.hours,
	    minutes = _ref.minutes,
	    seconds = _ref.seconds;
	  (0, _index.default)(1, arguments);
	  var totalDays = 0;
	  if (years) totalDays += years * daysInYear;
	  if (months) totalDays += months * (daysInYear / 12);
	  if (weeks) totalDays += weeks * 7;
	  if (days) totalDays += days;
	  var totalSeconds = totalDays * 24 * 60 * 60;
	  if (hours) totalSeconds += hours * 60 * 60;
	  if (minutes) totalSeconds += minutes * 60;
	  if (seconds) totalSeconds += seconds;
	  return Math.round(totalSeconds * 1000);
	}
	module.exports = exports.default;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToHours;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name millisecondsToHours
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to hours.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of hours.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200000 milliseconds to hours:
	 * const result = millisecondsToHours(7200000)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToHours(7199999)
	 * //=> 1
	 */
	function millisecondsToHours(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var hours = milliseconds / _index2.millisecondsInHour;
	  return Math.floor(hours);
	}
	module.exports = exports.default;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToMinutes;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name millisecondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to minutes.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of minutes.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted.
	 *
	 * @returns {number} the number of milliseconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 60000 milliseconds to minutes:
	 * const result = millisecondsToMinutes(60000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToMinutes(119999)
	 * //=> 1
	 */
	function millisecondsToMinutes(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = milliseconds / _index2.millisecondsInMinute;
	  return Math.floor(minutes);
	}
	module.exports = exports.default;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = millisecondsToSeconds;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name millisecondsToSeconds
	 * @category Conversion Helpers
	 * @summary Convert milliseconds to seconds.
	 *
	 * @description
	 * Convert a number of milliseconds to a full number of seconds.
	 *
	 * @param {number} milliseconds - number of milliseconds to be converted
	 *
	 * @returns {number} the number of milliseconds converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 1000 miliseconds to seconds:
	 * const result = millisecondsToSeconds(1000)
	 * //=> 1
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = millisecondsToSeconds(1999)
	 * //=> 1
	 */
	function millisecondsToSeconds(milliseconds) {
	  (0, _index.default)(1, arguments);
	  var seconds = milliseconds / _index2.millisecondsInSecond;
	  return Math.floor(seconds);
	}
	module.exports = exports.default;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToHours;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name minutesToHours
	 * @category Conversion Helpers
	 * @summary Convert minutes to hours.
	 *
	 * @description
	 * Convert a number of minutes to a full number of hours.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 140 minutes to hours:
	 * const result = minutesToHours(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = minutesToHours(179)
	 * //=> 2
	 */
	function minutesToHours(minutes) {
	  (0, _index.default)(1, arguments);
	  var hours = minutes / _index2.minutesInHour;
	  return Math.floor(hours);
	}
	module.exports = exports.default;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name minutesToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to milliseconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of milliseconds.
	 *
	 * @param {number} minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to milliseconds
	 * const result = minutesToMilliseconds(2)
	 * //=> 120000
	 */
	function minutesToMilliseconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.millisecondsInMinute);
	}
	module.exports = exports.default;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = minutesToSeconds;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name minutesToSeconds
	 * @category Conversion Helpers
	 * @summary Convert minutes to seconds.
	 *
	 * @description
	 * Convert a number of minutes to a full number of seconds.
	 *
	 * @param { number } minutes - number of minutes to be converted
	 *
	 * @returns {number} the number of minutes converted in seconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 minutes to seconds
	 * const result = minutesToSeconds(2)
	 * //=> 120
	 */
	function minutesToSeconds(minutes) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(minutes * _index2.secondsInMinute);
	}
	module.exports = exports.default;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToQuarters;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name monthsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert number of months to quarters.
	 *
	 * @description
	 * Convert a number of months to a full number of quarters.
	 *
	 * @param {number} months - number of months to be converted.
	 *
	 * @returns {number} the number of months converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 6 months to quarters:
	 * const result = monthsToQuarters(6)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = monthsToQuarters(7)
	 * //=> 2
	 */
	function monthsToQuarters(months) {
	  (0, _index.default)(1, arguments);
	  var quarters = months / _index2.monthsInQuarter;
	  return Math.floor(quarters);
	}
	module.exports = exports.default;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = monthsToYears;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name monthsToYears
	 * @category Conversion Helpers
	 * @summary Convert number of months to years.
	 *
	 * @description
	 * Convert a number of months to a full number of years.
	 *
	 * @param {number} months - number of months to be converted
	 *
	 * @returns {number} the number of months converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 36 months to years:
	 * const result = monthsToYears(36)
	 * //=> 3
	 *
	 * // It uses floor rounding:
	 * const result = monthsToYears(40)
	 * //=> 3
	 */
	function monthsToYears(months) {
	  (0, _index.default)(1, arguments);
	  var years = months / _index2.monthsInYear;
	  return Math.floor(years);
	}
	module.exports = exports.default;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextFriday;
	var _index = _interopRequireDefault(__webpack_require__(129));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextFriday
	 * @category Weekday Helpers
	 * @summary When is the next Friday?
	 *
	 * @description
	 * When is the next Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Friday after Mar, 22, 2020?
	 * const result = nextFriday(new Date(2020, 2, 22))
	 * //=> Fri Mar 27 2020 00:00:00
	 */
	function nextFriday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 5);
	}
	module.exports = exports.default;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextMonday;
	var _index = _interopRequireDefault(__webpack_require__(129));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextMonday
	 * @category Weekday Helpers
	 * @summary When is the next Monday?
	 *
	 * @description
	 * When is the next Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Monday after Mar, 22, 2020?
	 * const result = nextMonday(new Date(2020, 2, 22))
	 * //=> Mon Mar 23 2020 00:00:00
	 */
	function nextMonday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 1);
	}
	module.exports = exports.default;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSaturday;
	var _index = _interopRequireDefault(__webpack_require__(129));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextSaturday
	 * @category Weekday Helpers
	 * @summary When is the next Saturday?
	 *
	 * @description
	 * When is the next Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Saturday after Mar, 22, 2020?
	 * const result = nextSaturday(new Date(2020, 2, 22))
	 * //=> Sat Mar 28 2020 00:00:00
	 */
	function nextSaturday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 6);
	}
	module.exports = exports.default;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextSunday;
	var _index = _interopRequireDefault(__webpack_require__(129));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextSunday
	 * @category Weekday Helpers
	 * @summary When is the next Sunday?
	 *
	 * @description
	 * When is the next Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Sunday after Mar, 22, 2020?
	 * const result = nextSunday(new Date(2020, 2, 22))
	 * //=> Sun Mar 29 2020 00:00:00
	 */
	function nextSunday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 0);
	}
	module.exports = exports.default;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextThursday;
	var _index = _interopRequireDefault(__webpack_require__(129));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextThursday
	 * @category Weekday Helpers
	 * @summary When is the next Thursday?
	 *
	 * @description
	 * When is the next Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Thursday after Mar, 22, 2020?
	 * const result = nextThursday(new Date(2020, 2, 22))
	 * //=> Thur Mar 26 2020 00:00:00
	 */
	function nextThursday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 4);
	}
	module.exports = exports.default;

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextTuesday;
	var _index = _interopRequireDefault(__webpack_require__(129));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextTuesday
	 * @category Weekday Helpers
	 * @summary When is the next Tuesday?
	 *
	 * @description
	 * When is the next Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Tuesday after Mar, 22, 2020?
	 * const result = nextTuesday(new Date(2020, 2, 22))
	 * //=> Tue Mar 24 2020 00:00:00
	 */
	function nextTuesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 2);
	}
	module.exports = exports.default;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = nextWednesday;
	var _index = _interopRequireDefault(__webpack_require__(129));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name nextWednesday
	 * @category Weekday Helpers
	 * @summary When is the next Wednesday?
	 *
	 * @description
	 * When is the next Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the next Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the next Wednesday after Mar, 22, 2020?
	 * const result = nextWednesday(new Date(2020, 2, 22))
	 * //=> Wed Mar 25 2020 00:00:00
	 */
	function nextWednesday(date) {
	  (0, _index2.default)(1, arguments);
	  return (0, _index.default)(date, 3);
	}
	module.exports = exports.default;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMMidnightParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMMidnightParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMMidnightParser);
	  function AMPMMidnightParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMMidnightParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMMidnightParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'b':
	        case 'bb':
	        case 'bbb':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbbb':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'bbbb':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMMidnightParser;
	}(_Parser2.Parser);
	exports.AMPMMidnightParser = AMPMMidnightParser;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AMPMParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var AMPMParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(AMPMParser, _Parser);
	  var _super = (0, _createSuper2.default)(AMPMParser);
	  function AMPMParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, AMPMParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(AMPMParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'a':
	        case 'aa':
	        case 'aaa':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaaa':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'aaaa':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return AMPMParser;
	}(_Parser2.Parser);
	exports.AMPMParser = AMPMParser;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DateParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _utils = __webpack_require__(37);
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	
	// Day of the month
	var DateParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DateParser, _Parser);
	  var _super = (0, _createSuper2.default)(DateParser);
	  function DateParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DateParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subPriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DateParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'd':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.date, dateString);
	        case 'do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      var month = date.getUTCMonth();
	      if (isLeapYear) {
	        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
	      } else {
	        return value >= 1 && value <= DAYS_IN_MONTH[month];
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCDate(value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DateParser;
	}(_Parser2.Parser);
	exports.DateParser = DateParser;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayOfYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var DayOfYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayOfYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayOfYearParser);
	  function DayOfYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayOfYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "subpriority", 1);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayOfYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'D':
	        case 'DD':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.dayOfYear, dateString);
	        case 'Do':
	          return match.ordinalNumber(dateString, {
	            unit: 'date'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(date, value) {
	      var year = date.getUTCFullYear();
	      var isLeapYear = (0, _utils.isLeapYearIndex)(year);
	      if (isLeapYear) {
	        return value >= 1 && value <= 366;
	      } else {
	        return value >= 1 && value <= 365;
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(0, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayOfYearParser;
	}(_Parser2.Parser);
	exports.DayOfYearParser = DayOfYearParser;

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _index = _interopRequireDefault(__webpack_require__(383));
	// Day of week
	var DayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayParser);
	  function DayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // Tue
	        case 'E':
	        case 'EE':
	        case 'EEE':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'EEEEE':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'EEEEEE':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'EEEE':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayParser;
	}(_Parser2.Parser);
	exports.DayParser = DayParser;

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DayPeriodParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	// in the morning, in the afternoon, in the evening, at night
	var DayPeriodParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(DayPeriodParser, _Parser);
	  var _super = (0, _createSuper2.default)(DayPeriodParser);
	  function DayPeriodParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, DayPeriodParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 80);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(DayPeriodParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'B':
	        case 'BB':
	        case 'BBB':
	          return match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBBB':
	          return match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        case 'BBBB':
	        default:
	          return match.dayPeriod(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.dayPeriod(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours((0, _utils.dayPeriodEnumToHours)(value), 0, 0, 0);
	      return date;
	    }
	  }]);
	  return DayPeriodParser;
	}(_Parser2.Parser);
	exports.DayPeriodParser = DayPeriodParser;

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EraParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var EraParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(EraParser, _Parser);
	  var _super = (0, _createSuper2.default)(EraParser);
	  function EraParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, EraParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 140);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(EraParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // AD, BC
	        case 'G':
	        case 'GG':
	        case 'GGG':
	          return match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	        // A, B
	        case 'GGGGG':
	          return match.era(dateString, {
	            width: 'narrow'
	          });
	        // Anno Domini, Before Christ
	        case 'GGGG':
	        default:
	          return match.era(dateString, {
	            width: 'wide'
	          }) || match.era(dateString, {
	            width: 'abbreviated'
	          }) || match.era(dateString, {
	            width: 'narrow'
	          });
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      flags.era = value;
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return EraParser;
	}(_Parser2.Parser);
	exports.EraParser = EraParser;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ExtendedYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ExtendedYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ExtendedYearParser);
	  function ExtendedYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ExtendedYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ExtendedYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'u') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCFullYear(value, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ExtendedYearParser;
	}(_Parser2.Parser);
	exports.ExtendedYearParser = ExtendedYearParser;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FractionOfSecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(FractionOfSecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(FractionOfSecondParser);
	  function FractionOfSecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, FractionOfSecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 30);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(FractionOfSecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      var valueCallback = function valueCallback(value) {
	        return Math.floor(value * Math.pow(10, -token.length + 3));
	      };
	      return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMilliseconds(value);
	      return date;
	    }
	  }]);
	  return FractionOfSecondParser;
	}(_Parser2.Parser);
	exports.FractionOfSecondParser = FractionOfSecondParser;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0To11Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0To11Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0To11Parser);
	  function Hour0To11Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0To11Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0To11Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'K':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour11h, dateString);
	        case 'Ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour0To11Parser;
	}(_Parser2.Parser);
	exports.Hour0To11Parser = Hour0To11Parser;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour0to23Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour0to23Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour0to23Parser);
	  function Hour0to23Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour0to23Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour0to23Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'H':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour23h, dateString);
	        case 'Ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 23;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCHours(value, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour0to23Parser;
	}(_Parser2.Parser);
	exports.Hour0to23Parser = Hour0to23Parser;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1To24Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1To24Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1To24Parser);
	  function Hour1To24Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1To24Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1To24Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'k':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour24h, dateString);
	        case 'ko':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 24;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var hours = value <= 24 ? value % 24 : value;
	      date.setUTCHours(hours, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return Hour1To24Parser;
	}(_Parser2.Parser);
	exports.Hour1To24Parser = Hour1To24Parser;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hour1to12Parser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(Hour1to12Parser, _Parser);
	  var _super = (0, _createSuper2.default)(Hour1to12Parser);
	  function Hour1to12Parser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, Hour1to12Parser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 70);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(Hour1to12Parser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'h':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.hour12h, dateString);
	        case 'ho':
	          return match.ordinalNumber(dateString, {
	            unit: 'hour'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 12;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      var isPM = date.getUTCHours() >= 12;
	      if (isPM && value < 12) {
	        date.setUTCHours(value + 12, 0, 0, 0);
	      } else if (!isPM && value === 12) {
	        date.setUTCHours(0, 0, 0, 0);
	      } else {
	        date.setUTCHours(value, 0, 0, 0);
	      }
	      return date;
	    }
	  }]);
	  return Hour1to12Parser;
	}(_Parser2.Parser);
	exports.Hour1to12Parser = Hour1to12Parser;

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISODayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var _index = _interopRequireDefault(__webpack_require__(1569));
	// ISO day of week
	var ISODayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISODayParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISODayParser);
	  function ISODayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISODayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISODayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        if (value === 0) {
	          return 7;
	        }
	        return value;
	      };
	      switch (token) {
	        // 2
	        case 'i':
	        case 'ii':
	          // 02
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 2nd
	        case 'io':
	          return match.ordinalNumber(dateString, {
	            unit: 'day'
	          });
	        // Tue
	        case 'iii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // T
	        case 'iiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tu
	        case 'iiiiii':
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	        // Tuesday
	        case 'iiii':
	        default:
	          return (0, _utils.mapValue)(match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          }), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 7;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date = (0, _index.default)(date, value);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return ISODayParser;
	}(_Parser2.Parser);
	exports.ISODayParser = ISODayParser;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	// Timezone (ISO-8601)
	var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneParser);
	  function ISOTimezoneParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'X']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'x':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'xx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'xxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'xxxxx':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'xxx':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneParser = ISOTimezoneParser;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOTimezoneWithZParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	// Timezone (ISO-8601. +00:00 is `'Z'`)
	var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOTimezoneWithZParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOTimezoneWithZParser);
	  function ISOTimezoneWithZParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOTimezoneWithZParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 10);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T', 'x']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOTimezoneWithZParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      switch (token) {
	        case 'X':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalMinutes, dateString);
	        case 'XX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basic, dateString);
	        case 'XXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.basicOptionalSeconds, dateString);
	        case 'XXXXX':
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extendedOptionalSeconds, dateString);
	        case 'XXX':
	        default:
	          return (0, _utils.parseTimezonePattern)(_constants.timezonePatterns.extended, dateString);
	      }
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      if (flags.timestampIsSet) {
	        return date;
	      }
	      return new Date(date.getTime() - value);
	    }
	  }]);
	  return ISOTimezoneWithZParser;
	}(_Parser2.Parser);
	exports.ISOTimezoneWithZParser = ISOTimezoneWithZParser;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var _index = _interopRequireDefault(__webpack_require__(1570));
	var _index2 = _interopRequireDefault(__webpack_require__(217));
	// ISO week of year
	var ISOWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekParser);
	  function ISOWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'I':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'Io':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      return (0, _index2.default)((0, _index.default)(date, value));
	    }
	  }]);
	  return ISOWeekParser;
	}(_Parser2.Parser);
	exports.ISOWeekParser = ISOWeekParser;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ISOWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var _index = _interopRequireDefault(__webpack_require__(217));
	// ISO week-numbering year
	var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(ISOWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(ISOWeekYearParser);
	  function ISOWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, ISOWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(ISOWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token) {
	      if (token === 'R') {
	        return (0, _utils.parseNDigitsSigned)(4, dateString);
	      }
	      return (0, _utils.parseNDigitsSigned)(token.length, dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      var firstWeekOfYear = new Date(0);
	      firstWeekOfYear.setUTCFullYear(value, 0, 4);
	      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
	      return (0, _index.default)(firstWeekOfYear);
	    }
	  }]);
	  return ISOWeekYearParser;
	}(_Parser2.Parser);
	exports.ISOWeekYearParser = ISOWeekYearParser;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var _index = _interopRequireDefault(__webpack_require__(383));
	// Local day of week
	var LocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalDayParser);
	  function LocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'e':
	        case 'ee':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'eo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'eee':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // T
	        case 'eeeee':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tu
	        case 'eeeeee':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // Tuesday
	        case 'eeee':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'formatting'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return LocalDayParser;
	}(_Parser2.Parser);
	exports.LocalDayParser = LocalDayParser;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var _index = _interopRequireDefault(__webpack_require__(1571));
	var _index2 = _interopRequireDefault(__webpack_require__(218));
	// Local week of year
	var LocalWeekParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekParser);
	  function LocalWeekParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 100);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'w':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.week, dateString);
	        case 'wo':
	          return match.ordinalNumber(dateString, {
	            unit: 'week'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 53;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      return (0, _index2.default)((0, _index.default)(date, value, options), options);
	    }
	  }]);
	  return LocalWeekParser;
	}(_Parser2.Parser);
	exports.LocalWeekParser = LocalWeekParser;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LocalWeekYearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var _index = _interopRequireDefault(__webpack_require__(382));
	var _index2 = _interopRequireDefault(__webpack_require__(218));
	// Local week-numbering year
	var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(LocalWeekYearParser, _Parser);
	  var _super = (0, _createSuper2.default)(LocalWeekYearParser);
	  function LocalWeekYearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, LocalWeekYearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(LocalWeekYearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'YY'
	        };
	      };
	      switch (token) {
	        case 'Y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'Yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value, options) {
	      var currentYear = (0, _index.default)(date, options);
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
	        date.setUTCHours(0, 0, 0, 0);
	        return (0, _index2.default)(date, options);
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
	      date.setUTCHours(0, 0, 0, 0);
	      return (0, _index2.default)(date, options);
	    }
	  }]);
	  return LocalWeekYearParser;
	}(_Parser2.Parser);
	exports.LocalWeekYearParser = LocalWeekYearParser;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MinuteParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var MinuteParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MinuteParser, _Parser);
	  var _super = (0, _createSuper2.default)(MinuteParser);
	  function MinuteParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MinuteParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 60);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(MinuteParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 'm':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.minute, dateString);
	        case 'mo':
	          return match.ordinalNumber(dateString, {
	            unit: 'minute'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMinutes(value, 0, 0);
	      return date;
	    }
	  }]);
	  return MinuteParser;
	}(_Parser2.Parser);
	exports.MinuteParser = MinuteParser;

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _utils = __webpack_require__(37);
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var MonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(MonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(MonthParser);
	  function MonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, MonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    return _this;
	  }
	  (0, _createClass2.default)(MonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'M':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'MM':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Mo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'MMM':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // J, F, ..., D
	        case 'MMMMM':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // January, February, ..., December
	        case 'MMMM':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return MonthParser;
	}(_Parser2.Parser);
	exports.MonthParser = MonthParser;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.QuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var QuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(QuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(QuarterParser);
	  function QuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, QuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(QuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'Q':
	        case 'QQ':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'Qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'QQQ':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'QQQQQ':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'QQQQ':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'formatting'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'formatting'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return QuarterParser;
	}(_Parser2.Parser);
	exports.QuarterParser = QuarterParser;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SecondParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var SecondParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(SecondParser, _Parser);
	  var _super = (0, _createSuper2.default)(SecondParser);
	  function SecondParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, SecondParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 50);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['t', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(SecondParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        case 's':
	          return (0, _utils.parseNumericPattern)(_constants.numericPatterns.second, dateString);
	        case 'so':
	          return match.ordinalNumber(dateString, {
	            unit: 'second'
	          });
	        default:
	          return (0, _utils.parseNDigits)(token.length, dateString);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 59;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCSeconds(value, 0);
	      return date;
	    }
	  }]);
	  return SecondParser;
	}(_Parser2.Parser);
	exports.SecondParser = SecondParser;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneLocalDayParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var _index = _interopRequireDefault(__webpack_require__(383));
	// Stand-alone local day of week
	var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneLocalDayParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneLocalDayParser);
	  function StandAloneLocalDayParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneLocalDayParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 90);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneLocalDayParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match, options) {
	      var valueCallback = function valueCallback(value) {
	        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
	        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
	      };
	      switch (token) {
	        // 3
	        case 'c':
	        case 'cc':
	          // 03
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	        // 3rd
	        case 'co':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'day'
	          }), valueCallback);
	        // Tue
	        case 'ccc':
	          return match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // T
	        case 'ccccc':
	          return match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tu
	        case 'cccccc':
	          return match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // Tuesday
	        case 'cccc':
	        default:
	          return match.day(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'short',
	            context: 'standalone'
	          }) || match.day(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 6;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value, options) {
	      date = (0, _index.default)(date, value, options);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneLocalDayParser;
	}(_Parser2.Parser);
	exports.StandAloneLocalDayParser = StandAloneLocalDayParser;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneMonthParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _constants = __webpack_require__(68);
	var _utils = __webpack_require__(37);
	var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneMonthParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneMonthParser);
	  function StandAloneMonthParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneMonthParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 110);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneMonthParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(value) {
	        return value - 1;
	      };
	      switch (token) {
	        // 1, 2, ..., 12
	        case 'L':
	          return (0, _utils.mapValue)((0, _utils.parseNumericPattern)(_constants.numericPatterns.month, dateString), valueCallback);
	        // 01, 02, ..., 12
	        case 'LL':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(2, dateString), valueCallback);
	        // 1st, 2nd, ..., 12th
	        case 'Lo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'month'
	          }), valueCallback);
	        // Jan, Feb, ..., Dec
	        case 'LLL':
	          return match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // J, F, ..., D
	        case 'LLLLL':
	          return match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // January, February, ..., December
	        case 'LLLL':
	        default:
	          return match.month(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.month(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 0 && value <= 11;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth(value, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneMonthParser;
	}(_Parser2.Parser);
	exports.StandAloneMonthParser = StandAloneMonthParser;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StandAloneQuarterParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(StandAloneQuarterParser, _Parser);
	  var _super = (0, _createSuper2.default)(StandAloneQuarterParser);
	  function StandAloneQuarterParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, StandAloneQuarterParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 120);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(StandAloneQuarterParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      switch (token) {
	        // 1, 2, 3, 4
	        case 'q':
	        case 'qq':
	          // 01, 02, 03, 04
	          return (0, _utils.parseNDigits)(token.length, dateString);
	        // 1st, 2nd, 3rd, 4th
	        case 'qo':
	          return match.ordinalNumber(dateString, {
	            unit: 'quarter'
	          });
	        // Q1, Q2, Q3, Q4
	        case 'qqq':
	          return match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	        case 'qqqqq':
	          return match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	        // 1st quarter, 2nd quarter, ...
	        case 'qqqq':
	        default:
	          return match.quarter(dateString, {
	            width: 'wide',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'abbreviated',
	            context: 'standalone'
	          }) || match.quarter(dateString, {
	            width: 'narrow',
	            context: 'standalone'
	          });
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value >= 1 && value <= 4;
	    }
	  }, {
	    key: "set",
	    value: function set(date, _flags, value) {
	      date.setUTCMonth((value - 1) * 3, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return StandAloneQuarterParser;
	}(_Parser2.Parser);
	exports.StandAloneQuarterParser = StandAloneQuarterParser;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampMillisecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampMillisecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampMillisecondsParser);
	  function TimestampMillisecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampMillisecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 20);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampMillisecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampMillisecondsParser;
	}(_Parser2.Parser);
	exports.TimestampMillisecondsParser = TimestampMillisecondsParser;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TimestampSecondsParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(TimestampSecondsParser, _Parser);
	  var _super = (0, _createSuper2.default)(TimestampSecondsParser);
	  function TimestampSecondsParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, TimestampSecondsParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 40);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", '*');
	    return _this;
	  }
	  (0, _createClass2.default)(TimestampSecondsParser, [{
	    key: "parse",
	    value: function parse(dateString) {
	      return (0, _utils.parseAnyDigitsSigned)(dateString);
	    }
	  }, {
	    key: "set",
	    value: function set(_date, _flags, value) {
	      return [new Date(value * 1000), {
	        timestampIsSet: true
	      }];
	    }
	  }]);
	  return TimestampSecondsParser;
	}(_Parser2.Parser);
	exports.TimestampSecondsParser = TimestampSecondsParser;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.YearParser = void 0;
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(25));
	var _createClass2 = _interopRequireDefault(__webpack_require__(26));
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(24));
	var _inherits2 = _interopRequireDefault(__webpack_require__(30));
	var _createSuper2 = _interopRequireDefault(__webpack_require__(29));
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(27));
	var _Parser2 = __webpack_require__(34);
	var _utils = __webpack_require__(37);
	// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
	// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	// |----------|-------|----|-------|-------|-------|
	// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
	var YearParser = /*#__PURE__*/function (_Parser) {
	  (0, _inherits2.default)(YearParser, _Parser);
	  var _super = (0, _createSuper2.default)(YearParser);
	  function YearParser() {
	    var _this;
	    (0, _classCallCheck2.default)(this, YearParser);
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	    _this = _super.call.apply(_super, [this].concat(args));
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "priority", 130);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
	    return _this;
	  }
	  (0, _createClass2.default)(YearParser, [{
	    key: "parse",
	    value: function parse(dateString, token, match) {
	      var valueCallback = function valueCallback(year) {
	        return {
	          year: year,
	          isTwoDigitYear: token === 'yy'
	        };
	      };
	      switch (token) {
	        case 'y':
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(4, dateString), valueCallback);
	        case 'yo':
	          return (0, _utils.mapValue)(match.ordinalNumber(dateString, {
	            unit: 'year'
	          }), valueCallback);
	        default:
	          return (0, _utils.mapValue)((0, _utils.parseNDigits)(token.length, dateString), valueCallback);
	      }
	    }
	  }, {
	    key: "validate",
	    value: function validate(_date, value) {
	      return value.isTwoDigitYear || value.year > 0;
	    }
	  }, {
	    key: "set",
	    value: function set(date, flags, value) {
	      var currentYear = date.getUTCFullYear();
	      if (value.isTwoDigitYear) {
	        var normalizedTwoDigitYear = (0, _utils.normalizeTwoDigitYear)(value.year, currentYear);
	        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
	        date.setUTCHours(0, 0, 0, 0);
	        return date;
	      }
	      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
	      date.setUTCFullYear(year, 0, 1);
	      date.setUTCHours(0, 0, 0, 0);
	      return date;
	    }
	  }]);
	  return YearParser;
	}(_Parser2.Parser);
	exports.YearParser = YearParser;

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parsers = void 0;
	var _EraParser = __webpack_require__(1698);
	var _YearParser = __webpack_require__(1722);
	var _LocalWeekYearParser = __webpack_require__(1712);
	var _ISOWeekYearParser = __webpack_require__(1709);
	var _ExtendedYearParser = __webpack_require__(1699);
	var _QuarterParser = __webpack_require__(1715);
	var _StandAloneQuarterParser = __webpack_require__(1719);
	var _MonthParser = __webpack_require__(1714);
	var _StandAloneMonthParser = __webpack_require__(1718);
	var _LocalWeekParser = __webpack_require__(1711);
	var _ISOWeekParser = __webpack_require__(1708);
	var _DateParser = __webpack_require__(1694);
	var _DayOfYearParser = __webpack_require__(1695);
	var _DayParser = __webpack_require__(1696);
	var _LocalDayParser = __webpack_require__(1710);
	var _StandAloneLocalDayParser = __webpack_require__(1717);
	var _ISODayParser = __webpack_require__(1705);
	var _AMPMParser = __webpack_require__(1693);
	var _AMPMMidnightParser = __webpack_require__(1692);
	var _DayPeriodParser = __webpack_require__(1697);
	var _Hour1to12Parser = __webpack_require__(1704);
	var _Hour0to23Parser = __webpack_require__(1702);
	var _Hour0To11Parser = __webpack_require__(1701);
	var _Hour1To24Parser = __webpack_require__(1703);
	var _MinuteParser = __webpack_require__(1713);
	var _SecondParser = __webpack_require__(1716);
	var _FractionOfSecondParser = __webpack_require__(1700);
	var _ISOTimezoneWithZParser = __webpack_require__(1707);
	var _ISOTimezoneParser = __webpack_require__(1706);
	var _TimestampSecondsParser = __webpack_require__(1721);
	var _TimestampMillisecondsParser = __webpack_require__(1720);
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
	 * |  p  |                                |  P  |                                |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 */
	var parsers = {
	  G: new _EraParser.EraParser(),
	  y: new _YearParser.YearParser(),
	  Y: new _LocalWeekYearParser.LocalWeekYearParser(),
	  R: new _ISOWeekYearParser.ISOWeekYearParser(),
	  u: new _ExtendedYearParser.ExtendedYearParser(),
	  Q: new _QuarterParser.QuarterParser(),
	  q: new _StandAloneQuarterParser.StandAloneQuarterParser(),
	  M: new _MonthParser.MonthParser(),
	  L: new _StandAloneMonthParser.StandAloneMonthParser(),
	  w: new _LocalWeekParser.LocalWeekParser(),
	  I: new _ISOWeekParser.ISOWeekParser(),
	  d: new _DateParser.DateParser(),
	  D: new _DayOfYearParser.DayOfYearParser(),
	  E: new _DayParser.DayParser(),
	  e: new _LocalDayParser.LocalDayParser(),
	  c: new _StandAloneLocalDayParser.StandAloneLocalDayParser(),
	  i: new _ISODayParser.ISODayParser(),
	  a: new _AMPMParser.AMPMParser(),
	  b: new _AMPMMidnightParser.AMPMMidnightParser(),
	  B: new _DayPeriodParser.DayPeriodParser(),
	  h: new _Hour1to12Parser.Hour1to12Parser(),
	  H: new _Hour0to23Parser.Hour0to23Parser(),
	  K: new _Hour0To11Parser.Hour0To11Parser(),
	  k: new _Hour1To24Parser.Hour1To24Parser(),
	  m: new _MinuteParser.MinuteParser(),
	  s: new _SecondParser.SecondParser(),
	  S: new _FractionOfSecondParser.FractionOfSecondParser(),
	  X: new _ISOTimezoneWithZParser.ISOTimezoneWithZParser(),
	  x: new _ISOTimezoneParser.ISOTimezoneParser(),
	  t: new _TimestampSecondsParser.TimestampSecondsParser(),
	  T: new _TimestampMillisecondsParser.TimestampMillisecondsParser()
	};
	exports.parsers = parsers;

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseISO;
	var _index = __webpack_require__(42);
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name parseISO
	 * @category Common Helpers
	 * @summary Parse ISO string
	 *
	 * @description
	 * Parse the given string in ISO 8601 format and return an instance of Date.
	 *
	 * Function accepts complete ISO 8601 formats as well as partial implementations.
	 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
	 *
	 * If the argument isn't a string, the function cannot parse the string or
	 * the values are invalid, it returns Invalid Date.
	 *
	 * @param {String} argument - the value to convert
	 * @param {Object} [options] - an object with options.
	 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
	 *
	 * @example
	 * // Convert string '2014-02-11T11:30:30' to date:
	 * const result = parseISO('2014-02-11T11:30:30')
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert string '+02014101' to date,
	 * // if the additional number of digits in the extended year format is 1:
	 * const result = parseISO('+02014101', { additionalDigits: 1 })
	 * //=> Fri Apr 11 2014 00:00:00
	 */
	function parseISO(argument, options) {
	  var _options$additionalDi;
	  (0, _index2.default)(1, arguments);
	  var additionalDigits = (0, _index3.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
	  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
	    throw new RangeError('additionalDigits must be 0, 1 or 2');
	  }
	  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
	    return new Date(NaN);
	  }
	  var dateStrings = splitDateString(argument);
	  var date;
	  if (dateStrings.date) {
	    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
	    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
	  }
	  if (!date || isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  var timestamp = date.getTime();
	  var time = 0;
	  var offset;
	  if (dateStrings.time) {
	    time = parseTime(dateStrings.time);
	    if (isNaN(time)) {
	      return new Date(NaN);
	    }
	  }
	  if (dateStrings.timezone) {
	    offset = parseTimezone(dateStrings.timezone);
	    if (isNaN(offset)) {
	      return new Date(NaN);
	    }
	  } else {
	    var dirtyDate = new Date(timestamp + time);
	    // js parsed string assuming it's in UTC timezone
	    // but we need it to be parsed in our timezone
	    // so we use utc values to build date in our timezone.
	    // Year values from 0 to 99 map to the years 1900 to 1999
	    // so set year explicitly with setFullYear.
	    var result = new Date(0);
	    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
	    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
	    return result;
	  }
	  return new Date(timestamp + time + offset);
	}
	var patterns = {
	  dateTimeDelimiter: /[T ]/,
	  timeZoneDelimiter: /[Z ]/i,
	  timezone: /([Z+-].*)$/
	};
	var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
	var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
	var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
	function splitDateString(dateString) {
	  var dateStrings = {};
	  var array = dateString.split(patterns.dateTimeDelimiter);
	  var timeString;
	
	  // The regex match should only return at maximum two array elements.
	  // [date], [time], or [date, time].
	  if (array.length > 2) {
	    return dateStrings;
	  }
	  if (/:/.test(array[0])) {
	    timeString = array[0];
	  } else {
	    dateStrings.date = array[0];
	    timeString = array[1];
	    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
	      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
	      timeString = dateString.substr(dateStrings.date.length, dateString.length);
	    }
	  }
	  if (timeString) {
	    var token = patterns.timezone.exec(timeString);
	    if (token) {
	      dateStrings.time = timeString.replace(token[1], '');
	      dateStrings.timezone = token[1];
	    } else {
	      dateStrings.time = timeString;
	    }
	  }
	  return dateStrings;
	}
	function parseYear(dateString, additionalDigits) {
	  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
	  var captures = dateString.match(regex);
	  // Invalid ISO-formatted year
	  if (!captures) return {
	    year: NaN,
	    restDateString: ''
	  };
	  var year = captures[1] ? parseInt(captures[1]) : null;
	  var century = captures[2] ? parseInt(captures[2]) : null;
	
	  // either year or century is null, not both
	  return {
	    year: century === null ? year : century * 100,
	    restDateString: dateString.slice((captures[1] || captures[2]).length)
	  };
	}
	function parseDate(dateString, year) {
	  // Invalid ISO-formatted year
	  if (year === null) return new Date(NaN);
	  var captures = dateString.match(dateRegex);
	  // Invalid ISO-formatted string
	  if (!captures) return new Date(NaN);
	  var isWeekDate = !!captures[4];
	  var dayOfYear = parseDateUnit(captures[1]);
	  var month = parseDateUnit(captures[2]) - 1;
	  var day = parseDateUnit(captures[3]);
	  var week = parseDateUnit(captures[4]);
	  var dayOfWeek = parseDateUnit(captures[5]) - 1;
	  if (isWeekDate) {
	    if (!validateWeekDate(year, week, dayOfWeek)) {
	      return new Date(NaN);
	    }
	    return dayOfISOWeekYear(year, week, dayOfWeek);
	  } else {
	    var date = new Date(0);
	    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
	      return new Date(NaN);
	    }
	    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
	    return date;
	  }
	}
	function parseDateUnit(value) {
	  return value ? parseInt(value) : 1;
	}
	function parseTime(timeString) {
	  var captures = timeString.match(timeRegex);
	  if (!captures) return NaN; // Invalid ISO-formatted time
	
	  var hours = parseTimeUnit(captures[1]);
	  var minutes = parseTimeUnit(captures[2]);
	  var seconds = parseTimeUnit(captures[3]);
	  if (!validateTime(hours, minutes, seconds)) {
	    return NaN;
	  }
	  return hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute + seconds * 1000;
	}
	function parseTimeUnit(value) {
	  return value && parseFloat(value.replace(',', '.')) || 0;
	}
	function parseTimezone(timezoneString) {
	  if (timezoneString === 'Z') return 0;
	  var captures = timezoneString.match(timezoneRegex);
	  if (!captures) return 0;
	  var sign = captures[1] === '+' ? -1 : 1;
	  var hours = parseInt(captures[2]);
	  var minutes = captures[3] && parseInt(captures[3]) || 0;
	  if (!validateTimezone(hours, minutes)) {
	    return NaN;
	  }
	  return sign * (hours * _index.millisecondsInHour + minutes * _index.millisecondsInMinute);
	}
	function dayOfISOWeekYear(isoWeekYear, week, day) {
	  var date = new Date(0);
	  date.setUTCFullYear(isoWeekYear, 0, 4);
	  var fourthOfJanuaryDay = date.getUTCDay() || 7;
	  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
	  date.setUTCDate(date.getUTCDate() + diff);
	  return date;
	}
	
	// Validation functions
	
	// February is null to handle the leap year (using ||)
	var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	function isLeapYearIndex(year) {
	  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
	}
	function validateDate(year, month, date) {
	  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
	}
	function validateDayOfYearDate(year, dayOfYear) {
	  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
	}
	function validateWeekDate(_year, week, day) {
	  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
	}
	function validateTime(hours, minutes, seconds) {
	  if (hours === 24) {
	    return minutes === 0 && seconds === 0;
	  }
	  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
	}
	function validateTimezone(_hours, minutes) {
	  return minutes >= 0 && minutes <= 59;
	}
	module.exports = exports.default;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = parseJSON;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name parseJSON
	 * @category Common Helpers
	 * @summary Parse a JSON date string
	 *
	 * @description
	 * Converts a complete ISO date string in UTC time, the typical format for transmitting
	 * a date in JSON, to a JavaScript `Date` instance.
	 *
	 * This is a minimal implementation for converting dates retrieved from a JSON API to
	 * a `Date` instance which can be used with other functions in the `date-fns` library.
	 * The following formats are supported:
	 *
	 * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
	 * - `2000-03-15T05:20:10Z`: Without milliseconds
	 * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+05:45`: With a positive or negative offset, the default JSON encoded format in some other languages
	 * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
	 * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
	 * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
	 * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
	 *
	 * For convenience and ease of use these other input types are also supported
	 * via [toDate]{@link https://date-fns.org/docs/toDate}:
	 *
	 * - A `Date` instance will be cloned
	 * - A `number` will be treated as a timestamp
	 *
	 * Any other input type or invalid date strings will return an `Invalid Date`.
	 *
	 * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 */
	function parseJSON(argument) {
	  (0, _index2.default)(1, arguments);
	  if (typeof argument === 'string') {
	    var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
	    if (parts) {
	      // Group 8 matches the sign
	      return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
	    }
	    return new Date(NaN);
	  }
	  return (0, _index.default)(argument);
	}
	module.exports = exports.default;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousFriday;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(130));
	/**
	 * @name previousFriday
	 * @category Weekday Helpers
	 * @summary When is the previous Friday?
	 *
	 * @description
	 * When is the previous Friday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Friday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Friday before Jun, 19, 2021?
	 * const result = previousFriday(new Date(2021, 5, 19))
	 * //=> Fri June 18 2021 00:00:00
	 */
	function previousFriday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 5);
	}
	module.exports = exports.default;

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousMonday;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(130));
	/**
	 * @name previousMonday
	 * @category Weekday Helpers
	 * @summary When is the previous Monday?
	 *
	 * @description
	 * When is the previous Monday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Monday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Monday before Jun, 18, 2021?
	 * const result = previousMonday(new Date(2021, 5, 18))
	 * //=> Mon June 14 2021 00:00:00
	 */
	function previousMonday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 1);
	}
	module.exports = exports.default;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSaturday;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(130));
	/**
	 * @name previousSaturday
	 * @category Weekday Helpers
	 * @summary When is the previous Saturday?
	 *
	 * @description
	 * When is the previous Saturday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Saturday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Saturday before Jun, 20, 2021?
	 * const result = previousSaturday(new Date(2021, 5, 20))
	 * //=> Sat June 19 2021 00:00:00
	 */
	function previousSaturday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 6);
	}
	module.exports = exports.default;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousSunday;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(130));
	/**
	 * @name previousSunday
	 * @category Weekday Helpers
	 * @summary When is the previous Sunday?
	 *
	 * @description
	 * When is the previous Sunday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Sunday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Sunday before Jun, 21, 2021?
	 * const result = previousSunday(new Date(2021, 5, 21))
	 * //=> Sun June 20 2021 00:00:00
	 */
	function previousSunday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 0);
	}
	module.exports = exports.default;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousThursday;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(130));
	/**
	 * @name previousThursday
	 * @category Weekday Helpers
	 * @summary When is the previous Thursday?
	 *
	 * @description
	 * When is the previous Thursday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Thursday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Thursday before Jun, 18, 2021?
	 * const result = previousThursday(new Date(2021, 5, 18))
	 * //=> Thu June 17 2021 00:00:00
	 */
	function previousThursday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 4);
	}
	module.exports = exports.default;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousTuesday;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(130));
	/**
	 * @name previousTuesday
	 * @category Weekday Helpers
	 * @summary When is the previous Tuesday?
	 *
	 * @description
	 * When is the previous Tuesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Tuesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Tuesday before Jun, 18, 2021?
	 * const result = previousTuesday(new Date(2021, 5, 18))
	 * //=> Tue June 15 2021 00:00:00
	 */
	function previousTuesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 2);
	}
	module.exports = exports.default;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = previousWednesday;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = _interopRequireDefault(__webpack_require__(130));
	/**
	 * @name previousWednesday
	 * @category Weekday Helpers
	 * @summary When is the previous Wednesday?
	 *
	 * @description
	 * When is the previous Wednesday?
	 *
	 * @param {Date | number} date - the date to start counting from
	 * @returns {Date} the previous Wednesday
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // When is the previous Wednesday before Jun, 18, 2021?
	 * const result = previousWednesday(new Date(2021, 5, 18))
	 * //=> Wed June 16 2021 00:00:00
	 */
	function previousWednesday(date) {
	  (0, _index.default)(1, arguments);
	  return (0, _index2.default)(date, 3);
	}
	module.exports = exports.default;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToMonths;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name quartersToMonths
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to months.
	 *
	 * @description
	 * Convert a number of quarters to a full number of months.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 quarters to months
	 * const result = quartersToMonths(2)
	 * //=> 6
	 */
	function quartersToMonths(quarters) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(quarters * _index2.monthsInQuarter);
	}
	module.exports = exports.default;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = quartersToYears;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name quartersToYears
	 * @category Conversion Helpers
	 * @summary Convert number of quarters to years.
	 *
	 * @description
	 * Convert a number of quarters to a full number of years.
	 *
	 * @param {number} quarters - number of quarters to be converted
	 *
	 * @returns {number} the number of quarters converted in years
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 8 quarters to years
	 * const result = quartersToYears(8)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = quartersToYears(11)
	 * //=> 2
	 */
	function quartersToYears(quarters) {
	  (0, _index.default)(1, arguments);
	  var years = quarters / _index2.quartersInYear;
	  return Math.floor(years);
	}
	module.exports = exports.default;

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = roundToNearestMinutes;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = __webpack_require__(178);
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name roundToNearestMinutes
	 * @category Minute Helpers
	 * @summary Rounds the given date to the nearest minute
	 *
	 * @description
	 * Rounds the given date to the nearest minute (or number of minutes).
	 * Rounds up when the given date is exactly between the nearest round minutes.
	 *
	 * @param {Date|Number} date - the date to round
	 * @param {Object} [options] - an object with options.
	 * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
	 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
	 * @returns {Date} the new date rounded to the closest minute
	 * @throws {TypeError} 1 argument required
	 * @throws {RangeError} `options.nearestTo` must be between 1 and 30
	 *
	 * @example
	 * // Round 10 July 2014 12:12:34 to nearest minute:
	 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
	 * //=> Thu Jul 10 2014 12:13:00
	 *
	 * @example
	 * // Round 10 July 2014 12:07:30 to nearest quarter hour:
	 * const result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
	 * // rounds up because given date is exactly between 12:00:00 and 12:15:00
	 * //=> Thu Jul 10 2014 12:15:00
	 */
	function roundToNearestMinutes(dirtyDate, options) {
	  var _options$nearestTo;
	  if (arguments.length < 1) {
	    throw new TypeError('1 argument required, but only none provided present');
	  }
	  var nearestTo = (0, _index3.default)((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);
	  if (nearestTo < 1 || nearestTo > 30) {
	    throw new RangeError('`options.nearestTo` must be between 1 and 30');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
	  var minutes = date.getMinutes() + seconds / 60;
	  var roundingMethod = (0, _index2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod);
	  var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
	  var remainderMinutes = minutes % nearestTo;
	  var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
	  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
	}
	module.exports = exports.default;

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToHours;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name secondsToHours
	 * @category Conversion Helpers
	 * @summary Convert seconds to hours.
	 *
	 * @description
	 * Convert a number of seconds to a full number of hours.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in hours
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 7200 seconds into hours
	 * const result = secondsToHours(7200)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToHours(7199)
	 * //=> 1
	 */
	function secondsToHours(seconds) {
	  (0, _index.default)(1, arguments);
	  var hours = seconds / _index2.secondsInHour;
	  return Math.floor(hours);
	}
	module.exports = exports.default;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name secondsToMilliseconds
	 * @category Conversion Helpers
	 * @summary Convert seconds to milliseconds.
	 *
	 * @description
	 * Convert a number of seconds to a full number of milliseconds.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in milliseconds
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 seconds into milliseconds
	 * const result = secondsToMilliseconds(2)
	 * //=> 2000
	 */
	function secondsToMilliseconds(seconds) {
	  (0, _index.default)(1, arguments);
	  return seconds * _index2.millisecondsInSecond;
	}
	module.exports = exports.default;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = secondsToMinutes;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name secondsToMinutes
	 * @category Conversion Helpers
	 * @summary Convert seconds to minutes.
	 *
	 * @description
	 * Convert a number of seconds to a full number of minutes.
	 *
	 * @param {number} seconds - number of seconds to be converted
	 *
	 * @returns {number} the number of seconds converted in minutes
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 120 seconds into minutes
	 * const result = secondsToMinutes(120)
	 * //=> 2
	 *
	 * @example
	 * // It uses floor rounding:
	 * const result = secondsToMinutes(119)
	 * //=> 1
	 */
	function secondsToMinutes(seconds) {
	  (0, _index.default)(1, arguments);
	  var minutes = seconds / _index2.secondsInMinute;
	  return Math.floor(minutes);
	}
	module.exports = exports.default;

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = set;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(399));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name set
	 * @category Common Helpers
	 * @summary Set date values to a given date.
	 *
	 * @description
	 * Set date values to a given date.
	 *
	 * Sets time values to date from object `values`.
	 * A value is not set if it is undefined or null or doesn't exist in `values`.
	 *
	 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
	 * to use native `Date#setX` methods. If you use this function, you may not want to include the
	 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Object} values - an object with options
	 * @param {Number} [values.year] - the number of years to be set
	 * @param {Number} [values.month] - the number of months to be set
	 * @param {Number} [values.date] - the number of days to be set
	 * @param {Number} [values.hours] - the number of hours to be set
	 * @param {Number} [values.minutes] - the number of minutes to be set
	 * @param {Number} [values.seconds] - the number of seconds to be set
	 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
	 * @returns {Date} the new date with options set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `values` must be an object
	 *
	 * @example
	 * // Transform 1 September 2014 into 20 October 2015 in a single line:
	 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
	 * //=> Tue Oct 20 2015 00:00:00
	 *
	 * @example
	 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
	 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
	 * //=> Mon Sep 01 2014 12:23:45
	 */
	function set(dirtyDate, values) {
	  (0, _index4.default)(2, arguments);
	  if ((0, _typeof2.default)(values) !== 'object' || values === null) {
	    throw new RangeError('values parameter must be an object');
	  }
	  var date = (0, _index.default)(dirtyDate);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  if (values.year != null) {
	    date.setFullYear(values.year);
	  }
	  if (values.month != null) {
	    date = (0, _index2.default)(date, values.month);
	  }
	  if (values.date != null) {
	    date.setDate((0, _index3.default)(values.date));
	  }
	  if (values.hours != null) {
	    date.setHours((0, _index3.default)(values.hours));
	  }
	  if (values.minutes != null) {
	    date.setMinutes((0, _index3.default)(values.minutes));
	  }
	  if (values.seconds != null) {
	    date.setSeconds((0, _index3.default)(values.seconds));
	  }
	  if (values.milliseconds != null) {
	    date.setMilliseconds((0, _index3.default)(values.milliseconds));
	  }
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDate;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setDate
	 * @category Day Helpers
	 * @summary Set the day of the month to the given date.
	 *
	 * @description
	 * Set the day of the month to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfMonth - the day of the month of the new date
	 * @returns {Date} the new date with the day of the month set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 30th day of the month to 1 September 2014:
	 * const result = setDate(new Date(2014, 8, 1), 30)
	 * //=> Tue Sep 30 2014 00:00:00
	 */
	function setDate(dirtyDate, dirtyDayOfMonth) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfMonth = (0, _index.default)(dirtyDayOfMonth);
	  date.setDate(dayOfMonth);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDay;
	var _index = _interopRequireDefault(__webpack_require__(110));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	var _index5 = __webpack_require__(51);
	/**
	 * @name setDay
	 * @category Weekday Helpers
	 * @summary Set the day of the week to the given date.
	 *
	 * @description
	 * Set the day of the week to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @returns {Date} the new date with the day of the week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 *
	 * @example
	 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
	 * const result = setDay(new Date(2014, 8, 1), 0)
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Set week day to Sunday, with a weekStartsOn of Monday:
	 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setDay(dirtyDate, dirtyDay, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index4.default)(2, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
	
	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index3.default)(dirtyDay);
	  var currentDay = date.getDay();
	  var remainder = day % 7;
	  var dayIndex = (remainder + 7) % 7;
	  var delta = 7 - weekStartsOn;
	  var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
	  return (0, _index.default)(date, diff);
	}
	module.exports = exports.default;

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDayOfYear;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setDayOfYear
	 * @category Day Helpers
	 * @summary Set the day of the year to the given date.
	 *
	 * @description
	 * Set the day of the year to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} dayOfYear - the day of the year of the new date
	 * @returns {Date} the new date with the day of the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd day of the year to 2 July 2014:
	 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
	 * //=> Thu Jan 02 2014 00:00:00
	 */
	function setDayOfYear(dirtyDate, dirtyDayOfYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var dayOfYear = (0, _index.default)(dirtyDayOfYear);
	  date.setMonth(0);
	  date.setDate(dayOfYear);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setDefaultOptions;
	var _index = __webpack_require__(51);
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setDefaultOptions
	 * @category Common Helpers
	 * @summary Set default options including locale.
	 * @pure false
	 *
	 * @description
	 * Sets the defaults for
	 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
	 * arguments for all functions.
	 *
	 * @param {Object} newOptions - an object with options.
	 * @param {Locale} [newOptions.locale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [newOptions.weekStartsOn] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [newOptions.firstWeekContainsDate] - the day of January, which is always in the first week of the year
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Set global locale:
	 * import { es } from 'date-fns/locale'
	 * setDefaultOptions({ locale: es })
	 * const result = format(new Date(2014, 8, 2), 'PPPP')
	 * //=> 'martes, 2 de septiembre de 2014'
	 *
	 * @example
	 * // Start of the week for 2 September 2014:
	 * const result = startOfWeek(new Date(2014, 8, 2))
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Start of the week for 2 September 2014,
	 * // when we set that week starts on Monday by default:
	 * setDefaultOptions({ weekStartsOn: 1 })
	 * const result = startOfWeek(new Date(2014, 8, 2))
	 * //=> Mon Sep 01 2014 00:00:00
	 *
	 * @example
	 * // Manually set options take priority over default options:
	 * setDefaultOptions({ weekStartsOn: 1 })
	 * const result = startOfWeek(new Date(2014, 8, 2), { weekStartsOn: 0 })
	 * //=> Sun Aug 31 2014 00:00:00
	 *
	 * @example
	 * // Remove the option by setting it to `undefined`:
	 * setDefaultOptions({ weekStartsOn: 1 })
	 * setDefaultOptions({ weekStartsOn: undefined })
	 * const result = startOfWeek(new Date(2014, 8, 2))
	 * //=> Sun Aug 31 2014 00:00:00
	 */
	function setDefaultOptions(newOptions) {
	  (0, _index2.default)(1, arguments);
	  var result = {};
	  var defaultOptions = (0, _index.getDefaultOptions)();
	  for (var property in defaultOptions) {
	    if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) {
	      ;
	      result[property] = defaultOptions[property];
	    }
	  }
	  for (var _property in newOptions) {
	    if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
	      if (newOptions[_property] === undefined) {
	        delete result[_property];
	      } else {
	        ;
	        result[_property] = newOptions[_property];
	      }
	    }
	  }
	  (0, _index.setDefaultOptions)(result);
	}
	module.exports = exports.default;

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setHours;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setHours
	 * @category Hour Helpers
	 * @summary Set the hours to the given date.
	 *
	 * @description
	 * Set the hours to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} hours - the hours of the new date
	 * @returns {Date} the new date with the hours set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 4 hours to 1 September 2014 11:30:00:
	 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
	 * //=> Mon Sep 01 2014 04:30:00
	 */
	function setHours(dirtyDate, dirtyHours) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var hours = (0, _index.default)(dirtyHours);
	  date.setHours(hours);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISODay;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(110));
	var _index4 = _interopRequireDefault(__webpack_require__(644));
	var _index5 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setISODay
	 * @category Weekday Helpers
	 * @summary Set the day of the ISO week to the given date.
	 *
	 * @description
	 * Set the day of the ISO week to the given date.
	 * ISO week starts with Monday.
	 * 7 is the index of Sunday, 1 is the index of Monday etc.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} day - the day of the ISO week of the new date
	 * @returns {Date} the new date with the day of the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set Sunday to 1 September 2014:
	 * const result = setISODay(new Date(2014, 8, 1), 7)
	 * //=> Sun Sep 07 2014 00:00:00
	 */
	function setISODay(dirtyDate, dirtyDay) {
	  (0, _index5.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var day = (0, _index.default)(dirtyDay);
	  var currentDay = (0, _index4.default)(date);
	  var diff = day - currentDay;
	  return (0, _index3.default)(date, diff);
	}
	module.exports = exports.default;

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setISOWeek;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(645));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setISOWeek
	 * @category ISO Week Helpers
	 * @summary Set the ISO week to the given date.
	 *
	 * @description
	 * Set the ISO week to the given date, saving the weekday number.
	 *
	 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} isoWeek - the ISO week of the new date
	 * @returns {Date} the new date with the ISO week set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 53rd ISO week to 7 August 2004:
	 * const result = setISOWeek(new Date(2004, 7, 7), 53)
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setISOWeek(dirtyDate, dirtyISOWeek) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var isoWeek = (0, _index.default)(dirtyISOWeek);
	  var diff = (0, _index3.default)(date) - isoWeek;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMilliseconds;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setMilliseconds
	 * @category Millisecond Helpers
	 * @summary Set the milliseconds to the given date.
	 *
	 * @description
	 * Set the milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} milliseconds - the milliseconds of the new date
	 * @returns {Date} the new date with the milliseconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
	 * const result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
	 * //=> Mon Sep 01 2014 11:30:40.300
	 */
	function setMilliseconds(dirtyDate, dirtyMilliseconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var milliseconds = (0, _index.default)(dirtyMilliseconds);
	  date.setMilliseconds(milliseconds);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setMinutes;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setMinutes
	 * @category Minute Helpers
	 * @summary Set the minutes to the given date.
	 *
	 * @description
	 * Set the minutes to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} minutes - the minutes of the new date
	 * @returns {Date} the new date with the minutes set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 minutes to 1 September 2014 11:30:40:
	 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:45:40
	 */
	function setMinutes(dirtyDate, dirtyMinutes) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var minutes = (0, _index.default)(dirtyMinutes);
	  date.setMinutes(minutes);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setQuarter;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(399));
	var _index4 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setQuarter
	 * @category Quarter Helpers
	 * @summary Set the year quarter to the given date.
	 *
	 * @description
	 * Set the year quarter to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} quarter - the quarter of the new date
	 * @returns {Date} the new date with the quarter set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set the 2nd quarter to 2 July 2014:
	 * const result = setQuarter(new Date(2014, 6, 2), 2)
	 * //=> Wed Apr 02 2014 00:00:00
	 */
	function setQuarter(dirtyDate, dirtyQuarter) {
	  (0, _index4.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var quarter = (0, _index.default)(dirtyQuarter);
	  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
	  var diff = quarter - oldQuarter;
	  return (0, _index3.default)(date, date.getMonth() + diff * 3);
	}
	module.exports = exports.default;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setSeconds;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setSeconds
	 * @category Second Helpers
	 * @summary Set the seconds to the given date.
	 *
	 * @description
	 * Set the seconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} seconds - the seconds of the new date
	 * @returns {Date} the new date with the seconds set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set 45 seconds to 1 September 2014 11:30:40:
	 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
	 * //=> Mon Sep 01 2014 11:30:45
	 */
	function setSeconds(dirtyDate, dirtySeconds) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var seconds = (0, _index.default)(dirtySeconds);
	  date.setSeconds(seconds);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeek;
	var _index = _interopRequireDefault(__webpack_require__(648));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var _index4 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name setWeek
	 * @category Week Helpers
	 * @summary Set the local week to the given date.
	 *
	 * @description
	 * Set the local week to the given date, saving the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} week - the week of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005 with default options:
	 * const result = setWeek(new Date(2005, 0, 2), 1)
	 * //=> Sun Dec 26 2004 00:00:00
	 *
	 * @example
	 * // Set the 1st week to 2 January 2005,
	 * // if Monday is the first day of the week,
	 * // and the first week of the year always contains 4 January:
	 * const result = setWeek(new Date(2005, 0, 2), 1, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sun Jan 4 2004 00:00:00
	 */
	function setWeek(dirtyDate, dirtyWeek, options) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var week = (0, _index4.default)(dirtyWeek);
	  var diff = (0, _index.default)(date, options) - week;
	  date.setDate(date.getDate() - diff * 7);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setWeekYear;
	var _index = _interopRequireDefault(__webpack_require__(127));
	var _index2 = _interopRequireDefault(__webpack_require__(402));
	var _index3 = _interopRequireDefault(__webpack_require__(6));
	var _index4 = _interopRequireDefault(__webpack_require__(12));
	var _index5 = _interopRequireDefault(__webpack_require__(5));
	var _index6 = __webpack_require__(51);
	/**
	 * @name setWeekYear
	 * @category Week-Numbering Year Helpers
	 * @summary Set the local week-numbering year to the given date.
	 *
	 * @description
	 * Set the local week-numbering year to the given date,
	 * saving the week number and the weekday number.
	 * The exact calculation depends on the values of
	 * `options.weekStartsOn` (which is the index of the first day of the week)
	 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
	 * the first week of the week-numbering year)
	 *
	 * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} weekYear - the local week-numbering year of the new date
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
	 * @returns {Date} the new date with the local week-numbering year set
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
	 * const result = setWeekYear(new Date(2010, 0, 2), 2004)
	 * //=> Sat Jan 03 2004 00:00:00
	 *
	 * @example
	 * // Set the local week-numbering year 2004 to 2 January 2010,
	 * // if Monday is the first day of week
	 * // and 4 January is always in the first week of the year:
	 * const result = setWeekYear(new Date(2010, 0, 2), 2004, {
	 *   weekStartsOn: 1,
	 *   firstWeekContainsDate: 4
	 * })
	 * //=> Sat Jan 01 2005 00:00:00
	 */
	function setWeekYear(dirtyDate, dirtyWeekYear, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index5.default)(2, arguments);
	  var defaultOptions = (0, _index6.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var date = (0, _index3.default)(dirtyDate);
	  var weekYear = (0, _index4.default)(dirtyWeekYear);
	  var diff = (0, _index.default)(date, (0, _index2.default)(date, options));
	  var firstWeek = new Date(0);
	  firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
	  firstWeek.setHours(0, 0, 0, 0);
	  date = (0, _index2.default)(firstWeek, options);
	  date.setDate(date.getDate() + diff);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setYear;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(6));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name setYear
	 * @category Year Helpers
	 * @summary Set the year to the given date.
	 *
	 * @description
	 * Set the year to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} year - the year of the new date
	 * @returns {Date} the new date with the year set
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Set year 2013 to 1 September 2014:
	 * const result = setYear(new Date(2014, 8, 1), 2013)
	 * //=> Sun Sep 01 2013 00:00:00
	 */
	function setYear(dirtyDate, dirtyYear) {
	  (0, _index3.default)(2, arguments);
	  var date = (0, _index2.default)(dirtyDate);
	  var year = (0, _index.default)(dirtyYear);
	
	  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
	  if (isNaN(date.getTime())) {
	    return new Date(NaN);
	  }
	  date.setFullYear(year);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfDecade;
	var _index = _interopRequireDefault(__webpack_require__(6));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name startOfDecade
	 * @category Decade Helpers
	 * @summary Return the start of a decade for the given date.
	 *
	 * @description
	 * Return the start of a decade for the given date.
	 *
	 * @param {Date|Number} date - the original date
	 * @returns {Date} the start of a decade
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // The start of a decade for 21 October 2015 00:00:00:
	 * const result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
	 * //=> Jan 01 2010 00:00:00
	 */
	function startOfDecade(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getFullYear();
	  var decade = Math.floor(year / 10) * 10;
	  date.setFullYear(decade, 0, 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfToday;
	var _index = _interopRequireDefault(__webpack_require__(278));
	/**
	 * @name startOfToday
	 * @category Day Helpers
	 * @summary Return the start of today.
	 * @pure false
	 *
	 * @description
	 * Return the start of today.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `Date.now()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the start of today
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfToday()
	 * //=> Mon Oct 6 2014 00:00:00
	 */
	function startOfToday() {
	  return (0, _index.default)(Date.now());
	}
	module.exports = exports.default;

/***/ },
/* 1756 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfTomorrow;
	/**
	 * @name startOfTomorrow
	 * @category Day Helpers
	 * @summary Return the start of tomorrow.
	 * @pure false
	 *
	 * @description
	 * Return the start of tomorrow.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the start of tomorrow
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfTomorrow()
	 * //=> Tue Oct 7 2014 00:00:00
	 */
	function startOfTomorrow() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day + 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1757 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfYesterday;
	/**
	 * @name startOfYesterday
	 * @category Day Helpers
	 * @summary Return the start of yesterday.
	 * @pure false
	 *
	 * @description
	 * Return the start of yesterday.
	 *
	 * > ⚠️ Please note that this function is not present in the FP submodule as
	 * > it uses `new Date()` internally hence impure and can't be safely curried.
	 *
	 * @returns {Date} the start of yesterday
	 *
	 * @example
	 * // If today is 6 October 2014:
	 * const result = startOfYesterday()
	 * //=> Sun Oct 5 2014 00:00:00
	 */
	function startOfYesterday() {
	  var now = new Date();
	  var year = now.getFullYear();
	  var month = now.getMonth();
	  var day = now.getDate();
	  var date = new Date(0);
	  date.setFullYear(year, month, day - 1);
	  date.setHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default;

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sub;
	var _typeof2 = _interopRequireDefault(__webpack_require__(84));
	var _index = _interopRequireDefault(__webpack_require__(280));
	var _index2 = _interopRequireDefault(__webpack_require__(671));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	var _index4 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name sub
	 * @category Common Helpers
	 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @description
	 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
	 *
	 * | Key     | Description                        |
	 * |---------|------------------------------------|
	 * | years   | Amount of years to be subtracted   |
	 * | months  | Amount of months to be subtracted  |
	 * | weeks   | Amount of weeks to be subtracted   |
	 * | days    | Amount of days to be subtracted    |
	 * | hours   | Amount of hours to be subtracted   |
	 * | minutes | Amount of minutes to be subtracted |
	 * | seconds | Amount of seconds to be subtracted |
	 *
	 * All values default to 0
	 *
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract the following duration from 15 June 2017 15:29:20
	 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
	 *   years: 2,
	 *   months: 9,
	 *   weeks: 1,
	 *   days: 7,
	 *   hours: 5,
	 *   minutes: 9,
	 *   seconds: 30
	 * })
	 * //=> Mon Sep 1 2014 10:19:50
	 */
	function sub(date, duration) {
	  (0, _index3.default)(2, arguments);
	  if (!duration || (0, _typeof2.default)(duration) !== 'object') return new Date(NaN);
	  var years = duration.years ? (0, _index4.default)(duration.years) : 0;
	  var months = duration.months ? (0, _index4.default)(duration.months) : 0;
	  var weeks = duration.weeks ? (0, _index4.default)(duration.weeks) : 0;
	  var days = duration.days ? (0, _index4.default)(duration.days) : 0;
	  var hours = duration.hours ? (0, _index4.default)(duration.hours) : 0;
	  var minutes = duration.minutes ? (0, _index4.default)(duration.minutes) : 0;
	  var seconds = duration.seconds ? (0, _index4.default)(duration.seconds) : 0;
	
	  // Subtract years and months
	  var dateWithoutMonths = (0, _index2.default)(date, months + years * 12);
	
	  // Subtract weeks and days
	  var dateWithoutDays = (0, _index.default)(dateWithoutMonths, days + weeks * 7);
	
	  // Subtract hours, minutes and seconds
	  var minutestoSub = minutes + hours * 60;
	  var secondstoSub = seconds + minutestoSub * 60;
	  var mstoSub = secondstoSub * 1000;
	  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
	  return finalDate;
	}
	module.exports = exports.default;

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subBusinessDays;
	var _index = _interopRequireDefault(__webpack_require__(630));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name subBusinessDays
	 * @category Day Helpers
	 * @summary Substract the specified number of business days (mon - fri) to the given date.
	 *
	 * @description
	 * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the business days subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Substract 10 business days from 1 September 2014:
	 * const result = subBusinessDays(new Date(2014, 8, 1), 10)
	 * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
	 */
	function subBusinessDays(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subHours;
	var _index = _interopRequireDefault(__webpack_require__(384));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name subHours
	 * @category Hour Helpers
	 * @summary Subtract the specified number of hours from the given date.
	 *
	 * @description
	 * Subtract the specified number of hours from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the hours subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 2 hours from 11 July 2014 01:00:00:
	 * const result = subHours(new Date(2014, 6, 11, 1, 0), 2)
	 * //=> Thu Jul 10 2014 23:00:00
	 */
	function subHours(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMinutes;
	var _index = _interopRequireDefault(__webpack_require__(385));
	var _index2 = _interopRequireDefault(__webpack_require__(5));
	var _index3 = _interopRequireDefault(__webpack_require__(12));
	/**
	 * @name subMinutes
	 * @category Minute Helpers
	 * @summary Subtract the specified number of minutes from the given date.
	 *
	 * @description
	 * Subtract the specified number of minutes from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the minutes subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 minutes from 10 July 2014 12:00:00:
	 * const result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
	 * //=> Thu Jul 10 2014 11:30:00
	 */
	function subMinutes(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subQuarters;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(386));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name subQuarters
	 * @category Quarter Helpers
	 * @summary Subtract the specified number of year quarters from the given date.
	 *
	 * @description
	 * Subtract the specified number of year quarters from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the quarters subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 3 quarters from 1 September 2014:
	 * const result = subQuarters(new Date(2014, 8, 1), 3)
	 * //=> Sun Dec 01 2013 00:00:00
	 */
	function subQuarters(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subSeconds;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(632));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name subSeconds
	 * @category Second Helpers
	 * @summary Subtract the specified number of seconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of seconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the seconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 30 seconds from 10 July 2014 12:45:00:
	 * const result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
	 * //=> Thu Jul 10 2014 12:44:30
	 */
	function subSeconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subWeeks;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(272));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name subWeeks
	 * @category Week Helpers
	 * @summary Subtract the specified number of weeks from the given date.
	 *
	 * @description
	 * Subtract the specified number of weeks from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the weeks subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 4 weeks from 1 September 2014:
	 * const result = subWeeks(new Date(2014, 8, 1), 4)
	 * //=> Mon Aug 04 2014 00:00:00
	 */
	function subWeeks(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subYears;
	var _index = _interopRequireDefault(__webpack_require__(12));
	var _index2 = _interopRequireDefault(__webpack_require__(633));
	var _index3 = _interopRequireDefault(__webpack_require__(5));
	/**
	 * @name subYears
	 * @category Year Helpers
	 * @summary Subtract the specified number of years from the given date.
	 *
	 * @description
	 * Subtract the specified number of years from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the years subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 5 years from 1 September 2014:
	 * const result = subYears(new Date(2014, 8, 1), 5)
	 * //=> Tue Sep 01 2009 00:00:00
	 */
	function subYears(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var amount = (0, _index.default)(dirtyAmount);
	  return (0, _index2.default)(dirtyDate, -amount);
	}
	module.exports = exports.default;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = weeksToDays;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name weeksToDays
	 * @category Conversion Helpers
	 * @summary Convert weeks to days.
	 *
	 * @description
	 * Convert a number of weeks to a full number of days.
	 *
	 * @param {number} weeks - number of weeks to be converted
	 *
	 * @returns {number} the number of weeks converted in days
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 weeks into days
	 * const result = weeksToDays(2)
	 * //=> 14
	 */
	function weeksToDays(weeks) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(weeks * _index2.daysInWeek);
	}
	module.exports = exports.default;

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToMonths;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name yearsToMonths
	 * @category Conversion Helpers
	 * @summary Convert years to months.
	 *
	 * @description
	 * Convert a number of years to a full number of months.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in months
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years into months
	 * const result = yearsToMonths(2)
	 * //=> 24
	 */
	function yearsToMonths(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.monthsInYear);
	}
	module.exports = exports.default;

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3).default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = yearsToQuarters;
	var _index = _interopRequireDefault(__webpack_require__(5));
	var _index2 = __webpack_require__(42);
	/**
	 * @name yearsToQuarters
	 * @category Conversion Helpers
	 * @summary Convert years to quarters.
	 *
	 * @description
	 * Convert a number of years to a full number of quarters.
	 *
	 * @param {number} years - number of years to be converted
	 *
	 * @returns {number} the number of years converted in quarters
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Convert 2 years to quarters
	 * const result = yearsToQuarters(2)
	 * //=> 8
	 */
	function yearsToQuarters(years) {
	  (0, _index.default)(1, arguments);
	  return Math.floor(years * _index2.quartersInYear);
	}
	module.exports = exports.default;

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.deepmerge = factory());
	}(this, (function () { 'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
		return Array.isArray(val) ? [] : {}
	}
	
	function cloneUnlessOtherwiseSpecified(value, options) {
		return (options.clone !== false && options.isMergeableObject(value))
			? deepmerge(emptyTarget(value), value, options)
			: value
	}
	
	function defaultArrayMerge(target, source, options) {
		return target.concat(source).map(function(element) {
			return cloneUnlessOtherwiseSpecified(element, options)
		})
	}
	
	function mergeObject(target, source, options) {
		var destination = {};
		if (options.isMergeableObject(target)) {
			Object.keys(target).forEach(function(key) {
				destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
			});
		}
		Object.keys(source).forEach(function(key) {
			if (!options.isMergeableObject(source[key]) || !target[key]) {
				destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
			} else {
				destination[key] = deepmerge(target[key], source[key], options);
			}
		});
		return destination
	}
	
	function deepmerge(target, source, options) {
		options = options || {};
		options.arrayMerge = options.arrayMerge || defaultArrayMerge;
		options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	
		var sourceIsArray = Array.isArray(source);
		var targetIsArray = Array.isArray(target);
		var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
		if (!sourceAndTargetTypesMatch) {
			return cloneUnlessOtherwiseSpecified(source, options)
		} else if (sourceIsArray) {
			return options.arrayMerge(target, source, options)
		} else {
			return mergeObject(target, source, options)
		}
	}
	
	deepmerge.all = function deepmergeAll(array, options) {
		if (!Array.isArray(array)) {
			throw new Error('first argument should be an array')
		}
	
		return array.reduce(function(prev, next) {
			return deepmerge(prev, next, options)
		}, {})
	};
	
	var deepmerge_1 = deepmerge;
	
	return deepmerge_1;
	
	})));


/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(3);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1771));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 1771 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 1772 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 1773 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 1774 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 1775 */
1774,
/* 1776 */
1774,
/* 1777 */
1774,
/* 1778 */
1774,
/* 1779 */
1774,
/* 1780 */
1774,
/* 1781 */
1774,
/* 1782 */
1774,
/* 1783 */
1774,
/* 1784 */
1774,
/* 1785 */
1774,
/* 1786 */
1774,
/* 1787 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(1787);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function e(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var t,n=__webpack_require__(2034),r=__webpack_require__(1),i=e(__webpack_require__(1980)),o=e(__webpack_require__(1769)),a=e(__webpack_require__(1791)),s=e(__webpack_require__(1559)),u=e(__webpack_require__(2033)),l=e(__webpack_require__(1938)),d=e(__webpack_require__(1963)),p=e(__webpack_require__(1939)),c=(t=s({})).Provider,h=t.Consumer;function m(e){var t=function(t){return r.createElement(h,null,function(i){return r.createElement(e,n.__assign({},t,{formik:i}))})},i=e.displayName||e.name||e.constructor&&e.constructor.name||"Component";return t.WrappedComponent=e,t.displayName="FormikConnect("+i+")",a(t,e)}var f=function(e){return"function"==typeof e},v=function(e){return null!==e&&"object"==typeof e},F=function(e){return String(Math.floor(Number(e)))===e},g=function(e){return"[object String]"===Object.prototype.toString.call(e)},S=function(e){return e!=e},_=function(e){return 0===r.Children.count(e)},y=function(e){return v(e)&&f(e.then)},k=function(e){return e&&v(e)&&v(e.target)};function b(e){var t=!1;return[new Promise(function(n,r){e.then(function(e){return t?r({isCanceled:!0}):n(e)},function(e){return r(t?{isCanceled:!0}:e)})}),function(){t=!0}]}function C(e,t,n,r){void 0===r&&(r=0);for(var i=d(t);e&&r<i.length;)e=e[i[r++]];return void 0===e?n:e}function V(e,t,n){for(var r=l(e),i=r,o=0,a=d(t);o<a.length-1;o++){var s=a[o],u=C(e,a.slice(0,o+1));if(u)i=i[s]=l(u);else{var p=a[o+1];i=i[s]=F(p)&&Number(p)>=0?[]:{}}}return(0===o?e:i)[a[o]]===n?e:(void 0===n?delete i[a[o]]:i[a[o]]=n,0===o&&void 0===n&&delete r[a[o]],r)}function x(e,t,n,r){void 0===n&&(n=new WeakMap),void 0===r&&(r={});for(var i=0,o=Object.keys(e);i<o.length;i++){var a=o[i],s=e[a];v(s)?n.get(s)||(n.set(s,!0),r[a]=Array.isArray(s)?[]:{},x(s,t,n,r[a])):r[a]=t}return r}var E=function(e){function t(t){var r=e.call(this,t)||this;return r.hcCache={},r.hbCache={},r.registerField=function(e,t){r.fields[e]=t},r.unregisterField=function(e){delete r.fields[e]},r.setErrors=function(e){r.setState({errors:e})},r.setTouched=function(e){r.setState({touched:e},function(){r.props.validateOnBlur&&r.runValidations(r.state.values)})},r.setValues=function(e){r.setState({values:e},function(){r.props.validateOnChange&&r.runValidations(e)})},r.setStatus=function(e){r.setState({status:e})},r.setError=function(e){r.setState({error:e})},r.setSubmitting=function(e){r.didMount&&r.setState({isSubmitting:e})},r.validateField=function(e){return r.setState({isValidating:!0}),r.runSingleFieldLevelValidation(e,C(r.state.values,e)).then(function(t){return r.didMount&&r.setState({errors:V(r.state.errors,e,t),isValidating:!1}),t})},r.runSingleFieldLevelValidation=function(e,t){return new Promise(function(n){return n(r.fields[e].props.validate(t))}).then(function(e){return e},function(e){return e})},r.runValidationSchema=function(e){return new Promise(function(t){var n=r.props.validationSchema,i=f(n)?n():n;P(e,i).then(function(){t({})},function(e){t(O(e))})})},r.runValidations=function(e){void 0===e&&(e=r.state.values),r.validator&&r.validator();var t=b(Promise.all([r.runFieldLevelValidations(e),r.props.validationSchema?r.runValidationSchema(e):{},r.props.validate?r.runValidateHandler(e):{}]).then(function(e){return o.all([e[0],e[1],e[2]],{arrayMerge:w})})),n=t[0];return r.validator=t[1],n.then(function(e){return r.didMount&&r.setState(function(t){return i(t.errors,e)?null:{errors:e}}),e}).catch(function(e){return e})},r.handleChange=function(e){var t=function(e,t){var i,o=t;if(k(e)){var a=e;a.persist&&a.persist();var s=a.target,u=s.type,l=s.name,d=s.checked;if(o=t||(l||s.id),i=a.target.value,/number|range/.test(u)){var p=parseFloat(a.target.value);i=S(p)?"":p}/checkbox/.test(u)&&(i=d)}else i=e;o&&r.setState(function(e){return n.__assign({},e,{values:V(e.values,o,i)})},function(){r.props.validateOnChange&&r.runValidations(V(r.state.values,o,i))})};if(g(e)){var i=e;return f(r.hcCache[i])||(r.hcCache[i]=function(e){return t(e,i)}),r.hcCache[i]}t(e)},r.setFieldValue=function(e,t,i){void 0===i&&(i=!0),r.didMount&&r.setState(function(r){return n.__assign({},r,{values:V(r.values,e,t)})},function(){r.props.validateOnChange&&i&&r.runValidations(r.state.values)})},r.handleSubmit=function(e){e&&e.preventDefault&&e.preventDefault(),r.submitForm()},r.submitForm=function(){return r.setState(function(e){return{touched:x(e.values,!0),isSubmitting:!0,isValidating:!0,submitCount:e.submitCount+1}}),r.runValidations(r.state.values).then(function(e){r.didMount&&r.setState({isValidating:!1}),0===Object.keys(e).length?r.executeSubmit():r.didMount&&r.setState({isSubmitting:!1})})},r.executeSubmit=function(){r.props.onSubmit(r.state.values,r.getFormikActions())},r.handleBlur=function(e){var t=function(e,t){var n=t;if(k(e)){var i=e;i.persist&&i.persist();var o=i.target,a=o.name;n=a||o.id}r.setState(function(e){return{touched:V(e.touched,n,!0)}}),r.props.validateOnBlur&&r.runValidations(r.state.values)};if(g(e)){var n=e;return f(r.hbCache[n])||(r.hbCache[n]=function(e){return t(e,n)}),r.hbCache[n]}t(e)},r.setFieldTouched=function(e,t,i){void 0===t&&(t=!0),void 0===i&&(i=!0),r.setState(function(r){return n.__assign({},r,{touched:V(r.touched,e,t)})},function(){r.props.validateOnBlur&&i&&r.runValidations(r.state.values)})},r.setFieldError=function(e,t){r.setState(function(r){return n.__assign({},r,{errors:V(r.errors,e,t)})})},r.resetForm=function(e){var t=e||r.props.initialValues;r.initialValues=t,r.setState({isSubmitting:!1,isValidating:!1,errors:{},touched:{},error:void 0,status:r.props.initialStatus,values:t,submitCount:0})},r.handleReset=function(){if(r.props.onReset){var e=r.props.onReset(r.state.values,r.getFormikActions());y(e)?e.then(r.resetForm):r.resetForm()}else r.resetForm()},r.setFormikState=function(e,t){return r.setState(e,t)},r.validateForm=function(e){return r.setState({isValidating:!0}),r.runValidations(e).then(function(e){return r.didMount&&r.setState({isValidating:!1}),e})},r.getFormikActions=function(){return{resetForm:r.resetForm,submitForm:r.submitForm,validateForm:r.validateForm,validateField:r.validateField,setError:r.setError,setErrors:r.setErrors,setFieldError:r.setFieldError,setFieldTouched:r.setFieldTouched,setFieldValue:r.setFieldValue,setStatus:r.setStatus,setSubmitting:r.setSubmitting,setTouched:r.setTouched,setValues:r.setValues,setFormikState:r.setFormikState}},r.getFormikComputedProps=function(){var e=r.props.isInitialValid,t=!i(r.initialValues,r.state.values);return{dirty:t,isValid:t?r.state.errors&&0===Object.keys(r.state.errors).length:!1!==e&&f(e)?e(r.props):e,initialValues:r.initialValues}},r.getFormikBag=function(){return n.__assign({},r.state,r.getFormikActions(),r.getFormikComputedProps(),{registerField:r.registerField,unregisterField:r.unregisterField,handleBlur:r.handleBlur,handleChange:r.handleChange,handleReset:r.handleReset,handleSubmit:r.handleSubmit,validateOnChange:r.props.validateOnChange,validateOnBlur:r.props.validateOnBlur})},r.getFormikContext=function(){return n.__assign({},r.getFormikBag(),{validationSchema:r.props.validationSchema,validate:r.props.validate,initialValues:r.initialValues})},r.state={values:t.initialValues||{},errors:{},touched:{},isSubmitting:!1,isValidating:!1,submitCount:0,status:t.initialStatus},r.didMount=!1,r.fields={},r.initialValues=t.initialValues||{},u(!(t.component&&t.render),"You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored"),u(!(t.component&&t.children&&!_(t.children)),"You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored"),u(!(t.render&&t.children&&!_(t.children)),"You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored"),r}return n.__extends(t,e),t.prototype.componentDidMount=function(){this.didMount=!0},t.prototype.componentWillUnmount=function(){this.didMount=!1,this.validator&&this.validator()},t.prototype.componentDidUpdate=function(e){this.props.enableReinitialize&&!i(e.initialValues,this.props.initialValues)&&(this.initialValues=this.props.initialValues,this.resetForm(this.props.initialValues))},t.prototype.runFieldLevelValidations=function(e){var t=this,n=Object.keys(this.fields).filter(function(e){return t.fields&&t.fields[e]&&t.fields[e].props.validate&&f(t.fields[e].props.validate)}),r=n.length>0?n.map(function(n){return t.runSingleFieldLevelValidation(n,C(e,n))}):[Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];return Promise.all(r).then(function(e){return e.reduce(function(e,t,r){return"DO_NOT_DELETE_YOU_WILL_BE_FIRED"===t?e:(t&&(e=V(e,n[r],t)),e)},{})})},t.prototype.runValidateHandler=function(e){var t=this;return new Promise(function(n){var r=t.props.validate(e);void 0===r?n({}):y(r)?r.then(function(){n({})},function(e){n(e)}):n(r)})},t.prototype.render=function(){var e=this.props,t=e.component,n=e.render,i=e.children,o=this.getFormikBag(),a=this.getFormikContext();return r.createElement(c,{value:a},t?r.createElement(t,o):n?n(o):i?f(i)?i(o):_(i)?null:r.Children.only(i):null)},t.defaultProps={validateOnChange:!0,validateOnBlur:!0,isInitialValid:!1,enableReinitialize:!1},t}(r.Component);function O(e){var t={};if(0===e.inner.length)return V(t,e.path,e.message);for(var n=0,r=e.inner;n<r.length;n++){var i=r[n];t[i.path]||(t=V(t,i.path,i.message))}return t}function P(e,t,n,r){void 0===n&&(n=!1),void 0===r&&(r={});var i={};for(var o in e)if(e.hasOwnProperty(o)){var a=String(o);i[a]=""!==e[a]?e[a]:void 0}return t[n?"validateSync":"validate"](i,{abortEarly:!1,context:r})}function w(e,t,n){var r=e.slice();return t.forEach(function(t,i){if(void 0===r[i]){var a=!1!==n.clone&&n.isMergeableObject(t);r[i]=a?o(Array.isArray(t)?[]:{},t,n):t}else n.isMergeableObject(t)?r[i]=o(e[i],t,n):-1===e.indexOf(t)&&r.push(t)}),r}var M=m(function(e){function t(t){var n=e.call(this,t)||this,r=t.render,i=t.children,o=t.component;return u(!(o&&r),"You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored"),u(!(o&&i&&f(i)),"You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored."),u(!(r&&i&&!_(i)),"You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored"),n}return n.__extends(t,e),t.prototype.componentDidMount=function(){this.props.formik.registerField(this.props.name,this)},t.prototype.componentDidUpdate=function(e){this.props.name!==e.name&&(this.props.formik.unregisterField(e.name),this.props.formik.registerField(this.props.name,this)),this.props.validate!==e.validate&&this.props.formik.registerField(this.props.name,this)},t.prototype.componentWillUnmount=function(){this.props.formik.unregisterField(this.props.name)},t.prototype.render=function(){var e=this.props,t=e.name,i=e.render,o=e.children,a=e.component,s=void 0===a?"input":a,u=e.formik,l=n.__rest(e,["validate","name","render","children","component","formik"]),d=n.__rest(u,["validate","validationSchema"]),p={value:"radio"===l.type||"checkbox"===l.type?l.value:C(u.values,t),name:t,onChange:u.handleChange,onBlur:u.handleBlur},c={field:p,form:d};if(i)return i(c);if(f(o))return o(c);if("string"==typeof s){var h=l.innerRef,m=n.__rest(l,["innerRef"]);return r.createElement(s,n.__assign({ref:h},p,m,{children:o}))}return r.createElement(s,n.__assign({},c,l,{children:o}))},t}(r.Component)),R=m(function(e){var t=e.formik,i=t.handleReset,o=t.handleSubmit,a=n.__rest(e,["formik"]);return r.createElement("form",n.__assign({onReset:i,onSubmit:o},a))});R.displayName="Form";var A=function(e,t,n){var r=(e||[]).slice(),i=r[t];return r.splice(t,1),r.splice(n,0,i),r},B=function(e,t,n){var r=(e||[]).slice(),i=r[t];return r[t]=r[n],r[n]=i,r},j=function(e,t,n){var r=(e||[]).slice();return r.splice(t,0,n),r},U=function(e,t,n){var r=(e||[]).slice();return r[t]=n,r},D=m(function(e){function t(t){var r=e.call(this,t)||this;return r.updateArrayField=function(e,t,i){var o=r.props,a=o.name,s=o.validateOnChange,u=o.formik,l=u.validateForm;(0,u.setFormikState)(function(r){var o="function"==typeof i?i:e,s="function"==typeof t?t:e;return n.__assign({},r,{values:V(r.values,a,e(C(r.values,a))),errors:i?V(r.errors,a,o(C(r.errors,a))):r.errors,touched:t?V(r.touched,a,s(C(r.touched,a))):r.touched})},function(){s&&l()})},r.push=function(e){return r.updateArrayField(function(t){return(t||[]).concat([p(e)])},!1,!1)},r.handlePush=function(e){return function(){return r.push(e)}},r.swap=function(e,t){return r.updateArrayField(function(n){return B(n,e,t)},!0,!0)},r.handleSwap=function(e,t){return function(){return r.swap(e,t)}},r.move=function(e,t){return r.updateArrayField(function(n){return A(n,e,t)},!0,!0)},r.handleMove=function(e,t){return function(){return r.move(e,t)}},r.insert=function(e,t){return r.updateArrayField(function(n){return j(n,e,t)},function(t){return j(t,e,null)},function(t){return j(t,e,null)})},r.handleInsert=function(e,t){return function(){return r.insert(e,t)}},r.replace=function(e,t){return r.updateArrayField(function(n){return U(n,e,t)},!1,!1)},r.handleReplace=function(e,t){return function(){return r.replace(e,t)}},r.unshift=function(e){var t=-1;return r.updateArrayField(function(n){var r=n?[e].concat(n):[e];return t<0&&(t=r.length),r},function(e){var n=e?[null].concat(e):[null];return t<0&&(t=n.length),n},function(e){var n=e?[null].concat(e):[null];return t<0&&(t=n.length),n}),t},r.handleUnshift=function(e){return function(){return r.unshift(e)}},r.handleRemove=function(e){return function(){return r.remove(e)}},r.handlePop=function(){return function(){return r.pop()}},r.remove=r.remove.bind(r),r.pop=r.pop.bind(r),r}return n.__extends(t,e),t.prototype.remove=function(e){var t;return this.updateArrayField(function(n){var r=n?n.slice():[];return t||(t=r[e]),f(r.splice)&&r.splice(e,1),r},!0,!0),t},t.prototype.pop=function(){var e;return this.updateArrayField(function(t){var n=t;return e||(e=n&&n.pop&&n.pop()),n},!0,!0),e},t.prototype.render=function(){var e={push:this.push,pop:this.pop,swap:this.swap,move:this.move,insert:this.insert,replace:this.replace,unshift:this.unshift,remove:this.remove,handlePush:this.handlePush,handlePop:this.handlePop,handleSwap:this.handleSwap,handleMove:this.handleMove,handleInsert:this.handleInsert,handleReplace:this.handleReplace,handleUnshift:this.handleUnshift,handleRemove:this.handleRemove},t=this.props,i=t.component,o=t.render,a=t.children,s=t.name,u=t.formik,l=n.__rest(u,["validate","validationSchema"]),d=n.__assign({},e,{form:l,name:s});return i?r.createElement(i,d):o?o(d):a?"function"==typeof a?a(d):_(a)?null:r.Children.only(a):null},t.defaultProps={validateOnChange:!0},t}(r.Component)),T=m(function(e){function t(t){var n=e.call(this,t)||this,r=t.render,i=t.children,o=t.component;return u(!(o&&r),"You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored"),u(!(o&&i&&f(i)),"You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored."),u(!(r&&i&&!_(i)),"You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored"),n}return n.__extends(t,e),t.prototype.shouldComponentUpdate=function(e){return this.props.shouldUpdate?this.props.shouldUpdate(e,this.props):C(this.props.formik.values,this.props.name)!==C(e.formik.values,this.props.name)||C(this.props.formik.errors,this.props.name)!==C(e.formik.errors,this.props.name)||C(this.props.formik.touched,this.props.name)!==C(e.formik.touched,this.props.name)||Object.keys(this.props).length!==Object.keys(e).length||this.props.formik.isSubmitting!==e.formik.isSubmitting},t.prototype.componentDidMount=function(){this.props.formik.registerField(this.props.name,this)},t.prototype.componentDidUpdate=function(e){this.props.name!==e.name&&(this.props.formik.unregisterField(e.name),this.props.formik.registerField(this.props.name,this)),this.props.validate!==e.validate&&this.props.formik.registerField(this.props.name,this)},t.prototype.componentWillUnmount=function(){this.props.formik.unregisterField(this.props.name)},t.prototype.render=function(){var e=this.props,t=e.name,i=e.render,o=e.children,a=e.component,s=void 0===a?"input":a,u=e.formik,l=n.__rest(e,["validate","name","render","children","component","formik","shouldUpdate"]),d=n.__rest(u,["validate","validationSchema"]),p={value:"radio"===l.type||"checkbox"===l.type?l.value:C(u.values,t),name:t,onChange:u.handleChange,onBlur:u.handleBlur},c={field:p,form:d};if(i)return i(c);if(f(o))return o(c);if("string"==typeof s){var h=l.innerRef,m=n.__rest(l,["innerRef"]);return r.createElement(s,n.__assign({ref:h},p,m,{children:o}))}return r.createElement(s,n.__assign({},c,l,{children:o}))},t}(r.Component)),I=m(function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return n.__extends(t,e),t.prototype.shouldComponentUpdate=function(e){return C(this.props.formik.errors,this.props.name)!==C(e.formik.errors,this.props.name)||C(this.props.formik.touched,this.props.name)!==C(e.formik.touched,this.props.name)||Object.keys(this.props).length!==Object.keys(e).length},t.prototype.render=function(){var e=this.props,t=e.component,i=e.formik,o=e.render,a=e.children,s=e.name,u=n.__rest(e,["component","formik","render","children","name"]),l=C(i.touched,s),d=C(i.errors,s);return l&&d?o?f(o)?o(d):null:a?f(a)?a(d):null:t?r.createElement(t,u,d):d:null},t}(r.Component));exports.Formik=E,exports.yupToFormErrors=O,exports.validateYupSchema=P,exports.Field=M,exports.Form=R,exports.withFormik=function(e){var t=e.mapPropsToValues,i=void 0===t?function(e){var t={};for(var n in e)e.hasOwnProperty(n)&&"function"!=typeof e[n]&&(t[n]=e[n]);return t}:t,o=n.__rest(e,["mapPropsToValues"]);return function(e){var t=e.displayName||e.name||e.constructor&&e.constructor.name||"Component",s=function(a){function s(){var t=null!==a&&a.apply(this,arguments)||this;return t.validate=function(e){return o.validate(e,t.props)},t.validationSchema=function(){return f(o.validationSchema)?o.validationSchema(t.props):o.validationSchema},t.handleSubmit=function(e,r){return o.handleSubmit(e,n.__assign({},r,{props:t.props}))},t.renderFormComponent=function(i){return r.createElement(e,n.__assign({},t.props,i))},t}return n.__extends(s,a),s.prototype.render=function(){var e=this.props,t=n.__rest(e,["children"]);return r.createElement(E,n.__assign({},t,o,{validate:o.validate&&this.validate,validationSchema:o.validationSchema&&this.validationSchema,initialValues:i(this.props),initialStatus:o.mapPropsToStatus&&o.mapPropsToStatus(this.props),onSubmit:this.handleSubmit,render:this.renderFormComponent}))},s.displayName="WithFormik("+t+")",s}(r.Component);return a(s,e)}},exports.move=A,exports.swap=B,exports.insert=j,exports.replace=U,exports.FieldArray=D,exports.isFunction=f,exports.isObject=v,exports.isInteger=F,exports.isString=g,exports.isNaN=S,exports.isEmptyChildren=_,exports.isPromise=y,exports.isInputEvent=k,exports.getActiveElement=function(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}},exports.makeCancelable=b,exports.getIn=C,exports.setIn=V,exports.setNestedObjectValues=x,exports.FastField=T,exports.FormikProvider=c,exports.FormikConsumer=h,exports.connect=m,exports.ErrorMessage=I;
	//# sourceMappingURL=formik.cjs.production.js.map


/***/ },
/* 1790 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(1982);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(53),
		__webpack_require__(673),
		__webpack_require__(674),
		__webpack_require__(152)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction, nonce, rquery ) {
	
	"use strict";
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(406),
		__webpack_require__(53),
		__webpack_require__(677),
		__webpack_require__(152),
		__webpack_require__(182),
		__webpack_require__(283),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, isFunction ) {
	
	"use strict";
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(63),
		__webpack_require__(152)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, document ) {
	
	"use strict";
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
		"use strict";
	
		return window.location;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(154),
		__webpack_require__(152)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, support ) {
	
	"use strict";
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// trac-14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(1798),
		__webpack_require__(675),
		__webpack_require__(1799),
		__webpack_require__(1800)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Return jQuery for attributes-only inclusion
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(153),
		__webpack_require__(111),
		__webpack_require__(404),
		__webpack_require__(132),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, nodeName, support, rnothtmlwhite ) {
	
	"use strict";
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(406),
		__webpack_require__(53),
		__webpack_require__(132),
		__webpack_require__(112),
		__webpack_require__(94)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, isFunction, rnothtmlwhite, dataPriv ) {
	
	"use strict";
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
							if ( cur.indexOf( " " + className + " " ) < 0 ) {
								cur += className + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classNames, cur, curValue, className, i, finalValue;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classNames = classesToArray( value );
	
			if ( classNames.length ) {
				return this.each( function() {
					curValue = getClass( this );
	
					// This expression is here for better compressibility (see addClass)
					cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						for ( i = 0; i < classNames.length; i++ ) {
							className = classNames[ i ];
	
							// Remove *all* instances
							while ( cur.indexOf( " " + className + " " ) > -1 ) {
								cur = cur.replace( " " + className + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							this.setAttribute( "class", finalValue );
						}
					}
				} );
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var classNames, className, i, self,
				type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			classNames = classesToArray( value );
	
			return this.each( function() {
				if ( isValidValue ) {
	
					// Toggle individual class names
					self = jQuery( this );
	
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
								"" :
								dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
				}
			}
	
			return false;
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(406),
		__webpack_require__(404),
		__webpack_require__(111),
		__webpack_require__(53),
	
		__webpack_require__(94)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, stripAndCollapse, support, nodeName, isFunction ) {
	
	"use strict";
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (trac-2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(63),
		__webpack_require__(154)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( document, support ) {
	
	"use strict";
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	return support;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(81)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(112),
		__webpack_require__(686)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, dataPriv, isHiddenWithinTree ) {
	
	"use strict";
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	
	return showHide;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(408)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( cssExpand ) {
		"use strict";
	
		return new RegExp( cssExpand.join( "|" ), "i" );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	// A method for quickly swapping in/out CSS properties to get correct calculations.
	return function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(153),
		__webpack_require__(225),
		__webpack_require__(112),
		__webpack_require__(689)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, camelCase, dataPriv, dataUser ) {
	
	"use strict";
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (trac-14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(181)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
	// captured before the async barrier to get the original error cause
	// which may otherwise be hidden.
	jQuery.Deferred.exceptionHook = function( error, asyncError ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message,
				error.stack, asyncError );
		}
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(111),
		__webpack_require__(225),
		__webpack_require__(180),
		__webpack_require__(53),
		__webpack_require__(228),
		__webpack_require__(229),
	
		__webpack_require__(1810),
		__webpack_require__(1811)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, nodeName, camelCase, toType, isFunction, isWindow, slice ) {
	
	"use strict";
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	// Require that the "whitespace run" starts from a non-whitespace
	// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
	var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "$1" );
	};
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(152),
		__webpack_require__(227)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
	
		__webpack_require__(227),
		__webpack_require__(690)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this
				.on( "mouseenter", fnOver )
				.on( "mouseleave", fnOut || fnOver );
		}
	} );
	
	jQuery.each(
		( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		}
	);
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(153),
		__webpack_require__(228),
		__webpack_require__(226)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, isWindow ) {
	
	"use strict";
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( {
			padding: "inner" + name,
			content: type,
			"": "outer" + name
		}, function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(684),
	
		__webpack_require__(226)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, finalPropName ) {
	
	"use strict";
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(81),
		__webpack_require__(410)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (trac-13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(81),
		__webpack_require__(182),
		__webpack_require__(405),
		__webpack_require__(181),
		__webpack_require__(1808),
		__webpack_require__(679),
		__webpack_require__(1807),
		__webpack_require__(411),
		__webpack_require__(1820),
		__webpack_require__(1797),
		__webpack_require__(227),
		__webpack_require__(283),
		__webpack_require__(1818),
		__webpack_require__(1828),
		__webpack_require__(226),
		__webpack_require__(1803),
		__webpack_require__(699),
		__webpack_require__(152),
		__webpack_require__(1796),
		__webpack_require__(1794),
		__webpack_require__(1792),
		__webpack_require__(1793),
		__webpack_require__(678),
		__webpack_require__(677),
		__webpack_require__(410),
		__webpack_require__(1814),
		__webpack_require__(1819),
		__webpack_require__(1812),
		__webpack_require__(1809),
		__webpack_require__(1815),
		__webpack_require__(1816)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	return jQuery;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(152)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (trac-11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	return jQuery._evalUrl;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(153),
		__webpack_require__(285),
		__webpack_require__(53),
		__webpack_require__(409),
		__webpack_require__(683),
		__webpack_require__(681),
		__webpack_require__(407),
		__webpack_require__(228),
		__webpack_require__(94),
		__webpack_require__(226),
		__webpack_require__(81) // contains
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, access, documentElement, isFunction, rnumnonpx,
		curCSS, addGetHookIf, support, isWindow ) {
	
	"use strict";
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(411),
		__webpack_require__(410) // Delay is optional because of this dependency
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// Based off of the plugin by Clint Helfers, with permission.
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	return jQuery.fn.delay;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
	
	function fcssescape( ch, asCodePoint ) {
		if ( asCodePoint ) {
	
			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}
	
			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}
	
		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	}
	
	jQuery.escapeSelector = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery ) {
	
	"use strict";
	
	return function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	
	"use strict";
	
	return function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(703)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( fnToString ) {
		"use strict";
	
		return fnToString.call( Object );
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	
	"use strict";
	
	return arr.pop;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	
	"use strict";
	
	return arr.sort;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(113)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( arr ) {
	
	"use strict";
	
	return arr.splice;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(14),
		__webpack_require__(53),
		__webpack_require__(94),
		__webpack_require__(283), // clone
		__webpack_require__(182) // parent, contents
	], __WEBPACK_AMD_DEFINE_RESULT__ = function( jQuery, isFunction ) {
	
	"use strict";
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ },
/* 1829 */
/***/ function(module, exports) {

	module.exports = {
		"why": {
			"html": "<p>Read about what makes corporate bonds a popular investment choice for fixed income investors.</p><p><b>Competitive returns:</b> Corporate bonds may offer competitive returns, providing higher yields than comparable, government-issued bonds of similar maturity.</p><p><b>Income generation:</b> Coupon payments from corporate bonds can help generate a predictable income stream.<p><b>Diversification:</b> Because many types of corporate entities issue bonds, investors have access to a diverse offering of bonds, with varying coupon structures and risk profiles, across numerous sectors.</p><p><b>Liquidity:</b> Many corporate bonds are actively traded in the secondary market and can typically easily be sold prior to maturity.</p><p><b>Lower cost of entry:</b> Corporate bonds are often issued in denominations of $1,000, providing a lower cost of entry than other asset classes.</p><p><b>Here are more helpful resources on corporate bond investing.</b></p><p><a href='https://www.finra.org/investors/learn-to-invest/types-investments/bonds/types-of-bonds/corporate-bonds' target='blank'>FINRA: Learn to Invest - Corporate Bonds</a><br><a target='blank' href='https://www.sec.gov/files/ib_corporatebonds.pdf'>SEC Investor Bulletin: What are Corporate Bonds?</a></p>",
			"disclosure": "Investing in securities involves risk, including possible loss of principal. Diversification does not ensure profit or protect against loss in declining markets."
		},
		"faq": [
			[
				"What is a corporate bond?",
				"<p>A corporate bond is an interest-bearing debt obligation issued by a company to help finance ongoing business expenses and operations. When an investor purchases a corporate bond, they’re lending money to the company issuing the bond. In return, the company is obligated to adhere to the terms of the loan. Terms may vary, but an investor is typically due fixed-interest payments on set dates, as well as a return of their principal when the bond matures.</p>"
			],
			[
				"What’s the difference between investment-grade and high-yield corporate bonds?",
				"<p>Rating agencies, such as Standard & Poor’s (S&P) and Moody’s, measure the creditworthiness and financial strength of an issuer and assign a credit rating. Investment-grade bonds are rated BBB (S&P) or Baa (Moody’s) and higher. They generally have a lower probability of incurring a payment default. High-yield bonds, also known as junk bonds or speculative grade, are rated BB (S&P) or Ba (Moody’s) and below. These bonds that are rated lower, or extremely speculative (CCC at S&P or Caa2 at Moody’s), have a much higher probability of default. Lower rated bonds also typically carry higher yields to compensate the investor for the additional risk assumed.</p><img src='resources/images/corporates-bonds-ratings-table.png' />"
			],
			[
				"How are corporate bond prices quoted?",
				"<p>Corporate bonds are quoted as a percentage of their par, or face value, which is typically $1,000. For instance, if you have a corporate bond with a price of 99.8, that bond is being valued at 99.8% of its face value, or $980. Bonds priced above their face value are trading at a premium, and bonds priced below their face value are trading at a discount. E*TRADE will always display the best available bid and/or offer (as available) for any corporate bond showing on the platform. You may also use the depth-of-book feature to observe quantities and prices available from additional dealers.</p>"
			],
			[
				"Can I buy foreign corporate bonds?",
				"<p>Yes. You can trade bonds from foreign-based companies, as long as they are issued in the US market and are US dollar denominated.</p>"
			],
			[
				"What are the corporate bond structures I should know?",
				"<p>One of the many benefits of corporate bonds is their payment structure diversity, so investors can find one suited to their individual needs.</p><p>Coupon structures<ul><li><b>Fixed rate:</b> As with most bonds, a majority of corporate bonds feature a fixed interest rate. This means the investor will receive a fixed (non-variable) interest payment on a predetermined schedule (typically semiannually) over the life of the bond until maturity.</li><li><b>Floating rate:</b> These corporate bonds (often called “floaters”) feature a variable interest rate that is tied to a benchmark rate. Some common benchmarks include the federal funds rate or a popular market index like the Consumer Price Index (CPI). The variable coupon for most floaters is typically based on the performance of the underlying benchmark, plus a fixed spread in basis points.</li><li><b>Step-ups:</b> These bonds do not feature a fixed (constant) coupon rate. Rather, the coupon rate for these bonds gradually increases (steps up) over the life of the security according to a predetermined schedule. In most instances, step-up bonds become callable on the first date the coupon resets.</li><li><b>Zero-coupon:</b> These corporate bonds have no coupons (hence the name) and do not offer regular interest payments. In substitute, zero-coupons are purchased at a deep discount to their face value and are then redeemed at their full face value upon maturity. Although regular interest payments aren’t being received, investors must pay tax on the interest accrued each year over the life of the bond.</li></ul></p><p>Redemption structures<ul><li><b>Callable:</b> A bond is callable if the issuer has the right to redeem (call) the bond prior to its stated maturity date, usually at a predetermined price. A bond is more likely to be called if interest rates have declined since the bond’s initial issuance. The issuing entity may elect to call the bonds in order to refinance their debt at a lower rate of interest.  </li><li><b>Make-whole call:</b> A make-whole call provision allows the issuer to pay off remaining debt early, but with different terms than a traditional par call. The issuer is required to make a lump-sum payment to the borrower that is equivalent to the net present value of future coupon payments (which will not be paid incrementally due to the early call), plus the principal payment the investor would have received upon maturity. A make-whole call can be a form of investor protection, as the investor will be “made whole” if the issuer calls their bonds early.</li><li><b>Puttable:</b> A bond with a put option gives the investor the right (but not the obligation) to force the issuer to repurchase the bond on a specified date prior to maturity. The price at which the bond can be sold (put) back to the issuer is determined at the bond’s issuance, but it is typically par value.</li></ul></p>"
			],
			[
				"What are convertible corporate bonds?",
				"<p>Convertible bonds are a type of hybrid corporate bond that can be converted into a fixed number of shares of the issuer’s common stock, usually at the investor’s discretion. The bond’s conversion ratio dictates how many shares of common stock each bond can be converted into. The conversion price is the level at which the converted shares are equal to the bond’s face value. Although these bonds feature a unique conversion option, they still typically offer fixed coupon rates and have set maturity dates. Since convertible bonds have the characteristics of both bonds and stock, they are subject to liquidity risk, interest rate risk, and equity market risk.  An issuer’s credit rating can also affect the price of a convertible bond.  It is important to understand the parameters of a convertible bond, including the conversion ratio, maturity date and face value.</p>"
			],
			[
				"What is a corporate bond’s debt-ranking (seniority)?",
				"<p>Seniority generally refers to the order in which investors are repaid, in the event an issuer becomes insolvent. A bond’s debt ranking structure will determine the hierarchy in which investors have claim to an issuer’s assets during a bankruptcy event. Senior secured debt has the highest claim, while unsecured subordinated bonds have a lesser claim. Issuers back secured corporate bonds by collateral (e.g., physical assets), which is used to repay investors if they default. Unsecured bonds are not covered by collateral and are only backed by the good faith and credit of the issuer.</p>"
			],
			[
				"What is the minimum investment required to purchase a corporate bond?",
				"<p>The minimum investment required to buy a single bond is generally $1,000, and bond orders must be placed for at least one whole bond—you cannot order fractional bond sizes. Certain bond dealers impose a higher minimum quantity, for example, a $10,000 face value. You can observe this minimum on either the Search Results table, the Bond Description page, or a bond order ticket when placing a trade.</p>"
			],
			[
				"When will I receive interest payments for my corporate bond?",
				"<p>Your coupon frequency may be on a semiannual, quarterly, or monthly payment schedule.  There are several ways you can monitor when you’ll receive interest payments for your corporate bond. You can go to the E*TRADE Portfolios page and click the issuer name for a bond to load the Bond Description page. Under the Issuer Information section, you’ll see the first, last, and next coupon date, along with coupon frequency. The Estimated Income tool within the Portfolios page also displays your expected monthly income in a table and graph view.</p><p>Alternatively, you can find this information by downloading a <a href='#' style='cursor:pointer' onclick='twd.show(\"portfolio-report\")'>Bond Portfolio Report</a> within the Bond Resource Center. This report also breaks down your coupon cash flow.</p>"
			]
		],
		"risk": {
			"html": "<p>While corporate bonds are a popular choice for fixed-income investments, it&apos;s important to understand the associated risks.</p><p><b>Credit/default risk:</b> Corporate bonds may be at higher risk of the issuing company defaulting on their principal or interest payments.</p><p><b>Event risk:</b> Event risks may occur, when a company faces unexpected challenges in their competitive markets, which can impact their ability to generate cash flow and meet their debt obligations.</p><p><b>Interest-rate risk:</b> The value of your corporate bond will fluctuate in response to changes in interest rates. Corporate bond prices are based on their yield spread versus US Treasuries, so upward movement in government bond yields may erode the market value of your bond.</p><p><b>Call and reinvestment risk:</b> Corporate bonds may also come with call and reinvestment risks. If interest rates decline, a corporate issuer may call their bonds, to reissue them at lower coupon rates. In this case, an investor would receive their principal sooner than expected and may be unable to reinvest at yields comparable to their original holding.</p>"
		}
	};

/***/ },
/* 1830 */
/***/ function(module, exports) {

	module.exports = {
		"getting-started": [
			[
				"article",
				"Facts About Municipal Bonds",
				"https://www.msrb.org/sites/default/files/Facts-About-Municipal-Bonds.pdf"
			],
			[
				"tv",
				"What is an Official Statement?",
				"https://www.msrb.org/media/view/76948"
			],
			[
				"tv",
				"What's Inside an Official Statement?",
				"https://www.msrb.org/media/view/76949"
			],
			[
				"tv",
				"What is Financial Disclosure?",
				"https://www.msrb.org/media/view/76956"
			],
			[
				"article",
				"Using EMMA® to Monitor Your Bonds",
				"https://www.msrb.org/sites/default/files/Monitoring-Bonds.pdf"
			],
			[
				"article",
				"Tax and Liquidity Considerations for Discount Bonds",
				"https://www.msrb.org/sites/default/files/Tax-and-Liquidity-Considerations-for-Buying-Discount-Bonds.pdf"
			]
		],
		"the-municipal-market": [
			[
				"article",
				"Municipal Market 101",
				"https://www.msrb.org/sites/default/files/Municipal-Market-101-Online.pdf"
			],
			[
				"tv",
				"The Municipal Bond Market and the MSRB",
				"https://www.msrb.org/media/view/76964"
			],
			[
				"article",
				"Muni Facts",
				"https://www.msrb.org/sites/default/files/2022-09/MSRB-Muni-Facts.pdf"
			],
			[
				"campaign",
				"Getting the Facts on the Muni Market",
				"https://www.msrb.org/media/view/234"
			],
			[
				"books",
				"Glossary of Municipal Securities Terms",
				"https://www.msrb.org/sites/default/files/2022-08/MSRB-Glossary-of-Municipal-Securities-Terms-Third_Edition-August-2013.pdf"
			],
			[
				"books",
				"Original Issue Discount Bonds",
				"https://www.msrb.org/sites/default/files/Original-Issue-Discount-Bonds.pdf"
			]
		]
	};

/***/ },
/* 1831 */
/***/ function(module, exports) {

	module.exports = {
		"why": "<p>Read about what makes municipal bonds a popular investment choice for fixed-income investors.</p><p><b>Tax advantages:</b> The most popular feature of municipal bonds are their tax advantages. Most municipal bonds are tax-exempt at the federal level and may offer tax exemptions at the state/local levels for residents of the issuing state.</p><p><b>Capital preservation:</b>  Municipal bonds have historically lower risk of default in comparison to the corporate bond market.<p><p><b>Income generation:</b> Coupon payments from municipal bonds can help generate a predictable income stream.</p><p><b>Invest locally:</b> Opportunity to invest in state and local government projects that directly impact you.</p><p>For further information on municipal bond investing, check out these resources.</p><p><a href='https://www.finra.org/rules-guidance/key-topics/municipal-securities#overview' target='blank'>FINRA: Municipal Securities Overview</a><br/><a href='https://www.sec.gov/oiea/investor-alerts-and-bulletins/ib_munibondsoverview' target='blank'>SEC Investor Bulletin: Municipal Bonds Overview</a><br/><a href='https://www.sec.gov/oiea/investor-alerts-and-bulletins/ib_munibondsmarket' target='blank'>SEC Investor Bulletin: Municipal Bonds Market</a></p>",
		"faq": [
			[
				"What is a municipal bond?",
				"<p>A municipal bond is an interest-bearing debt obligation issued by a municipality, county, or state to help finance expenses associated with public projects.  These projects can include the construction of hospitals, schools, or roads. When you purchase a municipal bond, you are lending money to the local government issuing the bond. In return, the local government is obligated to adhere to the terms of the loan. Terms may vary, but you are typically due fixed-interest payments on set dates, as well as a return of their principal when the bond matures.</p>"
			],
			[
				"What is the difference between a general obligation and revenue bond?",
				"<p>The two main categories of municipal bonds are general obligation (GO) and revenue bonds. GO bonds are secured by the taxing authority of the issuing state or municipality. Some examples of GO bonds include building schools or parks that do not generate revenue. Revenue bonds are backed by the income generated by the public project the bond is funding. Examples of revenue bonds would include building a baseball stadium, airports, or toll roads.  GO bonds typically carry less risk than revenue bonds due to the taxation power of the issuer.</p>"
			],
			[
				"What does it mean when a municipal bond is tax-exempt?",
				"<p>For many investors, the primary advantage of investing in municipal bonds is that the interest payments received are typically exempt from federal income tax. Another notable advantage is that most states do not tax the interest earned on bonds purchased by residents of the issuing state, and in some cases, they may be exempt from local taxes as well. For these reasons, investors typically purchase municipal bonds issued by the state in which they reside, to take advantage of these tax-exemption benefits.</p>"
			],
			[
				"How do I know if a municipal bond is tax-free or taxable?",
				"<p>To determine if a municipal bond is tax-free or taxable, view the “Tax Treatment Features” section on the Bond Offering Detail page by clicking the issuer name link. This section will display a “Yes” or “No” value to indicate if the bond is tax-free/taxable in the state of issuance, federally, and/or subject to AMT. You may use the <a href='#'  style=\"cursor:pointer\" onclick=\"twd.show('advanced-screener',{from:'municipals'})\">Advanced Screener</a> to search for tax-free bonds by selecting Municipal for “Security Type” and then using the Tax Treatment dropdown to make a selection.</p>"
			],
			[
				"How do I compare yields on tax-free municipal bonds with taxable bonds?",
				"<p>The <a href='#' style='cursor:pointer' onclick=\"twd.publish('tey-calculator',{source:this})\">Taxable Equivalent Yield Calculator</a> can be used to make an after-tax comparison of taxable and tax-exempt bonds. The calculator asks you to input some information to determine the taxable equivalent yield required of a taxable bond to provide an equal return to a tax-free municipal bond.</p>"
			],
			[
				"What are some of the municipal tax rules that I should be aware of?",
				"<p>Municipal bonds may be subject to additional tax rules depending on both personal and offering-specific criteria. If a municipal bond is purchased at a minimal discount, it may be subject to the de minimis tax rule and a  price threshold will be used to determine whether the discount on the bond will be taxed as a capital gain or ordinary income. Another municipal tax rule to be aware of is the Alternative Minimum Tax (AMT). The AMT ensures that taxpayers with relatively high incomes do not escape their tax liability through tax breaks and loopholes. If an investor has an income that exceeds the annual AMT exemption amount, they may be subject to pay additional taxes on their municipal bond. Please consult your tax professional for information regarding any municipal bond tax implications.</p>"
			],
			[
				"What does it mean if my municipal bond is insured?",
				"<p>Issuers which adhere to certain criteria may elect to purchase a supplemental insurance policy on their debt offering from a private company.  This insurance policy provides investors with additional security that the bond’s interest and principal payments will be made in the event of an issuer default. Insured municipal bonds may carry higher credit ratings than uninsured alternatives, but typically offer lower yields in return for their added safety.</p>"
			],
			[
				"What is the MSRB/EMMA?",
				"<p>The Municipal Securities Rulemaking Board (MSRB) is the SEC’s independent, self-regulatory organization (SRO) that is charged with primary rulemaking authority for the municipal securities market. The mission of the MSRB is to protect investors, municipal entities and the public interest by promoting a fair and efficient municipal market, regulating firms that engage in municipal securities and advisory activities, and promoting market transparency.</p><p>Electronic Municipal Market Access (EMMA) is a service and website created by the MSRB to disseminate municipal market data and disclosures to the public. EMMA increases market transparency by providing free public access to official statements, trade data, credit ratings, educational materials, and other municipal market information.</p>"
			],
			[
				"How can I access a municipal bond’s disclosure documentation?",
				"<p>You can access a municipal bond’s disclosure documents by clicking on the “Disclosure Info” link found on the Bond Offering Detail page of a security. By clicking on this <a href='#' style='cursor:pointer' href='https://emma.msrb.org/home' target='_blank'>link</a>, you will be  redirected to the Electronic Municipal Market Access (EMMA) page where the official statement can be found.</p>"
			],
			[
				"What is the minimum investment required to purchase a municipal bond?",
				"<p>The minimum investment required to purchase a municipal bond is typically $5,000, and bond orders must be placed for whole bonds—you cannot order fractional bond sizes. Certain bond dealers impose a higher minimum quantity, for example, a $10,000 face value. You can observe this minimum on either the Search Results table, the Bond Description page, or a bond order ticket when placing a trade.</p>"
			],
			[
				"When will I receive interest payments for my municipal bond?",
				"<p>You will typically receive municipal bond interest payments semi-annually, but you may observe alternate structures in rare instances. There are several ways you can monitor when you’ll receive interest payments for your municipal bond. You can go to the E*TRADE Portfolios page and click the issuer name for a bond to load the Bond Description page. Under the Issuer Information section, you will see the first, last, and next coupon date, along with coupon frequency. The Estimated Income tool within the Portfolios page also displays your expected monthly income in a table and graph view.<br/>Alternatively, you can find this information by downloading a <a href='#' style='cursor:pointer' onclick='twd.show(\"portfolio-report\")'>Bond Portfolio Report</a> within the Bond Resource Center. This report also breaks down your coupon cash flow.</p>"
			],
			[
				"What is ESG Investing?",
				"<p>Environmental, Social, and Governance (ESG) criteria are a set of standards for a company’s operational processes that socially conscious investors use when searching for prospective investments within the ESG category. Environmental criteria assess how well a company contributes to the conservation of nature, such as employing effective pollution, biodiversity, and waste management procedures. Social criteria examine how well a company treats people and manages relationships, including customer satisfaction, gender and diversity, and community relations. Governance has to do with a company’s operational standards, which include board composition, executive compensation, and political contributions.</p>",
				"<p>Environmental, Social and Governance (“ESG”) investments in a portfolio may experience performance that is lower or higher than a portfolio not employing such practices.  Portfolios with ESG restrictions and strategies as well as ESG investments may not be able to take advantage of the same opportunities or market trends as portfolios where ESG criteria is not applied. There are inconsistent ESG definitions and criteria within the industry, as well as multiple ESG ratings providers that provide ESG ratings of the same subject companies and/or securities that vary among the providers.  Certain issuers of investments may have differing and inconsistent views concerning ESG criteria where the ESG claims made in offering documents or other literature may overstate ESG impact. ESG designations are as of the date of this material, and no assurance is provided that the underlying assets have maintained or will maintain and such designation or any stated ESG compliance. As a result, it is difficult to compare ESG investment products or to evaluate an ESG investment product in comparison to one that does not focus on ESG. Investors should also independently consider whether the ESG investment product meets their own ESG objectives or criteria.</p><p>There is no assurance that an ESG investing strategy or techniques employed will be successful. Past performance is not a guarantee or a dependable measure of future results.</p>"
			],
			[
				"What are green bonds?",
				"<p>Green bonds are fixed income securities that specifically allocate its proceeds to fund environmental and/or climate projects. Green Bonds follow the Green Bond Principles stated by the International Capital Market Association, and the proceeds from the issuance are only to be used for the pre-specified types of projects. These bonds are typically backed by the issuing entity’s balance sheet, and therefore usually carry the same credit rating as the issuer’s other debt obligations.</p>"
			]
		],
		"risk": "<p>While municipal bonds are a popular choice for fixed-income investments, it’s important to understand the associated risks.</p><p><b>Credit/default risk:</b> Municipal bonds are subject to the risk of the issuing company defaulting on their principal or interest payments.</p><p><b>Event risk:</b> Event risks may occur, when an issuer faces unexpected challenges, which can impact their ability to generate cash flow and meet their debt obligations.</p><p><b>Interest-rate risk:</b> The value of your municipal bond will fluctuate in response to changes in interest rates.</p><p><b>Call and reinvestment risk:</b> Municipal bonds may also come with call and reinvestment risks. If interest rates decline, an issuer may call their bonds, to reissue them at lower coupon rates. In this case, an investor would receive their principal sooner than expected and may be unable to reinvest at yields comparable to their original holding.<p><p><b>Liquidity risk:</b> Some municipal bonds may be more thinly traded in comparison to secondary markets for corporates or treasuries, which may make it harder to find a buyer should you need to sell your bond.</p>"
	};

/***/ },
/* 1832 */
/***/ function(module, exports) {

	module.exports = {
		"tools": [
			{
				"title": "Quote request tool",
				"description": "Need to buy or sell a bond but don’t see a live bid or offer for the CUSIP? Use the quote request tool to submit a bid (sell) or offer (buy) quote request, and we’ll get a price quote from our dealer network.",
				"img": "resources/images/quote-request-tool.png",
				"nav": "goto",
				"navArg": {
					"view": "tools.get-a-bond-quote",
					"actionSubset": "WF",
					"action": "W",
					"from": "tools-and-resources"
				}
			},
			{
				"title": "Bond ladder builder",
				"description": "Create a custom laddered portfolio, designed to reduce interest rate risk exposure and generate predictable income.",
				"img": "resources/images/bond-ladder-builder.png",
				"nav": "goto",
				"navArg": "bond-ladder-builder"
			},
			{
				"title": "Treasury auctions",
				"description": "See the latest Treasury auction schedule and place orders.",
				"img": "resources/images/treasury-auctions@3x.png",
				"nav": "goto",
				"navArg": {
					"view": "tools.treasury-auctions",
					"from": "tools-and-resources"
				}
			},
			{
				"title": "Advanced bond screener",
				"description": "Choose from a comprehensive range of criteria to customize your search.",
				"img": "resources/images/advanced-bond-screener.png",
				"nav": "goto",
				"navArg": "advanced-screener"
			},
			{
				"title": "Fixed income portfolio report",
				"description": "View our bond portfolio report with analysis on expected cash flows, maturity and duration exposure, credit quality distribution, and more.",
				"img": "resources/images/fixed-income-portfolio-report@3x.png",
				"nav": "goto",
				"navArg": "portfolio-report"
			},
			{
				"title": "Tax-equivalent yields calculator",
				"description": "Make an after-tax comparison of taxable and tax-exempt bonds. Determine the taxable equivalent yield required of a taxable bond to provide an equal return to a tax-free municipal bond.",
				"img": "resources/images/tax-equivalent-bond-yields-calculator@3x.png",
				"nav": "tey-calculator",
				"tag": "button",
				"navArg": {
					"isReset": true
				}
			},
			{
				"title": "Price/Yield calculator",
				"description": "Calculate the estimated price or yield of a bond and the potential cash flow based on investment quantity.",
				"img": "resources/images/price-yield-calculator.png",
				"nav": "calculator",
				"navArg": {
					"from": "tools-and-resources"
				}
			},
			{
				"title": "Sell order ticket",
				"description": "Need to sell a current bond holding? Use the sell order ticket to liquidate a position. If no live bid is available, submit a bid (sell) quote request, and we'll get a price quote from our dealer network.",
				"img": "resources/images/sell-order-ticket.png",
				"nav": "goto",
				"navArg": {
					"view": "sell-your-bond",
					"from": "tools-and-resources"
				}
			}
		],
		"resources": [
			{
				"title": "Municipal news search",
				"description": "Find relevant news for the municipal market, and monitor trending news articles related to your holdings.",
				"nav": "goto",
				"navArg": "municipals/municipal-market-news"
			},
			{
				"title": "Tradeweb Market Transparency Report",
				"description": "See Tradeweb’s monthly guide with insights on retail fixed income market trends, trade volumes, issuer activity, and more.",
				"nav": "open",
				"navArg": {
					"url": "https://www.bonddesk.com/static/etrade/Market_Transparency.pdf",
					"name": "_blank"
				}
			},
			{
				"title": "Whitepaper: FINRA Smart Bond Investing",
				"description": "Read FINRA’s guide to bond investing to learn more about the basics, types of bonds, and different investment strategies.",
				"nav": "open",
				"navArg": {
					"url": "https://www.bonddesk.com/etrade/smart_bond_investing.pdf",
					"name": "_blank"
				}
			},
			{
				"title": "Article: Understanding brokered CDs",
				"description": "Learn about the features and benefits of brokered certificates of deposit (CDs), compared to traditional bank CDs.",
				"nav": "open",
				"navArg": {
					"url": "https://us.etrade.com/knowledge/library/bonds-cds/understanding-brokered-cds"
				}
			},
			{
				"title": "Article: The basics of bond ladders",
				"description": "Learn the benefits of this simple investment strategy and discover how you can create a bond ladder designed around your goals.",
				"nav": "open",
				"navArg": {
					"url": "https://us.etrade.com/knowledge/library/bonds-cds/bond-ladders"
				}
			},
			{
				"title": "Article: Types of bonds",
				"description": "Explore the various types of bonds and learn which may be best suited for your portfolio.",
				"nav": "open",
				"navArg": {
					"url": "https://us.etrade.com/knowledge/library/bonds-cds/types-of-bonds"
				}
			},
			{
				"title": "Article: What is a bond?",
				"description": "Learn the basics of bonds, why investors include them in portfolios, and how to get started investing in bonds at E*TRADE.",
				"nav": "open",
				"navArg": {
					"url": "https://us.etrade.com/knowledge/library/bonds-cds/what-is-a-bond"
				}
			}
		]
	};

/***/ },
/* 1833 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1834 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(156),
	    root = __webpack_require__(95);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1901),
	    hashDelete = __webpack_require__(1902),
	    hashGet = __webpack_require__(1903),
	    hashHas = __webpack_require__(1904),
	    hashSet = __webpack_require__(1905);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(156),
	    root = __webpack_require__(95);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(156),
	    root = __webpack_require__(95);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 1839 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 1840 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 1841 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(231),
	    keys = __webpack_require__(187);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(231),
	    keysIn = __webpack_require__(437);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(290);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(290);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1889);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 1848 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(717),
	    baseIsNaN = __webpack_require__(1855),
	    strictIndexOf = __webpack_require__(1936);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(417),
	    arrayIncludes = __webpack_require__(712),
	    arrayIncludesWith = __webpack_require__(713),
	    arrayMap = __webpack_require__(155),
	    baseUnary = __webpack_require__(230),
	    cacheHas = __webpack_require__(424);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(133),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(418),
	    equalArrays = __webpack_require__(726),
	    equalByTag = __webpack_require__(1894),
	    equalObjects = __webpack_require__(1895),
	    getTag = __webpack_require__(295),
	    isArray = __webpack_require__(43),
	    isBuffer = __webpack_require__(434),
	    isTypedArray = __webpack_require__(740);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(295),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(418),
	    baseIsEqual = __webpack_require__(423);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 1855 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38),
	    isMasked = __webpack_require__(1911),
	    isObject = __webpack_require__(83),
	    toSource = __webpack_require__(737);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(295),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ },
/* 1858 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(133),
	    isLength = __webpack_require__(435),
	    isObjectLike = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(430),
	    nativeKeys = __webpack_require__(1924);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(83),
	    isPrototype = __webpack_require__(430),
	    nativeKeysIn = __webpack_require__(1925);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1854),
	    getMatchData = __webpack_require__(1897),
	    matchesStrictComparable = __webpack_require__(732);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(423),
	    get = __webpack_require__(185),
	    hasIn = __webpack_require__(1946),
	    isKey = __webpack_require__(429),
	    isStrictComparable = __webpack_require__(731),
	    matchesStrictComparable = __webpack_require__(732),
	    toKey = __webpack_require__(184);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(155),
	    baseGet = __webpack_require__(292),
	    baseIteratee = __webpack_require__(88),
	    baseMap = __webpack_require__(722),
	    baseSortBy = __webpack_require__(1870),
	    baseUnary = __webpack_require__(230),
	    compareMultiple = __webpack_require__(1884),
	    identity = __webpack_require__(186),
	    isArray = __webpack_require__(43);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 1864 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(292);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 1866 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1940),
	    defineProperty = __webpack_require__(725),
	    identity = __webpack_require__(186);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 1868 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(290);
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	module.exports = baseSome;


/***/ },
/* 1870 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 1871 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 1872 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(183),
	    arrayMap = __webpack_require__(155),
	    isArray = __webpack_require__(43),
	    isSymbol = __webpack_require__(158);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1937);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(417),
	    arrayIncludes = __webpack_require__(712),
	    arrayIncludesWith = __webpack_require__(713),
	    cacheHas = __webpack_require__(424),
	    createSet = __webpack_require__(1892),
	    setToArray = __webpack_require__(432);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(293),
	    last = __webpack_require__(741),
	    parent = __webpack_require__(1927),
	    toKey = __webpack_require__(184);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(1948);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(95);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(448)(module)))

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(425);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 1880 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(183);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(425);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(158);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1883);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(231),
	    getSymbols = __webpack_require__(427);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(231),
	    getSymbolsIn = __webpack_require__(730);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(95);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(157);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 1889 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(88),
	    isArrayLike = __webpack_require__(157),
	    keys = __webpack_require__(187);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1866),
	    isIterateeCall = __webpack_require__(296),
	    toFinite = __webpack_require__(748);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(709),
	    noop = __webpack_require__(1955),
	    setToArray = __webpack_require__(432);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(436);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(183),
	    Uint8Array = __webpack_require__(710),
	    eq = __webpack_require__(298),
	    equalArrays = __webpack_require__(726),
	    mapToArray = __webpack_require__(1922),
	    setToArray = __webpack_require__(432);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(728);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(1945),
	    overRest = __webpack_require__(734),
	    setToString = __webpack_require__(735);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(731),
	    keys = __webpack_require__(187);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(183);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 1899 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(293),
	    isArguments = __webpack_require__(433),
	    isArray = __webpack_require__(43),
	    isIndex = __webpack_require__(428),
	    isLength = __webpack_require__(435),
	    toKey = __webpack_require__(184);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(297);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 1902 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(297);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(297);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(297);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 1906 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(425),
	    cloneDataView = __webpack_require__(1879),
	    cloneRegExp = __webpack_require__(1880),
	    cloneSymbol = __webpack_require__(1881),
	    cloneTypedArray = __webpack_require__(1882);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(1844),
	    getPrototype = __webpack_require__(426),
	    isPrototype = __webpack_require__(430);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(183),
	    isArguments = __webpack_require__(433),
	    isArray = __webpack_require__(43);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 1910 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1887);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 1912 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(289);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(289);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(289);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(289);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1836),
	    ListCache = __webpack_require__(288),
	    Map = __webpack_require__(415);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(294);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(294);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(294);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(294);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 1922 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1953);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(733);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 1925 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 1926 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(292),
	    baseSlice = __webpack_require__(1868);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 1928 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 1929 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 1930 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(288);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 1932 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 1933 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 1934 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(288),
	    Map = __webpack_require__(415),
	    MapCache = __webpack_require__(416);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 1936 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 1937 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(421);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * Creates a shallow clone of `value`.
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	 * and supports cloning arrays, array buffers, booleans, date objects, maps,
	 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	 * arrays. The own enumerable properties of `arguments` objects are cloned
	 * as plain objects. An empty object is returned for uncloneable values such
	 * as error objects, functions, DOM nodes, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to clone.
	 * @returns {*} Returns the cloned value.
	 * @see _.cloneDeep
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var shallow = _.clone(objects);
	 * console.log(shallow[0] === objects[0]);
	 * // => true
	 */
	function clone(value) {
	  return baseClone(value, CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = clone;


/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(421);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 1940 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(711),
	    baseFilter = __webpack_require__(1846),
	    baseIteratee = __webpack_require__(88),
	    isArray = __webpack_require__(43);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1890),
	    findIndex = __webpack_require__(1943);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(717),
	    baseIteratee = __webpack_require__(88),
	    toInteger = __webpack_require__(1962);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(422),
	    map = __webpack_require__(1951);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(422);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1848),
	    hasPath = __webpack_require__(1900);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(155),
	    baseIntersection = __webpack_require__(1850),
	    baseRest = __webpack_require__(723),
	    castArrayLikeObject = __webpack_require__(1877);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(157),
	    isObjectLike = __webpack_require__(96);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1853),
	    baseUnary = __webpack_require__(230),
	    nodeUtil = __webpack_require__(431);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1857),
	    baseUnary = __webpack_require__(230),
	    nodeUtil = __webpack_require__(431);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(155),
	    baseIteratee = __webpack_require__(88),
	    baseMap = __webpack_require__(722),
	    isArray = __webpack_require__(43);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(420),
	    baseForOwn = __webpack_require__(718),
	    baseIteratee = __webpack_require__(88);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(416);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(291),
	    baseIteratee = __webpack_require__(88),
	    baseLt = __webpack_require__(721);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 1955 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(95);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1864),
	    basePropertyDeep = __webpack_require__(1865),
	    isKey = __webpack_require__(429),
	    toKey = __webpack_require__(184);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(715),
	    baseIteratee = __webpack_require__(88),
	    baseSome = __webpack_require__(1869),
	    isArray = __webpack_require__(43),
	    isIterateeCall = __webpack_require__(296);
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = some;


/***/ },
/* 1959 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(88),
	    baseSum = __webpack_require__(1871);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(738),
	    isObject = __webpack_require__(83);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(748);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(155),
	    copyArray = __webpack_require__(724),
	    isArray = __webpack_require__(43),
	    isSymbol = __webpack_require__(158),
	    stringToPath = __webpack_require__(736),
	    toKey = __webpack_require__(184),
	    toString = __webpack_require__(750);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(1968);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	var Mexp = __webpack_require__(1966)
	function inc(arr, val) {
		for (var i = 0; i < arr.length; i++) {
			arr[i] += val
		}
		return arr
	}
	var tokens = [
		{ token: 'sin', show: 'sin', type: 0, value: Mexp.math.sin },
		{ token: 'cos', show: 'cos', type: 0, value: Mexp.math.cos },
		{ token: 'tan', show: 'tan', type: 0, value: Mexp.math.tan },
		{ token: 'pi', show: '&pi;', type: 3, value: 'PI' },
		{ token: '(', show: '(', type: 4, value: '(' },
		{ token: ')', show: ')', type: 5, value: ')' },
		{ token: 'P', show: 'P', type: 10, value: Mexp.math.P },
		{ token: 'C', show: 'C', type: 10, value: Mexp.math.C },
		{ token: ' ', show: ' ', type: 14, value: ' '.anchor },
		{ token: 'asin', show: 'asin', type: 0, value: Mexp.math.asin },
		{ token: 'acos', show: 'acos', type: 0, value: Mexp.math.acos },
		{ token: 'atan', show: 'atan', type: 0, value: Mexp.math.atan },
		{ token: '7', show: '7', type: 1, value: '7' },
		{ token: '8', show: '8', type: 1, value: '8' },
		{ token: '9', show: '9', type: 1, value: '9' },
		{ token: 'int', show: 'Int', type: 0, value: Math.floor },
		{ token: 'cosh', show: 'cosh', type: 0, value: Mexp.math.cosh },
		{ token: 'acosh', show: 'acosh', type: 0, value: Mexp.math.acosh },
		{ token: 'ln', show: ' ln', type: 0, value: Math.log },
		{ token: '^', show: '^', type: 10, value: Math.pow },
		{ token: 'root', show: 'root', type: 0, value: Math.sqrt },
		{ token: '4', show: '4', type: 1, value: '4' },
		{ token: '5', show: '5', type: 1, value: '5' },
		{ token: '6', show: '6', type: 1, value: '6' },
		{ token: '/', show: '&divide;', type: 2, value: Mexp.math.div },
		{ token: '!', show: '!', type: 7, value: Mexp.math.fact },
		{ token: 'tanh', show: 'tanh', type: 0, value: Mexp.math.tanh },
		{ token: 'atanh', show: 'atanh', type: 0, value: Mexp.math.atanh },
		{ token: 'Mod', show: ' Mod ', type: 2, value: Mexp.math.mod },
		{ token: '1', show: '1', type: 1, value: '1' },
		{ token: '2', show: '2', type: 1, value: '2' },
		{ token: '3', show: '3', type: 1, value: '3' },
		{ token: '*', show: '&times;', type: 2, value: Mexp.math.mul },
		{ token: 'sinh', show: 'sinh', type: 0, value: Mexp.math.sinh },
		{ token: 'asinh', show: 'asinh', type: 0, value: Mexp.math.asinh },
		{ token: 'e', show: 'e', type: 3, value: 'E' },
		{ token: 'log', show: ' log', type: 0, value: Mexp.math.log },
		{ token: '0', show: '0', type: 1, value: '0' },
		{ token: '.', show: '.', type: 6, value: '.' },
		{ token: '+', show: '+', type: 9, value: Mexp.math.add },
		{ token: '-', show: '-', type: 9, value: Mexp.math.sub },
		{ token: ',', show: ',', type: 11, value: ',' },
		{ token: 'Sigma', show: '&Sigma;', type: 12, value: Mexp.math.sigma },
		{ token: 'n', show: 'n', type: 13, value: 'n' },
		{ token: 'Pi', show: '&Pi;', type: 12, value: Mexp.math.Pi },
		{ token: 'pow', show: 'pow', type: 8, value: Math.pow, numberOfArguments: 2 },
		{ token: '&', show: '&', type: 9, value: Mexp.math.and },
	]
	var preced = {
		0: 11,
		1: 0,
		2: 3,
		3: 0,
		4: 0,
		5: 0,
		6: 0,
		7: 11,
		8: 11,
		9: 1,
		10: 10,
		11: 0,
		12: 11,
		13: 0,
		14: -1,
		15: 11, // will be filtered after lexer
	} // stores precedence by types
	for (var i = 0; i < tokens.length; i++) {
		tokens[i].precedence = preced[tokens[i].type]
	}
	var type0 = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		9: true,
		12: true,
		13: true,
		14: true,
		15: true,
	} // type2:true,type4:true,type9:true,type11:true,type21:true,type22
	var type1 = {
		0: true,
		1: true,
		2: true,
		3: true,
		4: true,
		5: true,
		6: true,
		7: true,
		8: true,
		9: true,
		10: true,
		11: true,
		12: true,
		13: true,
		15: true,
	} // type3:true,type5:true,type7:true,type23
	var type1Asterick = {
		0: true,
		3: true,
		4: true,
		8: true,
		12: true,
		13: true,
		15: true,
	}
	var empty = {}
	var type3Asterick = {
		0: true,
		1: true,
		3: true,
		4: true,
		6: true,
		8: true,
		12: true,
		13: true,
		15: true,
	} // type_5:true,type_7:true,type_23
	var type6 = {
		1: true,
	}
	var newAr = [
		[],
		[
			'1',
			'2',
			'3',
			'7',
			'8',
			'9',
			'4',
			'5',
			'6',
			'+',
			'-',
			'*',
			'/',
			'(',
			')',
			'^',
			'!',
			'P',
			'C',
			'e',
			'0',
			'.',
			',',
			'n',
			' ',
			'&',
		],
		['pi', 'ln', 'Pi'],
		['sin', 'cos', 'tan', 'Del', 'int', 'Mod', 'log', 'pow'],
		['asin', 'acos', 'atan', 'cosh', 'root', 'tanh', 'sinh'],
		['acosh', 'atanh', 'asinh', 'Sigma'],
	]
	
	function match(str1, str2, i, x) {
		for (var f = 0; f < x; f++) {
			if (str1[i + f] !== str2[f]) {
				return false
			}
		}
		return true
	}
	Mexp.tokenTypes = {
		FUNCTION_WITH_ONE_ARG: 0,
		NUMBER: 1,
		BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
		CONSTANT: 3,
		OPENING_PARENTHESIS: 4,
		CLOSING_PARENTHESIS: 5,
		DECIMAL: 6,
		POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
		FUNCTION_WITH_N_ARGS: 8,
		BINARY_OPERATOR_LOW_PRECENDENCE: 9,
		BINARY_OPERATOR_PERMUTATION: 10,
		COMMA: 11,
		EVALUATED_FUNCTION: 12,
		EVALUATED_FUNCTION_PARAMETER: 13,
		SPACE: 14,
	}
	/**
	  
	  0 : function with syntax function_name(Maths_exp)
	  1 : numbers
	  2 : binary operators like * / Mod left associate and same precedence
	  3 : Math constant values like e,pi,Cruncher ans
	  4 : opening bracket
	  5 : closing bracket
	  6 : decimal
	  7 : function with syntax (Math_exp)function_name
	  8: function with syntax function_name(Math_exp1,Math_exp2)
	  9 : binary operator like +,-
	  10: binary operator like P C or ^
	  11: ,
	  12: function with , seperated three parameters and third parameter is a string that will be mexp string
	  13: variable of Sigma function
	 */
	Mexp.addToken = function (newTokens) {
		for (var i = 0; i < newTokens.length; i++) {
			var x = newTokens[i].token.length
			var temp = -1
			if (newTokens[i].type === Mexp.tokenTypes.FUNCTION_WITH_N_ARGS && newTokens[i].numberOfArguments === undefined) {
				newTokens[i].numberOfArguments = 2
			}
	
			// newAr is a specially designed data structure index of 1d array = length of tokens
			newAr[x] = newAr[x] || []
			for (var y = 0; y < newAr[x].length; y++) {
				if (newTokens[i].token === newAr[x][y]) {
					temp = indexOfToken(newAr[x][y], tokens)
					break
				}
			}
			if (temp === -1) {
				tokens.push(newTokens[i])
				newTokens[i].precedence = preced[newTokens[i].type]
				if (newAr.length <= newTokens[i].token.length) {
					newAr[newTokens[i].token.length] = []
				}
				newAr[newTokens[i].token.length].push(newTokens[i].token)
			} else {
				// overwrite
				tokens[temp] = newTokens[i]
				newTokens[i].precedence = preced[newTokens[i].type]
			}
		}
	}
	
	function indexOfToken(key, tokens) {
		for (var search = 0; search < tokens.length; search++) {
			if (tokens[search].token === key) return search
		}
		return -1
	}
	function tokenize(string) {
		var nodes = []
		var length = string.length
		var key, x, y
		for (var i = 0; i < length; i++) {
			if (i < length - 1 && string[i] === ' ' && string[i + 1] === ' ') {
				continue
			}
			key = ''
			for (x = string.length - i > newAr.length - 2 ? newAr.length - 1 : string.length - i; x > 0; x--) {
				if (newAr[x] === undefined) continue
				for (y = 0; y < newAr[x].length; y++) {
					if (match(string, newAr[x][y], i, x)) {
						key = newAr[x][y]
						y = newAr[x].length
						x = 0
					}
				}
			}
			i += key.length - 1
			if (key === '') {
				throw new Mexp.Exception("Can't understand after " + string.slice(i))
			}
			nodes.push(tokens[indexOfToken(key, tokens)])
		}
		return nodes
	}
	
	var changeSignObj = {
		value: Mexp.math.changeSign,
		type: 0,
		pre: 21,
		show: '-',
	}
	var closingParObj = {
		value: ')',
		show: ')',
		type: 5,
		pre: 0,
	}
	var openingParObj = {
		value: '(',
		type: 4,
		pre: 0,
		show: '(',
	}
	Mexp.lex = function (inp, tokens) {
		'use strict'
	
		var str = [openingParObj]
	
		var ptc = [] // Parenthesis to close at the beginning is after one token
		var inpStr = inp
		var allowed = type0
		var bracToClose = 0
		var asterick = empty
		var prevKey = ''
		var i
		if (typeof tokens !== 'undefined') {
			Mexp.addToken(tokens)
		}
		var obj = {}
		var nodes = tokenize(inpStr)
		for (i = 0; i < nodes.length; i++) {
			var node = nodes[i]
			if (node.type === 14) {
				if (
					i > 0 &&
					i < nodes.length - 1 &&
					nodes[i + 1].type === 1 &&
					(nodes[i - 1].type === 1 || nodes[i - 1].type === 6)
				) {
					throw new Mexp.Exception('Unexpected Space')
				}
				continue
			}
			var cToken = node.token
			var cType = node.type
			var cEv = node.value
			var cPre = node.precedence
			var cShow = node.show
			var pre = str[str.length - 1]
			var j
			for (j = ptc.length; j--; ) {
				// loop over ptc
				if (ptc[j] === 0) {
					if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(cType) !== -1) {
						if (allowed[cType] !== true) {
							throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
						}
						str.push(closingParObj)
						allowed = type1
						asterick = type3Asterick
						ptc.pop()
					}
				} else break
			}
			if (allowed[cType] !== true) {
				throw new Mexp.Exception(cToken + ' is not allowed after ' + prevKey)
			}
			if (asterick[cType] === true) {
				cType = 2
				cEv = Mexp.math.mul
				cShow = '&times;'
				cPre = 3
				i = i - 1
			}
			obj = {
				value: cEv,
				type: cType,
				pre: cPre,
				show: cShow,
				numberOfArguments: node.numberOfArguments,
			}
			if (cType === 0) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(2)
				}
				// bracToClose++
			} else if (cType === 1) {
				if (pre.type === 1) {
					pre.value += cEv
					inc(ptc, 1)
				} else {
					str.push(obj)
				}
				allowed = type1
				asterick = type1Asterick
			} else if (cType === 2) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 3) {
				// constant
				str.push(obj)
				allowed = type1
				asterick = type3Asterick
			} else if (cType === 4) {
				inc(ptc, 1)
				bracToClose++
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 5) {
				if (!bracToClose) {
					throw new Mexp.Exception('Closing parenthesis are more than opening one, wait What!!!')
				}
				bracToClose--
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
				inc(ptc, 1)
			} else if (cType === 6) {
				if (pre.hasDec) {
					throw new Mexp.Exception('Two decimals are not allowed in one number')
				}
				if (pre.type !== 1) {
					pre = {
						value: 0,
						type: 1,
						pre: 0,
					} // pre needs to be changed as it will the last value now to be safe in later code
					str.push(pre)
					// inc(ptc, 1)
				}
				allowed = type6
				inc(ptc, 1)
				asterick = empty
				pre.value += cEv
				pre.hasDec = true
			} else if (cType === 7) {
				allowed = type1
				asterick = type3Asterick
				inc(ptc, 1)
				str.push(obj)
			}
			if (cType === 8) {
				allowed = type0
				asterick = empty
				inc(ptc, node.numberOfArguments + 2)
				str.push(obj)
				// str.push(openingParObj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(node.numberOfArguments + 2)
				}
			} else if (cType === 9) {
				if (pre.type === 9) {
					if (pre.value === Mexp.math.add) {
						pre.value = cEv
						pre.show = cShow
						inc(ptc, 1)
					} else if (pre.value === Mexp.math.sub && cShow === '-') {
						pre.value = Mexp.math.add
						pre.show = '+'
						inc(ptc, 1)
					}
				} else if (pre.type !== 5 && pre.type !== 7 && pre.type !== 1 && pre.type !== 3 && pre.type !== 13) {
					// changesign only when negative is found
					if (cToken === '-') {
						// do nothing for + token
						// don't add with the above if statement as that will run the else statement of parent if on Ctoken +
						allowed = type0
						asterick = empty
						inc(ptc, 2).push(2)
						str.push(changeSignObj)
						str.push(openingParObj)
					}
				} else {
					str.push(obj)
					inc(ptc, 2)
				}
				allowed = type0
				asterick = empty
			} else if (cType === 10) {
				allowed = type0
				asterick = empty
				inc(ptc, 2)
				str.push(obj)
			} else if (cType === 11) {
				allowed = type0
				asterick = empty
				str.push(obj)
			} else if (cType === 12) {
				allowed = type0
				asterick = empty
				inc(ptc, 6)
				str.push(obj)
				if (nodes[i + 1].type !== 4) {
					str.push(openingParObj)
					ptc.push(6)
				}
			} else if (cType === 13) {
				allowed = type1
				asterick = type3Asterick
				str.push(obj)
			}
	
			inc(ptc, -1)
			prevKey = cToken
		}
		for (j = ptc.length; j--; ) {
			// loop over ptc
			str.push(closingParObj)
		}
		if (allowed[5] !== true) {
			throw new Mexp.Exception('complete the expression')
		}
		while (bracToClose--) {
			str.push(closingParObj)
		}
	
		str.push(closingParObj)
		//        console.log(str);
		return new Mexp(str)
	}
	module.exports = Mexp


/***/ },
/* 1966 */
/***/ function(module, exports) {

	"use strict";
	var Mexp = function (parsed) {
	  this.value = parsed
	}
	
	Mexp.math = {
	  isDegree: true, // mode of calculator
	  acos: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.acos(x) : Math.acos(x))
	  },
	  add: function (a, b) {
	    return a + b
	  },
	  asin: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.asin(x) : Math.asin(x))
	  },
	  atan: function (x) {
	    return (Mexp.math.isDegree ? 180 / Math.PI * Math.atan(x) : Math.atan(x))
	  },
	  acosh: function (x) {
	    return Math.log(x + Math.sqrt(x * x - 1))
	  },
	  asinh: function (x) {
	    return Math.log(x + Math.sqrt(x * x + 1))
	  },
	  atanh: function (x) {
	    return Math.log((1 + x) / (1 - x))
	  },
	  C: function (n, r) {
	    var pro = 1
	    var other = n - r
	    var choice = r
	    if (choice < other) {
	      choice = other
	      other = r
	    }
	    for (var i = choice + 1; i <= n; i++) {
	      pro *= i
	    }
	    return pro / Mexp.math.fact(other)
	  },
	  changeSign: function (x) {
	    return -x
	  },
	  cos: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.cos(x)
	  },
	  cosh: function (x) {
	    return (Math.pow(Math.E, x) + Math.pow(Math.E, -1 * x)) / 2
	  },
	  div: function (a, b) {
	    return a / b
	  },
	  fact: function (n) {
	    if (n % 1 !== 0) return 'NaN'
	    var pro = 1
	    for (var i = 2; i <= n; i++) {
	      pro *= i
	    }
	    return pro
	  },
	  inverse: function (x) {
	    return 1 / x
	  },
	  log: function (i) {
	    return Math.log(i) / Math.log(10)
	  },
	  mod: function (a, b) {
	    return a % b
	  },
	  mul: function (a, b) {
	    return a * b
	  },
	  P: function (n, r) {
	    var pro = 1
	    for (var i = Math.floor(n) - Math.floor(r) + 1; i <= Math.floor(n); i++) {
	      pro *= i
	    }
	    return pro
	  },
	  Pi: function (low, high, ex) {
	    var pro = 1
	    for (var i = low; i <= high; i++) {
	      pro *= Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return pro
	  },
	  pow10x: function (e) {
	    var x = 1
	    while (e--) {
	      x *= 10
	    }
	    return x
	  },
	  sigma: function (low, high, ex) {
	    var sum = 0
	    for (var i = low; i <= high; i++) {
	      sum += Number(ex.postfixEval({
	        n: i
	      }))
	    }
	    return sum
	  },
	  sin: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.sin(x)
	  },
	  sinh: function (x) {
	    return (Math.pow(Math.E, x) - Math.pow(Math.E, -1 * x)) / 2
	  },
	  sub: function (a, b) {
	    return a - b
	  },
	  tan: function (x) {
	    if (Mexp.math.isDegree) x = Mexp.math.toRadian(x)
	    return Math.tan(x)
	  },
	  tanh: function (x) {
	    return Mexp.sinha(x) / Mexp.cosha(x)
	  },
	  toRadian: function (x) {
	    return x * Math.PI / 180
	  },
	  and: function (a, b) {
	    return a & b
	  }
	}
	Mexp.Exception = function (message) {
	  this.message = message
	}
	module.exports = Mexp


/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	
	var Mexp = __webpack_require__(1965);
	
	Mexp.prototype.toPostfix = function () {
		'use strict';
		var post = [], elem, popped, prep, pre, ele;
		var stack = [{ value: "(", type: 4, pre: 0 }];
		var arr = this.value;
		for (var i = 1; i < arr.length; i++) {
			if (arr[i].type === 1 || arr[i].type === 3 || arr[i].type === 13) {	//if token is number,constant,or n(which is also a special constant in our case)
				if (arr[i].type === 1)
					arr[i].value = Number(arr[i].value);
				post.push(arr[i]);
			}
			else if (arr[i].type === 4) {
				stack.push(arr[i]);
			}
			else if (arr[i].type === 5) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
			}
			else if (arr[i].type === 11) {
				while ((popped = stack.pop()).type !== 4) {
					post.push(popped);
				}
				stack.push(popped);
			}
			else {
				elem = arr[i];
				pre = elem.pre;
				ele = stack[stack.length - 1];
				prep = ele.pre;
				var flag = ele.value == 'Math.pow' && elem.value == 'Math.pow';
				if (pre > prep) stack.push(elem);
				else {
					while (prep >= pre && !flag || flag && pre < prep) {
						popped = stack.pop();
						ele = stack[stack.length - 1];
						post.push(popped);
						prep = ele.pre;
						flag = elem.value == 'Math.pow' && ele.value == 'Math.pow';
					}
					stack.push(elem);
				}
			}
		}
		return new Mexp(post);
	};
	module.exports = Mexp;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp = __webpack_require__(1967)
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict'
		UserDefined = UserDefined || {}
		UserDefined.PI = Math.PI
		UserDefined.E = Math.E
		var stack = [],
			pop1,
			pop2,
			pop3
		var disp = []
		var temp = ''
		var arr = this.value
		var bool = typeof UserDefined.n !== 'undefined'
		for (var i = 0; i < arr.length; i++) {
			if (arr[i].type === 1) {
				stack.push({ value: arr[i].value, type: 1 })
			} else if (arr[i].type === 3) {
				stack.push({ value: UserDefined[arr[i].value], type: 1 })
			} else if (arr[i].type === 0) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 7) {
				if (typeof stack[stack.length - 1].type === 'undefined') {
					stack[stack.length - 1].value.push(arr[i])
				} else stack[stack.length - 1].value = arr[i].value(stack[stack.length - 1].value)
			} else if (arr[i].type === 8) {
				var popped = []
				for (var x = 0; x < arr[i].numberOfArguments; x++) {
					popped.push(stack.pop().value)
				}
				stack.push({ type: 1, value: arr[i].value.apply(arr[i], popped.reverse()) })
			} else if (arr[i].type === 10) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2.value = pop2.concat(pop1)
					pop2.value.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 2 || arr[i].type === 9) {
				pop1 = stack.pop()
				pop2 = stack.pop()
				if (typeof pop2.type === 'undefined') {
					pop2 = pop2.concat(pop1)
					pop2.push(arr[i])
					stack.push(pop2)
				} else if (typeof pop1.type === 'undefined') {
					pop1.unshift(pop2)
					pop1.push(arr[i])
					stack.push(pop1)
				} else {
					stack.push({ type: 1, value: arr[i].value(pop2.value, pop1.value) })
				}
			} else if (arr[i].type === 12) {
				pop1 = stack.pop()
				if (typeof pop1.type !== 'undefined') {
					pop1 = [pop1]
				}
				pop2 = stack.pop()
				pop3 = stack.pop()
				stack.push({ type: 1, value: arr[i].value(pop3.value, pop2.value, new Mexp(pop1)) })
			} else if (arr[i].type === 13) {
				if (bool) {
					stack.push({ value: UserDefined[arr[i].value], type: 3 })
				} else stack.push([arr[i]])
			}
		}
		if (stack.length > 1) {
			throw new Mexp.Exception('Uncaught Syntax error')
		}
		return stack[0].value > 1000000000000000 ? 'Infinity' : parseFloat(stack[0].value.toFixed(15))
	}
	Mexp.eval = function (str, tokens, obj) {
		if (typeof tokens === 'undefined') {
			return this.lex(str).toPostfix().postfixEval()
		} else if (typeof obj === 'undefined') {
			if (typeof tokens.length !== 'undefined') return this.lex(str, tokens).toPostfix().postfixEval()
			else return this.lex(str).toPostfix().postfixEval(tokens)
		} else return this.lex(str, tokens).toPostfix().postfixEval(obj)
	}
	module.exports = Mexp


/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1970)))

/***/ },
/* 1970 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(752);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._D);
	  p._y = 1;
	  p._z = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	var iterableToArray = function (iterable) {
	  if (typeof Array.from === 'function') {
	    // ES2015+, iterables exist
	    iterableToArray = Array.from;
	    return Array.from(iterable);
	  }
	
	  // ES5, only arrays and array-likes exist
	  iterableToArray = function (x) { return Array.prototype.slice.call(x); };
	  return Array.prototype.slice.call(iterable);
	}
	
	Promise.all = function (arr) {
	  var args = iterableToArray(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._y === 3) {
	            val = val._z;
	          }
	          if (val._y === 1) return res(i, val._z);
	          if (val._y === 2) reject(val._z);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	function onSettledFulfill(value) {
	  return { status: 'fulfilled', value: value };
	}
	function onSettledReject(reason) {
	  return { status: 'rejected', reason: reason };
	}
	function mapAllSettled(item) {
	  if(item && (typeof item === 'object' || typeof item === 'function')){
	    if(item instanceof Promise && item.then === Promise.prototype.then){
	      return item.then(onSettledFulfill, onSettledReject);
	    }
	    var then = item.then;
	    if (typeof then === 'function') {
	      return new Promise(then.bind(item)).then(onSettledFulfill, onSettledReject)
	    }
	  }
	
	  return onSettledFulfill(item);
	}
	Promise.allSettled = function (iterable) {
	  return Promise.all(iterableToArray(iterable).map(mapAllSettled));
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    iterableToArray(values).forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};
	
	function getAggregateError(errors){
	  if(typeof AggregateError === 'function'){
	    return new AggregateError(errors,'All promises were rejected');
	  }
	
	  var error = new Error('All promises were rejected');
	
	  error.name = 'AggregateError';
	  error.errors = errors;
	
	  return error;
	}
	
	Promise.any = function promiseAny(values) {
	  return new Promise(function(resolve, reject) {
	    var promises = iterableToArray(values);
	    var hasResolved = false;
	    var rejectionReasons = [];
	
	    function resolveOnce(value) {
	      if (!hasResolved) {
	        hasResolved = true;
	        resolve(value);
	      }
	    }
	
	    function rejectionCheck(reason) {
	      rejectionReasons.push(reason);
	
	      if (rejectionReasons.length === promises.length) {
	        reject(getAggregateError(rejectionReasons));
	      }
	    }
	
	    if(promises.length === 0){
	      reject(getAggregateError(rejectionReasons));
	    } else {
	      promises.forEach(function(value){
	        Promise.resolve(value).then(resolveOnce, rejectionCheck);
	      });
	    }
	  });
	};


/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(752);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._B = null;
	  Promise._C = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._B = function (promise) {
	    if (
	      promise._y === 2 && // IS REJECTED
	      rejections[promise._E]
	    ) {
	      if (rejections[promise._E].logged) {
	        onHandled(promise._E);
	      } else {
	        clearTimeout(rejections[promise._E].timeout);
	      }
	      delete rejections[promise._E];
	    }
	  };
	  Promise._C = function (promise, err) {
	    if (promise._x === 0) { // not yet handled
	      promise._E = id++;
	      rejections[promise._E] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._E),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1974);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1974 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1972).enable();
	  self.Promise = __webpack_require__(1971);
	}
	
	// Make sure we're in a Browser-like environment before importing polyfills
	// This prevents `fetch()` from being imported in a Node test environment
	if (typeof window !== 'undefined') {
	  // fetch() polyfill for making API calls.
	  __webpack_require__(2037);
	}
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(302);
	
	// Support for...of (a commonly used syntax feature that requires Symbols)
	__webpack_require__(1236);
	// Support iterable spread (...Set, ...Map)
	__webpack_require__(1233);


/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	
	__webpack_require__(1975);
	
	// React 16+ relies on Map, Set, and requestAnimationFrame
	__webpack_require__(1234);
	__webpack_require__(1235);
	
	__webpack_require__(439).polyfill();


/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var runtime = (function (exports) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; };
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  function define(obj, key, value) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	    return obj[key];
	  }
	  try {
	    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
	    define({}, "");
	  } catch (err) {
	    define = function(obj, key, value) {
	      return obj[key] = value;
	    };
	  }
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) });
	
	    return generator;
	  }
	  exports.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  define(IteratorPrototype, iteratorSymbol, function () {
	    return this;
	  });
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = GeneratorFunctionPrototype;
	  defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: true });
	  defineProperty(
	    GeneratorFunctionPrototype,
	    "constructor",
	    { value: GeneratorFunction, configurable: true }
	  );
	  GeneratorFunction.displayName = define(
	    GeneratorFunctionPrototype,
	    toStringTagSymbol,
	    "GeneratorFunction"
	  );
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      define(prototype, method, function(arg) {
	        return this._invoke(method, arg);
	      });
	    });
	  }
	
	  exports.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  exports.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      define(genFun, toStringTagSymbol, "GeneratorFunction");
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  exports.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator, PromiseImpl) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return PromiseImpl.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return PromiseImpl.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration.
	          result.value = unwrapped;
	          resolve(result);
	        }, function(error) {
	          // If a rejected Promise was yielded, throw the rejection back
	          // into the async generator function so it can be handled there.
	          return invoke("throw", error, resolve, reject);
	        });
	      }
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new PromiseImpl(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    defineProperty(this, "_invoke", { value: enqueue });
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
	    return this;
	  });
	  exports.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
	    if (PromiseImpl === void 0) PromiseImpl = Promise;
	
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList),
	      PromiseImpl
	    );
	
	    return exports.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var methodName = context.method;
	    var method = delegate.iterator[methodName];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method, or a missing .next mehtod, always terminate the
	      // yield* loop.
	      context.delegate = null;
	
	      // Note: ["return"] must be used for ES3 parsing compatibility.
	      if (methodName === "throw" && delegate.iterator["return"]) {
	        // If the delegate iterator has a return method, give it a
	        // chance to clean up.
	        context.method = "return";
	        context.arg = undefined;
	        maybeInvokeDelegate(delegate, context);
	
	        if (context.method === "throw") {
	          // If maybeInvokeDelegate(context) changed context.method from
	          // "return" to "throw", let that override the TypeError below.
	          return ContinueSentinel;
	        }
	      }
	      if (methodName !== "return") {
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a '" + methodName + "' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  define(Gp, toStringTagSymbol, "Generator");
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  define(Gp, iteratorSymbol, function() {
	    return this;
	  });
	
	  define(Gp, "toString", function() {
	    return "[object Generator]";
	  });
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  exports.keys = function(val) {
	    var object = Object(val);
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  exports.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	
	  // Regardless of whether this script is executing as a CommonJS module
	  // or not, return the runtime object so that we can declare the variable
	  // regeneratorRuntime in the outer scope, which allows this module to be
	  // injected easily by `bin/regenerator --include-runtime script.js`.
	  return exports;
	
	}(
	  // If this script is executing as a CommonJS module, use module.exports
	  // as the regeneratorRuntime namespace. Otherwise create a new empty
	  // object. Either way, the resulting object will be used to initialize
	  // the regeneratorRuntime variable at the top of this file.
	   true ? module.exports : {}
	));
	
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  // This module should not be running in strict mode, so the above
	  // assignment should always work unless something is misconfigured. Just
	  // in case runtime.js accidentally runs in strict mode, in modern engines
	  // we can explicitly access globalThis. In older engines we can escape
	  // strict mode using a global Function call. This could conceivably fail
	  // if a Content Security Policy forbids using Function, but in that case
	  // the proper solution is to fix the accidental strict mode problem. If
	  // you've misconfigured your bundler to force strict mode and applied a
	  // CSP to forbid Function, and you're not willing to fix either of those
	  // problems, please detail your unique predicament in a GitHub issue.
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}


/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';
	
	// Polyfill stable language features.
	// It's recommended to use @babel/preset-env and browserslist
	// to only include the polyfills necessary for the target browsers.
	__webpack_require__(1554);
	__webpack_require__(1977);


/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(302),r=__webpack_require__(2032);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
	function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
	function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
	function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
	function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
	function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
	function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
	Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
	C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
	function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
	60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
	function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
	function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
	function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
	ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
	var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
	function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
	function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
	function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
	function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
	function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
	function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
	ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
	var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
	function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
	function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
	function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
	function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
	var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
	"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
	ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
	ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
	var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
	function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
	function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
	var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
	function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
	function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
	function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
	function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
	function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
	function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
	b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
	function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
	function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
	function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
	n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
	var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
	function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
	function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
	var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
	b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
	var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
	function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
	var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
	Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
	var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
	a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
	k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
	function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
	var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
	function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
	var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
	case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
	a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
	Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
	We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
	function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
	function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
	var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
	function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
	function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
	function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
	function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
	function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
	function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
	function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
	ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
	(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
	function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
	var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
	c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
	function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
	function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
	(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
	function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
	nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
	m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
	if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
	q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
	k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
	d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
	function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
	function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
	var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
	function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
	function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
	function vh(a,b){return"function"===typeof b?b(a):b}
	function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
	(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
	function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
	function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
	function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
	function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
	function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
	d)}}
	var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
	b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
	c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
	wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
	b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
	function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
	function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
	function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
	typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
	typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
	x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
	("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
	function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
	var ii={dehydrated:null,retryTime:0};
	function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
	c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
	function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
	ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
	pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
	qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
	return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
	(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
	a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
	d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
	break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
	c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
	e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
	64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
	e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
	b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
	b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
	var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
	function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
	function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
	function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
	case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
	function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
	function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
	function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
	function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
	function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
	case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
	d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
	f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
	function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
	function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
	function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
	function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
	function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
	function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
	Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
	function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
	function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
	function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
	function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
	null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
	break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
	jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
	function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
	function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
	a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
	function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
	null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
	-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
	(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
	top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
	null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
	function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
	function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
	Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
	if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
	b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
	null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
	case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
	null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
	b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
	k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
	g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
	b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
	function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
	function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
	10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
	function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
	function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
	function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
	function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
	za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
	Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
	(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
	rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
	exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
	exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ },
/* 1980 */
/***/ function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 1981 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1981);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Popper = Popper;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Manager = __webpack_require__(440);
	
	var _utils = __webpack_require__(441);
	
	var _usePopper2 = __webpack_require__(754);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var NOOP = function NOOP() {
	  return void 0;
	};
	
	var NOOP_PROMISE = function NOOP_PROMISE() {
	  return Promise.resolve(null);
	};
	
	var EMPTY_MODIFIERS = [];
	
	function Popper(_ref) {
	  var _ref$placement = _ref.placement,
	      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
	      _ref$strategy = _ref.strategy,
	      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
	      _ref$modifiers = _ref.modifiers,
	      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
	      referenceElement = _ref.referenceElement,
	      onFirstUpdate = _ref.onFirstUpdate,
	      innerRef = _ref.innerRef,
	      children = _ref.children;
	  var referenceNode = React.useContext(_Manager.ManagerReferenceNodeContext);
	
	  var _React$useState = React.useState(null),
	      popperElement = _React$useState[0],
	      setPopperElement = _React$useState[1];
	
	  var _React$useState2 = React.useState(null),
	      arrowElement = _React$useState2[0],
	      setArrowElement = _React$useState2[1];
	
	  React.useEffect(function () {
	    (0, _utils.setRef)(innerRef, popperElement);
	  }, [innerRef, popperElement]);
	  var options = React.useMemo(function () {
	    return {
	      placement: placement,
	      strategy: strategy,
	      onFirstUpdate: onFirstUpdate,
	      modifiers: [].concat(modifiers, [{
	        name: 'arrow',
	        enabled: arrowElement != null,
	        options: {
	          element: arrowElement
	        }
	      }])
	    };
	  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);
	
	  var _usePopper = (0, _usePopper2.usePopper)(referenceElement || referenceNode, popperElement, options),
	      state = _usePopper.state,
	      styles = _usePopper.styles,
	      forceUpdate = _usePopper.forceUpdate,
	      update = _usePopper.update;
	
	  var childrenProps = React.useMemo(function () {
	    return {
	      ref: setPopperElement,
	      style: styles.popper,
	      placement: state ? state.placement : placement,
	      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
	      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
	      arrowProps: {
	        style: styles.arrow,
	        ref: setArrowElement
	      },
	      forceUpdate: forceUpdate || NOOP,
	      update: update || NOOP_PROMISE
	    };
	  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
	  return (0, _utils.unwrapArray)(children)(childrenProps);
	}

/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Reference = Reference;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(2036));
	
	var _Manager = __webpack_require__(440);
	
	var _utils = __webpack_require__(441);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function Reference(_ref) {
	  var children = _ref.children,
	      innerRef = _ref.innerRef;
	  var setReferenceNode = React.useContext(_Manager.ManagerReferenceNodeSetterContext);
	  var refHandler = React.useCallback(function (node) {
	    (0, _utils.setRef)(innerRef, node);
	    (0, _utils.safeInvoke)(setReferenceNode, node);
	  }, [innerRef, setReferenceNode]); // ran on unmount
	  // eslint-disable-next-line react-hooks/exhaustive-deps
	
	  React.useEffect(function () {
	    return function () {
	      return (0, _utils.setRef)(innerRef, null);
	    };
	  }, []);
	  React.useEffect(function () {
	    (0, _warning["default"])(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	  }, [setReferenceNode]);
	  return (0, _utils.unwrapArray)(children)({
	    ref: refHandler
	  });
	}

/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.Popper;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.Manager;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.Reference;
	  }
	});
	Object.defineProperty(exports, "usePopper", {
	  enumerable: true,
	  get: function get() {
	    return _usePopper.usePopper;
	  }
	});
	
	var _Popper = __webpack_require__(1983);
	
	var _Manager = __webpack_require__(440);
	
	var _Reference = __webpack_require__(1984);
	
	var _usePopper = __webpack_require__(754);

/***/ },
/* 1986 */
/***/ function(module, exports) {

	/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */
	
	var hasElementType = typeof Element !== 'undefined';
	var hasMap = typeof Map === 'function';
	var hasSet = typeof Set === 'function';
	var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
	
	// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
	
	function equal(a, b) {
	  // START: fast-deep-equal es6/index.js 3.1.3
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;
	
	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    // START: Modifications:
	    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
	    //    to co-exist with es5.
	    // 2. Replace `for of` with es5 compliant iteration using `for`.
	    //    Basically, take:
	    //
	    //    ```js
	    //    for (i of a.entries())
	    //      if (!b.has(i[0])) return false;
	    //    ```
	    //
	    //    ... and convert to:
	    //
	    //    ```js
	    //    it = a.entries();
	    //    while (!(i = it.next()).done)
	    //      if (!b.has(i.value[0])) return false;
	    //    ```
	    //
	    //    **Note**: `i` access switches to `i.value`.
	    var it;
	    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!equal(i.value[1], b.get(i.value[0]))) return false;
	      return true;
	    }
	
	    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
	      if (a.size !== b.size) return false;
	      it = a.entries();
	      while (!(i = it.next()).done)
	        if (!b.has(i.value[0])) return false;
	      return true;
	    }
	    // END: Modifications
	
	    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (a[i] !== b[i]) return false;
	      return true;
	    }
	
	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    // START: Modifications:
	    // Apply guards for `Object.create(null)` handling. See:
	    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
	    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
	    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
	    // END: Modifications
	
	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;
	
	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
	    // END: fast-deep-equal
	
	    // START: react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element) return false;
	
	    // custom handling for React/Preact
	    for (i = length; i-- !== 0;) {
	      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner
	        // Preact-specific: avoid traversing Preact elements' __v and __o
	        //    __v = $_original / $_vnode
	        //    __o = $_owner
	        // These properties contain circular references and are not needed when
	        // comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of elements
	
	        continue;
	      }
	
	      // all other properties should be traversed as usual
	      if (!equal(a[keys[i]], b[keys[i]])) return false;
	    }
	    // END: react-fast-compare
	
	    // START: fast-deep-equal
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function isEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if (((error.message || '').match(/stack|recursion/i))) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('react-fast-compare cannot handle circular refs');
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(13);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeObserverPolyfill = __webpack_require__(2030);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _lodash = __webpack_require__(1833);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(1834);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };
	
	var styles = {
	  position: 'absolute',
	  width: 0,
	  height: 0,
	  visibility: 'hidden',
	  display: 'none'
	};
	
	var ResizeDetector = function (_PureComponent) {
	  _inherits(ResizeDetector, _PureComponent);
	
	  function ResizeDetector(props) {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));
	
	    _this.createResizeObserver = function (entries) {
	      var _this$props = _this.props,
	          handleWidth = _this$props.handleWidth,
	          handleHeight = _this$props.handleHeight,
	          onResize = _this$props.onResize;
	
	      entries.forEach(function (entry) {
	        var _entry$contentRect = entry.contentRect,
	            width = _entry$contentRect.width,
	            height = _entry$contentRect.height;
	
	        var notifyWidth = handleWidth && _this.width !== width;
	        var notifyHeight = handleHeight && _this.height !== height;
	        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
	          onResize(width, height);
	        }
	        _this.width = width;
	        _this.height = height;
	        _this.skipOnMount = false;
	      });
	    };
	
	    var skipOnMount = props.skipOnMount,
	        refreshMode = props.refreshMode,
	        refreshRate = props.refreshRate;
	
	
	    _this.width = undefined;
	    _this.height = undefined;
	    _this.skipOnMount = skipOnMount;
	
	    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;
	
	    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.observe(resizableElement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var resizableElementId = this.props.resizableElementId;
	
	      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
	      this.ro.unobserve(resizableElement);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement('div', {
	        style: styles,
	        ref: function ref(el) {
	          _this2.el = el;
	        }
	      });
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.PureComponent);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  skipOnMount: _propTypes2.default.bool,
	  refreshRate: _propTypes2.default.number,
	  refreshMode: _propTypes2.default.string,
	  resizableElementId: _propTypes2.default.string,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  skipOnMount: false,
	  refreshRate: 1000,
	  refreshMode: undefined,
	  resizableElementId: '',
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(1987);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1991).enable();
	  window.Promise = __webpack_require__(1990);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1992);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(302);


/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(755);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(755);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1992 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(760);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _AnimateGroupChild = _interopRequireDefault(__webpack_require__(1994));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function AnimateGroup(props) {
	  var component = props.component,
	      children = props.children,
	      appear = props.appear,
	      enter = props.enter,
	      leave = props.leave;
	  return _react.default.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: component
	  }, _react.Children.map(children, function (child, index) {
	    return _react.default.createElement(_AnimateGroupChild.default, {
	      appearOptions: appear,
	      enterOptions: enter,
	      leaveOptions: leave,
	      key: "child-".concat(index)
	    }, child);
	  }));
	}
	
	AnimateGroup.propTypes = {
	  appear: _propTypes.default.object,
	  enter: _propTypes.default.object,
	  leave: _propTypes.default.object,
	  children: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.element]),
	  component: _propTypes.default.any
	};
	AnimateGroup.defaultProps = {
	  component: 'span'
	};
	var _default = AnimateGroup;
	exports.default = _default;

/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _isNumber2 = _interopRequireDefault(__webpack_require__(300));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactTransitionGroup = __webpack_require__(760);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _Animate = _interopRequireDefault(__webpack_require__(756));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var steps = options.steps,
	      duration = options.duration;
	
	  if (steps && steps.length) {
	    return steps.reduce(function (result, entry) {
	      return result + ((0, _isNumber2.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
	    }, 0);
	  }
	
	  if ((0, _isNumber2.default)(duration)) {
	    return duration;
	  }
	
	  return 0;
	};
	
	var AnimateGroupChild =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimateGroupChild)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = {
	      isActive: false
	    };
	
	    _this.handleEnter = function (node, isAppearing) {
	      var _this$props = _this.props,
	          appearOptions = _this$props.appearOptions,
	          enterOptions = _this$props.enterOptions;
	
	      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
	    };
	
	    _this.handleExit = function () {
	      _this.handleStyleActive(_this.props.leaveOptions);
	    };
	
	    return _this;
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: "handleStyleActive",
	    value: function handleStyleActive(style) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	        } : null;
	        this.setState(_objectSpread({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      }
	    }
	  }, {
	    key: "parseTimeout",
	    value: function parseTimeout() {
	      var _this$props2 = this.props,
	          appearOptions = _this$props2.appearOptions,
	          enterOptions = _this$props2.enterOptions,
	          leaveOptions = _this$props2.leaveOptions;
	      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          children = _this$props3.children,
	          appearOptions = _this$props3.appearOptions,
	          enterOptions = _this$props3.enterOptions,
	          leaveOptions = _this$props3.leaveOptions,
	          props = _objectWithoutProperties(_this$props3, ["children", "appearOptions", "enterOptions", "leaveOptions"]);
	
	      return _react.default.createElement(_reactTransitionGroup.Transition, _extends({}, props, {
	        onEnter: this.handleEnter,
	        onExit: this.handleExit,
	        timeout: this.parseTimeout()
	      }), function () {
	        return _react.default.createElement(_Animate.default, _this2.state, _react.Children.only(children));
	      });
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component);
	
	AnimateGroupChild.propTypes = {
	  appearOptions: _propTypes.default.object,
	  enterOptions: _propTypes.default.object,
	  leaveOptions: _propTypes.default.object,
	  children: _propTypes.default.element
	};
	var _default = AnimateGroupChild;
	exports.default = _default;

/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAnimateManager;
	
	var _setRafTimeout = _interopRequireDefault(__webpack_require__(1997));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function createAnimateManager() {
	  var currStyle = {};
	
	  var handleChange = function handleChange() {
	    return null;
	  };
	
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout.default)(setStyle.bind(null, restStyles), curr);
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if (_typeof(_style) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 1996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _filter2 = _interopRequireDefault(__webpack_require__(1941));
	
	var _raf = _interopRequireWildcard(__webpack_require__(439));
	
	var _util = __webpack_require__(304);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	
	
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _objectSpread({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _objectSpread({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	}; // configure update function
	
	
	var _default = function _default(from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _objectSpread({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime;
	  var beginTime;
	
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter2.default)(stepperStyle, needContinue).length;
	  }; // stepper timing function like spring
	
	
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, getCurrStyle(stepperStyle)));
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf.default)(update);
	    }
	  }; // t => val timing function like cubic-bezier
	
	
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(void 0, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle); // get union set and add compatible prefix
	
	    render(_objectSpread({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(void 0, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	      render(_objectSpread({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method
	
	  return function () {
	    (0, _raf.default)(update); // return stop animation method
	
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};
	
	exports.default = _default;

/***/ },
/* 1997 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = _interopRequireDefault(__webpack_require__(439));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf.default)(shouldUpdate);
	}

/***/ },
/* 1998 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(13));
	
	var _addClass = _interopRequireDefault(__webpack_require__(1770));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1772));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(758));
	
	var _PropTypes = __webpack_require__(761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(303);
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(759));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.14.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var l=__webpack_require__(302),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
	60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
	function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
	function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
	0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
	function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
	var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
	exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
	exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
	key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
	exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
	exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(672));
	
	var _utils = __webpack_require__(762);
	
	var _arithmetic = _interopRequireDefault(__webpack_require__(2004));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max; // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Decimal} roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Decimal} The step which is easy to understand between two ticks
	 */
	
	
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep.lte(0)) {
	    return new _decimal.default(0);
	  }
	
	  var digitCount = _arithmetic.default.getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	
	
	  var digitCountValue = new _decimal.default(10).pow(digitCount);
	  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
	
	  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
	  var amendStepRatio = new _decimal.default(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
	  var formatStep = amendStepRatio.mul(digitCountValue);
	  return allowDecimals ? formatStep : new _decimal.default(Math.ceil(formatStep));
	}
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	
	
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var step = 1; // calculate the middle value of ticks
	
	  var middle = new _decimal.default(value);
	
	  if (!middle.isint() && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = new _decimal.default(10).pow(_arithmetic.default.getDigitCount(value) - 1);
	      middle = new _decimal.default(Math.floor(middle.div(step).toNumber())).mul(step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = new _decimal.default(Math.floor(value));
	    }
	  } else if (value === 0) {
	    middle = new _decimal.default(Math.floor((tickCount - 1) / 2));
	  } else if (!allowDecimals) {
	    middle = new _decimal.default(Math.floor(value));
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return middle.add(new _decimal.default(n - middleIndex).mul(step)).toNumber();
	  }), _utils.range);
	  return fn(0, tickCount);
	}
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	
	
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // dirty hack (for recharts' test)
	  if (!Number.isFinite((max - min) / (tickCount - 1))) {
	    return {
	      step: new _decimal.default(0),
	      tickMin: new _decimal.default(0),
	      tickMax: new _decimal.default(0)
	    };
	  } // The step which is easy to understand between two ticks
	
	
	  var step = getFormatStep(new _decimal.default(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
	
	  var middle; // When 0 is inside the interval, 0 should be a tick
	
	  if (min <= 0 && max >= 0) {
	    middle = new _decimal.default(0);
	  } else {
	    // calculate the middle value
	    middle = new _decimal.default(min).add(max).div(2); // minus modulo value
	
	    middle = middle.sub(new _decimal.default(middle).mod(step));
	  }
	
	  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
	  var upCount = Math.ceil(new _decimal.default(max).sub(middle).div(step).toNumber());
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  }
	
	  if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: middle.sub(new _decimal.default(belowCount).mul(step)),
	    tickMax: middle.add(new _decimal.default(upCount).mul(step))
	  };
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks will be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return Infinity;
	    }))) : [].concat(_toConsumableArray((0, _utils.range)(0, tickCount - 1).map(function () {
	      return -Infinity;
	    })), [cormax]);
	
	    return min > max ? (0, _utils.reverse)(_values) : _values;
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  } // Get the step between two ticks
	
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic.default.rangeStep(tickMin, tickMax.add(new _decimal.default(0.1).mul(step)), step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return new _decimal.default(cormin).add(new _decimal.default(n).mul(step)).toNumber();
	  }), _utils.range);
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	/**
	 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
	 * but the domain will be guaranteed
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === -Infinity || cormax === Infinity) {
	    return [min, max];
	  }
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep(new _decimal.default(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic.default.rangeStep(new _decimal.default(cormin), new _decimal.default(cormax).sub(new _decimal.default(0.99).mul(step)), step)), [cormax]);
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	exports.getNiceTickValues = getNiceTickValues;
	var getTickValues = (0, _utils.memoize)(getTickValuesFn);
	exports.getTickValues = getTickValues;
	var getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);
	exports.getTickValuesFixedDomain = getTickValuesFixedDomain;

/***/ },
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "getTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, "getNiceTickValues", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, "getTickValuesFixedDomain", {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});
	
	var _getNiceTickValues = __webpack_require__(2002);

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _decimal = _interopRequireDefault(__webpack_require__(672));
	
	var _utils = __webpack_require__(762);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	function getDigitCount(value) {
	  var result;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(new _decimal.default(value).abs().log(10).toNumber()) + 1;
	  }
	
	  return result;
	}
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Decimal} start 起点
	 * @param  {Decimal} end   终点，不包含该值
	 * @param  {Decimal} step  步长
	 * @return {Array}         若干数值
	 */
	
	
	function rangeStep(start, end, step) {
	  var num = new _decimal.default(start);
	  var i = 0;
	  var result = []; // magic number to prevent infinite loop
	
	  while (num.lt(end) && i < 100000) {
	    result.push(num.toNumber());
	    num = num.add(step);
	    i++;
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	
	
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	  diff = diff || Infinity;
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	var _default = {
	  rangeStep: rangeStep,
	  getDigitCount: getDigitCount,
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};
	exports.default = _default;

/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var CartesianGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(CartesianGrid, _PureComponent);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianGrid).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: "renderHorizontal",
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	    value: function renderHorizontal(horizontalPoints) {
	      var _this = this;
	
	      var _this$props = this.props,
	          x = _this$props.x,
	          width = _this$props.width,
	          horizontal = _this$props.horizontal;
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this.constructor.renderLineItem(horizontal, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-horizontal"
	      }, items);
	    }
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: "renderVertical",
	    value: function renderVertical(verticalPoints) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          y = _this$props2.y,
	          height = _this$props2.height,
	          vertical = _this$props2.vertical;
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _objectSpread({}, _this2.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: "line-".concat(i),
	          index: i
	        });
	
	        return _this2.constructor.renderLineItem(vertical, props);
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid-vertical"
	      }, items);
	    }
	    /**
	     * Draw vertical grid stripes filled by colors
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical stripes
	     */
	
	  }, {
	    key: "renderVerticalStripes",
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _this$props3 = this.props,
	          fillOpacity = _this$props3.fillOpacity,
	          x = _this$props3.x,
	          y = _this$props3.y,
	          width = _this$props3.width,
	          height = _this$props3.height;
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	
	        if (lineWidth <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % verticalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: "none",
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-vertical"
	      }, items);
	    }
	    /**
	     * Draw horizontal grid stripes filled by colors
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal stripes
	     */
	
	  }, {
	    key: "renderHorizontalStripes",
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _this$props4 = this.props,
	          fillOpacity = _this$props4.fillOpacity,
	          x = _this$props4.x,
	          y = _this$props4.y,
	          width = _this$props4.width,
	          height = _this$props4.height;
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b;
	      });
	
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	
	        if (lineHeight <= 0) {
	          return null;
	        }
	
	        var colorIndex = i % horizontalFill.length;
	        return _react["default"].createElement("rect", {
	          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: "none",
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: "recharts-cartesian-grid-bg"
	        });
	      });
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-gridstripes-horizontal"
	      }, items);
	    }
	  }, {
	    key: "renderBackground",
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _this$props5 = this.props,
	          fillOpacity = _this$props5.fillOpacity,
	          x = _this$props5.x,
	          y = _this$props5.y,
	          width = _this$props5.width,
	          height = _this$props5.height;
	      return _react["default"].createElement("rect", {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: "none",
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: "recharts-cartesian-grid-bg"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          x = _this$props6.x,
	          y = _this$props6.y,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          horizontal = _this$props6.horizontal,
	          vertical = _this$props6.vertical,
	          horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
	          xAxis = _this$props6.xAxis,
	          yAxis = _this$props6.yAxis,
	          offset = _this$props6.offset,
	          chartWidth = _this$props6.chartWidth,
	          chartHeight = _this$props6.chartHeight;
	
	      if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0 || !(0, _DataUtils.isNumber)(x) || x !== +x || !(0, _DataUtils.isNumber)(y) || y !== +y) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          horizontalPoints = _this$props7.horizontalPoints,
	          verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified
	
	      if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction2["default"])(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({
	          yAxis: yAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      } // No vertical points are specified
	
	
	      if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction2["default"])(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({
	          xAxis: xAxis,
	          width: chartWidth,
	          height: chartHeight,
	          offset: offset
	        });
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-cartesian-grid"
	      }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
	    }
	  }], [{
	    key: "renderLineItem",
	    value: function renderLineItem(option, props) {
	      var lineItem;
	
	      if (_react["default"].isValidElement(option)) {
	        lineItem = _react["default"].cloneElement(option, props);
	      } else if ((0, _isFunction2["default"])(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ["x1", "y1", "x2", "y2", "key"]);
	
	        lineItem = _react["default"].createElement("line", _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: "none",
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.PureComponent);
	
	CartesianGrid.displayName = 'CartesianGrid';
	CartesianGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes["default"].number,
	  y: _propTypes["default"].number,
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  horizontal: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  vertical: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func, _propTypes["default"].bool]),
	  horizontalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  verticalPoints: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  horizontalCoordinatesGenerator: _propTypes["default"].func,
	  verticalCoordinatesGenerator: _propTypes["default"].func,
	  xAxis: _propTypes["default"].object,
	  yAxis: _propTypes["default"].object,
	  offset: _propTypes["default"].object,
	  chartWidth: _propTypes["default"].number,
	  chartHeight: _propTypes["default"].number,
	  verticalFill: _propTypes["default"].arrayOf(_propTypes["default"].string),
	  horizontalFill: _propTypes["default"].arrayOf(_propTypes["default"].string)
	});
	CartesianGrid.defaultProps = {
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	};
	var _default = CartesianGrid;
	exports["default"] = _default;

/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Area = _interopRequireDefault(__webpack_require__(442));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(188));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(189));
	
	var _CartesianUtils = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Area Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Bar = _interopRequireDefault(__webpack_require__(443));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(188));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(189));
	
	var _CartesianUtils = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Area = _interopRequireDefault(__webpack_require__(442));
	
	var _Bar = _interopRequireDefault(__webpack_require__(443));
	
	var _Line = _interopRequireDefault(__webpack_require__(444));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(445));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(188));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(189));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(305));
	
	var _CartesianUtils = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Composed Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line["default"], _Area["default"], _Bar["default"], _Scatter["default"]],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Funnel = _interopRequireDefault(__webpack_require__(768));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Funnel Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'FunnelChart',
	  GraphicalChild: _Funnel["default"],
	  eventType: 'item',
	  axisComponents: [],
	  defaultProps: {
	    layout: 'centric'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric'])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Line = _interopRequireDefault(__webpack_require__(444));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(188));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(189));
	
	var _CartesianUtils = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Line Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'LineChart',
	  GraphicalChild: _Line["default"],
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(307));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(308));
	
	var _PolarUtils = __webpack_require__(97);
	
	var _Pie = _interopRequireDefault(__webpack_require__(769));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie["default"],
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Radar = _interopRequireDefault(__webpack_require__(770));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(307));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(308));
	
	var _PolarUtils = __webpack_require__(97);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar["default"],
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 90,
	    endAngle: -270,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['centric']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _PolarAngleAxis = _interopRequireDefault(__webpack_require__(307));
	
	var _PolarRadiusAxis = _interopRequireDefault(__webpack_require__(308));
	
	var _PolarUtils = __webpack_require__(97);
	
	var _RadialBar = _interopRequireDefault(__webpack_require__(771));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar["default"],
	  legendContent: 'children',
	  axisComponents: [{
	    axisType: 'angleAxis',
	    AxisComp: _PolarAngleAxis["default"]
	  }, {
	    axisType: 'radiusAxis',
	    AxisComp: _PolarRadiusAxis["default"]
	  }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes["default"].oneOf(['radial']),
	    startAngle: _propTypes["default"].number,
	    endAngle: _propTypes["default"].number,
	    cx: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    cy: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    innerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	    outerRadius: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
	  }
	});
	
	exports["default"] = _default;

/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _sumBy2 = _interopRequireDefault(__webpack_require__(1960));
	
	var _min2 = _interopRequireDefault(__webpack_require__(744));
	
	var _maxBy2 = _interopRequireDefault(__webpack_require__(743));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Surface = _interopRequireDefault(__webpack_require__(233));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(306));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(192));
	
	var _ShallowEqual = __webpack_require__(313);
	
	var _ReactUtils = __webpack_require__(19);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultCoordinateOfTooltip = {
	  x: 0,
	  y: 0
	};
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return {
	    sourceNodes: sourceNodes,
	    sourceLinks: sourceLinks,
	    targetLinks: targetLinks,
	    targetNodes: targetNodes
	  };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	    return _objectSpread({}, entry, {}, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	
	  var maxDepth = (0, _maxBy2["default"])(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return {
	    tree: tree,
	    maxDepth: maxDepth
	  };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min2["default"])(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy2["default"])(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _objectSpread({}, link, {
	      dy: getValue(link) * yRatio
	    });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length; // Sort by the value of y
	
	    nodes.sort(ascendingY);
	    var y0 = 0;
	
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	  resolveCollisions(depthTree, height, nodePadding);
	  var alpha = 1;
	
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	    resolveCollisions(depthTree, height, nodePadding);
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	  return {
	    nodes: tree,
	    links: newLinks
	  };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return {
	      x: el.x + el.width / 2,
	      y: el.y + el.height / 2
	    };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	    return [{
	      payload: el,
	      name: "".concat(sourceName, " - ").concat(targetName),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Sankey, _PureComponent);
	
	  function Sankey(props) {
	    var _this;
	
	    _classCallCheck(this, Sankey);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sankey).call(this, props));
	    _this.state = _this.constructor.createDefaultState(props);
	    return _this;
	  } // eslint-disable-next-line camelcase
	
	
	  _createClass(Sankey, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var _this$props = this.props,
	          data = _this$props.data,
	          width = _this$props.width,
	          height = _this$props.height,
	          margin = _this$props.margin,
	          iterations = _this$props.iterations,
	          nodeWidth = _this$props.nodeWidth,
	          nodePadding = _this$props.nodePadding,
	          nameKey = _this$props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _ShallowEqual.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.constructor.createDefaultState(nextProps));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(el, type, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(el, type, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(el, type, e) {
	      var onClick = this.props.onClick;
	      if (onClick) onClick(el, type, e);
	    }
	  }, {
	    key: "renderLinks",
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          linkCurvature = _this$props4.linkCurvature,
	          linkContent = _this$props4.link,
	          margin = _this$props4.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-links",
	        key: "recharts-sankey-links"
	      }, links.map(function (link, i) {
	        var sourceRelativeY = link.sy,
	            targetRelativeY = link.ty,
	            linkWidth = link.dy;
	        var source = nodes[link.source];
	        var target = nodes[link.target];
	        var sourceX = source.x + source.dx + left;
	        var targetX = target.x + left;
	        var interpolationFunc = interpolationGenerator(sourceX, targetX);
	        var sourceControlX = interpolationFunc(linkCurvature);
	        var targetControlX = interpolationFunc(1 - linkCurvature);
	        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	        var linkProps = _objectSpread({
	          sourceX: sourceX,
	          targetX: targetX,
	          sourceY: sourceY,
	          targetY: targetY,
	          sourceControlX: sourceControlX,
	          targetControlX: targetControlX,
	          sourceRelativeY: sourceRelativeY,
	          targetRelativeY: targetRelativeY,
	          linkWidth: linkWidth,
	          index: i,
	          payload: _objectSpread({}, link, {
	            source: source,
	            target: target
	          })
	        }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	
	        var events = {
	          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
	          onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "link".concat(i)
	          }, events), _this2.constructor.renderLinkItem(linkContent, linkProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderNodes",
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          nodeContent = _this$props5.node,
	          margin = _this$props5.margin;
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	      return _react["default"].createElement(_Layer["default"], {
	        className: "recharts-sankey-nodes",
	        key: "recharts-sankey-nodes"
	      }, nodes.map(function (node, i) {
	        var x = node.x,
	            y = node.y,
	            dx = node.dx,
	            dy = node.dy;
	
	        var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	          x: x + left,
	          y: y + top,
	          width: dx,
	          height: dy,
	          index: i,
	          payload: node
	        });
	
	        var events = {
	          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
	          onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
	        };
	        return (// eslint-disable-next-line react/no-array-index-key
	          _react["default"].createElement(_Layer["default"], _extends({
	            key: "node".concat(i)
	          }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps))
	        );
	      }));
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props6 = this.props,
	          children = _this$props6.children,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          nameKey = _this$props6.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeElement = _this$state.activeElement,
	          activeElementType = _this$state.activeElementType;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props7 = this.props,
	          width = _this$props7.width,
	          height = _this$props7.height,
	          className = _this$props7.className,
	          style = _this$props7.style,
	          children = _this$props7.children,
	          others = _objectWithoutProperties(_this$props7, ["width", "height", "className", "style", "children"]);
	
	      var _this$state2 = this.state,
	          links = _this$state2.links,
	          nodes = _this$state2.nodes;
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: height
	      }), (0, _ReactUtils.filterSvgElements)(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations,
	        nodeWidth: nodeWidth,
	        nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes,
	        links: links
	      };
	    }
	  }, {
	    key: "renderLinkItem",
	    value: function renderLinkItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"]);
	
	      return _react["default"].createElement("path", _extends({
	        className: "recharts-sankey-link",
	        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
	        fill: "none",
	        stroke: "#333",
	        strokeWidth: linkWidth,
	        strokeOpacity: "0.2"
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: "renderNodeItem",
	    value: function renderNodeItem(option, props) {
	      if (_react["default"].isValidElement(option)) {
	        return _react["default"].cloneElement(option, props);
	      }
	
	      if ((0, _isFunction2["default"])(option)) {
	        return option(props);
	      }
	
	      return _react["default"].createElement(_Rectangle["default"], _extends({
	        className: "recharts-sankey-node",
	        fill: "#0088fe",
	        fillOpacity: "0.8"
	      }, props));
	    }
	  }]);
	
	  return Sankey;
	}(_react.PureComponent);
	
	Sankey.displayName = 'Sankey';
	Sankey.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {}, _ReactUtils.EVENT_ATTRIBUTES, {
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].shape({
	    nodes: _propTypes["default"].array,
	    links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	      target: _propTypes["default"].number,
	      source: _propTypes["default"].number,
	      value: _propTypes["default"].number
	    }))
	  }),
	  nodePadding: _propTypes["default"].number,
	  nodeWidth: _propTypes["default"].number,
	  linkCurvature: _propTypes["default"].number,
	  iterations: _propTypes["default"].number,
	  node: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  link: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].element, _propTypes["default"].func]),
	  style: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  margin: _propTypes["default"].shape({
	    top: _propTypes["default"].number,
	    right: _propTypes["default"].number,
	    bottom: _propTypes["default"].number,
	    left: _propTypes["default"].number
	  })
	});
	Sankey.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: {
	    top: 5,
	    right: 5,
	    bottom: 5,
	    left: 5
	  }
	};
	var _default = Sankey;
	exports["default"] = _default;

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _generateCategoricalChart = _interopRequireDefault(__webpack_require__(114));
	
	var _Scatter = _interopRequireDefault(__webpack_require__(445));
	
	var _XAxis = _interopRequireDefault(__webpack_require__(188));
	
	var _YAxis = _interopRequireDefault(__webpack_require__(189));
	
	var _ZAxis = _interopRequireDefault(__webpack_require__(305));
	
	var _CartesianUtils = __webpack_require__(136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	var _default = (0, _generateCategoricalChart["default"])({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter["default"],
	  eventType: 'single',
	  axisComponents: [{
	    axisType: 'xAxis',
	    AxisComp: _XAxis["default"]
	  }, {
	    axisType: 'yAxis',
	    AxisComp: _YAxis["default"]
	  }, {
	    axisType: 'zAxis',
	    AxisComp: _ZAxis["default"]
	  }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});
	
	exports["default"] = _default;

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _get2 = _interopRequireDefault(__webpack_require__(185));
	
	var _omit2 = _interopRequireDefault(__webpack_require__(745));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _isNaN2 = _interopRequireDefault(__webpack_require__(299));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _reactSmooth = _interopRequireDefault(__webpack_require__(89));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Surface = _interopRequireDefault(__webpack_require__(233));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _Rectangle = _interopRequireDefault(__webpack_require__(192));
	
	var _ReactUtils = __webpack_require__(19);
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(306));
	
	var _Polygon = _interopRequireDefault(__webpack_require__(309));
	
	var _ChartUtils = __webpack_require__(69);
	
	var _Constants = __webpack_require__(2023);
	
	var _DOMUtils = __webpack_require__(311);
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({
	      depth: childDepth,
	      node: child,
	      index: i,
	      valueKey: valueKey
	    });
	  }) : null;
	  var value;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = (0, _isNaN2["default"])(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _objectSpread({}, node, {
	    children: computedChildren,
	    value: value,
	    depth: depth,
	    index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return {
	    x: node.x,
	    y: node.y,
	    width: node.width,
	    height: node.height
	  };
	}; // Compute the area for each child based on value & scale.
	
	
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	  return children.map(function (child) {
	    var area = child.value * ratio;
	    return _objectSpread({}, child, {
	      area: (0, _isNaN2["default"])(area) || area <= 0 ? 0 : area
	    });
	  });
	}; // Computes the score for the specified row, as the worst aspect ratio.
	
	
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, {
	    min: Infinity,
	    max: 0
	  }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  } // what's z
	
	
	  child.z = true; // add the remain x to the last one of row
	
	  child.width += parentRect.x + parentRect.width - curX;
	  return _objectSpread({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child;
	
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	  return _objectSpread({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	}; // Recursively arranges the specified node's children into squarified rows.
	
	
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	
	    var child, score; // the current row score
	
	    var size = Math.min(rect.width, rect.height); // initial orientation
	
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      // eslint-disable-next-line prefer-destructuring
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	      score = getWorstScore(row, size, aspectRatio);
	
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _objectSpread({}, node, {
	      children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      })
	    });
	  }
	
	  return node;
	};
	
	var Treemap =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(Treemap, _PureComponent);
	
	  function Treemap() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Treemap)).call.apply(_getPrototypeOf2, [this].concat(args)));
	    _this.state = _this.constructor.createDefaultState();
	
	    _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	      _this.setState({
	        isAnimationFinished: true
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    };
	
	    _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({
	        isAnimationFinished: false
	      });
	
	      if ((0, _isFunction2["default"])(onAnimationStart)) {
	        onAnimationStart();
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          type = _this$props.type,
	          width = _this$props.width,
	          height = _this$props.height,
	          data = _this$props.data,
	          dataKey = _this$props.dataKey,
	          aspectRatio = _this$props.aspectRatio;
	
	      var _this$computeRoot = this.computeRoot({
	        type: type,
	        width: width,
	        height: height,
	        data: data,
	        dataKey: dataKey,
	        aspectRatio: aspectRatio
	      }),
	          formatRoot = _this$computeRoot.formatRoot,
	          currentRoot = _this$computeRoot.currentRoot,
	          nestIndex = _this$computeRoot.nestIndex;
	
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: currentRoot,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "computeRoot",
	    value: function computeRoot(_ref2) {
	      var type = _ref2.type,
	          width = _ref2.width,
	          height = _ref2.height,
	          data = _ref2.data,
	          dataKey = _ref2.dataKey,
	          aspectRatio = _ref2.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: {
	          children: data,
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        },
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      var nestIndex = this.state.nestIndex;
	
	      if (type === 'nest') {
	        nestIndex.push(root);
	      }
	
	      return {
	        formatRoot: formatRoot,
	        currentRoot: root,
	        nestIndex: nestIndex
	      };
	    } // eslint-disable-next-line camelcase
	
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var type = nextProps.type,
	          width = nextProps.width,
	          height = nextProps.height,
	          data = nextProps.data,
	          dataKey = nextProps.dataKey,
	          aspectRatio = nextProps.aspectRatio;
	
	      if (data !== this.props.data || type !== this.props.type || width !== this.props.width || height !== this.props.height || dataKey !== this.props.dataKey || aspectRatio !== this.props.aspectRatio) {
	        var nextRoot = this.computeRoot({
	          type: type,
	          width: width,
	          height: height,
	          data: data,
	          dataKey: dataKey,
	          aspectRatio: aspectRatio
	        });
	        this.setState(_objectSpread({}, this.constructor.createDefaultState(), {}, nextRoot, {
	          nestIndex: [nextRoot.currentRoot]
	        }));
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: "handleMouseEnter",
	    value: function handleMouseEnter(node, e) {
	      var _this$props2 = this.props,
	          onMouseEnter = _this$props2.onMouseEnter,
	          children = _this$props2.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: "handleMouseLeave",
	    value: function handleMouseLeave(node, e) {
	      var _this$props3 = this.props,
	          onMouseLeave = _this$props3.onMouseLeave,
	          children = _this$props3.children;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: "handleClick",
	    value: function handleClick(node) {
	      var _this$props4 = this.props,
	          onClick = _this$props4.onClick,
	          type = _this$props4.type;
	
	      if (type === 'nest' && node.children) {
	        var _this$props5 = this.props,
	            width = _this$props5.width,
	            height = _this$props5.height,
	            dataKey = _this$props5.dataKey,
	            aspectRatio = _this$props5.aspectRatio;
	        var root = computeNode({
	          depth: 0,
	          node: _objectSpread({}, node, {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          }),
	          index: 0,
	          valueKey: dataKey
	        });
	        var formatRoot = squarify(root, aspectRatio);
	        var nestIndex = this.state.nestIndex;
	        nestIndex.push(node);
	        this.setState({
	          formatRoot: formatRoot,
	          currentRoot: root,
	          nestIndex: nestIndex
	        });
	      }
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: "handleNestIndex",
	    value: function handleNestIndex(node, i) {
	      var nestIndex = this.state.nestIndex;
	      var _this$props6 = this.props,
	          width = _this$props6.width,
	          height = _this$props6.height,
	          dataKey = _this$props6.dataKey,
	          aspectRatio = _this$props6.aspectRatio;
	      var root = computeNode({
	        depth: 0,
	        node: _objectSpread({}, node, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        }),
	        index: 0,
	        valueKey: dataKey
	      });
	      var formatRoot = squarify(root, aspectRatio);
	      nestIndex = nestIndex.slice(0, i + 1);
	      this.setState({
	        formatRoot: formatRoot,
	        currentRoot: node,
	        nestIndex: nestIndex
	      });
	    }
	  }, {
	    key: "renderItem",
	    value: function renderItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _this$props7 = this.props,
	          isAnimationActive = _this$props7.isAnimationActive,
	          animationBegin = _this$props7.animationBegin,
	          animationDuration = _this$props7.animationDuration,
	          animationEasing = _this$props7.animationEasing,
	          isUpdateAnimationActive = _this$props7.isUpdateAnimationActive,
	          type = _this$props7.type,
	          animationId = _this$props7.animationId,
	          colorPanel = _this$props7.colorPanel;
	      var isAnimationFinished = this.state.isAnimationFinished;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y,
	          depth = nodeProps.depth;
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf || type === 'nest') {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      if (!isAnimationActive) {
	        return _react["default"].createElement(_Layer["default"], event, this.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	          isAnimationActive: false,
	          isUpdateAnimationActive: false,
	          width: width,
	          height: height,
	          x: x,
	          y: y
	        }), type, colorPanel));
	      }
	
	      return _react["default"].createElement(_reactSmooth["default"], {
	        begin: animationBegin,
	        duration: animationDuration,
	        isActive: isAnimationActive,
	        easing: animationEasing,
	        key: "treemap-".concat(animationId),
	        from: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        to: {
	          x: x,
	          y: y,
	          width: width,
	          height: height
	        },
	        onAnimationStart: this.handleAnimationStart,
	        onAnimationEnd: this.handleAnimationEnd
	      }, function (_ref3) {
	        var currX = _ref3.x,
	            currY = _ref3.y,
	            currWidth = _ref3.width,
	            currHeight = _ref3.height;
	        return _react["default"].createElement(_reactSmooth["default"], {
	          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
	          to: "translate(0, 0)",
	          attributeName: "transform",
	          begin: animationBegin,
	          easing: animationEasing,
	          isActive: isAnimationActive,
	          duration: animationDuration
	        }, _react["default"].createElement(_Layer["default"], event, function () {
	          // when animation Duration , only render depth=1 nodes
	          if (depth > 2 && !isAnimationFinished) {
	            return null;
	          }
	
	          return _this2.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
	            isAnimationActive: isAnimationActive,
	            isUpdateAnimationActive: !isUpdateAnimationActive,
	            width: currWidth,
	            height: currHeight,
	            x: currX,
	            y: currY
	          }), type, colorPanel);
	        }()));
	      });
	    }
	  }, {
	    key: "renderNode",
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var _this$props8 = this.props,
	          content = _this$props8.content,
	          type = _this$props8.type;
	
	      var nodeProps = _objectSpread({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {}, node, {
	        root: root
	      });
	
	      var isLeaf = !node.children || !node.children.length;
	      var currentRoot = this.state.currentRoot;
	      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
	        return item.depth === node.depth && item.name === node.name;
	      });
	
	      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
	        return null;
	      }
	
	      return (// eslint-disable-next-line react/no-array-index-key
	        _react["default"].createElement(_Layer["default"], {
	          key: "recharts-treemap-node-".concat(i),
	          className: "recharts-treemap-depth-".concat(node.depth)
	        }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null)
	      );
	    }
	  }, {
	    key: "renderAllNodes",
	    value: function renderAllNodes() {
	      var formatRoot = this.state.formatRoot;
	
	      if (!formatRoot) {
	        return null;
	      }
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: "renderTooltip",
	    value: function renderTooltip() {
	      var _this$props9 = this.props,
	          children = _this$props9.children,
	          nameKey = _this$props9.nameKey;
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip["default"]);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _this$props10 = this.props,
	          width = _this$props10.width,
	          height = _this$props10.height,
	          dataKey = _this$props10.dataKey;
	      var _this$state = this.state,
	          isTooltipActive = _this$state.isTooltipActive,
	          activeNode = _this$state.activeNode;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	      return _react["default"].cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    } // render nest treemap
	
	  }, {
	    key: "renderNestIndex",
	    value: function renderNestIndex() {
	      var _this4 = this;
	
	      var _this$props11 = this.props,
	          nameKey = _this$props11.nameKey,
	          nestIndexContent = _this$props11.nestIndexContent;
	      var nestIndex = this.state.nestIndex;
	      return _react["default"].createElement("div", {
	        className: "recharts-treemap-nest-index-wrapper",
	        style: {
	          marginTop: '8px',
	          textAlign: 'center'
	        }
	      }, nestIndex.map(function (item, i) {
	        var name = (0, _get2["default"])(item, nameKey, 'root');
	        var content = null;
	
	        if (_react["default"].isValidElement(nestIndexContent)) {
	          content = _react["default"].cloneElement(nestIndexContent, item, i);
	        }
	
	        if ((0, _isFunction2["default"])(nestIndexContent)) {
	          content = nestIndexContent(item, i);
	        } else {
	          content = name;
	        }
	
	        return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
	          _react["default"].createElement("div", {
	            onClick: _this4.handleNestIndex.bind(_this4, item, i),
	            key: "nest-index-".concat((0, _DataUtils.uniqueId)()),
	            className: "recharts-treemap-nest-index-box",
	            style: {
	              cursor: 'pointer',
	              display: 'inline-block',
	              padding: '0 7px',
	              background: '#000',
	              color: '#fff',
	              marginRight: '3px'
	            }
	          }, content)
	        );
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _this$props12 = this.props,
	          width = _this$props12.width,
	          height = _this$props12.height,
	          className = _this$props12.className,
	          style = _this$props12.style,
	          children = _this$props12.children,
	          type = _this$props12.type,
	          others = _objectWithoutProperties(_this$props12, ["width", "height", "className", "style", "children", "type"]);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])('recharts-wrapper', className),
	        style: _objectSpread({}, style, {
	          position: 'relative',
	          cursor: 'default',
	          width: width,
	          height: height
	        })
	      }, _react["default"].createElement(_Surface["default"], _extends({}, attrs, {
	        width: width,
	        height: type === 'nest' ? height - 30 : height
	      }), this.renderAllNodes(), (0, _ReactUtils.filterSvgElements)(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
	    }
	  }], [{
	    key: "createDefaultState",
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        isAnimationFinished: false,
	        activeNode: null,
	        currentRoot: null,
	        formatRoot: null,
	        nestIndex: []
	      };
	    }
	  }, {
	    key: "renderContentItem",
	    value: function renderContentItem(content, nodeProps, type, colorPanel) {
	      if (_react["default"].isValidElement(content)) {
	        return _react["default"].cloneElement(content, nodeProps);
	      }
	
	      if ((0, _isFunction2["default"])(content)) {
	        return content(nodeProps);
	      } // optimize default shape
	
	
	      var x = nodeProps.x,
	          y = nodeProps.y,
	          width = nodeProps.width,
	          height = nodeProps.height,
	          index = nodeProps.index;
	      var arrow = null;
	
	      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
	        arrow = _react["default"].createElement(_Polygon["default"], {
	          points: [{
	            x: x + 2,
	            y: y + height / 2
	          }, {
	            x: x + 6,
	            y: y + height / 2 + 3
	          }, {
	            x: x + 2,
	            y: y + height / 2 + 6
	          }]
	        });
	      }
	
	      var text = null;
	      var nameSize = (0, _DOMUtils.getStringSize)(nodeProps.name);
	
	      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
	        text = _react["default"].createElement("text", {
	          x: x + 8,
	          y: y + height / 2 + 7,
	          fontSize: 14
	        }, nodeProps.name);
	      }
	
	      var colors = colorPanel || _Constants.COLOR_PANEL;
	      return _react["default"].createElement("g", null, _react["default"].createElement(_Rectangle["default"], _extends({
	        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
	        stroke: "#fff"
	      }, (0, _omit2["default"])(nodeProps, 'children'))), arrow, text);
	    }
	  }]);
	
	  return Treemap;
	}(_react.PureComponent);
	
	Treemap.displayName = 'Treemap';
	Treemap.propTypes = {
	  width: _propTypes["default"].number,
	  height: _propTypes["default"].number,
	  data: _propTypes["default"].array,
	  animationId: _propTypes["default"].number,
	  style: _propTypes["default"].object,
	  aspectRatio: _propTypes["default"].number,
	  content: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  fill: _propTypes["default"].string,
	  stroke: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  nameKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  dataKey: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].func]),
	  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
	  // optional values flat/nest, flat show whole treemap, nest only show depth=1 node
	  type: _propTypes["default"].oneOf(['flat', 'nest']),
	  colorPanel: _propTypes["default"].array,
	  // customize nest index content
	  nestIndexContent: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]),
	  onAnimationStart: _propTypes["default"].func,
	  onAnimationEnd: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  isAnimationActive: _propTypes["default"].bool,
	  isUpdateAnimationActive: _propTypes["default"].bool,
	  animationBegin: _propTypes["default"].number,
	  animationDuration: _propTypes["default"].number,
	  animationEasing: _propTypes["default"].oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	};
	Treemap.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear',
	  type: 'flat'
	};
	var _default = Treemap;
	exports["default"] = _default;

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = Customized;
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(38));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _Layer = _interopRequireDefault(__webpack_require__(50));
	
	var _LogUtils = __webpack_require__(193);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	/**
	 * custom svg elements by rechart instance props and state.
	 * @returns {Object}   svg elements
	 */
	function Customized(_ref) {
	  var component = _ref.component,
	      props = _objectWithoutProperties(_ref, ["component"]);
	
	  var child;
	
	  if ((0, _react.isValidElement)(component)) {
	    child = (0, _react.cloneElement)(component, props);
	  } else if ((0, _isFunction2["default"])(component)) {
	    child = component(props);
	  } else {
	    (0, _LogUtils.warn)(false, 'Customized\'s props `component` must be React.element or Function, but got %s.', _typeof(component));
	  }
	
	  return _react["default"].createElement(_Layer["default"], {
	    className: "recharts-customized-wrapper"
	  }, child);
	}
	
	Customized.displayName = 'Customized';
	Customized.propTypes = {
	  component: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].func]).isRequired
	};

/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _Surface = _interopRequireDefault(__webpack_require__(233));
	
	var _Symbols = _interopRequireDefault(__webpack_require__(447));
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var SIZE = 32;
	
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultLegendContent, _PureComponent);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultLegendContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: "renderIcon",
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'plainline') {
	        return _react["default"].createElement("line", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          strokeDasharray: data.payload.strokeDasharray,
	          x1: 0,
	          y1: halfSize,
	          x2: SIZE,
	          y2: halfSize,
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'line') {
	        return _react["default"].createElement("path", {
	          strokeWidth: 4,
	          fill: "none",
	          stroke: color,
	          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      if (data.type === 'rect') {
	        return _react["default"].createElement("path", {
	          stroke: "none",
	          fill: color,
	          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
	          className: "recharts-legend-icon"
	        });
	      }
	
	      return _react["default"].createElement(_Symbols["default"], {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: "diameter",
	        type: data.type
	      });
	    }
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: "renderItems",
	    value: function renderItems() {
	      var _this = this;
	
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          iconSize = _this$props.iconSize,
	          layout = _this$props.layout,
	          formatter = _this$props.formatter;
	      var viewBox = {
	        x: 0,
	        y: 0,
	        width: SIZE,
	        height: SIZE
	      };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = {
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        marginRight: 4
	      };
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames["default"])((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, "legend-item-".concat(i), true), _defineProperty(_classNames, "inactive", entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react["default"].createElement("li", _extends({
	          className: className,
	          style: itemStyle,
	          key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
	
	        }, (0, _ReactUtils.filterEventsOfChild)(_this.props, entry, i)), _react["default"].createElement(_Surface["default"], {
	          width: iconSize,
	          height: iconSize,
	          viewBox: viewBox,
	          style: svgStyle
	        }, _this.renderIcon(entry)), _react["default"].createElement("span", {
	          className: "recharts-legend-item-text"
	        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          payload = _this$props2.payload,
	          layout = _this$props2.layout,
	          align = _this$props2.align;
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	      return _react["default"].createElement("ul", {
	        className: "recharts-default-legend",
	        style: finalStyle
	      }, this.renderItems());
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.PureComponent);
	
	DefaultLegendContent.displayName = 'Legend';
	DefaultLegendContent.propTypes = {
	  content: _propTypes["default"].element,
	  iconSize: _propTypes["default"].number,
	  iconType: _propTypes["default"].oneOf(ICON_TYPES),
	  layout: _propTypes["default"].oneOf(['horizontal', 'vertical']),
	  align: _propTypes["default"].oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes["default"].oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    value: _propTypes["default"].any,
	    id: _propTypes["default"].any,
	    type: _propTypes["default"].oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onMouseLeave: _propTypes["default"].func,
	  onClick: _propTypes["default"].func
	};
	DefaultLegendContent.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	};
	var _default = DefaultLegendContent;
	exports["default"] = _default;

/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _sortBy2 = _interopRequireDefault(__webpack_require__(438));
	
	var _isArray2 = _interopRequireDefault(__webpack_require__(43));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _DataUtils = __webpack_require__(39);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray2["default"])(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(DefaultTooltipContent, _PureComponent);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultTooltipContent).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: "renderContent",
	    value: function renderContent() {
	      var _this$props = this.props,
	          payload = _this$props.payload,
	          separator = _this$props.separator,
	          formatter = _this$props.formatter,
	          itemStyle = _this$props.itemStyle,
	          itemSorter = _this$props.itemSorter;
	
	      if (payload && payload.length) {
	        var listStyle = {
	          padding: 0,
	          margin: 0
	        };
	        var items = (itemSorter ? (0, _sortBy2["default"])(payload, itemSorter) : payload).map(function (entry, i) {
	          if (entry.type === 'none') {
	            return null;
	          }
	
	          var finalItemStyle = _objectSpread({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	          var name = entry.name,
	              value = entry.value;
	
	          if (finalFormatter) {
	            var formatted = finalFormatter(value, name, entry, i);
	
	            if (Array.isArray(formatted)) {
	              var _formatted = _slicedToArray(formatted, 2);
	
	              value = _formatted[0];
	              name = _formatted[1];
	            } else {
	              value = formatted;
	            }
	          }
	
	          return (// eslint-disable-next-line react/no-array-index-key
	            _react["default"].createElement("li", {
	              className: "recharts-tooltip-item",
	              key: "tooltip-item-".concat(i),
	              style: finalItemStyle
	            }, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-name"
	            }, name) : null, (0, _DataUtils.isNumOrStr)(name) ? _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-separator"
	            }, separator) : null, _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-value"
	            }, value), _react["default"].createElement("span", {
	              className: "recharts-tooltip-item-unit"
	            }, entry.unit || ''))
	          );
	        });
	        return _react["default"].createElement("ul", {
	          className: "recharts-tooltip-item-list",
	          style: listStyle
	        }, items);
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperClassName = _this$props2.wrapperClassName,
	          contentStyle = _this$props2.contentStyle,
	          labelClassName = _this$props2.labelClassName,
	          labelStyle = _this$props2.labelStyle,
	          label = _this$props2.label,
	          labelFormatter = _this$props2.labelFormatter;
	
	      var finalStyle = _objectSpread({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, contentStyle);
	
	      var finalLabelStyle = _objectSpread({
	        margin: 0
	      }, labelStyle);
	
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	      var wrapperCN = (0, _classnames["default"])('recharts-default-tooltip', wrapperClassName);
	      var labelCN = (0, _classnames["default"])('recharts-tooltip-label', labelClassName);
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react["default"].createElement("div", {
	        className: wrapperCN,
	        style: finalStyle
	      }, _react["default"].createElement("p", {
	        className: labelCN,
	        style: finalLabelStyle
	      }, finalLabel), this.renderContent());
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.PureComponent);
	
	DefaultTooltipContent.displayName = 'DefaultTooltipContent';
	DefaultTooltipContent.propTypes = {
	  separator: _propTypes["default"].string,
	  wrapperClassName: _propTypes["default"].string,
	  labelClassName: _propTypes["default"].string,
	  formatter: _propTypes["default"].func,
	  contentStyle: _propTypes["default"].object,
	  itemStyle: _propTypes["default"].object,
	  labelStyle: _propTypes["default"].object,
	  labelFormatter: _propTypes["default"].func,
	  label: _propTypes["default"].any,
	  payload: _propTypes["default"].arrayOf(_propTypes["default"].shape({
	    name: _propTypes["default"].any,
	    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
	    unit: _propTypes["default"].any
	  })),
	  itemSorter: _propTypes["default"].func
	};
	DefaultTooltipContent.defaultProps = {
	  separator: ' : ',
	  contentStyle: {},
	  itemStyle: {},
	  labelStyle: {}
	};
	var _default = DefaultTooltipContent;
	exports["default"] = _default;

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _debounce2 = _interopRequireDefault(__webpack_require__(738));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _classnames = _interopRequireDefault(__webpack_require__(31));
	
	var _reactResizeDetector = _interopRequireDefault(__webpack_require__(1988));
	
	var _DataUtils = __webpack_require__(39);
	
	var _LogUtils = __webpack_require__(193);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var ResponsiveContainer =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    var _this;
	
	    _classCallCheck(this, ResponsiveContainer);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveContainer).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({
	            containerWidth: containerWidth,
	            containerHeight: containerHeight
	          });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	    _this.handleResize = props.debounce > 0 ? (0, _debounce2["default"])(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.mounted = true;
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: "getContainerSize",
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: "renderChart",
	    value: function renderChart() {
	      var _this$state2 = this.state,
	          containerWidth = _this$state2.containerWidth,
	          containerHeight = _this$state2.containerHeight;
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _this$props = this.props,
	          aspect = _this$props.aspect,
	          width = _this$props.width,
	          height = _this$props.height,
	          minWidth = _this$props.minWidth,
	          minHeight = _this$props.minHeight,
	          maxHeight = _this$props.maxHeight,
	          children = _this$props.children;
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        if (calculatedWidth) {
	          // Will default to using width for aspect ratio
	          calculatedHeight = calculatedWidth / aspect;
	        } else if (calculatedHeight) {
	          // But we should also take height into consideration
	          calculatedWidth = calculatedHeight * aspect;
	        } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	
	
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	      return _react["default"].cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          minWidth = _this$props2.minWidth,
	          minHeight = _this$props2.minHeight,
	          width = _this$props2.width,
	          height = _this$props2.height,
	          maxHeight = _this$props2.maxHeight,
	          id = _this$props2.id,
	          className = _this$props2.className;
	      var style = {
	        width: width,
	        height: height,
	        minWidth: minWidth,
	        minHeight: minHeight,
	        maxHeight: maxHeight
	      };
	      return _react["default"].createElement("div", {
	        id: id,
	        className: (0, _classnames["default"])('recharts-responsive-container', className),
	        style: style,
	        ref: function ref(node) {
	          _this2.container = node;
	        }
	      }, this.renderChart(), _react["default"].createElement(_reactResizeDetector["default"], {
	        handleWidth: true,
	        handleHeight: true,
	        onResize: this.handleResize
	      }));
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component);
	
	ResponsiveContainer.displayName = 'ResponsiveContainer';
	ResponsiveContainer.propTypes = {
	  aspect: _propTypes["default"].number,
	  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  maxHeight: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  children: _propTypes["default"].node.isRequired,
	  debounce: _propTypes["default"].number,
	  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
	};
	ResponsiveContainer.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	};
	var _default = ResponsiveContainer;
	exports["default"] = _default;

/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(13));
	
	var _PolarUtils = __webpack_require__(97);
	
	var _ReactUtils = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PolarGrid =
	/*#__PURE__*/
	function (_PureComponent) {
	  _inherits(PolarGrid, _PureComponent);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PolarGrid).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: "getPolygonPath",
	    value: function getPolygonPath(radius) {
	      var _this$props = this.props,
	          cx = _this$props.cx,
	          cy = _this$props.cy,
	          polarAngles = _this$props.polarAngles;
	      var path = '';
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += "L ".concat(point.x, ",").concat(point.y);
	        } else {
	          path += "M ".concat(point.x, ",").concat(point.y);
	        }
	      });
	      path += 'Z';
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: "renderPolarAngles",
	    value: function renderPolarAngles() {
	      var _this$props2 = this.props,
	          cx = _this$props2.cx,
	          cy = _this$props2.cy,
	          innerRadius = _this$props2.innerRadius,
	          outerRadius = _this$props2.outerRadius,
	          polarAngles = _this$props2.polarAngles;
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-angle"
	      }, polarAngles.map(function (entry, i) {
	        var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	        var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	        return _react["default"].createElement("line", _extends({}, props, {
	          key: "line-".concat(i) // eslint-disable-line react/no-array-index-key
	          ,
	          x1: start.x,
	          y1: start.y,
	          x2: end.x,
	          y2: end.y
	        }));
	      }));
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: "renderConcentricCircle",
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _this$props3 = this.props,
	          cx = _this$props3.cx,
	          cy = _this$props3.cy;
	
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("circle", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-circle",
	        key: "circle-".concat(index),
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: "renderConcentricPolygon",
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _objectSpread({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react["default"].createElement("path", _extends({}, props, {
	        className: "recharts-polar-grid-concentric-polygon",
	        key: "path-".concat(index),
	        d: this.getPolygonPath(radius)
	      }));
	    }
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: "renderConcentricPath",
	    value: function renderConcentricPath() {
	      var _this = this;
	
	      var _this$props4 = this.props,
	          polarRadius = _this$props4.polarRadius,
	          gridType = _this$props4.gridType;
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid-concentric"
	      }, polarRadius.map(function (entry, i) {
	        return gridType === 'circle' ? _this.renderConcentricCircle(entry, i) : _this.renderConcentricPolygon(entry, i);
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react["default"].createElement("g", {
	        className: "recharts-polar-grid"
	      }, this.renderPolarAngles(), this.renderConcentricPath());
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.PureComponent);
	
	PolarGrid.displayName = 'PolarGrid';
	PolarGrid.propTypes = _objectSpread({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes["default"].number,
	  cy: _propTypes["default"].number,
	  innerRadius: _propTypes["default"].number,
	  outerRadius: _propTypes["default"].number,
	  polarAngles: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  polarRadius: _propTypes["default"].arrayOf(_propTypes["default"].number),
	  gridType: _propTypes["default"].oneOf(['polygon', 'circle'])
	});
	PolarGrid.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	};
	var _default = PolarGrid;
	exports["default"] = _default;

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	__webpack_require__(1229);
	
	__webpack_require__(1230);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 2023 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.COLOR_PANEL = void 0;
	var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];
	exports.COLOR_PANEL = COLOR_PANEL;

/***/ },
/* 2024 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generatePrefixStyle = void 0;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	
	var generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (!name) {
	    return null;
	  }
	
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var result = PREFIX_LIST.reduce(function (res, entry) {
	    return _objectSpread({}, res, _defineProperty({}, entry + camelName, value));
	  }, {});
	  result[name] = value;
	  return result;
	};
	
	exports.generatePrefixStyle = generatePrefixStyle;

/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectReferenceElementsDomain = void 0;
	
	var _ReferenceDot = _interopRequireDefault(__webpack_require__(766));
	
	var _ReferenceLine = _interopRequireDefault(__webpack_require__(767));
	
	var _ReferenceArea = _interopRequireDefault(__webpack_require__(765));
	
	var _IfOverflowMatches = __webpack_require__(312);
	
	var _ReactUtils = __webpack_require__(19);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine["default"]);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot["default"]);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea["default"]);
	  var idKey = "".concat(axisType, "Id");
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = "".concat(valueKey, "1");
	    var key2 = "".concat(valueKey, "2");
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && (0, _IfOverflowMatches.ifOverflowMatches)(el.props, 'extendDomain') && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  if (specifiedTicks && specifiedTicks.length) {
	    finalDomain = specifiedTicks.reduce(function (result, tick) {
	      if ((0, _DataUtils.isNumber)(tick)) {
	        return [Math.min(result[0], tick), Math.max(result[1], tick)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	exports.detectReferenceElementsDomain = detectReferenceElementsDomain;

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = void 0;
	
	var _events = _interopRequireDefault(__webpack_require__(1773));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var eventCenter = new _events["default"]();
	exports.eventCenter = eventCenter;
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	var SYNC_EVENT = 'recharts.syncMouseEvents';
	exports.SYNC_EVENT = SYNC_EVENT;

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(2028)
	var reduceFunctionCall = __webpack_require__(2029)
	var mexp = __webpack_require__(1964)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 2028 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(1221)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2031 */
/***/ function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2031);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ratings-table.9065d72d.png";

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  /* eslint-disable no-prototype-builtins */
	  var g =
	    (typeof globalThis !== 'undefined' && globalThis) ||
	    (typeof self !== 'undefined' && self) ||
	    // eslint-disable-next-line no-undef
	    (typeof global !== 'undefined' && global) ||
	    {};
	
	  var support = {
	    searchParams: 'URLSearchParams' in g,
	    iterable: 'Symbol' in g && 'iterator' in Symbol,
	    blob:
	      'FileReader' in g &&
	      'Blob' in g &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in g,
	    arrayBuffer: 'ArrayBuffer' in g
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
	      throw new TypeError('Invalid character in header field name: "' + name + '"')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        if (header.length != 2) {
	          throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
	        }
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body._noBody) return
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
	    var encoding = match ? match[1] : 'utf-8';
	    reader.readAsText(blob, encoding);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      /*
	        fetch-mock wraps the Response object in an ES6 Proxy to
	        provide useful test harness features such as flush. However, on
	        ES5 browsers without fetch or Proxy support pollyfills must be used;
	        the proxy-pollyfill is unable to proxy an attribute unless it exists
	        on the object before the Proxy is created. This change ensures
	        Response.bodyUsed exists on the instance, while maintaining the
	        semantic of setting Request.bodyUsed in the constructor before
	        _initBody is called.
	      */
	      // eslint-disable-next-line no-self-assign
	      this.bodyUsed = this.bodyUsed;
	      this._bodyInit = body;
	      if (!body) {
	        this._noBody = true;
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	    }
	
	    this.arrayBuffer = function() {
	      if (this._bodyArrayBuffer) {
	        var isConsumed = consumed(this);
	        if (isConsumed) {
	          return isConsumed
	        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
	          return Promise.resolve(
	            this._bodyArrayBuffer.buffer.slice(
	              this._bodyArrayBuffer.byteOffset,
	              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
	            )
	          )
	        } else {
	          return Promise.resolve(this._bodyArrayBuffer)
	        }
	      } else if (support.blob) {
	        return this.blob().then(readBlobAsArrayBuffer)
	      } else {
	        throw new Error('could not read as ArrayBuffer')
	      }
	    };
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    if (!(this instanceof Request)) {
	      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	    }
	
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal || (function () {
	      if ('AbortController' in g) {
	        var ctrl = new AbortController();
	        return ctrl.signal;
	      }
	    }());
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	
	    if (this.method === 'GET' || this.method === 'HEAD') {
	      if (options.cache === 'no-store' || options.cache === 'no-cache') {
	        // Search for a '_' parameter in the query string
	        var reParamSearch = /([?&])_=[^&]*/;
	        if (reParamSearch.test(this.url)) {
	          // If it already exists then set the value with the current time
	          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
	        } else {
	          // Otherwise add a new '_' parameter to the end with the current time
	          var reQueryString = /\?/;
	          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
	        }
	      }
	    }
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
	    // https://github.com/github/fetch/issues/748
	    // https://github.com/zloirock/core-js/issues/751
	    preProcessedHeaders
	      .split('\r')
	      .map(function(header) {
	        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
	      })
	      .forEach(function(line) {
	        var parts = line.split(':');
	        var key = parts.shift().trim();
	        if (key) {
	          var value = parts.join(':').trim();
	          try {
	            headers.append(key, value);
	          } catch (error) {
	            console.warn('Response ' + error.message);
	          }
	        }
	      });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!(this instanceof Response)) {
	      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
	    }
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    if (this.status < 200 || this.status > 599) {
	      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
	    }
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 200, statusText: ''});
	    response.status = 0;
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = g.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        // This check if specifically for when a user fetches a file locally from the file system
	        // Only if the status is out of a normal range
	        if (request.url.startsWith('file://') && (xhr.status < 200 || xhr.status > 599)) {
	          options.status = 200;
	        } else {
	          options.status = xhr.status;
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        setTimeout(function() {
	          resolve(new Response(body, options));
	        }, 0);
	      };
	
	      xhr.onerror = function() {
	        setTimeout(function() {
	          reject(new TypeError('Network request failed'));
	        }, 0);
	      };
	
	      xhr.ontimeout = function() {
	        setTimeout(function() {
	          reject(new TypeError('Network request timed out'));
	        }, 0);
	      };
	
	      xhr.onabort = function() {
	        setTimeout(function() {
	          reject(new exports.DOMException('Aborted', 'AbortError'));
	        }, 0);
	      };
	
	      function fixUrl(url) {
	        try {
	          return url === '' && g.location.href ? g.location.href : url
	        } catch (e) {
	          return url
	        }
	      }
	
	      xhr.open(request.method, fixUrl(request.url), true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr) {
	        if (support.blob) {
	          xhr.responseType = 'blob';
	        } else if (
	          support.arrayBuffer
	        ) {
	          xhr.responseType = 'arraybuffer';
	        }
	      }
	
	      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
	        var names = [];
	        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
	          names.push(normalizeName(name));
	          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
	        });
	        request.headers.forEach(function(value, name) {
	          if (names.indexOf(name) === -1) {
	            xhr.setRequestHeader(name, value);
	          }
	        });
	      } else {
	        request.headers.forEach(function(value, name) {
	          xhr.setRequestHeader(name, value);
	        });
	      }
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!g.fetch) {
	    g.fetch = fetch;
	    g.Headers = Headers;
	    g.Request = Request;
	    g.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(10);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useQuickScreener2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _twd = __webpack_require__(2);
	
	var _toSearchParams = __webpack_require__(__webpack_module_template_argument_1__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable no-use-before-define */
	
	
	exports.default = function (_ref) {
	    var errors = _ref.errors,
	        values = _ref.values;
	
	    var _useQuickScreener = (0, _useQuickScreener2.useQuickScreener)(),
	        state = _useQuickScreener.state,
	        ajax = _useQuickScreener.ajax;
	
	    var timerId = _react2.default.useRef();
	    var lastBody = _react2.default.useRef(state.lastBody);
	    var lastAbort = _react2.default.useRef();
	    var hasError = Object.keys(errors).length > 0;
	    var buttonRef = _react2.default.useRef();
	
	    _react2.default.useEffect(function () {
	
	        if (timerId.current) {
	            clearInterval(timerId.current);
	            timerId.current = 0;
	        }
	
	        timerId.current = setTimeout(_asyncToGenerator(_regenerator2.default.mark(function _callee() {
	            var p, body, _ref3, data, abort, _ref4, resultSetCount;
	
	            return _regenerator2.default.wrap(function _callee$(_context) {
	                while (1) {
	                    switch (_context.prev = _context.next) {
	                        case 0:
	                            if (!hasError) {
	                                _context.next = 2;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 2:
	                            p = Object.assign({
	                                searchType: 'offers',
	                                pageNumber: 1,
	                                resultsPerPage: 1,
	                                persistToPreviousSearches: false,
	                                marketCheckRequired: false,
	                                sort: [{
	                                    field: 'holdMaturitySortDt',
	                                    direction: 'ASC'
	                                }]
	                            }, (0, _toSearchParams.toSearchParams)(values));
	                            body = JSON.stringify(p);
	
	                            if (!(lastBody.current === body)) {
	                                _context.next = 6;
	                                break;
	                            }
	
	                            return _context.abrupt('return');
	
	                        case 6:
	
	                            lastBody.current = body;
	                            state.lastBody = body;
	
	                            _context.prev = 8;
	
	                            if (lastAbort.current) {
	                                lastAbort.current();
	                            }
	
	                            _context.next = 12;
	                            return ajax({
	                                url: '/esb/portfolio/offersearch/getHitCount',
	                                method: 'POST',
	                                body: body
	                            });
	
	                        case 12:
	                            _ref3 = _context.sent;
	                            data = _ref3.data;
	                            abort = _ref3.abort;
	
	
	                            updateText(null);
	                            lastAbort.current = abort;
	                            _context.next = 19;
	                            return data;
	
	                        case 19:
	                            _ref4 = _context.sent;
	                            resultSetCount = _ref4.resultSetCount;
	
	                            lastAbort.current = null;
	                            updateText(resultSetCount);
	
	                            _context.next = 28;
	                            break;
	
	                        case 25:
	                            _context.prev = 25;
	                            _context.t0 = _context['catch'](8);
	
	                            updateText(null);
	
	                        case 28:
	                        case 'end':
	                            return _context.stop();
	                    }
	                }
	            }, _callee, undefined, [[8, 25]]);
	        })), 1000);
	
	        return function () {
	            if (lastAbort.current) lastAbort.current();
	            if (timerId.current) clearInterval(timerId.current);
	            updateText(state.count);
	        };
	    });
	
	    var updateText = function updateText(count) {
	        if (!buttonRef.current) return;
	        if (count === null || count === undefined) {
	            buttonRef.current.innerHTML = 'View results';
	            return;
	        }
	
	        var s = 'View (' + _twd.fmt.count(count) + ') results';
	        buttonRef.current.innerHTML = s;
	        state.count = count;
	    };
	
	    return _react2.default.createElement(
	        'button',
	        {
	            ref: buttonRef,
	            type: 'submit',
	            disabled: hasError,
	            className: 'btn btn-primary btn-block' },
	        'View results'
	    );
	};

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.BenchmarkLegends = exports.BenchmarkTooltipCursor = exports.BenchmarkTooltipContent = exports.BenchmarkShape = undefined;
	
	var _shape = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _shape2 = _interopRequireDefault(_shape);
	
	var _tooltipContent = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _tooltipContent2 = _interopRequireDefault(_tooltipContent);
	
	var _tooltipCursor = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _tooltipCursor2 = _interopRequireDefault(_tooltipCursor);
	
	var _legends = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _legends2 = _interopRequireDefault(_legends);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BenchmarkShape = _shape2.default;
	exports.BenchmarkTooltipContent = _tooltipContent2.default;
	exports.BenchmarkTooltipCursor = _tooltipCursor2.default;
	exports.BenchmarkLegends = _legends2.default;

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.CriteriaTags = exports.CriteriaForm = undefined;
	
	var _form = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _form2 = _interopRequireDefault(_form);
	
	var _tags = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.CriteriaForm = _form2.default;
	exports.CriteriaTags = _tags2.default;

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _useScatterGraph2 = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _useScatterGraph3 = _interopRequireDefault(_useScatterGraph2);
	
	var _twd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    var _useScatterGraph = (0, _useScatterGraph3.default)(),
	        selectedBenchmarks = _useScatterGraph.selectedBenchmarks,
	        benchmarksData = _useScatterGraph.benchmarksData;
	
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        benchmarksTable(selectedBenchmarks, benchmarksData)
	    );
	}; /* eslint-disable no-use-before-define */
	
	
	var benchmarksTable = function benchmarksTable(selected, data) {
	    var years = [1, 2, 3, 5, 7, 10, 20, 30];
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            'table',
	            null,
	            _react2.default.createElement(
	                'caption',
	                null,
	                'Yield curves benchmarks.'
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        { scope: 'col' },
	                        'Benchmark'
	                    ),
	                    years.map(function (a, i) {
	                        return _react2.default.createElement(
	                            'th',
	                            { key: i, scope: 'col' },
	                            a,
	                            ' year'
	                        );
	                    })
	                ),
	                selected.map(function (bench, i) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: i },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            bench
	                        ),
	                        years.map(function (year, i) {
	                            return _react2.default.createElement(
	                                'td',
	                                { key: i },
	                                findYield(data, bench, year)
	                            );
	                        })
	                    );
	                })
	            )
	        )
	    );
	};
	
	var findYield = function findYield(data, key, year) {
	    var a = data[key];
	    if (!a) return '-';
	    return (0, _twd.arrayFrom)(a).filter(function (i) {
	        return i.maturityYearValue === year;
	    }).map(function (i) {
	        return i.yieldValue;
	    })[0] || '-';
	};

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.d438eae9.js